(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"/usr/var/server.base/node_modules/annotator/annotator.js":[function(require,module,exports){
(function (global){(function (){
/*
** Annotator v2.0.0-dev-d00e70f
** https://github.com/okfn/annotator/
**
** Copyright 2014, the Annotator project contributors.
** Dual licensed under the MIT and GPLv3 licenses.
** https://github.com/okfn/annotator/blob/master/LICENSE
**
** Built at: 2014-04-11 18:30:15Z
*/
!function(e){if("object"==typeof exports)module.exports=e();else if("function"==typeof define&&define.amd)define(e);else{var n;"undefined"!=typeof window?n=window:"undefined"!=typeof global?n=global:"undefined"!=typeof self&&(n=self),n.Annotator=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
/**
 * Standalone extraction of Backbone.Events, no external dependency required.
 * Degrades nicely when Backone/underscore are already available in the current
 * global context.
 *
 * Note that docs suggest to use underscore's `_.extend()` method to add Events
 * support to some given object. A `mixin()` method has been added to the Events
 * prototype to avoid using underscore for that sole purpose:
 *
 *     var myEventEmitter = BackboneEvents.mixin({});
 *
 * Or for a function constructor:
 *
 *     function MyConstructor(){}
 *     MyConstructor.prototype.foo = function(){}
 *     BackboneEvents.mixin(MyConstructor.prototype);
 *
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * (c) 2013 Nicolas Perriault
 */
/* global exports:true, define, module */
(function() {
  var root = this,
      breaker = {},
      nativeForEach = Array.prototype.forEach,
      hasOwnProperty = Object.prototype.hasOwnProperty,
      slice = Array.prototype.slice,
      idCounter = 0;

  // Returns a partial implementation matching the minimal API subset required
  // by Backbone.Events
  function miniscore() {
    return {
      keys: Object.keys,

      uniqueId: function(prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
      },

      has: function(obj, key) {
        return hasOwnProperty.call(obj, key);
      },

      each: function(obj, iterator, context) {
        if (obj == null) return;
        if (nativeForEach && obj.forEach === nativeForEach) {
          obj.forEach(iterator, context);
        } else if (obj.length === +obj.length) {
          for (var i = 0, l = obj.length; i < l; i++) {
            if (iterator.call(context, obj[i], i, obj) === breaker) return;
          }
        } else {
          for (var key in obj) {
            if (this.has(obj, key)) {
              if (iterator.call(context, obj[key], key, obj) === breaker) return;
            }
          }
        }
      },

      once: function(func) {
        var ran = false, memo;
        return function() {
          if (ran) return memo;
          ran = true;
          memo = func.apply(this, arguments);
          func = null;
          return memo;
        };
      }
    };
  }

  var _ = miniscore(), Events;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Mixin utility
  Events.mixin = function(proto) {
    var exports = ['on', 'once', 'off', 'trigger', 'stopListening', 'listenTo',
                   'listenToOnce', 'bind', 'unbind'];
    _.each(exports, function(name) {
      proto[name] = this[name];
    }, this);
    return proto;
  };

  // Export Events as BackboneEvents depending on current context
  if (typeof define === "function") {
    define(function() {
      return Events;
    });
  } else if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = Events;
    }
    exports.BackboneEvents = Events;
  } else {
    root.BackboneEvents = Events;
  }
})(this);

},{}],2:[function(_dereq_,module,exports){
module.exports = _dereq_('./backbone-events-standalone');

},{"./backbone-events-standalone":1}],3:[function(_dereq_,module,exports){
(function (definition) {
  if (typeof exports === "object") {
    module.exports = definition();
  }
  else if (typeof define === 'function' && define.amd) {
    define(definition);
  }
  else {
    window.BackboneExtend = definition();
  }
})(function () {
  "use strict";
  
  // mini-underscore
  var _ = {
    has: function (obj, key) {
      return Object.prototype.hasOwnProperty.call(obj, key);
    },
  
    extend: function(obj) {
      for (var i=1; i<arguments.length; ++i) {
        var source = arguments[i];
        if (source) {
          for (var prop in source) {
            obj[prop] = source[prop];
          }
        }
      }
      return obj;
    }
  };

  /// Following code is pasted from Backbone.js ///

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Expose the extend function
  return extend;
});

},{}],4:[function(_dereq_,module,exports){
/*!
 * jQuery JavaScript Library v1.11.1-beta1
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-03-24T17:21Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper window is present,
		// execute the factory and get jQuery
		// For environments that do not inherently posses a window with a document
		// (such as Node.js), expose a jQuery-making factory as module.exports
		// This accentuates the need for the creation of a real window
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Can't do this because several apps including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
// Support: Firefox 18+
//

var deletedIds = [];

var slice = deletedIds.slice;

var concat = deletedIds.concat;

var push = deletedIds.push;

var indexOf = deletedIds.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "1.11.1-beta1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1, IE<9
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: deletedIds.sort,
	splice: deletedIds.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var src, copyIsArray, copy, name, options, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type(obj) === "array";
	},

	isWindow: function( obj ) {
		/* jshint eqeqeq: false */
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		return !jQuery.isArray( obj ) && obj - parseFloat( obj ) >= 0;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	isPlainObject: function( obj ) {
		var key;

		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {
			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call(obj, "constructor") &&
				!hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
				return false;
			}
		} catch ( e ) {
			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Support: IE<9
		// Handle iteration over inherited properties before own properties.
		if ( support.ownLast ) {
			for ( key in obj ) {
				return hasOwn.call( obj, key );
			}
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && jQuery.trim( data ) ) {
			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data );
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1, IE<9
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		var len;

		if ( arr ) {
			if ( indexOf ) {
				return indexOf.call( arr, elem, i );
			}

			len = arr.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {
				// Skip accessing in sparse arrays
				if ( i in arr && arr[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		while ( j < len ) {
			first[ i++ ] = second[ j++ ];
		}

		// Support: IE<9
		// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
		if ( len !== len ) {
			while ( second[j] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var args, proxy, tmp;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: function() {
		return +( new Date() );
	},

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {
	var length = obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v1.10.18
 * http://sizzlejs.com/
 *
 * Copyright 2013 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-02-05
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + -(new Date()),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	strundefined = typeof undefined,
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf if we can't use a native one
	indexOf = arr.indexOf || function( elem ) {
		var i = 0,
			len = this.length;
		for ( ; i < len; i++ ) {
			if ( this[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Acceptable operators http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")" + whitespace +
		"*(?:([*^$|!~]?=)" + whitespace + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + identifier + ")|)|)" + whitespace + "*\\]",

	// Prefer arguments quoted,
	//   then not containing pseudos/brackets,
	//   then attribute selectors/non-parenthetical expressions,
	//   then anything else
	// These preferences are here to reduce the number of selectors
	//   needing tokenize in the PSEUDO preFilter
	pseudos = ":(" + characterEncoding + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + attributes.replace( 3, 8 ) + ")*)|.*)\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];

	if ( !selector || typeof selector !== "string" ) {
		return results;
	}

	if ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {
		return [];
	}

	if ( documentIsHTML && !seed ) {

		// Shortcuts
		if ( (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName && context.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType === 9 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== strundefined && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare,
		doc = node ? node.ownerDocument || node : preferredDoc,
		parent = doc.defaultView;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;

	// Support tests
	documentIsHTML = !isXML( doc );

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", function() {
				setDocument();
			}, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", function() {
				setDocument();
			});
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Check if getElementsByClassName can be trusted
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName ) && assert(function( div ) {
		div.innerHTML = "<div class='a'></div><div class='a i'></div>";

		// Support: Safari<4
		// Catch class over-caching
		div.firstChild.className = "i";
		// Support: Opera<10
		// Catch gEBCN failure to find non-leading classes
		return div.getElementsByClassName("i").length === 2;
	});

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [m] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== strundefined ) {
				return context.getElementsByTagName( tag );
			}
		} :
		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== strundefined && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			div.innerHTML = "<select t=''><option selected=''></option></select>";

			// Support: IE8, Opera 10-12
			// Nothing should be selected when empty strings follow ^= or $= or *=
			if ( div.querySelectorAll("[t^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch(e) {}
	}

	return Sizzle( expr, document, null, [elem] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[5] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] && match[4] !== undefined ) {
				match[2] = match[4];

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome<14
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( jQuery.inArray( elem, qualifier ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			ret = [],
			self = this,
			len = self.length;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {
						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[2] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			cur = elem[ dir ];

		while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
			if ( cur.nodeType === 1 ) {
				matched.push( cur );
			}
			cur = cur[dir];
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var r = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				r.push( n );
			}
		}

		return r;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var i,
			targets = jQuery( target, this ),
			len = targets.length;

		return this.filter(function() {
			for ( i = 0; i < len; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[0] && this[0].parentNode ) ? this.first().prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[0], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(
			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[0] : elem, this );
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	do {
		cur = cur[ dir ];
	} while ( cur && cur.nodeType !== 1 );

	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				ret = jQuery.unique( ret );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				ret = ret.reverse();
			}
		}

		return this.pushStack( ret );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,
		// Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );

					} else if ( !(--remaining) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// if we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
		if ( !document.body ) {
			return setTimeout( jQuery.ready );
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * Clean-up method for dom ready events
 */
function detach() {
	if ( document.addEventListener ) {
		document.removeEventListener( "DOMContentLoaded", completed, false );
		window.removeEventListener( "load", completed, false );

	} else {
		document.detachEvent( "onreadystatechange", completed );
		window.detachEvent( "onload", completed );
	}
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	// readyState === "complete" is good enough for us to call the dom ready in oldIE
	if ( document.addEventListener || event.type === "load" || document.readyState === "complete" ) {
		detach();
		jQuery.ready();
	}
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// we once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		// Standards-based browsers support DOMContentLoaded
		} else if ( document.addEventListener ) {
			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );

		// If IE event model is used
		} else {
			// Ensure firing before onload, maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", completed );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", completed );

			// If IE and not a frame
			// continually check to see if the document is ready
			var top = false;

			try {
				top = window.frameElement == null && document.documentElement;
			} catch(e) {}

			if ( top && top.doScroll ) {
				(function doScrollCheck() {
					if ( !jQuery.isReady ) {

						try {
							// Use the trick by Diego Perini
							// http://javascript.nwbox.com/IEContentLoaded/
							top.doScroll("left");
						} catch(e) {
							return setTimeout( doScrollCheck, 50 );
						}

						// detach all dom ready events
						detach();

						// and execute any waiting functions
						jQuery.ready();
					}
				})();
			}
		}
	}
	return readyList.promise( obj );
};


var strundefined = typeof undefined;



// Support: IE<9
// Iteration over object's inherited properties before its own
var i;
for ( i in jQuery( support ) ) {
	break;
}
support.ownLast = i !== "0";

// Note: most support tests are defined in their respective modules.
// false until the test is run
support.inlineBlockNeedsLayout = false;

// Execute ASAP in case we need to set body.style.zoom
jQuery(function() {
	// Minified: var a,b,c,d
	var val, div, body, container;

	body = document.getElementsByTagName( "body" )[ 0 ];
	if ( !body || !body.style ) {
		// Return for frameset docs that don't have a body
		return;
	}

	// Setup
	div = document.createElement( "div" );
	container = document.createElement( "div" );
	container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
	body.appendChild( container ).appendChild( div );

	if ( typeof div.style.zoom !== strundefined ) {
		// Support: IE<8
		// Check if natively block-level elements act like inline-block
		// elements when setting their display to 'inline' and giving
		// them layout
		div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";

		support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
		if ( val ) {
			// Prevent IE 6 from affecting layout for positioned elements #11048
			// Prevent IE from shrinking the body in IE 7 mode #12869
			// Support: IE<8
			body.style.zoom = 1;
		}
	}

	body.removeChild( container );
});




(function() {
	var div = document.createElement( "div" );

	// Execute the test only if not already executed in another module.
	if (support.deleteExpando == null) {
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch( e ) {
			support.deleteExpando = false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
})();


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( elem ) {
	var noData = jQuery.noData[ (elem.nodeName + " ").toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute("classid") === noData;
};


var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	var name;
	for ( name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}

function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
	if ( !jQuery.acceptData( elem ) ) {
		return;
	}

	var ret, thisCache,
		internalKey = jQuery.expando,

		// We have to handle DOM nodes and JS objects differently because IE6-7
		// can't GC object references properly across the DOM-JS boundary
		isNode = elem.nodeType,

		// Only DOM nodes need the global jQuery cache; JS object data is
		// attached directly to the object so GC can occur automatically
		cache = isNode ? jQuery.cache : elem,

		// Only defining an ID for JS objects if its cache already exists allows
		// the code to shortcut on the same path as a DOM node with no cache
		id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

	// Avoid doing any more work than we need to when trying to get data on an
	// object that has no data at all
	if ( (!id || !cache[id] || (!pvt && !cache[id].data)) && data === undefined && typeof name === "string" ) {
		return;
	}

	if ( !id ) {
		// Only DOM nodes need a new unique ID for each element since their data
		// ends up in the global cache
		if ( isNode ) {
			id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
		} else {
			id = internalKey;
		}
	}

	if ( !cache[ id ] ) {
		// Avoid exposing jQuery metadata on plain JS objects when the object
		// is serialized using JSON.stringify
		cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
	}

	// An object can be passed to jQuery.data instead of a key/value pair; this gets
	// shallow copied over onto the existing cache
	if ( typeof name === "object" || typeof name === "function" ) {
		if ( pvt ) {
			cache[ id ] = jQuery.extend( cache[ id ], name );
		} else {
			cache[ id ].data = jQuery.extend( cache[ id ].data, name );
		}
	}

	thisCache = cache[ id ];

	// jQuery data() is stored in a separate object inside the object's internal data
	// cache in order to avoid key collisions between internal data and user-defined
	// data.
	if ( !pvt ) {
		if ( !thisCache.data ) {
			thisCache.data = {};
		}

		thisCache = thisCache.data;
	}

	if ( data !== undefined ) {
		thisCache[ jQuery.camelCase( name ) ] = data;
	}

	// Check for both converted-to-camel and non-converted data property names
	// If a data property was specified
	if ( typeof name === "string" ) {

		// First Try to find as-is property data
		ret = thisCache[ name ];

		// Test for null|undefined property data
		if ( ret == null ) {

			// Try to find the camelCased property
			ret = thisCache[ jQuery.camelCase( name ) ];
		}
	} else {
		ret = thisCache;
	}

	return ret;
}

function internalRemoveData( elem, name, pvt ) {
	if ( !jQuery.acceptData( elem ) ) {
		return;
	}

	var thisCache, i,
		isNode = elem.nodeType,

		// See jQuery.data for more information
		cache = isNode ? jQuery.cache : elem,
		id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

	// If there is already no cache entry for this object, there is no
	// purpose in continuing
	if ( !cache[ id ] ) {
		return;
	}

	if ( name ) {

		thisCache = pvt ? cache[ id ] : cache[ id ].data;

		if ( thisCache ) {

			// Support array or space separated string names for data keys
			if ( !jQuery.isArray( name ) ) {

				// try the string as a key before any manipulation
				if ( name in thisCache ) {
					name = [ name ];
				} else {

					// split the camel cased version by spaces unless a key with the spaces exists
					name = jQuery.camelCase( name );
					if ( name in thisCache ) {
						name = [ name ];
					} else {
						name = name.split(" ");
					}
				}
			} else {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = name.concat( jQuery.map( name, jQuery.camelCase ) );
			}

			i = name.length;
			while ( i-- ) {
				delete thisCache[ name[i] ];
			}

			// If there is no data left in the cache, we want to continue
			// and let the cache object itself get destroyed
			if ( pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache) ) {
				return;
			}
		}
	}

	// See jQuery.data for more information
	if ( !pvt ) {
		delete cache[ id ].data;

		// Don't destroy the parent cache unless the internal data object
		// had been the only thing left in it
		if ( !isEmptyDataObject( cache[ id ] ) ) {
			return;
		}
	}

	// Destroy the cache
	if ( isNode ) {
		jQuery.cleanData( [ elem ], true );

	// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	/* jshint eqeqeq: false */
	} else if ( support.deleteExpando || cache != cache.window ) {
		/* jshint eqeqeq: true */
		delete cache[ id ];

	// When all else fails, null
	} else {
		cache[ id ] = null;
	}
}

jQuery.extend({
	cache: {},

	// The following elements (space-suffixed to avoid Object.prototype collisions)
	// throw uncatchable exceptions if you attempt to set expando properties
	noData: {
		"applet ": true,
		"embed ": true,
		// ...but Flash objects (which have this classid) *can* handle expandos
		"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data ) {
		return internalData( elem, name, data );
	},

	removeData: function( elem, name ) {
		return internalRemoveData( elem, name );
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return internalData( elem, name, data, true );
	},

	_removeData: function( elem, name ) {
		return internalRemoveData( elem, name, true );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[0],
			attrs = elem && elem.attributes;

		// Special expections of .data basically thwart jQuery.access,
		// so implement the relevant behavior ourselves

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {
						name = attrs[i].name;

						if ( name.indexOf("data-") === 0 ) {
							name = jQuery.camelCase( name.slice(5) );

							dataAttr( elem, name, data[ name ] );
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				jQuery.data( this, key );
			});
		}

		return arguments.length > 1 ?

			// Sets one value
			this.each(function() {
				jQuery.data( this, key, value );
			}) :

			// Gets one value
			// Try to fetch any internally stored data first
			elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
	},

	removeData: function( key ) {
		return this.each(function() {
			jQuery.removeData( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray(data) ) {
					queue = jQuery._data( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// not intended for public consumption - generates a queueHooks object, or returns the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return jQuery._data( elem, key ) || jQuery._data( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				jQuery._removeData( elem, type + "queue" );
				jQuery._removeData( elem, key );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = jQuery._data( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};



// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		length = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < length; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			length ? fn( elems[0], key ) : emptyGet;
};
var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	// Minified: var a,b,c
	var input = document.createElement( "input" ),
		div = document.createElement( "div" ),
		fragment = document.createDocumentFragment();

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

	// IE strips leading whitespace when .innerHTML is used
	support.leadingWhitespace = div.firstChild.nodeType === 3;

	// Make sure that tbody elements aren't automatically inserted
	// IE will insert them into empty tables
	support.tbody = !div.getElementsByTagName( "tbody" ).length;

	// Make sure that link elements get serialized correctly by innerHTML
	// This requires a wrapper element in IE
	support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

	// Makes sure cloning an html5 element does not cause problems
	// Where outerHTML is undefined, this still works
	support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	input.type = "checkbox";
	input.checked = true;
	fragment.appendChild( input );
	support.appendChecked = input.checked;

	// Make sure textarea (and checkbox) defaultValue is properly cloned
	// Support: IE6-IE11+
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// #11217 - WebKit loses check when the name is after the checked attribute
	fragment.appendChild( div );
	div.innerHTML = "<input type='radio' checked='checked' name='t'/>";

	// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	// old WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<9
	// Opera does not clone events (and typeof div.attachEvent === undefined).
	// IE9-10 clones events bound via attachEvent, but they don't trigger with .click()
	support.noCloneEvent = true;
	if ( div.attachEvent ) {
		div.attachEvent( "onclick", function() {
			support.noCloneEvent = false;
		});

		div.cloneNode( true ).click();
	}

	// Execute the test only if not already executed in another module.
	if (support.deleteExpando == null) {
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch( e ) {
			support.deleteExpando = false;
		}
	}
})();


(function() {
	var i, eventName,
		div = document.createElement( "div" );

	// Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)
	for ( i in { submit: true, change: true, focusin: true }) {
		eventName = "on" + i;

		if ( !(support[ i + "Bubbles" ] = eventName in window) ) {
			// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
			div.setAttribute( eventName, "t" );
			support[ i + "Bubbles" ] = div.attributes[ eventName ].expando === false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
})();


var rformElems = /^(?:input|select|textarea)$/i,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {
		var tmp, events, t, handleObjIn,
			special, eventHandle, handleObj,
			handlers, type, namespaces, origType,
			elemData = jQuery._data( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && (!e || jQuery.event.triggered !== e.type) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};
			// Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {
		var j, handleObj, tmp,
			origCount, t, events,
			special, handlers, type,
			namespaces, origType,
			elemData = jQuery.hasData( elem ) && jQuery._data( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery._removeData( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		var handle, ontype, cur,
			bubbleType, special, tmp, i,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					try {
						elem[ type ]();
					} catch ( e ) {
						// IE<9 dies on focus/blur to hidden element (#1486,#12518)
						// only reproducible on winXP IE8 native, not IE9 in IE8 mode
					}
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, ret, handleObj, matched, j,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or
				// 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var sel, handleObj, matches, i,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			/* jshint eqeqeq: false */
			for ( ; cur != this; cur = cur.parentNode || this ) {
				/* jshint eqeqeq: true */

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click") ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: IE<9
		// Fix target property (#1925)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Support: Chrome 23+, Safari?
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// Support: IE<9
		// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
		event.metaKey = !!event.metaKey;

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var body, eventDoc, doc,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					try {
						this.focus();
						return false;
					} catch ( e ) {
						// Support: IE<9
						// If we error on focus to hidden element (#1486, #12518),
						// let .trigger() run the handlers
					}
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle, false );
		}
	} :
	function( elem, type, handle ) {
		var name = "on" + type;

		if ( elem.detachEvent ) {

			// #8545, #7054, preventing memory leaks for custom events in IE6-8
			// detachEvent needed property on element, by name of that event, to properly expose it to GC
			if ( typeof elem[ name ] === strundefined ) {
				elem[ name ] = null;
			}

			elem.detachEvent( name, handle );
		}
	};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: IE < 9, Android < 4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;
		if ( !e ) {
			return;
		}

		// If preventDefault exists, run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// Support: IE
		// Otherwise set the returnValue property of the original event to false
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;
		if ( !e ) {
			return;
		}
		// If stopPropagation exists, run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}

		// Support: IE
		// Set the cancelBubble property of the original event to true
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// IE submit delegation
if ( !support.submitBubbles ) {

	jQuery.event.special.submit = {
		setup: function() {
			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
				if ( form && !jQuery._data( form, "submitBubbles" ) ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submit_bubble = true;
					});
					jQuery._data( form, "submitBubbles", true );
				}
			});
			// return undefined since we don't need an event listener
		},

		postDispatch: function( event ) {
			// If form was submitted by the user, bubble the event up the tree
			if ( event._submit_bubble ) {
				delete event._submit_bubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event, true );
				}
			}
		},

		teardown: function() {
			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !support.changeBubbles ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {
				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._just_changed = true;
						}
					});
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._just_changed && !event.isTrigger ) {
							this._just_changed = false;
						}
						// Allow triggered, simulated change events (#11500)
						jQuery.event.simulate( "change", this, event, true );
					});
				}
				return false;
			}
			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "changeBubbles" ) ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event, true );
						}
					});
					jQuery._data( elem, "changeBubbles", true );
				}
			});
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return !rformElems.test( this.nodeName );
		}
	};
}

// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					jQuery._removeData( doc, fix );
				} else {
					jQuery._data( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var type, origFn;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
		"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
	rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
	rleadingWhitespace = /^\s+/,
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rtbody = /<tbody/i,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		area: [ 1, "<map>", "</map>" ],
		param: [ 1, "<object>", "</object>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
		// unless wrapped in a div with non-breaking characters in front of it.
		_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>"  ]
	},
	safeFragment = createSafeFragment( document ),
	fragmentDiv = safeFragment.appendChild( document.createElement("div") );

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

function getAll( context, tag ) {
	var elems, elem,
		i = 0,
		found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== strundefined ? context.querySelectorAll( tag || "*" ) :
			undefined;

	if ( !found ) {
		for ( found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++ ) {
			if ( !tag || jQuery.nodeName( elem, tag ) ) {
				found.push( elem );
			} else {
				jQuery.merge( found, getAll( elem, tag ) );
			}
		}
	}

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], found ) :
		found;
}

// Used in buildFragment, fixes the defaultChecked property
function fixDefaultChecked( elem ) {
	if ( rcheckableType.test( elem.type ) ) {
		elem.defaultChecked = elem.checked;
	}
}

// Support: IE<8
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (jQuery.find.attr( elem, "type" ) !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );
	if ( match ) {
		elem.type = match[1];
	} else {
		elem.removeAttribute("type");
	}
	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; (elem = elems[i]) != null; i++ ) {
		jQuery._data( elem, "globalEval", !refElements || jQuery._data( refElements[i], "globalEval" ) );
	}
}

function cloneCopyEvent( src, dest ) {

	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function fixCloneNodeIssues( src, dest ) {
	var nodeName, e, data;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 copies events bound via attachEvent when using cloneNode.
	if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
		data = jQuery._data( dest );

		for ( e in data.events ) {
			jQuery.removeEvent( dest, e, data.handle );
		}

		// Event data gets referenced instead of copied if the expando gets copied too
		dest.removeAttribute( jQuery.expando );
	}

	// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
	if ( nodeName === "script" && dest.text !== src.text ) {
		disableScript( dest ).text = src.text;
		restoreScript( dest );

	// IE6-10 improperly clones children of object elements using classid.
	// IE10 throws NoModificationAllowedError if parent is null, #12132.
	} else if ( nodeName === "object" ) {
		if ( dest.parentNode ) {
			dest.outerHTML = src.outerHTML;
		}

		// This path appears unavoidable for IE9. When cloning an object
		// element in IE9, the outerHTML strategy above is not sufficient.
		// If the src has innerHTML and the destination does not,
		// copy the src.innerHTML into the dest.innerHTML. #10324
		if ( support.html5Clone && ( src.innerHTML && !jQuery.trim(dest.innerHTML) ) ) {
			dest.innerHTML = src.innerHTML;
		}

	} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set

		dest.defaultChecked = dest.checked = src.checked;

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.defaultSelected = dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var destElements, node, clone, i, srcElements,
			inPage = jQuery.contains( elem.ownerDocument, elem );

		if ( support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
			clone = elem.cloneNode( true );

		// IE<=8 does not properly clone detached, unknown element nodes
		} else {
			fragmentDiv.innerHTML = elem.outerHTML;
			fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
		}

		if ( (!support.noCloneEvent || !support.noCloneChecked) &&
				(elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			// Fix all IE cloning issues
			for ( i = 0; (node = srcElements[i]) != null; ++i ) {
				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[i] ) {
					fixCloneNodeIssues( node, destElements[i] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0; (node = srcElements[i]) != null; i++ ) {
					cloneCopyEvent( node, destElements[i] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		destElements = srcElements = node = null;

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var j, elem, contains,
			tmp, tag, tbody, wrap,
			l = elems.length,

			// Ensure a safe fragment
			safe = createSafeFragment( context ),

			nodes = [],
			i = 0;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || safe.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = (rtagName.exec( elem ) || [ "", "" ])[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;

					tmp.innerHTML = wrap[1] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[2];

					// Descend through wrappers to the right content
					j = wrap[0];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Manually add leading whitespace removed by IE
					if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[0] ) );
					}

					// Remove IE's autoinserted <tbody> from table fragments
					if ( !support.tbody ) {

						// String was a <table>, *may* have spurious <tbody>
						elem = tag === "table" && !rtbody.test( elem ) ?
							tmp.firstChild :

							// String was a bare <thead> or <tfoot>
							wrap[1] === "<table>" && !rtbody.test( elem ) ?
								tmp :
								0;

						j = elem && elem.childNodes.length;
						while ( j-- ) {
							if ( jQuery.nodeName( (tbody = elem.childNodes[j]), "tbody" ) && !tbody.childNodes.length ) {
								elem.removeChild( tbody );
							}
						}
					}

					jQuery.merge( nodes, tmp.childNodes );

					// Fix #12392 for WebKit and IE > 9
					tmp.textContent = "";

					// Fix #12392 for oldIE
					while ( tmp.firstChild ) {
						tmp.removeChild( tmp.firstChild );
					}

					// Remember the top-level container for proper cleanup
					tmp = safe.lastChild;
				}
			}
		}

		// Fix #11356: Clear elements from fragment
		if ( tmp ) {
			safe.removeChild( tmp );
		}

		// Reset defaultChecked for any radios and checkboxes
		// about to be appended to the DOM in IE 6/7 (#8060)
		if ( !support.appendChecked ) {
			jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
		}

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( safe.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		tmp = null;

		return safe;
	},

	cleanData: function( elems, /* internal */ acceptData ) {
		var elem, type, id, data,
			i = 0,
			internalKey = jQuery.expando,
			cache = jQuery.cache,
			deleteExpando = support.deleteExpando,
			special = jQuery.event.special;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( acceptData || jQuery.acceptData( elem ) ) {

				id = elem[ internalKey ];
				data = id && cache[ id ];

				if ( data ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Remove cache only if it was not already removed by jQuery.event.remove
					if ( cache[ id ] ) {

						delete cache[ id ];

						// IE does not allow us to delete expando properties from nodes,
						// nor does it have a removeAttribute function on Document nodes;
						// we must handle all of these cases
						if ( deleteExpando ) {
							delete elem[ internalKey ];

						} else if ( typeof elem.removeAttribute !== strundefined ) {
							elem.removeAttribute( internalKey );

						} else {
							elem[ internalKey ] = null;
						}

						deletedIds.push( id );
					}
				}
			}
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {

			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem, false ) );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}

			// If this is a select, ensure that it displays empty (#12336)
			// Support: IE<9
			if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
				elem.options.length = 0;
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					undefined;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ (rtagName.exec( value ) || [ "", "" ])[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for (; i < l; i++ ) {
						// Remove element nodes and prevent memory leaks
						elem = this[i] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch(e) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var first, node, hasScripts,
			scripts, doc, fragment,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[0],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[0] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[i], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( ( node.text || node.textContent || node.innerHTML || "" ).replace( rcleanScript, "" ) );
							}
						}
					}
				}

				// Fix #11809: Avoid leaking memory
				fragment = first = null;
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			i = 0,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone(true);
			jQuery( insert[i] )[ original ]( elems );

			// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optmization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}


(function() {
	var shrinkWrapBlocksVal;

	support.shrinkWrapBlocks = function() {
		if ( shrinkWrapBlocksVal != null ) {
			return shrinkWrapBlocksVal;
		}

		// Will be changed later if needed.
		shrinkWrapBlocksVal = false;

		// Minified: var b,c,d
		var div, body, container;

		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );

		// Support: IE6
		// Check if elements with layout shrink-wrap their children
		if ( typeof div.style.zoom !== strundefined ) {
			// Reset CSS: box-sizing; display; margin; border
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;" +
				"padding:1px;width:1px;zoom:1";
			div.appendChild( document.createElement( "div" ) ).style.width = "5px";
			shrinkWrapBlocksVal = div.offsetWidth !== 3;
		}

		body.removeChild( container );

		return shrinkWrapBlocksVal;
	};

})();
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );



var getStyles, curCSS,
	rposition = /^(top|right|bottom|left)$/;

if ( window.getComputedStyle ) {
	getStyles = function( elem ) {
		return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
	};

	curCSS = function( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is only needed for .css('filter') in IE9, see #12537
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

		if ( computed ) {

			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
			// Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
			// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
			if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "";
	};
} else if ( document.documentElement.currentStyle ) {
	getStyles = function( elem ) {
		return elem.currentStyle;
	};

	curCSS = function( elem, name, computed ) {
		var left, rs, rsLeft, ret,
			style = elem.style;

		computed = computed || getStyles( elem );
		ret = computed ? computed[ name ] : undefined;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && style[ name ] ) {
			ret = style[ name ];
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		// but not position css attributes, as those are proportional to the parent element instead
		// and we can't measure the parent instead because it might trigger a "stacking dolls" problem
		if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

			// Remember the original values
			left = style.left;
			rs = elem.runtimeStyle;
			rsLeft = rs && rs.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				rs.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				rs.left = rsLeft;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "" || "auto";
	};
}




function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			var condition = conditionFn();

			if ( condition == null ) {
				// The test was not ready at this point; screw the hook this time
				// but check again when needed next time.
				return;
			}

			if ( condition ) {
				// Hook not needed (or it's not possible to use it due to missing dependency),
				// remove it.
				// Since there are no other hooks for marginRight, remove the whole object.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.

			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	// Minified: var b,c,d,e,f,g, h,i
	var div, style, a, pixelPositionVal, boxSizingReliableVal,
		reliableHiddenOffsetsVal, reliableMarginRightVal;

	// Setup
	div = document.createElement( "div" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];
	style = a && a.style;

	// Finish early in limited (non-browser) environments
	if ( !style ) {
		return;
	}

	style.cssText = "float:left;opacity:.5";

	// Support: IE<9
	// Make sure that element opacity exists (as opposed to filter)
	support.opacity = style.opacity === "0.5";

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	// Support: Firefox<29, Android 2.3
	// Vendor-prefix box-sizing
	support.boxSizing = style.boxSizing === "" || style.MozBoxSizing === "" ||
		style.WebkitBoxSizing === "";

	jQuery.extend(support, {
		reliableHiddenOffsets: function() {
			if ( reliableHiddenOffsetsVal == null ) {
				computeStyleTests();
			}
			return reliableHiddenOffsetsVal;
		},

		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},

		pixelPosition: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelPositionVal;
		},

		// Support: Android 2.3
		reliableMarginRight: function() {
			if ( reliableMarginRightVal == null ) {
				computeStyleTests();
			}
			return reliableMarginRightVal;
		}
	});

	function computeStyleTests() {
		// Minified: var b,c,d,j
		var div, body, container, contents;

		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );

		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";

		// Support: IE<9
		// Assume reasonable values in the absence of getComputedStyle
		pixelPositionVal = boxSizingReliableVal = false;
		reliableMarginRightVal = true;

		// Check for getComputedStyle so that this code is not run in IE<9.
		if ( window.getComputedStyle ) {
			pixelPositionVal = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
			boxSizingReliableVal =
				( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";

			// Support: Android 2.3
			// Div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			contents = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			contents.style.cssText = div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
			contents.style.marginRight = contents.style.width = "0";
			div.style.width = "1px";

			reliableMarginRightVal =
				!parseFloat( ( window.getComputedStyle( contents, null ) || {} ).marginRight );
		}

		// Support: IE8
		// Check if table cells still have offsetWidth/Height when they are set
		// to display:none and there are still other visible table cells in a
		// table row; if so, offsetWidth/Height are not reliable for use when
		// determining if an element has been hidden directly using
		// display:none (it is still safe to use offsets if a parent element is
		// hidden; don safety goggles and see bug #4512 for more information).
		div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
		contents = div.getElementsByTagName( "td" );
		contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
		reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
		if ( reliableHiddenOffsetsVal ) {
			contents[ 0 ].style.display = "";
			contents[ 1 ].style.display = "none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
		}

		body.removeChild( container );
	}

})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
		ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity\s*=\s*([^)]*)/,

	// swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];


// return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// check for vendor prefixed names
	var capName = name.charAt(0).toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = jQuery._data( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = jQuery._data( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display && display !== "none" || !hidden ) {
				jQuery._data( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// at this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// at this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// at this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// we need the check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox && ( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend({
	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {
					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		// normalize float css property
		"float": support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {
		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// convert relative number strings (+= or -=) to relative numbers. #7345
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set. See: #7116
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
			// but it would mean to define eight (for every problematic property) identical functions
			if ( !support.clearCloneStyle && value === "" && name.indexOf("background") === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {

				// Support: IE
				// Swallow errors from 'invalid' CSS values (#5509)
				try {
					style[ name ] = value;
				} catch(e) {}
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var num, val, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		//convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Return, converting to number if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {
				// certain elements can have dimension info if we invisibly show them
				// however, it must have a current display style that would benefit from this
				return elem.offsetWidth === 0 && rdisplayswap.test( jQuery.css( elem, "display" ) ) ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

if ( !support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {
			// IE uses filters for opacity
			return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
				( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
				computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
			// if value === "", then remove inline opacity #12685
			if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there is no filter style applied in a css rule or unset inline opacity, we are done
				if ( value === "" || currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// Work around by temporarily setting element display to inline-block
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails
			// so, simple values such as "10px" are parsed to Float.
			// complex values such as "rotate(1rad)" are returned as is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// use step hook for back compat - use cssHook if its there - use .style if its
			// available and use plain properties where available
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9
// Panic based approach to setting things on disconnected nodes

Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*
					// Use a string for doubling factor so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur()
				// And breaking the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		attrs = { height: type },
		i = 0;

	// if we include width, step value is 1 to do all cssExpand values,
	// if we don't include width, step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// we're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = jQuery._data( elem, "fxshow" );

	// handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// doing this makes sure that the complete handler will be called
			// before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE does not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );
		// Test default display if display is currently "none"
		if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" &&
				jQuery.css( elem, "float" ) === "none" ) {

			// inline-level elements accept inline-block;
			// block-level elements need to be inline with layout
			if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
				style.display = "inline-block";
			} else {
				style.zoom = 1;
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		if ( !support.shrinkWrapBlocks() ) {
			anim.always(function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			});
		}
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = jQuery._data( elem, "fxshow", {} );
		}

		// store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;
			jQuery._removeData( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// not quite $.extend, this wont overwrite keys already present.
			// also - reusing 'index' from above because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// resolve when we played the last frame
				// otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || jQuery._data( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = jQuery._data( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = jQuery._data( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// enable finishing flag on private data
			data.finish = true;

			// empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		timers = jQuery.timers,
		i = 0;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	// Minified: var a,b,c,d,e
	var input, div, select, a, opt;

	// Setup
	div = document.createElement( "div" );
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName("a")[ 0 ];

	// First batch of tests.
	select = document.createElement("select");
	opt = select.appendChild( document.createElement("option") );
	input = div.getElementsByTagName("input")[ 0 ];

	a.style.cssText = "top:1px";

	// Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	support.getSetAttribute = div.className !== "t";

	// Get the style information from getAttribute
	// (IE uses .cssText instead)
	support.style = /top/.test( a.getAttribute("style") );

	// Make sure that URLs aren't manipulated
	// (IE normalizes it by default)
	support.hrefNormalized = a.getAttribute("href") === "/a";

	// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
	support.checkOn = !!input.value;

	// Make sure that a selected-by-default option has a working selected property.
	// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	support.optSelected = opt.selected;

	// Tests for enctype support on a form (#6743)
	support.enctype = !!document.createElement("form").enctype;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE8 only
	// Check if we can trust getAttribute("value")
	input = document.createElement( "input" );
	input.setAttribute( "value", "" );
	support.input = input.getAttribute( "value" ) === "";

	// Check if an input maintains its value after becoming a radio
	input.value = "t";
	input.setAttribute( "type", "radio" );
	support.radioValue = input.value === "t";
})();


var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// handle most common string cases
					ret.replace(rreturn, "") :
					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// oldIE doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) >= 0 ) {

						// Support: IE6
						// When new option element is added to select box we need to
						// force reflow of newly added node in order to workaround delay
						// of initialization properties
						try {
							option.selected = optionSet = true;

						} catch ( _ ) {

							// Will be executed only in IE6
							option.scrollHeight;
						}

					} else {
						option.selected = false;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}

				return options;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			// Support: Webkit
			// "" is returned instead of "on" if a value isn't specified
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle,
	ruseDefault = /^(?:checked|selected)$/i,
	getSetAttribute = support.getSetAttribute,
	getSetInput = support.input;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
						elem[ propName ] = false;
					// Support: IE<9
					// Also clear defaultChecked/defaultSelected (if appropriate)
					} else {
						elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
					}

				// See #9699 for explanation of this approach (setting first, then removal)
				} else {
					jQuery.attr( elem, name, "" );
				}

				elem.removeAttribute( getSetAttribute ? name : propName );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
					// Setting the type on a radio button after the value resets the value in IE6-9
					// Reset value to default in case type is set after value during creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hook for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
			// IE<8 needs the *property* name
			elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

		// Use defaultChecked and defaultSelected for oldIE
		} else {
			elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
		}

		return name;
	}
};

// Retrieve booleans specially
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {

	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = getSetInput && getSetAttribute || !ruseDefault.test( name ) ?
		function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		} :
		function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem[ jQuery.camelCase( "default-" + name ) ] ?
					name.toLowerCase() :
					null;
			}
		};
});

// fix oldIE attroperties
if ( !getSetInput || !getSetAttribute ) {
	jQuery.attrHooks.value = {
		set: function( elem, value, name ) {
			if ( jQuery.nodeName( elem, "input" ) ) {
				// Does not return so that setAttribute is also used
				elem.defaultValue = value;
			} else {
				// Use nodeHook if defined (#1954); otherwise setAttribute is fine
				return nodeHook && nodeHook.set( elem, value, name );
			}
		}
	};
}

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = {
		set: function( elem, value, name ) {
			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				elem.setAttributeNode(
					(ret = elem.ownerDocument.createAttribute( name ))
				);
			}

			ret.value = value += "";

			// Break association with cloned elements by also using setAttribute (#9646)
			if ( name === "value" || value === elem.getAttribute( name ) ) {
				return value;
			}
		}
	};

	// Some attributes are constructed with empty-string values when not defined
	attrHandle.id = attrHandle.name = attrHandle.coords =
		function( elem, name, isXML ) {
			var ret;
			if ( !isXML ) {
				return (ret = elem.getAttributeNode( name )) && ret.value !== "" ?
					ret.value :
					null;
			}
		};

	// Fixing value retrieval on a button requires this module
	jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret = elem.getAttributeNode( name );
			if ( ret && ret.specified ) {
				return ret.value;
			}
		},
		set: nodeHook.set
	};

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		set: function( elem, value, name ) {
			nodeHook.set( elem, value === "" ? false : value, name );
		}
	};

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each([ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		};
	});
}

if ( !support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {
			// Return undefined in the case of empty string
			// Note: IE uppercases css property names, but if we were to .toLowerCase()
			// .cssText, that would destroy case senstitivity in URL's, like in "background"
			return elem.style.cssText || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = value + "" );
		}
	};
}




var rfocusable = /^(?:input|select|textarea|button|object)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each(function() {
			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch( e ) {}
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				// elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
						0 :
						-1;
			}
		}
	}
});

// Some attributes require a special call on IE
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !support.hrefNormalized ) {
	// href/src property should get the full normalized URL (#10299/#12915)
	jQuery.each([ "href", "src" ], function( i, name ) {
		jQuery.propHooks[ name ] = {
			get: function( elem ) {
				return elem.getAttribute( name, 4 );
			}
		};
	});
}

// Support: Safari, IE9+
// mis-reports the default selected property of an option
// Accessing the parent's selectedIndex property fixes it
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});

// IE6/7 call enctype encoding
if ( !support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			i = 0,
			len = this.length,
			proceed = typeof value === "string" && value;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			i = 0,
			len = this.length,
			proceed = arguments.length === 0 || typeof value === "string" && value;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					jQuery._data( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed "false",
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

jQuery.parseJSON = function( data ) {
	// Attempt to parse using the native JSON parser first
	if ( window.JSON && window.JSON.parse ) {
		// Support: Android 2.3
		// Workaround failure to string-cast null input
		return window.JSON.parse( data + "" );
	}

	var requireNonComma,
		depth = null,
		str = jQuery.trim( data + "" );

	// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	// after removing valid tokens
	return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

		// Force termination if we see a misplaced comma
		if ( requireNonComma && comma ) {
			depth = 0;
		}

		// Perform no more replacements after returning to outermost depth
		if ( depth === 0 ) {
			return token;
		}

		// Commas must not follow "[", "{", or ","
		requireNonComma = open || comma;

		// Determine new depth
		// array/object open ("[" or "{"): depth += true - false (increment)
		// array/object close ("]" or "}"): depth += false - true (decrement)
		// other cases ("," or primitive): depth += true - true (numeric cast)
		depth += !close - !open;

		// Remove this token
		return "";
	}) ) ?
		( Function( "return " + str ) )() :
		jQuery.error( "Invalid JSON: " + data );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	try {
		if ( window.DOMParser ) { // Standard
			tmp = new DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} else { // IE
			xml = new ActiveXObject( "Microsoft.XMLDOM" );
			xml.async = "false";
			xml.loadXML( data );
		}
	} catch( e ) {
		xml = undefined;
	}
	if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	// Document location
	ajaxLocParts,
	ajaxLocation,

	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat("*");

// #8138, IE may throw an exception when accessing
// a field from window.location if document.domain has been set
try {
	ajaxLocation = location.href;
} catch( e ) {
	// Use the href attribute of an A element
	// since IE will modify it given document.location
	ajaxLocation = document.createElement( "a" );
	ajaxLocation.href = "";
	ajaxLocation = ajaxLocation.href;
}

// Segment location into parts
ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType.charAt( 0 ) === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var deep, key,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {
	var firstDataType, ct, finalDataType, type,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var // Cross-domain detection vars
			parts,
			// Loop variable
			i,
			// URL without anti-cache param
			cacheURL,
			// Response headers as string
			responseHeadersString,
			// timeout handle
			timeoutTimer,

			// To know if global events are to be dispatched
			fireGlobals,

			transport,
			// Response headers
			responseHeaders,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		fireGlobals = s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});

// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function(i) {
				jQuery(this).wrapAll( html.call(this, i) );
			});
		}

		if ( this[0] ) {
			// The elements to wrap the target around
			var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);

			if ( this[0].parentNode ) {
				wrap.insertBefore( this[0] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function(i) {
				jQuery(this).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function(i) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 ||
		(!support.reliableHiddenOffsets() &&
			((elem.style && elem.style.display) || jQuery.css( elem, "display" )) === "none");
};

jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;
			// Use .is(":disabled") so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	// Support: IE6+
	function() {

		// XHR cannot access local files, always use ActiveX for that case
		return !this.isLocal &&

			// Support: IE7-8
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			/^(get|post|head|put|delete|options)$/i.test( this.type ) &&

			createStandardXHR() || createActiveXHR();
	} :
	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

var xhrId = 0,
	xhrCallbacks = {},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE<10
// Open requests must be manually aborted on unload (#5280)
if ( window.ActiveXObject ) {
	jQuery( window ).on( "unload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( undefined, true );
		}
	});
}

// Determine support properties
support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
xhrSupported = support.ajax = !!xhrSupported;

// Create transport if the browser can provide an xhr
if ( xhrSupported ) {

	jQuery.ajaxTransport(function( options ) {
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !options.crossDomain || support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;

					// Open the socket
					xhr.open( options.type, options.url, options.async, options.username, options.password );

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers["X-Requested-With"] ) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {
						// Support: IE<9
						// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
						// request header to a null-value.
						//
						// To keep consistent with other XHR implementations, cast the value
						// to string and ignore `undefined`.
						if ( headers[ i ] !== undefined ) {
							xhr.setRequestHeader( i, headers[ i ] + "" );
						}
					}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( options.hasContent && options.data ) || null );

					// Listener
					callback = function( _, isAbort ) {
						var status, statusText, responses;

						// Was never called and is aborted or complete
						if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
							// Clean up
							delete xhrCallbacks[ id ];
							callback = undefined;
							xhr.onreadystatechange = jQuery.noop;

							// Abort manually if needed
							if ( isAbort ) {
								if ( xhr.readyState !== 4 ) {
									xhr.abort();
								}
							} else {
								responses = {};
								status = xhr.status;

								// Support: IE<10
								// Accessing binary-data responseText throws an exception
								// (#11426)
								if ( typeof xhr.responseText === "string" ) {
									responses.text = xhr.responseText;
								}

								// Firefox throws an exception when accessing
								// statusText for faulty cross-domain requests
								try {
									statusText = xhr.statusText;
								} catch( e ) {
									// We normalize with Webkit giving an empty statusText
									statusText = "";
								}

								// Filter status for non standard behaviors

								// If the request is local and we have data: assume a success
								// (success with no data won't get notified, that's the best we
								// can do given current implementations)
								if ( !status && options.isLocal && !options.crossDomain ) {
									status = responses.text ? 200 : 404;
								// IE - #1450: sometimes returns 1223 when it should be 204
								} else if ( status === 1223 ) {
									status = 204;
								}
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, xhr.getAllResponseHeaders() );
						}
					};

					if ( !options.async ) {
						// if we're in sync mode we fire the callback
						callback();
					} else if ( xhr.readyState === 4 ) {
						// (IE6 & IE7) if it's in cache and has been
						// retrieved directly we need to fire the callback
						setTimeout( callback );
					} else {
						// Add to the list of active xhr callbacks
						xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback( undefined, true );
					}
				}
			};
		}
	});
}

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch( e ) {}
}




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function(s) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || jQuery("head")[0] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement("script");

				script.async = true;

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( script.parentNode ) {
							script.parentNode.removeChild( script );
						}

						// Dereference the script
						script = null;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};

				// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
				// Use native DOM manipulation to avoid our domManip AJAX trickery
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( undefined, true );
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, response, type,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off, url.length ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};





var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray("auto", [ curCSSTop, curCSSLeft ] ) > -1;

		// need to be able to calculate position if either top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			box = { top: 0, left: 0 },
			elem = this[ 0 ],
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// If we don't have gBCR, just use 0,0 rather than error
		// BlackBerry 5, iOS 3 (original iPhone)
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
			left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			parentOffset = { top: 0, left: 0 },
			elem = this[ 0 ];

		// fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// we assume that getBoundingClientRect is available when computed position is fixed
			offset = elem.getBoundingClientRect();
		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		return {
			top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true)
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? (prop in win) ? win[ prop ] :
					win.document.documentElement[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// getComputedStyle returns percent when specified for top/left/bottom/right
// rather than make the css module depend on the offset module, we just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// if curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
					// unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	});
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in
// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));

},{}],5:[function(_dereq_,module,exports){
var $, AnnotationRegistry,
  __hasProp = {}.hasOwnProperty;

$ = _dereq_('./util').$;

AnnotationRegistry = (function() {
  function AnnotationRegistry() {}

  AnnotationRegistry.prototype.configure = function(config) {
    return this.core = config.core, config;
  };

  AnnotationRegistry.prototype.create = function(obj) {
    if (obj == null) {
      obj = {};
    }
    return this._cycle(obj, 'create');
  };

  AnnotationRegistry.prototype.update = function(obj) {
    if (obj.id == null) {
      throw new TypeError("annotation must have an id for update()");
    }
    return this._cycle(obj, 'update');
  };

  AnnotationRegistry.prototype["delete"] = function(obj) {
    if (obj.id == null) {
      throw new TypeError("annotation must have an id for delete()");
    }
    return this._cycle(obj, 'delete');
  };

  AnnotationRegistry.prototype.query = function(query) {
    return this.core.store.query(query);
  };

  AnnotationRegistry.prototype._cycle = function(obj, storeFunc) {
    var safeCopy;
    safeCopy = $.extend(true, {}, obj);
    delete safeCopy._local;
    return this.core.store[storeFunc](safeCopy).then(function(ret) {
      var k, v;
      for (k in obj) {
        if (!__hasProp.call(obj, k)) continue;
        v = obj[k];
        if (k !== '_local') {
          delete obj[k];
        }
      }
      $.extend(obj, ret);
      return obj;
    });
  };

  return AnnotationRegistry;

})();

module.exports = AnnotationRegistry;


},{"./util":14}],6:[function(_dereq_,module,exports){
var $, AnnotationRegistry, Annotator, Delegator, Editor, Factory, Notification, NullStore, Plugin, Range, Util, Viewer, Widget, extend, g, handleError, notification, _Annotator, _ref, _t,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

extend = _dereq_('backbone-extend-standalone');

Delegator = _dereq_('./delegator');

Range = _dereq_('./range');

Util = _dereq_('./util');

Widget = _dereq_('./widget');

Viewer = _dereq_('./viewer');

Editor = _dereq_('./editor');

Notification = _dereq_('./notification');

Factory = _dereq_('./factory');

Plugin = _dereq_('./plugin');

AnnotationRegistry = _dereq_('./annotations');

NullStore = _dereq_('./nullstore');

$ = Util.$;

_t = Util.TranslationString;

_Annotator = this.Annotator;

handleError = function() {
  return console.error.apply(console, arguments);
};

Annotator = (function(_super) {
  __extends(Annotator, _super);

  Annotator.prototype.events = {
    ".annotator-adder button click": "onAdderClick",
    ".annotator-adder button mousedown": "onAdderMousedown",
    ".annotator-hl mouseover": "onHighlightMouseover",
    ".annotator-hl mouseout": "startViewerHideTimer"
  };

  Annotator.prototype.html = {
    adder: '<div class="annotator-adder"><button type="button">' + _t('Annotate') + '</button></div>',
    wrapper: '<div class="annotator-wrapper"></div>'
  };

  Annotator.prototype.options = {
    store: null,
    readOnly: false,
    loadQuery: null
  };

  Annotator.prototype.plugins = {};

  Annotator.prototype.editor = null;

  Annotator.prototype.viewer = null;

  Annotator.prototype.selectedRanges = null;

  Annotator.prototype.mouseIsDown = false;

  Annotator.prototype.ignoreMouseup = false;

  Annotator.prototype.viewerHideTimer = null;

  function Annotator(element, options) {
    this.onEditAnnotation = __bind(this.onEditAnnotation, this);
    this.onAdderClick = __bind(this.onAdderClick, this);
    this.onAdderMousedown = __bind(this.onAdderMousedown, this);
    this.onHighlightMouseover = __bind(this.onHighlightMouseover, this);
    this.checkForEndSelection = __bind(this.checkForEndSelection, this);
    this.checkForStartSelection = __bind(this.checkForStartSelection, this);
    this.clearViewerHideTimer = __bind(this.clearViewerHideTimer, this);
    this.startViewerHideTimer = __bind(this.startViewerHideTimer, this);
    this.showViewer = __bind(this.showViewer, this);
    this.onEditorSubmit = __bind(this.onEditorSubmit, this);
    this.onEditorHide = __bind(this.onEditorHide, this);
    this.showEditor = __bind(this.showEditor, this);
    var factory;
    this.options = $.extend(true, {}, this.options, options);
    this.plugins = {};
    Annotator._instances.push(this);
    Annotator.Plugin._rebindOldPlugins();
    if (!Annotator.supported()) {
      return this;
    }
    if (element) {
      factory = new Factory();
      if (this.options.store) {
        factory.setStore(this.options.store.type, this.options.store);
      } else {
        factory.setStore(NullStore);
      }
      factory.configureInstance(this);
      this.attach(element);
    }
  }

  Annotator.prototype.configure = function(config) {
    var klass, name, p, plugins, _i, _len, _ref;
    this.store = config.store, plugins = config.plugins;
    this.plugins = {};
    for (_i = 0, _len = plugins.length; _i < _len; _i++) {
      p = plugins[_i];
      _ref = Annotator.Plugin._ctors;
      for (name in _ref) {
        klass = _ref[name];
        if (p.constructor === klass) {
          this.plugins[name] = p;
          break;
        }
      }
    }
    this.annotations = new AnnotationRegistry();
    return this.annotations.configure({
      core: this
    });
  };

  Annotator.prototype.attach = function(element) {
    var name, p;
    this.element = $(element);
    this.addEvents();
    if (!this.options.readOnly) {
      this._setupDocumentEvents();
    }
    this._setupWrapper()._setupViewer()._setupEditor();
    this._setupDynamicStyle();
    this.adder = $(this.html.adder).appendTo(this.wrapper).hide();
    if (this.options.loadQuery) {
      this.load(this.options.loadQuery);
    }
    for (name in this.plugins) {
      p = this.plugins[name];
      p.annotator = this;
      if (typeof p.pluginInit === "function") {
        p.pluginInit();
      }
    }
    return this;
  };

  Annotator.extend = extend;

  Annotator.prototype._setupWrapper = function() {
    this.wrapper = $(this.html.wrapper);
    this.element.find('script').remove();
    this.element.wrapInner(this.wrapper);
    this.wrapper = this.element.find('.annotator-wrapper');
    return this;
  };

  Annotator.prototype._setupViewer = function() {
    this.viewer = new Annotator.Viewer({
      readOnly: this.options.readOnly
    });
    this.viewer.hide().on("edit", this.onEditAnnotation).on("delete", (function(_this) {
      return function(annotation) {
        _this.viewer.hide();
        _this.publish('beforeAnnotationDeleted', [annotation]);
        _this.cleanupAnnotation(annotation);
        return _this.annotations["delete"](annotation).done(function() {
          return _this.publish('annotationDeleted', [annotation]);
        });
      };
    })(this)).addField({
      load: (function(_this) {
        return function(field, annotation) {
          if (annotation.text) {
            $(field).html(Util.escape(annotation.text));
          } else {
            $(field).html("<i>" + (_t('No Comment')) + "</i>");
          }
          return _this.publish('annotationViewerTextField', [field, annotation]);
        };
      })(this)
    }).element.appendTo(this.wrapper).bind({
      "mouseover": this.clearViewerHideTimer,
      "mouseout": this.startViewerHideTimer
    });
    return this;
  };

  Annotator.prototype._setupEditor = function() {
    this.editor = new Annotator.Editor();
    this.editor.hide().on('hide', this.onEditorHide).on('save', this.onEditorSubmit).addField({
      type: 'textarea',
      label: _t('Comments') + '\u2026',
      load: function(field, annotation) {
        return $(field).find('textarea').val(annotation.text || '');
      },
      submit: function(field, annotation) {
        return annotation.text = $(field).find('textarea').val();
      }
    });
    this.editor.element.appendTo(this.wrapper);
    return this;
  };

  Annotator.prototype._setupDocumentEvents = function() {
    $(document).bind({
      "mouseup": this.checkForEndSelection,
      "mousedown": this.checkForStartSelection
    });
    return this;
  };

  Annotator.prototype._setupDynamicStyle = function() {
    var max, notclasses, sel, style, x;
    style = $('#annotator-dynamic-style');
    if (!style.length) {
      style = $('<style id="annotator-dynamic-style"></style>').appendTo(document.head);
    }
    notclasses = ['adder', 'outer', 'notice', 'filter'];
    sel = '*' + ((function() {
      var _i, _len, _results;
      _results = [];
      for (_i = 0, _len = notclasses.length; _i < _len; _i++) {
        x = notclasses[_i];
        _results.push(":not(.annotator-" + x + ")");
      }
      return _results;
    })()).join('');
    max = Util.maxZIndex($(document.body).find(sel));
    max = Math.max(max, 1000);
    style.text([".annotator-adder, .annotator-outer, .annotator-notice {", "  z-index: " + (max + 20) + ";", "}", ".annotator-filter {", "  z-index: " + (max + 10) + ";", "}"].join("\n"));
    return this;
  };

  Annotator.prototype.load = function(query) {
    return this.annotations.query(query).then((function(_this) {
      return function(annotations, meta) {
        return _this.loadAnnotations(annotations);
      };
    })(this));
  };

  Annotator.prototype.destroy = function() {
    var idx, plugin, _i, _len, _ref;
    $(document).unbind({
      "mouseup": this.checkForEndSelection,
      "mousedown": this.checkForStartSelection
    });
    $('#annotator-dynamic-style').remove();
    this.adder.remove();
    this.viewer.destroy();
    this.editor.destroy();
    this.wrapper.find('.annotator-hl').each(function() {
      $(this).contents().insertBefore(this);
      return $(this).remove();
    });
    this.wrapper.contents().insertBefore(this.wrapper);
    this.wrapper.remove();
    this.element.data('annotator', null);
    _ref = this.plugins;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      plugin = _ref[_i];
      plugin.destroy();
    }
    this.removeEvents();
    idx = Annotator._instances.indexOf(this);
    if (idx !== -1) {
      return Annotator._instances.splice(idx, 1);
    }
  };

  Annotator.prototype.getSelectedRanges = function() {
    var browserRange, i, normedRange, r, ranges, rangesToIgnore, selection, _i, _len;
    selection = Util.getGlobal().getSelection();
    ranges = [];
    rangesToIgnore = [];
    if (!selection.isCollapsed) {
      ranges = (function() {
        var _i, _ref, _results;
        _results = [];
        for (i = _i = 0, _ref = selection.rangeCount; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
          r = selection.getRangeAt(i);
          browserRange = new Range.BrowserRange(r);
          normedRange = browserRange.normalize().limit(this.wrapper[0]);
          if (normedRange === null) {
            rangesToIgnore.push(r);
          }
          _results.push(normedRange);
        }
        return _results;
      }).call(this);
      selection.removeAllRanges();
    }
    for (_i = 0, _len = rangesToIgnore.length; _i < _len; _i++) {
      r = rangesToIgnore[_i];
      selection.addRange(r);
    }
    return $.grep(ranges, function(range) {
      if (range) {
        selection.addRange(range.toRange());
      }
      return range;
    });
  };

  Annotator.prototype.setupAnnotation = function(annotation) {
    var e, normed, normedRanges, r, root, _i, _j, _len, _len1, _ref;
    root = this.wrapper[0];
    normedRanges = [];
    _ref = annotation.ranges;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      r = _ref[_i];
      try {
        normedRanges.push(Range.sniff(r).normalize(root));
      } catch (_error) {
        e = _error;
        if (e instanceof Range.RangeError) {
          this.publish('rangeNormalizeFail', [annotation, r, e]);
        } else {
          throw e;
        }
      }
    }
    annotation.quote = [];
    annotation.ranges = [];
    annotation._local = {};
    annotation._local.highlights = [];
    for (_j = 0, _len1 = normedRanges.length; _j < _len1; _j++) {
      normed = normedRanges[_j];
      annotation.quote.push($.trim(normed.text()));
      annotation.ranges.push(normed.serialize(this.wrapper[0], '.annotator-hl'));
      $.merge(annotation._local.highlights, this.highlightRange(normed));
    }
    annotation.quote = annotation.quote.join(' / ');
    $(annotation._local.highlights).data('annotation', annotation);
    $(annotation._local.highlights).attr('data-annotation-id', annotation.id);
    return annotation;
  };

  Annotator.prototype.cleanupAnnotation = function(annotation) {
    var h, _i, _len, _ref, _ref1;
    if (((_ref = annotation._local) != null ? _ref.highlights : void 0) != null) {
      _ref1 = annotation._local.highlights;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        h = _ref1[_i];
        if (h.parentNode != null) {
          $(h).replaceWith(h.childNodes);
        }
      }
      delete annotation._local.highlights;
    }
    return annotation;
  };

  Annotator.prototype.loadAnnotations = function(annotations) {
    var clone, loader;
    if (annotations == null) {
      annotations = [];
    }
    loader = (function(_this) {
      return function(annList) {
        var n, now, _i, _len;
        if (annList == null) {
          annList = [];
        }
        now = annList.splice(0, 10);
        for (_i = 0, _len = now.length; _i < _len; _i++) {
          n = now[_i];
          _this.setupAnnotation(n);
        }
        if (annList.length > 0) {
          return setTimeout((function() {
            return loader(annList);
          }), 10);
        } else {
          return _this.publish('annotationsLoaded', [clone]);
        }
      };
    })(this);
    clone = annotations.slice();
    loader(annotations);
    return this;
  };

  Annotator.prototype.dumpAnnotations = function() {
    var _ref;
    if (((_ref = this.store) != null ? _ref.dumpAnnotations : void 0) != null) {
      return this.store.dumpAnnotations();
    } else {
      console.warn(_t("Can't dump annotations without store plugin."));
      return false;
    }
  };

  Annotator.prototype.highlightRange = function(normedRange, cssClass) {
    var hl, node, white, _i, _len, _ref, _results;
    if (cssClass == null) {
      cssClass = 'annotator-hl';
    }
    white = /^\s*$/;
    hl = $("<span class='" + cssClass + "'></span>");
    _ref = normedRange.textNodes();
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      node = _ref[_i];
      if (!white.test(node.nodeValue)) {
        _results.push($(node).wrapAll(hl).parent().show()[0]);
      }
    }
    return _results;
  };

  Annotator.prototype.addPlugin = function(name, options) {
    var klass, plug;
    klass = Annotator.Plugin.fetch(name);
    if (typeof klass === 'function') {
      plug = new klass(this.element[0], options);
      plug.annotator = this;
      if (typeof plug.pluginInit === "function") {
        plug.pluginInit();
      }
      this.plugins[name] = plug;
    } else {
      console.error(_t("Could not load ") + name + _t(" plugin. Have you included the appropriate <script> tag?"));
    }
    return this;
  };

  Annotator.prototype.editAnnotation = function(annotation, position) {
    var dfd, reject, resolve;
    dfd = $.Deferred();
    resolve = dfd.resolve.bind(dfd, annotation);
    reject = dfd.reject.bind(dfd, annotation);
    this.showEditor(annotation, position);
    this.subscribe('annotationEditorSubmit', resolve);
    this.once('annotationEditorHidden', (function(_this) {
      return function() {
        _this.unsubscribe('annotationEditorSubmit', resolve);
        if (dfd.state() === 'pending') {
          return reject();
        }
      };
    })(this));
    return dfd.promise();
  };

  Annotator.prototype.showEditor = function(annotation, location) {
    this.editor.element.css(location);
    this.editor.load(annotation);
    this.publish('annotationEditorShown', [this.editor, annotation]);
    return this;
  };

  Annotator.prototype.onEditorHide = function() {
    this.publish('annotationEditorHidden', [this.editor]);
    return this.ignoreMouseup = false;
  };

  Annotator.prototype.onEditorSubmit = function(annotation) {
    return this.publish('annotationEditorSubmit', [this.editor, annotation]);
  };

  Annotator.prototype.showViewer = function(annotations, location) {
    this.viewer.element.css(location);
    this.viewer.load(annotations);
    return this.publish('annotationViewerShown', [this.viewer, annotations]);
  };

  Annotator.prototype.startViewerHideTimer = function() {
    if (!this.viewerHideTimer) {
      return this.viewerHideTimer = setTimeout(this.viewer.hide, 250);
    }
  };

  Annotator.prototype.clearViewerHideTimer = function() {
    clearTimeout(this.viewerHideTimer);
    return this.viewerHideTimer = false;
  };

  Annotator.prototype.checkForStartSelection = function(event) {
    if (!(event && this.isAnnotator(event.target))) {
      this.startViewerHideTimer();
    }
    return this.mouseIsDown = true;
  };

  Annotator.prototype.checkForEndSelection = function(event) {
    var container, range, _i, _len, _ref;
    this.mouseIsDown = false;
    if (this.ignoreMouseup) {
      return;
    }
    this.selectedRanges = this.getSelectedRanges();
    _ref = this.selectedRanges;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      range = _ref[_i];
      container = range.commonAncestor;
      if ($(container).hasClass('annotator-hl')) {
        container = $(container).parents('[class!=annotator-hl]')[0];
      }
      if (this.isAnnotator(container)) {
        return;
      }
    }
    if (event && this.selectedRanges.length) {
      return this.adder.css(Util.mousePosition(event, this.wrapper[0])).show();
    } else {
      return this.adder.hide();
    }
  };

  Annotator.prototype.isAnnotator = function(element) {
    return !!$(element).parents().addBack().filter('[class^=annotator-]').not(this.wrapper).length;
  };

  Annotator.prototype.onHighlightMouseover = function(event) {
    var annotations;
    this.clearViewerHideTimer();
    if (this.mouseIsDown) {
      return false;
    }
    if (this.viewer.isShown()) {
      this.viewer.hide();
    }
    annotations = $(event.target).parents('.annotator-hl').addBack().map(function() {
      return $(this).data("annotation");
    }).toArray();
    return this.showViewer(annotations, Util.mousePosition(event, this.wrapper[0]));
  };

  Annotator.prototype.onAdderMousedown = function(event) {
    if (event != null) {
      event.preventDefault();
    }
    return this.ignoreMouseup = true;
  };

  Annotator.prototype.onAdderClick = function(event) {
    var annotation, position;
    if (event != null) {
      event.preventDefault();
    }
    position = this.adder.position();
    this.adder.hide();
    annotation = {
      ranges: this.selectedRanges
    };
    return $.when(annotation).done((function(_this) {
      return function(annotation) {
        return _this.publish('beforeAnnotationCreated', [annotation]);
      };
    })(this)).then((function(_this) {
      return function(annotation) {
        return _this.setupAnnotation(annotation);
      };
    })(this)).done(function(annotation) {
      return $(annotation._local.highlights).addClass('annotator-hl-temporary');
    }).then((function(_this) {
      return function(annotation) {
        return _this.editAnnotation(annotation, position);
      };
    })(this)).then((function(_this) {
      return function(annotation) {
        return _this.annotations.create(annotation).fail(handleError);
      };
    })(this)).done(function(annotation) {
      $(annotation._local.highlights).removeClass('annotator-hl-temporary');
      return $(annotation._local.highlights).attr('data-annotation-id', annotation.id);
    }).done((function(_this) {
      return function(annotation) {
        return _this.publish('annotationCreated', [annotation]);
      };
    })(this)).fail(this.cleanupAnnotation);
  };

  Annotator.prototype.onEditAnnotation = function(annotation) {
    var position;
    position = this.viewer.element.position();
    this.viewer.hide();
    return $.when(annotation).done((function(_this) {
      return function(annotation) {
        return _this.publish('beforeAnnotationUpdated', [annotation]);
      };
    })(this)).then((function(_this) {
      return function(annotation) {
        return _this.editAnnotation(annotation, position);
      };
    })(this)).then((function(_this) {
      return function(annotation) {
        return _this.annotations.update(annotation).fail(handleError);
      };
    })(this)).done((function(_this) {
      return function(annotation) {
        return _this.publish('annotationUpdated', [annotation]);
      };
    })(this));
  };

  return Annotator;

})(Delegator);

Annotator.Factory = (function(_super) {
  __extends(Factory, _super);

  function Factory(core) {
    if (core == null) {
      core = Annotator;
    }
    Factory.__super__.constructor.call(this, core);
    this.setStore(NullStore);
  }

  return Factory;

})(Factory);

g = Util.getGlobal();

if (((_ref = g.document) != null ? _ref.evaluate : void 0) == null) {
  $.getScript('http://assets.annotateit.org/vendor/xpath.min.js');
}

if (g.getSelection == null) {
  $.getScript('http://assets.annotateit.org/vendor/ierange.min.js');
}

if (g.JSON == null) {
  $.getScript('http://assets.annotateit.org/vendor/json2.min.js');
}

if (g.Node == null) {
  g.Node = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
  };
}

Annotator.Delegator = Delegator;

Annotator.Range = Range;

Annotator.Util = Util;

Annotator.Widget = Widget;

Annotator.Viewer = Viewer;

Annotator.Editor = Editor;

Annotator.Notification = Notification;

Annotator.Plugin = Plugin;

notification = new Notification();

Annotator.showNotification = notification.show;

Annotator.hideNotification = notification.hide;

Annotator.Plugin.register('NullStore', NullStore);

Annotator._instances = [];

Annotator._t = _t;

Annotator.supported = function() {
  return Util.getGlobal().getSelection != null;
};

Annotator.noConflict = function() {
  Util.getGlobal().Annotator = _Annotator;
  return Annotator;
};

module.exports = Annotator;


},{"./annotations":5,"./delegator":7,"./editor":8,"./factory":9,"./notification":10,"./nullstore":11,"./plugin":12,"./range":13,"./util":14,"./viewer":15,"./widget":16,"backbone-extend-standalone":3}],7:[function(_dereq_,module,exports){
var $, BackboneEvents, Delegator, natives, _isCustomEvent, _parseEvents,
  __slice = [].slice,
  __hasProp = {}.hasOwnProperty;

$ = _dereq_('./util').$;

Delegator = (function() {
  Delegator.prototype.events = {};

  Delegator.prototype.options = {};

  Delegator.prototype.element = null;

  function Delegator(element, options) {
    this.options = $.extend(true, {}, this.options, options);
    this.element = $(element);
    this.addEvents();
  }

  Delegator.prototype.addEvents = function() {
    var event, _i, _len, _ref, _results;
    _ref = _parseEvents(this.events);
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      event = _ref[_i];
      _results.push(this._addEvent(event.selector, event.event, event.functionName));
    }
    return _results;
  };

  Delegator.prototype.removeEvents = function() {
    var event, _i, _len, _ref, _results;
    _ref = _parseEvents(this.events);
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      event = _ref[_i];
      _results.push(this._removeEvent(event.selector, event.event, event.functionName));
    }
    return _results;
  };

  Delegator.prototype._addEvent = function(selector, event, functionName) {
    var closure;
    closure = (function(_this) {
      return function() {
        return _this[functionName].apply(_this, arguments);
      };
    })(this);
    if (selector === '' && _isCustomEvent(event)) {
      this.subscribe(event, closure);
    } else {
      this.element.delegate(selector, event, closure);
    }
    if (this._closures == null) {
      this._closures = {};
    }
    this._closures["" + selector + "/" + event + "/" + functionName] = closure;
    return this;
  };

  Delegator.prototype._removeEvent = function(selector, event, functionName) {
    var closure;
    closure = this._closures["" + selector + "/" + event + "/" + functionName];
    if (selector === '' && _isCustomEvent(event)) {
      this.unsubscribe(event, closure);
    } else {
      this.element.undelegate(selector, event, closure);
    }
    delete this._closures["" + selector + "/" + event + "/" + functionName];
    return this;
  };

  Delegator.prototype.publish = function(name, args) {
    if (args == null) {
      args = [];
    }
    return this.trigger.apply(this, [name].concat(__slice.call(args)));
  };

  Delegator.prototype.subscribe = function(event, callback, context) {
    if (context == null) {
      context = this;
    }
    return this.on(event, callback, context);
  };

  Delegator.prototype.unsubscribe = function(event, callback, context) {
    if (context == null) {
      context = this;
    }
    return this.off(event, callback, context);
  };

  return Delegator;

})();

_parseEvents = function(eventsObj) {
  var event, events, functionName, sel, selector, _i, _ref;
  events = [];
  for (sel in eventsObj) {
    functionName = eventsObj[sel];
    _ref = sel.split(' '), selector = 2 <= _ref.length ? __slice.call(_ref, 0, _i = _ref.length - 1) : (_i = 0, []), event = _ref[_i++];
    events.push({
      selector: selector.join(' '),
      event: event,
      functionName: functionName
    });
  }
  return events;
};

natives = (function() {
  var key, specials, val;
  specials = (function() {
    var _ref, _results;
    _ref = $.event.special;
    _results = [];
    for (key in _ref) {
      if (!__hasProp.call(_ref, key)) continue;
      val = _ref[key];
      _results.push(key);
    }
    return _results;
  })();
  return "blur focus focusin focusout load resize scroll unload click dblclick\nmousedown mouseup mousemove mouseover mouseout mouseenter mouseleave\nchange select submit keydown keypress keyup error".split(/[^a-z]+/).concat(specials);
})();

_isCustomEvent = function(event) {
  event = event.split('.')[0];
  return $.inArray(event, natives) === -1;
};

BackboneEvents = _dereq_('backbone-events-standalone');

BackboneEvents.mixin(Delegator.prototype);

module.exports = Delegator;


},{"./util":14,"backbone-events-standalone":2}],8:[function(_dereq_,module,exports){
var $, Editor, Util, Widget, _t,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Util = _dereq_('./util');

Widget = _dereq_('./widget');

$ = Util.$;

_t = Util.TranslationString;

Editor = (function(_super) {
  __extends(Editor, _super);

  Editor.prototype.events = {
    "form submit": "submit",
    ".annotator-save click": "submit",
    ".annotator-cancel click": "hide",
    ".annotator-cancel mouseover": "onCancelButtonMouseover",
    "textarea keydown": "processKeypress"
  };

  Editor.prototype.classes = {
    hide: 'annotator-hide',
    focus: 'annotator-focus'
  };

  Editor.prototype.html = "<div class=\"annotator-outer annotator-editor\">\n  <form class=\"annotator-widget\">\n    <ul class=\"annotator-listing\"></ul>\n    <div class=\"annotator-controls\">\n      <a href=\"#cancel\" class=\"annotator-cancel\">" + (_t('Cancel')) + "</a>\n      <a href=\"#save\"\n         class=\"annotator-save annotator-focus\">" + (_t('Save')) + "</a>\n    </div>\n  </form>\n</div>";

  Editor.prototype.options = {};

  function Editor(options) {
    this.onCancelButtonMouseover = __bind(this.onCancelButtonMouseover, this);
    this.processKeypress = __bind(this.processKeypress, this);
    this.submit = __bind(this.submit, this);
    this.load = __bind(this.load, this);
    this.hide = __bind(this.hide, this);
    this.show = __bind(this.show, this);
    Editor.__super__.constructor.call(this, $(this.html)[0], options);
    this.fields = [];
    this.annotation = {};
  }

  Editor.prototype.show = function(event) {
    Util.preventEventDefault(event);
    this.element.removeClass(this.classes.hide);
    this.element.find('.annotator-save').addClass(this.classes.focus);
    this.checkOrientation();
    this.element.find(":input:first").focus();
    this.setupDraggables();
    return this.publish('show');
  };

  Editor.prototype.hide = function(event) {
    Util.preventEventDefault(event);
    this.element.addClass(this.classes.hide);
    return this.publish('hide');
  };

  Editor.prototype.load = function(annotation) {
    var field, _i, _len, _ref;
    this.annotation = annotation;
    this.publish('load', [this.annotation]);
    _ref = this.fields;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      field = _ref[_i];
      field.load(field.element, this.annotation);
    }
    return this.show();
  };

  Editor.prototype.submit = function(event) {
    var field, _i, _len, _ref;
    Util.preventEventDefault(event);
    _ref = this.fields;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      field = _ref[_i];
      field.submit(field.element, this.annotation);
    }
    this.publish('save', [this.annotation]);
    return this.hide();
  };

  Editor.prototype.addField = function(options) {
    var element, field, input;
    field = $.extend({
      id: 'annotator-field-' + Util.uuid(),
      type: 'input',
      label: '',
      load: function() {},
      submit: function() {}
    }, options);
    input = null;
    element = $('<li class="annotator-item" />');
    field.element = element[0];
    switch (field.type) {
      case 'textarea':
        input = $('<textarea />');
        break;
      case 'input':
      case 'checkbox':
        input = $('<input />');
        break;
      case 'select':
        input = $('<select />');
    }
    element.append(input);
    input.attr({
      id: field.id,
      placeholder: field.label
    });
    if (field.type === 'checkbox') {
      input[0].type = 'checkbox';
      element.addClass('annotator-checkbox');
      element.append($('<label />', {
        "for": field.id,
        html: field.label
      }));
    }
    this.element.find('ul:first').append(element);
    this.fields.push(field);
    return field.element;
  };

  Editor.prototype.checkOrientation = function() {
    var controls, list;
    Editor.__super__.checkOrientation.apply(this, arguments);
    list = this.element.find('ul');
    controls = this.element.find('.annotator-controls');
    if (this.element.hasClass(this.classes.invert.y)) {
      controls.insertBefore(list);
    } else if (controls.is(':first-child')) {
      controls.insertAfter(list);
    }
    return this;
  };

  Editor.prototype.processKeypress = function(event) {
    if (event.keyCode === 27) {
      return this.hide();
    } else if (event.keyCode === 13 && !event.shiftKey) {
      return this.submit();
    }
  };

  Editor.prototype.onCancelButtonMouseover = function() {
    return this.element.find('.' + this.classes.focus).removeClass(this.classes.focus);
  };

  Editor.prototype.setupDraggables = function() {
    var classes, controls, cornerItem, editor, mousedown, onMousedown, onMousemove, onMouseup, resize, textarea, throttle;
    this.element.find('.annotator-resize').remove();
    if (this.element.hasClass(this.classes.invert.y)) {
      cornerItem = this.element.find('.annotator-item:last');
    } else {
      cornerItem = this.element.find('.annotator-item:first');
    }
    if (cornerItem) {
      $('<span class="annotator-resize"></span>').appendTo(cornerItem);
    }
    mousedown = null;
    classes = this.classes;
    editor = this.element;
    textarea = null;
    resize = editor.find('.annotator-resize');
    controls = editor.find('.annotator-controls');
    throttle = false;
    onMousedown = function(event) {
      if (event.target === this) {
        mousedown = {
          element: this,
          top: event.pageY,
          left: event.pageX
        };
        textarea = editor.find('textarea:first');
        $(window).bind({
          'mouseup.annotator-editor-resize': onMouseup,
          'mousemove.annotator-editor-resize': onMousemove
        });
        return event.preventDefault();
      }
    };
    onMouseup = function() {
      mousedown = null;
      return $(window).unbind('.annotator-editor-resize');
    };
    onMousemove = function(event) {
      var diff, directionX, directionY, height, width;
      if (mousedown && throttle === false) {
        diff = {
          top: event.pageY - mousedown.top,
          left: event.pageX - mousedown.left
        };
        if (mousedown.element === resize[0]) {
          height = textarea.outerHeight();
          width = textarea.outerWidth();
          directionX = editor.hasClass(classes.invert.x) ? -1 : 1;
          directionY = editor.hasClass(classes.invert.y) ? 1 : -1;
          textarea.height(height + (diff.top * directionY));
          textarea.width(width + (diff.left * directionX));
          if (textarea.outerHeight() !== height) {
            mousedown.top = event.pageY;
          }
          if (textarea.outerWidth() !== width) {
            mousedown.left = event.pageX;
          }
        } else if (mousedown.element === controls[0]) {
          editor.css({
            top: parseInt(editor.css('top'), 10) + diff.top,
            left: parseInt(editor.css('left'), 10) + diff.left
          });
          mousedown.top = event.pageY;
          mousedown.left = event.pageX;
        }
        throttle = true;
        return setTimeout((function() {
          return throttle = false;
        }), 1000 / 60);
      }
    };
    resize.bind('mousedown', onMousedown);
    return controls.bind('mousedown', onMousedown);
  };

  return Editor;

})(Widget);

module.exports = Editor;


},{"./util":14,"./widget":16}],9:[function(_dereq_,module,exports){
var Factory, extend,
  __slice = [].slice;

extend = _dereq_('backbone-extend-standalone');

Factory = (function() {
  function Factory(core) {
    this.ctors = {};
    this.ctors.core = core;
    this.args = {};
    this.pluginCtors = [];
    this.pluginArgs = [];
  }

  Factory.prototype.extend = function(properties, classProperties) {
    this.ctors.core = extend.call(this.ctors.core, properties, classProperties);
    return this;
  };

  Factory.prototype.getInstance = function() {
    var obj;
    obj = new this.ctors.core;
    this.configureInstance(obj);
    return obj;
  };

  Factory.prototype.configureInstance = function(obj) {
    var i, p, plug, plugins, store, _i, _j, _len, _ref;
    plugins = [];
    if (this.ctors.store != null) {
      store = (function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(this.ctors.store, this.args.store, function(){});
    }
    for (i = _i = 0, _ref = this.pluginCtors.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
      plug = (function(func, args, ctor) {
        ctor.prototype = func.prototype;
        var child = new ctor, result = func.apply(child, args);
        return Object(result) === result ? result : child;
      })(this.pluginCtors[i], this.pluginArgs[i], function(){});
      plugins.push(plug);
    }
    if (obj.configure != null) {
      obj.configure({
        store: store != null ? store : null,
        plugins: plugins
      });
    }
    if ((store != null ? store.configure : void 0) != null) {
      store.configure({
        core: obj
      });
    }
    for (_j = 0, _len = plugins.length; _j < _len; _j++) {
      p = plugins[_j];
      if (p.configure != null) {
        p.configure({
          core: obj
        });
      }
    }
    return obj;
  };

  Factory.prototype.setStore = function() {
    var args, store;
    store = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    this.ctors.store = store;
    this.args.store = args;
    return this;
  };

  Factory.prototype.addPlugin = function() {
    var args, plugin;
    plugin = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    this.pluginCtors.push(plugin);
    this.pluginArgs.push(args);
    return this;
  };

  return Factory;

})();

module.exports = Factory;


},{"backbone-extend-standalone":3}],10:[function(_dereq_,module,exports){
var $, Delegator, Notification, Util,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Delegator = _dereq_('./delegator');

Util = _dereq_('./util');

$ = Util.$;

Notification = (function(_super) {
  __extends(Notification, _super);

  Notification.prototype.events = {
    "click": "hide"
  };

  Notification.prototype.options = {
    html: "<div class='annotator-notice'></div>",
    classes: {
      show: "annotator-notice-show",
      info: "annotator-notice-info",
      success: "annotator-notice-success",
      error: "annotator-notice-error"
    }
  };

  function Notification(options) {
    this.hide = __bind(this.hide, this);
    this.show = __bind(this.show, this);
    Notification.__super__.constructor.call(this, $(this.options.html)[0], options);
  }

  Notification.prototype.show = function(message, status) {
    if (status == null) {
      status = Notification.INFO;
    }
    this.currentStatus = status;
    this._appendElement();
    $(this.element).addClass(this.options.classes.show).addClass(this.options.classes[this.currentStatus]).html(Util.escape(message || ""));
    setTimeout(this.hide, 5000);
    return this;
  };

  Notification.prototype.hide = function() {
    if (this.currentStatus == null) {
      this.currentStatus = Annotator.Notification.INFO;
    }
    $(this.element).removeClass(this.options.classes.show).removeClass(this.options.classes[this.currentStatus]);
    return this;
  };

  Notification.prototype._appendElement = function() {
    if (this.element.parentNode == null) {
      return $(this.element).appendTo(document.body);
    }
  };

  return Notification;

})(Delegator);

Notification.INFO = 'info';

Notification.SUCCESS = 'success';

Notification.ERROR = 'error';

module.exports = Notification;


},{"./delegator":7,"./util":14}],11:[function(_dereq_,module,exports){
var $, NullStore, id;

$ = _dereq_('./util').$;

id = (function() {
  var counter;
  counter = -1;
  return function() {
    return counter += 1;
  };
})();

NullStore = (function() {
  function NullStore() {}

  NullStore.prototype.create = function(annotation) {
    var dfd;
    dfd = $.Deferred();
    if (annotation.id == null) {
      annotation.id = id();
    }
    dfd.resolve(annotation);
    return dfd.promise();
  };

  NullStore.prototype.update = function(annotation) {
    var dfd;
    dfd = $.Deferred();
    dfd.resolve(annotation);
    return dfd.promise();
  };

  NullStore.prototype["delete"] = function(annotation) {
    var dfd;
    dfd = $.Deferred();
    dfd.resolve(annotation);
    return dfd.promise();
  };

  NullStore.prototype.query = function(queryObj) {
    var dfd;
    dfd = $.Deferred();
    dfd.resolve([], {});
    return dfd.promise();
  };

  return NullStore;

})();

module.exports = NullStore;


},{"./util":14}],12:[function(_dereq_,module,exports){
var Delegator, Plugin, Util,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Delegator = _dereq_("./delegator");

Util = _dereq_("./util");

Plugin = (function(_super) {
  __extends(Plugin, _super);

  function Plugin() {
    var name;
    if (this.constructor.name != null) {
      name = this.constructor.name;
    } else {
      name = "This";
    }
    Util.deprecationWarning("" + name + " plugin inherits from Annotator.Plugin: doing so is deprecated. If you need Delegator functionality, please extend Annotator.Delegator directly.");
    Plugin.__super__.constructor.apply(this, arguments);
  }

  Plugin.prototype.pluginInit = function() {};

  Plugin.prototype.destroy = function() {
    return this.removeEvents();
  };

  return Plugin;

})(Delegator);

Plugin._ctors = {};

Plugin.register = function(name, ctor) {
  Plugin._ctors[name] = ctor;
  return Object.defineProperty(Plugin, name, {
    configurable: true,
    get: function() {
      Util.deprecationWarning("Direct access to plugin constructors through the Annotator.Plugin namespace is deprecated. Please use Annotator.Plugin.fetch('" + name + "')!");
      return Plugin._ctors[name];
    }
  });
};

Plugin.fetch = function(name) {
  return Plugin._ctors[name];
};

Plugin._rebindOldPlugins = function() {
  var ignore, k, v, _results;
  ignore = ['__super__', '_ctors', '_rebindOldPlugins', 'register', 'fetch'];
  _results = [];
  for (k in Plugin) {
    if (!__hasProp.call(Plugin, k)) continue;
    v = Plugin[k];
    if (!(__indexOf.call(ignore, k) < 0)) {
      continue;
    }
    Util.deprecationWarning("Direct assignment of plugin constructors to the Annotator.Plugin namespace is deprecated. Please use Annotator.Plugin.register('" + k + "', " + k + ") instead! Automatically re-registering plugin...");
    delete Plugin._ctors[k];
    _results.push(Plugin.register(k, v));
  }
  return _results;
};

module.exports = Plugin;


},{"./delegator":7,"./util":14}],13:[function(_dereq_,module,exports){
var $, Range, Util, xpath,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

xpath = _dereq_('./xpath');

Util = _dereq_('./util');

$ = Util.$;

Range = {};

Range.sniff = function(r) {
  if (r.commonAncestorContainer != null) {
    return new Range.BrowserRange(r);
  } else if (typeof r.start === "string") {
    return new Range.SerializedRange(r);
  } else if (r.start && typeof r.start === "object") {
    return new Range.NormalizedRange(r);
  } else {
    console.error(_t("Could not sniff range type"));
    return false;
  }
};

Range.RangeError = (function(_super) {
  __extends(RangeError, _super);

  function RangeError(type, message, parent) {
    this.type = type;
    this.message = message;
    this.parent = parent != null ? parent : null;
    RangeError.__super__.constructor.call(this, this.message);
  }

  return RangeError;

})(Error);

Range.BrowserRange = (function() {
  function BrowserRange(obj) {
    this.commonAncestorContainer = obj.commonAncestorContainer;
    this.startContainer = obj.startContainer;
    this.startOffset = obj.startOffset;
    this.endContainer = obj.endContainer;
    this.endOffset = obj.endOffset;
  }

  BrowserRange.prototype.normalize = function(root) {
    var n, node, nr, r;
    if (this.tainted) {
      console.error(_t("You may only call normalize() once on a BrowserRange!"));
      return false;
    } else {
      this.tainted = true;
    }
    r = {};
    if (this.startContainer.nodeType === Node.ELEMENT_NODE) {
      r.start = Util.getFirstTextNodeNotBefore(this.startContainer.childNodes[this.startOffset]);
      r.startOffset = 0;
    } else {
      r.start = this.startContainer;
      r.startOffset = this.startOffset;
    }
    if (this.endContainer.nodeType === Node.ELEMENT_NODE) {
      node = this.endContainer.childNodes[this.endOffset];
      if (node != null) {
        n = node;
        while ((n != null) && (n.nodeType !== Node.TEXT_NODE)) {
          n = n.firstChild;
        }
        if (n != null) {
          r.end = n;
          r.endOffset = 0;
        }
      }
      if (r.end == null) {
        if (this.endOffset) {
          node = this.endContainer.childNodes[this.endOffset - 1];
        } else {
          node = this.endContainer.previousSibling;
        }
        r.end = Util.getLastTextNodeUpTo(node);
        r.endOffset = r.end.nodeValue.length;
      }
    } else {
      r.end = this.endContainer;
      r.endOffset = this.endOffset;
    }
    nr = {};
    if (r.startOffset > 0) {
      if (r.start.nodeValue.length > r.startOffset) {
        nr.start = r.start.splitText(r.startOffset);
      } else {
        nr.start = r.start.nextSibling;
      }
    } else {
      nr.start = r.start;
    }
    if (r.start === r.end) {
      if (nr.start.nodeValue.length > (r.endOffset - r.startOffset)) {
        nr.start.splitText(r.endOffset - r.startOffset);
      }
      nr.end = nr.start;
    } else {
      if (r.end.nodeValue.length > r.endOffset) {
        r.end.splitText(r.endOffset);
      }
      nr.end = r.end;
    }
    nr.commonAncestor = this.commonAncestorContainer;
    while (nr.commonAncestor.nodeType !== Node.ELEMENT_NODE) {
      nr.commonAncestor = nr.commonAncestor.parentNode;
    }
    return new Range.NormalizedRange(nr);
  };

  BrowserRange.prototype.serialize = function(root, ignoreSelector) {
    return this.normalize(root).serialize(root, ignoreSelector);
  };

  return BrowserRange;

})();

Range.NormalizedRange = (function() {
  function NormalizedRange(obj) {
    this.commonAncestor = obj.commonAncestor;
    this.start = obj.start;
    this.end = obj.end;
  }

  NormalizedRange.prototype.normalize = function(root) {
    return this;
  };

  NormalizedRange.prototype.limit = function(bounds) {
    var nodes, parent, startParents, _i, _len, _ref;
    nodes = $.grep(this.textNodes(), function(node) {
      return node.parentNode === bounds || $.contains(bounds, node.parentNode);
    });
    if (!nodes.length) {
      return null;
    }
    this.start = nodes[0];
    this.end = nodes[nodes.length - 1];
    startParents = $(this.start).parents();
    _ref = $(this.end).parents();
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      parent = _ref[_i];
      if (startParents.index(parent) !== -1) {
        this.commonAncestor = parent;
        break;
      }
    }
    return this;
  };

  NormalizedRange.prototype.serialize = function(root, ignoreSelector) {
    var end, serialization, start;
    serialization = function(node, isEnd) {
      var n, nodes, offset, origParent, path, textNodes, _i, _len;
      if (ignoreSelector) {
        origParent = $(node).parents(":not(" + ignoreSelector + ")").eq(0);
      } else {
        origParent = $(node).parent();
      }
      path = xpath.fromNode(origParent, root)[0];
      textNodes = Util.getTextNodes(origParent);
      nodes = textNodes.slice(0, textNodes.index(node));
      offset = 0;
      for (_i = 0, _len = nodes.length; _i < _len; _i++) {
        n = nodes[_i];
        offset += n.nodeValue.length;
      }
      if (isEnd) {
        return [path, offset + node.nodeValue.length];
      } else {
        return [path, offset];
      }
    };
    start = serialization(this.start);
    end = serialization(this.end, true);
    return new Range.SerializedRange({
      start: start[0],
      end: end[0],
      startOffset: start[1],
      endOffset: end[1]
    });
  };

  NormalizedRange.prototype.text = function() {
    var node;
    return ((function() {
      var _i, _len, _ref, _results;
      _ref = this.textNodes();
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        node = _ref[_i];
        _results.push(node.nodeValue);
      }
      return _results;
    }).call(this)).join('');
  };

  NormalizedRange.prototype.textNodes = function() {
    var end, start, textNodes, _ref;
    textNodes = Util.getTextNodes($(this.commonAncestor));
    _ref = [textNodes.index(this.start), textNodes.index(this.end)], start = _ref[0], end = _ref[1];
    return $.makeArray(textNodes.slice(start, +end + 1 || 9e9));
  };

  NormalizedRange.prototype.toRange = function() {
    var range;
    range = document.createRange();
    range.setStartBefore(this.start);
    range.setEndAfter(this.end);
    return range;
  };

  return NormalizedRange;

})();

Range.SerializedRange = (function() {
  function SerializedRange(obj) {
    this.start = obj.start;
    this.startOffset = obj.startOffset;
    this.end = obj.end;
    this.endOffset = obj.endOffset;
  }

  SerializedRange.prototype.normalize = function(root) {
    var contains, e, length, node, p, range, targetOffset, tn, _i, _j, _len, _len1, _ref, _ref1;
    range = {};
    _ref = ['start', 'end'];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      p = _ref[_i];
      try {
        node = xpath.toNode(this[p], root);
      } catch (_error) {
        e = _error;
        throw new Range.RangeError(p, ("Error while finding " + p + " node: " + this[p] + ": ") + e, e);
      }
      if (!node) {
        throw new Range.RangeError(p, "Couldn't find " + p + " node: " + this[p]);
      }
      length = 0;
      targetOffset = this[p + 'Offset'];
      if (p === 'end') {
        targetOffset -= 1;
      }
      _ref1 = Util.getTextNodes($(node));
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        tn = _ref1[_j];
        if (length + tn.nodeValue.length > targetOffset) {
          range[p + 'Container'] = tn;
          range[p + 'Offset'] = this[p + 'Offset'] - length;
          break;
        } else {
          length += tn.nodeValue.length;
        }
      }
      if (range[p + 'Offset'] == null) {
        throw new Range.RangeError("" + p + "offset", "Couldn't find offset " + this[p + 'Offset'] + " in element " + this[p]);
      }
    }
    contains = document.compareDocumentPosition == null ? function(a, b) {
      return a.contains(b);
    } : function(a, b) {
      return a.compareDocumentPosition(b) & 16;
    };
    $(range.startContainer).parents().each(function() {
      if (contains(this, range.endContainer)) {
        range.commonAncestorContainer = this;
        return false;
      }
    });
    return new Range.BrowserRange(range).normalize(root);
  };

  SerializedRange.prototype.serialize = function(root, ignoreSelector) {
    return this.normalize(root).serialize(root, ignoreSelector);
  };

  SerializedRange.prototype.toObject = function() {
    return {
      start: this.start,
      startOffset: this.startOffset,
      end: this.end,
      endOffset: this.endOffset
    };
  };

  return SerializedRange;

})();

module.exports = Range;


},{"./util":14,"./xpath":17}],14:[function(_dereq_,module,exports){
var $, Util, gettext, _gettext, _t,
  __slice = [].slice;

$ = _dereq_('jquery');

gettext = null;

if (typeof Gettext !== "undefined" && Gettext !== null) {
  _gettext = new Gettext({
    domain: "annotator"
  });
  gettext = function(msgid) {
    return _gettext.gettext(msgid);
  };
} else {
  gettext = function(msgid) {
    return msgid;
  };
}

_t = function(msgid) {
  return gettext(msgid);
};

if (!(JSON && JSON.parse && JSON.stringify)) {
  console.error(_t("Annotator requires a JSON implementation: have you included lib/vendor/json2.js?"));
}

Util = {};

Util.$ = $;

Util.TranslationString = _t;

Util.deprecationWarning = function() {
  var args;
  args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
  return console.warn.apply(console, ["Annotator DeprecationWarning:"].concat(__slice.call(args)));
};

Util.flatten = function(array) {
  var flatten;
  flatten = function(ary) {
    var el, flat, _i, _len;
    flat = [];
    for (_i = 0, _len = ary.length; _i < _len; _i++) {
      el = ary[_i];
      flat = flat.concat(el && $.isArray(el) ? flatten(el) : el);
    }
    return flat;
  };
  return flatten(array);
};

Util.contains = function(parent, child) {
  var node;
  node = child;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

Util.getTextNodes = function(jq) {
  var getTextNodes;
  getTextNodes = function(node) {
    var nodes;
    if (node && node.nodeType !== Node.TEXT_NODE) {
      nodes = [];
      if (node.nodeType !== Node.COMMENT_NODE) {
        node = node.lastChild;
        while (node) {
          nodes.push(getTextNodes(node));
          node = node.previousSibling;
        }
      }
      return nodes.reverse();
    } else {
      return node;
    }
  };
  return jq.map(function() {
    return Util.flatten(getTextNodes(this));
  });
};

Util.getLastTextNodeUpTo = function(n) {
  var result;
  switch (n.nodeType) {
    case Node.TEXT_NODE:
      return n;
    case Node.ELEMENT_NODE:
      if (n.lastChild != null) {
        result = Util.getLastTextNodeUpTo(n.lastChild);
        if (result != null) {
          return result;
        }
      }
      break;
  }
  n = n.previousSibling;
  if (n != null) {
    return Util.getLastTextNodeUpTo(n);
  } else {
    return null;
  }
};

Util.getFirstTextNodeNotBefore = function(n) {
  var result;
  switch (n.nodeType) {
    case Node.TEXT_NODE:
      return n;
    case Node.ELEMENT_NODE:
      if (n.firstChild != null) {
        result = Util.getFirstTextNodeNotBefore(n.firstChild);
        if (result != null) {
          return result;
        }
      }
      break;
  }
  n = n.nextSibling;
  if (n != null) {
    return Util.getFirstTextNodeNotBefore(n);
  } else {
    return null;
  }
};

Util.readRangeViaSelection = function(range) {
  var sel;
  sel = Util.getGlobal().getSelection();
  sel.removeAllRanges();
  sel.addRange(range.toRange());
  return sel.toString();
};

Util.escape = function(html) {
  return html.replace(/&(?!\w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};

Util.uuid = (function() {
  var counter;
  counter = -1;
  return function() {
    return counter += 1;
  };
})();

Util.getGlobal = function() {
  return (function() {
    return this;
  })();
};

Util.maxZIndex = function($elements) {
  var all, el;
  all = (function() {
    var _i, _len, _results;
    _results = [];
    for (_i = 0, _len = $elements.length; _i < _len; _i++) {
      el = $elements[_i];
      if ($(el).css('position') === 'static') {
        _results.push(-1);
      } else {
        _results.push(parseInt($(el).css('z-index'), 10) || -1);
      }
    }
    return _results;
  })();
  return Math.max.apply(Math, all);
};

Util.mousePosition = function(e, offsetEl) {
  var offset, _ref;
  if ((_ref = $(offsetEl).css('position')) !== 'absolute' && _ref !== 'fixed' && _ref !== 'relative') {
    offsetEl = $(offsetEl).offsetParent()[0];
  }
  offset = $(offsetEl).offset();
  return {
    top: e.pageY - offset.top,
    left: e.pageX - offset.left
  };
};

Util.preventEventDefault = function(event) {
  return event != null ? typeof event.preventDefault === "function" ? event.preventDefault() : void 0 : void 0;
};

module.exports = Util;


},{"jquery":4}],15:[function(_dereq_,module,exports){
var $, LinkParser, Util, Viewer, Widget, _t,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Util = _dereq_('./util');

Widget = _dereq_('./widget');

$ = Util.$;

_t = Util.TranslationString;

Viewer = (function(_super) {
  __extends(Viewer, _super);

  Viewer.prototype.events = {
    ".annotator-edit click": "onEditClick",
    ".annotator-delete click": "onDeleteClick"
  };

  Viewer.prototype.classes = {
    hide: 'annotator-hide',
    showControls: 'annotator-visible'
  };

  Viewer.prototype.html = {
    element: "<div class=\"annotator-outer annotator-viewer\">\n  <ul class=\"annotator-widget annotator-listing\"></ul>\n</div>",
    item: "<li class=\"annotator-annotation annotator-item\">\n  <span class=\"annotator-controls\">\n    <a href=\"#\"\n       title=\"View as webpage\"\n       class=\"annotator-link\">View as webpage</a>\n    <button type=\"button\"\n            title=\"Edit\"\n            class=\"annotator-edit\">Edit</button>\n    <button type=\"button\"\n            title=\"Delete\"\n            class=\"annotator-delete\">Delete</button>\n  </span>\n</li>"
  };

  Viewer.prototype.options = {
    readOnly: false
  };

  function Viewer(options) {
    this.onDeleteClick = __bind(this.onDeleteClick, this);
    this.onEditClick = __bind(this.onEditClick, this);
    this.load = __bind(this.load, this);
    this.hide = __bind(this.hide, this);
    this.show = __bind(this.show, this);
    Viewer.__super__.constructor.call(this, $(this.html.element)[0], options);
    this.item = $(this.html.item)[0];
    this.fields = [];
    this.annotations = [];
  }

  Viewer.prototype.show = function(event) {
    var controls;
    Util.preventEventDefault(event);
    controls = this.element.find('.annotator-controls').addClass(this.classes.showControls);
    setTimeout(((function(_this) {
      return function() {
        return controls.removeClass(_this.classes.showControls);
      };
    })(this)), 500);
    this.element.removeClass(this.classes.hide);
    return this.checkOrientation().publish('show');
  };

  Viewer.prototype.isShown = function() {
    return !this.element.hasClass(this.classes.hide);
  };

  Viewer.prototype.hide = function(event) {
    Util.preventEventDefault(event);
    this.element.addClass(this.classes.hide);
    return this.publish('hide');
  };

  Viewer.prototype.load = function(annotations) {
    var annotation, controller, controls, del, edit, element, field, item, link, links, list, _i, _j, _len, _len1, _ref, _ref1;
    this.annotations = annotations || [];
    list = this.element.find('ul:first').empty();
    _ref = this.annotations;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      annotation = _ref[_i];
      item = $(this.item).clone().appendTo(list).data('annotation', annotation);
      controls = item.find('.annotator-controls');
      link = controls.find('.annotator-link');
      edit = controls.find('.annotator-edit');
      del = controls.find('.annotator-delete');
      links = new LinkParser(annotation.links || []).get('alternate', {
        'type': 'text/html'
      });
      if (links.length === 0 || (links[0].href == null)) {
        link.remove();
      } else {
        link.attr('href', links[0].href);
      }
      if (this.options.readOnly) {
        edit.remove();
        del.remove();
      } else {
        controller = {
          showEdit: function() {
            return edit.removeAttr('disabled');
          },
          hideEdit: function() {
            return edit.attr('disabled', 'disabled');
          },
          showDelete: function() {
            return del.removeAttr('disabled');
          },
          hideDelete: function() {
            return del.attr('disabled', 'disabled');
          }
        };
      }
      _ref1 = this.fields;
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        field = _ref1[_j];
        element = $(field.element).clone().appendTo(item)[0];
        field.load(element, annotation, controller);
      }
    }
    this.publish('load', [this.annotations]);
    return this.show();
  };

  Viewer.prototype.addField = function(options) {
    var field;
    field = $.extend({
      load: function() {}
    }, options);
    field.element = $('<div />')[0];
    this.fields.push(field);
    field.element;
    return this;
  };

  Viewer.prototype.onEditClick = function(event) {
    return this.onButtonClick(event, 'edit');
  };

  Viewer.prototype.onDeleteClick = function(event) {
    return this.onButtonClick(event, 'delete');
  };

  Viewer.prototype.onButtonClick = function(event, type) {
    var item;
    item = $(event.target).parents('.annotator-annotation');
    return this.publish(type, [item.data('annotation')]);
  };

  return Viewer;

})(Widget);

LinkParser = (function() {
  function LinkParser(data) {
    this.data = data;
  }

  LinkParser.prototype.get = function(rel, cond) {
    var d, k, keys, match, v, _i, _len, _ref, _results;
    if (cond == null) {
      cond = {};
    }
    cond = $.extend({}, cond, {
      rel: rel
    });
    keys = (function() {
      var _results;
      _results = [];
      for (k in cond) {
        if (!__hasProp.call(cond, k)) continue;
        v = cond[k];
        _results.push(k);
      }
      return _results;
    })();
    _ref = this.data;
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      d = _ref[_i];
      match = keys.reduce((function(m, k) {
        return m && (d[k] === cond[k]);
      }), true);
      if (match) {
        _results.push(d);
      } else {
        continue;
      }
    }
    return _results;
  };

  return LinkParser;

})();

module.exports = Viewer;


},{"./util":14,"./widget":16}],16:[function(_dereq_,module,exports){
var $, Delegator, Util, Widget,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Delegator = _dereq_('./delegator');

Util = _dereq_('./util');

$ = Util.$;

Widget = (function(_super) {
  __extends(Widget, _super);

  Widget.prototype.classes = {
    hide: 'annotator-hide',
    invert: {
      x: 'annotator-invert-x',
      y: 'annotator-invert-y'
    }
  };

  function Widget(element, options) {
    Widget.__super__.constructor.apply(this, arguments);
    this.classes = $.extend({}, Widget.prototype.classes, this.classes);
  }

  Widget.prototype.destroy = function() {
    this.removeEvents();
    return this.element.remove();
  };

  Widget.prototype.checkOrientation = function() {
    var current, offset, viewport, widget, window;
    this.resetOrientation();
    window = $(Util.getGlobal());
    widget = this.element.children(":first");
    offset = widget.offset();
    viewport = {
      top: window.scrollTop(),
      right: window.width() + window.scrollLeft()
    };
    current = {
      top: offset.top,
      right: offset.left + widget.width()
    };
    if ((current.top - viewport.top) < 0) {
      this.invertY();
    }
    if ((current.right - viewport.right) > 0) {
      this.invertX();
    }
    return this;
  };

  Widget.prototype.resetOrientation = function() {
    this.element.removeClass(this.classes.invert.x).removeClass(this.classes.invert.y);
    return this;
  };

  Widget.prototype.invertX = function() {
    this.element.addClass(this.classes.invert.x);
    return this;
  };

  Widget.prototype.invertY = function() {
    this.element.addClass(this.classes.invert.y);
    return this;
  };

  Widget.prototype.isInvertedY = function() {
    return this.element.hasClass(this.classes.invert.y);
  };

  Widget.prototype.isInvertedX = function() {
    return this.element.hasClass(this.classes.invert.x);
  };

  return Widget;

})(Delegator);

module.exports = Widget;


},{"./delegator":7,"./util":14}],17:[function(_dereq_,module,exports){
var $, findChild, fromNode, getNodeName, getNodePosition, simpleXPathJQuery, simpleXPathPure, toNode;

$ = _dereq_('./util').$;

simpleXPathJQuery = function($el, relativeRoot) {
  var jq;
  jq = $el.map(function() {
    var elem, idx, path, tagName;
    path = '';
    elem = this;
    while ((elem != null ? elem.nodeType : void 0) === Node.ELEMENT_NODE && elem !== relativeRoot) {
      tagName = elem.tagName.replace(":", "\\:");
      idx = $(elem.parentNode).children(tagName).index(elem) + 1;
      idx = "[" + idx + "]";
      path = "/" + elem.tagName.toLowerCase() + idx + path;
      elem = elem.parentNode;
    }
    return path;
  });
  return jq.get();
};

simpleXPathPure = function($el, relativeRoot) {
  var getPathSegment, getPathTo, jq, rootNode;
  getPathSegment = function(node) {
    var name, pos;
    name = getNodeName(node);
    pos = getNodePosition(node);
    return "" + name + "[" + pos + "]";
  };
  rootNode = relativeRoot;
  getPathTo = function(node) {
    var xpath;
    xpath = '';
    while (node !== rootNode) {
      if (node == null) {
        throw new Error("Called getPathTo on a node which was not a descendant of @rootNode. " + rootNode);
      }
      xpath = (getPathSegment(node)) + '/' + xpath;
      node = node.parentNode;
    }
    xpath = '/' + xpath;
    xpath = xpath.replace(/\/$/, '');
    return xpath;
  };
  jq = $el.map(function() {
    var path;
    path = getPathTo(this);
    return path;
  });
  return jq.get();
};

findChild = function(node, type, index) {
  var child, children, found, name, _i, _len;
  if (!node.hasChildNodes()) {
    throw new Error("XPath error: node has no children!");
  }
  children = node.childNodes;
  found = 0;
  for (_i = 0, _len = children.length; _i < _len; _i++) {
    child = children[_i];
    name = getNodeName(child);
    if (name === type) {
      found += 1;
      if (found === index) {
        return child;
      }
    }
  }
  throw new Error("XPath error: wanted child not found.");
};

getNodeName = function(node) {
  var nodeName;
  nodeName = node.nodeName.toLowerCase();
  switch (nodeName) {
    case "#text":
      return "text()";
    case "#comment":
      return "comment()";
    case "#cdata-section":
      return "cdata-section()";
    default:
      return nodeName;
  }
};

getNodePosition = function(node) {
  var pos, tmp;
  pos = 0;
  tmp = node;
  while (tmp) {
    if (tmp.nodeName === node.nodeName) {
      pos += 1;
    }
    tmp = tmp.previousSibling;
  }
  return pos;
};

fromNode = function($el, relativeRoot) {
  var exception, result;
  try {
    result = simpleXPathJQuery($el, relativeRoot);
  } catch (_error) {
    exception = _error;
    console.log("jQuery-based XPath construction failed! Falling back to manual.");
    result = simpleXPathPure($el, relativeRoot);
  }
  return result;
};

toNode = function(path, root) {
  var customResolver, evaluateXPath, namespace, node, segment;
  if (root == null) {
    root = document;
  }
  evaluateXPath = function(xp, nsResolver) {
    var exception, idx, name, node, step, steps, _i, _len, _ref;
    if (nsResolver == null) {
      nsResolver = null;
    }
    try {
      return document.evaluate('.' + xp, root, nsResolver, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    } catch (_error) {
      exception = _error;
      console.log("XPath evaluation failed.");
      console.log("Trying fallback...");
      steps = xp.substring(1).split("/");
      node = root;
      for (_i = 0, _len = steps.length; _i < _len; _i++) {
        step = steps[_i];
        _ref = step.split("["), name = _ref[0], idx = _ref[1];
        idx = idx != null ? parseInt((idx != null ? idx.split("]") : void 0)[0]) : 1;
        node = findChild(node, name.toLowerCase(), idx);
      }
      return node;
    }
  };
  if (!$.isXMLDoc(document.documentElement)) {
    return evaluateXPath(path);
  } else {
    customResolver = document.createNSResolver(document.ownerDocument === null ? document.documentElement : document.ownerDocument.documentElement);
    node = evaluateXPath(path, customResolver);
    if (!node) {
      path = ((function() {
        var _i, _len, _ref, _results;
        _ref = path.split('/');
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          segment = _ref[_i];
          if (segment && segment.indexOf(':') === -1) {
            _results.push(segment.replace(/^([a-z]+)/, 'xhtml:$1'));
          } else {
            _results.push(segment);
          }
        }
        return _results;
      })()).join('/');
      namespace = document.lookupNamespaceURI(null);
      customResolver = function(ns) {
        if (ns === 'xhtml') {
          return namespace;
        } else {
          return document.documentElement.getAttribute('xmlns:' + ns);
        }
      };
      node = evaluateXPath(path, customResolver);
    }
    return node;
  }
};

module.exports = {
  fromNode: fromNode,
  toNode: toNode
};


},{"./util":14}]},{},[6])

(6)
});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],"/usr/var/server.base/node_modules/async/dist/async.js":[function(require,module,exports){
(function (process,global,setImmediate){(function (){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.async = global.async || {})));
}(this, (function (exports) { 'use strict';

function slice(arrayLike, start) {
    start = start|0;
    var newLen = Math.max(arrayLike.length - start, 0);
    var newArr = Array(newLen);
    for(var idx = 0; idx < newLen; idx++)  {
        newArr[idx] = arrayLike[start + idx];
    }
    return newArr;
}

/**
 * Creates a continuation function with some arguments already applied.
 *
 * Useful as a shorthand when combined with other control flow functions. Any
 * arguments passed to the returned function are added to the arguments
 * originally passed to apply.
 *
 * @name apply
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {Function} fn - The function you want to eventually apply all
 * arguments to. Invokes with (arguments...).
 * @param {...*} arguments... - Any number of arguments to automatically apply
 * when the continuation is called.
 * @returns {Function} the partially-applied function
 * @example
 *
 * // using apply
 * async.parallel([
 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
 *     async.apply(fs.writeFile, 'testfile2', 'test2')
 * ]);
 *
 *
 * // the same process without using apply
 * async.parallel([
 *     function(callback) {
 *         fs.writeFile('testfile1', 'test1', callback);
 *     },
 *     function(callback) {
 *         fs.writeFile('testfile2', 'test2', callback);
 *     }
 * ]);
 *
 * // It's possible to pass any number of additional arguments when calling the
 * // continuation:
 *
 * node> var fn = async.apply(sys.puts, 'one');
 * node> fn('two', 'three');
 * one
 * two
 * three
 */
var apply = function(fn/*, ...args*/) {
    var args = slice(arguments, 1);
    return function(/*callArgs*/) {
        var callArgs = slice(arguments);
        return fn.apply(null, args.concat(callArgs));
    };
};

var initialParams = function (fn) {
    return function (/*...args, callback*/) {
        var args = slice(arguments);
        var callback = args.pop();
        fn.call(this, args, callback);
    };
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

function fallback(fn) {
    setTimeout(fn, 0);
}

function wrap(defer) {
    return function (fn/*, ...args*/) {
        var args = slice(arguments, 1);
        defer(function () {
            fn.apply(null, args);
        });
    };
}

var _defer;

if (hasSetImmediate) {
    _defer = setImmediate;
} else if (hasNextTick) {
    _defer = process.nextTick;
} else {
    _defer = fallback;
}

var setImmediate$1 = wrap(_defer);

/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */
function asyncify(func) {
    return initialParams(function (args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (isObject(result) && typeof result.then === 'function') {
            result.then(function(value) {
                invokeCallback(callback, null, value);
            }, function(err) {
                invokeCallback(callback, err.message ? err : new Error(err));
            });
        } else {
            callback(null, result);
        }
    });
}

function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (e) {
        setImmediate$1(rethrow, e);
    }
}

function rethrow(error) {
    throw error;
}

var supportsSymbol = typeof Symbol === 'function';

function isAsync(fn) {
    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
}

function wrapAsync(asyncFn) {
    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
}

function applyEach$1(eachfn) {
    return function(fns/*, ...args*/) {
        var args = slice(arguments, 1);
        var go = initialParams(function(args, callback) {
            var that = this;
            return eachfn(fns, function (fn, cb) {
                wrapAsync(fn).apply(that, args.concat(cb));
            }, callback);
        });
        if (args.length) {
            return go.apply(this, args);
        }
        else {
            return go;
        }
    };
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]';
var funcTag = '[object Function]';
var genTag = '[object GeneratorFunction]';
var proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
var breakLoop = {};

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

function once(fn) {
    return function () {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}

var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;

var getIterator = function (coll) {
    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
};

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]';
var arrayTag = '[object Array]';
var boolTag = '[object Boolean]';
var dateTag = '[object Date]';
var errorTag = '[object Error]';
var funcTag$1 = '[object Function]';
var mapTag = '[object Map]';
var numberTag = '[object Number]';
var objectTag = '[object Object]';
var regexpTag = '[object RegExp]';
var setTag = '[object Set]';
var stringTag = '[object String]';
var weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]';
var dataViewTag = '[object DataView]';
var float32Tag = '[object Float32Array]';
var float64Tag = '[object Float64Array]';
var int8Tag = '[object Int8Array]';
var int16Tag = '[object Int16Array]';
var int32Tag = '[object Int32Array]';
var uint8Tag = '[object Uint8Array]';
var uint8ClampedTag = '[object Uint8ClampedArray]';
var uint16Tag = '[object Uint16Array]';
var uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$1.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? {value: coll[i], key: i} : null;
    }
}

function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done)
            return null;
        i++;
        return {value: item.value, key: i};
    }
}

function createObjectIterator(obj) {
    var okeys = keys(obj);
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        return i < len ? {value: obj[key], key: key} : null;
    };
}

function iterator(coll) {
    if (isArrayLike(coll)) {
        return createArrayIterator(coll);
    }

    var iterator = getIterator(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
}

function onlyOnce(fn) {
    return function() {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}

function _eachOfLimit(limit) {
    return function (obj, iteratee, callback) {
        callback = once(callback || noop);
        if (limit <= 0 || !obj) {
            return callback(null);
        }
        var nextElem = iterator(obj);
        var done = false;
        var running = 0;
        var looping = false;

        function iterateeCallback(err, value) {
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            }
            else if (value === breakLoop || (done && running <= 0)) {
                done = true;
                return callback(null);
            }
            else if (!looping) {
                replenish();
            }
        }

        function replenish () {
            looping = true;
            while (running < limit && !done) {
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) {
                        callback(null);
                    }
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
            }
            looping = false;
        }

        replenish();
    };
}

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
function eachOfLimit(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
}

function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}

// eachOf implementation optimized for array-likes
function eachOfArrayLike(coll, iteratee, callback) {
    callback = once(callback || noop);
    var index = 0,
        completed = 0,
        length = coll.length;
    if (length === 0) {
        callback(null);
    }

    function iteratorCallback(err, value) {
        if (err) {
            callback(err);
        } else if ((++completed === length) || value === breakLoop) {
            callback(null);
        }
    }

    for (; index < length; index++) {
        iteratee(coll[index], index, onlyOnce(iteratorCallback));
    }
}

// a generic version of eachOf which can handle array, object, and iterator cases.
var eachOfGeneric = doLimit(eachOfLimit, Infinity);

/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
 * var configs = {};
 *
 * async.forEachOf(obj, function (value, key, callback) {
 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
 *         if (err) return callback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }, function (err) {
 *     if (err) console.error(err.message);
 *     // configs is now a map of JSON data
 *     doSomethingWith(configs);
 * });
 */
var eachOf = function(coll, iteratee, callback) {
    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
    eachOfImplementation(coll, wrapAsync(iteratee), callback);
};

function doParallel(fn) {
    return function (obj, iteratee, callback) {
        return fn(eachOf, obj, wrapAsync(iteratee), callback);
    };
}

function _asyncMap(eachfn, arr, iteratee, callback) {
    callback = callback || noop;
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = wrapAsync(iteratee);

    eachfn(arr, function (value, _, callback) {
        var index = counter++;
        _iteratee(value, function (err, v) {
            results[index] = v;
            callback(err);
        });
    }, function (err) {
        callback(err, results);
    });
}

/**
 * Produces a new collection of values by mapping each value in `coll` through
 * the `iteratee` function. The `iteratee` is called with an item from `coll`
 * and a callback for when it has finished processing. Each of these callback
 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
 * `iteratee` passes an error to its callback, the main `callback` (for the
 * `map` function) is immediately called with the error.
 *
 * Note, that since this function applies the `iteratee` to each item in
 * parallel, there is no guarantee that the `iteratee` functions will complete
 * in order. However, the results array will be in the same order as the
 * original `coll`.
 *
 * If `map` is passed an Object, the results will be an Array.  The results
 * will roughly be in the order of the original Objects' keys (but this can
 * vary across JavaScript engines).
 *
 * @name map
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an Array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @example
 *
 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
 *     // results is now an array of stats for each file
 * });
 */
var map = doParallel(_asyncMap);

/**
 * Applies the provided arguments to each function in the array, calling
 * `callback` after all functions have completed. If you only provide the first
 * argument, `fns`, then it will return a function which lets you pass in the
 * arguments as if it were a single function call. If more arguments are
 * provided, `callback` is required while `args` is still optional.
 *
 * @name applyEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s
 * to all call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {Function} - If only the first argument, `fns`, is provided, it will
 * return a function which lets you pass in the arguments as if it were a single
 * function call. The signature is `(..args, callback)`. If invoked with any
 * arguments, `callback` is required.
 * @example
 *
 * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
 *
 * // partial application example:
 * async.each(
 *     buckets,
 *     async.applyEach([enableSearch, updateSchema]),
 *     callback
 * );
 */
var applyEach = applyEach$1(map);

function doParallelLimit(fn) {
    return function (obj, limit, iteratee, callback) {
        return fn(_eachOfLimit(limit), obj, wrapAsync(iteratee), callback);
    };
}

/**
 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
 *
 * @name mapLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 */
var mapLimit = doParallelLimit(_asyncMap);

/**
 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
 *
 * @name mapSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 */
var mapSeries = doLimit(mapLimit, 1);

/**
 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
 *
 * @name applyEachSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
 * @category Control Flow
 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s to all
 * call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {Function} - If only the first argument is provided, it will return
 * a function which lets you pass in the arguments as if it were a single
 * function call.
 */
var applyEachSeries = applyEach$1(mapSeries);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

/**
 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
 * their requirements. Each function can optionally depend on other functions
 * being completed first, and each function is run as soon as its requirements
 * are satisfied.
 *
 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
 * will stop. Further tasks will not execute (so any other functions depending
 * on it will not run), and the main `callback` is immediately called with the
 * error.
 *
 * {@link AsyncFunction}s also receive an object containing the results of functions which
 * have completed so far as the first argument, if they have dependencies. If a
 * task function has no dependencies, it will only be passed a callback.
 *
 * @name auto
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Object} tasks - An object. Each of its properties is either a
 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
 * in the array. The object's key of a property serves as the name of the task
 * defined by that property, i.e. can be used when specifying requirements for
 * other tasks. The function receives one or two arguments:
 * * a `results` object, containing the results of the previously executed
 *   functions, only passed if the task has any dependencies,
 * * a `callback(err, result)` function, which must be called when finished,
 *   passing an `error` (which can be `null`) and the result of the function's
 *   execution.
 * @param {number} [concurrency=Infinity] - An optional `integer` for
 * determining the maximum number of tasks that can be run in parallel. By
 * default, as many as possible.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback. Results are always returned; however, if an
 * error occurs, no further `tasks` will be performed, and the results object
 * will only contain partial results. Invoked with (err, results).
 * @returns undefined
 * @example
 *
 * async.auto({
 *     // this function will just be passed a callback
 *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
 *     showData: ['readData', function(results, cb) {
 *         // results.readData is the file's contents
 *         // ...
 *     }]
 * }, callback);
 *
 * async.auto({
 *     get_data: function(callback) {
 *         console.log('in get_data');
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         console.log('in make_folder');
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         console.log('in write_file', JSON.stringify(results));
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         console.log('in email_link', JSON.stringify(results));
 *         // once the file is written let's email a link to it...
 *         // results.write_file contains the filename returned by write_file.
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('results = ', results);
 * });
 */
var auto = function (tasks, concurrency, callback) {
    if (typeof concurrency === 'function') {
        // concurrency is optional, shift the args.
        callback = concurrency;
        concurrency = null;
    }
    callback = once(callback || noop);
    var keys$$1 = keys(tasks);
    var numTasks = keys$$1.length;
    if (!numTasks) {
        return callback(null);
    }
    if (!concurrency) {
        concurrency = numTasks;
    }

    var results = {};
    var runningTasks = 0;
    var hasError = false;

    var listeners = Object.create(null);

    var readyTasks = [];

    // for cycle detection:
    var readyToCheck = []; // tasks that have been identified as reachable
    // without the possibility of returning to an ancestor task
    var uncheckedDependencies = {};

    baseForOwn(tasks, function (task, key) {
        if (!isArray(task)) {
            // no dependencies
            enqueueTask(key, [task]);
            readyToCheck.push(key);
            return;
        }

        var dependencies = task.slice(0, task.length - 1);
        var remainingDependencies = dependencies.length;
        if (remainingDependencies === 0) {
            enqueueTask(key, task);
            readyToCheck.push(key);
            return;
        }
        uncheckedDependencies[key] = remainingDependencies;

        arrayEach(dependencies, function (dependencyName) {
            if (!tasks[dependencyName]) {
                throw new Error('async.auto task `' + key +
                    '` has a non-existent dependency `' +
                    dependencyName + '` in ' +
                    dependencies.join(', '));
            }
            addListener(dependencyName, function () {
                remainingDependencies--;
                if (remainingDependencies === 0) {
                    enqueueTask(key, task);
                }
            });
        });
    });

    checkForDeadlocks();
    processQueue();

    function enqueueTask(key, task) {
        readyTasks.push(function () {
            runTask(key, task);
        });
    }

    function processQueue() {
        if (readyTasks.length === 0 && runningTasks === 0) {
            return callback(null, results);
        }
        while(readyTasks.length && runningTasks < concurrency) {
            var run = readyTasks.shift();
            run();
        }

    }

    function addListener(taskName, fn) {
        var taskListeners = listeners[taskName];
        if (!taskListeners) {
            taskListeners = listeners[taskName] = [];
        }

        taskListeners.push(fn);
    }

    function taskComplete(taskName) {
        var taskListeners = listeners[taskName] || [];
        arrayEach(taskListeners, function (fn) {
            fn();
        });
        processQueue();
    }


    function runTask(key, task) {
        if (hasError) return;

        var taskCallback = onlyOnce(function(err, result) {
            runningTasks--;
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            }
            if (err) {
                var safeResults = {};
                baseForOwn(results, function(val, rkey) {
                    safeResults[rkey] = val;
                });
                safeResults[key] = result;
                hasError = true;
                listeners = Object.create(null);

                callback(err, safeResults);
            } else {
                results[key] = result;
                taskComplete(key);
            }
        });

        runningTasks++;
        var taskFn = wrapAsync(task[task.length - 1]);
        if (task.length > 1) {
            taskFn(results, taskCallback);
        } else {
            taskFn(taskCallback);
        }
    }

    function checkForDeadlocks() {
        // Kahn's algorithm
        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
        var currentTask;
        var counter = 0;
        while (readyToCheck.length) {
            currentTask = readyToCheck.pop();
            counter++;
            arrayEach(getDependents(currentTask), function (dependent) {
                if (--uncheckedDependencies[dependent] === 0) {
                    readyToCheck.push(dependent);
                }
            });
        }

        if (counter !== numTasks) {
            throw new Error(
                'async.auto cannot execute tasks due to a recursive dependency'
            );
        }
    }

    function getDependents(taskName) {
        var result = [];
        baseForOwn(tasks, function (task, key) {
            if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
                result.push(key);
            }
        });
        return result;
    }
};

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
var symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff';
var rsComboMarksRange = '\\u0300-\\u036f';
var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange = '\\u20d0-\\u20ff';
var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
var rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff';
var rsComboMarksRange$1 = '\\u0300-\\u036f';
var reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']';
var rsCombo = '[' + rsComboRange$1 + ']';
var rsFitz = '\\ud83c[\\udffb-\\udfff]';
var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
var rsNonAstral = '[^' + rsAstralRange$1 + ']';
var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
var rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?';
var rsOptVar = '[' + rsVarRange$1 + ']?';
var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
var rsSeq = rsOptVar + reOptMod + rsOptJoin;
var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

var FN_ARGS = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /(=.+)?(\s*)$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;

function parseParams(func) {
    func = func.toString().replace(STRIP_COMMENTS, '');
    func = func.match(FN_ARGS)[2].replace(' ', '');
    func = func ? func.split(FN_ARG_SPLIT) : [];
    func = func.map(function (arg){
        return trim(arg.replace(FN_ARG, ''));
    });
    return func;
}

/**
 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
 * tasks are specified as parameters to the function, after the usual callback
 * parameter, with the parameter names matching the names of the tasks it
 * depends on. This can provide even more readable task graphs which can be
 * easier to maintain.
 *
 * If a final callback is specified, the task results are similarly injected,
 * specified as named parameters after the initial error parameter.
 *
 * The autoInject function is purely syntactic sugar and its semantics are
 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
 *
 * @name autoInject
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.auto]{@link module:ControlFlow.auto}
 * @category Control Flow
 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
 * the form 'func([dependencies...], callback). The object's key of a property
 * serves as the name of the task defined by that property, i.e. can be used
 * when specifying requirements for other tasks.
 * * The `callback` parameter is a `callback(err, result)` which must be called
 *   when finished, passing an `error` (which can be `null`) and the result of
 *   the function's execution. The remaining parameters name other tasks on
 *   which the task is dependent, and the results from those tasks are the
 *   arguments of those parameters.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback, and a `results` object with any completed
 * task results, similar to `auto`.
 * @example
 *
 * //  The example from `auto` can be rewritten as follows:
 * async.autoInject({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: function(get_data, make_folder, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     },
 *     email_link: function(write_file, callback) {
 *         // once the file is written let's email a link to it...
 *         // write_file contains the filename returned by write_file.
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 *
 * // If you are using a JS minifier that mangles parameter names, `autoInject`
 * // will not work with plain functions, since the parameter names will be
 * // collapsed to a single letter identifier.  To work around this, you can
 * // explicitly specify the names of the parameters your task function needs
 * // in an array, similar to Angular.js dependency injection.
 *
 * // This still has an advantage over plain `auto`, since the results a task
 * // depends on are still spread into arguments.
 * async.autoInject({
 *     //...
 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(write_file, callback) {
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }]
 *     //...
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 */
function autoInject(tasks, callback) {
    var newTasks = {};

    baseForOwn(tasks, function (taskFn, key) {
        var params;
        var fnIsAsync = isAsync(taskFn);
        var hasNoDeps =
            (!fnIsAsync && taskFn.length === 1) ||
            (fnIsAsync && taskFn.length === 0);

        if (isArray(taskFn)) {
            params = taskFn.slice(0, -1);
            taskFn = taskFn[taskFn.length - 1];

            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
        } else if (hasNoDeps) {
            // no dependencies, use the function as-is
            newTasks[key] = taskFn;
        } else {
            params = parseParams(taskFn);
            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) {
                throw new Error("autoInject task functions require explicit parameters.");
            }

            // remove callback param
            if (!fnIsAsync) params.pop();

            newTasks[key] = params.concat(newTask);
        }

        function newTask(results, taskCb) {
            var newArgs = arrayMap(params, function (name) {
                return results[name];
            });
            newArgs.push(taskCb);
            wrapAsync(taskFn).apply(null, newArgs);
        }
    });

    auto(newTasks, callback);
}

// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
// used for queues. This implementation assumes that the node provided by the user can be modified
// to adjust the next and last properties. We implement only the minimal functionality
// for queue support.
function DLL() {
    this.head = this.tail = null;
    this.length = 0;
}

function setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
}

DLL.prototype.removeLink = function(node) {
    if (node.prev) node.prev.next = node.next;
    else this.head = node.next;
    if (node.next) node.next.prev = node.prev;
    else this.tail = node.prev;

    node.prev = node.next = null;
    this.length -= 1;
    return node;
};

DLL.prototype.empty = function () {
    while(this.head) this.shift();
    return this;
};

DLL.prototype.insertAfter = function(node, newNode) {
    newNode.prev = node;
    newNode.next = node.next;
    if (node.next) node.next.prev = newNode;
    else this.tail = newNode;
    node.next = newNode;
    this.length += 1;
};

DLL.prototype.insertBefore = function(node, newNode) {
    newNode.prev = node.prev;
    newNode.next = node;
    if (node.prev) node.prev.next = newNode;
    else this.head = newNode;
    node.prev = newNode;
    this.length += 1;
};

DLL.prototype.unshift = function(node) {
    if (this.head) this.insertBefore(this.head, node);
    else setInitial(this, node);
};

DLL.prototype.push = function(node) {
    if (this.tail) this.insertAfter(this.tail, node);
    else setInitial(this, node);
};

DLL.prototype.shift = function() {
    return this.head && this.removeLink(this.head);
};

DLL.prototype.pop = function() {
    return this.tail && this.removeLink(this.tail);
};

DLL.prototype.toArray = function () {
    var arr = Array(this.length);
    var curr = this.head;
    for(var idx = 0; idx < this.length; idx++) {
        arr[idx] = curr.data;
        curr = curr.next;
    }
    return arr;
};

DLL.prototype.remove = function (testFn) {
    var curr = this.head;
    while(!!curr) {
        var next = curr.next;
        if (testFn(curr)) {
            this.removeLink(curr);
        }
        curr = next;
    }
    return this;
};

function queue(worker, concurrency, payload) {
    if (concurrency == null) {
        concurrency = 1;
    }
    else if(concurrency === 0) {
        throw new Error('Concurrency must not be zero');
    }

    var _worker = wrapAsync(worker);
    var numRunning = 0;
    var workersList = [];

    var processingScheduled = false;
    function _insert(data, insertAtFront, callback) {
        if (callback != null && typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;
        if (!isArray(data)) {
            data = [data];
        }
        if (data.length === 0 && q.idle()) {
            // call drain immediately if there are no tasks
            return setImmediate$1(function() {
                q.drain();
            });
        }

        for (var i = 0, l = data.length; i < l; i++) {
            var item = {
                data: data[i],
                callback: callback || noop
            };

            if (insertAtFront) {
                q._tasks.unshift(item);
            } else {
                q._tasks.push(item);
            }
        }

        if (!processingScheduled) {
            processingScheduled = true;
            setImmediate$1(function() {
                processingScheduled = false;
                q.process();
            });
        }
    }

    function _next(tasks) {
        return function(err){
            numRunning -= 1;

            for (var i = 0, l = tasks.length; i < l; i++) {
                var task = tasks[i];

                var index = baseIndexOf(workersList, task, 0);
                if (index === 0) {
                    workersList.shift();
                } else if (index > 0) {
                    workersList.splice(index, 1);
                }

                task.callback.apply(task, arguments);

                if (err != null) {
                    q.error(err, task.data);
                }
            }

            if (numRunning <= (q.concurrency - q.buffer) ) {
                q.unsaturated();
            }

            if (q.idle()) {
                q.drain();
            }
            q.process();
        };
    }

    var isProcessing = false;
    var q = {
        _tasks: new DLL(),
        concurrency: concurrency,
        payload: payload,
        saturated: noop,
        unsaturated:noop,
        buffer: concurrency / 4,
        empty: noop,
        drain: noop,
        error: noop,
        started: false,
        paused: false,
        push: function (data, callback) {
            _insert(data, false, callback);
        },
        kill: function () {
            q.drain = noop;
            q._tasks.empty();
        },
        unshift: function (data, callback) {
            _insert(data, true, callback);
        },
        remove: function (testFn) {
            q._tasks.remove(testFn);
        },
        process: function () {
            // Avoid trying to start too many processing operations. This can occur
            // when callbacks resolve synchronously (#1267).
            if (isProcessing) {
                return;
            }
            isProcessing = true;
            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                var tasks = [], data = [];
                var l = q._tasks.length;
                if (q.payload) l = Math.min(l, q.payload);
                for (var i = 0; i < l; i++) {
                    var node = q._tasks.shift();
                    tasks.push(node);
                    workersList.push(node);
                    data.push(node.data);
                }

                numRunning += 1;

                if (q._tasks.length === 0) {
                    q.empty();
                }

                if (numRunning === q.concurrency) {
                    q.saturated();
                }

                var cb = onlyOnce(_next(tasks));
                _worker(data, cb);
            }
            isProcessing = false;
        },
        length: function () {
            return q._tasks.length;
        },
        running: function () {
            return numRunning;
        },
        workersList: function () {
            return workersList;
        },
        idle: function() {
            return q._tasks.length + numRunning === 0;
        },
        pause: function () {
            q.paused = true;
        },
        resume: function () {
            if (q.paused === false) { return; }
            q.paused = false;
            setImmediate$1(q.process);
        }
    };
    return q;
}

/**
 * A cargo of tasks for the worker function to complete. Cargo inherits all of
 * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
 * @typedef {Object} CargoObject
 * @memberOf module:ControlFlow
 * @property {Function} length - A function returning the number of items
 * waiting to be processed. Invoke like `cargo.length()`.
 * @property {number} payload - An `integer` for determining how many tasks
 * should be process per round. This property can be changed after a `cargo` is
 * created to alter the payload on-the-fly.
 * @property {Function} push - Adds `task` to the `queue`. The callback is
 * called once the `worker` has finished processing the task. Instead of a
 * single task, an array of `tasks` can be submitted. The respective callback is
 * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
 * @property {Function} saturated - A callback that is called when the
 * `queue.length()` hits the concurrency and further tasks will be queued.
 * @property {Function} empty - A callback that is called when the last item
 * from the `queue` is given to a `worker`.
 * @property {Function} drain - A callback that is called when the last item
 * from the `queue` has returned from the `worker`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke like `cargo.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
 */

/**
 * Creates a `cargo` object with the specified payload. Tasks added to the
 * cargo will be processed altogether (up to the `payload` limit). If the
 * `worker` is in progress, the task is queued until it becomes available. Once
 * the `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, cargo passes an array of tasks to a single worker, repeating
 * when the worker is finished.
 *
 * @name cargo
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargo and inner queue.
 * @example
 *
 * // create a cargo object with payload 2
 * var cargo = async.cargo(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2);
 *
 * // add some items
 * cargo.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargo.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * cargo.push({name: 'baz'}, function(err) {
 *     console.log('finished processing baz');
 * });
 */
function cargo(worker, payload) {
    return queue(worker, 1, payload);
}

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 */
var eachOfSeries = doLimit(eachOfLimit, 1);

/**
 * Reduces `coll` into a single value using an async `iteratee` to return each
 * successive step. `memo` is the initial state of the reduction. This function
 * only operates in series.
 *
 * For performance reasons, it may make sense to split a call to this function
 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
 * results. This function is for situations where each step in the reduction
 * needs to be async; if you can get the data before reducing it, then it's
 * probably a good idea to do so.
 *
 * @name reduce
 * @static
 * @memberOf module:Collections
 * @method
 * @alias inject
 * @alias foldl
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee complete with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @example
 *
 * async.reduce([1,2,3], 0, function(memo, item, callback) {
 *     // pointless async:
 *     process.nextTick(function() {
 *         callback(null, memo + item)
 *     });
 * }, function(err, result) {
 *     // result is now equal to the last value of memo, which is 6
 * });
 */
function reduce(coll, memo, iteratee, callback) {
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    eachOfSeries(coll, function(x, i, callback) {
        _iteratee(memo, x, function(err, v) {
            memo = v;
            callback(err);
        });
    }, function(err) {
        callback(err, memo);
    });
}

/**
 * Version of the compose function that is more natural to read. Each function
 * consumes the return value of the previous function. It is the equivalent of
 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name seq
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.compose]{@link module:ControlFlow.compose}
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} a function that composes the `functions` in order
 * @example
 *
 * // Requires lodash (or underscore), express3 and dresende's orm2.
 * // Part of an app, that fetches cats of the logged user.
 * // This example uses `seq` function to avoid overnesting and error
 * // handling clutter.
 * app.get('/cats', function(request, response) {
 *     var User = request.models.User;
 *     async.seq(
 *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
 *         function(user, fn) {
 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
 *         }
 *     )(req.session.user_id, function (err, cats) {
 *         if (err) {
 *             console.error(err);
 *             response.json({ status: 'error', message: err.message });
 *         } else {
 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
 *         }
 *     });
 * });
 */
function seq(/*...functions*/) {
    var _functions = arrayMap(arguments, wrapAsync);
    return function(/*...args*/) {
        var args = slice(arguments);
        var that = this;

        var cb = args[args.length - 1];
        if (typeof cb == 'function') {
            args.pop();
        } else {
            cb = noop;
        }

        reduce(_functions, args, function(newargs, fn, cb) {
            fn.apply(that, newargs.concat(function(err/*, ...nextargs*/) {
                var nextargs = slice(arguments, 1);
                cb(err, nextargs);
            }));
        },
        function(err, results) {
            cb.apply(that, [err].concat(results));
        });
    };
}

/**
 * Creates a function which is a composition of the passed asynchronous
 * functions. Each function consumes the return value of the function that
 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name compose
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} an asynchronous function that is the composed
 * asynchronous `functions`
 * @example
 *
 * function add1(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n + 1);
 *     }, 10);
 * }
 *
 * function mul3(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n * 3);
 *     }, 10);
 * }
 *
 * var add1mul3 = async.compose(mul3, add1);
 * add1mul3(4, function (err, result) {
 *     // result now equals 15
 * });
 */
var compose = function(/*...args*/) {
    return seq.apply(null, slice(arguments).reverse());
};

var _concat = Array.prototype.concat;

/**
 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
 *
 * @name concatLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 */
var concatLimit = function(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function(val, callback) {
        _iteratee(val, function(err /*, ...args*/) {
            if (err) return callback(err);
            return callback(null, slice(arguments, 1));
        });
    }, function(err, mapResults) {
        var result = [];
        for (var i = 0; i < mapResults.length; i++) {
            if (mapResults[i]) {
                result = _concat.apply(result, mapResults[i]);
            }
        }

        return callback(err, result);
    });
};

/**
 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
 * the concatenated list. The `iteratee`s are called in parallel, and the
 * results are concatenated as they return. There is no guarantee that the
 * results array will be returned in the original order of `coll` passed to the
 * `iteratee` function.
 *
 * @name concat
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback(err)] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @example
 *
 * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
 *     // files is now a list of filenames that exist in the 3 directories
 * });
 */
var concat = doLimit(concatLimit, Infinity);

/**
 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
 *
 * @name concatSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
 * The iteratee should complete with an array an array of results.
 * Invoked with (item, callback).
 * @param {Function} [callback(err)] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 */
var concatSeries = doLimit(concatLimit, 1);

/**
 * Returns a function that when called, calls-back with the values provided.
 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
 * [`auto`]{@link module:ControlFlow.auto}.
 *
 * @name constant
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {...*} arguments... - Any number of arguments to automatically invoke
 * callback with.
 * @returns {AsyncFunction} Returns a function that when invoked, automatically
 * invokes the callback with the previous given arguments.
 * @example
 *
 * async.waterfall([
 *     async.constant(42),
 *     function (value, next) {
 *         // value === 42
 *     },
 *     //...
 * ], callback);
 *
 * async.waterfall([
 *     async.constant(filename, "utf8"),
 *     fs.readFile,
 *     function (fileData, next) {
 *         //...
 *     }
 *     //...
 * ], callback);
 *
 * async.auto({
 *     hostname: async.constant("https://server.net/"),
 *     port: findFreePort,
 *     launchServer: ["hostname", "port", function (options, cb) {
 *         startServer(options, cb);
 *     }],
 *     //...
 * }, callback);
 */
var constant = function(/*...values*/) {
    var values = slice(arguments);
    var args = [null].concat(values);
    return function (/*...ignoredArgs, callback*/) {
        var callback = arguments[arguments.length - 1];
        return callback.apply(this, args);
    };
};

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

function _createTester(check, getResult) {
    return function(eachfn, arr, iteratee, cb) {
        cb = cb || noop;
        var testPassed = false;
        var testResult;
        eachfn(arr, function(value, _, callback) {
            iteratee(value, function(err, result) {
                if (err) {
                    callback(err);
                } else if (check(result) && !testResult) {
                    testPassed = true;
                    testResult = getResult(true, value);
                    callback(null, breakLoop);
                } else {
                    callback();
                }
            });
        }, function(err) {
            if (err) {
                cb(err);
            } else {
                cb(null, testPassed ? testResult : getResult(false));
            }
        });
    };
}

function _findGetResult(v, x) {
    return x;
}

/**
 * Returns the first value in `coll` that passes an async truth test. The
 * `iteratee` is applied in parallel, meaning the first iteratee to return
 * `true` will fire the detect `callback` with that result. That means the
 * result might not be the first item in the original `coll` (in terms of order)
 * that passes the test.

 * If order within the original `coll` is important, then look at
 * [`detectSeries`]{@link module:Collections.detectSeries}.
 *
 * @name detect
 * @static
 * @memberOf module:Collections
 * @method
 * @alias find
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @example
 *
 * async.detect(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // result now equals the first file in the list that exists
 * });
 */
var detect = doParallel(_createTester(identity, _findGetResult));

/**
 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name detectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findLimit
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 */
var detectLimit = doParallelLimit(_createTester(identity, _findGetResult));

/**
 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
 *
 * @name detectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findSeries
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 */
var detectSeries = doLimit(detectLimit, 1);

function consoleFunc(name) {
    return function (fn/*, ...args*/) {
        var args = slice(arguments, 1);
        args.push(function (err/*, ...args*/) {
            var args = slice(arguments, 1);
            if (typeof console === 'object') {
                if (err) {
                    if (console.error) {
                        console.error(err);
                    }
                } else if (console[name]) {
                    arrayEach(args, function (x) {
                        console[name](x);
                    });
                }
            }
        });
        wrapAsync(fn).apply(null, args);
    };
}

/**
 * Logs the result of an [`async` function]{@link AsyncFunction} to the
 * `console` using `console.dir` to display the properties of the resulting object.
 * Only works in Node.js or in browsers that support `console.dir` and
 * `console.error` (such as FF and Chrome).
 * If multiple arguments are returned from the async function,
 * `console.dir` is called on each argument in order.
 *
 * @name dir
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, {hello: name});
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.dir(hello, 'world');
 * {hello: 'world'}
 */
var dir = consoleFunc('dir');

/**
 * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
 * the order of operations, the arguments `test` and `fn` are switched.
 *
 * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
 * @name doDuring
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.during]{@link module:ControlFlow.during}
 * @category Control Flow
 * @param {AsyncFunction} fn - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `fn`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `fn`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `fn` has stopped. `callback`
 * will be passed an error if one occurred, otherwise `null`.
 */
function doDuring(fn, test, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);

    function next(err/*, ...args*/) {
        if (err) return callback(err);
        var args = slice(arguments, 1);
        args.push(check);
        _test.apply(this, args);
    }

    function check(err, truth) {
        if (err) return callback(err);
        if (!truth) return callback(null);
        _fn(next);
    }

    check(null, true);

}

/**
 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
 * the order of operations, the arguments `test` and `iteratee` are switched.
 *
 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
 *
 * @name doWhilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - A function which is called each time `test`
 * passes. Invoked with (callback).
 * @param {Function} test - synchronous truth test to perform after each
 * execution of `iteratee`. Invoked with any non-error callback results of
 * `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped.
 * `callback` will be passed an error and any arguments passed to the final
 * `iteratee`'s callback. Invoked with (err, [results]);
 */
function doWhilst(iteratee, test, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    var next = function(err/*, ...args*/) {
        if (err) return callback(err);
        var args = slice(arguments, 1);
        if (test.apply(this, args)) return _iteratee(next);
        callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
}

/**
 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
 * argument ordering differs from `until`.
 *
 * @name doUntil
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} test - synchronous truth test to perform after each
 * execution of `iteratee`. Invoked with any non-error callback results of
 * `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 */
function doUntil(iteratee, test, callback) {
    doWhilst(iteratee, function() {
        return !test.apply(this, arguments);
    }, callback);
}

/**
 * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
 * is passed a callback in the form of `function (err, truth)`. If error is
 * passed to `test` or `fn`, the main callback is immediately called with the
 * value of the error.
 *
 * @name during
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `fn`. Invoked with (callback).
 * @param {AsyncFunction} fn - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `fn` has stopped. `callback`
 * will be passed an error, if one occurred, otherwise `null`.
 * @example
 *
 * var count = 0;
 *
 * async.during(
 *     function (callback) {
 *         return callback(null, count < 5);
 *     },
 *     function (callback) {
 *         count++;
 *         setTimeout(callback, 1000);
 *     },
 *     function (err) {
 *         // 5 seconds have passed
 *     }
 * );
 */
function during(test, fn, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);

    function next(err) {
        if (err) return callback(err);
        _test(check);
    }

    function check(err, truth) {
        if (err) return callback(err);
        if (!truth) return callback(null);
        _fn(next);
    }

    _test(check);
}

function _withoutIndex(iteratee) {
    return function (value, index, callback) {
        return iteratee(value, callback);
    };
}

/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * // assuming openFiles is an array of file names and saveFile is a function
 * // to save the modified contents of that file:
 *
 * async.each(openFiles, saveFile, function(err){
 *   // if any of the saves produced an error, err would equal that error
 * });
 *
 * // assuming openFiles is an array of file names
 * async.each(openFiles, function(file, callback) {
 *
 *     // Perform operation on file here.
 *     console.log('Processing file ' + file);
 *
 *     if( file.length > 32 ) {
 *       console.log('This file name is too long');
 *       callback('File name too long');
 *     } else {
 *       // Do work to process file here
 *       console.log('File processed');
 *       callback();
 *     }
 * }, function(err) {
 *     // if any of the file processing produced an error, err would equal that error
 *     if( err ) {
 *       // One of the iterations produced an error.
 *       // All processing will now stop.
 *       console.log('A file failed to process');
 *     } else {
 *       console.log('All files have been processed successfully');
 *     }
 * });
 */
function eachLimit(coll, iteratee, callback) {
    eachOf(coll, _withoutIndex(wrapAsync(iteratee)), callback);
}

/**
 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
 *
 * @name eachLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfLimit`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
function eachLimit$1(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
}

/**
 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
 *
 * @name eachSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfSeries`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
var eachSeries = doLimit(eachLimit$1, 1);

/**
 * Wrap an async function and ensure it calls its callback on a later tick of
 * the event loop.  If the function already calls its callback on a next tick,
 * no extra deferral is added. This is useful for preventing stack overflows
 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
 * contained. ES2017 `async` functions are returned as-is -- they are immune
 * to Zalgo's corrupting influences, as they always resolve on a later tick.
 *
 * @name ensureAsync
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - an async function, one that expects a node-style
 * callback as its last argument.
 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
 * signature as the function passed in.
 * @example
 *
 * function sometimesAsync(arg, callback) {
 *     if (cache[arg]) {
 *         return callback(null, cache[arg]); // this would be synchronous!!
 *     } else {
 *         doSomeIO(arg, callback); // this IO would be asynchronous
 *     }
 * }
 *
 * // this has a risk of stack overflows if many results are cached in a row
 * async.mapSeries(args, sometimesAsync, done);
 *
 * // this will defer sometimesAsync's callback if necessary,
 * // preventing stack overflows
 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
 */
function ensureAsync(fn) {
    if (isAsync(fn)) return fn;
    return initialParams(function (args, callback) {
        var sync = true;
        args.push(function () {
            var innerArgs = arguments;
            if (sync) {
                setImmediate$1(function () {
                    callback.apply(null, innerArgs);
                });
            } else {
                callback.apply(null, innerArgs);
            }
        });
        fn.apply(this, args);
        sync = false;
    });
}

function notId(v) {
    return !v;
}

/**
 * Returns `true` if every element in `coll` satisfies an async test. If any
 * iteratee call returns `false`, the main `callback` is immediately called.
 *
 * @name every
 * @static
 * @memberOf module:Collections
 * @method
 * @alias all
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @example
 *
 * async.every(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // if result is true then every file exists
 * });
 */
var every = doParallel(_createTester(notId, notId));

/**
 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
 *
 * @name everyLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 */
var everyLimit = doParallelLimit(_createTester(notId, notId));

/**
 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
 *
 * @name everySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in series.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 */
var everySeries = doLimit(everyLimit, 1);

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

function filterArray(eachfn, arr, iteratee, callback) {
    var truthValues = new Array(arr.length);
    eachfn(arr, function (x, index, callback) {
        iteratee(x, function (err, v) {
            truthValues[index] = !!v;
            callback(err);
        });
    }, function (err) {
        if (err) return callback(err);
        var results = [];
        for (var i = 0; i < arr.length; i++) {
            if (truthValues[i]) results.push(arr[i]);
        }
        callback(null, results);
    });
}

function filterGeneric(eachfn, coll, iteratee, callback) {
    var results = [];
    eachfn(coll, function (x, index, callback) {
        iteratee(x, function (err, v) {
            if (err) {
                callback(err);
            } else {
                if (v) {
                    results.push({index: index, value: x});
                }
                callback();
            }
        });
    }, function (err) {
        if (err) {
            callback(err);
        } else {
            callback(null, arrayMap(results.sort(function (a, b) {
                return a.index - b.index;
            }), baseProperty('value')));
        }
    });
}

function _filter(eachfn, coll, iteratee, callback) {
    var filter = isArrayLike(coll) ? filterArray : filterGeneric;
    filter(eachfn, coll, wrapAsync(iteratee), callback || noop);
}

/**
 * Returns a new array of all the values in `coll` which pass an async truth
 * test. This operation is performed in parallel, but the results array will be
 * in the same order as the original.
 *
 * @name filter
 * @static
 * @memberOf module:Collections
 * @method
 * @alias select
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @example
 *
 * async.filter(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, results) {
 *     // results now equals an array of the existing files
 * });
 */
var filter = doParallel(_filter);

/**
 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name filterLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var filterLimit = doParallelLimit(_filter);

/**
 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
 *
 * @name filterSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results)
 */
var filterSeries = doLimit(filterLimit, 1);

/**
 * Calls the asynchronous function `fn` with a callback parameter that allows it
 * to call itself again, in series, indefinitely.

 * If an error is passed to the callback then `errback` is called with the
 * error, and execution stops, otherwise it will never be called.
 *
 * @name forever
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} fn - an async function to call repeatedly.
 * Invoked with (next).
 * @param {Function} [errback] - when `fn` passes an error to it's callback,
 * this function will be called, and execution stops. Invoked with (err).
 * @example
 *
 * async.forever(
 *     function(next) {
 *         // next is suitable for passing to things that need a callback(err [, whatever]);
 *         // it will result in this function being called again.
 *     },
 *     function(err) {
 *         // if next is called with a value in its first parameter, it will appear
 *         // in here as 'err', and execution will stop.
 *     }
 * );
 */
function forever(fn, errback) {
    var done = onlyOnce(errback || noop);
    var task = wrapAsync(ensureAsync(fn));

    function next(err) {
        if (err) return done(err);
        task(next);
    }
    next();
}

/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
 *
 * @name groupByLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 */
var groupByLimit = function(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function(val, callback) {
        _iteratee(val, function(err, key) {
            if (err) return callback(err);
            return callback(null, {key: key, val: val});
        });
    }, function(err, mapResults) {
        var result = {};
        // from MDN, handle object having an `hasOwnProperty` prop
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        for (var i = 0; i < mapResults.length; i++) {
            if (mapResults[i]) {
                var key = mapResults[i].key;
                var val = mapResults[i].val;

                if (hasOwnProperty.call(result, key)) {
                    result[key].push(val);
                } else {
                    result[key] = [val];
                }
            }
        }

        return callback(err, result);
    });
};

/**
 * Returns a new object, where each value corresponds to an array of items, from
 * `coll`, that returned the corresponding key. That is, the keys of the object
 * correspond to the values passed to the `iteratee` callback.
 *
 * Note: Since this function applies the `iteratee` to each item in parallel,
 * there is no guarantee that the `iteratee` functions will complete in order.
 * However, the values for each key in the `result` will be in the same order as
 * the original `coll`. For Objects, the values will roughly be in the order of
 * the original Objects' keys (but this can vary across JavaScript engines).
 *
 * @name groupBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @example
 *
 * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
 *     db.findById(userId, function(err, user) {
 *         if (err) return callback(err);
 *         return callback(null, user.age);
 *     });
 * }, function(err, result) {
 *     // result is object containing the userIds grouped by age
 *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
 * });
 */
var groupBy = doLimit(groupByLimit, Infinity);

/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
 *
 * @name groupBySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 */
var groupBySeries = doLimit(groupByLimit, 1);

/**
 * Logs the result of an `async` function to the `console`. Only works in
 * Node.js or in browsers that support `console.log` and `console.error` (such
 * as FF and Chrome). If multiple arguments are returned from the async
 * function, `console.log` is called on each argument in order.
 *
 * @name log
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, 'hello ' + name);
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.log(hello, 'world');
 * 'hello world'
 */
var log = consoleFunc('log');

/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name mapValuesLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 */
function mapValuesLimit(obj, limit, iteratee, callback) {
    callback = once(callback || noop);
    var newObj = {};
    var _iteratee = wrapAsync(iteratee);
    eachOfLimit(obj, limit, function(val, key, next) {
        _iteratee(val, key, function (err, result) {
            if (err) return next(err);
            newObj[key] = result;
            next();
        });
    }, function (err) {
        callback(err, newObj);
    });
}

/**
 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
 *
 * Produces a new Object by mapping each value of `obj` through the `iteratee`
 * function. The `iteratee` is called each `value` and `key` from `obj` and a
 * callback for when it has finished processing. Each of these callbacks takes
 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
 * passes an error to its callback, the main `callback` (for the `mapValues`
 * function) is immediately called with the error.
 *
 * Note, the order of the keys in the result is not guaranteed.  The keys will
 * be roughly in the order they complete, (but this is very engine-specific)
 *
 * @name mapValues
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @example
 *
 * async.mapValues({
 *     f1: 'file1',
 *     f2: 'file2',
 *     f3: 'file3'
 * }, function (file, key, callback) {
 *   fs.stat(file, callback);
 * }, function(err, result) {
 *     // result is now a map of stats for each file, e.g.
 *     // {
 *     //     f1: [stats for file1],
 *     //     f2: [stats for file2],
 *     //     f3: [stats for file3]
 *     // }
 * });
 */

var mapValues = doLimit(mapValuesLimit, Infinity);

/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
 *
 * @name mapValuesSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 */
var mapValuesSeries = doLimit(mapValuesLimit, 1);

function has(obj, key) {
    return key in obj;
}

/**
 * Caches the results of an async function. When creating a hash to store
 * function results against, the callback is omitted from the hash and an
 * optional hash function can be used.
 *
 * If no hash function is specified, the first argument is used as a hash key,
 * which may work reasonably if it is a string or a data type that converts to a
 * distinct string. Note that objects and arrays will not behave reasonably.
 * Neither will cases where the other arguments are significant. In such cases,
 * specify your own hash function.
 *
 * The cache of results is exposed as the `memo` property of the function
 * returned by `memoize`.
 *
 * @name memoize
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
 * @param {Function} hasher - An optional function for generating a custom hash
 * for storing results. It has all the arguments applied to it apart from the
 * callback, and must be synchronous.
 * @returns {AsyncFunction} a memoized version of `fn`
 * @example
 *
 * var slow_fn = function(name, callback) {
 *     // do something
 *     callback(null, result);
 * };
 * var fn = async.memoize(slow_fn);
 *
 * // fn can now be used as if it were slow_fn
 * fn('some name', function() {
 *     // callback
 * });
 */
function memoize(fn, hasher) {
    var memo = Object.create(null);
    var queues = Object.create(null);
    hasher = hasher || identity;
    var _fn = wrapAsync(fn);
    var memoized = initialParams(function memoized(args, callback) {
        var key = hasher.apply(null, args);
        if (has(memo, key)) {
            setImmediate$1(function() {
                callback.apply(null, memo[key]);
            });
        } else if (has(queues, key)) {
            queues[key].push(callback);
        } else {
            queues[key] = [callback];
            _fn.apply(null, args.concat(function(/*args*/) {
                var args = slice(arguments);
                memo[key] = args;
                var q = queues[key];
                delete queues[key];
                for (var i = 0, l = q.length; i < l; i++) {
                    q[i].apply(null, args);
                }
            }));
        }
    });
    memoized.memo = memo;
    memoized.unmemoized = fn;
    return memoized;
}

/**
 * Calls `callback` on a later loop around the event loop. In Node.js this just
 * calls `process.nextTick`.  In the browser it will use `setImmediate` if
 * available, otherwise `setTimeout(callback, 0)`, which means other higher
 * priority events may precede the execution of `callback`.
 *
 * This is used internally for browser-compatibility purposes.
 *
 * @name nextTick
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.setImmediate]{@link module:Utils.setImmediate}
 * @category Util
 * @param {Function} callback - The function to call on a later loop around
 * the event loop. Invoked with (args...).
 * @param {...*} args... - any number of additional arguments to pass to the
 * callback on the next tick.
 * @example
 *
 * var call_order = [];
 * async.nextTick(function() {
 *     call_order.push('two');
 *     // call_order now equals ['one','two']
 * });
 * call_order.push('one');
 *
 * async.setImmediate(function (a, b, c) {
 *     // a, b, and c equal 1, 2, and 3
 * }, 1, 2, 3);
 */
var _defer$1;

if (hasNextTick) {
    _defer$1 = process.nextTick;
} else if (hasSetImmediate) {
    _defer$1 = setImmediate;
} else {
    _defer$1 = fallback;
}

var nextTick = wrap(_defer$1);

function _parallel(eachfn, tasks, callback) {
    callback = callback || noop;
    var results = isArrayLike(tasks) ? [] : {};

    eachfn(tasks, function (task, key, callback) {
        wrapAsync(task)(function (err, result) {
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            }
            results[key] = result;
            callback(err);
        });
    }, function (err) {
        callback(err, results);
    });
}

/**
 * Run the `tasks` collection of functions in parallel, without waiting until
 * the previous function has completed. If any of the functions pass an error to
 * its callback, the main `callback` is immediately called with the value of the
 * error. Once the `tasks` have completed, the results are passed to the final
 * `callback` as an array.
 *
 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
 * parallel execution of code.  If your tasks do not use any timers or perform
 * any I/O, they will actually be executed in series.  Any synchronous setup
 * sections for each task will happen one after the other.  JavaScript remains
 * single-threaded.
 *
 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
 * execution of other tasks when a task fails.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 * results from {@link async.parallel}.
 *
 * @name parallel
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 *
 * @example
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // the results array will equal ['one','two'] even though
 *     // the second function had a shorter timeout.
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equals to: {one: 1, two: 2}
 * });
 */
function parallelLimit(tasks, callback) {
    _parallel(eachOf, tasks, callback);
}

/**
 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name parallelLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.parallel]{@link module:ControlFlow.parallel}
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 */
function parallelLimit$1(tasks, limit, callback) {
    _parallel(_eachOfLimit(limit), tasks, callback);
}

/**
 * A queue of tasks for the worker function to complete.
 * @typedef {Object} QueueObject
 * @memberOf module:ControlFlow
 * @property {Function} length - a function returning the number of items
 * waiting to be processed. Invoke with `queue.length()`.
 * @property {boolean} started - a boolean indicating whether or not any
 * items have been pushed and processed by the queue.
 * @property {Function} running - a function returning the number of items
 * currently being processed. Invoke with `queue.running()`.
 * @property {Function} workersList - a function returning the array of items
 * currently being processed. Invoke with `queue.workersList()`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
 * @property {number} concurrency - an integer for determining how many `worker`
 * functions should be run in parallel. This property can be changed after a
 * `queue` is created to alter the concurrency on-the-fly.
 * @property {Function} push - add a new task to the `queue`. Calls `callback`
 * once the `worker` has finished processing the task. Instead of a single task,
 * a `tasks` array can be submitted. The respective callback is used for every
 * task in the list. Invoke with `queue.push(task, [callback])`,
 * @property {Function} unshift - add a new task to the front of the `queue`.
 * Invoke with `queue.unshift(task, [callback])`.
 * @property {Function} remove - remove items from the queue that match a test
 * function.  The test function will be passed an object with a `data` property,
 * and a `priority` property, if this is a
 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
 * `function ({data, priority}) {}` and returns a Boolean.
 * @property {Function} saturated - a callback that is called when the number of
 * running workers hits the `concurrency` limit, and further tasks will be
 * queued.
 * @property {Function} unsaturated - a callback that is called when the number
 * of running workers is less than the `concurrency` & `buffer` limits, and
 * further tasks will not be queued.
 * @property {number} buffer - A minimum threshold buffer in order to say that
 * the `queue` is `unsaturated`.
 * @property {Function} empty - a callback that is called when the last item
 * from the `queue` is given to a `worker`.
 * @property {Function} drain - a callback that is called when the last item
 * from the `queue` has returned from the `worker`.
 * @property {Function} error - a callback that is called when a task errors.
 * Has the signature `function(error, task)`.
 * @property {boolean} paused - a boolean for determining whether the queue is
 * in a paused state.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke with `queue.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. No more tasks
 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
 */

/**
 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
 * `queue` are processed in parallel (up to the `concurrency` limit). If all
 * `worker`s are in progress, the task is queued until one becomes available.
 * Once a `worker` completes a `task`, that `task`'s callback is called.
 *
 * @name queue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`. Invoked with (task, callback).
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the queue.
 * @example
 *
 * // create a queue object with concurrency 2
 * var q = async.queue(function(task, callback) {
 *     console.log('hello ' + task.name);
 *     callback();
 * }, 2);
 *
 * // assign a callback
 * q.drain = function() {
 *     console.log('all items have been processed');
 * };
 *
 * // add some items to the queue
 * q.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * q.push({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 *
 * // add some items to the queue (batch-wise)
 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
 *     console.log('finished processing item');
 * });
 *
 * // add some items to the front of the queue
 * q.unshift({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 */
var queue$1 = function (worker, concurrency) {
    var _worker = wrapAsync(worker);
    return queue(function (items, cb) {
        _worker(items[0], cb);
    }, concurrency, 1);
};

/**
 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
 * completed in ascending priority order.
 *
 * @name priorityQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`.
 * Invoked with (task, callback).
 * @param {number} concurrency - An `integer` for determining how many `worker`
 * functions should be run in parallel.  If omitted, the concurrency defaults to
 * `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
 * differences between `queue` and `priorityQueue` objects:
 * * `push(task, priority, [callback])` - `priority` should be a number. If an
 *   array of `tasks` is given, all tasks will be assigned the same priority.
 * * The `unshift` method was removed.
 */
var priorityQueue = function(worker, concurrency) {
    // Start with a normal queue
    var q = queue$1(worker, concurrency);

    // Override push to accept second parameter representing priority
    q.push = function(data, priority, callback) {
        if (callback == null) callback = noop;
        if (typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;
        if (!isArray(data)) {
            data = [data];
        }
        if (data.length === 0) {
            // call drain immediately if there are no tasks
            return setImmediate$1(function() {
                q.drain();
            });
        }

        priority = priority || 0;
        var nextNode = q._tasks.head;
        while (nextNode && priority >= nextNode.priority) {
            nextNode = nextNode.next;
        }

        for (var i = 0, l = data.length; i < l; i++) {
            var item = {
                data: data[i],
                priority: priority,
                callback: callback
            };

            if (nextNode) {
                q._tasks.insertBefore(nextNode, item);
            } else {
                q._tasks.push(item);
            }
        }
        setImmediate$1(q.process);
    };

    // Remove unshift function
    delete q.unshift;

    return q;
};

/**
 * Runs the `tasks` array of functions in parallel, without waiting until the
 * previous function has completed. Once any of the `tasks` complete or pass an
 * error to its callback, the main `callback` is immediately called. It's
 * equivalent to `Promise.race()`.
 *
 * @name race
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
 * to run. Each function can complete with an optional `result` value.
 * @param {Function} callback - A callback to run once any of the functions have
 * completed. This function gets an error or result from the first function that
 * completed. Invoked with (err, result).
 * @returns undefined
 * @example
 *
 * async.race([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // main callback
 * function(err, result) {
 *     // the result will be equal to 'two' as it finishes earlier
 * });
 */
function race(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
    if (!tasks.length) return callback();
    for (var i = 0, l = tasks.length; i < l; i++) {
        wrapAsync(tasks[i])(callback);
    }
}

/**
 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
 *
 * @name reduceRight
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reduce]{@link module:Collections.reduce}
 * @alias foldr
 * @category Collection
 * @param {Array} array - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee complete with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 */
function reduceRight (array, memo, iteratee, callback) {
    var reversed = slice(array).reverse();
    reduce(reversed, memo, iteratee, callback);
}

/**
 * Wraps the async function in another function that always completes with a
 * result object, even when it errors.
 *
 * The result object has either the property `error` or `value`.
 *
 * @name reflect
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function you want to wrap
 * @returns {Function} - A function that always passes null to it's callback as
 * the error. The second argument to the callback will be an `object` with
 * either an `error` or a `value` property.
 * @example
 *
 * async.parallel([
 *     async.reflect(function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff but error ...
 *         callback('bad stuff happened');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     })
 * ],
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = 'bad stuff happened'
 *     // results[2].value = 'two'
 * });
 */
function reflect(fn) {
    var _fn = wrapAsync(fn);
    return initialParams(function reflectOn(args, reflectCallback) {
        args.push(function callback(error, cbArg) {
            if (error) {
                reflectCallback(null, { error: error });
            } else {
                var value;
                if (arguments.length <= 2) {
                    value = cbArg;
                } else {
                    value = slice(arguments, 1);
                }
                reflectCallback(null, { value: value });
            }
        });

        return _fn.apply(this, args);
    });
}

/**
 * A helper function that wraps an array or an object of functions with `reflect`.
 *
 * @name reflectAll
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.reflect]{@link module:Utils.reflect}
 * @category Util
 * @param {Array|Object|Iterable} tasks - The collection of
 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
 * @returns {Array} Returns an array of async functions, each wrapped in
 * `async.reflect`
 * @example
 *
 * let tasks = [
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         // do some more stuff but error ...
 *         callback(new Error('bad stuff happened'));
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ];
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = Error('bad stuff happened')
 *     // results[2].value = 'two'
 * });
 *
 * // an example using an object instead of an array
 * let tasks = {
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         callback('two');
 *     },
 *     three: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'three');
 *         }, 100);
 *     }
 * };
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results.one.value = 'one'
 *     // results.two.error = 'two'
 *     // results.three.value = 'three'
 * });
 */
function reflectAll(tasks) {
    var results;
    if (isArray(tasks)) {
        results = arrayMap(tasks, reflect);
    } else {
        results = {};
        baseForOwn(tasks, function(task, key) {
            results[key] = reflect.call(this, task);
        });
    }
    return results;
}

function reject$1(eachfn, arr, iteratee, callback) {
    _filter(eachfn, arr, function(value, cb) {
        iteratee(value, function(err, v) {
            cb(err, !v);
        });
    }, callback);
}

/**
 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
 *
 * @name reject
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @example
 *
 * async.reject(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, results) {
 *     // results now equals an array of missing files
 *     createFiles(results);
 * });
 */
var reject = doParallel(reject$1);

/**
 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name rejectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var rejectLimit = doParallelLimit(reject$1);

/**
 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
 *
 * @name rejectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var rejectSeries = doLimit(rejectLimit, 1);

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function() {
    return value;
  };
}

/**
 * Attempts to get a successful response from `task` no more than `times` times
 * before returning an error. If the task is successful, the `callback` will be
 * passed the result of the successful task. If all attempts fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name retry
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @see [async.retryable]{@link module:ControlFlow.retryable}
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
 * object with `times` and `interval` or a number.
 * * `times` - The number of attempts to make before giving up.  The default
 *   is `5`.
 * * `interval` - The time to wait between retries, in milliseconds.  The
 *   default is `0`. The interval may also be specified as a function of the
 *   retry count (see example).
 * * `errorFilter` - An optional synchronous function that is invoked on
 *   erroneous result. If it returns `true` the retry attempts will continue;
 *   if the function returns `false` the retry flow is aborted with the current
 *   attempt's error and result being returned to the final callback.
 *   Invoked with (err).
 * * If `opts` is a number, the number specifies the number of times to retry,
 *   with the default interval of `0`.
 * @param {AsyncFunction} task - An async function to retry.
 * Invoked with (callback).
 * @param {Function} [callback] - An optional callback which is called when the
 * task has succeeded, or after the final failed attempt. It receives the `err`
 * and `result` arguments of the last attempt at completing the `task`. Invoked
 * with (err, results).
 *
 * @example
 *
 * // The `retry` function can be used as a stand-alone control flow by passing
 * // a callback, as shown below:
 *
 * // try calling apiMethod 3 times
 * async.retry(3, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 3 times, waiting 200 ms between each retry
 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 10 times with exponential backoff
 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
 * async.retry({
 *   times: 10,
 *   interval: function(retryCount) {
 *     return 50 * Math.pow(2, retryCount);
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod the default 5 times no delay between each retry
 * async.retry(apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod only when error condition satisfies, all other
 * // errors will abort the retry control flow and return to final callback
 * async.retry({
 *   errorFilter: function(err) {
 *     return err.message === 'Temporary error'; // only retry on a specific error
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // to retry individual methods that are not as reliable within other
 * // control flow functions, use the `retryable` wrapper:
 * async.auto({
 *     users: api.getUsers.bind(api),
 *     payments: async.retryable(3, api.getPayments.bind(api))
 * }, function(err, results) {
 *     // do something with the results
 * });
 *
 */
function retry(opts, task, callback) {
    var DEFAULT_TIMES = 5;
    var DEFAULT_INTERVAL = 0;

    var options = {
        times: DEFAULT_TIMES,
        intervalFunc: constant$1(DEFAULT_INTERVAL)
    };

    function parseTimes(acc, t) {
        if (typeof t === 'object') {
            acc.times = +t.times || DEFAULT_TIMES;

            acc.intervalFunc = typeof t.interval === 'function' ?
                t.interval :
                constant$1(+t.interval || DEFAULT_INTERVAL);

            acc.errorFilter = t.errorFilter;
        } else if (typeof t === 'number' || typeof t === 'string') {
            acc.times = +t || DEFAULT_TIMES;
        } else {
            throw new Error("Invalid arguments for async.retry");
        }
    }

    if (arguments.length < 3 && typeof opts === 'function') {
        callback = task || noop;
        task = opts;
    } else {
        parseTimes(options, opts);
        callback = callback || noop;
    }

    if (typeof task !== 'function') {
        throw new Error("Invalid arguments for async.retry");
    }

    var _task = wrapAsync(task);

    var attempt = 1;
    function retryAttempt() {
        _task(function(err) {
            if (err && attempt++ < options.times &&
                (typeof options.errorFilter != 'function' ||
                    options.errorFilter(err))) {
                setTimeout(retryAttempt, options.intervalFunc(attempt));
            } else {
                callback.apply(null, arguments);
            }
        });
    }

    retryAttempt();
}

/**
 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
 * wraps a task and makes it retryable, rather than immediately calling it
 * with retries.
 *
 * @name retryable
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.retry]{@link module:ControlFlow.retry}
 * @category Control Flow
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
 * options, exactly the same as from `retry`
 * @param {AsyncFunction} task - the asynchronous function to wrap.
 * This function will be passed any arguments passed to the returned wrapper.
 * Invoked with (...args, callback).
 * @returns {AsyncFunction} The wrapped function, which when invoked, will
 * retry on an error, based on the parameters specified in `opts`.
 * This function will accept the same parameters as `task`.
 * @example
 *
 * async.auto({
 *     dep1: async.retryable(3, getFromFlakyService),
 *     process: ["dep1", async.retryable(3, function (results, cb) {
 *         maybeProcessData(results.dep1, cb);
 *     })]
 * }, callback);
 */
var retryable = function (opts, task) {
    if (!task) {
        task = opts;
        opts = null;
    }
    var _task = wrapAsync(task);
    return initialParams(function (args, callback) {
        function taskFn(cb) {
            _task.apply(null, args.concat(cb));
        }

        if (opts) retry(opts, taskFn, callback);
        else retry(taskFn, callback);

    });
};

/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @example
 * async.series([
 *     function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     },
 *     function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // results is now equal to ['one', 'two']
 * });
 *
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback){
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equal to: {one: 1, two: 2}
 * });
 */
function series(tasks, callback) {
    _parallel(eachOfSeries, tasks, callback);
}

/**
 * Returns `true` if at least one element in the `coll` satisfies an async test.
 * If any iteratee call returns `true`, the main `callback` is immediately
 * called.
 *
 * @name some
 * @static
 * @memberOf module:Collections
 * @method
 * @alias any
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @example
 *
 * async.some(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // if result is true then at least one of the files exists
 * });
 */
var some = doParallel(_createTester(Boolean, identity));

/**
 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
 *
 * @name someLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anyLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 */
var someLimit = doParallelLimit(_createTester(Boolean, identity));

/**
 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
 *
 * @name someSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anySeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in series.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 */
var someSeries = doLimit(someLimit, 1);

/**
 * Sorts a list by the results of running each `coll` value through an async
 * `iteratee`.
 *
 * @name sortBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a value to use as the sort criteria as
 * its `result`.
 * Invoked with (item, callback).
 * @param {Function} callback - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is the items
 * from the original `coll` sorted by the values returned by the `iteratee`
 * calls. Invoked with (err, results).
 * @example
 *
 * async.sortBy(['file1','file2','file3'], function(file, callback) {
 *     fs.stat(file, function(err, stats) {
 *         callback(err, stats.mtime);
 *     });
 * }, function(err, results) {
 *     // results is now the original array of files sorted by
 *     // modified date
 * });
 *
 * // By modifying the callback parameter the
 * // sorting order can be influenced:
 *
 * // ascending order
 * async.sortBy([1,9,3,5], function(x, callback) {
 *     callback(null, x);
 * }, function(err,result) {
 *     // result callback
 * });
 *
 * // descending order
 * async.sortBy([1,9,3,5], function(x, callback) {
 *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
 * }, function(err,result) {
 *     // result callback
 * });
 */
function sortBy (coll, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    map(coll, function (x, callback) {
        _iteratee(x, function (err, criteria) {
            if (err) return callback(err);
            callback(null, {value: x, criteria: criteria});
        });
    }, function (err, results) {
        if (err) return callback(err);
        callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
    });

    function comparator(left, right) {
        var a = left.criteria, b = right.criteria;
        return a < b ? -1 : a > b ? 1 : 0;
    }
}

/**
 * Sets a time limit on an asynchronous function. If the function does not call
 * its callback within the specified milliseconds, it will be called with a
 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
 *
 * @name timeout
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} asyncFn - The async function to limit in time.
 * @param {number} milliseconds - The specified time limit.
 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
 * to timeout Error for more information..
 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
 * of the control flow functions.
 * Invoke this function with the same parameters as you would `asyncFunc`.
 * @example
 *
 * function myFunction(foo, callback) {
 *     doAsyncTask(foo, function(err, data) {
 *         // handle errors
 *         if (err) return callback(err);
 *
 *         // do some stuff ...
 *
 *         // return processed data
 *         return callback(null, data);
 *     });
 * }
 *
 * var wrapped = async.timeout(myFunction, 1000);
 *
 * // call `wrapped` as you would `myFunction`
 * wrapped({ bar: 'bar' }, function(err, data) {
 *     // if `myFunction` takes < 1000 ms to execute, `err`
 *     // and `data` will have their expected values
 *
 *     // else `err` will be an Error with the code 'ETIMEDOUT'
 * });
 */
function timeout(asyncFn, milliseconds, info) {
    var fn = wrapAsync(asyncFn);

    return initialParams(function (args, callback) {
        var timedOut = false;
        var timer;

        function timeoutCallback() {
            var name = asyncFn.name || 'anonymous';
            var error  = new Error('Callback function "' + name + '" timed out.');
            error.code = 'ETIMEDOUT';
            if (info) {
                error.info = info;
            }
            timedOut = true;
            callback(error);
        }

        args.push(function () {
            if (!timedOut) {
                callback.apply(null, arguments);
                clearTimeout(timer);
            }
        });

        // setup timer and call original function
        timer = setTimeout(timeoutCallback, milliseconds);
        fn.apply(null, args);
    });
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;
var nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name timesLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} count - The number of times to run the function.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
 */
function timeLimit(count, limit, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    mapLimit(baseRange(0, count, 1), limit, _iteratee, callback);
}

/**
 * Calls the `iteratee` function `n` times, and accumulates results in the same
 * manner you would use with [map]{@link module:Collections.map}.
 *
 * @name times
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @example
 *
 * // Pretend this is some complicated async factory
 * var createUser = function(id, callback) {
 *     callback(null, {
 *         id: 'user' + id
 *     });
 * };
 *
 * // generate 5 users
 * async.times(5, function(n, next) {
 *     createUser(n, function(err, user) {
 *         next(err, user);
 *     });
 * }, function(err, users) {
 *     // we should now have 5 users
 * });
 */
var times = doLimit(timeLimit, Infinity);

/**
 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
 *
 * @name timesSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 */
var timesSeries = doLimit(timeLimit, 1);

/**
 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
 * element in series, each step potentially mutating an `accumulator` value.
 * The type of the accumulator defaults to the type of collection passed in.
 *
 * @name transform
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
 * it will default to an empty Object or Array, depending on the type of `coll`
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * collection that potentially modifies the accumulator.
 * Invoked with (accumulator, item, key, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the transformed accumulator.
 * Invoked with (err, result).
 * @example
 *
 * async.transform([1,2,3], function(acc, item, index, callback) {
 *     // pointless async:
 *     process.nextTick(function() {
 *         acc.push(item * 2)
 *         callback(null)
 *     });
 * }, function(err, result) {
 *     // result is now equal to [2, 4, 6]
 * });
 *
 * @example
 *
 * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
 *     setImmediate(function () {
 *         obj[key] = val * 2;
 *         callback();
 *     })
 * }, function (err, result) {
 *     // result is equal to {a: 2, b: 4, c: 6}
 * })
 */
function transform (coll, accumulator, iteratee, callback) {
    if (arguments.length <= 3) {
        callback = iteratee;
        iteratee = accumulator;
        accumulator = isArray(coll) ? [] : {};
    }
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);

    eachOf(coll, function(v, k, cb) {
        _iteratee(accumulator, v, k, cb);
    }, function(err) {
        callback(err, accumulator);
    });
}

/**
 * It runs each task in series but stops whenever any of the functions were
 * successful. If one of the tasks were successful, the `callback` will be
 * passed the result of the successful task. If all tasks fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name tryEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection containing functions to
 * run, each function is passed a `callback(err, result)` it must call on
 * completion with an error `err` (which can be `null`) and an optional `result`
 * value.
 * @param {Function} [callback] - An optional callback which is called when one
 * of the tasks has succeeded, or all have failed. It receives the `err` and
 * `result` arguments of the last attempt at completing the `task`. Invoked with
 * (err, results).
 * @example
 * async.tryEach([
 *     function getDataFromFirstWebsite(callback) {
 *         // Try getting the data from the first website
 *         callback(err, data);
 *     },
 *     function getDataFromSecondWebsite(callback) {
 *         // First website failed,
 *         // Try getting the data from the backup website
 *         callback(err, data);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     Now do something with the data.
 * });
 *
 */
function tryEach(tasks, callback) {
    var error = null;
    var result;
    callback = callback || noop;
    eachSeries(tasks, function(task, callback) {
        wrapAsync(task)(function (err, res/*, ...args*/) {
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            } else {
                result = res;
            }
            error = err;
            callback(!err);
        });
    }, function () {
        callback(error, result);
    });
}

/**
 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
 * unmemoized form. Handy for testing.
 *
 * @name unmemoize
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.memoize]{@link module:Utils.memoize}
 * @category Util
 * @param {AsyncFunction} fn - the memoized function
 * @returns {AsyncFunction} a function that calls the original unmemoized function
 */
function unmemoize(fn) {
    return function () {
        return (fn.unmemoized || fn).apply(null, arguments);
    };
}

/**
 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs.
 *
 * @name whilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Function} test - synchronous truth test to perform before each
 * execution of `iteratee`. Invoked with ().
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns undefined
 * @example
 *
 * var count = 0;
 * async.whilst(
 *     function() { return count < 5; },
 *     function(callback) {
 *         count++;
 *         setTimeout(function() {
 *             callback(null, count);
 *         }, 1000);
 *     },
 *     function (err, n) {
 *         // 5 seconds have passed, n = 5
 *     }
 * );
 */
function whilst(test, iteratee, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    if (!test()) return callback(null);
    var next = function(err/*, ...args*/) {
        if (err) return callback(err);
        if (test()) return _iteratee(next);
        var args = slice(arguments, 1);
        callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
}

/**
 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs. `callback` will be passed an error and any
 * arguments passed to the final `iteratee`'s callback.
 *
 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
 *
 * @name until
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {Function} test - synchronous truth test to perform before each
 * execution of `iteratee`. Invoked with ().
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 */
function until(test, iteratee, callback) {
    whilst(function() {
        return !test.apply(this, arguments);
    }, iteratee, callback);
}

/**
 * Runs the `tasks` array of functions in series, each passing their results to
 * the next in the array. However, if any of the `tasks` pass an error to their
 * own callback, the next function is not executed, and the main `callback` is
 * immediately called with the error.
 *
 * @name waterfall
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
 * to run.
 * Each function should complete with any number of `result` values.
 * The `result` values will be passed as arguments, in order, to the next task.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This will be passed the results of the last task's
 * callback. Invoked with (err, [results]).
 * @returns undefined
 * @example
 *
 * async.waterfall([
 *     function(callback) {
 *         callback(null, 'one', 'two');
 *     },
 *     function(arg1, arg2, callback) {
 *         // arg1 now equals 'one' and arg2 now equals 'two'
 *         callback(null, 'three');
 *     },
 *     function(arg1, callback) {
 *         // arg1 now equals 'three'
 *         callback(null, 'done');
 *     }
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 *
 * // Or, with named functions:
 * async.waterfall([
 *     myFirstFunction,
 *     mySecondFunction,
 *     myLastFunction,
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 * function myFirstFunction(callback) {
 *     callback(null, 'one', 'two');
 * }
 * function mySecondFunction(arg1, arg2, callback) {
 *     // arg1 now equals 'one' and arg2 now equals 'two'
 *     callback(null, 'three');
 * }
 * function myLastFunction(arg1, callback) {
 *     // arg1 now equals 'three'
 *     callback(null, 'done');
 * }
 */
var waterfall = function(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return callback();
    var taskIndex = 0;

    function nextTask(args) {
        var task = wrapAsync(tasks[taskIndex++]);
        args.push(onlyOnce(next));
        task.apply(null, args);
    }

    function next(err/*, ...args*/) {
        if (err || taskIndex === tasks.length) {
            return callback.apply(null, arguments);
        }
        nextTask(slice(arguments, 1));
    }

    nextTask([]);
};

/**
 * An "async function" in the context of Async is an asynchronous function with
 * a variable number of parameters, with the final parameter being a callback.
 * (`function (arg1, arg2, ..., callback) {}`)
 * The final callback is of the form `callback(err, results...)`, which must be
 * called once the function is completed.  The callback should be called with a
 * Error as its first argument to signal that an error occurred.
 * Otherwise, if no error occurred, it should be called with `null` as the first
 * argument, and any additional `result` arguments that may apply, to signal
 * successful completion.
 * The callback must be called exactly once, ideally on a later tick of the
 * JavaScript event loop.
 *
 * This type of function is also referred to as a "Node-style async function",
 * or a "continuation passing-style function" (CPS). Most of the methods of this
 * library are themselves CPS/Node-style async functions, or functions that
 * return CPS/Node-style async functions.
 *
 * Wherever we accept a Node-style async function, we also directly accept an
 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
 * In this case, the `async` function will not be passed a final callback
 * argument, and any thrown error will be used as the `err` argument of the
 * implicit callback, and the return value will be used as the `result` value.
 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
 * argument, and a `resolved` value becomes the `result`.)
 *
 * Note, due to JavaScript limitations, we can only detect native `async`
 * functions and not transpilied implementations.
 * Your environment must have `async`/`await` support for this to work.
 * (e.g. Node > v7.6, or a recent version of a modern browser).
 * If you are using `async` functions through a transpiler (e.g. Babel), you
 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
 * because the `async function` will be compiled to an ordinary function that
 * returns a promise.
 *
 * @typedef {Function} AsyncFunction
 * @static
 */

/**
 * Async is a utility module which provides straight-forward, powerful functions
 * for working with asynchronous JavaScript. Although originally designed for
 * use with [Node.js](http://nodejs.org) and installable via
 * `npm install --save async`, it can also be used directly in the browser.
 * @module async
 * @see AsyncFunction
 */


/**
 * A collection of `async` functions for manipulating collections, such as
 * arrays and objects.
 * @module Collections
 */

/**
 * A collection of `async` functions for controlling the flow through a script.
 * @module ControlFlow
 */

/**
 * A collection of `async` utility functions.
 * @module Utils
 */

var index = {
    apply: apply,
    applyEach: applyEach,
    applyEachSeries: applyEachSeries,
    asyncify: asyncify,
    auto: auto,
    autoInject: autoInject,
    cargo: cargo,
    compose: compose,
    concat: concat,
    concatLimit: concatLimit,
    concatSeries: concatSeries,
    constant: constant,
    detect: detect,
    detectLimit: detectLimit,
    detectSeries: detectSeries,
    dir: dir,
    doDuring: doDuring,
    doUntil: doUntil,
    doWhilst: doWhilst,
    during: during,
    each: eachLimit,
    eachLimit: eachLimit$1,
    eachOf: eachOf,
    eachOfLimit: eachOfLimit,
    eachOfSeries: eachOfSeries,
    eachSeries: eachSeries,
    ensureAsync: ensureAsync,
    every: every,
    everyLimit: everyLimit,
    everySeries: everySeries,
    filter: filter,
    filterLimit: filterLimit,
    filterSeries: filterSeries,
    forever: forever,
    groupBy: groupBy,
    groupByLimit: groupByLimit,
    groupBySeries: groupBySeries,
    log: log,
    map: map,
    mapLimit: mapLimit,
    mapSeries: mapSeries,
    mapValues: mapValues,
    mapValuesLimit: mapValuesLimit,
    mapValuesSeries: mapValuesSeries,
    memoize: memoize,
    nextTick: nextTick,
    parallel: parallelLimit,
    parallelLimit: parallelLimit$1,
    priorityQueue: priorityQueue,
    queue: queue$1,
    race: race,
    reduce: reduce,
    reduceRight: reduceRight,
    reflect: reflect,
    reflectAll: reflectAll,
    reject: reject,
    rejectLimit: rejectLimit,
    rejectSeries: rejectSeries,
    retry: retry,
    retryable: retryable,
    seq: seq,
    series: series,
    setImmediate: setImmediate$1,
    some: some,
    someLimit: someLimit,
    someSeries: someSeries,
    sortBy: sortBy,
    timeout: timeout,
    times: times,
    timesLimit: timeLimit,
    timesSeries: timesSeries,
    transform: transform,
    tryEach: tryEach,
    unmemoize: unmemoize,
    until: until,
    waterfall: waterfall,
    whilst: whilst,

    // aliases
    all: every,
    allLimit: everyLimit,
    allSeries: everySeries,
    any: some,
    anyLimit: someLimit,
    anySeries: someSeries,
    find: detect,
    findLimit: detectLimit,
    findSeries: detectSeries,
    forEach: eachLimit,
    forEachSeries: eachSeries,
    forEachLimit: eachLimit$1,
    forEachOf: eachOf,
    forEachOfSeries: eachOfSeries,
    forEachOfLimit: eachOfLimit,
    inject: reduce,
    foldl: reduce,
    foldr: reduceRight,
    select: filter,
    selectLimit: filterLimit,
    selectSeries: filterSeries,
    wrapSync: asyncify
};

exports['default'] = index;
exports.apply = apply;
exports.applyEach = applyEach;
exports.applyEachSeries = applyEachSeries;
exports.asyncify = asyncify;
exports.auto = auto;
exports.autoInject = autoInject;
exports.cargo = cargo;
exports.compose = compose;
exports.concat = concat;
exports.concatLimit = concatLimit;
exports.concatSeries = concatSeries;
exports.constant = constant;
exports.detect = detect;
exports.detectLimit = detectLimit;
exports.detectSeries = detectSeries;
exports.dir = dir;
exports.doDuring = doDuring;
exports.doUntil = doUntil;
exports.doWhilst = doWhilst;
exports.during = during;
exports.each = eachLimit;
exports.eachLimit = eachLimit$1;
exports.eachOf = eachOf;
exports.eachOfLimit = eachOfLimit;
exports.eachOfSeries = eachOfSeries;
exports.eachSeries = eachSeries;
exports.ensureAsync = ensureAsync;
exports.every = every;
exports.everyLimit = everyLimit;
exports.everySeries = everySeries;
exports.filter = filter;
exports.filterLimit = filterLimit;
exports.filterSeries = filterSeries;
exports.forever = forever;
exports.groupBy = groupBy;
exports.groupByLimit = groupByLimit;
exports.groupBySeries = groupBySeries;
exports.log = log;
exports.map = map;
exports.mapLimit = mapLimit;
exports.mapSeries = mapSeries;
exports.mapValues = mapValues;
exports.mapValuesLimit = mapValuesLimit;
exports.mapValuesSeries = mapValuesSeries;
exports.memoize = memoize;
exports.nextTick = nextTick;
exports.parallel = parallelLimit;
exports.parallelLimit = parallelLimit$1;
exports.priorityQueue = priorityQueue;
exports.queue = queue$1;
exports.race = race;
exports.reduce = reduce;
exports.reduceRight = reduceRight;
exports.reflect = reflect;
exports.reflectAll = reflectAll;
exports.reject = reject;
exports.rejectLimit = rejectLimit;
exports.rejectSeries = rejectSeries;
exports.retry = retry;
exports.retryable = retryable;
exports.seq = seq;
exports.series = series;
exports.setImmediate = setImmediate$1;
exports.some = some;
exports.someLimit = someLimit;
exports.someSeries = someSeries;
exports.sortBy = sortBy;
exports.timeout = timeout;
exports.times = times;
exports.timesLimit = timeLimit;
exports.timesSeries = timesSeries;
exports.transform = transform;
exports.tryEach = tryEach;
exports.unmemoize = unmemoize;
exports.until = until;
exports.waterfall = waterfall;
exports.whilst = whilst;
exports.all = every;
exports.allLimit = everyLimit;
exports.allSeries = everySeries;
exports.any = some;
exports.anyLimit = someLimit;
exports.anySeries = someSeries;
exports.find = detect;
exports.findLimit = detectLimit;
exports.findSeries = detectSeries;
exports.forEach = eachLimit;
exports.forEachSeries = eachSeries;
exports.forEachLimit = eachLimit$1;
exports.forEachOf = eachOf;
exports.forEachOfSeries = eachOfSeries;
exports.forEachOfLimit = eachOfLimit;
exports.inject = reduce;
exports.foldl = reduce;
exports.foldr = reduceRight;
exports.select = filter;
exports.selectLimit = filterLimit;
exports.selectSeries = filterSeries;
exports.wrapSync = asyncify;

Object.defineProperty(exports, '__esModule', { value: true });

})));

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"_process":"/usr/var/server.base/node_modules/browserify/node_modules/process/browser.js","timers":"/usr/var/server.base/node_modules/browserify/node_modules/timers-browserify/main.js"}],"/usr/var/server.base/node_modules/bootstrap/dist/js/bootstrap.js":[function(require,module,exports){
/*!
 * Bootstrap v4.0.0-alpha.6 (https://getbootstrap.com)
 * Copyright 2011-2017 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.')
}

+function ($) {
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] >= 4)) {
    throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0')
  }
}(jQuery);


+function () {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Util = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */

  var transition = false;

  var MAX_UID = 1000000;

  var TransitionEndEvent = {
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'transitionend',
    OTransition: 'oTransitionEnd otransitionend',
    transition: 'transitionend'
  };

  // shoutout AngusCroll (https://goo.gl/pxwQGp)
  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  }

  function isElement(obj) {
    return (obj[0] || obj).nodeType;
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: transition.end,
      delegateType: transition.end,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
        return undefined;
      }
    };
  }

  function transitionEndTest() {
    if (window.QUnit) {
      return false;
    }

    var el = document.createElement('bootstrap');

    for (var name in TransitionEndEvent) {
      if (el.style[name] !== undefined) {
        return {
          end: TransitionEndEvent[name]
        };
      }
    }

    return false;
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;

    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });

    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);

    return this;
  }

  function setTransitionEndSupport() {
    transition = transitionEndTest();

    $.fn.emulateTransitionEnd = transitionEndEmulator;

    if (Util.supportsTransitionEnd()) {
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
  }

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Util = {

    TRANSITION_END: 'bsTransitionEnd',

    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));
      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector) {
        selector = element.getAttribute('href') || '';
        selector = /^#[a-z]/i.test(selector) ? selector : null;
      }

      return selector;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(transition.end);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(transition);
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (configTypes.hasOwnProperty(property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
          }
        }
      }
    }
  };

  setTransitionEndSupport();

  return Util;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Alert = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'alert';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.alert';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Selector = {
    DISMISS: '[data-dismiss="alert"]'
  };

  var Event = {
    CLOSE: 'close' + EVENT_KEY,
    CLOSED: 'closed' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    ALERT: 'alert',
    FADE: 'fade',
    SHOW: 'show'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Alert = function () {
    function Alert(element) {
      _classCallCheck(this, Alert);

      this._element = element;
    }

    // getters

    // public

    Alert.prototype.close = function close(element) {
      element = element || this._element;

      var rootElement = this._getRootElement(element);
      var customEvent = this._triggerCloseEvent(rootElement);

      if (customEvent.isDefaultPrevented()) {
        return;
      }

      this._removeElement(rootElement);
    };

    Alert.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    };

    // private

    Alert.prototype._getRootElement = function _getRootElement(element) {
      var selector = Util.getSelectorFromElement(element);
      var parent = false;

      if (selector) {
        parent = $(selector)[0];
      }

      if (!parent) {
        parent = $(element).closest('.' + ClassName.ALERT)[0];
      }

      return parent;
    };

    Alert.prototype._triggerCloseEvent = function _triggerCloseEvent(element) {
      var closeEvent = $.Event(Event.CLOSE);

      $(element).trigger(closeEvent);
      return closeEvent;
    };

    Alert.prototype._removeElement = function _removeElement(element) {
      var _this2 = this;

      $(element).removeClass(ClassName.SHOW);

      if (!Util.supportsTransitionEnd() || !$(element).hasClass(ClassName.FADE)) {
        this._destroyElement(element);
        return;
      }

      $(element).one(Util.TRANSITION_END, function (event) {
        return _this2._destroyElement(element, event);
      }).emulateTransitionEnd(TRANSITION_DURATION);
    };

    Alert.prototype._destroyElement = function _destroyElement(element) {
      $(element).detach().trigger(Event.CLOSED).remove();
    };

    // static

    Alert._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $(this);
        var data = $element.data(DATA_KEY);

        if (!data) {
          data = new Alert(this);
          $element.data(DATA_KEY, data);
        }

        if (config === 'close') {
          data[config](this);
        }
      });
    };

    Alert._handleDismiss = function _handleDismiss(alertInstance) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        alertInstance.close(this);
      };
    };

    _createClass(Alert, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Alert;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Alert._jQueryInterface;
  $.fn[NAME].Constructor = Alert;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Alert._jQueryInterface;
  };

  return Alert;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Button = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'button';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.button';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var ClassName = {
    ACTIVE: 'active',
    BUTTON: 'btn',
    FOCUS: 'focus'
  };

  var Selector = {
    DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
    DATA_TOGGLE: '[data-toggle="buttons"]',
    INPUT: 'input',
    ACTIVE: '.active',
    BUTTON: '.btn'
  };

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUS_BLUR_DATA_API: 'focus' + EVENT_KEY + DATA_API_KEY + ' ' + ('blur' + EVENT_KEY + DATA_API_KEY)
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Button = function () {
    function Button(element) {
      _classCallCheck(this, Button);

      this._element = element;
    }

    // getters

    // public

    Button.prototype.toggle = function toggle() {
      var triggerChangeEvent = true;
      var rootElement = $(this._element).closest(Selector.DATA_TOGGLE)[0];

      if (rootElement) {
        var input = $(this._element).find(Selector.INPUT)[0];

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && $(this._element).hasClass(ClassName.ACTIVE)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = $(rootElement).find(Selector.ACTIVE)[0];

              if (activeElement) {
                $(activeElement).removeClass(ClassName.ACTIVE);
              }
            }
          }

          if (triggerChangeEvent) {
            input.checked = !$(this._element).hasClass(ClassName.ACTIVE);
            $(input).trigger('change');
          }

          input.focus();
        }
      }

      this._element.setAttribute('aria-pressed', !$(this._element).hasClass(ClassName.ACTIVE));

      if (triggerChangeEvent) {
        $(this._element).toggleClass(ClassName.ACTIVE);
      }
    };

    Button.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    };

    // static

    Button._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Button(this);
          $(this).data(DATA_KEY, data);
        }

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Button;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    event.preventDefault();

    var button = event.target;

    if (!$(button).hasClass(ClassName.BUTTON)) {
      button = $(button).closest(Selector.BUTTON);
    }

    Button._jQueryInterface.call($(button), 'toggle');
  }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
    var button = $(event.target).closest(Selector.BUTTON)[0];
    $(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Button._jQueryInterface;
  $.fn[NAME].Constructor = Button;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Button._jQueryInterface;
  };

  return Button;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Carousel = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'carousel';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.carousel';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;
  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

  var Default = {
    interval: 5000,
    keyboard: true,
    slide: false,
    pause: 'hover',
    wrap: true
  };

  var DefaultType = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    slide: '(boolean|string)',
    pause: '(string|boolean)',
    wrap: 'boolean'
  };

  var Direction = {
    NEXT: 'next',
    PREV: 'prev',
    LEFT: 'left',
    RIGHT: 'right'
  };

  var Event = {
    SLIDE: 'slide' + EVENT_KEY,
    SLID: 'slid' + EVENT_KEY,
    KEYDOWN: 'keydown' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY,
    LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    CAROUSEL: 'carousel',
    ACTIVE: 'active',
    SLIDE: 'slide',
    RIGHT: 'carousel-item-right',
    LEFT: 'carousel-item-left',
    NEXT: 'carousel-item-next',
    PREV: 'carousel-item-prev',
    ITEM: 'carousel-item'
  };

  var Selector = {
    ACTIVE: '.active',
    ACTIVE_ITEM: '.active.carousel-item',
    ITEM: '.carousel-item',
    NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
    INDICATORS: '.carousel-indicators',
    DATA_SLIDE: '[data-slide], [data-slide-to]',
    DATA_RIDE: '[data-ride="carousel"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Carousel = function () {
    function Carousel(element, config) {
      _classCallCheck(this, Carousel);

      this._items = null;
      this._interval = null;
      this._activeElement = null;

      this._isPaused = false;
      this._isSliding = false;

      this._config = this._getConfig(config);
      this._element = $(element)[0];
      this._indicatorsElement = $(this._element).find(Selector.INDICATORS)[0];

      this._addEventListeners();
    }

    // getters

    // public

    Carousel.prototype.next = function next() {
      if (this._isSliding) {
        throw new Error('Carousel is sliding');
      }
      this._slide(Direction.NEXT);
    };

    Carousel.prototype.nextWhenVisible = function nextWhenVisible() {
      // Don't call next when the page isn't visible
      if (!document.hidden) {
        this.next();
      }
    };

    Carousel.prototype.prev = function prev() {
      if (this._isSliding) {
        throw new Error('Carousel is sliding');
      }
      this._slide(Direction.PREVIOUS);
    };

    Carousel.prototype.pause = function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if ($(this._element).find(Selector.NEXT_PREV)[0] && Util.supportsTransitionEnd()) {
        Util.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    };

    Carousel.prototype.cycle = function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    };

    Carousel.prototype.to = function to(index) {
      var _this3 = this;

      this._activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        $(this._element).one(Event.SLID, function () {
          return _this3.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? Direction.NEXT : Direction.PREVIOUS;

      this._slide(direction, this._items[index]);
    };

    Carousel.prototype.dispose = function dispose() {
      $(this._element).off(EVENT_KEY);
      $.removeData(this._element, DATA_KEY);

      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    };

    // private

    Carousel.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Carousel.prototype._addEventListeners = function _addEventListeners() {
      var _this4 = this;

      if (this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN, function (event) {
          return _this4._keydown(event);
        });
      }

      if (this._config.pause === 'hover' && !('ontouchstart' in document.documentElement)) {
        $(this._element).on(Event.MOUSEENTER, function (event) {
          return _this4.pause(event);
        }).on(Event.MOUSELEAVE, function (event) {
          return _this4.cycle(event);
        });
      }
    };

    Carousel.prototype._keydown = function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;
        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;
        default:
          return;
      }
    };

    Carousel.prototype._getItemIndex = function _getItemIndex(element) {
      this._items = $.makeArray($(element).parent().find(Selector.ITEM));
      return this._items.indexOf(element);
    };

    Carousel.prototype._getItemByDirection = function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === Direction.NEXT;
      var isPrevDirection = direction === Direction.PREVIOUS;
      var activeIndex = this._getItemIndex(activeElement);
      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === Direction.PREVIOUS ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;

      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    };

    Carousel.prototype._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var slideEvent = $.Event(Event.SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName
      });

      $(this._element).trigger(slideEvent);

      return slideEvent;
    };

    Carousel.prototype._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        $(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          $(nextIndicator).addClass(ClassName.ACTIVE);
        }
      }
    };

    Carousel.prototype._slide = function _slide(direction, element) {
      var _this5 = this;

      var activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];
      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

      var isCycling = Boolean(this._interval);

      var directionalClassName = void 0;
      var orderClassName = void 0;
      var eventDirectionName = void 0;

      if (direction === Direction.NEXT) {
        directionalClassName = ClassName.LEFT;
        orderClassName = ClassName.NEXT;
        eventDirectionName = Direction.LEFT;
      } else {
        directionalClassName = ClassName.RIGHT;
        orderClassName = ClassName.PREV;
        eventDirectionName = Direction.RIGHT;
      }

      if (nextElement && $(nextElement).hasClass(ClassName.ACTIVE)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      var slidEvent = $.Event(Event.SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName
      });

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.SLIDE)) {

        $(nextElement).addClass(orderClassName);

        Util.reflow(nextElement);

        $(activeElement).addClass(directionalClassName);
        $(nextElement).addClass(directionalClassName);

        $(activeElement).one(Util.TRANSITION_END, function () {
          $(nextElement).removeClass(directionalClassName + ' ' + orderClassName).addClass(ClassName.ACTIVE);

          $(activeElement).removeClass(ClassName.ACTIVE + ' ' + orderClassName + ' ' + directionalClassName);

          _this5._isSliding = false;

          setTimeout(function () {
            return $(_this5._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        $(activeElement).removeClass(ClassName.ACTIVE);
        $(nextElement).addClass(ClassName.ACTIVE);

        this._isSliding = false;
        $(this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    };

    // static

    Carousel._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
          $.extend(_config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        } else if (_config.interval) {
          data.pause();
          data.cycle();
        }
      });
    };

    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
      var selector = Util.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = $(selector)[0];

      if (!target || !$(target).hasClass(ClassName.CAROUSEL)) {
        return;
      }

      var config = $.extend({}, $(target).data(), $(this).data());
      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call($(target), config);

      if (slideIndex) {
        $(target).data(DATA_KEY).to(slideIndex);
      }

      event.preventDefault();
    };

    _createClass(Carousel, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Carousel;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);

  $(window).on(Event.LOAD_DATA_API, function () {
    $(Selector.DATA_RIDE).each(function () {
      var $carousel = $(this);
      Carousel._jQueryInterface.call($carousel, $carousel.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Carousel._jQueryInterface;
  $.fn[NAME].Constructor = Carousel;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Carousel._jQueryInterface;
  };

  return Carousel;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Collapse = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'collapse';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.collapse';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;

  var Default = {
    toggle: true,
    parent: ''
  };

  var DefaultType = {
    toggle: 'boolean',
    parent: 'string'
  };

  var Event = {
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SHOW: 'show',
    COLLAPSE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed'
  };

  var Dimension = {
    WIDTH: 'width',
    HEIGHT: 'height'
  };

  var Selector = {
    ACTIVES: '.card > .show, .card > .collapsing',
    DATA_TOGGLE: '[data-toggle="collapse"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Collapse = function () {
    function Collapse(element, config) {
      _classCallCheck(this, Collapse);

      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    }

    // getters

    // public

    Collapse.prototype.toggle = function toggle() {
      if ($(this._element).hasClass(ClassName.SHOW)) {
        this.hide();
      } else {
        this.show();
      }
    };

    Collapse.prototype.show = function show() {
      var _this6 = this;

      if (this._isTransitioning) {
        throw new Error('Collapse is transitioning');
      }

      if ($(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var actives = void 0;
      var activesData = void 0;

      if (this._parent) {
        actives = $.makeArray($(this._parent).find(Selector.ACTIVES));
        if (!actives.length) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $(actives).data(DATA_KEY);
        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $.Event(Event.SHOW);
      $(this._element).trigger(startEvent);
      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($(actives), 'hide');
        if (!activesData) {
          $(actives).data(DATA_KEY, null);
        }
      }

      var dimension = this._getDimension();

      $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);

      this._element.style[dimension] = 0;
      this._element.setAttribute('aria-expanded', true);

      if (this._triggerArray.length) {
        $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $(_this6._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);

        _this6._element.style[dimension] = '';

        _this6.setTransitioning(false);

        $(_this6._element).trigger(Event.SHOWN);
      };

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = 'scroll' + capitalizedDimension;

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);

      this._element.style[dimension] = this._element[scrollSize] + 'px';
    };

    Collapse.prototype.hide = function hide() {
      var _this7 = this;

      if (this._isTransitioning) {
        throw new Error('Collapse is transitioning');
      }

      if (!$(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var startEvent = $.Event(Event.HIDE);
      $(this._element).trigger(startEvent);
      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();
      var offsetDimension = dimension === Dimension.WIDTH ? 'offsetWidth' : 'offsetHeight';

      this._element.style[dimension] = this._element[offsetDimension] + 'px';

      Util.reflow(this._element);

      $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

      this._element.setAttribute('aria-expanded', false);

      if (this._triggerArray.length) {
        $(this._triggerArray).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this7.setTransitioning(false);
        $(_this7._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
      };

      this._element.style[dimension] = '';

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
    };

    Collapse.prototype.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    Collapse.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);

      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    };

    // private

    Collapse.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      config.toggle = Boolean(config.toggle); // coerce string values
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Collapse.prototype._getDimension = function _getDimension() {
      var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
    };

    Collapse.prototype._getParent = function _getParent() {
      var _this8 = this;

      var parent = $(this._config.parent)[0];
      var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';

      $(parent).find(selector).each(function (i, element) {
        _this8._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });

      return parent;
    };

    Collapse.prototype._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      if (element) {
        var isOpen = $(element).hasClass(ClassName.SHOW);
        element.setAttribute('aria-expanded', isOpen);

        if (triggerArray.length) {
          $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
        }
      }
    };

    // static

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? $(selector)[0] : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY);
        var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

        if (!data && _config.toggle && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $this.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Collapse;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();

    var target = Collapse._getTargetFromElement(this);
    var data = $(target).data(DATA_KEY);
    var config = data ? 'toggle' : $(this).data();

    Collapse._jQueryInterface.call($(target), config);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Collapse._jQueryInterface;
  $.fn[NAME].Constructor = Collapse;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Collapse._jQueryInterface;
  };

  return Collapse;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Dropdown = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'dropdown';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.dropdown';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    FOCUSIN_DATA_API: 'focusin' + EVENT_KEY + DATA_API_KEY,
    KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    BACKDROP: 'dropdown-backdrop',
    DISABLED: 'disabled',
    SHOW: 'show'
  };

  var Selector = {
    BACKDROP: '.dropdown-backdrop',
    DATA_TOGGLE: '[data-toggle="dropdown"]',
    FORM_CHILD: '.dropdown form',
    ROLE_MENU: '[role="menu"]',
    ROLE_LISTBOX: '[role="listbox"]',
    NAVBAR_NAV: '.navbar-nav',
    VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, ' + '[role="listbox"] li:not(.disabled) a'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Dropdown = function () {
    function Dropdown(element) {
      _classCallCheck(this, Dropdown);

      this._element = element;

      this._addEventListeners();
    }

    // getters

    // public

    Dropdown.prototype.toggle = function toggle() {
      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return false;
      }

      var parent = Dropdown._getParentFromElement(this);
      var isActive = $(parent).hasClass(ClassName.SHOW);

      Dropdown._clearMenus();

      if (isActive) {
        return false;
      }

      if ('ontouchstart' in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {

        // if mobile we use a backdrop because click events don't delegate
        var dropdown = document.createElement('div');
        dropdown.className = ClassName.BACKDROP;
        $(dropdown).insertBefore(this);
        $(dropdown).on('click', Dropdown._clearMenus);
      }

      var relatedTarget = {
        relatedTarget: this
      };
      var showEvent = $.Event(Event.SHOW, relatedTarget);

      $(parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return false;
      }

      this.focus();
      this.setAttribute('aria-expanded', true);

      $(parent).toggleClass(ClassName.SHOW);
      $(parent).trigger($.Event(Event.SHOWN, relatedTarget));

      return false;
    };

    Dropdown.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._element).off(EVENT_KEY);
      this._element = null;
    };

    // private

    Dropdown.prototype._addEventListeners = function _addEventListeners() {
      $(this._element).on(Event.CLICK, this.toggle);
    };

    // static

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Dropdown(this);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config].call(this);
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) {
        return;
      }

      var backdrop = $(Selector.BACKDROP)[0];
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }

      var toggles = $.makeArray($(Selector.DATA_TOGGLE));

      for (var i = 0; i < toggles.length; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (!$(parent).hasClass(ClassName.SHOW)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'focusin') && $.contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $.Event(Event.HIDE, relatedTarget);
        $(parent).trigger(hideEvent);
        if (hideEvent.isDefaultPrevented()) {
          continue;
        }

        toggles[i].setAttribute('aria-expanded', 'false');

        $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent = void 0;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = $(selector)[0];
      }

      return parent || element.parentNode;
    };

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      if (!/(38|40|27|32)/.test(event.which) || /input|textarea/i.test(event.target.tagName)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);
      var isActive = $(parent).hasClass(ClassName.SHOW);

      if (!isActive && event.which !== ESCAPE_KEYCODE || isActive && event.which === ESCAPE_KEYCODE) {

        if (event.which === ESCAPE_KEYCODE) {
          var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
          $(toggle).trigger('focus');
        }

        $(this).trigger('click');
        return;
      }

      var items = $(parent).find(Selector.VISIBLE_ITEMS).get();

      if (!items.length) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Dropdown;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_MENU, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_LISTBOX, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + ' ' + Event.FOCUSIN_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, Dropdown.prototype.toggle).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
    e.stopPropagation();
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Dropdown._jQueryInterface;
  $.fn[NAME].Constructor = Dropdown;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Dropdown._jQueryInterface;
  };

  return Dropdown;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Modal = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'modal';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.modal';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 300;
  var BACKDROP_TRANSITION_DURATION = 150;
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var Default = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };

  var DefaultType = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    RESIZE: 'resize' + EVENT_KEY,
    CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
    KEYDOWN_DISMISS: 'keydown.dismiss' + EVENT_KEY,
    MOUSEUP_DISMISS: 'mouseup.dismiss' + EVENT_KEY,
    MOUSEDOWN_DISMISS: 'mousedown.dismiss' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Modal = function () {
    function Modal(element, config) {
      _classCallCheck(this, Modal);

      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = $(element).find(Selector.DIALOG)[0];
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._originalBodyPadding = 0;
      this._scrollbarWidth = 0;
    }

    // getters

    // public

    Modal.prototype.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    Modal.prototype.show = function show(relatedTarget) {
      var _this9 = this;

      if (this._isTransitioning) {
        throw new Error('Modal is transitioning');
      }

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
      }
      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: relatedTarget
      });

      $(this._element).trigger(showEvent);

      if (this._isShown || showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      this._checkScrollbar();
      this._setScrollbar();

      $(document.body).addClass(ClassName.OPEN);

      this._setEscapeEvent();
      this._setResizeEvent();

      $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
        return _this9.hide(event);
      });

      $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
        $(_this9._element).one(Event.MOUSEUP_DISMISS, function (event) {
          if ($(event.target).is(_this9._element)) {
            _this9._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this9._showElement(relatedTarget);
      });
    };

    Modal.prototype.hide = function hide(event) {
      var _this10 = this;

      if (event) {
        event.preventDefault();
      }

      if (this._isTransitioning) {
        throw new Error('Modal is transitioning');
      }

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
      if (transition) {
        this._isTransitioning = true;
      }

      var hideEvent = $.Event(Event.HIDE);
      $(this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;

      this._setEscapeEvent();
      this._setResizeEvent();

      $(document).off(Event.FOCUSIN);

      $(this._element).removeClass(ClassName.SHOW);

      $(this._element).off(Event.CLICK_DISMISS);
      $(this._dialog).off(Event.MOUSEDOWN_DISMISS);

      if (transition) {
        $(this._element).one(Util.TRANSITION_END, function (event) {
          return _this10._hideModal(event);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        this._hideModal();
      }
    };

    Modal.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);

      $(window, document, this._element, this._backdrop).off(EVENT_KEY);

      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._originalBodyPadding = null;
      this._scrollbarWidth = null;
    };

    // private

    Modal.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    Modal.prototype._showElement = function _showElement(relatedTarget) {
      var _this11 = this;

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // don't move modals dom position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';
      this._element.removeAttribute('aria-hidden');
      this._element.scrollTop = 0;

      if (transition) {
        Util.reflow(this._element);
      }

      $(this._element).addClass(ClassName.SHOW);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $.Event(Event.SHOWN, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this11._config.focus) {
          _this11._element.focus();
        }
        _this11._isTransitioning = false;
        $(_this11._element).trigger(shownEvent);
      };

      if (transition) {
        $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        transitionComplete();
      }
    };

    Modal.prototype._enforceFocus = function _enforceFocus() {
      var _this12 = this;

      $(document).off(Event.FOCUSIN) // guard against infinite focus loop
      .on(Event.FOCUSIN, function (event) {
        if (document !== event.target && _this12._element !== event.target && !$(_this12._element).has(event.target).length) {
          _this12._element.focus();
        }
      });
    };

    Modal.prototype._setEscapeEvent = function _setEscapeEvent() {
      var _this13 = this;

      if (this._isShown && this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
          if (event.which === ESCAPE_KEYCODE) {
            _this13.hide();
          }
        });
      } else if (!this._isShown) {
        $(this._element).off(Event.KEYDOWN_DISMISS);
      }
    };

    Modal.prototype._setResizeEvent = function _setResizeEvent() {
      var _this14 = this;

      if (this._isShown) {
        $(window).on(Event.RESIZE, function (event) {
          return _this14._handleUpdate(event);
        });
      } else {
        $(window).off(Event.RESIZE);
      }
    };

    Modal.prototype._hideModal = function _hideModal() {
      var _this15 = this;

      this._element.style.display = 'none';
      this._element.setAttribute('aria-hidden', 'true');
      this._isTransitioning = false;
      this._showBackdrop(function () {
        $(document.body).removeClass(ClassName.OPEN);
        _this15._resetAdjustments();
        _this15._resetScrollbar();
        $(_this15._element).trigger(Event.HIDDEN);
      });
    };

    Modal.prototype._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $(this._backdrop).remove();
        this._backdrop = null;
      }
    };

    Modal.prototype._showBackdrop = function _showBackdrop(callback) {
      var _this16 = this;

      var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

      if (this._isShown && this._config.backdrop) {
        var doAnimate = Util.supportsTransitionEnd() && animate;

        this._backdrop = document.createElement('div');
        this._backdrop.className = ClassName.BACKDROP;

        if (animate) {
          $(this._backdrop).addClass(animate);
        }

        $(this._backdrop).appendTo(document.body);

        $(this._element).on(Event.CLICK_DISMISS, function (event) {
          if (_this16._ignoreBackdropClick) {
            _this16._ignoreBackdropClick = false;
            return;
          }
          if (event.target !== event.currentTarget) {
            return;
          }
          if (_this16._config.backdrop === 'static') {
            _this16._element.focus();
          } else {
            _this16.hide();
          }
        });

        if (doAnimate) {
          Util.reflow(this._backdrop);
        }

        $(this._backdrop).addClass(ClassName.SHOW);

        if (!callback) {
          return;
        }

        if (!doAnimate) {
          callback();
          return;
        }

        $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
      } else if (!this._isShown && this._backdrop) {
        $(this._backdrop).removeClass(ClassName.SHOW);

        var callbackRemove = function callbackRemove() {
          _this16._removeBackdrop();
          if (callback) {
            callback();
          }
        };

        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
          $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    };

    // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------

    Modal.prototype._handleUpdate = function _handleUpdate() {
      this._adjustDialog();
    };

    Modal.prototype._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + 'px';
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + 'px';
      }
    };

    Modal.prototype._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    Modal.prototype._checkScrollbar = function _checkScrollbar() {
      this._isBodyOverflowing = document.body.clientWidth < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    Modal.prototype._setScrollbar = function _setScrollbar() {
      var bodyPadding = parseInt($(Selector.FIXED_CONTENT).css('padding-right') || 0, 10);

      this._originalBodyPadding = document.body.style.paddingRight || '';

      if (this._isBodyOverflowing) {
        document.body.style.paddingRight = bodyPadding + this._scrollbarWidth + 'px';
      }
    };

    Modal.prototype._resetScrollbar = function _resetScrollbar() {
      document.body.style.paddingRight = this._originalBodyPadding;
    };

    Modal.prototype._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    };

    // static

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Modal.Default, $(this).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

        if (!data) {
          data = new Modal(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return Modal;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    var _this17 = this;

    var target = void 0;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = $(selector)[0];
    }

    var config = $(target).data(DATA_KEY) ? 'toggle' : $.extend({}, $(target).data(), $(this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $(target).one(Event.SHOW, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(Event.HIDDEN, function () {
        if ($(_this17).is(':visible')) {
          _this17.focus();
        }
      });
    });

    Modal._jQueryInterface.call($(target), config, this);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Modal._jQueryInterface;
  $.fn[NAME].Constructor = Modal;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Modal._jQueryInterface;
  };

  return Modal;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var ScrollSpy = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'scrollspy';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.scrollspy';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Default = {
    offset: 10,
    method: 'auto',
    target: ''
  };

  var DefaultType = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };

  var Event = {
    ACTIVATE: 'activate' + EVENT_KEY,
    SCROLL: 'scroll' + EVENT_KEY,
    LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    DROPDOWN_ITEM: 'dropdown-item',
    DROPDOWN_MENU: 'dropdown-menu',
    NAV_LINK: 'nav-link',
    NAV: 'nav',
    ACTIVE: 'active'
  };

  var Selector = {
    DATA_SPY: '[data-spy="scroll"]',
    ACTIVE: '.active',
    LIST_ITEM: '.list-item',
    LI: 'li',
    LI_DROPDOWN: 'li.dropdown',
    NAV_LINKS: '.nav-link',
    DROPDOWN: '.dropdown',
    DROPDOWN_ITEMS: '.dropdown-item',
    DROPDOWN_TOGGLE: '.dropdown-toggle'
  };

  var OffsetMethod = {
    OFFSET: 'offset',
    POSITION: 'position'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var ScrollSpy = function () {
    function ScrollSpy(element, config) {
      var _this18 = this;

      _classCallCheck(this, ScrollSpy);

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + ' ' + Selector.NAV_LINKS + ',' + (this._config.target + ' ' + Selector.DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;

      $(this._scrollElement).on(Event.SCROLL, function (event) {
        return _this18._process(event);
      });

      this.refresh();
      this._process();
    }

    // getters

    // public

    ScrollSpy.prototype.refresh = function refresh() {
      var _this19 = this;

      var autoMethod = this._scrollElement !== this._scrollElement.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;

      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;

      var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;

      this._offsets = [];
      this._targets = [];

      this._scrollHeight = this._getScrollHeight();

      var targets = $.makeArray($(this._selector));

      targets.map(function (element) {
        var target = void 0;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = $(targetSelector)[0];
        }

        if (target && (target.offsetWidth || target.offsetHeight)) {
          // todo (fat): remove sketch reliance on jQuery position/offset
          return [$(target)[offsetMethod]().top + offsetBase, targetSelector];
        }
        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this19._offsets.push(item[0]);
        _this19._targets.push(item[1]);
      });
    };

    ScrollSpy.prototype.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._scrollElement).off(EVENT_KEY);

      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    };

    // private

    ScrollSpy.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      if (typeof config.target !== 'string') {
        var id = $(config.target).attr('id');
        if (!id) {
          id = Util.getUID(NAME);
          $(config.target).attr('id', id);
        }
        config.target = '#' + id;
      }

      Util.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    ScrollSpy.prototype._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    ScrollSpy.prototype._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    ScrollSpy.prototype._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.offsetHeight;
    };

    ScrollSpy.prototype._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;
      var scrollHeight = this._getScrollHeight();
      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }
        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;
        this._clear();
        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (this._offsets[i + 1] === undefined || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    ScrollSpy.prototype._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(',');
      queries = queries.map(function (selector) {
        return selector + '[data-target="' + target + '"],' + (selector + '[href="' + target + '"]');
      });

      var $link = $(queries.join(','));

      if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
        $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
        $link.addClass(ClassName.ACTIVE);
      } else {
        // todo (fat) this is kinda sus...
        // recursively add actives to tested nav-links
        $link.parents(Selector.LI).find('> ' + Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
      }

      $(this._scrollElement).trigger(Event.ACTIVATE, {
        relatedTarget: target
      });
    };

    ScrollSpy.prototype._clear = function _clear() {
      $(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
    };

    // static

    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }]);

    return ScrollSpy;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(window).on(Event.LOAD_DATA_API, function () {
    var scrollSpys = $.makeArray($(Selector.DATA_SPY));

    for (var i = scrollSpys.length; i--;) {
      var $spy = $(scrollSpys[i]);
      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = ScrollSpy._jQueryInterface;
  $.fn[NAME].Constructor = ScrollSpy;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return ScrollSpy._jQueryInterface;
  };

  return ScrollSpy;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Tab = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'tab';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.tab';
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var ClassName = {
    DROPDOWN_MENU: 'dropdown-menu',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    A: 'a',
    LI: 'li',
    DROPDOWN: '.dropdown',
    LIST: 'ul:not(.dropdown-menu), ol:not(.dropdown-menu), nav:not(.dropdown-menu)',
    FADE_CHILD: '> .nav-item .fade, > .fade',
    ACTIVE: '.active',
    ACTIVE_CHILD: '> .nav-item > .active, > .active',
    DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"]',
    DROPDOWN_TOGGLE: '.dropdown-toggle',
    DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Tab = function () {
    function Tab(element) {
      _classCallCheck(this, Tab);

      this._element = element;
    }

    // getters

    // public

    Tab.prototype.show = function show() {
      var _this20 = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $(this._element).hasClass(ClassName.ACTIVE) || $(this._element).hasClass(ClassName.DISABLED)) {
        return;
      }

      var target = void 0;
      var previous = void 0;
      var listElement = $(this._element).closest(Selector.LIST)[0];
      var selector = Util.getSelectorFromElement(this._element);

      if (listElement) {
        previous = $.makeArray($(listElement).find(Selector.ACTIVE));
        previous = previous[previous.length - 1];
      }

      var hideEvent = $.Event(Event.HIDE, {
        relatedTarget: this._element
      });

      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: previous
      });

      if (previous) {
        $(previous).trigger(hideEvent);
      }

      $(this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
        return;
      }

      if (selector) {
        target = $(selector)[0];
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        var hiddenEvent = $.Event(Event.HIDDEN, {
          relatedTarget: _this20._element
        });

        var shownEvent = $.Event(Event.SHOWN, {
          relatedTarget: previous
        });

        $(previous).trigger(hiddenEvent);
        $(_this20._element).trigger(shownEvent);
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    };

    Tab.prototype.dispose = function dispose() {
      $.removeClass(this._element, DATA_KEY);
      this._element = null;
    };

    // private

    Tab.prototype._activate = function _activate(element, container, callback) {
      var _this21 = this;

      var active = $(container).find(Selector.ACTIVE_CHILD)[0];
      var isTransitioning = callback && Util.supportsTransitionEnd() && (active && $(active).hasClass(ClassName.FADE) || Boolean($(container).find(Selector.FADE_CHILD)[0]));

      var complete = function complete() {
        return _this21._transitionComplete(element, active, isTransitioning, callback);
      };

      if (active && isTransitioning) {
        $(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      if (active) {
        $(active).removeClass(ClassName.SHOW);
      }
    };

    Tab.prototype._transitionComplete = function _transitionComplete(element, active, isTransitioning, callback) {
      if (active) {
        $(active).removeClass(ClassName.ACTIVE);

        var dropdownChild = $(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

        if (dropdownChild) {
          $(dropdownChild).removeClass(ClassName.ACTIVE);
        }

        active.setAttribute('aria-expanded', false);
      }

      $(element).addClass(ClassName.ACTIVE);
      element.setAttribute('aria-expanded', true);

      if (isTransitioning) {
        Util.reflow(element);
        $(element).addClass(ClassName.SHOW);
      } else {
        $(element).removeClass(ClassName.FADE);
      }

      if (element.parentNode && $(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {

        var dropdownElement = $(element).closest(Selector.DROPDOWN)[0];
        if (dropdownElement) {
          $(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    };

    // static

    Tab._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY);

        if (!data) {
          data = new Tab(this);
          $this.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Tab, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }]);

    return Tab;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    Tab._jQueryInterface.call($(this), 'show');
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Tab._jQueryInterface;
  $.fn[NAME].Constructor = Tab;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tab._jQueryInterface;
  };

  return Tab;
}(jQuery);

/* global Tether */

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Tooltip = function ($) {

  /**
   * Check for Tether dependency
   * Tether - http://tether.io/
   */
  if (typeof Tether === 'undefined') {
    throw new Error('Bootstrap tooltips require Tether (http://tether.io/)');
  }

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'tooltip';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.tooltip';
  var EVENT_KEY = '.' + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;
  var CLASS_PREFIX = 'bs-tether';

  var Default = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: '0 0',
    constraints: [],
    container: false
  };

  var DefaultType = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: 'string',
    constraints: 'array',
    container: '(string|element|boolean)'
  };

  var AttachmentMap = {
    TOP: 'bottom center',
    RIGHT: 'middle left',
    BOTTOM: 'top center',
    LEFT: 'middle right'
  };

  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    INSERTED: 'inserted' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    FOCUSOUT: 'focusout' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY
  };

  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner'
  };

  var TetherClass = {
    element: false,
    enabled: false
  };

  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Tooltip = function () {
    function Tooltip(element, config) {
      _classCallCheck(this, Tooltip);

      // private
      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._isTransitioning = false;
      this._tether = null;

      // protected
      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    }

    // getters

    // public

    Tooltip.prototype.enable = function enable() {
      this._isEnabled = true;
    };

    Tooltip.prototype.disable = function disable() {
      this._isEnabled = false;
    };

    Tooltip.prototype.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    Tooltip.prototype.toggle = function toggle(event) {
      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {

        if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
          this._leave(null, this);
          return;
        }

        this._enter(null, this);
      }
    };

    Tooltip.prototype.dispose = function dispose() {
      clearTimeout(this._timeout);

      this.cleanupTether();

      $.removeData(this.element, this.constructor.DATA_KEY);

      $(this.element).off(this.constructor.EVENT_KEY);
      $(this.element).closest('.modal').off('hide.bs.modal');

      if (this.tip) {
        $(this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;
      this._tether = null;

      this.element = null;
      this.config = null;
      this.tip = null;
    };

    Tooltip.prototype.show = function show() {
      var _this22 = this;

      if ($(this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $.Event(this.constructor.Event.SHOW);
      if (this.isWithContent() && this._isEnabled) {
        if (this._isTransitioning) {
          throw new Error('Tooltip is transitioning');
        }
        $(this.element).trigger(showEvent);

        var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);

        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);

        this.setContent();

        if (this.config.animation) {
          $(tip).addClass(ClassName.FADE);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        var container = this.config.container === false ? document.body : $(this.config.container);

        $(tip).data(this.constructor.DATA_KEY, this).appendTo(container);

        $(this.element).trigger(this.constructor.Event.INSERTED);

        this._tether = new Tether({
          attachment: attachment,
          element: tip,
          target: this.element,
          classes: TetherClass,
          classPrefix: CLASS_PREFIX,
          offset: this.config.offset,
          constraints: this.config.constraints,
          addTargetClasses: false
        });

        Util.reflow(tip);
        this._tether.position();

        $(tip).addClass(ClassName.SHOW);

        var complete = function complete() {
          var prevHoverState = _this22._hoverState;
          _this22._hoverState = null;
          _this22._isTransitioning = false;

          $(_this22.element).trigger(_this22.constructor.Event.SHOWN);

          if (prevHoverState === HoverState.OUT) {
            _this22._leave(null, _this22);
          }
        };

        if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
          this._isTransitioning = true;
          $(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
          return;
        }

        complete();
      }
    };

    Tooltip.prototype.hide = function hide(callback) {
      var _this23 = this;

      var tip = this.getTipElement();
      var hideEvent = $.Event(this.constructor.Event.HIDE);
      if (this._isTransitioning) {
        throw new Error('Tooltip is transitioning');
      }
      var complete = function complete() {
        if (_this23._hoverState !== HoverState.SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this23.element.removeAttribute('aria-describedby');
        $(_this23.element).trigger(_this23.constructor.Event.HIDDEN);
        _this23._isTransitioning = false;
        _this23.cleanupTether();

        if (callback) {
          callback();
        }
      };

      $(this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(tip).removeClass(ClassName.SHOW);

      this._activeTrigger[Trigger.CLICK] = false;
      this._activeTrigger[Trigger.FOCUS] = false;
      this._activeTrigger[Trigger.HOVER] = false;

      if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
        $(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    // protected

    Tooltip.prototype.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    Tooltip.prototype.getTipElement = function getTipElement() {
      return this.tip = this.tip || $(this.config.template)[0];
    };

    Tooltip.prototype.setContent = function setContent() {
      var $tip = $(this.getTipElement());

      this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());

      $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);

      this.cleanupTether();
    };

    Tooltip.prototype.setElementContent = function setElementContent($element, content) {
      var html = this.config.html;
      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
        // content is a DOM node or a jQuery
        if (html) {
          if (!$(content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($(content).text());
        }
      } else {
        $element[html ? 'html' : 'text'](content);
      }
    };

    Tooltip.prototype.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    };

    Tooltip.prototype.cleanupTether = function cleanupTether() {
      if (this._tether) {
        this._tether.destroy();
      }
    };

    // private

    Tooltip.prototype._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    Tooltip.prototype._setListeners = function _setListeners() {
      var _this24 = this;

      var triggers = this.config.trigger.split(' ');

      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $(_this24.element).on(_this24.constructor.Event.CLICK, _this24.config.selector, function (event) {
            return _this24.toggle(event);
          });
        } else if (trigger !== Trigger.MANUAL) {
          var eventIn = trigger === Trigger.HOVER ? _this24.constructor.Event.MOUSEENTER : _this24.constructor.Event.FOCUSIN;
          var eventOut = trigger === Trigger.HOVER ? _this24.constructor.Event.MOUSELEAVE : _this24.constructor.Event.FOCUSOUT;

          $(_this24.element).on(eventIn, _this24.config.selector, function (event) {
            return _this24._enter(event);
          }).on(eventOut, _this24.config.selector, function (event) {
            return _this24._leave(event);
          });
        }

        $(_this24.element).closest('.modal').on('hide.bs.modal', function () {
          return _this24.hide();
        });
      });

      if (this.config.selector) {
        this.config = $.extend({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    Tooltip.prototype._fixTitle = function _fixTitle() {
      var titleType = _typeof(this.element.getAttribute('data-original-title'));
      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    Tooltip.prototype._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;

      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
      }

      if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
        context._hoverState = HoverState.SHOW;
        return;
      }

      clearTimeout(context._timeout);

      context._hoverState = HoverState.SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    Tooltip.prototype._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;

      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);

      context._hoverState = HoverState.OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    Tooltip.prototype._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    Tooltip.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, this.constructor.Default, $(this.element).data(), config);

      if (config.delay && typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);

      return config;
    };

    Tooltip.prototype._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    // static

    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: 'VERSION',
      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }, {
      key: 'NAME',
      get: function get() {
        return NAME;
      }
    }, {
      key: 'DATA_KEY',
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: 'Event',
      get: function get() {
        return Event;
      }
    }, {
      key: 'EVENT_KEY',
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: 'DefaultType',
      get: function get() {
        return DefaultType;
      }
    }]);

    return Tooltip;
  }();

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Tooltip._jQueryInterface;
  $.fn[NAME].Constructor = Tooltip;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tooltip._jQueryInterface;
  };

  return Tooltip;
}(jQuery);

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

var Popover = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'popover';
  var VERSION = '4.0.0-alpha.6';
  var DATA_KEY = 'bs.popover';
  var EVENT_KEY = '.' + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Default = $.extend({}, Tooltip.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<h3 class="popover-title"></h3>' + '<div class="popover-content"></div></div>'
  });

  var DefaultType = $.extend({}, Tooltip.DefaultType, {
    content: '(string|element|function)'
  });

  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };

  var Selector = {
    TITLE: '.popover-title',
    CONTENT: '.popover-content'
  };

  var Event = {
    HIDE: 'hide' + EVENT_KEY,
    HIDDEN: 'hidden' + EVENT_KEY,
    SHOW: 'show' + EVENT_KEY,
    SHOWN: 'shown' + EVENT_KEY,
    INSERTED: 'inserted' + EVENT_KEY,
    CLICK: 'click' + EVENT_KEY,
    FOCUSIN: 'focusin' + EVENT_KEY,
    FOCUSOUT: 'focusout' + EVENT_KEY,
    MOUSEENTER: 'mouseenter' + EVENT_KEY,
    MOUSELEAVE: 'mouseleave' + EVENT_KEY
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  var Popover = function (_Tooltip) {
    _inherits(Popover, _Tooltip);

    function Popover() {
      _classCallCheck(this, Popover);

      return _possibleConstructorReturn(this, _Tooltip.apply(this, arguments));
    }

    // overrides

    Popover.prototype.isWithContent = function isWithContent() {
      return this.getTitle() || this._getContent();
    };

    Popover.prototype.getTipElement = function getTipElement() {
      return this.tip = this.tip || $(this.config.template)[0];
    };

    Popover.prototype.setContent = function setContent() {
      var $tip = $(this.getTipElement());

      // we use append for html objects to maintain js events
      this.setElementContent($tip.find(Selector.TITLE), this.getTitle());
      this.setElementContent($tip.find(Selector.CONTENT), this._getContent());

      $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);

      this.cleanupTether();
    };

    // private

    Popover.prototype._getContent = function _getContent() {
      return this.element.getAttribute('data-content') || (typeof this.config.content === 'function' ? this.config.content.call(this.element) : this.config.content);
    };

    // static

    Popover._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;

        if (!data && /destroy|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Popover(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    _createClass(Popover, null, [{
      key: 'VERSION',


      // getters

      get: function get() {
        return VERSION;
      }
    }, {
      key: 'Default',
      get: function get() {
        return Default;
      }
    }, {
      key: 'NAME',
      get: function get() {
        return NAME;
      }
    }, {
      key: 'DATA_KEY',
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: 'Event',
      get: function get() {
        return Event;
      }
    }, {
      key: 'EVENT_KEY',
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: 'DefaultType',
      get: function get() {
        return DefaultType;
      }
    }]);

    return Popover;
  }(Tooltip);

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Popover._jQueryInterface;
  $.fn[NAME].Constructor = Popover;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Popover._jQueryInterface;
  };

  return Popover;
}(jQuery);

}();

},{}],"/usr/var/server.base/node_modules/browserify/node_modules/base64-js/index.js":[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],"/usr/var/server.base/node_modules/browserify/node_modules/buffer/index.js":[function(require,module,exports){
(function (global,Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')
var isArray = require('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)
},{"base64-js":"/usr/var/server.base/node_modules/browserify/node_modules/base64-js/index.js","buffer":"/usr/var/server.base/node_modules/browserify/node_modules/buffer/index.js","ieee754":"/usr/var/server.base/node_modules/browserify/node_modules/ieee754/index.js","isarray":"/usr/var/server.base/node_modules/browserify/node_modules/buffer/node_modules/isarray/index.js"}],"/usr/var/server.base/node_modules/browserify/node_modules/buffer/node_modules/isarray/index.js":[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],"/usr/var/server.base/node_modules/browserify/node_modules/ieee754/index.js":[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],"/usr/var/server.base/node_modules/browserify/node_modules/is-buffer/index.js":[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],"/usr/var/server.base/node_modules/browserify/node_modules/process/browser.js":[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],"/usr/var/server.base/node_modules/browserify/node_modules/timers-browserify/main.js":[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":"/usr/var/server.base/node_modules/browserify/node_modules/process/browser.js","timers":"/usr/var/server.base/node_modules/browserify/node_modules/timers-browserify/main.js"}],"/usr/var/server.base/node_modules/brush-base/brush-base.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _syntaxhighlighterHtmlRenderer = require('syntaxhighlighter-html-renderer');

var _syntaxhighlighterHtmlRenderer2 = _interopRequireDefault(_syntaxhighlighterHtmlRenderer);

var _syntaxhighlighterRegex = require('syntaxhighlighter-regex');

var _syntaxhighlighterMatch = require('syntaxhighlighter-match');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function BrushBase() {
    _classCallCheck(this, BrushBase);
  }

  _createClass(BrushBase, [{
    key: 'getKeywords',

    /**
     * Converts space separated list of keywords into a regular expression string.
     * @param {String} str Space separated keywords.
     * @return {String} Returns regular expression string.
     */
    value: function getKeywords(str) {
      var results = str.replace(/^\s+|\s+$/g, '').replace(/\s+/g, '|');

      return '\\b(?:' + results + ')\\b';
    }

    /**
     * Makes a brush compatible with the `html-script` functionality.
     * @param {Object} regexGroup Object containing `left` and `right` regular expressions.
     */

  }, {
    key: 'forHtmlScript',
    value: function forHtmlScript(regexGroup) {
      var regex = { 'end': regexGroup.right.source };

      if (regexGroup.eof) {
        regex.end = '(?:(?:' + regex.end + ')|$)';
      }

      this.htmlScript = {
        left: { regex: regexGroup.left, css: 'script' },
        right: { regex: regexGroup.right, css: 'script' },
        code: (0, _syntaxhighlighterRegex.XRegExp)("(?<left>" + regexGroup.left.source + ")" + "(?<code>.*?)" + "(?<right>" + regex.end + ")", "sgi")
      };
    }
  }, {
    key: 'getHtml',
    value: function getHtml(code) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var matches = (0, _syntaxhighlighterMatch.applyRegexList)(code, this.regexList);
      var renderer = new _syntaxhighlighterHtmlRenderer2.default(code, matches, params);
      return renderer.getHtml();
    }
  }]);

  return BrushBase;
}();

},{"syntaxhighlighter-html-renderer":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-html-renderer/index.js","syntaxhighlighter-match":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/index.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-html-renderer/index.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Renderer;
/**
 * Pads number with zeros until it's length is the same as given length.
 *
 * @param {Number} number Number to pad.
 * @param {Number} length Max string length with.
 * @return {String}     Returns a string padded with proper amount of '0'.
 */
function padNumber(number, length) {
  var result = number.toString();

  while (result.length < length) {
    result = '0' + result;
  }return result;
};

function getLines(str) {
  return str.split(/\r?\n/);
}

function getLinesToHighlight(opts) {
  var results = {},
      linesToHighlight,
      l,
      i;

  linesToHighlight = opts.highlight || [];

  if (typeof linesToHighlight.push !== 'function') linesToHighlight = [linesToHighlight];

  for (i = 0, l = linesToHighlight.length; i < l; i++) {
    results[linesToHighlight[i]] = true;
  }return results;
}

function Renderer(code, matches, opts) {
  var _this = this;

  _this.opts = opts;
  _this.code = code;
  _this.matches = matches;
  _this.lines = getLines(code);
  _this.linesToHighlight = getLinesToHighlight(opts);
}

Renderer.prototype = {
  /**
   * Wraps each line of the string into <code/> tag with given style applied to it.
   *
   * @param {String} str   Input string.
   * @param {String} css   Style name to apply to the string.
   * @return {String}      Returns input string with each line surrounded by <span/> tag.
   */
  wrapLinesWithCode: function wrapLinesWithCode(str, css) {
    if (str == null || str.length == 0 || str == '\n' || css == null) return str;

    var _this = this,
        results = [],
        lines,
        line,
        spaces,
        i,
        l;

    str = str.replace(/</g, '&lt;');

    // Replace two or more sequential spaces with &nbsp; leaving last space untouched.
    str = str.replace(/ {2,}/g, function (m) {
      spaces = '';

      for (i = 0, l = m.length; i < l - 1; i++) {
        spaces += _this.opts.space;
      }return spaces + ' ';
    });

    lines = getLines(str);

    // Split each line and apply <span class="...">...</span> to them so that leading spaces aren't included.
    for (i = 0, l = lines.length; i < l; i++) {
      line = lines[i];
      spaces = '';

      if (line.length > 0) {
        line = line.replace(/^(&nbsp;| )+/, function (s) {
          spaces = s;
          return '';
        });

        line = line.length === 0 ? spaces : spaces + '<code class="' + css + '">' + line + '</code>';
      }

      results.push(line);
    }

    return results.join('\n');
  },

  /**
   * Turns all URLs in the code into <a/> tags.
   * @param {String} code Input code.
   * @return {String} Returns code with </a> tags.
   */
  processUrls: function processUrls(code) {
    var gt = /(.*)((&gt;|&lt;).*)/,
        url = /\w+:\/\/[\w-.\/?%&=:@;#]*/g;

    return code.replace(url, function (m) {
      var suffix = '',
          match = null;

      // We include &lt; and &gt; in the URL for the common cases like <http://google.com>
      // The problem is that they get transformed into &lt;http://google.com&gt;
      // Where as &gt; easily looks like part of the URL string.

      if (match = gt.exec(m)) {
        m = match[1];
        suffix = match[2];
      }

      return '<a href="' + m + '">' + m + '</a>' + suffix;
    });
  },

  /**
   * Creates an array containing integer line numbers starting from the 'first-line' param.
   * @return {Array} Returns array of integers.
   */
  figureOutLineNumbers: function figureOutLineNumbers(code) {
    var lineNumbers = [],
        lines = this.lines,
        firstLine = parseInt(this.opts.firstLine || 1),
        i,
        l;

    for (i = 0, l = lines.length; i < l; i++) {
      lineNumbers.push(i + firstLine);
    }return lineNumbers;
  },

  /**
   * Generates HTML markup for a single line of code while determining alternating line style.
   * @param {Integer} lineNumber  Line number.
   * @param {String} code Line  HTML markup.
   * @return {String}       Returns HTML markup.
   */
  wrapLine: function wrapLine(lineIndex, lineNumber, lineHtml) {
    var classes = ['line', 'number' + lineNumber, 'index' + lineIndex, 'alt' + (lineNumber % 2 == 0 ? 1 : 2).toString()];

    if (this.linesToHighlight[lineNumber]) classes.push('highlighted');

    if (lineNumber == 0) classes.push('break');

    return '<div class="' + classes.join(' ') + '">' + lineHtml + '</div>';
  },

  /**
   * Generates HTML markup for line number column.
   * @param {String} code     Complete code HTML markup.
   * @param {Array} lineNumbers Calculated line numbers.
   * @return {String}       Returns HTML markup.
   */
  renderLineNumbers: function renderLineNumbers(code, lineNumbers) {
    var _this = this,
        opts = _this.opts,
        html = '',
        count = _this.lines.length,
        firstLine = parseInt(opts.firstLine || 1),
        pad = opts.padLineNumbers,
        lineNumber,
        i;

    if (pad == true) pad = (firstLine + count - 1).toString().length;else if (isNaN(pad) == true) pad = 0;

    for (i = 0; i < count; i++) {
      lineNumber = lineNumbers ? lineNumbers[i] : firstLine + i;
      code = lineNumber == 0 ? opts.space : padNumber(lineNumber, pad);
      html += _this.wrapLine(i, lineNumber, code);
    }

    return html;
  },

  /**
   * Splits block of text into individual DIV lines.
   * @param {String} code     Code to highlight.
   * @param {Array} lineNumbers Calculated line numbers.
   * @return {String}       Returns highlighted code in HTML form.
   */
  getCodeLinesHtml: function getCodeLinesHtml(html, lineNumbers) {
    // html = utils.trim(html);

    var _this = this,
        opts = _this.opts,
        lines = getLines(html),
        padLength = opts.padLineNumbers,
        firstLine = parseInt(opts.firstLine || 1),
        brushName = opts.brush,
        html = '';

    for (var i = 0, l = lines.length; i < l; i++) {
      var line = lines[i],
          indent = /^(&nbsp;|\s)+/.exec(line),
          spaces = null,
          lineNumber = lineNumbers ? lineNumbers[i] : firstLine + i;
      ;

      if (indent != null) {
        spaces = indent[0].toString();
        line = line.substr(spaces.length);
        spaces = spaces.replace(' ', opts.space);
      }

      // line = utils.trim(line);

      if (line.length == 0) line = opts.space;

      html += _this.wrapLine(i, lineNumber, (spaces != null ? '<code class="' + brushName + ' spaces">' + spaces + '</code>' : '') + line);
    }

    return html;
  },

  /**
   * Returns HTML for the table title or empty string if title is null.
   */
  getTitleHtml: function getTitleHtml(title) {
    return title ? '<caption>' + title + '</caption>' : '';
  },

  /**
   * Finds all matches in the source code.
   * @param {String} code   Source code to process matches in.
   * @param {Array} matches Discovered regex matches.
   * @return {String} Returns formatted HTML with processed mathes.
   */
  getMatchesHtml: function getMatchesHtml(code, matches) {
    function getBrushNameCss(match) {
      var result = match ? match.brushName || brushName : brushName;
      return result ? result + ' ' : '';
    };

    var _this = this,
        pos = 0,
        result = '',
        brushName = _this.opts.brush || '',
        match,
        matchBrushName,
        i,
        l;

    // Finally, go through the final list of matches and pull the all
    // together adding everything in between that isn't a match.
    for (i = 0, l = matches.length; i < l; i++) {
      match = matches[i];

      if (match === null || match.length === 0) continue;

      matchBrushName = getBrushNameCss(match);

      result += _this.wrapLinesWithCode(code.substr(pos, match.index - pos), matchBrushName + 'plain') + _this.wrapLinesWithCode(match.value, matchBrushName + match.css);

      pos = match.index + match.length + (match.offset || 0);
    }

    // don't forget to add whatever's remaining in the string
    result += _this.wrapLinesWithCode(code.substr(pos), getBrushNameCss() + 'plain');

    return result;
  },

  /**
   * Generates HTML markup for the whole syntax highlighter.
   * @param {String} code Source code.
   * @return {String} Returns HTML markup.
   */
  getHtml: function getHtml() {
    var _this = this,
        opts = _this.opts,
        code = _this.code,
        matches = _this.matches,
        classes = ['syntaxhighlighter'],
        lineNumbers,
        gutter,
        html;

    if (opts.collapse === true) classes.push('collapsed');

    gutter = opts.gutter !== false;

    if (!gutter) classes.push('nogutter');

    // add custom user style name
    classes.push(opts.className);

    // add brush alias to the class name for custom CSS
    classes.push(opts.brush);

    if (gutter) lineNumbers = _this.figureOutLineNumbers(code);

    // processes found matches into the html
    html = _this.getMatchesHtml(code, matches);

    // finally, split all lines so that they wrap well
    html = _this.getCodeLinesHtml(html, lineNumbers);

    // finally, process the links
    if (opts.autoLinks) html = _this.processUrls(html);

    html = '\n      <div class="' + classes.join(' ') + '">\n        <table border="0" cellpadding="0" cellspacing="0">\n          ' + _this.getTitleHtml(opts.title) + '\n          <tbody>\n            <tr>\n              ' + (gutter ? '<td class="gutter">' + _this.renderLineNumbers(code) + '</td>' : '') + '\n              <td class="code">\n                <div class="container">' + html + '</div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    ';

    return html;
  }
};

},{}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/index.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _match = require('./lib/match');

Object.keys(_match).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _match[key];
    }
  });
});

var _applyRegexList = require('./lib/apply-regex-list');

Object.keys(_applyRegexList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _applyRegexList[key];
    }
  });
});

},{"./lib/apply-regex-list":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js","./lib/match":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/match.js"}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.applyRegexList = applyRegexList;

var _matches = require('./matches');

/**
 * Applies all regular expression to the code and stores all found
 * matches in the `this.matches` array.
 */
function applyRegexList(code, regexList) {
  var result = [];

  regexList = regexList || [];

  for (var i = 0, l = regexList.length; i < l; i++) {
    // BUG: length returns len+1 for array if methods added to prototype chain (oising@gmail.com)
    if (_typeof(regexList[i]) === 'object') result = result.concat((0, _matches.find)(code, regexList[i]));
  }

  result = (0, _matches.sort)(result);
  result = (0, _matches.removeNested)(result);
  result = (0, _matches.compact)(result);

  return result;
}

},{"./matches":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/matches.js"}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/match.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Match = exports.Match = function () {
  function Match(value, index, css) {
    _classCallCheck(this, Match);

    this.value = value;
    this.index = index;
    this.length = value.length;
    this.css = css;
    this.brushName = null;
  }

  _createClass(Match, [{
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }]);

  return Match;
}();

},{}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/matches.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.find = find;
exports.sort = sort;
exports.compact = compact;
exports.removeNested = removeNested;

var _match = require('./match');

var _syntaxhighlighterRegex = require('syntaxhighlighter-regex');

/**
 * Executes given regular expression on provided code and returns all matches that are found.
 *
 * @param {String} code    Code to execute regular expression on.
 * @param {Object} regex   Regular expression item info from `regexList` collection.
 * @return {Array}         Returns a list of Match objects.
 */
function find(code, regexInfo) {
  function defaultAdd(match, regexInfo) {
    return match[0];
  };

  var index = 0,
      match = null,
      matches = [],
      process = regexInfo.func ? regexInfo.func : defaultAdd,
      pos = 0;

  while (match = _syntaxhighlighterRegex.XRegExp.exec(code, regexInfo.regex, pos)) {
    var resultMatch = process(match, regexInfo);

    if (typeof resultMatch === 'string') resultMatch = [new _match.Match(resultMatch, match.index, regexInfo.css)];

    matches = matches.concat(resultMatch);
    pos = match.index + match[0].length;
  }

  return matches;
};

/**
 * Sorts matches by index position and then by length.
 */
function sort(matches) {
  function sortMatchesCallback(m1, m2) {
    // sort matches by index first
    if (m1.index < m2.index) return -1;else if (m1.index > m2.index) return 1;else {
      // if index is the same, sort by length
      if (m1.length < m2.length) return -1;else if (m1.length > m2.length) return 1;
    }

    return 0;
  }

  return matches.sort(sortMatchesCallback);
}

function compact(matches) {
  var result = [],
      i,
      l;

  for (i = 0, l = matches.length; i < l; i++) {
    if (matches[i]) result.push(matches[i]);
  }return result;
}

/**
 * Checks to see if any of the matches are inside of other matches.
 * This process would get rid of highligted strings inside comments,
 * keywords inside strings and so on.
 */
function removeNested(matches) {
  // Optimized by Jose Prado (http://joseprado.com)
  for (var i = 0, l = matches.length; i < l; i++) {
    if (matches[i] === null) continue;

    var itemI = matches[i],
        itemIEndPos = itemI.index + itemI.length;

    for (var j = i + 1, l = matches.length; j < l && matches[i] !== null; j++) {
      var itemJ = matches[j];

      if (itemJ === null) continue;else if (itemJ.index > itemIEndPos) break;else if (itemJ.index == itemI.index && itemJ.length > itemI.length) matches[i] = null;else if (itemJ.index >= itemI.index && itemJ.index < itemIEndPos) matches[j] = null;
    }
  }

  return matches;
}

},{"./match":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/match.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonRegExp = exports.XRegExp = undefined;

var _xregexp = require('./xregexp');

var _xregexp2 = _interopRequireDefault(_xregexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.XRegExp = _xregexp2.default;
var commonRegExp = exports.commonRegExp = {
  multiLineCComments: (0, _xregexp2.default)('/\\*.*?\\*/', 'gs'),
  singleLineCComments: /\/\/.*$/gm,
  singleLinePerlComments: /#.*$/gm,
  doubleQuotedString: /"([^\\"\n]|\\.)*"/g,
  singleQuotedString: /'([^\\'\n]|\\.)*'/g,
  multiLineDoubleQuotedString: (0, _xregexp2.default)('"([^\\\\"]|\\\\.)*"', 'gs'),
  multiLineSingleQuotedString: (0, _xregexp2.default)("'([^\\\\']|\\\\.)*'", 'gs'),
  xmlComments: (0, _xregexp2.default)('(&lt;|<)!--.*?--(&gt;|>)', 'gs'),
  url: /\w+:\/\/[\w-.\/?%&=:@;#]*/g,
  phpScriptTags: { left: /(&lt;|<)\?(?:=|php)?/g, right: /\?(&gt;|>)/g, 'eof': true },
  aspScriptTags: { left: /(&lt;|<)%=?/g, right: /%(&gt;|>)/g },
  scriptScriptTags: { left: /(&lt;|<)\s*script.*?(&gt;|>)/gi, right: /(&lt;|<)\/\s*script\s*(&gt;|>)/gi }
};

},{"./xregexp":"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/xregexp.js"}],"/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/xregexp.js":[function(require,module,exports){
/*!
 * XRegExp 3.1.0-dev
 * <xregexp.com>
 * Steven Levithan (c) 2007-2015 MIT License
 */

/**
 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
 * make your client-side grepping simpler and more powerful, while freeing you from related
 * cross-browser inconsistencies.
 */

'use strict';

/* ==============================
 * Private variables
 * ============================== */

// Property name used for extended regex instance data

var REGEX_DATA = 'xregexp';
// Optional features that can be installed and uninstalled
var features = {
    astral: false,
    natives: false
};
// Native methods to use and restore ('native' is an ES3 reserved keyword)
var nativ = {
    exec: RegExp.prototype.exec,
    test: RegExp.prototype.test,
    match: String.prototype.match,
    replace: String.prototype.replace,
    split: String.prototype.split
};
// Storage for fixed/extended native methods
var fixed = {};
// Storage for regexes cached by `XRegExp.cache`
var regexCache = {};
// Storage for pattern details cached by the `XRegExp` constructor
var patternCache = {};
// Storage for regex syntax tokens added internally or by `XRegExp.addToken`
var tokens = [];
// Token scopes
var defaultScope = 'default';
var classScope = 'class';
// Regexes that match native regex syntax, including octals
var nativeTokens = {
    // Any native multicharacter token in default scope, or any single character
    'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?[:=!]|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
    // Any native multicharacter token in character class scope, or any single character
    'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
};
// Any backreference or dollar-prefixed character in replacement strings
var replacementToken = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
// Check for correct `exec` handling of nonparticipating capturing groups
var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined;
// Check for ES6 `u` flag support
var hasNativeU = function () {
    var isSupported = true;
    try {
        new RegExp('', 'u');
    } catch (exception) {
        isSupported = false;
    }
    return isSupported;
}();
// Check for ES6 `y` flag support
var hasNativeY = function () {
    var isSupported = true;
    try {
        new RegExp('', 'y');
    } catch (exception) {
        isSupported = false;
    }
    return isSupported;
}();
// Check for ES6 `flags` prop support
var hasFlagsProp = /a/.flags !== undefined;
// Tracker for known flags, including addon flags
var registeredFlags = {
    g: true,
    i: true,
    m: true,
    u: hasNativeU,
    y: hasNativeY
};
// Shortcut to `Object.prototype.toString`
var toString = {}.toString;

/* ==============================
 * Private functions
 * ============================== */

/**
 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to augment.
 * @param {Array} captureNames Array with capture names, or `null`.
 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *   skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {RegExp} Augmented regex.
 */
function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
    var p;

    regex[REGEX_DATA] = {
        captureNames: captureNames
    };

    if (isInternalOnly) {
        return regex;
    }

    // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
    if (regex.__proto__) {
        regex.__proto__ = XRegExp.prototype;
    } else {
        for (p in XRegExp.prototype) {
            // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since
            // this is performance sensitive, and enumerable `Object.prototype` or
            // `RegExp.prototype` extensions exist on `regex.prototype` anyway
            regex[p] = XRegExp.prototype[p];
        }
    }

    regex[REGEX_DATA].source = xSource;
    // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
    regex[REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;

    return regex;
}

/**
 * Removes any duplicate characters from the provided string.
 *
 * @private
 * @param {String} str String to remove duplicate characters from.
 * @returns {String} String with any duplicate characters removed.
 */
function clipDuplicates(str) {
    return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
}

/**
 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
 * flags g and y while copying the regex.
 *
 * @private
 * @param {RegExp} regex Regex to copy.
 * @param {Object} [options] Options object with optional properties:
 *   <li>`addG` {Boolean} Add flag g while copying the regex.
 *   <li>`addY` {Boolean} Add flag y while copying the regex.
 *   <li>`removeG` {Boolean} Remove flag g while copying the regex.
 *   <li>`removeY` {Boolean} Remove flag y while copying the regex.
 *   <li>`isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *     skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
 */
function copyRegex(regex, options) {
    if (!XRegExp.isRegExp(regex)) {
        throw new TypeError('Type RegExp expected');
    }

    var xData = regex[REGEX_DATA] || {},
        flags = getNativeFlags(regex),
        flagsToAdd = '',
        flagsToRemove = '',
        xregexpSource = null,
        xregexpFlags = null;

    options = options || {};

    if (options.removeG) {
        flagsToRemove += 'g';
    }
    if (options.removeY) {
        flagsToRemove += 'y';
    }
    if (flagsToRemove) {
        flags = nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
    }

    if (options.addG) {
        flagsToAdd += 'g';
    }
    if (options.addY) {
        flagsToAdd += 'y';
    }
    if (flagsToAdd) {
        flags = clipDuplicates(flags + flagsToAdd);
    }

    if (!options.isInternalOnly) {
        if (xData.source !== undefined) {
            xregexpSource = xData.source;
        }
        // null or undefined; don't want to add to `flags` if the previous value was null, since
        // that indicates we're not tracking original precompilation flags
        if (xData.flags != null) {
            // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are
            // never removed for non-internal regexes, so don't need to handle it
            xregexpFlags = flagsToAdd ? clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
        }
    }

    // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to
    // avoid searching for special tokens. That would be wrong for regexes constructed by
    // `RegExp`, and unnecessary for regexes constructed by `XRegExp` because the regex has
    // already undergone the translation to native regex syntax
    regex = augment(new RegExp(regex.source, flags), hasNamedCapture(regex) ? xData.captureNames.slice(0) : null, xregexpSource, xregexpFlags, options.isInternalOnly);

    return regex;
}

/**
 * Converts hexadecimal to decimal.
 *
 * @private
 * @param {String} hex
 * @returns {Number}
 */
function dec(hex) {
    return parseInt(hex, 16);
}

/**
 * Returns native `RegExp` flags used by a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {String} Native flags in use.
 */
function getNativeFlags(regex) {
    return hasFlagsProp ? regex.flags :
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or
    // concatenation with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overriden
    nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
}

/**
 * Determines whether a regex has extended instance data used to track capture names.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {Boolean} Whether the regex uses named capture.
 */
function hasNamedCapture(regex) {
    return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
}

/**
 * Converts decimal to hexadecimal.
 *
 * @private
 * @param {Number|String} dec
 * @returns {String}
 */
function hex(dec) {
    return parseInt(dec, 10).toString(16);
}

/**
 * Returns the first index at which a given value can be found in an array.
 *
 * @private
 * @param {Array} array Array to search.
 * @param {*} value Value to locate in the array.
 * @returns {Number} Zero-based index at which the item is found, or -1.
 */
function indexOf(array, value) {
    var len = array.length,
        i;

    for (i = 0; i < len; ++i) {
        if (array[i] === value) {
            return i;
        }
    }

    return -1;
}

/**
 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
 *
 * @private
 * @param {*} value Object to check.
 * @param {String} type Type to check for, in TitleCase.
 * @returns {Boolean} Whether the object matches the type.
 */
function isType(value, type) {
    return toString.call(value) === '[object ' + type + ']';
}

/**
 * Checks whether the next nonignorable token after the specified position is a quantifier.
 *
 * @private
 * @param {String} pattern Pattern to search within.
 * @param {Number} pos Index in `pattern` to search at.
 * @param {String} flags Flags used by the pattern.
 * @returns {Boolean} Whether the next token is a quantifier.
 */
function isQuantifierNext(pattern, pos, flags) {
    return nativ.test.call(flags.indexOf('x') > -1 ?
    // Ignore any leading whitespace, line comments, and inline comments
    /^(?:\s+|#.*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ :
    // Ignore any leading inline comments
    /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/, pattern.slice(pos));
}

/**
 * Pads the provided string with as many leading zeros as needed to get to length 4. Used to produce
 * fixed-length hexadecimal values.
 *
 * @private
 * @param {String} str
 * @returns {String}
 */
function pad4(str) {
    while (str.length < 4) {
        str = '0' + str;
    }
    return str;
}

/**
 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
 * the flag preparation logic from the `XRegExp` constructor.
 *
 * @private
 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
 * @param {String} flags Any combination of flags.
 * @returns {Object} Object with properties `pattern` and `flags`.
 */
function prepareFlags(pattern, flags) {
    var i;

    // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
    if (clipDuplicates(flags) !== flags) {
        throw new SyntaxError('Invalid duplicate regex flag ' + flags);
    }

    // Strip and apply a leading mode modifier with any combination of flags except g or y
    pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function ($0, $1) {
        if (nativ.test.call(/[gy]/, $1)) {
            throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
        }
        // Allow duplicate flags within the mode modifier
        flags = clipDuplicates(flags + $1);
        return '';
    });

    // Throw on unknown native or nonnative flags
    for (i = 0; i < flags.length; ++i) {
        if (!registeredFlags[flags.charAt(i)]) {
            throw new SyntaxError('Unknown regex flag ' + flags.charAt(i));
        }
    }

    return {
        pattern: pattern,
        flags: flags
    };
}

/**
 * Prepares an options object from the given value.
 *
 * @private
 * @param {String|Object} value Value to convert to an options object.
 * @returns {Object} Options object.
 */
function prepareOptions(value) {
    var options = {};

    if (isType(value, 'String')) {
        XRegExp.forEach(value, /[^\s,]+/, function (match) {
            options[match] = true;
        });

        return options;
    }

    return value;
}

/**
 * Registers a flag so it doesn't throw an 'unknown flag' error.
 *
 * @private
 * @param {String} flag Single-character flag to register.
 */
function registerFlag(flag) {
    if (!/^[\w$]$/.test(flag)) {
        throw new Error('Flag must be a single character A-Za-z0-9_$');
    }

    registeredFlags[flag] = true;
}

/**
 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
 * position, until a match is found.
 *
 * @private
 * @param {String} pattern Original pattern from which an XRegExp object is being built.
 * @param {String} flags Flags being used to construct the regex.
 * @param {Number} pos Position to search for tokens within `pattern`.
 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
 * @param {Object} context Context object to use for token handler functions.
 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
 */
function runTokens(pattern, flags, pos, scope, context) {
    var i = tokens.length,
        leadChar = pattern.charAt(pos),
        result = null,
        match,
        t;

    // Run in reverse insertion order
    while (i--) {
        t = tokens[i];
        if (t.leadChar && t.leadChar !== leadChar || t.scope !== scope && t.scope !== 'all' || t.flag && flags.indexOf(t.flag) === -1) {
            continue;
        }

        match = XRegExp.exec(pattern, t.regex, pos, 'sticky');
        if (match) {
            result = {
                matchLength: match[0].length,
                output: t.handler.call(context, match, scope, flags),
                reparse: t.reparse
            };
            // Finished with token tests
            break;
        }
    }

    return result;
}

/**
 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
 * the Unicode Base addon is not available, since flag A is registered by that addon.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setAstral(on) {
    features.astral = on;
}

/**
 * Enables or disables native method overrides.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setNatives(on) {
    RegExp.prototype.exec = (on ? fixed : nativ).exec;
    RegExp.prototype.test = (on ? fixed : nativ).test;
    String.prototype.match = (on ? fixed : nativ).match;
    String.prototype.replace = (on ? fixed : nativ).replace;
    String.prototype.split = (on ? fixed : nativ).split;

    features.natives = on;
}

/**
 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
 * the ES5 abstract operation `ToObject`.
 *
 * @private
 * @param {*} value Object to check and return.
 * @returns {*} The provided object.
 */
function toObject(value) {
    // null or undefined
    if (value == null) {
        throw new TypeError('Cannot convert null or undefined to object');
    }

    return value;
}

/* ==============================
 * Constructor
 * ============================== */

/**
 * Creates an extended regular expression object for matching text with a pattern. Differs from a
 * native regular expression in that additional syntax and flags are supported. The returned object
 * is in fact a native `RegExp` and works with all native methods.
 *
 * @class XRegExp
 * @constructor
 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
 * @param {String} [flags] Any combination of flags.
 *   Native flags:
 *     <li>`g` - global
 *     <li>`i` - ignore case
 *     <li>`m` - multiline anchors
 *     <li>`u` - unicode (ES6)
 *     <li>`y` - sticky (Firefox 3+, ES6)
 *   Additional XRegExp flags:
 *     <li>`n` - explicit capture
 *     <li>`s` - dot matches all (aka singleline)
 *     <li>`x` - free-spacing and line comments (aka extended)
 *     <li>`A` - astral (requires the Unicode Base addon)
 *   Flags cannot be provided when constructing one `RegExp` from another.
 * @returns {RegExp} Extended regular expression object.
 * @example
 *
 * // With named capture and flag x
 * XRegExp('(?<year>  [0-9]{4} ) -?  # year  \n\
 *          (?<month> [0-9]{2} ) -?  # month \n\
 *          (?<day>   [0-9]{2} )     # day   ', 'x');
 *
 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
 * // have fresh `lastIndex` properties (set to zero).
 * XRegExp(/regex/);
 */
function XRegExp(pattern, flags) {
    var context = {
        hasNamedCapture: false,
        captureNames: []
    },
        scope = defaultScope,
        output = '',
        pos = 0,
        result,
        token,
        generated,
        appliedPattern,
        appliedFlags;

    if (XRegExp.isRegExp(pattern)) {
        if (flags !== undefined) {
            throw new TypeError('Cannot supply flags when copying a RegExp');
        }
        return copyRegex(pattern);
    }

    // Copy the argument behavior of `RegExp`
    pattern = pattern === undefined ? '' : String(pattern);
    flags = flags === undefined ? '' : String(flags);

    if (XRegExp.isInstalled('astral') && flags.indexOf('A') === -1) {
        // This causes an error to be thrown if the Unicode Base addon is not available
        flags += 'A';
    }

    if (!patternCache[pattern]) {
        patternCache[pattern] = {};
    }

    if (!patternCache[pattern][flags]) {
        // Check for flag-related errors, and strip/apply flags in a leading mode modifier
        result = prepareFlags(pattern, flags);
        appliedPattern = result.pattern;
        appliedFlags = result.flags;

        // Use XRegExp's tokens to translate the pattern to a native regex pattern.
        // `appliedPattern.length` may change on each iteration if tokens use `reparse`
        while (pos < appliedPattern.length) {
            do {
                // Check for custom tokens at the current position
                result = runTokens(appliedPattern, appliedFlags, pos, scope, context);
                // If the matched token used the `reparse` option, splice its output into the
                // pattern before running tokens again at the same position
                if (result && result.reparse) {
                    appliedPattern = appliedPattern.slice(0, pos) + result.output + appliedPattern.slice(pos + result.matchLength);
                }
            } while (result && result.reparse);

            if (result) {
                output += result.output;
                pos += result.matchLength || 1;
            } else {
                // Get the native token at the current position
                token = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky')[0];
                output += token;
                pos += token.length;
                if (token === '[' && scope === defaultScope) {
                    scope = classScope;
                } else if (token === ']' && scope === classScope) {
                    scope = defaultScope;
                }
            }
        }

        patternCache[pattern][flags] = {
            // Cleanup token cruft: repeated `(?:)(?:)` and leading/trailing `(?:)`
            pattern: nativ.replace.call(output, /\(\?:\)(?:[*+?]|\{\d+(?:,\d*)?})?\??(?=\(\?:\))|^\(\?:\)(?:[*+?]|\{\d+(?:,\d*)?})?\??|\(\?:\)(?:[*+?]|\{\d+(?:,\d*)?})?\??$/g, ''),
            // Strip all but native flags
            flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
            // `context.captureNames` has an item for each capturing group, even if unnamed
            captures: context.hasNamedCapture ? context.captureNames : null
        };
    }

    generated = patternCache[pattern][flags];
    return augment(new RegExp(generated.pattern, generated.flags), generated.captures, pattern, flags);
};

// Add `RegExp.prototype` to the prototype chain
XRegExp.prototype = new RegExp();

/* ==============================
 * Public properties
 * ============================== */

/**
 * The XRegExp version number as a string containing three dot-separated parts. For example,
 * '2.0.0-beta-3'.
 *
 * @static
 * @memberOf XRegExp
 * @type String
 */
XRegExp.version = '3.1.0-dev';

/* ==============================
 * Public methods
 * ============================== */

/**
 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
 * create XRegExp addons. If more than one token can match the same string, the last added wins.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex object that matches the new token.
 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
 *   properties of the regex being built, through `this`. Invoked with three arguments:
 *   <li>The match array, with named backreference properties.
 *   <li>The regex scope where the match was found: 'default' or 'class'.
 *   <li>The flags used by the regex, including any flags in a leading mode modifier.
 *   The handler function becomes part of the XRegExp construction process, so be careful not to
 *   construct XRegExps within the function or you will trigger infinite recursion.
 * @param {Object} [options] Options object with optional properties:
 *   <li>`scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
 *   <li>`flag` {String} Single-character flag that triggers the token. This also registers the
 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
 *   <li>`optionalFlags` {String} Any custom flags checked for within the token `handler` that are
 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
 *     throwing an 'unknown flag' error when any of the flags are used.
 *   <li>`reparse` {Boolean} Whether the `handler` function's output should not be treated as
 *     final, and instead be reparseable by other tokens (including the current token). Allows
 *     token chaining or deferring.
 *   <li>`leadChar` {String} Single character that occurs at the beginning of any successful match
 *     of the token (not always applicable). This doesn't change the behavior of the token unless
 *     you provide an erroneous value. However, providing it can increase the token's performance
 *     since the token can be skipped at any positions where this character doesn't appear.
 * @example
 *
 * // Basic usage: Add \a for the ALERT control code
 * XRegExp.addToken(
 *   /\\a/,
 *   function() {return '\\x07';},
 *   {scope: 'all'}
 * );
 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
 *
 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
 * // character classes only)
 * XRegExp.addToken(
 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
 *   function(match) {return match[1] + (match[2] ? '' : '?');},
 *   {flag: 'U'}
 * );
 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
 */
XRegExp.addToken = function (regex, handler, options) {
    options = options || {};
    var optionalFlags = options.optionalFlags,
        i;

    if (options.flag) {
        registerFlag(options.flag);
    }

    if (optionalFlags) {
        optionalFlags = nativ.split.call(optionalFlags, '');
        for (i = 0; i < optionalFlags.length; ++i) {
            registerFlag(optionalFlags[i]);
        }
    }

    // Add to the private list of syntax tokens
    tokens.push({
        regex: copyRegex(regex, {
            addG: true,
            addY: hasNativeY,
            isInternalOnly: true
        }),
        handler: handler,
        scope: options.scope || defaultScope,
        flag: options.flag,
        reparse: options.reparse,
        leadChar: options.leadChar
    });

    // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
    // flags might now produce different results
    XRegExp.cache.flush('patterns');
};

/**
 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
 * the same pattern and flag combination, the cached copy of the regex is returned.
 *
 * @memberOf XRegExp
 * @param {String} pattern Regex pattern string.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Cached XRegExp object.
 * @example
 *
 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
 *   // The regex is compiled once only
 * }
 */
XRegExp.cache = function (pattern, flags) {
    if (!regexCache[pattern]) {
        regexCache[pattern] = {};
    }
    return regexCache[pattern][flags] || (regexCache[pattern][flags] = XRegExp(pattern, flags));
};

// Intentionally undocumented
XRegExp.cache.flush = function (cacheName) {
    if (cacheName === 'patterns') {
        // Flush the pattern cache used by the `XRegExp` constructor
        patternCache = {};
    } else {
        // Flush the regex cache populated by `XRegExp.cache`
        regexCache = {};
    }
};

/**
 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
 * can safely be used at any point within a regex that uses any flags.
 *
 * @memberOf XRegExp
 * @param {String} str String to escape.
 * @returns {String} String with regex metacharacters escaped.
 * @example
 *
 * XRegExp.escape('Escaped? <.>');
 * // -> 'Escaped\?\ <\.>'
 */
XRegExp.escape = function (str) {
    return nativ.replace.call(toObject(str), /[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

/**
 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
 * regex uses named capture, named backreference properties are included on the match array.
 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
 * must start at the specified position only. The `lastIndex` property of the provided regex is not
 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.exec` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Array} Match array with named backreference properties, or `null`.
 * @example
 *
 * // Basic use, with named backreference
 * var match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
 * match.hex; // -> '2620'
 *
 * // With pos and sticky, in a loop
 * var pos = 2, result = [], match;
 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
 *   result.push(match[1]);
 *   pos = match.index + match[0].length;
 * }
 * // result -> ['2', '3', '4']
 */
XRegExp.exec = function (str, regex, pos, sticky) {
    var cacheKey = 'g',
        addY = false,
        match,
        r2;

    addY = hasNativeY && !!(sticky || regex.sticky && sticky !== false);
    if (addY) {
        cacheKey += 'y';
    }

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.match`/`replace`
    r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
        addG: true,
        addY: addY,
        removeY: sticky === false,
        isInternalOnly: true
    }));

    r2.lastIndex = pos = pos || 0;

    // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
    match = fixed.exec.call(r2, str);

    if (sticky && match && match.index !== pos) {
        match = null;
    }

    if (regex.global) {
        regex.lastIndex = match ? r2.lastIndex : 0;
    }

    return match;
};

/**
 * Executes a provided function once per regex match. Searches always start at the beginning of the
 * string and continue until the end, regardless of the state of the regex's `global` property and
 * initial `lastIndex`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
 *   <li>The match array, with named backreference properties.
 *   <li>The zero-based match index.
 *   <li>The string being traversed.
 *   <li>The regex object being used to traverse the string.
 * @example
 *
 * // Extracts every other digit from a string
 * var evens = [];
 * XRegExp.forEach('1a2345', /\d/, function(match, i) {
 *   if (i % 2) evens.push(+match[0]);
 * });
 * // evens -> [2, 4]
 */
XRegExp.forEach = function (str, regex, callback) {
    var pos = 0,
        i = -1,
        match;

    while (match = XRegExp.exec(str, regex, pos)) {
        // Because `regex` is provided to `callback`, the function could use the deprecated/
        // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since
        // `XRegExp.exec` doesn't use `lastIndex` to set the search position, this can't lead
        // to an infinite loop, at least. Actually, because of the way `XRegExp.exec` caches
        // globalized versions of regexes, mutating the regex will not have any effect on the
        // iteration or matched strings, which is a nice side effect that brings extra safety
        callback(match, ++i, str, regex);

        pos = match.index + (match[0].length || 1);
    }
};

/**
 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
 * regexes are not recompiled using XRegExp syntax.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex to globalize.
 * @returns {RegExp} Copy of the provided regex with flag `g` added.
 * @example
 *
 * var globalCopy = XRegExp.globalize(/regex/);
 * globalCopy.global; // -> true
 */
XRegExp.globalize = function (regex) {
    return copyRegex(regex, { addG: true });
};

/**
 * Installs optional features according to the specified options. Can be undone using
 * {@link #XRegExp.uninstall}.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.install({
 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
 *   astral: true,
 *
 *   // Overrides native regex methods with fixed/extended versions that support named
 *   // backreferences and fix numerous cross-browser bugs
 *   natives: true
 * });
 *
 * // With an options string
 * XRegExp.install('astral natives');
 */
XRegExp.install = function (options) {
    options = prepareOptions(options);

    if (!features.astral && options.astral) {
        setAstral(true);
    }

    if (!features.natives && options.natives) {
        setNatives(true);
    }
};

/**
 * Checks whether an individual optional feature is installed.
 *
 * @memberOf XRegExp
 * @param {String} feature Name of the feature to check. One of:
 *   <li>`natives`
 *   <li>`astral`
 * @returns {Boolean} Whether the feature is installed.
 * @example
 *
 * XRegExp.isInstalled('natives');
 */
XRegExp.isInstalled = function (feature) {
    return !!features[feature];
};

/**
 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
 * created in another frame, when `instanceof` and `constructor` checks would fail.
 *
 * @memberOf XRegExp
 * @param {*} value Object to check.
 * @returns {Boolean} Whether the object is a `RegExp` object.
 * @example
 *
 * XRegExp.isRegExp('string'); // -> false
 * XRegExp.isRegExp(/regex/i); // -> true
 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
 */
XRegExp.isRegExp = function (value) {
    return toString.call(value) === '[object RegExp]';
    //return isType(value, 'RegExp');
};

/**
 * Returns the first matched string, or in global mode, an array containing all matched strings.
 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
 * the result types you actually want (string instead of `exec`-style array in match-first mode,
 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
 *   `scope` is 'all'.
 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
 *   mode: Array of all matched strings, or an empty array.
 * @example
 *
 * // Match first
 * XRegExp.match('abc', /\w/); // -> 'a'
 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
 * XRegExp.match('abc', /x/g, 'one'); // -> null
 *
 * // Match all
 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /x/, 'all'); // -> []
 */
XRegExp.match = function (str, regex, scope) {
    var global = regex.global && scope !== 'one' || scope === 'all',
        cacheKey = (global ? 'g' : '') + (regex.sticky ? 'y' : '') || 'noGY',
        result,
        r2;

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.exec`/`replace`
    r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
        addG: !!global,
        addY: !!regex.sticky,
        removeG: scope === 'one',
        isInternalOnly: true
    }));

    result = nativ.match.call(toObject(str), r2);

    if (regex.global) {
        regex.lastIndex = scope === 'one' && result ?
        // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
        result.index + result[0].length : 0;
    }

    return global ? result || [] : result && result[0];
};

/**
 * Retrieves the matches from searching a string using a chain of regexes that successively search
 * within previous matches. The provided `chain` array can contain regexes and or objects with
 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
 * backreference is passed forward to the next regex or returned.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} chain Regexes that each search for matches within preceding results.
 * @returns {Array} Matches by the last regex in the chain, or an empty array.
 * @example
 *
 * // Basic usage; matches numbers within <b> tags
 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
 *   XRegExp('(?is)<b>.*?</b>'),
 *   /\d+/
 * ]);
 * // -> ['2', '4', '56']
 *
 * // Passing forward and returning specific backreferences
 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
 *         <a href="http://www.google.com/">Google</a>';
 * XRegExp.matchChain(html, [
 *   {regex: /<a href="([^"]+)">/i, backref: 1},
 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
 * ]);
 * // -> ['xregexp.com', 'www.google.com']
 */
XRegExp.matchChain = function (str, chain) {
    return function recurseChain(values, level) {
        var item = chain[level].regex ? chain[level] : { regex: chain[level] },
            matches = [],
            addMatch = function addMatch(match) {
            if (item.backref) {
                /* Safari 4.0.5 (but not 5.0.5+) inappropriately uses sparse arrays to hold
                 * the `undefined`s for backreferences to nonparticipating capturing
                 * groups. In such cases, a `hasOwnProperty` or `in` check on its own would
                 * inappropriately throw the exception, so also check if the backreference
                 * is a number that is within the bounds of the array.
                 */
                if (!(match.hasOwnProperty(item.backref) || +item.backref < match.length)) {
                    throw new ReferenceError('Backreference to undefined group: ' + item.backref);
                }

                matches.push(match[item.backref] || '');
            } else {
                matches.push(match[0]);
            }
        },
            i;

        for (i = 0; i < values.length; ++i) {
            XRegExp.forEach(values[i], item.regex, addMatch);
        }

        return level === chain.length - 1 || !matches.length ? matches : recurseChain(matches, level + 1);
    }([str], 0);
};

/**
 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
 * or regex, and the replacement can be a string or a function to be called for each match. To
 * perform a global search and replace, use the optional `scope` argument or include flag g if using
 * a regex. Replacement strings can use `${n}` for named and numbered backreferences. Replacement
 * functions can use named backreferences via `arguments[0].name`. Also fixes browser bugs compared
 * to the native `String.prototype.replace` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 *   Replacement strings can include special replacement syntax:
 *     <li>$$ - Inserts a literal $ character.
 *     <li>$&, $0 - Inserts the matched substring.
 *     <li>$` - Inserts the string that precedes the matched substring (left context).
 *     <li>$' - Inserts the string that follows the matched substring (right context).
 *     <li>$n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
 *       backreference n/nn.
 *     <li>${n} - Where n is a name or any number of digits that reference an existent capturing
 *       group, inserts backreference n.
 *   Replacement functions are invoked with three or more arguments:
 *     <li>The matched substring (corresponds to $& above). Named backreferences are accessible as
 *       properties of this first argument.
 *     <li>0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
 *     <li>The zero-based index of the match within the total search string.
 *     <li>The total string being searched.
 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
 * @returns {String} New string with one or all matches replaced.
 * @example
 *
 * // Regex search, using named backreferences in replacement string
 * var name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
 * XRegExp.replace('John Smith', name, '${last}, ${first}');
 * // -> 'Smith, John'
 *
 * // Regex search, using named backreferences in replacement function
 * XRegExp.replace('John Smith', name, function(match) {
 *   return match.last + ', ' + match.first;
 * });
 * // -> 'Smith, John'
 *
 * // String search, with replace-all
 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
 * // -> 'XRegExp builds XRegExps'
 */
XRegExp.replace = function (str, search, replacement, scope) {
    var isRegex = XRegExp.isRegExp(search),
        global = search.global && scope !== 'one' || scope === 'all',
        cacheKey = (global ? 'g' : '') + (search.sticky ? 'y' : '') || 'noGY',
        s2 = search,
        result;

    if (isRegex) {
        search[REGEX_DATA] = search[REGEX_DATA] || {};

        // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
        // `lastIndex` isn't updated *during* replacement iterations
        s2 = search[REGEX_DATA][cacheKey] || (search[REGEX_DATA][cacheKey] = copyRegex(search, {
            addG: !!global,
            addY: !!search.sticky,
            removeG: scope === 'one',
            isInternalOnly: true
        }));
    } else if (global) {
        s2 = new RegExp(XRegExp.escape(String(search)), 'g');
    }

    // Fixed `replace` required for named backreferences, etc.
    result = fixed.replace.call(toObject(str), s2, replacement);

    if (isRegex && search.global) {
        // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
        search.lastIndex = 0;
    }

    return result;
};

/**
 * Performs batch processing of string replacements. Used like {@link #XRegExp.replace}, but
 * accepts an array of replacement details. Later replacements operate on the output of earlier
 * replacements. Replacement details are accepted as an array with a regex or string to search for,
 * the replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
 * replacement text syntax, which supports named backreference properties via `${name}`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} replacements Array of replacement detail arrays.
 * @returns {String} New string with all replacements.
 * @example
 *
 * str = XRegExp.replaceEach(str, [
 *   [XRegExp('(?<name>a)'), 'z${name}'],
 *   [/b/gi, 'y'],
 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
 *   [/f/g, function($0) {
 *     return $0.toUpperCase();
 *   }]
 * ]);
 */
XRegExp.replaceEach = function (str, replacements) {
    var i, r;

    for (i = 0; i < replacements.length; ++i) {
        r = replacements[i];
        str = XRegExp.replace(str, r[0], r[1], r[2]);
    }

    return str;
};

/**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * XRegExp.split('a b c', ' ');
 * // -> ['a', 'b', 'c']
 *
 * // With limit
 * XRegExp.split('a b c', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', '..']
 */
XRegExp.split = function (str, separator, limit) {
    return fixed.split.call(toObject(str), separator, limit);
};

/**
 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
 * `sticky` arguments specify the search start position, and whether the match must start at the
 * specified position only. The `lastIndex` property of the provided regex is not used, but is
 * updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.test` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Boolean} Whether the regex matched the provided value.
 * @example
 *
 * // Basic use
 * XRegExp.test('abc', /c/); // -> true
 *
 * // With pos and sticky
 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
 */
XRegExp.test = function (str, regex, pos, sticky) {
    // Do this the easy way :-)
    return !!XRegExp.exec(str, regex, pos, sticky);
};

/**
 * Uninstalls optional features according to the specified options. All optional features start out
 * uninstalled, so this is used to undo the actions of {@link #XRegExp.install}.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.uninstall({
 *   // Disables support for astral code points in Unicode addons
 *   astral: true,
 *
 *   // Restores native regex methods
 *   natives: true
 * });
 *
 * // With an options string
 * XRegExp.uninstall('astral natives');
 */
XRegExp.uninstall = function (options) {
    options = prepareOptions(options);

    if (features.astral && options.astral) {
        setAstral(false);
    }

    if (features.natives && options.natives) {
        setNatives(false);
    }
};

/**
 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
 * Backreferences in provided regex objects are automatically renumbered to work correctly within
 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
 * `flags` argument.
 *
 * @memberOf XRegExp
 * @param {Array} patterns Regexes and strings to combine.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Union of the provided regexes and strings.
 * @example
 *
 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
 */
XRegExp.union = function (patterns, flags) {
    var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*]/g,
        output = [],
        numCaptures = 0,
        numPriorCaptures,
        captureNames,
        pattern,
        rewrite = function rewrite(match, paren, backref) {
        var name = captureNames[numCaptures - numPriorCaptures];

        // Capturing group
        if (paren) {
            ++numCaptures;
            // If the current capture has a name, preserve the name
            if (name) {
                return '(?<' + name + '>';
            }
            // Backreference
        } else if (backref) {
            // Rewrite the backreference
            return '\\' + (+backref + numPriorCaptures);
        }

        return match;
    },
        i;

    if (!(isType(patterns, 'Array') && patterns.length)) {
        throw new TypeError('Must provide a nonempty array of patterns to merge');
    }

    for (i = 0; i < patterns.length; ++i) {
        pattern = patterns[i];

        if (XRegExp.isRegExp(pattern)) {
            numPriorCaptures = numCaptures;
            captureNames = pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames || [];

            // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns
            // are independently valid; helps keep this simple. Named captures are put back
            output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
        } else {
            output.push(XRegExp.escape(pattern));
        }
    }

    return XRegExp(output.join('|'), flags);
};

/* ==============================
 * Fixed/extended native methods
 * ============================== */

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `RegExp.prototype.exec`. Calling `XRegExp.install('natives')` uses this to
 * override the native method. Use via `XRegExp.exec` without overriding natives.
 *
 * @private
 * @param {String} str String to search.
 * @returns {Array} Match array with named backreference properties, or `null`.
 */
fixed.exec = function (str) {
    var origLastIndex = this.lastIndex,
        match = nativ.exec.apply(this, arguments),
        name,
        r2,
        i;

    if (match) {
        // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating
        // capturing groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of
        // older IEs. IE 9 in standards mode follows the spec
        if (!correctExecNpcg && match.length > 1 && indexOf(match, '') > -1) {
            r2 = copyRegex(this, {
                removeG: true,
                isInternalOnly: true
            });
            // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
            // matching due to characters outside the match
            nativ.replace.call(String(str).slice(match.index), r2, function () {
                var len = arguments.length,
                    i;
                // Skip index 0 and the last 2
                for (i = 1; i < len - 2; ++i) {
                    if (arguments[i] === undefined) {
                        match[i] = undefined;
                    }
                }
            });
        }

        // Attach named capture properties
        if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
            // Skip index 0
            for (i = 1; i < match.length; ++i) {
                name = this[REGEX_DATA].captureNames[i - 1];
                if (name) {
                    match[name] = match[i];
                }
            }
        }

        // Fix browsers that increment `lastIndex` after zero-length matches
        if (this.global && !match[0].length && this.lastIndex > match.index) {
            this.lastIndex = match.index;
        }
    }

    if (!this.global) {
        // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
        this.lastIndex = origLastIndex;
    }

    return match;
};

/**
 * Fixes browser bugs in the native `RegExp.prototype.test`. Calling `XRegExp.install('natives')`
 * uses this to override the native method.
 *
 * @private
 * @param {String} str String to search.
 * @returns {Boolean} Whether the regex matched the provided value.
 */
fixed.test = function (str) {
    // Do this the easy way :-)
    return !!fixed.exec.call(this, str);
};

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `String.prototype.match`. Calling `XRegExp.install('natives')` uses this to
 * override the native method.
 *
 * @private
 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
 *   the result of calling `regex.exec(this)`.
 */
fixed.match = function (regex) {
    var result;

    if (!XRegExp.isRegExp(regex)) {
        // Use the native `RegExp` rather than `XRegExp`
        regex = new RegExp(regex);
    } else if (regex.global) {
        result = nativ.match.apply(this, arguments);
        // Fixes IE bug
        regex.lastIndex = 0;

        return result;
    }

    return fixed.exec.call(regex, toObject(this));
};

/**
 * Adds support for `${n}` tokens for named and numbered backreferences in replacement text, and
 * provides named backreferences to replacement functions as `arguments[0].name`. Also fixes browser
 * bugs in replacement text syntax when performing a replacement using a nonregex search value, and
 * the value of a replacement regex's `lastIndex` property during replacement iterations and upon
 * completion. Calling `XRegExp.install('natives')` uses this to override the native method. Note
 * that this doesn't support SpiderMonkey's proprietary third (`flags`) argument. Use via
 * `XRegExp.replace` without overriding natives.
 *
 * @private
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 * @returns {String} New string with one or all matches replaced.
 */
fixed.replace = function (search, replacement) {
    var isRegex = XRegExp.isRegExp(search),
        origLastIndex,
        captureNames,
        result;

    if (isRegex) {
        if (search[REGEX_DATA]) {
            captureNames = search[REGEX_DATA].captureNames;
        }
        // Only needed if `search` is nonglobal
        origLastIndex = search.lastIndex;
    } else {
        search += ''; // Type-convert
    }

    // Don't use `typeof`; some older browsers return 'function' for regex objects
    if (isType(replacement, 'Function')) {
        // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
        // functions isn't type-converted to a string
        result = nativ.replace.call(String(this), search, function () {
            var args = arguments,
                i;
            if (captureNames) {
                // Change the `arguments[0]` string primitive to a `String` object that can
                // store properties. This really does need to use `String` as a constructor
                args[0] = new String(args[0]);
                // Store named backreferences on the first argument
                for (i = 0; i < captureNames.length; ++i) {
                    if (captureNames[i]) {
                        args[0][captureNames[i]] = args[i + 1];
                    }
                }
            }
            // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox,
            // Safari bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
            if (isRegex && search.global) {
                search.lastIndex = args[args.length - 2] + args[0].length;
            }
            // ES6 specs the context for replacement functions as `undefined`
            return replacement.apply(undefined, args);
        });
    } else {
        // Ensure that the last value of `args` will be a string when given nonstring `this`,
        // while still throwing on null or undefined context
        result = nativ.replace.call(this == null ? this : String(this), search, function () {
            // Keep this function's `arguments` available through closure
            var args = arguments;
            return nativ.replace.call(String(replacement), replacementToken, function ($0, $1, $2) {
                var n;
                // Named or numbered backreference with curly braces
                if ($1) {
                    // XRegExp behavior for `${n}`:
                    // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for
                    //    for the entire match. Any number of leading zeros may be used.
                    // 2. Backreference to named capture `n`, if it exists and is not an
                    //    integer overridden by numbered capture. In practice, this does not
                    //    overlap with numbered capture since XRegExp does not allow named
                    //    capture to use a bare integer as the name.
                    // 3. If the name or number does not refer to an existing capturing group,
                    //    it's an error.
                    n = +$1; // Type-convert; drop leading zeros
                    if (n <= args.length - 3) {
                        return args[n] || '';
                    }
                    // Groups with the same name is an error, else would need `lastIndexOf`
                    n = captureNames ? indexOf(captureNames, $1) : -1;
                    if (n < 0) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[n + 1] || '';
                }
                // Else, special variable or numbered backreference without curly braces
                if ($2 === '$') {
                    // $$
                    return '$';
                }
                if ($2 === '&' || +$2 === 0) {
                    // $&, $0 (not followed by 1-9), $00
                    return args[0];
                }
                if ($2 === '`') {
                    // $` (left context)
                    return args[args.length - 1].slice(0, args[args.length - 2]);
                }
                if ($2 === "'") {
                    // $' (right context)
                    return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
                }
                // Else, numbered backreference without curly braces
                $2 = +$2; // Type-convert; drop leading zero
                // XRegExp behavior for `$n` and `$nn`:
                // - Backrefs end after 1 or 2 digits. Use `${..}` for more digits.
                // - `$1` is an error if no capturing groups.
                // - `$10` is an error if less than 10 capturing groups. Use `${1}0` instead.
                // - `$01` is `$1` if at least one capturing group, else it's an error.
                // - `$0` (not followed by 1-9) and `$00` are the entire match.
                // Native behavior, for comparison:
                // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
                // - `$1` is a literal `$1` if no capturing groups.
                // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
                // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
                // - `$0` is a literal `$0`.
                if (!isNaN($2)) {
                    if ($2 > args.length - 3) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[$2] || '';
                }
                // `$` followed by an unsupported char is an error, unlike native JS
                throw new SyntaxError('Invalid token ' + $0);
            });
        });
    }

    if (isRegex) {
        if (search.global) {
            // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
            search.lastIndex = 0;
        } else {
            // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
            search.lastIndex = origLastIndex;
        }
    }

    return result;
};

/**
 * Fixes browser bugs in the native `String.prototype.split`. Calling `XRegExp.install('natives')`
 * uses this to override the native method. Use via `XRegExp.split` without overriding natives.
 *
 * @private
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 */
fixed.split = function (separator, limit) {
    if (!XRegExp.isRegExp(separator)) {
        // Browsers handle nonregex split correctly, so use the faster native method
        return nativ.split.apply(this, arguments);
    }

    var str = String(this),
        output = [],
        origLastIndex = separator.lastIndex,
        lastLastIndex = 0,
        lastLength;

    // Values for `limit`, per the spec:
    // If undefined: pow(2,32) - 1
    // If 0, Infinity, or NaN: 0
    // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
    // If negative number: pow(2,32) - floor(abs(limit))
    // If other: Type-convert, then use the above rules
    // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63,
    // unless Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
    limit = (limit === undefined ? -1 : limit) >>> 0;

    XRegExp.forEach(str, separator, function (match) {
        // This condition is not the same as `if (match[0].length)`
        if (match.index + match[0].length > lastLastIndex) {
            output.push(str.slice(lastLastIndex, match.index));
            if (match.length > 1 && match.index < str.length) {
                Array.prototype.push.apply(output, match.slice(1));
            }
            lastLength = match[0].length;
            lastLastIndex = match.index + lastLength;
        }
    });

    if (lastLastIndex === str.length) {
        if (!nativ.test.call(separator, '') || lastLength) {
            output.push('');
        }
    } else {
        output.push(str.slice(lastLastIndex));
    }

    separator.lastIndex = origLastIndex;
    return output.length > limit ? output.slice(0, limit) : output;
};

/* ==============================
 * Built-in syntax/flag tokens
 * ============================== */

/*
 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
 * consistency and to reserve their syntax, but lets them be superseded by addons.
 */
XRegExp.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function (match, scope) {
    // \B is allowed in default scope only
    if (match[1] === 'B' && scope === defaultScope) {
        return match[0];
    }
    throw new SyntaxError('Invalid escape ' + match[0]);
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
 * if you use the same in a character class.
 */
XRegExp.addToken(/\\u{([\dA-Fa-f]+)}/, function (match, scope, flags) {
    var code = dec(match[1]);
    if (code > 0x10FFFF) {
        throw new SyntaxError('Invalid Unicode code point ' + match[0]);
    }
    if (code <= 0xFFFF) {
        // Converting to \uNNNN avoids needing to escape the literal character and keep it
        // separate from preceding tokens
        return '\\u' + pad4(hex(code));
    }
    // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
    if (hasNativeU && flags.indexOf('u') > -1) {
        return match[0];
    }
    throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
 * character class endings can't be determined.
 */
XRegExp.addToken(/\[(\^?)]/, function (match) {
    // For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
    // (?!) should work like \b\B, but is unreliable in some versions of Firefox
    return match[1] ? '[\\s\\S]' : '\\b\\B';
}, { leadChar: '[' });

/*
 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
 * free-spacing mode (flag x).
 */
XRegExp.addToken(/\(\?#[^)]*\)/, function (match, scope, flags) {
    // Keep tokens separated unless the following token is a quantifier
    return isQuantifierNext(match.input, match.index + match[0].length, flags) ? '' : '(?:)';
}, { leadChar: '(' });

/*
 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
 */
XRegExp.addToken(/\s+|#.*/, function (match, scope, flags) {
    // Keep tokens separated unless the following token is a quantifier
    return isQuantifierNext(match.input, match.index + match[0].length, flags) ? '' : '(?:)';
}, { flag: 'x' });

/*
 * Dot, in dotall mode (aka singleline mode, flag s) only.
 */
XRegExp.addToken(/\./, function () {
    return '[\\s\\S]';
}, {
    flag: 's',
    leadChar: '.'
});

/*
 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
 * and $ only. Also allows numbered backreferences as `\k<n>`.
 */
XRegExp.addToken(/\\k<([\w$]+)>/, function (match) {
    // Groups with the same name is an error, else would need `lastIndexOf`
    var index = isNaN(match[1]) ? indexOf(this.captureNames, match[1]) + 1 : +match[1],
        endIndex = match.index + match[0].length;
    if (!index || index > this.captureNames.length) {
        throw new SyntaxError('Backreference to undefined group ' + match[0]);
    }
    // Keep backreferences separate from subsequent literal numbers
    return '\\' + index + (endIndex === match.input.length || isNaN(match.input.charAt(endIndex)) ? '' : '(?:)');
}, { leadChar: '\\' });

/*
 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
 */
XRegExp.addToken(/\\(\d+)/, function (match, scope) {
    if (!(scope === defaultScope && /^[1-9]/.test(match[1]) && +match[1] <= this.captureNames.length) && match[1] !== '0') {
        throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' + match[0]);
    }
    return match[0];
}, {
    scope: 'all',
    leadChar: '\\'
});

/*
 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
 * Python-style named capture as octals.
 */
XRegExp.addToken(/\(\?P?<([\w$]+)>/, function (match) {
    // Disallow bare integers as names because named backreferences are added to match
    // arrays and therefore numeric properties may lead to incorrect lookups
    if (!isNaN(match[1])) {
        throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
    }
    if (match[1] === 'length' || match[1] === '__proto__') {
        throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
    }
    if (indexOf(this.captureNames, match[1]) > -1) {
        throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
    }
    this.captureNames.push(match[1]);
    this.hasNamedCapture = true;
    return '(';
}, { leadChar: '(' });

/*
 * Capturing group; match the opening parenthesis only. Required for support of named capturing
 * groups. Also adds explicit capture mode (flag n).
 */
XRegExp.addToken(/\((?!\?)/, function (match, scope, flags) {
    if (flags.indexOf('n') > -1) {
        return '(?:';
    }
    this.captureNames.push(null);
    return '(';
}, {
    optionalFlags: 'n',
    leadChar: '('
});

/* ==============================
 * Expose XRegExp
 * ============================== */

module.exports = XRegExp;

},{}],"/usr/var/server.base/node_modules/brush-javascript/brush.js":[function(require,module,exports){
'use strict';

var BrushBase = require('brush-base');
var regexLib = require('syntaxhighlighter-regex').commonRegExp;

function Brush() {
  var keywords = 'break case catch class continue ' + 'default delete do else enum export extends false  ' + 'for from as function if implements import in instanceof ' + 'interface let new null package private protected ' + 'static return super switch ' + 'this throw true try typeof var while with yield';

  this.regexList = [{
    regex: regexLib.multiLineDoubleQuotedString,
    css: 'string'
  }, {
    regex: regexLib.multiLineSingleQuotedString,
    css: 'string'
  }, {
    regex: regexLib.singleLineCComments,
    css: 'comments'
  }, {
    regex: regexLib.multiLineCComments,
    css: 'comments'
  }, {
    regex: /\s*#.*/gm,
    css: 'preprocessor'
  }, {
    regex: new RegExp(this.getKeywords(keywords), 'gm'),
    css: 'keyword'
  }];

  this.forHtmlScript(regexLib.scriptScriptTags);
}

Brush.prototype = new BrushBase();
Brush.aliases = ['js', 'jscript', 'javascript', 'json'];
module.exports = Brush;

},{"brush-base":"/usr/var/server.base/node_modules/brush-javascript/node_modules/brush-base/brush-base.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/brush-base/brush-base.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/brush-base.js"][0].apply(exports,arguments)
},{"syntaxhighlighter-html-renderer":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-html-renderer/index.js","syntaxhighlighter-match":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/index.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-html-renderer/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-html-renderer/index.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/index.js"][0].apply(exports,arguments)
},{"./lib/apply-regex-list":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js","./lib/match":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/match.js"}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js"][0].apply(exports,arguments)
},{"./matches":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/matches.js"}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/match.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/match.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/matches.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/matches.js"][0].apply(exports,arguments)
},{"./match":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-match/lib/match.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-regex/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js"][0].apply(exports,arguments)
},{"./xregexp":"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-regex/xregexp.js"}],"/usr/var/server.base/node_modules/brush-javascript/node_modules/syntaxhighlighter-regex/xregexp.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/xregexp.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/brush-python/brush.js":[function(require,module,exports){
'use strict';

var BrushBase = require('brush-base');
var regexLib = require('syntaxhighlighter-regex').commonRegExp;

function Brush() {
  // Contributed by Gheorghe Milas and Ahmad Sherif

  var keywords = 'and assert break class continue def del elif else ' + 'except exec finally for from global if import in is ' + 'lambda not or pass raise return try yield while';

  var funcs = '__import__ abs all any apply basestring bin bool buffer callable ' + 'chr classmethod cmp coerce compile complex delattr dict dir ' + 'divmod enumerate eval execfile file filter float format frozenset ' + 'getattr globals hasattr hash help hex id input int intern ' + 'isinstance issubclass iter len list locals long map max min next ' + 'object oct open ord pow print property range raw_input reduce ' + 'reload repr reversed round set setattr slice sorted staticmethod ' + 'str sum super tuple type type unichr unicode vars xrange zip';

  var special = 'None True False self cls class_';

  this.regexList = [{
    regex: regexLib.singleLinePerlComments,
    css: 'comments'
  }, {
    regex: /^\s*@\w+/gm,
    css: 'decorator'
  }, {
    regex: /(['\"]{3})([^\1])*?\1/gm,
    css: 'comments'
  }, {
    regex: /"(?!")(?:\.|\\\"|[^\""\n])*"/gm,
    css: 'string'
  }, {
    regex: /'(?!')(?:\.|(\\\')|[^\''\n])*'/gm,
    css: 'string'
  }, {
    regex: /\+|\-|\*|\/|\%|=|==/gm,
    css: 'keyword'
  }, {
    regex: /\b\d+\.?\w*/g,
    css: 'value'
  }, {
    regex: new RegExp(this.getKeywords(funcs), 'gmi'),
    css: 'functions'
  }, {
    regex: new RegExp(this.getKeywords(keywords), 'gm'),
    css: 'keyword'
  }, {
    regex: new RegExp(this.getKeywords(special), 'gm'),
    css: 'color1'
  }];

  this.forHtmlScript(regexLib.aspScriptTags);
};

Brush.prototype = new BrushBase();
Brush.aliases = ['py', 'python'];
module.exports = Brush;

},{"brush-base":"/usr/var/server.base/node_modules/brush-python/node_modules/brush-base/brush-base.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-python/node_modules/brush-base/brush-base.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/brush-base.js"][0].apply(exports,arguments)
},{"syntaxhighlighter-html-renderer":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-html-renderer/index.js","syntaxhighlighter-match":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/index.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-html-renderer/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-html-renderer/index.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/index.js"][0].apply(exports,arguments)
},{"./lib/apply-regex-list":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js","./lib/match":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/match.js"}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js"][0].apply(exports,arguments)
},{"./matches":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/matches.js"}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/match.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/match.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/matches.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/matches.js"][0].apply(exports,arguments)
},{"./match":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-match/lib/match.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-regex/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js"][0].apply(exports,arguments)
},{"./xregexp":"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-regex/xregexp.js"}],"/usr/var/server.base/node_modules/brush-python/node_modules/syntaxhighlighter-regex/xregexp.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/xregexp.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/canon/lib/canon.js":[function(require,module,exports){
// Generated by CoffeeScript 1.8.0
(function() {
  var CANON, hasOwnProperty, isArguments, keys, map, nativeMap, pad, toString, _ref,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty;

  CANON = {
    version: '0.3.0'
  };

  if (typeof module !== 'undefined' && 'exports' in module) {
    module.exports = CANON;
  } else {
    window.CANON = CANON;
  }

  CANON.stringify = (function() {
    var canonicalize;
    canonicalize = function(value) {
      var key, list, _i, _len, _ref;
      if (value === null) {
        return null;
      } else if (value === void 0) {
        return ['Undefined'];
      } else if (isArguments(value)) {
        return ['Arguments'].concat(__slice.call(map(value, canonicalize)));
      } else {
        switch (toString.call(value)) {
          case '[object Array]':
            return ['Array'].concat(__slice.call(map(value, canonicalize)));
          case '[object Date]':
            return ['Date'].concat(isFinite(+value) ? value.getUTCFullYear() + '-' + pad(value.getUTCMonth() + 1) + '-' + pad(value.getUTCDate()) + 'T' + pad(value.getUTCHours()) + ':' + pad(value.getUTCMinutes()) + ':' + pad(value.getUTCSeconds()) + '.' + pad(value.getUTCMilliseconds(), 3) + 'Z' : null);
          case '[object Function]':
            throw new TypeError('Functions cannot be serialized');
            break;
          case '[object Number]':
            if (isFinite(value)) {
              return value;
            } else {
              return ['Number', "" + value];
            }
            break;
          case '[object Object]':
            list = ['Object'];
            _ref = keys(value).sort();
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              key = _ref[_i];
              list.push(key, canonicalize(value[key]));
            }
            return list;
          case '[object RegExp]':
            return ['RegExp', "" + value];
          default:
            return value;
        }
      }
    };
    return function(value) {
      if (value === 0 && 1 / value === -Infinity) {
        return '-0';
      } else {
        return JSON.stringify(canonicalize(value));
      }
    };
  })();

  CANON.parse = (function() {
    var canonicalize;
    canonicalize = function(value) {
      var element, elements, idx, month, object, rest, what, year, _i, _ref, _ref1;
      if (toString.call(value) !== '[object Array]') {
        return value;
      }
      what = value[0], elements = 2 <= value.length ? __slice.call(value, 1) : [];
      element = elements[0];
      switch (what) {
        case 'Arguments':
          return (function() {
            return arguments;
          }).apply(null, map(elements, canonicalize));
        case 'Array':
          return map(elements, canonicalize);
        case 'Date':
          _ref = map(element.match(/\d+/g), Number), year = _ref[0], month = _ref[1], rest = 3 <= _ref.length ? __slice.call(_ref, 2) : [];
          return new Date(Date.UTC.apply(Date, [year, month - 1].concat(__slice.call(rest))));
        case 'Number':
          return +element;
        case 'Object':
          object = {};
          for (idx = _i = 0, _ref1 = elements.length; _i < _ref1; idx = _i += 2) {
            object[elements[idx]] = canonicalize(elements[idx + 1]);
          }
          return object;
        case 'RegExp':
          return (function(func, args, ctor) {
            ctor.prototype = func.prototype;
            var child = new ctor, result = func.apply(child, args);
            return Object(result) === result ? result : child;
          })(RegExp, /^[/](.+)[/]([gimy]*)$/.exec(element).slice(1), function(){});
        case 'Undefined':
          return void 0;
        default:
          throw new Error('Invalid input');
      }
    };
    return function(string) {
      if (string === '-0') {
        return -0;
      } else {
        return canonicalize(JSON.parse(string));
      }
    };
  })();

  _ref = Object.prototype, hasOwnProperty = _ref.hasOwnProperty, toString = _ref.toString;

  isArguments = (function() {
    if (toString.call(arguments) === '[object Arguments]') {
      return function(value) {
        return toString.call(value) === '[object Arguments]';
      };
    } else {
      return function(value) {
        return (value != null) && hasOwnProperty.call(value, 'callee');
      };
    }
  })();

  nativeMap = Array.prototype.map;

  map = function(array, iterator) {
    var el, _i, _len, _results;
    if (nativeMap && array.map === nativeMap) {
      return array.map(iterator);
    } else {
      _results = [];
      for (_i = 0, _len = array.length; _i < _len; _i++) {
        el = array[_i];
        _results.push(iterator(el));
      }
      return _results;
    }
  };

  keys = Object.keys || function(object) {
    var key, _results;
    _results = [];
    for (key in object) {
      if (!__hasProp.call(object, key)) continue;
      _results.push(key);
    }
    return _results;
  };

  pad = function(n, min) {
    if (min == null) {
      min = 2;
    }
    return ("" + (1000 + n)).substr(4 - min);
  };

}).call(this);

},{}],"/usr/var/server.base/node_modules/codemirror/lib/codemirror.js":[function(require,module,exports){
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE

// This is CodeMirror (https://codemirror.net/5), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.CodeMirror = factory());
}(this, (function () { 'use strict';

  // Kludges for bugs and behavior differences that can't be feature
  // detected are enabled based on userAgent etc sniffing.
  var userAgent = navigator.userAgent;
  var platform = navigator.platform;

  var gecko = /gecko\/\d/i.test(userAgent);
  var ie_upto10 = /MSIE \d/.test(userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
  var edge = /Edge\/(\d+)/.exec(userAgent);
  var ie = ie_upto10 || ie_11up || edge;
  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
  var webkit = !edge && /WebKit\//.test(userAgent);
  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
  var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent);
  var chrome_version = chrome && +chrome[1];
  var presto = /Opera\//.test(userAgent);
  var safari = /Apple Computer/.test(navigator.vendor);
  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
  var phantom = /PhantomJS/.test(userAgent);

  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
  var android = /Android/.test(userAgent);
  // This is woefully incomplete. Suggestions for alternative methods welcome.
  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
  var mac = ios || /Mac/.test(platform);
  var chromeOS = /\bCrOS\b/.test(userAgent);
  var windows = /win/i.test(platform);

  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
  if (presto_version) { presto_version = Number(presto_version[1]); }
  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
  var captureRightClick = gecko || (ie && ie_version >= 9);

  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

  var rmClass = function(node, cls) {
    var current = node.className;
    var match = classTest(cls).exec(current);
    if (match) {
      var after = current.slice(match.index + match[0].length);
      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
    }
  };

  function removeChildren(e) {
    for (var count = e.childNodes.length; count > 0; --count)
      { e.removeChild(e.firstChild); }
    return e
  }

  function removeChildrenAndAdd(parent, e) {
    return removeChildren(parent).appendChild(e)
  }

  function elt(tag, content, className, style) {
    var e = document.createElement(tag);
    if (className) { e.className = className; }
    if (style) { e.style.cssText = style; }
    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
    return e
  }
  // wrapper for elt, which removes the elt from the accessibility tree
  function eltP(tag, content, className, style) {
    var e = elt(tag, content, className, style);
    e.setAttribute("role", "presentation");
    return e
  }

  var range;
  if (document.createRange) { range = function(node, start, end, endNode) {
    var r = document.createRange();
    r.setEnd(endNode || node, end);
    r.setStart(node, start);
    return r
  }; }
  else { range = function(node, start, end) {
    var r = document.body.createTextRange();
    try { r.moveToElementText(node.parentNode); }
    catch(e) { return r }
    r.collapse(true);
    r.moveEnd("character", end);
    r.moveStart("character", start);
    return r
  }; }

  function contains(parent, child) {
    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
      { child = child.parentNode; }
    if (parent.contains)
      { return parent.contains(child) }
    do {
      if (child.nodeType == 11) { child = child.host; }
      if (child == parent) { return true }
    } while (child = child.parentNode)
  }

  function activeElt(doc) {
    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
    // IE < 10 will throw when accessed while the page is loading or in an iframe.
    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
    var activeElement;
    try {
      activeElement = doc.activeElement;
    } catch(e) {
      activeElement = doc.body || null;
    }
    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
      { activeElement = activeElement.shadowRoot.activeElement; }
    return activeElement
  }

  function addClass(node, cls) {
    var current = node.className;
    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
  }
  function joinClasses(a, b) {
    var as = a.split(" ");
    for (var i = 0; i < as.length; i++)
      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
    return b
  }

  var selectInput = function(node) { node.select(); };
  if (ios) // Mobile Safari apparently has a bug where select() is broken.
    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
  else if (ie) // Suppress mysterious IE10 errors
    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

  function doc(cm) { return cm.display.wrapper.ownerDocument }

  function win(cm) { return doc(cm).defaultView }

  function bind(f) {
    var args = Array.prototype.slice.call(arguments, 1);
    return function(){return f.apply(null, args)}
  }

  function copyObj(obj, target, overwrite) {
    if (!target) { target = {}; }
    for (var prop in obj)
      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
        { target[prop] = obj[prop]; } }
    return target
  }

  // Counts the column offset in a string, taking tabs into account.
  // Used mostly to find indentation.
  function countColumn(string, end, tabSize, startIndex, startValue) {
    if (end == null) {
      end = string.search(/[^\s\u00a0]/);
      if (end == -1) { end = string.length; }
    }
    for (var i = startIndex || 0, n = startValue || 0;;) {
      var nextTab = string.indexOf("\t", i);
      if (nextTab < 0 || nextTab >= end)
        { return n + (end - i) }
      n += nextTab - i;
      n += tabSize - (n % tabSize);
      i = nextTab + 1;
    }
  }

  var Delayed = function() {
    this.id = null;
    this.f = null;
    this.time = 0;
    this.handler = bind(this.onTimeout, this);
  };
  Delayed.prototype.onTimeout = function (self) {
    self.id = 0;
    if (self.time <= +new Date) {
      self.f();
    } else {
      setTimeout(self.handler, self.time - +new Date);
    }
  };
  Delayed.prototype.set = function (ms, f) {
    this.f = f;
    var time = +new Date + ms;
    if (!this.id || time < this.time) {
      clearTimeout(this.id);
      this.id = setTimeout(this.handler, ms);
      this.time = time;
    }
  };

  function indexOf(array, elt) {
    for (var i = 0; i < array.length; ++i)
      { if (array[i] == elt) { return i } }
    return -1
  }

  // Number of pixels added to scroller and sizer to hide scrollbar
  var scrollerGap = 50;

  // Returned or thrown by various protocols to signal 'I'm not
  // handling this'.
  var Pass = {toString: function(){return "CodeMirror.Pass"}};

  // Reused option objects for setSelection & friends
  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};

  // The inverse of countColumn -- find the offset that corresponds to
  // a particular column.
  function findColumn(string, goal, tabSize) {
    for (var pos = 0, col = 0;;) {
      var nextTab = string.indexOf("\t", pos);
      if (nextTab == -1) { nextTab = string.length; }
      var skipped = nextTab - pos;
      if (nextTab == string.length || col + skipped >= goal)
        { return pos + Math.min(skipped, goal - col) }
      col += nextTab - pos;
      col += tabSize - (col % tabSize);
      pos = nextTab + 1;
      if (col >= goal) { return pos }
    }
  }

  var spaceStrs = [""];
  function spaceStr(n) {
    while (spaceStrs.length <= n)
      { spaceStrs.push(lst(spaceStrs) + " "); }
    return spaceStrs[n]
  }

  function lst(arr) { return arr[arr.length-1] }

  function map(array, f) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
    return out
  }

  function insertSorted(array, value, score) {
    var pos = 0, priority = score(value);
    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
    array.splice(pos, 0, value);
  }

  function nothing() {}

  function createObj(base, props) {
    var inst;
    if (Object.create) {
      inst = Object.create(base);
    } else {
      nothing.prototype = base;
      inst = new nothing();
    }
    if (props) { copyObj(props, inst); }
    return inst
  }

  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
  function isWordCharBasic(ch) {
    return /\w/.test(ch) || ch > "\x80" &&
      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
  }
  function isWordChar(ch, helper) {
    if (!helper) { return isWordCharBasic(ch) }
    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
    return helper.test(ch)
  }

  function isEmpty(obj) {
    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
    return true
  }

  // Extending unicode characters. A series of a non-extending char +
  // any number of extending chars is treated as a single unit as far
  // as editing and measuring is concerned. This is not fully correct,
  // since some scripts/fonts/browsers also treat other configurations
  // of code points as a group.
  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
  function skipExtendingChars(str, pos, dir) {
    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
    return pos
  }

  // Returns the value from the range [`from`; `to`] that satisfies
  // `pred` and is closest to `from`. Assumes that at least `to`
  // satisfies `pred`. Supports `from` being greater than `to`.
  function findFirst(pred, from, to) {
    // At any point we are certain `to` satisfies `pred`, don't know
    // whether `from` does.
    var dir = from > to ? -1 : 1;
    for (;;) {
      if (from == to) { return from }
      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
      if (mid == from) { return pred(mid) ? from : to }
      if (pred(mid)) { to = mid; }
      else { from = mid + dir; }
    }
  }

  // BIDI HELPERS

  function iterateBidiSections(order, from, to, f) {
    if (!order) { return f(from, to, "ltr", 0) }
    var found = false;
    for (var i = 0; i < order.length; ++i) {
      var part = order[i];
      if (part.from < to && part.to > from || from == to && part.to == from) {
        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
        found = true;
      }
    }
    if (!found) { f(from, to, "ltr"); }
  }

  var bidiOther = null;
  function getBidiPartAt(order, ch, sticky) {
    var found;
    bidiOther = null;
    for (var i = 0; i < order.length; ++i) {
      var cur = order[i];
      if (cur.from < ch && cur.to > ch) { return i }
      if (cur.to == ch) {
        if (cur.from != cur.to && sticky == "before") { found = i; }
        else { bidiOther = i; }
      }
      if (cur.from == ch) {
        if (cur.from != cur.to && sticky != "before") { found = i; }
        else { bidiOther = i; }
      }
    }
    return found != null ? found : bidiOther
  }

  // Bidirectional ordering algorithm
  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
  // that this (partially) implements.

  // One-char codes used for character types:
  // L (L):   Left-to-Right
  // R (R):   Right-to-Left
  // r (AL):  Right-to-Left Arabic
  // 1 (EN):  European Number
  // + (ES):  European Number Separator
  // % (ET):  European Number Terminator
  // n (AN):  Arabic Number
  // , (CS):  Common Number Separator
  // m (NSM): Non-Spacing Mark
  // b (BN):  Boundary Neutral
  // s (B):   Paragraph Separator
  // t (S):   Segment Separator
  // w (WS):  Whitespace
  // N (ON):  Other Neutrals

  // Returns null if characters are ordered as they appear
  // (left-to-right), or an array of sections ({from, to, level}
  // objects) in the order in which they occur visually.
  var bidiOrdering = (function() {
    // Character types for codepoints 0 to 0xff
    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
    // Character types for codepoints 0x600 to 0x6f9
    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
    function charType(code) {
      if (code <= 0xf7) { return lowTypes.charAt(code) }
      else if (0x590 <= code && code <= 0x5f4) { return "R" }
      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
      else if (0x2000 <= code && code <= 0x200b) { return "w" }
      else if (code == 0x200c) { return "b" }
      else { return "L" }
    }

    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

    function BidiSpan(level, from, to) {
      this.level = level;
      this.from = from; this.to = to;
    }

    return function(str, direction) {
      var outerType = direction == "ltr" ? "L" : "R";

      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
      var len = str.length, types = [];
      for (var i = 0; i < len; ++i)
        { types.push(charType(str.charCodeAt(i))); }

      // W1. Examine each non-spacing mark (NSM) in the level run, and
      // change the type of the NSM to the type of the previous
      // character. If the NSM is at the start of the level run, it will
      // get the type of sor.
      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
        var type = types[i$1];
        if (type == "m") { types[i$1] = prev; }
        else { prev = type; }
      }

      // W2. Search backwards from each instance of a European number
      // until the first strong type (R, L, AL, or sor) is found. If an
      // AL is found, change the type of the European number to Arabic
      // number.
      // W3. Change all ALs to R.
      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
        var type$1 = types[i$2];
        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
      }

      // W4. A single European separator between two European numbers
      // changes to a European number. A single common separator between
      // two numbers of the same type changes to that type.
      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
        var type$2 = types[i$3];
        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
        else if (type$2 == "," && prev$1 == types[i$3+1] &&
                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
        prev$1 = type$2;
      }

      // W5. A sequence of European terminators adjacent to European
      // numbers changes to all European numbers.
      // W6. Otherwise, separators and terminators change to Other
      // Neutral.
      for (var i$4 = 0; i$4 < len; ++i$4) {
        var type$3 = types[i$4];
        if (type$3 == ",") { types[i$4] = "N"; }
        else if (type$3 == "%") {
          var end = (void 0);
          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
          for (var j = i$4; j < end; ++j) { types[j] = replace; }
          i$4 = end - 1;
        }
      }

      // W7. Search backwards from each instance of a European number
      // until the first strong type (R, L, or sor) is found. If an L is
      // found, then change the type of the European number to L.
      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
        var type$4 = types[i$5];
        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
        else if (isStrong.test(type$4)) { cur$1 = type$4; }
      }

      // N1. A sequence of neutrals takes the direction of the
      // surrounding strong text if the text on both sides has the same
      // direction. European and Arabic numbers act as if they were R in
      // terms of their influence on neutrals. Start-of-level-run (sor)
      // and end-of-level-run (eor) are used at level run boundaries.
      // N2. Any remaining neutrals take the embedding direction.
      for (var i$6 = 0; i$6 < len; ++i$6) {
        if (isNeutral.test(types[i$6])) {
          var end$1 = (void 0);
          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
          var before = (i$6 ? types[i$6-1] : outerType) == "L";
          var after = (end$1 < len ? types[end$1] : outerType) == "L";
          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
          i$6 = end$1 - 1;
        }
      }

      // Here we depart from the documented algorithm, in order to avoid
      // building up an actual levels array. Since there are only three
      // levels (0, 1, 2) in an implementation that doesn't take
      // explicit embedding into account, we can build up the order on
      // the fly, without following the level-based algorithm.
      var order = [], m;
      for (var i$7 = 0; i$7 < len;) {
        if (countsAsLeft.test(types[i$7])) {
          var start = i$7;
          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
          order.push(new BidiSpan(0, start, i$7));
        } else {
          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
          for (var j$2 = pos; j$2 < i$7;) {
            if (countsAsNum.test(types[j$2])) {
              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
              var nstart = j$2;
              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
              at += isRTL;
              pos = j$2;
            } else { ++j$2; }
          }
          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
        }
      }
      if (direction == "ltr") {
        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
          order[0].from = m[0].length;
          order.unshift(new BidiSpan(0, 0, m[0].length));
        }
        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
          lst(order).to -= m[0].length;
          order.push(new BidiSpan(0, len - m[0].length, len));
        }
      }

      return direction == "rtl" ? order.reverse() : order
    }
  })();

  // Get the bidi ordering for the given line (and cache it). Returns
  // false for lines that are fully left-to-right, and an array of
  // BidiSpan objects otherwise.
  function getOrder(line, direction) {
    var order = line.order;
    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
    return order
  }

  // EVENT HANDLING

  // Lightweight event framework. on/off also work on DOM nodes,
  // registering native DOM handlers.

  var noHandlers = [];

  var on = function(emitter, type, f) {
    if (emitter.addEventListener) {
      emitter.addEventListener(type, f, false);
    } else if (emitter.attachEvent) {
      emitter.attachEvent("on" + type, f);
    } else {
      var map = emitter._handlers || (emitter._handlers = {});
      map[type] = (map[type] || noHandlers).concat(f);
    }
  };

  function getHandlers(emitter, type) {
    return emitter._handlers && emitter._handlers[type] || noHandlers
  }

  function off(emitter, type, f) {
    if (emitter.removeEventListener) {
      emitter.removeEventListener(type, f, false);
    } else if (emitter.detachEvent) {
      emitter.detachEvent("on" + type, f);
    } else {
      var map = emitter._handlers, arr = map && map[type];
      if (arr) {
        var index = indexOf(arr, f);
        if (index > -1)
          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
      }
    }
  }

  function signal(emitter, type /*, values...*/) {
    var handlers = getHandlers(emitter, type);
    if (!handlers.length) { return }
    var args = Array.prototype.slice.call(arguments, 2);
    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
  }

  // The DOM events that CodeMirror handles can be overridden by
  // registering a (non-DOM) handler on the editor for the event name,
  // and preventDefault-ing the event in that handler.
  function signalDOMEvent(cm, e, override) {
    if (typeof e == "string")
      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
    signal(cm, override || e.type, cm, e);
    return e_defaultPrevented(e) || e.codemirrorIgnore
  }

  function signalCursorActivity(cm) {
    var arr = cm._handlers && cm._handlers.cursorActivity;
    if (!arr) { return }
    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
      { set.push(arr[i]); } }
  }

  function hasHandler(emitter, type) {
    return getHandlers(emitter, type).length > 0
  }

  // Add on and off methods to a constructor's prototype, to make
  // registering events on such objects more convenient.
  function eventMixin(ctor) {
    ctor.prototype.on = function(type, f) {on(this, type, f);};
    ctor.prototype.off = function(type, f) {off(this, type, f);};
  }

  // Due to the fact that we still support jurassic IE versions, some
  // compatibility wrappers are needed.

  function e_preventDefault(e) {
    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
  }
  function e_stopPropagation(e) {
    if (e.stopPropagation) { e.stopPropagation(); }
    else { e.cancelBubble = true; }
  }
  function e_defaultPrevented(e) {
    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
  }
  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

  function e_target(e) {return e.target || e.srcElement}
  function e_button(e) {
    var b = e.which;
    if (b == null) {
      if (e.button & 1) { b = 1; }
      else if (e.button & 2) { b = 3; }
      else if (e.button & 4) { b = 2; }
    }
    if (mac && e.ctrlKey && b == 1) { b = 3; }
    return b
  }

  // Detect drag-and-drop
  var dragAndDrop = function() {
    // There is *some* kind of drag-and-drop support in IE6-8, but I
    // couldn't get it to work yet.
    if (ie && ie_version < 9) { return false }
    var div = elt('div');
    return "draggable" in div || "dragDrop" in div
  }();

  var zwspSupported;
  function zeroWidthElement(measure) {
    if (zwspSupported == null) {
      var test = elt("span", "\u200b");
      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
      if (measure.firstChild.offsetHeight != 0)
        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
    }
    var node = zwspSupported ? elt("span", "\u200b") :
      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
    node.setAttribute("cm-text", "");
    return node
  }

  // Feature-detect IE's crummy client rect reporting for bidi text
  var badBidiRects;
  function hasBadBidiRects(measure) {
    if (badBidiRects != null) { return badBidiRects }
    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
    var r0 = range(txt, 0, 1).getBoundingClientRect();
    var r1 = range(txt, 1, 2).getBoundingClientRect();
    removeChildren(measure);
    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
    return badBidiRects = (r1.right - r0.right < 3)
  }

  // See if "".split is the broken IE version, if so, provide an
  // alternative way to split lines.
  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
    var pos = 0, result = [], l = string.length;
    while (pos <= l) {
      var nl = string.indexOf("\n", pos);
      if (nl == -1) { nl = string.length; }
      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
      var rt = line.indexOf("\r");
      if (rt != -1) {
        result.push(line.slice(0, rt));
        pos += rt + 1;
      } else {
        result.push(line);
        pos = nl + 1;
      }
    }
    return result
  } : function (string) { return string.split(/\r\n?|\n/); };

  var hasSelection = window.getSelection ? function (te) {
    try { return te.selectionStart != te.selectionEnd }
    catch(e) { return false }
  } : function (te) {
    var range;
    try {range = te.ownerDocument.selection.createRange();}
    catch(e) {}
    if (!range || range.parentElement() != te) { return false }
    return range.compareEndPoints("StartToEnd", range) != 0
  };

  var hasCopyEvent = (function () {
    var e = elt("div");
    if ("oncopy" in e) { return true }
    e.setAttribute("oncopy", "return;");
    return typeof e.oncopy == "function"
  })();

  var badZoomedRects = null;
  function hasBadZoomedRects(measure) {
    if (badZoomedRects != null) { return badZoomedRects }
    var node = removeChildrenAndAdd(measure, elt("span", "x"));
    var normal = node.getBoundingClientRect();
    var fromRange = range(node, 0, 1).getBoundingClientRect();
    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
  }

  // Known modes, by name and by MIME
  var modes = {}, mimeModes = {};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  function defineMode(name, mode) {
    if (arguments.length > 2)
      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
    modes[name] = mode;
  }

  function defineMIME(mime, spec) {
    mimeModes[mime] = spec;
  }

  // Given a MIME type, a {name, ...options} config object, or a name
  // string, return a mode config object.
  function resolveMode(spec) {
    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
      spec = mimeModes[spec];
    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
      var found = mimeModes[spec.name];
      if (typeof found == "string") { found = {name: found}; }
      spec = createObj(found, spec);
      spec.name = found.name;
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
      return resolveMode("application/xml")
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
      return resolveMode("application/json")
    }
    if (typeof spec == "string") { return {name: spec} }
    else { return spec || {name: "null"} }
  }

  // Given a mode spec (anything that resolveMode accepts), find and
  // initialize an actual mode object.
  function getMode(options, spec) {
    spec = resolveMode(spec);
    var mfactory = modes[spec.name];
    if (!mfactory) { return getMode(options, "text/plain") }
    var modeObj = mfactory(options, spec);
    if (modeExtensions.hasOwnProperty(spec.name)) {
      var exts = modeExtensions[spec.name];
      for (var prop in exts) {
        if (!exts.hasOwnProperty(prop)) { continue }
        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
        modeObj[prop] = exts[prop];
      }
    }
    modeObj.name = spec.name;
    if (spec.helperType) { modeObj.helperType = spec.helperType; }
    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
      { modeObj[prop$1] = spec.modeProps[prop$1]; } }

    return modeObj
  }

  // This can be used to attach properties to mode objects from
  // outside the actual mode definition.
  var modeExtensions = {};
  function extendMode(mode, properties) {
    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
    copyObj(properties, exts);
  }

  function copyState(mode, state) {
    if (state === true) { return state }
    if (mode.copyState) { return mode.copyState(state) }
    var nstate = {};
    for (var n in state) {
      var val = state[n];
      if (val instanceof Array) { val = val.concat([]); }
      nstate[n] = val;
    }
    return nstate
  }

  // Given a mode and a state (for that mode), find the inner mode and
  // state at the position that the state refers to.
  function innerMode(mode, state) {
    var info;
    while (mode.innerMode) {
      info = mode.innerMode(state);
      if (!info || info.mode == mode) { break }
      state = info.state;
      mode = info.mode;
    }
    return info || {mode: mode, state: state}
  }

  function startState(mode, a1, a2) {
    return mode.startState ? mode.startState(a1, a2) : true
  }

  // STRING STREAM

  // Fed to the mode parsers, provides helper functions to make
  // parsers more succinct.

  var StringStream = function(string, tabSize, lineOracle) {
    this.pos = this.start = 0;
    this.string = string;
    this.tabSize = tabSize || 8;
    this.lastColumnPos = this.lastColumnValue = 0;
    this.lineStart = 0;
    this.lineOracle = lineOracle;
  };

  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
  StringStream.prototype.next = function () {
    if (this.pos < this.string.length)
      { return this.string.charAt(this.pos++) }
  };
  StringStream.prototype.eat = function (match) {
    var ch = this.string.charAt(this.pos);
    var ok;
    if (typeof match == "string") { ok = ch == match; }
    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
    if (ok) {++this.pos; return ch}
  };
  StringStream.prototype.eatWhile = function (match) {
    var start = this.pos;
    while (this.eat(match)){}
    return this.pos > start
  };
  StringStream.prototype.eatSpace = function () {
    var start = this.pos;
    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
    return this.pos > start
  };
  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
  StringStream.prototype.skipTo = function (ch) {
    var found = this.string.indexOf(ch, this.pos);
    if (found > -1) {this.pos = found; return true}
  };
  StringStream.prototype.backUp = function (n) {this.pos -= n;};
  StringStream.prototype.column = function () {
    if (this.lastColumnPos < this.start) {
      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
      this.lastColumnPos = this.start;
    }
    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.indentation = function () {
    return countColumn(this.string, null, this.tabSize) -
      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
    if (typeof pattern == "string") {
      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
      var substr = this.string.substr(this.pos, pattern.length);
      if (cased(substr) == cased(pattern)) {
        if (consume !== false) { this.pos += pattern.length; }
        return true
      }
    } else {
      var match = this.string.slice(this.pos).match(pattern);
      if (match && match.index > 0) { return null }
      if (match && consume !== false) { this.pos += match[0].length; }
      return match
    }
  };
  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
  StringStream.prototype.hideFirstChars = function (n, inner) {
    this.lineStart += n;
    try { return inner() }
    finally { this.lineStart -= n; }
  };
  StringStream.prototype.lookAhead = function (n) {
    var oracle = this.lineOracle;
    return oracle && oracle.lookAhead(n)
  };
  StringStream.prototype.baseToken = function () {
    var oracle = this.lineOracle;
    return oracle && oracle.baseToken(this.pos)
  };

  // Find the line object corresponding to the given line number.
  function getLine(doc, n) {
    n -= doc.first;
    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
    var chunk = doc;
    while (!chunk.lines) {
      for (var i = 0;; ++i) {
        var child = chunk.children[i], sz = child.chunkSize();
        if (n < sz) { chunk = child; break }
        n -= sz;
      }
    }
    return chunk.lines[n]
  }

  // Get the part of a document between two positions, as an array of
  // strings.
  function getBetween(doc, start, end) {
    var out = [], n = start.line;
    doc.iter(start.line, end.line + 1, function (line) {
      var text = line.text;
      if (n == end.line) { text = text.slice(0, end.ch); }
      if (n == start.line) { text = text.slice(start.ch); }
      out.push(text);
      ++n;
    });
    return out
  }
  // Get the lines between from and to, as array of strings.
  function getLines(doc, from, to) {
    var out = [];
    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
    return out
  }

  // Update the height of a line, propagating the height change
  // upwards to parent nodes.
  function updateLineHeight(line, height) {
    var diff = height - line.height;
    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
  }

  // Given a line object, find its line number by walking up through
  // its parent links.
  function lineNo(line) {
    if (line.parent == null) { return null }
    var cur = line.parent, no = indexOf(cur.lines, line);
    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
      for (var i = 0;; ++i) {
        if (chunk.children[i] == cur) { break }
        no += chunk.children[i].chunkSize();
      }
    }
    return no + cur.first
  }

  // Find the line at the given vertical position, using the height
  // information in the document tree.
  function lineAtHeight(chunk, h) {
    var n = chunk.first;
    outer: do {
      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
        var child = chunk.children[i$1], ch = child.height;
        if (h < ch) { chunk = child; continue outer }
        h -= ch;
        n += child.chunkSize();
      }
      return n
    } while (!chunk.lines)
    var i = 0;
    for (; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i], lh = line.height;
      if (h < lh) { break }
      h -= lh;
    }
    return n + i
  }

  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

  function lineNumberFor(options, i) {
    return String(options.lineNumberFormatter(i + options.firstLineNumber))
  }

  // A Pos instance represents a position within the text.
  function Pos(line, ch, sticky) {
    if ( sticky === void 0 ) sticky = null;

    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
    this.line = line;
    this.ch = ch;
    this.sticky = sticky;
  }

  // Compare two positions, return 0 if they are the same, a negative
  // number when a is less, and a positive number otherwise.
  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

  function copyPos(x) {return Pos(x.line, x.ch)}
  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

  // Most of the external API clips given positions to make sure they
  // actually exist within the document.
  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
  function clipPos(doc, pos) {
    if (pos.line < doc.first) { return Pos(doc.first, 0) }
    var last = doc.first + doc.size - 1;
    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
    return clipToLen(pos, getLine(doc, pos.line).text.length)
  }
  function clipToLen(pos, linelen) {
    var ch = pos.ch;
    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
    else if (ch < 0) { return Pos(pos.line, 0) }
    else { return pos }
  }
  function clipPosArray(doc, array) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
    return out
  }

  var SavedContext = function(state, lookAhead) {
    this.state = state;
    this.lookAhead = lookAhead;
  };

  var Context = function(doc, state, line, lookAhead) {
    this.state = state;
    this.doc = doc;
    this.line = line;
    this.maxLookAhead = lookAhead || 0;
    this.baseTokens = null;
    this.baseTokenPos = 1;
  };

  Context.prototype.lookAhead = function (n) {
    var line = this.doc.getLine(this.line + n);
    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
    return line
  };

  Context.prototype.baseToken = function (n) {
    if (!this.baseTokens) { return null }
    while (this.baseTokens[this.baseTokenPos] <= n)
      { this.baseTokenPos += 2; }
    var type = this.baseTokens[this.baseTokenPos + 1];
    return {type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n}
  };

  Context.prototype.nextLine = function () {
    this.line++;
    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
  };

  Context.fromSaved = function (doc, saved, line) {
    if (saved instanceof SavedContext)
      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
    else
      { return new Context(doc, copyState(doc.mode, saved), line) }
  };

  Context.prototype.save = function (copy) {
    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
  };


  // Compute a style array (an array starting with a mode generation
  // -- for invalidation -- followed by pairs of end positions and
  // style strings), which is used to highlight the tokens on the
  // line.
  function highlightLine(cm, line, context, forceToEnd) {
    // A styles array always starts with a number identifying the
    // mode/overlays that it is based on (for easy invalidation).
    var st = [cm.state.modeGen], lineClasses = {};
    // Compute the base array of styles
    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
            lineClasses, forceToEnd);
    var state = context.state;

    // Run overlays, adjust style array.
    var loop = function ( o ) {
      context.baseTokens = st;
      var overlay = cm.state.overlays[o], i = 1, at = 0;
      context.state = true;
      runMode(cm, line.text, overlay.mode, context, function (end, style) {
        var start = i;
        // Ensure there's a token end at the current position, and that i points at it
        while (at < end) {
          var i_end = st[i];
          if (i_end > end)
            { st.splice(i, 1, end, st[i+1], i_end); }
          i += 2;
          at = Math.min(end, i_end);
        }
        if (!style) { return }
        if (overlay.opaque) {
          st.splice(start, i - start, end, "overlay " + style);
          i = start + 2;
        } else {
          for (; start < i; start += 2) {
            var cur = st[start+1];
            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
          }
        }
      }, lineClasses);
      context.state = state;
      context.baseTokens = null;
      context.baseTokenPos = 1;
    };

    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
  }

  function getLineStyles(cm, line, updateFrontier) {
    if (!line.styles || line.styles[0] != cm.state.modeGen) {
      var context = getContextBefore(cm, lineNo(line));
      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
      var result = highlightLine(cm, line, context);
      if (resetState) { context.state = resetState; }
      line.stateAfter = context.save(!resetState);
      line.styles = result.styles;
      if (result.classes) { line.styleClasses = result.classes; }
      else if (line.styleClasses) { line.styleClasses = null; }
      if (updateFrontier === cm.doc.highlightFrontier)
        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
    }
    return line.styles
  }

  function getContextBefore(cm, n, precise) {
    var doc = cm.doc, display = cm.display;
    if (!doc.mode.startState) { return new Context(doc, true, n) }
    var start = findStartLine(cm, n, precise);
    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

    doc.iter(start, n, function (line) {
      processLine(cm, line.text, context);
      var pos = context.line;
      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
      context.nextLine();
    });
    if (precise) { doc.modeFrontier = context.line; }
    return context
  }

  // Lightweight form of highlight -- proceed over this line and
  // update state, but don't save a style array. Used for lines that
  // aren't currently visible.
  function processLine(cm, text, context, startAt) {
    var mode = cm.doc.mode;
    var stream = new StringStream(text, cm.options.tabSize, context);
    stream.start = stream.pos = startAt || 0;
    if (text == "") { callBlankLine(mode, context.state); }
    while (!stream.eol()) {
      readToken(mode, stream, context.state);
      stream.start = stream.pos;
    }
  }

  function callBlankLine(mode, state) {
    if (mode.blankLine) { return mode.blankLine(state) }
    if (!mode.innerMode) { return }
    var inner = innerMode(mode, state);
    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
  }

  function readToken(mode, stream, state, inner) {
    for (var i = 0; i < 10; i++) {
      if (inner) { inner[0] = innerMode(mode, state).mode; }
      var style = mode.token(stream, state);
      if (stream.pos > stream.start) { return style }
    }
    throw new Error("Mode " + mode.name + " failed to advance stream.")
  }

  var Token = function(stream, type, state) {
    this.start = stream.start; this.end = stream.pos;
    this.string = stream.current();
    this.type = type || null;
    this.state = state;
  };

  // Utility for getTokenAt and getLineTokens
  function takeToken(cm, pos, precise, asArray) {
    var doc = cm.doc, mode = doc.mode, style;
    pos = clipPos(doc, pos);
    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
    if (asArray) { tokens = []; }
    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
      stream.start = stream.pos;
      style = readToken(mode, stream, context.state);
      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
    }
    return asArray ? tokens : new Token(stream, style, context.state)
  }

  function extractLineClasses(type, output) {
    if (type) { for (;;) {
      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
      if (!lineClass) { break }
      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
      var prop = lineClass[1] ? "bgClass" : "textClass";
      if (output[prop] == null)
        { output[prop] = lineClass[2]; }
      else if (!(new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)")).test(output[prop]))
        { output[prop] += " " + lineClass[2]; }
    } }
    return type
  }

  // Run the given mode's parser over a line, calling f for each token.
  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
    var flattenSpans = mode.flattenSpans;
    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
    var curStart = 0, curStyle = null;
    var stream = new StringStream(text, cm.options.tabSize, context), style;
    var inner = cm.options.addModeClass && [null];
    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
    while (!stream.eol()) {
      if (stream.pos > cm.options.maxHighlightLength) {
        flattenSpans = false;
        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
        stream.pos = text.length;
        style = null;
      } else {
        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
      }
      if (inner) {
        var mName = inner[0].name;
        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
      }
      if (!flattenSpans || curStyle != style) {
        while (curStart < stream.start) {
          curStart = Math.min(stream.start, curStart + 5000);
          f(curStart, curStyle);
        }
        curStyle = style;
      }
      stream.start = stream.pos;
    }
    while (curStart < stream.pos) {
      // Webkit seems to refuse to render text nodes longer than 57444
      // characters, and returns inaccurate measurements in nodes
      // starting around 5000 chars.
      var pos = Math.min(stream.pos, curStart + 5000);
      f(pos, curStyle);
      curStart = pos;
    }
  }

  // Finds the line to start with when starting a parse. Tries to
  // find a line with a stateAfter, so that it can start with a
  // valid state. If that fails, it returns the line with the
  // smallest indentation, which tends to need the least context to
  // parse correctly.
  function findStartLine(cm, n, precise) {
    var minindent, minline, doc = cm.doc;
    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
    for (var search = n; search > lim; --search) {
      if (search <= doc.first) { return doc.first }
      var line = getLine(doc, search - 1), after = line.stateAfter;
      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
        { return search }
      var indented = countColumn(line.text, null, cm.options.tabSize);
      if (minline == null || minindent > indented) {
        minline = search - 1;
        minindent = indented;
      }
    }
    return minline
  }

  function retreatFrontier(doc, n) {
    doc.modeFrontier = Math.min(doc.modeFrontier, n);
    if (doc.highlightFrontier < n - 10) { return }
    var start = doc.first;
    for (var line = n - 1; line > start; line--) {
      var saved = getLine(doc, line).stateAfter;
      // change is on 3
      // state on line 1 looked ahead 2 -- so saw 3
      // test 1 + 2 < 3 should cover this
      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
        start = line + 1;
        break
      }
    }
    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
  }

  // Optimize some code when these features are not used.
  var sawReadOnlySpans = false, sawCollapsedSpans = false;

  function seeReadOnlySpans() {
    sawReadOnlySpans = true;
  }

  function seeCollapsedSpans() {
    sawCollapsedSpans = true;
  }

  // TEXTMARKER SPANS

  function MarkedSpan(marker, from, to) {
    this.marker = marker;
    this.from = from; this.to = to;
  }

  // Search an array of spans for a span matching the given marker.
  function getMarkedSpanFor(spans, marker) {
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.marker == marker) { return span }
    } }
  }

  // Remove a span from an array, returning undefined if no spans are
  // left (we don't store arrays for lines without spans).
  function removeMarkedSpan(spans, span) {
    var r;
    for (var i = 0; i < spans.length; ++i)
      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
    return r
  }

  // Add a span to a line.
  function addMarkedSpan(line, span, op) {
    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
    if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) {
      line.markedSpans.push(span);
    } else {
      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
      if (inThisOp) { inThisOp.add(line.markedSpans); }
    }
    span.marker.attachLine(line);
  }

  // Used for the algorithm that adjusts markers for a change in the
  // document. These functions cut an array of spans at a given
  // character position, returning an array of remaining chunks (or
  // undefined if nothing remains).
  function markedSpansBefore(old, startCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
      }
    } }
    return nw
  }
  function markedSpansAfter(old, endCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                              span.to == null ? null : span.to - endCh));
      }
    } }
    return nw
  }

  // Given a change object, compute the new set of marker spans that
  // cover the line in which the change took place. Removes spans
  // entirely within the change, reconnects spans belonging to the
  // same marker that appear on both sides of the change, and cuts off
  // spans partially within the change. Returns an array of span
  // arrays with one element for each line in (after) the change.
  function stretchSpansOverChange(doc, change) {
    if (change.full) { return null }
    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
    if (!oldFirst && !oldLast) { return null }

    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
    // Get the spans that 'stick out' on both sides
    var first = markedSpansBefore(oldFirst, startCh, isInsert);
    var last = markedSpansAfter(oldLast, endCh, isInsert);

    // Next, merge those two ends
    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
    if (first) {
      // Fix up .to properties of first
      for (var i = 0; i < first.length; ++i) {
        var span = first[i];
        if (span.to == null) {
          var found = getMarkedSpanFor(last, span.marker);
          if (!found) { span.to = startCh; }
          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
        }
      }
    }
    if (last) {
      // Fix up .from in last (or move them into first in case of sameLine)
      for (var i$1 = 0; i$1 < last.length; ++i$1) {
        var span$1 = last[i$1];
        if (span$1.to != null) { span$1.to += offset; }
        if (span$1.from == null) {
          var found$1 = getMarkedSpanFor(first, span$1.marker);
          if (!found$1) {
            span$1.from = offset;
            if (sameLine) { (first || (first = [])).push(span$1); }
          }
        } else {
          span$1.from += offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      }
    }
    // Make sure we didn't create any zero-length spans
    if (first) { first = clearEmptySpans(first); }
    if (last && last != first) { last = clearEmptySpans(last); }

    var newMarkers = [first];
    if (!sameLine) {
      // Fill gap with whole-line-spans
      var gap = change.text.length - 2, gapMarkers;
      if (gap > 0 && first)
        { for (var i$2 = 0; i$2 < first.length; ++i$2)
          { if (first[i$2].to == null)
            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
      for (var i$3 = 0; i$3 < gap; ++i$3)
        { newMarkers.push(gapMarkers); }
      newMarkers.push(last);
    }
    return newMarkers
  }

  // Remove spans that are empty and don't have a clearWhenEmpty
  // option of false.
  function clearEmptySpans(spans) {
    for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
        { spans.splice(i--, 1); }
    }
    if (!spans.length) { return null }
    return spans
  }

  // Used to 'clip' out readOnly ranges when making a change.
  function removeReadOnlyRanges(doc, from, to) {
    var markers = null;
    doc.iter(from.line, to.line + 1, function (line) {
      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
        var mark = line.markedSpans[i].marker;
        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
          { (markers || (markers = [])).push(mark); }
      } }
    });
    if (!markers) { return null }
    var parts = [{from: from, to: to}];
    for (var i = 0; i < markers.length; ++i) {
      var mk = markers[i], m = mk.find(0);
      for (var j = 0; j < parts.length; ++j) {
        var p = parts[j];
        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
          { newParts.push({from: p.from, to: m.from}); }
        if (dto > 0 || !mk.inclusiveRight && !dto)
          { newParts.push({from: m.to, to: p.to}); }
        parts.splice.apply(parts, newParts);
        j += newParts.length - 3;
      }
    }
    return parts
  }

  // Connect or disconnect spans from a line.
  function detachMarkedSpans(line) {
    var spans = line.markedSpans;
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.detachLine(line); }
    line.markedSpans = null;
  }
  function attachMarkedSpans(line, spans) {
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.attachLine(line); }
    line.markedSpans = spans;
  }

  // Helpers used when computing which overlapping collapsed span
  // counts as the larger one.
  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

  // Returns a number indicating which of two overlapping collapsed
  // spans is larger (and thus includes the other). Falls back to
  // comparing ids when the spans cover exactly the same range.
  function compareCollapsedMarkers(a, b) {
    var lenDiff = a.lines.length - b.lines.length;
    if (lenDiff != 0) { return lenDiff }
    var aPos = a.find(), bPos = b.find();
    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
    if (fromCmp) { return -fromCmp }
    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
    if (toCmp) { return toCmp }
    return b.id - a.id
  }

  // Find out whether a line ends or starts in a collapsed span. If
  // so, return the marker for that span.
  function collapsedSpanAtSide(line, start) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
        { found = sp.marker; }
    } }
    return found
  }
  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

  function collapsedSpanAround(line, ch) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
    } }
    return found
  }

  // Test whether there exists a collapsed span that partially
  // overlaps (covers the start or end, but not both) of a new span.
  // Such overlap is not allowed.
  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
    var line = getLine(doc, lineNo);
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      var found = sp.marker.find(0);
      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
        { return true }
    } }
  }

  // A visual line is a line as drawn on the screen. Folding, for
  // example, can cause multiple logical lines to appear on the same
  // visual line. This finds the start of the visual line that the
  // given line is part of (usually that is the line itself).
  function visualLine(line) {
    var merged;
    while (merged = collapsedSpanAtStart(line))
      { line = merged.find(-1, true).line; }
    return line
  }

  function visualLineEnd(line) {
    var merged;
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return line
  }

  // Returns an array of logical lines that continue the visual line
  // started by the argument, or undefined if there are no such lines.
  function visualLineContinued(line) {
    var merged, lines;
    while (merged = collapsedSpanAtEnd(line)) {
      line = merged.find(1, true).line
      ;(lines || (lines = [])).push(line);
    }
    return lines
  }

  // Get the line number of the start of the visual line that the
  // given line number is part of.
  function visualLineNo(doc, lineN) {
    var line = getLine(doc, lineN), vis = visualLine(line);
    if (line == vis) { return lineN }
    return lineNo(vis)
  }

  // Get the line number of the start of the next visual line after
  // the given line.
  function visualLineEndNo(doc, lineN) {
    if (lineN > doc.lastLine()) { return lineN }
    var line = getLine(doc, lineN), merged;
    if (!lineIsHidden(doc, line)) { return lineN }
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return lineNo(line) + 1
  }

  // Compute whether a line is hidden. Lines count as hidden when they
  // are part of a visual line that starts with another line, or when
  // they are entirely covered by collapsed, non-widget span.
  function lineIsHidden(doc, line) {
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      if (sp.from == null) { return true }
      if (sp.marker.widgetNode) { continue }
      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
        { return true }
    } }
  }
  function lineIsHiddenInner(doc, line, span) {
    if (span.to == null) {
      var end = span.marker.find(1, true);
      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
    }
    if (span.marker.inclusiveRight && span.to == line.text.length)
      { return true }
    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
      sp = line.markedSpans[i];
      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
          (sp.to == null || sp.to != span.from) &&
          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
          lineIsHiddenInner(doc, line, sp)) { return true }
    }
  }

  // Find the height above the given line.
  function heightAtLine(lineObj) {
    lineObj = visualLine(lineObj);

    var h = 0, chunk = lineObj.parent;
    for (var i = 0; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i];
      if (line == lineObj) { break }
      else { h += line.height; }
    }
    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
        var cur = p.children[i$1];
        if (cur == chunk) { break }
        else { h += cur.height; }
      }
    }
    return h
  }

  // Compute the character length of a line, taking into account
  // collapsed ranges (see markText) that might hide parts, and join
  // other lines onto it.
  function lineLength(line) {
    if (line.height == 0) { return 0 }
    var len = line.text.length, merged, cur = line;
    while (merged = collapsedSpanAtStart(cur)) {
      var found = merged.find(0, true);
      cur = found.from.line;
      len += found.from.ch - found.to.ch;
    }
    cur = line;
    while (merged = collapsedSpanAtEnd(cur)) {
      var found$1 = merged.find(0, true);
      len -= cur.text.length - found$1.from.ch;
      cur = found$1.to.line;
      len += cur.text.length - found$1.to.ch;
    }
    return len
  }

  // Find the longest line in the document.
  function findMaxLine(cm) {
    var d = cm.display, doc = cm.doc;
    d.maxLine = getLine(doc, doc.first);
    d.maxLineLength = lineLength(d.maxLine);
    d.maxLineChanged = true;
    doc.iter(function (line) {
      var len = lineLength(line);
      if (len > d.maxLineLength) {
        d.maxLineLength = len;
        d.maxLine = line;
      }
    });
  }

  // LINE DATA STRUCTURE

  // Line objects. These hold state related to a line, including
  // highlighting info (the styles array).
  var Line = function(text, markedSpans, estimateHeight) {
    this.text = text;
    attachMarkedSpans(this, markedSpans);
    this.height = estimateHeight ? estimateHeight(this) : 1;
  };

  Line.prototype.lineNo = function () { return lineNo(this) };
  eventMixin(Line);

  // Change the content (text, markers) of a line. Automatically
  // invalidates cached information and tries to re-estimate the
  // line's height.
  function updateLine(line, text, markedSpans, estimateHeight) {
    line.text = text;
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
    if (line.order != null) { line.order = null; }
    detachMarkedSpans(line);
    attachMarkedSpans(line, markedSpans);
    var estHeight = estimateHeight ? estimateHeight(line) : 1;
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  }

  // Detach a line from the document tree and its markers.
  function cleanUpLine(line) {
    line.parent = null;
    detachMarkedSpans(line);
  }

  // Convert a style as returned by a mode (either null, or a string
  // containing one or more styles) to a CSS style. This is cached,
  // and also looks for line-wide styles.
  var styleToClassCache = {}, styleToClassCacheWithMode = {};
  function interpretTokenStyle(style, options) {
    if (!style || /^\s*$/.test(style)) { return null }
    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
    return cache[style] ||
      (cache[style] = style.replace(/\S+/g, "cm-$&"))
  }

  // Render the DOM representation of the text of a line. Also builds
  // up a 'line map', which points at the DOM nodes that represent
  // specific stretches of text, and is used by the measuring code.
  // The returned object contains the DOM node, this map, and
  // information about line-wide styles that were set by the mode.
  function buildLineContent(cm, lineView) {
    // The padding-right forces the element to have a 'border', which
    // is needed on Webkit to be able to get line-level bounding
    // rectangles for it (in measureChar).
    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                   col: 0, pos: 0, cm: cm,
                   trailingSpace: false,
                   splitSpaces: cm.getOption("lineWrapping")};
    lineView.measure = {};

    // Iterate over the logical lines that make up this visual line.
    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
      builder.pos = 0;
      builder.addToken = buildToken;
      // Optionally wire in some hacks into the token-rendering
      // algorithm, to deal with browser quirks.
      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
      builder.map = [];
      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
      if (line.styleClasses) {
        if (line.styleClasses.bgClass)
          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
        if (line.styleClasses.textClass)
          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
      }

      // Ensure at least a single node is present, for measuring.
      if (builder.map.length == 0)
        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

      // Store the map and a cache object for the current logical line
      if (i == 0) {
        lineView.measure.map = builder.map;
        lineView.measure.cache = {};
      } else {
  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
      }
    }

    // See issue #2901
    if (webkit) {
      var last = builder.content.lastChild;
      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
        { builder.content.className = "cm-tab-wrap-hack"; }
    }

    signal(cm, "renderLine", cm, lineView.line, builder.pre);
    if (builder.pre.className)
      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

    return builder
  }

  function defaultSpecialCharPlaceholder(ch) {
    var token = elt("span", "\u2022", "cm-invalidchar");
    token.title = "\\u" + ch.charCodeAt(0).toString(16);
    token.setAttribute("aria-label", token.title);
    return token
  }

  // Build up the DOM representation for a single token, and add it to
  // the line map. Takes care to render special characters separately.
  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
    if (!text) { return }
    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
    var special = builder.cm.state.specialChars, mustWrap = false;
    var content;
    if (!special.test(text)) {
      builder.col += text.length;
      content = document.createTextNode(displayText);
      builder.map.push(builder.pos, builder.pos + text.length, content);
      if (ie && ie_version < 9) { mustWrap = true; }
      builder.pos += text.length;
    } else {
      content = document.createDocumentFragment();
      var pos = 0;
      while (true) {
        special.lastIndex = pos;
        var m = special.exec(text);
        var skipped = m ? m.index - pos : text.length - pos;
        if (skipped) {
          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
          else { content.appendChild(txt); }
          builder.map.push(builder.pos, builder.pos + skipped, txt);
          builder.col += skipped;
          builder.pos += skipped;
        }
        if (!m) { break }
        pos += skipped + 1;
        var txt$1 = (void 0);
        if (m[0] == "\t") {
          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
          txt$1.setAttribute("role", "presentation");
          txt$1.setAttribute("cm-text", "\t");
          builder.col += tabWidth;
        } else if (m[0] == "\r" || m[0] == "\n") {
          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
          txt$1.setAttribute("cm-text", m[0]);
          builder.col += 1;
        } else {
          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
          txt$1.setAttribute("cm-text", m[0]);
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
          else { content.appendChild(txt$1); }
          builder.col += 1;
        }
        builder.map.push(builder.pos, builder.pos + 1, txt$1);
        builder.pos++;
      }
    }
    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
    if (style || startStyle || endStyle || mustWrap || css || attributes) {
      var fullStyle = style || "";
      if (startStyle) { fullStyle += startStyle; }
      if (endStyle) { fullStyle += endStyle; }
      var token = elt("span", [content], fullStyle, css);
      if (attributes) {
        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
          { token.setAttribute(attr, attributes[attr]); } }
      }
      return builder.content.appendChild(token)
    }
    builder.content.appendChild(content);
  }

  // Change some spaces to NBSP to prevent the browser from collapsing
  // trailing spaces at the end of a line when rendering text (issue #1362).
  function splitSpaces(text, trailingBefore) {
    if (text.length > 1 && !/  /.test(text)) { return text }
    var spaceBefore = trailingBefore, result = "";
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
        { ch = "\u00a0"; }
      result += ch;
      spaceBefore = ch == " ";
    }
    return result
  }

  // Work around nonsense dimensions being reported for stretches of
  // right-to-left text.
  function buildTokenBadBidi(inner, order) {
    return function (builder, text, style, startStyle, endStyle, css, attributes) {
      style = style ? style + " cm-force-border" : "cm-force-border";
      var start = builder.pos, end = start + text.length;
      for (;;) {
        // Find the part that overlaps with the start of this text
        var part = (void 0);
        for (var i = 0; i < order.length; i++) {
          part = order[i];
          if (part.to > start && part.from <= start) { break }
        }
        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
        startStyle = null;
        text = text.slice(part.to - start);
        start = part.to;
      }
    }
  }

  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
    var widget = !ignoreWidget && marker.widgetNode;
    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
      if (!widget)
        { widget = builder.content.appendChild(document.createElement("span")); }
      widget.setAttribute("cm-marker", marker.id);
    }
    if (widget) {
      builder.cm.display.input.setUneditable(widget);
      builder.content.appendChild(widget);
    }
    builder.pos += size;
    builder.trailingSpace = false;
  }

  // Outputs a number of spans to make up a line, taking highlighting
  // and marked text into account.
  function insertLineContent(line, builder, styles) {
    var spans = line.markedSpans, allText = line.text, at = 0;
    if (!spans) {
      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
      return
    }

    var len = allText.length, pos = 0, i = 1, text = "", style, css;
    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
    for (;;) {
      if (nextChange == pos) { // Update current marker set
        spanStyle = spanEndStyle = spanStartStyle = css = "";
        attributes = null;
        collapsed = null; nextChange = Infinity;
        var foundBookmarks = [], endStyles = (void 0);
        for (var j = 0; j < spans.length; ++j) {
          var sp = spans[j], m = sp.marker;
          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
            foundBookmarks.push(m);
          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
              nextChange = sp.to;
              spanEndStyle = "";
            }
            if (m.className) { spanStyle += " " + m.className; }
            if (m.css) { css = (css ? css + ";" : "") + m.css; }
            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
            // support for the old title property
            // https://github.com/codemirror/CodeMirror/pull/5673
            if (m.title) { (attributes || (attributes = {})).title = m.title; }
            if (m.attributes) {
              for (var attr in m.attributes)
                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
            }
            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
              { collapsed = sp; }
          } else if (sp.from > pos && nextChange > sp.from) {
            nextChange = sp.from;
          }
        }
        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
        if (collapsed && (collapsed.from || 0) == pos) {
          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                             collapsed.marker, collapsed.from == null);
          if (collapsed.to == null) { return }
          if (collapsed.to == pos) { collapsed = false; }
        }
      }
      if (pos >= len) { break }

      var upto = Math.min(len, nextChange);
      while (true) {
        if (text) {
          var end = pos + text.length;
          if (!collapsed) {
            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
          }
          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
          pos = end;
          spanStartStyle = "";
        }
        text = allText.slice(at, at = styles[i++]);
        style = interpretTokenStyle(styles[i++], builder.cm.options);
      }
    }
  }


  // These objects are used to represent the visible (currently drawn)
  // part of the document. A LineView may correspond to multiple
  // logical lines, if those are connected by collapsed ranges.
  function LineView(doc, line, lineN) {
    // The starting line
    this.line = line;
    // Continuing lines, if any
    this.rest = visualLineContinued(line);
    // Number of logical lines in this visual line
    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
    this.node = this.text = null;
    this.hidden = lineIsHidden(doc, line);
  }

  // Create a range of LineView objects for the given lines.
  function buildViewArray(cm, from, to) {
    var array = [], nextPos;
    for (var pos = from; pos < to; pos = nextPos) {
      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
      nextPos = pos + view.size;
      array.push(view);
    }
    return array
  }

  var operationGroup = null;

  function pushOperation(op) {
    if (operationGroup) {
      operationGroup.ops.push(op);
    } else {
      op.ownsGroup = operationGroup = {
        ops: [op],
        delayedCallbacks: []
      };
    }
  }

  function fireCallbacksForOps(group) {
    // Calls delayed callbacks and cursorActivity handlers until no
    // new ones appear
    var callbacks = group.delayedCallbacks, i = 0;
    do {
      for (; i < callbacks.length; i++)
        { callbacks[i].call(null); }
      for (var j = 0; j < group.ops.length; j++) {
        var op = group.ops[j];
        if (op.cursorActivityHandlers)
          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
      }
    } while (i < callbacks.length)
  }

  function finishOperation(op, endCb) {
    var group = op.ownsGroup;
    if (!group) { return }

    try { fireCallbacksForOps(group); }
    finally {
      operationGroup = null;
      endCb(group);
    }
  }

  var orphanDelayedCallbacks = null;

  // Often, we want to signal events at a point where we are in the
  // middle of some work, but don't want the handler to start calling
  // other methods on the editor, which might be in an inconsistent
  // state or simply not expect any other events to happen.
  // signalLater looks whether there are any handlers, and schedules
  // them to be executed when the last operation ends, or, if no
  // operation is active, when a timeout fires.
  function signalLater(emitter, type /*, values...*/) {
    var arr = getHandlers(emitter, type);
    if (!arr.length) { return }
    var args = Array.prototype.slice.call(arguments, 2), list;
    if (operationGroup) {
      list = operationGroup.delayedCallbacks;
    } else if (orphanDelayedCallbacks) {
      list = orphanDelayedCallbacks;
    } else {
      list = orphanDelayedCallbacks = [];
      setTimeout(fireOrphanDelayed, 0);
    }
    var loop = function ( i ) {
      list.push(function () { return arr[i].apply(null, args); });
    };

    for (var i = 0; i < arr.length; ++i)
      loop( i );
  }

  function fireOrphanDelayed() {
    var delayed = orphanDelayedCallbacks;
    orphanDelayedCallbacks = null;
    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
  }

  // When an aspect of a line changes, a string is added to
  // lineView.changes. This updates the relevant part of the line's
  // DOM structure.
  function updateLineForChanges(cm, lineView, lineN, dims) {
    for (var j = 0; j < lineView.changes.length; j++) {
      var type = lineView.changes[j];
      if (type == "text") { updateLineText(cm, lineView); }
      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
      else if (type == "class") { updateLineClasses(cm, lineView); }
      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
    }
    lineView.changes = null;
  }

  // Lines with gutter elements, widgets or a background class need to
  // be wrapped, and have the extra elements added to the wrapper div
  function ensureLineWrapped(lineView) {
    if (lineView.node == lineView.text) {
      lineView.node = elt("div", null, null, "position: relative");
      if (lineView.text.parentNode)
        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
      lineView.node.appendChild(lineView.text);
      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
    }
    return lineView.node
  }

  function updateLineBackground(cm, lineView) {
    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
    if (cls) { cls += " CodeMirror-linebackground"; }
    if (lineView.background) {
      if (cls) { lineView.background.className = cls; }
      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
    } else if (cls) {
      var wrap = ensureLineWrapped(lineView);
      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
      cm.display.input.setUneditable(lineView.background);
    }
  }

  // Wrapper around buildLineContent which will reuse the structure
  // in display.externalMeasured when possible.
  function getLineContent(cm, lineView) {
    var ext = cm.display.externalMeasured;
    if (ext && ext.line == lineView.line) {
      cm.display.externalMeasured = null;
      lineView.measure = ext.measure;
      return ext.built
    }
    return buildLineContent(cm, lineView)
  }

  // Redraw the line's text. Interacts with the background and text
  // classes because the mode may output tokens that influence these
  // classes.
  function updateLineText(cm, lineView) {
    var cls = lineView.text.className;
    var built = getLineContent(cm, lineView);
    if (lineView.text == lineView.node) { lineView.node = built.pre; }
    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
    lineView.text = built.pre;
    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
      lineView.bgClass = built.bgClass;
      lineView.textClass = built.textClass;
      updateLineClasses(cm, lineView);
    } else if (cls) {
      lineView.text.className = cls;
    }
  }

  function updateLineClasses(cm, lineView) {
    updateLineBackground(cm, lineView);
    if (lineView.line.wrapClass)
      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
    else if (lineView.node != lineView.text)
      { lineView.node.className = ""; }
    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
    lineView.text.className = textClass || "";
  }

  function updateLineGutter(cm, lineView, lineN, dims) {
    if (lineView.gutter) {
      lineView.node.removeChild(lineView.gutter);
      lineView.gutter = null;
    }
    if (lineView.gutterBackground) {
      lineView.node.removeChild(lineView.gutterBackground);
      lineView.gutterBackground = null;
    }
    if (lineView.line.gutterClass) {
      var wrap = ensureLineWrapped(lineView);
      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(lineView.gutterBackground);
      wrap.insertBefore(lineView.gutterBackground, lineView.text);
    }
    var markers = lineView.line.gutterMarkers;
    if (cm.options.lineNumbers || markers) {
      var wrap$1 = ensureLineWrapped(lineView);
      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
      gutterWrap.setAttribute("aria-hidden", "true");
      cm.display.input.setUneditable(gutterWrap);
      wrap$1.insertBefore(gutterWrap, lineView.text);
      if (lineView.line.gutterClass)
        { gutterWrap.className += " " + lineView.line.gutterClass; }
      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
        { lineView.lineNumber = gutterWrap.appendChild(
          elt("div", lineNumberFor(cm.options, lineN),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
        if (found)
          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
      } }
    }
  }

  function updateLineWidgets(cm, lineView, dims) {
    if (lineView.alignable) { lineView.alignable = null; }
    var isWidget = classTest("CodeMirror-linewidget");
    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
      next = node.nextSibling;
      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
    }
    insertLineWidgets(cm, lineView, dims);
  }

  // Build a line's DOM representation from scratch
  function buildLineElement(cm, lineView, lineN, dims) {
    var built = getLineContent(cm, lineView);
    lineView.text = lineView.node = built.pre;
    if (built.bgClass) { lineView.bgClass = built.bgClass; }
    if (built.textClass) { lineView.textClass = built.textClass; }

    updateLineClasses(cm, lineView);
    updateLineGutter(cm, lineView, lineN, dims);
    insertLineWidgets(cm, lineView, dims);
    return lineView.node
  }

  // A lineView may contain multiple logical lines (when merged by
  // collapsed spans). The widgets for all of them need to be drawn.
  function insertLineWidgets(cm, lineView, dims) {
    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
  }

  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
    if (!line.widgets) { return }
    var wrap = ensureLineWrapped(lineView);
    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
      positionLineWidget(widget, node, lineView, dims);
      cm.display.input.setUneditable(node);
      if (allowAbove && widget.above)
        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
      else
        { wrap.appendChild(node); }
      signalLater(widget, "redraw");
    }
  }

  function positionLineWidget(widget, node, lineView, dims) {
    if (widget.noHScroll) {
  (lineView.alignable || (lineView.alignable = [])).push(node);
      var width = dims.wrapperWidth;
      node.style.left = dims.fixedPos + "px";
      if (!widget.coverGutter) {
        width -= dims.gutterTotalWidth;
        node.style.paddingLeft = dims.gutterTotalWidth + "px";
      }
      node.style.width = width + "px";
    }
    if (widget.coverGutter) {
      node.style.zIndex = 5;
      node.style.position = "relative";
      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
    }
  }

  function widgetHeight(widget) {
    if (widget.height != null) { return widget.height }
    var cm = widget.doc.cm;
    if (!cm) { return 0 }
    if (!contains(document.body, widget.node)) {
      var parentStyle = "position: relative;";
      if (widget.coverGutter)
        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
      if (widget.noHScroll)
        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
    }
    return widget.height = widget.node.parentNode.offsetHeight
  }

  // Return true when the given mouse event happened in a widget
  function eventInWidget(display, e) {
    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
          (n.parentNode == display.sizer && n != display.mover))
        { return true }
    }
  }

  // POSITION MEASUREMENT

  function paddingTop(display) {return display.lineSpace.offsetTop}
  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
  function paddingH(display) {
    if (display.cachedPaddingH) { return display.cachedPaddingH }
    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
    return data
  }

  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
  function displayWidth(cm) {
    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
  }
  function displayHeight(cm) {
    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
  }

  // Ensure the lineView.wrapping.heights array is populated. This is
  // an array of bottom offsets for the lines that make up a drawn
  // line. When lineWrapping is on, there might be more than one
  // height.
  function ensureLineHeights(cm, lineView, rect) {
    var wrapping = cm.options.lineWrapping;
    var curWidth = wrapping && displayWidth(cm);
    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
      var heights = lineView.measure.heights = [];
      if (wrapping) {
        lineView.measure.width = curWidth;
        var rects = lineView.text.firstChild.getClientRects();
        for (var i = 0; i < rects.length - 1; i++) {
          var cur = rects[i], next = rects[i + 1];
          if (Math.abs(cur.bottom - next.bottom) > 2)
            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
        }
      }
      heights.push(rect.bottom - rect.top);
    }
  }

  // Find a line map (mapping character offsets to text nodes) and a
  // measurement cache for the given line number. (A line view might
  // contain multiple lines when collapsed ranges are present.)
  function mapFromLineView(lineView, line, lineN) {
    if (lineView.line == line)
      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
    if (lineView.rest) {
      for (var i = 0; i < lineView.rest.length; i++)
        { if (lineView.rest[i] == line)
          { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
      for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
        { if (lineNo(lineView.rest[i$1]) > lineN)
          { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
    }
  }

  // Render a line into the hidden node display.externalMeasured. Used
  // when measurement is needed for a line that's not in the viewport.
  function updateExternalMeasurement(cm, line) {
    line = visualLine(line);
    var lineN = lineNo(line);
    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
    view.lineN = lineN;
    var built = view.built = buildLineContent(cm, view);
    view.text = built.pre;
    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
    return view
  }

  // Get a {top, bottom, left, right} box (in line-local coordinates)
  // for a given character.
  function measureChar(cm, line, ch, bias) {
    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
  }

  // Find a line view that corresponds to the given line number.
  function findViewForLine(cm, lineN) {
    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
      { return cm.display.view[findViewIndex(cm, lineN)] }
    var ext = cm.display.externalMeasured;
    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
      { return ext }
  }

  // Measurement can be split in two steps, the set-up work that
  // applies to the whole line, and the measurement of the actual
  // character. Functions like coordsChar, that need to do a lot of
  // measurements in a row, can thus ensure that the set-up work is
  // only done once.
  function prepareMeasureForLine(cm, line) {
    var lineN = lineNo(line);
    var view = findViewForLine(cm, lineN);
    if (view && !view.text) {
      view = null;
    } else if (view && view.changes) {
      updateLineForChanges(cm, view, lineN, getDimensions(cm));
      cm.curOp.forceUpdate = true;
    }
    if (!view)
      { view = updateExternalMeasurement(cm, line); }

    var info = mapFromLineView(view, line, lineN);
    return {
      line: line, view: view, rect: null,
      map: info.map, cache: info.cache, before: info.before,
      hasHeights: false
    }
  }

  // Given a prepared measurement object, measures the position of an
  // actual character (or fetches it from the cache).
  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
    if (prepared.before) { ch = -1; }
    var key = ch + (bias || ""), found;
    if (prepared.cache.hasOwnProperty(key)) {
      found = prepared.cache[key];
    } else {
      if (!prepared.rect)
        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
      if (!prepared.hasHeights) {
        ensureLineHeights(cm, prepared.view, prepared.rect);
        prepared.hasHeights = true;
      }
      found = measureCharInner(cm, prepared, ch, bias);
      if (!found.bogus) { prepared.cache[key] = found; }
    }
    return {left: found.left, right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom}
  }

  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

  function nodeAndOffsetInLineMap(map, ch, bias) {
    var node, start, end, collapse, mStart, mEnd;
    // First, search the line map for the text node corresponding to,
    // or closest to, the target character.
    for (var i = 0; i < map.length; i += 3) {
      mStart = map[i];
      mEnd = map[i + 1];
      if (ch < mStart) {
        start = 0; end = 1;
        collapse = "left";
      } else if (ch < mEnd) {
        start = ch - mStart;
        end = start + 1;
      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
        end = mEnd - mStart;
        start = end - 1;
        if (ch >= mEnd) { collapse = "right"; }
      }
      if (start != null) {
        node = map[i + 2];
        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
          { collapse = bias; }
        if (bias == "left" && start == 0)
          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
            node = map[(i -= 3) + 2];
            collapse = "left";
          } }
        if (bias == "right" && start == mEnd - mStart)
          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
            node = map[(i += 3) + 2];
            collapse = "right";
          } }
        break
      }
    }
    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
  }

  function getUsefulRect(rects, bias) {
    var rect = nullRect;
    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
      if ((rect = rects[i]).left != rect.right) { break }
    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
      if ((rect = rects[i$1]).left != rect.right) { break }
    } }
    return rect
  }

  function measureCharInner(cm, prepared, ch, bias) {
    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

    var rect;
    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
          { rect = node.parentNode.getBoundingClientRect(); }
        else
          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
        if (rect.left || rect.right || start == 0) { break }
        end = start;
        start = start - 1;
        collapse = "right";
      }
      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
    } else { // If it is a widget, simply get the box for the whole widget.
      if (start > 0) { collapse = bias = "right"; }
      var rects;
      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
      else
        { rect = node.getBoundingClientRect(); }
    }
    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
      var rSpan = node.parentNode.getClientRects()[0];
      if (rSpan)
        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
      else
        { rect = nullRect; }
    }

    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
    var mid = (rtop + rbot) / 2;
    var heights = prepared.view.measure.heights;
    var i = 0;
    for (; i < heights.length - 1; i++)
      { if (mid < heights[i]) { break } }
    var top = i ? heights[i - 1] : 0, bot = heights[i];
    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                  top: top, bottom: bot};
    if (!rect.left && !rect.right) { result.bogus = true; }
    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

    return result
  }

  // Work around problem with bounding client rects on ranges being
  // returned incorrectly when zoomed on IE10 and below.
  function maybeUpdateRectForZooming(measure, rect) {
    if (!window.screen || screen.logicalXDPI == null ||
        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
      { return rect }
    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
    return {left: rect.left * scaleX, right: rect.right * scaleX,
            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
  }

  function clearLineMeasurementCacheFor(lineView) {
    if (lineView.measure) {
      lineView.measure.cache = {};
      lineView.measure.heights = null;
      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
        { lineView.measure.caches[i] = {}; } }
    }
  }

  function clearLineMeasurementCache(cm) {
    cm.display.externalMeasure = null;
    removeChildren(cm.display.lineMeasure);
    for (var i = 0; i < cm.display.view.length; i++)
      { clearLineMeasurementCacheFor(cm.display.view[i]); }
  }

  function clearCaches(cm) {
    clearLineMeasurementCache(cm);
    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
    cm.display.lineNumChars = null;
  }

  function pageScrollX(doc) {
    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
    // which causes page_Offset and bounding client rects to use
    // different reference viewports and invalidate our calculations.
    if (chrome && android) { return -(doc.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc.body).marginLeft)) }
    return doc.defaultView.pageXOffset || (doc.documentElement || doc.body).scrollLeft
  }
  function pageScrollY(doc) {
    if (chrome && android) { return -(doc.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc.body).marginTop)) }
    return doc.defaultView.pageYOffset || (doc.documentElement || doc.body).scrollTop
  }

  function widgetTopHeight(lineObj) {
    var ref = visualLine(lineObj);
    var widgets = ref.widgets;
    var height = 0;
    if (widgets) { for (var i = 0; i < widgets.length; ++i) { if (widgets[i].above)
      { height += widgetHeight(widgets[i]); } } }
    return height
  }

  // Converts a {top, bottom, left, right} box from line-local
  // coordinates into another coordinate system. Context may be one of
  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
  // or "page".
  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
    if (!includeWidgets) {
      var height = widgetTopHeight(lineObj);
      rect.top += height; rect.bottom += height;
    }
    if (context == "line") { return rect }
    if (!context) { context = "local"; }
    var yOff = heightAtLine(lineObj);
    if (context == "local") { yOff += paddingTop(cm.display); }
    else { yOff -= cm.display.viewOffset; }
    if (context == "page" || context == "window") {
      var lOff = cm.display.lineSpace.getBoundingClientRect();
      yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
      rect.left += xOff; rect.right += xOff;
    }
    rect.top += yOff; rect.bottom += yOff;
    return rect
  }

  // Coverts a box from "div" coords to another coordinate system.
  // Context may be "window", "page", "div", or "local"./null.
  function fromCoordSystem(cm, coords, context) {
    if (context == "div") { return coords }
    var left = coords.left, top = coords.top;
    // First move into "page" coordinate system
    if (context == "page") {
      left -= pageScrollX(doc(cm));
      top -= pageScrollY(doc(cm));
    } else if (context == "local" || !context) {
      var localBox = cm.display.sizer.getBoundingClientRect();
      left += localBox.left;
      top += localBox.top;
    }

    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
  }

  function charCoords(cm, pos, context, lineObj, bias) {
    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
  }

  // Returns a box for a given cursor position, which may have an
  // 'other' property containing the position of the secondary cursor
  // on a bidi boundary.
  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
  // and after `char - 1` in writing order of `char - 1`
  // A cursor Pos(line, char, "after") is on the same visual line as `char`
  // and before `char` in writing order of `char`
  // Examples (upper-case letters are RTL, lower-case are LTR):
  //     Pos(0, 1, ...)
  //     before   after
  // ab     a|b     a|b
  // aB     a|B     aB|
  // Ab     |Ab     A|b
  // AB     B|A     B|A
  // Every position after the last character on a line is considered to stick
  // to the last character on the line.
  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
    lineObj = lineObj || getLine(cm.doc, pos.line);
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    function get(ch, right) {
      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
      if (right) { m.left = m.right; } else { m.right = m.left; }
      return intoCoordSystem(cm, lineObj, m, context)
    }
    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
    if (ch >= lineObj.text.length) {
      ch = lineObj.text.length;
      sticky = "before";
    } else if (ch <= 0) {
      ch = 0;
      sticky = "after";
    }
    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

    function getBidi(ch, partPos, invert) {
      var part = order[partPos], right = part.level == 1;
      return get(invert ? ch - 1 : ch, right != invert)
    }
    var partPos = getBidiPartAt(order, ch, sticky);
    var other = bidiOther;
    var val = getBidi(ch, partPos, sticky == "before");
    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
    return val
  }

  // Used to cheaply estimate the coordinates for a position. Used for
  // intermediate scroll updates.
  function estimateCoords(cm, pos) {
    var left = 0;
    pos = clipPos(cm.doc, pos);
    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
    var lineObj = getLine(cm.doc, pos.line);
    var top = heightAtLine(lineObj) + paddingTop(cm.display);
    return {left: left, right: left, top: top, bottom: top + lineObj.height}
  }

  // Positions returned by coordsChar contain some extra information.
  // xRel is the relative x position of the input coordinates compared
  // to the found position (so xRel > 0 means the coordinates are to
  // the right of the character position, for example). When outside
  // is true, that means the coordinates lie outside the line's
  // vertical range.
  function PosWithInfo(line, ch, sticky, outside, xRel) {
    var pos = Pos(line, ch, sticky);
    pos.xRel = xRel;
    if (outside) { pos.outside = outside; }
    return pos
  }

  // Compute the character position closest to the given coordinates.
  // Input must be lineSpace-local ("div" coordinate system).
  function coordsChar(cm, x, y) {
    var doc = cm.doc;
    y += cm.display.viewOffset;
    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
    if (lineN > last)
      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
    if (x < 0) { x = 0; }

    var lineObj = getLine(doc, lineN);
    for (;;) {
      var found = coordsCharInner(cm, lineObj, lineN, x, y);
      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
      if (!collapsed) { return found }
      var rangeEnd = collapsed.find(1);
      if (rangeEnd.line == lineN) { return rangeEnd }
      lineObj = getLine(doc, lineN = rangeEnd.line);
    }
  }

  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
    y -= widgetTopHeight(lineObj);
    var end = lineObj.text.length;
    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
    return {begin: begin, end: end}
  }

  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
  }

  // Returns true if the given side of a box is after the given
  // coordinates, in top-to-bottom, left-to-right order.
  function boxIsAfter(box, x, y, left) {
    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
  }

  function coordsCharInner(cm, lineObj, lineNo, x, y) {
    // Move y into line-local coordinate space
    y -= heightAtLine(lineObj);
    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
    // When directly calling `measureCharPrepared`, we have to adjust
    // for the widgets at this line.
    var widgetHeight = widgetTopHeight(lineObj);
    var begin = 0, end = lineObj.text.length, ltr = true;

    var order = getOrder(lineObj, cm.doc.direction);
    // If the line isn't plain left-to-right text, first figure out
    // which bidi section the coordinates fall into.
    if (order) {
      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
      ltr = part.level != 1;
      // The awkward -1 offsets are needed because findFirst (called
      // on these below) will treat its first bound as inclusive,
      // second as exclusive, but we want to actually address the
      // characters in the part's range
      begin = ltr ? part.from : part.to - 1;
      end = ltr ? part.to : part.from - 1;
    }

    // A binary search to find the first character whose bounding box
    // starts after the coordinates. If we run across any whose box wrap
    // the coordinates, store that.
    var chAround = null, boxAround = null;
    var ch = findFirst(function (ch) {
      var box = measureCharPrepared(cm, preparedMeasure, ch);
      box.top += widgetHeight; box.bottom += widgetHeight;
      if (!boxIsAfter(box, x, y, false)) { return false }
      if (box.top <= y && box.left <= x) {
        chAround = ch;
        boxAround = box;
      }
      return true
    }, begin, end);

    var baseX, sticky, outside = false;
    // If a box around the coordinates was found, use that
    if (boxAround) {
      // Distinguish coordinates nearer to the left or right side of the box
      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
      ch = chAround + (atStart ? 0 : 1);
      sticky = atStart ? "after" : "before";
      baseX = atLeft ? boxAround.left : boxAround.right;
    } else {
      // (Adjust for extended bound, if necessary.)
      if (!ltr && (ch == end || ch == begin)) { ch++; }
      // To determine which side to associate with, get the box to the
      // left of the character and compare it's vertical position to the
      // coordinates
      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
        "after" : "before";
      // Now get accurate coordinates for this place, in order to get a
      // base X position
      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
      baseX = coords.left;
      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
    }

    ch = skipExtendingChars(lineObj.text, ch, 1);
    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
  }

  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
    // situation, we can take this ordering to correspond to the visual
    // ordering. This finds the first part whose end is after the given
    // coordinates.
    var index = findFirst(function (i) {
      var part = order[i], ltr = part.level != 1;
      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                     "line", lineObj, preparedMeasure), x, y, true)
    }, 0, order.length - 1);
    var part = order[index];
    // If this isn't the first part, the part's start is also after
    // the coordinates, and the coordinates aren't on the same line as
    // that start, move one part back.
    if (index > 0) {
      var ltr = part.level != 1;
      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
                               "line", lineObj, preparedMeasure);
      if (boxIsAfter(start, x, y, true) && start.top > y)
        { part = order[index - 1]; }
    }
    return part
  }

  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
    // In a wrapped line, rtl text on wrapping boundaries can do things
    // that don't correspond to the ordering in our `order` array at
    // all, so a binary search doesn't work, and we want to return a
    // part that only spans one line so that the binary search in
    // coordsCharInner is safe. As such, we first find the extent of the
    // wrapped line, and then do a flat search in which we discard any
    // spans that aren't on the line.
    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
    var begin = ref.begin;
    var end = ref.end;
    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
    var part = null, closestDist = null;
    for (var i = 0; i < order.length; i++) {
      var p = order[i];
      if (p.from >= end || p.to <= begin) { continue }
      var ltr = p.level != 1;
      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
      // Weigh against spans ending before this, so that they are only
      // picked if nothing ends after
      var dist = endX < x ? x - endX + 1e9 : endX - x;
      if (!part || closestDist > dist) {
        part = p;
        closestDist = dist;
      }
    }
    if (!part) { part = order[order.length - 1]; }
    // Clip the part to the wrapped line.
    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
    return part
  }

  var measureText;
  // Compute the default text height.
  function textHeight(display) {
    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
    if (measureText == null) {
      measureText = elt("pre", null, "CodeMirror-line-like");
      // Measure a bunch of lines, for browsers that compute
      // fractional heights.
      for (var i = 0; i < 49; ++i) {
        measureText.appendChild(document.createTextNode("x"));
        measureText.appendChild(elt("br"));
      }
      measureText.appendChild(document.createTextNode("x"));
    }
    removeChildrenAndAdd(display.measure, measureText);
    var height = measureText.offsetHeight / 50;
    if (height > 3) { display.cachedTextHeight = height; }
    removeChildren(display.measure);
    return height || 1
  }

  // Compute the default character width.
  function charWidth(display) {
    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
    var anchor = elt("span", "xxxxxxxxxx");
    var pre = elt("pre", [anchor], "CodeMirror-line-like");
    removeChildrenAndAdd(display.measure, pre);
    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
    if (width > 2) { display.cachedCharWidth = width; }
    return width || 10
  }

  // Do a bulk-read of the DOM positions and sizes needed to draw the
  // view, so that we don't interleave reading and writing to the DOM.
  function getDimensions(cm) {
    var d = cm.display, left = {}, width = {};
    var gutterLeft = d.gutters.clientLeft;
    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
      var id = cm.display.gutterSpecs[i].className;
      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
      width[id] = n.clientWidth;
    }
    return {fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth}
  }

  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
  // but using getBoundingClientRect to get a sub-pixel-accurate
  // result.
  function compensateForHScroll(display) {
    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
  }

  // Returns a function that estimates the height of a line, to use as
  // first approximation until the line becomes visible (and is thus
  // properly measurable).
  function estimateHeight(cm) {
    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
    return function (line) {
      if (lineIsHidden(cm.doc, line)) { return 0 }

      var widgetsHeight = 0;
      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
      } }

      if (wrapping)
        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
      else
        { return widgetsHeight + th }
    }
  }

  function estimateLineHeights(cm) {
    var doc = cm.doc, est = estimateHeight(cm);
    doc.iter(function (line) {
      var estHeight = est(line);
      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
    });
  }

  // Given a mouse event, find the corresponding position. If liberal
  // is false, it checks whether a gutter or scrollbar was clicked,
  // and returns null if it was. forRect is used by rectangular
  // selections, and tries to estimate a character position even for
  // coordinates beyond the right of the text.
  function posFromMouse(cm, e, liberal, forRect) {
    var display = cm.display;
    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

    var x, y, space = display.lineSpace.getBoundingClientRect();
    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
    try { x = e.clientX - space.left; y = e.clientY - space.top; }
    catch (e$1) { return null }
    var coords = coordsChar(cm, x, y), line;
    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
    }
    return coords
  }

  // Find the view element corresponding to a given line. Return null
  // when the line isn't visible.
  function findViewIndex(cm, n) {
    if (n >= cm.display.viewTo) { return null }
    n -= cm.display.viewFrom;
    if (n < 0) { return null }
    var view = cm.display.view;
    for (var i = 0; i < view.length; i++) {
      n -= view[i].size;
      if (n < 0) { return i }
    }
  }

  // Updates the display.view data structure for a given change to the
  // document. From and to are in pre-change coordinates. Lendiff is
  // the amount of lines added or subtracted by the change. This is
  // used for changes that span multiple lines, or change the way
  // lines are divided into visual lines. regLineChange (below)
  // registers single-line changes.
  function regChange(cm, from, to, lendiff) {
    if (from == null) { from = cm.doc.first; }
    if (to == null) { to = cm.doc.first + cm.doc.size; }
    if (!lendiff) { lendiff = 0; }

    var display = cm.display;
    if (lendiff && to < display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers > from))
      { display.updateLineNumbers = from; }

    cm.curOp.viewChanged = true;

    if (from >= display.viewTo) { // Change after
      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
        { resetView(cm); }
    } else if (to <= display.viewFrom) { // Change before
      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
        resetView(cm);
      } else {
        display.viewFrom += lendiff;
        display.viewTo += lendiff;
      }
    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
      resetView(cm);
    } else if (from <= display.viewFrom) { // Top overlap
      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cut) {
        display.view = display.view.slice(cut.index);
        display.viewFrom = cut.lineN;
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    } else if (to >= display.viewTo) { // Bottom overlap
      var cut$1 = viewCuttingPoint(cm, from, from, -1);
      if (cut$1) {
        display.view = display.view.slice(0, cut$1.index);
        display.viewTo = cut$1.lineN;
      } else {
        resetView(cm);
      }
    } else { // Gap in the middle
      var cutTop = viewCuttingPoint(cm, from, from, -1);
      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cutTop && cutBot) {
        display.view = display.view.slice(0, cutTop.index)
          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
          .concat(display.view.slice(cutBot.index));
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    }

    var ext = display.externalMeasured;
    if (ext) {
      if (to < ext.lineN)
        { ext.lineN += lendiff; }
      else if (from < ext.lineN + ext.size)
        { display.externalMeasured = null; }
    }
  }

  // Register a change to a single line. Type must be one of "text",
  // "gutter", "class", "widget"
  function regLineChange(cm, line, type) {
    cm.curOp.viewChanged = true;
    var display = cm.display, ext = cm.display.externalMeasured;
    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
      { display.externalMeasured = null; }

    if (line < display.viewFrom || line >= display.viewTo) { return }
    var lineView = display.view[findViewIndex(cm, line)];
    if (lineView.node == null) { return }
    var arr = lineView.changes || (lineView.changes = []);
    if (indexOf(arr, type) == -1) { arr.push(type); }
  }

  // Clear the view.
  function resetView(cm) {
    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
    cm.display.view = [];
    cm.display.viewOffset = 0;
  }

  function viewCuttingPoint(cm, oldN, newN, dir) {
    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
      { return {index: index, lineN: newN} }
    var n = cm.display.viewFrom;
    for (var i = 0; i < index; i++)
      { n += view[i].size; }
    if (n != oldN) {
      if (dir > 0) {
        if (index == view.length - 1) { return null }
        diff = (n + view[index].size) - oldN;
        index++;
      } else {
        diff = n - oldN;
      }
      oldN += diff; newN += diff;
    }
    while (visualLineNo(cm.doc, newN) != newN) {
      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
      index += dir;
    }
    return {index: index, lineN: newN}
  }

  // Force the view to cover a given range, adding empty view element
  // or clipping off existing ones as needed.
  function adjustView(cm, from, to) {
    var display = cm.display, view = display.view;
    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
      display.view = buildViewArray(cm, from, to);
      display.viewFrom = from;
    } else {
      if (display.viewFrom > from)
        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
      else if (display.viewFrom < from)
        { display.view = display.view.slice(findViewIndex(cm, from)); }
      display.viewFrom = from;
      if (display.viewTo < to)
        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
      else if (display.viewTo > to)
        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
    }
    display.viewTo = to;
  }

  // Count the number of lines in the view whose DOM representation is
  // out of date (or nonexistent).
  function countDirtyView(cm) {
    var view = cm.display.view, dirty = 0;
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
    }
    return dirty
  }

  function updateSelection(cm) {
    cm.display.input.showSelection(cm.display.input.prepareSelection());
  }

  function prepareSelection(cm, primary) {
    if ( primary === void 0 ) primary = true;

    var doc = cm.doc, result = {};
    var curFragment = result.cursors = document.createDocumentFragment();
    var selFragment = result.selection = document.createDocumentFragment();

    var customCursor = cm.options.$customCursor;
    if (customCursor) { primary = true; }
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      if (!primary && i == doc.sel.primIndex) { continue }
      var range = doc.sel.ranges[i];
      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
      var collapsed = range.empty();
      if (customCursor) {
        var head = customCursor(cm, range);
        if (head) { drawSelectionCursor(cm, head, curFragment); }
      } else if (collapsed || cm.options.showCursorWhenSelecting) {
        drawSelectionCursor(cm, range.head, curFragment);
      }
      if (!collapsed)
        { drawSelectionRange(cm, range, selFragment); }
    }
    return result
  }

  // Draws a cursor for the given range
  function drawSelectionCursor(cm, head, output) {
    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
    cursor.style.left = pos.left + "px";
    cursor.style.top = pos.top + "px";
    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

    if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
      var charPos = charCoords(cm, head, "div", null, null);
      var width = charPos.right - charPos.left;
      cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
    }

    if (pos.other) {
      // Secondary cursor, shown when on a 'jump' in bi-directional text
      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
      otherCursor.style.display = "";
      otherCursor.style.left = pos.other.left + "px";
      otherCursor.style.top = pos.other.top + "px";
      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
    }
  }

  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

  // Draws the given range as a highlighted selection
  function drawSelectionRange(cm, range, output) {
    var display = cm.display, doc = cm.doc;
    var fragment = document.createDocumentFragment();
    var padding = paddingH(cm.display), leftSide = padding.left;
    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
    var docLTR = doc.direction == "ltr";

    function add(left, top, width, bottom) {
      if (top < 0) { top = 0; }
      top = Math.round(top);
      bottom = Math.round(bottom);
      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
    }

    function drawForLine(line, fromArg, toArg) {
      var lineObj = getLine(doc, line);
      var lineLen = lineObj.text.length;
      var start, end;
      function coords(ch, bias) {
        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
      }

      function wrapX(pos, dir, side) {
        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
        return coords(ch, prop)[prop]
      }

      var order = getOrder(lineObj, doc.direction);
      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
        var ltr = dir == "ltr";
        var fromPos = coords(from, ltr ? "left" : "right");
        var toPos = coords(to - 1, ltr ? "right" : "left");

        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
        var first = i == 0, last = !order || i == order.length - 1;
        if (toPos.top - fromPos.top <= 3) { // Single line
          var openLeft = (docLTR ? openStart : openEnd) && first;
          var openRight = (docLTR ? openEnd : openStart) && last;
          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
          add(left, fromPos.top, right - left, fromPos.bottom);
        } else { // Multiple lines
          var topLeft, topRight, botLeft, botRight;
          if (ltr) {
            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
          } else {
            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
          }
          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
        }

        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
        if (cmpCoords(toPos, start) < 0) { start = toPos; }
        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
        if (cmpCoords(toPos, end) < 0) { end = toPos; }
      });
      return {start: start, end: end}
    }

    var sFrom = range.from(), sTo = range.to();
    if (sFrom.line == sTo.line) {
      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
    } else {
      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
      var singleVLine = visualLine(fromLine) == visualLine(toLine);
      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
      if (singleVLine) {
        if (leftEnd.top < rightStart.top - 2) {
          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
        } else {
          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
        }
      }
      if (leftEnd.bottom < rightStart.top)
        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
    }

    output.appendChild(fragment);
  }

  // Cursor-blinking
  function restartBlink(cm) {
    if (!cm.state.focused) { return }
    var display = cm.display;
    clearInterval(display.blinker);
    var on = true;
    display.cursorDiv.style.visibility = "";
    if (cm.options.cursorBlinkRate > 0)
      { display.blinker = setInterval(function () {
        if (!cm.hasFocus()) { onBlur(cm); }
        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
      }, cm.options.cursorBlinkRate); }
    else if (cm.options.cursorBlinkRate < 0)
      { display.cursorDiv.style.visibility = "hidden"; }
  }

  function ensureFocus(cm) {
    if (!cm.hasFocus()) {
      cm.display.input.focus();
      if (!cm.state.focused) { onFocus(cm); }
    }
  }

  function delayBlurEvent(cm) {
    cm.state.delayingBlurEvent = true;
    setTimeout(function () { if (cm.state.delayingBlurEvent) {
      cm.state.delayingBlurEvent = false;
      if (cm.state.focused) { onBlur(cm); }
    } }, 100);
  }

  function onFocus(cm, e) {
    if (cm.state.delayingBlurEvent && !cm.state.draggingText) { cm.state.delayingBlurEvent = false; }

    if (cm.options.readOnly == "nocursor") { return }
    if (!cm.state.focused) {
      signal(cm, "focus", cm, e);
      cm.state.focused = true;
      addClass(cm.display.wrapper, "CodeMirror-focused");
      // This test prevents this from firing when a context
      // menu is closed (since the input reset would kill the
      // select-all detection hack)
      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
        cm.display.input.reset();
        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
      }
      cm.display.input.receivedFocus();
    }
    restartBlink(cm);
  }
  function onBlur(cm, e) {
    if (cm.state.delayingBlurEvent) { return }

    if (cm.state.focused) {
      signal(cm, "blur", cm, e);
      cm.state.focused = false;
      rmClass(cm.display.wrapper, "CodeMirror-focused");
    }
    clearInterval(cm.display.blinker);
    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
  }

  // Read the actual heights of the rendered lines, and update their
  // stored heights to match.
  function updateHeightsInViewport(cm) {
    var display = cm.display;
    var prevBottom = display.lineDiv.offsetTop;
    var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
    var oldHeight = display.lineDiv.getBoundingClientRect().top;
    var mustScroll = 0;
    for (var i = 0; i < display.view.length; i++) {
      var cur = display.view[i], wrapping = cm.options.lineWrapping;
      var height = (void 0), width = 0;
      if (cur.hidden) { continue }
      oldHeight += cur.line.height;
      if (ie && ie_version < 8) {
        var bot = cur.node.offsetTop + cur.node.offsetHeight;
        height = bot - prevBottom;
        prevBottom = bot;
      } else {
        var box = cur.node.getBoundingClientRect();
        height = box.bottom - box.top;
        // Check that lines don't extend past the right of the current
        // editor width
        if (!wrapping && cur.text.firstChild)
          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
      }
      var diff = cur.line.height - height;
      if (diff > .005 || diff < -.005) {
        if (oldHeight < viewTop) { mustScroll -= diff; }
        updateLineHeight(cur.line, height);
        updateWidgetHeight(cur.line);
        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
          { updateWidgetHeight(cur.rest[j]); } }
      }
      if (width > cm.display.sizerWidth) {
        var chWidth = Math.ceil(width / charWidth(cm.display));
        if (chWidth > cm.display.maxLineLength) {
          cm.display.maxLineLength = chWidth;
          cm.display.maxLine = cur.line;
          cm.display.maxLineChanged = true;
        }
      }
    }
    if (Math.abs(mustScroll) > 2) { display.scroller.scrollTop += mustScroll; }
  }

  // Read and store the height of line widgets associated with the
  // given line.
  function updateWidgetHeight(line) {
    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
      var w = line.widgets[i], parent = w.node.parentNode;
      if (parent) { w.height = parent.offsetHeight; }
    } }
  }

  // Compute the lines that are visible in a given viewport (defaults
  // the the current scroll position). viewport may contain top,
  // height, and ensure (see op.scrollToPos) properties.
  function visibleLines(display, doc, viewport) {
    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
    top = Math.floor(top - paddingTop(display));
    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
    // forces those lines into the viewport (if possible).
    if (viewport && viewport.ensure) {
      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
      if (ensureFrom < from) {
        from = ensureFrom;
        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
        to = ensureTo;
      }
    }
    return {from: from, to: Math.max(to, from + 1)}
  }

  // SCROLLING THINGS INTO VIEW

  // If an editor sits on the top or bottom of the window, partially
  // scrolled out of view, this ensures that the cursor is visible.
  function maybeScrollWindow(cm, rect) {
    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
    var doc = display.wrapper.ownerDocument;
    if (rect.top + box.top < 0) { doScroll = true; }
    else if (rect.bottom + box.top > (doc.defaultView.innerHeight || doc.documentElement.clientHeight)) { doScroll = false; }
    if (doScroll != null && !phantom) {
      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
      cm.display.lineSpace.appendChild(scrollNode);
      scrollNode.scrollIntoView(doScroll);
      cm.display.lineSpace.removeChild(scrollNode);
    }
  }

  // Scroll a given position into view (immediately), verifying that
  // it actually became visible (as line heights are accurately
  // measured, the position of something may 'drift' during drawing).
  function scrollPosIntoView(cm, pos, end, margin) {
    if (margin == null) { margin = 0; }
    var rect;
    if (!cm.options.lineWrapping && pos == end) {
      // Set pos and end to the cursor positions around the character pos sticks to
      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
      // If pos == Pos(_, 0, "before"), pos and end are unchanged
      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
    }
    for (var limit = 0; limit < 5; limit++) {
      var changed = false;
      var coords = cursorCoords(cm, pos);
      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
      rect = {left: Math.min(coords.left, endCoords.left),
              top: Math.min(coords.top, endCoords.top) - margin,
              right: Math.max(coords.left, endCoords.left),
              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
      var scrollPos = calculateScrollPos(cm, rect);
      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
      if (scrollPos.scrollTop != null) {
        updateScrollTop(cm, scrollPos.scrollTop);
        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
      }
      if (scrollPos.scrollLeft != null) {
        setScrollLeft(cm, scrollPos.scrollLeft);
        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
      }
      if (!changed) { break }
    }
    return rect
  }

  // Scroll a given set of coordinates into view (immediately).
  function scrollIntoView(cm, rect) {
    var scrollPos = calculateScrollPos(cm, rect);
    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
  }

  // Calculate a new scroll position needed to scroll the given
  // rectangle into view. Returns an object with scrollTop and
  // scrollLeft properties. When these are undefined, the
  // vertical/horizontal position does not need to be adjusted.
  function calculateScrollPos(cm, rect) {
    var display = cm.display, snapMargin = textHeight(cm.display);
    if (rect.top < 0) { rect.top = 0; }
    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
    var screen = displayHeight(cm), result = {};
    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
    var docBottom = cm.doc.height + paddingVert(display);
    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
    if (rect.top < screentop) {
      result.scrollTop = atTop ? 0 : rect.top;
    } else if (rect.bottom > screentop + screen) {
      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
      if (newTop != screentop) { result.scrollTop = newTop; }
    }

    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
    var tooWide = rect.right - rect.left > screenw;
    if (tooWide) { rect.right = rect.left + screenw; }
    if (rect.left < 10)
      { result.scrollLeft = 0; }
    else if (rect.left < screenleft)
      { result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10)); }
    else if (rect.right > screenw + screenleft - 3)
      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
    return result
  }

  // Store a relative adjustment to the scroll position in the current
  // operation (to be applied when the operation finishes).
  function addToScrollTop(cm, top) {
    if (top == null) { return }
    resolveScrollToPos(cm);
    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
  }

  // Make sure that at the end of the operation the current cursor is
  // shown.
  function ensureCursorVisible(cm) {
    resolveScrollToPos(cm);
    var cur = cm.getCursor();
    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
  }

  function scrollToCoords(cm, x, y) {
    if (x != null || y != null) { resolveScrollToPos(cm); }
    if (x != null) { cm.curOp.scrollLeft = x; }
    if (y != null) { cm.curOp.scrollTop = y; }
  }

  function scrollToRange(cm, range) {
    resolveScrollToPos(cm);
    cm.curOp.scrollToPos = range;
  }

  // When an operation has its scrollToPos property set, and another
  // scroll action is applied before the end of the operation, this
  // 'simulates' scrolling that position into view in a cheap way, so
  // that the effect of intermediate scroll commands is not ignored.
  function resolveScrollToPos(cm) {
    var range = cm.curOp.scrollToPos;
    if (range) {
      cm.curOp.scrollToPos = null;
      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
      scrollToCoordsRange(cm, from, to, range.margin);
    }
  }

  function scrollToCoordsRange(cm, from, to, margin) {
    var sPos = calculateScrollPos(cm, {
      left: Math.min(from.left, to.left),
      top: Math.min(from.top, to.top) - margin,
      right: Math.max(from.right, to.right),
      bottom: Math.max(from.bottom, to.bottom) + margin
    });
    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
  }

  // Sync the scrollable area and scrollbars, ensure the viewport
  // covers the visible area.
  function updateScrollTop(cm, val) {
    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
    setScrollTop(cm, val, true);
    if (gecko) { updateDisplaySimple(cm); }
    startWorker(cm, 100);
  }

  function setScrollTop(cm, val, forceScroll) {
    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
    cm.doc.scrollTop = val;
    cm.display.scrollbars.setScrollTop(val);
    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
  }

  // Sync scroller and scrollbar, ensure the gutter elements are
  // aligned.
  function setScrollLeft(cm, val, isScroller, forceScroll) {
    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
    cm.doc.scrollLeft = val;
    alignHorizontally(cm);
    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
    cm.display.scrollbars.setScrollLeft(val);
  }

  // SCROLLBARS

  // Prepare DOM reads needed to update the scrollbars. Done in one
  // shot to minimize update/measure roundtrips.
  function measureForScrollbars(cm) {
    var d = cm.display, gutterW = d.gutters.offsetWidth;
    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
    return {
      clientHeight: d.scroller.clientHeight,
      viewHeight: d.wrapper.clientHeight,
      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
      viewWidth: d.wrapper.clientWidth,
      barLeft: cm.options.fixedGutter ? gutterW : 0,
      docHeight: docH,
      scrollHeight: docH + scrollGap(cm) + d.barHeight,
      nativeBarWidth: d.nativeBarWidth,
      gutterWidth: gutterW
    }
  }

  var NativeScrollbars = function(place, scroll, cm) {
    this.cm = cm;
    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
    vert.tabIndex = horiz.tabIndex = -1;
    place(vert); place(horiz);

    on(vert, "scroll", function () {
      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
    });
    on(horiz, "scroll", function () {
      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
    });

    this.checkedZeroWidth = false;
    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
  };

  NativeScrollbars.prototype.update = function (measure) {
    var needsH = measure.scrollWidth > measure.clientWidth + 1;
    var needsV = measure.scrollHeight > measure.clientHeight + 1;
    var sWidth = measure.nativeBarWidth;

    if (needsV) {
      this.vert.style.display = "block";
      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
      // A bug in IE8 can cause this value to be negative, so guard it.
      this.vert.firstChild.style.height =
        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
    } else {
      this.vert.scrollTop = 0;
      this.vert.style.display = "";
      this.vert.firstChild.style.height = "0";
    }

    if (needsH) {
      this.horiz.style.display = "block";
      this.horiz.style.right = needsV ? sWidth + "px" : "0";
      this.horiz.style.left = measure.barLeft + "px";
      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
      this.horiz.firstChild.style.width =
        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
    } else {
      this.horiz.style.display = "";
      this.horiz.firstChild.style.width = "0";
    }

    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
      if (sWidth == 0) { this.zeroWidthHack(); }
      this.checkedZeroWidth = true;
    }

    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
  };

  NativeScrollbars.prototype.setScrollLeft = function (pos) {
    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
  };

  NativeScrollbars.prototype.setScrollTop = function (pos) {
    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
  };

  NativeScrollbars.prototype.zeroWidthHack = function () {
    var w = mac && !mac_geMountainLion ? "12px" : "18px";
    this.horiz.style.height = this.vert.style.width = w;
    this.horiz.style.visibility = this.vert.style.visibility = "hidden";
    this.disableHoriz = new Delayed;
    this.disableVert = new Delayed;
  };

  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
    bar.style.visibility = "";
    function maybeDisable() {
      // To find out whether the scrollbar is still visible, we
      // check whether the element under the pixel in the bottom
      // right corner of the scrollbar box is the scrollbar box
      // itself (when the bar is still visible) or its filler child
      // (when the bar is hidden). If it is still visible, we keep
      // it enabled, if it's hidden, we disable pointer events.
      var box = bar.getBoundingClientRect();
      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
      if (elt != bar) { bar.style.visibility = "hidden"; }
      else { delay.set(1000, maybeDisable); }
    }
    delay.set(1000, maybeDisable);
  };

  NativeScrollbars.prototype.clear = function () {
    var parent = this.horiz.parentNode;
    parent.removeChild(this.horiz);
    parent.removeChild(this.vert);
  };

  var NullScrollbars = function () {};

  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
  NullScrollbars.prototype.setScrollLeft = function () {};
  NullScrollbars.prototype.setScrollTop = function () {};
  NullScrollbars.prototype.clear = function () {};

  function updateScrollbars(cm, measure) {
    if (!measure) { measure = measureForScrollbars(cm); }
    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
    updateScrollbarsInner(cm, measure);
    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
        { updateHeightsInViewport(cm); }
      updateScrollbarsInner(cm, measureForScrollbars(cm));
      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
    }
  }

  // Re-synchronize the fake scrollbars with the actual size of the
  // content.
  function updateScrollbarsInner(cm, measure) {
    var d = cm.display;
    var sizes = d.scrollbars.update(measure);

    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

    if (sizes.right && sizes.bottom) {
      d.scrollbarFiller.style.display = "block";
      d.scrollbarFiller.style.height = sizes.bottom + "px";
      d.scrollbarFiller.style.width = sizes.right + "px";
    } else { d.scrollbarFiller.style.display = ""; }
    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
      d.gutterFiller.style.display = "block";
      d.gutterFiller.style.height = sizes.bottom + "px";
      d.gutterFiller.style.width = measure.gutterWidth + "px";
    } else { d.gutterFiller.style.display = ""; }
  }

  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

  function initScrollbars(cm) {
    if (cm.display.scrollbars) {
      cm.display.scrollbars.clear();
      if (cm.display.scrollbars.addClass)
        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
    }

    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
      // Prevent clicks in the scrollbars from killing focus
      on(node, "mousedown", function () {
        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
      });
      node.setAttribute("cm-not-content", "true");
    }, function (pos, axis) {
      if (axis == "horizontal") { setScrollLeft(cm, pos); }
      else { updateScrollTop(cm, pos); }
    }, cm);
    if (cm.display.scrollbars.addClass)
      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  // Operations are used to wrap a series of changes to the editor
  // state in such a way that each change won't have to update the
  // cursor and display (which would be awkward, slow, and
  // error-prone). Instead, display updates are batched and then all
  // combined and executed at once.

  var nextOpId = 0;
  // Start a new operation.
  function startOperation(cm) {
    cm.curOp = {
      cm: cm,
      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
      startHeight: cm.doc.height, // Used to detect need to update scrollbar
      forceUpdate: false,      // Used to force a redraw
      updateInput: 0,       // Whether to reset the input textarea
      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
      changeObjs: null,        // Accumulated changes, for firing change events
      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
      selectionChanged: false, // Whether the selection needs to be redrawn
      updateMaxLine: false,    // Set when the widest line needs to be determined anew
      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
      scrollToPos: null,       // Used to scroll to a specific position
      focus: false,
      id: ++nextOpId,          // Unique ID
      markArrays: null         // Used by addMarkedSpan
    };
    pushOperation(cm.curOp);
  }

  // Finish an operation, updating the display and signalling delayed events
  function endOperation(cm) {
    var op = cm.curOp;
    if (op) { finishOperation(op, function (group) {
      for (var i = 0; i < group.ops.length; i++)
        { group.ops[i].cm.curOp = null; }
      endOperations(group);
    }); }
  }

  // The DOM updates done when an operation finishes are batched so
  // that the minimum number of relayouts are required.
  function endOperations(group) {
    var ops = group.ops;
    for (var i = 0; i < ops.length; i++) // Read DOM
      { endOperation_R1(ops[i]); }
    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
      { endOperation_W1(ops[i$1]); }
    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
      { endOperation_R2(ops[i$2]); }
    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
      { endOperation_W2(ops[i$3]); }
    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
      { endOperation_finish(ops[i$4]); }
  }

  function endOperation_R1(op) {
    var cm = op.cm, display = cm.display;
    maybeClipScrollbars(cm);
    if (op.updateMaxLine) { findMaxLine(cm); }

    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                         op.scrollToPos.to.line >= display.viewTo) ||
      display.maxLineChanged && cm.options.lineWrapping;
    op.update = op.mustUpdate &&
      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
  }

  function endOperation_W1(op) {
    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
  }

  function endOperation_R2(op) {
    var cm = op.cm, display = cm.display;
    if (op.updatedDisplay) { updateHeightsInViewport(cm); }

    op.barMeasure = measureForScrollbars(cm);

    // If the max line changed since it was last measured, measure it,
    // and ensure the document's width matches it.
    // updateDisplay_W2 will use these properties to do the actual resizing
    if (display.maxLineChanged && !cm.options.lineWrapping) {
      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
      cm.display.sizerWidth = op.adjustWidthTo;
      op.barMeasure.scrollWidth =
        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
    }

    if (op.updatedDisplay || op.selectionChanged)
      { op.preparedSelection = display.input.prepareSelection(); }
  }

  function endOperation_W2(op) {
    var cm = op.cm;

    if (op.adjustWidthTo != null) {
      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
      if (op.maxScrollLeft < cm.doc.scrollLeft)
        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
      cm.display.maxLineChanged = false;
    }

    var takeFocus = op.focus && op.focus == activeElt(doc(cm));
    if (op.preparedSelection)
      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
    if (op.updatedDisplay || op.startHeight != cm.doc.height)
      { updateScrollbars(cm, op.barMeasure); }
    if (op.updatedDisplay)
      { setDocumentHeight(cm, op.barMeasure); }

    if (op.selectionChanged) { restartBlink(cm); }

    if (cm.state.focused && op.updateInput)
      { cm.display.input.reset(op.typing); }
    if (takeFocus) { ensureFocus(op.cm); }
  }

  function endOperation_finish(op) {
    var cm = op.cm, display = cm.display, doc = cm.doc;

    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

    // Abort mouse wheel delta measurement, when scrolling explicitly
    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
      { display.wheelStartX = display.wheelStartY = null; }

    // Propagate the scroll position to the actual DOM scroller
    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
    // If we need to scroll a specific position into view, do so.
    if (op.scrollToPos) {
      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
      maybeScrollWindow(cm, rect);
    }

    // Fire events for markers that are hidden/unidden by editing or
    // undoing
    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
    if (hidden) { for (var i = 0; i < hidden.length; ++i)
      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

    if (display.wrapper.offsetHeight)
      { doc.scrollTop = cm.display.scroller.scrollTop; }

    // Fire change events, and delayed event handlers
    if (op.changeObjs)
      { signal(cm, "changes", cm, op.changeObjs); }
    if (op.update)
      { op.update.finish(); }
  }

  // Run the given function in an operation
  function runInOp(cm, f) {
    if (cm.curOp) { return f() }
    startOperation(cm);
    try { return f() }
    finally { endOperation(cm); }
  }
  // Wraps a function in an operation. Returns the wrapped function.
  function operation(cm, f) {
    return function() {
      if (cm.curOp) { return f.apply(cm, arguments) }
      startOperation(cm);
      try { return f.apply(cm, arguments) }
      finally { endOperation(cm); }
    }
  }
  // Used to add methods to editor and doc instances, wrapping them in
  // operations.
  function methodOp(f) {
    return function() {
      if (this.curOp) { return f.apply(this, arguments) }
      startOperation(this);
      try { return f.apply(this, arguments) }
      finally { endOperation(this); }
    }
  }
  function docMethodOp(f) {
    return function() {
      var cm = this.cm;
      if (!cm || cm.curOp) { return f.apply(this, arguments) }
      startOperation(cm);
      try { return f.apply(this, arguments) }
      finally { endOperation(cm); }
    }
  }

  // HIGHLIGHT WORKER

  function startWorker(cm, time) {
    if (cm.doc.highlightFrontier < cm.display.viewTo)
      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
  }

  function highlightWorker(cm) {
    var doc = cm.doc;
    if (doc.highlightFrontier >= cm.display.viewTo) { return }
    var end = +new Date + cm.options.workTime;
    var context = getContextBefore(cm, doc.highlightFrontier);
    var changedLines = [];

    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
      if (context.line >= cm.display.viewFrom) { // Visible
        var oldStyles = line.styles;
        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
        var highlighted = highlightLine(cm, line, context, true);
        if (resetState) { context.state = resetState; }
        line.styles = highlighted.styles;
        var oldCls = line.styleClasses, newCls = highlighted.classes;
        if (newCls) { line.styleClasses = newCls; }
        else if (oldCls) { line.styleClasses = null; }
        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
        if (ischange) { changedLines.push(context.line); }
        line.stateAfter = context.save();
        context.nextLine();
      } else {
        if (line.text.length <= cm.options.maxHighlightLength)
          { processLine(cm, line.text, context); }
        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
        context.nextLine();
      }
      if (+new Date > end) {
        startWorker(cm, cm.options.workDelay);
        return true
      }
    });
    doc.highlightFrontier = context.line;
    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
    if (changedLines.length) { runInOp(cm, function () {
      for (var i = 0; i < changedLines.length; i++)
        { regLineChange(cm, changedLines[i], "text"); }
    }); }
  }

  // DISPLAY DRAWING

  var DisplayUpdate = function(cm, viewport, force) {
    var display = cm.display;

    this.viewport = viewport;
    // Store some values that we'll need later (but don't want to force a relayout for)
    this.visible = visibleLines(display, cm.doc, viewport);
    this.editorIsHidden = !display.wrapper.offsetWidth;
    this.wrapperHeight = display.wrapper.clientHeight;
    this.wrapperWidth = display.wrapper.clientWidth;
    this.oldDisplayWidth = displayWidth(cm);
    this.force = force;
    this.dims = getDimensions(cm);
    this.events = [];
  };

  DisplayUpdate.prototype.signal = function (emitter, type) {
    if (hasHandler(emitter, type))
      { this.events.push(arguments); }
  };
  DisplayUpdate.prototype.finish = function () {
    for (var i = 0; i < this.events.length; i++)
      { signal.apply(null, this.events[i]); }
  };

  function maybeClipScrollbars(cm) {
    var display = cm.display;
    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
      display.heightForcer.style.height = scrollGap(cm) + "px";
      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
      display.scrollbarsClipped = true;
    }
  }

  function selectionSnapshot(cm) {
    if (cm.hasFocus()) { return null }
    var active = activeElt(doc(cm));
    if (!active || !contains(cm.display.lineDiv, active)) { return null }
    var result = {activeElt: active};
    if (window.getSelection) {
      var sel = win(cm).getSelection();
      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
        result.anchorNode = sel.anchorNode;
        result.anchorOffset = sel.anchorOffset;
        result.focusNode = sel.focusNode;
        result.focusOffset = sel.focusOffset;
      }
    }
    return result
  }

  function restoreSelection(snapshot) {
    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(snapshot.activeElt.ownerDocument)) { return }
    snapshot.activeElt.focus();
    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) &&
        snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
      var doc = snapshot.activeElt.ownerDocument;
      var sel = doc.defaultView.getSelection(), range = doc.createRange();
      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
      sel.extend(snapshot.focusNode, snapshot.focusOffset);
    }
  }

  // Does the actual updating of the line display. Bails out
  // (returning false) when there is nothing to be done and forced is
  // false.
  function updateDisplayIfNeeded(cm, update) {
    var display = cm.display, doc = cm.doc;

    if (update.editorIsHidden) {
      resetView(cm);
      return false
    }

    // Bail out if the visible area is already rendered and nothing changed.
    if (!update.force &&
        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
        display.renderedView == display.view && countDirtyView(cm) == 0)
      { return false }

    if (maybeUpdateLineNumberWidth(cm)) {
      resetView(cm);
      update.dims = getDimensions(cm);
    }

    // Compute a suitable new viewport (from & to)
    var end = doc.first + doc.size;
    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
    if (sawCollapsedSpans) {
      from = visualLineNo(cm.doc, from);
      to = visualLineEndNo(cm.doc, to);
    }

    var different = from != display.viewFrom || to != display.viewTo ||
      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
    adjustView(cm, from, to);

    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
    // Position the mover div to align with the current scroll position
    cm.display.mover.style.top = display.viewOffset + "px";

    var toUpdate = countDirtyView(cm);
    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
      { return false }

    // For big changes, we hide the enclosing element during the
    // update, since that speeds up the operations on most browsers.
    var selSnapshot = selectionSnapshot(cm);
    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
    patchDisplay(cm, display.updateLineNumbers, update.dims);
    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
    display.renderedView = display.view;
    // There might have been a widget with a focused element that got
    // hidden or updated, if so re-focus it.
    restoreSelection(selSnapshot);

    // Prevent selection and cursors from interfering with the scroll
    // width and height.
    removeChildren(display.cursorDiv);
    removeChildren(display.selectionDiv);
    display.gutters.style.height = display.sizer.style.minHeight = 0;

    if (different) {
      display.lastWrapHeight = update.wrapperHeight;
      display.lastWrapWidth = update.wrapperWidth;
      startWorker(cm, 400);
    }

    display.updateLineNumbers = null;

    return true
  }

  function postUpdateDisplay(cm, update) {
    var viewport = update.viewport;

    for (var first = true;; first = false) {
      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
        // Clip forced viewport to actual scrollable area.
        if (viewport && viewport.top != null)
          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
        // Updated line heights might result in the drawn area not
        // actually covering the viewport. Keep looping until it does.
        update.visible = visibleLines(cm.display, cm.doc, viewport);
        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
          { break }
      } else if (first) {
        update.visible = visibleLines(cm.display, cm.doc, viewport);
      }
      if (!updateDisplayIfNeeded(cm, update)) { break }
      updateHeightsInViewport(cm);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.force = false;
    }

    update.signal(cm, "update", cm);
    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
    }
  }

  function updateDisplaySimple(cm, viewport) {
    var update = new DisplayUpdate(cm, viewport);
    if (updateDisplayIfNeeded(cm, update)) {
      updateHeightsInViewport(cm);
      postUpdateDisplay(cm, update);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.finish();
    }
  }

  // Sync the actual display DOM structure with display.view, removing
  // nodes for lines that are no longer in view, and creating the ones
  // that are not there yet, and updating the ones that are out of
  // date.
  function patchDisplay(cm, updateNumbersFrom, dims) {
    var display = cm.display, lineNumbers = cm.options.lineNumbers;
    var container = display.lineDiv, cur = container.firstChild;

    function rm(node) {
      var next = node.nextSibling;
      // Works around a throw-scroll bug in OS X Webkit
      if (webkit && mac && cm.display.currentWheelTarget == node)
        { node.style.display = "none"; }
      else
        { node.parentNode.removeChild(node); }
      return next
    }

    var view = display.view, lineN = display.viewFrom;
    // Loop over the elements in the view, syncing cur (the DOM nodes
    // in display.lineDiv) with the view as we go.
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
        var node = buildLineElement(cm, lineView, lineN, dims);
        container.insertBefore(node, cur);
      } else { // Already drawn
        while (cur != lineView.node) { cur = rm(cur); }
        var updateNumber = lineNumbers && updateNumbersFrom != null &&
          updateNumbersFrom <= lineN && lineView.lineNumber;
        if (lineView.changes) {
          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
          updateLineForChanges(cm, lineView, lineN, dims);
        }
        if (updateNumber) {
          removeChildren(lineView.lineNumber);
          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
        }
        cur = lineView.node.nextSibling;
      }
      lineN += lineView.size;
    }
    while (cur) { cur = rm(cur); }
  }

  function updateGutterSpace(display) {
    var width = display.gutters.offsetWidth;
    display.sizer.style.marginLeft = width + "px";
    // Send an event to consumers responding to changes in gutter width.
    signalLater(display, "gutterChanged", display);
  }

  function setDocumentHeight(cm, measure) {
    cm.display.sizer.style.minHeight = measure.docHeight + "px";
    cm.display.heightForcer.style.top = measure.docHeight + "px";
    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
  }

  // Re-align line numbers and gutter marks to compensate for
  // horizontal scrolling.
  function alignHorizontally(cm) {
    var display = cm.display, view = display.view;
    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
    var gutterW = display.gutters.offsetWidth, left = comp + "px";
    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
      if (cm.options.fixedGutter) {
        if (view[i].gutter)
          { view[i].gutter.style.left = left; }
        if (view[i].gutterBackground)
          { view[i].gutterBackground.style.left = left; }
      }
      var align = view[i].alignable;
      if (align) { for (var j = 0; j < align.length; j++)
        { align[j].style.left = left; } }
    } }
    if (cm.options.fixedGutter)
      { display.gutters.style.left = (comp + gutterW) + "px"; }
  }

  // Used to ensure that the line number gutter is still the right
  // size for the current document size. Returns true when an update
  // is needed.
  function maybeUpdateLineNumberWidth(cm) {
    if (!cm.options.lineNumbers) { return false }
    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
    if (last.length != display.lineNumChars) {
      var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
      display.lineGutter.style.width = "";
      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
      display.lineNumWidth = display.lineNumInnerWidth + padding;
      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
      display.lineGutter.style.width = display.lineNumWidth + "px";
      updateGutterSpace(cm.display);
      return true
    }
    return false
  }

  function getGutters(gutters, lineNumbers) {
    var result = [], sawLineNumbers = false;
    for (var i = 0; i < gutters.length; i++) {
      var name = gutters[i], style = null;
      if (typeof name != "string") { style = name.style; name = name.className; }
      if (name == "CodeMirror-linenumbers") {
        if (!lineNumbers) { continue }
        else { sawLineNumbers = true; }
      }
      result.push({className: name, style: style});
    }
    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
    return result
  }

  // Rebuild the gutter elements, ensure the margin to the left of the
  // code matches their width.
  function renderGutters(display) {
    var gutters = display.gutters, specs = display.gutterSpecs;
    removeChildren(gutters);
    display.lineGutter = null;
    for (var i = 0; i < specs.length; ++i) {
      var ref = specs[i];
      var className = ref.className;
      var style = ref.style;
      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
      if (style) { gElt.style.cssText = style; }
      if (className == "CodeMirror-linenumbers") {
        display.lineGutter = gElt;
        gElt.style.width = (display.lineNumWidth || 1) + "px";
      }
    }
    gutters.style.display = specs.length ? "" : "none";
    updateGutterSpace(display);
  }

  function updateGutters(cm) {
    renderGutters(cm.display);
    regChange(cm);
    alignHorizontally(cm);
  }

  // The display handles the DOM integration, both for input reading
  // and content drawing. It holds references to DOM nodes and
  // display-related state.

  function Display(place, doc, input, options) {
    var d = this;
    this.input = input;

    // Covers bottom-right square when both scrollbars are present.
    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
    d.scrollbarFiller.setAttribute("cm-not-content", "true");
    // Covers bottom of gutter when coverGutterNextToScrollbar is on
    // and h scrollbar is present.
    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
    d.gutterFiller.setAttribute("cm-not-content", "true");
    // Will contain the actual code, positioned to cover the viewport.
    d.lineDiv = eltP("div", null, "CodeMirror-code");
    // Elements are added to these to represent selection and cursors.
    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
    // A visibility: hidden element used to find the size of things.
    d.measure = elt("div", null, "CodeMirror-measure");
    // When lines outside of the viewport are measured, they are drawn in this.
    d.lineMeasure = elt("div", null, "CodeMirror-measure");
    // Wraps everything that needs to exist inside the vertically-padded coordinate system
    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                      null, "position: relative; outline: none");
    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
    // Moved around its parent to cover visible view.
    d.mover = elt("div", [lines], null, "position: relative");
    // Set to the height of the document, allowing scrolling.
    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
    d.sizerWidth = null;
    // Behavior of elts with overflow: auto and padding is
    // inconsistent across browsers. This is used to ensure the
    // scrollable area is big enough.
    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
    // Will contain the gutters, if any.
    d.gutters = elt("div", null, "CodeMirror-gutters");
    d.lineGutter = null;
    // Actual scrollable element.
    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
    d.scroller.setAttribute("tabIndex", "-1");
    // The element in which the editor lives.
    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

    // This attribute is respected by automatic translation systems such as Google Translate,
    // and may also be respected by tools used by human translators.
    d.wrapper.setAttribute('translate', 'no');

    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

    if (place) {
      if (place.appendChild) { place.appendChild(d.wrapper); }
      else { place(d.wrapper); }
    }

    // Current rendered range (may be bigger than the view window).
    d.viewFrom = d.viewTo = doc.first;
    d.reportedViewFrom = d.reportedViewTo = doc.first;
    // Information about the rendered lines.
    d.view = [];
    d.renderedView = null;
    // Holds info about a single rendered line when it was rendered
    // for measurement, while not in view.
    d.externalMeasured = null;
    // Empty space (in pixels) above the view
    d.viewOffset = 0;
    d.lastWrapHeight = d.lastWrapWidth = 0;
    d.updateLineNumbers = null;

    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
    d.scrollbarsClipped = false;

    // Used to only resize the line number gutter when necessary (when
    // the amount of lines crosses a boundary that makes its width change)
    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
    // Set to true when a non-horizontal-scrolling line widget is
    // added. As an optimization, line widget aligning is skipped when
    // this is false.
    d.alignWidgets = false;

    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

    // Tracks the maximum line length so that the horizontal scrollbar
    // can be kept static when scrolling.
    d.maxLine = null;
    d.maxLineLength = 0;
    d.maxLineChanged = false;

    // Used for measuring wheel scrolling granularity
    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

    // True when shift is held down.
    d.shift = false;

    // Used to track whether anything happened since the context menu
    // was opened.
    d.selForContextMenu = null;

    d.activeTouch = null;

    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
    renderGutters(d);

    input.init(d);
  }

  // Since the delta values reported on mouse wheel events are
  // unstandardized between browsers and even browser versions, and
  // generally horribly unpredictable, this code starts by measuring
  // the scroll effect that the first few mouse wheel events have,
  // and, from that, detects the way it can convert deltas to pixel
  // offsets afterwards.
  //
  // The reason we want to know the amount a wheel event will scroll
  // is that it gives us a chance to update the display before the
  // actual scrolling happens, reducing flickering.

  var wheelSamples = 0, wheelPixelsPerUnit = null;
  // Fill in a browser-detected starting value on browsers where we
  // know one. These don't have to be accurate -- the result of them
  // being wrong would just be a slight flicker on the first wheel
  // scroll (if it is large enough).
  if (ie) { wheelPixelsPerUnit = -.53; }
  else if (gecko) { wheelPixelsPerUnit = 15; }
  else if (chrome) { wheelPixelsPerUnit = -.7; }
  else if (safari) { wheelPixelsPerUnit = -1/3; }

  function wheelEventDelta(e) {
    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
    else if (dy == null) { dy = e.wheelDelta; }
    return {x: dx, y: dy}
  }
  function wheelEventPixels(e) {
    var delta = wheelEventDelta(e);
    delta.x *= wheelPixelsPerUnit;
    delta.y *= wheelPixelsPerUnit;
    return delta
  }

  function onScrollWheel(cm, e) {
    // On Chrome 102, viewport updates somehow stop wheel-based
    // scrolling. Turning off pointer events during the scroll seems
    // to avoid the issue.
    if (chrome && chrome_version == 102) {
      if (cm.display.chromeScrollHack == null) { cm.display.sizer.style.pointerEvents = "none"; }
      else { clearTimeout(cm.display.chromeScrollHack); }
      cm.display.chromeScrollHack = setTimeout(function () {
        cm.display.chromeScrollHack = null;
        cm.display.sizer.style.pointerEvents = "";
      }, 100);
    }
    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
    var pixelsPerUnit = wheelPixelsPerUnit;
    if (e.deltaMode === 0) {
      dx = e.deltaX;
      dy = e.deltaY;
      pixelsPerUnit = 1;
    }

    var display = cm.display, scroll = display.scroller;
    // Quit if there's nothing to scroll here
    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
    if (!(dx && canScrollX || dy && canScrollY)) { return }

    // Webkit browsers on OS X abort momentum scrolls when the target
    // of the scroll event is removed from the scrollable element.
    // This hack (see related code in patchDisplay) makes sure the
    // element is kept around.
    if (dy && mac && webkit) {
      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
        for (var i = 0; i < view.length; i++) {
          if (view[i].node == cur) {
            cm.display.currentWheelTarget = cur;
            break outer
          }
        }
      }
    }

    // On some browsers, horizontal scrolling will cause redraws to
    // happen before the gutter has been realigned, causing it to
    // wriggle around in a most unseemly way. When we have an
    // estimated pixels/delta value, we just handle horizontal
    // scrolling entirely here. It'll be slightly off from native, but
    // better than glitching out.
    if (dx && !gecko && !presto && pixelsPerUnit != null) {
      if (dy && canScrollY)
        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit)); }
      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
      // Only prevent default scrolling if vertical scrolling is
      // actually possible. Otherwise, it causes vertical scroll
      // jitter on OSX trackpads when deltaX is small and deltaY
      // is large (issue #3579)
      if (!dy || (dy && canScrollY))
        { e_preventDefault(e); }
      display.wheelStartX = null; // Abort measurement, if in progress
      return
    }

    // 'Project' the visible viewport to cover the area that is being
    // scrolled into view (if we know enough to estimate it).
    if (dy && pixelsPerUnit != null) {
      var pixels = dy * pixelsPerUnit;
      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
      updateDisplaySimple(cm, {top: top, bottom: bot});
    }

    if (wheelSamples < 20 && e.deltaMode !== 0) {
      if (display.wheelStartX == null) {
        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
        display.wheelDX = dx; display.wheelDY = dy;
        setTimeout(function () {
          if (display.wheelStartX == null) { return }
          var movedX = scroll.scrollLeft - display.wheelStartX;
          var movedY = scroll.scrollTop - display.wheelStartY;
          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
            (movedX && display.wheelDX && movedX / display.wheelDX);
          display.wheelStartX = display.wheelStartY = null;
          if (!sample) { return }
          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
          ++wheelSamples;
        }, 200);
      } else {
        display.wheelDX += dx; display.wheelDY += dy;
      }
    }
  }

  // Selection objects are immutable. A new one is created every time
  // the selection changes. A selection is one or more non-overlapping
  // (and non-touching) ranges, sorted, and an integer that indicates
  // which one is the primary selection (the one that's scrolled into
  // view, that getCursor returns, etc).
  var Selection = function(ranges, primIndex) {
    this.ranges = ranges;
    this.primIndex = primIndex;
  };

  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

  Selection.prototype.equals = function (other) {
    if (other == this) { return true }
    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
    for (var i = 0; i < this.ranges.length; i++) {
      var here = this.ranges[i], there = other.ranges[i];
      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
    }
    return true
  };

  Selection.prototype.deepCopy = function () {
    var out = [];
    for (var i = 0; i < this.ranges.length; i++)
      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
    return new Selection(out, this.primIndex)
  };

  Selection.prototype.somethingSelected = function () {
    for (var i = 0; i < this.ranges.length; i++)
      { if (!this.ranges[i].empty()) { return true } }
    return false
  };

  Selection.prototype.contains = function (pos, end) {
    if (!end) { end = pos; }
    for (var i = 0; i < this.ranges.length; i++) {
      var range = this.ranges[i];
      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
        { return i }
    }
    return -1
  };

  var Range = function(anchor, head) {
    this.anchor = anchor; this.head = head;
  };

  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

  // Take an unsorted, potentially overlapping set of ranges, and
  // build a selection out of it. 'Consumes' ranges array (modifying
  // it).
  function normalizeSelection(cm, ranges, primIndex) {
    var mayTouch = cm && cm.options.selectionsMayTouch;
    var prim = ranges[primIndex];
    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
    primIndex = indexOf(ranges, prim);
    for (var i = 1; i < ranges.length; i++) {
      var cur = ranges[i], prev = ranges[i - 1];
      var diff = cmp(prev.to(), cur.from());
      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
        if (i <= primIndex) { --primIndex; }
        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
      }
    }
    return new Selection(ranges, primIndex)
  }

  function simpleSelection(anchor, head) {
    return new Selection([new Range(anchor, head || anchor)], 0)
  }

  // Compute the position of the end of a change (its 'to' property
  // refers to the pre-change end).
  function changeEnd(change) {
    if (!change.text) { return change.to }
    return Pos(change.from.line + change.text.length - 1,
               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
  }

  // Adjust a position to refer to the post-change position of the
  // same text, or the end of the change if the change covers it.
  function adjustForChange(pos, change) {
    if (cmp(pos, change.from) < 0) { return pos }
    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
    return Pos(line, ch)
  }

  function computeSelAfterChange(doc, change) {
    var out = [];
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      var range = doc.sel.ranges[i];
      out.push(new Range(adjustForChange(range.anchor, change),
                         adjustForChange(range.head, change)));
    }
    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
  }

  function offsetPos(pos, old, nw) {
    if (pos.line == old.line)
      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
    else
      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
  }

  // Used by replaceSelections to allow moving the selection to the
  // start or around the replaced test. Hint may be "start" or "around".
  function computeReplacedSel(doc, changes, hint) {
    var out = [];
    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
    for (var i = 0; i < changes.length; i++) {
      var change = changes[i];
      var from = offsetPos(change.from, oldPrev, newPrev);
      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
      oldPrev = change.to;
      newPrev = to;
      if (hint == "around") {
        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
        out[i] = new Range(inv ? to : from, inv ? from : to);
      } else {
        out[i] = new Range(from, from);
      }
    }
    return new Selection(out, doc.sel.primIndex)
  }

  // Used to get the editor into a consistent state again when options change.

  function loadMode(cm) {
    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
    resetModeState(cm);
  }

  function resetModeState(cm) {
    cm.doc.iter(function (line) {
      if (line.stateAfter) { line.stateAfter = null; }
      if (line.styles) { line.styles = null; }
    });
    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
    startWorker(cm, 100);
    cm.state.modeGen++;
    if (cm.curOp) { regChange(cm); }
  }

  // DOCUMENT DATA STRUCTURE

  // By default, updates that start and end at the beginning of a line
  // are treated specially, in order to make the association of line
  // widgets and marker elements with the text behave more intuitive.
  function isWholeLineUpdate(doc, change) {
    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
  }

  // Perform a change on the document data structure.
  function updateDoc(doc, change, markedSpans, estimateHeight) {
    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
    function update(line, text, spans) {
      updateLine(line, text, spans, estimateHeight);
      signalLater(line, "change", line, change);
    }
    function linesFor(start, end) {
      var result = [];
      for (var i = start; i < end; ++i)
        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
      return result
    }

    var from = change.from, to = change.to, text = change.text;
    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

    // Adjust the line structure
    if (change.full) {
      doc.insert(0, linesFor(0, text.length));
      doc.remove(text.length, doc.size - text.length);
    } else if (isWholeLineUpdate(doc, change)) {
      // This is a whole-line replace. Treated specially to make
      // sure line objects move the way they are supposed to.
      var added = linesFor(0, text.length - 1);
      update(lastLine, lastLine.text, lastSpans);
      if (nlines) { doc.remove(from.line, nlines); }
      if (added.length) { doc.insert(from.line, added); }
    } else if (firstLine == lastLine) {
      if (text.length == 1) {
        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
      } else {
        var added$1 = linesFor(1, text.length - 1);
        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
        doc.insert(from.line + 1, added$1);
      }
    } else if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
      doc.remove(from.line + 1, nlines);
    } else {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
      var added$2 = linesFor(1, text.length - 1);
      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
      doc.insert(from.line + 1, added$2);
    }

    signalLater(doc, "change", doc, change);
  }

  // Call f for all linked documents.
  function linkedDocs(doc, f, sharedHistOnly) {
    function propagate(doc, skip, sharedHist) {
      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
        var rel = doc.linked[i];
        if (rel.doc == skip) { continue }
        var shared = sharedHist && rel.sharedHist;
        if (sharedHistOnly && !shared) { continue }
        f(rel.doc, shared);
        propagate(rel.doc, doc, shared);
      } }
    }
    propagate(doc, null, true);
  }

  // Attach a document to an editor.
  function attachDoc(cm, doc) {
    if (doc.cm) { throw new Error("This document is already in use.") }
    cm.doc = doc;
    doc.cm = cm;
    estimateLineHeights(cm);
    loadMode(cm);
    setDirectionClass(cm);
    cm.options.direction = doc.direction;
    if (!cm.options.lineWrapping) { findMaxLine(cm); }
    cm.options.mode = doc.modeOption;
    regChange(cm);
  }

  function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
  }

  function directionChanged(cm) {
    runInOp(cm, function () {
      setDirectionClass(cm);
      regChange(cm);
    });
  }

  function History(prev) {
    // Arrays of change events and selections. Doing something adds an
    // event to done and clears undo. Undoing moves events from done
    // to undone, redoing moves them in the other direction.
    this.done = []; this.undone = [];
    this.undoDepth = prev ? prev.undoDepth : Infinity;
    // Used to track when changes can be merged into a single undo
    // event
    this.lastModTime = this.lastSelTime = 0;
    this.lastOp = this.lastSelOp = null;
    this.lastOrigin = this.lastSelOrigin = null;
    // Used by the isClean() method
    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
  }

  // Create a history change event from an updateDoc-style change
  // object.
  function historyChangeFromChange(doc, change) {
    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
    return histChange
  }

  // Pop all selection events off the end of a history array. Stop at
  // a change event.
  function clearSelectionEvents(array) {
    while (array.length) {
      var last = lst(array);
      if (last.ranges) { array.pop(); }
      else { break }
    }
  }

  // Find the top change event in the history. Pop off selection
  // events that are in the way.
  function lastChangeEvent(hist, force) {
    if (force) {
      clearSelectionEvents(hist.done);
      return lst(hist.done)
    } else if (hist.done.length && !lst(hist.done).ranges) {
      return lst(hist.done)
    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
      hist.done.pop();
      return lst(hist.done)
    }
  }

  // Register a change in the history. Merges changes that are within
  // a single operation, or are close together with an origin that
  // allows merging (starting with "+") into a single event.
  function addChangeToHistory(doc, change, selAfter, opId) {
    var hist = doc.history;
    hist.undone.length = 0;
    var time = +new Date, cur;
    var last;

    if ((hist.lastOp == opId ||
         hist.lastOrigin == change.origin && change.origin &&
         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
          change.origin.charAt(0) == "*")) &&
        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
      // Merge this change into the last event
      last = lst(cur.changes);
      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
        // Optimized case for simple insertion -- don't want to add
        // new changesets for every character typed
        last.to = changeEnd(change);
      } else {
        // Add new sub-event
        cur.changes.push(historyChangeFromChange(doc, change));
      }
    } else {
      // Can not be merged, start a new event.
      var before = lst(hist.done);
      if (!before || !before.ranges)
        { pushSelectionToHistory(doc.sel, hist.done); }
      cur = {changes: [historyChangeFromChange(doc, change)],
             generation: hist.generation};
      hist.done.push(cur);
      while (hist.done.length > hist.undoDepth) {
        hist.done.shift();
        if (!hist.done[0].ranges) { hist.done.shift(); }
      }
    }
    hist.done.push(selAfter);
    hist.generation = ++hist.maxGeneration;
    hist.lastModTime = hist.lastSelTime = time;
    hist.lastOp = hist.lastSelOp = opId;
    hist.lastOrigin = hist.lastSelOrigin = change.origin;

    if (!last) { signal(doc, "historyAdded"); }
  }

  function selectionEventCanBeMerged(doc, origin, prev, sel) {
    var ch = origin.charAt(0);
    return ch == "*" ||
      ch == "+" &&
      prev.ranges.length == sel.ranges.length &&
      prev.somethingSelected() == sel.somethingSelected() &&
      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
  }

  // Called whenever the selection changes, sets the new selection as
  // the pending selection in the history, and pushes the old pending
  // selection into the 'done' array when it was significantly
  // different (in number of selected ranges, emptiness, or time).
  function addSelectionToHistory(doc, sel, opId, options) {
    var hist = doc.history, origin = options && options.origin;

    // A new event is started when the previous origin does not match
    // the current, or the origins don't allow matching. Origins
    // starting with * are always merged, those starting with + are
    // merged when similar and close together in time.
    if (opId == hist.lastSelOp ||
        (origin && hist.lastSelOrigin == origin &&
         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
      { hist.done[hist.done.length - 1] = sel; }
    else
      { pushSelectionToHistory(sel, hist.done); }

    hist.lastSelTime = +new Date;
    hist.lastSelOrigin = origin;
    hist.lastSelOp = opId;
    if (options && options.clearRedo !== false)
      { clearSelectionEvents(hist.undone); }
  }

  function pushSelectionToHistory(sel, dest) {
    var top = lst(dest);
    if (!(top && top.ranges && top.equals(sel)))
      { dest.push(sel); }
  }

  // Used to store marked span information in the history.
  function attachLocalSpans(doc, change, from, to) {
    var existing = change["spans_" + doc.id], n = 0;
    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
      if (line.markedSpans)
        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
      ++n;
    });
  }

  // When un/re-doing restores text containing marked spans, those
  // that have been explicitly cleared should not be restored.
  function removeClearedSpans(spans) {
    if (!spans) { return null }
    var out;
    for (var i = 0; i < spans.length; ++i) {
      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
      else if (out) { out.push(spans[i]); }
    }
    return !out ? spans : out.length ? out : null
  }

  // Retrieve and filter the old marked spans stored in a change event.
  function getOldSpans(doc, change) {
    var found = change["spans_" + doc.id];
    if (!found) { return null }
    var nw = [];
    for (var i = 0; i < change.text.length; ++i)
      { nw.push(removeClearedSpans(found[i])); }
    return nw
  }

  // Used for un/re-doing changes from the history. Combines the
  // result of computing the existing spans with the set of spans that
  // existed in the history (so that deleting around a span and then
  // undoing brings back the span).
  function mergeOldSpans(doc, change) {
    var old = getOldSpans(doc, change);
    var stretched = stretchSpansOverChange(doc, change);
    if (!old) { return stretched }
    if (!stretched) { return old }

    for (var i = 0; i < old.length; ++i) {
      var oldCur = old[i], stretchCur = stretched[i];
      if (oldCur && stretchCur) {
        spans: for (var j = 0; j < stretchCur.length; ++j) {
          var span = stretchCur[j];
          for (var k = 0; k < oldCur.length; ++k)
            { if (oldCur[k].marker == span.marker) { continue spans } }
          oldCur.push(span);
        }
      } else if (stretchCur) {
        old[i] = stretchCur;
      }
    }
    return old
  }

  // Used both to provide a JSON-safe object in .getHistory, and, when
  // detaching a document, to split the history in two
  function copyHistoryArray(events, newGroup, instantiateSel) {
    var copy = [];
    for (var i = 0; i < events.length; ++i) {
      var event = events[i];
      if (event.ranges) {
        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
        continue
      }
      var changes = event.changes, newChanges = [];
      copy.push({changes: newChanges});
      for (var j = 0; j < changes.length; ++j) {
        var change = changes[j], m = (void 0);
        newChanges.push({from: change.from, to: change.to, text: change.text});
        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
          if (indexOf(newGroup, Number(m[1])) > -1) {
            lst(newChanges)[prop] = change[prop];
            delete change[prop];
          }
        } } }
      }
    }
    return copy
  }

  // The 'scroll' parameter given to many of these indicated whether
  // the new cursor position should be scrolled into view after
  // modifying the selection.

  // If shift is held or the extend flag is set, extends a range to
  // include a given position (and optionally a second position).
  // Otherwise, simply returns the range between the given positions.
  // Used for cursor motion and such.
  function extendRange(range, head, other, extend) {
    if (extend) {
      var anchor = range.anchor;
      if (other) {
        var posBefore = cmp(head, anchor) < 0;
        if (posBefore != (cmp(other, anchor) < 0)) {
          anchor = head;
          head = other;
        } else if (posBefore != (cmp(head, other) < 0)) {
          head = other;
        }
      }
      return new Range(anchor, head)
    } else {
      return new Range(other || head, head)
    }
  }

  // Extend the primary selection range, discard the rest.
  function extendSelection(doc, head, other, options, extend) {
    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
  }

  // Extend all selections (pos is an array of selections with length
  // equal the number of selections)
  function extendSelections(doc, heads, options) {
    var out = [];
    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
    for (var i = 0; i < doc.sel.ranges.length; i++)
      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
    setSelection(doc, newSel, options);
  }

  // Updates a single range in the selection.
  function replaceOneSelection(doc, i, range, options) {
    var ranges = doc.sel.ranges.slice(0);
    ranges[i] = range;
    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
  }

  // Reset the selection to a single range.
  function setSimpleSelection(doc, anchor, head, options) {
    setSelection(doc, simpleSelection(anchor, head), options);
  }

  // Give beforeSelectionChange handlers a change to influence a
  // selection update.
  function filterSelectionChange(doc, sel, options) {
    var obj = {
      ranges: sel.ranges,
      update: function(ranges) {
        this.ranges = [];
        for (var i = 0; i < ranges.length; i++)
          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                     clipPos(doc, ranges[i].head)); }
      },
      origin: options && options.origin
    };
    signal(doc, "beforeSelectionChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
    else { return sel }
  }

  function setSelectionReplaceHistory(doc, sel, options) {
    var done = doc.history.done, last = lst(done);
    if (last && last.ranges) {
      done[done.length - 1] = sel;
      setSelectionNoUndo(doc, sel, options);
    } else {
      setSelection(doc, sel, options);
    }
  }

  // Set a new selection.
  function setSelection(doc, sel, options) {
    setSelectionNoUndo(doc, sel, options);
    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
  }

  function setSelectionNoUndo(doc, sel, options) {
    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
      { sel = filterSelectionChange(doc, sel, options); }

    var bias = options && options.bias ||
      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor")
      { ensureCursorVisible(doc.cm); }
  }

  function setSelectionInner(doc, sel) {
    if (sel.equals(doc.sel)) { return }

    doc.sel = sel;

    if (doc.cm) {
      doc.cm.curOp.updateInput = 1;
      doc.cm.curOp.selectionChanged = true;
      signalCursorActivity(doc.cm);
    }
    signalLater(doc, "cursorActivity", doc);
  }

  // Verify that the selection does not partially select any atomic
  // marked ranges.
  function reCheckSelection(doc) {
    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
  }

  // Return a selection that does not partially select any atomic
  // ranges.
  function skipAtomicInSelection(doc, sel, bias, mayClear) {
    var out;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range = sel.ranges[i];
      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
      var newHead = range.head == range.anchor ? newAnchor : skipAtomic(doc, range.head, old && old.head, bias, mayClear);
      if (out || newAnchor != range.anchor || newHead != range.head) {
        if (!out) { out = sel.ranges.slice(0, i); }
        out[i] = new Range(newAnchor, newHead);
      }
    }
    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
  }

  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
    var line = getLine(doc, pos.line);
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var sp = line.markedSpans[i], m = sp.marker;

      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
      // is with selectLeft/Right
      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;

      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
        if (mayClear) {
          signal(m, "beforeCursorEnter");
          if (m.explicitlyCleared) {
            if (!line.markedSpans) { break }
            else {--i; continue}
          }
        }
        if (!m.atomic) { continue }

        if (oldPos) {
          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
          if (dir < 0 ? preventCursorRight : preventCursorLeft)
            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
        }

        var far = m.find(dir < 0 ? -1 : 1);
        if (dir < 0 ? preventCursorLeft : preventCursorRight)
          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
      }
    } }
    return pos
  }

  // Ensure a given position is not inside an atomic range.
  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
    var dir = bias || 1;
    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
    if (!found) {
      doc.cantEdit = true;
      return Pos(doc.first, 0)
    }
    return found
  }

  function movePos(doc, pos, dir, line) {
    if (dir < 0 && pos.ch == 0) {
      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
      else { return null }
    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
      else { return null }
    } else {
      return new Pos(pos.line, pos.ch + dir)
    }
  }

  function selectAll(cm) {
    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
  }

  // UPDATING

  // Allow "beforeChange" event handlers to influence a change
  function filterChange(doc, change, update) {
    var obj = {
      canceled: false,
      from: change.from,
      to: change.to,
      text: change.text,
      origin: change.origin,
      cancel: function () { return obj.canceled = true; }
    };
    if (update) { obj.update = function (from, to, text, origin) {
      if (from) { obj.from = clipPos(doc, from); }
      if (to) { obj.to = clipPos(doc, to); }
      if (text) { obj.text = text; }
      if (origin !== undefined) { obj.origin = origin; }
    }; }
    signal(doc, "beforeChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

    if (obj.canceled) {
      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
      return null
    }
    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
  }

  // Apply a change to a document, and add it to the document's
  // history, and propagating it to all linked documents.
  function makeChange(doc, change, ignoreReadOnly) {
    if (doc.cm) {
      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
      if (doc.cm.state.suppressEdits) { return }
    }

    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
      change = filterChange(doc, change, true);
      if (!change) { return }
    }

    // Possibly split or suppress the update based on the presence
    // of read-only spans in its range.
    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
    if (split) {
      for (var i = split.length - 1; i >= 0; --i)
        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
    } else {
      makeChangeInner(doc, change);
    }
  }

  function makeChangeInner(doc, change) {
    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
    var selAfter = computeSelAfterChange(doc, change);
    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
    var rebased = [];

    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
    });
  }

  // Revert a change stored in a document's history.
  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
    var suppress = doc.cm && doc.cm.state.suppressEdits;
    if (suppress && !allowSelectionOnly) { return }

    var hist = doc.history, event, selAfter = doc.sel;
    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

    // Verify that there is a useable event (so that ctrl-z won't
    // needlessly clear selection events)
    var i = 0;
    for (; i < source.length; i++) {
      event = source[i];
      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
        { break }
    }
    if (i == source.length) { return }
    hist.lastOrigin = hist.lastSelOrigin = null;

    for (;;) {
      event = source.pop();
      if (event.ranges) {
        pushSelectionToHistory(event, dest);
        if (allowSelectionOnly && !event.equals(doc.sel)) {
          setSelection(doc, event, {clearRedo: false});
          return
        }
        selAfter = event;
      } else if (suppress) {
        source.push(event);
        return
      } else { break }
    }

    // Build up a reverse change object to add to the opposite history
    // stack (redo when undoing, and vice versa).
    var antiChanges = [];
    pushSelectionToHistory(selAfter, dest);
    dest.push({changes: antiChanges, generation: hist.generation});
    hist.generation = event.generation || ++hist.maxGeneration;

    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

    var loop = function ( i ) {
      var change = event.changes[i];
      change.origin = type;
      if (filter && !filterChange(doc, change, false)) {
        source.length = 0;
        return {}
      }

      antiChanges.push(historyChangeFromChange(doc, change));

      var after = i ? computeSelAfterChange(doc, change) : lst(source);
      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
      var rebased = [];

      // Propagate to the linked documents
      linkedDocs(doc, function (doc, sharedHist) {
        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
          rebaseHist(doc.history, change);
          rebased.push(doc.history);
        }
        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
      });
    };

    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
      var returned = loop( i$1 );

      if ( returned ) return returned.v;
    }
  }

  // Sub-views need their line numbers shifted when text is added
  // above or below them in the parent document.
  function shiftDoc(doc, distance) {
    if (distance == 0) { return }
    doc.first += distance;
    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
      Pos(range.anchor.line + distance, range.anchor.ch),
      Pos(range.head.line + distance, range.head.ch)
    ); }), doc.sel.primIndex);
    if (doc.cm) {
      regChange(doc.cm, doc.first, doc.first - distance, distance);
      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
        { regLineChange(doc.cm, l, "gutter"); }
    }
  }

  // More lower-level change function, handling only a single document
  // (not linked ones).
  function makeChangeSingleDoc(doc, change, selAfter, spans) {
    if (doc.cm && !doc.cm.curOp)
      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

    if (change.to.line < doc.first) {
      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
      return
    }
    if (change.from.line > doc.lastLine()) { return }

    // Clip the change to the size of this doc
    if (change.from.line < doc.first) {
      var shift = change.text.length - 1 - (doc.first - change.from.line);
      shiftDoc(doc, shift);
      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
                text: [lst(change.text)], origin: change.origin};
    }
    var last = doc.lastLine();
    if (change.to.line > last) {
      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
                text: [change.text[0]], origin: change.origin};
    }

    change.removed = getBetween(doc, change.from, change.to);

    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
    else { updateDoc(doc, change, spans); }
    setSelectionNoUndo(doc, selAfter, sel_dontScroll);

    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
      { doc.cantEdit = false; }
  }

  // Handle the interaction of a change to a document with the editor
  // that this document is part of.
  function makeChangeSingleDocInEditor(cm, change, spans) {
    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

    var recomputeMaxLength = false, checkWidthStart = from.line;
    if (!cm.options.lineWrapping) {
      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
      doc.iter(checkWidthStart, to.line + 1, function (line) {
        if (line == display.maxLine) {
          recomputeMaxLength = true;
          return true
        }
      });
    }

    if (doc.sel.contains(change.from, change.to) > -1)
      { signalCursorActivity(cm); }

    updateDoc(doc, change, spans, estimateHeight(cm));

    if (!cm.options.lineWrapping) {
      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
        var len = lineLength(line);
        if (len > display.maxLineLength) {
          display.maxLine = line;
          display.maxLineLength = len;
          display.maxLineChanged = true;
          recomputeMaxLength = false;
        }
      });
      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
    }

    retreatFrontier(doc, from.line);
    startWorker(cm, 400);

    var lendiff = change.text.length - (to.line - from.line) - 1;
    // Remember that these lines changed, for updating the display
    if (change.full)
      { regChange(cm); }
    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
      { regLineChange(cm, from.line, "text"); }
    else
      { regChange(cm, from.line, to.line + 1, lendiff); }

    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
    if (changeHandler || changesHandler) {
      var obj = {
        from: from, to: to,
        text: change.text,
        removed: change.removed,
        origin: change.origin
      };
      if (changeHandler) { signalLater(cm, "change", cm, obj); }
      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
    }
    cm.display.selForContextMenu = null;
  }

  function replaceRange(doc, code, from, to, origin) {
    var assign;

    if (!to) { to = from; }
    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
    if (typeof code == "string") { code = doc.splitLines(code); }
    makeChange(doc, {from: from, to: to, text: code, origin: origin});
  }

  // Rebasing/resetting history to deal with externally-sourced changes

  function rebaseHistSelSingle(pos, from, to, diff) {
    if (to < pos.line) {
      pos.line += diff;
    } else if (from < pos.line) {
      pos.line = from;
      pos.ch = 0;
    }
  }

  // Tries to rebase an array of history events given a change in the
  // document. If the change touches the same lines as the event, the
  // event, and everything 'behind' it, is discarded. If the change is
  // before the event, the event's positions are updated. Uses a
  // copy-on-write scheme for the positions, to avoid having to
  // reallocate them all on every rebase, but also avoid problems with
  // shared position objects being unsafely updated.
  function rebaseHistArray(array, from, to, diff) {
    for (var i = 0; i < array.length; ++i) {
      var sub = array[i], ok = true;
      if (sub.ranges) {
        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
        for (var j = 0; j < sub.ranges.length; j++) {
          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
        }
        continue
      }
      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
        var cur = sub.changes[j$1];
        if (to < cur.from.line) {
          cur.from = Pos(cur.from.line + diff, cur.from.ch);
          cur.to = Pos(cur.to.line + diff, cur.to.ch);
        } else if (from <= cur.to.line) {
          ok = false;
          break
        }
      }
      if (!ok) {
        array.splice(0, i + 1);
        i = 0;
      }
    }
  }

  function rebaseHist(hist, change) {
    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
    rebaseHistArray(hist.done, from, to, diff);
    rebaseHistArray(hist.undone, from, to, diff);
  }

  // Utility for applying a change to a line by handle or number,
  // returning the number and optionally registering the line as
  // changed.
  function changeLine(doc, handle, changeType, op) {
    var no = handle, line = handle;
    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
    else { no = lineNo(handle); }
    if (no == null) { return null }
    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
    return line
  }

  // The document is represented as a BTree consisting of leaves, with
  // chunk of lines in them, and branches, with up to ten leaves or
  // other branch nodes below them. The top node is always a branch
  // node, and is the document object itself (meaning it has
  // additional methods and properties).
  //
  // All nodes have parent links. The tree is used both to go from
  // line numbers to line objects, and to go from objects to numbers.
  // It also indexes by height, and is used to convert between height
  // and line object, and to find the total height of the document.
  //
  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

  function LeafChunk(lines) {
    this.lines = lines;
    this.parent = null;
    var height = 0;
    for (var i = 0; i < lines.length; ++i) {
      lines[i].parent = this;
      height += lines[i].height;
    }
    this.height = height;
  }

  LeafChunk.prototype = {
    chunkSize: function() { return this.lines.length },

    // Remove the n lines at offset 'at'.
    removeInner: function(at, n) {
      for (var i = at, e = at + n; i < e; ++i) {
        var line = this.lines[i];
        this.height -= line.height;
        cleanUpLine(line);
        signalLater(line, "delete");
      }
      this.lines.splice(at, n);
    },

    // Helper used to collapse a small branch into a single leaf.
    collapse: function(lines) {
      lines.push.apply(lines, this.lines);
    },

    // Insert the given array of lines at offset 'at', count them as
    // having the given height.
    insertInner: function(at, lines, height) {
      this.height += height;
      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
    },

    // Used to iterate over a part of the tree.
    iterN: function(at, n, op) {
      for (var e = at + n; at < e; ++at)
        { if (op(this.lines[at])) { return true } }
    }
  };

  function BranchChunk(children) {
    this.children = children;
    var size = 0, height = 0;
    for (var i = 0; i < children.length; ++i) {
      var ch = children[i];
      size += ch.chunkSize(); height += ch.height;
      ch.parent = this;
    }
    this.size = size;
    this.height = height;
    this.parent = null;
  }

  BranchChunk.prototype = {
    chunkSize: function() { return this.size },

    removeInner: function(at, n) {
      this.size -= n;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var rm = Math.min(n, sz - at), oldHeight = child.height;
          child.removeInner(at, rm);
          this.height -= oldHeight - child.height;
          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
          if ((n -= rm) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
      // If the result is smaller than 25 lines, ensure that it is a
      // single leaf node.
      if (this.size - n < 25 &&
          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
        var lines = [];
        this.collapse(lines);
        this.children = [new LeafChunk(lines)];
        this.children[0].parent = this;
      }
    },

    collapse: function(lines) {
      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
    },

    insertInner: function(at, lines, height) {
      this.size += lines.length;
      this.height += height;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at <= sz) {
          child.insertInner(at, lines, height);
          if (child.lines && child.lines.length > 50) {
            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
            var remaining = child.lines.length % 25 + 25;
            for (var pos = remaining; pos < child.lines.length;) {
              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
              child.height -= leaf.height;
              this.children.splice(++i, 0, leaf);
              leaf.parent = this;
            }
            child.lines = child.lines.slice(0, remaining);
            this.maybeSpill();
          }
          break
        }
        at -= sz;
      }
    },

    // When a node has grown, check whether it should be split.
    maybeSpill: function() {
      if (this.children.length <= 10) { return }
      var me = this;
      do {
        var spilled = me.children.splice(me.children.length - 5, 5);
        var sibling = new BranchChunk(spilled);
        if (!me.parent) { // Become the parent node
          var copy = new BranchChunk(me.children);
          copy.parent = me;
          me.children = [copy, sibling];
          me = copy;
       } else {
          me.size -= sibling.size;
          me.height -= sibling.height;
          var myIndex = indexOf(me.parent.children, me);
          me.parent.children.splice(myIndex + 1, 0, sibling);
        }
        sibling.parent = me.parent;
      } while (me.children.length > 10)
      me.parent.maybeSpill();
    },

    iterN: function(at, n, op) {
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var used = Math.min(n, sz - at);
          if (child.iterN(at, used, op)) { return true }
          if ((n -= used) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
    }
  };

  // Line widgets are block elements displayed above or below a line.

  var LineWidget = function(doc, node, options) {
    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
      { this[opt] = options[opt]; } } }
    this.doc = doc;
    this.node = node;
  };

  LineWidget.prototype.clear = function () {
    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
    if (no == null || !ws) { return }
    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
    if (!ws.length) { line.widgets = null; }
    var height = widgetHeight(this);
    updateLineHeight(line, Math.max(0, line.height - height));
    if (cm) {
      runInOp(cm, function () {
        adjustScrollWhenAboveVisible(cm, line, -height);
        regLineChange(cm, no, "widget");
      });
      signalLater(cm, "lineWidgetCleared", cm, this, no);
    }
  };

  LineWidget.prototype.changed = function () {
      var this$1 = this;

    var oldH = this.height, cm = this.doc.cm, line = this.line;
    this.height = null;
    var diff = widgetHeight(this) - oldH;
    if (!diff) { return }
    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
    if (cm) {
      runInOp(cm, function () {
        cm.curOp.forceUpdate = true;
        adjustScrollWhenAboveVisible(cm, line, diff);
        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
      });
    }
  };
  eventMixin(LineWidget);

  function adjustScrollWhenAboveVisible(cm, line, diff) {
    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
      { addToScrollTop(cm, diff); }
  }

  function addLineWidget(doc, handle, node, options) {
    var widget = new LineWidget(doc, node, options);
    var cm = doc.cm;
    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
    changeLine(doc, handle, "widget", function (line) {
      var widgets = line.widgets || (line.widgets = []);
      if (widget.insertAt == null) { widgets.push(widget); }
      else { widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget); }
      widget.line = line;
      if (cm && !lineIsHidden(doc, line)) {
        var aboveVisible = heightAtLine(line) < doc.scrollTop;
        updateLineHeight(line, line.height + widgetHeight(widget));
        if (aboveVisible) { addToScrollTop(cm, widget.height); }
        cm.curOp.forceUpdate = true;
      }
      return true
    });
    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
    return widget
  }

  // TEXTMARKERS

  // Created with markText and setBookmark methods. A TextMarker is a
  // handle that can be used to clear or find a marked position in the
  // document. Line objects hold arrays (markedSpans) containing
  // {from, to, marker} object pointing to such marker objects, and
  // indicating that such a marker is present on that line. Multiple
  // lines may point to the same marker when it spans across lines.
  // The spans will have null for their from/to properties when the
  // marker continues beyond the start/end of the line. Markers have
  // links back to the lines they currently touch.

  // Collapsed markers have unique ids, in order to be able to order
  // them, which is needed for uniquely determining an outer marker
  // when they overlap (they may nest, but not partially overlap).
  var nextMarkerId = 0;

  var TextMarker = function(doc, type) {
    this.lines = [];
    this.type = type;
    this.doc = doc;
    this.id = ++nextMarkerId;
  };

  // Clear the marker.
  TextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    var cm = this.doc.cm, withOp = cm && !cm.curOp;
    if (withOp) { startOperation(cm); }
    if (hasHandler(this, "clear")) {
      var found = this.find();
      if (found) { signalLater(this, "clear", found.from, found.to); }
    }
    var min = null, max = null;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
      else if (cm) {
        if (span.to != null) { max = lineNo(line); }
        if (span.from != null) { min = lineNo(line); }
      }
      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
        { updateLineHeight(line, textHeight(cm.display)); }
    }
    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
      if (len > cm.display.maxLineLength) {
        cm.display.maxLine = visual;
        cm.display.maxLineLength = len;
        cm.display.maxLineChanged = true;
      }
    } }

    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
    this.lines.length = 0;
    this.explicitlyCleared = true;
    if (this.atomic && this.doc.cantEdit) {
      this.doc.cantEdit = false;
      if (cm) { reCheckSelection(cm.doc); }
    }
    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
    if (withOp) { endOperation(cm); }
    if (this.parent) { this.parent.clear(); }
  };

  // Find the position of the marker in the document. Returns a {from,
  // to} object by default. Side can be passed to get a specific side
  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
  // Pos objects returned contain a line object, rather than a line
  // number (used to prevent looking up the same line twice).
  TextMarker.prototype.find = function (side, lineObj) {
    if (side == null && this.type == "bookmark") { side = 1; }
    var from, to;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (span.from != null) {
        from = Pos(lineObj ? line : lineNo(line), span.from);
        if (side == -1) { return from }
      }
      if (span.to != null) {
        to = Pos(lineObj ? line : lineNo(line), span.to);
        if (side == 1) { return to }
      }
    }
    return from && {from: from, to: to}
  };

  // Signals that the marker's widget changed, and surrounding layout
  // should be recomputed.
  TextMarker.prototype.changed = function () {
      var this$1 = this;

    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
    if (!pos || !cm) { return }
    runInOp(cm, function () {
      var line = pos.line, lineN = lineNo(pos.line);
      var view = findViewForLine(cm, lineN);
      if (view) {
        clearLineMeasurementCacheFor(view);
        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
      }
      cm.curOp.updateMaxLine = true;
      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
        var oldHeight = widget.height;
        widget.height = null;
        var dHeight = widgetHeight(widget) - oldHeight;
        if (dHeight)
          { updateLineHeight(line, line.height + dHeight); }
      }
      signalLater(cm, "markerChanged", cm, this$1);
    });
  };

  TextMarker.prototype.attachLine = function (line) {
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp;
      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
    }
    this.lines.push(line);
  };

  TextMarker.prototype.detachLine = function (line) {
    this.lines.splice(indexOf(this.lines, line), 1);
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp
      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
    }
  };
  eventMixin(TextMarker);

  // Create a marker, wire it up to the right lines, and
  function markText(doc, from, to, options, type) {
    // Shared markers (across linked documents) are handled separately
    // (markTextShared will call out to this again, once per
    // document).
    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
    // Ensure we are in an operation.
    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

    var marker = new TextMarker(doc, type), diff = cmp(from, to);
    if (options) { copyObj(options, marker, false); }
    // Don't connect empty markers unless clearWhenEmpty is false
    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
      { return marker }
    if (marker.replacedWith) {
      // Showing up as a widget implies collapsed (widget replaces text)
      marker.collapsed = true;
      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
    }
    if (marker.collapsed) {
      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
      seeCollapsedSpans();
    }

    if (marker.addToHistory)
      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

    var curLine = from.line, cm = doc.cm, updateMaxLine;
    doc.iter(curLine, to.line + 1, function (line) {
      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
        { updateMaxLine = true; }
      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
      addMarkedSpan(line, new MarkedSpan(marker,
                                         curLine == from.line ? from.ch : null,
                                         curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
      ++curLine;
    });
    // lineIsHidden depends on the presence of the spans, so needs a second pass
    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
    }); }

    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

    if (marker.readOnly) {
      seeReadOnlySpans();
      if (doc.history.done.length || doc.history.undone.length)
        { doc.clearHistory(); }
    }
    if (marker.collapsed) {
      marker.id = ++nextMarkerId;
      marker.atomic = true;
    }
    if (cm) {
      // Sync editor state
      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
      if (marker.collapsed)
        { regChange(cm, from.line, to.line + 1); }
      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
               marker.attributes || marker.title)
        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
      if (marker.atomic) { reCheckSelection(cm.doc); }
      signalLater(cm, "markerAdded", cm, marker);
    }
    return marker
  }

  // SHARED TEXTMARKERS

  // A shared marker spans multiple linked documents. It is
  // implemented as a meta-marker-object controlling multiple normal
  // markers.
  var SharedTextMarker = function(markers, primary) {
    this.markers = markers;
    this.primary = primary;
    for (var i = 0; i < markers.length; ++i)
      { markers[i].parent = this; }
  };

  SharedTextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    this.explicitlyCleared = true;
    for (var i = 0; i < this.markers.length; ++i)
      { this.markers[i].clear(); }
    signalLater(this, "clear");
  };

  SharedTextMarker.prototype.find = function (side, lineObj) {
    return this.primary.find(side, lineObj)
  };
  eventMixin(SharedTextMarker);

  function markTextShared(doc, from, to, options, type) {
    options = copyObj(options);
    options.shared = false;
    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
    var widget = options.widgetNode;
    linkedDocs(doc, function (doc) {
      if (widget) { options.widgetNode = widget.cloneNode(true); }
      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
      for (var i = 0; i < doc.linked.length; ++i)
        { if (doc.linked[i].isParent) { return } }
      primary = lst(markers);
    });
    return new SharedTextMarker(markers, primary)
  }

  function findSharedMarkers(doc) {
    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
  }

  function copySharedMarkers(doc, markers) {
    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i], pos = marker.find();
      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
      if (cmp(mFrom, mTo)) {
        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
        marker.markers.push(subMark);
        subMark.parent = marker;
      }
    }
  }

  function detachSharedMarkers(markers) {
    var loop = function ( i ) {
      var marker = markers[i], linked = [marker.primary.doc];
      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
      for (var j = 0; j < marker.markers.length; j++) {
        var subMarker = marker.markers[j];
        if (indexOf(linked, subMarker.doc) == -1) {
          subMarker.parent = null;
          marker.markers.splice(j--, 1);
        }
      }
    };

    for (var i = 0; i < markers.length; i++) loop( i );
  }

  var nextDocId = 0;
  var Doc = function(text, mode, firstLine, lineSep, direction) {
    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
    if (firstLine == null) { firstLine = 0; }

    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
    this.first = firstLine;
    this.scrollTop = this.scrollLeft = 0;
    this.cantEdit = false;
    this.cleanGeneration = 1;
    this.modeFrontier = this.highlightFrontier = firstLine;
    var start = Pos(firstLine, 0);
    this.sel = simpleSelection(start);
    this.history = new History(null);
    this.id = ++nextDocId;
    this.modeOption = mode;
    this.lineSep = lineSep;
    this.direction = (direction == "rtl") ? "rtl" : "ltr";
    this.extend = false;

    if (typeof text == "string") { text = this.splitLines(text); }
    updateDoc(this, {from: start, to: start, text: text});
    setSelection(this, simpleSelection(start), sel_dontScroll);
  };

  Doc.prototype = createObj(BranchChunk.prototype, {
    constructor: Doc,
    // Iterate over the document. Supports two forms -- with only one
    // argument, it calls that for each line in the document. With
    // three, it iterates over the range given by the first two (with
    // the second being non-inclusive).
    iter: function(from, to, op) {
      if (op) { this.iterN(from - this.first, to - from, op); }
      else { this.iterN(this.first, this.first + this.size, from); }
    },

    // Non-public interface for adding and removing lines.
    insert: function(at, lines) {
      var height = 0;
      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
      this.insertInner(at - this.first, lines, height);
    },
    remove: function(at, n) { this.removeInner(at - this.first, n); },

    // From here, the methods are part of the public interface. Most
    // are also available from CodeMirror (editor) instances.

    getValue: function(lineSep) {
      var lines = getLines(this, this.first, this.first + this.size);
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },
    setValue: docMethodOp(function(code) {
      var top = Pos(this.first, 0), last = this.first + this.size - 1;
      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                        text: this.splitLines(code), origin: "setValue", full: true}, true);
      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
      setSelection(this, simpleSelection(top), sel_dontScroll);
    }),
    replaceRange: function(code, from, to, origin) {
      from = clipPos(this, from);
      to = to ? clipPos(this, to) : from;
      replaceRange(this, code, from, to, origin);
    },
    getRange: function(from, to, lineSep) {
      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
      if (lineSep === false) { return lines }
      if (lineSep === '') { return lines.join('') }
      return lines.join(lineSep || this.lineSeparator())
    },

    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
    getLineNumber: function(line) {return lineNo(line)},

    getLineHandleVisualStart: function(line) {
      if (typeof line == "number") { line = getLine(this, line); }
      return visualLine(line)
    },

    lineCount: function() {return this.size},
    firstLine: function() {return this.first},
    lastLine: function() {return this.first + this.size - 1},

    clipPos: function(pos) {return clipPos(this, pos)},

    getCursor: function(start) {
      var range = this.sel.primary(), pos;
      if (start == null || start == "head") { pos = range.head; }
      else if (start == "anchor") { pos = range.anchor; }
      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
      else { pos = range.from(); }
      return pos
    },
    listSelections: function() { return this.sel.ranges },
    somethingSelected: function() {return this.sel.somethingSelected()},

    setCursor: docMethodOp(function(line, ch, options) {
      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
    }),
    setSelection: docMethodOp(function(anchor, head, options) {
      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
    }),
    extendSelection: docMethodOp(function(head, other, options) {
      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
    }),
    extendSelections: docMethodOp(function(heads, options) {
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    extendSelectionsBy: docMethodOp(function(f, options) {
      var heads = map(this.sel.ranges, f);
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    setSelections: docMethodOp(function(ranges, primary, options) {
      if (!ranges.length) { return }
      var out = [];
      for (var i = 0; i < ranges.length; i++)
        { out[i] = new Range(clipPos(this, ranges[i].anchor),
                           clipPos(this, ranges[i].head || ranges[i].anchor)); }
      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
      setSelection(this, normalizeSelection(this.cm, out, primary), options);
    }),
    addSelection: docMethodOp(function(anchor, head, options) {
      var ranges = this.sel.ranges.slice(0);
      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
    }),

    getSelection: function(lineSep) {
      var ranges = this.sel.ranges, lines;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        lines = lines ? lines.concat(sel) : sel;
      }
      if (lineSep === false) { return lines }
      else { return lines.join(lineSep || this.lineSeparator()) }
    },
    getSelections: function(lineSep) {
      var parts = [], ranges = this.sel.ranges;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
        parts[i] = sel;
      }
      return parts
    },
    replaceSelection: function(code, collapse, origin) {
      var dup = [];
      for (var i = 0; i < this.sel.ranges.length; i++)
        { dup[i] = code; }
      this.replaceSelections(dup, collapse, origin || "+input");
    },
    replaceSelections: docMethodOp(function(code, collapse, origin) {
      var changes = [], sel = this.sel;
      for (var i = 0; i < sel.ranges.length; i++) {
        var range = sel.ranges[i];
        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
      }
      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
        { makeChange(this, changes[i$1]); }
      if (newSel) { setSelectionReplaceHistory(this, newSel); }
      else if (this.cm) { ensureCursorVisible(this.cm); }
    }),
    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

    setExtending: function(val) {this.extend = val;},
    getExtending: function() {return this.extend},

    historySize: function() {
      var hist = this.history, done = 0, undone = 0;
      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
      return {undo: done, redo: undone}
    },
    clearHistory: function() {
      var this$1 = this;

      this.history = new History(this.history);
      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
    },

    markClean: function() {
      this.cleanGeneration = this.changeGeneration(true);
    },
    changeGeneration: function(forceSplit) {
      if (forceSplit)
        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
      return this.history.generation
    },
    isClean: function (gen) {
      return this.history.generation == (gen || this.cleanGeneration)
    },

    getHistory: function() {
      return {done: copyHistoryArray(this.history.done),
              undone: copyHistoryArray(this.history.undone)}
    },
    setHistory: function(histData) {
      var hist = this.history = new History(this.history);
      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
    },

    setGutterMarker: docMethodOp(function(line, gutterID, value) {
      return changeLine(this, line, "gutter", function (line) {
        var markers = line.gutterMarkers || (line.gutterMarkers = {});
        markers[gutterID] = value;
        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
        return true
      })
    }),

    clearGutter: docMethodOp(function(gutterID) {
      var this$1 = this;

      this.iter(function (line) {
        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
          changeLine(this$1, line, "gutter", function () {
            line.gutterMarkers[gutterID] = null;
            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
            return true
          });
        }
      });
    }),

    lineInfo: function(line) {
      var n;
      if (typeof line == "number") {
        if (!isLine(this, line)) { return null }
        n = line;
        line = getLine(this, line);
        if (!line) { return null }
      } else {
        n = lineNo(line);
        if (n == null) { return null }
      }
      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
              widgets: line.widgets}
    },

    addLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        if (!line[prop]) { line[prop] = cls; }
        else if (classTest(cls).test(line[prop])) { return false }
        else { line[prop] += " " + cls; }
        return true
      })
    }),
    removeLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        var cur = line[prop];
        if (!cur) { return false }
        else if (cls == null) { line[prop] = null; }
        else {
          var found = cur.match(classTest(cls));
          if (!found) { return false }
          var end = found.index + found[0].length;
          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
        }
        return true
      })
    }),

    addLineWidget: docMethodOp(function(handle, node, options) {
      return addLineWidget(this, handle, node, options)
    }),
    removeLineWidget: function(widget) { widget.clear(); },

    markText: function(from, to, options) {
      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
    },
    setBookmark: function(pos, options) {
      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                      insertLeft: options && options.insertLeft,
                      clearWhenEmpty: false, shared: options && options.shared,
                      handleMouseEvents: options && options.handleMouseEvents};
      pos = clipPos(this, pos);
      return markText(this, pos, pos, realOpts, "bookmark")
    },
    findMarksAt: function(pos) {
      pos = clipPos(this, pos);
      var markers = [], spans = getLine(this, pos.line).markedSpans;
      if (spans) { for (var i = 0; i < spans.length; ++i) {
        var span = spans[i];
        if ((span.from == null || span.from <= pos.ch) &&
            (span.to == null || span.to >= pos.ch))
          { markers.push(span.marker.parent || span.marker); }
      } }
      return markers
    },
    findMarks: function(from, to, filter) {
      from = clipPos(this, from); to = clipPos(this, to);
      var found = [], lineNo = from.line;
      this.iter(from.line, to.line + 1, function (line) {
        var spans = line.markedSpans;
        if (spans) { for (var i = 0; i < spans.length; i++) {
          var span = spans[i];
          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
                span.from == null && lineNo != from.line ||
                span.from != null && lineNo == to.line && span.from >= to.ch) &&
              (!filter || filter(span.marker)))
            { found.push(span.marker.parent || span.marker); }
        } }
        ++lineNo;
      });
      return found
    },
    getAllMarks: function() {
      var markers = [];
      this.iter(function (line) {
        var sps = line.markedSpans;
        if (sps) { for (var i = 0; i < sps.length; ++i)
          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
      });
      return markers
    },

    posFromIndex: function(off) {
      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
      this.iter(function (line) {
        var sz = line.text.length + sepSize;
        if (sz > off) { ch = off; return true }
        off -= sz;
        ++lineNo;
      });
      return clipPos(this, Pos(lineNo, ch))
    },
    indexFromPos: function (coords) {
      coords = clipPos(this, coords);
      var index = coords.ch;
      if (coords.line < this.first || coords.ch < 0) { return 0 }
      var sepSize = this.lineSeparator().length;
      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
        index += line.text.length + sepSize;
      });
      return index
    },

    copy: function(copyHistory) {
      var doc = new Doc(getLines(this, this.first, this.first + this.size),
                        this.modeOption, this.first, this.lineSep, this.direction);
      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
      doc.sel = this.sel;
      doc.extend = false;
      if (copyHistory) {
        doc.history.undoDepth = this.history.undoDepth;
        doc.setHistory(this.getHistory());
      }
      return doc
    },

    linkedDoc: function(options) {
      if (!options) { options = {}; }
      var from = this.first, to = this.first + this.size;
      if (options.from != null && options.from > from) { from = options.from; }
      if (options.to != null && options.to < to) { to = options.to; }
      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
      if (options.sharedHist) { copy.history = this.history
      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
      copySharedMarkers(copy, findSharedMarkers(this));
      return copy
    },
    unlinkDoc: function(other) {
      if (other instanceof CodeMirror) { other = other.doc; }
      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
        var link = this.linked[i];
        if (link.doc != other) { continue }
        this.linked.splice(i, 1);
        other.unlinkDoc(this);
        detachSharedMarkers(findSharedMarkers(this));
        break
      } }
      // If the histories were shared, split them again
      if (other.history == this.history) {
        var splitIds = [other.id];
        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
        other.history = new History(null);
        other.history.done = copyHistoryArray(this.history.done, splitIds);
        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
      }
    },
    iterLinkedDocs: function(f) {linkedDocs(this, f);},

    getMode: function() {return this.mode},
    getEditor: function() {return this.cm},

    splitLines: function(str) {
      if (this.lineSep) { return str.split(this.lineSep) }
      return splitLinesAuto(str)
    },
    lineSeparator: function() { return this.lineSep || "\n" },

    setDirection: docMethodOp(function (dir) {
      if (dir != "rtl") { dir = "ltr"; }
      if (dir == this.direction) { return }
      this.direction = dir;
      this.iter(function (line) { return line.order = null; });
      if (this.cm) { directionChanged(this.cm); }
    })
  });

  // Public alias.
  Doc.prototype.eachLine = Doc.prototype.iter;

  // Kludge to work around strange IE behavior where it'll sometimes
  // re-fire a series of drag-related events right after the drop (#1551)
  var lastDrop = 0;

  function onDrop(e) {
    var cm = this;
    clearDragCursor(cm);
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
      { return }
    e_preventDefault(e);
    if (ie) { lastDrop = +new Date; }
    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
    if (!pos || cm.isReadOnly()) { return }
    // Might be a file drop, in which case we simply extract the text
    // and insert it.
    if (files && files.length && window.FileReader && window.File) {
      var n = files.length, text = Array(n), read = 0;
      var markAsReadAndPasteIfAllFilesAreRead = function () {
        if (++read == n) {
          operation(cm, function () {
            pos = clipPos(cm.doc, pos);
            var change = {from: pos, to: pos,
                          text: cm.doc.splitLines(
                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
                          origin: "paste"};
            makeChange(cm.doc, change);
            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
          })();
        }
      };
      var readTextFromFile = function (file, i) {
        if (cm.options.allowDropFileTypes &&
            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
          markAsReadAndPasteIfAllFilesAreRead();
          return
        }
        var reader = new FileReader;
        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
        reader.onload = function () {
          var content = reader.result;
          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
            markAsReadAndPasteIfAllFilesAreRead();
            return
          }
          text[i] = content;
          markAsReadAndPasteIfAllFilesAreRead();
        };
        reader.readAsText(file);
      };
      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
    } else { // Normal drop
      // Don't do a replace if the drop happened inside of the selected text.
      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
        cm.state.draggingText(e);
        // Ensure the editor is re-focused
        setTimeout(function () { return cm.display.input.focus(); }, 20);
        return
      }
      try {
        var text$1 = e.dataTransfer.getData("Text");
        if (text$1) {
          var selected;
          if (cm.state.draggingText && !cm.state.draggingText.copy)
            { selected = cm.listSelections(); }
          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
          cm.replaceSelection(text$1, "around", "paste");
          cm.display.input.focus();
        }
      }
      catch(e$1){}
    }
  }

  function onDragStart(cm, e) {
    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

    e.dataTransfer.setData("Text", cm.getSelection());
    e.dataTransfer.effectAllowed = "copyMove";

    // Use dummy image instead of default browsers image.
    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
    if (e.dataTransfer.setDragImage && !safari) {
      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      if (presto) {
        img.width = img.height = 1;
        cm.display.wrapper.appendChild(img);
        // Force a relayout, or Opera won't use our image for some obscure reason
        img._top = img.offsetTop;
      }
      e.dataTransfer.setDragImage(img, 0, 0);
      if (presto) { img.parentNode.removeChild(img); }
    }
  }

  function onDragOver(cm, e) {
    var pos = posFromMouse(cm, e);
    if (!pos) { return }
    var frag = document.createDocumentFragment();
    drawSelectionCursor(cm, pos, frag);
    if (!cm.display.dragCursor) {
      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
    }
    removeChildrenAndAdd(cm.display.dragCursor, frag);
  }

  function clearDragCursor(cm) {
    if (cm.display.dragCursor) {
      cm.display.lineSpace.removeChild(cm.display.dragCursor);
      cm.display.dragCursor = null;
    }
  }

  // These must be handled carefully, because naively registering a
  // handler for each editor will cause the editors to never be
  // garbage collected.

  function forEachCodeMirror(f) {
    if (!document.getElementsByClassName) { return }
    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
    for (var i = 0; i < byClass.length; i++) {
      var cm = byClass[i].CodeMirror;
      if (cm) { editors.push(cm); }
    }
    if (editors.length) { editors[0].operation(function () {
      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
    }); }
  }

  var globalsRegistered = false;
  function ensureGlobalHandlers() {
    if (globalsRegistered) { return }
    registerGlobalHandlers();
    globalsRegistered = true;
  }
  function registerGlobalHandlers() {
    // When the window resizes, we need to refresh active editors.
    var resizeTimer;
    on(window, "resize", function () {
      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
        resizeTimer = null;
        forEachCodeMirror(onResize);
      }, 100); }
    });
    // When the window loses focus, we want to show the editor as blurred
    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
  }
  // Called when the window resizes
  function onResize(cm) {
    var d = cm.display;
    // Might be a text scaling operation, clear size caches.
    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
    d.scrollbarsClipped = false;
    cm.setSize();
  }

  var keyNames = {
    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
  };

  // Number keys
  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
  // Alphabetic keys
  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
  // Function keys
  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

  var keyMap = {};

  keyMap.basic = {
    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
    "Esc": "singleSelection"
  };
  // Note that the save and find-related commands aren't defined by
  // default. User code or addons can define them. Unknown commands
  // are simply ignored.
  keyMap.pcDefault = {
    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
    "fallthrough": "basic"
  };
  // Very basic readline/emacs-style bindings, which are standard on Mac.
  keyMap.emacsy = {
    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
  };
  keyMap.macDefault = {
    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
    "fallthrough": ["basic", "emacsy"]
  };
  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

  // KEYMAP DISPATCH

  function normalizeKeyName(name) {
    var parts = name.split(/-(?!$)/);
    name = parts[parts.length - 1];
    var alt, ctrl, shift, cmd;
    for (var i = 0; i < parts.length - 1; i++) {
      var mod = parts[i];
      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
      else { throw new Error("Unrecognized modifier name: " + mod) }
    }
    if (alt) { name = "Alt-" + name; }
    if (ctrl) { name = "Ctrl-" + name; }
    if (cmd) { name = "Cmd-" + name; }
    if (shift) { name = "Shift-" + name; }
    return name
  }

  // This is a kludge to keep keymaps mostly working as raw objects
  // (backwards compatibility) while at the same time support features
  // like normalization and multi-stroke key bindings. It compiles a
  // new normalized keymap, and then updates the old object to reflect
  // this.
  function normalizeKeyMap(keymap) {
    var copy = {};
    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
      var value = keymap[keyname];
      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
      if (value == "...") { delete keymap[keyname]; continue }

      var keys = map(keyname.split(" "), normalizeKeyName);
      for (var i = 0; i < keys.length; i++) {
        var val = (void 0), name = (void 0);
        if (i == keys.length - 1) {
          name = keys.join(" ");
          val = value;
        } else {
          name = keys.slice(0, i + 1).join(" ");
          val = "...";
        }
        var prev = copy[name];
        if (!prev) { copy[name] = val; }
        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
      }
      delete keymap[keyname];
    } }
    for (var prop in copy) { keymap[prop] = copy[prop]; }
    return keymap
  }

  function lookupKey(key, map, handle, context) {
    map = getKeyMap(map);
    var found = map.call ? map.call(key, context) : map[key];
    if (found === false) { return "nothing" }
    if (found === "...") { return "multi" }
    if (found != null && handle(found)) { return "handled" }

    if (map.fallthrough) {
      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
        { return lookupKey(key, map.fallthrough, handle, context) }
      for (var i = 0; i < map.fallthrough.length; i++) {
        var result = lookupKey(key, map.fallthrough[i], handle, context);
        if (result) { return result }
      }
    }
  }

  // Modifier key presses don't count as 'real' key presses for the
  // purpose of keymap fallthrough.
  function isModifierKey(value) {
    var name = typeof value == "string" ? value : keyNames[value.keyCode];
    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
  }

  function addModifierNames(name, event, noShift) {
    var base = name;
    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") { name = "Cmd-" + name; }
    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
    return name
  }

  // Look up the name of a key as indicated by an event object.
  function keyName(event, noShift) {
    if (presto && event.keyCode == 34 && event["char"]) { return false }
    var name = keyNames[event.keyCode];
    if (name == null || event.altGraphKey) { return false }
    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
    if (event.keyCode == 3 && event.code) { name = event.code; }
    return addModifierNames(name, event, noShift)
  }

  function getKeyMap(val) {
    return typeof val == "string" ? keyMap[val] : val
  }

  // Helper for deleting text near the selection(s), used to implement
  // backspace, delete, and similar functionality.
  function deleteNearSelection(cm, compute) {
    var ranges = cm.doc.sel.ranges, kill = [];
    // Build up a set of ranges to kill first, merging overlapping
    // ranges.
    for (var i = 0; i < ranges.length; i++) {
      var toKill = compute(ranges[i]);
      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
        var replaced = kill.pop();
        if (cmp(replaced.from, toKill.from) < 0) {
          toKill.from = replaced.from;
          break
        }
      }
      kill.push(toKill);
    }
    // Next, remove those actual ranges.
    runInOp(cm, function () {
      for (var i = kill.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
      ensureCursorVisible(cm);
    });
  }

  function moveCharLogically(line, ch, dir) {
    var target = skipExtendingChars(line.text, ch + dir, dir);
    return target < 0 || target > line.text.length ? null : target
  }

  function moveLogically(line, start, dir) {
    var ch = moveCharLogically(line, start.ch, dir);
    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
  }

  function endOfLine(visually, cm, lineObj, lineNo, dir) {
    if (visually) {
      if (cm.doc.direction == "rtl") { dir = -dir; }
      var order = getOrder(lineObj, cm.doc.direction);
      if (order) {
        var part = dir < 0 ? lst(order) : order[0];
        var moveInStorageOrder = (dir < 0) == (part.level == 1);
        var sticky = moveInStorageOrder ? "after" : "before";
        var ch;
        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
        // it could be that the last bidi part is not on the last visual line,
        // since visual lines contain content order-consecutive chunks.
        // Thus, in rtl, we are looking for the first (content-order) character
        // in the rtl chunk that is on the last line (that is, the same line
        // as the last (content-order) character).
        if (part.level > 0 || cm.doc.direction == "rtl") {
          var prep = prepareMeasureForLine(cm, lineObj);
          ch = dir < 0 ? lineObj.text.length - 1 : 0;
          var targetTop = measureCharPrepared(cm, prep, ch).top;
          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
        } else { ch = dir < 0 ? part.to : part.from; }
        return new Pos(lineNo, ch, sticky)
      }
    }
    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
  }

  function moveVisually(cm, line, start, dir) {
    var bidi = getOrder(line, cm.doc.direction);
    if (!bidi) { return moveLogically(line, start, dir) }
    if (start.ch >= line.text.length) {
      start.ch = line.text.length;
      start.sticky = "before";
    } else if (start.ch <= 0) {
      start.ch = 0;
      start.sticky = "after";
    }
    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
      // nothing interesting happens.
      return moveLogically(line, start, dir)
    }

    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
    var prep;
    var getWrappedLineExtent = function (ch) {
      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
      prep = prep || prepareMeasureForLine(cm, line);
      return wrappedLineExtentChar(cm, line, prep, ch)
    };
    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

    if (cm.doc.direction == "rtl" || part.level == 1) {
      var moveInStorageOrder = (part.level == 1) == (dir < 0);
      var ch = mv(start, moveInStorageOrder ? 1 : -1);
      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
        var sticky = moveInStorageOrder ? "before" : "after";
        return new Pos(start.line, ch, sticky)
      }
    }

    // Case 3: Could not move within this bidi part in this visual line, so leave
    // the current bidi part

    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
        ? new Pos(start.line, mv(ch, 1), "before")
        : new Pos(start.line, ch, "after"); };

      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
        var part = bidi[partPos];
        var moveInStorageOrder = (dir > 0) == (part.level != 1);
        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
      }
    };

    // Case 3a: Look for other bidi parts on the same visual line
    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
    if (res) { return res }

    // Case 3b: Look for other bidi parts on the next visual line
    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
      if (res) { return res }
    }

    // Case 4: Nowhere to move
    return null
  }

  // Commands are parameter-less actions that can be performed on an
  // editor, mostly used for keybindings.
  var commands = {
    selectAll: selectAll,
    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
      if (range.empty()) {
        var len = getLine(cm.doc, range.head.line).text.length;
        if (range.head.ch == len && range.head.line < cm.lastLine())
          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
        else
          { return {from: range.head, to: Pos(range.head.line, len)} }
      } else {
        return {from: range.from(), to: range.to()}
      }
    }); },
    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0),
      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
    }); }); },
    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0), to: range.from()
    }); }); },
    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
      return {from: leftPos, to: range.from()}
    }); },
    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
      return {from: range.from(), to: rightPos }
    }); },
    undo: function (cm) { return cm.undo(); },
    redo: function (cm) { return cm.redo(); },
    undoSelection: function (cm) { return cm.undoSelection(); },
    redoSelection: function (cm) { return cm.redoSelection(); },
    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
      {origin: "+move", bias: 1}
    ); },
    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
      {origin: "+move", bias: 1}
    ); },
    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
      {origin: "+move", bias: -1}
    ); },
    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
    }, sel_move); },
    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: 0, top: top}, "div")
    }, sel_move); },
    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      var pos = cm.coordsChar({left: 0, top: top}, "div");
      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
      return pos
    }, sel_move); },
    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
    goLineDown: function (cm) { return cm.moveV(1, "line"); },
    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
    goPageDown: function (cm) { return cm.moveV(1, "page"); },
    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
    goCharRight: function (cm) { return cm.moveH(1, "char"); },
    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
    goWordRight: function (cm) { return cm.moveH(1, "word"); },
    delCharBefore: function (cm) { return cm.deleteH(-1, "codepoint"); },
    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
    indentAuto: function (cm) { return cm.indentSelection("smart"); },
    indentMore: function (cm) { return cm.indentSelection("add"); },
    indentLess: function (cm) { return cm.indentSelection("subtract"); },
    insertTab: function (cm) { return cm.replaceSelection("\t"); },
    insertSoftTab: function (cm) {
      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
      for (var i = 0; i < ranges.length; i++) {
        var pos = ranges[i].from();
        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
        spaces.push(spaceStr(tabSize - col % tabSize));
      }
      cm.replaceSelections(spaces);
    },
    defaultTab: function (cm) {
      if (cm.somethingSelected()) { cm.indentSelection("add"); }
      else { cm.execCommand("insertTab"); }
    },
    // Swap the two chars left and right of each selection's head.
    // Move cursor behind the two swapped characters afterwards.
    //
    // Doesn't consider line feeds a character.
    // Doesn't scan more than one line above to find a character.
    // Doesn't do anything on an empty line.
    // Doesn't do anything with non-empty selections.
    transposeChars: function (cm) { return runInOp(cm, function () {
      var ranges = cm.listSelections(), newSel = [];
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty()) { continue }
        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
        if (line) {
          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
          if (cur.ch > 0) {
            cur = new Pos(cur.line, cur.ch + 1);
            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
          } else if (cur.line > cm.doc.first) {
            var prev = getLine(cm.doc, cur.line - 1).text;
            if (prev) {
              cur = new Pos(cur.line, 1);
              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                              prev.charAt(prev.length - 1),
                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
            }
          }
        }
        newSel.push(new Range(cur, cur));
      }
      cm.setSelections(newSel);
    }); },
    newlineAndIndent: function (cm) { return runInOp(cm, function () {
      var sels = cm.listSelections();
      for (var i = sels.length - 1; i >= 0; i--)
        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
      sels = cm.listSelections();
      for (var i$1 = 0; i$1 < sels.length; i$1++)
        { cm.indentLine(sels[i$1].from().line, null, true); }
      ensureCursorVisible(cm);
    }); },
    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
  };


  function lineStart(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLine(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, visual, lineN, 1)
  }
  function lineEnd(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLineEnd(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, line, lineN, -1)
  }
  function lineStartSmart(cm, pos) {
    var start = lineStart(cm, pos.line);
    var line = getLine(cm.doc, start.line);
    var order = getOrder(line, cm.doc.direction);
    if (!order || order[0].level == 0) {
      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
    }
    return start
  }

  // Run a handler that was bound to a key.
  function doHandleBinding(cm, bound, dropShift) {
    if (typeof bound == "string") {
      bound = commands[bound];
      if (!bound) { return false }
    }
    // Ensure previous input has been read, so that the handler sees a
    // consistent view of the document
    cm.display.input.ensurePolled();
    var prevShift = cm.display.shift, done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      if (dropShift) { cm.display.shift = false; }
      done = bound(cm) != Pass;
    } finally {
      cm.display.shift = prevShift;
      cm.state.suppressEdits = false;
    }
    return done
  }

  function lookupKeyForEditor(cm, name, handle) {
    for (var i = 0; i < cm.state.keyMaps.length; i++) {
      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
      if (result) { return result }
    }
    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
      || lookupKey(name, cm.options.keyMap, handle, cm)
  }

  // Note that, despite the name, this function is also used to check
  // for bound mouse clicks.

  var stopSeq = new Delayed;

  function dispatchKey(cm, name, e, handle) {
    var seq = cm.state.keySeq;
    if (seq) {
      if (isModifierKey(name)) { return "handled" }
      if (/\'$/.test(name))
        { cm.state.keySeq = null; }
      else
        { stopSeq.set(50, function () {
          if (cm.state.keySeq == seq) {
            cm.state.keySeq = null;
            cm.display.input.reset();
          }
        }); }
      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
    }
    return dispatchKeyInner(cm, name, e, handle)
  }

  function dispatchKeyInner(cm, name, e, handle) {
    var result = lookupKeyForEditor(cm, name, handle);

    if (result == "multi")
      { cm.state.keySeq = name; }
    if (result == "handled")
      { signalLater(cm, "keyHandled", cm, name, e); }

    if (result == "handled" || result == "multi") {
      e_preventDefault(e);
      restartBlink(cm);
    }

    return !!result
  }

  // Handle a key from the keydown event.
  function handleKeyBinding(cm, e) {
    var name = keyName(e, true);
    if (!name) { return false }

    if (e.shiftKey && !cm.state.keySeq) {
      // First try to resolve full name (including 'Shift-'). Failing
      // that, see if there is a cursor-motion command (starting with
      // 'go') bound to the keyname without 'Shift-'.
      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
          || dispatchKey(cm, name, e, function (b) {
               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
                 { return doHandleBinding(cm, b) }
             })
    } else {
      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
    }
  }

  // Handle a key from the keypress event
  function handleCharBinding(cm, e, ch) {
    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
  }

  var lastStoppedKey = null;
  function onKeyDown(e) {
    var cm = this;
    if (e.target && e.target != cm.display.input.getField()) { return }
    cm.curOp.focus = activeElt(doc(cm));
    if (signalDOMEvent(cm, e)) { return }
    // IE does strange things with escape.
    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
    var code = e.keyCode;
    cm.display.shift = code == 16 || e.shiftKey;
    var handled = handleKeyBinding(cm, e);
    if (presto) {
      lastStoppedKey = handled ? code : null;
      // Opera has no cut event... we try to at least catch the key combo
      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
        { cm.replaceSelection("", null, "cut"); }
    }
    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
      { document.execCommand("cut"); }

    // Turn mouse into crosshair when Alt is held on Mac.
    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
      { showCrossHair(cm); }
  }

  function showCrossHair(cm) {
    var lineDiv = cm.display.lineDiv;
    addClass(lineDiv, "CodeMirror-crosshair");

    function up(e) {
      if (e.keyCode == 18 || !e.altKey) {
        rmClass(lineDiv, "CodeMirror-crosshair");
        off(document, "keyup", up);
        off(document, "mouseover", up);
      }
    }
    on(document, "keyup", up);
    on(document, "mouseover", up);
  }

  function onKeyUp(e) {
    if (e.keyCode == 16) { this.doc.sel.shift = false; }
    signalDOMEvent(this, e);
  }

  function onKeyPress(e) {
    var cm = this;
    if (e.target && e.target != cm.display.input.getField()) { return }
    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
    var keyCode = e.keyCode, charCode = e.charCode;
    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
    // Some browsers fire keypress events for backspace
    if (ch == "\x08") { return }
    if (handleCharBinding(cm, e, ch)) { return }
    cm.display.input.onKeyPress(e);
  }

  var DOUBLECLICK_DELAY = 400;

  var PastClick = function(time, pos, button) {
    this.time = time;
    this.pos = pos;
    this.button = button;
  };

  PastClick.prototype.compare = function (time, pos, button) {
    return this.time + DOUBLECLICK_DELAY > time &&
      cmp(pos, this.pos) == 0 && button == this.button
  };

  var lastClick, lastDoubleClick;
  function clickRepeat(pos, button) {
    var now = +new Date;
    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
      lastClick = lastDoubleClick = null;
      return "triple"
    } else if (lastClick && lastClick.compare(now, pos, button)) {
      lastDoubleClick = new PastClick(now, pos, button);
      lastClick = null;
      return "double"
    } else {
      lastClick = new PastClick(now, pos, button);
      lastDoubleClick = null;
      return "single"
    }
  }

  // A mouse down can be a single click, double click, triple click,
  // start of selection drag, start of text drag, new cursor
  // (ctrl-click), rectangle drag (alt-drag), or xwin
  // middle-click-paste. Or it might be a click on something we should
  // not interfere with, such as a scrollbar or widget.
  function onMouseDown(e) {
    var cm = this, display = cm.display;
    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
    display.input.ensurePolled();
    display.shift = e.shiftKey;

    if (eventInWidget(display, e)) {
      if (!webkit) {
        // Briefly turn off draggability, to allow widgets to do
        // normal dragging things.
        display.scroller.draggable = false;
        setTimeout(function () { return display.scroller.draggable = true; }, 100);
      }
      return
    }
    if (clickInGutter(cm, e)) { return }
    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
    win(cm).focus();

    // #3261: make sure, that we're not starting a second selection
    if (button == 1 && cm.state.selectingText)
      { cm.state.selectingText(e); }

    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

    if (button == 1) {
      if (pos) { leftButtonDown(cm, pos, repeat, e); }
      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
    } else if (button == 2) {
      if (pos) { extendSelection(cm.doc, pos); }
      setTimeout(function () { return display.input.focus(); }, 20);
    } else if (button == 3) {
      if (captureRightClick) { cm.display.input.onContextMenu(e); }
      else { delayBlurEvent(cm); }
    }
  }

  function handleMappedButton(cm, button, pos, repeat, event) {
    var name = "Click";
    if (repeat == "double") { name = "Double" + name; }
    else if (repeat == "triple") { name = "Triple" + name; }
    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
      if (typeof bound == "string") { bound = commands[bound]; }
      if (!bound) { return false }
      var done = false;
      try {
        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
        done = bound(cm, pos) != Pass;
      } finally {
        cm.state.suppressEdits = false;
      }
      return done
    })
  }

  function configureMouse(cm, repeat, event) {
    var option = cm.getOption("configureMouse");
    var value = option ? option(cm, repeat, event) : {};
    if (value.unit == null) {
      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
    }
    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
    return value
  }

  function leftButtonDown(cm, pos, repeat, event) {
    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
    else { cm.curOp.focus = activeElt(doc(cm)); }

    var behavior = configureMouse(cm, repeat, event);

    var sel = cm.doc.sel, contained;
    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
      { leftButtonStartDrag(cm, event, pos, behavior); }
    else
      { leftButtonSelect(cm, event, pos, behavior); }
  }

  // Start a text drag. When it ends, see if any dragging actually
  // happen, and treat as a click if it didn't.
  function leftButtonStartDrag(cm, event, pos, behavior) {
    var display = cm.display, moved = false;
    var dragEnd = operation(cm, function (e) {
      if (webkit) { display.scroller.draggable = false; }
      cm.state.draggingText = false;
      if (cm.state.delayingBlurEvent) {
        if (cm.hasFocus()) { cm.state.delayingBlurEvent = false; }
        else { delayBlurEvent(cm); }
      }
      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
      off(display.scroller, "dragstart", dragStart);
      off(display.scroller, "drop", dragEnd);
      if (!moved) {
        e_preventDefault(e);
        if (!behavior.addNew)
          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
        if ((webkit && !safari) || ie && ie_version == 9)
          { setTimeout(function () {display.wrapper.ownerDocument.body.focus({preventScroll: true}); display.input.focus();}, 20); }
        else
          { display.input.focus(); }
      }
    });
    var mouseMove = function(e2) {
      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
    };
    var dragStart = function () { return moved = true; };
    // Let the drag handler handle this.
    if (webkit) { display.scroller.draggable = true; }
    cm.state.draggingText = dragEnd;
    dragEnd.copy = !behavior.moveOnDrag;
    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
    on(display.scroller, "dragstart", dragStart);
    on(display.scroller, "drop", dragEnd);

    cm.state.delayingBlurEvent = true;
    setTimeout(function () { return display.input.focus(); }, 20);
    // IE's approach to draggable
    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
  }

  function rangeForUnit(cm, pos, unit) {
    if (unit == "char") { return new Range(pos, pos) }
    if (unit == "word") { return cm.findWordAt(pos) }
    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
    var result = unit(cm, pos);
    return new Range(result.from, result.to)
  }

  // Normal selection, as opposed to text dragging.
  function leftButtonSelect(cm, event, start, behavior) {
    if (ie) { delayBlurEvent(cm); }
    var display = cm.display, doc$1 = cm.doc;
    e_preventDefault(event);

    var ourRange, ourIndex, startSel = doc$1.sel, ranges = startSel.ranges;
    if (behavior.addNew && !behavior.extend) {
      ourIndex = doc$1.sel.contains(start);
      if (ourIndex > -1)
        { ourRange = ranges[ourIndex]; }
      else
        { ourRange = new Range(start, start); }
    } else {
      ourRange = doc$1.sel.primary();
      ourIndex = doc$1.sel.primIndex;
    }

    if (behavior.unit == "rectangle") {
      if (!behavior.addNew) { ourRange = new Range(start, start); }
      start = posFromMouse(cm, event, true, true);
      ourIndex = -1;
    } else {
      var range = rangeForUnit(cm, start, behavior.unit);
      if (behavior.extend)
        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
      else
        { ourRange = range; }
    }

    if (!behavior.addNew) {
      ourIndex = 0;
      setSelection(doc$1, new Selection([ourRange], 0), sel_mouse);
      startSel = doc$1.sel;
    } else if (ourIndex == -1) {
      ourIndex = ranges.length;
      setSelection(doc$1, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
                   {scroll: false, origin: "*mouse"});
    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
      setSelection(doc$1, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                   {scroll: false, origin: "*mouse"});
      startSel = doc$1.sel;
    } else {
      replaceOneSelection(doc$1, ourIndex, ourRange, sel_mouse);
    }

    var lastPos = start;
    function extendTo(pos) {
      if (cmp(lastPos, pos) == 0) { return }
      lastPos = pos;

      if (behavior.unit == "rectangle") {
        var ranges = [], tabSize = cm.options.tabSize;
        var startCol = countColumn(getLine(doc$1, start.line).text, start.ch, tabSize);
        var posCol = countColumn(getLine(doc$1, pos.line).text, pos.ch, tabSize);
        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
             line <= end; line++) {
          var text = getLine(doc$1, line).text, leftPos = findColumn(text, left, tabSize);
          if (left == right)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
          else if (text.length > leftPos)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
        }
        if (!ranges.length) { ranges.push(new Range(start, start)); }
        setSelection(doc$1, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                     {origin: "*mouse", scroll: false});
        cm.scrollIntoView(pos);
      } else {
        var oldRange = ourRange;
        var range = rangeForUnit(cm, pos, behavior.unit);
        var anchor = oldRange.anchor, head;
        if (cmp(range.anchor, anchor) > 0) {
          head = range.head;
          anchor = minPos(oldRange.from(), range.anchor);
        } else {
          head = range.anchor;
          anchor = maxPos(oldRange.to(), range.head);
        }
        var ranges$1 = startSel.ranges.slice(0);
        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc$1, anchor), head));
        setSelection(doc$1, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
      }
    }

    var editorSize = display.wrapper.getBoundingClientRect();
    // Used to ensure timeout re-tries don't fire when another extend
    // happened in the meantime (clearTimeout isn't reliable -- at
    // least on Chrome, the timeouts still happen even when cleared,
    // if the clear happens after their scheduled firing time).
    var counter = 0;

    function extend(e) {
      var curCount = ++counter;
      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
      if (!cur) { return }
      if (cmp(cur, lastPos) != 0) {
        cm.curOp.focus = activeElt(doc(cm));
        extendTo(cur);
        var visible = visibleLines(display, doc$1);
        if (cur.line >= visible.to || cur.line < visible.from)
          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
      } else {
        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
        if (outside) { setTimeout(operation(cm, function () {
          if (counter != curCount) { return }
          display.scroller.scrollTop += outside;
          extend(e);
        }), 50); }
      }
    }

    function done(e) {
      cm.state.selectingText = false;
      counter = Infinity;
      // If e is null or undefined we interpret this as someone trying
      // to explicitly cancel the selection rather than the user
      // letting go of the mouse button.
      if (e) {
        e_preventDefault(e);
        display.input.focus();
      }
      off(display.wrapper.ownerDocument, "mousemove", move);
      off(display.wrapper.ownerDocument, "mouseup", up);
      doc$1.history.lastSelOrigin = null;
    }

    var move = operation(cm, function (e) {
      if (e.buttons === 0 || !e_button(e)) { done(e); }
      else { extend(e); }
    });
    var up = operation(cm, done);
    cm.state.selectingText = up;
    on(display.wrapper.ownerDocument, "mousemove", move);
    on(display.wrapper.ownerDocument, "mouseup", up);
  }

  // Used when mouse-selecting to adjust the anchor to the proper side
  // of a bidi jump depending on the visual position of the head.
  function bidiSimplify(cm, range) {
    var anchor = range.anchor;
    var head = range.head;
    var anchorLine = getLine(cm.doc, anchor.line);
    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
    var order = getOrder(anchorLine);
    if (!order) { return range }
    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
    if (boundary == 0 || boundary == order.length) { return range }

    // Compute the relative visual position of the head compared to the
    // anchor (<0 is to the left, >0 to the right)
    var leftSide;
    if (head.line != anchor.line) {
      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
    } else {
      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
      if (headIndex == boundary - 1 || headIndex == boundary)
        { leftSide = dir < 0; }
      else
        { leftSide = dir > 0; }
    }

    var usePart = order[boundary + (leftSide ? -1 : 0)];
    var from = leftSide == (usePart.level == 1);
    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
  }


  // Determines whether an event happened in the gutter, and fires the
  // handlers for the corresponding event.
  function gutterEvent(cm, e, type, prevent) {
    var mX, mY;
    if (e.touches) {
      mX = e.touches[0].clientX;
      mY = e.touches[0].clientY;
    } else {
      try { mX = e.clientX; mY = e.clientY; }
      catch(e$1) { return false }
    }
    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
    if (prevent) { e_preventDefault(e); }

    var display = cm.display;
    var lineBox = display.lineDiv.getBoundingClientRect();

    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
    mY -= lineBox.top - display.viewOffset;

    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
      var g = display.gutters.childNodes[i];
      if (g && g.getBoundingClientRect().right >= mX) {
        var line = lineAtHeight(cm.doc, mY);
        var gutter = cm.display.gutterSpecs[i];
        signal(cm, type, cm, line, gutter.className, e);
        return e_defaultPrevented(e)
      }
    }
  }

  function clickInGutter(cm, e) {
    return gutterEvent(cm, e, "gutterClick", true)
  }

  // CONTEXT MENU HANDLING

  // To make the context menu work, we need to briefly unhide the
  // textarea (making it as unobtrusive as possible) to let the
  // right-click take effect on it.
  function onContextMenu(cm, e) {
    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
    if (signalDOMEvent(cm, e, "contextmenu")) { return }
    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
  }

  function contextMenuInGutter(cm, e) {
    if (!hasHandler(cm, "gutterContextMenu")) { return false }
    return gutterEvent(cm, e, "gutterContextMenu", false)
  }

  function themeChanged(cm) {
    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
    clearCaches(cm);
  }

  var Init = {toString: function(){return "CodeMirror.Init"}};

  var defaults = {};
  var optionHandlers = {};

  function defineOptions(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    function option(name, deflt, handle, notOnInit) {
      CodeMirror.defaults[name] = deflt;
      if (handle) { optionHandlers[name] =
        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
    }

    CodeMirror.defineOption = option;

    // Passed to option handlers when there is no old value.
    CodeMirror.Init = Init;

    // These two are, on init, called from the constructor because they
    // have to be initialized before the editor can start at all.
    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
    option("mode", null, function (cm, val) {
      cm.doc.modeOption = val;
      loadMode(cm);
    }, true);

    option("indentUnit", 2, loadMode, true);
    option("indentWithTabs", false);
    option("smartIndent", true);
    option("tabSize", 4, function (cm) {
      resetModeState(cm);
      clearCaches(cm);
      regChange(cm);
    }, true);

    option("lineSeparator", null, function (cm, val) {
      cm.doc.lineSep = val;
      if (!val) { return }
      var newBreaks = [], lineNo = cm.doc.first;
      cm.doc.iter(function (line) {
        for (var pos = 0;;) {
          var found = line.text.indexOf(val, pos);
          if (found == -1) { break }
          pos = found + val.length;
          newBreaks.push(Pos(lineNo, found));
        }
        lineNo++;
      });
      for (var i = newBreaks.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
    });
    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
      if (old != Init) { cm.refresh(); }
    });
    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
    option("electricChars", true);
    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
    }, true);
    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
    option("rtlMoveVisually", !windows);
    option("wholeLineUpdateBefore", true);

    option("theme", "default", function (cm) {
      themeChanged(cm);
      updateGutters(cm);
    }, true);
    option("keyMap", "default", function (cm, val, old) {
      var next = getKeyMap(val);
      var prev = old != Init && getKeyMap(old);
      if (prev && prev.detach) { prev.detach(cm, next); }
      if (next.attach) { next.attach(cm, prev || null); }
    });
    option("extraKeys", null);
    option("configureMouse", null);

    option("lineWrapping", false, wrappingChanged, true);
    option("gutters", [], function (cm, val) {
      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
      updateGutters(cm);
    }, true);
    option("fixedGutter", true, function (cm, val) {
      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
      cm.refresh();
    }, true);
    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
    option("scrollbarStyle", "native", function (cm) {
      initScrollbars(cm);
      updateScrollbars(cm);
      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
    }, true);
    option("lineNumbers", false, function (cm, val) {
      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
      updateGutters(cm);
    }, true);
    option("firstLineNumber", 1, updateGutters, true);
    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
    option("showCursorWhenSelecting", false, updateSelection, true);

    option("resetSelectionOnContextMenu", true);
    option("lineWiseCopyCut", true);
    option("pasteLinesPerSelection", true);
    option("selectionsMayTouch", false);

    option("readOnly", false, function (cm, val) {
      if (val == "nocursor") {
        onBlur(cm);
        cm.display.input.blur();
      }
      cm.display.input.readOnlyChanged(val);
    });

    option("screenReaderLabel", null, function (cm, val) {
      val = (val === '') ? null : val;
      cm.display.input.screenReaderLabelChanged(val);
    });

    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
    option("dragDrop", true, dragDropChanged);
    option("allowDropFileTypes", null);

    option("cursorBlinkRate", 530);
    option("cursorScrollMargin", 0);
    option("cursorHeight", 1, updateSelection, true);
    option("singleCursorHeightPerLine", true, updateSelection, true);
    option("workTime", 100);
    option("workDelay", 100);
    option("flattenSpans", true, resetModeState, true);
    option("addModeClass", false, resetModeState, true);
    option("pollInterval", 100);
    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
    option("historyEventDelay", 1250);
    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
    option("maxHighlightLength", 10000, resetModeState, true);
    option("moveInputWithCursor", true, function (cm, val) {
      if (!val) { cm.display.input.resetPosition(); }
    });

    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
    option("autofocus", null);
    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
    option("phrases", null);
  }

  function dragDropChanged(cm, value, old) {
    var wasOn = old && old != Init;
    if (!value != !wasOn) {
      var funcs = cm.display.dragFunctions;
      var toggle = value ? on : off;
      toggle(cm.display.scroller, "dragstart", funcs.start);
      toggle(cm.display.scroller, "dragenter", funcs.enter);
      toggle(cm.display.scroller, "dragover", funcs.over);
      toggle(cm.display.scroller, "dragleave", funcs.leave);
      toggle(cm.display.scroller, "drop", funcs.drop);
    }
  }

  function wrappingChanged(cm) {
    if (cm.options.lineWrapping) {
      addClass(cm.display.wrapper, "CodeMirror-wrap");
      cm.display.sizer.style.minWidth = "";
      cm.display.sizerWidth = null;
    } else {
      rmClass(cm.display.wrapper, "CodeMirror-wrap");
      findMaxLine(cm);
    }
    estimateLineHeights(cm);
    regChange(cm);
    clearCaches(cm);
    setTimeout(function () { return updateScrollbars(cm); }, 100);
  }

  // A CodeMirror instance represents an editor. This is the object
  // that user code is usually dealing with.

  function CodeMirror(place, options) {
    var this$1 = this;

    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }

    this.options = options = options ? copyObj(options) : {};
    // Determine effective options based on given values and defaults.
    copyObj(defaults, options, false);

    var doc = options.value;
    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
    else if (options.mode) { doc.modeOption = options.mode; }
    this.doc = doc;

    var input = new CodeMirror.inputStyles[options.inputStyle](this);
    var display = this.display = new Display(place, doc, input, options);
    display.wrapper.CodeMirror = this;
    themeChanged(this);
    if (options.lineWrapping)
      { this.display.wrapper.className += " CodeMirror-wrap"; }
    initScrollbars(this);

    this.state = {
      keyMaps: [],  // stores maps added by addKeyMap
      overlays: [], // highlighting overlays, as added by addOverlay
      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
      overwrite: false,
      delayingBlurEvent: false,
      focused: false,
      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
      selectingText: false,
      draggingText: false,
      highlight: new Delayed(), // stores highlight worker timeout
      keySeq: null,  // Unfinished key sequence
      specialChars: null
    };

    if (options.autofocus && !mobile) { display.input.focus(); }

    // Override magic textarea content restore that IE sometimes does
    // on our hidden textarea on reload
    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

    registerEventHandlers(this);
    ensureGlobalHandlers();

    startOperation(this);
    this.curOp.forceUpdate = true;
    attachDoc(this, doc);

    if ((options.autofocus && !mobile) || this.hasFocus())
      { setTimeout(function () {
        if (this$1.hasFocus() && !this$1.state.focused) { onFocus(this$1); }
      }, 20); }
    else
      { onBlur(this); }

    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
      { optionHandlers[opt](this, options[opt], Init); } }
    maybeUpdateLineNumberWidth(this);
    if (options.finishInit) { options.finishInit(this); }
    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
    endOperation(this);
    // Suppress optimizelegibility in Webkit, since it breaks text
    // measuring on line wrapping boundaries.
    if (webkit && options.lineWrapping &&
        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
      { display.lineDiv.style.textRendering = "auto"; }
  }

  // The default configuration options.
  CodeMirror.defaults = defaults;
  // Functions to run when options are changed.
  CodeMirror.optionHandlers = optionHandlers;

  // Attach the necessary event handlers when initializing the editor
  function registerEventHandlers(cm) {
    var d = cm.display;
    on(d.scroller, "mousedown", operation(cm, onMouseDown));
    // Older IE's will not fire a second mousedown for a double click
    if (ie && ie_version < 11)
      { on(d.scroller, "dblclick", operation(cm, function (e) {
        if (signalDOMEvent(cm, e)) { return }
        var pos = posFromMouse(cm, e);
        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
        e_preventDefault(e);
        var word = cm.findWordAt(pos);
        extendSelection(cm.doc, word.anchor, word.head);
      })); }
    else
      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
    // Some browsers fire contextmenu *after* opening the menu, at
    // which point we can't mess with it anymore. Context menu is
    // handled in onMouseDown for these browsers.
    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
    on(d.input.getField(), "contextmenu", function (e) {
      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
    });

    // Used to suppress mouse event handling when a touch happens
    var touchFinished, prevTouch = {end: 0};
    function finishTouch() {
      if (d.activeTouch) {
        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
        prevTouch = d.activeTouch;
        prevTouch.end = +new Date;
      }
    }
    function isMouseLikeTouchEvent(e) {
      if (e.touches.length != 1) { return false }
      var touch = e.touches[0];
      return touch.radiusX <= 1 && touch.radiusY <= 1
    }
    function farAway(touch, other) {
      if (other.left == null) { return true }
      var dx = other.left - touch.left, dy = other.top - touch.top;
      return dx * dx + dy * dy > 20 * 20
    }
    on(d.scroller, "touchstart", function (e) {
      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
        d.input.ensurePolled();
        clearTimeout(touchFinished);
        var now = +new Date;
        d.activeTouch = {start: now, moved: false,
                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
        if (e.touches.length == 1) {
          d.activeTouch.left = e.touches[0].pageX;
          d.activeTouch.top = e.touches[0].pageY;
        }
      }
    });
    on(d.scroller, "touchmove", function () {
      if (d.activeTouch) { d.activeTouch.moved = true; }
    });
    on(d.scroller, "touchend", function (e) {
      var touch = d.activeTouch;
      if (touch && !eventInWidget(d, e) && touch.left != null &&
          !touch.moved && new Date - touch.start < 300) {
        var pos = cm.coordsChar(d.activeTouch, "page"), range;
        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
          { range = new Range(pos, pos); }
        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
          { range = cm.findWordAt(pos); }
        else // Triple tap
          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
        cm.setSelection(range.anchor, range.head);
        cm.focus();
        e_preventDefault(e);
      }
      finishTouch();
    });
    on(d.scroller, "touchcancel", finishTouch);

    // Sync scrolling between fake scrollbars and real scrollable
    // area, ensure viewport is updated when scrolling.
    on(d.scroller, "scroll", function () {
      if (d.scroller.clientHeight) {
        updateScrollTop(cm, d.scroller.scrollTop);
        setScrollLeft(cm, d.scroller.scrollLeft, true);
        signal(cm, "scroll", cm);
      }
    });

    // Listen to wheel events in order to try and update the viewport on time.
    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

    // Prevent wrapper from ever scrolling
    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

    d.dragFunctions = {
      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
      start: function (e) { return onDragStart(cm, e); },
      drop: operation(cm, onDrop),
      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
    };

    var inp = d.input.getField();
    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
    on(inp, "keydown", operation(cm, onKeyDown));
    on(inp, "keypress", operation(cm, onKeyPress));
    on(inp, "focus", function (e) { return onFocus(cm, e); });
    on(inp, "blur", function (e) { return onBlur(cm, e); });
  }

  var initHooks = [];
  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };

  // Indent the given line. The how parameter can be "smart",
  // "add"/null, "subtract", or "prev". When aggressive is false
  // (typically set to true for forced single-line indents), empty
  // lines are not indented, and places where the mode returns Pass
  // are left alone.
  function indentLine(cm, n, how, aggressive) {
    var doc = cm.doc, state;
    if (how == null) { how = "add"; }
    if (how == "smart") {
      // Fall back to "prev" when the mode doesn't have an indentation
      // method.
      if (!doc.mode.indent) { how = "prev"; }
      else { state = getContextBefore(cm, n).state; }
    }

    var tabSize = cm.options.tabSize;
    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
    if (line.stateAfter) { line.stateAfter = null; }
    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
    if (!aggressive && !/\S/.test(line.text)) {
      indentation = 0;
      how = "not";
    } else if (how == "smart") {
      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
      if (indentation == Pass || indentation > 150) {
        if (!aggressive) { return }
        how = "prev";
      }
    }
    if (how == "prev") {
      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
      else { indentation = 0; }
    } else if (how == "add") {
      indentation = curSpace + cm.options.indentUnit;
    } else if (how == "subtract") {
      indentation = curSpace - cm.options.indentUnit;
    } else if (typeof how == "number") {
      indentation = curSpace + how;
    }
    indentation = Math.max(0, indentation);

    var indentString = "", pos = 0;
    if (cm.options.indentWithTabs)
      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
    if (pos < indentation) { indentString += spaceStr(indentation - pos); }

    if (indentString != curSpaceString) {
      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
      line.stateAfter = null;
      return true
    } else {
      // Ensure that, if the cursor was in the whitespace at the start
      // of the line, it is moved to the end of that space.
      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
        var range = doc.sel.ranges[i$1];
        if (range.head.line == n && range.head.ch < curSpaceString.length) {
          var pos$1 = Pos(n, curSpaceString.length);
          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
          break
        }
      }
    }
  }

  // This will be set to a {lineWise: bool, text: [string]} object, so
  // that, when pasting, we know what kind of selections the copied
  // text was made out of.
  var lastCopied = null;

  function setLastCopied(newLastCopied) {
    lastCopied = newLastCopied;
  }

  function applyTextInput(cm, inserted, deleted, sel, origin) {
    var doc = cm.doc;
    cm.display.shift = false;
    if (!sel) { sel = doc.sel; }

    var recent = +new Date - 200;
    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
    var textLines = splitLinesAuto(inserted), multiPaste = null;
    // When pasting N lines into N selections, insert one line per selection
    if (paste && sel.ranges.length > 1) {
      if (lastCopied && lastCopied.text.join("\n") == inserted) {
        if (sel.ranges.length % lastCopied.text.length == 0) {
          multiPaste = [];
          for (var i = 0; i < lastCopied.text.length; i++)
            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
        }
      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
        multiPaste = map(textLines, function (l) { return [l]; });
      }
    }

    var updateInput = cm.curOp.updateInput;
    // Normal behavior is to insert the new text into every selection
    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
      var range = sel.ranges[i$1];
      var from = range.from(), to = range.to();
      if (range.empty()) {
        if (deleted && deleted > 0) // Handle deletion
          { from = Pos(from.line, from.ch - deleted); }
        else if (cm.state.overwrite && !paste) // Handle overwrite
          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n"))
          { from = to = Pos(from.line, 0); }
      }
      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
      makeChange(cm.doc, changeEvent);
      signalLater(cm, "inputRead", cm, changeEvent);
    }
    if (inserted && !paste)
      { triggerElectric(cm, inserted); }

    ensureCursorVisible(cm);
    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
    cm.curOp.typing = true;
    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
  }

  function handlePaste(e, cm) {
    var pasted = e.clipboardData && e.clipboardData.getData("Text");
    if (pasted) {
      e.preventDefault();
      if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus())
        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
      return true
    }
  }

  function triggerElectric(cm, inserted) {
    // When an 'electric' character is inserted, immediately trigger a reindent
    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
    var sel = cm.doc.sel;

    for (var i = sel.ranges.length - 1; i >= 0; i--) {
      var range = sel.ranges[i];
      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
      var mode = cm.getModeAt(range.head);
      var indented = false;
      if (mode.electricChars) {
        for (var j = 0; j < mode.electricChars.length; j++)
          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
            indented = indentLine(cm, range.head.line, "smart");
            break
          } }
      } else if (mode.electricInput) {
        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
          { indented = indentLine(cm, range.head.line, "smart"); }
      }
      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
    }
  }

  function copyableRanges(cm) {
    var text = [], ranges = [];
    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
      var line = cm.doc.sel.ranges[i].head.line;
      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
      ranges.push(lineRange);
      text.push(cm.getRange(lineRange.anchor, lineRange.head));
    }
    return {text: text, ranges: ranges}
  }

  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
    field.setAttribute("autocorrect", autocorrect ? "" : "off");
    field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
    field.setAttribute("spellcheck", !!spellcheck);
  }

  function hiddenTextarea() {
    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
    // The textarea is kept positioned near the cursor to prevent the
    // fact that it'll be scrolled into view on input from scrolling
    // our fake cursor out of view. On webkit, when wrap=off, paste is
    // very slow. So make the area wide instead.
    if (webkit) { te.style.width = "1000px"; }
    else { te.setAttribute("wrap", "off"); }
    // If border: 0; -- iOS fails to open keyboard (issue #1287)
    if (ios) { te.style.border = "1px solid black"; }
    disableBrowserMagic(te);
    return div
  }

  // The publicly visible API. Note that methodOp(f) means
  // 'wrap f in an operation, performed on its `this` parameter'.

  // This is not the complete set of editor methods. Most of the
  // methods defined on the Doc type are also injected into
  // CodeMirror.prototype, for backwards compatibility and
  // convenience.

  function addEditorMethods(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    var helpers = CodeMirror.helpers = {};

    CodeMirror.prototype = {
      constructor: CodeMirror,
      focus: function(){win(this).focus(); this.display.input.focus();},

      setOption: function(option, value) {
        var options = this.options, old = options[option];
        if (options[option] == value && option != "mode") { return }
        options[option] = value;
        if (optionHandlers.hasOwnProperty(option))
          { operation(this, optionHandlers[option])(this, value, old); }
        signal(this, "optionChange", this, option);
      },

      getOption: function(option) {return this.options[option]},
      getDoc: function() {return this.doc},

      addKeyMap: function(map, bottom) {
        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
      },
      removeKeyMap: function(map) {
        var maps = this.state.keyMaps;
        for (var i = 0; i < maps.length; ++i)
          { if (maps[i] == map || maps[i].name == map) {
            maps.splice(i, 1);
            return true
          } }
      },

      addOverlay: methodOp(function(spec, options) {
        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
        insertSorted(this.state.overlays,
                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                      priority: (options && options.priority) || 0},
                     function (overlay) { return overlay.priority; });
        this.state.modeGen++;
        regChange(this);
      }),
      removeOverlay: methodOp(function(spec) {
        var overlays = this.state.overlays;
        for (var i = 0; i < overlays.length; ++i) {
          var cur = overlays[i].modeSpec;
          if (cur == spec || typeof spec == "string" && cur.name == spec) {
            overlays.splice(i, 1);
            this.state.modeGen++;
            regChange(this);
            return
          }
        }
      }),

      indentLine: methodOp(function(n, dir, aggressive) {
        if (typeof dir != "string" && typeof dir != "number") {
          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
          else { dir = dir ? "add" : "subtract"; }
        }
        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
      }),
      indentSelection: methodOp(function(how) {
        var ranges = this.doc.sel.ranges, end = -1;
        for (var i = 0; i < ranges.length; i++) {
          var range = ranges[i];
          if (!range.empty()) {
            var from = range.from(), to = range.to();
            var start = Math.max(end, from.line);
            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
            for (var j = start; j < end; ++j)
              { indentLine(this, j, how); }
            var newRanges = this.doc.sel.ranges;
            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
          } else if (range.head.line > end) {
            indentLine(this, range.head.line, how, true);
            end = range.head.line;
            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
          }
        }
      }),

      // Fetch the parser token for a given character. Useful for hacks
      // that want to inspect the mode state (say, for completion).
      getTokenAt: function(pos, precise) {
        return takeToken(this, pos, precise)
      },

      getLineTokens: function(line, precise) {
        return takeToken(this, Pos(line), precise, true)
      },

      getTokenTypeAt: function(pos) {
        pos = clipPos(this.doc, pos);
        var styles = getLineStyles(this, getLine(this.doc, pos.line));
        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
        var type;
        if (ch == 0) { type = styles[2]; }
        else { for (;;) {
          var mid = (before + after) >> 1;
          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
          else { type = styles[mid * 2 + 2]; break }
        } }
        var cut = type ? type.indexOf("overlay ") : -1;
        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
      },

      getModeAt: function(pos) {
        var mode = this.doc.mode;
        if (!mode.innerMode) { return mode }
        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
      },

      getHelper: function(pos, type) {
        return this.getHelpers(pos, type)[0]
      },

      getHelpers: function(pos, type) {
        var found = [];
        if (!helpers.hasOwnProperty(type)) { return found }
        var help = helpers[type], mode = this.getModeAt(pos);
        if (typeof mode[type] == "string") {
          if (help[mode[type]]) { found.push(help[mode[type]]); }
        } else if (mode[type]) {
          for (var i = 0; i < mode[type].length; i++) {
            var val = help[mode[type][i]];
            if (val) { found.push(val); }
          }
        } else if (mode.helperType && help[mode.helperType]) {
          found.push(help[mode.helperType]);
        } else if (help[mode.name]) {
          found.push(help[mode.name]);
        }
        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
          var cur = help._global[i$1];
          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
            { found.push(cur.val); }
        }
        return found
      },

      getStateAfter: function(line, precise) {
        var doc = this.doc;
        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
        return getContextBefore(this, line + 1, precise).state
      },

      cursorCoords: function(start, mode) {
        var pos, range = this.doc.sel.primary();
        if (start == null) { pos = range.head; }
        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
        else { pos = start ? range.from() : range.to(); }
        return cursorCoords(this, pos, mode || "page")
      },

      charCoords: function(pos, mode) {
        return charCoords(this, clipPos(this.doc, pos), mode || "page")
      },

      coordsChar: function(coords, mode) {
        coords = fromCoordSystem(this, coords, mode || "page");
        return coordsChar(this, coords.left, coords.top)
      },

      lineAtHeight: function(height, mode) {
        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
        return lineAtHeight(this.doc, height + this.display.viewOffset)
      },
      heightAtLine: function(line, mode, includeWidgets) {
        var end = false, lineObj;
        if (typeof line == "number") {
          var last = this.doc.first + this.doc.size - 1;
          if (line < this.doc.first) { line = this.doc.first; }
          else if (line > last) { line = last; end = true; }
          lineObj = getLine(this.doc, line);
        } else {
          lineObj = line;
        }
        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
          (end ? this.doc.height - heightAtLine(lineObj) : 0)
      },

      defaultTextHeight: function() { return textHeight(this.display) },
      defaultCharWidth: function() { return charWidth(this.display) },

      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

      addWidget: function(pos, node, scroll, vert, horiz) {
        var display = this.display;
        pos = cursorCoords(this, clipPos(this.doc, pos));
        var top = pos.bottom, left = pos.left;
        node.style.position = "absolute";
        node.setAttribute("cm-ignore-events", "true");
        this.display.input.setUneditable(node);
        display.sizer.appendChild(node);
        if (vert == "over") {
          top = pos.top;
        } else if (vert == "above" || vert == "near") {
          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
          // Default to positioning above (if specified and possible); otherwise default to positioning below
          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
            { top = pos.top - node.offsetHeight; }
          else if (pos.bottom + node.offsetHeight <= vspace)
            { top = pos.bottom; }
          if (left + node.offsetWidth > hspace)
            { left = hspace - node.offsetWidth; }
        }
        node.style.top = top + "px";
        node.style.left = node.style.right = "";
        if (horiz == "right") {
          left = display.sizer.clientWidth - node.offsetWidth;
          node.style.right = "0px";
        } else {
          if (horiz == "left") { left = 0; }
          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
          node.style.left = left + "px";
        }
        if (scroll)
          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
      },

      triggerOnKeyDown: methodOp(onKeyDown),
      triggerOnKeyPress: methodOp(onKeyPress),
      triggerOnKeyUp: onKeyUp,
      triggerOnMouseDown: methodOp(onMouseDown),

      execCommand: function(cmd) {
        if (commands.hasOwnProperty(cmd))
          { return commands[cmd].call(null, this) }
      },

      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

      findPosH: function(from, amount, unit, visually) {
        var dir = 1;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          cur = findPosH(this.doc, cur, dir, unit, visually);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveH: methodOp(function(dir, unit) {
        var this$1 = this;

        this.extendSelectionsBy(function (range) {
          if (this$1.display.shift || this$1.doc.extend || range.empty())
            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
          else
            { return dir < 0 ? range.from() : range.to() }
        }, sel_move);
      }),

      deleteH: methodOp(function(dir, unit) {
        var sel = this.doc.sel, doc = this.doc;
        if (sel.somethingSelected())
          { doc.replaceSelection("", null, "+delete"); }
        else
          { deleteNearSelection(this, function (range) {
            var other = findPosH(doc, range.head, dir, unit, false);
            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
          }); }
      }),

      findPosV: function(from, amount, unit, goalColumn) {
        var dir = 1, x = goalColumn;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          var coords = cursorCoords(this, cur, "div");
          if (x == null) { x = coords.left; }
          else { coords.left = x; }
          cur = findPosV(this, coords, dir, unit);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveV: methodOp(function(dir, unit) {
        var this$1 = this;

        var doc = this.doc, goals = [];
        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
        doc.extendSelectionsBy(function (range) {
          if (collapse)
            { return dir < 0 ? range.from() : range.to() }
          var headPos = cursorCoords(this$1, range.head, "div");
          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
          goals.push(headPos.left);
          var pos = findPosV(this$1, headPos, dir, unit);
          if (unit == "page" && range == doc.sel.primary())
            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
          return pos
        }, sel_move);
        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
          { doc.sel.ranges[i].goalColumn = goals[i]; } }
      }),

      // Find the word at the given position (as returned by coordsChar).
      findWordAt: function(pos) {
        var doc = this.doc, line = getLine(doc, pos.line).text;
        var start = pos.ch, end = pos.ch;
        if (line) {
          var helper = this.getHelper(pos, "wordChars");
          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
          var startChar = line.charAt(start);
          var check = isWordChar(startChar, helper)
            ? function (ch) { return isWordChar(ch, helper); }
            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
          while (start > 0 && check(line.charAt(start - 1))) { --start; }
          while (end < line.length && check(line.charAt(end))) { ++end; }
        }
        return new Range(Pos(pos.line, start), Pos(pos.line, end))
      },

      toggleOverwrite: function(value) {
        if (value != null && value == this.state.overwrite) { return }
        if (this.state.overwrite = !this.state.overwrite)
          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
        else
          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

        signal(this, "overwriteToggle", this, this.state.overwrite);
      },
      hasFocus: function() { return this.display.input.getField() == activeElt(doc(this)) },
      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
      getScrollInfo: function() {
        var scroller = this.display.scroller;
        return {left: scroller.scrollLeft, top: scroller.scrollTop,
                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
      },

      scrollIntoView: methodOp(function(range, margin) {
        if (range == null) {
          range = {from: this.doc.sel.primary().head, to: null};
          if (margin == null) { margin = this.options.cursorScrollMargin; }
        } else if (typeof range == "number") {
          range = {from: Pos(range, 0), to: null};
        } else if (range.from == null) {
          range = {from: range, to: null};
        }
        if (!range.to) { range.to = range.from; }
        range.margin = margin || 0;

        if (range.from.line != null) {
          scrollToRange(this, range);
        } else {
          scrollToCoordsRange(this, range.from, range.to, range.margin);
        }
      }),

      setSize: methodOp(function(width, height) {
        var this$1 = this;

        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
        if (width != null) { this.display.wrapper.style.width = interpret(width); }
        if (height != null) { this.display.wrapper.style.height = interpret(height); }
        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
        var lineNo = this.display.viewFrom;
        this.doc.iter(lineNo, this.display.viewTo, function (line) {
          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
          ++lineNo;
        });
        this.curOp.forceUpdate = true;
        signal(this, "refresh", this);
      }),

      operation: function(f){return runInOp(this, f)},
      startOperation: function(){return startOperation(this)},
      endOperation: function(){return endOperation(this)},

      refresh: methodOp(function() {
        var oldHeight = this.display.cachedTextHeight;
        regChange(this);
        this.curOp.forceUpdate = true;
        clearCaches(this);
        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
        updateGutterSpace(this.display);
        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping)
          { estimateLineHeights(this); }
        signal(this, "refresh", this);
      }),

      swapDoc: methodOp(function(doc) {
        var old = this.doc;
        old.cm = null;
        // Cancel the current text selection if any (#5821)
        if (this.state.selectingText) { this.state.selectingText(); }
        attachDoc(this, doc);
        clearCaches(this);
        this.display.input.reset();
        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
        this.curOp.forceScroll = true;
        signalLater(this, "swapDoc", this, old);
        return old
      }),

      phrase: function(phraseText) {
        var phrases = this.options.phrases;
        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
      },

      getInputField: function(){return this.display.input.getField()},
      getWrapperElement: function(){return this.display.wrapper},
      getScrollerElement: function(){return this.display.scroller},
      getGutterElement: function(){return this.display.gutters}
    };
    eventMixin(CodeMirror);

    CodeMirror.registerHelper = function(type, name, value) {
      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
      helpers[type][name] = value;
    };
    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
      CodeMirror.registerHelper(type, name, value);
      helpers[type]._global.push({pred: predicate, val: value});
    };
  }

  // Used for horizontal relative motion. Dir is -1 or 1 (left or
  // right), unit can be "codepoint", "char", "column" (like char, but
  // doesn't cross line boundaries), "word" (across next word), or
  // "group" (to the start of next group of word or
  // non-word-non-whitespace chars). The visually param controls
  // whether, in right-to-left text, direction 1 means to move towards
  // the next index in the string, or towards the character to the right
  // of the current position. The resulting position will have a
  // hitSide=true property if it reached the end of the document.
  function findPosH(doc, pos, dir, unit, visually) {
    var oldPos = pos;
    var origDir = dir;
    var lineObj = getLine(doc, pos.line);
    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
    function findNextLine() {
      var l = pos.line + lineDir;
      if (l < doc.first || l >= doc.first + doc.size) { return false }
      pos = new Pos(l, pos.ch, pos.sticky);
      return lineObj = getLine(doc, l)
    }
    function moveOnce(boundToLine) {
      var next;
      if (unit == "codepoint") {
        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
        if (isNaN(ch)) {
          next = null;
        } else {
          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
        }
      } else if (visually) {
        next = moveVisually(doc.cm, lineObj, pos, dir);
      } else {
        next = moveLogically(lineObj, pos, dir);
      }
      if (next == null) {
        if (!boundToLine && findNextLine())
          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
        else
          { return false }
      } else {
        pos = next;
      }
      return true
    }

    if (unit == "char" || unit == "codepoint") {
      moveOnce();
    } else if (unit == "column") {
      moveOnce(true);
    } else if (unit == "word" || unit == "group") {
      var sawType = null, group = unit == "group";
      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
      for (var first = true;; first = false) {
        if (dir < 0 && !moveOnce(!first)) { break }
        var cur = lineObj.text.charAt(pos.ch) || "\n";
        var type = isWordChar(cur, helper) ? "w"
          : group && cur == "\n" ? "n"
          : !group || /\s/.test(cur) ? null
          : "p";
        if (group && !first && !type) { type = "s"; }
        if (sawType && sawType != type) {
          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
          break
        }

        if (type) { sawType = type; }
        if (dir > 0 && !moveOnce(!first)) { break }
      }
    }
    var result = skipAtomic(doc, pos, oldPos, origDir, true);
    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
    return result
  }

  // For relative vertical movement. Dir may be -1 or 1. Unit can be
  // "page" or "line". The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosV(cm, pos, dir, unit) {
    var doc = cm.doc, x = pos.left, y;
    if (unit == "page") {
      var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc(cm).documentElement.clientHeight);
      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

    } else if (unit == "line") {
      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
    }
    var target;
    for (;;) {
      target = coordsChar(cm, x, y);
      if (!target.outside) { break }
      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
      y += dir * 5;
    }
    return target
  }

  // CONTENTEDITABLE INPUT STYLE

  var ContentEditableInput = function(cm) {
    this.cm = cm;
    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
    this.polling = new Delayed();
    this.composing = null;
    this.gracePeriod = false;
    this.readDOMTimeout = null;
  };

  ContentEditableInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = input.cm;
    var div = input.div = display.lineDiv;
    div.contentEditable = true;
    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);

    function belongsToInput(e) {
      for (var t = e.target; t; t = t.parentNode) {
        if (t == div) { return true }
        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) { break }
      }
      return false
    }

    on(div, "paste", function (e) {
      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
    });

    on(div, "compositionstart", function (e) {
      this$1.composing = {data: e.data, done: false};
    });
    on(div, "compositionupdate", function (e) {
      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
    });
    on(div, "compositionend", function (e) {
      if (this$1.composing) {
        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
        this$1.composing.done = true;
      }
    });

    on(div, "touchstart", function () { return input.forceCompositionEnd(); });

    on(div, "input", function () {
      if (!this$1.composing) { this$1.readFromDOMSoon(); }
    });

    function onCopyCut(e) {
      if (!belongsToInput(e) || signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.operation(function () {
            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
            cm.replaceSelection("", null, "cut");
          });
        }
      }
      if (e.clipboardData) {
        e.clipboardData.clearData();
        var content = lastCopied.text.join("\n");
        // iOS exposes the clipboard API, but seems to discard content inserted into it
        e.clipboardData.setData("Text", content);
        if (e.clipboardData.getData("Text") == content) {
          e.preventDefault();
          return
        }
      }
      // Old-fashioned briefly-focus-a-textarea hack
      var kludge = hiddenTextarea(), te = kludge.firstChild;
      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
      te.value = lastCopied.text.join("\n");
      var hadFocus = activeElt(div.ownerDocument);
      selectInput(te);
      setTimeout(function () {
        cm.display.lineSpace.removeChild(kludge);
        hadFocus.focus();
        if (hadFocus == div) { input.showPrimarySelection(); }
      }, 50);
    }
    on(div, "copy", onCopyCut);
    on(div, "cut", onCopyCut);
  };

  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
    // Label for screenreaders, accessibility
    if(label) {
      this.div.setAttribute('aria-label', label);
    } else {
      this.div.removeAttribute('aria-label');
    }
  };

  ContentEditableInput.prototype.prepareSelection = function () {
    var result = prepareSelection(this.cm, false);
    result.focus = activeElt(this.div.ownerDocument) == this.div;
    return result
  };

  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
    if (!info || !this.cm.display.view.length) { return }
    if (info.focus || takeFocus) { this.showPrimarySelection(); }
    this.showMultipleSelections(info);
  };

  ContentEditableInput.prototype.getSelection = function () {
    return this.cm.display.wrapper.ownerDocument.getSelection()
  };

  ContentEditableInput.prototype.showPrimarySelection = function () {
    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
    var from = prim.from(), to = prim.to();

    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
      sel.removeAllRanges();
      return
    }

    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
        cmp(minPos(curAnchor, curFocus), from) == 0 &&
        cmp(maxPos(curAnchor, curFocus), to) == 0)
      { return }

    var view = cm.display.view;
    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
        {node: view[0].measure.map[2], offset: 0};
    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
    if (!end) {
      var measure = view[view.length - 1].measure;
      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
    }

    if (!start || !end) {
      sel.removeAllRanges();
      return
    }

    var old = sel.rangeCount && sel.getRangeAt(0), rng;
    try { rng = range(start.node, start.offset, end.offset, end.node); }
    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
    if (rng) {
      if (!gecko && cm.state.focused) {
        sel.collapse(start.node, start.offset);
        if (!rng.collapsed) {
          sel.removeAllRanges();
          sel.addRange(rng);
        }
      } else {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
      if (old && sel.anchorNode == null) { sel.addRange(old); }
      else if (gecko) { this.startGracePeriod(); }
    }
    this.rememberSelection();
  };

  ContentEditableInput.prototype.startGracePeriod = function () {
      var this$1 = this;

    clearTimeout(this.gracePeriod);
    this.gracePeriod = setTimeout(function () {
      this$1.gracePeriod = false;
      if (this$1.selectionChanged())
        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
    }, 20);
  };

  ContentEditableInput.prototype.showMultipleSelections = function (info) {
    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
  };

  ContentEditableInput.prototype.rememberSelection = function () {
    var sel = this.getSelection();
    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
  };

  ContentEditableInput.prototype.selectionInEditor = function () {
    var sel = this.getSelection();
    if (!sel.rangeCount) { return false }
    var node = sel.getRangeAt(0).commonAncestorContainer;
    return contains(this.div, node)
  };

  ContentEditableInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor") {
      if (!this.selectionInEditor() || activeElt(this.div.ownerDocument) != this.div)
        { this.showSelection(this.prepareSelection(), true); }
      this.div.focus();
    }
  };
  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
  ContentEditableInput.prototype.getField = function () { return this.div };

  ContentEditableInput.prototype.supportsTouch = function () { return true };

  ContentEditableInput.prototype.receivedFocus = function () {
      var this$1 = this;

    var input = this;
    if (this.selectionInEditor())
      { setTimeout(function () { return this$1.pollSelection(); }, 20); }
    else
      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

    function poll() {
      if (input.cm.state.focused) {
        input.pollSelection();
        input.polling.set(input.cm.options.pollInterval, poll);
      }
    }
    this.polling.set(this.cm.options.pollInterval, poll);
  };

  ContentEditableInput.prototype.selectionChanged = function () {
    var sel = this.getSelection();
    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
  };

  ContentEditableInput.prototype.pollSelection = function () {
    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
    var sel = this.getSelection(), cm = this.cm;
    // On Android Chrome (version 56, at least), backspacing into an
    // uneditable block element will put the cursor in that element,
    // and then, because it's not editable, hide the virtual keyboard.
    // Because Android doesn't allow us to actually detect backspace
    // presses in a sane way, this code checks for when that happens
    // and simulates a backspace press in this case.
    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
      this.blur();
      this.focus();
      return
    }
    if (this.composing) { return }
    this.rememberSelection();
    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (anchor && head) { runInOp(cm, function () {
      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
    }); }
  };

  ContentEditableInput.prototype.pollContent = function () {
    if (this.readDOMTimeout != null) {
      clearTimeout(this.readDOMTimeout);
      this.readDOMTimeout = null;
    }

    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
    var from = sel.from(), to = sel.to();
    if (from.ch == 0 && from.line > cm.firstLine())
      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
      { to = Pos(to.line + 1, 0); }
    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

    var fromIndex, fromLine, fromNode;
    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
      fromLine = lineNo(display.view[0].line);
      fromNode = display.view[0].node;
    } else {
      fromLine = lineNo(display.view[fromIndex].line);
      fromNode = display.view[fromIndex - 1].node.nextSibling;
    }
    var toIndex = findViewIndex(cm, to.line);
    var toLine, toNode;
    if (toIndex == display.view.length - 1) {
      toLine = display.viewTo - 1;
      toNode = display.lineDiv.lastChild;
    } else {
      toLine = lineNo(display.view[toIndex + 1].line) - 1;
      toNode = display.view[toIndex + 1].node.previousSibling;
    }

    if (!fromNode) { return false }
    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
    while (newText.length > 1 && oldText.length > 1) {
      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
      else { break }
    }

    var cutFront = 0, cutEnd = 0;
    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
      { ++cutFront; }
    var newBot = lst(newText), oldBot = lst(oldText);
    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
    while (cutEnd < maxCutEnd &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
      { ++cutEnd; }
    // Try to move start of change to start of selection if ambiguous
    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
      while (cutFront && cutFront > from.ch &&
             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
        cutFront--;
        cutEnd++;
      }
    }

    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

    var chFrom = Pos(fromLine, cutFront);
    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
      return true
    }
  };

  ContentEditableInput.prototype.ensurePolled = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.reset = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.forceCompositionEnd = function () {
    if (!this.composing) { return }
    clearTimeout(this.readDOMTimeout);
    this.composing = null;
    this.updateFromDOM();
    this.div.blur();
    this.div.focus();
  };
  ContentEditableInput.prototype.readFromDOMSoon = function () {
      var this$1 = this;

    if (this.readDOMTimeout != null) { return }
    this.readDOMTimeout = setTimeout(function () {
      this$1.readDOMTimeout = null;
      if (this$1.composing) {
        if (this$1.composing.done) { this$1.composing = null; }
        else { return }
      }
      this$1.updateFromDOM();
    }, 80);
  };

  ContentEditableInput.prototype.updateFromDOM = function () {
      var this$1 = this;

    if (this.cm.isReadOnly() || !this.pollContent())
      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
  };

  ContentEditableInput.prototype.setUneditable = function (node) {
    node.contentEditable = "false";
  };

  ContentEditableInput.prototype.onKeyPress = function (e) {
    if (e.charCode == 0 || this.composing) { return }
    e.preventDefault();
    if (!this.cm.isReadOnly())
      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
  };

  ContentEditableInput.prototype.readOnlyChanged = function (val) {
    this.div.contentEditable = String(val != "nocursor");
  };

  ContentEditableInput.prototype.onContextMenu = function () {};
  ContentEditableInput.prototype.resetPosition = function () {};

  ContentEditableInput.prototype.needsContentAttribute = true;

  function posToDOM(cm, pos) {
    var view = findViewForLine(cm, pos.line);
    if (!view || view.hidden) { return null }
    var line = getLine(cm.doc, pos.line);
    var info = mapFromLineView(view, line, pos.line);

    var order = getOrder(line, cm.doc.direction), side = "left";
    if (order) {
      var partPos = getBidiPartAt(order, pos.ch);
      side = partPos % 2 ? "right" : "left";
    }
    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
    result.offset = result.collapse == "right" ? result.end : result.start;
    return result
  }

  function isInGutter(node) {
    for (var scan = node; scan; scan = scan.parentNode)
      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
    return false
  }

  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

  function domTextBetween(cm, from, to, fromLine, toLine) {
    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
    function close() {
      if (closing) {
        text += lineSep;
        if (extraLinebreak) { text += lineSep; }
        closing = extraLinebreak = false;
      }
    }
    function addText(str) {
      if (str) {
        close();
        text += str;
      }
    }
    function walk(node) {
      if (node.nodeType == 1) {
        var cmText = node.getAttribute("cm-text");
        if (cmText) {
          addText(cmText);
          return
        }
        var markerID = node.getAttribute("cm-marker"), range;
        if (markerID) {
          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
          if (found.length && (range = found[0].find(0)))
            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
          return
        }
        if (node.getAttribute("contenteditable") == "false") { return }
        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }

        if (isBlock) { close(); }
        for (var i = 0; i < node.childNodes.length; i++)
          { walk(node.childNodes[i]); }

        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
        if (isBlock) { closing = true; }
      } else if (node.nodeType == 3) {
        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
      }
    }
    for (;;) {
      walk(from);
      if (from == to) { break }
      from = from.nextSibling;
      extraLinebreak = false;
    }
    return text
  }

  function domToPos(cm, node, offset) {
    var lineNode;
    if (node == cm.display.lineDiv) {
      lineNode = cm.display.lineDiv.childNodes[offset];
      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
      node = null; offset = 0;
    } else {
      for (lineNode = node;; lineNode = lineNode.parentNode) {
        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
      }
    }
    for (var i = 0; i < cm.display.view.length; i++) {
      var lineView = cm.display.view[i];
      if (lineView.node == lineNode)
        { return locateNodeInLineView(lineView, node, offset) }
    }
  }

  function locateNodeInLineView(lineView, node, offset) {
    var wrapper = lineView.text.firstChild, bad = false;
    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
    if (node == wrapper) {
      bad = true;
      node = wrapper.childNodes[offset];
      offset = 0;
      if (!node) {
        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
        return badPos(Pos(lineNo(line), line.text.length), bad)
      }
    }

    var textNode = node.nodeType == 3 ? node : null, topNode = node;
    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
      textNode = node.firstChild;
      if (offset) { offset = textNode.nodeValue.length; }
    }
    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
    var measure = lineView.measure, maps = measure.maps;

    function find(textNode, topNode, offset) {
      for (var i = -1; i < (maps ? maps.length : 0); i++) {
        var map = i < 0 ? measure.map : maps[i];
        for (var j = 0; j < map.length; j += 3) {
          var curNode = map[j + 2];
          if (curNode == textNode || curNode == topNode) {
            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
            var ch = map[j] + offset;
            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
            return Pos(line, ch)
          }
        }
      }
    }
    var found = find(textNode, topNode, offset);
    if (found) { return badPos(found, bad) }

    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
      found = find(after, after.firstChild, 0);
      if (found)
        { return badPos(Pos(found.line, found.ch - dist), bad) }
      else
        { dist += after.textContent.length; }
    }
    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
      found = find(before, before.firstChild, -1);
      if (found)
        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
      else
        { dist$1 += before.textContent.length; }
    }
  }

  // TEXTAREA INPUT STYLE

  var TextareaInput = function(cm) {
    this.cm = cm;
    // See input.poll and input.reset
    this.prevInput = "";

    // Flag that indicates whether we expect input to appear real soon
    // now (after some event like 'keypress' or 'input') and are
    // polling intensively.
    this.pollingFast = false;
    // Self-resetting timeout for the poller
    this.polling = new Delayed();
    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
    this.hasSelection = false;
    this.composing = null;
  };

  TextareaInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = this.cm;
    this.createField(display);
    var te = this.textarea;

    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
    if (ios) { te.style.width = "0px"; }

    on(te, "input", function () {
      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
      input.poll();
    });

    on(te, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

      cm.state.pasteIncoming = +new Date;
      input.fastPoll();
    });

    function prepareCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.setSelections(ranges.ranges, null, sel_dontScroll);
        } else {
          input.prevInput = "";
          te.value = ranges.text.join("\n");
          selectInput(te);
        }
      }
      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
    }
    on(te, "cut", prepareCopyCut);
    on(te, "copy", prepareCopyCut);

    on(display.scroller, "paste", function (e) {
      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
      if (!te.dispatchEvent) {
        cm.state.pasteIncoming = +new Date;
        input.focus();
        return
      }

      // Pass the `paste` event to the textarea so it's handled by its event listener.
      var event = new Event("paste");
      event.clipboardData = e.clipboardData;
      te.dispatchEvent(event);
    });

    // Prevent normal selection in the editor (we handle our own)
    on(display.lineSpace, "selectstart", function (e) {
      if (!eventInWidget(display, e)) { e_preventDefault(e); }
    });

    on(te, "compositionstart", function () {
      var start = cm.getCursor("from");
      if (input.composing) { input.composing.range.clear(); }
      input.composing = {
        start: start,
        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
      };
    });
    on(te, "compositionend", function () {
      if (input.composing) {
        input.poll();
        input.composing.range.clear();
        input.composing = null;
      }
    });
  };

  TextareaInput.prototype.createField = function (_display) {
    // Wraps and hides input textarea
    this.wrapper = hiddenTextarea();
    // The semihidden textarea that is focused when the editor is
    // focused, and receives input.
    this.textarea = this.wrapper.firstChild;
  };

  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
    // Label for screenreaders, accessibility
    if(label) {
      this.textarea.setAttribute('aria-label', label);
    } else {
      this.textarea.removeAttribute('aria-label');
    }
  };

  TextareaInput.prototype.prepareSelection = function () {
    // Redraw the selection and/or cursor
    var cm = this.cm, display = cm.display, doc = cm.doc;
    var result = prepareSelection(cm);

    // Move the hidden textarea near the cursor to prevent scrolling artifacts
    if (cm.options.moveInputWithCursor) {
      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                          headPos.top + lineOff.top - wrapOff.top));
      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                           headPos.left + lineOff.left - wrapOff.left));
    }

    return result
  };

  TextareaInput.prototype.showSelection = function (drawn) {
    var cm = this.cm, display = cm.display;
    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
    if (drawn.teTop != null) {
      this.wrapper.style.top = drawn.teTop + "px";
      this.wrapper.style.left = drawn.teLeft + "px";
    }
  };

  // Reset the input to correspond to the selection (or to be empty,
  // when not typing and nothing is selected)
  TextareaInput.prototype.reset = function (typing) {
    if (this.contextMenuPending || this.composing) { return }
    var cm = this.cm;
    if (cm.somethingSelected()) {
      this.prevInput = "";
      var content = cm.getSelection();
      this.textarea.value = content;
      if (cm.state.focused) { selectInput(this.textarea); }
      if (ie && ie_version >= 9) { this.hasSelection = content; }
    } else if (!typing) {
      this.prevInput = this.textarea.value = "";
      if (ie && ie_version >= 9) { this.hasSelection = null; }
    }
  };

  TextareaInput.prototype.getField = function () { return this.textarea };

  TextareaInput.prototype.supportsTouch = function () { return false };

  TextareaInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(this.textarea.ownerDocument) != this.textarea)) {
      try { this.textarea.focus(); }
      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    }
  };

  TextareaInput.prototype.blur = function () { this.textarea.blur(); };

  TextareaInput.prototype.resetPosition = function () {
    this.wrapper.style.top = this.wrapper.style.left = 0;
  };

  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

  // Poll for input changes, using the normal rate of polling. This
  // runs as long as the editor is focused.
  TextareaInput.prototype.slowPoll = function () {
      var this$1 = this;

    if (this.pollingFast) { return }
    this.polling.set(this.cm.options.pollInterval, function () {
      this$1.poll();
      if (this$1.cm.state.focused) { this$1.slowPoll(); }
    });
  };

  // When an event has just come in that is likely to add or change
  // something in the input textarea, we poll faster, to ensure that
  // the change appears on the screen quickly.
  TextareaInput.prototype.fastPoll = function () {
    var missed = false, input = this;
    input.pollingFast = true;
    function p() {
      var changed = input.poll();
      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
      else {input.pollingFast = false; input.slowPoll();}
    }
    input.polling.set(20, p);
  };

  // Read input from the textarea, and update the document to match.
  // When something is selected, it is present in the textarea, and
  // selected (unless it is huge, in which case a placeholder is
  // used). When nothing is selected, the cursor sits after previously
  // seen text (can be empty), which is stored in prevInput (we must
  // not reset the textarea when typing, because that breaks IME).
  TextareaInput.prototype.poll = function () {
      var this$1 = this;

    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
    // Since this is called a *lot*, try to bail out as cheaply as
    // possible when it is clear that nothing happened. hasSelection
    // will be the case when there is a lot of text in the textarea,
    // in which case reading its value would be expensive.
    if (this.contextMenuPending || !cm.state.focused ||
        (hasSelection(input) && !prevInput && !this.composing) ||
        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
      { return false }

    var text = input.value;
    // If nothing changed, bail.
    if (text == prevInput && !cm.somethingSelected()) { return false }
    // Work around nonsensical selection resetting in IE9/10, and
    // inexplicable appearance of private area unicode characters on
    // some key combos in Mac (#2689).
    if (ie && ie_version >= 9 && this.hasSelection === text ||
        mac && /[\uf700-\uf7ff]/.test(text)) {
      cm.display.input.reset();
      return false
    }

    if (cm.doc.sel == cm.display.selForContextMenu) {
      var first = text.charCodeAt(0);
      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
    }
    // Find the part of the input that is actually new
    var same = 0, l = Math.min(prevInput.length, text.length);
    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

    runInOp(cm, function () {
      applyTextInput(cm, text.slice(same), prevInput.length - same,
                     null, this$1.composing ? "*compose" : null);

      // Don't leave long text in the textarea, since it makes further polling slow
      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
      else { this$1.prevInput = text; }

      if (this$1.composing) {
        this$1.composing.range.clear();
        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                           {className: "CodeMirror-composing"});
      }
    });
    return true
  };

  TextareaInput.prototype.ensurePolled = function () {
    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
  };

  TextareaInput.prototype.onKeyPress = function () {
    if (ie && ie_version >= 9) { this.hasSelection = null; }
    this.fastPoll();
  };

  TextareaInput.prototype.onContextMenu = function (e) {
    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
    if (input.contextMenuPending) { input.contextMenuPending(); }
    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
    if (!pos || presto) { return } // Opera is difficult.

    // Reset the current text selection only if the click is done outside of the selection
    // and 'resetSelectionOnContextMenu' option is true.
    var reset = cm.options.resetSelectionOnContextMenu;
    if (reset && cm.doc.sel.contains(pos) == -1)
      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
    input.wrapper.style.cssText = "position: static";
    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
    var oldScrollY;
    if (webkit) { oldScrollY = te.ownerDocument.defaultView.scrollY; } // Work around Chrome issue (#2712)
    display.input.focus();
    if (webkit) { te.ownerDocument.defaultView.scrollTo(null, oldScrollY); }
    display.input.reset();
    // Adds "Select all" to context menu in FF
    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
    input.contextMenuPending = rehide;
    display.selForContextMenu = cm.doc.sel;
    clearTimeout(display.detectingSelectAll);

    // Select-all will be greyed out if there's nothing to select, so
    // this adds a zero-width space so that we can later check whether
    // it got selected.
    function prepareSelectAllHack() {
      if (te.selectionStart != null) {
        var selected = cm.somethingSelected();
        var extval = "\u200b" + (selected ? te.value : "");
        te.value = "\u21da"; // Used to catch context-menu undo
        te.value = extval;
        input.prevInput = selected ? "" : "\u200b";
        te.selectionStart = 1; te.selectionEnd = extval.length;
        // Re-set this, in case some other handler touched the
        // selection in the meantime.
        display.selForContextMenu = cm.doc.sel;
      }
    }
    function rehide() {
      if (input.contextMenuPending != rehide) { return }
      input.contextMenuPending = false;
      input.wrapper.style.cssText = oldWrapperCSS;
      te.style.cssText = oldCSS;
      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

      // Try to detect the user choosing select-all
      if (te.selectionStart != null) {
        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
        var i = 0, poll = function () {
          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
              te.selectionEnd > 0 && input.prevInput == "\u200b") {
            operation(cm, selectAll)(cm);
          } else if (i++ < 10) {
            display.detectingSelectAll = setTimeout(poll, 500);
          } else {
            display.selForContextMenu = null;
            display.input.reset();
          }
        };
        display.detectingSelectAll = setTimeout(poll, 200);
      }
    }

    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
    if (captureRightClick) {
      e_stop(e);
      var mouseup = function () {
        off(window, "mouseup", mouseup);
        setTimeout(rehide, 20);
      };
      on(window, "mouseup", mouseup);
    } else {
      setTimeout(rehide, 50);
    }
  };

  TextareaInput.prototype.readOnlyChanged = function (val) {
    if (!val) { this.reset(); }
    this.textarea.disabled = val == "nocursor";
    this.textarea.readOnly = !!val;
  };

  TextareaInput.prototype.setUneditable = function () {};

  TextareaInput.prototype.needsContentAttribute = false;

  function fromTextArea(textarea, options) {
    options = options ? copyObj(options) : {};
    options.value = textarea.value;
    if (!options.tabindex && textarea.tabIndex)
      { options.tabindex = textarea.tabIndex; }
    if (!options.placeholder && textarea.placeholder)
      { options.placeholder = textarea.placeholder; }
    // Set autofocus to true if this textarea is focused, or if it has
    // autofocus and no other element is focused.
    if (options.autofocus == null) {
      var hasFocus = activeElt(textarea.ownerDocument);
      options.autofocus = hasFocus == textarea ||
        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
    }

    function save() {textarea.value = cm.getValue();}

    var realSubmit;
    if (textarea.form) {
      on(textarea.form, "submit", save);
      // Deplorable hack to make the submit method do the right thing.
      if (!options.leaveSubmitMethodAlone) {
        var form = textarea.form;
        realSubmit = form.submit;
        try {
          var wrappedSubmit = form.submit = function () {
            save();
            form.submit = realSubmit;
            form.submit();
            form.submit = wrappedSubmit;
          };
        } catch(e) {}
      }
    }

    options.finishInit = function (cm) {
      cm.save = save;
      cm.getTextArea = function () { return textarea; };
      cm.toTextArea = function () {
        cm.toTextArea = isNaN; // Prevent this from being ran twice
        save();
        textarea.parentNode.removeChild(cm.getWrapperElement());
        textarea.style.display = "";
        if (textarea.form) {
          off(textarea.form, "submit", save);
          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
            { textarea.form.submit = realSubmit; }
        }
      };
    };

    textarea.style.display = "none";
    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
      options);
    return cm
  }

  function addLegacyProps(CodeMirror) {
    CodeMirror.off = off;
    CodeMirror.on = on;
    CodeMirror.wheelEventPixels = wheelEventPixels;
    CodeMirror.Doc = Doc;
    CodeMirror.splitLines = splitLinesAuto;
    CodeMirror.countColumn = countColumn;
    CodeMirror.findColumn = findColumn;
    CodeMirror.isWordChar = isWordCharBasic;
    CodeMirror.Pass = Pass;
    CodeMirror.signal = signal;
    CodeMirror.Line = Line;
    CodeMirror.changeEnd = changeEnd;
    CodeMirror.scrollbarModel = scrollbarModel;
    CodeMirror.Pos = Pos;
    CodeMirror.cmpPos = cmp;
    CodeMirror.modes = modes;
    CodeMirror.mimeModes = mimeModes;
    CodeMirror.resolveMode = resolveMode;
    CodeMirror.getMode = getMode;
    CodeMirror.modeExtensions = modeExtensions;
    CodeMirror.extendMode = extendMode;
    CodeMirror.copyState = copyState;
    CodeMirror.startState = startState;
    CodeMirror.innerMode = innerMode;
    CodeMirror.commands = commands;
    CodeMirror.keyMap = keyMap;
    CodeMirror.keyName = keyName;
    CodeMirror.isModifierKey = isModifierKey;
    CodeMirror.lookupKey = lookupKey;
    CodeMirror.normalizeKeyMap = normalizeKeyMap;
    CodeMirror.StringStream = StringStream;
    CodeMirror.SharedTextMarker = SharedTextMarker;
    CodeMirror.TextMarker = TextMarker;
    CodeMirror.LineWidget = LineWidget;
    CodeMirror.e_preventDefault = e_preventDefault;
    CodeMirror.e_stopPropagation = e_stopPropagation;
    CodeMirror.e_stop = e_stop;
    CodeMirror.addClass = addClass;
    CodeMirror.contains = contains;
    CodeMirror.rmClass = rmClass;
    CodeMirror.keyNames = keyNames;
  }

  // EDITOR CONSTRUCTOR

  defineOptions(CodeMirror);

  addEditorMethods(CodeMirror);

  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
    { CodeMirror.prototype[prop] = (function(method) {
      return function() {return method.apply(this.doc, arguments)}
    })(Doc.prototype[prop]); } }

  eventMixin(Doc);
  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  CodeMirror.defineMode = function(name/*, mode, …*/) {
    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
    defineMode.apply(this, arguments);
  };

  CodeMirror.defineMIME = defineMIME;

  // Minimal default mode.
  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
  CodeMirror.defineMIME("text/plain", "null");

  // EXTENSIONS

  CodeMirror.defineExtension = function (name, func) {
    CodeMirror.prototype[name] = func;
  };
  CodeMirror.defineDocExtension = function (name, func) {
    Doc.prototype[name] = func;
  };

  CodeMirror.fromTextArea = fromTextArea;

  addLegacyProps(CodeMirror);

  CodeMirror.version = "5.65.7";

  return CodeMirror;

})));

},{}],"/usr/var/server.base/node_modules/codemirror/mode/javascript/javascript.js":[function(require,module,exports){
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE

(function(mod) {
  if (typeof exports == "object" && typeof module == "object") // CommonJS
    mod(require("../../lib/codemirror"));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode("javascript", function(config, parserConfig) {
  var indentUnit = config.indentUnit;
  var statementIndent = parserConfig.statementIndent;
  var jsonldMode = parserConfig.jsonld;
  var jsonMode = parserConfig.json || jsonldMode;
  var trackScope = parserConfig.trackScope !== false
  var isTS = parserConfig.typescript;
  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;

  // Tokenizer

  var keywords = function(){
    function kw(type) {return {type: type, style: "keyword"};}
    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
    var operator = kw("operator"), atom = {type: "atom", style: "atom"};

    return {
      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
      "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
      "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
      "function": kw("function"), "catch": kw("catch"),
      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
      "in": operator, "typeof": operator, "instanceof": operator,
      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
      "await": C
    };
  }();

  var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;

  function readRegexp(stream) {
    var escaped = false, next, inSet = false;
    while ((next = stream.next()) != null) {
      if (!escaped) {
        if (next == "/" && !inSet) return;
        if (next == "[") inSet = true;
        else if (inSet && next == "]") inSet = false;
      }
      escaped = !escaped && next == "\\";
    }
  }

  // Used as scratch variables to communicate multiple values without
  // consing up tons of objects.
  var type, content;
  function ret(tp, style, cont) {
    type = tp; content = cont;
    return style;
  }
  function tokenBase(stream, state) {
    var ch = stream.next();
    if (ch == '"' || ch == "'") {
      state.tokenize = tokenString(ch);
      return state.tokenize(stream, state);
    } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
      return ret("number", "number");
    } else if (ch == "." && stream.match("..")) {
      return ret("spread", "meta");
    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
      return ret(ch);
    } else if (ch == "=" && stream.eat(">")) {
      return ret("=>", "operator");
    } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
      return ret("number", "number");
    } else if (/\d/.test(ch)) {
      stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
      return ret("number", "number");
    } else if (ch == "/") {
      if (stream.eat("*")) {
        state.tokenize = tokenComment;
        return tokenComment(stream, state);
      } else if (stream.eat("/")) {
        stream.skipToEnd();
        return ret("comment", "comment");
      } else if (expressionAllowed(stream, state, 1)) {
        readRegexp(stream);
        stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
        return ret("regexp", "string-2");
      } else {
        stream.eat("=");
        return ret("operator", "operator", stream.current());
      }
    } else if (ch == "`") {
      state.tokenize = tokenQuasi;
      return tokenQuasi(stream, state);
    } else if (ch == "#" && stream.peek() == "!") {
      stream.skipToEnd();
      return ret("meta", "meta");
    } else if (ch == "#" && stream.eatWhile(wordRE)) {
      return ret("variable", "property")
    } else if (ch == "<" && stream.match("!--") ||
               (ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start)))) {
      stream.skipToEnd()
      return ret("comment", "comment")
    } else if (isOperatorChar.test(ch)) {
      if (ch != ">" || !state.lexical || state.lexical.type != ">") {
        if (stream.eat("=")) {
          if (ch == "!" || ch == "=") stream.eat("=")
        } else if (/[<>*+\-|&?]/.test(ch)) {
          stream.eat(ch)
          if (ch == ">") stream.eat(ch)
        }
      }
      if (ch == "?" && stream.eat(".")) return ret(".")
      return ret("operator", "operator", stream.current());
    } else if (wordRE.test(ch)) {
      stream.eatWhile(wordRE);
      var word = stream.current()
      if (state.lastType != ".") {
        if (keywords.propertyIsEnumerable(word)) {
          var kw = keywords[word]
          return ret(kw.type, kw.style, word)
        }
        if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false))
          return ret("async", "keyword", word)
      }
      return ret("variable", "variable", word)
    }
  }

  function tokenString(quote) {
    return function(stream, state) {
      var escaped = false, next;
      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
        state.tokenize = tokenBase;
        return ret("jsonld-keyword", "meta");
      }
      while ((next = stream.next()) != null) {
        if (next == quote && !escaped) break;
        escaped = !escaped && next == "\\";
      }
      if (!escaped) state.tokenize = tokenBase;
      return ret("string", "string");
    };
  }

  function tokenComment(stream, state) {
    var maybeEnd = false, ch;
    while (ch = stream.next()) {
      if (ch == "/" && maybeEnd) {
        state.tokenize = tokenBase;
        break;
      }
      maybeEnd = (ch == "*");
    }
    return ret("comment", "comment");
  }

  function tokenQuasi(stream, state) {
    var escaped = false, next;
    while ((next = stream.next()) != null) {
      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
        state.tokenize = tokenBase;
        break;
      }
      escaped = !escaped && next == "\\";
    }
    return ret("quasi", "string-2", stream.current());
  }

  var brackets = "([{}])";
  // This is a crude lookahead trick to try and notice that we're
  // parsing the argument patterns for a fat-arrow function before we
  // actually hit the arrow token. It only works if the arrow is on
  // the same line as the arguments and there's no strange noise
  // (comments) in between. Fallback is to only notice when we hit the
  // arrow, and not declare the arguments as locals for the arrow
  // body.
  function findFatArrow(stream, state) {
    if (state.fatArrowAt) state.fatArrowAt = null;
    var arrow = stream.string.indexOf("=>", stream.start);
    if (arrow < 0) return;

    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
      if (m) arrow = m.index
    }

    var depth = 0, sawSomething = false;
    for (var pos = arrow - 1; pos >= 0; --pos) {
      var ch = stream.string.charAt(pos);
      var bracket = brackets.indexOf(ch);
      if (bracket >= 0 && bracket < 3) {
        if (!depth) { ++pos; break; }
        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
      } else if (bracket >= 3 && bracket < 6) {
        ++depth;
      } else if (wordRE.test(ch)) {
        sawSomething = true;
      } else if (/["'\/`]/.test(ch)) {
        for (;; --pos) {
          if (pos == 0) return
          var next = stream.string.charAt(pos - 1)
          if (next == ch && stream.string.charAt(pos - 2) != "\\") { pos--; break }
        }
      } else if (sawSomething && !depth) {
        ++pos;
        break;
      }
    }
    if (sawSomething && !depth) state.fatArrowAt = pos;
  }

  // Parser

  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true,
                     "regexp": true, "this": true, "import": true, "jsonld-keyword": true};

  function JSLexical(indented, column, type, align, prev, info) {
    this.indented = indented;
    this.column = column;
    this.type = type;
    this.prev = prev;
    this.info = info;
    if (align != null) this.align = align;
  }

  function inScope(state, varname) {
    if (!trackScope) return false
    for (var v = state.localVars; v; v = v.next)
      if (v.name == varname) return true;
    for (var cx = state.context; cx; cx = cx.prev) {
      for (var v = cx.vars; v; v = v.next)
        if (v.name == varname) return true;
    }
  }

  function parseJS(state, style, type, content, stream) {
    var cc = state.cc;
    // Communicate our context to the combinators.
    // (Less wasteful than consing up a hundred closures on every call.)
    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;

    if (!state.lexical.hasOwnProperty("align"))
      state.lexical.align = true;

    while(true) {
      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
      if (combinator(type, content)) {
        while(cc.length && cc[cc.length - 1].lex)
          cc.pop()();
        if (cx.marked) return cx.marked;
        if (type == "variable" && inScope(state, content)) return "variable-2";
        return style;
      }
    }
  }

  // Combinator utils

  var cx = {state: null, column: null, marked: null, cc: null};
  function pass() {
    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
  }
  function cont() {
    pass.apply(null, arguments);
    return true;
  }
  function inList(name, list) {
    for (var v = list; v; v = v.next) if (v.name == name) return true
    return false;
  }
  function register(varname) {
    var state = cx.state;
    cx.marked = "def";
    if (!trackScope) return
    if (state.context) {
      if (state.lexical.info == "var" && state.context && state.context.block) {
        // FIXME function decls are also not block scoped
        var newContext = registerVarScoped(varname, state.context)
        if (newContext != null) {
          state.context = newContext
          return
        }
      } else if (!inList(varname, state.localVars)) {
        state.localVars = new Var(varname, state.localVars)
        return
      }
    }
    // Fall through means this is global
    if (parserConfig.globalVars && !inList(varname, state.globalVars))
      state.globalVars = new Var(varname, state.globalVars)
  }
  function registerVarScoped(varname, context) {
    if (!context) {
      return null
    } else if (context.block) {
      var inner = registerVarScoped(varname, context.prev)
      if (!inner) return null
      if (inner == context.prev) return context
      return new Context(inner, context.vars, true)
    } else if (inList(varname, context.vars)) {
      return context
    } else {
      return new Context(context.prev, new Var(varname, context.vars), false)
    }
  }

  function isModifier(name) {
    return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly"
  }

  // Combinators

  function Context(prev, vars, block) { this.prev = prev; this.vars = vars; this.block = block }
  function Var(name, next) { this.name = name; this.next = next }

  var defaultVars = new Var("this", new Var("arguments", null))
  function pushcontext() {
    cx.state.context = new Context(cx.state.context, cx.state.localVars, false)
    cx.state.localVars = defaultVars
  }
  function pushblockcontext() {
    cx.state.context = new Context(cx.state.context, cx.state.localVars, true)
    cx.state.localVars = null
  }
  pushcontext.lex = pushblockcontext.lex = true
  function popcontext() {
    cx.state.localVars = cx.state.context.vars
    cx.state.context = cx.state.context.prev
  }
  popcontext.lex = true
  function pushlex(type, info) {
    var result = function() {
      var state = cx.state, indent = state.indented;
      if (state.lexical.type == "stat") indent = state.lexical.indented;
      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
        indent = outer.indented;
      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
    };
    result.lex = true;
    return result;
  }
  function poplex() {
    var state = cx.state;
    if (state.lexical.prev) {
      if (state.lexical.type == ")")
        state.indented = state.lexical.indented;
      state.lexical = state.lexical.prev;
    }
  }
  poplex.lex = true;

  function expect(wanted) {
    function exp(type) {
      if (type == wanted) return cont();
      else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
      else return cont(exp);
    };
    return exp;
  }

  function statement(type, value) {
    if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
    if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
    if (type == "debugger") return cont(expect(";"));
    if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
    if (type == ";") return cont();
    if (type == "if") {
      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
        cx.state.cc.pop()();
      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
    }
    if (type == "function") return cont(functiondef);
    if (type == "for") return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
    if (type == "class" || (isTS && value == "interface")) {
      cx.marked = "keyword"
      return cont(pushlex("form", type == "class" ? type : value), className, poplex)
    }
    if (type == "variable") {
      if (isTS && value == "declare") {
        cx.marked = "keyword"
        return cont(statement)
      } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
        cx.marked = "keyword"
        if (value == "enum") return cont(enumdef);
        else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
        else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
      } else if (isTS && value == "namespace") {
        cx.marked = "keyword"
        return cont(pushlex("form"), expression, statement, poplex)
      } else if (isTS && value == "abstract") {
        cx.marked = "keyword"
        return cont(statement)
      } else {
        return cont(pushlex("stat"), maybelabel);
      }
    }
    if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext,
                                      block, poplex, poplex, popcontext);
    if (type == "case") return cont(expression, expect(":"));
    if (type == "default") return cont(expect(":"));
    if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
    if (type == "async") return cont(statement)
    if (value == "@") return cont(expression, statement)
    return pass(pushlex("stat"), expression, expect(";"), poplex);
  }
  function maybeCatchBinding(type) {
    if (type == "(") return cont(funarg, expect(")"))
  }
  function expression(type, value) {
    return expressionInner(type, value, false);
  }
  function expressionNoComma(type, value) {
    return expressionInner(type, value, true);
  }
  function parenExpr(type) {
    if (type != "(") return pass()
    return cont(pushlex(")"), maybeexpression, expect(")"), poplex)
  }
  function expressionInner(type, value, noComma) {
    if (cx.state.fatArrowAt == cx.stream.start) {
      var body = noComma ? arrowBodyNoComma : arrowBody;
      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
    }

    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
    if (type == "function") return cont(functiondef, maybeop);
    if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), classExpression, poplex); }
    if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
    if (type == "quasi") return pass(quasi, maybeop);
    if (type == "new") return cont(maybeTarget(noComma));
    return cont();
  }
  function maybeexpression(type) {
    if (type.match(/[;\}\)\],]/)) return pass();
    return pass(expression);
  }

  function maybeoperatorComma(type, value) {
    if (type == ",") return cont(maybeexpression);
    return maybeoperatorNoComma(type, value, false);
  }
  function maybeoperatorNoComma(type, value, noComma) {
    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
    var expr = noComma == false ? expression : expressionNoComma;
    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
    if (type == "operator") {
      if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
      if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false))
        return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
      if (value == "?") return cont(expression, expect(":"), expr);
      return cont(expr);
    }
    if (type == "quasi") { return pass(quasi, me); }
    if (type == ";") return;
    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
    if (type == ".") return cont(property, me);
    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
    if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
    if (type == "regexp") {
      cx.state.lastType = cx.marked = "operator"
      cx.stream.backUp(cx.stream.pos - cx.stream.start - 1)
      return cont(expr)
    }
  }
  function quasi(type, value) {
    if (type != "quasi") return pass();
    if (value.slice(value.length - 2) != "${") return cont(quasi);
    return cont(maybeexpression, continueQuasi);
  }
  function continueQuasi(type) {
    if (type == "}") {
      cx.marked = "string-2";
      cx.state.tokenize = tokenQuasi;
      return cont(quasi);
    }
  }
  function arrowBody(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expression);
  }
  function arrowBodyNoComma(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expressionNoComma);
  }
  function maybeTarget(noComma) {
    return function(type) {
      if (type == ".") return cont(noComma ? targetNoComma : target);
      else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma)
      else return pass(noComma ? expressionNoComma : expression);
    };
  }
  function target(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
  }
  function targetNoComma(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
  }
  function maybelabel(type) {
    if (type == ":") return cont(poplex, statement);
    return pass(maybeoperatorComma, expect(";"), poplex);
  }
  function property(type) {
    if (type == "variable") {cx.marked = "property"; return cont();}
  }
  function objprop(type, value) {
    if (type == "async") {
      cx.marked = "property";
      return cont(objprop);
    } else if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      if (value == "get" || value == "set") return cont(getterSetter);
      var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
      if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
        cx.state.fatArrowAt = cx.stream.pos + m[0].length
      return cont(afterprop);
    } else if (type == "number" || type == "string") {
      cx.marked = jsonldMode ? "property" : (cx.style + " property");
      return cont(afterprop);
    } else if (type == "jsonld-keyword") {
      return cont(afterprop);
    } else if (isTS && isModifier(value)) {
      cx.marked = "keyword"
      return cont(objprop)
    } else if (type == "[") {
      return cont(expression, maybetype, expect("]"), afterprop);
    } else if (type == "spread") {
      return cont(expressionNoComma, afterprop);
    } else if (value == "*") {
      cx.marked = "keyword";
      return cont(objprop);
    } else if (type == ":") {
      return pass(afterprop)
    }
  }
  function getterSetter(type) {
    if (type != "variable") return pass(afterprop);
    cx.marked = "property";
    return cont(functiondef);
  }
  function afterprop(type) {
    if (type == ":") return cont(expressionNoComma);
    if (type == "(") return pass(functiondef);
  }
  function commasep(what, end, sep) {
    function proceed(type, value) {
      if (sep ? sep.indexOf(type) > -1 : type == ",") {
        var lex = cx.state.lexical;
        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
        return cont(function(type, value) {
          if (type == end || value == end) return pass()
          return pass(what)
        }, proceed);
      }
      if (type == end || value == end) return cont();
      if (sep && sep.indexOf(";") > -1) return pass(what)
      return cont(expect(end));
    }
    return function(type, value) {
      if (type == end || value == end) return cont();
      return pass(what, proceed);
    };
  }
  function contCommasep(what, end, info) {
    for (var i = 3; i < arguments.length; i++)
      cx.cc.push(arguments[i]);
    return cont(pushlex(end, info), commasep(what, end), poplex);
  }
  function block(type) {
    if (type == "}") return cont();
    return pass(statement, block);
  }
  function maybetype(type, value) {
    if (isTS) {
      if (type == ":") return cont(typeexpr);
      if (value == "?") return cont(maybetype);
    }
  }
  function maybetypeOrIn(type, value) {
    if (isTS && (type == ":" || value == "in")) return cont(typeexpr)
  }
  function mayberettype(type) {
    if (isTS && type == ":") {
      if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr)
      else return cont(typeexpr)
    }
  }
  function isKW(_, value) {
    if (value == "is") {
      cx.marked = "keyword"
      return cont()
    }
  }
  function typeexpr(type, value) {
    if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
      cx.marked = "keyword"
      return cont(value == "typeof" ? expressionNoComma : typeexpr)
    }
    if (type == "variable" || value == "void") {
      cx.marked = "type"
      return cont(afterType)
    }
    if (value == "|" || value == "&") return cont(typeexpr)
    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
    if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType)
    if (type == "{") return cont(pushlex("}"), typeprops, poplex, afterType)
    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType)
    if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr)
    if (type == "quasi") { return pass(quasiType, afterType); }
  }
  function maybeReturnType(type) {
    if (type == "=>") return cont(typeexpr)
  }
  function typeprops(type) {
    if (type.match(/[\}\)\]]/)) return cont()
    if (type == "," || type == ";") return cont(typeprops)
    return pass(typeprop, typeprops)
  }
  function typeprop(type, value) {
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property"
      return cont(typeprop)
    } else if (value == "?" || type == "number" || type == "string") {
      return cont(typeprop)
    } else if (type == ":") {
      return cont(typeexpr)
    } else if (type == "[") {
      return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop)
    } else if (type == "(") {
      return pass(functiondecl, typeprop)
    } else if (!type.match(/[;\}\)\],]/)) {
      return cont()
    }
  }
  function quasiType(type, value) {
    if (type != "quasi") return pass();
    if (value.slice(value.length - 2) != "${") return cont(quasiType);
    return cont(typeexpr, continueQuasiType);
  }
  function continueQuasiType(type) {
    if (type == "}") {
      cx.marked = "string-2";
      cx.state.tokenize = tokenQuasi;
      return cont(quasiType);
    }
  }
  function typearg(type, value) {
    if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg)
    if (type == ":") return cont(typeexpr)
    if (type == "spread") return cont(typearg)
    return pass(typeexpr)
  }
  function afterType(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
    if (value == "|" || type == "." || value == "&") return cont(typeexpr)
    if (type == "[") return cont(typeexpr, expect("]"), afterType)
    if (value == "extends" || value == "implements") { cx.marked = "keyword"; return cont(typeexpr) }
    if (value == "?") return cont(typeexpr, expect(":"), typeexpr)
  }
  function maybeTypeArgs(_, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
  }
  function typeparam() {
    return pass(typeexpr, maybeTypeDefault)
  }
  function maybeTypeDefault(_, value) {
    if (value == "=") return cont(typeexpr)
  }
  function vardef(_, value) {
    if (value == "enum") {cx.marked = "keyword"; return cont(enumdef)}
    return pass(pattern, maybetype, maybeAssign, vardefCont);
  }
  function pattern(type, value) {
    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(pattern) }
    if (type == "variable") { register(value); return cont(); }
    if (type == "spread") return cont(pattern);
    if (type == "[") return contCommasep(eltpattern, "]");
    if (type == "{") return contCommasep(proppattern, "}");
  }
  function proppattern(type, value) {
    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
      register(value);
      return cont(maybeAssign);
    }
    if (type == "variable") cx.marked = "property";
    if (type == "spread") return cont(pattern);
    if (type == "}") return pass();
    if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
    return cont(expect(":"), pattern, maybeAssign);
  }
  function eltpattern() {
    return pass(pattern, maybeAssign)
  }
  function maybeAssign(_type, value) {
    if (value == "=") return cont(expressionNoComma);
  }
  function vardefCont(type) {
    if (type == ",") return cont(vardef);
  }
  function maybeelse(type, value) {
    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
  }
  function forspec(type, value) {
    if (value == "await") return cont(forspec);
    if (type == "(") return cont(pushlex(")"), forspec1, poplex);
  }
  function forspec1(type) {
    if (type == "var") return cont(vardef, forspec2);
    if (type == "variable") return cont(forspec2);
    return pass(forspec2)
  }
  function forspec2(type, value) {
    if (type == ")") return cont()
    if (type == ";") return cont(forspec2)
    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression, forspec2) }
    return pass(expression, forspec2)
  }
  function functiondef(type, value) {
    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
    if (type == "variable") {register(value); return cont(functiondef);}
    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef)
  }
  function functiondecl(type, value) {
    if (value == "*") {cx.marked = "keyword"; return cont(functiondecl);}
    if (type == "variable") {register(value); return cont(functiondecl);}
    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl)
  }
  function typename(type, value) {
    if (type == "keyword" || type == "variable") {
      cx.marked = "type"
      return cont(typename)
    } else if (value == "<") {
      return cont(pushlex(">"), commasep(typeparam, ">"), poplex)
    }
  }
  function funarg(type, value) {
    if (value == "@") cont(expression, funarg)
    if (type == "spread") return cont(funarg);
    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(funarg); }
    if (isTS && type == "this") return cont(maybetype, maybeAssign)
    return pass(pattern, maybetype, maybeAssign);
  }
  function classExpression(type, value) {
    // Class expressions may have an optional name.
    if (type == "variable") return className(type, value);
    return classNameAfter(type, value);
  }
  function className(type, value) {
    if (type == "variable") {register(value); return cont(classNameAfter);}
  }
  function classNameAfter(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter)
    if (value == "extends" || value == "implements" || (isTS && type == ",")) {
      if (value == "implements") cx.marked = "keyword";
      return cont(isTS ? typeexpr : expression, classNameAfter);
    }
    if (type == "{") return cont(pushlex("}"), classBody, poplex);
  }
  function classBody(type, value) {
    if (type == "async" ||
        (type == "variable" &&
         (value == "static" || value == "get" || value == "set" || (isTS && isModifier(value))) &&
         cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false))) {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      return cont(classfield, classBody);
    }
    if (type == "number" || type == "string") return cont(classfield, classBody);
    if (type == "[")
      return cont(expression, maybetype, expect("]"), classfield, classBody)
    if (value == "*") {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (isTS && type == "(") return pass(functiondecl, classBody)
    if (type == ";" || type == ",") return cont(classBody);
    if (type == "}") return cont();
    if (value == "@") return cont(expression, classBody)
  }
  function classfield(type, value) {
    if (value == "!") return cont(classfield)
    if (value == "?") return cont(classfield)
    if (type == ":") return cont(typeexpr, maybeAssign)
    if (value == "=") return cont(expressionNoComma)
    var context = cx.state.lexical.prev, isInterface = context && context.info == "interface"
    return pass(isInterface ? functiondecl : functiondef)
  }
  function afterExport(type, value) {
    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
    return pass(statement);
  }
  function exportField(type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
    if (type == "variable") return pass(expressionNoComma, exportField);
  }
  function afterImport(type) {
    if (type == "string") return cont();
    if (type == "(") return pass(expression);
    if (type == ".") return pass(maybeoperatorComma);
    return pass(importSpec, maybeMoreImports, maybeFrom);
  }
  function importSpec(type, value) {
    if (type == "{") return contCommasep(importSpec, "}");
    if (type == "variable") register(value);
    if (value == "*") cx.marked = "keyword";
    return cont(maybeAs);
  }
  function maybeMoreImports(type) {
    if (type == ",") return cont(importSpec, maybeMoreImports)
  }
  function maybeAs(_type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
  }
  function maybeFrom(_type, value) {
    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
  }
  function arrayLiteral(type) {
    if (type == "]") return cont();
    return pass(commasep(expressionNoComma, "]"));
  }
  function enumdef() {
    return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex)
  }
  function enummember() {
    return pass(pattern, maybeAssign);
  }

  function isContinuedStatement(state, textAfter) {
    return state.lastType == "operator" || state.lastType == "," ||
      isOperatorChar.test(textAfter.charAt(0)) ||
      /[,.]/.test(textAfter.charAt(0));
  }

  function expressionAllowed(stream, state, backUp) {
    return state.tokenize == tokenBase &&
      /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
      (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
  }

  // Interface

  return {
    startState: function(basecolumn) {
      var state = {
        tokenize: tokenBase,
        lastType: "sof",
        cc: [],
        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
        localVars: parserConfig.localVars,
        context: parserConfig.localVars && new Context(null, null, false),
        indented: basecolumn || 0
      };
      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
        state.globalVars = parserConfig.globalVars;
      return state;
    },

    token: function(stream, state) {
      if (stream.sol()) {
        if (!state.lexical.hasOwnProperty("align"))
          state.lexical.align = false;
        state.indented = stream.indentation();
        findFatArrow(stream, state);
      }
      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
      var style = state.tokenize(stream, state);
      if (type == "comment") return style;
      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
      return parseJS(state, style, type, content, stream);
    },

    indent: function(state, textAfter) {
      if (state.tokenize == tokenComment || state.tokenize == tokenQuasi) return CodeMirror.Pass;
      if (state.tokenize != tokenBase) return 0;
      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
      // Kludge to prevent 'maybelse' from blocking lexical scope pops
      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
        var c = state.cc[i];
        if (c == poplex) lexical = lexical.prev;
        else if (c != maybeelse && c != popcontext) break;
      }
      while ((lexical.type == "stat" || lexical.type == "form") &&
             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
        lexical = lexical.prev;
      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
        lexical = lexical.prev;
      var type = lexical.type, closing = firstChar == type;

      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
      else if (type == "form" && firstChar == "{") return lexical.indented;
      else if (type == "form") return lexical.indented + indentUnit;
      else if (type == "stat")
        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
      else return lexical.indented + (closing ? 0 : indentUnit);
    },

    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
    blockCommentStart: jsonMode ? null : "/*",
    blockCommentEnd: jsonMode ? null : "*/",
    blockCommentContinue: jsonMode ? null : " * ",
    lineComment: jsonMode ? null : "//",
    fold: "brace",
    closeBrackets: "()[]{}''\"\"``",

    helperType: jsonMode ? "json" : "javascript",
    jsonldMode: jsonldMode,
    jsonMode: jsonMode,

    expressionAllowed: expressionAllowed,

    skipExpression: function(state) {
      parseJS(state, "atom", "atom", "true", new CodeMirror.StringStream("", 2, null))
    }
  };
});

CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);

CodeMirror.defineMIME("text/javascript", "javascript");
CodeMirror.defineMIME("text/ecmascript", "javascript");
CodeMirror.defineMIME("application/javascript", "javascript");
CodeMirror.defineMIME("application/x-javascript", "javascript");
CodeMirror.defineMIME("application/ecmascript", "javascript");
CodeMirror.defineMIME("application/json", { name: "javascript", json: true });
CodeMirror.defineMIME("application/x-json", { name: "javascript", json: true });
CodeMirror.defineMIME("application/manifest+json", { name: "javascript", json: true })
CodeMirror.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });

});

},{"../../lib/codemirror":"/usr/var/server.base/node_modules/codemirror/lib/codemirror.js"}],"/usr/var/server.base/node_modules/debug/node_modules/ms/index.js":[function(require,module,exports){
/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

},{}],"/usr/var/server.base/node_modules/debug/src/browser.js":[function(require,module,exports){
(function (process){(function (){
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = require('./common')(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};

}).call(this)}).call(this,require('_process'))
},{"./common":"/usr/var/server.base/node_modules/debug/src/common.js","_process":"/usr/var/server.base/node_modules/browserify/node_modules/process/browser.js"}],"/usr/var/server.base/node_modules/debug/src/common.js":[function(require,module,exports){

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = require('ms');
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;

},{"ms":"/usr/var/server.base/node_modules/debug/node_modules/ms/index.js"}],"/usr/var/server.base/node_modules/diff-match-patch/index.js":[function(require,module,exports){
/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */

/**
 * Class containing the diff, match and patch methods.
 * @constructor
 */
function diff_match_patch() {

  // Defaults.
  // Redefine these in your program to override the defaults.

  // Number of seconds to map a diff before giving up (0 for infinity).
  this.Diff_Timeout = 1.0;
  // Cost of an empty edit operation in terms of edit characters.
  this.Diff_EditCost = 4;
  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
  this.Match_Threshold = 0.5;
  // How far to search for a match (0 = exact location, 1000+ = broad match).
  // A match this many characters away from the expected location will add
  // 1.0 to the score (0.0 is a perfect match).
  this.Match_Distance = 1000;
  // When deleting a large block of text (over ~64 characters), how close do
  // the contents have to be to match the expected contents. (0.0 = perfection,
  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
  // end points of a delete need to match.
  this.Patch_DeleteThreshold = 0.5;
  // Chunk size for context length.
  this.Patch_Margin = 4;

  // The number of bits in an int.
  this.Match_MaxBits = 32;
}


//  DIFF FUNCTIONS


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/** @typedef {{0: number, 1: string}} */
diff_match_patch.Diff;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */
diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
    opt_deadline) {
  // Set a deadline by which time the diff must be complete.
  if (typeof opt_deadline == 'undefined') {
    if (this.Diff_Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
  }
  var deadline = opt_deadline;

  // Check for null inputs.
  if (text1 == null || text2 == null) {
    throw new Error('Null input. (diff_main)');
  }

  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  if (typeof opt_checklines == 'undefined') {
    opt_checklines = true;
  }
  var checklines = opt_checklines;

  // Trim off common prefix (speedup).
  var commonlength = this.diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = this.diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = this.diff_compute_(text1, text2, checklines, deadline);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  this.diff_cleanupMerge(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
    deadline) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = this.diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  if (checklines && text1.length > 100 && text2.length > 100) {
    return this.diff_lineMode_(text1, text2, deadline);
  }

  return this.diff_bisect_(text1, text2, deadline);
};


/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  var a = this.diff_linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  var linearray = a.lineArray;

  var diffs = this.diff_main(text1, text2, false, deadline);

  // Convert the diff back to original text.
  this.diff_charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  this.diff_cleanupSemantic(diffs);

  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push([DIFF_EQUAL, '']);
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert,
                       count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          var a = this.diff_main(text_delete, text_insert, false, deadline);
          for (var j = a.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, a[j]);
          }
          pointer = pointer + a.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop();  // Remove the dummy entry at the end.

  return diffs;
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Bail out if deadline is reached.
    if ((new Date()).getTime() > deadline) {
      break;
    }

    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
    deadline) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = this.diff_main(text1a, text2a, false, deadline);
  var diffsb = this.diff_main(text1b, text2b, false, deadline);

  return diffs.concat(diffsb);
};


/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */
diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4

  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';

  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */
  function diff_linesToCharsMunge_(text) {
    var chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    var lineStart = 0;
    var lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    var lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd == -1) {
        lineEnd = text.length - 1;
      }
      var line = text.substring(lineStart, lineEnd + 1);
      lineStart = lineEnd + 1;

      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
          (lineHash[line] !== undefined)) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
    }
    return chars;
  }

  var chars1 = diff_linesToCharsMunge_(text1);
  var chars2 = diff_linesToCharsMunge_(text2);
  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
};


/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */
diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
  for (var x = 0; x < diffs.length; x++) {
    var chars = diffs[x][1];
    var text = [];
    for (var y = 0; y < chars.length; y++) {
      text[y] = lineArray[chars.charCodeAt(y)];
    }
    diffs[x][1] = text.join('');
  }
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */
diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length == 0 || text2_length == 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  var text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 == text2) {
    return text_length;
  }

  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
  var best = 0;
  var length = 1;
  while (true) {
    var pattern = text1.substring(text_length - length);
    var found = text2.indexOf(pattern);
    if (found == -1) {
      return best;
    }
    length += found;
    if (found == 0 || text1.substring(text_length - length) ==
        text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */
diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
  if (this.Diff_Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }
  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
                                               shorttext.substring(j));
      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
                                               shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Number of characters that changed prior to the equality.
  var length_insertions1 = 0;
  var length_deletions1 = 0;
  // Number of characters that changed after the equality.
  var length_insertions2 = 0;
  var length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastequality = diffs[pointer][1];
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastequality && (lastequality.length <=
          Math.max(length_insertions1, length_deletions1)) &&
          (lastequality.length <= Math.max(length_insertions2,
                                           length_deletions2))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0;  // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastequality = null;
        changes = true;
      }
    }
    pointer++;
  }

  // Normalize the diff.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
  this.diff_cleanupSemanticLossless(diffs);

  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] == DIFF_DELETE &&
        diffs[pointer][0] == DIFF_INSERT) {
      var deletion = diffs[pointer - 1][1];
      var insertion = diffs[pointer][1];
      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 ||
            overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, insertion.substring(0, overlap_length1)]);
          diffs[pointer - 1][1] =
              deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 ||
            overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, deletion.substring(0, overlap_length2)]);
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] =
              insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] =
              deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
};


/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }

    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    var char1 = one.charAt(one.length - 1);
    var char2 = two.charAt(0);
    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
    var whitespace1 = nonAlphaNumeric1 &&
        char1.match(diff_match_patch.whitespaceRegex_);
    var whitespace2 = nonAlphaNumeric2 &&
        char2.match(diff_match_patch.whitespaceRegex_);
    var lineBreak1 = whitespace1 &&
        char1.match(diff_match_patch.linebreakRegex_);
    var lineBreak2 = whitespace2 &&
        char2.match(diff_match_patch.linebreakRegex_);
    var blankLine1 = lineBreak1 &&
        one.match(diff_match_patch.blanklineEndRegex_);
    var blankLine2 = lineBreak2 &&
        two.match(diff_match_patch.blanklineStartRegex_);

    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }

  var pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      var equality1 = diffs[pointer - 1][1];
      var edit = diffs[pointer][1];
      var equality2 = diffs[pointer + 1][1];

      // First, shift the edit as far left as possible.
      var commonOffset = this.diff_commonSuffix(equality1, edit);
      if (commonOffset) {
        var commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }

      // Second, step character by character right, looking for the best fit.
      var bestEquality1 = equality1;
      var bestEdit = edit;
      var bestEquality2 = equality2;
      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
          diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        var score = diff_cleanupSemanticScore_(equality1, edit) +
            diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }

      if (diffs[pointer - 1][1] != bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
};

// Define some regex patterns for matching boundaries.
diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
diff_match_patch.whitespaceRegex_ = /\s/;
diff_match_patch.linebreakRegex_ = /[\r\n]/;
diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;

/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Is there an insertion operation before the last equality.
  var pre_ins = false;
  // Is there a deletion operation before the last equality.
  var pre_del = false;
  // Is there an insertion operation after the last equality.
  var post_ins = false;
  // Is there a deletion operation after the last equality.
  var post_del = false;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      if (diffs[pointer][1].length < this.Diff_EditCost &&
          (post_ins || post_del)) {
        // Candidate found.
        equalities[equalitiesLength++] = pointer;
        pre_ins = post_ins;
        pre_del = post_del;
        lastequality = diffs[pointer][1];
      } else {
        // Not a candidate, and can never become one.
        equalitiesLength = 0;
        lastequality = null;
      }
      post_ins = post_del = false;
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_DELETE) {
        post_del = true;
      } else {
        post_ins = true;
      }
      /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */
      if (lastequality && ((pre_ins && pre_del && post_ins && post_del) ||
                           ((lastequality.length < this.Diff_EditCost / 2) &&
                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        equalitiesLength--;  // Throw away the equality we just deleted;
        lastequality = null;
        if (pre_ins && pre_del) {
          // No changes made which could affect previous entry, keep going.
          post_ins = post_del = true;
          equalitiesLength = 0;
        } else {
          equalitiesLength--;  // Throw away the previous equality.
          pointer = equalitiesLength > 0 ?
              equalities[equalitiesLength - 1] : -1;
          post_ins = post_del = false;
        }
        changes = true;
      }
    }
    pointer++;
  }

  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = this.diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = this.diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */
diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
  var chars1 = 0;
  var chars2 = 0;
  var last_chars1 = 0;
  var last_chars2 = 0;
  var x;
  for (x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
      chars1 += diffs[x][1].length;
    }
    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
      chars2 += diffs[x][1].length;
    }
    if (chars1 > loc) {  // Overshot the location.
      break;
    }
    last_chars1 = chars1;
    last_chars2 = chars2;
  }
  // Was the location was deleted?
  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
    return last_chars2;
  }
  // Add the remaining character length.
  return last_chars2 + (loc - last_chars1);
};


/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */
diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
  var html = [];
  var pattern_amp = /&/g;
  var pattern_lt = /</g;
  var pattern_gt = />/g;
  var pattern_para = /\n/g;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];    // Operation (insert, delete, equal)
    var data = diffs[x][1];  // Text of change.
    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
    switch (op) {
      case DIFF_INSERT:
        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
        break;
      case DIFF_DELETE:
        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
        break;
      case DIFF_EQUAL:
        html[x] = '<span>' + text + '</span>';
        break;
    }
  }
  return html.join('');
};


/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */
diff_match_patch.prototype.diff_text1 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */
diff_match_patch.prototype.diff_text2 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_DELETE) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */
diff_match_patch.prototype.diff_levenshtein = function(diffs) {
  var levenshtein = 0;
  var insertions = 0;
  var deletions = 0;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];
    var data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        // A deletion and an insertion is one substitution.
        levenshtein += Math.max(insertions, deletions);
        insertions = 0;
        deletions = 0;
        break;
    }
  }
  levenshtein += Math.max(insertions, deletions);
  return levenshtein;
};


/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */
diff_match_patch.prototype.diff_toDelta = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    switch (diffs[x][0]) {
      case DIFF_INSERT:
        text[x] = '+' + encodeURI(diffs[x][1]);
        break;
      case DIFF_DELETE:
        text[x] = '-' + diffs[x][1].length;
        break;
      case DIFF_EQUAL:
        text[x] = '=' + diffs[x][1].length;
        break;
    }
  }
  return text.join('\t').replace(/%20/g, ' ');
};


/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
  var diffs = [];
  var diffsLength = 0;  // Keeping our own length var is faster in JS.
  var pointer = 0;  // Cursor in text1
  var tokens = delta.split(/\t/g);
  for (var x = 0; x < tokens.length; x++) {
    // Each token begins with a one character parameter which specifies the
    // operation of this token (delete, insert, equality).
    var param = tokens[x].substring(1);
    switch (tokens[x].charAt(0)) {
      case '+':
        try {
          diffs[diffsLength++] = [DIFF_INSERT, decodeURI(param)];
        } catch (ex) {
          // Malformed URI sequence.
          throw new Error('Illegal escape in diff_fromDelta: ' + param);
        }
        break;
      case '-':
        // Fall through.
      case '=':
        var n = parseInt(param, 10);
        if (isNaN(n) || n < 0) {
          throw new Error('Invalid number in diff_fromDelta: ' + param);
        }
        var text = text1.substring(pointer, pointer += n);
        if (tokens[x].charAt(0) == '=') {
          diffs[diffsLength++] = [DIFF_EQUAL, text];
        } else {
          diffs[diffsLength++] = [DIFF_DELETE, text];
        }
        break;
      default:
        // Blank tokens are ok (from a trailing \t).
        // Anything else is an error.
        if (tokens[x]) {
          throw new Error('Invalid diff operation in diff_fromDelta: ' +
                          tokens[x]);
        }
    }
  }
  if (pointer != text1.length) {
    throw new Error('Delta length (' + pointer +
        ') does not equal source text length (' + text1.length + ').');
  }
  return diffs;
};


//  MATCH FUNCTIONS


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */
diff_match_patch.prototype.match_main = function(text, pattern, loc) {
  // Check for null inputs.
  if (text == null || pattern == null || loc == null) {
    throw new Error('Null input. (match_main)');
  }

  loc = Math.max(0, Math.min(loc, text.length));
  if (text == pattern) {
    // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
  } else if (!text.length) {
    // Nothing to match.
    return -1;
  } else if (text.substring(loc, loc + pattern.length) == pattern) {
    // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
  } else {
    // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
  }
};


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */
diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
  if (pattern.length > this.Match_MaxBits) {
    throw new Error('Pattern too long for this browser.');
  }

  // Initialise the alphabet.
  var s = this.match_alphabet_(pattern);

  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  function match_bitapScore_(e, x) {
    var accuracy = e / pattern.length;
    var proximity = Math.abs(loc - x);
    if (!dmp.Match_Distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy;
    }
    return accuracy + (proximity / dmp.Match_Distance);
  }

  // Highest score beyond which we give up.
  var score_threshold = this.Match_Threshold;
  // Is there a nearby exact match? (speedup)
  var best_loc = text.indexOf(pattern, loc);
  if (best_loc != -1) {
    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    // What about in the other direction? (speedup)
    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
    if (best_loc != -1) {
      score_threshold =
          Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
  }

  // Initialise the bit arrays.
  var matchmask = 1 << (pattern.length - 1);
  best_loc = -1;

  var bin_min, bin_mid;
  var bin_max = pattern.length + text.length;
  var last_rd;
  for (var d = 0; d < pattern.length; d++) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from 'loc' we can stray at this
    // error level.
    bin_min = 0;
    bin_mid = bin_max;
    while (bin_min < bin_mid) {
      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
        bin_min = bin_mid;
      } else {
        bin_max = bin_mid;
      }
      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
    }
    // Use the result from this iteration as the maximum for the next.
    bin_max = bin_mid;
    var start = Math.max(1, loc - bin_mid + 1);
    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;

    var rd = Array(finish + 2);
    rd[finish + 1] = (1 << d) - 1;
    for (var j = finish; j >= start; j--) {
      // The alphabet (s) is a sparse hash, so the following line generates
      // warnings.
      var charMatch = s[text.charAt(j - 1)];
      if (d === 0) {  // First pass: exact match.
        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
      } else {  // Subsequent passes: fuzzy match.
        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
                last_rd[j + 1];
      }
      if (rd[j] & matchmask) {
        var score = match_bitapScore_(d, j - 1);
        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (score <= score_threshold) {
          // Told you so.
          score_threshold = score;
          best_loc = j - 1;
          if (best_loc > loc) {
            // When passing loc, don't exceed our current distance from loc.
            start = Math.max(1, 2 * loc - best_loc);
          } else {
            // Already passed loc, downhill from here on in.
            break;
          }
        }
      }
    }
    // No hope for a (better) match at greater error levels.
    if (match_bitapScore_(d + 1, loc) > score_threshold) {
      break;
    }
    last_rd = rd;
  }
  return best_loc;
};


/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */
diff_match_patch.prototype.match_alphabet_ = function(pattern) {
  var s = {};
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] = 0;
  }
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
  }
  return s;
};


//  PATCH FUNCTIONS


/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */
diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
  if (text.length == 0) {
    return;
  }
  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
  var padding = 0;

  // Look for the first and last matches of pattern in text.  If two different
  // matches are found, increase the pattern length.
  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
         pattern.length < this.Match_MaxBits - this.Patch_Margin -
         this.Patch_Margin) {
    padding += this.Patch_Margin;
    pattern = text.substring(patch.start2 - padding,
                             patch.start2 + patch.length1 + padding);
  }
  // Add one chunk for good luck.
  padding += this.Patch_Margin;

  // Add the prefix.
  var prefix = text.substring(patch.start2 - padding, patch.start2);
  if (prefix) {
    patch.diffs.unshift([DIFF_EQUAL, prefix]);
  }
  // Add the suffix.
  var suffix = text.substring(patch.start2 + patch.length1,
                              patch.start2 + patch.length1 + padding);
  if (suffix) {
    patch.diffs.push([DIFF_EQUAL, suffix]);
  }

  // Roll back the start points.
  patch.start1 -= prefix.length;
  patch.start2 -= prefix.length;
  // Extend the lengths.
  patch.length1 += prefix.length + suffix.length;
  patch.length2 += prefix.length + suffix.length;
};


/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
  var text1, diffs;
  if (typeof a == 'string' && typeof opt_b == 'string' &&
      typeof opt_c == 'undefined') {
    // Method 1: text1, text2
    // Compute diffs from text1 and text2.
    text1 = /** @type {string} */(a);
    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
    if (diffs.length > 2) {
      this.diff_cleanupSemantic(diffs);
      this.diff_cleanupEfficiency(diffs);
    }
  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
      typeof opt_c == 'undefined') {
    // Method 2: diffs
    // Compute text1 from diffs.
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
    text1 = this.diff_text1(diffs);
  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
      typeof opt_c == 'undefined') {
    // Method 3: text1, diffs
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
      opt_c && typeof opt_c == 'object') {
    // Method 4: text1, text2, diffs
    // text2 is not used.
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
  } else {
    throw new Error('Unknown call format to patch_make.');
  }

  if (diffs.length === 0) {
    return [];  // Get rid of the null case.
  }
  var patches = [];
  var patch = new diff_match_patch.patch_obj();
  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
  var char_count1 = 0;  // Number of characters into the text1 string.
  var char_count2 = 0;  // Number of characters into the text2 string.
  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
  // text2 (postpatch_text).  We recreate the patches one by one to determine
  // context info.
  var prepatch_text = text1;
  var postpatch_text = text1;
  for (var x = 0; x < diffs.length; x++) {
    var diff_type = diffs[x][0];
    var diff_text = diffs[x][1];

    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
      // A new patch starts here.
      patch.start1 = char_count1;
      patch.start2 = char_count2;
    }

    switch (diff_type) {
      case DIFF_INSERT:
        patch.diffs[patchDiffLength++] = diffs[x];
        patch.length2 += diff_text.length;
        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
                         postpatch_text.substring(char_count2);
        break;
      case DIFF_DELETE:
        patch.length1 += diff_text.length;
        patch.diffs[patchDiffLength++] = diffs[x];
        postpatch_text = postpatch_text.substring(0, char_count2) +
                         postpatch_text.substring(char_count2 +
                             diff_text.length);
        break;
      case DIFF_EQUAL:
        if (diff_text.length <= 2 * this.Patch_Margin &&
            patchDiffLength && diffs.length != x + 1) {
          // Small equality inside a patch.
          patch.diffs[patchDiffLength++] = diffs[x];
          patch.length1 += diff_text.length;
          patch.length2 += diff_text.length;
        } else if (diff_text.length >= 2 * this.Patch_Margin) {
          // Time for a new patch.
          if (patchDiffLength) {
            this.patch_addContext_(patch, prepatch_text);
            patches.push(patch);
            patch = new diff_match_patch.patch_obj();
            patchDiffLength = 0;
            // Unlike Unidiff, our patch lists have a rolling context.
            // http://code.google.com/p/google-diff-match-patch/wiki/Unidiff
            // Update prepatch text & pos to reflect the application of the
            // just completed patch.
            prepatch_text = postpatch_text;
            char_count1 = char_count2;
          }
        }
        break;
    }

    // Update the current character count.
    if (diff_type !== DIFF_INSERT) {
      char_count1 += diff_text.length;
    }
    if (diff_type !== DIFF_DELETE) {
      char_count2 += diff_text.length;
    }
  }
  // Pick up the leftover patch if not empty.
  if (patchDiffLength) {
    this.patch_addContext_(patch, prepatch_text);
    patches.push(patch);
  }

  return patches;
};


/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_deepCopy = function(patches) {
  // Making deep copies is hard in JavaScript.
  var patchesCopy = [];
  for (var x = 0; x < patches.length; x++) {
    var patch = patches[x];
    var patchCopy = new diff_match_patch.patch_obj();
    patchCopy.diffs = [];
    for (var y = 0; y < patch.diffs.length; y++) {
      patchCopy.diffs[y] = patch.diffs[y].slice();
    }
    patchCopy.start1 = patch.start1;
    patchCopy.start2 = patch.start2;
    patchCopy.length1 = patch.length1;
    patchCopy.length2 = patch.length2;
    patchesCopy[x] = patchCopy;
  }
  return patchesCopy;
};


/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */
diff_match_patch.prototype.patch_apply = function(patches, text) {
  if (patches.length == 0) {
    return [text, []];
  }

  // Deep copy the patches so that no changes are made to originals.
  patches = this.patch_deepCopy(patches);

  var nullPadding = this.patch_addPadding(patches);
  text = nullPadding + text + nullPadding;

  this.patch_splitMax(patches);
  // delta keeps track of the offset between the expected and actual location
  // of the previous patch.  If there are patches expected at positions 10 and
  // 20, but the first patch was found at 12, delta is 2 and the second patch
  // has an effective expected position of 22.
  var delta = 0;
  var results = [];
  for (var x = 0; x < patches.length; x++) {
    var expected_loc = patches[x].start2 + delta;
    var text1 = this.diff_text1(patches[x].diffs);
    var start_loc;
    var end_loc = -1;
    if (text1.length > this.Match_MaxBits) {
      // patch_splitMax will only provide an oversized pattern in the case of
      // a monster delete.
      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
                                  expected_loc);
      if (start_loc != -1) {
        end_loc = this.match_main(text,
            text1.substring(text1.length - this.Match_MaxBits),
            expected_loc + text1.length - this.Match_MaxBits);
        if (end_loc == -1 || start_loc >= end_loc) {
          // Can't find valid trailing context.  Drop this patch.
          start_loc = -1;
        }
      }
    } else {
      start_loc = this.match_main(text, text1, expected_loc);
    }
    if (start_loc == -1) {
      // No match found.  :(
      results[x] = false;
      // Subtract the delta for this failed patch from subsequent patches.
      delta -= patches[x].length2 - patches[x].length1;
    } else {
      // Found a match.  :)
      results[x] = true;
      delta = start_loc - expected_loc;
      var text2;
      if (end_loc == -1) {
        text2 = text.substring(start_loc, start_loc + text1.length);
      } else {
        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
      }
      if (text1 == text2) {
        // Perfect match, just shove the replacement text in.
        text = text.substring(0, start_loc) +
               this.diff_text2(patches[x].diffs) +
               text.substring(start_loc + text1.length);
      } else {
        // Imperfect match.  Run a diff to get a framework of equivalent
        // indices.
        var diffs = this.diff_main(text1, text2, false);
        if (text1.length > this.Match_MaxBits &&
            this.diff_levenshtein(diffs) / text1.length >
            this.Patch_DeleteThreshold) {
          // The end points match, but the content is unacceptably bad.
          results[x] = false;
        } else {
          this.diff_cleanupSemanticLossless(diffs);
          var index1 = 0;
          var index2;
          for (var y = 0; y < patches[x].diffs.length; y++) {
            var mod = patches[x].diffs[y];
            if (mod[0] !== DIFF_EQUAL) {
              index2 = this.diff_xIndex(diffs, index1);
            }
            if (mod[0] === DIFF_INSERT) {  // Insertion
              text = text.substring(0, start_loc + index2) + mod[1] +
                     text.substring(start_loc + index2);
            } else if (mod[0] === DIFF_DELETE) {  // Deletion
              text = text.substring(0, start_loc + index2) +
                     text.substring(start_loc + this.diff_xIndex(diffs,
                         index1 + mod[1].length));
            }
            if (mod[0] !== DIFF_DELETE) {
              index1 += mod[1].length;
            }
          }
        }
      }
    }
  }
  // Strip the padding off.
  text = text.substring(nullPadding.length, text.length - nullPadding.length);
  return [text, results];
};


/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */
diff_match_patch.prototype.patch_addPadding = function(patches) {
  var paddingLength = this.Patch_Margin;
  var nullPadding = '';
  for (var x = 1; x <= paddingLength; x++) {
    nullPadding += String.fromCharCode(x);
  }

  // Bump all the patches forward.
  for (var x = 0; x < patches.length; x++) {
    patches[x].start1 += paddingLength;
    patches[x].start2 += paddingLength;
  }

  // Add some padding on start of first diff.
  var patch = patches[0];
  var diffs = patch.diffs;
  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.unshift([DIFF_EQUAL, nullPadding]);
    patch.start1 -= paddingLength;  // Should be 0.
    patch.start2 -= paddingLength;  // Should be 0.
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[0][1].length) {
    // Grow first equality.
    var extraLength = paddingLength - diffs[0][1].length;
    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
    patch.start1 -= extraLength;
    patch.start2 -= extraLength;
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  // Add some padding on end of last diff.
  patch = patches[patches.length - 1];
  diffs = patch.diffs;
  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.push([DIFF_EQUAL, nullPadding]);
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
    // Grow last equality.
    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  return nullPadding;
};


/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */
diff_match_patch.prototype.patch_splitMax = function(patches) {
  var patch_size = this.Match_MaxBits;
  for (var x = 0; x < patches.length; x++) {
    if (patches[x].length1 <= patch_size) {
      continue;
    }
    var bigpatch = patches[x];
    // Remove the big old patch.
    patches.splice(x--, 1);
    var start1 = bigpatch.start1;
    var start2 = bigpatch.start2;
    var precontext = '';
    while (bigpatch.diffs.length !== 0) {
      // Create one of several smaller patches.
      var patch = new diff_match_patch.patch_obj();
      var empty = true;
      patch.start1 = start1 - precontext.length;
      patch.start2 = start2 - precontext.length;
      if (precontext !== '') {
        patch.length1 = patch.length2 = precontext.length;
        patch.diffs.push([DIFF_EQUAL, precontext]);
      }
      while (bigpatch.diffs.length !== 0 &&
             patch.length1 < patch_size - this.Patch_Margin) {
        var diff_type = bigpatch.diffs[0][0];
        var diff_text = bigpatch.diffs[0][1];
        if (diff_type === DIFF_INSERT) {
          // Insertions are harmless.
          patch.length2 += diff_text.length;
          start2 += diff_text.length;
          patch.diffs.push(bigpatch.diffs.shift());
          empty = false;
        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
                   patch.diffs[0][0] == DIFF_EQUAL &&
                   diff_text.length > 2 * patch_size) {
          // This is a large deletion.  Let it pass in one chunk.
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          empty = false;
          patch.diffs.push([diff_type, diff_text]);
          bigpatch.diffs.shift();
        } else {
          // Deletion or equality.  Only take as much as we can stomach.
          diff_text = diff_text.substring(0,
              patch_size - patch.length1 - this.Patch_Margin);
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          if (diff_type === DIFF_EQUAL) {
            patch.length2 += diff_text.length;
            start2 += diff_text.length;
          } else {
            empty = false;
          }
          patch.diffs.push([diff_type, diff_text]);
          if (diff_text == bigpatch.diffs[0][1]) {
            bigpatch.diffs.shift();
          } else {
            bigpatch.diffs[0][1] =
                bigpatch.diffs[0][1].substring(diff_text.length);
          }
        }
      }
      // Compute the head context for the next patch.
      precontext = this.diff_text2(patch.diffs);
      precontext =
          precontext.substring(precontext.length - this.Patch_Margin);
      // Append the end context for this patch.
      var postcontext = this.diff_text1(bigpatch.diffs)
                            .substring(0, this.Patch_Margin);
      if (postcontext !== '') {
        patch.length1 += postcontext.length;
        patch.length2 += postcontext.length;
        if (patch.diffs.length !== 0 &&
            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
          patch.diffs[patch.diffs.length - 1][1] += postcontext;
        } else {
          patch.diffs.push([DIFF_EQUAL, postcontext]);
        }
      }
      if (!empty) {
        patches.splice(++x, 0, patch);
      }
    }
  }
};


/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */
diff_match_patch.prototype.patch_toText = function(patches) {
  var text = [];
  for (var x = 0; x < patches.length; x++) {
    text[x] = patches[x];
  }
  return text.join('');
};


/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.patch_fromText = function(textline) {
  var patches = [];
  if (!textline) {
    return patches;
  }
  var text = textline.split('\n');
  var textPointer = 0;
  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
  while (textPointer < text.length) {
    var m = text[textPointer].match(patchHeader);
    if (!m) {
      throw new Error('Invalid patch string: ' + text[textPointer]);
    }
    var patch = new diff_match_patch.patch_obj();
    patches.push(patch);
    patch.start1 = parseInt(m[1], 10);
    if (m[2] === '') {
      patch.start1--;
      patch.length1 = 1;
    } else if (m[2] == '0') {
      patch.length1 = 0;
    } else {
      patch.start1--;
      patch.length1 = parseInt(m[2], 10);
    }

    patch.start2 = parseInt(m[3], 10);
    if (m[4] === '') {
      patch.start2--;
      patch.length2 = 1;
    } else if (m[4] == '0') {
      patch.length2 = 0;
    } else {
      patch.start2--;
      patch.length2 = parseInt(m[4], 10);
    }
    textPointer++;

    while (textPointer < text.length) {
      var sign = text[textPointer].charAt(0);
      try {
        var line = decodeURI(text[textPointer].substring(1));
      } catch (ex) {
        // Malformed URI sequence.
        throw new Error('Illegal escape in patch_fromText: ' + line);
      }
      if (sign == '-') {
        // Deletion.
        patch.diffs.push([DIFF_DELETE, line]);
      } else if (sign == '+') {
        // Insertion.
        patch.diffs.push([DIFF_INSERT, line]);
      } else if (sign == ' ') {
        // Minor equality.
        patch.diffs.push([DIFF_EQUAL, line]);
      } else if (sign == '@') {
        // Start of next patch.
        break;
      } else if (sign === '') {
        // Blank line?  Whatever.
      } else {
        // WTF?
        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
      }
      textPointer++;
    }
  }
  return patches;
};


/**
 * Class representing one patch operation.
 * @constructor
 */
diff_match_patch.patch_obj = function() {
  /** @type {!Array.<!diff_match_patch.Diff>} */
  this.diffs = [];
  /** @type {?number} */
  this.start1 = null;
  /** @type {?number} */
  this.start2 = null;
  /** @type {number} */
  this.length1 = 0;
  /** @type {number} */
  this.length2 = 0;
};


/**
 * Emmulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indicies are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */
diff_match_patch.patch_obj.prototype.toString = function() {
  var coords1, coords2;
  if (this.length1 === 0) {
    coords1 = this.start1 + ',0';
  } else if (this.length1 == 1) {
    coords1 = this.start1 + 1;
  } else {
    coords1 = (this.start1 + 1) + ',' + this.length1;
  }
  if (this.length2 === 0) {
    coords2 = this.start2 + ',0';
  } else if (this.length2 == 1) {
    coords2 = this.start2 + 1;
  } else {
    coords2 = (this.start2 + 1) + ',' + this.length2;
  }
  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
  var op;
  // Escape the body of the patch with %xx notation.
  for (var x = 0; x < this.diffs.length; x++) {
    switch (this.diffs[x][0]) {
      case DIFF_INSERT:
        op = '+';
        break;
      case DIFF_DELETE:
        op = '-';
        break;
      case DIFF_EQUAL:
        op = ' ';
        break;
    }
    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
  }
  return text.join('').replace(/%20/g, ' ');
};


// The following export code was added by @ForbesLindesay
module.exports = diff_match_patch;
module.exports['diff_match_patch'] = diff_match_patch;
module.exports['DIFF_DELETE'] = DIFF_DELETE;
module.exports['DIFF_INSERT'] = DIFF_INSERT;
module.exports['DIFF_EQUAL'] = DIFF_EQUAL;
},{}],"/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/node_modules/jquery/dist/jquery.js":[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],"/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/node_modules/moment/moment.js":[function(require,module,exports){
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

},{}],"/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js":[function(require,module,exports){
/*! version : 4.17.47
 =========================================================
 bootstrap-datetimejs
 https://github.com/Eonasdan/bootstrap-datetimepicker
 Copyright (c) 2015 Jonathan Peterson
 =========================================================
 */
/*
 The MIT License (MIT)

 Copyright (c) 2015 Jonathan Peterson

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */
/*global define:false */
/*global exports:false */
/*global require:false */
/*global jQuery:false */
/*global moment:false */
(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // AMD is used - Register as an anonymous module.
        define(['jquery', 'moment'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'), require('moment'));
    } else {
        // Neither AMD nor CommonJS used. Use global variables.
        if (typeof jQuery === 'undefined') {
            throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
        }
        if (typeof moment === 'undefined') {
            throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
        }
        factory(jQuery, moment);
    }
}(function ($, moment) {
    'use strict';
    if (!moment) {
        throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
    }

    var dateTimePicker = function (element, options) {
        var picker = {},
            date,
            viewDate,
            unset = true,
            input,
            component = false,
            widget = false,
            use24Hours,
            minViewModeNumber = 0,
            actualFormat,
            parseFormats,
            currentViewMode,
            datePickerModes = [
                {
                    clsName: 'days',
                    navFnc: 'M',
                    navStep: 1
                },
                {
                    clsName: 'months',
                    navFnc: 'y',
                    navStep: 1
                },
                {
                    clsName: 'years',
                    navFnc: 'y',
                    navStep: 10
                },
                {
                    clsName: 'decades',
                    navFnc: 'y',
                    navStep: 100
                }
            ],
            viewModes = ['days', 'months', 'years', 'decades'],
            verticalModes = ['top', 'bottom', 'auto'],
            horizontalModes = ['left', 'right', 'auto'],
            toolbarPlacements = ['default', 'top', 'bottom'],
            keyMap = {
                'up': 38,
                38: 'up',
                'down': 40,
                40: 'down',
                'left': 37,
                37: 'left',
                'right': 39,
                39: 'right',
                'tab': 9,
                9: 'tab',
                'escape': 27,
                27: 'escape',
                'enter': 13,
                13: 'enter',
                'pageUp': 33,
                33: 'pageUp',
                'pageDown': 34,
                34: 'pageDown',
                'shift': 16,
                16: 'shift',
                'control': 17,
                17: 'control',
                'space': 32,
                32: 'space',
                't': 84,
                84: 't',
                'delete': 46,
                46: 'delete'
            },
            keyState = {},

            /********************************************************************************
             *
             * Private functions
             *
             ********************************************************************************/

            hasTimeZone = function () {
                return moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '';
            },

            getMoment = function (d) {
                var returnMoment;

                if (d === undefined || d === null) {
                    returnMoment = moment(); //TODO should this use format? and locale?
                } else if (moment.isDate(d) || moment.isMoment(d)) {
                    // If the date that is passed in is already a Date() or moment() object,
                    // pass it directly to moment.
                    returnMoment = moment(d);
                } else if (hasTimeZone()) { // There is a string to parse and a default time zone
                    // parse with the tz function which takes a default time zone if it is not in the format string
                    returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
                } else {
                    returnMoment = moment(d, parseFormats, options.useStrict);
                }

                if (hasTimeZone()) {
                    returnMoment.tz(options.timeZone);
                }

                return returnMoment;
            },

            isEnabled = function (granularity) {
                if (typeof granularity !== 'string' || granularity.length > 1) {
                    throw new TypeError('isEnabled expects a single character string parameter');
                }
                switch (granularity) {
                    case 'y':
                        return actualFormat.indexOf('Y') !== -1;
                    case 'M':
                        return actualFormat.indexOf('M') !== -1;
                    case 'd':
                        return actualFormat.toLowerCase().indexOf('d') !== -1;
                    case 'h':
                    case 'H':
                        return actualFormat.toLowerCase().indexOf('h') !== -1;
                    case 'm':
                        return actualFormat.indexOf('m') !== -1;
                    case 's':
                        return actualFormat.indexOf('s') !== -1;
                    default:
                        return false;
                }
            },

            hasTime = function () {
                return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
            },

            hasDate = function () {
                return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
            },

            getDatePickerTemplate = function () {
                var headTemplate = $('<thead>')
                        .append($('<tr>')
                            .append($('<th>').addClass('prev').attr('data-action', 'previous')
                                .append($('<span>').addClass(options.icons.previous))
                                )
                            .append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', (options.calendarWeeks ? '6' : '5')))
                            .append($('<th>').addClass('next').attr('data-action', 'next')
                                .append($('<span>').addClass(options.icons.next))
                                )
                            ),
                    contTemplate = $('<tbody>')
                        .append($('<tr>')
                            .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
                            );

                return [
                    $('<div>').addClass('datepicker-days')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate)
                            .append($('<tbody>'))
                            ),
                    $('<div>').addClass('datepicker-months')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-years')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-decades')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            )
                ];
            },

            getTimePickerMainTemplate = function () {
                var topRow = $('<tr>'),
                    middleRow = $('<tr>'),
                    bottomRow = $('<tr>');

                if (isEnabled('h')) {
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours').append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours').append($('<span>').addClass(options.icons.down))));
                }
                if (isEnabled('m')) {
                    if (isEnabled('h')) {
                        topRow.append($('<td>').addClass('separator'));
                        middleRow.append($('<td>').addClass('separator').html(':'));
                        bottomRow.append($('<td>').addClass('separator'));
                    }
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes')
                            .append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes')
                            .append($('<span>').addClass(options.icons.down))));
                }
                if (isEnabled('s')) {
                    if (isEnabled('m')) {
                        topRow.append($('<td>').addClass('separator'));
                        middleRow.append($('<td>').addClass('separator').html(':'));
                        bottomRow.append($('<td>').addClass('separator'));
                    }
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds')
                            .append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds')
                            .append($('<span>').addClass(options.icons.down))));
                }

                if (!use24Hours) {
                    topRow.append($('<td>').addClass('separator'));
                    middleRow.append($('<td>')
                        .append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
                    bottomRow.append($('<td>').addClass('separator'));
                }

                return $('<div>').addClass('timepicker-picker')
                    .append($('<table>').addClass('table-condensed')
                        .append([topRow, middleRow, bottomRow]));
            },

            getTimePickerTemplate = function () {
                var hoursView = $('<div>').addClass('timepicker-hours')
                        .append($('<table>').addClass('table-condensed')),
                    minutesView = $('<div>').addClass('timepicker-minutes')
                        .append($('<table>').addClass('table-condensed')),
                    secondsView = $('<div>').addClass('timepicker-seconds')
                        .append($('<table>').addClass('table-condensed')),
                    ret = [getTimePickerMainTemplate()];

                if (isEnabled('h')) {
                    ret.push(hoursView);
                }
                if (isEnabled('m')) {
                    ret.push(minutesView);
                }
                if (isEnabled('s')) {
                    ret.push(secondsView);
                }

                return ret;
            },

            getToolbar = function () {
                var row = [];
                if (options.showTodayButton) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<span>').addClass(options.icons.today))));
                }
                if (!options.sideBySide && hasDate() && hasTime()) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<span>').addClass(options.icons.time))));
                }
                if (options.showClear) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<span>').addClass(options.icons.clear))));
                }
                if (options.showClose) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<span>').addClass(options.icons.close))));
                }
                return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
            },

            getTemplate = function () {
                var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
                    dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
                    timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
                    content = $('<ul>').addClass('list-unstyled'),
                    toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());

                if (options.inline) {
                    template.removeClass('dropdown-menu');
                }

                if (use24Hours) {
                    template.addClass('usetwentyfour');
                }

                if (isEnabled('s') && !use24Hours) {
                    template.addClass('wider');
                }

                if (options.sideBySide && hasDate() && hasTime()) {
                    template.addClass('timepicker-sbs');
                    if (options.toolbarPlacement === 'top') {
                        template.append(toolbar);
                    }
                    template.append(
                        $('<div>').addClass('row')
                            .append(dateView.addClass('col-md-6'))
                            .append(timeView.addClass('col-md-6'))
                    );
                    if (options.toolbarPlacement === 'bottom') {
                        template.append(toolbar);
                    }
                    return template;
                }

                if (options.toolbarPlacement === 'top') {
                    content.append(toolbar);
                }
                if (hasDate()) {
                    content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse in' : '')).append(dateView));
                }
                if (options.toolbarPlacement === 'default') {
                    content.append(toolbar);
                }
                if (hasTime()) {
                    content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
                }
                if (options.toolbarPlacement === 'bottom') {
                    content.append(toolbar);
                }
                return template.append(content);
            },

            dataToOptions = function () {
                var eData,
                    dataOptions = {};

                if (element.is('input') || options.inline) {
                    eData = element.data();
                } else {
                    eData = element.find('input').data();
                }

                if (eData.dateOptions && eData.dateOptions instanceof Object) {
                    dataOptions = $.extend(true, dataOptions, eData.dateOptions);
                }

                $.each(options, function (key) {
                    var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
                    if (eData[attributeName] !== undefined) {
                        dataOptions[key] = eData[attributeName];
                    }
                });
                return dataOptions;
            },

            place = function () {
                var position = (component || element).position(),
                    offset = (component || element).offset(),
                    vertical = options.widgetPositioning.vertical,
                    horizontal = options.widgetPositioning.horizontal,
                    parent;

                if (options.widgetParent) {
                    parent = options.widgetParent.append(widget);
                } else if (element.is('input')) {
                    parent = element.after(widget).parent();
                } else if (options.inline) {
                    parent = element.append(widget);
                    return;
                } else {
                    parent = element;
                    element.children().first().after(widget);
                }

                // Top and bottom logic
                if (vertical === 'auto') {
                    if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
                        widget.height() + element.outerHeight() < offset.top) {
                        vertical = 'top';
                    } else {
                        vertical = 'bottom';
                    }
                }

                // Left and right logic
                if (horizontal === 'auto') {
                    if (parent.width() < offset.left + widget.outerWidth() / 2 &&
                        offset.left + widget.outerWidth() > $(window).width()) {
                        horizontal = 'right';
                    } else {
                        horizontal = 'left';
                    }
                }

                if (vertical === 'top') {
                    widget.addClass('top').removeClass('bottom');
                } else {
                    widget.addClass('bottom').removeClass('top');
                }

                if (horizontal === 'right') {
                    widget.addClass('pull-right');
                } else {
                    widget.removeClass('pull-right');
                }

                // find the first parent element that has a non-static css positioning
                if (parent.css('position') === 'static') {
                    parent = parent.parents().filter(function () {
                        return $(this).css('position') !== 'static';
                    }).first();
                }

                if (parent.length === 0) {
                    throw new Error('datetimepicker component should be placed within a non-static positioned container');
                }

                widget.css({
                    top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
                    bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
                    left: horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
                    right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
                });
            },

            notifyEvent = function (e) {
                if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
                    return;
                }
                element.trigger(e);
            },

            viewUpdate = function (e) {
                if (e === 'y') {
                    e = 'YYYY';
                }
                notifyEvent({
                    type: 'dp.update',
                    change: e,
                    viewDate: viewDate.clone()
                });
            },

            showMode = function (dir) {
                if (!widget) {
                    return;
                }
                if (dir) {
                    currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
                }
                widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).show();
            },

            fillDow = function () {
                var row = $('<tr>'),
                    currentDate = viewDate.clone().startOf('w').startOf('d');

                if (options.calendarWeeks === true) {
                    row.append($('<th>').addClass('cw').text('#'));
                }

                while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
                    row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
                    currentDate.add(1, 'd');
                }
                widget.find('.datepicker-days thead').append(row);
            },

            isInDisabledDates = function (testDate) {
                return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInEnabledDates = function (testDate) {
                return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInDisabledHours = function (testDate) {
                return options.disabledHours[testDate.format('H')] === true;
            },

            isInEnabledHours = function (testDate) {
                return options.enabledHours[testDate.format('H')] === true;
            },

            isValid = function (targetMoment, granularity) {
                if (!targetMoment.isValid()) {
                    return false;
                }
                if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
                    return false;
                }
                if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
                    return false;
                }
                if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
                    return false;
                }
                if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
                    return false;
                }
                if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
                    return false;
                }
                if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
                    return false;
                }
                if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
                    return false;
                }
                if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
                    var found = false;
                    $.each(options.disabledTimeIntervals, function () {
                        if (targetMoment.isBetween(this[0], this[1])) {
                            found = true;
                            return false;
                        }
                    });
                    if (found) {
                        return false;
                    }
                }
                return true;
            },

            fillMonths = function () {
                var spans = [],
                    monthsShort = viewDate.clone().startOf('y').startOf('d');
                while (monthsShort.isSame(viewDate, 'y')) {
                    spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
                    monthsShort.add(1, 'M');
                }
                widget.find('.datepicker-months td').empty().append(spans);
            },

            updateMonths = function () {
                var monthsView = widget.find('.datepicker-months'),
                    monthsViewHeader = monthsView.find('th'),
                    months = monthsView.find('tbody').find('span');

                monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
                monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
                monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);

                monthsView.find('.disabled').removeClass('disabled');

                if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
                    monthsViewHeader.eq(0).addClass('disabled');
                }

                monthsViewHeader.eq(1).text(viewDate.year());

                if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
                    monthsViewHeader.eq(2).addClass('disabled');
                }

                months.removeClass('active');
                if (date.isSame(viewDate, 'y') && !unset) {
                    months.eq(date.month()).addClass('active');
                }

                months.each(function (index) {
                    if (!isValid(viewDate.clone().month(index), 'M')) {
                        $(this).addClass('disabled');
                    }
                });
            },

            updateYears = function () {
                var yearsView = widget.find('.datepicker-years'),
                    yearsViewHeader = yearsView.find('th'),
                    startYear = viewDate.clone().subtract(5, 'y'),
                    endYear = viewDate.clone().add(6, 'y'),
                    html = '';

                yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
                yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
                yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);

                yearsView.find('.disabled').removeClass('disabled');

                if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
                    yearsViewHeader.eq(0).addClass('disabled');
                }

                yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());

                if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
                    yearsViewHeader.eq(2).addClass('disabled');
                }

                while (!startYear.isAfter(endYear, 'y')) {
                    html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
                    startYear.add(1, 'y');
                }

                yearsView.find('td').html(html);
            },

            updateDecades = function () {
                var decadesView = widget.find('.datepicker-decades'),
                    decadesViewHeader = decadesView.find('th'),
                    startDecade = moment({ y: viewDate.year() - (viewDate.year() % 100) - 1 }),
                    endDecade = startDecade.clone().add(100, 'y'),
                    startedAt = startDecade.clone(),
                    minDateDecade = false,
                    maxDateDecade = false,
                    endDecadeYear,
                    html = '';

                decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
                decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);

                decadesView.find('.disabled').removeClass('disabled');

                if (startDecade.isSame(moment({ y: 1900 })) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
                    decadesViewHeader.eq(0).addClass('disabled');
                }

                decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());

                if (startDecade.isSame(moment({ y: 2000 })) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
                    decadesViewHeader.eq(2).addClass('disabled');
                }

                while (!startDecade.isAfter(endDecade, 'y')) {
                    endDecadeYear = startDecade.year() + 12;
                    minDateDecade = options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
                    maxDateDecade = options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
                    html += '<span data-action="selectDecade" class="decade' + (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') +
                        (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
                    startDecade.add(12, 'y');
                }
                html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even

                decadesView.find('td').html(html);
                decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
            },

            fillDate = function () {
                var daysView = widget.find('.datepicker-days'),
                    daysViewHeader = daysView.find('th'),
                    currentDate,
                    html = [],
                    row,
                    clsNames = [],
                    i;

                if (!hasDate()) {
                    return;
                }

                daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
                daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
                daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);

                daysView.find('.disabled').removeClass('disabled');
                daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));

                if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
                    daysViewHeader.eq(0).addClass('disabled');
                }
                if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
                    daysViewHeader.eq(2).addClass('disabled');
                }

                currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');

                for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
                    if (currentDate.weekday() === 0) {
                        row = $('<tr>');
                        if (options.calendarWeeks) {
                            row.append('<td class="cw">' + currentDate.week() + '</td>');
                        }
                        html.push(row);
                    }
                    clsNames = ['day'];
                    if (currentDate.isBefore(viewDate, 'M')) {
                        clsNames.push('old');
                    }
                    if (currentDate.isAfter(viewDate, 'M')) {
                        clsNames.push('new');
                    }
                    if (currentDate.isSame(date, 'd') && !unset) {
                        clsNames.push('active');
                    }
                    if (!isValid(currentDate, 'd')) {
                        clsNames.push('disabled');
                    }
                    if (currentDate.isSame(getMoment(), 'd')) {
                        clsNames.push('today');
                    }
                    if (currentDate.day() === 0 || currentDate.day() === 6) {
                        clsNames.push('weekend');
                    }
                    notifyEvent({
                        type: 'dp.classify',
                        date: currentDate,
                        classNames: clsNames
                    });
                    row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="' + clsNames.join(' ') + '">' + currentDate.date() + '</td>');
                    currentDate.add(1, 'd');
                }

                daysView.find('tbody').empty().append(html);

                updateMonths();

                updateYears();

                updateDecades();
            },

            fillHours = function () {
                var table = widget.find('.timepicker-hours table'),
                    currentHour = viewDate.clone().startOf('d'),
                    html = [],
                    row = $('<tr>');

                if (viewDate.hour() > 11 && !use24Hours) {
                    currentHour.hour(12);
                }
                while (currentHour.isSame(viewDate, 'd') && (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
                    if (currentHour.hour() % 4 === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
                    currentHour.add(1, 'h');
                }
                table.empty().append(html);
            },

            fillMinutes = function () {
                var table = widget.find('.timepicker-minutes table'),
                    currentMinute = viewDate.clone().startOf('h'),
                    html = [],
                    row = $('<tr>'),
                    step = options.stepping === 1 ? 5 : options.stepping;

                while (viewDate.isSame(currentMinute, 'h')) {
                    if (currentMinute.minute() % (step * 4) === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
                    currentMinute.add(step, 'm');
                }
                table.empty().append(html);
            },

            fillSeconds = function () {
                var table = widget.find('.timepicker-seconds table'),
                    currentSecond = viewDate.clone().startOf('m'),
                    html = [],
                    row = $('<tr>');

                while (viewDate.isSame(currentSecond, 'm')) {
                    if (currentSecond.second() % 20 === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
                    currentSecond.add(5, 's');
                }

                table.empty().append(html);
            },

            fillTime = function () {
                var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');

                if (!use24Hours) {
                    toggle = widget.find('.timepicker [data-action=togglePeriod]');
                    newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');

                    toggle.text(date.format('A'));

                    if (isValid(newDate, 'h')) {
                        toggle.removeClass('disabled');
                    } else {
                        toggle.addClass('disabled');
                    }
                }
                timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
                timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
                timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));

                fillHours();
                fillMinutes();
                fillSeconds();
            },

            update = function () {
                if (!widget) {
                    return;
                }
                fillDate();
                fillTime();
            },

            setValue = function (targetMoment) {
                var oldDate = unset ? null : date;

                // case of calling setValue(null or false)
                if (!targetMoment) {
                    unset = true;
                    input.val('');
                    element.data('date', '');
                    notifyEvent({
                        type: 'dp.change',
                        date: false,
                        oldDate: oldDate
                    });
                    update();
                    return;
                }

                targetMoment = targetMoment.clone().locale(options.locale);

                if (hasTimeZone()) {
                    targetMoment.tz(options.timeZone);
                }

                if (options.stepping !== 1) {
                    targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping)).seconds(0);

                    while (options.minDate && targetMoment.isBefore(options.minDate)) {
                        targetMoment.add(options.stepping, 'minutes');
                    }
                }

                if (isValid(targetMoment)) {
                    date = targetMoment;
                    viewDate = date.clone();
                    input.val(date.format(actualFormat));
                    element.data('date', date.format(actualFormat));
                    unset = false;
                    update();
                    notifyEvent({
                        type: 'dp.change',
                        date: date.clone(),
                        oldDate: oldDate
                    });
                } else {
                    if (!options.keepInvalid) {
                        input.val(unset ? '' : date.format(actualFormat));
                    } else {
                        notifyEvent({
                            type: 'dp.change',
                            date: targetMoment,
                            oldDate: oldDate
                        });
                    }
                    notifyEvent({
                        type: 'dp.error',
                        date: targetMoment,
                        oldDate: oldDate
                    });
                }
            },

            /**
             * Hides the widget. Possibly will emit dp.hide
             */
            hide = function () {
                var transitioning = false;
                if (!widget) {
                    return picker;
                }
                // Ignore event if in the middle of a picker transition
                widget.find('.collapse').each(function () {
                    var collapseData = $(this).data('collapse');
                    if (collapseData && collapseData.transitioning) {
                        transitioning = true;
                        return false;
                    }
                    return true;
                });
                if (transitioning) {
                    return picker;
                }
                if (component && component.hasClass('btn')) {
                    component.toggleClass('active');
                }
                widget.hide();

                $(window).off('resize', place);
                widget.off('click', '[data-action]');
                widget.off('mousedown', false);

                widget.remove();
                widget = false;

                notifyEvent({
                    type: 'dp.hide',
                    date: date.clone()
                });

                input.blur();

                viewDate = date.clone();

                return picker;
            },

            clear = function () {
                setValue(null);
            },

            parseInputDate = function (inputDate) {
                if (options.parseInputDate === undefined) {
                    if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
                        inputDate = getMoment(inputDate);
                    }
                } else {
                    inputDate = options.parseInputDate(inputDate);
                }
                //inputDate.locale(options.locale);
                return inputDate;
            },

            /********************************************************************************
             *
             * Widget UI interaction functions
             *
             ********************************************************************************/
            actions = {
                next: function () {
                    var navFnc = datePickerModes[currentViewMode].navFnc;
                    viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
                    fillDate();
                    viewUpdate(navFnc);
                },

                previous: function () {
                    var navFnc = datePickerModes[currentViewMode].navFnc;
                    viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
                    fillDate();
                    viewUpdate(navFnc);
                },

                pickerSwitch: function () {
                    showMode(1);
                },

                selectMonth: function (e) {
                    var month = $(e.target).closest('tbody').find('span').index($(e.target));
                    viewDate.month(month);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('M');
                },

                selectYear: function (e) {
                    var year = parseInt($(e.target).text(), 10) || 0;
                    viewDate.year(year);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('YYYY');
                },

                selectDecade: function (e) {
                    var year = parseInt($(e.target).data('selection'), 10) || 0;
                    viewDate.year(year);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('YYYY');
                },

                selectDay: function (e) {
                    var day = viewDate.clone();
                    if ($(e.target).is('.old')) {
                        day.subtract(1, 'M');
                    }
                    if ($(e.target).is('.new')) {
                        day.add(1, 'M');
                    }
                    setValue(day.date(parseInt($(e.target).text(), 10)));
                    if (!hasTime() && !options.keepOpen && !options.inline) {
                        hide();
                    }
                },

                incrementHours: function () {
                    var newDate = date.clone().add(1, 'h');
                    if (isValid(newDate, 'h')) {
                        setValue(newDate);
                    }
                },

                incrementMinutes: function () {
                    var newDate = date.clone().add(options.stepping, 'm');
                    if (isValid(newDate, 'm')) {
                        setValue(newDate);
                    }
                },

                incrementSeconds: function () {
                    var newDate = date.clone().add(1, 's');
                    if (isValid(newDate, 's')) {
                        setValue(newDate);
                    }
                },

                decrementHours: function () {
                    var newDate = date.clone().subtract(1, 'h');
                    if (isValid(newDate, 'h')) {
                        setValue(newDate);
                    }
                },

                decrementMinutes: function () {
                    var newDate = date.clone().subtract(options.stepping, 'm');
                    if (isValid(newDate, 'm')) {
                        setValue(newDate);
                    }
                },

                decrementSeconds: function () {
                    var newDate = date.clone().subtract(1, 's');
                    if (isValid(newDate, 's')) {
                        setValue(newDate);
                    }
                },

                togglePeriod: function () {
                    setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
                },

                togglePicker: function (e) {
                    var $this = $(e.target),
                        $parent = $this.closest('ul'),
                        expanded = $parent.find('.in'),
                        closed = $parent.find('.collapse:not(.in)'),
                        collapseData;

                    if (expanded && expanded.length) {
                        collapseData = expanded.data('collapse');
                        if (collapseData && collapseData.transitioning) {
                            return;
                        }
                        if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
                            expanded.collapse('hide');
                            closed.collapse('show');
                        } else { // otherwise just toggle in class on the two views
                            expanded.removeClass('in');
                            closed.addClass('in');
                        }
                        if ($this.is('span')) {
                            $this.toggleClass(options.icons.time + ' ' + options.icons.date);
                        } else {
                            $this.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                        }

                        // NOTE: uncomment if toggled state will be restored in show()
                        //if (component) {
                        //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                        //}
                    }
                },

                showPicker: function () {
                    widget.find('.timepicker > div:not(.timepicker-picker)').hide();
                    widget.find('.timepicker .timepicker-picker').show();
                },

                showHours: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-hours').show();
                },

                showMinutes: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-minutes').show();
                },

                showSeconds: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-seconds').show();
                },

                selectHour: function (e) {
                    var hour = parseInt($(e.target).text(), 10);

                    if (!use24Hours) {
                        if (date.hours() >= 12) {
                            if (hour !== 12) {
                                hour += 12;
                            }
                        } else {
                            if (hour === 12) {
                                hour = 0;
                            }
                        }
                    }
                    setValue(date.clone().hours(hour));
                    actions.showPicker.call(picker);
                },

                selectMinute: function (e) {
                    setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
                    actions.showPicker.call(picker);
                },

                selectSecond: function (e) {
                    setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
                    actions.showPicker.call(picker);
                },

                clear: clear,

                today: function () {
                    var todaysDate = getMoment();
                    if (isValid(todaysDate, 'd')) {
                        setValue(todaysDate);
                    }
                },

                close: hide
            },

            doAction = function (e) {
                if ($(e.currentTarget).is('.disabled')) {
                    return false;
                }
                actions[$(e.currentTarget).data('action')].apply(picker, arguments);
                return false;
            },

            /**
             * Shows the widget. Possibly will emit dp.show and dp.change
             */
            show = function () {
                var currentMoment,
                    useCurrentGranularity = {
                        'year': function (m) {
                            return m.month(0).date(1).hours(0).seconds(0).minutes(0);
                        },
                        'month': function (m) {
                            return m.date(1).hours(0).seconds(0).minutes(0);
                        },
                        'day': function (m) {
                            return m.hours(0).seconds(0).minutes(0);
                        },
                        'hour': function (m) {
                            return m.seconds(0).minutes(0);
                        },
                        'minute': function (m) {
                            return m.seconds(0);
                        }
                    };

                if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
                    return picker;
                }
                if (input.val() !== undefined && input.val().trim().length !== 0) {
                    setValue(parseInputDate(input.val().trim()));
                } else if (unset && options.useCurrent && (options.inline || (input.is('input') && input.val().trim().length === 0))) {
                    currentMoment = getMoment();
                    if (typeof options.useCurrent === 'string') {
                        currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
                    }
                    setValue(currentMoment);
                }
                widget = getTemplate();

                fillDow();
                fillMonths();

                widget.find('.timepicker-hours').hide();
                widget.find('.timepicker-minutes').hide();
                widget.find('.timepicker-seconds').hide();

                update();
                showMode();

                $(window).on('resize', place);
                widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
                widget.on('mousedown', false);

                if (component && component.hasClass('btn')) {
                    component.toggleClass('active');
                }
                place();
                widget.show();
                if (options.focusOnShow && !input.is(':focus')) {
                    input.focus();
                }

                notifyEvent({
                    type: 'dp.show'
                });
                return picker;
            },

            /**
             * Shows or hides the widget
             */
            toggle = function () {
                return (widget ? hide() : show());
            },

            keydown = function (e) {
                var handler = null,
                    index,
                    index2,
                    pressedKeys = [],
                    pressedModifiers = {},
                    currentKey = e.which,
                    keyBindKeys,
                    allModifiersPressed,
                    pressed = 'p';

                keyState[currentKey] = pressed;

                for (index in keyState) {
                    if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
                        pressedKeys.push(index);
                        if (parseInt(index, 10) !== currentKey) {
                            pressedModifiers[index] = true;
                        }
                    }
                }

                for (index in options.keyBinds) {
                    if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
                        keyBindKeys = index.split(' ');
                        if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
                            allModifiersPressed = true;
                            for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
                                if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
                                    allModifiersPressed = false;
                                    break;
                                }
                            }
                            if (allModifiersPressed) {
                                handler = options.keyBinds[index];
                                break;
                            }
                        }
                    }
                }

                if (handler) {
                    handler.call(picker, widget);
                    e.stopPropagation();
                    e.preventDefault();
                }
            },

            keyup = function (e) {
                keyState[e.which] = 'r';
                e.stopPropagation();
                e.preventDefault();
            },

            change = function (e) {
                var val = $(e.target).val().trim(),
                    parsedDate = val ? parseInputDate(val) : null;
                setValue(parsedDate);
                e.stopImmediatePropagation();
                return false;
            },

            attachDatePickerElementEvents = function () {
                input.on({
                    'change': change,
                    'blur': options.debug ? '' : hide,
                    'keydown': keydown,
                    'keyup': keyup,
                    'focus': options.allowInputToggle ? show : ''
                });

                if (element.is('input')) {
                    input.on({
                        'focus': show
                    });
                } else if (component) {
                    component.on('click', toggle);
                    component.on('mousedown', false);
                }
            },

            detachDatePickerElementEvents = function () {
                input.off({
                    'change': change,
                    'blur': blur,
                    'keydown': keydown,
                    'keyup': keyup,
                    'focus': options.allowInputToggle ? hide : ''
                });

                if (element.is('input')) {
                    input.off({
                        'focus': show
                    });
                } else if (component) {
                    component.off('click', toggle);
                    component.off('mousedown', false);
                }
            },

            indexGivenDates = function (givenDatesArray) {
                // Store given enabledDates and disabledDates as keys.
                // This way we can check their existence in O(1) time instead of looping through whole array.
                // (for example: options.enabledDates['2014-02-27'] === true)
                var givenDatesIndexed = {};
                $.each(givenDatesArray, function () {
                    var dDate = parseInputDate(this);
                    if (dDate.isValid()) {
                        givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
                    }
                });
                return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
            },

            indexGivenHours = function (givenHoursArray) {
                // Store given enabledHours and disabledHours as keys.
                // This way we can check their existence in O(1) time instead of looping through whole array.
                // (for example: options.enabledHours['2014-02-27'] === true)
                var givenHoursIndexed = {};
                $.each(givenHoursArray, function () {
                    givenHoursIndexed[this] = true;
                });
                return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
            },

            initFormatting = function () {
                var format = options.format || 'L LT';

                actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
                    var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
                    return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) { //temp fix for #740
                        return date.localeData().longDateFormat(formatInput2) || formatInput2;
                    });
                });


                parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
                if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
                    parseFormats.push(actualFormat);
                }

                use24Hours = (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);

                if (isEnabled('y')) {
                    minViewModeNumber = 2;
                }
                if (isEnabled('M')) {
                    minViewModeNumber = 1;
                }
                if (isEnabled('d')) {
                    minViewModeNumber = 0;
                }

                currentViewMode = Math.max(minViewModeNumber, currentViewMode);

                if (!unset) {
                    setValue(date);
                }
            };

        /********************************************************************************
         *
         * Public API functions
         * =====================
         *
         * Important: Do not expose direct references to private objects or the options
         * object to the outer world. Always return a clone when returning values or make
         * a clone when setting a private variable.
         *
         ********************************************************************************/
        picker.destroy = function () {
            ///<summary>Destroys the widget and removes all attached event listeners</summary>
            hide();
            detachDatePickerElementEvents();
            element.removeData('DateTimePicker');
            element.removeData('date');
        };

        picker.toggle = toggle;

        picker.show = show;

        picker.hide = hide;

        picker.disable = function () {
            ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
            ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
            hide();
            if (component && component.hasClass('btn')) {
                component.addClass('disabled');
            }
            input.prop('disabled', true);
            return picker;
        };

        picker.enable = function () {
            ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
            if (component && component.hasClass('btn')) {
                component.removeClass('disabled');
            }
            input.prop('disabled', false);
            return picker;
        };

        picker.ignoreReadonly = function (ignoreReadonly) {
            if (arguments.length === 0) {
                return options.ignoreReadonly;
            }
            if (typeof ignoreReadonly !== 'boolean') {
                throw new TypeError('ignoreReadonly () expects a boolean parameter');
            }
            options.ignoreReadonly = ignoreReadonly;
            return picker;
        };

        picker.options = function (newOptions) {
            if (arguments.length === 0) {
                return $.extend(true, {}, options);
            }

            if (!(newOptions instanceof Object)) {
                throw new TypeError('options() options parameter should be an object');
            }
            $.extend(true, options, newOptions);
            $.each(options, function (key, value) {
                if (picker[key] !== undefined) {
                    picker[key](value);
                } else {
                    throw new TypeError('option ' + key + ' is not recognized!');
                }
            });
            return picker;
        };

        picker.date = function (newDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.date">
            ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
            ///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
            ///</signature>
            if (arguments.length === 0) {
                if (unset) {
                    return null;
                }
                return date.clone();
            }

            if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
            }

            setValue(newDate === null ? null : parseInputDate(newDate));
            return picker;
        };

        picker.format = function (newFormat) {
            ///<summary>test su</summary>
            ///<param name="newFormat">info about para</param>
            ///<returns type="string|boolean">returns foo</returns>
            if (arguments.length === 0) {
                return options.format;
            }

            if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
                throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
            }

            options.format = newFormat;
            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.timeZone = function (newZone) {
            if (arguments.length === 0) {
                return options.timeZone;
            }

            if (typeof newZone !== 'string') {
                throw new TypeError('newZone() expects a string parameter');
            }

            options.timeZone = newZone;

            return picker;
        };

        picker.dayViewHeaderFormat = function (newFormat) {
            if (arguments.length === 0) {
                return options.dayViewHeaderFormat;
            }

            if (typeof newFormat !== 'string') {
                throw new TypeError('dayViewHeaderFormat() expects a string parameter');
            }

            options.dayViewHeaderFormat = newFormat;
            return picker;
        };

        picker.extraFormats = function (formats) {
            if (arguments.length === 0) {
                return options.extraFormats;
            }

            if (formats !== false && !(formats instanceof Array)) {
                throw new TypeError('extraFormats() expects an array or false parameter');
            }

            options.extraFormats = formats;
            if (parseFormats) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.disabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
            }

            if (!dates) {
                options.disabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('disabledDates() expects an array parameter');
            }
            options.disabledDates = indexGivenDates(dates);
            options.enabledDates = false;
            update();
            return picker;
        };

        picker.enabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
            ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
            ///<returns type="array">options.enabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
            }

            if (!dates) {
                options.enabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('enabledDates() expects an array parameter');
            }
            options.enabledDates = indexGivenDates(dates);
            options.disabledDates = false;
            update();
            return picker;
        };

        picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
            if (arguments.length === 0) {
                return options.daysOfWeekDisabled.splice(0);
            }

            if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
                options.daysOfWeekDisabled = false;
                update();
                return picker;
            }

            if (!(daysOfWeekDisabled instanceof Array)) {
                throw new TypeError('daysOfWeekDisabled() expects an array parameter');
            }
            options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
                currentValue = parseInt(currentValue, 10);
                if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
                    return previousValue;
                }
                if (previousValue.indexOf(currentValue) === -1) {
                    previousValue.push(currentValue);
                }
                return previousValue;
            }, []).sort();
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'd')) {
                    date.add(1, 'd');
                    if (tries === 31) {
                        throw 'Tried 31 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.maxDate = function (maxDate) {
            if (arguments.length === 0) {
                return options.maxDate ? options.maxDate.clone() : options.maxDate;
            }

            if ((typeof maxDate === 'boolean') && maxDate === false) {
                options.maxDate = false;
                update();
                return picker;
            }

            if (typeof maxDate === 'string') {
                if (maxDate === 'now' || maxDate === 'moment') {
                    maxDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(maxDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
            }
            if (options.minDate && parsedDate.isBefore(options.minDate)) {
                throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
            }
            options.maxDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
                setValue(options.maxDate);
            }
            if (viewDate.isAfter(parsedDate)) {
                viewDate = parsedDate.clone().subtract(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.minDate = function (minDate) {
            if (arguments.length === 0) {
                return options.minDate ? options.minDate.clone() : options.minDate;
            }

            if ((typeof minDate === 'boolean') && minDate === false) {
                options.minDate = false;
                update();
                return picker;
            }

            if (typeof minDate === 'string') {
                if (minDate === 'now' || minDate === 'moment') {
                    minDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(minDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
            }
            if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
                throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
            }
            options.minDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
                setValue(options.minDate);
            }
            if (viewDate.isBefore(parsedDate)) {
                viewDate = parsedDate.clone().add(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.defaultDate = function (defaultDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
            ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
            ///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
            }
            if (!defaultDate) {
                options.defaultDate = false;
                return picker;
            }

            if (typeof defaultDate === 'string') {
                if (defaultDate === 'now' || defaultDate === 'moment') {
                    defaultDate = getMoment();
                } else {
                    defaultDate = getMoment(defaultDate);
                }
            }

            var parsedDate = parseInputDate(defaultDate);
            if (!parsedDate.isValid()) {
                throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
            }
            if (!isValid(parsedDate)) {
                throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
            }

            options.defaultDate = parsedDate;

            if ((options.defaultDate && options.inline) || input.val().trim() === '') {
                setValue(options.defaultDate);
            }
            return picker;
        };

        picker.locale = function (locale) {
            if (arguments.length === 0) {
                return options.locale;
            }

            if (!moment.localeData(locale)) {
                throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
            }

            options.locale = locale;
            date.locale(options.locale);
            viewDate.locale(options.locale);

            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.stepping = function (stepping) {
            if (arguments.length === 0) {
                return options.stepping;
            }

            stepping = parseInt(stepping, 10);
            if (isNaN(stepping) || stepping < 1) {
                stepping = 1;
            }
            options.stepping = stepping;
            return picker;
        };

        picker.useCurrent = function (useCurrent) {
            var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
            if (arguments.length === 0) {
                return options.useCurrent;
            }

            if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
                throw new TypeError('useCurrent() expects a boolean or string parameter');
            }
            if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
                throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
            }
            options.useCurrent = useCurrent;
            return picker;
        };

        picker.collapse = function (collapse) {
            if (arguments.length === 0) {
                return options.collapse;
            }

            if (typeof collapse !== 'boolean') {
                throw new TypeError('collapse() expects a boolean parameter');
            }
            if (options.collapse === collapse) {
                return picker;
            }
            options.collapse = collapse;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.icons = function (icons) {
            if (arguments.length === 0) {
                return $.extend({}, options.icons);
            }

            if (!(icons instanceof Object)) {
                throw new TypeError('icons() expects parameter to be an Object');
            }
            $.extend(options.icons, icons);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.tooltips = function (tooltips) {
            if (arguments.length === 0) {
                return $.extend({}, options.tooltips);
            }

            if (!(tooltips instanceof Object)) {
                throw new TypeError('tooltips() expects parameter to be an Object');
            }
            $.extend(options.tooltips, tooltips);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.useStrict = function (useStrict) {
            if (arguments.length === 0) {
                return options.useStrict;
            }

            if (typeof useStrict !== 'boolean') {
                throw new TypeError('useStrict() expects a boolean parameter');
            }
            options.useStrict = useStrict;
            return picker;
        };

        picker.sideBySide = function (sideBySide) {
            if (arguments.length === 0) {
                return options.sideBySide;
            }

            if (typeof sideBySide !== 'boolean') {
                throw new TypeError('sideBySide() expects a boolean parameter');
            }
            options.sideBySide = sideBySide;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.viewMode = function (viewMode) {
            if (arguments.length === 0) {
                return options.viewMode;
            }

            if (typeof viewMode !== 'string') {
                throw new TypeError('viewMode() expects a string parameter');
            }

            if (viewModes.indexOf(viewMode) === -1) {
                throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
            }

            options.viewMode = viewMode;
            currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);

            showMode();
            return picker;
        };

        picker.toolbarPlacement = function (toolbarPlacement) {
            if (arguments.length === 0) {
                return options.toolbarPlacement;
            }

            if (typeof toolbarPlacement !== 'string') {
                throw new TypeError('toolbarPlacement() expects a string parameter');
            }
            if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
                throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
            }
            options.toolbarPlacement = toolbarPlacement;

            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetPositioning = function (widgetPositioning) {
            if (arguments.length === 0) {
                return $.extend({}, options.widgetPositioning);
            }

            if (({}).toString.call(widgetPositioning) !== '[object Object]') {
                throw new TypeError('widgetPositioning() expects an object variable');
            }
            if (widgetPositioning.horizontal) {
                if (typeof widgetPositioning.horizontal !== 'string') {
                    throw new TypeError('widgetPositioning() horizontal variable must be a string');
                }
                widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
                if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
                    throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
                }
                options.widgetPositioning.horizontal = widgetPositioning.horizontal;
            }
            if (widgetPositioning.vertical) {
                if (typeof widgetPositioning.vertical !== 'string') {
                    throw new TypeError('widgetPositioning() vertical variable must be a string');
                }
                widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
                if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
                    throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
                }
                options.widgetPositioning.vertical = widgetPositioning.vertical;
            }
            update();
            return picker;
        };

        picker.calendarWeeks = function (calendarWeeks) {
            if (arguments.length === 0) {
                return options.calendarWeeks;
            }

            if (typeof calendarWeeks !== 'boolean') {
                throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
            }

            options.calendarWeeks = calendarWeeks;
            update();
            return picker;
        };

        picker.showTodayButton = function (showTodayButton) {
            if (arguments.length === 0) {
                return options.showTodayButton;
            }

            if (typeof showTodayButton !== 'boolean') {
                throw new TypeError('showTodayButton() expects a boolean parameter');
            }

            options.showTodayButton = showTodayButton;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.showClear = function (showClear) {
            if (arguments.length === 0) {
                return options.showClear;
            }

            if (typeof showClear !== 'boolean') {
                throw new TypeError('showClear() expects a boolean parameter');
            }

            options.showClear = showClear;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetParent = function (widgetParent) {
            if (arguments.length === 0) {
                return options.widgetParent;
            }

            if (typeof widgetParent === 'string') {
                widgetParent = $(widgetParent);
            }

            if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
                throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
            }

            options.widgetParent = widgetParent;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.keepOpen = function (keepOpen) {
            if (arguments.length === 0) {
                return options.keepOpen;
            }

            if (typeof keepOpen !== 'boolean') {
                throw new TypeError('keepOpen() expects a boolean parameter');
            }

            options.keepOpen = keepOpen;
            return picker;
        };

        picker.focusOnShow = function (focusOnShow) {
            if (arguments.length === 0) {
                return options.focusOnShow;
            }

            if (typeof focusOnShow !== 'boolean') {
                throw new TypeError('focusOnShow() expects a boolean parameter');
            }

            options.focusOnShow = focusOnShow;
            return picker;
        };

        picker.inline = function (inline) {
            if (arguments.length === 0) {
                return options.inline;
            }

            if (typeof inline !== 'boolean') {
                throw new TypeError('inline() expects a boolean parameter');
            }

            options.inline = inline;
            return picker;
        };

        picker.clear = function () {
            clear();
            return picker;
        };

        picker.keyBinds = function (keyBinds) {
            if (arguments.length === 0) {
                return options.keyBinds;
            }

            options.keyBinds = keyBinds;
            return picker;
        };

        picker.getMoment = function (d) {
            return getMoment(d);
        };

        picker.debug = function (debug) {
            if (typeof debug !== 'boolean') {
                throw new TypeError('debug() expects a boolean parameter');
            }

            options.debug = debug;
            return picker;
        };

        picker.allowInputToggle = function (allowInputToggle) {
            if (arguments.length === 0) {
                return options.allowInputToggle;
            }

            if (typeof allowInputToggle !== 'boolean') {
                throw new TypeError('allowInputToggle() expects a boolean parameter');
            }

            options.allowInputToggle = allowInputToggle;
            return picker;
        };

        picker.showClose = function (showClose) {
            if (arguments.length === 0) {
                return options.showClose;
            }

            if (typeof showClose !== 'boolean') {
                throw new TypeError('showClose() expects a boolean parameter');
            }

            options.showClose = showClose;
            return picker;
        };

        picker.keepInvalid = function (keepInvalid) {
            if (arguments.length === 0) {
                return options.keepInvalid;
            }

            if (typeof keepInvalid !== 'boolean') {
                throw new TypeError('keepInvalid() expects a boolean parameter');
            }
            options.keepInvalid = keepInvalid;
            return picker;
        };

        picker.datepickerInput = function (datepickerInput) {
            if (arguments.length === 0) {
                return options.datepickerInput;
            }

            if (typeof datepickerInput !== 'string') {
                throw new TypeError('datepickerInput() expects a string parameter');
            }

            options.datepickerInput = datepickerInput;
            return picker;
        };

        picker.parseInputDate = function (parseInputDate) {
            if (arguments.length === 0) {
                return options.parseInputDate;
            }

            if (typeof parseInputDate !== 'function') {
                throw new TypeError('parseInputDate() sholud be as function');
            }

            options.parseInputDate = parseInputDate;

            return picker;
        };

        picker.disabledTimeIntervals = function (disabledTimeIntervals) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledTimeIntervals</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
            }

            if (!disabledTimeIntervals) {
                options.disabledTimeIntervals = false;
                update();
                return picker;
            }
            if (!(disabledTimeIntervals instanceof Array)) {
                throw new TypeError('disabledTimeIntervals() expects an array parameter');
            }
            options.disabledTimeIntervals = disabledTimeIntervals;
            update();
            return picker;
        };

        picker.disabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
            ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
            ///<returns type="array">options.disabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
            }

            if (!hours) {
                options.disabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('disabledHours() expects an array parameter');
            }
            options.disabledHours = indexGivenHours(hours);
            options.enabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.enabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
            ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
            ///<returns type="array">options.enabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
            }

            if (!hours) {
                options.enabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('enabledHours() expects an array parameter');
            }
            options.enabledHours = indexGivenHours(hours);
            options.disabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };
        /**
         * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.
         * @param {Takes string, viewDate, moment, null parameter.} newDate
         * @returns {viewDate.clone()}
         */
        picker.viewDate = function (newDate) {
            if (arguments.length === 0) {
                return viewDate.clone();
            }

            if (!newDate) {
                viewDate = date.clone();
                return picker;
            }

            if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
            }

            viewDate = parseInputDate(newDate);
            viewUpdate();
            return picker;
        };

        // initializing element and component attributes
        if (element.is('input')) {
            input = element;
        } else {
            input = element.find(options.datepickerInput);
            if (input.length === 0) {
                input = element.find('input');
            } else if (!input.is('input')) {
                throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
            }
        }

        if (element.hasClass('input-group')) {
            // in case there is more then one 'input-group-addon' Issue #48
            if (element.find('.datepickerbutton').length === 0) {
                component = element.find('.input-group-addon');
            } else {
                component = element.find('.datepickerbutton');
            }
        }

        if (!options.inline && !input.is('input')) {
            throw new Error('Could not initialize DateTimePicker without an input element');
        }

        // Set defaults for date here now instead of in var declaration
        date = getMoment();
        viewDate = date.clone();

        $.extend(true, options, dataToOptions());

        picker.options(options);

        initFormatting();

        attachDatePickerElementEvents();

        if (input.prop('disabled')) {
            picker.disable();
        }
        if (input.is('input') && input.val().trim().length !== 0) {
            setValue(parseInputDate(input.val().trim()));
        }
        else if (options.defaultDate && input.attr('placeholder') === undefined) {
            setValue(options.defaultDate);
        }
        if (options.inline) {
            show();
        }
        return picker;
    };

    /********************************************************************************
     *
     * jQuery plugin constructor and defaults object
     *
     ********************************************************************************/

    /**
    * See (http://jquery.com/).
    * @name jQuery
    * @class
    * See the jQuery Library  (http://jquery.com/) for full details.  This just
    * documents the function and classes that are added to jQuery by this plug-in.
    */
    /**
     * See (http://jquery.com/)
     * @name fn
     * @class
     * See the jQuery Library  (http://jquery.com/) for full details.  This just
     * documents the function and classes that are added to jQuery by this plug-in.
     * @memberOf jQuery
     */
    /**
     * Show comments
     * @class datetimepicker
     * @memberOf jQuery.fn
     */
    $.fn.datetimepicker = function (options) {
        options = options || {};

        var args = Array.prototype.slice.call(arguments, 1),
            isInstance = true,
            thisMethods = ['destroy', 'hide', 'show', 'toggle'],
            returnValue;

        if (typeof options === 'object') {
            return this.each(function () {
                var $this = $(this),
                    _options;
                if (!$this.data('DateTimePicker')) {
                    // create a private copy of the defaults object
                    _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
                    $this.data('DateTimePicker', dateTimePicker($this, _options));
                }
            });
        } else if (typeof options === 'string') {
            this.each(function () {
                var $this = $(this),
                    instance = $this.data('DateTimePicker');
                if (!instance) {
                    throw new Error('bootstrap-datetimepicker("' + options + '") method was called on an element that is not using DateTimePicker');
                }

                returnValue = instance[options].apply(instance, args);
                isInstance = returnValue === instance;
            });

            if (isInstance || $.inArray(options, thisMethods) > -1) {
                return this;
            }

            return returnValue;
        }

        throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
    };

    $.fn.datetimepicker.defaults = {
        timeZone: '',
        format: false,
        dayViewHeaderFormat: 'MMMM YYYY',
        extraFormats: false,
        stepping: 1,
        minDate: false,
        maxDate: false,
        useCurrent: true,
        collapse: true,
        locale: moment.locale(),
        defaultDate: false,
        disabledDates: false,
        enabledDates: false,
        icons: {
            time: 'glyphicon glyphicon-time',
            date: 'glyphicon glyphicon-calendar',
            up: 'glyphicon glyphicon-chevron-up',
            down: 'glyphicon glyphicon-chevron-down',
            previous: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            today: 'glyphicon glyphicon-screenshot',
            clear: 'glyphicon glyphicon-trash',
            close: 'glyphicon glyphicon-remove'
        },
        tooltips: {
            today: 'Go to today',
            clear: 'Clear selection',
            close: 'Close the picker',
            selectMonth: 'Select Month',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            selectYear: 'Select Year',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            selectDecade: 'Select Decade',
            prevDecade: 'Previous Decade',
            nextDecade: 'Next Decade',
            prevCentury: 'Previous Century',
            nextCentury: 'Next Century',
            pickHour: 'Pick Hour',
            incrementHour: 'Increment Hour',
            decrementHour: 'Decrement Hour',
            pickMinute: 'Pick Minute',
            incrementMinute: 'Increment Minute',
            decrementMinute: 'Decrement Minute',
            pickSecond: 'Pick Second',
            incrementSecond: 'Increment Second',
            decrementSecond: 'Decrement Second',
            togglePeriod: 'Toggle Period',
            selectTime: 'Select Time'
        },
        useStrict: false,
        sideBySide: false,
        daysOfWeekDisabled: false,
        calendarWeeks: false,
        viewMode: 'days',
        toolbarPlacement: 'default',
        showTodayButton: false,
        showClear: false,
        showClose: false,
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'auto'
        },
        widgetParent: null,
        ignoreReadonly: false,
        keepOpen: false,
        focusOnShow: true,
        inline: false,
        keepInvalid: false,
        datepickerInput: '.datepickerinput',
        keyBinds: {
            up: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(7, 'd'));
                } else {
                    this.date(d.clone().add(this.stepping(), 'm'));
                }
            },
            down: function (widget) {
                if (!widget) {
                    this.show();
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(7, 'd'));
                } else {
                    this.date(d.clone().subtract(this.stepping(), 'm'));
                }
            },
            'control up': function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'y'));
                } else {
                    this.date(d.clone().add(1, 'h'));
                }
            },
            'control down': function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'y'));
                } else {
                    this.date(d.clone().subtract(1, 'h'));
                }
            },
            left: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'd'));
                }
            },
            right: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'd'));
                }
            },
            pageUp: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'M'));
                }
            },
            pageDown: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'M'));
                }
            },
            enter: function () {
                this.hide();
            },
            escape: function () {
                this.hide();
            },
            //tab: function (widget) { //this break the flow of the form. disabling for now
            //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
            //    if(toggle.length > 0) toggle.click();
            //},
            'control space': function (widget) {
                if (!widget) {
                    return;
                }
                if (widget.find('.timepicker').is(':visible')) {
                    widget.find('.btn[data-action="togglePeriod"]').click();
                }
            },
            t: function () {
                this.date(this.getMoment());
            },
            'delete': function () {
                this.clear();
            }
        },
        debug: false,
        allowInputToggle: false,
        disabledTimeIntervals: false,
        disabledHours: false,
        enabledHours: false,
        viewDate: false
    };

    return $.fn.datetimepicker;
}));

},{"jquery":"/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/node_modules/jquery/dist/jquery.js","moment":"/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/node_modules/moment/moment.js"}],"/usr/var/server.base/node_modules/guppy-dev/lib/katex/katex-modified.min.js":[function(require,module,exports){
(function (global){(function (){
(function(e){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=e()}else if(typeof define==="function"&&define.amd){define([],e)}else{var t;if(typeof window!=="undefined"){t=window}else if(typeof global!=="undefined"){t=global}else if(typeof self!=="undefined"){t=self}else{t=this}t.katex=e()}})(function(){var e,t,r;return function e(t,r,a){function n(l,u){if(!r[l]){if(!t[l]){var o=typeof require=="function"&&require;if(!u&&o)return o(l,!0);if(i)return i(l,!0);var s=new Error("Cannot find module '"+l+"'");throw s.code="MODULE_NOT_FOUND",s}var f=r[l]={exports:{}};t[l][0].call(f.exports,function(e){var r=t[l][1][e];return n(r?r:e)},f,f.exports,e,t,r,a)}return r[l].exports}var i=typeof require=="function"&&require;for(var l=0;l<a.length;l++)n(a[l]);return n}({1:[function(e,t,r){"use strict";var a=e("./src/ParseError");var n=h(a);var i=e("./src/Settings");var l=h(i);var u=e("./src/buildTree");var o=h(u);var s=e("./src/parseTree");var f=h(s);var d=e("./src/utils");var c=h(d);function h(e){return e&&e.__esModule?e:{default:e}}var v=function e(t,r,a){c.default.clearNode(r);var n=g(t,a).toNode();r.appendChild(n)};if(typeof document!=="undefined"){if(document.compatMode!=="CSS1Compat"){typeof console!=="undefined"&&console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your "+"website has a suitable doctype.");v=function e(){throw new n.default("KaTeX doesn't work in quirks mode.")}}}var p=function e(t,r){var a=g(t,r).toMarkup();return a};var m=function e(t,r){var a=new l.default(r);return(0,f.default)(t,a)};var g=function e(t,r){var a=new l.default(r);var n=(0,f.default)(t,a);return(0,o.default)(n,t,a)};t.exports={render:v,renderToString:p,__parse:m,__getBuildTree:g,ParseError:n.default}},{"./src/ParseError":84,"./src/Settings":87,"./src/buildTree":94,"./src/parseTree":122,"./src/utils":128}],2:[function(e,t,r){t.exports={default:e("core-js/library/fn/array/from"),__esModule:true}},{"core-js/library/fn/array/from":12}],3:[function(e,t,r){t.exports={default:e("core-js/library/fn/get-iterator"),__esModule:true}},{"core-js/library/fn/get-iterator":13}],4:[function(e,t,r){t.exports={default:e("core-js/library/fn/is-iterable"),__esModule:true}},{"core-js/library/fn/is-iterable":14}],5:[function(e,t,r){t.exports={default:e("core-js/library/fn/json/stringify"),__esModule:true}},{"core-js/library/fn/json/stringify":15}],6:[function(e,t,r){t.exports={default:e("core-js/library/fn/object/define-property"),__esModule:true}},{"core-js/library/fn/object/define-property":16}],7:[function(e,t,r){t.exports={default:e("core-js/library/fn/object/freeze"),__esModule:true}},{"core-js/library/fn/object/freeze":17}],8:[function(e,t,r){"use strict";r.__esModule=true;r.default=function(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}},{}],9:[function(e,t,r){"use strict";r.__esModule=true;var a=e("../core-js/object/define-property");var n=i(a);function i(e){return e&&e.__esModule?e:{default:e}}r.default=function(){function e(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||false;a.configurable=true;if("value"in a)a.writable=true;(0,n.default)(e,a.key,a)}}return function(t,r,a){if(r)e(t.prototype,r);if(a)e(t,a);return t}}()},{"../core-js/object/define-property":6}],10:[function(e,t,r){"use strict";r.__esModule=true;var a=e("../core-js/is-iterable");var n=u(a);var i=e("../core-js/get-iterator");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}r.default=function(){function e(e,t){var r=[];var a=true;var n=false;var i=undefined;try{for(var u=(0,l.default)(e),o;!(a=(o=u.next()).done);a=true){r.push(o.value);if(t&&r.length===t)break}}catch(e){n=true;i=e}finally{try{if(!a&&u["return"])u["return"]()}finally{if(n)throw i}}return r}return function(t,r){if(Array.isArray(t)){return t}else if((0,n.default)(Object(t))){return e(t,r)}else{throw new TypeError("Invalid attempt to destructure non-iterable instance")}}}()},{"../core-js/get-iterator":3,"../core-js/is-iterable":4}],11:[function(e,t,r){"use strict";r.__esModule=true;var a=e("../core-js/array/from");var n=i(a);function i(e){return e&&e.__esModule?e:{default:e}}r.default=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++){r[t]=e[t]}return r}else{return(0,n.default)(e)}}},{"../core-js/array/from":2}],12:[function(e,t,r){e("../../modules/es6.string.iterator");e("../../modules/es6.array.from");t.exports=e("../../modules/_core").Array.from},{"../../modules/_core":24,"../../modules/es6.array.from":73,"../../modules/es6.string.iterator":77}],13:[function(e,t,r){e("../modules/web.dom.iterable");e("../modules/es6.string.iterator");t.exports=e("../modules/core.get-iterator")},{"../modules/core.get-iterator":71,"../modules/es6.string.iterator":77,"../modules/web.dom.iterable":78}],14:[function(e,t,r){e("../modules/web.dom.iterable");e("../modules/es6.string.iterator");t.exports=e("../modules/core.is-iterable")},{"../modules/core.is-iterable":72,"../modules/es6.string.iterator":77,"../modules/web.dom.iterable":78}],15:[function(e,t,r){var a=e("../../modules/_core"),n=a.JSON||(a.JSON={stringify:JSON.stringify});t.exports=function e(t){return n.stringify.apply(n,arguments)}},{"../../modules/_core":24}],16:[function(e,t,r){e("../../modules/es6.object.define-property");var a=e("../../modules/_core").Object;t.exports=function e(t,r,n){return a.defineProperty(t,r,n)}},{"../../modules/_core":24,"../../modules/es6.object.define-property":75}],17:[function(e,t,r){e("../../modules/es6.object.freeze");t.exports=e("../../modules/_core").Object.freeze},{"../../modules/_core":24,"../../modules/es6.object.freeze":76}],18:[function(e,t,r){t.exports=function(e){if(typeof e!="function")throw TypeError(e+" is not a function!");return e}},{}],19:[function(e,t,r){t.exports=function(){}},{}],20:[function(e,t,r){var a=e("./_is-object");t.exports=function(e){if(!a(e))throw TypeError(e+" is not an object!");return e}},{"./_is-object":40}],21:[function(e,t,r){var a=e("./_to-iobject"),n=e("./_to-length"),i=e("./_to-index");t.exports=function(e){return function(t,r,l){var u=a(t),o=n(u.length),s=i(l,o),f;if(e&&r!=r)while(o>s){f=u[s++];if(f!=f)return true}else for(;o>s;s++)if(e||s in u){if(u[s]===r)return e||s||0}return!e&&-1}}},{"./_to-index":62,"./_to-iobject":64,"./_to-length":65}],22:[function(e,t,r){var a=e("./_cof"),n=e("./_wks")("toStringTag"),i=a(function(){return arguments}())=="Arguments";var l=function(e,t){try{return e[t]}catch(e){}};t.exports=function(e){var t,r,u;return e===undefined?"Undefined":e===null?"Null":typeof(r=l(t=Object(e),n))=="string"?r:i?a(t):(u=a(t))=="Object"&&typeof t.callee=="function"?"Arguments":u}},{"./_cof":23,"./_wks":69}],23:[function(e,t,r){var a={}.toString;t.exports=function(e){return a.call(e).slice(8,-1)}},{}],24:[function(e,t,r){var a=t.exports={version:"2.4.0"};if(typeof __e=="number")__e=a},{}],25:[function(e,t,r){"use strict";var a=e("./_object-dp"),n=e("./_property-desc");t.exports=function(e,t,r){if(t in e)a.f(e,t,n(0,r));else e[t]=r}},{"./_object-dp":50,"./_property-desc":56}],26:[function(e,t,r){var a=e("./_a-function");t.exports=function(e,t,r){a(e);if(t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,a){return e.call(t,r,a)};case 3:return function(r,a,n){return e.call(t,r,a,n)}}return function(){return e.apply(t,arguments)}}},{"./_a-function":18}],27:[function(e,t,r){t.exports=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e}},{}],28:[function(e,t,r){t.exports=!e("./_fails")(function(){return Object.defineProperty({},"a",{get:function(){return 7}}).a!=7})},{"./_fails":32}],29:[function(e,t,r){var a=e("./_is-object"),n=e("./_global").document,i=a(n)&&a(n.createElement);t.exports=function(e){return i?n.createElement(e):{}}},{"./_global":33,"./_is-object":40}],30:[function(e,t,r){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},{}],31:[function(e,t,r){var a=e("./_global"),n=e("./_core"),i=e("./_ctx"),l=e("./_hide"),u="prototype";var o=function(e,t,r){var s=e&o.F,f=e&o.G,d=e&o.S,c=e&o.P,h=e&o.B,v=e&o.W,p=f?n:n[t]||(n[t]={}),m=p[u],g=f?a:d?a[t]:(a[t]||{})[u],b,y,x;if(f)r=t;for(b in r){y=!s&&g&&g[b]!==undefined;if(y&&b in p)continue;x=y?g[b]:r[b];p[b]=f&&typeof g[b]!="function"?r[b]:h&&y?i(x,a):v&&g[b]==x?function(e){var t=function(t,r,a){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,a)}return e.apply(this,arguments)};t[u]=e[u];return t}(x):c&&typeof x=="function"?i(Function.call,x):x;if(c){(p.virtual||(p.virtual={}))[b]=x;if(e&o.R&&m&&!m[b])l(m,b,x)}}};o.F=1;o.G=2;o.S=4;o.P=8;o.B=16;o.W=32;o.U=64;o.R=128;t.exports=o},{"./_core":24,"./_ctx":26,"./_global":33,"./_hide":35}],32:[function(e,t,r){t.exports=function(e){try{return!!e()}catch(e){return true}}},{}],33:[function(e,t,r){var a=t.exports=typeof window!="undefined"&&window.Math==Math?window:typeof self!="undefined"&&self.Math==Math?self:Function("return this")();if(typeof __g=="number")__g=a},{}],34:[function(e,t,r){var a={}.hasOwnProperty;t.exports=function(e,t){return a.call(e,t)}},{}],35:[function(e,t,r){var a=e("./_object-dp"),n=e("./_property-desc");t.exports=e("./_descriptors")?function(e,t,r){return a.f(e,t,n(1,r))}:function(e,t,r){e[t]=r;return e}},{"./_descriptors":28,"./_object-dp":50,"./_property-desc":56}],36:[function(e,t,r){t.exports=e("./_global").document&&document.documentElement},{"./_global":33}],37:[function(e,t,r){t.exports=!e("./_descriptors")&&!e("./_fails")(function(){return Object.defineProperty(e("./_dom-create")("div"),"a",{get:function(){return 7}}).a!=7})},{"./_descriptors":28,"./_dom-create":29,"./_fails":32}],38:[function(e,t,r){var a=e("./_cof");t.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return a(e)=="String"?e.split(""):Object(e)}},{"./_cof":23}],39:[function(e,t,r){var a=e("./_iterators"),n=e("./_wks")("iterator"),i=Array.prototype;t.exports=function(e){return e!==undefined&&(a.Array===e||i[n]===e)}},{"./_iterators":46,"./_wks":69}],40:[function(e,t,r){t.exports=function(e){return typeof e==="object"?e!==null:typeof e==="function"}},{}],41:[function(e,t,r){var a=e("./_an-object");t.exports=function(e,t,r,n){try{return n?t(a(r)[0],r[1]):t(r)}catch(t){var i=e["return"];if(i!==undefined)a(i.call(e));throw t}}},{"./_an-object":20}],42:[function(e,t,r){"use strict";var a=e("./_object-create"),n=e("./_property-desc"),i=e("./_set-to-string-tag"),l={};e("./_hide")(l,e("./_wks")("iterator"),function(){return this});t.exports=function(e,t,r){e.prototype=a(l,{next:n(1,r)});i(e,t+" Iterator")}},{"./_hide":35,"./_object-create":49,"./_property-desc":56,"./_set-to-string-tag":58,"./_wks":69}],43:[function(e,t,r){"use strict";var a=e("./_library"),n=e("./_export"),i=e("./_redefine"),l=e("./_hide"),u=e("./_has"),o=e("./_iterators"),s=e("./_iter-create"),f=e("./_set-to-string-tag"),d=e("./_object-gpo"),c=e("./_wks")("iterator"),h=!([].keys&&"next"in[].keys()),v="@@iterator",p="keys",m="values";var g=function(){return this};t.exports=function(e,t,r,b,y,x,w){s(r,t,b);var k=function(e){if(!h&&e in z)return z[e];switch(e){case p:return function t(){return new r(this,e)};case m:return function t(){return new r(this,e)}}return function t(){return new r(this,e)}};var M=t+" Iterator",_=y==m,S=false,z=e.prototype,T=z[c]||z[v]||y&&z[y],C=T||k(y),A=y?!_?C:k("entries"):undefined,O=t=="Array"?z.entries||T:T,N,L,j;if(O){j=d(O.call(new e));if(j!==Object.prototype){f(j,M,true);if(!a&&!u(j,c))l(j,c,g)}}if(_&&T&&T.name!==m){S=true;C=function e(){return T.call(this)}}if((!a||w)&&(h||S||!z[c])){l(z,c,C)}o[t]=C;o[M]=g;if(y){N={values:_?C:k(m),keys:x?C:k(p),entries:A};if(w)for(L in N){if(!(L in z))i(z,L,N[L])}else n(n.P+n.F*(h||S),t,N)}return N}},{"./_export":31,"./_has":34,"./_hide":35,"./_iter-create":42,"./_iterators":46,"./_library":47,"./_object-gpo":52,"./_redefine":57,"./_set-to-string-tag":58,"./_wks":69}],44:[function(e,t,r){var a=e("./_wks")("iterator"),n=false;try{var i=[7][a]();i["return"]=function(){n=true};Array.from(i,function(){throw 2})}catch(e){}t.exports=function(e,t){if(!t&&!n)return false;var r=false;try{var i=[7],l=i[a]();l.next=function(){return{done:r=true}};i[a]=function(){return l};e(i)}catch(e){}return r}},{"./_wks":69}],45:[function(e,t,r){t.exports=function(e,t){return{value:t,done:!!e}}},{}],46:[function(e,t,r){t.exports={}},{}],47:[function(e,t,r){t.exports=true},{}],48:[function(e,t,r){var a=e("./_uid")("meta"),n=e("./_is-object"),i=e("./_has"),l=e("./_object-dp").f,u=0;var o=Object.isExtensible||function(){return true};var s=!e("./_fails")(function(){return o(Object.preventExtensions({}))});var f=function(e){l(e,a,{value:{i:"O"+ ++u,w:{}}})};var d=function(e,t){if(!n(e))return typeof e=="symbol"?e:(typeof e=="string"?"S":"P")+e;if(!i(e,a)){if(!o(e))return"F";if(!t)return"E";f(e)}return e[a].i};var c=function(e,t){if(!i(e,a)){if(!o(e))return true;if(!t)return false;f(e)}return e[a].w};var h=function(e){if(s&&v.NEED&&o(e)&&!i(e,a))f(e);return e};var v=t.exports={KEY:a,NEED:false,fastKey:d,getWeak:c,onFreeze:h}},{"./_fails":32,"./_has":34,"./_is-object":40,"./_object-dp":50,"./_uid":68}],49:[function(e,t,r){var a=e("./_an-object"),n=e("./_object-dps"),i=e("./_enum-bug-keys"),l=e("./_shared-key")("IE_PROTO"),u=function(){},o="prototype";var s=function(){var t=e("./_dom-create")("iframe"),r=i.length,a="<",n=">",l;t.style.display="none";e("./_html").appendChild(t);t.src="javascript:";l=t.contentWindow.document;l.open();l.write(a+"script"+n+"document.F=Object"+a+"/script"+n);l.close();s=l.F;while(r--)delete s[o][i[r]];return s()};t.exports=Object.create||function e(t,r){var i;if(t!==null){u[o]=a(t);i=new u;u[o]=null;i[l]=t}else i=s();return r===undefined?i:n(i,r)}},{"./_an-object":20,"./_dom-create":29,"./_enum-bug-keys":30,"./_html":36,"./_object-dps":51,"./_shared-key":59}],50:[function(e,t,r){var a=e("./_an-object"),n=e("./_ie8-dom-define"),i=e("./_to-primitive"),l=Object.defineProperty;r.f=e("./_descriptors")?Object.defineProperty:function e(t,r,u){a(t);r=i(r,true);a(u);if(n)try{return l(t,r,u)}catch(e){}if("get"in u||"set"in u)throw TypeError("Accessors not supported!");if("value"in u)t[r]=u.value;return t}},{"./_an-object":20,"./_descriptors":28,"./_ie8-dom-define":37,"./_to-primitive":67}],51:[function(e,t,r){var a=e("./_object-dp"),n=e("./_an-object"),i=e("./_object-keys");t.exports=e("./_descriptors")?Object.defineProperties:function e(t,r){n(t);var l=i(r),u=l.length,o=0,s;while(u>o)a.f(t,s=l[o++],r[s]);return t}},{"./_an-object":20,"./_descriptors":28,"./_object-dp":50,"./_object-keys":54}],52:[function(e,t,r){var a=e("./_has"),n=e("./_to-object"),i=e("./_shared-key")("IE_PROTO"),l=Object.prototype;t.exports=Object.getPrototypeOf||function(e){e=n(e);if(a(e,i))return e[i];if(typeof e.constructor=="function"&&e instanceof e.constructor){return e.constructor.prototype}return e instanceof Object?l:null}},{"./_has":34,"./_shared-key":59,"./_to-object":66}],53:[function(e,t,r){var a=e("./_has"),n=e("./_to-iobject"),i=e("./_array-includes")(false),l=e("./_shared-key")("IE_PROTO");t.exports=function(e,t){var r=n(e),u=0,o=[],s;for(s in r)if(s!=l)a(r,s)&&o.push(s);while(t.length>u)if(a(r,s=t[u++])){~i(o,s)||o.push(s)}return o}},{"./_array-includes":21,"./_has":34,"./_shared-key":59,"./_to-iobject":64}],54:[function(e,t,r){var a=e("./_object-keys-internal"),n=e("./_enum-bug-keys");t.exports=Object.keys||function e(t){return a(t,n)}},{"./_enum-bug-keys":30,"./_object-keys-internal":53}],55:[function(e,t,r){var a=e("./_export"),n=e("./_core"),i=e("./_fails");t.exports=function(e,t){var r=(n.Object||{})[e]||Object[e],l={};l[e]=t(r);a(a.S+a.F*i(function(){r(1)}),"Object",l)}},{"./_core":24,"./_export":31,"./_fails":32}],56:[function(e,t,r){t.exports=function(e,t){return{enumerable:!(e&1),configurable:!(e&2),writable:!(e&4),value:t}}},{}],57:[function(e,t,r){t.exports=e("./_hide")},{"./_hide":35}],58:[function(e,t,r){var a=e("./_object-dp").f,n=e("./_has"),i=e("./_wks")("toStringTag");t.exports=function(e,t,r){if(e&&!n(e=r?e:e.prototype,i))a(e,i,{configurable:true,value:t})}},{"./_has":34,"./_object-dp":50,"./_wks":69}],59:[function(e,t,r){var a=e("./_shared")("keys"),n=e("./_uid");t.exports=function(e){return a[e]||(a[e]=n(e))}},{"./_shared":60,"./_uid":68}],60:[function(e,t,r){var a=e("./_global"),n="__core-js_shared__",i=a[n]||(a[n]={});t.exports=function(e){return i[e]||(i[e]={})}},{"./_global":33}],61:[function(e,t,r){var a=e("./_to-integer"),n=e("./_defined");t.exports=function(e){return function(t,r){var i=String(n(t)),l=a(r),u=i.length,o,s;if(l<0||l>=u)return e?"":undefined;o=i.charCodeAt(l);return o<55296||o>56319||l+1===u||(s=i.charCodeAt(l+1))<56320||s>57343?e?i.charAt(l):o:e?i.slice(l,l+2):(o-55296<<10)+(s-56320)+65536}}},{"./_defined":27,"./_to-integer":63}],62:[function(e,t,r){var a=e("./_to-integer"),n=Math.max,i=Math.min;t.exports=function(e,t){e=a(e);return e<0?n(e+t,0):i(e,t)}},{"./_to-integer":63}],63:[function(e,t,r){var a=Math.ceil,n=Math.floor;t.exports=function(e){return isNaN(e=+e)?0:(e>0?n:a)(e)}},{}],64:[function(e,t,r){var a=e("./_iobject"),n=e("./_defined");t.exports=function(e){return a(n(e))}},{"./_defined":27,"./_iobject":38}],65:[function(e,t,r){var a=e("./_to-integer"),n=Math.min;t.exports=function(e){return e>0?n(a(e),9007199254740991):0}},{"./_to-integer":63}],66:[function(e,t,r){var a=e("./_defined");t.exports=function(e){return Object(a(e))}},{"./_defined":27}],67:[function(e,t,r){var a=e("./_is-object");t.exports=function(e,t){if(!a(e))return e;var r,n;if(t&&typeof(r=e.toString)=="function"&&!a(n=r.call(e)))return n;if(typeof(r=e.valueOf)=="function"&&!a(n=r.call(e)))return n;if(!t&&typeof(r=e.toString)=="function"&&!a(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")}},{"./_is-object":40}],68:[function(e,t,r){var a=0,n=Math.random();t.exports=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++a+n).toString(36))}},{}],69:[function(e,t,r){var a=e("./_shared")("wks"),n=e("./_uid"),i=e("./_global").Symbol,l=typeof i=="function";var u=t.exports=function(e){return a[e]||(a[e]=l&&i[e]||(l?i:n)("Symbol."+e))};u.store=a},{"./_global":33,"./_shared":60,"./_uid":68}],70:[function(e,t,r){var a=e("./_classof"),n=e("./_wks")("iterator"),i=e("./_iterators");t.exports=e("./_core").getIteratorMethod=function(e){if(e!=undefined)return e[n]||e["@@iterator"]||i[a(e)]}},{"./_classof":22,"./_core":24,"./_iterators":46,"./_wks":69}],71:[function(e,t,r){var a=e("./_an-object"),n=e("./core.get-iterator-method");t.exports=e("./_core").getIterator=function(e){var t=n(e);if(typeof t!="function")throw TypeError(e+" is not iterable!");return a(t.call(e))}},{"./_an-object":20,"./_core":24,"./core.get-iterator-method":70}],72:[function(e,t,r){var a=e("./_classof"),n=e("./_wks")("iterator"),i=e("./_iterators");t.exports=e("./_core").isIterable=function(e){var t=Object(e);return t[n]!==undefined||"@@iterator"in t||i.hasOwnProperty(a(t))}},{"./_classof":22,"./_core":24,"./_iterators":46,"./_wks":69}],73:[function(e,t,r){"use strict";var a=e("./_ctx"),n=e("./_export"),i=e("./_to-object"),l=e("./_iter-call"),u=e("./_is-array-iter"),o=e("./_to-length"),s=e("./_create-property"),f=e("./core.get-iterator-method");n(n.S+n.F*!e("./_iter-detect")(function(e){Array.from(e)}),"Array",{from:function e(t){var r=i(t),n=typeof this=="function"?this:Array,d=arguments.length,c=d>1?arguments[1]:undefined,h=c!==undefined,v=0,p=f(r),m,g,b,y;if(h)c=a(c,d>2?arguments[2]:undefined,2);if(p!=undefined&&!(n==Array&&u(p))){for(y=p.call(r),g=new n;!(b=y.next()).done;v++){s(g,v,h?l(y,c,[b.value,v],true):b.value)}}else{m=o(r.length);for(g=new n(m);m>v;v++){s(g,v,h?c(r[v],v):r[v])}}g.length=v;return g}})},{"./_create-property":25,"./_ctx":26,"./_export":31,"./_is-array-iter":39,"./_iter-call":41,"./_iter-detect":44,"./_to-length":65,"./_to-object":66,"./core.get-iterator-method":70}],74:[function(e,t,r){"use strict";var a=e("./_add-to-unscopables"),n=e("./_iter-step"),i=e("./_iterators"),l=e("./_to-iobject");t.exports=e("./_iter-define")(Array,"Array",function(e,t){this._t=l(e);this._i=0;this._k=t},function(){var e=this._t,t=this._k,r=this._i++;if(!e||r>=e.length){this._t=undefined;return n(1)}if(t=="keys")return n(0,r);if(t=="values")return n(0,e[r]);return n(0,[r,e[r]])},"values");i.Arguments=i.Array;a("keys");a("values");a("entries")},{"./_add-to-unscopables":19,"./_iter-define":43,"./_iter-step":45,"./_iterators":46,"./_to-iobject":64}],75:[function(e,t,r){var a=e("./_export");a(a.S+a.F*!e("./_descriptors"),"Object",{defineProperty:e("./_object-dp").f})},{"./_descriptors":28,"./_export":31,"./_object-dp":50}],76:[function(e,t,r){var a=e("./_is-object"),n=e("./_meta").onFreeze;e("./_object-sap")("freeze",function(e){return function t(r){return e&&a(r)?e(n(r)):r}})},{"./_is-object":40,"./_meta":48,"./_object-sap":55}],77:[function(e,t,r){"use strict";var a=e("./_string-at")(true);e("./_iter-define")(String,"String",function(e){this._t=String(e);this._i=0},function(){var e=this._t,t=this._i,r;if(t>=e.length)return{value:undefined,done:true};r=a(e,t);this._i+=r.length;return{value:r,done:false}})},{"./_iter-define":43,"./_string-at":61}],78:[function(e,t,r){e("./es6.array.iterator");var a=e("./_global"),n=e("./_hide"),i=e("./_iterators"),l=e("./_wks")("toStringTag");for(var u=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],o=0;o<5;o++){var s=u[o],f=a[s],d=f&&f.prototype;if(d&&!d[l])n(d,l,s);i[s]=i.Array}},{"./_global":33,"./_hide":35,"./_iterators":46,"./_wks":69,"./es6.array.iterator":74}],79:[function(e,t,r){function a(e){if(!e.__matchAtRelocatable){var t=e.source+"|()";var r="g"+(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"");e.__matchAtRelocatable=new RegExp(t,r)}return e.__matchAtRelocatable}function n(e,t,r){if(e.global||e.sticky){throw new Error("matchAt(...): Only non-global regexes are supported")}var n=a(e);n.lastIndex=r;var i=n.exec(t);if(i[i.length-1]==null){i.length=i.length-1;return i}else{return null}}t.exports=n},{}],80:[function(e,t,r){"use strict";var a=Object.getOwnPropertySymbols;var n=Object.prototype.hasOwnProperty;var i=Object.prototype.propertyIsEnumerable;function l(e){if(e===null||e===undefined){throw new TypeError("Object.assign cannot be called with null or undefined")}return Object(e)}function u(){try{if(!Object.assign){return false}var e=new String("abc");e[5]="de";if(Object.getOwnPropertyNames(e)[0]==="5"){return false}var t={};for(var r=0;r<10;r++){t["_"+String.fromCharCode(r)]=r}var a=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if(a.join("")!=="0123456789"){return false}var n={};"abcdefghijklmnopqrst".split("").forEach(function(e){n[e]=e});if(Object.keys(Object.assign({},n)).join("")!=="abcdefghijklmnopqrst"){return false}return true}catch(e){return false}}t.exports=u()?Object.assign:function(e,t){var r;var u=l(e);var o;for(var s=1;s<arguments.length;s++){r=Object(arguments[s]);for(var f in r){if(n.call(r,f)){u[f]=r[f]}}if(a){o=a(r);for(var d=0;d<o.length;d++){if(i.call(r,o[d])){u[o[d]]=r[o[d]]}}}}return u}},{}],81:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.controlWordRegex=undefined;var a=e("babel-runtime/helpers/classCallCheck");var n=v(a);var i=e("babel-runtime/helpers/createClass");var l=v(i);var u=e("match-at");var o=v(u);var s=e("./ParseError");var f=v(s);var d=e("./SourceLocation");var c=v(d);var h=e("./Token");function v(e){return e&&e.__esModule?e:{default:e}}var p="%[^\n]*[\n]";var m="\\\\[a-zA-Z@]+";var g="\\\\[^\ud800-\udfff]";var b=new RegExp("([ \r\n\t]+)|"+("("+p+"|")+"[!-\\[\\]-\u2027\u202a-\ud7ff\uf900-\uffff]"+"|[\ud800-\udbff][\udc00-\udfff]"+"|\\\\verb\\*([^]).*?\\3"+"|\\\\verb([^*a-zA-Z]).*?\\4"+("|"+m)+("|"+g)+")");var y=r.controlWordRegex=new RegExp("^"+m);var x=new RegExp("^"+p);var w=function(){function e(t){(0,n.default)(this,e);this.input=t;this.pos=0}(0,l.default)(e,[{key:"lex",value:function e(){var t=this.input;var r=this.pos;if(r===t.length){return new h.Token("EOF",new c.default(this,r,r))}var a=(0,o.default)(b,t,r);if(a===null){throw new f.default("Unexpected character: '"+t[r]+"'",new h.Token(t[r],new c.default(this,r,r+1)))}var n=a[2]||" ";var i=this.pos;this.pos+=a[0].length;var l=this.pos;if(x.test(n)){return this.lex()}else{return new h.Token(n,new c.default(this,i,l))}}}]);return e}();r.default=w},{"./ParseError":84,"./SourceLocation":88,"./Token":90,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9,"match-at":79}],82:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/toConsumableArray");var n=b(a);var i=e("babel-runtime/helpers/classCallCheck");var l=b(i);var u=e("babel-runtime/helpers/createClass");var o=b(u);var s=e("./Lexer");var f=b(s);var d=e("./Token");var c=e("./macros");var h=b(c);var v=e("./ParseError");var p=b(v);var m=e("object-assign");var g=b(m);function b(e){return e&&e.__esModule?e:{default:e}}var y=function(){function e(t,r){(0,l.default)(this,e);this.lexer=new f.default(t);this.macros=(0,g.default)({},h.default,r);this.stack=[]}(0,o.default)(e,[{key:"future",value:function e(){if(this.stack.length===0){this.pushToken(this.lexer.lex())}return this.stack[this.stack.length-1]}},{key:"popToken",value:function e(){this.future();return this.stack.pop()}},{key:"pushToken",value:function e(t){this.stack.push(t)}},{key:"pushTokens",value:function e(t){var r;(r=this.stack).push.apply(r,(0,n.default)(t))}},{key:"consumeSpaces",value:function e(){for(;;){var t=this.future();if(t.text===" "){this.stack.pop()}else{break}}}},{key:"consumeArgs",value:function e(t){var r=[];for(var a=0;a<t;++a){this.consumeSpaces();var n=this.popToken();if(n.text==="{"){var i=[];var l=1;while(l!==0){var u=this.popToken();i.push(u);if(u.text==="{"){++l}else if(u.text==="}"){--l}else if(u.text==="EOF"){throw new p.default("End of input in macro argument",n)}}i.pop();i.reverse();r[a]=i}else if(n.text==="EOF"){throw new p.default("End of input expecting macro argument")}else{r[a]=[n]}}return r}},{key:"expandOnce",value:function e(){var t=this.popToken();var r=t.text;var a=r.charAt(0)==="\\";if(a&&s.controlWordRegex.test(r)){this.consumeSpaces()}if(!this.macros.hasOwnProperty(r)){this.pushToken(t);return t}var i=this._getExpansion(r),l=i.tokens,u=i.numArgs;var o=l;if(u){var f=this.consumeArgs(u);o=o.slice();for(var d=o.length-1;d>=0;--d){var c=o[d];if(c.text==="#"){if(d===0){throw new p.default("Incomplete placeholder at end of macro body",c)}c=o[--d];if(c.text==="#"){o.splice(d+1,1)}else if(/^[1-9]$/.test(c.text)){var h;(h=o).splice.apply(h,[d,2].concat((0,n.default)(f[+c.text-1])))}else{throw new p.default("Not a valid argument number",c)}}}}this.pushTokens(o);return o}},{key:"expandAfterFuture",value:function e(){this.expandOnce();return this.future()}},{key:"expandNextToken",value:function e(){for(;;){var t=this.expandOnce();if(t instanceof d.Token){if(t.text==="\\relax"){this.stack.pop()}else{return this.stack.pop()}}}throw new Error}},{key:"_getExpansion",value:function e(t){var r=this.macros[t];var a=typeof r==="function"?r(this):r;if(typeof a==="string"){var n=0;if(a.indexOf("#")!==-1){var i=a.replace(/##/g,"");while(i.indexOf("#"+(n+1))!==-1){++n}}var l=new f.default(a);var u=[];var o=l.lex();while(o.text!=="EOF"){u.push(o);o=l.lex()}u.reverse();var s={tokens:u,numArgs:n};if(typeof r!=="function"){this.macros[t]=s}return s}return a}}]);return e}();r.default=y},{"./Lexer":81,"./ParseError":84,"./Token":90,"./macros":120,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9,"babel-runtime/helpers/toConsumableArray":11,"object-assign":80}],83:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=s(a);var i=e("babel-runtime/helpers/createClass");var l=s(i);var u=e("./fontMetrics");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=[[1,1,1],[2,1,1],[3,1,1],[4,2,1],[5,2,1],[6,3,1],[7,4,2],[8,6,3],[9,7,6],[10,8,7],[11,10,9]];var d=[.5,.6,.7,.8,.9,1,1.2,1.44,1.728,2.074,2.488];var c=function e(t,r){return r.size<2?t:f[t-1][r.size-1]};var h=function(){function e(t){(0,n.default)(this,e);this.style=t.style;this.color=t.color;this.size=t.size||e.BASESIZE;this.textSize=t.textSize||this.size;this.phantom=!!t.phantom;this.fontFamily=t.fontFamily;this.fontWeight=t.fontWeight||"";this.fontShape=t.fontShape||"";this.sizeMultiplier=d[this.size-1];this.maxSize=t.maxSize;this._fontMetrics=undefined}(0,l.default)(e,[{key:"extend",value:function t(r){var a={style:this.style,size:this.size,textSize:this.textSize,color:this.color,phantom:this.phantom,fontFamily:this.fontFamily,fontWeight:this.fontWeight,fontShape:this.fontShape,maxSize:this.maxSize};for(var n in r){if(r.hasOwnProperty(n)){a[n]=r[n]}}return new e(a)}},{key:"havingStyle",value:function e(t){if(this.style===t){return this}else{return this.extend({style:t,size:c(this.textSize,t)})}}},{key:"havingCrampedStyle",value:function e(){return this.havingStyle(this.style.cramp())}},{key:"havingSize",value:function e(t){if(this.size===t&&this.textSize===t){return this}else{return this.extend({style:this.style.text(),size:t,textSize:t})}}},{key:"havingBaseStyle",value:function t(r){r=r||this.style.text();var a=c(e.BASESIZE,r);if(this.size===a&&this.textSize===e.BASESIZE&&this.style===r){return this}else{return this.extend({style:r,size:a})}}},{key:"withColor",value:function e(t){return this.extend({color:t})}},{key:"withPhantom",value:function e(){return this.extend({phantom:true})}},{key:"withFontFamily",value:function e(t){return this.extend({fontFamily:t||this.fontFamily})}},{key:"withFontWeight",value:function e(t){return this.extend({fontWeight:t})}},{key:"withFontShape",value:function e(t){return this.extend({fontShape:t})}},{key:"sizingClasses",value:function e(t){if(t.size!==this.size){return["sizing","reset-size"+t.size,"size"+this.size]}else{return[]}}},{key:"baseSizingClasses",value:function t(){if(this.size!==e.BASESIZE){return["sizing","reset-size"+this.size,"size"+e.BASESIZE]}else{return[]}}},{key:"fontMetrics",value:function e(){if(!this._fontMetrics){this._fontMetrics=o.default.getFontMetrics(this.size)}return this._fontMetrics}},{key:"getColor",value:function t(){if(this.phantom){return"transparent"}else if(this.color!=null&&e.colorMap.hasOwnProperty(this.color)){return e.colorMap[this.color]}else{return this.color}}}]);return e}();h.BASESIZE=6;h.colorMap={"katex-blue":"#6495ed","katex-orange":"#ffa500","katex-pink":"#ff00af","katex-red":"#df0030","katex-green":"#28ae7b","katex-gray":"gray","katex-purple":"#9d38bd","katex-blueA":"#ccfaff","katex-blueB":"#80f6ff","katex-blueC":"#63d9ea","katex-blueD":"#11accd","katex-blueE":"#0c7f99","katex-tealA":"#94fff5","katex-tealB":"#26edd5","katex-tealC":"#01d1c1","katex-tealD":"#01a995","katex-tealE":"#208170","katex-greenA":"#b6ffb0","katex-greenB":"#8af281","katex-greenC":"#74cf70","katex-greenD":"#1fab54","katex-greenE":"#0d923f","katex-goldA":"#ffd0a9","katex-goldB":"#ffbb71","katex-goldC":"#ff9c39","katex-goldD":"#e07d10","katex-goldE":"#a75a05","katex-redA":"#fca9a9","katex-redB":"#ff8482","katex-redC":"#f9685d","katex-redD":"#e84d39","katex-redE":"#bc2612","katex-maroonA":"#ffbde0","katex-maroonB":"#ff92c6","katex-maroonC":"#ed5fa6","katex-maroonD":"#ca337c","katex-maroonE":"#9e034e","katex-purpleA":"#ddd7ff","katex-purpleB":"#c6b9fc","katex-purpleC":"#aa87ff","katex-purpleD":"#7854ab","katex-purpleE":"#543b78","katex-mintA":"#f5f9e8","katex-mintB":"#edf2df","katex-mintC":"#e0e5cc","katex-grayA":"#f6f7f7","katex-grayB":"#f0f1f2","katex-grayC":"#e3e5e6","katex-grayD":"#d6d8da","katex-grayE":"#babec2","katex-grayF":"#888d93","katex-grayG":"#626569","katex-grayH":"#3b3e40","katex-grayI":"#21242c","katex-kaBlue":"#314453","katex-kaGreen":"#71B307"};r.default=h},{"./fontMetrics":101,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9
}],84:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=o(a);var i=e("./ParseNode");var l=o(i);var u=e("./Token");function o(e){return e&&e.__esModule?e:{default:e}}var s=function e(t,r){(0,n.default)(this,e);var a="KaTeX parse error: "+t;var i=void 0;var l=r&&r.loc;if(l&&l.start<=l.end){var u=l.lexer.input;i=l.start;var o=l.end;if(i===u.length){a+=" at end of input: "}else{a+=" at position "+(i+1)+": "}var s=u.slice(i,o).replace(/[^]/g,"$&\u0332");var f=void 0;if(i>15){f="\u2026"+u.slice(i-15,i)}else{f=u.slice(0,i)}var d=void 0;if(o+15<u.length){d=u.slice(o,o+15)+"\u2026"}else{d=u.slice(o)}a+=f+s+d}var c=new Error(a);c.name="ParseError";c.__proto__=e.prototype;c.position=i;return c};s.prototype.__proto__=Error.prototype;r.default=s},{"./ParseNode":85,"./Token":90,"babel-runtime/helpers/classCallCheck":8}],85:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=o(a);var i=e("./Token");var l=e("./SourceLocation");var u=o(l);function o(e){return e&&e.__esModule?e:{default:e}}var s=function e(t,r,a,i,l){(0,n.default)(this,e);this.type=t;this.value=r;this.mode=a;this.loc=u.default.range(i,l)};r.default=s},{"./SourceLocation":88,"./Token":90,"babel-runtime/helpers/classCallCheck":8}],86:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=M(a);var i=e("babel-runtime/helpers/createClass");var l=M(i);var u=e("./functions");var o=M(u);var s=e("./environments");var f=M(s);var d=e("./MacroExpander");var c=M(d);var h=e("./symbols");var v=M(h);var p=e("./utils");var m=M(p);var g=e("./units");var b=e("./unicodeRegexes");var y=e("./ParseNode");var x=M(y);var w=e("./ParseError");var k=M(w);function M(e){return e&&e.__esModule?e:{default:e}}function _(e,t){return{type:"arg",result:e,token:t}}function S(e){return{type:"fn",result:e.text,token:e}}function z(e){return{type:"$",result:"$",token:e}}function T(e){if(e.type==="$"){throw new k.default("Unexpected $",e.token)}return e}var C=function(){function e(t,r){(0,n.default)(this,e);this.gullet=new c.default(t,r.macros);if(r.colorIsTextColor){this.gullet.macros["\\color"]="\\textcolor"}this.settings=r;this.leftrightDepth=0}(0,l.default)(e,[{key:"expect",value:function e(t,r){if(this.nextToken.text!==t){throw new k.default("Expected '"+t+"', got '"+this.nextToken.text+"'",this.nextToken)}if(r!==false){this.consume()}}},{key:"consume",value:function e(){this.nextToken=this.gullet.expandNextToken()}},{key:"switchMode",value:function e(t){this.mode=t}},{key:"parse",value:function e(){this.mode="math";this.consume();var e=this.parseInput();return e}},{key:"parseInput",value:function e(){var t=this.parseExpression(false);this.expect("EOF",false);return t}},{key:"parseExpression",value:function t(r,a){var n=[];while(true){if(this.mode==="math"){this.consumeSpaces()}var i=this.nextToken;if(e.endOfExpression.indexOf(i.text)!==-1){break}if(a&&i.text===a){break}if(r&&o.default[i.text]&&o.default[i.text].infix){break}var l=this.parseAtom(a);if(!l){if(!this.settings.throwOnError&&i.text[0]==="\\"){var u=this.handleUnsupportedCmd();n.push(u);continue}break}n.push(l)}return this.handleInfixNodes(n)}},{key:"handleInfixNodes",value:function e(t){var r=-1;var a=void 0;for(var n=0;n<t.length;n++){var i=t[n];if(i.type==="infix"){if(r!==-1){throw new k.default("only one infix operator per group",i.value.token)}r=n;a=i.value.replaceWith}}if(r!==-1){var l=void 0;var u=void 0;var o=t.slice(0,r);var s=t.slice(r+1);if(o.length===1&&o[0].type==="ordgroup"){l=o[0]}else{l=new x.default("ordgroup",o,this.mode)}if(s.length===1&&s[0].type==="ordgroup"){u=s[0]}else{u=new x.default("ordgroup",s,this.mode)}var f=this.callFunction(a,[l,u],[]);return[new x.default(f.type,f,this.mode)]}else{return t}}},{key:"handleSupSubscript",value:function t(r){var a=this.nextToken;var n=a.text;this.consume();this.consumeSpaces();var i=this.parseGroup();if(!i){if(!this.settings.throwOnError&&this.nextToken.text[0]==="\\"){return this.handleUnsupportedCmd()}else{throw new k.default("Expected group after '"+n+"'",a)}}var l=T(i);if(l.type==="fn"){var u=o.default[i.result].greediness;if(u>e.SUPSUB_GREEDINESS){return this.parseGivenFunction(i)}else{throw new k.default("Got function '"+i.result+"' with no arguments "+"as "+r,a)}}else{return i.result}}},{key:"handleUnsupportedCmd",value:function e(){var t=this.nextToken.text;var r=[];for(var a=0;a<t.length;a++){r.push(new x.default("textord",t[a],"text"))}var n=new x.default("text",{body:r,type:"text"},this.mode);var i=new x.default("color",{color:this.settings.errorColor,value:[n],type:"color"},this.mode);this.consume();return i}},{key:"parseAtom",value:function e(t){var r=this.parseImplicitGroup(t);if(this.mode==="text"){return r}var a=void 0;var n=void 0;while(true){this.consumeSpaces();var i=this.nextToken;if(i.text==="\\limits"||i.text==="\\nolimits"){if(!r||r.type!=="op"){throw new k.default("Limit controls must follow a math operator",i)}else{var l=i.text==="\\limits";r.value.limits=l;r.value.alwaysHandleSupSub=true}this.consume()}else if(i.text==="^"){if(a){throw new k.default("Double superscript",i)}a=this.handleSupSubscript("superscript")}else if(i.text==="_"){if(n){throw new k.default("Double subscript",i)}n=this.handleSupSubscript("subscript")}else if(i.text==="'"){if(a){throw new k.default("Double superscript",i)}var u=new x.default("textord","\\prime",this.mode);var o=[u];this.consume();while(this.nextToken.text==="'"){o.push(u);this.consume()}if(this.nextToken.text==="^"){o.push(this.handleSupSubscript("superscript"))}a=new x.default("ordgroup",o,this.mode)}else{break}}if(a||n){return new x.default("supsub",{base:r,sup:a,sub:n},this.mode)}else{return r}}},{key:"parseImplicitGroup",value:function t(r){var a=this.parseSymbol();if(a==null){return this.parseFunction()}var n=a.result;if(n==="\\left"){var i=this.parseGivenFunction(a);++this.leftrightDepth;var l=this.parseExpression(false);--this.leftrightDepth;this.expect("\\right",false);var u=this.parseFunction();return new x.default("leftright",{body:l,left:i.value.value,right:u.value.value},this.mode)}else if(n==="\\begin"){var o=this.parseGivenFunction(a);var s=o.value.name;if(!f.default.has(s)){throw new k.default("No such environment: "+s,o.value.nameGroup)}var d=f.default.get(s);var c=this.parseArguments("\\begin{"+s+"}",d),h=c.args,v=c.optArgs;var p={mode:this.mode,envName:s,parser:this};var g=d.handler(p,h,v);this.expect("\\end",false);var b=this.nextToken;var y=this.parseFunction();if(y.value.name!==s){throw new k.default("Mismatch: \\begin{"+s+"} matched "+"by \\end{"+y.value.name+"}",b)}g.position=y.position;return g}else if(m.default.contains(e.sizeFuncs,n)){this.consumeSpaces();var w=this.parseExpression(false,r);return new x.default("sizing",{size:m.default.indexOf(e.sizeFuncs,n)+1,value:w},this.mode)}else if(m.default.contains(e.styleFuncs,n)){this.consumeSpaces();var M=this.parseExpression(true,r);return new x.default("styling",{style:n.slice(1,n.length-5),value:M},this.mode)}else if(n in e.oldFontFuncs){var _=e.oldFontFuncs[n];this.consumeSpaces();var S=this.parseExpression(true,r);if(_.slice(0,4)==="text"){return new x.default("text",{style:_,body:new x.default("ordgroup",S,this.mode)},this.mode)}else{return new x.default("font",{font:_,body:new x.default("ordgroup",S,this.mode)},this.mode)}}else if(n==="\\color"){var z=this.parseColorGroup(false);if(!z){throw new k.default("\\color not followed by color")}var T=this.parseExpression(true,r);return new x.default("color",{type:"color",color:z.result.value,value:T},this.mode)}else if(n==="$"){if(this.mode==="math"){throw new k.default("$ within math mode")}this.consume();var C=this.mode;this.switchMode("math");var A=this.parseExpression(false,"$");this.expect("$",true);this.switchMode(C);return new x.default("styling",{style:"text",value:A},"math")}else{return this.parseGivenFunction(a)}}},{key:"parseFunction",value:function e(){var t=this.parseGroup();return t?this.parseGivenFunction(t):null}},{key:"parseGivenFunction",value:function e(t){t=T(t);if(t.type==="fn"){var r=t.result;var a=o.default[r];if(this.mode==="text"&&!a.allowedInText){throw new k.default("Can't use function '"+r+"' in text mode",t.token)}else if(this.mode==="math"&&a.allowedInMath===false){throw new k.default("Can't use function '"+r+"' in math mode",t.token)}var n=this.parseArguments(r,a),i=n.args,l=n.optArgs;var u=t.token;var s=this.callFunction(r,i,l,u);return new x.default(s.type,s,this.mode)}else{return t.result}}},{key:"callFunction",value:function e(t,r,a,n){var i={funcName:t,parser:this,token:n};return o.default[t].handler(i,r,a)}},{key:"parseArguments",value:function e(t,r){var a=r.numArgs+r.numOptionalArgs;if(a===0){return{args:[],optArgs:[]}}var n=r.greediness;var i=[];var l=[];for(var u=0;u<a;u++){var s=r.argTypes&&r.argTypes[u];var f=u<r.numOptionalArgs;if(u>0&&!f){this.consumeSpaces()}if(u===0&&!f&&this.mode==="math"){this.consumeSpaces()}var d=this.nextToken;var c=s?this.parseGroupOfType(s,f):this.parseGroup(f);if(!c){if(f){l.push(null);continue}if(!this.settings.throwOnError&&this.nextToken.text[0]==="\\"){c=_(this.handleUnsupportedCmd(),d)}else{throw new k.default("Expected group after '"+t+"'",d)}}var h=void 0;c=T(c);if(c.type==="fn"){var v=o.default[c.result].greediness;if(v>n){h=this.parseGivenFunction(c)}else{throw new k.default("Got function '"+c.result+"' as "+"argument to '"+t+"'",d)}}else{h=c.result}(f?l:i).push(h)}return{args:i,optArgs:l}}},{key:"parseGroupOfType",value:function e(t,r){var a=this.mode;if(t==="original"){t=a}if(t==="color"){return this.parseColorGroup(r)}if(t==="size"){return this.parseSizeGroup(r)}if(t==="string"){var n=this.parseStringGroup("string",r);return new _(n.text,false)}if(t==="url"){return this.parseUrlGroup(r)}this.switchMode(t);var i=this.parseGroup(r);this.switchMode(a);return i}},{key:"consumeSpaces",value:function e(){while(this.nextToken.text===" "){this.consume()}}},{key:"parseStringGroup",value:function e(t,r){if(r&&this.nextToken.text!=="["){return null}var a=this.mode;this.mode="text";this.expect(r?"[":"{");var n="";var i=this.nextToken;var l=i;while(this.nextToken.text!==(r?"]":"}")){if(this.nextToken.text==="EOF"){throw new k.default("Unexpected end of input in "+t,i.range(this.nextToken,n))}l=this.nextToken;n+=l.text;this.consume()}this.mode=a;this.expect(r?"]":"}");return i.range(l,n)}},{key:"parseStringGroupWithBalancedBraces",value:function e(t,r){if(r&&this.nextToken.text!=="["){return null}var a=this.mode;this.mode="text";this.expect(r?"[":"{");var n="";var i=0;var l=this.nextToken;var u=l;while(i>0||this.nextToken.text!==(r?"]":"}")){if(this.nextToken.text==="EOF"){throw new k.default("Unexpected end of input in "+t,l.range(this.nextToken,n))}u=this.nextToken;n+=u.text;if(u.text==="{"){i+=1}else if(u.text==="}"){if(i<=0){throw new k.default("Unbalanced brace of input in "+t,l.range(this.nextToken,n))}else{i-=1}}this.consume()}this.mode=a;this.expect(r?"]":"}");return l.range(u,n)}},{key:"parseRegexGroup",value:function e(t,r){var a=this.mode;this.mode="text";var n=this.nextToken;var i=n;var l="";while(this.nextToken.text!=="EOF"&&t.test(l+this.nextToken.text)){i=this.nextToken;l+=i.text;this.consume()}if(l===""){throw new k.default("Invalid "+r+": '"+n.text+"'",n)}this.mode=a;return n.range(i,l)}},{key:"parseColorGroup",value:function e(t){var r=this.parseStringGroup("color",t);if(!r){return null}var a=/^(#[a-f0-9]{3}|#[a-f0-9]{6}|[a-z]+)$/i.exec(r.text);if(!a){throw new k.default("Invalid color: '"+r.text+"'",r)}return _(new x.default("color",a[0],this.mode),r)}},{key:"parseUrlGroup",value:function e(t){var r=this.parseStringGroupWithBalancedBraces("url",t);if(!r){return null}var a=r.text;var n=a.replace(/\\([#$%&~_^{}])/g,"$1");return _(new x.default("url",n,this.mode),r)}},{key:"parseSizeGroup",value:function e(t){var r=void 0;if(!t&&this.nextToken.text!=="{"){r=this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/,"size")}else{r=this.parseStringGroup("size",t)}if(!r){return null}var a=/([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(r.text);if(!a){throw new k.default("Invalid size: '"+r.text+"'",r)}var n={number:+(a[1]+a[2]),unit:a[3]};if(!(0,g.validUnit)(n)){throw new k.default("Invalid unit: '"+n.unit+"'",r)}return _(new x.default("size",n,this.mode),r)}},{key:"parseGroup",value:function e(t){var r=this.nextToken;if(this.nextToken.text===(t?"[":"{")){this.consume();var a=this.parseExpression(false,t?"]":"}");var n=this.nextToken;this.expect(t?"]":"}");if(this.mode==="text"){this.formLigatures(a)}return _(new x.default("ordgroup",a,this.mode,r,n),r.range(n,r.text))}else{return t?null:this.parseSymbol()}}},{key:"formLigatures",value:function e(t){var r=t.length-1;for(var a=0;a<r;++a){var n=t[a];var i=n.value;if(i==="-"&&t[a+1].value==="-"){if(a+1<r&&t[a+2].value==="-"){t.splice(a,3,new x.default("textord","---","text",n,t[a+2]));r-=2}else{t.splice(a,2,new x.default("textord","--","text",n,t[a+1]));r-=1}}if((i==="'"||i==="`")&&t[a+1].value===i){t.splice(a,2,new x.default("textord",i+i,"text",n,t[a+1]));r-=1}}}},{key:"parseSymbol",value:function e(){var t=this.nextToken;if(o.default[t.text]){this.consume();return S(t)}else if(v.default[this.mode][t.text]){this.consume();return _(new x.default(v.default[this.mode][t.text].group,t.text,this.mode,t),t)}else if(this.mode==="text"&&b.cjkRegex.test(t.text)){this.consume();return _(new x.default("textord",t.text,this.mode,t),t)}else if(t.text==="$"){return z(t)}else if(/^\\verb[^a-zA-Z]/.test(t.text)){this.consume();var r=t.text.slice(5);var a=r.charAt(0)==="*";if(a){r=r.slice(1)}if(r.length<2||r.charAt(0)!==r.slice(-1)){throw new k.default("\\verb assertion failed --\n                    please report what input caused this bug")}r=r.slice(1,-1);return _(new x.default("verb",{body:r,star:a},"text"),t)}else{return null}}}]);return e}();C.endOfExpression=["}","\\end","\\right","&","\\\\","\\cr"];C.SUPSUB_GREEDINESS=1;C.sizeFuncs=["\\tiny","\\sixptsize","\\scriptsize","\\footnotesize","\\small","\\normalsize","\\large","\\Large","\\LARGE","\\huge","\\Huge"];C.styleFuncs=["\\displaystyle","\\textstyle","\\scriptstyle","\\scriptscriptstyle"];C.oldFontFuncs={"\\rm":"mathrm","\\sf":"mathsf","\\tt":"mathtt","\\bf":"mathbf","\\it":"mathit"};r.default=C},{"./MacroExpander":82,"./ParseError":84,"./ParseNode":85,"./environments":99,"./functions":103,"./symbols":125,"./unicodeRegexes":126,"./units":127,"./utils":128,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],87:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=u(a);var i=e("./utils");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o=function e(t){(0,n.default)(this,e);t=t||{};this.displayMode=l.default.deflt(t.displayMode,false);this.throwOnError=l.default.deflt(t.throwOnError,true);this.errorColor=l.default.deflt(t.errorColor,"#cc0000");this.macros=t.macros||{};this.colorIsTextColor=l.default.deflt(t.colorIsTextColor,false);this.maxSize=Math.max(0,l.default.deflt(t.maxSize,Infinity))};r.default=o},{"./utils":128,"babel-runtime/helpers/classCallCheck":8}],88:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/object/freeze");var n=s(a);var i=e("babel-runtime/helpers/classCallCheck");var l=s(i);var u=e("babel-runtime/helpers/createClass");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=function(){function e(t,r,a){(0,l.default)(this,e);this.lexer=t;this.start=r;this.end=a;(0,n.default)(this)}(0,o.default)(e,null,[{key:"range",value:function t(r,a){if(!a){return r&&r.loc}else if(!r||!r.loc||!a.loc||r.loc.lexer!==a.loc.lexer){return null}else{return new e(r.loc.lexer,r.loc.start,a.loc.end)}}}]);return e}();r.default=f},{"babel-runtime/core-js/object/freeze":7,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],89:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/classCallCheck");var n=u(a);var i=e("babel-runtime/helpers/createClass");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o=function(){function e(t,r,a){(0,n.default)(this,e);this.id=t;this.size=r;this.cramped=a}(0,l.default)(e,[{key:"sup",value:function e(){return g[b[this.id]]}},{key:"sub",value:function e(){return g[y[this.id]]}},{key:"fracNum",value:function e(){return g[x[this.id]]}},{key:"fracDen",value:function e(){return g[w[this.id]]}},{key:"cramp",value:function e(){return g[k[this.id]]}},{key:"text",value:function e(){return g[M[this.id]]}},{key:"isTight",value:function e(){return this.size>=2}}]);return e}();var s=0;var f=1;var d=2;var c=3;var h=4;var v=5;var p=6;var m=7;var g=[new o(s,0,false),new o(f,0,true),new o(d,1,false),new o(c,1,true),new o(h,2,false),new o(v,2,true),new o(p,3,false),new o(m,3,true)];var b=[h,v,h,v,p,m,p,m];var y=[v,v,v,v,m,m,m,m];var x=[d,c,h,v,p,m,p,m];var w=[c,c,v,v,m,m,m,m];var k=[f,f,c,c,v,v,m,m];var M=[s,f,d,c,d,c,d,c];r.default={DISPLAY:g[s],TEXT:g[d],SCRIPT:g[h],SCRIPTSCRIPT:g[p]}},{"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],90:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.Token=undefined;var a=e("babel-runtime/helpers/classCallCheck");var n=s(a);var i=e("babel-runtime/helpers/createClass");var l=s(i);var u=e("./SourceLocation");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=r.Token=function(){function e(t,r){(0,n.default)(this,e);this.text=t;this.loc=r}(0,l.default)(e,[{key:"range",value:function t(r,a){return new e(a,o.default.range(this,r))}}]);return e}()},{"./SourceLocation":88,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],91:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/get-iterator");var n=p(a);var i=e("./domTree");var l=p(i);var u=e("./fontMetrics");var o=p(u);var s=e("./symbols");var f=p(s);var d=e("./utils");var c=p(d);var h=e("./stretchy");var v=p(h);function p(e){return e&&e.__esModule?e:{default:e}}var m=["\\imath","\\jmath","\\pounds"];var g=function e(t,r,a){if(f.default[a][t]&&f.default[a][t].replace){t=f.default[a][t].replace}return{value:t,metrics:o.default.getCharacterMetrics(t,r)}};var b=function e(t,r,a,n,i){var u=g(t,r,a);var o=u.metrics;t=u.value;var s=void 0;if(o){var f=o.italic;if(a==="text"){f=0}s=new l.default.symbolNode(t,o.height,o.depth,f,o.skew,i)}else{typeof console!=="undefined"&&console.warn("No character metrics for '"+t+"' in style '"+r+"'");s=new l.default.symbolNode(t,0,0,0,0,i)}if(n){s.maxFontSize=n.sizeMultiplier;if(n.style.isTight()){s.classes.push("mtight")}var d=n.getColor();if(d){s.style.color=d}}return s};var y=function e(t,r,a){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];if(a&&a.fontFamily&&a.fontFamily==="boldsymbol"&&g(t,"Main-Bold",r).metrics){return b(t,"Main-Bold",r,a,n.concat(["mathbf"]))}else if(t==="\\"||f.default[r][t].font==="main"){return b(t,"Main-Regular",r,a,n)}else{return b(t,"AMS-Regular",r,a,n.concat(["amsrm"]))}};var x=function e(t,r,a,n,i){if(i==="mathord"){var l=w(t,r,a,n);return b(t,l.fontName,r,a,n.concat([l.fontClass]))}else if(i==="textord"){var u=f.default[r][t]&&f.default[r][t].font;if(u==="ams"){var o=E("amsrm",a.fontWeight,a.fontShape);return b(t,o,r,a,n.concat("amsrm",a.fontWeight,a.fontShape))}else{var s=E("textrm",a.fontWeight,a.fontShape);return b(t,s,r,a,n.concat(a.fontWeight,a.fontShape))}}else{throw new Error("unexpected type: "+i+" in mathDefault")}};var w=function e(t,r,a,n){if(/[0-9]/.test(t.charAt(0))||c.default.contains(m,t)){return{fontName:"Main-Italic",fontClass:"mainit"}}else{return{fontName:"Math-Italic",fontClass:"mathit"}}};var k=function e(t,r,a,n){if(g(t,"Math-BoldItalic",r).metrics){return{fontName:"Math-BoldItalic",fontClass:"boldsymbol"}}else{return{fontName:"Main-Bold",fontClass:"mathbf"}}};var M=function e(t,r,a){var n=t.mode;var i=t.value;var l=["mord"];var u=r.fontFamily;if(u){var o=void 0;var s=void 0;if(u==="boldsymbol"){var f=k(i,n,r,l);o=f.fontName;s=[f.fontClass]}else if(u==="mathit"||c.default.contains(m,i)){var d=w(i,n,r,l);o=d.fontName;s=[d.fontClass]}else if(u.includes("math")||n==="math"){o=F[u].fontName;s=[u]}else{o=E(u,r.fontWeight,r.fontShape);s=[u,r.fontWeight,r.fontShape]}if(g(i,o,n).metrics){return b(i,o,n,r,l.concat(s))}else{return x(i,n,r,l,a)}}else{return x(i,n,r,l,a)}};var _=function e(t){for(var r=0;r<t.length-1;r++){if(t[r].tryCombine(t[r+1])){t.splice(r+1,1);r--}}return t};var S=function e(t){var r=0;var a=0;var i=0;var l=true;var u=false;var o=undefined;try{for(var s=(0,n.default)(t.children),f;!(l=(f=s.next()).done);l=true){var d=f.value;if(d.height>r){r=d.height}if(d.depth>a){a=d.depth}if(d.maxFontSize>i){i=d.maxFontSize}}}catch(e){u=true;o=e}finally{try{if(!l&&s.return){s.return()}}finally{if(u){throw o}}}t.height=r;t.depth=a;t.maxFontSize=i};var z=function e(t,r,a){var n=new l.default.span(t,r,a);S(n);return n};var T=function e(t,r){var a=v.default.ruleSpan(t,r);a.height=r.fontMetrics().defaultRuleThickness;a.style.height=a.height+"em";a.maxFontSize=1;return a};var C=function e(t,r,a,n){var i=new l.default.anchor(t,r,a,n);S(i);return i};var A=function e(t,r){t.children=r.concat(t.children);S(t)};var O=function e(t,r){var a=new l.default.documentFragment(t,r);S(a);return a};var N=function e(t){if(t.positionType==="individualShift"){var r=t.children;var a=[r[0]];var i=-r[0].shift-r[0].elem.depth;var l=i;for(var u=1;u<r.length;u++){var o=-r[u].shift-l-r[u].elem.depth;var s=o-(r[u-1].elem.height+r[u-1].elem.depth);l=l+o;a.push({type:"kern",size:s});a.push(r[u])}return{children:a,depth:i}}var f=void 0;if(t.positionType==="top"){var d=t.positionData;var c=true;var h=false;var v=undefined;try{for(var p=(0,n.default)(t.children),m;!(c=(m=p.next()).done);c=true){var g=m.value;d-=g.type==="kern"?g.size:g.elem.height+g.elem.depth}}catch(e){h=true;v=e}finally{try{if(!c&&p.return){p.return()}}finally{if(h){throw v}}}f=d}else if(t.positionType==="bottom"){f=-t.positionData}else{var b=t.children[0];if(b.type!=="elem"){throw new Error('First child must have type "elem".')}if(t.positionType==="shift"){f=-b.elem.depth-t.positionData}else if(t.positionType==="firstBaseline"){f=-b.elem.depth}else{throw new Error("Invalid positionType "+t.positionType+".")}}return{children:t.children,depth:f}};var L=function e(t,r){var a=N(t),i=a.children,u=a.depth;var o=0;var s=true;var f=false;var d=undefined;try{for(var c=(0,n.default)(i),h;!(s=(h=c.next()).done);s=true){var v=h.value;if(v.type==="elem"){var p=v.elem;o=Math.max(o,p.maxFontSize,p.height)}}}catch(e){f=true;d=e}finally{try{if(!s&&c.return){c.return()}}finally{if(f){throw d}}}o+=2;var m=z(["pstrut"],[]);m.style.height=o+"em";var g=[];var b=u;var y=u;var x=u;var w=true;var k=false;var M=undefined;try{for(var _=(0,n.default)(i),S;!(w=(S=_.next()).done);w=true){var T=S.value;if(T.type==="kern"){x+=T.size}else{var C=T.elem;var A=z([],[m,C]);A.style.top=-o-x-C.depth+"em";if(T.marginLeft){A.style.marginLeft=T.marginLeft}if(T.marginRight){A.style.marginRight=T.marginRight}g.push(A);x+=C.height+C.depth}b=Math.min(b,x);y=Math.max(y,x)}}catch(e){k=true;M=e}finally{try{if(!w&&_.return){_.return()}}finally{if(k){throw M}}}var O=z(["vlist"],g);O.style.height=y+"em";var L=void 0;if(b<0){var j=z(["vlist"],[]);j.style.height=-b+"em";var E=z(["vlist-s"],[new l.default.symbolNode("\u200b")]);L=[z(["vlist-r"],[O,E]),z(["vlist-r"],[j])]}else{L=[z(["vlist-r"],[O])]}var q=z(["vlist-t"],L);if(L.length===2){q.classes.push("vlist-t2")}q.height=y;q.depth=-b;return q};var j=function e(t,r){var a=t.value.body;if(t.value.star){a=a.replace(/ /g,"\u2423")}else{a=a.replace(/ /g,"\xa0")}return a};var E=function e(t,r,a){var n=q(t);var i=P(r,a);return n+"-"+i};var q=function e(t){var r="";switch(t){case"amsrm":r="AMS";break;case"textrm":r="Main";break;case"textsf":r="SansSerif";break;case"texttt":r="Typewriter";break;default:throw new Error("Invalid font provided: "+t)}return r};var P=function e(t,r){var a="";if(t==="textbf"){a+="Bold"}if(r==="textit"){a+="Italic"}return a||"Regular"};var B={"\\qquad":{size:"2em",className:"qquad"},"\\quad":{size:"1em",className:"quad"},"\\enspace":{size:"0.5em",className:"enspace"},"\\;":{size:"0.277778em",className:"thickspace"},"\\:":{size:"0.22222em",className:"mediumspace"},"\\,":{size:"0.16667em",className:"thinspace"},"\\!":{size:"-0.16667em",className:"negativethinspace"}};var F={mathbf:{variant:"bold",fontName:"Main-Bold"},mathrm:{variant:"normal",fontName:"Main-Regular"},textit:{variant:"italic",fontName:"Main-Italic"},mathbb:{variant:"double-struck",fontName:"AMS-Regular"},mathcal:{variant:"script",fontName:"Caligraphic-Regular"},mathfrak:{variant:"fraktur",fontName:"Fraktur-Regular"},mathscr:{variant:"script",fontName:"Script-Regular"},mathsf:{variant:"sans-serif",fontName:"SansSerif-Regular"},mathtt:{variant:"monospace",fontName:"Typewriter-Regular"}};r.default={fontMap:F,makeSymbol:b,mathsym:y,makeSpan:z,makeLineSpan:T,makeAnchor:C,makeFragment:O,makeVList:L,makeOrd:M,makeVerb:j,tryCombineChars:_,prependChildren:A,spacingFunctions:B}},{"./domTree":98,"./fontMetrics":101,"./stretchy":123,"./symbols":125,"./utils":128,"babel-runtime/core-js/get-iterator":3}],92:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.buildGroup=r.groupTypes=r.makeNullDelimiter=r.getTypeOfDomTree=r.buildExpression=r.spliceSpaces=undefined;var a=e("babel-runtime/core-js/json/stringify");var n=x(a);r.default=P;var i=e("./ParseError");var l=x(i);var u=e("./Style");var o=x(u);var s=e("./buildCommon");var f=x(s);var d=e("./delimiter");var c=x(d);var h=e("./domTree");var v=x(h);var p=e("./units");var m=e("./utils");var g=x(m);var b=e("./stretchy");var y=x(b);function x(e){return e&&e.__esModule?e:{default:e}}var w=f.default.makeSpan;var k=function e(t){return t instanceof v.default.span&&t.classes[0]==="mspace"};var M=function e(t){return t&&t.classes[0]==="mbin"};var _=function e(t,r){if(t){return g.default.contains(["mbin","mopen","mrel","mop","mpunct"],t.classes[0])}else{return r}};var S=function e(t,r){if(t){return g.default.contains(["mrel","mclose","mpunct"],t.classes[0])}else{return r}};var z=r.spliceSpaces=function e(t,r){var a=r;while(a<t.length&&k(t[a])){a++}if(a===r){return null}else{return t.splice(r,a-r)}};var T=r.buildExpression=function e(t,r,a){var n=[];for(var i=0;i<t.length;i++){var l=t[i];var u=q(l,r);if(u instanceof v.default.documentFragment){Array.prototype.push.apply(n,u.children)}else{n.push(u)}}for(var o=0;o<n.length;o++){var s=z(n,o);if(s){if(o<n.length){if(n[o]instanceof v.default.symbolNode){n[o]=w([].concat(n[o].classes),[n[o]])}f.default.prependChildren(n[o],s)}else{Array.prototype.push.apply(n,s);break}}}for(var d=0;d<n.length;d++){var c=1;var h=1;while(n[d-c]&&n[d-c].classes[0]==="cursor"){c++}while(n[d+h]&&n[d+h].classes[0]==="cursor"){h++}if(M(n[d])&&(_(n[d-c],a)||S(n[d+h],a))){n[d].classes[0]="mord"}}for(var p=0;p<n.length;p++){if(n[p].value==="\u0338"&&p+1<n.length){var m=n.slice(p,p+2);m[0].classes=["mainrm"];m[0].style.position="absolute";m[0].style.right="0";var g=n[p+1].classes;var b=w(g,m);if(g.indexOf("mord")!==-1){b.style.paddingLeft="0.277771em"}b.style.position="relative";n.splice(p,2,b)}}return n};var C=r.getTypeOfDomTree=function e(t){if(t instanceof v.default.documentFragment){if(t.children.length){return e(t.children[t.children.length-1])}}else{if(g.default.contains(["mord","mop","mbin","mrel","mopen","mclose","mpunct","minner"],t.classes[0])){return t.classes[0]}}return null};var A=function e(t,r){if(!t.value.base){return false}else{var a=t.value.base;if(a.type==="op"){return a.value.limits&&(r.style.size===o.default.DISPLAY.size||a.value.alwaysHandleSupSub)}else if(a.type==="accent"){return N(a.value.base)}else if(a.type==="horizBrace"){var n=t.value.sub?false:true;return n===a.value.isOver}else{return null}}};var O=function e(t){if(!t){return false}else if(t.type==="ordgroup"){if(t.value.length===1){return e(t.value[0])}else{return t}}else if(t.type==="color"){if(t.value.value.length===1){return e(t.value.value[0])}else{return t}}else if(t.type==="font"){return e(t.value.body)}else{return t}};var N=function e(t){var r=O(t);return r.type==="mathord"||r.type==="textord"||r.type==="bin"||r.type==="rel"||r.type==="inner"||r.type==="open"||r.type==="close"||r.type==="punct"};var L=r.makeNullDelimiter=function e(t,r){var a=["nulldelimiter"].concat(t.baseSizingClasses());return w(r.concat(a))};var j=r.groupTypes={};j.mathord=function(e,t){return f.default.makeOrd(e,t,"mathord")};j.textord=function(e,t){return f.default.makeOrd(e,t,"textord")};j.bin=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mbin"])};j.rel=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mrel"])};j.open=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mopen"])};j.close=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mclose"])};j.inner=function(e,t){return f.default.mathsym(e.value,e.mode,t,["minner"])};j.punct=function(e,t){return f.default.mathsym(e.value,e.mode,t,["mpunct"])};j.ordgroup=function(e,t){return w(["mord"],T(e.value,t,true),t)};j.xmlClass=function(e,t,r){var a=T(e.value.value,t,r);return new f.default.makeFragment(a,[e.value.cl])};j.supsub=function(e,t){if(A(e,t)){return j[e.value.base.type](e,t)}var r=q(e.value.base,t);var a=void 0;var n=void 0;var i=t.fontMetrics();var l=void 0;var u=0;var s=0;if(e.value.sup){l=t.havingStyle(t.style.sup());a=q(e.value.sup,l,t);if(!N(e.value.base)){u=r.height-l.fontMetrics().supDrop*l.sizeMultiplier/t.sizeMultiplier}}if(e.value.sub){l=t.havingStyle(t.style.sub());n=q(e.value.sub,l,t);if(!N(e.value.base)){s=r.depth+l.fontMetrics().subDrop*l.sizeMultiplier/t.sizeMultiplier}}var d=void 0;if(t.style===o.default.DISPLAY){d=i.sup1}else if(t.style.cramped){d=i.sup3}else{d=i.sup2}var c=t.sizeMultiplier;var h=.5/i.ptPerEm/c+"em";var p=void 0;if(!e.value.sup){s=Math.max(s,i.sub1,n.height-.8*i.xHeight);var m=[{type:"elem",elem:n,marginRight:h}];if(r instanceof v.default.symbolNode){m[0].marginLeft=-r.italic+"em"}p=f.default.makeVList({positionType:"shift",positionData:s,children:m},t)}else if(!e.value.sub){u=Math.max(u,d,a.depth+.25*i.xHeight);p=f.default.makeVList({positionType:"shift",positionData:-u,children:[{type:"elem",elem:a,marginRight:h}]},t)}else{u=Math.max(u,d,a.depth+.25*i.xHeight);s=Math.max(s,i.sub2);var g=i.defaultRuleThickness;if(u-a.depth-(n.height-s)<4*g){s=4*g-(u-a.depth)+n.height;var b=.8*i.xHeight-(u-a.depth);if(b>0){u+=b;s-=b}}var y=[{type:"elem",elem:n,shift:s,marginRight:h},{type:"elem",elem:a,shift:-u,marginRight:h}];if(r instanceof v.default.symbolNode){y[0].marginLeft=-r.italic+"em"}p=f.default.makeVList({positionType:"individualShift",children:y},t)}var x=C(r)||"mord";return w([x],[r,w(["msupsub"],[p])],t)};j.spacing=function(e,t){if(e.value==="\\ "||e.value==="\\space"||e.value===" "||e.value==="~"){if(e.mode==="text"){return f.default.makeOrd(e,t,"textord")}else{return w(["mspace"],[f.default.mathsym(e.value,e.mode,t)],t)}}else{return w(["mspace",f.default.spacingFunctions[e.value].className],[],t)}};j.sqrt=function(e,t){var r=q(e.value.body,t.havingCrampedStyle());if(r.height===0){r.height=t.fontMetrics().xHeight}if(r instanceof v.default.documentFragment){r=w([],[r],t)}var a=t.fontMetrics();var n=a.defaultRuleThickness;var i=n;if(t.style.id<o.default.TEXT.id){i=t.fontMetrics().xHeight}var l=n+i/4;var u=(r.height+r.depth+l+n)*t.sizeMultiplier;var s=c.default.sqrtImage(u,t),d=s.span,h=s.ruleWidth;var p=d.height-h;if(p>r.height+r.depth+l){l=(l+p-r.height-r.depth)/2}var m=d.height-r.height-l-h;r.style.paddingLeft=d.advanceWidth+"em";var g=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:r},{
type:"kern",size:-(r.height+m)},{type:"elem",elem:d},{type:"kern",size:h}]},t);g.children[0].children[0].classes.push("svg-align");if(!e.value.index){return w(["mord","sqrt"],[g],t)}else{var b=t.havingStyle(o.default.SCRIPTSCRIPT);var y=q(e.value.index,b,t);var x=.6*(g.height-g.depth);var k=f.default.makeVList({positionType:"shift",positionData:-x,children:[{type:"elem",elem:y}]},t);var M=w(["root"],[k]);return w(["mord","sqrt"],[M,g],t)}};function E(e,t,r){var a=T(e,t,false);var n=t.sizeMultiplier/r.sizeMultiplier;for(var i=0;i<a.length;i++){var l=g.default.indexOf(a[i].classes,"sizing");if(l<0){Array.prototype.push.apply(a[i].classes,t.sizingClasses(r))}else if(a[i].classes[l+1]==="reset-size"+t.size){a[i].classes[l+1]="reset-size"+r.size}a[i].height*=n;a[i].depth*=n}return f.default.makeFragment(a)}j.sizing=function(e,t){var r=t.havingSize(e.value.size);return E(e.value.value,r,t)};j.styling=function(e,t){var r={display:o.default.DISPLAY,text:o.default.TEXT,script:o.default.SCRIPT,scriptscript:o.default.SCRIPTSCRIPT};var a=r[e.value.style];var n=t.havingStyle(a);return E(e.value.value,n,t)};j.font=function(e,t){var r=e.value.font;return q(e.value.body,t.withFontFamily(r))};j.verb=function(e,t){var r=f.default.makeVerb(e,t);var a=[];var n=t.havingStyle(t.style.text());for(var i=0;i<r.length;i++){if(r[i]==="\xa0"){var l=w(["mord","rule"],[],n);l.style.marginLeft="0.525em";a.push(l)}else{a.push(f.default.makeSymbol(r[i],"Typewriter-Regular",e.mode,n,["mathtt"]))}}f.default.tryCombineChars(a);return w(["mord","text"].concat(n.sizingClasses(t)),a,n)};j.cursor=function(e,t,r){var a=w(["cursor"],[],t);var n=0;var i=(0,p.calculateSize)(e.value.height,t);if(e.value.shift){n=(0,p.calculateSize)(e.value.shift,t)}n/=t.sizeMultiplier;i/=t.sizeMultiplier;a.style.marginRight="-1px";a.style.borderRight="1px solid";a.style.marginBottom=n+"em";a.style.height=i+"em";a.width=1;a.height=i+n;a.depth=-n;e.value.previous=r;return a};j.accent=function(e,t){var r=e.value.base;var a=void 0;if(e.type==="supsub"){var n=e;e=n.value.base;r=e.value.base;n.value.base=r;a=q(n,t)}var i=q(r,t.havingCrampedStyle());var l=e.value.isShifty&&N(r);var u=0;if(l){var o=O(r);var s=q(o,t.havingCrampedStyle());u=s.skew}var d=Math.min(i.height,t.fontMetrics().xHeight);var c=void 0;if(!e.value.isStretchy){var h=f.default.makeSymbol(e.value.label,"Main-Regular",e.mode,t);h.italic=0;var v=null;if(e.value.label==="\\vec"){v="accent-vec"}else if(e.value.label==="\\H"){v="accent-hungarian"}c=w([],[h]);c=w(["accent-body",v],[c]);c.style.marginLeft=2*u+"em";c=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:i},{type:"kern",size:-d},{type:"elem",elem:c}]},t)}else{c=y.default.svgSpan(e,t);c=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:i},{type:"elem",elem:c}]},t);var p=c.children[0].children[0].children[1];p.classes.push("svg-align");if(u>0){p.style.width="calc(100% - "+2*u+"em)";p.style.marginLeft=2*u+"em"}}var m=w(["mord","accent"],[c],t);if(a){a.children[0]=m;a.height=Math.max(m.height,a.height);a.classes[0]="mord";return a}else{return m}};j.horizBrace=function(e,t){var r=t.style;var a=e.type==="supsub";var n=void 0;var i=void 0;if(a){if(e.value.sup){i=t.havingStyle(r.sup());n=q(e.value.sup,i,t)}else{i=t.havingStyle(r.sub());n=q(e.value.sub,i,t)}e=e.value.base}var l=q(e.value.base,t.havingBaseStyle(o.default.DISPLAY));var u=y.default.svgSpan(e,t);var s=void 0;if(e.value.isOver){s=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:l},{type:"kern",size:.1},{type:"elem",elem:u}]},t);s.children[0].children[0].children[1].classes.push("svg-align")}else{s=f.default.makeVList({positionType:"bottom",positionData:l.depth+.1+u.height,children:[{type:"elem",elem:u},{type:"kern",size:.1},{type:"elem",elem:l}]},t);s.children[0].children[0].children[0].classes.push("svg-align")}if(a){var d=w(["mord",e.value.isOver?"mover":"munder"],[s],t);if(e.value.isOver){s=f.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:d},{type:"kern",size:.2},{type:"elem",elem:n}]},t)}else{s=f.default.makeVList({positionType:"bottom",positionData:d.depth+.2+n.height,children:[{type:"elem",elem:n},{type:"kern",size:.2},{type:"elem",elem:d}]},t)}}return w(["mord",e.value.isOver?"mover":"munder"],[s],t)};j.accentUnder=function(e,t){var r=q(e.value.base,t);var a=y.default.svgSpan(e,t);var n=/tilde/.test(e.value.label)?.12:0;var i=f.default.makeVList({positionType:"bottom",positionData:a.height+n,children:[{type:"elem",elem:a},{type:"kern",size:n},{type:"elem",elem:r}]},t);i.children[0].children[0].children[0].classes.push("svg-align");return w(["mord","accentunder"],[i],t)};j.enclose=function(e,t){var r=q(e.value.body,t);var a=e.value.label.substr(1);var n=t.sizeMultiplier;var i=void 0;var l=0;var u=/color/.test(a);if(a==="sout"){i=w(["stretchy","sout"]);i.height=t.fontMetrics().defaultRuleThickness/n;l=-.5*t.fontMetrics().xHeight}else{r.classes.push(/cancel/.test(a)?"cancel-pad":"boxpad");var o=0;if(/box/.test(a)){o=a==="colorbox"?.3:.34}else{o=N(e.value.body)?.2:0}i=y.default.encloseSpan(r,a,o,t);l=r.depth+o;if(u){i.style.backgroundColor=e.value.backgroundColor.value;if(a==="fcolorbox"){i.style.borderColor=e.value.borderColor.value}}}var s=void 0;if(u){s=f.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:i,shift:l},{type:"elem",elem:r,shift:0}]},t)}else{s=f.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:r,shift:0},{type:"elem",elem:i,shift:l}]},t)}if(/cancel/.test(a)){s.children[0].children[0].children[1].classes.push("svg-align");return w(["mord","cancel-lap"],[s],t)}else{return w(["mord"],[s],t)}};j.xArrow=function(e,t){var r=t.style;var a=t.havingStyle(r.sup());var n=q(e.value.body,a,t);n.classes.push("x-arrow-pad");var i=void 0;if(e.value.below){a=t.havingStyle(r.sub());i=q(e.value.below,a,t);i.classes.push("x-arrow-pad")}var l=y.default.svgSpan(e,t);var u=-t.fontMetrics().axisHeight+.5*l.height;var o=-t.fontMetrics().axisHeight-.5*l.height-.111;var s=void 0;if(e.value.below){var d=-t.fontMetrics().axisHeight+i.height+.5*l.height+.111;s=f.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:n,shift:o},{type:"elem",elem:l,shift:u},{type:"elem",elem:i,shift:d}]},t)}else{s=f.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:n,shift:o},{type:"elem",elem:l,shift:u}]},t)}s.children[0].children[0].children[1].classes.push("svg-align");return w(["mrel","x-arrow"],[s],t)};j.mclass=function(e,t){var r=T(e.value.value,t,true);return w([e.value.mclass],r,t)};j.raisebox=function(e,t){var r=j.sizing({value:{value:[{type:"text",value:{body:e.value.value,font:"mathrm"}}],size:6}},t);var a=(0,p.calculateSize)(e.value.dy.value,t);return f.default.makeVList({positionType:"shift",positionData:-a,children:[{type:"elem",elem:r}]},t)};var q=r.buildGroup=function e(t,r,a){if(!t){return w()}if(j[t.type]){var n=j[t.type](t,r);if(a&&r.size!==a.size){n=w(r.sizingClasses(a),[n],r);var i=r.sizeMultiplier/a.sizeMultiplier;n.height*=i;n.depth*=i}return n}else{throw new l.default("Got group of unknown type: '"+t.type+"'")}};function P(e,t){e=JSON.parse((0,n.default)(e));var r=T(e,t,true);var a=w(["base"],r,t);var i=w(["strut"]);var l=w(["strut","bottom"]);i.style.height=a.height+"em";l.style.height=a.height+a.depth+"em";l.style.verticalAlign=-a.depth+"em";var u=w(["katex-html"],[i,l,a]);u.setAttribute("aria-hidden","true");return u}},{"./ParseError":84,"./Style":89,"./buildCommon":91,"./delimiter":97,"./domTree":98,"./stretchy":123,"./units":127,"./utils":128,"babel-runtime/core-js/json/stringify":5}],93:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.buildGroup=r.buildExpression=r.groupTypes=r.makeText=undefined;r.default=z;var a=e("./buildCommon");var n=y(a);var i=e("./fontMetrics");var l=y(i);var u=e("./mathMLTree");var o=y(u);var s=e("./ParseError");var f=y(s);var d=e("./Style");var c=y(d);var h=e("./symbols");var v=y(h);var p=e("./utils");var m=y(p);var g=e("./stretchy");var b=y(g);function y(e){return e&&e.__esModule?e:{default:e}}var x=r.makeText=function e(t,r){if(v.default[r][t]&&v.default[r][t].replace){t=v.default[r][t].replace}return new o.default.TextNode(t)};var w=function e(t,r){var a=r.fontFamily;if(!a){return null}var i=t.mode;if(a==="mathit"){return"italic"}else if(a==="boldsymbol"){return"bold-italic"}var u=t.value;if(m.default.contains(["\\imath","\\jmath"],u)){return null}if(v.default[i][u]&&v.default[i][u].replace){u=v.default[i][u].replace}var o=n.default.fontMap[a].fontName;if(l.default.getCharacterMetrics(u,o)){return n.default.fontMap[a].variant}return null};var k=r.groupTypes={};var M={mi:"italic",mn:"normal",mtext:"normal"};k.mathord=function(e,t){var r=new o.default.MathNode("mi",[x(e.value,e.mode)]);var a=w(e,t)||"italic";if(a!==M[r.type]){r.setAttribute("mathvariant",a)}return r};k.textord=function(e,t){var r=x(e.value,e.mode);var a=w(e,t)||"normal";var n=void 0;if(e.mode==="text"){n=new o.default.MathNode("mtext",[r])}else if(/[0-9]/.test(e.value)){n=new o.default.MathNode("mn",[r])}else if(e.value==="\\prime"){n=new o.default.MathNode("mo",[r])}else{n=new o.default.MathNode("mi",[r])}if(a!==M[n.type]){n.setAttribute("mathvariant",a)}return n};k.bin=function(e,t){var r=new o.default.MathNode("mo",[x(e.value,e.mode)]);var a=w(e,t);if(a==="bold-italic"){r.setAttribute("mathvariant",a)}return r};k.rel=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};k.open=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};k.close=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};k.inner=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);return t};k.punct=function(e){var t=new o.default.MathNode("mo",[x(e.value,e.mode)]);t.setAttribute("separator","true");return t};k.ordgroup=function(e,t){var r=_(e.value,t);var a=new o.default.MathNode("mrow",r);return a};k.xmlClass=function(e,t){var r=_(e.value.value,t);var a=new o.default.MathNode("mstyle",r);a.setAttribute("class",e.value.cl);return a};k.supsub=function(e,t){var r=false;var a=void 0;var n=void 0;if(e.value.base){if(e.value.base.value.type==="horizBrace"){n=e.value.sup?true:false;if(n===e.value.base.value.isOver){r=true;a=e.value.base.value.isOver}}}var i=true;var l=[S(e.value.base,t,i)];if(e.value.sub){l.push(S(e.value.sub,t,i))}if(e.value.sup){l.push(S(e.value.sup,t,i))}var u=void 0;if(r){u=a?"mover":"munder"}else if(!e.value.sub){u="msup"}else if(!e.value.sup){u="msub"}else{var s=e.value.base;if(s&&s.value.limits&&t.style===c.default.DISPLAY){u="munderover"}else{u="msubsup"}}var f=new o.default.MathNode(u,l);return f};k.sqrt=function(e,t){var r=void 0;if(e.value.index){r=new o.default.MathNode("mroot",[S(e.value.body,t),S(e.value.index,t)])}else{r=new o.default.MathNode("msqrt",[S(e.value.body,t)])}return r};k.accent=function(e,t){var r=void 0;if(e.value.isStretchy){r=b.default.mathMLnode(e.value.label)}else{r=new o.default.MathNode("mo",[x(e.value.label,e.mode)])}var a=new o.default.MathNode("mover",[S(e.value.base,t),r]);a.setAttribute("accent","true");return a};k.spacing=function(e){var t=void 0;if(e.value==="\\ "||e.value==="\\space"||e.value===" "||e.value==="~"){t=new o.default.MathNode("mtext",[new o.default.TextNode("\xa0")])}else{t=new o.default.MathNode("mspace");t.setAttribute("width",n.default.spacingFunctions[e.value].size)}return t};k.cursor=function(e){var t=new o.default.MathNode("mtext",[new o.default.TextNode("|")]);return t};k.font=function(e,t){var r=e.value.font;return S(e.value.body,t.withFontFamily(r))};k.styling=function(e,t){var r={display:c.default.DISPLAY,text:c.default.TEXT,script:c.default.SCRIPT,scriptscript:c.default.SCRIPTSCRIPT};var a=r[e.value.style];var n=t.havingStyle(a);var i=_(e.value.value,n);var l=new o.default.MathNode("mstyle",i);var u={display:["0","true"],text:["0","false"],script:["1","false"],scriptscript:["2","false"]};var s=u[e.value.style];l.setAttribute("scriptlevel",s[0]);l.setAttribute("displaystyle",s[1]);return l};k.sizing=function(e,t){var r=t.havingSize(e.value.size);var a=_(e.value.value,r);var n=new o.default.MathNode("mstyle",a);n.setAttribute("mathsize",r.sizeMultiplier+"em");return n};k.verb=function(e,t){var r=new o.default.TextNode(n.default.makeVerb(e,t));var a=new o.default.MathNode("mtext",[r]);a.setAttribute("mathvariant",n.default.fontMap["mathtt"].variant);return a};k.accentUnder=function(e,t){var r=b.default.mathMLnode(e.value.label);var a=new o.default.MathNode("munder",[S(e.value.body,t),r]);a.setAttribute("accentunder","true");return a};k.enclose=function(e,t){var r=new o.default.MathNode("menclose",[S(e.value.body,t)]);switch(e.value.label){case"\\cancel":r.setAttribute("notation","updiagonalstrike");break;case"\\bcancel":r.setAttribute("notation","downdiagonalstrike");break;case"\\sout":r.setAttribute("notation","horizontalstrike");break;case"\\fbox":r.setAttribute("notation","box");break;case"\\colorbox":r.setAttribute("mathbackground",e.value.backgroundColor.value);break;case"\\fcolorbox":r.setAttribute("mathbackground",e.value.backgroundColor.value);r.setAttribute("notation","box");break;default:r.setAttribute("notation","updiagonalstrike downdiagonalstrike")}return r};k.horizBrace=function(e,t){var r=b.default.mathMLnode(e.value.label);return new o.default.MathNode(e.value.isOver?"mover":"munder",[S(e.value.base,t),r])};k.xArrow=function(e,t){var r=b.default.mathMLnode(e.value.label);var a=void 0;var n=void 0;if(e.value.body){var i=S(e.value.body,t);if(e.value.below){n=S(e.value.below,t);a=new o.default.MathNode("munderover",[r,n,i])}else{a=new o.default.MathNode("mover",[r,i])}}else if(e.value.below){n=S(e.value.below,t);a=new o.default.MathNode("munder",[r,n])}else{a=new o.default.MathNode("mover",[r])}return a};k.mclass=function(e,t){var r=_(e.value.value,t);return new o.default.MathNode("mstyle",r)};k.raisebox=function(e,t){var r=new o.default.MathNode("mpadded",[S(e.value.body,t)]);var a=e.value.dy.value.number+e.value.dy.value.unit;r.setAttribute("voffset",a);return r};var _=r.buildExpression=function e(t,r){var a=[];for(var n=0;n<t.length;n++){var i=t[n];a.push(S(i,r))}return a};var S=r.buildGroup=function e(t,r){var a=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(!t){return new o.default.MathNode("mrow")}if(k[t.type]){var n=k[t.type](t,r);if(a){if(n.type==="mrow"&&n.children.length===1){return n.children[0]}}return n}else{throw new f.default("Got group of unknown type: '"+t.type+"'")}};function z(e,t,r){var a=_(e,r);var i=new o.default.MathNode("mrow",a);var l=new o.default.MathNode("annotation",[new o.default.TextNode(t)]);l.setAttribute("encoding","application/x-tex");var u=new o.default.MathNode("semantics",[i,l]);var s=new o.default.MathNode("math",[u]);return n.default.makeSpan(["katex-mathml"],[s])}},{"./ParseError":84,"./Style":89,"./buildCommon":91,"./fontMetrics":101,"./mathMLTree":121,"./stretchy":123,"./symbols":125,"./utils":128}],94:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./buildHTML");var n=p(a);var i=e("./buildMathML");var l=p(i);var u=e("./buildCommon");var o=p(u);var s=e("./Options");var f=p(s);var d=e("./Settings");var c=p(d);var h=e("./Style");var v=p(h);function p(e){return e&&e.__esModule?e:{default:e}}var m=function e(t,r,a){a=a||new c.default({});var i=v.default.TEXT;if(a.displayMode){i=v.default.DISPLAY}var u=new f.default({style:i,maxSize:a.maxSize});var s=(0,l.default)(t,r,u);var d=(0,n.default)(t,u);var h=o.default.makeSpan(["katex"],[s,d]);if(a.displayMode){return o.default.makeSpan(["katex-display"],[h])}else{return h}};r.default=m},{"./Options":83,"./Settings":87,"./Style":89,"./buildCommon":91,"./buildHTML":92,"./buildMathML":93}],95:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r._environments=undefined;r.default=d;var a=e("./buildHTML");var n=e("./buildMathML");var i=e("./Options");var l=s(i);var u=e("./ParseNode");var o=s(u);function s(e){return e&&e.__esModule?e:{default:e}}var f=r._environments={};function d(e){var t=e.type,r=e.names,i=e.props,l=e.handler,u=e.htmlBuilder,o=e.mathmlBuilder;var s={numArgs:i.numArgs||0,greediness:1,allowedInText:false,numOptionalArgs:0,handler:l};for(var d=0;d<r.length;++d){f[r[d]]=s}if(u){a.groupTypes[t]=u}if(o){n.groupTypes[t]=o}}},{"./Options":83,"./ParseNode":85,"./buildHTML":92,"./buildMathML":93}],96:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.ordargument=r._functions=undefined;r.default=l;var a=e("./buildHTML");var n=e("./buildMathML");var i=r._functions={};function l(e){var t=e.type,r=e.names,l=e.props,u=e.handler,o=e.htmlBuilder,s=e.mathmlBuilder;var f={numArgs:l.numArgs,argTypes:l.argTypes,greediness:l.greediness===undefined?1:l.greediness,allowedInText:!!l.allowedInText,allowedInMath:l.allowedInMath===undefined?true:l.allowedInMath,numOptionalArgs:l.numOptionalArgs||0,infix:!!l.infix,handler:u};for(var d=0;d<r.length;++d){i[r[d]]=f}if(t){if(o){a.groupTypes[t]=o}if(s){n.groupTypes[t]=s}}}var u=r.ordargument=function e(t){if(t.type==="ordgroup"){return t.value}else{return[t]}}},{"./buildHTML":92,"./buildMathML":93}],97:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./ParseError");var n=g(a);var i=e("./Style");var l=g(i);var u=e("./domTree");var o=g(u);var s=e("./buildCommon");var f=g(s);var d=e("./fontMetrics");var c=g(d);var h=e("./symbols");var v=g(h);var p=e("./utils");var m=g(p);function g(e){return e&&e.__esModule?e:{default:e}}var b=function e(t,r){if(v.default.math[t]&&v.default.math[t].replace){return c.default.getCharacterMetrics(v.default.math[t].replace,r)}else{return c.default.getCharacterMetrics(t,r)}};var y=function e(t,r,a,n){var i=a.havingBaseStyle(r);var l=f.default.makeSpan((n||[]).concat(i.sizingClasses(a)),[t],a);l.delimSizeMultiplier=i.sizeMultiplier/a.sizeMultiplier;l.height*=l.delimSizeMultiplier;l.depth*=l.delimSizeMultiplier;l.maxFontSize=i.sizeMultiplier;return l};var x=function e(t,r,a){var n=r.havingBaseStyle(a);var i=(1-r.sizeMultiplier/n.sizeMultiplier)*r.fontMetrics().axisHeight;t.classes.push("delimcenter");t.style.top=i+"em";t.height-=i;t.depth+=i};var w=function e(t,r,a,n,i,l){var u=f.default.makeSymbol(t,"Main-Regular",i,n);var o=y(u,r,n,l);if(a){x(o,n,r)}return o};var k=function e(t,r,a,n){return f.default.makeSymbol(t,"Size"+r+"-Regular",a,n)};var M=function e(t,r,a,n,i,u){var o=k(t,r,i,n);var s=y(f.default.makeSpan(["delimsizing","size"+r],[o],n),l.default.TEXT,n,u);if(a){x(s,n,l.default.TEXT)}return s};var _=function e(t,r,a){var n=void 0;if(r==="Size1-Regular"){n="delim-size1"}else if(r==="Size4-Regular"){n="delim-size4"}var i=f.default.makeSpan(["delimsizinginner",n],[f.default.makeSpan([],[f.default.makeSymbol(t,r,a)])]);return{type:"elem",elem:i}};var S=function e(t,r,a,n,i,u){var o=void 0;var s=void 0;var d=void 0;var c=void 0;o=d=c=t;s=null;var h="Size1-Regular";if(t==="\\uparrow"){d=c="\u23d0"}else if(t==="\\Uparrow"){d=c="\u2016"}else if(t==="\\downarrow"){o=d="\u23d0"}else if(t==="\\Downarrow"){o=d="\u2016"}else if(t==="\\updownarrow"){o="\\uparrow";d="\u23d0";c="\\downarrow"}else if(t==="\\Updownarrow"){o="\\Uparrow";d="\u2016";c="\\Downarrow"}else if(t==="["||t==="\\lbrack"){o="\u23a1";d="\u23a2";c="\u23a3";h="Size4-Regular"}else if(t==="]"||t==="\\rbrack"){o="\u23a4";d="\u23a5";c="\u23a6";h="Size4-Regular"}else if(t==="\\lfloor"){d=o="\u23a2";c="\u23a3";h="Size4-Regular"}else if(t==="\\lceil"){o="\u23a1";d=c="\u23a2";h="Size4-Regular"}else if(t==="\\rfloor"){d=o="\u23a5";c="\u23a6";h="Size4-Regular"}else if(t==="\\rceil"){o="\u23a4";d=c="\u23a5";h="Size4-Regular"}else if(t==="("){o="\u239b";d="\u239c";c="\u239d";h="Size4-Regular"}else if(t===")"){o="\u239e";d="\u239f";c="\u23a0";h="Size4-Regular"}else if(t==="\\{"||t==="\\lbrace"){o="\u23a7";s="\u23a8";c="\u23a9";d="\u23aa";h="Size4-Regular"}else if(t==="\\}"||t==="\\rbrace"){o="\u23ab";s="\u23ac";c="\u23ad";d="\u23aa";h="Size4-Regular"}else if(t==="\\lgroup"){o="\u23a7";c="\u23a9";d="\u23aa";h="Size4-Regular"}else if(t==="\\rgroup"){o="\u23ab";c="\u23ad";d="\u23aa";h="Size4-Regular"}else if(t==="\\lmoustache"){o="\u23a7";c="\u23ad";d="\u23aa";h="Size4-Regular"}else if(t==="\\rmoustache"){o="\u23ab";c="\u23a9";d="\u23aa";h="Size4-Regular"}var v=b(o,h);var p=v.height+v.depth;var m=b(d,h);var g=m.height+m.depth;var x=b(c,h);var w=x.height+x.depth;var k=0;var M=1;if(s!==null){var S=b(s,h);k=S.height+S.depth;M=2}var z=p+w+k;var T=Math.ceil((r-z)/(M*g));var C=z+T*M*g;var A=n.fontMetrics().axisHeight;if(a){A*=n.sizeMultiplier}var O=C/2-A;var N=[];N.push(_(c,h,i));if(s===null){for(var L=0;L<T;L++){N.push(_(d,h,i))}}else{for(var j=0;j<T;j++){N.push(_(d,h,i))}N.push(_(s,h,i));for(var E=0;E<T;E++){N.push(_(d,h,i))}}N.push(_(o,h,i));var q=n.havingBaseStyle(l.default.TEXT);var P=f.default.makeVList({positionType:"bottom",positionData:O,children:N},q);return y(f.default.makeSpan(["delimsizing","mult"],[P],q),l.default.TEXT,n,u)};var z=function e(t,r,a,n){var i=void 0;if(t==="sqrtTall"){var l=a-54;i="M702 0H400000v40H742v"+l+"l-4 4-4 4c-.667.667\n-2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1h-12l-28-84c-16.667-52-96.667\n-294.333-240-727l-212 -643 -85 170c-4-3.333-8.333-7.667-13 -13l-13-13l77-155\n 77-156c66 199.333 139 419.667 219 661 l218 661zM702 0H400000v40H742z"}var u=new o.default.pathNode(t,i);var s=new o.default.svgNode([u],{width:"400em",height:r+"em",viewBox:"0 0 400000 "+a,preserveAspectRatio:"xMinYMin slice"});return f.default.makeSpan(["hide-tail"],[s],n)};var T=function e(t,r){var a=B("\\surd",t,q,r);var n=void 0;var i=r.sizeMultiplier;var l=void 0;var u=void 0;if(a.type==="small"){u=1e3;var o=r.havingBaseStyle(a.style);i=o.sizeMultiplier/r.sizeMultiplier;l=1*i;n=z("sqrtMain",l,u,r);n.style.minWidth="0.853em";n.advanceWidth=.833*i}else if(a.type==="large"){u=1e3*N[a.size];l=N[a.size]/i;n=z("sqrtSize"+a.size,l,u,r);n.style.minWidth="1.02em";n.advanceWidth=1/i}else{l=t/i;u=Math.floor(1e3*t);n=z("sqrtTall",l,u,r);n.style.minWidth="0.742em";n.advanceWidth=1.056/i}n.height=l;n.style.height=l+"em";return{span:n,ruleWidth:r.fontMetrics().sqrtRuleThickness*i}};var C=["(",")","[","\\lbrack","]","\\rbrack","\\{","\\lbrace","\\}","\\rbrace","\\lfloor","\\rfloor","\\lceil","\\rceil","\\surd"];var A=["\\uparrow","\\downarrow","\\updownarrow","\\Uparrow","\\Downarrow","\\Updownarrow","|","\\|","\\vert","\\Vert","\\lvert","\\rvert","\\lVert","\\rVert","\\lgroup","\\rgroup","\\lmoustache","\\rmoustache"];var O=["<",">","\\langle","\\rangle","/","\\backslash","\\lt","\\gt"];var N=[0,1.2,1.8,2.4,3];var L=function e(t,r,a,i,l){if(t==="<"||t==="\\lt"){t="\\langle"}else if(t===">"||t==="\\gt"){t="\\rangle"}if(m.default.contains(C,t)||m.default.contains(O,t)){return M(t,r,false,a,i,l)}else if(m.default.contains(A,t)){return S(t,N[r],false,a,i,l)}else{throw new n.default("Illegal delimiter: '"+t+"'")}};var j=[{type:"small",style:l.default.SCRIPTSCRIPT},{type:"small",style:l.default.SCRIPT},{type:"small",style:l.default.TEXT},{type:"large",size:1},{type:"large",size:2},{type:"large",size:3},{type:"large",size:4}];var E=[{type:"small",style:l.default.SCRIPTSCRIPT},{type:"small",style:l.default.SCRIPT},{type:"small",style:l.default.TEXT},{type:"stack"}];var q=[{type:"small",style:l.default.SCRIPTSCRIPT},{type:"small",style:l.default.SCRIPT},{type:"small",style:l.default.TEXT},{type:"large",size:1},{type:"large",size:2},{type:"large",size:3},{type:"large",size:4},{type:"stack"}];var P=function e(t){if(t.type==="small"){return"Main-Regular"}else if(t.type==="large"){return"Size"+t.size+"-Regular"}else if(t.type==="stack"){return"Size4-Regular"}};var B=function e(t,r,a,n){var i=Math.min(2,3-n.style.size);for(var l=i;l<a.length;l++){if(a[l].type==="stack"){break}var u=b(t,P(a[l]));var o=u.height+u.depth;if(a[l].type==="small"){var s=n.havingBaseStyle(a[l].style);o*=s.sizeMultiplier}if(o>r){return a[l]}}return a[a.length-1]};var F=function e(t,r,a,n,i,l){if(t==="<"||t==="\\lt"){t="\\langle"}else if(t===">"||t==="\\gt"){t="\\rangle"}var u=void 0;if(m.default.contains(O,t)){u=j}else if(m.default.contains(C,t)){u=q}else{u=E}var o=B(t,r,u,n);if(o.type==="small"){return w(t,o.style,a,n,i,l)}else if(o.type==="large"){return M(t,o.size,a,n,i,l)}else{return S(t,r,a,n,i,l)}};var R=function e(t,r,a,n,i,l){var u=n.fontMetrics().axisHeight*n.sizeMultiplier;var o=901;var s=5/n.fontMetrics().ptPerEm;var f=Math.max(r-u,a+u);var d=Math.max(f/500*o,2*f-s);return F(t,d,true,n,i,l)};r.default={sqrtImage:T,sizedDelim:L,customSizedDelim:F,leftRightDelim:R}},{"./ParseError":84,"./Style":89,"./buildCommon":91,"./domTree":98,"./fontMetrics":101,"./symbols":125,"./utils":128}],98:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/get-iterator");var n=v(a);var i=e("babel-runtime/helpers/classCallCheck");var l=v(i);var u=e("babel-runtime/helpers/createClass");var o=v(u);var s=e("./unicodeRegexes");var f=e("./utils");var d=v(f);var c=e("./svgGeometry");var h=v(c);function v(e){return e&&e.__esModule?e:{default:e}}var p=function e(t){t=t.slice();for(var r=t.length-1;r>=0;r--){if(!t[r]){t.splice(r,1)}}return t.join(" ")};var m=function(){function e(t,r,a){(0,l.default)(this,e);this.classes=t||[];this.children=r||[];this.height=0;this.depth=0;this.maxFontSize=0;this.style={};this.attributes={};if(a){if(a.style.isTight()){this.classes.push("mtight")}var n=a.getColor();if(n){this.style.color=n}}}(0,o.default)(e,[{key:"setAttribute",value:function e(t,r){this.attributes[t]=r}},{key:"tryCombine",value:function e(t){return false}},{key:"toNode",value:function e(){var t=document.createElement("span");t.className=p(this.classes);for(var r in this.style){if(Object.prototype.hasOwnProperty.call(this.style,r)){t.style[r]=this.style[r]}}for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){t.setAttribute(a,this.attributes[a])}}for(var n=0;n<this.children.length;n++){t.appendChild(this.children[n].toNode())}return t}},{key:"toMarkup",value:function e(){var t="<span";if(this.classes.length){t+=' class="';t+=d.default.escape(p(this.classes));t+='"'}var r="";for(var a in this.style){if(this.style.hasOwnProperty(a)){r+=d.default.hyphenate(a)+":"+this.style[a]+";"}}if(r){t+=' style="'+d.default.escape(r)+'"'}for(var n in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,n)){t+=" "+n+'="';t+=d.default.escape(this.attributes[n]);t+='"'}}t+=">";for(var i=0;i<this.children.length;i++){t+=this.children[i].toMarkup()}t+="</span>";return t}}]);return e}();var g=function(){function e(t,r,a,n){(0,l.default)(this,e);this.href=t;this.classes=r;this.children=a;this.height=0;this.depth=0;this.maxFontSize=0;this.style={};this.attributes={};if(n.style.isTight()){this.classes.push("mtight")}var i=n.getColor();if(i){this.style.color=i}}(0,o.default)(e,[{key:"setAttribute",value:function e(t,r){this.attributes[t]=r}},{key:"tryCombine",value:function e(t){return false}},{key:"toNode",value:function e(){var t=document.createElement("a");t.setAttribute("href",this.href);if(this.classes.length){t.className=p(this.classes)}for(var r in this.style){if(Object.prototype.hasOwnProperty.call(this.style,r)){t.style[r]=this.style[r]}}for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){t.setAttribute(a,this.attributes[a])}}for(var n=0;n<this.children.length;n++){t.appendChild(this.children[n].toNode())}return t}},{key:"toMarkup",value:function e(){var t="<a";t+='href="'+(t+=d.default.escape(this.href))+'"';if(this.classes.length){t+=' class="'+d.default.escape(p(this.classes))+'"'}var r="";for(var a in this.style){if(this.style.hasOwnProperty(a)){r+=d.default.hyphenate(a)+":"+this.style[a]+";"}}if(r){t+=' style="'+d.default.escape(r)+'"'}for(var i in this.attributes){if(i!=="href"&&Object.prototype.hasOwnProperty.call(this.attributes,i)){t+=" "+i+'="'+d.default.escape(this.attributes[i])+'"'}}t+=">";var l=true;var u=false;var o=undefined;try{for(var s=(0,n.default)(this.children),f;!(l=(f=s.next()).done);l=true){var c=f.value;t+=c.toMarkup()}}catch(e){u=true;o=e}finally{try{if(!l&&s.return){s.return()}}finally{if(u){throw o}}}t+="</a>";return t}}]);return e}();var b=function(){function e(t,r){(0,l.default)(this,e);this.children=t||[];this.classes=r||[];this.height=0;this.depth=0;this.maxFontSize=0;if(r){for(var a=0;a<this.children.length;a++){for(var n=0;n<this.classes.length;n++){this.children[a].classes.push(r[n])}}}}(0,o.default)(e,[{key:"toNode",value:function e(){var t=document.createDocumentFragment();for(var r=0;r<this.children.length;r++){t.appendChild(this.children[r].toNode())}return t}},{key:"toMarkup",value:function e(){var t="";for(var r=0;r<this.children.length;r++){t+=this.children[r].toMarkup()}return t}}]);return e}();var y={"\xee":"\u0131\u0302","\xef":"\u0131\u0308","\xed":"\u0131\u0301","\xec":"\u0131\u0300"};var x=function(){function e(t,r,a,n,i,u,o){(0,l.default)(this,e);this.value=t;this.height=r||0;this.depth=a||0;this.italic=n||0;this.skew=i||0;this.classes=u||[];this.style=o||{};this.maxFontSize=0;if(s.cjkRegex.test(this.value)){if(s.hangulRegex.test(this.value)){this.classes.push("hangul_fallback")}else{this.classes.push("cjk_fallback")}}if(/[\xee\xef\xed\xec]/.test(this.value)){this.value=y[this.value]}}(0,o.default)(e,[{key:"tryCombine",value:function t(r){if(!r||!(r instanceof e)||this.italic>0||p(this.classes)!==p(r.classes)||this.skew!==r.skew||this.maxFontSize!==r.maxFontSize){return false}for(var a in this.style){if(this.style.hasOwnProperty(a)&&this.style[a]!==r.style[a]){return false}}for(var n in r.style){if(r.style.hasOwnProperty(n)&&this.style[n]!==r.style[n]){return false}}this.value+=r.value;this.height=Math.max(this.height,r.height);this.depth=Math.max(this.depth,r.depth);this.italic=r.italic;return true}},{key:"toNode",value:function e(){var t=document.createTextNode(this.value);var r=null;if(this.italic>0){r=document.createElement("span");r.style.marginRight=this.italic+"em"}if(this.classes.length>0){r=r||document.createElement("span");r.className=p(this.classes)}for(var a in this.style){if(this.style.hasOwnProperty(a)){r=r||document.createElement("span");r.style[a]=this.style[a]}}if(r){r.appendChild(t);return r}else{return t}}},{key:"toMarkup",value:function e(){var t=false;var r="<span";if(this.classes.length){t=true;r+=' class="';r+=d.default.escape(p(this.classes));r+='"'}var a="";if(this.italic>0){a+="margin-right:"+this.italic+"em;"}for(var n in this.style){if(this.style.hasOwnProperty(n)){a+=d.default.hyphenate(n)+":"+this.style[n]+";"}}if(a){t=true;r+=' style="'+d.default.escape(a)+'"'}var i=d.default.escape(this.value);if(t){r+=">";r+=i;r+="</span>";return r}else{return i}}}]);return e}();var w=function(){function e(t,r,a){(0,l.default)(this,e);this.children=t||[];this.classes=a||[];this.attributes=r||{};this.height=0;this.depth=0;this.maxFontSize=0}(0,o.default)(e,[{key:"toNode",value:function e(){var t="http://www.w3.org/2000/svg";var r=document.createElementNS(t,"svg");r.setAttribute("class",this.classes.join(" "));for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){r.setAttribute(a,this.attributes[a])}}for(var n=0;n<this.children.length;n++){r.appendChild(this.children[n].toNode())}return r}},{key:"toMarkup",value:function e(){var t="<svg";for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t+=" "+r+"='"+this.attributes[r]+"'"}}t+=">";for(var a=0;a<this.children.length;a++){t+=this.children[a].toMarkup()}t+="</svg>";return t}}]);return e}();var k=function(){function e(t,r){(0,l.default)(this,e);this.pathName=t;this.alternate=r}(0,o.default)(e,[{key:"toNode",value:function e(){var t="http://www.w3.org/2000/svg";var r=document.createElementNS(t,"path");if(this.alternate){r.setAttribute("d",this.alternate)}else{r.setAttribute("d",h.default.path[this.pathName]);
}return r}},{key:"toMarkup",value:function e(){if(this.alternate){return"<path d='"+this.alternate+"'/>"}else{return"<path d='"+h.default.path[this.pathName]+"'/>"}}}]);return e}();var M=function(){function e(t){(0,l.default)(this,e);this.attributes=t||{}}(0,o.default)(e,[{key:"toNode",value:function e(){var t="http://www.w3.org/2000/svg";var r=document.createElementNS(t,"line");for(var a in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,a)){r.setAttribute(a,this.attributes[a])}}return r}},{key:"toMarkup",value:function e(){var t="<line";for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t+=" "+r+"='"+this.attributes[r]+"'"}}t+="/>";return t}}]);return e}();r.default={span:m,anchor:g,documentFragment:b,symbolNode:x,svgNode:w,pathNode:k,lineNode:M}},{"./svgGeometry":124,"./unicodeRegexes":126,"./utils":128,"babel-runtime/core-js/get-iterator":3,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],99:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./defineEnvironment");e("./environments/array.js");var n={has:function e(t){return a._environments.hasOwnProperty(t)},get:function e(t){return a._environments[t]}};r.default=n},{"./defineEnvironment":95,"./environments/array.js":100}],100:[function(e,t,r){"use strict";var a=e("../buildCommon");var n=M(a);var i=e("../defineEnvironment");var l=M(i);var u=e("../mathMLTree");var o=M(u);var s=e("../ParseError");var f=M(s);var d=e("../ParseNode");var c=M(d);var h=e("../units");var v=e("../utils");var p=M(v);var m=e("../stretchy");var g=M(m);var b=e("../buildHTML");var y=k(b);var x=e("../buildMathML");var w=k(x);function k(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function M(e){return e&&e.__esModule?e:{default:e}}function _(e,t,r){var a=[];var n=[a];var i=[];while(true){var l=e.parseExpression(false,null);l=new c.default("ordgroup",l,e.mode);if(r){l=new c.default("styling",{style:r,value:[l]},e.mode)}a.push(l);var u=e.nextToken.text;if(u==="&"){e.consume()}else if(u==="\\end"){var o=n[n.length-1];if(n.length>1&&o.length===1&&o[0].value.value[0].value.length===0){n.pop()}break}else if(u==="\\\\"||u==="\\cr"){var s=e.parseFunction();i.push(s.value.size);a=[];n.push(a)}else{throw new f.default("Expected & or \\\\ or \\end",e.nextToken)}}t.body=n;t.rowGaps=i;return new c.default(t.type,t,e.mode)}function S(e){if(e.substr(0,1)==="d"){return"display"}else{return"text"}}var z=function e(t,r){var a=void 0;var i=void 0;var l=t.value.body.length;var u=0;var o=new Array(l);var s=1/r.fontMetrics().ptPerEm;var d=5*s;var c=12*s;var v=3*s;var m=p.default.deflt(t.value.arraystretch,1);var b=m*c;var x=.7*b;var w=.3*b;var k=0;for(a=0;a<t.value.body.length;++a){var M=t.value.body[a];var _=x;var S=w;if(u<M.length){u=M.length}var z=new Array(M.length);for(i=0;i<M.length;++i){var T=y.buildGroup(M[i],r);if(S<T.depth){S=T.depth}if(_<T.height){_=T.height}z[i]=T}var C=0;if(t.value.rowGaps[a]){C=(0,h.calculateSize)(t.value.rowGaps[a].value,r);if(C>0){C+=w;if(S<C){S=C}C=0}}if(t.value.addJot){S+=v}z.height=_;z.depth=S;k+=_;z.pos=k;k+=S+C;o[a]=z}var A=k/2+r.fontMetrics().axisHeight;var O=t.value.cols||[];var N=[];var L=void 0;var j=void 0;for(i=0,j=0;i<u||j<O.length;++i,++j){var E=O[j]||{};var q=true;while(E.type==="separator"){if(!q){L=n.default.makeSpan(["arraycolsep"],[]);L.style.width=r.fontMetrics().doubleRuleSep+"em";N.push(L)}if(E.separator==="|"){var P=g.default.ruleSpan("vertical-separator",r);P.style.height=k+"em";P.style.verticalAlign=-(k-A)+"em";N.push(P)}else{throw new f.default("Invalid separator type: "+E.separator)}j++;E=O[j]||{};q=false}if(i>=u){continue}var B=void 0;if(i>0||t.value.hskipBeforeAndAfter){B=p.default.deflt(E.pregap,d);if(B!==0){L=n.default.makeSpan(["arraycolsep"],[]);L.style.width=B+"em";N.push(L)}}var F=[];for(a=0;a<l;++a){var R=o[a];var D=R[i];if(!D){continue}var H=R.pos-A;D.depth=R.depth;D.height=R.height;F.push({type:"elem",elem:D,shift:H})}F=n.default.makeVList({positionType:"individualShift",children:F},r);F=n.default.makeSpan(["col-align-"+(E.align||"c")],[F]);N.push(F);if(i<u-1||t.value.hskipBeforeAndAfter){B=p.default.deflt(E.postgap,d);if(B!==0){L=n.default.makeSpan(["arraycolsep"],[]);L.style.width=B+"em";N.push(L)}}}o=n.default.makeSpan(["mtable"],N);return n.default.makeSpan(["mord"],[o],r)};var T=function e(t,r){return new o.default.MathNode("mtable",t.value.body.map(function(e){return new o.default.MathNode("mtr",e.map(function(e){return new o.default.MathNode("mtd",[w.buildGroup(e,r)])}))}))};var C=function e(t,r){var a={type:"array",cols:[],addJot:true};a=_(t.parser,a,"display");var n=void 0;var i=0;var l=new c.default("ordgroup",[],t.mode);if(r[0]&&r[0].value){var u="";for(var o=0;o<r[0].value.length;o++){u+=r[0].value[o].value}n=Number(u);i=n*2}var s=!i;a.value.body.forEach(function(e){for(var t=1;t<e.length;t+=2){var r=e[t].value.value[0];r.value.unshift(l)}if(!s){var a=e.length/2;if(n<a){throw new f.default("Too many math in a row: "+("expected "+n+", but got "+a),e)}}else if(i<e.length){i=e.length}});for(var d=0;d<i;++d){var h="r";var v=0;if(d%2===1){h="l"}else if(d>0&&s){v=1}a.value.cols[d]={type:"align",align:h,pregap:v,postgap:0}}return a};(0,l.default)({type:"array",names:["array","darray"],props:{numArgs:1},handler:function e(t,r){var a=r[0];a=a.value.map?a.value:[a];var n=a.map(function(e){var t=e.value;if("lcr".indexOf(t)!==-1){return{type:"align",align:t}}else if(t==="|"){return{type:"separator",separator:"|"}}throw new f.default("Unknown column alignment: "+e.value,e)});var i={type:"array",cols:n,hskipBeforeAndAfter:true};i=_(t.parser,i,S(t.envName));return i},htmlBuilder:z,mathmlBuilder:T});(0,l.default)({type:"array",names:["matrix","pmatrix","bmatrix","Bmatrix","vmatrix","Vmatrix"],props:{numArgs:0},handler:function e(t){var r={matrix:null,pmatrix:["(",")"],bmatrix:["[","]"],Bmatrix:["\\{","\\}"],vmatrix:["|","|"],Vmatrix:["\\Vert","\\Vert"]}[t.envName];var a={type:"array",hskipBeforeAndAfter:false};a=_(t.parser,a,S(t.envName));if(r){a=new c.default("leftright",{body:[a],left:r[0],right:r[1]},t.mode)}return a},htmlBuilder:z,mathmlBuilder:T});(0,l.default)({type:"array",names:["cases","dcases"],props:{numArgs:0},handler:function e(t){var r={type:"array",arraystretch:1.2,cols:[{type:"align",align:"l",pregap:0,postgap:1},{type:"align",align:"l",pregap:0,postgap:0}]};r=_(t.parser,r,S(t.envName));r=new c.default("leftright",{body:[r],left:"\\{",right:"."},t.mode);return r},htmlBuilder:z,mathmlBuilder:T});(0,l.default)({type:"array",names:["aligned"],props:{numArgs:0},handler:C,htmlBuilder:z,mathmlBuilder:T});(0,l.default)({type:"array",names:["gathered"],props:{numArgs:0},handler:function e(t){var r={type:"array",cols:[{type:"align",align:"c"}],addJot:true};r=_(t.parser,r,"display");return r},htmlBuilder:z,mathmlBuilder:T});(0,l.default)({type:"array",names:["alignedat"],props:{numArgs:1},handler:C,htmlBuilder:z,mathmlBuilder:T})},{"../ParseError":84,"../ParseNode":85,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineEnvironment":95,"../mathMLTree":121,"../stretchy":123,"../units":127,"../utils":128}],101:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./unicodeRegexes");var n=e("./fontMetricsData");var i=l(n);function l(e){return e&&e.__esModule?e:{default:e}}var u={slant:[.25,.25,.25],space:[0,0,0],stretch:[0,0,0],shrink:[0,0,0],xHeight:[.431,.431,.431],quad:[1,1.171,1.472],extraSpace:[0,0,0],num1:[.677,.732,.925],num2:[.394,.384,.387],num3:[.444,.471,.504],denom1:[.686,.752,1.025],denom2:[.345,.344,.532],sup1:[.413,.503,.504],sup2:[.363,.431,.404],sup3:[.289,.286,.294],sub1:[.15,.143,.2],sub2:[.247,.286,.4],supDrop:[.386,.353,.494],subDrop:[.05,.071,.1],delim1:[2.39,1.7,1.98],delim2:[1.01,1.157,1.42],axisHeight:[.25,.25,.25],defaultRuleThickness:[.04,.049,.049],bigOpSpacing1:[.111,.111,.111],bigOpSpacing2:[.166,.166,.166],bigOpSpacing3:[.2,.2,.2],bigOpSpacing4:[.6,.611,.611],bigOpSpacing5:[.1,.143,.143],sqrtRuleThickness:[.04,.04,.04],ptPerEm:[10,10,10],doubleRuleSep:[.2,.2,.2]};var o={"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"A","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"o","\xdf":"B","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"a","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"o","\xff":"y","\u0410":"A","\u0411":"B","\u0412":"B","\u0413":"F","\u0414":"A","\u0415":"E","\u0416":"K","\u0417":"3","\u0418":"N","\u0419":"N","\u041a":"K","\u041b":"N","\u041c":"M","\u041d":"H","\u041e":"O","\u041f":"N","\u0420":"P","\u0421":"C","\u0422":"T","\u0423":"y","\u0424":"O","\u0425":"X","\u0426":"U","\u0427":"h","\u0428":"W","\u0429":"W","\u042a":"B","\u042b":"X","\u042c":"B","\u042d":"3","\u042e":"X","\u042f":"R","\u0430":"a","\u0431":"b","\u0432":"a","\u0433":"r","\u0434":"y","\u0435":"e","\u0436":"m","\u0437":"e","\u0438":"n","\u0439":"n","\u043a":"n","\u043b":"n","\u043c":"m","\u043d":"n","\u043e":"o","\u043f":"n","\u0440":"p","\u0441":"c","\u0442":"o","\u0443":"y","\u0444":"b","\u0445":"x","\u0446":"n","\u0447":"n","\u0448":"w","\u0449":"w","\u044a":"a","\u044b":"m","\u044c":"a","\u044d":"e","\u044e":"m","\u044f":"r"};var s=function e(t,r){if(!i.default[r]){throw new Error("Font metrics not found for font: "+r+".")}var n=t.charCodeAt(0);if(t[0]in o){n=o[t[0]].charCodeAt(0)}else if(a.cjkRegex.test(t[0])){n="M".charCodeAt(0)}var l=i.default[r][""+n];if(l){return{depth:l[0],height:l[1],italic:l[2],skew:l[3],width:l[4]}}};var f={};var d=function e(t){var r=void 0;if(t>=5){r=0}else if(t>=3){r=1}else{r=2}if(!f[r]){var a=f[r]={cssEmPerMu:u.quad[r]/18};for(var n in u){if(u.hasOwnProperty(n)){a[n]=u[n][r]}}}return f[r]};r.default={getFontMetrics:d,getCharacterMetrics:s}},{"./fontMetricsData":102,"./unicodeRegexes":126}],102:[function(e,t,r){"use strict";t.exports={"AMS-Regular":{65:[0,.68889,0,0],66:[0,.68889,0,0],67:[0,.68889,0,0],68:[0,.68889,0,0],69:[0,.68889,0,0],70:[0,.68889,0,0],71:[0,.68889,0,0],72:[0,.68889,0,0],73:[0,.68889,0,0],74:[.16667,.68889,0,0],75:[0,.68889,0,0],76:[0,.68889,0,0],77:[0,.68889,0,0],78:[0,.68889,0,0],79:[.16667,.68889,0,0],80:[0,.68889,0,0],81:[.16667,.68889,0,0],82:[0,.68889,0,0],83:[0,.68889,0,0],84:[0,.68889,0,0],85:[0,.68889,0,0],86:[0,.68889,0,0],87:[0,.68889,0,0],88:[0,.68889,0,0],89:[0,.68889,0,0],90:[0,.68889,0,0],107:[0,.68889,0,0],165:[0,.675,.025,0],174:[.15559,.69224,0,0],240:[0,.68889,0,0],295:[0,.68889,0,0],710:[0,.825,0,0],732:[0,.9,0,0],770:[0,.825,0,0],771:[0,.9,0,0],989:[.08167,.58167,0,0],1008:[0,.43056,.04028,0],8245:[0,.54986,0,0],8463:[0,.68889,0,0],8487:[0,.68889,0,0],8498:[0,.68889,0,0],8502:[0,.68889,0,0],8503:[0,.68889,0,0],8504:[0,.68889,0,0],8513:[0,.68889,0,0],8592:[-.03598,.46402,0,0],8594:[-.03598,.46402,0,0],8602:[-.13313,.36687,0,0],8603:[-.13313,.36687,0,0],8606:[.01354,.52239,0,0],8608:[.01354,.52239,0,0],8610:[.01354,.52239,0,0],8611:[.01354,.52239,0,0],8619:[0,.54986,0,0],8620:[0,.54986,0,0],8621:[-.13313,.37788,0,0],8622:[-.13313,.36687,0,0],8624:[0,.69224,0,0],8625:[0,.69224,0,0],8630:[0,.43056,0,0],8631:[0,.43056,0,0],8634:[.08198,.58198,0,0],8635:[.08198,.58198,0,0],8638:[.19444,.69224,0,0],8639:[.19444,.69224,0,0],8642:[.19444,.69224,0,0],8643:[.19444,.69224,0,0],8644:[.1808,.675,0,0],8646:[.1808,.675,0,0],8647:[.1808,.675,0,0],8648:[.19444,.69224,0,0],8649:[.1808,.675,0,0],8650:[.19444,.69224,0,0],8651:[.01354,.52239,0,0],8652:[.01354,.52239,0,0],8653:[-.13313,.36687,0,0],8654:[-.13313,.36687,0,0],8655:[-.13313,.36687,0,0],8666:[.13667,.63667,0,0],8667:[.13667,.63667,0,0],8669:[-.13313,.37788,0,0],8672:[-.064,.437,0,0],8674:[-.064,.437,0,0],8705:[0,.825,0,0],8708:[0,.68889,0,0],8709:[.08167,.58167,0,0],8717:[0,.43056,0,0],8722:[-.03598,.46402,0,0],8724:[.08198,.69224,0,0],8726:[.08167,.58167,0,0],8733:[0,.69224,0,0],8736:[0,.69224,0,0],8737:[0,.69224,0,0],8738:[.03517,.52239,0,0],8739:[.08167,.58167,0,0],8740:[.25142,.74111,0,0],8741:[.08167,.58167,0,0],8742:[.25142,.74111,0,0],8756:[0,.69224,0,0],8757:[0,.69224,0,0],8764:[-.13313,.36687,0,0],8765:[-.13313,.37788,0,0],8769:[-.13313,.36687,0,0],8770:[-.03625,.46375,0,0],8774:[.30274,.79383,0,0],8776:[-.01688,.48312,0,0],8778:[.08167,.58167,0,0],8782:[.06062,.54986,0,0],8783:[.06062,.54986,0,0],8785:[.08198,.58198,0,0],8786:[.08198,.58198,0,0],8787:[.08198,.58198,0,0],8790:[0,.69224,0,0],8791:[.22958,.72958,0,0],8796:[.08198,.91667,0,0],8806:[.25583,.75583,0,0],8807:[.25583,.75583,0,0],8808:[.25142,.75726,0,0],8809:[.25142,.75726,0,0],8812:[.25583,.75583,0,0],8814:[.20576,.70576,0,0],8815:[.20576,.70576,0,0],8816:[.30274,.79383,0,0],8817:[.30274,.79383,0,0],8818:[.22958,.72958,0,0],8819:[.22958,.72958,0,0],8822:[.1808,.675,0,0],8823:[.1808,.675,0,0],8828:[.13667,.63667,0,0],8829:[.13667,.63667,0,0],8830:[.22958,.72958,0,0],8831:[.22958,.72958,0,0],8832:[.20576,.70576,0,0],8833:[.20576,.70576,0,0],8840:[.30274,.79383,0,0],8841:[.30274,.79383,0,0],8842:[.13597,.63597,0,0],8843:[.13597,.63597,0,0],8847:[.03517,.54986,0,0],8848:[.03517,.54986,0,0],8858:[.08198,.58198,0,0],8859:[.08198,.58198,0,0],8861:[.08198,.58198,0,0],8862:[0,.675,0,0],8863:[0,.675,0,0],8864:[0,.675,0,0],8865:[0,.675,0,0],8872:[0,.69224,0,0],8873:[0,.69224,0,0],8874:[0,.69224,0,0],8876:[0,.68889,0,0],8877:[0,.68889,0,0],8878:[0,.68889,0,0],8879:[0,.68889,0,0],8882:[.03517,.54986,0,0],8883:[.03517,.54986,0,0],8884:[.13667,.63667,0,0],8885:[.13667,.63667,0,0],8888:[0,.54986,0,0],8890:[.19444,.43056,0,0],8891:[.19444,.69224,0,0],8892:[.19444,.69224,0,0],8901:[0,.54986,0,0],8903:[.08167,.58167,0,0],8905:[.08167,.58167,0,0],8906:[.08167,.58167,0,0],8907:[0,.69224,0,0],8908:[0,.69224,0,0],8909:[-.03598,.46402,0,0],8910:[0,.54986,0,0],8911:[0,.54986,0,0],8912:[.03517,.54986,0,0],8913:[.03517,.54986,0,0],8914:[0,.54986,0,0],8915:[0,.54986,0,0],8916:[0,.69224,0,0],8918:[.0391,.5391,0,0],8919:[.0391,.5391,0,0],8920:[.03517,.54986,0,0],8921:[.03517,.54986,0,0],8922:[.38569,.88569,0,0],8923:[.38569,.88569,0,0],8926:[.13667,.63667,0,0],8927:[.13667,.63667,0,0],8928:[.30274,.79383,0,0],8929:[.30274,.79383,0,0],8934:[.23222,.74111,0,0],8935:[.23222,.74111,0,0],8936:[.23222,.74111,0,0],8937:[.23222,.74111,0,0],8938:[.20576,.70576,0,0],8939:[.20576,.70576,0,0],8940:[.30274,.79383,0,0],8941:[.30274,.79383,0,0],8994:[.19444,.69224,0,0],8995:[.19444,.69224,0,0],9416:[.15559,.69224,0,0],9484:[0,.69224,0,0],9488:[0,.69224,0,0],9492:[0,.37788,0,0],9496:[0,.37788,0,0],9585:[.19444,.68889,0,0],9586:[.19444,.74111,0,0],9632:[0,.675,0,0],9633:[0,.675,0,0],9650:[0,.54986,0,0],9651:[0,.54986,0,0],9654:[.03517,.54986,0,0],9660:[0,.54986,0,0],9661:[0,.54986,0,0],9664:[.03517,.54986,0,0],9674:[.11111,.69224,0,0],9733:[.19444,.69224,0,0],10003:[0,.69224,0,0],10016:[0,.69224,0,0],10731:[.11111,.69224,0,0],10846:[.19444,.75583,0,0],10877:[.13667,.63667,0,0],10878:[.13667,.63667,0,0],10885:[.25583,.75583,0,0],10886:[.25583,.75583,0,0],10887:[.13597,.63597,0,0],10888:[.13597,.63597,0,0],10889:[.26167,.75726,0,0],10890:[.26167,.75726,0,0],10891:[.48256,.98256,0,0],10892:[.48256,.98256,0,0],10901:[.13667,.63667,0,0],10902:[.13667,.63667,0,0],10933:[.25142,.75726,0,0],10934:[.25142,.75726,0,0],10935:[.26167,.75726,0,0],10936:[.26167,.75726,0,0],10937:[.26167,.75726,0,0],10938:[.26167,.75726,0,0],10949:[.25583,.75583,0,0],10950:[.25583,.75583,0,0],10955:[.28481,.79383,0,0],10956:[.28481,.79383,0,0],57350:[.08167,.58167,0,0],57351:[.08167,.58167,0,0],57352:[.08167,.58167,0,0],57353:[0,.43056,.04028,0],57356:[.25142,.75726,0,0],57357:[.25142,.75726,0,0],57358:[.41951,.91951,0,0],57359:[.30274,.79383,0,0],57360:[.30274,.79383,0,0],57361:[.41951,.91951,0,0],57366:[.25142,.75726,0,0],57367:[.25142,.75726,0,0],57368:[.25142,.75726,0,0],57369:[.25142,.75726,0,0],57370:[.13597,.63597,0,0],57371:[.13597,.63597,0,0]},"Caligraphic-Regular":{48:[0,.43056,0,0],49:[0,.43056,0,0],50:[0,.43056,0,0],51:[.19444,.43056,0,0],52:[.19444,.43056,0,0],53:[.19444,.43056,0,0],54:[0,.64444,0,0],55:[.19444,.43056,0,0],56:[0,.64444,0,0],57:[.19444,.43056,0,0],65:[0,.68333,0,.19445],66:[0,.68333,.03041,.13889],67:[0,.68333,.05834,.13889],68:[0,.68333,.02778,.08334],69:[0,.68333,.08944,.11111],70:[0,.68333,.09931,.11111],71:[.09722,.68333,.0593,.11111],72:[0,.68333,.00965,.11111],73:[0,.68333,.07382,0],74:[.09722,.68333,.18472,.16667],75:[0,.68333,.01445,.05556],76:[0,.68333,0,.13889],77:[0,.68333,0,.13889],78:[0,.68333,.14736,.08334],79:[0,.68333,.02778,.11111],80:[0,.68333,.08222,.08334],81:[.09722,.68333,0,.11111],82:[0,.68333,0,.08334],83:[0,.68333,.075,.13889],84:[0,.68333,.25417,0],85:[0,.68333,.09931,.08334],86:[0,.68333,.08222,0],87:[0,.68333,.08222,.08334],88:[0,.68333,.14643,.13889],89:[.09722,.68333,.08222,.08334],90:[0,.68333,.07944,.13889]},"Fraktur-Regular":{33:[0,.69141,0,0],34:[0,.69141,0,0],38:[0,.69141,0,0],39:[0,.69141,0,0],40:[.24982,.74947,0,0],41:[.24982,.74947,0,0],42:[0,.62119,0,0],43:[.08319,.58283,0,0],44:[0,.10803,0,0],45:[.08319,.58283,0,0],46:[0,.10803,0,0],47:[.24982,.74947,0,0],48:[0,.47534,0,0],49:[0,.47534,0,0],50:[0,.47534,0,0],51:[.18906,.47534,0,0],52:[.18906,.47534,0,0],53:[.18906,.47534,0,0],54:[0,.69141,0,0],55:[.18906,.47534,0,0],56:[0,.69141,0,0],57:[.18906,.47534,0,0],58:[0,.47534,0,0],59:[.12604,.47534,0,0],61:[-.13099,.36866,0,0],63:[0,.69141,0,0],65:[0,.69141,0,0],66:[0,.69141,0,0],67:[0,.69141,0,0],68:[0,.69141,0,0],69:[0,.69141,0,0],70:[.12604,.69141,0,0],71:[0,.69141,0,0],72:[.06302,.69141,0,0],73:[0,.69141,0,0],74:[.12604,.69141,0,0],75:[0,.69141,0,0],76:[0,.69141,0,0],77:[0,.69141,0,0],78:[0,.69141,0,0],79:[0,.69141,0,0],80:[.18906,.69141,0,0],81:[.03781,.69141,0,0],82:[0,.69141,0,0],83:[0,.69141,0,0],84:[0,.69141,0,0],85:[0,.69141,0,0],86:[0,.69141,0,0],87:[0,.69141,0,0],88:[0,.69141,0,0],89:[.18906,.69141,0,0],90:[.12604,.69141,0,0],91:[.24982,.74947,0,0],93:[.24982,.74947,0,0],94:[0,.69141,0,0],97:[0,.47534,0,0],98:[0,.69141,0,0],99:[0,.47534,0,0],100:[0,.62119,0,0],101:[0,.47534,0,0],102:[.18906,.69141,0,0],103:[.18906,.47534,0,0],104:[.18906,.69141,0,0],105:[0,.69141,0,0],106:[0,.69141,0,0],107:[0,.69141,0,0],108:[0,.69141,0,0],109:[0,.47534,0,0],110:[0,.47534,0,0],111:[0,.47534,0,0],112:[.18906,.52396,0,0],113:[.18906,.47534,0,0],114:[0,.47534,0,0],115:[0,.47534,0,0],116:[0,.62119,0,0],117:[0,.47534,0,0],118:[0,.52396,0,0],119:[0,.52396,0,0],120:[.18906,.47534,0,0],121:[.18906,.47534,0,0],122:[.18906,.47534,0,0],8216:[0,.69141,0,0],8217:[0,.69141,0,0],58112:[0,.62119,0,0],58113:[0,.62119,0,0],58114:[.18906,.69141,0,0],58115:[.18906,.69141,0,0],58116:[.18906,.47534,0,0],58117:[0,.69141,0,0],58118:[0,.62119,0,0],58119:[0,.47534,0,0]},"Main-Bold":{33:[0,.69444,0,0],34:[0,.69444,0,0],35:[.19444,.69444,0,0],36:[.05556,.75,0,0],37:[.05556,.75,0,0],38:[0,.69444,0,0],39:[0,.69444,0,0],40:[.25,.75,0,0],41:[.25,.75,0,0],42:[0,.75,0,0],43:[.13333,.63333,0,0],44:[.19444,.15556,0,0],45:[0,.44444,0,0],46:[0,.15556,0,0],47:[.25,.75,0,0],48:[0,.64444,0,0],49:[0,.64444,0,0],50:[0,.64444,0,0],51:[0,.64444,0,0],52:[0,.64444,0,0],53:[0,.64444,0,0],54:[0,.64444,0,0],55:[0,.64444,0,0],56:[0,.64444,0,0],57:[0,.64444,0,0],58:[0,.44444,0,0],59:[.19444,.44444,0,0],60:[.08556,.58556,0,0],61:[-.10889,.39111,0,0],62:[.08556,.58556,0,0],63:[0,.69444,0,0],64:[0,.69444,0,0],65:[0,.68611,0,0],66:[0,.68611,0,0],67:[0,.68611,0,0],68:[0,.68611,0,0],69:[0,.68611,0,0],70:[0,.68611,0,0],71:[0,.68611,0,0],72:[0,.68611,0,0],73:[0,.68611,0,0],74:[0,.68611,0,0],75:[0,.68611,0,0],76:[0,.68611,0,0],77:[0,.68611,0,0],78:[0,.68611,0,0],79:[0,.68611,0,0],80:[0,.68611,0,0],81:[.19444,.68611,0,0],82:[0,.68611,0,0],83:[0,.68611,0,0],84:[0,.68611,0,0],85:[0,.68611,0,0],86:[0,.68611,.01597,0],87:[0,.68611,.01597,0],88:[0,.68611,0,0],89:[0,.68611,.02875,0],90:[0,.68611,0,0],91:[.25,.75,0,0],92:[.25,.75,0,0],93:[.25,.75,0,0],94:[0,.69444,0,0],95:[.31,.13444,.03194,0],96:[0,.69444,0,0],97:[0,.44444,0,0],98:[0,.69444,0,0],99:[0,.44444,0,0],100:[0,.69444,0,0],101:[0,.44444,0,0],102:[0,.69444,.10903,0],103:[.19444,.44444,.01597,0],104:[0,.69444,0,0],105:[0,.69444,0,0],106:[.19444,.69444,0,0],107:[0,.69444,0,0],108:[0,.69444,0,0],109:[0,.44444,0,0],110:[0,.44444,0,0],111:[0,.44444,0,0],112:[.19444,.44444,0,0],113:[.19444,.44444,0,0],114:[0,.44444,0,0],115:[0,.44444,0,0],116:[0,.63492,0,0],117:[0,.44444,0,0],118:[0,.44444,.01597,0],119:[0,.44444,.01597,0],120:[0,.44444,0,0],121:[.19444,.44444,.01597,0],122:[0,.44444,0,0],123:[.25,.75,0,0],124:[.25,.75,0,0],125:[.25,.75,0,0],126:[.35,.34444,0,0],168:[0,.69444,0,0],172:[0,.44444,0,0],175:[0,.59611,0,0],176:[0,.69444,0,0],177:[.13333,.63333,0,0],180:[0,.69444,0,0],215:[.13333,.63333,0,0],247:[.13333,.63333,0,0],305:[0,.44444,0,0],567:[.19444,.44444,0,0],710:[0,.69444,0,0],711:[0,.63194,0,0],713:[0,.59611,0,0],714:[0,.69444,0,0],715:[0,.69444,0,0],728:[0,.69444,0,0],729:[0,.69444,0,0],730:[0,.69444,0,0],732:[0,.69444,0,0],768:[0,.69444,0,0],769:[0,.69444,0,0],770:[0,.69444,0,0],771:[0,.69444,0,0],772:[0,.59611,0,0],774:[0,.69444,0,0],775:[0,.69444,0,0],776:[0,.69444,0,0],778:[0,.69444,0,0],779:[0,.69444,0,0],780:[0,.63194,0,0],824:[.19444,.69444,0,0],915:[0,.68611,0,0],916:[0,.68611,0,0],920:[0,.68611,0,0],923:[0,.68611,0,0],926:[0,.68611,0,0],928:[0,.68611,0,0],931:[0,.68611,0,0],933:[0,.68611,0,0],934:[0,.68611,0,0],936:[0,.68611,0,0],937:[0,.68611,0,0],8211:[0,.44444,.03194,0],8212:[0,.44444,.03194,0],8216:[0,.69444,0,0],8217:[0,.69444,0,0],8220:[0,.69444,0,0],8221:[0,.69444,0,0],8224:[.19444,.69444,0,0],8225:[.19444,.69444,0,0],8242:[0,.55556,0,0],8407:[0,.72444,.15486,0],8463:[0,.69444,0,0],8465:[0,.69444,0,0],8467:[0,.69444,0,0],8472:[.19444,.44444,0,0],8476:[0,.69444,0,0],8501:[0,.69444,0,0],8592:[-.10889,.39111,0,0],8593:[.19444,.69444,0,0],8594:[-.10889,.39111,0,0],8595:[.19444,.69444,0,0],8596:[-.10889,.39111,0,0],8597:[.25,.75,0,0],8598:[.19444,.69444,0,0],8599:[.19444,.69444,0,0],8600:[.19444,.69444,0,0],8601:[.19444,.69444,0,0],8636:[-.10889,.39111,0,0],8637:[-.10889,.39111,0,0],8640:[-.10889,.39111,0,0],8641:[-.10889,.39111,0,0],8656:[-.10889,.39111,0,0],8657:[.19444,.69444,0,0],8658:[-.10889,.39111,0,0],8659:[.19444,.69444,0,0],8660:[-.10889,.39111,0,0],8661:[.25,.75,0,0],8704:[0,.69444,0,0],8706:[0,.69444,.06389,0],8707:[0,.69444,0,0],8709:[.05556,.75,0,0],8711:[0,.68611,0,0],8712:[.08556,.58556,0,0],8715:[.08556,.58556,0,0],8722:[.13333,.63333,0,0],8723:[.13333,.63333,0,0],8725:[.25,.75,0,0],8726:[.25,.75,0,0],8727:[-.02778,.47222,0,0],8728:[-.02639,.47361,0,0],8729:[-.02639,.47361,0,0],8730:[.18,.82,0,0],8733:[0,.44444,0,0],8734:[0,.44444,0,0],8736:[0,.69224,0,0],8739:[.25,.75,0,0],8741:[.25,.75,0,0],8743:[0,.55556,0,0],8744:[0,.55556,0,0],8745:[0,.55556,0,0],8746:[0,.55556,0,0],8747:[.19444,.69444,.12778,0],8764:[-.10889,.39111,0,0],8768:[.19444,.69444,0,0],8771:[.00222,.50222,0,0],8776:[.02444,.52444,0,0],8781:[.00222,.50222,0,0],8801:[.00222,.50222,0,0],8804:[.19667,.69667,0,0],8805:[.19667,.69667,0,0],8810:[.08556,.58556,0,0],8811:[.08556,.58556,0,0],8826:[.08556,.58556,0,0],8827:[.08556,.58556,0,0],8834:[.08556,.58556,0,0],8835:[.08556,.58556,0,0],8838:[.19667,.69667,0,0],8839:[.19667,.69667,0,0],8846:[0,.55556,0,0],8849:[.19667,.69667,0,0],8850:[.19667,.69667,0,0],8851:[0,.55556,0,0],8852:[0,.55556,0,0],8853:[.13333,.63333,0,0],8854:[.13333,.63333,0,0],8855:[.13333,.63333,0,0],8856:[.13333,.63333,0,0],8857:[.13333,.63333,0,0],8866:[0,.69444,0,0],8867:[0,.69444,0,0],8868:[0,.69444,0,0],8869:[0,.69444,0,0],8900:[-.02639,.47361,0,0],8901:[-.02639,.47361,0,0],8902:[-.02778,.47222,0,0],8968:[.25,.75,0,0],8969:[.25,.75,0,0],8970:[.25,.75,0,0],8971:[.25,.75,0,0],8994:[-.13889,.36111,0,0],8995:[-.13889,.36111,0,0],9651:[.19444,.69444,0,0],9657:[-.02778,.47222,0,0],9661:[.19444,.69444,0,0],9667:[-.02778,.47222,0,0],9711:[.19444,.69444,0,0],9824:[.12963,.69444,0,0],9825:[.12963,.69444,0,0],9826:[.12963,.69444,0,0],9827:[.12963,.69444,0,0],9837:[0,.75,0,0],9838:[.19444,.69444,0,0],9839:[.19444,.69444,0,0],10216:[.25,.75,0,0],10217:[.25,.75,0,0],10815:[0,.68611,0,0],10927:[.19667,.69667,0,0],10928:[.19667,.69667,0,0]},"Main-Italic":{33:[0,.69444,.12417,0],34:[0,.69444,.06961,0],35:[.19444,.69444,.06616,0],37:[.05556,.75,.13639,0],38:[0,.69444,.09694,0],39:[0,.69444,.12417,0],40:[.25,.75,.16194,0],41:[.25,.75,.03694,0],42:[0,.75,.14917,0],43:[.05667,.56167,.03694,0],44:[.19444,.10556,0,0],45:[0,.43056,.02826,0],46:[0,.10556,0,0],47:[.25,.75,.16194,0],48:[0,.64444,.13556,0],49:[0,.64444,.13556,0],50:[0,.64444,.13556,0],51:[0,.64444,.13556,0],52:[.19444,.64444,.13556,0],53:[0,.64444,.13556,0],54:[0,.64444,.13556,0],55:[.19444,.64444,.13556,0],56:[0,.64444,.13556,0],57:[0,.64444,.13556,0],58:[0,.43056,.0582,0],59:[.19444,.43056,.0582,0],61:[-.13313,.36687,.06616,0],63:[0,.69444,.1225,0],64:[0,.69444,.09597,0],65:[0,.68333,0,0],66:[0,.68333,.10257,0],67:[0,.68333,.14528,0],68:[0,.68333,.09403,0],69:[0,.68333,.12028,0],70:[0,.68333,.13305,0],71:[0,.68333,.08722,0],72:[0,.68333,.16389,0],73:[0,.68333,.15806,0],74:[0,.68333,.14028,0],75:[0,.68333,.14528,0],76:[0,.68333,0,0],77:[0,.68333,.16389,0],78:[0,.68333,.16389,0],79:[0,.68333,.09403,0],80:[0,.68333,.10257,0],81:[.19444,.68333,.09403,0],82:[0,.68333,.03868,0],83:[0,.68333,.11972,0],84:[0,.68333,.13305,0],85:[0,.68333,.16389,0],86:[0,.68333,.18361,0],87:[0,.68333,.18361,0],88:[0,.68333,.15806,0],89:[0,.68333,.19383,0],90:[0,.68333,.14528,0],91:[.25,.75,.1875,0],93:[.25,.75,.10528,0],94:[0,.69444,.06646,0],95:[.31,.12056,.09208,0],97:[0,.43056,.07671,0],98:[0,.69444,.06312,0],99:[0,.43056,.05653,0],100:[0,.69444,.10333,0],101:[0,.43056,.07514,0],102:[.19444,.69444,.21194,0],103:[.19444,.43056,.08847,0],104:[0,.69444,.07671,0],105:[0,.65536,.1019,0],106:[.19444,.65536,.14467,0],107:[0,.69444,.10764,0],108:[0,.69444,.10333,0],109:[0,.43056,.07671,0],110:[0,.43056,.07671,0],111:[0,.43056,.06312,0],112:[.19444,.43056,.06312,0],113:[.19444,.43056,.08847,0],114:[0,.43056,.10764,0],115:[0,.43056,.08208,0],116:[0,.61508,.09486,0],117:[0,.43056,.07671,0],118:[0,.43056,.10764,0],119:[0,.43056,.10764,0],120:[0,.43056,.12042,0],121:[.19444,.43056,.08847,0],122:[0,.43056,.12292,0],126:[.35,.31786,.11585,0],163:[0,.69444,0,0],305:[0,.43056,0,.02778],567:[.19444,.43056,0,.08334],768:[0,.69444,0,0],769:[0,.69444,.09694,0],770:[0,.69444,.06646,0],771:[0,.66786,.11585,0],772:[0,.56167,.10333,0],774:[0,.69444,.10806,0],775:[0,.66786,.11752,0],776:[0,.66786,.10474,0],778:[0,.69444,0,0],779:[0,.69444,.1225,0],780:[0,.62847,.08295,0],915:[0,.68333,.13305,0],916:[0,.68333,0,0],920:[0,.68333,.09403,0],923:[0,.68333,0,0],926:[0,.68333,.15294,0],928:[0,.68333,.16389,0],931:[0,.68333,.12028,0],933:[0,.68333,.11111,0],934:[0,.68333,.05986,0],936:[0,.68333,.11111,0],937:[0,.68333,.10257,0],8211:[0,.43056,.09208,0],8212:[0,.43056,.09208,0],8216:[0,.69444,.12417,0],8217:[0,.69444,.12417,0],8220:[0,.69444,.1685,0],8221:[0,.69444,.06961,0],8463:[0,.68889,0,0]},"Main-Regular":{32:[0,0,0,0],33:[0,.69444,0,0],34:[0,.69444,0,0],35:[.19444,.69444,0,0],36:[.05556,.75,0,0],37:[.05556,.75,0,0],38:[0,.69444,0,0],39:[0,.69444,0,0],40:[.25,.75,0,0],41:[.25,.75,0,0],42:[0,.75,0,0],43:[.08333,.58333,0,0],44:[.19444,.10556,0,0],45:[0,.43056,0,0],46:[0,.10556,0,0],47:[.25,.75,0,0],48:[0,.64444,0,0],49:[0,.64444,0,0],50:[0,.64444,0,0],51:[0,.64444,0,0],52:[0,.64444,0,0],53:[0,.64444,0,0],54:[0,.64444,0,0],55:[0,.64444,0,0],56:[0,.64444,0,0],57:[0,.64444,0,0],58:[0,.43056,0,0],59:[.19444,.43056,0,0],60:[.0391,.5391,0,0],61:[-.13313,.36687,0,0],62:[.0391,.5391,0,0],63:[0,.69444,0,0],64:[0,.69444,0,0],65:[0,.68333,0,0],66:[0,.68333,0,0],67:[0,.68333,0,0],68:[0,.68333,0,0],69:[0,.68333,0,0],70:[0,.68333,0,0],71:[0,.68333,0,0],72:[0,.68333,0,0],73:[0,.68333,0,0],74:[0,.68333,0,0],75:[0,.68333,0,0],76:[0,.68333,0,0],77:[0,.68333,0,0],78:[0,.68333,0,0],79:[0,.68333,0,0],80:[0,.68333,0,0],81:[.19444,.68333,0,0],82:[0,.68333,0,0],83:[0,.68333,0,0],84:[0,.68333,0,0],85:[0,.68333,0,0],86:[0,.68333,.01389,0],87:[0,.68333,.01389,0],88:[0,.68333,0,0],89:[0,.68333,.025,0],90:[0,.68333,0,0],91:[.25,.75,0,0],92:[.25,.75,0,0],93:[.25,.75,0,0],94:[0,.69444,0,0],95:[.31,.12056,.02778,0],96:[0,.69444,0,0],97:[0,.43056,0,0],98:[0,.69444,0,0],99:[0,.43056,0,0],100:[0,.69444,0,0],101:[0,.43056,0,0],102:[0,.69444,.07778,0],103:[.19444,.43056,.01389,0],104:[0,.69444,0,0],105:[0,.66786,0,0],106:[.19444,.66786,0,0],107:[0,.69444,0,0],108:[0,.69444,0,0],109:[0,.43056,0,0],110:[0,.43056,0,0],111:[0,.43056,0,0],112:[.19444,.43056,0,0],113:[.19444,.43056,0,0],114:[0,.43056,0,0],115:[0,.43056,0,0],116:[0,.61508,0,0],117:[0,.43056,0,0],118:[0,.43056,.01389,0],119:[0,.43056,.01389,0],120:[0,.43056,0,0],121:[.19444,.43056,.01389,0],122:[0,.43056,0,0],123:[.25,.75,0,0],124:[.25,.75,0,0],125:[.25,.75,0,0],126:[.35,.31786,0,0],160:[0,0,0,0],168:[0,.66786,0,0],172:[0,.43056,0,0],175:[0,.56778,0,0],176:[0,.69444,0,0],177:[.08333,.58333,0,0],180:[0,.69444,0,0],215:[.08333,.58333,0,0],247:[.08333,.58333,0,0],305:[0,.43056,0,0],567:[.19444,.43056,0,0],710:[0,.69444,0,0],711:[0,.62847,0,0],713:[0,.56778,0,0],714:[0,.69444,0,0],715:[0,.69444,0,0],728:[0,.69444,0,0],729:[0,.66786,0,0],730:[0,.69444,0,0],732:[0,.66786,0,0],768:[0,.69444,0,0],769:[0,.69444,0,0],770:[0,.69444,0,0],771:[0,.66786,0,0],772:[0,.56778,0,0],774:[0,.69444,0,0],775:[0,.66786,0,0],776:[0,.66786,0,0],778:[0,.69444,0,0],779:[0,.69444,0,0],780:[0,.62847,0,0],824:[.19444,.69444,0,0],915:[0,.68333,0,0],916:[0,.68333,0,0],920:[0,.68333,0,0],923:[0,.68333,0,0],926:[0,.68333,0,0],928:[0,.68333,0,0],931:[0,.68333,0,0],933:[0,.68333,0,0],934:[0,.68333,0,0],936:[0,.68333,0,0],937:[0,.68333,0,0],8211:[0,.43056,.02778,0],8212:[0,.43056,.02778,0],8216:[0,.69444,0,0],8217:[0,.69444,0,0],8220:[0,.69444,0,0],8221:[0,.69444,0,0],8224:[.19444,.69444,0,0],8225:[.19444,.69444,0,0],8230:[0,.12,0,0],8242:[0,.55556,0,0],8407:[0,.71444,.15382,0],8463:[0,.68889,0,0],8465:[0,.69444,0,0],8467:[0,.69444,0,.11111],8472:[.19444,.43056,0,.11111],8476:[0,.69444,0,0],8501:[0,.69444,0,0],8592:[-.13313,.36687,0,0],8593:[.19444,.69444,0,0],8594:[-.13313,.36687,0,0],8595:[.19444,.69444,0,0],8596:[-.13313,.36687,0,0],8597:[.25,.75,0,0],8598:[.19444,.69444,0,0],8599:[.19444,.69444,0,0],8600:[.19444,.69444,0,0],8601:[.19444,.69444,0,0],8614:[.011,.511,0,0],8617:[.011,.511,0,0],8618:[.011,.511,0,0],8636:[-.13313,.36687,0,0],8637:[-.13313,.36687,0,0],8640:[-.13313,.36687,0,0],8641:[-.13313,.36687,0,0],8652:[.011,.671,0,0],8656:[-.13313,.36687,0,0],8657:[.19444,.69444,0,0],8658:[-.13313,.36687,0,0],8659:[.19444,.69444,0,0],8660:[-.13313,.36687,0,0],8661:[.25,.75,0,0],8704:[0,.69444,0,0],8706:[0,.69444,.05556,.08334],8707:[0,.69444,0,0],8709:[.05556,.75,0,0],8711:[0,.68333,0,0],8712:[.0391,.5391,0,0],8715:[.0391,.5391,0,0],8722:[.08333,.58333,0,0],8723:[.08333,.58333,0,0],8725:[.25,.75,0,0],8726:[.25,.75,0,0],8727:[-.03472,.46528,0,0],8728:[-.05555,.44445,0,0],8729:[-.05555,.44445,0,0],8730:[.2,.8,0,0],8733:[0,.43056,0,0],8734:[0,.43056,0,0],8736:[0,.69224,0,0],8739:[.25,.75,0,0],8741:[.25,.75,0,0],8743:[0,.55556,0,0],8744:[0,.55556,0,0],8745:[0,.55556,0,0],8746:[0,.55556,0,0],8747:[.19444,.69444,.11111,0],8764:[-.13313,.36687,0,0],8768:[.19444,.69444,0,0],8771:[-.03625,.46375,0,0],8773:[-.022,.589,0,0],8776:[-.01688,.48312,0,0],8781:[-.03625,.46375,0,0],8784:[-.133,.67,0,0],8800:[.215,.716,0,0],8801:[-.03625,.46375,0,0],8804:[.13597,.63597,0,0],8805:[.13597,.63597,0,0],8810:[.0391,.5391,0,0],8811:[.0391,.5391,0,0],8826:[.0391,.5391,0,0],8827:[.0391,.5391,0,0],8834:[.0391,.5391,0,0],8835:[.0391,.5391,0,0],8838:[.13597,.63597,0,0],8839:[.13597,.63597,0,0],8846:[0,.55556,0,0],8849:[.13597,.63597,0,0],8850:[.13597,.63597,0,0],
8851:[0,.55556,0,0],8852:[0,.55556,0,0],8853:[.08333,.58333,0,0],8854:[.08333,.58333,0,0],8855:[.08333,.58333,0,0],8856:[.08333,.58333,0,0],8857:[.08333,.58333,0,0],8866:[0,.69444,0,0],8867:[0,.69444,0,0],8868:[0,.69444,0,0],8869:[0,.69444,0,0],8872:[.249,.75,0,0],8900:[-.05555,.44445,0,0],8901:[-.05555,.44445,0,0],8902:[-.03472,.46528,0,0],8904:[.005,.505,0,0],8942:[.03,.9,0,0],8943:[-.19,.31,0,0],8945:[-.1,.82,0,0],8968:[.25,.75,0,0],8969:[.25,.75,0,0],8970:[.25,.75,0,0],8971:[.25,.75,0,0],8994:[-.14236,.35764,0,0],8995:[-.14236,.35764,0,0],9136:[.244,.744,0,0],9137:[.244,.744,0,0],9651:[.19444,.69444,0,0],9657:[-.03472,.46528,0,0],9661:[.19444,.69444,0,0],9667:[-.03472,.46528,0,0],9711:[.19444,.69444,0,0],9824:[.12963,.69444,0,0],9825:[.12963,.69444,0,0],9826:[.12963,.69444,0,0],9827:[.12963,.69444,0,0],9837:[0,.75,0,0],9838:[.19444,.69444,0,0],9839:[.19444,.69444,0,0],10216:[.25,.75,0,0],10217:[.25,.75,0,0],10222:[.244,.744,0,0],10223:[.244,.744,0,0],10229:[.011,.511,0,0],10230:[.011,.511,0,0],10231:[.011,.511,0,0],10232:[.024,.525,0,0],10233:[.024,.525,0,0],10234:[.024,.525,0,0],10236:[.011,.511,0,0],10815:[0,.68333,0,0],10927:[.13597,.63597,0,0],10928:[.13597,.63597,0,0]},"Math-BoldItalic":{47:[.19444,.69444,0,0],65:[0,.68611,0,0],66:[0,.68611,.04835,0],67:[0,.68611,.06979,0],68:[0,.68611,.03194,0],69:[0,.68611,.05451,0],70:[0,.68611,.15972,0],71:[0,.68611,0,0],72:[0,.68611,.08229,0],73:[0,.68611,.07778,0],74:[0,.68611,.10069,0],75:[0,.68611,.06979,0],76:[0,.68611,0,0],77:[0,.68611,.11424,0],78:[0,.68611,.11424,0],79:[0,.68611,.03194,0],80:[0,.68611,.15972,0],81:[.19444,.68611,0,0],82:[0,.68611,.00421,0],83:[0,.68611,.05382,0],84:[0,.68611,.15972,0],85:[0,.68611,.11424,0],86:[0,.68611,.25555,0],87:[0,.68611,.15972,0],88:[0,.68611,.07778,0],89:[0,.68611,.25555,0],90:[0,.68611,.06979,0],97:[0,.44444,0,0],98:[0,.69444,0,0],99:[0,.44444,0,0],100:[0,.69444,0,0],101:[0,.44444,0,0],102:[.19444,.69444,.11042,0],103:[.19444,.44444,.03704,0],104:[0,.69444,0,0],105:[0,.69326,0,0],106:[.19444,.69326,.0622,0],107:[0,.69444,.01852,0],108:[0,.69444,.0088,0],109:[0,.44444,0,0],110:[0,.44444,0,0],111:[0,.44444,0,0],112:[.19444,.44444,0,0],113:[.19444,.44444,.03704,0],114:[0,.44444,.03194,0],115:[0,.44444,0,0],116:[0,.63492,0,0],117:[0,.44444,0,0],118:[0,.44444,.03704,0],119:[0,.44444,.02778,0],120:[0,.44444,0,0],121:[.19444,.44444,.03704,0],122:[0,.44444,.04213,0],915:[0,.68611,.15972,0],916:[0,.68611,0,0],920:[0,.68611,.03194,0],923:[0,.68611,0,0],926:[0,.68611,.07458,0],928:[0,.68611,.08229,0],931:[0,.68611,.05451,0],933:[0,.68611,.15972,0],934:[0,.68611,0,0],936:[0,.68611,.11653,0],937:[0,.68611,.04835,0],945:[0,.44444,0,0],946:[.19444,.69444,.03403,0],947:[.19444,.44444,.06389,0],948:[0,.69444,.03819,0],949:[0,.44444,0,0],950:[.19444,.69444,.06215,0],951:[.19444,.44444,.03704,0],952:[0,.69444,.03194,0],953:[0,.44444,0,0],954:[0,.44444,0,0],955:[0,.69444,0,0],956:[.19444,.44444,0,0],957:[0,.44444,.06898,0],958:[.19444,.69444,.03021,0],959:[0,.44444,0,0],960:[0,.44444,.03704,0],961:[.19444,.44444,0,0],962:[.09722,.44444,.07917,0],963:[0,.44444,.03704,0],964:[0,.44444,.13472,0],965:[0,.44444,.03704,0],966:[.19444,.44444,0,0],967:[.19444,.44444,0,0],968:[.19444,.69444,.03704,0],969:[0,.44444,.03704,0],977:[0,.69444,0,0],981:[.19444,.69444,0,0],982:[0,.44444,.03194,0],1009:[.19444,.44444,0,0],1013:[0,.44444,0,0]},"Math-Italic":{47:[.19444,.69444,0,0],65:[0,.68333,0,.13889],66:[0,.68333,.05017,.08334],67:[0,.68333,.07153,.08334],68:[0,.68333,.02778,.05556],69:[0,.68333,.05764,.08334],70:[0,.68333,.13889,.08334],71:[0,.68333,0,.08334],72:[0,.68333,.08125,.05556],73:[0,.68333,.07847,.11111],74:[0,.68333,.09618,.16667],75:[0,.68333,.07153,.05556],76:[0,.68333,0,.02778],77:[0,.68333,.10903,.08334],78:[0,.68333,.10903,.08334],79:[0,.68333,.02778,.08334],80:[0,.68333,.13889,.08334],81:[.19444,.68333,0,.08334],82:[0,.68333,.00773,.08334],83:[0,.68333,.05764,.08334],84:[0,.68333,.13889,.08334],85:[0,.68333,.10903,.02778],86:[0,.68333,.22222,0],87:[0,.68333,.13889,0],88:[0,.68333,.07847,.08334],89:[0,.68333,.22222,0],90:[0,.68333,.07153,.08334],97:[0,.43056,0,0],98:[0,.69444,0,0],99:[0,.43056,0,.05556],100:[0,.69444,0,.16667],101:[0,.43056,0,.05556],102:[.19444,.69444,.10764,.16667],103:[.19444,.43056,.03588,.02778],104:[0,.69444,0,0],105:[0,.65952,0,0],106:[.19444,.65952,.05724,0],107:[0,.69444,.03148,0],108:[0,.69444,.01968,.08334],109:[0,.43056,0,0],110:[0,.43056,0,0],111:[0,.43056,0,.05556],112:[.19444,.43056,0,.08334],113:[.19444,.43056,.03588,.08334],114:[0,.43056,.02778,.05556],115:[0,.43056,0,.05556],116:[0,.61508,0,.08334],117:[0,.43056,0,.02778],118:[0,.43056,.03588,.02778],119:[0,.43056,.02691,.08334],120:[0,.43056,0,.02778],121:[.19444,.43056,.03588,.05556],122:[0,.43056,.04398,.05556],915:[0,.68333,.13889,.08334],916:[0,.68333,0,.16667],920:[0,.68333,.02778,.08334],923:[0,.68333,0,.16667],926:[0,.68333,.07569,.08334],928:[0,.68333,.08125,.05556],931:[0,.68333,.05764,.08334],933:[0,.68333,.13889,.05556],934:[0,.68333,0,.08334],936:[0,.68333,.11,.05556],937:[0,.68333,.05017,.08334],945:[0,.43056,.0037,.02778],946:[.19444,.69444,.05278,.08334],947:[.19444,.43056,.05556,0],948:[0,.69444,.03785,.05556],949:[0,.43056,0,.08334],950:[.19444,.69444,.07378,.08334],951:[.19444,.43056,.03588,.05556],952:[0,.69444,.02778,.08334],953:[0,.43056,0,.05556],954:[0,.43056,0,0],955:[0,.69444,0,0],956:[.19444,.43056,0,.02778],957:[0,.43056,.06366,.02778],958:[.19444,.69444,.04601,.11111],959:[0,.43056,0,.05556],960:[0,.43056,.03588,0],961:[.19444,.43056,0,.08334],962:[.09722,.43056,.07986,.08334],963:[0,.43056,.03588,0],964:[0,.43056,.1132,.02778],965:[0,.43056,.03588,.02778],966:[.19444,.43056,0,.08334],967:[.19444,.43056,0,.05556],968:[.19444,.69444,.03588,.11111],969:[0,.43056,.03588,0],977:[0,.69444,0,.08334],981:[.19444,.69444,0,.08334],982:[0,.43056,.02778,0],1009:[.19444,.43056,0,.08334],1013:[0,.43056,0,.05556]},"Math-Regular":{65:[0,.68333,0,.13889],66:[0,.68333,.05017,.08334],67:[0,.68333,.07153,.08334],68:[0,.68333,.02778,.05556],69:[0,.68333,.05764,.08334],70:[0,.68333,.13889,.08334],71:[0,.68333,0,.08334],72:[0,.68333,.08125,.05556],73:[0,.68333,.07847,.11111],74:[0,.68333,.09618,.16667],75:[0,.68333,.07153,.05556],76:[0,.68333,0,.02778],77:[0,.68333,.10903,.08334],78:[0,.68333,.10903,.08334],79:[0,.68333,.02778,.08334],80:[0,.68333,.13889,.08334],81:[.19444,.68333,0,.08334],82:[0,.68333,.00773,.08334],83:[0,.68333,.05764,.08334],84:[0,.68333,.13889,.08334],85:[0,.68333,.10903,.02778],86:[0,.68333,.22222,0],87:[0,.68333,.13889,0],88:[0,.68333,.07847,.08334],89:[0,.68333,.22222,0],90:[0,.68333,.07153,.08334],97:[0,.43056,0,0],98:[0,.69444,0,0],99:[0,.43056,0,.05556],100:[0,.69444,0,.16667],101:[0,.43056,0,.05556],102:[.19444,.69444,.10764,.16667],103:[.19444,.43056,.03588,.02778],104:[0,.69444,0,0],105:[0,.65952,0,0],106:[.19444,.65952,.05724,0],107:[0,.69444,.03148,0],108:[0,.69444,.01968,.08334],109:[0,.43056,0,0],110:[0,.43056,0,0],111:[0,.43056,0,.05556],112:[.19444,.43056,0,.08334],113:[.19444,.43056,.03588,.08334],114:[0,.43056,.02778,.05556],115:[0,.43056,0,.05556],116:[0,.61508,0,.08334],117:[0,.43056,0,.02778],118:[0,.43056,.03588,.02778],119:[0,.43056,.02691,.08334],120:[0,.43056,0,.02778],121:[.19444,.43056,.03588,.05556],122:[0,.43056,.04398,.05556],915:[0,.68333,.13889,.08334],916:[0,.68333,0,.16667],920:[0,.68333,.02778,.08334],923:[0,.68333,0,.16667],926:[0,.68333,.07569,.08334],928:[0,.68333,.08125,.05556],931:[0,.68333,.05764,.08334],933:[0,.68333,.13889,.05556],934:[0,.68333,0,.08334],936:[0,.68333,.11,.05556],937:[0,.68333,.05017,.08334],945:[0,.43056,.0037,.02778],946:[.19444,.69444,.05278,.08334],947:[.19444,.43056,.05556,0],948:[0,.69444,.03785,.05556],949:[0,.43056,0,.08334],950:[.19444,.69444,.07378,.08334],951:[.19444,.43056,.03588,.05556],952:[0,.69444,.02778,.08334],953:[0,.43056,0,.05556],954:[0,.43056,0,0],955:[0,.69444,0,0],956:[.19444,.43056,0,.02778],957:[0,.43056,.06366,.02778],958:[.19444,.69444,.04601,.11111],959:[0,.43056,0,.05556],960:[0,.43056,.03588,0],961:[.19444,.43056,0,.08334],962:[.09722,.43056,.07986,.08334],963:[0,.43056,.03588,0],964:[0,.43056,.1132,.02778],965:[0,.43056,.03588,.02778],966:[.19444,.43056,0,.08334],967:[.19444,.43056,0,.05556],968:[.19444,.69444,.03588,.11111],969:[0,.43056,.03588,0],977:[0,.69444,0,.08334],981:[.19444,.69444,0,.08334],982:[0,.43056,.02778,0],1009:[.19444,.43056,0,.08334],1013:[0,.43056,0,.05556]},"SansSerif-Bold":{33:[0,.69444,0,0],34:[0,.69444,0,0],35:[.19444,.69444,0,0],36:[.05556,.75,0,0],37:[.05556,.75,0,0],38:[0,.69444,0,0],39:[0,.69444,0,0],40:[.25,.75,0,0],41:[.25,.75,0,0],42:[0,.75,0,0],43:[.11667,.61667,0,0],44:[.10556,.13056,0,0],45:[0,.45833,0,0],46:[0,.13056,0,0],47:[.25,.75,0,0],48:[0,.69444,0,0],49:[0,.69444,0,0],50:[0,.69444,0,0],51:[0,.69444,0,0],52:[0,.69444,0,0],53:[0,.69444,0,0],54:[0,.69444,0,0],55:[0,.69444,0,0],56:[0,.69444,0,0],57:[0,.69444,0,0],58:[0,.45833,0,0],59:[.10556,.45833,0,0],61:[-.09375,.40625,0,0],63:[0,.69444,0,0],64:[0,.69444,0,0],65:[0,.69444,0,0],66:[0,.69444,0,0],67:[0,.69444,0,0],68:[0,.69444,0,0],69:[0,.69444,0,0],70:[0,.69444,0,0],71:[0,.69444,0,0],72:[0,.69444,0,0],73:[0,.69444,0,0],74:[0,.69444,0,0],75:[0,.69444,0,0],76:[0,.69444,0,0],77:[0,.69444,0,0],78:[0,.69444,0,0],79:[0,.69444,0,0],80:[0,.69444,0,0],81:[.10556,.69444,0,0],82:[0,.69444,0,0],83:[0,.69444,0,0],84:[0,.69444,0,0],85:[0,.69444,0,0],86:[0,.69444,.01528,0],87:[0,.69444,.01528,0],88:[0,.69444,0,0],89:[0,.69444,.0275,0],90:[0,.69444,0,0],91:[.25,.75,0,0],93:[.25,.75,0,0],94:[0,.69444,0,0],95:[.35,.10833,.03056,0],97:[0,.45833,0,0],98:[0,.69444,0,0],99:[0,.45833,0,0],100:[0,.69444,0,0],101:[0,.45833,0,0],102:[0,.69444,.07639,0],103:[.19444,.45833,.01528,0],104:[0,.69444,0,0],105:[0,.69444,0,0],106:[.19444,.69444,0,0],107:[0,.69444,0,0],108:[0,.69444,0,0],109:[0,.45833,0,0],110:[0,.45833,0,0],111:[0,.45833,0,0],112:[.19444,.45833,0,0],113:[.19444,.45833,0,0],114:[0,.45833,.01528,0],115:[0,.45833,0,0],116:[0,.58929,0,0],117:[0,.45833,0,0],118:[0,.45833,.01528,0],119:[0,.45833,.01528,0],120:[0,.45833,0,0],121:[.19444,.45833,.01528,0],122:[0,.45833,0,0],126:[.35,.34444,0,0],305:[0,.45833,0,0],567:[.19444,.45833,0,0],768:[0,.69444,0,0],769:[0,.69444,0,0],770:[0,.69444,0,0],771:[0,.69444,0,0],772:[0,.63778,0,0],774:[0,.69444,0,0],775:[0,.69444,0,0],776:[0,.69444,0,0],778:[0,.69444,0,0],779:[0,.69444,0,0],780:[0,.63542,0,0],915:[0,.69444,0,0],916:[0,.69444,0,0],920:[0,.69444,0,0],923:[0,.69444,0,0],926:[0,.69444,0,0],928:[0,.69444,0,0],931:[0,.69444,0,0],933:[0,.69444,0,0],934:[0,.69444,0,0],936:[0,.69444,0,0],937:[0,.69444,0,0],8211:[0,.45833,.03056,0],8212:[0,.45833,.03056,0],8216:[0,.69444,0,0],8217:[0,.69444,0,0],8220:[0,.69444,0,0],8221:[0,.69444,0,0]},"SansSerif-Italic":{33:[0,.69444,.05733,0],34:[0,.69444,.00316,0],35:[.19444,.69444,.05087,0],36:[.05556,.75,.11156,0],37:[.05556,.75,.03126,0],38:[0,.69444,.03058,0],39:[0,.69444,.07816,0],40:[.25,.75,.13164,0],41:[.25,.75,.02536,0],42:[0,.75,.11775,0],43:[.08333,.58333,.02536,0],44:[.125,.08333,0,0],45:[0,.44444,.01946,0],46:[0,.08333,0,0],47:[.25,.75,.13164,0],48:[0,.65556,.11156,0],49:[0,.65556,.11156,0],50:[0,.65556,.11156,0],51:[0,.65556,.11156,0],52:[0,.65556,.11156,0],53:[0,.65556,.11156,0],54:[0,.65556,.11156,0],55:[0,.65556,.11156,0],56:[0,.65556,.11156,0],57:[0,.65556,.11156,0],58:[0,.44444,.02502,0],59:[.125,.44444,.02502,0],61:[-.13,.37,.05087,0],63:[0,.69444,.11809,0],64:[0,.69444,.07555,0],65:[0,.69444,0,0],66:[0,.69444,.08293,0],67:[0,.69444,.11983,0],68:[0,.69444,.07555,0],69:[0,.69444,.11983,0],70:[0,.69444,.13372,0],71:[0,.69444,.11983,0],72:[0,.69444,.08094,0],73:[0,.69444,.13372,0],74:[0,.69444,.08094,0],75:[0,.69444,.11983,0],76:[0,.69444,0,0],77:[0,.69444,.08094,0],78:[0,.69444,.08094,0],79:[0,.69444,.07555,0],80:[0,.69444,.08293,0],81:[.125,.69444,.07555,0],82:[0,.69444,.08293,0],83:[0,.69444,.09205,0],84:[0,.69444,.13372,0],85:[0,.69444,.08094,0],86:[0,.69444,.1615,0],87:[0,.69444,.1615,0],88:[0,.69444,.13372,0],89:[0,.69444,.17261,0],90:[0,.69444,.11983,0],91:[.25,.75,.15942,0],93:[.25,.75,.08719,0],94:[0,.69444,.0799,0],95:[.35,.09444,.08616,0],97:[0,.44444,.00981,0],98:[0,.69444,.03057,0],99:[0,.44444,.08336,0],100:[0,.69444,.09483,0],101:[0,.44444,.06778,0],102:[0,.69444,.21705,0],103:[.19444,.44444,.10836,0],104:[0,.69444,.01778,0],105:[0,.67937,.09718,0],106:[.19444,.67937,.09162,0],107:[0,.69444,.08336,0],108:[0,.69444,.09483,0],109:[0,.44444,.01778,0],110:[0,.44444,.01778,0],111:[0,.44444,.06613,0],112:[.19444,.44444,.0389,0],113:[.19444,.44444,.04169,0],114:[0,.44444,.10836,0],115:[0,.44444,.0778,0],116:[0,.57143,.07225,0],117:[0,.44444,.04169,0],118:[0,.44444,.10836,0],119:[0,.44444,.10836,0],120:[0,.44444,.09169,0],121:[.19444,.44444,.10836,0],122:[0,.44444,.08752,0],126:[.35,.32659,.08826,0],305:[0,.44444,.04169,0],567:[.19444,.44444,.04169,0],768:[0,.69444,0,0],769:[0,.69444,.09205,0],770:[0,.69444,.0799,0],771:[0,.67659,.08826,0],772:[0,.60889,.08776,0],774:[0,.69444,.09483,0],775:[0,.67937,.07774,0],776:[0,.67937,.06385,0],778:[0,.69444,0,0],779:[0,.69444,.09205,0],780:[0,.63194,.08432,0],915:[0,.69444,.13372,0],916:[0,.69444,0,0],920:[0,.69444,.07555,0],923:[0,.69444,0,0],926:[0,.69444,.12816,0],928:[0,.69444,.08094,0],931:[0,.69444,.11983,0],933:[0,.69444,.09031,0],934:[0,.69444,.04603,0],936:[0,.69444,.09031,0],937:[0,.69444,.08293,0],8211:[0,.44444,.08616,0],8212:[0,.44444,.08616,0],8216:[0,.69444,.07816,0],8217:[0,.69444,.07816,0],8220:[0,.69444,.14205,0],8221:[0,.69444,.00316,0]},"SansSerif-Regular":{33:[0,.69444,0,0],34:[0,.69444,0,0],35:[.19444,.69444,0,0],36:[.05556,.75,0,0],37:[.05556,.75,0,0],38:[0,.69444,0,0],39:[0,.69444,0,0],40:[.25,.75,0,0],41:[.25,.75,0,0],42:[0,.75,0,0],43:[.08333,.58333,0,0],44:[.125,.08333,0,0],45:[0,.44444,0,0],46:[0,.08333,0,0],47:[.25,.75,0,0],48:[0,.65556,0,0],49:[0,.65556,0,0],50:[0,.65556,0,0],51:[0,.65556,0,0],52:[0,.65556,0,0],53:[0,.65556,0,0],54:[0,.65556,0,0],55:[0,.65556,0,0],56:[0,.65556,0,0],57:[0,.65556,0,0],58:[0,.44444,0,0],59:[.125,.44444,0,0],61:[-.13,.37,0,0],63:[0,.69444,0,0],64:[0,.69444,0,0],65:[0,.69444,0,0],66:[0,.69444,0,0],67:[0,.69444,0,0],68:[0,.69444,0,0],69:[0,.69444,0,0],70:[0,.69444,0,0],71:[0,.69444,0,0],72:[0,.69444,0,0],73:[0,.69444,0,0],74:[0,.69444,0,0],75:[0,.69444,0,0],76:[0,.69444,0,0],77:[0,.69444,0,0],78:[0,.69444,0,0],79:[0,.69444,0,0],80:[0,.69444,0,0],81:[.125,.69444,0,0],82:[0,.69444,0,0],83:[0,.69444,0,0],84:[0,.69444,0,0],85:[0,.69444,0,0],86:[0,.69444,.01389,0],87:[0,.69444,.01389,0],88:[0,.69444,0,0],89:[0,.69444,.025,0],90:[0,.69444,0,0],91:[.25,.75,0,0],93:[.25,.75,0,0],94:[0,.69444,0,0],95:[.35,.09444,.02778,0],97:[0,.44444,0,0],98:[0,.69444,0,0],99:[0,.44444,0,0],100:[0,.69444,0,0],101:[0,.44444,0,0],102:[0,.69444,.06944,0],103:[.19444,.44444,.01389,0],104:[0,.69444,0,0],105:[0,.67937,0,0],106:[.19444,.67937,0,0],107:[0,.69444,0,0],108:[0,.69444,0,0],109:[0,.44444,0,0],110:[0,.44444,0,0],111:[0,.44444,0,0],112:[.19444,.44444,0,0],113:[.19444,.44444,0,0],114:[0,.44444,.01389,0],115:[0,.44444,0,0],116:[0,.57143,0,0],117:[0,.44444,0,0],118:[0,.44444,.01389,0],119:[0,.44444,.01389,0],120:[0,.44444,0,0],121:[.19444,.44444,.01389,0],122:[0,.44444,0,0],126:[.35,.32659,0,0],305:[0,.44444,0,0],567:[.19444,.44444,0,0],768:[0,.69444,0,0],769:[0,.69444,0,0],770:[0,.69444,0,0],771:[0,.67659,0,0],772:[0,.60889,0,0],774:[0,.69444,0,0],775:[0,.67937,0,0],776:[0,.67937,0,0],778:[0,.69444,0,0],779:[0,.69444,0,0],780:[0,.63194,0,0],915:[0,.69444,0,0],916:[0,.69444,0,0],920:[0,.69444,0,0],923:[0,.69444,0,0],926:[0,.69444,0,0],928:[0,.69444,0,0],931:[0,.69444,0,0],933:[0,.69444,0,0],934:[0,.69444,0,0],936:[0,.69444,0,0],937:[0,.69444,0,0],8211:[0,.44444,.02778,0],8212:[0,.44444,.02778,0],8216:[0,.69444,0,0],8217:[0,.69444,0,0],8220:[0,.69444,0,0],8221:[0,.69444,0,0]},"Script-Regular":{65:[0,.7,.22925,0],66:[0,.7,.04087,0],67:[0,.7,.1689,0],68:[0,.7,.09371,0],69:[0,.7,.18583,0],70:[0,.7,.13634,0],71:[0,.7,.17322,0],72:[0,.7,.29694,0],73:[0,.7,.19189,0],74:[.27778,.7,.19189,0],75:[0,.7,.31259,0],76:[0,.7,.19189,0],77:[0,.7,.15981,0],78:[0,.7,.3525,0],79:[0,.7,.08078,0],80:[0,.7,.08078,0],81:[0,.7,.03305,0],82:[0,.7,.06259,0],83:[0,.7,.19189,0],84:[0,.7,.29087,0],85:[0,.7,.25815,0],86:[0,.7,.27523,0],87:[0,.7,.27523,0],88:[0,.7,.26006,0],89:[0,.7,.2939,0],90:[0,.7,.24037,0]},"Size1-Regular":{40:[.35001,.85,0,0],41:[.35001,.85,0,0],47:[.35001,.85,0,0],91:[.35001,.85,0,0],92:[.35001,.85,0,0],93:[.35001,.85,0,0],123:[.35001,.85,0,0],125:[.35001,.85,0,0],710:[0,.72222,0,0],732:[0,.72222,0,0],770:[0,.72222,0,0],771:[0,.72222,0,0],8214:[-99e-5,.601,0,0],8593:[1e-5,.6,0,0],8595:[1e-5,.6,0,0],8657:[1e-5,.6,0,0],8659:[1e-5,.6,0,0],8719:[.25001,.75,0,0],8720:[.25001,.75,0,0],8721:[.25001,.75,0,0],8730:[.35001,.85,0,0],8739:[-.00599,.606,0,0],8741:[-.00599,.606,0,0],8747:[.30612,.805,.19445,0],8748:[.306,.805,.19445,0],8749:[.306,.805,.19445,0],8750:[.30612,.805,.19445,0],8896:[.25001,.75,0,0],8897:[.25001,.75,0,0],8898:[.25001,.75,0,0],8899:[.25001,.75,0,0],8968:[.35001,.85,0,0],8969:[.35001,.85,0,0],8970:[.35001,.85,0,0],8971:[.35001,.85,0,0],9168:[-99e-5,.601,0,0],10216:[.35001,.85,0,0],10217:[.35001,.85,0,0],10752:[.25001,.75,0,0],10753:[.25001,.75,0,0],10754:[.25001,.75,0,0],10756:[.25001,.75,0,0],10758:[.25001,.75,0,0]},"Size2-Regular":{40:[.65002,1.15,0,0],41:[.65002,1.15,0,0],47:[.65002,1.15,0,0],91:[.65002,1.15,0,0],92:[.65002,1.15,0,0],93:[.65002,1.15,0,0],123:[.65002,1.15,0,0],125:[.65002,1.15,0,0],710:[0,.75,0,0],732:[0,.75,0,0],770:[0,.75,0,0],771:[0,.75,0,0],8719:[.55001,1.05,0,0],8720:[.55001,1.05,0,0],8721:[.55001,1.05,0,0],8730:[.65002,1.15,0,0],8747:[.86225,1.36,.44445,0],8748:[.862,1.36,.44445,0],8749:[.862,1.36,.44445,0],8750:[.86225,1.36,.44445,0],8896:[.55001,1.05,0,0],8897:[.55001,1.05,0,0],8898:[.55001,1.05,0,0],8899:[.55001,1.05,0,0],8968:[.65002,1.15,0,0],8969:[.65002,1.15,0,0],8970:[.65002,1.15,0,0],8971:[.65002,1.15,0,0],10216:[.65002,1.15,0,0],10217:[.65002,1.15,0,0],10752:[.55001,1.05,0,0],10753:[.55001,1.05,0,0],10754:[.55001,1.05,0,0],10756:[.55001,1.05,0,0],10758:[.55001,1.05,0,0]},"Size3-Regular":{40:[.95003,1.45,0,0],41:[.95003,1.45,0,0],47:[.95003,1.45,0,0],91:[.95003,1.45,0,0],92:[.95003,1.45,0,0],93:[.95003,1.45,0,0],123:[.95003,1.45,0,0],125:[.95003,1.45,0,0],710:[0,.75,0,0],732:[0,.75,0,0],770:[0,.75,0,0],771:[0,.75,0,0],8730:[.95003,1.45,0,0],8968:[.95003,1.45,0,0],8969:[.95003,1.45,0,0],8970:[.95003,1.45,0,0],8971:[.95003,1.45,0,0],10216:[.95003,1.45,0,0],10217:[.95003,1.45,0,0]},"Size4-Regular":{40:[1.25003,1.75,0,0],41:[1.25003,1.75,0,0],47:[1.25003,1.75,0,0],91:[1.25003,1.75,0,0],92:[1.25003,1.75,0,0],93:[1.25003,1.75,0,0],123:[1.25003,1.75,0,0],125:[1.25003,1.75,0,0],710:[0,.825,0,0],732:[0,.825,0,0],770:[0,.825,0,0],771:[0,.825,0,0],8730:[1.25003,1.75,0,0],8968:[1.25003,1.75,0,0],8969:[1.25003,1.75,0,0],8970:[1.25003,1.75,0,0],8971:[1.25003,1.75,0,0],9115:[.64502,1.155,0,0],9116:[1e-5,.6,0,0],9117:[.64502,1.155,0,0],9118:[.64502,1.155,0,0],9119:[1e-5,.6,0,0],9120:[.64502,1.155,0,0],9121:[.64502,1.155,0,0],9122:[-99e-5,.601,0,0],9123:[.64502,1.155,0,0],9124:[.64502,1.155,0,0],9125:[-99e-5,.601,0,0],9126:[.64502,1.155,0,0],9127:[1e-5,.9,0,0],9128:[.65002,1.15,0,0],9129:[.90001,0,0,0],9130:[0,.3,0,0],9131:[1e-5,.9,0,0],9132:[.65002,1.15,0,0],9133:[.90001,0,0,0],9143:[.88502,.915,0,0],10216:[1.25003,1.75,0,0],10217:[1.25003,1.75,0,0],57344:[-.00499,.605,0,0],57345:[-.00499,.605,0,0],57680:[0,.12,0,0],57681:[0,.12,0,0],57682:[0,.12,0,0],57683:[0,.12,0,0]},"Typewriter-Regular":{33:[0,.61111,0,0],34:[0,.61111,0,0],35:[0,.61111,0,0],36:[.08333,.69444,0,0],37:[.08333,.69444,0,0],38:[0,.61111,0,0],39:[0,.61111,0,0],40:[.08333,.69444,0,0],41:[.08333,.69444,0,0],42:[0,.52083,0,0],43:[-.08056,.53055,0,0],44:[.13889,.125,0,0],45:[-.08056,.53055,0,0],46:[0,.125,0,0],47:[.08333,.69444,0,0],48:[0,.61111,0,0],49:[0,.61111,0,0],50:[0,.61111,0,0],51:[0,.61111,0,0],52:[0,.61111,0,0],53:[0,.61111,0,0],54:[0,.61111,0,0],55:[0,.61111,0,0],56:[0,.61111,0,0],57:[0,.61111,0,0],58:[0,.43056,0,0],59:[.13889,.43056,0,0],60:[-.05556,.55556,0,0],61:[-.19549,.41562,0,0],62:[-.05556,.55556,0,0],63:[0,.61111,0,0],64:[0,.61111,0,0],65:[0,.61111,0,0],66:[0,.61111,0,0],67:[0,.61111,0,0],68:[0,.61111,0,0],69:[0,.61111,0,0],70:[0,.61111,0,0],71:[0,.61111,0,0],72:[0,.61111,0,0],73:[0,.61111,0,0],74:[0,.61111,0,0],75:[0,.61111,0,0],76:[0,.61111,0,0],77:[0,.61111,0,0],78:[0,.61111,0,0],79:[0,.61111,0,0],80:[0,.61111,0,0],81:[.13889,.61111,0,0],82:[0,.61111,0,0],83:[0,.61111,0,0],84:[0,.61111,0,0],85:[0,.61111,0,0],86:[0,.61111,0,0],87:[0,.61111,0,0],88:[0,.61111,0,0],89:[0,.61111,0,0],90:[0,.61111,0,0],91:[.08333,.69444,0,0],92:[.08333,.69444,0,0],93:[.08333,.69444,0,0],94:[0,.61111,0,0],95:[.09514,0,0,0],96:[0,.61111,0,0],97:[0,.43056,0,0],98:[0,.61111,0,0],99:[0,.43056,0,0],100:[0,.61111,0,0],101:[0,.43056,0,0],102:[0,.61111,0,0],103:[.22222,.43056,0,0],104:[0,.61111,0,0],105:[0,.61111,0,0],106:[.22222,.61111,0,0],107:[0,.61111,0,0],108:[0,.61111,0,0],109:[0,.43056,0,0],110:[0,.43056,0,0],111:[0,.43056,0,0],112:[.22222,.43056,0,0],113:[.22222,.43056,0,0],114:[0,.43056,0,0],115:[0,.43056,0,0],116:[0,.55358,0,0],117:[0,.43056,0,0],118:[0,.43056,0,0],119:[0,.43056,0,0],120:[0,.43056,0,0],121:[.22222,.43056,0,0],122:[0,.43056,0,0],123:[.08333,.69444,0,0],124:[.08333,.69444,0,0],125:[.08333,.69444,0,0],126:[0,.61111,0,0],127:[0,.61111,0,0],305:[0,.43056,0,0],567:[.22222,.43056,0,0],768:[0,.61111,0,0],769:[0,.61111,0,0],770:[0,.61111,0,0],771:[0,.61111,0,0],772:[0,.56555,0,0],774:[0,.61111,0,0],776:[0,.61111,0,0],778:[0,.61111,0,0],780:[0,.56597,0,0],915:[0,.61111,0,0],916:[0,.61111,0,0],920:[0,.61111,0,0],923:[0,.61111,0,0],926:[0,.61111,0,0],928:[0,.61111,0,0],931:[0,.61111,0,0],933:[0,.61111,0,0],934:[0,.61111,0,0],936:[0,.61111,0,0],937:[0,.61111,0,0],8216:[0,.61111,0,0],8217:[0,.61111,0,0],8242:[0,.61111,0,0],9251:[.11111,.21944,0,0]}}},{}],103:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./utils");var n=d(a);var i=e("./ParseError");var l=d(i);var u=e("./ParseNode");var o=d(u);var s=e("./defineFunction");var f=d(s);e("./functions/color");e("./functions/text");e("./functions/overline");e("./functions/underline");e("./functions/rule");e("./functions/kern");e("./functions/phantom");e("./functions/mod");e("./functions/op");e("./functions/operatorname");e("./functions/genfrac");e("./functions/lap");e("./functions/smash");e("./functions/delimsizing");e("./functions/href");e("./functions/mathchoice");function d(e){return e&&e.__esModule?e:{default:e}}var c=s._functions;r.default=c;var h=function e(t,r,a){(0,f.default)({names:t,props:r,handler:a})};h(["\\sqrt"],{numArgs:1,numOptionalArgs:1},function(e,t,r){var a=r[0];var n=t[0];return{type:"sqrt",body:n,index:a}});h(["\\xmlClass"],{numArgs:2,allowedInText:true,greediness:3,argTypes:["string","original"]},function(e,t){var r=t[0];var a=t[1];var n=void 0;if(a.type==="ordgroup"){n=a.value}else{n=[a]}return{type:"xmlClass",cl:r,value:n}});h(["\\color"],{numArgs:1,allowedInText:true,greediness:3,argTypes:["color"]},null);h(["\\colorbox"],{numArgs:2,allowedInText:true,greediness:3,argTypes:["color","text"]},function(e,t){var r=t[0];var a=t[1];return{type:"enclose",label:e.funcName,backgroundColor:r,body:a}});h(["\\fcolorbox"],{numArgs:3,allowedInText:true,greediness:3,argTypes:["color","color","text"]},function(e,t){var r=t[0];var a=t[1];var n=t[2];return{type:"enclose",label:e.funcName,backgroundColor:a,borderColor:r,body:n}});h(["\\cursor"],{numArgs:1,numOptionalArgs:1,argTypes:["size","size"]},function(e,t,r){var a=r[0];var n=t[0];return{type:"cursor",shift:a&&a.value,height:n.value}});h(["\\mathord","\\mathbin","\\mathrel","\\mathopen","\\mathclose","\\mathpunct","\\mathinner"],{numArgs:1},function(e,t){var r=t[0];return{type:"mclass",mclass:"m"+e.funcName.substr(5),value:(0,s.ordargument)(r)}});h(["\\stackrel"],{numArgs:2},function(e,t){var r=t[0];var a=t[1];var n=new o.default("op",{type:"op",limits:true,alwaysHandleSupSub:true,symbol:false,value:(0,s.ordargument)(a)},a.mode);var i=new o.default("supsub",{base:n,sup:r,sub:null},r.mode);return{type:"mclass",mclass:"mrel",value:[i]}});var v={"\\Bbb":"\\mathbb","\\bold":"\\mathbf","\\frak":"\\mathfrak","\\bm":"\\boldsymbol"};var p={"\u222b":"\\int","\u222c":"\\iint","\u222d":"\\iiint","\u222e":"\\oint"};h(["\\arcsin","\\arccos","\\arctan","\\arctg","\\arcctg","\\arg","\\ch","\\cos","\\cosec","\\cosh","\\cot","\\cotg","\\coth","\\csc","\\ctg","\\cth","\\deg","\\dim","\\exp","\\hom","\\ker","\\lg","\\ln","\\log","\\sec","\\sin","\\sinh","\\sh","\\tan","\\tanh","\\tg","\\th"],{numArgs:0},function(e){return{type:"op",limits:false,symbol:false,body:e.funcName}});h(["\\det","\\gcd","\\inf","\\lim","\\liminf","\\limsup","\\max","\\min","\\Pr","\\sup"],{numArgs:0},function(e){return{type:"op",limits:true,symbol:false,body:e.funcName}});h(["\\int","\\iint","\\iiint","\\oint","\u222b","\u222c","\u222d","\u222e"],{numArgs:0},function(e){var t=e.funcName;if(t.length===1){t=p[t]}return{type:"op",limits:false,symbol:true,body:t}});h(["\\tiny","\\scriptsize","\\footnotesize","\\small","\\normalsize","\\large","\\Large","\\LARGE","\\huge","\\Huge"],{numArgs:0},null);h(["\\displaystyle","\\textstyle","\\scriptstyle","\\scriptscriptstyle"],{numArgs:0},null);h(["\\rm","\\sf","\\tt","\\bf","\\it"],{numArgs:0},null);h(["\\mathrm","\\mathit","\\mathbf","\\boldsymbol","\\mathbb","\\mathcal","\\mathfrak","\\mathscr","\\mathsf","\\mathtt","\\Bbb","\\bold","\\frak","\\bm"],{numArgs:1,greediness:2},function(e,t){var r=t[0];var a=e.funcName;if(a in v){a=v[a]}return{type:"font",font:a.slice(1),body:r}});h(["\\acute","\\grave","\\ddot","\\tilde","\\bar","\\breve","\\check","\\hat","\\vec","\\dot","\\widehat","\\widetilde","\\overrightarrow","\\overleftarrow","\\Overrightarrow","\\overleftrightarrow","\\overgroup","\\overlinesegment","\\overleftharpoon","\\overrightharpoon"],{numArgs:1},function(e,t){var r=t[0];var a=!n.default.contains(["\\acute","\\grave","\\ddot","\\tilde","\\bar","\\breve","\\check","\\hat","\\vec","\\dot"],e.funcName);var i=!a||n.default.contains(["\\widehat","\\widetilde"],e.funcName);return{type:"accent",label:e.funcName,isStretchy:a,isShifty:i,base:r}});h(["\\'","\\`","\\^","\\~","\\=","\\u","\\.",'\\"',"\\r","\\H","\\v"],{numArgs:1,allowedInText:true,allowedInMath:false},function(e,t){var r=t[0];return{type:"accent",label:e.funcName,isStretchy:false,isShifty:true,base:r}});h(["\\overbrace","\\underbrace"],{numArgs:1},function(e,t){var r=t[0];return{type:"horizBrace",label:e.funcName,isOver:/^\\over/.test(e.funcName),base:r}});h(["\\underleftarrow","\\underrightarrow","\\underleftrightarrow","\\undergroup","\\underlinesegment","\\utilde"],{numArgs:1},function(e,t){var r=t[0];return{type:"accentUnder",label:e.funcName,base:r}});h(["\\xleftarrow","\\xrightarrow","\\xLeftarrow","\\xRightarrow","\\xleftrightarrow","\\xLeftrightarrow","\\xhookleftarrow","\\xhookrightarrow","\\xmapsto","\\xrightharpoondown","\\xrightharpoonup","\\xleftharpoondown","\\xleftharpoonup","\\xrightleftharpoons","\\xleftrightharpoons","\\xlongequal","\\xtwoheadrightarrow","\\xtwoheadleftarrow","\\xtofrom"],{numArgs:1,numOptionalArgs:1},function(e,t,r){var a=r[0];var n=t[0];return{type:"xArrow",label:e.funcName,body:n,below:a}});h(["\\cancel","\\bcancel","\\xcancel","\\sout","\\fbox"],{numArgs:1},function(e,t){var r=t[0];return{type:"enclose",label:e.funcName,body:r}});h(["\\over","\\choose","\\atop"],{numArgs:0,infix:true},function(e){var t=void 0;switch(e.funcName){case"\\over":t="\\frac";break;case"\\choose":t="\\binom";break;case"\\atop":t="\\\\atopfrac";break;default:throw new Error("Unrecognized infix genfrac command")}return{type:"infix",replaceWith:t,token:e.token}});h(["\\\\","\\cr"],{numArgs:0,numOptionalArgs:1,argTypes:["size"]},function(e,t,r){var a=r[0];return{type:"cr",size:a}});h(["\\begin","\\end"],{numArgs:1,argTypes:["text"]},function(e,t){var r=t[0];if(r.type!=="ordgroup"){throw new l.default("Invalid environment name",r)}var a="";for(var n=0;n<r.value.length;++n){a+=r.value[n].value}return{type:"environment",name:a,nameGroup:r}});h(["\\raisebox"],{numArgs:2,argTypes:["size","text"],allowedInText:true},function(e,t){var r=t[0];var a=t[1];return{type:"raisebox",dy:r,body:a,value:(0,s.ordargument)(a)}});h(["\\verb"],{numArgs:0,allowedInText:true},function(e){throw new l.default("\\verb ended by end of line instead of matching delimiter")})},{"./ParseError":84,"./ParseNode":85,"./defineFunction":96,"./functions/color":104,"./functions/delimsizing":105,"./functions/genfrac":106,"./functions/href":107,"./functions/kern":108,"./functions/lap":109,"./functions/mathchoice":110,"./functions/mod":111,"./functions/op":112,"./functions/operatorname":113,"./functions/overline":114,"./functions/phantom":115,"./functions/rule":116,"./functions/smash":117,"./functions/text":118,"./functions/underline":119,"./utils":128}],104:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}var p=function e(t,r){var a=f.buildExpression(t.value.value,r.withColor(t.value.color),false);return new l.default.makeFragment(a)};var m=function e(t,r){var a=c.buildExpression(t.value.value,r);var n=new o.default.MathNode("mstyle",a);n.setAttribute("mathcolor",t.value.color);return n};(0,n.default)({type:"color",names:["\\textcolor"],props:{numArgs:2,allowedInText:true,greediness:3,argTypes:["color","original"]},handler:function e(t,r){var n=r[0];var i=r[1];return{type:"color",color:n.value,value:(0,a.ordargument)(i)}},htmlBuilder:p,mathmlBuilder:m});(0,n.default)({type:"color",names:["\\blue","\\orange","\\pink","\\red","\\green","\\gray","\\purple","\\blueA","\\blueB","\\blueC","\\blueD","\\blueE","\\tealA","\\tealB","\\tealC","\\tealD","\\tealE","\\greenA","\\greenB","\\greenC","\\greenD","\\greenE","\\goldA","\\goldB","\\goldC","\\goldD","\\goldE","\\redA","\\redB","\\redC","\\redD","\\redE","\\maroonA","\\maroonB","\\maroonC","\\maroonD","\\maroonE","\\purpleA","\\purpleB","\\purpleC","\\purpleD","\\purpleE","\\mintA","\\mintB","\\mintC","\\grayA","\\grayB","\\grayC","\\grayD","\\grayE","\\grayF","\\grayG","\\grayH","\\grayI","\\kaBlue","\\kaGreen"],props:{numArgs:1,allowedInText:true,greediness:3},handler:function e(t,r){var n=r[0];return{type:"color",color:"katex-"+t.funcName.slice(1),value:(0,a.ordargument)(n)}},htmlBuilder:p,mathmlBuilder:m})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],105:[function(e,t,r){"use strict";var a=e("../buildCommon");var n=x(a);var i=e("../defineFunction");var l=x(i);var u=e("../delimiter");var o=x(u);var s=e("../mathMLTree");var f=x(s);var d=e("../ParseError");var c=x(d);var h=e("../utils");var v=x(h);var p=e("../buildHTML");var m=y(p);var g=e("../buildMathML");var b=y(g);function y(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function x(e){return e&&e.__esModule?e:{default:e}}var w={"\\bigl":{mclass:"mopen",size:1},"\\Bigl":{mclass:"mopen",size:2},"\\biggl":{mclass:"mopen",size:3},"\\Biggl":{mclass:"mopen",size:4},"\\bigr":{mclass:"mclose",size:1},"\\Bigr":{mclass:"mclose",size:2},"\\biggr":{mclass:"mclose",size:3},"\\Biggr":{mclass:"mclose",size:4},"\\bigm":{mclass:"mrel",size:1},"\\Bigm":{mclass:"mrel",size:2},"\\biggm":{mclass:"mrel",size:3},"\\Biggm":{mclass:"mrel",size:4},"\\big":{mclass:"mord",size:1},"\\Big":{mclass:"mord",size:2},"\\bigg":{mclass:"mord",size:3},"\\Bigg":{mclass:"mord",size:4}};var k=["(",")","[","\\lbrack","]","\\rbrack","\\{","\\lbrace","\\}","\\rbrace","\\lfloor","\\rfloor","\\lceil","\\rceil","<",">","\\langle","\\rangle","\\lt","\\gt","\\lvert","\\rvert","\\lVert","\\rVert","\\lgroup","\\rgroup","\\lmoustache","\\rmoustache","/","\\backslash","|","\\vert","\\|","\\Vert","\\uparrow","\\Uparrow","\\downarrow","\\Downarrow","\\updownarrow","\\Updownarrow","."];
function M(e,t){if(v.default.contains(k,e.value)){return e}else{throw new c.default("Invalid delimiter: '"+e.value+"' after '"+t.funcName+"'",e)}}(0,l.default)({type:"delimsizing",names:["\\bigl","\\Bigl","\\biggl","\\Biggl","\\bigr","\\Bigr","\\biggr","\\Biggr","\\bigm","\\Bigm","\\biggm","\\Biggm","\\big","\\Big","\\bigg","\\Bigg"],props:{numArgs:1},handler:function e(t,r){var a=M(r[0],t);return{type:"delimsizing",size:w[t.funcName].size,mclass:w[t.funcName].mclass,value:a.value}},htmlBuilder:function e(t,r){var a=t.value.value;if(a==="."){return n.default.makeSpan([t.value.mclass])}return o.default.sizedDelim(a,t.value.size,r,t.mode,[t.value.mclass])},mathmlBuilder:function e(t){var r=[];if(t.value.value!=="."){r.push(b.makeText(t.value.value,t.mode))}var a=new f.default.MathNode("mo",r);if(t.value.mclass==="mopen"||t.value.mclass==="mclose"){a.setAttribute("fence","true")}else{a.setAttribute("fence","false")}return a}});(0,l.default)({type:"leftright",names:["\\left","\\right"],props:{numArgs:1},handler:function e(t,r){var a=M(r[0],t);return{type:"leftright",value:a.value}},htmlBuilder:function e(t,r){var a=m.buildExpression(t.value.body,r,true);var i=0;var l=0;var u=false;for(var s=0;s<a.length;s++){if(a[s].isMiddle){u=true}else{i=Math.max(a[s].height,i);l=Math.max(a[s].depth,l)}}i*=r.sizeMultiplier;l*=r.sizeMultiplier;var f=void 0;if(t.value.left==="."){f=m.makeNullDelimiter(r,["mopen"])}else{f=o.default.leftRightDelim(t.value.left,i,l,r,t.mode,["mopen"])}a.unshift(f);if(u){for(var d=1;d<a.length;d++){var c=a[d];if(c.isMiddle){a[d]=o.default.leftRightDelim(c.isMiddle.value,i,l,c.isMiddle.options,t.mode,[]);var h=m.spliceSpaces(c.children,0);if(h){n.default.prependChildren(a[d],h)}}}}var v=void 0;if(t.value.right==="."){v=m.makeNullDelimiter(r,["mclose"])}else{v=o.default.leftRightDelim(t.value.right,i,l,r,t.mode,["mclose"])}a.push(v);return n.default.makeSpan(["minner"],a,r)},mathmlBuilder:function e(t,r){var a=b.buildExpression(t.value.body,r);if(t.value.left!=="."){var n=new f.default.MathNode("mo",[b.makeText(t.value.left,t.mode)]);n.setAttribute("fence","true");a.unshift(n)}if(t.value.right!=="."){var i=new f.default.MathNode("mo",[b.makeText(t.value.right,t.mode)]);i.setAttribute("fence","true");a.push(i)}var l=new f.default.MathNode("mrow",a);return l}});(0,l.default)({type:"middle",names:["\\middle"],props:{numArgs:1},handler:function e(t,r){var a=M(r[0],t);if(!t.parser.leftrightDepth){throw new c.default("\\middle without preceding \\left",a)}return{type:"middle",value:a.value}},htmlBuilder:function e(t,r){var a=void 0;if(t.value.value==="."){a=m.makeNullDelimiter(r,[])}else{a=o.default.sizedDelim(t.value.value,1,r,t.mode,[]);a.isMiddle={value:t.value.value,options:r}}return a},mathmlBuilder:function e(t,r){var a=new f.default.MathNode("mo",[b.makeText(t.value.middle,t.mode)]);a.setAttribute("fence","true");return a}})},{"../ParseError":84,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../delimiter":97,"../mathMLTree":121,"../utils":128}],106:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=b(a);var i=e("../buildCommon");var l=b(i);var u=e("../delimiter");var o=b(u);var s=e("../mathMLTree");var f=b(s);var d=e("../Style");var c=b(d);var h=e("../buildHTML");var v=g(h);var p=e("../buildMathML");var m=g(p);function g(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function b(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"genfrac",names:["\\dfrac","\\frac","\\tfrac","\\dbinom","\\binom","\\tbinom","\\\\atopfrac"],props:{numArgs:2,greediness:2},handler:function e(t,r){var a=r[0];var n=r[1];var i=void 0;var l=null;var u=null;var o="auto";switch(t.funcName){case"\\dfrac":case"\\frac":case"\\tfrac":i=true;break;case"\\\\atopfrac":i=false;break;case"\\dbinom":case"\\binom":case"\\tbinom":i=false;l="(";u=")";break;default:throw new Error("Unrecognized genfrac command")}switch(t.funcName){case"\\dfrac":case"\\dbinom":o="display";break;case"\\tfrac":case"\\tbinom":o="text";break}return{type:"genfrac",numer:a,denom:n,hasBarLine:i,leftDelim:l,rightDelim:u,size:o}},htmlBuilder:function e(t,r){var a=r.style;if(t.value.size==="display"){a=c.default.DISPLAY}else if(t.value.size==="text"){a=c.default.TEXT}var n=a.fracNum();var i=a.fracDen();var u=void 0;u=r.havingStyle(n);var s=v.buildGroup(t.value.numer,u,r);u=r.havingStyle(i);var f=v.buildGroup(t.value.denom,u,r);var d=void 0;var h=void 0;var p=void 0;if(t.value.hasBarLine){d=l.default.makeLineSpan("frac-line",r);h=d.height;p=d.height}else{d=null;h=0;p=r.fontMetrics().defaultRuleThickness}var m=void 0;var g=void 0;var b=void 0;if(a.size===c.default.DISPLAY.size){m=r.fontMetrics().num1;if(h>0){g=3*p}else{g=7*p}b=r.fontMetrics().denom1}else{if(h>0){m=r.fontMetrics().num2;g=p}else{m=r.fontMetrics().num3;g=3*p}b=r.fontMetrics().denom2}var y=void 0;if(h===0){var x=m-s.depth-(f.height-b);if(x<g){m+=.5*(g-x);b+=.5*(g-x)}y=l.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:f,shift:b},{type:"elem",elem:s,shift:-m}]},r)}else{var w=r.fontMetrics().axisHeight;if(m-s.depth-(w+.5*h)<g){m+=g-(m-s.depth-(w+.5*h))}if(w-.5*h-(f.height-b)<g){b+=g-(w-.5*h-(f.height-b))}var k=-(w-.5*h);y=l.default.makeVList({positionType:"individualShift",children:[{type:"elem",elem:f,shift:b},{type:"elem",elem:d,shift:k},{type:"elem",elem:s,shift:-m}]},r)}u=r.havingStyle(a);y.height*=u.sizeMultiplier/r.sizeMultiplier;y.depth*=u.sizeMultiplier/r.sizeMultiplier;var M=void 0;if(a.size===c.default.DISPLAY.size){M=r.fontMetrics().delim1}else{M=r.fontMetrics().delim2}var _=void 0;var S=void 0;if(t.value.leftDelim==null){_=v.makeNullDelimiter(r,["mopen"])}else{_=o.default.customSizedDelim(t.value.leftDelim,M,true,r.havingStyle(a),t.mode,["mopen"])}if(t.value.rightDelim==null){S=v.makeNullDelimiter(r,["mclose"])}else{S=o.default.customSizedDelim(t.value.rightDelim,M,true,r.havingStyle(a),t.mode,["mclose"])}return l.default.makeSpan(["mord"].concat(u.sizingClasses(r)),[_,l.default.makeSpan(["mfrac"],[y]),S],r)},mathmlBuilder:function e(t,r){var a=new f.default.MathNode("mfrac",[m.buildGroup(t.value.numer,r),m.buildGroup(t.value.denom,r)]);if(!t.value.hasBarLine){a.setAttribute("linethickness","0px")}if(t.value.leftDelim!=null||t.value.rightDelim!=null){var n=[];if(t.value.leftDelim!=null){var i=new f.default.MathNode("mo",[new f.default.TextNode(t.value.leftDelim)]);i.setAttribute("fence","true");n.push(i)}n.push(a);if(t.value.rightDelim!=null){var l=new f.default.MathNode("mo",[new f.default.TextNode(t.value.rightDelim)]);l.setAttribute("fence","true");n.push(l)}var u=new f.default.MathNode("mrow",n);return u}return a}})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../delimiter":97,"../mathMLTree":121}],107:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"href",names:["\\href"],props:{numArgs:2,argTypes:["url","original"]},handler:function e(t,r){var n=r[1];var i=r[0].value;return{type:"href",href:i,body:(0,a.ordargument)(n)}},htmlBuilder:function e(t,r){var a=f.buildExpression(t.value.body,r,false);var n=t.value.href;var i=[];var u=void 0;var o=void 0;if(a.length===1){i=a[0].classes}else if(a.length>=2){u=f.getTypeOfDomTree(a[0])||"mord";o=f.getTypeOfDomTree(a[a.length-1])||"mord";if(u===o){i=[u]}else{var s=l.default.makeAnchor(n,[],a,r);return new l.default.makeFragment([new l.default.makeSpan([u],[],r),s,new l.default.makeSpan([o],[],r)])}}return new l.default.makeAnchor(n,i,a,r)},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.body,r);var n=new o.default.MathNode("mrow",a);n.setAttribute("href",t.value.href);return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],108:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=c(a);var i=e("../buildCommon");var l=c(i);var u=e("../mathMLTree");var o=c(u);var s=e("../units");var f=e("../ParseError");var d=c(f);function c(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"kern",names:["\\kern","\\mkern","\\hskip","\\mskip"],props:{numArgs:1,argTypes:["size"],allowedInText:true},handler:function e(t,r){var a=t.funcName[1]==="m";var n=r[0].value.unit==="mu";if(a){if(!n){typeof console!=="undefined"&&console.warn("In LaTeX, "+t.funcName+" supports only mu units, "+("not "+r[0].value.unit+" units"))}if(t.parser.mode!=="math"){throw new d.default("Can't use function '"+t.funcName+"' in text mode")}}else{if(n){typeof console!=="undefined"&&console.warn("In LaTeX, "+t.funcName+" does not support mu units")}}return{type:"kern",dimension:r[0].value}},htmlBuilder:function e(t,r){var a=l.default.makeSpan(["mord","rule"],[],r);if(t.value.dimension){var n=(0,s.calculateSize)(t.value.dimension,r);a.style.marginLeft=n+"em"}return a},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mspace");if(t.value.dimension){var n=(0,s.calculateSize)(t.value.dimension,r);a.setAttribute("width",n+"em")}return a}})},{"../ParseError":84,"../buildCommon":91,"../defineFunction":96,"../mathMLTree":121,"../units":127}],109:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"lap",names:["\\mathllap","\\mathrlap","\\mathclap"],props:{numArgs:1,allowedInText:true},handler:function e(t,r){var a=r[0];return{type:"lap",alignment:t.funcName.slice(5),body:a}},htmlBuilder:function e(t,r){var a=void 0;if(t.value.alignment==="clap"){a=l.default.makeSpan([],[f.buildGroup(t.value.body,r)]);a=l.default.makeSpan(["inner"],[a],r)}else{a=l.default.makeSpan(["inner"],[f.buildGroup(t.value.body,r)])}var n=l.default.makeSpan(["fix"],[]);return l.default.makeSpan(["mord",t.value.alignment],[a,n],r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mpadded",[c.buildGroup(t.value.body,r)]);if(t.value.alignment!=="rlap"){var n=t.value.alignment==="llap"?"-1":"-0.5";a.setAttribute("lspace",n+"width")}a.setAttribute("width","0px");return a}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],110:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=m(a);var i=e("../buildCommon");var l=m(i);var u=e("../mathMLTree");var o=m(u);var s=e("../Style");var f=m(s);var d=e("../buildHTML");var c=p(d);var h=e("../buildMathML");var v=p(h);function p(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function m(e){return e&&e.__esModule?e:{default:e}}var g=function e(t,r){var a=r.style;if(a.size===f.default.DISPLAY.size){return t.value.display}else if(a.size===f.default.TEXT.size){return t.value.text}else if(a.size===f.default.SCRIPT.size){return t.value.script}else if(a.size===f.default.SCRIPTSCRIPT.size){return t.value.scriptscript}return t.value.text};(0,n.default)({type:"mathchoice",names:["\\mathchoice"],props:{numArgs:4},handler:function e(t,r){return{type:"mathchoice",display:(0,a.ordargument)(r[0]),text:(0,a.ordargument)(r[1]),script:(0,a.ordargument)(r[2]),scriptscript:(0,a.ordargument)(r[3])}},htmlBuilder:function e(t,r){var a=g(t,r);var n=c.buildExpression(a,r,false);return new l.default.makeFragment(n)},mathmlBuilder:function e(t,r){var a=g(t,r);var n=v.buildExpression(a,r,false);return new o.default.MathNode("mrow",n)}})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],111:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=m(a);var i=e("../buildCommon");var l=m(i);var u=e("../mathMLTree");var o=m(u);var s=e("../Style");var f=m(s);var d=e("../buildHTML");var c=p(d);var h=e("../buildMathML");var v=p(h);function p(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function m(e){return e&&e.__esModule?e:{default:e}}var g=function e(t,r){var a=[];if(t.value.modType==="bmod"){if(!r.style.isTight()){a.push(l.default.makeSpan(["mspace","muspace"],[],r))}else{a.push(l.default.makeSpan(["mspace","thickspace"],[],r))}}else if(r.style.size===f.default.DISPLAY.size){a.push(l.default.makeSpan(["mspace","quad"],[],r))}else if(t.value.modType==="mod"){a.push(l.default.makeSpan(["mspace","twelvemuspace"],[],r))}else{a.push(l.default.makeSpan(["mspace","eightmuspace"],[],r))}if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(l.default.mathsym("(",t.mode))}if(t.value.modType!=="pod"){var n=[l.default.mathsym("m",t.mode),l.default.mathsym("o",t.mode),l.default.mathsym("d",t.mode)];if(t.value.modType==="bmod"){a.push(l.default.makeSpan(["mbin"],n,r));if(!r.style.isTight()){a.push(l.default.makeSpan(["mspace","muspace"],[],r))}else{a.push(l.default.makeSpan(["mspace","thickspace"],[],r))}}else{Array.prototype.push.apply(a,n);a.push(l.default.makeSpan(["mspace","sixmuspace"],[],r))}}if(t.value.value){Array.prototype.push.apply(a,c.buildExpression(t.value.value,r,false))}if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(l.default.mathsym(")",t.mode))}return l.default.makeFragment(a)};var b=function e(t,r){var a=[];if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(new o.default.MathNode("mo",[v.makeText("(",t.mode)]))}if(t.value.modType!=="pod"){a.push(new o.default.MathNode("mo",[v.makeText("mod",t.mode)]))}if(t.value.value){var n=new o.default.MathNode("mspace");n.setAttribute("width","0.333333em");a.push(n);a=a.concat(v.buildExpression(t.value.value,r))}if(t.value.modType==="pod"||t.value.modType==="pmod"){a.push(new o.default.MathNode("mo",[v.makeText(")",t.mode)]))}return new o.default.MathNode("mo",a)};(0,n.default)({type:"mod",names:["\\bmod"],props:{numArgs:0},handler:function e(t,r){return{type:"mod",modType:"bmod",value:null}},htmlBuilder:g,mathmlBuilder:b});(0,n.default)({type:"mod",names:["\\pod","\\pmod","\\mod"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"mod",modType:t.funcName.substr(1),value:(0,a.ordargument)(n)}},htmlBuilder:g,mathmlBuilder:b})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],112:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=x(a);var i=e("../buildCommon");var l=x(i);var u=e("../domTree");var o=x(u);var s=e("../mathMLTree");var f=x(s);var d=e("../utils");var c=x(d);var h=e("../Style");var v=x(h);var p=e("../buildHTML");var m=y(p);var g=e("../buildMathML");var b=y(g);function y(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function x(e){return e&&e.__esModule?e:{default:e}}var w=function e(t,r){var a=void 0;var n=void 0;var i=false;if(t.type==="supsub"){a=t.value.sup;n=t.value.sub;t=t.value.base;i=true}var u=r.style;var s=["\\smallint"];var f=false;if(u.size===v.default.DISPLAY.size&&t.value.symbol&&!c.default.contains(s,t.value.body)){f=true}var d=void 0;if(t.value.symbol){var h=f?"Size2-Regular":"Size1-Regular";d=l.default.makeSymbol(t.value.body,h,"math",r,["mop","op-symbol",f?"large-op":"small-op"])}else if(t.value.value){var p=m.buildExpression(t.value.value,r,true);if(p.length===1&&p[0]instanceof o.default.symbolNode){d=p[0];d.classes[0]="mop"}else{d=l.default.makeSpan(["mop"],p,r)}}else{var g=[];for(var b=1;b<t.value.body.length;b++){g.push(l.default.mathsym(t.value.body[b],t.mode))}d=l.default.makeSpan(["mop"],g,r)}var y=0;var x=0;if(d instanceof o.default.symbolNode){y=(d.height-d.depth)/2-r.fontMetrics().axisHeight;x=d.italic}if(i){d=l.default.makeSpan([],[d]);var w=void 0;var k=void 0;if(a){var M=m.buildGroup(a,r.havingStyle(u.sup()),r);k={elem:M,kern:Math.max(r.fontMetrics().bigOpSpacing1,r.fontMetrics().bigOpSpacing3-M.depth)}}if(n){var _=m.buildGroup(n,r.havingStyle(u.sub()),r);w={elem:_,kern:Math.max(r.fontMetrics().bigOpSpacing2,r.fontMetrics().bigOpSpacing4-_.height)}}var S=void 0;if(k&&w){var z=r.fontMetrics().bigOpSpacing5+w.elem.height+w.elem.depth+w.kern+d.depth+y;S=l.default.makeVList({positionType:"bottom",positionData:z,children:[{type:"kern",size:r.fontMetrics().bigOpSpacing5},{type:"elem",elem:w.elem,marginLeft:-x+"em"},{type:"kern",size:w.kern},{type:"elem",elem:d},{type:"kern",size:k.kern},{type:"elem",elem:k.elem,marginLeft:x+"em"},{type:"kern",size:r.fontMetrics().bigOpSpacing5}]},r)}else if(w){var T=d.height-y;S=l.default.makeVList({positionType:"top",positionData:T,children:[{type:"kern",size:r.fontMetrics().bigOpSpacing5},{type:"elem",elem:w.elem,marginLeft:-x+"em"},{type:"kern",size:w.kern},{type:"elem",elem:d}]},r)}else if(k){var C=d.depth+y;S=l.default.makeVList({positionType:"bottom",positionData:C,children:[{type:"elem",elem:d},{type:"kern",size:k.kern},{type:"elem",elem:k.elem,marginLeft:x+"em"},{type:"kern",size:r.fontMetrics().bigOpSpacing5}]},r)}else{return d}return l.default.makeSpan(["mop","op-limits"],[S],r)}else{if(y){d.style.position="relative";d.style.top=y+"em"}return d}};var k=function e(t,r){var a=void 0;if(t.value.symbol){a=new f.default.MathNode("mo",[b.makeText(t.value.body,t.mode)])}else if(t.value.value){a=new f.default.MathNode("mo",b.buildExpression(t.value.value,r))}else{a=new f.default.MathNode("mi",[new f.default.TextNode(t.value.body.slice(1))]);var n=new f.default.MathNode("mo",[b.makeText("\u2061","text")]);return new o.default.documentFragment([a,n])}return a};var M={"\u220f":"\\prod","\u2210":"\\coprod","\u2211":"\\sum","\u22c0":"\\bigwedge","\u22c1":"\\bigvee","\u22c2":"\\bigcap","\u22c3":"\\bigcap","\u2a00":"\\bigodot","\u2a01":"\\bigoplus","\u2a02":"\\bigotimes","\u2a04":"\\biguplus","\u2a06":"\\bigsqcup"};(0,n.default)({type:"op",names:["\\coprod","\\bigvee","\\bigwedge","\\biguplus","\\bigcap","\\bigcup","\\intop","\\prod","\\sum","\\bigotimes","\\bigoplus","\\bigodot","\\bigsqcup","\\smallint","\u220f","\u2210","\u2211","\u22c0","\u22c1","\u22c2","\u22c3","\u2a00","\u2a01","\u2a02","\u2a04","\u2a06"],props:{numArgs:0},handler:function e(t,r){var a=t.funcName;if(a.length===1){a=M[a]}return{type:"op",limits:true,symbol:true,body:a}},htmlBuilder:w,mathmlBuilder:k});(0,n.default)({type:"op",names:["\\mathop"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"op",limits:false,symbol:false,value:(0,a.ordargument)(n)}},htmlBuilder:w,mathmlBuilder:k})},{"../Style":89,"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../domTree":98,"../mathMLTree":121,"../utils":128}],113:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=m(a);var i=e("../buildCommon");var l=m(i);var u=e("../mathMLTree");var o=m(u);var s=e("../domTree");var f=m(s);var d=e("../buildHTML");var c=p(d);var h=e("../buildMathML");var v=p(h);function p(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function m(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"operatorname",names:["\\operatorname"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"operatorname",value:(0,a.ordargument)(n)}},htmlBuilder:function e(t,r){var a=[];if(t.value.value.length>0){var n="";var i="";var u=c.buildExpression(t.value.value,r,true);for(var o=0;o<u.length;o++){n=u[o].value;n=n.replace(/\u2212/,"-");n=n.replace(/\u2217/,"*");i=/[\u0391-\u03D7]/.test(n)?"math":"text";a.push(l.default.mathsym(n,i))}}return l.default.makeSpan(["mop"],a,r)},mathmlBuilder:function e(t,r){var a=[];if(t.value.value.length>0){var n=v.buildExpression(t.value.value,r);var i="";for(var l=0;l<n.length;l++){i+=n[l].children[0].text}i=i.replace(/\u2212/g,"-");i=i.replace(/\u2217/g,"*");a=[new o.default.TextNode(i)]}var u=new o.default.MathNode("mi",a);u.setAttribute("mathvariant","normal");var s=new o.default.MathNode("mo",[v.makeText("\u2061","text")]);return new f.default.documentFragment([u,s])}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../domTree":98,"../mathMLTree":121}],114:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"overline",names:["\\overline"],props:{numArgs:1},handler:function e(t,r){var a=r[0];return{type:"overline",body:a}},htmlBuilder:function e(t,r){var a=f.buildGroup(t.value.body,r.havingCrampedStyle());var n=l.default.makeLineSpan("overline-line",r);var i=l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a},{type:"kern",size:3*n.height},{type:"elem",elem:n},{type:"kern",size:n.height}]},r);return l.default.makeSpan(["mord","overline"],[i],r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mo",[new o.default.TextNode("\u203e")]);a.setAttribute("stretchy","true");var n=new o.default.MathNode("mover",[c.buildGroup(t.value.body,r),a]);n.setAttribute("accent","true");return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],115:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"phantom",names:["\\phantom"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"phantom",value:(0,a.ordargument)(n)}},htmlBuilder:function e(t,r){var a=f.buildExpression(t.value.value,r.withPhantom(),false);return new l.default.makeFragment(a)},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.value,r);return new o.default.MathNode("mphantom",a)}});(0,n.default)({type:"hphantom",names:["\\hphantom"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"hphantom",value:(0,a.ordargument)(n),body:n}},htmlBuilder:function e(t,r){var a=l.default.makeSpan([],[f.buildGroup(t.value.body,r.withPhantom())]);a.height=0;a.depth=0;if(a.children){for(var n=0;n<a.children.length;n++){a.children[n].height=0;a.children[n].depth=0}}a=l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a}]},r);return a},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.value,r);var n=new o.default.MathNode("mphantom",a);n.setAttribute("height","0px");return n}});(0,n.default)({type:"vphantom",names:["\\vphantom"],props:{numArgs:1},handler:function e(t,r){var n=r[0];return{type:"vphantom",value:(0,a.ordargument)(n),body:n}},htmlBuilder:function e(t,r){var a=l.default.makeSpan(["inner"],[f.buildGroup(t.value.body,r.withPhantom())]);var n=l.default.makeSpan(["fix"],[]);return l.default.makeSpan(["mord","rlap"],[a,n],r)},mathmlBuilder:function e(t,r){var a=c.buildExpression(t.value.value,r);var n=new o.default.MathNode("mphantom",a);n.setAttribute("width","0px");return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],116:[function(e,t,r){"use strict";var a=e("../buildCommon");var n=f(a);var i=e("../defineFunction");var l=f(i);var u=e("../mathMLTree");var o=f(u);var s=e("../units");function f(e){return e&&e.__esModule?e:{default:e}}(0,l.default)({type:"rule",names:["\\rule"],props:{numArgs:2,numOptionalArgs:1,argTypes:["size","size","size"]},handler:function e(t,r,a){var n=a[0];var i=r[0];var l=r[1];return{type:"rule",shift:n&&n.value,width:i.value,height:l.value}},htmlBuilder:function e(t,r){var a=n.default.makeSpan(["mord","rule"],[],r);var i=0;if(t.value.shift){i=(0,s.calculateSize)(t.value.shift,r)}var l=(0,s.calculateSize)(t.value.width,r);var u=(0,s.calculateSize)(t.value.height,r);a.style.borderRightWidth=l+"em";a.style.borderTopWidth=u+"em";a.style.bottom=i+"em";a.width=l;a.height=u+i;a.depth=-i;a.maxFontSize=u*1.125*r.sizeMultiplier;return a},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mrow");return a}})},{"../buildCommon":91,"../defineFunction":96,"../mathMLTree":121,"../units":127}],117:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"smash",names:["\\smash"],props:{numArgs:1,numOptionalArgs:1,allowedInText:true},handler:function e(t,r,a){var n=false;var i=false;var l=a[0];if(l){var u="";for(var o=0;o<l.value.length;++o){u=l.value[o].value;if(u==="t"){n=true}else if(u==="b"){i=true}else{n=false;i=false;break}}}else{n=true;i=true}var s=r[0];return{type:"smash",body:s,smashHeight:n,smashDepth:i}},htmlBuilder:function e(t,r){var a=l.default.makeSpan(["mord"],[f.buildGroup(t.value.body,r)]);if(!t.value.smashHeight&&!t.value.smashDepth){return a}if(t.value.smashHeight){a.height=0;if(a.children){for(var n=0;n<a.children.length;n++){a.children[n].height=0}}}if(t.value.smashDepth){a.depth=0;if(a.children){for(var i=0;i<a.children.length;i++){a.children[i].depth=0}}}return l.default.makeVList({positionType:"firstBaseline",children:[{type:"elem",elem:a}]},r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mpadded",[c.buildGroup(t.value.body,r)]);if(t.value.smashHeight){a.setAttribute("height","0px")}if(t.value.smashDepth){a.setAttribute("depth","0px")}return a}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],118:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}var p={"\\text":undefined,"\\textrm":"textrm","\\textsf":"textsf","\\texttt":"texttt","\\textnormal":"textrm"};var m={"\\textbf":"textbf"};var g={"\\textit":"textit"};(0,n.default)({type:"text",names:["\\text","\\textrm","\\textsf","\\texttt","\\textnormal","\\textbf","\\textit"],props:{numArgs:1,argTypes:["text"],greediness:2,allowedInText:true},handler:function e(t,r){var n=r[0];return{type:"text",body:(0,a.ordargument)(n),font:t.funcName}},htmlBuilder:function e(t,r){var a=t.value.font;var n=void 0;if(p[a]){n=r.withFontFamily(p[a])}else if(m[a]){n=r.withFontWeight(m[a])}else{n=r.withFontShape(g[a])}var i=f.buildExpression(t.value.body,n,true);l.default.tryCombineChars(i);return l.default.makeSpan(["mord","text"],i,n)},mathmlBuilder:function e(t,r){var a=t.value.body;var n=[];var i=null;for(var l=0;l<a.length;l++){var u=c.buildGroup(a[l],r);if(u.type==="mtext"&&i!=null){Array.prototype.push.apply(i.children,u.children)}else{n.push(u);if(u.type==="mtext"){i=u}}}if(n.length===1){return n[0]}else{return new o.default.MathNode("mrow",n)}}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],119:[function(e,t,r){"use strict";var a=e("../defineFunction");var n=v(a);var i=e("../buildCommon");var l=v(i);var u=e("../mathMLTree");var o=v(u);var s=e("../buildHTML");var f=h(s);var d=e("../buildMathML");var c=h(d);function h(e){if(e&&e.__esModule){return e}else{var t={};if(e!=null){for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r))t[r]=e[r]}}t.default=e;return t}}function v(e){return e&&e.__esModule?e:{default:e}}(0,n.default)({type:"underline",names:["\\underline"],props:{numArgs:1},handler:function e(t,r){var a=r[0];return{type:"underline",body:a}},htmlBuilder:function e(t,r){var a=f.buildGroup(t.value.body,r);var n=l.default.makeLineSpan("underline-line",r);var i=l.default.makeVList({positionType:"top",positionData:a.height,children:[{type:"kern",size:n.height},{type:"elem",elem:n},{type:"kern",size:3*n.height},{type:"elem",elem:a}]},r);return l.default.makeSpan(["mord","underline"],[i],r)},mathmlBuilder:function e(t,r){var a=new o.default.MathNode("mo",[new o.default.TextNode("\u203e")]);a.setAttribute("stretchy","true");var n=new o.default.MathNode("munder",[c.buildGroup(t.value.body,r),a]);n.setAttribute("accentunder","true");return n}})},{"../buildCommon":91,"../buildHTML":92,"../buildMathML":93,"../defineFunction":96,"../mathMLTree":121}],120:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./fontMetricsData");var n=f(a);var i=e("./symbols");var l=f(i);var u=e("./utils");var o=f(u);var s=e("./Token");function f(e){return e&&e.__esModule?e:{default:e}}var d={};r.default=d;function c(e,t){d[e]=t}c("\\@firstoftwo",function(e){var t=e.consumeArgs(2);return{tokens:t[0],numArgs:0}});c("\\@ifnextchar",function(e){var t=e.consumeArgs(3);var r=e.future();if(t[0].length===1&&t[0][0].text===r.text){return{tokens:t[1],numArgs:0}}else{return{tokens:t[2],numArgs:0}}});c("\\@ifstar","\\@ifnextchar *{\\@firstoftwo{#1}}");c("\\bgroup","{");c("\\egroup","}");c("\\begingroup","{");c("\\endgroup","}");c("\u2102","\\mathbb{C}");c("\u210d","\\mathbb{H}");c("\u2115","\\mathbb{N}");c("\u2119","\\mathbb{P}");c("\u211a","\\mathbb{Q}");c("\u211d","\\mathbb{R}");c("\u2124","\\mathbb{Z}");c("\xb7","\\cdotp");c("\\llap","\\mathllap{\\textrm{#1}}");c("\\rlap","\\mathrlap{\\textrm{#1}}");c("\\clap","\\mathclap{\\textrm{#1}}");c("\\overset","\\mathop{#2}\\limits^{#1}");c("\\underset","\\mathop{#2}\\limits_{#1}");c("\\boxed","\\fbox{\\displaystyle{#1}}");c("\\iff","\\DOTSB\\;\\Longleftrightarrow\\;");c("\\implies","\\DOTSB\\;\\Longrightarrow\\;");c("\\impliedby","\\DOTSB\\;\\Longleftarrow\\;");var h={",":"\\dotsc","\\not":"\\dotsb","+":"\\dotsb","=":"\\dotsb","<":"\\dotsb",">":"\\dotsb","-":"\\dotsb","*":"\\dotsb",":":"\\dotsb","\\DOTSB":"\\dotsb","\\coprod":"\\dotsb","\\bigvee":"\\dotsb","\\bigwedge":"\\dotsb","\\biguplus":"\\dotsb","\\bigcap":"\\dotsb","\\bigcup":"\\dotsb","\\prod":"\\dotsb","\\sum":"\\dotsb","\\bigotimes":"\\dotsb","\\bigoplus":"\\dotsb","\\bigodot":"\\dotsb","\\bigsqcup":"\\dotsb","\\implies":"\\dotsb","\\impliedby":"\\dotsb","\\And":"\\dotsb","\\longrightarrow":"\\dotsb","\\Longrightarrow":"\\dotsb","\\longleftarrow":"\\dotsb","\\Longleftarrow":"\\dotsb","\\longleftrightarrow":"\\dotsb","\\Longleftrightarrow":"\\dotsb","\\mapsto":"\\dotsb","\\longmapsto":"\\dotsb","\\hookrightarrow":"\\dotsb","\\iff":"\\dotsb","\\doteq":"\\dotsb","\\mathbin":"\\dotsb","\\bmod":"\\dotsb","\\mathrel":"\\dotsb","\\relbar":"\\dotsb","\\Relbar":"\\dotsb","\\xrightarrow":"\\dotsb","\\xleftarrow":"\\dotsb","\\DOTSI":"\\dotsi","\\int":"\\dotsi","\\oint":"\\dotsi","\\iint":"\\dotsi","\\iiint":"\\dotsi","\\iiiint":"\\dotsi",
"\\idotsint":"\\dotsi","\\DOTSX":"\\dotsx"};c("\\dots",function(e){var t="\\dotso";var r=e.expandAfterFuture().text;if(r in h){t=h[r]}else if(r.substr(0,4)==="\\not"){t="\\dotsb"}else if(r in l.default.math){if(o.default.contains(["bin","rel"],l.default.math[r].group)){t="\\dotsb"}}return t});var v={")":true,"]":true,"\\rbrack":true,"\\}":true,"\\rbrace":true,"\\rangle":true,"\\rceil":true,"\\rfloor":true,"\\rgroup":true,"\\rmoustache":true,"\\right":true,"\\bigr":true,"\\biggr":true,"\\Bigr":true,"\\Biggr":true,$:true,";":true,".":true,",":true};c("\\dotso",function(e){var t=e.future().text;if(t in v){return"\\ldots\\,"}else{return"\\ldots"}});c("\\dotsc",function(e){var t=e.future().text;if(t in v&&t!==","){return"\\ldots\\,"}else{return"\\ldots"}});c("\\cdots",function(e){var t=e.future().text;if(t in v){return"\\@cdots\\,"}else{return"\\@cdots"}});c("\\dotsb","\\cdots");c("\\dotsm","\\cdots");c("\\dotsi","\\!\\cdots");c("\\dotsx","\\ldots\\,");c("\\DOTSI","\\relax");c("\\DOTSB","\\relax");c("\\DOTSX","\\relax");c("\\thinspace","\\,");c("\\medspace","\\:");c("\\thickspace","\\;");c("\\TeX","\\textrm{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}");var p=n.default["Main-Regular"]["T".charCodeAt(0)][1]-.7*n.default["Main-Regular"]["A".charCodeAt(0)][1]+"em";c("\\LaTeX","\\textrm{L\\kern-.36em\\raisebox{"+p+"}{\\scriptsize A}"+"\\kern-.15em\\TeX}");c("\\KaTeX","\\textrm{K\\kern-.17em\\raisebox{"+p+"}{\\scriptsize A}"+"\\kern-.15em\\TeX}");c("\\hspace","\\@ifstar\\kern\\kern");c("\\ordinarycolon",":");c("\\vcentcolon","\\mathrel{\\mathop\\ordinarycolon}");c("\\dblcolon","\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon");c("\\coloneqq","\\vcentcolon\\mathrel{\\mkern-1.2mu}=");c("\\Coloneqq","\\dblcolon\\mathrel{\\mkern-1.2mu}=");c("\\coloneq","\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}");c("\\Coloneq","\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}");c("\\eqqcolon","=\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\Eqqcolon","=\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\eqcolon","\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\Eqcolon","\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\colonapprox","\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx");c("\\Colonapprox","\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx");c("\\colonsim","\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim");c("\\Colonsim","\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim");c("\\ratio","\\vcentcolon");c("\\coloncolon","\\dblcolon");c("\\colonequals","\\coloneqq");c("\\coloncolonequals","\\Coloneqq");c("\\equalscolon","\\eqqcolon");c("\\equalscoloncolon","\\Eqqcolon");c("\\colonminus","\\coloneq");c("\\coloncolonminus","\\Coloneq");c("\\minuscolon","\\eqcolon");c("\\minuscoloncolon","\\Eqcolon");c("\\coloncolonapprox","\\Colonapprox");c("\\coloncolonsim","\\Colonsim");c("\\simcolon","\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\simcoloncolon","\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\approxcolon","\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon");c("\\approxcoloncolon","\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon");c("\\notni","\\not\\ni")},{"./Token":90,"./fontMetricsData":102,"./symbols":125,"./utils":128}],121:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/core-js/get-iterator");var n=d(a);var i=e("babel-runtime/helpers/classCallCheck");var l=d(i);var u=e("babel-runtime/helpers/createClass");var o=d(u);var s=e("./utils");var f=d(s);function d(e){return e&&e.__esModule?e:{default:e}}var c=function(){function e(t,r){(0,l.default)(this,e);this.type=t;this.attributes={};this.children=r||[]}(0,o.default)(e,[{key:"setAttribute",value:function e(t,r){this.attributes[t]=r}},{key:"toNode",value:function e(){var t=document.createElementNS("http://www.w3.org/1998/Math/MathML",this.type);for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t.setAttribute(r,this.attributes[r])}}var a=true;var i=false;var l=undefined;try{for(var u=(0,n.default)(this.children),o;!(a=(o=u.next()).done);a=true){var s=o.value;t.appendChild(s.toNode())}}catch(e){i=true;l=e}finally{try{if(!a&&u.return){u.return()}}finally{if(i){throw l}}}return t}},{key:"toMarkup",value:function e(){var t="<"+this.type;for(var r in this.attributes){if(Object.prototype.hasOwnProperty.call(this.attributes,r)){t+=" "+r+'="';t+=f.default.escape(this.attributes[r]);t+='"'}}t+=">";for(var a=0;a<this.children.length;a++){t+=this.children[a].toMarkup()}t+="</"+this.type+">";return t}}]);return e}();var h=function(){function e(t){(0,l.default)(this,e);this.text=t}(0,o.default)(e,[{key:"toNode",value:function e(){return document.createTextNode(this.text)}},{key:"toMarkup",value:function e(){return f.default.escape(this.text)}}]);return e}();r.default={MathNode:c,TextNode:h}},{"./utils":128,"babel-runtime/core-js/get-iterator":3,"babel-runtime/helpers/classCallCheck":8,"babel-runtime/helpers/createClass":9}],122:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("./Parser");var n=i(a);function i(e){return e&&e.__esModule?e:{default:e}}var l=function e(t,r){if(!(typeof t==="string"||t instanceof String)){throw new TypeError("KaTeX can only parse string typed expression")}var a=new n.default(t,r);return a.parse()};r.default=l},{"./Parser":86}],123:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=e("babel-runtime/helpers/slicedToArray");var n=h(a);var i=e("./domTree");var l=h(i);var u=e("./buildCommon");var o=h(u);var s=e("./mathMLTree");var f=h(s);var d=e("./utils");var c=h(d);function h(e){return e&&e.__esModule?e:{default:e}}var v={widehat:"^",widetilde:"~",utilde:"~",overleftarrow:"\u2190",underleftarrow:"\u2190",xleftarrow:"\u2190",overrightarrow:"\u2192",underrightarrow:"\u2192",xrightarrow:"\u2192",underbrace:"\u23b5",overbrace:"\u23de",overleftrightarrow:"\u2194",underleftrightarrow:"\u2194",xleftrightarrow:"\u2194",Overrightarrow:"\u21d2",xRightarrow:"\u21d2",overleftharpoon:"\u21bc",xleftharpoonup:"\u21bc",overrightharpoon:"\u21c0",xrightharpoonup:"\u21c0",xLeftarrow:"\u21d0",xLeftrightarrow:"\u21d4",xhookleftarrow:"\u21a9",xhookrightarrow:"\u21aa",xmapsto:"\u21a6",xrightharpoondown:"\u21c1",xleftharpoondown:"\u21bd",xrightleftharpoons:"\u21cc",xleftrightharpoons:"\u21cb",xtwoheadleftarrow:"\u219e",xtwoheadrightarrow:"\u21a0",xlongequal:"=",xtofrom:"\u21c4"};var p=function e(t){var r=new f.default.MathNode("mo",[new f.default.TextNode(v[t.substr(1)])]);r.setAttribute("stretchy","true");return r};var m={overrightarrow:[["rightarrow"],.888,522,"xMaxYMin"],overleftarrow:[["leftarrow"],.888,522,"xMinYMin"],underrightarrow:[["rightarrow"],.888,522,"xMaxYMin"],underleftarrow:[["leftarrow"],.888,522,"xMinYMin"],xrightarrow:[["rightarrow"],1.469,522,"xMaxYMin"],xleftarrow:[["leftarrow"],1.469,522,"xMinYMin"],Overrightarrow:[["doublerightarrow"],.888,560,"xMaxYMin"],xRightarrow:[["doublerightarrow"],1.526,560,"xMaxYMin"],xLeftarrow:[["doubleleftarrow"],1.526,560,"xMinYMin"],overleftharpoon:[["leftharpoon"],.888,522,"xMinYMin"],xleftharpoonup:[["leftharpoon"],.888,522,"xMinYMin"],xleftharpoondown:[["leftharpoondown"],.888,522,"xMinYMin"],overrightharpoon:[["rightharpoon"],.888,522,"xMaxYMin"],xrightharpoonup:[["rightharpoon"],.888,522,"xMaxYMin"],xrightharpoondown:[["rightharpoondown"],.888,522,"xMaxYMin"],xlongequal:[["longequal"],.888,334,"xMinYMin"],xtwoheadleftarrow:[["twoheadleftarrow"],.888,334,"xMinYMin"],xtwoheadrightarrow:[["twoheadrightarrow"],.888,334,"xMaxYMin"],overleftrightarrow:[["leftarrow","rightarrow"],.888,522],overbrace:[["leftbrace","midbrace","rightbrace"],1.6,548],underbrace:[["leftbraceunder","midbraceunder","rightbraceunder"],1.6,548],underleftrightarrow:[["leftarrow","rightarrow"],.888,522],xleftrightarrow:[["leftarrow","rightarrow"],1.75,522],xLeftrightarrow:[["doubleleftarrow","doublerightarrow"],1.75,560],xrightleftharpoons:[["leftharpoondownplus","rightharpoonplus"],1.75,716],xleftrightharpoons:[["leftharpoonplus","rightharpoondownplus"],1.75,716],xhookleftarrow:[["leftarrow","righthook"],1.08,522],xhookrightarrow:[["lefthook","rightarrow"],1.08,522],overlinesegment:[["leftlinesegment","rightlinesegment"],.888,522],underlinesegment:[["leftlinesegment","rightlinesegment"],.888,522],overgroup:[["leftgroup","rightgroup"],.888,342],undergroup:[["leftgroupunder","rightgroupunder"],.888,342],xmapsto:[["leftmapsto","rightarrow"],1.5,522],xtofrom:[["leftToFrom","rightToFrom"],1.75,528]};var g=function e(t){if(t.type==="ordgroup"){return t.value.length}else{return 1}};var b=function e(t,r){function a(){var e=4e5;var a=t.value.label.substr(1);if(c.default.contains(["widehat","widetilde","utilde"],a)){var i=g(t.value.base);var u=void 0;var s=void 0;var f=void 0;if(i>5){u=a==="widehat"?420:312;e=a==="widehat"?2364:2340;f=a==="widehat"?.42:.34;s=(a==="widehat"?"widehat":"tilde")+"4"}else{var d=[1,1,2,2,3,3][i];if(a==="widehat"){e=[0,1062,2364,2364,2364][d];u=[0,239,300,360,420][d];f=[0,.24,.3,.3,.36,.42][d];s="widehat"+d}else{e=[0,600,1033,2339,2340][d];u=[0,260,286,306,312][d];f=[0,.26,.286,.3,.306,.34][d];s="tilde"+d}}var h=new l.default.pathNode(s);var v=new l.default.svgNode([h],{width:"100%",height:f+"em",viewBox:"0 0 "+e+" "+u,preserveAspectRatio:"none"});return{span:o.default.makeSpan([],[v],r),minWidth:0,height:f}}else{var p=[];var b=(0,n.default)(m[a],4),y=b[0],x=b[1],w=b[2],k=b[3];var M=w/1e3;var _=y.length;var S=void 0;var z=void 0;if(_===1){S=["hide-tail"];z=[k]}else if(_===2){S=["halfarrow-left","halfarrow-right"];z=["xMinYMin","xMaxYMin"]}else if(_===3){S=["brace-left","brace-center","brace-right"];z=["xMinYMin","xMidYMin","xMaxYMin"]}else{throw new Error("Correct katexImagesData or update code here to support\n                    "+_+" children.")}for(var T=0;T<_;T++){var C=new l.default.pathNode(y[T]);var A=new l.default.svgNode([C],{width:"400em",height:M+"em",viewBox:"0 0 "+e+" "+w,preserveAspectRatio:z[T]+" slice"});var O=o.default.makeSpan([S[T]],[A],r);if(_===1){return{span:O,minWidth:x,height:M}}else{O.style.height=M+"em";p.push(O)}}return{span:o.default.makeSpan(["stretchy"],p,r),minWidth:x,height:M}}}var i=a(),u=i.span,s=i.minWidth,f=i.height;u.height=f;u.style.height=f+"em";if(s>0){u.style.minWidth=s+"em"}return u};var y=function e(t,r,a,n){var i=void 0;var u=t.height+t.depth+2*a;if(/fbox|color/.test(r)){i=o.default.makeSpan(["stretchy",r],[],n);if(r==="fbox"){var s=n.color&&n.getColor();if(s){i.style.borderColor=s}}}else{var f=[];if(/^[bx]cancel$/.test(r)){f.push(new l.default.lineNode({x1:"0",y1:"0",x2:"100%",y2:"100%","stroke-width":"0.046em"}))}if(/^x?cancel$/.test(r)){f.push(new l.default.lineNode({x1:"0",y1:"100%",x2:"100%",y2:"0","stroke-width":"0.046em"}))}var d=new l.default.svgNode(f,{width:"100%",height:u+"em"});i=o.default.makeSpan([],[d],n)}i.height=u;i.style.height=u+"em";return i};var x=function e(t,r){var a=new l.default.pathNode("bigRule");var n=new l.default.svgNode([a],{width:"400em",height:"400em",viewBox:"0 0 400000 400000",preserveAspectRatio:"xMinYMin slice"});return o.default.makeSpan([t,"hide-tail"],[n],r)};r.default={encloseSpan:y,mathMLnode:p,ruleSpan:x,svgSpan:b}},{"./buildCommon":91,"./domTree":98,"./mathMLTree":121,"./utils":128,"babel-runtime/helpers/slicedToArray":10}],124:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a={bigRule:"M0 0 h400000 v400000 h-400000z M0 0 h400000 v400000 h-400000z",sqrtMain:"M95 622c-2.667 0-7.167-2.667-13.5\n-8S72 604 72 600c0-2 .333-3.333 1-4 1.333-2.667 23.833-20.667 67.5-54s\n65.833-50.333 66.5-51c1.333-1.333 3-2 5-2 4.667 0 8.667 3.333 12 10l173\n378c.667 0 35.333-71 104-213s137.5-285 206.5-429S812 17.333 812 14c5.333\n-9.333 12-14 20-14h399166v40H845.272L620 507 385 993c-2.667 4.667-9 7-19\n7-6 0-10-1-12-3L160 575l-65 47zM834 0h399166v40H845z",sqrtSize1:"M263 601c.667 0 18 39.667 52 119s68.167\n 158.667 102.5 238 51.833 119.333 52.5 120C810 373.333 980.667 17.667 982 11\nc4.667-7.333 11-11 19-11h398999v40H1012.333L741 607c-38.667 80.667-84 175-136\n 283s-89.167 185.333-111.5 232-33.833 70.333-34.5 71c-4.667 4.667-12.333 7-23\n 7l-12-1-109-253c-72.667-168-109.333-252-110-252-10.667 8-22 16.667-34 26-22\n 17.333-33.333 26-34 26l-26-26 76-59 76-60zM1001 0h398999v40H1012z",sqrtSize2:"M1001 0h398999v40H1013.084S929.667 308 749\n 880s-277 876.333-289 913c-4.667 4.667-12.667 7-24 7h-12c-1.333-3.333-3.667\n-11.667-7-25-35.333-125.333-106.667-373.333-214-744-10 12-21 25-33 39l-32 39\nc-6-5.333-15-14-27-26l25-30c26.667-32.667 52-63 76-91l52-60 208 722c56-175.333\n 126.333-397.333 211-666s153.833-488.167 207.5-658.5C944.167 129.167 975 32.667\n 983 10c4-6.667 10-10 18-10zm0 0h398999v40H1013z",sqrtSize3:"M424 2398c-1.333-.667-38.5-172-111.5-514 S202.667 1370.667 202\n 1370c0-2-10.667 14.333-32 49-4.667 7.333-9.833 15.667-15.5 25s-9.833 16-12.5\n 20l-5 7c-4-3.333-8.333-7.667-13-13l-13-13 76-122 77-121 209 968c0-2 84.667\n-361.667 254-1079C896.333 373.667 981.667 13.333 983 10c4-6.667 10-10 18-10\nh398999v40H1014.622S927.332 418.667 742 1206c-185.333 787.333-279.333 1182.333\n-282 1185-2 6-10 9-24 9-8 0-12-.667-12-2zM1001 0h398999v40H1014z",sqrtSize4:"M473 2713C812.333 913.667 982.333 13 983 11c3.333-7.333 9.333\n-11 18-11h399110v40H1017.698S927.168 518 741.5 1506C555.833 2494 462 2989 460\n 2991c-2 6-10 9-24 9-8 0-12-.667-12-2s-5.333-32-16-92c-50.667-293.333-119.667\n-693.333-207-1200 0-1.333-5.333 8.667-16 30l-32 64-16 33-26-26 76-153 77-151\nc.667.667 35.667 202 105 604 67.333 400.667 102 602.667 104 606z\nM1001 0h398999v40H1017z",doubleleftarrow:"M262 157\nl10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3\n 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28\n 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5\nc2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5\n 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87\n-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7\n-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z\nm8 0v40h399730v-40zm0 194v40h399730v-40z",doublerightarrow:"M399738 392l\n-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5\n 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88\n-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68\n-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18\n-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782\nc-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3\n-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z",leftarrow:"M400000 241H110l3-3c68.7-52.7 113.7-120\n 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8\n-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247\nc-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208\n 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3\n 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202\n l-3-3h399890zM100 241v40h399900v-40z",leftbrace:"M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117\n-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7\n 5-6 9-10 13-.7 1-7.3 1-20 1H6z",leftbraceunder:"M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13\n 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688\n 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7\n-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z",leftgroup:"M400000 80\nH435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0\n 435 0h399565z",leftgroupunder:"M400000 262\nH435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219\n 435 219h399565z",leftharpoon:"M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3\n-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5\n-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7\n-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z",leftharpoonplus:"M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5\n 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3\n-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7\n-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z\nm0 0v40h400000v-40z",leftharpoondown:"M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333\n 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5\n 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667\n-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z",leftharpoondownplus:"M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12\n 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7\n-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0\nv40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z",lefthook:"M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5\n-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3\n-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21\n 71.5 23h399859zM103 281v-40h399897v40z",leftlinesegment:"M40 281 V428 H0 V94 H40 V241 H400000 v40z\nM40 281 V428 H0 V94 H40 V241 H400000 v40z",leftmapsto:"M40 281 V448H0V74H40V241H400000v40z\nM40 281 V448H0V74H40V241H400000v40z",leftToFrom:"M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23\n-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8\nc28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3\n 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z",longequal:"M0 50 h400000 v40H0z m0 194h40000v40H0z\nM0 50 h400000 v40H0z m0 194h40000v40H0z",midbrace:"M200428 334\nc-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14\n-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7\n 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11\n 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z",midbraceunder:"M199572 214\nc100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14\n 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3\n 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0\n-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z",rightarrow:"M0 241v40h399891c-47.3 35.3-84 78-110 128\n-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20\n 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7\n 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85\n-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n 151.7 139 205zm0 0v40h399900v-40z",rightbrace:"M400000 542l\n-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5\ns-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1\nc124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z",rightbraceunder:"M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3\n 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237\n-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z",rightgroup:"M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0\n 3-1 3-3v-38c-76-158-257-219-435-219H0z",rightgroupunder:"M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18\n 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z",rightharpoon:"M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3\n-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2\n-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58\n 69.2 92 94.5zm0 0v40h399900v-40z",rightharpoonplus:"M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11\n-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7\n 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z\nm0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z",rightharpoondown:"M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8\n 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5\n-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95\n-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z",rightharpoondownplus:"M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8\n 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3\n 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3\n-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z\nm0-194v40h400000v-40zm0 0v40h400000v-40z",righthook:"M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3\n 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0\n-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21\n 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z",rightlinesegment:"M399960 241 V94 h40 V428 h-40 V281 H0 v-40z\nM399960 241 V94 h40 V428 h-40 V281 H0 v-40z",rightToFrom:"M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23\n 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32\n-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142\n-167z M100 147v40h399900v-40zM0 341v40h399900v-40z",twoheadleftarrow:"M0 167c68 40\n 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69\n-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3\n-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19\n-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101\n 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z",twoheadrightarrow:"M400000 167\nc-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3\n 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42\n 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333\n-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70\n 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z",tilde1:"M200 55.538c-77 0-168 73.953-177 73.953-3 0-7\n-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0\n 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0\n 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128\n-68.267.847-113-73.952-191-73.952z",tilde2:"M344 55.266c-142 0-300.638 81.316-311.5 86.418\n-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9\n 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114\nc1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751\n 181.476 676 181.476c-149 0-189-126.21-332-126.21z",tilde3:"M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457\n-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0\n 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697\n 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696\n -338 0-409-156.573-744-156.573z",tilde4:"M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345\n-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409\n 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9\n 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409\n -175.236-744-175.236z",widehat1:"M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22\nc-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z",widehat2:"M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",widehat3:"M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",widehat4:"M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z"};r.default={path:a}},{}],125:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a={math:{},text:{}};r.default=a;function n(e,t,r,n,i,l){a[e][i]={font:t,group:r,replace:n};if(l&&n){a[e][n]=a[e][i]}}var i="math";var l="text";var u="main";var o="ams";var s="accent";var f="bin";var d="close";var c="inner";var h="mathord";var v="op";var p="open";var m="punct";var g="rel";var b="spacing";var y="textord";n(i,u,g,"\u2261","\\equiv",true);n(i,u,g,"\u227a","\\prec",true);n(i,u,g,"\u227b","\\succ",true);n(i,u,g,"\u223c","\\sim",true);n(i,u,g,"\u22a5","\\perp");n(i,u,g,"\u2aaf","\\preceq",true);n(i,u,g,"\u2ab0","\\succeq",true);n(i,u,g,"\u2243","\\simeq",true);n(i,u,g,"\u2223","\\mid",true);n(i,u,g,"\u226a","\\ll");n(i,u,g,"\u226b","\\gg",true);n(i,u,g,"\u224d","\\asymp",true);n(i,u,g,"\u2225","\\parallel");n(i,u,g,"\u22c8","\\bowtie",true);n(i,u,g,"\u2323","\\smile",true);n(i,u,g,"\u2291","\\sqsubseteq",true);n(i,u,g,"\u2292","\\sqsupseteq",true);n(i,u,g,"\u2250","\\doteq",true);n(i,u,g,"\u2322","\\frown",true);n(i,u,g,"\u220b","\\ni",true);n(i,u,g,"\u221d","\\propto",true);n(i,u,g,"\u22a2","\\vdash",true);n(i,u,g,"\u22a3","\\dashv",true);n(i,u,g,"\u220b","\\owns");n(i,u,m,".","\\ldotp");n(i,u,m,"\u22c5","\\cdotp");n(i,u,y,"#","\\#");n(l,u,y,"#","\\#");n(i,u,y,"&","\\&");n(l,u,y,"&","\\&");n(i,u,y,"\u2135","\\aleph",true);n(i,u,y,"\u2200","\\forall",true);n(i,u,y,"\u210f","\\hbar");n(i,u,y,"\u2203","\\exists",true);n(i,u,y,"\u2207","\\nabla",true);n(i,u,y,"\u266d","\\flat",true);n(i,u,y,"\u2113","\\ell",true);n(i,u,y,"\u266e","\\natural",true);n(i,u,y,"\u2663","\\clubsuit",true);n(i,u,y,"\u2118","\\wp",true);n(i,u,y,"\u266f","\\sharp",true);n(i,u,y,"\u2662","\\diamondsuit",true);n(i,u,y,"\u211c","\\Re",true);n(i,u,y,"\u2661","\\heartsuit",true);n(i,u,y,"\u2111","\\Im",true);n(i,u,y,"\u2660","\\spadesuit",true);n(i,u,y,"\u2020","\\dag");n(l,u,y,"\u2020","\\dag");n(l,u,y,"\u2020","\\textdagger");n(i,u,y,"\u2021","\\ddag");n(l,u,y,"\u2021","\\ddag");n(l,u,y,"\u2020","\\textdaggerdbl");n(i,u,d,"\u23b1","\\rmoustache");n(i,u,p,"\u23b0","\\lmoustache");n(i,u,d,"\u27ef","\\rgroup");n(i,u,p,"\u27ee","\\lgroup");n(i,u,f,"\u2213","\\mp",true);n(i,u,f,"\u2296","\\ominus",true);n(i,u,f,"\u228e","\\uplus",true);n(i,u,f,"\u2293","\\sqcap",true);n(i,u,f,"\u2217","\\ast");n(i,u,f,"\u2294","\\sqcup",true);n(i,u,f,"\u25ef","\\bigcirc");n(i,u,f,"\u2219","\\bullet");n(i,u,f,"\u2021","\\ddagger");n(i,u,f,"\u2240","\\wr",true);n(i,u,f,"\u2a3f","\\amalg");n(i,u,f,"&","\\And");n(i,u,g,"\u27f5","\\longleftarrow",true);n(i,u,g,"\u21d0","\\Leftarrow",true);n(i,u,g,"\u27f8","\\Longleftarrow",true);n(i,u,g,"\u27f6","\\longrightarrow",true);n(i,u,g,"\u21d2","\\Rightarrow",true);n(i,u,g,"\u27f9","\\Longrightarrow",true);n(i,u,g,"\u2194","\\leftrightarrow",true);n(i,u,g,"\u27f7","\\longleftrightarrow",true);n(i,u,g,"\u21d4","\\Leftrightarrow",true);n(i,u,g,"\u27fa","\\Longleftrightarrow",true);n(i,u,g,"\u21a6","\\mapsto",true);n(i,u,g,"\u27fc","\\longmapsto",true);n(i,u,g,"\u2197","\\nearrow",true);n(i,u,g,"\u21a9","\\hookleftarrow",true);n(i,u,g,"\u21aa","\\hookrightarrow",true);n(i,u,g,"\u2198","\\searrow",true);n(i,u,g,"\u21bc","\\leftharpoonup",true);n(i,u,g,"\u21c0","\\rightharpoonup",true);n(i,u,g,"\u2199","\\swarrow",true);n(i,u,g,"\u21bd","\\leftharpoondown",true);n(i,u,g,"\u21c1","\\rightharpoondown",true);n(i,u,g,"\u2196","\\nwarrow",true);n(i,u,g,"\u21cc","\\rightleftharpoons",true);n(i,o,g,"\u226e","\\nless",true);n(i,o,g,"\ue010","\\nleqslant");n(i,o,g,"\ue011","\\nleqq");n(i,o,g,"\u2a87","\\lneq",true);n(i,o,g,"\u2268","\\lneqq",true);n(i,o,g,"\ue00c","\\lvertneqq");n(i,o,g,"\u22e6","\\lnsim",true);n(i,o,g,"\u2a89","\\lnapprox",true);n(i,o,g,"\u2280","\\nprec",true);n(i,o,g,"\u22e0","\\npreceq",true);n(i,o,g,"\u22e8","\\precnsim",true);n(i,o,g,"\u2ab9","\\precnapprox",true);n(i,o,g,"\u2241","\\nsim",true);n(i,o,g,"\ue006","\\nshortmid");n(i,o,g,"\u2224","\\nmid",true);n(i,o,g,"\u22ac","\\nvdash",true);n(i,o,g,"\u22ad","\\nvDash",true);n(i,o,g,"\u22ea","\\ntriangleleft");n(i,o,g,"\u22ec","\\ntrianglelefteq",true);n(i,o,g,"\u228a","\\subsetneq",true);n(i,o,g,"\ue01a","\\varsubsetneq");n(i,o,g,"\u2acb","\\subsetneqq",true);n(i,o,g,"\ue017","\\varsubsetneqq");n(i,o,g,"\u226f","\\ngtr",true);n(i,o,g,"\ue00f","\\ngeqslant");n(i,o,g,"\ue00e","\\ngeqq");n(i,o,g,"\u2a88","\\gneq",true);n(i,o,g,"\u2269","\\gneqq",true);n(i,o,g,"\ue00d","\\gvertneqq");n(i,o,g,"\u22e7","\\gnsim",true);n(i,o,g,"\u2a8a","\\gnapprox",true);n(i,o,g,"\u2281","\\nsucc",true);n(i,o,g,"\u22e1","\\nsucceq",true);n(i,o,g,"\u22e9","\\succnsim",true);n(i,o,g,"\u2aba","\\succnapprox",true);n(i,o,g,"\u2246","\\ncong",true);n(i,o,g,"\ue007","\\nshortparallel");n(i,o,g,"\u2226","\\nparallel",true);n(i,o,g,"\u22af","\\nVDash",true);n(i,o,g,"\u22eb","\\ntriangleright");n(i,o,g,"\u22ed","\\ntrianglerighteq",true);n(i,o,g,"\ue018","\\nsupseteqq");n(i,o,g,"\u228b","\\supsetneq",true);n(i,o,g,"\ue01b","\\varsupsetneq");n(i,o,g,"\u2acc","\\supsetneqq",true);n(i,o,g,"\ue019","\\varsupsetneqq");n(i,o,g,"\u22ae","\\nVdash",true);n(i,o,g,"\u2ab5","\\precneqq",true);n(i,o,g,"\u2ab6","\\succneqq",true);n(i,o,g,"\ue016","\\nsubseteqq");n(i,o,f,"\u22b4","\\unlhd");n(i,o,f,"\u22b5","\\unrhd");n(i,o,g,"\u219a","\\nleftarrow",true);n(i,o,g,"\u219b","\\nrightarrow",true);n(i,o,g,"\u21cd","\\nLeftarrow",true);n(i,o,g,"\u21cf","\\nRightarrow",true);n(i,o,g,"\u21ae","\\nleftrightarrow",true);n(i,o,g,"\u21ce","\\nLeftrightarrow",true);n(i,o,g,"\u25b3","\\vartriangle");n(i,o,y,"\u210f","\\hslash");n(i,o,y,"\u25bd","\\triangledown");n(i,o,y,"\u25ca","\\lozenge");n(i,o,y,"\u24c8","\\circledS");n(i,o,y,"\xae","\\circledR");n(l,o,y,"\xae","\\circledR");n(i,o,y,"\u2221","\\measuredangle",true);n(i,o,y,"\u2204","\\nexists");n(i,o,y,"\u2127","\\mho");n(i,o,y,"\u2132","\\Finv",true);n(i,o,y,"\u2141","\\Game",true);n(i,o,y,"k","\\Bbbk");n(i,o,y,"\u2035","\\backprime");n(i,o,y,"\u25b2","\\blacktriangle");n(i,o,y,"\u25bc","\\blacktriangledown");n(i,o,y,"\u25a0","\\blacksquare");n(i,o,y,"\u29eb","\\blacklozenge");n(i,o,y,"\u2605","\\bigstar");n(i,o,y,"\u2222","\\sphericalangle",true);n(i,o,y,"\u2201","\\complement",true);n(i,o,y,"\xf0","\\eth",true);n(i,o,y,"\u2571","\\diagup");n(i,o,y,"\u2572","\\diagdown");n(i,o,y,"\u25a1","\\square");n(i,o,y,"\u25a1","\\Box");n(i,o,y,"\u25ca","\\Diamond");n(i,o,y,"\xa5","\\yen",true);n(i,o,y,"\u2713","\\checkmark",true);n(l,o,y,"\u2713","\\checkmark");n(i,o,y,"\u2136","\\beth",true);n(i,o,y,"\u2138","\\daleth",true);n(i,o,y,"\u2137","\\gimel",true);n(i,o,y,"\u03dd","\\digamma");n(i,o,y,"\u03f0","\\varkappa");n(i,o,p,"\u250c","\\ulcorner");n(i,o,d,"\u2510","\\urcorner");n(i,o,p,"\u2514","\\llcorner");n(i,o,d,"\u2518","\\lrcorner");n(i,o,g,"\u2266","\\leqq",true);n(i,o,g,"\u2a7d","\\leqslant");n(i,o,g,"\u2a95","\\eqslantless",true);n(i,o,g,"\u2272","\\lesssim");n(i,o,g,"\u2a85","\\lessapprox");n(i,o,g,"\u224a","\\approxeq",true);n(i,o,f,"\u22d6","\\lessdot");n(i,o,g,"\u22d8","\\lll");n(i,o,g,"\u2276","\\lessgtr");n(i,o,g,"\u22da","\\lesseqgtr");n(i,o,g,"\u2a8b","\\lesseqqgtr");n(i,o,g,"\u2251","\\doteqdot");n(i,o,g,"\u2253","\\risingdotseq",true);n(i,o,g,"\u2252","\\fallingdotseq",true);n(i,o,g,"\u223d","\\backsim",true);n(i,o,g,"\u22cd","\\backsimeq",true);n(i,o,g,"\u2ac5","\\subseteqq",true);n(i,o,g,"\u22d0","\\Subset",true);n(i,o,g,"\u228f","\\sqsubset",true);n(i,o,g,"\u227c","\\preccurlyeq",true);n(i,o,g,"\u22de","\\curlyeqprec",true);n(i,o,g,"\u227e","\\precsim",true);n(i,o,g,"\u2ab7","\\precapprox",true);n(i,o,g,"\u22b2","\\vartriangleleft");n(i,o,g,"\u22b4","\\trianglelefteq");n(i,o,g,"\u22a8","\\vDash");n(i,o,g,"\u22aa","\\Vvdash",true);n(i,o,g,"\u2323","\\smallsmile");n(i,o,g,"\u2322","\\smallfrown");n(i,o,g,"\u224f","\\bumpeq",true);
n(i,o,g,"\u224e","\\Bumpeq",true);n(i,o,g,"\u2267","\\geqq",true);n(i,o,g,"\u2a7e","\\geqslant",true);n(i,o,g,"\u2a96","\\eqslantgtr",true);n(i,o,g,"\u2273","\\gtrsim",true);n(i,o,g,"\u2a86","\\gtrapprox",true);n(i,o,f,"\u22d7","\\gtrdot");n(i,o,g,"\u22d9","\\ggg",true);n(i,o,g,"\u2277","\\gtrless",true);n(i,o,g,"\u22db","\\gtreqless",true);n(i,o,g,"\u2a8c","\\gtreqqless",true);n(i,o,g,"\u2256","\\eqcirc",true);n(i,o,g,"\u2257","\\circeq",true);n(i,o,g,"\u225c","\\triangleq",true);n(i,o,g,"\u223c","\\thicksim");n(i,o,g,"\u2248","\\thickapprox");n(i,o,g,"\u2ac6","\\supseteqq",true);n(i,o,g,"\u22d1","\\Supset",true);n(i,o,g,"\u2290","\\sqsupset",true);n(i,o,g,"\u227d","\\succcurlyeq",true);n(i,o,g,"\u22df","\\curlyeqsucc",true);n(i,o,g,"\u227f","\\succsim",true);n(i,o,g,"\u2ab8","\\succapprox",true);n(i,o,g,"\u22b3","\\vartriangleright");n(i,o,g,"\u22b5","\\trianglerighteq");n(i,o,g,"\u22a9","\\Vdash",true);n(i,o,g,"\u2223","\\shortmid");n(i,o,g,"\u2225","\\shortparallel");n(i,o,g,"\u226c","\\between",true);n(i,o,g,"\u22d4","\\pitchfork",true);n(i,o,g,"\u221d","\\varpropto");n(i,o,g,"\u25c0","\\blacktriangleleft");n(i,o,g,"\u2234","\\therefore",true);n(i,o,g,"\u220d","\\backepsilon");n(i,o,g,"\u25b6","\\blacktriangleright");n(i,o,g,"\u2235","\\because",true);n(i,o,g,"\u22d8","\\llless");n(i,o,g,"\u22d9","\\gggtr");n(i,o,f,"\u22b2","\\lhd");n(i,o,f,"\u22b3","\\rhd");n(i,o,g,"\u2242","\\eqsim",true);n(i,u,g,"\u22c8","\\Join");n(i,o,g,"\u2251","\\Doteq",true);n(i,o,f,"\u2214","\\dotplus",true);n(i,o,f,"\u2216","\\smallsetminus");n(i,o,f,"\u22d2","\\Cap",true);n(i,o,f,"\u22d3","\\Cup",true);n(i,o,f,"\u2a5e","\\doublebarwedge",true);n(i,o,f,"\u229f","\\boxminus",true);n(i,o,f,"\u229e","\\boxplus",true);n(i,o,f,"\u22c7","\\divideontimes",true);n(i,o,f,"\u22c9","\\ltimes",true);n(i,o,f,"\u22ca","\\rtimes",true);n(i,o,f,"\u22cb","\\leftthreetimes",true);n(i,o,f,"\u22cc","\\rightthreetimes",true);n(i,o,f,"\u22cf","\\curlywedge",true);n(i,o,f,"\u22ce","\\curlyvee",true);n(i,o,f,"\u229d","\\circleddash",true);n(i,o,f,"\u229b","\\circledast",true);n(i,o,f,"\u22c5","\\centerdot");n(i,o,f,"\u22ba","\\intercal",true);n(i,o,f,"\u22d2","\\doublecap");n(i,o,f,"\u22d3","\\doublecup");n(i,o,f,"\u22a0","\\boxtimes",true);n(i,o,g,"\u21e2","\\dashrightarrow",true);n(i,o,g,"\u21e0","\\dashleftarrow",true);n(i,o,g,"\u21c7","\\leftleftarrows",true);n(i,o,g,"\u21c6","\\leftrightarrows",true);n(i,o,g,"\u21da","\\Lleftarrow",true);n(i,o,g,"\u219e","\\twoheadleftarrow",true);n(i,o,g,"\u21a2","\\leftarrowtail",true);n(i,o,g,"\u21ab","\\looparrowleft",true);n(i,o,g,"\u21cb","\\leftrightharpoons",true);n(i,o,g,"\u21b6","\\curvearrowleft",true);n(i,o,g,"\u21ba","\\circlearrowleft",true);n(i,o,g,"\u21b0","\\Lsh",true);n(i,o,g,"\u21c8","\\upuparrows",true);n(i,o,g,"\u21bf","\\upharpoonleft",true);n(i,o,g,"\u21c3","\\downharpoonleft",true);n(i,o,g,"\u22b8","\\multimap",true);n(i,o,g,"\u21ad","\\leftrightsquigarrow",true);n(i,o,g,"\u21c9","\\rightrightarrows",true);n(i,o,g,"\u21c4","\\rightleftarrows",true);n(i,o,g,"\u21a0","\\twoheadrightarrow",true);n(i,o,g,"\u21a3","\\rightarrowtail",true);n(i,o,g,"\u21ac","\\looparrowright",true);n(i,o,g,"\u21b7","\\curvearrowright",true);n(i,o,g,"\u21bb","\\circlearrowright",true);n(i,o,g,"\u21b1","\\Rsh",true);n(i,o,g,"\u21ca","\\downdownarrows",true);n(i,o,g,"\u21be","\\upharpoonright",true);n(i,o,g,"\u21c2","\\downharpoonright",true);n(i,o,g,"\u21dd","\\rightsquigarrow",true);n(i,o,g,"\u21dd","\\leadsto");n(i,o,g,"\u21db","\\Rrightarrow",true);n(i,o,g,"\u21be","\\restriction");n(i,u,y,"\u2018","`");n(i,u,y,"$","\\$");n(l,u,y,"$","\\$");n(l,u,y,"$","\\textdollar");n(i,u,y,"%","\\%");n(l,u,y,"%","\\%");n(i,u,y,"_","\\_");n(l,u,y,"_","\\_");n(l,u,y,"_","\\textunderscore");n(i,u,y,"\u2220","\\angle",true);n(i,u,y,"\u221e","\\infty",true);n(i,u,y,"\u2032","\\prime");n(i,u,y,"\u25b3","\\triangle");n(i,u,y,"\u0393","\\Gamma",true);n(i,u,y,"\u0394","\\Delta",true);n(i,u,y,"\u0398","\\Theta",true);n(i,u,y,"\u039b","\\Lambda",true);n(i,u,y,"\u039e","\\Xi",true);n(i,u,y,"\u03a0","\\Pi",true);n(i,u,y,"\u03a3","\\Sigma",true);n(i,u,y,"\u03a5","\\Upsilon",true);n(i,u,y,"\u03a6","\\Phi",true);n(i,u,y,"\u03a8","\\Psi",true);n(i,u,y,"\u03a9","\\Omega",true);n(i,u,y,"\xac","\\neg");n(i,u,y,"\xac","\\lnot");n(i,u,y,"\u22a4","\\top");n(i,u,y,"\u22a5","\\bot");n(i,u,y,"\u2205","\\emptyset");n(i,o,y,"\u2205","\\varnothing");n(i,u,h,"\u03b1","\\alpha",true);n(i,u,h,"\u03b2","\\beta",true);n(i,u,h,"\u03b3","\\gamma",true);n(i,u,h,"\u03b4","\\delta",true);n(i,u,h,"\u03f5","\\epsilon",true);n(i,u,h,"\u03b6","\\zeta",true);n(i,u,h,"\u03b7","\\eta",true);n(i,u,h,"\u03b8","\\theta",true);n(i,u,h,"\u03b9","\\iota",true);n(i,u,h,"\u03ba","\\kappa",true);n(i,u,h,"\u03bb","\\lambda",true);n(i,u,h,"\u03bc","\\mu",true);n(i,u,h,"\u03bd","\\nu",true);n(i,u,h,"\u03be","\\xi",true);n(i,u,h,"\u03bf","\\omicron",true);n(i,u,h,"\u03c0","\\pi",true);n(i,u,h,"\u03c1","\\rho",true);n(i,u,h,"\u03c3","\\sigma",true);n(i,u,h,"\u03c4","\\tau",true);n(i,u,h,"\u03c5","\\upsilon",true);n(i,u,h,"\u03d5","\\phi",true);n(i,u,h,"\u03c7","\\chi",true);n(i,u,h,"\u03c8","\\psi",true);n(i,u,h,"\u03c9","\\omega",true);n(i,u,h,"\u03b5","\\varepsilon",true);n(i,u,h,"\u03d1","\\vartheta",true);n(i,u,h,"\u03d6","\\varpi",true);n(i,u,h,"\u03f1","\\varrho",true);n(i,u,h,"\u03c2","\\varsigma",true);n(i,u,h,"\u03c6","\\varphi",true);n(i,u,f,"\u2217","*");n(i,u,f,"+","+");n(i,u,f,"\u2212","-");n(i,u,f,"\u22c5","\\cdot",true);n(i,u,f,"\u2218","\\circ");n(i,u,f,"\xf7","\\div",true);n(i,u,f,"\xb1","\\pm",true);n(i,u,f,"\xd7","\\times",true);n(i,u,f,"\u2229","\\cap",true);n(i,u,f,"\u222a","\\cup",true);n(i,u,f,"\u2216","\\setminus");n(i,u,f,"\u2227","\\land");n(i,u,f,"\u2228","\\lor");n(i,u,f,"\u2227","\\wedge",true);n(i,u,f,"\u2228","\\vee",true);n(i,u,y,"\u221a","\\surd");n(i,u,p,"(","(");n(i,u,p,"[","[");n(i,u,p,"\u27e8","\\langle");n(i,u,p,"\u2223","\\lvert");n(i,u,p,"\u2225","\\lVert");n(i,u,d,")",")");n(i,u,d,"]","]");n(i,u,d,"?","?");n(i,u,d,"!","!");n(i,u,d,"\u27e9","\\rangle");n(i,u,d,"\u2223","\\rvert");n(i,u,d,"\u2225","\\rVert");n(i,u,g,"=","=");n(i,u,g,"<","<");n(i,u,g,">",">");n(i,u,g,":",":");n(i,u,g,"\u2248","\\approx",true);n(i,u,g,"\u2245","\\cong",true);n(i,u,g,"\u2265","\\ge");n(i,u,g,"\u2265","\\geq",true);n(i,u,g,"\u2190","\\gets");n(i,u,g,">","\\gt");n(i,u,g,"\u2208","\\in",true);n(i,u,g,"\u2209","\\notin",true);n(i,u,g,"\u0338","\\not");n(i,u,g,"\u2282","\\subset",true);n(i,u,g,"\u2283","\\supset",true);n(i,u,g,"\u2286","\\subseteq",true);n(i,u,g,"\u2287","\\supseteq",true);n(i,o,g,"\u2288","\\nsubseteq",true);n(i,o,g,"\u2289","\\nsupseteq",true);n(i,u,g,"\u22a8","\\models");n(i,u,g,"\u2190","\\leftarrow",true);n(i,u,g,"\u2264","\\le");n(i,u,g,"\u2264","\\leq",true);n(i,u,g,"<","\\lt");n(i,u,g,"\u2260","\\ne",true);n(i,u,g,"\u2260","\\neq");n(i,u,g,"\u2192","\\rightarrow",true);n(i,u,g,"\u2192","\\to");n(i,o,g,"\u2271","\\ngeq",true);n(i,o,g,"\u2270","\\nleq",true);n(i,u,b,null,"\\!");n(i,u,b,"\xa0","\\ ");n(i,u,b,"\xa0","~");n(i,u,b,null,"\\,");n(i,u,b,null,"\\:");n(i,u,b,null,"\\;");n(i,u,b,null,"\\enspace");n(i,u,b,null,"\\qquad");n(i,u,b,null,"\\quad");n(i,u,b,"\xa0","\\space");n(i,u,m,",",",");n(i,u,m,";",";");n(i,u,m,":","\\colon");n(i,o,f,"\u22bc","\\barwedge",true);n(i,o,f,"\u22bb","\\veebar",true);n(i,u,f,"\u2299","\\odot",true);n(i,u,f,"\u2295","\\oplus",true);n(i,u,f,"\u2297","\\otimes",true);n(i,u,y,"\u2202","\\partial",true);n(i,u,f,"\u2298","\\oslash",true);n(i,o,f,"\u229a","\\circledcirc",true);n(i,o,f,"\u22a1","\\boxdot",true);n(i,u,f,"\u25b3","\\bigtriangleup");n(i,u,f,"\u25bd","\\bigtriangledown");n(i,u,f,"\u2020","\\dagger");n(i,u,f,"\u22c4","\\diamond");n(i,u,f,"\u22c6","\\star");n(i,u,f,"\u25c3","\\triangleleft");n(i,u,f,"\u25b9","\\triangleright");n(i,u,p,"{","\\{");n(l,u,y,"{","\\{");n(l,u,y,"{","\\textbraceleft");n(i,u,d,"}","\\}");n(l,u,y,"}","\\}");n(l,u,y,"}","\\textbraceright");n(i,u,p,"{","\\lbrace");n(i,u,d,"}","\\rbrace");n(i,u,p,"[","\\lbrack");n(i,u,d,"]","\\rbrack");n(l,u,y,"<","\\textless");n(l,u,y,">","\\textgreater");n(i,u,p,"\u230a","\\lfloor");n(i,u,d,"\u230b","\\rfloor");n(i,u,p,"\u2308","\\lceil");n(i,u,d,"\u2309","\\rceil");n(i,u,y,"\\","\\backslash");n(i,u,y,"\u2223","|");n(i,u,y,"\u2223","\\vert");n(l,u,y,"|","\\textbar");n(i,u,y,"\u2225","\\|");n(i,u,y,"\u2225","\\Vert");n(l,u,y,"\u2225","\\textbardbl");n(i,u,g,"\u2191","\\uparrow",true);n(i,u,g,"\u21d1","\\Uparrow",true);n(i,u,g,"\u2193","\\downarrow",true);n(i,u,g,"\u21d3","\\Downarrow",true);n(i,u,g,"\u2195","\\updownarrow",true);n(i,u,g,"\u21d5","\\Updownarrow",true);n(i,u,v,"\u2210","\\coprod");n(i,u,v,"\u22c1","\\bigvee");n(i,u,v,"\u22c0","\\bigwedge");n(i,u,v,"\u2a04","\\biguplus");n(i,u,v,"\u22c2","\\bigcap");n(i,u,v,"\u22c3","\\bigcup");n(i,u,v,"\u222b","\\int");n(i,u,v,"\u222b","\\intop");n(i,u,v,"\u222c","\\iint");n(i,u,v,"\u222d","\\iiint");n(i,u,v,"\u220f","\\prod");n(i,u,v,"\u2211","\\sum");n(i,u,v,"\u2a02","\\bigotimes");n(i,u,v,"\u2a01","\\bigoplus");n(i,u,v,"\u2a00","\\bigodot");n(i,u,v,"\u222e","\\oint");n(i,u,v,"\u2a06","\\bigsqcup");n(i,u,v,"\u222b","\\smallint");n(l,u,c,"\u2026","\\textellipsis");n(i,u,c,"\u2026","\\mathellipsis");n(l,u,c,"\u2026","\\ldots",true);n(i,u,c,"\u2026","\\ldots",true);n(i,u,c,"\u22ef","\\@cdots",true);n(i,u,c,"\u22f1","\\ddots",true);n(i,u,y,"\u22ee","\\vdots",true);n(i,u,s,"\xb4","\\acute");n(i,u,s,"`","\\grave");n(i,u,s,"\xa8","\\ddot");n(i,u,s,"~","\\tilde");n(i,u,s,"\xaf","\\bar");n(i,u,s,"\u02d8","\\breve");n(i,u,s,"\u02c7","\\check");n(i,u,s,"^","\\hat");n(i,u,s,"\u20d7","\\vec");n(i,u,s,"\u02d9","\\dot");n(i,u,h,"\u0131","\\imath");n(i,u,h,"\u0237","\\jmath");n(l,u,s,"\u02ca","\\'");n(l,u,s,"\u02cb","\\`");n(l,u,s,"\u02c6","\\^");n(l,u,s,"\u02dc","\\~");n(l,u,s,"\u02c9","\\=");n(l,u,s,"\u02d8","\\u");n(l,u,s,"\u02d9","\\.");n(l,u,s,"\u02da","\\r");n(l,u,s,"\u02c7","\\v");n(l,u,s,"\xa8",'\\"');n(l,u,s,"\u030b","\\H");n(l,u,y,"\u2013","--");n(l,u,y,"\u2013","\\textendash");n(l,u,y,"\u2014","---");n(l,u,y,"\u2014","\\textemdash");n(l,u,y,"\u2018","`");n(l,u,y,"\u2018","\\textquoteleft");n(l,u,y,"\u2019","'");n(l,u,y,"\u2019","\\textquoteright");n(l,u,y,"\u201c","``");n(l,u,y,"\u201c","\\textquotedblleft");n(l,u,y,"\u201d","''");n(l,u,y,"\u201d","\\textquotedblright");n(i,u,y,"\xb0","\\degree");n(l,u,y,"\xb0","\\degree");n(i,u,h,"\xa3","\\pounds");n(i,u,h,"\xa3","\\mathsterling",true);n(l,u,h,"\xa3","\\pounds");n(l,u,h,"\xa3","\\textsterling");n(i,o,y,"\u2720","\\maltese");n(l,o,y,"\u2720","\\maltese");n(l,u,b,"\xa0","\\ ");n(l,u,b,"\xa0"," ");n(l,u,b,"\xa0","~");var x='0123456789/@."';for(var w=0;w<x.length;w++){var k=x.charAt(w);n(i,u,y,k,k)}var M='0123456789!@*()-=+[]<>|";:?/.,';for(var _=0;_<M.length;_++){var S=M.charAt(_);n(l,u,y,S,S)}var z="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";for(var T=0;T<z.length;T++){var C=z.charAt(T);n(i,u,h,C,C);n(l,u,y,C,C)}for(var A=192;A<=214;A++){var O=String.fromCharCode(A);n(i,u,h,O,O);n(l,u,y,O,O)}for(var N=216;N<=246;N++){var L=String.fromCharCode(N);n(i,u,h,L,L);n(l,u,y,L,L)}for(var j=248;j<=255;j++){var E=String.fromCharCode(j);n(i,u,h,E,E);n(l,u,y,E,E)}for(var q=1040;q<=1103;q++){var P=String.fromCharCode(q);n(l,u,y,P,P)}n(l,u,y,"\u2013","\u2013");n(l,u,y,"\u2014","\u2014");n(l,u,y,"\u2018","\u2018");n(l,u,y,"\u2019","\u2019");n(l,u,y,"\u201c","\u201c");n(l,u,y,"\u201d","\u201d")},{}],126:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=r.hangulRegex=/[\uAC00-\uD7AF]/;var n=r.cjkRegex=/[\u3000-\u30FF\u4E00-\u9FAF\uAC00-\uD7AF\uFF00-\uFF60]/},{}],127:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});r.calculateSize=r.validUnit=undefined;var a=e("./ParseError");var n=u(a);var i=e("./Options");var l=u(i);function u(e){return e&&e.__esModule?e:{default:e}}var o={pt:1,mm:7227/2540,cm:7227/254,in:72.27,bp:803/800,pc:12,dd:1238/1157,cc:14856/1157,nd:685/642,nc:1370/107,sp:1/65536,px:803/800};var s={ex:true,em:true,mu:true};var f=r.validUnit=function e(t){if(typeof t!=="string"){t=t.unit}return t in o||t in s||t==="ex"};var d=r.calculateSize=function e(t,r){var a=void 0;if(t.unit in o){a=o[t.unit]/r.fontMetrics().ptPerEm/r.sizeMultiplier}else if(t.unit==="mu"){a=r.fontMetrics().cssEmPerMu}else{var i=void 0;if(r.style.isTight()){i=r.havingStyle(r.style.text())}else{i=r}if(t.unit==="ex"){a=i.fontMetrics().xHeight}else if(t.unit==="em"){a=i.fontMetrics().quad}else{throw new n.default("Invalid unit: '"+t.unit+"'")}if(i!==r){a*=i.sizeMultiplier/r.sizeMultiplier}}return Math.min(t.number*a,r.maxSize)}},{"./Options":83,"./ParseError":84}],128:[function(e,t,r){"use strict";Object.defineProperty(r,"__esModule",{value:true});var a=Array.prototype.indexOf;var n=function e(t,r){if(t==null){return-1}if(a&&t.indexOf===a){return t.indexOf(r)}var n=t.length;for(var i=0;i<n;i++){if(t[i]===r){return i}}return-1};var i=function e(t,r){return n(t,r)!==-1};var l=function e(t,r){return t===undefined?r:t};var u=/([A-Z])/g;var o=function e(t){return t.replace(u,"-$1").toLowerCase()};var s={"&":"&amp;",">":"&gt;","<":"&lt;",'"':"&quot;","'":"&#x27;"};var f=/[&><"']/g;function d(e){return String(e).replace(f,function(e){return s[e]})}var c=void 0;if(typeof document!=="undefined"){var h=document.createElement("span");if("textContent"in h){c=function e(t,r){t.textContent=r}}else{c=function e(t,r){t.innerText=r}}}function v(e){c(e,"")}r.default={contains:i,deflt:l,escape:d,hyphenate:o,indexOf:n,setTextContent:c,clearNode:v}},{}]},{},[1])(1)});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],"/usr/var/server.base/node_modules/guppy-dev/lib/mousetrap/mousetrap.min.js":[function(require,module,exports){
/* mousetrap v1.6.1 craig.is/killing/mice */
(function(r,v,f){function w(a,b,g){a.addEventListener?a.addEventListener(b,g,!1):a.attachEvent("on"+b,g)}function A(a){if("keypress"==a.type){var b=String.fromCharCode(a.which);a.shiftKey||(b=b.toLowerCase());return b}return p[a.which]?p[a.which]:t[a.which]?t[a.which]:String.fromCharCode(a.which).toLowerCase()}function F(a){var b=[];a.shiftKey&&b.push("shift");a.altKey&&b.push("alt");a.ctrlKey&&b.push("ctrl");a.metaKey&&b.push("meta");return b}function x(a){return"shift"==a||"ctrl"==a||"alt"==a||
"meta"==a}function B(a,b){var g,c,d,f=[];g=a;"+"===g?g=["+"]:(g=g.replace(/\+{2}/g,"+plus"),g=g.split("+"));for(d=0;d<g.length;++d)c=g[d],C[c]&&(c=C[c]),b&&"keypress"!=b&&D[c]&&(c=D[c],f.push("shift")),x(c)&&f.push(c);g=c;d=b;if(!d){if(!n){n={};for(var q in p)95<q&&112>q||p.hasOwnProperty(q)&&(n[p[q]]=q)}d=n[g]?"keydown":"keypress"}"keypress"==d&&f.length&&(d="keydown");return{key:c,modifiers:f,action:d}}function E(a,b){return null===a||a===v?!1:a===b?!0:E(a.parentNode,b)}function c(a){function b(a){a=
a||{};var b=!1,l;for(l in n)a[l]?b=!0:n[l]=0;b||(y=!1)}function g(a,b,u,e,c,g){var l,m,k=[],f=u.type;if(!h._callbacks[a])return[];"keyup"==f&&x(a)&&(b=[a]);for(l=0;l<h._callbacks[a].length;++l)if(m=h._callbacks[a][l],(e||!m.seq||n[m.seq]==m.level)&&f==m.action){var d;(d="keypress"==f&&!u.metaKey&&!u.ctrlKey)||(d=m.modifiers,d=b.sort().join(",")===d.sort().join(","));d&&(d=e&&m.seq==e&&m.level==g,(!e&&m.combo==c||d)&&h._callbacks[a].splice(l,1),k.push(m))}return k}function f(a,b,c,e){h.stopCallback(b,
b.target||b.srcElement,c,e)||!1!==a(b,c)||(b.preventDefault?b.preventDefault():b.returnValue=!1,b.stopPropagation?b.stopPropagation():b.cancelBubble=!0)}function d(a){"number"!==typeof a.which&&(a.which=a.keyCode);var b=A(a);b&&("keyup"==a.type&&z===b?z=!1:h.handleKey(b,F(a),a))}function p(a,c,u,e){function l(c){return function(){y=c;++n[a];clearTimeout(r);r=setTimeout(b,1E3)}}function g(c){f(u,c,a);"keyup"!==e&&(z=A(c));setTimeout(b,10)}for(var d=n[a]=0;d<c.length;++d){var m=d+1===c.length?g:l(e||
B(c[d+1]).action);q(c[d],m,e,a,d)}}function q(a,b,c,e,d){h._directMap[a+":"+c]=b;a=a.replace(/\s+/g," ");var f=a.split(" ");1<f.length?p(a,f,b,c):(c=B(a,c),h._callbacks[c.key]=h._callbacks[c.key]||[],g(c.key,c.modifiers,{type:c.action},e,a,d),h._callbacks[c.key][e?"unshift":"push"]({callback:b,modifiers:c.modifiers,action:c.action,seq:e,level:d,combo:a}))}var h=this;a=a||v;if(!(h instanceof c))return new c(a);h.target=a;h._callbacks={};h._directMap={};var n={},r,z=!1,t=!1,y=!1;h._handleKey=function(a,
c,d){var e=g(a,c,d),k;c={};var h=0,l=!1;for(k=0;k<e.length;++k)e[k].seq&&(h=Math.max(h,e[k].level));for(k=0;k<e.length;++k)e[k].seq?e[k].level==h&&(l=!0,c[e[k].seq]=1,f(e[k].callback,d,e[k].combo,e[k].seq)):l||f(e[k].callback,d,e[k].combo);e="keypress"==d.type&&t;d.type!=y||x(a)||e||b(c);t=l&&"keydown"==d.type};h._bindMultiple=function(a,b,c){for(var d=0;d<a.length;++d)q(a[d],b,c)};w(a,"keypress",d);w(a,"keydown",d);w(a,"keyup",d)}if(r){var p={8:"backspace",9:"tab",13:"enter",16:"shift",17:"ctrl",
18:"alt",20:"capslock",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",45:"ins",46:"del",91:"meta",93:"meta",224:"meta"},t={106:"*",107:"+",109:"-",110:".",111:"/",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'"},D={"~":"`","!":"1","@":"2","#":"3",$:"4","%":"5","^":"6","&":"7","*":"8","(":"9",")":"0",_:"-","+":"=",":":";",'"':"'","<":",",">":".","?":"/","|":"\\"},C={option:"alt",command:"meta","return":"enter",
escape:"esc",plus:"+",mod:/Mac|iPod|iPhone|iPad/.test(navigator.platform)?"meta":"ctrl"},n;for(f=1;20>f;++f)p[111+f]="f"+f;for(f=0;9>=f;++f)p[f+96]=f.toString();c.prototype.bind=function(a,b,c){a=a instanceof Array?a:[a];this._bindMultiple.call(this,a,b,c);return this};c.prototype.unbind=function(a,b){return this.bind.call(this,a,function(){},b)};c.prototype.trigger=function(a,b){if(this._directMap[a+":"+b])this._directMap[a+":"+b]({},a);return this};c.prototype.reset=function(){this._callbacks={};
this._directMap={};return this};c.prototype.stopCallback=function(a,b){return-1<(" "+b.className+" ").indexOf(" mousetrap ")||E(b,this.target)?!1:"INPUT"==b.tagName||"SELECT"==b.tagName||"TEXTAREA"==b.tagName||b.isContentEditable};c.prototype.handleKey=function(){return this._handleKey.apply(this,arguments)};c.addKeycodes=function(a){for(var b in a)a.hasOwnProperty(b)&&(p[b]=a[b]);n=null};c.init=function(){var a=c(v),b;for(b in a)"_"!==b.charAt(0)&&(c[b]=function(b){return function(){return a[b].apply(a,
arguments)}}(b))};c.init();r.Mousetrap=c;"undefined"!==typeof module&&module.exports&&(module.exports=c);"function"===typeof define&&define.amd&&define(function(){return c})}})("undefined"!==typeof window?window:null,"undefined"!==typeof window?document:null);

},{}],"/usr/var/server.base/node_modules/guppy-dev/src/ast.js":[function(require,module,exports){
var AST = {};

AST.to_eqlist = function(ast){
    var comparators = ["=","!=","<=",">=","<",">"];
    if(ast[1].length == 0 || comparators.indexOf(ast[1][0][0]) < 0) return [ast];
    return AST.to_eqlist(ast[1][0]).concat([[ast[0],[ast[1][0][1][1],ast[1][1]]]]);
}

AST.to_text = function(ast){
    var functions = {};
    functions["bracket"] = function(args){return "("+args[0]+")";};
    functions["="] = function(args){return args[0]+" = "+args[1];};
    functions["!="] = function(args){return args[0]+" != "+args[1];};
    functions["<="] = function(args){return args[0]+" <= "+args[1];};
    functions[">="] = function(args){return args[0]+" >= "+args[1];};
    functions["<"] = function(args){return args[0]+" < "+args[1];};
    functions[">"] = function(args){return args[0]+" > "+args[1];};
    functions["*"] = function(args){return "("+args[0]+" * "+args[1]+")";};
    functions["+"] = function(args){return "("+args[0]+" + "+args[1]+")";};
    functions["/"] = function(args){return "("+args[0]+" / "+args[1]+")";};
    functions["fraction"] = function(args){return "("+args[0]+" / "+args[1]+")";};
    functions["-"] = function(args){return args.length == 1 ? "-"+args[0] : "("+args[0]+" - "+args[1]+")";};
    functions["val"] = function(args){return args[0]+"";};
    functions["var"] = function(args){return args[0];};
    functions["subscript"] = function(args){return "("+args[0]+"_"+args[1]+")";};
    functions["exponential"] = function(args){return "("+args[0]+"^"+args[1]+")";};
    functions["factorial"] = function(args){return "("+args[0]+")!";};
    functions["_default"] = function(name, args){return name + "(" + args.join(",") + ")";};
    return AST.eval(ast, functions);
}

AST.to_xml = function(ast, symbols, symbol_to_node){
    var prepend_str = function(doc, str){
        doc.documentElement.firstChild.textContent = str + doc.documentElement.firstChild.textContent;
    }
    var append_str = function(doc, str){
        doc.documentElement.lastChild.textContent += str;
    }
    var append_doc = function(doc, doc2){
        var n = doc.documentElement.lastChild;
        var nn = doc2.documentElement.firstChild
        n.firstChild.textContent += nn.firstChild.textContent;
        for(nn = nn.nextSibling; nn; nn = nn.nextSibling){
            n.parentNode.insertBefore(nn.cloneNode(true),null); 
        }
    }
    var ensure_text_nodes = function(base){
        var l = base.getElementsByTagName("e");
        for(var i = 0; i < l.length; i++){
            if(!(l[i].firstChild)) l[i].appendChild(base.createTextNode(""));
        }
    }
    var get_symbol = function(name, symbols){
        for(var s in symbols){
            if(symbols[s].attrs.type == name) return symbols[s];
        }
    }
    var get_content_array = function(args){
        var content = {};
        for(var i = 0; i < args.length; i++){
            content[i] = [];
            if(args[i].documentElement.nodeName == "l") content[i].push(args[i].documentElement);
            else for(var nn = args[i].documentElement.firstChild; nn; nn = nn.nextSibling) content[i].push(nn);
        }
        return content;
    }
    var binop_low = function(args, op, parent){
        var d = args[0].cloneNode(true);
        append_str(d, op);
        append_doc(d, args[1].cloneNode(true));
        if(parent && (parent[0] == "*" || (parent[0] == "-" && parent[1].length == 1)))
            return make_sym("bracket", [d]);
        else
            return d;
    }
    var binop_high = function(args, op){
        var d = args[0].cloneNode(true);
        append_doc(d, make_sym(op,[]));
        append_doc(d, args[1].cloneNode(true));
        return d;
    }
    var make_sym = function(name, args){
        var sym = get_symbol(name, symbols);
        if(!sym) throw "Unrecognised symbol: "+name;
        var base = (new window.DOMParser()).parseFromString("<c><e></e><e></e></c>", "text/xml");
        ensure_text_nodes(base);
        var e0 = base.documentElement.firstChild;
        var content = get_content_array(args);
        var f = symbol_to_node(sym, content, base)['f'];
        e0.parentNode.insertBefore(f,e0.nextSibling);
        ensure_text_nodes(base);
        return base;
    }
    var functions = {};

    var ops = ["*","<",">","=","<=",">=","!="];
    for(var i = 0; i < ops.length; i++){
        functions[ops[i]] = function(o){ return function(args){ return binop_high(args, o); }}(ops[i]);
    }
    functions["/"] = function(args){
        return make_sym("fraction",args);
    };
    functions["+"] = function(args, parent){ return binop_low(args, "+", parent); };
    functions["-"] = function(args, parent) {
        if(args.length == 1) {
            var d = args[0].cloneNode(true);
            prepend_str(d, "-");
            return d;
        }
        else {
            return binop_low(args, "-", parent);
        }
    }
    functions["val"] = function(args){ return (new window.DOMParser()).parseFromString("<c><e>" + args[0] + "</e></c>", "text/xml");};
    functions["var"] = function(args){
        if(args[0].length == 1) return (new window.DOMParser()).parseFromString("<c><e>" + args[0] + "</e></c>", "text/xml");
        else return make_sym(args[0], {});
    };
    functions["list"] = function(args){
        var base = (new window.DOMParser()).parseFromString("<l></l>", "text/xml");
        for(var i = 0; i < args.length; i++){
            base.documentElement.appendChild(args[i].documentElement.cloneNode(true));
        }
        base.documentElement.setAttribute("s",String(args.length))
        return base;
    };
    // var comparators = {"<":"less",">":"greater","=":"eq","!=":"neq",">=":"geq","<=":"leq"};
    // for(var c in comparators){
    //     functions[c] = function(args){
    //         return make_sym(comparators[c], args);
    //     }
    // }
    functions["_default"] = function(name, args){
        return make_sym(name, args);
    }
    var ans = AST.eval(ast, functions);
    var new_base = (new window.DOMParser()).parseFromString("<m></m>", "text/xml");
    for(var nn = ans.documentElement.firstChild; nn; nn = nn.nextSibling){
        new_base.documentElement.insertBefore(nn.cloneNode(true),null);
    }
    return new_base;

}

AST.get_nodes = function(ast, name){
    if(ast.length < 2) return [];
    var ans = [];
    if(ast[0] == name) ans.push(ast[1]);
    if(ast[0] == "var" || ast[0] == "val") return ans;
    for(var i = 0; i < ast[1].length; i++) ans = ans.concat(AST.get_nodes(ast[1][i], name));
    return ans;
}

AST.get_vars = function(ast){
    var vars = {};
    var ans = [];
    var l = AST.get_nodes(ast, "var");
    for(var i = 0; i < l.length; i++) vars[l[i][0]] = true;
    for(var x in vars) ans.push(x);
    return ans;
}

AST.to_function = function(ast, functions){
    functions = functions || {}
    var defaults = {}
    defaults["*"] = function(args){return function(vars){return args[0](vars)*args[1](vars)};};
    defaults["+"] = function(args){return function(vars){return args[0](vars)+args[1](vars)};};
    defaults["fraction"] = function(args){return function(vars){return args[0](vars)/args[1](vars)};};
    defaults["/"] = function(args){return function(vars){return args[0](vars)/args[1](vars)};};
    defaults["-"] = function(args){return args.length == 1 ? function(vars){return -args[0](vars)} : function(vars){return args[0](vars)-args[1](vars)};};
    defaults["val"] = function(args){return function(){ return args[0]; };};
    defaults["var"] = function(args){return function(vars){ if(args[0] == "pi") return Math.PI; if(args[0] == "e") return Math.E; return vars[args[0]]; };};
    defaults["exponential"] = function(args){return function(vars){return Math.pow(args[0](vars),args[1](vars))};};
    defaults["squareroot"] = function(args){return function(vars){return Math.sqrt(args[0](vars))};};
    defaults["absolutevalue"] = function(args){return function(vars){return Math.abs(args[0](vars))};};
    defaults["sin"] = function(args){return function(vars){return Math.sin(args[0](vars))};};
    defaults["cos"] = function(args){return function(vars){return Math.cos(args[0](vars))};};
    defaults["tan"] = function(args){return function(vars){return Math.tan(args[0](vars))};};
    defaults["log"] = function(args){return function(vars){return Math.log(args[0](vars))};};
    for(var n in defaults) if(!functions[n]) functions[n] = defaults[n];
    return {"function":AST.eval(ast, functions),"vars":AST.get_vars(ast)};
}

AST.eval = function(ast, functions, parent){
    ans = null;
    if(!functions["_default"]) functions["_default"] = function(name, args){ throw Error("Function not implemented: " + name + "(" + args + ")");}
    
    var args = []
    for(var i = 0; i < ast[1].length; i++){
        if(Object.prototype.toString.call(ast[1][i]) === '[object Array]'){
            args.push(AST.eval(ast[1][i], functions, ast));
        }
        else{
            args.push(ast[1][i]);
        }
    }
    var ans = null;
    if(functions[ast[0]]) ans = functions[ast[0]](args, parent);
    else if(functions["_default"]) ans = functions["_default"](ast[0], args, parent);
    
    return ans
}

module.exports = AST;

},{}],"/usr/var/server.base/node_modules/guppy-dev/src/doc.js":[function(require,module,exports){
var katex = require('../lib/katex/katex-modified.min.js');
var AST = require('./ast.js');
var Symbols = require('./symbols.js');
var Utils = require('./utils.js');
var Parsers = require('./parser.js');
var Version = require('./version.js');

/**
   @class
   @classdesc A class representing a Guppy document.  To access this
   class, use `Guppy.Doc`.  To get the document for a particular guppy
   instance, say called `"guppy1"`, do `Guppy("guppy1").doc()`.
   @param {string} [doc=<m><e></e></m>] - An XML string representing the document
   @constructor 
 */
var Doc = function(doc, type){
    type = type || "xml";
    if(type == "xml") this.set_content(doc || "<m><e></e></m>");
    else if(type == "latex") this.import_latex(doc);
    else if(type == "text") this.import_text(doc);
    else if(type == "ast") this.import_ast(doc);
    if(this.root().hasAttribute("v") && this.root().getAttribute("v") != Version.DOC_VERSION)
	throw Version.DOC_ERROR;
    else
	this.root().setAttribute("v",Version.DOC_VERSION);
}

Doc.prototype.is_small = function(nn){
    var n = nn.parentNode;
    while(n != null && n.nodeName != 'm'){
        if(n.getAttribute("small") == "yes") return true;
        n = n.parentNode
        while(n != null && n.nodeName != 'c') n = n.parentNode;
    }
    return false;
}

Doc.prototype.ensure_text_nodes = function(){
    var l = this.base.getElementsByTagName("e");
    for(var i = 0; i < l.length; i++){
        if(!(l[i].firstChild)) l[i].appendChild(this.base.createTextNode(""));
    }
}

Doc.prototype.is_blank = function(){
    if(this.base.getElementsByTagName("f").length > 0) return false;
    var l = this.base.getElementsByTagName("e");
    if(l.length == 1 && (!(l[0].firstChild) || l[0].firstChild.textContent == "")) return true;
    return false;
}


/** 
    Get the document as a DOM object
    @memberof Doc
    @returns {Element}
*/
Doc.prototype.root = function(){
    return this.base.documentElement;
}

/** 
    Get the content of the document as a string
    @memberof Doc
    @param {string} t - The rendering method to use ("latex", "text", "ast" (for syntax tree), or "xml" (for internal XML representation))
    @returns {string}
*/
Doc.prototype.get_content = function(t,r){
    if(t == "xml") return (new XMLSerializer()).serializeToString(this.base);
    else if(t == "ast") return JSON.stringify(this.syntax_tree());
    else if(t == "text") return AST.to_text(this.syntax_tree());
    else if(t == "function") return AST.to_function(this.syntax_tree());
    else if(t == "eqns") return JSON.stringify(AST.to_eqlist(this.syntax_tree()));
    else return this.manual_render(t,this.root(),r);
}

/** 
    Evaluate the document using user-supplied functions to interpret symbols
    @memberof Doc
    @param {Object} evaluators - A dictionary where each key is a node
    type in the AST ("var", "val", "sin", "cos", etc.) and the
    corresponding value is a function that takes a list of argument
    (the results of evaluating that AST node's arguments) as well as,
    optionally, a second argument for the parent AST node to the one
    currently being evaluated.
    @returns {Object}
*/
Doc.prototype.evaluate = function(evaluators){
    return AST.eval(this.syntax_tree(), evaluators);
}

Doc.prototype.import_text = function(text, syms, s2n){
    var ast = Parsers.TextParser.tokenise_and_parse(text);
    this.import_ast(ast, syms, s2n);
}

Doc.prototype.import_latex = function(text, syms, s2n){
    var ast = Parsers.LaTeXParser.tokenise_and_parse(text);
    this.import_ast(ast, syms, s2n);
}

Doc.prototype.import_ast = function(ast, syms, s2n){
    syms = syms || Symbols.symbols;
    s2n = s2n || Symbols.symbol_to_node;
    var doc = AST.to_xml(ast, syms, s2n);
    this.base = doc;
    this.ensure_text_nodes();
}

Doc.prototype.syntax_tree = function(n){
    n = n || this.root()
    if(n.nodeName == "f"){
        var ans = {"args":[], "kwargs":{}};
        ans['value'] = n.getAttribute("type");
        ans['type'] = "function";
        if(n.hasAttribute("ast_value")) ans['value'] = n.getAttribute("ast_value");
        if(n.hasAttribute("ast_type")) ans['type'] = n.getAttribute("ast_type");
        else if(Utils.is_char(n)) ans['type'] = "name";
        
        var iterator = this.xpath_list("./*[name()='c' or name()='l']", n)
        for(var nn = iterator.iterateNext(); nn != null; nn = iterator.iterateNext()){
            //if(nn.hasAttribute("name")) ans.kwargs[nn.getAttribute("name")] = this.syntax_tree(nn)
            //else ans.args.push(this.syntax_tree(nn))
            ans.args.push(this.syntax_tree(nn))
        }
    }
    else if(n.nodeName == "l"){
        ans = [];
        for(nn = n.firstChild; nn != null; nn = nn.nextSibling){
        ans.push(this.syntax_tree(nn));
        }
        ans = ["list",ans];
    }
    else if(n.nodeName == "c" || n.nodeName == "m"){
        if(n.hasAttribute("mode") && n.getAttribute("mode") == "text"){
            ans = n.firstChild.firstChild.textContent;
        }
        else{
            var tokens = []
            for(nn = n.firstChild; nn != null; nn = nn.nextSibling){
                if(nn.nodeName == "e"){
                    tokens = tokens.concat(Parsers.EParser.tokenise(nn.firstChild.textContent));
                }
                else if(nn.nodeName == "f"){
                    tokens.push(this.syntax_tree(nn));
                }
            }
            ans = Parsers.EParser.parse(tokens);
        }
    }
    return ans;
}

Doc.prototype.xpath_node = function(xpath, node){
    node = node || this.root()
    return this.base.evaluate(xpath, node, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}

Doc.prototype.xpath_list = function(xpath, node){
    node = node || this.root()
    return this.base.evaluate(xpath, node, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null);
}

/** 
    Get the names of symbols used in this document
    @memberof Doc
    @param {string[]} [groups] - A list of groups you want strings for
    @returns {string[]}
*/
Doc.prototype.get_symbols = function(groups){
    var types = {};
    var ans = [];
    var groups_selector = "//f";
    if(groups) groups_selector += "[" + groups.map(function(){ return ""; }).join(" or ") + "]";
    var iterator = this.xpath_list(groups_selector)
    for(var nn = iterator.iterateNext(); nn != null; nn = iterator.iterateNext())
        types[nn.getAttribute("type")] = true;
    for(var t in types)
        ans.push(t);
    return ans;
}

/** 
    Set the content of the document
    @memberof Doc
    @param {string} xml_data - An XML string representing the content of the document
*/
Doc.prototype.set_content = function(xml_data){
    this.base = (new window.DOMParser()).parseFromString(xml_data, "text/xml");
    this.ensure_text_nodes();
}

Doc.prototype.auto_bracket = function(n){
    var e0 = n.firstChild;
    var e1 = n.lastChild;
    if(n.childElementCount == 3 && e0.firstChild.textContent == "" && e1.firstChild.textContent == ""){ // single f child, all e children empty
        var f = e0.nextSibling;
	var cs = 0;
	var c = null;
	// Count immediate children of f that are c nodes in cs and store the last one in c
	for(var nn = f.firstChild; nn; nn = nn.nextSibling) if(nn.tagName == "c"){ c = nn; cs++; }
        if(cs == 1 && c.getAttribute("is_bracket") == "yes") return false; // if the f child is a bracket, don't bracket
        if(Utils.is_char(f) && e0.getAttribute("current") != "yes" && e0.getAttribute("temp") != "yes" && e1.getAttribute("current") != "yes" && e1.getAttribute("temp") != "yes") return false; // if the f child is a character and not current or temp cursor location, don't bracket
    }
    else if(n.childElementCount == 1){ // Single e child
        var s = e0.firstChild.textContent;
        if(s.length != 1 && Number(s)+"" != s) return true; // If content is neither a single character nor a number, bracket it
        if(e0.getAttribute("current") == "yes" || e0.getAttribute("temp") == "yes") return true; // If content has the cursor or temp cursor, bracket it
        return false;
    }
    return true;
}

Doc.prototype.manual_render = function(t,n,r){
    var ans = "";
    var nn = null;
    var i = null;
    if(n.nodeName == "e"){
        if(t == "latex" && r){
            ans = n.getAttribute("render");
        }
        else{
            ans = n.firstChild.textContent;
        }
    }
    else if(n.nodeName == "f"){
        var real_type = (t == "latex" && this.is_small(n)) ? "small_latex" : t;
        nn = this.xpath_node("./b[@p='"+real_type+"']", n) || this.xpath_node("./b[@p='"+t+"']", n);
        if(nn) ans = this.manual_render(t,nn,r);
    }
    else if(n.nodeName == "b"){
        var cs = []
        i = 1;
        var par = n.parentNode;
        for(nn = par.firstChild; nn != null; nn = nn.nextSibling)
            if(nn.nodeName == "c" || nn.nodeName == "l") cs[i++] = this.manual_render(t,nn,r);
        for(nn = n.firstChild; nn != null; nn = nn.nextSibling){
            if(nn.nodeType == 3) ans += nn.textContent;
            else if(nn.nodeType == 1){
                if(nn.hasAttribute("d")){
                    var dim = parseInt(nn.getAttribute("d"));
                    var joiner = function(d,l){
                        if(d > 1) for(var k = 0; k < l.length; k++) l[k] = joiner(d-1,l[k]);
                        return l.join(nn.getAttribute('sep'+(d-1)));
                    }
                ans += joiner(dim,cs[parseInt(nn.getAttribute("ref"))]);
                }
                else ans += cs[parseInt(nn.getAttribute("ref"))];
            }
        }
    }
    else if(n.nodeName == "l"){
        ans = [];
        i = 0;
        for(nn = n.firstChild; nn != null; nn = nn.nextSibling){
            ans[i++] = this.manual_render(t,nn,r);
        }
    }
    else if(n.nodeName == "c" || n.nodeName == "m"){
        for(nn = n.firstChild; nn != null; nn = nn.nextSibling)
            ans += this.manual_render(t,nn,r);
        if(t == "latex" && n.getAttribute("bracket") == "yes" && this.auto_bracket(n)) {
            ans = "\\left("+ans+"\\right)";
        }
    }
    return ans;
}

/** 
    Render all guppy documents on the page. 
    @memberof Doc
*/
Doc.render_all = function(t, delim){
    var l,i,n,d,s,ans = [];
    if(!t || t == "xml"){
        l = document.getElementsByTagName("script");
        for(i = 0; i < l.length; i++){
            if(l[i].getAttribute("type") == "text/guppy_xml"){
                n = l[i];
                d = new Doc(n.innerHTML);
                s = document.createElement("span");
		var len = ans.length;
		var new_id = "guppy-"+t+"-render-"+len;
		while(document.getElementById(new_id)) new_id = "guppy-xml-render-"+(++len);
                s.setAttribute("id",new_id);
                s.setAttribute("class","guppy-render");
                katex.render(d.get_content("latex"), s);
                n.parentNode.insertBefore(s, n);
                n.parentNode.removeChild(n);
                ans.push({"container":s, "doc":d})
            }
        }
    }
    else {
        var subs = function(node) {
            if(!node) return;
            var excludeElements = ['script', 'style', 'iframe', 'canvas'];
            do {
                switch (node.nodeType) {
                case 1:
                    // Don't process KaTeX elements, Guppy instances, Javascript, or CSS
                    if (excludeElements.indexOf(node.tagName.toLowerCase()) > -1 || (" "+node.getAttribute("class")+" ").indexOf(" katex ") > -1) {
                            continue;
                    }
                    subs(node.firstChild);
                    break;
                case 3:
                    var text_node = node;
                    var offset = text_node.textContent.indexOf(delim);
                    while(offset > -1){
                        var next = text_node.textContent.substring(offset+delim.length).indexOf(delim);
                        if(next == -1) break;
                        var before = text_node.textContent.substring(0,offset);
                        var content = text_node.textContent.substring(offset+delim.length,offset+delim.length+next);
                        var after = text_node.textContent.substring(offset+delim.length+next+delim.length);

                        // Make the span to render the doc in
                        var s = document.createElement("span");
			var l = ans.length;
			var new_id = "guppy-"+t+"-render-"+l;
			while(document.getElementById(new_id)) new_id = "guppy-"+t+"-render-"+(++l);
                        s.setAttribute("id",new_id);
			s.setAttribute("class","guppy-render");

                        // Create the document
                        d = new Doc(content,t);
                        
                        // Render the doc
                        katex.render(d.get_content("latex"), s);
                        var new_node = document.createTextNode(after)
                        text_node.parentNode.insertBefore(document.createTextNode(before), text_node);
                        text_node.parentNode.insertBefore(s, text_node);
                        text_node.parentNode.insertBefore(new_node, text_node);
                        text_node.parentNode.removeChild(text_node);
                        text_node = new_node;
                        ans.push({"id":new_id, "doc":d})

                        // Place the right data in the remainder of the node
                        text_node.textContent = text_node.textContent.substring(next-offset+delim.length);
                        offset = text_node.textContent.indexOf(delim);
                    }
                    break;
		default:
                    break;
                }
            } while ((node = node.nextSibling));

        }
        delim = delim || "$$";
        subs(document.documentElement);
    }
    return ans;
}

/** 
    Render a given document into a specified HTML element.
    @param {string} doc - A GuppyXML string to be rendered
    @param {string} target_id - The ID of the HTML element to render into
    @memberof Doc
*/
Doc.render = function(doc, target_id){
    var d = new Doc(doc);
    var target = document.getElementById(target_id);
    katex.render(d.get_content("latex"), target);
    return {"container":target, "doc":d};
}


module.exports = Doc;

},{"../lib/katex/katex-modified.min.js":"/usr/var/server.base/node_modules/guppy-dev/lib/katex/katex-modified.min.js","./ast.js":"/usr/var/server.base/node_modules/guppy-dev/src/ast.js","./parser.js":"/usr/var/server.base/node_modules/guppy-dev/src/parser.js","./symbols.js":"/usr/var/server.base/node_modules/guppy-dev/src/symbols.js","./utils.js":"/usr/var/server.base/node_modules/guppy-dev/src/utils.js","./version.js":"/usr/var/server.base/node_modules/guppy-dev/src/version.js"}],"/usr/var/server.base/node_modules/guppy-dev/src/engine.js":[function(require,module,exports){
var Utils = require('./utils.js');
var Doc = require('./doc.js');
var Symbols = require('./symbols.js');
var Settings = require('./settings.js');

String.prototype.splice = function(idx, s){ return (this.slice(0,idx) + s + this.slice(idx)); };
String.prototype.splicen = function(idx, s, n){ return (this.slice(0,idx) + s + this.slice(idx+n));};
String.prototype.search_at = function(idx, s){ return (this.substring(idx-s.length,idx) == s); };

/**
 * @class
 * @classdesc The engine for scripting the editor.  To access the
 * engine for scripting a particular Guppy instance, say called
 * `"guppy1"`, do `Guppy("guppy1").engine`.  
 *
 * At that point, you can, for example, move that editor's cursor
 * one spot to the left with `Guppy("guppy1").engine.left()`.
*/
var Engine = function(config){
    config = config || {};
    var events = config['events'] || {};
    var settings = config['settings'] || {};
    this.parent = config['parent'];
    this.id = this.parent.editor.id;
    
    this.ready = false;
    this.events = {};
    this.settings = {};
    
    var evts = ["ready", "change", "left_end", "right_end", "done", "completion", "debug", "error", "focus"];
    
    for(var i = 0; i < evts.length; i++){
        var e = evts[i];
        if(e in events) this.events[e] = e in events ? events[e] : null;
    }

    var opts = ["blank_caret", "empty_content", "blacklist", "autoreplace", "cliptype"];
    
    for(var j = 0; j < opts.length; j++){
        var p = opts[j];
        if(p in settings) this.settings[p] = settings[p];
    }

    this.symbols = {};
    this.doc = new Doc(settings["xml_content"]);
    
    this.current = this.doc.root().firstChild;
    this.caret = 0;
    this.space_caret = 0;
    this.sel_start = null;
    this.sel_end = null;
    this.undo_data = [];
    this.undo_now = -1;
    this.sel_status = Engine.SEL_NONE;
    this.checkpoint();
    if(Engine.ready && !this.ready){
        this.ready = true;
        this.symbols = JSON.parse(JSON.stringify(Symbols.symbols));
        this.fire_event("ready");
    }
}

Engine.ready = false;
Engine.SEL_NONE = 0;
Engine.SEL_CURSOR_AT_START = 1;
Engine.SEL_CURSOR_AT_END = 2;
Engine.clipboard = null;

Engine.prototype.setting = function(name){
    return name in this.settings ? this.settings[name] : Settings.config.settings[name];
}

Engine.prototype.event = function(name){
    return name in this.events ? this.events[name] : Settings.config.events[name];
}

/** 
    Get the content of the editor
    @memberof Engine
    @param {string} t - The type of content to render ("latex", "text", or "xml").
*/
Engine.prototype.get_content = function(t,r){
    return this.doc.get_content(t,r);
}

/** 
    Set the XML content of the editor
    @memberof Engine
    @param {string} xml_data - An XML string of the content to place in the editor
*/
Engine.prototype.set_content = function(xml_data){
    this.set_doc(new Doc(xml_data));
}

/** 
    Set the document of the editor
    @memberof Engine
    @param {Doc} doc - The Doc that will be the editor's source
*/
Engine.prototype.set_doc = function(doc){
    this.doc = doc;
    this.current = this.doc.root().firstChild;
    this.caret = 0;
    this.sel_start = null;
    this.sel_end = null;
    this.undo_data = [];
    this.undo_now = -1;
    this.sel_status = Engine.SEL_NONE;
    this.checkpoint();
}

Engine.prototype.import_text = function(text){
    this.doc.import_text(text, this.symbols);
    this.set_doc(this.doc);
}

Engine.prototype.import_latex = function(text){
    this.doc.import_latex(text, this.symbols);
    this.set_doc(this.doc);
}

Engine.prototype.import_ast = function(ast){
    this.doc.import_ast(ast, this.symbols);
    this.set_doc(this.doc);
}

Engine.prototype.fire_event = function(event, args){
    args = args || {};
    args.target = this.parent || this;
    args.type = event;
    var ev = this.event(event);
    if(ev && this.ready && Engine.ready) ev(args);
}

/** 
    Remove a symbol from this instance of the editor.
    @memberof Engine
    @param {string} name - The name of the symbol to remove.
*/
Engine.prototype.remove_symbol = function(name){
    if(this.symbols[name]) delete this.symbols[name];
}

/** 
    Add a symbol to this instance of the editor.
    @memberof Engine
    @param {string} name - param
    @param {Object} symbol - If `template` is present, this is the
    template arguments.  Otherwise, it is a complete specification
    of the symbol, the format for which can be found in the
    documentation for Guppy.add_global_symbol.
    @param {string} [template] - The name of the template to use.
*/
Engine.prototype.add_symbol = function(name, symbol){
    this.symbols[name] = symbol;
}

Engine.prototype.select_to = function(loc, sel_cursor, sel_caret, mouse){
    if(loc.current == sel_cursor && loc.caret == sel_caret){
        this.current = loc.current;
        this.caret = loc.caret;
        this.sel_status = Engine.SEL_NONE;
    }
    else if(loc.pos == "left"){
        this.sel_end = {"node":sel_cursor,"caret":sel_caret};
        this.current = loc.current;
        this.caret = loc.caret;
        this.set_sel_boundary(Engine.SEL_CURSOR_AT_START, mouse);
    }
    else if(loc.pos == "right"){
        this.sel_start = {"node":sel_cursor,"caret":sel_caret};
        this.current = loc.current;
        this.caret = loc.caret;
        this.set_sel_boundary(Engine.SEL_CURSOR_AT_END, mouse);
    }
}

Engine.prototype.set_sel_start = function(){
    this.sel_start = {"node":this.current, "caret":this.caret};
}

Engine.prototype.set_sel_end = function(){
    this.sel_end = {"node":this.current, "caret":this.caret};
}

Engine.prototype.add_paths = function(n,path){
    if(n.nodeName == "e"){
        n.setAttribute("path",path);
    }
    else{
        var es = 1, fs = 1, cs = 1, ls = 1;
        for(var c = n.firstChild; c != null; c = c.nextSibling){
            if(c.nodeName == "c"){ this.add_paths(c, path+"_c"+cs); cs++; }
            else if(c.nodeName == "f"){ this.add_paths(c, path+"_f"+fs); fs++; }
            else if(c.nodeName == "l"){ this.add_paths(c, path+"_l"+ls); ls++; }
            else if(c.nodeName == "e"){ this.add_paths(c, path+"_e"+es); es++; }
        }
    }
}

Engine.prototype.add_classes_cursors = function(n){
    if(n.nodeName == "e"){
        var text = n.firstChild.nodeValue;
        var ans = "";
        var sel_cursor;
        var text_node = Utils.is_text(n);
        if(this.sel_status == Engine.SEL_CURSOR_AT_START) sel_cursor = this.sel_end;
        if(this.sel_status == Engine.SEL_CURSOR_AT_END) sel_cursor = this.sel_start;
        if(this.sel_status != Engine.SEL_NONE){
            var sel_caret_text = Utils.is_small(sel_cursor.node) ? Utils.SMALL_SEL_CARET : Utils.SEL_CARET;
            if(!text_node && text.length == 0 && n.parentNode.childElementCount > 1){
                sel_caret_text = "\\blue{\\xmlClass{guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0}{"+sel_caret_text+"}}";
            }
            else{
                sel_caret_text = "\\blue{"+sel_caret_text+"}";
            }
            if(this.sel_status == Engine.SEL_CURSOR_AT_END) sel_caret_text = text_node ? "[" : sel_caret_text + "\\"+Utils.SEL_COLOR+"{";
            if(this.sel_status == Engine.SEL_CURSOR_AT_START) sel_caret_text = text_node ? "]" : "}" + sel_caret_text;
        }
        var caret_text = "";
        var temp_caret_text = "";
        if(text.length == 0){
            if(text_node) caret_text = "\\_";
            else if(n.parentNode.childElementCount == 1){
                if(this.current == n){
                    var blank_caret = this.setting("blank_caret") || (Utils.is_small(this.current) ? Utils.SMALL_CARET : Utils.CARET);
                    ans = "\\red{\\xmlClass{main_cursor guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0"+"}{"+blank_caret+"}}";
                }
                else if(this.temp_cursor.node == n)
                    ans = "\\gray{\\xmlClass{guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0"+"}{[?]}}";
                else
                    ans = "\\blue{\\xmlClass{guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0"+"}{[?]}}";
            }
            else if(this.temp_cursor.node != n && this.current != n && (!(sel_cursor) || sel_cursor.node != n)){
                // These are the empty e elements at either end of
                // a c or m node, such as the space before and
                // after both the sin and x^2 in sin(x^2)
                //
                // Here, we add in a small element so that we can
                // use the mouse to select these areas
                ans = "\\phantom{\\xmlClass{guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0"+"}{\\cursor[0.1ex]{1ex}}}";
            }
        }
        for(var i = 0; i < text.length+1; i++){
            if(n == this.current && i == this.caret && (text.length > 0 || n.parentNode.childElementCount > 1)){
                if(text_node){
                    if(this.sel_status == Engine.SEL_CURSOR_AT_START)
                        caret_text = "[";
                    else if(this.sel_status == Engine.SEL_CURSOR_AT_END)
                        caret_text = "]";
                    else
                        caret_text = "\\_";
                }
                else{
                    caret_text = Utils.is_small(this.current) ? Utils.SMALL_CARET : Utils.CARET;
                    if(text.length == 0)
                        caret_text = "\\red{\\xmlClass{main_cursor guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0}{"+caret_text+"}}";
                    else{
                        caret_text = "\\red{\\xmlClass{main_cursor}{"+caret_text+"}}"
                    }
                    if(this.sel_status == Engine.SEL_CURSOR_AT_START)
                        caret_text = caret_text + "\\"+Utils.SEL_COLOR+"{";
                    else if(this.sel_status == Engine.SEL_CURSOR_AT_END)
                        caret_text = "}" + caret_text;
                }
                ans += caret_text;
            }
            else if(n == this.current && i == this.caret && text_node){
                ans += caret_text;
            }
            else if(this.sel_status != Engine.SEL_NONE && sel_cursor.node == n && i == sel_cursor.caret){
                ans += sel_caret_text;
            }
            else if(this.temp_cursor.node == n && i == this.temp_cursor.caret && (text.length > 0 || n.parentNode.childElementCount > 1)){
                if(text_node) 
                    temp_caret_text = ".";
                else{
                    temp_caret_text = Utils.is_small(this.current) ? Utils.TEMP_SMALL_CARET : Utils.TEMP_CARET;
                    if(text.length == 0){
                        temp_caret_text = "\\gray{\\xmlClass{guppy_elt guppy_blank guppy_loc_"+n.getAttribute("path")+"_0}{"+temp_caret_text+"}}";
                    }
                    else
                        temp_caret_text = "\\gray{"+temp_caret_text+"}";
                }
                ans += temp_caret_text;
            }
            if(i < text.length) ans += "\\xmlClass{guppy_elt guppy_loc_"+n.getAttribute("path")+"_"+i+"}{"+text[i]+"}";
        }
        if(text_node && n == this.current){
            ans = "\\xmlClass{guppy_text_current}{{"+ans+"}}";
        }
        n.setAttribute("render", ans);
        n.removeAttribute("path");
    }
    else{
        for(var c = n.firstChild; c != null; c = c.nextSibling){
            if(c.nodeName == "c" || c.nodeName == "l" || c.nodeName == "f" || c.nodeName == "e"){ this.add_classes_cursors(c); }
        }
    }
}

Engine.prototype.remove_cursors_classes = function(n){
    if(n.nodeName == "e"){
        n.removeAttribute("path");
        n.removeAttribute("render");
        n.removeAttribute("current");
        n.removeAttribute("temp");
    }
    else{
        for(var c = n.firstChild; c != null; c = c.nextSibling){
            if(c.nodeType == 1){ this.remove_cursors_classes(c); }
        }
    }
}

Engine.prototype.down_from_f = function(){
    var nn = this.current.firstChild;
    while(nn != null && nn.nodeName != 'c' && nn.nodeName != 'l') nn = nn.nextSibling;
    if(nn != null){
        while(nn.nodeName == 'l') nn = nn.firstChild;
        this.current = nn.firstChild;
    }
}

Engine.prototype.down_from_f_to_blank = function(){
    var nn = this.current.firstChild;
    while(nn != null && !(nn.nodeName == 'c' && nn.children.length == 1 && nn.firstChild.firstChild.nodeValue == "")){
        nn = nn.nextSibling;
    }
    if(nn != null){
        //Sanity check:
        
        while(nn.nodeName == 'l') nn = nn.firstChild;
        if(nn.nodeName != 'c' || nn.firstChild.nodeName != 'e'){
            this.problem('dfftb');
            return;
        }
        this.current = nn.firstChild;
    }
    else this.down_from_f();
}

Engine.prototype.delete_from_f = function(to_insert){
    var n = this.current;
    var p = n.parentNode;
    var prev = n.previousSibling;
    var next = n.nextSibling;
    var middle = to_insert || "";
    var new_node = this.make_e(prev.firstChild.textContent + middle + next.firstChild.textContent);
    this.current = new_node;
    this.caret = prev.firstChild.textContent.length;
    p.insertBefore(new_node, prev);
    p.removeChild(prev);
    p.removeChild(n);
    p.removeChild(next);
}

Engine.prototype.symbol_to_node = function(sym_name, content){
    return Symbols.symbol_to_node(this.symbols[sym_name], content, this.doc.base);
}

/** 
    Insert a symbol into the document at the current cursor position.
    @memberof Engine
    @param {string} sym_name - The name of the symbol to insert.
    Should match one of the keys in the symbols JSON object
*/
Engine.prototype.insert_symbol = function(sym_name){
    var s = this.symbols[sym_name];
    if(s.attrs && this.is_blacklisted(s.attrs.type)){
        return false;
    }
    var content = {};
    var left_piece,right_piece;
    var cur = "input" in s ? s.input : 0;
    var to_remove = [];
    var to_replace = null;
    var replace_f = false;
    var sel;
    
    if(cur > 0){
        cur--;
        if(this.sel_status != Engine.SEL_NONE){
            sel = this.sel_get();
            to_remove = sel.involved;
            left_piece = this.make_e(sel.remnant.firstChild.nodeValue.slice(0,this.sel_start.caret));
            right_piece = this.make_e(sel.remnant.firstChild.nodeValue.slice(this.sel_start.caret));
            content[cur] = sel.node_list;
        }
        else if("input" in s){
            // If we're at the beginning, then the token is the previous f node
            if(this.caret == 0 && this.current.previousSibling != null){
                content[cur] = [this.make_e(""), this.current.previousSibling, this.make_e("")];
                to_replace = this.current.previousSibling;
                replace_f = true;
            }
            else{
                // look for [0-9.]+|[a-zA-Z] immediately preceeding the caret and use that as token
                var prev = this.current.firstChild.nodeValue.substring(0,this.caret);
                var token = prev.match(/[0-9.]+$|[a-zA-Z]$/);
                if(token != null && token.length > 0){
                    token = token[0];
                    left_piece = this.make_e(this.current.firstChild.nodeValue.slice(0,this.caret-token.length));
                    right_piece = this.make_e(this.current.firstChild.nodeValue.slice(this.caret));
                    content[cur] = [this.make_e(token)];
                }
            }
        }
    }
    if(!replace_f && (left_piece == null || right_piece == null)){
        if(this.sel_status != Engine.SEL_NONE){
            sel = this.sel_get();
            to_remove = sel.involved;
            left_piece = this.make_e(sel.remnant.firstChild.nodeValue.slice(0,this.sel_start.caret));
            right_piece = this.make_e(sel.remnant.firstChild.nodeValue.slice(this.sel_start.caret));
            content = [sel.node_list];
	}
	else{
            left_piece = this.make_e(this.current.firstChild.nodeValue.slice(0,this.caret));
            right_piece = this.make_e(this.current.firstChild.nodeValue.slice(this.caret));
            to_remove = [this.current];
	}
    }

    // By now:
    // 
    // content contains whatever we want to pre-populate the 'current' field with (if any)
    //
    // right_piece contains whatever content was in an involved node
    // to the right of the cursor but is not part of the insertion.
    // Analogously for left_piece
    //
    // Thus all we should have to do now is symbol_to_node(sym_type,
    // content) and then add the left_piece, resulting node, and
    // right_piece in that order.
    var sym = this.symbol_to_node(sym_name,content);
    var current_parent = this.current.parentNode;
    
    var f = sym.f;

    var next = this.current.nextSibling;

    if(replace_f){
        current_parent.replaceChild(f,to_replace);
    }
    else{
        if(to_remove.length == 0) this.current.parentNode.removeChild(this.current);
        
        for(var i = 0; i < to_remove.length; i++){
            if(next == to_remove[i]) next = next.nextSibling;
            current_parent.removeChild(to_remove[i]);
        }
        current_parent.insertBefore(left_piece, next);
        current_parent.insertBefore(f, next);
        current_parent.insertBefore(right_piece, next);
    }
    
    this.caret = 0;
    this.current = f;
    if(sym.args.length == 0 || ("input" in s && s.input >= sym.args.length)){
        this.current = this.current.nextSibling;
    }
    else{
        this.down_from_f_to_blank();
        this.caret = this.current.firstChild.textContent.length;
    }

    this.sel_clear();
    this.checkpoint();
    return true;
}

Engine.prototype.sel_get = function(){
    if(this.sel_status == Engine.SEL_NONE){
        return null;
    }
    var involved = [];
    var node_list = [];
    var remnant = null;

    if(this.sel_start.node == this.sel_end.node){
        return {"node_list":[this.make_e(this.sel_start.node.firstChild.nodeValue.substring(this.sel_start.caret, this.sel_end.caret))],
                "remnant":this.make_e(this.sel_start.node.firstChild.nodeValue.substring(0, this.sel_start.caret) + this.sel_end.node.firstChild.nodeValue.substring(this.sel_end.caret)),
                "involved":[this.sel_start.node]};
    }
    
    node_list.push(this.make_e(this.sel_start.node.firstChild.nodeValue.substring(this.sel_start.caret)));
    involved.push(this.sel_start.node);
    involved.push(this.sel_end.node);
    remnant = this.make_e(this.sel_start.node.firstChild.nodeValue.substring(0, this.sel_start.caret) + this.sel_end.node.firstChild.nodeValue.substring(this.sel_end.caret));
    var n = this.sel_start.node.nextSibling;
    while(n != null && n != this.sel_end.node){
        involved.push(n);
        node_list.push(n);
        n = n.nextSibling;
    }
    node_list.push(this.make_e(this.sel_end.node.firstChild.nodeValue.substring(0, this.sel_end.caret)));
    return {"node_list":node_list,
            "remnant":remnant,
            "involved":involved,
            "cursor":0};
}

Engine.prototype.make_e = function(text){
    var base = this.doc.base;
    var new_node = base.createElement("e");
    new_node.appendChild(base.createTextNode(text));
    return new_node;
}

/** 
    Insert a string into the document at the current cursor position.
    @memberof Engine
    @param {string} s - The string to insert.
*/
Engine.prototype.insert_string = function(s){
    var self = this;
    if(this.sel_status != Engine.SEL_NONE){
        this.sel_delete();
        this.sel_clear();
    }
    this.current.firstChild.nodeValue = this.current.firstChild.nodeValue.splice(this.caret,s)
    this.caret += s.length;
    this.checkpoint();
    if(this.setting("autoreplace") == "auto") this.check_for_symbol(false);
    if(this.setting("autoreplace") == "whole") this.check_for_symbol(true);
    if(this.setting("autoreplace") == "delay" && setTimeout){
        if(this.delayed_check) clearTimeout(this.delayed_check);
        this.delayed_check = setTimeout(function(){ self.check_for_symbol(false); }, 200);
    }
}

/** 
    Insert a copy of the given document into the editor at the current cursor position.
    @memberof Engine
    @param {Doc} doc - The document to insert.
*/
Engine.prototype.insert_doc = function(doc){
    this.insert_nodes(doc.root().childNodes, true);
}

/** 
    Copy the current selection, leaving the document unchanged but
    placing the contents of the current selection on the clipboard.
    @memberof Engine
*/
Engine.prototype.sel_copy = function(){
    var sel = this.sel_get();
    if(!sel) return;
    Engine.clipboard = [];
    var cliptype = this.setting("cliptype");
    if(cliptype != "none") var clip_doc = new Doc("<m></m>");
    for(var i = 0; i < sel.node_list.length; i++){
        var node = sel.node_list[i].cloneNode(true);
        Engine.clipboard.push(node);
        if(cliptype != "none") clip_doc.root().appendChild(node.cloneNode(true));//clip_text += this.doc.manual_render(cliptype, node);
    }
    if(cliptype != "none"){
        try{
            this.system_copy(clip_doc.get_content(cliptype));
        }
        catch(e){
            this.system_copy("Syntax error");
        }
    }
    this.sel_clear();
}

Engine.prototype.system_copy = function(text) {
    if (window.clipboardData && window.clipboardData.setData)
        return window.clipboardData.setData("Text", text);
    else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        textarea.style.background = "transparent";
        document.body.appendChild(textarea);
        textarea.select();
        try { return document.execCommand("copy"); }
        catch (ex) { return false; }
        finally { document.body.removeChild(textarea); }
    }
}

/** 
    Cut the current selection, removing it from the document and placing it in the clipboard.
    @memberof Engine
*/
Engine.prototype.sel_cut = function(){
    var node_list = this.sel_delete();
    if(!node_list) return;
    Engine.clipboard = [];
    var cliptype = this.setting("cliptype");
    var clip_text = "";
    for(var i = 0; i < node_list.length; i++){
        var node = node_list[i].cloneNode(true);
        Engine.clipboard.push(node);
        if(cliptype != "none") clip_text += this.doc.manual_render(cliptype, node);
    }
    if(cliptype != "none") this.system_copy(clip_text);
    this.sel_clear();
    this.checkpoint();
}

Engine.prototype.insert_nodes = function(node_list, move_cursor){
    var real_clipboard = [];
    for(var i = 0; i < node_list.length; i++){
        real_clipboard.push(node_list[i].cloneNode(true));
    }

    if(real_clipboard.length == 1){
        this.current.firstChild.nodeValue = this.current.firstChild.nodeValue.substring(0,this.caret) + real_clipboard[0].firstChild.nodeValue + this.current.firstChild.nodeValue.substring(this.caret);
        if(move_cursor) this.caret += real_clipboard[0].firstChild.nodeValue.length;
    }
    else{
        var nn = this.make_e(real_clipboard[real_clipboard.length-1].firstChild.nodeValue + this.current.firstChild.nodeValue.substring(this.caret));
        this.current.firstChild.nodeValue = this.current.firstChild.nodeValue.substring(0,this.caret) + real_clipboard[0].firstChild.nodeValue;
        if(this.current.nextSibling == null)
            this.current.parentNode.appendChild(nn)
        else
            this.current.parentNode.insertBefore(nn, this.current.nextSibling)
        for(var j = 1; j < real_clipboard.length - 1; j++)
            this.current.parentNode.insertBefore(real_clipboard[j], nn);
        if(move_cursor){
            this.current = nn;
            this.caret = real_clipboard[real_clipboard.length-1].firstChild.nodeValue.length
        }
    }
}

/** 
    Paste the current contents of the clipboard.
    @memberof Engine
*/
Engine.prototype.sel_paste = function(){
    this.sel_delete();
    this.sel_clear();
    if(!(Engine.clipboard) || Engine.clipboard.length == 0) return;
    this.insert_nodes(Engine.clipboard, true);
    this.checkpoint();
    return;
}

/** 
    Clear the current selection, leaving the document unchanged and
    nothing selected.
    @memberof Engine
*/
Engine.prototype.sel_clear = function(){
    this.sel_start = null;    
    this.sel_end = null;
    this.sel_status = Engine.SEL_NONE;
}

/** 
    Delete the current selection.
    @memberof Engine
*/
Engine.prototype.sel_delete = function(){
    var sel = this.sel_get();
    if(!sel) return null;
    var sel_parent = sel.involved[0].parentNode;
    var sel_prev = sel.involved[0].previousSibling;
    for(var i = 0; i < sel.involved.length; i++){
        var n = sel.involved[i];
        sel_parent.removeChild(n);
    }
    if(sel_prev == null){
        if(sel_parent.firstChild == null)
            sel_parent.appendChild(sel.remnant);
        else
            sel_parent.insertBefore(sel.remnant, sel_parent.firstChild);
    }
    else if(sel_prev.nodeName == 'f'){
        if(sel_prev.nextSibling == null)
            sel_parent.appendChild(sel.remnant);
        else
            sel_parent.insertBefore(sel.remnant, sel_prev.nextSibling);
    }
    this.current = sel.remnant
    this.caret = this.sel_start.caret;
    return sel.node_list;
}

/** 
    Select the entire contents of the editor.
    @memberof Engine
*/
Engine.prototype.sel_all = function(){
    this.home();
    this.set_sel_start();
    this.end();
    this.set_sel_end();
    if(this.sel_start.node != this.sel_end.node || this.sel_start.caret != this.sel_end.caret)
        this.sel_status = Engine.SEL_CURSOR_AT_END;
}

/** 
    function
    @memberof Engine
    @param {string} name - param
*/
Engine.prototype.sel_right = function(){
    if(this.sel_status == Engine.SEL_NONE){
        this.set_sel_start();
        this.sel_status = Engine.SEL_CURSOR_AT_END;
    }
    if(this.caret >= Utils.get_length(this.current)){
        var nn = this.current.nextSibling;
        if(nn != null){
            this.current = nn.nextSibling;
            this.caret = 0;
            this.set_sel_boundary(Engine.SEL_CURSOR_AT_END);
        }
        else{
            this.set_sel_boundary(Engine.SEL_CURSOR_AT_END);
        }
    }
    else{
        this.caret += 1;
        this.set_sel_boundary(Engine.SEL_CURSOR_AT_END);
    }
    if(this.sel_start.node == this.sel_end.node && this.sel_start.caret == this.sel_end.caret){
        this.sel_status = Engine.SEL_NONE;
    }
}

Engine.prototype.set_sel_boundary = function(sstatus, mouse){
    if(this.sel_status == Engine.SEL_NONE || mouse) this.sel_status = sstatus;
    if(this.sel_status == Engine.SEL_CURSOR_AT_START)
        this.set_sel_start();
    else if(this.sel_status == Engine.SEL_CURSOR_AT_END)
        this.set_sel_end();
}

/** 
    Move the cursor to the left, adjusting the selection along with
    the cursor.
    @memberof Engine
*/
Engine.prototype.sel_left = function(){
    if(this.sel_status == Engine.SEL_NONE){
        this.set_sel_end();
        this.sel_status = Engine.SEL_CURSOR_AT_START;
    }
    if(this.caret <= 0){
        var nn = this.current.previousSibling;
        if(nn != null){
            this.current = nn.previousSibling;
            this.caret = this.current.firstChild.nodeValue.length;
            this.set_sel_boundary(Engine.SEL_CURSOR_AT_START);
        }
        else{
            this.set_sel_boundary(Engine.SEL_CURSOR_AT_START);
        }
    }
    else{
        this.caret -= 1;
        this.set_sel_boundary(Engine.SEL_CURSOR_AT_START);
    }
    if(this.sel_start.node == this.sel_end.node && this.sel_start.caret == this.sel_end.caret){
        this.sel_status = Engine.SEL_NONE;
    }
}

Engine.prototype.list_extend_copy_right = function(){this.list_extend("right", true);}
Engine.prototype.list_extend_copy_left = function(){this.list_extend("left", true);}
Engine.prototype.list_extend_right = function(){this.list_extend("right", false);}
Engine.prototype.list_extend_left = function(){this.list_extend("left", false);}
Engine.prototype.list_extend_up = function(){this.list_extend("up", false);}
Engine.prototype.list_extend_down = function(){this.list_extend("down", false);}
Engine.prototype.list_extend_copy_up = function(){this.list_extend("up", true);}
Engine.prototype.list_extend_copy_down = function(){this.list_extend("down", true);}

/** 
    Move the cursor by one row up or down in a matrix. 
    @memberof Engine
    @param {boolean} down - If `true`, move down in the matrix;
    otherwise, up.
*/
Engine.prototype.list_vertical_move = function(down){
    var n = this.current;
    while(n.parentNode && n.parentNode.parentNode && !(n.nodeName == 'c' && n.parentNode.nodeName == 'l' && n.parentNode.parentNode.nodeName == 'l')){
        n = n.parentNode;
    }
    if(!n.parentNode) return;
    var pos = 1;
    var cc = n;
    while(cc.previousSibling != null){
        pos++;
        cc = cc.previousSibling;
    }
    var new_l = down ? n.parentNode.nextSibling : n.parentNode.previousSibling
    if(!new_l) return;
    var idx = 1;
    var nn = new_l.firstChild;
    while(idx < pos){
        idx++;
        nn = nn.nextSibling;
    }
    this.current = nn.firstChild;
    this.caret = down ? 0 : this.current.firstChild.textContent.length;
}

/** 
    Add an element to a list (or row/column to a matrix) in the
    specified direction.  Can optionally copy the current
    element/row/column to the new one.
    @memberof Engine
    @param {string} direction - One of `"up"`, `"down"`, `"left"`, or
    `"right"`.  
    @param {boolean} copy - Whether or not to copy the current
    element/row/column into the new one.
*/
Engine.prototype.list_extend = function(direction, copy){
    var base = this.doc.base;
    var vertical = direction == "up" || direction == "down";
    var before = direction == "up" || direction == "left";
    var this_name = vertical ? "l" : "c";
    var n = this.current;
    while(n.parentNode && !(n.nodeName == this_name && n.parentNode.nodeName == 'l')){
        n = n.parentNode;
    }
    if(!n.parentNode) return;
    var to_insert;
    
    // check if 2D and horizontal and extend all the other rows if so 
    if(!vertical && n.parentNode.parentNode.nodeName == "l"){
        to_insert = base.createElement("c");
        to_insert.appendChild(this.make_e(""));
        var pos = 1;
        var cc = n;
        while(cc.previousSibling != null){
            pos++;
            cc = cc.previousSibling;
        }
        var to_modify = [];
        var iterator = this.doc.xpath_list("./l/c[position()="+pos+"]", n.parentNode.parentNode);
	var nn = null;
        try{ for(nn = iterator.iterateNext(); nn != null; nn = iterator.iterateNext()){ to_modify.push(nn); }}
        catch(e) { this.fire_event("error",{"message":'XML modified during iteration? ' + e}); }
        for(var j = 0; j < to_modify.length; j++){
            nn = to_modify[j];
            if(copy) nn.parentNode.insertBefore(nn.cloneNode(true), before ? nn : nn.nextSibling);
            else nn.parentNode.insertBefore(to_insert.cloneNode(true), before ? nn : nn.nextSibling);
            nn.parentNode.setAttribute("s",parseInt(nn.parentNode.getAttribute("s"))+1);
        }
        this.sel_clear();
        this.current = before ? n.previousSibling.lastChild : n.nextSibling.firstChild;
        this.caret = this.current.firstChild.textContent.length;
        this.checkpoint();
        return;
    }
    
    if(copy){
        to_insert = n.cloneNode(true);
    }
    else{
        if(vertical){
            to_insert = base.createElement("l");
            to_insert.setAttribute("s",n.getAttribute("s"))
            for(var i = 0; i < parseInt(n.getAttribute("s")); i++){
                var c = base.createElement("c");
                c.appendChild(this.make_e(""));
                to_insert.appendChild(c);
            }
        }
        else{
            to_insert = base.createElement("c");
            to_insert.appendChild(this.make_e(""));
        }
    }
    n.parentNode.setAttribute("s",parseInt(n.parentNode.getAttribute("s"))+1);
    n.parentNode.insertBefore(to_insert, before ? n : n.nextSibling);
    this.sel_clear();
    if(vertical) this.current = to_insert.firstChild.firstChild;
    else this.current = to_insert.firstChild;
    this.caret = 0;
    this.checkpoint();
}

/** 
    Remove the current column from a matrix
    @memberof Engine
*/
Engine.prototype.list_remove_col = function(){
    var n = this.current;
    while(n.parentNode && n.parentNode.parentNode && !(n.nodeName == 'c' && n.parentNode.nodeName == 'l' && n.parentNode.parentNode.nodeName == 'l')){
        n = n.parentNode;
    }
    if(!n.parentNode) return;
    
    // Don't remove if there is only a single column:
    if(n.previousSibling != null){
        this.current = n.previousSibling.lastChild;
        this.caret = n.previousSibling.lastChild.firstChild.textContent.length;
    }
    else if(n.nextSibling != null){
        this.current = n.nextSibling.firstChild;
        this.caret = 0;
    }
    else return;
    
    var pos = 1;
    var cc = n;
    
    // Find position of column
    while(cc.previousSibling != null){
        pos++;
        cc = cc.previousSibling;
    }
    var to_modify = [];
    var iterator = this.doc.xpath_list("./l/c[position()="+pos+"]", n.parentNode.parentNode)
    var nn = null;
    try{ for(nn = iterator.iterateNext(); nn != null; nn = iterator.iterateNext()){ to_modify.push(nn); }}
    catch(e) { this.fire_event("error",{"message":'XML modified during iteration? ' + e}); }
    for(var j = 0; j < to_modify.length; j++){
        nn = to_modify[j];
        nn.parentNode.setAttribute("s",parseInt(nn.parentNode.getAttribute("s"))-1);
        nn.parentNode.removeChild(nn);
    }
    this.checkpoint();
}

/** 
    Remove the current row from a matrix
    @memberof Engine
*/
Engine.prototype.list_remove_row = function(){
    var n = this.current;
    while(n.parentNode && !(n.nodeName == 'l' && n.parentNode.nodeName == 'l')){
        n = n.parentNode;
    }
    if(!n.parentNode) return;
    // Don't remove if there is only a single row:
    if(n.previousSibling != null){
        this.current = n.previousSibling.firstChild.lastChild;
        this.caret = n.previousSibling.lastChild.firstChild.textContent.length;
    }
    else if(n.nextSibling != null){
        this.current = n.nextSibling.firstChild.firstChild;
        this.caret = 0;
    }
    else return;

    n.parentNode.setAttribute("s",parseInt(n.parentNode.getAttribute("s"))-1);
    n.parentNode.removeChild(n);
    this.checkpoint();
}

/** 
    Remove the current element from a list (or column from a matrix)
    @memberof Engine
*/
Engine.prototype.list_remove = function(){
    var n = this.current;
    while(n.parentNode && !(n.nodeName == 'c' && n.parentNode.nodeName == 'l')){
        n = n.parentNode;
    }
    if(!n.parentNode) return;
    if(n.parentNode.parentNode && n.parentNode.parentNode.nodeName == "l"){
        this.list_remove_col();
        return;
    }
    if(n.previousSibling != null){
        this.current = n.previousSibling.lastChild;
        this.caret = n.previousSibling.lastChild.firstChild.textContent.length;
    }
    else if(n.nextSibling != null){
        this.current = n.nextSibling.firstChild;
        this.caret = 0;
    }
    else return;
    n.parentNode.setAttribute("s",parseInt(n.parentNode.getAttribute("s"))-1);
    n.parentNode.removeChild(n);
    this.checkpoint();
}

/** 
    Simulate the right arrow key press
    @memberof Engine
*/
Engine.prototype.right = function(){
    this.sel_clear();
    if(this.caret >= Utils.get_length(this.current)){
        var nn = this.doc.xpath_node("following::e[1]", this.current);
        if(nn != null){
            this.current = nn;
            this.caret = 0;
        }
        else{
            this.fire_event("right_end");
        }
    }
    else{
        this.caret += 1;
    }
}

/** 
    Simulate the spacebar key press
    @memberof Engine
*/
Engine.prototype.spacebar = function(){
    if(Utils.is_text(this.current)) this.insert_string(" ");
    else this.space_caret = this.caret;
}

/** 
    Simulate the left arrow key press
    @memberof Engine
*/
Engine.prototype.left = function(){
    this.sel_clear();
    if(this.caret <= 0){
        var pn = this.doc.xpath_node("preceding::e[1]", this.current);
        if(pn != null){
            this.current = pn;
            this.caret = this.current.firstChild.nodeValue.length;
        }
        else{
            this.fire_event("left_end");
        }
    }
    else{
        this.caret -= 1;
    }
}

Engine.prototype.delete_from_c = function(){
    var pos = 0;
    var c = this.current.parentNode;
    while(c && c.nodeName == "c"){
        pos++;
        c = c.previousSibling;
    }
    var idx = this.current.parentNode.getAttribute("delete");
    var survivor_node = this.doc.xpath_node("./c[position()="+idx+"]", this.current.parentNode.parentNode);
    var survivor_nodes = [];
    for(var n = survivor_node.firstChild; n != null; n = n.nextSibling){
        survivor_nodes.push(n);
    }
    this.current = this.current.parentNode.parentNode;
    this.delete_from_f();
    this.insert_nodes(survivor_nodes, pos > idx);
}

Engine.prototype.delete_from_e = function(){
    // return false if we deleted something, and true otherwise.
    if(this.caret > 0){
        this.current.firstChild.nodeValue = this.current.firstChild.nodeValue.splicen(this.caret-1,"",1);
        this.caret--;
    }
    else{
        // The order of these is important
        if(this.current.previousSibling != null && Utils.is_char(this.current.previousSibling)){
            // The previous node is an f node but is really just a character.  Delete it.
            this.current = this.current.previousSibling;
            this.delete_from_f();
        }
        else if(this.current.previousSibling != null && this.current.previousSibling.nodeName == 'f'){
            // We're in an e node just after an f node.  Move back into the f node (delete it?)
            this.left();
            return false;
        }
        else if(this.current.parentNode.previousSibling != null && this.current.parentNode.previousSibling.nodeName == 'c'){
            // We're in a c child of an f node, but not the first one.  Go to the previous c
            if(this.current.parentNode.hasAttribute("delete")){
                this.delete_from_c();
            }
            else{
                this.left();
                return false;
            }
        }
        else if(this.current.previousSibling == null && this.current.parentNode.nodeName == 'c' && (this.current.parentNode.previousSibling == null || this.current.parentNode.previousSibling.nodeName != 'c')){
            // We're in the first c child of an f node and at the beginning--delete the f node
            var par = this.current.parentNode;
            while(par.parentNode.nodeName == 'l' || par.parentNode.nodeName == 'c'){
                par = par.parentNode;
            }
            if(par.hasAttribute("delete")){
                this.delete_from_c();
            }
            else{
                this.current = par.parentNode;
                this.delete_from_f();
            }
        }
        else{
            // We're at the beginning (hopefully!) 
            return false;
        }
    }
    return true;
}

Engine.prototype.delete_forward_from_e = function(){
    // return false if we deleted something, and true otherwise.
    if(this.caret < this.current.firstChild.nodeValue.length){
        this.current.firstChild.nodeValue = this.current.firstChild.nodeValue.splicen(this.caret,"",1);
    }
    else{
        //We're at the end
        if(this.current.nextSibling != null){
            // The next node is an f node.  Delete it.
            this.current = this.current.nextSibling;
            this.delete_from_f();
        }
        else if(this.current.parentNode.nodeName == 'c'){
            // We're in a c child of an f node.  Do nothing
            return false;
        }
    }
    return true;
}

/** 
    Simulate the "backspace" key press
    @memberof Engine
*/
Engine.prototype.backspace = function(){
    if(this.sel_status != Engine.SEL_NONE){
        this.sel_delete();
        this.sel_status = Engine.SEL_NONE;
        this.checkpoint();
    }
    else if(this.delete_from_e()){
        this.checkpoint();
    }
}

/** 
    Simulate the "delete" key press
    @memberof Engine
*/
Engine.prototype.delete_key = function(){
    if(this.sel_status != Engine.SEL_NONE){
        this.sel_delete();
        this.sel_status = Engine.SEL_NONE;
        this.checkpoint();
    }
    else if(this.delete_forward_from_e()){
        this.checkpoint();
    }
}

Engine.prototype.backslash = function(){
    if(Utils.is_text(this.current)) return;
    this.insert_symbol("sym_name");
}

/** 
    Simulate a tab key press
    @memberof Engine
*/
Engine.prototype.tab = function(){
    if(!Utils.is_symbol(this.current)){
        this.check_for_symbol();
        return;
    }
    var sym_name = this.current.firstChild.textContent;
    var candidates = [];
    for(var n in this.symbols){
        if(n.startsWith(sym_name)) candidates.push(n);
    }
    if(candidates.length == 1){
        this.current.firstChild.textContent = candidates[0];
        this.caret = candidates[0].length;
    }
    else {
        this.fire_event("completion",{"candidates":candidates});
    }
}

Engine.prototype.right_paren = function(){
    if(this.current.nodeName == 'e' && this.caret < this.current.firstChild.nodeValue.length - 1) return;
    else this.right();
}

/** 
    Simulate an up arrow key press
    @memberof Engine
*/
Engine.prototype.up = function(){
    this.sel_clear();
    if(this.current.parentNode.hasAttribute("up")){
        var t = parseInt(this.current.parentNode.getAttribute("up"));
        var f = this.current.parentNode.parentNode;
        var n = f.firstChild;
        while(n != null && t > 0){
            if(n.nodeName == 'c') t--;
            if(t > 0) n = n.nextSibling;
        }
        this.current = n.lastChild;
        this.caret = this.current.firstChild.nodeValue.length;
    }
    else this.list_vertical_move(false);
}

/** 
    Simulate a down arrow key press
    @memberof Engine
*/
Engine.prototype.down = function(){
    this.sel_clear();
    if(this.current.parentNode.hasAttribute("down")){
        var t = parseInt(this.current.parentNode.getAttribute("down"));
        var f = this.current.parentNode.parentNode;
        var n = f.firstChild;
        while(n != null && t > 0){
            if(n.nodeName == 'c') t--;
            if(t > 0) n = n.nextSibling;
        }
        this.current = n.lastChild;
        this.caret = this.current.firstChild.nodeValue.length;
    }
    else this.list_vertical_move(true);
}

/** 
    Move the cursor to the beginning of the document
    @memberof Engine
*/
Engine.prototype.home = function(){
    this.current = this.doc.root().firstChild;
    this.caret = 0;
}

/** 
    Move the cursor to the end of the document
    @memberof Engine
*/
Engine.prototype.end = function(){
    this.current = this.doc.root().lastChild;
    this.caret = this.current.firstChild.nodeValue.length;
}

Engine.prototype.checkpoint = function(){
    var base = this.doc.base;
    this.current.setAttribute("current","yes");
    this.current.setAttribute("caret",this.caret.toString());
    this.undo_now++;
    this.undo_data[this.undo_now] = base.cloneNode(true);
    this.undo_data.splice(this.undo_now+1, this.undo_data.length);
    var old_data = this.undo_data[this.undo_now-1] ? (new XMLSerializer()).serializeToString(this.undo_data[this.undo_now-1]) : "[none]";
    var new_data = (new XMLSerializer()).serializeToString(this.undo_data[this.undo_now]);
    this.fire_event("change",{"old":old_data,"new":new_data});
    this.current.removeAttribute("current");
    this.current.removeAttribute("caret");
    if(this.parent && this.parent.ready) this.parent.render(true);
}

Engine.prototype.restore = function(t){
    this.doc.base = this.undo_data[t].cloneNode(true);
    this.find_current();
    this.current.removeAttribute("current");
    this.current.removeAttribute("caret");
}

Engine.prototype.find_current = function(){
    this.current = this.doc.xpath_node("//*[@current='yes']");
    this.caret = parseInt(this.current.getAttribute("caret"));
}

/** 
    Undo the last action
    @memberof Engine
*/
Engine.prototype.undo = function(){
    this.sel_clear();
    if(this.undo_now <= 0) return;
    this.undo_now--;
    this.restore(this.undo_now);
    var old_data = this.undo_data[this.undo_now+1] ? (new XMLSerializer()).serializeToString(this.undo_data[this.undo_now+1]) : "[none]";
    var new_data = (new XMLSerializer()).serializeToString(this.undo_data[this.undo_now]);
    this.fire_event("change",{"old":old_data,"new":new_data});
}

/** 
    Redo the last undone action
    @memberof Engine
*/
Engine.prototype.redo = function(){
    this.sel_clear();
    if(this.undo_now >= this.undo_data.length-1) return;
    this.undo_now++;
    this.restore(this.undo_now);
    var old_data = this.undo_data[this.undo_now-1] ? (new XMLSerializer()).serializeToString(this.undo_data[this.undo_now-1]) : "[none]";
    var new_data = (new XMLSerializer()).serializeToString(this.undo_data[this.undo_now]);
    this.fire_event("change",{"old":old_data,"new":new_data});
}

/** 
    Execute the "done" callback
    @memberof Engine
*/
Engine.prototype.done = function(){
    if(Utils.is_symbol(this.current)) this.complete_symbol();
    else this.fire_event("done");
}

Engine.prototype.complete_symbol = function(){
    var sym_name = this.current.firstChild.textContent;
    if(!(this.symbols[sym_name])) return;
    this.current = this.current.parentNode.parentNode;
    this.delete_from_f();
    this.insert_symbol(sym_name);
}

Engine.prototype.problem = function(message){
    this.fire_event("error",{"message":message});
}

Engine.prototype.is_blacklisted = function(symb_type){
    var blacklist = this.setting("blacklist");
    for(var i = 0; i < blacklist.length; i++)
        if(symb_type == blacklist[i]) return true;
    return false;
}

Engine.prototype.check_for_symbol = function(whole_node){
    var instance = this;
    if(Utils.is_text(this.current)) return;
    var sym = "";
    var n = null;
    if(whole_node){
        n = instance.current.firstChild.nodeValue.substring(instance.space_caret, instance.caret);
        var m = /[a-zA-Z_]+$/.exec(n);
        if(m){
            var s = m[0];
            if(this.symbols[s]) sym = s;
        }
    }
    else{    
        n = instance.current.firstChild.nodeValue.substring(instance.space_caret, instance.caret);
        while(n.length > 0){
            if(n in this.symbols){
                sym = n;
                break;
            }
            n = n.substring(1);
        }
    }

    if(sym == "") return;
    
    var temp = instance.current.firstChild.nodeValue;
    var temp_caret = instance.caret;
    instance.current.firstChild.nodeValue = instance.current.firstChild.nodeValue.slice(0,instance.caret-sym.length)+instance.current.firstChild.nodeValue.slice(instance.caret);
    instance.caret -= sym.length;
    var success = instance.insert_symbol(sym);
    if(!success){
        instance.current.firstChild.nodeValue = temp;
        instance.caret = temp_caret;
    }
}

module.exports = Engine;

},{"./doc.js":"/usr/var/server.base/node_modules/guppy-dev/src/doc.js","./settings.js":"/usr/var/server.base/node_modules/guppy-dev/src/settings.js","./symbols.js":"/usr/var/server.base/node_modules/guppy-dev/src/symbols.js","./utils.js":"/usr/var/server.base/node_modules/guppy-dev/src/utils.js"}],"/usr/var/server.base/node_modules/guppy-dev/src/guppy.js":[function(require,module,exports){
var Mousetrap = require('../lib/mousetrap/mousetrap.min.js');
var katex = require('../lib/katex/katex-modified.min.js');
var Engine = require('./engine.js');
var Utils = require('./utils.js');
var Symbols = require('./symbols.js');
var Settings = require('./settings.js');
var Doc = require('./doc.js');

/**
   @class
   @classdesc An instance of Guppy.  Calling `Guppy(id)` with the ID of
   an existing editor will simply return that instance.
   @param {string} id - The string ID of the element that should be converted to an editor.  
   @param {Object} [config] - The configuration options for this instance
   @param {Object} [config.events] - A dictionary of events.
   Available events are as specified in Guppy.init.  Values in this
   dictionary will, for this instance of the editor, override events
   specified through Guppy.init.
   @param {Object} [config.settings] - A dictionary of settings.
   Values in this dictionary will override any global settings
   specified in `Guppy.init`.  This dictionary takes the same keys as
   the `config.settings` dictionary passed to `Guppy.init`.  See that
   function's documentation for the complete list.
   @constructor 
*/
var Guppy = function(id, config){
    if(Guppy.instances[id]){
        if(Guppy.instances[id].ready){
            return Guppy.instances[id];
        }
        return null;
    }
    var self = this;
    config = config || {};
    var settings = config['settings'] || {};
    
    this.id = id;
    var guppy_div = document.getElementById(id);
    
    var tab_idx = Guppy.max_tabIndex || 0;
    guppy_div.tabIndex = tab_idx;
    Guppy.max_tabIndex = tab_idx+1;

    var buttons = settings['buttons'] || Settings.config.settings['buttons'];
    this.buttons_div = document.createElement("div");
    this.buttons_div.setAttribute("class","guppy_buttons");
    if(buttons){
        for(var i = 0; i < buttons.length; i++){
            if(buttons[i] == "osk" && Settings.osk){
                this.buttons_div.appendChild(Guppy.make_button("icons/keyboard.png", function() {
                    if(Settings.osk.guppy == self){ Settings.osk.detach(self); }
                    else{ Settings.osk.attach(self); }}));
            }
            else if(buttons[i] == "settings") this.buttons_div.appendChild(Guppy.make_button("icons/settings.png", function(){ Settings.toggle("settings", self); }));
            else if(buttons[i] == "symbols") this.buttons_div.appendChild(Guppy.make_button("icons/symbols.png", function(){ Settings.toggle("symbols", self); }));
            else if(buttons[i] == "controls") this.buttons_div.appendChild(Guppy.make_button("icons/help.png", function(){ Settings.toggle("controls", self); }));
        }
    }

    this.editor_active = true;
    //this.empty_content = settings['empty_content'] || "\\red{[?]}"
    this.editor = guppy_div;
    this.blacklist = [];
    this.autoreplace = true;
    this.ready = false;

    Guppy.instances[guppy_div.id] = this;

    config['parent'] = self;

    /**   @member {Engine} */
    this.engine = new Engine(config);
    this.temp_cursor = {"node":null,"caret":0}
    this.editor.addEventListener("keydown",Guppy.key_down, false);
    this.editor.addEventListener("keyup",Guppy.key_up, false);
    this.editor.addEventListener("focus", function() { Guppy.kb.alt_down = false; if(self.activate) self.activate();}, false);
    if(Guppy.ready && !this.ready){
        this.ready = true;
        this.engine.fire_event("ready");
        this.render(true);
    }
    this.deactivate();
    this.recompute_locations_paths();
}

Guppy.instances = {};
Guppy.ready = false;
Guppy.Doc = Doc;
Guppy.active_guppy = null;
Guppy.Symbols = Symbols;

Guppy.make_button = function(url, cb){
    var b = document.createElement("img");
    b.setAttribute("class","guppy-button");
    b.setAttribute("src", Settings.config.path + "/" + url);
    if(cb){
        b.onclick = function(e){
            cb(e);
            if(e.cancelBubble!=null) e.cancelBubble = true;
            if(e.stopPropagation) e.stopPropagation();
            e.preventDefault();
            return false;
        };
    }
    return b;
}

/** 
    Add a symbol to all instances of the editor
    @memberof Guppy
    @param {string} name - The name of the symbol to add.  This is
    also the string that will be autoreplaced with the symbol.
    @param {Object} symbol - If `template` is present, this is just
    the template arguments.  Otherwise, it is the complete symbol
    specification
    @param {Object} symbol.output - Key/value pairs where the key is
    the output type (such as "latex" or "asciimath") and the value is
    the string by which the output will be rendered in that format.
    In this string, {$n} will be substituted with the rendering of the
    nth argument.  If the nth argument is a d-dimensional list, then
    the argument should be specified as {$n{sep_1}{sep_2}...{sep_d}}
    where sep_i will be the separator used to separate entries in the
    ith dimension.  Note that keys are not necessary to describe the
    AST or plain-text outputs.
    @param {Array} symbol.keys - A list of strings representing
    keystrokes that can be used to trigger the insertion of this
    symbol.  For example, `"^" or `"shift+up"` for the `exponential`
    symbol.
    @param {Object} symbol.attrs - A specification of the attributes
    of the symbol
    @param {string} symbol.attrs.type - A longer description of the
    symbol type, suitable for searching and text rendering.
    @param {string} symbol.attrs.group - The group in which to place
    this symbol (for OSK)
    @param {Object} [symbol.input] - If the symbol should subsume part
    of the existing content of the editor (as in, for example, the
    case of exponent), this object will contain the (1-based) index of
    the argument in which that content should be placed.
    @param {Object} [symbol.ast] - Modifies the default construction
    of an entry in the AST for this symbol.  
    @param {Object} [symbol.ast.type="operator"] - The type of symbol
    for AST purposes.  Can be "name" (meaning this symbol represents
    a variable, as in the case of pi), "number" (meaning this symbol
    is a literal value), "operator" (meaning this symbol is a
    function or otherwise takes arguments (as in cos or +), or
    "pass" (meaning this symbol's first argument will be used as its
    AST entry, as in the case of brackets/parentheses).
    @param {Object[]} [symbol.args] - A list of specifications, one
    for each argument
    @param {string} [symbol.args.down] - The index of the argument
    to jump to when the "down" arrow is pressed in this argument
    @param {string} [symbol.args.up] - The index of the argument
    to jump to when the "up" arrow is pressed in this argument
    @param {string} [symbol.args.small="no"] - "yes" if the symbol is
    small (as in an exponent)
    @param {string} [symbol.args.name] - The name of this particular
    argument (suitable for searching)
    @param {string} [symbol.args.bracket="no"] - "yes" if brackets
    should automatically be rendered around this argument when they
    might be needed to disambiguate.
    @param {string} [symbol.args.delete] - If present, when the
    "backspace" key is pressed at the beginning of this argument,
    the symbol will be deleted and replaced with the argument whose
    index is specified in this parameter.  For example, the second
    argument of an exponent has this value set to "1", so that when
    the exponent is deleted, the base remains.
    @param {string} [symbol.args.mode="math"] - Change the mode of an
    argument.  Can be "text" (meaning the argument will be editable
    as and rendered as plain text), "symbol" (meaning the argument
    will specify a symbol name and will complete to an actual symbol
    when this is entered--only used for the backslash symbol), or
    "math" (the default)
    @param {string} [symbol.args.is_bracket="no"] - Set to "yes" if
    the symbol is itself a bracket/parenthesis equivalent.
    @param {string} [template] - The name of the template to use
*/
Guppy.add_global_symbol = function(name, symbol, template){
    if(template){
        symbol = Symbols.make_template_symbol(template, name, symbol);
    }
    Symbols.symbols[name] = JSON.parse(JSON.stringify(symbol));
    for(var i in Guppy.instances){
        Guppy.instances[i].engine.symbols[name] = JSON.parse(JSON.stringify(symbol));
    }
}

/** 
    Remove a symbol from all instances of the editor
    @memberof Guppy
    @param {string} name - The name of the symbol to remove
*/
Guppy.remove_global_symbol = function(name){
    if(Symbols.symbols[name]){
        delete Symbols.symbols[name]
        for(var i in Guppy.instances){
            if(Guppy.instances[i].engine.symbols[name]){
                delete Guppy.instances[i].engine.symbols[name];
            }
        }
    }
}

/**
   Initialise global settings for all instances of the editor.  Most
   of these can be overridden for specific instances later.  Should be
   called before instantiating the Guppy class.
   @static 
   @memberof Guppy
   @param {Object} config - The configuration options for this instance
   @param {string[]} [config.symbols] - A list of URLs for symbol JSON files to request
   @param {string} [config.path="/lib/guppy"] - The path to the guppy build folder.
   @param {GuppyOSK} [config.osk] - A GuppyOSK object to use for the on-screen keyboard if one is desired
   @param {Object} [config.events] - A dictionary of events
   @param {function} [config.events.ready] - Called when the instance is ready to render things. 
   @param {function} [config.events.change] - Called when the editor's content changes.  Argument will be a dictionary with keys `old` and `new` containing the old and new documents, respectively. 
   @param {function} [config.events.left_end] - Called when the cursor is at the left-most point and a command is received to move the cursor to the left (e.g., via the left arrow key).  Argument will be null.
   @param {function} [config.events.left_end] - Called when the cursor is at the right-most point and a command is received to move the cursor to the right (e.g., via the right arrow key).  Argument will be null.
   @param {function} [config.events.done] - Called when the enter key is pressed in the editor.
   @param {function} [config.events.completion] - Called when the editor outputs tab completion
   options.  Argument is a dictionary with the key `candidates`, a
   list of the options for tab-completion.
   @param {function} [config.events.debug] - Called when the editor outputs some debug information.
   Argument is a dictionary with the key `message`.
   @param {function} [config.events.error] - Called when the editor receives an error.  Argument is
   a dictionary with the key `message`.
   @param {function} [config.events.focus] - Called when the editor is focused or unfocused.
   Argument will have a single key `focused` which will be `true`
   or `false` according to whether the editor is newly focused or
   newly unfocused (respectively).
   @param {Object} [config.settings] - A dictionary of settings
   @param {string} [config.settings.xml_content=<m><e/></m>] - An XML
   string with which to initialise the editor's state.
   @param {string} [config.settings.autoreplace="auto"] - Determines
   whether or not to autoreplace typed text with the corresponding
   symbols when possible.
   @param {string} [config.settings.blank_caret=""] - A LaTeX string
   that specifies what the caret should look like when in a blank
   spot.  If `""`, the default caret is used.
   @param {string} [config.settings.empty_content=\color{red}{[?]}] - A
   LaTeX string that will be displayed when the editor is both
   inactive and contains no content.
   @param {string[]} [config.settings.blacklist=[]] - A list of string
   symbol names, corresponding to symbols that should not be
   allowed in this instance of the editor.
   @param {string[]} [config.settings.buttons=["osk","settings","symbols","controls"]] - A list of strings corresponding to the helper buttons that should be displayed in the editor when focused.
   @param {string} [config.settings.cliptype] - A string, either
   "text" or "latex".  If this option is present, when text is
   placed onto the editor clipboard, the contents of the editor
   will be rendered into either plain text or LaTeX (depending on
   the value of this option) and an attempt will be made to copy
   the result to the system clipboard.
   @param {function} [config.callback] - A function to be called when
   initialisation is complete.
*/
Guppy.init = function(config){
    var all_ready = function(){
        Settings.init(Symbols.symbols);
        Guppy.register_keyboard_handlers();
        for(var i in Guppy.instances){
            Guppy.instances[i].ready = true;
            Guppy.instances[i].render(true);

            // Set backend symbols
            Guppy.instances[i].engine.symbols = JSON.parse(JSON.stringify(Symbols.symbols));

            // Set backend settings
            // for(var s in Settings.config.settings){
            //     Guppy.instances[i].engine.settings[s] = JSON.parse(JSON.stringify(Settings.config.settings[s]));
            // }

            // Set backend events
            for(var e in Settings.config.events){
                Guppy.instances[i].engine.events[e] = Settings.config.events[e];
            }
        }
        Engine.ready = true;
        for(var j in Guppy.instances){
            Guppy.instances[j].engine.ready = true;
            Guppy.instances[j].engine.fire_event("ready");
        }
	if(config.callback) config.callback();
    }
    if(config.settings){
        var settings = JSON.parse(JSON.stringify(config.settings));
        for(var s in settings){
            Settings.config.settings[s] = settings[s];
        }
    }
    if(config.events){
        Settings.config.events = config.events;
    }
    if(config.osk){
	Guppy.OSK = config.osk;
        Settings.osk = config.osk;
        if(config.osk.config.attach == "focus"){
            var f = Settings.config.events["focus"];
            Settings.config.events["focus"] = function(e){
                if(f) f(e);
                if(e.focused) config.osk.attach(e.target);
                else config.osk.detach(e.target);
            };
        }
    }
    if(config.path){
        Settings.config.path = config.path;
    }
    if(config.symbols){
        var symbols = config.symbols;
        if(!(Array.isArray(symbols))){
            symbols = [symbols];
        }
        var calls = [];
        for(var i = 0; i < symbols.length; i++){
            var x = function outer(j){
                return function(callback){
                    var req = new XMLHttpRequest();
                    req.onload = function(){
                        var syms = JSON.parse(this.responseText);
                        Symbols.add_symbols(syms);
                        callback();
                    };
                    req.open("get", symbols[j], true);
                    req.send();
                }
            }(i);
            calls.push(x);
        }
        calls.push(all_ready);
        var j = 0;
        var cb = function(){
            j += 1;
            if(j < calls.length) calls[j](cb);
        }
        if(calls.length > 0) calls[0](cb);
    }
    else{
        all_ready();
    }
}

Guppy.prototype.is_changed = function(){
    var bb = this.editor.getElementsByClassName("katex")[0];
    if(!bb) return;
    var rect = bb.getBoundingClientRect();
    var ans = null;
    if(this.bounding_box)
        ans = this.bounding_box.top != rect.top || this.bounding_box.bottom != rect.bottom || this.bounding_box.right != rect.right || this.bounding_box.left != rect.left;
    else
        ans = true;
    this.bounding_box = rect;
    return ans;
}

Guppy.prototype.recompute_locations_paths = function(){
    var ans = [];
    var bb = this.editor.getElementsByClassName("katex")[0];
    if(!bb) return;
    var rect = bb.getBoundingClientRect();
    ans.push({'path':'all',
              'top':rect.top,
              'bottom':rect.bottom,
              'left':rect.left,
              'right':rect.right});
    var elts = this.editor.getElementsByClassName("guppy_elt");
    for(var i = 0; i < elts.length; i++){
        var elt = elts[i];
        if(elt.nodeName == "mstyle") continue;
        rect = elt.getBoundingClientRect();
        if(rect.top == 0 && rect.bottom == 0 && rect.left == 0 && rect.right == 0) continue;
        var cl = elt.classList;
        for(var j = 0; j < cl.length; j++){
            if(cl[j].indexOf("guppy_loc") == 0){
                ans.push({'path':cl[j],
                          'top':rect.top,
                          'bottom':rect.bottom,
                          'left':rect.left,
                          'right':rect.right,
                          'mid_x':(rect.left+rect.right)/2,
                          'mid_y':(rect.bottom+rect.top)/2,
                          'blank':(' '+elt.className+' ').indexOf(' guppy_blank ') >= 0});
                break;
            }
        }
    }
    this.boxes = ans;
}

Guppy.get_loc = function(x,y,current_node,current_caret){
    var g = Guppy.active_guppy;
    var min_dist = -1;
    var mid_dist = 0;
    var pos = "";
    var opt = null;
    var cur = null;
    var car = null;
    // check if we go to first or last element
    var bb = g.editor.getElementsByClassName("katex")[0];
    if(!bb) return;
    if(current_node){
        var current_path = Utils.path_to(current_node);
        var current_pos = parseInt(current_path.substring(current_path.lastIndexOf("e")+1));
    }
    
    var boxes = g.boxes;
    if(!boxes) return;
    if(current_node){
        current_path = current_path.replace(/e[0-9]+$/,"e");
        var boxes2 = [];
        for(var i = 0; i < boxes.length; i++){
            if(boxes[i].path == "all") continue;
            var loc = boxes[i].path.substring(0,boxes[i].path.lastIndexOf("_"));
            loc = loc.replace(/e[0-9]+$/,"e");
            if(loc == current_path){
                boxes2.push(boxes[i]);
            }
        }
        boxes = boxes2;
    }
    if(!boxes) return;
    for(var j = 0; j < boxes.length; j++){
        var box = boxes[j];
        if(box.path == "all"){
            if(!opt) opt = {'path':'guppy_loc_m_e1_0'};
            continue;
        }
        var xdist = Math.max(box.left - x, x - box.right, 0)
        var ydist = Math.max(box.top - y, y - box.bottom, 0)
        var dist = Math.sqrt(xdist*xdist + ydist*ydist);
        if(min_dist == -1 || dist < min_dist){
            min_dist = dist;
            mid_dist = x - box.mid_x;
            opt = box;
        }
    }
    loc = opt.path.substring("guppy_loc".length);
    loc = loc.replace(/_/g,"/");
    loc = loc.replace(/([0-9]+)(?=.*?\/)/g,"[$1]");
    cur = g.engine.doc.xpath_node(loc.substring(0,loc.lastIndexOf("/")), g.engine.doc.root());
    car = parseInt(loc.substring(loc.lastIndexOf("/")+1));
    // Check if we want the cursor before or after the element
    if(mid_dist > 0 && !(opt.blank)){
        car++;
    }
    var ans = {"current":cur,"caret":car,"pos":pos};
    if(current_node && opt){
        var opt_pos = parseInt(opt.path.substring(opt.path.lastIndexOf("e")+1,opt.path.lastIndexOf("_")));
        if(opt_pos < current_pos) pos = "left";
        else if(opt_pos > current_pos) pos = "right";
        else if(car < current_caret) pos = "left";
        else if(car > current_caret) pos = "right";
        if(pos) ans['pos'] = pos;
        else ans['pos'] = "none";
    }
    return ans;
}

Guppy.mouse_up = function(){
    Guppy.kb.is_mouse_down = false;
    var g = Guppy.active_guppy;
    if(g) g.render(true);
}

Guppy.mouse_down = function(e){
    if(e.target.getAttribute("class") == "guppy-button") return;
    var n = e.target;
    Guppy.kb.is_mouse_down = true;
    while(n != null){
        if(n.id in Guppy.instances){
            e.preventDefault();
            var prev_active = Guppy.active_guppy;
            for(var i in Guppy.instances){
                if(i != n.id) Guppy.instances[i].deactivate();
                Guppy.active_guppy = Guppy.instances[n.id];
                Guppy.active_guppy.activate();
            }
            var g = Guppy.active_guppy;
            var b = Guppy.active_guppy.engine;
            g.space_caret = 0;
            if(prev_active == g){
                if(e.shiftKey){
                    g.select_to(e.clientX, e.clientY, true);
                }
                else {
                    var loc = Guppy.get_loc(e.clientX,e.clientY);
                    if(!loc) return;
                    b.current = loc.current;
                    b.caret = loc.caret;
                    b.sel_status = Engine.SEL_NONE;
                }
                g.render(true);
            }
            return;
        }
        if(n.classList && n.classList.contains("guppy_osk")){
            return;
        }
        n = n.parentNode;
    }
    Guppy.active_guppy = null;
    for(var j in Guppy.instances){
        Guppy.instances[j].deactivate();
    }
}

Guppy.mouse_move = function(e){
    var g = Guppy.active_guppy;
    if(!g) return;
    if(!Guppy.kb.is_mouse_down){
        var bb = g.editor;
        var rect = bb.getBoundingClientRect();
        if((e.clientX < rect.left || e.clientX > rect.right) || (e.clientY > rect.bottom || e.clientY < rect.top)){
            g.temp_cursor = {"node":null,"caret":0};
        }
        else{
            var loc = Guppy.get_loc(e.clientX,e.clientY);
            if(!loc) return;
            g.temp_cursor = {"node":loc.current,"caret":loc.caret};
        }
        g.render(g.is_changed());
    }
    else{
        g.select_to(e.clientX,e.clientY, true);
        g.render(g.is_changed());
    }
}

Guppy.prototype.select_to = function(x, y, mouse){
    var sel_caret = this.engine.caret;
    var sel_cursor = this.engine.current;
    if(this.engine.sel_status == Engine.SEL_CURSOR_AT_START){
        sel_cursor = this.engine.sel_end.node;
        sel_caret = this.engine.sel_end.caret;
    }
    else if(this.engine.sel_status == Engine.SEL_CURSOR_AT_END){
        sel_cursor = this.engine.sel_start.node;
        sel_caret = this.engine.sel_start.caret;
    }
    var loc = Guppy.get_loc(x,y,sel_cursor,sel_caret);
    if(!loc) return;
    this.engine.select_to(loc, sel_cursor, sel_caret, mouse);
}


window.addEventListener("mousedown",Guppy.mouse_down, false);
window.addEventListener("mouseup",Guppy.mouse_up, false);
window.addEventListener("mousemove",Guppy.mouse_move, false);

Guppy.prototype.render_node = function(t){
    // All the interesting work is done by transform.  This function just adds in the cursor and selection-start cursor
    var output = "";
    if(t == "render"){
        var root = this.engine.doc.root();
        this.engine.add_paths(root,"m");
        this.engine.temp_cursor = this.temp_cursor;
        this.engine.add_classes_cursors(root);
        this.engine.current.setAttribute("current","yes");
        if(this.temp_cursor.node) this.temp_cursor.node.setAttribute("temp","yes");
        output = this.engine.get_content("latex",true);
        this.engine.remove_cursors_classes(root);
        output = output.replace(new RegExp('&amp;','g'), '&');
        return output;
    }
    else{
        output = this.engine.get_content(t);
    }
    return output
}

/** 
    Render the document
    @memberof Guppy
    @param {boolean} [updated=false] - Whether there have been visible
    changes to the document (i.e. that affect the positions of
    elements)
*/
Guppy.prototype.render = function(updated){
    if(!this.editor_active && this.engine.doc.is_blank()){
        katex.render(this.engine.setting("empty_content"),this.editor);
        this.editor.appendChild(this.buttons_div);
        return;
    }
    var tex = this.render_node("render");
    katex.render(tex,this.editor);
    this.editor.appendChild(this.buttons_div);
    if(updated){
        this.recompute_locations_paths();
    }
}

/** 
    Get the content of the editor as LaTeX
    @memberof Guppy
*/
Guppy.prototype.latex = function(){
    return this.engine.get_content("latex");
}

/** 
    Get the content of the editor as XML
    @memberof Guppy
*/
Guppy.prototype.xml = function(){
    return this.engine.get_content("xml");
}

/** 
    Get the content of the editor as a syntax tree, serialised using JSON
    @memberof Guppy
*/
Guppy.prototype.syntax_tree = function(){
    return this.engine.get_content("ast");
}

/** 
    Get the content of the editor as a list of equations, serialised
    using JSON.  For example, `x < y = z` will be returned as `[["<", [["var", "x"], ["var", "y"]]],["=", [["var", "y"], ["var", "z"]]]]
    @memberof Guppy
*/
Guppy.prototype.equations = function(){
    return this.engine.get_content("eqns");
}

/** 
    Get the content of the editor in a parseable text format.
    @memberof Guppy
*/
Guppy.prototype.text = function(){
    return this.engine.get_content("text");
}


/** 
    Get the content of the editor in AsciiMath.
    @memberof Guppy
*/
Guppy.prototype.asciimath = function(){
    return this.engine.get_content("asciimath");
}

/** 
    Get the Doc object representing the editor's contents.
    @memberof Guppy
*/
Guppy.prototype.doc = function(){
    return this.engine.doc;
}

/** 
    Get the content of the editor as a Javascript function, with
    user-supplied interpretations of the various symbols.  If not
    supplied, default interpretations will be given for the following
    symbols: `*,+,/,-,^,sqrt,sin,cos,tan,log`
    @param {Object} [evaluators] - An object with a key for each
    possible symbol type ("exponential", "integral", etc.)
    whose values are functions.  These functions take in a single
    argument, `args`, which is an array of that symbol's arguments,
    and should return a function that takes in an object argument
    `vars`.  In this inner function, to compute e.g. the sum of the
    first and second arguments, you would do
    `args[0](vars)+args[1](vars)`.  This function should return the
    result of that symbol's operation.  
    @returns {function(Object)} - Returns a function that takes in an
    object with a key for each variable in the expression and whose
    values are the values that will be passed in for those variables.
    In addition, this function is augmented with a `vars` member which
    is a list of the variables that appear in the expression.
    @memberof Guppy
*/
Guppy.prototype.func = function(evaluators){
    var res = this.engine.get_content("function", evaluators);
    var f = res['function'];
    f.vars = res.vars;
    return f;
}

/** 
    Recursively evaluate the syntax tree of the editor's contents using specified functions.
    @param {Object} [evaluators] - An object with a key for each
    possible symbol type ("exponential", "integral", etc.)
    whose values are functions that will be applied whenever that
    symbol is encountered in the syntax tree.  These functions take a
    single argument, `args`, which is a list of the results of
    evaluating that symbol's arguments.  
    @returns - Whatever the `evaluators` function for the root symbol
    in the syntax tree returns.
    @memberof Guppy
*/
Guppy.prototype.evaluate = function(evaluators){
    return this.engine.doc.evaluate(evaluators);
}

/** 
    Get a list of the symbols used in the document, in order of
    appearance, with each kind of symbol appearing only once.  For
    example, a document representing `sin(x^3)+sqrt(x^2+x)` will
    have symbols `["sin","exponential","square_root"]`.
    @param {String[]} [groups] - A list of the groups whose symbols
    may be included in the output.  If absent, all symbols in the
    document will be returned.
    @memberof Guppy
*/
Guppy.prototype.symbols_used = function(groups){
    return this.engine.doc.get_symbols(groups);
}

/** 
    Get a list of the variable names used in the document.  
    @memberof Guppy
*/
Guppy.prototype.vars = function(){
    return this.engine.get_content("function").vars;
}

/** 
    Set the content of the document from text in the format outputted by `guppy.text()`.
    @param {String} text - A string representing the document to import.
    @memberof Guppy
*/
Guppy.prototype.import_text = function(text){
    return this.engine.import_text(text);
}

/** 
    Set the content of the document from input text in "semantic
    LaTeX" format.  That is, all functions are represented as
    `\funcname{arg1}{arg2}`.  For example,
    `\defintegral{1}{2}{x^2}{x}`.
    @param {String} text - A string representing the document to import.
    @memberof Guppy
*/
Guppy.prototype.import_latex = function(text){
    return this.engine.import_latex(text);
}

/** 
    Set the content of the document from XML in the format outputted
    by `guppy.xml()`.
    @param {String} xml - An XML string representing the document to
    import.
    @memberof Guppy
*/
Guppy.prototype.import_xml = function(xml){
    return this.engine.set_content(xml);
}

/** 
    Import a syntax tree from a JSON object formatted as outputted by `guppy.syntax_tree()`.
    @param {Object} tree - A JSON object representing the syntax tree to import.
    @memberof Guppy
*/
Guppy.prototype.import_syntax_tree = function(tree){
    return this.engine.import_ast(tree);
}

/** 
    Focus this instance of the editor
    @memberof Guppy
*/
Guppy.prototype.activate = function(){
    Guppy.active_guppy = this;
    this.editor_active = true;
    this.editor.className = this.editor.className.replace(new RegExp('(\\s|^)guppy_inactive(\\s|$)'),' guppy_active ');
    this.editor.focus();
    if(this.ready){
        this.render(true);
        this.engine.fire_event("focus",{"focused":true});
    }
}

/** 
    Unfocus this instance of the editor
    @memberof Guppy
*/
Guppy.prototype.deactivate = function(){
    this.editor_active = false;
    var r1 = new RegExp('(?:\\s|^)guppy_active(?:\\s|$)');
    var r2 = new RegExp('(?:\\s|^)guppy_inactive(?:\\s|$)');
    if(this.editor.className.match(r1)){
        this.editor.className = this.editor.className.replace(r1,' guppy_inactive ');
    }
    else if(!this.editor.className.match(r2)){
        this.editor.className += ' guppy_inactive ';
    }
    Guppy.kb.shift_down = false;
    Guppy.kb.ctrl_down = false;
    Guppy.kb.alt_down = false;
    if(this.ready){
        this.render();
        this.engine.fire_event("focus",{"focused":false});
    }
}


// Keyboard stuff

Guppy.kb = {};

Guppy.kb.is_mouse_down = false;

/* keyboard behaviour definitions */

// keys aside from 0-9,a-z,A-Z
Guppy.kb.k_chars = {
    "+":"+",
    "-":"-",
    "*":"*",
    ".":".",
    "shift+/":"/",
    "shift+=":"+",
};
Guppy.kb.k_text = {
    "/":"/",
    "*":"*",
    "(":"(",
    ")":")",
    "<":"<",
    ">":">",
    "|":"|",
    "!":"!",
    ",":",",
    ".":".",
    ";":";",
    "=":"=",
    "[":"[",
    "]":"]",
    "@":"@",
    "'":"'",
    "`":"`",
    ":":":",
    "\"":"\"",
    "shift+/":"?",
    "space":" ",
};
Guppy.kb.k_controls = {
    "up":"up",
    "down":"down",
    "right":"right",
    "left":"left",
    "alt+k":"up",
    "alt+j":"down",
    "alt+l":"right",
    "alt+h":"left",
    "space":"spacebar",
    "home":"home",
    "end":"end",
    "backspace":"backspace",
    "del":"delete_key",
    "mod+a":"sel_all",
    "mod+c":"sel_copy",
    "mod+x":"sel_cut",
    "mod+v":"sel_paste",
    "mod+z":"undo",
    "mod+y":"redo",
    "enter":"done",
    "mod+shift+right":"list_extend_copy_right",
    "mod+shift+left":"list_extend_copy_left",
    ",":"list_extend_right",
    ";":"list_extend_down",
    "mod+right":"list_extend_right",
    "mod+left":"list_extend_left",
    "mod+up":"list_extend_up",
    "mod+down":"list_extend_down",
    "mod+shift+up":"list_extend_copy_up",
    "mod+shift+down":"list_extend_copy_down",
    "mod+backspace":"list_remove",
    "mod+shift+backspace":"list_remove_row",
    "shift+left":"sel_left",
    "shift+right":"sel_right",
    ")":"right_paren",
    "\\":"backslash",
    "tab":"tab"
};

// Will populate keyboard shortcuts for symbols from symbol files
Guppy.kb.k_syms = {};

var i = 0;

// letters

for(i = 65; i <= 90; i++){
    Guppy.kb.k_chars[String.fromCharCode(i).toLowerCase()] = String.fromCharCode(i).toLowerCase();
    Guppy.kb.k_chars['shift+'+String.fromCharCode(i).toLowerCase()] = String.fromCharCode(i).toUpperCase();
}

// numbers

for(i = 48; i <= 57; i++)
    Guppy.kb.k_chars[String.fromCharCode(i)] = String.fromCharCode(i);

Guppy.register_keyboard_handlers = function(){
    Mousetrap.addKeycodes({173: '-'}); // Firefox's special minus (needed for _ = sub binding)
    var i, name;
    // Pull symbol shortcuts from Symbols:
    for(name in Symbols.symbols){
	var s = Symbols.symbols[name];
	if(s.keys)
	    for(i = 0; i < s.keys.length; i++)
		Guppy.kb.k_syms[s.keys[i]] = s.attrs.type;
    }
    for(i in Guppy.kb.k_chars)
        Mousetrap.bind(i,function(i){ return function(){
            if(!Guppy.active_guppy) return true;
            Guppy.active_guppy.temp_cursor.node = null;
            if(Utils.is_text(Guppy.active_guppy.engine.current) && Guppy.kb.k_text[i]){
                Guppy.active_guppy.engine.insert_string(Guppy.kb.k_text[i]);
            }
            else{
                Guppy.active_guppy.engine.insert_string(Guppy.kb.k_chars[i]);
            }
            Guppy.active_guppy.render(true);
            return false;
        }}(i));
    for(i in Guppy.kb.k_syms)
        Mousetrap.bind(i,function(i){ return function(){
            if(!Guppy.active_guppy) return true;
            Guppy.active_guppy.temp_cursor.node = null;
            // We always want to skip using this symbol insertion if
            // we are in text mode, and additionally we want only to
            // insert the corresponding text if there is an overriding
            // text representation in Guppy.kb.k_text
            if(Utils.is_text(Guppy.active_guppy.engine.current)){
                if(Guppy.kb.k_text[i]) Guppy.active_guppy.engine.insert_string(Guppy.kb.k_text[i]);
            }
            else{
                Guppy.active_guppy.engine.space_caret = 0;
                //Guppy.active_guppy.engine.insert_symbol(Guppy.kb.k_syms[i]);
    		Guppy.active_guppy.engine.insert_symbol(Symbols.lookup_type(Guppy.kb.k_syms[i]));
            }
            Guppy.active_guppy.render(true);
            return false;
        }}(i));
    for(i in Guppy.kb.k_controls)
        Mousetrap.bind(i,function(i){ return function(){
            if(!Guppy.active_guppy) return true;
            // We want to skip using this control sequence only if there is an overriding text representation in Guppy.kb.k_text
            if(Utils.is_text(Guppy.active_guppy.engine.current) && Guppy.kb.k_text[i]){
                Guppy.active_guppy.engine.insert_string(Guppy.kb.k_text[i]);
            }
            else{
                Guppy.active_guppy.engine.space_caret = 0;
                Guppy.active_guppy.engine[Guppy.kb.k_controls[i]]();
                Guppy.active_guppy.temp_cursor.node = null;
            }
            Guppy.active_guppy.render(["up","down","right","left","home","end","sel_left","sel_right"].indexOf(i) < 0);
            //Guppy.active_guppy.render(false);
            return false;
        }}(i));
    for(i in Guppy.kb.k_text)
        if(!(Guppy.kb.k_chars[i] || Guppy.kb.k_syms[i] || Guppy.kb.k_controls[i])){
            Mousetrap.bind(i,function(i){ return function(){
                if(!Guppy.active_guppy) return true;
                Guppy.active_guppy.temp_cursor.node = null;
                if(Utils.is_text(Guppy.active_guppy.engine.current)){
                    Guppy.active_guppy.engine.insert_string(Guppy.kb.k_text[i]);
                    Guppy.active_guppy.render(true);
                }
                return false;
            }}(i));
        }
}

module.exports = Guppy;

},{"../lib/katex/katex-modified.min.js":"/usr/var/server.base/node_modules/guppy-dev/lib/katex/katex-modified.min.js","../lib/mousetrap/mousetrap.min.js":"/usr/var/server.base/node_modules/guppy-dev/lib/mousetrap/mousetrap.min.js","./doc.js":"/usr/var/server.base/node_modules/guppy-dev/src/doc.js","./engine.js":"/usr/var/server.base/node_modules/guppy-dev/src/engine.js","./settings.js":"/usr/var/server.base/node_modules/guppy-dev/src/settings.js","./symbols.js":"/usr/var/server.base/node_modules/guppy-dev/src/symbols.js","./utils.js":"/usr/var/server.base/node_modules/guppy-dev/src/utils.js"}],"/usr/var/server.base/node_modules/guppy-dev/src/parser.js":[function(require,module,exports){
var Parser = function(token_types){
    var self = this;
    this.token_types = token_types;
    this.symbol_table = {};

    this.original_symbol = {
        nud: function () { throw Error("Undefined"); },
        led: function () { throw Error("Missing operator"); }
    };

    this.mul = function(left){ return ["*", [left, this.nud()]]; };
    
    this.symbol = function (id, bp) {
        var s = self.symbol_table[id];
        bp = bp || 0;
        if (s) {
            if (bp >= s.lbp) {
                s.lbp = bp;
            }
        } else {
            s = Object.create(self.original_symbol);
            s.id = s.value = id;
            s.lbp = bp;
            s.parent = self;
            self.symbol_table[id] = s;
        }
        return s;
    };
    
    this.advance = function (id) {
        var a, o, t, v;
        if (id && this.token.id !== id) {
            throw Error("Expected '" + id + "'");
        }
        if (self.token_nr >= self.tokens.length) {
            self.token = this.symbol_table["(end)"];
            return;
        }
        t = self.tokens[self.token_nr];
        self.token_nr += 1;
        v = t.value;
        var args = null;
        a = t.type;
        if (a === "name") {
            o = this.symbol_table["(var)"];
        } else if (a === "operator") {
            o = this.symbol_table[v];
            if (!o) {
                throw Error("Unknown operator");
            }
        } else if (a === "pass") {
            a = "pass";
            o = this.symbol_table["(pass)"];
            args = t.args;
        } else if (a === "number") {
            a = "literal";
            o = this.symbol_table["(literal)"];
        } else if (a === "function") {
            a = "function";
            o = this.symbol_table["(function)"];
            args = t.args;
        } else {
            throw Error("Unexpected token",t);
        }
        self.token = Object.create(o);
        self.token.type = a;
        self.token.value = v;
        if(args) self.token.args = args;
        return self.token;
    };

    this.expression = function (rbp) {
        var left;
        var t = self.token;
        self.advance();
        left = t.nud();
        while (rbp < self.token.lbp) {
            t = self.token;
            self.advance();
            left = t.led(left);
        }
        return left;
    };

    this.infix = function (id, bp, led) {
        var s = this.symbol(id, bp);
        s.led = led || function (left) {
            return [this.value, [left, self.expression(bp)]];
        };
        return s;
    };
    
    this.prefix = function (id, nud) {
        var s = self.symbol(id);
        s.nud = nud || function () {
            return [this.value, [self.expression(70)]];
        };
        return s;
    }

    this.symbol("(end)");
    var s = null;
    
    s = this.symbol("(blank)", 60);
    s.nud = function(){ return ["blank"];};

    s = this.symbol("(function)", 60);
    s.led = this.mul;
    s.nud = function(){ return [this.value, this.args || []];};
    
    s = this.symbol("(literal)", 60);
    s.led = this.mul;
    s.nud = function(){ return ["val", [this.value]] };

    s = this.symbol("(pass)", 60);
    s.led = this.mul;
    s.nud = function(){ return this.args[0] };
    
    s = this.symbol("(var)", 60);
    s.led = this.mul;
    s.nud = function(){ return ["var", [this.value]] };
        
    this.token_nr = 0;
    this.tokens = [];
    
    this.infix("=", 40);
    this.infix("!=", 40);
    this.infix("<", 40);
    this.infix(">", 40);
    this.infix("<=", 40);
    this.infix(">=", 40);
    this.infix("+", 50);
    this.infix("-", 50);
    this.infix("*", 60);
    this.infix("/", 60);
    this.infix("!", 70, function(left){ return ["factorial", [left]]; });
    this.infix("^", 70, function(left){ return ["exponential", [left, self.expression(70)]]; });
    this.infix("_", 70, function(left){ return ["subscript", [left, self.expression(70)]]; });
    this.infix("(", 80, self.mul);
    this.symbol("(").nud = function(){ var ans = self.expression(0); self.advance(")"); return ans; }
    this.symbol(")");
    this.symbol("{").nud = function(){ var ans = self.expression(0); self.advance("}"); return ans; }
    this.symbol("}");
    this.symbol(",");
    this.prefix("-");

    this.tokenise_and_parse = function(str){
        return this.parse(this.tokenise(str));
    }
    
    this.parse = function(tokens){
        this.tokens = tokens;
        this.token_nr = 0;
        if(this.tokens.length == 0) return ["blank"];
        this.advance();
        return this.expression(10);
    }
}

Parser.prototype.tokenise = function(text){
    var ans = [];
    while(text.length > 0){
        var ok = false;
        for(var i = 0; i < this.token_types.length; i++){
            var t = this.token_types[i];
            var re = RegExp(t.re);
            var m = re.exec(text);
            if(m){
                m = m[0];
                text = text.substring(m.length);
                ok = true;
                if(t.type != "space") ans.push({"type":t.type, "value": t.value(m)})
                break;
            }
        }
        if(!ok){
            return [];
        }
    }
    return ans;
}

var EParser = new Parser([
    {"type":"number", "re":"^[0-9.]+", "value":function(m){
        if(isNaN(Number(m))) throw Error("Invalid number: "+m);
        return Number(m);
    }},
    {"type":"operator", "re":"^(<=|>=|!=|>|<|=)", "value":function(m){return m}},
    {"type":"operator", "re":"^[-+*/!]", "value":function(m){return m}},
    {"type":"name", "re":"^[a-zA-Z]", "value":function(m){return m}},
    {"type":"space", "re":"^\\s+", "value":function(m){return m}}
]);

var TextParser = new Parser([
    {"type":"number", "re":"^[0-9.]+", "value":function(m){
        if(isNaN(Number(m))) throw Error("Invalid number: "+m);
        return Number(m);
    }},
    {"type":"operator", "re":"^(!=|>=|<=)", "value":function(m){return m;}},
    {"type":"operator", "re":"^[-+*/,!()=<>_^]", "value":function(m){return m}},
    {"type":"name", "re":"^[a-zA-Z_]*[a-zA-Z]", "value":function(m){return m}},
    {"type":"comma", "re":"^,", "value":function(m){return m}},
    {"type":"space", "re":"^\\s+", "value":function(m){return m}}
]);


var s = TextParser.symbol("(var)", 60);
s.led = TextParser.mul;
s.nud = function(){
    if(this.parent.token.id == "("){
        var args = [];
        TextParser.advance()
        if(this.parent.token.id !== ")"){
            while(true){
                args.push(TextParser.expression(0));
                if (this.parent.token.id !== ",") {
                    break;
                }
                TextParser.advance(",");
            }
        }
        TextParser.advance(")");
        return [this.value, args];
    }
    else{
        return ["var", [this.value]]
    }
};

var LaTeXParser = new Parser([
    {"type":"number", "re":"^[0-9.]+", "value":function(m){
        if(isNaN(Number(m))) throw Error("Invalid number: "+m);
        return Number(m);
    }},
    {"type":"operator", "re":"^(!=|>=|<=)", "value":function(m){return m;}},
    {"type":"operator", "re":"^[-+*/,!()=<>_^}{]", "value":function(m){return m}},
    {"type":"name", "re":"^[a-zA-Z_]*[a-zA-Z]", "value":function(m){return m}},
    {"type":"name", "re":"^\\\\[a-zA-Z]*[a-zA-Z]", "value":function(m){return m.substring(1)}},
    {"type":"space", "re":"^\\s+", "value":function(m){return m}}
]);

s = LaTeXParser.symbol("(var)", 60);
s.led = LaTeXParser.mul;
s.nud = function(){
    var args = [];
    
    while(this.parent.token.id == "{"){
        LaTeXParser.advance()
        if(this.parent.token.id !== "}"){
            args.push(LaTeXParser.expression(0));
            LaTeXParser.advance("}");
        }
    }
    if(args.length > 0) return [this.value, args];
    else return ["var", [this.value]]
};

module.exports = {"Parser":Parser,
                  "TextParser":TextParser,
                  "LaTeXParser":LaTeXParser,
                  "EParser": EParser};


},{}],"/usr/var/server.base/node_modules/guppy-dev/src/settings.js":[function(require,module,exports){
var katex = require('../lib/katex/katex-modified.min.js');
var Symbols = require('./symbols.js');
var Settings = {}
Settings.config = {};
Settings.config.path = "/lib/guppy";
Settings.config.events = {};
Settings.config.settings = {
    "autoreplace":"auto",
    "empty_content":"\\blue{[?]}",
    "blank_caret":"",
    "blacklist":[],
    "buttons":["osk","settings","symbols","controls"],
    "cliptype":"latex",
};

Settings.settings_options = {
    "autoreplace":["auto","whole","delay","none"],
    "cliptype":["latex","text","xml","ast","asciimath"],
};

Settings.panels = {};
Settings.panels.controls = document.createElement("div");
Settings.panels.controls.setAttribute("class","guppy_help");
Settings.panels.controls.style = "padding:10px;border:1px solid black; background-color: #fff;position:absolute;top:0;left:0;display:none;";
Settings.panels.controls.innerHTML = "<p>Start typing the name of a mathematical function to automatically insert it.  </p><p>(For example, \"sqrt\" for root, \"mat\" for matrix, or \"defi\" for definite integral.)</p>\n\
<style>div.guppy_help td{ vertical-align:top;padding: 2px;}</style>\n\
<h3>Controls</h3><table id=\"guppy_help_table\"><tr><td><b>Press...</b></td><td><b>...to do</b></td></tr></table>";

Settings.panels.symbols = document.createElement("div");
Settings.panels.symbols.setAttribute("class","guppy_help");
Settings.panels.symbols.style = "padding:10px;border:1px solid black; background-color: #fff;position:absolute;top:0;left:0;display:none;";
Settings.panels.symbols.innerHTML = "<p>Start typing the name of a mathematical function to automatically insert it.  </p><p>(For example, \"sqrt\" for root, \"mat\" for matrix, or \"defi\" for definite integral.)</p>\n\
<style>div.guppy_help td{ vertical-align:top;padding: 2px;}</style>\n\
<h3>Symbols</h3><table id=\"guppy_syms_table\"><tr><td><b>Type...</b></td><td><b>...to get</b></td></tr></table>";

Settings.panels.settings = document.createElement("div");
Settings.panels.settings.setAttribute("class","guppy_help");
Settings.panels.settings.style = "padding:10px;border:1px solid black; background-color: #fff;position:absolute;top:0;left:0;display:none;";
Settings.panels.settings.innerHTML = "<p>Global settings: </p>\n\
<style>div.guppy_help td{ vertical-align:top;padding: 2px;}</style>\n\
<h3>Settings</h3><table id=\"guppy_settings_table\"></table>";

Settings.div_names = ["controls","symbols","settings"];

var make_row = function(table_id, c1, c2){
    var row = document.createElement("tr");
    row.innerHTML = "<td><font face=\"monospace\">"+c1+"</font></td><td>"+c2+"</td>";
    document.getElementById(table_id).appendChild(row);
    return row;
}

var make_x = function(elt){
    var x = document.createElement("div");
    x.setAttribute("class","guppy-card-x");
    x.innerHTML = "<font size=\"6pt\">&times;</font>";
    x.style = "cursor:pointer;position:absolute;top:0;right:0;padding-right:5px;line-height:1;";
    x.onclick = function(){ elt.style.display = "none"; }
    elt.appendChild(x);
}

Settings.hide_all = function(){
    for(var i = 0; i < Settings.div_names.length; i++)
        Settings.panels[Settings.div_names[i]].style.display = "none";
}

Settings.toggle = function(card, g){
    if(Settings.div_names.indexOf(card) >= 0){
        Settings.init_card(card, g);
        if(Settings.panels[card].style.display == "none"){
            Settings.hide_all();
            var r = g.editor.getBoundingClientRect();
            Settings.panels[card].style.top = (r.bottom+document.documentElement.scrollTop) + "px";
            Settings.panels[card].style.left = (r.left+document.documentElement.scrollLeft) + "px";
            Settings.panels[card].style.display = "block";
        }
        else{
            Settings.hide_all();
        }
    }
}

Settings.init_card = function(card, g){
    if(card == "settings"){
        document.getElementById("guppy_settings_table").innerHTML = "";
        for(var s in Settings.settings_options){
            var opt = Settings.settings_options[s];
            var val = g.engine.setting(s);
            var sel = document.createElement("select");
            sel.setAttribute("selected", val);
            sel.setAttribute("id","guppy_settings_select_"+s);
            sel.onchange = function(ss){
                return function(){
                    Settings.config.settings[ss] = document.getElementById("guppy_settings_select_"+ss).value;
                }
            }(s);
            for(var i = 0; i < opt.length; i++){
                var o = document.createElement("option");
                o.setAttribute("value",opt[i]);
                o.innerHTML = opt[i];
                sel.appendChild(o);
            }
            var row = document.createElement("tr");
            row.innerHTML = "<td><font face=\"monospace\">"+s+"</font></td>";
            var td = document.createElement("td");
            td.appendChild(sel);
            row.appendChild(td);
            document.getElementById("guppy_settings_table").appendChild(row);
        }
    }
}

Settings.init = function(symbols){
    for(var i = 0; i < Settings.div_names.length; i++){
        make_x(Settings.panels[Settings.div_names[i]]);
        document.body.appendChild(Settings.panels[Settings.div_names[i]])
    }
    
    make_row("guppy_help_table","left/right arrows","Move cursor");
    make_row("guppy_help_table","shift+left/right arrows","Select region")
    make_row("guppy_help_table","ctrl+a","Select all");
    make_row("guppy_help_table","ctrl+x/c/v","Cut/copy/paste");
    make_row("guppy_help_table","ctrl+z/y","Undo/redo");
    make_row("guppy_help_table","ctrl+left/right","Add entry to list or column to matrix");
    make_row("guppy_help_table","shift+ctrl+left/right","Add copy of current entry/column to to list/matrix");
    make_row("guppy_help_table","ctrl+up/down","Add row to matrix");
    make_row("guppy_help_table","shift+ctrl+up/down","Add copy of current row to matrix");
    make_row("guppy_help_table","ctrl+backspace","Delete current entry in list or column in matrix");
    make_row("guppy_help_table","ctrl+shift+backspace","Delete current row in matrix");

    
    
    for(var s in symbols){
        var latex = Symbols.add_blanks(symbols[s].output.latex, "\\blue{[?]}");
        var row = make_row("guppy_syms_table",s," ");
        katex.render(latex, row.lastChild);
    }
}

module.exports = Settings;

},{"../lib/katex/katex-modified.min.js":"/usr/var/server.base/node_modules/guppy-dev/lib/katex/katex-modified.min.js","./symbols.js":"/usr/var/server.base/node_modules/guppy-dev/src/symbols.js"}],"/usr/var/server.base/node_modules/guppy-dev/src/symbols.js":[function(require,module,exports){
var Version = require('./version.js');
var Symbols = {"symbols":{}, "templates":{}};

Symbols.make_template_symbol = function(template_name, name, args){
    var template = JSON.parse(JSON.stringify(Symbols.templates[template_name]));
    return Symbols.eval_template(template, name, args);
}

Symbols.eval_template = function(template, name, args){
    args['name'] = name;
    if(Object.prototype.toString.call(template) == "[object String]") {
        var ans = template;
        for(var nam in args) {
            ans = ans.replace(new RegExp("\\{\\$"+nam+"\\}"),args[nam]);
        }
        return ans;
    }
    else {
        for(var x in template) {
            template[x] = Symbols.eval_template(template[x], name, args)
        }
        return template;
    }
}

Symbols.lookup_type = function(type){
    for(var s in Symbols.symbols){
        if(Symbols.symbols[s].attrs.type == type) return s;
    }
}

Symbols.add_symbols = function(syms){
    var version = syms["_version"];
    var collection_name = syms["_name"];
    delete syms["_version"];
    delete syms["_name"];
    if(!version || version != Version.SYMBOL_VERSION) Version.SYMBOL_ERROR(collection_name, version);
    var templates = syms["_templates"];
    if(templates){
        for(var t in templates){
            Symbols.templates[t] = templates[t];
        }
        delete syms["_templates"];
    }
    for(var s in syms){
        if(syms[s].template){
            for(var v in syms[s].values){
                var name = null;
                var args = null;
                if(Object.prototype.toString.call(syms[s].values) == "[object Array]"){
                    name = syms[s].values[v];
                    args = {}
                }
                else{
                    name = v;
                    args = syms[s].values[v];
                }
                Symbols.symbols[name] = Symbols.make_template_symbol(syms[s].template, name, args);
            }
        }
        else{
            Symbols.symbols[s] = syms[s];
        }
    }
}

Symbols.validate = function(){
    for(var sym in Symbols.symbols){
	if(!Symbols.symbols[sym].output.latex) throw "Symbol " + sym + " missing output.latex (needed for display)";
	if(!Symbols.symbols[sym].attrs.name) throw "Symbol " + sym + " missing attrs.name (needed for text output)";
	if(!Symbols.symbols[sym].attrs.group) throw "Symbol " + sym + " missing attrs.group (needed for mobile)";
        //for(var i = 0; i < sym.length; i++)
        //    if(sym.substring(0,i) in Symbols.symbols) throw "WARNING: Symbols are not prefix free: '" + sym.substring(0,i) + "' and '" + sym + "' are both symbols";
    }
}

// Returns an array with alternating text and argument elements of the form
// {"type":"text", "val":the_text} or {"type":"arg", "index":the_index, "seperators":[sep1,sep2,...]}
Symbols.split_output = function(output){
    var regex = /\{\$([0-9]+)/g, result, starts = [], indices = [], i;
    var ans = [];
    while ((result = regex.exec(output))){
        starts.push(result.index);
        indices.push(parseInt(result[1]));
    }
    ans.push({"type":"text","val":output.substring(0,starts.length > 0 ? starts[0] : output.length)}); // Push the first text bit
    for(i = 0; i < starts.length; i++){
        var idx = starts[i]+1;
        var separators = [];
        var sep = "";
        var opens = 1
        while(opens > 0 && idx < output.length){
            if(output[idx] == "}"){
                if(opens == 2){ separators.push(sep); sep = ""; }
                opens--; }
            if(opens >= 2){ sep += output[idx]; }
            if(output[idx] == "{"){ opens++; }
            idx++;
        }
        ans.push({"type":"arg","index":indices[i],"separators":separators});
        var next = (i == starts.length - 1) ? output.length : starts[i+1];
        ans.push({"type":"text","val":output.substring(idx,next)}); // Push the next text bit
    }
    return ans;
}

Symbols.add_blanks = function(output, blank){
    var out = Symbols.split_output(output);
    var ans = "";
    for(var i = 0; i < out.length; i++){
        if(out[i]["type"] == "text"){
            ans += out[i]['val'];
        }
        else ans += blank;
    }
    return ans;
}

Symbols.symbol_to_node = function(s, content, base){
    
    // s is a symbol
    //
    // content is a list of nodes to insert
    var f = base.createElement("f");
    for(var attr in s.attrs){
        f.setAttribute(attr, s.attrs[attr]);
    }
    if("ast" in s){
        if("type" in s.ast) f.setAttribute("ast_type",s.ast["type"])
        if("value" in s.ast) f.setAttribute("ast_value",s.ast["value"])
    }
    //if(s['char']) f.setAttribute("c","yes");
    
    var first_ref=-1, arglist = [];
    var first, i;
    
    // Make the b nodes for rendering each output    
    for(var t in s["output"]){
        var b = base.createElement("b");
        b.setAttribute("p",t);

        var out = Symbols.split_output(s["output"][t]);
        for(i = 0; i < out.length; i++){
            if(out[i]["type"] == "text"){
                if(out[i]["val"].length > 0) b.appendChild(base.createTextNode(out[i]['val']));
            }
            else{
                if(t == 'latex') arglist.push(out[i]);
                var nt = base.createElement("r");
                nt.setAttribute("ref",out[i]["index"]);
                if(out[i]["separators"].length > 0) nt.setAttribute("d",out[i]["separators"].length);
                for(var j = 0; j < out[i]["separators"].length; j++) nt.setAttribute("sep"+j,out[i]["separators"][j]);
                if(t == 'latex' && first_ref == -1) first_ref = out[i]["index"];
                b.appendChild(nt);
            }
        }
        f.appendChild(b);
    }
    // Now make the c/l nodes for storing the content
    for(i = 0; i < arglist.length; i++){
        var a = arglist[i];
        var nc;
        if(i in content && a['separators'].length > 0) {  // If the content for this node is provided and is an array, then dig down to find the first c child
            f.appendChild(content[i][0]);
            nc = content[i][0];
            while(nc.nodeName != "c")
                nc = nc.firstChild;
        }
        else if(i in content) {                                  // If the content for this node is provided and not an array, create the c node and populate its content
            var node_list = content[i];
            nc = base.createElement("c");
            for(var se = 0; se < node_list.length; se++)
                nc.appendChild(node_list[se].cloneNode(true));
            f.appendChild(nc)
        }
        else{                                             // Otherwise create the c node and possibly l nodes
            nc = base.createElement("c");
            var new_e = base.createElement("e");
            new_e.appendChild(base.createTextNode(""));
            nc.appendChild(new_e);
            var par = f;                                  // Now we add nested l elements if this is an array of dimension > 0
            for(j = 0; j < a['separators'].length; j++){
                var nl = base.createElement("l");
                nl.setAttribute("s","1");
                par.appendChild(nl);
                par = nl;
            }
            par.appendChild(nc);
        }
        if(i+1 == first_ref) first = nc.lastChild;        // Note the first node we should visit based on the LaTeX output
        if(s['args'] && s['args'][i]){                    // Set the arguments for the c node based on the symbol
            for(var arg in s['args'][i]){
                nc.setAttribute(arg,s['args'][i][arg]);
            }
        }
    }
    return {"f":f, "first":first, "args":arglist};
}


module.exports = Symbols;

},{"./version.js":"/usr/var/server.base/node_modules/guppy-dev/src/version.js"}],"/usr/var/server.base/node_modules/guppy-dev/src/utils.js":[function(require,module,exports){
var Utils = {};

Utils.CARET = "\\cursor[-0.2ex]{0.7em}"
Utils.TEMP_SMALL_CARET = "\\cursor{0.7ex}"
Utils.TEMP_CARET = "\\cursor[-0.2ex]{0.7em}"
Utils.SMALL_CARET = "\\cursor{0.7ex}"
Utils.SEL_CARET = "\\cursor[-0.2ex]{0.7em}"
Utils.SMALL_SEL_CARET = "\\cursor{0.7ex}"
Utils.SEL_COLOR = "red"

Utils.is_blank = function(n){
    return n.firstChild == null || n.firstChild.nodeValue == '';
}

Utils.get_length = function(n){
    if(Utils.is_blank(n) || n.nodeName == 'f') return 0
    return n.firstChild.nodeValue.length;
}

Utils.path_to = function(n){
    var name = n.nodeName;
    if(name == "m") return "guppy_loc_m";
    var ns = 0;
    for(var nn = n; nn != null; nn = nn.previousSibling) if(nn.nodeType == 1 && nn.nodeName == name) ns++;
    return Utils.path_to(n.parentNode)+"_"+name+""+ns;
}

Utils.is_text = function(nn){
    return nn.parentNode.hasAttribute("mode") && (nn.parentNode.getAttribute("mode") == "text" || nn.parentNode.getAttribute("mode") == "symbol");
}

Utils.is_char = function(nn){
    for(var n = nn.firstChild; n; n = n.nextSibling){
	if(n.nodeName == "c" || n.nodeName == "l") return false;
    }
    return true;
}

Utils.is_symbol = function(nn){
    return nn.parentNode.getAttribute("mode") && nn.parentNode.getAttribute("mode") == "symbol";
}

Utils.is_small = function(nn){
    var n = nn.parentNode;
    while(n != null && n.nodeName != 'm'){
        if(n.getAttribute("small") == "yes"){
            return true;
        }
        n = n.parentNode
        while(n != null && n.nodeName != 'c')
            n = n.parentNode;
    }
    return false;
}

module.exports = Utils;

},{}],"/usr/var/server.base/node_modules/guppy-dev/src/version.js":[function(require,module,exports){
var Version = {}
Version.GUPPY_VERSION = "2.0.0-alpha.2";
Version.DOC_VERSION = "2.0.0-alpha.1";
Version.SYMBOL_VERSION = "2.0.0-alpha.2";

Version.DOC_ERROR = function(id, found_ver){
    throw Error("Document version mismatch for " + id + ": Found " + found_ver + ", required " + Version.DOC_VERSION + ".  To update your document, please see daniel3735928559.github.io/guppy/doc/version.html");
}

Version.SYMBOL_ERROR = function(id, found_ver){
    throw Error("Symbol version mismatch for " + id + ": Found " + found_ver + ", required " + Version.SYMBOL_VERSION + ".  To update your document, please see daniel3735928559.github.io/guppy/doc/version.html");
}
module.exports = Version

},{}],"/usr/var/server.base/node_modules/isotope-layout/js/isotope.js":[function(require,module,exports){
/*!
 * Isotope v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size',
        'desandro-matches-selector/matches-selector',
        'fizzy-ui-utils/utils',
        './item',
        './layout-mode',
        // include default layout modes
        './layout-modes/masonry',
        './layout-modes/fit-rows',
        './layout-modes/vertical'
      ],
      function( Outlayer, getSize, matchesSelector, utils, Item, LayoutMode ) {
        return factory( window, Outlayer, getSize, matchesSelector, utils, Item, LayoutMode );
      });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('outlayer'),
      require('get-size'),
      require('desandro-matches-selector'),
      require('fizzy-ui-utils'),
      require('./item'),
      require('./layout-mode'),
      // include default layout modes
      require('./layout-modes/masonry'),
      require('./layout-modes/fit-rows'),
      require('./layout-modes/vertical')
    );
  } else {
    // browser global
    window.Isotope = factory(
      window,
      window.Outlayer,
      window.getSize,
      window.matchesSelector,
      window.fizzyUIUtils,
      window.Isotope.Item,
      window.Isotope.LayoutMode
    );
  }

}( window, function factory( window, Outlayer, getSize, matchesSelector, utils,
  Item, LayoutMode ) {

'use strict';

// -------------------------- vars -------------------------- //

var jQuery = window.jQuery;

// -------------------------- helpers -------------------------- //

var trim = String.prototype.trim ?
  function( str ) {
    return str.trim();
  } :
  function( str ) {
    return str.replace( /^\s+|\s+$/g, '' );
  };

// -------------------------- isotopeDefinition -------------------------- //

  // create an Outlayer layout class
  var Isotope = Outlayer.create( 'isotope', {
    layoutMode: 'masonry',
    isJQueryFiltering: true,
    sortAscending: true
  });

  Isotope.Item = Item;
  Isotope.LayoutMode = LayoutMode;

  var proto = Isotope.prototype;

  proto._create = function() {
    this.itemGUID = 0;
    // functions that sort items
    this._sorters = {};
    this._getSorters();
    // call super
    Outlayer.prototype._create.call( this );

    // create layout modes
    this.modes = {};
    // start filteredItems with all items
    this.filteredItems = this.items;
    // keep of track of sortBys
    this.sortHistory = [ 'original-order' ];
    // create from registered layout modes
    for ( var name in LayoutMode.modes ) {
      this._initLayoutMode( name );
    }
  };

  proto.reloadItems = function() {
    // reset item ID counter
    this.itemGUID = 0;
    // call super
    Outlayer.prototype.reloadItems.call( this );
  };

  proto._itemize = function() {
    var items = Outlayer.prototype._itemize.apply( this, arguments );
    // assign ID for original-order
    for ( var i=0; i < items.length; i++ ) {
      var item = items[i];
      item.id = this.itemGUID++;
    }
    this._updateItemsSortData( items );
    return items;
  };


  // -------------------------- layout -------------------------- //

  proto._initLayoutMode = function( name ) {
    var Mode = LayoutMode.modes[ name ];
    // set mode options
    // HACK extend initial options, back-fill in default options
    var initialOpts = this.options[ name ] || {};
    this.options[ name ] = Mode.options ?
      utils.extend( Mode.options, initialOpts ) : initialOpts;
    // init layout mode instance
    this.modes[ name ] = new Mode( this );
  };


  proto.layout = function() {
    // if first time doing layout, do all magic
    if ( !this._isLayoutInited && this._getOption('initLayout') ) {
      this.arrange();
      return;
    }
    this._layout();
  };

  // private method to be used in layout() & magic()
  proto._layout = function() {
    // don't animate first layout
    var isInstant = this._getIsInstant();
    // layout flow
    this._resetLayout();
    this._manageStamps();
    this.layoutItems( this.filteredItems, isInstant );

    // flag for initalized
    this._isLayoutInited = true;
  };

  // filter + sort + layout
  proto.arrange = function( opts ) {
    // set any options pass
    this.option( opts );
    this._getIsInstant();
    // filter, sort, and layout

    // filter
    var filtered = this._filter( this.items );
    this.filteredItems = filtered.matches;

    this._bindArrangeComplete();

    if ( this._isInstant ) {
      this._noTransition( this._hideReveal, [ filtered ] );
    } else {
      this._hideReveal( filtered );
    }

    this._sort();
    this._layout();
  };
  // alias to _init for main plugin method
  proto._init = proto.arrange;

  proto._hideReveal = function( filtered ) {
    this.reveal( filtered.needReveal );
    this.hide( filtered.needHide );
  };

  // HACK
  // Don't animate/transition first layout
  // Or don't animate/transition other layouts
  proto._getIsInstant = function() {
    var isLayoutInstant = this._getOption('layoutInstant');
    var isInstant = isLayoutInstant !== undefined ? isLayoutInstant :
      !this._isLayoutInited;
    this._isInstant = isInstant;
    return isInstant;
  };

  // listen for layoutComplete, hideComplete and revealComplete
  // to trigger arrangeComplete
  proto._bindArrangeComplete = function() {
    // listen for 3 events to trigger arrangeComplete
    var isLayoutComplete, isHideComplete, isRevealComplete;
    var _this = this;
    function arrangeParallelCallback() {
      if ( isLayoutComplete && isHideComplete && isRevealComplete ) {
        _this.dispatchEvent( 'arrangeComplete', null, [ _this.filteredItems ] );
      }
    }
    this.once( 'layoutComplete', function() {
      isLayoutComplete = true;
      arrangeParallelCallback();
    });
    this.once( 'hideComplete', function() {
      isHideComplete = true;
      arrangeParallelCallback();
    });
    this.once( 'revealComplete', function() {
      isRevealComplete = true;
      arrangeParallelCallback();
    });
  };

  // -------------------------- filter -------------------------- //

  proto._filter = function( items ) {
    var filter = this.options.filter;
    filter = filter || '*';
    var matches = [];
    var hiddenMatched = [];
    var visibleUnmatched = [];

    var test = this._getFilterTest( filter );

    // test each item
    for ( var i=0; i < items.length; i++ ) {
      var item = items[i];
      if ( item.isIgnored ) {
        continue;
      }
      // add item to either matched or unmatched group
      var isMatched = test( item );
      // item.isFilterMatched = isMatched;
      // add to matches if its a match
      if ( isMatched ) {
        matches.push( item );
      }
      // add to additional group if item needs to be hidden or revealed
      if ( isMatched && item.isHidden ) {
        hiddenMatched.push( item );
      } else if ( !isMatched && !item.isHidden ) {
        visibleUnmatched.push( item );
      }
    }

    // return collections of items to be manipulated
    return {
      matches: matches,
      needReveal: hiddenMatched,
      needHide: visibleUnmatched
    };
  };

  // get a jQuery, function, or a matchesSelector test given the filter
  proto._getFilterTest = function( filter ) {
    if ( jQuery && this.options.isJQueryFiltering ) {
      // use jQuery
      return function( item ) {
        return jQuery( item.element ).is( filter );
      };
    }
    if ( typeof filter == 'function' ) {
      // use filter as function
      return function( item ) {
        return filter( item.element );
      };
    }
    // default, use filter as selector string
    return function( item ) {
      return matchesSelector( item.element, filter );
    };
  };

  // -------------------------- sorting -------------------------- //

  /**
   * @params {Array} elems
   * @public
   */
  proto.updateSortData = function( elems ) {
    // get items
    var items;
    if ( elems ) {
      elems = utils.makeArray( elems );
      items = this.getItems( elems );
    } else {
      // update all items if no elems provided
      items = this.items;
    }

    this._getSorters();
    this._updateItemsSortData( items );
  };

  proto._getSorters = function() {
    var getSortData = this.options.getSortData;
    for ( var key in getSortData ) {
      var sorter = getSortData[ key ];
      this._sorters[ key ] = mungeSorter( sorter );
    }
  };

  /**
   * @params {Array} items - of Isotope.Items
   * @private
   */
  proto._updateItemsSortData = function( items ) {
    // do not update if no items
    var len = items && items.length;

    for ( var i=0; len && i < len; i++ ) {
      var item = items[i];
      item.updateSortData();
    }
  };

  // ----- munge sorter ----- //

  // encapsulate this, as we just need mungeSorter
  // other functions in here are just for munging
  var mungeSorter = ( function() {
    // add a magic layer to sorters for convienent shorthands
    // `.foo-bar` will use the text of .foo-bar querySelector
    // `[foo-bar]` will use attribute
    // you can also add parser
    // `.foo-bar parseInt` will parse that as a number
    function mungeSorter( sorter ) {
      // if not a string, return function or whatever it is
      if ( typeof sorter != 'string' ) {
        return sorter;
      }
      // parse the sorter string
      var args = trim( sorter ).split(' ');
      var query = args[0];
      // check if query looks like [an-attribute]
      var attrMatch = query.match( /^\[(.+)\]$/ );
      var attr = attrMatch && attrMatch[1];
      var getValue = getValueGetter( attr, query );
      // use second argument as a parser
      var parser = Isotope.sortDataParsers[ args[1] ];
      // parse the value, if there was a parser
      sorter = parser ? function( elem ) {
        return elem && parser( getValue( elem ) );
      } :
      // otherwise just return value
      function( elem ) {
        return elem && getValue( elem );
      };

      return sorter;
    }

    // get an attribute getter, or get text of the querySelector
    function getValueGetter( attr, query ) {
      // if query looks like [foo-bar], get attribute
      if ( attr ) {
        return function getAttribute( elem ) {
          return elem.getAttribute( attr );
        };
      }

      // otherwise, assume its a querySelector, and get its text
      return function getChildText( elem ) {
        var child = elem.querySelector( query );
        return child && child.textContent;
      };
    }

    return mungeSorter;
  })();

  // parsers used in getSortData shortcut strings
  Isotope.sortDataParsers = {
    'parseInt': function( val ) {
      return parseInt( val, 10 );
    },
    'parseFloat': function( val ) {
      return parseFloat( val );
    }
  };

  // ----- sort method ----- //

  // sort filteredItem order
  proto._sort = function() {
    if ( !this.options.sortBy ) {
      return;
    }
    // keep track of sortBy History
    var sortBys = utils.makeArray( this.options.sortBy );
    if ( !this._getIsSameSortBy( sortBys ) ) {
      // concat all sortBy and sortHistory, add to front, oldest goes in last
      this.sortHistory = sortBys.concat( this.sortHistory );
    }
    // sort magic
    var itemSorter = getItemSorter( this.sortHistory, this.options.sortAscending );
    this.filteredItems.sort( itemSorter );
  };

  // check if sortBys is same as start of sortHistory
  proto._getIsSameSortBy = function( sortBys ) {
    for ( var i=0; i < sortBys.length; i++ ) {
      if ( sortBys[i] != this.sortHistory[i] ) {
        return false;
      }
    }
    return true;
  };

  // returns a function used for sorting
  function getItemSorter( sortBys, sortAsc ) {
    return function sorter( itemA, itemB ) {
      // cycle through all sortKeys
      for ( var i = 0; i < sortBys.length; i++ ) {
        var sortBy = sortBys[i];
        var a = itemA.sortData[ sortBy ];
        var b = itemB.sortData[ sortBy ];
        if ( a > b || a < b ) {
          // if sortAsc is an object, use the value given the sortBy key
          var isAscending = sortAsc[ sortBy ] !== undefined ? sortAsc[ sortBy ] : sortAsc;
          var direction = isAscending ? 1 : -1;
          return ( a > b ? 1 : -1 ) * direction;
        }
      }
      return 0;
    };
  }

  // -------------------------- methods -------------------------- //

  // get layout mode
  proto._mode = function() {
    var layoutMode = this.options.layoutMode;
    var mode = this.modes[ layoutMode ];
    if ( !mode ) {
      // TODO console.error
      throw new Error( 'No layout mode: ' + layoutMode );
    }
    // HACK sync mode's options
    // any options set after init for layout mode need to be synced
    mode.options = this.options[ layoutMode ];
    return mode;
  };

  proto._resetLayout = function() {
    // trigger original reset layout
    Outlayer.prototype._resetLayout.call( this );
    this._mode()._resetLayout();
  };

  proto._getItemLayoutPosition = function( item  ) {
    return this._mode()._getItemLayoutPosition( item );
  };

  proto._manageStamp = function( stamp ) {
    this._mode()._manageStamp( stamp );
  };

  proto._getContainerSize = function() {
    return this._mode()._getContainerSize();
  };

  proto.needsResizeLayout = function() {
    return this._mode().needsResizeLayout();
  };

  // -------------------------- adding & removing -------------------------- //

  // HEADS UP overwrites default Outlayer appended
  proto.appended = function( elems ) {
    var items = this.addItems( elems );
    if ( !items.length ) {
      return;
    }
    // filter, layout, reveal new items
    var filteredItems = this._filterRevealAdded( items );
    // add to filteredItems
    this.filteredItems = this.filteredItems.concat( filteredItems );
  };

  // HEADS UP overwrites default Outlayer prepended
  proto.prepended = function( elems ) {
    var items = this._itemize( elems );
    if ( !items.length ) {
      return;
    }
    // start new layout
    this._resetLayout();
    this._manageStamps();
    // filter, layout, reveal new items
    var filteredItems = this._filterRevealAdded( items );
    // layout previous items
    this.layoutItems( this.filteredItems );
    // add to items and filteredItems
    this.filteredItems = filteredItems.concat( this.filteredItems );
    this.items = items.concat( this.items );
  };

  proto._filterRevealAdded = function( items ) {
    var filtered = this._filter( items );
    this.hide( filtered.needHide );
    // reveal all new items
    this.reveal( filtered.matches );
    // layout new items, no transition
    this.layoutItems( filtered.matches, true );
    return filtered.matches;
  };

  /**
   * Filter, sort, and layout newly-appended item elements
   * @param {Array or NodeList or Element} elems
   */
  proto.insert = function( elems ) {
    var items = this.addItems( elems );
    if ( !items.length ) {
      return;
    }
    // append item elements
    var i, item;
    var len = items.length;
    for ( i=0; i < len; i++ ) {
      item = items[i];
      this.element.appendChild( item.element );
    }
    // filter new stuff
    var filteredInsertItems = this._filter( items ).matches;
    // set flag
    for ( i=0; i < len; i++ ) {
      items[i].isLayoutInstant = true;
    }
    this.arrange();
    // reset flag
    for ( i=0; i < len; i++ ) {
      delete items[i].isLayoutInstant;
    }
    this.reveal( filteredInsertItems );
  };

  var _remove = proto.remove;
  proto.remove = function( elems ) {
    elems = utils.makeArray( elems );
    var removeItems = this.getItems( elems );
    // do regular thing
    _remove.call( this, elems );
    // bail if no items to remove
    var len = removeItems && removeItems.length;
    // remove elems from filteredItems
    for ( var i=0; len && i < len; i++ ) {
      var item = removeItems[i];
      // remove item from collection
      utils.removeFrom( this.filteredItems, item );
    }
  };

  proto.shuffle = function() {
    // update random sortData
    for ( var i=0; i < this.items.length; i++ ) {
      var item = this.items[i];
      item.sortData.random = Math.random();
    }
    this.options.sortBy = 'random';
    this._sort();
    this._layout();
  };

  /**
   * trigger fn without transition
   * kind of hacky to have this in the first place
   * @param {Function} fn
   * @param {Array} args
   * @returns ret
   * @private
   */
  proto._noTransition = function( fn, args ) {
    // save transitionDuration before disabling
    var transitionDuration = this.options.transitionDuration;
    // disable transition
    this.options.transitionDuration = 0;
    // do it
    var returnValue = fn.apply( this, args );
    // re-enable transition for reveal
    this.options.transitionDuration = transitionDuration;
    return returnValue;
  };

  // ----- helper methods ----- //

  /**
   * getter method for getting filtered item elements
   * @returns {Array} elems - collection of item elements
   */
  proto.getFilteredItemElements = function() {
    return this.filteredItems.map( function( item ) {
      return item.element;
    });
  };

  // -----  ----- //

  return Isotope;

}));

},{"./item":"/usr/var/server.base/node_modules/isotope-layout/js/item.js","./layout-mode":"/usr/var/server.base/node_modules/isotope-layout/js/layout-mode.js","./layout-modes/fit-rows":"/usr/var/server.base/node_modules/isotope-layout/js/layout-modes/fit-rows.js","./layout-modes/masonry":"/usr/var/server.base/node_modules/isotope-layout/js/layout-modes/masonry.js","./layout-modes/vertical":"/usr/var/server.base/node_modules/isotope-layout/js/layout-modes/vertical.js","desandro-matches-selector":"/usr/var/server.base/node_modules/isotope-layout/node_modules/desandro-matches-selector/matches-selector.js","fizzy-ui-utils":"/usr/var/server.base/node_modules/isotope-layout/node_modules/fizzy-ui-utils/utils.js","get-size":"/usr/var/server.base/node_modules/isotope-layout/node_modules/get-size/get-size.js","outlayer":"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/outlayer.js"}],"/usr/var/server.base/node_modules/isotope-layout/js/item.js":[function(require,module,exports){
/**
 * Isotope Item
**/

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer')
    );
  } else {
    // browser global
    window.Isotope = window.Isotope || {};
    window.Isotope.Item = factory(
      window.Outlayer
    );
  }

}( window, function factory( Outlayer ) {
'use strict';

// -------------------------- Item -------------------------- //

// sub-class Outlayer Item
function Item() {
  Outlayer.Item.apply( this, arguments );
}

var proto = Item.prototype = Object.create( Outlayer.Item.prototype );

var _create = proto._create;
proto._create = function() {
  // assign id, used for original-order sorting
  this.id = this.layout.itemGUID++;
  _create.call( this );
  this.sortData = {};
};

proto.updateSortData = function() {
  if ( this.isIgnored ) {
    return;
  }
  // default sorters
  this.sortData.id = this.id;
  // for backward compatibility
  this.sortData['original-order'] = this.id;
  this.sortData.random = Math.random();
  // go thru getSortData obj and apply the sorters
  var getSortData = this.layout.options.getSortData;
  var sorters = this.layout._sorters;
  for ( var key in getSortData ) {
    var sorter = sorters[ key ];
    this.sortData[ key ] = sorter( this.element, this );
  }
};

var _destroy = proto.destroy;
proto.destroy = function() {
  // call super
  _destroy.apply( this, arguments );
  // reset display, #741
  this.css({
    display: ''
  });
};

return Item;

}));

},{"outlayer":"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/outlayer.js"}],"/usr/var/server.base/node_modules/isotope-layout/js/layout-mode.js":[function(require,module,exports){
/**
 * Isotope LayoutMode
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'get-size/get-size',
        'outlayer/outlayer'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('get-size'),
      require('outlayer')
    );
  } else {
    // browser global
    window.Isotope = window.Isotope || {};
    window.Isotope.LayoutMode = factory(
      window.getSize,
      window.Outlayer
    );
  }

}( window, function factory( getSize, Outlayer ) {
  'use strict';

  // layout mode class
  function LayoutMode( isotope ) {
    this.isotope = isotope;
    // link properties
    if ( isotope ) {
      this.options = isotope.options[ this.namespace ];
      this.element = isotope.element;
      this.items = isotope.filteredItems;
      this.size = isotope.size;
    }
  }

  var proto = LayoutMode.prototype;

  /**
   * some methods should just defer to default Outlayer method
   * and reference the Isotope instance as `this`
  **/
  var facadeMethods = [
    '_resetLayout',
    '_getItemLayoutPosition',
    '_manageStamp',
    '_getContainerSize',
    '_getElementOffset',
    'needsResizeLayout',
    '_getOption'
  ];

  facadeMethods.forEach( function( methodName ) {
    proto[ methodName ] = function() {
      return Outlayer.prototype[ methodName ].apply( this.isotope, arguments );
    };
  });

  // -----  ----- //

  // for horizontal layout modes, check vertical size
  proto.needsVerticalResizeLayout = function() {
    // don't trigger if size did not change
    var size = getSize( this.isotope.element );
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var hasSizes = this.isotope.size && size;
    return hasSizes && size.innerHeight != this.isotope.size.innerHeight;
  };

  // ----- measurements ----- //

  proto._getMeasurement = function() {
    this.isotope._getMeasurement.apply( this, arguments );
  };

  proto.getColumnWidth = function() {
    this.getSegmentSize( 'column', 'Width' );
  };

  proto.getRowHeight = function() {
    this.getSegmentSize( 'row', 'Height' );
  };

  /**
   * get columnWidth or rowHeight
   * segment: 'column' or 'row'
   * size 'Width' or 'Height'
  **/
  proto.getSegmentSize = function( segment, size ) {
    var segmentName = segment + size;
    var outerSize = 'outer' + size;
    // columnWidth / outerWidth // rowHeight / outerHeight
    this._getMeasurement( segmentName, outerSize );
    // got rowHeight or columnWidth, we can chill
    if ( this[ segmentName ] ) {
      return;
    }
    // fall back to item of first element
    var firstItemSize = this.getFirstItemSize();
    this[ segmentName ] = firstItemSize && firstItemSize[ outerSize ] ||
      // or size of container
      this.isotope.size[ 'inner' + size ];
  };

  proto.getFirstItemSize = function() {
    var firstItem = this.isotope.filteredItems[0];
    return firstItem && firstItem.element && getSize( firstItem.element );
  };

  // ----- methods that should reference isotope ----- //

  proto.layout = function() {
    this.isotope.layout.apply( this.isotope, arguments );
  };

  proto.getSize = function() {
    this.isotope.getSize();
    this.size = this.isotope.size;
  };

  // -------------------------- create -------------------------- //

  LayoutMode.modes = {};

  LayoutMode.create = function( namespace, options ) {

    function Mode() {
      LayoutMode.apply( this, arguments );
    }

    Mode.prototype = Object.create( proto );
    Mode.prototype.constructor = Mode;

    // default options
    if ( options ) {
      Mode.options = options;
    }

    Mode.prototype.namespace = namespace;
    // register in Isotope
    LayoutMode.modes[ namespace ] = Mode;

    return Mode;
  };

  return LayoutMode;

}));

},{"get-size":"/usr/var/server.base/node_modules/isotope-layout/node_modules/get-size/get-size.js","outlayer":"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/outlayer.js"}],"/usr/var/server.base/node_modules/isotope-layout/js/layout-modes/fit-rows.js":[function(require,module,exports){
/**
 * fitRows layout mode
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        '../layout-mode'
      ],
      factory );
  } else if ( typeof exports == 'object' ) {
    // CommonJS
    module.exports = factory(
      require('../layout-mode')
    );
  } else {
    // browser global
    factory(
      window.Isotope.LayoutMode
    );
  }

}( window, function factory( LayoutMode ) {
'use strict';

var FitRows = LayoutMode.create('fitRows');

var proto = FitRows.prototype;

proto._resetLayout = function() {
  this.x = 0;
  this.y = 0;
  this.maxY = 0;
  this._getMeasurement( 'gutter', 'outerWidth' );
};

proto._getItemLayoutPosition = function( item ) {
  item.getSize();

  var itemWidth = item.size.outerWidth + this.gutter;
  // if this element cannot fit in the current row
  var containerWidth = this.isotope.size.innerWidth + this.gutter;
  if ( this.x !== 0 && itemWidth + this.x > containerWidth ) {
    this.x = 0;
    this.y = this.maxY;
  }

  var position = {
    x: this.x,
    y: this.y
  };

  this.maxY = Math.max( this.maxY, this.y + item.size.outerHeight );
  this.x += itemWidth;

  return position;
};

proto._getContainerSize = function() {
  return { height: this.maxY };
};

return FitRows;

}));

},{"../layout-mode":"/usr/var/server.base/node_modules/isotope-layout/js/layout-mode.js"}],"/usr/var/server.base/node_modules/isotope-layout/js/layout-modes/masonry.js":[function(require,module,exports){
/*!
 * Masonry layout mode
 * sub-classes Masonry
 * https://masonry.desandro.com
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        '../layout-mode',
        'masonry-layout/masonry'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('../layout-mode'),
      require('masonry-layout')
    );
  } else {
    // browser global
    factory(
      window.Isotope.LayoutMode,
      window.Masonry
    );
  }

}( window, function factory( LayoutMode, Masonry ) {
'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var MasonryMode = LayoutMode.create('masonry');

  var proto = MasonryMode.prototype;

  var keepModeMethods = {
    _getElementOffset: true,
    layout: true,
    _getMeasurement: true
  };

  // inherit Masonry prototype
  for ( var method in Masonry.prototype ) {
    // do not inherit mode methods
    if ( !keepModeMethods[ method ] ) {
      proto[ method ] = Masonry.prototype[ method ];
    }
  }

  var measureColumns = proto.measureColumns;
  proto.measureColumns = function() {
    // set items, used if measuring first item
    this.items = this.isotope.filteredItems;
    measureColumns.call( this );
  };

  // point to mode options for fitWidth
  var _getOption = proto._getOption;
  proto._getOption = function( option ) {
    if ( option == 'fitWidth' ) {
      return this.options.isFitWidth !== undefined ?
        this.options.isFitWidth : this.options.fitWidth;
    }
    return _getOption.apply( this.isotope, arguments );
  };

  return MasonryMode;

}));

},{"../layout-mode":"/usr/var/server.base/node_modules/isotope-layout/js/layout-mode.js","masonry-layout":"/usr/var/server.base/node_modules/isotope-layout/node_modules/masonry-layout/masonry.js"}],"/usr/var/server.base/node_modules/isotope-layout/js/layout-modes/vertical.js":[function(require,module,exports){
/**
 * vertical layout mode
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        '../layout-mode'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('../layout-mode')
    );
  } else {
    // browser global
    factory(
      window.Isotope.LayoutMode
    );
  }

}( window, function factory( LayoutMode ) {
'use strict';

var Vertical = LayoutMode.create( 'vertical', {
  horizontalAlignment: 0
});

var proto = Vertical.prototype;

proto._resetLayout = function() {
  this.y = 0;
};

proto._getItemLayoutPosition = function( item ) {
  item.getSize();
  var x = ( this.isotope.size.innerWidth - item.size.outerWidth ) *
    this.options.horizontalAlignment;
  var y = this.y;
  this.y += item.size.outerHeight;
  return { x: x, y: y };
};

proto._getContainerSize = function() {
  return { height: this.y };
};

return Vertical;

}));

},{"../layout-mode":"/usr/var/server.base/node_modules/isotope-layout/js/layout-mode.js"}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/desandro-matches-selector/matches-selector.js":[function(require,module,exports){
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

},{}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/ev-emitter/ev-emitter.js":[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/fizzy-ui-utils/utils.js":[function(require,module,exports){
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

},{"desandro-matches-selector":"/usr/var/server.base/node_modules/isotope-layout/node_modules/desandro-matches-selector/matches-selector.js"}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/get-size/get-size.js":[function(require,module,exports){
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

},{}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/masonry-layout/masonry.js":[function(require,module,exports){
/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {

'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  var proto = Masonry.prototype;

  proto._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
    this.horizontalColIndex = 0;
  };

  proto.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  proto.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  proto._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ?
      '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[ colPosMethod ]( colSpan, item );
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for ( var i = colPosition.col; i < setMax; i++ ) {
      this.colYs[i] = setHeight;
    }

    return position;
  };

  proto._getTopColPosition = function( colSpan ) {
    var colGroup = this._getTopColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );

    return {
      col: colGroup.indexOf( minimumY ),
      y: minimumY,
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      colGroup[i] = this._getColGroupY( i, colSpan );
    }
    return colGroup;
  };

  proto._getColGroupY = function( col, colSpan ) {
    if ( colSpan < 2 ) {
      return this.colYs[ col ];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice( col, col + colSpan );
    // and get the max value of the array
    return Math.max.apply( Math, groupColYs );
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function( colSpan, item ) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

    return {
      col: col,
      y: this._getColGroupY( col, colSpan ),
    };
  };

  proto._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  proto._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  proto._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  proto.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));

},{"get-size":"/usr/var/server.base/node_modules/isotope-layout/node_modules/get-size/get-size.js","outlayer":"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/outlayer.js"}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/item.js":[function(require,module,exports){
/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( [
        'ev-emitter/ev-emitter',
        'get-size/get-size'
      ],
      factory
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties that could have vendor prefix
var vendorProperties = {
  transform: transformProperty,
  transition: transitionProperty,
  transitionDuration: transitionProperty + 'Duration',
  transitionProperty: transitionProperty + 'Property',
  transitionDelay: transitionProperty + 'Delay'
};

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  var x = parseFloat( xValue );
  var y = parseFloat( yValue );
  // convert percent to pixels
  var layoutSize = this.layout.size;
  if ( xValue.indexOf('%') != -1 ) {
    x = ( x / 100 ) * layoutSize.width;
  }
  if ( yValue.indexOf('%') != -1 ) {
    y = ( y / 100 ) * layoutSize.height;
  }
  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var didNotMove = x == this.position.x && y == this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseFloat( x );
  this.position.y = parseFloat( y );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto.transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' + toDashedAll( transformProperty );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // munge number to millisecond, to match stagger
  var duration = this.layout.options.transitionDuration;
  duration = typeof duration == 'number' ? duration + 'ms' : duration;
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: duration,
    transitionDelay: this.staggerDelay || 0
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: '',
  transitionDelay: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- stagger ----- //

proto.stagger = function( delay ) {
  delay = isNaN( delay ) ? 0 : delay;
  this.staggerDelay = delay + 'ms';
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));

},{"ev-emitter":"/usr/var/server.base/node_modules/isotope-layout/node_modules/ev-emitter/ev-emitter.js","get-size":"/usr/var/server.base/node_modules/isotope-layout/node_modules/get-size/get-size.js"}],"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/outlayer.js":[function(require,module,exports){
/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( [
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
      ],
      function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  this.updateStagger();
  queue.forEach( function( obj, i ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
  }, this );
};

// set stagger from option in milliseconds number
proto.updateStagger = function() {
  var stagger = this.options.stagger;
  if ( stagger === null || stagger === undefined ) {
    this.stagger = 0;
    return;
  }
  this.stagger = getMilliseconds( stagger );
  return this.stagger;
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant, i ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.stagger( i * this.stagger );
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- helpers ----- //

// how many milliseconds are in each unit
var msUnits = {
  ms: 1,
  s: 1000
};

// munge time-like parameter into millisecond number
// '0.4s' -> 40
function getMilliseconds( time ) {
  if ( typeof time == 'number' ) {
    return time;
  }
  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
  var num = matches && matches[1];
  var unit = matches && matches[2];
  if ( !num.length ) {
    return 0;
  }
  num = parseFloat( num );
  var mult = msUnits[ unit ] || 1;
  return num * mult;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));

},{"./item":"/usr/var/server.base/node_modules/isotope-layout/node_modules/outlayer/item.js","ev-emitter":"/usr/var/server.base/node_modules/isotope-layout/node_modules/ev-emitter/ev-emitter.js","fizzy-ui-utils":"/usr/var/server.base/node_modules/isotope-layout/node_modules/fizzy-ui-utils/utils.js","get-size":"/usr/var/server.base/node_modules/isotope-layout/node_modules/get-size/get-size.js"}],"/usr/var/server.base/node_modules/jquery-ui/ui/unique-id.js":[function(require,module,exports){
/*!
 * jQuery UI Unique ID 1.13.2
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery", "./version" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

return $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );

} );

},{}],"/usr/var/server.base/node_modules/jquery-ui/ui/widget.js":[function(require,module,exports){
/*!
 * jQuery UI Widget 1.13.2
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery", "./version" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

var widgetUuid = 0;
var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {

			// Only trigger remove when necessary to save time
			events = $._data( elem, "events" );
			if ( events && events.remove ) {
				$( elem ).triggerHandler( "remove" );
			}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( Array.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this || !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( typeof value !== "function" ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( widgetHasOwnProperty.call( input[ inputIndex ], key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( typeof instance[ options ] !== "function" ||
						options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function bindRemoveEvent() {
			var nodesToBind = [];

			options.element.each( function( _, element ) {
				var isTracked = $.map( that.classesElementLookup, function( elements ) {
					return elements;
				} )
					.some( function( elements ) {
						return elements.is( element );
					} );

				if ( !isTracked ) {
					nodesToBind.push( element );
				}
			} );

			that._on( $( nodesToBind ), {
				remove: "_untrackClassesElement"
			} );
		}

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					bindRemoveEvent();
					current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );

		this._off( $( event.target ) );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( typeof callback === "function" &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		} else if ( options === true ) {
			options = {};
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

return $.widget;

} );

},{}],"/usr/var/server.base/node_modules/jquery-ui/ui/widgets/accordion.js":[function(require,module,exports){
/*!
 * jQuery UI Accordion 1.13.2
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
/* eslint-disable max-len */
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
/* eslint-enable max-len */
//>>docs: http://api.jqueryui.com/accordion/
//>>demos: http://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [
			"jquery",
			"../version",
			"../keycode",
			"../unique-id",
			"../widget"
		], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

return $.widget( "ui.accordion", {
	version: "1.13.2",
	options: {
		active: 0,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: false,
		event: "click",
		header: function( elem ) {
			return elem.find( "> li > :first-child" ).add( elem.find( "> :not(li)" ).even() );
		},
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );

		// Support: IE8 Only
		// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		this._toggleClass( null, "ui-state-disabled", !!value );
		this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
			!!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		if ( typeof this.options.header === "function" ) {
			this.headers = this.options.header( this.element );
		} else {
			this.headers = this.element.find( this.options.header );
		}
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		// Work around for rendering bug in IE (#5421)
		if ( toHide.length ) {
			toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
		}
		this._trigger( "activate", null, data );
	}
} );

} );

},{}],"/usr/var/server.base/node_modules/jquery.kinetic/jquery.kinetic.min.js":[function(require,module,exports){
/*! jquery.kinetic - v2.2.4 - 2017-09-10 https://davetayls.me/jquery.kinetic 
 * Copyright (c) 2017 Dave Taylor (https://davetayls.me); Licensed MIT */

!function(t){"use strict";window.requestAnimationFrame||(window.requestAnimationFrame=window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t,e){window.setTimeout(t,1e3/60)}),t.support=t.support||{},t.extend(t.support,{touch:"ontouchend"in document});var e=function(e,s){return this.settings=s,this.el=e,this.$el=t(e),this._initElements(),this};e.DATA_KEY="kinetic",e.DEFAULTS={cursor:"move",decelerate:!0,triggerHardware:!1,threshold:0,y:!0,x:!0,slowdown:.9,maxvelocity:40,throttleFPS:60,invert:!1,movingClass:{up:"kinetic-moving-up",down:"kinetic-moving-down",left:"kinetic-moving-left",right:"kinetic-moving-right"},deceleratingClass:{up:"kinetic-decelerating-up",down:"kinetic-decelerating-down",left:"kinetic-decelerating-left",right:"kinetic-decelerating-right"}},e.prototype.start=function(e){this.settings=t.extend(this.settings,e),this.velocity=e.velocity||this.velocity,this.velocityY=e.velocityY||this.velocityY,this.settings.decelerate=!1,this._move()},e.prototype.end=function(){this.settings.decelerate=!0},e.prototype.stop=function(){this.velocity=0,this.velocityY=0,this.settings.decelerate=!0,t.isFunction(this.settings.stopped)&&this.settings.stopped.call(this)},e.prototype.detach=function(){this._detachListeners(),this.$el.removeClass("kinetic-active").css("cursor","")},e.prototype.attach=function(){this.$el.hasClass("kinetic-active")||(this._attachListeners(this.$el),this.$el.addClass("kinetic-active").css("cursor",this.settings.cursor))},e.prototype.destroy=function(){this.detach(),this.$el=null,this.el=null,this.settings=null},e.prototype._initElements=function(){this.$el.addClass("kinetic-active"),t.extend(this,{xpos:null,prevXPos:!1,ypos:null,prevYPos:!1,mouseDown:!1,throttleTimeout:1e3/this.settings.throttleFPS,lastMove:null,elementFocused:null}),this.velocity=0,this.velocityY=0,t(document).mouseup(t.proxy(this._resetMouse,this)).click(t.proxy(this._resetMouse,this)),this._initEvents(),this.$el.css("cursor",this.settings.cursor),this.settings.triggerHardware&&this.$el.css({"-webkit-transform":"translate3d(0,0,0)","-webkit-perspective":"1000","-webkit-backface-visibility":"hidden"})},e.prototype._initEvents=function(){var e=this;this.settings.events={touchStart:function(t){var s;e._useTarget(t.target,t)&&(s=t.originalEvent.touches[0],e.threshold=e._threshold(t.target,t),e._start(s.clientX,s.clientY),t.stopPropagation())},touchMove:function(t){var s;e.mouseDown&&(s=t.originalEvent.touches[0],e._inputmove(s.clientX,s.clientY),t.preventDefault&&t.preventDefault())},inputDown:function(t){e._useTarget(t.target,t)&&(e.threshold=e._threshold(t.target,t),e._start(t.clientX,t.clientY),e.elementFocused=t.target,"IMG"===t.target.nodeName&&t.preventDefault(),t.stopPropagation())},inputEnd:function(t){e._useTarget(t.target,t)&&(e._end(),e.elementFocused=null,t.preventDefault&&t.preventDefault())},inputMove:function(t){e.mouseDown&&(e._inputmove(t.clientX,t.clientY),t.preventDefault&&t.preventDefault())},scroll:function(s){t.isFunction(e.settings.moved)&&e.settings.moved.call(e,e.settings),s.preventDefault&&s.preventDefault()},inputClick:function(t){if(Math.abs(e.velocity)>0)return t.preventDefault(),!1},dragStart:function(t){if(e._useTarget(t.target,t)&&e.elementFocused)return!1},selectStart:function(s){return t.isFunction(e.settings.selectStart)?e.settings.selectStart.apply(e,arguments):!e._useTarget(s.target,s)&&void 0}},this._attachListeners(this.$el,this.settings)},e.prototype._inputmove=function(e,s){var i=this.$el;this.el;if((!this.lastMove||new Date>new Date(this.lastMove.getTime()+this.throttleTimeout))&&(this.lastMove=new Date,this.mouseDown&&(this.xpos||this.ypos))){var o=e-this.xpos,n=s-this.ypos;if(this.settings.invert&&(o*=-1,n*=-1),this.threshold>0){var l=Math.sqrt(o*o+n*n);if(this.threshold>l)return;this.threshold=0}this.elementFocused&&(t(this.elementFocused).blur(),this.elementFocused=null,i.focus()),this.settings.decelerate=!1,this.velocity=this.velocityY=0;var r=this.scrollLeft(),c=this.scrollTop();this.scrollLeft(this.settings.x?r-o:r),this.scrollTop(this.settings.y?c-n:c),this.prevXPos=this.xpos,this.prevYPos=this.ypos,this.xpos=e,this.ypos=s,this._calculateVelocities(),this._setMoveClasses(this.settings.movingClass),t.isFunction(this.settings.moved)&&this.settings.moved.call(this,this.settings)}},e.prototype._calculateVelocities=function(){this.velocity=this._capVelocity(this.prevXPos-this.xpos,this.settings.maxvelocity),this.velocityY=this._capVelocity(this.prevYPos-this.ypos,this.settings.maxvelocity),this.settings.invert&&(this.velocity*=-1,this.velocityY*=-1)},e.prototype._end=function(){this.xpos&&this.prevXPos&&!1===this.settings.decelerate&&(this.settings.decelerate=!0,this._calculateVelocities(),this.xpos=this.prevXPos=this.mouseDown=!1,this._move())},e.prototype._useTarget=function(e,s){return!t.isFunction(this.settings.filterTarget)||!1!==this.settings.filterTarget.call(this,e,s)},e.prototype._threshold=function(e,s){return t.isFunction(this.settings.threshold)?this.settings.threshold.call(this,e,s):this.settings.threshold},e.prototype._start=function(t,e){this.mouseDown=!0,this.velocity=this.prevXPos=0,this.velocityY=this.prevYPos=0,this.xpos=t,this.ypos=e},e.prototype._resetMouse=function(){this.xpos=!1,this.ypos=!1,this.mouseDown=!1},e.prototype._decelerateVelocity=function(t,e){return 0===Math.floor(Math.abs(t))?0:t*e},e.prototype._capVelocity=function(t,e){var s=t;return t>0?t>e&&(s=e):t<0-e&&(s=0-e),s},e.prototype._setMoveClasses=function(t){var e=this.settings,s=this.$el;s.removeClass(e.movingClass.up).removeClass(e.movingClass.down).removeClass(e.movingClass.left).removeClass(e.movingClass.right).removeClass(e.deceleratingClass.up).removeClass(e.deceleratingClass.down).removeClass(e.deceleratingClass.left).removeClass(e.deceleratingClass.right),this.velocity>0&&s.addClass(t.right),this.velocity<0&&s.addClass(t.left),this.velocityY>0&&s.addClass(t.down),this.velocityY<0&&s.addClass(t.up)},e.prototype._move=function(){var e=this._getScroller()[0],s=this,i=s.settings;i.x&&e.scrollWidth>0?(this.scrollLeft(this.scrollLeft()+this.velocity),Math.abs(this.velocity)>0&&(this.velocity=i.decelerate?s._decelerateVelocity(this.velocity,i.slowdown):this.velocity)):this.velocity=0,i.y&&e.scrollHeight>0?(this.scrollTop(this.scrollTop()+this.velocityY),Math.abs(this.velocityY)>0&&(this.velocityY=i.decelerate?s._decelerateVelocity(this.velocityY,i.slowdown):this.velocityY)):this.velocityY=0,s._setMoveClasses(i.deceleratingClass),t.isFunction(i.moved)&&i.moved.call(this,i),Math.abs(this.velocity)>0||Math.abs(this.velocityY)>0?this.moving||(this.moving=!0,window.requestAnimationFrame(function(){s.moving=!1,s._move()})):s.stop()},e.prototype._getScroller=function(){var e=this.$el;return(this.$el.is("body")||this.$el.is("html"))&&(e=t(window)),e},e.prototype.scrollLeft=function(t){var e=this._getScroller();if("number"!=typeof t)return e.scrollLeft();e.scrollLeft(t),this.settings.scrollLeft=t},e.prototype.scrollTop=function(t){var e=this._getScroller();if("number"!=typeof t)return e.scrollTop();e.scrollTop(t),this.settings.scrollTop=t},e.prototype._attachListeners=function(){var e=this.$el,s=this.settings;t.support.touch&&e.bind("touchstart",s.events.touchStart).bind("touchend",s.events.inputEnd).bind("touchmove",s.events.touchMove),e.mousedown(s.events.inputDown).mouseup(s.events.inputEnd).mousemove(s.events.inputMove),e.click(s.events.inputClick).scroll(s.events.scroll).bind("selectstart",s.events.selectStart).bind("dragstart",s.events.dragStart)},e.prototype._detachListeners=function(){var e=this.$el,s=this.settings;t.support.touch&&e.unbind("touchstart",s.events.touchStart).unbind("touchend",s.events.inputEnd).unbind("touchmove",s.events.touchMove),e.unbind("mousedown",s.events.inputDown).unbind("mouseup",s.events.inputEnd).unbind("mousemove",s.events.inputMove),e.unbind("click",s.events.inputClick).unbind("scroll",s.events.scroll).unbind("selectstart",s.events.selectStart).unbind("dragstart",s.events.dragStart)},t.Kinetic=e,t.fn.kinetic=function(s,i){return this.each(function(){var o=t(this),n=o.data(e.DATA_KEY),l=t.extend({},e.DEFAULTS,o.data(),"object"==typeof s&&s);n||o.data(e.DATA_KEY,n=new e(this,l)),"string"==typeof s&&n[s](i)})}}(window.jQuery||window.Zepto);
},{}],"/usr/var/server.base/node_modules/jquery.transit/jquery.transit.js":[function(require,module,exports){
/*!
 * jQuery Transit - CSS3 transitions and transformations
 * (c) 2011-2014 Rico Sta. Cruz
 * MIT Licensed.
 *
 * http://ricostacruz.com/jquery.transit
 * http://github.com/rstacruz/jquery.transit
 */

/* jshint expr: true */

;(function (root, factory) {

  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    factory(root.jQuery);
  }

}(this, function($) {

  $.transit = {
    version: "0.9.12",

    // Map of $.css() keys to values for 'transitionProperty'.
    // See https://developer.mozilla.org/en/CSS/CSS_transitions#Properties_that_can_be_animated
    propertyMap: {
      marginLeft    : 'margin',
      marginRight   : 'margin',
      marginBottom  : 'margin',
      marginTop     : 'margin',
      paddingLeft   : 'padding',
      paddingRight  : 'padding',
      paddingBottom : 'padding',
      paddingTop    : 'padding'
    },

    // Will simply transition "instantly" if false
    enabled: true,

    // Set this to false if you don't want to use the transition end property.
    useTransitionEnd: false
  };

  var div = document.createElement('div');
  var support = {};

  // Helper function to get the proper vendor property name.
  // (`transition` => `WebkitTransition`)
  function getVendorPropertyName(prop) {
    // Handle unprefixed versions (FF16+, for example)
    if (prop in div.style) return prop;

    var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
    var prop_ = prop.charAt(0).toUpperCase() + prop.substr(1);

    for (var i=0; i<prefixes.length; ++i) {
      var vendorProp = prefixes[i] + prop_;
      if (vendorProp in div.style) { return vendorProp; }
    }
  }

  // Helper function to check if transform3D is supported.
  // Should return true for Webkits and Firefox 10+.
  function checkTransform3dSupport() {
    div.style[support.transform] = '';
    div.style[support.transform] = 'rotateY(90deg)';
    return div.style[support.transform] !== '';
  }

  var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

  // Check for the browser's transitions support.
  support.transition      = getVendorPropertyName('transition');
  support.transitionDelay = getVendorPropertyName('transitionDelay');
  support.transform       = getVendorPropertyName('transform');
  support.transformOrigin = getVendorPropertyName('transformOrigin');
  support.filter          = getVendorPropertyName('Filter');
  support.transform3d     = checkTransform3dSupport();

  var eventNames = {
    'transition':       'transitionend',
    'MozTransition':    'transitionend',
    'OTransition':      'oTransitionEnd',
    'WebkitTransition': 'webkitTransitionEnd',
    'msTransition':     'MSTransitionEnd'
  };

  // Detect the 'transitionend' event needed.
  var transitionEnd = support.transitionEnd = eventNames[support.transition] || null;

  // Populate jQuery's `$.support` with the vendor prefixes we know.
  // As per [jQuery's cssHooks documentation](http://api.jquery.com/jQuery.cssHooks/),
  // we set $.support.transition to a string of the actual property name used.
  for (var key in support) {
    if (support.hasOwnProperty(key) && typeof $.support[key] === 'undefined') {
      $.support[key] = support[key];
    }
  }

  // Avoid memory leak in IE.
  div = null;

  // ## $.cssEase
  // List of easing aliases that you can use with `$.fn.transition`.
  $.cssEase = {
    '_default':       'ease',
    'in':             'ease-in',
    'out':            'ease-out',
    'in-out':         'ease-in-out',
    'snap':           'cubic-bezier(0,1,.5,1)',
    // Penner equations
    'easeInCubic':    'cubic-bezier(.550,.055,.675,.190)',
    'easeOutCubic':   'cubic-bezier(.215,.61,.355,1)',
    'easeInOutCubic': 'cubic-bezier(.645,.045,.355,1)',
    'easeInCirc':     'cubic-bezier(.6,.04,.98,.335)',
    'easeOutCirc':    'cubic-bezier(.075,.82,.165,1)',
    'easeInOutCirc':  'cubic-bezier(.785,.135,.15,.86)',
    'easeInExpo':     'cubic-bezier(.95,.05,.795,.035)',
    'easeOutExpo':    'cubic-bezier(.19,1,.22,1)',
    'easeInOutExpo':  'cubic-bezier(1,0,0,1)',
    'easeInQuad':     'cubic-bezier(.55,.085,.68,.53)',
    'easeOutQuad':    'cubic-bezier(.25,.46,.45,.94)',
    'easeInOutQuad':  'cubic-bezier(.455,.03,.515,.955)',
    'easeInQuart':    'cubic-bezier(.895,.03,.685,.22)',
    'easeOutQuart':   'cubic-bezier(.165,.84,.44,1)',
    'easeInOutQuart': 'cubic-bezier(.77,0,.175,1)',
    'easeInQuint':    'cubic-bezier(.755,.05,.855,.06)',
    'easeOutQuint':   'cubic-bezier(.23,1,.32,1)',
    'easeInOutQuint': 'cubic-bezier(.86,0,.07,1)',
    'easeInSine':     'cubic-bezier(.47,0,.745,.715)',
    'easeOutSine':    'cubic-bezier(.39,.575,.565,1)',
    'easeInOutSine':  'cubic-bezier(.445,.05,.55,.95)',
    'easeInBack':     'cubic-bezier(.6,-.28,.735,.045)',
    'easeOutBack':    'cubic-bezier(.175, .885,.32,1.275)',
    'easeInOutBack':  'cubic-bezier(.68,-.55,.265,1.55)'
  };

  // ## 'transform' CSS hook
  // Allows you to use the `transform` property in CSS.
  //
  //     $("#hello").css({ transform: "rotate(90deg)" });
  //
  //     $("#hello").css('transform');
  //     //=> { rotate: '90deg' }
  //
  $.cssHooks['transit:transform'] = {
    // The getter returns a `Transform` object.
    get: function(elem) {
      return $(elem).data('transform') || new Transform();
    },

    // The setter accepts a `Transform` object or a string.
    set: function(elem, v) {
      var value = v;

      if (!(value instanceof Transform)) {
        value = new Transform(value);
      }

      // We've seen the 3D version of Scale() not work in Chrome when the
      // element being scaled extends outside of the viewport.  Thus, we're
      // forcing Chrome to not use the 3d transforms as well.  Not sure if
      // translate is affectede, but not risking it.  Detection code from
      // http://davidwalsh.name/detecting-google-chrome-javascript
      if (support.transform === 'WebkitTransform' && !isChrome) {
        elem.style[support.transform] = value.toString(true);
      } else {
        elem.style[support.transform] = value.toString();
      }

      $(elem).data('transform', value);
    }
  };

  // Add a CSS hook for `.css({ transform: '...' })`.
  // In jQuery 1.8+, this will intentionally override the default `transform`
  // CSS hook so it'll play well with Transit. (see issue #62)
  $.cssHooks.transform = {
    set: $.cssHooks['transit:transform'].set
  };

  // ## 'filter' CSS hook
  // Allows you to use the `filter` property in CSS.
  //
  //     $("#hello").css({ filter: 'blur(10px)' });
  //
  $.cssHooks.filter = {
    get: function(elem) {
      return elem.style[support.filter];
    },
    set: function(elem, value) {
      elem.style[support.filter] = value;
    }
  };

  // jQuery 1.8+ supports prefix-free transitions, so these polyfills will not
  // be necessary.
  if ($.fn.jquery < "1.8") {
    // ## 'transformOrigin' CSS hook
    // Allows the use for `transformOrigin` to define where scaling and rotation
    // is pivoted.
    //
    //     $("#hello").css({ transformOrigin: '0 0' });
    //
    $.cssHooks.transformOrigin = {
      get: function(elem) {
        return elem.style[support.transformOrigin];
      },
      set: function(elem, value) {
        elem.style[support.transformOrigin] = value;
      }
    };

    // ## 'transition' CSS hook
    // Allows you to use the `transition` property in CSS.
    //
    //     $("#hello").css({ transition: 'all 0 ease 0' });
    //
    $.cssHooks.transition = {
      get: function(elem) {
        return elem.style[support.transition];
      },
      set: function(elem, value) {
        elem.style[support.transition] = value;
      }
    };
  }

  // ## Other CSS hooks
  // Allows you to rotate, scale and translate.
  registerCssHook('scale');
  registerCssHook('scaleX');
  registerCssHook('scaleY');
  registerCssHook('translate');
  registerCssHook('rotate');
  registerCssHook('rotateX');
  registerCssHook('rotateY');
  registerCssHook('rotate3d');
  registerCssHook('perspective');
  registerCssHook('skewX');
  registerCssHook('skewY');
  registerCssHook('x', true);
  registerCssHook('y', true);

  // ## Transform class
  // This is the main class of a transformation property that powers
  // `$.fn.css({ transform: '...' })`.
  //
  // This is, in essence, a dictionary object with key/values as `-transform`
  // properties.
  //
  //     var t = new Transform("rotate(90) scale(4)");
  //
  //     t.rotate             //=> "90deg"
  //     t.scale              //=> "4,4"
  //
  // Setters are accounted for.
  //
  //     t.set('rotate', 4)
  //     t.rotate             //=> "4deg"
  //
  // Convert it to a CSS string using the `toString()` and `toString(true)` (for WebKit)
  // functions.
  //
  //     t.toString()         //=> "rotate(90deg) scale(4,4)"
  //     t.toString(true)     //=> "rotate(90deg) scale3d(4,4,0)" (WebKit version)
  //
  function Transform(str) {
    if (typeof str === 'string') { this.parse(str); }
    return this;
  }

  Transform.prototype = {
    // ### setFromString()
    // Sets a property from a string.
    //
    //     t.setFromString('scale', '2,4');
    //     // Same as set('scale', '2', '4');
    //
    setFromString: function(prop, val) {
      var args =
        (typeof val === 'string')  ? val.split(',') :
        (val.constructor === Array) ? val :
        [ val ];

      args.unshift(prop);

      Transform.prototype.set.apply(this, args);
    },

    // ### set()
    // Sets a property.
    //
    //     t.set('scale', 2, 4);
    //
    set: function(prop) {
      var args = Array.prototype.slice.apply(arguments, [1]);
      if (this.setter[prop]) {
        this.setter[prop].apply(this, args);
      } else {
        this[prop] = args.join(',');
      }
    },

    get: function(prop) {
      if (this.getter[prop]) {
        return this.getter[prop].apply(this);
      } else {
        return this[prop] || 0;
      }
    },

    setter: {
      // ### rotate
      //
      //     .css({ rotate: 30 })
      //     .css({ rotate: "30" })
      //     .css({ rotate: "30deg" })
      //     .css({ rotate: "30deg" })
      //
      rotate: function(theta) {
        this.rotate = unit(theta, 'deg');
      },

      rotateX: function(theta) {
        this.rotateX = unit(theta, 'deg');
      },

      rotateY: function(theta) {
        this.rotateY = unit(theta, 'deg');
      },

      // ### scale
      //
      //     .css({ scale: 9 })      //=> "scale(9,9)"
      //     .css({ scale: '3,2' })  //=> "scale(3,2)"
      //
      scale: function(x, y) {
        if (y === undefined) { y = x; }
        this.scale = x + "," + y;
      },

      // ### skewX + skewY
      skewX: function(x) {
        this.skewX = unit(x, 'deg');
      },

      skewY: function(y) {
        this.skewY = unit(y, 'deg');
      },

      // ### perspectvie
      perspective: function(dist) {
        this.perspective = unit(dist, 'px');
      },

      // ### x / y
      // Translations. Notice how this keeps the other value.
      //
      //     .css({ x: 4 })       //=> "translate(4px, 0)"
      //     .css({ y: 10 })      //=> "translate(4px, 10px)"
      //
      x: function(x) {
        this.set('translate', x, null);
      },

      y: function(y) {
        this.set('translate', null, y);
      },

      // ### translate
      // Notice how this keeps the other value.
      //
      //     .css({ translate: '2, 5' })    //=> "translate(2px, 5px)"
      //
      translate: function(x, y) {
        if (this._translateX === undefined) { this._translateX = 0; }
        if (this._translateY === undefined) { this._translateY = 0; }

        if (x !== null && x !== undefined) { this._translateX = unit(x, 'px'); }
        if (y !== null && y !== undefined) { this._translateY = unit(y, 'px'); }

        this.translate = this._translateX + "," + this._translateY;
      }
    },

    getter: {
      x: function() {
        return this._translateX || 0;
      },

      y: function() {
        return this._translateY || 0;
      },

      scale: function() {
        var s = (this.scale || "1,1").split(',');
        if (s[0]) { s[0] = parseFloat(s[0]); }
        if (s[1]) { s[1] = parseFloat(s[1]); }

        // "2.5,2.5" => 2.5
        // "2.5,1" => [2.5,1]
        return (s[0] === s[1]) ? s[0] : s;
      },

      rotate3d: function() {
        var s = (this.rotate3d || "0,0,0,0deg").split(',');
        for (var i=0; i<=3; ++i) {
          if (s[i]) { s[i] = parseFloat(s[i]); }
        }
        if (s[3]) { s[3] = unit(s[3], 'deg'); }

        return s;
      }
    },

    // ### parse()
    // Parses from a string. Called on constructor.
    parse: function(str) {
      var self = this;
      str.replace(/([a-zA-Z0-9]+)\((.*?)\)/g, function(x, prop, val) {
        self.setFromString(prop, val);
      });
    },

    // ### toString()
    // Converts to a `transition` CSS property string. If `use3d` is given,
    // it converts to a `-webkit-transition` CSS property string instead.
    toString: function(use3d) {
      var re = [];

      for (var i in this) {
        if (this.hasOwnProperty(i)) {
          // Don't use 3D transformations if the browser can't support it.
          if ((!support.transform3d) && (
            (i === 'rotateX') ||
            (i === 'rotateY') ||
            (i === 'perspective') ||
            (i === 'transformOrigin'))) { continue; }

          if (i[0] !== '_') {
            if (use3d && (i === 'scale')) {
              re.push(i + "3d(" + this[i] + ",1)");
            } else if (use3d && (i === 'translate')) {
              re.push(i + "3d(" + this[i] + ",0)");
            } else {
              re.push(i + "(" + this[i] + ")");
            }
          }
        }
      }

      return re.join(" ");
    }
  };

  function callOrQueue(self, queue, fn) {
    if (queue === true) {
      self.queue(fn);
    } else if (queue) {
      self.queue(queue, fn);
    } else {
      self.each(function () {
                fn.call(this);
            });
    }
  }

  // ### getProperties(dict)
  // Returns properties (for `transition-property`) for dictionary `props`. The
  // value of `props` is what you would expect in `$.css(...)`.
  function getProperties(props) {
    var re = [];

    $.each(props, function(key) {
      key = $.camelCase(key); // Convert "text-align" => "textAlign"
      key = $.transit.propertyMap[key] || $.cssProps[key] || key;
      key = uncamel(key); // Convert back to dasherized

      // Get vendor specify propertie
      if (support[key])
        key = uncamel(support[key]);

      if ($.inArray(key, re) === -1) { re.push(key); }
    });

    return re;
  }

  // ### getTransition()
  // Returns the transition string to be used for the `transition` CSS property.
  //
  // Example:
  //
  //     getTransition({ opacity: 1, rotate: 30 }, 500, 'ease');
  //     //=> 'opacity 500ms ease, -webkit-transform 500ms ease'
  //
  function getTransition(properties, duration, easing, delay) {
    // Get the CSS properties needed.
    var props = getProperties(properties);

    // Account for aliases (`in` => `ease-in`).
    if ($.cssEase[easing]) { easing = $.cssEase[easing]; }

    // Build the duration/easing/delay attributes for it.
    var attribs = '' + toMS(duration) + ' ' + easing;
    if (parseInt(delay, 10) > 0) { attribs += ' ' + toMS(delay); }

    // For more properties, add them this way:
    // "margin 200ms ease, padding 200ms ease, ..."
    var transitions = [];
    $.each(props, function(i, name) {
      transitions.push(name + ' ' + attribs);
    });

    return transitions.join(', ');
  }

  // ## $.fn.transition
  // Works like $.fn.animate(), but uses CSS transitions.
  //
  //     $("...").transition({ opacity: 0.1, scale: 0.3 });
  //
  //     // Specific duration
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500);
  //
  //     // With duration and easing
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in');
  //
  //     // With callback
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, function() { ... });
  //
  //     // With everything
  //     $("...").transition({ opacity: 0.1, scale: 0.3 }, 500, 'in', function() { ... });
  //
  //     // Alternate syntax
  //     $("...").transition({
  //       opacity: 0.1,
  //       duration: 200,
  //       delay: 40,
  //       easing: 'in',
  //       complete: function() { /* ... */ }
  //      });
  //
  $.fn.transition = $.fn.transit = function(properties, duration, easing, callback) {
    var self  = this;
    var delay = 0;
    var queue = true;

    var theseProperties = $.extend(true, {}, properties);

    // Account for `.transition(properties, callback)`.
    if (typeof duration === 'function') {
      callback = duration;
      duration = undefined;
    }

    // Account for `.transition(properties, options)`.
    if (typeof duration === 'object') {
      easing = duration.easing;
      delay = duration.delay || 0;
      queue = typeof duration.queue === "undefined" ? true : duration.queue;
      callback = duration.complete;
      duration = duration.duration;
    }

    // Account for `.transition(properties, duration, callback)`.
    if (typeof easing === 'function') {
      callback = easing;
      easing = undefined;
    }

    // Alternate syntax.
    if (typeof theseProperties.easing !== 'undefined') {
      easing = theseProperties.easing;
      delete theseProperties.easing;
    }

    if (typeof theseProperties.duration !== 'undefined') {
      duration = theseProperties.duration;
      delete theseProperties.duration;
    }

    if (typeof theseProperties.complete !== 'undefined') {
      callback = theseProperties.complete;
      delete theseProperties.complete;
    }

    if (typeof theseProperties.queue !== 'undefined') {
      queue = theseProperties.queue;
      delete theseProperties.queue;
    }

    if (typeof theseProperties.delay !== 'undefined') {
      delay = theseProperties.delay;
      delete theseProperties.delay;
    }

    // Set defaults. (`400` duration, `ease` easing)
    if (typeof duration === 'undefined') { duration = $.fx.speeds._default; }
    if (typeof easing === 'undefined')   { easing = $.cssEase._default; }

    duration = toMS(duration);

    // Build the `transition` property.
    var transitionValue = getTransition(theseProperties, duration, easing, delay);

    // Compute delay until callback.
    // If this becomes 0, don't bother setting the transition property.
    var work = $.transit.enabled && support.transition;
    var i = work ? (parseInt(duration, 10) + parseInt(delay, 10)) : 0;

    // If there's nothing to do...
    if (i === 0) {
      var fn = function(next) {
        self.css(theseProperties);
        if (callback) { callback.apply(self); }
        if (next) { next(); }
      };

      callOrQueue(self, queue, fn);
      return self;
    }

    // Save the old transitions of each element so we can restore it later.
    var oldTransitions = {};

    var run = function(nextCall) {
      var bound = false;

      // Prepare the callback.
      var cb = function() {
        if (bound) { self.unbind(transitionEnd, cb); }

        if (i > 0) {
          self.each(function() {
            this.style[support.transition] = (oldTransitions[this] || null);
          });
        }

        if (typeof callback === 'function') { callback.apply(self); }
        if (typeof nextCall === 'function') { nextCall(); }
      };

      if ((i > 0) && (transitionEnd) && ($.transit.useTransitionEnd)) {
        // Use the 'transitionend' event if it's available.
        bound = true;
        self.bind(transitionEnd, cb);
      } else {
        // Fallback to timers if the 'transitionend' event isn't supported.
        window.setTimeout(cb, i);
      }

      // Apply transitions.
      self.each(function() {
        if (i > 0) {
          this.style[support.transition] = transitionValue;
        }
        $(this).css(theseProperties);
      });
    };

    // Defer running. This allows the browser to paint any pending CSS it hasn't
    // painted yet before doing the transitions.
    var deferredRun = function(next) {
        this.offsetWidth; // force a repaint
        run(next);
    };

    // Use jQuery's fx queue.
    callOrQueue(self, queue, deferredRun);

    // Chainability.
    return this;
  };

  function registerCssHook(prop, isPixels) {
    // For certain properties, the 'px' should not be implied.
    if (!isPixels) { $.cssNumber[prop] = true; }

    $.transit.propertyMap[prop] = support.transform;

    $.cssHooks[prop] = {
      get: function(elem) {
        var t = $(elem).css('transit:transform');
        return t.get(prop);
      },

      set: function(elem, value) {
        var t = $(elem).css('transit:transform');
        t.setFromString(prop, value);

        $(elem).css({ 'transit:transform': t });
      }
    };

  }

  // ### uncamel(str)
  // Converts a camelcase string to a dasherized string.
  // (`marginLeft` => `margin-left`)
  function uncamel(str) {
    return str.replace(/([A-Z])/g, function(letter) { return '-' + letter.toLowerCase(); });
  }

  // ### unit(number, unit)
  // Ensures that number `number` has a unit. If no unit is found, assume the
  // default is `unit`.
  //
  //     unit(2, 'px')          //=> "2px"
  //     unit("30deg", 'rad')   //=> "30deg"
  //
  function unit(i, units) {
    if ((typeof i === "string") && (!i.match(/^[\-0-9\.]+$/))) {
      return i;
    } else {
      return "" + i + units;
    }
  }

  // ### toMS(duration)
  // Converts given `duration` to a millisecond string.
  //
  // toMS('fast') => $.fx.speeds[i] => "200ms"
  // toMS('normal') //=> $.fx.speeds._default => "400ms"
  // toMS(10) //=> '10ms'
  // toMS('100ms') //=> '100ms'  
  //
  function toMS(duration) {
    var i = duration;

    // Allow string durations like 'fast' and 'slow', without overriding numeric values.
    if (typeof i === 'string' && (!i.match(/^[\-0-9\.]+/))) { i = $.fx.speeds[i] || $.fx.speeds._default; }

    return unit(i, 'ms');
  }

  // Export some functions for testable-ness.
  $.transit.getTransitionValue = getTransition;

  return $;
}));

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server.base/node_modules/jquery/dist/jquery.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/node_modules/jquery/dist/jquery.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/clone.js":[function(require,module,exports){

var isArray = (typeof Array.isArray === 'function') ?
  // use native function
  Array.isArray :
  // use instanceof operator
  function(a) {
    return a instanceof Array;
  };

function cloneRegExp(re) {
  var regexMatch = /^\/(.*)\/([gimyu]*)$/.exec(re.toString());
  return new RegExp(regexMatch[1], regexMatch[2]);
}

function clone(arg) {
  if (typeof arg !== 'object') {
    return arg;
  }
  if (arg === null) {
    return null;
  }
  if (isArray(arg)) {
    return arg.map(clone);
  }
  if (arg instanceof Date) {
    return new Date(arg.getTime());
  }
  if (arg instanceof RegExp) {
    return cloneRegExp(arg);
  }
  var cloned = {};
  for (var name in arg) {
    if (Object.prototype.hasOwnProperty.call(arg, name)) {
      cloned[name] = clone(arg[name]);
    }
  }
  return cloned;
}

module.exports = clone;

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/context.js":[function(require,module,exports){

var Pipe = require('../pipe').Pipe;

var Context = function Context(){
};

Context.prototype.setResult = function(result) {
	this.result = result;
	this.hasResult = true;
	return this;
};

Context.prototype.exit = function() {
	this.exiting = true;
	return this;
};

Context.prototype.switchTo = function(next, pipe) {
	if (typeof next === 'string' || next instanceof Pipe) {
		this.nextPipe = next;
	} else {
		this.next = next;
		if (pipe) {
			this.nextPipe = pipe;
		}
	}
	return this;
};

Context.prototype.push = function(child, name) {
	child.parent = this;
	if (typeof name !== 'undefined') {
		child.childName = name;
	}
	child.root = this.root || this;
	child.options = child.options || this.options;
	if (!this.children) {
		this.children = [child];
		this.nextAfterChildren = this.next || null;
		this.next = child;
	} else {
		this.children[this.children.length - 1].next = child;
		this.children.push(child);
	}
	child.next = this;
	return this;
};

exports.Context = Context;

},{"../pipe":"/usr/var/server.base/node_modules/jsondiffpatch/src/pipe.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/diff.js":[function(require,module,exports){
var Context = require('./context').Context;
var defaultClone = require('../clone');

var DiffContext = function DiffContext(left, right) {
  this.left = left;
  this.right = right;
  this.pipe = 'diff';
};

DiffContext.prototype = new Context();

DiffContext.prototype.setResult = function(result) {
  if (this.options.cloneDiffValues && typeof result === 'object') {
    var clone = typeof this.options.cloneDiffValues === 'function' ?
      this.options.cloneDiffValues : defaultClone;
    if (typeof result[0] === 'object') {
      result[0] = clone(result[0]);
    }
    if (typeof result[1] === 'object') {
      result[1] = clone(result[1]);
    }
  }
  return Context.prototype.setResult.apply(this, arguments);
};

exports.DiffContext = DiffContext;

},{"../clone":"/usr/var/server.base/node_modules/jsondiffpatch/src/clone.js","./context":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/context.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/patch.js":[function(require,module,exports){
var Context = require('./context').Context;

var PatchContext = function PatchContext(left, delta) {
  this.left = left;
  this.delta = delta;
  this.pipe = 'patch';
};

PatchContext.prototype = new Context();

exports.PatchContext = PatchContext;

},{"./context":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/context.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/reverse.js":[function(require,module,exports){
var Context = require('./context').Context;

var ReverseContext = function ReverseContext(delta) {
  this.delta = delta;
  this.pipe = 'reverse';
};

ReverseContext.prototype = new Context();

exports.ReverseContext = ReverseContext;

},{"./context":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/context.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/date-reviver.js":[function(require,module,exports){
// use as 2nd parameter for JSON.parse to revive Date instances
module.exports = function dateReviver(key, value) {
  var parts;
  if (typeof value === 'string') {
    parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d*))?(Z|([+\-])(\d{2}):(\d{2}))$/.exec(value);
    if (parts) {
      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +(parts[7] || 0)));
    }
  }
  return value;
};

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/diffpatcher.js":[function(require,module,exports){
var Processor = require('./processor').Processor;
var Pipe = require('./pipe').Pipe;
var DiffContext = require('./contexts/diff').DiffContext;
var PatchContext = require('./contexts/patch').PatchContext;
var ReverseContext = require('./contexts/reverse').ReverseContext;

var clone = require('./clone');

var trivial = require('./filters/trivial');
var nested = require('./filters/nested');
var arrays = require('./filters/arrays');
var dates = require('./filters/dates');
var texts = require('./filters/texts');

var DiffPatcher = function DiffPatcher(options) {
  this.processor = new Processor(options);
  this.processor.pipe(new Pipe('diff').append(
    nested.collectChildrenDiffFilter,
    trivial.diffFilter,
    dates.diffFilter,
    texts.diffFilter,
    nested.objectsDiffFilter,
    arrays.diffFilter
  ).shouldHaveResult());
  this.processor.pipe(new Pipe('patch').append(
    nested.collectChildrenPatchFilter,
    arrays.collectChildrenPatchFilter,
    trivial.patchFilter,
    texts.patchFilter,
    nested.patchFilter,
    arrays.patchFilter
  ).shouldHaveResult());
  this.processor.pipe(new Pipe('reverse').append(
    nested.collectChildrenReverseFilter,
    arrays.collectChildrenReverseFilter,
    trivial.reverseFilter,
    texts.reverseFilter,
    nested.reverseFilter,
    arrays.reverseFilter
  ).shouldHaveResult());
};

DiffPatcher.prototype.options = function() {
  return this.processor.options.apply(this.processor, arguments);
};

DiffPatcher.prototype.diff = function(left, right) {
  return this.processor.process(new DiffContext(left, right));
};

DiffPatcher.prototype.patch = function(left, delta) {
  return this.processor.process(new PatchContext(left, delta));
};

DiffPatcher.prototype.reverse = function(delta) {
  return this.processor.process(new ReverseContext(delta));
};

DiffPatcher.prototype.unpatch = function(right, delta) {
  return this.patch(right, this.reverse(delta));
};

DiffPatcher.prototype.clone = function(value) {
  return clone(value);
};

exports.DiffPatcher = DiffPatcher;

},{"./clone":"/usr/var/server.base/node_modules/jsondiffpatch/src/clone.js","./contexts/diff":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/diff.js","./contexts/patch":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/patch.js","./contexts/reverse":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/reverse.js","./filters/arrays":"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/arrays.js","./filters/dates":"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/dates.js","./filters/nested":"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/nested.js","./filters/texts":"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/texts.js","./filters/trivial":"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/trivial.js","./pipe":"/usr/var/server.base/node_modules/jsondiffpatch/src/pipe.js","./processor":"/usr/var/server.base/node_modules/jsondiffpatch/src/processor.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/environment.js":[function(require,module,exports){

exports.isBrowser = typeof window !== 'undefined';

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/arrays.js":[function(require,module,exports){
var DiffContext = require('../contexts/diff').DiffContext;
var PatchContext = require('../contexts/patch').PatchContext;
var ReverseContext = require('../contexts/reverse').ReverseContext;

var lcs = require('./lcs');

var ARRAY_MOVE = 3;

var isArray = (typeof Array.isArray === 'function') ?
  // use native function
  Array.isArray :
  // use instanceof operator
  function(a) {
    return a instanceof Array;
  };

var arrayIndexOf = typeof Array.prototype.indexOf === 'function' ?
  function(array, item) {
    return array.indexOf(item);
  } : function(array, item) {
    var length = array.length;
    for (var i = 0; i < length; i++) {
      if (array[i] === item) {
        return i;
      }
    }
    return -1;
  };

function arraysHaveMatchByRef(array1, array2, len1, len2) {
  for (var index1 = 0; index1 < len1; index1++) {
    var val1 = array1[index1];
    for (var index2 = 0; index2 < len2; index2++) {
      var val2 = array2[index2];
      if (index1 !== index2 && val1 === val2) {
        return true;
      }
    }
  }
}

function matchItems(array1, array2, index1, index2, context) {
  var value1 = array1[index1];
  var value2 = array2[index2];
  if (value1 === value2) {
    return true;
  }
  if (typeof value1 !== 'object' || typeof value2 !== 'object') {
    return false;
  }
  var objectHash = context.objectHash;
  if (!objectHash) {
    // no way to match objects was provided, try match by position
    return context.matchByPosition && index1 === index2;
  }
  var hash1;
  var hash2;
  if (typeof index1 === 'number') {
    context.hashCache1 = context.hashCache1 || [];
    hash1 = context.hashCache1[index1];
    if (typeof hash1 === 'undefined') {
      context.hashCache1[index1] = hash1 = objectHash(value1, index1);
    }
  } else {
    hash1 = objectHash(value1);
  }
  if (typeof hash1 === 'undefined') {
    return false;
  }
  if (typeof index2 === 'number') {
    context.hashCache2 = context.hashCache2 || [];
    hash2 = context.hashCache2[index2];
    if (typeof hash2 === 'undefined') {
      context.hashCache2[index2] = hash2 = objectHash(value2, index2);
    }
  } else {
    hash2 = objectHash(value2);
  }
  if (typeof hash2 === 'undefined') {
    return false;
  }
  return hash1 === hash2;
}

var diffFilter = function arraysDiffFilter(context) {
  if (!context.leftIsArray) {
    return;
  }

  var matchContext = {
    objectHash: context.options && context.options.objectHash,
    matchByPosition: context.options && context.options.matchByPosition
  };
  var commonHead = 0;
  var commonTail = 0;
  var index;
  var index1;
  var index2;
  var array1 = context.left;
  var array2 = context.right;
  var len1 = array1.length;
  var len2 = array2.length;

  var child;

  if (len1 > 0 && len2 > 0 && !matchContext.objectHash &&
    typeof matchContext.matchByPosition !== 'boolean') {
    matchContext.matchByPosition = !arraysHaveMatchByRef(array1, array2, len1, len2);
  }

  // separate common head
  while (commonHead < len1 && commonHead < len2 &&
    matchItems(array1, array2, commonHead, commonHead, matchContext)) {
    index = commonHead;
    child = new DiffContext(context.left[index], context.right[index]);
    context.push(child, index);
    commonHead++;
  }
  // separate common tail
  while (commonTail + commonHead < len1 && commonTail + commonHead < len2 &&
    matchItems(array1, array2, len1 - 1 - commonTail, len2 - 1 - commonTail, matchContext)) {
    index1 = len1 - 1 - commonTail;
    index2 = len2 - 1 - commonTail;
    child = new DiffContext(context.left[index1], context.right[index2]);
    context.push(child, index2);
    commonTail++;
  }
  var result;
  if (commonHead + commonTail === len1) {
    if (len1 === len2) {
      // arrays are identical
      context.setResult(undefined).exit();
      return;
    }
    // trivial case, a block (1 or more consecutive items) was added
    result = result || {
      _t: 'a'
    };
    for (index = commonHead; index < len2 - commonTail; index++) {
      result[index] = [array2[index]];
    }
    context.setResult(result).exit();
    return;
  }
  if (commonHead + commonTail === len2) {
    // trivial case, a block (1 or more consecutive items) was removed
    result = result || {
      _t: 'a'
    };
    for (index = commonHead; index < len1 - commonTail; index++) {
      result['_' + index] = [array1[index], 0, 0];
    }
    context.setResult(result).exit();
    return;
  }
  // reset hash cache
  delete matchContext.hashCache1;
  delete matchContext.hashCache2;

  // diff is not trivial, find the LCS (Longest Common Subsequence)
  var trimmed1 = array1.slice(commonHead, len1 - commonTail);
  var trimmed2 = array2.slice(commonHead, len2 - commonTail);
  var seq = lcs.get(
    trimmed1, trimmed2,
    matchItems,
    matchContext
  );
  var removedItems = [];
  result = result || {
    _t: 'a'
  };
  for (index = commonHead; index < len1 - commonTail; index++) {
    if (arrayIndexOf(seq.indices1, index - commonHead) < 0) {
      // removed
      result['_' + index] = [array1[index], 0, 0];
      removedItems.push(index);
    }
  }

  var detectMove = true;
  if (context.options && context.options.arrays && context.options.arrays.detectMove === false) {
    detectMove = false;
  }
  var includeValueOnMove = false;
  if (context.options && context.options.arrays && context.options.arrays.includeValueOnMove) {
    includeValueOnMove = true;
  }

  var removedItemsLength = removedItems.length;
  for (index = commonHead; index < len2 - commonTail; index++) {
    var indexOnArray2 = arrayIndexOf(seq.indices2, index - commonHead);
    if (indexOnArray2 < 0) {
      // added, try to match with a removed item and register as position move
      var isMove = false;
      if (detectMove && removedItemsLength > 0) {
        for (var removeItemIndex1 = 0; removeItemIndex1 < removedItemsLength; removeItemIndex1++) {
          index1 = removedItems[removeItemIndex1];
          if (matchItems(trimmed1, trimmed2, index1 - commonHead,
            index - commonHead, matchContext)) {
            // store position move as: [originalValue, newPosition, ARRAY_MOVE]
            result['_' + index1].splice(1, 2, index, ARRAY_MOVE);
            if (!includeValueOnMove) {
              // don't include moved value on diff, to save bytes
              result['_' + index1][0] = '';
            }

            index2 = index;
            child = new DiffContext(context.left[index1], context.right[index2]);
            context.push(child, index2);
            removedItems.splice(removeItemIndex1, 1);
            isMove = true;
            break;
          }
        }
      }
      if (!isMove) {
        // added
        result[index] = [array2[index]];
      }
    } else {
      // match, do inner diff
      index1 = seq.indices1[indexOnArray2] + commonHead;
      index2 = seq.indices2[indexOnArray2] + commonHead;
      child = new DiffContext(context.left[index1], context.right[index2]);
      context.push(child, index2);
    }
  }

  context.setResult(result).exit();

};
diffFilter.filterName = 'arrays';

var compare = {
  numerically: function(a, b) {
    return a - b;
  },
  numericallyBy: function(name) {
    return function(a, b) {
      return a[name] - b[name];
    };
  }
};

var patchFilter = function nestedPatchFilter(context) {
  if (!context.nested) {
    return;
  }
  if (context.delta._t !== 'a') {
    return;
  }
  var index, index1;

  var delta = context.delta;
  var array = context.left;

  // first, separate removals, insertions and modifications
  var toRemove = [];
  var toInsert = [];
  var toModify = [];
  for (index in delta) {
    if (index !== '_t') {
      if (index[0] === '_') {
        // removed item from original array
        if (delta[index][2] === 0 || delta[index][2] === ARRAY_MOVE) {
          toRemove.push(parseInt(index.slice(1), 10));
        } else {
          throw new Error('only removal or move can be applied at original array indices' +
            ', invalid diff type: ' + delta[index][2]);
        }
      } else {
        if (delta[index].length === 1) {
          // added item at new array
          toInsert.push({
            index: parseInt(index, 10),
            value: delta[index][0]
          });
        } else {
          // modified item at new array
          toModify.push({
            index: parseInt(index, 10),
            delta: delta[index]
          });
        }
      }
    }
  }

  // remove items, in reverse order to avoid sawing our own floor
  toRemove = toRemove.sort(compare.numerically);
  for (index = toRemove.length - 1; index >= 0; index--) {
    index1 = toRemove[index];
    var indexDiff = delta['_' + index1];
    var removedValue = array.splice(index1, 1)[0];
    if (indexDiff[2] === ARRAY_MOVE) {
      // reinsert later
      toInsert.push({
        index: indexDiff[1],
        value: removedValue
      });
    }
  }

  // insert items, in reverse order to avoid moving our own floor
  toInsert = toInsert.sort(compare.numericallyBy('index'));
  var toInsertLength = toInsert.length;
  for (index = 0; index < toInsertLength; index++) {
    var insertion = toInsert[index];
    array.splice(insertion.index, 0, insertion.value);
  }

  // apply modifications
  var toModifyLength = toModify.length;
  var child;
  if (toModifyLength > 0) {
    for (index = 0; index < toModifyLength; index++) {
      var modification = toModify[index];
      child = new PatchContext(context.left[modification.index], modification.delta);
      context.push(child, modification.index);
    }
  }

  if (!context.children) {
    context.setResult(context.left).exit();
    return;
  }
  context.exit();
};
patchFilter.filterName = 'arrays';

var collectChildrenPatchFilter = function collectChildrenPatchFilter(context) {
  if (!context || !context.children) {
    return;
  }
  if (context.delta._t !== 'a') {
    return;
  }
  var length = context.children.length;
  var child;
  for (var index = 0; index < length; index++) {
    child = context.children[index];
    context.left[child.childName] = child.result;
  }
  context.setResult(context.left).exit();
};
collectChildrenPatchFilter.filterName = 'arraysCollectChildren';

var reverseFilter = function arraysReverseFilter(context) {
  if (!context.nested) {
    if (context.delta[2] === ARRAY_MOVE) {
      context.newName = '_' + context.delta[1];
      context.setResult([context.delta[0], parseInt(context.childName.substr(1), 10), ARRAY_MOVE]).exit();
    }
    return;
  }
  if (context.delta._t !== 'a') {
    return;
  }
  var name, child;
  for (name in context.delta) {
    if (name === '_t') {
      continue;
    }
    child = new ReverseContext(context.delta[name]);
    context.push(child, name);
  }
  context.exit();
};
reverseFilter.filterName = 'arrays';

var reverseArrayDeltaIndex = function(delta, index, itemDelta) {
  if (typeof index === 'string' && index[0] === '_') {
    return parseInt(index.substr(1), 10);
  } else if (isArray(itemDelta) && itemDelta[2] === 0) {
    return '_' + index;
  }

  var reverseIndex = +index;
  for (var deltaIndex in delta) {
    var deltaItem = delta[deltaIndex];
    if (isArray(deltaItem)) {
      if (deltaItem[2] === ARRAY_MOVE) {
        var moveFromIndex = parseInt(deltaIndex.substr(1), 10);
        var moveToIndex = deltaItem[1];
        if (moveToIndex === +index) {
          return moveFromIndex;
        }
        if (moveFromIndex <= reverseIndex && moveToIndex > reverseIndex) {
          reverseIndex++;
        } else if (moveFromIndex >= reverseIndex && moveToIndex < reverseIndex) {
          reverseIndex--;
        }
      } else if (deltaItem[2] === 0) {
        var deleteIndex = parseInt(deltaIndex.substr(1), 10);
        if (deleteIndex <= reverseIndex) {
          reverseIndex++;
        }
      } else if (deltaItem.length === 1 && deltaIndex <= reverseIndex) {
        reverseIndex--;
      }
    }
  }

  return reverseIndex;
};

var collectChildrenReverseFilter = function collectChildrenReverseFilter(context) {
  if (!context || !context.children) {
    return;
  }
  if (context.delta._t !== 'a') {
    return;
  }
  var length = context.children.length;
  var child;
  var delta = {
    _t: 'a'
  };

  for (var index = 0; index < length; index++) {
    child = context.children[index];
    var name = child.newName;
    if (typeof name === 'undefined') {
      name = reverseArrayDeltaIndex(context.delta, child.childName, child.result);
    }
    if (delta[name] !== child.result) {
      delta[name] = child.result;
    }
  }
  context.setResult(delta).exit();
};
collectChildrenReverseFilter.filterName = 'arraysCollectChildren';

exports.diffFilter = diffFilter;
exports.patchFilter = patchFilter;
exports.collectChildrenPatchFilter = collectChildrenPatchFilter;
exports.reverseFilter = reverseFilter;
exports.collectChildrenReverseFilter = collectChildrenReverseFilter;

},{"../contexts/diff":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/diff.js","../contexts/patch":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/patch.js","../contexts/reverse":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/reverse.js","./lcs":"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/lcs.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/dates.js":[function(require,module,exports){
var diffFilter = function datesDiffFilter(context) {
  if (context.left instanceof Date) {
    if (context.right instanceof Date) {
      if (context.left.getTime() !== context.right.getTime()) {
        context.setResult([context.left, context.right]);
      } else {
        context.setResult(undefined);
      }
    } else {
      context.setResult([context.left, context.right]);
    }
    context.exit();
  } else if (context.right instanceof Date) {
    context.setResult([context.left, context.right]).exit();
  }
};
diffFilter.filterName = 'dates';

exports.diffFilter = diffFilter;

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/lcs.js":[function(require,module,exports){
/*

LCS implementation that supports arrays or strings

reference: http://en.wikipedia.org/wiki/Longest_common_subsequence_problem

*/

var defaultMatch = function(array1, array2, index1, index2) {
  return array1[index1] === array2[index2];
};

var lengthMatrix = function(array1, array2, match, context) {
  var len1 = array1.length;
  var len2 = array2.length;
  var x, y;

  // initialize empty matrix of len1+1 x len2+1
  var matrix = [len1 + 1];
  for (x = 0; x < len1 + 1; x++) {
    matrix[x] = [len2 + 1];
    for (y = 0; y < len2 + 1; y++) {
      matrix[x][y] = 0;
    }
  }
  matrix.match = match;
  // save sequence lengths for each coordinate
  for (x = 1; x < len1 + 1; x++) {
    for (y = 1; y < len2 + 1; y++) {
      if (match(array1, array2, x - 1, y - 1, context)) {
        matrix[x][y] = matrix[x - 1][y - 1] + 1;
      } else {
        matrix[x][y] = Math.max(matrix[x - 1][y], matrix[x][y - 1]);
      }
    }
  }
  return matrix;
};

var backtrack = function(matrix, array1, array2, index1, index2, context) {
  if (index1 === 0 || index2 === 0) {
    return {
      sequence: [],
      indices1: [],
      indices2: []
    };
  }

  if (matrix.match(array1, array2, index1 - 1, index2 - 1, context)) {
    var subsequence = backtrack(matrix, array1, array2, index1 - 1, index2 - 1, context);
    subsequence.sequence.push(array1[index1 - 1]);
    subsequence.indices1.push(index1 - 1);
    subsequence.indices2.push(index2 - 1);
    return subsequence;
  }

  if (matrix[index1][index2 - 1] > matrix[index1 - 1][index2]) {
    return backtrack(matrix, array1, array2, index1, index2 - 1, context);
  } else {
    return backtrack(matrix, array1, array2, index1 - 1, index2, context);
  }
};

var get = function(array1, array2, match, context) {
  context = context || {};
  var matrix = lengthMatrix(array1, array2, match || defaultMatch, context);
  var result = backtrack(matrix, array1, array2, array1.length, array2.length, context);
  if (typeof array1 === 'string' && typeof array2 === 'string') {
    result.sequence = result.sequence.join('');
  }
  return result;
};

exports.get = get;

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/nested.js":[function(require,module,exports){
var DiffContext = require('../contexts/diff').DiffContext;
var PatchContext = require('../contexts/patch').PatchContext;
var ReverseContext = require('../contexts/reverse').ReverseContext;

var collectChildrenDiffFilter = function collectChildrenDiffFilter(context) {
  if (!context || !context.children) {
    return;
  }
  var length = context.children.length;
  var child;
  var result = context.result;
  for (var index = 0; index < length; index++) {
    child = context.children[index];
    if (typeof child.result === 'undefined') {
      continue;
    }
    result = result || {};
    result[child.childName] = child.result;
  }
  if (result && context.leftIsArray) {
    result._t = 'a';
  }
  context.setResult(result).exit();
};
collectChildrenDiffFilter.filterName = 'collectChildren';

var objectsDiffFilter = function objectsDiffFilter(context) {
  if (context.leftIsArray || context.leftType !== 'object') {
    return;
  }

  var name, child, propertyFilter = context.options.propertyFilter;
  for (name in context.left) {
    if (!Object.prototype.hasOwnProperty.call(context.left, name)) {
      continue;
    }
    if (propertyFilter && !propertyFilter(name, context)) {
      continue;
    }
    child = new DiffContext(context.left[name], context.right[name]);
    context.push(child, name);
  }
  for (name in context.right) {
    if (!Object.prototype.hasOwnProperty.call(context.right, name)) {
      continue;
    }
    if (propertyFilter && !propertyFilter(name, context)) {
      continue;
    }
    if (typeof context.left[name] === 'undefined') {
      child = new DiffContext(undefined, context.right[name]);
      context.push(child, name);
    }
  }

  if (!context.children || context.children.length === 0) {
    context.setResult(undefined).exit();
    return;
  }
  context.exit();
};
objectsDiffFilter.filterName = 'objects';

var patchFilter = function nestedPatchFilter(context) {
  if (!context.nested) {
    return;
  }
  if (context.delta._t) {
    return;
  }
  var name, child;
  for (name in context.delta) {
    child = new PatchContext(context.left[name], context.delta[name]);
    context.push(child, name);
  }
  context.exit();
};
patchFilter.filterName = 'objects';

var collectChildrenPatchFilter = function collectChildrenPatchFilter(context) {
  if (!context || !context.children) {
    return;
  }
  if (context.delta._t) {
    return;
  }
  var length = context.children.length;
  var child;
  for (var index = 0; index < length; index++) {
    child = context.children[index];
    if (Object.prototype.hasOwnProperty.call(context.left, child.childName) && child.result === undefined) {
      delete context.left[child.childName];
    } else if (context.left[child.childName] !== child.result) {
      context.left[child.childName] = child.result;
    }
  }
  context.setResult(context.left).exit();
};
collectChildrenPatchFilter.filterName = 'collectChildren';

var reverseFilter = function nestedReverseFilter(context) {
  if (!context.nested) {
    return;
  }
  if (context.delta._t) {
    return;
  }
  var name, child;
  for (name in context.delta) {
    child = new ReverseContext(context.delta[name]);
    context.push(child, name);
  }
  context.exit();
};
reverseFilter.filterName = 'objects';

var collectChildrenReverseFilter = function collectChildrenReverseFilter(context) {
  if (!context || !context.children) {
    return;
  }
  if (context.delta._t) {
    return;
  }
  var length = context.children.length;
  var child;
  var delta = {};
  for (var index = 0; index < length; index++) {
    child = context.children[index];
    if (delta[child.childName] !== child.result) {
      delta[child.childName] = child.result;
    }
  }
  context.setResult(delta).exit();
};
collectChildrenReverseFilter.filterName = 'collectChildren';

exports.collectChildrenDiffFilter = collectChildrenDiffFilter;
exports.objectsDiffFilter = objectsDiffFilter;
exports.patchFilter = patchFilter;
exports.collectChildrenPatchFilter = collectChildrenPatchFilter;
exports.reverseFilter = reverseFilter;
exports.collectChildrenReverseFilter = collectChildrenReverseFilter;

},{"../contexts/diff":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/diff.js","../contexts/patch":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/patch.js","../contexts/reverse":"/usr/var/server.base/node_modules/jsondiffpatch/src/contexts/reverse.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/texts.js":[function(require,module,exports){
/* global diff_match_patch */
var TEXT_DIFF = 2;
var DEFAULT_MIN_LENGTH = 60;
var cachedDiffPatch = null;

var getDiffMatchPatch = function(required) {
  /*jshint camelcase: false */

  if (!cachedDiffPatch) {
    var instance;
    if (typeof diff_match_patch !== 'undefined') {
      // already loaded, probably a browser
      instance = typeof diff_match_patch === 'function' ?
        new diff_match_patch() : new diff_match_patch.diff_match_patch();
    } else if (typeof require === 'function') {
      try {
        var dmpModuleName = 'diff_match_patch_uncompressed';
        var dmp = require('../../public/external/' + dmpModuleName);
        instance = new dmp.diff_match_patch();
      } catch (err) {
        instance = null;
      }
    }
    if (!instance) {
      if (!required) {
        return null;
      }
      var error = new Error('text diff_match_patch library not found');
      error.diff_match_patch_not_found = true;
      throw error;
    }
    cachedDiffPatch = {
      diff: function(txt1, txt2) {
        return instance.patch_toText(instance.patch_make(txt1, txt2));
      },
      patch: function(txt1, patch) {
        var results = instance.patch_apply(instance.patch_fromText(patch), txt1);
        for (var i = 0; i < results[1].length; i++) {
          if (!results[1][i]) {
            var error = new Error('text patch failed');
            error.textPatchFailed = true;
          }
        }
        return results[0];
      }
    };
  }
  return cachedDiffPatch;
};

var diffFilter = function textsDiffFilter(context) {
  if (context.leftType !== 'string') {
    return;
  }
  var minLength = (context.options && context.options.textDiff &&
    context.options.textDiff.minLength) || DEFAULT_MIN_LENGTH;
  if (context.left.length < minLength ||
    context.right.length < minLength) {
    context.setResult([context.left, context.right]).exit();
    return;
  }
  // large text, try to use a text-diff algorithm
  var diffMatchPatch = getDiffMatchPatch();
  if (!diffMatchPatch) {
    // diff-match-patch library not available, fallback to regular string replace
    context.setResult([context.left, context.right]).exit();
    return;
  }
  var diff = diffMatchPatch.diff;
  context.setResult([diff(context.left, context.right), 0, TEXT_DIFF]).exit();
};
diffFilter.filterName = 'texts';

var patchFilter = function textsPatchFilter(context) {
  if (context.nested) {
    return;
  }
  if (context.delta[2] !== TEXT_DIFF) {
    return;
  }

  // text-diff, use a text-patch algorithm
  var patch = getDiffMatchPatch(true).patch;
  context.setResult(patch(context.left, context.delta[0])).exit();
};
patchFilter.filterName = 'texts';

var textDeltaReverse = function(delta) {
  var i, l, lines, line, lineTmp, header = null,
    headerRegex = /^@@ +\-(\d+),(\d+) +\+(\d+),(\d+) +@@$/,
    lineHeader, lineAdd, lineRemove;
  lines = delta.split('\n');
  for (i = 0, l = lines.length; i < l; i++) {
    line = lines[i];
    var lineStart = line.slice(0, 1);
    if (lineStart === '@') {
      header = headerRegex.exec(line);
      lineHeader = i;
      lineAdd = null;
      lineRemove = null;

      // fix header
      lines[lineHeader] = '@@ -' + header[3] + ',' + header[4] + ' +' + header[1] + ',' + header[2] + ' @@';
    } else if (lineStart === '+') {
      lineAdd = i;
      lines[i] = '-' + lines[i].slice(1);
      if (lines[i - 1].slice(0, 1) === '+') {
        // swap lines to keep default order (-+)
        lineTmp = lines[i];
        lines[i] = lines[i - 1];
        lines[i - 1] = lineTmp;
      }
    } else if (lineStart === '-') {
      lineRemove = i;
      lines[i] = '+' + lines[i].slice(1);
    }
  }
  return lines.join('\n');
};

var reverseFilter = function textsReverseFilter(context) {
  if (context.nested) {
    return;
  }
  if (context.delta[2] !== TEXT_DIFF) {
    return;
  }

  // text-diff, use a text-diff algorithm
  context.setResult([textDeltaReverse(context.delta[0]), 0, TEXT_DIFF]).exit();
};
reverseFilter.filterName = 'texts';

exports.diffFilter = diffFilter;
exports.patchFilter = patchFilter;
exports.reverseFilter = reverseFilter;

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/filters/trivial.js":[function(require,module,exports){
var isArray = (typeof Array.isArray === 'function') ?
  // use native function
  Array.isArray :
  // use instanceof operator
  function(a) {
    return a instanceof Array;
  };

var diffFilter = function trivialMatchesDiffFilter(context) {
  if (context.left === context.right) {
    context.setResult(undefined).exit();
    return;
  }
  if (typeof context.left === 'undefined') {
    if (typeof context.right === 'function') {
      throw new Error('functions are not supported');
    }
    context.setResult([context.right]).exit();
    return;
  }
  if (typeof context.right === 'undefined') {
    context.setResult([context.left, 0, 0]).exit();
    return;
  }
  if (typeof context.left === 'function' || typeof context.right === 'function') {
    throw new Error('functions are not supported');
  }
  context.leftType = context.left === null ? 'null' : typeof context.left;
  context.rightType = context.right === null ? 'null' : typeof context.right;
  if (context.leftType !== context.rightType) {
    context.setResult([context.left, context.right]).exit();
    return;
  }
  if (context.leftType === 'boolean' || context.leftType === 'number') {
    context.setResult([context.left, context.right]).exit();
    return;
  }
  if (context.leftType === 'object') {
    context.leftIsArray = isArray(context.left);
  }
  if (context.rightType === 'object') {
    context.rightIsArray = isArray(context.right);
  }
  if (context.leftIsArray !== context.rightIsArray) {
    context.setResult([context.left, context.right]).exit();
    return;
  }

  if (context.left instanceof RegExp) {
    if (context.right instanceof RegExp) {
      context.setResult([context.left.toString(), context.right.toString()]).exit();
    } else {
      context.setResult([context.left, context.right]).exit();
      return;
    }
  }
};
diffFilter.filterName = 'trivial';

var patchFilter = function trivialMatchesPatchFilter(context) {
  if (typeof context.delta === 'undefined') {
    context.setResult(context.left).exit();
    return;
  }
  context.nested = !isArray(context.delta);
  if (context.nested) {
    return;
  }
  if (context.delta.length === 1) {
    context.setResult(context.delta[0]).exit();
    return;
  }
  if (context.delta.length === 2) {
    if (context.left instanceof RegExp) {
      var regexArgs = /^\/(.*)\/([gimyu]+)$/.exec(context.delta[1]);
      if (regexArgs) {
        context.setResult(new RegExp(regexArgs[1], regexArgs[2])).exit();
        return;
      }
    }
    context.setResult(context.delta[1]).exit();
    return;
  }
  if (context.delta.length === 3 && context.delta[2] === 0) {
    context.setResult(undefined).exit();
    return;
  }
};
patchFilter.filterName = 'trivial';

var reverseFilter = function trivialReferseFilter(context) {
  if (typeof context.delta === 'undefined') {
    context.setResult(context.delta).exit();
    return;
  }
  context.nested = !isArray(context.delta);
  if (context.nested) {
    return;
  }
  if (context.delta.length === 1) {
    context.setResult([context.delta[0], 0, 0]).exit();
    return;
  }
  if (context.delta.length === 2) {
    context.setResult([context.delta[1], context.delta[0]]).exit();
    return;
  }
  if (context.delta.length === 3 && context.delta[2] === 0) {
    context.setResult([context.delta[0]]).exit();
    return;
  }
};
reverseFilter.filterName = 'trivial';

exports.diffFilter = diffFilter;
exports.patchFilter = patchFilter;
exports.reverseFilter = reverseFilter;

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/main.js":[function(require,module,exports){

var environment = require('./environment');

var DiffPatcher = require('./diffpatcher').DiffPatcher;
exports.DiffPatcher = DiffPatcher;

exports.create = function(options){
  return new DiffPatcher(options);
};

exports.dateReviver = require('./date-reviver');

var defaultInstance;

exports.diff = function() {
  if (!defaultInstance) {
    defaultInstance = new DiffPatcher();
  }
  return defaultInstance.diff.apply(defaultInstance, arguments);
};

exports.patch = function() {
  if (!defaultInstance) {
    defaultInstance = new DiffPatcher();
  }
  return defaultInstance.patch.apply(defaultInstance, arguments);
};

exports.unpatch = function() {
  if (!defaultInstance) {
    defaultInstance = new DiffPatcher();
  }
  return defaultInstance.unpatch.apply(defaultInstance, arguments);
};

exports.reverse = function() {
  if (!defaultInstance) {
    defaultInstance = new DiffPatcher();
  }
  return defaultInstance.reverse.apply(defaultInstance, arguments);
};

exports.clone = function() {
  if (!defaultInstance) {
    defaultInstance = new DiffPatcher();
  }
  return defaultInstance.clone.apply(defaultInstance, arguments);
};


if (environment.isBrowser) {
  exports.homepage = '{{package-homepage}}';
  exports.version = '{{package-version}}';
} else {
  var packageInfoModuleName = '../package.json';
  var packageInfo = require(packageInfoModuleName);
  exports.homepage = packageInfo.homepage;
  exports.version = packageInfo.version;

  var formatterModuleName = './formatters';
  var formatters = require(formatterModuleName);
  exports.formatters = formatters;
  // shortcut for console
  exports.console = formatters.console;
}

},{"./date-reviver":"/usr/var/server.base/node_modules/jsondiffpatch/src/date-reviver.js","./diffpatcher":"/usr/var/server.base/node_modules/jsondiffpatch/src/diffpatcher.js","./environment":"/usr/var/server.base/node_modules/jsondiffpatch/src/environment.js"}],"/usr/var/server.base/node_modules/jsondiffpatch/src/pipe.js":[function(require,module,exports){
var Pipe = function Pipe(name) {
  this.name = name;
  this.filters = [];
};

Pipe.prototype.process = function(input) {
  if (!this.processor) {
    throw new Error('add this pipe to a processor before using it');
  }
  var debug = this.debug;
  var length = this.filters.length;
  var context = input;
  for (var index = 0; index < length; index++) {
    var filter = this.filters[index];
    if (debug) {
      this.log('filter: ' + filter.filterName);
    }
    filter(context);
    if (typeof context === 'object' && context.exiting) {
      context.exiting = false;
      break;
    }
  }
  if (!context.next && this.resultCheck) {
    this.resultCheck(context);
  }
};

Pipe.prototype.log = function(msg) {
  console.log('[jsondiffpatch] ' + this.name + ' pipe, ' + msg);
};

Pipe.prototype.append = function() {
  this.filters.push.apply(this.filters, arguments);
  return this;
};

Pipe.prototype.prepend = function() {
  this.filters.unshift.apply(this.filters, arguments);
  return this;
};

Pipe.prototype.indexOf = function(filterName) {
  if (!filterName) {
    throw new Error('a filter name is required');
  }
  for (var index = 0; index < this.filters.length; index++) {
    var filter = this.filters[index];
    if (filter.filterName === filterName) {
      return index;
    }
  }
  throw new Error('filter not found: ' + filterName);
};

Pipe.prototype.list = function() {
  var names = [];
  for (var index = 0; index < this.filters.length; index++) {
    var filter = this.filters[index];
    names.push(filter.filterName);
  }
  return names;
};

Pipe.prototype.after = function(filterName) {
  var index = this.indexOf(filterName);
  var params = Array.prototype.slice.call(arguments, 1);
  if (!params.length) {
    throw new Error('a filter is required');
  }
  params.unshift(index + 1, 0);
  Array.prototype.splice.apply(this.filters, params);
  return this;
};

Pipe.prototype.before = function(filterName) {
  var index = this.indexOf(filterName);
  var params = Array.prototype.slice.call(arguments, 1);
  if (!params.length) {
    throw new Error('a filter is required');
  }
  params.unshift(index, 0);
  Array.prototype.splice.apply(this.filters, params);
  return this;
};

Pipe.prototype.replace = function(filterName) {
  var index = this.indexOf(filterName);
  var params = Array.prototype.slice.call(arguments, 1);
  if (!params.length) {
    throw new Error('a filter is required');
  }
  params.unshift(index, 1);
  Array.prototype.splice.apply(this.filters, params);
  return this;
};

Pipe.prototype.remove = function(filterName) {
  var index = this.indexOf(filterName);
  this.filters.splice(index, 1);
  return this;
};

Pipe.prototype.clear = function() {
  this.filters.length = 0;
  return this;
};

Pipe.prototype.shouldHaveResult = function(should) {
  if (should === false) {
    this.resultCheck = null;
    return;
  }
  if (this.resultCheck) {
    return;
  }
  var pipe = this;
  this.resultCheck = function(context) {
    if (!context.hasResult) {
      console.log(context);
      var error = new Error(pipe.name + ' failed');
      error.noResult = true;
      throw error;
    }
  };
  return this;
};

exports.Pipe = Pipe;

},{}],"/usr/var/server.base/node_modules/jsondiffpatch/src/processor.js":[function(require,module,exports){

var Processor = function Processor(options){
  this.selfOptions = options || {};
  this.pipes = {};
};

Processor.prototype.options = function(options) {
  if (options) {
    this.selfOptions = options;
  }
  return this.selfOptions;
};

Processor.prototype.pipe = function(name, pipe) {
  if (typeof name === 'string') {
    if (typeof pipe === 'undefined') {
      return this.pipes[name];
    } else {
      this.pipes[name] = pipe;
    }
  }
  if (name && name.name) {
    pipe = name;
    if (pipe.processor === this) { return pipe; }
    this.pipes[pipe.name] = pipe;
  }
  pipe.processor = this;
  return pipe;
};

Processor.prototype.process = function(input, pipe) {
  var context = input;
  context.options = this.options();
  var nextPipe = pipe || input.pipe || 'default';
  var lastPipe, lastContext;
  while (nextPipe) {
    if (typeof context.nextAfterChildren !== 'undefined') {
      // children processed and coming back to parent
      context.next = context.nextAfterChildren;
      context.nextAfterChildren = null;
    }

    if (typeof nextPipe === 'string') {
      nextPipe = this.pipe(nextPipe);
    }
    nextPipe.process(context);
    lastContext = context;
    lastPipe = nextPipe;
    nextPipe = null;
    if (context) {
      if (context.next) {
        context = context.next;
        nextPipe = lastContext.nextPipe || context.pipe || lastPipe;
      }
    }
  }
  return context.hasResult ? context.result : undefined;
};

exports.Processor = Processor;

},{}],"/usr/var/server.base/node_modules/math-expressions/build/math-expressions_umd.js":[function(require,module,exports){
(function (Buffer,process,global){(function (){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.MathExpression = factory());
}(this, (function () { 'use strict';

  const get_tree = function (expr_or_tree) {

    if (expr_or_tree === undefined || expr_or_tree === null)
      return undefined;

    var tree;
    if (expr_or_tree.tree !== undefined)
      tree = expr_or_tree.tree;
    else
      tree = expr_or_tree;

    return tree;
  };


  function* subsets(arr, m) {
    // returns an iterator over all subsets of array arr
    // up to size m

    var n = arr.length;

    if (m === undefined)
      m = n;

    if (m === 0)
      return;

    for (let i = 0; i < n; i++) {
      yield [arr[i]];
    }

    if (m === 1)
      return

    for (let i = 0; i < n; i++) {
      let sub = subsets(arr.slice(i + 1), m - 1);
      for (let val of sub) {
        yield [arr[i]].concat(val);
      }
    }
  }

  var is_associative = { '+': true, '*': true, 'and': true, 'or': true, 'union': true, 'intersect': true };


  function flatten(expr) {
    // flatten tree with all associative operators

    var tree = get_tree(expr);

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    operands = operands.map(function (v, i) {
      return flatten(v);
    });

    if (is_associative[operator]) {
      var result = [];

      for (var i = 0; i < operands.length; i++) {
        if (Array.isArray(operands[i]) && (operands[i][0] === operator)) {
          result = result.concat(operands[i].slice(1));
        } else {
          result.push(operands[i]);
        }
      }

      operands = result;
    }

    return [operator].concat(operands);
  }
  const unflattenRight = function (expr) {
    // unflatten tree with associate operators
    // into a right heavy tree;

    var tree = get_tree(expr);

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    operands = operands.map(function (v, i) {
      return unflattenRight(v);
    });

    if (operands.length > 2 && is_associative[operator]) {
      var result = [operator, operands[0], undefined];
      var next = result;

      for (var i = 1; i < operands.length - 1; i++) {
        next[2] = [operator, operands[i], undefined];
        next = next[2];
      }

      next[2] = operands[operands.length - 1];

      return result;
    }

    return [operator].concat(operands);
  };

  const allChildren = function (tree) {
    // find all children of operator of tree as though it had been flattened

    if (!Array.isArray(tree))
      return [];

    var operator = tree[0];
    var operands = tree.slice(1);

    if (!is_associative[operator])
      return operands;

    return operands.reduce(function (a, b) {
      if (Array.isArray(b) && b[0] === operator) {
        return a.concat(allChildren(b));
      }
      else
        return a.concat([b]);
    }, []);

  };

  function remove_duplicate_negatives(tree) {
    // remove pairs of consecutive minus signs

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    if (operator === '-' && operands[0][0] === '-') {
      return remove_duplicate_negatives(operands[0][1]);
    }

    operands = operands.map(remove_duplicate_negatives);

    return [operator].concat(operands);

  }

  function normalize_negatives_in_factors(tree) {
    // if any factors contain a negative,
    // place negative outside factor
    //
    // run remove_duplicates_negatives before and after
    // running this function to make sure all negatives are addressed

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    operands = operands.map(normalize_negatives_in_factors);

    if (operator !== '*' && operator !== '/')
      return [operator].concat(operands);

    var sign = 1;
    var operands_no_negatives = [];

    for (var i = 0; i < operands.length; i++) {
      if (operands[i][0] === '-') {
        sign *= -1;
        operands_no_negatives.push(operands[i][1]);
      }
      else {
        operands_no_negatives.push(operands[i]);
      }
    }
    var result = [operator].concat(operands_no_negatives);
    if (sign === -1)
      result = ['-', result];

    return result;
  }


  function normalize_negatives(expr_or_tree) {
    // Remove duplicate negatives and pull all negatives outside factors
    var tree = get_tree(expr_or_tree);

    tree = remove_duplicate_negatives(tree);
    tree = normalize_negatives_in_factors(tree);
    tree = remove_duplicate_negatives(tree);

    return tree;
  }


  function sort_key(tree, params={}) {
    if (typeof tree === 'number') {
      if (params.ignore_negatives)
        return [0, 'number', Math.abs(tree)];
      return [0, 'number', tree];
    }
    if (typeof tree === 'string') {
      // if string is a constant, return number with value?
      return [1, 'symbol', tree];
    }
    if (typeof tree === 'boolean') {
      return [1, 'boolean', tree];
    }


    if (!Array.isArray(tree))
      return [-1, 'unknown', tree];


    var operator = tree[0];
    var operands = tree.slice(1);

    if (operator === 'apply') {
      var key = [2, 'function', operands[0]];

      var f_args = operands[1];

      var n_args = 1;

      var arg_keys = [];

      if (Array.isArray(f_args)) {

        f_args = f_args.slice(1);  // remove vector operator

        n_args = f_args.length;

        arg_keys = f_args.map(x=>sort_key(x,params));


      }
      else {
        arg_keys = [sort_key(f_args,params)];
      }

      key.push([n_args, arg_keys]);

      return key;
    }

    var n_factors = operands.length;

    var factor_keys = operands.map(sort_key, params);


    if (operator === "*") {
      return [4, 'product', n_factors, factor_keys];
    }

    if (operator === "/") {
      return [4, 'quotient', n_factors, factor_keys];
    }

    if (operator === "+") {
      return [5, 'sum', n_factors, factor_keys];
    }

    if (operator === "-") {
      if (params.ignore_negatives)
        return factor_keys[0];
      return [6, 'minus', n_factors, factor_keys];
    }


    return [7, operator, n_factors, factor_keys];

  }


  function arrayCompare(a,b) {
    if(Array.isArray(a)) {
      if(Array.isArray(b)) {
        let minLength = Math.min(a.length, b.length);
        for(let i=0; i < minLength; i++) {
          let comp = arrayCompare(a[i], b[i]);
          if(comp !== 0) {
            return comp;
          }
        }

        // shorter array comes first
        return a.length < b.length ? -1 : (a.length > b.length ? 1: 0);

      }else {
        // non array comes before array
        // a is the array
        return 1;
      }
    } else {
      if(Array.isArray(b)) {
        // non-array comes before array
        // b is the array
        return -1;
      } else {
        // got to two scalar
        return a < b ? -1 : (a > b ? 1: 0)
      }
    }
  }

  function compare_function(a, b, params={}) {

    var key_a = sort_key(a, params);
    var key_b = sort_key(b, params);

    return arrayCompare(key_a, key_b);
  }


  function coeff_factors_from_term(term, string_factors) {
    if(typeof term === "string") {
      let ind = string_factors.indexOf(term);
      if(ind === -1) {
        string_factors.push(term);
        ind = string_factors.length - 1;
      }
      let f = [];
      f[ind] = 1;
      return { factor_contains: f, coeff: 1}
    } else if(Array.isArray(term)) {
      let operator = term[0];
      let operands = term.slice(1);
      if(operator === '*') {
        let coeff = [];
        let f = [];
        for(let factor of operands) {
          if(typeof factor === "string") {
            let ind = string_factors.indexOf(factor);
            if(ind === -1) {
              string_factors.push(factor);
              ind = string_factors.length - 1;
            }
            if(f[ind] === undefined) {
              f[ind] = 0;
            }
            f[ind]++;
            continue;
          } else if(Array.isArray(factor) && factor[0] === "^" || factor[0] === '-') {
            let result = coeff_factors_from_term(factor, string_factors);
            for(let ind in result.factor_contains) {
              if(f[ind] === undefined) {
                f[ind] = 0;
              }
              f[ind] += result.factor_contains[ind];
            }
            if(result.coeff !== 1) {
              coeff.push(result.coeff);
            }
            continue;
          }
          coeff.push(factor);
        }

        if(coeff.length === 0) {
          coeff = 1;
        } else if(coeff.length === 1) {
          coeff = coeff[0];
        } else {
          coeff = ['*', ...coeff];
        }
        return { factor_contains: f, coeff: coeff};
      } else if(operator === '^') {
        let base = operands[0];
        let exponent = operands[1];
        let f=[];
        if(typeof base === "string" && Number.isFinite(exponent)) {
          let ind = string_factors.indexOf(base);
          if(ind === -1) {
            string_factors.push(base);
            ind = string_factors.length - 1;
          }
          f[ind] = exponent;
          return {factor_contains: f, coeff: 1}
        }
      } else if(operator === '-') {
        let result = coeff_factors_from_term(operands[0], string_factors);
        let coeff = -1;
        if(typeof result.coeff === "number") {
          coeff *= result.coeff;
        } else {
          coeff = ['-', result.coeff];
        }
        return {factor_contains: result.factor_contains, coeff: coeff};
      } else if(operator === '/') {
        let result = coeff_factors_from_term(operands[0], string_factors);
        let coeff = ['/', result.coeff, operands[1]];
        return {factor_contains: result.factor_contains, coeff: coeff};
      }
    }
    
    return {factor_contains: [], coeff: term}
  }

  function default_order(expr_or_tree, params) {

    if (params === undefined)
      params = {};

    var tree = get_tree(expr_or_tree);

    tree = flatten(tree);
    tree = normalize_negatives(tree);

    function sort_ast(subTree) {
      if (!Array.isArray(subTree))
        return subTree;

      var operator = subTree[0];
      var operands = subTree.slice(1);

      operands = operands.map(sort_ast);

      if (operator === "+" ) {

        // kludge to get sort order closer to lexographic order

        // TODO: clean this up

        // find all string factors
        let string_factors = [];
        let factors_by_term = [];
        let coeffs_by_term = [];
        for(let term of operands) {
          let result = coeff_factors_from_term(term, string_factors);
          factors_by_term.push(result.factor_contains);
          coeffs_by_term.push(result.coeff);
        }

        // factors_by_term = factors_by_term.map(x => Array.from(x, item => item || 0))

        let variableInfo = [];
        for(let [ind, varname] of string_factors.entries()) {
          let thisvar = {varname: varname, exponents_in_term: []};
          for(let j=0; j< factors_by_term.length; j++) {
            thisvar.exponents_in_term.push(factors_by_term[j][ind] || 0);
          }
          variableInfo.push(thisvar);
        }

        variableInfo.sort((a,b) => a.varname < b.varname ? -1 : 1);

        let sort_keys_by_term = [];

        for(let i=0; i< coeffs_by_term.length; i++) {
          let this_sort_key = variableInfo.reduce((a,c) => [...a, -c.exponents_in_term[i]],[]);
          this_sort_key.push(sort_key(coeffs_by_term[i], params));
          sort_keys_by_term.push(this_sort_key);
        }

        let terms_with_sort_key = [];

        for(let [ind,term] of operands.entries()) {
          terms_with_sort_key.push({
            term: term,
            sort_key: sort_keys_by_term[ind],
          });
        }

        terms_with_sort_key.sort((a,b) => arrayCompare(a.sort_key, b.sort_key));

        operands = terms_with_sort_key.map(x => x.term);

        // sort all operands of these arguments in default order
        // determined by compare function
        // operands.sort((a, b) => compare_function(a, b, params));
      }
      else if (operator === "*" || operator === "="
        || operator === "and" || operator === "or" || operator === "ne"
        || operator === "union" || operator === "intersect") {

        // TODO: determine if commutative

        // sort all operands of these arguments in default order
        // determined by compare function
        operands.sort((a, b) => compare_function(a, b, params));
      }
      else if (operator === ">" || operator === "ge") {
        // turn all greater thans to less thans

        operands = operands.reverse();
        if (operator === ">")
          operator = "<";
        else
          operator = "le";
      }
      else if (operator === "gts") {
        // turn all greater thans to less thans
        var args = operands[0];
        var strict = operands[1];

        if (args[0] !== 'tuple' || strict[0] !== 'tuple')
          // something wrong if args or strict are not tuples
          throw new Error("Badly formed ast");

        args = ['tuple'].concat(args.slice(1).reverse());
        strict = ['tuple'].concat(strict.slice(1).reverse());

        operator = "lts";
        operands = [args, strict];

      }
      else if (operator === 'ni' || operator === 'notni'
        || operator === 'superset' || operator === 'notsuperset') {
        // turn all containment operators to have larger set at right

        operands = operands.reverse();
        if (operator === 'ni')
          operator = 'in';
        else if (operator === 'notni')
          operator = 'notin';
        else if (operator === 'superset')
          operator = 'subset';
        else
          operator = 'notsubset';
      }
      else if (operator === '-') {
        // when negating a product with a numerical first factor
        // put negative sign in that first factor
        if (operands[0][0] === '*') {
          operands[0][1] = ['-', operands[0][1]];
          return operands[0];
        }
      }

      return [operator].concat(operands);
    }

    return normalize_negatives(sort_ast(tree));
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /**
   * Test whether a value is a BigNumber
   * @param {*} x
   * @return {boolean}
   */
  var isBigNumber = function isBigNumber(x) {
    return x && x.constructor.prototype.isBigNumber || false
  };

  var object = createCommonjsModule(function (module, exports) {



  /**
   * Clone an object
   *
   *     clone(x)
   *
   * Can clone any primitive type, array, and object.
   * If x has a function clone, this function will be invoked to clone the object.
   *
   * @param {*} x
   * @return {*} clone
   */
  exports.clone = function clone(x) {
    var type = typeof x;

    // immutable primitive types
    if (type === 'number' || type === 'string' || type === 'boolean' ||
        x === null || x === undefined) {
      return x;
    }

    // use clone function of the object when available
    if (typeof x.clone === 'function') {
      return x.clone();
    }

    // array
    if (Array.isArray(x)) {
      return x.map(function (value) {
        return clone(value);
      });
    }

    if (x instanceof Number)    return new Number(x.valueOf());
    if (x instanceof String)    return new String(x.valueOf());
    if (x instanceof Boolean)   return new Boolean(x.valueOf());
    if (x instanceof Date)      return new Date(x.valueOf());
    if (isBigNumber(x))         return x; // bignumbers are immutable
    if (x instanceof RegExp)  throw new TypeError('Cannot clone ' + x);  // TODO: clone a RegExp

    // object
    return exports.map(x, clone);
  };

  /**
   * Apply map to all properties of an object
   * @param {Object} object
   * @param {function} callback
   * @return {Object} Returns a copy of the object with mapped properties
   */
  exports.map = function(object, callback) {
    var clone = {};

    for (var key in object) {
      if (exports.hasOwnProperty(object, key)) {
        clone[key] = callback(object[key]);
      }
    }

    return clone;
  };

  /**
   * Extend object a with the properties of object b
   * @param {Object} a
   * @param {Object} b
   * @return {Object} a
   */
  exports.extend = function(a, b) {
    for (var prop in b) {
      if (exports.hasOwnProperty(b, prop)) {
        a[prop] = b[prop];
      }
    }
    return a;
  };

  /**
   * Deep extend an object a with the properties of object b
   * @param {Object} a
   * @param {Object} b
   * @returns {Object}
   */
  exports.deepExtend = function deepExtend (a, b) {
    // TODO: add support for Arrays to deepExtend
    if (Array.isArray(b)) {
      throw new TypeError('Arrays are not supported by deepExtend');
    }

    for (var prop in b) {
      if (exports.hasOwnProperty(b, prop)) {
        if (b[prop] && b[prop].constructor === Object) {
          if (a[prop] === undefined) {
            a[prop] = {};
          }
          if (a[prop].constructor === Object) {
            deepExtend(a[prop], b[prop]);
          }
          else {
            a[prop] = b[prop];
          }
        } else if (Array.isArray(b[prop])) {
          throw new TypeError('Arrays are not supported by deepExtend');
        } else {
          a[prop] = b[prop];
        }
      }
    }
    return a;
  };

  /**
   * Deep test equality of all fields in two pairs of arrays or objects.
   * @param {Array | Object} a
   * @param {Array | Object} b
   * @returns {boolean}
   */
  exports.deepEqual = function deepEqual (a, b) {
    var prop, i, len;
    if (Array.isArray(a)) {
      if (!Array.isArray(b)) {
        return false;
      }

      if (a.length != b.length) {
        return false;
      }

      for (i = 0, len = a.length; i < len; i++) {
        if (!exports.deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    else if (a instanceof Object) {
      if (Array.isArray(b) || !(b instanceof Object)) {
        return false;
      }

      for (prop in a) {
        //noinspection JSUnfilteredForInLoop
        if (!exports.deepEqual(a[prop], b[prop])) {
          return false;
        }
      }
      for (prop in b) {
        //noinspection JSUnfilteredForInLoop
        if (!exports.deepEqual(a[prop], b[prop])) {
          return false;
        }
      }
      return true;
    }
    else {
      return (typeof a === typeof b) && (a == b);
    }
  };

  /**
   * Test whether the current JavaScript engine supports Object.defineProperty
   * @returns {boolean} returns true if supported
   */
  exports.canDefineProperty = function () {
    // test needed for broken IE8 implementation
    try {
      if (Object.defineProperty) {
        Object.defineProperty({}, 'x', { get: function () {} });
        return true;
      }
    } catch (e) {}

    return false;
  };

  /**
   * Attach a lazy loading property to a constant.
   * The given function `fn` is called once when the property is first requested.
   * On older browsers (<IE8), the function will fall back to direct evaluation
   * of the properties value.
   * @param {Object} object   Object where to add the property
   * @param {string} prop     Property name
   * @param {Function} fn     Function returning the property value. Called
   *                          without arguments.
   */
  exports.lazy = function (object, prop, fn) {
    if (exports.canDefineProperty()) {
      var _uninitialized = true;
      var _value;
      Object.defineProperty(object, prop, {
        get: function () {
          if (_uninitialized) {
            _value = fn();
            _uninitialized = false;
          }
          return _value;
        },

        set: function (value) {
          _value = value;
          _uninitialized = false;
        },

        configurable: true,
        enumerable: true
      });
    }
    else {
      // fall back to immediate evaluation
      object[prop] = fn();
    }
  };

  /**
   * Traverse a path into an object.
   * When a namespace is missing, it will be created
   * @param {Object} object
   * @param {string} path   A dot separated string like 'name.space'
   * @return {Object} Returns the object at the end of the path
   */
  exports.traverse = function(object, path) {
    var obj = object;

    if (path) {
      var names = path.split('.');
      for (var i = 0; i < names.length; i++) {
        var name = names[i];
        if (!(name in obj)) {
          obj[name] = {};
        }
        obj = obj[name];
      }
    }

    return obj;
  };

  /**
   * A safe hasOwnProperty
   * @param {Object} object
   * @param {string} property
   */
  exports.hasOwnProperty = function (object, property) {
    return object && Object.hasOwnProperty.call(object, property);
  };

  /**
   * Test whether an object is a factory. a factory has fields:
   *
   * - factory: function (type: Object, config: Object, load: function, typed: function [, math: Object])   (required)
   * - name: string (optional)
   * - path: string    A dot separated path (optional)
   * - math: boolean   If true (false by default), the math namespace is passed
   *                   as fifth argument of the factory function
   *
   * @param {*} object
   * @returns {boolean}
   */
  exports.isFactory = function (object) {
    return object && typeof object.factory === 'function';
  };
  });
  var object_1 = object.clone;
  var object_2 = object.map;
  var object_3 = object.extend;
  var object_4 = object.deepExtend;
  var object_5 = object.deepEqual;
  var object_6 = object.canDefineProperty;
  var object_7 = object.lazy;
  var object_8 = object.traverse;
  var object_9 = object.isFactory;

  var typedFunction = createCommonjsModule(function (module, exports) {

  (function (root, factory) {
    if (typeof undefined === 'function' && undefined.amd) {
      // AMD. Register as an anonymous module.
      undefined([], factory);
    } else {
      // OldNode. Does not work with strict CommonJS, but
      // only CommonJS-like environments that support module.exports,
      // like OldNode.
      module.exports = factory();
    }
  }(commonjsGlobal, function () {

    function ok () {
      return true;
    }

    function notOk () {
      return false;
    }

    function undef () {
      return undefined;
    }

    /**
     * @typedef {{
     *   params: Param[],
     *   fn: function
     * }} Signature
     *
     * @typedef {{
     *   types: Type[],
     *   restParam: boolean
     * }} Param
     *
     * @typedef {{
     *   name: string,
     *   typeIndex: number,
     *   test: function,
     *   conversion?: ConversionDef,
     *   conversionIndex: number,
     * }} Type
     *
     * @typedef {{
     *   from: string,
     *   to: string,
     *   convert: function (*) : *
     * }} ConversionDef
     *
     * @typedef {{
     *   name: string,
     *   test: function(*) : boolean
     * }} TypeDef
     */

    // create a new instance of typed-function
    function create () {
      // data type tests
      var _types = [
        { name: 'number',    test: function (x) { return typeof x === 'number' } },
        { name: 'string',    test: function (x) { return typeof x === 'string' } },
        { name: 'boolean',   test: function (x) { return typeof x === 'boolean' } },
        { name: 'Function',  test: function (x) { return typeof x === 'function'} },
        { name: 'Array',     test: Array.isArray },
        { name: 'Date',      test: function (x) { return x instanceof Date } },
        { name: 'RegExp',    test: function (x) { return x instanceof RegExp } },
        { name: 'Object',    test: function (x) {
          return typeof x === 'object' && x.constructor === Object
        }},
        { name: 'null',      test: function (x) { return x === null } },
        { name: 'undefined', test: function (x) { return x === undefined } }
      ];

      var anyType = {
        name: 'any',
        test: ok
      };

      // types which need to be ignored
      var _ignore = [];

      // type conversions
      var _conversions = [];

      // This is a temporary object, will be replaced with a typed function at the end
      var typed = {
        types: _types,
        conversions: _conversions,
        ignore: _ignore
      };

      /**
       * Find the test function for a type
       * @param {String} typeName
       * @return {TypeDef} Returns the type definition when found,
       *                    Throws a TypeError otherwise
       */
      function findTypeByName (typeName) {
        var entry = findInArray(typed.types, function (entry) {
          return entry.name === typeName;
        });

        if (entry) {
          return entry;
        }

        if (typeName === 'any') { // special baked-in case 'any'
          return anyType;
        }

        var hint = findInArray(typed.types, function (entry) {
          return entry.name.toLowerCase() === typeName.toLowerCase();
        });

        throw new TypeError('Unknown type "' + typeName + '"' +
            (hint ? ('. Did you mean "' + hint.name + '"?') : ''));
      }

      /**
       * Find the index of a type definition. Handles special case 'any'
       * @param {TypeDef} type
       * @return {number}
       */
      function findTypeIndex(type) {
        if (type === anyType) {
          return 999;
        }

        return typed.types.indexOf(type);
      }

      /**
       * Find a type that matches a value.
       * @param {*} value
       * @return {string} Returns the name of the first type for which
       *                  the type test matches the value.
       */
      function findTypeName(value) {
        var entry = findInArray(typed.types, function (entry) {
          return entry.test(value);
        });

        if (entry) {
          return entry.name;
        }

        throw new TypeError('Value has unknown type. Value: ' + value);
      }

      /**
       * Find a specific signature from a (composed) typed function, for example:
       *
       *   typed.find(fn, ['number', 'string'])
       *   typed.find(fn, 'number, string')
       *
       * Function find only only works for exact matches.
       *
       * @param {Function} fn                   A typed-function
       * @param {string | string[]} signature   Signature to be found, can be
       *                                        an array or a comma separated string.
       * @return {Function}                     Returns the matching signature, or
       *                                        throws an error when no signature
       *                                        is found.
       */
      function find (fn, signature) {
        if (!fn.signatures) {
          throw new TypeError('Function is no typed-function');
        }

        // normalize input
        var arr;
        if (typeof signature === 'string') {
          arr = signature.split(',');
          for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].trim();
          }
        }
        else if (Array.isArray(signature)) {
          arr = signature;
        }
        else {
          throw new TypeError('String array or a comma separated string expected');
        }

        var str = arr.join(',');

        // find an exact match
        var match = fn.signatures[str];
        if (match) {
          return match;
        }

        // TODO: extend find to match non-exact signatures

        throw new TypeError('Signature not found (signature: ' + (fn.name || 'unnamed') + '(' + arr.join(', ') + '))');
      }

      /**
       * Convert a given value to another data type.
       * @param {*} value
       * @param {string} type
       */
      function convert (value, type) {
        var from = findTypeName(value);

        // check conversion is needed
        if (type === from) {
          return value;
        }

        for (var i = 0; i < typed.conversions.length; i++) {
          var conversion = typed.conversions[i];
          if (conversion.from === from && conversion.to === type) {
            return conversion.convert(value);
          }
        }

        throw new Error('Cannot convert from ' + from + ' to ' + type);
      }
      
      /**
       * Stringify parameters in a normalized way
       * @param {Param[]} params
       * @return {string}
       */
      function stringifyParams (params) {
        return params
            .map(function (param) {
              var typeNames = param.types.map(getTypeName);

              return (param.restParam ? '...' : '') + typeNames.join('|');
            })
            .join(',');
      }

      /**
       * Parse a parameter, like "...number | boolean"
       * @param {string} param
       * @param {ConversionDef[]} conversions
       * @return {Param} param
       */
      function parseParam (param, conversions) {
        var restParam = param.indexOf('...') === 0;
        var types = (!restParam)
            ? param
            : (param.length > 3)
                ? param.slice(3)
                : 'any';

        var typeNames = types.split('|').map(trim)
            .filter(notEmpty)
            .filter(notIgnore);

        var matchingConversions = filterConversions(conversions, typeNames);

        var exactTypes = typeNames.map(function (typeName) {
          var type = findTypeByName(typeName);

          return {
            name: typeName,
            typeIndex: findTypeIndex(type),
            test: type.test,
            conversion: null,
            conversionIndex: -1
          };
        });

        var convertibleTypes = matchingConversions.map(function (conversion) {
          var type = findTypeByName(conversion.from);

          return {
            name: conversion.from,
            typeIndex: findTypeIndex(type),
            test: type.test,
            conversion: conversion,
            conversionIndex: conversions.indexOf(conversion)
          };
        });

        return {
          types: exactTypes.concat(convertibleTypes),
          restParam: restParam
        };
      }

      /**
       * Parse a signature with comma separated parameters,
       * like "number | boolean, ...string"
       * @param {string} signature
       * @param {function} fn
       * @param {ConversionDef[]} conversions
       * @return {Signature | null} signature
       */
      function parseSignature (signature, fn, conversions) {
        var params = [];

        if (signature.trim() !== '') {
          params = signature
              .split(',')
              .map(trim)
              .map(function (param, index, array) {
                var parsedParam = parseParam(param, conversions);

                if (parsedParam.restParam && (index !== array.length - 1)) {
                  throw new SyntaxError('Unexpected rest parameter "' + param + '": ' +
                      'only allowed for the last parameter');
                }

                return parsedParam;
            });
        }

        if (params.some(isInvalidParam)) {
          // invalid signature: at least one parameter has no types
          // (they may have been filtered)
          return null;
        }

        return {
          params: params,
          fn: fn
        };
      }

      /**
       * Test whether a set of params contains a restParam
       * @param {Param[]} params
       * @return {boolean} Returns true when the last parameter is a restParam
       */
      function hasRestParam(params) {
        var param = last(params);
        return param ? param.restParam : false;
      }

      /**
       * Test whether a parameter contains conversions
       * @param {Param} param
       * @return {boolean} Returns true when at least one of the parameters
       *                   contains a conversion.
       */
      function hasConversions(param) {
        return param.types.some(function (type) {
          return type.conversion != null;
        });
      }

      /**
       * Create a type test for a single parameter, which can have one or multiple
       * types.
       * @param {Param} param
       * @return {function(x: *) : boolean} Returns a test function
       */
      function compileTest(param) {
        if (!param || param.types.length === 0) {
          // nothing to do
          return ok;
        }
        else if (param.types.length === 1) {
          return findTypeByName(param.types[0].name).test;
        }
        else if (param.types.length === 2) {
          var test0 = findTypeByName(param.types[0].name).test;
          var test1 = findTypeByName(param.types[1].name).test;
          return function or(x) {
            return test0(x) || test1(x);
          }
        }
        else { // param.types.length > 2
          var tests = param.types.map(function (type) {
            return findTypeByName(type.name).test;
          });
          return function or(x) {
            for (var i = 0; i < tests.length; i++) {
              if (tests[i](x)) {
                return true;
              }
            }
            return false;
          }
        }
      }

      /**
       * Create a test for all parameters of a signature
       * @param {Param[]} params
       * @return {function(args: Array<*>) : boolean}
       */
      function compileTests(params) {
        var tests, test0, test1;

        if (hasRestParam(params)) {
          // variable arguments like '...number'
          tests = initial(params).map(compileTest);
          var varIndex = tests.length;
          var lastTest = compileTest(last(params));
          var testRestParam = function (args) {
            for (var i = varIndex; i < args.length; i++) {
              if (!lastTest(args[i])) {
                return false;
              }
            }
            return true;
          };

          return function testArgs(args) {
            for (var i = 0; i < tests.length; i++) {
              if (!tests[i](args[i])) {
                return false;
              }
            }
            return testRestParam(args) && (args.length >= varIndex + 1);
          };
        }
        else {
          // no variable arguments
          if (params.length === 0) {
            return function testArgs(args) {
              return args.length === 0;
            };
          }
          else if (params.length === 1) {
            test0 = compileTest(params[0]);
            return function testArgs(args) {
              return test0(args[0]) && args.length === 1;
            };
          }
          else if (params.length === 2) {
            test0 = compileTest(params[0]);
            test1 = compileTest(params[1]);
            return function testArgs(args) {
              return test0(args[0]) && test1(args[1]) && args.length === 2;
            };
          }
          else { // arguments.length > 2
            tests = params.map(compileTest);
            return function testArgs(args) {
              for (var i = 0; i < tests.length; i++) {
                if (!tests[i](args[i])) {
                  return false;
                }
              }
              return args.length === tests.length;
            };
          }
        }
      }

      /**
       * Find the parameter at a specific index of a signature.
       * Handles rest parameters.
       * @param {Signature} signature
       * @param {number} index
       * @return {Param | null} Returns the matching parameter when found,
       *                        null otherwise.
       */
      function getParamAtIndex(signature, index) {
        return index < signature.params.length
            ? signature.params[index]
            : hasRestParam(signature.params)
                ? last(signature.params)
                : null
      }

      /**
       * Get all type names of a parameter
       * @param {Signature} signature
       * @param {number} index
       * @param {boolean} excludeConversions
       * @return {string[]} Returns an array with type names
       */
      function getExpectedTypeNames (signature, index, excludeConversions) {
        var param = getParamAtIndex(signature, index);
        var types = param
            ? excludeConversions
                    ? param.types.filter(isExactType)
                    : param.types
            : [];

        return types.map(getTypeName);
      }

      /**
       * Returns the name of a type
       * @param {Type} type
       * @return {string} Returns the type name
       */
      function getTypeName(type) {
        return type.name;
      }

      /**
       * Test whether a type is an exact type or conversion
       * @param {Type} type
       * @return {boolean} Returns true when
       */
      function isExactType(type) {
        return type.conversion === null || type.conversion === undefined;
      }

      /**
       * Helper function for creating error messages: create an array with
       * all available types on a specific argument index.
       * @param {Signature[]} signatures
       * @param {number} index
       * @return {string[]} Returns an array with available types
       */
      function mergeExpectedParams(signatures, index) {
        var typeNames = uniq(flatMap(signatures, function (signature) {
          return getExpectedTypeNames(signature, index, false);
        }));

        return (typeNames.indexOf('any') !== -1) ? ['any'] : typeNames;
      }

      /**
       * Create
       * @param {string} name             The name of the function
       * @param {array.<*>} args          The actual arguments passed to the function
       * @param {Signature[]} signatures  A list with available signatures
       * @return {TypeError} Returns a type error with additional data
       *                     attached to it in the property `data`
       */
      function createError(name, args, signatures) {
        var err, expected;
        var _name = name || 'unnamed';

        // test for wrong type at some index
        var matchingSignatures = signatures;
        var index;
        for (index = 0; index < args.length; index++) {
          var nextMatchingDefs = matchingSignatures.filter(function (signature) {
            var test = compileTest(getParamAtIndex(signature, index));
            return (index < signature.params.length || hasRestParam(signature.params)) &&
                test(args[index]);
          });

          if (nextMatchingDefs.length === 0) {
            // no matching signatures anymore, throw error "wrong type"
            expected = mergeExpectedParams(matchingSignatures, index);
            if (expected.length > 0) {
              var actualType = findTypeName(args[index]);

              err = new TypeError('Unexpected type of argument in function ' + _name +
                  ' (expected: ' + expected.join(' or ') +
                  ', actual: ' + actualType + ', index: ' + index + ')');
              err.data = {
                category: 'wrongType',
                fn: _name,
                index: index,
                actual: actualType,
                expected: expected
              };
              return err;
            }
          }
          else {
            matchingSignatures = nextMatchingDefs;
          }
        }

        // test for too few arguments
        var lengths = matchingSignatures.map(function (signature) {
          return hasRestParam(signature.params) ? Infinity : signature.params.length;
        });
        if (args.length < Math.min.apply(null, lengths)) {
          expected = mergeExpectedParams(matchingSignatures, index);
          err = new TypeError('Too few arguments in function ' + _name +
              ' (expected: ' + expected.join(' or ') +
              ', index: ' + args.length + ')');
          err.data = {
            category: 'tooFewArgs',
            fn: _name,
            index: args.length,
            expected: expected
          };
          return err;
        }

        // test for too many arguments
        var maxLength = Math.max.apply(null, lengths);
        if (args.length > maxLength) {
          err = new TypeError('Too many arguments in function ' + _name +
              ' (expected: ' + maxLength + ', actual: ' + args.length + ')');
          err.data = {
            category: 'tooManyArgs',
            fn: _name,
            index: args.length,
            expectedLength: maxLength
          };
          return err;
        }

        err = new TypeError('Arguments of type "' + args.join(', ') +
            '" do not match any of the defined signatures of function ' + _name + '.');
        err.data = {
          category: 'mismatch',
          actual: args.map(findTypeName)
        };
        return err;
      }

      /**
       * Find the lowest index of all exact types of a parameter (no conversions)
       * @param {Param} param
       * @return {number} Returns the index of the lowest type in typed.types
       */
      function getLowestTypeIndex (param) {
        var min = 999;

        for (var i = 0; i < param.types.length; i++) {
          if (isExactType(param.types[i])) {
            min = Math.min(min, param.types[i].typeIndex);
          }
        }

        return min;
      }

      /**
       * Find the lowest index of the conversion of all types of the parameter
       * having a conversion
       * @param {Param} param
       * @return {number} Returns the lowest index of the conversions of this type
       */
      function getLowestConversionIndex (param) {
        var min = 999;

        for (var i = 0; i < param.types.length; i++) {
          if (!isExactType(param.types[i])) {
            min = Math.min(min, param.types[i].conversionIndex);
          }
        }

        return min;
      }

      /**
       * Compare two params
       * @param {Param} param1
       * @param {Param} param2
       * @return {number} returns a negative number when param1 must get a lower
       *                  index than param2, a positive number when the opposite,
       *                  or zero when both are equal
       */
      function compareParams (param1, param2) {
        var c;

        // compare having a rest parameter or not
        c = param1.restParam - param2.restParam;
        if (c !== 0) {
          return c;
        }

        // compare having conversions or not
        c = hasConversions(param1) - hasConversions(param2);
        if (c !== 0) {
          return c;
        }

        // compare the index of the types
        c = getLowestTypeIndex(param1) - getLowestTypeIndex(param2);
        if (c !== 0) {
          return c;
        }

        // compare the index of any conversion
        return getLowestConversionIndex(param1) - getLowestConversionIndex(param2);
      }

      /**
       * Compare two signatures
       * @param {Signature} signature1
       * @param {Signature} signature2
       * @return {number} returns a negative number when param1 must get a lower
       *                  index than param2, a positive number when the opposite,
       *                  or zero when both are equal
       */
      function compareSignatures (signature1, signature2) {
        var len = Math.min(signature1.params.length, signature2.params.length);
        var i;
        var c;

        // compare whether the params have conversions at all or not
        c = signature1.params.some(hasConversions) - signature2.params.some(hasConversions);
        if (c !== 0) {
          return c;
        }

        // next compare whether the params have conversions one by one
        for (i = 0; i < len; i++) {
          c = hasConversions(signature1.params[i]) - hasConversions(signature2.params[i]);
          if (c !== 0) {
            return c;
          }
        }

        // compare the types of the params one by one
        for (i = 0; i < len; i++) {
          c = compareParams(signature1.params[i], signature2.params[i]);
          if (c !== 0) {
            return c;
          }
        }

        // compare the number of params
        return signature1.params.length - signature2.params.length;
      }

      /**
       * Get params containing all types that can be converted to the defined types.
       *
       * @param {ConversionDef[]} conversions
       * @param {string[]} typeNames
       * @return {ConversionDef[]} Returns the conversions that are available
       *                        for every type (if any)
       */
      function filterConversions(conversions, typeNames) {
        var matches = {};

        conversions.forEach(function (conversion) {
          if (typeNames.indexOf(conversion.from) === -1 &&
              typeNames.indexOf(conversion.to) !== -1 &&
              !matches[conversion.from]) {
            matches[conversion.from] = conversion;
          }
        });

        return Object.keys(matches).map(function (from) {
          return matches[from];
        });
      }

      /**
       * Preprocess arguments before calling the original function:
       * - if needed convert the parameters
       * - in case of rest parameters, move the rest parameters into an Array
       * @param {Param[]} params
       * @param {function} fn
       * @return {function} Returns a wrapped function
       */
      function compileArgsPreprocessing(params, fn) {
        var fnConvert = fn;

        // TODO: can we make this wrapper function smarter/simpler?

        if (params.some(hasConversions)) {
          var restParam = hasRestParam(params);
          var compiledConversions = params.map(compileArgConversion);

          fnConvert = function convertArgs() {
            var args = [];
            var last = restParam ? arguments.length - 1 : arguments.length;
            for (var i = 0; i < last; i++) {
              args[i] = compiledConversions[i](arguments[i]);
            }
            if (restParam) {
              args[last] = arguments[last].map(compiledConversions[last]);
            }

            return fn.apply(null, args);
          };
        }

        var fnPreprocess = fnConvert;
        if (hasRestParam(params)) {
          var offset = params.length - 1;

          fnPreprocess = function preprocessRestParams () {
            return fnConvert.apply(null,
                slice(arguments, 0, offset).concat([slice(arguments, offset)]));
          };
        }

        return fnPreprocess;
      }

      /**
       * Compile conversion for a parameter to the right type
       * @param {Param} param
       * @return {function} Returns the wrapped function that will convert arguments
       *
       */
      function compileArgConversion(param) {
        var test0, test1, conversion0, conversion1;
        var tests = [];
        var conversions = [];

        param.types.forEach(function (type) {
          if (type.conversion) {
            tests.push(findTypeByName(type.conversion.from).test);
            conversions.push(type.conversion.convert);
          }
        });

        // create optimized conversion functions depending on the number of conversions
        switch (conversions.length) {
          case 0:
            return function convertArg(arg) {
              return arg;
            }

          case 1:
            test0 = tests[0];
            conversion0 = conversions[0];
            return function convertArg(arg) {
              if (test0(arg)) {
                return conversion0(arg)
              }
              return arg;
            }

          case 2:
            test0 = tests[0];
            test1 = tests[1];
            conversion0 = conversions[0];
            conversion1 = conversions[1];
            return function convertArg(arg) {
              if (test0(arg)) {
                return conversion0(arg)
              }
              if (test1(arg)) {
                return conversion1(arg)
              }
              return arg;
            }

          default:
            return function convertArg(arg) {
              for (var i = 0; i < conversions.length; i++) {
                if (tests[i](arg)) {
                  return conversions[i](arg);
                }
              }
              return arg;
            }
        }
      }

      /**
       * Convert an array with signatures into a map with signatures,
       * where signatures with union types are split into separate signatures
       *
       * Throws an error when there are conflicting types
       *
       * @param {Signature[]} signatures
       * @return {Object.<string, function>}  Returns a map with signatures
       *                                      as key and the original function
       *                                      of this signature as value.
       */
      function createSignaturesMap(signatures) {
        var signaturesMap = {};
        signatures.forEach(function (signature) {
          if (!signature.params.some(hasConversions)) {
            splitParams(signature.params, true).forEach(function (params) {
              signaturesMap[stringifyParams(params)] = signature.fn;
            });
          }
        });

        return signaturesMap;
      }

      /**
       * Split params with union types in to separate params.
       *
       * For example:
       *
       *     splitParams([['Array', 'Object'], ['string', 'RegExp'])
       *     // returns:
       *     // [
       *     //   ['Array', 'string'],
       *     //   ['Array', 'RegExp'],
       *     //   ['Object', 'string'],
       *     //   ['Object', 'RegExp']
       *     // ]
       *
       * @param {Param[]} params
       * @param {boolean} ignoreConversionTypes
       * @return {Param[]}
       */
      function splitParams(params, ignoreConversionTypes) {
        function _splitParams(params, index, types) {
          if (index < params.length) {
            var param = params[index];
            var filteredTypes = ignoreConversionTypes
                ? param.types.filter(isExactType)
                : param.types;
            var typeGroups;

            if (param.restParam) {
              // split the types of a rest parameter in two:
              // one with only exact types, and one with exact types and conversions
              var exactTypes = filteredTypes.filter(isExactType);
              typeGroups = exactTypes.length < filteredTypes.length
                  ? [exactTypes, filteredTypes]
                  : [filteredTypes];

            }
            else {
              // split all the types of a regular parameter into one type per group
              typeGroups = filteredTypes.map(function (type) {
                return [type]
              });
            }

            // recurse over the groups with types
            return flatMap(typeGroups, function (typeGroup) {
              return _splitParams(params, index + 1, types.concat([typeGroup]));
            });

          }
          else {
            // we've reached the end of the parameters. Now build a new Param
            var splittedParams = types.map(function (type, typeIndex) {
              return {
                types: type,
                restParam: (typeIndex === params.length - 1) && hasRestParam(params)
              }
            });

            return [splittedParams];
          }
        }

        return _splitParams(params, 0, []);
      }

      /**
       * Test whether two signatures have a conflicting signature
       * @param {Signature} signature1
       * @param {Signature} signature2
       * @return {boolean} Returns true when the signatures conflict, false otherwise.
       */
      function hasConflictingParams(signature1, signature2) {
        var ii = Math.max(signature1.params.length, signature2.params.length);

        for (var i = 0; i < ii; i++) {
          var typesNames1 = getExpectedTypeNames(signature1, i, true);
          var typesNames2 = getExpectedTypeNames(signature2, i, true);

          if (!hasOverlap(typesNames1, typesNames2)) {
            return false;
          }
        }

        var len1 = signature1.params.length;
        var len2 = signature2.params.length;
        var restParam1 = hasRestParam(signature1.params);
        var restParam2 = hasRestParam(signature2.params);

        return restParam1
            ? restParam2 ? (len1 === len2) : (len2 >= len1)
            : restParam2 ? (len1 >= len2)  : (len1 === len2)
      }

      /**
       * Create a typed function
       * @param {String} name               The name for the typed function
       * @param {Object.<string, function>} signaturesMap
       *                                    An object with one or
       *                                    multiple signatures as key, and the
       *                                    function corresponding to the
       *                                    signature as value.
       * @return {function}  Returns the created typed function.
       */
      function createTypedFunction(name, signaturesMap) {
        if (Object.keys(signaturesMap).length === 0) {
          throw new SyntaxError('No signatures provided');
        }

        // parse the signatures, and check for conflicts
        var parsedSignatures = [];
        Object.keys(signaturesMap)
            .map(function (signature) {
              return parseSignature(signature, signaturesMap[signature], typed.conversions);
            })
            .filter(notNull)
            .forEach(function (parsedSignature) {
              // check whether this parameter conflicts with already parsed signatures
              var conflictingSignature = findInArray(parsedSignatures, function (s) {
                return hasConflictingParams(s, parsedSignature)
              });
              if (conflictingSignature) {
                throw new TypeError('Conflicting signatures "' +
                    stringifyParams(conflictingSignature.params) + '" and "' +
                    stringifyParams(parsedSignature.params) + '".');
              }

              parsedSignatures.push(parsedSignature);
            });

        // split and filter the types of the signatures, and then order them
        var signatures = flatMap(parsedSignatures, function (parsedSignature) {
          var params = parsedSignature ? splitParams(parsedSignature.params, false) : [];

          return params.map(function (params) {
            return {
              params: params,
              fn: parsedSignature.fn
            };
          });
        }).filter(notNull);

        signatures.sort(compareSignatures);

        // we create a highly optimized checks for the first couple of signatures with max 2 arguments
        var ok0 = signatures[0] && signatures[0].params.length <= 2 && !hasRestParam(signatures[0].params);
        var ok1 = signatures[1] && signatures[1].params.length <= 2 && !hasRestParam(signatures[1].params);
        var ok2 = signatures[2] && signatures[2].params.length <= 2 && !hasRestParam(signatures[2].params);
        var ok3 = signatures[3] && signatures[3].params.length <= 2 && !hasRestParam(signatures[3].params);
        var ok4 = signatures[4] && signatures[4].params.length <= 2 && !hasRestParam(signatures[4].params);
        var ok5 = signatures[5] && signatures[5].params.length <= 2 && !hasRestParam(signatures[5].params);
        var allOk = ok0 && ok1 && ok2 && ok3 && ok4 && ok5;

        // compile the tests
        var tests = signatures.map(function (signature) {
          return compileTests(signature.params);
        });

        var test00 = ok0 ? compileTest(signatures[0].params[0]) : notOk;
        var test10 = ok1 ? compileTest(signatures[1].params[0]) : notOk;
        var test20 = ok2 ? compileTest(signatures[2].params[0]) : notOk;
        var test30 = ok3 ? compileTest(signatures[3].params[0]) : notOk;
        var test40 = ok4 ? compileTest(signatures[4].params[0]) : notOk;
        var test50 = ok5 ? compileTest(signatures[5].params[0]) : notOk;

        var test01 = ok0 ? compileTest(signatures[0].params[1]) : notOk;
        var test11 = ok1 ? compileTest(signatures[1].params[1]) : notOk;
        var test21 = ok2 ? compileTest(signatures[2].params[1]) : notOk;
        var test31 = ok3 ? compileTest(signatures[3].params[1]) : notOk;
        var test41 = ok4 ? compileTest(signatures[4].params[1]) : notOk;
        var test51 = ok5 ? compileTest(signatures[5].params[1]) : notOk;

        // compile the functions
        var fns = signatures.map(function(signature) {
          return compileArgsPreprocessing(signature.params, signature.fn)
        });

        var fn0 = ok0 ? fns[0] : undef;
        var fn1 = ok1 ? fns[1] : undef;
        var fn2 = ok2 ? fns[2] : undef;
        var fn3 = ok3 ? fns[3] : undef;
        var fn4 = ok4 ? fns[4] : undef;
        var fn5 = ok5 ? fns[5] : undef;

        var len0 = ok0 ? signatures[0].params.length : -1;
        var len1 = ok1 ? signatures[1].params.length : -1;
        var len2 = ok2 ? signatures[2].params.length : -1;
        var len3 = ok3 ? signatures[3].params.length : -1;
        var len4 = ok4 ? signatures[4].params.length : -1;
        var len5 = ok5 ? signatures[5].params.length : -1;

        // simple and generic, but also slow
        var iStart = allOk ? 6 : 0;
        var iEnd = signatures.length;
        var generic = function generic() {

          for (var i = iStart; i < iEnd; i++) {
            if (tests[i](arguments)) {
              return fns[i].apply(null, arguments);
            }
          }

          throw createError(name, arguments, signatures);
        };

        // create the typed function
        // fast, specialized version. Falls back to the slower, generic one if needed
        var fn = function fn(arg0, arg1) {

          if (arguments.length === len0 && test00(arg0) && test01(arg1)) { return fn0.apply(null, arguments); }
          if (arguments.length === len1 && test10(arg0) && test11(arg1)) { return fn1.apply(null, arguments); }
          if (arguments.length === len2 && test20(arg0) && test21(arg1)) { return fn2.apply(null, arguments); }
          if (arguments.length === len3 && test30(arg0) && test31(arg1)) { return fn3.apply(null, arguments); }
          if (arguments.length === len4 && test40(arg0) && test41(arg1)) { return fn4.apply(null, arguments); }
          if (arguments.length === len5 && test50(arg0) && test51(arg1)) { return fn5.apply(null, arguments); }

          return generic.apply(null, arguments);
        };

        // attach name the typed function
        try {
          Object.defineProperty(fn, 'name', {value: name});
        }
        catch (err) {
          // old browsers do not support Object.defineProperty and some don't support setting the name property
          // the function name is not essential for the functioning, it's mostly useful for debugging,
          // so it's fine to have unnamed functions.
        }

        // attach signatures to the function
        fn.signatures = createSignaturesMap(signatures);

        return fn;
      }

      /**
       * Test whether a type should be NOT be ignored
       * @param {string} typeName
       * @return {boolean}
       */
      function notIgnore(typeName) {
        return typed.ignore.indexOf(typeName) === -1;
      }

      /**
       * trim a string
       * @param {string} str
       * @return {string}
       */
      function trim(str) {
        return str.trim();
      }

      /**
       * Test whether a string is not empty
       * @param {string} str
       * @return {boolean}
       */
      function notEmpty(str) {
        return !!str;
      }

      /**
       * test whether a value is not strict equal to null
       * @param {*} value
       * @return {boolean}
       */
      function notNull(value) {
        return value !== null;
      }

      /**
       * Test whether a parameter has no types defined
       * @param {Param} param
       * @return {boolean}
       */
      function isInvalidParam (param) {
        return param.types.length === 0;
      }

      /**
       * Return all but the last items of an array
       * @param {Array} arr
       * @return {Array}
       */
      function initial(arr) {
        return arr.slice(0, arr.length - 1);
      }

      /**
       * return the last item of an array
       * @param {Array} arr
       * @return {*}
       */
      function last(arr) {
        return arr[arr.length - 1];
      }

      /**
       * Slice an array or function Arguments
       * @param {Array | Arguments | IArguments} arr
       * @param {number} start
       * @param {number} [end]
       * @return {Array}
       */
      function slice(arr, start, end) {
        return Array.prototype.slice.call(arr, start, end);
      }

      /**
       * Test whether an array contains some item
       * @param {Array} array
       * @param {*} item
       * @return {boolean} Returns true if array contains item, false if not.
       */
      function contains(array, item) {
        return array.indexOf(item) !== -1;
      }

      /**
       * Test whether two arrays have overlapping items
       * @param {Array} array1
       * @param {Array} array2
       * @return {boolean} Returns true when at least one item exists in both arrays
       */
      function hasOverlap(array1, array2) {
        for (var i = 0; i < array1.length; i++) {
          if (contains(array2, array1[i])) {
            return true;
          }
        }

        return false;
      }

      /**
       * Return the first item from an array for which test(arr[i]) returns true
       * @param {Array} arr
       * @param {function} test
       * @return {* | undefined} Returns the first matching item
       *                         or undefined when there is no match
       */
      function findInArray(arr, test) {
        for (var i = 0; i < arr.length; i++) {
          if (test(arr[i])) {
            return arr[i];
          }
        }
        return undefined;
      }

      /**
       * Filter unique items of an array with strings
       * @param {string[]} arr
       * @return {string[]}
       */
      function uniq(arr) {
        var entries = {};
        for (var i = 0; i < arr.length; i++) {
          entries[arr[i]] = true;
        }
        return Object.keys(entries);
      }

      /**
       * Flat map the result invoking a callback for every item in an array.
       * https://gist.github.com/samgiles/762ee337dff48623e729
       * @param {Array} arr
       * @param {function} callback
       * @return {Array}
       */
      function flatMap(arr, callback) {
        return Array.prototype.concat.apply([], arr.map(callback));
      }

      /**
       * Retrieve the function name from a set of typed functions,
       * and check whether the name of all functions match (if given)
       * @param {function[]} fns
       */
      function getName (fns) {
        var name = '';

        for (var i = 0; i < fns.length; i++) {
          var fn = fns[i];

          // check whether the names are the same when defined
          if (fn.signatures && fn.name !== '') {
            if (name === '') {
              name = fn.name;
            }
            else if (name !== fn.name) {
              var err = new Error('Function names do not match (expected: ' + name + ', actual: ' + fn.name + ')');
              err.data = {
                actual: fn.name,
                expected: name
              };
              throw err;
            }
          }
        }

        return name;
      }

      typed = createTypedFunction('typed', {
        'string, Object': createTypedFunction,
        'Object': function (signaturesMap) {
          // find existing name
          var fns = [];
          for (var signature in signaturesMap) {
            if (signaturesMap.hasOwnProperty(signature)) {
              fns.push(signaturesMap[signature]);
            }
          }
          var name = getName(fns);
          return createTypedFunction(name, signaturesMap);
        },
        '...Function': function (fns) {
          var err;
          var name = getName(fns);
          var signaturesMap = {};

          for (var i = 0; i < fns.length; i++) {
            var fn = fns[i];

            // test whether this is a typed-function
            if (!(typeof fn.signatures === 'object')) {
              err = new TypeError('Function is no typed-function (index: ' + i + ')');
              err.data = {index: i};
              throw err;
            }

            // merge the signatures
            for (var signature in fn.signatures) {
              if (fn.signatures.hasOwnProperty(signature)) {
                if (signaturesMap.hasOwnProperty(signature)) {
                  if (fn.signatures[signature] !== signaturesMap[signature]) {
                    err = new Error('Signature "' + signature + '" is defined twice');
                    err.data = {signature: signature};
                    throw err;
                  }
                  // else: both signatures point to the same function, that's fine
                }
                else {
                  signaturesMap[signature] = fn.signatures[signature];
                }
              }
            }
          }

          return createTypedFunction(name, signaturesMap);
        }
      });

      typed.create = create;
      typed.types = _types;
      typed.conversions = _conversions;
      typed.ignore = _ignore;
      typed.convert = convert;
      typed.find = find;

      // add a type
      typed.addType = function (type) {
        if (!type || typeof type.name !== 'string' || typeof type.test !== 'function') {
          throw new TypeError('Object with properties {name: string, test: function} expected');
        }

        typed.types.push(type);
      };

      // add a conversion
      typed.addConversion = function (conversion) {
        if (!conversion
            || typeof conversion.from !== 'string'
            || typeof conversion.to !== 'string'
            || typeof conversion.convert !== 'function') {
          throw new TypeError('Object with properties {from: string, to: string, convert: function} expected');
        }

        typed.conversions.push(conversion);
      };

      return typed;
    }

    return create();
  }));
  });

  var number = createCommonjsModule(function (module, exports) {



  /**
   * @typedef {{sign: '+' | '-' | '', coefficients: number[], exponent: number}} SplitValue
   */

  /**
   * Test whether value is a number
   * @param {*} value
   * @return {boolean} isNumber
   */
  exports.isNumber = function(value) {
    return typeof value === 'number';
  };

  /**
   * Check if a number is integer
   * @param {number | boolean} value
   * @return {boolean} isInteger
   */
  exports.isInteger = function(value) {
    return isFinite(value)
        ? (value == Math.round(value))
        : false;
    // Note: we use ==, not ===, as we can have Booleans as well
  };

  /**
   * Calculate the sign of a number
   * @param {number} x
   * @returns {*}
   */
  exports.sign = Math.sign || function(x) {
    if (x > 0) {
      return 1;
    }
    else if (x < 0) {
      return -1;
    }
    else {
      return 0;
    }
  };

  /**
   * Convert a number to a formatted string representation.
   *
   * Syntax:
   *
   *    format(value)
   *    format(value, options)
   *    format(value, precision)
   *    format(value, fn)
   *
   * Where:
   *
   *    {number} value   The value to be formatted
   *    {Object} options An object with formatting options. Available options:
   *                     {string} notation
   *                         Number notation. Choose from:
   *                         'fixed'          Always use regular number notation.
   *                                          For example '123.40' and '14000000'
   *                         'exponential'    Always use exponential notation.
   *                                          For example '1.234e+2' and '1.4e+7'
   *                         'engineering'    Always use engineering notation.
   *                                          For example '123.4e+0' and '14.0e+6'
   *                         'auto' (default) Regular number notation for numbers
   *                                          having an absolute value between
   *                                          `lowerExp` and `upperExp` bounds, and 
   *                                          uses exponential notation elsewhere.
   *                                          Lower bound is included, upper bound
   *                                          is excluded.
   *                                          For example '123.4' and '1.4e7'.
   *                     {number} precision   A number between 0 and 16 to round
   *                                          the digits of the number.
   *                                          In case of notations 'exponential' and
   *                                          'auto', `precision` defines the total
   *                                          number of significant digits returned.
   *                                          In case of notation 'fixed',
   *                                          `precision` defines the number of
   *                                          significant digits after the decimal 
   *                                          point.
   *                                          `precision` is undefined by default,
   *                                          not rounding any digits.
   *                     {number} lowerExp    Exponent determining the lower boundary
   *                                          for formatting a value with an exponent
   *                                          when `notation='auto`. 
   *                                          Default value is `-3`.
   *                     {number} upperExp    Exponent determining the upper boundary
   *                                          for formatting a value with an exponent
   *                                          when `notation='auto`. 
   *                                          Default value is `5`.
   *    {Function} fn    A custom formatting function. Can be used to override the
   *                     built-in notations. Function `fn` is called with `value` as
   *                     parameter and must return a string. Is useful for example to
   *                     format all values inside a matrix in a particular way.
   *
   * Examples:
   *
   *    format(6.4);                                        // '6.4'
   *    format(1240000);                                    // '1.24e6'
   *    format(1/3);                                        // '0.3333333333333333'
   *    format(1/3, 3);                                     // '0.333'
   *    format(21385, 2);                                   // '21000'
   *    format(12.071, {notation: 'fixed'});                // '12'
   *    format(2.3,    {notation: 'fixed', precision: 2});  // '2.30'
   *    format(52.8,   {notation: 'exponential'});          // '5.28e+1'
   *    format(12345678, {notation: 'engineering'});        // '12.345678e+6'
   *
   * @param {number} value
   * @param {Object | Function | number} [options]
   * @return {string} str The formatted value
   */
  exports.format = function(value, options) {
    if (typeof options === 'function') {
      // handle format(value, fn)
      return options(value);
    }

    // handle special cases
    if (value === Infinity) {
      return 'Infinity';
    }
    else if (value === -Infinity) {
      return '-Infinity';
    }
    else if (isNaN(value)) {
      return 'NaN';
    }

    // default values for options
    var notation = 'auto';
    var precision = undefined;

    if (options) {
      // determine notation from options
      if (options.notation) {
        notation = options.notation;
      }

      // determine precision from options
      if (exports.isNumber(options)) {
        precision = options;
      }
      else if (options.precision) {
        precision = options.precision;
      }
    }

    // handle the various notations
    switch (notation) {
      case 'fixed':
        return exports.toFixed(value, precision);

      case 'exponential':
        return exports.toExponential(value, precision);

      case 'engineering':
        return exports.toEngineering(value, precision);

      case 'auto':
        // TODO: clean up some day. Deprecated since: 2018-01-24
        // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
        if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
          var fixedOptions = object.map(options, function(x) { return x; });
          fixedOptions.exponential = undefined;
          if (options.exponential.lower !== undefined) {
            fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
          }
          if (options.exponential.upper !== undefined) {
            fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
          }

          console.warn('Deprecation warning: Formatting options exponential.lower and exponential.upper ' + 
              '(minimum and maximum value) ' +
              'are replaced with exponential.lowerExp and exponential.upperExp ' + 
              '(minimum and maximum exponent) since version 4.0.0. ' + 
              'Replace ' + JSON.stringify(options) + ' with ' + JSON.stringify(fixedOptions));

          return exports.toPrecision(value, precision, fixedOptions);
        }

        return exports
            .toPrecision(value, precision, options && options)

            // remove trailing zeros after the decimal point
            .replace(/((\.\d*?)(0+))($|e)/, function () {
              var digits = arguments[2];
              var e = arguments[4];
              return (digits !== '.') ? digits + e : e;
            });

      default:
        throw new Error('Unknown notation "' + notation + '". ' +
            'Choose "auto", "exponential", or "fixed".');
    }
  };

  /**
   * Split a number into sign, coefficients, and exponent
   * @param {number | string} value
   * @return {SplitValue}
   *              Returns an object containing sign, coefficients, and exponent
   */
  exports.splitNumber = function (value) {
    // parse the input value
    var match = String(value).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
    if (!match) {
      throw new SyntaxError('Invalid number ' + value);
    }

    var sign         = match[1];
    var digits       = match[2];
    var exponent     = parseFloat(match[4] || '0');

    var dot = digits.indexOf('.');
    exponent += (dot !== -1) ? (dot - 1) : (digits.length - 1);

    var coefficients = digits
        .replace('.', '')  // remove the dot (must be removed before removing leading zeros)
        .replace(/^0*/, function (zeros) {
          // remove leading zeros, add their count to the exponent
          exponent -= zeros.length;
          return '';
        })
        .replace(/0*$/, '') // remove trailing zeros
        .split('')
        .map(function (d) {
          return parseInt(d);
        });

    if (coefficients.length === 0) {
      coefficients.push(0);
      exponent++;
    }

    return {
      sign: sign,
      coefficients: coefficients,
      exponent: exponent
    };
  };


  /**
   * Format a number in engineering notation. Like '1.23e+6', '2.3e+0', '3.500e-3'
   * @param {number | string} value
   * @param {number} [precision=0]        Optional number of decimals after the
   *                                      decimal point. Zero by default.
   */
  exports.toEngineering = function (value, precision) {
    if (isNaN(value) || !isFinite(value)) {
      return String(value);
    }
    
    var rounded = exports.roundDigits(exports.splitNumber(value), precision);

    var e = rounded.exponent;
    var c = rounded.coefficients;

    // find nearest lower multiple of 3 for exponent
    var newExp = e % 3 === 0 ? e : (e < 0 ? (e - 3) - (e % 3) : e - (e % 3));

    // concatenate coefficients with necessary zeros
    var significandsDiff = e >= 0 ? e : Math.abs(newExp);

    // add zeros if necessary (for ex: 1e+8)
    if (c.length - 1 < significandsDiff) c = c.concat(zeros(significandsDiff - (c.length - 1)));

    // find difference in exponents
    var expDiff = Math.abs(e - newExp);

    var decimalIdx = 1;

    // push decimal index over by expDiff times
    while (--expDiff >= 0) decimalIdx++;

    // if all coefficient values are zero after the decimal point, don't add a decimal value.
    // otherwise concat with the rest of the coefficients
    var decimals = c.slice(decimalIdx).join('');
    var decimalVal = decimals.match(/[1-9]/) ? ('.' + decimals) : '';

    var str = c.slice(0, decimalIdx).join('') +
        decimalVal +
        'e' + (e >= 0 ? '+' : '') + newExp.toString();
    return rounded.sign + str;
  };

  /**
   * Format a number with fixed notation.
   * @param {number | string} value
   * @param {number} [precision=undefined]  Optional number of decimals after the
   *                                        decimal point. null by default.
   */
  exports.toFixed = function (value, precision) {
    if (isNaN(value) || !isFinite(value)) {
      return String(value);
    }

    var splitValue = exports.splitNumber(value);
    var rounded = (typeof precision === 'number')
        ? exports.roundDigits(splitValue, splitValue.exponent + 1 + precision)
        : splitValue;
    var c = rounded.coefficients;
    var p = rounded.exponent + 1; // exponent may have changed

    // append zeros if needed
    var pp = p + (precision || 0);
    if (c.length < pp) {
      c = c.concat(zeros(pp - c.length));
    }

    // prepend zeros if needed
    if (p < 0) {
      c = zeros(-p + 1).concat(c);
      p = 1;
    }

    // insert a dot if needed
    if (p < c.length) {
      c.splice(p, 0, (p === 0) ? '0.' : '.');
    }

    return rounded.sign + c.join('');
  };

  /**
   * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
   * @param {number | string} value
   * @param {number} [precision]  Number of digits in formatted output.
   *                              If not provided, the maximum available digits
   *                              is used.
   */
  exports.toExponential = function (value, precision) {
    if (isNaN(value) || !isFinite(value)) {
      return String(value);
    }

    // round if needed, else create a clone
    var split = exports.splitNumber(value);
    var rounded = precision ? exports.roundDigits(split, precision) : split;
    var c = rounded.coefficients;
    var e = rounded.exponent;

    // append zeros if needed
    if (c.length < precision) {
      c = c.concat(zeros(precision - c.length));
    }

    // format as `C.CCCe+EEE` or `C.CCCe-EEE`
    var first = c.shift();
    return rounded.sign + first + (c.length > 0 ? ('.' + c.join('')) : '') +
        'e' + (e >= 0 ? '+' : '') + e;
  };

  /**
   * Format a number with a certain precision
   * @param {number | string} value
   * @param {number} [precision=undefined] Optional number of digits.
   * @param {{lowerExp: number | undefined, upperExp: number | undefined}} [options]
   *                                       By default:
   *                                         lowerExp = -3 (incl)
   *                                         upper = +5 (excl)
   * @return {string}
   */
  exports.toPrecision = function (value, precision, options) {
    if (isNaN(value) || !isFinite(value)) {
      return String(value);
    }

    // determine lower and upper bound for exponential notation.
    var lowerExp = (options && options.lowerExp !== undefined) ? options.lowerExp : -3;
    var upperExp = (options && options.upperExp !== undefined) ? options.upperExp : 5;

    var split = exports.splitNumber(value);
    if (split.exponent < lowerExp || split.exponent >= upperExp) {
      // exponential notation
      return exports.toExponential(value, precision);
    }
    else {
      var rounded = precision ? exports.roundDigits(split, precision) : split;
      var c = rounded.coefficients;
      var e = rounded.exponent;

      // append trailing zeros
      if (c.length < precision) {
        c = c.concat(zeros(precision - c.length));
      }

      // append trailing zeros
      // TODO: simplify the next statement
      c = c.concat(zeros(e - c.length + 1 +
          (c.length < precision ? precision - c.length : 0)));

      // prepend zeros
      c = zeros(-e).concat(c);

      var dot = e > 0 ? e : 0;
      if (dot < c.length - 1) {
        c.splice(dot + 1, 0, '.');
      }

      return rounded.sign + c.join('');
    }
  };

  /**
   * Round the number of digits of a number *
   * @param {SplitValue} split       A value split with .splitNumber(value)
   * @param {number} precision  A positive integer
   * @return {SplitValue}
   *              Returns an object containing sign, coefficients, and exponent
   *              with rounded digits
   */
  exports.roundDigits = function (split, precision) {
    // create a clone
    var rounded = {
      sign: split.sign,
      coefficients: split.coefficients,
      exponent: split.exponent
    };
    var c = rounded.coefficients;

    // prepend zeros if needed
    while (precision <= 0) {
      c.unshift(0);
      rounded.exponent++;
      precision++;
    }

    if (c.length > precision) {
      var removed = c.splice(precision, c.length - precision);

      if (removed[0] >= 5) {
        var i = precision - 1;
        c[i]++;
        while (c[i] === 10) {
          c.pop();
          if (i === 0) {
            c.unshift(0);
            rounded.exponent++;
            i++;
          }
          i--;
          c[i]++;
        }
      }
    }

    return rounded;
  };

  /**
   * Create an array filled with zeros.
   * @param {number} length
   * @return {Array}
   */
  function zeros(length) {
    var arr = [];
    for (var i = 0; i < length; i++) {
      arr.push(0);
    }
    return arr;
  }

  /**
   * Count the number of significant digits of a number.
   *
   * For example:
   *   2.34 returns 3
   *   0.0034 returns 2
   *   120.5e+30 returns 4
   *
   * @param {number} value
   * @return {number} digits   Number of significant digits
   */
  exports.digits = function(value) {
    return value
        .toExponential()
        .replace(/e.*$/, '')          // remove exponential notation
        .replace( /^0\.?0*|\./, '')   // remove decimal point and leading zeros
        .length
  };

  /**
   * Minimum number added to one that makes the result different than one
   */
  exports.DBL_EPSILON = Number.EPSILON || 2.2204460492503130808472633361816E-16;

  /**
   * Compares two floating point numbers.
   * @param {number} x          First value to compare
   * @param {number} y          Second value to compare
   * @param {number} [epsilon]  The maximum relative difference between x and y
   *                            If epsilon is undefined or null, the function will
   *                            test whether x and y are exactly equal.
   * @return {boolean} whether the two numbers are nearly equal
  */
  exports.nearlyEqual = function(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon == null) {
      return x == y;
    }

    // use "==" operator, handles infinities
    if (x == y) {
      return true;
    }

    // NaN
    if (isNaN(x) || isNaN(y)) {
      return false;
    }

    // at this point x and y should be finite
    if(isFinite(x) && isFinite(y)) {
      // check numbers are very close, needed when comparing numbers near zero
      var diff = Math.abs(x - y);
      if (diff < exports.DBL_EPSILON) {
        return true;
      }
      else {
        // use relative error
        return diff <= Math.max(Math.abs(x), Math.abs(y)) * epsilon;
      }
    }

    // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
  };
  });
  var number_1 = number.isNumber;
  var number_2 = number.isInteger;
  var number_3 = number.sign;
  var number_4 = number.format;
  var number_5 = number.splitNumber;
  var number_6 = number.toEngineering;
  var number_7 = number.toFixed;
  var number_8 = number.toExponential;
  var number_9 = number.toPrecision;
  var number_10 = number.roundDigits;
  var number_11 = number.digits;
  var number_12 = number.DBL_EPSILON;
  var number_13 = number.nearlyEqual;

  /**
   * Test whether a value is a Matrix
   * @param {*} x
   * @returns {boolean} returns true with input is a Matrix
   *                    (like a DenseMatrix or SparseMatrix)
   */
  var isMatrix = function isMatrix (x) {
    return x && x.constructor.prototype.isMatrix || false;
  };

  var digits = number.digits;



  // returns a new instance of typed-function
  var createTyped = function () {
    // initially, return the original instance of typed-function
    // consecutively, return a new instance from typed.create.
    createTyped = typedFunction.create;
    return typedFunction;
  };

  /**
   * Factory function for creating a new typed instance
   * @param {Object} type   Object with data types like Complex and BigNumber
   * @returns {Function}
   */
  var create = function create(type) {
    // TODO: typed-function must be able to silently ignore signatures with unknown data types

    // type checks for all known types
    //
    // note that:
    //
    // - check by duck-typing on a property like `isUnit`, instead of checking instanceof.
    //   instanceof cannot be used because that would not allow to pass data from
    //   one instance of math.js to another since each has it's own instance of Unit.
    // - check the `isUnit` property via the constructor, so there will be no
    //   matches for "fake" instances like plain objects with a property `isUnit`.
    //   That is important for security reasons.
    // - It must not be possible to override the type checks used internally,
    //   for security reasons, so these functions are not exposed in the expression
    //   parser.
    type.isNumber = function (x) { return typeof x === 'number' };
    type.isComplex = function (x) { return type.Complex && x instanceof type.Complex || false };
    type.isBigNumber = isBigNumber;
    type.isFraction = function (x) { return type.Fraction && x instanceof type.Fraction || false };
    type.isUnit = function (x) { return x && x.constructor.prototype.isUnit || false };
    type.isString = function (x) { return typeof x === 'string' };
    type.isArray = Array.isArray;
    type.isMatrix = isMatrix;
    type.isDenseMatrix = function (x) { return x && x.isDenseMatrix && x.constructor.prototype.isMatrix || false };
    type.isSparseMatrix = function (x) { return x && x.isSparseMatrix && x.constructor.prototype.isMatrix || false };
    type.isRange = function (x) { return x && x.constructor.prototype.isRange || false };
    type.isIndex = function (x) { return x && x.constructor.prototype.isIndex || false };
    type.isBoolean = function (x) { return typeof x === 'boolean' };
    type.isResultSet = function (x) { return x && x.constructor.prototype.isResultSet || false };
    type.isHelp = function (x) { return x && x.constructor.prototype.isHelp || false };
    type.isFunction = function (x) { return typeof x === 'function'};
    type.isDate = function (x) { return x instanceof Date };
    type.isRegExp = function (x) { return x instanceof RegExp };
    type.isObject = function (x) {
      return typeof x === 'object' &&
          x.constructor === Object &&
          !type.isComplex(x) &&
          !type.isFraction(x)
    };
    type.isNull = function (x) { return x === null };
    type.isUndefined = function (x) { return x === undefined };

    type.isAccessorNode = function (x) { return x && x.isAccessorNode && x.constructor.prototype.isNode || false };
    type.isArrayNode = function (x) { return x && x.isArrayNode && x.constructor.prototype.isNode || false };
    type.isAssignmentNode = function (x) { return x && x.isAssignmentNode && x.constructor.prototype.isNode || false };
    type.isBlockNode = function (x) { return x && x.isBlockNode && x.constructor.prototype.isNode || false };
    type.isConditionalNode = function (x) { return x && x.isConditionalNode && x.constructor.prototype.isNode || false };
    type.isConstantNode = function (x) { return x && x.isConstantNode && x.constructor.prototype.isNode || false };
    type.isFunctionAssignmentNode = function (x) { return x && x.isFunctionAssignmentNode && x.constructor.prototype.isNode || false };
    type.isFunctionNode = function (x) { return x && x.isFunctionNode && x.constructor.prototype.isNode || false };
    type.isIndexNode = function (x) { return x && x.isIndexNode && x.constructor.prototype.isNode || false };
    type.isNode = function (x) { return x && x.isNode && x.constructor.prototype.isNode || false };
    type.isObjectNode = function (x) { return x && x.isObjectNode && x.constructor.prototype.isNode || false };
    type.isOperatorNode = function (x) { return x && x.isOperatorNode && x.constructor.prototype.isNode || false };
    type.isParenthesisNode = function (x) { return x && x.isParenthesisNode && x.constructor.prototype.isNode || false };
    type.isRangeNode = function (x) { return x && x.isRangeNode && x.constructor.prototype.isNode || false };
    type.isSymbolNode = function (x) { return x && x.isSymbolNode && x.constructor.prototype.isNode || false };

    type.isChain = function (x) { return x && x.constructor.prototype.isChain || false };

    // get a new instance of typed-function
    var typed = createTyped();

    // define all types. The order of the types determines in which order function
    // arguments are type-checked (so for performance it's important to put the
    // most used types first).
    typed.types = [
      { name: 'number',          test: type.isNumber },
      { name: 'Complex',         test: type.isComplex },
      { name: 'BigNumber',       test: type.isBigNumber },
      { name: 'Fraction',        test: type.isFraction },
      { name: 'Unit',            test: type.isUnit },
      { name: 'string',          test: type.isString },
      { name: 'Array',           test: type.isArray },
      { name: 'Matrix',          test: type.isMatrix },
      { name: 'DenseMatrix',     test: type.isDenseMatrix },
      { name: 'SparseMatrix',    test: type.isSparseMatrix },
      { name: 'Range',           test: type.isRange },
      { name: 'Index',           test: type.isIndex },
      { name: 'boolean',         test: type.isBoolean },
      { name: 'ResultSet',       test: type.isResultSet },
      { name: 'Help',            test: type.isHelp },
      { name: 'function',        test: type.isFunction },
      { name: 'Date',            test: type.isDate },
      { name: 'RegExp',          test: type.isRegExp },
      { name: 'null',            test: type.isNull },
      { name: 'undefined',       test: type.isUndefined },

      { name: 'OperatorNode',    test: type.isOperatorNode },
      { name: 'ConstantNode',    test: type.isConstantNode },
      { name: 'SymbolNode',      test: type.isSymbolNode },
      { name: 'ParenthesisNode', test: type.isParenthesisNode },
      { name: 'FunctionNode',    test: type.isFunctionNode },
      { name: 'FunctionAssignmentNode',    test: type.isFunctionAssignmentNode },
      { name: 'ArrayNode',                 test: type.isArrayNode },
      { name: 'AssignmentNode',            test: type.isAssignmentNode },
      { name: 'BlockNode',                 test: type.isBlockNode },
      { name: 'ConditionalNode',           test: type.isConditionalNode },
      { name: 'IndexNode',                 test: type.isIndexNode },
      { name: 'RangeNode',                 test: type.isRangeNode },
      { name: 'Node',                      test: type.isNode },

      { name: 'Object',          test: type.isObject } // order 'Object' last, it's a tricky one
    ];

    // TODO: add conversion from BigNumber to number?
    typed.conversions = [
      {
        from: 'number',
        to: 'BigNumber',
        convert: function (x) {
          // note: conversion from number to BigNumber can fail if x has >15 digits
          if (digits(x) > 15) {
            throw new TypeError('Cannot implicitly convert a number with >15 significant digits to BigNumber ' +
            '(value: ' + x + '). ' +
            'Use function bignumber(x) to convert to BigNumber.');
          }
          return new type.BigNumber(x);
        }
      }, {
        from: 'number',
        to: 'Complex',
        convert: function (x) {
          return new type.Complex(x, 0);
        }
      }, {
        from: 'number',
        to: 'string',
        convert: function (x) {
          return x + '';
        }
      }, {
        from: 'BigNumber',
        to: 'Complex',
        convert: function (x) {
          return new type.Complex(x.toNumber(), 0);
        }
      }, {
        from: 'Fraction',
        to: 'BigNumber',
        convert: function (x) {
          throw new TypeError('Cannot implicitly convert a Fraction to BigNumber or vice versa. ' +
              'Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.');
        }
      }, {
        from: 'Fraction',
        to: 'Complex',
        convert: function (x) {
          return new type.Complex(x.valueOf(), 0);
        }
      }, {
        from: 'number',
        to: 'Fraction',
        convert: function (x) {
          var f = new type.Fraction(x);
          if (f.valueOf() !== x) {
            throw new TypeError('Cannot implicitly convert a number to a Fraction when there will be a loss of precision ' +
                '(value: ' + x + '). ' +
                'Use function fraction(x) to convert to Fraction.');
          }
          return new type.Fraction(x);
        }
      }, {
      // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
      //  from: 'Fraction',
      //  to: 'number',
      //  convert: function (x) {
      //    return x.valueOf();
      //  }
      //}, {
        from: 'string',
        to: 'number',
        convert: function (x) {
          var n = Number(x);
          if (isNaN(n)) {
            throw new Error('Cannot convert "' + x + '" to a number');
          }
          return n;
        }
      }, {
        from: 'string',
        to: 'BigNumber',
        convert: function (x) {
          try {
            return new type.BigNumber(x);
          }
          catch (err) {
            throw new Error('Cannot convert "' + x + '" to BigNumber');
          }
        }
      }, {
        from: 'string',
        to: 'Fraction',
        convert: function (x) {
          try {
            return new type.Fraction(x);
          }
          catch (err) {
            throw new Error('Cannot convert "' + x + '" to Fraction');
          }
        }
      }, {
        from: 'string',
        to: 'Complex',
        convert: function (x) {
          try {
            return new type.Complex(x);
          }
          catch (err) {
            throw new Error('Cannot convert "' + x + '" to Complex');
          }
        }
      }, {
        from: 'boolean',
        to: 'number',
        convert: function (x) {
          return +x;
        }
      }, {
        from: 'boolean',
        to: 'BigNumber',
        convert: function (x) {
          return new type.BigNumber(+x);
        }
      }, {
        from: 'boolean',
        to: 'Fraction',
        convert: function (x) {
          return new type.Fraction(+x);
        }
      }, {
        from: 'boolean',
        to: 'string',
        convert: function (x) {
          return +x;
        }
      }, {
        from: 'Array',
        to: 'Matrix',
        convert: function (array) {
          return new type.DenseMatrix(array);
        }
      }, {
        from: 'Matrix',
        to: 'Array',
        convert: function (matrix) {
          return matrix.valueOf();
        }
      }
    ];

    return typed;
  };

  var typed = {
  	create: create
  };

  function E () {
    // Keep this empty so it's easier to inherit from
    // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
  }

  E.prototype = {
    on: function (name, callback, ctx) {
      var e = this.e || (this.e = {});

      (e[name] || (e[name] = [])).push({
        fn: callback,
        ctx: ctx
      });

      return this;
    },

    once: function (name, callback, ctx) {
      var self = this;
      function listener () {
        self.off(name, listener);
        callback.apply(ctx, arguments);
      }
      listener._ = callback;
      return this.on(name, listener, ctx);
    },

    emit: function (name) {
      var data = [].slice.call(arguments, 1);
      var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
      var i = 0;
      var len = evtArr.length;

      for (i; i < len; i++) {
        evtArr[i].fn.apply(evtArr[i].ctx, data);
      }

      return this;
    },

    off: function (name, callback) {
      var e = this.e || (this.e = {});
      var evts = e[name];
      var liveEvents = [];

      if (evts && callback) {
        for (var i = 0, len = evts.length; i < len; i++) {
          if (evts[i].fn !== callback && evts[i].fn._ !== callback)
            liveEvents.push(evts[i]);
        }
      }

      // Remove event from queue to prevent memory leak
      // Suggested by https://github.com/lazd
      // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

      (liveEvents.length)
        ? e[name] = liveEvents
        : delete e[name];

      return this;
    }
  };

  var tinyEmitter = E;

  /**
   * Extend given object with emitter functions `on`, `off`, `once`, `emit`
   * @param {Object} obj
   * @return {Object} obj
   */
  var mixin = function (obj) {
    // create event emitter
    var emitter = new tinyEmitter();

    // bind methods to obj (we don't want to expose the emitter.e Array...)
    obj.on   = emitter.on.bind(emitter);
    obj.off  = emitter.off.bind(emitter);
    obj.once = emitter.once.bind(emitter);
    obj.emit = emitter.emit.bind(emitter);

    return obj;
  };

  var emitter = {
  	mixin: mixin
  };

  /**
   * Create a syntax error with the message:
   *     'Wrong number of arguments in function <fn> (<count> provided, <min>-<max> expected)'
   * @param {string} fn     Function name
   * @param {number} count  Actual argument count
   * @param {number} min    Minimum required argument count
   * @param {number} [max]  Maximum required argument count
   * @extends Error
   */
  function ArgumentsError(fn, count, min, max) {
    if (!(this instanceof ArgumentsError)) {
      throw new SyntaxError('Constructor must be called with the new operator');
    }

    this.fn = fn;
    this.count = count;
    this.min = min;
    this.max = max;

    this.message = 'Wrong number of arguments in function ' + fn +
        ' (' + count + ' provided, ' +
        min + ((max != undefined) ? ('-' + max) : '') + ' expected)';

    this.stack = (new Error()).stack;
  }

  ArgumentsError.prototype = new Error();
  ArgumentsError.prototype.constructor = Error;
  ArgumentsError.prototype.name = 'ArgumentsError';
  ArgumentsError.prototype.isArgumentsError = true;

  var ArgumentsError_1 = ArgumentsError;

  var lazy = object.lazy;
  var isFactory = object.isFactory;
  var traverse = object.traverse;


  function factory (type, config, load, typed, math) {
    /**
     * Import functions from an object or a module
     *
     * Syntax:
     *
     *    math.import(object)
     *    math.import(object, options)
     *
     * Where:
     *
     * - `object: Object`
     *   An object with functions to be imported.
     * - `options: Object` An object with import options. Available options:
     *   - `override: boolean`
     *     If true, existing functions will be overwritten. False by default.
     *   - `silent: boolean`
     *     If true, the function will not throw errors on duplicates or invalid
     *     types. False by default.
     *   - `wrap: boolean`
     *     If true, the functions will be wrapped in a wrapper function
     *     which converts data types like Matrix to primitive data types like Array.
     *     The wrapper is needed when extending math.js with libraries which do not
     *     support these data type. False by default.
     *
     * Examples:
     *
     *    // define new functions and variables
     *    math.import({
     *      myvalue: 42,
     *      hello: function (name) {
     *        return 'hello, ' + name + '!';
     *      }
     *    });
     *
     *    // use the imported function and variable
     *    math.myvalue * 2;               // 84
     *    math.hello('user');             // 'hello, user!'
     *
     *    // import the npm module 'numbers'
     *    // (must be installed first with `npm install numbers`)
     *    math.import(require('numbers'), {wrap: true});
     *
     *    math.fibonacci(7); // returns 13
     *
     * @param {Object | Array} object   Object with functions to be imported.
     * @param {Object} [options]        Import options.
     */
    function math_import(object$$1, options) {
      var num = arguments.length;
      if (num !== 1 && num !== 2) {
        throw new ArgumentsError_1('import', num, 1, 2);
      }

      if (!options) {
        options = {};
      }

      if (isFactory(object$$1)) {
        _importFactory(object$$1, options);
      }
      // TODO: allow a typed-function with name too
      else if (Array.isArray(object$$1)) {
        object$$1.forEach(function (entry) {
          math_import(entry, options);
        });
      }
      else if (typeof object$$1 === 'object') {
        // a map with functions
        for (var name in object$$1) {
          if (object$$1.hasOwnProperty(name)) {
            var value = object$$1[name];
            if (isSupportedType(value)) {
              _import(name, value, options);
            }
            else if (isFactory(object$$1)) {
              _importFactory(object$$1, options);
            }
            else {
              math_import(value, options);
            }
          }
        }
      }
      else {
        if (!options.silent) {
          throw new TypeError('Factory, Object, or Array expected');
        }
      }
    }

    /**
     * Add a property to the math namespace and create a chain proxy for it.
     * @param {string} name
     * @param {*} value
     * @param {Object} options  See import for a description of the options
     * @private
     */
    function _import(name, value, options) {
      // TODO: refactor this function, it's to complicated and contains duplicate code
      if (options.wrap && typeof value === 'function') {
        // create a wrapper around the function
        value = _wrap(value);
      }

      if (isTypedFunction(math[name]) && isTypedFunction(value)) {
        if (options.override) {
          // give the typed function the right name
          value = typed(name, value.signatures);
        }
        else {
          // merge the existing and typed function
          value = typed(math[name], value);
        }

        math[name] = value;
        _importTransform(name, value);
        math.emit('import', name, function resolver() {
          return value;
        });
        return;
      }

      if (math[name] === undefined || options.override) {
        math[name] = value;
        _importTransform(name, value);
        math.emit('import', name, function resolver() {
          return value;
        });
        return;
      }

      if (!options.silent) {
        throw new Error('Cannot import "' + name + '": already exists');
      }
    }

    function _importTransform (name, value) {
      if (value && typeof value.transform === 'function') {
        math.expression.transform[name] = value.transform;
        if (allowedInExpressions(name)) {
          math.expression.mathWithTransform[name] = value.transform;
        }
      }
      else {
        // remove existing transform
        delete math.expression.transform[name];
        if (allowedInExpressions(name)) {
          math.expression.mathWithTransform[name] = value;
        }
      }
    }

    /**
     * Create a wrapper a round an function which converts the arguments
     * to their primitive values (like convert a Matrix to Array)
     * @param {Function} fn
     * @return {Function} Returns the wrapped function
     * @private
     */
    function _wrap (fn) {
      var wrapper = function wrapper () {
        var args = [];
        for (var i = 0, len = arguments.length; i < len; i++) {
          var arg = arguments[i];
          args[i] = arg && arg.valueOf();
        }
        return fn.apply(math, args);
      };

      if (fn.transform) {
        wrapper.transform = fn.transform;
      }

      return wrapper;
    }

    /**
     * Import an instance of a factory into math.js
     * @param {{factory: Function, name: string, path: string, math: boolean}} factory
     * @param {Object} options  See import for a description of the options
     * @private
     */
    function _importFactory(factory, options) {
      if (typeof factory.name === 'string') {
        var name = factory.name;
        var existingTransform = name in math.expression.transform;
        var namespace = factory.path ? traverse(math, factory.path) : math;
        var existing = namespace.hasOwnProperty(name) ? namespace[name] : undefined;

        var resolver = function () {
          var instance = load(factory);
          if (instance && typeof instance.transform === 'function') {
            throw new Error('Transforms cannot be attached to factory functions. ' +
                'Please create a separate function for it with exports.path="expression.transform"');
          }

          if (isTypedFunction(existing) && isTypedFunction(instance)) {
            if (options.override) {
              // replace the existing typed function (nothing to do)
            }
            else {
              // merge the existing and new typed function
              instance = typed(existing, instance);
            }

            return instance;
          }

          if (existing === undefined || options.override) {
            return instance;
          }

          if (!options.silent) {
            throw new Error('Cannot import "' + name + '": already exists');
          }
        };

        if (factory.lazy !== false) {
          lazy(namespace, name, resolver);

          if (!existingTransform) {
            if (factory.path === 'expression.transform' || factoryAllowedInExpressions(factory)) {
              lazy(math.expression.mathWithTransform, name, resolver);
            }
          }
        }
        else {
          namespace[name] = resolver();

          if (!existingTransform) {
            if (factory.path === 'expression.transform' || factoryAllowedInExpressions(factory)) {
              math.expression.mathWithTransform[name] = resolver();
            }
          }
        }

        math.emit('import', name, resolver, factory.path);
      }
      else {
        // unnamed factory.
        // no lazy loading
        load(factory);
      }
    }

    /**
     * Check whether given object is a type which can be imported
     * @param {Function | number | string | boolean | null | Unit | Complex} object
     * @return {boolean}
     * @private
     */
    function isSupportedType(object$$1) {
      return typeof object$$1 === 'function'
          || typeof object$$1 === 'number'
          || typeof object$$1 === 'string'
          || typeof object$$1 === 'boolean'
          || object$$1 === null
          || (object$$1 && type.isUnit(object$$1))
          || (object$$1 && type.isComplex(object$$1))
          || (object$$1 && type.isBigNumber(object$$1))
          || (object$$1 && type.isFraction(object$$1))
          || (object$$1 && type.isMatrix(object$$1))
          || (object$$1 && Array.isArray(object$$1))
    }

    /**
     * Test whether a given thing is a typed-function
     * @param {*} fn
     * @return {boolean} Returns true when `fn` is a typed-function
     */
    function isTypedFunction (fn) {
      return typeof fn === 'function' && typeof fn.signatures === 'object';
    }

    function allowedInExpressions (name) {
      return !unsafe.hasOwnProperty(name);
    }

    function factoryAllowedInExpressions (factory) {
      return factory.path === undefined && !unsafe.hasOwnProperty(factory.name);
    }

    // namespaces and functions not available in the parser for safety reasons
    var unsafe = {
      'expression': true,
      'type': true,
      'docs': true,
      'error': true,
      'json': true,
      'chain': true // chain method not supported. Note that there is a unit chain too.
    };

    return math_import;
  }

  var math = true; // request access to the math namespace as 5th argument of the factory function
  var name = 'import';
  var factory_1 = factory;
  var lazy_1 = true;

  var _import = {
  	math: math,
  	name: name,
  	factory: factory_1,
  	lazy: lazy_1
  };

  function factory$1 (type, config, load, typed, math) {
    var MATRIX = ['Matrix', 'Array'];                   // valid values for option matrix
    var NUMBER = ['number', 'BigNumber', 'Fraction'];   // valid values for option number

    /**
     * Set configuration options for math.js, and get current options.
     * Will emit a 'config' event, with arguments (curr, prev, changes).
     *
     * Syntax:
     *
     *     math.config(config: Object): Object
     *
     * Examples:
     *
     *     math.config().number;                // outputs 'number'
     *     math.eval('0.4');                    // outputs number 0.4
     *     math.config({number: 'Fraction'});
     *     math.eval('0.4');                    // outputs Fraction 2/5
     *
     * @param {Object} [options] Available options:
     *                            {number} epsilon
     *                              Minimum relative difference between two
     *                              compared values, used by all comparison functions.
     *                            {string} matrix
     *                              A string 'Matrix' (default) or 'Array'.
     *                            {string} number
     *                              A string 'number' (default), 'BigNumber', or 'Fraction'
     *                            {number} precision
     *                              The number of significant digits for BigNumbers.
     *                              Not applicable for Numbers.
     *                            {string} parenthesis
     *                              How to display parentheses in LaTeX and string
     *                              output.
     *                            {string} randomSeed
     *                              Random seed for seeded pseudo random number generator.
     *                              Set to null to randomly seed.
     * @return {Object} Returns the current configuration
     */
    function _config(options) {
      if (options) {
        var prev = object.map(config, object.clone);

        // validate some of the options
        validateOption(options, 'matrix', MATRIX);
        validateOption(options, 'number', NUMBER);

        // merge options
        object.deepExtend(config, options);

        var curr = object.map(config, object.clone);

        var changes = object.map(options, object.clone);

        // emit 'config' event
        math.emit('config', curr, prev, changes);

        return curr;
      }
      else {
        return object.map(config, object.clone);
      }
    }

    // attach the valid options to the function so they can be extended
    _config.MATRIX = MATRIX;
    _config.NUMBER = NUMBER;

    return _config;
  }

  /**
   * Test whether an Array contains a specific item.
   * @param {Array.<string>} array
   * @param {string} item
   * @return {boolean}
   */
  function contains (array, item) {
    return array.indexOf(item) !== -1;
  }

  /**
   * Find a string in an array. Case insensitive search
   * @param {Array.<string>} array
   * @param {string} item
   * @return {number} Returns the index when found. Returns -1 when not found
   */
  function findIndex (array, item) {
    return array
        .map(function (i) {
          return i.toLowerCase();
        })
        .indexOf(item.toLowerCase());
  }

  /**
   * Validate an option
   * @param {Object} options         Object with options
   * @param {string} name            Name of the option to validate
   * @param {Array.<string>} values  Array with valid values for this option
   */
  function validateOption(options, name, values) {
    if (options[name] !== undefined && !contains(values, options[name])) {
      var index = findIndex(values, options[name]);
      if (index !== -1) {
        // right value, wrong casing
        // TODO: lower case values are deprecated since v3, remove this warning some day.
        console.warn('Warning: Wrong casing for configuration option "' + name + '", should be "' + values[index] + '" instead of "' + options[name] + '".');

        options[name] = values[index]; // change the option to the right casing
      }
      else {
        // unknown value
        console.warn('Warning: Unknown value "' + options[name] + '" for configuration option "' + name + '". Available options: ' + values.map(JSON.stringify).join(', ') + '.');
      }
    }
  }

  var name$1 = 'config';
  var math$1 = true; // request the math namespace as fifth argument
  var factory_1$1 = factory$1;

  var config = {
  	name: name$1,
  	math: math$1,
  	factory: factory_1$1
  };

  var isFactory$1 = object.isFactory;






  /**
   * Math.js core. Creates a new, empty math.js instance
   * @param {Object} [options] Available options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'Matrix' (default) or 'Array'.
   *                            {string} number
   *                              A string 'number' (default), 'BigNumber', or 'Fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {boolean} predictable
   *                              Predictable output type of functions. When true,
   *                              output type depends only on the input types. When
   *                              false (default), output type can vary depending
   *                              on input values. For example `math.sqrt(-4)`
   *                              returns `complex('2i')` when predictable is false, and
   *                              returns `NaN` when true.
   *                            {string} randomSeed
   *                              Random seed for seeded pseudo random number generator.
   *                              Set to null to randomly seed.
   * @returns {Object} Returns a bare-bone math.js instance containing
   *                   functions:
   *                   - `import` to add new functions
   *                   - `config` to change configuration
   *                   - `on`, `off`, `once`, `emit` for events
   */
  var create$1 = function create (options) {
    // simple test for ES5 support
    if (typeof Object.create !== 'function') {
      throw new Error('ES5 not supported by this JavaScript engine. ' +
      'Please load the es5-shim and es5-sham library for compatibility.');
    }

    // cached factories and instances
    var factories = [];
    var instances = [];

    // create a namespace for the mathjs instance, and attach emitter functions
    var math = emitter.mixin({});
    math.type = {};
    math.expression = {
      transform: {},
      mathWithTransform: {}
    };

    // create a new typed instance
    math.typed = typed.create(math.type);

    // create configuration options. These are private
    var _config = {
      // minimum relative difference between two compared values,
      // used by all comparison functions
      epsilon: 1e-12,

      // type of default matrix output. Choose 'matrix' (default) or 'array'
      matrix: 'Matrix',

      // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
      number: 'number',

      // number of significant digits in BigNumbers
      precision: 64,

      // predictable output type of functions. When true, output type depends only
      // on the input types. When false (default), output type can vary depending
      // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
      // predictable is false, and returns `NaN` when true.
      predictable: false,

      // random seed for seeded pseudo random number generation
      // null = randomly seed
      randomSeed: null
    };

    /**
     * Load a function or data type from a factory.
     * If the function or data type already exists, the existing instance is
     * returned.
     * @param {{type: string, name: string, factory: Function}} factory
     * @returns {*}
     */
    function load (factory) {
      if (!isFactory$1(factory)) {
        throw new Error('Factory object with properties `type`, `name`, and `factory` expected');
      }

      var index = factories.indexOf(factory);
      var instance;
      if (index === -1) {
        // doesn't yet exist
        if (factory.math === true) {
          // pass with math namespace
          instance = factory.factory(math.type, _config, load, math.typed, math);
        }
        else {
          instance = factory.factory(math.type, _config, load, math.typed);
        }

        // append to the cache
        factories.push(factory);
        instances.push(instance);
      }
      else {
        // already existing function, return the cached instance
        instance = instances[index];
      }

      return instance;
    }

    // load the import and config functions
    math['import'] = load(_import);
    math['config'] = load(config);
    math.expression.mathWithTransform['config'] = math['config'];

    // apply options
    if (options) {
      math.config(options);
    }

    return math;
  };

  var core = {
  	create: create$1
  };

  var core$1 = core;

  var decimal = createCommonjsModule(function (module) {
  (function (globalScope) {


    /*
     *  decimal.js v9.0.1
     *  An arbitrary-precision Decimal type for JavaScript.
     *  https://github.com/MikeMcl/decimal.js
     *  Copyright (c) 2017 Michael Mclaughlin <M8ch88l@gmail.com>
     *  MIT Licence
     */


    // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


      // The maximum exponent magnitude.
      // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15,                      // 0 to 9e15

      // The limit on the value of `precision`, and on the value of the first argument to
      // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
      MAX_DIGITS = 1e9,                        // 0 to 1e9

      // Base conversion alphabet.
      NUMERALS = '0123456789abcdef',

      // The natural logarithm of 10 (1025 digits).
      LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058',

      // Pi (1025 digits).
      PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789',


      // The initial configuration properties of the Decimal constructor.
      DEFAULTS = {

        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.

        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,                         // 1 to MAX_DIGITS

        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,                           // 0 to 8

        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,                             // 0 to 9

        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,                          // 0 to -EXP_LIMIT

        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos:  21,                         // 0 to EXP_LIMIT

        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,                      // -1 to -EXP_LIMIT

        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,                       // 1 to EXP_LIMIT

        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false                          // true/false
      },


    // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


      Decimal, inexact, noConflict, quadrant,
      external = true,

      decimalError = '[DecimalError] ',
      invalidArgument = decimalError + 'Invalid argument: ',
      precisionLimitExceeded = decimalError + 'Precision limit exceeded',
      cryptoUnavailable = decimalError + 'crypto unavailable',

      mathfloor = Math.floor,
      mathpow = Math.pow,

      isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
      isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
      isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
      isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

      BASE = 1e7,
      LOG_BASE = 7,
      MAX_SAFE_INTEGER = 9007199254740991,

      LN10_PRECISION = LN10.length - 1,
      PI_PRECISION = PI.length - 1,

      // Decimal.prototype object
      P = { name: '[object Decimal]' };


    // Decimal prototype methods


    /*
     *  absoluteValue             abs
     *  ceil
     *  comparedTo                cmp
     *  cosine                    cos
     *  cubeRoot                  cbrt
     *  decimalPlaces             dp
     *  dividedBy                 div
     *  dividedToIntegerBy        divToInt
     *  equals                    eq
     *  floor
     *  greaterThan               gt
     *  greaterThanOrEqualTo      gte
     *  hyperbolicCosine          cosh
     *  hyperbolicSine            sinh
     *  hyperbolicTangent         tanh
     *  inverseCosine             acos
     *  inverseHyperbolicCosine   acosh
     *  inverseHyperbolicSine     asinh
     *  inverseHyperbolicTangent  atanh
     *  inverseSine               asin
     *  inverseTangent            atan
     *  isFinite
     *  isInteger                 isInt
     *  isNaN
     *  isNegative                isNeg
     *  isPositive                isPos
     *  isZero
     *  lessThan                  lt
     *  lessThanOrEqualTo         lte
     *  logarithm                 log
     *  [maximum]                 [max]
     *  [minimum]                 [min]
     *  minus                     sub
     *  modulo                    mod
     *  naturalExponential        exp
     *  naturalLogarithm          ln
     *  negated                   neg
     *  plus                      add
     *  precision                 sd
     *  round
     *  sine                      sin
     *  squareRoot                sqrt
     *  tangent                   tan
     *  times                     mul
     *  toBinary
     *  toDecimalPlaces           toDP
     *  toExponential
     *  toFixed
     *  toFraction
     *  toHexadecimal             toHex
     *  toNearest
     *  toNumber
     *  toOctal
     *  toPower                   pow
     *  toPrecision
     *  toSignificantDigits       toSD
     *  toString
     *  truncated                 trunc
     *  valueOf                   toJSON
     */


    /*
     * Return a new Decimal whose value is the absolute value of this Decimal.
     *
     */
    P.absoluteValue = P.abs = function () {
      var x = new this.constructor(this);
      if (x.s < 0) x.s = 1;
      return finalise(x);
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
     * direction of positive Infinity.
     *
     */
    P.ceil = function () {
      return finalise(new this.constructor(this), this.e + 1, 2);
    };


    /*
     * Return
     *   1    if the value of this Decimal is greater than the value of `y`,
     *  -1    if the value of this Decimal is less than the value of `y`,
     *   0    if they have the same value,
     *   NaN  if the value of either Decimal is NaN.
     *
     */
    P.comparedTo = P.cmp = function (y) {
      var i, j, xdL, ydL,
        x = this,
        xd = x.d,
        yd = (y = new x.constructor(y)).d,
        xs = x.s,
        ys = y.s;

      // Either NaN or ±Infinity?
      if (!xd || !yd) {
        return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
      }

      // Either zero?
      if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;

      // Signs differ?
      if (xs !== ys) return xs;

      // Compare exponents.
      if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;

      xdL = xd.length;
      ydL = yd.length;

      // Compare digit by digit.
      for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
        if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
      }

      // Compare lengths.
      return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };


    /*
     * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-1, 1]
     *
     * cos(0)         = 1
     * cos(-0)        = 1
     * cos(Infinity)  = NaN
     * cos(-Infinity) = NaN
     * cos(NaN)       = NaN
     *
     */
    P.cosine = P.cos = function () {
      var pr, rm,
        x = this,
        Ctor = x.constructor;

      if (!x.d) return new Ctor(NaN);

      // cos(0) = cos(-0) = 1
      if (!x.d[0]) return new Ctor(1);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
      Ctor.rounding = 1;

      x = cosine(Ctor, toLessThanHalfPi(Ctor, x));

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };


    /*
     *
     * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
     * `precision` significant digits using rounding mode `rounding`.
     *
     *  cbrt(0)  =  0
     *  cbrt(-0) = -0
     *  cbrt(1)  =  1
     *  cbrt(-1) = -1
     *  cbrt(N)  =  N
     *  cbrt(-I) = -I
     *  cbrt(I)  =  I
     *
     * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
     *
     */
    P.cubeRoot = P.cbrt = function () {
      var e, m, n, r, rep, s, sd, t, t3, t3plusx,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite() || x.isZero()) return new Ctor(x);
      external = false;

      // Initial estimate.
      s = x.s * Math.pow(x.s * x, 1 / 3);

       // Math.cbrt underflow/overflow?
       // Pass x to Math.pow as integer, then adjust the exponent of the result.
      if (!s || Math.abs(s) == 1 / 0) {
        n = digitsToString(x.d);
        e = x.e;

        // Adjust n exponent so it is a multiple of 3 away from x exponent.
        if (s = (e - n.length + 1) % 3) n += (s == 1 || s == -2 ? '0' : '00');
        s = Math.pow(n, 1 / 3);

        // Rarely, e may be one less than the result exponent value.
        e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));

        if (s == 1 / 0) {
          n = '5e' + e;
        } else {
          n = s.toExponential();
          n = n.slice(0, n.indexOf('e') + 1) + e;
        }

        r = new Ctor(n);
        r.s = x.s;
      } else {
        r = new Ctor(s.toString());
      }

      sd = (e = Ctor.precision) + 3;

      // Halley's method.
      // TODO? Compare Newton's method.
      for (;;) {
        t = r;
        t3 = t.times(t).times(t);
        t3plusx = t3.plus(x);
        r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);

        // TODO? Replace with for-loop and checkRoundingDigits.
        if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
          n = n.slice(sd - 3, sd + 1);

          // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
          // , i.e. approaching a rounding boundary, continue the iteration.
          if (n == '9999' || !rep && n == '4999') {

            // On the first iteration only, check to see if rounding up gives the exact result as the
            // nines may infinitely repeat.
            if (!rep) {
              finalise(t, e + 1, 0);

              if (t.times(t).times(t).eq(x)) {
                r = t;
                break;
              }
            }

            sd += 4;
            rep = 1;
          } else {

            // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
            // If not, then there are further digits and m will be truthy.
            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

              // Truncate to the first rounding digit.
              finalise(r, e + 1, 1);
              m = !r.times(r).times(r).eq(x);
            }

            break;
          }
        }
      }

      external = true;

      return finalise(r, e, Ctor.rounding, m);
    };


    /*
     * Return the number of decimal places of the value of this Decimal.
     *
     */
    P.decimalPlaces = P.dp = function () {
      var w,
        d = this.d,
        n = NaN;

      if (d) {
        w = d.length - 1;
        n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;

        // Subtract the number of trailing zeros of the last word.
        w = d[w];
        if (w) for (; w % 10 == 0; w /= 10) n--;
        if (n < 0) n = 0;
      }

      return n;
    };


    /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
     * `precision` significant digits using rounding mode `rounding`.
     *
     */
    P.dividedBy = P.div = function (y) {
      return divide(this, new this.constructor(y));
    };


    /*
     * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
     * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
     *
     */
    P.dividedToIntegerBy = P.divToInt = function (y) {
      var x = this,
        Ctor = x.constructor;
      return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };


    /*
     * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
     *
     */
    P.equals = P.eq = function (y) {
      return this.cmp(y) === 0;
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
     * direction of negative Infinity.
     *
     */
    P.floor = function () {
      return finalise(new this.constructor(this), this.e + 1, 3);
    };


    /*
     * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
     * false.
     *
     */
    P.greaterThan = P.gt = function (y) {
      return this.cmp(y) > 0;
    };


    /*
     * Return true if the value of this Decimal is greater than or equal to the value of `y`,
     * otherwise return false.
     *
     */
    P.greaterThanOrEqualTo = P.gte = function (y) {
      var k = this.cmp(y);
      return k == 1 || k === 0;
    };


    /*
     * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
     * Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [1, Infinity]
     *
     * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
     *
     * cosh(0)         = 1
     * cosh(-0)        = 1
     * cosh(Infinity)  = Infinity
     * cosh(-Infinity) = Infinity
     * cosh(NaN)       = NaN
     *
     *  x        time taken (ms)   result
     * 1000      9                 9.8503555700852349694e+433
     * 10000     25                4.4034091128314607936e+4342
     * 100000    171               1.4033316802130615897e+43429
     * 1000000   3817              1.5166076984010437725e+434294
     * 10000000  abandoned after 2 minute wait
     *
     * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
     *
     */
    P.hyperbolicCosine = P.cosh = function () {
      var k, n, pr, rm, len,
        x = this,
        Ctor = x.constructor,
        one = new Ctor(1);

      if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
      if (x.isZero()) return one;

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
      Ctor.rounding = 1;
      len = x.d.length;

      // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
      // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))

      // Estimate the optimum number of times to use the argument reduction.
      // TODO? Estimation reused from cosine() and may not be optimal here.
      if (len < 32) {
        k = Math.ceil(len / 3);
        n = Math.pow(4, -k).toString();
      } else {
        k = 16;
        n = '2.3283064365386962890625e-10';
      }

      x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);

      // Reverse argument reduction
      var cosh2_x,
        i = k,
        d8 = new Ctor(8);
      for (; i--;) {
        cosh2_x = x.times(x);
        x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
      }

      return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };


    /*
     * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
     * Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-Infinity, Infinity]
     *
     * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
     *
     * sinh(0)         = 0
     * sinh(-0)        = -0
     * sinh(Infinity)  = Infinity
     * sinh(-Infinity) = -Infinity
     * sinh(NaN)       = NaN
     *
     * x        time taken (ms)
     * 10       2 ms
     * 100      5 ms
     * 1000     14 ms
     * 10000    82 ms
     * 100000   886 ms            1.4033316802130615897e+43429
     * 200000   2613 ms
     * 300000   5407 ms
     * 400000   8824 ms
     * 500000   13026 ms          8.7080643612718084129e+217146
     * 1000000  48543 ms
     *
     * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
     *
     */
    P.hyperbolicSine = P.sinh = function () {
      var k, pr, rm, len,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite() || x.isZero()) return new Ctor(x);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
      Ctor.rounding = 1;
      len = x.d.length;

      if (len < 3) {
        x = taylorSeries(Ctor, 2, x, x, true);
      } else {

        // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
        // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
        // 3 multiplications and 1 addition

        // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
        // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
        // 4 multiplications and 2 additions

        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;

        x = x.times(Math.pow(5, -k));

        x = taylorSeries(Ctor, 2, x, x, true);

        // Reverse argument reduction
        var sinh2_x,
          d5 = new Ctor(5),
          d16 = new Ctor(16),
          d20 = new Ctor(20);
        for (; k--;) {
          sinh2_x = x.times(x);
          x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
        }
      }

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return finalise(x, pr, rm, true);
    };


    /*
     * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
     * Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-1, 1]
     *
     * tanh(x) = sinh(x) / cosh(x)
     *
     * tanh(0)         = 0
     * tanh(-0)        = -0
     * tanh(Infinity)  = 1
     * tanh(-Infinity) = -1
     * tanh(NaN)       = NaN
     *
     */
    P.hyperbolicTangent = P.tanh = function () {
      var pr, rm,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite()) return new Ctor(x.s);
      if (x.isZero()) return new Ctor(x);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + 7;
      Ctor.rounding = 1;

      return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };


    /*
     * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
     * this Decimal.
     *
     * Domain: [-1, 1]
     * Range: [0, pi]
     *
     * acos(x) = pi/2 - asin(x)
     *
     * acos(0)       = pi/2
     * acos(-0)      = pi/2
     * acos(1)       = 0
     * acos(-1)      = pi
     * acos(1/2)     = pi/3
     * acos(-1/2)    = 2*pi/3
     * acos(|x| > 1) = NaN
     * acos(NaN)     = NaN
     *
     */
    P.inverseCosine = P.acos = function () {
      var halfPi,
        x = this,
        Ctor = x.constructor,
        k = x.abs().cmp(1),
        pr = Ctor.precision,
        rm = Ctor.rounding;

      if (k !== -1) {
        return k === 0
          // |x| is 1
          ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0)
          // |x| > 1 or x is NaN
          : new Ctor(NaN);
      }

      if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);

      // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3

      Ctor.precision = pr + 6;
      Ctor.rounding = 1;

      x = x.asin();
      halfPi = getPi(Ctor, pr + 4, rm).times(0.5);

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return halfPi.minus(x);
    };


    /*
     * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
     * value of this Decimal.
     *
     * Domain: [1, Infinity]
     * Range: [0, Infinity]
     *
     * acosh(x) = ln(x + sqrt(x^2 - 1))
     *
     * acosh(x < 1)     = NaN
     * acosh(NaN)       = NaN
     * acosh(Infinity)  = Infinity
     * acosh(-Infinity) = NaN
     * acosh(0)         = NaN
     * acosh(-0)        = NaN
     * acosh(1)         = 0
     * acosh(-1)        = NaN
     *
     */
    P.inverseHyperbolicCosine = P.acosh = function () {
      var pr, rm,
        x = this,
        Ctor = x.constructor;

      if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
      if (!x.isFinite()) return new Ctor(x);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
      Ctor.rounding = 1;
      external = false;

      x = x.times(x).minus(1).sqrt().plus(x);

      external = true;
      Ctor.precision = pr;
      Ctor.rounding = rm;

      return x.ln();
    };


    /*
     * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
     * of this Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-Infinity, Infinity]
     *
     * asinh(x) = ln(x + sqrt(x^2 + 1))
     *
     * asinh(NaN)       = NaN
     * asinh(Infinity)  = Infinity
     * asinh(-Infinity) = -Infinity
     * asinh(0)         = 0
     * asinh(-0)        = -0
     *
     */
    P.inverseHyperbolicSine = P.asinh = function () {
      var pr, rm,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite() || x.isZero()) return new Ctor(x);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
      Ctor.rounding = 1;
      external = false;

      x = x.times(x).plus(1).sqrt().plus(x);

      external = true;
      Ctor.precision = pr;
      Ctor.rounding = rm;

      return x.ln();
    };


    /*
     * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
     * value of this Decimal.
     *
     * Domain: [-1, 1]
     * Range: [-Infinity, Infinity]
     *
     * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
     *
     * atanh(|x| > 1)   = NaN
     * atanh(NaN)       = NaN
     * atanh(Infinity)  = NaN
     * atanh(-Infinity) = NaN
     * atanh(0)         = 0
     * atanh(-0)        = -0
     * atanh(1)         = Infinity
     * atanh(-1)        = -Infinity
     *
     */
    P.inverseHyperbolicTangent = P.atanh = function () {
      var pr, rm, wpr, xsd,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite()) return new Ctor(NaN);
      if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      xsd = x.sd();

      if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);

      Ctor.precision = wpr = xsd - x.e;

      x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);

      Ctor.precision = pr + 4;
      Ctor.rounding = 1;

      x = x.ln();

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return x.times(0.5);
    };


    /*
     * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
     * Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-pi/2, pi/2]
     *
     * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
     *
     * asin(0)       = 0
     * asin(-0)      = -0
     * asin(1/2)     = pi/6
     * asin(-1/2)    = -pi/6
     * asin(1)       = pi/2
     * asin(-1)      = -pi/2
     * asin(|x| > 1) = NaN
     * asin(NaN)     = NaN
     *
     * TODO? Compare performance of Taylor series.
     *
     */
    P.inverseSine = P.asin = function () {
      var halfPi, k,
        pr, rm,
        x = this,
        Ctor = x.constructor;

      if (x.isZero()) return new Ctor(x);

      k = x.abs().cmp(1);
      pr = Ctor.precision;
      rm = Ctor.rounding;

      if (k !== -1) {

        // |x| is 1
        if (k === 0) {
          halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
          halfPi.s = x.s;
          return halfPi;
        }

        // |x| > 1 or x is NaN
        return new Ctor(NaN);
      }

      // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6

      Ctor.precision = pr + 6;
      Ctor.rounding = 1;

      x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return x.times(2);
    };


    /*
     * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
     * of this Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-pi/2, pi/2]
     *
     * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
     *
     * atan(0)         = 0
     * atan(-0)        = -0
     * atan(1)         = pi/4
     * atan(-1)        = -pi/4
     * atan(Infinity)  = pi/2
     * atan(-Infinity) = -pi/2
     * atan(NaN)       = NaN
     *
     */
    P.inverseTangent = P.atan = function () {
      var i, j, k, n, px, t, r, wpr, x2,
        x = this,
        Ctor = x.constructor,
        pr = Ctor.precision,
        rm = Ctor.rounding;

      if (!x.isFinite()) {
        if (!x.s) return new Ctor(NaN);
        if (pr + 4 <= PI_PRECISION) {
          r = getPi(Ctor, pr + 4, rm).times(0.5);
          r.s = x.s;
          return r;
        }
      } else if (x.isZero()) {
        return new Ctor(x);
      } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
        r = getPi(Ctor, pr + 4, rm).times(0.25);
        r.s = x.s;
        return r;
      }

      Ctor.precision = wpr = pr + 10;
      Ctor.rounding = 1;

      // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);

      // Argument reduction
      // Ensure |x| < 0.42
      // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))

      k = Math.min(28, wpr / LOG_BASE + 2 | 0);

      for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));

      external = false;

      j = Math.ceil(wpr / LOG_BASE);
      n = 1;
      x2 = x.times(x);
      r = new Ctor(x);
      px = x;

      // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
      for (; i !== -1;) {
        px = px.times(x2);
        t = r.minus(px.div(n += 2));

        px = px.times(x2);
        r = t.plus(px.div(n += 2));

        if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--;);
      }

      if (k) r = r.times(2 << (k - 1));

      external = true;

      return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };


    /*
     * Return true if the value of this Decimal is a finite number, otherwise return false.
     *
     */
    P.isFinite = function () {
      return !!this.d;
    };


    /*
     * Return true if the value of this Decimal is an integer, otherwise return false.
     *
     */
    P.isInteger = P.isInt = function () {
      return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };


    /*
     * Return true if the value of this Decimal is NaN, otherwise return false.
     *
     */
    P.isNaN = function () {
      return !this.s;
    };


    /*
     * Return true if the value of this Decimal is negative, otherwise return false.
     *
     */
    P.isNegative = P.isNeg = function () {
      return this.s < 0;
    };


    /*
     * Return true if the value of this Decimal is positive, otherwise return false.
     *
     */
    P.isPositive = P.isPos = function () {
      return this.s > 0;
    };


    /*
     * Return true if the value of this Decimal is 0 or -0, otherwise return false.
     *
     */
    P.isZero = function () {
      return !!this.d && this.d[0] === 0;
    };


    /*
     * Return true if the value of this Decimal is less than `y`, otherwise return false.
     *
     */
    P.lessThan = P.lt = function (y) {
      return this.cmp(y) < 0;
    };


    /*
     * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
     *
     */
    P.lessThanOrEqualTo = P.lte = function (y) {
      return this.cmp(y) < 1;
    };


    /*
     * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * If no base is specified, return log[10](arg).
     *
     * log[base](arg) = ln(arg) / ln(base)
     *
     * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
     * otherwise:
     *
     * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
     * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
     * between the result and the correctly rounded result will be one ulp (unit in the last place).
     *
     * log[-b](a)       = NaN
     * log[0](a)        = NaN
     * log[1](a)        = NaN
     * log[NaN](a)      = NaN
     * log[Infinity](a) = NaN
     * log[b](0)        = -Infinity
     * log[b](-0)       = -Infinity
     * log[b](-a)       = NaN
     * log[b](1)        = 0
     * log[b](Infinity) = Infinity
     * log[b](NaN)      = NaN
     *
     * [base] {number|string|Decimal} The base of the logarithm.
     *
     */
    P.logarithm = P.log = function (base) {
      var isBase10, d, denominator, k, inf, num, sd, r,
        arg = this,
        Ctor = arg.constructor,
        pr = Ctor.precision,
        rm = Ctor.rounding,
        guard = 5;

      // Default base is 10.
      if (base == null) {
        base = new Ctor(10);
        isBase10 = true;
      } else {
        base = new Ctor(base);
        d = base.d;

        // Return NaN if base is negative, or non-finite, or is 0 or 1.
        if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);

        isBase10 = base.eq(10);
      }

      d = arg.d;

      // Is arg negative, non-finite, 0 or 1?
      if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
        return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
      }

      // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
      // integer power of 10.
      if (isBase10) {
        if (d.length > 1) {
          inf = true;
        } else {
          for (k = d[0]; k % 10 === 0;) k /= 10;
          inf = k !== 1;
        }
      }

      external = false;
      sd = pr + guard;
      num = naturalLogarithm(arg, sd);
      denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);

      // The result will have 5 rounding digits.
      r = divide(num, denominator, sd, 1);

      // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
      // calculate 10 further digits.
      //
      // If the result is known to have an infinite decimal expansion, repeat this until it is clear
      // that the result is above or below the boundary. Otherwise, if after calculating the 10
      // further digits, the last 14 are nines, round up and assume the result is exact.
      // Also assume the result is exact if the last 14 are zero.
      //
      // Example of a result that will be incorrectly rounded:
      // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
      // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
      // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
      // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
      // place is still 2.6.
      if (checkRoundingDigits(r.d, k = pr, rm)) {

        do {
          sd += 10;
          num = naturalLogarithm(arg, sd);
          denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
          r = divide(num, denominator, sd, 1);

          if (!inf) {

            // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
            if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
              r = finalise(r, pr + 1, 0);
            }

            break;
          }
        } while (checkRoundingDigits(r.d, k += 10, rm));
      }

      external = true;

      return finalise(r, pr, rm);
    };


    /*
     * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
     *
     * arguments {number|string|Decimal}
     *
    P.max = function () {
      Array.prototype.push.call(arguments, this);
      return maxOrMin(this.constructor, arguments, 'lt');
    };
     */


    /*
     * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
     *
     * arguments {number|string|Decimal}
     *
    P.min = function () {
      Array.prototype.push.call(arguments, this);
      return maxOrMin(this.constructor, arguments, 'gt');
    };
     */


    /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     */
    P.minus = P.sub = function (y) {
      var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd,
        x = this,
        Ctor = x.constructor;

      y = new Ctor(y);

      // If either is not finite...
      if (!x.d || !y.d) {

        // Return NaN if either is NaN.
        if (!x.s || !y.s) y = new Ctor(NaN);

        // Return y negated if x is finite and y is ±Infinity.
        else if (x.d) y.s = -y.s;

        // Return x if y is finite and x is ±Infinity.
        // Return x if both are ±Infinity with different signs.
        // Return NaN if both are ±Infinity with the same sign.
        else y = new Ctor(y.d || x.s !== y.s ? x : NaN);

        return y;
      }

      // If signs differ...
      if (x.s != y.s) {
        y.s = -y.s;
        return x.plus(y);
      }

      xd = x.d;
      yd = y.d;
      pr = Ctor.precision;
      rm = Ctor.rounding;

      // If either is zero...
      if (!xd[0] || !yd[0]) {

        // Return y negated if x is zero and y is non-zero.
        if (yd[0]) y.s = -y.s;

        // Return x if y is zero and x is non-zero.
        else if (xd[0]) y = new Ctor(x);

        // Return zero if both are zero.
        // From IEEE 754 (2008) 6.3: 0 - 0 = -0 - -0 = -0 when rounding to -Infinity.
        else return new Ctor(rm === 3 ? -0 : 0);

        return external ? finalise(y, pr, rm) : y;
      }

      // x and y are finite, non-zero numbers with the same sign.

      // Calculate base 1e7 exponents.
      e = mathfloor(y.e / LOG_BASE);
      xe = mathfloor(x.e / LOG_BASE);

      xd = xd.slice();
      k = xe - e;

      // If base 1e7 exponents differ...
      if (k) {
        xLTy = k < 0;

        if (xLTy) {
          d = xd;
          k = -k;
          len = yd.length;
        } else {
          d = yd;
          e = xe;
          len = xd.length;
        }

        // Numbers with massively different exponents would result in a very high number of
        // zeros needing to be prepended, but this can be avoided while still ensuring correct
        // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
        i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

        if (k > i) {
          k = i;
          d.length = 1;
        }

        // Prepend zeros to equalise exponents.
        d.reverse();
        for (i = k; i--;) d.push(0);
        d.reverse();

      // Base 1e7 exponents equal.
      } else {

        // Check digits to determine which is the bigger number.

        i = xd.length;
        len = yd.length;
        xLTy = i < len;
        if (xLTy) len = i;

        for (i = 0; i < len; i++) {
          if (xd[i] != yd[i]) {
            xLTy = xd[i] < yd[i];
            break;
          }
        }

        k = 0;
      }

      if (xLTy) {
        d = xd;
        xd = yd;
        yd = d;
        y.s = -y.s;
      }

      len = xd.length;

      // Append zeros to `xd` if shorter.
      // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
      for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

      // Subtract yd from xd.
      for (i = yd.length; i > k;) {

        if (xd[--i] < yd[i]) {
          for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
          --xd[j];
          xd[i] += BASE;
        }

        xd[i] -= yd[i];
      }

      // Remove trailing zeros.
      for (; xd[--len] === 0;) xd.pop();

      // Remove leading zeros and adjust exponent accordingly.
      for (; xd[0] === 0; xd.shift()) --e;

      // Zero?
      if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);

      y.d = xd;
      y.e = getBase10Exponent(xd, e);

      return external ? finalise(y, pr, rm) : y;
    };


    /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
     * `precision` significant digits using rounding mode `rounding`.
     *
     * The result depends on the modulo mode.
     *
     */
    P.modulo = P.mod = function (y) {
      var q,
        x = this,
        Ctor = x.constructor;

      y = new Ctor(y);

      // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
      if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);

      // Return x if y is ±Infinity or x is ±0.
      if (!y.d || x.d && !x.d[0]) {
        return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
      }

      // Prevent rounding of intermediate calculations.
      external = false;

      if (Ctor.modulo == 9) {

        // Euclidian division: q = sign(y) * floor(x / abs(y))
        // result = x - q * y    where  0 <= result < abs(y)
        q = divide(x, y.abs(), 0, 3, 1);
        q.s *= y.s;
      } else {
        q = divide(x, y, 0, Ctor.modulo, 1);
      }

      q = q.times(y);

      external = true;

      return x.minus(q);
    };


    /*
     * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
     * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     */
    P.naturalExponential = P.exp = function () {
      return naturalExponential(this);
    };


    /*
     * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
     * rounded to `precision` significant digits using rounding mode `rounding`.
     *
     */
    P.naturalLogarithm = P.ln = function () {
      return naturalLogarithm(this);
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
     * -1.
     *
     */
    P.negated = P.neg = function () {
      var x = new this.constructor(this);
      x.s = -x.s;
      return finalise(x);
    };


    /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     */
    P.plus = P.add = function (y) {
      var carry, d, e, i, k, len, pr, rm, xd, yd,
        x = this,
        Ctor = x.constructor;

      y = new Ctor(y);

      // If either is not finite...
      if (!x.d || !y.d) {

        // Return NaN if either is NaN.
        if (!x.s || !y.s) y = new Ctor(NaN);

        // Return x if y is finite and x is ±Infinity.
        // Return x if both are ±Infinity with the same sign.
        // Return NaN if both are ±Infinity with different signs.
        // Return y if x is finite and y is ±Infinity.
        else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);

        return y;
      }

       // If signs differ...
      if (x.s != y.s) {
        y.s = -y.s;
        return x.minus(y);
      }

      xd = x.d;
      yd = y.d;
      pr = Ctor.precision;
      rm = Ctor.rounding;

      // If either is zero...
      if (!xd[0] || !yd[0]) {

        // Return x if y is zero.
        // Return y if y is non-zero.
        if (!yd[0]) y = new Ctor(x);

        return external ? finalise(y, pr, rm) : y;
      }

      // x and y are finite, non-zero numbers with the same sign.

      // Calculate base 1e7 exponents.
      k = mathfloor(x.e / LOG_BASE);
      e = mathfloor(y.e / LOG_BASE);

      xd = xd.slice();
      i = k - e;

      // If base 1e7 exponents differ...
      if (i) {

        if (i < 0) {
          d = xd;
          i = -i;
          len = yd.length;
        } else {
          d = yd;
          e = k;
          len = xd.length;
        }

        // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
        k = Math.ceil(pr / LOG_BASE);
        len = k > len ? k + 1 : len + 1;

        if (i > len) {
          i = len;
          d.length = 1;
        }

        // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
        d.reverse();
        for (; i--;) d.push(0);
        d.reverse();
      }

      len = xd.length;
      i = yd.length;

      // If yd is longer than xd, swap xd and yd so xd points to the longer array.
      if (len - i < 0) {
        i = len;
        d = yd;
        yd = xd;
        xd = d;
      }

      // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
      for (carry = 0; i;) {
        carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
        xd[i] %= BASE;
      }

      if (carry) {
        xd.unshift(carry);
        ++e;
      }

      // Remove trailing zeros.
      // No need to check for zero, as +x + +y != 0 && -x + -y != 0
      for (len = xd.length; xd[--len] == 0;) xd.pop();

      y.d = xd;
      y.e = getBase10Exponent(xd, e);

      return external ? finalise(y, pr, rm) : y;
    };


    /*
     * Return the number of significant digits of the value of this Decimal.
     *
     * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
     *
     */
    P.precision = P.sd = function (z) {
      var k,
        x = this;

      if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

      if (x.d) {
        k = getPrecision(x.d);
        if (z && x.e + 1 > k) k = x.e + 1;
      } else {
        k = NaN;
      }

      return k;
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
     * rounding mode `rounding`.
     *
     */
    P.round = function () {
      var x = this,
        Ctor = x.constructor;

      return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };


    /*
     * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-1, 1]
     *
     * sin(x) = x - x^3/3! + x^5/5! - ...
     *
     * sin(0)         = 0
     * sin(-0)        = -0
     * sin(Infinity)  = NaN
     * sin(-Infinity) = NaN
     * sin(NaN)       = NaN
     *
     */
    P.sine = P.sin = function () {
      var pr, rm,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite()) return new Ctor(NaN);
      if (x.isZero()) return new Ctor(x);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
      Ctor.rounding = 1;

      x = sine(Ctor, toLessThanHalfPi(Ctor, x));

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };


    /*
     * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     *  sqrt(-n) =  N
     *  sqrt(N)  =  N
     *  sqrt(-I) =  N
     *  sqrt(I)  =  I
     *  sqrt(0)  =  0
     *  sqrt(-0) = -0
     *
     */
    P.squareRoot = P.sqrt = function () {
      var m, n, sd, r, rep, t,
        x = this,
        d = x.d,
        e = x.e,
        s = x.s,
        Ctor = x.constructor;

      // Negative/NaN/Infinity/zero?
      if (s !== 1 || !d || !d[0]) {
        return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
      }

      external = false;

      // Initial estimate.
      s = Math.sqrt(+x);

      // Math.sqrt underflow/overflow?
      // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
      if (s == 0 || s == 1 / 0) {
        n = digitsToString(d);

        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(n);
        e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

        if (s == 1 / 0) {
          n = '1e' + e;
        } else {
          n = s.toExponential();
          n = n.slice(0, n.indexOf('e') + 1) + e;
        }

        r = new Ctor(n);
      } else {
        r = new Ctor(s.toString());
      }

      sd = (e = Ctor.precision) + 3;

      // Newton-Raphson iteration.
      for (;;) {
        t = r;
        r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);

        // TODO? Replace with for-loop and checkRoundingDigits.
        if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
          n = n.slice(sd - 3, sd + 1);

          // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
          // 4999, i.e. approaching a rounding boundary, continue the iteration.
          if (n == '9999' || !rep && n == '4999') {

            // On the first iteration only, check to see if rounding up gives the exact result as the
            // nines may infinitely repeat.
            if (!rep) {
              finalise(t, e + 1, 0);

              if (t.times(t).eq(x)) {
                r = t;
                break;
              }
            }

            sd += 4;
            rep = 1;
          } else {

            // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
            // If not, then there are further digits and m will be truthy.
            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

              // Truncate to the first rounding digit.
              finalise(r, e + 1, 1);
              m = !r.times(r).eq(x);
            }

            break;
          }
        }
      }

      external = true;

      return finalise(r, e, Ctor.rounding, m);
    };


    /*
     * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-Infinity, Infinity]
     *
     * tan(0)         = 0
     * tan(-0)        = -0
     * tan(Infinity)  = NaN
     * tan(-Infinity) = NaN
     * tan(NaN)       = NaN
     *
     */
    P.tangent = P.tan = function () {
      var pr, rm,
        x = this,
        Ctor = x.constructor;

      if (!x.isFinite()) return new Ctor(NaN);
      if (x.isZero()) return new Ctor(x);

      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + 10;
      Ctor.rounding = 1;

      x = x.sin();
      x.s = 1;
      x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);

      Ctor.precision = pr;
      Ctor.rounding = rm;

      return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };


    /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     */
    P.times = P.mul = function (y) {
      var carry, e, i, k, r, rL, t, xdL, ydL,
        x = this,
        Ctor = x.constructor,
        xd = x.d,
        yd = (y = new Ctor(y)).d;

      y.s *= x.s;

       // If either is NaN, ±Infinity or ±0...
      if (!xd || !xd[0] || !yd || !yd[0]) {

        return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd

          // Return NaN if either is NaN.
          // Return NaN if x is ±0 and y is ±Infinity, or y is ±0 and x is ±Infinity.
          ? NaN

          // Return ±Infinity if either is ±Infinity.
          // Return ±0 if either is ±0.
          : !xd || !yd ? y.s / 0 : y.s * 0);
      }

      e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
      xdL = xd.length;
      ydL = yd.length;

      // Ensure xd points to the longer array.
      if (xdL < ydL) {
        r = xd;
        xd = yd;
        yd = r;
        rL = xdL;
        xdL = ydL;
        ydL = rL;
      }

      // Initialise the result array with zeros.
      r = [];
      rL = xdL + ydL;
      for (i = rL; i--;) r.push(0);

      // Multiply!
      for (i = ydL; --i >= 0;) {
        carry = 0;
        for (k = xdL + i; k > i;) {
          t = r[k] + yd[i] * xd[k - i - 1] + carry;
          r[k--] = t % BASE | 0;
          carry = t / BASE | 0;
        }

        r[k] = (r[k] + carry) % BASE | 0;
      }

      // Remove trailing zeros.
      for (; !r[--rL];) r.pop();

      if (carry) ++e;
      else r.shift();

      y.d = r;
      y.e = getBase10Exponent(r, e);

      return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };


    /*
     * Return a string representing the value of this Decimal in base 2, round to `sd` significant
     * digits using rounding mode `rm`.
     *
     * If the optional `sd` argument is present then return binary exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     */
    P.toBinary = function (sd, rm) {
      return toStringBinary(this, 2, sd, rm);
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
     * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
     *
     * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     */
    P.toDecimalPlaces = P.toDP = function (dp, rm) {
      var x = this,
        Ctor = x.constructor;

      x = new Ctor(x);
      if (dp === void 0) return x;

      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      return finalise(x, dp + x.e + 1, rm);
    };


    /*
     * Return a string representing the value of this Decimal in exponential notation rounded to
     * `dp` fixed decimal places using rounding mode `rounding`.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     */
    P.toExponential = function (dp, rm) {
      var str,
        x = this,
        Ctor = x.constructor;

      if (dp === void 0) {
        str = finiteToString(x, true);
      } else {
        checkInt32(dp, 0, MAX_DIGITS);

        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);

        x = finalise(new Ctor(x), dp + 1, rm);
        str = finiteToString(x, true, dp + 1);
      }

      return x.isNeg() && !x.isZero() ? '-' + str : str;
    };


    /*
     * Return a string representing the value of this Decimal in normal (fixed-point) notation to
     * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
     * omitted.
     *
     * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
     * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
     * (-0).toFixed(3) is '0.000'.
     * (-0.5).toFixed(0) is '-0'.
     *
     */
    P.toFixed = function (dp, rm) {
      var str, y,
        x = this,
        Ctor = x.constructor;

      if (dp === void 0) {
        str = finiteToString(x);
      } else {
        checkInt32(dp, 0, MAX_DIGITS);

        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);

        y = finalise(new Ctor(x), dp + x.e + 1, rm);
        str = finiteToString(y, false, dp + y.e + 1);
      }

      // To determine whether to add the minus sign look at the value before it was rounded,
      // i.e. look at `x` rather than `y`.
      return x.isNeg() && !x.isZero() ? '-' + str : str;
    };


    /*
     * Return an array representing the value of this Decimal as a simple fraction with an integer
     * numerator and an integer denominator.
     *
     * The denominator will be a positive non-zero value less than or equal to the specified maximum
     * denominator. If a maximum denominator is not specified, the denominator will be the lowest
     * value necessary to represent the number exactly.
     *
     * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
     *
     */
    P.toFraction = function (maxD) {
      var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r,
        x = this,
        xd = x.d,
        Ctor = x.constructor;

      if (!xd) return new Ctor(x);

      n1 = d0 = new Ctor(1);
      d1 = n0 = new Ctor(0);

      d = new Ctor(d1);
      e = d.e = getPrecision(xd) - x.e - 1;
      k = e % LOG_BASE;
      d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);

      if (maxD == null) {

        // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
      } else {
        n = new Ctor(maxD);
        if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
        maxD = n.gt(d) ? (e > 0 ? d : n1) : n;
      }

      external = false;
      n = new Ctor(digitsToString(xd));
      pr = Ctor.precision;
      Ctor.precision = e = xd.length * LOG_BASE * 2;

      for (;;)  {
        q = divide(n, d, 0, 1, 1);
        d2 = d0.plus(q.times(d1));
        if (d2.cmp(maxD) == 1) break;
        d0 = d1;
        d1 = d2;
        d2 = n1;
        n1 = n0.plus(q.times(d2));
        n0 = d2;
        d2 = d;
        d = n.minus(q.times(d2));
        n = d2;
      }

      d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
      n0 = n0.plus(d2.times(n1));
      d0 = d0.plus(d2.times(d1));
      n0.s = n1.s = x.s;

      // Determine which fraction is closer to x, n0/d0 or n1/d1?
      r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1
          ? [n1, d1] : [n0, d0];

      Ctor.precision = pr;
      external = true;

      return r;
    };


    /*
     * Return a string representing the value of this Decimal in base 16, round to `sd` significant
     * digits using rounding mode `rm`.
     *
     * If the optional `sd` argument is present then return binary exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     */
    P.toHexadecimal = P.toHex = function (sd, rm) {
      return toStringBinary(this, 16, sd, rm);
    };



    /*
     * Returns a new Decimal whose value is the nearest multiple of the magnitude of `y` to the value
     * of this Decimal.
     *
     * If the value of this Decimal is equidistant from two multiples of `y`, the rounding mode `rm`,
     * or `Decimal.rounding` if `rm` is omitted, determines the direction of the nearest multiple.
     *
     * In the context of this method, rounding mode 4 (ROUND_HALF_UP) is the same as rounding mode 0
     * (ROUND_UP), and so on.
     *
     * The return value will always have the same sign as this Decimal, unless either this Decimal
     * or `y` is NaN, in which case the return value will be also be NaN.
     *
     * The return value is not affected by the value of `precision`.
     *
     * y {number|string|Decimal} The magnitude to round to a multiple of.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * 'toNearest() rounding mode not an integer: {rm}'
     * 'toNearest() rounding mode out of range: {rm}'
     *
     */
    P.toNearest = function (y, rm) {
      var x = this,
        Ctor = x.constructor;

      x = new Ctor(x);

      if (y == null) {

        // If x is not finite, return x.
        if (!x.d) return x;

        y = new Ctor(1);
        rm = Ctor.rounding;
      } else {
        y = new Ctor(y);
        if (rm !== void 0) checkInt32(rm, 0, 8);

        // If x is not finite, return x if y is not NaN, else NaN.
        if (!x.d) return y.s ? x : y;

        // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
        if (!y.d) {
          if (y.s) y.s = x.s;
          return y;
        }
      }

      // If y is not zero, calculate the nearest multiple of y to x.
      if (y.d[0]) {
        external = false;
        if (rm < 4) rm = [4, 5, 7, 8][rm];
        x = divide(x, y, 0, rm, 1).times(y);
        external = true;
        finalise(x);

      // If y is zero, return zero with the sign of x.
      } else {
        y.s = x.s;
        x = y;
      }

      return x;
    };


    /*
     * Return the value of this Decimal converted to a number primitive.
     * Zero keeps its sign.
     *
     */
    P.toNumber = function () {
      return +this;
    };


    /*
     * Return a string representing the value of this Decimal in base 8, round to `sd` significant
     * digits using rounding mode `rm`.
     *
     * If the optional `sd` argument is present then return binary exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     */
    P.toOctal = function (sd, rm) {
      return toStringBinary(this, 8, sd, rm);
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
     * to `precision` significant digits using rounding mode `rounding`.
     *
     * ECMAScript compliant.
     *
     *   pow(x, NaN)                           = NaN
     *   pow(x, ±0)                            = 1

     *   pow(NaN, non-zero)                    = NaN
     *   pow(abs(x) > 1, +Infinity)            = +Infinity
     *   pow(abs(x) > 1, -Infinity)            = +0
     *   pow(abs(x) == 1, ±Infinity)           = NaN
     *   pow(abs(x) < 1, +Infinity)            = +0
     *   pow(abs(x) < 1, -Infinity)            = +Infinity
     *   pow(+Infinity, y > 0)                 = +Infinity
     *   pow(+Infinity, y < 0)                 = +0
     *   pow(-Infinity, odd integer > 0)       = -Infinity
     *   pow(-Infinity, even integer > 0)      = +Infinity
     *   pow(-Infinity, odd integer < 0)       = -0
     *   pow(-Infinity, even integer < 0)      = +0
     *   pow(+0, y > 0)                        = +0
     *   pow(+0, y < 0)                        = +Infinity
     *   pow(-0, odd integer > 0)              = -0
     *   pow(-0, even integer > 0)             = +0
     *   pow(-0, odd integer < 0)              = -Infinity
     *   pow(-0, even integer < 0)             = +Infinity
     *   pow(finite x < 0, finite non-integer) = NaN
     *
     * For non-integer or very large exponents pow(x, y) is calculated using
     *
     *   x^y = exp(y*ln(x))
     *
     * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
     * probability of an incorrectly rounded result
     * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
     * i.e. 1 in 250,000,000,000,000
     *
     * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
     *
     * y {number|string|Decimal} The power to which to raise this Decimal.
     *
     */
    P.toPower = P.pow = function (y) {
      var e, k, pr, r, rm, s,
        x = this,
        Ctor = x.constructor,
        yn = +(y = new Ctor(y));

      // Either ±Infinity, NaN or ±0?
      if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));

      x = new Ctor(x);

      if (x.eq(1)) return x;

      pr = Ctor.precision;
      rm = Ctor.rounding;

      if (y.eq(1)) return finalise(x, pr, rm);

      // y exponent
      e = mathfloor(y.e / LOG_BASE);

      // If y is a small integer use the 'exponentiation by squaring' algorithm.
      if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
        r = intPow(Ctor, x, k, pr);
        return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
      }

      s = x.s;

      // if x is negative
      if (s < 0) {

        // if y is not an integer
        if (e < y.d.length - 1) return new Ctor(NaN);

        // Result is positive if x is negative and the last digit of integer y is even.
        if ((y.d[e] & 1) == 0) s = 1;

        // if x.eq(-1)
        if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
          x.s = s;
          return x;
        }
      }

      // Estimate result exponent.
      // x^y = 10^e,  where e = y * log10(x)
      // log10(x) = log10(x_significand) + x_exponent
      // log10(x_significand) = ln(x_significand) / ln(10)
      k = mathpow(+x, yn);
      e = k == 0 || !isFinite(k)
        ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1))
        : new Ctor(k + '').e;

      // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.

      // Overflow/underflow?
      if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);

      external = false;
      Ctor.rounding = x.s = 1;

      // Estimate the extra guard digits needed to ensure five correct rounding digits from
      // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
      // new Decimal(2.32456).pow('2087987436534566.46411')
      // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
      k = Math.min(12, (e + '').length);

      // r = x^y = exp(y*ln(x))
      r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);

      // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
      if (r.d) {

        // Truncate to the required precision plus five rounding digits.
        r = finalise(r, pr + 5, 1);

        // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
        // the result.
        if (checkRoundingDigits(r.d, pr, rm)) {
          e = pr + 10;

          // Truncate to the increased precision plus five rounding digits.
          r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);

          // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
          if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
            r = finalise(r, pr + 1, 0);
          }
        }
      }

      r.s = s;
      external = true;
      Ctor.rounding = rm;

      return finalise(r, pr, rm);
    };


    /*
     * Return a string representing the value of this Decimal rounded to `sd` significant digits
     * using rounding mode `rounding`.
     *
     * Return exponential notation if `sd` is less than the number of digits necessary to represent
     * the integer part of the value in normal notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     */
    P.toPrecision = function (sd, rm) {
      var str,
        x = this,
        Ctor = x.constructor;

      if (sd === void 0) {
        str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
      } else {
        checkInt32(sd, 1, MAX_DIGITS);

        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);

        x = finalise(new Ctor(x), sd, rm);
        str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
      }

      return x.isNeg() && !x.isZero() ? '-' + str : str;
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
     * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
     * omitted.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * 'toSD() digits out of range: {sd}'
     * 'toSD() digits not an integer: {sd}'
     * 'toSD() rounding mode not an integer: {rm}'
     * 'toSD() rounding mode out of range: {rm}'
     *
     */
    P.toSignificantDigits = P.toSD = function (sd, rm) {
      var x = this,
        Ctor = x.constructor;

      if (sd === void 0) {
        sd = Ctor.precision;
        rm = Ctor.rounding;
      } else {
        checkInt32(sd, 1, MAX_DIGITS);

        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
      }

      return finalise(new Ctor(x), sd, rm);
    };


    /*
     * Return a string representing the value of this Decimal.
     *
     * Return exponential notation if this Decimal has a positive exponent equal to or greater than
     * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
     *
     */
    P.toString = function () {
      var x = this,
        Ctor = x.constructor,
        str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);

      return x.isNeg() && !x.isZero() ? '-' + str : str;
    };


    /*
     * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
     *
     */
    P.truncated = P.trunc = function () {
      return finalise(new this.constructor(this), this.e + 1, 1);
    };


    /*
     * Return a string representing the value of this Decimal.
     * Unlike `toString`, negative zero will include the minus sign.
     *
     */
    P.valueOf = P.toJSON = function () {
      var x = this,
        Ctor = x.constructor,
        str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);

      return x.isNeg() ? '-' + str : str;
    };


    /*
    // Add aliases to match BigDecimal method names.
    // P.add = P.plus;
    P.subtract = P.minus;
    P.multiply = P.times;
    P.divide = P.div;
    P.remainder = P.mod;
    P.compareTo = P.cmp;
    P.negate = P.neg;
     */


    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


    /*
     *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
     *                           finiteToString, naturalExponential, naturalLogarithm
     *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
     *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
     *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
     *  convertBase              toStringBinary, parseOther
     *  cos                      P.cos
     *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
     *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
     *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
     *                           taylorSeries, atan2, parseOther
     *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
     *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
     *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
     *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
     *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
     *                           P.truncated, divide, getLn10, getPi, naturalExponential,
     *                           naturalLogarithm, ceil, floor, round, trunc
     *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
     *                           toStringBinary
     *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
     *  getLn10                  P.logarithm, naturalLogarithm
     *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
     *  getPrecision             P.precision, P.toFraction
     *  getZeroString            digitsToString, finiteToString
     *  intPow                   P.toPower, parseOther
     *  isOdd                    toLessThanHalfPi
     *  maxOrMin                 max, min
     *  naturalExponential       P.naturalExponential, P.toPower
     *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
     *                           P.toPower, naturalExponential
     *  nonFiniteToString        finiteToString, toStringBinary
     *  parseDecimal             Decimal
     *  parseOther               Decimal
     *  sin                      P.sin
     *  taylorSeries             P.cosh, P.sinh, cos, sin
     *  toLessThanHalfPi         P.cos, P.sin
     *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
     *  truncate                 intPow
     *
     *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
     *                           naturalLogarithm, config, parseOther, random, Decimal
     */


    function digitsToString(d) {
      var i, k, ws,
        indexOfLastWord = d.length - 1,
        str = '',
        w = d[0];

      if (indexOfLastWord > 0) {
        str += w;
        for (i = 1; i < indexOfLastWord; i++) {
          ws = d[i] + '';
          k = LOG_BASE - ws.length;
          if (k) str += getZeroString(k);
          str += ws;
        }

        w = d[i];
        ws = w + '';
        k = LOG_BASE - ws.length;
        if (k) str += getZeroString(k);
      } else if (w === 0) {
        return '0';
      }

      // Remove trailing zeros of last w.
      for (; w % 10 === 0;) w /= 10;

      return str + w;
    }


    function checkInt32(i, min, max) {
      if (i !== ~~i || i < min || i > max) {
        throw Error(invalidArgument + i);
      }
    }


    /*
     * Check 5 rounding digits if `repeating` is null, 4 otherwise.
     * `repeating == null` if caller is `log` or `pow`,
     * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
     */
    function checkRoundingDigits(d, i, rm, repeating) {
      var di, k, r, rd;

      // Get the length of the first word of the array d.
      for (k = d[0]; k >= 10; k /= 10) --i;

      // Is the rounding digit in the first word of d?
      if (--i < 0) {
        i += LOG_BASE;
        di = 0;
      } else {
        di = Math.ceil((i + 1) / LOG_BASE);
        i %= LOG_BASE;
      }

      // i is the index (0 - 6) of the rounding digit.
      // E.g. if within the word 3487563 the first rounding digit is 5,
      // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
      k = mathpow(10, LOG_BASE - i);
      rd = d[di] % k | 0;

      if (repeating == null) {
        if (i < 3) {
          if (i == 0) rd = rd / 100 | 0;
          else if (i == 1) rd = rd / 10 | 0;
          r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
        } else {
          r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) &&
            (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 ||
              (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        }
      } else {
        if (i < 4) {
          if (i == 0) rd = rd / 1000 | 0;
          else if (i == 1) rd = rd / 100 | 0;
          else if (i == 2) rd = rd / 10 | 0;
          r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else {
          r = ((repeating || rm < 4) && rd + 1 == k ||
          (!repeating && rm > 3) && rd + 1 == k / 2) &&
            (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        }
      }

      return r;
    }


    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
      var j,
        arr = [0],
        arrL,
        i = 0,
        strL = str.length;

      for (; i < strL;) {
        for (arrL = arr.length; arrL--;) arr[arrL] *= baseIn;
        arr[0] += NUMERALS.indexOf(str.charAt(i++));
        for (j = 0; j < arr.length; j++) {
          if (arr[j] > baseOut - 1) {
            if (arr[j + 1] === void 0) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
          }
        }
      }

      return arr.reverse();
    }


    /*
     * cos(x) = 1 - x^2/2! + x^4/4! - ...
     * |x| < pi/2
     *
     */
    function cosine(Ctor, x) {
      var k, y,
        len = x.d.length;

      // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
      // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1

      // Estimate the optimum number of times to use the argument reduction.
      if (len < 32) {
        k = Math.ceil(len / 3);
        y = Math.pow(4, -k).toString();
      } else {
        k = 16;
        y = '2.3283064365386962890625e-10';
      }

      Ctor.precision += k;

      x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));

      // Reverse argument reduction
      for (var i = k; i--;) {
        var cos2x = x.times(x);
        x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
      }

      Ctor.precision -= k;

      return x;
    }


    /*
     * Perform division in the specified base.
     */
    var divide = (function () {

      // Assumes non-zero x and k, and hence non-zero result.
      function multiplyInteger(x, k, base) {
        var temp,
          carry = 0,
          i = x.length;

        for (x = x.slice(); i--;) {
          temp = x[i] * k + carry;
          x[i] = temp % base | 0;
          carry = temp / base | 0;
        }

        if (carry) x.unshift(carry);

        return x;
      }

      function compare(a, b, aL, bL) {
        var i, r;

        if (aL != bL) {
          r = aL > bL ? 1 : -1;
        } else {
          for (i = r = 0; i < aL; i++) {
            if (a[i] != b[i]) {
              r = a[i] > b[i] ? 1 : -1;
              break;
            }
          }
        }

        return r;
      }

      function subtract(a, b, aL, base) {
        var i = 0;

        // Subtract b from a.
        for (; aL--;) {
          a[aL] -= i;
          i = a[aL] < b[aL] ? 1 : 0;
          a[aL] = i * base + a[aL] - b[aL];
        }

        // Remove leading zeros.
        for (; !a[0] && a.length > 1;) a.shift();
      }

      return function (x, y, pr, rm, dp, base) {
        var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0,
          yL, yz,
          Ctor = x.constructor,
          sign = x.s == y.s ? 1 : -1,
          xd = x.d,
          yd = y.d;

        // Either NaN, Infinity or 0?
        if (!xd || !xd[0] || !yd || !yd[0]) {

          return new Ctor(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN :

            // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
        }

        if (base) {
          logBase = 1;
          e = x.e - y.e;
        } else {
          base = BASE;
          logBase = LOG_BASE;
          e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
        }

        yL = yd.length;
        xL = xd.length;
        q = new Ctor(sign);
        qd = q.d = [];

        // Result exponent may be one less than e.
        // The digit array of a Decimal from toStringBinary may have trailing zeros.
        for (i = 0; yd[i] == (xd[i] || 0); i++);

        if (yd[i] > (xd[i] || 0)) e--;

        if (pr == null) {
          sd = pr = Ctor.precision;
          rm = Ctor.rounding;
        } else if (dp) {
          sd = pr + (x.e - y.e) + 1;
        } else {
          sd = pr;
        }

        if (sd < 0) {
          qd.push(1);
          more = true;
        } else {

          // Convert precision in number of base 10 digits to base 1e7 digits.
          sd = sd / logBase + 2 | 0;
          i = 0;

          // divisor < 1e7
          if (yL == 1) {
            k = 0;
            yd = yd[0];
            sd++;

            // k is the carry.
            for (; (i < xL || k) && sd--; i++) {
              t = k * base + (xd[i] || 0);
              qd[i] = t / yd | 0;
              k = t % yd | 0;
            }

            more = k || i < xL;

          // divisor >= 1e7
          } else {

            // Normalise xd and yd so highest order digit of yd is >= base/2
            k = base / (yd[0] + 1) | 0;

            if (k > 1) {
              yd = multiplyInteger(yd, k, base);
              xd = multiplyInteger(xd, k, base);
              yL = yd.length;
              xL = xd.length;
            }

            xi = yL;
            rem = xd.slice(0, yL);
            remL = rem.length;

            // Add zeros to make remainder as long as divisor.
            for (; remL < yL;) rem[remL++] = 0;

            yz = yd.slice();
            yz.unshift(0);
            yd0 = yd[0];

            if (yd[1] >= base / 2) ++yd0;

            do {
              k = 0;

              // Compare divisor and remainder.
              cmp = compare(yd, rem, yL, remL);

              // If divisor < remainder.
              if (cmp < 0) {

                // Calculate trial digit, k.
                rem0 = rem[0];
                if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

                // k will be how many times the divisor goes into the current remainder.
                k = rem0 / yd0 | 0;

                //  Algorithm:
                //  1. product = divisor * trial digit (k)
                //  2. if product > remainder: product -= divisor, k--
                //  3. remainder -= product
                //  4. if product was < remainder at 2:
                //    5. compare new remainder and divisor
                //    6. If remainder > divisor: remainder -= divisor, k++

                if (k > 1) {
                  if (k >= base) k = base - 1;

                  // product = divisor * trial digit.
                  prod = multiplyInteger(yd, k, base);
                  prodL = prod.length;
                  remL = rem.length;

                  // Compare product and remainder.
                  cmp = compare(prod, rem, prodL, remL);

                  // product > remainder.
                  if (cmp == 1) {
                    k--;

                    // Subtract divisor from product.
                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                  }
                } else {

                  // cmp is -1.
                  // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                  // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                  if (k == 0) cmp = k = 1;
                  prod = yd.slice();
                }

                prodL = prod.length;
                if (prodL < remL) prod.unshift(0);

                // Subtract product from remainder.
                subtract(rem, prod, remL, base);

                // If product was < previous remainder.
                if (cmp == -1) {
                  remL = rem.length;

                  // Compare divisor and new remainder.
                  cmp = compare(yd, rem, yL, remL);

                  // If divisor < new remainder, subtract divisor from remainder.
                  if (cmp < 1) {
                    k++;

                    // Subtract divisor from remainder.
                    subtract(rem, yL < remL ? yz : yd, remL, base);
                  }
                }

                remL = rem.length;
              } else if (cmp === 0) {
                k++;
                rem = [0];
              }    // if cmp === 1, k will be 0

              // Add the next digit, k, to the result array.
              qd[i++] = k;

              // Update the remainder.
              if (cmp && rem[0]) {
                rem[remL++] = xd[xi] || 0;
              } else {
                rem = [xd[xi]];
                remL = 1;
              }

            } while ((xi++ < xL || rem[0] !== void 0) && sd--);

            more = rem[0] !== void 0;
          }

          // Leading zero?
          if (!qd[0]) qd.shift();
        }

        // logBase is 1 when divide is being used for base conversion.
        if (logBase == 1) {
          q.e = e;
          inexact = more;
        } else {

          // To calculate q.e, first get the number of digits of qd[0].
          for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
          q.e = i + e * logBase - 1;

          finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
        }

        return q;
      };
    })();


    /*
     * Round `x` to `sd` significant digits using rounding mode `rm`.
     * Check for over/under-flow.
     */
     function finalise(x, sd, rm, isTruncated) {
      var digits, i, j, k, rd, roundUp, w, xd, xdi,
        Ctor = x.constructor;

      // Don't round if sd is null or undefined.
      out: if (sd != null) {
        xd = x.d;

        // Infinity/NaN.
        if (!xd) return x;

        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd containing rd, a base 1e7 number.
        // xdi: the index of w within xd.
        // digits: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

        // Get the length of the first word of the digits array xd.
        for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
        i = sd - digits;

        // Is the rounding digit in the first word of xd?
        if (i < 0) {
          i += LOG_BASE;
          j = sd;
          w = xd[xdi = 0];

          // Get the rounding digit at index j of w.
          rd = w / mathpow(10, digits - j - 1) % 10 | 0;
        } else {
          xdi = Math.ceil((i + 1) / LOG_BASE);
          k = xd.length;
          if (xdi >= k) {
            if (isTruncated) {

              // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
              for (; k++ <= xdi;) xd.push(0);
              w = rd = 0;
              digits = 1;
              i %= LOG_BASE;
              j = i - LOG_BASE + 1;
            } else {
              break out;
            }
          } else {
            w = k = xd[xdi];

            // Get the number of digits of w.
            for (digits = 1; k >= 10; k /= 10) digits++;

            // Get the index of rd within w.
            i %= LOG_BASE;

            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - digits.
            j = i - LOG_BASE + digits;

            // Get the rounding digit at index j of w.
            rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
          }
        }

        // Are there any non-zero digits after the rounding digit?
        isTruncated = isTruncated || sd < 0 ||
          xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));

        // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
        // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
        // will give 714.

        roundUp = rm < 4
          ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
          : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 &&

            // Check whether the digit to the left of the rounding digit is odd.
            ((i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
              rm == (x.s < 0 ? 8 : 7));

        if (sd < 1 || !xd[0]) {
          xd.length = 0;
          if (roundUp) {

            // Convert sd to decimal places.
            sd -= x.e + 1;

            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
            x.e = -sd || 0;
          } else {

            // Zero.
            xd[0] = x.e = 0;
          }

          return x;
        }

        // Remove excess digits.
        if (i == 0) {
          xd.length = xdi;
          k = 1;
          xdi--;
        } else {
          xd.length = xdi + 1;
          k = mathpow(10, LOG_BASE - i);

          // E.g. 56700 becomes 56000 if 7 is the rounding digit.
          // j > 0 means i > number of leading zeros of w.
          xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
        }

        if (roundUp) {
          for (;;) {

            // Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {

              // i will be the length of xd[0] before k is added.
              for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
              j = xd[0] += k;
              for (k = 1; j >= 10; j /= 10) k++;

              // if i != k the length has increased.
              if (i != k) {
                x.e++;
                if (xd[0] == BASE) xd[0] = 1;
              }

              break;
            } else {
              xd[xdi] += k;
              if (xd[xdi] != BASE) break;
              xd[xdi--] = 0;
              k = 1;
            }
          }
        }

        // Remove trailing zeros.
        for (i = xd.length; xd[--i] === 0;) xd.pop();
      }

      if (external) {

        // Overflow?
        if (x.e > Ctor.maxE) {

          // Infinity.
          x.d = null;
          x.e = NaN;

        // Underflow?
        } else if (x.e < Ctor.minE) {

          // Zero.
          x.e = 0;
          x.d = [0];
          // Ctor.underflow = true;
        } // else Ctor.underflow = false;
      }

      return x;
    }


    function finiteToString(x, isExp, sd) {
      if (!x.isFinite()) return nonFiniteToString(x);
      var k,
        e = x.e,
        str = digitsToString(x.d),
        len = str.length;

      if (isExp) {
        if (sd && (k = sd - len) > 0) {
          str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
        } else if (len > 1) {
          str = str.charAt(0) + '.' + str.slice(1);
        }

        str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
      } else if (e < 0) {
        str = '0.' + getZeroString(-e - 1) + str;
        if (sd && (k = sd - len) > 0) str += getZeroString(k);
      } else if (e >= len) {
        str += getZeroString(e + 1 - len);
        if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
      } else {
        if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
        if (sd && (k = sd - len) > 0) {
          if (e + 1 === len) str += '.';
          str += getZeroString(k);
        }
      }

      return str;
    }


    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
      var w = digits[0];

      // Add the number of digits of the first word of the digits array.
      for ( e *= LOG_BASE; w >= 10; w /= 10) e++;
      return e;
    }


    function getLn10(Ctor, sd, pr) {
      if (sd > LN10_PRECISION) {

        // Reset global state in case the exception is caught.
        external = true;
        if (pr) Ctor.precision = pr;
        throw Error(precisionLimitExceeded);
      }
      return finalise(new Ctor(LN10), sd, 1, true);
    }


    function getPi(Ctor, sd, rm) {
      if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
      return finalise(new Ctor(PI), sd, rm, true);
    }


    function getPrecision(digits) {
      var w = digits.length - 1,
        len = w * LOG_BASE + 1;

      w = digits[w];

      // If non-zero...
      if (w) {

        // Subtract the number of trailing zeros of the last word.
        for (; w % 10 == 0; w /= 10) len--;

        // Add the number of digits of the first word.
        for (w = digits[0]; w >= 10; w /= 10) len++;
      }

      return len;
    }


    function getZeroString(k) {
      var zs = '';
      for (; k--;) zs += '0';
      return zs;
    }


    /*
     * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
     * integer of type number.
     *
     * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
     *
     */
    function intPow(Ctor, x, n, pr) {
      var isTruncated,
        r = new Ctor(1),

        // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);

      external = false;

      for (;;) {
        if (n % 2) {
          r = r.times(x);
          if (truncate(r.d, k)) isTruncated = true;
        }

        n = mathfloor(n / 2);
        if (n === 0) {

          // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
          n = r.d.length - 1;
          if (isTruncated && r.d[n] === 0) ++r.d[n];
          break;
        }

        x = x.times(x);
        truncate(x.d, k);
      }

      external = true;

      return r;
    }


    function isOdd(n) {
      return n.d[n.d.length - 1] & 1;
    }


    /*
     * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
     */
    function maxOrMin(Ctor, args, ltgt) {
      var y,
        x = new Ctor(args[0]),
        i = 0;

      for (; ++i < args.length;) {
        y = new Ctor(args[i]);
        if (!y.s) {
          x = y;
          break;
        } else if (x[ltgt](y)) {
          x = y;
        }
      }

      return x;
    }


    /*
     * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
     * digits.
     *
     * Taylor/Maclaurin series.
     *
     * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
     *
     * Argument reduction:
     *   Repeat x = x / 32, k += 5, until |x| < 0.1
     *   exp(x) = exp(x / 2^k)^(2^k)
     *
     * Previously, the argument was initially reduced by
     * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
     * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
     * found to be slower than just dividing repeatedly by 32 as above.
     *
     * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
     * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
     * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
     *
     *  exp(Infinity)  = Infinity
     *  exp(-Infinity) = 0
     *  exp(NaN)       = NaN
     *  exp(±0)        = 1
     *
     *  exp(x) is non-terminating for any finite, non-zero x.
     *
     *  The result will always be correctly rounded.
     *
     */
    function naturalExponential(x, sd) {
      var denominator, guard, j, pow, sum, t, wpr,
        rep = 0,
        i = 0,
        k = 0,
        Ctor = x.constructor,
        rm = Ctor.rounding,
        pr = Ctor.precision;

      // 0/NaN/Infinity?
      if (!x.d || !x.d[0] || x.e > 17) {

        return new Ctor(x.d
          ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0
          : x.s ? x.s < 0 ? 0 : x : 0 / 0);
      }

      if (sd == null) {
        external = false;
        wpr = pr;
      } else {
        wpr = sd;
      }

      t = new Ctor(0.03125);

      // while abs(x) >= 0.1
      while (x.e > -2) {

        // x = x / 2^5
        x = x.times(t);
        k += 5;
      }

      // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
      // necessary to ensure the first 4 rounding digits are correct.
      guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
      wpr += guard;
      denominator = pow = sum = new Ctor(1);
      Ctor.precision = wpr;

      for (;;) {
        pow = finalise(pow.times(x), wpr, 1);
        denominator = denominator.times(++i);
        t = sum.plus(divide(pow, denominator, wpr, 1));

        if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
          j = k;
          while (j--) sum = finalise(sum.times(sum), wpr, 1);

          // Check to see if the first 4 rounding digits are [49]999.
          // If so, repeat the summation with a higher precision, otherwise
          // e.g. with precision: 18, rounding: 1
          // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
          // `wpr - guard` is the index of first rounding digit.
          if (sd == null) {

            if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
              Ctor.precision = wpr += 10;
              denominator = pow = t = new Ctor(1);
              i = 0;
              rep++;
            } else {
              return finalise(sum, Ctor.precision = pr, rm, external = true);
            }
          } else {
            Ctor.precision = pr;
            return sum;
          }
        }

        sum = t;
      }
    }


    /*
     * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
     * digits.
     *
     *  ln(-n)        = NaN
     *  ln(0)         = -Infinity
     *  ln(-0)        = -Infinity
     *  ln(1)         = 0
     *  ln(Infinity)  = Infinity
     *  ln(-Infinity) = NaN
     *  ln(NaN)       = NaN
     *
     *  ln(n) (n != 1) is non-terminating.
     *
     */
    function naturalLogarithm(y, sd) {
      var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2,
        n = 1,
        guard = 10,
        x = y,
        xd = x.d,
        Ctor = x.constructor,
        rm = Ctor.rounding,
        pr = Ctor.precision;

      // Is x negative or Infinity, NaN, 0 or 1?
      if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
        return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
      }

      if (sd == null) {
        external = false;
        wpr = pr;
      } else {
        wpr = sd;
      }

      Ctor.precision = wpr += guard;
      c = digitsToString(xd);
      c0 = c.charAt(0);

      if (Math.abs(e = x.e) < 1.5e15) {

        // Argument reduction.
        // The series converges faster the closer the argument is to 1, so using
        // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
        // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
        // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
        // later be divided by this number, then separate out the power of 10 using
        // ln(a*10^b) = ln(a) + b*ln(10).

        // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
        //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
        // max n is 6 (gives 0.7 - 1.3)
        while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
          x = x.times(y);
          c = digitsToString(x.d);
          c0 = c.charAt(0);
          n++;
        }

        e = x.e;

        if (c0 > 1) {
          x = new Ctor('0.' + c);
          e++;
        } else {
          x = new Ctor(c0 + '.' + c.slice(1));
        }
      } else {

        // The argument reduction method above may result in overflow if the argument y is a massive
        // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
        // function using ln(x*10^e) = ln(x) + e*ln(10).
        t = getLn10(Ctor, wpr + 2, pr).times(e + '');
        x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
        Ctor.precision = pr;

        return sd == null ? finalise(x, pr, rm, external = true) : x;
      }

      // x1 is x reduced to a value near 1.
      x1 = x;

      // Taylor series.
      // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
      // where x = (y - 1)/(y + 1)    (|x| < 1)
      sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
      x2 = finalise(x.times(x), wpr, 1);
      denominator = 3;

      for (;;) {
        numerator = finalise(numerator.times(x2), wpr, 1);
        t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));

        if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
          sum = sum.times(2);

          // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
          // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
          if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
          sum = divide(sum, new Ctor(n), wpr, 1);

          // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
          // been repeated previously) and the first 4 rounding digits 9999?
          // If so, restart the summation with a higher precision, otherwise
          // e.g. with precision: 12, rounding: 1
          // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
          // `wpr - guard` is the index of first rounding digit.
          if (sd == null) {
            if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
              Ctor.precision = wpr += guard;
              t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
              x2 = finalise(x.times(x), wpr, 1);
              denominator = rep = 1;
            } else {
              return finalise(sum, Ctor.precision = pr, rm, external = true);
            }
          } else {
            Ctor.precision = pr;
            return sum;
          }
        }

        sum = t;
        denominator += 2;
      }
    }


    // ±Infinity, NaN.
    function nonFiniteToString(x) {
      // Unsigned.
      return String(x.s * x.s / 0);
    }


    /*
     * Parse the value of a new Decimal `x` from string `str`.
     */
    function parseDecimal(x, str) {
      var e, i, len;

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

      // Exponential form?
      if ((i = str.search(/e/i)) > 0) {

        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
      } else if (e < 0) {

        // Integer.
        e = str.length;
      }

      // Determine leading zeros.
      for (i = 0; str.charCodeAt(i) === 48; i++);

      // Determine trailing zeros.
      for (len = str.length; str.charCodeAt(len - 1) === 48; --len);
      str = str.slice(i, len);

      if (str) {
        len -= i;
        x.e = e = e - i - 1;
        x.d = [];

        // Transform base

        // e is the base 10 exponent.
        // i is where to slice str to get the first word of the digits array.
        i = (e + 1) % LOG_BASE;
        if (e < 0) i += LOG_BASE;

        if (i < len) {
          if (i) x.d.push(+str.slice(0, i));
          for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
          str = str.slice(i);
          i = LOG_BASE - str.length;
        } else {
          i -= len;
        }

        for (; i--;) str += '0';
        x.d.push(+str);

        if (external) {

          // Overflow?
          if (x.e > x.constructor.maxE) {

            // Infinity.
            x.d = null;
            x.e = NaN;

          // Underflow?
          } else if (x.e < x.constructor.minE) {

            // Zero.
            x.e = 0;
            x.d = [0];
            // x.constructor.underflow = true;
          } // else x.constructor.underflow = false;
        }
      } else {

        // Zero.
        x.e = 0;
        x.d = [0];
      }

      return x;
    }


    /*
     * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
     */
    function parseOther(x, str) {
      var base, Ctor, divisor, i, isFloat, len, p, xd, xe;

      if (str === 'Infinity' || str === 'NaN') {
        if (!+str) x.s = NaN;
        x.e = NaN;
        x.d = null;
        return x;
      }

      if (isHex.test(str))  {
        base = 16;
        str = str.toLowerCase();
      } else if (isBinary.test(str))  {
        base = 2;
      } else if (isOctal.test(str))  {
        base = 8;
      } else {
        throw Error(invalidArgument + str);
      }

      // Is there a binary exponent part?
      i = str.search(/p/i);

      if (i > 0) {
        p = +str.slice(i + 1);
        str = str.substring(2, i);
      } else {
        str = str.slice(2);
      }

      // Convert `str` as an integer then divide the result by `base` raised to a power such that the
      // fraction part will be restored.
      i = str.indexOf('.');
      isFloat = i >= 0;
      Ctor = x.constructor;

      if (isFloat) {
        str = str.replace('.', '');
        len = str.length;
        i = len - i;

        // log[10](16) = 1.2041... , log[10](88) = 1.9444....
        divisor = intPow(Ctor, new Ctor(base), i, i * 2);
      }

      xd = convertBase(str, base, BASE);
      xe = xd.length - 1;

      // Remove trailing zeros.
      for (i = xe; xd[i] === 0; --i) xd.pop();
      if (i < 0) return new Ctor(x.s * 0);
      x.e = getBase10Exponent(xd, xe);
      x.d = xd;
      external = false;

      // At what precision to perform the division to ensure exact conversion?
      // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
      // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
      // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
      // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
      // Therefore using 4 * the number of digits of str will always be enough.
      if (isFloat) x = divide(x, divisor, len * 4);

      // Multiply by the binary exponent part if present.
      if (p) x = x.times(Math.abs(p) < 54 ? Math.pow(2, p) : Decimal.pow(2, p));
      external = true;

      return x;
    }


    /*
     * sin(x) = x - x^3/3! + x^5/5! - ...
     * |x| < pi/2
     *
     */
    function sine(Ctor, x) {
      var k,
        len = x.d.length;

      if (len < 3) return taylorSeries(Ctor, 2, x, x);

      // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
      // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
      // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))

      // Estimate the optimum number of times to use the argument reduction.
      k = 1.4 * Math.sqrt(len);
      k = k > 16 ? 16 : k | 0;

      // Max k before Math.pow precision loss is 22
      x = x.times(Math.pow(5, -k));
      x = taylorSeries(Ctor, 2, x, x);

      // Reverse argument reduction
      var sin2_x,
        d5 = new Ctor(5),
        d16 = new Ctor(16),
        d20 = new Ctor(20);
      for (; k--;) {
        sin2_x = x.times(x);
        x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
      }

      return x;
    }


    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
      var j, t, u, x2,
        pr = Ctor.precision,
        k = Math.ceil(pr / LOG_BASE);

      external = false;
      x2 = x.times(x);
      u = new Ctor(y);

      for (;;) {
        t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
        u = isHyperbolic ? y.plus(t) : y.minus(t);
        y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
        t = u.plus(y);

        if (t.d[k] !== void 0) {
          for (j = k; t.d[j] === u.d[j] && j--;);
          if (j == -1) break;
        }

        j = u;
        u = y;
        y = t;
        t = j;
      }

      external = true;
      t.d.length = k + 1;

      return t;
    }


    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
      var t,
        isNeg = x.s < 0,
        pi = getPi(Ctor, Ctor.precision, 1),
        halfPi = pi.times(0.5);

      x = x.abs();

      if (x.lte(halfPi)) {
        quadrant = isNeg ? 4 : 1;
        return x;
      }

      t = x.divToInt(pi);

      if (t.isZero()) {
        quadrant = isNeg ? 3 : 2;
      } else {
        x = x.minus(t.times(pi));

        // 0 <= x < pi
        if (x.lte(halfPi)) {
          quadrant = isOdd(t) ? (isNeg ? 2 : 3) : (isNeg ? 4 : 1);
          return x;
        }

        quadrant = isOdd(t) ? (isNeg ? 1 : 4) : (isNeg ? 3 : 2);
      }

      return x.minus(pi).abs();
    }


    /*
     * Return the value of Decimal `x` as a string in base `baseOut`.
     *
     * If the optional `sd` argument is present include a binary exponent suffix.
     */
    function toStringBinary(x, baseOut, sd, rm) {
      var base, e, i, k, len, roundUp, str, xd, y,
        Ctor = x.constructor,
        isExp = sd !== void 0;

      if (isExp) {
        checkInt32(sd, 1, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
      } else {
        sd = Ctor.precision;
        rm = Ctor.rounding;
      }

      if (!x.isFinite()) {
        str = nonFiniteToString(x);
      } else {
        str = finiteToString(x);
        i = str.indexOf('.');

        // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
        // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
        // minBinaryExponent = floor(decimalExponent * log[2](10))
        // log[2](10) = 3.321928094887362347870319429489390175864

        if (isExp) {
          base = 2;
          if (baseOut == 16) {
            sd = sd * 4 - 3;
          } else if (baseOut == 8) {
            sd = sd * 3 - 2;
          }
        } else {
          base = baseOut;
        }

        // Convert the number as an integer then divide the result by its base raised to a power such
        // that the fraction part will be restored.

        // Non-integer.
        if (i >= 0) {
          str = str.replace('.', '');
          y = new Ctor(1);
          y.e = str.length - i;
          y.d = convertBase(finiteToString(y), 10, base);
          y.e = y.d.length;
        }

        xd = convertBase(str, 10, base);
        e = len = xd.length;

        // Remove trailing zeros.
        for (; xd[--len] == 0;) xd.pop();

        if (!xd[0]) {
          str = isExp ? '0p+0' : '0';
        } else {
          if (i < 0) {
            e--;
          } else {
            x = new Ctor(x);
            x.d = xd;
            x.e = e;
            x = divide(x, y, sd, rm, 0, base);
            xd = x.d;
            e = x.e;
            roundUp = inexact;
          }

          // The rounding digit, i.e. the digit after the digit that may be rounded up.
          i = xd[sd];
          k = base / 2;
          roundUp = roundUp || xd[sd + 1] !== void 0;

          roundUp = rm < 4
            ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2))
            : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 ||
              rm === (x.s < 0 ? 8 : 7));

          xd.length = sd;

          if (roundUp) {

            // Rounding up may mean the previous digit has to be rounded up and so on.
            for (; ++xd[--sd] > base - 1;) {
              xd[sd] = 0;
              if (!sd) {
                ++e;
                xd.unshift(1);
              }
            }
          }

          // Determine trailing zeros.
          for (len = xd.length; !xd[len - 1]; --len);

          // E.g. [4, 11, 15] becomes 4bf.
          for (i = 0, str = ''; i < len; i++) str += NUMERALS.charAt(xd[i]);

          // Add binary exponent suffix?
          if (isExp) {
            if (len > 1) {
              if (baseOut == 16 || baseOut == 8) {
                i = baseOut == 16 ? 4 : 3;
                for (--len; len % i; len++) str += '0';
                xd = convertBase(str, base, baseOut);
                for (len = xd.length; !xd[len - 1]; --len);

                // xd[0] will always be be 1
                for (i = 1, str = '1.'; i < len; i++) str += NUMERALS.charAt(xd[i]);
              } else {
                str = str.charAt(0) + '.' + str.slice(1);
              }
            }

            str =  str + (e < 0 ? 'p' : 'p+') + e;
          } else if (e < 0) {
            for (; ++e;) str = '0' + str;
            str = '0.' + str;
          } else {
            if (++e > len) for (e -= len; e-- ;) str += '0';
            else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
          }
        }

        str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
      }

      return x.s < 0 ? '-' + str : str;
    }


    // Does not strip trailing zeros.
    function truncate(arr, len) {
      if (arr.length > len) {
        arr.length = len;
        return true;
      }
    }


    // Decimal methods


    /*
     *  abs
     *  acos
     *  acosh
     *  add
     *  asin
     *  asinh
     *  atan
     *  atanh
     *  atan2
     *  cbrt
     *  ceil
     *  clone
     *  config
     *  cos
     *  cosh
     *  div
     *  exp
     *  floor
     *  hypot
     *  ln
     *  log
     *  log2
     *  log10
     *  max
     *  min
     *  mod
     *  mul
     *  pow
     *  random
     *  round
     *  set
     *  sign
     *  sin
     *  sinh
     *  sqrt
     *  sub
     *  tan
     *  tanh
     *  trunc
     */


    /*
     * Return a new Decimal whose value is the absolute value of `x`.
     *
     * x {number|string|Decimal}
     *
     */
    function abs(x) {
      return new this(x).abs();
    }


    /*
     * Return a new Decimal whose value is the arccosine in radians of `x`.
     *
     * x {number|string|Decimal}
     *
     */
    function acos(x) {
      return new this(x).acos();
    }


    /*
     * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
     * `precision` significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function acosh(x) {
      return new this(x).acosh();
    }


    /*
     * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     * y {number|string|Decimal}
     *
     */
    function add(x, y) {
      return new this(x).plus(y);
    }


    /*
     * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function asin(x) {
      return new this(x).asin();
    }


    /*
     * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
     * `precision` significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function asinh(x) {
      return new this(x).asinh();
    }


    /*
     * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function atan(x) {
      return new this(x).atan();
    }


    /*
     * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
     * `precision` significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function atanh(x) {
      return new this(x).atanh();
    }


    /*
     * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
     * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
     *
     * Domain: [-Infinity, Infinity]
     * Range: [-pi, pi]
     *
     * y {number|string|Decimal} The y-coordinate.
     * x {number|string|Decimal} The x-coordinate.
     *
     * atan2(±0, -0)               = ±pi
     * atan2(±0, +0)               = ±0
     * atan2(±0, -x)               = ±pi for x > 0
     * atan2(±0, x)                = ±0 for x > 0
     * atan2(-y, ±0)               = -pi/2 for y > 0
     * atan2(y, ±0)                = pi/2 for y > 0
     * atan2(±y, -Infinity)        = ±pi for finite y > 0
     * atan2(±y, +Infinity)        = ±0 for finite y > 0
     * atan2(±Infinity, x)         = ±pi/2 for finite x
     * atan2(±Infinity, -Infinity) = ±3*pi/4
     * atan2(±Infinity, +Infinity) = ±pi/4
     * atan2(NaN, x) = NaN
     * atan2(y, NaN) = NaN
     *
     */
    function atan2(y, x) {
      y = new this(y);
      x = new this(x);
      var r,
        pr = this.precision,
        rm = this.rounding,
        wpr = pr + 4;

      // Either NaN
      if (!y.s || !x.s) {
        r = new this(NaN);

      // Both ±Infinity
      } else if (!y.d && !x.d) {
        r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
        r.s = y.s;

      // x is ±Infinity or y is ±0
      } else if (!x.d || y.isZero()) {
        r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
        r.s = y.s;

      // y is ±Infinity or x is ±0
      } else if (!y.d || x.isZero()) {
        r = getPi(this, wpr, 1).times(0.5);
        r.s = y.s;

      // Both non-zero and finite
      } else if (x.s < 0) {
        this.precision = wpr;
        this.rounding = 1;
        r = this.atan(divide(y, x, wpr, 1));
        x = getPi(this, wpr, 1);
        this.precision = pr;
        this.rounding = rm;
        r = y.s < 0 ? r.minus(x) : r.plus(x);
      } else {
        r = this.atan(divide(y, x, wpr, 1));
      }

      return r;
    }


    /*
     * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function cbrt(x) {
      return new this(x).cbrt();
    }


    /*
     * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
     *
     * x {number|string|Decimal}
     *
     */
    function ceil(x) {
      return finalise(x = new this(x), x.e + 1, 2);
    }


    /*
     * Configure global settings for a Decimal constructor.
     *
     * `obj` is an object with one or more of the following properties,
     *
     *   precision  {number}
     *   rounding   {number}
     *   toExpNeg   {number}
     *   toExpPos   {number}
     *   maxE       {number}
     *   minE       {number}
     *   modulo     {number}
     *   crypto     {boolean|number}
     *   defaults   {true}
     *
     * E.g. Decimal.config({ precision: 20, rounding: 4 })
     *
     */
    function config(obj) {
      if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
      var i, p, v,
        useDefaults = obj.defaults === true,
        ps = [
          'precision', 1, MAX_DIGITS,
          'rounding', 0, 8,
          'toExpNeg', -EXP_LIMIT, 0,
          'toExpPos', 0, EXP_LIMIT,
          'maxE', 0, EXP_LIMIT,
          'minE', -EXP_LIMIT, 0,
          'modulo', 0, 9
        ];

      for (i = 0; i < ps.length; i += 3) {
        if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
          if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
          else throw Error(invalidArgument + p + ': ' + v);
        }
      }

      if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
      if ((v = obj[p]) !== void 0) {
        if (v === true || v === false || v === 0 || v === 1) {
          if (v) {
            if (typeof crypto != 'undefined' && crypto &&
              (crypto.getRandomValues || crypto.randomBytes)) {
              this[p] = true;
            } else {
              throw Error(cryptoUnavailable);
            }
          } else {
            this[p] = false;
          }
        } else {
          throw Error(invalidArgument + p + ': ' + v);
        }
      }

      return this;
    }


    /*
     * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function cos(x) {
      return new this(x).cos();
    }


    /*
     * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function cosh(x) {
      return new this(x).cosh();
    }


    /*
     * Create and return a Decimal constructor with the same configuration properties as this Decimal
     * constructor.
     *
     */
    function clone(obj) {
      var i, p, ps;

      /*
       * The Decimal constructor and exported function.
       * Return a new Decimal instance.
       *
       * v {number|string|Decimal} A numeric value.
       *
       */
      function Decimal(v) {
        var e, i, t,
          x = this;

        // Decimal called without new.
        if (!(x instanceof Decimal)) return new Decimal(v);

        // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
        // which points to Object.
        x.constructor = Decimal;

        // Duplicate.
        if (v instanceof Decimal) {
          x.s = v.s;
          x.e = v.e;
          x.d = (v = v.d) ? v.slice() : v;
          return;
        }

        t = typeof v;

        if (t === 'number') {
          if (v === 0) {
            x.s = 1 / v < 0 ? -1 : 1;
            x.e = 0;
            x.d = [0];
            return;
          }

          if (v < 0) {
            v = -v;
            x.s = -1;
          } else {
            x.s = 1;
          }

          // Fast path for small integers.
          if (v === ~~v && v < 1e7) {
            for (e = 0, i = v; i >= 10; i /= 10) e++;
            x.e = e;
            x.d = [v];
            return;

          // Infinity, NaN.
          } else if (v * 0 !== 0) {
            if (!v) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return;
          }

          return parseDecimal(x, v.toString());

        } else if (t !== 'string') {
          throw Error(invalidArgument + v);
        }

        // Minus sign?
        if (v.charCodeAt(0) === 45) {
          v = v.slice(1);
          x.s = -1;
        } else {
          x.s = 1;
        }

        return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
      }

      Decimal.prototype = P;

      Decimal.ROUND_UP = 0;
      Decimal.ROUND_DOWN = 1;
      Decimal.ROUND_CEIL = 2;
      Decimal.ROUND_FLOOR = 3;
      Decimal.ROUND_HALF_UP = 4;
      Decimal.ROUND_HALF_DOWN = 5;
      Decimal.ROUND_HALF_EVEN = 6;
      Decimal.ROUND_HALF_CEIL = 7;
      Decimal.ROUND_HALF_FLOOR = 8;
      Decimal.EUCLID = 9;

      Decimal.config = Decimal.set = config;
      Decimal.clone = clone;
      Decimal.isDecimal = isDecimalInstance;

      Decimal.abs = abs;
      Decimal.acos = acos;
      Decimal.acosh = acosh;        // ES6
      Decimal.add = add;
      Decimal.asin = asin;
      Decimal.asinh = asinh;        // ES6
      Decimal.atan = atan;
      Decimal.atanh = atanh;        // ES6
      Decimal.atan2 = atan2;
      Decimal.cbrt = cbrt;          // ES6
      Decimal.ceil = ceil;
      Decimal.cos = cos;
      Decimal.cosh = cosh;          // ES6
      Decimal.div = div;
      Decimal.exp = exp;
      Decimal.floor = floor;
      Decimal.hypot = hypot;        // ES6
      Decimal.ln = ln;
      Decimal.log = log;
      Decimal.log10 = log10;        // ES6
      Decimal.log2 = log2;          // ES6
      Decimal.max = max;
      Decimal.min = min;
      Decimal.mod = mod;
      Decimal.mul = mul;
      Decimal.pow = pow;
      Decimal.random = random;
      Decimal.round = round;
      Decimal.sign = sign;          // ES6
      Decimal.sin = sin;
      Decimal.sinh = sinh;          // ES6
      Decimal.sqrt = sqrt;
      Decimal.sub = sub;
      Decimal.tan = tan;
      Decimal.tanh = tanh;          // ES6
      Decimal.trunc = trunc;        // ES6

      if (obj === void 0) obj = {};
      if (obj) {
        if (obj.defaults !== true) {
          ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'maxE', 'minE', 'modulo', 'crypto'];
          for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
      }

      Decimal.config(obj);

      return Decimal;
    }


    /*
     * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     * y {number|string|Decimal}
     *
     */
    function div(x, y) {
      return new this(x).div(y);
    }


    /*
     * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} The power to which to raise the base of the natural log.
     *
     */
    function exp(x) {
      return new this(x).exp();
    }


    /*
     * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
     *
     * x {number|string|Decimal}
     *
     */
    function floor(x) {
      return finalise(x = new this(x), x.e + 1, 3);
    }


    /*
     * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
     * rounded to `precision` significant digits using rounding mode `rounding`.
     *
     * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
     *
     */
    function hypot() {
      var i, n,
        t = new this(0);

      external = false;

      for (i = 0; i < arguments.length;) {
        n = new this(arguments[i++]);
        if (!n.d) {
          if (n.s) {
            external = true;
            return new this(1 / 0);
          }
          t = n;
        } else if (t.d) {
          t = t.plus(n.times(n));
        }
      }

      external = true;

      return t.sqrt();
    }


    /*
     * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
     * otherwise return false.
     *
     */
    function isDecimalInstance(obj) {
      return obj instanceof Decimal || obj && obj.name === '[object Decimal]' || false;
    }


    /*
     * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function ln(x) {
      return new this(x).ln();
    }


    /*
     * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
     * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
     *
     * log[y](x)
     *
     * x {number|string|Decimal} The argument of the logarithm.
     * y {number|string|Decimal} The base of the logarithm.
     *
     */
    function log(x, y) {
      return new this(x).log(y);
    }


    /*
     * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function log2(x) {
      return new this(x).log(2);
    }


    /*
     * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function log10(x) {
      return new this(x).log(10);
    }


    /*
     * Return a new Decimal whose value is the maximum of the arguments.
     *
     * arguments {number|string|Decimal}
     *
     */
    function max() {
      return maxOrMin(this, arguments, 'lt');
    }


    /*
     * Return a new Decimal whose value is the minimum of the arguments.
     *
     * arguments {number|string|Decimal}
     *
     */
    function min() {
      return maxOrMin(this, arguments, 'gt');
    }


    /*
     * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
     * using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     * y {number|string|Decimal}
     *
     */
    function mod(x, y) {
      return new this(x).mod(y);
    }


    /*
     * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     * y {number|string|Decimal}
     *
     */
    function mul(x, y) {
      return new this(x).mul(y);
    }


    /*
     * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} The base.
     * y {number|string|Decimal} The exponent.
     *
     */
    function pow(x, y) {
      return new this(x).pow(y);
    }


    /*
     * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
     * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
     * are produced).
     *
     * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
     *
     */
    function random(sd) {
      var d, e, k, n,
        i = 0,
        r = new this(1),
        rd = [];

      if (sd === void 0) sd = this.precision;
      else checkInt32(sd, 1, MAX_DIGITS);

      k = Math.ceil(sd / LOG_BASE);

      if (!this.crypto) {
        for (; i < k;) rd[i++] = Math.random() * 1e7 | 0;

      // Browsers supporting crypto.getRandomValues.
      } else if (crypto.getRandomValues) {
        d = crypto.getRandomValues(new Uint32Array(k));

        for (; i < k;) {
          n = d[i];

          // 0 <= n < 4294967296
          // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
          if (n >= 4.29e9) {
            d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
          } else {

            // 0 <= n <= 4289999999
            // 0 <= (n % 1e7) <= 9999999
            rd[i++] = n % 1e7;
          }
        }

      // Node.js supporting crypto.randomBytes.
      } else if (crypto.randomBytes) {

        // buffer
        d = crypto.randomBytes(k *= 4);

        for (; i < k;) {

          // 0 <= n < 2147483648
          n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);

          // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
          if (n >= 2.14e9) {
            crypto.randomBytes(4).copy(d, i);
          } else {

            // 0 <= n <= 2139999999
            // 0 <= (n % 1e7) <= 9999999
            rd.push(n % 1e7);
            i += 4;
          }
        }

        i = k / 4;
      } else {
        throw Error(cryptoUnavailable);
      }

      k = rd[--i];
      sd %= LOG_BASE;

      // Convert trailing digits to zeros according to sd.
      if (k && sd) {
        n = mathpow(10, LOG_BASE - sd);
        rd[i] = (k / n | 0) * n;
      }

      // Remove trailing words which are zero.
      for (; rd[i] === 0; i--) rd.pop();

      // Zero?
      if (i < 0) {
        e = 0;
        rd = [0];
      } else {
        e = -1;

        // Remove leading words which are zero and adjust exponent accordingly.
        for (; rd[0] === 0; e -= LOG_BASE) rd.shift();

        // Count the digits of the first word of rd to determine leading zeros.
        for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;

        // Adjust the exponent for leading zeros of the first word of rd.
        if (k < LOG_BASE) e -= LOG_BASE - k;
      }

      r.e = e;
      r.d = rd;

      return r;
    }


    /*
     * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
     *
     * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
     *
     * x {number|string|Decimal}
     *
     */
    function round(x) {
      return finalise(x = new this(x), x.e + 1, this.rounding);
    }


    /*
     * Return
     *   1    if x > 0,
     *  -1    if x < 0,
     *   0    if x is 0,
     *  -0    if x is -0,
     *   NaN  otherwise
     *
     */
    function sign(x) {
      x = new this(x);
      return x.d ? (x.d[0] ? x.s : 0 * x.s) : x.s || NaN;
    }


    /*
     * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
     * using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function sin(x) {
      return new this(x).sin();
    }


    /*
     * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function sinh(x) {
      return new this(x).sinh();
    }


    /*
     * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     *
     */
    function sqrt(x) {
      return new this(x).sqrt();
    }


    /*
     * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
     * using rounding mode `rounding`.
     *
     * x {number|string|Decimal}
     * y {number|string|Decimal}
     *
     */
    function sub(x, y) {
      return new this(x).sub(y);
    }


    /*
     * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
     * digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function tan(x) {
      return new this(x).tan();
    }


    /*
     * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
     * significant digits using rounding mode `rounding`.
     *
     * x {number|string|Decimal} A value in radians.
     *
     */
    function tanh(x) {
      return new this(x).tanh();
    }


    /*
     * Return a new Decimal whose value is `x` truncated to an integer.
     *
     * x {number|string|Decimal}
     *
     */
    function trunc(x) {
      return finalise(x = new this(x), x.e + 1, 1);
    }


    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);

    Decimal['default'] = Decimal.Decimal = Decimal;

    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);


    // Export.


    // AMD.
    if (typeof undefined == 'function' && undefined.amd) {
      undefined(function () {
        return Decimal;
      });

    // Node and other environments that support module.exports.
    } else if ('object' != 'undefined' && module.exports) {
      module.exports = Decimal;

    // Browser.
    } else {
      if (!globalScope) {
        globalScope = typeof self != 'undefined' && self && self.self == self
          ? self : Function('return this')();
      }

      noConflict = globalScope.Decimal;
      Decimal.noConflict = function () {
        globalScope.Decimal = noConflict;
        return Decimal;
      };

      globalScope.Decimal = Decimal;
    }
  })(commonjsGlobal);
  });

  // make sure to pick the es5 version

  function factory$2 (type, config, load, typed, math) {
    var BigNumber = decimal.clone({precision: config.precision});

    /**
     * Attach type information
     */
    BigNumber.prototype.type = 'BigNumber';
    BigNumber.prototype.isBigNumber = true;

    /**
     * Get a JSON representation of a BigNumber containing
     * type information
     * @returns {Object} Returns a JSON object structured as:
     *                   `{"mathjs": "BigNumber", "value": "0.2"}`
     */
    BigNumber.prototype.toJSON = function () {
      return {
        mathjs: 'BigNumber',
        value: this.toString()
      };
    };

    /**
     * Instantiate a BigNumber from a JSON object
     * @param {Object} json  a JSON object structured as:
     *                       `{"mathjs": "BigNumber", "value": "0.2"}`
     * @return {BigNumber}
     */
    BigNumber.fromJSON = function (json) {
      return new BigNumber(json.value);
    };

    // listen for changed in the configuration, automatically apply changed precision
    math.on('config', function (curr, prev) {
      if (curr.precision !== prev.precision) {
        BigNumber.config({ precision: curr.precision });
      }
    });

    return BigNumber;
  }

  var name$2 = 'BigNumber';
  var path = 'type';
  var factory_1$2 = factory$2;
  var math$2 = true; // request access to the math namespace

  var BigNumber = {
  	name: name$2,
  	path: path,
  	factory: factory_1$2,
  	math: math$2
  };

  /**
   * Execute the callback function element wise for each element in array and any
   * nested array
   * Returns an array with the results
   * @param {Array | Matrix} array
   * @param {Function} callback   The callback is called with two parameters:
   *                              value1 and value2, which contain the current
   *                              element of both arrays.
   * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
   *
   * @return {Array | Matrix} res
   */
  var deepMap = function deepMap(array, callback, skipZeros) {
    if (array && (typeof array.map === 'function')) {
      // TODO: replace array.map with a for loop to improve performance
      return array.map(function (x) {
        return deepMap(x, callback, skipZeros);
      });
    }
    else {
      return callback(array);
    }
  };

  function factory$3 (type, config, load, typed) {
    /**
     * Create a BigNumber, which can store numbers with arbitrary precision.
     * When a matrix is provided, all elements will be converted to BigNumber.
     *
     * Syntax:
     *
     *    math.bignumber(x)
     *
     * Examples:
     *
     *    0.1 + 0.2;                                  // returns number 0.30000000000000004
     *    math.bignumber(0.1) + math.bignumber(0.2);  // returns BigNumber 0.3
     *
     *
     *    7.2e500;                                    // returns number Infinity
     *    math.bignumber('7.2e500');                  // returns BigNumber 7.2e500
     *
     * See also:
     *
     *    boolean, complex, index, matrix, string, unit
     *
     * @param {number | string | Fraction | BigNumber | Array | Matrix | boolean | null} [value]  Value for the big number,
     *                                                    0 by default.
     * @returns {BigNumber} The created bignumber
     */
    var bignumber = typed('bignumber', {
      '': function () {
        return new type.BigNumber(0);
      },

      'number': function (x) {
        // convert to string to prevent errors in case of >15 digits
        return new type.BigNumber(x + '');
      },

      'string': function (x) {
        return new type.BigNumber(x);
      },

      'BigNumber': function (x) {
        // we assume a BigNumber is immutable
        return x;
      },

      'Fraction': function (x) {
        return new type.BigNumber(x.n).div(x.d);
      },

      'null': function (x) {
        return new type.BigNumber(0);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, bignumber);
      }
    });

    bignumber.toTex = {
      0: '0',
      1: '\\left(${args[0]}\\right)'
    };

    return bignumber;
  }

  var name$3 = 'bignumber';
  var factory_1$3 = factory$3;

  var bignumber = {
  	name: name$3,
  	factory: factory_1$3
  };

  var bignumber$1 = [
    // type
    BigNumber,

    // construction function
    bignumber
  ];

  function factory$4 (type, config, load, typed) {
    /**
     * Create a boolean or convert a string or number to a boolean.
     * In case of a number, `true` is returned for non-zero numbers, and `false` in
     * case of zero.
     * Strings can be `'true'` or `'false'`, or can contain a number.
     * When value is a matrix, all elements will be converted to boolean.
     *
     * Syntax:
     *
     *    math.boolean(x)
     *
     * Examples:
     *
     *    math.boolean(0);     // returns false
     *    math.boolean(1);     // returns true
     *    math.boolean(-3);     // returns true
     *    math.boolean('true');     // returns true
     *    math.boolean('false');     // returns false
     *    math.boolean([1, 0, 1, 1]);     // returns [true, false, true, true]
     *
     * See also:
     *
     *    bignumber, complex, index, matrix, string, unit
     *
     * @param {string | number | boolean | Array | Matrix | null} value  A value of any type
     * @return {boolean | Array | Matrix} The boolean value
     */
    var bool = typed('bool', {
      '': function () {
        return false;
      },

      'boolean': function (x) {
        return x;
      },

      'number': function (x) {
        return !!x;
      },

      'null': function (x) {
        return false;
      },

      'BigNumber': function (x) {
        return !x.isZero();
      },

      'string': function (x) {
        // try case insensitive
        var lcase = x.toLowerCase();
        if (lcase === 'true') {
          return true;
        }
        else if (lcase === 'false') {
          return false;
        }

        // test whether value is a valid number
        var num = Number(x);
        if (x != '' && !isNaN(num)) {
          return !!num;
        }

        throw new Error('Cannot convert "' + x + '" to a boolean');
      },

      'Array | Matrix': function (x) {
        return deepMap(x, bool);
      }
    });

    return bool;
  }

  var name$4 = 'boolean';
  var factory_1$4 = factory$4;

  var boolean_1 = {
  	name: name$4,
  	factory: factory_1$4
  };

  var formatter = createCommonjsModule(function (module, exports) {



  /**
   * Convert a BigNumber to a formatted string representation.
   *
   * Syntax:
   *
   *    format(value)
   *    format(value, options)
   *    format(value, precision)
   *    format(value, fn)
   *
   * Where:
   *
   *    {number} value   The value to be formatted
   *    {Object} options An object with formatting options. Available options:
   *                     {string} notation
   *                         Number notation. Choose from:
   *                         'fixed'          Always use regular number notation.
   *                                          For example '123.40' and '14000000'
   *                         'exponential'    Always use exponential notation.
   *                                          For example '1.234e+2' and '1.4e+7'
   *                         'auto' (default) Regular number notation for numbers
   *                                          having an absolute value between
   *                                          `lower` and `upper` bounds, and uses
   *                                          exponential notation elsewhere.
   *                                          Lower bound is included, upper bound
   *                                          is excluded.
   *                                          For example '123.4' and '1.4e7'.
   *                     {number} precision   A number between 0 and 16 to round
   *                                          the digits of the number.
   *                                          In case of notations 'exponential' and
   *                                          'auto', `precision` defines the total
   *                                          number of significant digits returned.
   *                                          In case of notation 'fixed',
   *                                          `precision` defines the number of
   *                                          significant digits after the decimal 
   *                                          point. 
   *                                          `precision` is undefined by default.
   *                     {number} lowerExp    Exponent determining the lower boundary
   *                                          for formatting a value with an exponent
   *                                          when `notation='auto`. 
   *                                          Default value is `-3`.
   *                     {number} upperExp    Exponent determining the upper boundary
   *                                          for formatting a value with an exponent
   *                                          when `notation='auto`. 
   *                                          Default value is `5`.
   *    {Function} fn    A custom formatting function. Can be used to override the
   *                     built-in notations. Function `fn` is called with `value` as
   *                     parameter and must return a string. Is useful for example to
   *                     format all values inside a matrix in a particular way.
   *
   * Examples:
   *
   *    format(6.4);                                        // '6.4'
   *    format(1240000);                                    // '1.24e6'
   *    format(1/3);                                        // '0.3333333333333333'
   *    format(1/3, 3);                                     // '0.333'
   *    format(21385, 2);                                   // '21000'
   *    format(12e8, {notation: 'fixed'});                  // returns '1200000000'
   *    format(2.3,    {notation: 'fixed', precision: 4});  // returns '2.3000'
   *    format(52.8,   {notation: 'exponential'});          // returns '5.28e+1'
   *    format(12400,  {notation: 'engineering'});          // returns '12.400e+3'
   *
   * @param {BigNumber} value
   * @param {Object | Function | number} [options]
   * @return {string} str The formatted value
   */
  exports.format = function (value, options) {
    if (typeof options === 'function') {
      // handle format(value, fn)
      return options(value);
    }

    // handle special cases
    if (!value.isFinite()) {
      return value.isNaN() ? 'NaN' : (value.gt(0) ? 'Infinity' : '-Infinity');
    }

    // default values for options
    var notation = 'auto';
    var precision = undefined;

    if (options !== undefined) {
      // determine notation from options
      if (options.notation) {
        notation = options.notation;
      }

      // determine precision from options
      if (typeof options === 'number') {
        precision = options;
      }
      else if (options.precision) {
        precision = options.precision;
      }
    }

    // handle the various notations
    switch (notation) {
      case 'fixed':
        return exports.toFixed(value, precision);

      case 'exponential':
        return exports.toExponential(value, precision);

      case 'auto':
        // TODO: clean up some day. Deprecated since: 2018-01-24
        // @deprecated upper and lower are replaced with upperExp and lowerExp since v4.0.0
        if (options && options.exponential && (options.exponential.lower !== undefined || options.exponential.upper !== undefined)) {
          var fixedOptions = object.map(options, function (x) { return x; });
          fixedOptions.exponential = undefined;
          if (options.exponential.lower !== undefined) {
            fixedOptions.lowerExp = Math.round(Math.log(options.exponential.lower) / Math.LN10);
          }
          if (options.exponential.upper !== undefined) {
            fixedOptions.upperExp = Math.round(Math.log(options.exponential.upper) / Math.LN10);
          }

          console.warn('Deprecation warning: Formatting options exponential.lower and exponential.upper ' + 
              '(minimum and maximum value) ' +
              'are replaced with exponential.lowerExp and exponential.upperExp ' + 
              '(minimum and maximum exponent) since version 4.0.0. ' + 
              'Replace ' + JSON.stringify(options) + ' with ' + JSON.stringify(fixedOptions));

          return exports.format(value, fixedOptions);
        }

        // determine lower and upper bound for exponential notation.
        // TODO: implement support for upper and lower to be BigNumbers themselves
        var lowerExp = (options && options.lowerExp !== undefined) ? options.lowerExp : -3;
        var upperExp = (options && options.upperExp !== undefined) ? options.upperExp : 5;

        // handle special case zero
        if (value.isZero()) return '0';

        // determine whether or not to output exponential notation
        var str;
        var exp = value.logarithm();
        if (exp.gte(lowerExp) && exp.lt(upperExp)) {
          // normal number notation
          str = value.toSignificantDigits(precision).toFixed();
        }
        else {
          // exponential notation
          str = exports.toExponential(value, precision);
        }

        // remove trailing zeros after the decimal point
        return str.replace(/((\.\d*?)(0+))($|e)/, function () {
          var digits = arguments[2];
          var e = arguments[4];
          return (digits !== '.') ? digits + e : e;
        });

      default:
        throw new Error('Unknown notation "' + notation + '". ' +
            'Choose "auto", "exponential", or "fixed".');
    }
  };

  /**
   * Format a number in exponential notation. Like '1.23e+5', '2.3e+0', '3.500e-3'
   * @param {BigNumber} value
   * @param {number} [precision]  Number of digits in formatted output.
   *                              If not provided, the maximum available digits
   *                              is used.
   * @returns {string} str
   */
  exports.toExponential = function (value, precision) {
    if (precision !== undefined) {
      return value.toExponential(precision - 1); // Note the offset of one
    }
    else {
      return value.toExponential();
    }
  };

  /**
   * Format a number with fixed notation.
   * @param {BigNumber} value
   * @param {number} [precision=undefined] Optional number of decimals after the
   *                                       decimal point. Undefined by default.
   */
  exports.toFixed = function (value, precision) {
    return value.toFixed(precision);
  };
  });
  var formatter_1 = formatter.format;
  var formatter_2 = formatter.toExponential;
  var formatter_3 = formatter.toFixed;

  var string = createCommonjsModule(function (module, exports) {

  var formatNumber = number.format;
  var formatBigNumber = formatter.format;


  /**
   * Test whether value is a string
   * @param {*} value
   * @return {boolean} isString
   */
  exports.isString = function(value) {
    return typeof value === 'string';
  };

  /**
   * Check if a text ends with a certain string.
   * @param {string} text
   * @param {string} search
   */
  exports.endsWith = function(text, search) {
    var start = text.length - search.length;
    var end = text.length;
    return (text.substring(start, end) === search);
  };

  /**
   * Format a value of any type into a string.
   *
   * Usage:
   *     math.format(value)
   *     math.format(value, precision)
   *
   * When value is a function:
   *
   * - When the function has a property `syntax`, it returns this
   *   syntax description.
   * - In other cases, a string `'function'` is returned.
   *
   * When `value` is an Object:
   *
   * - When the object contains a property `format` being a function, this
   *   function is invoked as `value.format(options)` and the result is returned.
   * - When the object has its own `toString` method, this method is invoked
   *   and the result is returned.
   * - In other cases the function will loop over all object properties and
   *   return JSON object notation like '{"a": 2, "b": 3}'.
   *
   * Example usage:
   *     math.format(2/7);                // '0.2857142857142857'
   *     math.format(math.pi, 3);         // '3.14'
   *     math.format(new Complex(2, 3));  // '2 + 3i'
   *     math.format('hello');            // '"hello"'
   *
   * @param {*} value             Value to be stringified
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @return {string} str
   */
  exports.format = function(value, options) {
    if (typeof value === 'number') {
      return formatNumber(value, options);
    }

    if (isBigNumber(value)) {
      return formatBigNumber(value, options);
    }

    // note: we use unsafe duck-typing here to check for Fractions, this is
    // ok here since we're only invoking toString or concatenating its values
    if (looksLikeFraction(value)) {
      if (!options || options.fraction !== 'decimal') {
        // output as ratio, like '1/3'
        return (value.s * value.n) + '/' + value.d;
      }
      else {
        // output as decimal, like '0.(3)'
        return value.toString();
      }
    }

    if (Array.isArray(value)) {
      return formatArray(value, options);
    }

    if (exports.isString(value)) {
      return '"' + value + '"';
    }

    if (typeof value === 'function') {
      return value.syntax ? String(value.syntax) : 'function';
    }

    if (value && typeof value === 'object') {
      if (typeof value.format === 'function') {
        return value.format(options);
      }
      else if (value && value.toString() !== {}.toString()) {
        // this object has a non-native toString method, use that one
        return value.toString();
      }
      else {
        var entries = [];

        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            entries.push('"' + key + '": ' + exports.format(value[key], options));
          }
        }

        return '{' + entries.join(', ') + '}';
      }
    }

    return String(value);
  };

  /**
   * Stringify a value into a string enclosed in double quotes.
   * Unescaped double quotes and backslashes inside the value are escaped.
   * @param {*} value
   * @return {string}
   */
  exports.stringify = function (value) {
    var text = String(value);
    var escaped = '';
    var i = 0;
    while (i < text.length) {
      var c = text.charAt(i);

      if (c === '\\') {
        escaped += c;
        i++;

        c = text.charAt(i);
        if (c === '' || '"\\/bfnrtu'.indexOf(c) === -1) {
          escaped += '\\';  // no valid escape character -> escape it
        }
        escaped += c;
      }
      else if (c === '"') {
        escaped += '\\"';
      }
      else {
        escaped += c;
      }
      i++;
    }

    return '"' + escaped + '"';
  };

  /**
   * Escape special HTML characters
   * @param {*} value
   * @return {string}
   */
  exports.escape = function (value) {
    var text = String(value);
    text = text.replace(/&/g, '&amp;')
  			 .replace(/"/g, '&quot;')
  			 .replace(/'/g, '&#39;')
  			 .replace(/</g, '&lt;')
  			 .replace(/>/g, '&gt;');
    
    return text;
  };

  /**
   * Recursively format an n-dimensional matrix
   * Example output: "[[1, 2], [3, 4]]"
   * @param {Array} array
   * @param {Object | number | Function} [options]  Formatting options. See
   *                                                lib/utils/number:format for a
   *                                                description of the available
   *                                                options.
   * @returns {string} str
   */
  function formatArray (array, options) {
    if (Array.isArray(array)) {
      var str = '[';
      var len = array.length;
      for (var i = 0; i < len; i++) {
        if (i != 0) {
          str += ', ';
        }
        str += formatArray(array[i], options);
      }
      str += ']';
      return str;
    }
    else {
      return exports.format(array, options);
    }
  }

  /**
   * Check whether a value looks like a Fraction (unsafe duck-type check)
   * @param {*} value
   * @return {boolean}
   */
  function looksLikeFraction (value) {
    return (value &&
        typeof value === 'object' &&
        typeof value.s === 'number' &&
        typeof value.n === 'number' &&
        typeof value.d === 'number') || false;
  }
  });
  var string_1 = string.isString;
  var string_2 = string.endsWith;
  var string_3 = string.format;
  var string_4 = string.stringify;
  var string_5 = string.escape;

  var format = string.format;
  var lazy$1 = object.lazy;

  function factory$5 (type, config, load, typed, math) {
    /**
     * @constructor Chain
     * Wrap any value in a chain, allowing to perform chained operations on
     * the value.
     *
     * All methods available in the math.js library can be called upon the chain,
     * and then will be evaluated with the value itself as first argument.
     * The chain can be closed by executing chain.done(), which will return
     * the final value.
     *
     * The Chain has a number of special functions:
     * - done()             Finalize the chained operation and return the
     *                      chain's value.
     * - valueOf()          The same as done()
     * - toString()         Returns a string representation of the chain's value.
     *
     * @param {*} [value]
     */
    function Chain (value) {
      if (!(this instanceof Chain)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      if (type.isChain(value)) {
        this.value = value.value;
      }
      else {
        this.value = value;
      }
    }

    /**
     * Attach type information
     */
    Chain.prototype.type = 'Chain';
    Chain.prototype.isChain = true;

    /**
     * Close the chain. Returns the final value.
     * Does the same as method valueOf()
     * @returns {*} value
     */
    Chain.prototype.done = function () {
      return this.value;
    };

    /**
     * Close the chain. Returns the final value.
     * Does the same as method done()
     * @returns {*} value
     */
    Chain.prototype.valueOf = function () {
      return this.value;
    };

    /**
     * Get a string representation of the value in the chain
     * @returns {string}
     */
    Chain.prototype.toString = function () {
      return format(this.value);
    };

    /**
     * Get a JSON representation of the chain
     * @returns {Object}
     */
    Chain.prototype.toJSON = function () {
      return {
        mathjs: 'Chain',
        value: this.value
      };
    };

    /**
     * Instantiate a Chain from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "Chain", value: ...}`,
     *                       where mathjs is optional
     * @returns {Chain}
     */
    Chain.fromJSON = function (json) {
      return new Chain(json.value);
    };

    /**
     * Create a proxy method for the chain
     * @param {string} name
     * @param {Function} fn      The function to be proxied
     *                           If fn is no function, it is silently ignored.
     * @private
     */
    function createProxy(name, fn) {
      if (typeof fn === 'function') {
        Chain.prototype[name] = chainify(fn);
      }
    }

    /**
     * Create a proxy method for the chain
     * @param {string} name
     * @param {function} resolver   The function resolving with the
     *                              function to be proxied
     * @private
     */
    function createLazyProxy(name, resolver) {
      lazy$1(Chain.prototype, name, function outerResolver() {
        var fn = resolver();
        if (typeof fn === 'function') {
          return chainify(fn);
        }

        return undefined; // if not a function, ignore
      });
    }

    /**
     * Make a function chainable
     * @param {function} fn
     * @return {Function} chain function
     * @private
     */
    function chainify (fn) {
      return function () {
        var args = [this.value];  // `this` will be the context of a Chain instance
        for (var i = 0; i < arguments.length; i++) {
          args[i + 1] = arguments[i];
        }

        return new Chain(fn.apply(fn, args));
      }
    }

    /**
     * Create a proxy for a single method, or an object with multiple methods.
     * Example usage:
     *
     *   Chain.createProxy('add', function add (x, y) {...});
     *   Chain.createProxy({
     *     add:      function add (x, y) {...},
     *     subtract: function subtract (x, y) {...}
     *   }
     *
     * @param {string | Object} arg0   A name (string), or an object with
     *                                 functions
     * @param {*} [arg1]               A function, when arg0 is a name
     */
    Chain.createProxy = function (arg0, arg1) {
      if (typeof arg0 === 'string') {
        // createProxy(name, value)
        createProxy(arg0, arg1);
      }
      else {
        // createProxy(values)
        for (var prop in arg0) {
          if (arg0.hasOwnProperty(prop)) {
            createProxy(prop, arg0[prop]);
          }
        }
      }
    };

    // create proxy for everything that is in math.js
    Chain.createProxy(math);

    // register on the import event, automatically add a proxy for every imported function.
    math.on('import', function (name, resolver, path) {
      if (path === undefined) {
        // an imported function (not a data type or something special)
        createLazyProxy(name, resolver);
      }
    });

    return Chain;
  }

  var name$5 = 'Chain';
  var path$1 = 'type';
  var factory_1$5 = factory$5;
  var math$3 = true;  // require providing the math namespace as 5th argument
  var lazy_1$1 = false; // we need to register a listener on the import events, so no lazy loading

  var Chain = {
  	name: name$5,
  	path: path$1,
  	factory: factory_1$5,
  	math: math$3,
  	lazy: lazy_1$1
  };

  function factory$6 (type, config, load, typed) {
    /**
     * Wrap any value in a chain, allowing to perform chained operations on
     * the value.
     *
     * All methods available in the math.js library can be called upon the chain,
     * and then will be evaluated with the value itself as first argument.
     * The chain can be closed by executing `chain.done()`, which returns
     * the final value.
     *
     * The chain has a number of special functions:
     *
     * - `done()`     Finalize the chain and return the chain's value.
     * - `valueOf()`  The same as `done()`
     * - `toString()` Executes `math.format()` onto the chain's value, returning
     *                a string representation of the value.
     *
     * Syntax:
     *
     *    math.chain(value)
     *
     * Examples:
     *
     *     math.chain(3)
     *         .add(4)
     *         .subtract(2)
     *         .done();     // 5
     *
     *     math.chain( [[1, 2], [3, 4]] )
     *         .subset(math.index(0, 0), 8)
     *         .multiply(3)
     *         .done();     // [[24, 6], [9, 12]]
     *
     * @param {*} [value]   A value of any type on which to start a chained operation.
     * @return {math.type.Chain} The created chain
     */
    return typed('chain', {
      '': function() {
        return new type.Chain();
      },

      'any': function(value) {
        return new type.Chain(value);
      }
    });
  }

  var name$6 = 'chain';
  var factory_1$6 = factory$6;

  var chain = {
  	name: name$6,
  	factory: factory_1$6
  };

  var chain$1 = [
    // type
    Chain,

    // construction function
    chain
  ];

  var complex = createCommonjsModule(function (module, exports) {
  /**
   * @license Complex.js v2.0.10 11/02/2016
   *
   * Copyright (c) 2016, Robert Eisele (robert@xarg.org)
   * Dual licensed under the MIT or GPL Version 2 licenses.
   **/

  /**
   *
   * This class allows the manipulation of complex numbers.
   * You can pass a complex number in different formats. Either as object, double, string or two integer parameters.
   *
   * Object form
   * { re: <real>, im: <imaginary> }
   * { arg: <angle>, abs: <radius> }
   * { phi: <angle>, r: <radius> }
   *
   * Array / Vector form
   * [ real, imaginary ]
   *
   * Double form
   * 99.3 - Single double value
   *
   * String form
   * '23.1337' - Simple real number
   * '15+3i' - a simple complex number
   * '3-i' - a simple complex number
   *
   * Example:
   *
   * var c = new Complex('99.3+8i');
   * c.mul({r: 3, i: 9}).div(4.9).sub(3, 2);
   *
   */

  (function(root) {

    var cosh = function(x) {
      return (Math.exp(x) + Math.exp(-x)) * 0.5;
    };

    var sinh = function(x) {
      return (Math.exp(x) - Math.exp(-x)) * 0.5;
    };

    /**
     * Calculates cos(x) - 1 using Taylor series if x is small.
     *
     * @param {number} x
     * @returns {number} cos(x) - 1
     */

    var cosm1 = function(x) {
      var limit = Math.PI/4;
      if (x < -limit || x > limit) {
        return (Math.cos(x) - 1.0);
      }

      var xx = x * x;
      return xx *
        (-0.5 + xx *
          (1/24 + xx *
            (-1/720 + xx *
              (1/40320 + xx *
                (-1/3628800 + xx *
                  (1/4790014600 + xx *
                    (-1/87178291200 + xx *
                      (1/20922789888000)
                    )
                  )
                )
              )
            )
          )
        )
    };

    var hypot = function(x, y) {

      var a = Math.abs(x);
      var b = Math.abs(y);

      if (a < 3000 && b < 3000) {
        return Math.sqrt(a * a + b * b);
      }

      if (a < b) {
        a = b;
        b = x / y;
      } else {
        b = y / x;
      }
      return a * Math.sqrt(1 + b * b);
    };

    var parser_exit = function() {
      throw SyntaxError('Invalid Param');
    };

    /**
     * Calculates log(sqrt(a^2+b^2)) in a way to avoid overflows
     *
     * @param {number} a
     * @param {number} b
     * @returns {number}
     */
    function logHypot(a, b) {

      var _a = Math.abs(a);
      var _b = Math.abs(b);

      if (a === 0) {
        return Math.log(_b);
      }

      if (b === 0) {
        return Math.log(_a);
      }

      if (_a < 3000 && _b < 3000) {
        return Math.log(a * a + b * b) * 0.5;
      }

      /* I got 4 ideas to compute this property without overflow:
       *
       * Testing 1000000 times with random samples for a,b ∈ [1, 1000000000] against a big decimal library to get an error estimate
       *
       * 1. Only eliminate the square root: (OVERALL ERROR: 3.9122483030951116e-11)

       Math.log(a * a + b * b) / 2

       *
       *
       * 2. Try to use the non-overflowing pythagoras: (OVERALL ERROR: 8.889760039210159e-10)

       var fn = function(a, b) {
       a = Math.abs(a);
       b = Math.abs(b);
       var t = Math.min(a, b);
       a = Math.max(a, b);
       t = t / a;

       return Math.log(a) + Math.log(1 + t * t) / 2;
       };

       * 3. Abuse the identity cos(atan(y/x) = x / sqrt(x^2+y^2): (OVERALL ERROR: 3.4780178737037204e-10)

       Math.log(a / Math.cos(Math.atan2(b, a)))

       * 4. Use 3. and apply log rules: (OVERALL ERROR: 1.2014087502620896e-9)

       Math.log(a) - Math.log(Math.cos(Math.atan2(b, a)))

       */

      return Math.log(a / Math.cos(Math.atan2(b, a)));
    }

    var parse = function(a, b) {

      var z = {'re': 0, 'im': 0};

      if (a === undefined || a === null) {
        z['re'] =
                z['im'] = 0;
      } else if (b !== undefined) {
        z['re'] = a;
        z['im'] = b;
      } else
        switch (typeof a) {

          case 'object':

            if ('im' in a && 're' in a) {
              z['re'] = a['re'];
              z['im'] = a['im'];
            } else if ('abs' in a && 'arg' in a) {
              if (!Number.isFinite(a['abs']) && Number.isFinite(a['arg'])) {
                return Complex['INFINITY'];
              }
              z['re'] = a['abs'] * Math.cos(a['arg']);
              z['im'] = a['abs'] * Math.sin(a['arg']);
            } else if ('r' in a && 'phi' in a) {
              if (!Number.isFinite(a['r']) && Number.isFinite(a['phi'])) {
                return Complex['INFINITY'];
              }
              z['re'] = a['r'] * Math.cos(a['phi']);
              z['im'] = a['r'] * Math.sin(a['phi']);
            } else if (a.length === 2) { // Quick array check
              z['re'] = a[0];
              z['im'] = a[1];
            } else {
              parser_exit();
            }
            break;

          case 'string':

            z['im'] = /* void */
                    z['re'] = 0;

            var tokens = a.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
            var plus = 1;
            var minus = 0;

            if (tokens === null) {
              parser_exit();
            }

            for (var i = 0; i < tokens.length; i++) {

              var c = tokens[i];

              if (c === ' ' || c === '\t' || c === '\n') {
                /* void */
              } else if (c === '+') {
                plus++;
              } else if (c === '-') {
                minus++;
              } else if (c === 'i' || c === 'I') {

                if (plus + minus === 0) {
                  parser_exit();
                }

                if (tokens[i + 1] !== ' ' && !isNaN(tokens[i + 1])) {
                  z['im'] += parseFloat((minus % 2 ? '-' : '') + tokens[i + 1]);
                  i++;
                } else {
                  z['im'] += parseFloat((minus % 2 ? '-' : '') + '1');
                }
                plus = minus = 0;

              } else {

                if (plus + minus === 0 || isNaN(c)) {
                  parser_exit();
                }

                if (tokens[i + 1] === 'i' || tokens[i + 1] === 'I') {
                  z['im'] += parseFloat((minus % 2 ? '-' : '') + c);
                  i++;
                } else {
                  z['re'] += parseFloat((minus % 2 ? '-' : '') + c);
                }
                plus = minus = 0;
              }
            }

            // Still something on the stack
            if (plus + minus > 0) {
              parser_exit();
            }
            break;

          case 'number':
            z['im'] = 0;
            z['re'] = a;
            break;

          default:
            parser_exit();
        }

      return z;
    };

    /**
     * @constructor
     * @returns {Complex}
     */
    function Complex(a, b) {

      if (!(this instanceof Complex)) {
        return new Complex(a, b);
      }

      var z = parse(a, b);

      this['re'] = z['re'];
      this['im'] = z['im'];
    }

    Complex.prototype = {

      're': 0,
      'im': 0,

      /**
       * Calculates the sign of a complex number, which is a normalized complex
       *
       * @returns {Complex}
       */
      'sign': function() {

        var abs = this['abs']();

        return new Complex(
                this['re'] / abs,
                this['im'] / abs);
      },

      /**
       * Adds two complex numbers
       *
       * @returns {Complex}
       */
      'add': function(a, b) {

        var z = new Complex(a, b);

        // Infinity + Infinity = NaN
        if (this.isInfinite() && z.isInfinite()) {
          return Complex['NAN'];
        }

        // Infinity + z = Infinity { where z != Infinity }
        if (this.isInfinite() || z.isInfinite()) {
          return Complex['INFINITY'];
        }

        return new Complex(
                this['re'] + z['re'],
                this['im'] + z['im']);
      },

      /**
       * Subtracts two complex numbers
       *
       * @returns {Complex}
       */
      'sub': function(a, b) {

        var z = new Complex(a, b);

        // Infinity - Infinity = NaN
        if (this.isInfinite() && z.isInfinite()) {
          return Complex['NAN'];
        }

        // Infinity - z = Infinity { where z != Infinity }
        if (this.isInfinite() || z.isInfinite()) {
          return Complex['INFINITY'];
        }

        return new Complex(
                this['re'] - z['re'],
                this['im'] - z['im']);
      },

      /**
       * Multiplies two complex numbers
       *
       * @returns {Complex}
       */
      'mul': function(a, b) {

        var z = new Complex(a, b);

        // Infinity * 0 = NaN
        if ((this.isInfinite() && z.isZero()) || (this.isZero() && z.isInfinite())) {
          return Complex['NAN'];
        }

        // Infinity * z = Infinity { where z != 0 }
        if (this.isInfinite() || z.isInfinite()) {
          return Complex['INFINITY'];
        }

        // Short circuit for real values
        if (z['im'] === 0 && this['im'] === 0) {
          return new Complex(this['re'] * z['re'], 0);
        }

        return new Complex(
                this['re'] * z['re'] - this['im'] * z['im'],
                this['re'] * z['im'] + this['im'] * z['re']);
      },

      /**
       * Divides two complex numbers
       *
       * @returns {Complex}
       */
      'div': function(a, b) {

        var z = new Complex(a, b);

        // 0 / 0 = NaN and Infinity / Infinity = NaN
        if ((this.isZero() && z.isZero()) || (this.isInfinite() && z.isInfinite())) {
          return Complex['NAN'];
        }

        // Infinity / 0 = Infinity
        if (this.isInfinite() || z.isZero()) {
          return Complex['INFINITY'];
        }

        // 0 / Infinity = 0
        if (this.isZero() || z.isInfinite()) {
          return Complex['ZERO'];
        }

        a = this['re'];
        b = this['im'];

        var c = z['re'];
        var d = z['im'];
        var t, x;

        if (0 === d) {
          // Divisor is real
          return new Complex(a / c, b / c);
        }

        if (Math.abs(c) < Math.abs(d)) {

          x = c / d;
          t = c * x + d;

          return new Complex(
                  (a * x + b) / t,
                  (b * x - a) / t);

        } else {

          x = d / c;
          t = d * x + c;

          return new Complex(
                  (a + b * x) / t,
                  (b - a * x) / t);
        }
      },

      /**
       * Calculate the power of two complex numbers
       *
       * @returns {Complex}
       */
      'pow': function(a, b) {

        var z = new Complex(a, b);

        a = this['re'];
        b = this['im'];

        if (z.isZero()) {
          return Complex['ONE'];
        }

        // If the exponent is real
        if (z['im'] === 0) {

          if (b === 0 && a >= 0) {

            return new Complex(Math.pow(a, z['re']), 0);

          } else if (a === 0) { // If base is fully imaginary

            switch ((z['re'] % 4 + 4) % 4) {
              case 0:
                return new Complex(Math.pow(b, z['re']), 0);
              case 1:
                return new Complex(0, Math.pow(b, z['re']));
              case 2:
                return new Complex(-Math.pow(b, z['re']), 0);
              case 3:
                return new Complex(0, -Math.pow(b, z['re']));
            }
          }
        }

        /* I couldn't find a good formula, so here is a derivation and optimization
         *
         * z_1^z_2 = (a + bi)^(c + di)
         *         = exp((c + di) * log(a + bi)
         *         = pow(a^2 + b^2, (c + di) / 2) * exp(i(c + di)atan2(b, a))
         * =>...
         * Re = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * cos(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
         * Im = (pow(a^2 + b^2, c / 2) * exp(-d * atan2(b, a))) * sin(d * log(a^2 + b^2) / 2 + c * atan2(b, a))
         *
         * =>...
         * Re = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * cos(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
         * Im = exp(c * log(sqrt(a^2 + b^2)) - d * atan2(b, a)) * sin(d * log(sqrt(a^2 + b^2)) + c * atan2(b, a))
         *
         * =>
         * Re = exp(c * logsq2 - d * arg(z_1)) * cos(d * logsq2 + c * arg(z_1))
         * Im = exp(c * logsq2 - d * arg(z_1)) * sin(d * logsq2 + c * arg(z_1))
         *
         */

        if (a === 0 && b === 0 && z['re'] > 0 && z['im'] >= 0) {
          return Complex['ZERO'];
        }

        var arg = Math.atan2(b, a);
        var loh = logHypot(a, b);

        a = Math.exp(z['re'] * loh - z['im'] * arg);
        b = z['im'] * loh + z['re'] * arg;
        return new Complex(
                a * Math.cos(b),
                a * Math.sin(b));
      },

      /**
       * Calculate the complex square root
       *
       * @returns {Complex}
       */
      'sqrt': function() {

        var a = this['re'];
        var b = this['im'];
        var r = this['abs']();

        var re, im;

        if (a >= 0) {

          if (b === 0) {
            return new Complex(Math.sqrt(a), 0);
          }

          re = 0.5 * Math.sqrt(2.0 * (r + a));
        } else {
          re = Math.abs(b) / Math.sqrt(2 * (r - a));
        }

        if (a <= 0) {
          im = 0.5 * Math.sqrt(2.0 * (r - a));
        } else {
          im = Math.abs(b) / Math.sqrt(2 * (r + a));
        }

        return new Complex(re, b < 0 ? -im : im);
      },

      /**
       * Calculate the complex exponent
       *
       * @returns {Complex}
       */
      'exp': function() {

        var tmp = Math.exp(this['re']);

        if (this['im'] === 0) {
          //return new Complex(tmp, 0);
        }
        return new Complex(
                tmp * Math.cos(this['im']),
                tmp * Math.sin(this['im']));
      },

      /**
       * Calculate the complex exponent and subtracts one.
       *
       * This may be more accurate than `Complex(x).exp().sub(1)` if
       * `x` is small.
       *
       * @returns {Complex}
       */
      'expm1': function() {

        /**
         * exp(a + i*b) - 1
         = exp(a) * (cos(b) + j*sin(b)) - 1
         = expm1(a)*cos(b) + cosm1(b) + j*exp(a)*sin(b)
         */

        var a = this['re'];
        var b = this['im'];

        return new Complex(
                Math.expm1(a) * Math.cos(b) + cosm1(b),
                Math.exp(a) * Math.sin(b));
      },

      /**
       * Calculate the natural log
       *
       * @returns {Complex}
       */
      'log': function() {

        var a = this['re'];
        var b = this['im'];

        return new Complex(
                logHypot(a, b),
                Math.atan2(b, a));
      },

      /**
       * Calculate the magnitude of the complex number
       *
       * @returns {number}
       */
      'abs': function() {

        return hypot(this['re'], this['im']);
      },

      /**
       * Calculate the angle of the complex number
       *
       * @returns {number}
       */
      'arg': function() {

        return Math.atan2(this['im'], this['re']);
      },

      /**
       * Calculate the sine of the complex number
       *
       * @returns {Complex}
       */
      'sin': function() {

        // sin(c) = (e^b - e^(-b)) / (2i)

        var a = this['re'];
        var b = this['im'];

        return new Complex(
                Math.sin(a) * cosh(b),
                Math.cos(a) * sinh(b));
      },

      /**
       * Calculate the cosine
       *
       * @returns {Complex}
       */
      'cos': function() {

        // cos(z) = (e^b + e^(-b)) / 2

        var a = this['re'];
        var b = this['im'];

        return new Complex(
                Math.cos(a) * cosh(b),
                -Math.sin(a) * sinh(b));
      },

      /**
       * Calculate the tangent
       *
       * @returns {Complex}
       */
      'tan': function() {

        // tan(c) = (e^(ci) - e^(-ci)) / (i(e^(ci) + e^(-ci)))

        var a = 2 * this['re'];
        var b = 2 * this['im'];
        var d = Math.cos(a) + cosh(b);

        return new Complex(
                Math.sin(a) / d,
                sinh(b) / d);
      },

      /**
       * Calculate the cotangent
       *
       * @returns {Complex}
       */
      'cot': function() {

        // cot(c) = i(e^(ci) + e^(-ci)) / (e^(ci) - e^(-ci))

        var a = 2 * this['re'];
        var b = 2 * this['im'];
        var d = Math.cos(a) - cosh(b);

        return new Complex(
                -Math.sin(a) / d,
                sinh(b) / d);
      },

      /**
       * Calculate the secant
       *
       * @returns {Complex}
       */
      'sec': function() {

        // sec(c) = 2 / (e^(ci) + e^(-ci))

        var a = this['re'];
        var b = this['im'];
        var d = 0.5 * cosh(2 * b) + 0.5 * Math.cos(2 * a);

        return new Complex(
                Math.cos(a) * cosh(b) / d,
                Math.sin(a) * sinh(b) / d);
      },

      /**
       * Calculate the cosecans
       *
       * @returns {Complex}
       */
      'csc': function() {

        // csc(c) = 2i / (e^(ci) - e^(-ci))

        var a = this['re'];
        var b = this['im'];
        var d = 0.5 * cosh(2 * b) - 0.5 * Math.cos(2 * a);

        return new Complex(
                Math.sin(a) * cosh(b) / d,
                -Math.cos(a) * sinh(b) / d);
      },

      /**
       * Calculate the complex arcus sinus
       *
       * @returns {Complex}
       */
      'asin': function() {

        // asin(c) = -i * log(ci + sqrt(1 - c^2))

        var a = this['re'];
        var b = this['im'];

        var t1 = new Complex(
                b * b - a * a + 1,
                -2 * a * b)['sqrt']();

        var t2 = new Complex(
                t1['re'] - b,
                t1['im'] + a)['log']();

        return new Complex(t2['im'], -t2['re']);
      },

      /**
       * Calculate the complex arcus cosinus
       *
       * @returns {Complex}
       */
      'acos': function() {

        // acos(c) = i * log(c - i * sqrt(1 - c^2))

        var a = this['re'];
        var b = this['im'];

        var t1 = new Complex(
                b * b - a * a + 1,
                -2 * a * b)['sqrt']();

        var t2 = new Complex(
                t1['re'] - b,
                t1['im'] + a)['log']();

        return new Complex(Math.PI / 2 - t2['im'], t2['re']);
      },

      /**
       * Calculate the complex arcus tangent
       *
       * @returns {Complex}
       */
      'atan': function() {

        // atan(c) = i / 2 log((i + x) / (i - x))

        var a = this['re'];
        var b = this['im'];

        if (a === 0) {

          if (b === 1) {
            return new Complex(0, Infinity);
          }

          if (b === -1) {
            return new Complex(0, -Infinity);
          }
        }

        var d = a * a + (1.0 - b) * (1.0 - b);

        var t1 = new Complex(
                (1 - b * b - a * a) / d,
                -2 * a / d).log();

        return new Complex(-0.5 * t1['im'], 0.5 * t1['re']);
      },

      /**
       * Calculate the complex arcus cotangent
       *
       * @returns {Complex}
       */
      'acot': function() {

        // acot(c) = i / 2 log((c - i) / (c + i))

        var a = this['re'];
        var b = this['im'];

        if (b === 0) {
          return new Complex(Math.atan2(1, a), 0);
        }

        var d = a * a + b * b;
        return (d !== 0)
                ? new Complex(
                        a / d,
                        -b / d).atan()
                : new Complex(
                        (a !== 0) ? a / 0 : 0,
                        (b !== 0) ? -b / 0 : 0).atan();
      },

      /**
       * Calculate the complex arcus secant
       *
       * @returns {Complex}
       */
      'asec': function() {

        // asec(c) = -i * log(1 / c + sqrt(1 - i / c^2))

        var a = this['re'];
        var b = this['im'];

        if (a === 0 && b === 0) {
          return new Complex(0, Infinity);
        }

        var d = a * a + b * b;
        return (d !== 0)
                ? new Complex(
                        a / d,
                        -b / d).acos()
                : new Complex(
                        (a !== 0) ? a / 0 : 0,
                        (b !== 0) ? -b / 0 : 0).acos();
      },

      /**
       * Calculate the complex arcus cosecans
       *
       * @returns {Complex}
       */
      'acsc': function() {

        // acsc(c) = -i * log(i / c + sqrt(1 - 1 / c^2))

        var a = this['re'];
        var b = this['im'];

        if (a === 0 && b === 0) {
          return new Complex(Math.PI / 2, Infinity);
        }

        var d = a * a + b * b;
        return (d !== 0)
                ? new Complex(
                        a / d,
                        -b / d).asin()
                : new Complex(
                        (a !== 0) ? a / 0 : 0,
                        (b !== 0) ? -b / 0 : 0).asin();
      },

      /**
       * Calculate the complex sinh
       *
       * @returns {Complex}
       */
      'sinh': function() {

        // sinh(c) = (e^c - e^-c) / 2

        var a = this['re'];
        var b = this['im'];

        return new Complex(
                sinh(a) * Math.cos(b),
                cosh(a) * Math.sin(b));
      },

      /**
       * Calculate the complex cosh
       *
       * @returns {Complex}
       */
      'cosh': function() {

        // cosh(c) = (e^c + e^-c) / 2

        var a = this['re'];
        var b = this['im'];

        return new Complex(
                cosh(a) * Math.cos(b),
                sinh(a) * Math.sin(b));
      },

      /**
       * Calculate the complex tanh
       *
       * @returns {Complex}
       */
      'tanh': function() {

        // tanh(c) = (e^c - e^-c) / (e^c + e^-c)

        var a = 2 * this['re'];
        var b = 2 * this['im'];
        var d = cosh(a) + Math.cos(b);

        return new Complex(
                sinh(a) / d,
                Math.sin(b) / d);
      },

      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      'coth': function() {

        // coth(c) = (e^c + e^-c) / (e^c - e^-c)

        var a = 2 * this['re'];
        var b = 2 * this['im'];
        var d = cosh(a) - Math.cos(b);

        return new Complex(
                sinh(a) / d,
                -Math.sin(b) / d);
      },

      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      'csch': function() {

        // csch(c) = 2 / (e^c - e^-c)

        var a = this['re'];
        var b = this['im'];
        var d = Math.cos(2 * b) - cosh(2 * a);

        return new Complex(
                -2 * sinh(a) * Math.cos(b) / d,
                2 * cosh(a) * Math.sin(b) / d);
      },

      /**
       * Calculate the complex sech
       *
       * @returns {Complex}
       */
      'sech': function() {

        // sech(c) = 2 / (e^c + e^-c)

        var a = this['re'];
        var b = this['im'];
        var d = Math.cos(2 * b) + cosh(2 * a);

        return new Complex(
                2 * cosh(a) * Math.cos(b) / d,
                -2 * sinh(a) * Math.sin(b) / d);
      },

      /**
       * Calculate the complex asinh
       *
       * @returns {Complex}
       */
      'asinh': function() {

        // asinh(c) = log(c + sqrt(c^2 + 1))

        var tmp = this['im'];
        this['im'] = -this['re'];
        this['re'] = tmp;
        var res = this['asin']();

        this['re'] = -this['im'];
        this['im'] = tmp;
        tmp = res['re'];

        res['re'] = -res['im'];
        res['im'] = tmp;
        return res;
      },

      /**
       * Calculate the complex asinh
       *
       * @returns {Complex}
       */
      'acosh': function() {

        // acosh(c) = log(c + sqrt(c^2 - 1))

        var res = this['acos']();
        if (res['im'] <= 0) {
          var tmp = res['re'];
          res['re'] = -res['im'];
          res['im'] = tmp;
        } else {
          var tmp = res['im'];
          res['im'] = -res['re'];
          res['re'] = tmp;
        }
        return res;
      },

      /**
       * Calculate the complex atanh
       *
       * @returns {Complex}
       */
      'atanh': function() {

        // atanh(c) = log((1+c) / (1-c)) / 2

        var a = this['re'];
        var b = this['im'];

        var noIM = a > 1 && b === 0;
        var oneMinus = 1 - a;
        var onePlus = 1 + a;
        var d = oneMinus * oneMinus + b * b;

        var x = (d !== 0)
                ? new Complex(
                        (onePlus * oneMinus - b * b) / d,
                        (b * oneMinus + onePlus * b) / d)
                : new Complex(
                        (a !== -1) ? (a / 0) : 0,
                        (b !== 0) ? (b / 0) : 0);

        var temp = x['re'];
        x['re'] = logHypot(x['re'], x['im']) / 2;
        x['im'] = Math.atan2(x['im'], temp) / 2;
        if (noIM) {
          x['im'] = -x['im'];
        }
        return x;
      },

      /**
       * Calculate the complex acoth
       *
       * @returns {Complex}
       */
      'acoth': function() {

        // acoth(c) = log((c+1) / (c-1)) / 2

        var a = this['re'];
        var b = this['im'];

        if (a === 0 && b === 0) {
          return new Complex(0, Math.PI / 2);
        }

        var d = a * a + b * b;
        return (d !== 0)
                ? new Complex(
                        a / d,
                        -b / d).atanh()
                : new Complex(
                        (a !== 0) ? a / 0 : 0,
                        (b !== 0) ? -b / 0 : 0).atanh();
      },

      /**
       * Calculate the complex acsch
       *
       * @returns {Complex}
       */
      'acsch': function() {

        // acsch(c) = log((1+sqrt(1+c^2))/c)

        var a = this['re'];
        var b = this['im'];

        if (b === 0) {

          return new Complex(
                  (a !== 0)
                  ? Math.log(a + Math.sqrt(a * a + 1))
                  : Infinity, 0);
        }

        var d = a * a + b * b;
        return (d !== 0)
                ? new Complex(
                        a / d,
                        -b / d).asinh()
                : new Complex(
                        (a !== 0) ? a / 0 : 0,
                        (b !== 0) ? -b / 0 : 0).asinh();
      },

      /**
       * Calculate the complex asech
       *
       * @returns {Complex}
       */
      'asech': function() {

        // asech(c) = log((1+sqrt(1-c^2))/c)

        var a = this['re'];
        var b = this['im'];

        if (this.isZero()) {
          return Complex['INFINITY'];
        }

        var d = a * a + b * b;
        return (d !== 0)
                ? new Complex(
                        a / d,
                        -b / d).acosh()
                : new Complex(
                        (a !== 0) ? a / 0 : 0,
                        (b !== 0) ? -b / 0 : 0).acosh();
      },

      /**
       * Calculate the complex inverse 1/z
       *
       * @returns {Complex}
       */
      'inverse': function() {

        // 1 / 0 = Infinity and 1 / Infinity = 0
        if (this.isZero()) {
          return Complex['INFINITY'];
        }

        if (this.isInfinite()) {
          return Complex['ZERO'];
        }

        var a = this['re'];
        var b = this['im'];

        var d = a * a + b * b;

        return new Complex(a / d, -b / d);
      },

      /**
       * Returns the complex conjugate
       *
       * @returns {Complex}
       */
      'conjugate': function() {

        return new Complex(this['re'], -this['im']);
      },

      /**
       * Gets the negated complex number
       *
       * @returns {Complex}
       */
      'neg': function() {

        return new Complex(-this['re'], -this['im']);
      },

      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      'ceil': function(places) {

        places = Math.pow(10, places || 0);

        return new Complex(
                Math.ceil(this['re'] * places) / places,
                Math.ceil(this['im'] * places) / places);
      },

      /**
       * Floors the actual complex number
       *
       * @returns {Complex}
       */
      'floor': function(places) {

        places = Math.pow(10, places || 0);

        return new Complex(
                Math.floor(this['re'] * places) / places,
                Math.floor(this['im'] * places) / places);
      },

      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      'round': function(places) {

        places = Math.pow(10, places || 0);

        return new Complex(
                Math.round(this['re'] * places) / places,
                Math.round(this['im'] * places) / places);
      },

      /**
       * Compares two complex numbers
       *
       * **Note:** new Complex(Infinity).equals(Infinity) === false
       *
       * @returns {boolean}
       */
      'equals': function(a, b) {

        var z = new Complex(a, b);

        return Math.abs(z['re'] - this['re']) <= Complex['EPSILON'] &&
                Math.abs(z['im'] - this['im']) <= Complex['EPSILON'];
      },

      /**
       * Clones the actual object
       *
       * @returns {Complex}
       */
      'clone': function() {

        return new Complex(this['re'], this['im']);
      },

      /**
       * Gets a string of the actual complex number
       *
       * @returns {string}
       */
      'toString': function() {

        var a = this['re'];
        var b = this['im'];
        var ret = '';

        if (this.isNaN()) {
          return 'NaN';
        }

        if (this.isZero()) {
          return '0';
        }

        if (this.isInfinite()) {
          return 'Infinity';
        }

        if (a !== 0) {
          ret += a;
        }

        if (b !== 0) {

          if (a !== 0) {
            ret += b < 0 ? ' - ' : ' + ';
          } else if (b < 0) {
            ret += '-';
          }

          b = Math.abs(b);

          if (1 !== b) {
            ret += b;
          }
          ret += 'i';
        }

        if (!ret)
          return '0';

        return ret;
      },

      /**
       * Returns the actual number as a vector
       *
       * @returns {Array}
       */
      'toVector': function() {

        return [this['re'], this['im']];
      },

      /**
       * Returns the actual real value of the current object
       *
       * @returns {number|null}
       */
      'valueOf': function() {

        if (this['im'] === 0) {
          return this['re'];
        }
        return null;
      },

      /**
       * Determines whether a complex number is not on the Riemann sphere.
       *
       * @returns {boolean}
       */
      'isNaN': function() {
        return isNaN(this['re']) || isNaN(this['im']);
      },

      /**
       * Determines whether or not a complex number is at the zero pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      'isZero': function() {
        return (
                (this['re'] === 0 || this['re'] === -0) &&
                (this['im'] === 0 || this['im'] === -0)
                );
      },

      /**
       * Determines whether a complex number is not at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      'isFinite': function() {
        return isFinite(this['re']) && isFinite(this['im']);
      },

      /**
       * Determines whether or not a complex number is at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      'isInfinite': function() {
        return !(this.isNaN() || this.isFinite());
      }
    };

    Complex['ZERO'] = new Complex(0, 0);
    Complex['ONE'] = new Complex(1, 0);
    Complex['I'] = new Complex(0, 1);
    Complex['PI'] = new Complex(Math.PI, 0);
    Complex['E'] = new Complex(Math.E, 0);
    Complex['INFINITY'] = new Complex(Infinity, Infinity);
    Complex['NAN'] = new Complex(NaN, NaN);
    Complex['EPSILON'] = 1e-16;

    if (typeof undefined === 'function' && undefined['amd']) {
      undefined([], function() {
        return Complex;
      });
    } else {
      Object.defineProperty(exports, "__esModule", {'value': true});
      Complex['default'] = Complex;
      Complex['Complex'] = Complex;
      module['exports'] = Complex;
    }

  })(commonjsGlobal);
  });

  unwrapExports(complex);

  var format$1 = number.format;
  var isNumber = number.isNumber;

  function factory$7 (type, config, load, typed, math) {

    /**
     * Attach type information
     */
    complex.prototype.type = 'Complex';
    complex.prototype.isComplex = true;


    /**
     * Get a JSON representation of the complex number
     * @returns {Object} Returns a JSON object structured as:
     *                   `{"mathjs": "Complex", "re": 2, "im": 3}`
     */
    complex.prototype.toJSON = function () {
      return {
        mathjs: 'Complex',
        re: this.re,
        im: this.im
      };
    };

    /*
     * Return the value of the complex number in polar notation
     * The angle phi will be set in the interval of [-pi, pi].
     * @return {{r: number, phi: number}} Returns and object with properties r and phi.
     */
    complex.prototype.toPolar = function () {
      return {
        r: this.abs(),
        phi: this.arg()
      };
    };

    /**
     * Get a string representation of the complex number,
     * with optional formatting options.
     * @param {Object | number | Function} [options]  Formatting options. See
     *                                                lib/utils/number:format for a
     *                                                description of the available
     *                                                options.
     * @return {string} str
     */
    complex.prototype.format = function (options) {
      var str = '';
      var im = this.im;
      var re = this.re;
      var strRe = format$1(this.re, options);
      var strIm = format$1(this.im, options);

      // round either re or im when smaller than the configured precision
      var precision = isNumber(options) ? options : options ? options.precision : null;
      if (precision !== null) {
        var epsilon = Math.pow(10, -precision);
        if (Math.abs(re / im) < epsilon) {
          re = 0;
        }
        if (Math.abs(im / re) < epsilon) {
          im = 0;
        }
      }

      if (im == 0) {
        // real value
        str = strRe;
      } else if (re == 0) {
        // purely complex value
        if (im == 1) {
          str = 'i';
        } else if (im == -1) {
          str = '-i';
        } else {
          str = strIm + 'i';
        }
      } else {
        // complex value
        if (im < 0) {
          if (im == -1) {
            str = strRe + ' - i';
          } else {
            str = strRe + ' - ' + strIm.substring(1) + 'i';
          }
        } else {
          if (im == 1) {
            str = strRe + ' + i';
          } else {
            str = strRe + ' + ' + strIm + 'i';
          }
        }
      }
      return str;
    };

    /**
     * Create a complex number from polar coordinates
     *
     * Usage:
     *
     *     Complex.fromPolar(r: number, phi: number) : Complex
     *     Complex.fromPolar({r: number, phi: number}) : Complex
     *
     * @param {*} args...
     * @return {Complex}
     */
    complex.fromPolar = function (args) {
      switch (arguments.length) {
        case 1:
          var arg = arguments[0];
          if (typeof arg === 'object') {
            return complex(arg);
          }
          throw new TypeError('Input has to be an object with r and phi keys.');

        case 2:
          var r = arguments[0],
              phi = arguments[1];
          if (isNumber(r)) {
            if (type.isUnit(phi) && phi.hasBase('ANGLE')) {
              // convert unit to a number in radians
              phi = phi.toNumber('rad');
            }

            if (isNumber(phi)) {
              return new complex({r: r, phi: phi});
            }

            throw new TypeError('Phi is not a number nor an angle unit.');
          } else {
            throw new TypeError('Radius r is not a number.');
          }

        default:
          throw new SyntaxError('Wrong number of arguments in function fromPolar');
      }
    };


    complex.prototype.valueOf = complex.prototype.toString;

    /**
     * Create a Complex number from a JSON object
     * @param {Object} json  A JSON Object structured as
     *                       {"mathjs": "Complex", "re": 2, "im": 3}
     *                       All properties are optional, default values
     *                       for `re` and `im` are 0.
     * @return {Complex} Returns a new Complex number
     */
    complex.fromJSON = function (json) {
      return new complex(json);
    };

    // apply the current epsilon
    complex.EPSILON = config.epsilon;

    // listen for changed in the configuration, automatically apply changed epsilon
    math.on('config', function (curr, prev) {
      if (curr.epsilon !== prev.epsilon) {
        complex.EPSILON = curr.epsilon;
      }
    });

    /**
     * Compare two complex numbers, `a` and `b`:
     *
     * - Returns 1 when the real part of `a` is larger than the real part of `b`
     * - Returns -1 when the real part of `a` is smaller than the real part of `b`
     * - Returns 1 when the real parts are equal
     *   and the imaginary part of `a` is larger than the imaginary part of `b`
     * - Returns -1 when the real parts are equal
     *   and the imaginary part of `a` is smaller than the imaginary part of `b`
     * - Returns 0 when both real and imaginary parts are equal.
     *
     * @params {Complex} a
     * @params {Complex} b
     * @returns {number} Returns the comparison result: -1, 0, or 1
     */
    complex.compare = function (a, b) {
      if (a.re > b.re) { return 1; }
      if (a.re < b.re) { return -1; }

      if (a.im > b.im) { return 1; }
      if (a.im < b.im) { return -1; }

      return 0;
    };

    return complex;
  }

  var name$7 = 'Complex';
  var path$2 = 'type';
  var factory_1$7 = factory$7;
  var math$4 = true; // request access to the math namespace

  var Complex_1 = {
  	name: name$7,
  	path: path$2,
  	factory: factory_1$7,
  	math: math$4
  };

  // Map the characters to escape to their escaped values. The list is derived
  // from http://www.cespedes.org/blog/85/how-to-escape-latex-special-characters

  var defaultEscapes = {
    "{": "\\{",
    "}": "\\}",
    "\\": "\\textbackslash{}",
    "#": "\\#",
    $: "\\$",
    "%": "\\%",
    "&": "\\&",
    "^": "\\textasciicircum{}",
    _: "\\_",
    "~": "\\textasciitilde{}"
  };
  var formatEscapes = {
    "–": "\\--",
    "—": "\\---",
    " ": "~",
    "\t": "\\qquad{}",
    "\r\n": "\\\\newline{}",
    "\n": "\\\\newline{}"
  };

  var defaultEscapeMapFn = function defaultEscapeMapFn(defaultEscapes, formatEscapes) {
    return Object.assign({}, defaultEscapes, formatEscapes);
  };

  /**
   * Escape a string to be used in LaTeX documents.
   * @param {string} str the string to be escaped.
   * @param {boolean} params.preserveFormatting whether formatting escapes should
   *  be performed (default: false).
   * @param {function} params.escapeMapFn the function to modify the escape maps.
   * @return {string} the escaped string, ready to be used in LaTeX.
   */
  var dist = function (str) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$preserveFormatti = _ref.preserveFormatting,
        preserveFormatting = _ref$preserveFormatti === undefined ? false : _ref$preserveFormatti,
        _ref$escapeMapFn = _ref.escapeMapFn,
        escapeMapFn = _ref$escapeMapFn === undefined ? defaultEscapeMapFn : _ref$escapeMapFn;

    var runningStr = String(str);
    var result = "";

    var escapes = escapeMapFn(Object.assign({}, defaultEscapes), preserveFormatting ? Object.assign({}, formatEscapes) : {});
    var escapeKeys = Object.keys(escapes); // as it is reused later on

    // Algorithm: Go through the string character by character, if it matches
    // with one of the special characters then we'll replace it with the escaped
    // version.

    var _loop = function _loop() {
      var specialCharFound = false;
      escapeKeys.forEach(function (key, index) {
        if (specialCharFound) {
          return;
        }
        if (runningStr.startsWith(key)) {
          result += escapes[escapeKeys[index]];
          runningStr = runningStr.slice(key.length, runningStr.length);
          specialCharFound = true;
        }
      });
      if (!specialCharFound) {
        result += runningStr.slice(0, 1);
        runningStr = runningStr.slice(1, runningStr.length);
      }
    };

    while (runningStr) {
      _loop();
    }
    return result;
  };

  var latex = createCommonjsModule(function (module, exports) {



  exports.symbols = {
    // GREEK LETTERS
    Alpha: 'A',     alpha: '\\alpha',
    Beta: 'B',      beta: '\\beta',
    Gamma: '\\Gamma',    gamma: '\\gamma',
    Delta: '\\Delta',    delta: '\\delta',
    Epsilon: 'E',   epsilon: '\\epsilon',  varepsilon: '\\varepsilon',
    Zeta: 'Z',      zeta: '\\zeta',
    Eta: 'H',       eta: '\\eta',
    Theta: '\\Theta',    theta: '\\theta',    vartheta: '\\vartheta',
    Iota: 'I',      iota: '\\iota',
    Kappa: 'K',     kappa: '\\kappa',    varkappa: '\\varkappa',
    Lambda: '\\Lambda',   lambda: '\\lambda',
    Mu: 'M',        mu: '\\mu',
    Nu: 'N',        nu: '\\nu',
    Xi: '\\Xi',       xi: '\\xi',
    Omicron: 'O',   omicron: 'o',
    Pi: '\\Pi',       pi: '\\pi',       varpi: '\\varpi',
    Rho: 'P',       rho: '\\rho',      varrho: '\\varrho',
    Sigma: '\\Sigma',    sigma: '\\sigma',    varsigma: '\\varsigma',
    Tau: 'T',       tau: '\\tau',
    Upsilon: '\\Upsilon',  upsilon: '\\upsilon',
    Phi: '\\Phi',      phi: '\\phi',      varphi: '\\varphi',
    Chi: 'X',       chi: '\\chi',
    Psi: '\\Psi',      psi: '\\psi',
    Omega: '\\Omega',    omega: '\\omega',
    //logic
    'true': '\\mathrm{True}',
    'false': '\\mathrm{False}',
    //other
    i: 'i', //TODO use \i ??
    inf: '\\infty',
    Inf: '\\infty',
    infinity: '\\infty',
    Infinity: '\\infty',
    oo: '\\infty',
    lim: '\\lim',
    'undefined': '\\mathbf{?}'
  };

  exports.operators = {
    'transpose': '^\\top',
    'factorial': '!',
    'pow': '^',
    'dotPow': '.^\\wedge', //TODO find ideal solution
    'unaryPlus': '+',
    'unaryMinus': '-',
    'bitNot': '~', //TODO find ideal solution
    'not': '\\neg',
    'multiply': '\\cdot',
    'divide': '\\frac', //TODO how to handle that properly?
    'dotMultiply': '.\\cdot', //TODO find ideal solution
    'dotDivide': '.:', //TODO find ideal solution
    'mod': '\\mod',
    'add': '+',
    'subtract': '-',
    'to': '\\rightarrow',
    'leftShift': '<<',
    'rightArithShift': '>>',
    'rightLogShift': '>>>',
    'equal': '=',
    'unequal': '\\neq',
    'smaller': '<',
    'larger': '>',
    'smallerEq': '\\leq',
    'largerEq': '\\geq',
    'bitAnd': '\\&',
    'bitXor': '\\underline{|}',
    'bitOr': '|',
    'and': '\\wedge',
    'xor': '\\veebar',
    'or': '\\vee'
  };

  exports.defaultTemplate = '\\mathrm{${name}}\\left(${args}\\right)';

  var units = {
    deg: '^\\circ'
  };

  exports.escape = function (string) {
    return dist(string, {'preserveFormatting': true});
  };

  //@param {string} name
  //@param {boolean} isUnit
  exports.toSymbol = function (name, isUnit) {
    isUnit = typeof isUnit === 'undefined' ? false : isUnit;
    if (isUnit) {
      if (units.hasOwnProperty(name)) {
        return units[name];
      }

      return '\\mathrm{' + exports.escape(name) + '}';
    }

    if (exports.symbols.hasOwnProperty(name)) {
      return exports.symbols[name];
    }

    return exports.escape(name);
  };
  });
  var latex_1 = latex.symbols;
  var latex_2 = latex.operators;
  var latex_3 = latex.defaultTemplate;
  var latex_4 = latex.escape;
  var latex_5 = latex.toSymbol;

  function factory$8 (type, config, load, typed) {
    var latex$$1 = latex;

    /**
     * Create a complex value or convert a value to a complex value.
     *
     * Syntax:
     *
     *     math.complex()                           // creates a complex value with zero
     *                                              // as real and imaginary part.
     *     math.complex(re : number, im : string)   // creates a complex value with provided
     *                                              // values for real and imaginary part.
     *     math.complex(re : number)                // creates a complex value with provided
     *                                              // real value and zero imaginary part.
     *     math.complex(complex : Complex)          // clones the provided complex value.
     *     math.complex(arg : string)               // parses a string into a complex value.
     *     math.complex(array : Array)              // converts the elements of the array
     *                                              // or matrix element wise into a
     *                                              // complex value.
     *     math.complex({re: number, im: number})   // creates a complex value with provided
     *                                              // values for real an imaginary part.
     *     math.complex({r: number, phi: number})   // creates a complex value with provided
     *                                              // polar coordinates
     *
     * Examples:
     *
     *    var a = math.complex(3, -4);     // a = Complex 3 - 4i
     *    a.re = 5;                        // a = Complex 5 - 4i
     *    var i = a.im;                    // Number -4;
     *    var b = math.complex('2 + 6i');  // Complex 2 + 6i
     *    var c = math.complex();          // Complex 0 + 0i
     *    var d = math.add(a, b);          // Complex 5 + 2i
     *
     * See also:
     *
     *    bignumber, boolean, index, matrix, number, string, unit
     *
     * @param {* | Array | Matrix} [args]
     *            Arguments specifying the real and imaginary part of the complex number
     * @return {Complex | Array | Matrix} Returns a complex value
     */
    var complex = typed('complex', {
      '': function () {
        return type.Complex.ZERO;
      },

      'number': function (x) {
        return new type.Complex(x, 0);
      },

      'number, number': function (re, im) {
        return new type.Complex(re, im);
      },

      // TODO: this signature should be redundant
      'BigNumber, BigNumber': function (re, im) {
        return new type.Complex(re.toNumber(), im.toNumber());
      },

      'Complex': function (x) {
        return x.clone();
      },

      'string': function (x) {
        return type.Complex(x); // for example '2 + 3i'
      },

      'null': function (x) {
        return type.Complex(0);
      },

      'Object': function (x) {
        if('re' in x && 'im' in x) {
          return new type.Complex(x.re, x.im);
        }

        if ('r' in x && 'phi' in x) {
          return new type.Complex(x);
        }

        throw new Error('Expected object with either properties re and im, or properties r and phi.');
      },

      'Array | Matrix': function (x) {
        return deepMap(x, complex);
      }
    });

    complex.toTex = {
      0: '0',
      1: '\\left(${args[0]}\\right)',
      2: '\\left(\\left(${args[0]}\\right)+'
        + latex$$1.symbols['i'] + '\\cdot\\left(${args[1]}\\right)\\right)'
    };

    return complex;
  }

  var name$8 = 'complex';
  var factory_1$8 = factory$8;

  var complex$2 = {
  	name: name$8,
  	factory: factory_1$8
  };

  var complex$3 = [
    // type
    Complex_1,

    // construction function
    complex$2
  ];

  var fraction = createCommonjsModule(function (module, exports) {
  /**
   * @license Fraction.js v4.0.8 09/09/2015
   * http://www.xarg.org/2014/03/rational-numbers-in-javascript/
   *
   * Copyright (c) 2015, Robert Eisele (robert@xarg.org)
   * Dual licensed under the MIT or GPL Version 2 licenses.
   **/


  /**
   *
   * This class offers the possibility to calculate fractions.
   * You can pass a fraction in different formats. Either as array, as double, as string or as an integer.
   *
   * Array/Object form
   * [ 0 => <nominator>, 1 => <denominator> ]
   * [ n => <nominator>, d => <denominator> ]
   *
   * Integer form
   * - Single integer value
   *
   * Double form
   * - Single double value
   *
   * String form
   * 123.456 - a simple double
   * 123/456 - a string fraction
   * 123.'456' - a double with repeating decimal places
   * 123.(456) - synonym
   * 123.45'6' - a double with repeating last place
   * 123.45(6) - synonym
   *
   * Example:
   *
   * var f = new Fraction("9.4'31'");
   * f.mul([-4, 3]).div(4.9);
   *
   */

  (function(root) {

    // Maximum search depth for cyclic rational numbers. 2000 should be more than enough.
    // Example: 1/7 = 0.(142857) has 6 repeating decimal places.
    // If MAX_CYCLE_LEN gets reduced, long cycles will not be detected and toString() only gets the first 10 digits
    var MAX_CYCLE_LEN = 2000;

    // Parsed data to avoid calling "new" all the time
    var P = {
      "s": 1,
      "n": 0,
      "d": 1
    };

    function createError(name) {

      function errorConstructor() {
        var temp = Error.apply(this, arguments);
        temp['name'] = this['name'] = name;
        this['stack'] = temp['stack'];
        this['message'] = temp['message'];
      }

      /**
       * Error constructor
       *
       * @constructor
       */
      function IntermediateInheritor() {}
      IntermediateInheritor.prototype = Error.prototype;
      errorConstructor.prototype = new IntermediateInheritor();

      return errorConstructor;
    }

    var DivisionByZero = Fraction['DivisionByZero'] = createError('DivisionByZero');
    var InvalidParameter = Fraction['InvalidParameter'] = createError('InvalidParameter');

    function assign(n, s) {

      if (isNaN(n = parseInt(n, 10))) {
        throwInvalidParam();
      }
      return n * s;
    }

    function throwInvalidParam() {
      throw new InvalidParameter();
    }

    var parse = function(p1, p2) {

      var n = 0, d = 1, s = 1;
      var v = 0, w = 0, x = 0, y = 1, z = 1;

      var A = 0, B = 1;
      var C = 1, D = 1;

      var N = 10000000;
      var M;

      if (p1 === undefined || p1 === null) {
        /* void */
      } else if (p2 !== undefined) {
        n = p1;
        d = p2;
        s = n * d;
      } else
        switch (typeof p1) {

          case "object":
          {
            if ("d" in p1 && "n" in p1) {
              n = p1["n"];
              d = p1["d"];
              if ("s" in p1)
                n *= p1["s"];
            } else if (0 in p1) {
              n = p1[0];
              if (1 in p1)
                d = p1[1];
            } else {
              throwInvalidParam();
            }
            s = n * d;
            break;
          }
          case "number":
          {
            if (p1 < 0) {
              s = p1;
              p1 = -p1;
            }

            if (p1 % 1 === 0) {
              n = p1;
            } else if (p1 > 0) { // check for != 0, scale would become NaN (log(0)), which converges really slow

              if (p1 >= 1) {
                z = Math.pow(10, Math.floor(1 + Math.log(p1) / Math.LN10));
                p1 /= z;
              }

              // Using Farey Sequences
              // http://www.johndcook.com/blog/2010/10/20/best-rational-approximation/

              while (B <= N && D <= N) {
                M = (A + C) / (B + D);

                if (p1 === M) {
                  if (B + D <= N) {
                    n = A + C;
                    d = B + D;
                  } else if (D > B) {
                    n = C;
                    d = D;
                  } else {
                    n = A;
                    d = B;
                  }
                  break;

                } else {

                  if (p1 > M) {
                    A += C;
                    B += D;
                  } else {
                    C += A;
                    D += B;
                  }

                  if (B > N) {
                    n = C;
                    d = D;
                  } else {
                    n = A;
                    d = B;
                  }
                }
              }
              n *= z;
            } else if (isNaN(p1) || isNaN(p2)) {
              d = n = NaN;
            }
            break;
          }
          case "string":
          {
            B = p1.match(/\d+|./g);

            if (B === null)
              throwInvalidParam();

            if (B[A] === '-') {// Check for minus sign at the beginning
              s = -1;
              A++;
            } else if (B[A] === '+') {// Check for plus sign at the beginning
              A++;
            }

            if (B.length === A + 1) { // Check if it's just a simple number "1234"
              w = assign(B[A++], s);
            } else if (B[A + 1] === '.' || B[A] === '.') { // Check if it's a decimal number

              if (B[A] !== '.') { // Handle 0.5 and .5
                v = assign(B[A++], s);
              }
              A++;

              // Check for decimal places
              if (A + 1 === B.length || B[A + 1] === '(' && B[A + 3] === ')' || B[A + 1] === "'" && B[A + 3] === "'") {
                w = assign(B[A], s);
                y = Math.pow(10, B[A].length);
                A++;
              }

              // Check for repeating places
              if (B[A] === '(' && B[A + 2] === ')' || B[A] === "'" && B[A + 2] === "'") {
                x = assign(B[A + 1], s);
                z = Math.pow(10, B[A + 1].length) - 1;
                A += 3;
              }

            } else if (B[A + 1] === '/' || B[A + 1] === ':') { // Check for a simple fraction "123/456" or "123:456"
              w = assign(B[A], s);
              y = assign(B[A + 2], 1);
              A += 3;
            } else if (B[A + 3] === '/' && B[A + 1] === ' ') { // Check for a complex fraction "123 1/2"
              v = assign(B[A], s);
              w = assign(B[A + 2], s);
              y = assign(B[A + 4], 1);
              A += 5;
            }

            if (B.length <= A) { // Check for more tokens on the stack
              d = y * z;
              s = /* void */
                      n = x + d * v + z * w;
              break;
            }

            /* Fall through on error */
          }
          default:
            throwInvalidParam();
        }

      if (d === 0) {
        throw new DivisionByZero();
      }

      P["s"] = s < 0 ? -1 : 1;
      P["n"] = Math.abs(n);
      P["d"] = Math.abs(d);
    };

    function modpow(b, e, m) {

      var r = 1;
      for (; e > 0; b = (b * b) % m, e >>= 1) {

        if (e & 1) {
          r = (r * b) % m;
        }
      }
      return r;
    }


    function cycleLen(n, d) {

      for (; d % 2 === 0;
              d /= 2) {
      }

      for (; d % 5 === 0;
              d /= 5) {
      }

      if (d === 1) // Catch non-cyclic numbers
        return 0;

      // If we would like to compute really large numbers quicker, we could make use of Fermat's little theorem:
      // 10^(d-1) % d == 1
      // However, we don't need such large numbers and MAX_CYCLE_LEN should be the capstone,
      // as we want to translate the numbers to strings.

      var rem = 10 % d;
      var t = 1;

      for (; rem !== 1; t++) {
        rem = rem * 10 % d;

        if (t > MAX_CYCLE_LEN)
          return 0; // Returning 0 here means that we don't print it as a cyclic number. It's likely that the answer is `d-1`
      }
      return t;
    }


       function cycleStart(n, d, len) {

      var rem1 = 1;
      var rem2 = modpow(10, len, d);

      for (var t = 0; t < 300; t++) { // s < ~log10(Number.MAX_VALUE)
        // Solve 10^s == 10^(s+t) (mod d)

        if (rem1 === rem2)
          return t;

        rem1 = rem1 * 10 % d;
        rem2 = rem2 * 10 % d;
      }
      return 0;
    }

    function gcd(a, b) {

      if (!a)
        return b;
      if (!b)
        return a;

      while (1) {
        a %= b;
        if (!a)
          return b;
        b %= a;
        if (!b)
          return a;
      }
    }
    /**
     * Module constructor
     *
     * @constructor
     * @param {number|Fraction=} a
     * @param {number=} b
     */
    function Fraction(a, b) {

      if (!(this instanceof Fraction)) {
        return new Fraction(a, b);
      }

      parse(a, b);

      if (Fraction['REDUCE']) {
        a = gcd(P["d"], P["n"]); // Abuse a
      } else {
        a = 1;
      }

      this["s"] = P["s"];
      this["n"] = P["n"] / a;
      this["d"] = P["d"] / a;
    }

    /**
     * Boolean global variable to be able to disable automatic reduction of the fraction
     *
     */
    Fraction['REDUCE'] = 1;

    Fraction.prototype = {

      "s": 1,
      "n": 0,
      "d": 1,

      /**
       * Calculates the absolute value
       *
       * Ex: new Fraction(-4).abs() => 4
       **/
      "abs": function() {

        return new Fraction(this["n"], this["d"]);
      },

      /**
       * Inverts the sign of the current fraction
       *
       * Ex: new Fraction(-4).neg() => 4
       **/
      "neg": function() {

        return new Fraction(-this["s"] * this["n"], this["d"]);
      },

      /**
       * Adds two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
       **/
      "add": function(a, b) {

        parse(a, b);
        return new Fraction(
                this["s"] * this["n"] * P["d"] + P["s"] * this["d"] * P["n"],
                this["d"] * P["d"]
                );
      },

      /**
       * Subtracts two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
       **/
      "sub": function(a, b) {

        parse(a, b);
        return new Fraction(
                this["s"] * this["n"] * P["d"] - P["s"] * this["d"] * P["n"],
                this["d"] * P["d"]
                );
      },

      /**
       * Multiplies two rational numbers
       *
       * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
       **/
      "mul": function(a, b) {

        parse(a, b);
        return new Fraction(
                this["s"] * P["s"] * this["n"] * P["n"],
                this["d"] * P["d"]
                );
      },

      /**
       * Divides two rational numbers
       *
       * Ex: new Fraction("-17.(345)").inverse().div(3)
       **/
      "div": function(a, b) {

        parse(a, b);
        return new Fraction(
                this["s"] * P["s"] * this["n"] * P["d"],
                this["d"] * P["n"]
                );
      },

      /**
       * Clones the actual object
       *
       * Ex: new Fraction("-17.(345)").clone()
       **/
      "clone": function() {
        return new Fraction(this);
      },

      /**
       * Calculates the modulo of two rational numbers - a more precise fmod
       *
       * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
       **/
      "mod": function(a, b) {

        if (isNaN(this['n']) || isNaN(this['d'])) {
          return new Fraction(NaN);
        }

        if (a === undefined) {
          return new Fraction(this["s"] * this["n"] % this["d"], 1);
        }

        parse(a, b);
        if (0 === P["n"] && 0 === this["d"]) {
          Fraction(0, 0); // Throw DivisionByZero
        }

        /*
         * First silly attempt, kinda slow
         *
         return that["sub"]({
         "n": num["n"] * Math.floor((this.n / this.d) / (num.n / num.d)),
         "d": num["d"],
         "s": this["s"]
         });*/

        /*
         * New attempt: a1 / b1 = a2 / b2 * q + r
         * => b2 * a1 = a2 * b1 * q + b1 * b2 * r
         * => (b2 * a1 % a2 * b1) / (b1 * b2)
         */
        return new Fraction(
                this["s"] * (P["d"] * this["n"]) % (P["n"] * this["d"]),
                P["d"] * this["d"]
                );
      },

      /**
       * Calculates the fractional gcd of two rational numbers
       *
       * Ex: new Fraction(5,8).gcd(3,7) => 1/56
       */
      "gcd": function(a, b) {

        parse(a, b);

        // gcd(a / b, c / d) = gcd(a, c) / lcm(b, d)

        return new Fraction(gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]), P["d"] * this["d"]);
      },

      /**
       * Calculates the fractional lcm of two rational numbers
       *
       * Ex: new Fraction(5,8).lcm(3,7) => 15
       */
      "lcm": function(a, b) {

        parse(a, b);

        // lcm(a / b, c / d) = lcm(a, c) / gcd(b, d)

        if (P["n"] === 0 && this["n"] === 0) {
          return new Fraction;
        }
        return new Fraction(P["n"] * this["n"], gcd(P["n"], this["n"]) * gcd(P["d"], this["d"]));
      },

      /**
       * Calculates the ceil of a rational number
       *
       * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
       **/
      "ceil": function(places) {

        places = Math.pow(10, places || 0);

        if (isNaN(this["n"]) || isNaN(this["d"])) {
          return new Fraction(NaN);
        }
        return new Fraction(Math.ceil(places * this["s"] * this["n"] / this["d"]), places);
      },

      /**
       * Calculates the floor of a rational number
       *
       * Ex: new Fraction('4.(3)').floor() => (4 / 1)
       **/
      "floor": function(places) {

        places = Math.pow(10, places || 0);

        if (isNaN(this["n"]) || isNaN(this["d"])) {
          return new Fraction(NaN);
        }
        return new Fraction(Math.floor(places * this["s"] * this["n"] / this["d"]), places);
      },

      /**
       * Rounds a rational numbers
       *
       * Ex: new Fraction('4.(3)').round() => (4 / 1)
       **/
      "round": function(places) {

        places = Math.pow(10, places || 0);

        if (isNaN(this["n"]) || isNaN(this["d"])) {
          return new Fraction(NaN);
        }
        return new Fraction(Math.round(places * this["s"] * this["n"] / this["d"]), places);
      },

      /**
       * Gets the inverse of the fraction, means numerator and denumerator are exchanged
       *
       * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
       **/
      "inverse": function() {

        return new Fraction(this["s"] * this["d"], this["n"]);
      },

      /**
       * Calculates the fraction to some integer exponent
       *
       * Ex: new Fraction(-1,2).pow(-3) => -8
       */
      "pow": function(m) {

        if (m < 0) {
          return new Fraction(Math.pow(this['s'] * this["d"], -m), Math.pow(this["n"], -m));
        } else {
          return new Fraction(Math.pow(this['s'] * this["n"], m), Math.pow(this["d"], m));
        }
      },

      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      "equals": function(a, b) {

        parse(a, b);
        return this["s"] * this["n"] * P["d"] === P["s"] * P["n"] * this["d"]; // Same as compare() === 0
      },

      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      "compare": function(a, b) {

        parse(a, b);
        var t = (this["s"] * this["n"] * P["d"] - P["s"] * P["n"] * this["d"]);
        return (0 < t) - (t < 0);
      },
      
      "simplify": function(eps) {
        
        // First naive implementation, needs improvement
        
        if (isNaN(this['n']) || isNaN(this['d'])) {
          return this;
        }

        var cont = this['abs']()['toContinued']();
        
        eps = eps || 0.001;
        
        function rec(a) {
          if (a.length === 1)
            return new Fraction(a[0]);
          return rec(a.slice(1))['inverse']()['add'](a[0]);
        }
        
        for (var i = 0; i < cont.length; i++) {
          var tmp = rec(cont.slice(0, i + 1));
          if (tmp['sub'](this['abs']())['abs']().valueOf() < eps) {
            return tmp['mul'](this['s']);
          }
        }
        return this;
      },

      /**
       * Check if two rational numbers are divisible
       *
       * Ex: new Fraction(19.6).divisible(1.5);
       */
      "divisible": function(a, b) {

        parse(a, b);
        return !(!(P["n"] * this["d"]) || ((this["n"] * P["d"]) % (P["n"] * this["d"])));
      },

      /**
       * Returns a decimal representation of the fraction
       *
       * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
       **/
      'valueOf': function() {

        return this["s"] * this["n"] / this["d"];
      },

      /**
       * Returns a string-fraction representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toFraction() => "4 1/3"
       **/
      'toFraction': function(excludeWhole) {

        var whole, str = "";
        var n = this["n"];
        var d = this["d"];
        if (this["s"] < 0) {
          str += '-';
        }

        if (d === 1) {
          str += n;
        } else {

          if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
            str += whole;
            str += " ";
            n %= d;
          }

          str += n;
          str += '/';
          str += d;
        }
        return str;
      },

      /**
       * Returns a latex representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
       **/
      'toLatex': function(excludeWhole) {

        var whole, str = "";
        var n = this["n"];
        var d = this["d"];
        if (this["s"] < 0) {
          str += '-';
        }

        if (d === 1) {
          str += n;
        } else {

          if (excludeWhole && (whole = Math.floor(n / d)) > 0) {
            str += whole;
            n %= d;
          }

          str += "\\frac{";
          str += n;
          str += '}{';
          str += d;
          str += '}';
        }
        return str;
      },

      /**
       * Returns an array of continued fraction elements
       *
       * Ex: new Fraction("7/8").toContinued() => [0,1,7]
       */
      'toContinued': function() {

        var t;
        var a = this['n'];
        var b = this['d'];
        var res = [];

        if (isNaN(this['n']) || isNaN(this['d'])) {
          return res;
        }

        do {
          res.push(Math.floor(a / b));
          t = a % b;
          a = b;
          b = t;
        } while (a !== 1);

        return res;
      },

      /**
       * Creates a string representation of a fraction with all digits
       *
       * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
       **/
      'toString': function() {

        var g;
        var N = this["n"];
        var D = this["d"];

        if (isNaN(N) || isNaN(D)) {
          return "NaN";
        }

        if (!Fraction['REDUCE']) {
          g = gcd(N, D);
          N /= g;
          D /= g;
        }

        var dec = 15; // 15 = decimal places when no repitation

        var cycLen = cycleLen(N, D); // Cycle length
        var cycOff = cycleStart(N, D, cycLen); // Cycle start

        var str = this['s'] === -1 ? "-" : "";

        str += N / D | 0;

        N %= D;
        N *= 10;

        if (N)
          str += ".";

        if (cycLen) {

          for (var i = cycOff; i--; ) {
            str += N / D | 0;
            N %= D;
            N *= 10;
          }
          str += "(";
          for (var i = cycLen; i--; ) {
            str += N / D | 0;
            N %= D;
            N *= 10;
          }
          str += ")";
        } else {
          for (var i = dec; N && i--; ) {
            str += N / D | 0;
            N %= D;
            N *= 10;
          }
        }
        return str;
      }
    };

    if (typeof undefined === "function" && undefined["amd"]) {
      undefined([], function() {
        return Fraction;
      });
    } else {
      Object.defineProperty(exports, "__esModule", {'value': true});
      Fraction['default'] = Fraction;
      Fraction['Fraction'] = Fraction;
      module['exports'] = Fraction;
    }

  })(commonjsGlobal);
  });

  unwrapExports(fraction);

  /**
   * Attach type information
   */
  fraction.prototype.type = 'Fraction';
  fraction.prototype.isFraction = true;

  /**
   * Get a JSON representation of a Fraction containing type information
   * @returns {Object} Returns a JSON object structured as:
   *                   `{"mathjs": "Fraction", "n": 3, "d": 8}`
   */
  fraction.prototype.toJSON = function () {
    return {
      mathjs: 'Fraction',
      n: this.s * this.n,
      d: this.d
    };
  };

  /**
   * Instantiate a Fraction from a JSON object
   * @param {Object} json  a JSON object structured as:
   *                       `{"mathjs": "Fraction", "n": 3, "d": 8}`
   * @return {BigNumber}
   */
  fraction.fromJSON = function (json) {
    return new fraction(json);
  };


  function factory$9 (type, config, load, typed) {
    return fraction;
  }

  var name$9 = 'Fraction';
  var path$3 = 'type';
  var factory_1$9 = factory$9;

  var Fraction_1 = {
  	name: name$9,
  	path: path$3,
  	factory: factory_1$9
  };

  function factory$10 (type, config, load, typed) {
    /**
     * Create a fraction convert a value to a fraction.
     *
     * Syntax:
     *     math.fraction(numerator, denominator)
     *     math.fraction({n: numerator, d: denominator})
     *     math.fraction(matrix: Array | Matrix)         Turn all matrix entries
     *                                                   into fractions
     *
     * Examples:
     *
     *     math.fraction(1, 3);
     *     math.fraction('2/3');
     *     math.fraction({n: 2, d: 3});
     *     math.fraction([0.2, 0.25, 1.25]);
     *
     * See also:
     *
     *    bignumber, number, string, unit
     *
     * @param {number | string | Fraction | BigNumber | Array | Matrix} [args]
     *            Arguments specifying the numerator and denominator of
     *            the fraction
     * @return {Fraction | Array | Matrix} Returns a fraction
     */
    var fraction = typed('fraction', {
      'number': function (x) {
        if (!isFinite(x) || isNaN(x)) {
          throw new Error(x + ' cannot be represented as a fraction');
        }

        return new type.Fraction(x);
      },

      'string': function (x) {
        return new type.Fraction(x);
      },

      'number, number': function (numerator, denominator) {
        return new type.Fraction(numerator, denominator);
      },

      'null': function (x) {
        return new type.Fraction(0);
      },

      'BigNumber': function (x) {
        return new type.Fraction(x.toString());
      },

      'Fraction': function (x) {
        return x; // fractions are immutable
      },

      'Object': function (x) {
        return new type.Fraction(x);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, fraction);
      }
    });

    return fraction;
  }

  var name$10 = 'fraction';
  var factory_1$10 = factory$10;

  var fraction$2 = {
  	name: name$10,
  	factory: factory_1$10
  };

  var fraction$3 = [
    // type
    Fraction_1,

    // construction function
    fraction$2
  ];

  /**
   * Create a range error with the message:
   *     'Dimension mismatch (<actual size> != <expected size>)'
   * @param {number | number[]} actual        The actual size
   * @param {number | number[]} expected      The expected size
   * @param {string} [relation='!=']          Optional relation between actual
   *                                          and expected size: '!=', '<', etc.
   * @extends RangeError
   */
  function DimensionError(actual, expected, relation) {
    if (!(this instanceof DimensionError)) {
      throw new SyntaxError('Constructor must be called with the new operator');
    }

    this.actual   = actual;
    this.expected = expected;
    this.relation = relation;

    this.message = 'Dimension mismatch (' +
        (Array.isArray(actual) ? ('[' + actual.join(', ') + ']') : actual) +
        ' ' + (this.relation || '!=') + ' ' +
        (Array.isArray(expected) ? ('[' + expected.join(', ') + ']') : expected) +
        ')';

    this.stack = (new Error()).stack;
  }

  DimensionError.prototype = new RangeError();
  DimensionError.prototype.constructor = RangeError;
  DimensionError.prototype.name = 'DimensionError';
  DimensionError.prototype.isDimensionError = true;

  var DimensionError_1 = DimensionError;

  /**
   * Create a range error with the message:
   *     'Index out of range (index < min)'
   *     'Index out of range (index < max)'
   *
   * @param {number} index     The actual index
   * @param {number} [min=0]   Minimum index (included)
   * @param {number} [max]     Maximum index (excluded)
   * @extends RangeError
   */
  function IndexError(index, min, max) {
    if (!(this instanceof IndexError)) {
      throw new SyntaxError('Constructor must be called with the new operator');
    }

    this.index = index;
    if (arguments.length < 3) {
      this.min = 0;
      this.max = min;
    }
    else {
      this.min = min;
      this.max = max;
    }

    if (this.min !== undefined && this.index < this.min) {
      this.message = 'Index out of range (' + this.index + ' < ' + this.min + ')';
    }
    else if (this.max !== undefined && this.index >= this.max) {
      this.message = 'Index out of range (' + this.index + ' > ' + (this.max - 1) + ')';
    }
    else {
      this.message = 'Index out of range (' + this.index + ')';
    }

    this.stack = (new Error()).stack;
  }

  IndexError.prototype = new RangeError();
  IndexError.prototype.constructor = RangeError;
  IndexError.prototype.name = 'IndexError';
  IndexError.prototype.isIndexError = true;

  var IndexError_1 = IndexError;

  var array = createCommonjsModule(function (module, exports) {







  /**
   * Calculate the size of a multi dimensional array.
   * This function checks the size of the first entry, it does not validate
   * whether all dimensions match. (use function `validate` for that)
   * @param {Array} x
   * @Return {Number[]} size
   */
  exports.size = function (x) {
    var s = [];

    while (Array.isArray(x)) {
      s.push(x.length);
      x = x[0];
    }

    return s;
  };

  /**
   * Recursively validate whether each element in a multi dimensional array
   * has a size corresponding to the provided size array.
   * @param {Array} array    Array to be validated
   * @param {number[]} size  Array with the size of each dimension
   * @param {number} dim   Current dimension
   * @throws DimensionError
   * @private
   */
  function _validate(array, size, dim) {
    var i;
    var len = array.length;

    if (len != size[dim]) {
      throw new DimensionError_1(len, size[dim]);
    }

    if (dim < size.length - 1) {
      // recursively validate each child array
      var dimNext = dim + 1;
      for (i = 0; i < len; i++) {
        var child = array[i];
        if (!Array.isArray(child)) {
          throw new DimensionError_1(size.length - 1, size.length, '<');
        }
        _validate(array[i], size, dimNext);
      }
    }
    else {
      // last dimension. none of the childs may be an array
      for (i = 0; i < len; i++) {
        if (Array.isArray(array[i])) {
          throw new DimensionError_1(size.length + 1, size.length, '>');
        }
      }
    }
  }

  /**
   * Validate whether each element in a multi dimensional array has
   * a size corresponding to the provided size array.
   * @param {Array} array    Array to be validated
   * @param {number[]} size  Array with the size of each dimension
   * @throws DimensionError
   */
  exports.validate = function(array, size) {
    var isScalar = (size.length == 0);
    if (isScalar) {
      // scalar
      if (Array.isArray(array)) {
        throw new DimensionError_1(array.length, 0);
      }
    }
    else {
      // array
      _validate(array, size, 0);
    }
  };

  /**
   * Test whether index is an integer number with index >= 0 and index < length
   * when length is provided
   * @param {number} index    Zero-based index
   * @param {number} [length] Length of the array
   */
  exports.validateIndex = function(index, length) {
    if (!number.isNumber(index) || !number.isInteger(index)) {
      throw new TypeError('Index must be an integer (value: ' + index + ')');
    }
    if (index < 0 || (typeof length === 'number' && index >= length)) {
      throw new IndexError_1(index, length);
    }
  };

  /**
   * Resize a multi dimensional array. The resized array is returned.
   * @param {Array} array         Array to be resized
   * @param {Array.<number>} size Array with the size of each dimension
   * @param {*} [defaultValue=0]  Value to be filled in in new entries,
   *                              zero by default. Specify for example `null`,
   *                              to clearly see entries that are not explicitly
   *                              set.
   * @return {Array} array         The resized array
   */
  exports.resize = function(array, size, defaultValue) {
    // TODO: add support for scalars, having size=[] ?

    // check the type of the arguments
    if (!Array.isArray(array) || !Array.isArray(size)) {
      throw new TypeError('Array expected');
    }
    if (size.length === 0) {
      throw new Error('Resizing to scalar is not supported');
    }

    // check whether size contains positive integers
    size.forEach(function (value) {
      if (!number.isNumber(value) || !number.isInteger(value) || value < 0) {
        throw new TypeError('Invalid size, must contain positive integers ' +
            '(size: ' + string.format(size) + ')');
      }
    });

    // recursively resize the array
    var _defaultValue = (defaultValue !== undefined) ? defaultValue : 0;
    _resize(array, size, 0, _defaultValue);

    return array;
  };

  /**
   * Recursively resize a multi dimensional array
   * @param {Array} array         Array to be resized
   * @param {number[]} size       Array with the size of each dimension
   * @param {number} dim          Current dimension
   * @param {*} [defaultValue]    Value to be filled in in new entries,
   *                              undefined by default.
   * @private
   */
  function _resize (array, size, dim, defaultValue) {
    var i;
    var elem;
    var oldLen = array.length;
    var newLen = size[dim];
    var minLen = Math.min(oldLen, newLen);

    // apply new length
    array.length = newLen;

    if (dim < size.length - 1) {
      // non-last dimension
      var dimNext = dim + 1;

      // resize existing child arrays
      for (i = 0; i < minLen; i++) {
        // resize child array
        elem = array[i];
        if (!Array.isArray(elem)) {
          elem = [elem]; // add a dimension
          array[i] = elem;
        }
        _resize(elem, size, dimNext, defaultValue);
      }

      // create new child arrays
      for (i = minLen; i < newLen; i++) {
        // get child array
        elem = [];
        array[i] = elem;

        // resize new child array
        _resize(elem, size, dimNext, defaultValue);
      }
    }
    else {
      // last dimension

      // remove dimensions of existing values
      for (i = 0; i < minLen; i++) {
        while (Array.isArray(array[i])) {
          array[i] = array[i][0];
        }
      }

      // fill new elements with the default value
      for (i = minLen; i < newLen; i++) {
        array[i] = defaultValue;
      }
    }
  }

  /**
   * Re-shape a multi dimensional array to fit the specified dimensions
   * @param {Array} array           Array to be reshaped
   * @param {Array.<number>} sizes  List of sizes for each dimension
   * @returns {Array}               Array whose data has been formatted to fit the
   *                                specified dimensions
   *
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */
  exports.reshape = function(array, sizes) {
    var flatArray = exports.flatten(array);
    var newArray;

    var product = function (arr) {
      return arr.reduce(function (prev, curr) {
        return prev * curr;
      });
    };

    if (!Array.isArray(array) || !Array.isArray(sizes)) {
      throw new TypeError('Array expected');
    }

    if (sizes.length === 0) {
      throw new DimensionError_1(0, product(exports.size(array)), '!=');
    }

    try {
      newArray  = _reshape(flatArray, sizes);
    } catch (e) {
      if (e instanceof DimensionError_1) {
        throw new DimensionError_1(
          product(sizes),
          product(exports.size(array)),
          '!='
        );
      }
      throw e;
    }

    if (flatArray.length > 0) {
      throw new DimensionError_1(
        product(sizes),
        product(exports.size(array)),
        '!='
      );
    }

    return newArray;
  };

  /**
   * Recursively re-shape a multi dimensional array to fit the specified dimensions
   * @param {Array} array           Array to be reshaped
   * @param {Array.<number>} sizes  List of sizes for each dimension
   * @returns {Array}               Array whose data has been formatted to fit the
   *                                specified dimensions
   *
   * @throws {DimensionError}       If the product of the new dimension sizes does
   *                                not equal that of the old ones
   */
  function _reshape(array, sizes) {
    var accumulator = [];
    var i;

    if (sizes.length === 0) {
      if (array.length === 0) {
        throw new DimensionError_1(null, null, '!=');
      }
      return array.shift();
    }
    for (i = 0; i < sizes[0]; i += 1) {
      accumulator.push(_reshape(array, sizes.slice(1)));
    }
    return accumulator;
  }


  /**
   * Squeeze a multi dimensional array
   * @param {Array} array
   * @param {Array} [size]
   * @returns {Array} returns the array itself
   */
  exports.squeeze = function(array, size) {
    var s = size || exports.size(array);

    // squeeze outer dimensions
    while (Array.isArray(array) && array.length === 1) {
      array = array[0];
      s.shift();
    }

    // find the first dimension to be squeezed
    var dims = s.length;
    while (s[dims - 1] === 1) {
      dims--;
    }

    // squeeze inner dimensions
    if (dims < s.length) {
      array = _squeeze(array, dims, 0);
      s.length = dims;
    }

    return array;
  };

  /**
   * Recursively squeeze a multi dimensional array
   * @param {Array} array
   * @param {number} dims Required number of dimensions
   * @param {number} dim  Current dimension
   * @returns {Array | *} Returns the squeezed array
   * @private
   */
  function _squeeze (array, dims, dim) {
    var i, ii;

    if (dim < dims) {
      var next = dim + 1;
      for (i = 0, ii = array.length; i < ii; i++) {
        array[i] = _squeeze(array[i], dims, next);
      }
    }
    else {
      while (Array.isArray(array)) {
        array = array[0];
      }
    }

    return array;
  }

  /**
   * Unsqueeze a multi dimensional array: add dimensions when missing
   * 
   * Paramter `size` will be mutated to match the new, unqueezed matrix size.
   * 
   * @param {Array} array
   * @param {number} dims     Desired number of dimensions of the array
   * @param {number} [outer]  Number of outer dimensions to be added
   * @param {Array} [size]    Current size of array.
   * @returns {Array} returns the array itself
   * @private
   */
  exports.unsqueeze = function(array, dims, outer, size) {
    var s = size || exports.size(array);

    // unsqueeze outer dimensions
    if (outer) {
      for (var i = 0; i < outer; i++) {
        array = [array];
        s.unshift(1);
      }
    }

    // unsqueeze inner dimensions
    array = _unsqueeze(array, dims, 0);
    while (s.length < dims) {
      s.push(1);
    }

    return array;
  };

  /**
   * Recursively unsqueeze a multi dimensional array
   * @param {Array} array
   * @param {number} dims Required number of dimensions
   * @param {number} dim  Current dimension
   * @returns {Array | *} Returns the squeezed array
   * @private
   */
  function _unsqueeze (array, dims, dim) {
    var i, ii;

    if (Array.isArray(array)) {
      var next = dim + 1;
      for (i = 0, ii = array.length; i < ii; i++) {
        array[i] = _unsqueeze(array[i], dims, next);
      }
    }
    else {
      for (var d = dim; d < dims; d++) {
        array = [array];
      }
    }

    return array;
  }
  /**
   * Flatten a multi dimensional array, put all elements in a one dimensional
   * array
   * @param {Array} array   A multi dimensional array
   * @return {Array}        The flattened array (1 dimensional)
   */
  exports.flatten = function(array) {
    if (!Array.isArray(array)) {
      //if not an array, return as is
      return array;
    }
    var flat = [];

    array.forEach(function callback(value) {
      if (Array.isArray(value)) {
        value.forEach(callback);  //traverse through sub-arrays recursively
      }
      else {
        flat.push(value);
      }
    });

    return flat;
  };

  /**
   * A safe map
   * @param {Array} array
   * @param {function} callback
   */
  exports.map = function (array, callback) {
    return Array.prototype.map.call(array, callback);
  };

  /**
   * A safe forEach
   * @param {Array} array
   * @param {function} callback
   */
  exports.forEach = function (array, callback) {
    Array.prototype.forEach.call(array, callback);
  };

  /**
   * A safe filter
   * @param {Array} array
   * @param {function} callback
   */
  exports.filter = function (array, callback) {
    if (exports.size(array).length !== 1) {
      throw new Error('Only one dimensional matrices supported');
    }

    return Array.prototype.filter.call(array, callback);
  };

  /**
   * Filter values in a callback given a regular expression
   * @param {Array} array
   * @param {RegExp} regexp
   * @return {Array} Returns the filtered array
   * @private
   */
  exports.filterRegExp = function (array, regexp) {
    if (exports.size(array).length !== 1) {
      throw new Error('Only one dimensional matrices supported');
    }

    return Array.prototype.filter.call(array, function (entry) {
      return regexp.test(entry);
    });
  };

  /**
   * A safe join
   * @param {Array} array
   * @param {string} separator
   */
  exports.join = function (array, separator) {
    return Array.prototype.join.call(array, separator);
  };

  /**
   * Assign a numeric identifier to every element of a sorted array
   * @param {Array}	a  An array
   * @return {Array}	An array of objects containing the original value and its identifier
   */
  exports.identify = function(a) {
    if (!Array.isArray(a)) {
  	throw new TypeError('Array input expected');
    }
  	
    if (a.length === 0) {
  	return a;
    }
  	
    var b = [];
    var count = 0;
    b[0] = {value: a[0], identifier: 0};
    for (var i=1; i<a.length; i++) {
      if (a[i] === a[i-1]) {
    	count++;
      }
      else {
        count = 0;
      }
      b.push({value: a[i], identifier: count});
    }
    return b;
  };

  /**
   * Remove the numeric identifier from the elements
   * @param	a  An array
   * @return	An array of values without identifiers
   */
  exports.generalize = function(a) {
    if (!Array.isArray(a)) {
  	throw new TypeError('Array input expected');
    }
  	
    if (a.length === 0) {
  	return a;
    }
  	
    var b = [];
    for (var i=0; i<a.length; i++) {
      b.push(a[i].value);
    }
    return b;
  };

  /**
   * Test whether an object is an array
   * @param {*} value
   * @return {boolean} isArray
   */
  exports.isArray = Array.isArray;
  });
  var array_1 = array.size;
  var array_2 = array.validate;
  var array_3 = array.validateIndex;
  var array_4 = array.resize;
  var array_5 = array.reshape;
  var array_6 = array.squeeze;
  var array_7 = array.unsqueeze;
  var array_8 = array.flatten;
  var array_9 = array.map;
  var array_10 = array.forEach;
  var array_11 = array.filter;
  var array_12 = array.filterRegExp;
  var array_13 = array.join;
  var array_14 = array.identify;
  var array_15 = array.generalize;
  var array_16 = array.isArray;

  /**
   * Test whether value is a boolean
   * @param {*} value
   * @return {boolean} isBoolean
   */
  var isBoolean = function(value) {
    return typeof value == 'boolean';
  };

  var boolean_1$1 = {
  	isBoolean: isBoolean
  };

  // function utils

  /**
   * Memoize a given function by caching the computed result.
   * The cache of a memoized function can be cleared by deleting the `cache`
   * property of the function.
   *
   * @param {function} fn                     The function to be memoized.
   *                                          Must be a pure function.
   * @param {function(args: Array)} [hasher]  A custom hash builder.
   *                                          Is JSON.stringify by default.
   * @return {function}                       Returns the memoized function
   */
  var memoize = function(fn, hasher) {
    return function memoize() {
      if (typeof memoize.cache !== 'object') {
        memoize.cache = {};
      }

      var args = [];
      for (var i = 0; i < arguments.length; i++) {
        args[i] = arguments[i];
      }

      var hash = hasher ? hasher(args) : JSON.stringify(args);
      if (!(hash in memoize.cache)) {
        return memoize.cache[hash] = fn.apply(fn, args);
      }
      return memoize.cache[hash];
    };
  };

  /**
   * Find the maximum number of arguments expected by a typed function.
   * @param {function} fn   A typed function
   * @return {number} Returns the maximum number of expected arguments.
   *                  Returns -1 when no signatures where found on the function.
   */
  var maxArgumentCount = function (fn) {
    return Object.keys(fn.signatures || {})
        .reduce(function (args, signature) {
          var count = (signature.match(/,/g) || []).length + 1;
          return Math.max(args, count);
        }, -1);
  };

  /**
   * Call a typed function with the
   * @param {function} fn   A function or typed function
   * @return {number} Returns the maximum number of expected arguments.
   *                  Returns -1 when no signatures where found on the function.
   */
  var callWithRightArgumentCount = function (fn, args, argCount) {
    return Object.keys(fn.signatures || {})
        .reduce(function (args, signature) {
          var count = (signature.match(/,/g) || []).length + 1;
          return Math.max(args, count);
        }, -1);
  };

  var _function = {
  	memoize: memoize,
  	maxArgumentCount: maxArgumentCount,
  	callWithRightArgumentCount: callWithRightArgumentCount
  };

  var utils = createCommonjsModule(function (module, exports) {

  exports.array = array;
  exports['boolean'] = boolean_1$1;
  exports['function'] = _function;
  exports.number = number;
  exports.object = object;
  exports.string = string;
  exports.emitter = emitter;
  });
  var utils_1 = utils.array;
  var utils_2 = utils.number;
  var utils_3 = utils.object;
  var utils_4 = utils.string;
  var utils_5 = utils.emitter;

  var string$1 = utils.string;

  var isString = string$1.isString;

  function factory$11 (type, config, load, typed) {
    /**
     * @constructor Matrix
     *
     * A Matrix is a wrapper around an Array. A matrix can hold a multi dimensional
     * array. A matrix can be constructed as:
     *     var matrix = math.matrix(data)
     *
     * Matrix contains the functions to resize, get and set values, get the size,
     * clone the matrix and to convert the matrix to a vector, array, or scalar.
     * Furthermore, one can iterate over the matrix using map and forEach.
     * The internal Array of the Matrix can be accessed using the function valueOf.
     *
     * Example usage:
     *     var matrix = math.matrix([[1, 2], [3, 4]]);
     *     matix.size();              // [2, 2]
     *     matrix.resize([3, 2], 5);
     *     matrix.valueOf();          // [[1, 2], [3, 4], [5, 5]]
     *     matrix.subset([1,2])       // 3 (indexes are zero-based)
     *
     */
    function Matrix() {
      if (!(this instanceof Matrix)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }
    }

    /**
     * Attach type information
     */
    Matrix.prototype.type = 'Matrix';
    Matrix.prototype.isMatrix = true;

    /**
     * Get the Matrix storage constructor for the given format.
     *
     * @param {string} format       The Matrix storage format.
     *
     * @return {Function}           The Matrix storage constructor.
     */
    Matrix.storage = function (format) {
      // check storage format is a string
      if (!isString(format)) {
        throw new TypeError('format must be a string value');
      }

      // get storage format constructor
      var constructor = Matrix._storage[format];
      if (!constructor) {
        throw new SyntaxError('Unsupported matrix storage format: ' + format);
      }

      // return storage constructor
      return constructor;
    };

    // a map with all constructors for all storage types
    Matrix._storage = {};

    /**
     * Get the storage format used by the matrix.
     *
     * Usage:
     *     var format = matrix.storage()                   // retrieve storage format
     *
     * @return {string}           The storage format.
     */
    Matrix.prototype.storage = function () {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke storage on a Matrix interface');
    };
    
    /**
     * Get the datatype of the data stored in the matrix.
     *
     * Usage:
     *     var format = matrix.datatype()                   // retrieve matrix datatype
     *
     * @return {string}           The datatype.
     */
    Matrix.prototype.datatype = function () {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke datatype on a Matrix interface');
    };

    /**
     * Create a new Matrix With the type of the current matrix instance
     * @param {Array | Object} data
     * @param {string} [datatype]
     */
    Matrix.prototype.create = function (data, datatype) {
      throw new Error('Cannot invoke create on a Matrix interface');
    };

    /**
     * Get a subset of the matrix, or replace a subset of the matrix.
     *
     * Usage:
     *     var subset = matrix.subset(index)               // retrieve subset
     *     var value = matrix.subset(index, replacement)   // replace subset
     *
     * @param {Index} index
     * @param {Array | Matrix | *} [replacement]
     * @param {*} [defaultValue=0]      Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be filled with zeros.
     */
    Matrix.prototype.subset = function (index, replacement, defaultValue) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke subset on a Matrix interface');
    };

    /**
     * Get a single element from the matrix.
     * @param {number[]} index   Zero-based index
     * @return {*} value
     */
    Matrix.prototype.get = function (index) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke get on a Matrix interface');
    };

    /**
     * Replace a single element in the matrix.
     * @param {number[]} index   Zero-based index
     * @param {*} value
     * @param {*} [defaultValue]        Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be left undefined.
     * @return {Matrix} self
     */
    Matrix.prototype.set = function (index, value, defaultValue) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke set on a Matrix interface');
    };

    /**
     * Resize the matrix to the given size. Returns a copy of the matrix when 
     * `copy=true`, otherwise return the matrix itself (resize in place).
     *
     * @param {number[]} size           The new size the matrix should have.
     * @param {*} [defaultValue=0]      Default value, filled in on new entries.
     *                                  If not provided, the matrix elements will
     *                                  be filled with zeros.
     * @param {boolean} [copy]          Return a resized copy of the matrix
     *
     * @return {Matrix}                 The resized matrix
     */
    Matrix.prototype.resize = function (size, defaultValue) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke resize on a Matrix interface');
    };

    /**
     * Reshape the matrix to the given size. Returns a copy of the matrix when
     * `copy=true`, otherwise return the matrix itself (reshape in place).
     *
     * @param {number[]} size           The new size the matrix should have.
     * @param {boolean} [copy]          Return a reshaped copy of the matrix
     *
     * @return {Matrix}                 The reshaped matrix
     */
    Matrix.prototype.reshape = function (size, defaultValue) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke reshape on a Matrix interface');
    };

    /**
     * Create a clone of the matrix
     * @return {Matrix} clone
     */
    Matrix.prototype.clone = function () {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke clone on a Matrix interface');
    };

    /**
     * Retrieve the size of the matrix.
     * @returns {number[]} size
     */
    Matrix.prototype.size = function() {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke size on a Matrix interface');
    };

    /**
     * Create a new matrix with the results of the callback function executed on
     * each entry of the matrix.
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
     *
     * @return {Matrix} matrix
     */
    Matrix.prototype.map = function (callback, skipZeros) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke map on a Matrix interface');
    };

    /**
     * Execute a callback function on each entry of the matrix.
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     */
    Matrix.prototype.forEach = function (callback) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke forEach on a Matrix interface');
    };

    /**
     * Create an Array with a copy of the data of the Matrix
     * @returns {Array} array
     */
    Matrix.prototype.toArray = function () {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke toArray on a Matrix interface');
    };

    /**
     * Get the primitive value of the Matrix: a multidimensional array
     * @returns {Array} array
     */
    Matrix.prototype.valueOf = function () {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke valueOf on a Matrix interface');
    };

    /**
     * Get a string representation of the matrix, with optional formatting options.
     * @param {Object | number | Function} [options]  Formatting options. See
     *                                                lib/utils/number:format for a
     *                                                description of the available
     *                                                options.
     * @returns {string} str
     */
    Matrix.prototype.format = function (options) {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke format on a Matrix interface');
    };

    /**
     * Get a string representation of the matrix
     * @returns {string} str
     */
    Matrix.prototype.toString = function () {
      // must be implemented by each of the Matrix implementations
      throw new Error('Cannot invoke toString on a Matrix interface');
    };
     
    // exports
    return Matrix;
  }

  var name$11 = 'Matrix';
  var path$4 = 'type';
  var factory_1$11 = factory$11;

  var Matrix = {
  	name: name$11,
  	path: path$4,
  	factory: factory_1$11
  };

  var string$2 = utils.string;
  var array$1 = utils.array;
  var object$1 = utils.object;
  var number$1 = utils.number;

  var isArray = Array.isArray;
  var isNumber$1 = number$1.isNumber;
  var isInteger = number$1.isInteger;
  var isString$1 = string$2.isString;

  var validateIndex = array$1.validateIndex;

  function factory$12 (type, config, load, typed) {
    var Matrix$$1 = load(Matrix); // force loading Matrix (do not use via type.Matrix)

    /**
     * Dense Matrix implementation. A regular, dense matrix, supporting multi-dimensional matrices. This is the default matrix type.
     * @class DenseMatrix
     */
    function DenseMatrix(data, datatype) {
      if (!(this instanceof DenseMatrix))
        throw new SyntaxError('Constructor must be called with the new operator');
      if (datatype && !isString$1(datatype))
        throw new Error('Invalid datatype: ' + datatype);

      if (type.isMatrix(data)) {
        // check data is a DenseMatrix
        if (data.type === 'DenseMatrix') {
          // clone data & size
          this._data = object$1.clone(data._data);
          this._size = object$1.clone(data._size);
          this._datatype = datatype || data._datatype;
        }
        else {
          // build data from existing matrix
          this._data = data.toArray();
          this._size = data.size();
          this._datatype = datatype || data._datatype;
        }
      }
      else if (data && isArray(data.data) && isArray(data.size)) {
        // initialize fields from JSON representation
        this._data = data.data;
        this._size = data.size;
        this._datatype = datatype || data.datatype;
      }
      else if (isArray(data)) {
        // replace nested Matrices with Arrays
        this._data = preprocess(data);
        // get the dimensions of the array
        this._size = array$1.size(this._data);
        // verify the dimensions of the array, TODO: compute size while processing array
        array$1.validate(this._data, this._size);
        // data type unknown
        this._datatype = datatype;
      }
      else if (data) {
        // unsupported type
        throw new TypeError('Unsupported type of data (' + utils.types.type(data) + ')');
      }
      else {
        // nothing provided
        this._data = [];
        this._size = [0];
        this._datatype = datatype;
      }
    }
    
    DenseMatrix.prototype = new Matrix$$1();

    /**
     * Attach type information
     */
    DenseMatrix.prototype.type = 'DenseMatrix';
    DenseMatrix.prototype.isDenseMatrix = true;

    /**
     * Get the storage format used by the matrix.
     *
     * Usage:
     *     var format = matrix.storage()                   // retrieve storage format
     *
     * @memberof DenseMatrix
     * @return {string}           The storage format.
     */
    DenseMatrix.prototype.storage = function () {
      return 'dense';
    };

    /**
     * Get the datatype of the data stored in the matrix.
     *
     * Usage:
     *     var format = matrix.datatype()                   // retrieve matrix datatype
     *
     * @memberof DenseMatrix
     * @return {string}           The datatype.
     */
    DenseMatrix.prototype.datatype = function () {
      return this._datatype;
    };

    /**
     * Create a new DenseMatrix
     * @memberof DenseMatrix
     * @param {Array} data
     * @param {string} [datatype]
     */
    DenseMatrix.prototype.create = function (data, datatype) {
      return new DenseMatrix(data, datatype);
    };

    /**
     * Get a subset of the matrix, or replace a subset of the matrix.
     *
     * Usage:
     *     var subset = matrix.subset(index)               // retrieve subset
     *     var value = matrix.subset(index, replacement)   // replace subset
     *
     * @memberof DenseMatrix
     * @param {Index} index
     * @param {Array | DenseMatrix | *} [replacement]
     * @param {*} [defaultValue=0]      Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be filled with zeros.
     */
    DenseMatrix.prototype.subset = function (index, replacement, defaultValue) {
      switch (arguments.length) {
        case 1:
          return _get(this, index);

          // intentional fall through
        case 2:
        case 3:
          return _set(this, index, replacement, defaultValue);

        default:
          throw new SyntaxError('Wrong number of arguments');
      }
    };
    
    /**
     * Get a single element from the matrix.
     * @memberof DenseMatrix
     * @param {number[]} index   Zero-based index
     * @return {*} value
     */
    DenseMatrix.prototype.get = function (index) {
      if (!isArray(index))
        throw new TypeError('Array expected');
      if (index.length != this._size.length)
        throw new DimensionError_1(index.length, this._size.length);

      // check index
      for (var x = 0; x < index.length; x++)
        validateIndex(index[x], this._size[x]);

      var data = this._data;
      for (var i = 0, ii = index.length; i < ii; i++) {
        var index_i = index[i];
        validateIndex(index_i, data.length);
        data = data[index_i];
      }

      return data;
    };
    
    /**
     * Replace a single element in the matrix.
     * @memberof DenseMatrix
     * @param {number[]} index   Zero-based index
     * @param {*} value
     * @param {*} [defaultValue]        Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be left undefined.
     * @return {DenseMatrix} self
     */
    DenseMatrix.prototype.set = function (index, value, defaultValue) {
      if (!isArray(index))
        throw new TypeError('Array expected');
      if (index.length < this._size.length)
        throw new DimensionError_1(index.length, this._size.length, '<');

      var i, ii, index_i;

      // enlarge matrix when needed
      var size = index.map(function (i) {
        return i + 1;
      });
      _fit(this, size, defaultValue);

      // traverse over the dimensions
      var data = this._data;
      for (i = 0, ii = index.length - 1; i < ii; i++) {
        index_i = index[i];
        validateIndex(index_i, data.length);
        data = data[index_i];
      }

      // set new value
      index_i = index[index.length - 1];
      validateIndex(index_i, data.length);
      data[index_i] = value;

      return this;
    };
    
    /**
     * Get a submatrix of this matrix
     * @memberof DenseMatrix
     * @param {DenseMatrix} matrix
     * @param {Index} index   Zero-based index
     * @private
     */
    function _get (matrix, index) {
      if (!type.isIndex(index)) {
        throw new TypeError('Invalid index');
      }

      var isScalar = index.isScalar();
      if (isScalar) {
        // return a scalar
        return matrix.get(index.min());
      }
      else {
        // validate dimensions
        var size = index.size();
        if (size.length != matrix._size.length) {
          throw new DimensionError_1(size.length, matrix._size.length);
        }

        // validate if any of the ranges in the index is out of range
        var min = index.min();
        var max = index.max();
        for (var i = 0, ii = matrix._size.length; i < ii; i++) {
          validateIndex(min[i], matrix._size[i]);
          validateIndex(max[i], matrix._size[i]);
        }

        // retrieve submatrix
        // TODO: more efficient when creating an empty matrix and setting _data and _size manually
        return new DenseMatrix(_getSubmatrix(matrix._data, index, size.length, 0), matrix._datatype);
      }
    }
    
    /**
     * Recursively get a submatrix of a multi dimensional matrix.
     * Index is not checked for correct number or length of dimensions.
     * @memberof DenseMatrix
     * @param {Array} data
     * @param {Index} index
     * @param {number} dims   Total number of dimensions
     * @param {number} dim    Current dimension
     * @return {Array} submatrix
     * @private
     */
    function _getSubmatrix (data, index, dims, dim) {
      var last = (dim === dims - 1);
      var range = index.dimension(dim);

      if (last) {
        return range.map(function (i) {
          validateIndex(i, data.length);
          return data[i];
        }).valueOf();
      }
      else {
        return range.map(function (i) {
          validateIndex(i, data.length);
          var child = data[i];
          return _getSubmatrix(child, index, dims, dim + 1);
        }).valueOf();
      }
    }
    
    /**
     * Replace a submatrix in this matrix
     * Indexes are zero-based.
     * @memberof DenseMatrix
     * @param {DenseMatrix} matrix
     * @param {Index} index
     * @param {DenseMatrix | Array | *} submatrix
     * @param {*} defaultValue          Default value, filled in on new entries when
     *                                  the matrix is resized.
     * @return {DenseMatrix} matrix
     * @private
     */
    function _set (matrix, index, submatrix, defaultValue) {
      if (!index || index.isIndex !== true) {
        throw new TypeError('Invalid index');
      }

      // get index size and check whether the index contains a single value
      var iSize = index.size(),
          isScalar = index.isScalar();

      // calculate the size of the submatrix, and convert it into an Array if needed
      var sSize;
      if (type.isMatrix(submatrix)) {
        sSize = submatrix.size();
        submatrix = submatrix.valueOf();
      }
      else {
        sSize = array$1.size(submatrix);
      }

      if (isScalar) {
        // set a scalar

        // check whether submatrix is a scalar
        if (sSize.length !== 0) {
          throw new TypeError('Scalar expected');
        }

        matrix.set(index.min(), submatrix, defaultValue);
      }
      else {
        // set a submatrix

        // validate dimensions
        if (iSize.length < matrix._size.length) {
          throw new DimensionError_1(iSize.length, matrix._size.length, '<');
        }

        if (sSize.length < iSize.length) {
          // calculate number of missing outer dimensions
          var i = 0;
          var outer = 0;
          while (iSize[i] === 1 && sSize[i] === 1) {
            i++;
          }
          while (iSize[i] === 1) {
            outer++;
            i++;
          }

          // unsqueeze both outer and inner dimensions
          submatrix = array$1.unsqueeze(submatrix, iSize.length, outer, sSize);
        }

        // check whether the size of the submatrix matches the index size
        if (!object$1.deepEqual(iSize, sSize)) {
          throw new DimensionError_1(iSize, sSize, '>');
        }

        // enlarge matrix when needed
        var size = index.max().map(function (i) {
          return i + 1;
        });
        _fit(matrix, size, defaultValue);

        // insert the sub matrix
        var dims = iSize.length,
            dim = 0;
        _setSubmatrix (matrix._data, index, submatrix, dims, dim);
      }

      return matrix;
    }
    
    /**
     * Replace a submatrix of a multi dimensional matrix.
     * @memberof DenseMatrix
     * @param {Array} data
     * @param {Index} index
     * @param {Array} submatrix
     * @param {number} dims   Total number of dimensions
     * @param {number} dim
     * @private
     */
    function _setSubmatrix (data, index, submatrix, dims, dim) {
      var last = (dim === dims - 1),
          range = index.dimension(dim);

      if (last) {
        range.forEach(function (dataIndex, subIndex) {
          validateIndex(dataIndex);
          data[dataIndex] = submatrix[subIndex[0]];
        });
      }
      else {
        range.forEach(function (dataIndex, subIndex) {
          validateIndex(dataIndex);
          _setSubmatrix(data[dataIndex], index, submatrix[subIndex[0]], dims, dim + 1);
        });
      }
    }
    
    /**
     * Resize the matrix to the given size. Returns a copy of the matrix when
     * `copy=true`, otherwise return the matrix itself (resize in place).
     *
     * @memberof DenseMatrix
     * @param {number[]} size           The new size the matrix should have.
     * @param {*} [defaultValue=0]      Default value, filled in on new entries.
     *                                  If not provided, the matrix elements will
     *                                  be filled with zeros.
     * @param {boolean} [copy]          Return a resized copy of the matrix
     *
     * @return {Matrix}                 The resized matrix
     */
    DenseMatrix.prototype.resize = function (size, defaultValue, copy) {
      // validate arguments
      if (!isArray(size))
        throw new TypeError('Array expected');

      // matrix to resize
      var m = copy ? this.clone() : this;
      // resize matrix
      return _resize(m, size, defaultValue);
    };
    
    var _resize = function (matrix, size, defaultValue) {
      // check size
      if (size.length === 0) {
        // first value in matrix
        var v = matrix._data;
        // go deep
        while (isArray(v)) {
          v = v[0];
        }
        return v;
      }
      // resize matrix
      matrix._size = size.slice(0); // copy the array
      matrix._data = array$1.resize(matrix._data, matrix._size, defaultValue);
      // return matrix
      return matrix;
    };

    /**
     * Reshape the matrix to the given size. Returns a copy of the matrix when
     * `copy=true`, otherwise return the matrix itself (reshape in place).
     *
     * NOTE: This might be better suited to copy by default, instead of modifying
     *       in place. For now, it operates in place to remain consistent with
     *       resize().
     *
     * @memberof DenseMatrix
     * @param {number[]} size           The new size the matrix should have.
     * @param {boolean} [copy]          Return a reshaped copy of the matrix
     *
     * @return {Matrix}                 The reshaped matrix
     */
    DenseMatrix.prototype.reshape = function (size, copy) {
      var m = copy ? this.clone() : this;

      m._data = array$1.reshape(m._data, size);
      m._size = size.slice(0);
      return m;
    };
    
    /**
     * Enlarge the matrix when it is smaller than given size.
     * If the matrix is larger or equal sized, nothing is done.
     * @memberof DenseMatrix
     * @param {DenseMatrix} matrix           The matrix to be resized
     * @param {number[]} size
     * @param {*} defaultValue          Default value, filled in on new entries.
     * @private
     */
    function _fit(matrix, size, defaultValue) {
      var newSize = matrix._size.slice(0), // copy the array
          changed = false;

      // add dimensions when needed
      while (newSize.length < size.length) {
        newSize.push(0);
        changed = true;
      }

      // enlarge size when needed
      for (var i = 0, ii = size.length; i < ii; i++) {
        if (size[i] > newSize[i]) {
          newSize[i] = size[i];
          changed = true;
        }
      }

      if (changed) {
        // resize only when size is changed
        _resize(matrix, newSize, defaultValue);
      }
    }
    
    /**
     * Create a clone of the matrix
     * @memberof DenseMatrix
     * @return {DenseMatrix} clone
     */
    DenseMatrix.prototype.clone = function () {
      var m = new DenseMatrix({
        data: object$1.clone(this._data),
        size: object$1.clone(this._size),
        datatype: this._datatype
      });
      return m;
    };
    
    /**
     * Retrieve the size of the matrix.
     * @memberof DenseMatrix
     * @returns {number[]} size
     */
    DenseMatrix.prototype.size = function() {
      return this._size.slice(0); // return a clone of _size
    };
    
    /**
     * Create a new matrix with the results of the callback function executed on
     * each entry of the matrix.
     * @memberof DenseMatrix
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     *
     * @return {DenseMatrix} matrix
     */
    DenseMatrix.prototype.map = function (callback) {
      // matrix instance
      var me = this;
      var recurse = function (value, index) {
        if (isArray(value)) {
          return value.map(function (child, i) {
            return recurse(child, index.concat(i));
          });
        }
        else {
          return callback(value, index, me);
        }
      };
      // return dense format
      return new DenseMatrix({
        data: recurse(this._data, []),
        size: object$1.clone(this._size),
        datatype: this._datatype
      });
    };
    
    /**
     * Execute a callback function on each entry of the matrix.
     * @memberof DenseMatrix
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     */
    DenseMatrix.prototype.forEach = function (callback) {
      // matrix instance
      var me = this;
      var recurse = function (value, index) {
        if (isArray(value)) {
          value.forEach(function (child, i) {
            recurse(child, index.concat(i));
          });
        }
        else {
          callback(value, index, me);
        }
      };
      recurse(this._data, []);
    };
    
    /**
     * Create an Array with a copy of the data of the DenseMatrix
     * @memberof DenseMatrix
     * @returns {Array} array
     */
    DenseMatrix.prototype.toArray = function () {
      return object$1.clone(this._data);
    };
    
    /**
     * Get the primitive value of the DenseMatrix: a multidimensional array
     * @memberof DenseMatrix
     * @returns {Array} array
     */
    DenseMatrix.prototype.valueOf = function () {
      return this._data;
    };
    
    /**
     * Get a string representation of the matrix, with optional formatting options.
     * @memberof DenseMatrix
     * @param {Object | number | Function} [options]  Formatting options. See
     *                                                lib/utils/number:format for a
     *                                                description of the available
     *                                                options.
     * @returns {string} str
     */
    DenseMatrix.prototype.format = function (options) {
      return string$2.format(this._data, options);
    };
    
    /**
     * Get a string representation of the matrix
     * @memberof DenseMatrix
     * @returns {string} str
     */
    DenseMatrix.prototype.toString = function () {
      return string$2.format(this._data);
    };
    
    /**
     * Get a JSON representation of the matrix
     * @memberof DenseMatrix
     * @returns {Object}
     */
    DenseMatrix.prototype.toJSON = function () {
      return {
        mathjs: 'DenseMatrix',
        data: this._data,
        size: this._size,
        datatype: this._datatype
      };
    };
    
    /**
     * Get the kth Matrix diagonal.
     *
     * @memberof DenseMatrix
     * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
     *
     * @returns {Array}                      The array vector with the diagonal values.
     */
    DenseMatrix.prototype.diagonal = function(k) {
      // validate k if any
      if (k) {
        // convert BigNumber to a number
        if (type.isBigNumber(k))
          k = k.toNumber();
        // is must be an integer
        if (!isNumber$1(k) || !isInteger(k)) {
          throw new TypeError ('The parameter k must be an integer number');
        }
      }
      else {
        // default value
        k = 0;
      }

      var kSuper = k > 0 ? k : 0;
      var kSub = k < 0 ? -k : 0;

      // rows & columns
      var rows = this._size[0];
      var columns = this._size[1];

      // number diagonal values
      var n = Math.min(rows - kSub, columns -  kSuper);
      
      // x is a matrix get diagonal from matrix
      var data = [];
      
      // loop rows
      for (var i = 0; i < n; i++) {
        data[i] = this._data[i + kSub][i + kSuper];
      }

      // create DenseMatrix
      return new DenseMatrix({
        data: data,
        size: [n],
        datatype: this._datatype
      });
    };
    
    /**
     * Create a diagonal matrix.
     *
     * @memberof DenseMatrix
     * @param {Array} size                   The matrix size.
     * @param {number | Array} value          The values for the diagonal.
     * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will be filled in.
     * @param {number} [defaultValue]        The default value for non-diagonal
     *
     * @returns {DenseMatrix}
     */
    DenseMatrix.diagonal = function (size, value, k, defaultValue, datatype) {
      if (!isArray(size))
        throw new TypeError('Array expected, size parameter');
      if (size.length !== 2)
        throw new Error('Only two dimensions matrix are supported');

      // map size & validate
      size = size.map(function (s) {
        // check it is a big number
        if (type.isBigNumber(s)) {
          // convert it
          s = s.toNumber();
        }
        // validate arguments
        if (!isNumber$1(s) || !isInteger(s) || s < 1) {
          throw new Error('Size values must be positive integers');
        } 
        return s;
      });

      // validate k if any
      if (k) {
        // convert BigNumber to a number
        if (type.isBigNumber(k))
          k = k.toNumber();
        // is must be an integer
        if (!isNumber$1(k) || !isInteger(k)) {
          throw new TypeError ('The parameter k must be an integer number');
        }
      }
      else {
        // default value
        k = 0;
      }
      
      if (defaultValue && isString$1(datatype)) {
        // convert defaultValue to the same datatype
        defaultValue = typed.convert(defaultValue, datatype);
      }

      var kSuper = k > 0 ? k : 0;
      var kSub = k < 0 ? -k : 0;
      
      // rows and columns
      var rows = size[0];
      var columns = size[1];

      // number of non-zero items
      var n = Math.min(rows - kSub, columns -  kSuper);

      // value extraction function
      var _value;

      // check value
      if (isArray(value)) {
        // validate array
        if (value.length !== n) {
          // number of values in array must be n
          throw new Error('Invalid value array length');
        }
        // define function
        _value = function (i) {
          // return value @ i
          return value[i];
        };      
      }
      else if (type.isMatrix(value)) {
        // matrix size
        var ms = value.size();
        // validate matrix
        if (ms.length !== 1 || ms[0] !== n) {
          // number of values in array must be n
          throw new Error('Invalid matrix length');
        }
        // define function
        _value = function (i) {
          // return value @ i
          return value.get([i]);
        };
      }
      else {
        // define function
        _value = function () {
          // return value
          return value;
        };
      }
      
      // discover default value if needed
      if (!defaultValue) {
        // check first value in array
        defaultValue = type.isBigNumber(_value(0)) ? new type.BigNumber(0) : 0;
      }

      // empty array
      var data = [];

      // check we need to resize array
      if (size.length > 0) {
        // resize array
        data = array$1.resize(data, size, defaultValue);
        // fill diagonal
        for (var d = 0; d < n; d++) {
          data[d + kSub][d + kSuper] = _value(d);
        }
      }
      
      // create DenseMatrix
      return new DenseMatrix({
        data: data,
        size: [rows, columns]
      });
    };

    /**
     * Generate a matrix from a JSON object
     * @memberof DenseMatrix
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "DenseMatrix", data: [], size: []}`,
     *                       where mathjs is optional
     * @returns {DenseMatrix}
     */
    DenseMatrix.fromJSON = function (json) {
      return new DenseMatrix(json);
    };
    
    /**
     * Swap rows i and j in Matrix.
     *
     * @memberof DenseMatrix
     * @param {number} i       Matrix row index 1
     * @param {number} j       Matrix row index 2
     *
     * @return {Matrix}        The matrix reference
     */
    DenseMatrix.prototype.swapRows = function (i, j) {
      // check index
      if (!isNumber$1(i) || !isInteger(i) || !isNumber$1(j) || !isInteger(j)) {
        throw new Error('Row index must be positive integers');
      }
      // check dimensions
      if (this._size.length !== 2) {
        throw new Error('Only two dimensional matrix is supported');
      }
      // validate index
      validateIndex(i, this._size[0]);
      validateIndex(j, this._size[0]);

      // swap rows
      DenseMatrix._swapRows(i, j, this._data);
      // return current instance
      return this;
    };

    /**
     * Swap rows i and j in Dense Matrix data structure.
     *
     * @param {number} i       Matrix row index 1
     * @param {number} j       Matrix row index 2
     */
    DenseMatrix._swapRows = function (i, j, data) {
      // swap values i <-> j
      var vi = data[i];
      data[i] = data[j];
      data[j] = vi;
    };

    /**
     * Preprocess data, which can be an Array or DenseMatrix with nested Arrays and
     * Matrices. Replaces all nested Matrices with Arrays
     * @memberof DenseMatrix
     * @param {Array} data
     * @return {Array} data
     */
    function preprocess(data) {
      for (var i = 0, ii = data.length; i < ii; i++) {
        var elem = data[i];
        if (isArray(elem)) {
          data[i] = preprocess(elem);
        }
        else if (elem && elem.isMatrix === true) {
          data[i] = preprocess(elem.valueOf());
        }
      }

      return data;
    }

    // register this type in the base class Matrix
    type.Matrix._storage.dense = DenseMatrix;
    type.Matrix._storage['default'] = DenseMatrix;

    // exports
    return DenseMatrix;
  }

  var name$12 = 'DenseMatrix';
  var path$5 = 'type';
  var factory_1$12 = factory$12;
  var lazy$2 = false;  // no lazy loading, as we alter type.Matrix._storage

  var DenseMatrix = {
  	name: name$12,
  	path: path$5,
  	factory: factory_1$12,
  	lazy: lazy$2
  };

  /**
   * Compares two BigNumbers.
   * @param {BigNumber} x       First value to compare
   * @param {BigNumber} y       Second value to compare
   * @param {number} [epsilon]  The maximum relative difference between x and y
   *                            If epsilon is undefined or null, the function will
   *                            test whether x and y are exactly equal.
   * @return {boolean} whether the two numbers are nearly equal
   */
  var nearlyEqual = function nearlyEqual(x, y, epsilon) {
    // if epsilon is null or undefined, test whether x and y are exactly equal
    if (epsilon == null) {
      return x.eq(y);
    }


    // use "==" operator, handles infinities
    if (x.eq(y)) {
      return true;
    }

    // NaN
    if (x.isNaN() || y.isNaN()) {
      return false;
    }

    // at this point x and y should be finite
    if(x.isFinite() && y.isFinite()) {
      // check numbers are very close, needed when comparing numbers near zero
      var diff = x.minus(y).abs();
      if (diff.isZero()) {
        return true;
      }
      else {
        // use relative error
        var max = x.constructor.max(x.abs(), y.abs());
        return diff.lte(max.times(epsilon));
      }
    }

    // Infinite and Number or negative Infinite and positive Infinite cases
    return false;
  };

  var nearlyEqual$1 = number.nearlyEqual;


  function factory$13 (type, config, load, typed) {
    
    /**
     * Test whether two values are equal.
     *
     * @param  {number | BigNumber | Fraction | boolean | Complex | Unit} x   First value to compare
     * @param  {number | BigNumber | Fraction | boolean | Complex} y          Second value to compare
     * @return {boolean}                                                  Returns true when the compared values are equal, else returns false
     * @private
     */
    var equalScalar = typed('equalScalar', {

      'boolean, boolean': function (x, y) {
        return x === y;
      },

      'number, number': function (x, y) {
        return x === y || nearlyEqual$1(x, y, config.epsilon);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.eq(y) || nearlyEqual(x, y, config.epsilon);
      },

      'Fraction, Fraction': function (x, y) {
        return x.equals(y);
      },

      'Complex, Complex': function (x, y) {
        return x.equals(y);
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return equalScalar(x.value, y.value);
      }
    });
    
    return equalScalar;
  }

  var factory_1$13 = factory$13;

  var equalScalar = {
  	factory: factory_1$13
  };

  var array$2 = utils.array;
  var object$2 = utils.object;
  var string$3 = utils.string;
  var number$2 = utils.number;

  var isArray$1 = Array.isArray;
  var isNumber$2 = number$2.isNumber;
  var isInteger$1 = number$2.isInteger;
  var isString$2 = string$3.isString;

  var validateIndex$1 = array$2.validateIndex;

  function factory$14 (type, config, load, typed) {
    var Matrix$$1 = load(Matrix); // force loading Matrix (do not use via type.Matrix)
    var equalScalar$$1 = load(equalScalar);

    /**
     * Sparse Matrix implementation. This type implements a Compressed Column Storage format
     * for sparse matrices.
     * @class SparseMatrix
     */
    function SparseMatrix(data, datatype) {
      if (!(this instanceof SparseMatrix))
        throw new SyntaxError('Constructor must be called with the new operator');
      if (datatype && !isString$2(datatype))
        throw new Error('Invalid datatype: ' + datatype);
      
      if (type.isMatrix(data)) {
        // create from matrix
        _createFromMatrix(this, data, datatype);
      }
      else if (data && isArray$1(data.index) && isArray$1(data.ptr) && isArray$1(data.size)) {
        // initialize fields
        this._values = data.values;
        this._index = data.index;
        this._ptr = data.ptr;
        this._size = data.size;
        this._datatype = datatype || data.datatype;
      }
      else if (isArray$1(data)) {
        // create from array
        _createFromArray(this, data, datatype);
      }
      else if (data) {
        // unsupported type
        throw new TypeError('Unsupported type of data (' + utils.types.type(data) + ')');
      }
      else {
        // nothing provided
        this._values = [];
        this._index = [];
        this._ptr = [0];
        this._size = [0, 0];
        this._datatype = datatype;
      }
    }
    
    var _createFromMatrix = function (matrix, source, datatype) {
      // check matrix type
      if (source.type === 'SparseMatrix') {
        // clone arrays
        matrix._values = source._values ? object$2.clone(source._values) : undefined;
        matrix._index = object$2.clone(source._index);
        matrix._ptr = object$2.clone(source._ptr);
        matrix._size = object$2.clone(source._size);
        matrix._datatype = datatype || source._datatype;
      }
      else {
        // build from matrix data
        _createFromArray(matrix, source.valueOf(), datatype || source._datatype);
      }
    };
    
    var _createFromArray = function (matrix, data, datatype) {
      // initialize fields
      matrix._values = [];
      matrix._index = [];
      matrix._ptr = [];
      matrix._datatype = datatype;
      // discover rows & columns, do not use math.size() to avoid looping array twice
      var rows = data.length;
      var columns = 0;
      
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      
      if (isString$2(datatype)) {
        // find signature that matches (datatype, datatype)
        eq = typed.find(equalScalar$$1, [datatype, datatype]) || equalScalar$$1;
        // convert 0 to the same datatype
        zero = typed.convert(0, datatype);
      }

      // check we have rows (empty array)
      if (rows > 0) {
        // column index
        var j = 0;
        do {
          // store pointer to values index
          matrix._ptr.push(matrix._index.length);
          // loop rows
          for (var i = 0; i < rows; i++) {
            // current row
            var row = data[i];
            // check row is an array
            if (isArray$1(row)) {
              // update columns if needed (only on first column)
              if (j === 0 && columns < row.length)
                columns = row.length;
              // check row has column
              if (j < row.length) {
                // value
                var v = row[j];
                // check value != 0
                if (!eq(v, zero)) {
                  // store value
                  matrix._values.push(v);
                  // index
                  matrix._index.push(i);
                }
              }
            }
            else {
              // update columns if needed (only on first column)
              if (j === 0 && columns < 1)
                columns = 1;
              // check value != 0 (row is a scalar)
              if (!eq(row, zero)) {
                // store value
                matrix._values.push(row);
                // index
                matrix._index.push(i);
              }
            }
          }
          // increment index
          j++;      
        }
        while (j < columns);
      }
      // store number of values in ptr
      matrix._ptr.push(matrix._index.length);
      // size
      matrix._size = [rows, columns];
    };
    
    SparseMatrix.prototype = new Matrix$$1();

    /**
     * Attach type information
     */
    SparseMatrix.prototype.type = 'SparseMatrix';
    SparseMatrix.prototype.isSparseMatrix = true;

    /**
     * Get the storage format used by the matrix.
     *
     * Usage:
     *     var format = matrix.storage()                   // retrieve storage format
     *
     * @memberof SparseMatrix
     * @return {string}           The storage format.
     */
    SparseMatrix.prototype.storage = function () {
      return 'sparse';
    };

    /**
     * Get the datatype of the data stored in the matrix.
     *
     * Usage:
     *     var format = matrix.datatype()                   // retrieve matrix datatype
     *
     * @memberof SparseMatrix
     * @return {string}           The datatype.
     */
    SparseMatrix.prototype.datatype = function () {
      return this._datatype;
    };

    /**
     * Create a new SparseMatrix
     * @memberof SparseMatrix
     * @param {Array} data
     * @param {string} [datatype]
     */
    SparseMatrix.prototype.create = function (data, datatype) {
      return new SparseMatrix(data, datatype);
    };

    /**
     * Get the matrix density.
     *
     * Usage:
     *     var density = matrix.density()                   // retrieve matrix density
     *
     * @memberof SparseMatrix
     * @return {number}           The matrix density.
     */
    SparseMatrix.prototype.density = function () {
      // rows & columns
      var rows = this._size[0];
      var columns = this._size[1];
      // calculate density
      return rows !== 0 && columns !== 0 ? (this._index.length / (rows * columns)) : 0;
    };
    
    /**
     * Get a subset of the matrix, or replace a subset of the matrix.
     *
     * Usage:
     *     var subset = matrix.subset(index)               // retrieve subset
     *     var value = matrix.subset(index, replacement)   // replace subset
     *
     * @memberof SparseMatrix
     * @param {Index} index
     * @param {Array | Maytrix | *} [replacement]
     * @param {*} [defaultValue=0]      Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be filled with zeros.
     */
    SparseMatrix.prototype.subset = function (index, replacement, defaultValue) { // check it is a pattern matrix
      if (!this._values)
        throw new Error('Cannot invoke subset on a Pattern only matrix');

      // check arguments
      switch (arguments.length) {
        case 1:
          return _getsubset(this, index);

          // intentional fall through
        case 2:
        case 3:
          return _setsubset(this, index, replacement, defaultValue);

        default:
          throw new SyntaxError('Wrong number of arguments');
      }
    };
    
    var _getsubset = function (matrix, idx) {
      // check idx
      if (!type.isIndex(idx)) {
        throw new TypeError('Invalid index');
      }

      var isScalar = idx.isScalar();
      if (isScalar) {
        // return a scalar
        return matrix.get(idx.min());
      }
      // validate dimensions
      var size = idx.size();
      if (size.length != matrix._size.length) {
        throw new DimensionError_1(size.length, matrix._size.length);
      }

      // vars
      var i, ii, k, kk;
      
      // validate if any of the ranges in the index is out of range
      var min = idx.min();
      var max = idx.max();
      for (i = 0, ii = matrix._size.length; i < ii; i++) {
        validateIndex$1(min[i], matrix._size[i]);
        validateIndex$1(max[i], matrix._size[i]);
      }
      
      // matrix arrays
      var mvalues = matrix._values;
      var mindex = matrix._index;
      var mptr = matrix._ptr;
          
      // rows & columns dimensions for result matrix
      var rows = idx.dimension(0);
      var columns = idx.dimension(1);
      
      // workspace & permutation vector
      var w = [];
      var pv = [];
      
      // loop rows in resulting matrix
      rows.forEach(function (i, r) {
        // update permutation vector
        pv[i] = r[0];  
        // mark i in workspace
        w[i] = true;
      });

      // result matrix arrays
      var values = mvalues ? [] : undefined;
      var index = [];
      var ptr = [];
          
      // loop columns in result matrix
      columns.forEach(function (j) {
        // update ptr
        ptr.push(index.length);
        // loop values in column j
        for (k = mptr[j], kk = mptr[j + 1]; k < kk; k++) {
          // row
          i = mindex[k];
          // check row is in result matrix
          if (w[i] === true) {
            // push index
            index.push(pv[i]);
            // check we need to process values
            if (values)
              values.push(mvalues[k]);
          }
        }
      });
      // update ptr
      ptr.push(index.length);
      
      // return matrix
      return new SparseMatrix({
        values: values,
        index: index,
        ptr: ptr,
        size: size,
        datatype: matrix._datatype
      });
    };
    
    var _setsubset = function (matrix, index, submatrix, defaultValue) {
      // check index
      if (!index || index.isIndex !== true) {
        throw new TypeError('Invalid index');
      }
      
      // get index size and check whether the index contains a single value
      var iSize = index.size(),
          isScalar = index.isScalar();
      
      // calculate the size of the submatrix, and convert it into an Array if needed
      var sSize;
      if (type.isMatrix(submatrix)) {
        // submatrix size
        sSize = submatrix.size();
        // use array representation
        submatrix = submatrix.toArray();
      }
      else {
        // get submatrix size (array, scalar)
        sSize = array$2.size(submatrix);
      }
      
      // check index is a scalar
      if (isScalar) {
        // verify submatrix is a scalar
        if (sSize.length !== 0) {
          throw new TypeError('Scalar expected');
        }
        // set value
        matrix.set(index.min(), submatrix, defaultValue);
      }
      else {
        // validate dimensions, index size must be one or two dimensions
        if (iSize.length !== 1 && iSize.length !== 2) {
          throw new DimensionError_1(iSize.length, matrix._size.length, '<');
        }
        
        // check submatrix and index have the same dimensions
        if (sSize.length < iSize.length) {
          // calculate number of missing outer dimensions
          var i = 0;
          var outer = 0;
          while (iSize[i] === 1 && sSize[i] === 1) {
            i++;
          }
          while (iSize[i] === 1) {
            outer++;
            i++;
          }
          // unsqueeze both outer and inner dimensions
          submatrix = array$2.unsqueeze(submatrix, iSize.length, outer, sSize);
        }
        
        // check whether the size of the submatrix matches the index size
        if (!object$2.deepEqual(iSize, sSize)) {
          throw new DimensionError_1(iSize, sSize, '>');
        }
        
        // offsets
        var x0 = index.min()[0];
        var y0 = index.min()[1];      
        
        // submatrix rows and columns
        var m = sSize[0];
        var n = sSize[1];

        // loop submatrix
        for (var x = 0; x < m; x++) {
          // loop columns
          for (var y = 0; y < n; y++) {
            // value at i, j
            var v = submatrix[x][y];
            // invoke set (zero value will remove entry from matrix)
            matrix.set([x + x0, y + y0], v, defaultValue);
          }
        }
      }
      return matrix;
    };

    /**
     * Get a single element from the matrix.
     * @memberof SparseMatrix
     * @param {number[]} index   Zero-based index
     * @return {*} value
     */
    SparseMatrix.prototype.get = function (index) {
      if (!isArray$1(index))
        throw new TypeError('Array expected');
      if (index.length != this._size.length)
        throw new DimensionError_1(index.length, this._size.length);

      // check it is a pattern matrix
      if (!this._values)
        throw new Error('Cannot invoke get on a Pattern only matrix');

      // row and column
      var i = index[0];
      var j = index[1];

      // check i, j are valid
      validateIndex$1(i, this._size[0]);
      validateIndex$1(j, this._size[1]);

      // find value index
      var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
      // check k is prior to next column k and it is in the correct row
      if (k < this._ptr[j + 1] && this._index[k] === i)
        return this._values[k];

      return 0;
    };
    
    /**
     * Replace a single element in the matrix.
     * @memberof SparseMatrix
     * @param {number[]} index   Zero-based index
     * @param {*} value
     * @param {*} [defaultValue]        Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be set to zero.
     * @return {SparseMatrix} self
     */
    SparseMatrix.prototype.set = function (index, v, defaultValue) {
      if (!isArray$1(index))
        throw new TypeError('Array expected');
      if (index.length != this._size.length)
        throw new DimensionError_1(index.length, this._size.length);

      // check it is a pattern matrix
      if (!this._values)
        throw new Error('Cannot invoke set on a Pattern only matrix');
        
      // row and column
      var i = index[0];
      var j = index[1];

      // rows & columns
      var rows = this._size[0];
      var columns = this._size[1];
      
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      if (isString$2(this._datatype)) {
        // find signature that matches (datatype, datatype)
        eq = typed.find(equalScalar$$1, [this._datatype, this._datatype]) || equalScalar$$1;
        // convert 0 to the same datatype
        zero = typed.convert(0, this._datatype);
      }

      // check we need to resize matrix
      if (i > rows - 1 || j > columns - 1) {
        // resize matrix
        _resize(this, Math.max(i + 1, rows), Math.max(j + 1, columns), defaultValue);
        // update rows & columns
        rows = this._size[0];
        columns = this._size[1];
      }

      // check i, j are valid
      validateIndex$1(i, rows);
      validateIndex$1(j, columns);

      // find value index
      var k = _getValueIndex(i, this._ptr[j], this._ptr[j + 1], this._index);
      // check k is prior to next column k and it is in the correct row
      if (k < this._ptr[j + 1] && this._index[k] === i) {
        // check value != 0
        if (!eq(v, zero)) {
          // update value
          this._values[k] = v;
        }
        else {
          // remove value from matrix
          _remove(k, j, this._values, this._index, this._ptr);
        }
      }
      else {
        // insert value @ (i, j)
        _insert(k, i, j, v, this._values, this._index, this._ptr);
      }

      return this;
    };
    
    var _getValueIndex = function(i, top, bottom, index) {
      // check row is on the bottom side
      if (bottom - top === 0)
        return bottom;
      // loop rows [top, bottom[
      for (var r = top; r < bottom; r++) {
        // check we found value index
        if (index[r] === i)
          return r;
      }
      // we did not find row
      return top;
    };

    var _remove = function (k, j, values, index, ptr) {
      // remove value @ k
      values.splice(k, 1);
      index.splice(k, 1);
      // update pointers
      for (var x = j + 1; x < ptr.length; x++)
        ptr[x]--;
    };

    var _insert = function (k, i, j, v, values, index, ptr) {
      // insert value
      values.splice(k, 0, v);
      // update row for k
      index.splice(k, 0, i);
      // update column pointers
      for (var x = j + 1; x < ptr.length; x++)
        ptr[x]++;
    };
    
    /**
     * Resize the matrix to the given size. Returns a copy of the matrix when 
     * `copy=true`, otherwise return the matrix itself (resize in place).
     *
     * @memberof SparseMatrix
     * @param {number[]} size           The new size the matrix should have.
     * @param {*} [defaultValue=0]      Default value, filled in on new entries.
     *                                  If not provided, the matrix elements will
     *                                  be filled with zeros.
     * @param {boolean} [copy]          Return a resized copy of the matrix
     *
     * @return {Matrix}                 The resized matrix
     */
    SparseMatrix.prototype.resize = function (size, defaultValue, copy) {    
      // validate arguments
      if (!isArray$1(size))
        throw new TypeError('Array expected');
      if (size.length !== 2)
        throw new Error('Only two dimensions matrix are supported');

      // check sizes
      size.forEach(function (value) {
        if (!number$2.isNumber(value) || !number$2.isInteger(value) || value < 0) {
          throw new TypeError('Invalid size, must contain positive integers ' +
                              '(size: ' + string$3.format(size) + ')');
        }
      });
      
      // matrix to resize
      var m = copy ? this.clone() : this;
      // resize matrix
      return _resize(m, size[0], size[1], defaultValue);
    };
    
    var _resize = function (matrix, rows, columns, defaultValue) {
      // value to insert at the time of growing matrix
      var value = defaultValue || 0;
      
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      if (isString$2(matrix._datatype)) {
        // find signature that matches (datatype, datatype)
        eq = typed.find(equalScalar$$1, [matrix._datatype, matrix._datatype]) || equalScalar$$1;
        // convert 0 to the same datatype
        zero = typed.convert(0, matrix._datatype);
        // convert value to the same datatype
        value = typed.convert(value, matrix._datatype);
      }
      
      // should we insert the value?
      var ins = !eq(value, zero);

      // old columns and rows
      var r = matrix._size[0];
      var c = matrix._size[1];

      var i, j, k;

      // check we need to increase columns
      if (columns > c) {
        // loop new columns
        for (j = c; j < columns; j++) {
          // update matrix._ptr for current column
          matrix._ptr[j] = matrix._values.length;
          // check we need to insert matrix._values
          if (ins) {
            // loop rows
            for (i = 0; i < r; i++) {
              // add new matrix._values
              matrix._values.push(value);
              // update matrix._index
              matrix._index.push(i);
            }
          }        
        }
        // store number of matrix._values in matrix._ptr
        matrix._ptr[columns] = matrix._values.length;
      }
      else if (columns < c) {
        // truncate matrix._ptr
        matrix._ptr.splice(columns + 1, c - columns);
        // truncate matrix._values and matrix._index
        matrix._values.splice(matrix._ptr[columns], matrix._values.length);
        matrix._index.splice(matrix._ptr[columns], matrix._index.length);
      }
      // update columns
      c = columns;

      // check we need to increase rows
      if (rows > r) {
        // check we have to insert values
        if (ins) {
          // inserts
          var n = 0;
          // loop columns
          for (j = 0; j < c; j++) {
            // update matrix._ptr for current column
            matrix._ptr[j] = matrix._ptr[j] + n;
            // where to insert matrix._values
            k = matrix._ptr[j + 1] + n;
            // pointer
            var p = 0;
            // loop new rows, initialize pointer
            for (i = r; i < rows; i++, p++) {
              // add value
              matrix._values.splice(k + p, 0, value);
              // update matrix._index
              matrix._index.splice(k + p, 0, i);
              // increment inserts
              n++;
            }
          }
          // store number of matrix._values in matrix._ptr
          matrix._ptr[c] = matrix._values.length;
        }
      }
      else if (rows < r) {
        // deletes
        var d = 0;
        // loop columns
        for (j = 0; j < c; j++) {
          // update matrix._ptr for current column
          matrix._ptr[j] = matrix._ptr[j] - d;
          // where matrix._values start for next column
          var k0 = matrix._ptr[j];
          var k1 = matrix._ptr[j + 1] - d;
          // loop matrix._index
          for (k = k0; k < k1; k++) {
            // row
            i = matrix._index[k];
            // check we need to delete value and matrix._index
            if (i > rows - 1) {
              // remove value
              matrix._values.splice(k, 1);
              // remove item from matrix._index
              matrix._index.splice(k, 1);
              // increase deletes
              d++;
            }
          }
        }
        // update matrix._ptr for current column
        matrix._ptr[j] = matrix._values.length;
      }
      // update matrix._size
      matrix._size[0] = rows;
      matrix._size[1] = columns;
      // return matrix
      return matrix;
    };

    /**
     * Reshape the matrix to the given size. Returns a copy of the matrix when
     * `copy=true`, otherwise return the matrix itself (reshape in place).
     *
     * NOTE: This might be better suited to copy by default, instead of modifying
     *       in place. For now, it operates in place to remain consistent with
     *       resize().
     *
     * @memberof SparseMatrix
     * @param {number[]} size           The new size the matrix should have.
     * @param {boolean} [copy]          Return a reshaped copy of the matrix
     *
     * @return {Matrix}                 The reshaped matrix
     */
    SparseMatrix.prototype.reshape = function (size, copy) {

      // validate arguments
      if (!isArray$1(size))
        throw new TypeError('Array expected');
      if (size.length !== 2)
        throw new Error('Sparse matrices can only be reshaped in two dimensions');

      // check sizes
      size.forEach(function (value) {
        if (!number$2.isNumber(value) || !number$2.isInteger(value) || value < 0) {
          throw new TypeError('Invalid size, must contain positive integers ' +
                              '(size: ' + string$3.format(size) + ')');
        }
      });

      // m * n must not change
      if(this._size[0] * this._size[1] !== size[0] * size[1]) {
        throw new Error('Reshaping sparse matrix will result in the wrong number of elements');
      }

      // matrix to reshape
      var m = copy ? this.clone() : this;

      // return unchanged if the same shape
      if(this._size[0] === size[0] && this._size[1] === size[1]) {
        return m;
      }

      // Convert to COO format (generate a column index)
      var colIndex = [];
      for(var i=0; i<m._ptr.length; i++) {
        for(var j=0; j<m._ptr[i+1]-m._ptr[i]; j++) {
          colIndex.push(i);
        }
      }

      // Clone the values array
      var values = m._values.slice();

      // Clone the row index array
      var rowIndex = m._index.slice();

      // Transform the (row, column) indices
      for(var i=0; i<m._index.length; i++) {
        var r1 = rowIndex[i];
        var c1 = colIndex[i];
        var flat = r1 * m._size[1] + c1;
        colIndex[i] = flat % size[1];
        rowIndex[i] = Math.floor(flat / size[1]);
      }

      // Now reshaping is supposed to preserve the row-major order, BUT these sparse matrices are stored
      // in column-major order, so we have to reorder the value array now. One option is to use a multisort,
      // sorting several arrays based on some other array.

      // OR, we could easily just:

      // 1. Remove all values from the matrix
      m._values.length = 0;
      m._index.length = 0;
      m._ptr.length = size[1] + 1;
      m._size = size.slice();
      for(var i=0; i<m._ptr.length; i++) {
        m._ptr[i] = 0;
      }

      // 2. Re-insert all elements in the proper order (simplified code from SparseMatrix.prototype.set)
      // This step is probably the most time-consuming
      for(var h=0; h<values.length; h++) {
        var i = rowIndex[h];
        var j = colIndex[h];
        var v = values[h];
        var k = _getValueIndex(i, m._ptr[j], m._ptr[j + 1], m._index);
        _insert(k, i, j, v, m._values, m._index, m._ptr);
      }

      // The value indices are inserted out of order, but apparently that's... still OK?

      return m;
    };
    
    /**
     * Create a clone of the matrix
     * @memberof SparseMatrix
     * @return {SparseMatrix} clone
     */
    SparseMatrix.prototype.clone = function () {
      var m = new SparseMatrix({
        values: this._values ? object$2.clone(this._values) : undefined,
        index: object$2.clone(this._index),
        ptr: object$2.clone(this._ptr),
        size: object$2.clone(this._size),
        datatype: this._datatype
      });
      return m;
    };
    
    /**
     * Retrieve the size of the matrix.
     * @memberof SparseMatrix
     * @returns {number[]} size
     */
    SparseMatrix.prototype.size = function() {
      return this._size.slice(0); // copy the Array
    };
    
    /**
     * Create a new matrix with the results of the callback function executed on
     * each entry of the matrix.
     * @memberof SparseMatrix
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
     *
     * @return {SparseMatrix} matrix
     */
    SparseMatrix.prototype.map = function (callback, skipZeros) {
      // check it is a pattern matrix
      if (!this._values)
        throw new Error('Cannot invoke map on a Pattern only matrix');
      // matrix instance
      var me = this;
      // rows and columns
      var rows = this._size[0];
      var columns = this._size[1];
      // invoke callback
      var invoke = function (v, i, j) {
        // invoke callback
        return callback(v, [i, j], me);
      };
      // invoke _map
      return _map(this, 0, rows - 1, 0, columns - 1, invoke, skipZeros);
    };

    /**
     * Create a new matrix with the results of the callback function executed on the interval
     * [minRow..maxRow, minColumn..maxColumn].
     */
    var _map = function (matrix, minRow, maxRow, minColumn, maxColumn, callback, skipZeros) {
      // result arrays
      var values = [];
      var index = [];
      var ptr = [];
      
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      if (isString$2(matrix._datatype)) {
        // find signature that matches (datatype, datatype)
        eq = typed.find(equalScalar$$1, [matrix._datatype, matrix._datatype]) || equalScalar$$1;
        // convert 0 to the same datatype
        zero = typed.convert(0, matrix._datatype);
      }
      
      // invoke callback
      var invoke = function (v, x, y) {
        // invoke callback
        v = callback(v, x, y);
        // check value != 0
        if (!eq(v, zero)) {
          // store value
          values.push(v);
          // index
          index.push(x);
        }
      };
      // loop columns
      for (var j = minColumn; j <= maxColumn; j++) {
        // store pointer to values index
        ptr.push(values.length);
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = matrix._ptr[j];
        var k1 = matrix._ptr[j + 1];
        // row pointer
        var p = minRow;
        // loop k within [k0, k1[
        for (var k = k0; k < k1; k++) {
          // row index
          var i = matrix._index[k];
          // check i is in range
          if (i >= minRow && i <= maxRow) {
            // zero values
            if (!skipZeros) {
             for (var x = p; x < i; x++)
               invoke(0, x - minRow, j - minColumn);
            }
            // value @ k
            invoke(matrix._values[k], i - minRow, j - minColumn);
          }
          // update pointer
          p = i + 1;
        }
        // zero values
        if (!skipZeros) {
          for (var y = p; y <= maxRow; y++)
            invoke(0, y - minRow, j - minColumn);
        }
      }
      // store number of values in ptr
      ptr.push(values.length);
      // return sparse matrix
      return new SparseMatrix({
        values: values,
        index: index,
        ptr: ptr,
        size: [maxRow - minRow + 1, maxColumn - minColumn + 1]
      });
    };
    
    /**
     * Execute a callback function on each entry of the matrix.
     * @memberof SparseMatrix
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     * @param {boolean} [skipZeros] Invoke callback function for non-zero values only.
     */
    SparseMatrix.prototype.forEach = function (callback, skipZeros) {
      // check it is a pattern matrix
      if (!this._values)
        throw new Error('Cannot invoke forEach on a Pattern only matrix');
      // matrix instance
      var me = this;
      // rows and columns
      var rows = this._size[0];
      var columns = this._size[1];
      // loop columns
      for (var j = 0; j < columns; j++) {
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = this._ptr[j];
        var k1 = this._ptr[j + 1];
        // column pointer
        var p = 0;
        // loop k within [k0, k1[
        for (var k = k0; k < k1; k++) {
          // row index
          var i = this._index[k];
          // check we need to process zeros
          if (!skipZeros) {
            // zero values
            for (var x = p; x < i; x++)
              callback(0, [x, j], me);
          }
          // value @ k
          callback(this._values[k], [i, j], me);
          // update pointer
          p = i + 1;
        }
        // check we need to process zeros
        if (!skipZeros) {
          // zero values
          for (var y = p; y < rows; y++)
            callback(0, [y, j], me);
        }
      }
    };
    
    /**
     * Create an Array with a copy of the data of the SparseMatrix
     * @memberof SparseMatrix
     * @returns {Array} array
     */
    SparseMatrix.prototype.toArray = function () {
      return _toArray(this._values, this._index, this._ptr, this._size, true);
    };

    /**
     * Get the primitive value of the SparseMatrix: a two dimensions array
     * @memberof SparseMatrix
     * @returns {Array} array
     */
    SparseMatrix.prototype.valueOf = function () {
      return _toArray(this._values, this._index, this._ptr, this._size, false);
    };
    
    var _toArray = function (values, index, ptr, size, copy) {    
      // rows and columns
      var rows = size[0];
      var columns = size[1];
      // result
      var a = [];
      // vars
      var i, j;
      // initialize array
      for (i = 0; i < rows; i++) {
        a[i] = [];
        for (j = 0; j < columns; j++)
          a[i][j] = 0;
      }

      // loop columns
      for (j = 0; j < columns; j++) {
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = ptr[j];
        var k1 = ptr[j + 1];
        // loop k within [k0, k1[
        for (var k = k0; k < k1; k++) {
          // row index
          i = index[k];
          // set value (use one for pattern matrix)
          a[i][j] = values ? (copy ? object$2.clone(values[k]) : values[k]) : 1;
        }
      }
      return a;
    };
    
    /**
     * Get a string representation of the matrix, with optional formatting options.
     * @memberof SparseMatrix
     * @param {Object | number | Function} [options]  Formatting options. See
     *                                                lib/utils/number:format for a
     *                                                description of the available
     *                                                options.
     * @returns {string} str
     */
    SparseMatrix.prototype.format = function (options) {
      // rows and columns
      var rows = this._size[0];
      var columns = this._size[1];
      // density
      var density = this.density();
      // rows & columns
      var str = 'Sparse Matrix [' + string$3.format(rows, options) + ' x ' + string$3.format(columns, options) + '] density: ' + string$3.format(density, options) + '\n';
      // loop columns
      for (var j = 0; j < columns; j++) {
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = this._ptr[j];
        var k1 = this._ptr[j + 1];
        // loop k within [k0, k1[
        for (var k = k0; k < k1; k++) {
          // row index
          var i = this._index[k];
          // append value
          str += '\n    (' + string$3.format(i, options) + ', ' + string$3.format(j, options) + ') ==> ' + (this._values ? string$3.format(this._values[k], options) : 'X');
        }
      }
      return str;
    };
    
    /**
     * Get a string representation of the matrix
     * @memberof SparseMatrix
     * @returns {string} str
     */
    SparseMatrix.prototype.toString = function () {
      return string$3.format(this.toArray());
    };
    
    /**
     * Get a JSON representation of the matrix
     * @memberof SparseMatrix
     * @returns {Object}
     */
    SparseMatrix.prototype.toJSON = function () {
      return {
        mathjs: 'SparseMatrix',
        values: this._values,
        index: this._index,
        ptr: this._ptr,
        size: this._size,
        datatype: this._datatype
      };
    };

    /**
     * Get the kth Matrix diagonal.
     *
     * @memberof SparseMatrix
     * @param {number | BigNumber} [k=0]     The kth diagonal where the vector will retrieved.
     *
     * @returns {Matrix}                     The matrix vector with the diagonal values.
     */
    SparseMatrix.prototype.diagonal = function(k) {
      // validate k if any
      if (k) {
        // convert BigNumber to a number
        if (type.isBigNumber(k))
          k = k.toNumber();
        // is must be an integer
        if (!isNumber$2(k) || !isInteger$1(k)) {
          throw new TypeError ('The parameter k must be an integer number');
        }
      }
      else {
        // default value
        k = 0;
      }

      var kSuper = k > 0 ? k : 0;
      var kSub = k < 0 ? -k : 0;
      
      // rows & columns
      var rows = this._size[0];
      var columns = this._size[1];
      
      // number diagonal values
      var n = Math.min(rows - kSub, columns -  kSuper);
      
      // diagonal arrays
      var values = [];
      var index = [];
      var ptr = [];
      // initial ptr value
      ptr[0] = 0;
      // loop columns
      for (var j = kSuper; j < columns && values.length < n; j++) {
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = this._ptr[j];
        var k1 = this._ptr[j + 1];
        // loop x within [k0, k1[
        for (var x = k0; x < k1; x++) {
          // row index
          var i = this._index[x];
          // check row
          if (i === j - kSuper + kSub) {
            // value on this column
            values.push(this._values[x]);
            // store row
            index[values.length - 1] = i - kSub;
            // exit loop
            break;
          }
        }
      }
      // close ptr
      ptr.push(values.length);
      // return matrix
      return new SparseMatrix({
        values: values,
        index: index,
        ptr: ptr,
        size: [n, 1]
      });
    };
    
    /**
     * Generate a matrix from a JSON object
     * @memberof SparseMatrix
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SparseMatrix", "values": [], "index": [], "ptr": [], "size": []}`,
     *                       where mathjs is optional
     * @returns {SparseMatrix}
     */
    SparseMatrix.fromJSON = function (json) {
      return new SparseMatrix(json);
    };

    /**
     * Create a diagonal matrix.
     *
     * @memberof SparseMatrix
     * @param {Array} size                       The matrix size.
     * @param {number | Array | Matrix } value   The values for the diagonal.
     * @param {number | BigNumber} [k=0]         The kth diagonal where the vector will be filled in.
     * @param {string} [datatype]                The Matrix datatype, values must be of this datatype.
     *
     * @returns {SparseMatrix}
     */
    SparseMatrix.diagonal = function (size, value, k, defaultValue, datatype) {
      if (!isArray$1(size))
        throw new TypeError('Array expected, size parameter');
      if (size.length !== 2)
        throw new Error('Only two dimensions matrix are supported');
      
      // map size & validate
      size = size.map(function (s) {
        // check it is a big number
        if (type.isBigNumber(s)) {
          // convert it
          s = s.toNumber();
        }
        // validate arguments
        if (!isNumber$2(s) || !isInteger$1(s) || s < 1) {
          throw new Error('Size values must be positive integers');
        } 
        return s;
      });
      
      // validate k if any
      if (k) {
        // convert BigNumber to a number
        if (type.isBigNumber(k))
          k = k.toNumber();
        // is must be an integer
        if (!isNumber$2(k) || !isInteger$1(k)) {
          throw new TypeError ('The parameter k must be an integer number');
        }
      }
      else {
        // default value
        k = 0;
      }

      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      if (isString$2(datatype)) {
        // find signature that matches (datatype, datatype)
        eq = typed.find(equalScalar$$1, [datatype, datatype]) || equalScalar$$1;
        // convert 0 to the same datatype
        zero = typed.convert(0, datatype);
      }
      
      var kSuper = k > 0 ? k : 0;
      var kSub = k < 0 ? -k : 0;
      
      // rows and columns
      var rows = size[0];
      var columns = size[1];
      
      // number of non-zero items
      var n = Math.min(rows - kSub, columns -  kSuper);
      
      // value extraction function
      var _value;
        
      // check value
      if (isArray$1(value)) {
        // validate array
        if (value.length !== n) {
          // number of values in array must be n
          throw new Error('Invalid value array length');
        }
        // define function
        _value = function (i) {
          // return value @ i
          return value[i];
        };
      }
      else if (type.isMatrix(value)) {
        // matrix size
        var ms = value.size();
        // validate matrix
        if (ms.length !== 1 || ms[0] !== n) {
          // number of values in array must be n
          throw new Error('Invalid matrix length');
        }
        // define function
        _value = function (i) {
          // return value @ i
          return value.get([i]);
        };
      }
      else {
        // define function
        _value = function () {
          // return value
          return value;
        };
      }
      
      // create arrays
      var values = [];
      var index = [];
      var ptr = [];
      
      // loop items
      for (var j = 0; j < columns; j++) {
        // number of rows with value
        ptr.push(values.length);
        // diagonal index
        var i = j - kSuper;      
        // check we need to set diagonal value
        if (i >= 0 && i < n) {
          // get value @ i
          var v = _value(i);
          // check for zero
          if (!eq(v, zero)) {
            // column
            index.push(i + kSub);
            // add value
            values.push(v);
          }
        }
      }
      // last value should be number of values
      ptr.push(values.length);
      // create SparseMatrix
      return new SparseMatrix({
        values: values,
        index: index,
        ptr: ptr,
        size: [rows, columns]
      });
    };
    
    /**
     * Swap rows i and j in Matrix.
     *
     * @memberof SparseMatrix
     * @param {number} i       Matrix row index 1
     * @param {number} j       Matrix row index 2
     *
     * @return {Matrix}        The matrix reference
     */
    SparseMatrix.prototype.swapRows = function (i, j) {
      // check index
      if (!isNumber$2(i) || !isInteger$1(i) || !isNumber$2(j) || !isInteger$1(j)) {
        throw new Error('Row index must be positive integers');
      }
      // check dimensions
      if (this._size.length !== 2) {
        throw new Error('Only two dimensional matrix is supported');
      }
      // validate index
      validateIndex$1(i, this._size[0]);
      validateIndex$1(j, this._size[0]);
      
      // swap rows
      SparseMatrix._swapRows(i, j, this._size[1], this._values, this._index, this._ptr);
      // return current instance
      return this;
    };
    
    /**
     * Loop rows with data in column j.
     *
     * @param {number} j            Column
     * @param {Array} values        Matrix values
     * @param {Array} index         Matrix row indeces
     * @param {Array} ptr           Matrix column pointers
     * @param {Function} callback   Callback function invoked for every row in column j
     */
    SparseMatrix._forEachRow = function (j, values, index, ptr, callback) {
      // indeces for column j
      var k0 = ptr[j];
      var k1 = ptr[j + 1];
      // loop
      for (var k = k0; k < k1; k++) {
        // invoke callback
        callback(index[k], values[k]);
      }
    };
    
    /**
     * Swap rows x and y in Sparse Matrix data structures.
     *
     * @param {number} x         Matrix row index 1
     * @param {number} y         Matrix row index 2
     * @param {number} columns   Number of columns in matrix
     * @param {Array} values     Matrix values
     * @param {Array} index      Matrix row indeces
     * @param {Array} ptr        Matrix column pointers
     */
    SparseMatrix._swapRows = function (x, y, columns, values, index, ptr) {
      // loop columns
      for (var j = 0; j < columns; j++) {
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = ptr[j];
        var k1 = ptr[j + 1];
        // find value index @ x
        var kx = _getValueIndex(x, k0, k1, index);
        // find value index @ x
        var ky = _getValueIndex(y, k0, k1, index);
        // check both rows exist in matrix
        if (kx < k1 && ky < k1 && index[kx] === x && index[ky] === y) {
          // swap values (check for pattern matrix)
          if (values) {
            var v = values[kx];
            values[kx] = values[ky];
            values[ky] = v;
          }
          // next column
          continue;
        }
        // check x row exist & no y row
        if (kx < k1 && index[kx] === x && (ky >= k1 || index[ky] !== y)) {
          // value @ x (check for pattern matrix)
          var vx = values ? values[kx] : undefined;
          // insert value @ y
          index.splice(ky, 0, y);
          if (values)
            values.splice(ky, 0, vx);        
          // remove value @ x (adjust array index if needed)
          index.splice(ky <= kx ? kx + 1 : kx, 1);
          if (values)
            values.splice(ky <= kx ? kx + 1 : kx, 1);
          // next column
          continue;
        }
        // check y row exist & no x row
        if (ky < k1 && index[ky] === y && (kx >= k1 || index[kx] !== x)) {
          // value @ y (check for pattern matrix)
          var vy = values ? values[ky] : undefined;
          // insert value @ x
          index.splice(kx, 0, x);
          if (values)
            values.splice(kx, 0, vy);
          // remove value @ y (adjust array index if needed)
          index.splice(kx <= ky ? ky + 1 : ky, 1);
          if (values)
            values.splice(kx <= ky ? ky + 1 : ky, 1);
        }
      }
    };

    // register this type in the base class Matrix
    type.Matrix._storage.sparse = SparseMatrix;

    return SparseMatrix;
  }

  var name$13 = 'SparseMatrix';
  var path$6 = 'type';
  var factory_1$14 = factory$14;
  var lazy$3 = false;  // no lazy loading, as we alter type.Matrix._storage

  var SparseMatrix = {
  	name: name$13,
  	path: path$6,
  	factory: factory_1$14,
  	lazy: lazy$3
  };

  function factory$15 (type, config, load, typed) {
    /**
     * Create a Matrix. The function creates a new `math.type.Matrix` object from
     * an `Array`. A Matrix has utility functions to manipulate the data in the
     * matrix, like getting the size and getting or setting values in the matrix.
     * Supported storage formats are 'dense' and 'sparse'.
     *
     * Syntax:
     *
     *    math.matrix()                         // creates an empty matrix using default storage format (dense).
     *    math.matrix(data)                     // creates a matrix with initial data using default storage format (dense).
     *    math.matrix('dense')                  // creates an empty matrix using the given storage format.
     *    math.matrix(data, 'dense')            // creates a matrix with initial data using the given storage format.
     *    math.matrix(data, 'sparse')           // creates a sparse matrix with initial data.
     *    math.matrix(data, 'sparse', 'number') // creates a sparse matrix with initial data, number data type.
     *
     * Examples:
     *
     *    var m = math.matrix([[1, 2], [3, 4]]);
     *    m.size();                        // Array [2, 2]
     *    m.resize([3, 2], 5);
     *    m.valueOf();                     // Array [[1, 2], [3, 4], [5, 5]]
     *    m.get([1, 0])                    // number 3
     *
     * See also:
     *
     *    bignumber, boolean, complex, index, number, string, unit, sparse
     *
     * @param {Array | Matrix} [data]    A multi dimensional array
     * @param {string} [format]          The Matrix storage format
     *
     * @return {Matrix} The created matrix
     */
    var matrix = typed('matrix', {
      '': function () {
        return _create([]);
      },

      'string': function (format) {
        return _create([], format);
      },
      
      'string, string': function (format, datatype) {
        return _create([], format, datatype);
      },

      'Array': function (data) {
        return _create(data);
      },
        
      'Matrix': function (data) {
        return _create(data, data.storage());
      },
      
      'Array | Matrix, string': _create,
      
      'Array | Matrix, string, string': _create
    });

    matrix.toTex = {
      0: '\\begin{bmatrix}\\end{bmatrix}',
      1: '\\left(${args[0]}\\right)',
      2: '\\left(${args[0]}\\right)'
    };

    return matrix;

    /**
     * Create a new Matrix with given storage format
     * @param {Array} data
     * @param {string} [format]
     * @param {string} [datatype]
     * @returns {Matrix} Returns a new Matrix
     * @private
     */
    function _create(data, format, datatype) {
      // get storage format constructor
      var M = type.Matrix.storage(format || 'default');

      // create instance
      return new M(data, datatype);
    }
  }

  var name$14 = 'matrix';
  var factory_1$15 = factory$15;

  var matrix = {
  	name: name$14,
  	factory: factory_1$15
  };

  function factory$16(type, config, load, typed) {

    /**
     * Add two scalar values, `x + y`.
     * This function is meant for internal use: it is used by the public function
     * `add`
     *
     * This function does not support collections (Array or Matrix), and does
     * not validate the number of of inputs.
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to add
     * @param  {number | BigNumber | Fraction | Complex} y          Second value to add
     * @return {number | BigNumber | Fraction | Complex | Unit}                      Sum of `x` and `y`
     * @private
     */
    var add = typed('add', {

      'number, number': function (x, y) {
        return x + y;
      },

      'Complex, Complex': function (x, y) {
        return x.add(y);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.plus(y);
      },

      'Fraction, Fraction': function (x, y) {
        return x.add(y);
      },

      'Unit, Unit': function (x, y) {
        if (x.value == null) throw new Error('Parameter x contains a unit with undefined value');
        if (y.value == null) throw new Error('Parameter y contains a unit with undefined value');
        if (!x.equalBase(y)) throw new Error('Units do not match');

        var res = x.clone();
        res.value = add(res.value, y.value);
        res.fixPrefix = false;
        return res;
      }
    });

    return add;
  }

  var factory_1$16 = factory$16;

  var addScalar = {
  	factory: factory_1$16
  };

  function factory$17 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij). 
     * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
     *
     *
     *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
     * C(i,j) = ┤
     *          └  Dij          ; otherwise
     *
     *
     * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
     * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
     * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
     */
    var algorithm01 = function (denseMatrix, sparseMatrix, callback, inverse) {
      // dense matrix arrays
      var adata = denseMatrix._data;
      var asize = denseMatrix._size;
      var adt = denseMatrix._datatype;
      // sparse matrix arrays
      var bvalues = sparseMatrix._values;
      var bindex = sparseMatrix._index;
      var bptr = sparseMatrix._ptr;
      var bsize = sparseMatrix._size;
      var bdt = sparseMatrix._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // sparse matrix cannot be a Pattern matrix
      if (!bvalues)
        throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // process data types
      var dt = typeof adt === 'string' && adt === bdt ? adt : undefined;
      // callback function
      var cf = dt ? typed.find(callback, [dt, dt]) : callback;

      // vars
      var i, j;
      
      // result (DenseMatrix)
      var cdata = [];
      // initialize c
      for (i = 0; i < rows; i++)
        cdata[i] = [];      
      
      // workspace
      var x = [];
      // marks indicating we have a value in x for a given column
      var w = [];

      // loop columns in b
      for (j = 0; j < columns; j++) {
        // column mark
        var mark = j + 1;
        // values in column j
        for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
          // row
          i = bindex[k];
          // update workspace
          x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
          // mark i as updated
          w[i] = mark;
        }
        // loop rows
        for (i = 0; i < rows; i++) {
          // check row is in workspace
          if (w[i] === mark) {
            // c[i][j] was already calculated
            cdata[i][j] = x[i];
          }
          else {
            // item does not exist in S
            cdata[i][j] = adata[i][j];
          }
        }
      }

      // return dense matrix
      return new DenseMatrix({
        data: cdata,
        size: [rows, columns],
        datatype: dt
      });
    };
    
    return algorithm01;
  }

  var name$15 = 'algorithm01';
  var factory_1$17 = factory$17;

  var algorithm01 = {
  	name: name$15,
  	factory: factory_1$17
  };

  function factory$18 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
     * Callback function invoked MAX(NNZA, NNZB) times
     *
     *
     *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
     * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
     *          └  B(i,j)       ; B(i,j) !== 0
     *
     *
     * @param {Matrix}   a                 The SparseMatrix instance (A)
     * @param {Matrix}   b                 The SparseMatrix instance (B)
     * @param {Function} callback          The f(Aij,Bij) operation to invoke
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
     */
    var algorithm04 = function (a, b, callback) {
      // sparse matrix arrays
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      var adt = a._datatype;
      // sparse matrix arrays
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      var bsize = b._size;
      var bdt = b._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cvalues = avalues && bvalues ? [] : undefined;
      var cindex = [];
      var cptr = [];
      // matrix
      var c = new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });

      // workspace
      var xa = avalues && bvalues ? [] : undefined;
      var xb = avalues && bvalues ? [] : undefined;
      // marks indicating we have a value in x for a given column
      var wa = [];
      var wb = [];

      // vars 
      var i, j, k, k0, k1;
      
      // loop columns
      for (j = 0; j < columns; j++) {
        // update cptr
        cptr[j] = cindex.length;
        // columns mark
        var mark = j + 1;
        // loop A(:,j)
        for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
          // row
          i = aindex[k];
          // update c
          cindex.push(i);
          // update workspace
          wa[i] = mark;
          // check we need to process values
          if (xa)
            xa[i] = avalues[k];
        }
        // loop B(:,j)
        for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
          // row
          i = bindex[k];
          // check row exists in A
          if (wa[i] === mark) {
            // update record in xa @ i
            if (xa) {
              // invoke callback
              var v = cf(xa[i], bvalues[k]);
              // check for zero
              if (!eq(v, zero)) {
                // update workspace
                xa[i] = v;              
              }
              else {
                // remove mark (index will be removed later)
                wa[i] = null;
              }
            }
          }
          else {
            // update c
            cindex.push(i);
            // update workspace
            wb[i] = mark;
            // check we need to process values
            if (xb)
              xb[i] = bvalues[k];
          }
        }
        // check we need to process values (non pattern matrix)
        if (xa && xb) {
          // initialize first index in j
          k = cptr[j];
          // loop index in j
          while (k < cindex.length) {
            // row
            i = cindex[k];
            // check workspace has value @ i
            if (wa[i] === mark) {
              // push value (Aij != 0 || (Aij != 0 && Bij != 0))
              cvalues[k] = xa[i];
              // increment pointer
              k++;
            }
            else if (wb[i] === mark) {
              // push value (bij != 0)
              cvalues[k] = xb[i];
              // increment pointer
              k++;
            }
            else {
              // remove index @ k
              cindex.splice(k, 1);
            }
          }
        }
      }
      // update cptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return c;
    };
    
    return algorithm04;
  }

  var name$16 = 'algorithm04';
  var factory_1$18 = factory$18;

  var algorithm04 = {
  	name: name$16,
  	factory: factory_1$18
  };

  function factory$19 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b). 
     * Callback function invoked NZ times (number of nonzero items in S).
     *
     *
     *          ┌  f(Sij, b)  ; S(i,j) !== 0
     * C(i,j) = ┤  
     *          └  b          ; otherwise
     *
     *
     * @param {Matrix}   s                 The SparseMatrix instance (S)
     * @param {Scalar}   b                 The Scalar value
     * @param {Function} callback          The f(Aij,b) operation to invoke
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
     */
    var algorithm10 = function (s, b, callback, inverse) {
      // sparse matrix arrays
      var avalues = s._values;
      var aindex = s._index;
      var aptr = s._ptr;
      var asize = s._size;
      var adt = s._datatype;

      // sparse matrix cannot be a Pattern matrix
      if (!avalues)
        throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string') {
        // datatype
        dt = adt;
        // convert b to the same datatype
        b = typed.convert(b, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cdata = [];
      // matrix
      var c = new DenseMatrix({
        data: cdata,
        size: [rows, columns],
        datatype: dt
      });

      // workspaces
      var x = [];
      // marks indicating we have a value in x for a given column
      var w = [];

      // loop columns
      for (var j = 0; j < columns; j++) {
        // columns mark
        var mark = j + 1;
        // values in j
        for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
          // row
          var r = aindex[k];
          // update workspace
          x[r] = avalues[k];
          w[r] = mark;
        }
        // loop rows
        for (var i = 0; i < rows; i++) {
          // initialize C on first column
          if (j === 0) {
            // create row array
            cdata[i] = [];
          }
          // check sparse matrix has a value @ i,j
          if (w[i] === mark) {
            // invoke callback, update C
            cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
          }
          else {
            // dense matrix value @ i, j
            cdata[i][j] = b;
          }
        }
      }

      // return sparse matrix
      return c;
    };

    return algorithm10;
  }

  var name$17 = 'algorithm10';
  var factory_1$19 = factory$19;

  var algorithm10 = {
  	name: name$17,
  	factory: factory_1$19
  };

  var string$4 = utils.string,
      isString$3 = string$4.isString;

  function factory$20 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, Bij..z). 
     * Callback function invoked MxN times.
     *
     * C(i,j,...z) = f(Aij..z, Bij..z)
     *
     * @param {Matrix}   a                 The DenseMatrix instance (A)
     * @param {Matrix}   b                 The DenseMatrix instance (B)
     * @param {Function} callback          The f(Aij..z,Bij..z) operation to invoke
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * https://github.com/josdejong/mathjs/pull/346#issuecomment-97658658
     */
    var algorithm13 = function (a, b, callback) {
      // a arrays
      var adata = a._data;
      var asize = a._size;
      var adt = a._datatype;
      // b arrays
      var bdata = b._data;
      var bsize = b._size;
      var bdt = b._datatype;
      // c arrays
      var csize = [];

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // validate each one of the dimension sizes
      for (var s = 0; s < asize.length; s++) {
        // must match
        if (asize[s] !== bsize[s])
          throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');
        // update dimension in c
        csize[s] = asize[s];
      }

      // datatype
      var dt;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // convert b to the same datatype
        b = typed.convert(b, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // populate cdata, iterate through dimensions
      var cdata = csize.length > 0 ? _iterate(cf, 0, csize, csize[0], adata, bdata) : [];
      
      // c matrix
      return new DenseMatrix({
        data: cdata,
        size: csize,
        datatype: dt
      });
    };
    
    // recursive function
    var _iterate = function (f, level, s, n, av, bv) {
      // initialize array for this level
      var cv = [];
      // check we reach the last level
      if (level === s.length - 1) {
        // loop arrays in last level
        for (var i = 0; i < n; i++) {
          // invoke callback and store value
          cv[i] = f(av[i], bv[i]);
        }
      }
      else {
        // iterate current level
        for (var j = 0; j < n; j++) {
          // iterate next level
          cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv[j]);
        }
      }
      return cv;
    };
    
    return algorithm13;
  }

  var name$18 = 'algorithm13';
  var factory_1$20 = factory$20;

  var algorithm13 = {
  	name: name$18,
  	factory: factory_1$20
  };

  var clone = object.clone;

  function factory$21 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over DenseMatrix items and invokes the callback function f(Aij..z, b). 
     * Callback function invoked MxN times.
     *
     * C(i,j,...z) = f(Aij..z, b)
     *
     * @param {Matrix}   a                 The DenseMatrix instance (A)
     * @param {Scalar}   b                 The Scalar value
     * @param {Function} callback          The f(Aij..z,b) operation to invoke
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Aij..z)
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * https://github.com/josdejong/mathjs/pull/346#issuecomment-97659042
     */
    var algorithm14 = function (a, b, callback, inverse) {
      // a arrays
      var adata = a._data;
      var asize = a._size;
      var adt = a._datatype;
      
      // datatype
      var dt;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string') {
        // datatype
        dt = adt;
        // convert b to the same datatype
        b = typed.convert(b, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }
      
      // populate cdata, iterate through dimensions
      var cdata = asize.length > 0 ? _iterate(cf, 0, asize, asize[0], adata, b, inverse) : [];

      // c matrix
      return new DenseMatrix({
        data: cdata,
        size: clone(asize),
        datatype: dt
      });
    };
    
    // recursive function
    var _iterate = function (f, level, s, n, av, bv, inverse) {
      // initialize array for this level
      var cv = [];
      // check we reach the last level
      if (level === s.length - 1) {
        // loop arrays in last level
        for (var i = 0; i < n; i++) {
          // invoke callback and store value
          cv[i] = inverse ? f(bv, av[i]) : f(av[i], bv);
        }
      }
      else {
        // iterate current level
        for (var j = 0; j < n; j++) {
          // iterate next level
          cv[j] = _iterate(f, level + 1, s, s[level + 1], av[j], bv, inverse);
        }
      }
      return cv;
    };

    return algorithm14;
  }

  var name$19 = 'algorithm14';
  var factory_1$21 = factory$21;

  var algorithm14 = {
  	name: name$19,
  	factory: factory_1$21
  };

  var extend = object.extend;

  function factory$22 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var addScalar$$1 = load(addScalar);
    var latex$$1 = latex;
    
    var algorithm01$$1 = load(algorithm01);
    var algorithm04$$1 = load(algorithm04);
    var algorithm10$$1 = load(algorithm10);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Add two or more values, `x + y`.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.add(x, y)
     *    math.add(x, y, z, ...)
     *
     * Examples:
     *
     *    math.add(2, 3);               // returns number 5
     *    math.add(2, 3, 4);            // returns number 9
     *
     *    var a = math.complex(2, 3);
     *    var b = math.complex(-4, 1);
     *    math.add(a, b);               // returns Complex -2 + 4i
     *
     *    math.add([1, 2, 3], 4);       // returns Array [5, 6, 7]
     *
     *    var c = math.unit('5 cm');
     *    var d = math.unit('2.1 mm');
     *    math.add(c, d);               // returns Unit 52.1 mm
     *
     *    math.add("2.3", "4");         // returns number 6.3
     *
     * See also:
     *
     *    subtract, sum
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to add
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to add
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Sum of `x` and `y`
     */
    var add = typed('add', extend({
      // we extend the signatures of addScalar with signatures dealing with matrices

      'DenseMatrix, DenseMatrix': function (x, y) {
        return algorithm13$$1(x, y, addScalar$$1);
      },

      'DenseMatrix, SparseMatrix': function (x, y) {
        return algorithm01$$1(x, y, addScalar$$1, false);
      },

      'SparseMatrix, DenseMatrix': function (x, y) {
        return algorithm01$$1(y, x, addScalar$$1, true);
      },

      'SparseMatrix, SparseMatrix': function (x, y) {
        return algorithm04$$1(x, y, addScalar$$1);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return add(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return add(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return add(x, matrix$$1(y));
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, addScalar$$1, false);
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm10$$1(x, y, addScalar$$1, false);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, addScalar$$1, true);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm10$$1(y, x, addScalar$$1, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, addScalar$$1, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, addScalar$$1, true).valueOf();
      },

      'any, any': addScalar$$1,

      'any, any, ...any': function (x, y, rest) {
        var result = add(x, y);

        for (var i = 0; i < rest.length; i++) {
          result = add(result, rest[i]);
        }

        return result;
      }
    }, addScalar$$1.signatures));

    add.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['add'] + '${args[1]}\\right)'
    };
    
    return add;
  }

  var name$20 = 'add';
  var factory_1$22 = factory$22;

  var add = {
  	name: name$20,
  	factory: factory_1$22
  };

  function factory$23 (type, config, load) {
    
    var add$$1 = load(add);
    var equalScalar$$1 = load(equalScalar);
    
    /**
     * An ordered Sparse Accumulator is a representation for a sparse vector that includes a dense array 
     * of the vector elements and an ordered list of non-zero elements.
     */
    function Spa() {
      if (!(this instanceof Spa))
        throw new SyntaxError('Constructor must be called with the new operator');
      
      // allocate vector, TODO use typed arrays
      this._values = [];
      this._heap = new type.FibonacciHeap();
    }

    /**
     * Attach type information
     */
    Spa.prototype.type = 'Spa';
    Spa.prototype.isSpa = true;

    /**
     * Set the value for index i.
     *
     * @param {number} i                       The index
     * @param {number | BigNumber | Complex}   The value at index i
     */
    Spa.prototype.set = function (i, v) {
      // check we have a value @ i
      if (!this._values[i]) {
        // insert in heap
        var node = this._heap.insert(i, v);
        // set the value @ i
        this._values[i] = node;
      }
      else {
        // update the value @ i
        this._values[i].value = v;
      }
    };
    
    Spa.prototype.get = function (i) {
      var node = this._values[i];
      if (node)
        return node.value;
      return 0;
    };
    
    Spa.prototype.accumulate = function (i, v) {
      // node @ i
      var node = this._values[i];
      if (!node) {
        // insert in heap
        node = this._heap.insert(i, v);
        // initialize value
        this._values[i] = node;
      }
      else {
        // accumulate value
        node.value = add$$1(node.value, v);
      }
    };
    
    Spa.prototype.forEach = function (from, to, callback) {
      // references
      var heap = this._heap;
      var values = this._values;
      // nodes
      var nodes = [];
      // node with minimum key, save it
      var node = heap.extractMinimum();
      if (node)
        nodes.push(node);
      // extract nodes from heap (ordered)
      while (node && node.key <= to) {
        // check it is in range
        if (node.key >= from) {
          // check value is not zero
          if (!equalScalar$$1(node.value, 0)) {
            // invoke callback
            callback(node.key, node.value, this);
          }
        }
        // extract next node, save it
        node = heap.extractMinimum();
        if (node)
          nodes.push(node);
      }
      // reinsert all nodes in heap
      for (var i = 0; i < nodes.length; i++) {
        // current node
        var n = nodes[i];
        // insert node in heap
        node = heap.insert(n.key, n.value);
        // update values
        values[node.key] = node;
      }
    };
    
    Spa.prototype.swap = function (i, j) {
      // node @ i and j
      var nodei = this._values[i];
      var nodej = this._values[j];
      // check we need to insert indeces
      if (!nodei && nodej) {
        // insert in heap
        nodei = this._heap.insert(i, nodej.value);
        // remove from heap
        this._heap.remove(nodej);
        // set values
        this._values[i] = nodei;
        this._values[j] = undefined;
      }
      else if (nodei && !nodej) {
        // insert in heap
        nodej = this._heap.insert(j, nodei.value);
        // remove from heap
        this._heap.remove(nodei);
        // set values
        this._values[j] = nodej;
        this._values[i] = undefined;
      }
      else if (nodei && nodej) {
        // swap values
        var v = nodei.value;
        nodei.value = nodej.value;
        nodej.value = v;
      }
    };
    
    return Spa;
  }

  var name$21 = 'Spa';
  var path$7 = 'type';
  var factory_1$23 = factory$23;

  var Spa = {
  	name: name$21,
  	path: path$7,
  	factory: factory_1$23
  };

  function factory$24 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over SparseMatrix items and invokes the callback function f(Dij, Sij).
     * Callback function invoked M*N times.
     *
     *
     *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
     * C(i,j) = ┤
     *          └  f(Dij, 0)    ; otherwise
     *
     *
     * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
     * @param {Matrix}   sparseMatrix      The SparseMatrix instance (C)
     * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
     */
    var algorithm03 = function (denseMatrix, sparseMatrix, callback, inverse) {
      // dense matrix arrays
      var adata = denseMatrix._data;
      var asize = denseMatrix._size;
      var adt = denseMatrix._datatype;
      // sparse matrix arrays
      var bvalues = sparseMatrix._values;
      var bindex = sparseMatrix._index;
      var bptr = sparseMatrix._ptr;
      var bsize = sparseMatrix._size;
      var bdt = sparseMatrix._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // sparse matrix cannot be a Pattern matrix
      if (!bvalues)
        throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result (DenseMatrix)
      var cdata = [];

      // initialize dense matrix
      for (var z = 0; z < rows; z++) {
        // initialize row
        cdata[z] = [];
      }

      // workspace
      var x = [];
      // marks indicating we have a value in x for a given column
      var w = [];

      // loop columns in b
      for (var j = 0; j < columns; j++) {
        // column mark
        var mark = j + 1;
        // values in column j
        for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
          // row
          var i = bindex[k];
          // update workspace
          x[i] = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
          w[i] = mark;
        }
        // process workspace
        for (var y = 0; y < rows; y++) {
          // check we have a calculated value for current row
          if (w[y] === mark) {
            // use calculated value
            cdata[y][j] = x[y];
          }
          else {
            // calculate value
            cdata[y][j] = inverse ? cf(zero, adata[y][j]) : cf(adata[y][j], zero);
          }
        }
      }

      // return dense matrix
      return new DenseMatrix({
        data: cdata,
        size: [rows, columns],
        datatype: dt
      });
    };
    
    return algorithm03;
  }

  var name$22 = 'algorithm03';
  var factory_1$24 = factory$24;

  var algorithm03 = {
  	name: name$22,
  	factory: factory_1$24
  };

  function factory$25 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over SparseMatrix A and SparseMatrix B items (zero and nonzero) and invokes the callback function f(Aij, Bij). 
     * Callback function invoked MxN times.
     *
     * C(i,j) = f(Aij, Bij)
     *
     * @param {Matrix}   a                 The SparseMatrix instance (A)
     * @param {Matrix}   b                 The SparseMatrix instance (B)
     * @param {Function} callback          The f(Aij,Bij) operation to invoke
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
     */
    var algorithm07 = function (a, b, callback) {
      // sparse matrix arrays
      var asize = a._size;
      var adt = a._datatype;
      // sparse matrix arrays
      var bsize = b._size;
      var bdt = b._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // vars
      var i, j;
      
      // result arrays
      var cdata = [];
      // initialize c
      for (i = 0; i < rows; i++)
        cdata[i] = [];

      // matrix
      var c = new DenseMatrix({
        data: cdata,
        size: [rows, columns],
        datatype: dt
      });

      // workspaces
      var xa = [];
      var xb = [];
      // marks indicating we have a value in x for a given column
      var wa = [];
      var wb = [];

      // loop columns
      for (j = 0; j < columns; j++) {
        // columns mark
        var mark = j + 1;
        // scatter the values of A(:,j) into workspace
        _scatter(a, j, wa, xa, mark);
        // scatter the values of B(:,j) into workspace
        _scatter(b, j, wb, xb, mark);
        // loop rows
        for (i = 0; i < rows; i++) {
          // matrix values @ i,j
          var va = wa[i] === mark ? xa[i] : zero;
          var vb = wb[i] === mark ? xb[i] : zero;
          // invoke callback
          cdata[i][j] = cf(va, vb);
        }          
      }

      // return sparse matrix
      return c;
    };
    
    var _scatter = function (m, j, w, x, mark) {
      // a arrays
      var values = m._values;
      var index = m._index;
      var ptr = m._ptr;
      // loop values in column j
      for (var k = ptr[j], k1 = ptr[j + 1]; k < k1; k++) {
        // row
        var i = index[k];
        // update workspace
        w[i] = mark;
        x[i] = values[k];
      }
    };
    
    return algorithm07;
  }

  var name$23 = 'algorithm07';
  var factory_1$25 = factory$25;

  var algorithm07 = {
  	name: name$23,
  	factory: factory_1$25
  };

  function factory$26 (type, config, load, typed) {

    var DenseMatrix = type.DenseMatrix;

    /**
     * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b). 
     * Callback function invoked MxN times.
     *
     *
     *          ┌  f(Sij, b)  ; S(i,j) !== 0
     * C(i,j) = ┤  
     *          └  f(0, b)    ; otherwise
     *
     *
     * @param {Matrix}   s                 The SparseMatrix instance (S)
     * @param {Scalar}   b                 The Scalar value
     * @param {Function} callback          The f(Aij,b) operation to invoke
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
     *
     * @return {Matrix}                    DenseMatrix (C)
     *
     * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
     */
    var algorithm12 = function (s, b, callback, inverse) {
      // sparse matrix arrays
      var avalues = s._values;
      var aindex = s._index;
      var aptr = s._ptr;
      var asize = s._size;
      var adt = s._datatype;

      // sparse matrix cannot be a Pattern matrix
      if (!avalues)
        throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string') {
        // datatype
        dt = adt;
        // convert b to the same datatype
        b = typed.convert(b, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }
      
      // result arrays
      var cdata = [];
      // matrix
      var c = new DenseMatrix({
        data: cdata,
        size: [rows, columns],
        datatype: dt
      });

      // workspaces
      var x = [];
      // marks indicating we have a value in x for a given column
      var w = [];

      // loop columns
      for (var j = 0; j < columns; j++) {
        // columns mark
        var mark = j + 1;
        // values in j
        for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
          // row
          var r = aindex[k];
          // update workspace
          x[r] = avalues[k];
          w[r] = mark;
        }
        // loop rows
        for (var i = 0; i < rows; i++) {
          // initialize C on first column
          if (j === 0) {
            // create row array
            cdata[i] = [];
          }
          // check sparse matrix has a value @ i,j
          if (w[i] === mark) {
            // invoke callback, update C
            cdata[i][j] = inverse ? cf(b, x[i]) : cf(x[i], b);
          }
          else {
            // dense matrix value @ i, j
            cdata[i][j] = inverse ? cf(b, 0) : cf(0, b);
          }
        }
      }

      // return sparse matrix
      return c;
    };
    
    return algorithm12;
  }

  var name$24 = 'algorithm12';
  var factory_1$26 = factory$26;

  var algorithm12 = {
  	name: name$24,
  	factory: factory_1$26
  };

  var nearlyEqual$2 = number.nearlyEqual;


  function factory$27 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    var latex$$1 = latex;

    /**
     * Test whether value x is smaller than y.
     *
     * The function returns true when x is smaller than y and the relative
     * difference between x and y is smaller than the configured epsilon. The
     * function cannot be used to compare values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.smaller(x, y)
     *
     * Examples:
     *
     *    math.smaller(2, 3);            // returns true
     *    math.smaller(5, 2 * 2);        // returns false
     *
     *    var a = math.unit('5 cm');
     *    var b = math.unit('2 inch');
     *    math.smaller(a, b);            // returns true
     *
     * See also:
     *
     *    equal, unequal, smallerEq, smaller, smallerEq, compare
     *
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
     * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
     */
    var smaller = typed('smaller', {

      'boolean, boolean': function (x, y) {
        return x < y;
      },

      'number, number': function (x, y) {
        return x < y && !nearlyEqual$2(x, y, config.epsilon);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.lt(y) && !nearlyEqual(x, y, config.epsilon);
      },

      'Fraction, Fraction': function (x, y) {
        return x.compare(y) === -1;
      },

      'Complex, Complex': function (x, y) {
        throw new TypeError('No ordering relation is defined for complex numbers');
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return smaller(x.value, y.value);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, smaller);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, smaller, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, smaller, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, smaller);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return smaller(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return smaller(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return smaller(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, smaller, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, smaller, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, smaller, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, smaller, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, smaller, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, smaller, true).valueOf();
      }
    });

    smaller.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['smaller'] + '${args[1]}\\right)'
    };

    return smaller;
  }

  var name$25 = 'smaller';
  var factory_1$27 = factory$27;

  var smaller = {
  	name: name$25,
  	factory: factory_1$27
  };

  var nearlyEqual$3 = number.nearlyEqual;


  function factory$28 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    var latex$$1 = latex;

    /**
     * Test whether value x is larger than y.
     *
     * The function returns true when x is larger than y and the relative
     * difference between x and y is larger than the configured epsilon. The
     * function cannot be used to compare values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.larger(x, y)
     *
     * Examples:
     *
     *    math.larger(2, 3);             // returns false
     *    math.larger(5, 2 + 2);         // returns true
     *
     *    var a = math.unit('5 cm');
     *    var b = math.unit('2 inch');
     *    math.larger(a, b);             // returns false
     *
     * See also:
     *
     *    equal, unequal, smaller, smallerEq, largerEq, compare
     *
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
     * @return {boolean | Array | Matrix} Returns true when the x is larger than y, else returns false
     */
    var larger = typed('larger', {

      'boolean, boolean': function (x, y) {
        return x > y;
      },

      'number, number': function (x, y) {
        return x > y && !nearlyEqual$3(x, y, config.epsilon);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.gt(y) && !nearlyEqual(x, y, config.epsilon);
      },

      'Fraction, Fraction': function (x, y) {
        return x.compare(y) === 1;
      },

      'Complex, Complex': function () {
        throw new TypeError('No ordering relation is defined for complex numbers');
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return larger(x.value, y.value);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, larger);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, larger, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, larger, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, larger);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return larger(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return larger(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return larger(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, larger, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, larger, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, larger, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, larger, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, larger, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, larger, true).valueOf();
      }
    });

    larger.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['larger'] + '${args[1]}\\right)'
    };

    return larger;
  }

  var name$26 = 'larger';
  var factory_1$28 = factory$28;

  var larger = {
  	name: name$26,
  	factory: factory_1$28
  };

  function factory$29 (type, config, load, typed) {
    
    var smaller$$1 = load(smaller);
    var larger$$1 = load(larger);
    
    var oneOverLogPhi = 1.0 / Math.log((1.0 + Math.sqrt(5.0)) / 2.0);
    
    /**
     * Fibonacci Heap implementation, used interally for Matrix math.
     * @class FibonacciHeap
     * @constructor FibonacciHeap
     */
    function FibonacciHeap() {
      if (!(this instanceof FibonacciHeap))
        throw new SyntaxError('Constructor must be called with the new operator');

      // initialize fields
      this._minimum = null;
      this._size = 0;
    }

    /**
     * Attach type information
     */
    FibonacciHeap.prototype.type = 'FibonacciHeap';
    FibonacciHeap.prototype.isFibonacciHeap = true;

    /**
     * Inserts a new data element into the heap. No heap consolidation is
     * performed at this time, the new node is simply inserted into the root
     * list of this heap. Running time: O(1) actual.
     * @memberof FibonacciHeap
     */
    FibonacciHeap.prototype.insert = function (key, value) {
      // create node
      var node = {
        key: key,
        value: value,
        degree: 0
      };
      // check we have a node in the minimum
      if (this._minimum) {
        // minimum node
        var minimum = this._minimum;
        // update left & right of node
        node.left = minimum;
        node.right = minimum.right;
        minimum.right = node;
        node.right.left = node;
        // update minimum node in heap if needed
        if (smaller$$1(key, minimum.key)) {
          // node has a smaller key, use it as minimum
          this._minimum = node;
        }
      }
      else {
        // set left & right
        node.left = node;
        node.right = node;
        // this is the first node
        this._minimum = node;
      }
      // increment number of nodes in heap
      this._size++;
      // return node
      return node;
    };

    /**
     * Returns the number of nodes in heap. Running time: O(1) actual.
     * @memberof FibonacciHeap
     */
    FibonacciHeap.prototype.size = function () {
      return this._size;
    };

    /**
     * Removes all elements from this heap.
     * @memberof FibonacciHeap
     */
    FibonacciHeap.prototype.clear = function () {
      this._minimum = null;
      this._size = 0;
    };

    /**
     * Returns true if the heap is empty, otherwise false.
     * @memberof FibonacciHeap
     */
    FibonacciHeap.prototype.isEmpty = function () {
      return this._size === 0;
    };
    
    /**
     * Extracts the node with minimum key from heap. Amortized running 
     * time: O(log n).
     * @memberof FibonacciHeap
     */
    FibonacciHeap.prototype.extractMinimum = function () {
      // node to remove
      var node = this._minimum;
      // check we have a minimum
      if (node === null)
        return node;
      // current minimum
      var minimum = this._minimum;
      // get number of children
      var numberOfChildren = node.degree;
      // pointer to the first child
      var x = node.child;
      // for each child of node do...
      while (numberOfChildren > 0) {
        // store node in right side
        var tempRight = x.right;
        // remove x from child list
        x.left.right = x.right;
        x.right.left = x.left;
        // add x to root list of heap
        x.left = minimum;
        x.right = minimum.right;
        minimum.right = x;
        x.right.left = x;
        // set Parent[x] to null
        x.parent = null;
        x = tempRight;
        numberOfChildren--;
      }
      // remove node from root list of heap
      node.left.right = node.right;
      node.right.left = node.left;
      // update minimum
      if (node == node.right) {
        // empty
        minimum = null;
      }
      else {
        // update minimum
        minimum = node.right;
        // we need to update the pointer to the root with minimum key
        minimum = _findMinimumNode(minimum, this._size);
      }
      // decrement size of heap
      this._size--;
      // update minimum
      this._minimum = minimum;
      // return node
      return node;
    };
    
    /**
     * Removes a node from the heap given the reference to the node. The trees
     * in the heap will be consolidated, if necessary. This operation may fail
     * to remove the correct element if there are nodes with key value -Infinity.
     * Running time: O(log n) amortized.
     * @memberof FibonacciHeap
     */
    FibonacciHeap.prototype.remove = function (node) {
      // decrease key value
      this._minimum = _decreaseKey(this._minimum, node, -1);
      // remove the smallest
      this.extractMinimum();
    };
    
    /**
     * Decreases the key value for a heap node, given the new value to take on.
     * The structure of the heap may be changed and will not be consolidated. 
     * Running time: O(1) amortized.
     * @memberof FibonacciHeap
     */
    var _decreaseKey = function (minimum, node, key) {
      // set node key
      node.key = key;
      // get parent node
      var parent = node.parent;
      if (parent && smaller$$1(node.key, parent.key)) {
        // remove node from parent
        _cut(minimum, node, parent);
        // remove all nodes from parent to the root parent
        _cascadingCut(minimum, parent);
      }
      // update minimum node if needed
      if (smaller$$1(node.key, minimum.key))
        minimum = node;
      // return minimum
      return minimum;
    };
    
    /**
     * The reverse of the link operation: removes node from the child list of parent.
     * This method assumes that min is non-null. Running time: O(1).
     * @memberof FibonacciHeap
     */
    var _cut = function (minimum, node, parent) {
      // remove node from parent children and decrement Degree[parent]
      node.left.right = node.right;
      node.right.left = node.left;
      parent.degree--;
      // reset y.child if necessary
      if (parent.child == node)
        parent.child = node.right;
      // remove child if degree is 0
      if (parent.degree === 0)
        parent.child = null;
      // add node to root list of heap
      node.left = minimum;
      node.right = minimum.right;
      minimum.right = node;
      node.right.left = node;
      // set parent[node] to null
      node.parent = null;
      // set mark[node] to false
      node.mark = false;
    };
    
    /**
     * Performs a cascading cut operation. This cuts node from its parent and then
     * does the same for its parent, and so on up the tree.
     * Running time: O(log n); O(1) excluding the recursion.
     * @memberof FibonacciHeap
     */
    var _cascadingCut= function (minimum, node) {
      // store parent node
      var parent = node.parent;
      // if there's a parent...
      if (!parent)
        return;
      // if node is unmarked, set it marked
      if (!node.mark) {
        node.mark = true;
      }
      else {
        // it's marked, cut it from parent
        _cut(minimum, node, parent);
        // cut its parent as well
        _cascadingCut(parent);
      }
    };
    
    /**
     * Make the first node a child of the second one. Running time: O(1) actual.
     * @memberof FibonacciHeap
     */
    var _linkNodes = function (node, parent) {
      // remove node from root list of heap
      node.left.right = node.right;
      node.right.left = node.left;
      // make node a Child of parent
      node.parent = parent;
      if (!parent.child) {
        parent.child = node;
        node.right = node;
        node.left = node;
      }
      else {
        node.left = parent.child;
        node.right = parent.child.right;
        parent.child.right = node;
        node.right.left = node;
      }
      // increase degree[parent]
      parent.degree++;
      // set mark[node] false
      node.mark = false;
    };
    
    var _findMinimumNode = function (minimum, size) {
      // to find trees of the same degree efficiently we use an array of length O(log n) in which we keep a pointer to one root of each degree
      var arraySize = Math.floor(Math.log(size) * oneOverLogPhi) + 1;
      // create list with initial capacity
      var array = new Array(arraySize);
      // find the number of root nodes.
      var numRoots = 0;
      var x = minimum;
      if (x) {
        numRoots++;
        x = x.right;
        while (x !== minimum) {
          numRoots++;
          x = x.right;
        }
      }
      // vars
      var y;
      // For each node in root list do...
      while (numRoots > 0) {
        // access this node's degree..
        var d = x.degree;
        // get next node
        var next = x.right;
        // check if there is a node already in array with the same degree
        while (true) {
          // get node with the same degree is any
          y = array[d];
          if (!y)
            break;
          // make one node with the same degree a child of the other, do this based on the key value.
          if (larger$$1(x.key, y.key)) {
            var temp = y;
            y = x;
            x = temp;
          }
          // make y a child of x
          _linkNodes(y, x);
          // we have handled this degree, go to next one.
          array[d] = null;
          d++;
        }
        // save this node for later when we might encounter another of the same degree.
        array[d] = x;
        // move forward through list.
        x = next;
        numRoots--;
      }
      // Set min to null (effectively losing the root list) and reconstruct the root list from the array entries in array[].
      minimum = null;
      // loop nodes in array
      for (var i = 0; i < arraySize; i++) {
        // get current node
        y = array[i];
        if (!y)
          continue;
        // check if we have a linked list
        if (minimum) {
          // First remove node from root list.
          y.left.right = y.right;
          y.right.left = y.left;
          // now add to root list, again.
          y.left = minimum;
          y.right = minimum.right;
          minimum.right = y;
          y.right.left = y;
          // check if this is a new min.
          if (smaller$$1(y.key, minimum.key))
            minimum = y;
        }
        else
          minimum = y;
      }
      return minimum;
    };
    
    return FibonacciHeap;
  }

  var name$27 = 'FibonacciHeap';
  var path$8 = 'type';
  var factory_1$29 = factory$29;

  var FibonacciHeap = {
  	name: name$27,
  	path: path$8,
  	factory: factory_1$29
  };

  var string$5 = utils.string;
  var object$3 = utils.object;

  var isArray$2 = Array.isArray;
  var isString$4 = string$5.isString;

  function factory$30 (type, config, load) {

    var DenseMatrix$$1 = load(DenseMatrix);

    var smaller$$1 = load(smaller);

    function ImmutableDenseMatrix(data, datatype) {
      if (!(this instanceof ImmutableDenseMatrix))
        throw new SyntaxError('Constructor must be called with the new operator');
      if (datatype && !isString$4(datatype))
        throw new Error('Invalid datatype: ' + datatype);

      if (type.isMatrix(data) || isArray$2(data)) {
        // use DenseMatrix implementation
        var matrix = new DenseMatrix$$1(data, datatype);
        // internal structures
        this._data = matrix._data;
        this._size = matrix._size;
        this._datatype = matrix._datatype;
        this._min = null;
        this._max = null;
      }
      else if (data && isArray$2(data.data) && isArray$2(data.size)) {
        // initialize fields from JSON representation
        this._data = data.data;
        this._size = data.size;
        this._datatype = data.datatype;
        this._min = typeof data.min !== 'undefined' ? data.min : null;
        this._max = typeof data.max !== 'undefined' ? data.max : null;
      }
      else if (data) {
        // unsupported type
        throw new TypeError('Unsupported type of data (' + utils.types.type(data) + ')');
      }
      else {
        // nothing provided
        this._data = [];
        this._size = [0];
        this._datatype = datatype;
        this._min = null;
        this._max = null;
      }
    }

    ImmutableDenseMatrix.prototype = new DenseMatrix$$1();

    /**
     * Attach type information
     */
    ImmutableDenseMatrix.prototype.type = 'ImmutableDenseMatrix';
    ImmutableDenseMatrix.prototype.isImmutableDenseMatrix = true;

    /**
     * Get a subset of the matrix, or replace a subset of the matrix.
     *
     * Usage:
     *     var subset = matrix.subset(index)               // retrieve subset
     *     var value = matrix.subset(index, replacement)   // replace subset
     *
     * @param {Index} index
     * @param {Array | ImmutableDenseMatrix | *} [replacement]
     * @param {*} [defaultValue=0]      Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be filled with zeros.
     */
    ImmutableDenseMatrix.prototype.subset = function (index) {
      switch (arguments.length) {
        case 1:
          // use base implementation
          var m = DenseMatrix$$1.prototype.subset.call(this, index);
          // check result is a matrix
          if (type.isMatrix(m)) {
            // return immutable matrix
            return new ImmutableDenseMatrix({
              data: m._data,
              size: m._size,
              datatype: m._datatype
            });
          }
          return m;
          
          // intentional fall through
        case 2:
        case 3:
          throw new Error('Cannot invoke set subset on an Immutable Matrix instance');

        default:
          throw new SyntaxError('Wrong number of arguments');
      }
    };

    /**
     * Replace a single element in the matrix.
     * @param {Number[]} index   Zero-based index
     * @param {*} value
     * @param {*} [defaultValue]        Default value, filled in on new entries when
     *                                  the matrix is resized. If not provided,
     *                                  new matrix elements will be left undefined.
     * @return {ImmutableDenseMatrix} self
     */
    ImmutableDenseMatrix.prototype.set = function () {
      throw new Error('Cannot invoke set on an Immutable Matrix instance');
    };

    /**
     * Resize the matrix to the given size. Returns a copy of the matrix when
     * `copy=true`, otherwise return the matrix itself (resize in place).
     *
     * @param {Number[]} size           The new size the matrix should have.
     * @param {*} [defaultValue=0]      Default value, filled in on new entries.
     *                                  If not provided, the matrix elements will
     *                                  be filled with zeros.
     * @param {boolean} [copy]          Return a resized copy of the matrix
     *
     * @return {Matrix}                 The resized matrix
     */
    ImmutableDenseMatrix.prototype.resize = function () {
      throw new Error('Cannot invoke resize on an Immutable Matrix instance');
    };

    /**
     * Disallows reshaping in favor of immutability.
     *
     * @throws {Error} Operation not allowed
     */
    ImmutableDenseMatrix.prototype.reshape = function () {
      throw new Error('Cannot invoke reshape on an Immutable Matrix instance');
    };

    /**
     * Create a clone of the matrix
     * @return {ImmutableDenseMatrix} clone
     */
    ImmutableDenseMatrix.prototype.clone = function () {
      var m = new ImmutableDenseMatrix({
        data: object$3.clone(this._data),
        size: object$3.clone(this._size),
        datatype: this._datatype
      });
      return m;
    };

    /**
     * Get a JSON representation of the matrix
     * @returns {Object}
     */
    ImmutableDenseMatrix.prototype.toJSON = function () {
      return {
        mathjs: 'ImmutableDenseMatrix',
        data: this._data,
        size: this._size,
        datatype: this._datatype
      };
    };

    /**
     * Generate a matrix from a JSON object
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ImmutableDenseMatrix", data: [], size: []}`,
     *                       where mathjs is optional
     * @returns {ImmutableDenseMatrix}
     */
    ImmutableDenseMatrix.fromJSON = function (json) {
      return new ImmutableDenseMatrix(json);
    };

    /**
     * Swap rows i and j in Matrix.
     *
     * @param {Number} i       Matrix row index 1
     * @param {Number} j       Matrix row index 2
     *
     * @return {Matrix}        The matrix reference
     */
    ImmutableDenseMatrix.prototype.swapRows = function () {
      throw new Error('Cannot invoke swapRows on an Immutable Matrix instance');
    };

    /**
     * Calculate the minimum value in the set
     * @return {Number | undefined} min
     */
    ImmutableDenseMatrix.prototype.min = function () {
      // check min has been calculated before
      if (this._min === null) {
        // minimum
        var m = null;
        // compute min
        this.forEach(function (v) {
          if (m === null || smaller$$1(v, m))
            m = v;
        });
        this._min = m !== null ? m : undefined;
      }
      return this._min;
    };

    /**
     * Calculate the maximum value in the set
     * @return {Number | undefined} max
     */
    ImmutableDenseMatrix.prototype.max = function () {
      // check max has been calculated before
      if (this._max === null) {
        // maximum
        var m = null;
        // compute max
        this.forEach(function (v) {
          if (m === null || smaller$$1(m, v))
            m = v;
        });
        this._max = m !== null ? m : undefined;
      }
      return this._max;
    };

    // exports
    return ImmutableDenseMatrix;
  }

  var name$28 = 'ImmutableDenseMatrix';
  var path$9 = 'type';
  var factory_1$30 = factory$30;

  var ImmutableDenseMatrix = {
  	name: name$28,
  	path: path$9,
  	factory: factory_1$30
  };

  var clone$1 = object.clone;
  var isInteger$2 = number.isInteger;

  function factory$31 (type) {
    
    /**
     * Create an index. An Index can store ranges and sets for multiple dimensions.
     * Matrix.get, Matrix.set, and math.subset accept an Index as input.
     *
     * Usage:
     *     var index = new Index(range1, range2, matrix1, array1, ...);
     *
     * Where each parameter can be any of:
     *     A number
     *     A string (containing a name of an object property)
     *     An instance of Range
     *     An Array with the Set values
     *     A Matrix with the Set values
     *
     * The parameters start, end, and step must be integer numbers.
     *
     * @class Index
     * @Constructor Index
     * @param {...*} ranges
     */
    function Index(ranges) {
      if (!(this instanceof Index)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      this._dimensions = [];
      this._isScalar = true;

      for (var i = 0, ii = arguments.length; i < ii; i++) {
        var arg = arguments[i];

        if (type.isRange(arg)) {
          this._dimensions.push(arg);
          this._isScalar = false;
        }
        else if (Array.isArray(arg) || type.isMatrix(arg)) {
          // create matrix
          var m = _createImmutableMatrix(arg.valueOf());
          this._dimensions.push(m);
          // size
          var size = m.size();
          // scalar
          if (size.length !== 1 || size[0] !== 1) {
            this._isScalar = false;
          }
        }
        else if (typeof arg === 'number') {
          this._dimensions.push(_createImmutableMatrix([arg]));
        }
        else if (typeof arg === 'string') {
          // object property (arguments.count should be 1)
          this._dimensions.push(arg);
        }
        // TODO: implement support for wildcard '*'
        else {
          throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');
        }
      }
    }

    /**
     * Attach type information
     */
    Index.prototype.type = 'Index';
    Index.prototype.isIndex = true;

    function _createImmutableMatrix(arg) {
      // loop array elements
      for (var i = 0, l = arg.length; i < l; i++) {
        if (typeof arg[i] !== 'number' || !isInteger$2(arg[i])) {
          throw new TypeError('Index parameters must be positive integer numbers');
        }
      }
      // create matrix
      return new type.ImmutableDenseMatrix(arg);
    }

    /**
     * Create a clone of the index
     * @memberof Index
     * @return {Index} clone
     */
    Index.prototype.clone = function () {
      var index = new Index();
      index._dimensions = clone$1(this._dimensions);
      index._isScalar = this._isScalar;
      return index;
    };

    /**
     * Create an index from an array with ranges/numbers
     * @memberof Index
     * @param {Array.<Array | number>} ranges
     * @return {Index} index
     * @private
     */
    Index.create = function (ranges) {
      var index = new Index();
      Index.apply(index, ranges);
      return index;
    };

    /**
     * Retrieve the size of the index, the number of elements for each dimension.
     * @memberof Index
     * @returns {number[]} size
     */
    Index.prototype.size = function () {
      var size = [];

      for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
        var d = this._dimensions[i];
        size[i] = (typeof d === 'string') ? 1 : d.size()[0];
      }

      return size;
    };

    /**
     * Get the maximum value for each of the indexes ranges.
     * @memberof Index
     * @returns {number[]} max
     */
    Index.prototype.max = function () {
      var values = [];

      for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
        var range = this._dimensions[i];
        values[i] = (typeof range === 'string') ? range : range.max();
      }

      return values;
    };

    /**
     * Get the minimum value for each of the indexes ranges.
     * @memberof Index
     * @returns {number[]} min
     */
    Index.prototype.min = function () {
      var values = [];

      for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
        var range = this._dimensions[i];
        values[i] = (typeof range === 'string') ? range : range.min();
      }

      return values;
    };

    /**
     * Loop over each of the ranges of the index
     * @memberof Index
     * @param {Function} callback   Called for each range with a Range as first
     *                              argument, the dimension as second, and the
     *                              index object as third.
     */
    Index.prototype.forEach = function (callback) {
      for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
        callback(this._dimensions[i], i, this);
      }
    };

    /**
     * Retrieve the dimension for the given index
     * @memberof Index
     * @param {Number} dim                  Number of the dimension
     * @returns {Range | null} range
     */
    Index.prototype.dimension = function (dim) {
      return this._dimensions[dim] || null;
    };

    /**
     * Test whether this index contains an object property
     * @returns {boolean} Returns true if the index is an object property
     */
    Index.prototype.isObjectProperty = function () {
      return this._dimensions.length === 1 && typeof this._dimensions[0] === 'string';
    };

    /**
     * Returns the object property name when the Index holds a single object property,
     * else returns null
     * @returns {string | null}
     */
    Index.prototype.getObjectProperty = function () {
      return this.isObjectProperty() ? this._dimensions[0] : null;
    };

    /**
     * Test whether this index contains only a single value.
     *
     * This is the case when the index is created with only scalar values as ranges,
     * not for ranges resolving into a single value.
     * @memberof Index
     * @return {boolean} isScalar
     */
    Index.prototype.isScalar = function () {
      return this._isScalar;
    };

    /**
     * Expand the Index into an array.
     * For example new Index([0,3], [2,7]) returns [[0,1,2], [2,3,4,5,6]]
     * @memberof Index
     * @returns {Array} array
     */
    Index.prototype.toArray = function () {
      var array = [];
      for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
        var dimension = this._dimensions[i];
        array.push((typeof dimension === 'string') ? dimension : dimension.toArray());
      }
      return array;
    };

    /**
     * Get the primitive value of the Index, a two dimensional array.
     * Equivalent to Index.toArray().
     * @memberof Index
     * @returns {Array} array
     */
    Index.prototype.valueOf = Index.prototype.toArray;

    /**
     * Get the string representation of the index, for example '[2:6]' or '[0:2:10, 4:7, [1,2,3]]'
     * @memberof Index
     * @returns {String} str
     */
    Index.prototype.toString = function () {
      var strings = [];

      for (var i = 0, ii = this._dimensions.length; i < ii; i++) {
        var dimension = this._dimensions[i];
        if (typeof dimension === 'string') {
          strings.push(JSON.stringify(dimension));
        }
        else {
          strings.push(dimension.toString());
        }
      }

      return '[' + strings.join(', ') + ']';
    };

    /**
     * Get a JSON representation of the Index
     * @memberof Index
     * @returns {Object} Returns a JSON object structured as:
     *                   `{"mathjs": "Index", "ranges": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
     */
    Index.prototype.toJSON = function () {
      return {
        mathjs: 'Index',
        dimensions: this._dimensions
      };
    };

    /**
     * Instantiate an Index from a JSON object
     * @memberof Index
     * @param {Object} json A JSON object structured as:
     *                     `{"mathjs": "Index", "dimensions": [{"mathjs": "Range", start: 0, end: 10, step:1}, ...]}`
     * @return {Index}
     */
    Index.fromJSON = function (json) {
      return Index.create(json.dimensions);
    };

    return Index;
  }

  var name$29 = 'Index';
  var path$10 = 'type';
  var factory_1$31 = factory$31;

  var MatrixIndex = {
  	name: name$29,
  	path: path$10,
  	factory: factory_1$31
  };

  function factory$32 (type, config, load, typed) {
    /**
     * Create a range. A range has a start, step, and end, and contains functions
     * to iterate over the range.
     *
     * A range can be constructed as:
     *     var range = new Range(start, end);
     *     var range = new Range(start, end, step);
     *
     * To get the result of the range:
     *     range.forEach(function (x) {
     *         console.log(x);
     *     });
     *     range.map(function (x) {
     *         return math.sin(x);
     *     });
     *     range.toArray();
     *
     * Example usage:
     *     var c = new Range(2, 6);         // 2:1:5
     *     c.toArray();                     // [2, 3, 4, 5]
     *     var d = new Range(2, -3, -1);    // 2:-1:-2
     *     d.toArray();                     // [2, 1, 0, -1, -2]
     *
     * @class Range
     * @constructor Range
     * @param {number} start  included lower bound
     * @param {number} end    excluded upper bound
     * @param {number} [step] step size, default value is 1
     */
    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      if (start != null) {
        if (type.isBigNumber(start))
          start = start.toNumber();
        else if (typeof start !== 'number')
          throw new TypeError('Parameter start must be a number');
      }
      if (end != null) {
        if (type.isBigNumber(end))
          end = end.toNumber();
        else if (typeof end !== 'number')
          throw new TypeError('Parameter end must be a number');
      }
      if (step != null) {
        if (type.isBigNumber(step))
          step = step.toNumber();
        else if (typeof step !== 'number')
          throw new TypeError('Parameter step must be a number');
      }

      this.start = (start != null) ? parseFloat(start) : 0;
      this.end   = (end != null)   ? parseFloat(end)   : 0;
      this.step  = (step != null)  ? parseFloat(step)  : 1;
    }

    /**
     * Attach type information
     */
    Range.prototype.type = 'Range';
    Range.prototype.isRange = true;

    /**
     * Parse a string into a range,
     * The string contains the start, optional step, and end, separated by a colon.
     * If the string does not contain a valid range, null is returned.
     * For example str='0:2:11'.
     * @memberof Range
     * @param {string} str
     * @return {Range | null} range
     */
    Range.parse = function (str) {
      if (typeof str !== 'string') {
        return null;
      }

      var args = str.split(':');
      var nums = args.map(function (arg) {
        return parseFloat(arg);
      });

      var invalid = nums.some(function (num) {
        return isNaN(num);
      });
      if (invalid) {
        return null;
      }

      switch (nums.length) {
        case 2:
          return new Range(nums[0], nums[1]);
        case 3:
          return new Range(nums[0], nums[2], nums[1]);
        default:
          return null;
      }
    };

    /**
     * Create a clone of the range
     * @return {Range} clone
     */
    Range.prototype.clone = function () {
      return new Range(this.start, this.end, this.step);
    };

    /**
     * Retrieve the size of the range.
     * Returns an array containing one number, the number of elements in the range.
     * @memberof Range
     * @returns {number[]} size
     */
    Range.prototype.size = function () {
      var len = 0,
          start = this.start,
          step = this.step,
          end = this.end,
          diff = end - start;

      if (number.sign(step) == number.sign(diff)) {
        len = Math.ceil((diff) / step);
      }
      else if (diff == 0) {
        len = 0;
      }

      if (isNaN(len)) {
        len = 0;
      }
      return [len];
    };

    /**
     * Calculate the minimum value in the range
     * @memberof Range
     * @return {number | undefined} min
     */
    Range.prototype.min = function () {
      var size = this.size()[0];

      if (size > 0) {
        if (this.step > 0) {
          // positive step
          return this.start;
        }
        else {
          // negative step
          return this.start + (size - 1) * this.step;
        }
      }
      else {
        return undefined;
      }
    };

    /**
     * Calculate the maximum value in the range
     * @memberof Range
     * @return {number | undefined} max
     */
    Range.prototype.max = function () {
      var size = this.size()[0];

      if (size > 0) {
        if (this.step > 0) {
          // positive step
          return this.start + (size - 1) * this.step;
        }
        else {
          // negative step
          return this.start;
        }
      }
      else {
        return undefined;
      }
    };


    /**
     * Execute a callback function for each value in the range.
     * @memberof Range
     * @param {function} callback   The callback method is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Range being traversed.
     */
    Range.prototype.forEach = function (callback) {
      var x = this.start;
      var step = this.step;
      var end = this.end;
      var i = 0;

      if (step > 0) {
        while (x < end) {
          callback(x, [i], this);
          x += step;
          i++;
        }
      }
      else if (step < 0) {
        while (x > end) {
          callback(x, [i], this);
          x += step;
          i++;
        }
      }
    };

    /**
     * Execute a callback function for each value in the Range, and return the
     * results as an array
     * @memberof Range
     * @param {function} callback   The callback method is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix being traversed.
     * @returns {Array} array
     */
    Range.prototype.map = function (callback) {
      var array = [];
      this.forEach(function (value, index, obj) {
        array[index[0]] = callback(value, index, obj);
      });
      return array;
    };

    /**
     * Create an Array with a copy of the Ranges data
     * @memberof Range
     * @returns {Array} array
     */
    Range.prototype.toArray = function () {
      var array = [];
      this.forEach(function (value, index) {
        array[index[0]] = value;
      });
      return array;
    };

    /**
     * Get the primitive value of the Range, a one dimensional array
     * @memberof Range
     * @returns {Array} array
     */
    Range.prototype.valueOf = function () {
      // TODO: implement a caching mechanism for range.valueOf()
      return this.toArray();
    };

    /**
     * Get a string representation of the range, with optional formatting options.
     * Output is formatted as 'start:step:end', for example '2:6' or '0:0.2:11'
     * @memberof Range
     * @param {Object | number | function} [options]  Formatting options. See
     *                                                lib/utils/number:format for a
     *                                                description of the available
     *                                                options.
     * @returns {string} str
     */
    Range.prototype.format = function (options) {
      var str = number.format(this.start, options);

      if (this.step != 1) {
        str += ':' + number.format(this.step, options);
      }
      str += ':' + number.format(this.end, options);
      return str;
    };

    /**
     * Get a string representation of the range.
     * @memberof Range
     * @returns {string}
     */
    Range.prototype.toString = function () {
      return this.format();
    };

    /**
     * Get a JSON representation of the range
     * @memberof Range
     * @returns {Object} Returns a JSON object structured as:
     *                   `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
     */
    Range.prototype.toJSON = function () {
      return {
        mathjs: 'Range',
        start: this.start,
        end: this.end,
        step: this.step
      };
    };

    /**
     * Instantiate a Range from a JSON object
     * @memberof Range
     * @param {Object} json A JSON object structured as:
     *                      `{"mathjs": "Range", "start": 2, "end": 4, "step": 1}`
     * @return {Range}
     */
    Range.fromJSON = function (json) {
      return new Range(json.start, json.end, json.step);
    };

    return Range;
  }

  var name$30 = 'Range';
  var path$11 = 'type';
  var factory_1$32 = factory$32;

  var Range = {
  	name: name$30,
  	path: path$11,
  	factory: factory_1$32
  };

  function factory$33 (type, config, load, typed) {
    /**
     * Create an index. An Index can store ranges having start, step, and end
     * for multiple dimensions.
     * Matrix.get, Matrix.set, and math.subset accept an Index as input.
     *
     * Syntax:
     *
     *     math.index(range1, range2, ...)
     *
     * Where each range can be any of:
     *
     * - A number
     * - A string for getting/setting an object property
     * - An instance of `Range`
     * - A one-dimensional Array or a Matrix with numbers
     *
     * Indexes must be zero-based, integer numbers.
     *
     * Examples:
     *
     *    var math = math.js
     *
     *    var b = [1, 2, 3, 4, 5];
     *    math.subset(b, math.index([1, 2, 3]));     // returns [2, 3, 4]
     *
     *    var a = math.matrix([[1, 2], [3, 4]]);
     *    a.subset(math.index(0, 1));             // returns 2
     *
     * See also:
     *
     *    bignumber, boolean, complex, matrix, number, string, unit
     *
     * @param {...*} ranges   Zero or more ranges or numbers.
     * @return {Index}        Returns the created index
     */
    return typed('index', {
      '...number | string | BigNumber | Range | Array | Matrix': function (args) {
        var ranges = args.map(function (arg) {
          if (type.isBigNumber(arg)) {
            return arg.toNumber(); // convert BigNumber to Number
          }
          else if (Array.isArray(arg) || type.isMatrix(arg)) {
            return arg.map(function (elem) {
              // convert BigNumber to Number
              return type.isBigNumber(elem) ? elem.toNumber() : elem;
            });
          }
          else {
            return arg;
          }
        });

        var res = new type.Index();
        type.Index.apply(res, ranges);
        return res;
      }
    });
  }

  var name$31 = 'index';
  var factory_1$33 = factory$33;

  var _function$1 = {
  	name: name$31,
  	factory: factory_1$33
  };

  function factory$34 (type, config, load, typed) {

    var SparseMatrix = type.SparseMatrix;

    /**
     * Create a Sparse Matrix. The function creates a new `math.type.Matrix` object from
     * an `Array`. A Matrix has utility functions to manipulate the data in the
     * matrix, like getting the size and getting or setting values in the matrix.
     *
     * Syntax:
     *
     *    math.sparse()               // creates an empty sparse matrix.
     *    math.sparse(data)           // creates a sparse matrix with initial data.
     *    math.sparse(data, 'number') // creates a sparse matrix with initial data, number datatype.
     *
     * Examples:
     *
     *    var m = math.sparse([[1, 2], [3, 4]]);
     *    m.size();                        // Array [2, 2]
     *    m.resize([3, 2], 5);
     *    m.valueOf();                     // Array [[1, 2], [3, 4], [5, 5]]
     *    m.get([1, 0])                    // number 3
     *
     * See also:
     *
     *    bignumber, boolean, complex, index, number, string, unit, matrix
     *
     * @param {Array | Matrix} [data]    A two dimensional array
     *
     * @return {Matrix} The created matrix
     */
    var sparse = typed('sparse', {
      '': function () {
        return new SparseMatrix([]);
      },
      
      'string': function (datatype) {
        return new SparseMatrix([], datatype);
      },

      'Array | Matrix': function (data) {
        return new SparseMatrix(data);
      },
      
      'Array | Matrix, string': function (data, datatype) {
        return new SparseMatrix(data, datatype);
      }
    });

    sparse.toTex = {
      0: '\\begin{bsparse}\\end{bsparse}',
      1: '\\left(${args[0]}\\right)'
    };

    return sparse;
  }

  var name$32 = 'sparse';
  var factory_1$34 = factory$34;

  var sparse = {
  	name: name$32,
  	factory: factory_1$34
  };

  var matrix$1 = [
    // types
    Matrix,
    DenseMatrix,
    SparseMatrix,
    Spa,
    FibonacciHeap,
    ImmutableDenseMatrix,
    MatrixIndex,
    Range,

    // construction functions
    _function$1,
    matrix,
    sparse
  ];

  function factory$35 (type, config, load, typed) {
    /**
     * Create a number or convert a string, boolean, or unit to a number.
     * When value is a matrix, all elements will be converted to number.
     *
     * Syntax:
     *
     *    math.number(value)
     *    math.number(unit, valuelessUnit)
     *
     * Examples:
     *
     *    math.number(2);                         // returns number 2
     *    math.number('7.2');                     // returns number 7.2
     *    math.number(true);                      // returns number 1
     *    math.number([true, false, true, true]); // returns [1, 0, 1, 1]
     *    math.number(math.unit('52cm'), 'm');    // returns 0.52
     *
     * See also:
     *
     *    bignumber, boolean, complex, index, matrix, string, unit
     *
     * @param {string | number | BigNumber | Fraction | boolean | Array | Matrix | Unit | null} [value]  Value to be converted
     * @param {Unit | string} [valuelessUnit] A valueless unit, used to convert a unit to a number
     * @return {number | Array | Matrix} The created number
     */
    var number = typed('number', {
      '': function () {
        return 0;
      },

      'number': function (x) {
        return x;
      },

      'string': function (x) {
        var num = Number(x);
        if (isNaN(num)) {
          throw new SyntaxError('String "' + x + '" is no valid number');
        }
        return num;
      },

      'BigNumber': function (x) {
        return x.toNumber();
      },

      'Fraction': function (x) {
        return x.valueOf();
      },

      'Unit': function (x) {
        throw new Error('Second argument with valueless unit expected');
      },

      'null': function (x) {
        return 0;
      },

      'Unit, string | Unit': function (unit, valuelessUnit) {
        return unit.toNumber(valuelessUnit);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, number);
      }
    });

    number.toTex = {
      0: '0',
      1: '\\left(${args[0]}\\right)',
      2: '\\left(\\left(${args[0]}\\right)${args[1]}\\right)'
    };

    return number;
  }

  var name$33 = 'number';
  var factory_1$35 = factory$35;

  var number$3 = {
  	name: name$33,
  	factory: factory_1$35
  };

  function factory$36 (type, config, load, typed) {
    /**
     * A ResultSet contains a list or results
     * @class ResultSet
     * @param {Array} entries
     * @constructor ResultSet
     */
    function ResultSet(entries) {
      if (!(this instanceof ResultSet)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      this.entries = entries || [];
    }

    /**
     * Attach type information
     */
    ResultSet.prototype.type = 'ResultSet';
    ResultSet.prototype.isResultSet = true;

    /**
     * Returns the array with results hold by this ResultSet
     * @memberof ResultSet
     * @returns {Array} entries
     */
    ResultSet.prototype.valueOf = function () {
      return this.entries;
    };

    /**
     * Returns the stringified results of the ResultSet
     * @memberof ResultSet
     * @returns {string} string
     */
    ResultSet.prototype.toString = function () {
      return '[' + this.entries.join(', ') + ']';
    };

    /**
     * Get a JSON representation of the ResultSet
     * @memberof ResultSet
     * @returns {Object} Returns a JSON object structured as:
     *                   `{"mathjs": "ResultSet", "entries": [...]}`
     */
    ResultSet.prototype.toJSON = function () {
      return {
        mathjs: 'ResultSet',
        entries: this.entries
      };
    };

    /**
     * Instantiate a ResultSet from a JSON object
     * @memberof ResultSet
     * @param {Object} json  A JSON object structured as:
     *                       `{"mathjs": "ResultSet", "entries": [...]}`
     * @return {ResultSet}
     */
    ResultSet.fromJSON = function (json) {
      return new ResultSet(json.entries);
    };

    return ResultSet;
  }

  var name$34 = 'ResultSet';
  var path$12 = 'type';
  var factory_1$36 = factory$36;

  var ResultSet = {
  	name: name$34,
  	path: path$12,
  	factory: factory_1$36
  };

  var resultset = [
    // type
    ResultSet
  ];

  function factory$37 (type, config, load, typed) {
    /**
     * Create a string or convert any object into a string.
     * Elements of Arrays and Matrices are processed element wise.
     *
     * Syntax:
     *
     *    math.string(value)
     *
     * Examples:
     *
     *    math.string(4.2);               // returns string '4.2'
     *    math.string(math.complex(3, 2); // returns string '3 + 2i'
     *
     *    var u = math.unit(5, 'km');
     *    math.string(u.to('m'));         // returns string '5000 m'
     *
     *    math.string([true, false]);     // returns ['true', 'false']
     *
     * See also:
     *
     *    bignumber, boolean, complex, index, matrix, number, unit
     *
     * @param {* | Array | Matrix | null} [value]  A value to convert to a string
     * @return {string | Array | Matrix} The created string
     */
    var string = typed('string', {
      '': function () {
        return '';
      },

      'number': number.format,

      'null': function (x) {
        return 'null';
      },

      'boolean': function (x) {
        return x + '';
      },

      'string': function (x) {
        return x;
      },

      'Array | Matrix': function (x) {
        return deepMap(x, string);
      },

      'any': function (x) {
        return String(x);
      }
    });

    string.toTex = {
      0: '\\mathtt{""}',
      1: '\\mathrm{string}\\left(${args[0]}\\right)'
    };

    return string;
  }

  var name$35 = 'string';
  var factory_1$37 = factory$37;

  var string$6 = {
  	name: name$35,
  	factory: factory_1$37
  };

  var type = [
    bignumber$1,
    boolean_1,
    chain$1,
    complex$3,
    fraction$3,
    matrix$1,
    number$3,
    resultset,
    string$6,
  ];

  var constants = createCommonjsModule(function (module, exports) {
  var memoize = _function.memoize;

  /**
   * Calculate BigNumber e
   * @param {function} BigNumber   BigNumber constructor
   * @returns {BigNumber} Returns e
   */
  exports.e = memoize(function (BigNumber) {
    return new BigNumber(1).exp();
  }, hasher);

  /**
   * Calculate BigNumber golden ratio, phi = (1+sqrt(5))/2
   * @param {function} BigNumber   BigNumber constructor
   * @returns {BigNumber} Returns phi
   */
  exports.phi = memoize(function (BigNumber) {
    return new BigNumber(1).plus(new BigNumber(5).sqrt()).div(2);
  }, hasher);

  /**
   * Calculate BigNumber pi.
   * @param {function} BigNumber   BigNumber constructor
   * @returns {BigNumber} Returns pi
   */
  exports.pi = memoize(function (BigNumber) {
    return BigNumber.acos(-1);
  }, hasher);

  /**
   * Calculate BigNumber tau, tau = 2 * pi
   * @param {function} BigNumber   BigNumber constructor
   * @returns {BigNumber} Returns tau
   */
  exports.tau = memoize(function (BigNumber) {
    return exports.pi(BigNumber).times(2);
  }, hasher);

  /**
   * Create a hash for a BigNumber constructor function. The created has is
   * the configured precision
   * @param {Array} args         Supposed to contain a single entry with
   *                             a BigNumber constructor
   * @return {number} precision
   * @private
   */
  function hasher (args) {
    return args[0].precision;
  }
  });
  var constants_1 = constants.e;
  var constants_2 = constants.phi;
  var constants_3 = constants.pi;
  var constants_4 = constants.tau;

  function factory$38 (type, config, load, typed, math) {
    // listen for changed in the configuration, automatically reload
    // constants when needed
    math.on('config', function (curr, prev) {
      if (curr.number !== prev.number || curr.define_pi !== prev.define_pi
  	|| curr.define_e !== prev.define_e || curr.define_i !== prev.define_i) {
        factory$38(type, config, load, typed, math);
      }
    });

    setConstant(math, 'true', true);
    setConstant(math, 'false', false);
    setConstant(math, 'null', null);
    setConstant(math, 'uninitialized', 'Error: Constant uninitialized is removed since v4.0.0. Use null instead');

    if (config.number === 'BigNumber') {
      setConstant(math, 'Infinity', new type.BigNumber(Infinity));
      setConstant(math, 'NaN', new type.BigNumber(NaN));

      if(config.define_pi === false)
        deleteConstant(math, 'pi');
      else
        setLazyConstant(math, 'pi',  function () {return constants.pi(type.BigNumber)});
      if(config.define_e === false)
        deleteConstant(math, 'e');
      else
        setLazyConstant(math, 'e',   function () {return constants.e(type.BigNumber)});
    }
    else {
      setConstant(math, 'Infinity', Infinity);
      setConstant(math, 'NaN',      NaN);

      if(config.define_pi === false)
        deleteConstant(math, 'pi');
      else
        setConstant(math, 'pi',  Math.PI);
      if(config.define_e === false)
        deleteConstant(math, 'e');
      else
        setConstant(math, 'e',   Math.E);
    }

    if(config.define_i===false)
      deleteConstant(math, 'i');
    else
      // complex i
      setConstant(math, 'i', type.Complex.I);

  }

  // delete a constant in both math and mathWithTransform
  function deleteConstant(math, name) {
      delete math[name];
      delete math.expression.mathWithTransform[name];
  }

  // create a constant in both math and mathWithTransform
  function setConstant(math, name, value) {
    math[name] = value;
    math.expression.mathWithTransform[name] = value;
  }

  // create a lazy constant in both math and mathWithTransform
  function setLazyConstant (math, name, resolver) {
    object.lazy(math, name,  resolver);
    object.lazy(math.expression.mathWithTransform, name,  resolver);
  }

  const lazy$4 = false;  // no lazy loading of constants, the constants themselves are lazy when needed
  const math$5 = true;   // request access to the math namespace

  var constants$1 = { factory: factory$38, lazy: lazy$4, math: math$5 };

  var bignumber$2 = {
    'name': 'bignumber',
    'category': 'Construction',
    'syntax': [
      'bignumber(x)'
    ],
    'description':
        'Create a big number from a number or string.',
    'examples': [
      '0.1 + 0.2',
      'bignumber(0.1) + bignumber(0.2)',
      'bignumber("7.2")',
      'bignumber("7.2e500")',
      'bignumber([0.1, 0.2, 0.3])'
    ],
    'seealso': [
      'boolean', 'complex', 'fraction', 'index', 'matrix', 'string', 'unit'
    ]
  };

  var boolean_1$2 = {
    'name': 'boolean',
    'category': 'Construction',
    'syntax': [
      'x',
      'boolean(x)'
    ],
    'description':
        'Convert a string or number into a boolean.',
    'examples': [
      'boolean(0)',
      'boolean(1)',
      'boolean(3)',
      'boolean("true")',
      'boolean("false")',
      'boolean([1, 0, 1, 1])'
    ],
    'seealso': [
      'bignumber', 'complex', 'index', 'matrix', 'number', 'string', 'unit'
    ]
  };

  var complex$4 = {
    'name': 'complex',
    'category': 'Construction',
    'syntax': [
      'complex()',
      'complex(re, im)',
      'complex(string)'
    ],
    'description':
        'Create a complex number.',
    'examples': [
      'complex()',
      'complex(2, 3)',
      'complex("7 - 2i")'
    ],
    'seealso': [
      'bignumber', 'boolean', 'index', 'matrix', 'number', 'string', 'unit'
    ]
  };

  var createUnit = {
    'name': 'createUnit',
    'category': 'Construction',
    'syntax': [
      'createUnit(definitions)',
      'createUnit(name, definition)'
    ],
    'description':
        'Create a user-defined unit and register it with the Unit type.',
    'examples': [
      'createUnit("foo")',
      'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})',
      'createUnit("mph", "1 mile/hour")'
    ],
    'seealso': [
      'unit', 'splitUnit'
    ]
  };

  var fraction$4 = {
    'name': 'fraction',
    'category': 'Construction',
    'syntax': [
      'fraction(num)',
      'fraction(num,den)'
    ],
    'description':
      'Create a fraction from a number or from a numerator and denominator.',
    'examples': [
      'fraction(0.125)',
      'fraction(1, 3) + fraction(2, 5)'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'index', 'matrix', 'string', 'unit'
    ]
  };

  var construction = {
    'name': 'index',
    'category': 'Construction',
    'syntax': [
      '[start]',
      '[start:end]',
      '[start:step:end]',
      '[start1, start 2, ...]',
      '[start1:end1, start2:end2, ...]',
      '[start1:step1:end1, start2:step2:end2, ...]'
    ],
    'description':
        'Create an index to get or replace a subset of a matrix',
    'examples': [
      '[]',
      '[1, 2, 3]',
      'A = [1, 2, 3; 4, 5, 6]',
      'A[1, :]',
      'A[1, 2] = 50',
      'A[0:2, 0:2] = ones(2, 2)'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'matrix,', 'number', 'range', 'string', 'unit'
    ]
  };

  var matrix$2 = {
    'name': 'matrix',
    'category': 'Construction',
    'syntax': [
      '[]',
      '[a1, b1, ...; a2, b2, ...]',
      'matrix()',
      'matrix("dense")',
      'matrix([...])'
    ],
    'description':
        'Create a matrix.',
    'examples': [
      '[]',
      '[1, 2, 3]',
      '[1, 2, 3; 4, 5, 6]',
      'matrix()',
      'matrix([3, 4])',
      'matrix([3, 4; 5, 6], "sparse")',
      'matrix([3, 4; 5, 6], "sparse", "number")'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'index', 'number', 'string', 'unit', 'sparse'
    ]
  };

  var number$4 = {
    'name': 'number',
    'category': 'Construction',
    'syntax': [
      'x',
      'number(x)',
      'number(unit, valuelessUnit)'
    ],
    'description':
        'Create a number or convert a string or boolean into a number.',
    'examples': [
      '2',
      '2e3',
      '4.05',
      'number(2)',
      'number("7.2")',
      'number(true)',
      'number([true, false, true, true])',
      'number(unit("52cm"), "m")'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'fraction', 'index', 'matrix', 'string', 'unit'
    ]
  };

  var sparse$1 = {
    'name': 'sparse',
    'category': 'Construction',
    'syntax': [
      'sparse()',
      'sparse([a1, b1, ...; a1, b2, ...])',
      'sparse([a1, b1, ...; a1, b2, ...], "number")'
    ],
    'description':
    'Create a sparse matrix.',
    'examples': [
      'sparse()',
      'sparse([3, 4; 5, 6])',
      'sparse([3, 0; 5, 0], "number")'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'index', 'number', 'string', 'unit', 'matrix'
    ]
  };

  var splitUnit = {
    'name': 'splitUnit',
    'category': 'Construction',
    'syntax': [
      'splitUnit(unit: Unit, parts: Unit[])'
    ],
    'description':
        'Split a unit in an array of units whose sum is equal to the original unit.',
    'examples': [
      'splitUnit(1 m, ["feet", "inch"])'
    ],
    'seealso': [
      'unit', 'createUnit'
    ]
  };

  var string$7 = {
    'name': 'string',
    'category': 'Construction',
    'syntax': [
      '"text"',
      'string(x)'
    ],
    'description':
        'Create a string or convert a value to a string',
    'examples': [
      '"Hello World!"',
      'string(4.2)',
      'string(3 + 2i)'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'index', 'matrix', 'number', 'unit'
    ]
  };

  var unit = {
    'name': 'unit',
    'category': 'Construction',
    'syntax': [
      'value unit',
      'unit(value, unit)',
      'unit(string)'
    ],
    'description':
        'Create a unit.',
    'examples': [
      '5.5 mm',
      '3 inch',
      'unit(7.1, "kilogram")',
      'unit("23 deg")'
    ],
    'seealso': [
      'bignumber', 'boolean', 'complex', 'index', 'matrix', 'number', 'string'
    ]
  };

  var e = {
    'name': 'e',
    'category': 'Constants',
    'syntax': [
      'e'
    ],
    'description': 'Euler\'s number, the base of the natural logarithm. Approximately equal to 2.71828',
    'examples': [
      'e',
      'e ^ 2',
      'exp(2)',
      'log(e)'
    ],
    'seealso': ['exp']
  };

  var _false = {
    'name': 'false',
    'category': 'Constants',
    'syntax': [
      'false'
    ],
    'description': 'Boolean value false',
    'examples': [
      'false'
    ],
    'seealso': ['true']
  };

  var i = {
    'name': 'i',
    'category': 'Constants',
    'syntax': [
      'i'
    ],
    'description': 'Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.',
    'examples': [
      'i',
      'i * i',
      'sqrt(-1)'
    ],
    'seealso': []
  };

  var _Infinity = {
    'name': 'Infinity',
    'category': 'Constants',
    'syntax': [
      'Infinity'
    ],
    'description': 'Infinity, a number which is larger than the maximum number that can be handled by a floating point number.',
    'examples': [
      'Infinity',
      '1 / 0'
    ],
    'seealso': []
  };

  var LN2 = {
    'name': 'LN2',
    'category': 'Constants',
    'syntax': [
      'LN2'
    ],
    'description': 'Returns the natural logarithm of 2, approximately equal to 0.693',
    'examples': [
      'LN2',
      'log(2)'
    ],
    'seealso': []
  };

  var LN10 = {
    'name': 'LN10',
    'category': 'Constants',
    'syntax': [
      'LN10'
    ],
    'description': 'Returns the natural logarithm of 10, approximately equal to 2.302',
    'examples': [
      'LN10',
      'log(10)'
    ],
    'seealso': []
  };

  var LOG2E = {
    'name': 'LOG2E',
    'category': 'Constants',
    'syntax': [
      'LOG2E'
    ],
    'description': 'Returns the base-2 logarithm of E, approximately equal to 1.442',
    'examples': [
      'LOG2E',
      'log(e, 2)'
    ],
    'seealso': []
  };

  var LOG10E = {
    'name': 'LOG10E',
    'category': 'Constants',
    'syntax': [
      'LOG10E'
    ],
    'description': 'Returns the base-10 logarithm of E, approximately equal to 0.434',
    'examples': [
      'LOG10E',
      'log(e, 10)'
    ],
    'seealso': []
  };

  var _NaN = {
    'name': 'NaN',
    'category': 'Constants',
    'syntax': [
      'NaN'
    ],
    'description': 'Not a number',
    'examples': [
      'NaN',
      '0 / 0'
    ],
    'seealso': []
  };

  var _null = {
    'name': 'null',
    'category': 'Constants',
    'syntax': [
      'null'
    ],
    'description': 'Value null',
    'examples': [
      'null'
    ],
    'seealso': ['true', 'false']
  };

  var pi = {
    'name': 'pi',
    'category': 'Constants',
    'syntax': [
      'pi'
    ],
    'description': 'The number pi is a mathematical constant that is the ratio of a circle\'s circumference to its diameter, and is approximately equal to 3.14159',
    'examples': [
      'pi',
      'sin(pi/2)'
    ],
    'seealso': ['tau']
  };

  var phi = {
    'name': 'phi',
    'category': 'Constants',
    'syntax': [
      'phi'
    ],
    'description': 'Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...',
    'examples': [
      'phi'
    ],
    'seealso': []
  };

  var SQRT1_2 = {
    'name': 'SQRT1_2',
    'category': 'Constants',
    'syntax': [
      'SQRT1_2'
    ],
    'description': 'Returns the square root of 1/2, approximately equal to 0.707',
    'examples': [
      'SQRT1_2',
      'sqrt(1/2)'
    ],
    'seealso': []
  };

  var SQRT2 = {
    'name': 'SQRT2',
    'category': 'Constants',
    'syntax': [
      'SQRT2'
    ],
    'description': 'Returns the square root of 2, approximately equal to 1.414',
    'examples': [
      'SQRT2',
      'sqrt(2)'
    ],
    'seealso': []
  };

  var tau = {
    'name': 'tau',
    'category': 'Constants',
    'syntax': [
      'tau'
    ],
    'description': 'Tau is the ratio constant of a circle\'s circumference to radius, equal to 2 * pi, approximately 6.2832.',
    'examples': [
      'tau',
      '2 * pi'
    ],
    'seealso': ['pi']
  };

  var _true = {
    'name': 'true',
    'category': 'Constants',
    'syntax': [
      'true'
    ],
    'description': 'Boolean value true',
    'examples': [
      'true'
    ],
    'seealso': ['false']
  };

  var version = {
    'name': 'version',
    'category': 'Constants',
    'syntax': [
      'version'
    ],
    'description': 'A string with the version number of math.js',
    'examples': [
      'version'
    ],
    'seealso': []
  };

  var derivative = {
    'name': 'derivative',
    'category': 'Algebra',
    'syntax': [
      'derivative(expr, variable)',
      'derivative(expr, variable, {simplify: boolean})'
    ],
    'description': 'Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.',
    'examples': [
      'derivative("2x^3", "x")',
      'derivative("2x^3", "x", {simplify: false})',
      'derivative("2x^2 + 3x + 4", "x")',
      'derivative("sin(2x)", "x")',
      'f = parse("x^2 + x")',
      'x = parse("x")',
      'df = derivative(f, x)',
      'df.eval({x: 3})'
    ],
    'seealso': [
      'simplify', 'parse', 'eval'
    ]
  };

  var lsolve = {
    'name': 'lsolve',
    'category': 'Algebra',
    'syntax': [
      'x=lsolve(L, b)'
    ],
    'description':
    'Solves the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.',
    'examples': [
      'a = [-2, 3; 2, 1]',
      'b = [11, 9]',
      'x = lsolve(a, b)'
    ],
    'seealso': [
      'lup', 'lusolve', 'usolve', 'matrix', 'sparse'
    ]
  };

  var lup = {
    'name': 'lup',
    'category': 'Algebra',
    'syntax': [
      'lup(m)'
    ],
    'description':
    'Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U',
    'examples': [
      'lup([[2, 1], [1, 4]])',
      'lup(matrix([[2, 1], [1, 4]]))',
      'lup(sparse([[2, 1], [1, 4]]))'
    ],
    'seealso': [
      'lusolve', 'lsolve', 'usolve', 'matrix', 'sparse', 'slu', 'qr'
    ]
  };

  var lusolve = {
    'name': 'lusolve',
    'category': 'Algebra',
    'syntax': [
      'x=lusolve(A, b)',
      'x=lusolve(lu, b)'
    ],
    'description': 'Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.',
    'examples': [
      'a = [-2, 3; 2, 1]',
      'b = [11, 9]',
      'x = lusolve(a, b)'
    ],
    'seealso': [
      'lup', 'slu', 'lsolve', 'usolve', 'matrix', 'sparse'
    ]
  };

  var simplify = {
    'name': 'simplify',
    'category': 'Algebra',
    'syntax': [
      'simplify(expr)',
      'simplify(expr, rules)'
    ],
    'description': 'Simplify an expression tree.',
    'examples': [
      'simplify("3 + 2 / 4")',
      'simplify("2x + x")',
      'f = parse("x * (x + 2 + x)")',
      'simplified = simplify(f)',
      'simplified.eval({x: 2})'
    ],
    'seealso': [
      'derivative', 'parse', 'eval'
    ]
  };

  var rationalize = {
    'name': 'rationalize',
    'category': 'Algebra',
    'syntax': [
      'rationalize(expr)',
      'rationalize(expr, scope)',
      'rationalize(expr, scope, detailed)'
    ],
    'description': 'Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.',
    'examples': [
      'rationalize("2x/y - y/(x+1)")',
      'rationalize("2x/y - y/(x+1)", true)',
    ],
    'seealso': [
      'simplify'
    ]
  };

  var slu = {
    'name': 'slu',
    'category': 'Algebra',
    'syntax': [
      'slu(A, order, threshold)'
    ],
    'description': 'Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U',
    'examples': [
      'slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)'
    ],
    'seealso': [
      'lusolve', 'lsolve', 'usolve', 'matrix', 'sparse', 'lup', 'qr'
    ]
  };

  var usolve = {
    'name': 'usolve',
    'category': 'Algebra',
    'syntax': [
      'x=usolve(U, b)'
    ],
    'description':
    'Solves the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.',
    'examples': [
      'x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])'
    ],
    'seealso': [
      'lup', 'lusolve', 'lsolve', 'matrix', 'sparse'
    ]
  };

  var qr = {
    'name': 'qr',
    'category': 'Algebra',
    'syntax': [
      'qr(A)'
    ],
    'description':
    'Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.',
    'examples': [
      'qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])'
    ],
    'seealso': [
      'lup', 'slu', 'matrix'
    ]
  };

  var abs = {
    'name': 'abs',
    'category': 'Arithmetic',
    'syntax': [
      'abs(x)'
    ],
    'description': 'Compute the absolute value.',
    'examples': [
      'abs(3.5)',
      'abs(-4.2)'
    ],
    'seealso': ['sign']
  };

  var add$1 = {
    'name': 'add',
    'category': 'Operators',
    'syntax': [
      'x + y',
      'add(x, y)'
    ],
    'description': 'Add two values.',
    'examples': [
      'a = 2.1 + 3.6',
      'a - 3.6',
      '3 + 2i',
      '3 cm + 2 inch',
      '"2.3" + "4"'
    ],
    'seealso': [
      'subtract'
    ]
  };

  var cbrt = {
    'name': 'cbrt',
    'category': 'Arithmetic',
    'syntax': [
      'cbrt(x)',
      'cbrt(x, allRoots)'
    ],
    'description':
        'Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned',
    'examples': [
      'cbrt(64)',
      'cube(4)',
      'cbrt(-8)',
      'cbrt(2 + 3i)',
      'cbrt(8i)',
      'cbrt(8i, true)',
      'cbrt(27 m^3)'
    ],
    'seealso': [
      'square',
      'sqrt',
      'cube',
      'multiply'
    ]
  };

  var ceil = {
    'name': 'ceil',
    'category': 'Arithmetic',
    'syntax': [
      'ceil(x)'
    ],
    'description':
        'Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.',
    'examples': [
      'ceil(3.2)',
      'ceil(3.8)',
      'ceil(-4.2)'
    ],
    'seealso': ['floor', 'fix', 'round']
  };

  var cube = {
    'name': 'cube',
    'category': 'Arithmetic',
    'syntax': [
      'cube(x)'
    ],
    'description': 'Compute the cube of a value. The cube of x is x * x * x.',
    'examples': [
      'cube(2)',
      '2^3',
      '2 * 2 * 2'
    ],
    'seealso': [
      'multiply',
      'square',
      'pow'
    ]
  };

  var divide = {
    'name': 'divide',
    'category': 'Operators',
    'syntax': [
      'x / y',
      'divide(x, y)'
    ],
    'description': 'Divide two values.',
    'examples': [
      'a = 2 / 3',
      'a * 3',
      '4.5 / 2',
      '3 + 4 / 2',
      '(3 + 4) / 2',
      '18 km / 4.5'
    ],
    'seealso': [
      'multiply'
    ]
  };

  var dotDivide = {
    'name': 'dotDivide',
    'category': 'Operators',
    'syntax': [
      'x ./ y',
      'dotDivide(x, y)'
    ],
    'description': 'Divide two values element wise.',
    'examples': [
      'a = [1, 2, 3; 4, 5, 6]',
      'b = [2, 1, 1; 3, 2, 5]',
      'a ./ b'
    ],
    'seealso': [
      'multiply',
      'dotMultiply',
      'divide'
    ]
  };

  var dotMultiply = {
    'name': 'dotMultiply',
    'category': 'Operators',
    'syntax': [
      'x .* y',
      'dotMultiply(x, y)'
    ],
    'description': 'Multiply two values element wise.',
    'examples': [
      'a = [1, 2, 3; 4, 5, 6]',
      'b = [2, 1, 1; 3, 2, 5]',
      'a .* b'
    ],
    'seealso': [
      'multiply',
      'divide',
      'dotDivide'
    ]
  };

  var dotPow = {
    'name': 'dotpow',
    'category': 'Operators',
    'syntax': [
      'x .^ y',
      'dotpow(x, y)'
    ],
    'description':
        'Calculates the power of x to y element wise.',
    'examples': [
      'a = [1, 2, 3; 4, 5, 6]',
      'a .^ 2'
    ],
    'seealso': [
      'pow'
    ]
  };

  var exp = {
    'name': 'exp',
    'category': 'Arithmetic',
    'syntax': [
      'exp(x)'
    ],
    'description': 'Calculate the exponent of a value.',
    'examples': [
      'exp(1.3)',
      'e ^ 1.3',
      'log(exp(1.3))',
      'x = 2.4',
      '(exp(i*x) == cos(x) + i*sin(x))   # Euler\'s formula'
    ],
    'seealso': [
      'expm',
      'expm1',
      'pow',
      'log'
    ]
  };

  var expm = {
    'name': 'expm',
    'category': 'Arithmetic',
    'syntax': [
      'exp(x)'
    ],
    'description': 'Compute the matrix exponential, expm(A) = e^A. ' +
      'The matrix must be square. ' +
      'Not to be confused with exp(a), which performs element-wise exponentiation.',
    'examples': [
      'expm([[0,2],[0,0]])'
    ],
    'seealso': [
      'exp'
    ]
  };

  var expm1 = {
    'name': 'expm1',
    'category': 'Arithmetic',
    'syntax': [
      'expm1(x)'
    ],
    'description': 'Calculate the value of subtracting 1 from the exponential value.',
    'examples': [
      'expm1(2)',
      'pow(e, 2) - 1',
      'log(expm1(2) + 1)'
    ],
    'seealso': [
      'exp',
      'pow',
      'log'
    ]
  };

  var fix = {
    'name': 'fix',
    'category': 'Arithmetic',
    'syntax': [
      'fix(x)'
    ],
    'description':
        'Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.',
    'examples': [
      'fix(3.2)',
      'fix(3.8)',
      'fix(-4.2)',
      'fix(-4.8)'
    ],
    'seealso': ['ceil', 'floor', 'round']
  };

  var floor = {
    'name': 'floor',
    'category': 'Arithmetic',
    'syntax': [
      'floor(x)'
    ],
    'description':
        'Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.',
    'examples': [
      'floor(3.2)',
      'floor(3.8)',
      'floor(-4.2)'
    ],
    'seealso': ['ceil', 'fix', 'round']
  };

  var gcd = {
    'name': 'gcd',
    'category': 'Arithmetic',
    'syntax': [
      'gcd(a, b)',
      'gcd(a, b, c, ...)'
    ],
    'description': 'Compute the greatest common divisor.',
    'examples': [
      'gcd(8, 12)',
      'gcd(-4, 6)',
      'gcd(25, 15, -10)'
    ],
    'seealso': [ 'lcm', 'xgcd' ]
  };

  var hypot = {
    'name': 'hypot',
    'category': 'Arithmetic',
    'syntax': [
      'hypot(a, b, c, ...)',
      'hypot([a, b, c, ...])'
    ],
    'description': 'Calculate the hypotenusa of a list with values. ',
    'examples': [
      'hypot(3, 4)',
      'sqrt(3^2 + 4^2)',
      'hypot(-2)',
      'hypot([3, 4, 5])'
    ],
    'seealso': [ 'abs', 'norm' ]
  };

  var lcm = {
    'name': 'lcm',
    'category': 'Arithmetic',
    'syntax': [
      'lcm(x, y)'
    ],
    'description': 'Compute the least common multiple.',
    'examples': [
      'lcm(4, 6)',
      'lcm(6, 21)',
      'lcm(6, 21, 5)'
    ],
    'seealso': [ 'gcd' ]
  };

  var log = {
    'name': 'log',
    'category': 'Arithmetic',
    'syntax': [
      'log(x)',
      'log(x, base)'
    ],
    'description': 'Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).',
    'examples': [
      'log(3.5)',
      'a = log(2.4)',
      'exp(a)',
      '10 ^ 4',
      'log(10000, 10)',
      'log(10000) / log(10)',
      'b = log(1024, 2)',
      '2 ^ b'
    ],
    'seealso': [
      'exp',
      'log1p',
      'log2',
      'log10'
    ]
  };

  var log2 = {
    'name': 'log2',
    'category': 'Arithmetic',
    'syntax': [
      'log2(x)'
    ],
    'description': 'Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.',
    'examples': [
      'log2(0.03125)',
      'log2(16)',
      'log2(16) / log2(2)',
      'pow(2, 4)'
    ],
    'seealso': [
      'exp',
      'log1p',
      'log',
      'log10'
    ]
  };

  var log1p = {
    'name': 'log1p',
    'category': 'Arithmetic',
    'syntax': [
      'log1p(x)',
      'log1p(x, base)'
    ],
    'description': 'Calculate the logarithm of a `value+1`',
    'examples': [
      'log1p(2.5)',
      'exp(log1p(1.4))',
      'pow(10, 4)',
      'log1p(9999, 10)',
      'log1p(9999) / log(10)'
    ],
    'seealso': [
      'exp',
      'log',
      'log2',
      'log10'
    ]
  };

  var log10 = {
    'name': 'log10',
    'category': 'Arithmetic',
    'syntax': [
      'log10(x)'
    ],
    'description': 'Compute the 10-base logarithm of a value.',
    'examples': [
      'log10(0.00001)',
      'log10(10000)',
      '10 ^ 4',
      'log(10000) / log(10)',
      'log(10000, 10)'
    ],
    'seealso': [
      'exp',
      'log'
    ]
  };

  var mod = {
    'name': 'mod',
    'category': 'Operators',
    'syntax': [
      'x % y',
      'x mod y',
      'mod(x, y)'
    ],
    'description':
        'Calculates the modulus, the remainder of an integer division.',
    'examples': [
      '7 % 3',
      '11 % 2',
      '10 mod 4',
      'isOdd(x) = x % 2',
      'isOdd(2)',
      'isOdd(3)'
    ],
    'seealso': ['divide']
  };

  var multiply = {
    'name': 'multiply',
    'category': 'Operators',
    'syntax': [
      'x * y',
      'multiply(x, y)'
    ],
    'description': 'multiply two values.',
    'examples': [
      'a = 2.1 * 3.4',
      'a / 3.4',
      '2 * 3 + 4',
      '2 * (3 + 4)',
      '3 * 2.1 km'
    ],
    'seealso': [
      'divide'
    ]
  };

  var norm = {
    'name': 'norm',
    'category': 'Arithmetic',
    'syntax': [
      'norm(x)',
      'norm(x, p)'
    ],
    'description': 'Calculate the norm of a number, vector or matrix.',
    'examples': [
      'abs(-3.5)',
      'norm(-3.5)',
      'norm(3 - 4i)',
      'norm([1, 2, -3], Infinity)',
      'norm([1, 2, -3], -Infinity)',
      'norm([3, 4], 2)',
      'norm([[1, 2], [3, 4]], 1)',
      'norm([[1, 2], [3, 4]], "inf")',
      'norm([[1, 2], [3, 4]], "fro")'
    ]
  };

  var nthRoot = {
    'name': 'nthRoot',
    'category': 'Arithmetic',
    'syntax': [
      'nthRoot(a)',
      'nthRoot(a, root)'
    ],
    'description': 'Calculate the nth root of a value. ' +
        'The principal nth root of a positive real number A, ' +
        'is the positive real solution of the equation "x^root = A".',
    'examples': [
      '4 ^ 3',
      'nthRoot(64, 3)',
      'nthRoot(9, 2)',
      'sqrt(9)'
    ],
    'seealso': [
      'sqrt',
      'pow'
    ]
  };

  var pow = {
    'name': 'pow',
    'category': 'Operators',
    'syntax': [
      'x ^ y',
      'pow(x, y)'
    ],
    'description':
        'Calculates the power of x to y, x^y.',
    'examples': [
      '2^3',
      '2*2*2',
      '1 + e ^ (pi * i)'
    ],
    'seealso': [ 'multiply' ]
  };

  var round = {
    'name': 'round',
    'category': 'Arithmetic',
    'syntax': [
      'round(x)',
      'round(x, n)'
    ],
    'description':
        'round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.',
    'examples': [
      'round(3.2)',
      'round(3.8)',
      'round(-4.2)',
      'round(-4.8)',
      'round(pi, 3)',
      'round(123.45678, 2)'
    ],
    'seealso': ['ceil', 'floor', 'fix']
  };

  var sign = {
    'name': 'sign',
    'category': 'Arithmetic',
    'syntax': [
      'sign(x)'
    ],
    'description':
        'Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.',
    'examples': [
      'sign(3.5)',
      'sign(-4.2)',
      'sign(0)'
    ],
    'seealso': [
      'abs'
    ]
  };

  var sqrt = {
    'name': 'sqrt',
    'category': 'Arithmetic',
    'syntax': [
      'sqrt(x)'
    ],
    'description':
        'Compute the square root value. If x = y * y, then y is the square root of x.',
    'examples': [
      'sqrt(25)',
      '5 * 5',
      'sqrt(-1)'
    ],
    'seealso': [
      'square',
      'sqrtm',
      'multiply'
    ]
  };

  var sqrtm = {
    'name': 'sqrtm',
    'category': 'Arithmetic',
    'syntax': [
      'sqrtm(x)'
    ],
    'description':
        'Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.',
    'examples': [
      'sqrtm([[1, 2], [3, 4]])'
    ],
    'seealso': [
      'sqrt',
      'abs',
      'square',
      'multiply'
    ]
  };

  var square = {
    'name': 'square',
    'category': 'Arithmetic',
    'syntax': [
      'square(x)'
    ],
    'description':
        'Compute the square of a value. The square of x is x * x.',
    'examples': [
      'square(3)',
      'sqrt(9)',
      '3^2',
      '3 * 3'
    ],
    'seealso': [
      'multiply',
      'pow',
      'sqrt',
      'cube'
    ]
  };

  var subtract = {
    'name': 'subtract',
    'category': 'Operators',
    'syntax': [
      'x - y',
      'subtract(x, y)'
    ],
    'description': 'subtract two values.',
    'examples': [
      'a = 5.3 - 2',
      'a + 2',
      '2/3 - 1/6',
      '2 * 3 - 3',
      '2.1 km - 500m'
    ],
    'seealso': [
      'add'
    ]
  };

  var unaryMinus = {
    'name': 'unaryMinus',
    'category': 'Operators',
    'syntax': [
      '-x',
      'unaryMinus(x)'
    ],
    'description':
        'Inverse the sign of a value. Converts booleans and strings to numbers.',
    'examples': [
      '-4.5',
      '-(-5.6)',
      '-"22"'
    ],
    'seealso': [
      'add', 'subtract', 'unaryPlus'
    ]
  };

  var unaryPlus = {
    'name': 'unaryPlus',
    'category': 'Operators',
    'syntax': [
      '+x',
      'unaryPlus(x)'
    ],
    'description':
        'Converts booleans and strings to numbers.',
    'examples': [
      '+true',
      '+"2"'
    ],
    'seealso': [
      'add', 'subtract', 'unaryMinus'
    ]
  };

  var xgcd = {
    'name': 'xgcd',
    'category': 'Arithmetic',
    'syntax': [
      'xgcd(a, b)'
    ],
    'description': 'Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.',
    'examples': [
      'xgcd(8, 12)',
      'gcd(8, 12)',
      'xgcd(36163, 21199)'
    ],
    'seealso': [ 'gcd', 'lcm' ]
  };

  var bitAnd = {
    'name': 'bitAnd',
    'category': 'Bitwise',
    'syntax': [
      'x & y',
      'bitAnd(x, y)'
    ],
    'description': 'Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0',
    'examples': [
      '5 & 3',
      'bitAnd(53, 131)',
      '[1, 12, 31] & 42'
    ],
    'seealso': [
      'bitNot', 'bitOr', 'bitXor', 'leftShift', 'rightArithShift', 'rightLogShift'
    ]
  };

  var bitNot = {
    'name': 'bitNot',
    'category': 'Bitwise',
    'syntax': [
      '~x',
      'bitNot(x)'
    ],
    'description': 'Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.',
    'examples': [
      '~1',
      '~2',
      'bitNot([2, -3, 4])'
    ],
    'seealso': [
      'bitAnd', 'bitOr', 'bitXor', 'leftShift', 'rightArithShift', 'rightLogShift'
    ]
  };

  var bitOr = {
    'name': 'bitOr',
    'category': 'Bitwise',
    'syntax': [
      'x | y',
      'bitOr(x, y)'
    ],
    'description': 'Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.',
    'examples': [
      '5 | 3',
      'bitOr([1, 2, 3], 4)'
    ],
    'seealso': [
      'bitAnd', 'bitNot', 'bitXor', 'leftShift', 'rightArithShift', 'rightLogShift'
    ]
  };

  var bitXor = {
    'name': 'bitXor',
    'category': 'Bitwise',
    'syntax': [
      'bitXor(x, y)'
    ],
    'description': 'Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.',
    'examples': [
      'bitOr(1, 2)',
      'bitXor([2, 3, 4], 4)'
    ],
    'seealso': [
      'bitAnd', 'bitNot', 'bitOr', 'leftShift', 'rightArithShift', 'rightLogShift'
    ]
  };

  var leftShift = {
    'name': 'leftShift',
    'category': 'Bitwise',
    'syntax': [
      'x << y',
      'leftShift(x, y)'
    ],
    'description': 'Bitwise left logical shift of a value x by y number of bits.',
    'examples': [
      '4 << 1',
      '8 >> 1'
    ],
    'seealso': [
      'bitAnd', 'bitNot', 'bitOr', 'bitXor', 'rightArithShift', 'rightLogShift'
    ]
  };

  var rightArithShift = {
    'name': 'rightArithShift',
    'category': 'Bitwise',
    'syntax': [
      'x >> y',
      'rightArithShift(x, y)'
    ],
    'description': 'Bitwise right arithmetic shift of a value x by y number of bits.',
    'examples': [
      '8 >> 1',
      '4 << 1',
      '-12 >> 2'
    ],
    'seealso': [
      'bitAnd', 'bitNot', 'bitOr', 'bitXor', 'leftShift', 'rightLogShift'
    ]
  };

  var rightLogShift = {
    'name': 'rightLogShift',
    'category': 'Bitwise',
    'syntax': [
      'x >>> y',
      'rightLogShift(x, y)'
    ],
    'description': 'Bitwise right logical shift of a value x by y number of bits.',
    'examples': [
      '8 >>> 1',
      '4 << 1',
      '-12 >>> 2'
    ],
    'seealso': [
      'bitAnd', 'bitNot', 'bitOr', 'bitXor', 'leftShift', 'rightArithShift'
    ]
  };

  var bellNumbers = {
    'name': 'bellNumbers',
    'category': 'Combinatorics',
    'syntax': [
      'bellNumbers(n)'
    ],
    'description': 'The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.',
    'examples': [
      'bellNumbers(3)',
      'bellNumbers(8)'
    ],
    'seealso': ['stirlingS2']
  };

  var catalan = {
    'name': 'catalan',
    'category': 'Combinatorics',
    'syntax': [
      'catalan(n)'
    ],
    'description': 'The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.',
    'examples': [
      'catalan(3)',
      'catalan(8)'
    ],
    'seealso': ['bellNumbers']
  };

  var composition = {
    'name': 'composition',
    'category': 'Combinatorics',
    'syntax': [
      'composition(n, k)'
    ],
    'description': 'The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.',
    'examples': [
      'composition(5, 3)'
    ],
    'seealso': ['combinations']
  };

  var stirlingS2 = {
    'name': 'stirlingS2',
    'category': 'Combinatorics',
    'syntax': [
      'stirlingS2(n, k)'
    ],
    'description': 'he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.',
    'examples': [
      'stirlingS2(5, 3)'
    ],
    'seealso': ['bellNumbers']
  };

  var config$1 = {
    'name': 'config',
    'category': 'Core',
    'syntax': [
      'config()',
      'config(options)'
    ],
    'description': 'Get configuration or change configuration.',
    'examples': [
      'config()',
      '1/3 + 1/4',
      'config({number: "Fraction"})',
      '1/3 + 1/4'
    ],
    'seealso': []
  };

  var _import$1 = {
    'name': 'import',
    'category': 'Core',
    'syntax': [
      'import(functions)',
      'import(functions, options)'
    ],
    'description': 'Import functions or constants from an object.',
    'examples': [
      'import({myFn: f(x)=x^2, myConstant: 32 })',
      'myFn(2)',
      'myConstant'
    ],
    'seealso': []
  };

  var typed$1 = {
    'name': 'typed',
    'category': 'Core',
    'syntax': [
      'typed(signatures)',
      'typed(name, signatures)'
    ],
    'description': 'Create a typed function.',
    'examples': [
      'double = typed({ "number, number": f(x)=x+x })',
      'double(2)',
      'double("hello")'
    ],
    'seealso': []
  };

  var arg = {
    'name': 'arg',
    'category': 'Complex',
    'syntax': [
      'arg(x)'
    ],
    'description':
        'Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).',
    'examples': [
      'arg(2 + 2i)',
      'atan2(3, 2)',
      'arg(2 + 3i)'
    ],
    'seealso': [
      're',
      'im',
      'conj',
      'abs'
    ]
  };

  var conj = {
    'name': 'conj',
    'category': 'Complex',
    'syntax': [
      'conj(x)'
    ],
    'description':
        'Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.',
    'examples': [
      'conj(2 + 3i)',
      'conj(2 - 3i)',
      'conj(-5.2i)'
    ],
    'seealso': [
      're',
      'im',
      'abs',
      'arg'
    ]
  };

  var re = {
    'name': 're',
    'category': 'Complex',
    'syntax': [
      're(x)'
    ],
    'description': 'Get the real part of a complex number.',
    'examples': [
      're(2 + 3i)',
      'im(2 + 3i)',
      're(-5.2i)',
      're(2.4)'
    ],
    'seealso': [
      'im',
      'conj',
      'abs',
      'arg'
    ]
  };

  var im = {
    'name': 'im',
    'category': 'Complex',
    'syntax': [
      'im(x)'
    ],
    'description': 'Get the imaginary part of a complex number.',
    'examples': [
      'im(2 + 3i)',
      're(2 + 3i)',
      'im(-5.2i)',
      'im(2.4)'
    ],
    'seealso': [
      're',
      'conj',
      'abs',
      'arg'
    ]
  };

  var _eval = {
    'name': 'eval',
    'category': 'Expression',
    'syntax': [
      'eval(expression)',
      'eval([expr1, expr2, expr3, ...])'
    ],
    'description': 'Evaluate an expression or an array with expressions.',
    'examples': [
      'eval("2 + 3")',
      'eval("sqrt(" + 4 + ")")'
    ],
    'seealso': []
  };

  var help = {
    'name': 'help',
    'category': 'Expression',
    'syntax': [
      'help(object)',
      'help(string)'
    ],
    'description': 'Display documentation on a function or data type.',
    'examples': [
      'help(sqrt)',
      'help("complex")'
    ],
    'seealso': []
  };

  var distance = {
    'name': 'distance',
    'category': 'Geometry',
    'syntax': [
      'distance([x1, y1], [x2, y2])',
      'distance([[x1, y1], [x2, y2])'
    ],
    'description': 'Calculates the Euclidean distance between two points.',
    'examples': [
      'distance([0,0], [4,4])',
      'distance([[0,0], [4,4]])'
    ],
    'seealso': []
  };

  var intersect = {
    'name': 'intersect',
    'category': 'Geometry',
    'syntax': [
      'intersect(expr1, expr2, expr3, expr4)',
      'intersect(expr1, expr2, expr3)'
    ],
    'description': 'Computes the intersection point of lines and/or planes.',
    'examples': [
      'intersect([0, 0], [10, 10], [10, 0], [0, 10])',
      'intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])'
    ],
    'seealso': []
  };

  var and = {
    'name': 'and',
    'category': 'Logical',
    'syntax': [
      'x and y',
      'and(x, y)'
    ],
    'description': 'Logical and. Test whether two values are both defined with a nonzero/nonempty value.',
    'examples': [
      'true and false',
      'true and true',
      '2 and 4'
    ],
    'seealso': [
      'not', 'or', 'xor'
    ]
  };

  var not = {
    'name': 'not',
    'category': 'Logical',
    'syntax': [
      'not x',
      'not(x)'
    ],
    'description': 'Logical not. Flips the boolean value of given argument.',
    'examples': [
      'not true',
      'not false',
      'not 2',
      'not 0'
    ],
    'seealso': [
      'and', 'or', 'xor'
    ]
  };

  var or = {
    'name': 'or',
    'category': 'Logical',
    'syntax': [
      'x or y',
      'or(x, y)'
    ],
    'description': 'Logical or. Test if at least one value is defined with a nonzero/nonempty value.',
    'examples': [
      'true or false',
      'false or false',
      '0 or 4'
    ],
    'seealso': [
      'not', 'and', 'xor'
    ]
  };

  var xor = {
    'name': 'xor',
    'category': 'Logical',
    'syntax': [
      'x xor y',
      'xor(x, y)'
    ],
    'description': 'Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.',
    'examples': [
      'true xor false',
      'false xor false',
      'true xor true',
      '0 xor 4'
    ],
    'seealso': [
      'not', 'and', 'or'
    ]
  };

  var concat = {
    'name': 'concat',
    'category': 'Matrix',
    'syntax': [
      'concat(A, B, C, ...)',
      'concat(A, B, C, ..., dim)'
    ],
    'description': 'Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.',
    'examples': [
      'A = [1, 2; 5, 6]',
      'B = [3, 4; 7, 8]',
      'concat(A, B)',
      'concat(A, B, 1)',
      'concat(A, B, 2)'
    ],
    'seealso': [
      'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var cross = {
    'name': 'cross',
    'category': 'Matrix',
    'syntax': [
      'cross(A, B)'
    ],
    'description': 'Calculate the cross product for two vectors in three dimensional space.',
    'examples': [
      'cross([1, 1, 0],  [0, 1, 1])',
      'cross([3, -3, 1], [4, 9, 2])',
      'cross([2, 3, 4],  [5, 6, 7])'
    ],
    'seealso': [
      'multiply',
      'dot'
    ]
  };

  var det = {
    'name': 'det',
    'category': 'Matrix',
    'syntax': [
      'det(x)'
    ],
    'description': 'Calculate the determinant of a matrix',
    'examples': [
      'det([1, 2; 3, 4])',
      'det([-2, 2, 3; -1, 1, 3; 2, 0, -1])'
    ],
    'seealso': [
      'concat', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var diag = {
    'name': 'diag',
    'category': 'Matrix',
    'syntax': [
      'diag(x)',
      'diag(x, k)'
    ],
    'description': 'Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.',
    'examples': [
      'diag(1:3)',
      'diag(1:3, 1)',
      'a = [1, 2, 3; 4, 5, 6; 7, 8, 9]',
      'diag(a)'
    ],
    'seealso': [
      'concat', 'det', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var dot = {
    'name': 'dot',
    'category': 'Matrix',
    'syntax': [
      'dot(A, B)',
      'A * B'
    ],
    'description': 'Calculate the dot product of two vectors. ' +
        'The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] ' +
        'is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn',
    'examples': [
      'dot([2, 4, 1], [2, 2, 3])',
      '[2, 4, 1] * [2, 2, 3]'
    ],
    'seealso': [
      'multiply',
      'cross'
    ]
  };

  var eye = {
    'name': 'eye',
    'category': 'Matrix',
    'syntax': [
      'eye(n)',
      'eye(m, n)',
      'eye([m, n])'
    ],
    'description': 'Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.',
    'examples': [
      'eye(3)',
      'eye(3, 5)',
      'a = [1, 2, 3; 4, 5, 6]',
      'eye(size(a))'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var filter = {
    'name': 'filter',
    'category': 'Matrix',
    'syntax': [
      'filter(x, test)'
    ],
    'description': 'Filter items in a matrix.',
    'examples': [
      'isPositive(x) = x > 0',
      'filter([6, -2, -1, 4, 3], isPositive)',
      'filter([6, -2, 0, 1, 0], x != 0)'
    ],
    'seealso': ['sort', 'map', 'forEach']
  };

  var flatten$1 = {
    'name': 'flatten',
    'category': 'Matrix',
    'syntax': [
      'flatten(x)'
    ],
    'description': 'Flatten a multi dimensional matrix into a single dimensional matrix.',
    'examples': [
      'a = [1, 2, 3; 4, 5, 6]',
      'size(a)',
      'b = flatten(a)',
      'size(b)'
    ],
    'seealso': [
      'concat', 'resize', 'size', 'squeeze'
    ]
  };

  var forEach = {
    'name': 'forEach',
    'category': 'Matrix',
    'syntax': [
      'forEach(x, callback)'
    ],
    'description': 'Iterates over all elements of a matrix/array, and executes the given callback function.',
    'examples': [
      'forEach([1, 2, 3], function(val) { console.log(val) })'
    ],
    'seealso': ['map', 'sort', 'filter']
  };

  var inv = {
    'name': 'inv',
    'category': 'Matrix',
    'syntax': [
      'inv(x)'
    ],
    'description': 'Calculate the inverse of a matrix',
    'examples': [
      'inv([1, 2; 3, 4])',
      'inv(4)',
      '1 / 4'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var kron = {
    'name': 'kron',
    'category': 'Matrix',
    'syntax': [
      'kron(x, y)'
    ],
    'description': 'Calculates the kronecker product of 2 matrices or vectors.',
    'examples': [
      'kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])',
      'kron([1,1], [2,3,4])'
    ],
    'seealso': [
      'multiply', 'dot', 'cross'
    ]
  };

  var map = {
    'name': 'map',
    'category': 'Matrix',
    'syntax': [
      'map(x, callback)'
    ],
    'description': 'Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.',
    'examples': [
      'map([1, 2, 3], square)'
    ],
    'seealso': ['filter', 'forEach']
  };

  var ones = {
    'name': 'ones',
    'category': 'Matrix',
    'syntax': [
      'ones(m)',
      'ones(m, n)',
      'ones(m, n, p, ...)',
      'ones([m])',
      'ones([m, n])',
      'ones([m, n, p, ...])'
    ],
    'description': 'Create a matrix containing ones.',
    'examples': [
      'ones(3)',
      'ones(3, 5)',
      'ones([2,3]) * 4.5',
      'a = [1, 2, 3; 4, 5, 6]',
      'ones(size(a))'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var partitionSelect = {
    'name': 'partitionSelect',
    'category': 'Matrix',
    'syntax': [
      'partitionSelect(x, k)',
      'partitionSelect(x, k, compare)'
    ],
    'description': 'Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.',
    'examples': [
      'partitionSelect([5, 10, 1], 2)',
      'partitionSelect(["C", "B", "A", "D"], 1)'
    ],
    'seealso': ['sort']
  };

  var range = {
    'name': 'range',
    'category': 'Type',
    'syntax': [
      'start:end',
      'start:step:end',
      'range(start, end)',
      'range(start, end, step)',
      'range(string)'
    ],
    'description':
        'Create a range. Lower bound of the range is included, upper bound is excluded.',
    'examples': [
      '1:5',
      '3:-1:-3',
      'range(3, 7)',
      'range(0, 12, 2)',
      'range("4:10")',
      'a = [1, 2, 3, 4; 5, 6, 7, 8]',
      'a[1:2, 1:2]'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'size', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var resize = {
    'name': 'resize',
    'category': 'Matrix',
    'syntax': [
      'resize(x, size)',
      'resize(x, size, defaultValue)'
    ],
    'description': 'Resize a matrix.',
    'examples': [
      'resize([1,2,3,4,5], [3])',
      'resize([1,2,3], [5])',
      'resize([1,2,3], [5], -1)',
      'resize(2, [2, 3])',
      'resize("hello", [8], "!")'
    ],
    'seealso': [
      'size', 'subset', 'squeeze', 'reshape'
    ]
  };

  var reshape = {
    'name': 'reshape',
    'category': 'Matrix',
    'syntax': [
      'reshape(x, sizes)'
    ],
    'description': 'Reshape a multi dimensional array to fit the specified dimensions.',
    'examples': [
      'reshape([1, 2, 3, 4, 5, 6], [2, 3])',
      'reshape([[1, 2], [3, 4]], [1, 4])',
      'reshape([[1, 2], [3, 4]], [4])'
    ],
    'seealso': [
      'size', 'squeeze', 'resize'
    ]
  };

  var size = {
    'name': 'size',
    'category': 'Matrix',
    'syntax': [
      'size(x)'
    ],
    'description': 'Calculate the size of a matrix.',
    'examples': [
      'size(2.3)',
      'size("hello world")',
      'a = [1, 2; 3, 4; 5, 6]',
      'size(a)',
      'size(1:6)'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'squeeze', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var sort = {
    'name': 'sort',
    'category': 'Matrix',
    'syntax': [
      'sort(x)',
      'sort(x, compare)'
    ],
    'description': 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
    'examples': [
      'sort([5, 10, 1])',
      'sort(["C", "B", "A", "D"])',
      'sortByLength(a, b) = size(a)[1] - size(b)[1]',
      'sort(["Langdon", "Tom", "Sara"], sortByLength)',
      'sort(["10", "1", "2"], "natural")'
    ],
    'seealso': ['map', 'filter', 'forEach']
  };

  var squeeze = {
    'name': 'squeeze',
    'category': 'Matrix',
    'syntax': [
      'squeeze(x)'
    ],
    'description': 'Remove inner and outer singleton dimensions from a matrix.',
    'examples': [
      'a = zeros(3,2,1)',
      'size(squeeze(a))',
      'b = zeros(1,1,3)',
      'size(squeeze(b))'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'subset', 'trace', 'transpose', 'zeros'
    ]
  };

  var subset = {
    'name': 'subset',
    'category': 'Matrix',
    'syntax': [
      'value(index)',
      'value(index) = replacement',
      'subset(value, [index])',
      'subset(value, [index], replacement)'
    ],
    'description': 'Get or set a subset of a matrix or string. ' +
        'Indexes are one-based. ' +
        'Both the ranges lower-bound and upper-bound are included.',
    'examples': [
      'd = [1, 2; 3, 4]',
      'e = []',
      'e[1, 1:2] = [5, 6]',
      'e[2, :] = [7, 8]',
      'f = d * e',
      'f[2, 1]',
      'f[:, 1]'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'trace', 'transpose', 'zeros'
    ]
  };

  var trace = {
    'name': 'trace',
    'category': 'Matrix',
    'syntax': [
      'trace(A)'
    ],
    'description': 'Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.',
    'examples': [
      'A = [1, 2, 3; -1, 2, 3; 2, 0, 3]',
      'trace(A)'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'transpose', 'zeros'
    ]
  };

  var transpose = {
    'name': 'transpose',
    'category': 'Matrix',
    'syntax': [
      'x\'',
      'transpose(x)'
    ],
    'description': 'Transpose a matrix',
    'examples': [
      'a = [1, 2, 3; 4, 5, 6]',
      'a\'',
      'transpose(a)'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'zeros'
    ]
  };

  var zeros = {
    'name': 'zeros',
    'category': 'Matrix',
    'syntax': [
      'zeros(m)',
      'zeros(m, n)',
      'zeros(m, n, p, ...)',
      'zeros([m])',
      'zeros([m, n])',
      'zeros([m, n, p, ...])'
    ],
    'description': 'Create a matrix containing zeros.',
    'examples': [
      'zeros(3)',
      'zeros(3, 5)',
      'a = [1, 2, 3; 4, 5, 6]',
      'zeros(size(a))'
    ],
    'seealso': [
      'concat', 'det', 'diag', 'eye', 'inv', 'ones', 'range', 'size', 'squeeze', 'subset', 'trace', 'transpose'
    ]
  };

  var combinations = {
    'name': 'combinations',
    'category': 'Probability',
    'syntax': [
      'combinations(n, k)'
    ],
    'description': 'Compute the number of combinations of n items taken k at a time',
    'examples': [
      'combinations(7, 5)'
    ],
    'seealso': ['permutations', 'factorial']
  };

  var factorial = {
    'name': 'factorial',
    'category': 'Probability',
    'syntax': [
      'n!',
      'factorial(n)'
    ],
    'description': 'Compute the factorial of a value',
    'examples': [
      '5!',
      '5 * 4 * 3 * 2 * 1',
      '3!'
    ],
    'seealso': ['combinations', 'permutations', 'gamma']
  };

  var gamma = {
    'name': 'gamma',
    'category': 'Probability',
    'syntax': [
      'gamma(n)'
    ],
    'description': 'Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.',
    'examples': [
      'gamma(4)',
      '3!',
      'gamma(1/2)',
      'sqrt(pi)'
    ],
    'seealso': ['factorial']
  };

  var kldivergence = {
    'name': 'kldivergence',
    'category': 'Probability',
    'syntax': [
      'kldivergence(x, y)'
    ],
    'description': 'Calculate the Kullback-Leibler (KL) divergence  between two distributions.',
    'examples': [
      'kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])'
    ],
    'seealso': []
  };

  var multinomial = {
    'name': 'multinomial',
    'category': 'Probability',
    'syntax': [
      'multinomial(A)'
    ],
    'description': 'Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.',
    'examples': [
      'multinomial([1, 2, 1])'
    ],
    'seealso': ['combinations', 'factorial']
  };

  var permutations = {
    'name': 'permutations',
    'category': 'Probability',
    'syntax': [
      'permutations(n)',
      'permutations(n, k)'
    ],
    'description': 'Compute the number of permutations of n items taken k at a time',
    'examples': [
      'permutations(5)',
      'permutations(5, 3)'
    ],
    'seealso': ['combinations', 'factorial']
  };

  var pickRandom = {
    'name': 'pickRandom',
    'category': 'Probability',
    'syntax': [
      'pickRandom(array)',
      'pickRandom(array, number)',
      'pickRandom(array, weights)',
      'pickRandom(array, number, weights)',
      'pickRandom(array, weights, number)'
    ],
    'description':
        'Pick a random entry from a given array.',
    'examples': [
      'pickRandom(0:10)',
      'pickRandom([1, 3, 1, 6])',
      'pickRandom([1, 3, 1, 6], 2)',
      'pickRandom([1, 3, 1, 6], [2, 3, 2, 1])',
      'pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])',
      'pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)'
    ],
    'seealso': ['random', 'randomInt']
  };

  var random = {
    'name': 'random',
    'category': 'Probability',
    'syntax': [
      'random()',
      'random(max)',
      'random(min, max)',
      'random(size)',
      'random(size, max)',
      'random(size, min, max)'
    ],
    'description':
        'Return a random number.',
    'examples': [
      'random()',
      'random(10, 20)',
      'random([2, 3])'
    ],
    'seealso': ['pickRandom', 'randomInt']
  };

  var randomInt = {
    'name': 'randomInt',
    'category': 'Probability',
    'syntax': [
      'randomInt(max)',
      'randomInt(min, max)',
      'randomInt(size)',
      'randomInt(size, max)',
      'randomInt(size, min, max)'
    ],
    'description':
        'Return a random integer number',
    'examples': [
      'randomInt(10, 20)',
      'randomInt([2, 3], 10)'
    ],
    'seealso': ['pickRandom', 'random']
  };

  var compare = {
    'name': 'compare',
    'category': 'Relational',
    'syntax': [
      'compare(x, y)'
    ],
    'description':
        'Compare two values. ' +
        'Returns 1 when x > y, -1 when x < y, and 0 when x == y.',
    'examples': [
      'compare(2, 3)',
      'compare(3, 2)',
      'compare(2, 2)',
      'compare(5cm, 40mm)',
      'compare(2, [1, 2, 3])'
    ],
    'seealso': [
      'equal', 'unequal', 'smaller', 'smallerEq', 'largerEq', 'compareNatural', 'compareText'
    ]
  };

  var compareNatural = {
    'name': 'compareNatural',
    'category': 'Relational',
    'syntax': [
      'compareNatural(x, y)'
    ],
    'description':
        'Compare two values of any type in a deterministic, natural way. ' +
        'Returns 1 when x > y, -1 when x < y, and 0 when x == y.',
    'examples': [
      'compareNatural(2, 3)',
      'compareNatural(3, 2)',
      'compareNatural(2, 2)',
      'compareNatural(5cm, 40mm)',
      'compareNatural("2", "10")',
      'compareNatural(2 + 3i, 2 + 4i)',
      'compareNatural([1, 2, 4], [1, 2, 3])',
      'compareNatural([1, 5], [1, 2, 3])',
      'compareNatural([1, 2], [1, 2])',
      'compareNatural({a: 2}, {a: 4})'
    ],
    'seealso': [
      'equal', 'unequal', 'smaller', 'smallerEq', 'largerEq', 'compare', 'compareText'
    ]
  };

  var compareText = {
    'name': 'compareText',
    'category': 'Relational',
    'syntax': [
      'compareText(x, y)'
    ],
    'description':
        'Compare two strings lexically. Comparison is case sensitive. ' +
        'Returns 1 when x > y, -1 when x < y, and 0 when x == y.',
    'examples': [
      'compareText("B", "A")',
      'compareText("A", "B")',
      'compareText("A", "A")',
      'compareText("2", "10")',
      'compare("2", "10")',
      'compare(2, 10)',
      'compareNatural("2", "10")',
      'compareText("B", ["A", "B", "C"])'
    ],
    'seealso': [
      'compare', 'compareNatural'
    ]
  };

  var deepEqual = {
    'name': 'deepEqual',
    'category': 'Relational',
    'syntax': [
      'deepEqual(x, y)'
    ],
    'description':
        'Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.',
    'examples': [
      'deepEqual([1,3,4], [1,3,4])',
      'deepEqual([1,3,4], [1,3])'
    ],
    'seealso': [
      'equal', 'unequal', 'smaller', 'larger', 'smallerEq', 'largerEq', 'compare'
    ]
  };

  var equal = {
    'name': 'equal',
    'category': 'Relational',
    'syntax': [
      'x == y',
      'equal(x, y)'
    ],
    'description':
        'Check equality of two values. Returns true if the values are equal, and false if not.',
    'examples': [
      '2+2 == 3',
      '2+2 == 4',
      'a = 3.2',
      'b = 6-2.8',
      'a == b',
      '50cm == 0.5m'
    ],
    'seealso': [
      'unequal', 'smaller', 'larger', 'smallerEq', 'largerEq', 'compare', 'deepEqual', 'equalText'
    ]
  };

  var equalText = {
    'name': 'equalText',
    'category': 'Relational',
    'syntax': [
      'equalText(x, y)'
    ],
    'description':
        'Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.',
    'examples': [
      'equalText("Hello", "Hello")',
      'equalText("a", "A")',
      'equal("2e3", "2000")',
      'equalText("2e3", "2000")',
      'equalText("B", ["A", "B", "C"])'
    ],
    'seealso': [
      'compare', 'compareNatural', 'compareText', 'equal'
    ]
  };

  var larger$1 = {
    'name': 'larger',
    'category': 'Relational',
    'syntax': [
      'x > y',
      'larger(x, y)'
    ],
    'description':
        'Check if value x is larger than y. Returns true if x is larger than y, and false if not.',
    'examples': [
      '2 > 3',
      '5 > 2*2',
      'a = 3.3',
      'b = 6-2.8',
      '(a > b)',
      '(b < a)',
      '5 cm > 2 inch'
    ],
    'seealso': [
      'equal', 'unequal', 'smaller', 'smallerEq', 'largerEq', 'compare'
    ]
  };

  var largerEq = {
    'name': 'largerEq',
    'category': 'Relational',
    'syntax': [
      'x >= y',
      'largerEq(x, y)'
    ],
    'description':
        'Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.',
    'examples': [
      '2 >= 1+1',
      '2 > 1+1',
      'a = 3.2',
      'b = 6-2.8',
      '(a >= b)'
    ],
    'seealso': [
      'equal', 'unequal', 'smallerEq', 'smaller', 'compare'
    ]
  };

  var smaller$1 = {
    'name': 'smaller',
    'category': 'Relational',
    'syntax': [
      'x < y',
      'smaller(x, y)'
    ],
    'description':
        'Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.',
    'examples': [
      '2 < 3',
      '5 < 2*2',
      'a = 3.3',
      'b = 6-2.8',
      '(a < b)',
      '5 cm < 2 inch'
    ],
    'seealso': [
      'equal', 'unequal', 'larger', 'smallerEq', 'largerEq', 'compare'
    ]
  };

  var smallerEq = {
    'name': 'smallerEq',
    'category': 'Relational',
    'syntax': [
      'x <= y',
      'smallerEq(x, y)'
    ],
    'description':
        'Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.',
    'examples': [
      '2 <= 1+1',
      '2 < 1+1',
      'a = 3.2',
      'b = 6-2.8',
      '(a <= b)'
    ],
    'seealso': [
      'equal', 'unequal', 'larger', 'smaller', 'largerEq', 'compare'
    ]
  };

  var unequal = {
    'name': 'unequal',
    'category': 'Relational',
    'syntax': [
      'x != y',
      'unequal(x, y)'
    ],
    'description':
        'Check unequality of two values. Returns true if the values are unequal, and false if they are equal.',
    'examples': [
      '2+2 != 3',
      '2+2 != 4',
      'a = 3.2',
      'b = 6-2.8',
      'a != b',
      '50cm != 0.5m',
      '5 cm != 2 inch'
    ],
    'seealso': [
      'equal', 'smaller', 'larger', 'smallerEq', 'largerEq', 'compare', 'deepEqual'
    ]
  };

  var setCartesian = {
    'name': 'setCartesian',
    'category': 'Set',
    'syntax': [
      'setCartesian(set1, set2)'
    ],
    'description':
        'Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
    'examples': [
      'setCartesian([1, 2], [3, 4])'
    ],
    'seealso': [
      'setUnion', 'setIntersect', 'setDifference', 'setPowerset'
    ]
  };

  var setDifference = {
    'name': 'setDifference',
    'category': 'Set',
    'syntax': [
      'setDifference(set1, set2)'
    ],
    'description':
        'Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
    'examples': [
      'setDifference([1, 2, 3, 4], [3, 4, 5, 6])',
      'setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
    ],
    'seealso': [
      'setUnion', 'setIntersect', 'setSymDifference'
    ]
  };

  var setDistinct = {
    'name': 'setDistinct',
    'category': 'Set',
    'syntax': [
      'setDistinct(set)'
    ],
    'description':
        'Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.',
    'examples': [
      'setDistinct([1, 1, 1, 2, 2, 3])'
    ],
    'seealso': [
      'setMultiplicity'
    ]
  };

  var setIntersect = {
    'name': 'setIntersect',
    'category': 'Set',
    'syntax': [
      'setIntersect(set1, set2)'
    ],
    'description':
        'Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
    'examples': [
      'setIntersect([1, 2, 3, 4], [3, 4, 5, 6])',
      'setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
    ],
    'seealso': [
      'setUnion', 'setDifference'
    ]
  };

  var setIsSubset = {
    'name': 'setIsSubset',
    'category': 'Set',
    'syntax': [
      'setIsSubset(set1, set2)'
    ],
    'description':
        'Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
    'examples': [
      'setIsSubset([1, 2], [3, 4, 5, 6])',
      'setIsSubset([3, 4], [3, 4, 5, 6])'
    ],
    'seealso': [
      'setUnion', 'setIntersect', 'setDifference'
    ]
  };

  var setMultiplicity = {
    'name': 'setMultiplicity',
    'category': 'Set',
    'syntax': [
      'setMultiplicity(element, set)'
    ],
    'description':
        'Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.',
    'examples': [
      'setMultiplicity(1, [1, 2, 2, 4])',
      'setMultiplicity(2, [1, 2, 2, 4])'
    ],
    'seealso': [
      'setDistinct', 'setSize'
    ]
  };

  var setPowerset = {
    'name': 'setPowerset',
    'category': 'Set',
    'syntax': [
      'setPowerset(set)'
    ],
    'description':
        'Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.',
    'examples': [
      'setPowerset([1, 2, 3])'
    ],
    'seealso': [
      'setCartesian'
    ]
  };

  var setSize = {
    'name': 'setSize',
    'category': 'Set',
    'syntax': [
      'setSize(set)',
      'setSize(set, unique)'
    ],
    'description':
        'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
    'examples': [
      'setSize([1, 2, 2, 4])',
      'setSize([1, 2, 2, 4], true)'
    ],
    'seealso': [
      'setUnion', 'setIntersect', 'setDifference'
    ]
  };

  var setSymDifference = {
    'name': 'setSymDifference',
    'category': 'Set',
    'syntax': [
      'setSymDifference(set1, set2)'
    ],
    'description':
        'Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
    'examples': [
      'setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])',
      'setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
    ],
    'seealso': [
      'setUnion', 'setIntersect', 'setDifference'
    ]
  };

  var setUnion = {
    'name': 'setUnion',
    'category': 'Set',
    'syntax': [
      'setUnion(set1, set2)'
    ],
    'description':
        'Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.',
    'examples': [
      'setUnion([1, 2, 3, 4], [3, 4, 5, 6])',
      'setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])'
    ],
    'seealso': [
      'setIntersect', 'setDifference'
    ]
  };

  var erf = {
    'name': 'erf',
    'category': 'Special',
    'syntax': [
      'erf(x)'
    ],
    'description': 'Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x',
    'examples': [
      'erf(0.2)',
      'erf(-0.5)',
      'erf(4)'
    ],
    'seealso': []
  };

  var mad = {
    'name': 'mad',
    'category': 'Statistics',
    'syntax': [
      'mad(a, b, c, ...)',
      'mad(A)'
    ],
    'description': 'Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.',
    'examples': [
      'mad(10, 20, 30)',
      'mad([1, 2, 3])'
    ],
    'seealso': [
      'mean',
      'median',
      'std',
      'abs'
    ]
  };

  var max = {
    'name': 'max',
    'category': 'Statistics',
    'syntax': [
      'max(a, b, c, ...)',
      'max(A)',
      'max(A, dim)'
    ],
    'description': 'Compute the maximum value of a list of values.',
    'examples': [
      'max(2, 3, 4, 1)',
      'max([2, 3, 4, 1])',
      'max([2, 5; 4, 3])',
      'max([2, 5; 4, 3], 1)',
      'max([2, 5; 4, 3], 2)',
      'max(2.7, 7.1, -4.5, 2.0, 4.1)',
      'min(2.7, 7.1, -4.5, 2.0, 4.1)'
    ],
    'seealso': [
      'mean',
      'median',
      'min',
      'prod',
      'std',
      'sum',
      'var'
    ]
  };

  var mean = {
    'name': 'mean',
    'category': 'Statistics',
    'syntax': [
      'mean(a, b, c, ...)',
      'mean(A)',
      'mean(A, dim)'
    ],
    'description': 'Compute the arithmetic mean of a list of values.',
    'examples': [
      'mean(2, 3, 4, 1)',
      'mean([2, 3, 4, 1])',
      'mean([2, 5; 4, 3])',
      'mean([2, 5; 4, 3], 1)',
      'mean([2, 5; 4, 3], 2)',
      'mean([1.0, 2.7, 3.2, 4.0])'
    ],
    'seealso': [
      'max',
      'median',
      'min',
      'prod',
      'std',
      'sum',
      'var'
    ]
  };

  var median = {
    'name': 'median',
    'category': 'Statistics',
    'syntax': [
      'median(a, b, c, ...)',
      'median(A)'
    ],
    'description': 'Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.',
    'examples': [
      'median(5, 2, 7)',
      'median([3, -1, 5, 7])'
    ],
    'seealso': [
      'max',
      'mean',
      'min',
      'prod',
      'std',
      'sum',
      'var',
      'quantileSeq'
    ]
  };

  var min = {
    'name': 'min',
    'category': 'Statistics',
    'syntax': [
      'min(a, b, c, ...)',
      'min(A)',
      'min(A, dim)'
    ],
    'description': 'Compute the minimum value of a list of values.',
    'examples': [
      'min(2, 3, 4, 1)',
      'min([2, 3, 4, 1])',
      'min([2, 5; 4, 3])',
      'min([2, 5; 4, 3], 1)',
      'min([2, 5; 4, 3], 2)',
      'min(2.7, 7.1, -4.5, 2.0, 4.1)',
      'max(2.7, 7.1, -4.5, 2.0, 4.1)'
    ],
    'seealso': [
      'max',
      'mean',
      'median',
      'prod',
      'std',
      'sum',
      'var'
    ]
  };

  var mode = {
    'name': 'mode',
    'category': 'Statistics',
    'syntax': [
      'mode(a, b, c, ...)',
      'mode(A)',
      'mode(A, a, b, B, c, ...)'
    ],
    'description': 'Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.',
    'examples': [
      'mode(2, 1, 4, 3, 1)',
      'mode([1, 2.7, 3.2, 4, 2.7])',
      'mode(1, 4, 6, 1, 6)'
    ],
    'seealso': [
      'max',
      'mean',
      'min',
      'median',
      'prod',
      'std',
      'sum',
      'var'
    ]
  };

  var prod = {
    'name': 'prod',
    'category': 'Statistics',
    'syntax': [
      'prod(a, b, c, ...)',
      'prod(A)'
    ],
    'description': 'Compute the product of all values.',
    'examples': [
      'prod(2, 3, 4)',
      'prod([2, 3, 4])',
      'prod([2, 5; 4, 3])'
    ],
    'seealso': [
      'max',
      'mean',
      'min',
      'median',
      'min',
      'std',
      'sum',
      'var'
    ]
  };

  var quantileSeq = {
    'name': 'quantileSeq',
    'category': 'Statistics',
    'syntax': [
      'quantileSeq(A, prob[, sorted])',
      'quantileSeq(A, [prob1, prob2, ...][, sorted])',
      'quantileSeq(A, N[, sorted])'
    ],
    'description': 'Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.',
    'examples': [
      'quantileSeq([3, -1, 5, 7], 0.5)',
      'quantileSeq([3, -1, 5, 7], [1/3, 2/3])',
      'quantileSeq([3, -1, 5, 7], 2)',
      'quantileSeq([-1, 3, 5, 7], 0.5, true)'
    ],
    'seealso': [
      'mean',
      'median',
      'min',
      'max',
      'prod',
      'std',
      'sum',
      'var'
    ]
  };

  var std = {
    'name': 'std',
    'category': 'Statistics',
    'syntax': [
      'std(a, b, c, ...)',
      'std(A)',
      'std(A, normalization)'
    ],
    'description': 'Compute the standard deviation of all values, defined as std(A) = sqrt(var(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    'examples': [
      'std(2, 4, 6)',
      'std([2, 4, 6, 8])',
      'std([2, 4, 6, 8], "uncorrected")',
      'std([2, 4, 6, 8], "biased")',
      'std([1, 2, 3; 4, 5, 6])'
    ],
    'seealso': [
      'max',
      'mean',
      'min',
      'median',
      'min',
      'prod',
      'sum',
      'var'
    ]
  };

  var sum = {
    'name': 'sum',
    'category': 'Statistics',
    'syntax': [
      'sum(a, b, c, ...)',
      'sum(A)'
    ],
    'description': 'Compute the sum of all values.',
    'examples': [
      'sum(2, 3, 4, 1)',
      'sum([2, 3, 4, 1])',
      'sum([2, 5; 4, 3])'
    ],
    'seealso': [
      'max',
      'mean',
      'median',
      'min',
      'prod',
      'std',
      'sum',
      'var'
    ]
  };

  var _var = {
    'name': 'var',
    'category': 'Statistics',
    'syntax': [
      'var(a, b, c, ...)',
      'var(A)',
      'var(A, normalization)'
    ],
    'description': 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
    'examples': [
      'var(2, 4, 6)',
      'var([2, 4, 6, 8])',
      'var([2, 4, 6, 8], "uncorrected")',
      'var([2, 4, 6, 8], "biased")',
      'var([1, 2, 3; 4, 5, 6])'
    ],
    'seealso': [
      'max',
      'mean',
      'min',
      'median',
      'min',
      'prod',
      'std',
      'sum'
    ]
  };

  var acos = {
    'name': 'acos',
    'category': 'Trigonometry',
    'syntax': [
      'acos(x)'
    ],
    'description': 'Compute the inverse cosine of a value in radians.',
    'examples': [
      'acos(0.5)',
      'acos(cos(2.3))'
    ],
    'seealso': [
      'cos',
      'atan',
      'asin'
    ]
  };

  var acosh = {
    'name': 'acosh',
    'category': 'Trigonometry',
    'syntax': [
      'acosh(x)'
    ],
    'description': 'Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.',
    'examples': [
      'acosh(1.5)'
    ],
    'seealso': [
      'cosh',
      'asinh',
      'atanh'
    ]
  };

  var acot = {
    'name': 'acot',
    'category': 'Trigonometry',
    'syntax': [
      'acot(x)'
    ],
    'description': 'Calculate the inverse cotangent of a value.',
    'examples': [
      'acot(0.5)',
      'acot(cot(0.5))',
      'acot(2)'
    ],
    'seealso': [
      'cot',
      'atan'
    ]
  };

  var acoth = {
    'name': 'acoth',
    'category': 'Trigonometry',
    'syntax': [
      'acoth(x)'
    ],
    'description': 'Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.',
    'examples': [
      'acoth(2)',
      'acoth(0.5)'
    ],
    'seealso': [
      'acsch',
      'asech'
    ]
  };

  var acsc = {
    'name': 'acsc',
    'category': 'Trigonometry',
    'syntax': [
      'acsc(x)'
    ],
    'description': 'Calculate the inverse cotangent of a value.',
    'examples': [
      'acsc(2)',
      'acsc(csc(0.5))',
      'acsc(0.5)'
    ],
    'seealso': [
      'csc',
      'asin',
      'asec'
    ]
  };

  var acsch = {
    'name': 'acsch',
    'category': 'Trigonometry',
    'syntax': [
      'acsch(x)'
    ],
    'description': 'Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.',
    'examples': [
      'acsch(0.5)'
    ],
    'seealso': [
      'asech',
      'acoth'
    ]
  };

  var asec = {
    'name': 'asec',
    'category': 'Trigonometry',
    'syntax': [
      'asec(x)'
    ],
    'description': 'Calculate the inverse secant of a value.',
    'examples': [
      'asec(0.5)',
      'asec(sec(0.5))',
      'asec(2)'
    ],
    'seealso': [
      'acos',
      'acot',
      'acsc'
    ]
  };

  var asech = {
    'name': 'asech',
    'category': 'Trigonometry',
    'syntax': [
      'asech(x)'
    ],
    'description': 'Calculate the inverse secant of a value.',
    'examples': [
      'asech(0.5)'
    ],
    'seealso': [
      'acsch',
      'acoth'
    ]
  };

  var asin = {
    'name': 'asin',
    'category': 'Trigonometry',
    'syntax': [
      'asin(x)'
    ],
    'description': 'Compute the inverse sine of a value in radians.',
    'examples': [
      'asin(0.5)',
      'asin(sin(0.5))'
    ],
    'seealso': [
      'sin',
      'acos',
      'atan'
    ]
  };

  var asinh = {
    'name': 'asinh',
    'category': 'Trigonometry',
    'syntax': [
      'asinh(x)'
    ],
    'description': 'Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.',
    'examples': [
      'asinh(0.5)'
    ],
    'seealso': [
      'acosh',
      'atanh'
    ]
  };

  var atan = {
    'name': 'atan',
    'category': 'Trigonometry',
    'syntax': [
      'atan(x)'
    ],
    'description': 'Compute the inverse tangent of a value in radians.',
    'examples': [
      'atan(0.5)',
      'atan(tan(0.5))'
    ],
    'seealso': [
      'tan',
      'acos',
      'asin'
    ]
  };

  var atanh = {
    'name': 'atanh',
    'category': 'Trigonometry',
    'syntax': [
      'atanh(x)'
    ],
    'description': 'Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.',
    'examples': [
      'atanh(0.5)'
    ],
    'seealso': [
      'acosh',
      'asinh'
    ]
  };

  var atan2 = {
    'name': 'atan2',
    'category': 'Trigonometry',
    'syntax': [
      'atan2(y, x)'
    ],
    'description':
        'Computes the principal value of the arc tangent of y/x in radians.',
    'examples': [
      'atan2(2, 2) / pi',
      'angle = 60 deg in rad',
      'x = cos(angle)',
      'y = sin(angle)',
      'atan2(y, x)'
    ],
    'seealso': [
      'sin',
      'cos',
      'tan'
    ]
  };

  var cos = {
    'name': 'cos',
    'category': 'Trigonometry',
    'syntax': [
      'cos(x)'
    ],
    'description': 'Compute the cosine of x in radians.',
    'examples': [
      'cos(2)',
      'cos(pi / 4) ^ 2',
      'cos(180 deg)',
      'cos(60 deg)',
      'sin(0.2)^2 + cos(0.2)^2'
    ],
    'seealso': [
      'acos',
      'sin',
      'tan'
    ]
  };

  var cosh = {
    'name': 'cosh',
    'category': 'Trigonometry',
    'syntax': [
      'cosh(x)'
    ],
    'description': 'Compute the hyperbolic cosine of x in radians.',
    'examples': [
      'cosh(0.5)'
    ],
    'seealso': [
      'sinh',
      'tanh',
      'coth'
    ]
  };

  var cot = {
    'name': 'cot',
    'category': 'Trigonometry',
    'syntax': [
      'cot(x)'
    ],
    'description': 'Compute the cotangent of x in radians. Defined as 1/tan(x)',
    'examples': [
      'cot(2)',
      '1 / tan(2)'
    ],
    'seealso': [
      'sec',
      'csc',
      'tan'
    ]
  };

  var coth = {
    'name': 'coth',
    'category': 'Trigonometry',
    'syntax': [
      'coth(x)'
    ],
    'description': 'Compute the hyperbolic cotangent of x in radians.',
    'examples': [
      'coth(2)',
      '1 / tanh(2)'
    ],
    'seealso': [
      'sech',
      'csch',
      'tanh'
    ]
  };

  var csc = {
    'name': 'csc',
    'category': 'Trigonometry',
    'syntax': [
      'csc(x)'
    ],
    'description': 'Compute the cosecant of x in radians. Defined as 1/sin(x)',
    'examples': [
      'csc(2)',
      '1 / sin(2)'
    ],
    'seealso': [
      'sec',
      'cot',
      'sin'
    ]
  };

  var csch = {
    'name': 'csch',
    'category': 'Trigonometry',
    'syntax': [
      'csch(x)'
    ],
    'description': 'Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)',
    'examples': [
      'csch(2)',
      '1 / sinh(2)'
    ],
    'seealso': [
      'sech',
      'coth',
      'sinh'
    ]
  };

  var sec = {
    'name': 'sec',
    'category': 'Trigonometry',
    'syntax': [
      'sec(x)'
    ],
    'description': 'Compute the secant of x in radians. Defined as 1/cos(x)',
    'examples': [
      'sec(2)',
      '1 / cos(2)'
    ],
    'seealso': [
      'cot',
      'csc',
      'cos'
    ]
  };

  var sech = {
    'name': 'sech',
    'category': 'Trigonometry',
    'syntax': [
      'sech(x)'
    ],
    'description': 'Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)',
    'examples': [
      'sech(2)',
      '1 / cosh(2)'
    ],
    'seealso': [
      'coth',
      'csch',
      'cosh'
    ]
  };

  var sin = {
    'name': 'sin',
    'category': 'Trigonometry',
    'syntax': [
      'sin(x)'
    ],
    'description': 'Compute the sine of x in radians.',
    'examples': [
      'sin(2)',
      'sin(pi / 4) ^ 2',
      'sin(90 deg)',
      'sin(30 deg)',
      'sin(0.2)^2 + cos(0.2)^2'
    ],
    'seealso': [
      'asin',
      'cos',
      'tan'
    ]
  };

  var sinh = {
    'name': 'sinh',
    'category': 'Trigonometry',
    'syntax': [
      'sinh(x)'
    ],
    'description': 'Compute the hyperbolic sine of x in radians.',
    'examples': [
      'sinh(0.5)'
    ],
    'seealso': [
      'cosh',
      'tanh'
    ]
  };

  var tan = {
    'name': 'tan',
    'category': 'Trigonometry',
    'syntax': [
      'tan(x)'
    ],
    'description': 'Compute the tangent of x in radians.',
    'examples': [
      'tan(0.5)',
      'sin(0.5) / cos(0.5)',
      'tan(pi / 4)',
      'tan(45 deg)'
    ],
    'seealso': [
      'atan',
      'sin',
      'cos'
    ]
  };

  var tanh = {
    'name': 'tanh',
    'category': 'Trigonometry',
    'syntax': [
      'tanh(x)'
    ],
    'description': 'Compute the hyperbolic tangent of x in radians.',
    'examples': [
      'tanh(0.5)',
      'sinh(0.5) / cosh(0.5)'
    ],
    'seealso': [
      'sinh',
      'cosh'
    ]
  };

  var to = {
    'name': 'to',
    'category': 'Units',
    'syntax': [
      'x to unit',
      'to(x, unit)'
    ],
    'description': 'Change the unit of a value.',
    'examples': [
      '5 inch to cm',
      '3.2kg to g',
      '16 bytes in bits'
    ],
    'seealso': []
  };

  var clone$2 = {
    'name': 'clone',
    'category': 'Utils',
    'syntax': [
      'clone(x)'
    ],
    'description': 'Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices',
    'examples': [
      'clone(3.5)',
      'clone(2 - 4i)',
      'clone(45 deg)',
      'clone([1, 2; 3, 4])',
      'clone("hello world")'
    ],
    'seealso': []
  };

  var format$2 = {
    'name': 'format',
    'category': 'Utils',
    'syntax': [
      'format(value)',
      'format(value, precision)'
    ],
    'description': 'Format a value of any type as string.',
    'examples': [
      'format(2.3)',
      'format(3 - 4i)',
      'format([])',
      'format(pi, 3)'
    ],
    'seealso': ['print']
  };

  var _isNaN = {
    'name': 'isNaN',
    'category': 'Utils',
    'syntax': [
      'isNaN(x)'
    ],
    'description': 'Test whether a value is NaN (not a number)',
    'examples': [
      'isNaN(2)',
      'isNaN(0 / 0)',
      'isNaN(NaN)',
      'isNaN(Infinity)'
    ],
    'seealso': ['isNegative', 'isNumeric', 'isPositive', 'isZero']
  };

  var isInteger$3 = {
    'name': 'isInteger',
    'category': 'Utils',
    'syntax': [
      'isInteger(x)'
    ],
    'description': 'Test whether a value is an integer number.',
    'examples': [
      'isInteger(2)',
      'isInteger(3.5)',
      'isInteger([3, 0.5, -2])'
    ],
    'seealso': ['isNegative', 'isNumeric', 'isPositive', 'isZero']
  };

  var isNegative = {
    'name': 'isNegative',
    'category': 'Utils',
    'syntax': [
      'isNegative(x)'
    ],
    'description': 'Test whether a value is negative: smaller than zero.',
    'examples': [
      'isNegative(2)',
      'isNegative(0)',
      'isNegative(-4)',
      'isNegative([3, 0.5, -2])'
    ],
    'seealso': ['isInteger', 'isNumeric', 'isPositive', 'isZero']
  };

  var isNumeric = {
    'name': 'isNumeric',
    'category': 'Utils',
    'syntax': [
      'isNumeric(x)'
    ],
    'description': 'Test whether a value is a numeric value. ' +
      'Returns true when the input is a number, BigNumber, Fraction, or boolean.',
    'examples': [
      'isNumeric(2)',
      'isNumeric(0)',
      'isNumeric(bignumber(500))',
      'isNumeric(fraction(0.125))',
      'isNumeric("3")',
      'isNumeric(2 + 3i)',
      'isNumeric([2.3, "foo", false])'
    ],
    'seealso': ['isInteger', 'isZero', 'isNegative', 'isPositive', 'isNaN']
  };

  var isPositive = {
    'name': 'isPositive',
    'category': 'Utils',
    'syntax': [
      'isPositive(x)'
    ],
    'description': 'Test whether a value is positive: larger than zero.',
    'examples': [
      'isPositive(2)',
      'isPositive(0)',
      'isPositive(-4)',
      'isPositive([3, 0.5, -2])'
    ],
    'seealso': ['isInteger', 'isNumeric', 'isNegative', 'isZero']
  };

  var isPrime = {
    'name': 'isPrime',
    'category': 'Utils',
    'syntax': [
      'isPrime(x)'
    ],
    'description': 'Test whether a value is prime: has no divisors other than itself and one.',
    'examples': [
      'isPrime(3)',
      'isPrime(-2)',
      'isPrime([2, 17, 100])'
    ],
    'seealso': ['isInteger', 'isNumeric', 'isNegative', 'isZero']
  };

  var isZero = {
    'name': 'isZero',
    'category': 'Utils',
    'syntax': [
      'isZero(x)'
    ],
    'description': 'Test whether a value is zero.',
    'examples': [
      'isZero(2)',
      'isZero(0)',
      'isZero(-4)',
      'isZero([3, 0, -2, 0])'
    ],
    'seealso': ['isInteger', 'isNumeric', 'isNegative', 'isPositive']
  };

  var _typeof = {
    'name': 'typeof',
    'category': 'Utils',
    'syntax': [
      'typeof(x)'
    ],
    'description': 'Get the type of a variable.',
    'examples': [
      'typeof(3.5)',
      'typeof(2 - 4i)',
      'typeof(45 deg)',
      'typeof("hello world")'
    ],
    'seealso': []
  };

  function factory$39 (construction$$1, config, load, typed) {
    var docs = {};


    // construction functions
    docs.bignumber = bignumber$2;
    docs['boolean'] = boolean_1$2;
    docs.complex = complex$4;
    docs.createUnit = createUnit;
    docs.fraction = fraction$4;
    docs.index = construction;
    docs.matrix = matrix$2;
    docs.number = number$4;
    docs.sparse = sparse$1;
    docs.splitUnit = splitUnit;
    docs.string = string$7;
    docs.unit = unit;

    // constants
    docs.e = e;
    docs.E = e;
    docs['false'] = _false;
    docs.i = i;
    docs['Infinity'] = _Infinity;
    docs.LN2 = LN2;
    docs.LN10 = LN10;
    docs.LOG2E = LOG2E;
    docs.LOG10E = LOG10E;
    docs.NaN = _NaN;
    docs['null'] = _null;
    docs.pi = pi;
    docs.PI = pi;
    docs.phi = phi;
    docs.SQRT1_2 = SQRT1_2;
    docs.SQRT2 = SQRT2;
    docs.tau = tau;
    docs['true'] = _true;
    docs.version = version;

    // physical constants
    // TODO: more detailed docs for physical constants
    docs.speedOfLight = {description: 'Speed of light in vacuum', examples: ['speedOfLight']};
    docs.gravitationConstant = {description: 'Newtonian constant of gravitation', examples: ['gravitationConstant']};
    docs.planckConstant = {description: 'Planck constant', examples: ['planckConstant']};
    docs.reducedPlanckConstant = {description: 'Reduced Planck constant', examples: ['reducedPlanckConstant']};

    docs.magneticConstant = {description: 'Magnetic constant (vacuum permeability)', examples: ['magneticConstant']};
    docs.electricConstant = {description: 'Electric constant (vacuum permeability)', examples: ['electricConstant']};
    docs.vacuumImpedance = {description: 'Characteristic impedance of vacuum', examples: ['vacuumImpedance']};
    docs.coulomb = {description: 'Coulomb\'s constant', examples: ['coulomb']};
    docs.elementaryCharge = {description: 'Elementary charge', examples: ['elementaryCharge']};
    docs.bohrMagneton = {description: 'Borh magneton', examples: ['bohrMagneton']};
    docs.conductanceQuantum = {description: 'Conductance quantum', examples: ['conductanceQuantum']};
    docs.inverseConductanceQuantum = {description: 'Inverse conductance quantum', examples: ['inverseConductanceQuantum']};
    //docs.josephson = {description: 'Josephson constant', examples: ['josephson']};
    docs.magneticFluxQuantum = {description: 'Magnetic flux quantum', examples: ['magneticFluxQuantum']};
    docs.nuclearMagneton = {description: 'Nuclear magneton', examples: ['nuclearMagneton']};
    docs.klitzing = {description: 'Von Klitzing constant', examples: ['klitzing']};

    docs.bohrRadius = {description: 'Borh radius', examples: ['bohrRadius']};
    docs.classicalElectronRadius = {description: 'Classical electron radius', examples: ['classicalElectronRadius']};
    docs.electronMass = {description: 'Electron mass', examples: ['electronMass']};
    docs.fermiCoupling = {description: 'Fermi coupling constant', examples: ['fermiCoupling']};
    docs.fineStructure = {description: 'Fine-structure constant', examples: ['fineStructure']};
    docs.hartreeEnergy = {description: 'Hartree energy', examples: ['hartreeEnergy']};
    docs.protonMass = {description: 'Proton mass', examples: ['protonMass']};
    docs.deuteronMass = {description: 'Deuteron Mass', examples: ['deuteronMass']};
    docs.neutronMass = {description: 'Neutron mass', examples: ['neutronMass']};
    docs.quantumOfCirculation = {description: 'Quantum of circulation', examples: ['quantumOfCirculation']};
    docs.rydberg = {description: 'Rydberg constant', examples: ['rydberg']};
    docs.thomsonCrossSection = {description: 'Thomson cross section', examples: ['thomsonCrossSection']};
    docs.weakMixingAngle = {description: 'Weak mixing angle', examples: ['weakMixingAngle']};
    docs.efimovFactor = {description: 'Efimov factor', examples: ['efimovFactor']};

    docs.atomicMass = {description: 'Atomic mass constant', examples: ['atomicMass']};
    docs.avogadro = {description: 'Avogadro\'s number', examples: ['avogadro']};
    docs.boltzmann = {description: 'Boltzmann constant', examples: ['boltzmann']};
    docs.faraday = {description: 'Faraday constant', examples: ['faraday']};
    docs.firstRadiation = {description: 'First radiation constant', examples: ['firstRadiation']};
    docs.loschmidt = {description: 'Loschmidt constant at T=273.15 K and p=101.325 kPa', examples: ['loschmidt']};
    docs.gasConstant = {description: 'Gas constant', examples: ['gasConstant']};
    docs.molarPlanckConstant = {description: 'Molar Planck constant', examples: ['molarPlanckConstant']};
    docs.molarVolume = {description: 'Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa', examples: ['molarVolume']};
    docs.sackurTetrode = {description: 'Sackur-Tetrode constant at T=1 K and p=101.325 kPa', examples: ['sackurTetrode']};
    docs.secondRadiation = {description: 'Second radiation constant', examples: ['secondRadiation']};
    docs.stefanBoltzmann = {description: 'Stefan-Boltzmann constant', examples: ['stefanBoltzmann']};
    docs.wienDisplacement = {description: 'Wien displacement law constant', examples: ['wienDisplacement']};
    //docs.spectralRadiance = {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']};

    docs.molarMass = {description: 'Molar mass constant', examples: ['molarMass']};
    docs.molarMassC12 = {description: 'Molar mass constant of carbon-12', examples: ['molarMassC12']};
    docs.gravity = {description: 'Standard acceleration of gravity (standard acceleration of free-fall on Earth)', examples: ['gravity']};

    docs.planckLength = {description: 'Planck length', examples: ['planckLength']};
    docs.planckMass = {description: 'Planck mass', examples: ['planckMass']};
    docs.planckTime = {description: 'Planck time', examples: ['planckTime']};
    docs.planckCharge = {description: 'Planck charge', examples: ['planckCharge']};
    docs.planckTemperature = {description: 'Planck temperature', examples: ['planckTemperature']};

    // functions - algebra
    docs.derivative = derivative;
    docs.lsolve = lsolve;
    docs.lup = lup;
    docs.lusolve = lusolve;
    docs.simplify = simplify;
    docs.rationalize = rationalize;
    docs.slu = slu;
    docs.usolve = usolve;
    docs.qr = qr;

    // functions - arithmetic
    docs.abs = abs;
    docs.add = add$1;
    docs.cbrt = cbrt;
    docs.ceil = ceil;
    docs.cube = cube;
    docs.divide = divide;
    docs.dotDivide = dotDivide;
    docs.dotMultiply = dotMultiply;
    docs.dotPow = dotPow;
    docs.exp = exp;
    docs.expm = expm;
    docs.expm1 = expm1;
    docs.fix = fix;
    docs.floor = floor;
    docs.gcd = gcd;
    docs.hypot = hypot;
    docs.lcm = lcm;
    docs.log = log;
    docs.log2 = log2;
    docs.log1p = log1p;
    docs.log10 = log10;
    docs.mod = mod;
    docs.multiply = multiply;
    docs.norm = norm;
    docs.nthRoot = nthRoot;
    docs.pow = pow;
    docs.round = round;
    docs.sign = sign;
    docs.sqrt = sqrt;
    docs.sqrtm = sqrtm;
    docs.square = square;
    docs.subtract = subtract;
    docs.unaryMinus = unaryMinus;
    docs.unaryPlus = unaryPlus;
    docs.xgcd = xgcd;

    // functions - bitwise
    docs.bitAnd = bitAnd;
    docs.bitNot = bitNot;
    docs.bitOr = bitOr;
    docs.bitXor = bitXor;
    docs.leftShift = leftShift;
    docs.rightArithShift = rightArithShift;
    docs.rightLogShift = rightLogShift;

    // functions - combinatorics
    docs.bellNumbers = bellNumbers;
    docs.catalan = catalan;
    docs.composition = composition;
    docs.stirlingS2 = stirlingS2;

    // functions - core
    docs['config'] =  config$1;
    docs['import'] =  _import$1;
    docs['typed'] =  typed$1;

    // functions - complex
    docs.arg = arg;
    docs.conj = conj;
    docs.re = re;
    docs.im = im;

    // functions - expression
    docs['eval'] =  _eval;
    docs.help =  help;

    // functions - geometry
    docs.distance = distance;
    docs.intersect = intersect;

    // functions - logical
    docs['and'] = and;
    docs['not'] = not;
    docs['or'] = or;
    docs['xor'] = xor;

    // functions - matrix
    docs['concat'] = concat;
    docs.cross = cross;
    docs.det = det;
    docs.diag = diag;
    docs.dot = dot;
    docs.eye = eye;
    docs.filter =  filter;
    docs.flatten = flatten$1;
    docs.forEach =  forEach;
    docs.inv = inv;
    docs.kron = kron;
    docs.map =  map;
    docs.ones = ones;
    docs.partitionSelect =  partitionSelect;
    docs.range = range;
    docs.resize = resize;
    docs.reshape = reshape;
    docs.size = size;
    docs.sort =  sort;
    docs.squeeze = squeeze;
    docs.subset = subset;
    docs.trace = trace;
    docs.transpose = transpose;
    docs.zeros = zeros;

    // functions - probability
    docs.combinations = combinations;
    //docs.distribution = require('./function/probability/distribution');
    docs.factorial = factorial;
    docs.gamma = gamma;
    docs.kldivergence = kldivergence;
    docs.multinomial = multinomial;
    docs.permutations = permutations;
    docs.pickRandom = pickRandom;
    docs.random = random;
    docs.randomInt = randomInt;

    // functions - relational
    docs.compare = compare;
    docs.compareNatural = compareNatural;
    docs.compareText = compareText;
    docs.deepEqual = deepEqual;
    docs['equal'] = equal;
    docs.equalText = equalText;
    docs.larger = larger$1;
    docs.largerEq = largerEq;
    docs.smaller = smaller$1;
    docs.smallerEq = smallerEq;
    docs.unequal = unequal;

    // functions - set
    docs.setCartesian = setCartesian;
    docs.setDifference = setDifference;
    docs.setDistinct = setDistinct;
    docs.setIntersect = setIntersect;
    docs.setIsSubset = setIsSubset;
    docs.setMultiplicity = setMultiplicity;
    docs.setPowerset = setPowerset;
    docs.setSize = setSize;
    docs.setSymDifference = setSymDifference;
    docs.setUnion = setUnion;

    // functions - special
    docs.erf = erf;

    // functions - statistics
    docs.mad = mad;
    docs.max = max;
    docs.mean = mean;
    docs.median = median;
    docs.min = min;
    docs.mode = mode;
    docs.prod = prod;
    docs.quantileSeq = quantileSeq;
    docs.std = std;
    docs.sum = sum;
    docs['var'] = _var;

    // functions - trigonometry
    docs.acos = acos;
    docs.acosh = acosh;
    docs.acot = acot;
    docs.acoth = acoth;
    docs.acsc = acsc;
    docs.acsch = acsch;
    docs.asec = asec;
    docs.asech = asech;
    docs.asin = asin;
    docs.asinh = asinh;
    docs.atan = atan;
    docs.atanh = atanh;
    docs.atan2 = atan2;
    docs.cos = cos;
    docs.cosh = cosh;
    docs.cot = cot;
    docs.coth = coth;
    docs.csc = csc;
    docs.csch = csch;
    docs.sec = sec;
    docs.sech = sech;
    docs.sin = sin;
    docs.sinh = sinh;
    docs.tan = tan;
    docs.tanh = tanh;

    // functions - units
    docs.to = to;

    // functions - utils
    docs.clone = clone$2;
    docs.format = format$2;
    docs.isNaN = _isNaN;
    docs.isInteger = isInteger$3;
    docs.isNegative = isNegative;
    docs.isNumeric = isNumeric;
    docs.isPositive = isPositive;
    docs.isPrime = isPrime;
    docs.isZero = isZero;
    // docs.print = require('./function/utils/print'); // TODO: add documentation for print as soon as the parser supports objects.
    docs['typeof'] =  _typeof;

    return docs;
  }

  var name$36 = 'docs';
  var path$13 = 'expression';
  var factory_1$38 = factory$39;

  var embeddedDocs = {
  	name: name$36,
  	path: path$13,
  	factory: factory_1$38
  };

  function factory$40(type, config, load, typed) {

    // TODO: expose this function to mathjs, add documentation

    /**
     * Create a numeric value with a specific type: number, BigNumber, or Fraction
     *
     * @param {string | number} value
     * @param {'number' | 'BigNumber' | 'Fraction'}
     * @return {number | BigNumber | Fraction} Returns an instance of the
     *                                         numeric requested type
     */
    return function numeric (value, valueType) {
      if (valueType === 'BigNumber') {
        return new type.BigNumber(value);
      }
      else if (valueType === 'Fraction') {
        return new type.Fraction(value);
      }
      else {
        // valueType === 'number' or undefined // TODO: check this
        if (typeof value === 'number') {
          return value;
        }
        else {
          if (value === 'Infinity') {
            return Infinity;
          }

          if (value === 'NaN') {
            return NaN;
          }

          // The following regexp is relatively permissive
          if (!/^[\-+]?((\d+\.?\d*)|(\d*\.?\d+))([eE][+\-]?\d+)?$/.test(value)) {
            throw new Error('Invalid numeric value "' + value + '"');
          }

          // remove leading zeros like '003.2' which are not allowed by JavaScript
          return parseFloat(value.replace(/^(0*)[0-9]/, function (match, zeros) {
            return match.substring(zeros.length);
          }));
        }
      }
    }
  }

  var factory_1$39 = factory$40;

  var numeric = {
  	factory: factory_1$39
  };

  var hasOwnProperty = object.hasOwnProperty;

  /**
   * Get a property of a plain object
   * Throws an error in case the object is not a plain object or the
   * property is not defined on the object itself
   * @param {Object} object
   * @param {string} prop
   * @return {*} Returns the property value when safe
   */
  function getSafeProperty (object$$1, prop) {
    // only allow getting safe properties of a plain object
    if (isPlainObject(object$$1) && isSafeProperty(object$$1, prop)) {
      return object$$1[prop];
    }

    if (typeof object$$1[prop] === 'function' && isSafeMethod(object$$1, prop)) {
      throw new Error('Cannot access method "' + prop + '" as a property');
    }

    throw new Error('No access to property "' + prop + '"');
  }

  /**
   * Set a property on a plain object.
   * Throws an error in case the object is not a plain object or the
   * property would override an inherited property like .constructor or .toString
   * @param {Object} object
   * @param {string} prop
   * @param {*} value
   * @return {*} Returns the value
   */
  // TODO: merge this function into access.js?
  function setSafeProperty (object$$1, prop, value) {
    // only allow setting safe properties of a plain object
    if (isPlainObject(object$$1) && isSafeProperty(object$$1, prop)) {
      return object$$1[prop] = value;
    }

    throw new Error('No access to property "' + prop + '"');
  }

  /**
   * Test whether a property is safe to use for an object.
   * For example .toString and .constructor are not safe
   * @param {string} prop
   * @return {boolean} Returns true when safe
   */
  function isSafeProperty (object$$1, prop) {
    if (!object$$1 || typeof object$$1 !== 'object') {
      return false;
    }
    // SAFE: whitelisted
    // e.g length
    if (hasOwnProperty(safeNativeProperties, prop)) {
      return true;
    }
    // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (prop in Object.prototype) {
      // 'in' is used instead of hasOwnProperty for nodejs v0.10
      // which is inconsistent on root prototypes. It is safe
      // here because Object.prototype is a root object
      return false;
    }
    // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (prop in Function.prototype) {
      // 'in' is used instead of hasOwnProperty for nodejs v0.10
      // which is inconsistent on root prototypes. It is safe
      // here because Function.prototype is a root object
      return false;
    }
    return true;
  }

  /**
   * Validate whether a method is safe.
   * Throws an error when that's not the case.
   * @param {Object} object
   * @param {string} method
   */
  // TODO: merge this function into assign.js?
  function validateSafeMethod (object$$1, method) {
    if (!isSafeMethod(object$$1, method)) {
      throw new Error('No access to method "' + method + '"');
    }
  }

  /**
   * Check whether a method is safe.
   * Throws an error when that's not the case (for example for `constructor`).
   * @param {Object} object
   * @param {string} method
   * @return {boolean} Returns true when safe, false otherwise
   */
  function isSafeMethod (object$$1, method) {
    if (!object$$1 || typeof object$$1[method] !== 'function') {
      return false;
    }
    // UNSAFE: ghosted
    // e.g overridden toString
    // Note that IE10 doesn't support __proto__ and we can't do this check there.
    if (hasOwnProperty(object$$1, method) &&
        (object$$1.__proto__ && (method in object$$1.__proto__))) {
      return false;
    }
    // SAFE: whitelisted
    // e.g toString
    if (hasOwnProperty(safeNativeMethods, method)) {
      return true;
    }
    // UNSAFE: inherited from Object prototype
    // e.g constructor
    if (method in Object.prototype) {
      // 'in' is used instead of hasOwnProperty for nodejs v0.10
      // which is inconsistent on root prototypes. It is safe
      // here because Object.prototype is a root object
      return false;
    }
    // UNSAFE: inherited from Function prototype
    // e.g call, apply
    if (method in Function.prototype) {
      // 'in' is used instead of hasOwnProperty for nodejs v0.10
      // which is inconsistent on root prototypes. It is safe
      // here because Function.prototype is a root object
      return false;
    }
    return true;
  }

  function isPlainObject (object$$1) {
    return typeof object$$1 === 'object' && object$$1 && object$$1.constructor === Object;
  }

  var safeNativeProperties = {
    length: true,
    name: true
  };

  var safeNativeMethods = {
    toString: true,
    valueOf: true,
    toLocaleString: true
  };

  var getSafeProperty_1 = getSafeProperty;
  var setSafeProperty_1 = setSafeProperty;
  var isSafeProperty_1 = isSafeProperty;
  var validateSafeMethod_1 = validateSafeMethod;
  var isSafeMethod_1 = isSafeMethod;
  var isPlainObject_1 = isPlainObject;

  var customs = {
  	getSafeProperty: getSafeProperty_1,
  	setSafeProperty: setSafeProperty_1,
  	isSafeProperty: isSafeProperty_1,
  	validateSafeMethod: validateSafeMethod_1,
  	isSafeMethod: isSafeMethod_1,
  	isPlainObject: isPlainObject_1
  };

  // Reserved keywords not allowed to use in the parser
  var keywords = {
    end: true
  };

  var deepEqual$1= object.deepEqual;
  var hasOwnProperty$1 = object.hasOwnProperty;

  function factory$41 (type, config, load, typed, math) {

    /**
     * Node
     */
    function Node() {
      if (!(this instanceof Node)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }
    }

    /**
     * Evaluate the node
     * @param {Object} [scope]  Scope to read/write variables
     * @return {*}              Returns the result
     */
    Node.prototype.eval = function(scope) {
      return this.compile().eval(scope);
    };

    Node.prototype.type = 'Node';

    Node.prototype.isNode = true;

    Node.prototype.comment = '';

    /**
     * Compile the node into an optimized, evauatable JavaScript function 
     * @return {{eval: function([Object])}} expr  Returns an object with a function 'eval',
     *                                  which can be invoked as expr.eval([scope: Object]),
     *                                  where scope is an optional object with
     *                                  variables.
     */
    Node.prototype.compile = function () {
      var expr = this._compile(math.expression.mathWithTransform, {});
      var args = {};
      var context = null;
      return {
        eval: function evalNode(scope) {
          var s = scope ? scope : {};
          _validateScope(s);
          return expr(s, args, context);
        }
      }
    };
    
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    Node.prototype._compile = function (math, argNames) {
      throw new Error('Method _compile should be implemented by type ' + this.type);
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    Node.prototype.forEach = function (callback) {
      // must be implemented by each of the Node implementations
      throw new Error('Cannot run forEach on a Node interface');
    };

    /**
     * Create a new Node having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    Node.prototype.map = function (callback) {
      // must be implemented by each of the Node implementations
      throw new Error('Cannot run map on a Node interface');
    };

    /**
     * Validate whether an object is a Node, for use with map
     * @param {Node} node
     * @returns {Node} Returns the input if it's a node, else throws an Error
     * @protected
     */
    Node.prototype._ifNode = function (node) {
      if (!type.isNode(node)) {
        throw new TypeError('Callback function must return a Node');
      }

      return node;
    };

    /**
     * Recursively traverse all nodes in a node tree. Executes given callback for
     * this node and each of its child nodes.
     * @param {function(node: Node, path: string, parent: Node)} callback
     *          A callback called for every node in the node tree.
     */
    Node.prototype.traverse = function (callback) {
      // execute callback for itself
      callback(this, null, null);

      // recursively traverse over all childs of a node
      function _traverse(node, callback) {
        node.forEach(function (child, path, parent) {
          callback(child, path, parent);
          _traverse(child, callback);
        });
      }

      _traverse(this, callback);
    };

    /**
     * Recursively transform a node tree via a transform function.
     *
     * For example, to replace all nodes of type SymbolNode having name 'x' with a
     * ConstantNode with value 2:
     *
     *     var res = Node.transform(function (node, path, parent) {
     *       if (node && node.isSymbolNode) && (node.name == 'x')) {
     *         return new ConstantNode(2);
     *       }
     *       else {
     *         return node;
     *       }
     *     });
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *          A mapping function accepting a node, and returning
     *          a replacement for the node or the original node.
     *          Signature: callback(node: Node, index: string, parent: Node) : Node
     * @return {Node} Returns the original node or its replacement
     */
    Node.prototype.transform = function (callback) {
      // traverse over all childs
      function _transform (node, callback) {
        return node.map(function(child, path, parent) {
          var replacement = callback(child, path, parent);
          return _transform(replacement, callback);
        });
      }

      var replacement = callback(this, null, null);
      return _transform(replacement, callback);
    };

    /**
     * Find any node in the node tree matching given filter function. For example, to
     * find all nodes of type SymbolNode having name 'x':
     *
     *     var results = Node.filter(function (node) {
     *       return (node && node.isSymbolNode) && (node.name == 'x');
     *     });
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *            A test function returning true when a node matches, and false
     *            otherwise. Function signature:
     *            callback(node: Node, index: string, parent: Node) : boolean
     * @return {Node[]} nodes       An array with nodes matching given filter criteria
     */
    Node.prototype.filter = function (callback) {
      var nodes = [];

      this.traverse(function (node, path, parent) {
        if (callback(node, path, parent)) {
          nodes.push(node);
        }
      });

      return nodes;
    };

    // TODO: deprecated since version 1.1.0, remove this some day
    Node.prototype.find = function () {
      throw new Error('Function Node.find is deprecated. Use Node.filter instead.');
    };

    // TODO: deprecated since version 1.1.0, remove this some day
    Node.prototype.match = function () {
      throw new Error('Function Node.match is deprecated. See functions Node.filter, Node.transform, Node.traverse.');
    };

    /**
     * Create a shallow clone of this node
     * @return {Node}
     */
    Node.prototype.clone = function () {
      // must be implemented by each of the Node implementations
      throw new Error('Cannot clone a Node interface');
    };

    /**
     * Create a deep clone of this node
     * @return {Node}
     */
    Node.prototype.cloneDeep = function () {
      return this.map(function (node) {
        return node.cloneDeep();
      });
    };

    /**
     * Deep compare this node with another node.
     * @param {Node} other
     * @return {boolean} Returns true when both nodes are of the same type and
     *                   contain the same values (as do their childs)
     */
    Node.prototype.equals = function (other) {
      return other
          ? deepEqual$1(this, other)
          : false
    };

    /**
     * Get string representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    Node.prototype.toString = function (options) {
      var customString;
      if (options && typeof options === 'object') {
          switch (typeof options.handler) {
            case 'object':
            case 'undefined':
              break;
            case 'function':
              customString = options.handler(this, options);
              break;
            default:
              throw new TypeError('Object or function expected as callback');
          }
      }

      if (typeof customString !== 'undefined') {
        return customString;
      }

      return this._toString(options);
    };

    /**
     * Get a JSON representation of the node
     * Both .toJSON() and the static .fromJSON(json) should be implemented by all
     * implementations of Node
     * @returns {Object}
     */
    Node.prototype.toJSON = function () {
      throw new Error('Cannot serialize object: toJSON not implemented by ' + this.type);
    };

    /**
     * Get HTML representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)" or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    Node.prototype.toHTML = function (options) {
      var customString;
      if (options && typeof options === 'object') {
          switch (typeof options.handler) {
            case 'object':
            case 'undefined':
              break;
            case 'function':
              customString = options.handler(this, options);
              break;
            default:
              throw new TypeError('Object or function expected as callback');
          }
      }

      if (typeof customString !== 'undefined') {
        return customString;
      }

      return this.toHTML(options);
    };

    /**
     * Internal function to generate the string output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    Node.prototype._toString = function () {
      //must be implemented by each of the Node implementations
      throw new Error('_toString not implemented for ' + this.type);
    };

    /**
     * Get LaTeX representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    Node.prototype.toTex = function (options) {
      var customTex;
      if (options && typeof options == 'object') {
        switch (typeof options.handler) {
          case 'object':
          case 'undefined':
            break;
          case 'function':
            customTex = options.handler(this, options);
            break;
          default:
            throw new TypeError('Object or function expected as callback');
        }
      }

      if (typeof customTex !== 'undefined') {
        return customTex;
      }

      return this._toTex(options);
    };

    /**
     * Internal function to generate the LaTeX output.
     * This has to be implemented by every Node
     *
     * @param {Object} [options]
     * @throws {Error}
     */
    Node.prototype._toTex = function (options) {
      //must be implemented by each of the Node implementations
      throw new Error('_toTex not implemented for ' + this.type);
    };

    /**
     * Get identifier.
     * @return {string}
     */
    Node.prototype.getIdentifier = function () {
      return this.type;
    };

    /**
     * Get the content of the current Node.
     * @return {Node} node
     **/
    Node.prototype.getContent = function () {
      return this;
    };

    /**
     * Validate the symbol names of a scope.
     * Throws an error when the scope contains an illegal symbol.
     * @param {Object} scope
     */
    function _validateScope(scope) {
      for (var symbol in scope) {
        if (hasOwnProperty$1(scope, symbol)) {
          if (symbol in keywords) {
            throw new Error('Scope contains an illegal symbol, "' + symbol + '" is a reserved keyword');
          }
        }
      }
    }

    return Node;
  }

  var name$37 = 'Node';
  var path$14 = 'expression.node';
  var math$6 = true; // request access to the math namespace as 5th argument of the factory function
  var factory_1$40 = factory$41;

  var Node = {
  	name: name$37,
  	path: path$14,
  	math: math$6,
  	factory: factory_1$40
  };

  var map$1 = array.map;
  var escape = string.escape;

  function factory$42 (type, config, load, typed) {
    var Node$$1 = load(Node);
    var Range$$1 = load(Range);

    var isArray = Array.isArray;

    /**
     * @constructor IndexNode
     * @extends Node
     *
     * Describes a subset of a matrix or an object property.
     * Cannot be used on its own, needs to be used within an AccessorNode or
     * AssignmentNode.
     *
     * @param {Node[]} dimensions
     * @param {boolean} [dotNotation=false]  Optional property describing whether
     *                                       this index was written using dot
     *                                       notation like `a.b`, or using bracket
     *                                       notation like `a["b"]` (default).
     *                                       Used to stringify an IndexNode.
     */
    function IndexNode(dimensions, dotNotation) {
      if (!(this instanceof IndexNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      this.dimensions = dimensions;
      this.dotNotation = dotNotation || false;

      // validate input
      if (!isArray(dimensions) || !dimensions.every(type.isNode)) {
        throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
      }
      if (this.dotNotation && !this.isObjectProperty()) {
        throw new Error('dotNotation only applicable for object properties');
      }

      // TODO: deprecated since v3, remove some day
      var deprecated = function () {
        throw new Error('Property `IndexNode.object` is deprecated, use `IndexNode.fn` instead');
      };
      Object.defineProperty(this, 'object', { get: deprecated, set: deprecated });
    }

    IndexNode.prototype = new Node$$1();

    IndexNode.prototype.type = 'IndexNode';

    IndexNode.prototype.isIndexNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    IndexNode.prototype._compile = function (math, argNames) {
      // TODO: implement support for bignumber (currently bignumbers are silently
      //       reduced to numbers when changing the value to zero-based)

      // TODO: Optimization: when the range values are ConstantNodes,
      //       we can beforehand resolve the zero-based value

      // optimization for a simple object property
      var evalDimensions = map$1(this.dimensions, function (range, i) {
        if (type.isRangeNode(range)) {
          if (range.needsEnd()) {
            // create a range containing end (like '4:end')
            var childArgNames = Object.create(argNames);
            childArgNames['end'] = true;

            var evalStart = range.start._compile(math, childArgNames);
            var evalEnd = range.end._compile(math, childArgNames);
            var evalStep = range.step 
                ? range.step._compile(math, childArgNames) 
                : function () { return 1 };

            return function evalDimension(scope, args, context) {
              var size = math.size(context).valueOf();
              var childArgs = Object.create(args);
              childArgs['end'] = size[i];

              return createRange(
                evalStart(scope, childArgs, context),
                evalEnd(scope, childArgs, context),
                evalStep(scope, childArgs, context)
              );
            };
          }
          else {
            // create range
            var evalStart = range.start._compile(math, argNames);
            var evalEnd = range.end._compile(math, argNames);
            var evalStep = range.step 
                ? range.step._compile(math, argNames) 
                : function () { return 1 };

            return function evalDimension(scope, args, context) {
              return createRange(
                evalStart(scope, args, context),
                evalEnd(scope, args, context),
                evalStep(scope, args, context)
              );
            };
          }
        }
        else if (type.isSymbolNode(range) && range.name === 'end') {
          // SymbolNode 'end'
          var childArgNames = Object.create(argNames);
          childArgNames['end'] = true;

          var evalRange = range._compile(math, childArgNames);
          
          return function evalDimension(scope, args, context) {
            var size = math.size(context).valueOf();
            var childArgs = Object.create(args);
            childArgs['end'] = size[i];

            return evalRange(scope, childArgs, context);
          };
        }
        else {
          // ConstantNode
          var evalRange = range._compile(math, argNames);
          return function evalDimension(scope, args, context) {
            return evalRange(scope, args, context);
          };
        }
      });

      return function evalIndexNode (scope, args, context) {
        var dimensions = map$1(evalDimensions, function (evalDimension) {
          return evalDimension(scope, args, context);
        });
        return math.index.apply(math, dimensions);
      };
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    IndexNode.prototype.forEach = function (callback) {
      for (var i = 0; i < this.dimensions.length; i++) {
        callback(this.dimensions[i], 'dimensions[' + i + ']', this);
      }
    };

    /**
     * Create a new IndexNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {IndexNode} Returns a transformed copy of the node
     */
    IndexNode.prototype.map = function (callback) {
      var dimensions = [];
      for (var i = 0; i < this.dimensions.length; i++) {
        dimensions[i] = this._ifNode(callback(this.dimensions[i], 'dimensions[' + i + ']', this));
      }

      return new IndexNode(dimensions);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {IndexNode}
     */
    IndexNode.prototype.clone = function () {
      return new IndexNode(this.dimensions.slice(0));
    };

    /**
     * Test whether this IndexNode contains a single property name
     * @return {boolean}
     */
    IndexNode.prototype.isObjectProperty = function () {
      return this.dimensions.length === 1 &&
          type.isConstantNode(this.dimensions[0]) &&
          typeof this.dimensions[0].value === 'string';
    };

    /**
     * Returns the property name if IndexNode contains a property.
     * If not, returns null.
     * @return {string | null}
     */
    IndexNode.prototype.getObjectProperty = function () {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    IndexNode.prototype._toString = function (options) {
      // format the parameters like "[1, 0:5]"
      return this.dotNotation
          ? ('.' + this.getObjectProperty())
          : ('[' + this.dimensions.join(', ') + ']');
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    IndexNode.prototype.toJSON = function () {
      return {
        mathjs: 'IndexNode',
        dimensions: this.dimensions,
        dotNotation: this.dotNotation
      };
    };

    /**
     * Instantiate an IndexNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
     *                       where mathjs is optional
     * @returns {IndexNode}
     */
    IndexNode.fromJSON = function (json) {
      return new IndexNode(json.dimensions, json.dotNotation);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    IndexNode.prototype.toHTML = function (options) {
      // format the parameters like "[1, 0:5]"
  	var dimensions = [];
  	for (var i=0; i<this.dimensions.length; i++)	{
  	  dimensions[i] = this.dimensions[i].toHTML();
  	}
  	if (this.dotNotation) {
  	  return '<span class="math-operator math-accessor-operator">.</span>' + '<span class="math-symbol math-property">' + escape(this.getObjectProperty()) + '</span>';}
  	else {
  	  return '<span class="math-parenthesis math-square-parenthesis">[</span>' + dimensions.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>'}
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    IndexNode.prototype._toTex = function (options) {
      var dimensions = this.dimensions.map(function (range) {
        return range.toTex(options);
      });

      return this.dotNotation
          ? ('.' + this.getObjectProperty() + '')
          : ('_{' + dimensions.join(',') + '}');
    };

    // helper function to create a Range from start, step and end
    function createRange(start, end, step) {
      return new Range$$1(
          type.isBigNumber(start) ? start.toNumber() : start,
          type.isBigNumber(end)   ? end.toNumber()   : end,
          type.isBigNumber(step)  ? step.toNumber()  : step
      );
    }
    return IndexNode;
  }

  var name$38 = 'IndexNode';
  var path$15 = 'expression.node';
  var factory_1$41 = factory$42;

  var IndexNode = {
  	name: name$38,
  	path: path$15,
  	factory: factory_1$41
  };

  /**
   * Transform zero-based indices to one-based indices in errors
   * @param {Error} err
   * @returns {Error} Returns the transformed error
   */
  var transform = function (err) {
    if (err && err.isIndexError) {
      return new IndexError_1(
          err.index + 1,
          err.min + 1,
          err.max !== undefined ? err.max + 1 : undefined);
    }

    return err;
  };

  var error_transform = {
  	transform: transform
  };

  var clone$3 = object.clone;
  var validateIndex$2 = array.validateIndex;
  var getSafeProperty$1 = customs.getSafeProperty;
  var setSafeProperty$1 = customs.setSafeProperty;


  function factory$43 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Get or set a subset of a matrix or string.
     *
     * Syntax:
     *     math.subset(value, index)                                // retrieve a subset
     *     math.subset(value, index, replacement [, defaultValue])  // replace a subset
     *
     * Examples:
     *
     *     // get a subset
     *     var d = [[1, 2], [3, 4]];
     *     math.subset(d, math.index(1, 0));        // returns 3
     *     math.subset(d, math.index([0, 2], 1));   // returns [[2], [4]]
     *
     *     // replace a subset
     *     var e = [];
     *     var f = math.subset(e, math.index(0, [0, 2]), [5, 6]);  // f = [[5, 6]]
     *     var g = math.subset(f, math.index(1, 1), 7, 0);         // g = [[5, 6], [0, 7]]
     *
     * See also:
     *
     *     size, resize, squeeze, index
     *
     * @param {Array | Matrix | string} matrix  An array, matrix, or string
     * @param {Index} index                     An index containing ranges for each
     *                                          dimension
     * @param {*} [replacement]                 An array, matrix, or scalar.
     *                                          If provided, the subset is replaced with replacement.
     *                                          If not provided, the subset is returned
     * @param {*} [defaultValue=undefined]      Default value, filled in on new entries when
     *                                          the matrix is resized. If not provided,
     *                                          math.matrix elements will be left undefined.
     * @return {Array | Matrix | string} Either the retrieved subset or the updated matrix.
     */
    var subset = typed('subset', {
      // get subset
      'Array, Index': function (value, index) {
        var m = matrix$$1(value);
        var subset = m.subset(index);       // returns a Matrix
        return index.isScalar()
            ? subset
            : subset.valueOf();  // return an Array (like the input)
      },

      'Matrix, Index': function (value, index) {
        return value.subset(index);
      },

      'Object, Index': _getObjectProperty,

      'string, Index': _getSubstring,

      // set subset
      'Array, Index, any': function (value, index, replacement) {
        return matrix$$1(clone$3(value))
            .subset(index, replacement, undefined)
            .valueOf();
      },

      'Array, Index, any, any': function (value, index, replacement, defaultValue) {
        return matrix$$1(clone$3(value))
            .subset(index, replacement, defaultValue)
            .valueOf();
      },

      'Matrix, Index, any': function (value, index, replacement) {
        return value.clone().subset(index, replacement);
      },

      'Matrix, Index, any, any': function (value, index, replacement, defaultValue) {
        return value.clone().subset(index, replacement, defaultValue);
      },

      'string, Index, string': _setSubstring,
      'string, Index, string, string': _setSubstring,
      'Object, Index, any': _setObjectProperty
    });

    subset.toTex = undefined; // use default template

    return subset;

    /**
     * Retrieve a subset of a string
     * @param {string} str            string from which to get a substring
     * @param {Index} index           An index containing ranges for each dimension
     * @returns {string} substring
     * @private
     */
    function _getSubstring(str, index) {
      if (!type.isIndex(index)) {
        // TODO: better error message
        throw new TypeError('Index expected');
      }
      if (index.size().length != 1) {
        throw new DimensionError_1(index.size().length, 1);
      }

      // validate whether the range is out of range
      var strLen = str.length;
      validateIndex$2(index.min()[0], strLen);
      validateIndex$2(index.max()[0], strLen);

      var range = index.dimension(0);

      var substr = '';
      range.forEach(function (v) {
        substr += str.charAt(v);
      });

      return substr;
    }

    /**
     * Replace a substring in a string
     * @param {string} str            string to be replaced
     * @param {Index} index           An index containing ranges for each dimension
     * @param {string} replacement    Replacement string
     * @param {string} [defaultValue] Default value to be uses when resizing
     *                                the string. is ' ' by default
     * @returns {string} result
     * @private
     */
    function _setSubstring(str, index, replacement, defaultValue) {
      if (!index || index.isIndex !== true) {
        // TODO: better error message
        throw new TypeError('Index expected');
      }
      if (index.size().length != 1) {
        throw new DimensionError_1(index.size().length, 1);
      }
      if (defaultValue !== undefined) {
        if (typeof defaultValue !== 'string' || defaultValue.length !== 1) {
          throw new TypeError('Single character expected as defaultValue');
        }
      }
      else {
        defaultValue = ' ';
      }

      var range = index.dimension(0);
      var len = range.size()[0];

      if (len != replacement.length) {
        throw new DimensionError_1(range.size()[0], replacement.length);
      }

      // validate whether the range is out of range
      var strLen = str.length;
      validateIndex$2(index.min()[0]);
      validateIndex$2(index.max()[0]);

      // copy the string into an array with characters
      var chars = [];
      for (var i = 0; i < strLen; i++) {
        chars[i] = str.charAt(i);
      }

      range.forEach(function (v, i) {
        chars[v] = replacement.charAt(i[0]);
      });

      // initialize undefined characters with a space
      if (chars.length > strLen) {
        for (i = strLen - 1, len = chars.length; i < len; i++) {
          if (!chars[i]) {
            chars[i] = defaultValue;
          }
        }
      }

      return chars.join('');
    }
  }

  /**
   * Retrieve a property from an object
   * @param {Object} object
   * @param {Index} index
   * @return {*} Returns the value of the property
   * @private
   */
  function _getObjectProperty (object$$1, index) {
    if (index.size().length !== 1) {
      throw new DimensionError_1(index.size(), 1);
    }

    var key = index.dimension(0);
    if (typeof key !== 'string') {
      throw new TypeError('String expected as index to retrieve an object property');
    }

    return getSafeProperty$1(object$$1, key);
  }

  /**
   * Set a property on an object
   * @param {Object} object
   * @param {Index} index
   * @param {*} replacement
   * @return {*} Returns the updated object
   * @private
   */
  function _setObjectProperty (object$$1, index, replacement) {
    if (index.size().length !== 1) {
      throw new DimensionError_1(index.size(), 1);
    }

    var key = index.dimension(0);
    if (typeof key !== 'string') {
      throw new TypeError('String expected as index to retrieve an object property');
    }

    // clone the object, and apply the property to the clone
    var updated = clone$3(object$$1);
    setSafeProperty$1(updated, key, replacement);

    return updated;
  }

  var name$39 = 'subset';
  var factory_1$42 = factory$43;

  var subset$1 = {
  	name: name$39,
  	factory: factory_1$42
  };

  var errorTransform = error_transform.transform;
  var getSafeProperty$2 = customs.getSafeProperty;

  function factory$44 (type, config, load, typed) {
    var subset = load(subset$1);

    /**
     * Retrieve part of an object:
     *
     * - Retrieve a property from an object
     * - Retrieve a part of a string
     * - Retrieve a matrix subset
     *
     * @param {Object | Array | Matrix | string} object
     * @param {Index} index
     * @return {Object | Array | Matrix | string} Returns the subset
     */
    return function access(object, index) {
      try {
        if (Array.isArray(object)) {
          return subset(object, index);
        }
        else if (object && typeof object.subset === 'function') { // Matrix
          return object.subset(index);
        }
        else if (typeof object === 'string') {
          // TODO: move getStringSubset into a separate util file, use that
          return subset(object, index);
        }
        else if (typeof object === 'object') {
          if (!index.isObjectProperty()) {
            throw new TypeError('Cannot apply a numeric index as object property');
          }

          return getSafeProperty$2(object, index.getObjectProperty());
        }
        else {
          throw new TypeError('Cannot apply index: unsupported type of object');
        }
      }
      catch (err) {
        throw errorTransform(err);
      }
    }
  }

  var factory_1$43 = factory$44;

  var access = {
  	factory: factory_1$43
  };

  var getSafeProperty$3 = customs.getSafeProperty;

  function factory$45 (type, config, load, typed) {
    var Node$$1 = load(Node);
    var IndexNode$$1 = load(IndexNode);
    var access$$1 = load(access);

    /**
     * @constructor AccessorNode
     * @extends {Node}
     * Access an object property or get a matrix subset
     *
     * @param {Node} object                 The object from which to retrieve
     *                                      a property or subset.
     * @param {IndexNode} index             IndexNode containing ranges
     */
    function AccessorNode(object, index) {
      if (!(this instanceof AccessorNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      if (!type.isNode(object)) {
        throw new TypeError('Node expected for parameter "object"');
      }
      if (!type.isIndexNode(index)) {
        throw new TypeError('IndexNode expected for parameter "index"');
      }

      this.object = object || null;
      this.index = index;

      // readonly property name
      Object.defineProperty(this, 'name', {
        get: function () {
          if (this.index) {
            return (this.index.isObjectProperty())
                ? this.index.getObjectProperty()
                : '';
          }
          else {
            return this.object.name || '';
          }
        }.bind(this),
        set: function () {
          throw new Error('Cannot assign a new name, name is read-only');
        }
      });
    }

    AccessorNode.prototype = new Node$$1();

    AccessorNode.prototype.type = 'AccessorNode';

    AccessorNode.prototype.isAccessorNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    AccessorNode.prototype._compile = function (math, argNames) {
      var evalObject = this.object._compile(math, argNames);
      var evalIndex = this.index._compile(math, argNames);

      if (this.index.isObjectProperty()) {
        var prop = this.index.getObjectProperty();
        return function evalAccessorNode(scope, args, context) {
          return getSafeProperty$3(evalObject(scope, args, context), prop);
        };
      }
      else {
        return function evalAccessorNode (scope, args, context) {
          var object = evalObject(scope, args, context);
          var index = evalIndex(scope, args, object); // we pass object here instead of context
          return access$$1(object, index);
        };
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    AccessorNode.prototype.forEach = function (callback) {
      callback(this.object, 'object', this);
      callback(this.index, 'index', this);
    };

    /**
     * Create a new AccessorNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AccessorNode} Returns a transformed copy of the node
     */
    AccessorNode.prototype.map = function (callback) {
      return new AccessorNode(
          this._ifNode(callback(this.object, 'object', this)),
          this._ifNode(callback(this.index, 'index', this))
      );
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {AccessorNode}
     */
    AccessorNode.prototype.clone = function () {
      return new AccessorNode(this.object, this.index);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    AccessorNode.prototype._toString = function (options) {
      var object = this.object.toString(options);
      if (needParenthesis(this.object)) {
        object = '(' + object + ')';
      }

      return object + this.index.toString(options);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    AccessorNode.prototype.toHTML = function (options) {
      var object = this.object.toHTML(options);
      if (needParenthesis(this.object)) {
        object = '<span class="math-parenthesis math-round-parenthesis">(</span>' + object + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }

      return object + this.index.toHTML(options);
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    AccessorNode.prototype._toTex = function (options) {
      var object = this.object.toTex(options);
      if (needParenthesis(this.object)) {
        object = '\\left(' + object + '\\right)';
      }

      return object + this.index.toTex(options);
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    AccessorNode.prototype.toJSON = function () {
      return {
        mathjs: 'AccessorNode',
        object: this.object,
        index: this.index
      };
    };

    /**
     * Instantiate an AccessorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "AccessorNode", object: ..., index: ...}`,
     *                       where mathjs is optional
     * @returns {AccessorNode}
     */
    AccessorNode.fromJSON = function (json) {
      return new AccessorNode(json.object, json.index);
    };

    /**
     * Are parenthesis needed?
     * @private
     */
    function needParenthesis(node) {
      // TODO: maybe make a method on the nodes which tells whether they need parenthesis?
      return !(
          type.isAccessorNode(node) ||
          type.isArrayNode(node) ||
          type.isConstantNode(node) ||
          type.isFunctionNode(node) ||
          type.isObjectNode(node) ||
          type.isParenthesisNode(node) ||
          type.isSymbolNode(node));
    }

    return AccessorNode;
  }

  var name$40 = 'AccessorNode';
  var path$16 = 'expression.node';
  var factory_1$44 = factory$45;

  var AccessorNode = {
  	name: name$40,
  	path: path$16,
  	factory: factory_1$44
  };

  var map$2 = array.map;

  function factory$46 (type, config, load, typed) {
    var Node$$1 = load(Node);

    /**
     * @constructor ArrayNode
     * @extends {Node}
     * Holds an 1-dimensional array with items
     * @param {Node[]} [items]   1 dimensional array with items
     */
    function ArrayNode(items) {
      if (!(this instanceof ArrayNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      this.items = items || [];

      // validate input
      if (!Array.isArray(this.items) || !this.items.every(type.isNode)) {
        throw new TypeError('Array containing Nodes expected');
      }

      // TODO: deprecated since v3, remove some day
      var deprecated = function () {
        throw new Error('Property `ArrayNode.nodes` is deprecated, use `ArrayNode.items` instead');
      };
      Object.defineProperty(this, 'nodes', { get: deprecated, set: deprecated });
    }

    ArrayNode.prototype = new Node$$1();

    ArrayNode.prototype.type = 'ArrayNode';

    ArrayNode.prototype.isArrayNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    ArrayNode.prototype._compile = function (math, argNames) {
      var evalItems = map$2(this.items, function (item) {
        return item._compile(math, argNames);
      });

      var asMatrix = (math.config().matrix !== 'Array');
      if (asMatrix) {
        var matrix = math.matrix;
        return function evalArrayNode (scope, args, context) {
          return matrix(map$2(evalItems, function (evalItem) {
            return evalItem(scope, args, context);
          }));
        };
      }
      else {
        return function evalArrayNode (scope, args, context) {
          return map$2(evalItems, function (evalItem) {
            return evalItem(scope, args, context);
          });
        };
      }
    };

        /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    ArrayNode.prototype.forEach = function (callback) {
      for (var i = 0; i < this.items.length; i++) {
        var node = this.items[i];
        callback(node, 'items[' + i + ']', this);
      }
    };

    /**
     * Create a new ArrayNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ArrayNode} Returns a transformed copy of the node
     */
    ArrayNode.prototype.map = function (callback) {
      var items = [];
      for (var i = 0; i < this.items.length; i++) {
        items[i] = this._ifNode(callback(this.items[i], 'items[' + i + ']', this));
      }
      return new ArrayNode(items);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {ArrayNode}
     */
    ArrayNode.prototype.clone = function() {
      return new ArrayNode(this.items.slice(0));
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ArrayNode.prototype._toString = function(options) {
      var items = this.items.map(function (node) {
        return node.toString(options);
      });
      return '[' + items.join(', ') + ']';
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    ArrayNode.prototype.toJSON = function () {
      return {
        mathjs: 'ArrayNode',
        items: this.items
      };
    };

    /**
     * Instantiate an ArrayNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ArrayNode", items: [...]}`,
     *                       where mathjs is optional
     * @returns {ArrayNode}
     */
    ArrayNode.fromJSON = function (json) {
      return new ArrayNode(json.items);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ArrayNode.prototype.toHTML = function(options) {
      var items = this.items.map(function (node) {
        return node.toHTML(options);
      });
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + items.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    ArrayNode.prototype._toTex = function(options) {
      var s = '\\begin{bmatrix}';

      this.items.forEach(function(node) {
        if (node.items) {
          s += node.items.map(function(childNode) {
            return childNode.toTex(options);
          }).join('&');
        }
        else {
          s += node.toTex(options);
        }

        // new line
        s += '\\\\';
      });
      s += '\\end{bmatrix}';
      return s;
    };

    return ArrayNode;
  }

  var name$41 = 'ArrayNode';
  var path$17 = 'expression.node';
  var factory_1$45 = factory$46;

  var ArrayNode = {
  	name: name$41,
  	path: path$17,
  	factory: factory_1$45
  };

  var errorTransform$1 = error_transform.transform;
  var setSafeProperty$2 = customs.setSafeProperty;

  function factory$47 (type, config, load, typed) {
    var subset = load(subset$1);
    var matrix$$1 = load(matrix);

    /**
     * Replace part of an object:
     *
     * - Assign a property to an object
     * - Replace a part of a string
     * - Replace a matrix subset
     *
     * @param {Object | Array | Matrix | string} object
     * @param {Index} index
     * @param {*} value
     * @return {Object | Array | Matrix | string} Returns the original object
     *                                            except in case of a string
     */
    // TODO: change assign to return the value instead of the object
    return function assign(object, index, value) {
      try {
        if (Array.isArray(object)) {
          return matrix$$1(object).subset(index, value).valueOf();
        }
        else if (object && typeof object.subset === 'function') { // Matrix
          return object.subset(index, value);
        }
        else if (typeof object === 'string') {
          // TODO: move setStringSubset into a separate util file, use that
          return subset(object, index, value);
        }
        else if (typeof object === 'object') {
          if (!index.isObjectProperty()) {
            throw TypeError('Cannot apply a numeric index as object property');
          }
          setSafeProperty$2(object, index.getObjectProperty(), value);
          return object;
        }
        else {
          throw new TypeError('Cannot apply index: unsupported type of object');
        }
      }
      catch (err) {
          throw errorTransform$1(err);
      }
    }
  }

  var factory_1$46 = factory$47;

  var assign = {
  	factory: factory_1$46
  };

  //list of identifiers of nodes in order of their precedence
  //also contains information about left/right associativity
  //and which other operator the operator is associative with
  //Example:
  // addition is associative with addition and subtraction, because:
  // (a+b)+c=a+(b+c)
  // (a+b)-c=a+(b-c)
  //
  // postfix operators are left associative, prefix operators 
  // are right associative
  //
  //It's also possible to set the following properties:
  // latexParens: if set to false, this node doesn't need to be enclosed
  //              in parentheses when using LaTeX
  // latexLeftParens: if set to false, this !OperatorNode's! 
  //                  left argument doesn't need to be enclosed
  //                  in parentheses
  // latexRightParens: the same for the right argument
  var properties = [
    { //assignment
      'AssignmentNode': {},
      'FunctionAssignmentNode': {}
    },
    { //conditional expression
      'ConditionalNode': {
        latexLeftParens: false,
        latexRightParens: false,
        latexParens: false
        //conditionals don't need parentheses in LaTeX because
        //they are 2 dimensional
      }
    },
    { //logical or
      'OperatorNode:or': {
        associativity: 'left',
        associativeWith: []
      }

    },
    { //logical xor
      'OperatorNode:xor': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //logical and
      'OperatorNode:and': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //bitwise or
      'OperatorNode:bitOr': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //bitwise xor
      'OperatorNode:bitXor': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //bitwise and
      'OperatorNode:bitAnd': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //relational operators
      'OperatorNode:equal': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:unequal': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:smaller': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:larger': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:smallerEq': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:largerEq': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //bitshift operators
      'OperatorNode:leftShift': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:rightArithShift': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:rightLogShift': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //unit conversion
      'OperatorNode:to': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //range
      'RangeNode': {}
    },
    { //addition, subtraction
      'OperatorNode:add': {
        associativity: 'left',
        associativeWith: ['OperatorNode:add', 'OperatorNode:subtract']
      },
      'OperatorNode:subtract': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //multiply, divide, modulus
      'OperatorNode:multiply': {
        associativity: 'left',
        associativeWith: [
          'OperatorNode:multiply',
          'OperatorNode:divide',
          'Operator:dotMultiply',
          'Operator:dotDivide'
        ]
      },
      'OperatorNode:divide': {
        associativity: 'left',
        associativeWith: [],
        latexLeftParens: false,
        latexRightParens: false,
        latexParens: false
        //fractions don't require parentheses because
        //they're 2 dimensional, so parens aren't needed
        //in LaTeX
      },
      'OperatorNode:dotMultiply': {
        associativity: 'left',
        associativeWith: [
          'OperatorNode:multiply',
          'OperatorNode:divide',
          'OperatorNode:dotMultiply',
          'OperatorNode:doDivide'
        ]
      },
      'OperatorNode:dotDivide': {
        associativity: 'left',
        associativeWith: []
      },
      'OperatorNode:mod': {
        associativity: 'left',
        associativeWith: []
      }
    },
    { //unary prefix operators
      'OperatorNode:unaryPlus': {
        associativity: 'right'
      },
      'OperatorNode:unaryMinus': {
        associativity: 'right'
      },
      'OperatorNode:bitNot': {
        associativity: 'right'
      },
      'OperatorNode:not': {
        associativity: 'right'
      }
    },
    { //exponentiation
      'OperatorNode:pow': {
        associativity: 'right',
        associativeWith: [],
        latexRightParens: false
        //the exponent doesn't need parentheses in
        //LaTeX because it's 2 dimensional
        //(it's on top)
      },
      'OperatorNode:dotPow': {
        associativity: 'right',
        associativeWith: []
      }
    },
    { //factorial
      'OperatorNode:factorial': {
        associativity: 'left'
      }
    },
    { //matrix transpose
      'OperatorNode:transpose': {
        associativity: 'left'
      }
    }
  ];

  /**
   * Get the precedence of a Node.
   * Higher number for higher precedence, starting with 0.
   * Returns null if the precedence is undefined.
   *
   * @param {Node}
   * @param {string} parenthesis
   * @return {number|null}
   */
  function getPrecedence (_node, parenthesis) {
    var node = _node;
    if (parenthesis !== 'keep') {
      //ParenthesisNodes are only ignored when not in 'keep' mode
      node = _node.getContent();
    }
    var identifier = node.getIdentifier();
    for (var i = 0; i < properties.length; i++) {
      if (identifier in properties[i]) {
        return i;
      }
    }
    return null;
  }

  /**
   * Get the associativity of an operator (left or right).
   * Returns a string containing 'left' or 'right' or null if
   * the associativity is not defined.
   *
   * @param {Node}
   * @param {string} parenthesis
   * @return {string|null}
   * @throws {Error}
   */
  function getAssociativity (_node, parenthesis) {
    var node = _node;
    if (parenthesis !== 'keep') {
      //ParenthesisNodes are only ignored when not in 'keep' mode
      node = _node.getContent();
    }
    var identifier = node.getIdentifier();
    var index = getPrecedence(node, parenthesis);
    if (index === null) {
      //node isn't in the list
      return null;
    }
    var property = properties[index][identifier];

    if (property.hasOwnProperty('associativity')) {
      if (property.associativity === 'left') {
        return 'left';
      }
      if (property.associativity === 'right') {
        return 'right';
      }
      //associativity is invalid
      throw Error('\'' + identifier + '\' has the invalid associativity \''
                  + property.associativity + '\'.');
    }

    //associativity is undefined
    return null;
  }

  /**
   * Check if an operator is associative with another operator.
   * Returns either true or false or null if not defined.
   *
   * @param {Node} nodeA
   * @param {Node} nodeB
   * @param {string} parenthesis
   * @return {bool|null}
   */
  function isAssociativeWith (nodeA, nodeB, parenthesis) {
    var a = nodeA;
    var b = nodeB;
    if (parenthesis !== 'keep') {
      //ParenthesisNodes are only ignored when not in 'keep' mode
      var a = nodeA.getContent();
      var b = nodeB.getContent();
    }
    var identifierA = a.getIdentifier();
    var identifierB = b.getIdentifier();
    var index = getPrecedence(a, parenthesis);
    if (index === null) {
      //node isn't in the list
      return null;
    }
    var property = properties[index][identifierA];

    if (property.hasOwnProperty('associativeWith')
        && (property.associativeWith instanceof Array)) {
      for (var i = 0; i < property.associativeWith.length; i++) {
        if (property.associativeWith[i] === identifierB) {
          return true;
        }
      }
      return false;
    }

    //associativeWith is not defined
    return null;
  }

  var properties_1 = properties;
  var getPrecedence_1 = getPrecedence;
  var getAssociativity_1 = getAssociativity;
  var isAssociativeWith_1 = isAssociativeWith;

  var operators = {
  	properties: properties_1,
  	getPrecedence: getPrecedence_1,
  	getAssociativity: getAssociativity_1,
  	isAssociativeWith: isAssociativeWith_1
  };

  var getSafeProperty$4 = customs.getSafeProperty;
  var setSafeProperty$3 = customs.setSafeProperty;

  function factory$48 (type, config, load, typed) {
    var Node$$1 = load(Node);
    var assign$$1 = load(assign);
    var access$$1 = load(access);

    var operators$$1 = operators;

    /**
     * @constructor AssignmentNode
     * @extends {Node}
     *
     * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
     * replace a subset of a matrix like `A[2,2]=42`.
     *
     * Syntax:
     *
     *     new AssignmentNode(symbol, value)
     *     new AssignmentNode(object, index, value)
     *
     * Usage:
     *
     *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2));                      // a=2
     *    new AssignmentNode(new SymbolNode('a'), new IndexNode('b'), new ConstantNode(2))   // a.b=2
     *    new AssignmentNode(new SymbolNode('a'), new IndexNode(1, 2), new ConstantNode(3))  // a[1,2]=3
     *
     * @param {SymbolNode | AccessorNode} object  Object on which to assign a value
     * @param {IndexNode} [index=null]            Index, property name or matrix
     *                                            index. Optional. If not provided
     *                                            and `object` is a SymbolNode,
     *                                            the property is assigned to the
     *                                            global scope.
     * @param {Node} value                        The value to be assigned
     */
    function AssignmentNode(object, index, value) {
      if (!(this instanceof AssignmentNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      this.object = object;
      this.index = value ? index : null;
      this.value = value ? value : index;

      // validate input
      if (!type.isSymbolNode(object) && !type.isAccessorNode(object)) {
        throw new TypeError('SymbolNode or AccessorNode expected as "object"');
      }
      if (type.isSymbolNode(object) && object.name === 'end') {
        throw new Error('Cannot assign to symbol "end"');
      }
      if (this.index && !type.isIndexNode(this.index)) { // index is optional
        throw new TypeError('IndexNode expected as "index"');
      }
      if (!type.isNode(this.value)) {
        throw new TypeError('Node expected as "value"');
      }

      // readonly property name
      Object.defineProperty(this, 'name', {
        get: function () {
          if (this.index) {
            return (this.index.isObjectProperty())
                ? this.index.getObjectProperty()
                : '';
          }
          else {
            return this.object.name || '';
          }
        }.bind(this),
        set: function () {
          throw new Error('Cannot assign a new name, name is read-only');
        }
      });
    }

    AssignmentNode.prototype = new Node$$1();

    AssignmentNode.prototype.type = 'AssignmentNode';

    AssignmentNode.prototype.isAssignmentNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    AssignmentNode.prototype._compile = function (math, argNames) {
      var evalObject = this.object._compile(math, argNames);
      var evalIndex = this.index ? this.index._compile(math, argNames) : null;
      var evalValue = this.value._compile(math, argNames);
      var name = this.object.name;
      
      if (!this.index) {
        // apply a variable to the scope, for example `a=2`
        if (!type.isSymbolNode(this.object)) {
          throw new TypeError('SymbolNode expected as object');
        }

        return function evalAssignmentNode (scope, args, context) {
          return setSafeProperty$3(scope, name, evalValue(scope, args, context));
        };
      }
      else if (this.index.isObjectProperty()) {
        // apply an object property for example `a.b=2`
        var prop = this.index.getObjectProperty();

        return function evalAssignmentNode (scope, args, context) {
          var object = evalObject(scope, args, context);
          var value = evalValue(scope, args, context);
          return setSafeProperty$3(object, prop, value);
        };
      }
      else if (type.isSymbolNode(this.object)) {
        // update a matrix subset, for example `a[2]=3`
        return function evalAssignmentNode(scope, args, context) {
          var childObject = evalObject(scope, args, context);
          var value = evalValue(scope, args, context);
          var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
          setSafeProperty$3(scope, name, assign$$1(childObject, index, value));
          return value;
        }
      }
      else { // type.isAccessorNode(node.object) === true
        // update a matrix subset, for example `a.b[2]=3`

        // we will not use the compile function of the AccessorNode, but compile it
        // ourselves here as we need the parent object of the AccessorNode:
        // wee need to apply the updated object to parent object
        var evalParentObject = this.object.object._compile(math, argNames);

        if (this.object.index.isObjectProperty()) {
          var parentProp = this.object.index.getObjectProperty();

          return function evalAssignmentNode(scope, args, context) {
            var parent = evalParentObject(scope, args, context);
            var childObject = getSafeProperty$4(parent, parentProp);
            var index = evalIndex(scope, args, childObject); // Important: we pass childObject instead of context
            var value = evalValue(scope, args, context);
            setSafeProperty$3(parent, parentProp, assign$$1(childObject, index, value));
            return value;
          }
        }
        else {
          // if some parameters use the 'end' parameter, we need to calculate the size
          var evalParentIndex = this.object.index._compile(math, argNames);

          return function evalAssignmentNode(scope, args, context) {
            var parent = evalParentObject(scope, args, context);
            var parentIndex = evalParentIndex(scope, args, parent); // Important: we pass parent instead of context
            var childObject = access$$1(parent, parentIndex);
            var index = evalIndex(scope, args, childObject); // Important:  we pass childObject instead of context
            var value = evalValue(scope, args, context);

            assign$$1(parent, parentIndex, assign$$1(childObject, index, value));

            return value;
          }
        }
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    AssignmentNode.prototype.forEach = function (callback) {
      callback(this.object, 'object', this);
      if (this.index) {
        callback(this.index, 'index', this);
      }
      callback(this.value, 'value', this);
    };

    /**
     * Create a new AssignmentNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AssignmentNode} Returns a transformed copy of the node
     */
    AssignmentNode.prototype.map = function (callback) {
      var object = this._ifNode(callback(this.object, 'object', this));
      var index = this.index
          ? this._ifNode(callback(this.index, 'index', this))
          : null;
      var value = this._ifNode(callback(this.value, 'value', this));

      return new AssignmentNode(object, index, value);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {AssignmentNode}
     */
    AssignmentNode.prototype.clone = function() {
      return new AssignmentNode(this.object, this.index, this.value);
    };

    /*
     * Is parenthesis needed?
     * @param {node} node
     * @param {string} [parenthesis='keep']
     * @private
     */
    function needParenthesis(node, parenthesis) {
      if (!parenthesis) {
        parenthesis = 'keep';
      }

      var precedence = operators$$1.getPrecedence(node, parenthesis);
      var exprPrecedence = operators$$1.getPrecedence(node.value, parenthesis);
      return (parenthesis === 'all')
        || ((exprPrecedence !== null) && (exprPrecedence <= precedence));
    }

    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    AssignmentNode.prototype._toString = function(options) {
      var object = this.object.toString(options);
      var index = this.index ? this.index.toString(options) : '';
      var value = this.value.toString(options);
      if (needParenthesis(this, options && options.parenthesis)) {
        value = '(' + value + ')';
      }

      return object + index + ' = ' + value;
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    AssignmentNode.prototype.toJSON = function () {
      return {
        mathjs: 'AssignmentNode',
        object: this.object,
        index: this.index,
        value: this.value
      };
    };

    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
     *                       where mathjs is optional
     * @returns {AssignmentNode}
     */
    AssignmentNode.fromJSON = function (json) {
      return new AssignmentNode(json.object, json.index, json.value);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    AssignmentNode.prototype.toHTML = function(options) {
      var object = this.object.toHTML(options);
      var index = this.index ? this.index.toHTML(options) : '';
      var value = this.value.toHTML(options);
      if (needParenthesis(this, options && options.parenthesis)) {
        value = '<span class="math-paranthesis math-round-parenthesis">(</span>' + value + '<span class="math-paranthesis math-round-parenthesis">)</span>';
      }

      return object + index + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + value;
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    AssignmentNode.prototype._toTex = function(options) {
      var object = this.object.toTex(options);
      var index = this.index ? this.index.toTex(options) : '';
      var value = this.value.toTex(options);
      if (needParenthesis(this, options && options.parenthesis)) {
        value = '\\left(' + value + '\\right)';
      }

      return object + index + ':=' + value;
    };

    return AssignmentNode;
  }

  var name$42 = 'AssignmentNode';
  var path$18 = 'expression.node';
  var factory_1$47 = factory$48;

  var AssignmentNode = {
  	name: name$42,
  	path: path$18,
  	factory: factory_1$47
  };

  var forEach$1 = array.forEach;
  var map$3 = array.map;

  function factory$49 (type, config, load, typed) {
    var Node$$1 = load(Node);
    var ResultSet$$1 = load(ResultSet);

    /**
     * @constructor BlockNode
     * @extends {Node}
     * Holds a set with blocks
     * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
     *            An array with blocks, where a block is constructed as an Object
     *            with properties block, which is a Node, and visible, which is
     *            a boolean. The property visible is optional and is true by default
     */
    function BlockNode(blocks) {
      if (!(this instanceof BlockNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      // validate input, copy blocks
      if (!Array.isArray(blocks)) throw new Error('Array expected');
      this.blocks = blocks.map(function (block) {
        var node = block && block.node;
        var visible = block && block.visible !== undefined ? block.visible : true;

        if (!type.isNode(node)) throw new TypeError('Property "node" must be a Node');
        if (typeof visible !== 'boolean') throw new TypeError('Property "visible" must be a boolean');

        return {
          node: node,
          visible: visible
        }
      });
    }

    BlockNode.prototype = new Node$$1();

    BlockNode.prototype.type = 'BlockNode';

    BlockNode.prototype.isBlockNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    BlockNode.prototype._compile = function (math, argNames) {
      var evalBlocks = map$3(this.blocks, function (block) {
        return {
          eval: block.node._compile(math, argNames),
          visible: block.visible
        };
      });

      return function evalBlockNodes (scope, args, context) {
        var results = [];

        forEach$1(evalBlocks, function evalBlockNode(block) {
          var result = block.eval(scope, args, context);
          if (block.visible) {
            results.push(result);
          }
        });

        return new ResultSet$$1(results);
      }
    };

    /**
     * Execute a callback for each of the child blocks of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    BlockNode.prototype.forEach = function (callback) {
      for (var i = 0; i < this.blocks.length; i++) {
        callback(this.blocks[i].node, 'blocks[' + i + '].node', this);
      }
    };

    /**
     * Create a new BlockNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {BlockNode} Returns a transformed copy of the node
     */
    BlockNode.prototype.map = function (callback) {
      var blocks = [];
      for (var i = 0; i < this.blocks.length; i++) {
        var block = this.blocks[i];
        var node = this._ifNode(callback(block.node, 'blocks[' + i + '].node', this));
        blocks[i] = {
          node: node,
          visible: block.visible
        };
      }
      return new BlockNode(blocks);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {BlockNode}
     */
    BlockNode.prototype.clone = function () {
      var blocks = this.blocks.map(function (block) {
        return {
          node: block.node,
          visible: block.visible
        };
      });

      return new BlockNode(blocks);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    BlockNode.prototype._toString = function (options) {
      return this.blocks.map(function (param) {
        return param.node.toString(options) + (param.visible ? '' : ';');
      }).join('\n');
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    BlockNode.prototype.toJSON = function () {
      return {
        mathjs: 'BlockNode',
        blocks: this.blocks
      };
    };

    /**
     * Instantiate an BlockNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
     *                       where mathjs is optional
     * @returns {BlockNode}
     */
    BlockNode.fromJSON = function (json) {
      return new BlockNode(json.blocks);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    BlockNode.prototype.toHTML = function (options) {
      return this.blocks.map(function (param) {
        return param.node.toHTML(options) + (param.visible ? '' : '<span class="math-separator">;</span>');
      }).join('<span class="math-separator"><br /></span>');
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    BlockNode.prototype._toTex = function (options) {
      return this.blocks.map(function (param) {
        return param.node.toTex(options) + (param.visible ? '' : ';');
      }).join('\\;\\;\n');
    };

    return BlockNode;
  }

  var name$43 = 'BlockNode';
  var path$19 = 'expression.node';
  var factory_1$48 = factory$49;

  var BlockNode = {
  	name: name$43,
  	path: path$19,
  	factory: factory_1$48
  };

  function factory$50 (type, config, load, typed) {
    /**
     * Determine the type of a variable.
     *
     * Function `typeof` recognizes the following types of objects:
     *
     * Object                 | Returns       | Example
     * ---------------------- | ------------- | ------------------------------------------
     * null                   | `'null'`      | `math.typeof(null)`
     * number                 | `'number'`    | `math.typeof(3.5)`
     * boolean                | `'boolean'`   | `math.typeof(true)`
     * string                 | `'string'`    | `math.typeof('hello world')`
     * Array                  | `'Array'`     | `math.typeof([1, 2, 3])`
     * Date                   | `'Date'`      | `math.typeof(new Date())`
     * Function               | `'Function'`  | `math.typeof(function () {})`
     * Object                 | `'Object'`    | `math.typeof({a: 2, b: 3})`
     * RegExp                 | `'RegExp'`    | `math.typeof(/a regexp/)`
     * undefined              | `'undefined'` | `math.typeof(undefined)`
     * math.type.BigNumber    | `'BigNumber'` | `math.typeof(math.bignumber('2.3e500'))`
     * math.type.Chain        | `'Chain'`     | `math.typeof(math.chain(2))`
     * math.type.Complex      | `'Complex'`   | `math.typeof(math.complex(2, 3))`
     * math.type.Fraction     | `'Fraction'`  | `math.typeof(math.fraction(1, 3))`
     * math.type.Help         | `'Help'`      | `math.typeof(math.help('sqrt'))`
     * math.type.Help         | `'Help'`      | `math.typeof(math.help('sqrt'))`
     * math.type.Index        | `'Index'`     | `math.typeof(math.index(1, 3))`
     * math.type.Matrix       | `'Matrix'`    | `math.typeof(math.matrix([[1,2], [3, 4]]))`
     * math.type.Range        | `'Range'`     | `math.typeof(math.range(0, 10))`
     * math.type.ResultSet    | `'ResultSet'` | `math.typeof(math.eval('a=2\nb=3'))`
     * math.type.Unit         | `'Unit'`      | `math.typeof(math.unit('45 deg'))`
     * math.expression.node.AccessorNode            | `'AccessorNode'`            | `math.typeof(math.parse('A[2]'))`
     * math.expression.node.ArrayNode               | `'ArrayNode'`               | `math.typeof(math.parse('[1,2,3]'))`
     * math.expression.node.AssignmentNode          | `'AssignmentNode'`          | `math.typeof(math.parse('x=2'))`
     * math.expression.node.BlockNode               | `'BlockNode'`               | `math.typeof(math.parse('a=2; b=3'))`
     * math.expression.node.ConditionalNode         | `'ConditionalNode'`         | `math.typeof(math.parse('x<0 ? -x : x'))`
     * math.expression.node.ConstantNode            | `'ConstantNode'`            | `math.typeof(math.parse('2.3'))`
     * math.expression.node.FunctionAssignmentNode  | `'FunctionAssignmentNode'`  | `math.typeof(math.parse('f(x)=x^2'))`
     * math.expression.node.FunctionNode            | `'FunctionNode'`            | `math.typeof(math.parse('sqrt(4)'))`
     * math.expression.node.IndexNode               | `'IndexNode'`               | `math.typeof(math.parse('A[2]').index)`
     * math.expression.node.ObjectNode              | `'ObjectNode'`              | `math.typeof(math.parse('{a:2}'))`
     * math.expression.node.ParenthesisNode         | `'ParenthesisNode'`         | `math.typeof(math.parse('(2+3)'))`
     * math.expression.node.RangeNode               | `'RangeNode'`               | `math.typeof(math.parse('1:10'))`
     * math.expression.node.SymbolNode              | `'SymbolNode'`              | `math.typeof(math.parse('x'))`
     *
     * Syntax:
     *
     *    math.typeof(x)
     *
     * Examples:
     *
     *    math.typeof(3.5);                     // returns 'number'
     *    math.typeof(math.complex('2-4i'));    // returns 'Complex'
     *    math.typeof(math.unit('45 deg'));     // returns 'Unit'
     *    math.typeof('hello world');           // returns 'string'
     *
     * @param {*} x     The variable for which to test the type.
     * @return {string} Returns the name of the type. Primitive types are lower case,
     *                  non-primitive types are upper-camel-case.
     *                  For example 'number', 'string', 'Array', 'Date'.
     */
    var _typeof = typed('_typeof', {
      'any': function (x) {
        var t = typeof x;

        if (t === 'object') {
          // JavaScript types
          if (x === null)           return 'null';
          if (Array.isArray(x))     return 'Array';
          if (x instanceof Date)    return 'Date';
          if (x instanceof RegExp)  return 'RegExp';
          if (x instanceof Boolean) return 'boolean';
          if (x instanceof Number)  return 'number';
          if (x instanceof String)  return 'string';

          // math.js types
          if (type.isBigNumber(x)) return 'BigNumber';
          if (type.isComplex(x))   return 'Complex';
          if (type.isFraction(x))  return 'Fraction';
          if (type.isMatrix(x))    return 'Matrix';
          if (type.isUnit(x))      return 'Unit';
          if (type.isIndex(x))     return 'Index';
          if (type.isRange(x))     return 'Range';
          if (type.isResultSet(x)) return 'ResultSet';
          if (type.isNode(x))      return x.type;
          if (type.isChain(x))     return 'Chain';
          if (type.isHelp(x))      return 'Help';

          return 'Object';
        }

        if (t === 'function') return 'Function';

        return t; // can be 'string', 'number', 'boolean', ...
      }
    });

    _typeof.toTex = undefined; // use default template

    return _typeof;
  }

  var name$44 = 'typeof';
  var factory_1$49 = factory$50;

  var _typeof$1 = {
  	name: name$44,
  	factory: factory_1$49
  };

  function factory$51 (type, config, load, typed) {
    var Node$$1 = load(Node);
    var mathTypeOf = load(_typeof$1);

    /**
     * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
     *
     * @param {Node} condition   Condition, must result in a boolean
     * @param {Node} trueExpr    Expression evaluated when condition is true
     * @param {Node} falseExpr   Expression evaluated when condition is true
     *
     * @constructor ConditionalNode
     * @extends {Node}
     */
    function ConditionalNode(condition, trueExpr, falseExpr) {
      if (!(this instanceof ConditionalNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }
      if (!type.isNode(condition)) throw new TypeError('Parameter condition must be a Node');
      if (!type.isNode(trueExpr))  throw new TypeError('Parameter trueExpr must be a Node');
      if (!type.isNode(falseExpr)) throw new TypeError('Parameter falseExpr must be a Node');

      this.condition = condition;
      this.trueExpr = trueExpr;
      this.falseExpr = falseExpr;
    }

    ConditionalNode.prototype = new Node$$1();

    ConditionalNode.prototype.type = 'ConditionalNode';

    ConditionalNode.prototype.isConditionalNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    ConditionalNode.prototype._compile = function (math, argNames) {
      var evalCondition = this.condition._compile(math, argNames);
      var evalTrueExpr = this.trueExpr._compile(math, argNames);
      var evalFalseExpr = this.falseExpr._compile(math, argNames);

      return function evalConditionalNode(scope, args, context) {
        return testCondition(evalCondition(scope, args, context)) 
            ? evalTrueExpr(scope, args, context) 
            : evalFalseExpr(scope, args, context);
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    ConditionalNode.prototype.forEach = function (callback) {
      callback(this.condition, 'condition', this);
      callback(this.trueExpr, 'trueExpr', this);
      callback(this.falseExpr, 'falseExpr', this);
    };

    /**
     * Create a new ConditionalNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ConditionalNode} Returns a transformed copy of the node
     */
    ConditionalNode.prototype.map = function (callback) {
      return new ConditionalNode(
          this._ifNode(callback(this.condition, 'condition', this)),
          this._ifNode(callback(this.trueExpr, 'trueExpr', this)),
          this._ifNode(callback(this.falseExpr, 'falseExpr', this))
      );
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {ConditionalNode}
     */
    ConditionalNode.prototype.clone = function () {
      return new ConditionalNode(this.condition, this.trueExpr, this.falseExpr);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    ConditionalNode.prototype._toString = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var precedence = operators.getPrecedence(this, parenthesis);

      //Enclose Arguments in parentheses if they are an OperatorNode
      //or have lower or equal precedence
      //NOTE: enclosing all OperatorNodes in parentheses is a decision
      //purely based on aesthetics and readability
      var condition = this.condition.toString(options);
      var conditionPrecedence = operators.getPrecedence(this.condition, parenthesis);
      if ((parenthesis === 'all')
          || (this.condition.type === 'OperatorNode')
          || ((conditionPrecedence !== null) && (conditionPrecedence <= precedence))) {
        condition = '(' + condition + ')';
      }

      var trueExpr = this.trueExpr.toString(options);
      var truePrecedence = operators.getPrecedence(this.trueExpr, parenthesis);
      if ((parenthesis === 'all')
          || (this.trueExpr.type === 'OperatorNode')
          || ((truePrecedence !== null) && (truePrecedence <= precedence))) {
        trueExpr = '(' + trueExpr + ')';
      }

      var falseExpr = this.falseExpr.toString(options);
      var falsePrecedence = operators.getPrecedence(this.falseExpr, parenthesis);
      if ((parenthesis === 'all')
          || (this.falseExpr.type === 'OperatorNode')
          || ((falsePrecedence !== null) && (falsePrecedence <= precedence))) {
        falseExpr = '(' + falseExpr + ')';
      }
      return condition + ' ? ' + trueExpr + ' : ' + falseExpr;
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    ConditionalNode.prototype.toJSON = function () {
      return {
        mathjs: 'ConditionalNode',
        condition: this.condition,
        trueExpr: this.trueExpr,
        falseExpr: this.falseExpr
      };
    };

    /**
     * Instantiate an ConditionalNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ConditionalNode", "condition": ..., "trueExpr": ..., "falseExpr": ...}`,
     *                       where mathjs is optional
     * @returns {ConditionalNode}
     */
    ConditionalNode.fromJSON = function (json) {
      return new ConditionalNode(json.condition, json.trueExpr, json.falseExpr);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    ConditionalNode.prototype.toHTML = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var precedence = operators.getPrecedence(this, parenthesis);

      //Enclose Arguments in parentheses if they are an OperatorNode
      //or have lower or equal precedence
      //NOTE: enclosing all OperatorNodes in parentheses is a decision
      //purely based on aesthetics and readability
      var condition = this.condition.toHTML(options);
      var conditionPrecedence = operators.getPrecedence(this.condition, parenthesis);
      if ((parenthesis === 'all')
          || (this.condition.type === 'OperatorNode')
          || ((conditionPrecedence !== null) && (conditionPrecedence <= precedence))) {
        condition = '<span class="math-parenthesis math-round-parenthesis">(</span>' + condition + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }

      var trueExpr = this.trueExpr.toHTML(options);
      var truePrecedence = operators.getPrecedence(this.trueExpr, parenthesis);
      if ((parenthesis === 'all')
          || (this.trueExpr.type === 'OperatorNode')
          || ((truePrecedence !== null) && (truePrecedence <= precedence))) {
        trueExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + trueExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }

      var falseExpr = this.falseExpr.toHTML(options);
      var falsePrecedence = operators.getPrecedence(this.falseExpr, parenthesis);
      if ((parenthesis === 'all')
          || (this.falseExpr.type === 'OperatorNode')
          || ((falsePrecedence !== null) && (falsePrecedence <= precedence))) {
        falseExpr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + falseExpr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }
      return condition + '<span class="math-operator math-conditional-operator">?</span>' + trueExpr + '<span class="math-operator math-conditional-operator">:</span>' + falseExpr;
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    ConditionalNode.prototype._toTex = function (options) {
      return '\\begin{cases} {'
          + this.trueExpr.toTex(options) + '}, &\\quad{\\text{if }\\;'
          + this.condition.toTex(options)
          + '}\\\\{' + this.falseExpr.toTex(options)
          + '}, &\\quad{\\text{otherwise}}\\end{cases}';
    };

    /**
     * Test whether a condition is met
     * @param {*} condition
     * @returns {boolean} true if condition is true or non-zero, else false
     */
    function testCondition (condition) {
      if (typeof condition === 'number'
          || typeof condition === 'boolean'
          || typeof condition === 'string') {
        return condition ? true : false;
      }

      if (condition) {
        if (type.isBigNumber(condition)) {
          return condition.isZero() ? false : true;
        }

        if (type.isComplex(condition)) {
          return (condition.re || condition.im) ? true : false;
        }

        if (type.isUnit(condition)) {
          return condition.value ? true : false;
        }
      }

      if (condition === null || condition === undefined) {
        return false;
      }

      throw new TypeError('Unsupported type of condition "' + mathTypeOf(condition) + '"');
    }
    return ConditionalNode;
  }

  var name$45 = 'ConditionalNode';
  var path$20 = 'expression.node';
  var factory_1$50 = factory$51;

  var ConditionalNode = {
  	name: name$45,
  	path: path$20,
  	factory: factory_1$50
  };

  var format$3 = string.format;
  var escapeLatex = latex.escape;

  function factory$52 (type, config, load, typed) {
    var Node$$1 = load(Node);
    var getType = load(_typeof$1);

    /**
     * A ConstantNode holds a constant value like a number or string.
     *
     * Usage:
     *
     *     new ConstantNode(2.3);
     *     new ConstantNode('hello');
     *
     * @param {*} value    Value can be any type (number, BigNumber, string, ...)
     * @constructor ConstantNode
     * @extends {Node}
     */
    function ConstantNode(value) {
      if (!(this instanceof ConstantNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      if (arguments.length === 2) {
        // TODO: remove deprecation error some day (created 2018-01-23)
        throw new SyntaxError('new ConstantNode(valueStr, valueType) is not supported anymore since math v4.0.0. Use new ConstantNode(value) instead, where value is a non-stringified value.');
      }

      this.value = value;
    }

    ConstantNode.prototype = new Node$$1();

    ConstantNode.prototype.type = 'ConstantNode';

    ConstantNode.prototype.isConstantNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    ConstantNode.prototype._compile = function (math, argNames) {
      var value = this.value;

      return function evalConstantNode() {
        return value;
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    ConstantNode.prototype.forEach = function (callback) {
      // nothing to do, we don't have childs
    };

    /**
     * Create a new ConstantNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ConstantNode} Returns a clone of the node
     */
    ConstantNode.prototype.map = function (callback) {
      return this.clone();
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {ConstantNode}
     */
    ConstantNode.prototype.clone = function () {
      return new ConstantNode(this.value);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    ConstantNode.prototype._toString = function (options) {
      return format$3 (this.value, options);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    ConstantNode.prototype.toHTML = function (options) {
      var value = this._toString(options);

      switch (getType(this.value)) {
    	  case 'number':
    	  case 'BigNumber':
    	  case 'Fraction':
  	    return '<span class="math-number">' + value + '</span>';
        case 'string':
  	    return '<span class="math-string">' + value + '</span>';
        case 'boolean':
  	    return '<span class="math-boolean">' + value + '</span>';
        case 'null':
  	    return '<span class="math-null-symbol">' + value + '</span>';
        case 'undefined':
  	    return '<span class="math-undefined">' + value + '</span>';

        default:
          return '<span class="math-symbol">' + value + '</span>';
      }
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    ConstantNode.prototype.toJSON = function () {
      return {
        mathjs: 'ConstantNode',
        value: this.value
      };
    };

    /**
     * Instantiate a ConstantNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", value: 2.3}`,
     *                       where mathjs is optional
     * @returns {ConstantNode}
     */
    ConstantNode.fromJSON = function (json) {
      return new ConstantNode(json.value);
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    ConstantNode.prototype._toTex = function (options) {
      var value = this._toString(options);

      switch (getType(this.value)) {
        case 'string':
          return '\\mathtt{' + escapeLatex(value) + '}';

        case 'number':
        case 'BigNumber':
          var index = value.toLowerCase().indexOf('e');
          if (index !== -1) {
            return value.substring(0, index) + '\\cdot10^{' +
                value.substring(index + 1) + '}';
          }
          return value;

        case 'Fraction':
          return this.value.toLatex();

        default:
          return value;
      }
    };

    return ConstantNode;
  }

  var name$46 = 'ConstantNode';
  var path$21 = 'expression.node';
  var factory_1$51 = factory$52;

  var ConstantNode = {
  	name: name$46,
  	path: path$21,
  	factory: factory_1$51
  };

  var escape$1 = string.escape;
  var forEach$2 = array.forEach;
  var join = array.join;


  var setSafeProperty$4 = customs.setSafeProperty;

  function factory$53 (type, config, load, typed) {
    var Node$$1 = load(Node);

    /**
     * @constructor FunctionAssignmentNode
     * @extends {Node}
     * Function assignment
     *
     * @param {string} name           Function name
     * @param {string[] | Array.<{name: string, type: string}>} params
     *                                Array with function parameter names, or an
     *                                array with objects containing the name
     *                                and type of the parameter
     * @param {Node} expr             The function expression
     */
    function FunctionAssignmentNode(name, params, expr) {
      if (!(this instanceof FunctionAssignmentNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      // validate input
      if (typeof name !== 'string') throw new TypeError('String expected for parameter "name"');
      if (!Array.isArray(params))  throw new TypeError('Array containing strings or objects expected for parameter "params"');
      if (!type.isNode(expr)) throw new TypeError('Node expected for parameter "expr"');
      if (name in keywords) throw new Error('Illegal function name, "' + name + '" is a reserved keyword');

      this.name = name;
      this.params = params.map(function (param) {
        return param && param.name || param;
      });
      this.types = params.map(function (param) {
        return param && param.type || 'any'
      });
      this.expr = expr;
    }

    FunctionAssignmentNode.prototype = new Node$$1();

    FunctionAssignmentNode.prototype.type = 'FunctionAssignmentNode';

    FunctionAssignmentNode.prototype.isFunctionAssignmentNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    FunctionAssignmentNode.prototype._compile = function (math, argNames) {
      var childArgNames = Object.create(argNames);
      forEach$2(this.params, function (param) {
        childArgNames[param] = true;
      });

      // compile the function expression with the child args
      var evalExpr = this.expr._compile(math, childArgNames);
      var name = this.name;
      var params = this.params;
      var signature = join(this.types, ',');
      var syntax = name + '(' + join(this.params, ', ') + ')';

      return function evalFunctionAssignmentNode(scope, args, context) {
        var signatures = {};
        signatures[signature] = function () {
          var childArgs = Object.create(args);

          for (var i = 0; i < params.length; i++) {
            childArgs[params[i]] = arguments[i];
          }

          return evalExpr(scope, childArgs, context);
        };
        var fn = typed(name, signatures);
        fn.syntax = syntax;

        setSafeProperty$4(scope, name, fn);

        return fn;
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    FunctionAssignmentNode.prototype.forEach = function (callback) {
      callback(this.expr, 'expr', this);
    };

    /**
     * Create a new FunctionAssignmentNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
     */
    FunctionAssignmentNode.prototype.map = function (callback) {
      var expr = this._ifNode(callback(this.expr, 'expr', this));

      return new FunctionAssignmentNode(this.name, this.params.slice(0), expr);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionAssignmentNode}
     */
    FunctionAssignmentNode.prototype.clone = function () {
      return new FunctionAssignmentNode(this.name, this.params.slice(0), this.expr);
    };

    /**
     * Is parenthesis needed?
     * @param {Node} node
     * @param {Object} parenthesis
     * @private
     */
    function needParenthesis(node, parenthesis) {
      var precedence = operators.getPrecedence(node, parenthesis);
      var exprPrecedence = operators.getPrecedence(node.expr, parenthesis);

      return (parenthesis === 'all')
        || ((exprPrecedence !== null) && (exprPrecedence <= precedence));
    }

    /**
     * get string representation
     * @param {Object} options
     * @return {string} str
     */
    FunctionAssignmentNode.prototype._toString = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var expr = this.expr.toString(options);
      if (needParenthesis(this, parenthesis)) {
        expr = '(' + expr + ')';
      }
      return this.name + '(' + this.params.join(', ') + ') = ' + expr;
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    FunctionAssignmentNode.prototype.toJSON = function () {
      var types = this.types;

      return {
        mathjs: 'FunctionAssignmentNode',
        name: this.name,
        params: this.params.map(function(param, index) {
          return {
            name: param,
            type: types[index]
          }
        }),
        expr: this.expr
      };
    };

    /**
     * Instantiate an FunctionAssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "FunctionAssignmentNode", name: ..., params: ..., expr: ...}`,
     *                       where mathjs is optional
     * @returns {FunctionAssignmentNode}
     */
    FunctionAssignmentNode.fromJSON = function (json) {
      return new FunctionAssignmentNode(json.name, json.params, json.expr);
    };

    /**
     * get HTML representation
     * @param {Object} options
     * @return {string} str
     */
     FunctionAssignmentNode.prototype.toHTML = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
  	var params = [];
  	for (var i=0; i<this.params.length; i++)	{
  	  params.push('<span class="math-symbol math-parameter">' + escape$1(this.params[i]) + '</span>');
  	}
      var expr = this.expr.toHTML(options);
      if (needParenthesis(this, parenthesis)) {
        expr = '<span class="math-parenthesis math-round-parenthesis">(</span>' + expr + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }
      return '<span class="math-function">' + escape$1(this.name) + '</span>' + '<span class="math-parenthesis math-round-parenthesis">(</span>' + params.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + expr;
    };

    /**
     * get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    FunctionAssignmentNode.prototype._toTex = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var expr = this.expr.toTex(options);
      if (needParenthesis(this, parenthesis)) {
        expr = '\\left(' + expr + '\\right)';
      }

      return '\\mathrm{' + this.name
          + '}\\left(' + this.params.map(latex.toSymbol).join(',') + '\\right):=' + expr;
    };

    return FunctionAssignmentNode;
  }
  var name$47 = 'FunctionAssignmentNode';
  var path$22 = 'expression.node';
  var factory_1$52 = factory$53;

  var FunctionAssignmentNode = {
  	name: name$47,
  	path: path$22,
  	factory: factory_1$52
  };

  var stringify = string.stringify;
  var escape$2 = string.escape;
  var isSafeProperty$1 = customs.isSafeProperty;
  var hasOwnProperty$2 = object.hasOwnProperty;

  function factory$54 (type, config, load, typed) {
    var Node$$1 = load(Node);

    /**
     * @constructor ObjectNode
     * @extends {Node}
     * Holds an object with keys/values
     * @param {Object.<string, Node>} [properties]   object with key/value pairs
     */
    function ObjectNode(properties) {
      if (!(this instanceof ObjectNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      this.properties = properties || {};

      // validate input
      if (properties) {
        if (!(typeof properties === 'object') || !Object.keys(properties).every(function (key) {
              return type.isNode(properties[key]);
            })) {
          throw new TypeError('Object containing Nodes expected');
        }
      }
    }

    ObjectNode.prototype = new Node$$1();

    ObjectNode.prototype.type = 'ObjectNode';

    ObjectNode.prototype.isObjectNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    ObjectNode.prototype._compile = function (math, argNames) {
      var evalEntries = {};

      for (var key in this.properties) {
        if (hasOwnProperty$2(this.properties, key)) {
          // we stringify/parse the key here to resolve unicode characters,
          // so you cannot create a key like {"co\\u006Estructor": null} 
          var stringifiedKey = stringify(key);
          var parsedKey = JSON.parse(stringifiedKey);
          if (!isSafeProperty$1(this.properties, parsedKey)) {
            throw new Error('No access to property "' + parsedKey + '"');
          }

          evalEntries[parsedKey]= this.properties[key]._compile(math, argNames);
        }
      }

      return function evalObjectNode (scope, args, context) {
        var obj = {};

        for (var key in evalEntries) {
          if (hasOwnProperty$2(evalEntries, key)) {
            obj[key] = evalEntries[key](scope, args, context);
          }
        }

        return obj;
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    ObjectNode.prototype.forEach = function (callback) {
      for (var key in this.properties) {
        if (this.properties.hasOwnProperty(key)) {
          callback(this.properties[key], 'properties[' + stringify(key) + ']', this);
        }
      }
    };

    /**
     * Create a new ObjectNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ObjectNode} Returns a transformed copy of the node
     */
    ObjectNode.prototype.map = function (callback) {
      var properties = {};
      for (var key in this.properties) {
        if (this.properties.hasOwnProperty(key)) {
          properties[key] = this._ifNode(callback(this.properties[key],
              'properties[' + stringify(key) + ']', this));
        }
      }
      return new ObjectNode(properties);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {ObjectNode}
     */
    ObjectNode.prototype.clone = function() {
      var properties = {};
      for (var key in this.properties) {
        if (this.properties.hasOwnProperty(key)) {
          properties[key] = this.properties[key];
        }
      }
      return new ObjectNode(properties);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ObjectNode.prototype._toString = function(options) {
      var entries = [];
      for (var key in this.properties) {
        if (this.properties.hasOwnProperty(key)) {
          entries.push(stringify(key) + ': ' + this.properties[key].toString(options));
        }
      }
      return '{' + entries.join(', ') + '}';
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    ObjectNode.prototype.toJSON = function () {
      return {
        mathjs: 'ObjectNode',
        properties: this.properties
      };
    };

    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
     *                       where mathjs is optional
     * @returns {ObjectNode}
     */
    ObjectNode.fromJSON = function (json) {
      return new ObjectNode(json.properties);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ObjectNode.prototype.toHTML = function(options) {
      var entries = [];
      for (var key in this.properties) {
        if (this.properties.hasOwnProperty(key)) {
          entries.push('<span class="math-symbol math-property">' + escape$2(key) + '</span>' + '<span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[key].toHTML(options));
        }
      }
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + entries.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    ObjectNode.prototype._toTex = function(options) {
      var entries = [];
      for (var key in this.properties) {
        if (this.properties.hasOwnProperty(key)) {
          entries.push("\\mathbf{" + key + ':} & ' + this.properties[key].toTex(options) + "\\\\");
        }
      }
      return '\\left\\{\\begin{array}{ll}' + entries.join('\n') + '\\end{array}\\right\\}';
    };

    return ObjectNode;
  }

  var name$48 = 'ObjectNode';
  var path$23 = 'expression.node';
  var factory_1$53 = factory$54;

  var ObjectNode = {
  	name: name$48,
  	path: path$23,
  	factory: factory_1$53
  };

  var map$4 = array.map;
  var escape$3 = string.escape;
  var isSafeMethod$1 = customs.isSafeMethod;
  var getSafeProperty$5 = customs.getSafeProperty;


  function factory$55 (type, config, load, typed) {
    var Node$$1 = load(Node);

    /**
     * @constructor OperatorNode
     * @extends {Node}
     * An operator with two arguments, like 2+3
     *
     * @param {string} op           Operator name, for example '+'
     * @param {string} fn           Function name, for example 'add'
     * @param {Node[]} args         Operator arguments
     * @param {boolean} [implicit]  Is this an implicit multiplication?
     */
    function OperatorNode(op, fn, args, implicit) {
      if (!(this instanceof OperatorNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      //validate input
      if (typeof op !== 'string') {
        throw new TypeError('string expected for parameter "op"');
      }
      if (typeof fn !== 'string') {
        throw new TypeError('string expected for parameter "fn"');
      }
      if (!Array.isArray(args) || !args.every(type.isNode)) {
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      }

      this.implicit = (implicit === true);
      this.op = op;
      this.fn = fn;
      this.args = args || [];
    }

    OperatorNode.prototype = new Node$$1();

    OperatorNode.prototype.type = 'OperatorNode';

    OperatorNode.prototype.isOperatorNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    OperatorNode.prototype._compile = function (math, argNames) {
      // validate fn
      if (typeof this.fn !== 'string' || !isSafeMethod$1(math, this.fn)) {
        if (!math[this.fn]) {
          throw new Error('Function ' + this.fn + ' missing in provided namespace "math"');
        }
        else {
          throw new Error('No access to function "' + this.fn + '"');
        }
      }

      var fn = getSafeProperty$5(math, this.fn);
      var evalArgs = map$4(this.args, function (arg) {
        return arg._compile(math, argNames);
      });

      if (evalArgs.length === 1) {
        var evalArg0 = evalArgs[0];
        return function evalOperatorNode(scope, args, context) {
          return fn(evalArg0(scope, args, context));
        };
      }
      else if (evalArgs.length === 2) {
        var evalArg0 = evalArgs[0];
        var evalArg1 = evalArgs[1];
        return function evalOperatorNode(scope, args, context) {
          return fn(evalArg0(scope, args, context), evalArg1(scope, args, context))
        };
      }
      else {
        return function evalOperatorNode(scope, args, context) {
          return fn.apply(null, map$4(evalArgs, function (evalArg) {
            return evalArg(scope, args, context)
          }));
        };
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    OperatorNode.prototype.forEach = function (callback) {
      for (var i = 0; i < this.args.length; i++) {
        callback(this.args[i], 'args[' + i + ']', this);
      }
    };

    /**
     * Create a new OperatorNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    OperatorNode.prototype.map = function (callback) {
      var args = [];
      for (var i = 0; i < this.args.length; i++) {
        args[i] = this._ifNode(callback(this.args[i], 'args[' + i + ']', this));
      }
      return new OperatorNode(this.op, this.fn, args, this.implicit);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {OperatorNode}
     */
    OperatorNode.prototype.clone = function () {
      return new OperatorNode(this.op, this.fn, this.args.slice(0), this.implicit);
    };

    /**
     * Check whether this is an unary OperatorNode:
     * has exactly one argument, like `-a`.
     * @return {boolean} Returns true when an unary operator node, false otherwise.
     */
    OperatorNode.prototype.isUnary = function () {
      return this.args.length === 1;
    };

    /**
     * Check whether this is a binary OperatorNode:
     * has exactly two arguments, like `a + b`.
     * @return {boolean} Returns true when a binary operator node, false otherwise.
     */
    OperatorNode.prototype.isBinary = function () {
      return this.args.length === 2;
    };

    /**
     * Calculate which parentheses are necessary. Gets an OperatorNode
     * (which is the root of the tree) and an Array of Nodes
     * (this.args) and returns an array where 'true' means that an argument
     * has to be enclosed in parentheses whereas 'false' means the opposite.
     *
     * @param {OperatorNode} root
     * @param {string} parenthesis
     * @param {Node[]} args
     * @param {boolean} latex
     * @return {boolean[]}
     * @private
     */
    function calculateNecessaryParentheses(root, parenthesis, implicit, args, latex$$1) {
      //precedence of the root OperatorNode
      var precedence = operators.getPrecedence(root, parenthesis);
      var associativity = operators.getAssociativity(root, parenthesis);

      if ((parenthesis === 'all') || ((args.length > 2) && (root.getIdentifier() !== 'OperatorNode:add') && (root.getIdentifier() !== 'OperatorNode:multiply'))) {
        var parens = args.map(function (arg) {
          switch (arg.getContent().type) { //Nodes that don't need extra parentheses
            case 'ArrayNode':
            case 'ConstantNode':
            case 'SymbolNode':
            case 'ParenthesisNode':
              return false;
              break;
            default:
              return true;
          }
        });
        return parens;
      }

      var result = undefined;
      switch (args.length) {
        case 0:
          result = [];
          break;

        case 1: //unary operators
          //precedence of the operand
          var operandPrecedence = operators.getPrecedence(args[0], parenthesis);

          //handle special cases for LaTeX, where some of the parentheses aren't needed
          if (latex$$1 && (operandPrecedence !== null)) {
            var operandIdentifier;
            var rootIdentifier;
            if (parenthesis === 'keep') {
              operandIdentifier = args[0].getIdentifier();
              rootIdentifier = root.getIdentifier();
            }
            else {
              //Ignore Parenthesis Nodes when not in 'keep' mode
              operandIdentifier = args[0].getContent().getIdentifier();
              rootIdentifier = root.getContent().getIdentifier();
            }
            if (operators.properties[precedence][rootIdentifier].latexLeftParens === false) {
              result = [false];
              break;
            }

            if (operators.properties[operandPrecedence][operandIdentifier].latexParens === false) {
              result = [false];
              break;
            }
          }

          if (operandPrecedence === null) {
            //if the operand has no defined precedence, no parens are needed
            result = [false];
            break;
          }

          if (operandPrecedence <= precedence) {
            //if the operands precedence is lower, parens are needed
            result = [true];
            break;
          }

          //otherwise, no parens needed
          result = [false];
          break;

        case 2: //binary operators
          var lhsParens; //left hand side needs parenthesis?
          //precedence of the left hand side
          var lhsPrecedence = operators.getPrecedence(args[0], parenthesis);
          //is the root node associative with the left hand side
          var assocWithLhs = operators.isAssociativeWith(root, args[0], parenthesis);

          if (lhsPrecedence === null) {
            //if the left hand side has no defined precedence, no parens are needed
            //FunctionNode for example
            lhsParens = false;
          }
          else if ((lhsPrecedence === precedence) && (associativity === 'right') && !assocWithLhs) {
            //In case of equal precedence, if the root node is left associative
            // parens are **never** necessary for the left hand side.
            //If it is right associative however, parens are necessary
            //if the root node isn't associative with the left hand side
            lhsParens = true;
          }
          else if (lhsPrecedence < precedence) {
            lhsParens = true;
          }
          else {
            lhsParens = false;
          }

          var rhsParens; //right hand side needs parenthesis?
          //precedence of the right hand side
          var rhsPrecedence = operators.getPrecedence(args[1], parenthesis);
          //is the root node associative with the right hand side?
          var assocWithRhs = operators.isAssociativeWith(root, args[1], parenthesis);

          if (rhsPrecedence === null) {
            //if the right hand side has no defined precedence, no parens are needed
            //FunctionNode for example
            rhsParens = false;
          }
          else if ((rhsPrecedence === precedence) && (associativity === 'left') && !assocWithRhs) {
            //In case of equal precedence, if the root node is right associative
            // parens are **never** necessary for the right hand side.
            //If it is left associative however, parens are necessary
            //if the root node isn't associative with the right hand side
            rhsParens = true;
          }
          else if (rhsPrecedence < precedence) {
            rhsParens = true;
          }
          else {
            rhsParens = false;
          }

          //handle special cases for LaTeX, where some of the parentheses aren't needed
          if (latex$$1) {
            var rootIdentifier;
            var lhsIdentifier;
            var rhsIdentifier;
            if (parenthesis === 'keep') {
              rootIdentifier = root.getIdentifier();
              lhsIdentifier = root.args[0].getIdentifier();
              rhsIdentifier = root.args[1].getIdentifier();
            }
            else {
              //Ignore ParenthesisNodes when not in 'keep' mode
              rootIdentifier = root.getContent().getIdentifier();
              lhsIdentifier = root.args[0].getContent().getIdentifier();
              rhsIdentifier = root.args[1].getContent().getIdentifier();
            }

            if (lhsPrecedence !== null) {
              if (operators.properties[precedence][rootIdentifier].latexLeftParens === false) {
                lhsParens = false;
              }

              if (operators.properties[lhsPrecedence][lhsIdentifier].latexParens === false) {
                lhsParens = false;
              }
            }

            if (rhsPrecedence !== null) {
              if (operators.properties[precedence][rootIdentifier].latexRightParens === false) {
                rhsParens = false;
              }

              if (operators.properties[rhsPrecedence][rhsIdentifier].latexParens === false) {
                rhsParens = false;
              }
            }
          }

          result = [lhsParens, rhsParens];
          break;

        default:
          if ((root.getIdentifier() === 'OperatorNode:add') || (root.getIdentifier() === 'OperatorNode:multiply')) {
            var result = args.map(function (arg) {
              var argPrecedence = operators.getPrecedence(arg, parenthesis);
              var assocWithArg = operators.isAssociativeWith(root, arg, parenthesis);
              var argAssociativity = operators.getAssociativity(arg, parenthesis);
              if (argPrecedence === null) {
                //if the argument has no defined precedence, no parens are needed
                return false;
              } else if ((precedence === argPrecedence) && (associativity === argAssociativity) && !assocWithArg) {
                return true;
              } else if (argPrecedence < precedence) {
                return true;
              }

              return false;
            });
          }
          break;
      }

      //handles an edge case of 'auto' parentheses with implicit multiplication of ConstantNode
      //In that case print parentheses for ParenthesisNodes even though they normally wouldn't be
      //printed.
      if ((args.length >= 2) && (root.getIdentifier() === 'OperatorNode:multiply') && root.implicit && (parenthesis === 'auto') && (implicit === 'hide')) {
        result = args.map(function (arg, index) {
          var isParenthesisNode = (arg.getIdentifier() === 'ParenthesisNode');
          if (result[index] || isParenthesisNode) { //put in parenthesis?
            return true;
          }

          return false;
        });
      }

      return result;
    }

    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    OperatorNode.prototype._toString = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var implicit = (options && options.implicit) ? options.implicit : 'hide';
      var args = this.args;
      var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);

      if (args.length === 1) { //unary operators
        var assoc = operators.getAssociativity(this, parenthesis);

        var operand = args[0].toString(options);
        if (parens[0]) {
          operand = '(' + operand + ')';
        }

        if (assoc === 'right') { //prefix operator
          return this.op + operand;
        }
        else if (assoc === 'left') { //postfix
          return operand + this.op;
        }

        //fall back to postfix
        return operand + this.op;
      } else if (args.length == 2) {
        var lhs = args[0].toString(options); //left hand side
        var rhs = args[1].toString(options); //right hand side
        if (parens[0]) { //left hand side in parenthesis?
          lhs = '(' + lhs + ')';
        }
        if (parens[1]) { //right hand side in parenthesis?
          rhs = '(' + rhs + ')';
        }

        if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit == 'hide')) {
          return lhs + ' ' + rhs;
        }

        return lhs + ' ' + this.op + ' ' + rhs;
      } else if ((args.length > 2) && ((this.getIdentifier() === 'OperatorNode:add') || (this.getIdentifier() === 'OperatorNode:multiply'))) {
        var stringifiedArgs = args.map(function (arg, index) {
          arg = arg.toString(options);
          if (parens[index]) { //put in parenthesis?
            arg = '(' + arg + ')';
          }

          return arg;
        });

        if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit === 'hide')) {
          return stringifiedArgs.join(' ');
        }

        return stringifiedArgs.join(' ' + this.op + ' ');
      } else {
        //fallback to formatting as a function call
        return this.fn + '(' + this.args.join(', ') + ')';
      }
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    OperatorNode.prototype.toJSON = function () {
      return {
        mathjs: 'OperatorNode',
        op: this.op,
        fn: this.fn,
        args: this.args,
        implicit: this.implicit
      };
    };

    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "OperatorNode", "op": "+", "fn": "add", "args": [...], "implicit": false}`,
     *                       where mathjs is optional
     * @returns {OperatorNode}
     */
    OperatorNode.fromJSON = function (json) {
      return new OperatorNode(json.op, json.fn, json.args, json.implicit);
    };

    /**
     * Get HTML representation.
     * @param {Object} options
     * @return {string} str
     */
    OperatorNode.prototype.toHTML = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var implicit = (options && options.implicit) ? options.implicit : 'hide';
      var args = this.args;
      var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, false);

      if (args.length === 1) { //unary operators
        var assoc = operators.getAssociativity(this, parenthesis);

        var operand = args[0].toHTML(options);
        if (parens[0]) {
          operand = '<span class="math-parenthesis math-round-parenthesis">(</span>' + operand + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        }

        if (assoc === 'right') { //prefix operator
          return '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + escape$3(this.op) + '</span>' + operand;
        }
        else if (assoc === 'left') { //postfix
          return '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape$3(this.op) + '</span>' + operand;
        }

        //fall back to postfix
        return '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape$3(this.op) + '</span>' + operand;
      }
  	else if (args.length == 2) { // binary operatoes
        var lhs = args[0].toHTML(options); //left hand side
        var rhs = args[1].toHTML(options); //right hand side
        if (parens[0]) { //left hand side in parenthesis?
          lhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + lhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        }
        if (parens[1]) { //right hand side in parenthesis?
          rhs = '<span class="math-parenthesis math-round-parenthesis">(</span>' + rhs + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        }
  	  
  	  if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit == 'hide')) {
  	    return lhs + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + rhs;
  	  }
        
  	  return lhs + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$3(this.op) + '</span>' + rhs;
      }
  	else if ((args.length > 2) && ((this.getIdentifier() === 'OperatorNode:add') || (this.getIdentifier() === 'OperatorNode:multiply'))) {
        var stringifiedArgs = args.map(function (arg, index) {
          arg = arg.toHTML(options);
          if (parens[index]) { //put in parenthesis?
            arg = '<span class="math-parenthesis math-round-parenthesis">(</span>' + arg + '<span class="math-parenthesis math-round-parenthesis">)</span>';
          }

          return arg;
        });

        if (this.implicit && (this.getIdentifier() === 'OperatorNode:multiply') && (implicit === 'hide')) {
          return stringifiedArgs.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>');
        }

        return stringifiedArgs.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$3(this.op) + '</span>');
      } else {
        //fallback to formatting as a function call
        return '<span class="math-function">' + escape$3(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + stringifiedArgs.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
      }
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    OperatorNode.prototype._toTex = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var implicit = (options && options.implicit) ? options.implicit : 'hide';
      var args = this.args;
      var parens = calculateNecessaryParentheses(this, parenthesis, implicit, args, true);
      var op = latex.operators[this.fn];
      op = typeof op === 'undefined' ? this.op : op; //fall back to using this.op

      if (args.length === 1) { //unary operators
        var assoc = operators.getAssociativity(this, parenthesis);

        var operand = args[0].toTex(options);
        if (parens[0]) {
          operand = '\\left(' + operand + '\\right)';
        }

        if (assoc === 'right') { //prefix operator
          return op + operand;
        }
        else if (assoc === 'left') { //postfix operator
          return operand + op;
        }

        //fall back to postfix
        return operand + op;
      } else if (args.length === 2) { //binary operators
        var lhs = args[0]; //left hand side
        var lhsTex = lhs.toTex(options);
        if (parens[0]) {
          lhsTex = '\\left(' + lhsTex + '\\right)';
        }

        var rhs = args[1]; //right hand side
        var rhsTex = rhs.toTex(options);
        if (parens[1]) {
          rhsTex = '\\left(' + rhsTex + '\\right)';
        }

        //handle some exceptions (due to the way LaTeX works)
        var lhsIdentifier;
        if (parenthesis === 'keep') {
          lhsIdentifier = lhs.getIdentifier();
        }
        else {
          //Ignore ParenthesisNodes if in 'keep' mode
          lhsIdentifier = lhs.getContent().getIdentifier();
        }
        switch (this.getIdentifier()) {
          case 'OperatorNode:divide':
            //op contains '\\frac' at this point
            return op + '{' + lhsTex + '}' + '{' + rhsTex + '}';
          case 'OperatorNode:pow':
            lhsTex = '{' + lhsTex + '}';
            rhsTex = '{' + rhsTex + '}';
            switch (lhsIdentifier) {
              case 'ConditionalNode': //
              case 'OperatorNode:divide':
                lhsTex = '\\left(' + lhsTex + '\\right)';
            }
          case 'OperatorNode:multiply':
            if (this.implicit && (implicit === 'hide')) {
              return lhsTex + '~' + rhsTex;
            }
        }
        return lhsTex + op + rhsTex;
      } else if ((args.length > 2) && ((this.getIdentifier() === 'OperatorNode:add') || (this.getIdentifier() === 'OperatorNode:multiply'))) {
        var texifiedArgs = args.map(function (arg, index) {
          arg = arg.toTex(options);
          if (parens[index]) {
            arg = '\\left(' + arg + '\\right)';
          }
          return arg;
        });

        if ((this.getIdentifier() === 'OperatorNode:multiply') && this.implicit) {
          return texifiedArgs.join('~');
        }

        return texifiedArgs.join(op)
      } else {
        //fall back to formatting as a function call
        //as this is a fallback, it doesn't use
        //fancy function names
        return '\\mathrm{' + this.fn + '}\\left('
            + args.map(function (arg) {
              return arg.toTex(options);
            }).join(',') + '\\right)';
      }
    };

    /**
     * Get identifier.
     * @return {string}
     */
    OperatorNode.prototype.getIdentifier = function () {
      return this.type + ':' + this.fn;
    };

    return OperatorNode;
  }

  var name$49 = 'OperatorNode';
  var path$24 = 'expression.node';
  var factory_1$54 = factory$55;

  var OperatorNode = {
  	name: name$49,
  	path: path$24,
  	factory: factory_1$54
  };

  function factory$56 (type, config, load, typed) {
    var Node$$1 = load(Node);

    /**
     * @constructor ParenthesisNode
     * @extends {Node}
     * A parenthesis node describes manual parenthesis from the user input
     * @param {Node} content
     * @extends {Node}
     */
    function ParenthesisNode(content) {
      if (!(this instanceof ParenthesisNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      // validate input
      if (!type.isNode(content)) {
        throw new TypeError('Node expected for parameter "content"');
      }

      this.content = content;
    }

    ParenthesisNode.prototype = new Node$$1();

    ParenthesisNode.prototype.type = 'ParenthesisNode';

    ParenthesisNode.prototype.isParenthesisNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    ParenthesisNode.prototype._compile = function (math, argNames) {
      return this.content._compile(math, argNames);
    };

    /**
     * Get the content of the current Node.
     * @return {Node} content
     * @override
     **/
    ParenthesisNode.prototype.getContent = function () {
      return this.content.getContent();
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    ParenthesisNode.prototype.forEach = function (callback) {
      callback(this.content, 'content', this);
    };

    /**
     * Create a new ParenthesisNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ParenthesisNode} Returns a clone of the node
     */
    ParenthesisNode.prototype.map = function (callback) {
      var content = callback(this.content, 'content', this);
      return new ParenthesisNode(content);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {ParenthesisNode}
     */
    ParenthesisNode.prototype.clone = function() {
      return new ParenthesisNode(this.content);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ParenthesisNode.prototype._toString = function(options) {
      if ((!options) || (options && !options.parenthesis) || (options && options.parenthesis === 'keep')) {
        return '(' + this.content.toString(options) + ')';
      }
      return this.content.toString(options);
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    ParenthesisNode.prototype.toJSON = function () {
      return {
        mathjs: 'ParenthesisNode',
        content: this.content
      };
    };

    /**
     * Instantiate an ParenthesisNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
     *                       where mathjs is optional
     * @returns {ParenthesisNode}
     */
    ParenthesisNode.fromJSON = function (json) {
      return new ParenthesisNode(json.content);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ParenthesisNode.prototype.toHTML = function(options) {
      if ((!options) || (options && !options.parenthesis) || (options && options.parenthesis === 'keep')) {
        return '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(options) + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }
      return this.content.toHTML(options);
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    ParenthesisNode.prototype._toTex = function(options) {
      if ((!options) || (options && !options.parenthesis) || (options && options.parenthesis === 'keep')) {
        return '\\left(' + this.content.toTex(options) + '\\right)';
      }
      return this.content.toTex(options);
    };

    return ParenthesisNode;
  }

  var name$50 = 'ParenthesisNode';
  var path$25 = 'expression.node';
  var factory_1$55 = factory$56;

  var ParenthesisNode = {
  	name: name$50,
  	path: path$25,
  	factory: factory_1$55
  };

  var escape$4 = string.escape;
  var hasOwnProperty$3 = object.hasOwnProperty;
  var getSafeProperty$6 = customs.getSafeProperty;

  function factory$57 (type, config, load, typed, math) {
    var Node$$1 = load(Node);

    /**
     * Check whether some name is a valueless unit like "inch".
     * @param {string} name
     * @return {boolean}
     */
    function isValuelessUnit (name) {
      return type.Unit ? type.Unit.isValuelessUnit(name) : false;
    }

    /**
     * @constructor SymbolNode
     * @extends {Node}
     * A symbol node can hold and resolve a symbol
     * @param {string} name
     * @extends {Node}
     */
    function SymbolNode(name) {
      if (!(this instanceof SymbolNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      // validate input
      if (typeof name !== 'string')  throw new TypeError('String expected for parameter "name"');

      this.name = name;
    }

    SymbolNode.prototype = new Node$$1();

    SymbolNode.prototype.type = 'SymbolNode';

    SymbolNode.prototype.isSymbolNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    SymbolNode.prototype._compile = function (math, argNames) {
      var name = this.name;

      if (hasOwnProperty$3(argNames, name)) {
        // this is a FunctionAssignment argument
        // (like an x when inside the expression of a function assignment `f(x) = ...`)
        return function (scope, args, context) {
          return args[name];
        }
      }
      else if (name in math) {
        return function (scope, args, context) {
          return name in scope 
            ? getSafeProperty$6(scope, name) 
            : getSafeProperty$6(math, name);
        }
      }
      else {
        var isUnit = isValuelessUnit(name);

        return function (scope, args, context) {
          return name in scope 
            ? getSafeProperty$6(scope, name) 
            : isUnit 
              ? new type.Unit(null, name)
              : undef(name);
        }
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    SymbolNode.prototype.forEach = function (callback) {
      // nothing to do, we don't have childs
    };

    /**
     * Create a new SymbolNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {SymbolNode} Returns a clone of the node
     */
    SymbolNode.prototype.map = function (callback) {
      return this.clone();
    };

    /**
     * Throws an error 'Undefined symbol {name}'
     * @param {string} name
     */
    function undef (name) {
      throw new Error('Undefined symbol ' + name);
    }

    /**
     * Create a clone of this node, a shallow copy
     * @return {SymbolNode}
     */
    SymbolNode.prototype.clone = function() {
      return new SymbolNode(this.name);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    SymbolNode.prototype._toString = function(options) {
      return this.name;
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    SymbolNode.prototype.toHTML = function(options) {
  	var name = escape$4(this.name);
  	
      if (name == "true" || name == "false") {
  	  return '<span class="math-symbol math-boolean">' + name + '</span>';
  	}
  	else if (name == "i") {
  	  return '<span class="math-symbol math-imaginary-symbol">' + name + '</span>';
  	}
  	else if (name == "Infinity") {
  	  return '<span class="math-symbol math-infinity-symbol">' + name + '</span>';
  	}
  	else if (name == "NaN") {
  	  return '<span class="math-symbol math-nan-symbol">' + name + '</span>';
  	}
  	else if (name == "null") {
  	  return '<span class="math-symbol math-null-symbol">' + name + '</span>';
  	}
  	else if (name == "undefined") {
  	  return '<span class="math-symbol math-undefined-symbol">' + name + '</span>';
  	}
  	
  	return '<span class="math-symbol">' + name + '</span>';
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    SymbolNode.prototype.toJSON = function () {
      return {
        mathjs: 'SymbolNode',
        name: this.name
      };
    };

    /**
     * Instantiate a SymbolNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", name: "x"}`,
     *                       where mathjs is optional
     * @returns {SymbolNode}
     */
    SymbolNode.fromJSON = function (json) {
      return new SymbolNode(json.name);
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    SymbolNode.prototype._toTex = function(options) {
      var isUnit = false;
      if ((typeof math[this.name] === 'undefined') && isValuelessUnit(this.name)) {
        isUnit = true;
      }
      var symbol = latex.toSymbol(this.name, isUnit);
      if (symbol[0] === '\\') {
        //no space needed if the symbol starts with '\'
        return symbol;
      }
      //the space prevents symbols from breaking stuff like '\cdot' if it's written right before the symbol
      return ' ' + symbol;
    };

    return SymbolNode;
  }

  var name$51 = 'SymbolNode';
  var path$26 = 'expression.node';
  var math$7 = true; // request access to the math namespace as 5th argument of the factory function
  var factory_1$56 = factory$57;

  var SymbolNode = {
  	name: name$51,
  	path: path$26,
  	math: math$7,
  	factory: factory_1$56
  };

  var latex$1 = latex;
  var escape$5 = string.escape;
  var hasOwnProperty$4 = object.hasOwnProperty;
  var map$5 = array.map;
  var validateSafeMethod$1 = customs.validateSafeMethod;
  var getSafeProperty$7 = customs.getSafeProperty;

  function factory$58 (type, config, load, typed, math) {
    var Node$$1 = load(Node);
    var SymbolNode$$1 = load(SymbolNode);

    /**
     * @constructor FunctionNode
     * @extends {./Node}
     * invoke a list with arguments on a node
     * @param {./Node | string} fn Node resolving with a function on which to invoke
     *                             the arguments, typically a SymboNode or AccessorNode
     * @param {./Node[]} args
     */
    function FunctionNode(fn, args) {
      if (!(this instanceof FunctionNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      if (typeof fn === 'string') {
        fn = new SymbolNode$$1(fn);
      }

      // validate input
      if (!type.isNode(fn)) throw new TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(args) || !args.every(type.isNode)) {
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      }

      this.fn = fn;
      this.args = args || [];

      // readonly property name
      Object.defineProperty(this, 'name', {
        get: function () {
          return this.fn.name || '';
        }.bind(this),
        set: function () {
          throw new Error('Cannot assign a new name, name is read-only');
        }
      });

      // TODO: deprecated since v3, remove some day
      var deprecated = function () {
        throw new Error('Property `FunctionNode.object` is deprecated, use `FunctionNode.fn` instead');
      };
      Object.defineProperty(this, 'object', { get: deprecated, set: deprecated });
    }

    FunctionNode.prototype = new Node$$1();

    FunctionNode.prototype.type = 'FunctionNode';

    FunctionNode.prototype.isFunctionNode = true;

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    FunctionNode.prototype._compile = function (math, argNames) {
      if (!(this instanceof FunctionNode)) {
        throw new TypeError('No valid FunctionNode')
      }

      // compile arguments
      var evalArgs = map$5(this.args, function (arg) {
        return arg._compile(math, argNames);
      });

      if (type.isSymbolNode(this.fn)) {
        // we can statically determine whether the function has an rawArgs property
        var name = this.fn.name;
        var fn = name in math ? getSafeProperty$7(math, name) : undefined;
        var isRaw = (typeof fn === 'function') && (fn.rawArgs == true);

        if (isRaw) {
          // pass unevaluated parameters (nodes) to the function
          // "raw" evaluation
          var rawArgs = this.args;
          return function evalFunctionNode(scope, args, context) {
            return (name in scope ? getSafeProperty$7(scope, name) : fn)(rawArgs, math, scope);
          };
        }
        else {
          // "regular" evaluation
          if (evalArgs.length === 1) {
            var evalArg0 = evalArgs[0];
            return function evalFunctionNode(scope, args, context) {
              return (name in scope ? getSafeProperty$7(scope, name) : fn)(evalArg0(scope, args, context));
            };
          }
          else if (evalArgs.length === 2) {
            var evalArg0 = evalArgs[0];
            var evalArg1 = evalArgs[1];
            return function evalFunctionNode(scope, args, context) {
              return (name in scope ? getSafeProperty$7(scope, name) : fn)(evalArg0(scope, args, context), evalArg1(scope, args, context));
            };
          }
          else {
            return function evalFunctionNode(scope, args, context) {
              return (name in scope ? getSafeProperty$7(scope, name) : fn).apply(null, map$5(evalArgs, function (evalArg) {
                return evalArg(scope, args, context);
              }));
            }
          }
        }
      }
      else if (type.isAccessorNode(this.fn) &&
          type.isIndexNode(this.fn.index) && this.fn.index.isObjectProperty()) {
        // execute the function with the right context: the object of the AccessorNode

        var evalObject = this.fn.object._compile(math, argNames);
        var prop = this.fn.index.getObjectProperty();
        var rawArgs = this.args;

        return function evalFunctionNode (scope, args, context) {
          var object$$1 = evalObject(scope, args, context);
          validateSafeMethod$1(object$$1, prop);
          var isRaw = object$$1[prop] && object$$1[prop].rawArgs;

          return isRaw 
            ? object$$1[prop](rawArgs, math, scope)                             // "raw" evaluation
            : object$$1[prop].apply(object$$1, map$5(evalArgs, function (evalArg) {  // "regular" evaluation
                return evalArg(scope, args, context);
              }));
        }
      }
      else { // node.fn.isAccessorNode && !node.fn.index.isObjectProperty()
        // we have to dynamically determine whether the function has a rawArgs property
        var evalFn = this.fn._compile(math, argNames);

        return function evalFunctionNode (scope, args, context) {
          var fn = evalFn(scope, args, context);
          var isRaw = fn && fn.rawArgs;

          return isRaw 
            ? fn(rawArgs, math, scope)                         // "raw" evaluation
            : fn.apply(fn, map$5(evalArgs, function (evalArg) {  // "regular" evaluation
                return evalArg(scope, args, context);
              }));
        };
      }
    };
    
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    FunctionNode.prototype.forEach = function (callback) {
      for (var i = 0; i < this.args.length; i++) {
        callback(this.args[i], 'args[' + i + ']', this);
      }
    };

    /**
     * Create a new FunctionNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionNode} Returns a transformed copy of the node
     */
    FunctionNode.prototype.map = function (callback) {
      var fn = this.fn.map(callback);
      var args = [];
      for (var i = 0; i < this.args.length; i++) {
        args[i] = this._ifNode(callback(this.args[i], 'args[' + i + ']', this));
      }
      return new FunctionNode(fn, args);
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionNode}
     */
    FunctionNode.prototype.clone = function () {
      return new FunctionNode(this.fn, this.args.slice(0));
    };

    //backup Node's toString function
    //@private
    var nodeToString = FunctionNode.prototype.toString;

    /**
     * Get string representation. (wrapper function)
     * This overrides parts of Node's toString function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toString
     * function.
     *
     * @param {Object} options
     * @return {string} str
     * @override
     */
    FunctionNode.prototype.toString = function (options) {
      var customString;
      var name = this.fn.toString(options);
      if (options && (typeof options.handler === 'object') && hasOwnProperty$4(options.handler, name)) {
        //callback is a map of callback functions
        customString = options.handler[name](this, options);
      }

      if (typeof customString !== 'undefined') {
        return customString;
      }

      //fall back to Node's toString
      return nodeToString.call(this, options);
    };

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    FunctionNode.prototype._toString = function (options) {
      var args = this.args.map(function (arg) {
        return arg.toString(options);
      });

      var fn = type.isFunctionAssignmentNode(this.fn)
          ? ('(' + this.fn.toString(options) + ')')
          : this.fn.toString(options);

      // format the arguments like "add(2, 4.2)"
      return fn + '(' + args.join(', ') + ')';
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    FunctionNode.prototype.toJSON = function () {
      return {
        mathjs: 'FunctionNode',
        fn: this.fn,
        args: this.args
      };
    };

    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
     *                       where mathjs is optional
     * @returns {FunctionNode}
     */
    FunctionNode.fromJSON = function (json) {
      return new FunctionNode(json.fn, json.args);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    FunctionNode.prototype.toHTML = function (options) {
      var args = this.args.map(function (arg) {
        return arg.toHTML(options);
      });

      // format the arguments like "add(2, 4.2)"
      return '<span class="math-function">' + escape$5(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + args.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    };

    /*
     * Expand a LaTeX template
     *
     * @param {string} template
     * @param {Node} node
     * @param {Object} options
     * @private
     **/
    function expandTemplate(template, node, options) {
      var latex$$1 = '';

      // Match everything of the form ${identifier} or ${identifier[2]} or $$
      // while submatching identifier and 2 (in the second case)
      var regex = new RegExp('\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)', 'ig');

      var inputPos = 0;   //position in the input string
      var match;
      while ((match = regex.exec(template)) !== null) {   //go through all matches
        // add everything in front of the match to the LaTeX string
        latex$$1 += template.substring(inputPos, match.index);
        inputPos = match.index;

        if (match[0] === '$$') { // escaped dollar sign
          latex$$1 += '$';
          inputPos++;
        }
        else { // template parameter
          inputPos += match[0].length;
          var property = node[match[1]];
          if (!property) {
            throw new ReferenceError('Template: Property ' + match[1] + ' does not exist.');
          }
          if (match[2] === undefined) { //no square brackets
            switch (typeof property) {
              case 'string':
                latex$$1 += property;
                break;
              case 'object':
                if (type.isNode(property)) {
                  latex$$1 += property.toTex(options);
                }
                else if (Array.isArray(property)) {
                  //make array of Nodes into comma separated list
                  latex$$1 += property.map(function (arg, index) {
                    if (type.isNode(arg)) {
                      return arg.toTex(options);
                    }
                    throw new TypeError('Template: ' + match[1] + '[' + index + '] is not a Node.');
                  }).join(',');
                }
                else {
                  throw new TypeError('Template: ' + match[1] + ' has to be a Node, String or array of Nodes');
                }
                break;
              default:
                throw new TypeError('Template: ' + match[1] + ' has to be a Node, String or array of Nodes');
            }
          }
          else { //with square brackets
            if (type.isNode(property[match[2]] && property[match[2]])) {
              latex$$1 += property[match[2]].toTex(options);
            }
            else {
              throw new TypeError('Template: ' + match[1] + '[' + match[2] + '] is not a Node.');
            }
          }
        }
      }
      latex$$1 += template.slice(inputPos);  //append rest of the template

      return latex$$1;
    }

    //backup Node's toTex function
    //@private
    var nodeToTex = FunctionNode.prototype.toTex;

    /**
     * Get LaTeX representation. (wrapper function)
     * This overrides parts of Node's toTex function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toTex
     * function.
     *
     * @param {Object} options
     * @return {string}
     */
    FunctionNode.prototype.toTex = function (options) {
      var customTex;
      if (options && (typeof options.handler === 'object') && hasOwnProperty$4(options.handler, this.name)) {
        //callback is a map of callback functions
        customTex = options.handler[this.name](this, options);
      }

      if (typeof customTex !== 'undefined') {
        return customTex;
      }

      //fall back to Node's toTex
      return nodeToTex.call(this, options);
    };

    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    FunctionNode.prototype._toTex = function (options) {
      var args = this.args.map(function (arg) { //get LaTeX of the arguments
        return arg.toTex(options);
      });

      var latexConverter;

      if (math[this.name] && ((typeof math[this.name].toTex === 'function') || (typeof math[this.name].toTex === 'object') || (typeof math[this.name].toTex === 'string'))) {
        //.toTex is a callback function
        latexConverter = math[this.name].toTex;
      }

      var customToTex;
      switch (typeof latexConverter) {
        case 'function': //a callback function
          customToTex = latexConverter(this, options);
          break;
        case 'string': //a template string
          customToTex = expandTemplate(latexConverter, this, options);
          break;
        case 'object': //an object with different "converters" for different numbers of arguments
          switch (typeof latexConverter[args.length]) {
            case 'function':
              customToTex = latexConverter[args.length](this, options);
              break;
            case 'string':
              customToTex = expandTemplate(latexConverter[args.length], this, options);
              break;
          }
      }

      if (typeof customToTex !== 'undefined') {
        return customToTex;
      }

      return expandTemplate(latex$1.defaultTemplate, this, options);
    };

    /**
     * Get identifier.
     * @return {string}
     */
    FunctionNode.prototype.getIdentifier = function () {
      return this.type + ':' + this.name;
    };

    return FunctionNode;
  }

  var name$52 = 'FunctionNode';
  var path$27 = 'expression.node';
  var math$8 = true; // request access to the math namespace as 5th argument of the factory function
  var factory_1$57 = factory$58;

  var FunctionNode = {
  	name: name$52,
  	path: path$27,
  	math: math$8,
  	factory: factory_1$57
  };

  function factory$59 (type, config, load, typed) {
    var Node$$1 = load(Node);

    /**
     * @constructor RangeNode
     * @extends {Node}
     * create a range
     * @param {Node} start  included lower-bound
     * @param {Node} end    included upper-bound
     * @param {Node} [step] optional step
     */
    function RangeNode(start, end, step) {
      if (!(this instanceof RangeNode)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      // validate inputs
      if (!type.isNode(start)) throw new TypeError('Node expected');
      if (!type.isNode(end)) throw new TypeError('Node expected');
      if (step && !type.isNode(step)) throw new TypeError('Node expected');
      if (arguments.length > 3) throw new Error('Too many arguments');

      this.start = start;         // included lower-bound
      this.end = end;           // included upper-bound
      this.step = step || null;  // optional step
    }

    RangeNode.prototype = new Node$$1();

    RangeNode.prototype.type = 'RangeNode';

    RangeNode.prototype.isRangeNode = true;

    /**
     * Check whether the RangeNode needs the `end` symbol to be defined.
     * This end is the size of the Matrix in current dimension.
     * @return {boolean}
     */
    RangeNode.prototype.needsEnd = function () {
      // find all `end` symbols in this RangeNode
      var endSymbols = this.filter(function (node) {
        return type.isSymbolNode(node) && (node.name === 'end');
      });

      return endSymbols.length > 0;
    };

    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants. 
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    RangeNode.prototype._compile = function (math, argNames) {
      var range = math.range;
      var evalStart = this.start._compile(math, argNames);
      var evalEnd = this.end._compile(math, argNames);

      if (this.step) {
        var evalStep = this.step._compile(math, argNames);
        
        return function evalRangeNode(scope, args, context) {
          return range(
            evalStart(scope, args, context), 
            evalEnd(scope, args, context), 
            evalStep(scope, args, context)
          );
        }
      }
      else {
        return function evalRangeNode(scope, args, context) {
          return range(
            evalStart(scope, args, context), 
            evalEnd(scope, args, context)
          );
        }
      }
    };

    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    RangeNode.prototype.forEach = function (callback) {
      callback(this.start, 'start', this);
      callback(this.end, 'end', this);
      if (this.step) {
        callback(this.step, 'step', this);
      }
    };

    /**
     * Create a new RangeNode having it's childs be the results of calling
     * the provided callback function for each of the childs of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RangeNode} Returns a transformed copy of the node
     */
    RangeNode.prototype.map = function (callback) {
      return new RangeNode(
          this._ifNode(callback(this.start, 'start', this)),
          this._ifNode(callback(this.end, 'end', this)),
          this.step && this._ifNode(callback(this.step, 'step', this))
      );
    };

    /**
     * Create a clone of this node, a shallow copy
     * @return {RangeNode}
     */
    RangeNode.prototype.clone = function () {
      return new RangeNode(this.start, this.end, this.step && this.step);
    };

    /**
     * Calculate the necessary parentheses
     * @param {Node} node
     * @param {string} parenthesis
     * @return {Object} parentheses
     * @private
     */
    function calculateNecessaryParentheses(node, parenthesis) {
      var precedence = operators.getPrecedence(node, parenthesis);
      var parens = {};

      var startPrecedence = operators.getPrecedence(node.start, parenthesis);
      parens.start = ((startPrecedence !== null) && (startPrecedence <= precedence))
        || (parenthesis === 'all');

      if (node.step) {
        var stepPrecedence = operators.getPrecedence(node.step, parenthesis);
        parens.step = ((stepPrecedence !== null) && (stepPrecedence <= precedence))
          || (parenthesis === 'all');
      }

      var endPrecedence = operators.getPrecedence(node.end, parenthesis);
      parens.end = ((endPrecedence !== null) && (endPrecedence <= precedence))
        || (parenthesis === 'all');

      return parens;
    }

    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    RangeNode.prototype._toString = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var parens = calculateNecessaryParentheses(this, parenthesis);

      //format string as start:step:stop
      var str;

      var start = this.start.toString(options);
      if (parens.start) {
        start = '(' + start + ')';
      }
      str = start;

      if (this.step) {
        var step = this.step.toString(options);
        if (parens.step) {
          step = '(' + step + ')';
        }
        str += ':' + step;
      }

      var end = this.end.toString(options);
      if (parens.end) {
        end = '(' + end + ')';
      }
      str += ':' + end;

      return str;
    };

    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    RangeNode.prototype.toJSON = function () {
      return {
        mathjs: 'RangeNode',
        start: this.start,
        end: this.end,
        step: this.step
      };
    };

    /**
     * Instantiate an RangeNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
     *                       where mathjs is optional
     * @returns {RangeNode}
     */
    RangeNode.fromJSON = function (json) {
      return new RangeNode(json.start, json.end, json.step);
    };

    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    RangeNode.prototype.toHTML = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var parens = calculateNecessaryParentheses(this, parenthesis);

      //format string as start:step:stop
      var str;

      var start = this.start.toHTML(options);
      if (parens.start) {
        start = '<span class="math-parenthesis math-round-parenthesis">(</span>' + start + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }
      str = start;

      if (this.step) {
        var step = this.step.toHTML(options);
        if (parens.step) {
          step = '<span class="math-parenthesis math-round-parenthesis">(</span>' + step + '<span class="math-parenthesis math-round-parenthesis">)</span>';
        }
        str += '<span class="math-operator math-range-operator">:</span>' + step;
      }

      var end = this.end.toHTML(options);
      if (parens.end) {
        end = '<span class="math-parenthesis math-round-parenthesis">(</span>' + end + '<span class="math-parenthesis math-round-parenthesis">)</span>';
      }
      str += '<span class="math-operator math-range-operator">:</span>' + end;

      return str;
    };

    /**
     * Get LaTeX representation
     * @params {Object} options
     * @return {string} str
     */
    RangeNode.prototype._toTex = function (options) {
      var parenthesis = (options && options.parenthesis) ? options.parenthesis : 'keep';
      var parens = calculateNecessaryParentheses(this, parenthesis);

      var str = this.start.toTex(options);
      if (parens.start) {
        str = '\\left(' + str + '\\right)';
      }

      if (this.step) {
        var step = this.step.toTex(options);
        if (parens.step) {
          step = '\\left(' + step + '\\right)';
        }
        str += ':' + step;
      }

      var end = this.end.toTex(options);
      if (parens.end) {
        end = '\\left(' + end + '\\right)';
      }
      str += ':' + end;

      return str;
    };

    return RangeNode;
  }

  var name$53 = 'RangeNode';
  var path$28 = 'expression.node';
  var factory_1$58 = factory$59;

  var RangeNode = {
  	name: name$53,
  	path: path$28,
  	factory: factory_1$58
  };

  function factory$60 (type, config, load, typed) {
    var numeric$$1 = load(numeric);

    var AccessorNode$$1            = load(AccessorNode);
    var ArrayNode$$1               = load(ArrayNode);
    var AssignmentNode$$1          = load(AssignmentNode);
    var BlockNode$$1               = load(BlockNode);
    var ConditionalNode$$1         = load(ConditionalNode);
    var ConstantNode$$1            = load(ConstantNode);
    var FunctionAssignmentNode$$1  = load(FunctionAssignmentNode);
    var IndexNode$$1               = load(IndexNode);
    var ObjectNode$$1              = load(ObjectNode);
    var OperatorNode$$1            = load(OperatorNode);
    var ParenthesisNode$$1         = load(ParenthesisNode);
    var FunctionNode$$1            = load(FunctionNode);
    var RangeNode$$1               = load(RangeNode);
    var SymbolNode$$1              = load(SymbolNode);

    /**
     * Parse an expression. Returns a node tree, which can be evaluated by
     * invoking node.eval();
     *
     * Syntax:
     *
     *     parse(expr)
     *     parse(expr, options)
     *     parse([expr1, expr2, expr3, ...])
     *     parse([expr1, expr2, expr3, ...], options)
     *
     * Example:
     *
     *     var node = parse('sqrt(3^2 + 4^2)');
     *     node.compile(math).eval(); // 5
     *
     *     var scope = {a:3, b:4}
     *     var node = parse('a * b'); // 12
     *     var code = node.compile(math);
     *     code.eval(scope); // 12
     *     scope.a = 5;
     *     code.eval(scope); // 20
     *
     *     var nodes = math.parse(['a = 3', 'b = 4', 'a * b']);
     *     nodes[2].compile(math).eval(); // 12
     *
     * @param {string | string[] | Matrix} expr
     * @param {{nodes: Object<string, Node>}} [options]  Available options:
     *                                                   - `nodes` a set of custom nodes
     * @return {Node | Node[]} node
     * @throws {Error}
     */
    function parse (expr, options) {
      if (arguments.length !== 1 && arguments.length !== 2) {
        throw new ArgumentsError_1('parse', arguments.length, 1, 2);
      }

      // pass extra nodes
      extra_nodes = (options && options.nodes) ? options.nodes : {};

      if (typeof expr === 'string') {
        // parse a single expression
        expression = expr;
        return parseStart();
      }
      else if (Array.isArray(expr) || expr instanceof type.Matrix) {
        // parse an array or matrix with expressions
        return deepMap(expr, function (elem) {
          if (typeof elem !== 'string') throw new TypeError('String expected');

          expression = elem;
          return parseStart();
        });
      }
      else {
        // oops
        throw new TypeError('String or matrix expected');
      }
    }

    // token types enumeration
    var TOKENTYPE = {
      NULL : 0,
      DELIMITER : 1,
      NUMBER : 2,
      SYMBOL : 3,
      UNKNOWN : 4
    };

    // map with all delimiters
    var DELIMITERS = {
      ',': true,
      '(': true,
      ')': true,
      '[': true,
      ']': true,
      '{': true,
      '}': true,
      '\"': true,
      ';': true,

      '+': true,
      '-': true,
      '*': true,
      '.*': true,
      '/': true,
      './': true,
      '%': true,
      '^': true,
      '.^': true,
      '~': true,
      '!': true,
      '&': true,
      '|': true,
      '^|': true,
      '\'': true,
      '=': true,
      ':': true,
      '?': true,

      '==': true,
      '!=': true,
      '<': true,
      '>': true,
      '<=': true,
      '>=': true,

      '<<': true,
      '>>': true,
      '>>>': true
    };

    // map with all named delimiters
    var NAMED_DELIMITERS = {
      'mod': true,
      'to': true,
      'in': true,
      'and': true,
      'xor': true,
      'or': true,
      'not': true
    };

    var CONSTANTS = {
      'true': true,
      'false': false,
      'null': null,
      'undefined': undefined
    };

    var NUMERIC_CONSTANTS = [
      'NaN',
      'Infinity'
    ];

    var extra_nodes = {};             // current extra nodes
    var expression = '';              // current expression
    var comment = '';                 // last parsed comment
    var index = 0;                    // current index in expr
    var c = '';                       // current token character in expr
    var token = '';                   // current token
    var token_type = TOKENTYPE.NULL;  // type of the token
    var nesting_level = 0;            // level of nesting inside parameters, used to ignore newline characters
    var conditional_level = null;     // when a conditional is being parsed, the level of the conditional is stored here
    var tokenStates = [];             // holds saved token states

    /**
     * Get the first character from the expression.
     * The character is stored into the char c. If the end of the expression is
     * reached, the function puts an empty string in c.
     * @private
     */
    function first() {
      index = 0;
      c = expression.charAt(0);
      nesting_level = 0;
      conditional_level = null;
    }

    /**
     * Get the next character from the expression.
     * The character is stored into the char c. If the end of the expression is
     * reached, the function puts an empty string in c.
     * @private
     */
    function next() {
      index++;
      c = expression.charAt(index);
    }

    /**
     * Preview the previous character from the expression.
     * @return {string} cNext
     * @private
     */
    function prevPreview() {
      return expression.charAt(index - 1);
    }

    /**
     * Preview the next character from the expression.
     * @return {string} cNext
     * @private
     */
    function nextPreview() {
      return expression.charAt(index + 1);
    }

    /**
     * Preview the second next character from the expression.
     * @return {string} cNext
     * @private
     */
    function nextNextPreview() {
      return expression.charAt(index + 2);
    }

    /**
     * Save the current token state so we can rewind later if necessary.
     * @private
     */
    function pushTokenState() {
      tokenStates.push({
        token_type: token_type,
        token: token,
        comment: comment,
        index: index,
        c: c
      });
    }

    /**
     * Rewind the parser by one token by restoring the last saved token state
     * @private
     */
    function popTokenState() {
      var restoredState = tokenStates.pop();
      token_type = restoredState.token_type;
      token = restoredState.token;
      comment = restoredState.comment;
      index = restoredState.index;
      c = restoredState.c;
    }

    /**
     * Discard the most recent token state without restoring it
     * @private
     */
    function discardTokenState() {
      tokenStates.pop();
    }

    /**
     * Get next token in the current string expr.
     * The token and token type are available as token and token_type
     * @private
     */
    function getToken() {
      token_type = TOKENTYPE.NULL;
      token = '';
      comment = '';

      // skip over whitespaces
      // space, tab, and newline when inside parameters
      while (parse.isWhitespace(c, nesting_level)) {
        next();
      }

      // skip comment
      if (c === '#') {
        while (c !== '\n' && c !== '') {
          comment += c;
          next();
        }
      }

      // check for end of expression
      if (c === '') {
        // token is still empty
        token_type = TOKENTYPE.DELIMITER;
        return;
      }

      // check for new line character
      if (c === '\n' && !nesting_level) {
        token_type = TOKENTYPE.DELIMITER;
        token = c;
        next();
        return;
      }

      // check for delimiters consisting of 3 characters
      var c2 = c + nextPreview();
      var c3 = c2 + nextNextPreview();
      if (c3.length === 3 && DELIMITERS[c3]) {
        token_type = TOKENTYPE.DELIMITER;
        token = c3;
        next();
        next();
        next();
        return;
      }

      // check for delimiters consisting of 2 characters
      if (c2.length === 2 && DELIMITERS[c2]) {
        token_type = TOKENTYPE.DELIMITER;
        token = c2;
        next();
        next();
        return;
      }

      // check for delimiters consisting of 1 character
      if (DELIMITERS[c]) {
        token_type = TOKENTYPE.DELIMITER;
        token = c;
        next();
        return;
      }

      // check for a number
      if (parse.isDigitDot(c)) {
        token_type = TOKENTYPE.NUMBER;

        // get number, can have a single dot
        if (c === '.') {
          token += c;
          next();

          if (!parse.isDigit(c)) {
            // this is no number, it is just a dot (can be dot notation)
            token_type = TOKENTYPE.DELIMITER;
          }
        }
        else {
          while (parse.isDigit(c)) {
            token += c;
            next();
          }
          if (parse.isDecimalMark(c, nextPreview())) {
            token += c;
            next();
          }
        }
        while (parse.isDigit(c)) {
          token += c;
          next();
        }

        // check for exponential notation like "2.3e-4", "1.23e50" or "2e+4"
        c2 = nextPreview();
        if (c === 'E' || c === 'e') {
          if (parse.isDigit(c2) || c2 === '-' || c2 === '+') {
            token += c;
            next();

            if (c === '+' || c === '-') {
              token += c;
              next();
            }

            // Scientific notation MUST be followed by an exponent
            if (!parse.isDigit(c)) {
              throw createSyntaxError('Digit expected, got "' + c + '"');
            }

            while (parse.isDigit(c)) {
              token += c;
              next();
            }

            if (parse.isDecimalMark(c, nextPreview())) {
              throw createSyntaxError('Digit expected, got "' + c + '"');
            }
          }
          else if (c2 === '.') {
            next();
            throw createSyntaxError('Digit expected, got "' + c + '"');
          }
        }

        return;
      }

      // check for variables, functions, named operators
      if (parse.isAlpha(c, prevPreview(), nextPreview())) {
        while (parse.isAlpha(c, prevPreview(), nextPreview()) || parse.isDigit(c)) {
          token += c;
          next();
        }

        if (NAMED_DELIMITERS.hasOwnProperty(token)) {
          token_type = TOKENTYPE.DELIMITER;
        }
        else {
          token_type = TOKENTYPE.SYMBOL;
        }

        return;
      }

      // something unknown is found, wrong characters -> a syntax error
      token_type = TOKENTYPE.UNKNOWN;
      while (c !== '') {
        token += c;
        next();
      }
      throw createSyntaxError('Syntax error in part "' + token + '"');
    }

    /**
     * Get next token and skip newline tokens
     */
    function getTokenSkipNewline () {
      do {
        getToken();
      }
      while (token === '\n');
    }

    /**
     * Open parameters.
     * New line characters will be ignored until closeParams() is called
     */
    function openParams() {
      nesting_level++;
    }

    /**
     * Close parameters.
     * New line characters will no longer be ignored
     */
    function closeParams() {
      nesting_level--;
    }

    /**
     * Checks whether the current character `c` is a valid alpha character:
     *
     * - A latin letter (upper or lower case) Ascii: a-z, A-Z
     * - An underscore                        Ascii: _
     * - A dollar sign                        Ascii: $
     * - A latin letter with accents          Unicode: \u00C0 - \u02AF
     * - A greek letter                       Unicode: \u0370 - \u03FF
     * - A mathematical alphanumeric symbol   Unicode: \u{1D400} - \u{1D7FF} excluding invalid code points
     *
     * The previous and next characters are needed to determine whether
     * this character is part of a unicode surrogate pair.
     *
     * @param {string} c      Current character in the expression
     * @param {string} cPrev  Previous character
     * @param {string} cNext  Next character
     * @return {boolean}
     */
    parse.isAlpha = function isAlpha (c, cPrev, cNext) {
      return parse.isValidLatinOrGreek(c)
          || parse.isValidMathSymbol(c, cNext)
          || parse.isValidMathSymbol(cPrev, c);
    };

    /**
     * Test whether a character is a valid latin, greek, or letter-like character
     * @param {string} c
     * @return {boolean}
     */
    parse.isValidLatinOrGreek = function isValidLatinOrGreek (c) {
      return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(c);
    };

    /**
     * Test whether two given 16 bit characters form a surrogate pair of a
     * unicode math symbol.
     *
     * http://unicode-table.com/en/
     * http://www.wikiwand.com/en/Mathematical_operators_and_symbols_in_Unicode
     *
     * Note: In ES6 will be unicode aware:
     * http://stackoverflow.com/questions/280712/javascript-unicode-regexes
     * https://mathiasbynens.be/notes/es6-unicode-regex
     *
     * @param {string} high
     * @param {string} low
     * @return {boolean}
     */
    parse.isValidMathSymbol = function isValidMathSymbol (high, low) {
      return /^[\uD835]$/.test(high) &&
          /^[\uDC00-\uDFFF]$/.test(low) &&
          /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(low);
    };

    /**
     * Check whether given character c is a white space character: space, tab, or enter
     * @param {string} c
     * @param {number} nestingLevel
     * @return {boolean}
     */
    parse.isWhitespace = function isWhitespace (c, nestingLevel) {
      // TODO: also take '\r' carriage return as newline? Or does that give problems on mac?
      return c === ' ' || c === '\t' || (c === '\n' && nestingLevel > 0);
    };

    /**
     * Test whether the character c is a decimal mark (dot).
     * This is the case when it's not the start of a delimiter '.*', './', or '.^'
     * @param {string} c
     * @param {string} cNext
     * @return {boolean}
     */
    parse.isDecimalMark = function isDecimalMark (c, cNext) {
      return c === '.' && cNext !== '/' && cNext !== '*' && cNext !== '^';
    };

    /**
     * checks if the given char c is a digit or dot
     * @param {string} c   a string with one character
     * @return {boolean}
     */
    parse.isDigitDot = function isDigitDot (c) {
      return ((c >= '0' && c <= '9') || c === '.');
    };

    /**
     * checks if the given char c is a digit
     * @param {string} c   a string with one character
     * @return {boolean}
     */
    parse.isDigit = function isDigit (c) {
      return (c >= '0' && c <= '9');
    };

    /**
     * Start of the parse levels below, in order of precedence
     * @return {Node} node
     * @private
     */
    function parseStart () {
      // get the first character in expression
      first();

      getToken();

      var node = parseBlock();

      // check for garbage at the end of the expression
      // an expression ends with a empty character '' and token_type DELIMITER
      if (token !== '') {
        if (token_type === TOKENTYPE.DELIMITER) {
          // user entered a not existing operator like "//"

          // TODO: give hints for aliases, for example with "<>" give as hint " did you mean !== ?"
          throw createError('Unexpected operator ' + token);
        }
        else {
          throw createSyntaxError('Unexpected part "' + token + '"');
        }
      }

      return node;
    }

    /**
     * Parse a block with expressions. Expressions can be separated by a newline
     * character '\n', or by a semicolon ';'. In case of a semicolon, no output
     * of the preceding line is returned.
     * @return {Node} node
     * @private
     */
    function parseBlock () {
      var node;
      var blocks = [];
      var visible;

      if (token !== '' && token !== '\n' && token !== ';') {
        node = parseAssignment();
        node.comment = comment;
      }

      // TODO: simplify this loop
      while (token === '\n' || token === ';') {
        if (blocks.length === 0 && node) {
          visible = (token !== ';');
          blocks.push({
            node: node,
            visible: visible
          });
        }

        getToken();
        if (token !== '\n' && token !== ';' && token !== '') {
          node = parseAssignment();
          node.comment = comment;

          visible = (token !== ';');
          blocks.push({
            node: node,
            visible: visible
          });
        }
      }

      if (blocks.length > 0) {
        return new BlockNode$$1(blocks);
      }
      else {
        if (!node) {
          node = new ConstantNode$$1(undefined);
          node.comment = comment;
        }

        return node
      }
    }

    /**
     * Assignment of a function or variable,
     * - can be a variable like 'a=2.3'
     * - or a updating an existing variable like 'matrix(2,3:5)=[6,7,8]'
     * - defining a function like 'f(x) = x^2'
     * @return {Node} node
     * @private
     */
    function parseAssignment () {
      var name, args, value, valid;

      var node = parseConditional();

      if (token === '=') {
        if (type.isSymbolNode(node)) {
          // parse a variable assignment like 'a = 2/3'
          name = node.name;
          getTokenSkipNewline();
          value = parseAssignment();
          return new AssignmentNode$$1(new SymbolNode$$1(name), value);
        }
        else if (type.isAccessorNode(node)) {
          // parse a matrix subset assignment like 'A[1,2] = 4'
          getTokenSkipNewline();
          value = parseAssignment();
          return new AssignmentNode$$1(node.object, node.index, value);
        }
        else if (type.isFunctionNode(node) && type.isSymbolNode(node.fn)) {
          // parse function assignment like 'f(x) = x^2'
          valid = true;
          args = [];

          name = node.name;
          node.args.forEach(function (arg, index) {
            if (type.isSymbolNode(arg)) {
              args[index] = arg.name;
            }
            else {
              valid = false;
            }
          });

          if (valid) {
            getTokenSkipNewline();
            value = parseAssignment();
            return new FunctionAssignmentNode$$1(name, args, value);
          }
        }

        throw createSyntaxError('Invalid left hand side of assignment operator =');
      }

      return node;
    }

    /**
     * conditional operation
     *
     *     condition ? truePart : falsePart
     *
     * Note: conditional operator is right-associative
     *
     * @return {Node} node
     * @private
     */
    function parseConditional () {
      var node = parseLogicalOr();

      while (token === '?') {
        // set a conditional level, the range operator will be ignored as long
        // as conditional_level === nesting_level.
        var prev = conditional_level;
        conditional_level = nesting_level;
        getTokenSkipNewline();

        var condition = node;
        var trueExpr = parseAssignment();

        if (token !== ':') throw createSyntaxError('False part of conditional expression expected');

        conditional_level = null;
        getTokenSkipNewline();

        var falseExpr = parseAssignment(); // Note: check for conditional operator again, right associativity

        node = new ConditionalNode$$1(condition, trueExpr, falseExpr);

        // restore the previous conditional level
        conditional_level = prev;
      }

      return node;
    }

    /**
     * logical or, 'x or y'
     * @return {Node} node
     * @private
     */
    function parseLogicalOr() {
      var node = parseLogicalXor();

      while (token === 'or') {
        getTokenSkipNewline();
        node = new OperatorNode$$1('or', 'or', [node, parseLogicalXor()]);
      }

      return node;
    }

    /**
     * logical exclusive or, 'x xor y'
     * @return {Node} node
     * @private
     */
    function parseLogicalXor() {
      var node = parseLogicalAnd();

      while (token === 'xor') {
        getTokenSkipNewline();
        node = new OperatorNode$$1('xor', 'xor', [node, parseLogicalAnd()]);
      }

      return node;
    }

    /**
     * logical and, 'x and y'
     * @return {Node} node
     * @private
     */
    function parseLogicalAnd() {
      var node = parseBitwiseOr();

      while (token === 'and') {
        getTokenSkipNewline();
        node = new OperatorNode$$1('and', 'and', [node, parseBitwiseOr()]);
      }

      return node;
    }

    /**
     * bitwise or, 'x | y'
     * @return {Node} node
     * @private
     */
    function parseBitwiseOr() {
      var node = parseBitwiseXor();

      while (token === '|') {
        getTokenSkipNewline();
        node = new OperatorNode$$1('|', 'bitOr', [node, parseBitwiseXor()]);
      }

      return node;
    }

    /**
     * bitwise exclusive or (xor), 'x ^| y'
     * @return {Node} node
     * @private
     */
    function parseBitwiseXor() {
      var node = parseBitwiseAnd();

      while (token === '^|') {
        getTokenSkipNewline();
        node = new OperatorNode$$1('^|', 'bitXor', [node, parseBitwiseAnd()]);
      }

      return node;
    }

    /**
     * bitwise and, 'x & y'
     * @return {Node} node
     * @private
     */
    function parseBitwiseAnd () {
      var node = parseRelational();

      while (token === '&') {
        getTokenSkipNewline();
        node = new OperatorNode$$1('&', 'bitAnd', [node, parseRelational()]);
      }

      return node;
    }

    /**
     * relational operators
     * @return {Node} node
     * @private
     */
    function parseRelational () {
      var node, operators, name, fn, params;

      node = parseShift();

      operators = {
        '==': 'equal',
        '!=': 'unequal',
        '<': 'smaller',
        '>': 'larger',
        '<=': 'smallerEq',
        '>=': 'largerEq'
      };
      while (operators.hasOwnProperty(token)) {
        name = token;
        fn = operators[name];

        getTokenSkipNewline();
        params = [node, parseShift()];
        node = new OperatorNode$$1(name, fn, params);
      }

      return node;
    }

    /**
     * Bitwise left shift, bitwise right arithmetic shift, bitwise right logical shift
     * @return {Node} node
     * @private
     */
    function parseShift () {
      var node, operators, name, fn, params;

      node = parseConversion();

      operators = {
        '<<' : 'leftShift',
        '>>' : 'rightArithShift',
        '>>>' : 'rightLogShift'
      };

      while (operators.hasOwnProperty(token)) {
        name = token;
        fn = operators[name];

        getTokenSkipNewline();
        params = [node, parseConversion()];
        node = new OperatorNode$$1(name, fn, params);
      }

      return node;
    }

    /**
     * conversion operators 'to' and 'in'
     * @return {Node} node
     * @private
     */
    function parseConversion () {
      var node, operators, name, fn, params;

      node = parseRange();

      operators = {
        'to' : 'to',
        'in' : 'to'   // alias of 'to'
      };

      while (operators.hasOwnProperty(token)) {
        name = token;
        fn = operators[name];

        getTokenSkipNewline();
        
        if (name === 'in' && token === '') {
          // end of expression -> this is the unit 'in' ('inch')
          node = new OperatorNode$$1('*', 'multiply', [node, new SymbolNode$$1('in')], true);
        }
        else {
          // operator 'a to b' or 'a in b'
          params = [node, parseRange()];
          node = new OperatorNode$$1(name, fn, params);
        }
      }

      return node;
    }

    /**
     * parse range, "start:end", "start:step:end", ":", "start:", ":end", etc
     * @return {Node} node
     * @private
     */
    function parseRange () {
      var node, params = [];

      if (token === ':') {
        // implicit start=1 (one-based)
        node = new ConstantNode$$1(1);
      }
      else {
        // explicit start
        node = parseAddSubtract();
      }

      if (token === ':' && (conditional_level !== nesting_level)) {
        // we ignore the range operator when a conditional operator is being processed on the same level
        params.push(node);

        // parse step and end
        while (token === ':' && params.length < 3) {
          getTokenSkipNewline();

          if (token === ')' || token === ']' || token === ',' || token === '') {
            // implicit end
            params.push(new SymbolNode$$1('end'));
          }
          else {
            // explicit end
            params.push(parseAddSubtract());
          }
        }

        if (params.length === 3) {
          // params = [start, step, end]
          node = new RangeNode$$1(params[0], params[2], params[1]); // start, end, step
        }
        else { // length === 2
          // params = [start, end]
          node = new RangeNode$$1(params[0], params[1]); // start, end
        }
      }

      return node;
    }

    /**
     * add or subtract
     * @return {Node} node
     * @private
     */
    function parseAddSubtract ()  {
      var node, operators, name, fn, params;

      node = parseMultiplyDivide();

      operators = {
        '+': 'add',
        '-': 'subtract'
      };
      while (operators.hasOwnProperty(token)) {
        name = token;
        fn = operators[name];

        getTokenSkipNewline();
        params = [node, parseMultiplyDivide()];
        node = new OperatorNode$$1(name, fn, params);
      }

      return node;
    }

    /**
     * multiply, divide, modulus
     * @return {Node} node
     * @private
     */
    function parseMultiplyDivide () {
      var node, last, operators, name, fn;

      node = parseImplicitMultiplication();
      last = node;

      operators = {
        '*': 'multiply',
        '.*': 'dotMultiply',
        '/': 'divide',
        './': 'dotDivide',
        '%': 'mod',
        'mod': 'mod'
      };

      while (true) {
        if (operators.hasOwnProperty(token)) {
          // explicit operators
          name = token;
          fn = operators[name];

          getTokenSkipNewline();

          last = parseImplicitMultiplication();
          node = new OperatorNode$$1(name, fn, [node, last]);
        }
        else {
          break;
        }
      }

      return node;
    }
    
    /**
     * implicit multiplication
     * @return {Node} node
     * @private
     */
    function parseImplicitMultiplication () {
      var node, last;

      node = parseRule2();
      last = node;

      while (true) {
        if ((token_type === TOKENTYPE.SYMBOL) ||
            (token === 'in' && type.isConstantNode(node)) ||
            (token_type === TOKENTYPE.NUMBER &&
                !type.isConstantNode(last) &&
                (!type.isOperatorNode(last) || last.op === '!')) ||
            (token === '(')) {
          // parse implicit multiplication
          //
          // symbol:      implicit multiplication like '2a', '(2+3)a', 'a b'
          // number:      implicit multiplication like '(2+3)2'
          // parenthesis: implicit multiplication like '2(3+4)', '(3+4)(1+2)'
          last = parseRule2();
          node = new OperatorNode$$1('*', 'multiply', [node, last], true /*implicit*/);
        }
        else {
          break;
        }
      }

      return node;
    }
    
    /**
     * Infamous "rule 2" as described in https://github.com/josdejong/mathjs/issues/792#issuecomment-361065370
     * Explicit division gets higher precedence than implicit multiplication
     * when the division matches this pattern: [number] / [number] [symbol]
     * @return {Node} node
     * @private
     */
    function parseRule2 () {
      var node, last;
      
      node = parseUnary();
      last = node;
      
      
      while(true) {
        
        // Match the "number /" part of the pattern "number / number symbol"
        if(token === '/' && type.isConstantNode(last)) {
          
          // Look ahead to see if the next token is a number
          pushTokenState();
          getTokenSkipNewline();
          
          // Match the "number / number" part of the pattern 
          if(token_type === TOKENTYPE.NUMBER) {
         
            // Look ahead again
            pushTokenState();
            getTokenSkipNewline();
            
            // Match the "symbol" part of the pattern, or a left parenthesis
            if(token_type === TOKENTYPE.SYMBOL || token === '(') {
              // We've matched the pattern "number / number symbol".
              // Rewind once and build the "number / number" node; the symbol will be consumed later
              popTokenState();
              discardTokenState();
              last = parseUnary();
              node = new OperatorNode$$1('/', 'divide', [node, last]);
            }
            else {
              // Not a match, so rewind
              popTokenState();
              popTokenState();
              break;
            }
          } 
          else {
            // Not a match, so rewind
            popTokenState();
            break;
          }
        }
        else {
          break;
        }
      }
      
      return node;
    }
    
    /**
     * Unary plus and minus, and logical and bitwise not
     * @return {Node} node
     * @private
     */
    function parseUnary () {
      var name, params, fn;
      var operators = {
        '-': 'unaryMinus',
        '+': 'unaryPlus',
        '~': 'bitNot',
        'not': 'not'
      };

      if (operators.hasOwnProperty(token)) {
        fn = operators[token];
        name = token;

        getTokenSkipNewline();
        params = [parseUnary()];

        return new OperatorNode$$1(name, fn, params);
      }

      return parsePow();
    }

    /**
     * power
     * Note: power operator is right associative
     * @return {Node} node
     * @private
     */
    function parsePow () {
      var node, name, fn, params;

      node = parseLeftHandOperators();

      if (token === '^' || token === '.^') {
        name = token;
        fn = (name === '^') ? 'pow' : 'dotPow';

        getTokenSkipNewline();
        params = [node, parseUnary()]; // Go back to unary, we can have '2^-3'
        node = new OperatorNode$$1(name, fn, params);
      }

      return node;
    }

    /**
     * Left hand operators: factorial x!, transpose x'
     * @return {Node} node
     * @private
     */
    function parseLeftHandOperators ()  {
      var node, operators, name, fn, params;

      node = parseCustomNodes();

      operators = {
        '!': 'factorial',
        '\'': 'transpose'
      };

      while (operators.hasOwnProperty(token)) {
        name = token;
        fn = operators[name];

        getToken();
        params = [node];

        node = new OperatorNode$$1(name, fn, params);
        node = parseAccessors(node);
      }

      return node;
    }

    /**
     * Parse a custom node handler. A node handler can be used to process
     * nodes in a custom way, for example for handling a plot.
     *
     * A handler must be passed as second argument of the parse function.
     * - must extend math.expression.node.Node
     * - must contain a function _compile(defs: Object) : string
     * - must contain a function find(filter: Object) : Node[]
     * - must contain a function toString() : string
     * - the constructor is called with a single argument containing all parameters
     *
     * For example:
     *
     *     nodes = {
     *       'plot': PlotHandler
     *     };
     *
     * The constructor of the handler is called as:
     *
     *     node = new PlotHandler(params);
     *
     * The handler will be invoked when evaluating an expression like:
     *
     *     node = math.parse('plot(sin(x), x)', nodes);
     *
     * @return {Node} node
     * @private
     */
    function parseCustomNodes () {
      var params = [];

      if (token_type === TOKENTYPE.SYMBOL && extra_nodes.hasOwnProperty(token)) {
        var CustomNode = extra_nodes[token];

        getToken();

        // parse parameters
        if (token === '(') {
          params = [];

          openParams();
          getToken();

          if (token !== ')') {
            params.push(parseAssignment());

            // parse a list with parameters
            while (token === ',') {
              getToken();
              params.push(parseAssignment());
            }
          }

          if (token !== ')') {
            throw createSyntaxError('Parenthesis ) expected');
          }
          closeParams();
          getToken();
        }

        // create a new custom node
        //noinspection JSValidateTypes
        return new CustomNode(params);
      }

      return parseSymbol();
    }

    /**
     * parse symbols: functions, variables, constants, units
     * @return {Node} node
     * @private
     */
    function parseSymbol () {
      var node, name;

      if (token_type === TOKENTYPE.SYMBOL ||
          (token_type === TOKENTYPE.DELIMITER && token in NAMED_DELIMITERS)) {
        name = token;

        getToken();

        if (CONSTANTS.hasOwnProperty(name)) { // true, false, null, ...
          node = new ConstantNode$$1(CONSTANTS[name]);
        }
        else if (NUMERIC_CONSTANTS.indexOf(name) !== -1) { // NaN, Infinity
          node = new ConstantNode$$1(numeric$$1(name));
        }
        else {
          node = new SymbolNode$$1(name);
        }

        // parse function parameters and matrix index
        node = parseAccessors(node);
        return node;
      }

      return parseString();
    }

    /**
     * parse accessors:
     * - function invocation in round brackets (...), for example sqrt(2)
     * - index enclosed in square brackets [...], for example A[2,3]
     * - dot notation for properties, like foo.bar
     * @param {Node} node    Node on which to apply the parameters. If there
     *                       are no parameters in the expression, the node
     *                       itself is returned
     * @param {string[]} [types]  Filter the types of notations
     *                            can be ['(', '[', '.']
     * @return {Node} node
     * @private
     */
    function parseAccessors (node, types) {
      var params;

      while ((token === '(' || token === '[' || token === '.') &&
          (!types || types.indexOf(token) !== -1)) {
        params = [];

        if (token === '(') {
          if (type.isSymbolNode(node) || type.isAccessorNode(node)) {
            // function invocation like fn(2, 3) or obj.fn(2, 3)
            openParams();
            getToken();

            if (token !== ')') {
              params.push(parseAssignment());

              // parse a list with parameters
              while (token === ',') {
                getToken();
                params.push(parseAssignment());
              }
            }

            if (token !== ')') {
              throw createSyntaxError('Parenthesis ) expected');
            }
            closeParams();
            getToken();

            node = new FunctionNode$$1(node, params);
          }
          else {
            // implicit multiplication like (2+3)(4+5) or sqrt(2)(1+2)
            // don't parse it here but let it be handled by parseImplicitMultiplication
            // with correct precedence
            return node;
          }
        }
        else if (token === '[') {
          // index notation like variable[2, 3]
          openParams();
          getToken();

          if (token !== ']') {
            params.push(parseAssignment());

            // parse a list with parameters
            while (token === ',') {
              getToken();
              params.push(parseAssignment());
            }
          }

          if (token !== ']') {
            throw createSyntaxError('Parenthesis ] expected');
          }
          closeParams();
          getToken();

          node = new AccessorNode$$1(node, new IndexNode$$1(params));
        }
        else {
          // dot notation like variable.prop
          getToken();

          if (token_type !== TOKENTYPE.SYMBOL) {
            throw createSyntaxError('Property name expected after dot');
          }
          params.push(new ConstantNode$$1(token));
          getToken();

          var dotNotation = true;
          node = new AccessorNode$$1(node, new IndexNode$$1(params, dotNotation));
        }
      }

      return node;
    }

    /**
     * parse a string.
     * A string is enclosed by double quotes
     * @return {Node} node
     * @private
     */
    function parseString () {
      var node, str;

      if (token === '"') {
        str = parseStringToken();

        // create constant
        node = new ConstantNode$$1(str);

        // parse index parameters
        node = parseAccessors(node);

        return node;
      }

      return parseMatrix();
    }

    /**
     * Parse a string surrounded by double quotes "..."
     * @return {string}
     */
    function parseStringToken () {
      var str = '';

      while (c !== '' && c !== '\"') {
        if (c === '\\') {
          // escape character, immediately process the next
          // character to prevent stopping at a next '\"'
          str += c;
          next();
        }

        str += c;
        next();
      }

      getToken();
      if (token !== '"') {
        throw createSyntaxError('End of string " expected');
      }
      getToken();

      return JSON.parse('"' + str + '"'); // unescape escaped characters
    }

    /**
     * parse the matrix
     * @return {Node} node
     * @private
     */
    function parseMatrix () {
      var array, params, rows, cols;

      if (token === '[') {
        // matrix [...]
        openParams();
        getToken();

        if (token !== ']') {
          // this is a non-empty matrix
          var row = parseRow();

          if (token === ';') {
            // 2 dimensional array
            rows = 1;
            params = [row];

            // the rows of the matrix are separated by dot-comma's
            while (token === ';') {
              getToken();

              params[rows] = parseRow();
              rows++;
            }

            if (token !== ']') {
              throw createSyntaxError('End of matrix ] expected');
            }
            closeParams();
            getToken();

            // check if the number of columns matches in all rows
            cols = params[0].items.length;
            for (var r = 1; r < rows; r++) {
              if (params[r].items.length !== cols) {
                throw createError('Column dimensions mismatch ' +
                    '(' + params[r].items.length + ' !== ' + cols + ')');
              }
            }

            array = new ArrayNode$$1(params);
          }
          else {
            // 1 dimensional vector
            if (token !== ']') {
              throw createSyntaxError('End of matrix ] expected');
            }
            closeParams();
            getToken();

            array = row;
          }
        }
        else {
          // this is an empty matrix "[ ]"
          closeParams();
          getToken();
          array = new ArrayNode$$1([]);
        }

        return parseAccessors(array);
      }

      return parseObject();
    }

    /**
     * Parse a single comma-separated row from a matrix, like 'a, b, c'
     * @return {ArrayNode} node
     */
    function parseRow () {
      var params = [parseAssignment()];
      var len = 1;

      while (token === ',') {
        getToken();

        // parse expression
        params[len] = parseAssignment();
        len++;
      }

      return new ArrayNode$$1(params);
    }

    /**
     * parse an object, enclosed in angle brackets{...}, for example {value: 2}
     * @return {Node} node
     * @private
     */
    function parseObject () {
      if (token === '{') {
        var key;

        var properties = {};
        do {
          getToken();

          if (token !== '}') {
            // parse key
            if (token === '"') {
              key = parseStringToken();
            }
            else if (token_type === TOKENTYPE.SYMBOL) {
              key = token;
              getToken();
            }
            else {
              throw createSyntaxError('Symbol or string expected as object key');
            }

            // parse key/value separator
            if (token !== ':') {
              throw createSyntaxError('Colon : expected after object key');
            }
            getToken();

            // parse key
            properties[key] = parseAssignment();
          }
        }
        while (token === ',');

        if (token !== '}') {
          throw createSyntaxError('Comma , or bracket } expected after object value');
        }
        getToken();

        var node = new ObjectNode$$1(properties);

        // parse index parameters
        node = parseAccessors(node);

        return node;
      }

      return parseNumber();
    }

    /**
     * parse a number
     * @return {Node} node
     * @private
     */
    function parseNumber () {
      var numberStr;

      if (token_type === TOKENTYPE.NUMBER) {
        // this is a number
        numberStr = token;
        getToken();

        return new ConstantNode$$1(numeric$$1(numberStr, config.number));
      }

      return parseParentheses();
    }

    /**
     * parentheses
     * @return {Node} node
     * @private
     */
    function parseParentheses () {
      var node;

      // check if it is a parenthesized expression
      if (token === '(') {
        // parentheses (...)
        openParams();
        getToken();

        node = parseAssignment(); // start again

        if (token !== ')') {
          throw createSyntaxError('Parenthesis ) expected');
        }
        closeParams();
        getToken();

        node = new ParenthesisNode$$1(node);
        node = parseAccessors(node);
        return node;
      }

      return parseEnd();
    }

    /**
     * Evaluated when the expression is not yet ended but expected to end
     * @return {Node} res
     * @private
     */
    function parseEnd () {
      if (token === '') {
        // syntax error or unexpected end of expression
        throw createSyntaxError('Unexpected end of expression');
      } else if (token === "'") {
        throw createSyntaxError('Value expected. Note: strings must be enclosed by double quotes');
      } else {
        throw createSyntaxError('Value expected');
      }
    }

    /**
     * Shortcut for getting the current row value (one based)
     * Returns the line of the currently handled expression
     * @private
     */
    /* TODO: implement keeping track on the row number
    function row () {
      return null;
    }
    */

    /**
     * Shortcut for getting the current col value (one based)
     * Returns the column (position) where the last token starts
     * @private
     */
    function col () {
      return index - token.length + 1;
    }

    /**
     * Create an error
     * @param {string} message
     * @return {SyntaxError} instantiated error
     * @private
     */
    function createSyntaxError (message) {
      var c = col();
      var error = new SyntaxError(message + ' (char ' + c + ')');
      error['char'] = c;

      return error;
    }

    /**
     * Create an error
     * @param {string} message
     * @return {Error} instantiated error
     * @private
     */
    function createError (message) {
      var c = col();
      var error = new SyntaxError(message + ' (char ' + c + ')');
      error['char'] = c;

      return error;
    }

    return parse;
  }

  var name$54 = 'parse';
  var path$29 = 'expression';
  var factory_1$59 = factory$60;

  var parse = {
  	name: name$54,
  	path: path$29,
  	factory: factory_1$59
  };

  function factory$61 (type, config, load, typed) {
    var parse$$1 = load(parse);

    /**
     * Parse and compile an expression.
     * Returns a an object with a function `eval([scope])` to evaluate the
     * compiled expression.
     *
     * Syntax:
     *
     *     math.compile(expr)                       // returns one node
     *     math.compile([expr1, expr2, expr3, ...]) // returns an array with nodes
     *
     * Examples:
     *
     *     var code = math.compile('sqrt(3^2 + 4^2)');
     *     code.eval(); // 5
     *
     *     var scope = {a: 3, b: 4}
     *     var code = math.compile('a * b'); // 12
     *     code.eval(scope); // 12
     *     scope.a = 5;
     *     code.eval(scope); // 20
     *
     *     var nodes = math.compile(['a = 3', 'b = 4', 'a * b']);
     *     nodes[2].eval(); // 12
     *
     * See also:
     *
     *    parse, eval
     *
     * @param {string | string[] | Array | Matrix} expr
     *            The expression to be compiled
     * @return {{eval: Function} | Array.<{eval: Function}>} code
     *            An object with the compiled expression
     * @throws {Error}
     */
    return typed('compile', {
      'string': function (expr) {
        return parse$$1(expr).compile();
      },

      'Array | Matrix': function (expr) {
        return deepMap(expr, function (entry) {
          return parse$$1(entry).compile();
        });
      }
    });
  }

  var name$55 = 'compile';
  var factory_1$60 = factory$61;

  var compile = {
  	name: name$55,
  	factory: factory_1$60
  };

  function factory$62 (type, config, load, typed) {
    var parse$$1 = load(parse);

    /**
     * Evaluate an expression.
     *
     * Note the evaluating arbitrary expressions may involve security risks,
     * see [http://mathjs.org/docs/expressions/security.html](http://mathjs.org/docs/expressions/security.html) for more information.
     *
     * Syntax:
     *
     *     math.eval(expr)
     *     math.eval(expr, scope)
     *     math.eval([expr1, expr2, expr3, ...])
     *     math.eval([expr1, expr2, expr3, ...], scope)
     *
     * Example:
     *
     *     math.eval('(2+3)/4');                // 1.25
     *     math.eval('sqrt(3^2 + 4^2)');        // 5
     *     math.eval('sqrt(-4)');               // 2i
     *     math.eval(['a=3', 'b=4', 'a*b']);,   // [3, 4, 12]
     *
     *     var scope = {a:3, b:4};
     *     math.eval('a * b', scope);           // 12
     *
     * See also:
     *
     *    parse, compile
     *
     * @param {string | string[] | Matrix} expr   The expression to be evaluated
     * @param {Object} [scope]                    Scope to read/write variables
     * @return {*} The result of the expression
     * @throws {Error}
     */
    return typed('compile', {
      'string': function (expr) {
        var scope = {};
        return parse$$1(expr).compile().eval(scope);
      },

      'string, Object': function (expr, scope) {
        return parse$$1(expr).compile().eval(scope);
      },

      'Array | Matrix': function (expr) {
        var scope = {};
        return deepMap(expr, function (entry) {
          return parse$$1(entry).compile().eval(scope);
        });
      },

      'Array | Matrix, Object': function (expr, scope) {
        return deepMap(expr, function (entry) {
          return parse$$1(entry).compile().eval(scope);
        });
      }
    });
  }

  var name$56 = 'eval';
  var factory_1$61 = factory$62;

  var _eval$1 = {
  	name: name$56,
  	factory: factory_1$61
  };

  var getSafeProperty$8 = customs.getSafeProperty;

  function factory$63 (type, config, load, typed, math) {
    var docs = load(embeddedDocs);

    /**
     * Retrieve help on a function or data type.
     * Help files are retrieved from the documentation in math.expression.docs.
     *
     * Syntax:
     *
     *    math.help(search)
     *
     * Examples:
     *
     *    console.log(math.help('sin').toString());
     *    console.log(math.help(math.add).toString());
     *    console.log(math.help(math.add).toJSON());
     *
     * @param {Function | string | Object} search   A function or function name
     *                                              for which to get help
     * @return {Help} A help object
     */
    return typed('help', {
      'any': function (search) {
        var prop;
        var name = search;

        if (typeof search !== 'string') {
          for (prop in math) {
            // search in functions and constants
            if (math.hasOwnProperty(prop) && (search === math[prop])) {
              name = prop;
              break;
            }
          }

          /* TODO: implement help for data types
           if (!text) {
           // search data type
           for (prop in math.type) {
           if (math.type.hasOwnProperty(prop)) {
           if (search === math.type[prop]) {
           text = prop;
           break;
           }
           }
           }
           }
           */
        }

        var doc = getSafeProperty$8(docs, name);
        if (!doc) {
          throw new Error('No documentation found on "' + name + '"');
        }
        return new type.Help(doc);
      }
    });
  }

  var math$9 = true; // request access to the math namespace as 5th argument of the factory function
  var name$57 = 'help';
  var factory_1$62 = factory$63;

  var help$1 = {
  	math: math$9,
  	name: name$57,
  	factory: factory_1$62
  };

  function factory$64 (type, config, load, typed) {
    var parse$$1 = load(parse);

    /**
     * Parse an expression. Returns a node tree, which can be evaluated by
     * invoking node.eval();
     *
     * Note the evaluating arbitrary expressions may involve security risks,
     * see [http://mathjs.org/docs/expressions/security.html](http://mathjs.org/docs/expressions/security.html) for more information.
     *
     * Syntax:
     *
     *     math.parse(expr)
     *     math.parse(expr, options)
     *     math.parse([expr1, expr2, expr3, ...])
     *     math.parse([expr1, expr2, expr3, ...], options)
     *
     * Example:
     *
     *     var node = math.parse('sqrt(3^2 + 4^2)');
     *     node.compile().eval(); // 5
     *
     *     var scope = {a:3, b:4}
     *     var node = math.parse('a * b'); // 12
     *     var code = node.compile();
     *     code.eval(scope); // 12
     *     scope.a = 5;
     *     code.eval(scope); // 20
     *
     *     var nodes = math.parse(['a = 3', 'b = 4', 'a * b']);
     *     nodes[2].compile().eval(); // 12
     *
     * See also:
     *
     *     eval, compile
     *
     * @param {string | string[] | Matrix} expr          Expression to be parsed
     * @param {{nodes: Object<string, Node>}} [options]  Available options:
     *                                                   - `nodes` a set of custom nodes
     * @return {Node | Node[]} node
     * @throws {Error}
     */
    return typed('parse', {
      'string | Array | Matrix': parse$$1,
      'string | Array | Matrix, Object': parse$$1
    });
  }

  var name$58 = 'parse';
  var factory_1$63 = factory$64;

  var parse$1 = {
  	name: name$58,
  	factory: factory_1$63
  };

  var extend$1 = object.extend;


  function factory$65 (type, config, load, typed, math) {
    var _parse = load(parse);

    /**
     * @constructor Parser
     * Parser contains methods to evaluate or parse expressions, and has a number
     * of convenience methods to get, set, and remove variables from memory. Parser
     * keeps a scope containing variables in memory, which is used for all
     * evaluations.
     *
     * Methods:
     *    var result = parser.eval(expr);    // evaluate an expression
     *    var value = parser.get(name);      // retrieve a variable from the parser
     *    var values = parser.getAll();      // retrieve all defined variables
     *    parser.set(name, value);           // set a variable in the parser
     *    parser.remove(name);               // clear a variable from the
     *                                       // parsers scope
     *    parser.clear();                    // clear the parsers scope
     *
     * Example usage:
     *    var parser = new Parser();
     *    // Note: there is a convenience method which can be used instead:
     *    // var parser = new math.parser();
     *
     *    // evaluate expressions
     *    parser.eval('sqrt(3^2 + 4^2)');         // 5
     *    parser.eval('sqrt(-4)');                // 2i
     *    parser.eval('2 inch in cm');            // 5.08 cm
     *    parser.eval('cos(45 deg)');             // 0.7071067811865476
     *
     *    // define variables and functions
     *    parser.eval('x = 7 / 2');               // 3.5
     *    parser.eval('x + 3');                   // 6.5
     *    parser.eval('function f(x, y) = x^y');  // f(x, y)
     *    parser.eval('f(2, 3)');                 // 8
     *
     *    // get and set variables and functions
     *    var x = parser.get('x');                // 7
     *    var f = parser.get('f');                // function
     *    var g = f(3, 2);                        // 9
     *    parser.set('h', 500);
     *    var i = parser.eval('h / 2');           // 250
     *    parser.set('hello', function (name) {
     *        return 'hello, ' + name + '!';
     *    });
     *    parser.eval('hello("user")');           // "hello, user!"
     *
     *    // clear defined functions and variables
     *    parser.clear();
     *
     */
    function Parser() {
      if (!(this instanceof Parser)) {
        throw new SyntaxError(
            'Constructor must be called with the new operator');
      }
      this.scope = {};
    }

    /**
     * Attach type information
     */
    Parser.prototype.type = 'Parser';
    Parser.prototype.isParser = true;

    /**
     * Parse an expression and return the parsed function node.
     * The node tree can be compiled via `code = node.compile(math)`,
     * and the compiled code can be executed as `code.eval([scope])`
     * @param {string} expr
     * @return {Node} node
     * @throws {Error}
     */
    Parser.prototype.parse = function (expr) {
      throw new Error('Parser.parse is deprecated. Use math.parse instead.');
    };

    /**
     * Parse and compile an expression, return the compiled javascript code.
     * The node can be evaluated via code.eval([scope])
     * @param {string} expr
     * @return {{eval: function}} code
     * @throws {Error}
     */
    Parser.prototype.compile = function (expr) {
      throw new Error('Parser.compile is deprecated. Use math.compile instead.');
    };

    /**
     * Parse and evaluate the given expression
     * @param {string} expr   A string containing an expression, for example "2+3"
     * @return {*} result     The result, or undefined when the expression was empty
     * @throws {Error}
     */
    Parser.prototype.eval = function (expr) {
      // TODO: validate arguments
      return _parse(expr)
          .compile()
          .eval(this.scope);
    };

    /**
     * Get a variable (a function or variable) by name from the parsers scope.
     * Returns undefined when not found
     * @param {string} name
     * @return {* | undefined} value
     */
    Parser.prototype.get = function (name) {
      // TODO: validate arguments
      return name in this.scope
          ? customs.getSafeProperty(this.scope, name)
          : undefined;
    };

    /**
     * Get a map with all defined variables
     * @return {Object} values
     */
    Parser.prototype.getAll = function () {
      return extend$1({}, this.scope);
    };

    /**
     * Set a symbol (a function or variable) by name from the parsers scope.
     * @param {string} name
     * @param {* | undefined} value
     */
    Parser.prototype.set = function (name, value) {
      // TODO: validate arguments
      return customs.setSafeProperty(this.scope, name, value);
    };

    /**
     * Remove a variable from the parsers scope
     * @param {string} name
     */
    Parser.prototype.remove = function (name) {
      // TODO: validate arguments
      delete this.scope[name];
    };

    /**
     * Clear the scope with variables and functions
     */
    Parser.prototype.clear = function () {
      for (var name in this.scope) {
        if (this.scope.hasOwnProperty(name)) {
          delete this.scope[name];
        }
      }
    };

    return Parser;
  }

  var name$59 = 'Parser';
  var path$30 = 'expression';
  var factory_1$64 = factory$65;
  var math$10 = true; // requires the math namespace as 5th argument

  var Parser = {
  	name: name$59,
  	path: path$30,
  	factory: factory_1$64,
  	math: math$10
  };

  function factory$66 (type, config, load, typed, math) {
    var Parser$$1 = load(Parser);

    /**
     * Create a parser. The function creates a new `math.expression.Parser` object.
     *
     * Syntax:
     *
     *    math.parser()
     *
     * Examples:
     *
     *     var parser = new math.parser();
     *
     *     // evaluate expressions
     *     var a = parser.eval('sqrt(3^2 + 4^2)'); // 5
     *     var b = parser.eval('sqrt(-4)');        // 2i
     *     var c = parser.eval('2 inch in cm');    // 5.08 cm
     *     var d = parser.eval('cos(45 deg)');     // 0.7071067811865476
     *
     *     // define variables and functions
     *     parser.eval('x = 7 / 2');               // 3.5
     *     parser.eval('x + 3');                   // 6.5
     *     parser.eval('function f(x, y) = x^y');  // f(x, y)
     *     parser.eval('f(2, 3)');                 // 8
     *
     *     // get and set variables and functions
     *     var x = parser.get('x');                // 7
     *     var f = parser.get('f');                // function
     *     var g = f(3, 2);                        // 9
     *     parser.set('h', 500);
     *     var i = parser.eval('h / 2');           // 250
     *     parser.set('hello', function (name) {
     *       return 'hello, ' + name + '!';
     *     });
     *     parser.eval('hello("user")');           // "hello, user!"
     *
     *     // clear defined functions and variables
     *     parser.clear();
     *
     * See also:
     *
     *    eval, compile, parse
     *
     * @return {Parser} Parser
     */
    return typed('parser', {
      '': function () {
        return new Parser$$1(math);
      }
    });
  }

  var name$60 = 'parser';
  var factory_1$65 = factory$66;
  var math$11 = true; // requires the math namespace as 5th argument

  var parser = {
  	name: name$60,
  	factory: factory_1$65,
  	math: math$11
  };

  var _function$2 = [
    compile,
    _eval$1,
    help$1,
    parse$1,
    parser
  ];

  function factory$67 (type, config, load, typed) {
    /**
     * @constructor UpdateNode
     */
    function UpdateNode() {
      // TODO: deprecated since v3. Cleanup some day
      throw new Error('UpdateNode is deprecated. Use AssignmentNode instead.');
    }

    return UpdateNode;
  }

  var name$61 = 'UpdateNode';
  var path$31 = 'expression.node';
  var factory_1$66 = factory$67;

  var UpdateNode = {
  	name: name$61,
  	path: path$31,
  	factory: factory_1$66
  };

  var node = [
    AccessorNode,
    ArrayNode,
    AssignmentNode,
    BlockNode,
    ConditionalNode,
    ConstantNode,
    IndexNode,
    FunctionAssignmentNode,
    FunctionNode,
    Node,
    ObjectNode,
    OperatorNode,
    ParenthesisNode,
    RangeNode,
    SymbolNode,
    UpdateNode
  ];

  var clone$4 = object.clone;
  var isInteger$4 = number.isInteger;




  function factory$68 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Concatenate two or more matrices.
     *
     * Syntax:
     *
     *     math.concat(A, B, C, ...)
     *     math.concat(A, B, C, ..., dim)
     *
     * Where:
     *
     * - `dim: number` is a zero-based dimension over which to concatenate the matrices.
     *   By default the last dimension of the matrices.
     *
     * Examples:
     *
     *    var A = [[1, 2], [5, 6]];
     *    var B = [[3, 4], [7, 8]];
     *
     *    math.concat(A, B);                  // returns [[1, 2, 3, 4], [5, 6, 7, 8]]
     *    math.concat(A, B, 0);               // returns [[1, 2], [5, 6], [3, 4], [7, 8]]
     *    math.concat('hello', ' ', 'world'); // returns 'hello world'
     *
     * See also:
     *
     *    size, squeeze, subset, transpose
     *
     * @param {... Array | Matrix} args     Two or more matrices
     * @return {Array | Matrix} Concatenated matrix
     */
    var concat = typed('concat', {
      // TODO: change signature to '...Array | Matrix, dim?' when supported
      '...Array | Matrix | number | BigNumber': function (args) {
        var i;
        var len = args.length;
        var dim = -1;  // zero-based dimension
        var prevDim;
        var asMatrix = false;
        var matrices = [];  // contains multi dimensional arrays

        for (i = 0; i < len; i++) {
          var arg = args[i];

          // test whether we need to return a Matrix (if not we return an Array)
          if (type.isMatrix(arg)) {
            asMatrix = true;
          }

          if (type.isNumber(arg) || type.isBigNumber(arg)) {
            if (i !== len - 1) {
              throw new Error('Dimension must be specified as last argument');
            }

            // last argument contains the dimension on which to concatenate
            prevDim = dim;
            dim = arg.valueOf(); // change BigNumber to number

            if (!isInteger$4(dim)) {
              throw new TypeError('Integer number expected for dimension');
            }

            if (dim < 0 || (i > 0 && dim > prevDim)) {
              // TODO: would be more clear when throwing a DimensionError here
              throw new IndexError_1(dim, prevDim + 1);
            }
          }
          else {
            // this is a matrix or array
            var m = clone$4(arg).valueOf();
            var size = array.size(m);
            matrices[i] = m;
            prevDim = dim;
            dim = size.length - 1;

            // verify whether each of the matrices has the same number of dimensions
            if (i > 0 && dim != prevDim) {
              throw new DimensionError_1(prevDim + 1, dim + 1);
            }
          }
        }

        if (matrices.length == 0) {
          throw new SyntaxError('At least one matrix expected');
        }

        var res = matrices.shift();
        while (matrices.length) {
          res = _concat(res, matrices.shift(), dim, 0);
        }

        return asMatrix ? matrix$$1(res) : res;
      },

      '...string': function (args) {
        return args.join('');
      }
    });

    concat.toTex = undefined; // use default template

    return concat;
  }

  /**
   * Recursively concatenate two matrices.
   * The contents of the matrices is not cloned.
   * @param {Array} a             Multi dimensional array
   * @param {Array} b             Multi dimensional array
   * @param {number} concatDim    The dimension on which to concatenate (zero-based)
   * @param {number} dim          The current dim (zero-based)
   * @return {Array} c            The concatenated matrix
   * @private
   */
  function _concat(a, b, concatDim, dim) {
    if (dim < concatDim) {
      // recurse into next dimension
      if (a.length != b.length) {
        throw new DimensionError_1(a.length, b.length);
      }

      var c = [];
      for (var i = 0; i < a.length; i++) {
        c[i] = _concat(a[i], b[i], concatDim, dim + 1);
      }
      return c;
    }
    else {
      // concatenate this dimension
      return a.concat(b);
    }
  }

  var name$62 = 'concat';
  var factory_1$67 = factory$68;

  var concat$1 = {
  	name: name$62,
  	factory: factory_1$67
  };

  var errorTransform$2 = error_transform.transform;

  /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function concat
   * from one-based to zero based
   */
  function factory$69 (type, config, load, typed) {
    var concat = load(concat$1);

    // @see: comment of concat itself
   return typed('concat', {
      '...any': function (args) {
        // change last argument from one-based to zero-based
        var lastIndex = args.length - 1;
        var last = args[lastIndex];
        if (type.isNumber(last)) {
          args[lastIndex] = last - 1;
        }
        else if (type.isBigNumber(last)) {
          args[lastIndex] = last.minus(1);
        }

        try {
          return concat.apply(null, args);
        }
        catch (err) {
          throw errorTransform$2(err);
        }
      }
    });
  }

  var name$63 = 'concat';
  var path$32 = 'expression.transform';
  var factory_1$68 = factory$69;

  var concat_transform = {
  	name: name$63,
  	path: path$32,
  	factory: factory_1$68
  };

  function factory$70 (type, config, load, typed) {
    /**
     * Compile an inline expression like "x > 0"
     * @param {Node} expression
     * @param {Object} math
     * @param {Object} scope
     * @return {function} Returns a function with one argument which fills in the
     *                    undefined variable (like "x") and evaluates the expression
     */
    return function compileInlineExpression(expression, math, scope) {
      // find an undefined symbol
      var symbol = expression.filter(function (node) {
        return type.isSymbolNode(node) &&
            !(node.name in math) &&
            !(node.name in scope);
      })[0];

      if (!symbol) {
        throw new Error('No undefined variable found in inline expression "' + expression + '"');
      }

      // create a test function for this equation
      var name = symbol.name; // variable name
      var subScope = Object.create(scope);
      var eq = expression.compile();
      return function inlineExpression(x) {
        subScope[name] = x;
        return eq.eval(subScope);
      }
    };
  }

  var factory_1$69 = factory$70;

  var compileInlineExpression = {
  	factory: factory_1$69
  };

  var filter$1 = array.filter;
  var filterRegExp = array.filterRegExp;
  var maxArgumentCount$1 = _function.maxArgumentCount;

  /**
   * Attach a transform function to math.filter
   * Adds a property transform containing the transform function.
   *
   * This transform adds support for equations as test function for math.filter,
   * so you can do something like 'filter([3, -2, 5], x > 0)'.
   */
  function factory$71 (type, config, load, typed) {
    var compileInlineExpression$$1 = load(compileInlineExpression);
    var matrix$$1 = load(matrix);

    function filterTransform(args, math, scope) {
      var x, callback;

      if (args[0]) {
        x = args[0].compile().eval(scope);
      }

      if (args[1]) {
        if (type.isSymbolNode(args[1]) || type.isFunctionAssignmentNode(args[1])) {
          // a function pointer, like filter([3, -2, 5], myTestFunction);
          callback = args[1].compile().eval(scope);
        }
        else {
          // an expression like filter([3, -2, 5], x > 0)
          callback = compileInlineExpression$$1(args[1], math, scope);
        }
      }

      return filter(x, callback);
    }
    filterTransform.rawArgs = true;

    // one based version of function filter
    var filter = typed('filter', {
      'Array, function': _filter,

      'Matrix, function': function (x, test) {
        return matrix$$1(_filter(x.toArray(), test));
      },

      'Array, RegExp': filterRegExp,

      'Matrix, RegExp': function (x, test) {
        return matrix$$1(filterRegExp(x.toArray(), test));
      }
    });

    filter.toTex = undefined; // use default template

    return filterTransform;
  }

  /**
   * Filter values in a callback given a callback function
   *
   * !!! Passes a one-based index !!!
   *
   * @param {Array} x
   * @param {Function} callback
   * @return {Array} Returns the filtered array
   * @private
   */
  function _filter (x, callback) {
    // figure out what number of arguments the callback function expects
    var args = maxArgumentCount$1(callback);

    return filter$1(x, function (value, index, array$$1) {
      // invoke the callback function with the right number of arguments
      if (args === 1) {
        return callback(value);
      }
      else if (args === 2) {
        return callback(value, [index + 1]);
      }
      else { // 3 or -1
        return callback(value, [index + 1], array$$1);
      }
    });
  }

  var name$64 = 'filter';
  var path$33 = 'expression.transform';
  var factory_1$70 = factory$71;

  var filter_transform = {
  	name: name$64,
  	path: path$33,
  	factory: factory_1$70
  };

  var maxArgumentCount$2 = _function.maxArgumentCount;
  var forEach$3 = array.forEach;

  /**
   * Attach a transform function to math.forEach
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */
  function factory$72 (type, config, load, typed) {
    var compileInlineExpression$$1 = load(compileInlineExpression);

    function forEachTransform(args, math, scope) {
      var x, callback;

      if (args[0]) {
        x = args[0].compile().eval(scope);
      }

      if (args[1]) {
          if (type.isSymbolNode(args[1]) || type.isFunctionAssignmentNode(args[1])) {
          // a function pointer, like forEach([3, -2, 5], myTestFunction);
          callback = args[1].compile().eval(scope);
        }
        else {
          // an expression like forEach([3, -2, 5], x > 0 ? callback1(x) : callback2(x) )
          callback = compileInlineExpression$$1(args[1], math, scope);
        }
      }

      return _forEach(x, callback);
    }
    forEachTransform.rawArgs = true;

    // one-based version of forEach
    var _forEach = typed('forEach', {
      'Array | Matrix, function': function (array$$1, callback) {
        // figure out what number of arguments the callback function expects
        var args = maxArgumentCount$2(callback);

        var recurse = function (value, index) {
          if (Array.isArray(value)) {
            forEach$3(value, function (child, i) {
              // we create a copy of the index array and append the new index value
              recurse(child, index.concat(i + 1)); // one based index, hence i+1
            });
          }
          else {
            // invoke the callback function with the right number of arguments
            if (args === 1) {
              callback(value);
            }
            else if (args === 2) {
              callback(value, index);
            }
            else { // 3 or -1
              callback(value, index, array$$1);
            }
          }
        };
        recurse(array$$1.valueOf(), []); // pass Array
      }
    });

    return forEachTransform;
  }

  var name$65 = 'forEach';
  var path$34 = 'expression.transform';
  var factory_1$71 = factory$72;

  var forEach_transform = {
  	name: name$65,
  	path: path$34,
  	factory: factory_1$71
  };

  /**
   * Attach a transform function to math.index
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */
  function factory$73 (type, config, load) {

    return function indexTransform() {
      var args = [];
      for (var i = 0, ii = arguments.length; i < ii; i++) {
        var arg = arguments[i];

        // change from one-based to zero based, and convert BigNumber to number
        if (type.isRange(arg)) {
          arg.start--;
          arg.end -= (arg.step > 0 ? 0 : 2);
        }
        else if (arg && arg.isSet === true) {
          arg = arg.map(function (v) { return v - 1; });
        }
        else if (type.isArray(arg) || type.isMatrix(arg)) {
          arg = arg.map(function (v) { return v - 1; });
        }
        else if (type.isNumber(arg)) {
          arg--;
        }
        else if (type.isBigNumber(arg)) {
          arg = arg.toNumber() - 1;
        }
        else if (typeof arg === 'string') {
          // leave as is
        }
        else {
          throw new TypeError('Dimension must be an Array, Matrix, number, string, or Range');
        }

        args[i] = arg;
      }

      var res = new type.Index();
      type.Index.apply(res, args);
      return res;
    };
  }

  var name$66 = 'index';
  var path$35 = 'expression.transform';
  var factory_1$72 = factory$73;

  var index_transform = {
  	name: name$66,
  	path: path$35,
  	factory: factory_1$72
  };

  var maxArgumentCount$3 = _function.maxArgumentCount;
  var map$6 = array.map;

  /**
   * Attach a transform function to math.map
   * Adds a property transform containing the transform function.
   *
   * This transform creates a one-based index instead of a zero-based index
   */
  function factory$74 (type, config, load, typed) {
    var compileInlineExpression$$1 = load(compileInlineExpression);
    var matrix$$1 = load(matrix);

    function mapTransform(args, math, scope) {
      var x, callback;

      if (args[0]) {
        x = args[0].compile().eval(scope);
      }

      if (args[1]) {
        if (type.isSymbolNode(args[1]) || type.isFunctionAssignmentNode(args[1])) {
          // a function pointer, like filter([3, -2, 5], myTestFunction);
          callback = args[1].compile().eval(scope);
        }
        else {
          // an expression like filter([3, -2, 5], x > 0)
          callback = compileInlineExpression$$1(args[1], math, scope);
        }
      }

      return map(x, callback);
    }
    mapTransform.rawArgs = true;

    // one-based version of map function
    var map = typed('map', {
      'Array, function': function (x, callback) {
        return _map(x, callback, x);
      },

      'Matrix, function': function (x, callback) {
        return matrix$$1(_map(x.valueOf(), callback, x));
      }
    });

    return mapTransform;
  }

  /**
   * Map for a multi dimensional array. One-based indexes
   * @param {Array} array
   * @param {function} callback
   * @param {Array} orig
   * @return {Array}
   * @private
   */
  function _map (array$$1, callback, orig) {
    // figure out what number of arguments the callback function expects
    var argsCount = maxArgumentCount$3(callback);

    function recurse(value, index) {
      if (Array.isArray(value)) {
        return map$6(value, function (child, i) {
          // we create a copy of the index array and append the new index value
          return recurse(child, index.concat(i + 1)); // one based index, hence i + 1
        });
      }
      else {
        // invoke the (typed) callback function with the right number of arguments
        if (argsCount === 1) {
          return callback(value);
        }
        else if (argsCount === 2) {
          return callback(value, index);
        }
        else { // 3 or -1
          return callback(value, index, orig);
        }
      }
    }

    return recurse(array$$1, []);
  }

  var name$67 = 'map';
  var path$36 = 'expression.transform';
  var factory_1$73 = factory$74;

  var map_transform = {
  	name: name$67,
  	path: path$36,
  	factory: factory_1$73
  };

  /**
   * Test whether a value is a collection: an Array or Matrix
   * @param {*} x
   * @returns {boolean} isCollection
   */
  var isCollection = function isCollection (x) {
    return Array.isArray(x) || isMatrix(x);
  };

  /**
   * Recursively loop over all elements in a given multi dimensional array
   * and invoke the callback on each of the elements.
   * @param {Array | Matrix} array
   * @param {Function} callback     The callback method is invoked with one
   *                                parameter: the current element in the array
   */
  var deepForEach = function deepForEach (array, callback) {
    if (isMatrix(array)) {
      array = array.valueOf();
    }

    for (var i = 0, ii = array.length; i < ii; i++) {
      var value = array[i];

      if (Array.isArray(value)) {
        deepForEach(value, callback);
      }
      else {
        callback(value);
      }
    }
  };

  var arraySize = array.size;



  /**
   * Reduce a given matrix or array to a new matrix or
   * array with one less dimension, applying the given
   * callback in the selected dimension.
   * @param {Array | Matrix} mat
   * @param {number} dim
   * @param {Function} callback
   * @return {Array | Matrix} res
   */
  var reduce = function(mat, dim, callback) {
    var size = Array.isArray(mat) ? arraySize(mat) : mat.size();
    if (dim < 0 || (dim >= size.length)) {
      // TODO: would be more clear when throwing a DimensionError here
      throw new IndexError_1(dim, size.length);
    }

    if (isMatrix(mat)) {
      return mat.create(_reduce(mat.valueOf(), dim, callback));
    }else {
      return _reduce(mat, dim, callback);
    }
  };

  /**
   * Recursively reduce a matrix
   * @param {Array} mat
   * @param {number} dim
   * @param {Function} callback
   * @returns {Array} ret
   * @private
   */
  function _reduce(mat, dim, callback){
    var i, ret, val, tran;

    if(dim<=0){
      if( !Array.isArray(mat[0]) ){
        val = mat[0];
        for(i=1; i<mat.length; i++){
          val = callback(val, mat[i]);
        }
        return val;
      }else{
        tran = _switch(mat);
        ret = [];
        for(i=0; i<tran.length; i++){
          ret[i] = _reduce(tran[i], dim-1, callback);
        }
        return ret;
      }
    }else{
      ret = [];
      for(i=0; i<mat.length; i++){
        ret[i] = _reduce(mat[i], dim-1, callback);
      }
      return ret;
    }
  }

  /**
   * Transpose a matrix
   * @param {Array} mat
   * @returns {Array} ret
   * @private
   */
  function _switch(mat){
    var I = mat.length;
    var J = mat[0].length;
    var i, j;
    var ret = [];
    for( j=0; j<J; j++) {
      var tmp = [];
      for( i=0; i<I; i++) {
        tmp.push(mat[i][j]);
      }
      ret.push(tmp);
    }
    return ret;
  }

  /**
   * Test whether an array contains collections
   * @param {Array} array
   * @returns {boolean} Returns true when the array contains one or multiple
   *                    collections (Arrays or Matrices). Returns false otherwise.
   */
  var containsCollections = function containsCollections (array) {
    for (var i = 0; i < array.length; i++) {
      if (isCollection(array[i])) {
        return true;
      }
    }
    return false;
  };

  function factory$75 (type, config, load, typed) {
    var getType = load(_typeof$1);

    /**
     * Improve error messages for statistics functions. Errors are typically
     * thrown in an internally used function like larger, causing the error
     * not to mention the function (like max) which is actually used by the user.
     *
     * @param {Error} err
     * @param {String} fnName
     * @param {*} [value]
     * @return {Error}
     */
    return function improveErrorMessage(err, fnName, value) {
      // TODO: add information with the index (also needs transform in expression parser)
      var details;

      if (String(err).indexOf('Unexpected type') !== -1) {
        details = arguments.length > 2
            ? ' (type: ' + getType(value) + ', value: ' + JSON.stringify(value) + ')'
            : ' (type: ' + err.data.actual + ')';

        return new TypeError('Cannot calculate ' + fnName + ', unexpected type of argument' + details);
      }

      if (String(err).indexOf('complex numbers') !== -1) {
        details = arguments.length > 2
            ? ' (type: ' + getType(value) + ', value: ' + JSON.stringify(value) + ')'
            : '';

        return new TypeError('Cannot calculate ' + fnName + ', no ordering relation is defined for complex numbers' + details);
      }

      return err;
    }
  }

  var factory_1$74 = factory$75;

  var improveErrorMessage = {
  	factory: factory_1$74
  };

  function factory$76 (type, config, load, typed) {
    var larger$$1 = load(larger);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the maximum value of a matrix or a  list with values.
     * In case of a multi dimensional array, the maximum of the flattened array
     * will be calculated. When `dim` is provided, the maximum over the selected
     * dimension will be calculated. Parameter `dim` is zero-based.
     *
     * Syntax:
     *
     *     math.max(a, b, c, ...)
     *     math.max(A)
     *     math.max(A, dim)
     *
     * Examples:
     *
     *     math.max(2, 1, 4, 3);                  // returns 4
     *     math.max([2, 1, 4, 3]);                // returns 4
     *
     *     // maximum over a specified dimension (zero-based)
     *     math.max([[2, 5], [4, 3], [1, 7]], 0); // returns [4, 7]
     *     math.max([[2, 5], [4, 3]], [1, 7], 1); // returns [5, 4, 7]
     *
     *     math.max(2.7, 7.1, -4.5, 2.0, 4.1);    // returns 7.1
     *     math.min(2.7, 7.1, -4.5, 2.0, 4.1);    // returns -4.5
     *
     * See also:
     *
     *    mean, median, min, prod, std, sum, var
     *
     * @param {... *} args  A single matrix or or multiple scalar values
     * @return {*} The maximum value
     */
    var max = typed('max', {
      // max([a, b, c, d, ...])
      'Array | Matrix': _max,

      // max([a, b, c, d, ...], dim)
      'Array | Matrix, number | BigNumber': function (array, dim) {
        return reduce(array, dim.valueOf(), _largest);
      },

      // max(a, b, c, d, ...)
      '...': function (args) {
        if (containsCollections(args)) {
          throw new TypeError('Scalar values expected in function max');
        }

        return _max(args);
      }
    });

    max.toTex = '\\max\\left(${args}\\right)';

    return max;

    /**
     * Return the largest of two values
     * @param {*} x
     * @param {*} y
     * @returns {*} Returns x when x is largest, or y when y is largest
     * @private
     */
    function _largest(x, y) {
      try {
        return larger$$1(x, y) ? x : y;
      }
      catch (err) {
        throw improveErrorMessage$$1(err, 'max', y);
      }
    }

    /**
     * Recursively calculate the maximum value in an n-dimensional array
     * @param {Array} array
     * @return {number} max
     * @private
     */
    function _max(array) {
      var max = undefined;

      deepForEach(array, function (value) {
        try {
          if (max === undefined || larger$$1(value, max)) {
            max = value;
          }
        }
        catch (err) {
          throw improveErrorMessage$$1(err, 'max', value);
        }
      });

      if (max === undefined) {
        throw new Error('Cannot calculate max of an empty array');
      }

      return max;
    }

  }

  var name$68 = 'max';
  var factory_1$75 = factory$76;

  var max$1 = {
  	name: name$68,
  	factory: factory_1$75
  };

  var errorTransform$3 = error_transform.transform;


  /**
   * Attach a transform function to math.max
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function max
   * from one-based to zero based
   */
  function factory$77 (type, config, load, typed) {
    var max = load(max$1);

    return typed('max', {
      '...any': function (args) {
        // change last argument dim from one-based to zero-based
        if (args.length == 2 && isCollection(args[0])) {
          var dim = args[1];
          if (type.isNumber(dim)) {
            args[1] = dim - 1;
          }
          else if (type.isBigNumber(dim)) {
            args[1] = dim.minus(1);
          }
        }

        try {
          return max.apply(null, args);
        }
        catch (err) {
          throw errorTransform$3(err);
        }
      }
    });
  }

  var name$69 = 'max';
  var path$37 = 'expression.transform';
  var factory_1$76 = factory$77;

  var max_transform = {
  	name: name$69,
  	path: path$37,
  	factory: factory_1$76
  };

  function factory$78(type, config, load, typed) {
    
    /**
     * Multiply two scalar values, `x * y`.
     * This function is meant for internal use: it is used by the public function
     * `multiply`
     *
     * This function does not support collections (Array or Matrix), and does
     * not validate the number of of inputs.
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit} x   First value to multiply
     * @param  {number | BigNumber | Fraction | Complex} y          Second value to multiply
     * @return {number | BigNumber | Fraction | Complex | Unit}                      Multiplication of `x` and `y`
     * @private
     */
    var multiplyScalar = typed('multiplyScalar', {

      'number, number': function (x, y) {
        return x * y;
      },

      'Complex, Complex': function (x, y) {
        return x.mul(y);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.times(y);
      },

      'Fraction, Fraction': function (x, y) {
        return x.mul(y);
      },

      'number | Fraction | BigNumber | Complex, Unit': function (x, y) {
        var res = y.clone();
        res.value = (res.value === null) ? res._normalize(x) : multiplyScalar(res.value, x);
        return res;
      },

      'Unit, number | Fraction | BigNumber | Complex': function (x, y) {
        var res = x.clone();
        res.value = (res.value === null) ? res._normalize(y) : multiplyScalar(res.value, y);
        return res;
      },

      'Unit, Unit': function (x, y) {
        return x.multiply(y);
      }

    });

    return multiplyScalar;
  }

  var factory_1$77 = factory$78;

  var multiplyScalar = {
  	factory: factory_1$77
  };

  function factory$79(type, config, load, typed) {
    var multiplyScalar$$1 = load(multiplyScalar);

    /**
     * Divide two scalar values, `x / y`.
     * This function is meant for internal use: it is used by the public functions
     * `divide` and `inv`.
     *
     * This function does not support collections (Array or Matrix), and does
     * not validate the number of of inputs.
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit} x   Numerator
     * @param  {number | BigNumber | Fraction | Complex} y          Denominator
     * @return {number | BigNumber | Fraction | Complex | Unit}                      Quotient, `x / y`
     * @private
     */
    var divideScalar = typed('divide', {
      'number, number': function (x, y) {
        return x / y;
      },

      'Complex, Complex': function (x, y) {
        return x.div(y);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.div(y);
      },

      'Fraction, Fraction': function (x, y) {
        return x.div(y);
      },

      'Unit, number | Fraction | BigNumber': function (x, y) {
        var res = x.clone();
        // TODO: move the divide function to Unit.js, it uses internals of Unit
        res.value = divideScalar(((res.value === null) ? res._normalize(1) : res.value), y);
        return res;
      },

      'number | Fraction | BigNumber, Unit': function (x, y) {
        var res = y.pow(-1);
        // TODO: move the divide function to Unit.js, it uses internals of Unit
        res.value = multiplyScalar$$1(((res.value === null) ? res._normalize(1) : res.value), x);
        return res;
      },

      'Unit, Unit': function (x, y) {
        return x.divide(y);
      }

    });

    return divideScalar;
  }

  var factory_1$78 = factory$79;

  var divideScalar = {
  	factory: factory_1$78
  };

  function factory$80 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix S nonzero items and invokes the callback function f(Sij, b). 
     * Callback function invoked NZ times (number of nonzero items in S).
     *
     *
     *          ┌  f(Sij, b)  ; S(i,j) !== 0
     * C(i,j) = ┤  
     *          └  0          ; otherwise
     *
     *
     * @param {Matrix}   s                 The SparseMatrix instance (S)
     * @param {Scalar}   b                 The Scalar value
     * @param {Function} callback          The f(Aij,b) operation to invoke
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(b,Sij)
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * https://github.com/josdejong/mathjs/pull/346#issuecomment-97626813
     */
    var algorithm11 = function (s, b, callback, inverse) {
      // sparse matrix arrays
      var avalues = s._values;
      var aindex = s._index;
      var aptr = s._ptr;
      var asize = s._size;
      var adt = s._datatype;

      // sparse matrix cannot be a Pattern matrix
      if (!avalues)
        throw new Error('Cannot perform operation on Pattern Sparse Matrix and Scalar value');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // convert b to the same datatype
        b = typed.convert(b, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cvalues = [];
      var cindex = [];
      var cptr = [];
      // matrix
      var c = new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });

      // loop columns
      for (var j = 0; j < columns; j++) {
        // initialize ptr
        cptr[j] = cindex.length;
        // values in j
        for (var k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
          // row
          var i = aindex[k];
          // invoke callback
          var v = inverse ? cf(b, avalues[k]) : cf(avalues[k], b);
          // check value is zero
          if (!eq(v, zero)) {
            // push index & value
            cindex.push(i);
            cvalues.push(v);
          }
        }
      }
      // update ptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return c;
    };

    return algorithm11;
  }

  var name$70 = 'algorithm11';
  var factory_1$79 = factory$80;

  var algorithm11 = {
  	name: name$70,
  	factory: factory_1$79
  };

  var extend$2 = object.extend;


  function factory$81 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);
    var addScalar$$1 = load(addScalar);
    var multiplyScalar$$1 = load(multiplyScalar);
    var equalScalar$$1 = load(equalScalar);

    var algorithm11$$1 = load(algorithm11);
    var algorithm14$$1 = load(algorithm14);
    
    var DenseMatrix = type.DenseMatrix;
    var SparseMatrix = type.SparseMatrix;

    /**
     * Multiply two or more values, `x * y`.
     * For matrices, the matrix product is calculated.
     *
     * Syntax:
     *
     *    math.multiply(x, y)
     *    math.multiply(x, y, z, ...)
     *
     * Examples:
     *
     *    math.multiply(4, 5.2);        // returns number 20.8
     *    math.multiply(2, 3, 4);       // returns number 24
     *
     *    var a = math.complex(2, 3);
     *    var b = math.complex(4, 1);
     *    math.multiply(a, b);          // returns Complex 5 + 14i
     *
     *    var c = [[1, 2], [4, 3]];
     *    var d = [[1, 2, 3], [3, -4, 7]];
     *    math.multiply(c, d);          // returns Array [[7, -6, 17], [13, -4, 33]]
     *
     *    var e = math.unit('2.1 km');
     *    math.multiply(3, e);          // returns Unit 6.3 km
     *
     * See also:
     *
     *    divide, prod, cross, dot
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First value to multiply
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second value to multiply
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Multiplication of `x` and `y`
     */
    var multiply = typed('multiply', extend$2({
      // we extend the signatures of multiplyScalar with signatures dealing with matrices

      'Array, Array': function (x, y) {
        // check dimensions
        _validateMatrixDimensions(array.size(x), array.size(y));

        // use dense matrix implementation
        var m = multiply(matrix$$1(x), matrix$$1(y));
        // return array or scalar
        return type.isMatrix(m) ? m.valueOf() : m;
      },

      'Matrix, Matrix': function (x, y) {
        // dimensions
        var xsize = x.size();
        var ysize = y.size();

        // check dimensions
        _validateMatrixDimensions(xsize, ysize);

        // process dimensions
        if (xsize.length === 1) {
          // process y dimensions
          if (ysize.length === 1) {
            // Vector * Vector
            return _multiplyVectorVector(x, y, xsize[0]);
          }
          // Vector * Matrix
          return _multiplyVectorMatrix(x, y);
        }
        // process y dimensions
        if (ysize.length === 1) {
          // Matrix * Vector
          return _multiplyMatrixVector(x, y);
        }
        // Matrix * Matrix
        return _multiplyMatrixMatrix(x, y);
      },

      'Matrix, Array': function (x, y) {
        // use Matrix * Matrix implementation
        return multiply(x, matrix$$1(y));
      },

      'Array, Matrix': function (x, y) {
        // use Matrix * Matrix implementation
        return multiply(matrix$$1(x, y.storage()), y);
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, multiplyScalar$$1, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, multiplyScalar$$1, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm11$$1(y, x, multiplyScalar$$1, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, multiplyScalar$$1, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, multiplyScalar$$1, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, multiplyScalar$$1, true).valueOf();
      },

      'any, any': multiplyScalar$$1,

      'any, any, ...any': function (x, y, rest) {
        var result = multiply(x, y);

        for (var i = 0; i < rest.length; i++) {
          result = multiply(result, rest[i]);
        }
        
        return result;
      }
    }, multiplyScalar$$1.signatures));

    var _validateMatrixDimensions = function (size1, size2) {
      // check left operand dimensions
      switch (size1.length) {
        case 1:
          // check size2
          switch (size2.length) {
            case 1:
              // Vector x Vector
              if (size1[0] !== size2[0]) {
                // throw error
                throw new RangeError('Dimension mismatch in multiplication. Vectors must have the same length');
              }
              break;
            case 2:
              // Vector x Matrix
              if (size1[0] !== size2[0]) {
                // throw error
                throw new RangeError('Dimension mismatch in multiplication. Vector length (' + size1[0] + ') must match Matrix rows (' + size2[0] + ')');
              }
              break;
            default:
              throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
          }
          break;
        case 2:
          // check size2
          switch (size2.length) {
            case 1:
              // Matrix x Vector
              if (size1[1] !== size2[0]) {
                // throw error
                throw new RangeError('Dimension mismatch in multiplication. Matrix columns (' + size1[1] + ') must match Vector length (' + size2[0] + ')');
              }
              break;
            case 2:
              // Matrix x Matrix
              if (size1[1] !== size2[0]) {
                // throw error
                throw new RangeError('Dimension mismatch in multiplication. Matrix A columns (' + size1[1] + ') must match Matrix B rows (' + size2[0] + ')');
              }
              break;
            default:
              throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix B has ' + size2.length + ' dimensions)');
          }
          break;
        default:
          throw new Error('Can only multiply a 1 or 2 dimensional matrix (Matrix A has ' + size1.length + ' dimensions)');
      }
    };

    /**
     * C = A * B
     *
     * @param {Matrix} a            Dense Vector   (N)
     * @param {Matrix} b            Dense Vector   (N)
     *
     * @return {number}             Scalar value
     */
    var _multiplyVectorVector = function (a, b, n) {
      // check empty vector
      if (n === 0)
        throw new Error('Cannot multiply two empty vectors');

      // a dense
      var adata = a._data;
      var adt = a._datatype;
      // b dense
      var bdata = b._data;
      var bdt = b._datatype;

      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
      }
      
      // result (do not initialize it with zero)
      var c = mf(adata[0], bdata[0]);
      // loop data
      for (var i = 1; i < n; i++) {
        // multiply and accumulate
        c = af(c, mf(adata[i], bdata[i]));
      }
      return c;
    };

    /**
     * C = A * B
     *
     * @param {Matrix} a            Dense Vector   (M)
     * @param {Matrix} b            Matrix         (MxN)
     *
     * @return {Matrix}             Dense Vector   (N)
     */
    var _multiplyVectorMatrix = function (a, b) {
      // process storage
      if (b.storage() !== 'dense') {
        throw new Error('Support for SparseMatrix not implemented');
      }
      return _multiplyVectorDenseMatrix(a, b);
    };

    /**
     * C = A * B
     *
     * @param {Matrix} a            Dense Vector   (M)
     * @param {Matrix} b            Dense Matrix   (MxN)
     *
     * @return {Matrix}             Dense Vector   (N)
     */
    var _multiplyVectorDenseMatrix = function (a, b) {
      // a dense
      var adata = a._data;
      var asize = a._size;
      var adt = a._datatype;
      // b dense
      var bdata = b._data;
      var bsize = b._size;
      var bdt = b._datatype;
      // rows & columns
      var alength = asize[0];
      var bcolumns = bsize[1];

      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
      }

      // result
      var c = [];

      // loop matrix columns
      for (var j = 0; j < bcolumns; j++) {
        // sum (do not initialize it with zero)
        var sum = mf(adata[0], bdata[0][j]);      
        // loop vector
        for (var i = 1; i < alength; i++) {
          // multiply & accumulate
          sum = af(sum, mf(adata[i], bdata[i][j]));
        }
        c[j] = sum;
      }

      // return matrix
      return new DenseMatrix({
        data: c,
        size: [bcolumns],
        datatype: dt
      });
    };

    /**
     * C = A * B
     *
     * @param {Matrix} a            Matrix         (MxN)
     * @param {Matrix} b            Dense Vector   (N)
     *
     * @return {Matrix}             Dense Vector   (M)
     */
    var _multiplyMatrixVector = typed('_multiplyMatrixVector', {
      'DenseMatrix, any': _multiplyDenseMatrixVector,
      'SparseMatrix, any': _multiplySparseMatrixVector
    });

    /**
     * C = A * B
     *
     * @param {Matrix} a            Matrix         (MxN)
     * @param {Matrix} b            Matrix         (NxC)
     *
     * @return {Matrix}             Matrix         (MxC)
     */
    var _multiplyMatrixMatrix = typed('_multiplyMatrixMatrix', {
      'DenseMatrix, DenseMatrix': _multiplyDenseMatrixDenseMatrix,
      'DenseMatrix, SparseMatrix': _multiplyDenseMatrixSparseMatrix,
      'SparseMatrix, DenseMatrix': _multiplySparseMatrixDenseMatrix,
      'SparseMatrix, SparseMatrix': _multiplySparseMatrixSparseMatrix
    });

    /**
     * C = A * B
     *
     * @param {Matrix} a            DenseMatrix  (MxN)
     * @param {Matrix} b            Dense Vector (N)
     *
     * @return {Matrix}             Dense Vector (M) 
     */ 
    function _multiplyDenseMatrixVector(a, b) {
      // a dense
      var adata = a._data;
      var asize = a._size;
      var adt = a._datatype;
      // b dense
      var bdata = b._data;
      var bdt = b._datatype;
      // rows & columns
      var arows = asize[0];
      var acolumns = asize[1];

      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
      }

      // result
      var c = [];

      // loop matrix a rows
      for (var i = 0; i < arows; i++) {
        // current row
        var row = adata[i];
        // sum (do not initialize it with zero)
        var sum = mf(row[0], bdata[0]);
        // loop matrix a columns
        for (var j = 1; j < acolumns; j++) {
          // multiply & accumulate
          sum = af(sum, mf(row[j], bdata[j]));
        }
        c[i] = sum;
      }

      // return matrix
      return new DenseMatrix({
        data: c,
        size: [arows],
        datatype: dt
      });
    }

    /**
     * C = A * B
     *
     * @param {Matrix} a            DenseMatrix    (MxN)
     * @param {Matrix} b            DenseMatrix    (NxC)
     *
     * @return {Matrix}             DenseMatrix    (MxC)
     */
    function _multiplyDenseMatrixDenseMatrix (a, b) {
      // a dense
      var adata = a._data;
      var asize = a._size;
      var adt = a._datatype;
      // b dense
      var bdata = b._data;
      var bsize = b._size;
      var bdt = b._datatype;
      // rows & columns
      var arows = asize[0];
      var acolumns = asize[1];
      var bcolumns = bsize[1];

      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
      }
      
      // result
      var c = [];

      // loop matrix a rows
      for (var i = 0; i < arows; i++) {
        // current row
        var row = adata[i];
        // initialize row array
        c[i] = [];
        // loop matrix b columns
        for (var j = 0; j < bcolumns; j++) {
          // sum (avoid initializing sum to zero)
          var sum = mf(row[0], bdata[0][j]);
          // loop matrix a columns
          for (var x = 1; x < acolumns; x++) {
            // multiply & accumulate
            sum = af(sum, mf(row[x], bdata[x][j]));
          }
          c[i][j] = sum;
        }
      }

      // return matrix
      return new DenseMatrix({
        data: c,
        size: [arows, bcolumns],
        datatype: dt
      });
    }

    /**
     * C = A * B
     *
     * @param {Matrix} a            DenseMatrix    (MxN)
     * @param {Matrix} b            SparseMatrix   (NxC)
     *
     * @return {Matrix}             SparseMatrix   (MxC)
     */
    function _multiplyDenseMatrixSparseMatrix (a, b) {
      // a dense
      var adata = a._data;
      var asize = a._size;
      var adt = a._datatype;
      // b sparse
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      var bsize = b._size;
      var bdt = b._datatype;
      // validate b matrix
      if (!bvalues)
        throw new Error('Cannot multiply Dense Matrix times Pattern only Matrix');
      // rows & columns
      var arows = asize[0];
      var bcolumns = bsize[1];
      
      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;
      // equalScalar signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
      }

      // result
      var cvalues = [];
      var cindex = [];
      var cptr = [];
      // c matrix
      var c = new SparseMatrix({
        values : cvalues,
        index: cindex,
        ptr: cptr,
        size: [arows, bcolumns],
        datatype: dt
      });

      // loop b columns
      for (var jb = 0; jb < bcolumns; jb++) {
        // update ptr
        cptr[jb] = cindex.length;
        // indeces in column jb
        var kb0 = bptr[jb];
        var kb1 = bptr[jb + 1];
        // do not process column jb if no data exists
        if (kb1 > kb0) {
          // last row mark processed
          var last = 0;
          // loop a rows
          for (var i = 0; i < arows; i++) {
            // column mark
            var mark = i + 1;
            // C[i, jb]
            var cij;
            // values in b column j
            for (var kb = kb0; kb < kb1; kb++) {
              // row
              var ib = bindex[kb];
              // check value has been initialized
              if (last !== mark) {
                // first value in column jb
                cij = mf(adata[i][ib], bvalues[kb]);
                // update mark
                last = mark;
              }
              else {
                // accumulate value
                cij = af(cij, mf(adata[i][ib], bvalues[kb]));
              }
            }
            // check column has been processed and value != 0
            if (last === mark && !eq(cij, zero)) {
              // push row & value
              cindex.push(i);
              cvalues.push(cij);
            }
          }
        }
      }
      // update ptr
      cptr[bcolumns] = cindex.length;

      // return sparse matrix
      return c;
    }

    /**
     * C = A * B
     *
     * @param {Matrix} a            SparseMatrix    (MxN)
     * @param {Matrix} b            Dense Vector (N)
     *
     * @return {Matrix}             SparseMatrix    (M, 1) 
     */
    function _multiplySparseMatrixVector(a, b) {
      // a sparse
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var adt = a._datatype;
      // validate a matrix
      if (!avalues)
        throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
      // b dense
      var bdata = b._data;
      var bdt = b._datatype;
      // rows & columns
      var arows = a._size[0];
      var brows = b._size[0];
      // result
      var cvalues = [];
      var cindex = [];
      var cptr = [];
      
      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;
      // equalScalar signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
      }

      // workspace
      var x = [];
      // vector with marks indicating a value x[i] exists in a given column
      var w = [];

      // update ptr
      cptr[0] = 0;
      // rows in b
      for (var ib = 0; ib < brows; ib++) {
        // b[ib]
        var vbi = bdata[ib];
        // check b[ib] != 0, avoid loops
        if (!eq(vbi, zero)) {
          // A values & index in ib column
          for (var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
            // a row
            var ia = aindex[ka];
            // check value exists in current j
            if (!w[ia]) {
              // ia is new entry in j
              w[ia] = true;
              // add i to pattern of C
              cindex.push(ia);
              // x(ia) = A
              x[ia] = mf(vbi, avalues[ka]);
            }
            else {
              // i exists in C already
              x[ia] = af(x[ia], mf(vbi, avalues[ka]));
            }
          }
        }
      }
      // copy values from x to column jb of c
      for (var p1 = cindex.length, p = 0; p < p1; p++) {
        // row
        var ic = cindex[p];
        // copy value
        cvalues[p] = x[ic];
      }
      // update ptr
      cptr[1] = cindex.length;

      // return sparse matrix
      return new SparseMatrix({
        values : cvalues,
        index: cindex,
        ptr: cptr,
        size: [arows, 1],
        datatype: dt
      });
    }

    /**
     * C = A * B
     *
     * @param {Matrix} a            SparseMatrix      (MxN)
     * @param {Matrix} b            DenseMatrix       (NxC)
     *
     * @return {Matrix}             SparseMatrix      (MxC)
     */
    function _multiplySparseMatrixDenseMatrix(a, b) {
      // a sparse
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var adt = a._datatype;
      // validate a matrix
      if (!avalues)
        throw new Error('Cannot multiply Pattern only Matrix times Dense Matrix');
      // b dense
      var bdata = b._data;
      var bdt = b._datatype;
      // rows & columns
      var arows = a._size[0];
      var brows = b._size[0];
      var bcolumns = b._size[1];

      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;
      // equalScalar signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
      }

      // result
      var cvalues = [];
      var cindex = [];
      var cptr = [];
      // c matrix
      var c = new SparseMatrix({
        values : cvalues,
        index: cindex,
        ptr: cptr,
        size: [arows, bcolumns],
        datatype: dt
      });

      // workspace
      var x = [];
      // vector with marks indicating a value x[i] exists in a given column
      var w = [];

      // loop b columns
      for (var jb = 0; jb < bcolumns; jb++) {
        // update ptr
        cptr[jb] = cindex.length;
        // mark in workspace for current column
        var mark = jb + 1;
        // rows in jb
        for (var ib = 0; ib < brows; ib++) {
          // b[ib, jb]
          var vbij = bdata[ib][jb];
          // check b[ib, jb] != 0, avoid loops
          if (!eq(vbij, zero)) {
            // A values & index in ib column
            for (var ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
              // a row
              var ia = aindex[ka];
              // check value exists in current j
              if (w[ia] !== mark) {
                // ia is new entry in j
                w[ia] = mark;
                // add i to pattern of C
                cindex.push(ia);
                // x(ia) = A
                x[ia] = mf(vbij, avalues[ka]);
              }
              else {
                // i exists in C already
                x[ia] = af(x[ia], mf(vbij, avalues[ka]));
              }
            }
          }
        }
        // copy values from x to column jb of c
        for (var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++) {
          // row
          var ic = cindex[p];
          // copy value
          cvalues[p] = x[ic];
        }
      }
      // update ptr
      cptr[bcolumns] = cindex.length;

      // return sparse matrix
      return c;
    }

    /**
     * C = A * B
     *
     * @param {Matrix} a            SparseMatrix      (MxN)
     * @param {Matrix} b            SparseMatrix      (NxC)
     *
     * @return {Matrix}             SparseMatrix      (MxC)
     */
    function _multiplySparseMatrixSparseMatrix(a, b) {
      // a sparse
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var adt = a._datatype;
      // b sparse
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      var bdt = b._datatype;
      
      // rows & columns
      var arows = a._size[0];
      var bcolumns = b._size[1];
      // flag indicating both matrices (a & b) contain data
      var values = avalues && bvalues;

      // datatype
      var dt;
      // addScalar signature to use
      var af = addScalar$$1;
      // multiplyScalar signature to use
      var mf = multiplyScalar$$1;

      // process data types
      if (adt && bdt && adt === bdt && typeof adt === 'string') {
        // datatype
        dt = adt;
        // find signatures that matches (dt, dt)
        af = typed.find(addScalar$$1, [dt, dt]);
        mf = typed.find(multiplyScalar$$1, [dt, dt]);
      }
      
      // result
      var cvalues = values ? [] : undefined;
      var cindex = [];
      var cptr = [];
      // c matrix
      var c = new SparseMatrix({
        values : cvalues,
        index: cindex,
        ptr: cptr,
        size: [arows, bcolumns],
        datatype: dt
      });

      // workspace
      var x = values ? [] : undefined;
      // vector with marks indicating a value x[i] exists in a given column
      var w = [];
      // variables
      var ka, ka0, ka1, kb, kb0, kb1, ia, ib;
      // loop b columns
      for (var jb = 0; jb < bcolumns; jb++) {
        // update ptr
        cptr[jb] = cindex.length;
        // mark in workspace for current column
        var mark = jb + 1;
        // B values & index in j
        for (kb0 = bptr[jb], kb1 = bptr[jb + 1], kb = kb0; kb < kb1; kb++) {
          // b row
          ib = bindex[kb];
          // check we need to process values
          if (values) {
            // loop values in a[:,ib]
            for (ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
              // row
              ia = aindex[ka];
              // check value exists in current j
              if (w[ia] !== mark) {
                // ia is new entry in j
                w[ia] = mark;
                // add i to pattern of C
                cindex.push(ia);
                // x(ia) = A
                x[ia] = mf(bvalues[kb], avalues[ka]);
              }
              else {
                // i exists in C already
                x[ia] = af(x[ia], mf(bvalues[kb], avalues[ka]));
              }
            }
          }
          else {
            // loop values in a[:,ib]
            for (ka0 = aptr[ib], ka1 = aptr[ib + 1], ka = ka0; ka < ka1; ka++) {
              // row
              ia = aindex[ka];
              // check value exists in current j
              if (w[ia] !== mark) {
                // ia is new entry in j
                w[ia] = mark;
                // add i to pattern of C
                cindex.push(ia);
              }
            }
          }
        }
        // check we need to process matrix values (pattern matrix)
        if (values) {
          // copy values from x to column jb of c
          for (var p0 = cptr[jb], p1 = cindex.length, p = p0; p < p1; p++) {
            // row
            var ic = cindex[p];
            // copy value
            cvalues[p] = x[ic];
          }
        }
      }
      // update ptr
      cptr[bcolumns] = cindex.length;

      // return sparse matrix
      return c;
    }

    multiply.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['multiply'] + '${args[1]}\\right)'
    };

    return multiply;
  }

  var name$71 = 'multiply';
  var factory_1$80 = factory$81;

  var multiply$1 = {
  	name: name$71,
  	factory: factory_1$80
  };

  function factory$82 (type, config, load, typed) {
    var latex$$1 = latex;

    /**
     * Inverse the sign of a value, apply a unary minus operation.
     *
     * For matrices, the function is evaluated element wise. Boolean values and
     * strings will be converted to a number. For complex numbers, both real and
     * complex value are inverted.
     *
     * Syntax:
     *
     *    math.unaryMinus(x)
     *
     * Examples:
     *
     *    math.unaryMinus(3.5);      // returns -3.5
     *    math.unaryMinus(-4.2);     // returns 4.2
     *
     * See also:
     *
     *    add, subtract, unaryPlus
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Number to be inverted.
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} Returns the value with inverted sign.
     */
    var unaryMinus = typed('unaryMinus', {
      'number': function (x) {
        return -x;
      },

      'Complex': function (x) {
        return x.neg();
      },

      'BigNumber': function (x) {
        return x.neg();
      },

      'Fraction': function (x) {
        return x.neg();
      },

      'Unit': function (x) {
        var res = x.clone();
        res.value = unaryMinus(x.value);
        return res;
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since unaryMinus(0) = 0
        return deepMap(x, unaryMinus, true);
      }

      // TODO: add support for string
    });

    unaryMinus.toTex = {
      1: latex$$1.operators['unaryMinus'] + '\\left(${args[0]}\\right)'
    };

    return unaryMinus;
  }

  var name$72 = 'unaryMinus';
  var factory_1$81 = factory$82;

  var unaryMinus$1 = {
  	name: name$72,
  	factory: factory_1$81
  };

  function factory$83 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);
    
    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
     * Callback function invoked MAX(NNZA, NNZB) times
     *
     *
     *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 || B(i,j) !== 0
     * C(i,j) = ┤  
     *          └  0            ; otherwise
     *
     *
     * @param {Matrix}   a                 The SparseMatrix instance (A)
     * @param {Matrix}   b                 The SparseMatrix instance (B)
     * @param {Function} callback          The f(Aij,Bij) operation to invoke
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
     */
    var algorithm05 = function (a, b, callback) {
      // sparse matrix arrays
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      var adt = a._datatype;
      // sparse matrix arrays
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      var bsize = b._size;
      var bdt = b._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cvalues = avalues && bvalues ? [] : undefined;
      var cindex = [];
      var cptr = [];
      // matrix
      var c = new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });

      // workspaces
      var xa = cvalues ? [] : undefined;
      var xb = cvalues ? [] : undefined;
      // marks indicating we have a value in x for a given column
      var wa = [];
      var wb = [];

      // vars
      var i, j, k, k1;
      
      // loop columns
      for (j = 0; j < columns; j++) {
        // update cptr
        cptr[j] = cindex.length;
        // columns mark
        var mark = j + 1;
        // loop values A(:,j)
        for (k = aptr[j], k1 = aptr[j + 1]; k < k1; k++) {
          // row
          i = aindex[k];
          // push index
          cindex.push(i);
          // update workspace
          wa[i] = mark;
          // check we need to process values
          if (xa)
            xa[i] = avalues[k];
        }
        // loop values B(:,j)
        for (k = bptr[j], k1 = bptr[j + 1]; k < k1; k++) {
          // row
          i = bindex[k];
          // check row existed in A
          if (wa[i] !== mark) {
            // push index
            cindex.push(i);
          }
          // update workspace
          wb[i] = mark;
          // check we need to process values
          if (xb)
            xb[i] = bvalues[k];
        }
        // check we need to process values (non pattern matrix)
        if (cvalues) {
          // initialize first index in j
          k = cptr[j];
          // loop index in j
          while (k < cindex.length) {
            // row
            i = cindex[k];
            // marks
            var wai = wa[i];
            var wbi = wb[i];
            // check Aij or Bij are nonzero
            if (wai === mark || wbi === mark) {
              // matrix values @ i,j
              var va = wai === mark ? xa[i] : zero;
              var vb = wbi === mark ? xb[i] : zero;
              // Cij
              var vc = cf(va, vb);
              // check for zero
              if (!eq(vc, zero)) {
                // push value
                cvalues.push(vc);
                // increment pointer
                k++;
              }
              else {
                // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
              }
            }
          }
        }
      }
      // update cptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return c;
    };

    return algorithm05;
  }

  var name$73 = 'algorithm05';
  var factory_1$82 = factory$83;

  var algorithm05 = {
  	name: name$73,
  	factory: factory_1$82
  };

  function factory$84 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);
    var addScalar$$1 = load(addScalar);
    var unaryMinus = load(unaryMinus$1);

    var algorithm01$$1 = load(algorithm01);
    var algorithm03$$1 = load(algorithm03);
    var algorithm05$$1 = load(algorithm05);
    var algorithm10$$1 = load(algorithm10);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    // TODO: split function subtract in two: subtract and subtractScalar

    /**
     * Subtract two values, `x - y`.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.subtract(x, y)
     *
     * Examples:
     *
     *    math.subtract(5.3, 2);        // returns number 3.3
     *
     *    var a = math.complex(2, 3);
     *    var b = math.complex(4, 1);
     *    math.subtract(a, b);          // returns Complex -2 + 2i
     *
     *    math.subtract([5, 7, 4], 4);  // returns Array [1, 3, 0]
     *
     *    var c = math.unit('2.1 km');
     *    var d = math.unit('500m');
     *    math.subtract(c, d);          // returns Unit 1.6 km
     *
     * See also:
     *
     *    add
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x
     *            Initial value
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y
     *            Value to subtract from `x`
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
     *            Subtraction of `x` and `y`
     */
    var subtract = typed('subtract', {

      'number, number': function (x, y) {
        return x - y;
      },

      'Complex, Complex': function (x, y) {
        return x.sub(y);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.minus(y);
      },

      'Fraction, Fraction': function (x, y) {
        return x.sub(y);
      },

      'Unit, Unit': function (x, y) {
        if (x.value == null) {
          throw new Error('Parameter x contains a unit with undefined value');
        }

        if (y.value == null) {
          throw new Error('Parameter y contains a unit with undefined value');
        }

        if (!x.equalBase(y)) {
          throw new Error('Units do not match');
        }

        var res = x.clone();
        res.value = subtract(res.value, y.value);
        res.fixPrefix = false;

        return res;
      },

      'SparseMatrix, SparseMatrix': function (x, y) {
        checkEqualDimensions(x, y);
        return algorithm05$$1(x, y, subtract);
      },

      'SparseMatrix, DenseMatrix': function (x, y) {
        checkEqualDimensions(x, y);
        return algorithm03$$1(y, x, subtract, true);
      },

      'DenseMatrix, SparseMatrix': function (x, y) {
        checkEqualDimensions(x, y);
        return algorithm01$$1(x, y, subtract, false);
      },

      'DenseMatrix, DenseMatrix': function (x, y) {
        checkEqualDimensions(x, y);
        return algorithm13$$1(x, y, subtract);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return subtract(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return subtract(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return subtract(x, matrix$$1(y));
      },
      
      'SparseMatrix, any': function (x, y) {
        return algorithm10$$1(x, unaryMinus(y), addScalar$$1);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, subtract);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm10$$1(y, x, subtract, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, subtract, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, subtract, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, subtract, true).valueOf();
      }
    });

    subtract.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['subtract'] + '${args[1]}\\right)'
    };

    return subtract;
  }

  /**
   * Check whether matrix x and y have the same number of dimensions.
   * Throws a DimensionError when dimensions are not equal
   * @param {Matrix} x
   * @param {Matrix} y
   */
  function checkEqualDimensions(x, y) {
    var xsize = x.size();
    var ysize = y.size();

    if (xsize.length !== ysize.length) {
      throw new DimensionError_1(xsize.length, ysize.length);
    }
  }

  var name$74 = 'subtract';
  var factory_1$83 = factory$84;

  var subtract$1 = {
  	name: name$74,
  	factory: factory_1$83
  };

  function factory$85 (type, config, load, typed) {
    /**
     * Calculate the absolute value of a number. For matrices, the function is
     * evaluated element wise.
     *
     * Syntax:
     *
     *    math.abs(x)
     *
     * Examples:
     *
     *    math.abs(3.5);                // returns number 3.5
     *    math.abs(-4.2);               // returns number 4.2
     *
     *    math.abs([3, -5, -1, 0, 2]);  // returns Array [3, 5, 1, 0, 2]
     *
     * See also:
     *
     *    sign
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
     *            A number or matrix for which to get the absolute value
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
     *            Absolute value of `x`
     */
    var abs = typed('abs', {
      'number': Math.abs,

      'Complex': function (x) {
        return x.abs();
      },

      'BigNumber': function (x) {
        return x.abs();
      },

      'Fraction': function (x) {
        return x.abs();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since abs(0) = 0
        return deepMap(x, abs, true);
      },

      'Unit': function(x) {
        return x.abs();
      }
    });

    abs.toTex = {1: '\\left|${args[0]}\\right|'};

    return abs;
  }

  var name$75 = 'abs';
  var factory_1$84 = factory$85;

  var abs$1 = {
  	name: name$75,
  	factory: factory_1$84
  };

  var object$4 = utils.object;

  function factory$86 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var abs = load(abs$1);
    var addScalar$$1 = load(addScalar);
    var divideScalar$$1 = load(divideScalar);
    var multiplyScalar$$1 = load(multiplyScalar);
    var subtract = load(subtract$1);
    var larger$$1 = load(larger);
    var equalScalar$$1 = load(equalScalar);
    var unaryMinus = load(unaryMinus$1);
    
    var SparseMatrix = type.SparseMatrix;
    var DenseMatrix = type.DenseMatrix;
    var Spa = type.Spa;
    
    /**
     * Calculate the Matrix LU decomposition with partial pivoting. Matrix `A` is decomposed in two matrices (`L`, `U`) and a
     * row permutation vector `p` where `A[p,:] = L * U`
     *
     * Syntax:
     *
     *    math.lup(A);
     *
     * Example:
     *
     *    var m = [[2, 1], [1, 4]];
     *    var r = math.lup(m);
     *    // r = {
     *    //   L: [[1, 0], [0.5, 1]],
     *    //   U: [[2, 1], [0, 3.5]],
     *    //   P: [0, 1]
     *    // }
     *
     * See also:
     *
     *    slu, lsolve, lusolve, usolve
     *
     * @param {Matrix | Array} A    A two dimensional matrix or array for which to get the LUP decomposition.
     *
     * @return {{L: Array | Matrix, U: Array | Matrix, P: Array.<number>}} The lower triangular matrix, the upper triangular matrix and the permutation matrix.
     */
    var lup = typed('lup', {

      'DenseMatrix': function (m) {
        return _denseLUP(m);
      },
      
      'SparseMatrix': function (m) {
        return _sparseLUP(m);
      },

      'Array': function (a) {
        // create dense matrix from array
        var m = matrix$$1(a);
        // lup, use matrix implementation
        var r = _denseLUP(m);
        // result
        return {
          L: r.L.valueOf(),
          U: r.U.valueOf(),
          p: r.p
        };
      }
    });

    var _denseLUP = function (m) {
      // rows & columns
      var rows = m._size[0];
      var columns = m._size[1];
      // minimum rows and columns
      var n = Math.min(rows, columns);
      // matrix array, clone original data
      var data = object$4.clone(m._data);
      // l matrix arrays
      var ldata = [];
      var lsize = [rows, n];
      // u matrix arrays
      var udata = [];
      var usize = [n, columns];
      // vars
      var i, j, k;
      // permutation vector    
      var p = [];
      for (i = 0; i < rows; i++)
        p[i] = i;    
      // loop columns
      for (j = 0; j < columns; j++) {
        // skip first column in upper triangular matrix
        if (j > 0) {
          // loop rows
          for (i = 0; i < rows; i++) {
            // min i,j
            var min = Math.min(i, j);
            // v[i, j]
            var s = 0;
            // loop up to min
            for (k = 0; k < min; k++) {
              // s = l[i, k] - data[k, j]
              s = addScalar$$1(s, multiplyScalar$$1(data[i][k], data[k][j]));
            }
            data[i][j] = subtract(data[i][j], s);
          }
        }      
        // row with larger value in cvector, row >= j
        var pi = j;
        var pabsv = 0;
        var vjj = 0;
        // loop rows
        for (i = j; i < rows; i++) {
          // data @ i, j
          var v = data[i][j];
          // absolute value
          var absv = abs(v);
          // value is greater than pivote value
          if (larger$$1(absv, pabsv)) {
            // store row
            pi = i;
            // update max value
            pabsv = absv;
            // value @ [j, j]
            vjj = v;
          }
        }
        // swap rows (j <-> pi)
        if (j !== pi) {
          // swap values j <-> pi in p
          p[j] = [p[pi], p[pi] = p[j]][0];
          // swap j <-> pi in data
          DenseMatrix._swapRows(j, pi, data);
        }
        // check column is in lower triangular matrix
        if (j < rows) {
          // loop rows (lower triangular matrix)
          for (i = j + 1; i < rows; i++) {
            // value @ i, j
            var vij = data[i][j];
            if (!equalScalar$$1(vij, 0)) {
              // update data
              data[i][j] = divideScalar$$1(data[i][j], vjj);
            }
          }
        }
      }
      // loop columns
      for (j = 0; j < columns; j++) {
        // loop rows
        for (i = 0; i < rows; i++) {
          // initialize row in arrays
          if (j === 0) {
            // check row exists in upper triangular matrix
            if (i < columns) {
              // U
              udata[i] = [];
            }
            // L
            ldata[i] = [];
          }
          // check we are in the upper triangular matrix
          if (i < j) {
            // check row exists in upper triangular matrix
            if (i < columns) {
              // U
              udata[i][j] = data[i][j];
            }
            // check column exists in lower triangular matrix
            if (j < rows) {
              // L
              ldata[i][j] = 0;
            }
            continue;
          }
          // diagonal value
          if (i === j) {
            // check row exists in upper triangular matrix
            if (i < columns) {
              // U
              udata[i][j] = data[i][j];
            }
            // check column exists in lower triangular matrix
            if (j < rows) {
              // L
              ldata[i][j] = 1;
            }
            continue;
          }
          // check row exists in upper triangular matrix
          if (i < columns) {
            // U
            udata[i][j] = 0;
          }
          // check column exists in lower triangular matrix
          if (j < rows) {
            // L
            ldata[i][j] = data[i][j];
          }
        }
      }
      // l matrix
      var l =  new DenseMatrix({
        data: ldata,
        size: lsize
      });
      // u matrix
      var u =  new DenseMatrix({
        data: udata,
        size: usize
      });
      // p vector
      var pv = [];
      for (i = 0, n = p.length; i < n; i++)
        pv[p[i]] = i;
      // return matrices
      return { 
        L: l, 
        U: u, 
        p: pv, 
        toString: function () {
          return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
        }
      };
    };
    
    var _sparseLUP = function (m) {
      // rows & columns
      var rows = m._size[0];
      var columns = m._size[1];
      // minimum rows and columns
      var n = Math.min(rows, columns);
      // matrix arrays (will not be modified, thanks to permutation vector)
      var values = m._values;
      var index = m._index;
      var ptr = m._ptr;
      // l matrix arrays
      var lvalues = [];
      var lindex = [];
      var lptr = [];
      var lsize = [rows, n];
      // u matrix arrays
      var uvalues = [];
      var uindex = [];
      var uptr = [];
      var usize = [n, columns];
      // vars
      var i, j, k;
      // permutation vectors, (current index -> original index) and (original index -> current index)
      var pv_co = [];
      var pv_oc = [];
      for (i = 0; i < rows; i++) {
        pv_co[i] = i;
        pv_oc[i] = i;
      }
      // swap indices in permutation vectors (condition x < y)!
      var swapIndeces = function (x, y) {      
        // find pv indeces getting data from x and y
        var kx = pv_oc[x];
        var ky = pv_oc[y];
        // update permutation vector current -> original
        pv_co[kx] = y;
        pv_co[ky] = x;
        // update permutation vector original -> current
        pv_oc[x] = ky;
        pv_oc[y] = kx;
      };
      // loop columns
      for (j = 0; j < columns; j++) {
        // sparse accumulator
        var spa = new Spa();            
        // check lower triangular matrix has a value @ column j
        if (j < rows) {
          // update ptr
          lptr.push(lvalues.length);
          // first value in j column for lower triangular matrix
          lvalues.push(1);
          lindex.push(j);
        }
        // update ptr
        uptr.push(uvalues.length);
        // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
        var k0 = ptr[j];
        var k1 = ptr[j + 1];
        // copy column j into sparse accumulator
        for (k = k0; k < k1; k++) {
          // row
          i = index[k];
          // copy column values into sparse accumulator (use permutation vector)
          spa.set(pv_co[i], values[k]);
        }
        // skip first column in upper triangular matrix
        if (j > 0) {
          // loop rows in column j (above diagonal)
          spa.forEach(0, j - 1, function (k, vkj) {
            // loop rows in column k (L)
            SparseMatrix._forEachRow(k, lvalues, lindex, lptr, function (i, vik) {
              // check row is below k
              if (i > k) {
                // update spa value
                spa.accumulate(i, unaryMinus(multiplyScalar$$1(vik, vkj)));
              }
            });
          });        
        }
        // row with larger value in spa, row >= j
        var pi = j;
        var vjj = spa.get(j);
        var pabsv = abs(vjj);      
        // loop values in spa (order by row, below diagonal)
        spa.forEach(j + 1, rows - 1, function (x, v) {
          // absolute value
          var absv = abs(v);
          // value is greater than pivote value
          if (larger$$1(absv, pabsv)) {
            // store row
            pi = x;
            // update max value
            pabsv = absv;
            // value @ [j, j]
            vjj = v;
          }
        });
        // swap rows (j <-> pi)
        if (j !== pi) {
          // swap values j <-> pi in L
          SparseMatrix._swapRows(j, pi, lsize[1], lvalues, lindex, lptr);
          // swap values j <-> pi in U
          SparseMatrix._swapRows(j, pi, usize[1], uvalues, uindex, uptr);
          // swap values in spa
          spa.swap(j, pi);
          // update permutation vector (swap values @ j, pi)
          swapIndeces(j, pi);
        }
        // loop values in spa (order by row)
        spa.forEach(0, rows - 1, function (x, v) {
          // check we are above diagonal
          if (x <= j) {
            // update upper triangular matrix
            uvalues.push(v);
            uindex.push(x);
          }
          else {
            // update value
            v = divideScalar$$1(v, vjj);
            // check value is non zero
            if (!equalScalar$$1(v, 0)) {
              // update lower triangular matrix
              lvalues.push(v);
              lindex.push(x);
            }
          }
        });
      }
      // update ptrs
      uptr.push(uvalues.length);
      lptr.push(lvalues.length);

      // return matrices
      return {
        L: new SparseMatrix({
          values: lvalues,
          index: lindex,
          ptr: lptr,
          size: lsize
        }), 
        U: new SparseMatrix({
          values: uvalues,
          index: uindex,
          ptr: uptr,
          size: usize
        }),
        p: pv_co,
        toString: function () {
          return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\nP: ' + this.p;
        }
      };
    };
    
    return lup;
  }

  var name$76 = 'lup';
  var factory_1$85 = factory$86;

  var lup$1 = {
  	name: name$76,
  	factory: factory_1$85
  };

  var object$5 = utils.object;
  var string$8 = utils.string;

  function factory$87 (type, config, load, typed) {
    var matrix$$1 = load(matrix);
    var add$$1 = load(add);
    var subtract = load(subtract$1);
    var multiply = load(multiply$1);
    var unaryMinus = load(unaryMinus$1);
    var lup = load(lup$1);

    /**
     * Calculate the determinant of a matrix.
     *
     * Syntax:
     *
     *    math.det(x)
     *
     * Examples:
     *
     *    math.det([[1, 2], [3, 4]]); // returns -2
     *
     *    var A = [
     *      [-2, 2, 3],
     *      [-1, 1, 3],
     *      [2, 0, -1]
     *    ]
     *    math.det(A); // returns 6
     *
     * See also:
     *
     *    inv
     *
     * @param {Array | Matrix} x  A matrix
     * @return {number} The determinant of `x`
     */
    var det = typed('det', {
      'any': function (x) {
        return object$5.clone(x);
      },

      'Array | Matrix': function det (x) {
        var size;
        if (type.isMatrix(x)) {
          size = x.size();
        }
        else if (Array.isArray(x)) {
          x = matrix$$1(x);
          size = x.size();
        }
        else {
          // a scalar
          size = [];
        }

        switch (size.length) {
          case 0:
            // scalar
            return object$5.clone(x);

          case 1:
            // vector
            if (size[0] == 1) {
              return object$5.clone(x.valueOf()[0]);
            }
            else {
              throw new RangeError('Matrix must be square ' +
              '(size: ' + string$8.format(size) + ')');
            }

          case 2:
            // two dimensional array
            var rows = size[0];
            var cols = size[1];
            if (rows == cols) {
              return _det(x.clone().valueOf(), rows, cols);
            }
            else {
              throw new RangeError('Matrix must be square ' +
              '(size: ' + string$8.format(size) + ')');
            }

          default:
            // multi dimensional array
            throw new RangeError('Matrix must be two dimensional ' +
            '(size: ' + string$8.format(size) + ')');
        }
      }
    });

    det.toTex = {1: '\\det\\left(${args[0]}\\right)'};

    return det;

    /**
     * Calculate the determinant of a matrix
     * @param {Array[]} matrix  A square, two dimensional matrix
     * @param {number} rows     Number of rows of the matrix (zero-based)
     * @param {number} cols     Number of columns of the matrix (zero-based)
     * @returns {number} det
     * @private
     */
    function _det (matrix$$1, rows, cols) {
      if (rows == 1) {
        // this is a 1 x 1 matrix
        return object$5.clone(matrix$$1[0][0]);
      }
      else if (rows == 2) {
        // this is a 2 x 2 matrix
        // the determinant of [a11,a12;a21,a22] is det = a11*a22-a21*a12
        return subtract(
            multiply(matrix$$1[0][0], matrix$$1[1][1]),
            multiply(matrix$$1[1][0], matrix$$1[0][1])
        );
      }
      else {

        // Compute the LU decomposition
        var decomp = lup(matrix$$1);

        // The determinant is the product of the diagonal entries of U (and those of L, but they are all 1)
        var det = decomp.U[0][0];
        for(var i=1; i<rows; i++) {
          det = multiply(det, decomp.U[i][i]);
        }

        // The determinant will be multiplied by 1 or -1 depending on the parity of the permutation matrix.
        // This can be determined by counting the cycles. This is roughly a linear time algorithm.
        var evenCycles=0;
        var i=0;
        var visited=[];
        while(true) {
          while(visited[i]) {
           i++;
          }
          if(i >= rows) break;
          var j=i;
          var cycleLen = 0;
          while(!visited[decomp.p[j]]) {
            visited[decomp.p[j]] = true;
            j = decomp.p[j];
            cycleLen++;
          }
          if(cycleLen % 2 === 0) {
            evenCycles++;
          }
        }

        return evenCycles % 2 === 0 ? det : unaryMinus(det);

      }
    }
  }

  var name$77 = 'det';
  var factory_1$86 = factory$87;

  var det$1 = {
  	name: name$77,
  	factory: factory_1$86
  };

  var isInteger$5 = number.isInteger;

  function factory$88 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);
    
    /**
     * Create a 2-dimensional identity matrix with size m x n or n x n.
     * The matrix has ones on the diagonal and zeros elsewhere.
     *
     * Syntax:
     *
     *    math.eye(n)
     *    math.eye(n, format)
     *    math.eye(m, n)
     *    math.eye(m, n, format)
     *    math.eye([m, n])
     *    math.eye([m, n], format)
     *
     * Examples:
     *
     *    math.eye(3);                    // returns [[1, 0, 0], [0, 1, 0], [0, 0, 1]]
     *    math.eye(3, 2);                 // returns [[1, 0], [0, 1], [0, 0]]
     *
     *    var A = [[1, 2, 3], [4, 5, 6]];
     *    math.eye(math.size(A));         // returns [[1, 0, 0], [0, 1, 0]]
     *
     * See also:
     *
     *    diag, ones, zeros, size, range
     *
     * @param {...number | Matrix | Array} size   The size for the matrix
     * @param {string} [format]                   The Matrix storage format
     *
     * @return {Matrix | Array | number} A matrix with ones on the diagonal.
     */
    var eye = typed('eye', {
      '': function () {
        return (config.matrix === 'Matrix') ? matrix$$1([]) : [];
      },

      'string': function (format) {
        return matrix$$1(format);
      },

      'number | BigNumber': function (rows) {
        return _eye(rows, rows, config.matrix === 'Matrix' ? 'default' : undefined);
      },
      
      'number | BigNumber, string': function (rows, format) {
        return _eye(rows, rows, format);
      },

      'number | BigNumber, number | BigNumber': function (rows, cols) {
        return _eye(rows, cols, config.matrix === 'Matrix' ? 'default' : undefined);
      },
      
      'number | BigNumber, number | BigNumber, string': function (rows, cols, format) {
        return _eye(rows, cols, format);
      },

      'Array':  function (size) {
        return _eyeVector(size);
      },
      
      'Array, string':  function (size, format) {
        return _eyeVector(size, format);
      },

      'Matrix': function (size) {
        return _eyeVector(size.valueOf(), size.storage());
      },
      
      'Matrix, string': function (size, format) {
        return _eyeVector(size.valueOf(), format);
      }
    });

    eye.toTex = undefined; // use default template

    return eye;

    function _eyeVector (size, format) {
      switch (size.length) {
        case 0: return format ? matrix$$1(format) : [];
        case 1: return _eye(size[0], size[0], format);
        case 2: return _eye(size[0], size[1], format);
        default: throw new Error('Vector containing two values expected');
      }
    }

    /**
     * Create an identity matrix
     * @param {number | BigNumber} rows
     * @param {number | BigNumber} cols
     * @param {string} [format]
     * @returns {Matrix}
     * @private
     */
    function _eye (rows, cols, format) {
      // BigNumber constructor with the right precision
      var Big = (type.isBigNumber(rows) || type.isBigNumber(cols))
              ? type.BigNumber
              : null;

      if (type.isBigNumber(rows)) rows = rows.toNumber();
      if (type.isBigNumber(cols)) cols = cols.toNumber();

      if (!isInteger$5(rows) || rows < 1) {
        throw new Error('Parameters in function eye must be positive integers');
      }
      if (!isInteger$5(cols) || cols < 1) {
        throw new Error('Parameters in function eye must be positive integers');
      }
      
      var one = Big ? new type.BigNumber(1) : 1;
      var defaultValue = Big ? new Big(0) : 0;
      var size = [rows, cols];
      
      // check we need to return a matrix
      if (format) {
        // get matrix storage constructor
        var F = type.Matrix.storage(format);
        // create diagonal matrix (use optimized implementation for storage format)
        return F.diagonal(size, one, 0, defaultValue);
      }
      
      // create and resize array
      var res = array.resize([], size, defaultValue);
      // fill in ones on the diagonal
      var minimum = rows < cols ? rows : cols;
      // fill diagonal
      for (var d = 0; d < minimum; d++) {
        res[d][d] = one;
      }
      return res;
    }
  }

  var name$78 = 'eye';
  var factory_1$87 = factory$88;

  var eye$1 = {
  	name: name$78,
  	factory: factory_1$87
  };

  function factory$89 (type, config, load, typed) {
    var matrix$$1       = load(matrix);
    var divideScalar$$1 = load(divideScalar);
    var addScalar$$1    = load(addScalar);
    var multiply     = load(multiply$1);
    var unaryMinus   = load(unaryMinus$1);
    var det          = load(det$1);
    var eye          = load(eye$1);
    var abs          = load(abs$1);

    /**
     * Calculate the inverse of a square matrix.
     *
     * Syntax:
     *
     *     math.inv(x)
     *
     * Examples:
     *
     *     math.inv([[1, 2], [3, 4]]);  // returns [[-2, 1], [1.5, -0.5]]
     *     math.inv(4);                 // returns 0.25
     *     1 / 4;                       // returns 0.25
     *
     * See also:
     *
     *     det, transpose
     *
     * @param {number | Complex | Array | Matrix} x     Matrix to be inversed
     * @return {number | Complex | Array | Matrix} The inverse of `x`.
     */
    var inv = typed('inv', {
      'Array | Matrix': function (x) {
        var size = type.isMatrix(x) ? x.size() : utils.array.size(x);
        switch (size.length) {
          case 1:
            // vector
            if (size[0] == 1) {
              if (type.isMatrix(x)) {
                return matrix$$1([
                  divideScalar$$1(1, x.valueOf()[0])
                ]);
              }
              else {
                return [
                  divideScalar$$1(1, x[0])
                ];
              }
            }
            else {
              throw new RangeError('Matrix must be square ' +
              '(size: ' + utils.string.format(size) + ')');
            }

          case 2:
            // two dimensional array
            var rows = size[0];
            var cols = size[1];
            if (rows == cols) {
              if (type.isMatrix(x)) {
                return matrix$$1(
                    _inv(x.valueOf(), rows, cols),
                    x.storage()
                );
              }
              else {
                // return an Array
                return _inv(x, rows, cols);
              }
            }
            else {
              throw new RangeError('Matrix must be square ' +
              '(size: ' + utils.string.format(size) + ')');
            }

          default:
            // multi dimensional array
            throw new RangeError('Matrix must be two dimensional ' +
            '(size: ' + utils.string.format(size) + ')');
        }
      },

      'any': function (x) {
        // scalar
        return divideScalar$$1(1, x); // FIXME: create a BigNumber one when configured for bignumbers
      }
    });

    /**
     * Calculate the inverse of a square matrix
     * @param {Array[]} mat     A square matrix
     * @param {number} rows     Number of rows
     * @param {number} cols     Number of columns, must equal rows
     * @return {Array[]} inv    Inverse matrix
     * @private
     */
    function _inv (mat, rows, cols){
      var r, s, f, value, temp;

      if (rows == 1) {
        // this is a 1 x 1 matrix
        value = mat[0][0];
        if (value == 0) {
          throw Error('Cannot calculate inverse, determinant is zero');
        }
        return [[
          divideScalar$$1(1, value)
        ]];
      }
      else if (rows == 2) {
        // this is a 2 x 2 matrix
        var d = det(mat);
        if (d == 0) {
          throw Error('Cannot calculate inverse, determinant is zero');
        }
        return [
          [
            divideScalar$$1(mat[1][1], d),
            divideScalar$$1(unaryMinus(mat[0][1]), d)
          ],
          [
            divideScalar$$1(unaryMinus(mat[1][0]), d),
            divideScalar$$1(mat[0][0], d)
          ]
        ];
      }
      else {
        // this is a matrix of 3 x 3 or larger
        // calculate inverse using gauss-jordan elimination
        //      http://en.wikipedia.org/wiki/Gaussian_elimination
        //      http://mathworld.wolfram.com/MatrixInverse.html
        //      http://math.uww.edu/~mcfarlat/inverse.htm

        // make a copy of the matrix (only the arrays, not of the elements)
        var A = mat.concat();
        for (r = 0; r < rows; r++) {
          A[r] = A[r].concat();
        }

        // create an identity matrix which in the end will contain the
        // matrix inverse
        var B = eye(rows).valueOf();

        // loop over all columns, and perform row reductions
        for (var c = 0; c < cols; c++) {
          // Pivoting: Swap row c with row r, where row r contains the largest element A[r][c]
          var A_big = abs(A[c][c]);
          var r_big = c;
          r = c+1;
          while (r < rows) {
            if(abs(A[r][c]) > A_big) {
              A_big = abs(A[r][c]);
              r_big = r;
            }
            r++;
          }
          if(A_big == 0) {
            throw Error('Cannot calculate inverse, determinant is zero');
          }
          r = r_big;
          if (r != c) {
            temp = A[c]; A[c] = A[r]; A[r] = temp;
            temp = B[c]; B[c] = B[r]; B[r] = temp;
          }

          // eliminate non-zero values on the other rows at column c
          var Ac = A[c],
              Bc = B[c];
          for (r = 0; r < rows; r++) {
            var Ar = A[r],
                Br = B[r];
            if(r != c) {
              // eliminate value at column c and row r
              if (Ar[c] != 0) {
                f = divideScalar$$1(unaryMinus(Ar[c]), Ac[c]);

                // add (f * row c) to row r to eliminate the value
                // at column c
                for (s = c; s < cols; s++) {
                  Ar[s] = addScalar$$1(Ar[s], multiply(f, Ac[s]));
                }
                for (s = 0; s < cols; s++) {
                  Br[s] = addScalar$$1(Br[s],  multiply(f, Bc[s]));
                }
              }
            }
            else {
              // normalize value at Acc to 1,
              // divide each value on row r with the value at Acc
              f = Ac[c];
              for (s = c; s < cols; s++) {
                Ar[s] = divideScalar$$1(Ar[s], f);
              }
              for (s = 0; s < cols; s++) {
                Br[s] = divideScalar$$1(Br[s], f);
              }
            }
          }
        }
        return B;
      }
    }

    inv.toTex = {1: '\\left(${args[0]}\\right)^{-1}'};

    return inv;
  }

  var name$79 = 'inv';
  var factory_1$88 = factory$89;

  var inv$1 = {
  	name: name$79,
  	factory: factory_1$88
  };

  var extend$3 = object.extend;

  function factory$90 (type, config, load, typed) {

    var divideScalar$$1 = load(divideScalar);
    var multiply     = load(multiply$1);
    var inv          = load(inv$1);
    var matrix$$1       = load(matrix);

    var algorithm11$$1 = load(algorithm11);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Divide two values, `x / y`.
     * To divide matrices, `x` is multiplied with the inverse of `y`: `x * inv(y)`.
     *
     * Syntax:
     *
     *    math.divide(x, y)
     *
     * Examples:
     *
     *    math.divide(2, 3);            // returns number 0.6666666666666666
     *
     *    var a = math.complex(5, 14);
     *    var b = math.complex(4, 1);
     *    math.divide(a, b);            // returns Complex 2 + 3i
     *
     *    var c = [[7, -6], [13, -4]];
     *    var d = [[1, 2], [4, 3]];
     *    math.divide(c, d);            // returns Array [[-9, 4], [-11, 6]]
     *
     *    var e = math.unit('18 km');
     *    math.divide(e, 4.5);          // returns Unit 4 km
     *
     * See also:
     *
     *    multiply
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x   Numerator
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} y          Denominator
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                      Quotient, `x / y`
     */
    var divide = typed('divide', extend$3({
      // we extend the signatures of divideScalar with signatures dealing with matrices

      'Array | Matrix, Array | Matrix': function (x, y) {
        // TODO: implement matrix right division using pseudo inverse
        // http://www.mathworks.nl/help/matlab/ref/mrdivide.html
        // http://www.gnu.org/software/octave/doc/interpreter/Arithmetic-Ops.html
        // http://stackoverflow.com/questions/12263932/how-does-gnu-octave-matrix-division-work-getting-unexpected-behaviour
        return multiply(x, inv(y));
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, divideScalar$$1, false);
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, divideScalar$$1, false);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, divideScalar$$1, false).valueOf();
      },

      'any, Array | Matrix': function (x, y) {
        return multiply(x, inv(y));
      }
    }, divideScalar$$1.signatures));

    divide.toTex = {2: '\\frac{${args[0]}}{${args[1]}}'};

    return divide;
  }

  var name$80 = 'divide';
  var factory_1$89 = factory$90;

  var divide$1 = {
  	name: name$80,
  	factory: factory_1$89
  };

  var size$1 = array.size;




  function factory$91 (type, config, load, typed) {
    var add$$1 = load(add);
    var divide = load(divide$1);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the mean value of matrix or a list with values.
     * In case of a multi dimensional array, the mean of the flattened array
     * will be calculated. When `dim` is provided, the maximum over the selected
     * dimension will be calculated. Parameter `dim` is zero-based.
     *
     * Syntax:
     *
     *     math.mean(a, b, c, ...)
     *     math.mean(A)
     *     math.mean(A, dim)
     *
     * Examples:
     *
     *     math.mean(2, 1, 4, 3);                     // returns 2.5
     *     math.mean([1, 2.7, 3.2, 4]);               // returns 2.725
     *
     *     math.mean([[2, 5], [6, 3], [1, 7]], 0);    // returns [3, 5]
     *     math.mean([[2, 5], [6, 3], [1, 7]], 1);    // returns [3.5, 4.5, 4]
     *
     * See also:
     *
     *     median, min, max, sum, prod, std, var
     *
     * @param {... *} args  A single matrix or or multiple scalar values
     * @return {*} The mean of all values
     */
    var mean = typed('mean', {
        // mean([a, b, c, d, ...])
      'Array | Matrix': _mean,

        // mean([a, b, c, d, ...], dim)
      'Array | Matrix, number | BigNumber': _nmeanDim,

      // mean(a, b, c, d, ...)
      '...': function (args) {
        if (containsCollections(args)) {
          throw new TypeError('Scalar values expected in function mean');
        }

        return _mean(args);
      }
    });

    mean.toTex = undefined; // use default template

    return mean;

    /**
     * Calculate the mean value in an n-dimensional array, returning a
     * n-1 dimensional array
     * @param {Array} array
     * @param {number} dim
     * @return {number} mean
     * @private
     */
    function _nmeanDim(array$$1, dim) {
      try {
        var sum = reduce(array$$1, dim, add$$1);
        var s = Array.isArray(array$$1) ? size$1(array$$1) : array$$1.size();
        return divide(sum, s[dim]);
      }
      catch (err) {
        throw improveErrorMessage$$1(err, 'mean');
      }
    }

    /**
     * Recursively calculate the mean value in an n-dimensional array
     * @param {Array} array
     * @return {number} mean
     * @private
     */
    function _mean(array$$1) {
      var sum = 0;
      var num = 0;

      deepForEach(array$$1, function (value) {
        try {
          sum = add$$1(sum, value);
          num++;
        }
        catch (err) {
          throw improveErrorMessage$$1(err, 'mean', value);
        }
      });

      if (num === 0) {
        throw new Error('Cannot calculate mean of an empty array');
      }

      return divide(sum, num);
    }
  }

  var name$81 = 'mean';
  var factory_1$90 = factory$91;

  var mean$1 = {
  	name: name$81,
  	factory: factory_1$90
  };

  var errorTransform$4 = error_transform.transform;


  /**
   * Attach a transform function to math.mean
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function mean
   * from one-based to zero based
   */
  function factory$92 (type, config, load, typed) {
    var mean = load(mean$1);

    return typed('mean', {
      '...any': function (args) {
        // change last argument dim from one-based to zero-based
        if (args.length == 2 && isCollection(args[0])) {
          var dim = args[1];
          if (type.isNumber(dim)) {
            args[1] = dim - 1;
          }
          else if (type.isBigNumber(dim)) {
            args[1] = dim.minus(1);
          }
        }

        try {
          return mean.apply(null, args);
        }
        catch (err) {
          throw errorTransform$4(err);
        }
      }
    });
  }

  var name$82 = 'mean';
  var path$38 = 'expression.transform';
  var factory_1$91 = factory$92;

  var mean_transform = {
  	name: name$82,
  	path: path$38,
  	factory: factory_1$91
  };

  function factory$93 (type, config, load, typed) {
    var smaller$$1 = load(smaller);
    var improveErrorMessage$$1 = load(improveErrorMessage);
    
    /**
     * Compute the maximum value of a matrix or a  list of values.
     * In case of a multi dimensional array, the maximum of the flattened array
     * will be calculated. When `dim` is provided, the maximum over the selected
     * dimension will be calculated. Parameter `dim` is zero-based.
     *
     * Syntax:
     *
     *     math.min(a, b, c, ...)
     *     math.min(A)
     *     math.min(A, dim)
     *
     * Examples:
     *
     *     math.min(2, 1, 4, 3);                  // returns 1
     *     math.min([2, 1, 4, 3]);                // returns 1
     *
     *     // maximum over a specified dimension (zero-based)
     *     math.min([[2, 5], [4, 3], [1, 7]], 0); // returns [1, 3]
     *     math.min([[2, 5], [4, 3], [1, 7]], 1); // returns [2, 3, 1]
     *
     *     math.max(2.7, 7.1, -4.5, 2.0, 4.1);    // returns 7.1
     *     math.min(2.7, 7.1, -4.5, 2.0, 4.1);    // returns -4.5
     *
     * See also:
     *
     *    mean, median, max, prod, std, sum, var
     *
     * @param {... *} args  A single matrix or or multiple scalar values
     * @return {*} The minimum value
     */
    var min = typed('min', {
      // min([a, b, c, d, ...])
      'Array | Matrix': _min,

      // min([a, b, c, d, ...], dim)
      'Array | Matrix, number | BigNumber': function (array, dim) {
        return reduce(array, dim.valueOf(), _smallest);
      },

      // min(a, b, c, d, ...)
      '...': function (args) {
        if (containsCollections(args)) {
          throw new TypeError('Scalar values expected in function min');
        }

        return _min(args);
      }
    });

    min.toTex = '\\min\\left(${args}\\right)';

    return min;

    /**
     * Return the smallest of two values
     * @param {*} x
     * @param {*} y
     * @returns {*} Returns x when x is smallest, or y when y is smallest
     * @private
     */
    function _smallest(x, y) {
      try {
        return smaller$$1(x, y) ? x : y;
      }
      catch (err) {
        throw improveErrorMessage$$1(err, 'min', y);
      }
    }

    /**
     * Recursively calculate the minimum value in an n-dimensional array
     * @param {Array} array
     * @return {number} min
     * @private
     */
    function _min(array) {
      var min = undefined;

      deepForEach(array, function (value) {
        try {
          if (min === undefined || smaller$$1(value, min)) {
            min = value;
          }
        }
        catch (err) {
          throw improveErrorMessage$$1(err, 'min', value);
        }
      });

      if (min === undefined) {
        throw new Error('Cannot calculate min of an empty array');
      }

      return min;
    }
  }

  var name$83 = 'min';
  var factory_1$92 = factory$93;

  var min$1 = {
  	name: name$83,
  	factory: factory_1$92
  };

  var errorTransform$5 = error_transform.transform;


  /**
   * Attach a transform function to math.min
   * Adds a property transform containing the transform function.
   *
   * This transform changed the last `dim` parameter of function min
   * from one-based to zero based
   */
  function factory$94 (type, config, load, typed) {
    var min = load(min$1);

    return typed('min', {
      '...any': function (args) {
        // change last argument dim from one-based to zero-based
        if (args.length == 2 && isCollection(args[0])) {
          var dim = args[1];
          if (type.isNumber(dim)) {
            args[1] = dim - 1;
          }
          else if (type.isBigNumber(dim)) {
            args[1] = dim.minus(1);
          }
        }

        try {
          return min.apply(null, args);
        }
        catch (err) {
          throw errorTransform$5(err);
        }
      }
    });
  }

  var name$84 = 'min';
  var path$39 = 'expression.transform';
  var factory_1$93 = factory$94;

  var min_transform = {
  	name: name$84,
  	path: path$39,
  	factory: factory_1$93
  };

  function factory$95 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    var ZERO = new type.BigNumber(0);
    var ONE = new type.BigNumber(1);

    /**
     * Create an array from a range.
     * By default, the range end is excluded. This can be customized by providing
     * an extra parameter `includeEnd`.
     *
     * Syntax:
     *
     *     math.range(str [, includeEnd])               // Create a range from a string,
     *                                                  // where the string contains the
     *                                                  // start, optional step, and end,
     *                                                  // separated by a colon.
     *     math.range(start, end [, includeEnd])        // Create a range with start and
     *                                                  // end and a step size of 1.
     *     math.range(start, end, step [, includeEnd])  // Create a range with start, step,
     *                                                  // and end.
     *
     * Where:
     *
     * - `str: string`
     *   A string 'start:end' or 'start:step:end'
     * - `start: {number | BigNumber}`
     *   Start of the range
     * - `end: number | BigNumber`
     *   End of the range, excluded by default, included when parameter includeEnd=true
     * - `step: number | BigNumber`
     *   Step size. Default value is 1.
     * - `includeEnd: boolean`
     *   Option to specify whether to include the end or not. False by default.
     *
     * Examples:
     *
     *     math.range(2, 6);        // [2, 3, 4, 5]
     *     math.range(2, -3, -1);   // [2, 1, 0, -1, -2]
     *     math.range('2:1:6');     // [2, 3, 4, 5]
     *     math.range(2, 6, true);  // [2, 3, 4, 5, 6]
     *
     * See also:
     *
     *     ones, zeros, size, subset
     *
     * @param {*} args   Parameters describing the ranges `start`, `end`, and optional `step`.
     * @return {Array | Matrix} range
     */
    var range = typed('range', {
      // TODO: simplify signatures when typed-function supports default values and optional arguments

      // TODO: a number or boolean should not be converted to string here
      'string': _strRange,
      'string, boolean': _strRange,

      'number, number':  function (start, end) {
        return _out(_rangeEx(start, end, 1));
      },
      'number, number, number': function (start, end, step) {
        return _out(_rangeEx(start, end, step));
      },
      'number, number, boolean': function (start, end, includeEnd) {
        return includeEnd
            ? _out(_rangeInc(start, end, 1))
            : _out(_rangeEx(start, end, 1));
      },
      'number, number, number, boolean': function (start, end, step, includeEnd) {
        return includeEnd
            ? _out(_rangeInc(start, end, step))
            : _out(_rangeEx(start, end, step));
      },

      'BigNumber, BigNumber':  function (start, end) {
        return _out(_bigRangeEx(start, end, ONE));
      },
      'BigNumber, BigNumber, BigNumber': function (start, end, step) {
        return _out(_bigRangeEx(start, end, step));
      },
      'BigNumber, BigNumber, boolean': function (start, end, includeEnd) {
        return includeEnd
            ? _out(_bigRangeInc(start, end, ONE))
            : _out(_bigRangeEx(start, end, ONE));
      },
      'BigNumber, BigNumber, BigNumber, boolean': function (start, end, step, includeEnd) {
        return includeEnd
            ? _out(_bigRangeInc(start, end, step))
            : _out(_bigRangeEx(start, end, step));
      }

    });

    range.toTex = undefined; // use default template

    return range;

    function _out(arr) {
      return config.matrix === 'Array' ? arr : matrix$$1(arr);
    }

    function _strRange (str, includeEnd) {
      var r = _parse(str);
      if (!r){
        throw new SyntaxError('String "' + str + '" is no valid range');
      }

      var fn;
      if (config.number === 'BigNumber') {
        fn = includeEnd ? _bigRangeInc : _bigRangeEx;
        return _out(fn(
            new type.BigNumber(r.start),
            new type.BigNumber(r.end),
            new type.BigNumber(r.step)));
      }
      else {
        fn = includeEnd ? _rangeInc : _rangeEx;
        return _out(fn(r.start, r.end, r.step));
      }
    }

    /**
     * Create a range with numbers. End is excluded
     * @param {number} start
     * @param {number} end
     * @param {number} step
     * @returns {Array} range
     * @private
     */
    function _rangeEx (start, end, step) {
      var array = [],
          x = start;
      if (step > 0) {
        while (x < end) {
          array.push(x);
          x += step;
        }
      }
      else if (step < 0) {
        while (x > end) {
          array.push(x);
          x += step;
        }
      }

      return array;
    }

    /**
     * Create a range with numbers. End is included
     * @param {number} start
     * @param {number} end
     * @param {number} step
     * @returns {Array} range
     * @private
     */
    function _rangeInc (start, end, step) {
      var array = [],
          x = start;
      if (step > 0) {
        while (x <= end) {
          array.push(x);
          x += step;
        }
      }
      else if (step < 0) {
        while (x >= end) {
          array.push(x);
          x += step;
        }
      }

      return array;
    }

    /**
     * Create a range with big numbers. End is excluded
     * @param {BigNumber} start
     * @param {BigNumber} end
     * @param {BigNumber} step
     * @returns {Array} range
     * @private
     */
    function _bigRangeEx (start, end, step) {
      var array = [],
          x = start;
      if (step.gt(ZERO)) {
        while (x.lt(end)) {
          array.push(x);
          x = x.plus(step);
        }
      }
      else if (step.lt(ZERO)) {
        while (x.gt(end)) {
          array.push(x);
          x = x.plus(step);
        }
      }

      return array;
    }

    /**
     * Create a range with big numbers. End is included
     * @param {BigNumber} start
     * @param {BigNumber} end
     * @param {BigNumber} step
     * @returns {Array} range
     * @private
     */
    function _bigRangeInc (start, end, step) {
      var array = [],
          x = start;
      if (step.gt(ZERO)) {
        while (x.lte(end)) {
          array.push(x);
          x = x.plus(step);
        }
      }
      else if (step.lt(ZERO)) {
        while (x.gte(end)) {
          array.push(x);
          x = x.plus(step);
        }
      }

      return array;
    }

    /**
     * Parse a string into a range,
     * The string contains the start, optional step, and end, separated by a colon.
     * If the string does not contain a valid range, null is returned.
     * For example str='0:2:11'.
     * @param {string} str
     * @return {{start: number, end: number, step: number} | null} range Object containing properties start, end, step
     * @private
     */
    function _parse (str) {
      var args = str.split(':');

      // number
      var nums = args.map(function (arg) {
        // use Number and not parseFloat as Number returns NaN on invalid garbage in the string
        return Number(arg);
      });

      var invalid = nums.some(function (num) {
        return isNaN(num);
      });
      if(invalid) {
        return null;
      }

      switch (nums.length) {
        case 2:
          return {
            start: nums[0],
            end: nums[1],
            step: 1
          };

        case 3:
          return {
            start: nums[0],
            end: nums[2],
            step: nums[1]
          };

        default:
          return null;
      }
    }

  }

  var name$85 = 'range';
  var factory_1$94 = factory$95;

  var range$1 = {
  	name: name$85,
  	factory: factory_1$94
  };

  /**
   * Attach a transform function to math.range
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */
  function factory$96 (type, config, load, typed) {
    var range = load(range$1);

    return typed('range', {
      '...any': function (args) {
        var lastIndex = args.length - 1;
        var last = args[lastIndex];
        if (typeof last !== 'boolean') {
          // append a parameter includeEnd=true
          args.push(true);
        }

        return range.apply(null, args);
      }
    });
  }

  var name$86 = 'range';
  var path$40 = 'expression.transform';
  var factory_1$95 = factory$96;

  var range_transform = {
  	name: name$86,
  	path: path$40,
  	factory: factory_1$95
  };

  var errorTransform$6 = error_transform.transform;

  /**
   * Attach a transform function to math.subset
   * Adds a property transform containing the transform function.
   *
   * This transform creates a range which includes the end value
   */
  function factory$97 (type, config, load, typed) {
    var subset = load(subset$1);

    return typed('subset', {
      '...any': function (args) {
        try {
          return subset.apply(null, args);
        }
        catch (err) {
          throw errorTransform$6(err);
        }
      }
    });
  }

  var name$87 = 'subset';
  var path$41 = 'expression.transform';
  var factory_1$96 = factory$97;

  var subset_transform = {
  	name: name$87,
  	path: path$41,
  	factory: factory_1$96
  };

  var transform$1 = [
    concat_transform,
    filter_transform,
    forEach_transform,
    index_transform,
    map_transform,
    max_transform,
    mean_transform,
    min_transform,
    range_transform,
    subset_transform
  ];

  function factory$98 (type, config, load, typed) {
    var parser$$1 = load(parser)();

    /**
     * Documentation object
     * @param {Object} doc  Object containing properties:
     *                      {string} name
     *                      {string} category
     *                      {string} description
     *                      {string[]} syntax
     *                      {string[]} examples
     *                      {string[]} seealso
     * @constructor
     */
    function Help(doc) {
      if (!(this instanceof Help)) {
        throw new SyntaxError('Constructor must be called with the new operator');
      }

      if (!doc)  throw new Error('Argument "doc" missing');

      this.doc = doc;
    }

    /**
     * Attach type information
     */
    Help.prototype.type = 'Help';
    Help.prototype.isHelp = true;

    /**
     * Generate a string representation of the Help object
     * @return {string} Returns a string
     * @private
     */
    Help.prototype.toString = function () {
      var doc = this.doc || {};
      var desc = '\n';

      if (doc.name) {
        desc += 'Name: ' + doc.name + '\n\n';
      }
      if (doc.category) {
        desc += 'Category: ' + doc.category + '\n\n';
      }
      if (doc.description) {
        desc += 'Description:\n    ' + doc.description + '\n\n';
      }
      if (doc.syntax) {
        desc += 'Syntax:\n    ' + doc.syntax.join('\n    ') + '\n\n';
      }
      if (doc.examples) {
        desc += 'Examples:\n';
        for (var i = 0; i < doc.examples.length; i++) {
          var expr = doc.examples[i];
          desc += '    ' + expr + '\n';

          var res;
          try {
            // note: res can be undefined when `expr` is an empty string
            res = parser$$1.eval(expr);
          }
          catch (e) {
            res = e;
          }
          if (res !== undefined && !type.isHelp(res)) {
            desc += '        ' + string.format(res, {precision: 14}) + '\n';
          }
        }
        desc += '\n';
      }
      if (doc.seealso && doc.seealso.length) {
        desc += 'See also: ' + doc.seealso.join(', ') + '\n';
      }

      return desc;
    };

    /**
     * Export the help object to JSON
     */
    Help.prototype.toJSON = function () {
      var obj = object.clone(this.doc);
      obj.mathjs = 'Help';
      return obj;
    };

    /**
     * Instantiate a Help object from a JSON object
     * @param {Object} json
     * @returns {Help} Returns a new Help object
     */
    Help.fromJSON = function (json) {
      var doc = {};
      for (var prop in json) {
        if (prop !== 'mathjs') { // ignore mathjs field
          doc[prop] = json[prop];
        }
      }
      return new Help(doc);
    };

    /**
     * Returns a string representation of the Help object
     */
    Help.prototype.valueOf = Help.prototype.toString;

    return Help;
  }

  var name$88 = 'Help';
  var path$42 = 'type';
  var factory_1$97 = factory$98;

  var Help = {
  	name: name$88,
  	path: path$42,
  	factory: factory_1$97
  };

  var expression = [
    // Note that the docs folder is called "embeddedDocs" and not "docs" to prevent issues
    // with yarn autoclean. See https://github.com/josdejong/mathjs/issues/969
    embeddedDocs,
    _function$2,
    node,
    transform$1,

    Help,
    parse,
    Parser
  ];

  function factory$99 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);
    var equalScalar$$1 = load(equalScalar);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    var latex$$1 = latex;

    /**
     * Test whether two values are equal.
     *
     * The function tests whether the relative difference between x and y is
     * smaller than the configured epsilon. The function cannot be used to
     * compare values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * In case of complex numbers, x.re must equal y.re, and x.im must equal y.im.
     *
     * Values `null` and `undefined` are compared strictly, thus `null` is only
     * equal to `null` and nothing else, and `undefined` is only equal to
     * `undefined` and nothing else. Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.equal(x, y)
     *
     * Examples:
     *
     *    math.equal(2 + 2, 3);         // returns false
     *    math.equal(2 + 2, 4);         // returns true
     *
     *    var a = math.unit('50 cm');
     *    var b = math.unit('5 m');
     *    math.equal(a, b);             // returns true
     *
     *    var c = [2, 5, 1];
     *    var d = [2, 7, 1];
     *
     *    math.equal(c, d);             // returns [true, false, true]
     *    math.deepEqual(c, d);         // returns false
     *
     *    math.equal("1000", "1e3");    // returns true
     *    math.equal(0, null);          // returns false
     *
     * See also:
     *
     *    unequal, smaller, smallerEq, larger, largerEq, compare, deepEqual, equalText
     *
     * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} x First value to compare
     * @param  {number | BigNumber | boolean | Complex | Unit | string | Array | Matrix} y Second value to compare
     * @return {boolean | Array | Matrix} Returns true when the compared values are equal, else returns false
     */
    var equal = typed('equal', {
      
      'any, any': function (x, y) {
        // strict equality for null and undefined?
        if (x === null) { return y === null; }
        if (y === null) { return x === null; }
        if (x === undefined) { return y === undefined; }
        if (y === undefined) { return x === undefined; }

        return equalScalar$$1(x, y);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, equalScalar$$1);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, equalScalar$$1, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, equalScalar$$1, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, equalScalar$$1);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return equal(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return equal(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return equal(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, equalScalar$$1, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, equalScalar$$1, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, equalScalar$$1, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, equalScalar$$1, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, equalScalar$$1, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, equalScalar$$1, true).valueOf();
      }
    });

    equal.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['equal'] + '${args[1]}\\right)'
    };

    return equal;
  }

  var name$89 = 'equal';
  var factory_1$98 = factory$99;

  var equal$1 = {
  	name: name$89,
  	factory: factory_1$98
  };

  function factory$100(type, config, load, typed, math) {
    var FunctionNode = math.expression.node.FunctionNode;
    var OperatorNode = math.expression.node.OperatorNode;
    var SymbolNode = math.expression.node.SymbolNode;

    // TODO commutative/associative properties rely on the arguments
    // e.g. multiply is not commutative for matrices
    // The properties should be calculated from an argument to simplify, or possibly something in math.config
    // the other option is for typed() to specify a return type so that we can evaluate the type of arguments
    var commutative = {
      'add': true,
      'multiply': true
    };
    var associative = {
      'add': true,
      'multiply': true
    };


    function isCommutative(node, context) {
      if (!type.isOperatorNode(node)) {
        return true;
      }
      var name = node.fn.toString();
      if (context && context.hasOwnProperty(name) && context[name].hasOwnProperty('commutative')) {
        return context[name].commutative;
      }
      return commutative[name] || false;
    }

    function isAssociative(node, context) {
      if (!type.isOperatorNode(node)) {
        return false;
      }
      var name = node.fn.toString();
      if (context && context.hasOwnProperty(name) && context[name].hasOwnProperty('associative')) {
        return context[name].associative;
      }
      return associative[name] || false;
    }

    /**
     * Flatten all associative operators in an expression tree.
     * Assumes parentheses have already been removed.
     */
    function flatten(node) {
      if (!node.args || node.args.length === 0) {
        return node;
      }
      node.args = allChildren(node);
      for (var i=0; i<node.args.length; i++) {
        flatten(node.args[i]);
      }
    }

    /**
     * Get the children of a node as if it has been flattened.
     * TODO implement for FunctionNodes
     */
    function allChildren(node) {
      var op;
      var children = [];
      var findChildren = function(node) {
        for (var i = 0; i < node.args.length; i++) {
          var child = node.args[i];
          if (type.isOperatorNode(child) && op === child.op) {
            findChildren(child);
          }
          else {
            children.push(child);
          }
        }
      };

      if (isAssociative(node)) {
        op = node.op;
        findChildren(node);
        return children;
      }
      else {
        return node.args;
      }
    }

    /**
     *  Unflatten all flattened operators to a right-heavy binary tree.
     */
    function unflattenr(node) {
      if (!node.args || node.args.length === 0) {
        return;
      }
      var makeNode = createMakeNodeFunction(node);
      var l = node.args.length;
      for (var i = 0; i < l; i++) {
        unflattenr(node.args[i]);
      }
      if (l > 2 && isAssociative(node)) {
        var curnode = node.args.pop();
        while (node.args.length > 0) {
          curnode = makeNode([node.args.pop(), curnode]);
        }
        node.args = curnode.args;
      }
    }

    /**
     *  Unflatten all flattened operators to a left-heavy binary tree.
     */
    function unflattenl(node) {
      if (!node.args || node.args.length === 0) {
        return;
      }
      var makeNode = createMakeNodeFunction(node);
      var l = node.args.length;
      for (var i = 0; i < l; i++) {
        unflattenl(node.args[i]);
      }
      if (l > 2 && isAssociative(node)) {
        var curnode = node.args.shift();
        while (node.args.length > 0) {
          curnode = makeNode([curnode, node.args.shift()]);
        }
        node.args = curnode.args;
      }
    }

    function createMakeNodeFunction(node) {
      if (type.isOperatorNode(node)) {
        return function(args){
          try{
            return new OperatorNode(node.op, node.fn, args);
          } catch(err){
            console.error(err);
            return [];
          }
        };
      }
      else {
        return function(args){
          return new FunctionNode(new SymbolNode(node.name), args);
        };
      }
    }
    return {
      createMakeNodeFunction: createMakeNodeFunction,
      isCommutative: isCommutative,
      isAssociative: isAssociative,
      flatten: flatten,
      allChildren: allChildren,
      unflattenr: unflattenr,
      unflattenl: unflattenl
    };
  }

  var factory_1$99 = factory$100;
  var math$12 = true;

  var util = {
  	factory: factory_1$99,
  	math: math$12
  };

  function factory$101 (type, config, load, typed) {
    /**
     * Test whether a value is an numeric value.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isNumeric(x)
     *
     * Examples:
     *
     *    math.isNumeric(2);                     // returns true
     *    math.isNumeric(0);                     // returns true
     *    math.isNumeric(math.bignumber(500));   // returns true
     *    math.isNumeric(math.fraction(4));      // returns true
     *    math.isNumeric(math.complex('2-4i');   // returns false
     *    math.isNumeric('3');                   // returns false
     *    math.isNumeric([2.3, 'foo', false]);   // returns [true, false, true]
     *
     * See also:
     *
     *    isZero, isPositive, isNegative, isInteger
     *
     * @param {*} x       Value to be tested
     * @return {boolean}  Returns true when `x` is a `number`, `BigNumber`,
     *                    `Fraction`, or `boolean`. Returns false for other types.
     *                    Throws an error in case of unknown types.
     */
    var isNumeric = typed('isNumeric', {
      'number | BigNumber | Fraction | boolean': function () {
        return true;
      },

      'Complex | Unit | string': function () {
        return false;
      },

      'Array | Matrix': function (x) {
        return deepMap(x, isNumeric);
      }
    });

    return isNumeric;
  }

  var name$90 = 'isNumeric';
  var factory_1$100 = factory$101;

  var isNumeric$1 = {
  	name: name$90,
  	factory: factory_1$100
  };

  var digits$1 = number.digits;
  // TODO this could be improved by simplifying seperated constants under associative and commutative operators
  function factory$102(type, config, load, typed, math) {
    var util$$1 = load(util);
    var isNumeric = load(isNumeric$1);
    var isCommutative = util$$1.isCommutative;
    var isAssociative = util$$1.isAssociative;
    var allChildren = util$$1.allChildren;
    var createMakeNodeFunction = util$$1.createMakeNodeFunction;
    var ConstantNode = math.expression.node.ConstantNode;
    var OperatorNode = math.expression.node.OperatorNode;
    var FunctionNode = math.expression.node.FunctionNode;

    function simplifyConstant(expr) {
      var res = foldFraction(expr);
      return type.isNode(res) ? res : _toNode(res);
    }

    function _eval(fnname, args) {
      try {
        return _toNumber(math[fnname].apply(null, args));
      }
      catch (ignore) {
        // sometimes the implicit type conversion causes the evaluation to fail, so we'll try again after removing Fractions
        args = args.map(function(x){
          if (type.isFraction(x)) {
            return x.valueOf();
          }
          return x;
        });
        return _toNumber(math[fnname].apply(null, args));
      }
    }

    var _toNode = typed({
      'Fraction': _fractionToNode,
      'number': function(n) {
        if (n < 0) {
          return unaryMinusNode(new ConstantNode(-n));
        }
        return new ConstantNode(n);
      },
      'BigNumber': function(n) {
        if (n < 0) {
          return unaryMinusNode(new ConstantNode(n.negated().toString(), 'number'));
        }
        return new ConstantNode(n.toString(), 'number');
      },
      'Complex': function(s) {
        throw 'Cannot convert Complex number to Node';
      }
    });

    // convert a number to a fraction only if it can be expressed exactly
    function _exactFraction(n) {
      if (isFinite(n)) {
        var f = math.fraction(n);
        if (f.valueOf() === n) {
          return f;
        }
      }
      return n;
    }

    // Convert numbers to a preferred number type in preference order: Fraction, number, Complex
    // BigNumbers are left alone
    var _toNumber = typed({
      'string': function(s) {
        if (config.number === 'BigNumber') {
          return math.bignumber(s);
        }
        else if (config.number === 'Fraction') {
          return math.fraction(s);
        }
        else {
          return _exactFraction(parseFloat(s));
        }
      },

      'Fraction': function(s) { return s; },

      'BigNumber': function(s) { return s; },

      'number': function(s) {
        return _exactFraction(s);
      },

      'Complex': function(s) {
        if (s.im !== 0) {
          return s;
        }
        return _exactFraction(s.re);
      },
    });

    function unaryMinusNode(n) {
      return new OperatorNode('-', 'unaryMinus', [n]);
    }

    function _fractionToNode(f) {
      var n;
      var vn = f.s*f.n;
      if (vn < 0) {
        n = new OperatorNode('-', 'unaryMinus', [new ConstantNode(-vn)]);
      }
      else {
        n = new ConstantNode(vn);
      }

      if (f.d === 1) {
        return n;
      }
      return new OperatorNode('/', 'divide', [n, new ConstantNode(f.d)]);
    }

    /*
     * Create a binary tree from a list of Fractions and Nodes.
     * Tries to fold Fractions by evaluating them until the first Node in the list is hit, so
     * `args` should be sorted to have the Fractions at the start (if the operator is commutative).
     * @param args - list of Fractions and Nodes
     * @param fn - evaluator for the binary operation evaluator that accepts two Fractions
     * @param makeNode - creates a binary OperatorNode/FunctionNode from a list of child Nodes
     * if args.length is 1, returns args[0]
     * @return - Either a Node representing a binary expression or Fraction
     */
    function foldOp(fn, args, makeNode) {
      return args.reduce(function(a, b) {
        if (!type.isNode(a) && !type.isNode(b)) {
          try {
            return _eval(fn, [a,b]);
          }
          catch (ignoreandcontinue) {}
          a = _toNode(a);
          b = _toNode(b);
        }
        else if (!type.isNode(a)) {
          a = _toNode(a);
        }
        else if (!type.isNode(b)) {
          b = _toNode(b);
        }

        return makeNode([a, b]);
      });
    }

    // destroys the original node and returns a folded one
    function foldFraction(node) {
      switch(node.type) {
        case 'SymbolNode':
          return node;
        case 'ConstantNode':
          if (typeof node.value === 'number') {
            return _toNumber(node.value);
          }
          return node;
        case 'FunctionNode':
          if (math[node.name] && math[node.name].rawArgs) {
            return node;
          }

          // Process operators as OperatorNode
          var operatorFunctions = [ 'add', 'multiply' ];
          if (operatorFunctions.indexOf(node.name) === -1) {
            var args = node.args.map(foldFraction);

            // If all args are numbers
            if (!args.some(type.isNode)) {
              try {
                return _eval(node.name, args);
              }
              catch (ignoreandcontine) {}
            }

            // Convert all args to nodes and construct a symbolic function call
            args = args.map(function(arg) {
              return type.isNode(arg) ? arg : _toNode(arg);
            });
            return new FunctionNode(node.name, args);
          }
          else {
            // treat as operator
          }
          /* falls through */
        case 'OperatorNode':
          var fn = node.fn.toString();
          var args;
          var res;
          var makeNode = createMakeNodeFunction(node);
          if (node.isUnary()) {
            args = [foldFraction(node.args[0])];
            if (!type.isNode(args[0])) {
              res = _eval(fn, args);
            }
            else {
              res = makeNode(args);
            }
          }
          else if (isAssociative(node)) {
            args = allChildren(node);
            args = args.map(foldFraction);

            if (isCommutative(fn)) {
              // commutative binary operator
              var consts = [], vars = [];

              for (var i=0; i < args.length; i++) {
                if (!type.isNode(args[i])) {
                  consts.push(args[i]);
                }
                else {
                  vars.push(args[i]);
                }
              }

              if (consts.length > 1) {
                res = foldOp(fn, consts, makeNode);
                vars.unshift(res);
                res = foldOp(fn, vars, makeNode);
              }
              else {
                // we won't change the children order since it's not neccessary
                res = foldOp(fn, args, makeNode);
              }
            }
            else {
              // non-commutative binary operator
              res = foldOp(fn, args, makeNode);
            }
          }
          else {
            // non-associative binary operator
            args = node.args.map(foldFraction);
            res = foldOp(fn, args, makeNode);
          }
          return res;
        case 'ParenthesisNode':
          // remove the uneccessary parenthesis
          return foldFraction(node.content);
        case 'AccessorNode':
          /* falls through */
        case 'ArrayNode':
          /* falls through */
        case 'AssignmentNode':
          /* falls through */
        case 'BlockNode':
          /* falls through */
        case 'FunctionAssignmentNode':
          /* falls through */
        case 'IndexNode':
          /* falls through */
        case 'ObjectNode':
          /* falls through */
        case 'RangeNode':
          /* falls through */
        case 'UpdateNode':
          /* falls through */
        case 'ConditionalNode':
          /* falls through */
        default:
          throw 'Unimplemented node type in simplifyConstant: '+node.type;
      }
    }

    return simplifyConstant;
  }

  var math$13 = true;
  var name$91 = 'simplifyConstant';
  var path$43 = 'algebra.simplify';
  var factory_1$101 = factory$102;

  var simplifyConstant = {
  	math: math$13,
  	name: name$91,
  	path: path$43,
  	factory: factory_1$101
  };

  function factory$103 (type, config, load, typed) {
    /**
     * Test whether a value is zero.
     * The function can check for zero for types `number`, `BigNumber`, `Fraction`,
     * `Complex`, and `Unit`.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isZero(x)
     *
     * Examples:
     *
     *    math.isZero(0);                     // returns true
     *    math.isZero(2);                     // returns false
     *    math.isZero(0.5);                   // returns false
     *    math.isZero(math.bignumber(0));     // returns true
     *    math.isZero(math.fraction(0));      // returns true
     *    math.isZero(math.fraction(1,3));    // returns false
     *    math.isZero(math.complex('2 - 4i'); // returns false
     *    math.isZero(math.complex('0i');     // returns true
     *    math.isZero('0');                   // returns true
     *    math.isZero('2');                   // returns false
     *    math.isZero([2, 0, -3]');           // returns [false, true, false]
     *
     * See also:
     *
     *    isNumeric, isPositive, isNegative, isInteger
     *
     * @param {number | BigNumber | Complex | Fraction | Unit | Array | Matrix} x       Value to be tested
     * @return {boolean}  Returns true when `x` is zero.
     *                    Throws an error in case of an unknown data type.
     */
    var isZero = typed('isZero', {
      'number': function (x) {
        return x === 0;
      },

      'BigNumber': function (x) {
        return x.isZero();
      },

      'Complex': function (x) {
        return x.re === 0 && x.im === 0;
      },

      'Fraction': function (x) {
        return x.d === 1 && x.n === 0;
      },

      'Unit': function (x) {
        return isZero(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, isZero);
      }
    });

    return isZero;
  }

  var name$92 = 'isZero';
  var factory_1$102 = factory$103;

  var isZero$1 = {
  	name: name$92,
  	factory: factory_1$102
  };

  var isInteger$6 = number.isInteger;
  var size$2 = array.size;

  function factory$104 (type, config, load, typed) {
    var latex$$1 = latex;
    var eye = load(eye$1);
    var multiply = load(multiply$1);
    var matrix$$1 = load(matrix);
    var fraction = load(fraction$2);
    var number$$1 = load(number$3);

    /**
     * Calculates the power of x to y, `x ^ y`.
     * Matrix exponentiation is supported for square matrices `x`, and positive
     * integer exponents `y`.
     *
     * For cubic roots of negative numbers, the function returns the principal
     * root by default. In order to let the function return the real root,
     * math.js can be configured with `math.config({predictable: true})`.
     * To retrieve all cubic roots of a value, use `math.cbrt(x, true)`.
     *
     * Syntax:
     *
     *    math.pow(x, y)
     *
     * Examples:
     *
     *    math.pow(2, 3);               // returns number 8
     *
     *    var a = math.complex(2, 3);
     *    math.pow(a, 2)                // returns Complex -5 + 12i
     *
     *    var b = [[1, 2], [4, 3]];
     *    math.pow(b, 2);               // returns Array [[9, 8], [16, 17]]
     *
     * See also:
     *
     *    multiply, sqrt, cbrt, nthRoot
     *
     * @param  {number | BigNumber | Complex | Array | Matrix} x  The base
     * @param  {number | BigNumber | Complex} y                   The exponent
     * @return {number | BigNumber | Complex | Array | Matrix} The value of `x` to the power `y`
     */
    var pow = typed('pow', {
      'number, number': _pow,

      'Complex, Complex': function (x, y) {
        return x.pow(y);
      },

      'BigNumber, BigNumber': function (x, y) {
        if (y.isInteger() || x >= 0 || config.predictable) {
          return x.pow(y);
        }
        else {
          return new type.Complex(x.toNumber(), 0).pow(y.toNumber(), 0);
        }
      },

      'Fraction, Fraction': function (x, y) {
        if (y.d !== 1) {
          if (config.predictable) {
            throw new Error('Function pow does not support non-integer exponents for fractions.');
          }
          else {
            return _pow(x.valueOf(), y.valueOf());
          }
        }
        else {
          return x.pow(y);
       }
      },

      'Array, number': _powArray,

      'Array, BigNumber': function (x, y) {
        return _powArray(x, y.toNumber());
      },

      'Matrix, number': _powMatrix,

      'Matrix, BigNumber': function (x, y) {
        return _powMatrix(x, y.toNumber());
      },

      'Unit, number': function (x, y) {
        return x.pow(y);
      }

    });

    /**
     * Calculates the power of x to y, x^y, for two numbers.
     * @param {number} x
     * @param {number} y
     * @return {number | Complex} res
     * @private
     */
    function _pow(x, y) {

      // Alternatively could define a 'realmode' config option or something, but
      // 'predictable' will work for now
      if (config.predictable && !isInteger$6(y) && x < 0) {
        // Check to see if y can be represented as a fraction
        try {
          var yFrac = fraction(y);
          var yNum = number$$1(yFrac);
          if(y === yNum || Math.abs((y - yNum) / y) < 1e-14) {
            if(yFrac.d % 2 === 1) {
              return (yFrac.n % 2 === 0 ? 1 : -1) * Math.pow(-x, y);
            }
          }
        }
        catch (ex) {
          // fraction() throws an error if y is Infinity, etc.
        }

        // Unable to express y as a fraction, so continue on
      }


      // x^Infinity === 0 if -1 < x < 1
      // A real number 0 is returned instead of complex(0)
      if ((x*x < 1 && y ===  Infinity) ||
          (x*x > 1 && y === -Infinity)) {
        return 0;
      }

      // **for predictable mode** x^Infinity === NaN if x < -1
      // N.B. this behavour is different from `Math.pow` which gives
      // (-2)^Infinity === Infinity
      if (config.predictable &&
          ((x < -1 &&          y ===  Infinity) ||
           (x > -1 && x < 0 && y === -Infinity))) {
        return NaN;
      }

      if (isInteger$6(y) || x >= 0 || config.predictable) {
        return Math.pow(x, y);
      }
      else {
        return new type.Complex(x, 0).pow(y, 0);
      }
    }

    /**
     * Calculate the power of a 2d array
     * @param {Array} x     must be a 2 dimensional, square matrix
     * @param {number} y    a positive, integer value
     * @returns {Array}
     * @private
     */
    function _powArray(x, y) {
      if (!isInteger$6(y) || y < 0) {
        throw new TypeError('For A^b, b must be a positive integer (value is ' + y + ')');
      }
      // verify that A is a 2 dimensional square matrix
      var s = size$2(x);
      if (s.length != 2) {
        throw new Error('For A^b, A must be 2 dimensional (A has ' + s.length + ' dimensions)');
      }
      if (s[0] != s[1]) {
        throw new Error('For A^b, A must be square (size is ' + s[0] + 'x' + s[1] + ')');
      }

      var res = eye(s[0]).valueOf();
      var px = x;
      while (y >= 1) {
        if ((y & 1) == 1) {
          res = multiply(px, res);
        }
        y >>= 1;
        px = multiply(px, px);
      }
      return res;
    }

    /**
     * Calculate the power of a 2d matrix
     * @param {Matrix} x     must be a 2 dimensional, square matrix
     * @param {number} y    a positive, integer value
     * @returns {Matrix}
     * @private
     */
    function _powMatrix (x, y) {
      return matrix$$1(_powArray(x.valueOf(), y));
    }



    pow.toTex = {
      2: '\\left(${args[0]}\\right)' + latex$$1.operators['pow'] + '{${args[1]}}'
    };

    return pow;
  }

  var name$93 = 'pow';
  var factory_1$103 = factory$104;

  var pow$1 = {
  	name: name$93,
  	factory: factory_1$103
  };

  function factory$105(type, config, load, typed, math) {
    var equal = load(equal$1);
    var isZero = load(isZero$1);
    var isNumeric = load(isNumeric$1);
    var add$$1 = load(add);
    var subtract = load(subtract$1);
    var multiply = load(multiply$1);
    var divide = load(divide$1);
    var pow = load(pow$1);

    var ConstantNode = math.expression.node.ConstantNode;
    var OperatorNode = math.expression.node.OperatorNode;
    var FunctionNode = math.expression.node.FunctionNode;
    var ParenthesisNode = math.expression.node.ParenthesisNode;

    var node0 = new ConstantNode(0);
    var node1 = new ConstantNode(1);

    /**
     * simplifyCore() performs single pass simplification suitable for
     * applications requiring ultimate performance. In contrast, simplify()
     * extends simplifyCore() with additional passes to provide deeper
     * simplification.
     *
     * Syntax:
     *
     *     simplify.simplifyCore(expr)
     *
     * Examples:
     *
     *     var f = math.parse('2 * 1 * x ^ (2 - 1)');
     *     math.simplify.simpifyCore(f);                          // Node {2 * x}
     *     math.simplify('2 * 1 * x ^ (2 - 1)', [math.simplify.simpifyCore]); // Node {2 * x};
     *
     * See also:
     *
     *     derivative
     *
     * @param {Node} node
     *     The expression to be simplified
     */
    function simplifyCore(node) {
      if (type.isOperatorNode(node) && node.isUnary()) {
        var a0 = simplifyCore(node.args[0]);

        if (node.op === '+') { // unary plus
          return a0;
        }

        if (node.op === '-') { // unary minus
          if (type.isOperatorNode(a0)) {
            if (a0.isUnary() && a0.op === '-') {
              return a0.args[0];
            } else if (a0.isBinary() && a0.fn === 'subtract') {
              return new OperatorNode('-', 'subtract', [a0.args[1], a0.args[0]]);
            }
          }
          return new OperatorNode(node.op, node.fn, [a0]);
        }
      }
      else if (type.isOperatorNode(node) && node.isBinary()) {
        var a0 = simplifyCore(node.args[0]);
        var a1 = simplifyCore(node.args[1]);

        if (node.op === "+") {
            if (type.isConstantNode(a0)) {
                if (isZero(a0.value)) {
                    return a1;
                } else if (type.isConstantNode(a1)) {
                  return new ConstantNode(add$$1(a0.value, a1.value));
                }
            }
            if (type.isConstantNode(a1) && isZero(a1.value)) {
                return a0;
            }
            if (type.isOperatorNode(a1) && a1.isUnary() && a1.op === '-') {
                return new OperatorNode('-', 'subtract', [a0,a1.args[0]]);
            }
            return new OperatorNode(node.op, node.fn, a1 ? [a0,a1] : [a0]);
        } else if (node.op === "-") {
            if (type.isConstantNode(a0) && a1) {
                if (type.isConstantNode(a1)) {
                    return new ConstantNode(subtract(a0.value, a1.value));
                } else if (isZero(a0.value)) {
                    return new OperatorNode("-", "unaryMinus", [a1]);
                }
            }
            // if (node.fn === "subtract" && node.args.length === 2) {
            if (node.fn === "subtract") {
                if (type.isConstantNode(a1) && isZero(a1.value)) {
                    return a0;
                }
                if (type.isOperatorNode(a1) && a1.isUnary() && a1.op === '-') {
                    return simplifyCore(new OperatorNode("+", "add", [a0, a1.args[0]]));
                }
                return new OperatorNode(node.op, node.fn, [a0,a1]);
            }
        } else if (node.op === "*") {
            if (type.isConstantNode(a0)) {
                if (isZero(a0.value)) {
                    return node0;
                } else if (equal(a0.value, 1)) {
                    return a1;
                } else if (type.isConstantNode(a1)) {
                    return new ConstantNode(multiply(a0.value, a1.value));
                }
            }
            if (type.isConstantNode(a1)) {
                if (isZero(a1.value)) {
                    return node0;
                } else if (equal(a1.value, 1)) {
                    return a0;
                } else if (type.isOperatorNode(a0) && a0.isBinary() && a0.op === node.op) {
                    var a00 = a0.args[0];
                    if (type.isConstantNode(a00)) {
                        var a00_a1 =  new ConstantNode(multiply(a00.value, a1.value));
                        return new OperatorNode(node.op, node.fn, [a00_a1, a0.args[1]]); // constants on left
                    }
                }
                return new OperatorNode(node.op, node.fn, [a1, a0]); // constants on left
            }
            return new OperatorNode(node.op, node.fn, [a0, a1]);
        } else if (node.op === "/") {
            if (type.isConstantNode(a0)) {
                if (isZero(a0.value)) {
                    return node0;
                } else if (type.isConstantNode(a1) &&
                        (equal(a1.value, 1) || equal(a1.value, 2) || equal(a1.value, 4))) {
                    return new ConstantNode(divide(a0.value, a1.value));
                }
            }
            return new OperatorNode(node.op, node.fn, [a0, a1]);
        } else if (node.op === "^") {
            if (type.isConstantNode(a1)) {
                if (isZero(a1.value)) {
                    return node1;
                } else if (equal(a1.value, 1)) {
                    return a0;
                } else {
                    if (type.isConstantNode(a0)) {
                        // fold constant
                        return new ConstantNode(pow(a0.value, a1.value));
                    } else if (type.isOperatorNode(a0) && a0.isBinary() && a0.op === "^") {
                        var a01 = a0.args[1];
                        if (type.isConstantNode(a01)) {
                            return new OperatorNode(node.op, node.fn, [
                                a0.args[0], 
                                new ConstantNode(multiply(a01.value, a1.value))
                            ]);
                        }
                    }
                }
            }
            return new OperatorNode(node.op, node.fn, [a0, a1]);
        }
      } else if (type.isParenthesisNode(node)) {
          var c = simplifyCore(node.content);
          if (type.isParenthesisNode(c) || type.isSymbolNode(c) || type.isConstantNode(c)) {
              return c;
          }
          return new ParenthesisNode(c);
      } else if (type.isFunctionNode(node)) {
            var args = node.args
                .map(simplifyCore)
                .map(function (arg) {
                  return type.isParenthesisNode(arg) ? arg.content : arg;
                });
            return new FunctionNode(simplifyCore(node.fn), args);
      } else {
          // cannot simplify
      }
      return node;
    }

    return simplifyCore;
  }

  var math$14 = true;
  var name$94 = 'simplifyCore';
  var path$44 = 'algebra.simplify';
  var factory_1$104 = factory$105;

  var simplifyCore = {
  	math: math$14,
  	name: name$94,
  	path: path$44,
  	factory: factory_1$104
  };

  function factory$106(type, config, load, typed, math) {
    var Node = math.expression.node.Node;
    var OperatorNode = math.expression.node.OperatorNode;
    var FunctionNode = math.expression.node.FunctionNode;
    var ParenthesisNode = math.expression.node.ParenthesisNode;

    /**
     * resolve(expr, scope) replaces variable nodes with their scoped values
     *
     * Syntax:
     *
     *     simplify.resolve(expr, scope)
     *
     * Examples:
     *
     *     math.simplify.resolve('x + y', {x:1, y:2}) // Node {1 + 2}
     *     math.simplify.resolve(math.parse('x+y'), {x:1, y:2}) // Node {1 + 2}
     *     math.simplify('x+y', {x:2, y:'x+x'}).toString(); // "6"
     *
     * @param {Node} node
     *     The expression tree to be simplified
     * @param {Object} scope with variables to be resolved
     */
    function resolve(node, scope) {
      if (!scope) {
          return node;
      }
      if (type.isSymbolNode(node)) {
          var value = scope[node.name];
          if (value instanceof Node) {
              return resolve(value, scope);
          } else if (typeof value === 'number') {
              return math.parse(String(value));
          }
      } else if (type.isOperatorNode(node)) {
          var args = node.args.map(function (arg) {
            return resolve(arg, scope)
          });
          return new OperatorNode(node.op, node.fn, args);
      } else if (type.isParenthesisNode(node)) {
          return new ParenthesisNode(resolve(node.content, scope));
      } else if (type.isFunctionNode(node)) {
          var args = node.args.map(function (arg) {
            return resolve(arg, scope)
          });
          return new FunctionNode(node.name, args);
      }
      return node;
    }

    return resolve;
  }

  var math$15 = true;
  var name$95 = 'resolve';
  var path$45 = 'algebra.simplify';
  var factory_1$105 = factory$106;

  var resolve = {
  	math: math$15,
  	name: name$95,
  	path: path$45,
  	factory: factory_1$105
  };

  function factory$107 (type, config, load, typed, math) {
    var parse$$1 = load(parse);
    var equal = load(equal$1);
    var ConstantNode$$1 = load(ConstantNode);
    var FunctionNode$$1 = load(FunctionNode);
    var OperatorNode$$1 = load(OperatorNode);
    var ParenthesisNode$$1 = load(ParenthesisNode);
    var SymbolNode$$1 = load(SymbolNode);
    var Node$$1 = load(Node);
    var simplifyConstant$$1 = load(simplifyConstant);
    var simplifyCore$$1 = load(simplifyCore);
    var resolve$$1 = load(resolve);

    var util$$1 = load(util);
    var isCommutative = util$$1.isCommutative;
    var isAssociative = util$$1.isAssociative;
    var flatten = util$$1.flatten;
    var unflattenr = util$$1.unflattenr;
    var unflattenl = util$$1.unflattenl;
    var createMakeNodeFunction = util$$1.createMakeNodeFunction;

    /**
     * Simplify an expression tree.
     *
     * A list of rules are applied to an expression, repeating over the list until
     * no further changes are made.
     * It's possible to pass a custom set of rules to the function as second
     * argument. A rule can be specified as an object, string, or function:
     *
     *     var rules = [
     *       { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },
     *       'n1*n3 + n2*n3 -> (n1+n2)*n3',
     *       function (node) {
     *         // ... return a new node or return the node unchanged
     *         return node
     *       }
     *     ]
     *
     * String and object rules consist of a left and right pattern. The left is
     * used to match against the expression and the right determines what matches
     * are replaced with. The main difference between a pattern and a normal
     * expression is that variables starting with the following characters are
     * interpreted as wildcards:
     *
     * - 'n' - matches any Node
     * - 'c' - matches any ConstantNode
     * - 'v' - matches any Node that is not a ConstantNode
     *
     * The default list of rules is exposed on the function as `simplify.rules`
     * and can be used as a basis to built a set of custom rules.
     *
     * For more details on the theory, see:
     *
     * - [Strategies for simplifying math expressions (Stackoverflow)](http://stackoverflow.com/questions/7540227/strategies-for-simplifying-math-expressions)
     * - [Symbolic computation - Simplification (Wikipedia)](https://en.wikipedia.org/wiki/Symbolic_computation#Simplification)
     *
     * Syntax:
     *
     *     simplify(expr)
     *     simplify(expr, rules)
     *     simplify(expr, rules, scope)
     *     simplify(expr, scope)
     *
     * Examples:
     *
     *     math.simplify('2 * 1 * x ^ (2 - 1)');      // Node {2 * x}
     *     math.simplify('2 * 3 * x', {x: 4});        // Node {24}
     *     var f = math.parse('2 * 1 * x ^ (2 - 1)');
     *     math.simplify(f);                          // Node {2 * x}
     *
     * See also:
     *
     *     derivative, parse, eval
     *
     * @param {Node | string} expr
     *            The expression to be simplified
     * @param {Array<{l:string, r: string} | string | function>} [rules]
     *            Optional list with custom rules
     * @return {Node} Returns the simplified form of `expr`
     */
    var simplify = typed('simplify', {
      'string': function (expr) {
        return simplify(parse$$1(expr), simplify.rules, {});
      },

      'string, Object': function (expr, scope) {
        return simplify(parse$$1(expr), simplify.rules, scope);
      },

      'string, Array': function (expr, rules) {
        return simplify(parse$$1(expr), rules, {});
      },

      'string, Array, Object': function (expr, rules, scope) {
        return simplify(parse$$1(expr), rules, scope);
      },

      'Node, Object': function (expr, scope) {
        return simplify(expr, simplify.rules, scope);
      },

      'Node': function (expr) {
        return simplify(expr, simplify.rules, {});
      },

      'Node, Array': function (expr, rules) {
        return simplify(expr, rules, {});
      },

      'Node, Array, Object': function (expr, rules, scope) {
        rules = _buildRules(rules);

        var res = resolve$$1(expr, scope);
        var res = removeParens(res);
        var visited = {};

        var str = res.toString({parenthesis: 'all'});
        while(!visited[str]) {
          visited[str] = true;
          _lastsym = 0; // counter for placeholder symbols
          for (var i=0; i<rules.length; i++) {
            if (typeof rules[i] === 'function') {
              res = rules[i](res);
            }
            else {
              flatten(res);
              res = applyRule(res, rules[i]);
            }
            unflattenl(res); // using left-heavy binary tree here since custom rule functions may expect it
          }
          str = res.toString({parenthesis: 'all'});
        }

        return res;
      }
    });
    simplify.simplifyCore = simplifyCore$$1;
    simplify.resolve = resolve$$1;

    function removeParens(node) {
      return node.transform(function(node, path, parent) {
        return type.isParenthesisNode(node)
            ? node.content
            : node;
      });
    }

    // All constants that are allowed in rules
    var SUPPORTED_CONSTANTS = {
      true: true,
      false: true,
      e: true,
      i: true,
      Infinity: true,
      LN2: true,
      LN10: true,
      LOG2E: true,
      LOG10E: true,
      NaN: true,
      phi: true,
      pi: true,
      SQRT1_2: true,
      SQRT2: true,
      tau: true,
      // null: false,
      // undefined: false,
      // version: false,
    };

    // Array of strings, used to build the ruleSet.
    // Each l (left side) and r (right side) are parsed by
    // the expression parser into a node tree.
    // Left hand sides are matched to subtrees within the
    // expression to be parsed and replaced with the right
    // hand side.
    // TODO: Add support for constraints on constants (either in the form of a '=' expression or a callback [callback allows things like comparing symbols alphabetically])
    // To evaluate lhs constants for rhs constants, use: { l: 'c1+c2', r: 'c3', evaluate: 'c3 = c1 + c2' }. Multiple assignments are separated by ';' in block format.
    // It is possible to get into an infinite loop with conflicting rules
    simplify.rules = [
      simplifyCore$$1,
      //{ l: 'n+0', r: 'n' },     // simplifyCore
      //{ l: 'n^0', r: '1' },     // simplifyCore
      //{ l: '0*n', r: '0' },     // simplifyCore
      //{ l: 'n/n', r: '1'},      // simplifyCore
      //{ l: 'n^1', r: 'n' },     // simplifyCore
      //{ l: '+n1', r:'n1' },     // simplifyCore
      //{ l: 'n--n1', r:'n+n1' }, // simplifyCore
      { l: 'log(e)', r:'1' },

      // temporary rules
      { l: 'n-n1', r:'n+-n1' }, // temporarily replace 'subtract' so we can further flatten the 'add' operator
      { l: '-(c*v)', r: '(-c) * v' }, // make non-constant terms positive
      { l: '-v', r: '(-1) * v' },
      { l: 'n/n1^n2', r:'n*n1^-n2' }, // temporarily replace 'divide' so we can further flatten the 'multiply' operator
      { l: 'n/n1', r:'n*n1^-1' },

      // expand nested exponentiation
      { l: '(n ^ n1) ^ n2', r: 'n ^ (n1 * n2)'},

      // collect like factors
      { l: 'n*n', r: 'n^2' },
      { l: 'n * n^n1', r: 'n^(n1+1)' },
      { l: 'n^n1 * n^n2', r: 'n^(n1+n2)' },

      // collect like terms
      { l: 'n+n', r: '2*n' },
      { l: 'n+-n', r: '0' },
      { l: 'n1*n2 + n2', r: '(n1+1)*n2' },
      { l: 'n1*n3 + n2*n3', r: '(n1+n2)*n3' },

      // remove parenthesis in the case of negating a quantitiy
      { l: 'n1 + -1 * (n2 + n3)', r:'n1 + -1 * n2 + -1 * n3' },

      simplifyConstant$$1,

      { l: '(-n)*n1', r: '-(n*n1)' }, // make factors positive (and undo 'make non-constant terms positive')

      // ordering of constants
      { l: 'c+v', r: 'v+c', context: { 'add': { commutative:false } } },
      { l: 'v*c', r: 'c*v', context: { 'multiply': { commutative:false } } },

      // undo temporary rules
      //{ l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
      { l: 'n+-n1', r:'n-n1' },  // undo replace 'subtract'
      { l: 'n*(n1^-1)', r:'n/n1' },  // undo replace 'divide'
      { l: 'n*n1^-n2', r:'n/n1^n2' },
      { l: 'n1^-1', r:'1/n1' },

      { l: 'n*(n1/n2)', r:'(n*n1)/n2' }, // '*' before '/'
      { l: 'n-(n1+n2)', r:'n-n1-n2' }, // '-' before '+'
      // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
      // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },

      { l: '1*n', r: 'n' } // this pattern can be produced by simplifyConstant

    ];

    /**
     * Parse the string array of rules into nodes
     *
     * Example syntax for rules:
     *
     * Position constants to the left in a product:
     * { l: 'n1 * c1', r: 'c1 * n1' }
     * n1 is any Node, and c1 is a ConstantNode.
     *
     * Apply difference of squares formula:
     * { l: '(n1 - n2) * (n1 + n2)', r: 'n1^2 - n2^2' }
     * n1, n2 mean any Node.
     *
     * Short hand notation:
     * 'n1 * c1 -> c1 * n1'
     */
    function _buildRules(rules) {
      // Array of rules to be used to simplify expressions
      var ruleSet = [];
      for(var i=0; i<rules.length; i++) {
        var rule = rules[i];
        var newRule;
        var ruleType = typeof rule;
        switch (ruleType) {
          case 'string':
            var lr = rule.split('->');
            if (lr.length !== 2) {
              throw SyntaxError('Could not parse rule: ' + rule);
            }
            rule = {l: lr[0], r: lr[1]};
            /* falls through */
          case 'object':
            newRule = {
              l: removeParens(parse$$1(rule.l)),
              r: removeParens(parse$$1(rule.r)),
            };
            if(rule.context) {
              newRule.evaluate = rule.context;
            }
            if(rule.evaluate) {
              newRule.evaluate = parse$$1(rule.evaluate);
            }

            if (isAssociative(newRule.l)) {
              var makeNode = createMakeNodeFunction(newRule.l);
              var expandsym = _getExpandPlaceholderSymbol();
              newRule.expanded = {};
              newRule.expanded.l = makeNode([newRule.l.clone(), expandsym]);
              // Push the expandsym into the deepest possible branch.
              // This helps to match the newRule against nodes returned from getSplits() later on.
              flatten(newRule.expanded.l);
              unflattenr(newRule.expanded.l);
              newRule.expanded.r = makeNode([newRule.r, expandsym]);
            }
            break;
          case 'function':
            newRule = rule;
            break;
          default:
            throw TypeError('Unsupported type of rule: ' + ruleType);
        }
       // console.log('Adding rule: ' + rules[i]);
       // console.log(newRule);
        ruleSet.push(newRule);
      }
      return ruleSet;
    }

    var _lastsym = 0;
    function _getExpandPlaceholderSymbol() {
      return new SymbolNode$$1('_p' + _lastsym++);
    }

    /**
     * Returns a simplfied form of node, or the original node if no simplification was possible.
     *
     * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
     * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} The simplified form of `expr`, or the original node if no simplification was possible.
     */
    var applyRule = typed('applyRule', {
      'Node, Object': function (node, rule) {

        //console.log('Entering applyRule(' + node.toString() + ')');

        // Do not clone node unless we find a match
        var res = node;

        // First replace our child nodes with their simplified versions
        // If a child could not be simplified, the assignments will have
        // no effect since the node is returned unchanged
        if (res instanceof OperatorNode$$1 || res instanceof FunctionNode$$1) {
          if (res.args) {
            for(var i=0; i<res.args.length; i++) {
              res.args[i] = applyRule(res.args[i], rule);
            }
          }
        }
        else if(res instanceof ParenthesisNode$$1) {
          if(res.content) {
            res.content = applyRule(res.content, rule);
          }
        }

        // Try to match a rule against this node
        var repl = rule.r;
        var matches = _ruleMatch(rule.l, res)[0];

        // If the rule is associative operator, we can try matching it while allowing additional terms.
        // This allows us to match rules like 'n+n' to the expression '(1+x)+x' or even 'x+1+x' if the operator is commutative.
        if (!matches && rule.expanded) {
          repl = rule.expanded.r;
          matches = _ruleMatch(rule.expanded.l, res)[0];
        }

        if (matches) {
          // var before = res.toString({parenthesis: 'all'});

          // Create a new node by cloning the rhs of the matched rule
          res = repl.clone();

          // Replace placeholders with their respective nodes without traversing deeper into the replaced nodes
          var _transform = function(node) {
            if(node.isSymbolNode && matches.placeholders.hasOwnProperty(node.name)) {
              return matches.placeholders[node.name].clone();
            }
            else {
              return node.map(_transform);
            }
          };

          res = _transform(res);

          // var after = res.toString({parenthesis: 'all'});
          // console.log('Simplified ' + before + ' to ' + after);
        }

        return res;
      }
    });

    /**
     * Get (binary) combinations of a flattened binary node
     * e.g. +(node1, node2, node3) -> [
     *        +(node1,  +(node2, node3)),
     *        +(node2,  +(node1, node3)),
     *        +(node3,  +(node1, node2))]
     *
     */
    function getSplits(node, context) {
      var res = [];
      var right, rightArgs;
      var makeNode = createMakeNodeFunction(node);
      if (isCommutative(node, context)) {
        for (var i=0; i<node.args.length; i++) {
          rightArgs = node.args.slice(0);
          rightArgs.splice(i, 1);
          right = (rightArgs.length === 1) ? rightArgs[0] : makeNode(rightArgs);
          res.push(makeNode([node.args[i], right]));
        }
      }
      else {
        rightArgs = node.args.slice(1);
        right = (rightArgs.length === 1) ? rightArgs[0] : makeNode(rightArgs);
        res.push(makeNode([node.args[0], right]));
      }
      return res;
    }

    /**
     * Returns the set union of two match-placeholders or null if there is a conflict.
     */
    function mergeMatch(match1, match2) {
      var res = {placeholders:{}};

      // Some matches may not have placeholders; this is OK
      if (!match1.placeholders && !match2.placeholders) {
        return res;
      }
      else if (!match1.placeholders) {
        return match2;
      }
      else if (!match2.placeholders) {
        return match1;
      }

      // Placeholders with the same key must match exactly
      for (var key in match1.placeholders) {
        res.placeholders[key] = match1.placeholders[key];
        if (match2.placeholders.hasOwnProperty(key)) {
          if (!_exactMatch(match1.placeholders[key], match2.placeholders[key] )) {
            return null;
          }
        }
      }

      for (var key in match2.placeholders) {
        res.placeholders[key] = match2.placeholders[key];
      }

      return res;
    }

    /**
     * Combine two lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
     * Each list represents matches found in one child of a node.
     */
    function combineChildMatches(list1, list2) {
      var res = [];

      if (list1.length === 0 || list2.length === 0) {
        return res;
      }

      var merged;
      for (var i1 = 0; i1 < list1.length; i1++) {
        for (var i2 = 0; i2 < list2.length; i2++) {
          merged = mergeMatch(list1[i1], list2[i2]);
          if (merged) {
            res.push(merged);
          }
        }
      }
      return res;
    }

    /**
     * Combine multiple lists of matches by applying mergeMatch to the cartesian product of two lists of matches.
     * Each list represents matches found in one child of a node.
     * Returns a list of unique matches.
     */
    function mergeChildMatches(childMatches) {
      if (childMatches.length === 0) {
        return childMatches;
      }

      var sets = childMatches.reduce(combineChildMatches);
      var uniqueSets = [];
      var unique = {};
      for(var i = 0; i < sets.length; i++) {
        var s = JSON.stringify(sets[i]);
        if (!unique[s]) {
          unique[s] = true;
          uniqueSets.push(sets[i]);
        }
      }
      return uniqueSets;
    }

    /**
     * Determines whether node matches rule.
     *
     * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} rule
     * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
     * @return {Object} Information about the match, if it exists.
     */
    function _ruleMatch(rule, node, isSplit) {
  //    console.log('Entering _ruleMatch(' + JSON.stringify(rule) + ', ' + JSON.stringify(node) + ')');
  //    console.log('rule = ' + rule);
  //    console.log('node = ' + node);

  //    console.log('Entering _ruleMatch(' + rule.toString() + ', ' + node.toString() + ')');
      var res = [{placeholders:{}}];

      if (rule instanceof OperatorNode$$1 && node instanceof OperatorNode$$1
       || rule instanceof FunctionNode$$1 && node instanceof FunctionNode$$1) {

        // If the rule is an OperatorNode or a FunctionNode, then node must match exactly
        if (rule instanceof OperatorNode$$1) {
          if (rule.op !== node.op || rule.fn !== node.fn) {
            return [];
          }
        }
        else if (rule instanceof FunctionNode$$1) {
          if (rule.name !== node.name) {
            return [];
          }
        }

        // rule and node match. Search the children of rule and node.
        if (node.args.length === 1 && rule.args.length === 1 || !isAssociative(node) || isSplit) {
          // Expect non-associative operators to match exactly
          var childMatches = [];
          for (var i = 0; i < rule.args.length; i++) {
            var childMatch = _ruleMatch(rule.args[i], node.args[i]);
            if (childMatch.length === 0) {
              // Child did not match, so stop searching immediately
              return [];
            }
            // The child matched, so add the information returned from the child to our result
            childMatches.push(childMatch);
          }
          res = mergeChildMatches(childMatches);
        }
        else if (node.args.length >= 2 && rule.args.length === 2) { // node is flattened, rule is not
          // Associative operators/functions can be split in different ways so we check if the rule matches each
          // them and return their union.
          var splits = getSplits(node, rule.context);
          var splitMatches = [];
          for(var i = 0; i < splits.length; i++) {
            var matchSet = _ruleMatch(rule, splits[i], true); // recursing at the same tree depth here
            splitMatches = splitMatches.concat(matchSet);
          }
          return splitMatches;
        }
        else if (rule.args.length > 2) {
          throw Error('Unexpected non-binary associative function: ' + rule.toString());
        }
        else {
          // Incorrect number of arguments in rule and node, so no match
          return [];
        }
      }
      else if (rule instanceof SymbolNode$$1) {
        // If the rule is a SymbolNode, then it carries a special meaning
        // according to the first character of the symbol node name.
        // c.* matches a ConstantNode
        // n.* matches any node
        if (rule.name.length === 0) {
          throw new Error('Symbol in rule has 0 length...!?');
        }
       if (math.hasOwnProperty(rule.name)) {
          if (!SUPPORTED_CONSTANTS[rule.name]) {
            throw new Error('Built in constant: ' + rule.name + ' is not supported by simplify.');
          }

          // built-in constant must match exactly
          if(rule.name !== node.name) {
            return [];
          }
        }
        else if (rule.name[0] === 'n' || rule.name.substring(0,2) === '_p') {
          // rule matches _anything_, so assign this node to the rule.name placeholder
          // Assign node to the rule.name placeholder.
          // Our parent will check for matches among placeholders.
          res[0].placeholders[rule.name] = node;
        }
        else if (rule.name[0] === 'v') {
          // rule matches any variable thing (not a ConstantNode)
          if(!type.isConstantNode(node)) {
            res[0].placeholders[rule.name] = node;
          }
          else {
            // Mis-match: rule was expecting something other than a ConstantNode
            return [];
          }
        }
        else if (rule.name[0] === 'c') {
          // rule matches any ConstantNode
          if(node instanceof ConstantNode$$1) {
            res[0].placeholders[rule.name] = node;
          }
          else {
            // Mis-match: rule was expecting a ConstantNode
            return [];
          }
        }
        else {
          throw new Error('Invalid symbol in rule: ' + rule.name);
        }
      }
      else if (rule instanceof ConstantNode$$1) {
        // Literal constant must match exactly
        if(!equal(rule.value, node.value)) {
          return [];
        }
      }
      else {
        // Some other node was encountered which we aren't prepared for, so no match
        return [];
      }

      // It's a match!

      // console.log('_ruleMatch(' + rule.toString() + ', ' + node.toString() + ') found a match');
      return res;
    }


    /**
     * Determines whether p and q (and all their children nodes) are identical.
     *
     * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} p
     * @param {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} q
     * @return {Object} Information about the match, if it exists.
     */
    function _exactMatch(p, q) {
      if(p instanceof ConstantNode$$1 && q instanceof ConstantNode$$1) {
        if(!equal(p.value, q.value)) {
          return false;
        }
      }
      else if(p instanceof SymbolNode$$1 && q instanceof SymbolNode$$1) {
        if(p.name !== q.name) {
          return false;
        }
      }
      else if(p instanceof OperatorNode$$1 && q instanceof OperatorNode$$1
           || p instanceof FunctionNode$$1 && q instanceof FunctionNode$$1) {
        if (p instanceof OperatorNode$$1) {
          if (p.op !== q.op || p.fn !== q.fn) {
            return false;
          }
        }
        else if (p instanceof FunctionNode$$1) {
          if (p.name !== q.name) {
            return false;
          }
        }

        if(p.args.length !== q.args.length) {
          return false;
        }

        for(var i=0; i<p.args.length; i++) {
          if(!_exactMatch(p.args[i], q.args[i])) {
            return false;
          }
        }
      }
      else {
        return false;
      }

      return true;
    }

    return simplify;
  }

  var math$16 = true;
  var name$96 = 'simplify';
  var factory_1$106 = factory$107;

  var simplify$1 = {
  	math: math$16,
  	name: name$96,
  	factory: factory_1$106
  };

  function factory$108 (type, config, load, typed) {
    var parse$$1 = load(parse);
    var simplify = load(simplify$1);
    var equal = load(equal$1);
    var isZero = load(isZero$1);
    var numeric$$1 = load(numeric);
    var ConstantNode$$1 = load(ConstantNode);
    var FunctionNode$$1 = load(FunctionNode);
    var OperatorNode$$1 = load(OperatorNode);
    var ParenthesisNode$$1 = load(ParenthesisNode);
    var SymbolNode$$1 = load(SymbolNode);

    /**
     * Takes the derivative of an expression expressed in parser Nodes.
     * The derivative will be taken over the supplied variable in the
     * second parameter. If there are multiple variables in the expression,
     * it will return a partial derivative.
     *
     * This uses rules of differentiation which can be found here:
     *
     * - [Differentiation rules (Wikipedia)](http://en.wikipedia.org/wiki/Differentiation_rules)
     *
     * Syntax:
     *
     *     derivative(expr, variable)
     *     derivative(expr, variable, options)
     *
     * Examples:
     *
     *     math.derivative('x^2', 'x');                     // Node {2 * x}
     *     math.derivative('x^2', 'x', {simplify: false});  // Node {2 * 1 * x ^ (2 - 1)
     *     math.derivative('sin(2x)', 'x'));                // Node {2 * cos(2 * x)}
     *     math.derivative('2*x', 'x').eval();              // number 2
     *     math.derivative('x^2', 'x').eval({x: 4});        // number 8
     *     var f = math.parse('x^2');
     *     var x = math.parse('x');
     *     math.derivative(f, x);                           // Node {2 * x}
     *
     * See also:
     *
     *     simplify, parse, eval
     *
     * @param  {Node | string} expr           The expression to differentiate
     * @param  {SymbolNode | string} variable The variable over which to differentiate
     * @param  {{simplify: boolean}} [options]
     *                         There is one option available, `simplify`, which
     *                         is true by default. When false, output will not
     *                         be simplified.
     * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
     */
    var derivative = typed('derivative', {
      'Node, SymbolNode, Object': function (expr, variable, options) {
        var constNodes = {};
        constTag(constNodes, expr, variable.name);
        var res = _derivative(expr, constNodes);
        return options.simplify ? simplify(res) : res;
      },
      'Node, SymbolNode': function (expr, variable) {
        return derivative(expr, variable, {simplify: true})
      },

      'string, SymbolNode': function (expr, variable) {
        return derivative(parse$$1(expr), variable)
      },
      'string, SymbolNode, Object': function (expr, variable, options) {
        return derivative(parse$$1(expr), variable, options)
      },

      'string, string': function (expr, variable) {
        return derivative(parse$$1(expr), parse$$1(variable))
      },
      'string, string, Object': function (expr, variable, options) {
        return derivative(parse$$1(expr), parse$$1(variable), options)
      },

      'Node, string': function (expr, variable) {
        return derivative(expr, parse$$1(variable))
      },
      'Node, string, Object': function (expr, variable, options) {
        return derivative(expr, parse$$1(variable), options)
      }

      // TODO: replace the 8 signatures above with 4 as soon as typed-function supports optional arguments

      /* TODO: implement and test syntax with order of derivatives -> implement as an option {order: number}
      'Node, SymbolNode, ConstantNode': function (expr, variable, {order}) {
        var res = expr;
        for (var i = 0; i < order; i++) {
          var constNodes = {};
          constTag(constNodes, expr, variable.name);
          res = _derivative(res, constNodes);
        }
        return res;
      }
      */
    });

    derivative._simplify = true;

    derivative.toTex = function(deriv) {
      return _derivTex.apply(null, deriv.args);
    };

    var _derivTex = typed('_derivTex', {
      'Node, SymbolNode': function (expr, x) {
        return _derivTex(expr.toString(), x.toString(), 1);
      },
      'Node, SymbolNode, ConstantNode': function (expr, x, order) {
        return _derivTex(expr.toString(), x.name, order.value);
      },
      'string, string, number': function (expr, x, order) {
        var d;
        if (order === 1) {
          d = "{d\\over d" + x + "}";
        }
        else {
          d = "{d^{" + order + "}\\over d" + x + "^{" + order + "}}";
        }
        return d + "\\left[" + expr + "\\right]"
      }
    });

    /**
     * Does a depth-first search on the expression tree to identify what Nodes
     * are constants (e.g. 2 + 2), and stores the ones that are constants in
     * constNodes. Classification is done as follows:
     *
     *   1. ConstantNodes are constants.
     *   2. If there exists a SymbolNode, of which we are differentiating over,
     *      in the subtree it is not constant.
     *
     * @param  {Object} constNodes  Holds the nodes that are constant
     * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
     * @param  {string} varName     Variable that we are differentiating
     * @return {boolean}  if node is constant
     */
    // TODO: can we rewrite constTag into a pure function?
    var constTag = typed('constTag', {
      'Object, ConstantNode, string': function (constNodes, node) {
        return constNodes[node] = true;
      },

      'Object, SymbolNode, string': function (constNodes, node, varName) {
        // Treat other variables like constants. For reasoning, see:
        //   https://en.wikipedia.org/wiki/Partial_derivative
        if (node.name !== varName) {
          return constNodes[node] = true;
        }
        return false;
      },

      'Object, ParenthesisNode, string': function (constNodes, node, varName) {
        return constTag(constNodes, node.content, varName);
      },

      'Object, FunctionAssignmentNode, string': function (constNodes, node, varName) {
        if (node.params.indexOf(varName) === -1) {
          return constNodes[node] = true;
        }
        return constTag(constNodes, node.expr, varName);
      },

      'Object, FunctionNode | OperatorNode, string': function (constNodes, node, varName) {
        if (node.args.length > 0) {
          var isConst = constTag(constNodes, node.args[0], varName);
          for (var i = 1; i < node.args.length; ++i) {
            isConst = constTag(constNodes, node.args[i], varName) && isConst;
          }

          if (isConst) {
            return constNodes[node] = true;
          }
        }
        return false;
      }
    });

    /**
     * Applies differentiation rules.
     *
     * @param  {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode} node
     * @param  {Object} constNodes  Holds the nodes that are constant
     * @return {ConstantNode | SymbolNode | ParenthesisNode | FunctionNode | OperatorNode}    The derivative of `expr`
     */
    var _derivative = typed('_derivative', {
      'ConstantNode, Object': function (node) {
         return createConstantNode(0);
      },

      'SymbolNode, Object': function (node, constNodes) {
        if (constNodes[node] !== undefined) {
          return createConstantNode(0);
        }
        return createConstantNode(1);
      },

      'ParenthesisNode, Object': function (node, constNodes) {
        return new ParenthesisNode$$1(_derivative(node.content, constNodes));
      },

      'FunctionAssignmentNode, Object': function (node, constNodes) {
        if (constNodes[node] !== undefined) {
          return createConstantNode(0);
        }
        return _derivative(node.expr, constNodes);
      },

      'FunctionNode, Object': function (node, constNodes) {
        if (node.args.length !== 1) {
          funcArgsCheck(node);
        }

        if (constNodes[node] !== undefined) {
          return createConstantNode(0);
        }

        var arg0 = node.args[0];
        var arg1;

        var div = false;       // is output a fraction?
        var negative = false;  // is output negative?

        var funcDerivative;
        switch (node.name) {
          case 'cbrt':
            // d/dx(cbrt(x)) = 1 / (3x^(2/3))
            div = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              createConstantNode(3),
              new OperatorNode$$1('^', 'pow', [
                arg0,
                new OperatorNode$$1('/', 'divide', [
                  createConstantNode(2),
                  createConstantNode(3)
                ])
              ])
            ]);
            break;
          case 'sqrt':
          case 'nthRoot':
            // d/dx(sqrt(x)) = 1 / (2*sqrt(x))
            if (node.args.length === 1) {
              div = true;
              funcDerivative = new OperatorNode$$1('*', 'multiply', [
                createConstantNode(2),
                new FunctionNode$$1('sqrt', [arg0])
              ]);
            }
            else if (node.args.length === 2) {
              // Rearrange from nthRoot(x, a) -> x^(1/a)
              arg1 = new OperatorNode$$1('/', 'divide', [
                createConstantNode(1),
                node.args[1]
              ]);

              // Is a variable?
              constNodes[arg1] = constNodes[node.args[1]];

              return _derivative(new OperatorNode$$1('^', 'pow', [arg0, arg1]), constNodes);
            }
            break;
          case 'log10':
            arg1 = createConstantNode(10);
            /* fall through! */
          case 'log':
            if (!arg1 && node.args.length === 1) {
              // d/dx(log(x)) = 1 / x
              funcDerivative = arg0.clone();
              div = true;
            } else if ((node.args.length === 1 && arg1) ||
                (node.args.length === 2 && constNodes[node.args[1]] !== undefined)) {
              // d/dx(log(x, c)) = 1 / (x*ln(c))
              funcDerivative = new OperatorNode$$1('*', 'multiply', [
                arg0.clone(),
                new FunctionNode$$1('log', [arg1 || node.args[1]])
              ]);
              div = true;
            } else if (node.args.length === 2) {
              // d/dx(log(f(x), g(x))) = d/dx(log(f(x)) / log(g(x)))
              return _derivative(new OperatorNode$$1('/', 'divide', [
                  new FunctionNode$$1('log', [arg0]),
                  new FunctionNode$$1('log', [node.args[1]])
                ]), constNodes);
            }
            break;
          case 'exp':
            // d/dx(e^x) = e^x
            funcDerivative = new FunctionNode$$1('exp', [arg0.clone()]);
            break;
          case 'sin':
            // d/dx(sin(x)) = cos(x)
            funcDerivative = new FunctionNode$$1('cos', [arg0.clone()]);
            break;
          case 'cos':
            // d/dx(cos(x)) = -sin(x)
            funcDerivative = new OperatorNode$$1('-', 'unaryMinus', [
              new FunctionNode$$1('sin', [arg0.clone()])
            ]);
            break;
          case 'tan':
            // d/dx(tan(x)) = sec(x)^2
            funcDerivative = new OperatorNode$$1('^', 'pow', [
              new FunctionNode$$1('sec', [arg0.clone()]),
              createConstantNode(2)
            ]);
            break;
          case 'sec':
            // d/dx(sec(x)) = sec(x)tan(x)
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              node,
              new FunctionNode$$1('tan', [arg0.clone()])
            ]);
            break;
          case 'csc':
            // d/dx(csc(x)) = -csc(x)cot(x)
            negative = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              node,
              new FunctionNode$$1('cot', [arg0.clone()])
            ]);
            break;
          case 'cot':
            // d/dx(cot(x)) = -csc(x)^2
            negative = true;
            funcDerivative = new OperatorNode$$1('^', 'pow', [
              new FunctionNode$$1('csc', [arg0.clone()]),
              createConstantNode(2)
            ]);
            break;
          case 'asin':
            // d/dx(asin(x)) = 1 / sqrt(1 - x^2)
            div = true;
            funcDerivative = new FunctionNode$$1('sqrt', [
              new OperatorNode$$1('-', 'subtract', [
                createConstantNode(1),
                new OperatorNode$$1('^', 'pow', [
                  arg0.clone(),
                  createConstantNode(2)
                ])
              ])
            ]);
            break;
          case 'acos':
            // d/dx(acos(x)) = -1 / sqrt(1 - x^2)
            div = true;
            negative = true;
            funcDerivative = new FunctionNode$$1('sqrt', [
              new OperatorNode$$1('-', 'subtract', [
                createConstantNode(1),
                new OperatorNode$$1('^', 'pow', [
                  arg0.clone(),
                  createConstantNode(2)
                ])
              ])
            ]);
            break;
          case 'atan':
            // d/dx(atan(x)) = 1 / (x^2 + 1)
            div = true;
            funcDerivative = new OperatorNode$$1('+', 'add', [
              new OperatorNode$$1('^', 'pow', [
                arg0.clone(),
                createConstantNode(2)
              ]),
              createConstantNode(1)
            ]);
            break;
          case 'asec':
            // d/dx(asec(x)) = 1 / (|x|*sqrt(x^2 - 1))
            div = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              new FunctionNode$$1('abs', [arg0.clone()]),
              new FunctionNode$$1('sqrt', [
                new OperatorNode$$1('-', 'subtract', [
                  new OperatorNode$$1('^', 'pow', [
                    arg0.clone(),
                    createConstantNode(2)
                  ]),
                  createConstantNode(1)
                ])
              ])
            ]);
            break;
          case 'acsc':
            // d/dx(acsc(x)) = -1 / (|x|*sqrt(x^2 - 1))
            div = true;
            negative = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              new FunctionNode$$1('abs', [arg0.clone()]),
              new FunctionNode$$1('sqrt', [
                new OperatorNode$$1('-', 'subtract', [
                  new OperatorNode$$1('^', 'pow', [
                    arg0.clone(),
                    createConstantNode(2)
                  ]),
                  createConstantNode(1)
                ])
              ])
            ]);
            break;
          case 'acot':
            // d/dx(acot(x)) = -1 / (x^2 + 1)
            div = true;
            negative = true;
            funcDerivative = new OperatorNode$$1('+', 'add', [
              new OperatorNode$$1('^', 'pow', [
                arg0.clone(),
                createConstantNode(2)
              ]),
              createConstantNode(1)
            ]);
            break;
          case 'sinh':
            // d/dx(sinh(x)) = cosh(x)
            funcDerivative = new FunctionNode$$1('cosh', [arg0.clone()]);
            break;
          case 'cosh':
            // d/dx(cosh(x)) = sinh(x)
            funcDerivative = new FunctionNode$$1('sinh', [arg0.clone()]);
            break;
          case 'tanh':
            // d/dx(tanh(x)) = sech(x)^2
            funcDerivative = new OperatorNode$$1('^', 'pow', [
              new FunctionNode$$1('sech', [arg0.clone()]),
              createConstantNode(2)
            ]);
            break;
          case 'sech':
            // d/dx(sech(x)) = -sech(x)tanh(x)
            negative = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              node,
              new FunctionNode$$1('tanh', [arg0.clone()])
            ]);
            break;
          case 'csch':
            // d/dx(csch(x)) = -csch(x)coth(x)
            negative = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              node,
              new FunctionNode$$1('coth', [arg0.clone()])
            ]);
            break;
          case 'coth':
            // d/dx(coth(x)) = -csch(x)^2
            negative = true;
            funcDerivative = new OperatorNode$$1('^', 'pow', [
              new FunctionNode$$1('csch', [arg0.clone()]),
              createConstantNode(2)
            ]);
            break;
          case 'asinh':
            // d/dx(asinh(x)) = 1 / sqrt(x^2 + 1)
            div = true;
            funcDerivative = new FunctionNode$$1('sqrt', [
              new OperatorNode$$1('+', 'add', [
                new OperatorNode$$1('^', 'pow', [
                  arg0.clone(),
                  createConstantNode(2)
                ]),
                createConstantNode(1)
              ])
            ]);
            break;
          case 'acosh':
            // d/dx(acosh(x)) = 1 / sqrt(x^2 - 1); XXX potentially only for x >= 1 (the real spectrum)
            div = true;
            funcDerivative = new FunctionNode$$1('sqrt', [
              new OperatorNode$$1('-', 'subtract', [
                new OperatorNode$$1('^', 'pow', [
                  arg0.clone(),
                  createConstantNode(2)
                ]),
                createConstantNode(1)
              ])
            ]);
            break;
          case 'atanh':
            // d/dx(atanh(x)) = 1 / (1 - x^2)
            div = true;
            funcDerivative = new OperatorNode$$1('-', 'subtract', [
              createConstantNode(1),
              new OperatorNode$$1('^', 'pow', [
                arg0.clone(),
                createConstantNode(2)
              ])
            ]);
            break;
          case 'asech':
            // d/dx(asech(x)) = -1 / (x*sqrt(1 - x^2))
            div = true;
            negative = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              arg0.clone(),
              new FunctionNode$$1('sqrt', [
                new OperatorNode$$1('-', 'subtract', [
                  createConstantNode(1),
                  new OperatorNode$$1('^', 'pow', [
                    arg0.clone(),
                    createConstantNode(2)
                  ])
                ])
              ])
            ]);
            break;
          case 'acsch':
            // d/dx(acsch(x)) = -1 / (|x|*sqrt(x^2 + 1))
            div = true;
            negative = true;
            funcDerivative = new OperatorNode$$1('*', 'multiply', [
              new FunctionNode$$1('abs', [arg0.clone()]),
              new FunctionNode$$1('sqrt', [
                new OperatorNode$$1('+', 'add', [
                  new OperatorNode$$1('^', 'pow', [
                    arg0.clone(),
                    createConstantNode(2)
                  ]),
                  createConstantNode(1)
                ])
              ])
            ]);
            break;
          case 'acoth':
            // d/dx(acoth(x)) = -1 / (1 - x^2)
            div = true;
            negative = true;
            funcDerivative = new OperatorNode$$1('-', 'subtract', [
              createConstantNode(1),
              new OperatorNode$$1('^', 'pow', [
                arg0.clone(),
                createConstantNode(2)
              ])
            ]);
            break;
          case 'abs':
            // d/dx(abs(x)) = abs(x)/x
            funcDerivative = new OperatorNode$$1('/', 'divide', [
              new FunctionNode$$1(new SymbolNode$$1('abs'), [arg0.clone()]),
              arg0.clone()
            ]);
            break;
          case 'gamma':  // Needs digamma function, d/dx(gamma(x)) = gamma(x)digamma(x)
          default: throw new Error('Function "' + node.name + '" is not supported by derivative, or a wrong number of arguments is passed');
        }

        var op, func;
        if (div) {
          op = '/';
          func = 'divide';
        } else {
          op = '*';
          func = 'multiply';
        }

        /* Apply chain rule to all functions:
           F(x)  = f(g(x))
           F'(x) = g'(x)*f'(g(x)) */
        var chainDerivative = _derivative(arg0, constNodes);
        if (negative) {
          chainDerivative = new OperatorNode$$1('-', 'unaryMinus', [chainDerivative]);
        }
        return new OperatorNode$$1(op, func, [chainDerivative, funcDerivative]);
      },

      'OperatorNode, Object': function (node, constNodes) {
        if (constNodes[node] !== undefined) {
          return createConstantNode(0);
        }

        if (node.op === '+') {
          // d/dx(sum(f(x)) = sum(f'(x))
          return new OperatorNode$$1(node.op, node.fn, node.args.map(function(arg) {
            return _derivative(arg, constNodes);
          }));
        }

        if (node.op === '-') {
          // d/dx(+/-f(x)) = +/-f'(x)
          if (node.isUnary()) {
            return new OperatorNode$$1(node.op, node.fn, [
                _derivative(node.args[0], constNodes)
            ]);
          }

          // Linearity of differentiation, d/dx(f(x) +/- g(x)) = f'(x) +/- g'(x)
          if (node.isBinary()) {
            return new OperatorNode$$1(node.op, node.fn, [
              _derivative(node.args[0], constNodes),
              _derivative(node.args[1], constNodes)
            ]);
          }
        }

        if (node.op === '*') {
          // d/dx(c*f(x)) = c*f'(x)
          var constantTerms = node.args.filter(function(arg) {
            return constNodes[arg] !== undefined;
          });

          if (constantTerms.length > 0) {
            var nonConstantTerms = node.args.filter(function(arg) {
              return constNodes[arg] === undefined;
            });

            var nonConstantNode = nonConstantTerms.length === 1
                ? nonConstantTerms[0]
                : new OperatorNode$$1('*', 'multiply', nonConstantTerms);

            var newArgs = constantTerms.concat(_derivative(nonConstantNode, constNodes));

            return new OperatorNode$$1('*', 'multiply', newArgs);
          }

          // Product Rule, d/dx(f(x)*g(x)) = f'(x)*g(x) + f(x)*g'(x)
          return new OperatorNode$$1('+', 'add', node.args.map(function(argOuter) {
            return new OperatorNode$$1('*', 'multiply', node.args.map(function(argInner) {
              return (argInner === argOuter)
                  ? _derivative(argInner, constNodes)
                  : argInner.clone();
            }));
          }));
        }

        if (node.op === '/' && node.isBinary()) {
          var arg0 = node.args[0];
          var arg1 = node.args[1];

          // d/dx(f(x) / c) = f'(x) / c
          if (constNodes[arg1] !== undefined) {
            return new OperatorNode$$1('/', 'divide', [_derivative(arg0, constNodes), arg1]);
          }

          // Reciprocal Rule, d/dx(c / f(x)) = -c(f'(x)/f(x)^2)
          if (constNodes[arg0] !== undefined) {
            return new OperatorNode$$1('*', 'multiply', [
              new OperatorNode$$1('-', 'unaryMinus', [arg0]),
              new OperatorNode$$1('/', 'divide', [
                _derivative(arg1, constNodes),
                new OperatorNode$$1('^', 'pow', [arg1.clone(), createConstantNode(2)])
              ])
            ]);
          }

          // Quotient rule, d/dx(f(x) / g(x)) = (f'(x)g(x) - f(x)g'(x)) / g(x)^2
          return new OperatorNode$$1('/', 'divide', [
            new OperatorNode$$1('-', 'subtract', [
              new OperatorNode$$1('*', 'multiply', [_derivative(arg0, constNodes), arg1.clone()]),
              new OperatorNode$$1('*', 'multiply', [arg0.clone(), _derivative(arg1, constNodes)])
            ]),
            new OperatorNode$$1('^', 'pow', [arg1.clone(), createConstantNode(2)])
          ]);
        }

        if (node.op === '^' && node.isBinary()) {
          var arg0 = node.args[0];
          var arg1 = node.args[1];

          if (constNodes[arg0] !== undefined) {
            // If is secretly constant; 0^f(x) = 1 (in JS), 1^f(x) = 1
            if (type.isConstantNode(arg0) && (isZero(arg0.value) || equal(arg0.value, 1))) {
              return createConstantNode(0);
            }

            // d/dx(c^f(x)) = c^f(x)*ln(c)*f'(x)
            return new OperatorNode$$1('*', 'multiply', [
              node,
              new OperatorNode$$1('*', 'multiply', [
                new FunctionNode$$1('log', [arg0.clone()]),
                _derivative(arg1.clone(), constNodes)
              ])
            ]);
          }

            if (constNodes[arg1] !== undefined) {
              if (type.isConstantNode(arg1)) {
                // If is secretly constant; f(x)^0 = 1 -> d/dx(1) = 0
                if (isZero(arg1.value)) {
                  return createConstantNode(0);
                }
                // Ignore exponent; f(x)^1 = f(x)
                if (equal(arg1.value,1)) {
                  return _derivative(arg0, constNodes);
                }
              }

              // Elementary Power Rule, d/dx(f(x)^c) = c*f'(x)*f(x)^(c-1)
              var powMinusOne = new OperatorNode$$1('^', 'pow', [
                arg0.clone(),
                new OperatorNode$$1('-', 'subtract', [
                  arg1,
                  createConstantNode(1)
                ])
              ]);

            return new OperatorNode$$1('*', 'multiply', [
              arg1.clone(),
              new OperatorNode$$1('*', 'multiply', [
                _derivative(arg0, constNodes),
                powMinusOne
              ])
            ]);
          }

          // Functional Power Rule, d/dx(f^g) = f^g*[f'*(g/f) + g'ln(f)]
          return new OperatorNode$$1('*', 'multiply', [
            new OperatorNode$$1('^', 'pow', [arg0.clone(), arg1.clone()]),
            new OperatorNode$$1('+', 'add', [
              new OperatorNode$$1('*', 'multiply', [
                _derivative(arg0, constNodes),
                new OperatorNode$$1('/', 'divide', [arg1.clone(), arg0.clone()])
              ]),
              new OperatorNode$$1('*', 'multiply', [
                _derivative(arg1, constNodes),
                new FunctionNode$$1('log', [arg0.clone()])
              ])
            ])
          ]);
        }

        throw new Error('Operator "' + node.op + '" is not supported by derivative, or a wrong number of arguments is passed');
      }
    });

    /**
     * Ensures the number of arguments for a function are correct,
     * and will throw an error otherwise.
     *
     * @param {FunctionNode} node
     */
    function funcArgsCheck(node) {
      //TODO add min, max etc
      if ((node.name === 'log' || node.name === 'nthRoot') && node.args.length === 2) {
        return;
      }

      // There should be an incorrect number of arguments if we reach here

      // Change all args to constants to avoid unidentified
      // symbol error when compiling function
      for (var i = 0; i < node.args.length; ++i) {
        node.args[i] = createConstantNode(0);
      }

      node.compile().eval();
      throw new Error('Expected TypeError, but none found');
    }

    /**
     * Helper function to create a constant node with a specific type
     * (number, BigNumber, Fraction)
     * @param {number} value
     * @param {string} [valueType]
     * @return {ConstantNode}
     */
    function createConstantNode(value, valueType) {
      return new ConstantNode$$1(numeric$$1(value, valueType || config.number));
    }

    return derivative;
  }

  var name$97 = 'derivative';
  var factory_1$107 = factory$108;

  var derivative$1 = {
  	name: name$97,
  	factory: factory_1$107
  };

  function factory$109 (type, config, load, typed) {
    var simplify = load(simplify$1);
    var simplifyCore$$1 = load(simplifyCore);  
    var simplifyConstant$$1 = load(simplifyConstant);  
    var ArgumentsError = ArgumentsError_1;
    var parse = load(parse$1);
    var number$$1 = number;
    var ConstantNode$$1 = load(ConstantNode);
    var OperatorNode$$1 = load(OperatorNode);
    var SymbolNode$$1 = load(SymbolNode);

    /**
     * Transform a rationalizable expression in a rational fraction. 
     * If rational fraction is one variable polynomial then converts
     * the numerator and denominator in canonical form, with decreasing
     * exponents, returning the coefficients of numerator. 
     *
     * Syntax:
     *
     *     rationalize(expr)
     *     rationalize(expr, detailed)
     *     rationalize(expr, scope)
     *     rationalize(expr, scope, detailed)
     *
     * Examples:
     *
     *     math.rationalize('sin(x)+y')  //  Error: There is an unsolved function call
     *     math.rationalize('2x/y - y/(x+1)')  // (2*x^2-y^2+2*x)/(x*y+y)
     *     math.rationalize('(2x+1)^6')  
     *                   //     64*x^6+192*x^5+240*x^4+160*x^3+60*x^2+12*x+1
     *     math.rationalize('2x/( (2x-1) / (3x+2) ) - 5x/ ( (3x+4) / (2x^2-5) ) + 3') 
     *                   //    -20*x^4+28*x^3+104*x^2+6*x-12)/(6*x^2+5*x-4)
     *     math.rationalize('x/(1-x)/(x-2)/(x-3)/(x-4) + 2x/ ( (1-2x)/(2-3x) )/ ((3-4x)/(4-5x) )') =
     *                   //  (-30*x^7+344*x^6-1506*x^5+3200*x^4-3472*x^3+1846*x^2-381*x)/
     *                   //   (-8*x^6+90*x^5-383*x^4+780*x^3-797*x^2+390*x-72)
     *
     *     math.rationalize('x+x+x+y',{y:1}) // 3*x+1
     *     math.rationalize('x+x+x+y',{})    // 3*x+y
     *     ret = math.rationalize('x+x+x+y',{},true) 
     *                          // ret.expression=3*x+y,  ret.variables = ["x","y"]
     *     ret = math.rationalize('-2+5x^2',{},true) 
     *                          // ret.expression=5*x^2-2,  ret.variables = ["x"], ret.coefficients=[-2,0,5]
     *
     * See also:
     * 
     *     simplify
     * 
     * @param  {Node|string} expr    The expression to check if is a polynomial expression
     * @param  {Object|boolean}      optional scope of expression or true for already evaluated rational expression at input
     * @param  {Boolean}  detailed   optional True if return an object, false if return expression node (default) 
     *
     * @return {Object | Expression Node}    The rational polynomial of `expr` or na object
     *            {Object}
     *              {Expression Node} expression: node simplified expression
     *              {Expression Node} numerator: simplified numerator of expression
     *              {Expression Node | boolean} denominator: simplified denominator or false (if there is no denominator)
     *              {Array}           variables:  variable names
     *              {Array}           coefficients: coefficients of numerator sorted by increased exponent 
     *           {Expression Node}  node simplified expression
     *   
     */
    var rationalize = typed('rationalize', {
      'string': function (expr) {
         return rationalize(parse(expr), {}, false);  
      },

      'string, boolean': function (expr, detailed) {
         return rationalize(parse(expr), {} , detailed); 
      },

      'string, Object': function (expr, scope) {
         return rationalize(parse(expr), scope, false);  
      },

      'string, Object, boolean': function (expr, scope, detailed) {
         return rationalize(parse(expr), scope, detailed); 
      },

      'Node': function (expr) {
         return rationalize(expr, {}, false);
      },

      'Node, boolean': function (expr, detailed) {
        return rationalize(expr, {}, detailed);
      },

      'Node, Object': function (expr, scope) {
        return rationalize(expr, scope, false);
      },

      'Node, Object, boolean': function (expr, scope, detailed) {

        var polyRet = polynomial(expr, scope, true);  // Check if expression is a rationalizable polynomial
        var nVars =  polyRet.variables.length;
        var expr = polyRet.expression;         
             
        if (nVars>=1) {   // If expression in not a constant
          var setRules = rulesRationalize();   // Rules for change polynomial in near canonical form
          expr = expandPower(expr);              // First expand power of polynomials (cannot be made from rules!)
          var redoInic = true;   // If has change after start, redo the beginning
          var s = "";            // New expression
          var sBefore;           // Previous expression
          var rules;  
          var eDistrDiv = true;  

          expr = simplify(expr, setRules.firstRules);  // Apply the initial rules, including succ div rules
          s = expr.toString();


          while (true) {                  // Apply alternately  successive division rules and distr.div.rules
            rules = eDistrDiv ? setRules.distrDivRules : setRules.sucDivRules;
            expr = simplify(expr,rules);         // until no more changes
            eDistrDiv = ! eDistrDiv;    // Swap between Distr.Div and Succ. Div. Rules
            
            s = expr.toString();
            if (s===sBefore) break   // No changes : end of the loop
            
            redoInic = true;
            sBefore = s;
          }  
         
          if (redoInic)  {         // Apply first rules again without succ div rules (if there are changes)
            expr = simplify(expr,setRules.firstRulesAgain); 
          }
          expr = simplify(expr,setRules.finalRules);  // Aplly final rules 

        }  // NVars >= 1

        var coefficients=[];
        var retRationalize = {};

        if (expr.type === 'OperatorNode' && expr.isBinary() && expr.op === '/')  {   // Separate numerator from denominator
            if (nVars==1)  {
               expr.args[0] = polyToCanonical(expr.args[0],coefficients);
               expr.args[1] = polyToCanonical(expr.args[1]);
            }
            if (detailed) {
              retRationalize.numerator = expr.args[0];
              retRationalize.denominator = expr.args[1];
            }
          } else {
            if (nVars==1) expr = polyToCanonical(expr,coefficients);
            if (detailed) { 
              retRationalize.numerator = expr;
              retRationalize.denominator = null; 
            }
        }
         // nVars

        if (! detailed) return expr;
        retRationalize.coefficients = coefficients;
        retRationalize.variables = polyRet.variables;
        retRationalize.expression = expr;
        return retRationalize;
      }  // ^^^^^^^ end of rationalize ^^^^^^^^
    });  // end of typed rationalize

    /**
     *  Function to simplify an expression using an optional scope and
     *  return it if the expression is a polynomial expression, i.e. 
     *  an expression with one or more variables and the operators
     *  +, -, *, and ^, where the exponent can only be a positive integer. 
     *
     * Syntax:
     *
     *     polynomial(expr,scope,extended)
     *
     * @param  {Node | string} expr     The expression to simplify and check if is polynomial expression
     * @param  {object} scope           Optional scope for expression simplification
     * @param  {boolean} extended       Optional. Default is false. When true allows divide operator.
     *
     *
     * @return {Object} 
     *            {Object} node:   node simplified expression
     *            {Array}  variables:  variable names
     */             
    function polynomial (expr, scope, extended) {
      var variables = [];
      var node = simplify(expr,scope);  // Resolves any variables and functions with all defined parameters   
      extended = !! extended;

      var oper = '+-*' + (extended ? '/' : '');
      recPoly(node); 
      var retFunc ={};
      retFunc.expression = node;
      retFunc.variables = variables;
      return retFunc; 

      //-------------------------------------------------------------------------------------------------------

      /**
       *  Function to simplify an expression using an optional scope and
       *  return it if the expression is a polynomial expression, i.e. 
       *  an expression with one or more variables and the operators
       *  +, -, *, and ^, where the exponent can only be a positive integer. 
       *
       * Syntax:
       *
       *     recPoly(node)
       *
       *
       * @param  {Node} node               The current sub tree expression in recursion
       *
       * @return                           nothing, throw an exception if error
       */
      function recPoly(node) {
        var tp = node.type;  // node type
        if (tp==='FunctionNode') 
          throw new ArgumentsError('There is an unsolved function call')   // No function call in polynomial expression
        else if (tp==='OperatorNode')  {
          if (node.op === '^' && node.isBinary())  {
            if (node.args[1].type!=='ConstantNode' ||  ! number$$1.isInteger(parseFloat(node.args[1].value)))
              throw new ArgumentsError('There is a non-integer exponent');
            else
              recPoly(node.args[0]);      
          } else  { 
              if (oper.indexOf(node.op) === -1) throw new ArgumentsError('Operator ' + node.op + ' invalid in polynomial expression');
              for (var i=0;i<node.args.length;i++) { 
                recPoly(node.args[i]);
              }
          } // type of operator

        } else if (tp==='SymbolNode')  {
           var name = node.name;   // variable name
           var pos = variables.indexOf(name); 
           if (pos===-1)    // new variable in expression
             variables.push(name);        

        } else if (tp==='ParenthesisNode') 
           recPoly(node.content);

        else if (tp!=='ConstantNode')   
           throw new ArgumentsError('type ' + tp + ' is not allowed in polynomial expression')
           
      }  // end of recPoly

    }  // end of polynomial 


    //---------------------------------------------------------------------------------------
    /**
     * Return a rule set to rationalize an polynomial expression in rationalize
     *
     * Syntax:
     *
     *     rulesRationalize()
     *
     * @return {array}        rule set to rationalize an polynomial expression 
     */
    function rulesRationalize() {
      var oldRules = [simplifyCore$$1,  // sCore
                  {l:"n+n",r:"2*n"},
                  {l:"n+-n",r:"0"},
                  simplifyConstant$$1,  // sConstant
                  {l:"n*(n1^-1)",r:"n/n1"},
                  {l:"n*n1^-n2",r:"n/n1^n2"},
                  {l:"n1^-1",r:"1/n1"},
                  {l:"n*(n1/n2)",r:"(n*n1)/n2"},
                  {l:"1*n",r:"n"}];

      var rulesFirst = [
         { l: '(-n1)/(-n2)', r: 'n1/n2' },  // Unary division
         { l: '(-n1)*(-n2)', r: 'n1*n2' },  // Unary multiplication
         { l: 'n1--n2', r:'n1+n2'},        // '--' elimination
         { l: 'n1-n2', r:'n1+(-n2)'} ,      // Subtraction turn into add with un�ry minus    
         { l:'(n1+n2)*n3', r:'(n1*n3 + n2*n3)' },     // Distributive 1 
         { l:'n1*(n2+n3)', r:'(n1*n2+n1*n3)' },       // Distributive 2 
         { l: 'c1*n + c2*n', r:'(c1+c2)*n'} ,       // Joining constants
         { l: '-v*-c', r:'c*v'} ,          // Inversion constant and variable 1
         { l: '-v*c', r:'-c*v'} ,          // Inversion constant and variable 2
         { l: 'v*-c', r:'-c*v'} ,          // Inversion constant and variable 3
         { l: 'v*c', r:'c*v'} ,            // Inversion constant and variable 4
         { l: '-(-n1*n2)', r:'(n1*n2)'} ,  // Unary propagation
         { l: '-(n1*n2)', r:'(-n1*n2)'} ,  // Unary propagation
         { l: '-(-n1+n2)', r:'(n1-n2)'} ,  // Unary propagation
         { l: '-(n1+n2)', r:'(-n1-n2)'} ,  // Unary propagation
         { l: '(n1^n2)^n3', r:'(n1^(n2*n3))'} ,  // Power to Power
         { l: '-(-n1/n2)', r:'(n1/n2)'} ,   // Division and Unary
         { l: '-(n1/n2)', r:'(-n1/n2)'} ];   // Divisao and Unary

      var rulesDistrDiv=[
         { l:'(n1/n2 + n3/n4)', r:'((n1*n4 + n3*n2)/(n2*n4))' },  // Sum of fractions
         { l:'(n1/n2 + n3)', r:'((n1 + n3*n2)/n2)' }, // Sum fraction with number 1
         { l:'(n1 + n2/n3)', r:'((n1*n3 + n2)/n3)' }  ];  // Sum fraction with number 1

      var rulesSucDiv=[
         { l:'(n1/(n2/n3))', r:'((n1*n3)/n2)'} , // Division simplification
         { l:'(n1/n2/n3)', r:'(n1/(n2*n3))' } ];

      var setRules={};   // rules set in 4 steps. 

          // All rules => infinite loop
          // setRules.allRules =oldRules.concat(rulesFirst,rulesDistrDiv,rulesSucDiv);  

      setRules.firstRules =oldRules.concat(rulesFirst,rulesSucDiv);  // First rule set
      setRules.distrDivRules = rulesDistrDiv;                  // Just distr. div. rules  
      setRules.sucDivRules = rulesSucDiv;                      // Jus succ. div. rules
      setRules.firstRulesAgain = oldRules.concat(rulesFirst);  // Last rules set without succ. div. 

             // Division simplification
            
           // Second rule set. 
            // There is no aggregate expression with parentesis, but the only variable can be scattered. 
      setRules.finalRules=[ simplifyCore$$1,                // simplify.rules[0]
         { l: 'n*-n', r: '-n^2' },                // Joining multiply with power 1
         { l: 'n*n', r: 'n^2' },                  // Joining multiply with power 2
          simplifyConstant$$1,                              // simplify.rules[14] old 3rd index in oldRules
         { l: 'n*-n^n1', r: '-n^(n1+1)' },        // Joining multiply with power 3
         { l: 'n*n^n1', r: 'n^(n1+1)' },          // Joining multiply with power 4
         { l: 'n^n1*-n^n2', r: '-n^(n1+n2)' },    // Joining multiply with power 5
         { l: 'n^n1*n^n2', r: 'n^(n1+n2)' },      // Joining multiply with power 6
         { l: 'n^n1*-n', r: '-n^(n1+1)' },        // Joining multiply with power 7
         { l: 'n^n1*n', r: 'n^(n1+1)' },          // Joining multiply with power 8
         { l: 'n^n1/-n', r: '-n^(n1-1)' },        // Joining multiply with power 8
         { l: 'n^n1/n', r: 'n^(n1-1)' },          // Joining division with power 1
         { l: 'n/-n^n1', r: '-n^(1-n1)' },        // Joining division with power 2
         { l: 'n/n^n1', r: 'n^(1-n1)' },          // Joining division with power 3
         { l: 'n^n1/-n^n2', r: 'n^(n1-n2)' },     // Joining division with power 4
         { l: 'n^n1/n^n2', r: 'n^(n1-n2)' },      // Joining division with power 5
         { l: 'n1+(-n2*n3)', r: 'n1-n2*n3' },     // Solving useless parenthesis 1 
         { l: 'v*(-c)', r: '-c*v' },              // Solving useless unary 2 
         { l: 'n1+-n2', r: 'n1-n2' },             // Solving +- together (new!)
         { l: 'v*c', r: 'c*v' },                  // inversion constant with variable
         { l: '(n1^n2)^n3', r:'(n1^(n2*n3))'},    // Power to Power
         
      ];                    
      return setRules;
    } // End rulesRationalize

    //---------------------------------------------------------------------------------------
    /**
     *  Expand recursively a tree node for handling with expressions with exponents
     *  (it's not for constants, symbols or functions with exponents)
     *  PS: The other parameters are internal for recursion
     *
     * Syntax:
     *
     *     expandPower(node)
     *
     * @param  {Node} node         Current expression node
     * @param  {node} parent       Parent current node inside the recursion
     * @param  (int}               Parent number of chid inside the rercursion 
     *
     * @return {node}        node expression with all powers expanded. 
     */
    function expandPower(node,parent,indParent) {
      var tp = node.type; 
      var internal = (arguments.length>1);   // TRUE in internal calls

      if (tp === 'OperatorNode' && node.isBinary()) {
        var does = false;
        if (node.op==='^')  {   // First operator: Parenthesis or UnaryMinus
          if ( ( node.args[0].type==='ParenthesisNode' ||  
              node.args[0].type==='OperatorNode' ) 
              && (node.args[1].type==='ConstantNode') )  {   // Second operator: Constant
            var val = parseFloat(node.args[1].value);
            does = (val>=2 && number$$1.isInteger(val));  
          }
        } 

        if (does)  {  // Exponent >= 2 
            //Before:
            //            operator A --> Subtree
            // parent pow 
            //            constant
            //
          if (val>2)     {  // Exponent > 2, 
            //AFTER:  (exponent > 2)
            //             operator A --> Subtree
            // parent  * 
            //                 deep clone (operator A --> Subtree
            //             pow     
            //                 constant - 1
            //
             var nEsqTopo = node.args[0];  
             var nDirTopo = new OperatorNode$$1('^', 'pow', [node.args[0].cloneDeep(),new ConstantNode$$1(val-1)]);
             node = new OperatorNode$$1('*', 'multiply', [nEsqTopo, nDirTopo]);
          } else   // Expo = 2 - no power

              //AFTER:  (exponent =  2)
              //             operator A --> Subtree
              // parent   oper 
              //            deep clone (operator A --> Subtree)    
              //                            
             node = new OperatorNode$$1('*', 'multiply', [node.args[0], node.args[0].cloneDeep()]);
          
          if (internal)       // Change parent references in internal recursive calls
            if (indParent==='content')
              parent.content = node;
            else
              parent.args[indParent] = node;
        } // does
      } // binary OperatorNode

      if (tp==='ParenthesisNode' )  // Recursion 
             expandPower(node.content,node,'content');  
      else if (tp!=='ConstantNode' && tp!=='SymbolNode')  
        for (var i=0;i<node.args.length;i++)  
           expandPower(node.args[i],node,i);
          
        
      if (! internal ) return node   // return the root node

    }  // End expandPower


    //---------------------------------------------------------------------------------------
    /**
     * Auxilary function for rationalize
     * Convert near canonical polynomial in one variable in a canonical polynomial
     * with one term for each exponent in decreasing order
     *
     * Syntax:
     *
     *     polyToCanonical(node [, coefficients])
     *
     * @param  {Node | string} expr       The near canonical polynomial expression to convert in a a canonical polynomial expression
     * 
     *        The string or tree expression needs to be at below syntax, with free spaces:
     *         (  (^(-)? | [+-]? )cte (*)? var (^expo)?  | cte )+
     *       Where 'var' is one variable with any valid name
     *             'cte' are real numeric constants with any value. It can be omitted if equal than 1
     *             'expo' are integers greater than 0. It can be omitted if equal than 1.
     *
     * @param  {array}   coefficients             Optional returns coefficients sorted by increased exponent 
     *
     *
     * @return {node}        new node tree with one variable polynomial or string error. 
     */
    function polyToCanonical(node,coefficients) {
      var i;

      if (coefficients===undefined)
         coefficients = []; // coefficients.

      coefficients[0] = 0;   // index is the exponent
      var o = {};
      o.cte=1; 
      o.oper='+'; 

       // fire: mark with * or ^ when finds * or ^ down tree, reset to "" with + and -. 
       //       It is used to deduce the exponent: 1 for *, 0 for "". 
      o.fire='';  

      var maxExpo=0;   // maximum exponent
      var varname='';  // var name 

      recurPol(node,null,o);    
      maxExpo = coefficients.length-1;
      var first=true;

      for (i=maxExpo;i>=0 ;i--)  {
        if (coefficients[i]===0)  continue;
        var n1  = new ConstantNode$$1(
                        first ? coefficients[i] : Math.abs(coefficients[i]));
        var op = coefficients[i]<0  ? '-' : '+';

        if (i>0)   {  // Is not a constant without variable 
          var n2 = new SymbolNode$$1(varname);    
          if (i>1)  {
            var n3 =  new ConstantNode$$1(i);     
            n2 = new OperatorNode$$1('^', 'pow', [n2, n3]); 
          }
          if (coefficients[i]===-1  && first) 
            n1 = new OperatorNode$$1('-', 'unaryMinus', [n2]);          
          else if (Math.abs(coefficients[i])===1)  
            n1 = n2;
          else
            n1 = new OperatorNode$$1('*', 'multiply', [n1, n2]); 
        }

        var no;
        if (first)   
          no = n1;
        else if (op==='+')
          no = new OperatorNode$$1('+', 'add', [no, n1]);
        else
          no = new OperatorNode$$1('-', 'subtract', [no, n1]);

        first = false;
      }  // for 

      if (first) 
        return new ConstantNode$$1(0);
      else
        return no;

      /**
       * Recursive auxilary function inside polyToCanonical for
       * converting expression in canonical form
       *
       * Syntax:
       *
       *     recurPol(node, noPai, obj)
       *
       * @param  {Node} node        The current subpolynomial expression 
       * @param  {Node | Null}  noPai   The current parent node
       * @param  {object}    obj        Object with many internal flags
       *
       * @return {}                    No return. If error, throws an exception
       */
      function recurPol(node,noPai,o) {

        var tp = node.type; 
        if (tp==='FunctionNode')            // ***** FunctionName *****
                  // No function call in polynomial expression
          throw new ArgumentsError('There is an unsolved function call')

        else if (tp==='OperatorNode')  {    // ***** OperatorName *****
          if ('+-*^'.indexOf(node.op) === -1) throw new ArgumentsError('Operator ' + node.op + ' invalid');

          if (noPai!==null)  {
              // -(unary),^  : children of *,+,-
            if ( (node.fn==='unaryMinus' || node.fn==='pow') && noPai.fn !=='add' &&  
                                  noPai.fn!=='subtract'  &&  noPai.fn!=='multiply' )
              throw new ArgumentsError('Invalid ' + node.op +  ' placing')

              // -,+,* : children of +,- 
            if ((node.fn==='subtract' || node.fn==='add' || node.fn==='multiply')  && 
                noPai.fn!=='add' &&  noPai.fn!=='subtract' )
              throw new ArgumentsError('Invalid ' + node.op +  ' placing'); 
          
             // -,+ : first child
          if ((node.fn==='subtract' || node.fn==='add' ||                
              node.fn==='unaryMinus' )  && o.noFil!==0 )                  
              throw new ArgumentsError('Invalid ' + node.op +  ' placing')
           } // Has parent    

          // Firers: ^,*       Old:   ^,&,-(unary): firers
          if (node.op==='^' || node.op==='*') o.fire = node.op;

          for (var i=0;i<node.args.length;i++)  {
             // +,-: reset fire
            if (node.fn==='unaryMinus') o.oper='-';
            if (node.op==='+' || node.fn==='subtract' ) {    
              o.fire = '';  
              o.cte = 1;   // default if there is no constant
              o.oper = (i===0 ? '+' : node.op);
            }
            o.noFil = i;  // number of son
            recurPol(node.args[i],node,o);
          } // for in children

        } else if (tp==='SymbolNode') {      // ***** SymbolName *****
          if (node.name !== varname && varname!=='')
            throw new ArgumentsError('There is more than one variable')
          varname = node.name;   
          if (noPai === null)  {
              coefficients[1] = 1; 
              return;
          }   

            // ^: Symbol is First child
          if (noPai.op==='^' && o.noFil!==0 ) 
             throw new ArgumentsError('In power the variable should be the first parameter')

            // *: Symbol is Second child 
          if (noPai.op==='*' && o.noFil!==1 ) 
             throw new ArgumentsError('In multiply the variable should be the second parameter')

            // Symbol: firers '',* => it means there is no exponent above, so it's 1 (cte * var) 
          if (o.fire==='' || o.fire==='*' )   {
            if (maxExpo<1) coefficients[1]=0;
            coefficients[1] += o.cte* (o.oper==='+'  ? 1 : -1);
            maxExpo = Math.max(1,maxExpo);
          }

        } else if (tp==='ConstantNode') {
          var valor =  parseFloat(node.value);
          if (noPai === null)  {
            coefficients[0] = valor;
            return;
          }   
          if (noPai.op==='^')  {
             // cte: second  child of power
            if (o.noFil!==1) throw new ArgumentsError('Constant cannot be powered')

            if (! number$$1.isInteger(valor) || valor<=0 )
              throw new ArgumentsError('Non-integer exponent is not allowed');

            for (var i=maxExpo+1;i<valor;i++) coefficients[i]=0;
            if (valor>maxExpo) coefficients[valor]=0;
            coefficients[valor] += o.cte * (o.oper==='+' ? 1 : -1); 
            maxExpo = Math.max(valor,maxExpo);
            return;
          }
          o.cte = valor;

          // Cte: firer '' => There is no exponent and no multiplication, so the exponent is 0. 
          if (o.fire==='')  
            coefficients[0] += o.cte * (o.oper==='+'? 1 : -1);


        } else 
           throw new ArgumentsError('Type ' + tp + ' is not allowed');
        return;
      } // End of recurPol
   
    } // End of polyToCanonical

    return rationalize;
  } // end of factory

  var name$98 = 'rationalize';
  var factory_1$108 = factory$109;

  var rationalize$1 = {
  	name: name$98,
  	factory: factory_1$108
  };

  var isInteger$7 = number.isInteger;
  var resize$1 = array.resize;

  function factory$110 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Create a matrix filled with zeros. The created matrix can have one or
     * multiple dimensions.
     *
     * Syntax:
     *
     *    math.zeros(m)
     *    math.zeros(m, format)
     *    math.zeros(m, n)
     *    math.zeros(m, n, format)
     *    math.zeros([m, n])
     *    math.zeros([m, n], format)
     *
     * Examples:
     *
     *    math.zeros(3);                  // returns [0, 0, 0]
     *    math.zeros(3, 2);               // returns [[0, 0], [0, 0], [0, 0]]
     *    math.zeros(3, 'dense');         // returns [0, 0, 0]
     *
     *    var A = [[1, 2, 3], [4, 5, 6]];
     *    math.zeros(math.size(A));       // returns [[0, 0, 0], [0, 0, 0]]
     *
     * See also:
     *
     *    ones, eye, size, range
     *
     * @param {...number | Array} size    The size of each dimension of the matrix
     * @param {string} [format]           The Matrix storage format
     *
     * @return {Array | Matrix}           A matrix filled with zeros
     */
    var zeros = typed('zeros', {
      '': function () {
        return (config.matrix === 'Array')
            ? _zeros([])
            : _zeros([], 'default');
      },

      // math.zeros(m, n, p, ..., format)
      // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
      '...number | BigNumber | string': function (size) {
        var last = size[size.length - 1];
        if (typeof last === 'string') {
          var format = size.pop();
          return _zeros(size, format);
        }
        else if (config.matrix === 'Array') {
          return _zeros(size);
        }
        else {
          return _zeros(size, 'default');
        }
      },

      'Array': _zeros,

      'Matrix': function (size) {
        var format = size.storage();
        return _zeros(size.valueOf(), format);
      },

      'Array | Matrix, string': function (size, format) {
        return _zeros (size.valueOf(), format);
      }
    });

    zeros.toTex = undefined; // use default template

    return zeros;

    /**
     * Create an Array or Matrix with zeros
     * @param {Array} size
     * @param {string} [format='default']
     * @return {Array | Matrix}
     * @private
     */
    function _zeros(size, format) {
      var hasBigNumbers = _normalize(size);
      var defaultValue = hasBigNumbers ? new type.BigNumber(0) : 0;
      _validate(size);

      if (format) {
        // return a matrix
        var m = matrix$$1(format);
        if (size.length > 0) {
          return m.resize(size, defaultValue);
        }
        return m;
      }
      else {
        // return an Array
        var arr = [];
        if (size.length > 0) {
          return resize$1(arr, size, defaultValue);
        }
        return arr;
      }
    }

    // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
      var hasBigNumbers = false;
      size.forEach(function (value, index, arr) {
        if (type.isBigNumber(value)) {
          hasBigNumbers = true;
          arr[index] = value.toNumber();
        }
      });
      return hasBigNumbers;
    }

    // validate arguments
    function _validate (size) {
      size.forEach(function (value) {
        if (typeof value !== 'number' || !isInteger$7(value) || value < 0) {
          throw new Error('Parameters in function zeros must be positive integers');
        }
      });
    }
  }

  // TODO: zeros contains almost the same code as ones. Reuse this?

  var name$99 = 'zeros';
  var factory_1$109 = factory$110;

  var zeros$1 = {
  	name: name$99,
  	factory: factory_1$109
  };

  function factory$111 (type, config, load, typed) {
    /**
     * Clone an object.
     *
     * Syntax:
     *
     *     math.clone(x)
     *
     * Examples:
     *
     *    math.clone(3.5);                   // returns number 3.5
     *    math.clone(math.complex('2-4i'); // returns Complex 2 - 4i
     *    math.clone(math.unit(45, 'deg'));  // returns Unit 45 deg
     *    math.clone([[1, 2], [3, 4]]);      // returns Array [[1, 2], [3, 4]]
     *    math.clone("hello world");         // returns string "hello world"
     *
     * @param {*} x   Object to be cloned
     * @return {*} A clone of object x
     */
    var clone = typed('clone', {
      'any': object.clone
    });

    clone.toTex = undefined; // use default template

    return clone;
  }

  var name$100 = 'clone';
  var factory_1$110 = factory$111;

  var clone$5 = {
  	name: name$100,
  	factory: factory_1$110
  };

  function factory$112 (type, config, load, typed) {
    /**
     * Test whether a value is positive: larger than zero.
     * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isPositive(x)
     *
     * Examples:
     *
     *    math.isPositive(3);                     // returns true
     *    math.isPositive(-2);                    // returns false
     *    math.isPositive(0);                     // returns false
     *    math.isPositive(-0);                    // returns false
     *    math.isPositive(0.5);                   // returns true
     *    math.isPositive(math.bignumber(2));     // returns true
     *    math.isPositive(math.fraction(-2, 5));  // returns false
     *    math.isPositive(math.fraction(1,3));    // returns false
     *    math.isPositive('2');                   // returns true
     *    math.isPositive([2, 0, -3]');           // returns [true, false, false]
     *
     * See also:
     *
     *    isNumeric, isZero, isNegative, isInteger
     *
     * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
     * @return {boolean}  Returns true when `x` is larger than zero.
     *                    Throws an error in case of an unknown data type.
     */
    var isPositive = typed('isPositive', {
      'number': function (x) {
        return x > 0;
      },

      'BigNumber': function (x) {
        return !x.isNeg() && !x.isZero() && !x.isNaN();
      },

      'Fraction': function (x) {
        return x.s > 0 && x.n > 0;
      },

      'Unit': function (x) {
        return isPositive(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, isPositive);
      }
    });

    return isPositive;
  }

  var name$101 = 'isPositive';
  var factory_1$111 = factory$112;

  var isPositive$1 = {
  	name: name$101,
  	factory: factory_1$111
  };

  var nearlyEqual$4 = number.nearlyEqual;


  function factory$113 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    var latex$$1 = latex;

    /**
     * Test whether two values are unequal.
     *
     * The function tests whether the relative difference between x and y is
     * larger than the configured epsilon. The function cannot be used to compare
     * values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * In case of complex numbers, x.re must unequal y.re, or x.im must unequal y.im.
     * Strings are compared by their numerical value.
     *
     * Values `null` and `undefined` are compared strictly, thus `null` is unequal
     * with everything except `null`, and `undefined` is unequal with everything
     * except `undefined`.
     *
     * Syntax:
     *
     *    math.unequal(x, y)
     *
     * Examples:
     *
     *    math.unequal(2 + 2, 3);       // returns true
     *    math.unequal(2 + 2, 4);       // returns false
     *
     *    var a = math.unit('50 cm');
     *    var b = math.unit('5 m');
     *    math.unequal(a, b);           // returns false
     *
     *    var c = [2, 5, 1];
     *    var d = [2, 7, 1];
     *
     *    math.unequal(c, d);           // returns [false, true, false]
     *    math.deepEqual(c, d);         // returns false
     *
     *    math.unequal(0, null);        // returns true
     * See also:
     *
     *    equal, deepEqual, smaller, smallerEq, larger, largerEq, compare
     *
     * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} x First value to compare
     * @param  {number | BigNumber | Fraction | boolean | Complex | Unit | string | Array | Matrix | undefined} y Second value to compare
     * @return {boolean | Array | Matrix} Returns true when the compared values are unequal, else returns false
     */
    var unequal = typed('unequal', {
      
      'any, any': function (x, y) {
        // strict equality for null and undefined?
        if (x === null) { return y !== null; }
        if (y === null) { return x !== null; }
        if (x === undefined) { return y !== undefined; }
        if (y === undefined) { return x !== undefined; }

        return _unequal(x, y);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, _unequal);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, _unequal, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, _unequal, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, _unequal);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return unequal(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return unequal(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return unequal(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, _unequal, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, _unequal, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, _unequal, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, _unequal, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, _unequal, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, _unequal, true).valueOf();
      }
    });

    var _unequal = typed('_unequal', {

      'boolean, boolean': function (x, y) {
        return x !== y;
      },

      'number, number': function (x, y) {
        return !nearlyEqual$4(x, y, config.epsilon);
      },

      'BigNumber, BigNumber': function (x, y) {
        return !nearlyEqual(x, y, config.epsilon);
      },

      'Fraction, Fraction': function (x, y) {
        return !x.equals(y);
      },

      'Complex, Complex': function (x, y) {
        return !x.equals(y);
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return unequal(x.value, y.value);
      }
    });

    unequal.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['unequal'] + '${args[1]}\\right)'
    };

    return unequal;
  }

  var name$102 = 'unequal';
  var factory_1$112 = factory$113;

  var unequal$1 = {
  	name: name$102,
  	factory: factory_1$112
  };

  function factory$114 (type, config, load, typed) {
    /**
     * Compute the sign of a value. The sign of a value x is:
     *
     * -  1 when x > 1
     * - -1 when x < 0
     * -  0 when x == 0
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.sign(x)
     *
     * Examples:
     *
     *    math.sign(3.5);               // returns 1
     *    math.sign(-4.2);              // returns -1
     *    math.sign(0);                 // returns 0
     *
     *    math.sign([3, 5, -2, 0, 2]);  // returns [1, 1, -1, 0, 1]
     *
     * See also:
     *
     *    abs
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
     *            The number for which to determine the sign
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}e
     *            The sign of `x`
     */
    var sign = typed('sign', {
      'number': number.sign,

      'Complex': function (x) {
        return x.sign();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(x.cmp(0));
      },

      'Fraction': function (x) {
        return new type.Fraction(x.s, 1);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since sign(0) = 0
        return deepMap(x, sign, true);
      },

      'Unit': function(x) {
        return sign(x.value);
      }
    });

    sign.toTex = {1: '\\mathrm{${name}}\\left(${args[0]}\\right)'};

    return sign;
  }

  var name$103 = 'sign';
  var factory_1$113 = factory$114;

  var sign$1 = {
  	name: name$103,
  	factory: factory_1$113
  };

  function factory$115 (type, config, load, typed) {
    /**
     * Calculate the square root of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.sqrt(x)
     *
     * Examples:
     *
     *    math.sqrt(25);                // returns 5
     *    math.square(5);               // returns 25
     *    math.sqrt(-4);                // returns Complex 2i
     *
     * See also:
     *
     *    square, multiply, cube, cbrt, sqrtm
     *
     * @param {number | BigNumber | Complex | Array | Matrix | Unit} x
     *            Value for which to calculate the square root.
     * @return {number | BigNumber | Complex | Array | Matrix | Unit}
     *            Returns the square root of `x`
     */
    var sqrt = typed('sqrt', {
      'number': _sqrtNumber,

      'Complex': function (x) {
          return x.sqrt();
      },

      'BigNumber': function (x) {
        if (!x.isNegative() || config.predictable) {
          return x.sqrt();
        }
        else {
          // negative value -> downgrade to number to do complex value computation
          return _sqrtNumber(x.toNumber());
        }
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since sqrt(0) = 0
        return deepMap(x, sqrt, true);
      },

      'Unit': function (x) {
        // Someday will work for complex units when they are implemented
        return x.pow(0.5);
      }

    });

    /**
     * Calculate sqrt for a number
     * @param {number} x
     * @returns {number | Complex} Returns the square root of x
     * @private
     */
    function _sqrtNumber(x) {
      if (x >= 0 || config.predictable) {
        return Math.sqrt(x);
      }
      else {
        return new type.Complex(x, 0).sqrt();
      }
    }

    sqrt.toTex = {1: '\\sqrt{${args[0]}}'};

    return sqrt;
  }

  var name$104 = 'sqrt';
  var factory_1$114 = factory$115;

  var sqrt$1 = {
  	name: name$104,
  	factory: factory_1$114
  };

  function factory$116 (type, config, load, typed) {
    /**
     * Compute the complex conjugate of a complex value.
     * If `x = a+bi`, the complex conjugate of `x` is `a - bi`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.conj(x)
     *
     * Examples:
     *
     *    math.conj(math.complex('2 + 3i'));  // returns Complex 2 - 3i
     *    math.conj(math.complex('2 - 3i'));  // returns Complex 2 + 3i
     *    math.conj(math.complex('-5.2i'));  // returns Complex 5.2i
     *
     * See also:
     *
     *    re, im, arg, abs
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            A complex number or array with complex numbers
     * @return {number | BigNumber | Complex | Array | Matrix}
     *            The complex conjugate of x
     */
    var conj = typed('conj', {
      'number': function (x) {
        return x;
      },

      'BigNumber': function (x) {
        return x;
      },

      'Complex': function (x) {
        return x.conjugate();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, conj);
      }
    });

    conj.toTex = {1: '\\left(${args[0]}\\right)^*'};

    return conj;
  }

  var name$105 = 'conj';
  var factory_1$115 = factory$116;

  var conj$1 = {
  	name: name$105,
  	factory: factory_1$115
  };

  function factory$117 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var zeros = load(zeros$1);
    var eye = load(eye$1);
    var clone = load(clone$5);
    
    var isZero = load(isZero$1);
    var isPositive = load(isPositive$1);
    var unequal = load(unequal$1);
      
    var abs = load(abs$1);
    var sign = load(sign$1);
    var sqrt = load(sqrt$1);
    var conj = load(conj$1);
    
    var unaryMinus = load(unaryMinus$1); 
    var addScalar$$1 = load(addScalar);  
    var divideScalar$$1 = load(divideScalar);
    var multiplyScalar$$1 = load(multiplyScalar);  
    var subtract = load(subtract$1);
      
    
    /**
     * Calculate the Matrix QR decomposition. Matrix `A` is decomposed in 
     * two matrices (`Q`, `R`) where `Q` is an 
     * orthogonal matrix and `R` is an upper triangular matrix.
     *
     * Syntax:
     *
     *    math.qr(A);
     *
     * Example:
     *
     *    var m = [
     *      [1, -1,  4],
     *      [1,  4, -2],
     *      [1,  4,  2],
     *      [1,  -1, 0]
     *    ];
     *    var result = math.qr(m);
     *    // r = {
     *    //   Q: [
     *    //     [0.5, -0.5,   0.5],
     *    //     [0.5,  0.5,  -0.5],
     *    //     [0.5,  0.5,   0.5],
     *    //     [0.5, -0.5,  -0.5],
     *    //   ],
     *    //   R: [
     *    //     [2, 3,  2],
     *    //     [0, 5, -2],
     *    //     [0, 0,  4],
     *    //     [0, 0,  0]
     *    //   ]
     *    // }
     *
     * See also:
     *
     *    lu
     *
     * @param {Matrix | Array} A    A two dimensional matrix or array 
     * for which to get the QR decomposition.
     *
     * @return {{Q: Array | Matrix, R: Array | Matrix}} Q: the orthogonal
     * matrix and R: the upper triangular matrix
     */
    var qr = typed('qr', {

      'DenseMatrix': function (m) {
        return _denseQR(m);
      },
      
      'SparseMatrix': function (m) {
        return _sparseQR(m);
      },

      'Array': function (a) {
        // create dense matrix from array
        var m = matrix$$1(a);
        // lup, use matrix implementation
        var r = _denseQR(m);
        // result
        return {
          Q: r.Q.valueOf(),
          R: r.R.valueOf()
        };
      }
    });

    var _denseQR = function (m) {
      
      // rows & columns (m x n)
      var rows = m._size[0]; // m
      var cols = m._size[1]; // n
              
      var Q = eye([rows], 'dense');
      var Qdata = Q._data;
      
      var R = m.clone();
      var Rdata = R._data;
      
      // vars
      var i, j, k;
          
      var w = zeros([rows], '');
      
      for (k = 0; k < Math.min(cols, rows); ++k) {
        
        /*
         * **k-th Household matrix**
         *
         * The matrix I - 2*v*transpose(v)
         * x     = first column of A
         * x1    = first element of x
         * alpha = x1 / |x1| * |x|
         * e1    = tranpose([1, 0, 0, ...])
         * u     = x - alpha * e1
         * v     = u / |u|
         *
         * Household matrix = I - 2 * v * tranpose(v)
         *
         *  * Initially Q = I and R = A.
         *  * Household matrix is a reflection in a plane normal to v which 
         *    will zero out all but the top right element in R.
         *  * Appplying reflection to both Q and R will not change product.
         *  * Repeat this process on the (1,1) minor to get R as an upper 
         *    triangular matrix.
         *  * Reflections leave the magnitude of the columns of Q unchanged 
         *    so Q remains othoganal.
         *
         */  
        
        var pivot = Rdata[k][k];          
        var sgn = unaryMinus(sign(pivot));
        var conjSgn = conj(sgn);
        
        var alphaSquared = 0;

        for(i = k; i < rows; i++) {
          alphaSquared = addScalar$$1(alphaSquared, multiplyScalar$$1(Rdata[i][k], conj(Rdata[i][k])));        
        }
        
        var alpha = multiplyScalar$$1(sgn, sqrt(alphaSquared));
        
        
        if (!isZero(alpha)) {
            
          // first element in vector u
          var u1 = subtract(pivot, alpha);
          
          // w = v * u1 / |u|    (only elements k to (rows-1) are used)    
          w[k] = 1;
          
          for (i = k+1; i < rows; i++) {
            w[i] = divideScalar$$1(Rdata[i][k], u1);
          }        
           
          // tau = - conj(u1 / alpha)
          var tau = unaryMinus(conj(divideScalar$$1(u1, alpha)));
          
          var s;
          
          /*
           * tau and w have been choosen so that
           * 
           * 2 * v * tranpose(v) = tau * w * tranpose(w)
           */
           
          /*
           * -- calculate R = R - tau * w * tranpose(w) * R --
           * Only do calculation with rows k to (rows-1)
           * Additionally columns 0 to (k-1) will not be changed by this
           *   multiplication so do not bother recalculating them
           */
          for (j = k; j < cols; j++) {
            s = 0.0;
            
            // calculate jth element of [tranpose(w) * R]
            for (i = k; i < rows; i++) {
              s = addScalar$$1(s, multiplyScalar$$1(conj(w[i]), Rdata[i][j]));
            }
            
            // calculate the jth element of [tau * transpose(w) * R]
            s = multiplyScalar$$1(s, tau);
            
            for (i = k; i < rows; i++) {
              Rdata[i][j] = multiplyScalar$$1(
                subtract(Rdata[i][j], multiplyScalar$$1(w[i], s)), 
                conjSgn
              );            
            }          
          }
          /*
           * -- calculate Q = Q - tau * Q * w * transpose(w) --
           * Q is a square matrix (rows x rows)
           * Only do calculation with columns k to (rows-1)
           * Additionally rows 0 to (k-1) will not be changed by this
           *   multiplication so do not bother recalculating them
           */
          for (i = 0; i < rows; i++) {
            s = 0.0;
            
            // calculate ith element of [Q * w]
            for (j = k; j < rows; j++) {
              s = addScalar$$1(s, multiplyScalar$$1(Qdata[i][j], w[j]));
            }
            
            // calculate the ith element of [tau * Q * w]
            s = multiplyScalar$$1(s, tau);
            
            for (j = k; j < rows; ++j) {
              Qdata[i][j] = divideScalar$$1(
                subtract(Qdata[i][j], multiplyScalar$$1(s, conj(w[j]))), 
                conjSgn
              );
            }
            
          }
        }
        
      }
      
      // coerse almost zero elements to zero
      // TODO I feel uneasy just zeroing these values
      for (i = 0; i < rows; ++i) {
        for (j = 0; j < i && j < cols; ++j) {
          if (unequal(0, divideScalar$$1(Rdata[i][j], 1e5))) {
            throw new Error('math.qr(): unknown error - ' + 
             'R is not lower triangular (element (' + 
              i + ', ' + j + ')  = ' + Rdata[i][j] + ')'
            );
          }
          Rdata[i][j] = multiplyScalar$$1(Rdata[i][j], 0);
        }
      }
      
      // return matrices
      return { 
        Q: Q,
        R: R,
        toString: function () {
          return 'Q: ' + this.Q.toString() + '\nR: ' + this.R.toString();
        }
      };
    };
    
    var _sparseQR = function (m) {
      
      throw new Error('qr not implemented for sparse matrices yet');
    
    };
    
    return qr;
  }

  var name$106 = 'qr';
  var factory_1$116 = factory$117;

  var qr$1 = {
  	name: name$106,
  	factory: factory_1$116
  };

  function factory$118 () {

    /**
     * This function "flips" its input about the integer -1.
     *
     * @param {Number}  i               The value to flip
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_flip = function (i) {
      // flip the value
      return -i - 2;
    };

    return cs_flip;
  }

  var name$107 = 'cs_flip';
  var path$46 = 'sparse';
  var factory_1$117 = factory$118;

  var cs_flip = {
  	name: name$107,
  	path: path$46,
  	factory: factory_1$117
  };

  function factory$119 () {

    /**
     * Keeps entries in the matrix when the callback function returns true, removes the entry otherwise
     *
     * @param {Matrix}   a              The sparse matrix
     * @param {function} callback       The callback function, function will be invoked with the following args:
     *                                    - The entry row
     *                                    - The entry column
     *                                    - The entry value
     *                                    - The state parameter
     * @param {any}      other          The state
     *
     * @return                          The number of nonzero elements in the matrix
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_fkeep = function (a, callback, other) {
      // a arrays
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      // columns
      var n = asize[1];
      // nonzero items
      var nz = 0;
      // loop columns
      for (var j = 0; j < n; j++) {
        // get current location of col j
        var p = aptr[j];
        // record new location of col j
        aptr[j] = nz;
        for (; p < aptr[j+1]; p++) {
          // check we need to keep this item
          if (callback(aindex[p], j, avalues ? avalues[p] : 1, other)) {
            // keep A(i,j)
            aindex[nz] = aindex[p];
            // check we need to process values (pattern only)
            if (avalues) 
              avalues[nz] = avalues[p];
            // increment nonzero items
            nz++;
          }
        }
      }
      // finalize A
      aptr[n] = nz;
      // trim arrays
      aindex.splice(nz, aindex.length - nz);
      // check we need to process values (pattern only)
      if (avalues)
        avalues.splice(nz, avalues.length - nz);    
      // return number of nonzero items
      return (nz);
    };
    
    return cs_fkeep;
  }

  var name$108 = 'cs_fkeep';
  var path$47 = 'sparse';
  var factory_1$118 = factory$119;

  var cs_fkeep = {
  	name: name$108,
  	path: path$47,
  	factory: factory_1$118
  };

  function factory$120 () {

    /**
     * Depth-first search and postorder of a tree rooted at node j
     *
     * @param {Number}  j               The tree node
     * @param {Number}  k               
     * @param {Array}   w               The workspace array
     * @param {Number}  head            The index offset within the workspace for the head array
     * @param {Number}  next            The index offset within the workspace for the next array
     * @param {Array}   post            The post ordering array
     * @param {Number}  stack           The index offset within the workspace for the stack array
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_tdfs = function (j, k, w, head, next, post, stack) {
      // variables
      var top = 0;
      // place j on the stack
      w[stack] = j;
      // while (stack is not empty) 
      while (top >= 0) {
        // p = top of stack
        var p = w[stack + top];
        // i = youngest child of p
        var i = w[head + p];
        if (i == -1) {
          // p has no unordered children left
          top--;
          // node p is the kth postordered node
          post[k++] = p;
        }
        else {
          // remove i from children of p
          w[head + p] = w[next + i];
          // increment top
          ++top;
          // start dfs on child node i
          w[stack + top] = i;
        }
      }
      return k;
    };

    return cs_tdfs;
  }

  var name$109 = 'cs_tdfs';
  var path$48 = 'sparse';
  var factory_1$119 = factory$120;

  var cs_tdfs = {
  	name: name$109,
  	path: path$48,
  	factory: factory_1$119
  };

  var clone$6 = object.clone;
  var format$4 = string.format;

  function factory$121 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var DenseMatrix = type.DenseMatrix,
        SparseMatrix = type.SparseMatrix;

    /**
     * Transpose a matrix. All values of the matrix are reflected over its
     * main diagonal. Only applicable to two dimensional matrices containing
     * a vector (i.e. having size `[1,n]` or `[n,1]`). One dimensional
     * vectors and scalars return the input unchanged.
     *
     * Syntax:
     *
     *     math.transpose(x)
     *
     * Examples:
     *
     *     var A = [[1, 2, 3], [4, 5, 6]];
     *     math.transpose(A);               // returns [[1, 4], [2, 5], [3, 6]]
     *
     * See also:
     *
     *     diag, inv, subset, squeeze
     *
     * @param {Array | Matrix} x  Matrix to be transposed
     * @return {Array | Matrix}   The transposed matrix
     */
    var transpose = typed('transpose', {

      'Array': function (x) {
        // use dense matrix implementation
        return transpose(matrix$$1(x)).valueOf();
      },

      'Matrix': function (x) {
        // matrix size
        var size = x.size();

        // result
        var c;
        
        // process dimensions
        switch (size.length) {
          case 1:
            // vector
            c = x.clone();
            break;

          case 2:
            // rows and columns
            var rows = size[0];
            var columns = size[1];

            // check columns
            if (columns === 0) {
              // throw exception
              throw new RangeError('Cannot transpose a 2D matrix with no columns (size: ' + format$4(size) + ')');
            }

            // process storage format
            switch (x.storage()) {
              case 'dense':
                c = _denseTranspose(x, rows, columns);
                break;
              case 'sparse':
                c = _sparseTranspose(x, rows, columns);
                break;
            }
            break;
            
          default:
            // multi dimensional
            throw new RangeError('Matrix must be a vector or two dimensional (size: ' + format$4(this._size) + ')');
        }
        return c;
      },

      // scalars
      'any': function (x) {
        return clone$6(x);
      }
    });

    var _denseTranspose = function (m, rows, columns) {
      // matrix array
      var data = m._data;
      // transposed matrix data
      var transposed = [];
      var transposedRow;
      // loop columns
      for (var j = 0; j < columns; j++) {
        // initialize row
        transposedRow = transposed[j] = [];
        // loop rows
        for (var i = 0; i < rows; i++) {
          // set data
          transposedRow[i] = clone$6(data[i][j]);
        }
      }
      // return matrix
      return new DenseMatrix({
        data: transposed,
        size: [columns, rows],
        datatype: m._datatype
      });
    };

    var _sparseTranspose = function (m, rows, columns) {
      // matrix arrays
      var values = m._values;
      var index = m._index;
      var ptr = m._ptr;
      // result matrices
      var cvalues = values ? [] : undefined;
      var cindex = [];
      var cptr = [];
      // row counts
      var w = [];
      for (var x = 0; x < rows; x++)
        w[x] = 0;
      // vars
      var p, l, j;
      // loop values in matrix
      for (p = 0, l = index.length; p < l; p++) {
        // number of values in row
        w[index[p]]++;
      }
      // cumulative sum
      var sum = 0;
      // initialize cptr with the cummulative sum of row counts
      for (var i = 0; i < rows; i++) {
        // update cptr
        cptr.push(sum);
        // update sum
        sum += w[i];
        // update w
        w[i] = cptr[i];
      }
      // update cptr
      cptr.push(sum);
      // loop columns
      for (j = 0; j < columns; j++) {
        // values & index in column
        for (var k0 = ptr[j], k1 = ptr[j + 1], k = k0; k < k1; k++) {
          // C values & index
          var q = w[index[k]]++;
          // C[j, i] = A[i, j]
          cindex[q] = j;
          // check we need to process values (pattern matrix)
          if (values)
            cvalues[q] = clone$6(values[k]);
        }
      }
      // return matrix
      return new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [columns, rows],
        datatype: m._datatype
      });
    };

    transpose.toTex = {1: '\\left(${args[0]}\\right)' + latex$$1.operators['transpose']};

    return transpose;
  }

  var name$110 = 'transpose';
  var factory_1$120 = factory$121;

  var transpose$1 = {
  	name: name$110,
  	factory: factory_1$120
  };

  function factory$122 (type, config, load) {

    var cs_flip$$1 = load(cs_flip);
    var cs_fkeep$$1 = load(cs_fkeep);
    var cs_tdfs$$1 = load(cs_tdfs);
    
    var add$$1       = load(add);
    var multiply  = load(multiply$1);
    var transpose = load(transpose$1);

    /**
     * Approximate minimum degree ordering. The minimum degree algorithm is a widely used 
     * heuristic for finding a permutation P so that P*A*P' has fewer nonzeros in its factorization
     * than A. It is a gready method that selects the sparsest pivot row and column during the course
     * of a right looking sparse Cholesky factorization.
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     *
     * @param {Number} order    0: Natural, 1: Cholesky, 2: LU, 3: QR
     * @param {Matrix} m        Sparse Matrix
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_amd = function (order, a) {
      // check input parameters
      if (!a || order <= 0 || order > 3)
        return null;
      // a matrix arrays
      var asize = a._size;
      // rows and columns
      var m = asize[0];
      var n = asize[1];    
      // initialize vars
      var lemax = 0;
      // dense threshold
      var dense = Math.max(16, 10 * Math.sqrt(n));
      dense = Math.min(n - 2, dense);
      // create target matrix C
      var cm = _createTargetMatrix(order, a, m, n, dense);
      // drop diagonal entries
      cs_fkeep$$1(cm, _diag, null);
      // C matrix arrays
      var cindex = cm._index;
      var cptr = cm._ptr;

      // number of nonzero elements in C
      var cnz = cptr[n];
      
      // allocate result (n+1)
      var P = [];
      
      // create workspace (8 * (n + 1))
      var W = [];
      var len = 0; // first n + 1 entries
      var nv = n + 1; // next n + 1 entries
      var next = 2 * (n + 1); // next n + 1 entries
      var head = 3 * (n + 1);  // next n + 1 entries
      var elen = 4 * (n + 1);  // next n + 1 entries
      var degree = 5 * (n + 1);  // next n + 1 entries
      var w = 6 * (n + 1);  // next n + 1 entries
      var hhead = 7 * (n + 1);  // last n + 1 entries    

      // use P as workspace for last
      var last = P;
      
      // initialize quotient graph
      var mark = _initializeQuotientGraph(n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree);
      
      // initialize degree lists
      var nel = _initializeDegreeLists(n, cptr, W, degree, elen, w, dense, nv, head, last, next);
      
      // minimum degree node
      var mindeg = 0;
      
      // vars
      var i, j, k, k1, k2, e, pj, ln, nvi, pk, eln, p1, p2, pn, h, d;
      
      // while (selecting pivots) do
      while (nel < n) {
        // select node of minimum approximate degree. amd() is now ready to start eliminating the graph. It first
        // finds a node k of minimum degree and removes it from its degree list. The variable nel keeps track of thow
        // many nodes have been eliminated.
        for (k = -1; mindeg < n && (k = W[head + mindeg]) == -1; mindeg++);      
        if (W[next + k] != -1) 
          last[W[next + k]] = -1;
        // remove k from degree list
        W[head + mindeg] = W[next + k];
        // elenk = |Ek|
        var elenk = W[elen + k];
        // # of nodes k represents
        var nvk = W[nv + k];
        // W[nv + k] nodes of A eliminated
        nel += nvk;

        // Construct a new element. The new element Lk is constructed in place if |Ek| = 0. nv[i] is 
        // negated for all nodes i in Lk to flag them as members of this set. Each node i is removed from the
        // degree lists. All elements e in Ek are absorved into element k.
        var dk = 0;
        // flag k as in Lk
        W[nv + k] = -nvk;
        var p = cptr[k];
        // do in place if W[elen + k] == 0
        var pk1 = (elenk === 0) ? p : cnz;
        var pk2 = pk1;
        for (k1 = 1; k1 <= elenk + 1; k1++) {
          if (k1 > elenk) {
            // search the nodes in k
            e = k;
            // list of nodes starts at cindex[pj]
            pj = p;
            // length of list of nodes in k
            ln = W[len + k] - elenk;
          }
          else {
            // search the nodes in e
            e = cindex[p++];
            pj = cptr[e];
            // length of list of nodes in e
            ln = W[len + e];
          }
          for (k2 = 1; k2 <= ln; k2++) {
            i = cindex[pj++];
            // check  node i dead, or seen
            if ((nvi = W[nv + i]) <= 0) 
              continue;
            // W[degree + Lk] += size of node i
            dk += nvi;
            // negate W[nv + i] to denote i in Lk
            W[nv + i] = -nvi;
            // place i in Lk
            cindex[pk2++] = i;
            if (W[next + i] != -1) 
              last[W[next + i]] = last[i];
            // check we need to remove i from degree list
            if (last[i] != -1) 
              W[next + last[i]] = W[next + i];
            else
              W[head + W[degree + i]] = W[next + i];
          }
          if (e != k) {
            // absorb e into k
            cptr[e] = cs_flip$$1(k);
            // e is now a dead element
            W[w + e] = 0;
          }
        }
        // cindex[cnz...nzmax] is free
        if (elenk !== 0) 
          cnz = pk2;
        // external degree of k - |Lk\i|
        W[degree + k] = dk;
        // element k is in cindex[pk1..pk2-1]
        cptr[k] = pk1;
        W[len + k] = pk2 - pk1;
        // k is now an element
        W[elen + k] = -2;
              
        // Find set differences. The scan1 function now computes the set differences |Le \ Lk| for all elements e. At the start of the
        // scan, no entry in the w array is greater than or equal to mark.
        
        // clear w if necessary
        mark = _wclear(mark, lemax, W, w, n);
        // scan 1: find |Le\Lk|
        for (pk = pk1; pk < pk2; pk++) {
          i = cindex[pk];
          // check if W[elen + i] empty, skip it
          if ((eln = W[elen + i]) <= 0) 
            continue;
          // W[nv + i] was negated
          nvi = -W[nv + i];
          var wnvi = mark - nvi;
          // scan Ei
          for (p = cptr[i], p1 = cptr[i] + eln - 1; p <= p1; p++) {
            e = cindex[p];
            if (W[w + e] >= mark) {
              // decrement |Le\Lk|
              W[w + e] -= nvi;
            }
            else if (W[w + e] !== 0) {
              // ensure e is a live element, 1st time e seen in scan 1
              W[w + e] = W[degree + e] + wnvi;
            }
          }
        }
        
        // degree update
        // The second pass computes the approximate degree di, prunes the sets Ei and Ai, and computes a hash
        // function h(i) for all nodes in Lk.
        
        // scan2: degree update
        for (pk = pk1; pk < pk2; pk++) {
          // consider node i in Lk
          i = cindex[pk];
          p1 = cptr[i];
          p2 = p1 + W[elen + i] - 1;
          pn = p1;
          // scan Ei
          for (h = 0, d = 0, p = p1; p <= p2; p++) {
            e = cindex[p];
            // check e is an unabsorbed element
            if (W[w + e] !== 0) {
              // dext = |Le\Lk|
              var dext = W[w + e] - mark;
              if (dext > 0) {
                // sum up the set differences
                d += dext;
                // keep e in Ei
                cindex[pn++] = e;
                // compute the hash of node i
                h += e;
              }
              else {
                // aggressive absorb. e->k
                cptr[e] = cs_flip$$1(k);
                // e is a dead element
                W[w + e] = 0;
              }
            }
          }
          // W[elen + i] = |Ei|
          W[elen + i] = pn - p1 + 1;
          var p3 = pn;
          var p4 = p1 + W[len + i];
          // prune edges in Ai
          for (p = p2 + 1; p < p4; p++) {
            j = cindex[p];
            // check node j dead or in Lk
            var nvj = W[nv + j];
            if (nvj <= 0) 
              continue;
            // degree(i) += |j|
            d += nvj;
            // place j in node list of i
            cindex[pn++] = j;
            // compute hash for node i
            h += j;
          }
          // check for mass elimination
          if (d === 0) {
            // absorb i into k
            cptr[i] = cs_flip$$1(k);
            nvi = -W[nv + i];
            // |Lk| -= |i|
            dk -= nvi;
            // |k| += W[nv + i]
            nvk += nvi;
            nel += nvi;
            W[nv + i] = 0;
            // node i is dead
            W[elen + i] = -1;
          }
          else {
            // update degree(i)
            W[degree + i] = Math.min(W[degree + i], d);
            // move first node to end
            cindex[pn] = cindex[p3];
            // move 1st el. to end of Ei
            cindex[p3] = cindex[p1];
            // add k as 1st element in of Ei
            cindex[p1] = k;
            // new len of adj. list of node i
            W[len + i] = pn - p1 + 1;
            // finalize hash of i
            h = (h < 0 ? -h : h) % n;
            // place i in hash bucket
            W[next + i] = W[hhead + h];
            W[hhead + h] = i;
            // save hash of i in last[i]
            last[i] = h;
          }
        }
        // finalize |Lk|
        W[degree + k] = dk;
        lemax = Math.max(lemax, dk);
        // clear w
        mark = _wclear(mark + lemax, lemax, W, w, n);
        
        // Supernode detection. Supernode detection relies on the hash function h(i) computed for each node i.
        // If two nodes have identical adjacency lists, their hash functions wil be identical.
        for (pk = pk1; pk < pk2; pk++) {
          i = cindex[pk];
          // check i is dead, skip it
          if (W[nv + i] >= 0) 
            continue;
          // scan hash bucket of node i
          h = last[i];
          i = W[hhead + h];
          // hash bucket will be empty
          W[hhead + h] = -1;
          for (; i != -1 && W[next + i] != -1; i = W[next + i], mark++) {
            ln = W[len + i];
            eln = W[elen + i];
            for (p = cptr[i] + 1; p <= cptr[i] + ln - 1; p++) 
              W[w + cindex[p]] = mark;
            var jlast = i;
            // compare i with all j
            for (j = W[next + i]; j != -1; ) {
              var ok = W[len + j] === ln && W[elen + j] === eln;
              for (p = cptr[j] + 1; ok && p <= cptr[j] + ln - 1; p++) {
                // compare i and j
                if (W[w + cindex[p]] != mark) 
                  ok = 0;
              }
              // check i and j are identical
              if (ok) {
                // absorb j into i
                cptr[j] = cs_flip$$1(i);
                W[nv + i] += W[nv + j];
                W[nv + j] = 0;
                // node j is dead
                W[elen + j] = -1;
                // delete j from hash bucket
                j = W[next + j];
                W[next + jlast] = j;
              }
              else {
                // j and i are different
                jlast = j;
                j = W[next + j];
              }
            }
          }
        }
        
        // Finalize new element. The elimination of node k is nearly complete. All nodes i in Lk are scanned one last time.
        // Node i is removed from Lk if it is dead. The flagged status of nv[i] is cleared.
        for (p = pk1, pk = pk1; pk < pk2; pk++) {
          i = cindex[pk];
          // check  i is dead, skip it
          if ((nvi = -W[nv + i]) <= 0) 
            continue;
          // restore W[nv + i]
          W[nv + i] = nvi;
          // compute external degree(i)
          d = W[degree + i] + dk - nvi;
          d = Math.min(d, n - nel - nvi);
          if (W[head + d] != -1) 
            last[W[head + d]] = i;
          // put i back in degree list
          W[next + i] = W[head + d];
          last[i] = -1;
          W[head + d] = i;
          // find new minimum degree
          mindeg = Math.min(mindeg, d);
          W[degree + i] = d;
          // place i in Lk
          cindex[p++] = i;
        }
        // # nodes absorbed into k
        W[nv + k] = nvk;
        // length of adj list of element k
        if ((W[len + k] = p - pk1) === 0) {
          // k is a root of the tree
          cptr[k] = -1;
          // k is now a dead element
          W[w + k] = 0;
        }
        if (elenk !== 0) {
          // free unused space in Lk
          cnz = p;
        }
      }
      
      // Postordering. The elimination is complete, but no permutation has been computed. All that is left 
      // of the graph is the assembly tree (ptr) and a set of dead nodes and elements (i is a dead node if
      // nv[i] is zero and a dead element if nv[i] > 0). It is from this information only that the final permutation
      // is computed. The tree is restored by unflipping all of ptr.
      
      // fix assembly tree
      for (i = 0; i < n; i++) 
        cptr[i] = cs_flip$$1(cptr[i]);
      for (j = 0; j <= n; j++) 
        W[head + j] = -1;
      // place unordered nodes in lists
      for (j = n; j >= 0; j--) {
        // skip if j is an element
        if (W[nv + j] > 0)
          continue;
        // place j in list of its parent
        W[next + j] = W[head + cptr[j]];
        W[head + cptr[j]] = j;
      }
      // place elements in lists
      for (e = n; e >= 0; e--) {
        // skip unless e is an element
        if (W[nv + e] <= 0)
          continue;
        if (cptr[e] != -1) {
          // place e in list of its parent
          W[next + e] = W[head + cptr[e]];
          W[head + cptr[e]] = e;
        }
      }
      // postorder the assembly tree
      for (k = 0, i = 0; i <= n; i++) {
        if (cptr[i] == -1) 
          k = cs_tdfs$$1(i, k, W, head, next, P, w);
      }
      // remove last item in array
      P.splice(P.length - 1, 1);
      // return P
      return P;
    };
    
    /**
     * Creates the matrix that will be used by the approximate minimum degree ordering algorithm. The function accepts the matrix M as input and returns a permutation
     * vector P. The amd algorithm operates on a symmetrix matrix, so one of three symmetric matrices is formed.
     *
     * Order: 0
     *   A natural ordering P=null matrix is returned.
     *
     * Order: 1
     *   Matrix must be square. This is appropriate for a Cholesky or LU factorization.
     *   P = M + M'
     *
     * Order: 2
     *   Dense columns from M' are dropped, M recreated from M'. This is appropriatefor LU factorization of unsymmetric matrices.
     *   P = M' * M
     * 
     * Order: 3
     *   This is best used for QR factorization or LU factorization is matrix M has no dense rows. A dense row is a row with more than 10*sqr(columns) entries.
     *   P = M' * M
     */
    var _createTargetMatrix = function (order, a, m, n, dense) {
      // compute A'
      var at = transpose(a);

      // check order = 1, matrix must be square
      if (order === 1 && n === m) {
        // C = A + A'
        return add$$1(a, at);
      }
      
      // check order = 2, drop dense columns from M'
      if (order == 2) {
        // transpose arrays
        var tindex = at._index;
        var tptr = at._ptr;
        // new column index
        var p2 = 0;
        // loop A' columns (rows)
        for (var j = 0; j < m; j++) {
          // column j of AT starts here
          var p = tptr[j];
          // new column j starts here
          tptr[j] = p2;
          // skip dense col j
          if (tptr[j + 1] - p > dense) 
            continue;
          // map rows in column j of A
          for (var p1 = tptr[j + 1]; p < p1; p++) 
            tindex[p2++] = tindex[p];
        }
        // finalize AT
        tptr[m] = p2;
        // recreate A from new transpose matrix
        a = transpose(at);
        // use A' * A
        return multiply(at, a);
      }
      
      // use A' * A, square or rectangular matrix
      return multiply(at, a);
    };

    /**
     * Initialize quotient graph. There are four kind of nodes and elements that must be represented:
     *
     *  - A live node is a node i (or a supernode) that has not been selected as a pivot nad has not been merged into another supernode.
     *  - A dead node i is one that has been removed from the graph, having been absorved into r = flip(ptr[i]).
     *  - A live element e is one that is in the graph, having been formed when node e was selected as the pivot.
     *  - A dead element e is one that has benn absorved into a subsequent element s = flip(ptr[e]).
     */
    var _initializeQuotientGraph = function (n, cptr, W, len, head, last, next, hhead, nv, w, elen, degree) {
      // Initialize quotient graph
      for (var k = 0; k < n; k++) 
        W[len + k] = cptr[k + 1] - cptr[k];
      W[len + n] = 0;
      // initialize workspace
      for (var i = 0; i <= n; i++) {
        // degree list i is empty
        W[head + i] = -1;
        last[i] = -1;
        W[next + i] = -1;
        // hash list i is empty
        W[hhead + i] = -1;
        // node i is just one node
        W[nv + i] = 1;
        // node i is alive
        W[w + i] = 1;
        // Ek of node i is empty
        W[elen + i] = 0;
        // degree of node i
        W[degree + i] = W[len + i];
      }
      // clear w
      var mark = _wclear(0, 0, W, w, n);
      // n is a dead element
      W[elen + n] = -2;
      // n is a root of assembly tree
      cptr[n] = -1;
      // n is a dead element
      W[w + n] = 0;
      // return mark
      return mark;
    };

    /**
     * Initialize degree lists. Each node is placed in its degree lists. Nodes of zero degree are eliminated immediately. Nodes with 
     * degree >= dense are alsol eliminated and merged into a placeholder node n, a dead element. Thes nodes will appera last in the
     * output permutation p.
     */
    var _initializeDegreeLists = function (n, cptr, W, degree, elen, w, dense, nv, head, last, next) {
      // result
      var nel = 0;
      // loop columns
      for (var i = 0; i < n; i++) {
        // degree @ i
        var d = W[degree + i];
        // check node i is empty
        if (d === 0) {
          // element i is dead
          W[elen + i] = -2;
          nel++;
          // i is a root of assembly tree
          cptr[i] = -1;
          W[w + i] = 0;
        }
        else if (d > dense) {
          // absorb i into element n
          W[nv + i] = 0;
          // node i is dead
          W[elen + i] = -1;
          nel++;
          cptr[i] = cs_flip$$1(n);
          W[nv + n]++;
        }
        else {
          var h = W[head + d];
          if (h != -1)
            last[h] = i;
          // put node i in degree list d
          W[next + i] = W[head + d];
          W[head + d] = i;
        }
      }
      return nel;
    };

    var _wclear = function(mark, lemax, W, w, n) {
      if (mark < 2 || (mark + lemax < 0)) {
        for (var k = 0; k < n; k++) {
          if (W[w + k] !== 0)
            W[w + k] = 1;
        }
        mark = 2 ;
      }
      // at this point, W [0..n-1] < mark holds
      return mark;
    };
    
    var _diag = function (i, j) { 
      return i != j;
    };
    
    return cs_amd;
  }

  var name$111 = 'cs_amd';
  var path$49 = 'sparse';
  var factory_1$121 = factory$122;

  var cs_amd = {
  	name: name$111,
  	path: path$49,
  	factory: factory_1$121
  };

  function factory$123 (type) {

    var SparseMatrix = type.SparseMatrix;

    /**
     * Permutes a sparse matrix C = P * A * Q
     *
     * @param {Matrix}  a               The Matrix A
     * @param {Array}   pinv            The row permutation vector
     * @param {Array}   q               The column permutation vector
     * @param {boolean} values          Create a pattern matrix (false), values and pattern otherwise
     *
     * @return {Matrix}                 C = P * A * Q, null on error
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_permute = function (a, pinv, q, values) {
      // a arrays
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      var adt = a._datatype;
      // rows & columns
      var m = asize[0];
      var n = asize[1];
      // c arrays
      var cvalues = values && a._values ? [] : null;
      var cindex = []; // (aptr[n]);
      var cptr = []; // (n + 1);
      // initialize vars
      var nz = 0;
      // loop columns    
      for (var k = 0; k < n; k++) {
        // column k of C is column q[k] of A
        cptr[k] = nz;
        // apply column permutation
        var j = q ? (q[k]) : k;
        // loop values in column j of A
        for (var t0 = aptr[j], t1 = aptr[j + 1], t = t0; t < t1; t++) {
          // row i of A is row pinv[i] of C
          var r = pinv ? pinv[aindex[t]] : aindex[t];
          // index
          cindex[nz] = r;
          // check we need to populate values
          if (cvalues) 
            cvalues[nz] = avalues[t];
          // increment number of nonzero elements
          nz++;
        }
      }
      // finalize the last column of C
      cptr[n] = nz;
      // return C matrix
      return new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [m, n],
        datatype: adt
      });
    };

    return cs_permute;
  }

  var name$112 = 'cs_permute';
  var path$50 = 'sparse';
  var factory_1$122 = factory$123;

  var cs_permute = {
  	name: name$112,
  	path: path$50,
  	factory: factory_1$122
  };

  function factory$124 () {

    /**
     * Computes the elimination tree of Matrix A (using triu(A)) or the 
     * elimination tree of A'A without forming A'A.
     *
     * @param {Matrix}  a               The A Matrix
     * @param {boolean} ata             A value of true the function computes the etree of A'A
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_etree = function (a, ata) {
      // check inputs
      if (!a)
        return null;
      // a arrays
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      // rows & columns
      var m = asize[0];
      var n = asize[1];
      
      // allocate result
      var parent = []; // (n)
      
      // allocate workspace
      var w = []; // (n + (ata ? m : 0))
      var ancestor = 0; // first n entries in w
      var prev = n; // last m entries (ata = true)
      
      var i, inext;
      
      // check we are calculating A'A
      if (ata) {
        // initialize workspace
        for (i = 0; i < m; i++) 
          w[prev + i] = -1;
      }
      // loop columns
      for (var k = 0; k < n; k++) {
        // node k has no parent yet
        parent[k] = -1;
        // nor does k have an ancestor
        w[ancestor + k] = -1;
        // values in column k
        for (var p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++) {
          // row
          var r = aindex[p];
          // node
          i = ata ? (w[prev + r]) : r;
          // traverse from i to k 
          for (; i != -1 && i < k; i = inext) {
            // inext = ancestor of i
            inext = w[ancestor + i];
            // path compression
            w[ancestor + i] = k;
            // check no anc., parent is k
            if (inext == -1) 
              parent[i] = k;
          }
          if (ata) 
            w[prev + r] = k;
        }
      }
      return parent;
    };

    return cs_etree;
  }

  var name$113 = 'cs_etree';
  var path$51 = 'sparse';
  var factory_1$123 = factory$124;

  var cs_etree = {
  	name: name$113,
  	path: path$51,
  	factory: factory_1$123
  };

  function factory$125 (type, config, load) {

    var cs_tdfs$$1 = load(cs_tdfs);

    /**
     * Post order a tree of forest
     *
     * @param {Array}   parent          The tree or forest
     * @param {Number}  n               Number of columns
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_post = function (parent, n) {
      // check inputs
      if (!parent) 
        return null;
      // vars 
      var k = 0;
      var j;
      // allocate result
      var post = []; // (n);
      // workspace, head: first n entries, next: next n entries, stack: last n entries
      var w = []; // (3 * n);
      var head = 0; 
      var next = n; 
      var stack = 2 * n;
      // initialize workspace
      for (j = 0; j < n; j++) {
        // empty linked lists
        w[head + j] = -1;
      }
      // traverse nodes in reverse order
      for (j = n-1; j >= 0; j--) {
        // check j is a root
        if (parent[j] == -1) 
          continue;
        // add j to list of its parent
        w[next + j] = w[head + parent[j]];
        w[head + parent[j]] = j;
      }
      // loop nodes
      for (j = 0; j < n; j++) {
        // skip j if it is not a root
        if (parent[j] != -1) 
          continue;
        // depth-first search
        k = cs_tdfs$$1(j, k, w, head, next, post, stack);
      }
      return post;
    };

    return cs_post;
  }

  var name$114 = 'cs_post';
  var path$52 = 'sparse';
  var factory_1$124 = factory$125;

  var cs_post = {
  	name: name$114,
  	path: path$52,
  	factory: factory_1$124
  };

  function factory$126 () {

    /**
     * This function determines if j is a leaf of the ith row subtree.
     * Consider A(i,j), node j in ith row subtree and return lca(jprev,j)
     *
     * @param {Number}  i               The ith row subtree
     * @param {Number}  j               The node to test
     * @param {Array}   w               The workspace array
     * @param {Number}  first           The index offset within the workspace for the first array
     * @param {Number}  maxfirst        The index offset within the workspace for the maxfirst array
     * @param {Number}  prevleaf        The index offset within the workspace for the prevleaf array
     * @param {Number}  ancestor        The index offset within the workspace for the ancestor array
     *
     * @return {Object}
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_leaf = function (i, j, w, first, maxfirst, prevleaf, ancestor) {
      
      var s, sparent, jprev;
      
      // our result
      var jleaf = 0;
      var q;
      
      // check j is a leaf
      if (i <= j || w[first + j] <= w[maxfirst + i]) 
        return (-1);
      // update max first[j] seen so far
      w[maxfirst + i] = w[first + j];
      // jprev = previous leaf of ith subtree
      jprev = w[prevleaf + i];
      w[prevleaf + i] = j;
      
      // check j is first or subsequent leaf
      if (jprev === -1) {
        // 1st leaf, q = root of ith subtree
        jleaf = 1;
        q = i;
      }
      else {
        // update jleaf
        jleaf = 2;
        // q = least common ancester (jprev,j)
        for (q = jprev; q != w[ancestor + q]; q = w[ancestor + q]);
        for (s = jprev; s != q; s = sparent) {
          // path compression
          sparent = w[ancestor + s];
          w[ancestor + s] = q;
        }      
      }
      return {
        jleaf: jleaf,
        q: q
      };
    };

    return cs_leaf;
  }

  var name$115 = 'cs_leaf';
  var path$53 = 'sparse';
  var factory_1$125 = factory$126;

  var cs_leaf = {
  	name: name$115,
  	path: path$53,
  	factory: factory_1$125
  };

  function factory$127 (type, config, load) {

    var transpose = load(transpose$1);
    
    var cs_leaf$$1 = load(cs_leaf);

    /**
     * Computes the column counts using the upper triangular part of A.
     * It transposes A internally, none of the input parameters are modified.
     *
     * @param {Matrix} a           The sparse matrix A
     *
     * @param {Matrix} ata         Count the columns of A'A instead
     *
     * @return                     An array of size n of the column counts or null on error
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_counts = function (a, parent, post, ata) {
      // check inputs
      if (!a || !parent || !post) 
        return null;
      // a matrix arrays
      var asize = a._size;
      // rows and columns
      var m = asize[0];
      var n = asize[1];   
      // variables
      var i, j, k,  J,  p, p0, p1;
      
      // workspace size
      var s = 4 * n + (ata ? (n + m + 1) : 0);
      // allocate workspace
      var w = []; // (s)
      var ancestor = 0; // first n entries
      var maxfirst = n; // next n entries
      var prevleaf = 2 * n; // next n entries
      var first = 3 * n; // next n entries
      var head = 4 * n; // next n + 1 entries (used when ata is true)
      var next = 5 * n + 1; // last entries in workspace
      // clear workspace w[0..s-1]
      for (k = 0; k < s; k++) 
        w[k] = -1;
      
      // allocate result
      var colcount = []; // (n);
      
      // AT = A'
      var at = transpose(a);
      // at arrays
      var tindex = at._index;
      var tptr = at._ptr;

      // find w[first + j]
      for (k = 0; k < n; k++) {
        j = post[k];
        // colcount[j]=1 if j is a leaf
        colcount[j] = (w[first + j] == -1) ? 1 : 0;
        for (; j != -1 && w[first + j] == -1; j = parent[j]) 
          w[first + j] = k;
      }

      // initialize ata if needed
      if (ata) {
        // invert post
        for (k = 0; k < n; k++) 
          w[post[k]] = k;
        // loop rows (columns in AT)
        for (i = 0; i < m; i++) {
          // values in column i of AT
          for (k = n, p0 = tptr[i], p1 = tptr[i + 1], p = p0; p < p1; p++) 
            k = Math.min(k, w[tindex[p]]);
          // place row i in linked list k
          w[next + i] = w[head + k];
          w[head + k] = i;
        }
      }
      
      // each node in its own set
      for (i = 0; i < n; i++) 
        w[ancestor + i] = i;
      
      for (k = 0; k < n; k++) {
        // j is the kth node in postordered etree
        j = post[k];
        // check j is not a root
        if (parent[j] != -1) 
          colcount[parent[j]]--;
        
        // J=j for LL'=A case
        for (J = (ata ? w[head + k] : j); J != -1; J = (ata ? w[next + J] : -1)) {
          for (p = tptr[J]; p < tptr[J+1]; p++) {
            i = tindex[p];
            var r = cs_leaf$$1(i, j, w, first, maxfirst, prevleaf, ancestor);
            // check A(i,j) is in skeleton
            if (r.jleaf >= 1) 
              colcount[j]++;
            // check account for overlap in q
            if (r.jleaf == 2) 
              colcount[r.q]--;
          }
        }
        if (parent[j] != -1) 
          w[ancestor + j] = parent[j];
      }
      // sum up colcount's of each child
      for (j = 0; j < n; j++) {
        if (parent[j] != -1) 
          colcount[parent[j]] += colcount[j];
      }
      return colcount;
    };

    return cs_counts;
  }

  var name$116 = 'cs_counts';
  var path$54 = 'sparse';
  var factory_1$126 = factory$127;

  var cs_counts = {
  	name: name$116,
  	path: path$54,
  	factory: factory_1$126
  };

  function factory$128 (type, config, load) {

    var cs_amd$$1 = load(cs_amd);
    var cs_permute$$1 = load(cs_permute);
    var cs_etree$$1 = load(cs_etree);
    var cs_post$$1 = load(cs_post);
    var cs_counts$$1 = load(cs_counts);

    /**
     * Symbolic ordering and analysis for QR and LU decompositions.
     *
     * @param {Number}  order           The ordering strategy (see cs_amd for more details)
     * @param {Matrix}  a               The A matrix
     * @param {boolean} qr              Symbolic ordering and analysis for QR decomposition (true) or
     *                                  symbolic ordering and analysis for LU decomposition (false)
     *
     * @return {Object}                 The Symbolic ordering and analysis for matrix A
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_sqr = function (order, a, qr) {
      // a arrays
      var aptr = a._ptr;
      var asize = a._size;
      // columns
      var n = asize[1];
      // vars
      var k;
      // symbolic analysis result
      var s = {};    
      // fill-reducing ordering
      s.q = cs_amd$$1(order, a);
      // validate results
      if (order && !s.q) 
        return null;
      // QR symbolic analysis
      if (qr) {
        // apply permutations if needed
        var c = order ? cs_permute$$1(a, null, s.q, 0) : a;
        // etree of C'*C, where C=A(:,q)
        s.parent = cs_etree$$1(c, 1);
        // post order elimination tree
        var post = cs_post$$1 (s.parent, n);
        // col counts chol(C'*C)
        s.cp = cs_counts$$1(c, s.parent, post, 1);
        // check we have everything needed to calculate number of nonzero elements
        if (c && s.parent && s.cp && _vcount(c, s)) {
          // calculate number of nonzero elements
          for (s.unz = 0, k = 0; k < n; k++) 
            s.unz += s.cp[k];
        }
      }
      else {
        // for LU factorization only, guess nnz(L) and nnz(U)
        s.unz = 4 * (aptr[n]) + n;
        s.lnz = s.unz;
      }
      // return result S
      return s;
    };
    
    /**
     * Compute nnz(V) = s.lnz, s.pinv, s.leftmost, s.m2 from A and s.parent
     */
    var _vcount = function (a, s) {
      // a arrays
      var aptr = a._ptr;
      var aindex = a._index;
      var asize = a._size;
      // rows & columns
      var m = asize[0];
      var n = asize[1];
      // initialize s arrays
      s.pinv = []; // (m + n);
      s.leftmost = []; // (m);
      // vars
      var parent = s.parent;
      var pinv = s.pinv;
      var leftmost = s.leftmost;
      // workspace, next: first m entries, head: next n entries, tail: next n entries, nque: next n entries
      var w = []; // (m + 3 * n);
      var next = 0;
      var head = m;
      var tail = m + n;
      var nque = m + 2 * n;
      // vars
      var i, k, p, p0, p1;
      // initialize w
      for (k = 0; k < n; k++) {
        // queue k is empty
        w[head + k] = -1;
        w[tail + k] = -1;
        w[nque + k] = 0;
      }
      // initialize row arrays
      for (i = 0; i < m; i++) 
        leftmost[i] = -1;
      // loop columns backwards    
      for (k = n - 1; k >= 0; k--) {
        // values & index for column k
        for (p0 = aptr[k], p1 = aptr[k + 1], p = p0; p < p1; p++) {
          // leftmost[i] = min(find(A(i,:)))
          leftmost[aindex[p]] = k;
        }
      }
      // scan rows in reverse order
      for (i = m - 1; i >= 0; i--) {
        // row i is not yet ordered
        pinv[i] = -1;
        k = leftmost[i];
        // check row i is empty
        if (k == -1) 
          continue;
        // first row in queue k
        if (w[nque + k]++ === 0) 
          w[tail + k] = i;
        // put i at head of queue k
        w[next + i] = w[head + k];
        w[head + k] = i;
      }
      s.lnz = 0;
      s.m2 = m;
      // find row permutation and nnz(V)
      for (k = 0; k < n; k++) {
        // remove row i from queue k
        i = w[head + k];
        // count V(k,k) as nonzero
        s.lnz++;
        // add a fictitious row
        if (i < 0) 
          i = s.m2++;
        // associate row i with V(:,k)
        pinv[i] = k;
        // skip if V(k+1:m,k) is empty
        if (--nque[k] <= 0) 
          continue;
        // nque[k] is nnz (V(k+1:m,k))
        s.lnz += w[nque + k];
        // move all rows to parent of k
        var pa = parent[k];
        if (pa != -1) {
          if (w[nque + pa] === 0) 
            w[tail + pa] = w[tail + k];
          w[next + w[tail + k]] = w[head + pa];
          w[head + pa] = w[next + i];
          w[nque + pa] += w[nque + k];
        }
      }
      for (i = 0; i < m; i++) {
        if (pinv[i] < 0) 
          pinv[i] = k++;
      }
      return true;
    };

    return cs_sqr;
  }

  var name$117 = 'cs_sqr';
  var path$55 = 'sparse';
  var factory_1$127 = factory$128;

  var cs_sqr = {
  	name: name$117,
  	path: path$55,
  	factory: factory_1$127
  };

  var nearlyEqual$5 = number.nearlyEqual;


  function factory$129 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    var latex$$1 = latex;

    /**
     * Test whether value x is larger or equal to y.
     *
     * The function returns true when x is larger than y or the relative
     * difference between x and y is smaller than the configured epsilon. The
     * function cannot be used to compare values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.largerEq(x, y)
     *
     * Examples:
     *
     *    math.larger(2, 1 + 1);         // returns false
     *    math.largerEq(2, 1 + 1);       // returns true
     *
     * See also:
     *
     *    equal, unequal, smaller, smallerEq, larger, compare
     *
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
     * @return {boolean | Array | Matrix} Returns true when the x is larger or equal to y, else returns false
     */
    var largerEq = typed('largerEq', {

      'boolean, boolean': function (x, y) {
        return x >= y;
      },

      'number, number': function (x, y) {
        return x >= y || nearlyEqual$5(x, y, config.epsilon);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.gte(y) || nearlyEqual(x, y, config.epsilon);
      },

      'Fraction, Fraction': function (x, y) {
        return x.compare(y) !== -1;
      },

      'Complex, Complex': function () {
        throw new TypeError('No ordering relation is defined for complex numbers');
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return largerEq(x.value, y.value);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, largerEq);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, largerEq, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, largerEq, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, largerEq);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return largerEq(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return largerEq(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return largerEq(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, largerEq, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, largerEq, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, largerEq, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, largerEq, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, largerEq, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, largerEq, true).valueOf();
      }
    });

    largerEq.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['largerEq'] + '${args[1]}\\right)'
    };

    return largerEq;
  }

  var name$118 = 'largerEq';
  var factory_1$128 = factory$129;

  var largerEq$1 = {
  	name: name$118,
  	factory: factory_1$128
  };

  function factory$130 () {

    /**
     * Checks if the node at w[j] is marked
     *
     * @param {Array}   w               The array
     * @param {Number}  j               The array index
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_marked = function (w, j) {
      // check node is marked
      return w[j] < 0;
    };

    return cs_marked;
  }

  var name$119 = 'cs_marked';
  var path$56 = 'sparse';
  var factory_1$129 = factory$130;

  var cs_marked = {
  	name: name$119,
  	path: path$56,
  	factory: factory_1$129
  };

  function factory$131 (type, config, load) {

    var cs_flip$$1 = load(cs_flip);

    /**
     * Marks the node at w[j]
     *
     * @param {Array}   w               The array
     * @param {Number}  j               The array index
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_mark = function (w, j) {
      // mark w[j]
      w[j] = cs_flip$$1(w [j]);
    };

    return cs_mark;
  }

  var name$120 = 'cs_mark';
  var path$57 = 'sparse';
  var factory_1$130 = factory$131;

  var cs_mark = {
  	name: name$120,
  	path: path$57,
  	factory: factory_1$130
  };

  function factory$132 (type, config, load) {

    var cs_flip$$1 = load(cs_flip);
    
    /**
     * Flips the value if it is negative of returns the same value otherwise.
     *
     * @param {Number}  i               The value to flip
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_unflip = function (i) {
      // flip the value if it is negative
      return i < 0 ? cs_flip$$1(i) : i;
    };

    return cs_unflip;
  }

  var name$121 = 'cs_unflip';
  var path$58 = 'sparse';
  var factory_1$131 = factory$132;

  var cs_unflip = {
  	name: name$121,
  	path: path$58,
  	factory: factory_1$131
  };

  function factory$133 (type, config, load) {

    var cs_marked$$1 = load(cs_marked);
    var cs_mark$$1   = load(cs_mark);
    var cs_unflip$$1 = load(cs_unflip);

    /**
     * Depth-first search computes the nonzero pattern xi of the directed graph G (Matrix) starting
     * at nodes in B (see cs_reach()).
     *
     * @param {Number}  j               The starting node for the DFS algorithm
     * @param {Matrix}  g               The G matrix to search, ptr array modified, then restored
     * @param {Number}  top             Start index in stack xi[top..n-1]
     * @param {Number}  k               The kth column in B
     * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
     *                                  The first n entries is the nonzero pattern, the last n entries is the stack
     * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
     *
     * @return {Number}                 New value of top
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_dfs = function (j, g, top, xi, pinv) {
      // g arrays
      var index = g._index;
      var ptr = g._ptr;
      var size = g._size;
      // columns
      var n = size[1];
      // vars
      var i, p, p2;
      // initialize head
      var head = 0;
      // initialize the recursion stack
      xi[0] = j;
      // loop
      while (head >= 0) {
        // get j from the top of the recursion stack
        j = xi[head];
        // apply permutation vector
        var jnew = pinv ? pinv[j] : j;
        // check node j is marked
        if (!cs_marked$$1(ptr, j)) {
          // mark node j as visited
          cs_mark$$1(ptr, j);
          // update stack (last n entries in xi)
          xi[n + head] = jnew < 0 ? 0 : cs_unflip$$1(ptr[jnew]);
        }
        // node j done if no unvisited neighbors
        var done = 1;
        // examine all neighbors of j, stack (last n entries in xi)
        for (p = xi[n + head], p2 = jnew < 0 ? 0 : cs_unflip$$1(ptr[jnew+1]); p < p2; p++) {
          // consider neighbor node i
          i = index[p];
          // check we have visited node i, skip it
          if (cs_marked$$1(ptr, i)) 
            continue;
          // pause depth-first search of node j, update stack (last n entries in xi)
          xi[n + head] = p;
          // start dfs at node i
          xi[++head] = i;
          // node j is not done
          done = 0;
          // break, to start dfs(i)
          break;
        }
        // check depth-first search at node j is done
        if (done) {
          // remove j from the recursion stack
          head--;
          // and place in the output stack
          xi[--top] = j;
        }
      }
      return top;    
    };

    return cs_dfs;
  }

  var name$122 = 'cs_dfs';
  var path$59 = 'sparse';
  var factory_1$132 = factory$133;

  var cs_dfs = {
  	name: name$122,
  	path: path$59,
  	factory: factory_1$132
  };

  function factory$134 (type, config, load) {

    var cs_dfs$$1 = load(cs_dfs);
    var cs_marked$$1 = load(cs_marked);
    var cs_mark$$1 = load(cs_mark);

    /**
     * The cs_reach function computes X = Reach(B), where B is the nonzero pattern of the n-by-1 
     * sparse column of vector b. The function returns the set of nodes reachable from any node in B. The
     * nonzero pattern xi of the solution x to the sparse linear system Lx=b is given by X=Reach(B).
     *
     * @param {Matrix}  g               The G matrix
     * @param {Matrix}  b               The B matrix
     * @param {Number}  k               The kth column in B
     * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
     *                                  The first n entries is the nonzero pattern, the last n entries is the stack
     * @param {Array}   pinv            The inverse row permutation vector
     *
     * @return {Number}                 The index for the nonzero pattern
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_reach = function (g, b, k, xi, pinv) {
      // g arrays
      var gptr = g._ptr;
      var gsize = g._size;
      // b arrays
      var bindex = b._index;
      var bptr = b._ptr;
      // columns
      var n = gsize[1];
      // vars
      var p, p0, p1;
      // initialize top
      var top = n;
      // loop column indeces in B
      for (p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++) {
        // node i
        var i = bindex[p];
        // check node i is marked
        if (!cs_marked$$1(gptr, i)) {
          // start a dfs at unmarked node i
          top = cs_dfs$$1(i, g, top, xi, pinv);
        }
      }
      // loop columns from top -> n - 1
      for (p = top; p < n; p++) {
        // restore G
        cs_mark$$1(gptr, xi[p]);
      }
      return top;
    };

    return cs_reach;
  }

  var name$123 = 'cs_reach';
  var path$60 = 'sparse';
  var factory_1$133 = factory$134;

  var cs_reach = {
  	name: name$123,
  	path: path$60,
  	factory: factory_1$133
  };

  function factory$135 (type, config, load) {

    var divideScalar$$1 = load(divideScalar);
    var multiply = load(multiply$1);
    var subtract = load(subtract$1);

    var cs_reach$$1 = load(cs_reach);

    /**
     * The function cs_spsolve() computes the solution to G * x = bk, where bk is the
     * kth column of B. When lo is true, the function assumes G = L is lower triangular with the
     * diagonal entry as the first entry in each column. When lo is true, the function assumes G = U 
     * is upper triangular with the diagonal entry as the last entry in each column.
     *
     * @param {Matrix}  g               The G matrix
     * @param {Matrix}  b               The B matrix
     * @param {Number}  k               The kth column in B
     * @param {Array}   xi              The nonzero pattern xi[top] .. xi[n - 1], an array of size = 2 * n
     *                                  The first n entries is the nonzero pattern, the last n entries is the stack
     * @param {Array}   x               The soluton to the linear system G * x = b
     * @param {Array}   pinv            The inverse row permutation vector, must be null for L * x = b
     * @param {boolean} lo              The lower (true) upper triangular (false) flag
     *
     * @return {Number}                 The index for the nonzero pattern
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_spsolve = function (g, b, k, xi, x, pinv, lo) {
      // g arrays
      var gvalues = g._values;
      var gindex = g._index;
      var gptr = g._ptr;
      var gsize = g._size;
      // columns
      var n = gsize[1];
      // b arrays
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      // vars
      var p, p0, p1, q;
      // xi[top..n-1] = cs_reach(B(:,k))
      var top = cs_reach$$1(g, b, k, xi, pinv);
      // clear x
      for (p = top; p < n; p++) 
        x[xi[p]] = 0;
      // scatter b
      for (p0 = bptr[k], p1 = bptr[k + 1], p = p0; p < p1; p++) 
        x[bindex[p]] = bvalues[p];
      // loop columns
      for (var px = top; px < n; px++) {
        // x array index for px
        var j = xi[px];
        // apply permutation vector (U x = b), j maps to column J of G
        var J = pinv ? pinv[j] : j;
        // check column J is empty
        if (J < 0)
          continue;
        // column value indeces in G, p0 <= p < p1
        p0 = gptr[J];
        p1 = gptr[J + 1];
        // x(j) /= G(j,j)
        x[j] = divideScalar$$1(x[j], gvalues[lo ? p0 : (p1 - 1)]);
        // first entry L(j,j)
        p = lo ? (p0 + 1) : p0;
        q = lo ? (p1) : (p1 - 1);
        // loop
        for ( ; p < q ; p++) {
          // row
          var i = gindex[p];
          // x(i) -= G(i,j) * x(j)
          x[i] = subtract(x[i], multiply(gvalues[p], x[j]));
        }
      }
      // return top of stack
      return top;
    };
    
    return cs_spsolve;
  }

  var name$124 = 'cs_spsolve';
  var path$61 = 'sparse';
  var factory_1$134 = factory$135;

  var cs_spsolve = {
  	name: name$124,
  	path: path$61,
  	factory: factory_1$134
  };

  function factory$136 (type, config, load) {

    var abs = load(abs$1);
    var divideScalar$$1 = load(divideScalar);
    var multiply = load(multiply$1);
    
    var larger$$1 = load(larger);
    var largerEq = load(largerEq$1);
    
    var cs_spsolve$$1 = load(cs_spsolve);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Computes the numeric LU factorization of the sparse matrix A. Implements a Left-looking LU factorization
     * algorithm that computes L and U one column at a tume. At the kth step, it access columns 1 to k-1 of L 
     * and column k of A. Given the fill-reducing column ordering q (see parameter s) computes L, U and pinv so
     * L * U = A(p, q), where p is the inverse of pinv.
     *
     * @param {Matrix}  m               The A Matrix to factorize
     * @param {Object}  s               The symbolic analysis from cs_sqr(). Provides the fill-reducing 
     *                                  column ordering q
     * @param {Number}  tol             Partial pivoting threshold (1 for partial pivoting)
     *
     * @return {Number}                 The numeric LU factorization of A or null
     *
     * Reference: http://faculty.cse.tamu.edu/davis/publications.html
     */
    var cs_lu = function (m, s, tol) {
      // validate input
      if (!m)
        return null;
      // m arrays
      var size = m._size;
      // columns
      var n = size[1];
      // symbolic analysis result
      var q;
      var lnz = 100;
      var unz = 100;
      // update symbolic analysis parameters
      if (s) {
        q = s.q;
        lnz = s.lnz || lnz;
        unz = s.unz || unz;
      }
      // L arrays
      var lvalues = []; // (lnz)
      var lindex = []; // (lnz);
      var lptr = []; // (n + 1);
      // L
      var L = new SparseMatrix({
        values: lvalues,
        index: lindex,
        ptr: lptr,
        size: [n, n]
      });
      // U arrays
      var uvalues = []; // (unz);
      var uindex = []; // (unz);
      var uptr = []; // (n + 1);
      // U
      var U = new SparseMatrix({
        values: uvalues,
        index: uindex,
        ptr: uptr,
        size: [n, n]
      });
      // inverse of permutation vector
      var pinv = []; // (n);
      // vars 
      var i, p;
      // allocate arrays
      var x = []; // (n);
      var xi = []; // (2 * n);
      // initialize variables
      for (i = 0; i < n; i++) {
        // clear workspace
        x[i] = 0;
        // no rows pivotal yet
        pinv[i] = -1;
        // no cols of L yet
        lptr[i + 1] = 0;
      }
      // reset number of nonzero elements in L and U
      lnz = 0;
      unz = 0;
      // compute L(:,k) and U(:,k)
      for (var k = 0; k < n; k++) {
        // update ptr
        lptr[k] = lnz;
        uptr[k] = unz;
        // apply column permutations if needed
        var col = q ? q[k] : k;
        // solve triangular system, x = L\A(:,col)
        var top = cs_spsolve$$1(L, m, col, xi, x, pinv, 1);
        // find pivot
        var ipiv = -1;
        var a = -1;
        // loop xi[] from top -> n
        for (p = top; p < n; p++) {
          // x[i] is nonzero
          i = xi[p];
          // check row i is not yet pivotal
          if (pinv[i] < 0) {
            // absolute value of x[i]          
            var xabs = abs(x[i]);
            // check absoulte value is greater than pivot value
            if (larger$$1(xabs, a)) {
              // largest pivot candidate so far
              a = xabs;
              ipiv = i;
            }
          }
          else {
            // x(i) is the entry U(pinv[i],k)
            uindex[unz] = pinv[i];
            uvalues[unz++] = x[i];
          }
        }
        // validate we found a valid pivot
        if (ipiv == -1 || a <= 0) 
          return null;
        // update actual pivot column, give preference to diagonal value
        if (pinv[col] < 0 && largerEq(abs(x[col]), multiply(a, tol)))
          ipiv = col;
        // the chosen pivot
        var pivot = x[ipiv];
        // last entry in U(:,k) is U(k,k)
        uindex[unz] = k;
        uvalues[unz++] = pivot;
        // ipiv is the kth pivot row
        pinv[ipiv] = k;
        // first entry in L(:,k) is L(k,k) = 1
        lindex[lnz] = ipiv;
        lvalues[lnz++] = 1;
        // L(k+1:n,k) = x / pivot      
        for (p = top; p < n; p++) {
          // row
          i = xi[p];
          // check x(i) is an entry in L(:,k)
          if (pinv[i] < 0) {
            // save unpermuted row in L
            lindex[lnz] = i;
            // scale pivot column
            lvalues[lnz++] = divideScalar$$1(x[i], pivot);
          }
          // x[0..n-1] = 0 for next k
          x[i] = 0;
        }
      }
      // update ptr
      lptr[n] = lnz;
      uptr[n] = unz;
      // fix row indices of L for final pinv
      for (p = 0; p < lnz; p++) 
        lindex[p] = pinv[lindex[p]];
      // trim arrays
      lvalues.splice(lnz, lvalues.length - lnz);
      lindex.splice(lnz, lindex.length - lnz);
      uvalues.splice(unz, uvalues.length - unz);
      uindex.splice(unz, uindex.length - unz);    
      // return LU factor
      return {
        L: L,
        U: U,
        pinv: pinv
      };
    };

    return cs_lu;
  }

  var name$125 = 'cs_lu';
  var path$62 = 'sparse';
  var factory_1$135 = factory$136;

  var cs_lu = {
  	name: name$125,
  	path: path$62,
  	factory: factory_1$135
  };

  var number$5 = utils.number,
      
      isInteger$8 = number$5.isInteger;

  function factory$137 (type, config, load, typed) {

    var cs_sqr$$1 = load(cs_sqr);
    var cs_lu$$1 = load(cs_lu);

    /**
     * Calculate the Sparse Matrix LU decomposition with full pivoting. Sparse Matrix `A` is decomposed in two matrices (`L`, `U`) and two permutation vectors (`pinv`, `q`) where
     *
     * `P * A * Q = L * U`
     *
     * Syntax:
     *
     *    math.slu(A, order, threshold);
     *
     * Examples:
     *
     *    var A = math.sparse([[4,3], [6, 3]])
     *    math.slu(A, 1, 0.001)
     *    // returns:
     *    // {
     *    //   L: [[1, 0], [1.5, 1]]
     *    //   U: [[4, 3], [0, -1.5]]
     *    //   p: [0, 1]
     *    //   q: [0, 1]
     *    // }
     *
     * See also:
     *
     *    lup, lsolve, usolve, lusolve
     *
     * @param {SparseMatrix} A              A two dimensional sparse matrix for which to get the LU decomposition.
     * @param {Number}       order          The Symbolic Ordering and Analysis order:
     *                                       0 - Natural ordering, no permutation vector q is returned
     *                                       1 - Matrix must be square, symbolic ordering and analisis is performed on M = A + A'
     *                                       2 - Symbolic ordering and analisis is performed on M = A' * A. Dense columns from A' are dropped, A recreated from A'. 
     *                                           This is appropriatefor LU factorization of unsymmetric matrices.
     *                                       3 - Symbolic ordering and analisis is performed on M = A' * A. This is best used for LU factorization is matrix M has no dense rows.
     *                                           A dense row is a row with more than 10*sqr(columns) entries.
     * @param {Number}       threshold       Partial pivoting threshold (1 for partial pivoting)
     *
     * @return {Object} The lower triangular matrix, the upper triangular matrix and the permutation vectors.
     */
    var slu = typed('slu', {

      'SparseMatrix, number, number': function (a, order, threshold) {
        // verify order
        if (!isInteger$8(order) || order < 0 || order > 3)
          throw new Error('Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]');
        // verify threshold
        if (threshold < 0 || threshold > 1)
          throw new Error('Partial pivoting threshold must be a number from 0 to 1');
        
        // perform symbolic ordering and analysis
        var s = cs_sqr$$1(order, a, false);
        
        // perform lu decomposition
        var f = cs_lu$$1(a, s, threshold);
        
        // return decomposition
        return {
          L: f.L,
          U: f.U,
          p: f.pinv,
          q: s.q,
          toString: function () {
            return 'L: ' + this.L.toString() + '\nU: ' + this.U.toString() + '\np: ' + this.p.toString() + (this.q ? '\nq: ' + this.q.toString() : '') + '\n';
          }
        };
      }
    });

    return slu;
  }

  var name$126 = 'slu';
  var factory_1$136 = factory$137;

  var slu$1 = {
  	name: name$126,
  	factory: factory_1$136
  };

  var string$9 = utils.string;
  var array$3 = utils.array;

  var isArray$3 = Array.isArray;

  function factory$138 (type) {
    
    var DenseMatrix = type.DenseMatrix;

    /**
     * Validates matrix and column vector b for backward/forward substitution algorithms.
     *
     * @param {Matrix} m            An N x N matrix
     * @param {Array | Matrix} b    A column vector
     * @param {Boolean} copy        Return a copy of vector b
     *
     * @return {DenseMatrix}        Dense column vector b
     */
    var solveValidation = function (m, b, copy) {
      // matrix size
      var size = m.size();
      // validate matrix dimensions
      if (size.length !== 2)
        throw new RangeError('Matrix must be two dimensional (size: ' + string$9.format(size) + ')');
      // rows & columns
      var rows = size[0];
      var columns = size[1];    
      // validate rows & columns
      if (rows !== columns) 
        throw new RangeError('Matrix must be square (size: ' + string$9.format(size) + ')');
      // vars
      var data, i, bdata;
      // check b is matrix
      if (type.isMatrix(b)) {
        // matrix size
        var msize = b.size();
        // vector
        if (msize.length === 1) {
          // check vector length
          if (msize[0] !== rows)
            throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
          // create data array
          data = [];
          // matrix data (DenseMatrix)
          bdata = b._data;
          // loop b data
          for (i = 0; i < rows; i++) {
            // row array
            data[i] = [bdata[i]];
          }
          // return Dense Matrix
          return new DenseMatrix({
            data: data,
            size: [rows, 1],
            datatype: b._datatype
          });
        }
        // two dimensions
        if (msize.length === 2) {
          // array must be a column vector
          if (msize[0] !== rows || msize[1] !== 1)
            throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
          // check matrix type
          if (type.isDenseMatrix(b)) {
            // check a copy is needed
            if (copy) {
              // create data array
              data = [];
              // matrix data (DenseMatrix)
              bdata = b._data;
              // loop b data
              for (i = 0; i < rows; i++) {
                // row array
                data[i] = [bdata[i][0]];
              }
              // return Dense Matrix
              return new DenseMatrix({
                data: data,
                size: [rows, 1],
                datatype: b._datatype
              });
            }
            // b is already a column vector
            return b;
          }
          // create data array
          data = [];
          for (i = 0; i < rows; i++)
            data[i] = [0];
          // sparse matrix arrays
          var values = b._values;
          var index = b._index;
          var ptr = b._ptr;
          // loop values in column 0
          for (var k1 = ptr[1], k = ptr[0]; k < k1; k++) {
            // row
            i = index[k];
            // add to data
            data[i][0] = values[k]; 
          }
          // return Dense Matrix
          return new DenseMatrix({
            data: data,
            size: [rows, 1],
            datatype: b._datatype
          });
        }
        // throw error
        throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
      }
      // check b is array
      if (isArray$3(b)) {
        // size
        var asize = array$3.size(b);
        // check matrix dimensions, vector
        if (asize.length === 1) {
          // check vector length
          if (asize[0] !== rows)
            throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');        
          // create data array
          data = [];
          // loop b
          for (i = 0; i < rows; i++) {
            // row array
            data[i] = [b[i]];
          }
          // return Dense Matrix
          return new DenseMatrix({
            data: data,
            size: [rows, 1]
          });
        }
        if (asize.length === 2) {
          // array must be a column vector
          if (asize[0] !== rows || asize[1] !== 1)
            throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');
          // create data array
          data = [];
          // loop b data
          for (i = 0; i < rows; i++) {
            // row array
            data[i] = [b[i][0]];
          }
          // return Dense Matrix
          return new DenseMatrix({
            data: data,
            size: [rows, 1]
          });
        }
        // throw error
        throw new RangeError('Dimension mismatch. Matrix columns must match vector length.');      
      }
    };
    
    return solveValidation;
  }

  var factory_1$137 = factory$138;

  var solveValidation = {
  	factory: factory_1$137
  };

  function factory$139 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var divideScalar$$1 = load(divideScalar);
    var multiplyScalar$$1 = load(multiplyScalar);
    var subtract = load(subtract$1);
    var equalScalar$$1 = load(equalScalar);

    var solveValidation$$1 = load(solveValidation);

    var DenseMatrix = type.DenseMatrix;

    /** 
     * Solves the linear equation system by forwards substitution. Matrix must be a lower triangular matrix.
     *
     * `L * x = b`
     *
     * Syntax:
     *
     *    math.lsolve(L, b);
     *
     * Examples:
     *
     *    var a = [[-2, 3], [2, 1]];
     *    var b = [11, 9];
     *    var x = lsolve(a, b);  // [[-5.5], [20]]
     *
     * See also:
     *
     *    lup, slu, usolve, lusolve
     *
     * @param {Matrix, Array} L       A N x N matrix or array (L)
     * @param {Matrix, Array} b       A column vector with the b values
     *
     * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
     */
    var lsolve = typed('lsolve', {

      'SparseMatrix, Array | Matrix': function (m, b) {
        // process matrix
        return _sparseForwardSubstitution(m, b);
      },
      
      'DenseMatrix, Array | Matrix': function (m, b) {
        // process matrix
        return _denseForwardSubstitution(m, b);
      },
      
      'Array, Array | Matrix': function (a, b) {
        // create dense matrix from array
        var m = matrix$$1(a);
        // use matrix implementation
        var r = _denseForwardSubstitution(m, b);
        // result
        return r.valueOf();
      }
    });

    var _denseForwardSubstitution = function (m, b) {
      // validate matrix and vector, return copy of column vector b
      b = solveValidation$$1(m, b, true);
      // column vector data
      var bdata = b._data;
      // rows & columns
      var rows = m._size[0];
      var columns = m._size[1];
      // result
      var x = [];
      // data
      var data = m._data;
      // forward solve m * x = b, loop columns
      for (var j = 0; j < columns; j++) {
        // b[j]
        var bj = bdata[j][0] || 0;
        // x[j]
        var xj;
        // forward substitution (outer product) avoids inner looping when bj == 0
        if (!equalScalar$$1(bj, 0)) {
          // value @ [j, j]
          var vjj = data[j][j];
          // check vjj
          if (equalScalar$$1(vjj, 0)) {
            // system cannot be solved
            throw new Error('Linear system cannot be solved since matrix is singular');
          }
          // calculate xj
          xj = divideScalar$$1(bj, vjj);
          // loop rows
          for (var i = j + 1; i < rows; i++) {
            // update copy of b
            bdata[i] = [subtract(bdata[i][0] || 0, multiplyScalar$$1(xj, data[i][j]))];
          }
        }
        else {
          // zero @ j
          xj = 0;
        }
        // update x
        x[j] = [xj];
      }
      // return vector
      return new DenseMatrix({
        data: x,
        size: [rows, 1]
      });
    };

    var _sparseForwardSubstitution = function (m, b) {
      // validate matrix and vector, return copy of column vector b
      b = solveValidation$$1(m, b, true);
      // column vector data
      var bdata = b._data;
      // rows & columns
      var rows = m._size[0];
      var columns = m._size[1];
      // matrix arrays
      var values = m._values;
      var index = m._index;
      var ptr = m._ptr;
      // vars
      var i, k;
      // result
      var x = [];
      // forward solve m * x = b, loop columns
      for (var j = 0; j < columns; j++) {
        // b[j]
        var bj = bdata[j][0] || 0;
        // forward substitution (outer product) avoids inner looping when bj == 0
        if (!equalScalar$$1(bj, 0)) {
          // value @ [j, j]
          var vjj = 0;
          // lower triangular matrix values & index (column j)
          var jvalues = [];
          var jindex = [];
          // last index in column
          var l = ptr[j + 1];
          // values in column, find value @ [j, j]
          for (k = ptr[j]; k < l; k++) {
            // row
            i = index[k];
            // check row (rows are not sorted!)
            if (i === j) {
              // update vjj
              vjj = values[k];
            }
            else if (i > j) {
              // store lower triangular
              jvalues.push(values[k]);
              jindex.push(i);
            }
          }
          // at this point we must have a value @ [j, j]
          if (equalScalar$$1(vjj, 0)) {
            // system cannot be solved, there is no value @ [j, j]
            throw new Error('Linear system cannot be solved since matrix is singular');
          }
          // calculate xj
          var xj = divideScalar$$1(bj, vjj);
          // loop lower triangular
          for (k = 0, l = jindex.length; k < l; k++) {
            // row
            i = jindex[k];
            // update copy of b
            bdata[i] = [subtract(bdata[i][0] || 0, multiplyScalar$$1(xj, jvalues[k]))];
          }
          // update x
          x[j] = [xj];
        }
        else {
          // update x
          x[j] = [0];
        }
      }
      // return vector
      return new DenseMatrix({
        data: x,
        size: [rows, 1]
      });
    };

    return lsolve;
  }

  var name$127 = 'lsolve';
  var factory_1$138 = factory$139;

  var lsolve$1 = {
  	name: name$127,
  	factory: factory_1$138
  };

  function factory$140 () {

    /**
     * Permutes a vector; x = P'b. In MATLAB notation, x(p)=b.
     *
     * @param {Array} p           The permutation vector of length n. null value denotes identity
     * @param {Array} b           The input vector
     *
     * @return {Array}            The output vector x = P'b
     */
    var cs_ipvec = function (p, b, n) {
      // vars 
      var k;
      var n = b.length;
      var x = [];
      // check permutation vector was provided, p = null denotes identity
      if (p) {
        // loop vector
        for (k = 0; k < n; k++) {
          // apply permutation
          x[p[k]] = b[k];
        }
      }
      else {
        // loop vector
        for (k = 0; k < n; k++) {
          // x[i] = b[i]
          x[k] = b[k];
        }
      }
      return x;
    };

    return cs_ipvec;
  }

  var name$128 = 'cs_ipvec';
  var path$63 = 'sparse';
  var factory_1$139 = factory$140;

  var cs_ipvec = {
  	name: name$128,
  	path: path$63,
  	factory: factory_1$139
  };

  function factory$141 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var divideScalar$$1 = load(divideScalar);
    var multiplyScalar$$1 = load(multiplyScalar);
    var subtract = load(subtract$1);
    var equalScalar$$1 = load(equalScalar);

    var solveValidation$$1 = load(solveValidation);
    
    var DenseMatrix = type.DenseMatrix;

    /**
     * Solves the linear equation system by backward substitution. Matrix must be an upper triangular matrix.
     *
     * `U * x = b`
     *
     * Syntax:
     *
     *    math.usolve(U, b);
     *
     * Examples:
     *
     *    var a = [[-2, 3], [2, 1]];
     *    var b = [11, 9];
     *    var x = usolve(a, b);  // [[8], [9]]
     *
     * See also:
     *
     *    lup, slu, usolve, lusolve
     *
     * @param {Matrix, Array} U       A N x N matrix or array (U)
     * @param {Matrix, Array} b       A column vector with the b values
     *
     * @return {DenseMatrix | Array}  A column vector with the linear system solution (x)
     */
    var usolve = typed('usolve', {
      
      'SparseMatrix, Array | Matrix': function (m, b) {
        // process matrix
        return _sparseBackwardSubstitution(m, b);
      },

      'DenseMatrix, Array | Matrix': function (m, b) {
        // process matrix
        return _denseBackwardSubstitution(m, b);
      },

      'Array, Array | Matrix': function (a, b) {
        // create dense matrix from array
        var m = matrix$$1(a);
        // use matrix implementation
        var r = _denseBackwardSubstitution(m, b);
        // result
        return r.valueOf();
      }
    });

    var _denseBackwardSubstitution = function (m, b) {
      // validate matrix and vector, return copy of column vector b
      b = solveValidation$$1(m, b, true);
      // column vector data
      var bdata = b._data;
      // rows & columns
      var rows = m._size[0];
      var columns = m._size[1];
      // result
      var x = [];
      // arrays
      var data = m._data;
      // backward solve m * x = b, loop columns (backwards)
      for (var j = columns - 1; j >= 0 ; j--) {
        // b[j]
        var bj = bdata[j][0] || 0;
        // x[j]
        var xj;
        // backward substitution (outer product) avoids inner looping when bj == 0
        if (!equalScalar$$1(bj, 0)) {
          // value @ [j, j]
          var vjj = data[j][j];
          // check vjj
          if (equalScalar$$1(vjj, 0)) {
            // system cannot be solved
            throw new Error('Linear system cannot be solved since matrix is singular');
          }
          // calculate xj
          xj = divideScalar$$1(bj, vjj);        
          // loop rows
          for (var i = j - 1; i >= 0; i--) {
            // update copy of b
            bdata[i] = [subtract(bdata[i][0] || 0, multiplyScalar$$1(xj, data[i][j]))];
          }
        }
        else {
          // zero value @ j
          xj = 0;
        }
        // update x
        x[j] = [xj];
      }
      // return column vector
      return new DenseMatrix({
        data: x,
        size: [rows, 1]
      });
    };
    
    var _sparseBackwardSubstitution = function (m, b) {
      // validate matrix and vector, return copy of column vector b
      b = solveValidation$$1(m, b, true);
      // column vector data
      var bdata = b._data;
      // rows & columns
      var rows = m._size[0];
      var columns = m._size[1];
      // matrix arrays
      var values = m._values;
      var index = m._index;
      var ptr = m._ptr;
      // vars
      var i, k;
      // result
      var x = [];
      // backward solve m * x = b, loop columns (backwards)
      for (var j = columns - 1; j >= 0 ; j--) {
        // b[j]
        var bj = bdata[j][0] || 0;
        // backward substitution (outer product) avoids inner looping when bj == 0
        if (!equalScalar$$1(bj, 0)) {
          // value @ [j, j]
          var vjj = 0;
          // upper triangular matrix values & index (column j)
          var jvalues = [];
          var jindex = [];
          // first & last indeces in column
          var f = ptr[j];
          var l = ptr[j + 1];
          // values in column, find value @ [j, j], loop backwards
          for (k = l - 1; k >= f; k--) {
            // row
            i = index[k];
            // check row
            if (i === j) {
              // update vjj
              vjj = values[k];
            }
            else if (i < j) {
              // store upper triangular
              jvalues.push(values[k]);
              jindex.push(i);
            }
          }
          // at this point we must have a value @ [j, j]
          if (equalScalar$$1(vjj, 0)) {
            // system cannot be solved, there is no value @ [j, j]
            throw new Error('Linear system cannot be solved since matrix is singular');
          }
          // calculate xj
          var xj = divideScalar$$1(bj, vjj);
          // loop upper triangular
          for (k = 0, l = jindex.length; k < l; k++) {
            // row
            i = jindex[k];
            // update copy of b
            bdata[i] = [subtract(bdata[i][0], multiplyScalar$$1(xj, jvalues[k]))];
          }
          // update x
          x[j] = [xj];
        }
        else {
          // update x
          x[j] = [0];
        }
      }
      // return vector
      return new DenseMatrix({
        data: x,
        size: [rows, 1]
      });
    };
    
    return usolve;
  }

  var name$129 = 'usolve';
  var factory_1$140 = factory$141;

  var usolve$1 = {
  	name: name$129,
  	factory: factory_1$140
  };

  var isArray$4 = Array.isArray;

  function factory$142 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);
    var lup = load(lup$1);
    var slu = load(slu$1);
    var cs_ipvec$$1 = load(cs_ipvec);

    var solveValidation$$1 = load(solveValidation);

    var usolve = load(usolve$1);
    var lsolve = load(lsolve$1);

    /**
     * Solves the linear system `A * x = b` where `A` is an [n x n] matrix and `b` is a [n] column vector.
     *
     * Syntax:
     *
     *    math.lusolve(A, b)     // returns column vector with the solution to the linear system A * x = b
     *    math.lusolve(lup, b)   // returns column vector with the solution to the linear system A * x = b, lup = math.lup(A)
     *
     * Examples:
     *
     *    var m = [[1, 0, 0, 0], [0, 2, 0, 0], [0, 0, 3, 0], [0, 0, 0, 4]];
     *
     *    var x = math.lusolve(m, [-1, -1, -1, -1]);        // x = [[-1], [-0.5], [-1/3], [-0.25]]
     *
     *    var f = math.lup(m);
     *    var x1 = math.lusolve(f, [-1, -1, -1, -1]);       // x1 = [[-1], [-0.5], [-1/3], [-0.25]]
     *    var x2 = math.lusolve(f, [1, 2, 1, -1]);          // x2 = [[1], [1], [1/3], [-0.25]]
     *
     *    var a = [[-2, 3], [2, 1]];
     *    var b = [11, 9];
     *    var x = math.lusolve(a, b);  // [[2], [5]]
     *
     * See also:
     *
     *    lup, slu, lsolve, usolve
     *
     * @param {Matrix | Array | Object} A      Invertible Matrix or the Matrix LU decomposition
     * @param {Matrix | Array} b               Column Vector
     * @param {number} [order]                 The Symbolic Ordering and Analysis order, see slu for details. Matrix must be a SparseMatrix
     * @param {Number} [threshold]             Partial pivoting threshold (1 for partial pivoting), see slu for details. Matrix must be a SparseMatrix.
     *
     * @return {DenseMatrix | Array}           Column vector with the solution to the linear system A * x = b
     */
    var lusolve = typed('lusolve', {
      
      'Array, Array | Matrix': function (a, b) {
        // convert a to matrix
        a = matrix$$1(a);
        // matrix lup decomposition
        var d = lup(a);
        // solve
        var x = _lusolve(d.L, d.U, d.p, null, b);
        // convert result to array
        return x.valueOf();
      },
      
      'DenseMatrix, Array | Matrix': function (a, b) {
        // matrix lup decomposition
        var d = lup(a);
        // solve
        return _lusolve(d.L, d.U, d.p, null, b);
      },
      
      'SparseMatrix, Array | Matrix': function (a, b) {
        // matrix lup decomposition
        var d = lup(a);
        // solve
        return _lusolve(d.L, d.U, d.p, null, b);
      },
      
      'SparseMatrix, Array | Matrix, number, number': function (a, b, order, threshold) {
        // matrix lu decomposition
        var d = slu(a, order, threshold);
        // solve
        return _lusolve(d.L, d.U, d.p, d.q, b);
      },

      'Object, Array | Matrix': function (d, b) {
        // solve
        return _lusolve(d.L, d.U, d.p, d.q, b);
      }
    });
    
    var _toMatrix = function (a) {
      // check it is a matrix
      if (type.isMatrix(a))
        return a;
      // check array
      if (isArray$4(a))
        return matrix$$1(a);
      // throw
      throw new TypeError('Invalid Matrix LU decomposition');
    };
    
    var _lusolve = function (l, u, p, q, b) {
      // verify L, U, P
      l = _toMatrix(l);
      u = _toMatrix(u);
      // validate matrix and vector
      b = solveValidation$$1(l, b, false);
      // apply row permutations if needed (b is a DenseMatrix)
      if (p)
        b._data = cs_ipvec$$1(p, b._data);
      // use forward substitution to resolve L * y = b
      var y = lsolve(l, b);
      // use backward substitution to resolve U * x = y
      var x = usolve(u, y);
      // apply column permutations if needed (x is a DenseMatrix)
      if (q)
        x._data = cs_ipvec$$1(q, x._data);
      // return solution
      return x;
    };

    return lusolve;
  }

  var name$130 = 'lusolve';
  var factory_1$141 = factory$142;

  var lusolve$1 = {
  	name: name$130,
  	factory: factory_1$141
  };

  var algebra = [
    derivative$1,

    // simplify
    simplify$1,

    // polynomial 
    rationalize$1,
      
    
    // decomposition
    qr$1,
    lup$1,
    slu$1,

    // solver
    lsolve$1,
    lusolve$1,
    usolve$1
  ];

  function factory$143 (type, config, load, typed) {
    /**
     * Test whether a value is negative: smaller than zero.
     * The function supports types `number`, `BigNumber`, `Fraction`, and `Unit`.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isNegative(x)
     *
     * Examples:
     *
     *    math.isNegative(3);                     // returns false
     *    math.isNegative(-2);                    // returns true
     *    math.isNegative(0);                     // returns false
     *    math.isNegative(-0);                    // returns false
     *    math.isNegative(math.bignumber(2));     // returns false
     *    math.isNegative(math.fraction(-2, 5));  // returns true
     *    math.isNegative('-2');                  // returns true
     *    math.isNegative([2, 0, -3]');           // returns [false, false, true]
     *
     * See also:
     *
     *    isNumeric, isPositive, isZero, isInteger
     *
     * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
     * @return {boolean}  Returns true when `x` is larger than zero.
     *                    Throws an error in case of an unknown data type.
     */
    var isNegative = typed('isNegative', {
      'number': function (x) {
        return x < 0;
      },

      'BigNumber': function (x) {
        return x.isNeg() && !x.isZero() && !x.isNaN();
      },

      'Fraction': function (x) {
        return x.s < 0; // It's enough to decide on the sign
      },

      'Unit': function (x) {
        return isNegative(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, isNegative);
      }
    });

    return isNegative;
  }

  var name$131 = 'isNegative';
  var factory_1$142 = factory$143;

  var isNegative$1 = {
  	name: name$131,
  	factory: factory_1$142
  };

  function factory$144 (type, config, load, typed) {
    var unaryMinus = load(unaryMinus$1);
    var isNegative = load(isNegative$1);
    var matrix$$1 = load(matrix);

    /**
     * Calculate the cubic root of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.cbrt(x)
     *    math.cbrt(x, allRoots)
     *
     * Examples:
     *
     *    math.cbrt(27);                  // returns 3
     *    math.cube(3);                   // returns 27
     *    math.cbrt(-64);                 // returns -4
     *    math.cbrt(math.unit('27 m^3')); // returns Unit 3 m
     *    math.cbrt([27, 64, 125]);       // returns [3, 4, 5]
     *
     *    var x = math.complex('8i');
     *    math.cbrt(x);                   // returns Complex 1.7320508075689 + i
     *    math.cbrt(x, true);             // returns Matrix [
     *                                    //    1.7320508075689 + i
     *                                    //   -1.7320508075689 + i
     *                                    //   -2i
     *                                    // ]
     *
     * See also:
     *
     *    square, sqrt, cube
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x
     *            Value for which to calculate the cubic root.
     * @param {boolean} [allRoots]  Optional, false by default. Only applicable
     *            when `x` is a number or complex number. If true, all complex
     *            roots are returned, if false (default) the principal root is
     *            returned.
     * @return {number | BigNumber | Complex | Unit | Array | Matrix}
     *            Returns the cubic root of `x`
     */
    var cbrt = typed('cbrt', {
      'number': _cbrtNumber,
      // note: signature 'number, boolean' is also supported,
      //       created by typed as it knows how to convert number to Complex

      'Complex': _cbrtComplex,

      'Complex, boolean': _cbrtComplex,

      'BigNumber': function (x) {
        return x.cbrt();
      },

      'Unit': _cbrtUnit,

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since cbrt(0) = 0
        return deepMap(x, cbrt, true);
      }
    });

    /**
     * Calculate the cubic root for a complex number
     * @param {Complex} x
     * @param {boolean} [allRoots]   If true, the function will return an array
     *                               with all three roots. If false or undefined,
     *                               the principal root is returned.
     * @returns {Complex | Array.<Complex> | Matrix.<Complex>} Returns the cubic root(s) of x
     * @private
     */
    function _cbrtComplex(x, allRoots) {
      // https://www.wikiwand.com/en/Cube_root#/Complex_numbers

      var arg_3 = x.arg() / 3;
      var abs = x.abs();

      // principal root:
      var principal = new type.Complex(_cbrtNumber(abs), 0).mul(
          new type.Complex(0, arg_3).exp());

      if (allRoots) {
        var all = [
            principal,
            new type.Complex(_cbrtNumber(abs), 0).mul(
              new type.Complex(0, arg_3 + Math.PI * 2 / 3).exp()),
            new type.Complex(_cbrtNumber(abs), 0).mul(
              new type.Complex(0, arg_3 - Math.PI * 2 / 3).exp())
        ];

        return (config.matrix === 'Array') ? all : matrix$$1(all);
      }
      else {
        return principal;
      }
    }

    /**
     * Calculate the cubic root for a Unit
     * @param {Unit} x
     * @return {Unit} Returns the cubic root of x
     * @private
     */
    function _cbrtUnit(x) {
      if(x.value && type.isComplex(x.value)) {
        var result = x.clone();
        result.value = 1.0;
        result = result.pow(1.0/3);           // Compute the units
        result.value = _cbrtComplex(x.value); // Compute the value
        return result;
      }
      else {
        var negate = isNegative(x.value);
        if (negate) {
          x.value = unaryMinus(x.value);
        }

        // TODO: create a helper function for this
        var third;
        if (type.isBigNumber(x.value)) {
          third = new type.BigNumber(1).div(3);
        }
        else if (type.isFraction(x.value)) {
          third = new type.Fraction(1, 3);
        }
        else {
          third = 1/3;
        }

        var result = x.pow(third);

        if (negate) {
          result.value = unaryMinus(result.value);
        }

        return result;
      }
    }

    cbrt.toTex = {1: '\\sqrt[3]{${args[0]}}'};

    return cbrt;
  }

  /**
   * Calculate cbrt for a number
   *
   * Code from es6-shim.js:
   *   https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1564-L1577
   *
   * @param {number} x
   * @returns {number | Complex} Returns the cubic root of x
   * @private
   */
  var _cbrtNumber = Math.cbrt || function (x) {
    if (x === 0) {
      return x;
    }

    var negate = x < 0;
    var result;
    if (negate) {
      x = -x;
    }

    if (isFinite(x)) {
      result = Math.exp(Math.log(x) / 3);
      // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
      result = (x / (result * result) + (2 * result)) / 3;
    } else {
      result = x;
    }

    return negate ? -result : result;
  };

  var name$132 = 'cbrt';
  var factory_1$143 = factory$144;

  var cbrt$1 = {
  	name: name$132,
  	factory: factory_1$143
  };

  function factory$145 (type, config, load, typed) {
    /**
     * Round a value towards plus infinity
     * If `x` is complex, both real and imaginary part are rounded towards plus infinity.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.ceil(x)
     *
     * Examples:
     *
     *    math.ceil(3.2);               // returns number 4
     *    math.ceil(3.8);               // returns number 4
     *    math.ceil(-4.2);              // returns number -4
     *    math.ceil(-4.7);              // returns number -4
     *
     *    var c = math.complex(3.2, -2.7);
     *    math.ceil(c);                 // returns Complex 4 - 2i
     *
     *    math.ceil([3.2, 3.8, -4.7]);  // returns Array [4, 4, -4]
     *
     * See also:
     *
     *    floor, fix, round
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
     */
    var ceil = typed('ceil', {
      'number': Math.ceil,

      'Complex': function (x) {
        return x.ceil();
      },

      'BigNumber': function (x) {
        return x.ceil();
      },

      'Fraction': function (x) {
        return x.ceil();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since ceil(0) = 0
        return deepMap(x, ceil, true);
      }
    });

    ceil.toTex = {1: '\\left\\lceil${args[0]}\\right\\rceil'};

    return ceil;
  }

  var name$133 = 'ceil';
  var factory_1$144 = factory$145;

  var ceil$1 = {
  	name: name$133,
  	factory: factory_1$144
  };

  function factory$146 (type, config, load, typed) {

    /**
     * Compute the cube of a value, `x * x * x`.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.cube(x)
     *
     * Examples:
     *
     *    math.cube(2);            // returns number 8
     *    math.pow(2, 3);          // returns number 8
     *    math.cube(4);            // returns number 64
     *    4 * 4 * 4;               // returns number 64
     *
     *    math.cube([1, 2, 3, 4]); // returns Array [1, 8, 27, 64]
     *
     * See also:
     *
     *    multiply, square, pow, cbrt
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x  Number for which to calculate the cube
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} Cube of x
     */
    var cube = typed('cube', {
      'number': function (x) {
        return x * x * x;
      },

      'Complex': function (x) {
        return x.mul(x).mul(x); // Is faster than pow(x, 3)
      },

      'BigNumber': function (x) {
        return x.times(x).times(x);
      },

      'Fraction': function (x) {
        return x.pow(3); // Is faster than mul()mul()mul()
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since cube(0) = 0
        return deepMap(x, cube, true);
      },

      'Unit': function(x) {
        return x.pow(3);
      }
    });

    cube.toTex = {1: '\\left(${args[0]}\\right)^3'};

    return cube;
  }

  var name$134 = 'cube';
  var factory_1$145 = factory$146;

  var cube$1 = {
  	name: name$134,
  	factory: factory_1$145
  };

  function factory$147 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix nonzero items and invokes the callback function f(Dij, Sij). 
     * Callback function invoked NNZ times (number of nonzero items in SparseMatrix).
     *
     *
     *          ┌  f(Dij, Sij)  ; S(i,j) !== 0
     * C(i,j) = ┤
     *          └  0            ; otherwise
     *
     *
     * @param {Matrix}   denseMatrix       The DenseMatrix instance (D)
     * @param {Matrix}   sparseMatrix      The SparseMatrix instance (S)
     * @param {Function} callback          The f(Dij,Sij) operation to invoke, where Dij = DenseMatrix(i,j) and Sij = SparseMatrix(i,j)
     * @param {boolean}  inverse           A true value indicates callback should be invoked f(Sij,Dij)
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97477571
     */
    var algorithm02 = function (denseMatrix, sparseMatrix, callback, inverse) {
      // dense matrix arrays
      var adata = denseMatrix._data;
      var asize = denseMatrix._size;
      var adt = denseMatrix._datatype;
      // sparse matrix arrays
      var bvalues = sparseMatrix._values;
      var bindex = sparseMatrix._index;
      var bptr = sparseMatrix._ptr;
      var bsize = sparseMatrix._size;
      var bdt = sparseMatrix._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // sparse matrix cannot be a Pattern matrix
      if (!bvalues)
        throw new Error('Cannot perform operation on Dense Matrix and Pattern Sparse Matrix');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];
      
      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result (SparseMatrix)
      var cvalues = [];
      var cindex = [];
      var cptr = [];

      // loop columns in b
      for (var j = 0; j < columns; j++) {
        // update cptr
        cptr[j] = cindex.length;
        // values in column j
        for (var k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
          // row
          var i = bindex[k];
          // update C(i,j)
          var cij = inverse ? cf(bvalues[k], adata[i][j]) : cf(adata[i][j], bvalues[k]);
          // check for nonzero
          if (!eq(cij, zero)) {
            // push i & v
            cindex.push(i);
            cvalues.push(cij);
          }
        }
      }
      // update cptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });
    };
    
    return algorithm02;
  }

  var name$135 = 'algorithm02';
  var factory_1$146 = factory$147;

  var algorithm02 = {
  	name: name$135,
  	factory: factory_1$146
  };

  function factory$148 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var divideScalar$$1 = load(divideScalar);
    var latex$$1 = latex;
    
    var algorithm02$$1 = load(algorithm02);
    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm11$$1 = load(algorithm11);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Divide two matrices element wise. The function accepts both matrices and
     * scalar values.
     *
     * Syntax:
     *
     *    math.dotDivide(x, y)
     *
     * Examples:
     *
     *    math.dotDivide(2, 4);   // returns 0.5
     *
     *    a = [[9, 5], [6, 1]];
     *    b = [[3, 2], [5, 2]];
     *
     *    math.dotDivide(a, b);   // returns [[3, 2.5], [1.2, 0.5]]
     *    math.divide(a, b);      // returns [[1.75, 0.75], [-1.75, 2.25]]
     *
     * See also:
     *
     *    divide, multiply, dotMultiply
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Numerator
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Denominator
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Quotient, `x ./ y`
     */
    var dotDivide = typed('dotDivide', {
      
      'any, any': divideScalar$$1,

      'SparseMatrix, SparseMatrix': function (x, y) {
        return algorithm07$$1(x, y, divideScalar$$1, false);
      },

      'SparseMatrix, DenseMatrix': function (x, y) {
        return algorithm02$$1(y, x, divideScalar$$1, true);
      },

      'DenseMatrix, SparseMatrix': function (x, y) {
        return algorithm03$$1(x, y, divideScalar$$1, false);
      },

      'DenseMatrix, DenseMatrix': function (x, y) {
        return algorithm13$$1(x, y, divideScalar$$1);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return dotDivide(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return dotDivide(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return dotDivide(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, divideScalar$$1, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, divideScalar$$1, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, divideScalar$$1, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, divideScalar$$1, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, divideScalar$$1, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, divideScalar$$1, true).valueOf();
      }
    });

    dotDivide.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['dotDivide'] + '${args[1]}\\right)'
    };
    
    return dotDivide;
  }

  var name$136 = 'dotDivide';
  var factory_1$147 = factory$148;

  var dotDivide$1 = {
  	name: name$136,
  	factory: factory_1$147
  };

  function factory$149 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix A and invokes the callback function f(Aij, Bij). 
     * Callback function invoked NZA times, number of nonzero elements in A.
     *
     *
     *          ┌  f(Aij, Bij)  ; A(i,j) !== 0
     * C(i,j) = ┤  
     *          └  0            ; otherwise
     *
     *
     * @param {Matrix}   a                 The SparseMatrix instance (A)
     * @param {Matrix}   b                 The SparseMatrix instance (B)
     * @param {Function} callback          The f(Aij,Bij) operation to invoke
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
     */
    var algorithm09 = function (a, b, callback) {
      // sparse matrix arrays
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      var adt = a._datatype;
      // sparse matrix arrays
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      var bsize = b._size;
      var bdt = b._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cvalues = avalues && bvalues ? [] : undefined;
      var cindex = [];
      var cptr = [];
      // matrix
      var c = new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });

      // workspaces
      var x = cvalues ? [] : undefined;
      // marks indicating we have a value in x for a given column
      var w = [];

      // vars
      var i, j, k, k0, k1;
      
      // loop columns
      for (j = 0; j < columns; j++) {
        // update cptr
        cptr[j] = cindex.length;
        // column mark
        var mark = j + 1;
        // check we need to process values
        if (x) {
          // loop B(:,j)
          for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
            // row
            i = bindex[k];
            // update workspace
            w[i] = mark;
            x[i] = bvalues[k];
          }
        }
        // loop A(:,j)
        for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
          // row
          i = aindex[k];
          // check we need to process values
          if (x) {
            // b value @ i,j
            var vb = w[i] === mark ? x[i] : zero;
            // invoke f
            var vc = cf(avalues[k], vb);
            // check zero value
            if (!eq(vc, zero)) {
              // push index
              cindex.push(i);
              // push value
              cvalues.push(vc);
            }
          }
          else {
            // push index
            cindex.push(i);
          }
        }
      }
      // update cptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return c;
    };

    return algorithm09;
  }

  var name$137 = 'algorithm09';
  var factory_1$148 = factory$149;

  var algorithm09 = {
  	name: name$137,
  	factory: factory_1$148
  };

  function factory$150 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var multiplyScalar$$1 = load(multiplyScalar);
    var latex$$1 = latex;

    var algorithm02$$1 = load(algorithm02);
    var algorithm09$$1 = load(algorithm09);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Multiply two matrices element wise. The function accepts both matrices and
     * scalar values.
     *
     * Syntax:
     *
     *    math.dotMultiply(x, y)
     *
     * Examples:
     *
     *    math.dotMultiply(2, 4); // returns 8
     *
     *    a = [[9, 5], [6, 1]];
     *    b = [[3, 2], [5, 2]];
     *
     *    math.dotMultiply(a, b); // returns [[27, 10], [30, 2]]
     *    math.multiply(a, b);    // returns [[52, 28], [23, 14]]
     *
     * See also:
     *
     *    multiply, divide, dotDivide
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x Left hand value
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Right hand value
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}                    Multiplication of `x` and `y`
     */
    var dotMultiply = typed('dotMultiply', {
      
      'any, any': multiplyScalar$$1,

      'SparseMatrix, SparseMatrix': function (x, y) {
        return algorithm09$$1(x, y, multiplyScalar$$1, false);
      },

      'SparseMatrix, DenseMatrix': function (x, y) {
        return algorithm02$$1(y, x, multiplyScalar$$1, true);
      },

      'DenseMatrix, SparseMatrix': function (x, y) {
        return algorithm02$$1(x, y, multiplyScalar$$1, false);
      },

      'DenseMatrix, DenseMatrix': function (x, y) {
        return algorithm13$$1(x, y, multiplyScalar$$1);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return dotMultiply(matrix$$1(x), matrix$$1(y)).valueOf();
      },
      
      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return dotMultiply(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return dotMultiply(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, multiplyScalar$$1, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, multiplyScalar$$1, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm11$$1(y, x, multiplyScalar$$1, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, multiplyScalar$$1, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, multiplyScalar$$1, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, multiplyScalar$$1, true).valueOf();
      }
    });

    dotMultiply.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['dotMultiply'] + '${args[1]}\\right)'
    };
    
    return dotMultiply;
  }

  var name$138 = 'dotMultiply';
  var factory_1$149 = factory$150;

  var dotMultiply$1 = {
  	name: name$138,
  	factory: factory_1$149
  };

  function factory$151 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var pow = load(pow$1);
    var latex$$1 = latex;

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm11$$1 = load(algorithm11);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Calculates the power of x to y element wise.
     *
     * Syntax:
     *
     *    math.dotPow(x, y)
     *
     * Examples:
     *
     *    math.dotPow(2, 3);            // returns number 8
     *
     *    var a = [[1, 2], [4, 3]];
     *    math.dotPow(a, 2);            // returns Array [[1, 4], [16, 9]]
     *    math.pow(a, 2);               // returns Array [[9, 8], [16, 17]]
     *
     * See also:
     *
     *    pow, sqrt, multiply
     *
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x  The base
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y  The exponent
     * @return {number | BigNumber | Complex | Unit | Array | Matrix}                     The value of `x` to the power `y`
     */
    var dotPow = typed('dotPow', {
      
      'any, any': pow,

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, pow, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, pow, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, pow, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, pow);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return dotPow(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return dotPow(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return dotPow(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, dotPow, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, dotPow, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, dotPow, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, dotPow, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, dotPow, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, dotPow, true).valueOf();
      }
    });

    dotPow.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['dotPow'] + '${args[1]}\\right)'
    };
    
    return dotPow;
  }

  var name$139 = 'dotPow';
  var factory_1$150 = factory$151;

  var dotPow$1 = {
  	name: name$139,
  	factory: factory_1$150
  };

  function factory$152 (type, config, load, typed) {
    /**
     * Calculate the exponent of a value.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.exp(x)
     *
     * Examples:
     *
     *    math.exp(2);                  // returns number 7.3890560989306495
     *    math.pow(math.e, 2);          // returns number 7.3890560989306495
     *    math.log(math.exp(2));        // returns number 2
     *
     *    math.exp([1, 2, 3]);
     *    // returns Array [
     *    //   2.718281828459045,
     *    //   7.3890560989306495,
     *    //   20.085536923187668
     *    // ]
     *
     * See also:
     *
     *    expm1, log, pow
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to exponentiate
     * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
     */
    var exp = typed('exp', {
      'number': Math.exp,

      'Complex': function (x) {
        return x.exp();
      },

      'BigNumber': function (x) {
        return x.exp();
      },

      'Array | Matrix': function (x) {
        // TODO: exp(sparse) should return a dense matrix since exp(0)==1
        return deepMap(x, exp);
      }
    });

    exp.toTex = {1: '\\exp\\left(${args[0]}\\right)'};

    return exp;
  }

  var name$140 = 'exp';
  var factory_1$151 = factory$152;

  var exp$1 = {
  	name: name$140,
  	factory: factory_1$151
  };

  function factory$153 (type, config, load, typed) {
    var latex$$1 = latex;

    /**
     * Calculate the value of subtracting 1 from the exponential value.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.expm1(x)
     *
     * Examples:
     *
     *    math.expm1(2);                      // returns number 6.38905609893065
     *    math.pow(math.e, 2) - 1;            // returns number 6.3890560989306495
     *    math.log(math.expm1(2) + 1);        // returns number 2
     *
     *    math.expm1([1, 2, 3]);
     *    // returns Array [
     *    //   1.718281828459045,
     *    //   6.3890560989306495,
     *    //   19.085536923187668
     *    // ]
     *
     * See also:
     *
     *    exp, log, pow
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x  A number or matrix to apply expm1
     * @return {number | BigNumber | Complex | Array | Matrix} Exponent of `x`
     */
    var expm1 = typed('expm1', {
      'number': Math.expm1 || _expm1,

      'Complex': function (x) {
        var r = Math.exp(x.re);
        return new type.Complex(
            r * Math.cos(x.im) - 1,
            r * Math.sin(x.im)
        );
      },

      'BigNumber': function (x) {
        return x.exp().minus(1);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, expm1);
      }
    });

    /**
     * Calculates exponentiation minus 1.
     * @param {number} x
     * @return {number} res
     * @private
     */
    function _expm1(x) {
      return (x >= 2e-4 || x <= -2e-4)
        ? Math.exp(x) - 1
        : x + x*x/2 + x*x*x/6;
    }

    expm1.toTex = '\\left(e' + latex$$1.operators['pow'] + '{${args[0]}}-1\\right)';

    return expm1;
  }

  var name$141 = 'expm1';
  var factory_1$152 = factory$153;

  var expm1$1 = {
  	name: name$141,
  	factory: factory_1$152
  };

  function factory$154 (type, config, load, typed) {
    /**
     * Round a value towards zero.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.fix(x)
     *
     * Examples:
     *
     *    math.fix(3.2);                // returns number 3
     *    math.fix(3.8);                // returns number 3
     *    math.fix(-4.2);               // returns number -4
     *    math.fix(-4.7);               // returns number -4
     *
     *    var c = math.complex(3.2, -2.7);
     *    math.fix(c);                  // returns Complex 3 - 2i
     *
     *    math.fix([3.2, 3.8, -4.7]);   // returns Array [3, 3, -4]
     *
     * See also:
     *
     *    ceil, floor, round
     *
     * @param {number | BigNumber | Fraction | Complex | Array | Matrix} x Number to be rounded
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix}            Rounded value
     */
    var fix = typed('fix', {
      'number': function (x) {
        return (x > 0) ? Math.floor(x) : Math.ceil(x);
      },

      'Complex': function (x) {
        return new type.Complex(
            (x.re > 0) ? Math.floor(x.re) : Math.ceil(x.re),
            (x.im > 0) ? Math.floor(x.im) : Math.ceil(x.im)
        );
      },

      'BigNumber': function (x) {
        return x.isNegative() ? x.ceil() : x.floor();
      },

      'Fraction': function (x) {
        return x.s < 0 ? x.ceil() : x.floor();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since fix(0) = 0
        return deepMap(x, fix, true);
      }
    });

    fix.toTex = {1: '\\mathrm{${name}}\\left(${args[0]}\\right)'};

    return fix;
  }

  var name$142 = 'fix';
  var factory_1$153 = factory$154;

  var fix$1 = {
  	name: name$142,
  	factory: factory_1$153
  };

  function factory$155 (type, config, load, typed) {
    /**
     * Round a value towards minus infinity.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.floor(x)
     *
     * Examples:
     *
     *    math.floor(3.2);              // returns number 3
     *    math.floor(3.8);              // returns number 3
     *    math.floor(-4.2);             // returns number -5
     *    math.floor(-4.7);             // returns number -5
     *
     *    var c = math.complex(3.2, -2.7);
     *    math.floor(c);                // returns Complex 3 - 3i
     *
     *    math.floor([3.2, 3.8, -4.7]); // returns Array [3, 3, -5]
     *
     * See also:
     *
     *    ceil, fix, round
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
     */
    var floor = typed('floor', {
      'number': Math.floor,

      'Complex': function (x) {
        return x.floor();
      },

      'BigNumber': function (x) {
        return x.floor();
      },

      'Fraction': function (x) {
        return x.floor();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since floor(0) = 0
        return deepMap(x, floor, true);
      }
    });

    floor.toTex = {1: '\\left\\lfloor${args[0]}\\right\\rfloor'};

    return floor;
  }

  var name$143 = 'floor';
  var factory_1$154 = factory$155;

  var floor$1 = {
  	name: name$143,
  	factory: factory_1$154
  };

  var isInteger$9 = number.isInteger;

  function factory$156 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm01$$1 = load(algorithm01);
    var algorithm04$$1 = load(algorithm04);
    var algorithm10$$1 = load(algorithm10);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Calculate the greatest common divisor for two or more values or arrays.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.gcd(a, b)
     *    math.gcd(a, b, c, ...)
     *
     * Examples:
     *
     *    math.gcd(8, 12);              // returns 4
     *    math.gcd(-4, 6);              // returns 2
     *    math.gcd(25, 15, -10);        // returns 5
     *
     *    math.gcd([8, -4], [12, 6]);   // returns [4, 2]
     *
     * See also:
     *
     *    lcm, xgcd
     *
     * @param {... number | BigNumber | Fraction | Array | Matrix} args  Two or more integer numbers
     * @return {number | BigNumber | Fraction | Array | Matrix}                           The greatest common divisor
     */
    var gcd = typed('gcd', {

      'number, number': _gcd,

      'BigNumber, BigNumber': _gcdBigNumber,

      'Fraction, Fraction': function (x, y) {
        return x.gcd(y);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm04$$1(x, y, gcd);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm01$$1(y, x, gcd, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm01$$1(x, y, gcd, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, gcd);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return gcd(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return gcd(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return gcd(x, matrix$$1(y));
      },
      
      'SparseMatrix, number | BigNumber': function (x, y) {
        return algorithm10$$1(x, y, gcd, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        return algorithm14$$1(x, y, gcd, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        return algorithm10$$1(y, x, gcd, true);
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, gcd, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, gcd, false).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, gcd, true).valueOf();
      },

      // TODO: need a smarter notation here
      'Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber': function (a, b, args) {
        var res = gcd(a, b);
        for (var i = 0; i < args.length; i++) {
          res = gcd(res, args[i]);
        }
        return res;
      }
    });

    gcd.toTex = '\\gcd\\left(${args}\\right)';

    return gcd;

    /**
     * Calculate gcd for BigNumbers
     * @param {BigNumber} a
     * @param {BigNumber} b
     * @returns {BigNumber} Returns greatest common denominator of a and b
     * @private
     */
    function _gcdBigNumber(a, b) {
      if (!a.isInt() || !b.isInt()) {
        throw new Error('Parameters in function gcd must be integer numbers');
      }

      // http://en.wikipedia.org/wiki/Euclidean_algorithm
      var zero = new type.BigNumber(0);
      while (!b.isZero()) {
        var r = a.mod(b);
        a = b;
        b = r;
      }
      return a.lt(zero) ? a.neg() : a;
    }
  }

  /**
   * Calculate gcd for numbers
   * @param {number} a
   * @param {number} b
   * @returns {number} Returns the greatest common denominator of a and b
   * @private
   */
  function _gcd(a, b) {
    if (!isInteger$9(a) || !isInteger$9(b)) {
      throw new Error('Parameters in function gcd must be integer numbers');
    }

    // http://en.wikipedia.org/wiki/Euclidean_algorithm
    var r;
    while (b != 0) {
      r = a % b;
      a = b;
      b = r;
    }
    return (a < 0) ? -a : a;
  }

  var name$144 = 'gcd';
  var factory_1$155 = factory$156;

  var gcd$1 = {
  	name: name$144,
  	factory: factory_1$155
  };

  var flatten$2 = array.flatten;

  function factory$157 (type, config, load, typed) {
    var abs = load(abs$1);
    var add = load(addScalar);
    var divide = load(divideScalar);
    var multiply = load(multiplyScalar);
    var sqrt = load(sqrt$1);
    var smaller$$1 = load(smaller);
    var isPositive = load(isPositive$1);

    /**
     * Calculate the hypotenusa of a list with values. The hypotenusa is defined as:
     *
     *     hypot(a, b, c, ...) = sqrt(a^2 + b^2 + c^2 + ...)
     *
     * For matrix input, the hypotenusa is calculated for all values in the matrix.
     *
     * Syntax:
     *
     *     math.hypot(a, b, ...)
     *     math.hypot([a, b, c, ...])
     *
     * Examples:
     *
     *     math.hypot(3, 4);      // 5
     *     math.hypot(3, 4, 5);   // 7.0710678118654755
     *     math.hypot([3, 4, 5]); // 7.0710678118654755
     *     math.hypot(-2);        // 2
     *
     * See also:
     *
     *     abs, norm
     *
     * @param {... number | BigNumber | Array | Matrix} args    A list with numeric values or an Array or Matrix.
     *                                                          Matrix and Array input is flattened and returns a
     *                                                          single number for the whole matrix.
     * @return {number | BigNumber} Returns the hypothenusa of the input values.
     */
    var hypot = typed('hypot', {
      '... number | BigNumber': _hypot,

      'Array': function (x) {
        return hypot.apply(hypot, flatten$2(x));
      },

      'Matrix': function (x) {
        return hypot.apply(hypot, flatten$2(x.toArray()));
      }
    });

    /**
     * Calculate the hypotenusa for an Array with values
     * @param {Array.<number | BigNumber>} args
     * @return {number | BigNumber} Returns the result
     * @private
     */
    function _hypot (args) {
      // code based on `hypot` from es6-shim:
      // https://github.com/paulmillr/es6-shim/blob/master/es6-shim.js#L1619-L1633
      var result = 0;
      var largest = 0;

      for (var i = 0; i < args.length; i++) {
        var value = abs(args[i]);
        if (smaller$$1(largest, value)) {
          result = multiply(result, multiply(divide(largest, value), divide(largest, value)));
          result = add(result, 1);
          largest = value;
        } else {
          result = add(result, isPositive(value) ? multiply(divide(value, largest), divide(value, largest)) : value);
        }
      }

      return multiply(largest, sqrt(result));
    }

    hypot.toTex = '\\hypot\\left(${args}\\right)';

    return hypot;
  }

  var name$145 = 'hypot';
  var factory_1$156 = factory$157;

  var hypot$1 = {
  	name: name$145,
  	factory: factory_1$156
  };

  var scatter = function scatter(a, j, w, x, u, mark, c, f, inverse, update, value) {
    // a arrays
    var avalues = a._values;
    var aindex = a._index;
    var aptr = a._ptr;
    // c arrays
    var cindex = c._index;

    // vars
    var k, k0, k1, i;

    // check we need to process values (pattern matrix)
    if (x) {
      // values in j
      for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
        // row
        i = aindex[k];
        // check value exists in current j
        if (w[i] !== mark) {
          // i is new entry in j
          w[i] = mark;
          // add i to pattern of C
          cindex.push(i);
          // x(i) = A, check we need to call function this time
          if (update) {
            // copy value to workspace calling callback function
            x[i] = inverse ? f(avalues[k], value) : f(value, avalues[k]);
            // function was called on current row
            u[i] = mark;
          }
          else {
            // copy value to workspace
            x[i] = avalues[k];
          }
        }
        else {
          // i exists in C already
          x[i] = inverse ? f(avalues[k], x[i]) : f(x[i], avalues[k]);
          // function was called on current row
          u[i] = mark;
        }
      }
    }
    else {
      // values in j
      for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
        // row
        i = aindex[k];
        // check value exists in current j
        if (w[i] !== mark) {
          // i is new entry in j
          w[i] = mark;
          // add i to pattern of C
          cindex.push(i);
        }
        else {
          // indicate function was called on current row
          u[i] = mark;
        }
      }
    }
  };

  function factory$158 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
     * Callback function invoked (Anz U Bnz) times, where Anz and Bnz are the nonzero elements in both matrices.
     *
     *
     *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
     * C(i,j) = ┤  
     *          └  0            ; otherwise
     *
     *
     * @param {Matrix}   a                 The SparseMatrix instance (A)
     * @param {Matrix}   b                 The SparseMatrix instance (B)
     * @param {Function} callback          The f(Aij,Bij) operation to invoke
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
     */
    var algorithm06 = function (a, b, callback) {
      // sparse matrix arrays
      var avalues = a._values;
      var asize = a._size;
      var adt = a._datatype;
      // sparse matrix arrays
      var bvalues = b._values;
      var bsize = b._size;
      var bdt = b._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cvalues = avalues && bvalues ? [] : undefined;
      var cindex = [];
      var cptr = [];
      // matrix
      var c = new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });

      // workspaces
      var x = cvalues ? [] : undefined;
      // marks indicating we have a value in x for a given column
      var w = [];
      // marks indicating value in a given row has been updated
      var u = [];

      // loop columns
      for (var j = 0; j < columns; j++) {
        // update cptr
        cptr[j] = cindex.length;
        // columns mark
        var mark = j + 1;
        // scatter the values of A(:,j) into workspace
        scatter(a, j, w, x, u, mark, c, cf);
        // scatter the values of B(:,j) into workspace
        scatter(b, j, w, x, u, mark, c, cf);
        // check we need to process values (non pattern matrix)
        if (x) {
          // initialize first index in j
          var k = cptr[j];
          // loop index in j
          while (k < cindex.length) {
            // row
            var i = cindex[k];
            // check function was invoked on current row (Aij !=0 && Bij != 0)
            if (u[i] === mark) {
              // value @ i
              var v = x[i];
              // check for zero value
              if (!eq(v, zero)) {
                // push value
                cvalues.push(v);
                // increment pointer
                k++;
              }
              else {
                // remove value @ i, do not increment pointer
                cindex.splice(k, 1);
              }
            }
            else {
              // remove value @ i, do not increment pointer
              cindex.splice(k, 1);
            }
          }
        }
        else {
          // initialize first index in j
          var p = cptr[j];
          // loop index in j
          while (p < cindex.length) {
            // row
            var r = cindex[p];
            // check function was invoked on current row (Aij !=0 && Bij != 0)
            if (u[r] !== mark) {
              // remove value @ i, do not increment pointer
              cindex.splice(p, 1);
            }
            else {
              // increment pointer
              p++;
            }
          }
        }
      }
      // update cptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return c;
    };
    
    return algorithm06;
  }

  var name$146 = 'algorithm06';
  var factory_1$157 = factory$158;

  var algorithm06 = {
  	name: name$146,
  	factory: factory_1$157
  };

  var isInteger$10 = number.isInteger;

  function factory$159 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);

    var algorithm02$$1 = load(algorithm02);
    var algorithm06$$1 = load(algorithm06);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Calculate the least common multiple for two or more values or arrays.
     *
     * lcm is defined as:
     *
     *     lcm(a, b) = abs(a * b) / gcd(a, b)
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.lcm(a, b)
     *    math.lcm(a, b, c, ...)
     *
     * Examples:
     *
     *    math.lcm(4, 6);               // returns 12
     *    math.lcm(6, 21);              // returns 42
     *    math.lcm(6, 21, 5);           // returns 210
     *
     *    math.lcm([4, 6], [6, 21]);    // returns [12, 42]
     *
     * See also:
     *
     *    gcd, xgcd
     *
     * @param {... number | BigNumber | Array | Matrix} args  Two or more integer numbers
     * @return {number | BigNumber | Array | Matrix}                           The least common multiple
     */
    var lcm = typed('lcm', {
      'number, number': _lcm,

      'BigNumber, BigNumber': _lcmBigNumber,

      'Fraction, Fraction': function (x, y) {

        return x.lcm(y);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm06$$1(x, y, lcm);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, lcm, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm02$$1(x, y, lcm, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, lcm);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return lcm(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return lcm(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return lcm(x, matrix$$1(y));
      },

      'SparseMatrix, number | BigNumber': function (x, y) {
        return algorithm11$$1(x, y, lcm, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        return algorithm14$$1(x, y, lcm, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        return algorithm11$$1(y, x, lcm, true);
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, lcm, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, lcm, false).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, lcm, true).valueOf();
      },

      // TODO: need a smarter notation here
      'Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber': function (a, b, args) {
        var res = lcm(a, b);
        for (var i = 0; i < args.length; i++) {
          res = lcm(res, args[i]);
        }
        return res;
      }
    });

    lcm.toTex = undefined;  // use default template

    return lcm;

    /**
     * Calculate lcm for two BigNumbers
     * @param {BigNumber} a
     * @param {BigNumber} b
     * @returns {BigNumber} Returns the least common multiple of a and b
     * @private
     */
    function _lcmBigNumber(a, b) {
      if (!a.isInt() || !b.isInt()) {
        throw new Error('Parameters in function lcm must be integer numbers');
      }

      if (a.isZero() || b.isZero()) {
        return new type.BigNumber(0);
      }

      // http://en.wikipedia.org/wiki/Euclidean_algorithm
      // evaluate lcm here inline to reduce overhead
      var prod = a.times(b);
      while (!b.isZero()) {
        var t = b;
        b = a.mod(t);
        a = t;
      }
      return prod.div(a).abs();
    }
  }

  /**
   * Calculate lcm for two numbers
   * @param {number} a
   * @param {number} b
   * @returns {number} Returns the least common multiple of a and b
   * @private
   */
  function _lcm (a, b) {
    if (!isInteger$10(a) || !isInteger$10(b)) {
      throw new Error('Parameters in function lcm must be integer numbers');
    }

    if (a == 0 || b == 0) {
      return 0;
    }

    // http://en.wikipedia.org/wiki/Euclidean_algorithm
    // evaluate lcm here inline to reduce overhead
    var t;
    var prod = a * b;
    while (b != 0) {
      t = b;
      b = a % t;
      a = t;
    }
    return Math.abs(prod / a);
  }

  var name$147 = 'lcm';
  var factory_1$158 = factory$159;

  var lcm$1 = {
  	name: name$147,
  	factory: factory_1$158
  };

  function factory$160 (type, config, load, typed) {
    var divideScalar$$1 = load(divideScalar);

    /**
     * Calculate the logarithm of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.log(x)
     *    math.log(x, base)
     *
     * Examples:
     *
     *    math.log(3.5);                  // returns 1.252762968495368
     *    math.exp(math.log(2.4));        // returns 2.4
     *
     *    math.pow(10, 4);                // returns 10000
     *    math.log(10000, 10);            // returns 4
     *    math.log(10000) / math.log(10); // returns 4
     *
     *    math.log(1024, 2);              // returns 10
     *    math.pow(2, 10);                // returns 1024
     *
     * See also:
     *
     *    exp, log2, log10, log1p
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            Value for which to calculate the logarithm.
     * @param {number | BigNumber | Complex} [base=e]
     *            Optional base for the logarithm. If not provided, the natural
     *            logarithm of `x` is calculated.
     * @return {number | BigNumber | Complex | Array | Matrix}
     *            Returns the logarithm of `x`
     */
    var log = typed('log', {
      'number': function (x) {
        if (x >= 0 || config.predictable) {
          return Math.log(x);
        }
        else {
          // negative value -> complex value computation
          return new type.Complex(x, 0).log();
        }
      },

      'Complex': function (x) {
        return x.log();
      },

      'BigNumber': function (x) {
        if (!x.isNegative() || config.predictable) {
          return x.ln();
        }
        else {
          // downgrade to number, return Complex valued result
          return new type.Complex(x.toNumber(), 0).log();
        }
      },

      'Array | Matrix': function (x) {
        return deepMap(x, log);
      },

      'any, any': function (x, base) {
        // calculate logarithm for a specified base, log(x, base)
        return divideScalar$$1(log(x), log(base));
      }
    });

    log.toTex = {
      1: '\\ln\\left(${args[0]}\\right)',
      2: '\\log_{${args[1]}}\\left(${args[0]}\\right)'
    };

    return log;
  }

  var name$148 = 'log';
  var factory_1$159 = factory$160;

  var log$1 = {
  	name: name$148,
  	factory: factory_1$159
  };

  function factory$161 (type, config, load, typed) {
    /**
     * Calculate the 10-base logarithm of a value. This is the same as calculating `log(x, 10)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.log10(x)
     *
     * Examples:
     *
     *    math.log10(0.00001);            // returns -5
     *    math.log10(10000);              // returns 4
     *    math.log(10000) / math.log(10); // returns 4
     *    math.pow(10, 4);                // returns 10000
     *
     * See also:
     *
     *    exp, log, log1p, log2
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            Value for which to calculate the logarithm.
     * @return {number | BigNumber | Complex | Array | Matrix}
     *            Returns the 10-base logarithm of `x`
     */
    var log10 = typed('log10', {
      'number': function (x) {
        if (x >= 0 || config.predictable) {
          return _log10(x);
        }
        else {
          // negative value -> complex value computation
          return new type.Complex(x, 0).log().div(Math.LN10);
        }
      },

      'Complex': function (x) {
        return new type.Complex(x).log().div(Math.LN10);
      },

      'BigNumber': function (x) {
        if (!x.isNegative() || config.predictable) {
          return x.log();
        }
        else {
          // downgrade to number, return Complex valued result
          return new type.Complex(x.toNumber(), 0).log().div(Math.LN10);
        }
      },

      'Array | Matrix': function (x) {
        return deepMap(x, log10);
      }
    });

    log10.toTex = {1: '\\log_{10}\\left(${args[0]}\\right)'};

    return log10;
  }

  /**
   * Calculate the 10-base logarithm of a number
   * @param {number} x
   * @return {number}
   * @private
   */
  var _log10 = Math.log10 || function (x) {
    return Math.log(x) / Math.LN10;
  };

  var name$149 = 'log10';
  var factory_1$160 = factory$161;

  var log10$1 = {
  	name: name$149,
  	factory: factory_1$160
  };

  function factory$162 (type, config, load, typed) {
    var divideScalar$$1 = load(divideScalar);
    var log = load(log$1);

    /**
     * Calculate the logarithm of a `value+1`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.log1p(x)
     *    math.log1p(x, base)
     *
     * Examples:
     *
     *    math.log1p(2.5);                 // returns 1.252762968495368
     *    math.exp(math.log1p(1.4));       // returns 2.4
     *
     *    math.pow(10, 4);                 // returns 10000
     *    math.log1p(9999, 10);            // returns 4
     *    math.log1p(9999) / math.log(10); // returns 4
     *
     * See also:
     *
     *    exp, log, log2, log10
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            Value for which to calculate the logarithm of `x+1`.
     * @param {number | BigNumber | Complex} [base=e]
     *            Optional base for the logarithm. If not provided, the natural
     *            logarithm of `x+1` is calculated.
     * @return {number | BigNumber | Complex | Array | Matrix}
     *            Returns the logarithm of `x+1`
     */
    var log1p = typed('log1p', {
      'number': _log1pNumber,

      'Complex': _log1pComplex,

      'BigNumber': function (x) {
        var y = x.plus(1);
        if (!y.isNegative() || config.predictable) {
          return y.ln();
        }
        else {
          // downgrade to number, return Complex valued result
          return _log1pComplex(new type.Complex(x.toNumber(), 0));
        }
      },

      'Array | Matrix': function (x) {
        return deepMap(x, log1p);
      },

      'any, any': function (x, base) {
        // calculate logarithm for a specified base, log1p(x, base)
        return divideScalar$$1(log1p(x), log(base));
      }
    });

    /**
     * Calculate the natural logarithm of a `number+1`
     * @param {number} x
     * @returns {number | Complex}
     * @private
     */
    function _log1pNumber(x) {
      if (x >= -1 || config.predictable) {
        return (Math.log1p) ? Math.log1p(x) : Math.log(x+1);
      }
      else {
        // negative value -> complex value computation
        return _log1pComplex(new type.Complex(x, 0));
      }
    }

    /**
     * Calculate the natural logarithm of a complex number + 1
     * @param {Complex} x
     * @returns {Complex}
     * @private
     */
    function _log1pComplex(x) {
      var x_re1p = x.re + 1;
      return new type.Complex (
          Math.log(Math.sqrt(x_re1p * x_re1p + x.im * x.im)),
          Math.atan2(x.im, x_re1p)
      );
    }

    log1p.toTex = {
      1: '\\ln\\left(${args[0]}+1\\right)',
      2: '\\log_{${args[1]}}\\left(${args[0]}+1\\right)'
    };

    return log1p;
  }

  var name$150 = 'log1p';
  var factory_1$161 = factory$162;

  var log1p$1 = {
  	name: name$150,
  	factory: factory_1$161
  };

  function factory$163 (type, config, load, typed) {
    /**
     * Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.log2(x)
     *
     * Examples:
     *
     *    math.log2(0.03125);           // returns -5
     *    math.log2(16);                // returns 4
     *    math.log2(16) / math.log2(2); // returns 4
     *    math.pow(2, 4);               // returns 16
     *
     * See also:
     *
     *    exp, log, log1p, log10
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            Value for which to calculate the logarithm.
     * @return {number | BigNumber | Complex | Array | Matrix}
     *            Returns the 2-base logarithm of `x`
     */
    var log2 = typed('log2', {
      'number': function (x) {
        if (x >= 0 || config.predictable) {
          return (Math.log2)
            ? Math.log2(x)
            : Math.log(x) / Math.LN2;
        }
        else {
          // negative value -> complex value computation
          return _log2Complex(new type.Complex(x, 0));
        }
      },

      'Complex': _log2Complex,

      'BigNumber': function (x) {
        if (!x.isNegative() || config.predictable) {
          return x.log(2);
        }
        else {
          // downgrade to number, return Complex valued result
          return _log2Complex(new type.Complex(x.toNumber(), 0));
        }
      },

      'Array | Matrix': function (x) {
        return deepMap(x, log2);
      }
    });

    /**
     * Calculate log2 for a complex value
     * @param {Complex} x
     * @returns {Complex}
     * @private
     */
    function _log2Complex(x) {
      var newX = Math.sqrt(x.re * x.re + x.im * x.im);
      return new type.Complex (
          (Math.log2) ? Math.log2(newX) : Math.log(newX) / Math.LN2,
          Math.atan2(x.im, x.re) / Math.LN2
      );
    }

    log2.toTex = '\\log_{2}\\left(${args[0]}\\right)';

    return log2;

  }

  var name$151 = 'log2';
  var factory_1$162 = factory$163;

  var log2$1 = {
  	name: name$151,
  	factory: factory_1$162
  };

  function factory$164 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var latex$$1 = latex;

    var algorithm02$$1 = load(algorithm02);
    var algorithm03$$1 = load(algorithm03);
    var algorithm05$$1 = load(algorithm05);
    var algorithm11$$1 = load(algorithm11);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Calculates the modulus, the remainder of an integer division.
     *
     * For matrices, the function is evaluated element wise.
     *
     * The modulus is defined as:
     *
     *     x - y * floor(x / y)
     *
     * See http://en.wikipedia.org/wiki/Modulo_operation.
     *
     * Syntax:
     *
     *    math.mod(x, y)
     *
     * Examples:
     *
     *    math.mod(8, 3);                // returns 2
     *    math.mod(11, 2);               // returns 1
     *
     *    function isOdd(x) {
     *      return math.mod(x, 2) != 0;
     *    }
     *
     *    isOdd(2);                      // returns false
     *    isOdd(3);                      // returns true
     *
     * See also:
     *
     *    divide
     *
     * @param  {number | BigNumber | Fraction | Array | Matrix} x Dividend
     * @param  {number | BigNumber | Fraction | Array | Matrix} y Divisor
     * @return {number | BigNumber | Fraction | Array | Matrix} Returns the remainder of `x` divided by `y`.
     */
    var mod = typed('mod', {

      'number, number': _mod,

      'BigNumber, BigNumber': function (x, y) {
        return y.isZero() ? x : x.mod(y);
      },

      'Fraction, Fraction': function (x, y) {
        return x.mod(y);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm05$$1(x, y, mod, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, mod, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, mod, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, mod);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return mod(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return mod(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return mod(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, mod, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, mod, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, mod, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, mod, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, mod, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, mod, true).valueOf();
      }
    });

    mod.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['mod'] + '${args[1]}\\right)'
    };

    return mod;

    /**
     * Calculate the modulus of two numbers
     * @param {number} x
     * @param {number} y
     * @returns {number} res
     * @private
     */
    function _mod(x, y) {
      if (y > 0) {
        // We don't use JavaScript's % operator here as this doesn't work
        // correctly for x < 0 and x == 0
        // see http://en.wikipedia.org/wiki/Modulo_operation
        return x - y * Math.floor(x / y);
      }
      else if (y === 0) {
        return x;
      }
      else { // y < 0
        // TODO: implement mod for a negative divisor
        throw new Error('Cannot calculate mod for a negative divisor');
      }
    }
  }

  var name$152 = 'mod';
  var factory_1$163 = factory$164;

  var mod$1 = {
  	name: name$152,
  	factory: factory_1$163
  };

  var clone$7 = object.clone;
  var format$5 = string.format;

  function factory$165 (type, config, load, typed) {
    
    var matrix$$1 = load(matrix);
    var add$$1 = load(add);

    /**
     * Calculate the trace of a matrix: the sum of the elements on the main
     * diagonal of a square matrix.
     *
     * Syntax:
     *
     *    math.trace(x)
     *
     * Examples:
     *
     *    math.trace([[1, 2], [3, 4]]); // returns 5
     *
     *    var A = [
     *      [1, 2, 3],
     *      [-1, 2, 3],
     *      [2, 0, 3]
     *    ]
     *    math.trace(A); // returns 6
     *
     * See also:
     *
     *    diag
     *
     * @param {Array | Matrix} x  A matrix
     *
     * @return {number} The trace of `x`
     */
    var trace = typed('trace', {
      
      'Array': function _arrayTrace(x) {
        // use dense matrix implementation
        return _denseTrace(matrix$$1(x));
      },

      'SparseMatrix': _sparseTrace,

      'DenseMatrix': _denseTrace,

      'any': clone$7
    });
    
    function _denseTrace(m) {
      // matrix size & data
      var size = m._size;
      var data = m._data;
      
      // process dimensions
      switch (size.length) {
        case 1:
          // vector
          if (size[0] === 1) {
            // return data[0]
            return clone$7(data[0]);
          }
          throw new RangeError('Matrix must be square (size: ' + format$5(size) + ')');
        case 2:
          // two dimensional
          var rows = size[0];
          var cols = size[1];
          if (rows === cols) {
            // calulate sum
            var sum = 0;
            // loop diagonal
            for (var i = 0; i < rows; i++)
              sum = add$$1(sum, data[i][i]);
            // return trace
            return sum;
          }
          throw new RangeError('Matrix must be square (size: ' + format$5(size) + ')');        
        default:
          // multi dimensional
          throw new RangeError('Matrix must be two dimensional (size: ' + format$5(size) + ')');
      }
    }
    
    function _sparseTrace(m) {
      // matrix arrays
      var values = m._values;
      var index = m._index;
      var ptr = m._ptr;
      var size = m._size;
      // check dimensions
      var rows = size[0];
      var columns = size[1];
      // matrix must be square
      if (rows === columns) {
        // calulate sum
        var sum = 0;
        // check we have data (avoid looping columns)
        if (values.length > 0) {
          // loop columns
          for (var j = 0; j < columns; j++) {
            // k0 <= k < k1 where k0 = _ptr[j] && k1 = _ptr[j+1]
            var k0 = ptr[j];
            var k1 = ptr[j + 1];
            // loop k within [k0, k1[
            for (var k = k0; k < k1; k++) {
              // row index
              var i = index[k];
              // check row
              if (i === j) {
                // accumulate value
                sum = add$$1(sum, values[k]);
                // exit loop
                break;
              }
              if (i > j) {
                // exit loop, no value on the diagonal for column j
                break;
              }
            }
          }
        }
        // return trace
        return sum;
      }
      throw new RangeError('Matrix must be square (size: ' + format$5(size) + ')');   
    }

    trace.toTex = {1: '\\mathrm{tr}\\left(${args[0]}\\right)'};
    
    return trace;
  }

  var name$153 = 'trace';
  var factory_1$164 = factory$165;

  var trace$1 = {
  	name: name$153,
  	factory: factory_1$164
  };

  function factory$166 (type, config, load, typed) {
    
    var abs         = load(abs$1);
    var add$$1         = load(add);
    var pow         = load(pow$1);
    var conj        = load(conj$1);
    var sqrt        = load(sqrt$1);
    var multiply    = load(multiply$1);
    var equalScalar$$1 = load(equalScalar);
    var larger$$1      = load(larger);
    var smaller$$1     = load(smaller);
    var matrix$$1      = load(matrix);
    var trace       = load(trace$1);
    var transpose   = load(transpose$1);


    /**
     * Calculate the norm of a number, vector or matrix.
     *
     * The second parameter p is optional. If not provided, it defaults to 2.
     *
     * Syntax:
     *
     *    math.norm(x)
     *    math.norm(x, p)
     *
     * Examples:
     *
     *    math.abs(-3.5);                         // returns 3.5
     *    math.norm(-3.5);                        // returns 3.5
     *
     *    math.norm(math.complex(3, -4));         // returns 5
     *
     *    math.norm([1, 2, -3], Infinity);        // returns 3
     *    math.norm([1, 2, -3], -Infinity);       // returns 1
     *
     *    math.norm([3, 4], 2);                   // returns 5
     *
     *    math.norm([[1, 2], [3, 4]], 1)          // returns 6
     *    math.norm([[1, 2], [3, 4]], 'inf');     // returns 7
     *    math.norm([[1, 2], [3, 4]], 'fro');     // returns 5.477225575051661
     *
     * See also:
     *
     *    abs, hypot
     *
     * @param  {number | BigNumber | Complex | Array | Matrix} x
     *            Value for which to calculate the norm
     * @param  {number | BigNumber | string} [p=2]
     *            Vector space.
     *            Supported numbers include Infinity and -Infinity.
     *            Supported strings are: 'inf', '-inf', and 'fro' (The Frobenius norm)
     * @return {number | BigNumber} the p-norm
     */
    var norm = typed('norm', {
      'number': Math.abs,

      'Complex': function (x) {
        return x.abs();
      },

      'BigNumber': function (x) {
        // norm(x) = abs(x)
        return x.abs();
      },
      
      'boolean' : function (x) {
        // norm(x) = abs(x)
        return Math.abs(x);
      },

      'Array': function (x) {
        return _norm(matrix$$1(x), 2);
      },
      
      'Matrix': function (x) {
        return _norm(x, 2);
      },

      'number | Complex | BigNumber | boolean, number | BigNumber | string': function (x) {
        // ignore second parameter, TODO: remove the option of second parameter for these types
        return norm(x);
      },

      'Array, number | BigNumber | string': function (x, p) {
        return _norm(matrix$$1(x), p);
      },
      
      'Matrix, number | BigNumber | string': function (x, p) {
        return _norm(x, p);
      }
    });

    /**
     * Calculate the norm for an array
     * @param {Array} x
     * @param {number | string} p
     * @returns {number} Returns the norm
     * @private
     */
    function _norm (x, p) {
      // size
      var sizeX = x.size();
      
      // check if it is a vector
      if (sizeX.length == 1) {
        // check p
        if (p === Number.POSITIVE_INFINITY || p === 'inf') {
          // norm(x, Infinity) = max(abs(x))
          var pinf = 0;
          // skip zeros since abs(0) == 0
          x.forEach(
            function (value) {
              var v = abs(value);
              if (larger$$1(v, pinf))
                pinf = v;
            },
            true);
          return pinf;
        }
        if (p === Number.NEGATIVE_INFINITY || p === '-inf') {
          // norm(x, -Infinity) = min(abs(x))
          var ninf;
          // skip zeros since abs(0) == 0
          x.forEach(
            function (value) {
              var v = abs(value);
              if (!ninf || smaller$$1(v, ninf))
                ninf = v;
            },
            true);
          return ninf || 0;
        }
        if (p === 'fro') {
          return _norm(x, 2);
        }
        if (typeof p === 'number' && !isNaN(p)) {
          // check p != 0
          if (!equalScalar$$1(p, 0)) {
            // norm(x, p) = sum(abs(xi) ^ p) ^ 1/p
            var n = 0;
            // skip zeros since abs(0) == 0
            x.forEach(
              function (value) {
                n = add$$1(pow(abs(value), p), n);
              },
              true);
            return pow(n, 1 / p);
          }
          return Number.POSITIVE_INFINITY;
        }
        // invalid parameter value
        throw new Error('Unsupported parameter value');
      }
      // MxN matrix
      if (sizeX.length == 2) {
        // check p
        if (p === 1) {
          // norm(x) = the largest column sum
          var c = [];
          // result
          var maxc = 0;
          // skip zeros since abs(0) == 0
          x.forEach(
            function (value, index) {
              var j = index[1];
              var cj = add$$1(c[j] || 0, abs(value));
              if (larger$$1(cj, maxc))
                maxc = cj;
              c[j] = cj;
            },
            true);
          return maxc;
        }
        if (p === Number.POSITIVE_INFINITY || p === 'inf') {
          // norm(x) = the largest row sum
          var r = [];
          // result
          var maxr = 0;
          // skip zeros since abs(0) == 0
          x.forEach(
            function (value, index) {
              var i = index[0];
              var ri = add$$1(r[i] || 0, abs(value));
              if (larger$$1(ri, maxr))
                maxr = ri;
              r[i] = ri;
            },
            true);
          return maxr;
        }
        if (p === 'fro') {
          // norm(x) = sqrt(sum(diag(x'x)))
          var fro = 0;
          x.forEach(
            function (value, index) {
              fro = add$$1( fro, multiply( value, conj(value) ) );
            });
          return sqrt(fro);
        }
        if (p === 2) {
          // not implemented
          throw new Error('Unsupported parameter value, missing implementation of matrix singular value decomposition');
        }
        // invalid parameter value
        throw new Error('Unsupported parameter value');
      }
    }

    norm.toTex = {
      1: '\\left\\|${args[0]}\\right\\|',
      2: undefined  // use default template
    };

    return norm;
  }

  var name$154 = 'norm';
  var factory_1$165 = factory$166;

  var norm$1 = {
  	name: name$154,
  	factory: factory_1$165
  };

  function factory$167 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm01$$1 = load(algorithm01);
    var algorithm02$$1 = load(algorithm02);
    var algorithm06$$1 = load(algorithm06);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Calculate the nth root of a value.
     * The principal nth root of a positive real number A, is the positive real
     * solution of the equation
     *
     *     x^root = A
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *     math.nthRoot(a)
     *     math.nthRoot(a, root)
     *
     * Examples:
     *
     *     math.nthRoot(9, 2);    // returns 3, as 3^2 == 9
     *     math.sqrt(9);          // returns 3, as 3^2 == 9
     *     math.nthRoot(64, 3);   // returns 4, as 4^3 == 64
     *
     * See also:
     *
     *     sqrt, pow
     *
     * @param {number | BigNumber | Array | Matrix | Complex} a
     *              Value for which to calculate the nth root
     * @param {number | BigNumber} [root=2]    The root.
     * @return {number | Complex | Array | Matrix} Returns the nth root of `a`
     */
    var nthRoot = typed('nthRoot', {
      
      'number': function (x) {
        return _nthRoot(x, 2);
      },
      'number, number': _nthRoot,

      'BigNumber': function (x) {
        return _bigNthRoot(x, new type.BigNumber(2));
      },
      'Complex' : function(x) {
        return _nthComplexRoot(x, 2);
      }, 
      'Complex, number' : _nthComplexRoot,
      'BigNumber, BigNumber': _bigNthRoot,

      'Array | Matrix': function (x) {
        return nthRoot(x, 2);
      },

      'SparseMatrix, SparseMatrix': function (x, y) {
        // density must be one (no zeros in matrix)
        if (y.density() === 1) {
          // sparse + sparse
          return algorithm06$$1(x, y, nthRoot);
        }
        else {
          // throw exception
          throw new Error('Root must be non-zero');
        }
      },

      'SparseMatrix, DenseMatrix': function (x, y) {
        return algorithm02$$1(y, x, nthRoot, true);
      },

      'DenseMatrix, SparseMatrix': function (x, y) {
        // density must be one (no zeros in matrix)
        if (y.density() === 1) {
          // dense + sparse
          return algorithm01$$1(x, y, nthRoot, false);
        }
        else {
          // throw exception
          throw new Error('Root must be non-zero');
        }
      },

      'DenseMatrix, DenseMatrix': function (x, y) {
        return algorithm13$$1(x, y, nthRoot);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return nthRoot(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return nthRoot(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return nthRoot(x, matrix$$1(y));
      },
      
      'SparseMatrix, number | BigNumber': function (x, y) {
        return algorithm11$$1(x, y, nthRoot, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        return algorithm14$$1(x, y, nthRoot, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        // density must be one (no zeros in matrix)
        if (y.density() === 1) {
          // sparse - scalar
          return algorithm11$$1(y, x, nthRoot, true);
        }
        else {
          // throw exception
          throw new Error('Root must be non-zero');
        }
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, nthRoot, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return nthRoot(matrix$$1(x), y).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return nthRoot(x, matrix$$1(y)).valueOf();
      }
    });

    nthRoot.toTex = {2: '\\sqrt[${args[1]}]{${args[0]}}'};

    return nthRoot;

    /**
     * Calculate the nth root of a for BigNumbers, solve x^root == a
     * http://rosettacode.org/wiki/Nth_root#JavaScript
     * @param {BigNumber} a
     * @param {BigNumber} root
     * @private
     */
    function _bigNthRoot(a, root) {
      var precision = type.BigNumber.precision;
      var Big = type.BigNumber.clone({precision: precision + 2});
      var zero = new type.BigNumber(0);

      var one = new Big(1);
      var inv = root.isNegative();
      if (inv) {
        root = root.neg();
      }

      if (root.isZero()) {
        throw new Error('Root must be non-zero');
      }
      if (a.isNegative() && !root.abs().mod(2).equals(1)) {
        throw new Error('Root must be odd when a is negative.');
      }

      // edge cases zero and infinity
      if (a.isZero()) {
        return inv ? new Big(Infinity) : 0;
      }
      if (!a.isFinite()) {
        return inv ? zero : a;
      }

      var x = a.abs().pow(one.div(root));
      // If a < 0, we require that root is an odd integer,
      // so (-1) ^ (1/root) = -1
      x = a.isNeg() ? x.neg() : x;
      return new type.BigNumber((inv ? one.div(x) : x).toPrecision(precision));
    }
  }

  /**
   * Calculate the nth root of a, solve x^root == a
   * http://rosettacode.org/wiki/Nth_root#JavaScript
   * @param {number} a
   * @param {number} root
   * @private
   */
  function _nthRoot(a, root) {
    var inv = root < 0;
    if (inv) {
      root = -root;
    }

    if (root === 0) {
      throw new Error('Root must be non-zero');
    }
    if (a < 0 && (Math.abs(root) % 2 != 1)) {
      throw new Error('Root must be odd when a is negative.');
    }

    // edge cases zero and infinity
    if (a == 0) {
      return inv ? Infinity : 0;
    }
    if (!isFinite(a)) {
      return inv ? 0 : a;
    }

    var x = Math.pow(Math.abs(a), 1/root);
    // If a < 0, we require that root is an odd integer,
    // so (-1) ^ (1/root) = -1
    x = a < 0 ? -x : x;
    return inv ? 1 / x : x;

    // Very nice algorithm, but fails with nthRoot(-2, 3).
    // Newton's method has some well-known problems at times:
    // https://en.wikipedia.org/wiki/Newton%27s_method#Failure_analysis
    /*
    var x = 1; // Initial guess
    var xPrev = 1;
    var i = 0;
    var iMax = 10000;
    do {
      var delta = (a / Math.pow(x, root - 1) - x) / root;
      xPrev = x;
      x = x + delta;
      i++;
    }
    while (xPrev !== x && i < iMax);

    if (xPrev !== x) {
      throw new Error('Function nthRoot failed to converge');
    }

    return inv ? 1 / x : x;
    */
  }

  /**
   * Calculate the nth root of a Complex Number a using De Moviers Theorem.
   * @param  {Complex} a
   * @param  {number} root
   * @return {Array} array or n Complex Roots in Polar Form.
   */
  function _nthComplexRoot(a, root) {
    if (root < 0) throw new Error('Root must be greater than zero');
    if (root === 0) throw new Error('Root must be non-zero');
    if (root % 1 !== 0) throw new Error('Root must be an integer');  
    var arg = a.arg();
    var abs = a.abs();
    var roots = [];
    var r = Math.pow(abs, 1/root);
    for(var k = 0; k < root; k++) {
      roots.push({r: r, phi: (arg + 2 * Math.PI * k)/root});
    }
    return roots;
  }

  var name$155 = 'nthRoot';
  var factory_1$166 = factory$167;

  var nthRoot$1 = {
  	name: name$155,
  	factory: factory_1$166
  };

  var isInteger$11 = number.isInteger;
  var toFixed = number.toFixed;


  var NO_INT = 'Number of decimals in function round must be an integer';

  function factory$168 (type, config, load, typed) {
    var matrix$$1 = load(matrix);
    var equalScalar$$1 = load(equalScalar);
    var zeros = load(zeros$1);

    var algorithm11$$1 = load(algorithm11);
    var algorithm12$$1 = load(algorithm12);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Round a value towards the nearest integer.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.round(x)
     *    math.round(x, n)
     *
     * Examples:
     *
     *    math.round(3.2);              // returns number 3
     *    math.round(3.8);              // returns number 4
     *    math.round(-4.2);             // returns number -4
     *    math.round(-4.7);             // returns number -5
     *    math.round(math.pi, 3);       // returns number 3.142
     *    math.round(123.45678, 2);     // returns number 123.46
     *
     *    var c = math.complex(3.2, -2.7);
     *    math.round(c);                // returns Complex 3 - 3i
     *
     *    math.round([3.2, 3.8, -4.7]); // returns Array [3, 4, -5]
     *
     * See also:
     *
     *    ceil, fix, floor
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix} x  Number to be rounded
     * @param  {number | BigNumber | Array} [n=0]                            Number of decimals
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix} Rounded value
     */
    var round = typed('round', {

      'number': Math.round,

      'number, number': function (x, n) {
        if (!isInteger$11(n))   {throw new TypeError(NO_INT);}
        if (n < 0 || n > 15) {throw new Error('Number of decimals in function round must be in te range of 0-15');}

        return _round(x, n);
      },

      'Complex': function (x) {
        return x.round();
      },

      'Complex, number': function (x, n) {
        if (n % 1) {throw new TypeError(NO_INT);}
        
        return x.round(n);
      },

      'Complex, BigNumber': function (x, n) {
        if (!n.isInteger()) {throw new TypeError(NO_INT);}

        var _n = n.toNumber();
        return x.round(_n);
      },

      'number, BigNumber': function (x, n) {
        if (!n.isInteger()) {throw new TypeError(NO_INT);}

        return new type.BigNumber(x).toDecimalPlaces(n.toNumber());
      },

      'BigNumber': function (x) {
        return x.toDecimalPlaces(0);
      },

      'BigNumber, BigNumber': function (x, n) {
        if (!n.isInteger()) {throw new TypeError(NO_INT);}

        return x.toDecimalPlaces(n.toNumber());
      },

      'Fraction': function (x) {
        return x.round();
      },

      'Fraction, number': function (x, n) {
        if (n % 1) {throw new TypeError(NO_INT);}
        return x.round(n);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since round(0) = 0
        return deepMap(x, round, true);
      },

      'SparseMatrix, number | BigNumber': function (x, y) {
        return algorithm11$$1(x, y, round, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        return algorithm14$$1(x, y, round, false);
      },

      'number | Complex | BigNumber, SparseMatrix': function (x, y) {
        // check scalar is zero
        if (equalScalar$$1(x, 0)) {
          // do not execute algorithm, result will be a zero matrix
          return zeros(y.size(), y.storage());
        }
        return algorithm12$$1(y, x, round, true);
      },

      'number | Complex | BigNumber, DenseMatrix': function (x, y) {
        // check scalar is zero
        if (equalScalar$$1(x, 0)) {
          // do not execute algorithm, result will be a zero matrix
          return zeros(y.size(), y.storage());
        }
        return algorithm14$$1(y, x, round, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, round, false).valueOf();
      },

      'number | Complex | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, round, true).valueOf();
      }
    });

    round.toTex = {
      1: '\\left\\lfloor${args[0]}\\right\\rceil',
      2: undefined  // use default template
    };

    return round;
  }

  /**
   * round a number to the given number of decimals, or to zero if decimals is
   * not provided
   * @param {number} value
   * @param {number} decimals       number of decimals, between 0 and 15 (0 by default)
   * @return {number} roundedValue
   * @private
   */
  function _round (value, decimals) {
    return parseFloat(toFixed(value, decimals));
  }

  var name$156 = 'round';
  var factory_1$167 = factory$168;

  var round$1 = {
  	name: name$156,
  	factory: factory_1$167
  };

  function factory$169 (type, config, load, typed) {
    /**
     * Compute the square of a value, `x * x`.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.square(x)
     *
     * Examples:
     *
     *    math.square(2);           // returns number 4
     *    math.square(3);           // returns number 9
     *    math.pow(3, 2);           // returns number 9
     *    math.multiply(3, 3);      // returns number 9
     *
     *    math.square([1, 2, 3, 4]);  // returns Array [1, 4, 9, 16]
     *
     * See also:
     *
     *    multiply, cube, sqrt, pow
     *
     * @param  {number | BigNumber | Fraction | Complex | Array | Matrix | Unit} x
     *            Number for which to calculate the square
     * @return {number | BigNumber | Fraction | Complex | Array | Matrix | Unit}
     *            Squared value
     */
    var square = typed('square', {
      'number': function (x) {
        return x * x;
      },

      'Complex': function (x) {
        return x.mul(x);
      },

      'BigNumber': function (x) {
        return x.times(x);
      },

      'Fraction': function (x) {
        return x.mul(x);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since square(0) = 0
        return deepMap(x, square, true);
      },

      'Unit': function(x) {
        return x.pow(2);
      }
    });

    square.toTex = {1: '\\left(${args[0]}\\right)^2'};

    return square;
  }

  var name$157 = 'square';
  var factory_1$168 = factory$169;

  var square$1 = {
  	name: name$157,
  	factory: factory_1$168
  };

  function factory$170 (type, config, load, typed) {
    var latex$$1 = latex;

    /**
     * Unary plus operation.
     * Boolean values and strings will be converted to a number, numeric values will be returned as is.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.unaryPlus(x)
     *
     * Examples:
     *
     *    math.unaryPlus(3.5);      // returns 3.5
     *    math.unaryPlus(1);     // returns 1
     *
     * See also:
     *
     *    unaryMinus, add, subtract
     *
     * @param  {number | BigNumber | Fraction | string | Complex | Unit | Array | Matrix} x
     *            Input value
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
     *            Returns the input value when numeric, converts to a number when input is non-numeric.
     */
    var unaryPlus = typed('unaryPlus', {
      'number': function (x) {
        return x;
      },

      'Complex': function (x) {
        return x; // complex numbers are immutable
      },

      'BigNumber': function (x) {
        return x; // bignumbers are immutable
      },

      'Fraction': function (x) {
        return x; // fractions are immutable
      },

      'Unit': function (x) {
        return x.clone();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since unaryPlus(0) = 0
        return deepMap(x, unaryPlus, true);
      },

      'boolean | string': function (x) {
        // convert to a number or bignumber
        return (config.number == 'BigNumber') ? new type.BigNumber(+x): +x;
      }
    });

    unaryPlus.toTex = {
      1: latex$$1.operators['unaryPlus'] + '\\left(${args[0]}\\right)'
    };

    return unaryPlus;
  }

  var name$158 = 'unaryPlus';
  var factory_1$169 = factory$170;

  var unaryPlus$1 = {
  	name: name$158,
  	factory: factory_1$169
  };

  var isInteger$12 = number.isInteger;

  function factory$171 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Calculate the extended greatest common divisor for two values.
     * See http://en.wikipedia.org/wiki/Extended_Euclidean_algorithm.
     *
     * Syntax:
     *
     *    math.xgcd(a, b)
     *
     * Examples:
     *
     *    math.xgcd(8, 12);             // returns [4, -1, 1]
     *    math.gcd(8, 12);              // returns 4
     *    math.xgcd(36163, 21199);      // returns [1247, -7, 12]
     *
     * See also:
     *
     *    gcd, lcm
     *
     * @param {number | BigNumber} a  An integer number
     * @param {number | BigNumber} b  An integer number
     * @return {Array}              Returns an array containing 3 integers `[div, m, n]`
     *                              where `div = gcd(a, b)` and `a*m + b*n = div`
     */
    var xgcd = typed('xgcd', {
      'number, number': _xgcd,
      'BigNumber, BigNumber': _xgcdBigNumber
      // TODO: implement support for Fraction
    });

    xgcd.toTex = undefined; // use default template

    return xgcd;

    /**
     * Calculate xgcd for two numbers
     * @param {number} a
     * @param {number} b
     * @return {number} result
     * @private
     */
    function _xgcd (a, b) {
      // source: http://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
      var t, // used to swap two variables
          q, // quotient
          r, // remainder
          x = 0, lastx = 1,
          y = 1, lasty = 0;

      if (!isInteger$12(a) || !isInteger$12(b)) {
        throw new Error('Parameters in function xgcd must be integer numbers');
      }

      while (b) {
        q = Math.floor(a / b);
        r = a - q*b;

        t = x;
        x = lastx - q * x;
        lastx = t;

        t = y;
        y = lasty - q * y;
        lasty = t;

        a = b;
        b = r;
      }

      var res;
      if (a < 0) {
        res = [-a, -lastx, -lasty];
      }
      else {
        res = [a, a ? lastx : 0, lasty];
      }
      return (config.matrix === 'Array') ? res : matrix$$1(res);
    }

    /**
     * Calculate xgcd for two BigNumbers
     * @param {BigNumber} a
     * @param {BigNumber} b
     * @return {BigNumber[]} result
     * @private
     */
    function _xgcdBigNumber(a, b) {
      // source: http://en.wikipedia.org/wiki/Extended_Euclidean_algorithm
      var t, // used to swap two variables
          q, // quotient
          r, // remainder
          zero = new type.BigNumber(0),
          one = new type.BigNumber(1),
          x = zero,
          lastx = one,
          y = one,
          lasty = zero;

      if (!a.isInt() || !b.isInt()) {
        throw new Error('Parameters in function xgcd must be integer numbers');
      }

      while (!b.isZero()) {
        q = a.div(b).floor();
        r = a.mod(b);

        t = x;
        x = lastx.minus(q.times(x));
        lastx = t;

        t = y;
        y = lasty.minus(q.times(y));
        lasty = t;

        a = b;
        b = r;
      }

      var res;
      if (a.lt(zero)) {
        res = [a.neg(), lastx.neg(), lasty.neg()];
      }
      else {
        res = [a, !a.isZero() ? lastx : 0, lasty];
      }
      return (config.matrix === 'Array') ? res : matrix$$1(res);
    }
  }

  var name$159 = 'xgcd';
  var factory_1$170 = factory$171;

  var xgcd$1 = {
  	name: name$159,
  	factory: factory_1$170
  };

  var arithmetic = [
    abs$1,
    add,
    addScalar,
    cbrt$1,
    ceil$1,
    cube$1,
    divide$1,
    dotDivide$1,
    dotMultiply$1,
    dotPow$1,
    exp$1,
    expm1$1,
    fix$1,
    floor$1,
    gcd$1,
    hypot$1,
    lcm$1,
    log$1,
    log10$1,
    log1p$1,
    log2$1,
    mod$1,
    multiply$1,
    norm$1,
    nthRoot$1,
    pow$1,
    round$1,
    sign$1,
    sqrt$1,
    square$1,
    subtract$1,
    unaryMinus$1,
    unaryPlus$1,
    xgcd$1
  ];

  /**
   * Bitwise not
   * @param {BigNumber} value
   * @return {BigNumber} Result of ~`x`, fully precise
   *
   */
  var bitNot$1 = function bitNot (x) {
    if (x.isFinite() && !x.isInteger()) {
      throw new Error('Integer expected in function bitNot');
    }

    var BigNumber = x.constructor;
    var prevPrec = BigNumber.precision;
    BigNumber.config({precision: 1E9});

    var x = x.plus(new BigNumber(1));
    x.s = -x.s || null;

    BigNumber.config({precision: prevPrec});
    return x;
  };

  /**
   * Applies bitwise function to numbers
   * @param {BigNumber} x
   * @param {BigNumber} y
   * @param {function (a, b)} func
   * @return {BigNumber}
   */
  var bitwise = function bitwise(x, y, func) {
    var BigNumber = x.constructor;

    var xBits, yBits;
    var xSign = +(x.s < 0);
    var ySign = +(y.s < 0);
    if (xSign) {
      xBits = decCoefficientToBinaryString(bitNot$1(x));
      for (var i = 0; i < xBits.length; ++i) {
        xBits[i] ^= 1;
      }
    } else {
      xBits = decCoefficientToBinaryString(x);
    }
    if (ySign) {
      yBits = decCoefficientToBinaryString(bitNot$1(y));
      for (var i = 0; i < yBits.length; ++i) {
        yBits[i] ^= 1;
      }
    } else {
      yBits = decCoefficientToBinaryString(y);
    }

    var minBits, maxBits, minSign;
    if (xBits.length <= yBits.length) {
      minBits = xBits;
      maxBits = yBits;
      minSign = xSign;
    } else {
      minBits = yBits;
      maxBits = xBits;
      minSign = ySign;
    }

    var shortLen = minBits.length;
    var longLen = maxBits.length;
    var expFuncVal = func(xSign, ySign) ^ 1;
    var outVal = new BigNumber(expFuncVal ^ 1);
    var twoPower = new BigNumber(1);
    var two = new BigNumber(2);

    var prevPrec = BigNumber.precision;
    BigNumber.config({precision: 1E9});

    while (shortLen > 0) {
      if (func(minBits[--shortLen], maxBits[--longLen]) == expFuncVal) {
        outVal = outVal.plus(twoPower);
      }
      twoPower = twoPower.times(two);
    }
    while (longLen > 0) {
      if (func(minSign, maxBits[--longLen]) == expFuncVal) {
        outVal = outVal.plus(twoPower);
      }
      twoPower = twoPower.times(two);
    }

    BigNumber.config({precision: prevPrec});

    if (expFuncVal == 0) {
      outVal.s = -outVal.s;
    }
    return outVal;
  };

  /* Extracted from decimal.js, and edited to specialize. */
  function decCoefficientToBinaryString (x) {
    // Convert to string
    var a = x.d; // array with digits
    var r = a[0] + '';

    for (var i = 1; i < a.length; ++i) {
      var s = a[i] + '';
      for (var z = 7 - s.length; z--; ) {
        s = '0' + s;
      }

      r += s;
    }

    var j;
    for (j = r.length - 1; r.charAt(j) == '0'; --j);

    var xe = x.e;
    var str = r.slice(0, j + 1 || 1);
    var strL = str.length;
    if (xe > 0) {
      if (++xe > strL) {
        // Append zeros.
        for (xe -= strL; xe--; str += '0');
      } else if (xe < strL) {
        str = str.slice(0, xe) + '.' + str.slice(xe);
      }
    }

    // Convert from base 10 (decimal) to base 2
    var arr = [0];
    for (var i = 0; i < str.length; ) {
      for (var arrL = arr.length; arrL--; arr[arrL] *= 10);

      arr[0] += str.charAt(i++) << 0;  // convert to int
      for (var j = 0; j < arr.length; ++j) {
        if (arr[j] > 1) {
          if (arr[j + 1] == null) {
            arr[j + 1] = 0;
          }

          arr[j + 1] += arr[j] >> 1;
          arr[j] &= 1;
        }
      }
    }

    return arr.reverse();
  }

  /**
   * Bitwise and for Bignumbers
   *
   * Special Cases:
   *   N &  n =  N
   *   n &  0 =  0
   *   n & -1 =  n
   *   n &  n =  n
   *   I &  I =  I
   *  -I & -I = -I
   *   I & -I =  0
   *   I &  n =  n
   *   I & -n =  I
   *  -I &  n =  0
   *  -I & -n = -I
   *
   * @param {BigNumber} x
   * @param {BigNumber} y
   * @return {BigNumber} Result of `x` & `y`, is fully precise
   * @private
   */
  var bitAnd$1 = function bitAnd(x, y) {
    if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
      throw new Error('Integers expected in function bitAnd');
    }

    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) {
      return new BigNumber(NaN);
    }

    if (x.isZero() || y.eq(-1) || x.eq(y)) {
      return x;
    }
    if (y.isZero() || x.eq(-1)) {
      return y;
    }

    if (!x.isFinite() || !y.isFinite()) {
      if (!x.isFinite() && !y.isFinite()) {
        if (x.isNegative() == y.isNegative()) {
          return x;
        }
        return new BigNumber(0);
      }
      if (!x.isFinite()) {
        if (y.isNegative()) {
          return x;
        }
        if (x.isNegative()) {
          return new BigNumber(0);
        }
        return y;
      }
      if (!y.isFinite()) {
        if (x.isNegative()) {
          return y;
        }
        if (y.isNegative()) {
          return new BigNumber(0);
        }
        return x;
      }
    }
    return bitwise(x, y, function (a, b) { return a & b });
  };

  var isInteger$13 = number.isInteger;


  function factory$172 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var algorithm02$$1 = load(algorithm02);
    var algorithm06$$1 = load(algorithm06);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Bitwise AND two values, `x & y`.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.bitAnd(x, y)
     *
     * Examples:
     *
     *    math.bitAnd(53, 131);               // returns number 1
     *
     *    math.bitAnd([1, 12, 31], 42);       // returns Array [0, 8, 10]
     *
     * See also:
     *
     *    bitNot, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
     *
     * @param  {number | BigNumber | Array | Matrix} x First value to and
     * @param  {number | BigNumber | Array | Matrix} y Second value to and
     * @return {number | BigNumber | Array | Matrix} AND of `x` and `y`
     */
    var bitAnd = typed('bitAnd', {

      'number, number': function (x, y) {
        if (!isInteger$13(x) || !isInteger$13(y)) {
          throw new Error('Integers expected in function bitAnd');
        }

        return x & y;
      },

      'BigNumber, BigNumber': bitAnd$1,

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm06$$1(x, y, bitAnd, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, bitAnd, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm02$$1(x, y, bitAnd, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, bitAnd);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return bitAnd(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return bitAnd(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return bitAnd(x, matrix$$1(y));
      },
      
      'SparseMatrix, any': function (x, y) {
        return algorithm11$$1(x, y, bitAnd, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, bitAnd, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm11$$1(y, x, bitAnd, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, bitAnd, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, bitAnd, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, bitAnd, true).valueOf();
      }
    });

    bitAnd.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['bitAnd'] + '${args[1]}\\right)'
    };

    return bitAnd;
  }

  var name$160 = 'bitAnd';
  var factory_1$171 = factory$172;

  var bitAnd$2 = {
  	name: name$160,
  	factory: factory_1$171
  };

  var isInteger$14 = number.isInteger;

  function factory$173 (type, config, load, typed) {
    var latex$$1 = latex;

    /**
     * Bitwise NOT value, `~x`.
     * For matrices, the function is evaluated element wise.
     * For units, the function is evaluated on the best prefix base.
     *
     * Syntax:
     *
     *    math.bitNot(x)
     *
     * Examples:
     *
     *    math.bitNot(1);               // returns number -2
     *
     *    math.bitNot([2, -3, 4]);      // returns Array [-3, 2, 5]
     *
     * See also:
     *
     *    bitAnd, bitOr, bitXor, leftShift, rightArithShift, rightLogShift
     *
     * @param  {number | BigNumber | Array | Matrix} x Value to not
     * @return {number | BigNumber | Array | Matrix} NOT of `x`
     */
    var bitNot = typed('bitNot', {
      'number': function (x) {
        if (!isInteger$14(x)) {
          throw new Error('Integer expected in function bitNot');
        }

        return ~x;
      },

      'BigNumber': bitNot$1,

      'Array | Matrix': function (x) {
        return deepMap(x, bitNot);
      }
    });

    bitNot.toTex = {
      1: latex$$1.operators['bitNot'] + '\\left(${args[0]}\\right)'
    };

    return bitNot;
  }

  var name$161 = 'bitNot';
  var factory_1$172 = factory$173;

  var bitNot$2 = {
  	name: name$161,
  	factory: factory_1$172
  };

  /**
   * Bitwise OR for BigNumbers
   *
   * Special Cases:
   *   N |  n =  N
   *   n |  0 =  n
   *   n | -1 = -1
   *   n |  n =  n
   *   I |  I =  I
   *  -I | -I = -I
   *   I | -n = -1
   *   I | -I = -1
   *   I |  n =  I
   *  -I |  n = -I
   *  -I | -n = -n
   *
   * @param {BigNumber} x
   * @param {BigNumber} y
   * @return {BigNumber} Result of `x` | `y`, fully precise
   */
  var bitOr$1 = function bitOr (x, y) {
    if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
      throw new Error('Integers expected in function bitOr');
    }

    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) {
      return new BigNumber(NaN);
    }

    var negOne = new BigNumber(-1);
    if (x.isZero() || y.eq(negOne) || x.eq(y)) {
      return y;
    }
    if (y.isZero() || x.eq(negOne)) {
      return x;
    }

    if (!x.isFinite() || !y.isFinite()) {
      if ((!x.isFinite() && !x.isNegative() && y.isNegative()) ||
          (x.isNegative() && !y.isNegative() && !y.isFinite())) {
        return negOne;
      }
      if (x.isNegative() && y.isNegative()) {
        return x.isFinite() ? x : y;
      }
      return x.isFinite() ? y : x;
    }

    return bitwise(x, y, function (a, b) { return a | b });
  };

  var isInteger$15 = number.isInteger;


  function factory$174 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var algorithm01$$1 = load(algorithm01);
    var algorithm04$$1 = load(algorithm04);
    var algorithm10$$1 = load(algorithm10);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Bitwise OR two values, `x | y`.
     * For matrices, the function is evaluated element wise.
     * For units, the function is evaluated on the lowest print base.
     *
     * Syntax:
     *
     *    math.bitOr(x, y)
     *
     * Examples:
     *
     *    math.bitOr(1, 2);               // returns number 3
     *
     *    math.bitOr([1, 2, 3], 4);       // returns Array [5, 6, 7]
     *
     * See also:
     *
     *    bitAnd, bitNot, bitXor, leftShift, rightArithShift, rightLogShift
     *
     * @param  {number | BigNumber | Array | Matrix} x First value to or
     * @param  {number | BigNumber | Array | Matrix} y Second value to or
     * @return {number | BigNumber | Array | Matrix} OR of `x` and `y`
     */
    var bitOr = typed('bitOr', {

      'number, number': function (x, y) {
        if (!isInteger$15(x) || !isInteger$15(y)) {
          throw new Error('Integers expected in function bitOr');
        }

        return x | y;
      },

      'BigNumber, BigNumber': bitOr$1,

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm04$$1(x, y, bitOr);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm01$$1(y, x, bitOr, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm01$$1(x, y, bitOr, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, bitOr);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return bitOr(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return bitOr(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return bitOr(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm10$$1(x, y, bitOr, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, bitOr, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm10$$1(y, x, bitOr, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, bitOr, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, bitOr, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, bitOr, true).valueOf();
      }
    });

    bitOr.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['bitOr'] + '${args[1]}\\right)'
    };

    return bitOr;
  }

  var name$162 = 'bitOr';
  var factory_1$173 = factory$174;

  var bitOr$2 = {
  	name: name$162,
  	factory: factory_1$173
  };

  /**
   * Bitwise XOR for BigNumbers
   *
   * Special Cases:
   *   N ^  n =  N
   *   n ^  0 =  n
   *   n ^  n =  0
   *   n ^ -1 = ~n
   *   I ^  n =  I
   *   I ^ -n = -I
   *   I ^ -I = -1
   *  -I ^  n = -I
   *  -I ^ -n =  I
   *
   * @param {BigNumber} x
   * @param {BigNumber} y
   * @return {BigNumber} Result of `x` ^ `y`, fully precise
   *
   */
  var bitXor$1 = function bitXor(x, y) {
    if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
      throw new Error('Integers expected in function bitXor');
    }

    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN()) {
      return new BigNumber(NaN);
    }
    if (x.isZero()) {
      return y;
    }
    if (y.isZero()) {
      return x;
    }

    if (x.eq(y)) {
      return new BigNumber(0);
    }

    var negOne = new BigNumber(-1);
    if (x.eq(negOne)) {
      return bitNot$1(y);
    }
    if (y.eq(negOne)) {
      return bitNot$1(x);
    }

    if (!x.isFinite() || !y.isFinite()) {
      if (!x.isFinite() && !y.isFinite()) {
        return negOne;
      }
      return new BigNumber(x.isNegative() == y.isNegative()
          ?  Infinity
          : -Infinity);
    }
    return bitwise(x, y, function (a, b) { return a ^ b });
  };

  var isInteger$16 = number.isInteger;


  function factory$175 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Bitwise XOR two values, `x ^ y`.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.bitXor(x, y)
     *
     * Examples:
     *
     *    math.bitXor(1, 2);               // returns number 3
     *
     *    math.bitXor([2, 3, 4], 4);       // returns Array [6, 7, 0]
     *
     * See also:
     *
     *    bitAnd, bitNot, bitOr, leftShift, rightArithShift, rightLogShift
     *
     * @param  {number | BigNumber | Array | Matrix} x First value to xor
     * @param  {number | BigNumber | Array | Matrix} y Second value to xor
     * @return {number | BigNumber | Array | Matrix} XOR of `x` and `y`
     */
    var bitXor = typed('bitXor', {

      'number, number': function (x, y) {
        if (!isInteger$16(x) || !isInteger$16(y)) {
          throw new Error('Integers expected in function bitXor');
        }

        return x ^ y;
      },

      'BigNumber, BigNumber': bitXor$1,

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, bitXor);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, bitXor, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, bitXor, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, bitXor);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return bitXor(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return bitXor(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return bitXor(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, bitXor, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, bitXor, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, bitXor, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, bitXor, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, bitXor, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, bitXor, true).valueOf();
      }
    });

    bitXor.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['bitXor'] + '${args[1]}\\right)'
    };

    return bitXor;
  }

  var name$163 = 'bitXor';
  var factory_1$174 = factory$175;

  var bitXor$2 = {
  	name: name$163,
  	factory: factory_1$174
  };

  /**
   * Bitwise left shift
   *
   * Special Cases:
   *  n << -n = N
   *  n <<  N = N
   *  N <<  n = N
   *  n <<  0 = n
   *  0 <<  n = 0
   *  I <<  I = N
   *  I <<  n = I
   *  n <<  I = I
   *
   * @param {BigNumber} x
   * @param {BigNumber} y
   * @return {BigNumber} Result of `x` << `y`
   *
   */
  var leftShift$1 = function leftShift (x, y) {
    if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
      throw new Error('Integers expected in function leftShift');
    }

    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || (y.isNegative() && !y.isZero())) {
      return new BigNumber(NaN);
    }
    if (x.isZero() || y.isZero()) {
      return x;
    }
    if (!x.isFinite() && !y.isFinite()) {
      return new BigNumber(NaN);
    }

    // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) {
      return x.times(Math.pow(2, y.toNumber()) + '');
    }
    return x.times(new BigNumber(2).pow(y));
  };

  function factory$176 (type, config, load, typed) {

    var equalScalar$$1 = load(equalScalar);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Iterates over SparseMatrix A and SparseMatrix B nonzero items and invokes the callback function f(Aij, Bij). 
     * Callback function invoked MAX(NNZA, NNZB) times
     *
     *
     *          ┌  f(Aij, Bij)  ; A(i,j) !== 0 && B(i,j) !== 0
     * C(i,j) = ┤  A(i,j)       ; A(i,j) !== 0
     *          └  0            ; otherwise
     *
     *
     * @param {Matrix}   a                 The SparseMatrix instance (A)
     * @param {Matrix}   b                 The SparseMatrix instance (B)
     * @param {Function} callback          The f(Aij,Bij) operation to invoke
     *
     * @return {Matrix}                    SparseMatrix (C)
     *
     * see https://github.com/josdejong/mathjs/pull/346#issuecomment-97620294
     */
    var algorithm08 = function (a, b, callback) {
      // sparse matrix arrays
      var avalues = a._values;
      var aindex = a._index;
      var aptr = a._ptr;
      var asize = a._size;
      var adt = a._datatype;
      // sparse matrix arrays
      var bvalues = b._values;
      var bindex = b._index;
      var bptr = b._ptr;
      var bsize = b._size;
      var bdt = b._datatype;

      // validate dimensions
      if (asize.length !== bsize.length)
        throw new DimensionError_1(asize.length, bsize.length);

      // check rows & columns
      if (asize[0] !== bsize[0] || asize[1] !== bsize[1])
        throw new RangeError('Dimension mismatch. Matrix A (' + asize + ') must match Matrix B (' + bsize + ')');

      // sparse matrix cannot be a Pattern matrix
      if (!avalues || !bvalues)
        throw new Error('Cannot perform operation on Pattern Sparse Matrices');

      // rows & columns
      var rows = asize[0];
      var columns = asize[1];

      // datatype
      var dt;
      // equal signature to use
      var eq = equalScalar$$1;
      // zero value
      var zero = 0;
      // callback signature to use
      var cf = callback;

      // process data types
      if (typeof adt === 'string' && adt === bdt) {
        // datatype
        dt = adt;
        // find signature that matches (dt, dt)
        eq = typed.find(equalScalar$$1, [dt, dt]);
        // convert 0 to the same datatype
        zero = typed.convert(0, dt);
        // callback
        cf = typed.find(callback, [dt, dt]);
      }

      // result arrays
      var cvalues = [];
      var cindex = [];
      var cptr = [];
      // matrix
      var c = new SparseMatrix({
        values: cvalues,
        index: cindex,
        ptr: cptr,
        size: [rows, columns],
        datatype: dt
      });

      // workspace
      var x = [];
      // marks indicating we have a value in x for a given column
      var w = [];

      // vars
      var k, k0, k1, i;

      // loop columns
      for (var j = 0; j < columns; j++) {
        // update cptr
        cptr[j] = cindex.length;
        // columns mark
        var mark = j + 1;
        // loop values in a
        for (k0 = aptr[j], k1 = aptr[j + 1], k = k0; k < k1; k++) {
          // row
          i = aindex[k];
          // mark workspace
          w[i] = mark;
          // set value
          x[i] = avalues[k];
          // add index
          cindex.push(i);
        }
        // loop values in b
        for (k0 = bptr[j], k1 = bptr[j + 1], k = k0; k < k1; k++) {
          // row
          i = bindex[k];
          // check value exists in workspace
          if (w[i] === mark) {
            // evaluate callback
            x[i] = cf(x[i], bvalues[k]);
          }
        }
        // initialize first index in j
        k = cptr[j];
        // loop index in j
        while (k < cindex.length) {
          // row
          i = cindex[k];
          // value @ i
          var v = x[i];
          // check for zero value
          if (!eq(v, zero)) {
            // push value
            cvalues.push(v);
            // increment pointer
            k++;
          }
          else {
            // remove value @ i, do not increment pointer
            cindex.splice(k, 1);
          }
        }      
      }
      // update cptr
      cptr[columns] = cindex.length;

      // return sparse matrix
      return c;
    };

    return algorithm08;
  }

  var name$164 = 'algorithm08';
  var factory_1$175 = factory$176;

  var algorithm08 = {
  	name: name$164,
  	factory: factory_1$175
  };

  var isInteger$17 = number.isInteger;


  function factory$177 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);
    var equalScalar$$1 = load(equalScalar);
    var zeros = load(zeros$1);

    var algorithm01$$1 = load(algorithm01);
    var algorithm02$$1 = load(algorithm02);
    var algorithm08$$1 = load(algorithm08);
    var algorithm10$$1 = load(algorithm10);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Bitwise left logical shift of a value x by y number of bits, `x << y`.
     * For matrices, the function is evaluated element wise.
     * For units, the function is evaluated on the best prefix base.
     *
     * Syntax:
     *
     *    math.leftShift(x, y)
     *
     * Examples:
     *
     *    math.leftShift(1, 2);               // returns number 4
     *
     *    math.leftShift([1, 2, 3], 4);       // returns Array [16, 32, 64]
     *
     * See also:
     *
     *    leftShift, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
     *
     * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
     * @param  {number | BigNumber} y Amount of shifts
     * @return {number | BigNumber | Array | Matrix} `x` shifted left `y` times
     */
    var leftShift = typed('leftShift', {
      
      'number, number': function (x, y) {
        if (!isInteger$17(x) || !isInteger$17(y)) {
          throw new Error('Integers expected in function leftShift');
        }

        return x << y;
      },

      'BigNumber, BigNumber': leftShift$1,

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm08$$1(x, y, leftShift, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, leftShift, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm01$$1(x, y, leftShift, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, leftShift);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return leftShift(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return leftShift(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return leftShift(x, matrix$$1(y));
      },

      'SparseMatrix, number | BigNumber': function (x, y) {
        // check scalar
        if (equalScalar$$1(y, 0)) {
          return x.clone();
        }
        return algorithm11$$1(x, y, leftShift, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        // check scalar
        if (equalScalar$$1(y, 0)) {
          return x.clone();
        }
        return algorithm14$$1(x, y, leftShift, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        // check scalar
        if (equalScalar$$1(x, 0)) {
          return zeros(y.size(), y.storage());
        }
        return algorithm10$$1(y, x, leftShift, true);
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        // check scalar
        if (equalScalar$$1(x, 0)) {
          return zeros(y.size(), y.storage());
        }
        return algorithm14$$1(y, x, leftShift, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return leftShift(matrix$$1(x), y).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return leftShift(x, matrix$$1(y)).valueOf();
      }
    });

    leftShift.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['leftShift'] + '${args[1]}\\right)'
    };

    return leftShift;
  }

  var name$165 = 'leftShift';
  var factory_1$176 = factory$177;

  var leftShift$2 = {
  	name: name$165,
  	factory: factory_1$176
  };

  /*
   * Special Cases:
   *   n >> -n =  N
   *   n >>  N =  N
   *   N >>  n =  N
   *   I >>  I =  N
   *   n >>  0 =  n
   *   I >>  n =  I
   *  -I >>  n = -I
   *  -I >>  I = -I
   *   n >>  I =  I
   *  -n >>  I = -1
   *   0 >>  n =  0
   *
   * @param {BigNumber} value
   * @param {BigNumber} value
   * @return {BigNumber} Result of `x` >> `y`
   *
   */
  var rightArithShift$1 = function rightArithShift (x, y) {
    if ((x.isFinite() && !x.isInteger()) || (y.isFinite() && !y.isInteger())) {
      throw new Error('Integers expected in function rightArithShift');
    }

    var BigNumber = x.constructor;
    if (x.isNaN() || y.isNaN() || (y.isNegative() && !y.isZero())) {
      return new BigNumber(NaN);
    }
    if (x.isZero() || y.isZero()) {
      return x;
    }
    if (!y.isFinite()) {
      if (x.isNegative()) {
        return new BigNumber(-1);
      }
      if (!x.isFinite()) {
        return new BigNumber(NaN);
      }
      return new BigNumber(0);
    }

    // Math.pow(2, y) is fully precise for y < 55, and fast
    if (y.lt(55)) {
      return x.div(Math.pow(2, y.toNumber()) + '').floor();
    }
    return x.div(new BigNumber(2).pow(y)).floor();
  };

  var isInteger$18 = number.isInteger;


  function factory$178 (type, config, load, typed) {
    var latex$$1 = latex;
    
    var matrix$$1 = load(matrix);
    var equalScalar$$1 = load(equalScalar);
    var zeros = load(zeros$1);

    var algorithm01$$1 = load(algorithm01);
    var algorithm02$$1 = load(algorithm02);
    var algorithm08$$1 = load(algorithm08);
    var algorithm10$$1 = load(algorithm10);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Bitwise right arithmetic shift of a value x by y number of bits, `x >> y`.
     * For matrices, the function is evaluated element wise.
     * For units, the function is evaluated on the best prefix base.
     *
     * Syntax:
     *
     *    math.rightArithShift(x, y)
     *
     * Examples:
     *
     *    math.rightArithShift(4, 2);               // returns number 1
     *
     *    math.rightArithShift([16, -32, 64], 4);   // returns Array [1, -2, 3]
     *
     * See also:
     *
     *    bitAnd, bitNot, bitOr, bitXor, rightArithShift, rightLogShift
     *
     * @param  {number | BigNumber | Array | Matrix} x Value to be shifted
     * @param  {number | BigNumber} y Amount of shifts
     * @return {number | BigNumber | Array | Matrix} `x` sign-filled shifted right `y` times
     */
    var rightArithShift = typed('rightArithShift', {

      'number, number': function (x, y) {
        if (!isInteger$18(x) || !isInteger$18(y)) {
          throw new Error('Integers expected in function rightArithShift');
        }

        return x >> y;
      },

      'BigNumber, BigNumber': rightArithShift$1,

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm08$$1(x, y, rightArithShift, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, rightArithShift, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm01$$1(x, y, rightArithShift, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, rightArithShift);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return rightArithShift(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return rightArithShift(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return rightArithShift(x, matrix$$1(y));
      },

      'SparseMatrix, number | BigNumber': function (x, y) {
        // check scalar
        if (equalScalar$$1(y, 0)) {
          return x.clone();
        }
        return algorithm11$$1(x, y, rightArithShift, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        // check scalar
        if (equalScalar$$1(y, 0)) {
          return x.clone();
        }
        return algorithm14$$1(x, y, rightArithShift, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        // check scalar
        if (equalScalar$$1(x, 0)) {
          return zeros(y.size(), y.storage());
        }
        return algorithm10$$1(y, x, rightArithShift, true);
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        // check scalar
        if (equalScalar$$1(x, 0)) {
          return zeros(y.size(), y.storage());
        }
        return algorithm14$$1(y, x, rightArithShift, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return rightArithShift(matrix$$1(x), y).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return rightArithShift(x, matrix$$1(y)).valueOf();
      }
    });

    rightArithShift.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['rightArithShift'] + '${args[1]}\\right)'
    };

    return rightArithShift;
  }

  var name$166 = 'rightArithShift';
  var factory_1$177 = factory$178;

  var rightArithShift$2 = {
  	name: name$166,
  	factory: factory_1$177
  };

  var isInteger$19 = number.isInteger;

  function factory$179 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);
    var equalScalar$$1 = load(equalScalar);
    var zeros = load(zeros$1);

    var algorithm01$$1 = load(algorithm01);
    var algorithm02$$1 = load(algorithm02);
    var algorithm08$$1 = load(algorithm08);
    var algorithm10$$1 = load(algorithm10);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Bitwise right logical shift of value x by y number of bits, `x >>> y`.
     * For matrices, the function is evaluated element wise.
     * For units, the function is evaluated on the best prefix base.
     *
     * Syntax:
     *
     *    math.rightLogShift(x, y)
     *
     * Examples:
     *
     *    math.rightLogShift(4, 2);               // returns number 1
     *
     *    math.rightLogShift([16, -32, 64], 4);   // returns Array [1, 2, 3]
     *
     * See also:
     *
     *    bitAnd, bitNot, bitOr, bitXor, leftShift, rightLogShift
     *
     * @param  {number | Array | Matrix} x Value to be shifted
     * @param  {number} y Amount of shifts
     * @return {number | Array | Matrix} `x` zero-filled shifted right `y` times
     */

    var rightLogShift = typed('rightLogShift', {

      'number, number': function (x, y) {
        if (!isInteger$19(x) || !isInteger$19(y)) {
          throw new Error('Integers expected in function rightLogShift');
        }

        return x >>> y;
      },

      // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm08$$1(x, y, rightLogShift, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, rightLogShift, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm01$$1(x, y, rightLogShift, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, rightLogShift);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return rightLogShift(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return rightLogShift(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return rightLogShift(x, matrix$$1(y));
      },

      'SparseMatrix, number | BigNumber': function (x, y) {
        // check scalar
        if (equalScalar$$1(y, 0)) {
          return x.clone();
        }
        return algorithm11$$1(x, y, rightLogShift, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        // check scalar
        if (equalScalar$$1(y, 0)) {
          return x.clone();
        }
        return algorithm14$$1(x, y, rightLogShift, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        // check scalar
        if (equalScalar$$1(x, 0)) {
          return zeros(y.size(), y.storage());
        }
        return algorithm10$$1(y, x, rightLogShift, true);
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        // check scalar
        if (equalScalar$$1(x, 0)) {
          return zeros(y.size(), y.storage());
        }
        return algorithm14$$1(y, x, rightLogShift, true);
      },

      'Array, number | BigNumber': function (x, y) {
        // use matrix implementation
        return rightLogShift(matrix$$1(x), y).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        // use matrix implementation
        return rightLogShift(x, matrix$$1(y)).valueOf();
      }
    });

    rightLogShift.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['rightLogShift'] + '${args[1]}\\right)'
    };

    return rightLogShift;
  }

  var name$167 = 'rightLogShift';
  var factory_1$178 = factory$179;

  var rightLogShift$1 = {
  	name: name$167,
  	factory: factory_1$178
  };

  var bitwise$1 = [
    bitAnd$2,
    bitNot$2,
    bitOr$2,
    bitXor$2,
    leftShift$2,
    rightArithShift$2,
    rightLogShift$1
  ];

  var isInteger$20 = number.isInteger;

  function factory$180 (type, config, load, typed) {
    var multiply = load(multiply$1);
    var pow = load(pow$1);

    /**
     * Compute the gamma function of a value using Lanczos approximation for
     * small values, and an extended Stirling approximation for large values.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.gamma(n)
     *
     * Examples:
     *
     *    math.gamma(5);       // returns 24
     *    math.gamma(-0.5);    // returns -3.5449077018110335
     *    math.gamma(math.i);  // returns -0.15494982830180973 - 0.49801566811835596i
     *
     * See also:
     *
     *    combinations, factorial, permutations
     *
     * @param {number | Array | Matrix} n   A real or complex number
     * @return {number | Array | Matrix}    The gamma of `n`
     */
    var gamma = typed('gamma', {
      'number': function (n) {
        var t, x;

        if (isInteger$20(n)) {
          if (n <= 0) {
            return isFinite(n) ? Infinity : NaN;
          }

          if (n > 171) {
            return Infinity;                  // Will overflow
          }

          var value = n - 2;
          var res = n - 1;
          while (value > 1) {
            res *= value;
            value--;
          }

          if (res == 0) {
            res = 1;                          // 0! is per definition 1
          }

          return res;
        }

        if (n < 0.5) {
          return Math.PI / (Math.sin(Math.PI * n) * gamma(1-n));
        }

        if (n >= 171.35) {
          return Infinity;                    // will overflow
        }

        if (n > 85.0) {                       // Extended Stirling Approx
          var twoN = n*n;
          var threeN = twoN*n;
          var fourN = threeN*n;
          var fiveN = fourN*n;
          return Math.sqrt(2*Math.PI/n) * Math.pow((n/Math.E), n) *
              (1 + 1/(12*n) + 1/(288*twoN) - 139/(51840*threeN) -
              571/(2488320*fourN) + 163879/(209018880*fiveN) +
              5246819/(75246796800*fiveN*n));
        }

        --n;
        x = p[0];
        for (var i = 1; i < p.length; ++i) {
          x += p[i] / (n+i);
        }

        t = n + g + 0.5;
        return Math.sqrt(2*Math.PI) * Math.pow(t, n+0.5) * Math.exp(-t) * x;
      },

      'Complex': function (n) {
        var t, x;

        if (n.im == 0) {
          return gamma(n.re);
        }

        n = new type.Complex(n.re - 1, n.im);
        x = new type.Complex(p[0], 0);
        for (var i = 1; i < p.length; ++i) {
          var real = n.re + i;                // x += p[i]/(n+i)
          var den = real*real + n.im*n.im;
          if (den != 0) {
            x.re += p[i] * real / den;
            x.im += -(p[i] * n.im) / den;
          } else {
            x.re = p[i] < 0
                ? -Infinity
                :  Infinity;
          }
        }

        t = new type.Complex(n.re + g + 0.5, n.im);
        var twoPiSqrt = Math.sqrt(2*Math.PI);

        n.re += 0.5;
        var result = pow(t, n);
        if (result.im == 0) {                 // sqrt(2*PI)*result
          result.re *= twoPiSqrt;
        } else if (result.re == 0) {
          result.im *= twoPiSqrt;
        } else {
          result.re *= twoPiSqrt;
          result.im *= twoPiSqrt;
        }

        var r = Math.exp(-t.re);              // exp(-t)
        t.re = r * Math.cos(-t.im);
        t.im = r * Math.sin(-t.im);

        return multiply(multiply(result, t), x);
      },

      'BigNumber': function (n) {
        if (n.isInteger()) {
          return (n.isNegative() || n.isZero())
              ? new type.BigNumber(Infinity)
              : bigFactorial(n.minus(1));
        }

        if (!n.isFinite()) {
          return new type.BigNumber(n.isNegative() ? NaN : Infinity);
        }

        throw new Error('Integer BigNumber expected');
      },

      'Array | Matrix': function (n) {
        return deepMap(n, gamma);
      }
    });

    /**
     * Calculate factorial for a BigNumber
     * @param {BigNumber} n
     * @returns {BigNumber} Returns the factorial of n
     */
    function bigFactorial(n) {
      if (n.isZero()) {
        return new type.BigNumber(1); // 0! is per definition 1
      }

      var precision = config.precision + (Math.log(n.toNumber()) | 0);
      var Big = type.BigNumber.clone({precision: precision});

      var res = new Big(n);
      var value = n.toNumber() - 1; // number
      while (value > 1) {
        res = res.times(value);
        value--;
      }

      return new type.BigNumber(res.toPrecision(type.BigNumber.precision));
    }

    gamma.toTex = {1: '\\Gamma\\left(${args[0]}\\right)'};

    return gamma;
  }

  // TODO: comment on the variables g and p

  var g = 4.7421875;

  var p = [
    0.99999999999999709182,
    57.156235665862923517,
    -59.597960355475491248,
    14.136097974741747174,
    -0.49191381609762019978,
    0.33994649984811888699e-4,
    0.46523628927048575665e-4,
    -0.98374475304879564677e-4,
    0.15808870322491248884e-3,
    -0.21026444172410488319e-3,
    0.21743961811521264320e-3,
    -0.16431810653676389022e-3,
    0.84418223983852743293e-4,
    -0.26190838401581408670e-4,
    0.36899182659531622704e-5
  ];

  var name$168 = 'gamma';
  var factory_1$179 = factory$180;

  var gamma$1 = {
  	name: name$168,
  	factory: factory_1$179
  };

  function factory$181 (type, config, load, typed) {
    var gamma = load(gamma$1);
    var latex$$1 = latex;

    /**
     * Compute the factorial of a value
     *
     * Factorial only supports an integer value as argument.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.factorial(n)
     *
     * Examples:
     *
     *    math.factorial(5);    // returns 120
     *    math.factorial(3);    // returns 6
     *
     * See also:
     *
     *    combinations, gamma, permutations
     *
     * @param {number | BigNumber | Array | Matrix} n   An integer number
     * @return {number | BigNumber | Array | Matrix}    The factorial of `n`
     */
    var factorial = typed('factorial', {
      'number': function (n) {
        if (n < 0) {
          throw new Error('Value must be non-negative');
        }

        return gamma(n + 1);
      },

      'BigNumber': function (n) {
        if (n.isNegative()) {
          throw new Error('Value must be non-negative');
        }

        return gamma(n.plus(1));
      },

      'Array | Matrix': function (n) {
        return deepMap(n, factorial);
      }
    });

    factorial.toTex = {
      1: '\\left(${args[0]}\\right)' + latex$$1.operators['factorial']
    };

    return factorial;
  }

  var name$169 = 'factorial';
  var factory_1$180 = factory$181;

  var factorial$1 = {
  	name: name$169,
  	factory: factory_1$180
  };

  var isInteger$21 = number.isInteger;

  function factory$182 (type, config, load, typed) {
    /**
     * Compute the number of ways of picking `k` unordered outcomes from `n`
     * possibilities.
     *
     * Combinations only takes integer arguments.
     * The following condition must be enforced: k <= n.
     *
     * Syntax:
     *
     *     math.combinations(n, k)
     *
     * Examples:
     *
     *    math.combinations(7, 5); // returns 21
     *
     * See also:
     *
     *    permutations, factorial
     *
     * @param {number | BigNumber} n    Total number of objects in the set
     * @param {number | BigNumber} k    Number of objects in the subset
     * @return {number | BigNumber}     Number of possible combinations.
     */
    var combinations = typed('combinations', {
      'number, number': function (n, k) {
        var max, result, i;

        if (!isInteger$21(n) || n < 0) {
          throw new TypeError('Positive integer value expected in function combinations');
        }
        if (!isInteger$21(k) || k < 0) {
          throw new TypeError('Positive integer value expected in function combinations');
        }
        if (k > n) {
          throw new TypeError('k must be less than or equal to n');
        }

        max = Math.max(k, n - k);
        result = 1;
        for (i = 1; i <= n - max; i++) {
          result = result * (max + i) / i;
        }

        return result;
      },

      'BigNumber, BigNumber': function (n, k) {
        var max, result, i, ii;
        var one = new type.BigNumber(1);

        if (!isPositiveInteger(n) || !isPositiveInteger(k)) {
          throw new TypeError('Positive integer value expected in function combinations');
        }
        if (k.gt(n)) {
          throw new TypeError('k must be less than n in function combinations');
        }

        max = n.minus(k);
        if (k.lt(max)) max = k;
        result = one;
        for (i = one, ii = n.minus(max); i.lte(ii); i = i.plus(1)) {
          result = result.times(max.plus(i)).dividedBy(i);
        }

        return result;
      }

      // TODO: implement support for collection in combinations
    });

    combinations.toTex = {2: '\\binom{${args[0]}}{${args[1]}}'};

    return combinations;
  }

  /**
   * Test whether BigNumber n is a positive integer
   * @param {BigNumber} n
   * @returns {boolean} isPositiveInteger
   */
  function isPositiveInteger(n) {
    return n.isInteger() && n.gte(0);
  }

  var name$170 = 'combinations';
  var factory_1$181 = factory$182;

  var combinations$1 = {
  	name: name$170,
  	factory: factory_1$181
  };

  function factory$183 (type, config, load, typed) {
    /**
     * Test whether a value is an integer number.
     * The function supports `number`, `BigNumber`, and `Fraction`.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isInteger(x)
     *
     * Examples:
     *
     *    math.isInteger(2);                     // returns true
     *    math.isInteger(0);                     // returns true
     *    math.isInteger(0.5);                   // returns false
     *    math.isInteger(math.bignumber(500));   // returns true
     *    math.isInteger(math.fraction(4));      // returns true
     *    math.isInteger('3');                   // returns true
     *    math.isInteger([3, 0.5, -2]);          // returns [true, false, true]
     *    math.isInteger(math.complex('2-4i');   // throws an error
     *
     * See also:
     *
     *    isNumeric, isPositive, isNegative, isZero
     *
     * @param {number | BigNumber | Fraction | Array | Matrix} x   Value to be tested
     * @return {boolean}  Returns true when `x` contains a numeric, integer value.
     *                    Throws an error in case of an unknown data type.
     */
    var isInteger = typed('isInteger', {
      'number': number.isInteger, // TODO: what to do with isInteger(add(0.1, 0.2))  ?

      'BigNumber': function (x) {
        return x.isInt();
      },

      'Fraction': function (x) {
        return x.d === 1 && isFinite(x.n);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, isInteger);
      }
    });

    return isInteger;
  }

  var name$171 = 'isInteger';
  var factory_1$182 = factory$183;

  var isInteger$22 = {
  	name: name$171,
  	factory: factory_1$182
  };

  function factory$184 (type, config, load, typed) {
    var add$$1 = load(add);
    var subtract = load(subtract$1);
    var multiply = load(multiply$1);
    var divide = load(divide$1);
    var pow = load(pow$1);
    var factorial = load(factorial$1);
    var combinations = load(combinations$1);
    var isNegative = load(isNegative$1);
    var isInteger = load(isInteger$22);
    var larger$$1 = load(larger);

    /**
     * The Stirling numbers of the second kind, counts the number of ways to partition
     * a set of n labelled objects into k nonempty unlabelled subsets.
     * stirlingS2 only takes integer arguments.
     * The following condition must be enforced: k <= n.
     *
     *  If n = k or k = 1, then s(n,k) = 1
     *
     * Syntax:
     *
     *   math.stirlingS2(n, k)
     *
     * Examples:
     *
     *    math.stirlingS2(5, 3); //returns 25
     *
     * See also:
     *
     *    Bell numbers
     *
     * @param {Number | BigNumber} n    Total number of objects in the set
     * @param {Number | BigNumber} k    Number of objects in the subset
     * @return {Number | BigNumber}     S(n,k)
     */
    var stirlingS2 = typed('stirlingS2', {
      'number | BigNumber, number | BigNumber': function (n, k) {
        if (!isInteger(n) || isNegative(n) || !isInteger(k) || isNegative(k)) {
          throw new TypeError('Non-negative integer value expected in function stirlingS2');
        }
        else if (larger$$1(k, n)) {
          throw new TypeError('k must be less than or equal to n in function stirlingS2');
        }

        // 1/k! Sum(i=0 -> k) [(-1)^(k-i)*C(k,j)* i^n]
        var kFactorial = factorial(k);
        var result = 0;
        for(var i = 0; i <= k; i++) {
          var negativeOne = pow(-1, subtract(k,i));
          var kChooseI = combinations(k,i);
          var iPower = pow(i,n);

          result = add$$1(result, multiply(multiply(kChooseI, iPower), negativeOne));
        }

        return divide(result, kFactorial);
      }
    });

    stirlingS2.toTex = {2: '\\mathrm{S}\\left(${args}\\right)'};

    return stirlingS2;
  }

  var name$172 = 'stirlingS2';
  var factory_1$183 = factory$184;

  var stirlingS2$1 = {
  	name: name$172,
  	factory: factory_1$183
  };

  function factory$185 (type, config, load, typed) {
    var add$$1 = load(add);
    var stirlingS2 = load(stirlingS2$1);
    var isNegative = load(isNegative$1);
    var isInteger = load(isInteger$22);

    /**
     * The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S.
     * bellNumbers only takes integer arguments.
     * The following condition must be enforced: n >= 0
     *
     * Syntax:
     *
     *   math.bellNumbers(n)
     *
     * Examples:
     *
     *    math.bellNumbers(3); // returns 5;
     *    math.bellNumbers(8); // returns 4140;
     *
     * See also:
     *
     *    stirlingS2
     *
     * @param {Number | BigNumber} n    Total number of objects in the set
     * @return {Number | BigNumber}     B(n)
     */
    var bellNumbers = typed('bellNumbers', {
      'number | BigNumber': function (n) {

        if (!isInteger(n) || isNegative(n)) {
          throw new TypeError('Non-negative integer value expected in function bellNumbers');
        }

        // Sum (k=0, n) S(n,k).
        var result = 0;
        for(var i = 0; i <= n; i++) {
          result = add$$1(result, stirlingS2(n, i));
        }

        return result;
      }
    });

    bellNumbers.toTex = {1: '\\mathrm{B}_{${args[0]}}'};

    return bellNumbers;
  }

  var name$173 = 'bellNumbers';
  var factory_1$184 = factory$185;

  var bellNumbers$1 = {
  	name: name$173,
  	factory: factory_1$184
  };

  function factory$186 (type, config, load, typed) {
    var combinations = load(combinations$1);
    var add = load(addScalar);
    var isPositive = load(isPositive$1);
    var isInteger = load(isInteger$22);
    var larger$$1 = load(larger);

    /**
     * The composition counts of n into k parts.
     *
     * composition only takes integer arguments.
     * The following condition must be enforced: k <= n.
     *
     * Syntax:
     *
     *   math.composition(n, k)
     *
     * Examples:
     *
     *    math.composition(5, 3); // returns 6
     *
     * See also:
     *
     *    combinations
     *
     * @param {Number | BigNumber} n    Total number of objects in the set
     * @param {Number | BigNumber} k    Number of objects in the subset
     * @return {Number | BigNumber}     Returns the composition counts of n into k parts.
     */
    var composition =  typed('composition', {
      'number | BigNumber, number | BigNumber': function (n, k) {
        if (!isInteger(n) || !isPositive(n) || !isInteger(k) || !isPositive(k)) {
          throw new TypeError('Positive integer value expected in function composition');
        }
        else if (larger$$1(k, n)) {
          throw new TypeError('k must be less than or equal to n in function composition');
        }

        return combinations(add(n, -1), add(k, -1));
      }
    });

    composition.toTex = undefined; // use default template

    return composition;
  }

  var name$174 = 'composition';
  var factory_1$185 = factory$186;

  var composition$1 = {
  	name: name$174,
  	factory: factory_1$185
  };

  function factory$187 (type, config, load, typed) {
    var add$$1 = load(add);
    var divide = load(divide$1);
    var multiply = load(multiply$1);
    var combinations = load(combinations$1);
    var isNegative = load(isNegative$1);
    var isInteger = load(isInteger$22);


    /**
     * The Catalan Numbers enumerate combinatorial structures of many different types.
     * catalan only takes integer arguments.
     * The following condition must be enforced: n >= 0
     *
     * Syntax:
     *
     *   math.catalan(n)
     *
     * Examples:
     *
     *    math.catalan(3); // returns 5;
     *    math.catalan(8); // returns 1430;
     *
     * See also:
     *
     *    bellNumbers
     *
     * @param {Number | BigNumber} n    nth Catalan number
     * @return {Number | BigNumber}     Cn(n)
     */
    var catalan = typed('catalan', {
      'number | BigNumber': function (n) {

        if (!isInteger(n) || isNegative(n)) {
          throw new TypeError('Non-negative integer value expected in function catalan');
        }
         
        return divide(combinations(multiply(n,2), n), add$$1(n,1));

      }
    });

    catalan.toTex = {1: '\\mathrm{C}_{${args[0]}}'};

    return catalan;
  }

  var name$175 = 'catalan';
  var factory_1$186 = factory$187;

  var catalan$1 = {
  	name: name$175,
  	factory: factory_1$186
  };

  var combinatorics = [
    bellNumbers$1,
    composition$1,
    stirlingS2$1,
    catalan$1
  ];

  function factory$188 (type, config, load, typed) {
    /**
     * Compute the argument of a complex value.
     * For a complex number `a + bi`, the argument is computed as `atan2(b, a)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.arg(x)
     *
     * Examples:
     *
     *    var a = math.complex(2, 2);
     *    math.arg(a) / math.pi;          // returns number 0.25
     *
     *    var b = math.complex('2 + 3i');
     *    math.arg(b);                    // returns number 0.982793723247329
     *    math.atan2(3, 2);               // returns number 0.982793723247329
     *
     * See also:
     *
     *    re, im, conj, abs
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            A complex number or array with complex numbers
     * @return {number | BigNumber | Array | Matrix} The argument of x
     */
    var arg = typed('arg', {
      'number': function (x) {
        return Math.atan2(0, x);
      },

      'BigNumber': function (x) {
        return type.BigNumber.atan2(0, x);
      },

      'Complex': function (x) {
        return x.arg();
      },

      // TODO: implement BigNumber support for function arg

      'Array | Matrix': function (x) {
        return deepMap(x, arg);
      }
    });

    arg.toTex = {1: '\\arg\\left(${args[0]}\\right)'};

    return arg;
  }

  var name$176 = 'arg';
  var factory_1$187 = factory$188;

  var arg$1 = {
  	name: name$176,
  	factory: factory_1$187
  };

  function factory$189 (type, config, load, typed) {
    /**
     * Get the imaginary part of a complex number.
     * For a complex number `a + bi`, the function returns `b`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.im(x)
     *
     * Examples:
     *
     *    var a = math.complex(2, 3);
     *    math.re(a);                     // returns number 2
     *    math.im(a);                     // returns number 3
     *
     *    math.re(math.complex('-5.2i')); // returns number -5.2
     *    math.re(math.complex(2.4));     // returns number 0
     *
     * See also:
     *
     *    re, conj, abs, arg
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            A complex number or array with complex numbers
     * @return {number | BigNumber | Array | Matrix} The imaginary part of x
     */
    var im = typed('im', {
      'number': function (x) {
        return 0;
      },

      'BigNumber': function (x) {
        return new type.BigNumber(0);
      },

      'Complex': function (x) {
        return x.im;
      },

      'Array | Matrix': function (x) {
        return deepMap(x, im);
      }
    });

    im.toTex = {1: '\\Im\\left\\lbrace${args[0]}\\right\\rbrace'};

    return im;
  }

  var name$177 = 'im';
  var factory_1$188 = factory$189;

  var im$1 = {
  	name: name$177,
  	factory: factory_1$188
  };

  function factory$190 (type, config, load, typed) {
    /**
     * Get the real part of a complex number.
     * For a complex number `a + bi`, the function returns `a`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.re(x)
     *
     * Examples:
     *
     *    var a = math.complex(2, 3);
     *    math.re(a);                     // returns number 2
     *    math.im(a);                     // returns number 3
     *
     *    math.re(math.complex('-5.2i')); // returns number 0
     *    math.re(math.complex(2.4));     // returns number 2.4
     *
     * See also:
     *
     *    im, conj, abs, arg
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x
     *            A complex number or array with complex numbers
     * @return {number | BigNumber | Array | Matrix} The real part of x
     */
    var re = typed('re', {
      'number': function (x) {
        return x;
      },

      'BigNumber': function (x) {
        return x;
      },

      'Complex': function (x) {
        return x.re;
      },

      'Array | Matrix': function (x) {
        return deepMap(x, re);
      }
    });

    re.toTex = {1: '\\Re\\left\\lbrace${args[0]}\\right\\rbrace'};

    return re;
  }

  var name$178 = 're';
  var factory_1$189 = factory$190;

  var re$1 = {
  	name: name$178,
  	factory: factory_1$189
  };

  var complex$5 = [
    arg$1,
    conj$1,
    im$1,
    re$1
  ];

  function factory$191 (type, config, load, typed) {

    var abs = load(abs$1);
    var add$$1 = load(add);
    var addScalar$$1 = load(addScalar);
    var matrix$$1 = load(matrix);
    var multiply = load(multiply$1);
    var multiplyScalar$$1 = load(multiplyScalar);
    var divideScalar$$1 = load(divideScalar);
    var subtract = load(subtract$1);
    var smaller$$1 = load(smaller);
    var equalScalar$$1 = load(equalScalar);

    /**
     * Calculates the point of intersection of two lines in two or three dimensions
     * and of a line and a plane in three dimensions. The inputs are in the form of
     * arrays or 1 dimensional matrices. The line intersection functions return null
     * if the lines do not meet.
     *
     * Note: Fill the plane coefficients as `x + y + z = c` and not as `x + y + z + c = 0`.
     *
     * Syntax:
     *
     *    math.intersect(endPoint1Line1, endPoint2Line1, endPoint1Line2, endPoint2Line2)
     *    math.intersect(endPoint1, endPoint2, planeCoefficients)
     *
     * Examples:
     *
     *    math.intersect([0, 0], [10, 10], [10, 0], [0, 10]);              // Returns [5, 5]
     *    math.intersect([0, 0, 0], [10, 10, 0], [10, 0, 0], [0, 10, 0]);  // Returns [5, 5, 0]
     *    math.intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6]);            // Returns [7, -4, 3]
     *
     * @param  {Array | Matrix} w   Co-ordinates of first end-point of first line
     * @param  {Array | Matrix} x   Co-ordinates of second end-point of first line
     * @param  {Array | Matrix} y   Co-ordinates of first end-point of second line
     *                              OR Co-efficients of the plane's equation
     * @param  {Array | Matrix} z   Co-ordinates of second end-point of second line
     *                              OR null if the calculation is for line and plane
     * @return {Array}              Returns the point of intersection of lines/lines-planes
     */
    var intersect = typed('intersect', {
      'Array, Array, Array': function (x, y, plane) {
        if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
        if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }
        if (!_4d(plane)) { throw new TypeError('Array with 4 numbers expected as third argument'); }

        return _intersectLinePlane(x[0], x[1], x[2], y[0], y[1], y[2], plane[0], plane[1], plane[2], plane[3]);
      },

      'Array, Array, Array, Array': function (w, x, y, z) {
        if (w.length === 2) {
          if (!_2d(w)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
          if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument'); }
          if (!_2d(y)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument'); }
          if (!_2d(z)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for fourth argument'); }

          return _intersect2d(w, x, y, z);
        }
        else if (w.length === 3) {
          if (!_3d(w)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
          if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }
          if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for third argument'); }
          if (!_3d(z)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for fourth argument'); }

          return _intersect3d(w[0], w[1], w[2], x[0], x[1], x[2], y[0], y[1], y[2], z[0], z[1], z[2]);
        }
        else {
          throw new TypeError('Arrays with two or thee dimensional points expected');
        }
      },

      'Matrix, Matrix, Matrix': function (x, y, plane) {
        return matrix$$1(intersect(x.valueOf(), y.valueOf(), plane.valueOf()));
      },

      'Matrix, Matrix, Matrix, Matrix': function (w, x, y, z) {
        // TODO: output matrix type should match input matrix type
        return matrix$$1(intersect(w.valueOf(), x.valueOf(), y.valueOf(), z.valueOf()));
      }
    });

    function _isNumber(a) {
      // intersect supports numbers and bignumbers
      return (typeof a === 'number' || type.isBigNumber(a));
    }

    function _2d(x) {
      return x.length === 2 && _isNumber(x[0]) && _isNumber(x[1]);
    }

    function _3d(x) {
      return x.length === 3 && _isNumber(x[0]) && _isNumber(x[1]) && _isNumber(x[2]);
    }

    function _4d(x) {
      return x.length === 4 && _isNumber(x[0]) && _isNumber(x[1]) && _isNumber(x[2]) && _isNumber(x[3]);
    }

    function _intersect2d(p1a, p1b, p2a, p2b){
      var o1 = p1a;
      var o2 = p2a;
      var d1 = subtract(o1, p1b);
      var d2 = subtract(o2, p2b);
      var det = subtract(multiplyScalar$$1(d1[0], d2[1]), multiplyScalar$$1(d2[0], d1[1]));
      if (smaller$$1(abs(det), config.epsilon)) {
        return null;
      }
      var d20o11 = multiplyScalar$$1(d2[0], o1[1]);
      var d21o10 = multiplyScalar$$1(d2[1], o1[0]);
      var d20o21 = multiplyScalar$$1(d2[0], o2[1]);
      var d21o20 = multiplyScalar$$1(d2[1], o2[0]);
      var t = divideScalar$$1(addScalar$$1(subtract(subtract(d20o11, d21o10), d20o21), d21o20), det);
      return add$$1(multiply(d1, t), o1);
    }

    function _intersect3dHelper(a, b, c, d, e, f, g, h, i, j, k, l){
        // (a - b)*(c - d) + (e - f)*(g - h) + (i - j)*(k - l)
        var add1 = multiplyScalar$$1(subtract(a, b), subtract(c, d));
        var add2 = multiplyScalar$$1(subtract(e, f), subtract(g, h));
        var add3 = multiplyScalar$$1(subtract(i, j), subtract(k, l));
        return addScalar$$1(addScalar$$1(add1, add2), add3);
    }

    function _intersect3d(x1, y1, z1, x2, y2, z2, x3, y3, z3, x4, y4, z4){
      var d1343 = _intersect3dHelper(x1, x3, x4, x3, y1, y3, y4, y3, z1, z3, z4, z3);
      var d4321 = _intersect3dHelper(x4, x3, x2, x1, y4, y3, y2, y1, z4, z3, z2, z1);
      var d1321 = _intersect3dHelper(x1, x3, x2, x1, y1, y3, y2, y1, z1, z3, z2, z1);
      var d4343 = _intersect3dHelper(x4, x3, x4, x3, y4, y3, y4, y3, z4, z3, z4, z3);
      var d2121 = _intersect3dHelper(x2, x1, x2, x1, y2, y1, y2, y1, z2, z1, z2, z1);
      var ta = divideScalar$$1(
        subtract(multiplyScalar$$1(d1343, d4321), multiplyScalar$$1(d1321, d4343)),
        subtract(multiplyScalar$$1(d2121, d4343), multiplyScalar$$1(d4321, d4321)));
      var tb = divideScalar$$1(addScalar$$1(d1343, multiplyScalar$$1(ta, d4321)), d4343);

      var pax = addScalar$$1(x1, multiplyScalar$$1(ta, subtract(x2, x1)));
      var pay = addScalar$$1(y1, multiplyScalar$$1(ta, subtract(y2, y1)));
      var paz = addScalar$$1(z1, multiplyScalar$$1(ta, subtract(z2, z1)));
      var pbx = addScalar$$1(x3, multiplyScalar$$1(tb, subtract(x4, x3)));
      var pby = addScalar$$1(y3, multiplyScalar$$1(tb, subtract(y4, y3)));
      var pbz = addScalar$$1(z3, multiplyScalar$$1(tb, subtract(z4, z3)));
      if (equalScalar$$1(pax, pbx) && equalScalar$$1(pay, pby) && equalScalar$$1(paz, pbz)){
        return [pax, pay, paz];
      }
      else{
        return null;
      }
    }

    function _intersectLinePlane(x1, y1, z1, x2, y2, z2, x, y, z, c){
      var x1x = multiplyScalar$$1(x1, x);
      var x2x = multiplyScalar$$1(x2, x);
      var y1y = multiplyScalar$$1(y1, y);
      var y2y = multiplyScalar$$1(y2, y);
      var z1z = multiplyScalar$$1(z1, z);
      var z2z = multiplyScalar$$1(z2, z);
      var t = divideScalar$$1(
        subtract(subtract(subtract(c, x1x), y1y), z1z),
        subtract(subtract(subtract(addScalar$$1(addScalar$$1(x2x, y2y), z2z), x1x), y1y), z1z));
      var px = addScalar$$1(x1, multiplyScalar$$1(t, subtract(x2, x1)));
      var py = addScalar$$1(y1, multiplyScalar$$1(t, subtract(y2, y1)));
      var pz = addScalar$$1(z1, multiplyScalar$$1(t, subtract(z2, z1)));
      return [px, py, pz];
      // TODO: Add cases when line is parallel to the plane:
      //       (a) no intersection,
      //       (b) line contained in plane
    }

    return intersect;
  }

  var name$179 = 'intersect';
  var factory_1$190 = factory$191;

  var intersect$1 = {
  	name: name$179,
  	factory: factory_1$190
  };

  function factory$192 (type, config, load, typed) {
    var matrix$$1 = load(matrix);
    var add = load(addScalar);
    var subtract = load(subtract$1);
    var multiply = load(multiplyScalar);
    var divide = load(divideScalar);
    var negate = load(unaryMinus$1);
    var sqrt = load(sqrt$1);
    var abs = load(abs$1);

    /**
      * Calculates:
      *    The eucledian distance between two points in 2 and 3 dimensional spaces.
      *    Distance between point and a line in 2 and 3 dimensional spaces.
      *    Pairwise distance between a set of 2D or 3D points
      * NOTE:
      *    When substituting coefficients of a line(a, b and c), use ax + by + c = 0 instead of ax + by = c
      *    For parametric equation of a 3D line, x0, y0, z0, a, b, c are from: (x−x0, y−y0, z−z0) = t(a, b, c)
      *
      * Syntax:
      *    math.distance([x1, y1], [x2, y2])
      *-   math.distance({pointOneX: 4, pointOneY: 5}, {pointTwoX: 2, pointTwoY: 7})
      *    math.distance([x1, y1, z1], [x2, y2, z2])
      *    math.distance({pointOneX: 4, pointOneY: 5, pointOneZ: 8}, {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})
      *    math.distance([[A], [B], [C]...])
      *    math.distance([x1, y1], [LinePtX1, LinePtY1], [LinePtX2, LinePtY2])
      *    math.distance({pointX: 1, pointY: 4}, {lineOnePtX: 6, lineOnePtY: 3}, {lineTwoPtX: 2, lineTwoPtY: 8})
      *    math.distance([x1, y1, z1], [LinePtX1, LinePtY1, LinePtZ1], [LinePtX2, LinePtY2, LinePtZ2])
      *    math.distance({pointX: 1, pointY: 4, pointZ: 7}, {lineOnePtX: 6, lineOnePtY: 3, lineOnePtZ: 4}, {lineTwoPtX: 2, lineTwoPtY: 8, lineTwoPtZ: 5})
      *    math.distance([x1, y1], [xCoeffLine, yCoeffLine, constant])
      *    math.distance({pointX: 10, pointY: 10}, {xCoeffLine: 8, yCoeffLine: 1, constant: 3})
      *    math.distance([x1, y1, z1], [x0, y0, z0, a-tCoeff, b-tCoeff, c-tCoeff]) point and parametric equation of 3D line
      *    math.distance([x, y, z], [x0, y0, z0, a, b, c])
      *    math.distance({pointX: 2, pointY: 5, pointZ: 9}, {x0: 4, y0: 6, z0: 3, a: 4, b: 2, c: 0})
      *
      * Examples:
      *    math.distance([0,0], [4,4])                     // Returns 5.6569
      *    math.distance(
      *     {pointOneX: 0, pointOneY: 0},
      *     {pointTwoX: 10, pointTwoY: 10})                // Returns 14.142135623730951
      *    math.distance([1, 0, 1], [4, -2, 2])            // Returns 3.74166
      *    math.distance(
      *     {pointOneX: 4, pointOneY: 5, pointOneZ: 8},
      *     {pointTwoX: 2, pointTwoY: 7, pointTwoZ: 9})    // Returns 3
      *    math.distance([[1, 2], [1, 2], [1, 3]])         // Returns [0, 1, 1]
      *    math.distance([[1,2,4], [1,2,6], [8,1,3]])      // Returns [2, 7.14142842854285, 7.681145747868608]
      *    math.distance([10, 10], [8, 1, 3])              // Returns 11.535230316796387
      *    math.distance([10, 10], [2, 3], [-8, 0])        // Returns 8.759953130362847
      *    math.distance(
      *     {pointX: 1, pointY: 4},
      *     {lineOnePtX: 6, lineOnePtY: 3},
      *     {lineTwoPtX: 2, lineTwoPtY: 8})                // Returns 2.720549372624744
      *    math.distance([2, 3, 1], [1, 1, 2, 5, 0, 1])    // Returns 2.3204774044612857
      *    math.distance(
      *     {pointX: 2, pointY: 3, pointZ: 1},
      *     {x0: 1, y0: 1, z0: 2, a: 5, b: 0, c: 1}        // Returns 2.3204774044612857
      *
      * @param {Array | Matrix | Object} x    Co-ordinates of first point
      * @param {Array | Matrix | Object} y    Co-ordinates of second point
      * @return {Number | BigNumber} Returns the distance from two/three points
    */

    var distance = typed('distance', {
      'Array, Array, Array': function(x, y, z){
        // Point to Line 2D; (x=Point, y=LinePoint1, z=LinePoint2)
        if (x.length == 2 && y.length == 2 && z.length == 2){
          if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
          if (!_2d(y)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument'); }
          if (!_2d(z)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for third argument'); }
          var m = divide(subtract(z[1], z[0]), subtract(y[1], y[0]));
          var xCoeff = multiply(multiply(m, m), y[0]);
          var yCoeff = negate(multiply(m, y[0]));
          var constant = x[1];

          return _distancePointLine2D(x[0], x[1], xCoeff, yCoeff, constant);
        }
        else{
          throw new TypeError('Invalid Arguments: Try again');
        }
      },
      'Object, Object, Object': function(x, y, z){
        if (Object.keys(x).length == 2 && Object.keys(y).length == 2 && Object.keys(z).length == 2){
          if (!_2d(x)) { throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers'); }
          if (!_2d(y)) { throw new TypeError('Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers'); }
          if (!_2d(z)) { throw new TypeError('Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers'); }
          if (x.hasOwnProperty('pointX') && x.hasOwnProperty('pointY') && y.hasOwnProperty('lineOnePtX') &&
            y.hasOwnProperty('lineOnePtY') && z.hasOwnProperty('lineTwoPtX') && z.hasOwnProperty('lineTwoPtY')){
            var m = divide(subtract(z.lineTwoPtY, z.lineTwoPtX), subtract(y.lineOnePtY, y.lineOnePtX));
            var xCoeff = multiply(multiply(m, m), y.lineOnePtX);
            var yCoeff = negate(multiply(m, y.lineOnePtX));
            var constant = x.pointX;

            return _distancePointLine2D(x.pointX, x.pointY, xCoeff, yCoeff, constant);
          }
          else{
            throw new TypeError('Key names do not match');
          }
        }
        else{
          throw new TypeError('Invalid Arguments: Try again');
        }
      },
      'Array, Array': function(x, y){
        // Point to Line 2D; (x=[pointX, pointY], y=[x-coeff, y-coeff, const])
        if (x.length == 2 && y.length == 3){
          if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
          if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }

          return _distancePointLine2D(x[0], x[1], y[0], y[1], y[2]);
        }
        // Point to Line 3D
        else if (x.length == 3 && y.length == 6){
          if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
          if (!_parametricLine(y)) { throw new TypeError('Array with 6 numbers or BigNumbers expected for second argument'); }

          return _distancePointLine3D(x[0], x[1], x[2], y[0], y[1], y[2], y[3], y[4], y[5]);
        }
        // Point to Point 2D
        else if (x.length == 2 && y.length == 2){
          if (!_2d(x)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for first argument'); }
          if (!_2d(y)) { throw new TypeError('Array with 2 numbers or BigNumbers expected for second argument'); }

          return _distance2d(x[0], x[1], y[0], y[1]);
        }
        // Point to Point 3D
        else if(x.length == 3 && y.length == 3){
          if (!_3d(x)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for first argument'); }
          if (!_3d(y)) { throw new TypeError('Array with 3 numbers or BigNumbers expected for second argument'); }

          return _distance3d(x[0], x[1], x[2], y[0], y[1], y[2]);
        }
        else{
          throw new TypeError('Invalid Arguments: Try again');
        }
      },
      'Object, Object': function(x, y){
        if (Object.keys(x).length == 2 && Object.keys(y).length == 3){
          if (!_2d(x)) { throw new TypeError('Values of pointX and pointY should be numbers or BigNumbers'); }
          if (!_3d(y)) { throw new TypeError('Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers'); }
          if (x.hasOwnProperty('pointX') && x.hasOwnProperty('pointY') && y.hasOwnProperty('xCoeffLine') &&
            y.hasOwnProperty('yCoeffLine') && y.hasOwnProperty('constant')){

            return _distancePointLine2D(x.pointX, x.pointY, y.xCoeffLine, y.yCoeffLine, y.constant);
          }
          else{
            throw new TypeError('Key names do not match');
          }
        }
        // Point to Line 3D
        else if (Object.keys(x).length == 3 && Object.keys(y).length == 6){
          if (!_3d(x)) { throw new TypeError('Values of pointX, pointY and pointZ should be numbers or BigNumbers'); }
          if (!_parametricLine(y)) { throw new TypeError('Values of x0, y0, z0, a, b and c should be numbers or BigNumbers'); }
          if (x.hasOwnProperty('pointX') && x.hasOwnProperty('pointY') && y.hasOwnProperty('x0') &&
            y.hasOwnProperty('y0') && y.hasOwnProperty('z0') && y.hasOwnProperty('a') &&
            y.hasOwnProperty('b') && y.hasOwnProperty('c')){

            return _distancePointLine3D(x.pointX, x.pointY, x.pointZ, y.x0, y.y0, y.z0, y.a, y.b, y.c);
          }
          else{
            throw new TypeError('Key names do not match');
          }
        }
        // Point to Point 2D
        else if (Object.keys(x).length == 2 && Object.keys(y).length == 2){
          if (!_2d(x)) { throw new TypeError('Values of pointOneX and pointOneY should be numbers or BigNumbers'); }
          if (!_2d(y)) { throw new TypeError('Values of pointTwoX and pointTwoY should be numbers or BigNumbers'); }
          if (x.hasOwnProperty('pointOneX') && x.hasOwnProperty('pointOneY') &&
            y.hasOwnProperty('pointTwoX') && y.hasOwnProperty('pointTwoY')){

            return _distance2d(x.pointOneX, x.pointOneY, y.pointTwoX, y.pointTwoY);
          }
          else{
            throw new TypeError('Key names do not match');
          }
        }
        // Point to Point 3D
        else if(Object.keys(x).length == 3 && Object.keys(y).length == 3){
          if (!_3d(x)) { throw new TypeError('Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers'); }
          if (!_3d(y)) { throw new TypeError('Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers'); }
          if (x.hasOwnProperty('pointOneX') && x.hasOwnProperty('pointOneY') && x.hasOwnProperty('pointOneZ') &&
            y.hasOwnProperty('pointTwoX') && y.hasOwnProperty('pointTwoY') && y.hasOwnProperty('pointTwoZ')){

            return _distance3d(x.pointOneX, x.pointOneY, x.pointOneZ, y.pointTwoX, y.pointTwoY, y.pointTwoZ);
          }
          else {
            throw new TypeError('Key names do not match');
          }
        }
        else{
          throw new TypeError('Invalid Arguments: Try again');
        }
      },
      'Array': function(arr){
        if (!_pairwise(arr)) { throw new TypeError('Incorrect array format entered for pairwise distance calculation'); }

        return _distancePairwise(arr);
      }
    });

    function _isNumber(a) {
      // distance supports numbers and bignumbers
      return (typeof a === 'number' || type.isBigNumber(a));
    }

    function _2d(a){
      // checks if the number of arguments are correct in count and are valid (should be numbers)
      if (a.constructor !== Array){
        a = _objectToArray(a);
      }
      return _isNumber(a[0]) && _isNumber(a[1]);
    }

    function _3d(a){
      // checks if the number of arguments are correct in count and are valid (should be numbers)
      if (a.constructor !== Array){
        a = _objectToArray(a);
      }
      return _isNumber(a[0]) && _isNumber(a[1]) &&  _isNumber(a[2]);
    }

    function _parametricLine(a){
      if (a.constructor !== Array){
        a = _objectToArray(a);
      }
      return _isNumber(a[0]) && _isNumber(a[1]) && _isNumber(a[2]) &&
        _isNumber(a[3]) && _isNumber(a[4]) && _isNumber(a[5]);
    }

    function _objectToArray(o){
      var keys = Object.keys(o);
      var a = [];
      for (var i = 0; i < keys.length; i++) {
        a.push(o[keys[i]]);
      }
      return a;
    }

    function _pairwise(a){
      //checks for valid arguments passed to _distancePairwise(Array)
      if (a[0].length == 2 && _isNumber(a[0][0]) && _isNumber(a[0][1])){
        for(var i in a){
          if (a[i].length != 2 || !_isNumber(a[i][0]) || !_isNumber(a[i][1])){
            return false;
          }
        }
      }
      else if (a[0].length == 3 && _isNumber(a[0][0]) && _isNumber(a[0][1]) && _isNumber(a[0][2])){
        for(var i in a){
          if (a[i].length != 3 || !_isNumber(a[i][0]) || !_isNumber(a[i][1]) || !_isNumber(a[i][2])){
            return false;
          }
        }
      }
      else{
        return false;
      }
      return true;
    }

    function _distancePointLine2D(x, y, a, b, c){
      var num =  abs(add(add(multiply(a, x), multiply(b, y)), c));
      var den = sqrt(add(multiply(a, a), multiply(b, b)));
      var result = divide(num, den);
      return result;
    }

    function _distancePointLine3D(x, y, z, x0, y0, z0, a, b, c){
      var num = [ subtract(multiply(subtract(y0, y), c), multiply(subtract(z0, z), b)),
                  subtract(multiply(subtract(z0, z), a), multiply(subtract(x0, x), c)),
                  subtract(multiply(subtract(x0, x), b), multiply(subtract(y0, y), a)) ];
      num = sqrt(add(add(multiply(num[0], num[0]), multiply(num[1], num[1])), multiply(num[2], num[2])));
      var den = sqrt(add(add(multiply(a, a), multiply(b, b)), multiply(c, c)));
      var result = divide(num, den);
      return result;
    }

    function _distance2d(x1, y1, x2, y2){
      var yDiff = subtract(y2, y1);
      var xDiff = subtract(x2, x1);
      var radicant = add(multiply(yDiff, yDiff), multiply(xDiff, xDiff));
      var result = sqrt(radicant);
      return result;
    }

    function _distance3d(x1, y1, z1, x2, y2, z2){
      var zDiff = subtract(z2, z1);
      var yDiff = subtract(y2, y1);
      var xDiff = subtract(x2, x1);
      var radicant = add(add(multiply(zDiff, zDiff), multiply(yDiff, yDiff)), multiply(xDiff, xDiff));
      var result = sqrt(radicant);
      return result;
    }

    function _distancePairwise(a){
      var result = [];
      for(var i = 0; i < a.length-1; i++){
        for(var j = i+1; j < a.length; j++){
          if (a[0].length == 2){
            result.push(_distance2d(a[i][0], a[i][1], a[j][0], a[j][1]));
          }
          else if (a[0].length == 3){
            result.push(_distance3d(a[i][0], a[i][1], a[i][2], a[j][0], a[j][1], a[j][2]));
          }
        }
      }
      return result;
    }

    return distance;
  }

  var name$180 = 'distance';
  var factory_1$191 = factory$192;

  var distance$1 = {
  	name: name$180,
  	factory: factory_1$191
  };

  var geometry = [
    intersect$1,
    distance$1
  ];

  function factory$193 (type, config, load, typed) {
    var latex$$1 = latex;

    /**
     * Logical `not`. Flips boolean value of a given parameter.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.not(x)
     *
     * Examples:
     *
     *    math.not(2);      // returns false
     *    math.not(0);      // returns true
     *    math.not(true);   // returns false
     *
     *    a = [2, -7, 0];
     *    math.not(a);      // returns [false, false, true]
     *
     * See also:
     *
     *    and, or, xor
     *
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
     * @return {boolean | Array | Matrix}
     *            Returns true when input is a zero or empty value.
     */
    var not = typed('not', {
      'number': function (x) {
        return !x;
      },

      'Complex': function (x) {
        return x.re === 0 && x.im === 0;
      },

      'BigNumber': function (x) {
        return x.isZero() || x.isNaN();
      },

      'Unit': function (x) {
        return x.value !== null ? not(x.value) : true;
      },

      'Array | Matrix': function (x) {
        return deepMap(x, not);
      }
    });

    not.toTex = {
      1: latex$$1.operators['not'] + '\\left(${args[0]}\\right)'
    };

    return not;
  }

  var name$181 = 'not';
  var factory_1$192 = factory$193;

  var not$1 = {
  	name: name$181,
  	factory: factory_1$192
  };

  function factory$194 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);
    var zeros = load(zeros$1);
    var not = load(not$1);
    var isZero = load(isZero$1);

    var algorithm02$$1 = load(algorithm02);
    var algorithm06$$1 = load(algorithm06);
    var algorithm11$$1 = load(algorithm11);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Logical `and`. Test whether two values are both defined with a nonzero/nonempty value.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.and(x, y)
     *
     * Examples:
     *
     *    math.and(2, 4);   // returns true
     *
     *    a = [2, 0, 0];
     *    b = [3, 7, 0];
     *    c = 0;
     *
     *    math.and(a, b);   // returns [true, false, false]
     *    math.and(a, c);   // returns [false, false, false]
     *
     * See also:
     *
     *    not, or, xor
     *
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
     * @return {boolean | Array | Matrix}
     *            Returns true when both inputs are defined with a nonzero/nonempty value.
     */
    var and = typed('and', {

      'number, number': function (x, y) {
        return !!(x && y);
      },

      'Complex, Complex': function (x, y) {
        return (x.re !== 0 || x.im !== 0) && (y.re !== 0 || y.im !== 0);
      },

      'BigNumber, BigNumber': function (x, y) {
        return !x.isZero() && !y.isZero() && !x.isNaN() && !y.isNaN();
      },

      'Unit, Unit': function (x, y) {
        return and(x.value || 0, y.value || 0);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm06$$1(x, y, and, false);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm02$$1(y, x, and, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm02$$1(x, y, and, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, and);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return and(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return and(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return and(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        // check scalar
        if (not(y)) {
          // return zero matrix
          return zeros(x.size(), x.storage());
        }
        return algorithm11$$1(x, y, and, false);
      },

      'DenseMatrix, any': function (x, y) {
        // check scalar
        if (not(y)) {
          // return zero matrix
          return zeros(x.size(), x.storage());
        }
        return algorithm14$$1(x, y, and, false);
      },

      'any, SparseMatrix': function (x, y) {
        // check scalar
        if (not(x)) {
          // return zero matrix
          return zeros(x.size(), x.storage());
        }
        return algorithm11$$1(y, x, and, true);
      },

      'any, DenseMatrix': function (x, y) {
        // check scalar
        if (not(x)) {
          // return zero matrix
          return zeros(x.size(), x.storage());
        }
        return algorithm14$$1(y, x, and, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return and(matrix$$1(x), y).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return and(x, matrix$$1(y)).valueOf();
      }
    });

    and.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['and'] + '${args[1]}\\right)'
    };

    return and;
  }

  var name$182 = 'and';
  var factory_1$193 = factory$194;

  var and$1 = {
  	name: name$182,
  	factory: factory_1$193
  };

  function factory$195 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm05$$1 = load(algorithm05);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Logical `or`. Test if at least one value is defined with a nonzero/nonempty value.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.or(x, y)
     *
     * Examples:
     *
     *    math.or(2, 4);   // returns true
     *
     *    a = [2, 5, 0];
     *    b = [0, 22, 0];
     *    c = 0;
     *
     *    math.or(a, b);   // returns [true, true, false]
     *    math.or(b, c);   // returns [false, true, false]
     *
     * See also:
     *
     *    and, not, xor
     *
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
     * @return {boolean | Array | Matrix}
     *            Returns true when one of the inputs is defined with a nonzero/nonempty value.
     */
    var or = typed('or', {

      'number, number': function (x, y) {
        return !!(x || y);
      },

      'Complex, Complex': function (x, y) {
        return (x.re !== 0 || x.im !== 0) || (y.re !== 0 || y.im !== 0);
      },

      'BigNumber, BigNumber': function (x, y) {
        return (!x.isZero() && !x.isNaN()) || (!y.isZero() && !y.isNaN());
      },

      'Unit, Unit': function (x, y) {
        return or(x.value || 0, y.value || 0);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm05$$1(x, y, or);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, or, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, or, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, or);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return or(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return or(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return or(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, or, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, or, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, or, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, or, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, or, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, or, true).valueOf();
      }
    });

    or.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['or'] + '${args[1]}\\right)'
    };

    return or;
  }

  var name$183 = 'or';
  var factory_1$194 = factory$195;

  var or$1 = {
  	name: name$183,
  	factory: factory_1$194
  };

  function factory$196 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Logical `xor`. Test whether one and only one value is defined with a nonzero/nonempty value.
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.xor(x, y)
     *
     * Examples:
     *
     *    math.xor(2, 4);   // returns false
     *
     *    a = [2, 0, 0];
     *    b = [2, 7, 0];
     *    c = 0;
     *
     *    math.xor(a, b);   // returns [false, true, false]
     *    math.xor(a, c);   // returns [true, false, false]
     *
     * See also:
     *
     *    and, not, or
     *
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} x First value to check
     * @param  {number | BigNumber | Complex | Unit | Array | Matrix} y Second value to check
     * @return {boolean | Array | Matrix}
     *            Returns true when one and only one input is defined with a nonzero/nonempty value.
     */
    var xor = typed('xor', {
   
      'number, number': function (x, y) {
        return !!x !== !!y;
      },

      'Complex, Complex': function (x, y) {
        return ((x.re !== 0 || x.im !== 0) !== (y.re !== 0 || y.im !== 0));
      },

      'BigNumber, BigNumber': function (x, y) {
        return ((!x.isZero() && !x.isNaN()) !== (!y.isZero() && !y.isNaN()));
      },

      'Unit, Unit': function (x, y) {
        return xor(x.value || 0, y.value || 0);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, xor);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, xor, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, xor, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, xor);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return xor(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return xor(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return xor(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, xor, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, xor, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, xor, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, xor, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, xor, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, xor, true).valueOf();
      }
    });

    xor.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['xor'] + '${args[1]}\\right)'
    };

    return xor;
  }

  var name$184 = 'xor';
  var factory_1$195 = factory$196;

  var xor$1 = {
  	name: name$184,
  	factory: factory_1$195
  };

  var logical = [
    and$1,
    not$1,
    or$1,
    xor$1
  ];

  function factory$197 (type, config, load, typed) {
    var matrix$$1   = load(matrix);
    var subtract = load(subtract$1);
    var multiply = load(multiply$1);

    /**
     * Calculate the cross product for two vectors in three dimensional space.
     * The cross product of `A = [a1, a2, a3]` and `B = [b1, b2, b3]` is defined
     * as:
     *
     *    cross(A, B) = [
     *      a2 * b3 - a3 * b2,
     *      a3 * b1 - a1 * b3,
     *      a1 * b2 - a2 * b1
     *    ]
     *
     * If one of the input vectors has a dimension greater than 1, the output
     * vector will be a 1x3 (2-dimensional) matrix.
     *
     * Syntax:
     *
     *    math.cross(x, y)
     *
     * Examples:
     *
     *    math.cross([1, 1, 0],   [0, 1, 1]);       // Returns [1, -1, 1]
     *    math.cross([3, -3, 1],  [4, 9, 2]);       // Returns [-15, -2, 39]
     *    math.cross([2, 3, 4],   [5, 6, 7]);       // Returns [-3, 6, -3]
     *    math.cross([[1, 2, 3]], [[4], [5], [6]]); // Returns [[-3, 6, -3]]
     *
     * See also:
     *
     *    dot, multiply
     *
     * @param  {Array | Matrix} x   First vector
     * @param  {Array | Matrix} y   Second vector
     * @return {Array | Matrix}     Returns the cross product of `x` and `y`
     */
    var cross = typed('cross', {
      'Matrix, Matrix': function (x, y) {
        return matrix$$1(_cross(x.toArray(), y.toArray()));
      },

      'Matrix, Array': function (x, y) {
        return matrix$$1(_cross(x.toArray(), y));
      },

      'Array, Matrix': function (x, y) {
        return matrix$$1(_cross(x, y.toArray()));
      },

      'Array, Array': _cross
    });

    cross.toTex = {
      2: '\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)'
    };

    return cross;

    /**
     * Calculate the cross product for two arrays
     * @param {Array} x  First vector
     * @param {Array} y  Second vector
     * @returns {Array} Returns the cross product of x and y
     * @private
     */
    function _cross(x, y) {
      var highestDimension = Math.max(array.size(x).length, array.size(y).length);

      x = array.squeeze(x);
      y = array.squeeze(y);

      var xSize = array.size(x);
      var ySize = array.size(y);

      if (xSize.length != 1 || ySize.length != 1 || xSize[0] != 3 || ySize[0] != 3) {
        throw new RangeError('Vectors with length 3 expected ' +
        '(Size A = [' + xSize.join(', ') + '], B = [' + ySize.join(', ') + '])');
      }

      var product = [
        subtract(multiply(x[1], y[2]), multiply(x[2], y[1])),
        subtract(multiply(x[2], y[0]), multiply(x[0], y[2])),
        subtract(multiply(x[0], y[1]), multiply(x[1], y[0]))
      ];

      if (highestDimension > 1) {
        return [product];
      } else {
        return product;
      }
    }
  }

  var name$185 = 'cross';
  var factory_1$196 = factory$197;

  var cross$1 = {
  	name: name$185,
  	factory: factory_1$196
  };

  var clone$8     = object.clone;
  var isInteger$23 = number.isInteger;

  function factory$198 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    
    /**
     * Create a diagonal matrix or retrieve the diagonal of a matrix
     *
     * When `x` is a vector, a matrix with vector `x` on the diagonal will be returned.
     * When `x` is a two dimensional matrix, the matrixes `k`th diagonal will be returned as vector.
     * When k is positive, the values are placed on the super diagonal.
     * When k is negative, the values are placed on the sub diagonal.
     *
     * Syntax:
     *
     *     math.diag(X)
     *     math.diag(X, format)
     *     math.diag(X, k)
     *     math.diag(X, k, format)
     *
     * Examples:
     *
     *     // create a diagonal matrix
     *     math.diag([1, 2, 3]);      // returns [[1, 0, 0], [0, 2, 0], [0, 0, 3]]
     *     math.diag([1, 2, 3], 1);   // returns [[0, 1, 0, 0], [0, 0, 2, 0], [0, 0, 0, 3]]
     *     math.diag([1, 2, 3], -1);  // returns [[0, 0, 0], [1, 0, 0], [0, 2, 0], [0, 0, 3]]
     *
     *    // retrieve the diagonal from a matrix
     *    var a = [[1, 2, 3], [4, 5, 6], [7, 8, 9]];
     *    math.diag(a);   // returns [1, 5, 9]
     *
     * See also:
     *
     *     ones, zeros, eye
     *
     * @param {Matrix | Array} x          A two dimensional matrix or a vector
     * @param {number | BigNumber} [k=0]  The diagonal where the vector will be filled
     *                                    in or retrieved.
     * @param {string} [format='dense']   The matrix storage format.
     *
     * @returns {Matrix | Array} Diagonal matrix from input vector, or diagonal from input matrix.
     */
    var diag = typed('diag', {
      // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments

      'Array': function (x) {
        return _diag(x, 0, array.size(x), null);
      },

      'Array, number': function (x, k) {
        return _diag(x, k, array.size(x), null);
      },
      
      'Array, BigNumber': function (x, k) {
        return _diag(x, k.toNumber(), array.size(x), null);
      },

      'Array, string': function (x, format) {
        return _diag(x, 0, array.size(x), format);
      },

      'Array, number, string': function (x, k, format) {
        return _diag(x, k, array.size(x), format);
      },

      'Array, BigNumber, string': function (x, k, format) {
        return _diag(x, k.toNumber(), array.size(x), format);
      },

      'Matrix': function (x) {
        return _diag(x, 0, x.size(), x.storage());
      },

      'Matrix, number': function (x, k) {
        return _diag(x, k, x.size(), x.storage());
      },

      'Matrix, BigNumber': function (x, k) {
        return _diag(x, k.toNumber(), x.size(), x.storage());
      },

      'Matrix, string': function (x, format) {
        return _diag(x, 0, x.size(), format);
      },

      'Matrix, number, string': function (x, k, format) {
        return _diag(x, k, x.size(), format);
      },

      'Matrix, BigNumber, string': function (x, k, format) {
        return _diag(x, k.toNumber(), x.size(), format);
      }
    });

    diag.toTex = undefined; // use default template

    return diag;

    /**
     * Creeate diagonal matrix from a vector or vice versa
     * @param {Array | Matrix} x
     * @param {number} k
     * @param {string} format Storage format for matrix. If null,
     *                          an Array is returned
     * @returns {Array | Matrix}
     * @private
     */
    function _diag (x, k, size, format) {
      if (!isInteger$23(k)) {
        throw new TypeError ('Second parameter in function diag must be an integer');
      }
      
      var kSuper = k > 0 ? k : 0;
      var kSub = k < 0 ? -k : 0;

      // check dimensions
      switch (size.length) {
        case 1:
          return _createDiagonalMatrix(x, k, format, size[0], kSub, kSuper);
        case 2:
          return _getDiagonal(x, k, format, size, kSub, kSuper);
      }
      throw new RangeError('Matrix for function diag must be 2 dimensional');
    }
    
    function _createDiagonalMatrix(x, k, format, l, kSub, kSuper) {
      // matrix size
      var ms = [l + kSub, l + kSuper];
      // get matrix constructor
      var F = type.Matrix.storage(format || 'dense');
      // create diagonal matrix
      var m = F.diagonal(ms, x, k);
      // check we need to return a matrix
      return format !== null ? m : m.valueOf();
    }
    
    function _getDiagonal(x, k, format, s, kSub, kSuper) {
      // check x is a Matrix
      if (type.isMatrix(x)) {
        // get diagonal matrix
        var dm = x.diagonal(k);
        // check we need to return a matrix
        if (format !== null) {
          // check we need to change matrix format
          if (format !== dm.storage())
            return matrix$$1(dm, format);
          return dm;
        }
        return dm.valueOf();
      }
      // vector size
      var n = Math.min(s[0] - kSub, s[1] - kSuper);
      // diagonal values
      var vector = [];
      // loop diagonal
      for (var i = 0; i < n; i++) {
        vector[i] = x[i + kSub][i + kSuper];
      }
      // check we need to return a matrix
      return format !== null ? matrix$$1(vector) : vector;
    }
  }

  var name$186 = 'diag';
  var factory_1$197 = factory$198;

  var diag$1 = {
  	name: name$186,
  	factory: factory_1$197
  };

  var size$3 = array.size;

  function factory$199 (type, config, load, typed) {
    var add$$1      = load(add);
    var multiply = load(multiply$1);

    /**
     * Calculate the dot product of two vectors. The dot product of
     * `A = [a1, a2, a3, ..., an]` and `B = [b1, b2, b3, ..., bn]` is defined as:
     *
     *    dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn
     *
     * Syntax:
     *
     *    math.dot(x, y)
     *
     * Examples:
     *
     *    math.dot([2, 4, 1], [2, 2, 3]);       // returns number 15
     *    math.multiply([2, 4, 1], [2, 2, 3]);  // returns number 15
     *
     * See also:
     *
     *    multiply, cross
     *
     * @param  {Array | Matrix} x     First vector
     * @param  {Array | Matrix} y     Second vector
     * @return {number}               Returns the dot product of `x` and `y`
     */
    var dot = typed('dot', {
      'Matrix, Matrix': function (x, y) {
        return _dot(x.toArray(), y.toArray());
      },

      'Matrix, Array': function (x, y) {
        return _dot(x.toArray(), y);
      },

      'Array, Matrix': function (x, y) {
        return _dot(x, y.toArray());
      },

      'Array, Array': _dot
    });
    
    dot.toTex = {2: '\\left(${args[0]}\\cdot${args[1]}\\right)'};

    return dot;

    /**
     * Calculate the dot product for two arrays
     * @param {Array} x  First vector
     * @param {Array} y  Second vector
     * @returns {number} Returns the dot product of x and y
     * @private
     */
    // TODO: double code with math.multiply
    function _dot(x, y) {
      var xSize= size$3(x);
      var ySize = size$3(y);
      var len = xSize[0];

      if (xSize.length !== 1 || ySize.length !== 1) throw new RangeError('Vector expected'); // TODO: better error message
      if (xSize[0] != ySize[0]) throw new RangeError('Vectors must have equal length (' + xSize[0] + ' != ' + ySize[0] + ')');
      if (len == 0) throw new RangeError('Cannot calculate the dot product of empty vectors');

      var prod = 0;
      for (var i = 0; i < len; i++) {
        prod = add$$1(prod, multiply(x[i], y[i]));
      }

      return prod;
    }
  }

  var name$187 = 'dot';
  var factory_1$198 = factory$199;

  var dot$1 = {
  	name: name$187,
  	factory: factory_1$198
  };

  var format$6 = string.format;

  function factory$200 (type, config, load, typed) {

    var abs = load(abs$1);
    var add$$1 = load(add);
    var eye = load(eye$1);
    var inv = load(inv$1);
    var multiply = load(multiply$1);

    var SparseMatrix = type.SparseMatrix;

    /**
     * Compute the matrix exponential, expm(A) = e^A. The matrix must be square.
     * Not to be confused with exp(a), which performs element-wise
     * exponentiation.
     *
     * The exponential is calculated using the Padé approximant with scaling and
     * squaring; see "Nineteen Dubious Ways to Compute the Exponential of a
     * Matrix," by Moler and Van Loan.
     *
     * Syntax:
     *
     *     math.expm(x)
     *
     * Examples:
     *
     *     var A = [[0,2],[0,0]]
     *     math.expm(A);        // returns [[1,2],[0,1]]
     *
     * See also:
     *
     *     exp
     *
     * @param {Matrix} x  A square Matrix
     * @return {Matrix}   The exponential of x
     */
    var expm = typed('expm', {

      'Matrix': function (A) {

        // Check matrix size
        var size = A.size();
        
        if(size.length !== 2 || size[0] !== size[1]) {
          throw new RangeError('Matrix must be square ' +
            '(size: ' + format$6(size) + ')');
        }
        
        var n = size[0];

        // Desired accuracy of the approximant (The actual accuracy
        // will be affected by round-off error)
        var eps = 1e-15;
        
        // The Padé approximant is not so accurate when the values of A
        // are "large", so scale A by powers of two. Then compute the
        // exponential, and square the result repeatedly according to
        // the identity e^A = (e^(A/m))^m 
        
        // Compute infinity-norm of A, ||A||, to see how "big" it is
        var infNorm = infinityNorm(A);
        
        // Find the optimal scaling factor and number of terms in the 
        // Padé approximant to reach the desired accuracy
        var params = findParams(infNorm, eps);
        var q = params.q;
        var j = params.j;
        
        // The Pade approximation to e^A is:
        // Rqq(A) = Dqq(A) ^ -1 * Nqq(A)
        // where
        // Nqq(A) = sum(i=0, q, (2q-i)!p! / [ (2q)!i!(q-i)! ] A^i
        // Dqq(A) = sum(i=0, q, (2q-i)!q! / [ (2q)!i!(q-i)! ] (-A)^i
       
        // Scale A by 1 / 2^j
        var Apos = multiply(A, Math.pow(2, -j));
       
        // The i=0 term is just the identity matrix
        var N = eye(n);
        var D = eye(n);
       
        // Initialization (i=0)
        var factor = 1;
       
        // Initialization (i=1)
        var Apos_to_i = Apos; // Cloning not necessary
        var alternate = -1;
       
        for(var i=1; i<=q; i++) {
          if(i>1) {
            Apos_to_i = multiply(Apos_to_i, Apos);
            alternate = -alternate;
          }
          factor = factor*(q-i+1)/((2*q-i+1)*i);
          
          N = add$$1(N, multiply(factor, Apos_to_i));
          D = add$$1(D, multiply(factor*alternate, Apos_to_i));
        }
        
        var R = multiply(inv(D), N);      
        
        // Square j times
        for(var i=0; i<j; i++) {
          R = multiply(R, R);
        }

        return type.isSparseMatrix(A)
            ? new SparseMatrix(R)
            : R;
      }
      
    });
    
    function infinityNorm(A) {
      var n = A.size()[0];  
      var infNorm = 0;  
      for(var i=0; i<n; i++) {
        var rowSum = 0;
        for(var j=0; j<n; j++) {
          rowSum += abs(A.get([i,j]));
        }
        infNorm = Math.max(rowSum, infNorm);
      }
      return infNorm;
    }

    /**
     * Find the best parameters for the Pade approximant given
     * the matrix norm and desired accuracy. Returns the first acceptable
     * combination in order of increasing computational load.
     */
    function findParams(infNorm, eps) {
      var maxSearchSize = 30;
      for(var k=0; k<maxSearchSize; k++) {
        for(var q=0; q<=k; q++) {
          var j = k - q;
          if(errorEstimate(infNorm, q, j) < eps) {
            return {q: q, j: j};
          }
        }
      }
      throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    }
    
    /**
     * Returns the estimated error of the Pade approximant for the given
     * parameters.
     */
    function errorEstimate(infNorm, q, j) {
      
      var qfac = 1;
      for(var i=2; i<=q; i++) {
        qfac *= i;
      }
      var twoqfac = qfac;
      for(var i=q+1; i<=2*q; i++) {
        twoqfac *= i;
      }
      var twoqp1fac = twoqfac * (2*q+1);
      
      return 8.0 *
        Math.pow(infNorm / Math.pow(2, j), 2*q) *
        qfac*qfac / (twoqfac*twoqp1fac);
    }
    
    expm.toTex = {1: '\\exp\\left(${args[0]}\\right)'};

    return expm;
  }

  var name$188 = 'expm';
  var factory_1$199 = factory$200;

  var expm$1 = {
  	name: name$188,
  	factory: factory_1$199
  };

  var filter$2 = array.filter;
  var filterRegExp$1 = array.filterRegExp;
  var maxArgumentCount$4 = _function.maxArgumentCount;

  function factory$201 (type, config, load, typed) {
    var matrix$$1 = load(matrix);
    
    /**
     * Filter the items in an array or one dimensional matrix.
     *
     * Syntax:
     *
     *    math.filter(x, test)
     *
     * Examples:
     *
     *    function isPositive (x) {
     *      return x > 0;
     *    }
     *    math.filter([6, -2, -1, 4, 3], isPositive); // returns [6, 4, 3]
     *
     *    math.filter(["23", "foo", "100", "55", "bar"], /[0-9]+/); // returns ["23", "100", "55"]
     *
     * See also:
     *
     *    forEach, map, sort
     *
     * @param {Matrix | Array} x    A one dimensional matrix or array to filter
     * @param {Function | RegExp} test
     *        A function or regular expression to test items.
     *        All entries for which `test` returns true are returned.
     *        When `test` is a function, it is invoked with three parameters:
     *        the value of the element, the index of the element, and the
     *        matrix/array being traversed. The function must return a boolean.
     * @return {Matrix | Array} Returns the filtered matrix.
     */
    var filter = typed('filter', {
      'Array, function': _filterCallback,

      'Matrix, function': function (x, test) {
        return matrix$$1(_filterCallback(x.toArray(), test));
      },

      'Array, RegExp': filterRegExp$1,

      'Matrix, RegExp': function (x, test) {
        return matrix$$1(filterRegExp$1(x.toArray(), test));
      }
    });

    filter.toTex = undefined; // use default template

    return filter;
  }

  /**
   * Filter values in a callback given a callback function
   * @param {Array} x
   * @param {Function} callback
   * @return {Array} Returns the filtered array
   * @private
   */
  function _filterCallback (x, callback) {
    // figure out what number of arguments the callback function expects
    var args = maxArgumentCount$4(callback);

    return filter$2(x, function (value, index, array$$1) {
      // invoke the callback function with the right number of arguments
      if (args === 1) {
        return callback(value);
      }
      else if (args === 2) {
        return callback(value, [index]);
      }
      else { // 3 or -1
        return callback(value, [index], array$$1);
      }
    });
  }

  var name$189 = 'filter';
  var factory_1$200 = factory$201;

  var filter_1 = {
  	name: name$189,
  	factory: factory_1$200
  };

  var clone$9 = object.clone;
  var _flatten = array.flatten;

  function factory$202 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Flatten a multi dimensional matrix into a single dimensional matrix.
     *
     * Syntax:
     *
     *    math.flatten(x)
     *
     * Examples:
     *
     *    math.flatten([[1,2], [3,4]]);   // returns [1, 2, 3, 4]
     *
     * See also:
     *
     *    concat, resize, size, squeeze
     *
     * @param {Matrix | Array} x   Matrix to be flattened
     * @return {Matrix | Array} Returns the flattened matrix
     */
    var flatten = typed('flatten', {
      'Array': function (x) {
        return _flatten(clone$9(x));
      },

      'Matrix': function (x) {
        var flat = _flatten(clone$9(x.toArray()));
        // TODO: return the same matrix type as x
        return matrix$$1(flat);
      }
    });

    flatten.toTex = undefined; // use default template

    return flatten;
  }

  var name$190 = 'flatten';
  var factory_1$201 = factory$202;

  var flatten$3 = {
  	name: name$190,
  	factory: factory_1$201
  };

  var maxArgumentCount$5 = _function.maxArgumentCount;
  var forEach$4 = array.forEach;

  function factory$203 (type, config, load, typed) {
    /**
     * Iterate over all elements of a matrix/array, and executes the given callback function.
     *
     * Syntax:
     *
     *    math.forEach(x, callback)
     *
     * Examples:
     *
     *    math.forEach([1, 2, 3], function(value) {
     *      console.log(value);
     *    });
     *    // outputs 1, 2, 3
     *
     * See also:
     *
     *    filter, map, sort
     *
     * @param {Matrix | Array} x    The matrix to iterate on.
     * @param {Function} callback   The callback function is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the Matrix/array being traversed.
     */
    var forEach = typed('forEach', {
      'Array, function': _forEach,

      'Matrix, function': function (x, callback) {
        return x.forEach(callback);
      }
    });

    forEach.toTex = undefined; // use default template

    return forEach;
  }

  /**
   * forEach for a multi dimensional array
   * @param {Array} array
   * @param {Function} callback
   * @private
   */
  function _forEach (array$$1, callback) {
    // figure out what number of arguments the callback function expects
    var args = maxArgumentCount$5(callback);

    var recurse = function (value, index) {
      if (Array.isArray(value)) {
        forEach$4(value, function (child, i) {
          // we create a copy of the index array and append the new index value
          recurse(child, index.concat(i));
        });
      }
      else {
        // invoke the callback function with the right number of arguments
        if (args === 1) {
          callback(value);
        }
        else if (args === 2) {
          callback(value, index);
        }
        else { // 3 or -1
          callback(value, index, array$$1);
        }
      }
    };
    recurse(array$$1, []);
  }

  var name$191 = 'forEach';
  var factory_1$202 = factory$203;

  var forEach_1 = {
  	name: name$191,
  	factory: factory_1$202
  };

  var size$4 = array.size;

  function factory$204(type, config, load, typed) {
    var matrix$$1 = load(matrix);
    var multiplyScalar$$1 = load(multiplyScalar);
      /**
       * Calculates the kronecker product of 2 matrices or vectors.
       *
       * NOTE: If a one dimensional vector / matrix is given, it will be
       * wrapped so its two dimensions.
       * See the examples.
       *
       * Syntax:
       *
       *    math.kron(x, y)
       *
       * Examples:
       *
       *    math.kron([[1, 0], [0, 1]], [[1, 2], [3, 4]]);
       *    // returns [ [ 1, 2, 0, 0 ], [ 3, 4, 0, 0 ], [ 0, 0, 1, 2 ], [ 0, 0, 3, 4 ] ]
       *
       *    math.kron([1,1], [2,3,4]);
       *    // returns [ [ 2, 3, 4, 2, 3, 4 ] ]
       *
       * See also:
       *
       *    multiply, dot, cross
       *
       * @param  {Array | Matrix} x     First vector
       * @param  {Array | Matrix} y     Second vector
       * @return {Array | Matrix}       Returns the kronecker product of `x` and `y`
       */
      var kron = typed('kron', {
          'Matrix, Matrix': function(x, y) {
              return matrix$$1(_kron(x.toArray(), y.toArray()));
          },

          'Matrix, Array': function(x, y) {
              return matrix$$1(_kron(x.toArray(), y));
          },

          'Array, Matrix': function(x, y) {
              return matrix$$1(_kron(x, y.toArray()));
          },

          'Array, Array': _kron
      });

      return kron;

      /**
       * Calculate the kronecker product of two matrices / vectors
       * @param {Array} a  First vector
       * @param {Array} b  Second vector
       * @returns {Array} Returns the kronecker product of x and y
       * @private
       */
      function _kron(a, b) {
          // Deal with the dimensions of the matricies.
          if (size$4(a).length === 1) {
            // Wrap it in a 2D Matrix
            a = [a];
          }
          if (size$4(b).length === 1) {
            // Wrap it in a 2D Matrix
            b = [b];
          }
          if (size$4(a).length > 2 || size$4(b).length > 2) {
              throw new RangeError('Vectors with dimensions greater then 2 are not supported expected ' +
              '(Size x = ' + JSON.stringify(a.length) + ', y = ' + JSON.stringify(b.length) + ')');
          }
          var t = [];
          var r = [];

          return a.map(function(a) {
              return b.map(function(b) {
                  return a.map(function(y) {
                      return b.map(function(x) {
                          return r.push(multiplyScalar$$1(y, x));
                      });
                  }, t.push(r = []));
              });
          }, t = []) && t;
      }
  }

  var name$192 = 'kron';
  var factory_1$203 = factory$204;

  var kron$1 = {
  	name: name$192,
  	factory: factory_1$203
  };

  var maxArgumentCount$6 = _function.maxArgumentCount;

  function factory$205 (type, config, load, typed) {
    /**
     * Create a new matrix or array with the results of the callback function executed on
     * each entry of the matrix/array.
     *
     * Syntax:
     *
     *    math.map(x, callback)
     *
     * Examples:
     *
     *    math.map([1, 2, 3], function(value) {
     *      return value * value;
     *    });  // returns [1, 4, 9]
     *
     * See also:
     *
     *    filter, forEach, sort
     *
     * @param {Matrix | Array} x    The matrix to iterate on.
     * @param {Function} callback   The callback method is invoked with three
     *                              parameters: the value of the element, the index
     *                              of the element, and the matrix being traversed.
     * @return {Matrix | array}     Transformed map of x
     */
    var map = typed('map', {
      'Array, function': _map$1,

      'Matrix, function': function (x, callback) {
        return x.map(callback);
      }
    });

    map.toTex = undefined; // use default template

    return map;
  }

  /**
   * Map for a multi dimensional array
   * @param {Array} array
   * @param {Function} callback
   * @return {Array}
   * @private
   */
  function _map$1 (array, callback) {
    // figure out what number of arguments the callback function expects
    var args = maxArgumentCount$6(callback);

    var recurse = function (value, index) {
      if (Array.isArray(value)) {
        return value.map(function (child, i) {
          // we create a copy of the index array and append the new index value
          return recurse(child, index.concat(i));
        });
      }
      else {
        // invoke the callback function with the right number of arguments
        if (args === 1) {
          return callback(value);
        }
        else if (args === 2) {
          return callback(value, index);
        }
        else { // 3 or -1
          return callback(value, index, array);
        }
      }
    };

    return recurse(array, []);
  }

  var name$193 = 'map';
  var factory_1$204 = factory$205;

  var map$7 = {
  	name: name$193,
  	factory: factory_1$204
  };

  var isInteger$24 = number.isInteger;
  var resize$2 = array.resize;

  function factory$206 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Create a matrix filled with ones. The created matrix can have one or
     * multiple dimensions.
     *
     * Syntax:
     *
     *    math.ones(m)
     *    math.ones(m, format)
     *    math.ones(m, n)
     *    math.ones(m, n, format)
     *    math.ones([m, n])
     *    math.ones([m, n], format)
     *    math.ones([m, n, p, ...])
     *    math.ones([m, n, p, ...], format)
     *
     * Examples:
     *
     *    math.ones(3);                   // returns [1, 1, 1]
     *    math.ones(3, 2);                // returns [[1, 1], [1, 1], [1, 1]]
     *    math.ones(3, 2, 'dense');       // returns Dense Matrix [[1, 1], [1, 1], [1, 1]]
     *
     *    var A = [[1, 2, 3], [4, 5, 6]];
     *    math.ones(math.size(A));       // returns [[1, 1, 1], [1, 1, 1]]
     *
     * See also:
     *
     *    zeros, eye, size, range
     *
     * @param {...number | Array} size    The size of each dimension of the matrix
     * @param {string} [format]           The Matrix storage format
     *
     * @return {Array | Matrix | number}  A matrix filled with ones
     */
    var ones = typed('ones', {
      '': function () {
        return (config.matrix === 'Array')
            ? _ones([])
            : _ones([], 'default');
      },

      // math.ones(m, n, p, ..., format)
      // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
      '...number | BigNumber | string': function (size) {
        var last = size[size.length - 1];
        if (typeof last === 'string') {
          var format = size.pop();
          return _ones(size, format);
        }
        else if (config.matrix === 'Array') {
          return _ones(size);
        }
        else {
          return _ones(size, 'default');
        }
      },

      'Array': _ones,

      'Matrix': function (size) {
        var format = size.storage();
        return _ones(size.valueOf(), format);
      },

      'Array | Matrix, string': function (size, format) {
        return _ones (size.valueOf(), format);
      }
    });

    ones.toTex = undefined; // use default template

    return ones;

    /**
     * Create an Array or Matrix with ones
     * @param {Array} size
     * @param {string} [format='default']
     * @return {Array | Matrix}
     * @private
     */
    function _ones(size, format) {
      var hasBigNumbers = _normalize(size);
      var defaultValue = hasBigNumbers ? new type.BigNumber(1) : 1;
      _validate(size);

      if (format) {
        // return a matrix
        var m = matrix$$1(format);
        if (size.length > 0) {
          return m.resize(size, defaultValue);
        }
        return m;
      }
      else {
        // return an Array
        var arr = [];
        if (size.length > 0) {
          return resize$2(arr, size, defaultValue);
        }
        return arr;
      }
    }

    // replace BigNumbers with numbers, returns true if size contained BigNumbers
    function _normalize(size) {
      var hasBigNumbers = false;
      size.forEach(function (value, index, arr) {
        if (type.isBigNumber(value)) {
          hasBigNumbers = true;
          arr[index] = value.toNumber();
        }
      });
      return hasBigNumbers;
    }

    // validate arguments
    function _validate (size) {
      size.forEach(function (value) {
        if (typeof value !== 'number' || !isInteger$24(value) || value < 0) {
          throw new Error('Parameters in function ones must be positive integers');
        }
      });
    }
  }

  var name$194 = 'ones';
  var factory_1$205 = factory$206;

  var ones$1 = {
  	name: name$194,
  	factory: factory_1$205
  };

  var nearlyEqual$6 = number.nearlyEqual;


  function factory$207 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm05$$1 = load(algorithm05);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.
     *
     * x and y are considered equal when the relative difference between x and y
     * is smaller than the configured epsilon. The function cannot be used to
     * compare values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.compare(x, y)
     *
     * Examples:
     *
     *    math.compare(6, 1);           // returns 1
     *    math.compare(2, 3);           // returns -1
     *    math.compare(7, 7);           // returns 0
     *    math.compare('10', '2');      // returns 1
     *    math.compare('1000', '1e3');  // returns 0
     *
     *    var a = math.unit('5 cm');
     *    var b = math.unit('40 mm');
     *    math.compare(a, b);           // returns 1
     *
     *    math.compare(2, [1, 2, 3]);   // returns [1, 0, -1]
     *
     * See also:
     *
     *    equal, unequal, smaller, smallerEq, larger, largerEq, compareNatural, compareText
     *
     * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} x First value to compare
     * @param  {number | BigNumber | Fraction | Unit | string | Array | Matrix} y Second value to compare
     * @return {number | BigNumber | Fraction | Array | Matrix} Returns the result of the comparison:
     *                                                          1 when x > y, -1 when x < y, and 0 when x == y.
     */
    var compare = typed('compare', {

      'boolean, boolean': function (x, y) {
        return x === y ? 0 : (x > y ? 1 : -1);
      },

      'number, number': function (x, y) {
        return (x === y || nearlyEqual$6(x, y, config.epsilon))
            ? 0
            : (x > y ? 1 : -1);
      },

      'BigNumber, BigNumber': function (x, y) {
        return (x.eq(y) || nearlyEqual(x, y, config.epsilon))
            ? new type.BigNumber(0)
            : new type.BigNumber(x.cmp(y));
      },

      'Fraction, Fraction': function (x, y) {
        return new type.Fraction(x.compare(y));
      },

      'Complex, Complex': function () {
        throw new TypeError('No ordering relation is defined for complex numbers');
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return compare(x.value, y.value);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm05$$1(x, y, compare);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, compare, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, compare, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, compare);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return compare(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return compare(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return compare(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, compare, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, compare, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, compare, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, compare, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, compare, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, compare, true).valueOf();
      }
    });

    compare.toTex = undefined; // use default template

    return compare;
  }

  var name$195 = 'compare';
  var factory_1$206 = factory$207;

  var compare$1 = {
  	name: name$195,
  	factory: factory_1$206
  };

  var isInteger$25 = number.isInteger;

  function factory$208 (type, config, load, typed) {
    var asc = load(compare$1);
    function desc(a, b) {
      return -asc(a, b);
    }

    /**
     * Partition-based selection of an array or 1D matrix.
     * Will find the kth smallest value, and mutates the input array.
     * Uses Quickselect.
     *
     * Syntax:
     *
     *    math.partitionSelect(x, k)
     *    math.partitionSelect(x, k, compare)
     *
     * Examples:
     *
     *    math.partitionSelect([5, 10, 1], 2);           // returns 10
     *    math.partitionSelect(['C', 'B', 'A', 'D'], 1); // returns 'B'
     *
     *    function sortByLength (a, b) {
     *      return a.length - b.length;
     *    }
     *    math.partitionSelect(['Langdon', 'Tom', 'Sara'], 2, sortByLength); // returns 'Langdon'
     *
     * See also:
     *
     *    sort
     *
     * @param {Matrix | Array} x    A one dimensional matrix or array to sort
     * @param {Number} k            The kth smallest value to be retrieved; zero-based index
     * @param {Function | 'asc' | 'desc'} [compare='asc']
     *        An optional comparator function. The function is called as
     *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
     *        and 0 when a == b.
     * @return {*} Returns the kth lowest value.
     */
    return typed('partitionSelect', {
      'Array | Matrix, number': function (x, k) {
        return _partitionSelect(x, k, asc);
      },

      'Array | Matrix, number, string': function (x, k, compare) {
        if (compare === 'asc') {
          return _partitionSelect(x, k, asc);
        }
        else if (compare === 'desc') {
          return _partitionSelect(x, k, desc);
        }
        else {
          throw new Error('Compare string must be "asc" or "desc"');
        }
      },

      'Array | Matrix, number, function': _partitionSelect
    });

    function _partitionSelect(x, k, compare) {
      if (!isInteger$25(k) || k < 0) {
        throw new Error('k must be a non-negative integer');
      }

      if (type.isMatrix(x)) {
        var size = x.size();
        if (size.length > 1) {
          throw new Error('Only one dimensional matrices supported');
        }
        return quickSelect(x.valueOf(), k, compare);
      }

      if (Array.isArray(x)) {
        return quickSelect(x, k, compare);
      }
    }

    /**
     * Quickselect algorithm.
     * Code adapted from:
     * http://blog.teamleadnet.com/2012/07/quick-select-algorithm-find-kth-element.html
     *
     * @param {Array} arr
     * @param {Number} k
     * @param {Function} compare
     * @private
     */
    function quickSelect(arr, k, compare) {
      if (k >= arr.length) {
        throw new Error('k out of bounds');
      }

      var from = 0;
      var to = arr.length - 1;

      // if from == to we reached the kth element
      while (from < to) {
        var r = from;
        var w = to;
        var pivot = arr[Math.floor(Math.random() * (to - from + 1)) + from];

        // stop if the reader and writer meets
        while (r < w) {
          // arr[r] >= pivot
          if (compare(arr[r], pivot) >= 0) { // put the large values at the end
            var tmp = arr[w];
            arr[w] = arr[r];
            arr[r] = tmp;
            --w;
          } else { // the value is smaller than the pivot, skip
            ++r;
          }
        }

        // if we stepped up (r++) we need to step one down (arr[r] > pivot)
        if (compare(arr[r], pivot) > 0) {
          --r;
        }

        // the r pointer is on the end of the first k elements
        if (k <= r) {
          to = r;
        } else {
          from = r + 1;
        }
      }

      return arr[k];
    }
  }

  var name$196 = 'partitionSelect';
  var factory_1$207 = factory$208;

  var partitionSelect$1 = {
  	name: name$196,
  	factory: factory_1$207
  };

  var isInteger$26 = number.isInteger;


  function factory$209 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Reshape a multi dimensional array to fit the specified dimensions
     *
     * Syntax:
     *
     *     math.reshape(x, sizes)
     *
     * Examples:
     *
     *     math.reshape([1, 2, 3, 4, 5, 6], [2, 3]);
     *     // returns Array  [[1, 2, 3], [4, 5, 6]]
     *
     *     math.reshape([[1, 2], [3, 4]], [1, 4]);
     *     // returns Array  [[1, 2, 3, 4]]
     *
     *     math.reshape([[1, 2], [3, 4]], [4]);
     *     // returns Array [1, 2, 3, 4]
     *
     *     var x = math.matrix([1, 2, 3, 4, 5, 6, 7, 8]);
     *     math.reshape(x, [2, 2, 2]);
     *     // returns Matrix [[[1, 2], [3, 4]], [[5, 6], [7, 8]]]
     *
     * See also:
     *
     *     size, squeeze, resize
     *
     * @param {Array | Matrix | *} x  Matrix to be reshaped
     * @param {number[]} sizes        One dimensional array with integral sizes for
     *                                each dimension
     *
     * @return {* | Array | Matrix}   A reshaped clone of matrix `x`
     *
     * @throws {TypeError}            If `sizes` does not contain solely integers
     * @throws {DimensionError}       If the product of the new dimension sizes does
     *                                not equal that of the old ones
     */
    var reshape = typed('reshape', {

      'Matrix, Array': function (x, sizes) {
        if(x.reshape) {
          return x.reshape(sizes);
        } else {
          return matrix$$1(array.reshape(x.valueOf(), sizes));
        }
      },

      'Array, Array': function (x, sizes) {
        sizes.forEach(function (size) {
          if (!isInteger$26(size)) {
            throw new TypeError('Invalid size for dimension: ' + size);
          }
        });
        return array.reshape(x, sizes);
      }

    });

    reshape.toTex = undefined; // use default template

    return reshape;
  }

  var name$197 = 'reshape';
  var factory_1$208 = factory$209;

  var reshape$1 = {
  	name: name$197,
  	factory: factory_1$208
  };

  var isInteger$27 = number.isInteger;
  var format$7 = string.format;
  var clone$10 = object.clone;


  function factory$210 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Resize a matrix
     *
     * Syntax:
     *
     *     math.resize(x, size)
     *     math.resize(x, size, defaultValue)
     *
     * Examples:
     *
     *     math.resize([1, 2, 3, 4, 5], [3]); // returns Array  [1, 2, 3]
     *     math.resize([1, 2, 3], [5], 0);    // returns Array  [1, 2, 3, 0, 0]
     *     math.resize(2, [2, 3], 0);         // returns Matrix [[2, 0, 0], [0, 0, 0]]
     *     math.resize("hello", [8], "!");    // returns string 'hello!!!'
     *
     * See also:
     *
     *     size, squeeze, subset, reshape
     *
     * @param {Array | Matrix | *} x             Matrix to be resized
     * @param {Array | Matrix} size              One dimensional array with numbers
     * @param {number | string} [defaultValue=0] Zero by default, except in
     *                                           case of a string, in that case
     *                                           defaultValue = ' '
     * @return {* | Array | Matrix} A resized clone of matrix `x`
     */
    // TODO: rework resize to a typed-function
    var resize = function resize (x, size, defaultValue) {
      if (arguments.length != 2 && arguments.length != 3) {
        throw new ArgumentsError_1('resize', arguments.length, 2, 3);
      }

      if (type.isMatrix(size)) {
        size = size.valueOf(); // get Array
      }

      if (type.isBigNumber(size[0])) {
        // convert bignumbers to numbers
        size = size.map(function (value) {
          return type.isBigNumber(value) ? value.toNumber() : value;
        });
      }
      
      // check x is a Matrix
      if (type.isMatrix(x)) {
        // use optimized matrix implementation, return copy
        return x.resize(size, defaultValue, true);
      }
      
      if (typeof x === 'string') {
        // resize string
        return _resizeString(x, size, defaultValue);
      }
      
      // check result should be a matrix
      var asMatrix = Array.isArray(x) ? false : (config.matrix !== 'Array');

      if (size.length == 0) {
        // output a scalar
        while (Array.isArray(x)) {
          x = x[0];
        }

        return clone$10(x);
      }
      else {
        // output an array/matrix
        if (!Array.isArray(x)) {
          x = [x];
        }
        x = clone$10(x);

        var res = array.resize(x, size, defaultValue);
        return asMatrix ? matrix$$1(res) : res;
      }
    };

    resize.toTex = undefined; // use default template

    return resize;

    /**
     * Resize a string
     * @param {string} str
     * @param {number[]} size
     * @param {string} [defaultChar=' ']
     * @private
     */
    function _resizeString(str, size, defaultChar) {
      if (defaultChar !== undefined) {
        if (typeof defaultChar !== 'string' || defaultChar.length !== 1) {
          throw new TypeError('Single character expected as defaultValue');
        }
      }
      else {
        defaultChar = ' ';
      }

      if (size.length !== 1) {
        throw new DimensionError_1(size.length, 1);
      }
      var len = size[0];
      if (typeof len !== 'number' || !isInteger$27(len)) {
        throw new TypeError('Invalid size, must contain positive integers ' +
            '(size: ' + format$7(size) + ')');
      }

      if (str.length > len) {
        return str.substring(0, len);
      }
      else if (str.length < len) {
        var res = str;
        for (var i = 0, ii = len - str.length; i < ii; i++) {
          res += defaultChar;
        }
        return res;
      }
      else {
        return str;
      }
    }
  }

  var name$198 = 'resize';
  var factory_1$209 = factory$210;

  var resize$3 = {
  	name: name$198,
  	factory: factory_1$209
  };

  function factory$211 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Calculate the size of a matrix or scalar.
     *
     * Syntax:
     *
     *     math.size(x)
     *
     * Examples:
     *
     *     math.size(2.3);                  // returns []
     *     math.size('hello world');        // returns [11]
     *
     *     var A = [[1, 2, 3], [4, 5, 6]];
     *     math.size(A);                    // returns [2, 3]
     *     math.size(math.range(1,6));      // returns [5]
     *
     * See also:
     *
     *     resize, squeeze, subset
     *
     * @param {boolean | number | Complex | Unit | string | Array | Matrix} x  A matrix
     * @return {Array | Matrix} A vector with size of `x`.
     */
    var size = typed('size', {
      'Matrix': function (x) {
        // TODO: return the same matrix type as the input
        return matrix$$1(x.size());
      },

      'Array': array.size,

      'string': function (x) {
        return (config.matrix === 'Array') ? [x.length] : matrix$$1([x.length]);
      },

      'number | Complex | BigNumber | Unit | boolean | null': function (x) {
        // scalar
        return (config.matrix === 'Array') ? [] : matrix$$1([]);
      }
    });

    size.toTex = undefined; // use default template

    return size;
  }

  var name$199 = 'size';
  var factory_1$210 = factory$211;

  var size$5 = {
  	name: name$199,
  	factory: factory_1$210
  };

  /*
   * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
   * Author: Jim Palmer (based on chunking idea from Dave Koelle)
   */
  /*jshint unused:false */
  var naturalSort = function naturalSort (a, b) {
  	var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
  		sre = /(^[ ]*|[ ]*$)/g,
  		dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
  		hre = /^0x[0-9a-f]+$/i,
  		ore = /^0/,
  		i = function(s) { return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s; },
  		// convert all to strings strip whitespace
  		x = i(a).replace(sre, '') || '',
  		y = i(b).replace(sre, '') || '',
  		// chunk/tokenize
  		xN = x.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
  		yN = y.replace(re, '\0$1\0').replace(/\0$/,'').replace(/^\0/,'').split('\0'),
  		// numeric, hex or date detection
  		xD = parseInt(x.match(hre), 16) || (xN.length !== 1 && x.match(dre) && Date.parse(x)),
  		yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null,
  		oFxNcL, oFyNcL;
  	// first try and sort Hex codes or Dates
  	if (yD) {
  		if ( xD < yD ) { return -1; }
  		else if ( xD > yD ) { return 1; }
  	}
  	// natural sorting through split numeric strings and default strings
  	for(var cLoc=0, numS=Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
  		// find floats not starting with '0', string or 0 if not defined (Clint Priest)
  		oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
  		oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
  		// handle numeric vs string comparison - number < string - (Kyle Adams)
  		if (isNaN(oFxNcL) !== isNaN(oFyNcL)) { return (isNaN(oFxNcL)) ? 1 : -1; }
  		// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
  		else if (typeof oFxNcL !== typeof oFyNcL) {
  			oFxNcL += '';
  			oFyNcL += '';
  		}
  		if (oFxNcL < oFyNcL) { return -1; }
  		if (oFxNcL > oFyNcL) { return 1; }
  	}
  	return 0;
  };

  function factory$212 (type, config, load, typed) {
    var getTypeOf = load(_typeof$1);
    var compare = load(compare$1);

    var compareBooleans = compare.signatures['boolean,boolean'];

    /**
     * Compare two values of any type in a deterministic, natural way.
     *
     * For numeric values, the function works the same as `math.compare`.
     * For types of values that can't be compared mathematically,
     * the function compares in a natural way.
     *
     * For numeric values, x and y are considered equal when the relative
     * difference between x and y is smaller than the configured epsilon.
     * The function cannot be used to compare values smaller than
     * approximately 2.22e-16.
     *
     * For Complex numbers, first the real parts are compared. If equal,
     * the imaginary parts are compared.
     *
     * Strings are compared with a natural sorting algorithm, which
     * orders strings in a "logic" way following some heuristics.
     * This differs from the function `compare`, which converts the string
     * into a numeric value and compares that. The function `compareText`
     * on the other hand compares text lexically.
     *
     * Arrays and Matrices are compared value by value until there is an
     * unequal pair of values encountered. Objects are compared by sorted
     * keys until the keys or their values are unequal.
     *
     * Syntax:
     *
     *    math.compareNatural(x, y)
     *
     * Examples:
     *
     *    math.compareNatural(6, 1);              // returns 1
     *    math.compareNatural(2, 3);              // returns -1
     *    math.compareNatural(7, 7);              // returns 0
     *
     *    math.compareNatural('10', '2');         // returns 1
     *    math.compareText('10', '2');            // returns -1
     *    math.compare('10', '2');                // returns 1
     *
     *    math.compareNatural('Answer: 10', 'Answer: 2'); // returns 1
     *    math.compareText('Answer: 10', 'Answer: 2');    // returns -1
     *    math.compare('Answer: 10', 'Answer: 2');
     *        // Error: Cannot convert "Answer: 10" to a number
     *
     *    var a = math.unit('5 cm');
     *    var b = math.unit('40 mm');
     *    math.compareNatural(a, b);              // returns 1
     *
     *    var c = math.complex('2 + 3i');
     *    var d = math.complex('2 + 4i');
     *    math.compareNatural(c, d);              // returns -1
     *
     *    math.compareNatural([1, 2, 4], [1, 2, 3]); // returns 1
     *    math.compareNatural([1, 2, 3], [1, 2]);    // returns 1
     *    math.compareNatural([1, 5], [1, 2, 3]);    // returns 1
     *    math.compareNatural([1, 2], [1, 2]);       // returns 0
     *
     *    math.compareNatural({a: 2}, {a: 4});       // returns -1
     *
     * See also:
     *
     *    compare, compareText
     *
     * @param  {*} x First value to compare
     * @param  {*} y Second value to compare
     * @return {number} Returns the result of the comparison:
     *                  1 when x > y, -1 when x < y, and 0 when x == y.
     */
    var compareNatural = typed('compareNatural', {
      'any, any': function (x, y) {
        var typeX = getTypeOf(x);
        var typeY = getTypeOf(y);
        var c;

        // numeric types
        if ((typeX === 'number' || typeX === 'BigNumber' || typeX === 'Fraction') &&
            (typeY === 'number' || typeY === 'BigNumber' || typeY === 'Fraction')) {
          c = compare(x, y);
          if (c.toString() !== '0') {
            // c can be number, BigNumber, or Fraction
            return c > 0 ? 1 : -1; // return a number
          }
          else {
            return naturalSort(typeX, typeY);
          }
        }

        // matrix types
        if (typeX === 'Array' || typeX === 'Matrix' ||
            typeY === 'Array' || typeY === 'Matrix') {
          c = compareMatricesAndArrays (x, y);
          if (c !== 0) {
            return c;
          }
          else {
            return naturalSort(typeX, typeY);
          }
        }

        // in case of different types, order by name of type, i.e. 'BigNumber' < 'Complex'
        if (typeX !== typeY) {
          return naturalSort(typeX, typeY);
        }

        if (typeX === 'Complex') {
          return compareComplexNumbers(x, y);
        }

        if (typeX === 'Unit') {
          if (x.equalBase(y)) {
            return compareNatural(x.value, y.value);
          }

          // compare by units
          return compareArrays(x.formatUnits(), y.formatUnits());
        }

        if (typeX === 'boolean') {
          return compareBooleans(x, y);
        }

        if (typeX === 'string') {
          return naturalSort(x, y);
        }

        if (typeX === 'Object') {
          return compareObjects(x, y);
        }

        if (typeX === 'null') {
          return 0;
        }

        if (typeX === 'undefined') {
          return 0;
        }

        // this should not occur...
        throw new TypeError('Unsupported type of value "' + typeX + '"');
      }
    });

    compareNatural.toTex = undefined; // use default template

    /**
     * Compare mixed matrix/array types, by converting to same-shaped array.
     * This comparator is non-deterministic regarding input types.
     * @param {Array | SparseMatrix | DenseMatrix | *} x
     * @param {Array | SparseMatrix | DenseMatrix | *} y
     * @returns {number} Returns the comparison result: -1, 0, or 1
     */
    function compareMatricesAndArrays (x, y) {
      if (type.isSparseMatrix(x) && type.isSparseMatrix(y)) {
        return compareArrays(x.toJSON().values, y.toJSON().values);
      }
      if (type.isSparseMatrix(x)) {
        // note: convert to array is expensive
        return compareMatricesAndArrays(x.toArray(), y);
      }
      if (type.isSparseMatrix(y)) {
        // note: convert to array is expensive
        return compareMatricesAndArrays(x, y.toArray());
      }

      // convert DenseArray into Array
      if (type.isDenseMatrix(x)) {
        return compareMatricesAndArrays(x.toJSON().data, y);
      }
      if (type.isDenseMatrix(y)) {
        return compareMatricesAndArrays(x, y.toJSON().data);
      }

      // convert scalars to array
      if (!Array.isArray(x)) {
        return compareMatricesAndArrays([x], y);
      }
      if (!Array.isArray(y)) {
        return compareMatricesAndArrays(x, [y]);
      }

      return compareArrays(x, y);
    }

    /**
     * Compare two Arrays
     *
     * - First, compares value by value
     * - Next, if all corresponding values are equal,
     *   look at the length: longest array will be considered largest
     *
     * @param {Array} x
     * @param {Array} y
     * @returns {number} Returns the comparison result: -1, 0, or 1
     */
    function compareArrays (x, y) {
      // compare each value
      for (var i = 0, ii = Math.min(x.length, y.length); i < ii; i++) {
        var v = compareNatural(x[i], y[i]);
        if (v !== 0) {
          return v;
        }
      }

      // compare the size of the arrays
      if (x.length > y.length) { return 1; }
      if (x.length < y.length) { return -1; }

      // both Arrays have equal size and content
      return 0;
    }

    /**
     * Compare two objects
     *
     * - First, compare sorted property names
     * - Next, compare the property values
     *
     * @param {Object} x
     * @param {Object} y
     * @returns {number} Returns the comparison result: -1, 0, or 1
     */
    function compareObjects (x, y) {
      var keysX = Object.keys(x);
      var keysY = Object.keys(y);

      // compare keys
      keysX.sort(naturalSort);
      keysY.sort(naturalSort);
      var c = compareArrays(keysX, keysY);
      if (c !== 0) {
        return c;
      }

      // compare values
      for (var i = 0; i < keysX.length; i++) {
        var v = compareNatural(x[keysX[i]], y[keysY[i]]);
        if (v !== 0) {
          return v;
        }
      }

      return 0;
    }

    return compareNatural;
  }

  /**
   * Compare two complex numbers, `x` and `y`:
   *
   * - First, compare the real values of `x` and `y`
   * - If equal, compare the imaginary values of `x` and `y`
   * 
   * @params {Complex} x
   * @params {Complex} y
   * @returns {number} Returns the comparison result: -1, 0, or 1
   */
  function compareComplexNumbers (x, y) {
    if (x.re > y.re) { return 1; }
    if (x.re < y.re) { return -1; }

    if (x.im > y.im) { return 1; }
    if (x.im < y.im) { return -1; }

    return 0;
  }

  var name$200 = 'compareNatural';
  var factory_1$211 = factory$212;

  var compareNatural$1 = {
  	name: name$200,
  	factory: factory_1$211
  };

  var size$6 = array.size;

  function factory$213 (type, config, load, typed) {
    var matrix$$1 = load(matrix);
    var compareAsc = load(compare$1);
    var compareDesc = function (a, b) {
      return -compareAsc(a, b);
    };
    var compareNatural = load(compareNatural$1);

    /**
     * Sort the items in a matrix.
     *
     * Syntax:
     *
     *    math.sort(x)
     *    math.sort(x, compare)
     *
     * Examples:
     *
     *    math.sort([5, 10, 1]); // returns [1, 5, 10]
     *    math.sort(['C', 'B', 'A', 'D'], math.compareNatural);
     *    // returns ['A', 'B', 'C', 'D']
     *
     *    function sortByLength (a, b) {
     *      return a.length - b.length;
     *    }
     *    math.sort(['Langdon', 'Tom', 'Sara'], sortByLength);
     *    // returns ['Tom', 'Sara', 'Langdon']
     *
     * See also:
     *
     *    filter, forEach, map, compare, compareNatural
     *
     * @param {Matrix | Array} x    A one dimensional matrix or array to sort
     * @param {Function | 'asc' | 'desc' | 'natural'} [compare='asc']
     *        An optional _comparator function or name. The function is called as
     *        `compare(a, b)`, and must return 1 when a > b, -1 when a < b,
     *        and 0 when a == b.
     * @return {Matrix | Array} Returns the sorted matrix.
     */
    var sort = typed('sort', {
      'Array': function (x) {
        _arrayIsVector(x);
        return x.sort(compareAsc);
      },

      'Matrix': function (x) {
        _matrixIsVector(x);
        return matrix$$1(x.toArray().sort(compareAsc), x.storage());
      },

      'Array, function': function (x, _comparator) {
        _arrayIsVector(x);
        return x.sort(_comparator);
      },

      'Matrix, function': function (x, _comparator) {
        _matrixIsVector(x);
        return matrix$$1(x.toArray().sort(_comparator), x.storage());
      },

      'Array, string': function (x, order) {
        _arrayIsVector(x);
        return x.sort(_comparator(order));
      },

      'Matrix, string': function (x, order) {
        _matrixIsVector(x);
        return matrix$$1(x.toArray().sort(_comparator(order)), x.storage());
      }
    });

    sort.toTex = undefined; // use default template

    /**
     * Get the comparator for given order ('asc', 'desc', 'natural')
     * @param {'asc' | 'desc' | 'natural'} order
     * @return {Function} Returns a _comparator function
     */
    function _comparator (order) {
      if (order === 'asc') {
        return compareAsc;
      }
      else if (order === 'desc') {
        return compareDesc;
      }
      else if (order === 'natural') {
        return compareNatural;
      }
      else {
        throw new Error('String "asc", "desc", or "natural" expected');
      }
    }

    /**
     * Validate whether an array is one dimensional
     * Throws an error when this is not the case
     * @param {Array} array
     * @private
     */
    function _arrayIsVector (array$$1) {
      if (size$6(array$$1).length !== 1) {
        throw new Error('One dimensional array expected');
      }
    }

    /**
     * Validate whether a matrix is one dimensional
     * Throws an error when this is not the case
     * @param {Matrix} matrix
     * @private
     */
    function _matrixIsVector (matrix$$1) {
      if (matrix$$1.size().length !== 1) {
        throw new Error('One dimensional matrix expected');
      }
    }

    return sort;
  }

  var name$201 = 'sort';
  var factory_1$212 = factory$213;

  var sort$1 = {
  	name: name$201,
  	factory: factory_1$212
  };

  function factory$214(type, config, load, typed) {
    var matrix$$1   = load(matrix);
    var abs      = load(abs$1);
    var add$$1      = load(add);
    var divide   = load(divide$1);
    var multiply = load(multiply$1);
    var sqrt     = load(sqrt$1);
    var subtract = load(subtract$1);
    var inv      = load(inv$1);
    var size     = load(size$5);
    var max      = load(max$1);
    var eye      = load(eye$1);

    /**
     * Calculate the principal square root of a square matrix.
     * The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.
     *
     * https://en.wikipedia.org/wiki/Square_root_of_a_matrix
     * 
     * Syntax:
     *
     *     X = math.sqrtm(A)
     *
     * Examples:
     *
     *     math.sqrtm([[1, 2], [3, 4]]); // returns [[-2, 1], [1.5, -0.5]]
     *
     * See also:
     *
     *     sqrt, pow
     *
     * @param  {Array | Matrix} A   The square matrix `A`
     * @return {Array | Matrix}     The principal square root of matrix `A`
     */
    var sqrtm = typed('sqrtm', {
      'Array | Matrix': function (A) {
        var size = type.isMatrix(A) ? A.size() : array.size(A);
        switch (size.length) {
          case 1:
            // Single element Array | Matrix
            if (size[0] == 1) {
              return sqrt(A);
            }
            else {
              throw new RangeError('Matrix must be square ' +
              '(size: ' + string.format(size) + ')');
            }

          case 2:
            // Two-dimensional Array | Matrix
            var rows = size[0];
            var cols = size[1];
            if (rows == cols) {
              return _denmanBeavers(A);
            }
            else {
              throw new RangeError('Matrix must be square ' +
              '(size: ' + string.format(size) + ')');
            }
        }
      }
    });

    var _maxIterations = 1e3;
    var _tolerance = 1e-6;

    /**
     * Calculate the principal square root matrix using the Denman–Beavers iterative method
     * 
     * https://en.wikipedia.org/wiki/Square_root_of_a_matrix#By_Denman–Beavers_iteration
     * 
     * @param  {Array | Matrix} A   The square matrix `A`
     * @return {Array | Matrix}     The principal square root of matrix `A`
     * @private
     */
    function _denmanBeavers(A) {
      var error;
      var iterations = 0;

      var Y = A;
      var Z = eye(size(A));

      do {
        var Y_k = Y;
        Y = multiply(0.5, add$$1(Y_k, inv(Z)));
        Z = multiply(0.5, add$$1(Z, inv(Y_k)));

        error = max(abs(subtract(Y, Y_k)));

        if (error > _tolerance && ++iterations > _maxIterations) {
          throw new Error('computing square root of matrix: iterative method could not converge');
        }
      } while (error > _tolerance);

      return Y;
    }

    sqrtm.toTex = {1: '{${args[0]}}' + latex.operators['pow'] + '{\\frac{1}{2}}'};

    return sqrtm;
  }

  var name$202 = 'sqrtm';
  var factory_1$213 = factory$214;

  var sqrtm$1 = {
  	name: name$202,
  	factory: factory_1$213
  };

  function factory$215 (type, config, load, typed) {
    var matrix$$1 = load(matrix);

    /**
     * Squeeze a matrix, remove inner and outer singleton dimensions from a matrix.
     *
     * Syntax:
     *
     *     math.squeeze(x)
     *
     * Examples:
     *
     *     math.squeeze([3]);           // returns 3
     *     math.squeeze([[3]]);         // returns 3
     *
     *     var A = math.zeros(3, 1);    // returns [[0], [0], [0]] (size 3x1)
     *     math.squeeze(A);             // returns [0, 0, 0] (size 3)
     *
     *     var B = math.zeros(1, 3);    // returns [[0, 0, 0]] (size 1x3)
     *     math.squeeze(B);             // returns [0, 0, 0] (size 3)
     *
     *     // only inner and outer dimensions are removed
     *     var C = math.zeros(2, 1, 3); // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
     *     math.squeeze(C);             // returns [[[0, 0, 0]], [[0, 0, 0]]] (size 2x1x3)
     *
     * See also:
     *
     *     subset
     *
     * @param {Matrix | Array} x      Matrix to be squeezed
     * @return {Matrix | Array} Squeezed matrix
     */
    var squeeze = typed('squeeze', {
      'Array': function (x) {
        return array.squeeze(object.clone(x));
      },

      'Matrix': function (x) {
        var res = array.squeeze(x.toArray());
        // FIXME: return the same type of matrix as the input
        return Array.isArray(res) ? matrix$$1(res) : res;
      },

      'any': function (x) {
        // scalar
        return object.clone(x);
      }
    });

    squeeze.toTex = undefined; // use default template

    return squeeze;
  }

  var name$203 = 'squeeze';
  var factory_1$214 = factory$215;

  var squeeze$1 = {
  	name: name$203,
  	factory: factory_1$214
  };

  var matrix$3 = [
    concat$1,
    cross$1,
    det$1,
    diag$1,
    dot$1,
    eye$1,
    expm$1,
    filter_1,
    flatten$3,
    forEach_1,
    inv$1,
    kron$1,
    map$7,
    ones$1,
    partitionSelect$1,
    range$1,
    reshape$1,
    resize$3,
    size$5,
    sort$1,
    sqrtm$1,
    squeeze$1,
    subset$1,
    trace$1,
    transpose$1,
    zeros$1
  ];

  function factory$216 (type, config, load, typed) {
    var add = load(addScalar);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the sum of a matrix or a list with values.
     * In case of a (multi dimensional) array or matrix, the sum of all
     * elements will be calculated.
     *
     * Syntax:
     *
     *     math.sum(a, b, c, ...)
     *     math.sum(A)
     *
     * Examples:
     *
     *     math.sum(2, 1, 4, 3);               // returns 10
     *     math.sum([2, 1, 4, 3]);             // returns 10
     *     math.sum([[2, 5], [4, 3], [1, 7]]); // returns 22
     *
     * See also:
     *
     *    mean, median, min, max, prod, std, var
     *
     * @param {... *} args  A single matrix or or multiple scalar values
     * @return {*} The sum of all values
     */
    var sum = typed('sum', {
      'Array | Matrix': function (args) {
        // sum([a, b, c, d, ...])
        return _sum(args);
      },

      'Array | Matrix, number | BigNumber': function () {
        // sum([a, b, c, d, ...], dim)
        // TODO: implement sum(A, dim)
        throw new Error('sum(A, dim) is not yet supported');
      },

      '...': function (args) {
        // sum(a, b, c, d, ...)
        return _sum(args);
      }
    });

    sum.toTex = undefined; // use default template

    return sum;

    /**
     * Recursively calculate the sum of an n-dimensional array
     * @param {Array} array
     * @return {number} sum
     * @private
     */
    function _sum(array) {
      var sum = undefined;

      deepForEach(array, function (value) {
        try {
          sum = (sum === undefined) ? value : add(sum, value);
        }
        catch (err) {
          throw improveErrorMessage$$1(err, 'sum', value);
        }
      });

      if (sum === undefined) {
        switch (config.number) {
          case 'number':
            return 0;
          case 'BigNumber':
            return new type.BigNumber(0);
          case 'Fraction':
            return new type.Fraction(0);
          default:
            return 0;
        }
      }

      return sum;
    }
  }

  var name$204 = 'sum';
  var factory_1$215 = factory$216;

  var sum$1 = {
  	name: name$204,
  	factory: factory_1$215
  };

  function factory$217(type, config, load, typed) {
      var matrix$$1 = load(matrix);
      var divide = load(divide$1);
      var sum = load(sum$1);
      var multiply = load(multiply$1);
      var dotDivide = load(dotDivide$1);
      var log = load(log$1);
      var isNumeric = load(isNumeric$1);

      /**
       * Calculate the Kullback-Leibler (KL) divergence  between two distributions
       *
       * Syntax:
       *
       *     math.kldivergence(x, y)
       *
       * Examples:
       *
       *     math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5]);   //returns 0.24376698773121153
       *
       *
       * @param  {Array | Matrix} q    First vector
       * @param  {Array | Matrix} p    Second vector
       * @return {number}              Returns distance between q and p
       */
      var kldivergence = typed('kldivergence', {
          'Array, Array': function(q, p) {
              return _kldiv(matrix$$1(q), matrix$$1(p));
          },

          'Matrix, Array': function(q, p) {
              return _kldiv(q, matrix$$1(p));
          },

          'Array, Matrix': function(q, p){
              return _kldiv(matrix$$1(q), p);
          },

          'Matrix, Matrix': function(q, p){
              return _kldiv(q, p);
          }

      });

      function _kldiv(q, p) {
          var plength = p.size().length;
          var qlength = q.size().length;
          if (plength > 1) {
              throw new Error('first object must be one dimensional');
          }
          
          if (qlength > 1) {
              throw new Error('second object must be one dimensional');
          }
          
          if(plength !== qlength){
              throw new Error("Length of two vectors must be equal");
          }
          
          //Before calculation, apply normalization
          var sumq = sum(q);
          if (sumq === 0) {
              throw new Error("Sum of elements in first object must be non zero");
          }

          var sump = sum(p);
          if (sump === 0) {
              throw new Error("Sum of elements in second object must be non zero");
          }
          var qnorm = divide(q, sum(q));
          var pnorm = divide(p, sum(p));

          var result = sum(multiply(qnorm, log(dotDivide(qnorm, pnorm))));
          if (isNumeric(result)) {
              return result;
          }
          else {
              return Number.NaN;
          }
      }

      return kldivergence;
  }


  var name$205 = 'kldivergence';
  var factory_1$216 = factory$217;

  var kldivergence$1 = {
  	name: name$205,
  	factory: factory_1$216
  };

  function factory$218 (type, config, load, typed) {
    var add$$1 = load(add);
    var multiply = load(multiply$1);
    var divide = load(divide$1);
    var factorial = load(factorial$1);
    var isInteger = load(isInteger$22);
    var isPositive = load(isPositive$1);

    /**
     * Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities.
     *
     * multinomial takes one array of integers as an argument.
     * The following condition must be enforced: every ai <= 0
     *
     * Syntax:
     *
     *     math.multinomial(a) // a is an array type
     *
     * Examples:
     *
     *    math.multinomial([1,2,1]); // returns 12
     *
     * See also:
     *
     *    combinations, factorial
     *
     * @param {number[] | BigNumber[]} a    Integer numbers of objects in the subset
     * @return {Number | BigNumber}         Multinomial coefficient.
     */
    return typed('multinomial', {
      'Array | Matrix': function (a) {
        var sum = 0;
        var denom = 1;

        deepForEach(a, function(ai) {
          if(!isInteger(ai) || !isPositive(ai)) {
            throw new TypeError('Positive integer value expected in function multinomial');
          }
          sum = add$$1(sum, ai);
          denom = multiply(denom, factorial(ai));
        });

        return divide(factorial(sum), denom);
      }
    });
  }

  var name$206 = 'multinomial';
  var factory_1$217 = factory$218;

  var multinomial$1 = {
  	name: name$206,
  	factory: factory_1$217
  };

  var isInteger$28 = number.isInteger;

  function factory$219 (type, config, load, typed) {
    var factorial = load(factorial$1);

    /**
     * Compute the number of ways of obtaining an ordered subset of `k` elements
     * from a set of `n` elements.
     *
     * Permutations only takes integer arguments.
     * The following condition must be enforced: k <= n.
     *
     * Syntax:
     *
     *     math.permutations(n)
     *     math.permutations(n, k)
     *
     * Examples:
     *
     *    math.permutations(5);     // 120
     *    math.permutations(5, 3);  // 60
     *
     * See also:
     *
     *    combinations, factorial
     *
     * @param {number | BigNumber} n   The number of objects in total
     * @param {number | BigNumber} [k] The number of objects in the subset
     * @return {number | BigNumber}    The number of permutations
     */
    var permutations = typed('permutations', {
      'number | BigNumber': factorial,

      'number, number': function (n, k) {
        var result, i;

        if (!isInteger$28(n) || n < 0) {
          throw new TypeError('Positive integer value expected in function permutations');
        }
        if (!isInteger$28(k) || k < 0) {
          throw new TypeError('Positive integer value expected in function permutations');
        }
        if (k > n) {
          throw new TypeError('second argument k must be less than or equal to first argument n');
        }

        // Permute n objects, k at a time
        result = 1;
        for (i = n - k + 1; i <= n; i++) {
          result = result * i;
        }

        return result;
      },

      'BigNumber, BigNumber': function (n, k) {
        var result, i;

        if (!isPositiveInteger$1(n) || !isPositiveInteger$1(k)) {
          throw new TypeError('Positive integer value expected in function permutations');
        }
        if (k.gt(n)) {
          throw new TypeError('second argument k must be less than or equal to first argument n');
        }

        result = new type.BigNumber(1);
        for (i = n.minus(k).plus(1); i.lte(n); i = i.plus(1)) {
          result = result.times(i);
        }

        return result;
      }

      // TODO: implement support for collection in permutations
    });

    permutations.toTex = undefined; // use default template

    return permutations;
  }

  /**
   * Test whether BigNumber n is a positive integer
   * @param {BigNumber} n
   * @returns {boolean} isPositiveInteger
   */
  function isPositiveInteger$1(n) {
    return n.isInteger() && n.gte(0);
  }

  var name$207 = 'permutations';
  var factory_1$218 = factory$219;

  var permutations$1 = {
  	name: name$207,
  	factory: factory_1$218
  };

  var seedRandom = createCommonjsModule(function (module) {

  var width = 256;// each RC4 output is 0 <= x < 256
  var chunks = 6;// at least six RC4 outputs for each double
  var digits = 52;// there are 52 significant digits in a double
  var pool = [];// pool: entropy pool starts empty
  var GLOBAL = typeof commonjsGlobal === 'undefined' ? window : commonjsGlobal;

  //
  // The following constants are related to IEEE 754 limits.
  //
  var startdenom = Math.pow(width, chunks),
      significance = Math.pow(2, digits),
      overflow = significance * 2,
      mask = width - 1;


  var oldRandom = Math.random;

  //
  // seedrandom()
  // This is the seedrandom function described above.
  //
  module.exports = function(seed, options) {
    if (options && options.global === true) {
      options.global = false;
      Math.random = module.exports(seed, options);
      options.global = true;
      return Math.random;
    }
    var use_entropy = (options && options.entropy) || false;
    var key = [];

    // Flatten the seed string or build one from local entropy if needed.
    var shortseed = mixkey(flatten(
      use_entropy ? [seed, tostring(pool)] :
      0 in arguments ? seed : autoseed(), 3), key);

    // Use the seed to initialize an ARC4 generator.
    var arc4 = new ARC4(key);

    // Mix the randomness into accumulated entropy.
    mixkey(tostring(arc4.S), pool);

    // Override Math.random

    // This function returns a random double in [0, 1) that contains
    // randomness in every bit of the mantissa of the IEEE 754 value.

    return function() {         // Closure to return a random double:
      var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
          d = startdenom,                 //   and denominator d = 2 ^ 48.
          x = 0;                          //   and no 'extra last byte'.
      while (n < significance) {          // Fill up all significant digits by
        n = (n + x) * width;              //   shifting numerator and
        d *= width;                       //   denominator and generating a
        x = arc4.g(1);                    //   new least-significant-byte.
      }
      while (n >= overflow) {             // To avoid rounding up, before adding
        n /= 2;                           //   last byte, shift everything
        d /= 2;                           //   right using integer Math until
        x >>>= 1;                         //   we have exactly the desired bits.
      }
      return (n + x) / d;                 // Form the number within [0, 1).
    };
  };

  module.exports.resetGlobal = function () {
    Math.random = oldRandom;
  };

  //
  // ARC4
  //
  // An ARC4 implementation.  The constructor takes a key in the form of
  // an array of at most (width) integers that should be 0 <= x < (width).
  //
  // The g(count) method returns a pseudorandom integer that concatenates
  // the next (count) outputs from ARC4.  Its return value is a number x
  // that is in the range 0 <= x < (width ^ count).
  //
  /** @constructor */
  function ARC4(key) {
    var t, keylen = key.length,
        me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];

    // The empty key [] is treated as [0].
    if (!keylen) { key = [keylen++]; }

    // Set up S using the standard key scheduling algorithm.
    while (i < width) {
      s[i] = i++;
    }
    for (i = 0; i < width; i++) {
      s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
      s[j] = t;
    }

    // The "g" method returns the next (count) outputs as one number.
    (me.g = function(count) {
      // Using instance members instead of closure state nearly doubles speed.
      var t, r = 0,
          i = me.i, j = me.j, s = me.S;
      while (count--) {
        t = s[i = mask & (i + 1)];
        r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
      }
      me.i = i; me.j = j;
      return r;
      // For robust unpredictability discard an initial batch of values.
      // See http://www.rsa.com/rsalabs/node.asp?id=2009
    })(width);
  }

  //
  // flatten()
  // Converts an object tree to nested arrays of strings.
  //
  function flatten(obj, depth) {
    var result = [], typ = (typeof obj)[0], prop;
    if (depth && typ == 'o') {
      for (prop in obj) {
        try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
      }
    }
    return (result.length ? result : typ == 's' ? obj : obj + '\0');
  }

  //
  // mixkey()
  // Mixes a string seed into a key that is an array of integers, and
  // returns a shortened string seed that is equivalent to the result key.
  //
  function mixkey(seed, key) {
    var stringseed = seed + '', smear, j = 0;
    while (j < stringseed.length) {
      key[mask & j] =
        mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
    }
    return tostring(key);
  }

  //
  // autoseed()
  // Returns an object for autoseeding, using window.crypto if available.
  //
  /** @param {Uint8Array=} seed */
  function autoseed(seed) {
    try {
      GLOBAL.crypto.getRandomValues(seed = new Uint8Array(width));
      return tostring(seed);
    } catch (e) {
      return [+new Date, GLOBAL, GLOBAL.navigator && GLOBAL.navigator.plugins,
              GLOBAL.screen, tostring(pool)];
    }
  }

  //
  // tostring()
  // Converts an array of charcodes to a string
  //
  function tostring(a) {
    return String.fromCharCode.apply(0, a);
  }

  //
  // When seedrandom.js is loaded, we immediately mix a few bits
  // from the built-in RNG into the entropy pool.  Because we do
  // not want to intefere with determinstic PRNG state later,
  // seedrandom will not call Math.random on its own again after
  // initialization.
  //
  mixkey(Math.random(), pool);
  });
  var seedRandom_1 = seedRandom.resetGlobal;

  // create a random seed here to prevent an infinite loop from seed-random
  // inside the factory. Reason is that math.random is defined as a getter/setter
  // and seed-random generates a seed from the local entropy by reading every
  // defined object including `math` itself. That means that whilst getting
  // math.random, it tries to get math.random, etc... an infinite loop.
  // See https://github.com/ForbesLindesay/seed-random/issues/6
  var singletonRandom = seedRandom();

  function factory$220 (type, config, load, typed, math) {
    var random;

    // create a new random generator with given seed
    function setSeed (seed) {
      random = seed === null ? singletonRandom : seedRandom(String(seed));
    }

    // initialize a seeded pseudo random number generator with config's random seed
    setSeed(config.randomSeed);

    // wrapper function so the rng can be updated via generator
    function rng() {
        return random();
    }

    // updates generator with a new instance of a seeded pseudo random number generator
    math.on('config', function (curr, prev, changes) {
      // if the user specified a randomSeed
      if(changes.randomSeed !== undefined) {
        // update generator with a new instance of a seeded pseudo random number generator
        setSeed(curr.randomSeed);
      }
    });

    return rng;
  }

  var factory_1$219 = factory$220;
  var math$17 = true;

  var seededRNG = {
  	factory: factory_1$219,
  	math: math$17
  };

  var isNumber$3 = number.isNumber;

  // TODO: rethink math.distribution
  // TODO: rework to a typed function
  function factory$221 (type, config, load, typed, math) {
    var matrix$$1 = load(matrix);
    var array$$1 = array;

    // seeded pseudo random number generator
    var rng = load(seededRNG);

    /**
     * Create a distribution object with a set of random functions for given
     * random distribution.
     *
     * Syntax:
     *
     *     math.distribution(name)
     *
     * Examples:
     *
     *     var normalDist = math.distribution('normal'); // create a normal distribution
     *     normalDist.random(0, 10);                     // get a random value between 0 and 10
     *
     * See also:
     *
     *     random, randomInt, pickRandom
     *
     * @param {string} name   Name of a distribution. Choose from 'uniform', 'normal'.
     * @return {Object}       Returns a distribution object containing functions:
     *                        `random([size] [, min] [, max])`,
     *                        `randomInt([min] [, max])`,
     *                        `pickRandom(array)`
     */
    function distribution(name) {
      if (!distributions.hasOwnProperty(name))
        throw new Error('Unknown distribution ' + name);

      var args = Array.prototype.slice.call(arguments, 1),
          distribution = distributions[name].apply(this, args);

      return (function(distribution) {

        // This is the public API for all distributions
        var randFunctions = {

          random: function(arg1, arg2, arg3) {
            var size, min, max;

            if (arguments.length > 3) {
              throw new ArgumentsError_1('random', arguments.length, 0, 3);
            } else if (arguments.length === 1) {
              // `random(max)` or `random(size)`
              if (isCollection(arg1)) {
                size = arg1;
              } else {
                max = arg1;
              }
            } else if (arguments.length === 2) {
              // `random(min, max)` or `random(size, max)`
              if (isCollection(arg1)) {
                size = arg1;
                max = arg2;
              } else {
                min = arg1;
                max = arg2;
              }
            } else {
              // `random(size, min, max)`
              size = arg1;
              min = arg2;
              max = arg3;
            }

            // TODO: validate type of size
            if ((min !== undefined && !isNumber$3(min)) || (max !== undefined && !isNumber$3(max))) {
              throw new TypeError('Invalid argument in function random');
            }

            if (max === undefined) max = 1;
            if (min === undefined) min = 0;
            if (size !== undefined) {
              var res = _randomDataForMatrix(size.valueOf(), min, max, _random);
              return type.isMatrix(size) ? matrix$$1(res) : res;
            }
            return _random(min, max);
          },

          randomInt: typed({
            'number | Array': function(arg) {
              var min = 0;

              if (isCollection(arg)) {
                var size = arg;
                var max = 1;
                var res = _randomDataForMatrix(size.valueOf(), min, max, _randomInt);
                return type.isMatrix(size) ? matrix$$1(res) : res;
              } else {
                var max = arg;
                return _randomInt(min, max);
              }
            },
            'number | Array, number': function(arg1, arg2) {
              if (isCollection(arg1)) {
                var size = arg1;
                var max = arg2;
                var min = 0;
                var res = _randomDataForMatrix(size.valueOf(), min, max, _randomInt);
                return type.isMatrix(size) ? matrix$$1(res) : res;
              }
              else {
                var min = arg1;
                var max = arg2;
                return _randomInt(min, max);
              }
            },
            'Array, number, number': function(size, min, max) {
              var res = _randomDataForMatrix(size.valueOf(), min, max, _randomInt);
              return (size && size.isMatrix === true) ? matrix$$1(res) : res;
            }
          }),

          pickRandom: typed({
            'Array': function(possibles) {
              return _pickRandom(possibles);
            },
            'Array, number | Array': function(possibles, arg2) {
              var number$$1, weights;

              if (Array.isArray(arg2)) {
                weights = arg2;
              } else if (isNumber$3(arg2)) {
                number$$1 = arg2;
              } else {
                throw new TypeError('Invalid argument in function pickRandom')
              }

              return _pickRandom(possibles, number$$1, weights);
            },
            'Array, number | Array, Array | number': function(possibles, arg2, arg3) {
              var number$$1, weights;

              if (Array.isArray(arg2)) {
                weights = arg2;
                number$$1 = arg3;
              } else {
                weights = arg3;
                number$$1 = arg2;
              }

              if (!Array.isArray(weights) || !isNumber$3(number$$1)) {
                throw new TypeError('Invalid argument in function pickRandom');
              }

              return _pickRandom(possibles, number$$1, weights);
            }
          })
        };

        var _pickRandom = function(possibles, number$$1, weights) {
          var single = (typeof number$$1 === 'undefined');

          if (single) {
            number$$1 = 1;
          }

          if (type.isMatrix(possibles)) {
            possibles = possibles.valueOf(); // get Array
          } else if (!Array.isArray(possibles)) {
            throw new TypeError('Unsupported type of value in function pickRandom');
          }

          if (array$$1.size(possibles).length > 1) {
            throw new Error('Only one dimensional vectors supported');
          }

          if (typeof weights !== 'undefined') {
            if (weights.length != possibles.length) {
              throw new Error('Weights must have the same length as possibles');
            }

            var totalWeights = 0;

            for (var i = 0, len = weights.length; i < len; i++) {
              if (!isNumber$3(weights[i]) || weights[i] < 0) {
                throw new Error('Weights must be an array of positive numbers');
              }

              totalWeights += weights[i];
            }
          }

          var length = possibles.length;

          if (length == 0) {
            return [];
          } else if (number$$1 >= length) {
            return number$$1 > 1 ? possibles : possibles[0];
          }

          var result = [];
          var pick;

          while (result.length < number$$1) {
            if (typeof weights === 'undefined') {
              pick = possibles[Math.floor(rng() * length)];
            } else {
              var randKey = rng() * totalWeights;

              for (var i = 0, len = possibles.length; i < len; i++) {
                randKey -= weights[i];

                if (randKey < 0) {
                  pick = possibles[i];
                  break;
                }
              }
            }

            if (result.indexOf(pick) == -1) {
              result.push(pick);
            }
          }

          return single ? result[0] : result;

          // TODO: add support for multi dimensional matrices
        };

        var _random = function(min, max) {
          return min + distribution() * (max - min);
        };

        var _randomInt = function(min, max) {
          return Math.floor(min + distribution() * (max - min));
        };

        // This is a function for generating a random matrix recursively.
        var _randomDataForMatrix = function(size, min, max, randFunc) {
          var data = [], length, i;
          size = size.slice(0);

          if (size.length > 1) {
            for (var i = 0, length = size.shift(); i < length; i++) {
              data.push(_randomDataForMatrix(size, min, max, randFunc));
            }
          } else {
            for (var i = 0, length = size.shift(); i < length; i++) {
              data.push(randFunc(min, max));
            }
          }

          return data;
        };

        return randFunctions;

      })(distribution);
    }

    // Each distribution is a function that takes no argument and when called returns
    // a number between 0 and 1.
    var distributions = {

      uniform: function() {
        return rng;
      },

      // Implementation of normal distribution using Box-Muller transform
      // ref : http://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
      // We take : mean = 0.5, standard deviation = 1/6
      // so that 99.7% values are in [0, 1].
      normal: function() {
        return function() {
          var u1, u2,
              picked = -1;
          // We reject values outside of the interval [0, 1]
          // TODO: check if it is ok to do that?
          while (picked < 0 || picked > 1) {
            u1 = rng();
            u2 = rng();
            picked = 1/6 * Math.pow(-2 * Math.log(u1), 0.5) * Math.cos(2 * Math.PI * u2) + 0.5;
          }
          return picked;
        }
      }
    };

    distribution.toTex = undefined; // use default template

    return distribution;
  }

  var name$208 = 'distribution';
  var factory_1$220 = factory$221;

  var distribution = {
  	name: name$208,
  	factory: factory_1$220
  };

  function factory$222 (type, config, load, typed) {
    var distribution$$1 = load(distribution);

    /**
     * Random pick one or more values from a one dimensional array.
     * Array elements are picked using a random function with uniform or weighted distribution.
     *
     * Syntax:
     *
     *     math.pickRandom(array)
     *     math.pickRandom(array, number)
     *     math.pickRandom(array, weights)
     *     math.pickRandom(array, number, weights)
     *     math.pickRandom(array, weights, number)
     *
     * Examples:
     *
     *     math.pickRandom([3, 6, 12, 2]);                  // returns one of the values in the array
     *     math.pickRandom([3, 6, 12, 2], 2);               // returns an array of two of the values in the array
     *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1]);    // returns one of the values in the array with weighted distribution
     *     math.pickRandom([3, 6, 12, 2], 2, [1, 3, 2, 1]); // returns an array of two of the values in the array with weighted distribution
     *     math.pickRandom([3, 6, 12, 2], [1, 3, 2, 1], 2); // returns an array of two of the values in the array with weighted distribution
     *
     * See also:
     *
     *     random, randomInt
     *
     * @param {Array} array     A one dimensional array
     * @param {Int} number      An int or float
     * @param {Array} weights   An array of ints or floats
     * @return {number | Array} Returns a single random value from array when number is 1 or undefined.
     *                          Returns an array with the configured number of elements when number is > 1.
     */
    // TODO: rework pickRandom to a typed-function
    var pickRandom =  distribution$$1('uniform').pickRandom;

    pickRandom.toTex = undefined; // use default template

    return pickRandom;
  }

  var name$209 = 'pickRandom';
  var factory_1$221 = factory$222;

  var pickRandom$1 = {
  	name: name$209,
  	factory: factory_1$221
  };

  function factory$223 (type, config, load, typed) {
    var distribution$$1 = load(distribution);

    /**
     * Return a random number larger or equal to `min` and smaller than `max`
     * using a uniform distribution.
     *
     * Syntax:
     *
     *     math.random()                // generate a random number between 0 and 1
     *     math.random(max)             // generate a random number between 0 and max
     *     math.random(min, max)        // generate a random number between min and max
     *     math.random(size)            // generate a matrix with random numbers between 0 and 1
     *     math.random(size, max)       // generate a matrix with random numbers between 0 and max
     *     math.random(size, min, max)  // generate a matrix with random numbers between min and max
     *
     * Examples:
     *
     *     math.random();       // returns a random number between 0 and 1
     *     math.random(100);    // returns a random number between 0 and 100
     *     math.random(30, 40); // returns a random number between 30 and 40
     *     math.random([2, 3]); // returns a 2x3 matrix with random numbers between 0 and 1
     *
     * See also:
     *
     *     randomInt, pickRandom
     *
     * @param {Array | Matrix} [size] If provided, an array or matrix with given
     *                                size and filled with random values is returned
     * @param {number} [min]  Minimum boundary for the random value, included
     * @param {number} [max]  Maximum boundary for the random value, excluded
     * @return {number | Array | Matrix} A random number
     */
    // TODO: rework random to a typed-function
    var random = distribution$$1('uniform').random;

    random.toTex = undefined; // use default template

    return random;
  }

  var name$210 = 'random';
  var factory_1$222 = factory$223;

  var random$1 = {
  	name: name$210,
  	factory: factory_1$222
  };

  function factory$224 (type, config, load, typed) {
    var distribution$$1 = load(distribution);

    /**
     * Return a random integer number larger or equal to `min` and smaller than `max`
     * using a uniform distribution.
     *
     * Syntax:
     *
     *     math.randomInt(max)             // generate a random integer between 0 and max
     *     math.randomInt(min, max)        // generate a random integer between min and max
     *     math.randomInt(size)            // generate a matrix with random integer between 0 and 1
     *     math.randomInt(size, max)       // generate a matrix with random integer between 0 and max
     *     math.randomInt(size, min, max)  // generate a matrix with random integer between min and max
     *
     * Examples:
     *
     *     math.randomInt(100);    // returns a random integer between 0 and 100
     *     math.randomInt(30, 40); // returns a random integer between 30 and 40
     *     math.randomInt([2, 3]); // returns a 2x3 matrix with random integers between 0 and 1
     *
     * See also:
     *
     *     random, pickRandom
     *
     * @param {Array | Matrix} [size] If provided, an array or matrix with given
     *                                size and filled with random values is returned
     * @param {number} [min]  Minimum boundary for the random value, included
     * @param {number} [max]  Maximum boundary for the random value, excluded
     * @return {number | Array | Matrix} A random integer value
     */
    // TODO: rework randomInt to a typed-function
    var randomInt = distribution$$1('uniform').randomInt;

    randomInt.toTex = undefined; // use default template

    return randomInt;
  }

  var name$211 = 'randomInt';
  var factory_1$223 = factory$224;

  var randomInt$1 = {
  	name: name$211,
  	factory: factory_1$223
  };

  var probability = [
    //require('./distribution'), // TODO: rethink math.distribution
    combinations$1,
    factorial$1,
    gamma$1,
    kldivergence$1,
    multinomial$1,
    permutations$1,
    pickRandom$1,
    random$1,
    randomInt$1
  ];

  function factory$225 (type, config, load, typed) {

    var matrix$$1 = load(matrix);
    var _typeof = load(_typeof$1);

    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);
    
    /**
     * Compare two strings lexically. Comparison is case sensitive.
     * Returns 1 when x > y, -1 when x < y, and 0 when x == y.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.compareText(x, y)
     *
     * Examples:
     *
     *    math.compareText('B', 'A');     // returns 1
     *    math.compareText('2', '10');    // returns 1
     *    math.compare('2', '10');        // returns -1
     *    math.compareNatural('2', '10'); // returns -1
     *
     *    math.compareText('B', ['A', 'B', 'C']); // returns [1, 0, -1]
     *
     * See also:
     *
     *    equal, equalText, compare, compareNatural
     *
     * @param  {string | Array | DenseMatrix} x First string to compare
     * @param  {string | Array | DenseMatrix} y Second string to compare
     * @return {number | Array | DenseMatrix} Returns the result of the comparison:
     *                                        1 when x > y, -1 when x < y, and 0 when x == y.
     */
    var compareText = typed('compareText', {

      'any, any': _compareText,

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, _compareText);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return compareText(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return compareText(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return compareText(x, matrix$$1(y));
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, _compareText, false);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, _compareText, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, _compareText, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, _compareText, true).valueOf();
      }
    });

    /**
     * Compare two strings
     * @param {string} x
     * @param {string} y
     * @returns {number}
     * @private
     */
    function _compareText(x, y) {
      // we don't want to convert numbers to string, only accept string input
      if (!type.isString(x)) {
        throw new TypeError('Unexpected type of argument in function compareText ' +
            '(expected: string or Array or Matrix, actual: ' + _typeof(x) + ', index: 0)');
      }
      if (!type.isString(y)) {
        throw new TypeError('Unexpected type of argument in function compareText ' +
            '(expected: string or Array or Matrix, actual: ' + _typeof(y) + ', index: 1)');
      }

      return (x === y)
          ? 0
          : (x > y ? 1 : -1);
    }

    compareText.toTex = undefined; // use default template

    return compareText;
  }

  var name$212 = 'compareText';
  var factory_1$224 = factory$225;

  var compareText$1 = {
  	name: name$212,
  	factory: factory_1$224
  };

  function factory$226 (type, config, load, typed) {
    var equal = load(equal$1);

    /**
     * Test element wise whether two matrices are equal.
     * The function accepts both matrices and scalar values.
     *
     * Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.deepEqual(x, y)
     *
     * Examples:
     *
     *    math.deepEqual(2, 4);   // returns false
     *
     *    a = [2, 5, 1];
     *    b = [2, 7, 1];
     *
     *    math.deepEqual(a, b);   // returns false
     *    math.equal(a, b);       // returns [true, false, true]
     *
     * See also:
     *
     *    equal, unequal
     *
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} x First matrix to compare
     * @param  {number | BigNumber | Fraction | Complex | Unit | Array | Matrix} y Second matrix to compare
     * @return {number | BigNumber | Fraction | Complex | Unit | Array | Matrix}
     *            Returns true when the input matrices have the same size and each of their elements is equal.
     */
    var deepEqual = typed('deepEqual', {
      'any, any': function (x, y) {
        return _deepEqual(x.valueOf(), y.valueOf());
      }
    });

    deepEqual.toTex = undefined; // use default template

    return deepEqual;

    /**
     * Test whether two arrays have the same size and all elements are equal
     * @param {Array | *} x
     * @param {Array | *} y
     * @return {boolean} Returns true if both arrays are deep equal
     */
    function _deepEqual(x, y) {
      if (Array.isArray(x)) {
        if (Array.isArray(y)) {
          var len = x.length;
          if (len !== y.length) {
            return false;
          }

          for (var i = 0; i < len; i++) {
            if (!_deepEqual(x[i], y[i])) {
              return false;
            }
          }

          return true;
        }
        else {
          return false;
        }
      }
      else {
        if (Array.isArray(y)) {
          return false;
        }
        else {
          return equal(x, y);
        }
      }
    }
  }

  var name$213 = 'deepEqual';
  var factory_1$225 = factory$226;

  var deepEqual$2 = {
  	name: name$213,
  	factory: factory_1$225
  };

  function factory$227 (type, config, load, typed) {
    var compareText = load(compareText$1);
    var isZero = load(isZero$1);

    /**
     * Check equality of two strings. Comparison is case sensitive.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.equalText(x, y)
     *
     * Examples:
     *
     *    math.equalText('Hello', 'Hello');     // returns true
     *    math.equalText('a', 'A');     // returns false
     *    math.equal('2e3', '2000');        // returns true
     *    math.equalText('2e3', '2000');        // returns false
     *
     *    math.equalText('B', ['A', 'B', 'C']); // returns [false, true, false]
     *
     * See also:
     *
     *    equal, compareText, compare, compareNatural
     *
     * @param  {string | Array | DenseMatrix} x First string to compare
     * @param  {string | Array | DenseMatrix} y Second string to compare
     * @return {number | Array | DenseMatrix} Returns true if the values are equal, and false if not.
     */
    var equalText = typed('equalText', {

      'any, any': function (x, y) {
        return isZero(compareText(x, y));
      }

    });

    equalText.toTex = undefined; // use default template

    return equalText;
  }

  var name$214 = 'equalText';
  var factory_1$226 = factory$227;

  var equalText$1 = {
  	name: name$214,
  	factory: factory_1$226
  };

  var nearlyEqual$7 = number.nearlyEqual;


  function factory$228 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm03$$1 = load(algorithm03);
    var algorithm07$$1 = load(algorithm07);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    var latex$$1 = latex;

    /**
     * Test whether value x is smaller or equal to y.
     *
     * The function returns true when x is smaller than y or the relative
     * difference between x and y is smaller than the configured epsilon. The
     * function cannot be used to compare values smaller than approximately 2.22e-16.
     *
     * For matrices, the function is evaluated element wise.
     * Strings are compared by their numerical value.
     *
     * Syntax:
     *
     *    math.smallerEq(x, y)
     *
     * Examples:
     *
     *    math.smaller(1 + 2, 3);        // returns false
     *    math.smallerEq(1 + 2, 3);      // returns true
     *
     * See also:
     *
     *    equal, unequal, smaller, larger, largerEq, compare
     *
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} x First value to compare
     * @param  {number | BigNumber | Fraction | boolean | Unit | string | Array | Matrix} y Second value to compare
     * @return {boolean | Array | Matrix} Returns true when the x is smaller than y, else returns false
     */
    var smallerEq = typed('smallerEq', {

      'boolean, boolean': function (x, y) {
        return x <= y;
      },

      'number, number': function (x, y) {
        return x <= y || nearlyEqual$7(x, y, config.epsilon);
      },

      'BigNumber, BigNumber': function (x, y) {
        return x.lte(y) || nearlyEqual(x, y, config.epsilon);
      },

      'Fraction, Fraction': function (x, y) {
        return x.compare(y) !== 1;
      },

      'Complex, Complex': function () {
        throw new TypeError('No ordering relation is defined for complex numbers');
      },

      'Unit, Unit': function (x, y) {
        if (!x.equalBase(y)) {
          throw new Error('Cannot compare units with different base');
        }
        return smallerEq(x.value, y.value);
      },

      'SparseMatrix, SparseMatrix': function(x, y) {
        return algorithm07$$1(x, y, smallerEq);
      },

      'SparseMatrix, DenseMatrix': function(x, y) {
        return algorithm03$$1(y, x, smallerEq, true);
      },

      'DenseMatrix, SparseMatrix': function(x, y) {
        return algorithm03$$1(x, y, smallerEq, false);
      },

      'DenseMatrix, DenseMatrix': function(x, y) {
        return algorithm13$$1(x, y, smallerEq);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return smallerEq(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return smallerEq(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return smallerEq(x, matrix$$1(y));
      },

      'SparseMatrix, any': function (x, y) {
        return algorithm12$$1(x, y, smallerEq, false);
      },

      'DenseMatrix, any': function (x, y) {
        return algorithm14$$1(x, y, smallerEq, false);
      },

      'any, SparseMatrix': function (x, y) {
        return algorithm12$$1(y, x, smallerEq, true);
      },

      'any, DenseMatrix': function (x, y) {
        return algorithm14$$1(y, x, smallerEq, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, smallerEq, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, smallerEq, true).valueOf();
      }
    });

    smallerEq.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['smallerEq'] + '${args[1]}\\right)'
    };

    return smallerEq;
  }

  var name$215 = 'smallerEq';
  var factory_1$227 = factory$228;

  var smallerEq$1 = {
  	name: name$215,
  	factory: factory_1$227
  };

  var relational = [
    compare$1,
    compareNatural$1,
    compareText$1,
    deepEqual$2,
    equal$1,
    equalText$1,
    larger,
    largerEq$1,
    smaller,
    smallerEq$1,
    unequal$1
  ];

  var flatten$4 = array.flatten;

  function factory$229 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var matrix = load(DenseMatrix);
    var size = load(size$5);
    var subset = load(subset$1);
    var compareNatural = load(compareNatural$1);
    
    /**
     * Create the cartesian product of two (multi)sets.
     * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
     *
     * Syntax:
     *
     *    math.setCartesian(set1, set2)
     *
     * Examples:
     *
     *    math.setCartesian([1, 2], [3, 4]);        // returns [[1, 3], [1, 4], [2, 3], [2, 4]]
     *
     * See also:
     *
     *    setUnion, setIntersect, setDifference, setPowerset
     *
     * @param {Array | Matrix}    a1  A (multi)set
     * @param {Array | Matrix}    a2  A (multi)set
     * @return {Array | Matrix}    The cartesian product of two (multi)sets
     */
    var setCartesian = typed('setCartesian', {
      'Array | Matrix, Array | Matrix': function (a1, a2) {
        if (subset(size(a1), new index(0)) === 0 || subset(size(a2), new index(0)) === 0) { // if any of them is empty, return empty
          var result = [];
        }
        else {
          var b1 = flatten$4(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural);
          var b2 = flatten$4(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural);
          var result = [];
          for (var i=0; i<b1.length; i++) {
            for (var j=0; j<b2.length; j++) {
              result.push([b1[i], b2[j]]);
            }
          }
        }
        // return an array, if both inputs were arrays
        if (Array.isArray(a1) && Array.isArray(a2)) {
          return result;
        }
        // return a matrix otherwise
        return new matrix(result);
      }
    });

    return setCartesian;
  }

  var name$216 = 'setCartesian';
  var factory_1$228 = factory$229;

  var setCartesian$1 = {
  	name: name$216,
  	factory: factory_1$228
  };

  var flatten$5 = array.flatten;
  var identify = array.identify;
  var generalize = array.generalize;

  function factory$230 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var matrix = load(DenseMatrix);
    var size = load(size$5);
    var subset = load(subset$1);
    var compareNatural = load(compareNatural$1);
    
    /**
     * Create the difference of two (multi)sets: every element of set1, that is not the element of set2.
     * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
     *
     * Syntax:
     *
     *    math.setDifference(set1, set2)
     *
     * Examples:
     *
     *    math.setDifference([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [1, 2]
     *    math.setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [1, 2]
     *
     * See also:
     *
     *    setUnion, setIntersect, setSymDifference
     *
     * @param {Array | Matrix}    a1  A (multi)set
     * @param {Array | Matrix}    a2  A (multi)set
     * @return {Array | Matrix}    The difference of two (multi)sets
     */
    var setDifference = typed('setDifference', {
      'Array | Matrix, Array | Matrix': function (a1, a2) {
        if (subset(size(a1), new index(0)) === 0) { // empty-anything=empty
          var result = [];
        }
        else if (subset(size(a2), new index(0)) === 0) { // anything-empty=anything
          return flatten$5(a1.toArray());
        }
        else {
          var b1 = identify(flatten$5(Array.isArray(a1) ? a1: a1.toArray()).sort(compareNatural));
          var b2 = identify(flatten$5(Array.isArray(a2) ? a2: a2.toArray()).sort(compareNatural));
          var result = [];
          var inb2;
          for (var i=0; i<b1.length; i++) {
            inb2 = false;
            for (var j=0; j<b2.length; j++) {
              if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) { // the identifier is always a decimal int
                inb2 = true;
                break;
              }
            }
            if (!inb2) {
              result.push(b1[i]);
            }
          }
        }
        // return an array, if both inputs were arrays
        if (Array.isArray(a1) && Array.isArray(a2)) {
          return generalize(result);
        }
        // return a matrix otherwise
        return new matrix(generalize(result));
      }
    });

    return setDifference;
  }

  var name$217 = 'setDifference';
  var factory_1$229 = factory$230;

  var setDifference$1 = {
  	name: name$217,
  	factory: factory_1$229
  };

  var flatten$6 = array.flatten;

  function factory$231 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var matrix = load(DenseMatrix);
    var size = load(size$5);
    var subset = load(subset$1);
    var compareNatural = load(compareNatural$1);
    
    /**
     * Collect the distinct elements of a multiset.
     * A multi-dimension array will be converted to a single-dimension array before the operation.
     *
     * Syntax:
     *
     *    math.setDistinct(set)
     *
     * Examples:
     *
     *    math.setDistinct([1, 1, 1, 2, 2, 3]);        // returns [1, 2, 3]
     *
     * See also:
     *
     *    setMultiplicity
     *
     * @param {Array | Matrix}    a  A multiset
     * @return {Array | Matrix}    A set containing the distinc elements of the multiset
     */
    var setDistinct = typed('setDistinct', {
      'Array | Matrix': function (a) {
        if (subset(size(a), new index(0)) === 0) { // if empty, return empty
          var result = [];
        }
        else {
          var b = flatten$6(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
          var result = [];
          result.push(b[0]);
          for (var i=1; i<b.length; i++) {
            if (compareNatural(b[i], b[i-1]) !== 0) {
              result.push(b[i]);
            }
          }
        }
        // return an array, if the input was an array
        if (Array.isArray(a)) {
          return result;
        }
        // return a matrix otherwise
        return new matrix(result);
      }
    });

    return setDistinct;
  }

  var name$218 = 'setDistinct';
  var factory_1$230 = factory$231;

  var setDistinct$1 = {
  	name: name$218,
  	factory: factory_1$230
  };

  var flatten$7 = array.flatten;
  var identify$1 = array.identify;
  var generalize$1 = array.generalize;

  function factory$232 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var matrix = load(DenseMatrix);
    var size = load(size$5);
    var subset = load(subset$1);
    var compareNatural = load(compareNatural$1);
    
    /**
     * Create the intersection of two (multi)sets.
     * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
     *
     * Syntax:
     *
     *    math.setIntersect(set1, set2)
     *
     * Examples:
     *
     *    math.setIntersect([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [3, 4]
     *    math.setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [3, 4]
     *
     * See also:
     *
     *    setUnion, setDifference
     *
     * @param {Array | Matrix}    a1  A (multi)set
     * @param {Array | Matrix}    a2  A (multi)set
     * @return {Array | Matrix}    The intersection of two (multi)sets
     */
    var setIntersect = typed('setIntersect', {
      'Array | Matrix, Array | Matrix': function (a1, a2) {
        if (subset(size(a1), new index(0)) === 0 || subset(size(a2), new index(0)) === 0) { // of any of them is empty, return empty
          var result = [];
        }
        else {
          var b1 = identify$1(flatten$7(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
          var b2 = identify$1(flatten$7(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
          var result = [];
          for (var i=0; i<b1.length; i++) {
            for (var j=0; j<b2.length; j++) {
                if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) { // the identifier is always a decimal int
                  result.push(b1[i]);
                  break;
                }
            }
          }
        }
        // return an array, if both inputs were arrays
        if (Array.isArray(a1) && Array.isArray(a2)) {
          return generalize$1(result);
        }
        // return a matrix otherwise
        return new matrix(generalize$1(result));
      }
    });

    return setIntersect;
  }

  var name$219 = 'setIntersect';
  var factory_1$231 = factory$232;

  var setIntersect$1 = {
  	name: name$219,
  	factory: factory_1$231
  };

  var flatten$8 = array.flatten;
  var identify$2 = array.identify;

  function factory$233 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var size = load(size$5);
    var subset = load(subset$1);
    var compareNatural = load(compareNatural$1);
    
    /**
     * Check whether a (multi)set is a subset of another (multi)set. (Every element of set1 is the element of set2.)
     * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
     *
     * Syntax:
     *
     *    math.setIsSubset(set1, set2)
     *
     * Examples:
     *
     *    math.setIsSubset([1, 2], [3, 4, 5, 6]);        // returns false
     *    math.setIsSubset([3, 4], [3, 4, 5, 6]);        // returns true
     *
     * See also:
     *
     *    setUnion, setIntersect, setDifference
     *
     * @param {Array | Matrix}    a1  A (multi)set
     * @param {Array | Matrix}    a2  A (multi)set
     * @return {boolean}            true | false
     */
    var setIsSubset = typed('setIsSubset', {
      'Array | Matrix, Array | Matrix': function (a1, a2) {
        if (subset(size(a1), new index(0)) === 0) { // empty is a subset of anything
          return true;
        }
        else if (subset(size(a2), new index(0)) === 0) { // anything is not a subset of empty
          return false;
        }
        var b1 = identify$2(flatten$8(Array.isArray(a1) ? a1 : a1.toArray()).sort(compareNatural));
        var b2 = identify$2(flatten$8(Array.isArray(a2) ? a2 : a2.toArray()).sort(compareNatural));
        var inb2;
        for (var i=0; i<b1.length; i++) {
          inb2 = false;
          for (var j=0; j<b2.length; j++) {
            if (compareNatural(b1[i].value, b2[j].value) === 0 && b1[i].identifier === b2[j].identifier) { // the identifier is always a decimal int
              inb2 = true;
              break;
            }
          }
          if (inb2 === false) {
            return false;
          }
        }
        return true;
      }
    });

    return setIsSubset;
  }

  var name$220 = 'setIsSubset';
  var factory_1$232 = factory$233;

  var setIsSubset$1 = {
  	name: name$220,
  	factory: factory_1$232
  };

  var flatten$9 = array.flatten;

  function factory$234 (type, config, load, typed) {
    var compareNatural = load(compareNatural$1);
    var index = load(MatrixIndex);
    var size = load(size$5);
    var subset = load(subset$1);
    
    /**
     * Count the multiplicity of an element in a multiset.
     * A multi-dimension array will be converted to a single-dimension array before the operation.
     *
     * Syntax:
     *
     *    math.setMultiplicity(element, set)
     *
     * Examples:
     *
     *    math.setMultiplicity(1, [1, 2, 2, 4]);    // returns 1
     *    math.setMultiplicity(2, [1, 2, 2, 4]);    // returns 2
     *
     * See also:
     *
     *    setDistinct, setSize
     *
     * @param {number | BigNumber | Fraction | Complex} e  An element in the multiset
     * @param {Array | Matrix}     a  A multiset
     * @return {number}            The number of how many times the multiset contains the element
     */
    var setMultiplicity = typed('setMultiplicity', {
      'number | BigNumber | Fraction | Complex, Array | Matrix': function (e, a) {
        if (subset(size(a), new index(0)) === 0) { // if empty, return 0
          return 0;
        }
        var b = flatten$9(Array.isArray(a) ? a : a.toArray());
        var count = 0;
        for (var i=0; i<b.length; i++) {
          if (compareNatural(b[i], e) === 0) {
            count++;
          }
        }
        return count;
      }
    });

    return setMultiplicity;
  }

  var name$221 = 'setMultiplicity';
  var factory_1$233 = factory$234;

  var setMultiplicity$1 = {
  	name: name$221,
  	factory: factory_1$233
  };

  var flatten$10 = array.flatten;

  function factory$235 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var size = load(size$5);
    var subset = load(subset$1);
    var compareNatural = load(compareNatural$1);
    
    /**
     * Create the powerset of a (multi)set. (The powerset contains very possible subsets of a (multi)set.)
     * A multi-dimension array will be converted to a single-dimension array before the operation.
     *
     * Syntax:
     *
     *    math.setPowerset(set)
     *
     * Examples:
     *
     *    math.setPowerset([1, 2, 3]);        // returns [[], [1], [2], [3], [1, 2], [1, 3], [2, 3], [1, 2, 3]]
     *
     * See also:
     *
     *    setCartesian
     *
     * @param {Array | Matrix}    a  A (multi)set
     * @return {Array}    The powerset of the (multi)set
     */
    var setPowerset = typed('setPowerset', {
      'Array | Matrix': function (a) {
        if (subset(size(a), new index(0)) === 0) { // if empty, return empty
          return [];
        }
        var b = flatten$10(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
        var result = [];
        var number = 0;
        while (number.toString(2).length <= b.length) {
          result.push(_subset(b, number.toString(2).split("").reverse()));
          number++;
        }
        // can not return a matrix, because of the different size of the subarrays
        return _sort(result);
      }
    });

    return setPowerset;
    
    // create subset
    function _subset(array$$1, bitarray) {
      var result = [];
      for (var i=0; i<bitarray.length; i++) {
        if (bitarray[i] === "1") {
          result.push(array$$1[i]);
        }
      }
      return result;
    }
    
    // sort subsests by length
    function _sort(array$$1) {
      var temp = [];
      for (var i=array$$1.length-1; i>0; i--) {
        for (var j=0; j<i; j++) {
          if (array$$1[j].length > array$$1[j+1].length) {
            temp = array$$1[j];
            array$$1[j] = array$$1[j+1];
            array$$1[j+1] = temp;
          }
        }
      }
      return array$$1;
    }
  }

  var name$222 = 'setPowerset';
  var factory_1$234 = factory$235;

  var setPowerset$1 = {
  	name: name$222,
  	factory: factory_1$234
  };

  var flatten$11 = array.flatten;

  function factory$236 (type, config, load, typed) {
    var compareNatural = load(compareNatural$1);
    
    /**
     * Count the number of elements of a (multi)set. When a second parameter is 'true', count only the unique values.
     * A multi-dimension array will be converted to a single-dimension array before the operation.
     *
     * Syntax:
     *
     *    math.setSize(set)
     *    math.setSize(set, unique)
     *
     * Examples:
     *
     *    math.setSize([1, 2, 2, 4]);          // returns 4
     *    math.setSize([1, 2, 2, 4], true);    // returns 3
     *
     * See also:
     *
     *    setUnion, setIntersect, setDifference
     *
     * @param {Array | Matrix}    a  A multiset
     * @return {number}            The number of elements of the (multi)set
     */
    var setSize = typed('setSize', {
      'Array | Matrix': function (a) {
        return Array.isArray(a) ? flatten$11(a).length : flatten$11(a.toArray()).length;
      },
      'Array | Matrix, boolean': function (a, unique) {
        if (unique === false || a.length === 0) {
          return Array.isArray(a) ? flatten$11(a).length : flatten$11(a.toArray()).length;
        }
        else {
          var b = flatten$11(Array.isArray(a) ? a : a.toArray()).sort(compareNatural);
          var count = 1;
          for (var i=1; i<b.length; i++) {
            if (compareNatural(b[i], b[i-1]) !== 0) {
              count++;
            }
          }
          return count;
        }
      }
    });

    return setSize;
  }

  var name$223 = 'setSize';
  var factory_1$235 = factory$236;

  var setSize$1 = {
  	name: name$223,
  	factory: factory_1$235
  };

  var flatten$12 = array.flatten;

  function factory$237 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var concat = load(concat$1);
    var size = load(size$5);
    var subset = load(subset$1);
    var setDifference = load(setDifference$1);
    
    /**
     * Create the symmetric difference of two (multi)sets.
     * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
     *
     * Syntax:
     *
     *    math.setSymDifference(set1, set2)
     *
     * Examples:
     *
     *    math.setSymDifference([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [1, 2, 5, 6]
     *    math.setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [1, 2, 5, 6]
     *
     * See also:
     *
     *    setUnion, setIntersect, setDifference
     *
     * @param {Array | Matrix}    a1  A (multi)set
     * @param {Array | Matrix}    a2  A (multi)set
     * @return {Array | Matrix}    The symmetric difference of two (multi)sets
     */
    var setSymDifference = typed('setSymDifference', {
      'Array | Matrix, Array | Matrix': function (a1, a2) {
        if (subset(size(a1), new index(0)) === 0) { // if any of them is empty, return the other one
          return flatten$12(a2);
        }
        else if (subset(size(a2), new index(0)) === 0) {
          return flatten$12(a1);
        }
        var b1 = flatten$12(a1);
        var b2 = flatten$12(a2);
        return concat(setDifference(b1, b2), setDifference(b2, b1));
      }
    });

    return setSymDifference;
  }

  var name$224 = 'setSymDifference';
  var factory_1$236 = factory$237;

  var setSymDifference$1 = {
  	name: name$224,
  	factory: factory_1$236
  };

  var flatten$13 = array.flatten;

  function factory$238 (type, config, load, typed) {
    var index = load(MatrixIndex);
    var concat = load(concat$1);
    var size = load(size$5);
    var subset = load(subset$1);
    var setIntersect = load(setIntersect$1);
    var setSymDifference = load(setSymDifference$1);
    
    /**
     * Create the union of two (multi)sets.
     * Multi-dimension arrays will be converted to single-dimension arrays before the operation.
     *
     * Syntax:
     *
     *    math.setUnion(set1, set2)
     *
     * Examples:
     *
     *    math.setUnion([1, 2, 3, 4], [3, 4, 5, 6]);            // returns [1, 2, 3, 4, 5, 6]
     *    math.setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]]);    // returns [1, 2, 3, 4, 5, 6]
     *
     * See also:
     *
     *    setIntersect, setDifference
     *
     * @param {Array | Matrix}    a1  A (multi)set
     * @param {Array | Matrix}    a2  A (multi)set
     * @return {Array | Matrix}    The union of two (multi)sets
     */
    var setUnion = typed('setUnion', {
      'Array | Matrix, Array | Matrix': function (a1, a2) {
        if (subset(size(a1), new index(0)) === 0) { // if any of them is empty, return the other one
          return flatten$13(a2);
        }
        else if (subset(size(a2), new index(0)) === 0) {
          return flatten$13(a1);
        }
        var b1 = flatten$13(a1);
        var b2 = flatten$13(a2);
        return concat(setSymDifference(b1, b2), setIntersect(b1, b2));
      }
    });

    return setUnion;
  }

  var name$225 = 'setUnion';
  var factory_1$237 = factory$238;

  var setUnion$1 = {
  	name: name$225,
  	factory: factory_1$237
  };

  var set = [
    setCartesian$1,
    setDifference$1,
    setDistinct$1,
    setIntersect$1,
    setIsSubset$1,
    setMultiplicity$1,
    setPowerset$1,
    setSize$1,
    setSymDifference$1,
    setUnion$1
  ];

  var sign$2 = number.sign;


  function factory$239 (type, config, load, typed) {
    /**
     * Compute the erf function of a value using a rational Chebyshev
     * approximations for different intervals of x.
     *
     * This is a translation of W. J. Cody's Fortran implementation from 1987
     * ( http://www.netlib.org/specfun/erf ). See the AMS publication
     * "Rational Chebyshev Approximations for the Error Function" by W. J. Cody
     * for an explanation of this process.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.erf(x)
     *
     * Examples:
     *
     *    math.erf(0.2);    // returns 0.22270258921047847
     *    math.erf(-0.5);   // returns -0.5204998778130465
     *    math.erf(4);      // returns 0.9999999845827421
     *
     * @param {number | Array | Matrix} x   A real number
     * @return {number | Array | Matrix}    The erf of `x`
     */
    var erf = typed('erf', {
      'number': function (x) {
        var y = Math.abs(x);

        if (y >= MAX_NUM) {
          return sign$2(x);
        }
        if (y <= THRESH) {
          return sign$2(x) * erf1(y);
        }
        if (y <= 4.0) {
          return sign$2(x) * (1 - erfc2(y));
        }
        return sign$2(x) * (1 - erfc3(y));
      },

      // TODO: Not sure if there's a way to guarantee some degree of accuracy here.
      //  Perhaps it would be best to set the precision of the number to that which
      //  is guaranteed by erf()
      'BigNumber': function (n) {
        return new type.BigNumber(erf(n.toNumber()));
      },

      'Array | Matrix': function (n) {
        return deepMap(n, erf);
      }

      // TODO: For complex numbers, use the approximation for the Faddeeva function
      //  from "More Efficient Computation of the Complex Error Function" (AMS)

    });

    /**
     * Approximates the error function erf() for x <= 0.46875 using this function:
     *               n
     * erf(x) = x * sum (p_j * x^(2j)) / (q_j * x^(2j))
     *              j=0
     */
    function erf1(y) {
      var ysq = y * y;
      var xnum = P[0][4]*ysq;
      var xden = ysq;
      var i;

      for (i = 0; i < 3; i += 1) {
        xnum = (xnum + P[0][i]) * ysq;
        xden = (xden + Q[0][i]) * ysq;
      }
      return y * (xnum + P[0][3]) / (xden + Q[0][3]);
    }

    /**
     * Approximates the complement of the error function erfc() for
     * 0.46875 <= x <= 4.0 using this function:
     *                       n
     * erfc(x) = e^(-x^2) * sum (p_j * x^j) / (q_j * x^j)
     *                      j=0
     */
    function erfc2(y) {
      var xnum = P[1][8] * y;
      var xden = y;
      var i;

      for (i = 0; i < 7; i += 1) {
        xnum = (xnum + P[1][i]) * y;
        xden = (xden + Q[1][i]) * y;
      }
      var result = (xnum + P[1][7]) / (xden + Q[1][7]);
      var ysq = parseInt(y * 16) / 16;
      var del = (y - ysq) * (y + ysq);
      return Math.exp(-ysq*ysq) * Math.exp(-del) * result;
    }

    /**
     * Approximates the complement of the error function erfc() for x > 4.0 using
     * this function:
     *
     * erfc(x) = (e^(-x^2) / x) * [ 1/sqrt(pi) +
     *               n
     *    1/(x^2) * sum (p_j * x^(-2j)) / (q_j * x^(-2j)) ]
     *              j=0
     */
    function erfc3(y) {
      var ysq = 1 / (y * y);
      var xnum = P[2][5] * ysq;
      var xden = ysq;
      var i;

      for (i = 0; i < 4; i += 1) {
        xnum = (xnum + P[2][i]) * ysq;
        xden = (xden + Q[2][i]) * ysq;
      }
      var result = ysq * (xnum + P[2][4]) / (xden + Q[2][4]);
      result = (SQRPI - result) / y;
      ysq = parseInt(y * 16) / 16;
      var del = (y - ysq) * (y + ysq);
      return Math.exp(-ysq*ysq) * Math.exp(-del) * result;
    }

    erf.toTex = {1: 'erf\\left(${args[0]}\\right)'};

    return erf;
  }

  /**
   * Upper bound for the first approximation interval, 0 <= x <= THRESH
   * @constant
   */
  var THRESH = 0.46875;

  /**
   * Constant used by W. J. Cody's Fortran77 implementation to denote sqrt(pi)
   * @constant
   */
  var SQRPI = 5.6418958354775628695e-1;

  /**
   * Coefficients for each term of the numerator sum (p_j) for each approximation
   * interval (see W. J. Cody's paper for more details)
   * @constant
   */
  var P = [[
    3.16112374387056560e00, 1.13864154151050156e02,
    3.77485237685302021e02, 3.20937758913846947e03,
    1.85777706184603153e-1
  ], [
    5.64188496988670089e-1, 8.88314979438837594e00,
    6.61191906371416295e01, 2.98635138197400131e02,
    8.81952221241769090e02, 1.71204761263407058e03,
    2.05107837782607147e03, 1.23033935479799725e03,
    2.15311535474403846e-8
  ], [
    3.05326634961232344e-1, 3.60344899949804439e-1,
    1.25781726111229246e-1, 1.60837851487422766e-2,
    6.58749161529837803e-4, 1.63153871373020978e-2
  ]];

  /**
   * Coefficients for each term of the denominator sum (q_j) for each approximation
   * interval (see W. J. Cody's paper for more details)
   * @constant
   */
  var Q = [[
    2.36012909523441209e01, 2.44024637934444173e02,
    1.28261652607737228e03, 2.84423683343917062e03
  ], [
    1.57449261107098347e01, 1.17693950891312499e02,
    5.37181101862009858e02, 1.62138957456669019e03,
    3.29079923573345963e03, 4.36261909014324716e03,
    3.43936767414372164e03, 1.23033935480374942e03
  ], [
    2.56852019228982242e00, 1.87295284992346047e00,
    5.27905102951428412e-1, 6.05183413124413191e-2,
    2.33520497626869185e-3
  ]];

  /**
   * Maximum/minimum safe numbers to input to erf() (in ES6+, this number is
   * Number.[MAX|MIN]_SAFE_INTEGER). erf() for all numbers beyond this limit will
   * return 1
   */
  var MAX_NUM = Math.pow(2, 53);


  var name$226 = 'erf';
  var factory_1$238 = factory$239;

  var erf$1 = {
  	name: name$226,
  	factory: factory_1$238
  };

  var special = [
    erf$1
  ];

  var flatten$14 = array.flatten;


  function factory$240 (type, config, load, typed) {
    var add = load(addScalar);
    var divide = load(divideScalar);
    var compare = load(compare$1);
    var partitionSelect = load(partitionSelect$1);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the median of a matrix or a list with values. The values are
     * sorted and the middle value is returned. In case of an even number of
     * values, the average of the two middle values is returned.
     * Supported types of values are: Number, BigNumber, Unit
     *
     * In case of a (multi dimensional) array or matrix, the median of all
     * elements will be calculated.
     *
     * Syntax:
     *
     *     math.median(a, b, c, ...)
     *     math.median(A)
     *
     * Examples:
     *
     *     math.median(5, 2, 7);        // returns 5
     *     math.median([3, -1, 5, 7]);  // returns 4
     *
     * See also:
     *
     *     mean, min, max, sum, prod, std, var, quantileSeq
     *
     * @param {... *} args  A single matrix or or multiple scalar values
     * @return {*} The median
     */
    var median = typed('median', {
      // median([a, b, c, d, ...])
      'Array | Matrix': _median,

      // median([a, b, c, d, ...], dim)
      'Array | Matrix, number | BigNumber': function (array$$1, dim) {
        // TODO: implement median(A, dim)
        throw new Error('median(A, dim) is not yet supported');
        //return reduce(arguments[0], arguments[1], ...);
      },

      // median(a, b, c, d, ...)
      '...': function (args) {
        if (containsCollections(args)) {
            throw new TypeError('Scalar values expected in function median');
        }

        return _median(args);
      }
    });


    /**
     * Recursively calculate the median of an n-dimensional array
     * @param {Array} array
     * @return {Number} median
     * @private
     */
    function _median(array$$1) {
      try {
        array$$1 = flatten$14(array$$1.valueOf());

        var num = array$$1.length;
        if (num == 0) {
          throw new Error('Cannot calculate median of an empty array');
        }

        if (num % 2 == 0) {
          // even: return the average of the two middle values
          var mid = num / 2 - 1;
          var right = partitionSelect(array$$1, mid + 1);

          // array now partitioned at mid + 1, take max of left part
          var left = array$$1[mid];
          for (var i = 0; i < mid; ++i) {
            if (compare(array$$1[i], left) > 0) {
              left = array$$1[i];
            }
          }

          return middle2(left, right);
        }
        else {
          // odd: return the middle value
          var m = partitionSelect(array$$1, (num - 1) / 2);

          return middle(m);
        }
      }
      catch (err) {
        throw improveErrorMessage$$1(err, 'median');
      }
    }

    // helper function to type check the middle value of the array
    var middle = typed({
      'number | BigNumber | Complex | Unit': function (value) {
        return value;
      }
    });

    // helper function to type check the two middle value of the array
    var middle2 = typed({
      'number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit': function (left, right) {
        return divide(add(left, right), 2);
      }
    });

    median.toTex = undefined; // use default template

    return median;
  }

  var name$227 = 'median';
  var factory_1$239 = factory$240;

  var median$1 = {
  	name: name$227,
  	factory: factory_1$239
  };

  var flatten$15 = array.flatten;

  function factory$241 (type, config, load, typed) {
    var abs      = load(abs$1);
    var map      = load(map$7);
    var median   = load(median$1);
    var subtract = load(subtract$1);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the median absolute deviation of a matrix or a list with values.
     * The median absolute deviation is defined as the median of the absolute
     * deviations from the median.
     *
     * Syntax:
     *
     *     math.mad(a, b, c, ...)
     *     math.mad(A)
     *
     * Examples:
     *
     *     math.mad(10, 20, 30);             // returns 10
     *     math.mad([1, 2, 3]);              // returns 1
     *     math.mad([[1, 2, 3], [4, 5, 6]]); // returns 1.5
     *
     * See also:
     *
     *     median, mean, std, abs
     *
     * @param {Array | Matrix} array
     *                        A single matrix or multiple scalar values.
     * @return {*} The median absolute deviation.
     */
    var mad = typed('mad', {
      // mad([a, b, c, d, ...])
      'Array | Matrix': _mad,

      // mad(a, b, c, d, ...)
      '...': function (args) {
        return _mad(args);
      }
    });

    mad.toTex = undefined; // use default template

    return mad;

    function _mad(array$$1) {
      array$$1 = flatten$15(array$$1.valueOf());

      if (array$$1.length === 0) {
        throw new Error('Cannot calculate median absolute deviation (mad) of an empty array');
      }

      try {
        var med = median(array$$1);
        return median(map(array$$1, function (value) {
          return abs(subtract(value, med));
        }));
      }
      catch (err) {
        if (err instanceof TypeError && err.message.indexOf('median') !== -1) {
          throw new TypeError(err.message.replace('median', 'mad'));
        }
        else {
          throw improveErrorMessage$$1(err, 'mad');
        }
      }
    }
  }

  var name$228 = 'mad';
  var factory_1$240 = factory$241;

  var mad$1 = {
  	name: name$228,
  	factory: factory_1$240
  };

  var flatten$16 = array.flatten;

  function factory$242 (type, config, load, typed) {

    /**
    * Computes the mode of a set of numbers or a list with values(numbers or characters).
    * If there are more than one modes, it returns a list of those values.
    *
    * Syntax:
    *
    *     math.mode(a, b, c, ...)
    *     math.mode(A)
    *
    * Examples:
    *
    *     math.mode(2, 1, 4, 3, 1);                            // returns [1]
    *     math.mode([1, 2.7, 3.2, 4, 2.7]);                    // returns [2.7]
    *     math.mode(1, 4, 6, 1, 6)                             // returns [1, 6]
    *     math.mode('a','a','b','c')                           // returns ["a"]
    *     math.mode(1, 1.5, 'abc')                             // returns [1, 1.5, "abc"]
    *
    * See also:
    *
    *     median,
    *     mean
    *
    * @param {... *} args  A single matrix
    * @return {*} The mode of all values
    */

    var mode = typed('mode', {
      'Array | Matrix' : _mode,
      
      '...': function (args) {
        return _mode(args);
      }
    });
    
    return mode;

    /**
     * Calculates the mode in an 1-dimensional array
     * @param {Array} values
     * @return {number} mode
     * @private
     */
    function _mode(values) {
      values = flatten$16(values.valueOf());
      var num = values.length;
      if (num == 0) {
        throw new Error('Cannot calculate mode of an empty array');
      }
      
      var count = {},
          mode = [],
          max = 0;
      for (var i in values) {
        if (!(values[i] in count)){
          count[values[i]] = 0;
        }
        count[values[i]]++;
        if (count[values[i]] == max){
          mode.push(values[i]);
        }
        else if (count[values[i]] > max) {
          max = count[values[i]];
          mode = [values[i]];
        }
      }
      return mode; 
    }}

  var name$229 = 'mode';
  var factory_1$241 = factory$242;

  var mode$1 = {
  	name: name$229,
  	factory: factory_1$241
  };

  function factory$243 (type, config, load, typed) {
    var multiply = load(multiplyScalar);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the product of a matrix or a list with values.
     * In case of a (multi dimensional) array or matrix, the sum of all
     * elements will be calculated.
     *
     * Syntax:
     *
     *     math.prod(a, b, c, ...)
     *     math.prod(A)
     *
     * Examples:
     *
     *     math.multiply(2, 3);           // returns 6
     *     math.prod(2, 3);               // returns 6
     *     math.prod(2, 3, 4);            // returns 24
     *     math.prod([2, 3, 4]);          // returns 24
     *     math.prod([[2, 5], [4, 3]]);   // returns 120
     *
     * See also:
     *
     *    mean, median, min, max, sum, std, var
     *
     * @param {... *} args  A single matrix or or multiple scalar values
     * @return {*} The product of all values
     */
    var prod = typed('prod', {
      // prod([a, b, c, d, ...])
      'Array | Matrix': _prod,

      // prod([a, b, c, d, ...], dim)
      'Array | Matrix, number | BigNumber': function (array, dim) {
        // TODO: implement prod(A, dim)
        throw new Error('prod(A, dim) is not yet supported');
        //return reduce(arguments[0], arguments[1], math.prod);
      },

      // prod(a, b, c, d, ...)
      '...': function (args) {
        return _prod(args);
      }
    });

    prod.toTex = undefined; // use default template

    return prod;

    /**
     * Recursively calculate the product of an n-dimensional array
     * @param {Array} array
     * @return {number} prod
     * @private
     */
    function _prod(array) {
      var prod = undefined;

      deepForEach(array, function (value) {
        try {
          prod = (prod === undefined) ? value : multiply(prod, value);
        }
        catch (err) {
          throw improveErrorMessage$$1(err, 'prod', value);
        }
      });

      if (prod === undefined) {
        throw new Error('Cannot calculate prod of an empty array');
      }

      return prod;
    }
  }

  var name$230 = 'prod';
  var factory_1$242 = factory$243;

  var prod$1 = {
  	name: name$230,
  	factory: factory_1$242
  };

  var isInteger$29 = number.isInteger;
  var isNumber$4 = number.isNumber;
  var flatten$17 = array.flatten;


  function factory$244 (type, config, load, typed) {
    var add$$1 = load(add);
    var multiply = load(multiply$1);
    var partitionSelect = load(partitionSelect$1);
    var compare = load(compare$1);

    /**
     * Compute the prob order quantile of a matrix or a list with values.
     * The sequence is sorted and the middle value is returned.
     * Supported types of sequence values are: Number, BigNumber, Unit
     * Supported types of probability are: Number, BigNumber
     *
     * In case of a (multi dimensional) array or matrix, the prob order quantile
     * of all elements will be calculated.
     *
     * Syntax:
     *
     *     math.quantileSeq(A, prob[, sorted])
     *     math.quantileSeq(A, [prob1, prob2, ...][, sorted])
     *     math.quantileSeq(A, N[, sorted])
     *
     * Examples:
     *
     *     math.quantileSeq([3, -1, 5, 7], 0.5);         // returns 4
     *     math.quantileSeq([3, -1, 5, 7], [1/3, 2/3]);  // returns [3, 5]
     *     math.quantileSeq([3, -1, 5, 7], 2);           // returns [3, 5]
     *     math.quantileSeq([-1, 3, 5, 7], 0.5, true);   // returns 4
     *
     * See also:
     *
     *     median, mean, min, max, sum, prod, std, var
     *
     * @param {Array, Matrix} data                A single matrix or Array
     * @param {Number, BigNumber, Array} probOrN  prob is the order of the quantile, while N is
     *                                            the amount of evenly distributed steps of
     *                                            probabilities; only one of these options can
     *                                            be provided
     * @param {Boolean} sorted=false              is data sorted in ascending order
     * @return {Number, BigNumber, Unit, Array}   Quantile(s)
     */
    function quantileSeq(data, probOrN, sorted) {
      var probArr, dataArr, one;

      if (arguments.length < 2 || arguments.length > 3) {
        throw new SyntaxError('Function quantileSeq requires two or three parameters');
      }

      if (isCollection(data)) {
        sorted = sorted || false;
        if (typeof sorted === 'boolean') {
          dataArr = data.valueOf();
          if (isNumber$4(probOrN)) {
            if (probOrN < 0) {
              throw new Error('N/prob must be non-negative');
            }

            if (probOrN <= 1) {
              // quantileSeq([a, b, c, d, ...], prob[,sorted])
              return _quantileSeq(dataArr, probOrN, sorted);
            }

            if (probOrN > 1) {
              // quantileSeq([a, b, c, d, ...], N[,sorted])
              if (!isInteger$29(probOrN)) {
                throw new Error('N must be a positive integer');
              }

              var nPlusOne = probOrN + 1;
              probArr = new Array(probOrN);
              for (var i = 0; i < probOrN;) {
                probArr[i] = _quantileSeq(dataArr, (++i) / nPlusOne, sorted);
              }
              return probArr;
            }
          }

          if (type.isBigNumber(probOrN)) {
            if (probOrN.isNegative()) {
              throw new Error('N/prob must be non-negative');
            }

            one = new probOrN.constructor(1);

            if (probOrN.lte(one)) {
              // quantileSeq([a, b, c, d, ...], prob[,sorted])
              return _quantileSeq(dataArr, probOrN, sorted);
            }

            if (probOrN.gt(one)) {
              // quantileSeq([a, b, c, d, ...], N[,sorted])
              if (!probOrN.isInteger()) {
                throw new Error('N must be a positive integer');
              }

              // largest possible Array length is 2^32-1;
              // 2^32 < 10^15, thus safe conversion guaranteed
              var intN = probOrN.toNumber();
              if (intN > 4294967295) {
                throw new Error('N must be less than or equal to 2^32-1, as that is the maximum length of an Array');
              }

              var nPlusOne = new type.BigNumber(intN + 1);
              probArr = new Array(intN);
              for (var i = 0; i < intN;) {
                probArr[i] = _quantileSeq(dataArr, new type.BigNumber(++i).div(nPlusOne), sorted);
              }
              return probArr;
            }
          }

          if (Array.isArray(probOrN)) {
            // quantileSeq([a, b, c, d, ...], [prob1, prob2, ...][,sorted])
            probArr = new Array(probOrN.length);
            for (var i = 0; i < probArr.length; ++i) {
              var currProb = probOrN[i];
              if (isNumber$4(currProb)) {
                if (currProb < 0 || currProb > 1) {
                  throw new Error('Probability must be between 0 and 1, inclusive');
                }
              } else if (type.isBigNumber(currProb)) {
                one = new currProb.constructor(1);
                if (currProb.isNegative() || currProb.gt(one)) {
                  throw new Error('Probability must be between 0 and 1, inclusive');
                }
              } else {
                throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
              }

              probArr[i] = _quantileSeq(dataArr, currProb, sorted);
            }
            return probArr;
          }

          throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
        }

        throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
      }

      throw new TypeError('Unexpected type of argument in function quantileSeq'); // FIXME: becomes redundant when converted to typed-function
    }

    /**
     * Calculate the prob order quantile of an n-dimensional array.
     * 
     * @param {Array} array
     * @param {Number, BigNumber} prob
     * @param {Boolean} sorted
     * @return {Number, BigNumber, Unit} prob order quantile
     * @private
     */
    function _quantileSeq(array$$1, prob, sorted) {
      var flat = flatten$17(array$$1);
      var len = flat.length;
      if (len === 0) {
        throw new Error('Cannot calculate quantile of an empty sequence');
      }

      if (isNumber$4(prob)) {
        var index = prob * (len-1);
        var fracPart = index % 1;
        if (fracPart === 0) {
          var value = sorted ? flat[index] : partitionSelect(flat, index);

          validate(value);

          return value;
        }

        var integerPart = Math.floor(index);

        var left, right;
        if (sorted) {
          left = flat[integerPart];
          right = flat[integerPart+1];
        } else {
          right = partitionSelect(flat, integerPart+1);

          // max of partition is kth largest
          left = flat[integerPart];
          for (var i = 0; i < integerPart; ++i) {
            if (compare(flat[i], left) > 0) {
              left = flat[i];
            }
          }
        }

        validate(left);
        validate(right);

        // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
        return add$$1(multiply(left, 1 - fracPart), multiply(right, fracPart));
      }

      // If prob is a BigNumber
      var index = prob.times(len-1);
      if (index.isInteger()) {
        index = index.toNumber();
        var value = sorted ? flat[index] : partitionSelect(flat, index);

        validate(value);

        return value;
      }

      var integerPart = index.floor();
      var fracPart = index.minus(integerPart);
      var integerPartNumber = integerPart.toNumber();

      var left, right;
      if (sorted) {
        left = flat[integerPartNumber];
        right = flat[integerPartNumber+1];
      } else {
        right = partitionSelect(flat, integerPartNumber+1);

        // max of partition is kth largest
        left = flat[integerPartNumber];
        for (var i = 0; i < integerPartNumber; ++i) {
          if (compare(flat[i], left) > 0) {
            left = flat[i];
          }
        }
      }

      validate(left);
      validate(right);

      // Q(prob) = (1-f)*A[floor(index)] + f*A[floor(index)+1]
      var one = new fracPart.constructor(1);
      return add$$1(multiply(left, one.minus(fracPart)), multiply(right, fracPart));
    }

    /**
     * Check if array value types are valid, throw error otherwise.
     * @param {number | BigNumber | Unit} x
     * @param {number | BigNumber | Unit} x
     * @private
     */
    var validate = typed({
      'number | BigNumber | Unit': function (x) {
        return x;
      }
    });

    return quantileSeq;
  }

  var name$231 = 'quantileSeq';
  var factory_1$243 = factory$244;

  var quantileSeq$1 = {
  	name: name$231,
  	factory: factory_1$243
  };

  var DEFAULT_NORMALIZATION = 'unbiased';



  function factory$245 (type, config, load, typed) {
    var add = load(addScalar);
    var subtract = load(subtract$1);
    var multiply = load(multiplyScalar);
    var divide = load(divideScalar);
    var improveErrorMessage$$1 = load(improveErrorMessage);

    /**
     * Compute the variance of a matrix or a  list with values.
     * In case of a (multi dimensional) array or matrix, the variance over all
     * elements will be calculated.
     *
     * Optionally, the type of normalization can be specified as second
     * parameter. The parameter `normalization` can be one of the following values:
     *
     * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
     * - 'uncorrected'        The sum of squared errors is divided by n
     * - 'biased'             The sum of squared errors is divided by (n + 1)
     *
     * Note that older browser may not like the variable name `var`. In that
     * case, the function can be called as `math['var'](...)` instead of
     * `math.var(...)`.
     *
     * Syntax:
     *
     *     math.var(a, b, c, ...)
     *     math.var(A)
     *     math.var(A, normalization)
     *
     * Examples:
     *
     *     math.var(2, 4, 6);                     // returns 4
     *     math.var([2, 4, 6, 8]);                // returns 6.666666666666667
     *     math.var([2, 4, 6, 8], 'uncorrected'); // returns 5
     *     math.var([2, 4, 6, 8], 'biased');      // returns 4
     *
     *     math.var([[1, 2, 3], [4, 5, 6]]);      // returns 3.5
     *
     * See also:
     *
     *    mean, median, max, min, prod, std, sum
     *
     * @param {Array | Matrix} array
     *                        A single matrix or or multiple scalar values
     * @param {string} [normalization='unbiased']
     *                        Determines how to normalize the variance.
     *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
     * @return {*} The variance
     */
    var variance = typed('variance', {
      // var([a, b, c, d, ...])
      'Array | Matrix': function (array) {
        return _var(array, DEFAULT_NORMALIZATION);
      },

      // var([a, b, c, d, ...], normalization)
      'Array | Matrix, string': _var,

      // var(a, b, c, d, ...)
      '...': function (args) {
        return _var(args, DEFAULT_NORMALIZATION);
      }
    });

    variance.toTex = '\\mathrm{Var}\\left(${args}\\right)';

    return variance;

    /**
     * Recursively calculate the variance of an n-dimensional array
     * @param {Array} array
     * @param {string} normalization
     *                        Determines how to normalize the variance:
     *                        - 'unbiased'    The sum of squared errors is divided by (n - 1)
     *                        - 'uncorrected' The sum of squared errors is divided by n
     *                        - 'biased'      The sum of squared errors is divided by (n + 1)
     * @return {number | BigNumber} variance
     * @private
     */
    function _var(array, normalization) {
      var sum = 0;
      var num = 0;

      if (array.length == 0) {
        throw new SyntaxError('Function var requires one or more parameters (0 provided)');
      }

      // calculate the mean and number of elements
      deepForEach(array, function (value) {
        try {
          sum = add(sum, value);
          num++;
        }
        catch (err) {
          throw improveErrorMessage$$1(err, 'var', value);
        }
      });
      if (num === 0) throw new Error('Cannot calculate var of an empty array');

      var mean = divide(sum, num);

      // calculate the variance
      sum = 0;
      deepForEach(array, function (value) {
        var diff = subtract(value, mean);
        sum = add(sum, multiply(diff, diff));
      });

      switch (normalization) {
        case 'uncorrected':
          return divide(sum, num);

        case 'biased':
          return divide(sum, num + 1);

        case 'unbiased':
          var zero = type.isBigNumber(sum) ? new type.BigNumber(0) : 0;
          return (num == 1) ? zero : divide(sum, num - 1);

        default:
          throw new Error('Unknown normalization "' + normalization + '". ' +
          'Choose "unbiased" (default), "uncorrected", or "biased".');
      }
    }
  }

  var name$232 = 'var';
  var factory_1$244 = factory$245;

  var _var$1 = {
  	name: name$232,
  	factory: factory_1$244
  };

  function factory$246 (type, config, load, typed) {
    var sqrt       = load(sqrt$1);
    var variance   = load(_var$1);

    /**
     * Compute the standard deviation of a matrix or a  list with values.
     * The standard deviations is defined as the square root of the variance:
     * `std(A) = sqrt(var(A))`.
     * In case of a (multi dimensional) array or matrix, the standard deviation
     * over all elements will be calculated.
     *
     * Optionally, the type of normalization can be specified as second
     * parameter. The parameter `normalization` can be one of the following values:
     *
     * - 'unbiased' (default) The sum of squared errors is divided by (n - 1)
     * - 'uncorrected'        The sum of squared errors is divided by n
     * - 'biased'             The sum of squared errors is divided by (n + 1)
     *
     * Syntax:
     *
     *     math.std(a, b, c, ...)
     *     math.std(A)
     *     math.std(A, normalization)
     *
     * Examples:
     *
     *     math.std(2, 4, 6);                     // returns 2
     *     math.std([2, 4, 6, 8]);                // returns 2.581988897471611
     *     math.std([2, 4, 6, 8], 'uncorrected'); // returns 2.23606797749979
     *     math.std([2, 4, 6, 8], 'biased');      // returns 2
     *
     *     math.std([[1, 2, 3], [4, 5, 6]]);      // returns 1.8708286933869707
     *
     * See also:
     *
     *    mean, median, max, min, prod, sum, var
     *
     * @param {Array | Matrix} array
     *                        A single matrix or or multiple scalar values
     * @param {string} [normalization='unbiased']
     *                        Determines how to normalize the variance.
     *                        Choose 'unbiased' (default), 'uncorrected', or 'biased'.
     * @return {*} The standard deviation
     */
    var std = typed('std', {
      // std([a, b, c, d, ...])
      'Array | Matrix': _std,

      // std([a, b, c, d, ...], normalization)
      'Array | Matrix, string': _std,

      // std(a, b, c, d, ...)
      '...': function (args) {
        return _std(args);
      }
    });
    
    std.toTex = undefined; // use default template

    return std;

    function _std(array, normalization) {
      if (array.length == 0) {
        throw new SyntaxError('Function std requires one or more parameters (0 provided)');
      }

      try {
        return sqrt(variance.apply(null, arguments));
      }
      catch (err) {
        if (err instanceof TypeError && err.message.indexOf(' var') !== -1) {
          throw new TypeError(err.message.replace(' var', ' std'));
        }
        else {
          throw err;
        }
      }
    }
  }

  var name$233 = 'std';
  var factory_1$245 = factory$246;

  var std$1 = {
  	name: name$233,
  	factory: factory_1$245
  };

  var statistics = [
    mad$1,
    max$1,
    mean$1,
    median$1,
    min$1,
    mode$1,
    prod$1,
    quantileSeq$1,
    std$1,
    sum$1,
    _var$1
  ];

  function factory$247 (type, config, load, typed) {
    /**
     * Format a value of any type into a string.
     *
     * Syntax:
     *
     *    math.format(value)
     *    math.format(value, options)
     *    math.format(value, precision)
     *    math.format(value, callback)
     *
     * Where:
     *
     *  - `value: *`
     *    The value to be formatted
     *  - `options: Object`
     *    An object with formatting options. Available options:
     *    - `notation: string`
     *      Number notation. Choose from:
     *      - 'fixed'
     *        Always use regular number notation.
     *        For example '123.40' and '14000000'
     *      - 'exponential'
     *        Always use exponential notation.
     *        For example '1.234e+2' and '1.4e+7'
     *      - 'engineering'
     *        Always use engineering notation.
     *        For example '123.4e+0' and '14.0e+6'
     *      - 'auto' (default)
     *        Regular number notation for numbers having an absolute value between
     *        `lower` and `upper` bounds, and uses exponential notation elsewhere.
     *        Lower bound is included, upper bound is excluded.
     *        For example '123.4' and '1.4e7'.
     *    - `precision: number`
     *      A number between 0 and 16 to round the digits of the number. In case
     *      of notations 'exponential' and 'auto', `precision` defines the total
     *      number of significant digits returned.
     *      In case of notation 'fixed', `precision` defines the number of
     *      significant digits after the decimal point.
     *      `precision` is undefined by default.
     *    - `lowerExp: number`
     *      Exponent determining the lower boundary for formatting a value with 
     *      an exponent when `notation='auto`. Default value is `-3`.
     *    - `upperExp: number` 
     *      Exponent determining the upper boundary for formatting a value with 
     *      an exponent when `notation='auto`. Default value is `5`.
     *    - `fraction: string`. Available values: 'ratio' (default) or 'decimal'.
     *      For example `format(fraction(1, 3))` will output '1/3' when 'ratio' is
     *      configured, and will output `0.(3)` when 'decimal' is configured.
     * - `callback: function`
     *   A custom formatting function, invoked for all numeric elements in `value`,
     *   for example all elements of a matrix, or the real and imaginary
     *   parts of a complex number. This callback can be used to override the
     *   built-in numeric notation with any type of formatting. Function `callback`
     *   is called with `value` as parameter and must return a string.
     *
     * When `value` is an Object:
     *
     * - When the object contains a property `format` being a function, this function
     *   is invoked as `value.format(options)` and the result is returned.
     * - When the object has its own `toString` method, this method is invoked
     *   and the result is returned.
     * - In other cases the function will loop over all object properties and
     *   return JSON object notation like '{"a": 2, "b": 3}'.
     *
     * When value is a function:
     *
     * - When the function has a property `syntax`, it returns this
     *   syntax description.
     * - In other cases, a string `'function'` is returned.
     *
     * Examples:
     *
     *    math.format(6.4);                                        // returns '6.4'
     *    math.format(1240000);                                    // returns '1.24e6'
     *    math.format(1/3);                                        // returns '0.3333333333333333'
     *    math.format(1/3, 3);                                     // returns '0.333'
     *    math.format(21385, 2);                                   // returns '21000'
     *    math.format(12e8, {notation: 'fixed'});                  // returns '1200000000'
     *    math.format(2.3,  {notation: 'fixed', precision: 4});    // returns '2.3000'
     *    math.format(52.8, {notation: 'exponential'});            // returns '5.28e+1'
     *    math.format(12400,{notation: 'engineering'});            // returns '12.400e+3'
     *    math.format(2000, {lowerExp: -2, upperExp: 2});          // returns '2e+3'
     *
     *    function formatCurrency(value) {
     *      // return currency notation with two digits:
     *      return '$' + value.toFixed(2);
     *
     *      // you could also use math.format inside the callback:
     *      // return '$' + math.format(value, {notation: 'fixed', precision: 2});
     *    }
     *    math.format([2.1, 3, 0.016], formatCurrency};            // returns '[$2.10, $3.00, $0.02]'
     *
     * See also:
     *
     *    print
     *
     * @param {*} value                               Value to be stringified
     * @param {Object | Function | number} [options]  Formatting options
     * @return {string} The formatted value
     */
    var format = typed('format', {
      'any': string.format,
      'any, Object | function | number': string.format
    });

    format.toTex = undefined; // use default template

    return format;
  }

  var name$234 = 'format';
  var factory_1$246 = factory$247;

  var format$8 = {
  	name: name$234,
  	factory: factory_1$246
  };

  var isString$5 = string.isString;
  var format$9 = string.format;

  function factory$248 (type, config, load, typed) {
    /**
     * Interpolate values into a string template.
     *
     * Syntax:
     *
     *     math.print(template, values)
     *     math.print(template, values, precision)
     *     math.print(template, values, options)
     *
     * Example usage:
     *
     *     // the following outputs: 'Lucy is 5 years old'
     *     math.print('Lucy is $age years old', {age: 5});
     *
     *     // the following outputs: 'The value of pi is 3.141592654'
     *     math.print('The value of pi is $pi', {pi: math.pi}, 10);
     *
     *     // the following outputs: 'hello Mary! The date is 2013-03-23'
     *     math.print('Hello $user.name! The date is $date', {
     *       user: {
     *         name: 'Mary',
     *       },
     *       date: new Date(2013, 2, 23).toISOString().substring(0, 10)
     *     });
     *
     *     // the following outputs: 'My favorite fruits are apples and bananas !'
     *     math.print('My favorite fruits are $0 and $1 !', [
     *       'apples',
     *       'bananas'
     *     ]);
     *
     * See also:
     *
     *     format
     *
     * @param {string} template       A string containing variable placeholders.
     * @param {Object | Array | Matrix} values An object or array containing variables
     *                                which will be filled in in the template.
     * @param {number | Object} [options]  Formatting options,
     *                                or the number of digits to format numbers.
     *                                See function math.format for a description
     *                                of all options.
     * @return {string} Interpolated string
     */
    var print = typed ('print', {
      // note: Matrix will be converted automatically to an Array
      'string, Object | Array': _print,
      'string, Object | Array, number | Object': _print
    });

    print.toTex = undefined; // use default template

    return print;
  }

  /**
   * Interpolate values into a string template.
   * @param {string} template
   * @param {Object} values
   * @param {number | Object} [options]
   * @returns {string} Interpolated string
   * @private
   */
  function _print(template, values, options) {
    return template.replace(/\$([\w\.]+)/g, function (original, key) {
          var keys = key.split('.');
          var value = values[keys.shift()];
          while (keys.length && value !== undefined) {
            var k = keys.shift();
            value = k ? value[k] : value + '.';
          }

          if (value !== undefined) {
            if (!isString$5(value)) {
              return format$9(value, options);
            }
            else {
              return value;
            }
          }

          return original;
        }
    );
  }

  var name$235 = 'print';
  var factory_1$247 = factory$248;

  var print = {
  	name: name$235,
  	factory: factory_1$247
  };

  var string$10 = [
    format$8,
    print
  ];

  function factory$249 (type, config, load, typed) {

    /**
     * Calculate the inverse cosine of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.acos(x)
     *
     * Examples:
     *
     *    math.acos(0.5);           // returns number 1.0471975511965979
     *    math.acos(math.cos(1.5)); // returns number 1.5
     *
     *    math.acos(2);             // returns Complex 0 + 1.3169578969248166 i
     *
     * See also:
     *
     *    cos, atan, asin
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} The arc cosine of x
     */
    var acos = typed('acos', {
      'number': function (x) {
        if ((x >= -1 && x <= 1) || config.predictable) {
          return Math.acos(x);
        }
        else {
          return new type.Complex(x, 0).acos();
        }
      },

      'Complex': function (x) {
        return x.acos();
      },

      'BigNumber': function (x) {
        return x.acos();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, acos);
      }
    });

    acos.toTex = {1: '\\cos^{-1}\\left(${args[0]}\\right)'};

    return acos;
  }

  var name$236 = 'acos';
  var factory_1$248 = factory$249;

  var acos$1 = {
  	name: name$236,
  	factory: factory_1$248
  };

  function factory$250 (type, config, load, typed) {

    /**
     * Calculate the hyperbolic arccos of a value,
     * defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.acosh(x)
     *
     * Examples:
     *
     *    math.acosh(1.5);       // returns 0.9624236501192069
     *
     * See also:
     *
     *    cosh, asinh, atanh
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic arccosine of x
     */
    var acosh = typed('acosh', {
      'number': function (x) {
        if (x >= 1 || config.predictable) {
          return _acosh(x);
        }
        if (x <= -1) {
          return new type.Complex(Math.log(Math.sqrt(x*x - 1) - x), Math.PI);
        }
        return new type.Complex(x, 0).acosh();
      },

      'Complex': function (x) {
        return x.acosh();
      },

      'BigNumber': function (x) {
        return x.acosh();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, acosh);
      }
    });

    acosh.toTex = {1: '\\cosh^{-1}\\left(${args[0]}\\right)'};

    return acosh;
  }

  /**
   * Calculate the hyperbolic arccos of a number
   * @param {number} x
   * @return {number}
   * @private
   */
  var _acosh = Math.acosh || function (x) {
    return Math.log(Math.sqrt(x*x - 1) + x)
  };

  var name$237 = 'acosh';
  var factory_1$249 = factory$250;

  var acosh$1 = {
  	name: name$237,
  	factory: factory_1$249
  };

  function factory$251 (type, config, load, typed) {

    /**
     * Calculate the inverse cotangent of a value, defined as `acot(x) = atan(1/x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.acot(x)
     *
     * Examples:
     *
     *    math.acot(0.5);           // returns number 0.4636476090008061
     *    math.acot(math.cot(1.5)); // returns number 1.5
     *
     *    math.acot(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
     *
     * See also:
     *
     *    cot, atan
     *
     * @param {number | Complex | Array | Matrix} x   Function input
     * @return {number | Complex | Array | Matrix} The arc cotangent of x
     */
    var acot = typed('acot', {
      'number': function (x) {
        return Math.atan(1 / x);
      },

      'Complex': function (x) {
        return x.acot();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x).atan();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, acot);
      }
    });

    acot.toTex = {1: '\\cot^{-1}\\left(${args[0]}\\right)'};

    return acot;
  }

  var name$238 = 'acot';
  var factory_1$250 = factory$251;

  var acot$1 = {
  	name: name$238,
  	factory: factory_1$250
  };

  function factory$252 (type, config, load, typed) {

    /**
     * Calculate the hyperbolic arccotangent of a value,
     * defined as `acoth(x) = atanh(1/x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.acoth(x)
     *
     * Examples:
     *
     *    math.acoth(0.5);       // returns 0.8047189562170503
     *
     * See also:
     *
     *    acsch, asech
     *
     * @param {number | Complex | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic arccotangent of x
     */
    var acoth = typed('acoth', {
      'number': function (x) {
        if (x >= 1 || x <= -1 || config.predictable) {
          return isFinite(x) ? (Math.log((x+1)/x) + Math.log(x/(x-1))) / 2 : 0;
        }
        return new type.Complex(x, 0).acoth();
      },

      'Complex': function (x) {
        return x.acoth();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x).atanh();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, acoth);
      }
    });

    acoth.toTex = {1: '\\coth^{-1}\\left(${args[0]}\\right)'};

    return acoth;
  }

  var name$239 = 'acoth';
  var factory_1$251 = factory$252;

  var acoth$1 = {
  	name: name$239,
  	factory: factory_1$251
  };

  function factory$253 (type, config, load, typed) {

    /**
     * Calculate the inverse cosecant of a value, defined as `acsc(x) = asin(1/x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.acsc(x)
     *
     * Examples:
     *
     *    math.acsc(0.5);           // returns number 0.5235987755982989
     *    math.acsc(math.csc(1.5)); // returns number ~1.5
     *
     *    math.acsc(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
     *
     * See also:
     *
     *    csc, asin, asec
     *
     * @param {number | Complex | Array | Matrix} x   Function input
     * @return {number | Complex | Array | Matrix} The arc cosecant of x
     */
    var acsc = typed('acsc', {
      'number': function (x) {
        if (x <= -1 || x >= 1 || config.predictable) {
          return Math.asin(1 / x);
        }
        return new type.Complex(x, 0).acsc();
      },

      'Complex': function (x) {
        return x.acsc();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x).asin();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, acsc);
      }
    });

    acsc.toTex = {1: '\\csc^{-1}\\left(${args[0]}\\right)'};

    return acsc;
  }

  var name$240 = 'acsc';
  var factory_1$252 = factory$253;

  var acsc$1 = {
  	name: name$240,
  	factory: factory_1$252
  };

  function factory$254 (type, config, load, typed) {

    /**
     * Calculate the hyperbolic arccosecant of a value,
     * defined as `acsch(x) = asinh(1/x) = ln(1/x + sqrt(1/x^2 + 1))`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.acsch(x)
     *
     * Examples:
     *
     *    math.acsch(0.5);       // returns 1.4436354751788103
     *
     * See also:
     *
     *    asech, acoth
     *
     * @param {number | Complex | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic arccosecant of x
     */
    var acsch = typed('acsch', {
      'number': function (x) {
        x = 1 / x;
        return Math.log(x + Math.sqrt(x*x + 1));
      },

      'Complex': function (x) {
        return x.acsch();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x).asinh();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, acsch);
      }
    });

    acsch.toTex = {1: '\\mathrm{csch}^{-1}\\left(${args[0]}\\right)'};

    return acsch;
  }

  var name$241 = 'acsch';
  var factory_1$253 = factory$254;

  var acsch$1 = {
  	name: name$241,
  	factory: factory_1$253
  };

  function factory$255 (type, config, load, typed) {

    /**
     * Calculate the inverse secant of a value. Defined as `asec(x) = acos(1/x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.asec(x)
     *
     * Examples:
     *
     *    math.asec(0.5);           // returns 1.0471975511965979
     *    math.asec(math.sec(1.5)); // returns 1.5
     *
     *    math.asec(2);             // returns 0 + 1.3169578969248166 i
     *
     * See also:
     *
     *    acos, acot, acsc
     *
     * @param {number | Complex | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} The arc secant of x
     */
    var asec = typed('asec', {
      'number': function (x) {
        if (x <= -1 || x >= 1 || config.predictable) {
          return Math.acos(1 / x);
        }
        return new type.Complex(x, 0).asec();
      },

      'Complex': function (x) {
        return x.asec();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x).acos();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, asec);
      }
    });

    asec.toTex = {1: '\\sec^{-1}\\left(${args[0]}\\right)'};

    return asec;
  }

  var name$242 = 'asec';
  var factory_1$254 = factory$255;

  var asec$1 = {
  	name: name$242,
  	factory: factory_1$254
  };

  function factory$256 (type, config, load, typed) {
    var acosh = typed.find(load(acosh$1), ['Complex']);

    /**
     * Calculate the hyperbolic arcsecant of a value,
     * defined as `asech(x) = acosh(1/x) = ln(sqrt(1/x^2 - 1) + 1/x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.asech(x)
     *
     * Examples:
     *
     *    math.asech(0.5);       // returns 1.3169578969248166
     *
     * See also:
     *
     *    acsch, acoth
     *
     * @param {number | Complex | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic arcsecant of x
     */
    var asech = typed('asech', {
      'number': function (x) {
        if ((x <= 1 && x >= -1) || config.predictable) {
          x = 1 / x;

          var ret = Math.sqrt(x*x - 1);
          if (x > 0 || config.predictable) {
            return Math.log(ret + x);
          }

          return new type.Complex(Math.log(ret - x), Math.PI);
        }

        return new type.Complex(x, 0).asech();
      },

      'Complex': function (x) {
        return x.asech()
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x).acosh();
      },

      'Array | Matrix': function (x) {
        return deepMap(x, asech);
      }
    });

    asech.toTex = {1: '\\mathrm{sech}^{-1}\\left(${args[0]}\\right)'};

    return asech;
  }

  var name$243 = 'asech';
  var factory_1$255 = factory$256;

  var asech$1 = {
  	name: name$243,
  	factory: factory_1$255
  };

  function factory$257 (type, config, load, typed) {

    /**
     * Calculate the inverse sine of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.asin(x)
     *
     * Examples:
     *
     *    math.asin(0.5);           // returns number 0.5235987755982989
     *    math.asin(math.sin(1.5)); // returns number ~1.5
     *
     *    math.asin(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
     *
     * See also:
     *
     *    sin, atan, acos
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
     * @return {number | BigNumber | Complex | Array | Matrix} The arc sine of x
     */
    var asin = typed('asin', {
      'number': function (x) {
        if ((x >= -1 && x <= 1) || config.predictable) {
          return Math.asin(x);
        }
        else {
          return new type.Complex(x, 0).asin();
        }
      },

      'Complex': function (x) {
        return x.asin();
      },

      'BigNumber': function (x) {
        return x.asin();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since asin(0) = 0
        return deepMap(x, asin, true);
      }
    });

    asin.toTex = {1: '\\sin^{-1}\\left(${args[0]}\\right)'};

    return asin;
  }

  var name$244 = 'asin';
  var factory_1$256 = factory$257;

  var asin$1 = {
  	name: name$244,
  	factory: factory_1$256
  };

  function factory$258 (type, config, load, typed) {

    /**
     * Calculate the hyperbolic arcsine of a value,
     * defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.asinh(x)
     *
     * Examples:
     *
     *    math.asinh(0.5);       // returns 0.48121182505960347
     *
     * See also:
     *
     *    acosh, atanh
     *
     * @param {number | Complex | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic arcsine of x
     */
    var asinh = typed('asinh', {
      'number': Math.asinh || function (x) {
        return Math.log(Math.sqrt(x*x + 1) + x);
      },

      'Complex': function (x) {
          return x.asinh();
      },

      'BigNumber': function (x) {
        return x.asinh();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since asinh(0) = 0
        return deepMap(x, asinh, true);
      }
    });

    asinh.toTex = {1: '\\sinh^{-1}\\left(${args[0]}\\right)'};

    return asinh;
  }

  var name$245 = 'asinh';
  var factory_1$257 = factory$258;

  var asinh$1 = {
  	name: name$245,
  	factory: factory_1$257
  };

  function factory$259 (type, config, load, typed) {

    /**
     * Calculate the inverse tangent of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.atan(x)
     *
     * Examples:
     *
     *    math.atan(0.5);           // returns number 0.4636476090008061
     *    math.atan(math.tan(1.5)); // returns number 1.5
     *
     *    math.atan(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
     *
     * See also:
     *
     *    tan, asin, acos
     *
     * @param {number | BigNumber | Complex | Array | Matrix} x   Function input
     * @return {number | BigNumber | Complex | Array | Matrix} The arc tangent of x
     */
    var atan = typed('atan', {
      'number': function (x) {
        return Math.atan(x);
      },

      'Complex': function (x) {
        return x.atan();
      },

      'BigNumber': function (x) {
        return x.atan();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since atan(0) = 0
        return deepMap(x, atan, true);
      }
    });

    atan.toTex = {1: '\\tan^{-1}\\left(${args[0]}\\right)'};

    return atan;
  }

  var name$246 = 'atan';
  var factory_1$258 = factory$259;

  var atan$1 = {
  	name: name$246,
  	factory: factory_1$258
  };

  function factory$260 (type, config, load, typed) {

    var matrix$$1 = load(matrix);

    var algorithm02$$1 = load(algorithm02);
    var algorithm03$$1 = load(algorithm03);
    var algorithm09$$1 = load(algorithm09);
    var algorithm11$$1 = load(algorithm11);
    var algorithm12$$1 = load(algorithm12);
    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Calculate the inverse tangent function with two arguments, y/x.
     * By providing two arguments, the right quadrant of the computed angle can be
     * determined.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.atan2(y, x)
     *
     * Examples:
     *
     *    math.atan2(2, 2) / math.pi;       // returns number 0.25
     *
     *    var angle = math.unit(60, 'deg'); // returns Unit 60 deg
     *    var x = math.cos(angle);
     *    var y = math.sin(angle);
     *
     *    math.atan(2);             // returns Complex 1.5707963267948966 -1.3169578969248166 i
     *
     * See also:
     *
     *    tan, atan, sin, cos
     *
     * @param {number | Array | Matrix} y  Second dimension
     * @param {number | Array | Matrix} x  First dimension
     * @return {number | Array | Matrix} Four-quadrant inverse tangent
     */
    var atan2 = typed('atan2', {

      'number, number': Math.atan2,

      // Complex numbers doesn't seem to have a reasonable implementation of
      // atan2(). Even Matlab removed the support, after they only calculated
      // the atan only on base of the real part of the numbers and ignored the imaginary.

      'BigNumber, BigNumber': function (y, x) {
        return type.BigNumber.atan2(y, x);
      },

      'SparseMatrix, SparseMatrix': function (x, y) {
        return algorithm09$$1(x, y, atan2, false);
      },

      'SparseMatrix, DenseMatrix': function (x, y) {
        // mind the order of y and x!
        return algorithm02$$1(y, x, atan2, true);
      },

      'DenseMatrix, SparseMatrix': function (x, y) {
        return algorithm03$$1(x, y, atan2, false);
      },

      'DenseMatrix, DenseMatrix': function (x, y) {
        return algorithm13$$1(x, y, atan2);
      },

      'Array, Array': function (x, y) {
        return atan2(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        return atan2(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        return atan2(x, matrix$$1(y));
      },

      'SparseMatrix, number | BigNumber': function (x, y) {
        return algorithm11$$1(x, y, atan2, false);
      },

      'DenseMatrix, number | BigNumber': function (x, y) {
        return algorithm14$$1(x, y, atan2, false);
      },

      'number | BigNumber, SparseMatrix': function (x, y) {
        // mind the order of y and x
        return algorithm12$$1(y, x, atan2, true);
      },

      'number | BigNumber, DenseMatrix': function (x, y) {
        // mind the order of y and x
        return algorithm14$$1(y, x, atan2, true);
      },

      'Array, number | BigNumber': function (x, y) {
        return algorithm14$$1(matrix$$1(x), y, atan2, false).valueOf();
      },

      'number | BigNumber, Array': function (x, y) {
        return algorithm14$$1(matrix$$1(y), x, atan2, true).valueOf();
      }
    });

    atan2.toTex = {2: '\\mathrm{atan2}\\left(${args}\\right)'};

    return atan2;
  }

  var name$247 = 'atan2';
  var factory_1$259 = factory$260;

  var atan2$1 = {
  	name: name$247,
  	factory: factory_1$259
  };

  function factory$261 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic arctangent of a value,
     * defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.atanh(x)
     *
     * Examples:
     *
     *    math.atanh(0.5);       // returns 0.5493061443340549
     *
     * See also:
     *
     *    acosh, asinh
     *
     * @param {number | Complex | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic arctangent of x
     */
    var atanh = typed('atanh', {
      'number': function (x) {
        if ((x <= 1 && x >= -1) || config.predictable) {
          return _atanh(x);
        }
        return new type.Complex(x, 0).atanh();
      },

      'Complex': function (x) {
        return x.atanh();
      },

      'BigNumber': function (x) {
        return x.atanh();
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since atanh(0) = 0
        return deepMap(x, atanh, true);
      }
    });

    atanh.toTex = {1: '\\tanh^{-1}\\left(${args[0]}\\right)'};

    return atanh;
  }

  /**
   * Calculate the hyperbolic arctangent of a number
   * @param {number} x
   * @return {number}
   * @private
   */
  var _atanh = Math.atanh || function (x) {
    return Math.log((1 + x)/(1 - x)) / 2
  };

  var name$248 = 'atanh';
  var factory_1$260 = factory$261;

  var atanh$1 = {
  	name: name$248,
  	factory: factory_1$260
  };

  function factory$262 (type, config, load, typed) {

    /**
     * Calculate the cosine of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.cos(x)
     *
     * Examples:
     *
     *    math.cos(2);                      // returns number -0.4161468365471422
     *    math.cos(math.pi / 4);            // returns number  0.7071067811865475
     *    math.cos(math.unit(180, 'deg'));  // returns number -1
     *    math.cos(math.unit(60, 'deg'));   // returns number  0.5
     *
     *    var angle = 0.2;
     *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2); // returns number ~1
     *
     * See also:
     *
     *    cos, tan
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} Cosine of x
     */
    var cos = typed('cos', {
      'number': Math.cos,

      'Complex': function (x) {
        return x.cos();
      },

      'BigNumber': function (x) {
        return x.cos();
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function cos is no angle');
        }
        return cos(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, cos);
      }
    });

    cos.toTex = {1: '\\cos\\left(${args[0]}\\right)'};

    return cos;
  }

  var name$249 = 'cos';
  var factory_1$261 = factory$262;

  var cos$1 = {
  	name: name$249,
  	factory: factory_1$261
  };

  function factory$263 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic cosine of a value,
     * defined as `cosh(x) = 1/2 * (exp(x) + exp(-x))`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.cosh(x)
     *
     * Examples:
     *
     *    math.cosh(0.5);       // returns number 1.1276259652063807
     *
     * See also:
     *
     *    sinh, tanh
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic cosine of x
     */
    var cosh = typed('cosh', {
      'number': _cosh,

      'Complex': function (x) {
        return x.cosh();
      },

      'BigNumber': function (x) {
        return x.cosh();
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function cosh is no angle');
        }
        return cosh(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, cosh);
      }
    });

    cosh.toTex = {1: '\\cosh\\left(${args[0]}\\right)'};

    return cosh;
  }

  /**
   * Calculate the hyperbolic cosine of a number
   * @param {number} x
   * @returns {number}
   * @private
   */
  var _cosh = Math.cosh || function (x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
  };

  var name$250 = 'cosh';
  var factory_1$262 = factory$263;

  var cosh$1 = {
  	name: name$250,
  	factory: factory_1$262
  };

  function factory$264 (type, config, load, typed) {
    /**
     * Calculate the cotangent of a value. Defined as `cot(x) = 1 / tan(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.cot(x)
     *
     * Examples:
     *
     *    math.cot(2);      // returns number -0.45765755436028577
     *    1 / math.tan(2);  // returns number -0.45765755436028577
     *
     * See also:
     *
     *    tan, sec, csc
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Cotangent of x
     */
    var cot = typed('cot', {
      'number': function (x) {
        return 1 / Math.tan(x);
      },

      'Complex': function (x) {
        return x.cot();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x.tan());
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function cot is no angle');
        }
        return cot(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, cot);
      }
    });

    cot.toTex = {1: '\\cot\\left(${args[0]}\\right)'};

    return cot;
  }

  var name$251 = 'cot';
  var factory_1$263 = factory$264;

  var cot$1 = {
  	name: name$251,
  	factory: factory_1$263
  };

  function factory$265 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic cotangent of a value,
     * defined as `coth(x) = 1 / tanh(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.coth(x)
     *
     * Examples:
     *
     *    // coth(x) = 1 / tanh(x)
     *    math.coth(2);         // returns 1.0373147207275482
     *    1 / math.tanh(2);     // returns 1.0373147207275482
     *
     * See also:
     *
     *    sinh, tanh, cosh
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic cotangent of x
     */
    var coth = typed('coth', {
      'number': _coth,

      'Complex': function (x) {
        return x.coth();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x.tanh());
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function coth is no angle');
        }
        return coth(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, coth);
      }
    });

    coth.toTex = {1: '\\coth\\left(${args[0]}\\right)'};

    return coth;
  }

  /**
   * Calculate the hyperbolic cosine of a number
   * @param {number} x
   * @returns {number}
   * @private
   */
  function _coth(x) {
    var e = Math.exp(2 * x);
    return (e + 1) / (e - 1);
  }

  var name$252 = 'coth';
  var factory_1$264 = factory$265;

  var coth$1 = {
  	name: name$252,
  	factory: factory_1$264
  };

  function factory$266 (type, config, load, typed) {
    /**
     * Calculate the cosecant of a value, defined as `csc(x) = 1/sin(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.csc(x)
     *
     * Examples:
     *
     *    math.csc(2);      // returns number 1.099750170294617
     *    1 / math.sin(2);  // returns number 1.099750170294617
     *
     * See also:
     *
     *    sin, sec, cot
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Cosecant of x
     */
    var csc = typed('csc', {
      'number': function (x) {
        return 1 / Math.sin(x);
      },

      'Complex': function (x) {
        return x.csc();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x.sin());
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function csc is no angle');
        }
        return csc(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, csc);
      }
    });

    csc.toTex = {1: '\\csc\\left(${args[0]}\\right)'};

    return csc;
  }

  var name$253 = 'csc';
  var factory_1$265 = factory$266;

  var csc$1 = {
  	name: name$253,
  	factory: factory_1$265
  };

  var sign$3 = number.sign;

  function factory$267 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic cosecant of a value,
     * defined as `csch(x) = 1 / sinh(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.csch(x)
     *
     * Examples:
     *
     *    // csch(x) = 1/ sinh(x)
     *    math.csch(0.5);       // returns 1.9190347513349437
     *    1 / math.sinh(0.5);   // returns 1.9190347513349437
     *
     * See also:
     *
     *    sinh, sech, coth
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic cosecant of x
     */
    var csch = typed('csch', {
      'number': _csch,

      'Complex': function (x) {
        return x.csch();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x.sinh());
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function csch is no angle');
        }
        return csch(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, csch);
      }
    });

    csch.toTex = {1: '\\mathrm{csch}\\left(${args[0]}\\right)'};

    return csch;
  }

  /**
   * Calculate the hyperbolic cosecant of a number
   * @param {number} x
   * @returns {number}
   * @private
   */
  function _csch(x) {
    // consider values close to zero (+/-)
    if (x == 0) {
      return Number.POSITIVE_INFINITY;
    }
    else {
      return Math.abs(2 / (Math.exp(x) - Math.exp(-x))) * sign$3(x);
    }
  }

  var name$254 = 'csch';
  var factory_1$266 = factory$267;

  var csch$1 = {
  	name: name$254,
  	factory: factory_1$266
  };

  function factory$268 (type, config, load, typed) {
    /**
     * Calculate the secant of a value, defined as `sec(x) = 1/cos(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.sec(x)
     *
     * Examples:
     *
     *    math.sec(2);      // returns number -2.4029979617223822
     *    1 / math.cos(2);  // returns number -2.4029979617223822
     *
     * See also:
     *
     *    cos, csc, cot
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Secant of x
     */
    var sec = typed('sec', {
      'number': function (x) {
        return 1 / Math.cos(x);
      },

      'Complex': function (x) {
        return x.sec();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x.cos());
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function sec is no angle');
        }
        return sec(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, sec);
      }
    });

    sec.toTex = {1: '\\sec\\left(${args[0]}\\right)'};

    return sec;
  }

  var name$255 = 'sec';
  var factory_1$267 = factory$268;

  var sec$1 = {
  	name: name$255,
  	factory: factory_1$267
  };

  function factory$269 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic secant of a value,
     * defined as `sech(x) = 1 / cosh(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.sech(x)
     *
     * Examples:
     *
     *    // sech(x) = 1/ cosh(x)
     *    math.sech(0.5);       // returns 0.886818883970074
     *    1 / math.cosh(0.5);   // returns 0.886818883970074
     *
     * See also:
     *
     *    cosh, csch, coth
     *
     * @param {number | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | Complex | Array | Matrix} Hyperbolic secant of x
     */
    var sech = typed('sech', {
      'number': _sech,

      'Complex': function (x) {
        return x.sech();
      },

      'BigNumber': function (x) {
        return new type.BigNumber(1).div(x.cosh());
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function sech is no angle');
        }
        return sech(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, sech);
      }
    });

    sech.toTex = {1: '\\mathrm{sech}\\left(${args[0]}\\right)'};

    return sech;
  }

  /**
   * Calculate the hyperbolic secant of a number
   * @param {number} x
   * @returns {number}
   * @private
   */
  function _sech(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
  }

  var name$256 = 'sech';
  var factory_1$268 = factory$269;

  var sech$1 = {
  	name: name$256,
  	factory: factory_1$268
  };

  function factory$270 (type, config, load, typed) {

    /**
     * Calculate the sine of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.sin(x)
     *
     * Examples:
     *
     *    math.sin(2);                      // returns number 0.9092974268256813
     *    math.sin(math.pi / 4);            // returns number 0.7071067811865475
     *    math.sin(math.unit(90, 'deg'));   // returns number 1
     *    math.sin(math.unit(30, 'deg'));   // returns number 0.5
     *
     *    var angle = 0.2;
     *    math.pow(math.sin(angle), 2) + math.pow(math.cos(angle), 2); // returns number ~1
     *
     * See also:
     *
     *    cos, tan
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} Sine of x
     */
    var sin = typed('sin', {
      'number': Math.sin,

      'Complex': function (x) {
        return x.sin();
      },

      'BigNumber': function (x) {
        return x.sin();
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function sin is no angle');
        }
        return sin(x.value);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since sin(0) = 0
        return deepMap(x, sin, true);
      }
    });

    sin.toTex = {1: '\\sin\\left(${args[0]}\\right)'};

    return sin;
  }

  var name$257 = 'sin';
  var factory_1$269 = factory$270;

  var sin$1 = {
  	name: name$257,
  	factory: factory_1$269
  };

  function factory$271 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic sine of a value,
     * defined as `sinh(x) = 1/2 * (exp(x) - exp(-x))`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.sinh(x)
     *
     * Examples:
     *
     *    math.sinh(0.5);       // returns number 0.5210953054937474
     *
     * See also:
     *
     *    cosh, tanh
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic sine of x
     */
    var sinh = typed('sinh', {
      'number': _sinh,

      'Complex': function (x) {
        return x.sinh();
      },

      'BigNumber': function (x) {
        return x.sinh();
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function sinh is no angle');
        }
        return sinh(x.value);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since sinh(0) = 0
        return deepMap(x, sinh, true);
      }
    });

    sinh.toTex = {1: '\\sinh\\left(${args[0]}\\right)'};

    return sinh;
  }

  /**
   * Calculate the hyperbolic sine of a number
   * @param {number} x
   * @returns {number}
   * @private
   */
  var _sinh = Math.sinh || function (x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
  };

  var name$258 = 'sinh';
  var factory_1$270 = factory$271;

  var sinh$1 = {
  	name: name$258,
  	factory: factory_1$270
  };

  function factory$272 (type, config, load, typed) {
    /**
     * Calculate the tangent of a value. `tan(x)` is equal to `sin(x) / cos(x)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.tan(x)
     *
     * Examples:
     *
     *    math.tan(0.5);                    // returns number 0.5463024898437905
     *    math.sin(0.5) / math.cos(0.5);    // returns number 0.5463024898437905
     *    math.tan(math.pi / 4);            // returns number 1
     *    math.tan(math.unit(45, 'deg'));   // returns number 1
     *
     * See also:
     *
     *    atan, sin, cos
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} Tangent of x
     */
    var tan = typed('tan', {
      'number': Math.tan,

      'Complex': function (x) {
          return x.tan();
      },

      'BigNumber': function (x) {
        return x.tan();
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function tan is no angle');
        }
        return tan(x.value);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since tan(0) = 0
        return deepMap(x, tan, true);
      }
    });

    tan.toTex = {1: '\\tan\\left(${args[0]}\\right)'};

    return tan;
  }

  var name$259 = 'tan';
  var factory_1$271 = factory$272;

  var tan$1 = {
  	name: name$259,
  	factory: factory_1$271
  };

  function factory$273 (type, config, load, typed) {
    /**
     * Calculate the hyperbolic tangent of a value,
     * defined as `tanh(x) = (exp(2 * x) - 1) / (exp(2 * x) + 1)`.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.tanh(x)
     *
     * Examples:
     *
     *    // tanh(x) = sinh(x) / cosh(x) = 1 / coth(x)
     *    math.tanh(0.5);                   // returns 0.46211715726000974
     *    math.sinh(0.5) / math.cosh(0.5);  // returns 0.46211715726000974
     *    1 / math.coth(0.5);               // returns 0.46211715726000974
     *
     * See also:
     *
     *    sinh, cosh, coth
     *
     * @param {number | BigNumber | Complex | Unit | Array | Matrix} x  Function input
     * @return {number | BigNumber | Complex | Array | Matrix} Hyperbolic tangent of x
     */
    var tanh = typed('tanh', {
      'number': _tanh,

      'Complex': function (x) {
          return x.tanh();
      },

      'BigNumber': function (x) {
        return x.tanh();
      },

      'Unit': function (x) {
        if (!x.hasBase(type.Unit.BASE_UNITS.ANGLE)) {
          throw new TypeError ('Unit in function tanh is no angle');
        }
        return tanh(x.value);
      },

      'Array | Matrix': function (x) {
        // deep map collection, skip zeros since tanh(0) = 0
        return deepMap(x, tanh, true);
      }
    });

    tanh.toTex = {1: '\\tanh\\left(${args[0]}\\right)'};

    return tanh;
  }

  /**
   * Calculate the hyperbolic tangent of a number
   * @param {number} x
   * @returns {number}
   * @private
   */
  var _tanh = Math.tanh || function (x) {
    var e = Math.exp(2 * x);
    return (e - 1) / (e + 1);
  };

  var name$260 = 'tanh';
  var factory_1$272 = factory$273;

  var tanh$1 = {
  	name: name$260,
  	factory: factory_1$272
  };

  var trigonometry = [
    acos$1,
    acosh$1,
    acot$1,
    acoth$1,
    acsc$1,
    acsch$1,
    asec$1,
    asech$1,
    asin$1,
    asinh$1,
    atan$1,
    atan2$1,
    atanh$1,
    cos$1,
    cosh$1,
    cot$1,
    coth$1,
    csc$1,
    csch$1,
    sec$1,
    sech$1,
    sin$1,
    sinh$1,
    tan$1,
    tanh$1
  ];

  function factory$274 (type, config, load, typed) {
    var latex$$1 = latex;

    var matrix$$1 = load(matrix);

    var algorithm13$$1 = load(algorithm13);
    var algorithm14$$1 = load(algorithm14);

    /**
     * Change the unit of a value.
     *
     * For matrices, the function is evaluated element wise.
     *
     * Syntax:
     *
     *    math.to(x, unit)
     *
     * Examples:
     *
     *    math.to(math.unit('2 inch'), 'cm');                   // returns Unit 5.08 cm
     *    math.to(math.unit('2 inch'), math.unit(null, 'cm'));  // returns Unit 5.08 cm
     *    math.to(math.unit(16, 'bytes'), 'bits');              // returns Unit 128 bits
     *
     * See also:
     *
     *    unit
     *
     * @param {Unit | Array | Matrix} x     The unit to be converted.
     * @param {Unit | Array | Matrix} unit  New unit. Can be a string like "cm"
     *                                      or a unit without value.
     * @return {Unit | Array | Matrix} value with changed, fixed unit.
     */
    var to = typed('to', {

      'Unit, Unit | string': function (x, unit) {
        return x.to(unit);
      },

      'Matrix, Matrix': function (x, y) {
        // SparseMatrix does not support Units
        return algorithm13$$1(x, y, to);
      },

      'Array, Array': function (x, y) {
        // use matrix implementation
        return to(matrix$$1(x), matrix$$1(y)).valueOf();
      },

      'Array, Matrix': function (x, y) {
        // use matrix implementation
        return to(matrix$$1(x), y);
      },

      'Matrix, Array': function (x, y) {
        // use matrix implementation
        return to(x, matrix$$1(y));
      },

      'Matrix, any': function (x, y) {
        // SparseMatrix does not support Units
        return algorithm14$$1(x, y, to, false);
      },

      'any, Matrix': function (x, y) {
        // SparseMatrix does not support Units
        return algorithm14$$1(y, x, to, true);
      },

      'Array, any': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(x), y, to, false).valueOf();
      },

      'any, Array': function (x, y) {
        // use matrix implementation
        return algorithm14$$1(matrix$$1(y), x, to, true).valueOf();
      }
    });

    to.toTex = {
      2: '\\left(${args[0]}' + latex$$1.operators['to'] + '${args[1]}\\right)'
    };

    return to;
  }

  var name$261 = 'to';
  var factory_1$273 = factory$274;

  var to$1 = {
  	name: name$261,
  	factory: factory_1$273
  };

  var unit$1 = [
    to$1
  ];

  function factory$275 (type, config, load, typed) {
    /**
     * Test whether a value is prime: has no divisors other than itself and one.
     * The function supports type `number`, `bignumber`.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isPrime(x)
     *
     * Examples:
     *
     *    math.isPrime(3);                     // returns true
     *    math.isPrime(-2);                    // returns false
     *    math.isPrime(0);                     // returns false
     *    math.isPrime(-0);                    // returns false
     *    math.isPrime(0.5);                   // returns false
     *    math.isPrime('2');                   // returns true
     *    math.isPrime([2, 17, 100]);           // returns [true, true, false]
     *
     * See also:
     *
     *    isNumeric, isZero, isNegative, isInteger
     *
     * @param {number | BigNumber | Array | Matrix} x  Value to be tested
     * @return {boolean}  Returns true when `x` is larger than zero.
     *                    Throws an error in case of an unknown data type.
     */
    var isPrime = typed('isPrime', {
      'number': function (x) {
        if (x < 2){
          return false;
        }
        if (x == 2){
          return true;
        }
        if (x % 2 == 0){ 
          return false;
        }
        for (var i = 3; i * i <= x; i += 2){
          if (x % i == 0){
            return false;
          }
        }
        return true;
      },

      'BigNumber': function (x) {
        if (x.lt(2)){
          return false;
        }
        if (x.equals(2)){
          return true;
        }
        if (x.mod(2).isZero()){
          return false;
        }
        for(var i = type.BigNumber(3); i.times(i).lte(x); i = i.plus(1)){
          if (x.mod(i).isZero()){
            return false;
          }
        }
        return true;
      },

      'Array | Matrix': function (x) {
        return deepMap(x, isPrime);
      }
    });

    return isPrime;
  }

  var name$262 = 'isPrime';
  var factory_1$274 = factory$275;

  var isPrime$1 = {
  	name: name$262,
  	factory: factory_1$274
  };

  function factory$276 (type, config, load, typed) {
    /**
     * Test whether a value is NaN (not a number).
     * The function supports types `number`, `BigNumber`, `Fraction`, `Unit` and `Complex`.
     *
     * The function is evaluated element-wise in case of Array or Matrix input.
     *
     * Syntax:
     *
     *     math.isNaN(x)
     *
     * Examples:
     *
     *    math.isNaN(3);                     // returns false
     *    math.isNaN(NaN);                   // returns true
     *    math.isNaN(0);                     // returns false
     *    math.isNaN(math.bignumber(NaN));   // returns true
     *    math.isNaN(math.bignumber(0));     // returns false
     *    math.isNaN(math.fraction(-2, 5));  // returns false
     *    math.isNaN('-2');                  // returns false
     *    math.isNaN([2, 0, -3, NaN]');      // returns [false, false, false, true]
     *
     * See also:
     *
     *    isNumeric, isNegative, isPositive, isZero, isInteger
     *
     * @param {number | BigNumber | Fraction | Unit | Array | Matrix} x  Value to be tested
     * @return {boolean}  Returns true when `x` is NaN.
     *                    Throws an error in case of an unknown data type.
     */
    var isNaN = typed('isNaN', {
      'number': function (x) {
        return Number.isNaN(x);
      },

      'BigNumber': function (x) {
        return x.isNaN();
      },

      'Fraction': function (x) {
        return false;
      },

      'Complex': function (x) {
        return x.isNaN();
      },

      'Unit': function (x) {
        return Number.isNaN(x.value);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, Number.isNaN);
      }
    });

    return isNaN;
  }

  var name$263 = 'isNaN';
  var factory_1$275 = factory$276;

  var _isNaN$1 = {
  	name: name$263,
  	factory: factory_1$275
  };

  var utils$1 = [
    clone$5,
    isInteger$22,
    isNegative$1,
    isNumeric$1,
    isPositive$1,
    isPrime$1,
    isZero$1,
    _isNaN$1,
    _typeof$1
  ];

  var _function$3 = [
    algebra,
    arithmetic,
    bitwise$1,
    combinatorics,
    complex$5,
    geometry,
    logical,
    matrix$3,
    probability,
    relational,
    set,
    special,
    statistics,
    string$10,
    trigonometry,
    unit$1,
    utils$1
  ];

  function factory$277 (type, config, load, typed, math) {
    /**
     * Instantiate mathjs data types from their JSON representation
     * @param {string} key
     * @param {*} value
     * @returns {*} Returns the revived object
     */
    return function reviver(key, value) {
      var constructor = type[value && value.mathjs] ||
          (math.expression && math.expression.node[value && value.mathjs]);
      // TODO: instead of checking math.expression.node, expose all Node classes on math.type too

      if (constructor && typeof constructor.fromJSON === 'function') {
        return constructor.fromJSON(value);
      }

      return value;
    }
  }

  var name$264 = 'reviver';
  var path$64 = 'json';
  var factory_1$276 = factory$277;
  var math$18 = true; // request the math namespace as fifth argument

  var reviver = {
  	name: name$264,
  	path: path$64,
  	factory: factory_1$276,
  	math: math$18
  };

  var json = [
    reviver
  ];

  var error = [
    {
      name: 'ArgumentsError', path: 'error',
      factory: function () {
        return ArgumentsError_1;
      }
    },
    {
      name: 'DimensionError',
      path: 'error',
      factory: function () {
        return DimensionError_1;
      }
    },
    {
      name: 'IndexError',
      path: 'error',
      factory: function () {
        return IndexError_1;
      }
    }
  ];

  // import customized constants file

  var lib = [
    type,        // data types (Matrix, Complex, Unit, ...)
    constants$1,   // constants
    expression,  // expression parsing
    _function$3,    // functions
    json,        // serialization utility (math.json.reviver)
    error        // errors
  ];

  var numeric1_2_6 = createCommonjsModule(function (module, exports) {

  var numeric = exports;
  if(typeof commonjsGlobal !== "undefined") { commonjsGlobal.numeric = numeric; }

  numeric.version = "1.2.6";

  // 1. Utility functions
  numeric.bench = function bench (f,interval) {
      var t1,t2,n,i;
      if(typeof interval === "undefined") { interval = 15; }
      n = 0.5;
      t1 = new Date();
      while(1) {
          n*=2;
          for(i=n;i>3;i-=4) { f(); f(); f(); f(); }
          while(i>0) { f(); i--; }
          t2 = new Date();
          if(t2-t1 > interval) break;
      }
      for(i=n;i>3;i-=4) { f(); f(); f(); f(); }
      while(i>0) { f(); i--; }
      t2 = new Date();
      return 1000*(3*n-1)/(t2-t1);
  };

  numeric._myIndexOf = (function _myIndexOf(w) {
      var n = this.length,k;
      for(k=0;k<n;++k) if(this[k]===w) return k;
      return -1;
  });
  numeric.myIndexOf = (Array.prototype.indexOf)?Array.prototype.indexOf:numeric._myIndexOf;

  numeric.Function = Function;
  numeric.precision = 4;
  numeric.largeArray = 50;

  numeric.prettyPrint = function prettyPrint(x) {
      function fmtnum(x) {
          if(x === 0) { return '0'; }
          if(isNaN(x)) { return 'NaN'; }
          if(x<0) { return '-'+fmtnum(-x); }
          if(isFinite(x)) {
              var scale = Math.floor(Math.log(x) / Math.log(10));
              var normalized = x / Math.pow(10,scale);
              var basic = normalized.toPrecision(numeric.precision);
              if(parseFloat(basic) === 10) { scale++; normalized = 1; basic = normalized.toPrecision(numeric.precision); }
              return parseFloat(basic).toString()+'e'+scale.toString();
          }
          return 'Infinity';
      }
      var ret = [];
      function foo(x) {
          var k;
          if(typeof x === "undefined") { ret.push(Array(numeric.precision+8).join(' ')); return false; }
          if(typeof x === "string") { ret.push('"'+x+'"'); return false; }
          if(typeof x === "boolean") { ret.push(x.toString()); return false; }
          if(typeof x === "number") {
              var a = fmtnum(x);
              var b = x.toPrecision(numeric.precision);
              var c = parseFloat(x.toString()).toString();
              var d = [a,b,c,parseFloat(b).toString(),parseFloat(c).toString()];
              for(k=1;k<d.length;k++) { if(d[k].length < a.length) a = d[k]; }
              ret.push(Array(numeric.precision+8-a.length).join(' ')+a);
              return false;
          }
          if(x === null) { ret.push("null"); return false; }
          if(typeof x === "function") { 
              ret.push(x.toString());
              var flag = false;
              for(k in x) { if(x.hasOwnProperty(k)) { 
                  if(flag) ret.push(',\n');
                  else ret.push('\n{');
                  flag = true; 
                  ret.push(k); 
                  ret.push(': \n'); 
                  foo(x[k]); 
              } }
              if(flag) ret.push('}\n');
              return true;
          }
          if(x instanceof Array) {
              if(x.length > numeric.largeArray) { ret.push('...Large Array...'); return true; }
              var flag = false;
              ret.push('[');
              for(k=0;k<x.length;k++) { if(k>0) { ret.push(','); if(flag) ret.push('\n '); } flag = foo(x[k]); }
              ret.push(']');
              return true;
          }
          ret.push('{');
          var flag = false;
          for(k in x) { if(x.hasOwnProperty(k)) { if(flag) ret.push(',\n'); flag = true; ret.push(k); ret.push(': \n'); foo(x[k]); } }
          ret.push('}');
          return true;
      }
      foo(x);
      return ret.join('');
  };

  numeric.parseDate = function parseDate(d) {
      function foo(d) {
          if(typeof d === 'string') { return Date.parse(d.replace(/-/g,'/')); }
          if(!(d instanceof Array)) { throw new Error("parseDate: parameter must be arrays of strings"); }
          var ret = [],k;
          for(k=0;k<d.length;k++) { ret[k] = foo(d[k]); }
          return ret;
      }
      return foo(d);
  };

  numeric.parseFloat = function parseFloat_(d) {
      function foo(d) {
          if(typeof d === 'string') { return parseFloat(d); }
          if(!(d instanceof Array)) { throw new Error("parseFloat: parameter must be arrays of strings"); }
          var ret = [],k;
          for(k=0;k<d.length;k++) { ret[k] = foo(d[k]); }
          return ret;
      }
      return foo(d);
  };

  numeric.parseCSV = function parseCSV(t) {
      var foo = t.split('\n');
      var j,k;
      var ret = [];
      var pat = /(([^'",]*)|('[^']*')|("[^"]*")),/g;
      var patnum = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/;
      var stripper = function(n) { return n.substr(0,n.length-1); };
      var count = 0;
      for(k=0;k<foo.length;k++) {
        var bar = (foo[k]+",").match(pat),baz;
        if(bar.length>0) {
            ret[count] = [];
            for(j=0;j<bar.length;j++) {
                baz = stripper(bar[j]);
                if(patnum.test(baz)) { ret[count][j] = parseFloat(baz); }
                else ret[count][j] = baz;
            }
            count++;
        }
      }
      return ret;
  };

  numeric.toCSV = function toCSV(A) {
      var s = numeric.dim(A);
      var i,j,m,n,row,ret;
      m = s[0];
      n = s[1];
      ret = [];
      for(i=0;i<m;i++) {
          row = [];
          for(j=0;j<m;j++) { row[j] = A[i][j].toString(); }
          ret[i] = row.join(', ');
      }
      return ret.join('\n')+'\n';
  };

  numeric.getURL = function getURL(url) {
      var client = new XMLHttpRequest();
      client.open("GET",url,false);
      client.send();
      return client;
  };

  numeric.imageURL = function imageURL(img) {
      function base64(A) {
          var n = A.length, i,x,y,z,p,q,r,s;
          var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          var ret = "";
          for(i=0;i<n;i+=3) {
              x = A[i];
              y = A[i+1];
              z = A[i+2];
              p = x >> 2;
              q = ((x & 3) << 4) + (y >> 4);
              r = ((y & 15) << 2) + (z >> 6);
              s = z & 63;
              if(i+1>=n) { r = s = 64; }
              else if(i+2>=n) { s = 64; }
              ret += key.charAt(p) + key.charAt(q) + key.charAt(r) + key.charAt(s);
              }
          return ret;
      }
      function crc32Array (a,from,to) {
          if(typeof from === "undefined") { from = 0; }
          if(typeof to === "undefined") { to = a.length; }
          var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
                       0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 
                       0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
                       0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 
                       0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 
                       0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 
                       0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
                       0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
                       0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
                       0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 
                       0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 
                       0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 
                       0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 
                       0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 
                       0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 
                       0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 
                       0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 
                       0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 
                       0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 
                       0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 
                       0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 
                       0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 
                       0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 
                       0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 
                       0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 
                       0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 
                       0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 
                       0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 
                       0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 
                       0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 
                       0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 
                       0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];
       
          var crc = -1, y = 0, n = a.length,i;

          for (i = from; i < to; i++) {
              y = (crc ^ a[i]) & 0xFF;
              crc = (crc >>> 8) ^ table[y];
          }
       
          return crc ^ (-1);
      }

      var h = img[0].length, w = img[0][0].length, s1, s2, k,length,a,b,i,j,adler32,crc32;
      var stream = [
                    137, 80, 78, 71, 13, 10, 26, 10,                           //  0: PNG signature
                    0,0,0,13,                                                  //  8: IHDR Chunk length
                    73, 72, 68, 82,                                            // 12: "IHDR" 
                    (w >> 24) & 255, (w >> 16) & 255, (w >> 8) & 255, w&255,   // 16: Width
                    (h >> 24) & 255, (h >> 16) & 255, (h >> 8) & 255, h&255,   // 20: Height
                    8,                                                         // 24: bit depth
                    2,                                                         // 25: RGB
                    0,                                                         // 26: deflate
                    0,                                                         // 27: no filter
                    0,                                                         // 28: no interlace
                    -1,-2,-3,-4,                                               // 29: CRC
                    -5,-6,-7,-8,                                               // 33: IDAT Chunk length
                    73, 68, 65, 84,                                            // 37: "IDAT"
                    // RFC 1950 header starts here
                    8,                                                         // 41: RFC1950 CMF
                    29                                                         // 42: RFC1950 FLG
                    ];
      crc32 = crc32Array(stream,12,29);
      stream[29] = (crc32>>24)&255;
      stream[30] = (crc32>>16)&255;
      stream[31] = (crc32>>8)&255;
      stream[32] = (crc32)&255;
      s1 = 1;
      s2 = 0;
      for(i=0;i<h;i++) {
          if(i<h-1) { stream.push(0); }
          else { stream.push(1); }
          a = (3*w+1+(i===0))&255; b = ((3*w+1+(i===0))>>8)&255;
          stream.push(a); stream.push(b);
          stream.push((~a)&255); stream.push((~b)&255);
          if(i===0) stream.push(0);
          for(j=0;j<w;j++) {
              for(k=0;k<3;k++) {
                  a = img[k][i][j];
                  if(a>255) a = 255;
                  else if(a<0) a=0;
                  else a = Math.round(a);
                  s1 = (s1 + a )%65521;
                  s2 = (s2 + s1)%65521;
                  stream.push(a);
              }
          }
          stream.push(0);
      }
      adler32 = (s2<<16)+s1;
      stream.push((adler32>>24)&255);
      stream.push((adler32>>16)&255);
      stream.push((adler32>>8)&255);
      stream.push((adler32)&255);
      length = stream.length - 41;
      stream[33] = (length>>24)&255;
      stream[34] = (length>>16)&255;
      stream[35] = (length>>8)&255;
      stream[36] = (length)&255;
      crc32 = crc32Array(stream,37);
      stream.push((crc32>>24)&255);
      stream.push((crc32>>16)&255);
      stream.push((crc32>>8)&255);
      stream.push((crc32)&255);
      stream.push(0);
      stream.push(0);
      stream.push(0);
      stream.push(0);
  //    a = stream.length;
      stream.push(73);  // I
      stream.push(69);  // E
      stream.push(78);  // N
      stream.push(68);  // D
      stream.push(174); // CRC1
      stream.push(66);  // CRC2
      stream.push(96);  // CRC3
      stream.push(130); // CRC4
      return 'data:image/png;base64,'+base64(stream);
  };

  // 2. Linear algebra with Arrays.
  numeric._dim = function _dim(x) {
      var ret = [];
      while(typeof x === "object") { ret.push(x.length); x = x[0]; }
      return ret;
  };

  numeric.dim = function dim(x) {
      var y,z;
      if(typeof x === "object") {
          y = x[0];
          if(typeof y === "object") {
              z = y[0];
              if(typeof z === "object") {
                  return numeric._dim(x);
              }
              return [x.length,y.length];
          }
          return [x.length];
      }
      return [];
  };

  numeric.mapreduce = function mapreduce(body,init) {
      return Function('x','accum','_s','_k',
              'if(typeof accum === "undefined") accum = '+init+';\n'+
              'if(typeof x === "number") { var xi = x; '+body+'; return accum; }\n'+
              'if(typeof _s === "undefined") _s = numeric.dim(x);\n'+
              'if(typeof _k === "undefined") _k = 0;\n'+
              'var _n = _s[_k];\n'+
              'var i,xi;\n'+
              'if(_k < _s.length-1) {\n'+
              '    for(i=_n-1;i>=0;i--) {\n'+
              '        accum = arguments.callee(x[i],accum,_s,_k+1);\n'+
              '    }'+
              '    return accum;\n'+
              '}\n'+
              'for(i=_n-1;i>=1;i-=2) { \n'+
              '    xi = x[i];\n'+
              '    '+body+';\n'+
              '    xi = x[i-1];\n'+
              '    '+body+';\n'+
              '}\n'+
              'if(i === 0) {\n'+
              '    xi = x[i];\n'+
              '    '+body+'\n'+
              '}\n'+
              'return accum;'
              );
  };
  numeric.mapreduce2 = function mapreduce2(body,setup) {
      return Function('x',
              'var n = x.length;\n'+
              'var i,xi;\n'+setup+';\n'+
              'for(i=n-1;i!==-1;--i) { \n'+
              '    xi = x[i];\n'+
              '    '+body+';\n'+
              '}\n'+
              'return accum;'
              );
  };


  numeric.same = function same(x,y) {
      var i,n;
      if(!(x instanceof Array) || !(y instanceof Array)) { return false; }
      n = x.length;
      if(n !== y.length) { return false; }
      for(i=0;i<n;i++) {
          if(x[i] === y[i]) { continue; }
          if(typeof x[i] === "object") { if(!same(x[i],y[i])) return false; }
          else { return false; }
      }
      return true;
  };

  numeric.rep = function rep(s,v,k) {
      if(typeof k === "undefined") { k=0; }
      var n = s[k], ret = Array(n), i;
      if(k === s.length-1) {
          for(i=n-2;i>=0;i-=2) { ret[i+1] = v; ret[i] = v; }
          if(i===-1) { ret[0] = v; }
          return ret;
      }
      for(i=n-1;i>=0;i--) { ret[i] = numeric.rep(s,v,k+1); }
      return ret;
  };


  numeric.dotMMsmall = function dotMMsmall(x,y) {
      var i,j,k,p,q,r,ret,foo,bar,woo,i0;
      p = x.length; q = y.length; r = y[0].length;
      ret = Array(p);
      for(i=p-1;i>=0;i--) {
          foo = Array(r);
          bar = x[i];
          for(k=r-1;k>=0;k--) {
              woo = bar[q-1]*y[q-1][k];
              for(j=q-2;j>=1;j-=2) {
                  i0 = j-1;
                  woo += bar[j]*y[j][k] + bar[i0]*y[i0][k];
              }
              if(j===0) { woo += bar[0]*y[0][k]; }
              foo[k] = woo;
          }
          ret[i] = foo;
      }
      return ret;
  };
  numeric._getCol = function _getCol(A,j,x) {
      var n = A.length, i;
      for(i=n-1;i>0;--i) {
          x[i] = A[i][j];
          --i;
          x[i] = A[i][j];
      }
      if(i===0) x[0] = A[0][j];
  };
  numeric.dotMMbig = function dotMMbig(x,y){
      var gc = numeric._getCol, p = y.length, v = Array(p);
      var m = x.length, n = y[0].length, A = new Array(m), xj;
      var VV = numeric.dotVV;
      var i,j;
      --p;
      --m;
      for(i=m;i!==-1;--i) A[i] = Array(n);
      --n;
      for(i=n;i!==-1;--i) {
          gc(y,i,v);
          for(j=m;j!==-1;--j) {
              xj = x[j];
              A[j][i] = VV(xj,v);
          }
      }
      return A;
  };

  numeric.dotMV = function dotMV(x,y) {
      var p = x.length, q = y.length,i;
      var ret = Array(p), dotVV = numeric.dotVV;
      for(i=p-1;i>=0;i--) { ret[i] = dotVV(x[i],y); }
      return ret;
  };

  numeric.dotVM = function dotVM(x,y) {
      var j,k,p,q,ret,woo,i0;
      p = x.length; q = y[0].length;
      ret = Array(q);
      for(k=q-1;k>=0;k--) {
          woo = x[p-1]*y[p-1][k];
          for(j=p-2;j>=1;j-=2) {
              i0 = j-1;
              woo += x[j]*y[j][k] + x[i0]*y[i0][k];
          }
          if(j===0) { woo += x[0]*y[0][k]; }
          ret[k] = woo;
      }
      return ret;
  };

  numeric.dotVV = function dotVV(x,y) {
      var i,n=x.length,i1,ret = x[n-1]*y[n-1];
      for(i=n-2;i>=1;i-=2) {
          i1 = i-1;
          ret += x[i]*y[i] + x[i1]*y[i1];
      }
      if(i===0) { ret += x[0]*y[0]; }
      return ret;
  };

  numeric.dot = function dot(x,y) {
      var d = numeric.dim;
      switch(d(x).length*1000+d(y).length) {
      case 2002:
          if(y.length < 10) return numeric.dotMMsmall(x,y);
          else return numeric.dotMMbig(x,y);
      case 2001: return numeric.dotMV(x,y);
      case 1002: return numeric.dotVM(x,y);
      case 1001: return numeric.dotVV(x,y);
      case 1000: return numeric.mulVS(x,y);
      case 1: return numeric.mulSV(x,y);
      case 0: return x*y;
      default: throw new Error('numeric.dot only works on vectors and matrices');
      }
  };

  numeric.diag = function diag(d) {
      var i,i1,j,n = d.length, A = Array(n), Ai;
      for(i=n-1;i>=0;i--) {
          Ai = Array(n);
          i1 = i+2;
          for(j=n-1;j>=i1;j-=2) {
              Ai[j] = 0;
              Ai[j-1] = 0;
          }
          if(j>i) { Ai[j] = 0; }
          Ai[i] = d[i];
          for(j=i-1;j>=1;j-=2) {
              Ai[j] = 0;
              Ai[j-1] = 0;
          }
          if(j===0) { Ai[0] = 0; }
          A[i] = Ai;
      }
      return A;
  };
  numeric.getDiag = function(A) {
      var n = Math.min(A.length,A[0].length),i,ret = Array(n);
      for(i=n-1;i>=1;--i) {
          ret[i] = A[i][i];
          --i;
          ret[i] = A[i][i];
      }
      if(i===0) {
          ret[0] = A[0][0];
      }
      return ret;
  };

  numeric.identity = function identity(n) { return numeric.diag(numeric.rep([n],1)); };
  numeric.pointwise = function pointwise(params,body,setup) {
      if(typeof setup === "undefined") { setup = ""; }
      var fun = [];
      var k;
      var avec = /\[i\]$/,p,thevec = '';
      var haveret = false;
      for(k=0;k<params.length;k++) {
          if(avec.test(params[k])) {
              p = params[k].substring(0,params[k].length-3);
              thevec = p;
          } else { p = params[k]; }
          if(p==='ret') haveret = true;
          fun.push(p);
      }
      fun[params.length] = '_s';
      fun[params.length+1] = '_k';
      fun[params.length+2] = (
              'if(typeof _s === "undefined") _s = numeric.dim('+thevec+');\n'+
              'if(typeof _k === "undefined") _k = 0;\n'+
              'var _n = _s[_k];\n'+
              'var i'+(haveret?'':', ret = Array(_n)')+';\n'+
              'if(_k < _s.length-1) {\n'+
              '    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee('+params.join(',')+',_s,_k+1);\n'+
              '    return ret;\n'+
              '}\n'+
              setup+'\n'+
              'for(i=_n-1;i!==-1;--i) {\n'+
              '    '+body+'\n'+
              '}\n'+
              'return ret;'
              );
      return Function.apply(null,fun);
  };
  numeric.pointwise2 = function pointwise2(params,body,setup) {
      if(typeof setup === "undefined") { setup = ""; }
      var fun = [];
      var k;
      var avec = /\[i\]$/,p,thevec = '';
      var haveret = false;
      for(k=0;k<params.length;k++) {
          if(avec.test(params[k])) {
              p = params[k].substring(0,params[k].length-3);
              thevec = p;
          } else { p = params[k]; }
          if(p==='ret') haveret = true;
          fun.push(p);
      }
      fun[params.length] = (
              'var _n = '+thevec+'.length;\n'+
              'var i'+(haveret?'':', ret = Array(_n)')+';\n'+
              setup+'\n'+
              'for(i=_n-1;i!==-1;--i) {\n'+
              body+'\n'+
              '}\n'+
              'return ret;'
              );
      return Function.apply(null,fun);
  };
  numeric._biforeach = (function _biforeach(x,y,s,k,f) {
      if(k === s.length-1) { f(x,y); return; }
      var i,n=s[k];
      for(i=n-1;i>=0;i--) { _biforeach(typeof x==="object"?x[i]:x,typeof y==="object"?y[i]:y,s,k+1,f); }
  });
  numeric._biforeach2 = (function _biforeach2(x,y,s,k,f) {
      if(k === s.length-1) { return f(x,y); }
      var i,n=s[k],ret = Array(n);
      for(i=n-1;i>=0;--i) { ret[i] = _biforeach2(typeof x==="object"?x[i]:x,typeof y==="object"?y[i]:y,s,k+1,f); }
      return ret;
  });
  numeric._foreach = (function _foreach(x,s,k,f) {
      if(k === s.length-1) { f(x); return; }
      var i,n=s[k];
      for(i=n-1;i>=0;i--) { _foreach(x[i],s,k+1,f); }
  });
  numeric._foreach2 = (function _foreach2(x,s,k,f) {
      if(k === s.length-1) { return f(x); }
      var i,n=s[k], ret = Array(n);
      for(i=n-1;i>=0;i--) { ret[i] = _foreach2(x[i],s,k+1,f); }
      return ret;
  });

  /*numeric.anyV = numeric.mapreduce('if(xi) return true;','false');
  numeric.allV = numeric.mapreduce('if(!xi) return false;','true');
  numeric.any = function(x) { if(typeof x.length === "undefined") return x; return numeric.anyV(x); }
  numeric.all = function(x) { if(typeof x.length === "undefined") return x; return numeric.allV(x); }*/

  numeric.ops2 = {
          add: '+',
          sub: '-',
          mul: '*',
          div: '/',
          mod: '%',
          and: '&&',
          or:  '||',
          eq:  '===',
          neq: '!==',
          lt:  '<',
          gt:  '>',
          leq: '<=',
          geq: '>=',
          band: '&',
          bor: '|',
          bxor: '^',
          lshift: '<<',
          rshift: '>>',
          rrshift: '>>>'
  };
  numeric.opseq = {
          addeq: '+=',
          subeq: '-=',
          muleq: '*=',
          diveq: '/=',
          modeq: '%=',
          lshifteq: '<<=',
          rshifteq: '>>=',
          rrshifteq: '>>>=',
          bandeq: '&=',
          boreq: '|=',
          bxoreq: '^='
  };
  numeric.mathfuns = ['abs','acos','asin','atan','ceil','cos',
                      'exp','floor','log','round','sin','sqrt','tan',
                      'isNaN','isFinite'];
  numeric.mathfuns2 = ['atan2','pow','max','min'];
  numeric.ops1 = {
          neg: '-',
          not: '!',
          bnot: '~',
          clone: ''
  };
  numeric.mapreducers = {
          any: ['if(xi) return true;','var accum = false;'],
          all: ['if(!xi) return false;','var accum = true;'],
          sum: ['accum += xi;','var accum = 0;'],
          prod: ['accum *= xi;','var accum = 1;'],
          norm2Squared: ['accum += xi*xi;','var accum = 0;'],
          norminf: ['accum = max(accum,abs(xi));','var accum = 0, max = Math.max, abs = Math.abs;'],
          norm1: ['accum += abs(xi)','var accum = 0, abs = Math.abs;'],
          sup: ['accum = max(accum,xi);','var accum = -Infinity, max = Math.max;'],
          inf: ['accum = min(accum,xi);','var accum = Infinity, min = Math.min;']
  };

  (function () {
      var i,o;
      for(i=0;i<numeric.mathfuns2.length;++i) {
          o = numeric.mathfuns2[i];
          numeric.ops2[o] = o;
      }
      for(i in numeric.ops2) {
          if(numeric.ops2.hasOwnProperty(i)) {
              o = numeric.ops2[i];
              var code, codeeq, setup = '';
              if(numeric.myIndexOf.call(numeric.mathfuns2,i)!==-1) {
                  setup = 'var '+o+' = Math.'+o+';\n';
                  code = function(r,x,y) { return r+' = '+o+'('+x+','+y+')'; };
                  codeeq = function(x,y) { return x+' = '+o+'('+x+','+y+')'; };
              } else {
                  code = function(r,x,y) { return r+' = '+x+' '+o+' '+y; };
                  if(numeric.opseq.hasOwnProperty(i+'eq')) {
                      codeeq = function(x,y) { return x+' '+o+'= '+y; };
                  } else {
                      codeeq = function(x,y) { return x+' = '+x+' '+o+' '+y; };                    
                  }
              }
              numeric[i+'VV'] = numeric.pointwise2(['x[i]','y[i]'],code('ret[i]','x[i]','y[i]'),setup);
              numeric[i+'SV'] = numeric.pointwise2(['x','y[i]'],code('ret[i]','x','y[i]'),setup);
              numeric[i+'VS'] = numeric.pointwise2(['x[i]','y'],code('ret[i]','x[i]','y'),setup);
              numeric[i] = Function(
                      'var n = arguments.length, i, x = arguments[0], y;\n'+
                      'var VV = numeric.'+i+'VV, VS = numeric.'+i+'VS, SV = numeric.'+i+'SV;\n'+
                      'var dim = numeric.dim;\n'+
                      'for(i=1;i!==n;++i) { \n'+
                      '  y = arguments[i];\n'+
                      '  if(typeof x === "object") {\n'+
                      '      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n'+
                      '      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n'+
                      '  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n'+
                      '  else '+codeeq('x','y')+'\n'+
                      '}\nreturn x;\n');
              numeric[o] = numeric[i];
              numeric[i+'eqV'] = numeric.pointwise2(['ret[i]','x[i]'], codeeq('ret[i]','x[i]'),setup);
              numeric[i+'eqS'] = numeric.pointwise2(['ret[i]','x'], codeeq('ret[i]','x'),setup);
              numeric[i+'eq'] = Function(
                      'var n = arguments.length, i, x = arguments[0], y;\n'+
                      'var V = numeric.'+i+'eqV, S = numeric.'+i+'eqS\n'+
                      'var s = numeric.dim(x);\n'+
                      'for(i=1;i!==n;++i) { \n'+
                      '  y = arguments[i];\n'+
                      '  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n'+
                      '  else numeric._biforeach(x,y,s,0,S);\n'+
                      '}\nreturn x;\n');
          }
      }
      for(i=0;i<numeric.mathfuns2.length;++i) {
          o = numeric.mathfuns2[i];
          delete numeric.ops2[o];
      }
      for(i=0;i<numeric.mathfuns.length;++i) {
          o = numeric.mathfuns[i];
          numeric.ops1[o] = o;
      }
      for(i in numeric.ops1) {
          if(numeric.ops1.hasOwnProperty(i)) {
              setup = '';
              o = numeric.ops1[i];
              if(numeric.myIndexOf.call(numeric.mathfuns,i)!==-1) {
                  if(Math.hasOwnProperty(o)) setup = 'var '+o+' = Math.'+o+';\n';
              }
              numeric[i+'eqV'] = numeric.pointwise2(['ret[i]'],'ret[i] = '+o+'(ret[i]);',setup);
              numeric[i+'eq'] = Function('x',
                      'if(typeof x !== "object") return '+o+'x\n'+
                      'var i;\n'+
                      'var V = numeric.'+i+'eqV;\n'+
                      'var s = numeric.dim(x);\n'+
                      'numeric._foreach(x,s,0,V);\n'+
                      'return x;\n');
              numeric[i+'V'] = numeric.pointwise2(['x[i]'],'ret[i] = '+o+'(x[i]);',setup);
              numeric[i] = Function('x',
                      'if(typeof x !== "object") return '+o+'(x)\n'+
                      'var i;\n'+
                      'var V = numeric.'+i+'V;\n'+
                      'var s = numeric.dim(x);\n'+
                      'return numeric._foreach2(x,s,0,V);\n');
          }
      }
      for(i=0;i<numeric.mathfuns.length;++i) {
          o = numeric.mathfuns[i];
          delete numeric.ops1[o];
      }
      for(i in numeric.mapreducers) {
          if(numeric.mapreducers.hasOwnProperty(i)) {
              o = numeric.mapreducers[i];
              numeric[i+'V'] = numeric.mapreduce2(o[0],o[1]);
              numeric[i] = Function('x','s','k',
                      o[1]+
                      'if(typeof x !== "object") {'+
                      '    xi = x;\n'+
                      o[0]+';\n'+
                      '    return accum;\n'+
                      '}'+
                      'if(typeof s === "undefined") s = numeric.dim(x);\n'+
                      'if(typeof k === "undefined") k = 0;\n'+
                      'if(k === s.length-1) return numeric.'+i+'V(x);\n'+
                      'var xi;\n'+
                      'var n = x.length, i;\n'+
                      'for(i=n-1;i!==-1;--i) {\n'+
                      '   xi = arguments.callee(x[i]);\n'+
                      o[0]+';\n'+
                      '}\n'+
                      'return accum;\n');
          }
      }
  }());

  numeric.truncVV = numeric.pointwise(['x[i]','y[i]'],'ret[i] = round(x[i]/y[i])*y[i];','var round = Math.round;');
  numeric.truncVS = numeric.pointwise(['x[i]','y'],'ret[i] = round(x[i]/y)*y;','var round = Math.round;');
  numeric.truncSV = numeric.pointwise(['x','y[i]'],'ret[i] = round(x/y[i])*y[i];','var round = Math.round;');
  numeric.trunc = function trunc(x,y) {
      if(typeof x === "object") {
          if(typeof y === "object") return numeric.truncVV(x,y);
          return numeric.truncVS(x,y);
      }
      if (typeof y === "object") return numeric.truncSV(x,y);
      return Math.round(x/y)*y;
  };

  numeric.inv = function inv(x) {
      var s = numeric.dim(x), abs = Math.abs, m = s[0], n = s[1];
      var A = numeric.clone(x), Ai, Aj;
      var I = numeric.identity(m), Ii, Ij;
      var i,j,k,x;
      for(j=0;j<n;++j) {
          var i0 = -1;
          var v0 = -1;
          for(i=j;i!==m;++i) { k = abs(A[i][j]); if(k>v0) { i0 = i; v0 = k; } }
          Aj = A[i0]; A[i0] = A[j]; A[j] = Aj;
          Ij = I[i0]; I[i0] = I[j]; I[j] = Ij;
          x = Aj[j];
          for(k=j;k!==n;++k)    Aj[k] /= x; 
          for(k=n-1;k!==-1;--k) Ij[k] /= x;
          for(i=m-1;i!==-1;--i) {
              if(i!==j) {
                  Ai = A[i];
                  Ii = I[i];
                  x = Ai[j];
                  for(k=j+1;k!==n;++k)  Ai[k] -= Aj[k]*x;
                  for(k=n-1;k>0;--k) { Ii[k] -= Ij[k]*x; --k; Ii[k] -= Ij[k]*x; }
                  if(k===0) Ii[0] -= Ij[0]*x;
              }
          }
      }
      return I;
  };

  numeric.det = function det(x) {
      var s = numeric.dim(x);
      if(s.length !== 2 || s[0] !== s[1]) { throw new Error('numeric: det() only works on square matrices'); }
      var n = s[0], ret = 1,i,j,k,A = numeric.clone(x),Aj,Ai,alpha,temp,k1;
      for(j=0;j<n-1;j++) {
          k=j;
          for(i=j+1;i<n;i++) { if(Math.abs(A[i][j]) > Math.abs(A[k][j])) { k = i; } }
          if(k !== j) {
              temp = A[k]; A[k] = A[j]; A[j] = temp;
              ret *= -1;
          }
          Aj = A[j];
          for(i=j+1;i<n;i++) {
              Ai = A[i];
              alpha = Ai[j]/Aj[j];
              for(k=j+1;k<n-1;k+=2) {
                  k1 = k+1;
                  Ai[k] -= Aj[k]*alpha;
                  Ai[k1] -= Aj[k1]*alpha;
              }
              if(k!==n) { Ai[k] -= Aj[k]*alpha; }
          }
          if(Aj[j] === 0) { return 0; }
          ret *= Aj[j];
      }
      return ret*A[j][j];
  };

  numeric.transpose = function transpose(x) {
      var i,j,m = x.length,n = x[0].length, ret=Array(n),A0,A1,Bj;
      for(j=0;j<n;j++) ret[j] = Array(m);
      for(i=m-1;i>=1;i-=2) {
          A1 = x[i];
          A0 = x[i-1];
          for(j=n-1;j>=1;--j) {
              Bj = ret[j]; Bj[i] = A1[j]; Bj[i-1] = A0[j];
              --j;
              Bj = ret[j]; Bj[i] = A1[j]; Bj[i-1] = A0[j];
          }
          if(j===0) {
              Bj = ret[0]; Bj[i] = A1[0]; Bj[i-1] = A0[0];
          }
      }
      if(i===0) {
          A0 = x[0];
          for(j=n-1;j>=1;--j) {
              ret[j][0] = A0[j];
              --j;
              ret[j][0] = A0[j];
          }
          if(j===0) { ret[0][0] = A0[0]; }
      }
      return ret;
  };
  numeric.negtranspose = function negtranspose(x) {
      var i,j,m = x.length,n = x[0].length, ret=Array(n),A0,A1,Bj;
      for(j=0;j<n;j++) ret[j] = Array(m);
      for(i=m-1;i>=1;i-=2) {
          A1 = x[i];
          A0 = x[i-1];
          for(j=n-1;j>=1;--j) {
              Bj = ret[j]; Bj[i] = -A1[j]; Bj[i-1] = -A0[j];
              --j;
              Bj = ret[j]; Bj[i] = -A1[j]; Bj[i-1] = -A0[j];
          }
          if(j===0) {
              Bj = ret[0]; Bj[i] = -A1[0]; Bj[i-1] = -A0[0];
          }
      }
      if(i===0) {
          A0 = x[0];
          for(j=n-1;j>=1;--j) {
              ret[j][0] = -A0[j];
              --j;
              ret[j][0] = -A0[j];
          }
          if(j===0) { ret[0][0] = -A0[0]; }
      }
      return ret;
  };

  numeric._random = function _random(s,k) {
      var i,n=s[k],ret=Array(n), rnd;
      if(k === s.length-1) {
          rnd = Math.random;
          for(i=n-1;i>=1;i-=2) {
              ret[i] = rnd();
              ret[i-1] = rnd();
          }
          if(i===0) { ret[0] = rnd(); }
          return ret;
      }
      for(i=n-1;i>=0;i--) ret[i] = _random(s,k+1);
      return ret;
  };
  numeric.random = function random(s) { return numeric._random(s,0); };

  numeric.norm2 = function norm2(x) { return Math.sqrt(numeric.norm2Squared(x)); };

  numeric.linspace = function linspace(a,b,n) {
      if(typeof n === "undefined") n = Math.max(Math.round(b-a)+1,1);
      if(n<2) { return n===1?[a]:[]; }
      var i,ret = Array(n);
      n--;
      for(i=n;i>=0;i--) { ret[i] = (i*b+(n-i)*a)/n; }
      return ret;
  };

  numeric.getBlock = function getBlock(x,from,to) {
      var s = numeric.dim(x);
      function foo(x,k) {
          var i,a = from[k], n = to[k]-a, ret = Array(n);
          if(k === s.length-1) {
              for(i=n;i>=0;i--) { ret[i] = x[i+a]; }
              return ret;
          }
          for(i=n;i>=0;i--) { ret[i] = foo(x[i+a],k+1); }
          return ret;
      }
      return foo(x,0);
  };

  numeric.setBlock = function setBlock(x,from,to,B) {
      var s = numeric.dim(x);
      function foo(x,y,k) {
          var i,a = from[k], n = to[k]-a;
          if(k === s.length-1) { for(i=n;i>=0;i--) { x[i+a] = y[i]; } }
          for(i=n;i>=0;i--) { foo(x[i+a],y[i],k+1); }
      }
      foo(x,B,0);
      return x;
  };

  numeric.getRange = function getRange(A,I,J) {
      var m = I.length, n = J.length;
      var i,j;
      var B = Array(m), Bi, AI;
      for(i=m-1;i!==-1;--i) {
          B[i] = Array(n);
          Bi = B[i];
          AI = A[I[i]];
          for(j=n-1;j!==-1;--j) Bi[j] = AI[J[j]];
      }
      return B;
  };

  numeric.blockMatrix = function blockMatrix(X) {
      var s = numeric.dim(X);
      if(s.length<4) return numeric.blockMatrix([X]);
      var m=s[0],n=s[1],M,N,i,j,Xij;
      M = 0; N = 0;
      for(i=0;i<m;++i) M+=X[i][0].length;
      for(j=0;j<n;++j) N+=X[0][j][0].length;
      var Z = Array(M);
      for(i=0;i<M;++i) Z[i] = Array(N);
      var I=0,J,ZI,k,l,Xijk;
      for(i=0;i<m;++i) {
          J=N;
          for(j=n-1;j!==-1;--j) {
              Xij = X[i][j];
              J -= Xij[0].length;
              for(k=Xij.length-1;k!==-1;--k) {
                  Xijk = Xij[k];
                  ZI = Z[I+k];
                  for(l = Xijk.length-1;l!==-1;--l) ZI[J+l] = Xijk[l];
              }
          }
          I += X[i][0].length;
      }
      return Z;
  };

  numeric.tensor = function tensor(x,y) {
      if(typeof x === "number" || typeof y === "number") return numeric.mul(x,y);
      var s1 = numeric.dim(x), s2 = numeric.dim(y);
      if(s1.length !== 1 || s2.length !== 1) {
          throw new Error('numeric: tensor product is only defined for vectors');
      }
      var m = s1[0], n = s2[0], A = Array(m), Ai, i,j,xi;
      for(i=m-1;i>=0;i--) {
          Ai = Array(n);
          xi = x[i];
          for(j=n-1;j>=3;--j) {
              Ai[j] = xi * y[j];
              --j;
              Ai[j] = xi * y[j];
              --j;
              Ai[j] = xi * y[j];
              --j;
              Ai[j] = xi * y[j];
          }
          while(j>=0) { Ai[j] = xi * y[j]; --j; }
          A[i] = Ai;
      }
      return A;
  };

  // 3. The Tensor type T
  numeric.T = function T(x,y) { this.x = x; this.y = y; };
  numeric.t = function t(x,y) { return new numeric.T(x,y); };

  numeric.Tbinop = function Tbinop(rr,rc,cr,cc,setup) {
      var io = numeric.indexOf;
      if(typeof setup !== "string") {
          var k;
          setup = '';
          for(k in numeric) {
              if(numeric.hasOwnProperty(k) && (rr.indexOf(k)>=0 || rc.indexOf(k)>=0 || cr.indexOf(k)>=0 || cc.indexOf(k)>=0) && k.length>1) {
                  setup += 'var '+k+' = numeric.'+k+';\n';
              }
          }
      }
      return Function(['y'],
              'var x = this;\n'+
              'if(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n'+
              setup+'\n'+
              'if(x.y) {'+
              '  if(y.y) {'+
              '    return new numeric.T('+cc+');\n'+
              '  }\n'+
              '  return new numeric.T('+cr+');\n'+
              '}\n'+
              'if(y.y) {\n'+
              '  return new numeric.T('+rc+');\n'+
              '}\n'+
              'return new numeric.T('+rr+');\n'
      );
  };

  numeric.T.prototype.add = numeric.Tbinop(
          'add(x.x,y.x)',
          'add(x.x,y.x),y.y',
          'add(x.x,y.x),x.y',
          'add(x.x,y.x),add(x.y,y.y)');
  numeric.T.prototype.sub = numeric.Tbinop(
          'sub(x.x,y.x)',
          'sub(x.x,y.x),neg(y.y)',
          'sub(x.x,y.x),x.y',
          'sub(x.x,y.x),sub(x.y,y.y)');
  numeric.T.prototype.mul = numeric.Tbinop(
          'mul(x.x,y.x)',
          'mul(x.x,y.x),mul(x.x,y.y)',
          'mul(x.x,y.x),mul(x.y,y.x)',
          'sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))');

  numeric.T.prototype.reciprocal = function reciprocal() {
      var mul = numeric.mul, div = numeric.div;
      if(this.y) {
          var d = numeric.add(mul(this.x,this.x),mul(this.y,this.y));
          return new numeric.T(div(this.x,d),div(numeric.neg(this.y),d));
      }
      return new T(div(1,this.x));
  };
  numeric.T.prototype.div = function div(y) {
      if(!(y instanceof numeric.T)) y = new numeric.T(y);
      if(y.y) { return this.mul(y.reciprocal()); }
      var div = numeric.div;
      if(this.y) { return new numeric.T(div(this.x,y.x),div(this.y,y.x)); }
      return new numeric.T(div(this.x,y.x));
  };
  numeric.T.prototype.dot = numeric.Tbinop(
          'dot(x.x,y.x)',
          'dot(x.x,y.x),dot(x.x,y.y)',
          'dot(x.x,y.x),dot(x.y,y.x)',
          'sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))'
          );
  numeric.T.prototype.transpose = function transpose() {
      var t = numeric.transpose, x = this.x, y = this.y;
      if(y) { return new numeric.T(t(x),t(y)); }
      return new numeric.T(t(x));
  };
  numeric.T.prototype.transjugate = function transjugate() {
      var t = numeric.transpose, x = this.x, y = this.y;
      if(y) { return new numeric.T(t(x),numeric.negtranspose(y)); }
      return new numeric.T(t(x));
  };
  numeric.Tunop = function Tunop(r,c,s) {
      if(typeof s !== "string") { s = ''; }
      return Function(
              'var x = this;\n'+
              s+'\n'+
              'if(x.y) {'+
              '  '+c+';\n'+
              '}\n'+
              r+';\n'
      );
  };

  numeric.T.prototype.exp = numeric.Tunop(
          'return new numeric.T(ex)',
          'return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))',
          'var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;');
  numeric.T.prototype.conj = numeric.Tunop(
          'return new numeric.T(x.x);',
          'return new numeric.T(x.x,numeric.neg(x.y));');
  numeric.T.prototype.neg = numeric.Tunop(
          'return new numeric.T(neg(x.x));',
          'return new numeric.T(neg(x.x),neg(x.y));',
          'var neg = numeric.neg;');
  numeric.T.prototype.sin = numeric.Tunop(
          'return new numeric.T(numeric.sin(x.x))',
          'return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));');
  numeric.T.prototype.cos = numeric.Tunop(
          'return new numeric.T(numeric.cos(x.x))',
          'return x.exp().add(x.neg().exp()).div(2);');
  numeric.T.prototype.abs = numeric.Tunop(
          'return new numeric.T(numeric.abs(x.x));',
          'return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));',
          'var mul = numeric.mul;');
  numeric.T.prototype.log = numeric.Tunop(
          'return new numeric.T(numeric.log(x.x));',
          'var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\n'+
          'return new numeric.T(numeric.log(r.x),theta.x);');
  numeric.T.prototype.norm2 = numeric.Tunop(
          'return numeric.norm2(x.x);',
          'var f = numeric.norm2Squared;\n'+
          'return Math.sqrt(f(x.x)+f(x.y));');
  numeric.T.prototype.inv = function inv() {
      var A = this;
      if(typeof A.y === "undefined") { return new numeric.T(numeric.inv(A.x)); }
      var n = A.x.length, i, j, k;
      var Rx = numeric.identity(n),Ry = numeric.rep([n,n],0);
      var Ax = numeric.clone(A.x), Ay = numeric.clone(A.y);
      var Aix, Aiy, Ajx, Ajy, Rix, Riy, Rjx, Rjy;
      var i,j,k,d,d1,ax,ay,bx,by,temp;
      for(i=0;i<n;i++) {
          ax = Ax[i][i]; ay = Ay[i][i];
          d = ax*ax+ay*ay;
          k = i;
          for(j=i+1;j<n;j++) {
              ax = Ax[j][i]; ay = Ay[j][i];
              d1 = ax*ax+ay*ay;
              if(d1 > d) { k=j; d = d1; }
          }
          if(k!==i) {
              temp = Ax[i]; Ax[i] = Ax[k]; Ax[k] = temp;
              temp = Ay[i]; Ay[i] = Ay[k]; Ay[k] = temp;
              temp = Rx[i]; Rx[i] = Rx[k]; Rx[k] = temp;
              temp = Ry[i]; Ry[i] = Ry[k]; Ry[k] = temp;
          }
          Aix = Ax[i]; Aiy = Ay[i];
          Rix = Rx[i]; Riy = Ry[i];
          ax = Aix[i]; ay = Aiy[i];
          for(j=i+1;j<n;j++) {
              bx = Aix[j]; by = Aiy[j];
              Aix[j] = (bx*ax+by*ay)/d;
              Aiy[j] = (by*ax-bx*ay)/d;
          }
          for(j=0;j<n;j++) {
              bx = Rix[j]; by = Riy[j];
              Rix[j] = (bx*ax+by*ay)/d;
              Riy[j] = (by*ax-bx*ay)/d;
          }
          for(j=i+1;j<n;j++) {
              Ajx = Ax[j]; Ajy = Ay[j];
              Rjx = Rx[j]; Rjy = Ry[j];
              ax = Ajx[i]; ay = Ajy[i];
              for(k=i+1;k<n;k++) {
                  bx = Aix[k]; by = Aiy[k];
                  Ajx[k] -= bx*ax-by*ay;
                  Ajy[k] -= by*ax+bx*ay;
              }
              for(k=0;k<n;k++) {
                  bx = Rix[k]; by = Riy[k];
                  Rjx[k] -= bx*ax-by*ay;
                  Rjy[k] -= by*ax+bx*ay;
              }
          }
      }
      for(i=n-1;i>0;i--) {
          Rix = Rx[i]; Riy = Ry[i];
          for(j=i-1;j>=0;j--) {
              Rjx = Rx[j]; Rjy = Ry[j];
              ax = Ax[j][i]; ay = Ay[j][i];
              for(k=n-1;k>=0;k--) {
                  bx = Rix[k]; by = Riy[k];
                  Rjx[k] -= ax*bx - ay*by;
                  Rjy[k] -= ax*by + ay*bx;
              }
          }
      }
      return new numeric.T(Rx,Ry);
  };
  numeric.T.prototype.get = function get(i) {
      var x = this.x, y = this.y, k = 0, ik, n = i.length;
      if(y) {
          while(k<n) {
              ik = i[k];
              x = x[ik];
              y = y[ik];
              k++;
          }
          return new numeric.T(x,y);
      }
      while(k<n) {
          ik = i[k];
          x = x[ik];
          k++;
      }
      return new numeric.T(x);
  };
  numeric.T.prototype.set = function set(i,v) {
      var x = this.x, y = this.y, k = 0, ik, n = i.length, vx = v.x, vy = v.y;
      if(n===0) {
          if(vy) { this.y = vy; }
          else if(y) { this.y = undefined; }
          this.x = x;
          return this;
      }
      if(vy) {
          if(y) { /* ok */ }
          else {
              y = numeric.rep(numeric.dim(x),0);
              this.y = y;
          }
          while(k<n-1) {
              ik = i[k];
              x = x[ik];
              y = y[ik];
              k++;
          }
          ik = i[k];
          x[ik] = vx;
          y[ik] = vy;
          return this;
      }
      if(y) {
          while(k<n-1) {
              ik = i[k];
              x = x[ik];
              y = y[ik];
              k++;
          }
          ik = i[k];
          x[ik] = vx;
          if(vx instanceof Array) y[ik] = numeric.rep(numeric.dim(vx),0);
          else y[ik] = 0;
          return this;
      }
      while(k<n-1) {
          ik = i[k];
          x = x[ik];
          k++;
      }
      ik = i[k];
      x[ik] = vx;
      return this;
  };
  numeric.T.prototype.getRows = function getRows(i0,i1) {
      var n = i1-i0+1, j;
      var rx = Array(n), ry, x = this.x, y = this.y;
      for(j=i0;j<=i1;j++) { rx[j-i0] = x[j]; }
      if(y) {
          ry = Array(n);
          for(j=i0;j<=i1;j++) { ry[j-i0] = y[j]; }
          return new numeric.T(rx,ry);
      }
      return new numeric.T(rx);
  };
  numeric.T.prototype.setRows = function setRows(i0,i1,A) {
      var j;
      var rx = this.x, ry = this.y, x = A.x, y = A.y;
      for(j=i0;j<=i1;j++) { rx[j] = x[j-i0]; }
      if(y) {
          if(!ry) { ry = numeric.rep(numeric.dim(rx),0); this.y = ry; }
          for(j=i0;j<=i1;j++) { ry[j] = y[j-i0]; }
      } else if(ry) {
          for(j=i0;j<=i1;j++) { ry[j] = numeric.rep([x[j-i0].length],0); }
      }
      return this;
  };
  numeric.T.prototype.getRow = function getRow(k) {
      var x = this.x, y = this.y;
      if(y) { return new numeric.T(x[k],y[k]); }
      return new numeric.T(x[k]);
  };
  numeric.T.prototype.setRow = function setRow(i,v) {
      var rx = this.x, ry = this.y, x = v.x, y = v.y;
      rx[i] = x;
      if(y) {
          if(!ry) { ry = numeric.rep(numeric.dim(rx),0); this.y = ry; }
          ry[i] = y;
      } else if(ry) {
          ry = numeric.rep([x.length],0);
      }
      return this;
  };

  numeric.T.prototype.getBlock = function getBlock(from,to) {
      var x = this.x, y = this.y, b = numeric.getBlock;
      if(y) { return new numeric.T(b(x,from,to),b(y,from,to)); }
      return new numeric.T(b(x,from,to));
  };
  numeric.T.prototype.setBlock = function setBlock(from,to,A) {
      if(!(A instanceof numeric.T)) A = new numeric.T(A);
      var x = this.x, y = this.y, b = numeric.setBlock, Ax = A.x, Ay = A.y;
      if(Ay) {
          if(!y) { this.y = numeric.rep(numeric.dim(this),0); y = this.y; }
          b(x,from,to,Ax);
          b(y,from,to,Ay);
          return this;
      }
      b(x,from,to,Ax);
      if(y) b(y,from,to,numeric.rep(numeric.dim(Ax),0));
  };
  numeric.T.rep = function rep(s,v) {
      var T = numeric.T;
      if(!(v instanceof T)) v = new T(v);
      var x = v.x, y = v.y, r = numeric.rep;
      if(y) return new T(r(s,x),r(s,y));
      return new T(r(s,x));
  };
  numeric.T.diag = function diag(d) {
      if(!(d instanceof numeric.T)) d = new numeric.T(d);
      var x = d.x, y = d.y, diag = numeric.diag;
      if(y) return new numeric.T(diag(x),diag(y));
      return new numeric.T(diag(x));
  };
  numeric.T.eig = function eig() {
      if(this.y) { throw new Error('eig: not implemented for complex matrices.'); }
      return numeric.eig(this.x);
  };
  numeric.T.identity = function identity(n) { return new numeric.T(numeric.identity(n)); };
  numeric.T.prototype.getDiag = function getDiag() {
      var n = numeric;
      var x = this.x, y = this.y;
      if(y) { return new n.T(n.getDiag(x),n.getDiag(y)); }
      return new n.T(n.getDiag(x));
  };

  // 4. Eigenvalues of real matrices

  numeric.house = function house(x) {
      var v = numeric.clone(x);
      var s = x[0] >= 0 ? 1 : -1;
      var alpha = s*numeric.norm2(x);
      v[0] += alpha;
      var foo = numeric.norm2(v);
      if(foo === 0) { /* this should not happen */ throw new Error('eig: internal error'); }
      return numeric.div(v,foo);
  };

  numeric.toUpperHessenberg = function toUpperHessenberg(me) {
      var s = numeric.dim(me);
      if(s.length !== 2 || s[0] !== s[1]) { throw new Error('numeric: toUpperHessenberg() only works on square matrices'); }
      var m = s[0], i,j,k,x,v,A = numeric.clone(me),B,C,Ai,Ci,Q = numeric.identity(m),Qi;
      for(j=0;j<m-2;j++) {
          x = Array(m-j-1);
          for(i=j+1;i<m;i++) { x[i-j-1] = A[i][j]; }
          if(numeric.norm2(x)>0) {
              v = numeric.house(x);
              B = numeric.getBlock(A,[j+1,j],[m-1,m-1]);
              C = numeric.tensor(v,numeric.dot(v,B));
              for(i=j+1;i<m;i++) { Ai = A[i]; Ci = C[i-j-1]; for(k=j;k<m;k++) Ai[k] -= 2*Ci[k-j]; }
              B = numeric.getBlock(A,[0,j+1],[m-1,m-1]);
              C = numeric.tensor(numeric.dot(B,v),v);
              for(i=0;i<m;i++) { Ai = A[i]; Ci = C[i]; for(k=j+1;k<m;k++) Ai[k] -= 2*Ci[k-j-1]; }
              B = Array(m-j-1);
              for(i=j+1;i<m;i++) B[i-j-1] = Q[i];
              C = numeric.tensor(v,numeric.dot(v,B));
              for(i=j+1;i<m;i++) { Qi = Q[i]; Ci = C[i-j-1]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
          }
      }
      return {H:A, Q:Q};
  };

  numeric.epsilon = 2.220446049250313e-16;

  numeric.QRFrancis = function(H,maxiter) {
      if(typeof maxiter === "undefined") { maxiter = 10000; }
      H = numeric.clone(H);
      var H0 = numeric.clone(H);
      var s = numeric.dim(H),m=s[0],x,v,a,b,c,d,det,tr, Hloc, Q = numeric.identity(m), Qi, Hi, B, C, Ci,i,j,k,iter;
      if(m<3) { return {Q:Q, B:[ [0,m-1] ]}; }
      var epsilon = numeric.epsilon;
      for(iter=0;iter<maxiter;iter++) {
          for(j=0;j<m-1;j++) {
              if(Math.abs(H[j+1][j]) < epsilon*(Math.abs(H[j][j])+Math.abs(H[j+1][j+1]))) {
                  var QH1 = numeric.QRFrancis(numeric.getBlock(H,[0,0],[j,j]),maxiter);
                  var QH2 = numeric.QRFrancis(numeric.getBlock(H,[j+1,j+1],[m-1,m-1]),maxiter);
                  B = Array(j+1);
                  for(i=0;i<=j;i++) { B[i] = Q[i]; }
                  C = numeric.dot(QH1.Q,B);
                  for(i=0;i<=j;i++) { Q[i] = C[i]; }
                  B = Array(m-j-1);
                  for(i=j+1;i<m;i++) { B[i-j-1] = Q[i]; }
                  C = numeric.dot(QH2.Q,B);
                  for(i=j+1;i<m;i++) { Q[i] = C[i-j-1]; }
                  return {Q:Q,B:QH1.B.concat(numeric.add(QH2.B,j+1))};
              }
          }
          a = H[m-2][m-2]; b = H[m-2][m-1];
          c = H[m-1][m-2]; d = H[m-1][m-1];
          tr = a+d;
          det = (a*d-b*c);
          Hloc = numeric.getBlock(H, [0,0], [2,2]);
          if(tr*tr>=4*det) {
              var s1,s2;
              s1 = 0.5*(tr+Math.sqrt(tr*tr-4*det));
              s2 = 0.5*(tr-Math.sqrt(tr*tr-4*det));
              Hloc = numeric.add(numeric.sub(numeric.dot(Hloc,Hloc),
                                             numeric.mul(Hloc,s1+s2)),
                                 numeric.diag(numeric.rep([3],s1*s2)));
          } else {
              Hloc = numeric.add(numeric.sub(numeric.dot(Hloc,Hloc),
                                             numeric.mul(Hloc,tr)),
                                 numeric.diag(numeric.rep([3],det)));
          }
          x = [Hloc[0][0],Hloc[1][0],Hloc[2][0]];
          v = numeric.house(x);
          B = [H[0],H[1],H[2]];
          C = numeric.tensor(v,numeric.dot(v,B));
          for(i=0;i<3;i++) { Hi = H[i]; Ci = C[i]; for(k=0;k<m;k++) Hi[k] -= 2*Ci[k]; }
          B = numeric.getBlock(H, [0,0],[m-1,2]);
          C = numeric.tensor(numeric.dot(B,v),v);
          for(i=0;i<m;i++) { Hi = H[i]; Ci = C[i]; for(k=0;k<3;k++) Hi[k] -= 2*Ci[k]; }
          B = [Q[0],Q[1],Q[2]];
          C = numeric.tensor(v,numeric.dot(v,B));
          for(i=0;i<3;i++) { Qi = Q[i]; Ci = C[i]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
          var J;
          for(j=0;j<m-2;j++) {
              for(k=j;k<=j+1;k++) {
                  if(Math.abs(H[k+1][k]) < epsilon*(Math.abs(H[k][k])+Math.abs(H[k+1][k+1]))) {
                      var QH1 = numeric.QRFrancis(numeric.getBlock(H,[0,0],[k,k]),maxiter);
                      var QH2 = numeric.QRFrancis(numeric.getBlock(H,[k+1,k+1],[m-1,m-1]),maxiter);
                      B = Array(k+1);
                      for(i=0;i<=k;i++) { B[i] = Q[i]; }
                      C = numeric.dot(QH1.Q,B);
                      for(i=0;i<=k;i++) { Q[i] = C[i]; }
                      B = Array(m-k-1);
                      for(i=k+1;i<m;i++) { B[i-k-1] = Q[i]; }
                      C = numeric.dot(QH2.Q,B);
                      for(i=k+1;i<m;i++) { Q[i] = C[i-k-1]; }
                      return {Q:Q,B:QH1.B.concat(numeric.add(QH2.B,k+1))};
                  }
              }
              J = Math.min(m-1,j+3);
              x = Array(J-j);
              for(i=j+1;i<=J;i++) { x[i-j-1] = H[i][j]; }
              v = numeric.house(x);
              B = numeric.getBlock(H, [j+1,j],[J,m-1]);
              C = numeric.tensor(v,numeric.dot(v,B));
              for(i=j+1;i<=J;i++) { Hi = H[i]; Ci = C[i-j-1]; for(k=j;k<m;k++) Hi[k] -= 2*Ci[k-j]; }
              B = numeric.getBlock(H, [0,j+1],[m-1,J]);
              C = numeric.tensor(numeric.dot(B,v),v);
              for(i=0;i<m;i++) { Hi = H[i]; Ci = C[i]; for(k=j+1;k<=J;k++) Hi[k] -= 2*Ci[k-j-1]; }
              B = Array(J-j);
              for(i=j+1;i<=J;i++) B[i-j-1] = Q[i];
              C = numeric.tensor(v,numeric.dot(v,B));
              for(i=j+1;i<=J;i++) { Qi = Q[i]; Ci = C[i-j-1]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
          }
      }
      throw new Error('numeric: eigenvalue iteration does not converge -- increase maxiter?');
  };

  numeric.eig = function eig(A,maxiter) {
      var QH = numeric.toUpperHessenberg(A);
      var QB = numeric.QRFrancis(QH.H,maxiter);
      var T = numeric.T;
      var n = A.length,i,k,B = QB.B,H = numeric.dot(QB.Q,numeric.dot(QH.H,numeric.transpose(QB.Q)));
      var Q = new T(numeric.dot(QB.Q,QH.Q)),Q0;
      var m = B.length,j;
      var a,b,c,d,p1,p2,disc,x,y,p,q,n1,n2;
      var sqrt = Math.sqrt;
      for(k=0;k<m;k++) {
          i = B[k][0];
          if(i === B[k][1]) {
              // nothing
          } else {
              j = i+1;
              a = H[i][i];
              b = H[i][j];
              c = H[j][i];
              d = H[j][j];
              if(b === 0 && c === 0) continue;
              p1 = -a-d;
              p2 = a*d-b*c;
              disc = p1*p1-4*p2;
              if(disc>=0) {
                  if(p1<0) x = -0.5*(p1-sqrt(disc));
                  else     x = -0.5*(p1+sqrt(disc));
                  n1 = (a-x)*(a-x)+b*b;
                  n2 = c*c+(d-x)*(d-x);
                  if(n1>n2) {
                      n1 = sqrt(n1);
                      p = (a-x)/n1;
                      q = b/n1;
                  } else {
                      n2 = sqrt(n2);
                      p = c/n2;
                      q = (d-x)/n2;
                  }
                  Q0 = new T([[q,-p],[p,q]]);
                  Q.setRows(i,j,Q0.dot(Q.getRows(i,j)));
              } else {
                  x = -0.5*p1;
                  y = 0.5*sqrt(-disc);
                  n1 = (a-x)*(a-x)+b*b;
                  n2 = c*c+(d-x)*(d-x);
                  if(n1>n2) {
                      n1 = sqrt(n1+y*y);
                      p = (a-x)/n1;
                      q = b/n1;
                      x = 0;
                      y /= n1;
                  } else {
                      n2 = sqrt(n2+y*y);
                      p = c/n2;
                      q = (d-x)/n2;
                      x = y/n2;
                      y = 0;
                  }
                  Q0 = new T([[q,-p],[p,q]],[[x,y],[y,-x]]);
                  Q.setRows(i,j,Q0.dot(Q.getRows(i,j)));
              }
          }
      }
      var R = Q.dot(A).dot(Q.transjugate()), n = A.length, E = numeric.T.identity(n);
      for(j=0;j<n;j++) {
          if(j>0) {
              for(k=j-1;k>=0;k--) {
                  var Rk = R.get([k,k]), Rj = R.get([j,j]);
                  if(numeric.neq(Rk.x,Rj.x) || numeric.neq(Rk.y,Rj.y)) {
                      x = R.getRow(k).getBlock([k],[j-1]);
                      y = E.getRow(j).getBlock([k],[j-1]);
                      E.set([j,k],(R.get([k,j]).neg().sub(x.dot(y))).div(Rk.sub(Rj)));
                  } else {
                      E.setRow(j,E.getRow(k));
                      continue;
                  }
              }
          }
      }
      for(j=0;j<n;j++) {
          x = E.getRow(j);
          E.setRow(j,x.div(x.norm2()));
      }
      E = E.transpose();
      E = Q.transjugate().dot(E);
      return { lambda:R.getDiag(), E:E };
  };

  // 5. Compressed Column Storage matrices
  numeric.ccsSparse = function ccsSparse(A) {
      var m = A.length,n,foo, i,j, counts = [];
      for(i=m-1;i!==-1;--i) {
          foo = A[i];
          for(j in foo) {
              j = parseInt(j);
              while(j>=counts.length) counts[counts.length] = 0;
              if(foo[j]!==0) counts[j]++;
          }
      }
      var n = counts.length;
      var Ai = Array(n+1);
      Ai[0] = 0;
      for(i=0;i<n;++i) Ai[i+1] = Ai[i] + counts[i];
      var Aj = Array(Ai[n]), Av = Array(Ai[n]);
      for(i=m-1;i!==-1;--i) {
          foo = A[i];
          for(j in foo) {
              if(foo[j]!==0) {
                  counts[j]--;
                  Aj[Ai[j]+counts[j]] = i;
                  Av[Ai[j]+counts[j]] = foo[j];
              }
          }
      }
      return [Ai,Aj,Av];
  };
  numeric.ccsFull = function ccsFull(A) {
      var Ai = A[0], Aj = A[1], Av = A[2], s = numeric.ccsDim(A), m = s[0], n = s[1], i,j,j0,j1;
      var B = numeric.rep([m,n],0);
      for(i=0;i<n;i++) {
          j0 = Ai[i];
          j1 = Ai[i+1];
          for(j=j0;j<j1;++j) { B[Aj[j]][i] = Av[j]; }
      }
      return B;
  };
  numeric.ccsTSolve = function ccsTSolve(A,b,x,bj,xj) {
      var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, max = Math.max,n=0;
      if(typeof bj === "undefined") x = numeric.rep([m],0);
      if(typeof bj === "undefined") bj = numeric.linspace(0,x.length-1);
      if(typeof xj === "undefined") xj = [];
      function dfs(j) {
          var k;
          if(x[j] !== 0) return;
          x[j] = 1;
          for(k=Ai[j];k<Ai[j+1];++k) dfs(Aj[k]);
          xj[n] = j;
          ++n;
      }
      var i,j,j0,j1,k,l,a;
      for(i=bj.length-1;i!==-1;--i) { dfs(bj[i]); }
      xj.length = n;
      for(i=xj.length-1;i!==-1;--i) { x[xj[i]] = 0; }
      for(i=bj.length-1;i!==-1;--i) { j = bj[i]; x[j] = b[j]; }
      for(i=xj.length-1;i!==-1;--i) {
          j = xj[i];
          j0 = Ai[j];
          j1 = max(Ai[j+1],j0);
          for(k=j0;k!==j1;++k) { if(Aj[k] === j) { x[j] /= Av[k]; break; } }
          a = x[j];
          for(k=j0;k!==j1;++k) {
              l = Aj[k];
              if(l !== j) x[l] -= a*Av[k];
          }
      }
      return x;
  };
  numeric.ccsDFS = function ccsDFS(n) {
      this.k = Array(n);
      this.k1 = Array(n);
      this.j = Array(n);
  };
  numeric.ccsDFS.prototype.dfs = function dfs(J,Ai,Aj,x,xj,Pinv) {
      var m = 0,foo,n=xj.length;
      var k = this.k, k1 = this.k1, j = this.j,km,k11;
      if(x[J]!==0) return;
      x[J] = 1;
      j[0] = J;
      k[0] = km = Ai[J];
      k1[0] = k11 = Ai[J+1];
      while(1) {
          if(km >= k11) {
              xj[n] = j[m];
              if(m===0) return;
              ++n;
              --m;
              km = k[m];
              k11 = k1[m];
          } else {
              foo = Pinv[Aj[km]];
              if(x[foo] === 0) {
                  x[foo] = 1;
                  k[m] = km;
                  ++m;
                  j[m] = foo;
                  km = Ai[foo];
                  k1[m] = k11 = Ai[foo+1];
              } else ++km;
          }
      }
  };
  numeric.ccsLPSolve = function ccsLPSolve(A,B,x,xj,I,Pinv,dfs) {
      var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1;
      var Bi = B[0], Bj = B[1], Bv = B[2];
      
      var i,i0,i1,j,j0,j1,k,l,a;
      i0 = Bi[I];
      i1 = Bi[I+1];
      xj.length = 0;
      for(i=i0;i<i1;++i) { dfs.dfs(Pinv[Bj[i]],Ai,Aj,x,xj,Pinv); }
      for(i=xj.length-1;i!==-1;--i) { x[xj[i]] = 0; }
      for(i=i0;i!==i1;++i) { j = Pinv[Bj[i]]; x[j] = Bv[i]; }
      for(i=xj.length-1;i!==-1;--i) {
          j = xj[i];
          j0 = Ai[j];
          j1 = Ai[j+1];
          for(k=j0;k<j1;++k) { if(Pinv[Aj[k]] === j) { x[j] /= Av[k]; break; } }
          a = x[j];
          for(k=j0;k<j1;++k) {
              l = Pinv[Aj[k]];
              if(l !== j) x[l] -= a*Av[k];
          }
      }
      return x;
  };
  numeric.ccsLUP1 = function ccsLUP1(A,threshold) {
      var m = A[0].length-1;
      var L = [numeric.rep([m+1],0),[],[]], U = [numeric.rep([m+1], 0),[],[]];
      var Li = L[0], Lj = L[1], Lv = L[2], Ui = U[0], Uj = U[1], Uv = U[2];
      var x = numeric.rep([m],0), xj = numeric.rep([m],0);
      var i,j,k,a,e,c,d;
      var sol = numeric.ccsLPSolve, abs = Math.abs;
      var P = numeric.linspace(0,m-1),Pinv = numeric.linspace(0,m-1);
      var dfs = new numeric.ccsDFS(m);
      if(typeof threshold === "undefined") { threshold = 1; }
      for(i=0;i<m;++i) {
          sol(L,A,x,xj,i,Pinv,dfs);
          a = -1;
          e = -1;
          for(j=xj.length-1;j!==-1;--j) {
              k = xj[j];
              if(k <= i) continue;
              c = abs(x[k]);
              if(c > a) { e = k; a = c; }
          }
          if(abs(x[i])<threshold*a) {
              j = P[i];
              a = P[e];
              P[i] = a; Pinv[a] = i;
              P[e] = j; Pinv[j] = e;
              a = x[i]; x[i] = x[e]; x[e] = a;
          }
          a = Li[i];
          e = Ui[i];
          d = x[i];
          Lj[a] = P[i];
          Lv[a] = 1;
          ++a;
          for(j=xj.length-1;j!==-1;--j) {
              k = xj[j];
              c = x[k];
              xj[j] = 0;
              x[k] = 0;
              if(k<=i) { Uj[e] = k; Uv[e] = c;   ++e; }
              else     { Lj[a] = P[k]; Lv[a] = c/d; ++a; }
          }
          Li[i+1] = a;
          Ui[i+1] = e;
      }
      for(j=Lj.length-1;j!==-1;--j) { Lj[j] = Pinv[Lj[j]]; }
      return {L:L, U:U, P:P, Pinv:Pinv};
  };
  numeric.ccsDFS0 = function ccsDFS0(n) {
      this.k = Array(n);
      this.k1 = Array(n);
      this.j = Array(n);
  };
  numeric.ccsDFS0.prototype.dfs = function dfs(J,Ai,Aj,x,xj,Pinv,P) {
      var m = 0,foo,n=xj.length;
      var k = this.k, k1 = this.k1, j = this.j,km,k11;
      if(x[J]!==0) return;
      x[J] = 1;
      j[0] = J;
      k[0] = km = Ai[Pinv[J]];
      k1[0] = k11 = Ai[Pinv[J]+1];
      while(1) {
          if(isNaN(km)) throw new Error("Ow!");
          if(km >= k11) {
              xj[n] = Pinv[j[m]];
              if(m===0) return;
              ++n;
              --m;
              km = k[m];
              k11 = k1[m];
          } else {
              foo = Aj[km];
              if(x[foo] === 0) {
                  x[foo] = 1;
                  k[m] = km;
                  ++m;
                  j[m] = foo;
                  foo = Pinv[foo];
                  km = Ai[foo];
                  k1[m] = k11 = Ai[foo+1];
              } else ++km;
          }
      }
  };
  numeric.ccsLPSolve0 = function ccsLPSolve0(A,B,y,xj,I,Pinv,P,dfs) {
      var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1;
      var Bi = B[0], Bj = B[1], Bv = B[2];
      
      var i,i0,i1,j,j0,j1,k,l,a;
      i0 = Bi[I];
      i1 = Bi[I+1];
      xj.length = 0;
      for(i=i0;i<i1;++i) { dfs.dfs(Bj[i],Ai,Aj,y,xj,Pinv,P); }
      for(i=xj.length-1;i!==-1;--i) { j = xj[i]; y[P[j]] = 0; }
      for(i=i0;i!==i1;++i) { j = Bj[i]; y[j] = Bv[i]; }
      for(i=xj.length-1;i!==-1;--i) {
          j = xj[i];
          l = P[j];
          j0 = Ai[j];
          j1 = Ai[j+1];
          for(k=j0;k<j1;++k) { if(Aj[k] === l) { y[l] /= Av[k]; break; } }
          a = y[l];
          for(k=j0;k<j1;++k) y[Aj[k]] -= a*Av[k];
          y[l] = a;
      }
  };
  numeric.ccsLUP0 = function ccsLUP0(A,threshold) {
      var m = A[0].length-1;
      var L = [numeric.rep([m+1],0),[],[]], U = [numeric.rep([m+1], 0),[],[]];
      var Li = L[0], Lj = L[1], Lv = L[2], Ui = U[0], Uj = U[1], Uv = U[2];
      var y = numeric.rep([m],0), xj = numeric.rep([m],0);
      var i,j,k,a,e,c,d;
      var sol = numeric.ccsLPSolve0, abs = Math.abs;
      var P = numeric.linspace(0,m-1),Pinv = numeric.linspace(0,m-1);
      var dfs = new numeric.ccsDFS0(m);
      if(typeof threshold === "undefined") { threshold = 1; }
      for(i=0;i<m;++i) {
          sol(L,A,y,xj,i,Pinv,P,dfs);
          a = -1;
          e = -1;
          for(j=xj.length-1;j!==-1;--j) {
              k = xj[j];
              if(k <= i) continue;
              c = abs(y[P[k]]);
              if(c > a) { e = k; a = c; }
          }
          if(abs(y[P[i]])<threshold*a) {
              j = P[i];
              a = P[e];
              P[i] = a; Pinv[a] = i;
              P[e] = j; Pinv[j] = e;
          }
          a = Li[i];
          e = Ui[i];
          d = y[P[i]];
          Lj[a] = P[i];
          Lv[a] = 1;
          ++a;
          for(j=xj.length-1;j!==-1;--j) {
              k = xj[j];
              c = y[P[k]];
              xj[j] = 0;
              y[P[k]] = 0;
              if(k<=i) { Uj[e] = k; Uv[e] = c;   ++e; }
              else     { Lj[a] = P[k]; Lv[a] = c/d; ++a; }
          }
          Li[i+1] = a;
          Ui[i+1] = e;
      }
      for(j=Lj.length-1;j!==-1;--j) { Lj[j] = Pinv[Lj[j]]; }
      return {L:L, U:U, P:P, Pinv:Pinv};
  };
  numeric.ccsLUP = numeric.ccsLUP0;

  numeric.ccsDim = function ccsDim(A) { return [numeric.sup(A[1])+1,A[0].length-1]; };
  numeric.ccsGetBlock = function ccsGetBlock(A,i,j) {
      var s = numeric.ccsDim(A),m=s[0],n=s[1];
      if(typeof i === "undefined") { i = numeric.linspace(0,m-1); }
      else if(typeof i === "number") { i = [i]; }
      if(typeof j === "undefined") { j = numeric.linspace(0,n-1); }
      else if(typeof j === "number") { j = [j]; }
      var p,P = i.length,q,Q = j.length,r,jq,ip;
      var Bi = numeric.rep([n],0), Bj=[], Bv=[], B = [Bi,Bj,Bv];
      var Ai = A[0], Aj = A[1], Av = A[2];
      var x = numeric.rep([m],0),count=0,flags = numeric.rep([m],0);
      for(q=0;q<Q;++q) {
          jq = j[q];
          var q0 = Ai[jq];
          var q1 = Ai[jq+1];
          for(p=q0;p<q1;++p) {
              r = Aj[p];
              flags[r] = 1;
              x[r] = Av[p];
          }
          for(p=0;p<P;++p) {
              ip = i[p];
              if(flags[ip]) {
                  Bj[count] = p;
                  Bv[count] = x[i[p]];
                  ++count;
              }
          }
          for(p=q0;p<q1;++p) {
              r = Aj[p];
              flags[r] = 0;
          }
          Bi[q+1] = count;
      }
      return B;
  };

  numeric.ccsDot = function ccsDot(A,B) {
      var Ai = A[0], Aj = A[1], Av = A[2];
      var Bi = B[0], Bj = B[1], Bv = B[2];
      var sA = numeric.ccsDim(A), sB = numeric.ccsDim(B);
      var m = sA[0], n = sA[1], o = sB[1];
      var x = numeric.rep([m],0), flags = numeric.rep([m],0), xj = Array(m);
      var Ci = numeric.rep([o],0), Cj = [], Cv = [], C = [Ci,Cj,Cv];
      var i,j,k,j0,j1,i0,i1,l,p,a,b;
      for(k=0;k!==o;++k) {
          j0 = Bi[k];
          j1 = Bi[k+1];
          p = 0;
          for(j=j0;j<j1;++j) {
              a = Bj[j];
              b = Bv[j];
              i0 = Ai[a];
              i1 = Ai[a+1];
              for(i=i0;i<i1;++i) {
                  l = Aj[i];
                  if(flags[l]===0) {
                      xj[p] = l;
                      flags[l] = 1;
                      p = p+1;
                  }
                  x[l] = x[l] + Av[i]*b;
              }
          }
          j0 = Ci[k];
          j1 = j0+p;
          Ci[k+1] = j1;
          for(j=p-1;j!==-1;--j) {
              b = j0+j;
              i = xj[j];
              Cj[b] = i;
              Cv[b] = x[i];
              flags[i] = 0;
              x[i] = 0;
          }
          Ci[k+1] = Ci[k]+p;
      }
      return C;
  };

  numeric.ccsLUPSolve = function ccsLUPSolve(LUP,B) {
      var L = LUP.L, U = LUP.U, P = LUP.P;
      var Bi = B[0];
      var flag = false;
      if(typeof Bi !== "object") { B = [[0,B.length],numeric.linspace(0,B.length-1),B]; Bi = B[0]; flag = true; }
      var Bj = B[1], Bv = B[2];
      var n = L[0].length-1, m = Bi.length-1;
      var x = numeric.rep([n],0), xj = Array(n);
      var b = numeric.rep([n],0), bj = Array(n);
      var Xi = numeric.rep([m+1],0), Xj = [], Xv = [];
      var sol = numeric.ccsTSolve;
      var i,j,j0,j1,k,J,N=0;
      for(i=0;i<m;++i) {
          k = 0;
          j0 = Bi[i];
          j1 = Bi[i+1];
          for(j=j0;j<j1;++j) { 
              J = LUP.Pinv[Bj[j]];
              bj[k] = J;
              b[J] = Bv[j];
              ++k;
          }
          bj.length = k;
          sol(L,b,x,bj,xj);
          for(j=bj.length-1;j!==-1;--j) b[bj[j]] = 0;
          sol(U,x,b,xj,bj);
          if(flag) return b;
          for(j=xj.length-1;j!==-1;--j) x[xj[j]] = 0;
          for(j=bj.length-1;j!==-1;--j) {
              J = bj[j];
              Xj[N] = J;
              Xv[N] = b[J];
              b[J] = 0;
              ++N;
          }
          Xi[i+1] = N;
      }
      return [Xi,Xj,Xv];
  };

  numeric.ccsbinop = function ccsbinop(body,setup) {
      if(typeof setup === "undefined") setup='';
      return Function('X','Y',
              'var Xi = X[0], Xj = X[1], Xv = X[2];\n'+
              'var Yi = Y[0], Yj = Y[1], Yv = Y[2];\n'+
              'var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\n'+
              'var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\n'+
              'var x = numeric.rep([m],0),y = numeric.rep([m],0);\n'+
              'var xk,yk,zk;\n'+
              'var i,j,j0,j1,k,p=0;\n'+
              setup+
              'for(i=0;i<n;++i) {\n'+
              '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
              '  for(j=j0;j!==j1;++j) {\n'+
              '    k = Xj[j];\n'+
              '    x[k] = 1;\n'+
              '    Zj[p] = k;\n'+
              '    ++p;\n'+
              '  }\n'+
              '  j0 = Yi[i]; j1 = Yi[i+1];\n'+
              '  for(j=j0;j!==j1;++j) {\n'+
              '    k = Yj[j];\n'+
              '    y[k] = Yv[j];\n'+
              '    if(x[k] === 0) {\n'+
              '      Zj[p] = k;\n'+
              '      ++p;\n'+
              '    }\n'+
              '  }\n'+
              '  Zi[i+1] = p;\n'+
              '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
              '  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n'+
              '  j0 = Zi[i]; j1 = Zi[i+1];\n'+
              '  for(j=j0;j!==j1;++j) {\n'+
              '    k = Zj[j];\n'+
              '    xk = x[k];\n'+
              '    yk = y[k];\n'+
              body+'\n'+
              '    Zv[j] = zk;\n'+
              '  }\n'+
              '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
              '  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n'+
              '  j0 = Yi[i]; j1 = Yi[i+1];\n'+
              '  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n'+
              '}\n'+
              'return [Zi,Zj,Zv];'
              );
  };

  (function() {
      var k,A,B,C;
      for(k in numeric.ops2) {
          if(isFinite(eval('1'+numeric.ops2[k]+'0'))) A = '[Y[0],Y[1],numeric.'+k+'(X,Y[2])]';
          else A = 'NaN';
          if(isFinite(eval('0'+numeric.ops2[k]+'1'))) B = '[X[0],X[1],numeric.'+k+'(X[2],Y)]';
          else B = 'NaN';
          if(isFinite(eval('1'+numeric.ops2[k]+'0')) && isFinite(eval('0'+numeric.ops2[k]+'1'))) C = 'numeric.ccs'+k+'MM(X,Y)';
          else C = 'NaN';
          numeric['ccs'+k+'MM'] = numeric.ccsbinop('zk = xk '+numeric.ops2[k]+'yk;');
          numeric['ccs'+k] = Function('X','Y',
                  'if(typeof X === "number") return '+A+';\n'+
                  'if(typeof Y === "number") return '+B+';\n'+
                  'return '+C+';\n'
                  );
      }
  }());

  numeric.ccsScatter = function ccsScatter(A) {
      var Ai = A[0], Aj = A[1], Av = A[2];
      var n = numeric.sup(Aj)+1,m=Ai.length;
      var Ri = numeric.rep([n],0),Rj=Array(m), Rv = Array(m);
      var counts = numeric.rep([n],0),i;
      for(i=0;i<m;++i) counts[Aj[i]]++;
      for(i=0;i<n;++i) Ri[i+1] = Ri[i] + counts[i];
      var ptr = Ri.slice(0),k,Aii;
      for(i=0;i<m;++i) {
          Aii = Aj[i];
          k = ptr[Aii];
          Rj[k] = Ai[i];
          Rv[k] = Av[i];
          ptr[Aii]=ptr[Aii]+1;
      }
      return [Ri,Rj,Rv];
  };

  numeric.ccsGather = function ccsGather(A) {
      var Ai = A[0], Aj = A[1], Av = A[2];
      var n = Ai.length-1,m = Aj.length;
      var Ri = Array(m), Rj = Array(m), Rv = Array(m);
      var i,j,j0,j1,p;
      p=0;
      for(i=0;i<n;++i) {
          j0 = Ai[i];
          j1 = Ai[i+1];
          for(j=j0;j!==j1;++j) {
              Rj[p] = i;
              Ri[p] = Aj[j];
              Rv[p] = Av[j];
              ++p;
          }
      }
      return [Ri,Rj,Rv];
  };

  // The following sparse linear algebra routines are deprecated.

  numeric.sdim = function dim(A,ret,k) {
      if(typeof ret === "undefined") { ret = []; }
      if(typeof A !== "object") return ret;
      if(typeof k === "undefined") { k=0; }
      if(!(k in ret)) { ret[k] = 0; }
      if(A.length > ret[k]) ret[k] = A.length;
      var i;
      for(i in A) {
          if(A.hasOwnProperty(i)) dim(A[i],ret,k+1);
      }
      return ret;
  };

  numeric.sclone = function clone(A,k,n) {
      if(typeof k === "undefined") { k=0; }
      if(typeof n === "undefined") { n = numeric.sdim(A).length; }
      var i,ret = Array(A.length);
      if(k === n-1) {
          for(i in A) { if(A.hasOwnProperty(i)) ret[i] = A[i]; }
          return ret;
      }
      for(i in A) {
          if(A.hasOwnProperty(i)) ret[i] = clone(A[i],k+1,n);
      }
      return ret;
  };

  numeric.sdiag = function diag(d) {
      var n = d.length,i,ret = Array(n),i1;
      for(i=n-1;i>=1;i-=2) {
          i1 = i-1;
          ret[i] = []; ret[i][i] = d[i];
          ret[i1] = []; ret[i1][i1] = d[i1];
      }
      if(i===0) { ret[0] = []; ret[0][0] = d[i]; }
      return ret;
  };

  numeric.sidentity = function identity(n) { return numeric.sdiag(numeric.rep([n],1)); };

  numeric.stranspose = function transpose(A) {
      var ret = [], n = A.length, i,j,Ai;
      for(i in A) {
          if(!(A.hasOwnProperty(i))) continue;
          Ai = A[i];
          for(j in Ai) {
              if(!(Ai.hasOwnProperty(j))) continue;
              if(typeof ret[j] !== "object") { ret[j] = []; }
              ret[j][i] = Ai[j];
          }
      }
      return ret;
  };

  numeric.sLUP = function LUP(A,tol) {
      throw new Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
  };

  numeric.sdotMM = function dotMM(A,B) {
      var p = A.length, q = B.length, BT = numeric.stranspose(B), r = BT.length, Ai, BTk;
      var i,j,k,accum;
      var ret = Array(p),reti;
      for(i=p-1;i>=0;i--) {
          reti = [];
          Ai = A[i];
          for(k=r-1;k>=0;k--) {
              accum = 0;
              BTk = BT[k];
              for(j in Ai) {
                  if(!(Ai.hasOwnProperty(j))) continue;
                  if(j in BTk) { accum += Ai[j]*BTk[j]; }
              }
              if(accum) reti[k] = accum;
          }
          ret[i] = reti;
      }
      return ret;
  };

  numeric.sdotMV = function dotMV(A,x) {
      var p = A.length, Ai, i,j;
      var ret = Array(p), accum;
      for(i=p-1;i>=0;i--) {
          Ai = A[i];
          accum = 0;
          for(j in Ai) {
              if(!(Ai.hasOwnProperty(j))) continue;
              if(x[j]) accum += Ai[j]*x[j];
          }
          if(accum) ret[i] = accum;
      }
      return ret;
  };

  numeric.sdotVM = function dotMV(x,A) {
      var i,j,Ai,alpha;
      var ret = [];
      for(i in x) {
          if(!x.hasOwnProperty(i)) continue;
          Ai = A[i];
          alpha = x[i];
          for(j in Ai) {
              if(!Ai.hasOwnProperty(j)) continue;
              if(!ret[j]) { ret[j] = 0; }
              ret[j] += alpha*Ai[j];
          }
      }
      return ret;
  };

  numeric.sdotVV = function dotVV(x,y) {
      var i,ret=0;
      for(i in x) { if(x[i] && y[i]) ret+= x[i]*y[i]; }
      return ret;
  };

  numeric.sdot = function dot(A,B) {
      var m = numeric.sdim(A).length, n = numeric.sdim(B).length;
      var k = m*1000+n;
      switch(k) {
      case 0: return A*B;
      case 1001: return numeric.sdotVV(A,B);
      case 2001: return numeric.sdotMV(A,B);
      case 1002: return numeric.sdotVM(A,B);
      case 2002: return numeric.sdotMM(A,B);
      default: throw new Error('numeric.sdot not implemented for tensors of order '+m+' and '+n);
      }
  };

  numeric.sscatter = function scatter(V) {
      var n = V[0].length, Vij, i, j, m = V.length, A = [], Aj;
      for(i=n-1;i>=0;--i) {
          if(!V[m-1][i]) continue;
          Aj = A;
          for(j=0;j<m-2;j++) {
              Vij = V[j][i];
              if(!Aj[Vij]) Aj[Vij] = [];
              Aj = Aj[Vij];
          }
          Aj[V[j][i]] = V[j+1][i];
      }
      return A;
  };

  numeric.sgather = function gather(A,ret,k) {
      if(typeof ret === "undefined") ret = [];
      if(typeof k === "undefined") k = [];
      var n,i,Ai;
      n = k.length;
      for(i in A) {
          if(A.hasOwnProperty(i)) {
              k[n] = parseInt(i);
              Ai = A[i];
              if(typeof Ai === "number") {
                  if(Ai) {
                      if(ret.length === 0) {
                          for(i=n+1;i>=0;--i) ret[i] = [];
                      }
                      for(i=n;i>=0;--i) ret[i].push(k[i]);
                      ret[n+1].push(Ai);
                  }
              } else gather(Ai,ret,k);
          }
      }
      if(k.length>n) k.pop();
      return ret;
  };

  // 6. Coordinate matrices
  numeric.cLU = function LU(A) {
      var I = A[0], J = A[1], V = A[2];
      var p = I.length, m=0, i,j,k,a,b,c;
      for(i=0;i<p;i++) if(I[i]>m) m=I[i];
      m++;
      var L = Array(m), U = Array(m), left = numeric.rep([m],Infinity), right = numeric.rep([m],-Infinity);
      var Ui, Uj,alpha;
      for(k=0;k<p;k++) {
          i = I[k];
          j = J[k];
          if(j<left[i]) left[i] = j;
          if(j>right[i]) right[i] = j;
      }
      for(i=0;i<m-1;i++) { if(right[i] > right[i+1]) right[i+1] = right[i]; }
      for(i=m-1;i>=1;i--) { if(left[i]<left[i-1]) left[i-1] = left[i]; }
      var countL = 0, countU = 0;
      for(i=0;i<m;i++) {
          U[i] = numeric.rep([right[i]-left[i]+1],0);
          L[i] = numeric.rep([i-left[i]],0);
          countL += i-left[i]+1;
          countU += right[i]-i+1;
      }
      for(k=0;k<p;k++) { i = I[k]; U[i][J[k]-left[i]] = V[k]; }
      for(i=0;i<m-1;i++) {
          a = i-left[i];
          Ui = U[i];
          for(j=i+1;left[j]<=i && j<m;j++) {
              b = i-left[j];
              c = right[i]-i;
              Uj = U[j];
              alpha = Uj[b]/Ui[a];
              if(alpha) {
                  for(k=1;k<=c;k++) { Uj[k+b] -= alpha*Ui[k+a]; }
                  L[j][i-left[j]] = alpha;
              }
          }
      }
      var Ui = [], Uj = [], Uv = [], Li = [], Lj = [], Lv = [];
      var p,q,foo;
      p=0; q=0;
      for(i=0;i<m;i++) {
          a = left[i];
          b = right[i];
          foo = U[i];
          for(j=i;j<=b;j++) {
              if(foo[j-a]) {
                  Ui[p] = i;
                  Uj[p] = j;
                  Uv[p] = foo[j-a];
                  p++;
              }
          }
          foo = L[i];
          for(j=a;j<i;j++) {
              if(foo[j-a]) {
                  Li[q] = i;
                  Lj[q] = j;
                  Lv[q] = foo[j-a];
                  q++;
              }
          }
          Li[q] = i;
          Lj[q] = i;
          Lv[q] = 1;
          q++;
      }
      return {U:[Ui,Uj,Uv], L:[Li,Lj,Lv]};
  };

  numeric.cLUsolve = function LUsolve(lu,b) {
      var L = lu.L, U = lu.U, ret = numeric.clone(b);
      var Li = L[0], Lj = L[1], Lv = L[2];
      var Ui = U[0], Uj = U[1], Uv = U[2];
      var p = Ui.length, q = Li.length;
      var m = ret.length,i,k;
      k = 0;
      for(i=0;i<m;i++) {
          while(Lj[k] < i) {
              ret[i] -= Lv[k]*ret[Lj[k]];
              k++;
          }
          k++;
      }
      k = p-1;
      for(i=m-1;i>=0;i--) {
          while(Uj[k] > i) {
              ret[i] -= Uv[k]*ret[Uj[k]];
              k--;
          }
          ret[i] /= Uv[k];
          k--;
      }
      return ret;
  };

  numeric.cgrid = function grid(n,shape) {
      if(typeof n === "number") n = [n,n];
      var ret = numeric.rep(n,-1);
      var i,j,count;
      if(typeof shape !== "function") {
          switch(shape) {
          case 'L':
              shape = function(i,j) { return (i>=n[0]/2 || j<n[1]/2); };
              break;
          default:
              shape = function(i,j) { return true; };
              break;
          }
      }
      count=0;
      for(i=1;i<n[0]-1;i++) for(j=1;j<n[1]-1;j++) 
          if(shape(i,j)) {
              ret[i][j] = count;
              count++;
          }
      return ret;
  };

  numeric.cdelsq = function delsq(g) {
      var dir = [[-1,0],[0,-1],[0,1],[1,0]];
      var s = numeric.dim(g), m = s[0], n = s[1], i,j,k,p,q;
      var Li = [], Lj = [], Lv = [];
      for(i=1;i<m-1;i++) for(j=1;j<n-1;j++) {
          if(g[i][j]<0) continue;
          for(k=0;k<4;k++) {
              p = i+dir[k][0];
              q = j+dir[k][1];
              if(g[p][q]<0) continue;
              Li.push(g[i][j]);
              Lj.push(g[p][q]);
              Lv.push(-1);
          }
          Li.push(g[i][j]);
          Lj.push(g[i][j]);
          Lv.push(4);
      }
      return [Li,Lj,Lv];
  };

  numeric.cdotMV = function dotMV(A,x) {
      var ret, Ai = A[0], Aj = A[1], Av = A[2],k,p=Ai.length,N;
      N=0;
      for(k=0;k<p;k++) { if(Ai[k]>N) N = Ai[k]; }
      N++;
      ret = numeric.rep([N],0);
      for(k=0;k<p;k++) { ret[Ai[k]]+=Av[k]*x[Aj[k]]; }
      return ret;
  };

  // 7. Splines

  numeric.Spline = function Spline(x,yl,yr,kl,kr) { this.x = x; this.yl = yl; this.yr = yr; this.kl = kl; this.kr = kr; };
  numeric.Spline.prototype._at = function _at(x1,p) {
      var x = this.x;
      var yl = this.yl;
      var yr = this.yr;
      var kl = this.kl;
      var kr = this.kr;
      var x1,a,b,t;
      var add = numeric.add, sub = numeric.sub, mul = numeric.mul;
      a = sub(mul(kl[p],x[p+1]-x[p]),sub(yr[p+1],yl[p]));
      b = add(mul(kr[p+1],x[p]-x[p+1]),sub(yr[p+1],yl[p]));
      t = (x1-x[p])/(x[p+1]-x[p]);
      var s = t*(1-t);
      return add(add(add(mul(1-t,yl[p]),mul(t,yr[p+1])),mul(a,s*(1-t))),mul(b,s*t));
  };
  numeric.Spline.prototype.at = function at(x0) {
      if(typeof x0 === "number") {
          var x = this.x;
          var n = x.length;
          var p,q,mid,floor = Math.floor;
          p = 0;
          q = n-1;
          while(q-p>1) {
              mid = floor((p+q)/2);
              if(x[mid] <= x0) p = mid;
              else q = mid;
          }
          return this._at(x0,p);
      }
      var n = x0.length, i, ret = Array(n);
      for(i=n-1;i!==-1;--i) ret[i] = this.at(x0[i]);
      return ret;
  };
  numeric.Spline.prototype.diff = function diff() {
      var x = this.x;
      var yl = this.yl;
      var yr = this.yr;
      var kl = this.kl;
      var kr = this.kr;
      var n = yl.length;
      var i,dx,dy;
      var zl = kl, zr = kr, pl = Array(n), pr = Array(n);
      var add = numeric.add, mul = numeric.mul, div = numeric.div, sub = numeric.sub;
      for(i=n-1;i!==-1;--i) {
          dx = x[i+1]-x[i];
          dy = sub(yr[i+1],yl[i]);
          pl[i] = div(add(mul(dy, 6),mul(kl[i],-4*dx),mul(kr[i+1],-2*dx)),dx*dx);
          pr[i+1] = div(add(mul(dy,-6),mul(kl[i], 2*dx),mul(kr[i+1], 4*dx)),dx*dx);
      }
      return new numeric.Spline(x,zl,zr,pl,pr);
  };
  numeric.Spline.prototype.roots = function roots() {
      function sqr(x) { return x*x; }
      var ret = [];
      var x = this.x, yl = this.yl, yr = this.yr, kl = this.kl, kr = this.kr;
      if(typeof yl[0] === "number") {
          yl = [yl];
          yr = [yr];
          kl = [kl];
          kr = [kr];
      }
      var m = yl.length,n=x.length-1,i,j,k;
      var ai,bi,ci,di, ret = Array(m),ri,k0,k1,y0,y1,A,B,D,dx,cx,stops,z0,z1,zm,t0,t1,tm;
      var sqrt = Math.sqrt;
      for(i=0;i!==m;++i) {
          ai = yl[i];
          bi = yr[i];
          ci = kl[i];
          di = kr[i];
          ri = [];
          for(j=0;j!==n;j++) {
              if(j>0 && bi[j]*ai[j]<0) ri.push(x[j]);
              dx = (x[j+1]-x[j]);
              cx = x[j];
              y0 = ai[j];
              y1 = bi[j+1];
              k0 = ci[j]/dx;
              k1 = di[j+1]/dx;
              D = sqr(k0-k1+3*(y0-y1)) + 12*k1*y0;
              A = k1+3*y0+2*k0-3*y1;
              B = 3*(k1+k0+2*(y0-y1));
              if(D<=0) {
                  z0 = A/B;
                  if(z0>x[j] && z0<x[j+1]) stops = [x[j],z0,x[j+1]];
                  else stops = [x[j],x[j+1]];
              } else {
                  z0 = (A-sqrt(D))/B;
                  z1 = (A+sqrt(D))/B;
                  stops = [x[j]];
                  if(z0>x[j] && z0<x[j+1]) stops.push(z0);
                  if(z1>x[j] && z1<x[j+1]) stops.push(z1);
                  stops.push(x[j+1]);
              }
              t0 = stops[0];
              z0 = this._at(t0,j);
              for(k=0;k<stops.length-1;k++) {
                  t1 = stops[k+1];
                  z1 = this._at(t1,j);
                  if(z0 === 0) {
                      ri.push(t0); 
                      t0 = t1;
                      z0 = z1;
                      continue;
                  }
                  if(z1 === 0 || z0*z1>0) {
                      t0 = t1;
                      z0 = z1;
                      continue;
                  }
                  var side = 0;
                  while(1) {
                      tm = (z0*t1-z1*t0)/(z0-z1);
                      if(tm <= t0 || tm >= t1) { break; }
                      zm = this._at(tm,j);
                      if(zm*z1>0) {
                          t1 = tm;
                          z1 = zm;
                          if(side === -1) z0*=0.5;
                          side = -1;
                      } else if(zm*z0>0) {
                          t0 = tm;
                          z0 = zm;
                          if(side === 1) z1*=0.5;
                          side = 1;
                      } else break;
                  }
                  ri.push(tm);
                  t0 = stops[k+1];
                  z0 = this._at(t0, j);
              }
              if(z1 === 0) ri.push(t1);
          }
          ret[i] = ri;
      }
      if(typeof this.yl[0] === "number") return ret[0];
      return ret;
  };
  numeric.spline = function spline(x,y,k1,kn) {
      var n = x.length, b = [], dx = [], dy = [];
      var i;
      var sub = numeric.sub,mul = numeric.mul,add = numeric.add;
      for(i=n-2;i>=0;i--) { dx[i] = x[i+1]-x[i]; dy[i] = sub(y[i+1],y[i]); }
      if(typeof k1 === "string" || typeof kn === "string") { 
          k1 = kn = "periodic";
      }
      // Build sparse tridiagonal system
      var T = [[],[],[]];
      switch(typeof k1) {
      case "undefined":
          b[0] = mul(3/(dx[0]*dx[0]),dy[0]);
          T[0].push(0,0);
          T[1].push(0,1);
          T[2].push(2/dx[0],1/dx[0]);
          break;
      case "string":
          b[0] = add(mul(3/(dx[n-2]*dx[n-2]),dy[n-2]),mul(3/(dx[0]*dx[0]),dy[0]));
          T[0].push(0,0,0);
          T[1].push(n-2,0,1);
          T[2].push(1/dx[n-2],2/dx[n-2]+2/dx[0],1/dx[0]);
          break;
      default:
          b[0] = k1;
          T[0].push(0);
          T[1].push(0);
          T[2].push(1);
          break;
      }
      for(i=1;i<n-1;i++) {
          b[i] = add(mul(3/(dx[i-1]*dx[i-1]),dy[i-1]),mul(3/(dx[i]*dx[i]),dy[i]));
          T[0].push(i,i,i);
          T[1].push(i-1,i,i+1);
          T[2].push(1/dx[i-1],2/dx[i-1]+2/dx[i],1/dx[i]);
      }
      switch(typeof kn) {
      case "undefined":
          b[n-1] = mul(3/(dx[n-2]*dx[n-2]),dy[n-2]);
          T[0].push(n-1,n-1);
          T[1].push(n-2,n-1);
          T[2].push(1/dx[n-2],2/dx[n-2]);
          break;
      case "string":
          T[1][T[1].length-1] = 0;
          break;
      default:
          b[n-1] = kn;
          T[0].push(n-1);
          T[1].push(n-1);
          T[2].push(1);
          break;
      }
      if(typeof b[0] !== "number") b = numeric.transpose(b);
      else b = [b];
      var k = Array(b.length);
      if(typeof k1 === "string") {
          for(i=k.length-1;i!==-1;--i) {
              k[i] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(T)),b[i]);
              k[i][n-1] = k[i][0];
          }
      } else {
          for(i=k.length-1;i!==-1;--i) {
              k[i] = numeric.cLUsolve(numeric.cLU(T),b[i]);
          }
      }
      if(typeof y[0] === "number") k = k[0];
      else k = numeric.transpose(k);
      return new numeric.Spline(x,y,y,k,k);
  };

  // 8. FFT
  numeric.fftpow2 = function fftpow2(x,y) {
      var n = x.length;
      if(n === 1) return;
      var cos = Math.cos, sin = Math.sin, i,j;
      var xe = Array(n/2), ye = Array(n/2), xo = Array(n/2), yo = Array(n/2);
      j = n/2;
      for(i=n-1;i!==-1;--i) {
          --j;
          xo[j] = x[i];
          yo[j] = y[i];
          --i;
          xe[j] = x[i];
          ye[j] = y[i];
      }
      fftpow2(xe,ye);
      fftpow2(xo,yo);
      j = n/2;
      var t,k = (-6.2831853071795864769252867665590057683943387987502116419/n),ci,si;
      for(i=n-1;i!==-1;--i) {
          --j;
          if(j === -1) j = n/2-1;
          t = k*i;
          ci = cos(t);
          si = sin(t);
          x[i] = xe[j] + ci*xo[j] - si*yo[j];
          y[i] = ye[j] + ci*yo[j] + si*xo[j];
      }
  };
  numeric._ifftpow2 = function _ifftpow2(x,y) {
      var n = x.length;
      if(n === 1) return;
      var cos = Math.cos, sin = Math.sin, i,j;
      var xe = Array(n/2), ye = Array(n/2), xo = Array(n/2), yo = Array(n/2);
      j = n/2;
      for(i=n-1;i!==-1;--i) {
          --j;
          xo[j] = x[i];
          yo[j] = y[i];
          --i;
          xe[j] = x[i];
          ye[j] = y[i];
      }
      _ifftpow2(xe,ye);
      _ifftpow2(xo,yo);
      j = n/2;
      var t,k = (6.2831853071795864769252867665590057683943387987502116419/n),ci,si;
      for(i=n-1;i!==-1;--i) {
          --j;
          if(j === -1) j = n/2-1;
          t = k*i;
          ci = cos(t);
          si = sin(t);
          x[i] = xe[j] + ci*xo[j] - si*yo[j];
          y[i] = ye[j] + ci*yo[j] + si*xo[j];
      }
  };
  numeric.ifftpow2 = function ifftpow2(x,y) {
      numeric._ifftpow2(x,y);
      numeric.diveq(x,x.length);
      numeric.diveq(y,y.length);
  };
  numeric.convpow2 = function convpow2(ax,ay,bx,by) {
      numeric.fftpow2(ax,ay);
      numeric.fftpow2(bx,by);
      var i,n = ax.length,axi,bxi,ayi,byi;
      for(i=n-1;i!==-1;--i) {
          axi = ax[i]; ayi = ay[i]; bxi = bx[i]; byi = by[i];
          ax[i] = axi*bxi-ayi*byi;
          ay[i] = axi*byi+ayi*bxi;
      }
      numeric.ifftpow2(ax,ay);
  };
  numeric.T.prototype.fft = function fft() {
      var x = this.x, y = this.y;
      var n = x.length, log = Math.log, log2 = log(2),
          p = Math.ceil(log(2*n-1)/log2), m = Math.pow(2,p);
      var cx = numeric.rep([m],0), cy = numeric.rep([m],0), cos = Math.cos, sin = Math.sin;
      var k, c = (-3.141592653589793238462643383279502884197169399375105820/n),t;
      var a = numeric.rep([m],0), b = numeric.rep([m],0);
      for(k=0;k<n;k++) a[k] = x[k];
      if(typeof y !== "undefined") for(k=0;k<n;k++) b[k] = y[k];
      cx[0] = 1;
      for(k=1;k<=m/2;k++) {
          t = c*k*k;
          cx[k] = cos(t);
          cy[k] = sin(t);
          cx[m-k] = cos(t);
          cy[m-k] = sin(t);
      }
      var X = new numeric.T(a,b), Y = new numeric.T(cx,cy);
      X = X.mul(Y);
      numeric.convpow2(X.x,X.y,numeric.clone(Y.x),numeric.neg(Y.y));
      X = X.mul(Y);
      X.x.length = n;
      X.y.length = n;
      return X;
  };
  numeric.T.prototype.ifft = function ifft() {
      var x = this.x, y = this.y;
      var n = x.length, log = Math.log, log2 = log(2),
          p = Math.ceil(log(2*n-1)/log2), m = Math.pow(2,p);
      var cx = numeric.rep([m],0), cy = numeric.rep([m],0), cos = Math.cos, sin = Math.sin;
      var k, c = (3.141592653589793238462643383279502884197169399375105820/n),t;
      var a = numeric.rep([m],0), b = numeric.rep([m],0);
      for(k=0;k<n;k++) a[k] = x[k];
      if(typeof y !== "undefined") for(k=0;k<n;k++) b[k] = y[k];
      cx[0] = 1;
      for(k=1;k<=m/2;k++) {
          t = c*k*k;
          cx[k] = cos(t);
          cy[k] = sin(t);
          cx[m-k] = cos(t);
          cy[m-k] = sin(t);
      }
      var X = new numeric.T(a,b), Y = new numeric.T(cx,cy);
      X = X.mul(Y);
      numeric.convpow2(X.x,X.y,numeric.clone(Y.x),numeric.neg(Y.y));
      X = X.mul(Y);
      X.x.length = n;
      X.y.length = n;
      return X.div(n);
  };

  //9. Unconstrained optimization
  numeric.gradient = function gradient(f,x) {
      var n = x.length;
      var f0 = f(x);
      if(isNaN(f0)) throw new Error('gradient: f(x) is a NaN!');
      var max = Math.max;
      var i,x0 = numeric.clone(x),f1,f2, J = Array(n);
      var div = numeric.div, sub = numeric.sub,errest,max = Math.max,eps = 1e-3,abs = Math.abs, min = Math.min;
      var t0,t1,t2,it=0,d1,d2,N;
      for(i=0;i<n;i++) {
          var h = max(1e-6*f0,1e-8);
          while(1) {
              ++it;
              if(it>20) { throw new Error("Numerical gradient fails"); }
              x0[i] = x[i]+h;
              f1 = f(x0);
              x0[i] = x[i]-h;
              f2 = f(x0);
              x0[i] = x[i];
              if(isNaN(f1) || isNaN(f2)) { h/=16; continue; }
              J[i] = (f1-f2)/(2*h);
              t0 = x[i]-h;
              t1 = x[i];
              t2 = x[i]+h;
              d1 = (f1-f0)/h;
              d2 = (f0-f2)/h;
              N = max(abs(J[i]),abs(f0),abs(f1),abs(f2),abs(t0),abs(t1),abs(t2),1e-8);
              errest = min(max(abs(d1-J[i]),abs(d2-J[i]),abs(d1-d2))/N,h/N);
              if(errest>eps) { h/=16; }
              else break;
              }
      }
      return J;
  };

  numeric.uncmin = function uncmin(f,x0,tol,gradient,maxit,callback,options) {
      var grad = numeric.gradient;
      if(typeof options === "undefined") { options = {}; }
      if(typeof tol === "undefined") { tol = 1e-8; }
      if(typeof gradient === "undefined") { gradient = function(x) { return grad(f,x); }; }
      if(typeof maxit === "undefined") maxit = 1000;
      x0 = numeric.clone(x0);
      var n = x0.length;
      var f0 = f(x0),f1,df0;
      if(isNaN(f0)) throw new Error('uncmin: f(x0) is a NaN!');
      var max = Math.max, norm2 = numeric.norm2;
      tol = max(tol,numeric.epsilon);
      var step,g0,g1,H1 = options.Hinv || numeric.identity(n);
      var dot = numeric.dot, inv = numeric.inv, sub = numeric.sub, add = numeric.add, ten = numeric.tensor, div = numeric.div, mul = numeric.mul;
      var all = numeric.all, isfinite = numeric.isFinite, neg = numeric.neg;
      var it=0,s,x1,y,Hy,ys,t,nstep;
      var msg = "";
      g0 = gradient(x0);
      while(it<maxit) {
          if(typeof callback === "function") { if(callback(it,x0,f0,g0,H1)) { msg = "Callback returned true"; break; } }
          if(!all(isfinite(g0))) { msg = "Gradient has Infinity or NaN"; break; }
          step = neg(dot(H1,g0));
          if(!all(isfinite(step))) { msg = "Search direction has Infinity or NaN"; break; }
          nstep = norm2(step);
          if(nstep < tol) { msg="Newton step smaller than tol"; break; }
          t = 1;
          df0 = dot(g0,step);
          // line search
          x1 = x0;
          while(it < maxit) {
              if(t*nstep < tol) { break; }
              s = mul(step,t);
              x1 = add(x0,s);
              f1 = f(x1);
              if(f1-f0 >= 0.1*t*df0 || isNaN(f1)) {
                  t *= 0.5;
                  ++it;
                  continue;
              }
              break;
          }
          if(t*nstep < tol) { msg = "Line search step size smaller than tol"; break; }
          if(it === maxit) { msg = "maxit reached during line search"; break; }
          g1 = gradient(x1);
          y = sub(g1,g0);
          ys = dot(y,s);
          Hy = dot(H1,y);
          H1 = sub(add(H1,
                  mul(
                          (ys+dot(y,Hy))/(ys*ys),
                          ten(s,s)    )),
                  div(add(ten(Hy,s),ten(s,Hy)),ys));
          x0 = x1;
          f0 = f1;
          g0 = g1;
          ++it;
      }
      return {solution: x0, f: f0, gradient: g0, invHessian: H1, iterations:it, message: msg};
  };

  // 10. Ode solver (Dormand-Prince)
  numeric.Dopri = function Dopri(x,y,f,ymid,iterations,msg,events) {
      this.x = x;
      this.y = y;
      this.f = f;
      this.ymid = ymid;
      this.iterations = iterations;
      this.events = events;
      this.message = msg;
  };
  numeric.Dopri.prototype._at = function _at(xi,j) {
      function sqr(x) { return x*x; }
      var sol = this;
      var xs = sol.x;
      var ys = sol.y;
      var k1 = sol.f;
      var ymid = sol.ymid;
      var n = xs.length;
      var x0,x1,xh,y0,y1,yh,xi;
      var h;
      var c = 0.5;
      var add = numeric.add, mul = numeric.mul,sub = numeric.sub, p,q,w;
      x0 = xs[j];
      x1 = xs[j+1];
      y0 = ys[j];
      y1 = ys[j+1];
      h  = x1-x0;
      xh = x0+c*h;
      yh = ymid[j];
      p = sub(k1[j  ],mul(y0,1/(x0-xh)+2/(x0-x1)));
      q = sub(k1[j+1],mul(y1,1/(x1-xh)+2/(x1-x0)));
      w = [sqr(xi - x1) * (xi - xh) / sqr(x0 - x1) / (x0 - xh),
           sqr(xi - x0) * sqr(xi - x1) / sqr(x0 - xh) / sqr(x1 - xh),
           sqr(xi - x0) * (xi - xh) / sqr(x1 - x0) / (x1 - xh),
           (xi - x0) * sqr(xi - x1) * (xi - xh) / sqr(x0-x1) / (x0 - xh),
           (xi - x1) * sqr(xi - x0) * (xi - xh) / sqr(x0-x1) / (x1 - xh)];
      return add(add(add(add(mul(y0,w[0]),
                             mul(yh,w[1])),
                             mul(y1,w[2])),
                             mul( p,w[3])),
                             mul( q,w[4]));
  };
  numeric.Dopri.prototype.at = function at(x) {
      var i,j,k,floor = Math.floor;
      if(typeof x !== "number") {
          var n = x.length, ret = Array(n);
          for(i=n-1;i!==-1;--i) {
              ret[i] = this.at(x[i]);
          }
          return ret;
      }
      var x0 = this.x;
      i = 0; j = x0.length-1;
      while(j-i>1) {
          k = floor(0.5*(i+j));
          if(x0[k] <= x) i = k;
          else j = k;
      }
      return this._at(x,i);
  };

  numeric.dopri = function dopri(x0,x1,y0,f,tol,maxit,event) {
      if(typeof tol === "undefined") { tol = 1e-6; }
      if(typeof maxit === "undefined") { maxit = 1000; }
      var xs = [x0], ys = [y0], k1 = [f(x0,y0)], k2,k3,k4,k5,k6,k7, ymid = [];
      var A2 = 1/5;
      var A3 = [3/40,9/40];
      var A4 = [44/45,-56/15,32/9];
      var A5 = [19372/6561,-25360/2187,64448/6561,-212/729];
      var A6 = [9017/3168,-355/33,46732/5247,49/176,-5103/18656];
      var b = [35/384,0,500/1113,125/192,-2187/6784,11/84];
      var bm = [0.5*6025192743/30085553152,
                0,
                0.5*51252292925/65400821598,
                0.5*-2691868925/45128329728,
                0.5*187940372067/1594534317056,
                0.5*-1776094331/19743644256,
                0.5*11237099/235043384];
      var c = [1/5,3/10,4/5,8/9,1,1];
      var e = [-71/57600,0,71/16695,-71/1920,17253/339200,-22/525,1/40];
      var i = 0,er,j;
      var h = (x1-x0)/10;
      var it = 0;
      var add = numeric.add, mul = numeric.mul, y1,erinf;
      var min = Math.min, abs = Math.abs, norminf = numeric.norminf,pow = Math.pow;
      var any = numeric.any, lt = numeric.lt, and = numeric.and, sub = numeric.sub;
      var e0, e1, ev;
      var ret = new numeric.Dopri(xs,ys,k1,ymid,-1,"");
      if(typeof event === "function") e0 = event(x0,y0);
      while(x0<x1 && it<maxit) {
          ++it;
          if(x0+h>x1) h = x1-x0;
          k2 = f(x0+c[0]*h,                add(y0,mul(   A2*h,k1[i])));
          k3 = f(x0+c[1]*h,            add(add(y0,mul(A3[0]*h,k1[i])),mul(A3[1]*h,k2)));
          k4 = f(x0+c[2]*h,        add(add(add(y0,mul(A4[0]*h,k1[i])),mul(A4[1]*h,k2)),mul(A4[2]*h,k3)));
          k5 = f(x0+c[3]*h,    add(add(add(add(y0,mul(A5[0]*h,k1[i])),mul(A5[1]*h,k2)),mul(A5[2]*h,k3)),mul(A5[3]*h,k4)));
          k6 = f(x0+c[4]*h,add(add(add(add(add(y0,mul(A6[0]*h,k1[i])),mul(A6[1]*h,k2)),mul(A6[2]*h,k3)),mul(A6[3]*h,k4)),mul(A6[4]*h,k5)));
          y1 = add(add(add(add(add(y0,mul(k1[i],h*b[0])),mul(k3,h*b[2])),mul(k4,h*b[3])),mul(k5,h*b[4])),mul(k6,h*b[5]));
          k7 = f(x0+h,y1);
          er = add(add(add(add(add(mul(k1[i],h*e[0]),mul(k3,h*e[2])),mul(k4,h*e[3])),mul(k5,h*e[4])),mul(k6,h*e[5])),mul(k7,h*e[6]));
          if(typeof er === "number") erinf = abs(er);
          else erinf = norminf(er);
          if(erinf > tol) { // reject
              h = 0.2*h*pow(tol/erinf,0.25);
              if(x0+h === x0) {
                  ret.msg = "Step size became too small";
                  break;
              }
              continue;
          }
          ymid[i] = add(add(add(add(add(add(y0,
                  mul(k1[i],h*bm[0])),
                  mul(k3   ,h*bm[2])),
                  mul(k4   ,h*bm[3])),
                  mul(k5   ,h*bm[4])),
                  mul(k6   ,h*bm[5])),
                  mul(k7   ,h*bm[6]));
          ++i;
          xs[i] = x0+h;
          ys[i] = y1;
          k1[i] = k7;
          if(typeof event === "function") {
              var yi,xl = x0,xr = x0+0.5*h,xi;
              e1 = event(xr,ymid[i-1]);
              ev = and(lt(e0,0),lt(0,e1));
              if(!any(ev)) { xl = xr; xr = x0+h; e0 = e1; e1 = event(xr,y1); ev = and(lt(e0,0),lt(0,e1)); }
              if(any(ev)) {
                  var en,ei;
                  var side=0, sl = 1.0, sr = 1.0;
                  while(1) {
                      if(typeof e0 === "number") xi = (sr*e1*xl-sl*e0*xr)/(sr*e1-sl*e0);
                      else {
                          xi = xr;
                          for(j=e0.length-1;j!==-1;--j) {
                              if(e0[j]<0 && e1[j]>0) xi = min(xi,(sr*e1[j]*xl-sl*e0[j]*xr)/(sr*e1[j]-sl*e0[j]));
                          }
                      }
                      if(xi <= xl || xi >= xr) break;
                      yi = ret._at(xi, i-1);
                      ei = event(xi,yi);
                      en = and(lt(e0,0),lt(0,ei));
                      if(any(en)) {
                          xr = xi;
                          e1 = ei;
                          ev = en;
                          sr = 1.0;
                          if(side === -1) sl *= 0.5;
                          else sl = 1.0;
                          side = -1;
                      } else {
                          xl = xi;
                          e0 = ei;
                          sl = 1.0;
                          if(side === 1) sr *= 0.5;
                          else sr = 1.0;
                          side = 1;
                      }
                  }
                  y1 = ret._at(0.5*(x0+xi),i-1);
                  ret.f[i] = f(xi,yi);
                  ret.x[i] = xi;
                  ret.y[i] = yi;
                  ret.ymid[i-1] = y1;
                  ret.events = ev;
                  ret.iterations = it;
                  return ret;
              }
          }
          x0 += h;
          y0 = y1;
          e0 = e1;
          h = min(0.8*h*pow(tol/erinf,0.25),4*h);
      }
      ret.iterations = it;
      return ret;
  };

  // 11. Ax = b
  numeric.LU = function(A, fast) {
    fast = fast || false;

    var abs = Math.abs;
    var i, j, k, absAjk, Akk, Ak, Pk, Ai;
    var max;
    var n = A.length, n1 = n-1;
    var P = new Array(n);
    if(!fast) A = numeric.clone(A);

    for (k = 0; k < n; ++k) {
      Pk = k;
      Ak = A[k];
      max = abs(Ak[k]);
      for (j = k + 1; j < n; ++j) {
        absAjk = abs(A[j][k]);
        if (max < absAjk) {
          max = absAjk;
          Pk = j;
        }
      }
      P[k] = Pk;

      if (Pk != k) {
        A[k] = A[Pk];
        A[Pk] = Ak;
        Ak = A[k];
      }

      Akk = Ak[k];

      for (i = k + 1; i < n; ++i) {
        A[i][k] /= Akk;
      }

      for (i = k + 1; i < n; ++i) {
        Ai = A[i];
        for (j = k + 1; j < n1; ++j) {
          Ai[j] -= Ai[k] * Ak[j];
          ++j;
          Ai[j] -= Ai[k] * Ak[j];
        }
        if(j===n1) Ai[j] -= Ai[k] * Ak[j];
      }
    }

    return {
      LU: A,
      P:  P
    };
  };

  numeric.LUsolve = function LUsolve(LUP, b) {
    var i, j;
    var LU = LUP.LU;
    var n   = LU.length;
    var x = numeric.clone(b);
    var P   = LUP.P;
    var Pi, LUi, tmp;

    for (i=n-1;i!==-1;--i) x[i] = b[i];
    for (i = 0; i < n; ++i) {
      Pi = P[i];
      if (P[i] !== i) {
        tmp = x[i];
        x[i] = x[Pi];
        x[Pi] = tmp;
      }

      LUi = LU[i];
      for (j = 0; j < i; ++j) {
        x[i] -= x[j] * LUi[j];
      }
    }

    for (i = n - 1; i >= 0; --i) {
      LUi = LU[i];
      for (j = i + 1; j < n; ++j) {
        x[i] -= x[j] * LUi[j];
      }

      x[i] /= LUi[i];
    }

    return x;
  };

  numeric.solve = function solve(A,b,fast) { return numeric.LUsolve(numeric.LU(A,fast), b); };

  // 12. Linear programming
  numeric.echelonize = function echelonize(A) {
      var s = numeric.dim(A), m = s[0], n = s[1];
      var I = numeric.identity(m);
      var P = Array(m);
      var i,j,k,l,Ai,Ii,Z,a;
      var abs = Math.abs;
      var diveq = numeric.diveq;
      A = numeric.clone(A);
      for(i=0;i<m;++i) {
          k = 0;
          Ai = A[i];
          Ii = I[i];
          for(j=1;j<n;++j) if(abs(Ai[k])<abs(Ai[j])) k=j;
          P[i] = k;
          diveq(Ii,Ai[k]);
          diveq(Ai,Ai[k]);
          for(j=0;j<m;++j) if(j!==i) {
              Z = A[j]; a = Z[k];
              for(l=n-1;l!==-1;--l) Z[l] -= Ai[l]*a;
              Z = I[j];
              for(l=m-1;l!==-1;--l) Z[l] -= Ii[l]*a;
          }
      }
      return {I:I, A:A, P:P};
  };

  numeric.__solveLP = function __solveLP(c,A,b,tol,maxit,x,flag) {
      var sum = numeric.sum, log = numeric.log, mul = numeric.mul, sub = numeric.sub, dot = numeric.dot, div = numeric.div, add = numeric.add;
      var m = c.length, n = b.length,y;
      var unbounded = false, i0=0;
      var alpha = 1.0;
      var AT = numeric.transpose(A), svd = numeric.svd,transpose = numeric.transpose,leq = numeric.leq, sqrt = Math.sqrt, abs = Math.abs;
      var muleq = numeric.muleq;
      var norm = numeric.norminf, any = numeric.any,min = Math.min;
      var all = numeric.all, gt = numeric.gt;
      var p = Array(m), A0 = Array(n),e=numeric.rep([n],1), H;
      var solve = numeric.solve, z = sub(b,dot(A,x)),count;
      var dotcc = dot(c,c);
      var g;
      for(count=i0;count<maxit;++count) {
          var i,d;
          for(i=n-1;i!==-1;--i) A0[i] = div(A[i],z[i]);
          var A1 = transpose(A0);
          for(i=m-1;i!==-1;--i) p[i] = (/*x[i]+*/sum(A1[i]));
          alpha = 0.25*abs(dotcc/dot(c,p));
          var a1 = 100*sqrt(dotcc/dot(p,p));
          if(!isFinite(alpha) || alpha>a1) alpha = a1;
          g = add(c,mul(alpha,p));
          H = dot(A1,A0);
          for(i=m-1;i!==-1;--i) H[i][i] += 1;
          d = solve(H,div(g,alpha),true);
          var t0 = div(z,dot(A,d));
          var t = 1.0;
          for(i=n-1;i!==-1;--i) if(t0[i]<0) t = min(t,-0.999*t0[i]);
          y = sub(x,mul(d,t));
          z = sub(b,dot(A,y));
          if(!all(gt(z,0))) return { solution: x, message: "", iterations: count };
          x = y;
          if(alpha<tol) return { solution: y, message: "", iterations: count };
          if(flag) {
              var s = dot(c,g), Ag = dot(A,g);
              unbounded = true;
              for(i=n-1;i!==-1;--i) if(s*Ag[i]<0) { unbounded = false; break; }
          } else {
              if(x[m-1]>=0) unbounded = false;
              else unbounded = true;
          }
          if(unbounded) return { solution: y, message: "Unbounded", iterations: count };
      }
      return { solution: x, message: "maximum iteration count exceeded", iterations:count };
  };

  numeric._solveLP = function _solveLP(c,A,b,tol,maxit) {
      var m = c.length, n = b.length,y;
      var sum = numeric.sum, log = numeric.log, mul = numeric.mul, sub = numeric.sub, dot = numeric.dot, div = numeric.div, add = numeric.add;
      var c0 = numeric.rep([m],0).concat([1]);
      var J = numeric.rep([n,1],-1);
      var A0 = numeric.blockMatrix([[A                   ,   J  ]]);
      var b0 = b;
      var y = numeric.rep([m],0).concat(Math.max(0,numeric.sup(numeric.neg(b)))+1);
      var x0 = numeric.__solveLP(c0,A0,b0,tol,maxit,y,false);
      var x = numeric.clone(x0.solution);
      x.length = m;
      var foo = numeric.inf(sub(b,dot(A,x)));
      if(foo<0) { return { solution: NaN, message: "Infeasible", iterations: x0.iterations }; }
      var ret = numeric.__solveLP(c, A, b, tol, maxit-x0.iterations, x, true);
      ret.iterations += x0.iterations;
      return ret;
  };

  numeric.solveLP = function solveLP(c,A,b,Aeq,beq,tol,maxit) {
      if(typeof maxit === "undefined") maxit = 1000;
      if(typeof tol === "undefined") tol = numeric.epsilon;
      if(typeof Aeq === "undefined") return numeric._solveLP(c,A,b,tol,maxit);
      var m = Aeq.length, n = Aeq[0].length, o = A.length;
      var B = numeric.echelonize(Aeq);
      var flags = numeric.rep([n],0);
      var P = B.P;
      var Q = [];
      var i;
      for(i=P.length-1;i!==-1;--i) flags[P[i]] = 1;
      for(i=n-1;i!==-1;--i) if(flags[i]===0) Q.push(i);
      var g = numeric.getRange;
      var I = numeric.linspace(0,m-1), J = numeric.linspace(0,o-1);
      var Aeq2 = g(Aeq,I,Q), A1 = g(A,J,P), A2 = g(A,J,Q), dot = numeric.dot, sub = numeric.sub;
      var A3 = dot(A1,B.I);
      var A4 = sub(A2,dot(A3,Aeq2)), b4 = sub(b,dot(A3,beq));
      var c1 = Array(P.length), c2 = Array(Q.length);
      for(i=P.length-1;i!==-1;--i) c1[i] = c[P[i]];
      for(i=Q.length-1;i!==-1;--i) c2[i] = c[Q[i]];
      var c4 = sub(c2,dot(c1,dot(B.I,Aeq2)));
      var S = numeric._solveLP(c4,A4,b4,tol,maxit);
      var x2 = S.solution;
      if(x2!==x2) return S;
      var x1 = dot(B.I,sub(beq,dot(Aeq2,x2)));
      var x = Array(c.length);
      for(i=P.length-1;i!==-1;--i) x[P[i]] = x1[i];
      for(i=Q.length-1;i!==-1;--i) x[Q[i]] = x2[i];
      return { solution: x, message:S.message, iterations: S.iterations };
  };

  numeric.MPStoLP = function MPStoLP(MPS) {
      if(MPS instanceof String) { MPS.split('\n'); }
      var state = 0;
      var states = ['Initial state','NAME','ROWS','COLUMNS','RHS','BOUNDS','ENDATA'];
      var n = MPS.length;
      var i,j,z,N=0,rows = {}, sign = [], rl = 0, vars = {}, nv = 0;
      var name;
      var c = [], A = [], b = [];
      function err(e) { throw new Error('MPStoLP: '+e+'\nLine '+i+': '+MPS[i]+'\nCurrent state: '+states[state]+'\n'); }
      for(i=0;i<n;++i) {
          z = MPS[i];
          var w0 = z.match(/\S*/g);
          var w = [];
          for(j=0;j<w0.length;++j) if(w0[j]!=="") w.push(w0[j]);
          if(w.length === 0) continue;
          for(j=0;j<states.length;++j) if(z.substr(0,states[j].length) === states[j]) break;
          if(j<states.length) {
              state = j;
              if(j===1) { name = w[1]; }
              if(j===6) return { name:name, c:c, A:numeric.transpose(A), b:b, rows:rows, vars:vars };
              continue;
          }
          switch(state) {
          case 0: case 1: err('Unexpected line');
          case 2: 
              switch(w[0]) {
              case 'N': if(N===0) N = w[1]; else err('Two or more N rows'); break;
              case 'L': rows[w[1]] = rl; sign[rl] = 1; b[rl] = 0; ++rl; break;
              case 'G': rows[w[1]] = rl; sign[rl] = -1;b[rl] = 0; ++rl; break;
              case 'E': rows[w[1]] = rl; sign[rl] = 0;b[rl] = 0; ++rl; break;
              default: err('Parse error '+numeric.prettyPrint(w));
              }
              break;
          case 3:
              if(!vars.hasOwnProperty(w[0])) { vars[w[0]] = nv; c[nv] = 0; A[nv] = numeric.rep([rl],0); ++nv; }
              var p = vars[w[0]];
              for(j=1;j<w.length;j+=2) {
                  if(w[j] === N) { c[p] = parseFloat(w[j+1]); continue; }
                  var q = rows[w[j]];
                  A[p][q] = (sign[q]<0?-1:1)*parseFloat(w[j+1]);
              }
              break;
          case 4:
              for(j=1;j<w.length;j+=2) b[rows[w[j]]] = (sign[rows[w[j]]]<0?-1:1)*parseFloat(w[j+1]);
              break;
          case 5: /*FIXME*/ break;
          case 6: err('Internal error');
          }
      }
      err('Reached end of file without ENDATA');
  };
  // seedrandom.js version 2.0.
  // Author: David Bau 4/2/2011
  //
  // Defines a method Math.seedrandom() that, when called, substitutes
  // an explicitly seeded RC4-based algorithm for Math.random().  Also
  // supports automatic seeding from local or network sources of entropy.
  //
  // Usage:
  //
  //   <script src=http://davidbau.com/encode/seedrandom-min.js></script>
  //
  //   Math.seedrandom('yipee'); Sets Math.random to a function that is
  //                             initialized using the given explicit seed.
  //
  //   Math.seedrandom();        Sets Math.random to a function that is
  //                             seeded using the current time, dom state,
  //                             and other accumulated local entropy.
  //                             The generated seed string is returned.
  //
  //   Math.seedrandom('yowza', true);
  //                             Seeds using the given explicit seed mixed
  //                             together with accumulated entropy.
  //
  //   <script src="http://bit.ly/srandom-512"></script>
  //                             Seeds using physical random bits downloaded
  //                             from random.org.
  //
  //   <script src="https://jsonlib.appspot.com/urandom?callback=Math.seedrandom">
  //   </script>                 Seeds using urandom bits from call.jsonlib.com,
  //                             which is faster than random.org.
  //
  // Examples:
  //
  //   Math.seedrandom("hello");            // Use "hello" as the seed.
  //   document.write(Math.random());       // Always 0.5463663768140734
  //   document.write(Math.random());       // Always 0.43973793770592234
  //   var rng1 = Math.random;              // Remember the current prng.
  //
  //   var autoseed = Math.seedrandom();    // New prng with an automatic seed.
  //   document.write(Math.random());       // Pretty much unpredictable.
  //
  //   Math.random = rng1;                  // Continue "hello" prng sequence.
  //   document.write(Math.random());       // Always 0.554769432473455
  //
  //   Math.seedrandom(autoseed);           // Restart at the previous seed.
  //   document.write(Math.random());       // Repeat the 'unpredictable' value.
  //
  // Notes:
  //
  // Each time seedrandom('arg') is called, entropy from the passed seed
  // is accumulated in a pool to help generate future seeds for the
  // zero-argument form of Math.seedrandom, so entropy can be injected over
  // time by calling seedrandom with explicit data repeatedly.
  //
  // On speed - This javascript implementation of Math.random() is about
  // 3-10x slower than the built-in Math.random() because it is not native
  // code, but this is typically fast enough anyway.  Seeding is more expensive,
  // especially if you use auto-seeding.  Some details (timings on Chrome 4):
  //
  // Our Math.random()            - avg less than 0.002 milliseconds per call
  // seedrandom('explicit')       - avg less than 0.5 milliseconds per call
  // seedrandom('explicit', true) - avg less than 2 milliseconds per call
  // seedrandom()                 - avg about 38 milliseconds per call
  //
  // LICENSE (BSD):
  //
  // Copyright 2010 David Bau, all rights reserved.
  //
  // Redistribution and use in source and binary forms, with or without
  // modification, are permitted provided that the following conditions are met:
  // 
  //   1. Redistributions of source code must retain the above copyright
  //      notice, this list of conditions and the following disclaimer.
  //
  //   2. Redistributions in binary form must reproduce the above copyright
  //      notice, this list of conditions and the following disclaimer in the
  //      documentation and/or other materials provided with the distribution.
  // 
  //   3. Neither the name of this module nor the names of its contributors may
  //      be used to endorse or promote products derived from this software
  //      without specific prior written permission.
  // 
  // THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
  // "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
  // LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
  // A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
  // OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
  // SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
  // LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
  // DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
  // THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  // (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
  // OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  //
  /**
   * All code is in an anonymous closure to keep the global namespace clean.
   *
   * @param {number=} overflow 
   * @param {number=} startdenom
   */

  // Patched by Seb so that seedrandom.js does not pollute the Math object.
  // My tests suggest that doing Math.trouble = 1 makes Math lookups about 5%
  // slower.
  numeric.seedrandom = { pow:Math.pow, random:Math.random };

  (function (pool, math, width, chunks, significance, overflow, startdenom) {


  //
  // seedrandom()
  // This is the seedrandom function described above.
  //
  math['seedrandom'] = function seedrandom(seed, use_entropy) {
    var key = [];
    var arc4;

    // Flatten the seed string or build one from local entropy if needed.
    seed = mixkey(flatten(
      use_entropy ? [seed, pool] :
      arguments.length ? seed :
      [new Date().getTime(), pool, window], 3), key);

    // Use the seed to initialize an ARC4 generator.
    arc4 = new ARC4(key);

    // Mix the randomness into accumulated entropy.
    mixkey(arc4.S, pool);

    // Override Math.random

    // This function returns a random double in [0, 1) that contains
    // randomness in every bit of the mantissa of the IEEE 754 value.

    math['random'] = function random() {  // Closure to return a random double:
      var n = arc4.g(chunks);             // Start with a numerator n < 2 ^ 48
      var d = startdenom;                 //   and denominator d = 2 ^ 48.
      var x = 0;                          //   and no 'extra last byte'.
      while (n < significance) {          // Fill up all significant digits by
        n = (n + x) * width;              //   shifting numerator and
        d *= width;                       //   denominator and generating a
        x = arc4.g(1);                    //   new least-significant-byte.
      }
      while (n >= overflow) {             // To avoid rounding up, before adding
        n /= 2;                           //   last byte, shift everything
        d /= 2;                           //   right using integer math until
        x >>>= 1;                         //   we have exactly the desired bits.
      }
      return (n + x) / d;                 // Form the number within [0, 1).
    };

    // Return the seed that was used
    return seed;
  };

  //
  // ARC4
  //
  // An ARC4 implementation.  The constructor takes a key in the form of
  // an array of at most (width) integers that should be 0 <= x < (width).
  //
  // The g(count) method returns a pseudorandom integer that concatenates
  // the next (count) outputs from ARC4.  Its return value is a number x
  // that is in the range 0 <= x < (width ^ count).
  //
  /** @constructor */
  function ARC4(key) {
    var t, u, me = this, keylen = key.length;
    var i = 0, j = me.i = me.j = me.m = 0;
    me.S = [];
    me.c = [];

    // The empty key [] is treated as [0].
    if (!keylen) { key = [keylen++]; }

    // Set up S using the standard key scheduling algorithm.
    while (i < width) { me.S[i] = i++; }
    for (i = 0; i < width; i++) {
      t = me.S[i];
      j = lowbits(j + t + key[i % keylen]);
      u = me.S[j];
      me.S[i] = u;
      me.S[j] = t;
    }

    // The "g" method returns the next (count) outputs as one number.
    me.g = function getnext(count) {
      var s = me.S;
      var i = lowbits(me.i + 1); var t = s[i];
      var j = lowbits(me.j + t); var u = s[j];
      s[i] = u;
      s[j] = t;
      var r = s[lowbits(t + u)];
      while (--count) {
        i = lowbits(i + 1); t = s[i];
        j = lowbits(j + t); u = s[j];
        s[i] = u;
        s[j] = t;
        r = r * width + s[lowbits(t + u)];
      }
      me.i = i;
      me.j = j;
      return r;
    };
    // For robust unpredictability discard an initial batch of values.
    // See http://www.rsa.com/rsalabs/node.asp?id=2009
    me.g(width);
  }

  //
  // flatten()
  // Converts an object tree to nested arrays of strings.
  //
  /** @param {Object=} result 
    * @param {string=} prop
    * @param {string=} typ */
  function flatten(obj, depth, result, prop, typ) {
    result = [];
    typ = typeof(obj);
    if (depth && typ == 'object') {
      for (prop in obj) {
        if (prop.indexOf('S') < 5) {    // Avoid FF3 bug (local/sessionStorage)
          try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
        }
      }
    }
    return (result.length ? result : obj + (typ != 'string' ? '\0' : ''));
  }

  //
  // mixkey()
  // Mixes a string seed into a key that is an array of integers, and
  // returns a shortened string seed that is equivalent to the result key.
  //
  /** @param {number=} smear 
    * @param {number=} j */
  function mixkey(seed, key, smear, j) {
    seed += '';                         // Ensure the seed is a string
    smear = 0;
    for (j = 0; j < seed.length; j++) {
      key[lowbits(j)] =
        lowbits((smear ^= key[lowbits(j)] * 19) + seed.charCodeAt(j));
    }
    seed = '';
    for (j in key) { seed += String.fromCharCode(key[j]); }
    return seed;
  }

  //
  // lowbits()
  // A quick "n mod width" for width a power of 2.
  //
  function lowbits(n) { return n & (width - 1); }

  //
  // The following constants are related to IEEE 754 limits.
  //
  startdenom = math.pow(width, chunks);
  significance = math.pow(2, significance);
  overflow = significance * 2;

  //
  // When seedrandom.js is loaded, we immediately mix a few bits
  // from the built-in RNG into the entropy pool.  Because we do
  // not want to intefere with determinstic PRNG state later,
  // seedrandom will not call math.random on its own again after
  // initialization.
  //
  mixkey(math.random(), pool);

  // End anonymous scope, and pass initial values.
  }(
    [],   // pool: entropy pool starts empty
    numeric.seedrandom, // math: package containing random, pow, and seedrandom
    256,  // width: each RC4 output is 0 <= x < 256
    6,    // chunks: at least six RC4 outputs for each double
    52    // significance: there are 52 significant digits in a double
    ));
  /* This file is a slightly modified version of quadprog.js from Alberto Santini.
   * It has been slightly modified by Sébastien Loisel to make sure that it handles
   * 0-based Arrays instead of 1-based Arrays.
   * License is in resources/LICENSE.quadprog */
  (function(exports) {

  function base0to1(A) {
      if(typeof A !== "object") { return A; }
      var ret = [], i,n=A.length;
      for(i=0;i<n;i++) ret[i+1] = base0to1(A[i]);
      return ret;
  }
  function base1to0(A) {
      if(typeof A !== "object") { return A; }
      var ret = [], i,n=A.length;
      for(i=1;i<n;i++) ret[i-1] = base1to0(A[i]);
      return ret;
  }

  function dpori(a, lda, n) {
      var i, j, k, kp1, t;

      for (k = 1; k <= n; k = k + 1) {
          a[k][k] = 1 / a[k][k];
          t = -a[k][k];
          //~ dscal(k - 1, t, a[1][k], 1);
          for (i = 1; i < k; i = i + 1) {
              a[i][k] = t * a[i][k];
          }

          kp1 = k + 1;
          if (n < kp1) {
              break;
          }
          for (j = kp1; j <= n; j = j + 1) {
              t = a[k][j];
              a[k][j] = 0;
              //~ daxpy(k, t, a[1][k], 1, a[1][j], 1);
              for (i = 1; i <= k; i = i + 1) {
                  a[i][j] = a[i][j] + (t * a[i][k]);
              }
          }
      }

  }

  function dposl(a, lda, n, b) {
      var i, k, kb, t;

      for (k = 1; k <= n; k = k + 1) {
          //~ t = ddot(k - 1, a[1][k], 1, b[1], 1);
          t = 0;
          for (i = 1; i < k; i = i + 1) {
              t = t + (a[i][k] * b[i]);
          }

          b[k] = (b[k] - t) / a[k][k];
      }

      for (kb = 1; kb <= n; kb = kb + 1) {
          k = n + 1 - kb;
          b[k] = b[k] / a[k][k];
          t = -b[k];
          //~ daxpy(k - 1, t, a[1][k], 1, b[1], 1);
          for (i = 1; i < k; i = i + 1) {
              b[i] = b[i] + (t * a[i][k]);
          }
      }
  }

  function dpofa(a, lda, n, info) {
      var i, j, jm1, k, t, s;

      for (j = 1; j <= n; j = j + 1) {
          info[1] = j;
          s = 0;
          jm1 = j - 1;
          if (jm1 < 1) {
              s = a[j][j] - s;
              if (s <= 0) {
                  break;
              }
              a[j][j] = Math.sqrt(s);
          } else {
              for (k = 1; k <= jm1; k = k + 1) {
                  //~ t = a[k][j] - ddot(k - 1, a[1][k], 1, a[1][j], 1);
                  t = a[k][j];
                  for (i = 1; i < k; i = i + 1) {
                      t = t - (a[i][j] * a[i][k]);
                  }
                  t = t / a[k][k];
                  a[k][j] = t;
                  s = s + t * t;
              }
              s = a[j][j] - s;
              if (s <= 0) {
                  break;
              }
              a[j][j] = Math.sqrt(s);
          }
          info[1] = 0;
      }
  }

  function qpgen2(dmat, dvec, fddmat, n, sol, crval, amat,
      bvec, fdamat, q, meq, iact, nact, iter, work, ierr) {

      var i, j, l, l1, info, it1, iwzv, iwrv, iwrm, iwsv, iwuv, nvl, r, iwnbv,
          temp, sum, t1, tt, gc, gs, nu,
          t1inf, t2min,
          vsmall, tmpa, tmpb,
          go;

      r = Math.min(n, q);
      l = 2 * n + (r * (r + 5)) / 2 + 2 * q + 1;

      vsmall = 1.0e-60;
      do {
          vsmall = vsmall + vsmall;
          tmpa = 1 + 0.1 * vsmall;
          tmpb = 1 + 0.2 * vsmall;
      } while (tmpa <= 1 || tmpb <= 1);

      for (i = 1; i <= n; i = i + 1) {
          work[i] = dvec[i];
      }
      for (i = n + 1; i <= l; i = i + 1) {
          work[i] = 0;
      }
      for (i = 1; i <= q; i = i + 1) {
          iact[i] = 0;
      }

      info = [];

      if (ierr[1] === 0) {
          dpofa(dmat, fddmat, n, info);
          if (info[1] !== 0) {
              ierr[1] = 2;
              return;
          }
          dposl(dmat, fddmat, n, dvec);
          dpori(dmat, fddmat, n);
      } else {
          for (j = 1; j <= n; j = j + 1) {
              sol[j] = 0;
              for (i = 1; i <= j; i = i + 1) {
                  sol[j] = sol[j] + dmat[i][j] * dvec[i];
              }
          }
          for (j = 1; j <= n; j = j + 1) {
              dvec[j] = 0;
              for (i = j; i <= n; i = i + 1) {
                  dvec[j] = dvec[j] + dmat[j][i] * sol[i];
              }
          }
      }

      crval[1] = 0;
      for (j = 1; j <= n; j = j + 1) {
          sol[j] = dvec[j];
          crval[1] = crval[1] + work[j] * sol[j];
          work[j] = 0;
          for (i = j + 1; i <= n; i = i + 1) {
              dmat[i][j] = 0;
          }
      }
      crval[1] = -crval[1] / 2;
      ierr[1] = 0;

      iwzv = n;
      iwrv = iwzv + n;
      iwuv = iwrv + r;
      iwrm = iwuv + r + 1;
      iwsv = iwrm + (r * (r + 1)) / 2;
      iwnbv = iwsv + q;

      for (i = 1; i <= q; i = i + 1) {
          sum = 0;
          for (j = 1; j <= n; j = j + 1) {
              sum = sum + amat[j][i] * amat[j][i];
          }
          work[iwnbv + i] = Math.sqrt(sum);
      }
      nact = 0;
      iter[1] = 0;
      iter[2] = 0;

      function fn_goto_50() {
          iter[1] = iter[1] + 1;

          l = iwsv;
          for (i = 1; i <= q; i = i + 1) {
              l = l + 1;
              sum = -bvec[i];
              for (j = 1; j <= n; j = j + 1) {
                  sum = sum + amat[j][i] * sol[j];
              }
              if (Math.abs(sum) < vsmall) {
                  sum = 0;
              }
              if (i > meq) {
                  work[l] = sum;
              } else {
                  work[l] = -Math.abs(sum);
                  if (sum > 0) {
                      for (j = 1; j <= n; j = j + 1) {
                          amat[j][i] = -amat[j][i];
                      }
                      bvec[i] = -bvec[i];
                  }
              }
          }

          for (i = 1; i <= nact; i = i + 1) {
              work[iwsv + iact[i]] = 0;
          }

          nvl = 0;
          temp = 0;
          for (i = 1; i <= q; i = i + 1) {
              if (work[iwsv + i] < temp * work[iwnbv + i]) {
                  nvl = i;
                  temp = work[iwsv + i] / work[iwnbv + i];
              }
          }
          if (nvl === 0) {
              return 999;
          }

          return 0;
      }

      function fn_goto_55() {
          for (i = 1; i <= n; i = i + 1) {
              sum = 0;
              for (j = 1; j <= n; j = j + 1) {
                  sum = sum + dmat[j][i] * amat[j][nvl];
              }
              work[i] = sum;
          }

          l1 = iwzv;
          for (i = 1; i <= n; i = i + 1) {
              work[l1 + i] = 0;
          }
          for (j = nact + 1; j <= n; j = j + 1) {
              for (i = 1; i <= n; i = i + 1) {
                  work[l1 + i] = work[l1 + i] + dmat[i][j] * work[j];
              }
          }

          t1inf = true;
          for (i = nact; i >= 1; i = i - 1) {
              sum = work[i];
              l = iwrm + (i * (i + 3)) / 2;
              l1 = l - i;
              for (j = i + 1; j <= nact; j = j + 1) {
                  sum = sum - work[l] * work[iwrv + j];
                  l = l + j;
              }
              sum = sum / work[l1];
              work[iwrv + i] = sum;
              if (iact[i] < meq) {
                  // continue;
                  break;
              }
              if (sum < 0) {
                  // continue;
                  break;
              }
              t1inf = false;
              it1 = i;
          }

          if (!t1inf) {
              t1 = work[iwuv + it1] / work[iwrv + it1];
              for (i = 1; i <= nact; i = i + 1) {
                  if (iact[i] < meq) {
                      // continue;
                      break;
                  }
                  if (work[iwrv + i] < 0) {
                      // continue;
                      break;
                  }
                  temp = work[iwuv + i] / work[iwrv + i];
                  if (temp < t1) {
                      t1 = temp;
                      it1 = i;
                  }
              }
          }

          sum = 0;
          for (i = iwzv + 1; i <= iwzv + n; i = i + 1) {
              sum = sum + work[i] * work[i];
          }
          if (Math.abs(sum) <= vsmall) {
              if (t1inf) {
                  ierr[1] = 1;
                  // GOTO 999
                  return 999;
              } else {
                  for (i = 1; i <= nact; i = i + 1) {
                      work[iwuv + i] = work[iwuv + i] - t1 * work[iwrv + i];
                  }
                  work[iwuv + nact + 1] = work[iwuv + nact + 1] + t1;
                  // GOTO 700
                  return 700;
              }
          } else {
              sum = 0;
              for (i = 1; i <= n; i = i + 1) {
                  sum = sum + work[iwzv + i] * amat[i][nvl];
              }
              tt = -work[iwsv + nvl] / sum;
              t2min = true;
              if (!t1inf) {
                  if (t1 < tt) {
                      tt = t1;
                      t2min = false;
                  }
              }

              for (i = 1; i <= n; i = i + 1) {
                  sol[i] = sol[i] + tt * work[iwzv + i];
                  if (Math.abs(sol[i]) < vsmall) {
                      sol[i] = 0;
                  }
              }

              crval[1] = crval[1] + tt * sum * (tt / 2 + work[iwuv + nact + 1]);
              for (i = 1; i <= nact; i = i + 1) {
                  work[iwuv + i] = work[iwuv + i] - tt * work[iwrv + i];
              }
              work[iwuv + nact + 1] = work[iwuv + nact + 1] + tt;

              if (t2min) {
                  nact = nact + 1;
                  iact[nact] = nvl;

                  l = iwrm + ((nact - 1) * nact) / 2 + 1;
                  for (i = 1; i <= nact - 1; i = i + 1) {
                      work[l] = work[i];
                      l = l + 1;
                  }

                  if (nact === n) {
                      work[l] = work[n];
                  } else {
                      for (i = n; i >= nact + 1; i = i - 1) {
                          if (work[i] === 0) {
                              // continue;
                              break;
                          }
                          gc = Math.max(Math.abs(work[i - 1]), Math.abs(work[i]));
                          gs = Math.min(Math.abs(work[i - 1]), Math.abs(work[i]));
                          if (work[i - 1] >= 0) {
                              temp = Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
                          } else {
                              temp = -Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
                          }
                          gc = work[i - 1] / temp;
                          gs = work[i] / temp;

                          if (gc === 1) {
                              // continue;
                              break;
                          }
                          if (gc === 0) {
                              work[i - 1] = gs * temp;
                              for (j = 1; j <= n; j = j + 1) {
                                  temp = dmat[j][i - 1];
                                  dmat[j][i - 1] = dmat[j][i];
                                  dmat[j][i] = temp;
                              }
                          } else {
                              work[i - 1] = temp;
                              nu = gs / (1 + gc);
                              for (j = 1; j <= n; j = j + 1) {
                                  temp = gc * dmat[j][i - 1] + gs * dmat[j][i];
                                  dmat[j][i] = nu * (dmat[j][i - 1] + temp) - dmat[j][i];
                                  dmat[j][i - 1] = temp;

                              }
                          }
                      }
                      work[l] = work[nact];
                  }
              } else {
                  sum = -bvec[nvl];
                  for (j = 1; j <= n; j = j + 1) {
                      sum = sum + sol[j] * amat[j][nvl];
                  }
                  if (nvl > meq) {
                      work[iwsv + nvl] = sum;
                  } else {
                      work[iwsv + nvl] = -Math.abs(sum);
                      if (sum > 0) {
                          for (j = 1; j <= n; j = j + 1) {
                              amat[j][nvl] = -amat[j][nvl];
                          }
                          bvec[nvl] = -bvec[nvl];
                      }
                  }
                  // GOTO 700
                  return 700;
              }
          }

          return 0;
      }

      function fn_goto_797() {
          l = iwrm + (it1 * (it1 + 1)) / 2 + 1;
          l1 = l + it1;
          if (work[l1] === 0) {
              // GOTO 798
              return 798;
          }
          gc = Math.max(Math.abs(work[l1 - 1]), Math.abs(work[l1]));
          gs = Math.min(Math.abs(work[l1 - 1]), Math.abs(work[l1]));
          if (work[l1 - 1] >= 0) {
              temp = Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
          } else {
              temp = -Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
          }
          gc = work[l1 - 1] / temp;
          gs = work[l1] / temp;

          if (gc === 1) {
              // GOTO 798
              return 798;
          }
          if (gc === 0) {
              for (i = it1 + 1; i <= nact; i = i + 1) {
                  temp = work[l1 - 1];
                  work[l1 - 1] = work[l1];
                  work[l1] = temp;
                  l1 = l1 + i;
              }
              for (i = 1; i <= n; i = i + 1) {
                  temp = dmat[i][it1];
                  dmat[i][it1] = dmat[i][it1 + 1];
                  dmat[i][it1 + 1] = temp;
              }
          } else {
              nu = gs / (1 + gc);
              for (i = it1 + 1; i <= nact; i = i + 1) {
                  temp = gc * work[l1 - 1] + gs * work[l1];
                  work[l1] = nu * (work[l1 - 1] + temp) - work[l1];
                  work[l1 - 1] = temp;
                  l1 = l1 + i;
              }
              for (i = 1; i <= n; i = i + 1) {
                  temp = gc * dmat[i][it1] + gs * dmat[i][it1 + 1];
                  dmat[i][it1 + 1] = nu * (dmat[i][it1] + temp) - dmat[i][it1 + 1];
                  dmat[i][it1] = temp;
              }
          }

          return 0;
      }

      function fn_goto_798() {
          l1 = l - it1;
          for (i = 1; i <= it1; i = i + 1) {
              work[l1] = work[l];
              l = l + 1;
              l1 = l1 + 1;
          }

          work[iwuv + it1] = work[iwuv + it1 + 1];
          iact[it1] = iact[it1 + 1];
          it1 = it1 + 1;
          if (it1 < nact) {
              // GOTO 797
              return 797;
          }

          return 0;
      }

      function fn_goto_799() {
          work[iwuv + nact] = work[iwuv + nact + 1];
          work[iwuv + nact + 1] = 0;
          iact[nact] = 0;
          nact = nact - 1;
          iter[2] = iter[2] + 1;

          return 0;
      }

      go = 0;
      while (true) {
          go = fn_goto_50();
          if (go === 999) {
              return;
          }
          while (true) {
              go = fn_goto_55();
              if (go === 0) {
                  break;
              }
              if (go === 999) {
                  return;
              }
              if (go === 700) {
                  if (it1 === nact) {
                      fn_goto_799();
                  } else {
                      while (true) {
                          fn_goto_797();
                          go = fn_goto_798();
                          if (go !== 797) {
                              break;
                          }
                      }
                      fn_goto_799();
                  }
              }
          }
      }

  }

  function solveQP(Dmat, dvec, Amat, bvec, meq, factorized) {
      Dmat = base0to1(Dmat);
      dvec = base0to1(dvec);
      Amat = base0to1(Amat);
      var i, n, q,
          nact, r,
          crval = [], iact = [], sol = [], work = [], iter = [],
          message;

      meq = meq || 0;
      factorized = factorized ? base0to1(factorized) : [undefined, 0];
      bvec = bvec ? base0to1(bvec) : [];

      // In Fortran the array index starts from 1
      n = Dmat.length - 1;
      q = Amat[1].length - 1;

      if (!bvec) {
          for (i = 1; i <= q; i = i + 1) {
              bvec[i] = 0;
          }
      }
      for (i = 1; i <= q; i = i + 1) {
          iact[i] = 0;
      }
      nact = 0;
      r = Math.min(n, q);
      for (i = 1; i <= n; i = i + 1) {
          sol[i] = 0;
      }
      crval[1] = 0;
      for (i = 1; i <= (2 * n + (r * (r + 5)) / 2 + 2 * q + 1); i = i + 1) {
          work[i] = 0;
      }
      for (i = 1; i <= 2; i = i + 1) {
          iter[i] = 0;
      }

      qpgen2(Dmat, dvec, n, n, sol, crval, Amat,
          bvec, n, q, meq, iact, nact, iter, work, factorized);

      message = "";
      if (factorized[1] === 1) {
          message = "constraints are inconsistent, no solution!";
      }
      if (factorized[1] === 2) {
          message = "matrix D in quadratic function is not positive definite!";
      }

      return {
          solution: base1to0(sol),
          value: base1to0(crval),
          unconstrained_solution: base1to0(dvec),
          iterations: base1to0(iter),
          iact: base1to0(iact),
          message: message
      };
  }
  exports.solveQP = solveQP;
  }(numeric));
  /*
  Shanti Rao sent me this routine by private email. I had to modify it
  slightly to work on Arrays instead of using a Matrix object.
  It is apparently translated from http://stitchpanorama.sourceforge.net/Python/svd.py
  */

  numeric.svd= function svd(A) {
      var temp;
  //Compute the thin SVD from G. H. Golub and C. Reinsch, Numer. Math. 14, 403-420 (1970)
  	var prec= numeric.epsilon; //Math.pow(2,-52) // assumes double prec
  	var tolerance= 1.e-64/prec;
  	var itmax= 50;
  	var c=0;
  	var i=0;
  	var j=0;
  	var k=0;
  	var l=0;
  	
  	var u= numeric.clone(A);
  	var m= u.length;
  	
  	var n= u[0].length;
  	
  	if (m < n) throw "Need more rows than columns"
  	
  	var e = new Array(n);
  	var q = new Array(n);
  	for (i=0; i<n; i++) e[i] = q[i] = 0.0;
  	var v = numeric.rep([n,n],0);
  //	v.zero();
  	
   	function pythag(a,b)
   	{
  		a = Math.abs(a);
  		b = Math.abs(b);
  		if (a > b)
  			return a*Math.sqrt(1.0+(b*b/a/a))
  		else if (b == 0.0) 
  			return a
  		return b*Math.sqrt(1.0+(a*a/b/b))
  	}

  	//Householder's reduction to bidiagonal form

  	var f= 0.0;
  	var g= 0.0;
  	var h= 0.0;
  	var x= 0.0;
  	var y= 0.0;
  	var z= 0.0;
  	var s= 0.0;
  	
  	for (i=0; i < n; i++)
  	{	
  		e[i]= g;
  		s= 0.0;
  		l= i+1;
  		for (j=i; j < m; j++) 
  			s += (u[j][i]*u[j][i]);
  		if (s <= tolerance)
  			g= 0.0;
  		else
  		{	
  			f= u[i][i];
  			g= Math.sqrt(s);
  			if (f >= 0.0) g= -g;
  			h= f*g-s;
  			u[i][i]=f-g;
  			for (j=l; j < n; j++)
  			{
  				s= 0.0;
  				for (k=i; k < m; k++) 
  					s += u[k][i]*u[k][j];
  				f= s/h;
  				for (k=i; k < m; k++) 
  					u[k][j]+=f*u[k][i];
  			}
  		}
  		q[i]= g;
  		s= 0.0;
  		for (j=l; j < n; j++) 
  			s= s + u[i][j]*u[i][j];
  		if (s <= tolerance)
  			g= 0.0;
  		else
  		{	
  			f= u[i][i+1];
  			g= Math.sqrt(s);
  			if (f >= 0.0) g= -g;
  			h= f*g - s;
  			u[i][i+1] = f-g;
  			for (j=l; j < n; j++) e[j]= u[i][j]/h;
  			for (j=l; j < m; j++)
  			{	
  				s=0.0;
  				for (k=l; k < n; k++) 
  					s += (u[j][k]*u[i][k]);
  				for (k=l; k < n; k++) 
  					u[j][k]+=s*e[k];
  			}	
  		}
  		y= Math.abs(q[i])+Math.abs(e[i]);
  		if (y>x) 
  			x=y;
  	}
  	
  	// accumulation of right hand gtransformations
  	for (i=n-1; i != -1; i+= -1)
  	{	
  		if (g != 0.0)
  		{
  		 	h= g*u[i][i+1];
  			for (j=l; j < n; j++) 
  				v[j][i]=u[i][j]/h;
  			for (j=l; j < n; j++)
  			{	
  				s=0.0;
  				for (k=l; k < n; k++) 
  					s += u[i][k]*v[k][j];
  				for (k=l; k < n; k++) 
  					v[k][j]+=(s*v[k][i]);
  			}	
  		}
  		for (j=l; j < n; j++)
  		{
  			v[i][j] = 0;
  			v[j][i] = 0;
  		}
  		v[i][i] = 1;
  		g= e[i];
  		l= i;
  	}
  	
  	// accumulation of left hand transformations
  	for (i=n-1; i != -1; i+= -1)
  	{	
  		l= i+1;
  		g= q[i];
  		for (j=l; j < n; j++) 
  			u[i][j] = 0;
  		if (g != 0.0)
  		{
  			h= u[i][i]*g;
  			for (j=l; j < n; j++)
  			{
  				s=0.0;
  				for (k=l; k < m; k++) s += u[k][i]*u[k][j];
  				f= s/h;
  				for (k=i; k < m; k++) u[k][j]+=f*u[k][i];
  			}
  			for (j=i; j < m; j++) u[j][i] = u[j][i]/g;
  		}
  		else
  			for (j=i; j < m; j++) u[j][i] = 0;
  		u[i][i] += 1;
  	}
  	
  	// diagonalization of the bidiagonal form
  	prec= prec*x;
  	for (k=n-1; k != -1; k+= -1)
  	{
  		for (var iteration=0; iteration < itmax; iteration++)
  		{	// test f splitting
  			var test_convergence = false;
  			for (l=k; l != -1; l+= -1)
  			{	
  				if (Math.abs(e[l]) <= prec)
  				{	test_convergence= true;
  					break 
  				}
  				if (Math.abs(q[l-1]) <= prec)
  					break 
  			}
  			if (!test_convergence)
  			{	// cancellation of e[l] if l>0
  				c= 0.0;
  				s= 1.0;
  				var l1= l-1;
  				for (i =l; i<k+1; i++)
  				{	
  					f= s*e[i];
  					e[i]= c*e[i];
  					if (Math.abs(f) <= prec)
  						break
  					g= q[i];
  					h= pythag(f,g);
  					q[i]= h;
  					c= g/h;
  					s= -f/h;
  					for (j=0; j < m; j++)
  					{	
  						y= u[j][l1];
  						z= u[j][i];
  						u[j][l1] =  y*c+(z*s);
  						u[j][i] = -y*s+(z*c);
  					} 
  				}	
  			}
  			// test f convergence
  			z= q[k];
  			if (l== k)
  			{	//convergence
  				if (z<0.0)
  				{	//q[k] is made non-negative
  					q[k]= -z;
  					for (j=0; j < n; j++)
  						v[j][k] = -v[j][k];
  				}
  				break  //break out of iteration loop and move on to next k value
  			}
  			if (iteration >= itmax-1)
  				throw 'Error: no convergence.'
  			// shift from bottom 2x2 minor
  			x= q[l];
  			y= q[k-1];
  			g= e[k-1];
  			h= e[k];
  			f= ((y-z)*(y+z)+(g-h)*(g+h))/(2.0*h*y);
  			g= pythag(f,1.0);
  			if (f < 0.0)
  				f= ((x-z)*(x+z)+h*(y/(f-g)-h))/x;
  			else
  				f= ((x-z)*(x+z)+h*(y/(f+g)-h))/x;
  			// next QR transformation
  			c= 1.0;
  			s= 1.0;
  			for (i=l+1; i< k+1; i++)
  			{	
  				g= e[i];
  				y= q[i];
  				h= s*g;
  				g= c*g;
  				z= pythag(f,h);
  				e[i-1]= z;
  				c= f/z;
  				s= h/z;
  				f= x*c+g*s;
  				g= -x*s+g*c;
  				h= y*s;
  				y= y*c;
  				for (j=0; j < n; j++)
  				{	
  					x= v[j][i-1];
  					z= v[j][i];
  					v[j][i-1] = x*c+z*s;
  					v[j][i] = -x*s+z*c;
  				}
  				z= pythag(f,h);
  				q[i-1]= z;
  				c= f/z;
  				s= h/z;
  				f= c*g+s*y;
  				x= -s*g+c*y;
  				for (j=0; j < m; j++)
  				{
  					y= u[j][i-1];
  					z= u[j][i];
  					u[j][i-1] = y*c+z*s;
  					u[j][i] = -y*s+z*c;
  				}
  			}
  			e[l]= 0.0;
  			e[k]= f;
  			q[k]= x;
  		} 
  	}
  		
  	//vt= transpose(v)
  	//return (u,q,vt)
  	for (i=0;i<q.length; i++) 
  	  if (q[i] < prec) q[i] = 0;
  	  
  	//sort eigenvalues	
  	for (i=0; i< n; i++)
  	{	 
  	//writeln(q)
  	 for (j=i-1; j >= 0; j--)
  	 {
  	  if (q[j] < q[i])
  	  {
  	//  writeln(i,'-',j)
  	   c = q[j];
  	   q[j] = q[i];
  	   q[i] = c;
  	   for(k=0;k<u.length;k++) { temp = u[k][i]; u[k][i] = u[k][j]; u[k][j] = temp; }
  	   for(k=0;k<v.length;k++) { temp = v[k][i]; v[k][i] = v[k][j]; v[k][j] = temp; }
  //	   u.swapCols(i,j)
  //	   v.swapCols(i,j)
  	   i = j;	   
  	  }
  	 }	
  	}
  	
  	return {U:u,S:q,V:v}
  };
  });

  // import math.js, only with customized constants

  function create$2 (config) {
    // create a new math.js instance
    var math = core$1.create(config);
    math.create = create$2;
    
    // import data types, functions, constants, expression parser, etc.
    math['import'](lib);

    // import numeric
    math['import'](numeric1_2_6, {wrap: true, silent: true});  

    // strict power function that returns NaN for 0^0, NaN^0, and Infinty^0
    var pow_original = math.pow;
    function pow_strict_f(base, pow) {
      if(pow === 0 && (typeof base === 'number') &&
        (base === 0 || !Number.isFinite(base))) {
          return NaN;
      }
      else
         return pow_original(base,pow);
    }

    function set_pow_strict(bool) {
      if(bool)
        math['import']({pow: pow_strict_f}, {override: true});
      else
        math['import']({pow: pow_original}, {override: true});
    }

    var is_pow_strict = () => math.pow === pow_strict_f;

    Object.defineProperty(math, 'pow_strict', {
      get: is_pow_strict,
      set: set_pow_strict,
    });

    math.pow_strict = true;


    function set_define_e(bool) {
      if(bool)
        math.config({define_e: true});
      else
        math.config({define_e: false});
    }
    var get_define_e = () => math.config().define_e!==false;
    function set_define_i(bool) {
      if(bool)
        math.config({define_i: true});
      else
        math.config({define_i: false});
    }
    var get_define_i = () => math.config().define_i!==false;
    function set_define_pi(bool) {
      if(bool)
        math.config({define_pi: true});
      else
        math.config({define_pi: false});
    }
    var get_define_pi = () => math.config().define_pi!==false;

    Object.defineProperty(math, 'define_e', {
      get: get_define_e,
      set: set_define_e,
    });
    Object.defineProperty(math, 'define_i', {
      get: get_define_i,
      set: set_define_i,
    });
    Object.defineProperty(math, 'define_pi', {
      get: get_define_pi,
      set: set_define_pi,
    });

    return math;
  }

  // return a new instance of math.js
  var math$19 = create$2();

  function leaves( tree, include_subscripts ) {
      if(!Array.isArray(tree))
  	return [tree];

      var operator = tree[0];
      var operands = tree.slice(1);

      if(include_subscripts && operator === '_') {
        if(typeof operands[0] === "string" &&
        ((typeof operands[1] === "string") || (typeof operands[1] === "number")))
        return [operands[0] + "_"+ operands[1]];
      }

      if(operator === "apply") {
  	operands = tree.slice(2);
      }
      if(operands.length === 0)
        return [];

      return operands.map( function(v,i) { return leaves(v, include_subscripts); } )
  	.reduce( function(a,b) { return a.concat(b); } );

  }

  function variables( expr_or_tree, include_subscripts = false ) {

      var tree = get_tree(expr_or_tree);

      var result = leaves( tree, include_subscripts );

      result = result.filter( function(v,i) {
  	return (typeof v === 'string') &&
  	    (math$19.define_e || (v !== "e")) &&
  	    (math$19.define_pi || (v !== "pi")) &&
  	    (math$19.define_i || (v !== "i"));
      });

      result = result.filter(function(itm,i,a){
  	return i === result.indexOf(itm);
      });

      return result;
  }

  function operators_list( tree ) {
      if (!Array.isArray(tree))
  	return [];

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === "apply") {
  	operands = tree.slice(2);
      }
      if(operands.length === 0)
        return [operator];

      return [operator].concat(
  	operands.map( function(v,i) { return operators_list(v); } )
  	    .reduce( function(a,b) { return a.concat(b); } ));

  }

  function operators$1( expr_or_tree ) {

      var tree = get_tree(expr_or_tree);

      var result = operators_list( tree );

      result = result.filter( function(v,i) {
  	return (v !== 'apply');
      });

      result = result.filter(function(itm,i,a){
  	return i === result.indexOf(itm);
      });

      return result;
  }

  function functions_list( tree ) {
      if (typeof tree === 'number') {
  	return [];
      }

      if (typeof tree === 'string') {
  	return [];
      }

      if (typeof tree === 'boolean') {
  	return [];
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      var functions = [];
      if(operator === "apply") {
  	functions = [operands[0]];
  	operands = tree.slice(2);
      }

      return functions.concat(
  	operands.map( function(v,i) { return functions_list(v); } )
  	    .reduce( function(a,b) { return a.concat(b); } ));

  }

  function functions( expr_or_tree ) {

      var tree = get_tree(expr_or_tree);

      var result = functions_list( tree );

      result = result.filter(function(itm,i,a){
  	return i === result.indexOf(itm);
      });

      return result;
  }

  var variables$1 = /*#__PURE__*/Object.freeze({
    variables: variables,
    operators: operators$1,
    functions: functions
  });

  var underscore = createCommonjsModule(function (module, exports) {
  //     Underscore.js 1.8.3
  //     http://underscorejs.org
  //     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  (function() {

    // Baseline setup
    // --------------

    // Establish the root object, `window` in the browser, or `exports` on the server.
    var root = this;

    // Save the previous value of the `_` variable.
    var previousUnderscore = root._;

    // Save bytes in the minified (but not gzipped) version:
    var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

    // Create quick reference variables for speed access to core prototypes.
    var
      push             = ArrayProto.push,
      slice            = ArrayProto.slice,
      toString         = ObjProto.toString,
      hasOwnProperty   = ObjProto.hasOwnProperty;

    // All **ECMAScript 5** native function implementations that we hope to use
    // are declared here.
    var
      nativeIsArray      = Array.isArray,
      nativeKeys         = Object.keys,
      nativeBind         = FuncProto.bind,
      nativeCreate       = Object.create;

    // Naked function reference for surrogate-prototype-swapping.
    var Ctor = function(){};

    // Create a safe reference to the Underscore object for use below.
    var _ = function(obj) {
      if (obj instanceof _) return obj;
      if (!(this instanceof _)) return new _(obj);
      this._wrapped = obj;
    };

    // Export the Underscore object for **Node.js**, with
    // backwards-compatibility for the old `require()` API. If we're in
    // the browser, add `_` as a global object.
    {
      if ('object' !== 'undefined' && module.exports) {
        exports = module.exports = _;
      }
      exports._ = _;
    }

    // Current version.
    _.VERSION = '1.8.3';

    // Internal function that returns an efficient (for current engines) version
    // of the passed-in callback, to be repeatedly applied in other Underscore
    // functions.
    var optimizeCb = function(func, context, argCount) {
      if (context === void 0) return func;
      switch (argCount == null ? 3 : argCount) {
        case 1: return function(value) {
          return func.call(context, value);
        };
        case 2: return function(value, other) {
          return func.call(context, value, other);
        };
        case 3: return function(value, index, collection) {
          return func.call(context, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(context, accumulator, value, index, collection);
        };
      }
      return function() {
        return func.apply(context, arguments);
      };
    };

    // A mostly-internal function to generate callbacks that can be applied
    // to each element in a collection, returning the desired result — either
    // identity, an arbitrary callback, a property matcher, or a property accessor.
    var cb = function(value, context, argCount) {
      if (value == null) return _.identity;
      if (_.isFunction(value)) return optimizeCb(value, context, argCount);
      if (_.isObject(value)) return _.matcher(value);
      return _.property(value);
    };
    _.iteratee = function(value, context) {
      return cb(value, context, Infinity);
    };

    // An internal function for creating assigner functions.
    var createAssigner = function(keysFunc, undefinedOnly) {
      return function(obj) {
        var length = arguments.length;
        if (length < 2 || obj == null) return obj;
        for (var index = 1; index < length; index++) {
          var source = arguments[index],
              keys = keysFunc(source),
              l = keys.length;
          for (var i = 0; i < l; i++) {
            var key = keys[i];
            if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
          }
        }
        return obj;
      };
    };

    // An internal function for creating a new object that inherits from another.
    var baseCreate = function(prototype) {
      if (!_.isObject(prototype)) return {};
      if (nativeCreate) return nativeCreate(prototype);
      Ctor.prototype = prototype;
      var result = new Ctor;
      Ctor.prototype = null;
      return result;
    };

    var property = function(key) {
      return function(obj) {
        return obj == null ? void 0 : obj[key];
      };
    };

    // Helper for collection methods to determine whether a collection
    // should be iterated as an array or as an object
    // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
    // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
    var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
    var getLength = property('length');
    var isArrayLike = function(collection) {
      var length = getLength(collection);
      return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
    };

    // Collection Functions
    // --------------------

    // The cornerstone, an `each` implementation, aka `forEach`.
    // Handles raw objects in addition to array-likes. Treats all
    // sparse array-likes as if they were dense.
    _.each = _.forEach = function(obj, iteratee, context) {
      iteratee = optimizeCb(iteratee, context);
      var i, length;
      if (isArrayLike(obj)) {
        for (i = 0, length = obj.length; i < length; i++) {
          iteratee(obj[i], i, obj);
        }
      } else {
        var keys = _.keys(obj);
        for (i = 0, length = keys.length; i < length; i++) {
          iteratee(obj[keys[i]], keys[i], obj);
        }
      }
      return obj;
    };

    // Return the results of applying the iteratee to each element.
    _.map = _.collect = function(obj, iteratee, context) {
      iteratee = cb(iteratee, context);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          results = Array(length);
      for (var index = 0; index < length; index++) {
        var currentKey = keys ? keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
    };

    // Create a reducing function iterating left or right.
    function createReduce(dir) {
      // Optimized iterator function as using arguments.length
      // in the main function will deoptimize the, see #1991.
      function iterator(obj, iteratee, memo, keys, index, length) {
        for (; index >= 0 && index < length; index += dir) {
          var currentKey = keys ? keys[index] : index;
          memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
      }

      return function(obj, iteratee, memo, context) {
        iteratee = optimizeCb(iteratee, context, 4);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length,
            index = dir > 0 ? 0 : length - 1;
        // Determine the initial value if none is provided.
        if (arguments.length < 3) {
          memo = obj[keys ? keys[index] : index];
          index += dir;
        }
        return iterator(obj, iteratee, memo, keys, index, length);
      };
    }

    // **Reduce** builds up a single result from a list of values, aka `inject`,
    // or `foldl`.
    _.reduce = _.foldl = _.inject = createReduce(1);

    // The right-associative version of reduce, also known as `foldr`.
    _.reduceRight = _.foldr = createReduce(-1);

    // Return the first value which passes a truth test. Aliased as `detect`.
    _.find = _.detect = function(obj, predicate, context) {
      var key;
      if (isArrayLike(obj)) {
        key = _.findIndex(obj, predicate, context);
      } else {
        key = _.findKey(obj, predicate, context);
      }
      if (key !== void 0 && key !== -1) return obj[key];
    };

    // Return all the elements that pass a truth test.
    // Aliased as `select`.
    _.filter = _.select = function(obj, predicate, context) {
      var results = [];
      predicate = cb(predicate, context);
      _.each(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
      });
      return results;
    };

    // Return all the elements for which a truth test fails.
    _.reject = function(obj, predicate, context) {
      return _.filter(obj, _.negate(cb(predicate)), context);
    };

    // Determine whether all of the elements match a truth test.
    // Aliased as `all`.
    _.every = _.all = function(obj, predicate, context) {
      predicate = cb(predicate, context);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length;
      for (var index = 0; index < length; index++) {
        var currentKey = keys ? keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
      }
      return true;
    };

    // Determine if at least one element in the object matches a truth test.
    // Aliased as `any`.
    _.some = _.any = function(obj, predicate, context) {
      predicate = cb(predicate, context);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length;
      for (var index = 0; index < length; index++) {
        var currentKey = keys ? keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
      }
      return false;
    };

    // Determine if the array or object contains a given item (using `===`).
    // Aliased as `includes` and `include`.
    _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      if (typeof fromIndex != 'number' || guard) fromIndex = 0;
      return _.indexOf(obj, item, fromIndex) >= 0;
    };

    // Invoke a method (with arguments) on every item in a collection.
    _.invoke = function(obj, method) {
      var args = slice.call(arguments, 2);
      var isFunc = _.isFunction(method);
      return _.map(obj, function(value) {
        var func = isFunc ? method : value[method];
        return func == null ? func : func.apply(value, args);
      });
    };

    // Convenience version of a common use case of `map`: fetching a property.
    _.pluck = function(obj, key) {
      return _.map(obj, _.property(key));
    };

    // Convenience version of a common use case of `filter`: selecting only objects
    // containing specific `key:value` pairs.
    _.where = function(obj, attrs) {
      return _.filter(obj, _.matcher(attrs));
    };

    // Convenience version of a common use case of `find`: getting the first object
    // containing specific `key:value` pairs.
    _.findWhere = function(obj, attrs) {
      return _.find(obj, _.matcher(attrs));
    };

    // Return the maximum element (or element-based computation).
    _.max = function(obj, iteratee, context) {
      var result = -Infinity, lastComputed = -Infinity,
          value, computed;
      if (iteratee == null && obj != null) {
        obj = isArrayLike(obj) ? obj : _.values(obj);
        for (var i = 0, length = obj.length; i < length; i++) {
          value = obj[i];
          if (value > result) {
            result = value;
          }
        }
      } else {
        iteratee = cb(iteratee, context);
        _.each(obj, function(value, index, list) {
          computed = iteratee(value, index, list);
          if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
            result = value;
            lastComputed = computed;
          }
        });
      }
      return result;
    };

    // Return the minimum element (or element-based computation).
    _.min = function(obj, iteratee, context) {
      var result = Infinity, lastComputed = Infinity,
          value, computed;
      if (iteratee == null && obj != null) {
        obj = isArrayLike(obj) ? obj : _.values(obj);
        for (var i = 0, length = obj.length; i < length; i++) {
          value = obj[i];
          if (value < result) {
            result = value;
          }
        }
      } else {
        iteratee = cb(iteratee, context);
        _.each(obj, function(value, index, list) {
          computed = iteratee(value, index, list);
          if (computed < lastComputed || computed === Infinity && result === Infinity) {
            result = value;
            lastComputed = computed;
          }
        });
      }
      return result;
    };

    // Shuffle a collection, using the modern version of the
    // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
    _.shuffle = function(obj) {
      var set = isArrayLike(obj) ? obj : _.values(obj);
      var length = set.length;
      var shuffled = Array(length);
      for (var index = 0, rand; index < length; index++) {
        rand = _.random(0, index);
        if (rand !== index) shuffled[index] = shuffled[rand];
        shuffled[rand] = set[index];
      }
      return shuffled;
    };

    // Sample **n** random values from a collection.
    // If **n** is not specified, returns a single random element.
    // The internal `guard` argument allows it to work with `map`.
    _.sample = function(obj, n, guard) {
      if (n == null || guard) {
        if (!isArrayLike(obj)) obj = _.values(obj);
        return obj[_.random(obj.length - 1)];
      }
      return _.shuffle(obj).slice(0, Math.max(0, n));
    };

    // Sort the object's values by a criterion produced by an iteratee.
    _.sortBy = function(obj, iteratee, context) {
      iteratee = cb(iteratee, context);
      return _.pluck(_.map(obj, function(value, index, list) {
        return {
          value: value,
          index: index,
          criteria: iteratee(value, index, list)
        };
      }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
          if (a > b || a === void 0) return 1;
          if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
      }), 'value');
    };

    // An internal function used for aggregate "group by" operations.
    var group = function(behavior) {
      return function(obj, iteratee, context) {
        var result = {};
        iteratee = cb(iteratee, context);
        _.each(obj, function(value, index) {
          var key = iteratee(value, index, obj);
          behavior(result, value, key);
        });
        return result;
      };
    };

    // Groups the object's values by a criterion. Pass either a string attribute
    // to group by, or a function that returns the criterion.
    _.groupBy = group(function(result, value, key) {
      if (_.has(result, key)) result[key].push(value); else result[key] = [value];
    });

    // Indexes the object's values by a criterion, similar to `groupBy`, but for
    // when you know that your index values will be unique.
    _.indexBy = group(function(result, value, key) {
      result[key] = value;
    });

    // Counts instances of an object that group by a certain criterion. Pass
    // either a string attribute to count by, or a function that returns the
    // criterion.
    _.countBy = group(function(result, value, key) {
      if (_.has(result, key)) result[key]++; else result[key] = 1;
    });

    // Safely create a real, live array from anything iterable.
    _.toArray = function(obj) {
      if (!obj) return [];
      if (_.isArray(obj)) return slice.call(obj);
      if (isArrayLike(obj)) return _.map(obj, _.identity);
      return _.values(obj);
    };

    // Return the number of elements in an object.
    _.size = function(obj) {
      if (obj == null) return 0;
      return isArrayLike(obj) ? obj.length : _.keys(obj).length;
    };

    // Split a collection into two arrays: one whose elements all satisfy the given
    // predicate, and one whose elements all do not satisfy the predicate.
    _.partition = function(obj, predicate, context) {
      predicate = cb(predicate, context);
      var pass = [], fail = [];
      _.each(obj, function(value, key, obj) {
        (predicate(value, key, obj) ? pass : fail).push(value);
      });
      return [pass, fail];
    };

    // Array Functions
    // ---------------

    // Get the first element of an array. Passing **n** will return the first N
    // values in the array. Aliased as `head` and `take`. The **guard** check
    // allows it to work with `_.map`.
    _.first = _.head = _.take = function(array, n, guard) {
      if (array == null) return void 0;
      if (n == null || guard) return array[0];
      return _.initial(array, array.length - n);
    };

    // Returns everything but the last entry of the array. Especially useful on
    // the arguments object. Passing **n** will return all the values in
    // the array, excluding the last N.
    _.initial = function(array, n, guard) {
      return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
    };

    // Get the last element of an array. Passing **n** will return the last N
    // values in the array.
    _.last = function(array, n, guard) {
      if (array == null) return void 0;
      if (n == null || guard) return array[array.length - 1];
      return _.rest(array, Math.max(0, array.length - n));
    };

    // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
    // Especially useful on the arguments object. Passing an **n** will return
    // the rest N values in the array.
    _.rest = _.tail = _.drop = function(array, n, guard) {
      return slice.call(array, n == null || guard ? 1 : n);
    };

    // Trim out all falsy values from an array.
    _.compact = function(array) {
      return _.filter(array, _.identity);
    };

    // Internal implementation of a recursive `flatten` function.
    var flatten = function(input, shallow, strict, startIndex) {
      var output = [], idx = 0;
      for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
        var value = input[i];
        if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
          //flatten current level of array or arguments object
          if (!shallow) value = flatten(value, shallow, strict);
          var j = 0, len = value.length;
          output.length += len;
          while (j < len) {
            output[idx++] = value[j++];
          }
        } else if (!strict) {
          output[idx++] = value;
        }
      }
      return output;
    };

    // Flatten out an array, either recursively (by default), or just one level.
    _.flatten = function(array, shallow) {
      return flatten(array, shallow, false);
    };

    // Return a version of the array that does not contain the specified value(s).
    _.without = function(array) {
      return _.difference(array, slice.call(arguments, 1));
    };

    // Produce a duplicate-free version of the array. If the array has already
    // been sorted, you have the option of using a faster algorithm.
    // Aliased as `unique`.
    _.uniq = _.unique = function(array, isSorted, iteratee, context) {
      if (!_.isBoolean(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
      }
      if (iteratee != null) iteratee = cb(iteratee, context);
      var result = [];
      var seen = [];
      for (var i = 0, length = getLength(array); i < length; i++) {
        var value = array[i],
            computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted) {
          if (!i || seen !== computed) result.push(value);
          seen = computed;
        } else if (iteratee) {
          if (!_.contains(seen, computed)) {
            seen.push(computed);
            result.push(value);
          }
        } else if (!_.contains(result, value)) {
          result.push(value);
        }
      }
      return result;
    };

    // Produce an array that contains the union: each distinct element from all of
    // the passed-in arrays.
    _.union = function() {
      return _.uniq(flatten(arguments, true, true));
    };

    // Produce an array that contains every item shared between all the
    // passed-in arrays.
    _.intersection = function(array) {
      var result = [];
      var argsLength = arguments.length;
      for (var i = 0, length = getLength(array); i < length; i++) {
        var item = array[i];
        if (_.contains(result, item)) continue;
        for (var j = 1; j < argsLength; j++) {
          if (!_.contains(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
      }
      return result;
    };

    // Take the difference between one array and a number of other arrays.
    // Only the elements present in just the first array will remain.
    _.difference = function(array) {
      var rest = flatten(arguments, true, true, 1);
      return _.filter(array, function(value){
        return !_.contains(rest, value);
      });
    };

    // Zip together multiple lists into a single array -- elements that share
    // an index go together.
    _.zip = function() {
      return _.unzip(arguments);
    };

    // Complement of _.zip. Unzip accepts an array of arrays and groups
    // each array's elements on shared indices
    _.unzip = function(array) {
      var length = array && _.max(array, getLength).length || 0;
      var result = Array(length);

      for (var index = 0; index < length; index++) {
        result[index] = _.pluck(array, index);
      }
      return result;
    };

    // Converts lists into objects. Pass either a single array of `[key, value]`
    // pairs, or two parallel arrays of the same length -- one of keys, and one of
    // the corresponding values.
    _.object = function(list, values) {
      var result = {};
      for (var i = 0, length = getLength(list); i < length; i++) {
        if (values) {
          result[list[i]] = values[i];
        } else {
          result[list[i][0]] = list[i][1];
        }
      }
      return result;
    };

    // Generator function to create the findIndex and findLastIndex functions
    function createPredicateIndexFinder(dir) {
      return function(array, predicate, context) {
        predicate = cb(predicate, context);
        var length = getLength(array);
        var index = dir > 0 ? 0 : length - 1;
        for (; index >= 0 && index < length; index += dir) {
          if (predicate(array[index], index, array)) return index;
        }
        return -1;
      };
    }

    // Returns the first index on an array-like that passes a predicate test
    _.findIndex = createPredicateIndexFinder(1);
    _.findLastIndex = createPredicateIndexFinder(-1);

    // Use a comparator function to figure out the smallest index at which
    // an object should be inserted so as to maintain order. Uses binary search.
    _.sortedIndex = function(array, obj, iteratee, context) {
      iteratee = cb(iteratee, context, 1);
      var value = iteratee(obj);
      var low = 0, high = getLength(array);
      while (low < high) {
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
      }
      return low;
    };

    // Generator function to create the indexOf and lastIndexOf functions
    function createIndexFinder(dir, predicateFind, sortedIndex) {
      return function(array, item, idx) {
        var i = 0, length = getLength(array);
        if (typeof idx == 'number') {
          if (dir > 0) {
              i = idx >= 0 ? idx : Math.max(idx + length, i);
          } else {
              length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
          }
        } else if (sortedIndex && idx && length) {
          idx = sortedIndex(array, item);
          return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
          idx = predicateFind(slice.call(array, i, length), _.isNaN);
          return idx >= 0 ? idx + i : -1;
        }
        for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
          if (array[idx] === item) return idx;
        }
        return -1;
      };
    }

    // Return the position of the first occurrence of an item in an array,
    // or -1 if the item is not included in the array.
    // If the array is large and already in sort order, pass `true`
    // for **isSorted** to use binary search.
    _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
    _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

    // Generate an integer Array containing an arithmetic progression. A port of
    // the native Python `range()` function. See
    // [the Python documentation](http://docs.python.org/library/functions.html#range).
    _.range = function(start, stop, step) {
      if (stop == null) {
        stop = start || 0;
        start = 0;
      }
      step = step || 1;

      var length = Math.max(Math.ceil((stop - start) / step), 0);
      var range = Array(length);

      for (var idx = 0; idx < length; idx++, start += step) {
        range[idx] = start;
      }

      return range;
    };

    // Function (ahem) Functions
    // ------------------

    // Determines whether to execute a function as a constructor
    // or a normal function with the provided arguments
    var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
      if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
      var self = baseCreate(sourceFunc.prototype);
      var result = sourceFunc.apply(self, args);
      if (_.isObject(result)) return result;
      return self;
    };

    // Create a function bound to a given object (assigning `this`, and arguments,
    // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
    // available.
    _.bind = function(func, context) {
      if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
      if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
      var args = slice.call(arguments, 2);
      var bound = function() {
        return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
      };
      return bound;
    };

    // Partially apply a function by creating a version that has had some of its
    // arguments pre-filled, without changing its dynamic `this` context. _ acts
    // as a placeholder, allowing any combination of arguments to be pre-filled.
    _.partial = function(func) {
      var boundArgs = slice.call(arguments, 1);
      var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for (var i = 0; i < length; i++) {
          args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
        }
        while (position < arguments.length) args.push(arguments[position++]);
        return executeBound(func, bound, this, this, args);
      };
      return bound;
    };

    // Bind a number of an object's methods to that object. Remaining arguments
    // are the method names to be bound. Useful for ensuring that all callbacks
    // defined on an object belong to it.
    _.bindAll = function(obj) {
      var i, length = arguments.length, key;
      if (length <= 1) throw new Error('bindAll must be passed function names');
      for (i = 1; i < length; i++) {
        key = arguments[i];
        obj[key] = _.bind(obj[key], obj);
      }
      return obj;
    };

    // Memoize an expensive function by storing its results.
    _.memoize = function(func, hasher) {
      var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
      };
      memoize.cache = {};
      return memoize;
    };

    // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.
    _.delay = function(func, wait) {
      var args = slice.call(arguments, 2);
      return setTimeout(function(){
        return func.apply(null, args);
      }, wait);
    };

    // Defers a function, scheduling it to run after the current call stack has
    // cleared.
    _.defer = _.partial(_.delay, _, 1);

    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    _.throttle = function(func, wait, options) {
      var context, args, result;
      var timeout = null;
      var previous = 0;
      if (!options) options = {};
      var later = function() {
        previous = options.leading === false ? 0 : _.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      };
      return function() {
        var now = _.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
          timeout = setTimeout(later, remaining);
        }
        return result;
      };
    };

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    _.debounce = function(func, wait, immediate) {
      var timeout, args, context, timestamp, result;

      var later = function() {
        var last = _.now() - timestamp;

        if (last < wait && last >= 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          }
        }
      };

      return function() {
        context = this;
        args = arguments;
        timestamp = _.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }

        return result;
      };
    };

    // Returns the first function passed as an argument to the second,
    // allowing you to adjust arguments, run code before and after, and
    // conditionally execute the original function.
    _.wrap = function(func, wrapper) {
      return _.partial(wrapper, func);
    };

    // Returns a negated version of the passed-in predicate.
    _.negate = function(predicate) {
      return function() {
        return !predicate.apply(this, arguments);
      };
    };

    // Returns a function that is the composition of a list of functions, each
    // consuming the return value of the function that follows.
    _.compose = function() {
      var args = arguments;
      var start = args.length - 1;
      return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while (i--) result = args[i].call(this, result);
        return result;
      };
    };

    // Returns a function that will only be executed on and after the Nth call.
    _.after = function(times, func) {
      return function() {
        if (--times < 1) {
          return func.apply(this, arguments);
        }
      };
    };

    // Returns a function that will only be executed up to (but not including) the Nth call.
    _.before = function(times, func) {
      var memo;
      return function() {
        if (--times > 0) {
          memo = func.apply(this, arguments);
        }
        if (times <= 1) func = null;
        return memo;
      };
    };

    // Returns a function that will be executed at most one time, no matter how
    // often you call it. Useful for lazy initialization.
    _.once = _.partial(_.before, 2);

    // Object Functions
    // ----------------

    // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
    var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
    var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                        'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

    function collectNonEnumProps(obj, keys) {
      var nonEnumIdx = nonEnumerableProps.length;
      var constructor = obj.constructor;
      var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

      // Constructor is a special case.
      var prop = 'constructor';
      if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

      while (nonEnumIdx--) {
        prop = nonEnumerableProps[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
          keys.push(prop);
        }
      }
    }

    // Retrieve the names of an object's own properties.
    // Delegates to **ECMAScript 5**'s native `Object.keys`
    _.keys = function(obj) {
      if (!_.isObject(obj)) return [];
      if (nativeKeys) return nativeKeys(obj);
      var keys = [];
      for (var key in obj) if (_.has(obj, key)) keys.push(key);
      // Ahem, IE < 9.
      if (hasEnumBug) collectNonEnumProps(obj, keys);
      return keys;
    };

    // Retrieve all the property names of an object.
    _.allKeys = function(obj) {
      if (!_.isObject(obj)) return [];
      var keys = [];
      for (var key in obj) keys.push(key);
      // Ahem, IE < 9.
      if (hasEnumBug) collectNonEnumProps(obj, keys);
      return keys;
    };

    // Retrieve the values of an object's properties.
    _.values = function(obj) {
      var keys = _.keys(obj);
      var length = keys.length;
      var values = Array(length);
      for (var i = 0; i < length; i++) {
        values[i] = obj[keys[i]];
      }
      return values;
    };

    // Returns the results of applying the iteratee to each element of the object
    // In contrast to _.map it returns an object
    _.mapObject = function(obj, iteratee, context) {
      iteratee = cb(iteratee, context);
      var keys =  _.keys(obj),
            length = keys.length,
            results = {},
            currentKey;
        for (var index = 0; index < length; index++) {
          currentKey = keys[index];
          results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };

    // Convert an object into a list of `[key, value]` pairs.
    _.pairs = function(obj) {
      var keys = _.keys(obj);
      var length = keys.length;
      var pairs = Array(length);
      for (var i = 0; i < length; i++) {
        pairs[i] = [keys[i], obj[keys[i]]];
      }
      return pairs;
    };

    // Invert the keys and values of an object. The values must be serializable.
    _.invert = function(obj) {
      var result = {};
      var keys = _.keys(obj);
      for (var i = 0, length = keys.length; i < length; i++) {
        result[obj[keys[i]]] = keys[i];
      }
      return result;
    };

    // Return a sorted list of the function names available on the object.
    // Aliased as `methods`
    _.functions = _.methods = function(obj) {
      var names = [];
      for (var key in obj) {
        if (_.isFunction(obj[key])) names.push(key);
      }
      return names.sort();
    };

    // Extend a given object with all the properties in passed-in object(s).
    _.extend = createAssigner(_.allKeys);

    // Assigns a given object with all the own properties in the passed-in object(s)
    // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
    _.extendOwn = _.assign = createAssigner(_.keys);

    // Returns the first key on an object that passes a predicate test
    _.findKey = function(obj, predicate, context) {
      predicate = cb(predicate, context);
      var keys = _.keys(obj), key;
      for (var i = 0, length = keys.length; i < length; i++) {
        key = keys[i];
        if (predicate(obj[key], key, obj)) return key;
      }
    };

    // Return a copy of the object only containing the whitelisted properties.
    _.pick = function(object, oiteratee, context) {
      var result = {}, obj = object, iteratee, keys;
      if (obj == null) return result;
      if (_.isFunction(oiteratee)) {
        keys = _.allKeys(obj);
        iteratee = optimizeCb(oiteratee, context);
      } else {
        keys = flatten(arguments, false, false, 1);
        iteratee = function(value, key, obj) { return key in obj; };
        obj = Object(obj);
      }
      for (var i = 0, length = keys.length; i < length; i++) {
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
      }
      return result;
    };

     // Return a copy of the object without the blacklisted properties.
    _.omit = function(obj, iteratee, context) {
      if (_.isFunction(iteratee)) {
        iteratee = _.negate(iteratee);
      } else {
        var keys = _.map(flatten(arguments, false, false, 1), String);
        iteratee = function(value, key) {
          return !_.contains(keys, key);
        };
      }
      return _.pick(obj, iteratee, context);
    };

    // Fill in a given object with default properties.
    _.defaults = createAssigner(_.allKeys, true);

    // Creates an object that inherits from the given prototype object.
    // If additional properties are provided then they will be added to the
    // created object.
    _.create = function(prototype, props) {
      var result = baseCreate(prototype);
      if (props) _.extendOwn(result, props);
      return result;
    };

    // Create a (shallow-cloned) duplicate of an object.
    _.clone = function(obj) {
      if (!_.isObject(obj)) return obj;
      return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
    };

    // Invokes interceptor with the obj, and then returns obj.
    // The primary purpose of this method is to "tap into" a method chain, in
    // order to perform operations on intermediate results within the chain.
    _.tap = function(obj, interceptor) {
      interceptor(obj);
      return obj;
    };

    // Returns whether an object has a given set of `key:value` pairs.
    _.isMatch = function(object, attrs) {
      var keys = _.keys(attrs), length = keys.length;
      if (object == null) return !length;
      var obj = Object(object);
      for (var i = 0; i < length; i++) {
        var key = keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
      }
      return true;
    };


    // Internal recursive comparison function for `isEqual`.
    var eq = function(a, b, aStack, bStack) {
      // Identical objects are equal. `0 === -0`, but they aren't identical.
      // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
      if (a === b) return a !== 0 || 1 / a === 1 / b;
      // A strict comparison is necessary because `null == undefined`.
      if (a == null || b == null) return a === b;
      // Unwrap any wrapped objects.
      if (a instanceof _) a = a._wrapped;
      if (b instanceof _) b = b._wrapped;
      // Compare `[[Class]]` names.
      var className = toString.call(a);
      if (className !== toString.call(b)) return false;
      switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case '[object String]':
          // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
          // equivalent to `new String("5")`.
          return '' + a === '' + b;
        case '[object Number]':
          // `NaN`s are equivalent, but non-reflexive.
          // Object(NaN) is equivalent to NaN
          if (+a !== +a) return +b !== +b;
          // An `egal` comparison is performed for other numeric values.
          return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case '[object Date]':
        case '[object Boolean]':
          // Coerce dates and booleans to numeric primitive values. Dates are compared by their
          // millisecond representations. Note that invalid dates with millisecond representations
          // of `NaN` are not equivalent.
          return +a === +b;
      }

      var areArrays = className === '[object Array]';
      if (!areArrays) {
        if (typeof a != 'object' || typeof b != 'object') return false;

        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                                 _.isFunction(bCtor) && bCtor instanceof bCtor)
                            && ('constructor' in a && 'constructor' in b)) {
          return false;
        }
      }
      // Assume equality for cyclic structures. The algorithm for detecting cyclic
      // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

      // Initializing stack of traversed objects.
      // It's done here since we only need them for objects and arrays comparison.
      aStack = aStack || [];
      bStack = bStack || [];
      var length = aStack.length;
      while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
      }

      // Add the first object to the stack of traversed objects.
      aStack.push(a);
      bStack.push(b);

      // Recursively compare objects and arrays.
      if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
          if (!eq(a[length], b[length], aStack, bStack)) return false;
        }
      } else {
        // Deep compare objects.
        var keys = _.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (_.keys(b).length !== length) return false;
        while (length--) {
          // Deep compare each member
          key = keys[length];
          if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
        }
      }
      // Remove the first object from the stack of traversed objects.
      aStack.pop();
      bStack.pop();
      return true;
    };

    // Perform a deep comparison to check if two objects are equal.
    _.isEqual = function(a, b) {
      return eq(a, b);
    };

    // Is a given array, string, or object empty?
    // An "empty" object has no enumerable own-properties.
    _.isEmpty = function(obj) {
      if (obj == null) return true;
      if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
      return _.keys(obj).length === 0;
    };

    // Is a given value a DOM element?
    _.isElement = function(obj) {
      return !!(obj && obj.nodeType === 1);
    };

    // Is a given value an array?
    // Delegates to ECMA5's native Array.isArray
    _.isArray = nativeIsArray || function(obj) {
      return toString.call(obj) === '[object Array]';
    };

    // Is a given variable an object?
    _.isObject = function(obj) {
      var type = typeof obj;
      return type === 'function' || type === 'object' && !!obj;
    };

    // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
    _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
      _['is' + name] = function(obj) {
        return toString.call(obj) === '[object ' + name + ']';
      };
    });

    // Define a fallback version of the method in browsers (ahem, IE < 9), where
    // there isn't any inspectable "Arguments" type.
    if (!_.isArguments(arguments)) {
      _.isArguments = function(obj) {
        return _.has(obj, 'callee');
      };
    }

    // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
    // IE 11 (#1621), and in Safari 8 (#1929).
    if (typeof /./ != 'function' && typeof Int8Array != 'object') {
      _.isFunction = function(obj) {
        return typeof obj == 'function' || false;
      };
    }

    // Is a given object a finite number?
    _.isFinite = function(obj) {
      return isFinite(obj) && !isNaN(parseFloat(obj));
    };

    // Is the given value `NaN`? (NaN is the only number which does not equal itself).
    _.isNaN = function(obj) {
      return _.isNumber(obj) && obj !== +obj;
    };

    // Is a given value a boolean?
    _.isBoolean = function(obj) {
      return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
    };

    // Is a given value equal to null?
    _.isNull = function(obj) {
      return obj === null;
    };

    // Is a given variable undefined?
    _.isUndefined = function(obj) {
      return obj === void 0;
    };

    // Shortcut function for checking if an object has a given property directly
    // on itself (in other words, not on a prototype).
    _.has = function(obj, key) {
      return obj != null && hasOwnProperty.call(obj, key);
    };

    // Utility Functions
    // -----------------

    // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
    // previous owner. Returns a reference to the Underscore object.
    _.noConflict = function() {
      root._ = previousUnderscore;
      return this;
    };

    // Keep the identity function around for default iteratees.
    _.identity = function(value) {
      return value;
    };

    // Predicate-generating functions. Often useful outside of Underscore.
    _.constant = function(value) {
      return function() {
        return value;
      };
    };

    _.noop = function(){};

    _.property = property;

    // Generates a function for a given object that returns a given property.
    _.propertyOf = function(obj) {
      return obj == null ? function(){} : function(key) {
        return obj[key];
      };
    };

    // Returns a predicate for checking whether an object has a given set of
    // `key:value` pairs.
    _.matcher = _.matches = function(attrs) {
      attrs = _.extendOwn({}, attrs);
      return function(obj) {
        return _.isMatch(obj, attrs);
      };
    };

    // Run a function **n** times.
    _.times = function(n, iteratee, context) {
      var accum = Array(Math.max(0, n));
      iteratee = optimizeCb(iteratee, context, 1);
      for (var i = 0; i < n; i++) accum[i] = iteratee(i);
      return accum;
    };

    // Return a random integer between min and max (inclusive).
    _.random = function(min, max) {
      if (max == null) {
        max = min;
        min = 0;
      }
      return min + Math.floor(Math.random() * (max - min + 1));
    };

    // A (possibly faster) way to get the current timestamp as an integer.
    _.now = Date.now || function() {
      return new Date().getTime();
    };

     // List of HTML entities for escaping.
    var escapeMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;',
      '`': '&#x60;'
    };
    var unescapeMap = _.invert(escapeMap);

    // Functions for escaping and unescaping strings to/from HTML interpolation.
    var createEscaper = function(map) {
      var escaper = function(match) {
        return map[match];
      };
      // Regexes for identifying a key that needs to be escaped
      var source = '(?:' + _.keys(map).join('|') + ')';
      var testRegexp = RegExp(source);
      var replaceRegexp = RegExp(source, 'g');
      return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
      };
    };
    _.escape = createEscaper(escapeMap);
    _.unescape = createEscaper(unescapeMap);

    // If the value of the named `property` is a function then invoke it with the
    // `object` as context; otherwise, return it.
    _.result = function(object, property, fallback) {
      var value = object == null ? void 0 : object[property];
      if (value === void 0) {
        value = fallback;
      }
      return _.isFunction(value) ? value.call(object) : value;
    };

    // Generate a unique integer id (unique within the entire client session).
    // Useful for temporary DOM ids.
    var idCounter = 0;
    _.uniqueId = function(prefix) {
      var id = ++idCounter + '';
      return prefix ? prefix + id : id;
    };

    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
    _.templateSettings = {
      evaluate    : /<%([\s\S]+?)%>/g,
      interpolate : /<%=([\s\S]+?)%>/g,
      escape      : /<%-([\s\S]+?)%>/g
    };

    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
    var noMatch = /(.)^/;

    // Certain characters need to be escaped so that they can be put into a
    // string literal.
    var escapes = {
      "'":      "'",
      '\\':     '\\',
      '\r':     'r',
      '\n':     'n',
      '\u2028': 'u2028',
      '\u2029': 'u2029'
    };

    var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

    var escapeChar = function(match) {
      return '\\' + escapes[match];
    };

    // JavaScript micro-templating, similar to John Resig's implementation.
    // Underscore templating handles arbitrary delimiters, preserves whitespace,
    // and correctly escapes quotes within interpolated code.
    // NB: `oldSettings` only exists for backwards compatibility.
    _.template = function(text, settings, oldSettings) {
      if (!settings && oldSettings) settings = oldSettings;
      settings = _.defaults({}, settings, _.templateSettings);

      // Combine delimiters into one regular expression via alternation.
      var matcher = RegExp([
        (settings.escape || noMatch).source,
        (settings.interpolate || noMatch).source,
        (settings.evaluate || noMatch).source
      ].join('|') + '|$', 'g');

      // Compile the template source, escaping string literals appropriately.
      var index = 0;
      var source = "__p+='";
      text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace(escaper, escapeChar);
        index = offset + match.length;

        if (escape) {
          source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        } else if (interpolate) {
          source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        } else if (evaluate) {
          source += "';\n" + evaluate + "\n__p+='";
        }

        // Adobe VMs need the match returned to produce the correct offest.
        return match;
      });
      source += "';\n";

      // If a variable is not specified, place data values in local scope.
      if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

      source = "var __t,__p='',__j=Array.prototype.join," +
        "print=function(){__p+=__j.call(arguments,'');};\n" +
        source + 'return __p;\n';

      try {
        var render = new Function(settings.variable || 'obj', '_', source);
      } catch (e) {
        e.source = source;
        throw e;
      }

      var template = function(data) {
        return render.call(this, data, _);
      };

      // Provide the compiled source as a convenience for precompilation.
      var argument = settings.variable || 'obj';
      template.source = 'function(' + argument + '){\n' + source + '}';

      return template;
    };

    // Add a "chain" function. Start chaining a wrapped Underscore object.
    _.chain = function(obj) {
      var instance = _(obj);
      instance._chain = true;
      return instance;
    };

    // OOP
    // ---------------
    // If Underscore is called as a function, it returns a wrapped object that
    // can be used OO-style. This wrapper holds altered versions of all the
    // underscore functions. Wrapped objects may be chained.

    // Helper function to continue chaining intermediate results.
    var result = function(instance, obj) {
      return instance._chain ? _(obj).chain() : obj;
    };

    // Add your own custom functions to the Underscore object.
    _.mixin = function(obj) {
      _.each(_.functions(obj), function(name) {
        var func = _[name] = obj[name];
        _.prototype[name] = function() {
          var args = [this._wrapped];
          push.apply(args, arguments);
          return result(this, func.apply(_, args));
        };
      });
    };

    // Add all of the Underscore functions to the wrapper object.
    _.mixin(_);

    // Add all mutator Array functions to the wrapper.
    _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
      var method = ArrayProto[name];
      _.prototype[name] = function() {
        var obj = this._wrapped;
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        return result(this, obj);
      };
    });

    // Add all accessor Array functions to the wrapper.
    _.each(['concat', 'join', 'slice'], function(name) {
      var method = ArrayProto[name];
      _.prototype[name] = function() {
        return result(this, method.apply(this._wrapped, arguments));
      };
    });

    // Extracts the result from a wrapped and chained object.
    _.prototype.value = function() {
      return this._wrapped;
    };

    // Provide unwrapping proxy for some methods used in engine operations
    // such as arithmetic and JSON stringification.
    _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

    _.prototype.toString = function() {
      return '' + this._wrapped;
    };

    // AMD registration happens at the end for compatibility with AMD loaders
    // that may not enforce next-turn semantics on modules. Even though general
    // practice for AMD registration is to be anonymous, underscore registers
    // as a named module because, like jQuery, it is a base library that is
    // popular enough to be bundled in a third party lib, but not be part of
    // an AMD load request. Those cases could generate an error when an
    // anonymous define() is called outside of a loader request.
    if (typeof undefined === 'function' && undefined.amd) {
      undefined('underscore', [], function() {
        return _;
      });
    }
  }.call(commonjsGlobal));
  });
  var underscore_1 = underscore._;

  function handleNaNInfinityStringify(key, value) {
    if (value !== value) {
      return '0/0';
    }

    if (value === 1/0) {
      return '1/0';
    }

    if (value === -1/0) {
      return '-1/0';
    }

    return value;
  }

  function handleNaNInfinityParse(key, value) {
    if (value === '0/0') {
      return 0/0;
    }

    if (value === '1/0') {
      return Infinity;
    }

    if (value === '-1/0') {
      return -1/0;
    }

    return value;
  }

  function deepClone(s) {
    return JSON.parse(
      JSON.stringify(s, handleNaNInfinityStringify),
      handleNaNInfinityParse);
  }

  const equal$2 = function(left, right, {
    allowed_error_in_numbers = 0,
    include_error_in_number_exponents = false,
    allowed_error_is_absolute = false,
  }={}) {
    /*
     * Return true if left and right are syntactically equal.
     *
     */

    if(!(Array.isArray(left) && Array.isArray(right))) {
      if((typeof left) !== (typeof right))
        return false;

      if(typeof left === "number" && Number.isFinite(left)) {
        let tol = 1E-14;
        let minAbs = Math.min(Math.abs(left),Math.abs(right));
        if(allowed_error_is_absolute) {
          tol *= minAbs;
          if(allowed_error_in_numbers > tol) {
            tol = allowed_error_in_numbers;
          }
        }else {
          if(allowed_error_in_numbers > tol) {
            tol = allowed_error_in_numbers;
          }
          tol *= minAbs;
        }
        return Math.abs(left-right) <= tol;
      }

      return (left===right);
    }

    var leftOperator = left[0];
    var leftOperands = left.slice(1);

    var rightOperator = right[0];
    var rightOperands = right.slice(1);

    if (leftOperator !== rightOperator)
      return false;

    if (leftOperands.length !== rightOperands.length)
      return false;

    if(allowed_error_in_numbers > 0 && !include_error_in_number_exponents && leftOperator === "^") {
      let baseEqual = equal$2(leftOperands[0], rightOperands[0], {
        allowed_error_in_numbers: allowed_error_in_numbers,
        include_error_in_number_exponents: include_error_in_number_exponents,
        allowed_error_is_absolute: allowed_error_is_absolute,
    });

      if(!baseEqual) {
        return false;
      }
      let exponentEqual = equal$2(leftOperands[1], rightOperands[1]);
      return exponentEqual;
    }

    return underscore.every( underscore.zip( leftOperands, rightOperands ),
          function(pair) {
            return equal$2(pair[0], pair[1], {
              allowed_error_in_numbers: allowed_error_in_numbers,
              include_error_in_number_exponents: include_error_in_number_exponents,
              allowed_error_is_absolute: allowed_error_is_absolute,
            });
          });
  };

  const match = function( tree, pattern, params) {

    /*
     * Attempt to match the entire tree to given pattern
     *
     * Returns
     * - object describing the bindings of pattern if the entire tree
     *   was matched with those bindings
     * - false if a match was not found
     *
     *
     * In a pattern:
     * - operators much match exactly
     * - strings that are designed as variables
     *   must be bound to a subtree
     * - numbers and other strings much exactly match
     *
     * variables, if defined, specifies which strings in pattern are
     * wildcards that can be matched to any subtree
     * If defined, variables must be an object with
     *   key: string from pattern which is a wildcard
     *   values: must be one of the following
     *      - true: any subtree matches the wildcard
     *      - a regular expression: subtree must match regular expression
     *           (a non-string subtree is first passed to JSON.stringify)
     *      - a function: takes a tree as an argument and
     *           returns whether or not that tree is a valid match
     *
     * If variables is not defined, then all variables from pattern
     * will be wildcards that match any subtree
     *
     * If defined, params is an object with keys
     *   - allow_permutations: if true, check all permutations of operators
     *   - allow_implicit_identities: an array of variables from pattern
     *       that can implicitly match the identity of their enclosing
     *       operator
     *   - allow_extended_match: if true, then some tree operands can be skipped
     *       otherwise, all tree operands must be matched

     */

    var allow_extended_match=false;

    if(params === undefined)
      params = {};
    else {
      // don't let extended match parameter propagate
      if(params.allow_extended_match) {
        allow_extended_match=true;
        // copy params to new object
        params = Object.assign({}, params);
        delete params["allow_extended_match"];
      }

    }

    var variables$$1 = params["variables"];
    if(variables$$1 === undefined) {
      variables$$1 = {};
      let vip = variables(pattern);
      for(let i=0; i < vip.length;i++ ) {
        variables$$1[vip[i]] = true;
      }

      // add to params, after copying to new object
      params = Object.assign({}, params);
      params["variables"] = variables$$1;
    }

    if(pattern in variables$$1) {
      // check if tree satisfies any conditions for pattern
      let condition = variables$$1[pattern];
      if(condition !== true) {
        if(condition instanceof RegExp) {
      		if(typeof tree === 'string') {
    		    if(!tree.match(condition))
        			return false;
      		}
      		else {
    		    if(!JSON.stringify(tree).match(condition))
      			return false;
      		}
  	    }
  	    else if(typeof variables$$1[pattern] === 'function') {
      		if(!variables$$1[pattern](tree))
    		    return false;
  	    }
  	    else {
      		return false;
  	    }
    	}

    	// record the whole tree as the match to pattern
    	let result = {};
    	result[pattern] = tree;
    	return result;
    }

    if(params.allow_permutations) {
    	// even though order doesn't matter with permutations
    	// normalize to default order as it orients operators
    	// such as inequalities and containments to a direction
    	// that won't be affected by permutations
    	tree = default_order(tree);
    	pattern = default_order(pattern);
    }

    // if pattern isn't an array, the tree must be the pattern to match
    // (As there are no variables, there is no binding)
    if(!Array.isArray(pattern)) {
      if (tree === pattern)
  	    return {};
    	else
  	    return false;
    }

    var treeOperands = allChildren(tree);
    var operator=pattern[0];
    var patternOperands = pattern.slice(1);

    // Since pattern is an array, there is no match if tree isn't an array
    // of the same or larger length with the same operator
    // (unless some pattern variables can be implicitly set to identities)
    if (!Array.isArray(tree) || (tree[0] !== operator)
      || (treeOperands.length < patternOperands.length)) {

      if(Array.isArray(params.allow_implicit_identities)) {

  	    let result = matchImplicitIdentity(tree, pattern, params);
  	    if(result)
      		return result;
    	}

    	// if pattern is a multiplication and
    	// tree is a unary minus of a multiplication
    	// convert tree to a muliplication with unary minus on first factor
    	if(operator === '*' && Array.isArray(tree) && tree[0] === '-'
    	   && Array.isArray(tree[1]) && tree[1][0] === '*') {
  	    treeOperands = allChildren(tree[1]);
  	    treeOperands[0] = ['-', treeOperands[0]];
    	}
    	else
  	    return false;
    }

    let result = matchOperands(operator, treeOperands, patternOperands,
  		       params, allow_extended_match);

    if(result)
    	return result;


    if(Array.isArray(params.allow_implicit_identities))
    	return matchImplicitIdentity([operator].concat(treeOperands),
  			     pattern, params);
    else
    	return false;
  };



  function matchOperands(operator, treeOperands, patternOperands, params,
  		       allow_extended_match) {

    // treeOperands will match patternOperands only if
    // - each pattern operand can be matched by a tree operand
    //   (or a group of tree operands)
    // - if allow_extended_match, then some tree operands can be skipped
    //   otherwise, all tree operands must be matched
    // - if permutations are allowed (calculated from params and operator)
    //   patterns can be matched in any order
    //   otherwise, patterns must be matched in order, possibly skipping
    //   beginning or ending tree operands (if allow_extended_match)
    // - all the resulting bindings are consistent,
    //   meaning they assigned the same match to any
    //   repeated placeholder in pattern

    var previous_matches = patternOperands.map(v => Object());
    var nPars = patternOperands.length;

    // TODO: check if commutative
    var allow_permutations = false;
    if(params.allow_permutations &&
         (operator === "*" || operator === "+" || operator === "="
      	|| operator === "and" || operator === "or" || operator === "ne"
      	|| operator === "union" || operator === "intersect"))
    	allow_permutations=true;


    function matchOps(treeOpIndicesLeft, patternInd, matches) {

      // max group is the maximum number of tree operands that can be matched by a variable
    	let max_group = 1;
      let max_last_group = 1;

      // only allow multiple matches by variables for associative operators
      if(is_associative[operator]) {
        max_group = treeOpIndicesLeft.length - (nPars-patternInd-1);
        max_last_group = treeOpIndicesLeft.length;    }

    	if(params.max_group !== undefined)
  	    max_group = (params.max_group < max_group) ? params.max_group
    	    : max_group;
      if(params.max_last_group !== undefined)
  	    max_last_group = (params.max_last_group < max_last_group) ? params.max_last_group
    	    : max_last_group;


    	let inds_set;

    	if(!allow_extended_match && patternInd === nPars-1) {
  	    // if no extended match, then the last pattern operand
  	    // must match the remaining tree operands
        if(treeOpIndicesLeft.length <= max_last_group) {
          inds_set = [treeOpIndicesLeft];
        }
        else {
          return false;
        }
    	}
    	else if(allow_permutations) {
  	    inds_set = subsets(treeOpIndicesLeft, max_group);
    	}
    	else {
  	    inds_set = [];
  	    for(let i=1; i <= max_group; i++)
  	    	inds_set.push(treeOpIndicesLeft.slice(0, i));

    	}

    	for(let inds of inds_set) {

  	    let m = previous_matches[patternInd][inds];

  	    if(m === undefined) {

      		let treeChunk = inds.reduce(function(a,b) {
    		    return a.concat([treeOperands[b]]);}, []);

      		if(treeChunk.length > 1)
    		    treeChunk= [operator].concat(treeChunk);
      		else
    		    treeChunk = treeChunk[0];

      		m = match(treeChunk, patternOperands[patternInd], params);

      		previous_matches[patternInd][inds] = m;

  	    }

  	    if(!m)
      		continue;

  	    // Check consistency of bindings
  	    if (!underscore.every( underscore.intersection(
          		Object.keys( matches ),
          		Object.keys( m ) ),
      			 function(k) {
    			     return equal$2(matches[k], m[k]);
      			 })) {
      		continue;
  	    }

  	    // combine matches
  	    let combined_matches = Object.assign({}, m);
  	    Object.assign( combined_matches, matches );

  	    let treeOpIndices = treeOpIndicesLeft.filter(
        		v => !inds.includes(v));

  	    // if last pattern operand, we're done
  	    if(patternInd === nPars-1) {
      		let skipped = treeOpIndices.reduce(function(a,b) {
      		    return a.concat([treeOperands[b]]);}, []);

      		return {matches: combined_matches, skipped: skipped};
  	    }

  	    // attempt to match remaining treeOps
  	    // with remaining pattern operands
  	    let results = matchOps(treeOpIndices, patternInd+1,
  			   combined_matches);

  	    if(results) {
      		return results;
  	    }
    	}

    	return false;
    }

    var matches = {};

    // create array of 0, 1, ...., treeOperands.length-1
    var treeIndices = [...Array(treeOperands.length).keys()];

    if(allow_permutations) {

    	let m = matchOps(treeIndices, 0, {});

    	if(!m)
  	    return false;

    	matches = m.matches;
    	if(m.skipped.length > 0)
  	    matches['_skipped'] = m.skipped;

    	return matches;
    }
    else {
    	let maxSkip = allow_extended_match ? treeOperands.length - nPars : 0;
    	let skipped_before = [];
    	let m;

    	// without permutations, operands can only be skipped
    	// at beggining or end
    	// (matchOps will skip at end but not at beginning
    	// when permutations are not allowed)
    	for(let initialSkip=0; initialSkip <= maxSkip; initialSkip++ ) {

  	    m = matchOps(treeIndices, 0, {});

  	    if(m)
      		break;

  	    treeIndices = treeIndices.slice(1);
  	    skipped_before.push(treeOperands[initialSkip]);
    	}

    	if(!m)
  	    return false;

    	matches = m.matches;
    	if(m.skipped.length > 0)
  	    matches['_skipped'] = m.skipped;
    	if(skipped_before.length > 0)
  	    matches['_skipped_before'] = skipped_before;
    	return matches;

    }
  }

  function matchImplicitIdentity(tree, pattern, params) {

    var operator = pattern[0];
    var patternOperands = pattern.slice(1);

    // for now, implement implicit identities just
    // for addition, multiplication, and exponents
    if(!(operator === '+' || operator === '*' || operator === '^'))
    	return false;

    // find any pattern operand that is allowed to be an implicit identity
    var implicit_identity = null;
    for(let i=0; i < patternOperands.length; i++) {
    	let po = patternOperands[i];
    	if(typeof po === 'string' &&
      	   params.allow_implicit_identities.includes(po)) {
  	    implicit_identity = po;
  	    break;
    	}
    }

    if(implicit_identity === null)
    	return false;

    var matches = {};

    // match implicit_identity to the identity of the operator
    if(operator === '+')
    	matches[implicit_identity] = 0;
    else
    	matches[implicit_identity] = 1;

    // special case where tree beings with unary -
    // and pattern is a multiplication where implicit identity is a factor
    if(operator === '*' && patternOperands.includes(implicit_identity)
         && Array.isArray(tree) && tree[0] === '-') {
    	matches[implicit_identity] = -1;
    	tree = tree[1];
    }

    // remove matched variable from pattern
    var matched_ind = patternOperands.indexOf(implicit_identity);
    patternOperands.splice(matched_ind,1);

    // for exponentiation, only allow for identity in exponent
    if(operator === '^' && matched_ind === 0)
    	return false;

    if(patternOperands.length === 1) {
    	pattern = patternOperands[0];
    }
    else {
    	pattern = [operator].concat(patternOperands);
    }

    var m = match(tree, pattern, params);

    if (m) {
    	// Check consistency of bindings
    	if(implicit_identity in m) {
  	    if(!equal$2(m[implicit_identity], matches[implicit_identity]))
  		return false;
    	}
    	Object.assign( matches, m);
    } else
    	return false;

    return matches;
  }


  const substitute = function( pattern, bindings ) {
    if (typeof pattern === 'number') {
    	return pattern;
    }

    if (typeof pattern === 'string') {
    	if (bindings[pattern] !== undefined)
  	    return deepClone(bindings[pattern]);

    	return pattern;
    }

    if (Array.isArray(pattern)) {
    	return [pattern[0]].concat( pattern.slice(1).map( function(p) {
  	    return substitute(p, bindings);
    	}) );
    }

    return [];
  };

  const transform$2 = function( tree, F ) {
    /*
     * Transform the tree function F in a bottom-up fashion
     * (calling F at children before parents)
     *
     * F must be be a function that returns a tree
     */

    if (Array.isArray(tree)) {
    	let new_tree = [tree[0]];
    	for( let i=1; i<tree.length; i++ ) {
  	    new_tree.push(transform$2(tree[i], F));
    	}
    	return F(new_tree);
    }

    return F(tree);
  };

  const applyAllTransformations = function( tree, transformations, depth ) {
    /*
     * Repeatedly apply all transformations from transformations
     * to tree and return the resulting tree.
     *
     * transformations must be an array of arrays of the form
     * [pattern, replacement, params]
     * where the last two components are optional
     */

    if (depth === undefined)
      depth = 5;

    var new_tree = tree;
    var old_tree;
    for( ; depth > 0; depth-- ) {
    	old_tree = new_tree;
    	for(let i=0; i<transformations.length; i++) {
  	    let pattern = transformations[i][0];
  	    let replacement = transformations[i][1];
  	    let params = transformations[i][2];
  	    if(params === undefined)
      		params = {};
  	    new_tree = transform$2(new_tree, function(subtree) {
  		    let m = match(subtree, pattern, params);
  		    if (m) {
      			let result= substitute(replacement, m);

      			if(params.evaluate_numbers)
    			    result = evaluate_numbers(
        				result, {max_digits: params.max_digits});

      			let add_right=[], add_left=[];
      			if(m._skipped) {
    			    add_right = m._skipped;
      			}
      			if(m._skipped_before) {
    			    add_left = m._skipped_before;
      			}

      			if(add_left.length > 0 || add_right.length > 0) {
    			    if(Array.isArray(result)) {
        				if(result[0]===pattern[0]) {
      				    result = result.slice(1);
        				}
        				else {
      				    result = [result];
        				}
    			    }
    			    result=[pattern[0]].concat(
          				add_left, result, add_right);
      			}

      			if(params.evaluate_numbers)
    			    result = evaluate_numbers(
          				result, {max_digits: params.max_digits});

      			return result;
  		    }
  		    else {
      			return subtree;
  		    }
    		});

    	}

    	if(equal$2(old_tree, new_tree)) {
  	    return new_tree;
    	}
    }

    return new_tree;
  };

  var endsWith = string.endsWith;
  var clone$11 = object.clone;


  function factory$278 (type, config, load, typed, math) {
    var add       = load(addScalar);
    var subtract  = load(subtract$1);
    var multiply  = load(multiplyScalar);
    var divide    = load(divideScalar);
    var pow       = load(pow$1);
    var abs       = load(abs$1);
    var fix       = load(fix$1);
    var round     = load(round$1);
    var equal     = load(equal$1);
    var isNumeric = load(isNumeric$1);
    var format    = load(format$8);
    var getTypeOf = load(_typeof$1);
    var toNumber  = load(number$3);
    var Complex   = load(Complex_1);

    /**
     * A unit can be constructed in the following ways:
     *     var a = new Unit(value, name);
     *     var b = new Unit(null, name);
     *     var c = Unit.parse(str);
     *
     * Example usage:
     *     var a = new Unit(5, 'cm');               // 50 mm
     *     var b = Unit.parse('23 kg');             // 23 kg
     *     var c = math.in(a, new Unit(null, 'm');  // 0.05 m
     *     var d = new Unit(9.81, "m/s^2");         // 9.81 m/s^2
     *
     * @class Unit
     * @constructor Unit
     * @param {number | BigNumber | Fraction | Complex | boolean} [value]  A value like 5.2
     * @param {string} [name]   A unit name like "cm" or "inch", or a derived unit of the form: "u1[^ex1] [u2[^ex2] ...] [/ u3[^ex3] [u4[^ex4]]]", such as "kg m^2/s^2", where each unit appearing after the forward slash is taken to be in the denominator. "kg m^2 s^-2" is a synonym and is also acceptable. Any of the units can include a prefix.
     */
    function Unit(value, name) {
      if (!(this instanceof Unit)) {
        throw new Error('Constructor must be called with the new operator');
      }

      if (!(value == undefined || isNumeric(value) || type.isComplex(value))) {
        throw new TypeError('First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined');
      }
      if (name != undefined && (typeof name !== 'string' || name === '')) {
        throw new TypeError('Second parameter in Unit constructor must be a string');
      }

      if (name != undefined) {
        var u = Unit.parse(name);
        this.units = u.units;
        this.dimensions = u.dimensions;
      }
      else {
        this.units = [
          {
            unit: UNIT_NONE,
            prefix: PREFIXES.NONE,  // link to a list with supported prefixes
            power: 0
          }
        ];
        this.dimensions = []; 
        for(var i=0; i<BASE_DIMENSIONS.length; i++) {
          this.dimensions[i] = 0;
        }
      }

      this.value = (value != undefined) ? this._normalize(value) : null;

      this.fixPrefix = false; // if true, function format will not search for the
                              // best prefix but leave it as initially provided.
                              // fixPrefix is set true by the method Unit.to

      // The justification behind this is that if the constructor is explicitly called,
      // the caller wishes the units to be returned exactly as he supplied.
      this.isUnitListSimplified = true;

    }

    /**
     * Attach type information
     */
    Unit.prototype.type = 'Unit';
    Unit.prototype.isUnit = true;

    // private variables and functions for the Unit parser
    var text, index, c;

    function skipWhitespace() {
      while (c == ' ' || c == '\t') {
        next();
      }
    }

    function isDigitDot(c) {
      return ((c >= '0' && c <= '9') || c == '.');
    }

    function isDigit(c) {
      return ((c >= '0' && c <= '9'));
    }

    function next() {
      index++;
      c = text.charAt(index);
    }

    function revert(oldIndex) {
      index = oldIndex;
      c = text.charAt(index);
    }

    function parseNumber() {
      var number = '';
      var oldIndex;
      oldIndex = index;

      if (c == '+') {
        next();
      }
      else if (c == '-') {
        number += c;
        next();
      }

      if (!isDigitDot(c)) {
        // a + or - must be followed by a digit
        revert(oldIndex);
        return null;
      }

      // get number, can have a single dot
      if (c == '.') {
        number += c;
        next();
        if (!isDigit(c)) {
          // this is no legal number, it is just a dot
          revert(oldIndex);
          return null;
        }
      }
      else {
        while (isDigit(c)) {
          number += c;
          next();
        }
        if (c == '.') {
          number += c;
          next();
        }
      }
      while (isDigit(c)) {
        number += c;
        next();
      }

      // check for exponential notation like "2.3e-4" or "1.23e50"
      if (c == 'E' || c == 'e') {
        // The grammar branches here. This could either be part of an exponent or the start of a unit that begins with the letter e, such as "4exabytes"

        var tentativeNumber = '';
        var tentativeIndex = index;

        tentativeNumber += c;
        next();

        if (c == '+' || c == '-') {
          tentativeNumber += c;
          next();
        }

        // Scientific notation MUST be followed by an exponent (otherwise we assume it is not scientific notation)
        if (!isDigit(c)) {
          // The e or E must belong to something else, so return the number without the e or E.
          revert(tentativeIndex);
          return number;
        }
        
        // We can now safely say that this is scientific notation.
        number = number + tentativeNumber;
        while (isDigit(c)) {
          number += c;
          next();
        }
      }

      return number;
    }

    function parseUnit() {
      var unitName = '';

      // Alphanumeric characters only; matches [a-zA-Z0-9]
      var code = text.charCodeAt(index);
      while ( (code >= 48 && code <= 57) ||
              (code >= 65 && code <= 90) ||
              (code >= 97 && code <= 122)) {
        unitName += c;
        next();
        code = text.charCodeAt(index);
      }

      // Must begin with [a-zA-Z]
      code = unitName.charCodeAt(0);
      if ((code >= 65 && code <= 90) ||
          (code >= 97 && code <= 122)) {
          return unitName || null;
      } 
      else {
        return null;
      }
    }

    function parseCharacter(toFind) {
      if (c === toFind) {
        next();
        return toFind;
      }
      else {
        return null;
      }
    }

    /**
     * Parse a string into a unit. The value of the unit is parsed as number,
     * BigNumber, or Fraction depending on the math.js config setting `number`.
     *
     * Throws an exception if the provided string does not contain a valid unit or
     * cannot be parsed.
     * @memberof Unit
     * @param {string} str        A string like "5.2 inch", "4e2 cm/s^2"
     * @return {Unit} unit
     */
    Unit.parse = function (str, options) {
      options = options || {};
      text = str;
      index = -1;
      c = '';

      if (typeof text !== 'string') {
        throw new TypeError('Invalid argument in Unit.parse, string expected');
      }

      var unit = new Unit();
      unit.units = [];

      var powerMultiplierCurrent = 1;
      var expectingUnit = false;

      // A unit should follow this pattern:
      // [number] ...[ [*/] unit[^number] ]
      // unit[^number] ... [ [*/] unit[^number] ]

      // Rules:
      // number is any floating point number.
      // unit is any alphanumeric string beginning with an alpha. Units with names like e3 should be avoided because they look like the exponent of a floating point number!
      // The string may optionally begin with a number.
      // Each unit may optionally be followed by ^number.
      // Whitespace or a forward slash is recommended between consecutive units, although the following technically is parseable:
      //   2m^2kg/s^2
      // it is not good form. If a unit starts with e, then it could be confused as a floating point number:
      //   4erg

      next();
      skipWhitespace();

      // Optional number at the start of the string
      var valueStr = parseNumber();
      var value = null;
      if(valueStr) {
        if (config.number === 'BigNumber') {
          value = new type.BigNumber(valueStr);
        }
        else if (config.number === 'Fraction') {
          value = new type.Fraction(valueStr);
        }
        else { // number
          value = parseFloat(valueStr);
        }

        skipWhitespace();    // Whitespace is not required here

        // handle multiplication or division right after the value, like '1/s'
        if (parseCharacter('*')) {
          powerMultiplierCurrent = 1;
          expectingUnit = true;
        }
        else if (parseCharacter('/')) {
          powerMultiplierCurrent = -1;
          expectingUnit = true;
        }
      }

      // Stack to keep track of powerMultipliers applied to each parentheses group
      var powerMultiplierStack = [];

      // Running product of all elements in powerMultiplierStack
      var powerMultiplierStackProduct = 1;

      while (true) {
        skipWhitespace();

        // Check for and consume opening parentheses, pushing powerMultiplierCurrent to the stack
        // A '(' will always appear directly before a unit.
        while (c === '(') {
          powerMultiplierStack.push(powerMultiplierCurrent);
          powerMultiplierStackProduct *= powerMultiplierCurrent;
          powerMultiplierCurrent = 1;
          next();
          skipWhitespace();
        }

        // Is there something here?
        if(c) {
          var oldC = c;
          var uStr = parseUnit();
          if(uStr == null) {
            throw new SyntaxError('Unexpected "' + oldC + '" in "' + text + '" at index ' + index.toString());
          }
        }
        else {
          // End of input.
          break;
        }

        // Verify the unit exists and get the prefix (if any)
        var res = _findUnit(uStr);
        if(res == null) {
          // Unit not found.
          throw new SyntaxError('Unit "' + uStr + '" not found.');
        }

        var power = powerMultiplierCurrent * powerMultiplierStackProduct;
        // Is there a "^ number"?
        skipWhitespace();
        if (parseCharacter('^')) {
          skipWhitespace();
          var p = parseNumber();
          if(p == null) {
            // No valid number found for the power!
            throw new SyntaxError('In "' + str + '", "^" must be followed by a floating-point number');
          }
          power *= p;
        }

        // Add the unit to the list
        unit.units.push( {
          unit: res.unit,
          prefix: res.prefix,
          power: power
        });
        for(var i=0; i<BASE_DIMENSIONS.length; i++) {
          unit.dimensions[i] += (res.unit.dimensions[i] || 0) * power;
        }

        // Check for and consume closing parentheses, popping from the stack.
        // A ')' will always follow a unit.
        skipWhitespace();
        while (c === ')') {
          if(powerMultiplierStack.length === 0) {
            throw new SyntaxError('Unmatched ")" in "' + text + '" at index ' + index.toString());
          }
          powerMultiplierStackProduct /= powerMultiplierStack.pop();
          next();
          skipWhitespace();
        }

        // "*" and "/" should mean we are expecting something to come next.
        // Is there a forward slash? If so, negate powerMultiplierCurrent. The next unit or paren group is in the denominator.
        expectingUnit = false;

        if (parseCharacter('*')) {
          // explicit multiplication
          powerMultiplierCurrent = 1;
          expectingUnit = true;
        }
        else if (parseCharacter('/')) {
          // division
          powerMultiplierCurrent = -1;
          expectingUnit = true;
        }
        else {
          // implicit multiplication
          powerMultiplierCurrent = 1;
        }

        // Replace the unit into the auto unit system
        if(res.unit.base) {
          var baseDim = res.unit.base.key;
          UNIT_SYSTEMS.auto[baseDim] = {
            unit: res.unit,
            prefix: res.prefix
          };
        }
      }
      
      // Has the string been entirely consumed?
      skipWhitespace();
      if(c) {
        throw new SyntaxError('Could not parse: "' + str + '"');
      }

      // Is there a trailing slash?
      if(expectingUnit) {
        throw new SyntaxError('Trailing characters: "' + str + '"');
      }

      // Is the parentheses stack empty?
      if(powerMultiplierStack.length !== 0) {
        throw new SyntaxError('Unmatched "(" in "' + text + '"');
      }

      // Are there any units at all?
      if(unit.units.length == 0 && !options.allowNoUnits) {
        throw new SyntaxError('"' + str + '" contains no units');
      }

      unit.value = (value != undefined) ? unit._normalize(value) : null;
      return unit;
    };

    /**
     * create a copy of this unit
     * @memberof Unit
     * @return {Unit} Returns a cloned version of the unit
     */
    Unit.prototype.clone = function () {
      var unit = new Unit();

      unit.fixPrefix = this.fixPrefix;
      unit.isUnitListSimplified = this.isUnitListSimplified;

      unit.value = clone$11(this.value);
      unit.dimensions = this.dimensions.slice(0);
      unit.units = [];
      for(var i = 0; i < this.units.length; i++) {
        unit.units[i] = { };
        for (var p in this.units[i]) {
          if (this.units[i].hasOwnProperty(p)) {
            unit.units[i][p] = this.units[i][p];
          }
        }
      }

      return unit;
    };

    /**
     * Return whether the unit is derived (such as m/s, or cm^2, but not N)
     * @memberof Unit
     * @return {boolean} True if the unit is derived
     */
    Unit.prototype._isDerived = function() {
      if(this.units.length === 0) {
        return false;
      }
      return this.units.length > 1 || Math.abs(this.units[0].power - 1.0) > 1e-15;
    };

    /**
     * Normalize a value, based on its currently set unit(s)
     * @memberof Unit
     * @param {number | BigNumber | Fraction | boolean} value
     * @return {number | BigNumber | Fraction | boolean} normalized value
     * @private
     */
    Unit.prototype._normalize = function (value) {
      var unitValue, unitOffset, unitPower, unitPrefixValue;
      var convert;

      if (value == null || this.units.length === 0) {
        return value;
      }
      else if (this._isDerived()) {
        // This is a derived unit, so do not apply offsets.
        // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
        var res = value;
        convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed

        for(var i=0; i < this.units.length; i++) {
          unitValue       = convert(this.units[i].unit.value);
          unitPrefixValue = convert(this.units[i].prefix.value);
          unitPower       = convert(this.units[i].power);
          res = multiply(res, pow(multiply(unitValue, unitPrefixValue), unitPower));
        }

        return res;
      }
      else {
        // This is a single unit of power 1, like kg or degC
        convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed

        unitValue       = convert(this.units[0].unit.value);
        unitOffset      = convert(this.units[0].unit.offset);
        unitPrefixValue = convert(this.units[0].prefix.value);

        return multiply(add(value, unitOffset), multiply(unitValue, unitPrefixValue));
      }
    };

    /**
     * Denormalize a value, based on its currently set unit(s)
     * @memberof Unit
     * @param {number} value
     * @param {number} [prefixValue]    Optional prefix value to be used (ignored if this is a derived unit)
     * @return {number} denormalized value
     * @private
     */
    Unit.prototype._denormalize = function (value, prefixValue) {
      var unitValue, unitOffset, unitPower, unitPrefixValue;
      var convert;

      if (value == null || this.units.length === 0) {
        return value;
      }
      else if (this._isDerived()) {
        // This is a derived unit, so do not apply offsets.
        // For example, with J kg^-1 degC^-1 you would NOT want to apply the offset.
        // Also, prefixValue is ignored--but we will still use the prefix value stored in each unit, since kg is usually preferable to g unless the user decides otherwise.
        var res = value;
        convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed

        for (var i = 0; i < this.units.length; i++) {
          unitValue       = convert(this.units[i].unit.value);
          unitPrefixValue = convert(this.units[i].prefix.value);
          unitPower       = convert(this.units[i].power);
          res = divide(res, pow(multiply(unitValue, unitPrefixValue), unitPower));
        }

        return res;
      }
      else {
        // This is a single unit of power 1, like kg or degC
        convert = Unit._getNumberConverter(getTypeOf(value)); // convert to Fraction or BigNumber if needed

        unitValue       = convert(this.units[0].unit.value);
        unitPrefixValue = convert(this.units[0].prefix.value);
        unitOffset      = convert(this.units[0].unit.offset);

        if (prefixValue == undefined) {
          return subtract(divide(divide(value, unitValue), unitPrefixValue), unitOffset);
        }
        else {
          return subtract(divide(divide(value, unitValue), prefixValue), unitOffset);
        }
      }
    };

    /**
     * Find a unit from a string
     * @memberof Unit
     * @param {string} str              A string like 'cm' or 'inch'
     * @returns {Object | null} result  When found, an object with fields unit and
     *                                  prefix is returned. Else, null is returned.
     * @private
     */
    function _findUnit(str) {
    
      // First, match units names exactly. For example, a user could define 'mm' as 10^-4 m, which is silly, but then we would want 'mm' to match the user-defined unit.
      if(UNITS.hasOwnProperty(str)) {
        var unit = UNITS[str];
        var prefix = unit.prefixes[''];
        return {
          unit: unit,
          prefix: prefix
        }
      }

      for (var name in UNITS) {
        if (UNITS.hasOwnProperty(name)) {
          if (endsWith(str, name)) {
            var unit = UNITS[name];
            var prefixLen = (str.length - name.length);
            var prefixName = str.substring(0, prefixLen);
            var prefix = unit.prefixes.hasOwnProperty(prefixName)
                ? unit.prefixes[prefixName]
                : undefined;
            if (prefix !== undefined) {
              // store unit, prefix, and value
              return {
                unit: unit,
                prefix: prefix
              };
            }
          }
        }
      }

      return null;
    }

    /**
     * Test if the given expression is a unit.
     * The unit can have a prefix but cannot have a value.
     * @memberof Unit
     * @param {string} name   A string to be tested whether it is a value less unit.
     *                        The unit can have prefix, like "cm"
     * @return {boolean}      true if the given string is a unit
     */
    Unit.isValuelessUnit = function (name) {
      return (_findUnit(name) != null);
    };

    /**
     * check if this unit has given base unit
     * If this unit is a derived unit, this will ALWAYS return false, since by definition base units are not derived.
     * @memberof Unit
     * @param {BASE_UNITS | string | undefined} base
     */
    Unit.prototype.hasBase = function (base) {

      if(typeof(base) === "string") {
        base = BASE_UNITS[base];
      }

      if(!base)
        return false;


      // All dimensions must be the same
      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
        if (Math.abs((this.dimensions[i] || 0) - (base.dimensions[i] || 0)) > 1e-12) {
          return false;
        }
      }
      return true;

    };

    /**
     * Check if this unit has a base or bases equal to another base or bases
     * For derived units, the exponent on each base also must match
     * @memberof Unit
     * @param {Unit} other
     * @return {boolean} true if equal base
     */
    Unit.prototype.equalBase = function (other) {
      // All dimensions must be the same
      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
        if (Math.abs((this.dimensions[i] || 0) - (other.dimensions[i] || 0)) > 1e-12) {
          return false;
        }
      }
      return true;
    };

    /**
     * Check if this unit equals another unit
     * @memberof Unit
     * @param {Unit} other
     * @return {boolean} true if both units are equal
     */
    Unit.prototype.equals = function (other) {
      return (this.equalBase(other) && equal(this.value, other.value));
    };

    /**
     * Multiply this unit with another one
     * @memberof Unit
     * @param {Unit} other
     * @return {Unit} product of this unit and the other unit
     */
    Unit.prototype.multiply = function (other) {
      var res = this.clone();
      
      for(var i = 0; i<BASE_DIMENSIONS.length; i++) {
        // Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) + (other.dimensions[i] || 0);
      }

      // Append other's units list onto res (simplify later in Unit.prototype.format)
      for(var i=0; i<other.units.length; i++) {
        // Make a deep copy
        var inverted = {};
        for(var key in other.units[i]) {
          inverted[key] = other.units[i][key];
        }
        res.units.push(inverted);
      }

      // If at least one operand has a value, then the result should also have a value
      if(this.value != null || other.value != null) {
        var valThis = this.value == null ? this._normalize(1) : this.value;
        var valOther = other.value == null ? other._normalize(1) : other.value;
        res.value = multiply(valThis, valOther);
      }
      else {
        res.value = null;
      }

      // Trigger simplification of the unit list at some future time
      res.isUnitListSimplified = false;

      return getNumericIfUnitless(res);
    };

    /**
     * Divide this unit by another one
     * @memberof Unit
     * @param {Unit} other
     * @return {Unit} result of dividing this unit by the other unit
     */
    Unit.prototype.divide = function (other) {
      var res = this.clone();
      
      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
        // Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) - (other.dimensions[i] || 0);
      }

      // Invert and append other's units list onto res (simplify later in Unit.prototype.format)
      for(var i=0; i<other.units.length; i++) {
        // Make a deep copy
        var inverted = {};
        for(var key in other.units[i]) {
          inverted[key] = other.units[i][key];
        }
        inverted.power = -inverted.power;
        res.units.push(inverted);
      }

      // If at least one operand has a value, the result should have a value
      if (this.value != null || other.value != null) {
        var valThis = this.value == null ? this._normalize(1) : this.value;
        var valOther = other.value == null ? other._normalize(1) : other.value;
        res.value = divide(valThis, valOther);
      }
      else {
        res.value = null;
      }

      // Trigger simplification of the unit list at some future time
      res.isUnitListSimplified = false;

      return getNumericIfUnitless(res);
    };

    /**
     * Calculate the power of a unit
     * @memberof Unit
     * @param {number | Fraction | BigNumber} p
     * @returns {Unit}      The result: this^p
     */
    Unit.prototype.pow = function (p) {
      var res = this.clone();
      
      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
        // Dimensions arrays may be of different lengths. Default to 0.
        res.dimensions[i] = (this.dimensions[i] || 0) * p;
      }

      // Adjust the power of each unit in the list
      for(var i=0; i<res.units.length; i++) {
        res.units[i].power *= p;
      }

      if(res.value != null) {
        res.value = pow(res.value, p);

        // only allow numeric output, we don't want to return a Complex number
        //if (!isNumeric(res.value)) {
        //  res.value = NaN;
        //}
        // Update: Complex supported now
      }
      else {
        res.value = null;
      }

      // Trigger lazy evaluation of the unit list
      res.isUnitListSimplified = false;

      return getNumericIfUnitless(res);
    };

    /**
     * Return the numeric value of this unit if it is dimensionless, has a value, and config.predictable == false; or the original unit otherwise
     * @param {Unit} unit
     * @returns {number | Fraction | BigNumber | Unit}  The numeric value of the unit if conditions are met, or the original unit otherwise
     */
    var getNumericIfUnitless = function(unit) {
      if(unit.equalBase(BASE_UNITS.NONE) && unit.value !== null && !config.predictable) {
        return unit.value;
      }
      else {
        return unit;
      }
    };
      

    /**
     * Calculate the absolute value of a unit
     * @memberof Unit
     * @param {number | Fraction | BigNumber} x
     * @returns {Unit}      The result: |x|, absolute value of x
     */
    Unit.prototype.abs = function () {
      // This gives correct, but unexpected, results for units with an offset.
      // For example, abs(-283.15 degC) = -263.15 degC !!!
      var ret = this.clone();
      ret.value = ret.value !== null ? abs(ret.value) : null;

      for(var i in ret.units) {
        if(ret.units[i].unit.name === 'VA' || ret.units[i].unit.name === 'VAR') {
          ret.units[i].unit = UNITS["W"];
        }
      }

      return ret;
    };

    /**
     * Convert the unit to a specific unit name.
     * @memberof Unit
     * @param {string | Unit} valuelessUnit   A unit without value. Can have prefix, like "cm"
     * @returns {Unit} Returns a clone of the unit with a fixed prefix and unit.
     */
    Unit.prototype.to = function (valuelessUnit) {
      var other;
      var value = this.value == null ? this._normalize(1) : this.value;
      if (typeof valuelessUnit === 'string') {
        //other = new Unit(null, valuelessUnit);
        other = Unit.parse(valuelessUnit);
        if (!this.equalBase(other)) {
          throw new Error('Units do not match');
        }
        if (other.value !== null) {
          throw new Error('Cannot convert to a unit with a value');
        }

        other.value = clone$11(value);
        other.fixPrefix = true;
        other.isUnitListSimplified = true;
        return other;
      }
      else if (type.isUnit(valuelessUnit)) {
        if (!this.equalBase(valuelessUnit)) {
          throw new Error('Units do not match');
        }
        if (valuelessUnit.value !== null) {
          throw new Error('Cannot convert to a unit with a value');
        }
        other = valuelessUnit.clone();
        other.value = clone$11(value);
        other.fixPrefix = true;
        other.isUnitListSimplified = true;
        return other;
      }
      else {
        throw new Error('String or Unit expected as parameter');
      }
    };

    /**
     * Return the value of the unit when represented with given valueless unit
     * @memberof Unit
     * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
     * @return {number} Returns the unit value as number.
     */
    // TODO: deprecate Unit.toNumber? It's always better to use toNumeric
    Unit.prototype.toNumber = function (valuelessUnit) {
      return toNumber(this.toNumeric(valuelessUnit));
    };

    /**
     * Return the value of the unit in the original numeric type
     * @memberof Unit
     * @param {string | Unit} valuelessUnit    For example 'cm' or 'inch'
     * @return {number | BigNumber | Fraction} Returns the unit value
     */
    Unit.prototype.toNumeric = function (valuelessUnit) {
      var other = this;
      if(valuelessUnit) {
        // Allow getting the numeric value without converting to a different unit
        other = this.to(valuelessUnit);
      }

      other.simplifyUnitListLazy();

      if(other._isDerived()) {
        return other._denormalize(other.value);
      }
      else {
        return other._denormalize(other.value, other.units[0].prefix.value);
      }
    };

    /**
     * Get a string representation of the unit.
     * @memberof Unit
     * @return {string}
     */
    Unit.prototype.toString = function () {
      return this.format();
    };

    /**
     * Get a JSON representation of the unit
     * @memberof Unit
     * @returns {Object} Returns a JSON object structured as:
     *                   `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
     */
    Unit.prototype.toJSON = function () {
      return {
        mathjs: 'Unit',
        value: this._denormalize(this.value),
        unit: this.formatUnits(),
        fixPrefix: this.fixPrefix
      };
    };

    /**
     * Instantiate a Unit from a JSON object
     * @memberof Unit
     * @param {Object} json  A JSON object structured as:
     *                       `{"mathjs": "Unit", "value": 2, "unit": "cm", "fixPrefix": false}`
     * @return {Unit}
     */
    Unit.fromJSON = function (json) {
      var unit = new Unit(json.value, json.unit);
      unit.fixPrefix = json.fixPrefix || false;
      return unit;
    };

    /**
     * Returns the string representation of the unit.
     * @memberof Unit
     * @return {string}
     */
    Unit.prototype.valueOf = Unit.prototype.toString;

    /**
     * Attempt to simplify the list of units for this unit according to the dimensions array and the current unit system. After the call, this Unit will contain a list of the "best" units for formatting.
     * Intended to be evaluated lazily. You must set isUnitListSimplified = false before the call! After the call, isUnitListSimplified will be set to true.
     */
    Unit.prototype.simplifyUnitListLazy = function() {

      if (this.isUnitListSimplified || this.value == null) {
        return;
      }

      var proposedUnitList = [];

      // Search for a matching base
      var matchingBase;
      for(var key in currentUnitSystem) {
        if(this.hasBase(BASE_UNITS[key])) {
          matchingBase = key;
          break;
        }
      }

      if(matchingBase === 'NONE')
      {
        this.units = [];
      }
      else {
        var matchingUnit;
        if(matchingBase) {
          // Does the unit system have a matching unit?
          if(currentUnitSystem.hasOwnProperty(matchingBase)) {
            matchingUnit = currentUnitSystem[matchingBase];
          }
        }
        if(matchingUnit) {
          this.units = [{
            unit: matchingUnit.unit,
            prefix: matchingUnit.prefix,
            power: 1.0
          }];
        }
        else {
          // Multiple units or units with powers are formatted like this:
          // 5 (kg m^2) / (s^3 mol)
          // Build an representation from the base units of the current unit system
          var missingBaseDim = false;
          for(var i=0; i<BASE_DIMENSIONS.length; i++) {
            var baseDim = BASE_DIMENSIONS[i];
            if(Math.abs(this.dimensions[i] || 0) > 1e-12) {
              if(currentUnitSystem.hasOwnProperty(baseDim)) {
                proposedUnitList.push({
                  unit: currentUnitSystem[baseDim].unit,
                  prefix: currentUnitSystem[baseDim].prefix,
                  power: this.dimensions[i] || 0
                });
              }
              else {
                missingBaseDim = true;
              }
            }
          }

          // Is the proposed unit list "simpler" than the existing one?
          if(proposedUnitList.length < this.units.length && !missingBaseDim) {
            // Replace this unit list with the proposed list
            this.units = proposedUnitList;
          }
        }
      }

      this.isUnitListSimplified = true;
    };

    Unit.prototype.toSI = function() {

      var ret = this.clone();

      var proposedUnitList = [];
      for(var i=0; i<BASE_DIMENSIONS.length; i++) {
        var baseDim = BASE_DIMENSIONS[i];
        if(Math.abs(ret.dimensions[i] || 0) > 1e-12) {
          if(UNIT_SYSTEMS["si"].hasOwnProperty(baseDim)) {
            proposedUnitList.push({
              unit: UNIT_SYSTEMS["si"][baseDim].unit,
              prefix: UNIT_SYSTEMS["si"][baseDim].prefix,
              power: ret.dimensions[i] || 0
            });
          }
          else {
            throw new Error("Cannot express custom unit " + baseDim + " in SI units");
          }
        }
      }

      // Replace this unit list with the proposed list
      ret.units = proposedUnitList;

      ret.isUnitListSimplified = true;

      return ret;
    };

    /**
     * Get a string representation of the units of this Unit, without the value.
     * @memberof Unit
     * @return {string}
     */
    Unit.prototype.formatUnits = function () {

      // Lazy evaluation of the unit list
      this.simplifyUnitListLazy();

      var strNum = "";
      var strDen = "";
      var nNum = 0;
      var nDen = 0;

      for(var i=0; i<this.units.length; i++) {
        if(this.units[i].power > 0) {
          nNum++;
          strNum += " " + this.units[i].prefix.name + this.units[i].unit.name;
          if(Math.abs(this.units[i].power - 1.0) > 1e-15) {
            strNum += "^" + this.units[i].power;
          }
        }
        else if(this.units[i].power < 0) {
          nDen++;
        }
      }

      if(nDen > 0) {
        for(var i=0; i<this.units.length; i++) {
          if(this.units[i].power < 0) {
            if(nNum > 0) {
              strDen += " " + this.units[i].prefix.name + this.units[i].unit.name;
              if(Math.abs(this.units[i].power + 1.0) > 1e-15) {
                strDen += "^" + (-this.units[i].power);
              }
            }
            else {
              strDen += " " + this.units[i].prefix.name + this.units[i].unit.name;
              strDen += "^" + (this.units[i].power);
            }
          }
        }
      }
      // Remove leading " "
      strNum = strNum.substr(1);
      strDen = strDen.substr(1);

      // Add parans for better copy/paste back into the eval, for example, or for better pretty print formatting
      if(nNum > 1 && nDen > 0) {
        strNum = "(" + strNum + ")";
      }
      if(nDen > 1 && nNum > 0) {
        strDen = "(" + strDen + ")";
      }

      var str = strNum;
      if(nNum > 0 && nDen > 0) {
        str += " / ";
      }
      str += strDen;

      return str;
    };

    /**
     * Get a string representation of the Unit, with optional formatting options.
     * @memberof Unit
     * @param {Object | number | Function} [options]  Formatting options. See
     *                                                lib/utils/number:format for a
     *                                                description of the available
     *                                                options.
     * @return {string}
     */
    Unit.prototype.format = function (options) {

      // Simplfy the unit list, if necessary
      this.simplifyUnitListLazy();

      // Apply some custom logic for handling VA and VAR. The goal is to express the value of the unit as a real value, if possible. Otherwise, use a real-valued unit instead of a complex-valued one.
      var isImaginary = false;
      var isReal = true;
      if(typeof(this.value) !== 'undefined' && this.value !== null && type.isComplex(this.value)) {
        // TODO: Make this better, for example, use relative magnitude of re and im rather than absolute
        isImaginary = Math.abs(this.value.re) < 1e-14;
        isReal = Math.abs(this.value.im) < 1e-14;
      }
      
      for(var i in this.units) {
        if(this.units[i].unit) {
          if(this.units[i].unit.name === 'VA' && isImaginary) {
            this.units[i].unit = UNITS["VAR"];
          }
          else if(this.units[i].unit.name === 'VAR' && !isImaginary) {
            this.units[i].unit = UNITS["VA"];
          }
        }
      }


      // Now apply the best prefix
      // Units must have only one unit and not have the fixPrefix flag set
      if (this.units.length === 1 && !this.fixPrefix) {
        // Units must have integer powers, otherwise the prefix will change the
        // outputted value by not-an-integer-power-of-ten
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) < 1e-14) {
          // Apply the best prefix
          this.units[0].prefix = this._bestPrefix();
        }
      }


      var value = this._denormalize(this.value);
      var str = (this.value !== null) ? format(value, options || {}) : '';
      var unitStr = this.formatUnits();
      if(this.value && type.isComplex(this.value)) {
        str = "(" + str + ")";    // Surround complex values with ( ) to enable better parsing 
      }
      if(unitStr.length > 0 && str.length > 0) {
        str += " ";
      }
      str += unitStr;

      return str;
    };

    /**
     * Calculate the best prefix using current value.
     * @memberof Unit
     * @returns {Object} prefix
     * @private
     */
    Unit.prototype._bestPrefix = function () {
      if (this.units.length !== 1) {
        throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
      }
      if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) {
        throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
      }

      // find the best prefix value (resulting in the value of which
      // the absolute value of the log10 is closest to zero,
      // though with a little offset of 1.2 for nicer values: you get a
      // sequence 1mm 100mm 500mm 0.6m 1m 10m 100m 500m 0.6km 1km ...

      // Note: the units value can be any numeric type, but to find the best
      // prefix it's enough to work with limited precision of a regular number
      // Update: using mathjs abs since we also allow complex numbers
      var absValue = this.value !== null ? abs(this.value) : 0;
      var absUnitValue = abs(this.units[0].unit.value);
      var bestPrefix = this.units[0].prefix;
      if (absValue === 0) {
        return bestPrefix;
      }
      var power = this.units[0].power;
      var bestDiff = Math.log(absValue / Math.pow(bestPrefix.value * absUnitValue, power)) / Math.LN10 - 1.2;
      if(bestDiff > -2.200001 && bestDiff < 1.800001) return bestPrefix;    // Allow the original prefix
      bestDiff = Math.abs(bestDiff);
      var prefixes = this.units[0].unit.prefixes;
      for (var p in prefixes) {
        if (prefixes.hasOwnProperty(p)) {
          var prefix = prefixes[p];
          if (prefix.scientific) {

            var diff = Math.abs(
                Math.log(absValue / Math.pow(prefix.value * absUnitValue, power)) / Math.LN10 - 1.2);

            if (diff < bestDiff
                || (diff === bestDiff && prefix.name.length < bestPrefix.name.length)) {
                  // choose the prefix with the smallest diff, or if equal, choose the one
                  // with the shortest name (can happen with SHORTLONG for example)
                  bestPrefix = prefix;
                  bestDiff = diff;
            }
          }
        }
      }

      return bestPrefix;
    };

    /**
     * Returns an array of units whose sum is equal to this unit
     * @memberof Unit
     * @param {Array} [parts] An array of strings or valueless units. 
     *
     *   Example:
     *
     *   var u = new Unit(1, 'm');
     *   u.splitUnit(['feet', 'inch']);
     *     [ 3 feet, 3.3700787401575 inch ]
     *
     * @return {Array} An array of units.
     */
    Unit.prototype.splitUnit = function(parts) {

      var x = this.clone();
      var ret = [];
      for(var i=0; i<parts.length; i++) {
        // Convert x to the requested unit
        x = x.to(parts[i]);
        if(i==parts.length-1) break;

        // Get the numeric value of this unit
        var xNumeric = x.toNumeric();

        // Check to see if xNumeric is nearly equal to an integer,
        // since fix can incorrectly round down if there is round-off error
        var xRounded = round(xNumeric);
        var xFixed;
        var isNearlyEqual = equal(xRounded, xNumeric);
        if (isNearlyEqual) {
          xFixed = xRounded;
        }
        else {
          xFixed = fix(x.toNumeric());
        }

        var y = new Unit(xFixed, parts[i].toString());
        ret.push(y);
        x = subtract(x, y);
      }

      // This little bit fixes a bug where the remainder should be 0 but is a little bit off.
      // But instead of comparing x, the remainder, with zero--we will compare the sum of
      // all the parts so far with the original value. If they are nearly equal,
      // we set the remainder to 0.
      var testSum = 0;
      for(var i=0; i<ret.length; i++) {
        testSum = add(testSum, ret[i].value);
      }
      if(equal(testSum, this.value)) {
        x.value = 0;
      }

      ret.push(x);

      return ret;
    };

    var PREFIXES = {
      NONE: {
        '': {name: '', value: 1, scientific: true}
      },
      SHORT: {
        '': {name: '', value: 1, scientific: true},

        'da': {name: 'da', value: 1e1, scientific: false},
        'h': {name: 'h', value: 1e2, scientific: false},
        'k': {name: 'k', value: 1e3, scientific: true},
        'M': {name: 'M', value: 1e6, scientific: true},
        'G': {name: 'G', value: 1e9, scientific: true},
        'T': {name: 'T', value: 1e12, scientific: true},
        'P': {name: 'P', value: 1e15, scientific: true},
        'E': {name: 'E', value: 1e18, scientific: true},
        'Z': {name: 'Z', value: 1e21, scientific: true},
        'Y': {name: 'Y', value: 1e24, scientific: true},

        'd': {name: 'd', value: 1e-1, scientific: false},
        'c': {name: 'c', value: 1e-2, scientific: false},
        'm': {name: 'm', value: 1e-3, scientific: true},
        'u': {name: 'u', value: 1e-6, scientific: true},
        'n': {name: 'n', value: 1e-9, scientific: true},
        'p': {name: 'p', value: 1e-12, scientific: true},
        'f': {name: 'f', value: 1e-15, scientific: true},
        'a': {name: 'a', value: 1e-18, scientific: true},
        'z': {name: 'z', value: 1e-21, scientific: true},
        'y': {name: 'y', value: 1e-24, scientific: true}
      },
      LONG: {
        '': {name: '', value: 1, scientific: true},

        'deca': {name: 'deca', value: 1e1, scientific: false},
        'hecto': {name: 'hecto', value: 1e2, scientific: false},
        'kilo': {name: 'kilo', value: 1e3, scientific: true},
        'mega': {name: 'mega', value: 1e6, scientific: true},
        'giga': {name: 'giga', value: 1e9, scientific: true},
        'tera': {name: 'tera', value: 1e12, scientific: true},
        'peta': {name: 'peta', value: 1e15, scientific: true},
        'exa': {name: 'exa', value: 1e18, scientific: true},
        'zetta': {name: 'zetta', value: 1e21, scientific: true},
        'yotta': {name: 'yotta', value: 1e24, scientific: true},

        'deci': {name: 'deci', value: 1e-1, scientific: false},
        'centi': {name: 'centi', value: 1e-2, scientific: false},
        'milli': {name: 'milli', value: 1e-3, scientific: true},
        'micro': {name: 'micro', value: 1e-6, scientific: true},
        'nano': {name: 'nano', value: 1e-9, scientific: true},
        'pico': {name: 'pico', value: 1e-12, scientific: true},
        'femto': {name: 'femto', value: 1e-15, scientific: true},
        'atto': {name: 'atto', value: 1e-18, scientific: true},
        'zepto': {name: 'zepto', value: 1e-21, scientific: true},
        'yocto': {name: 'yocto', value: 1e-24, scientific: true}
      },
      SQUARED: {
        '': {name: '', value: 1, scientific: true},

        'da': {name: 'da', value: 1e2, scientific: false},
        'h': {name: 'h', value: 1e4, scientific: false},
        'k': {name: 'k', value: 1e6, scientific: true},
        'M': {name: 'M', value: 1e12, scientific: true},
        'G': {name: 'G', value: 1e18, scientific: true},
        'T': {name: 'T', value: 1e24, scientific: true},
        'P': {name: 'P', value: 1e30, scientific: true},
        'E': {name: 'E', value: 1e36, scientific: true},
        'Z': {name: 'Z', value: 1e42, scientific: true},
        'Y': {name: 'Y', value: 1e48, scientific: true},

        'd': {name: 'd', value: 1e-2, scientific: false},
        'c': {name: 'c', value: 1e-4, scientific: false},
        'm': {name: 'm', value: 1e-6, scientific: true},
        'u': {name: 'u', value: 1e-12, scientific: true},
        'n': {name: 'n', value: 1e-18, scientific: true},
        'p': {name: 'p', value: 1e-24, scientific: true},
        'f': {name: 'f', value: 1e-30, scientific: true},
        'a': {name: 'a', value: 1e-36, scientific: true},
        'z': {name: 'z', value: 1e-42, scientific: true},
        'y': {name: 'y', value: 1e-48, scientific: true}
      },
      CUBIC: {
        '': {name: '', value: 1, scientific: true},

        'da': {name: 'da', value: 1e3, scientific: false},
        'h': {name: 'h', value: 1e6, scientific: false},
        'k': {name: 'k', value: 1e9, scientific: true},
        'M': {name: 'M', value: 1e18, scientific: true},
        'G': {name: 'G', value: 1e27, scientific: true},
        'T': {name: 'T', value: 1e36, scientific: true},
        'P': {name: 'P', value: 1e45, scientific: true},
        'E': {name: 'E', value: 1e54, scientific: true},
        'Z': {name: 'Z', value: 1e63, scientific: true},
        'Y': {name: 'Y', value: 1e72, scientific: true},

        'd': {name: 'd', value: 1e-3, scientific: false},
        'c': {name: 'c', value: 1e-6, scientific: false},
        'm': {name: 'm', value: 1e-9, scientific: true},
        'u': {name: 'u', value: 1e-18, scientific: true},
        'n': {name: 'n', value: 1e-27, scientific: true},
        'p': {name: 'p', value: 1e-36, scientific: true},
        'f': {name: 'f', value: 1e-45, scientific: true},
        'a': {name: 'a', value: 1e-54, scientific: true},
        'z': {name: 'z', value: 1e-63, scientific: true},
        'y': {name: 'y', value: 1e-72, scientific: true}
      },
      BINARY_SHORT: {
        '': {name: '', value: 1, scientific: true},
        'k': {name: 'k', value: 1e3, scientific: true},
        'M': {name: 'M', value: 1e6, scientific: true},
        'G': {name: 'G', value: 1e9, scientific: true},
        'T': {name: 'T', value: 1e12, scientific: true},
        'P': {name: 'P', value: 1e15, scientific: true},
        'E': {name: 'E', value: 1e18, scientific: true},
        'Z': {name: 'Z', value: 1e21, scientific: true},
        'Y': {name: 'Y', value: 1e24, scientific: true},

        'Ki': {name: 'Ki', value: 1024, scientific: true},
        'Mi': {name: 'Mi', value: Math.pow(1024, 2), scientific: true},
        'Gi': {name: 'Gi', value: Math.pow(1024, 3), scientific: true},
        'Ti': {name: 'Ti', value: Math.pow(1024, 4), scientific: true},
        'Pi': {name: 'Pi', value: Math.pow(1024, 5), scientific: true},
        'Ei': {name: 'Ei', value: Math.pow(1024, 6), scientific: true},
        'Zi': {name: 'Zi', value: Math.pow(1024, 7), scientific: true},
        'Yi': {name: 'Yi', value: Math.pow(1024, 8), scientific: true}
      },
      BINARY_LONG: {
        '': {name: '', value: 1, scientific: true},
        'kilo': {name: 'kilo', value: 1e3, scientific: true},
        'mega': {name: 'mega', value: 1e6, scientific: true},
        'giga': {name: 'giga', value: 1e9, scientific: true},
        'tera': {name: 'tera', value: 1e12, scientific: true},
        'peta': {name: 'peta', value: 1e15, scientific: true},
        'exa': {name: 'exa', value: 1e18, scientific: true},
        'zetta': {name: 'zetta', value: 1e21, scientific: true},
        'yotta': {name: 'yotta', value: 1e24, scientific: true},

        'kibi': {name: 'kibi', value: 1024, scientific: true},
        'mebi': {name: 'mebi', value: Math.pow(1024, 2), scientific: true},
        'gibi': {name: 'gibi', value: Math.pow(1024, 3), scientific: true},
        'tebi': {name: 'tebi', value: Math.pow(1024, 4), scientific: true},
        'pebi': {name: 'pebi', value: Math.pow(1024, 5), scientific: true},
        'exi': {name: 'exi', value: Math.pow(1024, 6), scientific: true},
        'zebi': {name: 'zebi', value: Math.pow(1024, 7), scientific: true},
        'yobi': {name: 'yobi', value: Math.pow(1024, 8), scientific: true}
      },
      BTU: {
        '':   {name: '',   value: 1,   scientific: true},
        'MM': {name: 'MM', value: 1e6, scientific: true}
      }
    };

    // Add a prefix list for both short and long prefixes (for example for ohm and bar which support both Mohm and megaohm, mbar and millibar):
    PREFIXES.SHORTLONG = {};
    for (var key in PREFIXES.SHORT) {
      if(PREFIXES.SHORT.hasOwnProperty(key)) {
        PREFIXES.SHORTLONG[key] = PREFIXES.SHORT[key];
      }
    }
    for (var key in PREFIXES.LONG) {
      if(PREFIXES.LONG.hasOwnProperty(key)) {
        PREFIXES.SHORTLONG[key] = PREFIXES.LONG[key];
      }
    }

    /* Internally, each unit is represented by a value and a dimension array. The elements of the dimensions array have the following meaning:
     * Index  Dimension
     * -----  ---------
     *   0    Length
     *   1    Mass
     *   2    Time
     *   3    Current
     *   4    Temperature
     *   5    Luminous intensity
     *   6    Amount of substance
     *   7    Angle
     *   8    Bit (digital)
     * For example, the unit "298.15 K" is a pure temperature and would have a value of 298.15 and a dimension array of [0, 0, 0, 0, 1, 0, 0, 0, 0]. The unit "1 cal / (gm °C)" can be written in terms of the 9 fundamental dimensions as [length^2] / ([time^2] * [temperature]), and would a value of (after conversion to SI) 4184.0 and a dimensions array of [2, 0, -2, 0, -1, 0, 0, 0, 0].
     *
     */

    var BASE_DIMENSIONS = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"];

    var BASE_UNITS = {
      NONE: {
        dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      MASS: {
        dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      LENGTH: {
        dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
      },
      TIME: {
        dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
      },
      CURRENT: {
        dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
      },
      TEMPERATURE: {
        dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
      },
      LUMINOUS_INTENSITY: {
        dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
      },
      AMOUNT_OF_SUBSTANCE: {
        dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
      },

      FORCE: {
        dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
      },
      SURFACE: {
        dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
      },
      VOLUME: {
        dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
      },
      ENERGY: {
        dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
      },
      POWER: {
        dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
      },
      PRESSURE: {
        dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
      },

      ELECTRIC_CHARGE: {
        dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
      },
      ELECTRIC_CAPACITANCE: {
        dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
      },
      ELECTRIC_POTENTIAL: {
        dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
      },
      ELECTRIC_RESISTANCE: {
        dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
      },
      ELECTRIC_INDUCTANCE: {
        dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
      },
      ELECTRIC_CONDUCTANCE: {
        dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
      },
      MAGNETIC_FLUX: {
        dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
      },
      MAGNETIC_FLUX_DENSITY: {
        dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
      },

      FREQUENCY: {
        dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
      },
      ANGLE: {
        dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
      },
      BIT: {
        dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
      }
    };

    for(var key in BASE_UNITS) {
      BASE_UNITS[key].key = key;
    }

    var BASE_UNIT_NONE = {};

    var UNIT_NONE = {name: '', base: BASE_UNIT_NONE, value: 1, offset: 0, dimensions: [0,0,0,0,0,0,0,0,0]};

    var UNITS = {
      // length
      meter: {
        name: 'meter',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      inch: {
        name: 'inch',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.0254,
        offset: 0
      },
      foot: {
        name: 'foot',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.3048,
        offset: 0
      },
      yard: {
        name: 'yard',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.9144,
        offset: 0
      },
      mile: {
        name: 'mile',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 1609.344,
        offset: 0
      },
      link: {
        name: 'link',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.201168,
        offset: 0
      },
      rod: {
        name: 'rod',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 5.029210,
        offset: 0
      },
      chain: {
        name: 'chain',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 20.1168,
        offset: 0
      },
      angstrom: {
        name: 'angstrom',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 1e-10,
        offset: 0
      },

      m: {
        name: 'm',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      'in': {
        name: 'in',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.0254,
        offset: 0
      },
      ft: {
        name: 'ft',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.3048,
        offset: 0
      },
      yd: {
        name: 'yd',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.9144,
        offset: 0
      },
      mi: {
        name: 'mi',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 1609.344,
        offset: 0
      },
      li: {
        name: 'li',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.201168,
        offset: 0
      },
      rd: {
        name: 'rd',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 5.029210,
        offset: 0
      },
      ch: {
        name: 'ch',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 20.1168,
        offset: 0
      },
      mil: {
        name: 'mil',
        base: BASE_UNITS.LENGTH,
        prefixes: PREFIXES.NONE,
        value: 0.0000254,
        offset: 0
      }, // 1/1000 inch

      // Surface
      m2: {
        name: 'm2',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.SQUARED,
        value: 1,
        offset: 0
      },
      sqin: {
        name: 'sqin',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 0.00064516,
        offset: 0
      }, // 645.16 mm2
      sqft: {
        name: 'sqft',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 0.09290304,
        offset: 0
      }, // 0.09290304 m2
      sqyd: {
        name: 'sqyd',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 0.83612736,
        offset: 0
      }, // 0.83612736 m2
      sqmi: {
        name: 'sqmi',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 2589988.110336,
        offset: 0
      }, // 2.589988110336 km2
      sqrd: {
        name: 'sqrd',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 25.29295,
        offset: 0
      }, // 25.29295 m2
      sqch: {
        name: 'sqch',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 404.6873,
        offset: 0
      }, // 404.6873 m2
      sqmil: {
        name: 'sqmil',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 6.4516e-10,
        offset: 0
      }, // 6.4516 * 10^-10 m2
      acre: {
        name: 'acre',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 4046.86,
        offset: 0
      }, // 4046.86 m2
      hectare: {
        name: 'hectare',
        base: BASE_UNITS.SURFACE,
        prefixes: PREFIXES.NONE,
        value: 10000,
        offset: 0
      }, // 10000 m2

      // Volume
      m3: {
        name: 'm3',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.CUBIC,
        value: 1,
        offset: 0
      },
      L: {
        name: 'L',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.SHORT,
        value: 0.001,
        offset: 0
      }, // litre
      l: {
        name: 'l',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.SHORT,
        value: 0.001,
        offset: 0
      }, // litre
      litre: {
        name: 'litre',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.LONG,
        value: 0.001,
        offset: 0
      },
      cuin: {
        name: 'cuin',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 1.6387064e-5,
        offset: 0
      }, // 1.6387064e-5 m3
      cuft: {
        name: 'cuft',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.028316846592,
        offset: 0
      }, // 28.316 846 592 L
      cuyd: {
        name: 'cuyd',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.764554857984,
        offset: 0
      }, // 764.554 857 984 L
      teaspoon: {
        name: 'teaspoon',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.000005,
        offset: 0
      }, // 5 mL
      tablespoon: {
        name: 'tablespoon',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.000015,
        offset: 0
      }, // 15 mL
      //{name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
      drop: {
        name: 'drop',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 5e-8,
        offset: 0
      },  // 0.05 mL = 5e-8 m3
      gtt: {
        name: 'gtt',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 5e-8,
        offset: 0
      },  // 0.05 mL = 5e-8 m3

      // Liquid volume
      minim: {
        name: 'minim',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.00000006161152,
        offset: 0
      }, // 0.06161152 mL
      fluiddram: {
        name: 'fluiddram',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0000036966911,
        offset: 0
      },  // 3.696691 mL
      fluidounce: {
        name: 'fluidounce',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.00002957353,
        offset: 0
      }, // 29.57353 mL
      gill: {
        name: 'gill',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0001182941,
        offset: 0
      }, // 118.2941 mL
      cc: {
        name: 'cc',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 1e-6,
        offset: 0
      }, // 1e-6 L
      cup: {
        name: 'cup',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0002365882,
        offset: 0
      }, // 236.5882 mL
      pint: {
        name: 'pint',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0004731765,
        offset: 0
      }, // 473.1765 mL
      quart: {
        name: 'quart',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0009463529,
        offset: 0
      }, // 946.3529 mL
      gallon: {
        name: 'gallon',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.003785412,
        offset: 0
      }, // 3.785412 L
      beerbarrel: {
        name: 'beerbarrel',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.1173478,
        offset: 0
      }, // 117.3478 L
      oilbarrel: {
        name: 'oilbarrel',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.1589873,
        offset: 0
      }, // 158.9873 L
      hogshead: {
        name: 'hogshead',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.2384810,
        offset: 0
      }, // 238.4810 L

      //{name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
      fldr: {
        name: 'fldr',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0000036966911,
        offset: 0
      },  // 3.696691 mL
      floz: {
        name: 'floz',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.00002957353,
        offset: 0
      }, // 29.57353 mL
      gi: {
        name: 'gi',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0001182941,
        offset: 0
      }, // 118.2941 mL
      cp: {
        name: 'cp',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0002365882,
        offset: 0
      }, // 236.5882 mL
      pt: {
        name: 'pt',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0004731765,
        offset: 0
      }, // 473.1765 mL
      qt: {
        name: 'qt',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.0009463529,
        offset: 0
      }, // 946.3529 mL
      gal: {
        name: 'gal',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.003785412,
        offset: 0
      }, // 3.785412 L
      bbl: {
        name: 'bbl',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.1173478,
        offset: 0
      }, // 117.3478 L
      obl: {
        name: 'obl',
        base: BASE_UNITS.VOLUME,
        prefixes: PREFIXES.NONE,
        value: 0.1589873,
        offset: 0
      }, // 158.9873 L
      //{name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?

      // Mass
      g: {
        name: 'g',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.SHORT,
        value: 0.001,
        offset: 0
      },
      gram: {
        name: 'gram',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.LONG,
        value: 0.001,
        offset: 0
      },

      ton: {
        name: 'ton',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.SHORT,
        value: 907.18474,
        offset: 0
      },
      tonne: {
        name: 'tonne',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.SHORT,
        value: 1000,
        offset: 0
      },

      grain: {
        name: 'grain',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 64.79891e-6,
        offset: 0
      },
      dram: {
        name: 'dram',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 1.7718451953125e-3,
        offset: 0
      },
      ounce: {
        name: 'ounce',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 28.349523125e-3,
        offset: 0
      },
      poundmass: {
        name: 'poundmass',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 453.59237e-3,
        offset: 0
      },
      hundredweight: {
        name: 'hundredweight',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 45.359237,
        offset: 0
      },
      stick: {
        name: 'stick',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 115e-3,
        offset: 0
      },
      stone: {
        name: 'stone',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 6.35029318,
        offset: 0
      },

      gr: {
        name: 'gr',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 64.79891e-6,
        offset: 0
      },
      dr: {
        name: 'dr',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 1.7718451953125e-3,
        offset: 0
      },
      oz: {
        name: 'oz',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 28.349523125e-3,
        offset: 0
      },
      lbm: {
        name: 'lbm',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 453.59237e-3,
        offset: 0
      },
      cwt: {
        name: 'cwt',
        base: BASE_UNITS.MASS,
        prefixes: PREFIXES.NONE,
        value: 45.359237,
        offset: 0
      },

      // Time
      s: {
        name: 's',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      min: {
        name: 'min',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 60,
        offset: 0
      },
      h: {
        name: 'h',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 3600,
        offset: 0
      },
      second: {
        name: 'second',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      sec: {
        name: 'sec',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      minute: {
        name: 'minute',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 60,
        offset: 0
      },
      hour: {
        name: 'hour',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 3600,
        offset: 0
      },
      day: {
        name: 'day',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 86400,
        offset: 0
      },
      week: {
        name: 'week',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 7*86400,
        offset: 0
      },
      month: {
        name: 'month',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 2629800, //1/12th of Julian year
        offset: 0
      },
      year: {
        name: 'year',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 31557600, //Julian year
        offset: 0
      },
      decade: {
        name: 'decade',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 315576000, //Julian decade
        offset: 0
      },
      century: {
        name: 'century',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 3155760000, //Julian century
        offset: 0
      },
      millennium: {
        name: 'millennium',
        base: BASE_UNITS.TIME,
        prefixes: PREFIXES.NONE,
        value: 31557600000, //Julian millennium
        offset: 0
      },

      // Frequency
      hertz: {
        name: 'Hertz',
        base: BASE_UNITS.FREQUENCY,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0,
        reciprocal: true
      },
      Hz: {
        name: 'Hz',
        base: BASE_UNITS.FREQUENCY,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0,
        reciprocal: true
      },

      // Angle
      rad: {
        name: 'rad',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      radian: {
        name: 'radian',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
      deg: {
        name: 'deg',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.SHORT,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      degree: {
        name: 'degree',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.LONG,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
      grad: {
        name: 'grad',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.SHORT,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      gradian: {
        name: 'gradian',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.LONG,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
      cycle: {
        name: 'cycle',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.NONE,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
      arcsec: {
        name: 'arcsec',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.NONE,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
      arcmin: {
        name: 'arcmin',
        base: BASE_UNITS.ANGLE,
        prefixes: PREFIXES.NONE,
        value: null, // will be filled in by calculateAngleValues()
        offset: 0
      },
      
      // Electric current
      A: {
        name: 'A',
        base: BASE_UNITS.CURRENT,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      ampere: {
        name: 'ampere',
        base: BASE_UNITS.CURRENT,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },

      // Temperature
      // K(C) = °C + 273.15
      // K(F) = (°F + 459.67) / 1.8
      // K(R) = °R / 1.8
      K: {
        name: 'K',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1,
        offset: 0
      },
      degC: {
        name: 'degC',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1,
        offset: 273.15
      },
      degF: {
        name: 'degF',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1 / 1.8,
        offset: 459.67
      },
      degR: {
        name: 'degR',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1 / 1.8,
        offset: 0
      },
      kelvin: {
        name: 'kelvin',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1,
        offset: 0
      },
      celsius: {
        name: 'celsius',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1,
        offset: 273.15
      },
      fahrenheit: {
        name: 'fahrenheit',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1 / 1.8,
        offset: 459.67
      },
      rankine: {
        name: 'rankine',
        base: BASE_UNITS.TEMPERATURE,
        prefixes: PREFIXES.NONE,
        value: 1 / 1.8,
        offset: 0
      },

      // amount of substance
      mol: {
        name: 'mol',
        base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      mole: {
        name: 'mole',
        base: BASE_UNITS.AMOUNT_OF_SUBSTANCE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },

      // luminous intensity
      cd: {
        name: 'cd',
        base: BASE_UNITS.LUMINOUS_INTENSITY,
        prefixes: PREFIXES.NONE,
        value: 1,
        offset: 0
      },
      candela: {
        name: 'candela',
        base: BASE_UNITS.LUMINOUS_INTENSITY,
        prefixes: PREFIXES.NONE,
        value: 1,
        offset: 0
      },
      // TODO: units STERADIAN
      //{name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
      //{name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},

      // Force
      N: {
        name: 'N',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      newton: {
        name: 'newton',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      dyn: {
        name: 'dyn',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.SHORT,
        value: 0.00001,
        offset: 0
      },
      dyne: {
        name: 'dyne',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.LONG,
        value: 0.00001,
        offset: 0
      },
      lbf: {
        name: 'lbf',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.NONE,
        value: 4.4482216152605,
        offset: 0
      },
      poundforce: {
        name: 'poundforce',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.NONE,
        value: 4.4482216152605,
        offset: 0
      },
      kip: {
        name: 'kip',
        base: BASE_UNITS.FORCE,
        prefixes: PREFIXES.LONG,
        value: 4448.2216,
        offset: 0
      },
  	
      // Energy
      J: {
        name: 'J',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      joule: {
        name: 'joule',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      erg: {
        name: 'erg',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.NONE,
        value: 1e-7,
        offset: 0
      },
      Wh: {
        name: 'Wh',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.SHORT,
        value: 3600,
        offset: 0
      },
      BTU: {
        name: 'BTU',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.BTU,
        value: 1055.05585262,
        offset: 0
      },
      eV: {
        name: 'eV',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.SHORT,
        value: 1.602176565e-19,
        offset: 0
      },
      electronvolt: {
        name: 'electronvolt',
        base: BASE_UNITS.ENERGY,
        prefixes: PREFIXES.LONG,
        value: 1.602176565e-19,
        offset: 0
      },


      // Power
      W: {
        name: 'W',
        base: BASE_UNITS.POWER,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      watt: {
        name: 'watt',
        base: BASE_UNITS.POWER,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      hp: {
        name: 'hp',
        base: BASE_UNITS.POWER,
        prefixes: PREFIXES.NONE,
        value: 745.6998715386,
        offset: 0
      },

      // Electrical power units
      VAR: {
        name: 'VAR',
        base: BASE_UNITS.POWER,
        prefixes: PREFIXES.SHORT,
        value: Complex.I,
        offset: 0
      },
      
      VA: {
        name: 'VA',
        base: BASE_UNITS.POWER,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },

      // Pressure
      Pa: {
        name: 'Pa',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      psi: {
        name: 'psi',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.NONE,
        value: 6894.75729276459,
        offset: 0
      },
      atm: {
        name: 'atm',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.NONE,
        value: 101325,
        offset: 0
      },
      bar: {
        name: 'bar',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.SHORTLONG,
        value: 100000,
        offset: 0
      },
      torr: {
        name: 'torr',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.NONE,
        value: 133.322,
        offset: 0
      },
      mmHg: {
        name: 'mmHg',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.NONE,
        value: 133.322,
        offset: 0
      },
      mmH2O: {
        name: 'mmH2O',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.NONE,
        value: 9.80665,
        offset: 0
      },
      cmH2O: {
        name: 'cmH2O',
        base: BASE_UNITS.PRESSURE,
        prefixes: PREFIXES.NONE,
        value: 98.0665,
        offset: 0
      },

      // Electric charge
      coulomb: {
        name: 'coulomb',
        base: BASE_UNITS.ELECTRIC_CHARGE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      C: {
        name: 'C',
        base: BASE_UNITS.ELECTRIC_CHARGE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      // Electric capacitance
      farad: {
        name: 'farad',
        base: BASE_UNITS.ELECTRIC_CAPACITANCE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      F: {
        name: 'F',
        base: BASE_UNITS.ELECTRIC_CAPACITANCE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      // Electric potential
      volt: {
        name: 'volt',
        base: BASE_UNITS.ELECTRIC_POTENTIAL,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      V: {
        name: 'V',
        base: BASE_UNITS.ELECTRIC_POTENTIAL,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      // Electric resistance
      ohm: {
        name: 'ohm',
        base: BASE_UNITS.ELECTRIC_RESISTANCE,
        prefixes: PREFIXES.SHORTLONG,    // Both Mohm and megaohm are acceptable
        value: 1,
        offset: 0
      },
      /*
       * Unicode breaks in browsers if charset is not specified
      Ω: {
        name: 'Ω',
        base: BASE_UNITS.ELECTRIC_RESISTANCE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      */
      // Electric inductance
      henry: {
        name: 'henry',
        base: BASE_UNITS.ELECTRIC_INDUCTANCE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      H: {
        name: 'H',
        base: BASE_UNITS.ELECTRIC_INDUCTANCE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      // Electric conductance
      siemens: {
        name: 'siemens',
        base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      S: {
        name: 'S',
        base: BASE_UNITS.ELECTRIC_CONDUCTANCE,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      // Magnetic flux
      weber: {
        name: 'weber',
        base: BASE_UNITS.MAGNETIC_FLUX,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      Wb: {
        name: 'Wb',
        base: BASE_UNITS.MAGNETIC_FLUX,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },
      // Magnetic flux density
      tesla: {
        name: 'tesla',
        base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
        prefixes: PREFIXES.LONG,
        value: 1,
        offset: 0
      },
      T: {
        name: 'T',
        base: BASE_UNITS.MAGNETIC_FLUX_DENSITY,
        prefixes: PREFIXES.SHORT,
        value: 1,
        offset: 0
      },

      // Binary
      b: {
        name: 'b',
        base: BASE_UNITS.BIT,
        prefixes: PREFIXES.BINARY_SHORT,
        value: 1,
        offset: 0
      },
      bits: {
        name: 'bits',
        base: BASE_UNITS.BIT,
        prefixes: PREFIXES.BINARY_LONG,
        value: 1,
        offset: 0
      },
      B: {
        name: 'B',
        base: BASE_UNITS.BIT,
        prefixes: PREFIXES.BINARY_SHORT,
        value: 8,
        offset: 0
      },
      bytes: {
        name: 'bytes',
        base: BASE_UNITS.BIT,
        prefixes: PREFIXES.BINARY_LONG,
        value: 8,
        offset: 0
      }
    };

    // aliases (formerly plurals)
    var ALIASES = {
      meters: 'meter',
      inches: 'inch',
      feet: 'foot',
      yards: 'yard',
      miles: 'mile',
      links: 'link',
      rods: 'rod',
      chains: 'chain',
      angstroms: 'angstrom',

      lt: 'l',
      litres: 'litre',
      liter: 'litre',
      liters: 'litre',
      teaspoons: 'teaspoon',
      tablespoons: 'tablespoon',
      minims: 'minim',
      fluiddrams: 'fluiddram',
      fluidounces: 'fluidounce',
      gills: 'gill',
      cups: 'cup',
      pints: 'pint',
      quarts: 'quart',
      gallons: 'gallon',
      beerbarrels: 'beerbarrel',
      oilbarrels: 'oilbarrel',
      hogsheads: 'hogshead',
      gtts: 'gtt',

      grams: 'gram',
      tons: 'ton',
      tonnes: 'tonne',
      grains: 'grain',
      drams: 'dram',
      ounces: 'ounce',
      poundmasses: 'poundmass',
      hundredweights: 'hundredweight',
      sticks: 'stick',
      lb: 'lbm',
      lbs: 'lbm',
  	
      kips: 'kip',

      acres: 'acre',
      hectares: 'hectare',
      sqfeet: 'sqft',
      sqyard: 'sqyd',
      sqmile: 'sqmi',
      sqmiles: 'sqmi',

      mmhg: 'mmHg',
      mmh2o: 'mmH2O',
      cmh2o: 'cmH2O',

      seconds: 'second',
      secs: 'second',
      minutes: 'minute',
      mins: 'minute',
      hours: 'hour',
      hr: 'hour',
      hrs: 'hour',
      days: 'day',
      weeks: 'week',
      months: 'month',
      years: 'year',
      decades: 'decade',
      centuries: 'century',
      millennia: 'millennium',

      hertz: 'hertz',

      radians: 'radian',
      degrees: 'degree',
      gradians: 'gradian',
      cycles: 'cycle',
      arcsecond: 'arcsec',
      arcseconds: 'arcsec',
      arcminute: 'arcmin',
      arcminutes: 'arcmin',

      BTUs: 'BTU',
      watts: 'watt',
      joules: 'joule',

      amperes: 'ampere',
      coulombs: 'coulomb',
      volts: 'volt',
      ohms: 'ohm',
      farads: 'farad',
      webers: 'weber',
      teslas: 'tesla',
      electronvolts: 'electronvolt',
      moles: 'mole'

    };

    /**
     * Calculate the values for the angle units.
     * Value is calculated as number or BigNumber depending on the configuration
     * @param {{number: 'number' | 'BigNumber'}} config
     */
    function calculateAngleValues (config) {
      if (config.number === 'BigNumber') {
        var pi = constants.pi(type.BigNumber);
        UNITS.rad.value = new type.BigNumber(1);
        UNITS.deg.value = pi.div(180);        // 2 * pi / 360;
        UNITS.grad.value = pi.div(200);       // 2 * pi / 400;
        UNITS.cycle.value = pi.times(2);      // 2 * pi
        UNITS.arcsec.value = pi.div(648000);  // 2 * pi / 360 / 3600
        UNITS.arcmin.value = pi.div(10800);   // 2 * pi / 360 / 60
      }
      else { // number
        UNITS.rad.value = 1;
        UNITS.deg.value = Math.PI / 180;        // 2 * pi / 360;
        UNITS.grad.value = Math.PI / 200;       // 2 * pi / 400;
        UNITS.cycle.value = Math.PI * 2;        // 2 * pi
        UNITS.arcsec.value = Math.PI / 648000;  // 2 * pi / 360 / 3600;
        UNITS.arcmin.value = Math.PI / 10800;   // 2 * pi / 360 / 60;
      }

      // copy to the full names of the angles
      UNITS.radian.value = UNITS.rad.value;
      UNITS.degree.value = UNITS.deg.value;
      UNITS.gradian.value = UNITS.grad.value;
    }

    // apply the angle values now
    calculateAngleValues(config);

    // recalculate the values on change of configuration
    math.on('config', function (curr, prev) {
      if (curr.number !== prev.number) {
        calculateAngleValues(curr);
      }
    });

    /**
     * A unit system is a set of dimensionally independent base units plus a set of derived units, formed by multiplication and division of the base units, that are by convention used with the unit system.
     * A user perhaps could issue a command to select a preferred unit system, or use the default (see below).
     * Auto unit system: The default unit system is updated on the fly anytime a unit is parsed. The corresponding unit in the default unit system is updated, so that answers are given in the same units the user supplies.
     */
    var UNIT_SYSTEMS = {
      si: {
        // Base units
        NONE:                  {unit: UNIT_NONE, prefix: PREFIXES.NONE['']},
        LENGTH:                {unit: UNITS.m,   prefix: PREFIXES.SHORT['']},
        MASS:                  {unit: UNITS.g,   prefix: PREFIXES.SHORT['k']}, 
        TIME:                  {unit: UNITS.s,   prefix: PREFIXES.SHORT['']}, 
        CURRENT:               {unit: UNITS.A,   prefix: PREFIXES.SHORT['']}, 
        TEMPERATURE:           {unit: UNITS.K,   prefix: PREFIXES.SHORT['']}, 
        LUMINOUS_INTENSITY:    {unit: UNITS.cd,  prefix: PREFIXES.SHORT['']}, 
        AMOUNT_OF_SUBSTANCE:   {unit: UNITS.mol, prefix: PREFIXES.SHORT['']}, 
        ANGLE:                 {unit: UNITS.rad, prefix: PREFIXES.SHORT['']}, 
        BIT:                   {unit: UNITS.bit, prefix: PREFIXES.SHORT['']}, 

        // Derived units
        FORCE:                 {unit: UNITS.N,   prefix: PREFIXES.SHORT['']}, 
        ENERGY:                {unit: UNITS.J,   prefix: PREFIXES.SHORT['']},
        POWER:                 {unit: UNITS.W,   prefix: PREFIXES.SHORT['']},
        PRESSURE:              {unit: UNITS.Pa,  prefix: PREFIXES.SHORT['']},
        ELECTRIC_CHARGE:       {unit: UNITS.C,   prefix: PREFIXES.SHORT['']},
        ELECTRIC_CAPACITANCE:  {unit: UNITS.F,   prefix: PREFIXES.SHORT['']},
        ELECTRIC_POTENTIAL:    {unit: UNITS.V,   prefix: PREFIXES.SHORT['']},
        ELECTRIC_RESISTANCE:   {unit: UNITS.ohm, prefix: PREFIXES.SHORT['']},
        ELECTRIC_INDUCTANCE:   {unit: UNITS.H,   prefix: PREFIXES.SHORT['']},
        ELECTRIC_CONDUCTANCE:  {unit: UNITS.S,   prefix: PREFIXES.SHORT['']},
        MAGNETIC_FLUX:         {unit: UNITS.Wb,  prefix: PREFIXES.SHORT['']},
        MAGNETIC_FLUX_DENSITY: {unit: UNITS.T,   prefix: PREFIXES.SHORT['']},
        FREQUENCY:             {unit: UNITS.Hz,  prefix: PREFIXES.SHORT['']}
      }
    };

    // Clone to create the other unit systems
    UNIT_SYSTEMS.cgs = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.cgs.LENGTH = {unit: UNITS.m,   prefix: PREFIXES.SHORT['c']};
    UNIT_SYSTEMS.cgs.MASS =   {unit: UNITS.g,   prefix: PREFIXES.SHORT['']};
    UNIT_SYSTEMS.cgs.FORCE =  {unit: UNITS.dyn, prefix: PREFIXES.SHORT['']};
    UNIT_SYSTEMS.cgs.ENERGY = {unit: UNITS.erg, prefix: PREFIXES.NONE['']};
    // there are wholly 4 unique cgs systems for electricity and magnetism,
    // so let's not worry about it unless somebody complains
    
    UNIT_SYSTEMS.us = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));
    UNIT_SYSTEMS.us.LENGTH =      {unit: UNITS.ft,   prefix: PREFIXES.NONE['']};
    UNIT_SYSTEMS.us.MASS =        {unit: UNITS.lbm,  prefix: PREFIXES.NONE['']};
    UNIT_SYSTEMS.us.TEMPERATURE = {unit: UNITS.degF, prefix: PREFIXES.NONE['']};
    UNIT_SYSTEMS.us.FORCE =       {unit: UNITS.lbf,  prefix: PREFIXES.NONE['']};
    UNIT_SYSTEMS.us.ENERGY =      {unit: UNITS.BTU,  prefix: PREFIXES.BTU['']};
    UNIT_SYSTEMS.us.POWER =       {unit: UNITS.hp,   prefix: PREFIXES.NONE['']};
    UNIT_SYSTEMS.us.PRESSURE =    {unit: UNITS.psi,  prefix: PREFIXES.NONE['']};

    // Add additional unit systems here.



    // Choose a unit system to seed the auto unit system.
    UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.si));

    // Set the current unit system
    var currentUnitSystem = UNIT_SYSTEMS.auto;

    /**
     * Set a unit system for formatting derived units.
     * @param {string} [name] The name of the unit system.
     */
    Unit.setUnitSystem = function(name) {
      if(UNIT_SYSTEMS.hasOwnProperty(name)) {
        currentUnitSystem = UNIT_SYSTEMS[name];
      }
      else {
        throw new Error('Unit system ' + name + ' does not exist. Choices are: ' + Object.keys(UNIT_SYSTEMS).join(', '));
      }
    };

    /**
     * Return the current unit system.
     * @return {string} The current unit system.
     */
    Unit.getUnitSystem = function() {
      for(var key in UNIT_SYSTEMS) {
        if(UNIT_SYSTEMS[key] === currentUnitSystem) {
          return key;
        }
      }
    };

    /**
     * Converters to convert from number to an other numeric type like BigNumber
     * or Fraction
     */
    Unit.typeConverters = {
      BigNumber: function (x) {
        return new type.BigNumber(x + ''); // stringify to prevent constructor error
      },

      Fraction: function (x) {
        return new type.Fraction(x);
      },

      Complex: function (x) {
        return x;
      },

      number: function (x) {
        return x;
      }
    };

    /**
     * Retrieve the right convertor function corresponding with the type
     * of provided exampleValue.
     *
     * @param {string} type   A string 'number', 'BigNumber', or 'Fraction'
     *                        In case of an unknown type,
     * @return {Function}
     */
    Unit._getNumberConverter = function (type) {
      if (!Unit.typeConverters[type]) {
        throw new TypeError('Unsupported type "' + type + '"');
      }

      return Unit.typeConverters[type];
    };

    // Add dimensions to each built-in unit
    for (var key in UNITS) {
      var unit = UNITS[key];
      unit.dimensions = unit.base.dimensions;
    }    

    // Create aliases
    for (var name in ALIASES) {
      if(ALIASES.hasOwnProperty(name)) {
        var unit = UNITS[ALIASES[name]];
        var alias = {};
        for(var key in unit) {
          if(unit.hasOwnProperty(key)) {
            alias[key] = unit[key];
          }
        }
        alias.name = name;
        UNITS[name] = alias;
      }
    }

    function assertUnitNameIsValid(name) {
      for(var i=0; i<name.length; i++) {
        var c = name.charAt(i);
         
        var isValidAlpha = function (p) {
          return /^[a-zA-Z]$/.test(p);
        };

        var isDigit = function (c) {
          return (c >= '0' && c <= '9');
        };

        if(i === 0 && !isValidAlpha(c))
          throw new Error('Invalid unit name (must begin with alpha character): "' + name + '"');

        if(i > 0 && !( isValidAlpha(c)
                    || isDigit(c)))
          throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + name + '"');

      }
    }

    /**
     * Wrapper around createUnitSingle.
     * Example: 
     *  createUnit({
     *    foo: { },
     *    bar: {
     *      definition: 'kg/foo',
     *      aliases: ['ba', 'barr', 'bars'],
     *      offset: 200
     *    },
     *    baz: '4 bar'
     *  }, 
     *  {
     *    override: true;
     *  });
     * @param {object} obj      Object map. Each key becomes a unit which is defined by its value.
     * @param {object} options
     */
    Unit.createUnit = function(obj, options) {
      
      if(typeof(obj) !== 'object') {
        throw new TypeError("createUnit expects first parameter to be of type 'Object'");
      }

      // Remove all units and aliases we are overriding
      if(options && options.override) {
        for(var key in obj) {
          if(obj.hasOwnProperty(key)) {
            Unit.deleteUnit(key);
          }
          if(obj[key].aliases) {
            for(var i=0; i<obj[key].aliases.length; i++) {
              Unit.deleteUnit(obj[key].aliases[i]);
            }
          }
        }
      }

      // TODO: traverse multiple times until all units have been added
      var lastUnit;
      for(var key in obj) {
        if(obj.hasOwnProperty(key)) {
          lastUnit = Unit.createUnitSingle(key, obj[key]);
        }
      }
      return lastUnit;
    };

    /**
     * Create a user-defined unit and register it with the Unit type.
     * Example: 
     *  createUnitSingle('knot', '0.514444444 m/s')
     *  createUnitSingle('acre', new Unit(43560, 'ft^2'))
     *
     * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
     * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
     * @param {Object} options   (optional) An object containing any of the following properties:
     *     prefixes {string} "none", "short", "long", "binary_short", or "binary_long". The default is "none".
     *     aliases {Array} Array of strings. Example: ['knots', 'kt', 'kts']
     *     offset {Numeric} An offset to apply when converting from the unit. For example, the offset for celsius is 273.15 and the offset for farhenheit is 459.67. Default is 0.
     *
     * @return {Unit} 
     */
    Unit.createUnitSingle = function(name, obj, options) {

      if(typeof(obj) === 'undefined' || obj === null) {
        obj = {};
      }
      
      if(typeof(name) !== 'string') {
        throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
      }
     
      // Check collisions with existing units
      if(UNITS.hasOwnProperty(name)) {
        throw new Error('Cannot create unit "' + name + '": a unit with that name already exists');
      }

      // TODO: Validate name for collisions with other built-in functions (like abs or cos, for example), and for acceptable variable names. For example, '42' is probably not a valid unit. Nor is '%', since it is also an operator.

      assertUnitNameIsValid(name);

      var defUnit = null;   // The Unit from which the new unit will be created.
      var aliases = [];
      var offset = 0;
      var definition;
      var prefixes;
      if(obj && obj.type === 'Unit') {
        defUnit = obj.clone();
      }
      else if(typeof(obj) === 'string') {
        if(obj !== '') {
          definition = obj;
        }
      }
      else if(typeof(obj) === 'object') {
        definition = obj.definition;
        prefixes = obj.prefixes; 
        offset = obj.offset;
        if (obj.aliases) {
          aliases = obj.aliases.valueOf(); // aliases could be a Matrix, so convert to Array
        }
      }
      else {
        throw new TypeError('Cannot create unit "' + name + '" from "' + obj.toString() + '": expecting "string" or "Unit" or "Object"');
      }

      if(aliases) {
        for (var i=0; i<aliases.length; i++) {
          if(UNITS.hasOwnProperty(aliases[i])) {
            throw new Error('Cannot create alias "' + aliases[i] + '": a unit with that name already exists');
          }
        }
      }

      if(definition && typeof(definition) === 'string' && !defUnit) {
        try {
          defUnit = Unit.parse(definition, {allowNoUnits: true});
        }
        catch (ex) {
          ex.message = 'Could not create unit "' + name + '" from "' + definition + '": ' + ex.message;
          throw(ex);
        }
      }
      else if(definition && definition.type === 'Unit') {
        defUnit = definition.clone();
      }

      aliases = aliases || [];
      offset = offset || 0;
      if(prefixes && prefixes.toUpperCase) 
        prefixes = PREFIXES[prefixes.toUpperCase()] || PREFIXES.NONE;
      else
        prefixes = PREFIXES.NONE;


      // If defUnit is null, it is because the user did not
      // specify a defintion. So create a new base dimension.
      var newUnit = {};
      if(!defUnit) {
        // Add a new base dimension
        var baseName = name + "_STUFF";   // foo --> foo_STUFF, or the essence of foo
        if(BASE_DIMENSIONS.indexOf(baseName) >= 0) {
          throw new Error('Cannot create new base unit "' + name + '": a base unit with that name already exists (and cannot be overridden)');
        }
        BASE_DIMENSIONS.push(baseName);

        // Push 0 onto existing base units
        for(var b in BASE_UNITS) {
          if(BASE_UNITS.hasOwnProperty(b)) {
            BASE_UNITS[b].dimensions[BASE_DIMENSIONS.length-1] = 0;
          }
        }

        // Add the new base unit
        var newBaseUnit = { dimensions: [] };
        for(var i=0; i<BASE_DIMENSIONS.length; i++) {
          newBaseUnit.dimensions[i] = 0;
        }
        newBaseUnit.dimensions[BASE_DIMENSIONS.length-1] = 1;
        newBaseUnit.key = baseName;
        BASE_UNITS[baseName] = newBaseUnit;
         
        newUnit = {
          name: name,
          value: 1,
          dimensions: BASE_UNITS[baseName].dimensions.slice(0),
          prefixes: prefixes,
          offset: offset,
          base: baseName
        };

        currentUnitSystem[baseName] = {
          unit: newUnit,
          prefix: PREFIXES.NONE['']
        };

      }
      else {

        newUnit = {
          name: name,
          value: defUnit.value,
          dimensions: defUnit.dimensions.slice(0),
          prefixes: prefixes,
          offset: offset,
        };
        
        // Create a new base if no matching base exists
        var anyMatch = false;
        for(var i in BASE_UNITS) {
          if(BASE_UNITS.hasOwnProperty(i)) {
            var match = true;
            for(var j=0; j<BASE_DIMENSIONS.length; j++) {
              if (Math.abs((newUnit.dimensions[j] || 0) - (BASE_UNITS[i].dimensions[j] || 0)) > 1e-12) {
                match = false;
                break;
              }
            }
            if(match) {
              anyMatch = true;
              break;
            }
          }
        }
        if(!anyMatch) {
          var baseName = name + "_STUFF";   // foo --> foo_STUFF, or the essence of foo
          // Add the new base unit
          var newBaseUnit = { dimensions: defUnit.dimensions.slice(0) };
          newBaseUnit.key = baseName;
          BASE_UNITS[baseName] = newBaseUnit;

          currentUnitSystem[baseName] = {
            unit: newUnit,
            prefix: PREFIXES.NONE['']
          };

          newUnit.base = baseName;
        }
      }

      Unit.UNITS[name] = newUnit;

      for (var i=0; i<aliases.length; i++) {
        var aliasName = aliases[i];
        var alias = {};
        for(var key in newUnit) {
          if(newUnit.hasOwnProperty(key)) {
            alias[key] = newUnit[key];
          }
        }
        alias.name = aliasName;
        Unit.UNITS[aliasName] = alias;
      }

      return new Unit(null, name);
    };

    Unit.deleteUnit = function(name) {
      delete Unit.UNITS[name];
    };

    // expose arrays with prefixes, dimensions, units, systems
    Unit.PREFIXES = PREFIXES;
    Unit.BASE_DIMENSIONS = BASE_DIMENSIONS;
    Unit.BASE_UNITS = BASE_UNITS;
    Unit.UNIT_SYSTEMS = UNIT_SYSTEMS;
    Unit.UNITS = UNITS;

    return Unit;
  }

  var name$265 = 'Unit';
  var path$65 = 'type';
  var factory_1$277 = factory$278;
  var math$20 = true; // request access to the math namespace

  var Unit = {
  	name: name$265,
  	path: path$65,
  	factory: factory_1$277,
  	math: math$20
  };

  function factory$279 (type, config, load, typed) {
    /**
     * Create a unit. Depending on the passed arguments, the function
     * will create and return a new math.type.Unit object.
     * When a matrix is provided, all elements will be converted to units.
     *
     * Syntax:
     *
     *     math.unit(unit : string)
     *     math.unit(value : number, unit : string)
     *
     * Examples:
     *
     *    var a = math.unit(5, 'cm');    // returns Unit 50 mm
     *    var b = math.unit('23 kg');    // returns Unit 23 kg
     *    a.to('m');                     // returns Unit 0.05 m
     *
     * See also:
     *
     *    bignumber, boolean, complex, index, matrix, number, string, createUnit
     *
     * @param {* | Array | Matrix} args   A number and unit.
     * @return {Unit | Array | Matrix}    The created unit
     */

    var unit = typed('unit', {
      'Unit': function (x) {
        return x.clone();
      },

      'string': function (x) {
        if (type.Unit.isValuelessUnit(x)) {
          return new type.Unit(null, x); // a pure unit
        }

        return type.Unit.parse(x); // a unit with value, like '5cm'
      },

      'number | BigNumber | Fraction | Complex, string': function (value, unit) {
        return new type.Unit(value, unit);
      },

      'Array | Matrix': function (x) {
        return deepMap(x, unit);
      }
    });

    unit.toTex = {
      1: '\\left(${args[0]}\\right)',
      2: '\\left(\\left(${args[0]}\\right)${args[1]}\\right)'
    };

    return unit;
  }

  var name$266 = 'unit';
  var factory_1$278 = factory$279;

  var unit$2 = {
  	name: name$266,
  	factory: factory_1$278
  };

  function factory$280 (type, config, load, typed) {
    /**
     * Create a user-defined unit and register it with the Unit type.
     *
     * Syntax:
     *
     *     math.createUnit({
     *       baseUnit1: {
     *         aliases: [string, ...]
     *         prefixes: object
     *       },
     *       unit2: {
     *         definition: string,
     *         aliases: [string, ...]
     *         prefixes: object,
     *         offset: number
     *       },
     *       unit3: string    // Shortcut
     *     })
     *
     *     // Another shortcut:
     *     math.createUnit(string, unit : string, [object])
     *
     * Examples: 
     *
     *     math.createUnit('foo');
     *     math.createUnit('knot', {definition: '0.514444444 m/s', aliases: ['knots', 'kt', 'kts']});
     *     math.createUnit('mph', '1 mile/hour');
     *
     * @param {string} name      The name of the new unit. Must be unique. Example: 'knot'
     * @param {string, Unit} definition      Definition of the unit in terms of existing units. For example, '0.514444444 m / s'.
     * @param {Object} options   (optional) An object containing any of the following properties:
     *     - `prefixes {string}` "none", "short", "long", "binary_short", or "binary_long". The default is "none".
     *     - `aliases {Array}` Array of strings. Example: ['knots', 'kt', 'kts']
     *     - `offset {Numeric}` An offset to apply when converting from the unit. For example, the offset for celsius is 273.15. Default is 0.
     *
     * See also:
     *
     *     unit
     *
     * @return {Unit} The new unit
     */
    var createUnit = typed('createUnit', {

      // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
      'Object, Object': function(obj, options) {
        return type.Unit.createUnit(obj, options);
      },

      // Same as above but without the options.
      'Object': function(obj) {
        return type.Unit.createUnit(obj, {});
      },

      // Shortcut method for creating one unit.
      'string, Unit | string | Object, Object': function (name, def, options) {
        var obj = {};
        obj[name] = def;
        return type.Unit.createUnit(obj, options);
      },

      // Same as above but without the options.
      'string, Unit | string | Object': function (name, def) {
        var obj = {};
        obj[name] = def;
        return type.Unit.createUnit(obj, {});
      },

      // Without a definition, creates a base unit.
      'string': function (name) {
        var obj = {};
        obj[name] = {};
        return type.Unit.createUnit(obj, {});
      },
    });

    return createUnit;
  }

  var name$267 = 'createUnit';
  var factory_1$279 = factory$280;

  var createUnit$1 = {
  	name: name$267,
  	factory: factory_1$279
  };

  function factory$281 (type, config, load, typed) {

    /**
     * Split a unit in an array of units whose sum is equal to the original unit.
     *
     * Syntax:
     *
     *     splitUnit(unit: Unit, parts: Array.<Unit>)
     *
     * Example:
     *
     *     math.splitUnit(new Unit(1, 'm'), ['feet', 'inch']);
     *     // [ 3 feet, 3.3700787401575 inch ]
     *
     * See also:
     *
     *     unit
     *
     * @param {Array} [parts] An array of strings or valueless units.
     * @return {Array} An array of units.
     */
    var splitUnit = typed('splitUnit', {
      'Unit, Array': function(unit, parts) {
        return unit.splitUnit(parts);
      }
    });

    return splitUnit;

  }

  var name$268 = 'splitUnit';
  var factory_1$280 = factory$281;

  var splitUnit$1 = {
  	name: name$268,
  	factory: factory_1$280
  };

  var lazy$5 = object.lazy;


  function factory$282 (type, config, load, typed, math) {

    // helper function to create a unit with a fixed prefix
    function fixedUnit(str) {
      var unit = type.Unit.parse(str);
      unit.fixPrefix = true;
      return unit;
    }

    // Source: http://www.wikiwand.com/en/Physical_constant

    // Universal constants
    setLazyConstant$1(math, 'speedOfLight',         function () {return fixedUnit('299792458 m s^-1')});
    setLazyConstant$1(math, 'gravitationConstant',  function () {return fixedUnit('6.6738480e-11 m^3 kg^-1 s^-2')});
    setLazyConstant$1(math, 'planckConstant',       function () {return fixedUnit('6.626069311e-34 J s')});
    setLazyConstant$1(math, 'reducedPlanckConstant',function () {return fixedUnit('1.05457172647e-34 J s')});

    // Electromagnetic constants
    setLazyConstant$1(math, 'magneticConstant',          function () {return fixedUnit('1.2566370614e-6 N A^-2')});
    setLazyConstant$1(math, 'electricConstant',          function () {return fixedUnit('8.854187817e-12 F m^-1')});
    setLazyConstant$1(math, 'vacuumImpedance',           function () {return fixedUnit('376.730313461 ohm')});
    setLazyConstant$1(math, 'coulomb',                   function () {return fixedUnit('8.9875517873681764e9 N m^2 C^-2')});
    setLazyConstant$1(math, 'elementaryCharge',          function () {return fixedUnit('1.60217656535e-19 C')});
    setLazyConstant$1(math, 'bohrMagneton',              function () {return fixedUnit('9.2740096820e-24 J T^-1')});
    setLazyConstant$1(math, 'conductanceQuantum',        function () {return fixedUnit('7.748091734625e-5 S')});
    setLazyConstant$1(math, 'inverseConductanceQuantum', function () {return fixedUnit('12906.403721742 ohm')});
    setLazyConstant$1(math, 'magneticFluxQuantum',       function () {return fixedUnit('2.06783375846e-15 Wb')});
    setLazyConstant$1(math, 'nuclearMagneton',           function () {return fixedUnit('5.0507835311e-27 J T^-1')});
    setLazyConstant$1(math, 'klitzing',                  function () {return fixedUnit('25812.807443484 ohm')});
    //setLazyConstant(math, 'josephson',                 function () {return fixedUnit('4.8359787011e-14 Hz V^-1')});  // TODO: support for Hz needed

    // Atomic and nuclear constants
    setLazyConstant$1(math, 'bohrRadius',              function () {return fixedUnit('5.291772109217e-11 m')});
    setLazyConstant$1(math, 'classicalElectronRadius', function () {return fixedUnit('2.817940326727e-15 m')});
    setLazyConstant$1(math, 'electronMass',            function () {return fixedUnit('9.1093829140e-31 kg')});
    setLazyConstant$1(math, 'fermiCoupling',           function () {return fixedUnit('1.1663645e-5 GeV^-2')});
    setLazyConstant$1(math, 'fineStructure',           function () {return 7.297352569824e-3});
    setLazyConstant$1(math, 'hartreeEnergy',           function () {return fixedUnit('4.3597443419e-18 J')});
    setLazyConstant$1(math, 'protonMass',              function () {return fixedUnit('1.67262177774e-27 kg')});
    setLazyConstant$1(math, 'deuteronMass',            function () {return fixedUnit('3.3435830926e-27 kg')});
    setLazyConstant$1(math, 'neutronMass',             function () {return fixedUnit('1.6749271613e-27 kg')});
    setLazyConstant$1(math, 'quantumOfCirculation',    function () {return fixedUnit('3.636947552024e-4 m^2 s^-1')});
    setLazyConstant$1(math, 'rydberg',                 function () {return fixedUnit('10973731.56853955 m^-1')});
    setLazyConstant$1(math, 'thomsonCrossSection',     function () {return fixedUnit('6.65245873413e-29 m^2')});
    setLazyConstant$1(math, 'weakMixingAngle',         function () {return 0.222321});
    setLazyConstant$1(math, 'efimovFactor',            function () {return 22.7});

    // Physico-chemical constants
    setLazyConstant$1(math, 'atomicMass',          function () {return fixedUnit('1.66053892173e-27 kg')});
    setLazyConstant$1(math, 'avogadro',            function () {return fixedUnit('6.0221412927e23 mol^-1')});
    setLazyConstant$1(math, 'boltzmann',           function () {return fixedUnit('1.380648813e-23 J K^-1')});
    setLazyConstant$1(math, 'faraday',             function () {return fixedUnit('96485.336521 C mol^-1')});
    setLazyConstant$1(math, 'firstRadiation',      function () {return fixedUnit('3.7417715317e-16 W m^2')});
    // setLazyConstant(math, 'spectralRadiance',   function () {return fixedUnit('1.19104286953e-16 W m^2 sr^-1')}); // TODO spectralRadiance
    setLazyConstant$1(math, 'loschmidt',           function () {return fixedUnit('2.686780524e25 m^-3')});
    setLazyConstant$1(math, 'gasConstant',         function () {return fixedUnit('8.314462175 J K^-1 mol^-1')});
    setLazyConstant$1(math, 'molarPlanckConstant', function () {return fixedUnit('3.990312717628e-10 J s mol^-1')});
    setLazyConstant$1(math, 'molarVolume',         function () {return fixedUnit('2.241396820e-10 m^3 mol^-1')});
    setLazyConstant$1(math, 'sackurTetrode',       function () {return -1.164870823});
    setLazyConstant$1(math, 'secondRadiation',     function () {return fixedUnit('1.438777013e-2 m K')});
    setLazyConstant$1(math, 'stefanBoltzmann',     function () {return fixedUnit('5.67037321e-8 W m^-2 K^-4')});
    setLazyConstant$1(math, 'wienDisplacement',    function () {return fixedUnit('2.897772126e-3 m K')});

    // Adopted values
    setLazyConstant$1(math, 'molarMass',         function () {return fixedUnit('1e-3 kg mol^-1')});
    setLazyConstant$1(math, 'molarMassC12',      function () {return fixedUnit('1.2e-2 kg mol^-1')});
    setLazyConstant$1(math, 'gravity',           function () {return fixedUnit('9.80665 m s^-2')});
    // atm is defined in Unit.js

    // Natural units
    setLazyConstant$1(math, 'planckLength',      function () {return fixedUnit('1.61619997e-35 m')});
    setLazyConstant$1(math, 'planckMass',        function () {return fixedUnit('2.1765113e-8 kg')});
    setLazyConstant$1(math, 'planckTime',        function () {return fixedUnit('5.3910632e-44 s')});
    setLazyConstant$1(math, 'planckCharge',      function () {return fixedUnit('1.87554595641e-18 C')});
    setLazyConstant$1(math, 'planckTemperature', function () {return fixedUnit('1.41683385e+32 K')});

  }

  // create a lazy constant in both math and mathWithTransform
  function setLazyConstant$1 (math, name, resolver) {
    lazy$5(math, name,  resolver);
    lazy$5(math.expression.mathWithTransform, name,  resolver);
  }

  var factory_1$281 = factory$282;
  var lazy_1$2 = false;  // no lazy loading of constants, the constants themselves are lazy when needed
  var math$21 = true;   // request access to the math namespace

  var physicalConstants = {
  	factory: factory_1$281,
  	lazy: lazy_1$2,
  	math: math$21
  };

  var unit$3 = [
    // type
    Unit,

    // construction function
    unit$2,

    // create new units
    createUnit$1,

    // split units
    splitUnit$1,

    // physical constants
    physicalConstants
  ];

  var type$1 = [
    bignumber$1,
    boolean_1,
    chain$1,
    complex$3,
    fraction$3,
    matrix$1,
    number$3,
    resultset,
    string$6,
    unit$3
  ];

  var version$1 = '4.4.2';

  function factory$283 (type, config, load, typed, math) {
    // listen for changed in the configuration, automatically reload
    // constants when needed
    math.on('config', function (curr, prev) {
      if (curr.number !== prev.number) {
        factory$283(type, config, load, typed, math);
      }
    });

    setConstant$1(math, 'true', true);
    setConstant$1(math, 'false', false);
    setConstant$1(math, 'null', null);
    setConstant$1(math, 'uninitialized', 'Error: Constant uninitialized is removed since v4.0.0. Use null instead');

    if (config.number === 'BigNumber') {
      setConstant$1(math, 'Infinity', new type.BigNumber(Infinity));
      setConstant$1(math, 'NaN', new type.BigNumber(NaN));

      setLazyConstant$2(math, 'pi',  function () {return constants.pi(type.BigNumber)});
      setLazyConstant$2(math, 'tau', function () {return constants.tau(type.BigNumber)});
      setLazyConstant$2(math, 'e',   function () {return constants.e(type.BigNumber)});
      setLazyConstant$2(math, 'phi', function () {return constants.phi(type.BigNumber)}); // golden ratio, (1+sqrt(5))/2

      // uppercase constants (for compatibility with built-in Math)
      setLazyConstant$2(math, 'E',       function () {return math.e;});
      setLazyConstant$2(math, 'LN2',     function () {return new type.BigNumber(2).ln();});
      setLazyConstant$2(math, 'LN10',    function () {return new type.BigNumber(10).ln()});
      setLazyConstant$2(math, 'LOG2E',   function () {return new type.BigNumber(1).div(new type.BigNumber(2).ln());});
      setLazyConstant$2(math, 'LOG10E',  function () {return new type.BigNumber(1).div(new type.BigNumber(10).ln())});
      setLazyConstant$2(math, 'PI',      function () {return math.pi});
      setLazyConstant$2(math, 'SQRT1_2', function () {return new type.BigNumber('0.5').sqrt()});
      setLazyConstant$2(math, 'SQRT2',   function () {return new type.BigNumber(2).sqrt()});
    }
    else {
      setConstant$1(math, 'Infinity', Infinity);
      setConstant$1(math, 'NaN',      NaN);

      setConstant$1(math, 'pi',  Math.PI);
      setConstant$1(math, 'tau', Math.PI * 2);
      setConstant$1(math, 'e',   Math.E);
      setConstant$1(math, 'phi', 1.61803398874989484820458683436563811772030917980576286213545); // golden ratio, (1+sqrt(5))/2

      // uppercase constants (for compatibility with built-in Math)
      setConstant$1(math, 'E',           math.e);
      setConstant$1(math, 'LN2',         Math.LN2);
      setConstant$1(math, 'LN10',        Math.LN10);
      setConstant$1(math, 'LOG2E',       Math.LOG2E);
      setConstant$1(math, 'LOG10E',      Math.LOG10E);
      setConstant$1(math, 'PI',          math.pi);
      setConstant$1(math, 'SQRT1_2',     Math.SQRT1_2);
      setConstant$1(math, 'SQRT2',       Math.SQRT2);
    }

    // complex i
    setConstant$1(math, 'i', type.Complex.I);

    // meta information
    setConstant$1(math, 'version', version$1);
  }

  // create a constant in both math and mathWithTransform
  function setConstant$1(math, name, value) {
    math[name] = value;
    math.expression.mathWithTransform[name] = value;
  }

  // create a lazy constant in both math and mathWithTransform
  function setLazyConstant$2 (math, name, resolver) {
    object.lazy(math, name,  resolver);
    object.lazy(math.expression.mathWithTransform, name,  resolver);
  }

  var factory_1$282 = factory$283;
  var lazy$6 = false;  // no lazy loading of constants, the constants themselves are lazy when needed
  var math$22 = true;   // request access to the math namespace

  var constants$2 = {
  	factory: factory_1$282,
  	lazy: lazy$6,
  	math: math$22
  };

  var lib$1 = [
    type$1,        // data types (Matrix, Complex, Unit, ...)
    constants$2,   // constants
    expression,  // expression parsing
    _function$3,    // functions
    json,        // serialization utility (math.json.reviver)
    error        // errors
  ];

  /**
   * math.js factory function. Creates a new instance of math.js
   *
   * @param {Object} [config] Available configuration options:
   *                            {number} epsilon
   *                              Minimum relative difference between two
   *                              compared values, used by all comparison functions.
   *                            {string} matrix
   *                              A string 'matrix' (default) or 'array'.
   *                            {string} number
   *                              A string 'number' (default), 'bignumber', or
   *                              'fraction'
   *                            {number} precision
   *                              The number of significant digits for BigNumbers.
   *                              Not applicable for Numbers.
   *                            {boolean} predictable
   *                              Predictable output type of functions. When true,
   *                              output type depends only on the input types. When
   *                              false (default), output type can vary depending
   *                              on input values. For example `math.sqrt(-4)`
   *                              returns `complex('2i')` when predictable is false, and
   *                              returns `NaN` when true.
   */
  function create$3 (config) {
    // create a new math.js instance
    var math = core$1.create(config);
    math.create = create$3;

    // import data types, functions, constants, expression parser, etc.
    math['import'](lib$1);

    return math;
  }

  // return a new instance of math.js
  var mathjs = create$3();

  var node$1 = mathjs.expression.node;

  const operators$2 = {
    "+": function(operands) { return new node$1.OperatorNode('+', 'add', operands);},
    "*": function(operands) { return new node$1.OperatorNode('*', 'multiply', operands);},
    "/": function(operands)  { return new node$1.OperatorNode('/', 'divide', operands);},
    "-": function(operands) { return new node$1.OperatorNode('-', 'unaryMinus', [operands[0]]);},
    "^": function(operands) { return new node$1.OperatorNode('^', 'pow', operands);},
    //"prime": function(operands) { return operands[0] + "'"; },
    //"tuple": function(operands) { return '\\left( ' + operands.join( ', ' ) + ' \\right)';},
    //"array": function(operands) { return '\\left[ ' + operands.join( ', ' ) + ' \\right]';},
    //"set": function(operands) { return '\\left\\{ ' + operands.join( ', ' ) + ' \\right\\}';},
    "vector": function(operands) { return new node$1.ArrayNode(operands);},
    //"interval": function(operands) { return '\\left( ' + operands.join( ', ' ) + ' \\right)';},
    "and": function(operands) { return new node$1.OperatorNode('and', 'and', operands);},
    "or": function(operands) { return new node$1.OperatorNode('or', 'or', operands);},
    "not": function(operands) { return new node$1.OperatorNode('not', 'not', [operands[0]]);},
    "<": function(operands) { return new node$1.OperatorNode('<', 'smaller', operands);},
    ">": function(operands) { return new node$1.OperatorNode('>', 'larger', operands);},
    "le": function(operands) { return new node$1.OperatorNode('<=', 'smallerEq', operands);},
    "ge": function(operands) { return new node$1.OperatorNode('>=', 'largerEq', operands);},
    "ne": function(operands) { return new node$1.OperatorNode('!=', 'unequal', operands);},
    //"union": function (operands) { return operands.join(' \\cup '); },
    //"intersect": function (operands) { return operands.join(' \\cap '); },
  };

  class astToMathjs {
    constructor({ mathjs: mathjs$$1 = null } = {}) {
      if(mathjs$$1)
        node$1 = mathjs$$1.expression.node;
    }

    convert(tree) {
      if (typeof tree === 'number' ) {
        if(Number.isFinite(tree))
          return new node$1.ConstantNode(tree);
        if(Number.isNaN(tree))
          return new node$1.SymbolNode('NaN');
        if(tree < 0)
          return operators$2['-']([new node$1.SymbolNode('Infinity')]);
        return new node$1.SymbolNode('Infinity');
      }

      if (typeof tree === 'string') {
        return new node$1.SymbolNode(tree);
      }

      if (typeof tree === 'boolean')
        throw Error("no support for boolean");

      if (!Array.isArray(tree))
        throw Error("Invalid ast");

      const operator = tree[0];
      const operands = tree.slice(1);

      if(operator === "apply") {
        if(typeof operands[0] !== 'string')
  	throw Error("Non string functions not implemented for conversion to mathjs");

        if(operands[0] === "factorial")
  	return new node$1.OperatorNode('!', 'factorial',[this.convert(operands[1])]);

        const f = new node$1.SymbolNode(operands[0]);
        const args = operands[1];
        let f_args;

        if (args[0] === 'tuple')
          f_args =  args.slice(1).map(function(v,i) { return this.convert(v); }.bind(this));
        else
          f_args = [this.convert(args)];

        return new node$1.FunctionNode(f, f_args);
      }

      if(operator === 'lts' || operator === 'gts') {
        const args = operands[0];
        const strict = operands[1];

        if(args[0] !== 'tuple' || strict[0] !== 'tuple')
  	// something wrong if args or strict are not tuples
  	throw new Error("Badly formed ast");

        const arg_nodes = args.slice(1).map(function(v,i) { return this.convert(v); }.bind(this));

        let comparisons = [];
        for(let i=1; i< args.length-1; i++) {
          if(strict[i]) {
            if(operator === 'lts')
              comparisons.push(new node$1.OperatorNode('<', 'smaller', arg_nodes.slice(i-1, i+1)));
            else
              comparisons.push(new node$1.OperatorNode('>', 'larger', arg_nodes.slice(i-1, i+1)));
          }else{
            if(operator === 'lts')
              comparisons.push(new node$1.OperatorNode('<=', 'smallerEq', arg_nodes.slice(i-1, i+1)));
            else
              comparisons.push(new node$1.OperatorNode('>=', 'largerEq', arg_nodes.slice(i-1, i+1)));
          }
        }
        let result = new node$1.OperatorNode('and', 'and', comparisons.slice(0,2));
        for(let i=2; i<comparisons.length; i++)
          result = new node$1.OperatorNode('and', 'and', [result, comparisons[i]]);
        return result;
      }

      if(operator === '=') {

        let arg_nodes = operands.map(function(v,i) { return this.convert(v); }.bind(this) );

        let comparisons = [];
        for(let i=1; i< arg_nodes.length; i++) {
          comparisons.push(new node$1.OperatorNode('==', 'equal', arg_nodes.slice(i-1, i+1)));
        }

        if(comparisons.length === 1)
          return comparisons[0];

        let result = new node$1.OperatorNode('and', 'and', comparisons.slice(0,2));
        for(let i=2; i<comparisons.length; i++)
          result = new node$1.OperatorNode('and', 'and', [result, comparisons[i]]);
        return result;
      }

      if(operator === 'in' || operator === 'notin' ||
         operator === 'ni' || operator === 'notni') {

        let x, interval;
        if(operator === 'in' || operator === 'notin') {
  	x = operands[0];
  	interval = operands[1];
        }else{
  	x = operands[1];
  	interval = operands[0];
        }
        if((typeof x !== 'number') && (typeof x !== 'string'))
  	throw Error("Set membership non-string variables not implemented for conversion to mathjs");
        x = this.convert(x);

        if(interval[0] !== 'interval')
          throw Error("Set membership in non-intervals not implemented for conversion to mathjs");

        let args = interval[1];
        let closed = interval[2];
        if(args[0] !== 'tuple' || closed[0] !== 'tuple')
          throw new Error("Badly formed ast");

        let a = this.convert(args[1]);
        let b = this.convert(args[2]);

        let comparisons = [];
        if(closed[1])
          comparisons.push(new node$1.OperatorNode('>=', 'largerEq', [x,a]));
        else
          comparisons.push(new node$1.OperatorNode('>', 'larger', [x,a]));
        if(closed[2])
          comparisons.push(new node$1.OperatorNode('<=', 'smallerEq', [x,b]));
        else
          comparisons.push(new node$1.OperatorNode('<', 'smaller', [x,b]));

        let result =  new node$1.OperatorNode('and', 'and', comparisons);

        if(operator === 'notin' || operator === 'notni')
          result = new node$1.OperatorNode('not', 'not', [result]);

        return result;
      }

      if(operator === 'subset' || operator === 'notsubset' ||
         operator === 'superset' || operator === 'notsuperset') {

        let big, small;
        if(operator === 'subset' || operator === 'notsubset') {
  	small = operands[0];
  	big = operands[1];
        }else{
  	small = operands[1];
  	big = operands[0];
        }
        if(small[0] !== 'interval' || big[0] !== 'interval')
          throw Error("Set containment of non-intervals not implemented for conversion to mathjs");

        let small_args = small[1];
        let small_closed = small[2];
        let big_args = big[1];
        let big_closed = big[2];
        if(small_args[0] !== 'tuple' || small_closed[0] !== 'tuple' ||
  	 big_args[0] !== 'tuple' || big_closed[0] !== 'tuple')
  	throw Error("Badly formed ast");

        let small_a = this.convert(small_args[1]);
        let small_b = this.convert(small_args[2]);
        let big_a = this.convert(big_args[1]);
        let big_b = this.convert(big_args[2]);

        let comparisons = [];
        if(small_closed[1] && !big_closed[1])
  	comparisons.push(new node$1.OperatorNode('>', 'larger',[small_a,big_a]));
        else
  	comparisons.push(new node$1.OperatorNode('>=', 'largerEq',[small_a,big_a]));

        if(small_closed[2] && !big_closed[2])
  	comparisons.push(new node$1.OperatorNode('<', 'smaller',[small_b,big_b]));
        else
  	comparisons.push(new node$1.OperatorNode('<=', 'smallerEq',[small_b,big_b]));

        let result =  new node$1.OperatorNode('and', 'and', comparisons);

        if(operator === 'notsubset' || operator === 'notsuperset')
  	result = new node$1.OperatorNode('not', 'not', [result]);

        return result;
      }

      if(operator === 'matrix') {
        // Convert matrices into nested array nodes
        // Will become matrix on eval

        let size = operands[0];
        let nrows = size[1];
        let ncols = size[2];

        let entries = operands[1];

        if(!Number.isInteger(nrows) || !Number.isInteger(ncols))
  	throw Error('Matrix must have integer dimensions');

        let result = [];

        for(let i=1; i <= nrows; i++) {
  	let row = [];
  	for(let j=1; j <= ncols; j++) {
  	  row.push(this.convert(entries[i][j]));
  	}
  	result.push(new node$1.ArrayNode(row));
        }

        return new node$1.ArrayNode(result);

      }

      if (operator in operators$2) {
        return operators$2[operator](
          operands.map( function(v,i) { return this.convert(v); }.bind(this) ) );
      }

      throw Error("Operator " + operator + " not implemented for conversion to mathjs");

    }


  }

  var function_normalizations = {
    ln: 'log',
    arccos: 'acos',
    arccosh: 'acosh',
    arcsin: 'asin',
    arcsinh: 'asinh',
    arctan: 'atan',
    arctanh: 'atanh',
    arcsec: 'asec',
    arcsech: 'asech',
    arccsc: 'acsc',
    arccsch: 'acsch',
    arccot: 'acot',
    arccoth: 'acoth',
    cosec: 'csc',
  };

  function normalize_function_names(expr_or_tree) {
    // replace "ln" with "log"
    // "arccos" with "acos", etc.
    // e^x with exp(x)
    // sqrt(x) with x^0.5

    var tree = get_tree(expr_or_tree);

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    if (operator === 'apply') {
      if (operands[0] === 'sqrt') {
        return ['^', normalize_function_names(operands[1]), 0.5];
      }

      var result = normalize_function_names_sub(operands[0]);
      result = ['apply', result];

      var args = operands.slice(1).map(function (v) {
        return normalize_function_names(v);
      });

      if (args.length > 1)
        args = ['tuple'].concat(args);
      else
        args = args[0];

      result.push(args);

      return result;
    }

    if (operator === '^' && operands[0] === 'e' && math$19.define_e)
      return ['apply', 'exp', normalize_function_names(operands[1])];

    return [operator].concat(operands.map(function (v) {
      return normalize_function_names(v)
    }));
  }

  function normalize_function_names_sub(tree) {

    if (typeof tree === 'string') {
      if (tree in function_normalizations)
        return function_normalizations[tree];
      return tree;
    }

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    var result = [operator].concat(operands.map(function (v) {
      return normalize_function_names_sub(v);
    }));

    return result;
  }



  function normalize_applied_functions(expr_or_tree) {
    // normalize applied functions
    // so that primes and powers occur outside function application

    var tree = get_tree(expr_or_tree);

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    if (operator === 'apply') {
      let result = strip_function_names(operands[0]);
      let f_applied = ['apply', result.tree, operands[1]];
      for (let i = 0; i < result.n_primes; i++)
        f_applied = ['prime', f_applied];

      if (result.exponent !== undefined)
        f_applied = ['^', f_applied, result.exponent];

      return f_applied
    }

    var result = [operator].concat(operands.map(function (v, i) { return normalize_applied_functions(v); }));
    return result;
  }


  function strip_function_names(tree) {
    // strip primes and powers off tree

    if (!Array.isArray(tree))
      return { tree: tree, n_primes: 0 };

    var operator = tree[0];
    var operands = tree.slice(1);


    if (operator === '^') {
      let result = strip_function_names(operands[0]);
      let exponent = normalize_applied_functions(operands[1]);

      result.exponent = exponent;
      return result;
    }

    if (operator === "prime") {
      let result = strip_function_names(operands[0]);
      result.n_primes += 1;
      return result;
    }

    return { tree: normalize_applied_functions(tree), n_primes: 0 };
  }


  function substitute_abs(expr_or_tree) {

    var tree = get_tree(expr_or_tree);

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);

    if (operator === "apply" && operands[0] === 'abs') {
      return ['^', ['^', substitute_abs(operands[1]), 2], 0.5];
    }

    return [operator].concat(operands.map(function (v) {
      return substitute_abs(v);
    }));
  }


  function constants_to_floats(expr_or_tree) {

    var tree = get_tree(expr_or_tree);

    if(!(math$19.define_e || math$19.define_pi)) {
      return tree;
    }
    if(typeof tree === "string") {
      if(tree === "e") {
        if(math$19.define_e) {
          return math$19.e;
        }
      } else if(tree === "pi") {
        if(math$19.define_pi) {
          return math$19.pi;
        }
      }
      return tree;
    }

    if(!Array.isArray(tree)) {
      return tree;
    }

    let operator = tree[0];
    let operands = tree.slice(1);

    // don't convert exponential function
    if(operator === "^" && operands[0] === "e") {
      return ["^", "e", constants_to_floats(operands[1])];
    }

    return [operator, ...operands.map(constants_to_floats)]

  }

  var astToMathjs$1 = new astToMathjs({mathjs: math$19 });

  const f = function(expr_or_tree) {
      var tree = get_tree(expr_or_tree);
      
      var mt = factorial_to_gamma_function(
  	astToMathjs$1.convert(	
  	    normalize_function_names(
  		normalize_applied_functions(
  		    tree
  		)
  	    )
  	)
      );
      
      return mt.eval.bind(mt);
  };

  const evaluate = function(expr, bindings) {
      return f(expr)(bindings);
  };

  // export const finite_field_evaluate = function(expr, bindings, modulus) {
  //     return parser.ast.to.finiteField( expr.tree, modulus )( bindings );
  // };

  const evaluate_to_constant = function(expr_or_tree) {
    // evaluate to number by converting tree to number
    // and calling without arguments

    // return null if couldn't evaluate to constant (e.g., contains a variable)
    // otherwise returns constant
    // NOTE: constant could be a math.js complex number object

    var tree = get_tree(expr_or_tree);

    if(typeof tree === "number") {
      return tree;
    }else if(typeof tree === "string") {
      if(tree === "pi" && math$19.define_pi) {
        return Math.PI;
      }else if(tree === "e" && math$19.define_e) {
        return Math.E;
      }else if(tree === "i" && math$19.define_i) {
        return { re: 0, im: 1};
      }
      return null;
    }

    var num=null;
    try {
      var the_f = f(expr_or_tree);
      num = the_f();
    }
    catch (e) {}
    return num;
  };

  function factorial_to_gamma_function(math_tree) {
      // convert factorial to gamma function
      // so that can evaluate at complex numbers
      var transformed = math_tree.transform(function (node, path, parent) {
      	if(node.isOperatorNode && node.op === "!" && node.fn === "factorial") {
      	    var args = [new math$19.expression.node.OperatorNode(
      		'+', 'add', [node.args[0],
      			     new math$19.expression.node.ConstantNode(1)])];
      	    return new math$19.expression.node.FunctionNode(
      		new math$19.expression.node.SymbolNode("gamma"),args);
      	}
      	else {
      	    return node;
      	}
      });
      return transformed;
  }

  var evaluation = /*#__PURE__*/Object.freeze({
    f: f,
    evaluate: evaluate,
    evaluate_to_constant: evaluate_to_constant
  });

  // functions that map from one set to another
  var functions$1 = {
      C: {},
      R: {},
      nonzeroC: {},
      nonneg: {},
      pos: {},
  };

  functions$1.C.nonneg = ["abs"];
  functions$1.C.nonzero = ["exp"];
  functions$1.C.R = ["abs", "arg"];
  functions$1.C.C = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh",
  		 "erf", "sqrt", "log", "ln", "log10"];
  functions$1.R.pos = ["exp"];
  functions$1.R.nonneg = ["abs", "exp", "arg"];
  functions$1.R.R = ["abs", "arg", "exp", "sign",  "cos", "cosh", "sin", "sinh",
  		 "erf"];
  functions$1.R.Z = ["sign"];
  functions$1.nonzeroC.pos = ["abs"];
  functions$1.nonneg.nonneg = ["abs", "exp", "arg", "sqrt", "erf"];
  functions$1.nonzeroC.nonzero = ["abs"];
  functions$1.nonneg.R = [...new Set(functions$1.R.R.concat(
      functions$1.nonneg.nonneg))];
  functions$1.pos.pos = ["abs", "exp", "sqrt", "erf"];
  functions$1.pos.nonneg = functions$1.pos.pos;
  functions$1.pos.nonzero = ["abs", "exp", "sqrt", "erf"];
  functions$1.pos.R = functions$1.nonneg.R.concat(["log", "ln", "log10"]);


  function negate_adjust(result, negate_assumptions) {
      if(result)
  	return !negate_assumptions;
      if(result===false)
  	return negate_assumptions;
      return undefined
  }

  function narrow_assumptions(assumptions, original_assumptions) {
      // find part of original assumptions after remove assumptions

      if(!Array.isArray(original_assumptions))
  	return [];

      var operator = original_assumptions[0];
      var operands = original_assumptions.slice(1);
      if(operator !== 'and')
  	return [];

      var remaining_assumptions = [];

      for(var i=0; i<operands.length; i++) {
  	if(!equal$2(operands[i], assumptions))
  	    remaining_assumptions.push(operands[i]);
      }
      if(remaining_assumptions.length === 0)
  	return [];
      if(remaining_assumptions.legnth === 1)
  	return remaining_assumptions[0];
      return [operator].concat(remaining_assumptions);

  }


  function simple_assumption_combination(assume_operator, left, right) {
      // For assume_operator='and' or assume_operator='or'
      // attempt to deduce wehther or not assumption was met
      // given results from left and right.
      // Results left and right are either true, false, or undefind (ambiguous)

      // Note: assumptions are restrictions on possible values.
      // If assume_operator is AND, then having a test passing
      // with either condition (restriction) is sufficient to pass test.
      // Not attemping logic where only a combination of restrictions
      // will lead to a pass.

      if(assume_operator === 'and') {
  	// if one is undefined (i.e., ambiguous)
  	// result is determined by other
  	if(left === undefined)
  	    return right;
  	if(right === undefined)
  	    return left;

  	// meeting either restriction means both conditions are enough
  	return left || right;
      }
      else { //assume_operator === 'or';

  	// Since either condition could apply,
  	// the test must pass for both

  	// if either test is ambiguous, overall result is ambiguous
  	if(left === undefined || right === undefined)
  	    return undefined;

  	// if tests disagree, result is ambiguous
  	if(left !== right)
  	    return undefined;

  	return left;
      }
  }

  function is_integer_ast(tree, assumptions, original_assumptions) {
      // see description of is_integer

      if(typeof assumptions !== 'object')
  	assumptions = [];

      if(original_assumptions===undefined)
  	original_assumptions = assumptions;

      if(typeof tree === 'number')
  	return Number.isInteger(tree);

      // if can convert to constant, evaluate directly
      var c = evaluate_to_constant(tree);
      if(c !== null) {
  	return Number.isInteger(c);
      }

      if(typeof tree === 'string') {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions(tree);
  	if(!Array.isArray(assume))
  	    return undefined;

  	let assume_with_negations = assume;

  	let assume_operator = assume[0];
  	let assume_operands = assume.slice(1);

  	let negate_assumptions = false;
  	while(assume_operator === 'not') {
  	    negate_assumptions = !negate_assumptions;
  	    assume = assume_operands[0];
  	    if(!Array.isArray(assume))
  		return undefined;
  	    assume_operator = assume[0];
  	    assume_operands = assume.slice(1);
  	}

  	if(assume_operator === 'in')
  	    if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		return negate_adjust(true, negate_assumptions);
  	if(assume_operator === 'notin')
  	    if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		return negate_adjust(false, negate_assumptions);


  	// haven't negated, then determining tree is not real or complex
  	//  means it is not an integer
  	if(negate_assumptions===false) {
  	    if(assume_operator === 'notin') {
  		if(assume_operands[0]===tree && assume_operands[1] === 'R')
  		    return false;
  		if(assume_operands[0]===tree && assume_operands[1] === 'C')
  		    return false;
  	    }
  	}
  	// if have negated, then determining tree is real or complex
  	// means it is not an integer
  	else {
  	    if(assume_operator === 'in') {
  		if(assume_operands[0]===tree && assume_operands[1] === 'R')
  		    return false;
  		if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		    return false;
  	    }
  	}
  	// assume equality has been expanded so that has two arguments
  	if((assume_operator === '=' && !negate_assumptions) ||
  	   (assume_operator === 'ne' && negate_assumptions)) {
  	    // if assumption is "tree=something"
  	    // check if something is integer
  	    // (but without the assumption to avoid infinite loop)

  	    let new_assumptions = narrow_assumptions(assume_with_negations,
  						     original_assumptions);
  	    if(assume_operands[0]===tree)
  		return is_integer_ast(assume_operands[1], new_assumptions);
  	    if(assume_operands[1]===tree)
  		return is_integer_ast(assume_operands[0], new_assumptions);
  	}

  	// if isn't a simple And or Or, just give up
  	if(assume_operator !== 'and' && assume_operator !== 'or')
  	    return undefined;

  	// shouldn't have negated assumptions
  	if(negate_assumptions)
  	    return undefined;

  	// if more than two operands, unflatten
  	// (OK, since not attempting logic where only combined restrictions
  	// lead to a passing test)
  	if(assume_operands.length > 2) {
  	    assume = unflattenRight(assume);
  	    assume_operands = assume.slice(1);
  	}

  	let result_left = is_integer_ast(tree, assume_operands[0],
  					 original_assumptions);
  	let result_right = is_integer_ast(tree, assume_operands[1],
  					  original_assumptions);
  	return simple_assumption_combination(assume_operator, result_left,
  					     result_right)
      }

      if(Array.isArray(tree)) {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions([variables(tree)]);

  	let operator = tree[0];
  	let operands = tree.slice(1);

  	if(operator === '-')
  	    return is_integer_ast(operands[0], assume, original_assumptions);

  	if(operator === '*') {

  	    let all_integers = operands.every(
  		function (v) {
  		    return is_integer_ast(v, assume, original_assumptions);
  		});

  	    if(all_integers)
  		return true;
  	    else {
  		return undefined;

  	    }
  	}

  	if(operator === '^') {

  	    let base_nonzero = is_nonzero_ast(operands[0], assume,
  					      original_assumptions);

  	    if(!base_nonzero) {
  		// if base is NaN, return false
  		if(Number.isNaN(operands[0]))
  		    return false;

  		let pow_positive = is_positive_ast(operands[1], assume, true,
  						   original_assumptions);

  		if(pow_positive) {
  		    if(base_nonzero === false)
  			return true;  // 0^positive
  		}
  		else {
  		    return undefined; // (possibly zero)^(possibly nonpositive)
  		}

  	    }
  	    else { // nonzero base
  		let pow_nonzero = is_nonzero_ast(operands[1], assume,
  						 original_assumptions);
  		if(pow_nonzero === false) {
  		    // infinity^0 is undefined
  		    if(operands[0] === Infinity || operands[0] === -Infinity)
  			return false;

  		    return true;   // nonzero^0
  		}

  	    }

  	    let base_integer = is_integer_ast(operands[0], assume,
  					      original_assumptions);
  	    let pow_integer =  is_integer_ast(operands[1], assume,
  					      original_assumptions);

  	    if(!base_integer)
  		return base_integer;

  	    if(!pow_integer)
  		return undefined;  // don't check for cases like 9^(1/2)

  	    let pow_nonneg= is_positive_ast(operands[1], assume, false,
  					    original_assumptions);

  	    if(pow_nonneg)
  		return true;
  	    else
  		return undefined;


  	}
  	if(operator === '+') {

  	    let n_non_integers=0;

  	    for(let i=0; i < operands.length; i++) {
  		let result = is_integer_ast(operands[i], assume,
  					    original_assumptions);

  		if(result === false) {
  		    if(n_non_integers > 0)
  			return undefined;
  		    n_non_integers += 1;
  		}
  		if(result === undefined)
  		    return undefined;
  	    }

  	    if(n_non_integers === 0)
  		return true;
  	    else // only one non-integer
  		return false;
  	}


  	// check for functions that map certain sets to integers
  	if(operator === 'apply') {
  	    if(functions$1.C.Z && functions$1.C.Z.includes(operands[0]) &&
  	       is_complex_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.R.Z && functions$1.R.Z.includes(operands[0]) &&
  	       is_real_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.nonzeroC.Z && functions$1.nonzeroC.Z.includes(operands[0])
  	       && is_nonzero_ast(operands[1], assume, original_assumptions)
  	       && is_complex_ast(operands[1], assume, original_assumptions)
  	      )
  		return true;
  	    if(functions$1.nonneg.Z && functions$1.nonneg.Z.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, false, original_assumptions))
  		return true;
  	    if(functions$1.pos.Z && functions$1.pos.Z.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, true, original_assumptions))
  		return true;
  	    return undefined;
  	}

  	if(operator === '/' || operator === 'prime')
  	    return undefined;

  	// other operators don't return numbers
  	return false;
      }

      return false;
  }


  function is_real_ast(tree, assumptions, original_assumptions) {
      // see description of is_real

      if(typeof assumptions !== 'object')
  	assumptions = [];

      if(original_assumptions===undefined)
  	original_assumptions = assumptions;

      if(typeof tree === 'number')
  	return Number.isFinite(tree);

      // if can convert to constant, evaluate directly
      var c = evaluate_to_constant(tree);

      if(c !== null) {
  	if(typeof c === 'number') {
  	    return Number.isFinite(c);
  	}
  	return false;
      }

      if(typeof tree === 'string') {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions(tree);

  	if(!Array.isArray(assume))
  	    return undefined;

  	let assume_with_negations = assume;

  	let assume_operator = assume[0];
  	let assume_operands = assume.slice(1);

  	let negate_assumptions = false;
  	while(assume_operator === 'not') {
  	    negate_assumptions = !negate_assumptions;
  	    assume = assume_operands[0];
  	    if(!Array.isArray(assume))
  		return undefined;
  	    assume_operator = assume[0];
  	    assume_operands = assume.slice(1);
  	}

  	if(assume_operator === 'in')
  	    if(assume_operands[0]===tree && assume_operands[1] === 'R')
  		return negate_adjust(true, negate_assumptions);
  	if(assume_operator === 'notin')
  	    if(assume_operands[0]===tree && assume_operands[1] === 'R')
  		return negate_adjust(false, negate_assumptions);
  	// haven't negated, then determining tree is integer means it is real
  	if(negate_assumptions===false) {
  	    if(assume_operator === 'in')
  		if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		    return true;
  	}
  	// if have negated, then determining tree is not integer,
  	// means it is an integer, hence real
  	else {
  	    if(assume_operator === 'notin')
  		if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		    return true;
  	}

  	// if assumptions is an inequality involving variable
  	// then return true
  	if(assume_operator === '<' || assume_operator === 'le') {

  	    let variables_in_inequality = variables(assume);
  	    let functions_in_inequality = functions(assume);

  	    if(variables_in_inequality.indexOf(tree) !== -1
  	      && functions_in_inequality.length === 0)
  		return true;  // don't negate adjust
  	}

  	// assume equality has been expanded so that has two arguments
  	if((assume_operator === '=' && !negate_assumptions) ||
  	   (assume_operator === 'ne' && negate_assumptions)) {
  	    // if assumption is "tree=something"
  	    // check if something is real
  	    // (but without the assumption to avoid infinite loop)

  	    let new_assumptions = narrow_assumptions(assume_with_negations,
  						     original_assumptions);
  	    if(assume_operands[0]===tree)
  		return is_real_ast(assume_operands[1], new_assumptions);
  	    if(assume_operands[1]===tree)
  		return is_real_ast(assume_operands[0], new_assumptions);
  	}


  	// if isn't a simple And or Or, just give up
  	if(assume_operator !== 'and' && assume_operator !== 'or')
  	    return undefined;

  	// shouldn't have negated assumptions
  	if(negate_assumptions)
  	    return undefined;

  	// if more than two operands, unflatten
  	// (OK, since not attempting logic where only combined restrictions
  	// lead to a passing test)
  	if(assume_operands.length > 2) {
  	    assume = unflattenRight(assume);
  	    assume_operands = assume.slice(1);
  	}

  	let result_left = is_real_ast(tree, assume_operands[0],
  				      original_assumptions);
  	let result_right = is_real_ast(tree, assume_operands[1],
  				       original_assumptions);

  	return simple_assumption_combination(assume_operator, result_left,
  					     result_right)
      }

      if(Array.isArray(tree)) {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions([variables(tree)]);


  	let operator = tree[0];
  	let operands = tree.slice(1);

  	if(operator === '-') {
  	    return is_real_ast(operands[0], assume, original_assumptions);
  	}
  	if(operator === '*' || operator === '+') {

  	    // if more than two terms, unflatten
  	    if(operands.length > 2) {
  		tree = unflattenRight(tree);
  		operands = tree.slice(1);
  	    }

  	    if(operator==='*') {
  		// one confirmed zero factor makes product zero
  		if((is_nonzero_ast(operands[0], assume, original_assumptions)
  		    === false) ||
  		   (is_nonzero_ast(operands[1], assume, original_assumptions)
  		    === false))
  		    return true;
  	    }

  	    let left_real = is_real_ast(operands[0], assume,
  					original_assumptions);
  	    let right_real = is_real_ast(operands[1], assume,
  					 original_assumptions);

  	    if(left_real && right_real)
  		return true;

  	    // can confirm that is not real
  	    // if one term/factor is real and the other is not real
  	    if((left_real && right_real===false) ||
  	       (right_real && left_real===false))
  		return false

  	    return undefined;

  	}

  	if(operator === '^') {

  	    let base_nonzero = is_nonzero_ast(operands[0], assume,
  					      original_assumptions);
  	    let pow_positive = is_positive_ast(operands[1], assume, true,
  					       original_assumptions);

  	    if(!base_nonzero) {
  		// if base is NaN, return false
  		if(Number.isNaN(operands[0]))
  		    return false;

  		if(pow_positive) {
  		    if(base_nonzero === false)
  			return true;  // 0^positive
  		}
  		else {
  		    return undefined; // (possibly zero)^(possibly nonpositive)
  		}

  	    }
  	    else { // nonzero base
  		let pow_nonzero = is_nonzero_ast(operands[1], assume,
  						 original_assumptions);
  		if(pow_nonzero === false) {
  		    // infinity^0 is undefined
  		    if(operands[0] === Infinity || operands[0] === -Infinity)
  			return false;

  		    return true;   // nonzero^0
  		}

  	    }

  	    let base_real = is_real_ast(operands[0], assume,
  					original_assumptions);
  	    let pow_real = is_real_ast(operands[1], assume,
  				       original_assumptions);

  	    if(!(base_real && pow_real))
  		return undefined;

  	    let base_nonnegative = is_positive_ast(operands[0], assume, false,
  						   original_assumptions);

  	    if(!base_nonnegative) {
  		// if base might be negative
  		// then power must be an integer
  		// (already excluded 0^0)

  		let pow_integer = is_integer_ast(operands[1], assume,
  						 original_assumptions);
  		if(pow_integer)
  		    return true;
  		else
  		    return undefined
  	    }

  	    let base_positive = is_positive_ast(operands[0], assume, true,
  						original_assumptions);

  	    if(!base_positive) {
  		// if base might be zero
  		// then power must be positive
  		if(pow_positive)
  		    return true;
  		else
  		    return undefined;
  	    }

  	    // base is positive, power is real
  	    return true;

  	}

  	if(operator === '/') {
  	    // if can't be sure denominator is nonzero
  	    if(!is_nonzero_ast(operands[1], assume, original_assumptions))
  		return undefined;

  	    // zero numerator
  	    if(is_nonzero_ast(operands[0], assume, original_assumptions) === false)
  		return true;

  	    if(!(is_real_ast(operands[0], assume, original_assumptions)
  		 && is_real_ast(operands[1], assume, original_assumptions)))
  		return undefined;

  	    return true;

  	}

  	// check for functions that map certain sets to reals
  	if(operator === 'apply') {
  	    if(functions$1.C.R && functions$1.C.R.includes(operands[0]) &&
  	       is_complex_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.R.R && functions$1.R.R.includes(operands[0]) &&
  	       is_real_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.nonzeroC.R && functions$1.nonzeroC.R.includes(operands[0])
  	       && is_nonzero_ast(operands[1], assume, original_assumptions)
  	       && is_complex_ast(operands[1], assume, original_assumptions)
  	      )
  		return true;
  	    if(functions$1.nonneg.R && functions$1.nonneg.R.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, false, original_assumptions))
  		return true;
  	    if(functions$1.pos.R && functions$1.pos.R.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, true, original_assumptions))
  		return true;
  	    return undefined;
  	}

  	if(operator === 'prime')
  	    return undefined;

  	// other operators don't return numbers
  	return false;
      }

      return false;
  }


  function is_complex_ast(tree, assumptions, original_assumptions) {
      // see description of is_complex

      if(typeof assumptions !== 'object')
  	assumptions = [];

      if(original_assumptions===undefined)
  	original_assumptions = assumptions;

      if(typeof tree === 'number')
  	return Number.isFinite(tree);

      // if can convert to constant, evaluate directly
      var c = evaluate_to_constant(tree);
      if(c !== null) {
  	if(typeof c === 'number') {
  	    return Number.isFinite(c);
  	}
  	if(c.re !== undefined && Number.isFinite(c.re)
  	   && c.im !== undefined && Number.isFinite(c.im) )
  	    return true;

  	return false;
      }

      if(typeof tree === 'string') {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions(tree);

  	if(!Array.isArray(assume))
  	    return undefined;

  	let assume_with_negations = assume;

  	let assume_operator = assume[0];
  	let assume_operands = assume.slice(1);

  	let negate_assumptions = false;
  	while(assume_operator === 'not') {
  	    negate_assumptions = !negate_assumptions;
  	    assume = assume_operands[0];
  	    if(!Array.isArray(assume))
  		return undefined;
  	    assume_operator = assume[0];
  	    assume_operands = assume.slice(1);
  	}

  	if(assume_operator === 'in')
  	    if(assume_operands[0]===tree && assume_operands[1] === 'C')
  		return negate_adjust(true, negate_assumptions);
  	if(assume_operator === 'notin')
  	    if(assume_operands[0]===tree && assume_operands[1] === 'C')
  		return negate_adjust(false, negate_assumptions);
  	// haven't negated, then determining tree is integer or real
  	// means it is complex
  	if(negate_assumptions===false) {
  	    if(assume_operator === 'in') {
  		if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		    return true;
  		if(assume_operands[0]===tree && assume_operands[1] === 'R')
  		    return true;
  	    }
  	}
  	// if have negated, then determining tree is not integer or not real,
  	// means it is an integer/real, hence complex
  	else {
  	    if(assume_operator === 'notin') {
  		if(assume_operands[0]===tree && assume_operands[1] === 'Z')
  		    return true;
  		if(assume_operands[0]===tree && assume_operands[1] === 'R')
  		    return true;
  	    }
  	}

  	// if assumptions is an inequality involving variable
  	// then must be real, hence complex, so return true
  	if(assume_operator === '<' || assume_operator === 'le') {

  	    let variables_in_inequality = variables(assume);
  	    let functions_in_inequality = functions(assume);

  	    if(variables_in_inequality.indexOf(tree) !== -1
  	      && functions_in_inequality.length === 0)
  		return true;  // don't negate adjust
  	}

  	// assume equality has been expanded so that has two arguments
  	if((assume_operator === '=' && !negate_assumptions) ||
  	   (assume_operator === 'ne' && negate_assumptions)) {
  	    // if assumption is "tree=something"
  	    // check if something is complex
  	    // (but without the assumption to avoid infinite loop)

  	    let new_assumptions = narrow_assumptions(assume_with_negations,
  						     original_assumptions);
  	    if(assume_operands[0]===tree)
  		return is_complex_ast(assume_operands[1], new_assumptions);
  	    if(assume_operands[1]===tree)
  		return is_complex_ast(assume_operands[0], new_assumptions);
  	}

  	// if isn't a simple And or Or, just give up
  	if(assume_operator !== 'and' && assume_operator !== 'or')
  	    return undefined;

  	// shouldn't have negated assumptions
  	if(negate_assumptions)
  	    return undefined;

  	// if more than two operands, unflatten
  	// (OK, since not attempting logic where only combined restrictions
  	// lead to a passing test)
  	if(assume_operands.length > 2) {
  	    assume = unflattenRight(assume);
  	    assume_operands = assume.slice(1);
  	}

  	let result_left = is_complex_ast(tree, assume_operands[0],
  					 original_assumptions);
  	let result_right = is_complex_ast(tree, assume_operands[1],
  					  original_assumptions);
  	return simple_assumption_combination(assume_operator, result_left,
  					     result_right)
      }

      if(Array.isArray(tree)) {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions([variables(tree)]);


  	let operator = tree[0];
  	let operands = tree.slice(1);

  	if(operator === '-')
  	    return is_complex_ast(operands[0], assume, original_assumptions);

  	if(operator === '*' || operator === '+') {

  	    if(operator==='*') {
  		// one confirmed zero factor makes product zero
  		if(!operands.every(v => is_nonzero_ast(v, assume, original_assumptions) !== false))
  		    return true;
  	    }

  	    let all_complex = operands.every(v => is_complex_ast(v, assume, original_assumptions));

  	    if(all_complex)
  		return true;
  	    else {
  		return undefined;

  	    }
  	}

  	if(operator === '^') {

  	    let base_nonzero = is_nonzero_ast(operands[0], assume,
  					      original_assumptions);
  	    let pow_positive = is_positive_ast(operands[1], assume, true,
  					       original_assumptions);

  	    if(!base_nonzero) {

  		// if base is NaN, return false
  		if(Number.isNaN(operands[0]))
  		    return false;

  		if(pow_positive) {
  		    if(base_nonzero === false)
  			return true;  // 0^positive
  		}
  		else {
  		    return undefined; // (possibly zero)^(possibly nonpositive)
  		}

  	    }
  	    else { // nonzero base
  		let pow_nonzero = is_nonzero_ast(operands[1], assume,
  						 original_assumptions);
  		if(pow_nonzero === false) {
  		    // infinity^0 is undefined
  		    if(operands[0] === Infinity || operands[0] === -Infinity)
  			return false;

  		    return true;   // nonzero^0
  		}

  	    }

  	    let base_complex = is_complex_ast(operands[0], assume,
  					      original_assumptions);
  	    let pow_complex = is_complex_ast(operands[1], assume,
  					     original_assumptions);

  	    if(base_complex && pow_complex)
  		return true;
  	    else
  		return undefined;

  	}

  	if(operator === '/') {
  	    // if can't be sure denominator is nonzero
  	    if(!is_nonzero_ast(operands[1], assume, original_assumptions))
  		return undefined;

  	    // zero numerator
  	    if(is_nonzero_ast(operands[0], assume, original_assumptions) === false)
  		return true;

  	    if(!(is_complex_ast(operands[0], assume, original_assumptions)
  		 && is_complex_ast(operands[1], assume, original_assumptions)))
  		return undefined;

  	    return true;

  	}

  	// check for functions that map certain sets to complex numbers
  	if(operator === 'apply') {
  	    if(functions$1.C.C && functions$1.C.C.includes(operands[0]) &&
  	       is_complex_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.R.C && functions$1.R.C.includes(operands[0]) &&
  	       is_real_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.nonzeroC.C && functions$1.nonzeroC.C.includes(operands[0])
  	       && is_nonzero_ast(operands[1], assume, original_assumptions)
  	       && is_complex_ast(operands[1], assume, original_assumptions)
  	      )
  		return true;
  	    if(functions$1.nonneg.C && functions$1.nonneg.C.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, false, original_assumptions))
  		return true;
  	    if(functions$1.pos.C && functions$1.pos.C.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, true, original_assumptions))
  		return true;
  	    return undefined;
  	}

  	if(operator === 'prime')
  	    return undefined;

  	// other operators don't return numbers
  	return false;
      }

      return false;
  }


  function is_nonzero_ast(tree, assumptions, original_assumptions) {
      // see description of is_nonzero

      if(typeof assumptions !== 'object')
  	assumptions = [];

      if(original_assumptions===undefined)
  	original_assumptions = assumptions;

      if(typeof tree === 'number') {
  	if(Number.isFinite(tree))
  	    return tree !== 0;
  	if(Number.isNaN(tree))
  	    return undefined;
  	return true;    // consider infinity to be nonzero
      }

      // if can convert to constant, evaluate directly
      var c = evaluate_to_constant(tree);
      if(c !== null) {
  	if(typeof c === 'number') {
  	    if(Number.isFinite(c))
  		return c !== 0;
  	    if(Number.isNaN(c))
  		return undefined;
  	    return true;  // consider infinity to be nonzero
  	}
  	if(c.re !== undefined && c.im !== undefined &&
  	   (c.re !== 0 || c.im !== 0) )
  	    return true;
  	return undefined;
      }

      if(typeof tree === 'string') {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions(tree);

  	if(!Array.isArray(assume))
  	    return undefined;

  	let assume_with_negations = assume;

  	let assume_operator = assume[0];
  	let assume_operands = assume.slice(1);

  	let negate_assumptions = false;
  	while(assume_operator === 'not') {
  	    negate_assumptions = !negate_assumptions;
  	    assume = assume_operands[0];
  	    if(!Array.isArray(assume))
  		return undefined;
  	    assume_operator = assume[0];
  	    assume_operands = assume.slice(1);
  	}

  	let new_assumptions = narrow_assumptions(assume_with_negations,
  						 original_assumptions);

  	// assume equality has been expanded so that has two arguments
  	if((assume_operator === '=' && !negate_assumptions) ||
  	   (assume_operator === 'ne' && negate_assumptions)) {
  	    // if assumption is "tree=something"
  	    // check if something is nonzero
  	    // (but without the assumption to avoid infinite loop)

  	    if(assume_operands[0]===tree)
  		return is_nonzero_ast(assume_operands[1], new_assumptions);
  	    if(assume_operands[1]===tree)
  		return is_nonzero_ast(assume_operands[0], new_assumptions);
  	}

  	if((assume_operator === 'ne' && !negate_assumptions) ||
  	   (assume_operator === '=' && negate_assumptions)) {
  	    // if assumption is "tree!=something"
  	    // check if something is zero

  	    if(assume_operands[0]===tree) {
  		if(is_nonzero_ast(assume_operands[1], new_assumptions)===false)
  		    return true
  	    }
  	    if(assume_operands[1]===tree) {
  		if(is_nonzero_ast(assume_operands[0], new_assumptions)===false)
  		    return true;
  	    }
  	}

  	// assume assumptions are ordered so greater than doesn't appear
  	if(assume_operator === '<') {
  	    if(!negate_assumptions) {
  		if(assume_operands[0]===tree) {
  		    if(is_negative_ast(
  			assume_operands[1], new_assumptions, false))
  			return true;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_positive_ast(
  			assume_operands[0], new_assumptions, false))
  			return true;
  		}
  	    }
  	    else {
  		// negated, becomes ge
  		if(assume_operands[0]===tree) {
  		    if(is_positive_ast(
  			assume_operands[1], new_assumptions, true))
  			return true;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_negative_ast(
  			assume_operands[0], new_assumptions, true))
  			return true;
  		}

  	    }
  	}
  	if(assume_operator === 'le') {
  	    if(!negate_assumptions) {
  		if(assume_operands[0]===tree) {
  		    if(is_negative_ast(
  			assume_operands[1], new_assumptions, true))
  			return true;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_positive_ast(
  			assume_operands[0], new_assumptions, true))
  			return true;
  		}
  	    }
  	    else {
  		// negated, so becomes >
  		if(assume_operands[0]===tree) {
  		    if(is_positive_ast(
  			assume_operands[1], new_assumptions, false))
  			return true;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_negative_ast(
  			assume_operands[0], new_assumptions, false))
  			return true;
  		}

  	    }
  	}

  	// if isn't a simple And or Or, just give up
  	if(assume_operator !== 'and' && assume_operator !== 'or')
  	    return undefined;

  	// shouldn't have negated assumptions
  	if(negate_assumptions)
  	    return undefined;

  	// if more than two operands, unflatten
  	// (OK, since not attempting logic where only combined restrictions
  	// lead to a passing test)
  	if(assume_operands.length > 2) {
  	    assume = unflattenRight(assume);
  	    assume_operands = assume.slice(1);
  	}

  	let result_left = is_nonzero_ast(tree, assume_operands[0],
  					 original_assumptions);
  	let result_right = is_nonzero_ast(tree, assume_operands[1],
  					  original_assumptions);
  	return simple_assumption_combination(assume_operator, result_left,
  					     result_right)
      }

      if(Array.isArray(tree)) {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions([variables(tree)]);

  	let operator = tree[0];
  	let operands = tree.slice(1);

  	if(operator === '-')
  	    return is_nonzero_ast(operands[0], assume, original_assumptions);

  	if(operator === '+') {

  	    // if more than two terms, unflatten
  	    if(operands.length > 2) {
  		tree = unflattenRight(tree);
  		operands = tree.slice(1);
  	    }

  	    // if operands are opposite
  	    // (trees.equal removes duplicate negatives through default_order)
  	    // TODO: check if operands aren't infinite
  	    if(equal$2(operands[0],
  			   simplify$2(['-', operands[1]],
  					     original_assumptions)))
  		return false;

  	    // can definitely determine nonzero if one term is zero
  	    // or if both have the same sign

  	    let nonzero_left = is_nonzero_ast(operands[0], assume,
  					      original_assumptions);
  	    let nonzero_right = is_nonzero_ast(operands[1], assume,
  					       original_assumptions);

  	    // if one is known to be zero, return result from other
  	    if(nonzero_left===false)
  		return nonzero_right;
  	    if(nonzero_right===false)
  		return nonzero_left;


  	    // if one of both aren't real
  	    // decide now
  	    let real_left = is_real_ast(operands[0], assume,
  					original_assumptions);
  	    let real_right = is_real_ast(operands[1], assume,
  					 original_assumptions);

  	    if(!real_left || !real_right) {
  		if(real_left===true) {
  		    if(real_right === false)
  			return true;
  		    return undefined;
  		}
  		if(real_right===true) {
  		    if(real_left===false)
  			return true;
  		    return undefined;
  		}
  		return undefined;
  	    }

  	    // if reach here, both are real

  	    let nonneg_left = is_positive_ast(operands[0], assume, false,
  					      original_assumptions);
  	    let nonneg_right = is_positive_ast(operands[1], assume, false,
  					       original_assumptions);

  	    let positive_left = is_positive_ast(operands[0], assume, true,
  						original_assumptions);
  	    let positive_right = is_positive_ast(operands[1], assume, true,
  						 original_assumptions);

  	    // positive + nonnegative is nonzero
  	    if( (nonneg_left && positive_right)
  		|| (positive_left && nonneg_right))
  		return true;

  	    // negative + nonpositive is nonzero
  	    if( (nonneg_left===false && positive_right===false)
  		|| (positive_left===false && nonneg_right===false))
  		return true;


  	    // have terms of both signs (or undefined sign)
  	    // so can't determine if nonzero by this approach
  	    return undefined;
  	}

  	if(operator === '*') {
  	    let all_nonzero = true;
  	    for(let i=0; i < operands.length; i++) {

  		let result = is_nonzero_ast(operands[i], assume,
  					    original_assumptions);

  		if(result===false)
  		    return false;  // found a zero factor
  		if(result===undefined)
  		    all_nonzero=false;
  	    }

  	    if(all_nonzero)
  		return true;
  	    else
  		return undefined;
  	}

  	if(operator === '/') {

  	    let result = is_nonzero_ast(operands[0], assume,
  					original_assumptions);

  	    if(is_nonzero_ast(operands[1], assume, original_assumptions))
  		return result;
  	    else
  		return undefined;
  	}

  	if(operator === '^') {

  	    let base_nonzero = is_nonzero_ast(operands[0], assume,
  					      original_assumptions);

  	    if(!base_nonzero) {
  		let pow_positive = is_positive_ast(operands[1], assume, true,
  						   original_assumptions);

  		if(pow_positive && (base_nonzero === false))
  		    return false;  // 0^positive

  		return undefined;
  	    }
  	    else { // nonzero base
  		// infinity^0 is undefined
  		if(operands[0] === Infinity || operands[0] === -Infinity) {
  		    let pow_nonzero = is_nonzero_ast(operands[1], assume,
  						     original_assumptions);
  		    if(pow_nonzero === false)
  			return undefined;
  		}

  		return true;

  		// TODO? positive^(-infinity) =? 0
  	    }

  	}

  	// check for functions that map certain sets to nonzeros
  	if(operator === 'apply') {
  	    if(functions$1.C.nonzero && functions$1.C.nonzero.includes(operands[0]) &&
  	       is_complex_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.R.nonzero && functions$1.R.nonzero.includes(operands[0]) &&
  	       is_real_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.nonzeroC.nonzero && functions$1.nonzeroC.nonzero.includes(operands[0])
  	       && is_nonzero_ast(operands[1], assume, original_assumptions)
  	       && is_complex_ast(operands[1], assume, original_assumptions)
  	      )
  		return true;
  	    if(functions$1.nonneg.nonzero && functions$1.nonneg.nonzero.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, false, original_assumptions))
  		return true;
  	    if(functions$1.pos.nonzero && functions$1.pos.nonzero.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, true, original_assumptions))
  		return true;
  	    return undefined;
  	}

  	if(operator === 'prime')
  	    return undefined;

  	// other operators don't return numbers
  	return false;
      }

      return false;
  }


  function is_positive_ast(tree, assumptions, strict, original_assumptions) {
      // see description of is_nonnegative

      if(typeof assumptions !== 'object')
  	assumptions = [];

      if(original_assumptions===undefined)
  	original_assumptions = assumptions;

      if(strict === undefined)
  	strict = true;

      if(typeof tree === 'number') {
  	if(Number.isFinite(tree))
  	    return (strict ? tree > 0 : tree >= 0);
  	return false;
      }

      var is_real = is_real_ast(tree, assumptions, original_assumptions);
      if(!is_real)
  	return is_real;

      // if can convert to constant, evaluate directly
      var c = evaluate_to_constant(tree);

      if(c !== null) {
  	if(typeof c === 'number') {
  	    if(Number.isFinite(c))
  		return (strict ? c > 0 : c >= 0);
  	    return false;
  	}
  	return false;
      }

      if(typeof tree === 'string') {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions(tree);

  	if(!Array.isArray(assume))
  	    return undefined;

  	let assume_with_negations = assume;

  	let assume_operator = assume[0];
  	let assume_operands = assume.slice(1);

  	let negate_assumptions = false;
  	while(assume_operator === 'not') {
  	    negate_assumptions = !negate_assumptions;
  	    assume = assume_operands[0];
  	    if(!Array.isArray(assume))
  		return undefined;
  	    assume_operator = assume[0];
  	    assume_operands = assume.slice(1);
  	}

  	let new_assumptions = narrow_assumptions(assume_with_negations,
  						 original_assumptions);

  	// assume that equality has been expanded so that
  	// have only two operands
  	if((assume_operator === '=' && !negate_assumptions) ||
  	   (assume_operator === 'ne' && negate_assumptions)) {
  	    // if assumption is "tree=something"
  	    // check if something is positive
  	    // (but without the assumption to avoid infinite loop)

  	    if(assume_operands[0]===tree)
  		return is_positive_ast(assume_operands[1], new_assumptions,
  				       strict);
  	    if(assume_operands[1]===tree)
  		return is_positive_ast(assume_operands[0], new_assumptions,
  				       strict);
  	}

  	// assume assumptions are ordered so greater than doesn't appear
  	if(assume_operator === '<') {
  	    if(!negate_assumptions) {
  		if(assume_operands[0]===tree) {
  		    if(is_negative_ast(assume_operands[1], new_assumptions,
  				       false))
  			return false;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_positive_ast(assume_operands[0], new_assumptions,
  				       false))
  			return true;
  		}
  	    }
  	    else {
  		// negated, so becomes ge
  		if(assume_operands[0]===tree) {
  		    if(is_positive_ast(assume_operands[1], new_assumptions,
  				       strict))
  			return true;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_negative_ast(assume_operands[0], new_assumptions,
  				       !strict))
  			return false;
  		}

  	    }
  	}
  	if(assume_operator === 'le') {
  	    if(!negate_assumptions) {
  		if(assume_operands[0]===tree) {
  		    if(is_negative_ast(assume_operands[1], new_assumptions,
  				       !strict))
  			return false;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_positive_ast(assume_operands[0], new_assumptions,
  				       strict))
  			return true;
  		}
  	    }
  	    else {
  		// negated, so becomes >
  		if(assume_operands[0]===tree) {
  		    if(is_positive_ast(assume_operands[1], new_assumptions,
  				       false))
  			return true;
  		}
  		if(assume_operands[1]===tree) {
  		    if(is_negative_ast(assume_operands[0], new_assumptions,
  				       false))
  			return false;
  		}

  	    }
  	}


  	// if isn't a simple And or Or, just give up
  	if(assume_operator !== 'and' && assume_operator !== 'or')
  	    return undefined;

  	// shouldn't have negated assumptions
  	if(negate_assumptions)
  	    return undefined;

  	// if more than two operands, unflatten
  	// (OK, since not attempting logic where only combined restrictions
  	// lead to a passing test)
  	if(assume_operands.length > 2) {
  	    assume = unflattenRight(assume);
  	    assume_operands = assume.slice(1);
  	}

  	let result_left = is_positive_ast(tree, assume_operands[0], strict,
  					  original_assumptions);
  	let result_right = is_positive_ast(tree, assume_operands[1], strict,
  					   original_assumptions);
  	return simple_assumption_combination(assume_operator, result_left,
  					     result_right)
      }

      if(Array.isArray(tree)) {

  	let assume;
  	if(Array.isArray(assumptions))
  	    assume = assumptions;
  	else
  	    assume = assumptions.get_assumptions([variables(tree)]);

  	let operator = tree[0];
  	let operands = tree.slice(1);

  	if(operator === '-')
  	    return is_negative_ast(operands[0], assume, strict,
  				   original_assumptions);

  	if(operator === '+') {

  	    // if more than two terms, unflatten
  	    if(operands.length > 2) {
  		tree = unflattenRight(tree);
  		operands = tree.slice(1);
  	    }


  	    let nonneg_left = is_positive_ast(operands[0], assume, false,
  					      original_assumptions);
  	    let nonneg_right = is_positive_ast(operands[1], assume, false,
  					       original_assumptions);

  	    let positive_left = is_positive_ast(operands[0], assume, true,
  						original_assumptions);
  	    let positive_right = is_positive_ast(operands[1], assume, true,
  						 original_assumptions);


  	    if(strict) {
  		// positive + nonnegative is positive
  		if( (nonneg_left && positive_right)
  		    || (positive_left && nonneg_right))
  		    return true;
  	    }
  	    else {
  		// nonnegative + nonnegative is nonnegative
  		if(nonneg_left && nonneg_right)
  		    return true;
  	    }

  	    if(strict) {
  		// nonpositive + nonpositive is nonpositive
  		if(positive_left===false && positive_right===false)
  		    return false;
  	    }
  	    else {
  		// negative + nonpositive is negative
  		if( (nonneg_left===false && positive_right===false)
  		    || (positive_left===false && nonneg_right===false))
  		    return false;
  	    }

  	    // have terms of both signs (or undefined sign)
  	    // so can't determine if positive or negative by this approach
  	    return undefined;
  	}

  	if(operator === '*') {
  	    // one confirmed zero factor makes product zero
  	    if(!operands.every(v => is_nonzero_ast(v, assume, original_assumptions) !== false))
  		return !strict;

  	    // if more than two terms, unflatten
  	    if(operands.length > 2) {
  		tree = unflattenRight(tree);
  		operands = tree.slice(1);
  	    }

  	    let real_left = is_real_ast(operands[0], assume,
  					original_assumptions);
  	    let real_right = is_real_ast(operands[1], assume,
  					 original_assumptions);

  	    // if can't determine if real, can't determine positivity
  	    if(real_left===undefined || real_right===undefined)
  		return undefined;

  	    // if one nonreal, return false
  	    // if two nonreals, return undefined
  	    if(real_left===false) {
  		if(real_right===false)
  		    return undefined;
  		else
  		    return false;
  	    }
  	    else if(real_right===false)
  		return false;

  	    // if reach here, both factors are real

  	    let nonneg_left = is_positive_ast(operands[0], assume, false,
  					      original_assumptions);
  	    let nonneg_right = is_positive_ast(operands[1], assume, false,
  					       original_assumptions);

  	    let positive_left = is_positive_ast(operands[0], assume, true,
  						original_assumptions);
  	    let positive_right = is_positive_ast(operands[1], assume, true,
  						 original_assumptions);

  	    if(strict) {
  		// product of two positives or two negatives is positive
  		if((positive_left && positive_right)
  		   || (nonneg_left === false && nonneg_right === false))
  		    return true;

  		// product of nonnegative and nonpositive is nonpositive
  		if((positive_left === false && nonneg_right)
  		   || (nonneg_left && positive_right === false))
  		    return false;
  	    }
  	    else {
  		// product of two nonnegatives or two nonpositives
  		// is nonnegative
  		if((nonneg_left && nonneg_right)
  		   || (positive_left === false && positive_right === false))
  		    return true;

  		// product of positive and negative is negative
  		if((positive_left && nonneg_right === false)
  		   || (nonneg_left === false && positive_right))
  		    return false;
  	    }

  	    // couldn't figure out sign via above algorithm
  	    return undefined;

  	}

  	if(operator === '/') {

  	    // if can't be sure denominator is nonzero
  	    if(!is_nonzero_ast(operands[1], assume, original_assumptions))
  		return undefined;

  	    // zero numerator
  	    if(is_nonzero_ast(operands[0], assume,
  			      original_assumptions) === false)
  		return !strict;

  	    let denom_pos = is_positive_ast(operands[1], assume, true,
  					    original_assumptions);
  	    if(denom_pos === undefined)
  		return undefined;

  	    // if denominator is negative, sign is swapped
  	    // so need opposite strictness for numerator
  	    let numer_strict = denom_pos ? strict : !strict;
  	    let numer_pos = is_positive_ast(operands[0], assume,
  					    numer_strict,
  					    original_assumptions);

  	    if(numer_pos === undefined)
  		return undefined;

  	    if(numer_pos === true) {
  		if(denom_pos === true)
  		    return true;
  		else
  		    return false;
  	    }
  	    else {
  		if(denom_pos === true)
  		    return false;
  		else
  		    return true;
  	    }
  	}
  	if(operator === '^') {

  	    let base_nonzero = is_nonzero_ast(operands[0], assume,
  					      original_assumptions);

  	    if(!base_nonzero) {
  		let pow_positive = is_positive_ast(operands[1], assume, true,
  						   original_assumptions);

  		if(pow_positive) {
  		    if(base_nonzero === false)
  			return !strict;  // 0^positive
  		    if(strict)
  			return undefined // (possibly 0)^positive
  		}
  		else {
  		    return undefined; // (possibly zero)^(possibly nonpositive)
  		}

  	    }
  	    else { // nonzero base
  		let pow_nonzero = is_nonzero_ast(operands[1], assume,
  						 original_assumptions);
  		if(pow_nonzero === false) {
  		    // infinity^0 is undefined
  		    if(operands[0] === Infinity || operands[0] === -Infinity)
  			return undefined;

  		    return true;   // nonzero^0
  		}

  	    }

  	    let base_real = is_real_ast(operands[0], assume,
  					original_assumptions);

  	    if(base_real !== true) {
  		return undefined;
  	    }

  	    let base_positive = is_positive_ast(operands[0], assume, strict,
  						original_assumptions);

  	    if(!base_positive) {
  		// if base could be negative
  		// (already excluded zero base if strict)
  		// then only way to be
  		// positive (non_negative if not strict)
  		// is if pow is an even integer

  		// since haven't implemented is_even, only check
  		// if have a constant that is an even integer
  		let pow_over_two = simplify$2(['/', operands[1], 2],
  						     original_assumptions);
  		if(is_integer_ast(pow_over_two, assume, original_assumptions))
  		    return true;

  		return undefined;
  	    }

  	    // base must be nonnegative
  	    let pow_real = is_real_ast(operands[1], assume,
  				       original_assumptions);

  	    if(pow_real)
  		return true;  // since already excluded 0^0
  	    else
  		return undefined;

  	}

  	// check for functions that map certain sets to nonnegatives
  	if(operator === 'apply'  && !strict) {
  	    if(functions$1.C.nonneg && functions$1.C.nonneg.includes(operands[0]) &&
  	       is_complex_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.R.nonneg && functions$1.R.nonneg.includes(operands[0]) &&
  	       is_real_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.nonzeroC.nonneg && functions$1.nonzeroC.nonneg.includes(operands[0])
  	       && is_nonzero_ast(operands[1], assume, original_assumptions)
  	       && is_complex_ast(operands[1], assume, original_assumptions)
  	      )
  		return true;
  	    if(functions$1.nonneg.nonneg && functions$1.nonneg.nonneg.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, false, original_assumptions))
  		return true;
  	    if(functions$1.pos.nonneg && functions$1.pos.nonneg.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, true, original_assumptions))
  		return true;
  	    return undefined;
  	}
  	// check for functions that map certain sets to integers
  	if(operator === 'apply' && strict) {
  	    if(functions$1.C.pos && functions$1.C.pos.includes(operands[0]) &&
  	       is_complex_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.R.pos && functions$1.R.pos.includes(operands[0]) &&
  	       is_real_ast(operands[1], assume, original_assumptions))
  		return true;
  	    if(functions$1.nonzeroC.pos && functions$1.nonzeroC.pos.includes(operands[0])
  	       && is_nonzero_ast(operands[1], assume, original_assumptions)
  	       && is_complex_ast(operands[1], assume, original_assumptions)
  	      )
  		return true;
  	    if(functions$1.nonneg.pos && functions$1.nonneg.pos.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, false, original_assumptions))
  		return true;
  	    if(functions$1.pos.pos && functions$1.pos.pos.includes(operands[0]) &&
  	       is_positive_ast(operands[1], assume, true, original_assumptions))
  		return true;
  	    return undefined;
  	}

  	if(operator === 'prime')
  	    return undefined;

  	// other operators don't return numbers
  	return false;
      }

      return false;
  }

  function is_negative_ast(tree, assumptions, strict, original_assumptions) {
      if(strict === undefined)
  	strict = true;

      var real = is_real_ast(tree, assumptions, original_assumptions);

      if(real === true) {
  	let nonneg = is_positive_ast(tree, assumptions, !strict,
  				     original_assumptions);
  	if(nonneg === false)
  	    return true;
  	if(nonneg === true)
  	    return false;
  	return undefined;
      }

      return real;
  }

  function clean(expr_or_tree) {
    var tree = get_tree(expr_or_tree);
    return flatten(tree);
  }

  function evalf(x, n) {
    return parseFloat(number_8(x, n));
  }

  function collapse_unary_minus(expr_or_tree) {
    var tree = get_tree(expr_or_tree);

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1);
    operands = operands.map(v => collapse_unary_minus(v));

    if (operator === "-") {
      if (typeof operands[0] === 'number')
        return -operands[0];
      // check if operand is a multiplication with that begins with
      // a constant.  If so combine with constant
      if (Array.isArray(operands[0]) && operands[0][0] === '*'
        && (typeof operands[0][1] === 'number')) {
        return ['*', -operands[0][1]].concat(operands[0].slice(2));
      }
      // check if operand is a division with that begins with
      // either
      /// (A) a constant or
      //  (B) a multiplication that begins with a constant.
      // If so. combine with constant
      if (Array.isArray(operands[0]) && operands[0][0] === '/') {
        if (typeof operands[0][1] === 'number')
          return ['/', -operands[0][1], operands[0][2]];
        if (Array.isArray(operands[0][1]) && operands[0][1][0] === '*'
          && (typeof operands[0][1][1] === 'number')) {
          return ['/', [
            '*', -operands[0][1][1]].concat(operands[0][1].slice(2)),
            operands[0][2]];
        }
      }
    }

    return [operator].concat(operands);
  }

  function simplify$2(expr_or_tree, assumptions, max_digits) {
    var tree = get_tree(expr_or_tree);

    if (assumptions === undefined && expr_or_tree.context !== undefined
      && expr_or_tree.context.get_assumptions !== undefined)
      assumptions = expr_or_tree.context.get_assumptions(
        [expr_or_tree.variables()]);

    tree = evaluate_numbers(tree, { assumptions: assumptions, max_digits: max_digits, evaluate_functions: true });
    // if already have it down to a number of variable, no need for more simplification
    if (!Array.isArray(tree)) {
      return tree;
    }
    tree = simplify_logical(tree, assumptions);
    tree = collect_like_terms_factors(tree, assumptions, max_digits);

    return tree;
  }

  function simplify_logical(expr_or_tree, assumptions) {
    var tree = get_tree(expr_or_tree);

    if (assumptions === undefined && expr_or_tree.context !== undefined
      && expr_or_tree.context.get_assumptions !== undefined)
      assumptions = expr_or_tree.context.get_assumptions(
        [expr_or_tree.variables()]);

    tree = evaluate_numbers(tree, { assumptions: assumptions });

    tree = unflattenRight(tree);

    var transformations = [];
    transformations.push([ [ 'not', [ 'not', 'a' ] ], "a"]);
    transformations.push([ [ 'not', [ 'and', 'a', 'b' ] ], [ 'or', [ 'not', 'a' ], [ 'not', 'b' ] ] ]);
    transformations.push([ [ 'not', [ 'or', 'a', 'b' ] ], [ 'and', [ 'not', 'a' ], [ 'not', 'b' ] ] ]);
    transformations.push([ [ 'not', [ '=', 'a', 'b' ] ], [ 'ne', 'a', 'b' ] ]);
    transformations.push([ [ 'not', [ 'ne', 'a', 'b' ] ], [ '=', 'a', 'b' ] ]);
    transformations.push([ [ 'not', [ '<', 'a', 'b' ] ], [ 'le', 'b', 'a' ] ]);
    transformations.push([ [ 'not', [ 'le', 'a', 'b' ] ], [ 'not', [ 'le', 'a', 'b' ] ] ]);
    transformations.push([ [ 'not', [ 'in', 'a', 'b' ] ], [ 'notin', 'a', 'b' ] ]);
    transformations.push([ [ 'not', [ 'subset', 'a', 'b' ] ], [ 'notsubset', 'a', 'b' ] ]);

    tree = applyAllTransformations(tree, transformations, 20);

    tree = flatten(tree);

    return tree;
  }

  function contains_decimal_number(tree) {
    if (typeof tree === "string") {
      return false;
    }
    if (typeof tree === "number") {
      if (Number.isFinite(tree) && !Number.isInteger(tree)) {
        return true;
      } else {
        return false;
      }
    }
    if (!Array.isArray(tree)) {
      return false;
    }
    return tree.slice(1).some(x => contains_decimal_number(x));
  }

  function contains_only_numbers(tree, { include_number_symbols = false } = {}) {
    if (typeof tree === "string") {
      if (include_number_symbols) {
        if (tree === "e" && math$19.define_e) {
          return true;
        }
        if (tree === "pi" && math$19.define_pi) {
          return true;
        }
      }
      return false;
    }
    if (typeof tree === "number") {
      return true;
    }
    if (!Array.isArray(tree)) {
      return false;
    }
    return tree.slice(1).every(x => contains_only_numbers(x, { include_number_symbols: include_number_symbols }));
  }

  function evaluate_numbers_sub(tree, assumptions, max_digits, skip_ordering, evaluate_functions, set_small_zero) {
    // assume that tree has been sorted to default order (while flattened)
    // and then unflattened_right
    // returns unflattened tree

    if (tree === undefined)
      return tree;

    if (typeof tree === 'number') {
      if(set_small_zero > 0 && math$19.abs(tree) < set_small_zero) {
        return 0;
      }
      if(tree === 0) {
        return 0;  // so that -0 returns 0
      }
      return tree;
    }

    if (evaluate_functions || contains_only_numbers(tree, { include_number_symbols: true })) {

      var c = evaluate_to_constant(tree);

      if (c !== null) {
        if (typeof c === 'number') {
          if (Number.isFinite(c)) {
            if(set_small_zero > 0 && math$19.abs(c) < set_small_zero) {
              return 0;
            }
            if (max_digits === Infinity)
              return c;
            if (Number.isInteger(c)) {
              if(c === 0) {
                return 0;
              }
              return c;
            }

            let c_minround = evalf(c, 14);
            let c_round = evalf(c, max_digits);
            if (max_digits === 0) {
              // interpret 0 max_digits as only accepting integers
              // (even though positive max_digits is number of significant digits)
              c_round = math$19.round(c);
            }
            if (c_round === c_minround) {
              return c;
            }

            // if expression already contained a decimal,
            // and contains only numbers (no constants like pi)
            // return the number
            if (contains_decimal_number(tree) && contains_only_numbers(tree)) {
              return c;
            }

            let c_frac = math$19.fraction(c);
            let c_frac_d_round = evalf(c_frac.d, 3);

            if (c_frac.n < 1E4 || (c_frac_d_round === c_frac.d)) {
              let c_reconstruct = evalf(c_frac.s * c_frac.n / c_frac.d, 14);
              if (c_reconstruct === c_minround) {
                if (c_frac.d === 1) {
                  return c_frac.s * c_frac.n;
                } else {
                  return ['/', c_frac.s * c_frac.n, c_frac.d];
                }
              }
            }
          }
        }
      }
    }

    if (!Array.isArray(tree))
      return tree;

    var operator = tree[0];
    var operands = tree.slice(1).map(v => evaluate_numbers_sub(
      v, assumptions, max_digits, skip_ordering, evaluate_functions, set_small_zero));

    if (operator === '+') {
      let left = operands[0];
      let right = operands[1];

      if (right === undefined)
        return left;

      if (typeof left === 'number') {
        if (left === 0)
          return right;
        if (typeof right === 'number')
          return left + right;
        // check if right is an addition with that begins with
        // a constant.  If so combine with left
        if (Array.isArray(right) && right[0] === '+'
          && (typeof right[1] === 'number')) {
          return ['+', left + right[1], right[2]];
        }
        // check if right is an addition with that ends with
        // a constant.  If so combine with left
        if (!skip_ordering && Array.isArray(right) && right[0] === '+'
          && (typeof right[2] === 'number')) {
          return ['+', left + right[2], right[1]];
        }

      }
      if (typeof right === 'number')
        if (right === 0)
          return left;

      return [operator].concat(operands);
    }
    if (operator === '-') {
      if (typeof operands[0] === 'number')
        return -operands[0];
      // check if operand is a multiplication with that begins with
      // a constant.  If so combine with constant
      if (Array.isArray(operands[0]) && operands[0][0] === '*'
        && (typeof operands[0][1] === 'number')) {
        return ['*', -operands[0][1]].concat(operands[0].slice(2));
      }
      // check if operand is a division with that begins with
      // either
      /// (A) a constant or
      //  (B) a multiplication that begins with a constant.
      // If so. combine with constant
      if (Array.isArray(operands[0]) && operands[0][0] === '/') {
        if (typeof operands[0][1] === 'number')
          return ['/', -operands[0][1], operands[0][2]];
        if (Array.isArray(operands[0][1]) && operands[0][1][0] === '*'
          && (typeof operands[0][1][1] === 'number')) {
          return ['/', [
            '*', -operands[0][1][1]].concat(operands[0][1].slice(2)),
            operands[0][2]];

        }

      }

      return [operator].concat(operands);
    }
    if (operator === '*') {
      let left = operands[0];
      let right = operands[1];

      if (right === undefined)
        return left;

      if (typeof left === 'number') {
        if (isNaN(left))
          return NaN;

        if (typeof right === 'number')
          return left * right;

        if (!isFinite(left)) {
          if ((left === Infinity && is_negative_ast(right))
            || (left === -Infinity && is_positive_ast(right)))
            return -Infinity
          if (is_nonzero_ast(right) === false)
            return NaN;
          return Infinity;
        }
        if (left === 0) {
          return 0;
        }
        if (left === 1)
          return right;

        if (left === -1) {
          return ['-', right];
        }
        // check if right is a multiplication with that begins with
        // a constant.  If so combine with left
        if (Array.isArray(right) && right[0] === '*'
          && (typeof right[1] === 'number')) {
          left = left * right[1];
          right = right[2];
          if (left === 1)
            return right;
          if (left === -1)
            return ['-', right];
          return ['*', left, right];
        }

      }
      if (typeof right === 'number') {
        if (isNaN(right))
          return NaN;
        if (!isFinite(right)) {
          if ((right === Infinity && is_negative_ast(left))
            || (right === -Infinity && is_positive_ast(left)))
            return -Infinity
          if (is_nonzero_ast(left) === false)
            return NaN;
          return Infinity;
        }
        if (right === 0) {
          return 0;
        }
        if (right === 1)
          return left;
        if (right === -1) {
          return ['-', left];
        }
        // check if left is a multiplication with that begins with
        // a constant.  If so combine with right
        if (Array.isArray(left) && left[0] === '*'
          && (typeof left[1] === 'number')) {
          right = right * left[1];
          left = left[2];
          if (right === 1)
            return left;
          if (right === -1)
            return ['-', left];
          return ['*', left, right];
        }
      }

      return [operator].concat(operands);
    }

    if (operator === '/') {

      let numer = operands[0];
      let denom = operands[1];

      if (typeof numer === 'number') {
        if (numer === 0) {
          let denom_nonzero = is_nonzero_ast(denom, assumptions);
          if (denom_nonzero)
            return 0;
          if (denom_nonzero === false)
            return NaN;  // 0/0
        }

        if (typeof denom === 'number') {
          let quotient = numer / denom;
          if (max_digits === Infinity
            || math$19.round(quotient, max_digits) === quotient)
            return quotient;
          else if (denom < 0)
            return ['/', -numer, -denom];
        }

        // check if denom is a multiplication with that begins with
        // a constant.  If so combine with numerator
        if (Array.isArray(denom) && denom[0] === '*'
          && (typeof denom[1] === 'number')) {
          let quotient = numer / denom[1];

          if (max_digits === Infinity
            || math$19.round(quotient, max_digits) === quotient) {
            return ['/', quotient, denom[2]];
          }
        }
      }
      else if (typeof denom === 'number') {
        // check if numer is a multiplication with that begins with
        // a constant.  If so combine with denominator
        if (Array.isArray(numer) && numer[0] === '*'
          && (typeof numer[1] === 'number')) {
          let quotient = numer[1] / denom;
          if (max_digits === Infinity
            || math$19.round(quotient, max_digits) === quotient) {
            if (quotient === 1)
              return numer[2];
            else
              return ['*', quotient, numer[2]];
          }
          // if denom is negative move negative to number
          if (denom < 0)
            return ['/', ['*', -numer[1], numer[2]], -denom];
        }
        // if denonimator is negative, negate whole fraction
        if (denom < 0) {
          if (Array.isArray(numer) && numer[0] === '-')
            return ['/', numer[1], -denom];
          else
            return ['-', ['/', numer, -denom]];

        }
      }
      return [operator].concat(operands);

    }

    if (operator === '^') {

      let base = operands[0];
      let pow = operands[1];

      if (typeof pow === 'number') {
        if (pow === 0) {
          if (!math$19.pow_strict)
            return 1;
          let base_nonzero = is_nonzero_ast(base, assumptions);
          if (base_nonzero && (base !== Infinity) && (base !== -Infinity))
            return 1;
          if (base_nonzero === false)
            return NaN;   // 0^0
        }
        else if (pow === 1) {
          return base;
        }
        else if (typeof base === 'number') {
          let result = math$19.pow(base, pow);
          if (max_digits === Infinity
            || math$19.round(result, max_digits) === result)
            return result;

        }
      } else if (base === 1) {
        return 1;
      }
      return [operator].concat(operands);
    }

    return [operator].concat(operands);
  }


  function evaluate_numbers(expr_or_tree, {
    assumptions, max_digits, skip_ordering = false,
    evaluate_functions = false,
    set_small_zero = 0,
  } = {}) {

    if (max_digits === undefined ||
      !(Number.isInteger(max_digits) || max_digits === Infinity))
      max_digits = 0;

    if (set_small_zero === true) {
      set_small_zero = 1E-14;
    }

    var tree = get_tree(expr_or_tree);


    if (assumptions === undefined && expr_or_tree.context !== undefined
      && expr_or_tree.context.get_assumptions !== undefined)
      assumptions = expr_or_tree.context.get_assumptions(
        [expr_or_tree.variables()]);

    var result;
    if (skip_ordering) {
      tree = unflattenRight(flatten(tree));
      result = evaluate_numbers_sub(
        tree, assumptions, max_digits, skip_ordering, evaluate_functions, set_small_zero);
    } else {
      tree = unflattenRight(default_order(flatten(tree)));
      result = default_order(evaluate_numbers_sub(
        tree, assumptions, max_digits, skip_ordering, evaluate_functions, set_small_zero));
      // TODO: determine how often have to repeat
      result = default_order(evaluate_numbers_sub(
        unflattenRight(result), assumptions, max_digits, skip_ordering, evaluate_functions, set_small_zero));
    }

    return flatten(result);
  }

  function collect_like_terms_factors(expr_or_tree, assumptions, max_digits) {

    function isNumber(s) {
      if (typeof s === 'number')
        return true;
      if (Array.isArray(s) && s[0] === '-' && (typeof s[1] === 'number'))
        return true;
      return false;
    }
    function isNegativeNumber(s) {
      if (typeof s === 'number' && s < 0)
        return true;
      if (Array.isArray(s) && s[0] === '-' && (typeof s[1] === 'number'))
        return true;
      return false;
    }
    function isNumerical(s) {
      if (typeof s === 'number')
        return true;
      if (Array.isArray(s) && s[0] === '-' && (typeof s[1] === 'number'))
        return true;
      let c = evaluate_to_constant(s);
      if (typeof c === 'number' && Number.isFinite(c))
        return true;

      return false;

    }


    var tree = get_tree(expr_or_tree);

    if (assumptions === undefined && expr_or_tree.context !== undefined
      && expr_or_tree.context.get_assumptions !== undefined)
      assumptions = expr_or_tree.context.get_assumptions(
        [expr_or_tree.variables()]);

    tree = evaluate_numbers(tree, { assumptions: assumptions, max_digits: max_digits, evaluate_functions: true });

    var transformations = [];

    // preliminary transformations
    transformations.push([
      [ '/', 'x', [ '^', 'y', 'a' ] ],
      [ '*', 'x', [ '^', 'y', [ '-', 'a' ] ] ],
    { evaluate_numbers: true, max_digits: max_digits }]);
    transformations.push([
      [ '/', 'x', 'y' ],
      [ '*', 'x', [ '^', 'y', [ '-', 1 ] ] ],
    { evaluate_numbers: true, max_digits: max_digits }]);
    tree = applyAllTransformations(tree, transformations, 40);

    // collecting like terms and factors
    transformations = [];
    transformations.push(
      [
        [ '*', [ '^', 'x', 'n' ], [ '^', 'x', 'm' ] ], 
        [ '^', 'x', [ '+', 'n', 'm' ] ],
      {
        variables: {
          x: v => is_nonzero_ast(v, assumptions),
          n: isNumber, m: isNumber
        },
        evaluate_numbers: true, max_digits: max_digits,
        allow_implicit_identities: ['m', 'n'],
        allow_extended_match: true,
        allow_permutations: true,
        max_group: 1,
      }]
    );
    transformations.push(
      [
        [ '*', [ '^', 'x', 'n' ], [ '^', 'x', 'm' ] ],
        [ '^', 'x', [ '+', 'n', 'm' ] ],
      {
        variables: {
          x: true,
          n: v => isNumber(v) && is_positive_ast(v, assumptions),
          m: v => isNumber(v) && is_positive_ast(v, assumptions)
        },
        evaluate_numbers: true, max_digits: max_digits,
        allow_implicit_identities: ['m', 'n'],
        allow_extended_match: true,
        allow_permutations: true,
        max_group: 1,
      }]
    );
    transformations.push(
      [
        [ '*', [ '^', 'x', 'n' ], [ '^', 'x', 'm' ] ],
        [ '^', 'x', [ '+', 'n', 'm' ] ],
      {
        variables: {
          x: true,
          n: v => isNumber(v) && is_negative_ast(v, assumptions),
          m: v => isNumber(v) && is_negative_ast(v, assumptions)
        },
        evaluate_numbers: true, max_digits: max_digits,
        allow_extended_match: true,
        allow_permutations: true,
        max_group: 1,
      }]
    );
    transformations.push(
      [
        [ '+', [ '*', 'n', 'x' ], [ '*', 'm', 'x' ] ],
        [ '*', [ '+', 'n', 'm' ], 'x' ],
      {
        variables: {
          x: true,
          n: isNumber, m: isNumber
        },
        evaluate_numbers: true, max_digits: max_digits,
        allow_implicit_identities: ['m', 'n'],
        allow_extended_match: true,
        allow_permutations: true,
        max_group: 1,
      }]
    );
    transformations.push(
      [
        [ '+', [ '*', 'n', 'x' ], [ '-', [ '*', 'm', 'x' ] ] ],
        [ '*', [ '+', 'n', [ '-', 'm' ] ], 'x' ],
      {
        variables: {
          x: true,
          n: isNumber, m: isNumber
        },
        evaluate_numbers: true, max_digits: max_digits,
        allow_implicit_identities: ['m', 'n'],
        allow_extended_match: true,
        allow_permutations: true,
        max_group: 1,
      }]
    );
    transformations.push(
      [
        [ '^', [ '*', 'x', 'y' ], 'a' ],
        [ '*', [ '^', 'x', 'a' ], [ '^', 'y', 'a' ] ],
      { allow_permutations: true, }]
    );
    transformations.push(
      [
        [ '^', [ '^', 'x', 'n' ], 'm' ],
        [ '^', 'x', [ '*', 'n', 'm' ] ],
      {
        variables: {
          x: true,
          n: isNumber, m: isNumber
        },
        evaluate_numbers: true, max_digits: max_digits,
        allow_permutations: true,
      }]
    );
    transformations.push([
      [ '-', [ '+', 'a', 'b' ] ],
      [ '+', [ '-', 'a' ], [ '-', 'b' ] ] 
    ]);

    // evaluate any products
    // (required since evaluate_numbers needs to be applied separately
    // to complicated products to evaluate them as numbers)
    transformations.push(
      [
        [ '*', 'x', 'y' ],
        [ '*', 'x', 'y' ],
      {
        variables: { x: isNumerical, y: isNumerical },
        evaluate_numbers: true, max_digits: max_digits,
        allow_extended_match: true,
        allow_permutations: true,
        max_group: 1,
      }]
    );

    tree = applyAllTransformations(tree, transformations, 40);

    transformations = [];
    // redo as division
    transformations.push(
      [
        [ '*', 'x', [ '^', 'y', [ '-', 'a' ] ] ],
        [ '/', 'x', [ '^', 'y', 'a' ] ],
    {
      allow_extended_match: true,
      allow_permutations: true,
      evaluate_numbers: true, max_digits: max_digits,
      max_group: 1,
    }]);
    transformations.push([
      [ '*', 'x', [ '^', 'y', 'n' ] ],
      [ '/', 'x', [ '^', 'y', [ '-', 'n' ] ] ],
    {
      variables: {
        x: true, y: true,
        n: isNegativeNumber
      },
      evaluate_numbers: true, max_digits: max_digits,
      allow_extended_match: true,
      allow_permutations: true,
      max_group: 1,
    }]);
    tree = applyAllTransformations(tree, transformations, 40);

    transformations = [];
    // redo as division, try 2
    transformations.push([
      [ '^', 'y', 'n' ],
      [ '/', 1, [ '^', 'y', [ '-', 'n' ] ] ],
    {
      variables: {
        y: true,
        n: isNegativeNumber
      },
      evaluate_numbers: true, max_digits: max_digits,
    }]);
    tree = applyAllTransformations(tree, transformations, 40);

    transformations = [];
    // '*' before '/' and products in denominator
    transformations.push([
      [ '*', 'x', [ '/', 'y', 'z' ] ],
      [ '/', [ '*', 'x', 'y' ], 'z' ],
    {
      allow_extended_match: true,
      allow_permutations: true,
      max_group: 1,
    }]);
    transformations.push([
      [ '/', [ '/', 'x', 'y' ], 'z' ],
      [ '/', 'x', [ '*', 'y', 'z' ] ],
    {
      allow_extended_match: true,
      allow_permutations: true,
    }]);
    transformations.push([
      [ '/', 'x', [ '/', 'y', 'z' ] ],
      [ '/', [ '*', 'x', 'z' ], 'y' ],
    {
      allow_extended_match: true,
      allow_permutations: true,
    }]);
    tree = applyAllTransformations(tree, transformations, 40);

    tree = evaluate_numbers(tree, { assumptions: assumptions, max_digits: max_digits });

    return tree;

  }

  function simplify_ratios(expr_or_tree, assumptions) {

    // TODO: actually factor numerator and denominator
    // for now, assume factored, other than minus sign

    function remove_negative_factors(factors) {

      var sign_change = 1;

      factors = factors.map(function (v) {
        if (typeof v === "number") {
          if (v < 0) {
            sign_change *= -1;
            return -v;
          }
          return v;
        }
        if (!Array.isArray(v))
          return v;

        if (v[0] === '-') {
          sign_change *= -1;
          return v[1];
        }
        if (v[0] !== '+')
          return v;

        var negate = false;
        if ((typeof v[1] === "number") && v[1] < 0)
          negate = true;
        else if (Array.isArray(v[1]) && v[1][0] === '-')
          negate = true;
        else if (Array.isArray(v[1]) && v[1][0] === '*' && Number(v[1][1]) < 0) {
          negate = true;
        }

        if (negate) {
          sign_change *= -1;
          var v_ops = v.slice(1).map(x => ['-', x]);
          return evaluate_numbers(['+'].concat(v_ops));
        }
        else
          return v;
      });

      return { factors: factors, sign_change: sign_change };
    }

    function simplify_ratios_sub(tree, negated) {

      if (!Array.isArray(tree)) {
        if (negated) {
          return ['-', tree];
        } else {
          return tree;
        }
      }

      var operator = tree[0];
      if (operator === "-") {
        return simplify_ratios_sub(tree[1], negated = true);
      }
      var operands = tree.slice(1).map(v => simplify_ratios_sub(v));

      if (operator !== '/') {
        if (negated) {
          return ['-', [operator, ...operands]]
        } else {
          return [operator, ...operands];
        }
      }

      var numer = operands[0];
      var denom = operands[1];

      // factor a minus sign from each factor in numerator and denominator
      // if it is negative or it is a sum with a negative first term
      // (when terms are sorted as though they were not negative)

      numer = default_order(numer, { ignore_negatives: true });
      var numer_factors;
      if (Array.isArray(numer) && numer[0] === '*')
        numer_factors = numer.slice(1);
      else
        numer_factors = [numer];
      var result_n = remove_negative_factors(numer_factors);
      numer_factors = result_n["factors"];
      if (negated) {
        result_n["sign_change"] *= -1;
      }

      denom = default_order(denom, { ignore_negatives: true });
      var denom_factors;
      if (Array.isArray(denom) && denom[0] === '*')
        denom_factors = denom.slice(1);
      else
        denom_factors = [denom];
      var result_d = remove_negative_factors(denom_factors);
      denom_factors = result_d["factors"];

      if (result_n["sign_change"] * result_d["sign_change"] < 0)
        numer_factors[0] = ['-', numer_factors[0]];

      if (numer_factors.length === 1)
        numer = numer_factors[0];
      else
        numer = ['*'].concat(numer_factors);
      if (denom_factors.length === 1)
        denom = denom_factors[0];
      else
        denom = ['*'].concat(denom_factors);

      return ['/', numer, denom];

    }


    var tree = get_tree(expr_or_tree);

    if (assumptions === undefined && expr_or_tree.context !== undefined
      && expr_or_tree.context.get_assumptions !== undefined)
      assumptions = expr_or_tree.context.get_assumptions(
        [expr_or_tree.variables()]);

    return simplify_ratios_sub(tree);

  }

  var simplify$3 = /*#__PURE__*/Object.freeze({
    clean: clean,
    simplify: simplify$2,
    simplify_logical: simplify_logical,
    evaluate_numbers: evaluate_numbers,
    collect_like_terms_factors: collect_like_terms_factors,
    collapse_unary_minus: collapse_unary_minus,
    simplify_ratios: simplify_ratios,
    default_order: default_order
  });

  function tuples_to_vectors(expr_or_tree) {
      // convert tuple to vectors
      // except if tuple is argument of a function, gts, lts, or interval

      var tree = get_tree(expr_or_tree);

      if (typeof tree === 'number') {
  	return tree;
      }

      if (typeof tree === 'string') {
  	return tree;
      }

      if (typeof tree === 'boolean') {
  	return tree;
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === 'tuple') {
  	let result = ['vector'].concat( operands.map( function(v,i) { return tuples_to_vectors(v); } ) );
  	return result;
      }

      if (operator === 'apply') {
  	if(operands[1][0] === 'tuple') {
  	    // special case for function applied to tuple.
  	    // preserve tuple
  	    let f = tuples_to_vectors(operands[0]);
  	    let f_operands = operands[1].slice(1);
  	    let f_tuple = ['tuple'].concat( f_operands.map( function(v,i) { return tuples_to_vectors(v); } ) );
  	    return ['apply', f, f_tuple];
  	}
  	// no special case for function applied to single argument
      }
      else if(operator === 'gts' || operator === 'lts' || operator === 'interval') {
  	// don't change tuples of gts, lts, or interval
  	let args = operands[0];
  	let booleans = operands[1];

  	if(args[0] !== 'tuple' || booleans[0] !== 'tuple')
  	    // something wrong if args or strict are not tuples
  	    throw new Error("Badly formed ast");

  	let args2= ['tuple'].concat( args.slice(1).map( function(v,i) { return tuples_to_vectors(v); } ) );

  	return [operator, args2, booleans];
      }

      var result = [operator].concat( operands.map( function(v,i) { return tuples_to_vectors(v); } ) );
      return result;
  }

  function to_intervals(expr_or_tree) {
      // convert tuple and arrays of two arguments to intervals
      // except if tuple is argument of a function, gts, lts, or interval

      var tree = get_tree(expr_or_tree);

      if (typeof tree === 'number') {
  	return tree;
      }

      if (typeof tree === 'string') {
  	return tree;
      }

      if (typeof tree === 'boolean') {
  	return tree;
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === 'tuple' && operands.length === 2) {
  	// open interval
  	let result = ['tuple'].concat( operands.map( function(v,i) { return to_intervals(v); } ) );
  	result = ['interval', result, ['tuple', false, false]];
  	return result;
      }
      if(operator === 'array' && operands.length === 2) {
  	// closed interval
  	let result = ['tuple'].concat( operands.map( function(v,i) { return to_intervals(v); } ) );
  	result = ['interval', result, ['tuple', true, true]];
  	return result;
      }

      if (operator === 'apply') {
  	if(operands[1][0] === 'tuple') {
  	    // special case for function applied to tuple.
  	    // preserve tuple
  	    let f = to_intervals(operands[0]);
  	    let f_operands = operands[1].slice(1);
  	    let f_tuple = ['tuple'].concat( f_operands.map( function(v,i) { return to_intervals(v); } ) );
  	    return ['apply', f, f_tuple];
  	}
  	// no special case for function applied to single argument
      }
      else if(operator === 'gts' || operator === 'lts' || operator === 'interval') {
  	// don't change tuples of gts, lts, or interval
  	let args = operands[0];
  	let booleans = operands[1];

  	if(args[0] !== 'tuple' || booleans[0] !== 'tuple')
  	    // something wrong if args or strict are not tuples
  	    throw new Error("Badly formed ast");

  	let args2= ['tuple'].concat( args.slice(1).map( function(v,i) { return to_intervals(v); } ) );

  	return [operator, args2, booleans];
      }

      var result = [operator].concat( operands.map( function(v,i) { return to_intervals(v); } ) );
      return result;
  }

  function ParseError(message, location) {
      this.name = 'ParseError';
      this.message = message || 'Error parsing input';
      this.stack = (new Error()).stack;
      this.location = location;
  }
  ParseError.prototype = Object.create(Error.prototype);
  ParseError.prototype.constructor = ParseError;

  // lexer class
  //
  // Processes input string to return tokens
  //
  // Token rules:
  // array of rules to identify tokens
  // Rules will be applied in order until a match is found.
  // Each rule is an array of two or three elements
  //   First element: a string to be converted into a regular expression
  //   Second element: the token type
  //   Third element (optional): replacement for actual string matched


  class lexer {
    constructor(token_rules, whitespace='\\s') {

      this.input = '';
      this.location = 0;
      this.token_rules=[];

      // regular expression to identify whitespace at beginning
      this.initial_whitespace = new RegExp('^(' + whitespace + ')+');
      
      // convert first element of each rule to a regular expression that
      // starts at the beginning of the string
      for(let rule of token_rules) {
        this.token_rules.push([new RegExp('^'+rule[0])].concat(rule.slice(1)));
      }
    }
    
    set_input(input) {
      if(typeof input !== "string")
        throw new Error("Input must be a string");
      
      this.input = input;
      this.location = 0;
    }

    return_state() {
      return({ input: this.input, location: this.location });
    }

    set_state({ input=null, location=0 } = {}) {

      if(input !== null) {
        this.input = input;
        this.location = location;
      }
    }
    
    
    advance({ remove_initial_space=true } = {}) {
      // Find next token at beginning of input and delete from input.
      // Update location to be the position in original input corresponding
      // to end of match.
      // Return token, which is an array of token type and matched string


      let result = this.initial_whitespace.exec(this.input);
      if(result) {
        //first find any initial whitespace and adjust location
        let n_whitespace = result[0].length;
        this.input = this.input.slice(n_whitespace);
        this.location += n_whitespace;

        // don't remove initial space, return it as next token
        if(!remove_initial_space) {
  	return { 
  	  token_type: "SPACE",
  	  token_text: result[0],
  	  original_text: result[0],
  	}
        }

        // otherwise ignore initial space and continue
      }
        
      // check for EOF
      if(this.input.length === 0) {
        return { 
  	token_type: "EOF",
  	token_text: "",
  	original_text: "",
        }
      }
      
      // search through each token rule in order, finding first match
      result = null;
      
      for(var rule of this.token_rules) {
        result = rule[0].exec(this.input);
        
        if(result) {
  	let n_characters = result[0].length;
  	this.input = this.input.slice(n_characters);
  	this.location += n_characters;
  	break;
        }
      }

      // case that didn't find any matches
      if(result === null) {
        return { 
  	token_type: "INVALID",
  	token_text: this.input[0],
  	original_text: this.input[0],
        }
      }

      // found a match, set token
      if(rule.length > 2) {
        // overwrite text by third element of rule
        return { token_type: rule[1],
  	       token_text: rule[2],
  	       original_text: result[0],
  	     };
      }
      else {
        return { token_type: rule[1],
  	       token_text: result[0],
  	       original_text: result[0],
  	     };
      }
    }

    
    unput(string) {
      // add string to beginning of input and adjust location
      
      if(typeof string !== "string")
        throw new Error("Input must be a string");

      this.location -= string.length;
      this.input = string + this.input;

    }
    
  }

  var is_associative$1 = { '+': true, '*': true, 'and': true, 'or': true, 'union': true, 'intersect': true};

  function flatten$18(tree) {
    
      // flatten tree with all associative operators
      
      if(!Array.isArray(tree))
  	return tree;

      var operator = tree[0];
      var operands = tree.slice(1);

      operands = operands.map( function(v,i) {
  	return flatten$18(v); } );
      
      if (is_associative$1[operator]) {
  	var result = [];
  	
  	for( var i=0; i<operands.length; i++ ) {
  	    if (Array.isArray(operands[i]) && (operands[i][0] === operator)) {
  		result = result.concat( operands[i].slice(1) );
  	    } else {
  		result.push( operands[i] );
  	    }
  	}
  	
  	operands = result;
      }
      
      return [operator].concat( operands );
  }

  // UPDATETHIS: Delete or change to new license & package name

  /*
   * recursive descent parser for math expressions
   *
   * Copyright 2014-2017 by
   *  Jim Fowler <kisonecat@gmail.com>
   *  Duane Nykamp <nykamp@umn.edu>
   *
   * This file is part of a math-expressions library
   *
   * math-expressions is free software: you can redistribute
   * it and/or modify it under the terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */


  // UPDATETHIS: Is this grammar still correct?

  /* Grammar:

     statement_list =
      statement_list ',' statement |
      statement

     statement =
      '...' |
      statement_a '|' statement_a |
      statement_a ':' statement_a |
      statement_a
      **** statement_a '|' statement_a
           used with turning off '|' statement '|' in baseFactor
  	 tried only after parse error encountered

     statement_a =
      statement_a 'OR' statement_b |
      statement_b

     statement_b =
      statement_b 'AND' relation |
      relation

     relation =
      'NOT' relation |
      '!' relation |
      relation '=' expression |
      relation 'NE' expression |
      relation '<' expression |
      relation '>' expression |
      relation 'LE' expression |
      relation 'GE' expression |
      relation 'IN' expression |
      relation 'NOTIN' expression |
      relation 'NI' expression |
      relation 'NOTNI' expression |
      relation 'SUBSET' expression |
      relation 'NOTSUBSET' expression |
      relation 'SUPERSET' expression |
      relation 'NOTSUPERSET' expression |
      expression

     expression =
      expression '+' term |
      expression '-' term |
      expression 'UNION' term |
      expression 'INTERSECT' term |
      '+' term |
      term

     term =
      term '*' factor |
      term nonMinusFactor |
      term '/' factor |
      factor

     baseFactor =
      '(' statement_list ')' |
      '[' statement_list ']' |
      '{' statement_list '}' |
      '(' statement ',' statement ']' |
      '[' statement ',' statement ')' |
      '|' statement '|' |
      number |
      variable |
      modified_function '(' statement_list ')' |
      modified_applied_function '(' statement_list ')' |
      modified_function |
      modified_applied_function factor |
      baseFactor '_' baseFactor |
      *** modified_applied_function factor
          allowed only if allowSimplifiedFunctionApplication==true
      *** '|' statement '|'
          allowed only at beginning of factor or if not currently in absolute value


     modified_function =
      function |
      function '_' baseFactor |
      function '_' baseFactor '^' factor |
      function '^' factor
      function "'"
      function '_' baseFactor "'"
      function '_' baseFactor "'" '^' factor
      function "'" '^' factor
      *** where the "'" after the functions can be repeated

     modified_applied_function =
      applied_function |
      applied_function '_' baseFactor |
      applied_function '_' baseFactor '^' factor |
      applied_function '^' factor
      applied_function "'"
      applied_function '_' baseFactor "'"
      applied_function '_' baseFactor "'" '^' factor
      applied_function "'" '^' factor
      *** where the "'" after the applied_functions can be repeated

     nonMinusFactor =
      baseFactor |
      baseFactor '^' factor |
      baseFactor '!' and/or "'" |
      baseFactor '!' and/or "'"  '^' factor|
      *** where '!' and/or "'"  indicates arbitrary sequence of "!" and/or "'"

     factor =
      '-' factor |
      nonMinusFactor

  */

  // in order to parse as scientific notation, e.g., 3.2E-12 or .7E+3,
  // it must be at the end or followed a comma, |, ), }, or ]
  const sci_notat_exp_regex = '(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?';


  const text_rules = [
    // in order to parse as scientific notation, e.g., 3.2E-12 or .7E+3,
    // it must be at the end or followed a |, or a closing ),}, or ]
    ['[0-9]+(\\.[0-9]*)?'+sci_notat_exp_regex, 'NUMBER'],
    ['\\.[0-9]+'+sci_notat_exp_regex, 'NUMBER'],
    ['\\*\\*', '^'],
    ['\\*', '*'], // there is some variety in multiplication symbols
    ['\\xB7', '*'], // '·'
    ['\u00B7', '*'], // '·'
    ['\u2022', '*'], // '•'
    ['\u22C5', '*'], // '⋅'
    ['\u00D7', '*'], // '×'
    ['/', '/'],
    ['-', '-'], // there is quite some variety with unicode hyphens
    ['\u058A', '-'], // '֊'
    ['\u05BE', '-'], // '־'
    ['\u1806', '-'], // '᠆'
    ['\u2010', '-'], // '‐'
    ['\u2011', '-'], // '‑'
    ['\u2012', '-'], // '‒'
    ['\u2013', '-'], // '–'
    ['\u2014', '-'], // '—'
    ['\u2015', '-'], // '―'
    ['\u207B', '-'], // '⁻'
    ['\u208B', '-'], // '₋'
    ['\u2212', '-'], // '−'
    ['\u2E3A', '-'], // '⸺'
    ['\u2E3B', '-'], // '⸻'
    ['\uFE58', '-'], // '﹘'
    ['\uFE63', '-'], // '﹣'
    ['\uFF0D', '-'], // '－'
    ['\\+', '+'],
    ['\\^', '^'], // a few ways to denote exponentiation
    ['\u2038', '^'], // '‸'
    ['\u028C', '^'], // 'ʌ'
    ['\\|', '|'],
    ['\\(', '('],
    ['\\)', ')'],
    ['\\[', '['],
    ['\\]', ']'],
    ['\\{', '{'],
    ['\\}', '}'],
    [',', ','],
    [':', ':'],

    ['\u03B1', 'VARMULTICHAR', 'alpha'], // 'α'
    ['\u03B2', 'VARMULTICHAR', 'beta'], // 'β'
    ['\u03D0', 'VARMULTICHAR', 'beta'], // 'ϐ'
    ['\u0393', 'VARMULTICHAR', 'Gamma'], // 'Γ'
    ['\u03B3', 'VARMULTICHAR', 'gamma'], // 'γ'
    ['\u0394', 'VARMULTICHAR', 'Delta'], // 'Δ'
    ['\u03B4', 'VARMULTICHAR', 'delta'], // 'δ'
    ['\u03B5', 'VARMULTICHAR', 'epsilon'], // 'ε' should this be varepsilon?
    ['\u03F5', 'VARMULTICHAR', 'epsilon'], // 'ϵ'
    ['\u03B6', 'VARMULTICHAR', 'zeta'], // 'ζ'
    ['\u03B7', 'VARMULTICHAR', 'eta'], // 'η'
    ['\u0398', 'VARMULTICHAR', 'Theta'], // 'Θ'
    ['\u03F4', 'VARMULTICHAR', 'Theta'], // 'ϴ'
    ['\u03B8', 'VARMULTICHAR', 'theta'], // 'θ'
    ['\u1DBF', 'VARMULTICHAR', 'theta'], // 'ᶿ'
    ['\u03D1', 'VARMULTICHAR', 'theta'], // 'ϑ'
    ['\u03B9', 'VARMULTICHAR', 'iota'], // 'ι'
    ['\u03BA', 'VARMULTICHAR', 'kappa'], // 'κ'
    ['\u039B', 'VARMULTICHAR', 'Lambda'], // 'Λ'
    ['\u03BB', 'VARMULTICHAR', 'lambda'], // 'λ'
    ['\u03BC', 'VARMULTICHAR', 'mu'], // 'μ'
    ['\u00B5', 'VARMULTICHAR', 'mu'], // 'µ' should this be micro?
    ['\u03BD', 'VARMULTICHAR', 'nu'], // 'ν'
    ['\u039E', 'VARMULTICHAR', 'Xi'], // 'Ξ'
    ['\u03BE', 'VARMULTICHAR', 'xi'], // 'ξ'
    ['\u03A0', 'VARMULTICHAR', 'Pi'], // 'Π'
    ['\u03C0', 'VARMULTICHAR', 'pi'], // 'π'
    ['\u03D6', 'VARMULTICHAR', 'pi'], // 'ϖ' should this be varpi?
    ['\u03C1', 'VARMULTICHAR', 'rho'], // 'ρ'
    ['\u03F1', 'VARMULTICHAR', 'rho'], // 'ϱ' should this be varrho?
    ['\u03A3', 'VARMULTICHAR', 'Sigma'], // 'Σ'
    ['\u03C3', 'VARMULTICHAR', 'sigma'], // 'σ'
    ['\u03C2', 'VARMULTICHAR', 'sigma'], // 'ς' should this be varsigma?
    ['\u03C4', 'VARMULTICHAR', 'tau'], // 'τ'
    ['\u03A5', 'VARMULTICHAR', 'Upsilon'], // 'Υ'
    ['\u03C5', 'VARMULTICHAR', 'upsilon'], // 'υ'
    ['\u03A6', 'VARMULTICHAR', 'Phi'], // 'Φ'
    ['\u03C6', 'VARMULTICHAR', 'phi'], // 'φ' should this be varphi?
    ['\u03D5', 'VARMULTICHAR', 'phi'], // 'ϕ'
    ['\u03A8', 'VARMULTICHAR', 'Psi'], // 'Ψ'
    ['\u03C8', 'VARMULTICHAR', 'psi'], // 'ψ'
    ['\u03A9', 'VARMULTICHAR', 'Omega'], // 'Ω'
    ['\u03C9', 'VARMULTICHAR', 'omega'], // 'ω'


    ['oo\\b', 'INFINITY'],
    ['OO\\b', 'INFINITY'],
    ['infty\\b', 'INFINITY'],
    ['infinity\\b', 'INFINITY'],
    ['Infinity\\b', 'INFINITY'],
    ['\u221E', 'INFINITY'], // '∞'

    ['\u212F', 'VAR', 'e'], // 'ℯ'

    ['\u2660', 'VARMULTICHAR', 'spade'], // '♠'
    ['\u2661', 'VARMULTICHAR', 'heart'], // '♡'
    ['\u2662', 'VARMULTICHAR', 'diamond'], // '♢'
    ['\u2663', 'VARMULTICHAR', 'club'], // '♣'
    ['\u2605', 'VARMULTICHAR', 'bigstar'], // '★'
    ['\u25EF', 'VARMULTICHAR', 'bigcirc'], // '◯'
    ['\u25CA', 'VARMULTICHAR', 'lozenge'], // '◊'
    ['\u25B3', 'VARMULTICHAR', 'bigtriangleup'], // '△'
    ['\u25BD', 'VARMULTICHAR', 'bigtriangledown'], // '▽'
    ['\u29EB', 'VARMULTICHAR', 'blacklozenge'], // '⧫'
    ['\u25A0', 'VARMULTICHAR', 'blacksquare'], // '■'
    ['\u25B2', 'VARMULTICHAR', 'blacktriangle'], // '▲'
    ['\u25BC', 'VARMULTICHAR', 'blacktriangledown'], //'▼'
    ['\u25C0', 'VARMULTICHAR', 'blacktriangleleft'], // '◀'
    ['\u25B6', 'VARMULTICHAR', 'blacktriangleright'], // '▶'
    ['\u25A1', 'VARMULTICHAR', 'Box'], // '□'
    ['\u2218', 'VARMULTICHAR', 'circ'], // '∘'
    ['\u22C6', 'VARMULTICHAR', 'star'], // '⋆'

    ['and\\b', 'AND'],
    ['\\&\\&?', 'AND'],
    ['\u2227', 'AND'], // '∧'

    ['or\\b', 'OR'],
    ['\u2228', 'OR'], // '∨'

    ['not\\b', 'NOT'],
    ['\u00ac', 'NOT'], // '¬'

    ['=', '='],
    ['\u1400', '='], // '᐀'
    ['\u30A0', '='], // '゠'
    ['!=', 'NE'],
    ['\u2260', 'NE'], // '≠'
    ['<=', 'LE'],
    ['\u2264', 'LE'], // '≤'
    ['>=', 'GE'],
    ['\u2265', 'GE'], // '≥'
    ['<', '<'],
    ['>', '>'],

    ['elementof\\b', 'IN'],
    ['\u2208', 'IN'], // '∈'

    ['notelementof\\b', 'NOTIN'],
    ['\u2209', 'NOTIN'], //'∉'

    ['containselement\\b', 'NI'],
    ['\u220B', 'NI'], // '∋'

    ['notcontainselement\\b', 'NOTNI'],
    ['\u220C', 'NOTNI'], // '∌'

    ['subset\\b', 'SUBSET'],
    ['\u2282', 'SUBSET'], // '⊂'

    ['notsubset\\b', 'NOTSUBSET'],
    ['\u2284', 'NOTSUBSET'], // '⊄'

    ['superset\\b', 'SUPERSET'],
    ['\u2283', 'SUPERSET'], // '⊃'

    ['notsuperset\\b', 'NOTSUPERSET'],
    ['\u2285', 'NOTSUPERSET'], //'⊅'

    ['union\\b', 'UNION'],
    ['\u222A', 'UNION'], // '∪'

    ['intersect\\b', 'INTERSECT'],
    ['\u2229', 'INTERSECT'], //'∩'

    ['!', '!'],
    ['\'', '\''],
    ['_', '_'],
    ['\\.\\.\\.', 'LDOTS'],
    ['[a-zA-Z∂][a-zA-Z∂0-9]*', 'VAR'],  // include ∂ in VAR
  ];


  // defaults for parsers if not overridden by context

  // if true, allowed applied functions to omit parentheses around argument
  // if false, omitting parentheses will lead to a Parse Error
  const allowSimplifiedFunctionApplicationDefault = true;

  // if true, split multicharacter symbols into a product of letters
  const splitSymbolsDefault = true;

  // symbols that won't be split into a product of letters if splitSymbols==true
  const unsplitSymbolsDefault = ['alpha', 'beta', 'gamma', 'Gamma', 'delta', 'Delta', 'epsilon', 'zeta', 'eta', 'theta', 'Theta', 'iota', 'kappa', 'lambda', 'Lambda', 'mu', 'nu', 'xi', 'Xi', 'pi', 'Pi', 'rho', 'sigma', 'Sigma', 'tau', 'Tau', 'upsilon', 'Upsilon', 'phi', 'Phi', 'chi', 'psi', 'Psi', 'omega', 'Omega'];

  // Applied functions must be given an argument so that
  // they are applied to the argument
  const appliedFunctionSymbolsDefault = ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "acos", "acosh", "acot", "acoth", "acsc", "acsch", "asec", "asech", "asin", "asinh", "atan", "atanh", "cos", "cosh", "cot", "coth", "csc", "csch", "sec", "sech", "sin", "sinh", "tan", "tanh", 'arcsin', 'arccos', 'arctan', 'arccsc', 'arcsec', 'arccot', 'cosec', 'arg', 'conj'];

  // Functions could have an argument, in which case they are applied
  // or, if they don't have an argument in parentheses, then they are treated
  // like a variable, except that trailing ^ and ' have higher precedence
  const functionSymbolsDefault = ['f', 'g'];

  // Parse Leibniz notation
  const parseLeibnizNotationDefault = true;


  class textToAst {
    constructor({
      allowSimplifiedFunctionApplication = allowSimplifiedFunctionApplicationDefault,
      splitSymbols = splitSymbolsDefault,
      unsplitSymbols = unsplitSymbolsDefault,
      appliedFunctionSymbols = appliedFunctionSymbolsDefault,
      functionSymbols = functionSymbolsDefault,
      parseLeibnizNotation = parseLeibnizNotationDefault,
    } = {}) {
      this.allowSimplifiedFunctionApplication = allowSimplifiedFunctionApplication;
      this.splitSymbols = splitSymbols;
      this.unsplitSymbols = unsplitSymbols;
      this.appliedFunctionSymbols = appliedFunctionSymbols;
      this.functionSymbols = functionSymbols;
      this.parseLeibnizNotation = parseLeibnizNotation;

      this.lexer = new lexer(text_rules);

    }

    advance(params) {
      this.token = this.lexer.advance(params);
      if (this.token.token_type === 'INVALID') {
        throw new ParseError("Invalid symbol '" + this.token.original_text + "'",
          this.lexer.location);
      }
    }

    return_state() {
      return ({
        lexer_state: this.lexer.return_state(),
        token: Object.assign({}, this.token)
      });
    }

    set_state(state) {
      this.lexer.set_state(state.lexer_state);
      this.token = Object.assign({}, state.token);
    }


    convert(input) {

      this.lexer.set_input(input);
      this.advance();

      var result = this.statement_list();

      if (this.token.token_type !== 'EOF') {
        throw new ParseError("Invalid location of '" + this.token.original_text + "'",
          this.lexer.location);
      }

      return flatten$18(result);

    }


    statement_list() {

      var list = [this.statement()];

      while (this.token.token_type === ",") {
        this.advance();
        list.push(this.statement());
      }

      if (list.length > 1)
        list = ['list'].concat(list);
      else
        list = list[0];

      return list;
    }

    statement({ inside_absolute_value = 0 } = {}) {

      // three periods ... can be a statement by itself
      if (this.token.token_type === 'LDOTS') {
        this.advance();
        return ['ldots'];
      }

      var original_state;

      try {

        original_state = this.return_state();

        let lhs = this.statement_a({ inside_absolute_value: inside_absolute_value });

        if (this.token.token_type !== ':')
          return lhs;

        this.advance();

        let rhs = this.statement_a();

        return [':', lhs, rhs];

      }
      catch (e) {
        try {

          // if ran into problem parsing statement
          // then try again with ignoring absolute value
          // and then interpreting bar as a binary operator

          // return state to what it was before attempting to parse statement
          this.set_state(original_state);

          let lhs = this.statement_a({ parse_absolute_value: false });

          if (this.token.token_type !== '|') {
            throw (e);
          }

          this.advance();

          let rhs = this.statement_a({ parse_absolute_value: false });

          return ['|', lhs, rhs];

        }
        catch (e2) {
          throw (e);  // throw original error
        }
      }
    }

    statement_a({ inside_absolute_value = 0, parse_absolute_value = true } = {}) {

      var lhs = this.statement_b({
        inside_absolute_value: inside_absolute_value,
        parse_absolute_value: parse_absolute_value
      });

      while (this.token.token_type === 'OR') {

        let operation = this.token.token_type.toLowerCase();

        this.advance();

        let rhs = this.statement_b({
          inside_absolute_value: inside_absolute_value,
          parse_absolute_value: parse_absolute_value
        });

        lhs = [operation, lhs, rhs];
      }

      return lhs;
    }

    statement_b(params) {
      // split AND into second statement to give higher precedence than OR

      var lhs = this.relation(params);

      while (this.token.token_type === 'AND') {

        let operation = this.token.token_type.toLowerCase();

        this.advance();

        let rhs = this.relation(params);

        lhs = [operation, lhs, rhs];
      }

      return lhs;
    }


    relation(params) {

      if (this.token.token_type === 'NOT' || this.token.token_type === '!') {
        this.advance();
        return ['not', this.relation(params)];
      }

      var lhs = this.expression(params);

      while ((this.token.token_type === '=') || (this.token.token_type === 'NE') ||
        (this.token.token_type === '<') || (this.token.token_type === '>') ||
        (this.token.token_type === 'LE') || (this.token.token_type === 'GE') ||
        (this.token.token_type === 'IN') || (this.token.token_type === 'NOTIN') ||
        (this.token.token_type === 'NI') || (this.token.token_type === 'NOTNI') ||
        (this.token.token_type === 'SUBSET') || (this.token.token_type === 'NOTSUBSET') ||
        (this.token.token_type === 'SUPERSET') || (this.token.token_type === 'NOTSUPERSET')) {

        let operation = this.token.token_type.toLowerCase();

        let inequality_sequence = 0;

        if ((this.token.token_type === '<') || (this.token.token_type === 'LE')) {
          inequality_sequence = -1;
        } else if ((this.token.token_type === '>') || (this.token.token_type === 'GE')) {
          inequality_sequence = 1;
        }

        this.advance();
        let rhs = this.expression(params);

        if (inequality_sequence === -1) {
          if ((this.token.token_type === '<') || this.token.token_type === 'LE') {
            // sequence of multiple < or <=
            let strict = ['tuple'];
            if (operation === '<')
              strict.push(true);
            else
              strict.push(false);

            let args = ['tuple', lhs, rhs];
            while ((this.token.token_type === '<') || this.token.token_type === 'LE') {
              if (this.token.token_type === '<')
                strict.push(true);
              else
                strict.push(false);

              this.advance();
              args.push(this.expression(params));
            }
            lhs = ['lts', args, strict];
          } else {
            lhs = [operation, lhs, rhs];
          }

        } else if (inequality_sequence === 1) {
          if ((this.token.token_type === '>') || this.token.token_type === 'GE') {
            // sequence of multiple > or >=
            let strict = ['tuple'];
            if (operation === '>')
              strict.push(true);
            else
              strict.push(false);

            let args = ['tuple', lhs, rhs];
            while ((this.token.token_type === '>') || this.token.token_type === 'GE') {
              if (this.token.token_type === '>')
                strict.push(true);
              else
                strict.push(false);

              this.advance();
              args.push(this.expression(params));
            }
            lhs = ['gts', args, strict];
          } else {
            lhs = [operation, lhs, rhs];
          }

        } else if (operation === '=') {
          lhs = ['=', lhs, rhs];

          // check for sequence of multiple =
          while (this.token.token_type === '=') {
            this.advance();
            lhs.push(this.expression(params));
          }
        } else {

          lhs = [operation, lhs, rhs];
        }

      }

      return lhs;
    }


    expression(params) {
      if (this.token.token_type === '+')
        this.advance();

      let negative_begin = false;
      if (this.token.token_type === '-') {
        negative_begin = true;
        this.advance();
      }

      var lhs = this.term(params);

      if (negative_begin) {
        lhs = ['-', lhs];
      }

      while ((this.token.token_type === '+') || (this.token.token_type === '-')
        || (this.token.token_type === 'UNION') ||
        (this.token.token_type === 'INTERSECT')) {

        let operation = this.token.token_type.toLowerCase();
        let negative = false;

        if (this.token.token_type === '-') {
          operation = '+';
          negative = true;
          this.advance();
        } else {
          this.advance();
          if (operation === '+' && this.token.token_type === '-') {
            negative = true;
            this.advance();
          }
        }
        let rhs = this.term(params);
        if (negative) {
          rhs = ['-', rhs];
        }

        lhs = [operation, lhs, rhs];
      }

      return lhs;
    }


    term(params) {
      var lhs = this.factor(params);

      var keepGoing = false;

      do {
        keepGoing = false;

        if (this.token.token_type === '*') {
          this.advance();
          lhs = ['*', lhs, this.factor(params)];
          keepGoing = true;
        } else if (this.token.token_type === '/') {
          this.advance();
          lhs = ['/', lhs, this.factor(params)];
          keepGoing = true;
        } else {
          // this is the one case where a | could indicate a closing absolute value
          let params2 = Object.assign({}, params);
          params2.allow_absolute_value_closing = true;
          let rhs = this.nonMinusFactor(params2);
          if (rhs !== false) {
            lhs = ['*', lhs, rhs];
            keepGoing = true;
          }
        }
      } while (keepGoing);

      return lhs;
    }


    factor(params) {

      if (this.token.token_type === '-') {
        this.advance();
        return ['-', this.factor(params)];
      }

      var result = this.nonMinusFactor(params);

      if (result === false) {
        if (this.token.token_type === "EOF") {
          throw new ParseError("Unexpected end of input", this.lexer.location);
        } else {
          throw new ParseError("Invalid location of '" + this.token.original_text + "'",
            this.lexer.location);
        }
      } else {
        return result;
      }

    }

    nonMinusFactor(params) {

      var result = this.baseFactor(params);

      // allow arbitrary sequence of factorials
      if (this.token.token_type === '!' || this.token.token_type === "'") {
        if (result === false)
          throw new ParseError("Invalid location of " + this.token.token_type,
            this.lexer.location);
        while (this.token.token_type === '!' || this.token.token_type === "'") {
          if (this.token.token_type === '!')
            result = ['apply', 'factorial', result];
          else
            result = ['prime', result];
          this.advance();
        }
      }

      if (this.token.token_type === '^') {
        if (result === false) {
          throw new ParseError("Invalid location of ^", this.lexer.location);
        }
        this.advance();

        // do not allow absolute value closing here
        let params2 = Object.assign({}, params);
        delete params2.allow_absolute_value_closing;
        delete params2.inside_absolute_value;

        return ['^', result, this.factor(params2)];
      }

      return result;
    }


    baseFactor({ inside_absolute_value = 0,
      parse_absolute_value = true,
      allow_absolute_value_closing = false
    } = {}) {

      var result = false;

      if (this.token.token_type === 'NUMBER') {
        result = parseFloat(this.token.token_text);
        this.advance();
      } else if (this.token.token_type === 'INFINITY') {
        result = Infinity;
        this.advance();
      } else if (this.token.token_type === 'VAR' || this.token.token_type === 'VARMULTICHAR') {
        result = this.token.token_text;

        if (this.appliedFunctionSymbols.includes(result) ||
          this.functionSymbols.includes(result)) {
          let must_apply = false;
          if (this.appliedFunctionSymbols.includes(result))
            must_apply = true;

          this.advance();

          if (this.token.token_type === '_') {
            this.advance();
            let subresult = this.baseFactor({ parse_absolute_value: parse_absolute_value });

            // since baseFactor could return false, must check
            if (subresult === false) {
              if (this.token.token_type === "EOF") {
                throw new ParseError("Unexpected end of input",
                  this.lexer.location);
              } else {
                throw new ParseError("Invalid location of '" + this.token.original_text +
                  "'", this.lexer.location);
              }
            }
            result = ['_', result, subresult];
          }

          while (this.token.token_type === "'") {
            result = ['prime', result];
            this.advance();
          }

          if (this.token.token_type === '^') {
            this.advance();
            result = ['^', result, this.factor({ parse_absolute_value: parse_absolute_value })];
          }

          if (this.token.token_type === '(') {
            this.advance();
            let parameters = this.statement_list();

            if (this.token.token_type !== ')') {
              throw new ParseError('Expecting )', this.lexer.location);
            }
            this.advance();

            if (parameters[0] === 'list') {
              // rename from list to tuple
              parameters[0] = 'tuple';
            }

            result = ['apply', result, parameters];
          } else {
            // if was an applied function symbol,
            // cannot omit argument
            if (must_apply) {
              if (!this.allowSimplifiedFunctionApplication)
                throw new ParseError("Expecting ( after function",
                  this.lexer.location);

              // if allow simplied function application
              // let the argument be the next factor
              result = ['apply', result, this.factor({ parse_absolute_value: parse_absolute_value })];
            }
          }
        } else {

          // determine if may be a derivative in Leibniz notation
          if (this.parseLeibnizNotation) {

            let original_state = this.return_state();

            let r = this.leibniz_notation();

            if (r) {
              // successfully parsed derivative in Leibniz notation, so return
              return r;
            }
            else {
              // didn't find a properly format Leibniz notation
              // so reset state and continue
              this.set_state(original_state);
            }
          }

          // determine if should split text into single letter factors
          let split = this.splitSymbols;

          if (split) {
            if (this.token.token_type === 'VARMULTICHAR' ||
              this.unsplitSymbols.includes(result) ||
              result.length === 1) {
              split = false;
            } else if (result.match(/[\d]/g)) {
              // don't split if has a number in it
              split = false;
            }
          }

          if (split) {
            // so that each character gets processed separately
            // put all characters back on the input
            // but with spaces
            // then process again

            for (let i = result.length - 1; i >= 0; i--) {
              this.lexer.unput(" ");
              this.lexer.unput(result[i]);
            }
            this.advance();

            return this.baseFactor({
              inside_absolute_value: inside_absolute_value,
              parse_absolute_value: parse_absolute_value,
              allow_absolute_value_closing: allow_absolute_value_closing
            });
          } else {
            this.advance();
          }
        }
      } else if (this.token.token_type === '(' || this.token.token_type === '[' ||
        this.token.token_type === '{') {
        let token_left = this.token.token_type;
        let expected_right, other_right;
        if (this.token.token_type === '(') {
          expected_right = ')';
          other_right = ']';
        } else if (this.token.token_type === '[') {
          expected_right = ']';
          other_right = ')';
        } else {
          expected_right = '}';
          other_right = null;
        }

        this.advance();
        result = this.statement_list();

        let n_elements = 1;
        if (result[0] === "list") {
          n_elements = result.length - 1;
        }

        if (this.token.token_type !== expected_right) {
          if (n_elements !== 2 || other_right === null) {
            throw new ParseError('Expecting ' + expected_right,
              this.lexer.location);
          } else if (this.token.token_type !== other_right) {
            throw new ParseError('Expecting ) or ]', this.lexer.location);
          }

          // half-open interval
          result[0] = 'tuple';
          result = ['interval', result];
          let closed;
          if (token_left === '(')
            closed = ['tuple', false, true];
          else
            closed = ['tuple', true, false];
          result.push(closed);

        } else if (n_elements >= 2) {
          if (token_left === '(') {
            result[0] = 'tuple';
          } else if (token_left === '[') {
            result[0] = 'array';
          } else {
            result[0] = 'set';
          }
        } else if (token_left === '{') {
          if (result[0] === '|' || result[0] === ':') {
            result = ['set', result];  // set builder notation
          }
          else {
            result = ['set', result]; // singleton set
          }
        }

        this.advance();

      } else if (this.token.token_type === '|' && parse_absolute_value &&
        (inside_absolute_value === 0 || !allow_absolute_value_closing)) {

        // allow the opening of an absolute value here if either
        // - we aren't already inside an absolute value (inside_absolute_value==0), or
        // - we don't allows an absolute value closing
        // otherwise, skip this token so that will drop out the factor (and entire statement)
        // to where the absolute value will close

        inside_absolute_value += 1;

        this.advance();

        result = this.statement({ inside_absolute_value: inside_absolute_value });
        result = ['apply', 'abs', result];

        if (this.token.token_type !== '|') {
          throw new ParseError('Expecting |', this.lexer.location);
        }

        this.advance();
      }

      if (this.token.token_type === '_') {
        if (result === false) {
          throw new ParseError("Invalid location of _", this.lexer.location);
        }
        this.advance();
        let subresult = this.baseFactor({ parse_absolute_value: parse_absolute_value });

        if (subresult === false) {
          if (this.token.token_type === "EOF") {
            throw new ParseError("Unexpected end of input", this.lexer.location);
          } else {
            throw new ParseError("Invalid location of '" + this.token.original_text + "'",
              this.lexer.location);
          }
        }
        return ['_', result, subresult];
      }

      return result;
    }


    leibniz_notation() {
      // attempt to find and return a derivative in Leibniz notation
      // if unsuccessful, return false

      var result = this.token.token_text;

      if (!(this.token.token_type === 'VAR' && (result[0] === "d" || result[0] === "∂")
        && (result.length === 1 || (result.length === 2 && /[a-zA-Z]/.exec(result[1]))))) {
        return false;
      }

      // found one of these two possibilities for start of derivative are
      // - dx or ∂x (no space, x is a single letter)
      // - d or ∂

      let deriv_symbol = result[0];

      let n_deriv = 1;

      let var1 = "";
      let var2s = [];
      let var2_exponents = [];

      if (result.length === 2)
        var1 = result[1];
      else { // result is length 1

        // since have just a d or ∂
        // must be followed by a ^ or a VARMULTICHAR
        this.advance({ remove_initial_space: false });

        if (this.token.token_type === 'VARMULTICHAR') {
          var1 = this.token.token_text;
        }

        else {
          // since not VARMULTICHAR, must be a ^ next
          if (this.token.token_type !== '^') {
            return false;
          }

          // so far have d or ∂ followed by ^
          // must be followed by an integer
          this.advance({ remove_initial_space: false });

          if (this.token.token_type !== 'NUMBER') {
            return false;
          }

          n_deriv = parseFloat(this.token.token_text);
          if (!Number.isInteger(n_deriv)) {
            return false;
          }

          // see if next character is single character
          this.advance({ remove_initial_space: false });

          // either a single letter from VAR
          // or a VARMULTICHAR
          if ((this.token.token_type === 'VAR' && (/^[a-zA-Z]$/.exec(this.token.token_text)))
            || this.token.token_type === 'VARMULTICHAR') {
            var1 = this.token.token_text;
          }
          else {
            return false;
          }
        }
      }

      // next character must be a /

      this.advance(); // allow a space this time

      if (this.token.token_type !== '/')
        return false;

      // find sequence of
      // derivative symbol followed by a single character or VARMULTICHAR (with no space)
      // optionally followed by a ^ and an integer (with no spaces)
      // (with spaces allowed between elements of sequence)
      // End when sum of exponents meets or exceeds n_deriv

      let exponent_sum = 0;

      this.advance(); // allow space just after the /

      while (true) {

        // next must either be
        // - a VAR whose first character matches derivative symbol
        //   and whose second character is a letter, or
        // - a single character VAR that matches derivative symbol
        //   which must be followed by a VARMULTICHAR (with no space)

        if (this.token.token_type !== 'VAR' || this.token.token_text[0] !== deriv_symbol) {
          return false;
        }

        if (this.token.token_text.length > 2) {
          // Put extra characters back on lexer
          this.lexer.unput(this.token.token_text.slice(2));

          // keep just two character token
          this.token.token_text = this.token.token_text.slice(0, 2);

        }

        let token_text = this.token.token_text;

        // derivative symbol and variable together
        if (token_text.length === 2) {
          if (/[a-zA-Z]/.exec(token_text[1]))
            var2s.push(token_text[1]);
          else {
            return false;
          }
        }
        else { // token text was just the derivative symbol
          this.advance({ remove_initial_space: false });

          if (this.token.token_type !== 'VARMULTICHAR') {
            return false;
          }
          var2s.push(this.token.token_text);
        }

        // have derivative and variable, now check for optional ^ followed by number

        let this_exponent = 1;

        this.advance({ remove_initial_space: false });

        if (this.token.token_type === '^') {

          this.advance({ remove_initial_space: false });

          if (this.token.token_type !== 'NUMBER') {
            return false;
          }

          this_exponent = parseFloat(this.token.token_text);
          if (!Number.isInteger(this_exponent)) {
            return false;
          }

          this.advance({ remove_initial_space: false });

        }
        var2_exponents.push(this_exponent);
        exponent_sum += this_exponent;

        if (exponent_sum > n_deriv) {
          return false;
        }

        // possibly found derivative
        if (exponent_sum === n_deriv) {

          // check to make sure next token isn't another VAR or VARMULTICHAR
          // in this case, the derivative isn't separated from what follows
          if (this.token.token_type === "VAR" || this.token.token_type === "VARMULTICHAR") {
            return false;
          }

          // found derivative!

          // if last token was a space advance to next non-space token
          if (this.token.token_type === "SPACE")
            this.advance();

          let result_name = "derivative_leibniz";
          if (deriv_symbol === "∂")
            result_name = "partial_" + result_name;

          result = [result_name];

          if (n_deriv === 1)
            result.push(var1);
          else
            result.push(["tuple", var1, n_deriv]);

          let r2 = [];
          for (let i = 0; i < var2s.length; i += 1) {
            if (var2_exponents[i] === 1)
              r2.push(var2s[i]);
            else
              r2.push(["tuple", var2s[i], var2_exponents[i]]);
          }
          r2 = ["tuple"].concat(r2);

          result.push(r2);

          return result;
        }
      }
    }
  }

  var textToAst$1 = new textToAst();


  function expand(expr_or_tree, no_division) {
    // Initial implementation of expand
    // Expands polynomials only up to degree 4

    var tree = get_tree(expr_or_tree);

    var transformations = [];
    transformations.push([textToAst$1.convert("a*(b+c)"), textToAst$1.convert("a*b+a*c")]);
    transformations.push([textToAst$1.convert("(a+b)*c"), textToAst$1.convert("a*c+b*c")]);
    if(!no_division)
      transformations.push([textToAst$1.convert("(a+b)/c"), textToAst$1.convert("a/c+b/c")]);
    transformations.push([textToAst$1.convert("-(a+b)"), textToAst$1.convert("-a-b")]);
    transformations.push([textToAst$1.convert("a(-b)"), textToAst$1.convert("-ab")]);
    transformations.push([textToAst$1.convert("(a+b)^2"), textToAst$1.convert("a^2+2ab+b^2")]);
    transformations.push([textToAst$1.convert("(a+b)^3"), textToAst$1.convert("a^3+3a^2b+3ab^2+b^3")]);
    transformations.push([textToAst$1.convert("(a+b)^4"), textToAst$1.convert("a^4+4a^3b+6a^2b^2+4ab^3+b^4")]);
    transformations.push([textToAst$1.convert("(-a)^2"), textToAst$1.convert("a^2")]);
    transformations.push([textToAst$1.convert("(-a)^3"), textToAst$1.convert("-a^3")]);
    transformations.push([textToAst$1.convert("(-a)^4"), textToAst$1.convert("a^4")]);

    tree = applyAllTransformations(tree, transformations, 20);

    tree = flatten(tree);

    tree = evaluate_numbers(tree);

    tree = collect_like_terms_factors(tree);

    tree = normalize_negatives(tree);

    return tree;
  }

  function expand_relations(expr_or_tree) {
    var tree = get_tree(expr_or_tree);
    return transform$2(tree, expand_relations_transform);
  }

  function expand_relations_transform (ast) {
    if(!Array.isArray(ast)) {
      return ast;
    }

    var operator = ast[0];
    var operands = ast.slice(1);
    // since transforms in bottom up fashion,
    // operands have already been expanded

    if(operator === '=') {
      if(operands.length <= 2)
        return ast;
      let result = ['and'];
      for(let i=0; i < operands.length-1; i++) {
        result.push(['=', operands[i], operands[i+1]]);
      }
      return result;
    }
    if(operator === 'gts' || operator === 'lts') {
      let args = operands[0];
      let strict = operands[1];

      if(args[0] !== 'tuple' || strict[0] !== 'tuple')
        // something wrong if args or strict are not tuples
        throw new Error("Badly formed ast");


      let comparisons = [];
      for(let i=1; i< args.length-1; i++) {
        let new_operator;
        if(strict[i]) {
  	if(operator === 'lts')
  	  new_operator = '<';
  	else
  	  new_operator = '>';
        }
        else {
  	if(operator === 'lts')
  	  new_operator = 'le';
  	else
  	  new_operator = 'ge';
        }
        comparisons.push([new_operator, args[i], args[i+1]]);
      }

      let result = ['and', comparisons[0], comparisons[1]];
      for(let i=2; i<comparisons.length; i++)
        result = ['and', result, comparisons[i]];
      return result;
    }

    // convert interval containment to inequalities
    if(operator === 'in' || operator === 'notin' ||
       operator === 'ni' || operator === 'notni') {

      let negate=false;
      if(operator === 'notin' || operator === 'notni')
        negate=true;

      let x, interval;
      if(operator === 'in' || operator === 'notin') {
        x = operands[0];
        interval = operands[1];
      }
      else {
        x = operands[1];
        interval = operands[0];
      }

      // convert any tuples/arrays of length two to intervals
      interval = to_intervals(interval);

      // if not interval, don't transform
      if(interval[0] !== 'interval')
        return ast;

      let args = interval[1];
      let closed = interval[2];
      if(args[0] !== 'tuple' || closed[0] !== 'tuple')
        throw new Error("Badly formed ast");

      let a = args[1];
      let b = args[2];

      let comparisons = [];
      if(closed[1]) {
        if(negate)
  	comparisons.push(['<', x, a]);
        else
  	comparisons.push(['ge', x, a]);
      }
      else {
        if(negate)
  	comparisons.push(['le', x, a]);
        else
  	comparisons.push(['>', x, a]);
      }
      if(closed[2]) {
        if(negate)
  	comparisons.push(['>', x, b]);
        else
  	comparisons.push(['le', x, b]);
      }
      else {
        if(negate)
  	comparisons.push(['ge', x, b]);
        else
  	comparisons.push(['<', x, b]);
      }

      let result;
      if(negate)
        result =  ['or'].concat(comparisons);
      else
        result =  ['and'].concat(comparisons);

      return result;
    }

    // convert interval containment to inequalities
    if(operator === 'subset' || operator === 'notsubset' ||
       operator === 'superset' || operator === 'notsuperset') {

      let negate=false;
      if(operator === 'notsubset' || operator === 'notsuperset')
        negate=true;

      let small, big;
      if(operator === 'subset' || operator === 'notsubset') {
        small = operands[0];
        big = operands[1];
      }
      else {
        small = operands[1];
        big = operands[0];
      }

      // convert any tuples/arrays of length two to intervals
      small = to_intervals(small);
      big = to_intervals(big);

      // if not interval, don't transform
      if(small[0] !== 'interval' || big[0] !== 'interval')
        return ast;

      let small_args = small[1];
      let small_closed = small[2];
      let big_args = big[1];
      let big_closed = big[2];
      if(small_args[0] !== 'tuple' || small_closed[0] !== 'tuple' ||
         big_args[0] !== 'tuple' || big_closed[0] !== 'tuple')
        throw new Error("Badly formed ast");

      let small_a = small_args[1];
      let small_b = small_args[2];
      let big_a = big_args[1];
      let big_b = big_args[2];

      let comparisons = [];
      if(small_closed[1] && !big_closed[1]) {
        if(negate)
  	comparisons.push(['le', small_a,big_a]);
        else
  	comparisons.push(['>', small_a,big_a]);
      }
      else {
        if(negate)
  	comparisons.push(['<', small_a,big_a]);
        else
  	comparisons.push(['ge', small_a,big_a]);
      }
      if(small_closed[2] && !big_closed[2]) {
        if(negate)
  	comparisons.push(['ge', small_b,big_b]);
        else
  	comparisons.push(['<', small_b,big_b]);
      }
      else {
        if(negate)
  	comparisons.push(['>',small_b,big_b]);
        else
  	comparisons.push(['le',small_b,big_b]);
      }
      let result;
      if(negate)
        result =  ['or'].concat(comparisons);
      else
        result =  ['and'].concat(comparisons);

      return result;

    }

    return ast;
  }

  function substitute$1(pattern, bindings) {
    var pattern_tree = get_tree(pattern);

    var bindings_tree = {};
    for(let b in bindings) {
      bindings_tree[b] = get_tree(bindings[b]);
    }

    return substitute(pattern_tree, bindings_tree);

  }

  function substitute_component(pattern, component, value) {
    let pattern_tree = get_tree(pattern);
    let value_tree = get_tree(value);

    if(typeof component === "number") {
      component = [component];
    }
    else if(!Array.isArray(component)) {
      throw Error("Invalid substitute_component: " + component);
    }


    let container_operators = ["list", "tuple", "vector", "array"];

    return substitute_component_sub(pattern_tree, component, value_tree);


    function substitute_component_sub(tree, component, value_tree) {

      if(component.length === 0) {
        return value;
      }
      if(!Array.isArray(tree)) {
        throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
      }

      let operator = tree[0];
      let operands = tree.slice(1);

      if(!container_operators.includes(operator)) {
        throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
      }

      let ind = component[0];
      if(ind < 0 || ind > operands.length-1) {
        throw Error("Invalid substitute_component: component out of range");
      }
      let new_components = component.slice(1);
      let result = substitute_component_sub(operands[ind], new_components, value_tree);

      return [operator, ...operands.slice(0,ind), result, ...operands.slice(ind+1)];
    }

  }

  function get_component(pattern, component) {
    let pattern_tree = get_tree(pattern);

    if(typeof component === "number") {
      component = [component];
    }
    else if(!Array.isArray(component)) {
      throw Error("Invalid get_component: " + component);
    }

    let container_operators = ["list", "tuple", "vector", "array"];

    return get_component_sub(pattern_tree, component);


    function get_component_sub(tree, component) {

      if(component.length === 0) {
        return tree;
      }

      if(!Array.isArray(tree)) {
        throw Error("Invalid get_component: expected list, tuple, vector, or array");
      }

      let operator = tree[0];
      let operands = tree.slice(1);

      if(!container_operators.includes(operator)) {
        throw Error("Invalid get_component: expected list, tuple, vector, or array");
      }

      let ind = component[0];
      if(ind < 0 || ind > operands.length-1) {
        throw Error("Invalid get_component: component out of range");
      }
      let new_components = component.slice(1);
      return get_component_sub(operands[ind], new_components);

    }

  }

  var transformation = /*#__PURE__*/Object.freeze({
    expand: expand,
    expand_relations: expand_relations,
    substitute: substitute$1,
    substitute_component: substitute_component,
    get_component: get_component
  });

  function solve_linear(expr_or_tree, variable, assumptions) {
      // assume expr is linear in variable


      if(!(typeof variable === 'string'))
  	return undefined;

      if(assumptions===undefined && expr_or_tree.context !== undefined
         && expr_or_tree.context.get_assumptions !== undefined)
  	assumptions = expr_or_tree.context.get_assumptions(
  	    [expr_or_tree.variables()]);

      var tree = simplify$2(get_tree(expr_or_tree), assumptions);
      //var tree = get_tree(expr_or_tree);

      if(!Array.isArray(tree))
  	return undefined;

      var operator = tree[0];
      var operands = tree.slice(1);

      if(!(operator === '=' || operator === 'ne'
  	 || operator === '<' || operator === 'le'
  	 || operator === '>' || operator === 'ge'))
  	return undefined;


      // set equal to zero, as lhs = 0
      var lhs = simplify$2(['+', operands[0], ['-', operands[1]]],
  				assumptions);

      var no_var = tree => !variables(tree).includes(variable);

      // factor out variable
      var transformation  = [
  	['+', ['*', '_a', variable], ['*', '_b', variable]],
  	['*', ['+', '_a', '_b'], variable],
  	{variables: {_a: no_var, _b: no_var},
  	 allow_permutations: true,
  	 allow_extended_match: true,
  	 allow_implicit_identities: ['_a', '_b'],
  	 evaluate_numbers: true,

  	}];

      lhs = simplify$2(
  	applyAllTransformations(lhs, [transformation], 20));

      if(!variables(lhs).includes(variable))
  	return undefined;

      var pattern = ['+', ['*', '_a', variable], '_b'];

      var params = {
  	variables: { _a: no_var, _b: no_var},
  	allow_permutations: true,
  	allow_implicit_identities: ['_a', '_b'],
      };

      var match$$1 = match(lhs, pattern, params);

      if(!match$$1)
  	return undefined;  // not linear in variable

      var a = simplify$2(match$$1['_a']);
      var b = simplify$2(match$$1['_b']);

      if(!is_nonzero_ast(a, assumptions))
  	return undefined;  // can't confirm that there is a variable

      // equality or inequality with positive coefficient
      if(operator === '=' || operator === 'ne' || is_positive_ast(a, assumptions)) {
  	let result = simplify$2(['/', ['-', b], a]);
  	return [operator, variable, result];
      }

      if(!is_negative_ast(a, assumptions))
  	return undefined;   // couldn't determined sign and have inequality

      // have inequality with negative coefficient
      var result = simplify$2(['/', ['-', b], a]);
      if(operator === '<')
  	operator = '>';
      else if(operator === 'le')
  	operator = 'ge';
      else if(operator === '>')
  	operator = '<';
      else
  	operator = 'le';

      return [operator, variable, result];
  }

  var solve = /*#__PURE__*/Object.freeze({
    solve_linear: solve_linear
  });

  function clean_assumptions(tree, known) {
      // normalize order and operators of assumptions in tree,
      // remove any duplicates or those in known
      // return ast or undefined if no assumptions found

      if(!Array.isArray(tree) || tree.length === 0)
  	return tree;

      tree= flatten(
  	default_order(
  	    simplify_logical(
  		expand_relations(tree)
  	    )
  	)
      );

      // check for duplicates (within tree or already in known)
      var operator=tree[0];
      var operands=tree.slice(1);

      if(operator === 'and' || operator === 'or') {
  	// remove duplicates, using trees.equal
  	operands = operands.reduce(function (a,b) {
  	    if(a.every(function(v) { return !equal$2(v,b)}))
  		a.push(b);
  	    return a;
  	},[]);

  	// if known exists, filter out those
  	if(operator === 'and' && known && Array.isArray(known)) {
  	    let known_operands;
  	    if(known[0] === 'and')
  		known_operands = known.slice(1);
  	    else
  		known_operands = [known];

  	    operands = operands.filter(
  		v => known_operands.every(u => !equal$2(u, v))
  	    );

  	}

  	if(operands.length === 1)
  	    tree = operands[0];
  	else
  	    tree = [operator].concat(operands);
      }

      // check if whole thing is known
      if(operator !== 'and' && known && Array.isArray(known)) {
  	let known_operands;
  	if(known[0] === 'and')
  	    known_operands = known.slice(1);
  	else
  	    known_operands = [known];

  	if(!known_operands.every(u => !equal$2(u, tree)))
  	    return undefined;
      }

      return tree;
  }


  function calculate_derived_assumptions(assumptions, tree) {
      // Calculate all assumptions on variables within tree that
      // can be derived from the assumptions within tree,
      // eliminating any assumptions that are already recorded
      // in byvar or generic of assumptions
      //
      // if tree is undefined, calculate assumptions that can be
      // derived from all given assumptions


      if(tree === undefined) {
  	tree = [];
  	for(let v in assumptions.byvar) {
  	    let a = assumptions.byvar[v];
  	    if(a.length > 0)
  		tree.push(a);
  	}
  	if(tree.length === 0)
  	    return {};

  	if(tree.length === 1)
  	    tree = tree[0];
  	else
  	    tree = ['and'].concat(tree);

  	tree = clean_assumptions(tree);
      }

      if(!Array.isArray(tree) || tree.length === 0)
  	return {};

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === 'and' || operator === 'or') {
  	let results = operands.map(function (v) {
  	    return calculate_derived_assumptions(assumptions, v);
  	});

  	// array of all vars found in at least one result
  	let allvars = [...new Set(results.reduce(
  	    (a,b) => [...a, ...Object.keys(b)], []))];

  	let derived = {};

  	for(let v of allvars) {
  	    let res = results.reduce(function (a,b) {
  		if(b[v] !== undefined)
  		    a.push(b[v]);
  		return a;
  	    },[]);


  	    // for OR, add only if obtain result for each operand
  	    if(operator === 'and' || res.length === results.length) {
  		let new_derived = derived[v];
  		if(new_derived === undefined) {
  		    if(res.length > 1)
  			new_derived = [operator].concat(res);
  		    else
  			new_derived = res[0];
  		}
  		else {
  		    if(res.length > 1)
  			new_derived = ['and', new_derived,
  				       [operator].concat(res)];
  		    else
  			new_derived = ['and', new_derived, res[0]];
  		}

  		derived[v] = clean_assumptions(
  		    new_derived,
  		    get_assumptions(assumptions, v, {omit_derived: true}));
  	    }
  	}

  	return derived;
      }
      // Shouldn't get a NOT of (in)equality after simplifying logical
      // if(operator === 'not') {
      // 	let results = calculate_derived_assumptions(assumptions, operands[0]);
      // 	for(let v of Object.keys(results)) {
      // 	    derived[v] = ['not', results[v]];
      // 	}
      // 	return derived;
      // }

      let derived = {};

      if(operator === '=' || operator === 'ne' ||
         operator === '<' || operator === 'le' ||
         operator === 'in' || operator === 'subset' ||
         operator === 'notin' || operator === 'notsubset'
        ) {

  	var addressed_assumption = false;

  	// calculate derived if one side is equal to a variable
  	for(let ind = 0; ind < 2; ind++) {
  	    let v = operands[ind];
  	    let other = operands[1-ind];
  	    let other_var = variables(other);
  	    if((typeof v !== 'string') || other_var.length === 0
  	       || other_var.includes(v))
  		continue;

  	    addressed_assumption = true;

  	    // look for any assumptions that from other that
  	    // do not contain a v
  	    var adjusted_op = operator;
  	    if(ind === 1) {
  		if(operator === '<')
  		    adjusted_op = '>';
  		else if(operator === 'le')
  		    adjusted_op = 'ge';
  		else if(operator === 'in')
  		    adjusted_op = 'ni';
  		else if(operator === 'subset')
  		    adjusted_op = 'superset';
  		else if(operator === 'notin')
  		    adjusted_op = 'notni';
  		else if(operator === 'notsubset')
  		    adjusted_op = 'notsuperset';
  	    }
  	    let result = get_assumptions_for_expr(
  		assumptions, other, [v]);

  	    // combine with results for expr, if compatible
  	    result = combine_assumptions(v, adjusted_op, other, result);

  	    if(result !== undefined) {
  		let new_derived = derived[v];

  		if(new_derived === undefined) {
  		    new_derived = result;
  		}
  		else {
  		    new_derived = ['and', new_derived, result];
  		}

  		derived[v] = clean_assumptions(
  		    new_derived, get_assumptions(
  			assumptions, v, {omit_derived: true}));

  	    }

  	}
  	if(addressed_assumption)
  	    return derived;
      }

      // if wasn't able to combine expressions, just add any assumptions
      // on the operands
      let results = [];

      for(let op of operands)  {
  	let res =  get_assumptions_for_expr(assumptions, op, []);
  	if(res !== undefined)
  	    results.push(res);
      }

      if(results.length === 0)
  	return {};

      if(results.length === 1)
  	results = results[0];
      else
  	results = ['and'].concat(results);

      for(let v of variables(tree)) {
  	derived[v] = clean_assumptions(
  	    results, get_assumptions(
  		assumptions, v, {omit_derived: true}));
      }

      return derived;

  }

  function get_assumptions_for_expr(assumptions, expr, exclude_variables) {
      // return any assumptions that can be calculated for expression expr
      // that don't include exclude_variables
      //
      // The assumptions will be given directly in terms of expr when possible.


      let variables$$1 = variables(expr);

      // filter out any of the excluded variables
      variables$$1 = variables$$1.filter(v => !exclude_variables.includes(v));

      if(variables$$1.length === 0)
  	return undefined;

      function isNumber(s) {
  	if (typeof s === 'number')
  	    return true;
  	if (Array.isArray(s) && s[0] === '-' && (typeof s[1] === 'number'))
  	    return true;
  	return false;
      }

      // will proccess assumptions in case where variables are linear in expr
      var pattern = ['_b'];
      var implicit_identities = ['_b'];
      var match_vars = {_b: isNumber};
      var coeff_mapping = {};
      for(let i=0; i < variables$$1.length; i++) {
  	let a = '_a' + i;
  	coeff_mapping[variables$$1[i]] = a;
  	pattern.push(['*', a, variables$$1[i]]);
  	implicit_identities.push(a);
  	match_vars[a] = isNumber;
      }

      pattern = ['+'].concat(pattern);

      var m = match(expr, pattern,
  			{variables: match_vars,
  			 allow_permutations: true,
  			 allow_extended_match: false,
  			 allow_implicit_identities: implicit_identities,
  			 max_group: 1});

      if(!m) {
  	// if not linear, get assumptions for each variable of expr
  	let results = [];
  	for(let v of variables(expr)) {
  	    let res = get_assumptions_for_expr(
  		assumptions, v, exclude_variables);
  	    if(res !== undefined)
  		results.push(res);
  	}
  	if(results.length === 0)
  	    return undefined;
  	if(results.length === 1)
  	    return results[0];
  	return ['and'].concat(results);
      }

      for(let v of variables$$1)
  	coeff_mapping[v] = m[coeff_mapping[v]];

      let identity = false;
      if(m["_b"] === 0 && m["_a0"] === 1 && variables$$1.length === 1)
  	identity = true;

      // find all assumptions involving variables but excluding exclude_variables
      var new_assumptions;
      new_assumptions = get_assumptions(
  	assumptions, [variables$$1], {exclude_variables: exclude_variables});

      if(new_assumptions === undefined)
  	return undefined;

      return clean_assumptions(process_additional_assumptions(new_assumptions));


      function process_additional_assumptions(new_as) {

  	if(!Array.isArray(new_as))
  	    return undefined;

  	var operator = new_as[0];
  	var operands = new_as.slice(1);

  	if(operator === 'and' || operator === 'or') {
  	    let results = operands
  		.map(process_additional_assumptions)
  		.filter(v => v !== undefined);

  	    if(results.length === 0)
  		return undefined;
  	    if(operator === 'or') {
  		if(results.length === operands.length)
  		    return ['or'].concat(results);
  		else
  		    return undefined;
  	    }
  	    if(results.length === 1)
  		return results[0];
  	    else
  		return ['and'].concat(results);
  	}

  	// can ignore NOTs, as simplify_logical should remove
  	// any before (in)equalities or containments

  	if(!(['=', 'ne', '<', 'le'].includes(operator) ||
  	     (['in', 'notin', 'subset', 'notsubset'].includes(operator)
  	      && identity))) {

  	    let new_exclude = exclude_variables.concat(variables(expr));
  	    let results = [];
  	    for(let v of variables(new_as)) {
  		if(new_exclude.includes(v))
  		    continue;
  		let res = get_assumptions_for_expr(assumptions, v, new_exclude);
  		if(res !== undefined)
  		    results.push(res);
  	    }
  	    if(results.length === 0)
  		return new_as;
  	    if(results.length === 1)
  		return ['and', new_as, results[0]];
  	    return ['and', new_as].concat(results);
  	}

  	let results = [];

  	for(let ind=0; ind <= 1; ind++) {
  	    let next_var = operands[ind];
  	    let next_rhs = operands[1-ind];

  	    if((typeof next_var === 'string') && variables$$1.includes(next_var)) {

  		var bindings = {};
  		bindings[next_var] = next_rhs;
  		var new_expr = simplify$2(substitute(expr, bindings));

  		// may need to flip operator if it is an inequality
  		// Two factors could induce flipping
  		// - coefficient from expr is negative
  		// - switched sides in next inequality (ind === 1)
  		// The factors could cancel each other out
  		var flip = false;
  		var operator_eff = operator;
  		if((ind === 1 && coeff_mapping[next_var] > 0) ||
  		   (ind === 0 && coeff_mapping[next_var] < 0)) {
  		    if(operator === '<') {
  			flip = true;
  			operator_eff = '>';
  		    }
  		    else if(operator === 'le') {
  			flip = true;
  			operator_eff = 'ge';
  		    }
  		    else if(operator === 'in') {
  			flip = true;
  			operator_eff = 'ni';
  		    }
  		    else if(operator === 'subset') {
  			flip = true;
  			operator_eff = 'superset';
  		    }
  		    else if(operator === 'notin') {
  			flip = true;
  			operator_eff = 'notni';
  		    }
  		    else if(operator === 'notsubset') {
  			flip = true;
  			operator_eff = 'notsuperset';
  		    }
  		}

  		if(flip)
  		    results.push([operator, new_expr, expr]);
  		else
  		    results.push([operator, expr, new_expr]);

  		// look for more assumptions
  		let new_exclude = exclude_variables.concat([next_var]);
  		let res = get_assumptions_for_expr(
  		    assumptions, new_expr, new_exclude);
  		// combine with results for expr, if compatible
  		res = combine_assumptions(expr, operator_eff, new_expr, res);

  		if(res !== undefined)
  		    results.push(res);

  	    }
  	}

  	if(results.length === 1)
  	    return results[0];
  	else if(results.length > 1)
  	    return ['and'].concat(results);

  	// didn't address assumption
  	let new_exclude = exclude_variables.concat(variables(expr));
  	results = [];
  	for(let v of variables(new_as)) {
  	    if(new_exclude.includes(v))
  		continue;
  	    let res = get_assumptions_for_expr(assumptions, v, new_exclude);
  	    if(res !== undefined)
  		results.push(res);
  	}
  	if(results.length === 0)
  	    return new_as;
  	if(results.length === 1)
  	    return ['and', new_as, results[0]];
  	return ['and', new_as].concat(results);
      }
  }


  function combine_assumptions(expr1, op1, expr2, new_as) {
      // given the assumption "expr1 op1 expr2" and assumptions from new_as
      // - return new assumptions involving expr1, if possible
      // - return undefined if new_as appears to not affect expr1
      // - return new_as if new_as appear to affect expr1 but cannot
      //   be distilled to assumptions on expr1

      if(!['=', 'ne', '<', 'le', '>', 'ge', 'in', 'notin', 'ni', 'notni',
  	 'subset', 'notsubset', 'superset', 'notsuperset'].includes(op1))
  	return new_as;

      if(!Array.isArray(new_as))
  	return undefined;

      var op2 = new_as[0];
      var operands2 = new_as.slice(1);

      if(op2 === 'and' || op2 === 'or') {
  	let results = operands2.map(
  	    v => combine_assumptions(expr1, op1, expr2, v))
  	    .filter(v => v !== undefined);

  	if(results.length === 0)
  	    return undefined;
  	if(op2 === 'or') {
  	    if(results.length === operands2.length)
  		return [['or'].concat(results)];
  	    else
  		return undefined;
  	}
  	if(results.length === 1)
  	    return results[0];
  	else
  	    return ['and'].concat(results);
      }

      if(!['=', 'ne', '<', 'le', 'in', 'notin', 'subset', 'notsubset']
         .includes(op2))
  	return new_as;

      var op2_eff = op2;
      var rhs;
      if(equal$2(operands2[0], expr2)) {
  	rhs = operands2[1];
      }
      else if(equal$2(operands2[1], expr2)) {
  	rhs = operands2[0];
  	if(op2 === '<')
  	    op2_eff = '>';
  	else if(op2 === 'le')
  	    op2_eff = 'ge';
  	else if(op2 === 'in')
  	    op2_eff = 'ni';
  	else if(op2 === 'notin')
  	    op2_eff = 'notni';
  	else if(op2 === 'subset')
  	    op2_eff = 'superset';
  	else if(op2 === 'notsubset')
  	    op2_eff = 'notsuperset';
      }
      else {
  	return new_as;
      }


      // determined operator of combined expression
      var combined_op;
      if(op1 === '=')
  	combined_op = op2_eff;
      else if(op2_eff === '=')
  	combined_op = op1;
      else if(op1 === '<') {
  	if(op2_eff === '<' || op2_eff === 'le')
  	    combined_op = '<';
  	else if(op2_eff === 'in' || op2_eff === 'notin')
  	    return new_as;
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'le') {
  	if(op2_eff === '<')
  	    combined_op = '<';
  	else if(op2_eff === 'le')
  	    combined_op = 'le';
  	else if(op2_eff === 'in' || op2_eff === 'notin')
  	    return new_as;
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === '>') {
  	if(op2_eff === '>' || op2_eff === 'ge')
  	    combined_op = '>';
  	else if(op2_eff === 'in' || op2_eff === 'notin')
  	    return new_as;
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'ge') {
  	if(op2_eff === '>')
  	    combined_op = '>';
  	else if(op2_eff === 'ge')
  	    combined_op = 'ge';
  	else if(op2_eff === 'in' || op2_eff === 'notin')
  	    return new_as;
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'in') {
  	if(op2_eff === 'subset')
  	    combined_op = 'in';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'notin') {
  	if(op2_eff === 'superset')
  	    combined_op = 'notin';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'ni') {
  	if(op2_eff === 'notin')
  	    combined_op = 'notsubset';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'notni') {
  	if(op2_eff === 'in')
  	    combined_op = 'notsuperset';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'subset') {
  	if(op2_eff === 'subset')
  	    combined_op = 'subset';
  	else if(op2_eff === 'notni')
  	    combined_op = 'notni';
  	else if(op2_eff === 'notsuperset')
  	    combined_op = 'notsuperset';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'notsubset') {
  	if(op2_eff === 'superset')
  	    combined_op = 'notsubset';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'superset') {
  	if(op2_eff === 'superset')
  	    combined_op = 'superset';
  	else if(op2_eff === 'ni')
  	    combined_op = 'ni';
  	else if(op2_eff === 'notsubset')
  	    combined_op = 'notsubset';
  	else
  	    return undefined;   // incompatible operators
      }
      else if(op1 === 'notsuperset') {
  	if(op2_eff === 'subset')
  	    combined_op = 'notsuperset';
  	else
  	    return undefined;   // incompatible operators
      }
      else
  	return undefined;


      if(combined_op ===  '>')
  	return ['<', rhs, expr1];
      else if(combined_op === 'ge')
  	return ['le', rhs, expr1];
      else if(combined_op === 'ni')
  	return ['in', rhs, expr1];
      else if(combined_op === 'notni')
  	return ['notin', rhs, expr1];
      else if(combined_op === 'superset')
  	return ['subset', rhs, expr1];
      else if(combined_op === 'notsuperset')
  	return ['notsubset', rhs, expr1];
      else
  	return [combined_op, expr1, rhs];

  }


  function filter_assumptions_from_tree(tree, exclude_variables) {
      // return an ast if found in tree assumptions without exclude_variables
      // otherwise return undefined

      if(!Array.isArray(tree) || tree.length === 0) {
  	return undefined;
      }

      if(!Array.isArray(exclude_variables))
  	exclude_variables = [exclude_variables];

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === 'and') {

  	var a= operands.map(function (v) {
  	    return filter_assumptions_from_tree(v, exclude_variables);
  	});

  	a=a.filter(v => v !== undefined);

  	if(a.length === 0)
  	    return undefined;
  	else if(a.length === 1)
  	    return a[0];
  	else
  	    return ['and'].concat(a);
      }

      // if no intersection between exclude variables and variables in tree
      // return tree
      var tree_variables = variables(tree);
      var contains_excluded = exclude_variables.filter(
  	(v) => tree_variables.includes(v)).length > 0;

      if(!contains_excluded)
  	return tree;
      else
  	return undefined;
  }


  function get_assumptions_sub(assumptions, variables$$1, exclude_variables,
  			     omit_derived) {
      // return an ast if found assumptions involving variables
      // otherwise return undefined

      if(!Array.isArray(variables$$1))
  	variables$$1 = [variables$$1];

      var a = [];

      // add assumptions specified by each variable
      variables$$1.forEach(function (v) {
  	// get assumption from byvar and derived, if exist
  	if(assumptions.byvar[v] || assumptions.derived[v]) {
  	    if(assumptions.byvar[v] && assumptions.byvar[v].length > 0) {
  		// only get assumptions that don't contain
  		// exclude variables
  		var byvar = filter_assumptions_from_tree(
  		    assumptions.byvar[v], exclude_variables);
  		if(byvar !== undefined)
  		    a.push(byvar);
  	    }
  	    if(assumptions.derived[v] && assumptions.derived[v].length > 0
  	       && !omit_derived) {
  		// only get derived assumptions that don't contain
  		// exclude variables
  		var da = filter_assumptions_from_tree(
  		    assumptions.derived[v], exclude_variables);
  		if(da !== undefined)
  		    a.push(da);
  	    }
  	}
  	// if byvar and derived are undefined,
  	// then get assumptions from generic
  	else if(assumptions['generic'].length > 0) {
  	    // if generic contains any variables other than x
  	    // don't substitute those back into generic
  	    if(v === 'x' ||
  	       !variables(assumptions['generic']).includes(v))
  		a.push(substitute(assumptions['generic'], {x: v}));
  	}
      });

      if(a.length === 1)
  	a=a[0];
      else if(a.length > 1)
  	a=['and'].concat(a);

      if(a.length > 0)
  	return clean_assumptions(a);
      else
  	return undefined

  }

  function get_assumptions(assumptions, variables_or_expr, params) {
      // return an ast if found assumptions
      // otherwise return undefined
      //
      // variables_or_expr
      // - if a string or an array of an array, find assumptions on
      //   each of the variables represented by those strings
      //   directly from byvar and derived or from generic
      // - if an ast, then
      //   - calculate assumptions of the expression itself, if possible, or
      //   - calculate assumptions on the variables of the expression.

      // include any additional assumptions
      // involving new variables found in assumptions

      if(params === undefined)
  	params = {};

      var exclude_variables = params.exclude_variables;
      if(exclude_variables === undefined)
  	exclude_variables = [];
      else if(!Array.isArray(exclude_variables))
  	exclude_variables = [exclude_variables];

      var variables$$1;
      var tree = get_tree(variables_or_expr);

      // if string, have a variable
      if(typeof tree === "string")
  	variables$$1 = [tree];
      else if(!Array.isArray(tree))
  	return undefined;
      else if(Array.isArray(tree[0]))
  	// if array containing array, is list of variables
  	variables$$1 = tree[0];


      if(variables$$1)
  	return get_assumptions_sub(assumptions, variables$$1,
  				   exclude_variables, params.omit_derived);
      else
  	return get_assumptions_for_expr(assumptions, tree, exclude_variables)

  }


  function add_assumption(assumptions, expr_or_tree, exclude_generic) {
      // add assumption in tree to assumptions
      // if !exclude_generic, then add any generic assumptions to
      // variables if they don't have previous assumptions
      // return 1 if added assumption or 0 otherwise

      var tree = get_tree(expr_or_tree);

      if(!Array.isArray(tree))
  	return 0;

      tree = clean_assumptions(simplify$2(tree,assumptions));

      var added = add_assumption_sub(assumptions, tree, exclude_generic);

      if(added)
  	assumptions.derived = calculate_derived_assumptions(assumptions);

      return added;
  }


  function add_assumption_sub(assumptions, tree, exclude_generic) {
      // add assumption in tree to assumptions
      // if !exclude_generic, then add any generic assumptions to
      // variables if they don't have previous assumptions
      // return number of assumptions added

      // if tree is an 'and', call once for each operand
      // so that assumptions can be separated by variable
      if(tree[0] === 'and') {
  	var results = tree.slice(1).map(
  	    v => add_assumption_sub(assumptions, v, exclude_generic));
  	return results.reduce(function (a,b) { return a + b;});
      }

      var variables$$1 = variables(tree);

      if(variables$$1.length === 0)
  	return 0;

      let n_added = 0;

      if(!exclude_generic && assumptions['generic'].length > 0) {
  	// check to see if any assumptions already for each variable
  	// if not, start by assigning generic assumptions
  	variables$$1.forEach(function (v) {
  	    if(assumptions.byvar[v] === undefined) {

  		// no previous assumptions, so
  		// include add assumption for v corresponding to generic
  		// unless non-x v is explicitly in generic
  		if(v === 'x' ||
  		   !variables(assumptions['generic']).includes(v)) {
  		    add_assumption_sub(
  			assumptions,
  			substitute(assumptions['generic'], {x: v}),
  			true);
  		    n_added += 1;
  		}

  	    }
  	});

      }


      // attempt to solve for each variable
      for(let variable of variables$$1) {

  	// solve using current state of assumptions
  	let solved = solve_linear(tree, variable, assumptions);

  	let new_a = tree;
  	if(solved)
  	    new_a = solved;

  	let current_a = assumptions['byvar'][variable];

  	if(current_a !== undefined && current_a.length !== 0)
  	    new_a = ['and', current_a, new_a];

  	new_a = clean_assumptions(new_a);

  	if(!equal$2(new_a, current_a)) {
  	    assumptions['byvar'][variable] = new_a;
  	    n_added +=1;
  	}
      }

      return n_added;

  }


  function add_generic_assumption(assumptions, expr_or_tree) {
      // add assumption in expr_or_tree to generic assumptions

      // tree must contain the variable x
      // the variable x represents any variable for which
      // assumptions aren't specifically assigned

      // return 1 if added assumption or 0 otherwise

      var tree = get_tree(expr_or_tree);

      if(!Array.isArray(tree))
  	return 0;

      tree = clean_assumptions(simplify$2(tree,assumptions));

      var added = add_generic_assumption_sub(assumptions, tree);

      if(added)
  	assumptions.derived = calculate_derived_assumptions(assumptions);

      return added;
  }

  function add_generic_assumption_sub(assumptions, tree) {

      // if tree is an 'and', call once for each operand
      // so that assumptions involving one variable can be separated
      if(tree[0] === 'and') {
  	var results = tree.slice(1).map(
  	    v => add_generic_assumption_sub(assumptions, v));
  	return results.reduce(function (a,b) { return a + b;});
      }

      var variables$$1 = variables(tree);

      if(!variables$$1.includes('x'))
  	return 0;

      // attempt to solve for x
      // solve using current state of assumptions
      let solved = solve_linear(tree, 'x', assumptions);

      let new_a = tree;
      if(solved)
  	new_a = solved;

      let current_a = assumptions['generic'];

      if(current_a.length !== 0)
  	new_a = ['and', current_a, new_a];

      new_a = clean_assumptions(new_a);

      if(equal$2(new_a, current_a)) {
  	return 0;
      }

      assumptions['generic'] = new_a;

      return 1;
  }


  function remove_assumption(assumptions, expr_or_tree) {

      var tree=get_tree(expr_or_tree);

      if(!Array.isArray(tree))
  	return 0;

      tree = clean_assumptions(simplify$2(tree,assumptions));

      var removed = remove_assumption_sub(assumptions, tree);

      if(removed)
  	assumptions.derived = calculate_derived_assumptions(assumptions);

      return removed;

  }


  function remove_assumption_sub(assumptions, tree) {


      // if tree is an 'and', call once for each operand
      // so that assumptions can be separated by variable
      if(tree[0] === 'and') {
  	var results = tree.slice(1).map(v => remove_assumption_sub(
  	    assumptions, v));
  	return results.reduce(function (a,b) { return a+b;});
      }

      var variables$$1 = variables(tree);

      if(variables$$1.length === 0)
  	return 0;

      var n_removed = 0;

      // attempt to solve for each variable
      for(let variable of variables$$1) {

  	// solve using current state of assumptions
  	let solved = solve_linear(tree, variable, assumptions);

  	let current = assumptions['byvar'][variable];

  	// didn't find any assumptions to remove
  	if(!current || current.length === 0) {
  	    continue;
  	}

  	// remove any occurence of tree from current
  	let operator=current[0];
  	let operands=current.slice(1);

  	let n_op = operands.length;

  	let result;

  	if(operator === 'and') {
  	    // remove any match, using trees.equal
  	    operands = operands.filter(
  		v => !(equal$2(v, tree) || equal$2(v,solved)));

  	    if(operands.length === 0) {
  		result = [];
  	    }
  	    else if(operands.length === 1) {
  		result = operands[0];
  	    }
  	    else if(operands.length < n_op) {
  		result = [operator].concat(operands);
  	    }
  	    else {
  		// didn't find anything to remove
  		continue
  	    }
  	}
  	else {
  	    if(equal$2(current, tree) || equal$2(current, solved)) {
  		result = [];
  	    }
  	    else {
  		// didn't find anything to remove
  		continue;
  	    }
  	}

  	n_removed += 1;
  	assumptions['byvar'][variable] = result;

      }

      return n_removed;

  }

  function remove_generic_assumption(assumptions, expr_or_tree) {
      // remove assumption in expr_or_tree from generic assumptions

      // return 1 if removed assumption or 0 otherwise

      var tree=get_tree(expr_or_tree);

      if(!Array.isArray(tree))
  	return 0;

      tree = clean_assumptions(simplify$2(tree,assumptions));

      var removed = remove_generic_assumption_sub(assumptions, tree);

      if(removed)
  	assumptions.derived = calculate_derived_assumptions(assumptions);

      return removed;
  }


  function remove_generic_assumption_sub(assumptions, tree) {

      // if tree is an 'and', call once for each operand
      // so that assumptions involving one variable can be separated
      if(tree[0] === 'and') {
  	var results = tree.slice(1).map(v => remove_generic_assumption_sub(
  	    assumptions, v));
  	return results.reduce(function (a,b) { return a+b;});
      }

      var variables$$1 = variables(tree);

      if(!variables$$1.includes('x'))
  	return 0;

      var current = assumptions['generic'];

      if(current.length === 0)
  	return 0;

      // solve using current state of assumptions
      let solved = solve_linear(tree, 'x', assumptions);

      // remove any occurence of tree from current
      var operator=current[0];
      var operands=current.slice(1);

      var n_op = operands.length;

      var result;

      if(operator === 'and') {
  	// remove any match, using trees.equal
  	    operands = operands.filter(
  		v => !(equal$2(v, tree) || equal$2(v,solved)));

  	if(operands.length === 0) {
  	    result = [];
  	}
  	else if(operands.length === 1) {
  	    result = operands[0];
  	}
  	else if(operands.length < n_op) {
  	    result = [operator].concat(operands);
  	}
  	else {
  	    // didn't find anything to remove
  	    return 0;
  	}
      }
      else {
  	if(equal$2(current, tree) || equal$2(current, solved)) {
  	    result = [];
  	}
  	else {
  	    // didn't find anything to remove
  	    return 0;
  	}
      }

      assumptions['generic'] = result;

      return 1;
  }


  function initialize_assumptions() {
      var assumptions = {};
      assumptions['byvar'] = {};
      assumptions['derived'] = {};
      assumptions['generic'] = [];
      assumptions['not_commutative'] = [];
      assumptions['get_assumptions'] = function(v, params) {
  	return get_assumptions(assumptions, v, params);
      };
      assumptions['add_assumption'] = function(v, exclude_generic) {
  	return add_assumption(assumptions, v, exclude_generic);
      };
      assumptions['add_generic_assumption'] = function(v) {
  	return add_generic_assumption(assumptions, v);
      };
      assumptions['remove_assumption'] = function(v) {
  	return remove_assumption(assumptions, v);
      };
      assumptions['remove_generic_assumption'] = function(v) {
  	return remove_generic_assumption(assumptions, v);
      };

      return assumptions;
  }

  /*
   * convert syntax trees back to LaTeX code
   *
   * Copyright 2014-2017 by
   *  Jim Fowler <kisonecat@gmail.com>
   *  Duane Nykamp <nykamp@umn.edu>
   *
   * This file is part of a math-expressions library
   *
   * math-expressions is free software: you can redistribute
   * it and/or modify it under the terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */


  const operators$3 = {
    "+": function(operands) {
      return operands.join(' ');
    },
    "-": function(operands) {
      return "- " + operands[0];
    },
    "*": function(operands) {
      return operands.join(" ");
    },
    "/": function(operands) {
      return "\\frac{" + operands[0] + "}{" + operands[1] + "}";
    },
    "_": function(operands) {
      return operands[0] + "_{" + operands[1] + "}";
    },
    "^": function(operands) {
      return operands[0] + "^{" + operands[1] + "}";
    },
    "prime": function(operands) {
      return operands[0] + "'";
    },
    "tuple": function(operands) {
      return '\\left( ' + operands.join(', ') + ' \\right)';
    },
    "array": function(operands) {
      return '\\left[ ' + operands.join(', ') + ' \\right]';
    },
    "list": function(operands) {
      return operands.join(', ');
    },
    "set": function(operands) {
      return '\\left\\{ ' + operands.join(', ') + ' \\right\\}';
    },
    "vector": function(operands) {
      return '\\left( ' + operands.join(', ') + ' \\right)';
    },
    "interval": function(operands) {
      return '\\left( ' + operands.join(', ') + ' \\right)';
    },
    "matrix": function(operands) {
      return '\\left( ' + operands.join(', ') + ' \\right)';
    },
    "and": function(operands) {
      return operands.join(' \\land ');
    },
    "or": function(operands) {
      return operands.join(' \\lor ');
    },
    "not": function(operands) {
      return '\\lnot ' + operands[0];
    },
    "=": function(operands) {
      return operands.join(' = ');
    },
    "<": function(operands) {
      return operands.join(' < ');
    },
    ">": function(operands) {
      return operands.join(' > ');
    },
    "lts": function(operands) {
      return operands.join(' < ');
    },
    "gts": function(operands) {
      return operands.join(' > ');
    },
    "le": function(operands) {
      return operands.join(' \\le ');
    },
    "ge": function(operands) {
      return operands.join(' \\ge ');
    },
    "ne": function(operands) {
      return operands.join(' \\ne ');
    },
    "in": function(operands) {
      return operands[0] + " \\in " + operands[1];
    },
    "notin": function(operands) {
      return operands[0] + " \\notin " + operands[1];
    },
    "ni": function(operands) {
      return operands[0] + " \\ni " + operands[1];
    },
    "notni": function(operands) {
      return operands[0] + " \\not\\ni " + operands[1];
    },
    "subset": function(operands) {
      return operands[0] + " \\subset " + operands[1];
    },
    "notsubset": function(operands) {
      return operands[0] + " \\not\\subset " + operands[1];
    },
    "superset": function(operands) {
      return operands[0] + " \\supset " + operands[1];
    },
    "notsuperset": function(operands) {
      return operands[0] + " \\not\\supset " + operands[1];
    },
    "union": function(operands) {
      return operands.join(' \\cup ');
    },
    "intersect": function(operands) {
      return operands.join(' \\cap ');
    },
    "derivative_leibniz": function (operands) {
      return "\\frac{d" + operands[0] + "}{d" + operands[1] + "}";
    },
    "partial_derivative_leibniz": function (operands) {
      return "\\frac{d" + operands[0] + "}{d" + operands[1] + "}";
    },
    "|": function (operands) {
      return operands[0] + " \\mid " + operands[1];
    },
    ":": function (operands) {
      return operands[0] + " : " + operands[1];
    },
  };

  // defaults for parsers if not overridden by context


  // allowed multicharacter latex symbols
  // in addition to the below applied function symbols
  const allowedLatexSymbolsDefault = ['alpha', 'beta', 'gamma', 'Gamma', 'delta', 'Delta', 'epsilon', 'zeta', 'eta', 'theta', 'Theta', 'iota', 'kappa', 'lambda', 'Lambda', 'mu', 'nu', 'xi', 'Xi', 'pi', 'Pi', 'rho', 'sigma', 'Sigma', 'tau', 'Tau', 'upsilon', 'Upsilon', 'phi', 'Phi', 'chi', 'psi', 'Psi', 'omega', 'Omega', 'partial', "abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "acos", "acosh", "acot", "acoth", "acsc", "acsch", "asec", "asech", "asin", "asinh", "atan", "atanh", "cos", "cosh", "cot", "coth", "csc", "csch", "sec", "sech", "sin", "sinh", "tan", "tanh", 'arcsin', 'arccos', 'arctan', 'arccsc', 'arcsec', 'arccot', 'cosec', 'arg'];

  const matrixEnvironmentDefault = 'bmatrix';

  class astToLatex {

    constructor({
      allowedLatexSymbols=allowedLatexSymbolsDefault,
      matrixEnvironment=matrixEnvironmentDefault,
    } = {}){
      this.allowedLatexSymbols = allowedLatexSymbols;
      this.matrixEnvironment = matrixEnvironment;
    }

    convert(tree) {
      return this.statement(tree);
    }

    statement(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
        return this.single_statement(tree);
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === 'ldots')
        return '\\ldots';

      if ((!(operator in operators$3)) && operator !== "apply")
        throw new Error("Badly formed ast: operator " + operator + " not recognized.");

      if (operator === 'and' || operator === 'or') {
        return operators$3[operator](operands.map(function(v, i) {
          let result = this.single_statement(v);
          // for clarity, add parenthesis unless result is
          // single quantity (with no spaces) or already has parens
          if (result.toString().match(/ /) &&
            (!(result.toString().match(/^\\left\(.*\\right\)$/))))
            return '\\left(' + result + '\\right)';
          else
            return result;
        }.bind(this)));
      }
      return this.single_statement(tree);
    }

    single_statement(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
        return this.expression(tree);
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      if (operator === 'not') {
        return operators$3[operator](operands.map(function(v, i) {
          let result = this.single_statement(v);
          // for clarity, add parenthesis unless result is
          // single quantity (with no spaces) or already has parens
          if (result.toString().match(/ /) &&
            (!(result.toString().match(/^\\left\(.*\\right\)$/))))
            return '\\left(' + result + '\\right)';
          else
            return result;
        }.bind(this)));
      }

      if ((operator === '=') || (operator === 'ne') ||
        (operator === '<') || (operator === '>') ||
        (operator === 'le') || (operator === 'ge') ||
        (operator === 'in') || (operator === 'notin') ||
        (operator === 'ni') || (operator === 'notni') ||
        (operator === 'subset') || (operator === 'notsubset') ||
        (operator === 'superset') || (operator === 'notsuperset')) {
        return operators$3[operator](operands.map(function(v, i) {
          return this.expression(v);
        }.bind(this)));
      }

      if (operator === 'lts' || operator === 'gts') {
        let args = operands[0];
        let strict = operands[1];

        if (args[0] !== 'tuple' || strict[0] !== 'tuple')
          // something wrong if args or strict are not tuples
          throw new Error("Badly formed ast");

        let result = this.expression(args[1]);
        for (let i = 1; i < args.length - 1; i++) {
          if (strict[i]) {
            if (operator === 'lts')
              result += " < ";
            else
              result += " > ";
          }
          else {
            if (operator === 'lts') {
              result += " \\le ";
            }
            else {
              result += " \\ge ";
            }
          }
          result += this.expression(args[i + 1]);
        }
        return result;
      }

      return this.expression(tree);
    }

    expression(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
        return this.term(tree);
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      if (operator === '+') {
        return operators$3[operator](operands.map(function(v, i) {
          if (i > 0)
            return this.termWithPlusIfNotNegated(v);
          else
            return this.term(v);
        }.bind(this)));
      }

      if ((operator === 'union') || (operator === 'intersect')) {
        return operators$3[operator](operands.map(function(v, i) {
          return this.term(v);
        }.bind(this)));
      }

      return this.term(tree);
    }

    term(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
        return this.factor(tree);
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      if (operator === '-') {
        return operators$3[operator](operands.map(function(v, i) {
          return this.term(v);
        }.bind(this)));
      }
      if (operator === '*') {
        return operators$3[operator](operands.map(function(v, i) {
          let result;
          if (i > 0) {
            result = this.factorWithParenthesesIfNegated(v);
            if (result.toString().match(/^[0-9]/))
              return '\\cdot ' + result;
            else
              return '\\, ' + result
          }
          else
            return this.factor(v);
        }.bind(this)));
      }

      if (operator === '/') {
        return operators$3[operator](operands.map(function(v, i) {
          return this.expression(v);
        }.bind(this)));
      }

      return this.factor(tree);
    }

    simple_factor_or_function_or_parens(tree) {
      // return true if
      // factor(tree) is a single character
      // or tree is a non-negative number not in scientific notation
      // or tree is a string
      // or tree is a function call other than sqrt
      // or factor(tree) is in parens

      var result = this.factor(tree);

      if (result.toString().length === 1 ||
        (typeof tree === 'string') ||
        (tree[0] === 'apply' && tree[1] !== "sqrt") ||
        result.toString().match(/^\\left\(.*\\right\)$/)
      ) {
        return true;
      } else if (typeof tree === "number") {
        if(tree >= 0 && !tree.toString().includes('e')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    }

    stringConvert(string) {
      if (string.length > 1) {
        if(this.allowedLatexSymbols.includes(string))
  	return "\\" + string;
        else
  	return "\\var{" + string + '}';
      }
      return string;
    }

    factor(tree) {
      if (typeof tree === 'string') {
        return this.stringConvert(tree);
      }

      if (typeof tree === 'number') {
        if(tree === Infinity)
          return "\\infty";
        else if(tree === -Infinity)
          return "-\\infty";
        else {
          let numberString = tree.toString();
          let eIndex = numberString.indexOf('e');
          if(eIndex === -1) {
            return numberString;
          }
          let num = numberString.substring(0,eIndex);
          let exponent = numberString.substring(eIndex+1);

          return num + " \\cdot 10^{" + exponent + "}";
        }
      }

      var operator = tree[0];
      var operands = tree.slice(1);


      if (operator === "^") {
        let operand0 = this.factor(operands[0]);

        // so that f_(st)'^2(x) doesn't get extra parentheses
        // (and no longer recognized as function call)
        // check for simple factor after removing primes
        let remove_primes = operands[0];
        while (remove_primes[0] === 'prime') {
          remove_primes = remove_primes[1];
        }

        if (!(this.simple_factor_or_function_or_parens(remove_primes) ||
            (remove_primes[0] === '_' && (typeof remove_primes[1] === 'string'))
          ))
          operand0 = '\\left(' + operand0.toString() + '\\right)';

        return operand0 + '^{' + this.statement(operands[1]) + '}';
      }
      else if (operator === "_") {
        let operand0 = this.factor(operands[0]);
        if (!(this.simple_factor_or_function_or_parens(operands[0])))
          operand0 = '\\left(' + operand0.toString() + '\\right)';

        return operand0 + '_{' + this.statement(operands[1]) + '}';
      }
      else if (operator === "prime") {
        let op = operands[0];

        let n_primes = 1;
        while (op[0] === "prime") {
          n_primes += 1;
          op = op[1];
        }

        let result = this.factor(op);

        if (!(this.simple_factor_or_function_or_parens(op) ||
            (op[0] === '_' && (typeof op[1] === 'string'))
          ))
          result = '\\left(' + result.toString() + '\\right)';
        for (let i = 0; i < n_primes; i++) {
          result += "'";
        }
        return result;
      }
      else if (operator === "-") {
        return operators$3[operator](operands.map(function(v, i) {
          return this.factor(v);
        }.bind(this)));
      }
      else if (operator === 'tuple' || operator === 'array' ||
        operator === 'list' ||
  	     operator === 'set' || operator === 'vector' ||
  	     operator === '|' || operator === ':') {
        return operators$3[operator](operands.map(function(v, i) {
          return this.statement(v);
        }.bind(this)));

      }
      else if (operator === 'interval') {

        let args = operands[0];
        let closed = operands[1];
        if (args[0] !== 'tuple' || closed[0] !== 'tuple')
          throw new Error("Badly formed ast");

        let result = this.statement(args[1]) + ", " +
          this.statement(args[2]);

        if (closed[1])
          result = '\\left[ ' + result;
        else
          result = '\\left( ' + result;

        if (closed[2])
          result = result + ' \\right]';
        else
          result = result + ' \\right)';

        return result;

      }
      else if (operator === 'matrix') {
        let size = operands[0];
        let args = operands[1];

        let result = '\\begin{' + this.matrixEnvironment + '} ';

        for(let row = 0; row < size[1]; row += 1) {
  	for(let col = 0; col < size[2]; col += 1) {
  	  result = result + this.statement(args[row+1][col+1]);
  	  if(col < size[2]-1)
  	    result = result + ' & ';
  	}
  	if(row < size[1]-1)
  	  result = result + ' \\\\ ';
        }
        result = result + ' \\end{' + this.matrixEnvironment + '}';

        return result;

      }
      else if(operator === 'derivative_leibniz' || operator === 'partial_derivative_leibniz') {
        let deriv_symbol = "d";
        if(operator === 'partial_derivative_leibniz')
  	deriv_symbol = "\\partial ";

        let num = operands[0];
        let denom = operands[1];

        let n_deriv = 1;
        let var1 = "";
        if(Array.isArray(num)) {
  	var1 = num[1];
  	n_deriv = num[2];
        }
        else
  	var1 = num;

        let result = deriv_symbol;
        if(n_deriv > 1)
  	result = result.trimRight() + "^{" + n_deriv + "}" + this.stringConvert(var1);
        else {
  	result = result + this.stringConvert(var1);
        }

        result = "\\frac{ " +  result + " }{ ";

        let n_denom = 1;
        if(Array.isArray(denom)) {
  	n_denom = denom.length-1;
        }

        for(let i=1; i <= n_denom; i++) {
  	let denom_part = denom[i];

         let exponent = 1;
  	let var2 = "";
  	if(Array.isArray(denom_part)) {
  	  var2 = denom_part[1];
  	  exponent = denom_part[2];
  	}
  	else
  	  var2 = denom_part;

  	result = result + deriv_symbol + this.stringConvert(var2);

  	if(exponent > 1)
  	  result = result + "^{" + exponent + "}";

  	result = result + " ";

        }
        result = result + "}";
        return result;

      }
      else if (operator === 'apply') {

        if (operands[0] === 'abs') {
          return '\\left|' + this.statement(operands[1]) + '\\right|';
        }

        if (operands[0] === "factorial") {
          let result = this.factor(operands[1]);
          if (this.simple_factor_or_function_or_parens(operands[1]) ||
            (operands[1][0] === '_' && (typeof operands[1][1] === 'string'))
          )
            return result + "!";
          else
            return '\\left(' + result.toString() + '\\right)!';
        }

        if (operands[0] === 'sqrt') {
          return '\\sqrt{' + this.statement(operands[1]) + '}';
        }

        let f = this.factor(operands[0]);
        let f_args = this.statement(operands[1]);

        if (operands[1][0] !== 'tuple')
          f_args = "\\left(" + f_args + "\\right)";

        return f + f_args;
      }
      else {
        return '\\left(' + this.statement(tree) + '\\right)';
      }
    }

    factorWithParenthesesIfNegated(tree) {
      var result = this.factor(tree);

      if (result.toString().match(/^-/))
        return '\\left(' + result.toString() + '\\right)';

      // else
      return result;
    }

    termWithPlusIfNotNegated(tree) {
      var result = this.term(tree);

      if (!result.toString().match(/^-/))
        return '+ ' + result.toString();

      // else
      return result;
    }

  }

  const textToAst$2 = new textToAst();
  const astToLatex$1 = new astToLatex();

  var derivatives = {
      "sin": textToAst$2.convert('cos x'),
      "cos": textToAst$2.convert('-(sin x)'),
      "tan": textToAst$2.convert('(sec x)^2'),
      "cot": textToAst$2.convert('-((csc x)^2)'),
      "sec": textToAst$2.convert('(sec x)*(tan x)'),
      "csc": textToAst$2.convert('-(csc x)*(cot x)'),
      "sqrt": textToAst$2.convert('1/(2*sqrt(x))'),
      "log": textToAst$2.convert('1/x'),
      "ln": textToAst$2.convert('1/x'),
      "exp": textToAst$2.convert('exp(x)'),
      "arcsin": textToAst$2.convert('1/sqrt(1 - x^2)'),
      "arccos": textToAst$2.convert('-1/sqrt(1 - x^2)'),
      "arctan": textToAst$2.convert('1/(1 + x^2)'),
      "arccsc": textToAst$2.convert('-1/(sqrt(-1/x^2 + 1)*x^2)'),
      "arcsec": textToAst$2.convert('1/(sqrt(-1/x^2 + 1)*x^2)'),
      "arccot": textToAst$2.convert('-1/(1 + x^2)'),
      "abs": textToAst$2.convert('abs(x)/x'),
  };


  function derivative$2(expr_or_tree,x,story = []) {
      var tree = get_tree(expr_or_tree);

      var ddx = '\\frac{d}{d' + x + '} ';

      // Derivative of a constant
      if (typeof tree === 'number') {
  	story.push( 'The derivative of a constant is zero, that is, \\(' + ddx + astToLatex$1.convert(tree) + ' = 0\\).' );
  	return 0;
      }

      // Derivative of a more complicated constant
      if ((variables(tree)).indexOf(x) < 0) {
  	story.push( 'The derivative of a constant is zero, that is, \\(' + ddx + astToLatex$1.convert(tree) + ' = 0\\).' );
  	return 0;
      }

      // Derivative of a variable
      if (typeof tree === 'string') {
  	if (x === tree) {
  	    story.push( 'We know the derivative of the identity function is one, that is, \\(' + ddx + astToLatex$1.convert(tree) + ' = 1\\).' );
  	    return 1;
  	}

  	// should never get to this line
  	// as would have been considered a constant
  	story.push( 'As far as \\(' + astToLatex$1.convert(x) + '\\) is concerned, \\(' + astToLatex$1.convert(tree) + '\\) is constant, so ' + ddx + astToLatex$1.convert(tree) + ' = 0\\).' );
  	return 0;
      }

      var operator = tree[0];
      var operands = tree.slice(1);

      // derivative of sum is sum of derivatives
      if ((operator === '+') || (operator === '-') || (operator === '~')) {
  	story.push( 'Using the sum rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + (operands.map( function(v,i) { return ddx + astToLatex$1.convert(v); } )).join( ' + ' ) + '\\).' );
  	let result = [operator].concat( operands.map( function(v,i) { return derivative$2(v,x,story); } ) );
  	result = simplify$2(result);
  	story.push( 'So using the sum rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	return result;
      }

      // product rule
      if (operator === '*') {
  	let non_numeric_operands = [];
  	let numeric_operands = [];

  	for( let i=0; i<operands.length; i++ ) {
  	    if ((typeof operands[i] === 'number') || ((variables(operands[i])).indexOf(x) < 0)) {
  		numeric_operands.push( operands[i] );
  	    } else {
  		non_numeric_operands.push( operands[i] );
  	    }
  	}

  	if (numeric_operands.length > 0) {
  	    if (non_numeric_operands.length === 0) {
  		story.push( 'Since the derivative of a constant is zero, \\(' + ddx + astToLatex$1.convert( tree ) + ' = 0.\\)' );
  		let result = 0;
  		return result;
  	    }

  	    let remaining = ['*'].concat( non_numeric_operands );
  	    if (non_numeric_operands.length === 1)
  		remaining = non_numeric_operands[0];



  	    if (remaining === x) {
  		story.push( 'By the constant multiple rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + (numeric_operands.map( function(v,i) { return astToLatex$1.convert(v); } )).join( ' \\cdot ' ) + '\\).' );
  		let result = ['*'].concat( numeric_operands );
  		result = simplify$2(result);
  		return result;
  	    }

  	    story.push( 'By the constant multiple rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + (numeric_operands.map( function(v,i) { return astToLatex$1.convert(v); } )).join( ' \\cdot ' ) + ' \\cdot ' + ddx + '\\left(' + astToLatex$1.convert(remaining) + '\\right)\\).' );

  	    let d = derivative$2(remaining,x,story);
  	    let result = ['*'].concat( numeric_operands.concat( [d] ) );
  	    result = simplify$2(result);
  	    story.push( 'And so \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	}

  	story.push( 'Using the product rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' +
  		    (operands.map( function(v,i) {
  			return (operands.map( function(w,j) {
  			    if (i === j)
  				return ddx + '\\left(' + astToLatex$1.convert(v) + '\\right)';
  			    else
  				return astToLatex$1.convert(w);
  			})).join( ' \\cdot ' ) })).join( ' + ' ) + '\\).' );

  	let inner_operands = operands.slice();

  	let result = ['+'].concat( operands.map( function(v,i) {
  	    return ['*'].concat( inner_operands.map( function(w,j) {
  		if (i === j) {
  		    let d = derivative$2(w,x,story);
  		    // remove terms that have derivative 1
  		    if (d === 1)
  			return null;

  		    return d;
  		} else {
  		    return w;
  		}
  	    } ).filter( function(t) { return t != null; } ) );
  	} ) );
  	result = simplify$2(result);
  	story.push( 'So using the product rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );

  	return result;
      }

      // quotient rule
      if (operator === '/') {
  	let f = operands[0];
  	let g = operands[1];

  	if ((variables(g)).indexOf(x) < 0) {
  	    story.push( 'By the constant multiple rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(['/', 1, g]) + ' \\cdot ' + ddx + '\\left(' + astToLatex$1.convert(f) + '\\right)\\).' );

  	    let df = derivative$2(f,x,story);
  	    let quotient_rule = textToAst$2.convert('(1/g)*d');
  	    let result = substitute( quotient_rule, { "d": df, "g": g } );
  	    result = simplify$2(result);
  	    story.push( 'So \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );

  	    return result;
  	}

  	if ((variables(f)).indexOf(x) < 0) {
  	    if (f !== 1) {
  		story.push( 'By the constant multiple rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(f) + ' \\cdot ' + ddx + '\\left(' + astToLatex$1.convert(['/',1,g]) + '\\right)\\).' );
  	    }

  	    story.push( 'Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(f) + '\\cdot \\frac{-1}{ ' + astToLatex$1.convert(g) + '^2} \\cdot ' + ddx + astToLatex$1.convert( g ) + "\\)." );

  	    let a = derivative$2(g,x,story);

  	    let quotient_rule = textToAst$2.convert('f * (-a/(g^2))');
  	    let result = substitute( quotient_rule, { "f": f, "a": a, "g": g } );
  	    result = simplify$2(result);
  	    story.push( 'So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );

  	    return result;
  	}

  	story.push( 'Using the quotient rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = \\frac{' + ddx + '\\left(' + astToLatex$1.convert(f) + '\\right) \\cdot ' + astToLatex$1.convert(g) + ' - ' + astToLatex$1.convert(f) + '\\cdot ' + ddx + '\\left(' + astToLatex$1.convert(g) + '\\right)}{ \\left( ' + astToLatex$1.convert(g) + ' \\right)^2} \\).' );

  	let a = derivative$2(f,x,story);
  	let b = derivative$2(g,x,story);

  	let quotient_rule = textToAst$2.convert('(a * g - f * b)/(g^2)');

  	let result = substitute( quotient_rule, { "a": a, "b": b, "f": f, "g": g } );
  	result = simplify$2(result);
  	story.push( 'So using the quotient rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );

  	return result;
      }

      // power rule
      if (operator === '^') {
  	let base = operands[0];
  	let exponent = operands[1];

  	if ((variables(exponent)).indexOf(x) < 0) {
  	    if ((typeof base === 'string') && (base === 'x')) {
  		if (typeof exponent === 'number') {
  		    let power_rule = textToAst$2.convert('n * (f^m)');
  		    let result = substitute( power_rule, { "n": exponent, "m": exponent - 1, "f": base } );
  		    result = simplify$2(result);
  		    story.push( 'By the power rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( exponent ) + ' \\cdot \\left(' + astToLatex$1.convert( base ) + '\\right)^{' + astToLatex$1.convert( ['-', exponent, 1] ) + '}\\).' );
  		    return result;
  		}

  		let power_rule = textToAst$2.convert('n * (f^(n-1))');
  		let result = substitute( power_rule, { "n": exponent, "f": base } );
  		result = simplify$2(result);
  		story.push( 'By the power rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( exponent ) + ' \\cdot \\left(' + astToLatex$1.convert( base ) + '\\right)^{' + astToLatex$1.convert( ['-', exponent, 1] ) + '}\\).' );

  		return result;
  	    }

  	    if (exponent !== 1) {
  		story.push( 'By the power rule and the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( exponent ) + ' \\cdot \\left(' + astToLatex$1.convert( base ) + '\\right)^{' + astToLatex$1.convert( ['-', exponent, 1] ) + '} \\cdot ' + ddx + astToLatex$1.convert( base ) + '\\).' );
  	    }

  	    let a = derivative$2(base,x,story);

  	    if (exponent === 1)
  		return a;

  	    if (typeof exponent === 'number') {
  		let power_rule = textToAst$2.convert('n * (f^m) * a');
  		let result = substitute( power_rule, { "n": exponent, "m": exponent - 1, "f": base, "a" : a } );
  		result = simplify$2(result);
  		story.push( 'So by the power rule and the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  		return result;
  	    }

  	    let power_rule = textToAst$2.convert('n * (f^(n-1)) * a');
  	    let result = substitute( power_rule, { "n": exponent, "f": base, "a" : a } );
  	    result = simplify$2(result);
  	    story.push( 'So by the power rule and the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	}

  	if (base === 'e' && math$19.define_e) {
  	    if ((typeof exponent === 'string') && (exponent === x)) {
  		let power_rule = textToAst$2.convert('e^(f)');
  		let result = substitute( power_rule, { "f": exponent } );
  		result = simplify$2(result);
  		story.push( 'The derivative of \\(e^' + astToLatex$1.convert( x ) + '\\) is itself, that is, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( tree ) + '\\).' );

  		return result;
  	    }

  	    story.push( 'Using the rule for \\(e^x\\) and the chain rule, we know \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( tree ) + ' \\cdot ' + ddx + astToLatex$1.convert( exponent ) + '\\).' );

  	    let power_rule = textToAst$2.convert('e^(f)*d');

  	    let d = derivative$2(exponent,x,story);
  	    let result = substitute( power_rule, { "f": exponent, "d": d } );
  	    result = simplify$2(result);
  	    story.push( 'So using the rule for \\(e^x\\) and the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	}

  	if (typeof base === 'number') {
  	    if ((typeof exponent === 'string') && (exponent === x)) {
  		let power_rule = textToAst$2.convert('a^(f) * log(a)');
  		let result = substitute( power_rule, { "a": base, "f": exponent } );
  		result = simplify$2(result);
  		story.push( 'The derivative of \\(a^' + astToLatex$1.convert( x ) + '\\) is \\(a^{' + astToLatex$1.convert( x ) + '} \\, \\log a\\), that is, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( result ) + '\\).' );

  		return result;
  	    }

  	    let exp_rule = textToAst$2.convert('a^(f) * log(a)');
  	    let partial_result = substitute( exp_rule, { "a": base, "f": exponent } );

  	    story.push( 'Using the rule for \\(a^x\\) and the chain rule, we know \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert( partial_result ) + ' \\cdot ' + ddx + astToLatex$1.convert( exponent ) + '\\).' );

  	    let power_rule = textToAst$2.convert('a^(b)*log(a)*d');
  	    let d = derivative$2(exponent,x,story);
  	    let result = substitute( power_rule, { "a": base, "b": exponent, "d": d } );
  	    result = simplify$2(result);
  	    story.push( 'So using the rule for \\(a^x\\) and the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	}

  	// general case of a function raised to a function
  	let f = base;
  	let g = exponent;

  	story.push( "Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = " +  astToLatex$1.convert( f ) + "\\) and \\(v(x) = " + astToLatex$1.convert( g ) + "\\)." );

  	let a = derivative$2(f,x,story);
  	let b = derivative$2(g,x,story);

  	let power_rule = textToAst$2.convert('(f^g)*(b * log(f) + (g * a)/f)');
  	let result = substitute( power_rule, { "a": a, "b": b, "f": f, "g": g } );
  	result = simplify$2(result);
  	story.push( 'So by the general rule for exponents, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	return result;
      }

      if (operator === "apply" && !(operands[0] in derivatives)) {
  	// derivative of function whose derivative is not given

  	let input = operands[1];

  	story.push( 'By the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(substitute( ["apply",operands[0] + "'","x"], { "x": input } )) + " \\cdot " + ddx + astToLatex$1.convert(input)  + '\\).' );

  	let result = ['*',
  		      substitute( ["apply",operands[0] + "'","x"], { "x": input } ),
  		      derivative$2( input, x, story )];
  	result = simplify$2(result);
  	story.push( 'So by the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	return result;
      }

      // chain rule
      if ((operator === "apply" && operands[0] in derivatives) ||
  	operator in derivatives) {

  	let used_apply = false;
  	if(operator === "apply") {
  	    operator = operands[0];
  	    operands = operands.slice(1);
  	    used_apply = true;
  	}

  	let input = operands[0];

  	if (typeof input === "number") {
  	    let result = 0;
  	    story.push( 'The derivative of a constant is zero so \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	} else if ((typeof input === "string") && (input === x)) {
  	    let result = ['*',
  			  substitute( derivatives[operator], { "x": input } )];
  	    result = simplify$2(result);
  	    story.push( 'It is the case that \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	} else if ((typeof input === "string") && (input !== x)) {
  	    let result = 0;
  	    story.push( 'Since the derivative of a constant is zero, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	} else {
  	    let example_ast = [operator,'u'];
  	    if(used_apply)
  		example_ast = ["apply"].concat(example_ast);
  	    story.push( 'Recall \\(\\frac{d}{du}' + astToLatex$1.convert( example_ast ) + ' = ' +
  			astToLatex$1.convert( derivative$2( example_ast, 'u', [] ) ) + '\\).' );

  	    story.push( 'By the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(substitute( derivatives[operator], { "x": input } )) + " \\cdot " + ddx + astToLatex$1.convert(input)  + '\\).' );

  	    let result = ['*',
  			  substitute( derivatives[operator], { "x": input } ),
  			  derivative$2( input, x, story )];
  	    result = simplify$2(result);
  	    story.push( 'So by the chain rule, \\(' + ddx + astToLatex$1.convert( tree ) + ' = ' + astToLatex$1.convert(result) + '\\).' );
  	    return result;
  	}
      }

      return 0;
  }

  /****************************************************************/
  //
  // The "story" that the differentiation code produces can be somewhat repetitive
  //
  // Here we fix this
  //

  function lowercaseFirstLetter(string)
  {
      return string.charAt(0).toLowerCase() + string.slice(1);
  }

  function simplify_story( story ) {
      // remove neighboring duplicates
      for (let i = story.length - 1; i >= 1; i--) {
  	if (story[i] === story[i-1])
  	    story.splice( i, 1 );
      }

      // Make it seem obvious that I know I am repeating myself
      for (let i = 0; i < story.length; i++ ) {
  	for( let j = i + 1; j < story.length; j++ ) {
  	    if (story[i] === story[j]) {
  		story[j] = 'Again, ' + lowercaseFirstLetter( story[j] );
  	    }
  	}
      }

      return story;
  }


  function derivative_story(expr, x) {
      var story = [];
      derivative$2( expr, x, story );
      story = simplify_story( story );
      return story;
  }
  const derivativeStory = derivative_story;

  var differentiation = /*#__PURE__*/Object.freeze({
    derivative: derivative$2,
    derivative_story: derivative_story,
    derivativeStory: derivativeStory
  });

  /*
   * convert syntax trees back to string representations
   *
   * Copyright 2014-2017 by
   *  Jim Fowler <kisonecat@gmail.com>
   *  Duane Nykamp <nykamp@umn.edu>
   *
   * This file is part of a math-expressions library
   *
   * math-expressions is free software: you can redistribute
   * it and/or modify it under the terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */


  const unicode_operators = {
      "+": function(operands) { return operands.join( ' ' ); },
      "-": function(operands) { return "- " + operands[0]; },
      "*": function(operands) { return operands.join( " " ); },
      "/": function(operands) { return operands[0] + "/" + operands[1]; },
      "_": function(operands) { return operands[0]  + "_" + operands[1]; },
      "^": function(operands) { return operands[0]  + "^" + operands[1]; },
      "prime": function(operands) { return operands[0] + "'"; },
      "tuple": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "array": function(operands) { return '[ ' + operands.join( ', ' ) + ' ]';},
      "list": function(operands) { return operands.join( ', ' );},
      "set": function(operands) { return '{ ' + operands.join( ', ' ) + ' }';},
      "vector": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "interval": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "matrix": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "and": function(operands) { return operands.join( ' and ' );},
      "or": function(operands) { return operands.join( ' or ' );},
      "not": function(operands) { return 'not ' + operands[0]; },
      "=": function(operands) { return operands.join( ' = ' );},
      "<": function(operands) { return operands.join( ' < ' );},
      ">": function(operands) { return operands.join( ' > ' );},
      "lts": function(operands) { return operands.join( ' < ' );},
      "gts": function(operands) { return operands.join( ' > ' );},

      "le": function(operands) { return operands.join( ' ≤ ' );},
      "ge": function(operands) { return operands.join( ' ≥ ' );},
      "ne": function(operands) { return operands.join( ' ≠ ' );},
      "in": function(operands) { return operands[0] + " ∈ " + operands[1]; },
      "notin": function(operands) { return operands[0] + " ∉ " + operands[1]; },
      "ni": function(operands) { return operands[0] + " ∋ " + operands[1]; },
      "notni": function(operands) { return operands[0] + " ∌ " + operands[1]; },
      "subset": function(operands) { return operands[0] + " ⊂ " + operands[1]; },
      "notsubset": function(operands) { return operands[0] + " ⊄ " + operands[1]; },
      "superset": function(operands) { return operands[0] + " ⊃ " + operands[1]; },
      "notsuperset": function(operands) { return operands[0] + " ⊅ " + operands[1]; },
      "union": function (operands) { return operands.join(' ∪ '); },
      "intersect": function (operands) { return operands.join(' ∩ '); },
      "derivative_leibniz": function (operands) { return "d" + operands[0] + "/d" + operands[1]; },
      "partial_derivative_leibniz": function (operands) { return "∂" + operands[0] + "/∂" + operands[1]; },
      "|": function (operands) { return operands[0] + " | " + operands[1]; },
      ":": function (operands) { return operands[0] + " : " + operands[1]; },

  };

  const nonunicode_operators = {
      "+": function(operands) { return operands.join( ' ' ); },
      "-": function(operands) { return "- " + operands[0]; },
      "*": function(operands) { return operands.join( " " ); },
      "/": function(operands) { return operands[0] + "/" + operands[1]; },
      "_": function(operands) { return operands[0]  + "_" + operands[1]; },
      "^": function(operands) { return operands[0]  + "^" + operands[1]; },
      "prime": function(operands) { return operands[0] + "'"; },
      "tuple": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "array": function(operands) { return '[ ' + operands.join( ', ' ) + ' ]';},
      "list": function(operands) { return operands.join( ', ' );},
      "set": function(operands) { return '{ ' + operands.join( ', ' ) + ' }';},
      "vector": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "interval": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "matrix": function(operands) { return '( ' + operands.join( ', ' ) + ' )';},
      "and": function(operands) { return operands.join( ' and ' );},
      "or": function(operands) { return operands.join( ' or ' );},
      "not": function(operands) { return 'not ' + operands[0]; },
      "=": function(operands) { return operands.join( ' = ' );},
      "<": function(operands) { return operands.join( ' < ' );},
      ">": function(operands) { return operands.join( ' > ' );},
      "lts": function(operands) { return operands.join( ' < ' );},
      "gts": function(operands) { return operands.join( ' > ' );},

      "le": function(operands) { return operands.join( ' <= ' );},
      "ge": function(operands) { return operands.join( ' >= ' );},
      "ne": function(operands) { return operands.join( ' ne ' );},
      "in": function(operands) { return operands[0] + " elementof " + operands[1]; },
      "notin": function(operands) { return operands[0] + " notelementof " + operands[1]; },
      "ni": function(operands) { return operands[0] + " containselement " + operands[1]; },
      "notni": function(operands) { return operands[0] + " notcontainselement " + operands[1]; },
      "subset": function(operands) { return operands[0] + " subset " + operands[1]; },
      "notsubset": function(operands) { return operands[0] + " notsubset " + operands[1]; },
      "superset": function(operands) { return operands[0] + " superset " + operands[1]; },
      "notsuperset": function(operands) { return operands[0] + " notsuperset " + operands[1]; },
      "union": function (operands) { return operands.join(' union '); },
      "intersect": function (operands) { return operands.join(' intersect '); },
      "derivative_leibniz": function (operands) { return "d" + operands[0] + "/d" + operands[1]; },
      "partial_derivative_leibniz": function (operands) { return "∂" + operands[0] + "/∂" + operands[1]; },
      "|": function (operands) { return operands[0] + " | " + operands[1]; },
      ":": function (operands) { return operands[0] + " : " + operands[1]; },
  };


  const output_unicodeDefault = true;


  class astToText {
    constructor({
      output_unicode = output_unicodeDefault
    } = {}) {
      this.output_unicode = output_unicode;
      this.operators = unicode_operators;
      if(!output_unicode){ this.operators = nonunicode_operators;}
    }

    convert(tree) {
        return this.statement(tree);
    }

   statement(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
  	return this.single_statement(tree);
      }

      let operator = tree[0];
      let operands = tree.slice(1);

     if(operator === 'ldots')
       return '...';

      if((!(operator in this.operators)) && operator!=="apply")
  	throw new Error("Badly formed ast: operator " + operator + " not recognized.");

      if (operator === 'and' || operator === 'or')  {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    let result = this.single_statement(v);
  	    // for clarity, add parenthesis unless result is
  	    // single quantity (with no spaces) or already has parens
  	    if (result.toString().match(/ /)
  		&& (!(result.toString().match(/^\(.*\)$/))))
  		return '(' + result  + ')';
  	    else
  		return result;
  	}.bind(this)));
      }
      return this.single_statement(tree);
  }

   single_statement(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
  	return this.expression(tree);
      }

      let operator = tree[0];
      let operands = tree.slice(1);

      if (operator === 'not') {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    let result = this.single_statement(v);
  	    // for clarity, add parenthesis unless result is
  	    // single quantity (with no spaces) or already has parens
  	    if (result.toString().match(/ /)
  		&& (!(result.toString().match(/^\(.*\)$/))))
  		return '(' + result  + ')';
  	    else
  		return result;
  	}.bind(this)));
      }

      if((operator === '=') || (operator === 'ne')
         || (operator === '<') || (operator === '>')
         || (operator === 'le') || (operator === 'ge')
         || (operator === 'in') || (operator === 'notin')
         || (operator === 'ni') || (operator === 'notni')
         || (operator === 'subset') || (operator === 'notsubset')
         || (operator === 'superset') || (operator === 'notsuperset')) {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    return this.expression(v);
  	}.bind(this)));
      }

      if(operator === 'lts' || operator === 'gts') {
  	let args = operands[0];
  	let strict = operands[1];

  	if(args[0] !== 'tuple' || strict[0] !== 'tuple')
  	    // something wrong if args or strict are not tuples
  	    throw new Error("Badly formed ast");

  	let result = this.expression(args[1]);
  	for(let i=1; i< args.length-1; i++) {
  	    if(strict[i]) {
  		if(operator === 'lts')
  		    result += " < ";
  		else
  		    result += " > ";
  	    }
  	    else {
  		if(operator === 'lts') {
  		    if(this.output_unicode)
  			result += " ≤ ";
  		    else
  			result += " <= ";
  		}
  		else {
  		    if(this.output_unicode)
  			result += " ≥ ";
  		    else
  			result += " >= ";
  		}
  	    }
  	    result += this.expression(args[i+1]);
  	}
  	return result;
      }

      return this.expression(tree);
  }

   expression(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
  	return this.term(tree);
      }

      let operator = tree[0];
      let operands = tree.slice(1);

      if (operator === '+') {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    if(i>0)
  		return this.termWithPlusIfNotNegated(v);
  	    else
  		return this.term(v);
  	}.bind(this) ));
      }

      if ((operator === 'union') || (operator === 'intersect')) {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    return this.term(v);
  	}.bind(this)));
      }

      return this.term(tree);
  }

   term(tree) {
      if ((typeof tree === 'string') || (typeof tree === 'number')) {
  	return this.factor(tree);
      }

      let operator = tree[0];
      let operands = tree.slice(1);

      if (operator === '-') {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    return this.term(v);
  	}.bind(this)));
      }
      if (operator === '*') {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    let result;
  	    if(i > 0) {
  		result = this.factorWithParenthesesIfNegated(v);
  		if (result.toString().match( /^[0-9]/ ))
  		    return '* ' + result;
  		else
  		    return result
  	    }
  	    else
  		return this.factor(v);
  	}.bind(this)));
      }

      if (operator === '/') {
  	return this.operators[operator]( operands.map( function(v,i) { return this.factor(v); }.bind(this) ) );
      }

      return this.factor(tree);
  }

   symbolConvert(symbol) {
      let symbolConversions= {
  	'alpha': 'α',
  	'beta': 'β',
  	'Gamma': 'Γ',
  	'gamma': 'γ',
  	'Delta': 'Δ',
  	'delta': 'δ',
  	'epsilon': 'ε',
  	'zeta': 'ζ',
  	'eta': 'η',
  	'Theta': 'ϴ',
  	'theta': 'θ',
  	'iota': 'ι',
  	'kappa': 'κ',
  	'Lambda': 'Λ',
  	'lambda': 'λ',
  	'mu': 'μ',
  	'nu': 'ν',
  	'Xi': 'Ξ',
  	'xi': 'ξ',
  	'Pi': 'Π',
  	'pi': 'π',
  	'rho': 'ρ',
  	'Sigma': 'Σ',
  	'sigma': 'σ',
  	'tau': 'τ',
  	'Upsilon': 'Υ',
  	'upsilon': 'υ',
  	'Phi': 'Φ',
  	'phi': 'ϕ',
  	'Psi': 'Ψ',
  	'psi': 'ψ',
  	'Omega': 'Ω',
  	'omega': 'ω',
      };
      if (this.output_unicode && (symbol in symbolConversions))
  	return symbolConversions[symbol];
      else
  	return symbol
  }

    simple_factor_or_function_or_parens(tree) {
      // return true if
      // factor(tree) is a single character
      // or tree is a non-negative number not in scientific notation
      // or tree is a string
      // or tree is a function call
      // or factor(tree) is in parens

      let result = this.factor(tree);

      if (result.toString().length === 1
        || (typeof tree === 'string')
        || (tree[0] === 'apply')
        || result.toString().match(/^\(.*\)$/)
      ) {
        return true;
      } else if (typeof tree === 'number') {
        if (tree >= 0 && !tree.toString().includes('e')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false
      }
    }

   factor(tree) {
      if (typeof tree === 'string') {
  	return this.symbolConvert(tree);
      }

      if (typeof tree === 'number') {
        if(tree === Infinity) {
          if(this.output_unicode) {
            return '∞';
          }
          else {
            return 'infinity';
          }
        }
        else if(tree === -Infinity) {
          if(this.output_unicode) {
            return '-∞';
          }
          else {
            return '-infinity';
          }
        }
        else {
          let numberString = tree.toString();
          let eIndex = numberString.indexOf('e');
          if(eIndex === -1) {
            return numberString;
          }
          let num = numberString.substring(0,eIndex);
          let exponent = numberString.substring(eIndex+1);
          if(exponent[0] === "+") {
            return num + " * 10^" + exponent.substring(1);
          } else {
            return num + " * 10^(" + exponent + ")";
          }
        }
      }

      let operator = tree[0];
      let operands = tree.slice(1);

      if (operator === "^") {
  	let operand0 = this.factor(operands[0]);

  	// so that f_(st)'^2(x) doesn't get extra parentheses
  	// (and no longer recognized as function call)
  	// check for simple factor after removing primes
  	let remove_primes = operands[0];
  	while(remove_primes[0] === 'prime') {
  	    remove_primes=remove_primes[1];
  	}

  	if(!(this.simple_factor_or_function_or_parens(remove_primes) ||
  	     (remove_primes[0] === '_' &&  (typeof remove_primes[1] === 'string'))
  	    ))
  	    operand0 = '(' + operand0.toString() + ')';

  	let operand1 = this.factor(operands[1]);
  	if(!(this.simple_factor_or_function_or_parens(operands[1])))
  	    operand1 = '(' + operand1.toString() + ')';

  	return operand0 + '^' + operand1;
      }
      else if (operator === "_") {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    let result = this.factor(v);
  	    if(this.simple_factor_or_function_or_parens(v))
  		return result;
  	    else
  		return '(' + result.toString() + ')';
  	}.bind(this)));
      }
      else if(operator === "prime") {
  	let op = operands[0];

  	let n_primes=1;
  	while(op[0] === "prime") {
  	    n_primes+=1;
  	    op=op[1];
  	}

  	let result = this.factor(op);

  	if (!(this.simple_factor_or_function_or_parens(op) ||
  	      (op[0] === '_' &&  (typeof op[1] === 'string'))
  	     ))
  	    result = '(' + result.toString() + ')';
  	for(let i=0; i<n_primes; i++) {
  	    result += "'";
  	}
  	return result;
      }
      else if(operator === "-") {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    return this.factor(v);
  	}.bind(this)));
      }
      else if(operator === 'tuple' || operator === 'array'
  	    || operator === 'list'
  	    || operator === 'set' || operator === 'vector'
  	    || operator === '|' || operator === ':') {
  	return this.operators[operator]( operands.map( function(v,i) {
  	    return this.statement(v);
  	}.bind(this)));

      }
      else if(operator === 'interval') {

  	let args = operands[0];
  	let closed = operands[1];
  	if(args[0] !== 'tuple' || closed[0] !== 'tuple')
  	    throw new Error("Badly formed ast");

  	let result = this.statement(args[1]) + ", "
  	    + this.statement(args[2]);

  	if(closed[1])
  	    result = '[ ' + result;
  	else
  	    result = '( ' + result;

  	if(closed[2])
  	    result = result + ' ]';
  	else
  	    result = result + ' )';

  	return result;

      }
     else if(operator === 'matrix') {
       let size = operands[0];
        let args = operands[1];

       let result = '[ ';

       for(let row = 0; row < size[1]; row += 1) {
         result = result + '[ ';
  	for(let col = 0; col < size[2]; col += 1) {
  	  result = result + this.statement(args[row+1][col+1]);
  	  if(col < size[2]-1)
  	    result = result + ',';
  	  result = result + ' ';
  	}
  	result = result + ']';
         	if(row < size[1]-1)
  	  result = result + ",";
         result = result + ' ';
        }
       result = result + ']';

       return result;

     }
     else if(operator === 'derivative_leibniz' || operator === 'partial_derivative_leibniz') {
       let deriv_symbol = "d";
       if(operator === 'partial_derivative_leibniz')
         deriv_symbol = "∂";

       let num = operands[0];
       let denom = operands[1];

       let n_deriv = 1;
       let var1 = "";
       if(Array.isArray(num)) {
         var1 = num[1];
         n_deriv = num[2];
       }
       else
         var1 = num;

       let result = deriv_symbol;
       if(n_deriv > 1)
         result = result + "^" + n_deriv;
       result = result + this.symbolConvert(var1) + "/";

       let n_denom = 1;
       if(Array.isArray(denom)) {
         n_denom = denom.length-1;
       }

       for(let i=1; i <= n_denom; i++) {
         let denom_part = denom[i];

         let exponent = 1;
         let var2 = "";
         if(Array.isArray(denom_part)) {
  	 var2 = denom_part[1];
  	 exponent = denom_part[2];
         }
         else
  	 var2 = denom_part;

         result = result + deriv_symbol + this.symbolConvert(var2);

         if(exponent > 1)
  	 result = result + "^" + exponent;

       }
       return result;

     }
     else if(operator === 'apply'){

  	if(operands[0] === 'abs') {
  	    return '|' + this.statement(operands[1]) + '|';
  	}

  	if (operands[0] === "factorial") {
  	    let result = this.factor(operands[1]);
  	    if(this.simple_factor_or_function_or_parens(operands[1]) ||
  	       (operands[1][0] === '_' &&  (typeof operands[1][1] === 'string'))
  	      )
  		return result + "!";
  	    else
  		return '(' + result.toString() + ')!';

  	}

  	let f = this.factor(operands[0]);
  	let f_args = this.statement(operands[1]);

  	if(operands[1][0] !== 'tuple')
  	    f_args = "(" + f_args + ")";

  	return f+f_args;
      }
      else {
  	return '(' + this.statement(tree) + ')';
      }
  }

   factorWithParenthesesIfNegated(tree){
      let result = this.factor(tree);

      if (result.toString().match( /^-/ ))
  	return '(' + result.toString() + ')';

      // else
      return result;
  }

   termWithPlusIfNotNegated(tree){
      let result = this.term(tree);

      if (!result.toString().match( /^-/ ))
  	return '+ ' + result.toString();

      // else
      return result;
  }

  }

  var astToText$1 = new astToText();

  function subscripts_to_strings(expr_or_tree, force=false) {
    // convert ['_', a,b] to string
    // if force is set, perform conversions for any values of a or b
    // otherwise (the default), perform conversion only
    // when both a and b are strings or numbers

    var tree = get_tree(expr_or_tree);

    if(!Array.isArray(tree)) {
      return tree;
    }
    
    let operator = tree[0];
    let operands = tree.slice(1);
    
    if(operator === '_') {
      if(force || operands.every(x => ['number', 'string'].includes(typeof x))) {
        return astToText$1.convert(tree);
      }
    }

    return [operator].concat(operands.map(x => subscripts_to_strings(x,force)));
  }



  function strings_to_subscripts(expr_or_tree) {
    // convert string 'a_b' to ['_', 'a','b'] and string 'a_1' to ['_', 'a', 1]

    var tree = get_tree(expr_or_tree);

    if(typeof tree === "string") {
      let res = tree.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
      if(res) {
        let base = Number(res[1]);
        if(isNaN(base)) {
          base = res[1];
        }
        let sub = Number(res[2]);
        if(isNaN(sub)) {
          sub = res[2];
        }
        return ['_', base, sub]
      }else {
        return tree;
      }
    }

    if(!Array.isArray(tree)) {
      return tree;
    }
    
    let operator = tree[0];
    let operands = tree.slice(1);
    
    return [operator].concat(operands.map(strings_to_subscripts));
  }



  var normalization = /*#__PURE__*/Object.freeze({
    normalize_function_names: normalize_function_names,
    normalize_applied_functions: normalize_applied_functions,
    substitute_abs: substitute_abs,
    default_order: default_order,
    constants_to_floats: constants_to_floats,
    tuples_to_vectors: tuples_to_vectors,
    to_intervals: to_intervals,
    subscripts_to_strings: subscripts_to_strings,
    strings_to_subscripts: strings_to_subscripts
  });

  const equalUpToSign = function(expression, correct) {
      var root = expression.tree;
      var stack = [[root]];
      var pointer = 0;
      var tree;
      var i;

      /* Unfortunately the root is handled separately */
      expression.tree = ['-', root];
      var equals = expression.equals(correct);
      expression.tree = root;

      if (equals) return true;

      while (tree = stack[pointer++]) {
  	tree = tree[0];

  	if (typeof tree === 'number') {
  	    continue;
  	}

  	if (typeof tree === 'string') {
  	    continue;
  	}

  	for (i = 1; i < tree.length; i++) {
              stack.push([tree[i]]);
  	    tree[i] = ['-', tree[i]];
  	    equals = expression.equals(correct);
  	    tree[i] = tree[i][1];

  	    if (equals) return true;
  	}
      }

      return false;
  };

  var sign_error = /*#__PURE__*/Object.freeze({
    equalUpToSign: equalUpToSign
  });

  function add$2(expr_or_tree1, expr_or_tree2) {
      var result = ['+', get_tree(expr_or_tree1), get_tree(expr_or_tree2)];
      return clean(result);
  }

  function subtract$2(expr_or_tree1, expr_or_tree2) {
      var result = ['+', get_tree(expr_or_tree1), ['-', get_tree(expr_or_tree2)]];
      return clean(result);
  }

  function multiply$2(expr_or_tree1, expr_or_tree2) {
      var result = ['*', get_tree(expr_or_tree1), get_tree(expr_or_tree2)];
      return clean(result);
  }

  function divide$2(expr_or_tree1, expr_or_tree2) {
      var result = ['/', get_tree(expr_or_tree1), get_tree(expr_or_tree2)];
      return clean(result);
  }

  function pow$2(expr_or_tree1, expr_or_tree2) {
      var result = ['^', get_tree(expr_or_tree1), get_tree(expr_or_tree2)];
      return clean(result);
  }

  function mod$2(expr_or_tree1, expr_or_tree2) {
      var result = ['apply', 'mod', ['tuple', get_tree(expr_or_tree1),
  				   get_tree(expr_or_tree2)]];
      return clean(result);
  }

  function copy(expr_or_tree) {
    return get_tree(expr_or_tree);
  }

  var arithmetic$1 = /*#__PURE__*/Object.freeze({
    add: add$2,
    subtract: subtract$2,
    multiply: multiply$2,
    divide: divide$2,
    pow: pow$2,
    mod: mod$2,
    copy: copy
  });

  var analytic_operators = ['+', '-', '*', '/', '^', 'tuple', 'vector', 'list', 'array', 'matrix', 'interval'];
  var analytic_functions = ["exp", "log", "log10", "sqrt", "factorial", "gamma", "erf", "acos", "acosh", "acot", "acoth", "acsc", "acsch", "asec", "asech", "asin", "asinh", "atan", "atanh", "cos", "cosh", "cot", "coth", "csc", "csch", "sec", "sech", "sin", "sinh", "tan", "tanh", 'arcsin', 'arccos', 'arctan', 'arccsc', 'arcsec', 'arccot', 'cosec'];
  var relation_operators = ['=', 'le', 'ge', '<', '>'];

  function isAnalytic(expr_or_tree, { allow_abs = false, allow_relation = false } = {}) {

    var tree = normalize_applied_functions(
      normalize_function_names(expr_or_tree));

    tree = subscripts_to_strings(tree);

    var operators_found = operators$1(tree);
    for (let i = 0; i < operators_found.length; i++) {
      let oper = operators_found[i];
      if (analytic_operators.indexOf(oper) === -1) {
        if (allow_relation) {
          if (relation_operators.indexOf(oper) === -1) {
            return false;
          }
        } else {
          return false;
        }
      }
    }

    var functions_found = functions(tree);
    for (let i = 0; i < functions_found.length; i++) {
      let fun = functions_found[i];
      if (analytic_functions.indexOf(fun) === -1) {
        if ((!allow_abs) || fun !== "abs")
          return false;
      }
    }

    return true;
  }

  var analytic = /*#__PURE__*/Object.freeze({
    isAnalytic: isAnalytic
  });

  function create_discrete_infinite_set({
    offsets,
    periods,
    min_index = ['-', Infinity],
    max_index = Infinity,
  } = {}) {

    offsets = get_tree(offsets);
    periods = get_tree(periods);
    min_index = get_tree(min_index);
    max_index = get_tree(max_index);



    if(offsets === undefined || periods === undefined)
      return undefined;

    let results = [];
    if(offsets[0] === 'list') {
      if(periods[0] === 'list') {
        if(offsets.length !== periods.length || offsets.length === 1)
          return undefined;
        for(let i=1; i<offsets.length; i++)
          results.push(['tuple', offsets[i], periods[i], min_index, max_index]);
      }
      else {
        for(let i=1; i<offsets.length; i++)
          results.push(['tuple', offsets[i], periods, min_index, max_index]);
      }
    }
    else {
      results.push(['tuple', offsets, periods, min_index, max_index]);

    }
    return ['discrete_infinite_set'].concat(results);
  }

  var sets = /*#__PURE__*/Object.freeze({
    create_discrete_infinite_set: create_discrete_infinite_set
  });

  function tuple(entries){
      var expression=[];
      expression.push('tuple');
      var len = entries.length;
      for (let i = 0; i < len; i++){
          expression.push(entries[i]);
      }
      return expression;
  }

  function matrix$4(entries){       //entries is an array of arrays of math expressions
      var expression=[];
      expression.push('matrix');
      var r = entries.length;
      var c = entries[0].length;
      for (let i = 1; i < r; i++){
          if (entries[i].length !== c){      //check if columns are equal size
              throw new Error("Matrix dimensions mismatch");
          }
      }
      expression.push(tuple([r,c]));
      let theMatrix = [];
      for (let j = 0; j < r; j++){
          theMatrix.push(tuple(entries[j].map(function(v) {return v.tree;})));
      }
      expression.push(tuple(theMatrix));
      return expression;
  }

  function vector_add(v1, v2){
      v1 = get_tree(v1);
      v2 = get_tree(v2);
      
      if(v1.length !== v2.length || (v1[0] !== 'tuple' && v1[0] !== 'vector') || (v2[0] !== 'tuple' && v2[0] !== 'vector')) {
          throw new Error("Can't add. Those aren't vectors, or the dimensions don't match");
      }
      var v_sum = ['vector'];
      var len = v1.length;
      for (let i = 1; i < len; i = i+1){
          v_sum.push(['+', v1[i], v2[i]]);
      }
      return simplify$2(v_sum);
  }

  function scalar_mul(k, v){
      v = get_tree(v);
      
      if(v[0] !== 'tuple' && v[0] !== 'vector'){
          throw new Error("Can't scalar multiply. Isn't a vector");
      }
      var v_prod = ['vector'];
      var len = v.length;
      for (let i = 1; i < len; i = i+1){
          v_prod.push(['*', v[i], k]);
      }
      return simplify$2(v_prod);
  }

  function vector_sub(v1, v2){
      return vector_add(v1, scalar_mul(-1, v2));
  }

  function dot_prod(v1, v2){
      v1 = get_tree(v1);
      v2 = get_tree(v2);
      
      if(v1.length !== v2.length || (v1[0] !== 'tuple' && v1[0] !== 'vector') || (v2[0] !== 'tuple' && v2[0] !== 'vector')) {
          throw new Error("Can't take dot product. Those aren't vectors, or the dimensions don't match");
      }
      var sum = 0;
      var term = 0;
      var len = v1.length;
      for (let i = 1; i < len; i = i+1){
          term = ['*', v1[i], v2[i]];
          sum = ['+', sum, term];
      }
      return simplify$2(sum);
  }

  function cross_prod(v1, v2){
      v1 = get_tree(v1);
      v2 = get_tree(v2);
      
      if((v1[0] !== 'tuple' && v1[0] !== 'vector') || (v2[0] !== 'tuple' && v2[0] !== 'vector')){
          throw new Error("Can't take cross product. Those aren't vectors");
      }
      
      if (v1.length === 3 && v2.length === 3){
          return simplify$2(['+', ['*', v1[1], v2[2]], ['-', ['*', v1[2], v2[1]]]]);
      }
          
      if (v1.length === 4 && v2.length === 4){
          var x_coord = ['+', ['*', v1[2], v2[3]], ['-',['*', v1[3], v2[2]]]];
          var y_coord = ['+', ['*', v1[3], v2[1]], ['-',['*', v1[1], v2[3]]]];
          var z_coord = ['+', ['*', v1[1], v2[2]], ['-',['*', v1[2], v2[1]]]];
          return simplify$2(['vector', x_coord, y_coord, z_coord]);
      }
      
      throw new Error("Can't take cross product. The dimensions aren't both 2 or 3.");
  }

  var matrix$5 = /*#__PURE__*/Object.freeze({
    matrix: matrix$4,
    vector_add: vector_add,
    scalar_mul: scalar_mul,
    vector_sub: vector_sub,
    dot_prod: dot_prod,
    cross_prod: cross_prod
  });

  /*
   * convert syntax trees to Guppy XML representations
   *
   * Copyright 2017 by Jim Fowler <kisonecat@gmail.com>
   *
   * This file is part of a math-this.expressions library
   *
   * math-this.expressions is free software: you can redistribute
   * it and/or modify it under the this.terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-this.expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */




  class astToGuppy{
    constructor(){
      this.operators = {
          "+": function(operands) { return operands.join( '<e>+</e>' ); },
          "-": function(operands) { return "<e>-" + operands.join( '-' ) + "</e>"; },
          "*": function(operands) { return operands.join( '<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>' ); },
          "/": function(operands) { return astToGuppy.dfrac(operands[0], operands[1]); },
          "^": function(operands) { return astToGuppy.power(operands[0],operands[1]); },
          "sin": function(operands) { return astToGuppy.trig("sin",operands[0]); },
          "cos": function(operands) { return astToGuppy.trig("cos",operands[0]); },
          "tan": function(operands) { return astToGuppy.trig("tan",operands[0]); },
          "arcsin": function(operands) { return astToGuppy.trig("arcsin",operands[0]); },
          "arccos": function(operands) { return astToGuppy.trig("arccos",operands[0]); },
          "arctan": function(operands) { return astToGuppy.trig("arctan",operands[0]); },
          "arccsc": function(operands) { return astToGuppy.trig("arccsc",operands[0]); },
          "arcsec": function(operands) { return astToGuppy.trig("arcsec",operands[0]); },
          "arccot": function(operands) { return astToGuppy.trig("arccot",operands[0]); },
          "csc": function(operands) { return astToGuppy.trig("csc",operands[0]); },
          "sec": function(operands) { return astToGuppy.trig("sec",operands[0]); },
          "cot": function(operands) { return astToGuppy.trig("cot",operands[0]); },
          "log": function(operands) { return astToGuppy.trig("log",operands[0]); },
          "exp": function(operands) { return astToGuppy.trig("exp",operands[0]); },
          "ln": function(operands) { return astToGuppy.trig("ln",operands[0]); },
          "sqrt": function(operands) { return astToGuppy.sqrt(operands[0]); },
          "abs": function(operands) { return astToGuppy.abs(operands[0]); },
          //"factorial": function(operands) { return operands[0] + "!"; },
      };

    }

    static dfrac(a,b) {
        return '<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>' + a + '<e></e></c><c up="1" down="2" name="denominator"><e></e>' + b + '<e></e></c></f>';
    }

    static trig(name, parameter ) {
        return '<f type="' + name + '" group="functions"><b p="latex">\\' + name + '\\left(<r ref="1"/>\\right)</b><b p="text"> ' + name + '(<r ref="1"/>)</b><c delete="1"><e></e>' + parameter + '<e></e></c></f>';
    }

    static sqrt(x) {
        return '<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>' + x + '<e></e></c></f>';
    }

    static power(x,y) {
        return '<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>' + x + '<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>' + y + '<e></e></c></f>';
    }

    static abs(x) {
        return '<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>' + x + '<e></e></c></f>';
    }

    static paren(x) {
        return '<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>' + x + '<e></e></c></f>';
    }

    static isFunctionSymbol( symbol ){
        var functionSymbols = ['sin', 'cos', 'tan', 'csc', 'sec', 'cot', 'arcsin', 'arccos', 'arctan', 'arccsc', 'arcsec', 'arccot', 'log', 'ln', 'exp', 'sqrt', 'abs', 'this.factorial'];
        return (functionSymbols.indexOf(symbol) !== -1);
    }

    static isGreekLetterSymbol( symbol ){
        var greekSymbols = ['pi', 'theta', 'theta', 'Theta', 'alpha', 'nu', 'beta', 'xi', 'Xi', 'gamma', 'Gamma', 'delta', 'Delta', 'pi', 'Pi', 'epsilon', 'epsilon', 'rho', 'rho', 'zeta', 'sigma', 'Sigma', 'eta', 'tau', 'upsilon', 'Upsilon', 'iota', 'phi', 'phi', 'Phi', 'kappa', 'chi', 'lambda', 'Lambda', 'psi', 'Psi', 'omega', 'Omega'];
        return (greekSymbols.indexOf(symbol) !== -1);
    }

    factorWithParenthesesIfNegated(tree){
        var result = this.factor(tree);

        if (result.toString().match( /^<e>-/ ))
    	return astToGuppy.paren( result.toString() );

        // else
        return result;
    }





    /*
      this.factor =
      '(' this.expression ')' |
      number |
      variable |
      function this.factor |
      this.factor '^' this.factor
      '-' this.factor |
      nonMinusthis.factor
    */

  factor(tree) {
        if (typeof tree === 'string') {
    	if (astToGuppy.isGreekLetterSymbol(tree)) {
    	    return '<f type="' + tree + '" group="greek" c="yes"><b p="latex">\\' + tree + '</b><b p="text"> $' + tree + '</b></f>';
    	}

    	return '<e>' + tree + '</e>';
        }

        if (typeof tree === 'number') {
    	return '<e>' + tree + '</e>';
        }

        var operator = tree[0];
        var operands = tree.slice(1);

        if(operator === "apply") {
    	operator = tree[1];
    	operands = tree.slice(2);
        }

        // Absolute value doesn't need any special parentheses handling, but its operand is really an this.expression
        if (operator === "abs") {
    	return this.operators[operator]( operands.map( function(v,i) { return this.expression(v); }.bind(this) ));
    } else if (astToGuppy.isFunctionSymbol(operator)) {
    	if ((operator === 'this.factorial') && ((operands[0].toString().length === 1) || (operands[0].toString().match( /^[0-9]*$/ ))))
    	    return this.operators[operator]( operands );

    	return this.operators[operator]( operands.map( function(v,i) {
    	    var result = this.factor(v);
    	    return result;
    	}.bind(this)));
        }

        if (operator === "^") {
    	return this.operators[operator]( operands.map( function(v,i) { return this.factor(v); }.bind(this) ) );
        }

        if (operator === '~') {
    	return this.operators[operator]( operands.map( function(v,i) { return this.factor(v); }.bind(this) ) );
        }

        return astToGuppy.paren( this.expression(tree) );
    }


    /*
      this.term =
      this.term '*' this.factor |
      this.term nonMinusthis.factor |
      this.term '/' this.factor |
      this.factor
    */

    term(tree) {
        if ((typeof tree === 'string') || (typeof tree === 'number')) {
    	return this.factor(tree);
        }

        var operator = tree[0];
        var operands = tree.slice(1);

        if (operator === '*') {
    	return this.operators[operator]( operands.map( function(v,i) {
    	    var result = this.factorWithParenthesesIfNegated(v);

    	    if (result.toString().match( /^[0-9]/ ) && (i > 0))
    		return ' * ' + result;
    	    else
    		return result;
    	}.bind(this)));
        }

        if (operator === '/') {
    	return this.operators[operator]( operands.map( function(v,i) { return this.factor(v); }.bind(this) ) );
        }

        return this.factor(tree);
    }

    /*
       this.expression =
        this.expression '+' this.term |
        this.expression '-' this.term |
        this.term
    */

    expression(tree) {
        if ((typeof tree === 'string') || (typeof tree === 'number')) {
    	return this.term(tree);
        }

        var operator = tree[0];
        var operands = tree.slice(1);

        if ((operator === '+') || (operator === '-')) {
    	return this.operators[operator]( operands.map( function(v,i) { return this.factorWithParenthesesIfNegated(v); }.bind(this) ));
        }

        return this.term(tree);
    }


    convert(tree){
      return ('<m><e></e>' + this.expression(tree) + '<e></e></m>').replace(/<\/e><e>/g,'');
    }

  }

  /*
   * convert syntax trees to GLSL representations
   *
   * Copyright 2014-2018 by
   *  Jim Fowler <kisonecat@gmail.com>
   *  Duane Nykamp <nykamp@umn.edu>
   *
   * This file is part of a math-expressions library
   *
   * math-expressions is free software: you can redistribute
   * it and/or modify it under the terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */


  const glslOperators = {
      "+": function(operands) { var result = operands[0]; operands.slice(1).forEach(function(rhs) { result = result + "+" + rhs; }); return result; },
    "-": function(operands) { var result = "-" + operands[0]; operands.slice(1).forEach(function(rhs) { result = result + "-" + rhs; }); return result; },
      "~": function(operands) { var result = "vec2(0.0,0.0)"; operands.forEach(function(rhs) { result = result + "-" + rhs; }); return result; },
      "*": function(operands) { var result = operands[0]; operands.slice(1).forEach(function(rhs) { result = "cmul(" + result + "," + rhs + ")"; }); return result; },
      "/": function(operands) { var result = operands[0]; operands.slice(1).forEach(function(rhs) { result = "cdiv(" + result + "," + rhs + ")"; }); return result; },

      "sin": function(operands) { return "csin(" + operands[0] + ")"; },
      "cos": function(operands) { return "ccos(" + operands[0] + ")"; },
      "tan": function(operands) { return "ctan(" + operands[0] + ")"; },

      "sinh": function(operands) { return "csinh(" + operands[0] + ")"; },
      "cosh": function(operands) { return "ccosh(" + operands[0] + ")"; },
    
      "arcsin": function(operands) { return "carcsin(" + operands[0] + ")"; },
      "arccos": function(operands) { return "carccos(" + operands[0] + ")"; },
      "arctan": function(operands) { return "carctan(" + operands[0] + ")"; },

      "arccsc": function(operands) { return "carcsin(cdiv(vec2(1.0,0)," + operands[0] + "))"; },
      "arcsec": function(operands) { return "carccos(cdiv(vec2(1.0,0)," + operands[0] + "))"; },
      "arccot": function(operands) { return "carctan(cdiv(vec2(1.0,0)," + operands[0] + "))"; },

      "csc": function(operands) { return "ccsc(" + operands[0] + ")"; },
      "sec": function(operands) { return "csec(" + operands[0] + ")"; },
      "cot": function(operands) { return "ccot(" + operands[0] + ")"; },

      "exp": function(operands) { return "cexp(" + operands[0] + ")"; },    

      "conj": function(operands) { return "conjugate(" + operands[0] + ")"; },
    
      "sqrt": function(operands) { return "cpower(" + operands[0] + ",vec2(0.5,0.0))"; },
      "log": function(operands) { return "clog(" + operands[0] + ")"; },
      "ln": function(operands) { return "clog(" + operands[0] + ")"; },    
      "^": function(operands) { return "cpower(" + operands[0] + "," + operands[1] + ")"; },
      
      "abs": function(operands) { return "cabs(" + operands[0] + ")"; },
      "apply": function(operands) { return "vec2(NaN,NaN)"; },
  };

  class astToGLSL {
    constructor() {
    }
    
      convert(tree) {
  	if (typeof tree === 'boolean')
  	    throw Error("no support for boolean");

  	
      if (typeof tree === 'string') {
  	if (tree === "e")
  	    return "vec2(2.71828182845905,0.0)";
  	
  	if (tree === "pi")
  	    return "vec2(3.14159265358979,0.0)";
  	
  	if (tree === "i")
  	    return "vec2(0.0,1.0)";

  	return String(tree);
      }    
      
      if (typeof tree === 'number') {
  	return "vec2(" + String(tree) + ",0.0)";
      }
      
      if (("real" in tree) && ("imaginary" in tree))
  	return tree;

  	if (!Array.isArray(tree)) {
  	    throw Error("Invalid ast");
  	}

  	
      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === "apply") {
        if(typeof operands[0] !== 'string')
  	throw Error("Non string functions not implemented for conversion to GLSL");

  	var operator = operands[0];
  	var operands = operands.slice(1);
  	
  	return glslOperators[operator]( operands.map( function(v,i) { return this.convert(v); }.bind(this) ) );
      }
  	
      if (operator in glslOperators) {
  	return glslOperators[operator]( operands.map( function(v,i) { return this.convert(v); }.bind(this) ) );
      }
      
  	throw Error("Operator " + operator + " not implemented for conversion to mathjs");
      }
  }

  var astToLatex$2 = new astToLatex();
  var astToText$2 = new astToText();
  var astToGuppy$1 = new astToGuppy();
  var astToGLSL$1 = new astToGLSL();

  const tex = function(expr) {
      return astToLatex$2.convert( expr.tree );
  };

  const toLatex = tex;

  const toString = function(expr) {
      return astToText$2.convert( expr.tree );
  };

  const toGLSL = function(expr) {
      return astToGLSL$1.convert( expr.tree );
  };

  const toXML = function(expr) {
      return astToGuppy$1.convert( expr.tree );
  };

  var printing = /*#__PURE__*/Object.freeze({
    tex: tex,
    toLatex: toLatex,
    toString: toString,
    toXML: toXML,
    toGLSL: toGLSL
  });

  // check for equality by randomly sampling

  function generate_random_integer(minvalue, maxvalue) {
    minvalue = math$19.ceil(minvalue);
    maxvalue = math$19.floor(maxvalue);
    return math$19.floor(math$19.random() * (maxvalue - minvalue + 1)) + minvalue;
  }



  const equals = function ({ expr, other, randomBindings,
    expr_context, other_context,
    tolerance = 1E-12, allowed_error_in_numbers = 0,
    include_error_in_number_exponents = false,
    allowed_error_is_absolute = false,
  }) {

    if (Array.isArray(expr.tree) && Array.isArray(other.tree)) {

      let expr_operator = expr.tree[0];
      let expr_operands = expr.tree.slice(1);
      let other_operator = other.tree[0];
      let other_operands = other.tree.slice(1);

      if (expr_operator === 'tuple' || expr_operator === 'vector'
        || expr_operator === 'list' || expr_operator === 'array'
        || expr_operator === 'matrix' || expr_operator === 'interval'
      ) {

        if (other_operator !== expr_operator)
          return false;

        if (other_operands.length !== expr_operands.length)
          return false;

        for (let i = 0; i < expr_operands.length; i++) {
          if (!equals({
            expr: expr_context.fromAst(expr_operands[i]),
            other: other_context.fromAst(other_operands[i]),
            randomBindings: randomBindings,
            expr_context: expr_context,
            other_context: other_context,
            tolerance: tolerance,
            allowed_error_in_numbers: allowed_error_in_numbers,
            include_error_in_number_exponents: include_error_in_number_exponents,
            allowed_error_is_absolute: allowed_error_is_absolute,
          }))
            return false;
        }

        return true;  // each component is equal
      }

      // check if a relation with two operands
      if (expr_operands.length === 2 && ["=", '>', '<', 'ge', 'le'].includes(expr_operator)) {
        if (other_operands.length !== 2) {
          return false;
        }
        //normalize operator
        if (expr_operator === ">") {
          expr_operator = "<";
          expr_operands = [expr_operands[1], expr_operands[0]];
        } else if (expr_operator === "ge") {
          expr_operator = "le";
          expr_operands = [expr_operands[1], expr_operands[0]];
        }
        if (other_operator === ">") {
          other_operator = "<";
          other_operands = [other_operands[1], other_operands[0]];
        } else if (other_operator === "ge") {
          other_operator = "le";
          other_operands = [other_operands[1], other_operands[0]];
        }

        if (expr_operator !== other_operator) {
          return false;
        }

        // put in standard form
        let expr_rhs = ['+', expr_operands[0], ['-', expr_operands[1]]];
        let other_rhs = ['+', other_operands[0], ['-', other_operands[1]]];
        let require_positive_proportion = (expr_operator !== "=");

        return component_equals({
          expr: expr_context.fromAst(expr_rhs),
          other: other_context.fromAst(other_rhs),
          randomBindings: randomBindings,
          expr_context: expr_context,
          other_context: other_context,
          allow_proportional: true,
          require_positive_proportion: require_positive_proportion,
          tolerance: tolerance,
          allowed_error_in_numbers: allowed_error_in_numbers,
          include_error_in_number_exponents: include_error_in_number_exponents,
          allowed_error_is_absolute: allowed_error_is_absolute,
        });

      }

    }

    // if not special case, use standard numerical equality
    return component_equals({
      expr: expr,
      other: other,
      randomBindings: randomBindings,
      expr_context: expr_context,
      other_context: other_context,
      tolerance: tolerance,
      allowed_error_in_numbers: allowed_error_in_numbers,
      include_error_in_number_exponents: include_error_in_number_exponents,
      allowed_error_is_absolute: allowed_error_is_absolute,
    });

  };


  const component_equals = function ({ expr, other, randomBindings,
    expr_context, other_context,
    allow_proportional = false, require_positive_proportion = false,
    tolerance, allowed_error_in_numbers, include_error_in_number_exponents,
    allowed_error_is_absolute,
  }) {

    var max_value = Number.MAX_VALUE * 1E-20;
    var min_nonzero_value = 0;//1E-100; //Number.MIN_VALUE & 1E20;

    var epsilon = tolerance;
    var minimum_matches = 10;
    var number_tries = 100;
    // if (allowed_error_in_numbers > 0) {
    //   minimum_matches = 400;
    //   number_tries = 4000;
    // }

    // normalize function names, so in particular, e^x becomes exp(x)
    expr = expr.normalize_function_names();
    other = other.normalize_function_names();

    // convert subscripts to strings so that variables like x_t are considered single variable
    expr = expr.subscripts_to_strings();
    other = other.subscripts_to_strings();

    // Get set of variables mentioned in at least one of the two expressions
    var variables = [expr.variables(), other.variables()];
    variables = variables.reduce(function (a, b) { return a.concat(b); });
    variables = variables.reduce(function (p, c) {
      if (p.indexOf(c) < 0) p.push(c);
      return p;
    }, []);

    // pi, e, and i shouldn't be treated as a variable
    // for the purposes of equality if they are defined as having values
    if (math$19.define_pi) {
      variables = variables.filter(function (a) {
        return (a !== "pi");
      });
    }
    if (math$19.define_i) {
      variables = variables.filter(function (a) {
        return (a !== "i");
      });
    }
    if (math$19.define_e) {
      variables = variables.filter(function (a) {
        return (a !== "e");
      });
    }

    // determine if any of the variables are integers
    // consider integer if is integer in either expressions' assumptions
    var integer_variables = [];
    for (let i = 0; i < variables.length; i++)
      if (is_integer_ast(variables[i], expr_context.assumptions)
        || is_integer_ast(variables[i], other_context.assumptions))
        integer_variables.push(variables[i]);

    // determine if any of the variables are functions
    var functions = [expr.functions(), other.functions()];
    functions = functions.reduce(function (a, b) { return a.concat(b); });
    functions = functions.reduce(function (p, c) {
      if (p.indexOf(c) < 0) p.push(c);
      return p;
    }, []);
    functions = functions.filter(function (a) {
      return a.length == 1;
    });

    try {
      var expr_f = expr.f();
      var other_f = other.f();
    }
    catch (e) {
      // Can't convert to mathjs to create function
      // just check if equal via syntax
      return expr.equalsViaSyntax(other)
    }

    let expr_with_params, parameters_for_numbers;
    let tolerance_function;

    if (allowed_error_in_numbers > 0) {
      let result = replace_numbers_with_parameters({
        expr: expr,
        variables: variables,
        include_exponents: include_error_in_number_exponents,
      });
      expr_with_params = expr_context.fromAst(result.expr_with_params);
      parameters_for_numbers = result.parameters;

      let parameter_list = Object.keys(parameters_for_numbers);
      if (parameter_list.length > 0) {
        let derivative_sum = expr_with_params.derivative(parameter_list[0]);
        if(!allowed_error_is_absolute) {
          derivative_sum = derivative_sum
            .multiply(parameters_for_numbers[parameter_list[0]]);
        }
        if (parameter_list.length > 1) {
          for (let par of parameter_list.slice(1)) {
            let term = expr_with_params.derivative(par);
            if(!allowed_error_is_absolute) {
              term = term.multiply(parameters_for_numbers[par]);
            }
            derivative_sum = derivative_sum.add(term);
          }
        }

        let tolerance_expression = derivative_sum.multiply(allowed_error_in_numbers);

        try {
          tolerance_function = tolerance_expression.f();
        } catch (e) {
          // can't create function out of derivative
          // so can't compute tolerance that would correspond
          // to the allowed error in numbers

          // Leave tolerance_function undefined

        }

      }

    }



    var noninteger_binding_scale = 1;

    var binding_scales = [10, 1, 100, 0.1, 1000, 0.01];
    var scale_num = 0;

    // Numerical test of equality
    // If can find a region of the complex plane where the functions are equal
    // at minimum_matches points, consider the functions equal
    // unless the functions were always zero, in which case
    // test at multiple scales to check for underflow

    // In order to account for possible branch cuts,
    // finding points where the functions are not equal does not lead to the
    // conclusion that expression are unequal. Instead, to be consider unequal
    // the functions must be unequal around many different points.

    let num_at_this_scale = 0;

    let always_zero = true;

    let num_finite_unequal = 0;

    for (let i = 0; i < 10 * number_tries; i++) {

      // Look for a location where the magnitudes of both expressions
      // are below max_value;
      try {
        var result = find_equality_region(binding_scales[scale_num]);
      }
      catch (e) {
        continue;
      }

      if (result.always_zero === false) {
        always_zero = false;
      }


      if (!result.equal && !result.out_of_bounds && !result.always_zero &&
        result.sufficient_finite_values !== false
      ) {
        num_finite_unequal++;
        if (num_finite_unequal > number_tries) {
          return false;
        }
      }

      if (result.equal) {
        if (result.always_zero) {
          if (!always_zero) {
            // if found always zero this time, but wasn't zero at a different point
            // don't count as equal
            continue;
          }
          // functions equal but zero
          // repeat to make sure (changing if continuing to be zero)
          num_at_this_scale += 1;
          if (num_at_this_scale > 5) {
            scale_num += 1;
            num_at_this_scale = 0;
          }
          if (scale_num >= binding_scales.length) {
            return true;  // were equal and zero at all scales
          } else
            continue
        }
        else {
          return true;
        }
      }
    }
    return false;



    function find_equality_region(noninteger_scale) {

      // Check if expr and other are equal in a region as follows
      // 1. Randomly select bindings (use noninteger scale for non-integer variables)
      //    and evaluate expr and other at that point
      // 2. If either value is too large, return { out_of_bounds: true }
      // 3. If values are not equal (within tolerance), return { equal_at_start: false }
      // 4. If functions are equal, then
      //    randomly select binding in neighborhood of that point
      //    (use non_integer scale/100 for non-integer variables)
      // 5. If find a point where the functions are not equal,
      //    then return { equal_in_middle: false }
      // 6. If find that functions are equal at minimum_matches points
      //    then return { equality: true, always_zero: always_zero }
      //    where always_zero is true if both functions were always zero
      //    and is false otherwise
      // 7. If were unable to find sufficent points where both functions are finite
      //    return { sufficient_finite_values: false }
      // If allow_proportional is true, then instead of return non-equal
      // in step 3, use the ratio of value of these first evaluations to set
      // the proportion, and base equality on remaining values having the
      // same proportion



      var bindings = randomBindings(variables, noninteger_scale);

      // replace any integer variables with integer
      for (let i = 0; i < integer_variables.length; i++) {
        bindings[integer_variables[i]] = generate_random_integer(-10, 10);
      }

      // replace any function variables with a function
      for (let i = 0; i < functions.length; i++) {
        var a = generate_random_integer(-10, 10);
        var b = generate_random_integer(-10, 10);
        var c = generate_random_integer(-10, 10);
        bindings[functions[i]] = function (x) {
          return math$19.add(math$19.multiply(math$19.add(math$19.multiply(a, x), b), x), c);
        };
      }


      var bindingsIncludingParameters;
      if (tolerance_function) {
        bindingsIncludingParameters = Object.assign({}, bindings, parameters_for_numbers);
      }

      var expr_evaluated = expr_f(bindings);
      var other_evaluated = other_f(bindings);

      var expr_abs = math$19.abs(expr_evaluated);
      var other_abs = math$19.abs(other_evaluated);

      if (!(expr_abs < max_value && other_abs < max_value))
        return { out_of_bounds: true, always_zero: false };

      if (!((expr_abs === 0 || expr_abs > min_nonzero_value) &&
        (other_abs === 0 || other_abs > min_nonzero_value)))
        return { out_of_bounds: true, always_zero: false };

      // now that found a finite point,
      // check to see if expressions are nearly equal.

      var min_mag = Math.min(expr_abs, other_abs);
      var max_mag = Math.max(expr_abs, other_abs);
      var proportion = 1;

      let tol = 0;
      if (tolerance_function) {
        try {
          tol = math$19.abs(tolerance_function(bindingsIncludingParameters));
        } catch (e) {
          return { equal_at_start: false, always_zero: false };
        }
        if (!Number.isFinite(tol)) {
          return { equal_at_start: false, always_zero: false };
        }
      }

      tol += min_mag * epsilon;

      // never allow tol to get over 10% the min_mag
      tol = Math.min(tol, 0.1 * min_mag);

      if (!(
        max_mag === 0 ||
        math$19.abs(math$19.subtract(expr_evaluated, other_evaluated)) < tol
      )) {
        if (!allow_proportional) {
          return { equal_at_start: false, always_zero: false };
        }
        // at this point, know both are not zero
        if (expr_abs === 0 || other_abs === 0) {
          return { equal_at_start: false, always_zero: false };
        }

        proportion = math$19.divide(expr_evaluated, other_evaluated);
        if (require_positive_proportion && !(proportion > 0)) {
          return { equal_at_start: false, always_zero: false };
        }
      }


      var always_zero = (max_mag === 0);

      // Look for a region around point
      var finite_tries = 0;
      for (let j = 0; j < 100; j++) {
        var bindings2 = randomBindings(
          variables, noninteger_binding_scale / 100, bindings);

        // replace any integer variables with integer
        for (let k = 0; k < integer_variables.length; k++) {
          bindings2[integer_variables[k]]
            = generate_random_integer(-10, 10);
        }

        // replace any function variables with a function
        for (let i = 0; i < functions.length; i++) {
          var a = generate_random_integer(-10, 10);
          var b = generate_random_integer(-10, 10);
          var c = generate_random_integer(-10, 10);
          bindings2[functions[i]] = function (x) {
            return math$19.add(math$19.multiply(math$19.add(math$19.multiply(a, x), b), x), c);
          };
        }

        var bindings2IncludingParameters;
        if (tolerance_function) {
          bindings2IncludingParameters = Object.assign({}, bindings2, parameters_for_numbers);
        }

        try {
          expr_evaluated = expr_f(bindings2);
          other_evaluated = math$19.multiply(other_f(bindings2), proportion);
        }
        catch (e) {
          continue;
        }
        expr_abs = math$19.abs(expr_evaluated);
        other_abs = math$19.abs(other_evaluated);

        if (expr_abs < max_value && other_abs < max_value) {
          min_mag = Math.min(expr_abs, other_abs);
          max_mag = Math.max(expr_abs, other_abs);

          finite_tries++;

          let tol = 0;
          if (tolerance_function) {
            try {
              tol = math$19.abs(tolerance_function(bindings2IncludingParameters));
            } catch (e) {
              continue;
            }
            if (!Number.isFinite(tol)) {
              continue;
            }
          }
          tol += min_mag * epsilon;

          // never allow tol to get over 10% the min_mag
          tol = Math.min(tol, 0.1 * min_mag);

          if (!(
            max_mag === 0 ||
            math$19.abs(math$19.subtract(expr_evaluated, other_evaluated)) < tol
          )) {
            return { equality_in_middle: false, always_zero: false };
          }

          always_zero = always_zero && (max_mag === 0);

          if (finite_tries >= minimum_matches) {
            return { equal: true, always_zero: always_zero }
          }
        }
      }
      return { sufficient_finite_values: false, always_zero: always_zero };
    }

  };

  function replace_numbers_with_parameters({ expr, variables, include_exponents = false }) {

    // find all numbers, including pi and e, if defined as numerical
    let parameters = {};
    let lastParNum = 0;

    function get_new_parameter_name() {
      lastParNum++;
      let parName = "par" + lastParNum;
      while (variables.includes(parName)) {
        lastParNum++;
        parName = "par" + lastParNum;
      }

      // found a new parameter name that isn't a variable
      return parName;

    }

    function replace_number_sub(tree) {
      if (typeof tree === 'number') {
        if (tree === 0) {
          // since will compute bounds for relative error in numbers
          // can't include zero
          return tree;
        } else {
          let par = get_new_parameter_name();
          parameters[par] = tree;
          return par;
        }
      }

      if (typeof tree === "string") {
        if (tree === "pi") {
          if (math$19.define_pi) {
            let par = get_new_parameter_name();
            parameters[par] = math$19.PI;
            return par;
          }
        } else if (tree === "e") {
          if (math$19.define_e) {
            let par = get_new_parameter_name();
            parameters[par] = math$19.e;
            return par;
          }
        }
        return tree;
      }

      if (!Array.isArray(tree)) {
        return tree;
      }

      let operator = tree[0];
      let operands = tree.slice(1);
      if (operator === "^" && !include_exponents) {
        return [operator, replace_number_sub(operands[0]), operands[1]]
      } else {
        return [operator, ...operands.map(replace_number_sub)];
      }

    }

    // first evaluate numbers to combine then
    // and turn any numerical constants to floating points
    expr = expr.evaluate_numbers({ max_digits: Infinity });
    return {
      expr_with_params: replace_number_sub(expr.tree),
      parameters: parameters
    }

  }

  //import { substitute_abs } from '../normalization/standard_form';

  function randomComplexBindings(variables, radius, centers) {
    var result = {};

    if (centers === undefined) {
      variables.forEach(function (v) {
        result[v] = math$19.complex(math$19.random() * 2 * radius - radius,
          math$19.random() * 2 * radius - radius);
      });
    }
    else {
      variables.forEach(function (v) {
        result[v] = math$19.complex(
          centers[v].re + math$19.random() * 2 * radius - radius,
          centers[v].im + math$19.random() * 2 * radius - radius);
      });
    }

    return result;
  }

  const equals$1 = function (expr, other,
    { tolerance = 1E-12, allowed_error_in_numbers = 0,
      include_error_in_number_exponents = false,
      allowed_error_is_absolute = false,
    } = {}) {

    //expr = expr.substitute_abs();
    //other = other.substitute_abs();

    // don't use complex equality if not analytic expression
    // except abs is OK
    if ((!expr.isAnalytic({ allow_abs: true, allow_relation: true })) ||
      (!other.isAnalytic({ allow_abs: true, allow_relation: true })))
      return false;

    return equals({
      expr: expr,
      other: other,
      randomBindings: randomComplexBindings,
      expr_context: expr.context,
      other_context: other.context,
      tolerance: tolerance,
      allowed_error_in_numbers: allowed_error_in_numbers,
      include_error_in_number_exponents: include_error_in_number_exponents,
      allowed_error_is_absolute: allowed_error_is_absolute,
    });
  };

  function randomRealBindings(variables, radius, centers) {
      var result = {};

      if(centers === undefined) {
  	variables.forEach( function(v) {
  	    result[v] = math$19.random()*2*radius - radius;
  	});
      }
      else {
  	variables.forEach( function(v) {
  	    result[v] =centers[v] + math$19.random()*2*radius - radius;
  	});
      }

      return result;
  }

  const equals$2 = function(expr, other,
      { tolerance = 1E-12, allowed_error_in_numbers = 0,
        include_error_in_number_exponents = false } = {}) {

    // don't use real equality if not analytic expression
    if((!expr.isAnalytic()) || (!other.isAnalytic()))
      return false;

    return equals({
      expr: expr,
      other: other,
      randomBindings: randomRealBindings,
      expr_context: expr.context,
      other_content: other.context,
      tolerance: tolerance,
      allowed_error_in_numbers: allowed_error_in_numbers,
      include_error_in_number_exponents: include_error_in_number_exponents,
    });
  };

  const equals$3 = function (expr, other, {
    allowed_error_in_numbers = 0,
    include_error_in_number_exponents = false,
    allowed_error_is_absolute = false,
  } = {}) {
    return equal$2(expr.tree, other.tree, {
      allowed_error_in_numbers: allowed_error_in_numbers,
      include_error_in_number_exponents: include_error_in_number_exponents,
      allowed_error_is_absolute: allowed_error_is_absolute,
    });
  };

  const equals$$1 = function(expr, other, { min_elements_match=3, match_partial = false } = {} ) {

    // expr must be a discrete infinite set
    if(!is_discrete_infinite_set(expr))
      return false;

    // other must be a discrete infinite set or a list
    if(is_discrete_infinite_set(other)) {
      var assumptions = [];
      let a = expr.context.get_assumptions(expr);
      if(a !== undefined)
        assumptions.push(a);
      a = other.context.get_assumptions(other);
      if(a !== undefined)
        assumptions.push(a);
      if(assumptions.length === 0)
        assumptions = undefined;
      else if(assumptions.length === 1)
        assumptions=assumptions[0];
      else
        assumptions = clean_assumptions(['and'].concat(assumptions));

      if(match_partial) {
        let match1 = contained_in(expr.tree, other.tree, assumptions, match_partial);
        if(match1 === false) {
          return 0;
        }
        let match2 = contained_in(other.tree, expr.tree, assumptions, match_partial);
        if(match2 === false) {
          return 0;
        }

        if(match1 === true) {
          if(match2 === true) {
            return 1;
          } else {
            return match2;
          }
        } else if(match2 === true) {
          return match1;
        } else {
          return Math.min(match1, match2);
        }

      } else {
        return contained_in(expr.tree, other.tree, assumptions, match_partial) &&
          contained_in(other.tree, expr.tree, assumptions, match_partial);
      }
    }
    else {
      // check if other is a list than ends in 'ldots'
      let other_tree = other.tree;

      if(other_tree[0] !== 'list')
        return false;

      let n_in_list = other_tree.length-2;

      if(other_tree[n_in_list+1][0] !== 'ldots')
        return false;

      if(n_in_list < min_elements_match)
        return false;

      let the_list = other_tree.slice(0,n_in_list+1);

      // get list of same size from
      let generated_list = sequence_from_discrete_infinite(expr, n_in_list);

      if(!generated_list)
        return false;

      generated_list = ['list'].concat(generated_list);

      return equals$5(expr.context.from(generated_list), other.context.from(the_list));

    }

  };


  function is_discrete_infinite_set(expr) {

    var tree = expr.tree;
    if(!Array.isArray(tree))
      return false;
    if(tree[0] !== 'discrete_infinite_set')
      return false;
    var operands = tree.slice(1);

    for(var v of operands) {
      if(!Array.isArray(v))
        return false;
      if(v[0] !== 'tuple')
        return false;
      if(v.length !== 5)
        return false;
    }

    return true;
  }


  function contained_in(tree, i_set, assumptions, match_partial) {
    // true if tree is contained in the discrete infinite set i_set
    // tree is either a discrete infinite set
    // or a tuple of form [offset, period, min_index, max_index]

    if(tree[0] === 'discrete_infinite_set') {
      if(match_partial) {
        let num_matches = 0;
        for(let piece of tree.slice(1)){
          let match = contained_in(piece, i_set, assumptions, match_partial);
          if(match === true) {
            num_matches++;
          } else if(match !== false) {
            num_matches += match;
          }
        }

        let num_pieces = tree.length - 1;

        if(num_matches === num_pieces) {
          return true;
        }else if(num_matches === 0) {
          return false;
        }else {
          return num_matches/num_pieces;
        }
      } else {
        return tree.slice(1).every(v => contained_in(v, i_set, assumptions));
      }
    }

    // tree is a tuple of the form [offset, period, min_index, max_index]

    var offset0 = tree[1];
    var period0 = tree[2];
    var min_index = tree[3];
    var max_index = tree[4];

    // implemented only if min_index === -infinity and max_index === infinity
    if(!Array.isArray(min_index) || min_index[0] !== '-' || min_index[1] !== Infinity
       || max_index !== Infinity)
      return false;

    // normalize to period 1
    offset0 = simplify$2(
      ['/', offset0, period0], assumptions, Infinity);

    // if(!(typeof offset0 === 'number'))
    //   return false;

    var tuples = i_set.slice(1);

    // data will be array of form [p, q, offset, period]
    // where offset and period are normalized by period0
    // and p/q is fraction form of period

    var data = [];
    for(let i=0; i<tuples.length; i++) {

      // implemented only if min_index === -infinity and max_index === infinity
      let this_min_index = tuples[i][3];
      let this_max_index = tuples[i][4];
      if(!Array.isArray(this_min_index) || this_min_index[0] !== '-'
         || this_min_index[1] !== Infinity
         || this_max_index !== Infinity)
        return false;


      let offset = simplify$2(
        ['/', tuples[i][1], period0], assumptions, Infinity);
      let period = simplify$2(
        ['/', tuples[i][2], period0], assumptions, Infinity);

      if(typeof period !== 'number')
        return false;

      let frac = math$19.fraction(period);
      let p = frac.n;
      let q = frac.d;
      data.push([p,q,offset,period]);
    }

    // sort by p
    data.sort();

    // check any with period for which original period is a multiple
    while(true) {
      let p = data[0][0];
      if(p !== 1)
        break;

      let offset = data[0][2];
      let period = data[0][3];

      // offsets match, then we've covered all of tree
      let offset_diff =  simplify$2(
        expand(
          ['+', offset, ['-', offset0]]),
        assumptions, Infinity);

      if(Number.isFinite(offset_diff) && Number.isFinite(period)) {
        // use math.mod rather than % so it always non-negative
        offset_diff = math$19.mod(offset_diff, period);

        if(math$19.min(offset_diff, period-offset_diff) < 1E-10*period)
          return true;
      }
      data.splice(0,1);  // remove first entry from data
      if(data.length === 0)
        return false;

    }

    var all_ps = [...new Set(data.map(v => v[0]))];

    let max_fraction_covered = 0;

    for(let base_p of all_ps) {
      // find all ps where base_p is a multiple
      let options = data.map(function (v,i) {
        let m = base_p/v[0];
        if(Number.isInteger(m))
          return [v[0], m, i];
        else
          return undefined;
      }).filter(v=>v);

      let covered = [];

      for(let opt of options) {
        let p = opt[0];
        let m = opt[1];
        let i = opt[2];
        let offset = data[i][2];
        let period = data[i][3];


        for(let j=0; j < p; j++) {

          let offset_diff =  simplify$2(
            expand(
              ['+', offset, ['-', ['+', offset0, j]]]),
            assumptions, Infinity);

          // use math.mod rather than % so it always non-negative
          if(Number.isFinite(offset_diff) && Number.isFinite(period)) {
            offset_diff = math$19.mod(offset_diff, period);

            if(math$19.min(offset_diff, period-offset_diff) < 1E-10*period) {

              for(let k=0; k<m; k++) {
                covered[j+k*p] = true;
              }

              // check to see if covered all;
              let covered_all = true;
              for(let ind=0; ind < base_p; ind++) {
                if(!covered[ind]) {
                  covered_all = false;
                  break;
                }
              }

              if(covered_all)
                return true;

              break;
            }
          }
        }
      }

      if(match_partial) {
        let fraction_covered = 0;
        for(let ind=0; ind < base_p; ind++) {
          if(covered[ind]) {
            fraction_covered++;
          }
        }
        fraction_covered /= base_p;

        if(fraction_covered > max_fraction_covered) {
          max_fraction_covered = fraction_covered;
        }
      }
    }

    if(match_partial && max_fraction_covered > 0) {
      return max_fraction_covered;
    }

    return false;

  }


  function sequence_from_discrete_infinite(expr, n_elements) {

    // assuming without checking that expr is discrete infinite set

    var tree = expr.tree;
    var operands = tree.slice(1);

    // implemented only if have just one tuple defining set
    if(operands.length > 1)
      return;

    let offset = operands[0][1];
    let period = operands[0][2];
    let min_index = evaluate_numbers(operands[0][3]);
    let max_index = operands[0][4];

    // implemented only if min_index is defined and an integer and max_index is infinity
    if(!Number.isInteger(min_index) || max_index !== Infinity)
      return;

    let result = [];

    for(let i=0; i < n_elements; i++) {
      result.push(evaluate_numbers(['+', ['*', period, min_index+i], offset]));
    }

    return result;
  }

  //exports.equalsViaFiniteField = equalsViaFiniteField;

  const equals$5 = function (expr, other, {
    tolerance = 1E-12, allowed_error_in_numbers = 0,
    include_error_in_number_exponents = false,
    allowed_error_is_absolute = false,
  } = {}) {
    if (expr.variables().includes('\uFF3F') || other.variables().includes('\uFF3F')) {
      return false;
    }

    // first check with symbolic equality
    // converting all numbers and numerical quantities to floating point
    // and normalizing form of each expression
    let exprNormalized = expr.evaluate_numbers({ max_digits: Infinity })
      .normalize_function_names()
      .normalize_applied_functions()
      .simplify();
    let otherNormalized = other.evaluate_numbers({ max_digits: Infinity })
      .normalize_function_names()
      .normalize_applied_functions()
      .simplify();

    if (exprNormalized.equalsViaSyntax(otherNormalized, {
      allowed_error_in_numbers: allowed_error_in_numbers,
      include_error_in_number_exponents: include_error_in_number_exponents,
      allowed_error_is_absolute: allowed_error_is_absolute,
    })
    ) {
      return true;
    } else if (expr.equalsViaComplex(other, {
      tolerance: tolerance,
      allowed_error_in_numbers: allowed_error_in_numbers,
      include_error_in_number_exponents: include_error_in_number_exponents,
      allowed_error_is_absolute: allowed_error_is_absolute,
    })) {
      return true;
      // } else if (expr.equalsViaReal(other)) {
      //   	return true;
    } else if (equals$$1(expr, other)) {
      return true;
    } else {
      return false;
    }
  };

  var equality = /*#__PURE__*/Object.freeze({
    equals: equals$5,
    equalsViaComplex: equals$1,
    equalsViaReal: equals$2,
    equalsViaSyntax: equals$3,
    equalsDiscreteInfinite: equals$$1
  });

  const integrateNumerically = function(expr, x,a,b) {
      var intervals = 100;
      var total = 0.0;
      var bindings = {};

      for( var i=0; i < intervals; i++ ) {
  	var sample_point = a + ((b - a) * (i + 0.5) / intervals);
  	bindings[x] = sample_point;
  	total = total + expr.evaluate( bindings );
      }

      return total * (b - a) / intervals;
  };

  var integration = /*#__PURE__*/Object.freeze({
    integrateNumerically: integrateNumerically
  });

  function expression_to_polynomial(expr_or_tree) {

      var tree = get_tree(expr_or_tree);

      if(typeof tree === 'string') {
  	if((tree === 'pi' && math$19.define_pi)
  	   || (tree === 'i' && math$19.define_i)
  	   || (tree === 'e' && math$19.define_e))
  	    return tree; // treat as number
  	else
  	    return ['polynomial', tree, [[1, 1]]];  // treat a polynomial variable
      }

      if(typeof tree === 'number')
  	return tree;

      let c = evaluate_to_constant(tree);
      if(c !== null && Number.isFinite(c)) {
  	return simplify$2(tree);
      }

      if(!Array.isArray(tree))
  	return false;

      // if contains invalid operators, it's not a polynomial
      if(!operators$1(tree).every(
  	v => ['+', '-', '*', '^', '/', '_', 'prime'].includes(v)))
  	return false;

      var operator = tree[0];
      var operands = tree.slice(1);

      if(operator === '+') {
  	let result = operands.map(expression_to_polynomial);

      // return false if any operand returned false
  	if(!result.every(v => v !== false))
  	    return false;

  	return result.reduce((u,v) => polynomial_add(u,v));
      }
      else if(operator === '-') {
  	let result = expression_to_polynomial(operands[0]);

  	if(!result)
  	    return false;

  	return polynomial_neg(result);
      }
      else if(operator === '*') {
  	let result = operands.map(expression_to_polynomial);

  	// return false if any operand returned false
  	if(!result.every(v => v !== false ))
  	    return false;

  	return result.reduce((u,v) => polynomial_mul(u,v));
      }
      else if(operator === '^') {

  	let base = operands[0];
  	let subresult = expression_to_polynomial(base);

  	// if subresult itself is false, then don't have a polynomial
  	if(subresult === false)
  	    return false;

  	let pow = simplify$2(operands[1]);

  	// if pow isn't a literal nonnegative integer
  	if((typeof pow !== 'number') || pow < 0 || !Number.isInteger(pow)) {

  	    let pow_num = evaluate_to_constant(pow);

  	    // check if pow is a rational number with a small base
  	    if(pow_num !== null || Number.isFinite(pow_num)) {
  		let pow_fraction = math$19.fraction(pow_num);
  		if(pow_fraction.d <= 100) {
  		    if(pow_fraction.s < 0)
  			base = ['^', base, ['/', -1, pow_fraction.d]];
  		    else
  			base = ['^', base, ['/', 1, pow_fraction.d]];

  		    var results = ['polynomial', simplify$2(base), []];

  		    results[2].push([pow_fraction.n, 1]);

  		    return results;

  		}
  	    }

  	    // just return entire tree as a polynomial variable
  	    return ["polynomial", tree, [[1,1]]];
  	}

  	if(pow===0) {
  	    return 1;
  	}
  	if(pow===1) {
  	    return subresult;
  	}

  	return polynomial_pow(subresult, pow);

      }
      else if(operator === '/') {
  	var denom = operands[1];

  	var denom_num = evaluate_to_constant(denom);

  	if(denom_num === null || !Number.isFinite(denom_num)) {
  	    // return entire tree as polynomial variable
  	    return ['polynomial', tree, [[1, 1]]];
  	}

  	var numer_result = expression_to_polynomial(operands[0]);

  	return polynomial_mul(numer_result, ['/', 1, denom_num]);
      }


      else {
  	// return entire tree as polynomial variable
  	return ['polynomial', tree, [[1, 1]]];
      }


  }


  function polynomials_in_same_leading_variable(p,q) {
      // If both polynomials have same leading variable, return unchanged.
      // Else, rewrite the polymomial whose leading variable comes later
      // as a polynomial that is constant in leading variable of other

      if(p[1] !== q[1]) {
  	if(compare_function(p[1], q[1]) < 0) {
  	    // variable p[1] is earlier in default order
  	    // so write q as a polynomial constant in p[1]
  	    q = ["polynomial", p[1], [[0, q]]];
  	}
  	else {
  	    // variable q[1] is earlier in default order
  	    // so write p as a polynomial constant in q[1]
  	    p = ["polynomial", q[1], [[0, p]]];
  	}
      }

      return [p, q];
  }


  function polynomial_add(p,q) {      //being called on empty polynomials

      if(p[0] !== "polynomial") {
  	if(q[0] !== "polynomial")
  	    return simplify$2(['+', p, q]);
  	else {
  	    // write p as a constant polynomial in q's first variable
  	    p = ["polynomial", q[1], [[0, p]]];
  	}
      }
      else {
  	if (q[0] !== "polynomial") {
  	    // write q as a constant polynomial in p's first variable
  	    q = ["polynomial", p[1], [[0, q]]];
  	}
  	else {
  	    // if needed, rewrite polynomials so have same first variable
  	    let tmp = polynomials_in_same_leading_variable(p,q);
  	    p = tmp[0];
  	    q = tmp[1];
  	}
      }

      // at this point, both q and p are polynomials with same first variable

      let sum = ["polynomial", p[1], []];

      let p_terms = p[2];
      let q_terms = q[2];
      let sum_terms = sum[2];

      let len_p = p_terms.length;
      let len_q = q_terms.length;
      let i = 0;
      let j = 0;

      while (i < len_p || j < len_q){
          if (i === len_p){
              if (q_terms[j][1])
                  sum_terms.push(q_terms[j]);
              j = j+1;
          }
          else if (j === len_q){
              if (p_terms[i][1])
                  sum_terms.push(p_terms[i]);
              i = i+1;
          }
          else if (p_terms[i][0] === q_terms[j][0]){
              let temp = polynomial_add(p_terms[i][1], q_terms[j][1]);
              if(temp)
                  sum_terms.push([p_terms[i][0], temp]);
              i = i+1;
              j = j+1;
          }
          else if (p_terms[i][0] < q_terms[j][0]){
              if (p_terms[i][1])
                  sum_terms.push(p_terms[i]);
              i = i+1;
          }
          else{
              if (q_terms[j][1])
                  sum_terms.push(q_terms[j]);
              j = j+1;
          }
      }

      // all terms canceled
      if(sum_terms.length === 0)
  	return 0;

      // only a term that is constant in leading variable is left
      if(sum_terms.length === 1 && (sum_terms[0][0] === 0))
  	return sum_terms[0][1];

      return sum;

  }


  function polynomial_neg(p) {

      if(p[0] !== "polynomial") {
  	return simplify$2(['-', p ]);
      }

      let result = ["polynomial", p[1], []];
      let p_terms = p[2];
      let result_terms = result[2];

      let len = p_terms.length;

      for (var i = 0; i < len; i = i + 1){
          result_terms.push([p_terms[i][0], polynomial_neg(p_terms[i][1])]);
      }

      return result;
  }


  function polynomial_sub(p,q) {

      return polynomial_add(p, polynomial_neg(q));

  }


  function polynomial_mul(p,q) {

      if(p[0] !== "polynomial") {
  	if(q[0] !== "polynomial") {
  	    return simplify$2(['*', p, q]);
  	}
  	else if(p) {
  	    let prod = ["polynomial", q[1], []];
  	    let q_terms = q[2];
  	    let prod_terms = prod[2];
  	    for(let term of q_terms) {
  		if(term[1])
  		    prod_terms.push([term[0], polynomial_mul(p, term[1])]);
  	    }
  	    return prod;
  	}
      }
      else {
  	if (q && q[0] !== "polynomial") {
  	    let prod = ["polynomial", p[1], []];
  	    let p_terms = p[2];
  	    let prod_terms = prod[2];
  	    for(let term of p_terms) {
  		if(term[1])
  		    prod_terms.push([term[0], polynomial_mul(term[1], q)]);
  	    }
  	    return prod;
  	}
      }

      // two non-constant polynomials
      // if needed, rewrite polynomials so have same first variable
      let tmp = polynomials_in_same_leading_variable(p,q);
      p = tmp[0];
      q = tmp[1];

      let p_terms = p[2];
      let q_terms = q[2];

      let prod = ["polynomial", p[1], []];
      let prod_terms = prod[2];
      let p_len = p_terms.length;
      let q_len = q_terms.length;

      //find the degrees that will occur in the product
      let degrees = [];
      for (let term_p of p_terms){
          for (let term_q of q_terms){
              let found = false;
              let current_deg = term_p[0] + term_q[0];
              for (let deg of degrees){
                  if (current_deg === deg){
                      found = true;
                      break;
                  }
              }
              if (!found)
                  degrees.push(current_deg);
          }
      }

      degrees.sort(function(a, b){return a - b});

      //this is where the product is computed
      for(let deg of degrees){
          let sum = 0;
          let i = 0;
          while (i < p_len && p_terms[i][0] <= deg){
              let j = 0;
              while (j < q_len && q_terms[j][0] <= deg){
                  if ((p_terms[i][0] + q_terms[j][0]) === deg){
                      sum = polynomial_add(sum, polynomial_mul(p_terms[i][1], q_terms[j][1]));
                      break;
                  }
                  j = j+1;
              }
              i = i+1;
          }
          if(sum)
              prod_terms.push([deg, sum]);
      }

      return prod;
  }


  function polynomial_pow(p, e) {

      if(isNaN(e) || e < 0 || !Number.isInteger(e))
  	return undefined;

      let res = 1;

      while(e > 0) {

  	if(e & 1) {
  	    // odd exponent
  	    res = polynomial_mul(res, p);
  	}

  	p = polynomial_mul(p, p);

  	e >>= 1; // divide by 2 and truncate

      }

      return res;
  }


  function polynomial_to_expression(p) {

      if(!Array.isArray(p) || p[0] !== "polynomial")
  	return p;

      let x = p[1];
      let terms = p[2];

      let result = [];

      let len_terms = terms.length;
      for(var i = 0; i < len_terms; i = i+1) {
  	if(terms[i][1]) {
  	    if(terms[i][0]===0)
  		result.push(polynomial_to_expression(terms[i][1]));
  	    else if(terms[i][0]===1)
  		result.push(['*', polynomial_to_expression(terms[i][1]), x]);
  	    else
  		result.push(['*', polynomial_to_expression(terms[i][1]),
  			     ['^', x, terms[i][0]]]);

  	}
      }

      if(result.length === 0)
  	return 0;
      else if(result.length === 1)
  	result = result[0];
      else
  	result.unshift('+');

      return simplify$2(result);
  }


  function initial_term(p) {
      //takes a polynomial ["polynomial", "var"...] and returns the initial term according to lexicographic order, in form ["monomial", coefficient, [[variable1, power1], ...]]

      if (!Array.isArray(p) || p[0] !== "polynomial")
          return p;

      let var_powers = [];

      while( Array.isArray(p) && p[0] === "polynomial"){
          let x = p[1];
          let terms = p[2];
          let exp = (terms[terms.length-1])[0];
          p = (terms[terms.length-1])[1];
          var_powers.push([x,exp]);
      }

      return ["monomial", p, var_powers];
  }

  function mono_less_than(left,right) {
      //takes two monomials ["monomial", coeff, terms array] and returns true if left is less than right in lexicographic order.
      //stringify vars before calling this

      if (!Array.isArray(right) || right[0] !== "monomial")
          return false;           //if right is constant, always false

      if (!Array.isArray(left) || left[0] !== "monomial")
          return true;        //if left is constant and right is not, always true

      let left_vars = left[2];
      let right_vars = right[2];
      let left_length = left_vars.length;
      let right_length = right_vars.length;
      var shorter;
      if (left_length < right_length)
          shorter = left_length;
      else
          shorter = right_length;

      for ( var i = 0; i < shorter; i++ ){
          if(left_vars[i][0] !== right_vars[i][0]) {
              if(compare_function(left_vars[i][0], right_vars[i][0]) < 0) {
                  // left variable is earlier in default order
                  return false;
              }
              else {
                  // right variable is earlier in default order
                  return true;
              }
          }
          if(left_vars[i][1] < right_vars[i][1]) {
              // left power is lower
              return true;
          }
          if(left_vars[i][1] > right_vars[i][1]) {
              // right power is lower
              return false;
          }
      }
      if ( left_length === right_length || shorter === right_length ){
          // same monomial, except possibly coefficient, or same until left is longer
          return false;
          }
      else {
          // same until right is longer
          return true;
      }
  }


  function mono_gcd(left, right) {
      //takes two monomials ["monomial", coeff, terms array] and returns their greatest common divisor as a monomial
      //stringify vars before calling this

      if (!Array.isArray(left) || !Array.isArray(right) || left[0] !== "monomial" || right[0] !== "monomial")
          return 1;               //if either is constant, gcd is 1

      let left_vars = left[2];
      let right_vars = right[2];
      let gcd_vars = [];
      let left_length = left_vars.length;
      let right_length = right_vars.length;

      let i = 0;
      let j = 0;
      while (i < left_length && j < right_length){
          if (left_vars[i][0] === right_vars[j][0]){
              if (left_vars[i][1] < right_vars[j][1]){
                  gcd_vars.push(left_vars[i]);
              }
              else{
                  gcd_vars.push(right_vars[j]);
              }
              i = i + 1;
              j = j + 1;
          }
          else if (compare_function(left_vars[i][0], right_vars[j][0]) < 0){
              i = i + 1;
          }
          else if (compare_function(right_vars[j][0], left_vars[i][0]) < 0){
              j = j + 1;
          }
      }

      if (gcd_vars.length === 0)
          return 1;           //if they have no common variables, gcd is 1

      return ["monomial", 1, gcd_vars];
  }

  function mono_div(top, bottom) {
      //!!This function should only be called if bottom has coefficient 1 and divides the top (e.g., bottom was computed using mono_gcd)!!
      //takes two monomials ["monomial", coeff, terms array] and returns their quotient as a monomial
      //stringify vars before calling this

      if ( !Array.isArray(bottom) || bottom[0] !== "monomial"){
          //if bottom is constant
          if (bottom === 1)
              return top;
          if ( !Array.isArray(top) || top[0] !== "monomial")      //if top is constant
              return evaluate_numbers(['/', top, bottom]);
          else
              return [top[0], evaluate_numbers(['/', top[1], bottom]), top[2]];       //shouldn't be passing constants other than 1
      }

      if ( !Array.isArray(top) || top[0] !== "monomial")      //if top is constant and bottom is not
          return undefined;

      let top_vars = top[2];
      let bottom_vars = bottom[2];
      let div_vars = [];
      let top_length = top_vars.length;
      let bottom_length = bottom_vars.length;

      let i = 0;
      let j = 0;
      while (i < top_length && j < bottom_length){
          if (top_vars[i][0] === bottom_vars[j][0]){
              if (top_vars[i][1] < bottom_vars[j][1]){
                  return undefined;       //does not divide
              }
              else{
                  let diff = top_vars[i][1] - bottom_vars[j][1];
                  if (diff !== 0)
                      div_vars.push( [ top_vars[i][0] , diff ] );
              }
              i = i + 1;
              j = j + 1;
          }
          else if (compare_function(top_vars[i][0], bottom_vars[j][0]) < 0){
              div_vars.push( top_vars[i] );
              i = i + 1;
          }
          else if (compare_function(bottom_vars[j][0], top_vars[i][0]) < 0){
              return undefined;           //does not divide
          }
      }

      if (j < bottom_length)
          return undefined;

      while (i < top_length){
          div_vars.push( top_vars[i]);
          i=i+1;
      }

      if (div_vars.length === 0){
          if (bottom[1] === 1)
              return top[1];           //everything canceled, return coefficient of the top
          else
              return evaluate_numbers(['/', top[1], bottom[1]]);
      }

      if (bottom[1] === 1)
          return ["monomial", top[1], div_vars];
      else
          return ["monomial", evaluate_numbers(['/', top[1], bottom[1]]), div_vars];
  }

  function mono_is_div(top, bottom) {
      //takes two monomials ["monomial", coeff, terms array] and returns true if bottom divides top, otherwise returns false
      //stringify vars before calling this

      if (bottom === 0)
          return false;

      if ( !Array.isArray(bottom) || bottom[0] !== "monomial"){   //if bottom is nonzero constant
          return true;
      }

      if ( !Array.isArray(top) || top[0] !== "monomial")      //if top is constant and bottom is not
          return false;

      let top_vars = top[2];
      let bottom_vars = bottom[2];
      let div_vars = [];
      let top_length = top_vars.length;
      let bottom_length = bottom_vars.length;

      let i = 0;
      let j = 0;
      while (i < top_length && j < bottom_length){
          if (top_vars[i][0] === bottom_vars[j][0]){
              if (top_vars[i][1] < bottom_vars[j][1]){
                  return false;       //does not divide
              }
              else{
                  let diff = top_vars[i][1] - bottom_vars[j][1];
                  if (diff !== 0)
                      div_vars.push( [ top_vars[i][0] , diff ] );
              }
              i = i + 1;
              j = j + 1;
          }
          else if (compare_function(top_vars[i][0], bottom_vars[j][0]) < 0){
              div_vars.push( top_vars[i] );
              i = i + 1;
          }
          else if (compare_function(bottom_vars[j][0], top_vars[i][0]) < 0){
              return false;           //does not divide
          }
      }

      if (j < bottom_length)
          return false;

      return true;
  }

  function mono_to_poly(mono){
      //takes a monomial ["monomial", coeff, terms array] and returns the corresponding polynomial ["polynomial", var1, ...]

      if ( !Array.isArray(mono) || mono[0] !== "monomial")
          return mono;            //if constant, just return itself

      let num_vars = mono[2].length;
      let i = num_vars-1;
      let result = mono[1];

      while ( i >= 0){
          var coeffs = [];
          coeffs.push([mono[2][i][1],result]);
          result = ["polynomial", mono[2][i][0], coeffs];
          i=i-1;
      }

      return result;
  }

  function max_div_init(f$$1, monos){
      //f is a polynomial ["polynomial", ...], monos is array of monomials ["monomial", ...]. returns the largest term (a monomial) of f divisible by something
      //in monos, and the index of the divisor.
      //stringify vars before calling this

      if ( f$$1 === 0){
          return 0;
      }
      let focus = f$$1;
      let var_powers = [];

      while( Array.isArray(focus) && focus[0] === "polynomial"){
          let x = focus[1];
          let terms = focus[2];
          let exp = terms[terms.length-1][0];
          focus = terms[terms.length-1][1];
          var_powers.push([x,exp]);
      }

      let current_term = ["monomial", focus, var_powers];

      let monos_size = monos.length;
      for ( var i = 0; i < monos_size; i = i+1 ){
          if (mono_is_div(current_term, monos[i])){
              return [current_term, i];
          }
      }

      return max_div_init(polynomial_sub( f$$1, mono_to_poly(current_term)), monos);
  }

  function poly_div(f$$1, divs){
      //takes a polynomial f and an array of polynomials div = [g1,g2,...], and returns a standard expression (according to mult. division) of the form [[[s1,m1],[s2,m2],....], f'] where f=m1g_{s1}+m2g_{s2}+...+f'
      //stringify vars before calling this

      let inits = [];
      let su_mu = [];
      let sp = [];
      let mp = [];
      let f_prime = f$$1;

      for (var g of divs){
          inits.push(initial_term(g));
      }

      let m = max_div_init(f_prime, inits);

      while (m !== 0){
          sp = m[1];
          mp = mono_div(m[0], inits[sp]);
          su_mu.push([sp, mp]);
          f_prime = polynomial_sub(f_prime, polynomial_mul(mono_to_poly(mp), divs[sp]));
          m = max_div_init(f_prime, inits);
      }

      return [su_mu, f_prime];
  }

  function prereduce(polys){
      //takes an array of polys, and does some simply reductions: gets rid of 0 polynomials, if there's a constant: just return [1], if there are no nonzero polys: return [0].

      let len = polys.length;
      let new_polys = [];

      //check for 0's, constants
      for (var j = 0; j < len; j++ ){
          if (polys[j] !== 0 && (!Array.isArray(polys[j]) || polys[j][0] !== "polynomial")){
              return [1];       //if there's a nonzero constant, return [1]
          }
          if (polys[j] !== 0){
              new_polys.push(polys[j]);
          }
      }

      if (new_polys.length === 0)
          return [0];

      return new_polys;
  }

  function reduce_ith(i, polys){
      //takes an index i and an array polys of polynomials, and reduces the ith polynomial wrt the rest (i.e., finds a std expression and replaces with f'). Returns the reduced polynomial.
      //stringify vars before calling this

      let inits = [];
      let sp = [];
      let mp = [];
      let f_prime = polys[i];
      let len = polys.length;

      for (var j = 0; j < len; j = j+1){
          if (j === i)                         //don't want to cancel out with itself, so put 0 for this initial term instead to avoid it being used
              inits.push(0);
          else
              inits.push(initial_term(polys[j]));
      }

      let m = max_div_init(f_prime, inits);

      while (m !== 0){
          sp = m[1];
          mp = mono_div(m[0], inits[sp]);
          f_prime = polynomial_sub(f_prime, polynomial_mul(mono_to_poly(mp), polys[sp]));
          m = max_div_init(f_prime, inits);
      }

      return f_prime;

      /*  OLD CODE:

       if (!Array.isArray(polys) || i >= polys.length){
          return undefined;
      }

      let len = polys.length;
      let new_polys = [];

      //check for 0's, constants
      for (var j = 0; j < len; j++ ){
          if (polys[j] !== 0 && (!Array.isArray(polys[j]) || polys[j][0] !== "polynomial")){
              return 1;       //if there's a nonzero constant, return [1]
          }
          if (polys[j] !== 0){
              new_polys.push(polys[j]);
          }
      }

      len = new_polys.length;

      if (len === 0)
          return 0;         //if there were no nonzero polys, return [0]

      if (len === 1)
          return new_polys[0];           //if there's only one poly, don't need to reduce

      let others = [];
      for ( var j = 0; j < len; j++ ){
          if (j !== i)
              others.push(new_polys[j]);
      }

      return poly_div(new_polys[i], others)[1];*/
  }

  function reduce$1(polys){
      //takes an array of polynomials, and reduces them with respect to each other until they can't be reduced anymore. Returns array of reduced polynomials.
      //this could be made more efficient with better bookkeeping if necessary - currently copying sub-arrays a lot, whenever call reduce_ith. Would need to track changes in sub-arrays.
      //stringify vars before calling this

      let i = 0;
      let h=[];
      let new_polys = prereduce(polys);
      let len = new_polys.length;

      if (len === 1)
          return new_polys;           //if there's only one poly, don't need to reduce
      /*prereduce more frequently:
      while (i < len){
          h = reduce_ith(i, new_polys);
          if ( _.isEqual( h, new_polys[i] )){      //from underscore lib to compare arrays with objects
              i=i+1;
          }
          else{
              new_polys[i] = h;
              i = 0;
              new_polys = prereduce(new_polys);
              len = new_polys.length;
          }
      }*/

      /*      This code prereduces less frequently, maybe slightly faster?*/
      let trigger = true;
      while (trigger){
          trigger = false;
          new_polys = prereduce(new_polys);
          len = new_polys.length;
          i = 0;
          while (i < len){
              h = reduce_ith(i, new_polys);
              if ( !underscore.isEqual( h, new_polys[i] )){      //from underscore lib to compare arrays with objects
                  new_polys[i]=h;
                  trigger = true;
              }
              i = i+1;
          }
      }

      i = 0;
      let init = [];
      let coeff = 0;
      while (i < len){            //leading coeffs should be 1
          init = initial_term(new_polys[i]);
          if (!Array.isArray(init) || init[0] !== "monomial")
              new_polys[i] = 1;
          else{
              coeff = init[1];
              if (coeff !== 1)
                  new_polys[i] = polynomial_mul(new_polys[i], ['/', 1, coeff]);
          }
          i = i + 1;
      }

      return new_polys;
  }

  function hij(i, j, polys){
      //takes indices i,j and an array of polynomials. Returns the polynomial hij computed from the ith and jth polys in polynomials, for Buchberger's criterion.
      //stringify vars before calling this

      let init_gi = initial_term(polys[i]);
      let init_gj = initial_term(polys[j]);
      let gcd = mono_gcd(init_gi, init_gj);
      let mij = mono_to_poly(mono_div(init_gi, gcd));
      let mji = mono_to_poly(mono_div(init_gj, gcd));
      let std_exp = poly_div(polynomial_sub(polynomial_mul(mji, polys[i]), polynomial_mul(mij, polys[j])), polys);
      return std_exp[1];
  }

  function build_hij_table(table, polys){
      //takes an empty table and an array of polynomials, and fills in table where table[[i,j]]=h_ij for i < j < polys.length. (Look up h_ij based on the index in polys) returns first choice for h
      //stringify vars before calling this

      let len = polys.length;
      let i = 0;
      let j = 1;

      let candidates = [];

      while (j < len){
          while (i < j){
              table[[i,j]] = hij(i,j,polys);
              if (table[[i,j]] !== 0)
                  candidates.push(table[[i,j]]);
              i = i + 1;
          }
          i = 0;
          j = j + 1;
      }

      if (candidates.length > 0)
          return choice_lowest_degree(candidates);           //call different choice functions here. Could avoid iterating through again if check as go.

      return 0;
  }

  function update_hij_table(table, polys, h){
      //takes an hij table, array of polynomials that the table was built for, and a poynomial h. Updates the hij values for the addition of the polynomial h, h is added with the highest index. return next choice of h.

      let len = polys.length;
      polys.push(h);
      let i = 0;
      let j = 1;

      let candidates = [];
      while (j < len){                //this loop updates old hij values.
          while (i < j){
              if (table[[i,j]] !== 0){
                  table[[i,j]] = hij(i,j,polys);
                  if (table[[i,j]] !== 0)
                      candidates.push(table[[i,j]]);
              }
              i = i + 1;
          }
          i = 0;
          j = j+1;
      }

      while (i < len){                //this loop adds values with h
          table [[i,len]] = hij(i,len,polys);
          if (table[[i,len]] !== 0)
              candidates.push(table[[i,len]]);
          i = i + 1;
      }

      if (candidates.length > 0)
          return choice_lowest_degree(candidates);           //call different choice functions here. Could avoid iterating through again if check as go.

      return 0;
  }

  function choice_lowest_degree(polys){
      //takes an array of polynomials, returns the polynomial of lowest degree.

      let inits = [];
      let len = polys.length;

      for (i = 0; i < len; i = i+1){
          inits.push(initial_term(polys[i]));
      }

      let min_index = 0;
      for (var i = 1; i < len; i = i+1){
          if (inits[i] === 1)
              return 1;
          if (mono_less_than(inits[i], inits[min_index]))
              min_index = i;
      }

      return polys[min_index];
  }

  function reduced_grobner(polys){
      //takes an array of polynomials, returns reduced grobner basis of the ideal they generate.
      //stringify vars before calling this

      let new_polys = reduce$1(polys);

      let table = {};
      let h = build_hij_table(table, new_polys);
      while (h !== 0){
          h = update_hij_table(table, new_polys, h);
      }

      new_polys = reduce$1(new_polys);

      return new_polys;
  }

  function poly_lcm(f$$1,g){
      //takes two polynomials f and g, and returns their least common multiple.
      //stringify vars before calling this

      let t = ["polynomial", "_t", [[1,1]]];
      let one_minus_t = ["polynomial", "_t", [[0,1], [1,-1]]];
      let grob = reduced_grobner([polynomial_mul(t, f$$1), polynomial_mul(one_minus_t, g)]);

      //find term without _t
      let len = grob.length;
      for (var i = 0; i < len; i = i + 1){
          if (!Array.isArray(grob[i]) || grob[i][0] !== "polynomial"){
              return 1;           //if there is a constant in the grobner basis, return 1 (shouldn't have constants other than 1, so could probably just check for 1)
          }
          if (grob[i][1] !== "_t")
              return grob[i];
      }

      return undefined;       //this should never be reached, unless something bad happens?
  }

  function poly_gcd(f$$1,g){
      //takes two polynomials f and g, and returns their greatest common divisor.
      //stringify vars before calling this

      let lcm = poly_lcm(f$$1,g);
      let fg = polynomial_mul(f$$1,g);
      let std_exp = poly_div(fg, [lcm]);

      let sum = 0;
      let len = std_exp[0].length;
      for (var i = 0; i < len; i = i+1){
          sum = polynomial_add(sum, mono_to_poly(std_exp[0][i][1]));
      }

      //divide by leading coeff, so leading coeff of gcd is 1
      let init = initial_term(sum);
      if (!Array.isArray(init) || init[0] !== "monomial")
          sum = 1;
      else{
          let coeff = init[1];
          if (coeff !== 1)
              sum = polynomial_mul(sum, ['/', 1, coeff]);
      }

      return sum;
  }

  function poly_by_divisor(f$$1, d){
      //takes two polynomials f and d (where d is a divisor of f), and returns f divided by d.
      //!!Only call if d evenly divides f!!
      //stringify vars before calling this

      let std_exp = poly_div(f$$1, [d]);
      let sum = 0;
      let len = std_exp[0].length;
      for (var i = 0; i < len; i = i+1){
          sum = polynomial_add(sum, mono_to_poly(std_exp[0][i][1]));
      }
      return sum;
  }

  function reduce_rational_expression(top, bottom){
      //input: top and bottom of a rational expression. top and bottom should be polynomials, ["polynomial", ...]. returns an array with two entries: new_top and new_bottom, which are reduced (gcd of new_top and new_bottom is 1). new_bottom will always have leading coefficient 1 (according to lexicographic order)

      let stringy_top = stringify_vars(top);
      let stringy_bottom = stringify_vars(bottom);
      top = stringy_top[0];
      bottom = stringy_bottom[0];

      let gcd = poly_gcd(top, bottom);
      let denom_coeff = (initial_term(bottom))[1];
      let div = polynomial_mul(gcd,denom_coeff);
      let new_top = poly_by_divisor(top, div);
      let new_bottom = poly_by_divisor(bottom, div);
      return [destringify_vars(destringify_vars(new_top, stringy_top[1]), stringy_bottom[1]), destringify_vars(destringify_vars(new_bottom, stringy_top[1]), stringy_bottom[1])];
  }

  function stringify_vars(f$$1){
      //takes a polynomial f and converts all variables to strings. Returns the new, stringy polynomial, and a dictionary to convert back to the original degrees.

      if (!Array.isArray(f$$1) || f$$1[0] !== "polynomial")
          return [f$$1, {}];             //if it's not a polynomial, don't need to change anything.

      let table = {};
      let var_string = "z" + JSON.stringify(f$$1[1]);
      table[var_string] = f$$1[1];
      f$$1[1] = var_string;

      let terms = f$$1[2];
      let current = [];
      for (let f_term of terms){
          current = stringify_vars(f_term[1]);
          f_term[1] = current[0];
          for (let key in current[1]){
              table[key] = current[1][key];
          }
      }

      return [f$$1, table];
  }

  function destringify_vars(f$$1, table){
      //takes a stringy polynomial and a dictionary {string:actual_variable,...} and returns the polynomial with strings replaced with the actual variable they represent.

      if (!Array.isArray(f$$1) || f$$1[0] !== "polynomial")
          return f$$1;               //it it's not a polynomial, don't need to change anything.

      if (table[f$$1[1]])
          f$$1[1] = table[f$$1[1]];

      let terms = f$$1[2];
      for (let f_term of terms){
          f_term[1] = destringify_vars(f_term[1], table);
      }

      return f$$1;
  }

  var textToAst$3 = new textToAst();

  function common_denominator(tree, assumptions) {

      tree = simplify$2(tree, assumptions);

      var transformations = [];
      transformations.push(
  	[textToAst$3.convert("a/c+b/c"), textToAst$3.convert("(a+b)/c"),
  	 {evaluate_numbers: true,
  	  allow_extended_match: true,
  	  allow_permutations: true,
  	  max_group: 1,
  	 }]
      );
      transformations.push(
  	[textToAst$3.convert("a/c-b/c"), textToAst$3.convert("(a-b)/c"),
  	 {evaluate_numbers: true,
  	  allow_extended_match: true,
  	  allow_permutations: true,
  	  max_group: 1,
  	 }]
      );
      transformations.push(
  	[textToAst$3.convert("a+b/c"), textToAst$3.convert("(ac+b)/c"),
  	 {evaluate_numbers: true,
  	  allow_extended_match: true,
  	  allow_permutations: true,
  	  max_group: 1,
  	 }]
      );
      transformations.push(
  	[textToAst$3.convert("a-b/c"), textToAst$3.convert("(ac-b)/c"),
  	 {evaluate_numbers: true,
  	  allow_extended_match: true,
  	  allow_permutations: true,
  	  max_group: 1,
  	 }]
      );
      transformations.push(
  	[textToAst$3.convert("a/d+b/c"), textToAst$3.convert("(ac+bd)/(cd)"),
  	 {evaluate_numbers: true,
  	  allow_extended_match: true,
  	  allow_permutations: true,
  	  max_group: 1,
  	 }]
      );
      transformations.push(
  	[textToAst$3.convert("a/d-b/c"), textToAst$3.convert("(ac-bd)/(cd)"),
  	 {evaluate_numbers: true,
  	  allow_extended_match: true,
  	  allow_permutations: true,
  	  max_group: 1,
  	 }]
      );
      transformations.push([textToAst$3.convert("x*(y/z)"), textToAst$3.convert("(x*y)/z"),
      			  {allow_extended_match: true,
      			   allow_permutations: true,
  			   max_group: 1,
      			  }]);
      transformations.push([textToAst$3.convert("(x/y)/z"), textToAst$3.convert("x/(y*z)"),
      			  {allow_extended_match: true,
      			   allow_permutations: true,
      			  }]);
      transformations.push([textToAst$3.convert("x/(y/z)"), textToAst$3.convert("xz/y"),
      			  {allow_extended_match: true,
      			   allow_permutations: true,
      			  }]);

      tree = applyAllTransformations(tree, transformations, 40);

      tree = expand(tree, true);

      return tree;
  }


  function as_num_denom(expr_or_tree) {
      // Return tuple containing numerator and denominator
      // after attempting to place over common denominator

      var tree = get_tree(expr_or_tree);

      tree = common_denominator(tree);

      if(tree[0] === '/')
  	return [tree[1], tree[2]];
      else
  	return [tree, 1];
  }

  function reduce_rational(expr_or_tree) {
      var tree = get_tree(expr_or_tree);

      var num_denom = as_num_denom(tree);

      if(num_denom[1] === 1)
  	return tree;

      var poly_num = expression_to_polynomial(num_denom[0]);
      var poly_denom = expression_to_polynomial(num_denom[1]);

      var reduced_polys = reduce_rational_expression(poly_num, poly_denom);

      var num_new = polynomial_to_expression(reduced_polys[0]);
      var denom_new = polynomial_to_expression(reduced_polys[1]);

      if(denom_new === 1)
  	return num_new;
      else
  	return ['/', num_new, denom_new];

  }

  const common_demoninator = common_denominator;

  var rational = /*#__PURE__*/Object.freeze({
    reduce_rational: reduce_rational,
    common_demoninator: common_demoninator
  });

  function round_numbers_to_precision(expr_or_tree, digits=14) {
    // round any decimals to specified number of significant digits

    var tree = get_tree(expr_or_tree);

    if(digits < 1) {
      throw Error("For round_numbers_to_precision, digits must be positive");
    }

    if(!Number.isFinite(digits)) {
      throw Error("For round_numbers_to_precision, digits must be a number");
    }

    if(digits > 15) {
      return tree;
    }

    digits = Math.round(digits);

    return round_numbers_to_precision_sub(tree,digits);
  }

  const round_numbers_to_precision_sub = function(tree, digits=14) {

    if(typeof tree === "number") {

      if(Number.isFinite(tree) && tree !== 0) {
        const scaleFactor = math$19.floor(math$19.log10(math$19.abs(tree)));
        const n = digits - scaleFactor - 1;
        if(n < 0) {
          // mathjs toFixed truncates zeros when n is negative
          // so add back on when creating float
          return parseFloat(number_7(tree, n)+'0'.repeat(math$19.abs(n)));
        } else {
          return parseFloat(number_7(tree, n))
        }
      }
    }
    if(!Array.isArray(tree)) {
      return tree;
    }
    let operator = tree[0];
    let operands = tree.slice(1);
    return [operator, ...operands.map(x => round_numbers_to_precision_sub(x,digits))]
  };


  function round_numbers_to_decimals(expr_or_tree, ndecimals=14) {
    // round any numbers to specified number of decimals

    var tree = get_tree(expr_or_tree);


    if(!Number.isFinite(ndecimals)) {
      throw Error("For round_numbers_to_decimals, ndecimals must be a number");
    }

    ndecimals = Math.round(ndecimals);

    // no need to go much beyond limits of double precision
    ndecimals = Math.max(-330, Math.min(330, ndecimals));

    return round_numbers_to_decimals_sub(tree,ndecimals);
  }

  const round_numbers_to_decimals_sub = function(tree, ndecimals=0) {

    if(typeof tree === "number") {
      if(ndecimals < 0) {
        // mathjs toFixed truncates zeros when n is negative
        // so add back on when creating float
        return parseFloat(number_7(tree, ndecimals)+'0'.repeat(math$19.abs(ndecimals)));
      } else {
        return parseFloat(number_7(tree, ndecimals))
      }
    }
    if(!Array.isArray(tree)) {
      return tree;
    }
    let operator = tree[0];
    let operands = tree.slice(1);
    return [operator, ...operands.map(x => round_numbers_to_decimals_sub(x,ndecimals))]
  };

  var round$2 = /*#__PURE__*/Object.freeze({
    round_numbers_to_precision: round_numbers_to_precision,
    round_numbers_to_decimals: round_numbers_to_decimals
  });

  const expression_to_tree = [
      simplify$3,
      differentiation,
      normalization,
      sign_error,
      arithmetic$1,
      transformation,
      solve,
      sets,
      matrix$5,
      rational,
      round$2,
  ];

  const expression_to_other = [
      variables$1,
      printing,
      equality,
    integration,
    evaluation,
    analytic,
  ];

  // standard functions

  //"intersect", "cross", "det", "diag", "dot", "eye", " inv", " sort", " trace", " transpose", "max", "mean", "median", "min", "mode", "nthRoot"
  // "ceil", "fix", "floor", "round"

  function abs$2(expr_or_tree) {return ['apply', 'abs', get_tree(expr_or_tree)];}
  function exp$2(expr_or_tree) {return ['apply', 'exp', get_tree(expr_or_tree)];}
  function log$2(expr_or_tree) {return ['apply', 'log', get_tree(expr_or_tree)];}
  function log10$2(expr_or_tree) {return ['apply', 'log10', get_tree(expr_or_tree)];}
  function sign$4(expr_or_tree) {return ['apply', 'sign', get_tree(expr_or_tree)];}
  function sqrt$2(expr_or_tree) {return ['apply', 'sqrt', get_tree(expr_or_tree)];}
  function conj$2(expr_or_tree) {return ['apply', 'conj', get_tree(expr_or_tree)];}
  function im$2(expr_or_tree) {return ['apply', 'im', get_tree(expr_or_tree)];}
  function re$2(expr_or_tree) {return ['apply', 're', get_tree(expr_or_tree)];}
  function factorial$2(expr_or_tree) {return ['apply', 'factorial', get_tree(expr_or_tree)];}
  function gamma$2(expr_or_tree) {return ['apply', 'gamma', get_tree(expr_or_tree)];}
  function erf$2(expr_or_tree) {return ['apply', 'erf', get_tree(expr_or_tree)];}
  function acos$2(expr_or_tree) {return ['apply', 'acos', get_tree(expr_or_tree)];}
  function acosh$2(expr_or_tree) {return ['apply', 'acosh', get_tree(expr_or_tree)];}
  function acot$2(expr_or_tree) {return ['apply', 'acot', get_tree(expr_or_tree)];}
  function acoth$2(expr_or_tree) {return ['apply', 'acoth', get_tree(expr_or_tree)];}
  function acsc$2(expr_or_tree) {return ['apply', 'acsc', get_tree(expr_or_tree)];}
  function acsch$2(expr_or_tree) {return ['apply', 'acsch', get_tree(expr_or_tree)];}
  function asec$2(expr_or_tree) {return ['apply', 'asec', get_tree(expr_or_tree)];}
  function asech$2(expr_or_tree) {return ['apply', 'asech', get_tree(expr_or_tree)];}
  function asin$2(expr_or_tree) {return ['apply', 'asin', get_tree(expr_or_tree)];}
  function asinh$2(expr_or_tree) {return ['apply', 'asinh', get_tree(expr_or_tree)];}
  function atan$2(expr_or_tree) {return ['apply', 'atan', get_tree(expr_or_tree)];}
  function atanh$2(expr_or_tree) {return ['apply', 'atanh', get_tree(expr_or_tree)];}
  function cos$2(expr_or_tree) {return ['apply', 'cos', get_tree(expr_or_tree)];}
  function cosh$2(expr_or_tree) {return ['apply', 'cosh', get_tree(expr_or_tree)];}
  function cot$2(expr_or_tree) {return ['apply', 'cot', get_tree(expr_or_tree)];}
  function coth$2(expr_or_tree) {return ['apply', 'coth', get_tree(expr_or_tree)];}
  function csc$2(expr_or_tree) {return ['apply', 'csc', get_tree(expr_or_tree)];}
  function csch$2(expr_or_tree) {return ['apply', 'csch', get_tree(expr_or_tree)];}
  function sec$2(expr_or_tree) {return ['apply', 'sec', get_tree(expr_or_tree)];}
  function sech$2(expr_or_tree) {return ['apply', 'sech', get_tree(expr_or_tree)];}
  function sin$2(expr_or_tree) {return ['apply', 'sin', get_tree(expr_or_tree)];}
  function sinh$2(expr_or_tree) {return ['apply', 'sinh', get_tree(expr_or_tree)];}
  function tan$2(expr_or_tree) {return ['apply', 'tan', get_tree(expr_or_tree)];}
  function tanh$2(expr_or_tree) {return ['apply', 'tanh', get_tree(expr_or_tree)];}

  // function of two variables
  function atan2$2(expr_or_tree1, expr_or_tree2) {
      return ['apply', 'atan2', ['tuple', get_tree(expr_or_tree1),
  			       get_tree(expr_or_tree2)]];
  }

  var standard = /*#__PURE__*/Object.freeze({
    abs: abs$2,
    exp: exp$2,
    log: log$2,
    log10: log10$2,
    sign: sign$4,
    sqrt: sqrt$2,
    conj: conj$2,
    im: im$2,
    re: re$2,
    factorial: factorial$2,
    gamma: gamma$2,
    erf: erf$2,
    acos: acos$2,
    acosh: acosh$2,
    acot: acot$2,
    acoth: acoth$2,
    acsc: acsc$2,
    acsch: acsch$2,
    asec: asec$2,
    asech: asech$2,
    asin: asin$2,
    asinh: asinh$2,
    atan: atan$2,
    atanh: atanh$2,
    cos: cos$2,
    cosh: cosh$2,
    cot: cot$2,
    coth: coth$2,
    csc: csc$2,
    csch: csch$2,
    sec: sec$2,
    sech: sech$2,
    sin: sin$2,
    sinh: sinh$2,
    tan: tan$2,
    tanh: tanh$2,
    atan2: atan2$2
  });

  const expression_to_tree$1 = [
      standard,
  ];

  // UPDATETHIS: Delete or change to new license & package name

  /*
   * recursive descent parser for math expressions
   *
   * Copyright 2014-2017 by
   *  Jim Fowler <kisonecat@gmail.com>
   *  Duane Nykamp <nykamp@umn.edu>
   *
   * This file is part of a math-expressions library
   *
   * math-expressions is free software: you can redistribute
   * it and/or modify it under the terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */

  // UPDATETHIS: Is this grammar still correct?

  /* Grammar:

     statement_list =
     statement_list ',' statement |
     statement

     statement =
     '\\dots' |
     statement_a '|' statement_a |
     statement_a 'MID' statement_a |
     statement_a ':' statement_a
     **** statement_a '|' statement_a
          used with turning off '|' statement '|' in baseFactor
          tried only after parse error encountered

     statement_a =
     statement_a 'OR' statement_b |
     statement_b

     statement_b =
     statement_b 'AND' relation |
     relation

     relation =
     'NOT' relation |
     relation '=' expression |
     relation 'NE' expression |
     relation '<' expression |
     relation '>' expression |
     relation 'LE' expression |
     relation 'GE' expression |
     relation 'IN' expression |
     relation 'NOTIN' expression |
     relation 'NI' expression |
     relation 'NOTNI' expression |
     relation 'SUBSET' expression |
     relation 'NOTSUBSET' expression |
     relation 'SUPERSET' expression |
     relation 'NOTSUPERSET' expression |
     expression

     expression =
     expression '+' term |
     expression '-' term |
     expression 'UNION' term |
     expression 'INTERSECT' term |
     '+' term |
     term

     term =
     term '*' factor |
     term nonMinusFactor |
     term '/' factor |
     factor

     baseFactor =
     '(' statement_list ')' |
     '[' statement_list ']' |
     '{' statement_list '}' |
     'LBRACE' statement_list 'RBRACE' |
     '(' statement ',' statement ']' |
     '[' statement ',' statement ')' |
     '|' statement '|' |
     \frac{statement}{statement} |
     number |
     variable |
     modified_function '(' statement_list ')' |
     modified_applied_function '(' statement_list ')' |
     modified_function '{' statement_list '}' |
     modified_applied_function '{' statement_list '}' |
     modified_function |
     modified_applied_function factor |
     sqrt '[' statement ']' '{' statement '}' |
     baseFactor '_' baseFactor |
     *** modified_applied_function factor
         allowed only if allowSimplifiedFunctionApplication==true
     *** '|' statement '|'
         allowed only at beginning of factor or if not currently in absolute value

     modified_function =
     function |
     function '_' baseFactor |
     function '_' baseFactor '^' factor |
     function '^' factor
     function "'"
     function '_' baseFactor "'"
     function '_' baseFactor "'" '^' factor
     function "'" '^' factor
     *** where the "'" after the functions can be repeated

     modified_applied_function =
     applied_function |
     applied_function '_' baseFactor |
     applied_function '_' baseFactor '^' factor |
     applied_function '^' factor
     applied_function "'"
     applied_function '_' baseFactor "'"
     applied_function '_' baseFactor "'" '^' factor
     applied_function "'" '^' factor
     *** where the "'" after the applied_functions can be repeated

     nonMinusFactor =
     baseFactor |
     baseFactor '^' factor |
     baseFactor '!' and/or "'" |
     baseFactor '!' and/or "'"  '^' factor|
     *** where '!' and/or "'"  indicates arbitrary sequence of "!" and/or "'"

     factor =
     '-' factor |
     nonMinusFactor

  */


  // Some of the latex commands that lead to spacing
  const whitespace_rule = '\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b';

  // in order to parse as scientific notation, e.g., 3.2E-12 or .7E+3,
  // it must be at the end or followed a comma, &, |, \|, ), }, \}, ], \\, or \end
  const sci_notat_exp_regex$1 = '(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?';

  const latex_rules = [
    ['[0-9]+(\\.[0-9]*)?'+sci_notat_exp_regex$1 , 'NUMBER'],
    ['\\.[0-9]+'+sci_notat_exp_regex$1, 'NUMBER'],
    ['\\*', '*'],
    ['\\/', '/'],
    ['-', '-'],
    ['\\+', '+'],
    ['\\^', '^'],
    ['\\(', '('],
    ['\\\\left\\s*\\(', '('],
    ['\\\\bigl\\s*\\(', '('],
    ['\\\\Bigl\\s*\\(', '('],
    ['\\\\biggl\\s*\\(', '('],
    ['\\\\Biggl\\s*\\(', '('],
    ['\\)', ')'],
    ['\\\\right\\s*\\)', ')'],
    ['\\\\bigr\\s*\\)', ')'],
    ['\\\\Bigr\\s*\\)', ')'],
    ['\\\\biggr\\s*\\)', ')'],
    ['\\\\Biggr\\s*\\)', ')'],
    ['\\[', '['],
    ['\\\\left\\s*\\[', '['],
    ['\\\\bigl\\s*\\[', '['],
    ['\\\\Bigl\\s*\\[', '['],
    ['\\\\biggl\\s*\\[', '['],
    ['\\\\Biggl\\s*\\[', '['],
    ['\\]', ']'],
    ['\\\\right\\s*\\]', ']'],
    ['\\\\bigr\\s*\\]', ']'],
    ['\\\\Bigr\\s*\\]', ']'],
    ['\\\\biggr\\s*\\]', ']'],
    ['\\\\Biggr\\s*\\]', ']'],
    ['\\|', '|'],
    ['\\\\left\\s*\\|', '|L'],
    ['\\\\bigl\\s*\\|', '|L'],
    ['\\\\Bigl\\s*\\|', '|L'],
    ['\\\\biggl\\s*\\|', '|L'],
    ['\\\\Biggl\\s*\\|', '|L'],
    ['\\\\right\\s*\\|', '|'],
    ['\\\\bigr\\s*\\|', '|'],
    ['\\\\Bigr\\s*\\|', '|'],
    ['\\\\biggr\\s*\\|', '|'],
    ['\\\\Biggr\\s*\\|', '|'],
    ['\\\\big\\s*\\|', '|'],
    ['\\\\Big\\s*\\|', '|'],
    ['\\\\bigg\\s*\\|', '|'],
    ['\\\\Bigg\\s*\\|', '|'],
    ['{', '{'],
    ['}', '}'],
    ['\\\\{', 'LBRACE'],
    ['\\\\left\\s*\\\\{', 'LBRACE'],
    ['\\\\bigl\\s*\\\\{', 'LBRACE'],
    ['\\\\Bigl\\s*\\\\{', 'LBRACE'],
    ['\\\\biggl\\s*\\\\{', 'LBRACE'],
    ['\\\\Biggl\\s*\\\\{', 'LBRACE'],
    ['\\\\}', 'RBRACE'],
    ['\\\\right\\s*\\\\}', 'RBRACE'],
    ['\\\\bigr\\s*\\\\}', 'RBRACE'],
    ['\\\\Bigr\\s*\\\\}', 'RBRACE'],
    ['\\\\biggr\\s*\\\\}', 'RBRACE'],
    ['\\\\Biggr\\s*\\\\}', 'RBRACE'],
    ['\\\\cdot(?![a-zA-Z])', '*'],
    ['\\\\div(?![a-zA-Z])', '/'],
    ['\\\\times(?![a-zA-Z])', '*'],
    ['\\\\frac(?![a-zA-Z])', 'FRAC'],
    [',', ','],
    [':', ':'],
    ['\\\\mid', 'MID'],

    ['\\\\vartheta(?![a-zA-Z])', 'LATEXCOMMAND', '\\theta'],
    ['\\\\varepsilon(?![a-zA-Z])', 'LATEXCOMMAND', '\\epsilon'],
    ['\\\\varrho(?![a-zA-Z])', 'LATEXCOMMAND', '\\rho'],
    ['\\\\varphi(?![a-zA-Z])', 'LATEXCOMMAND', '\\phi'],

    ['\\\\infty(?![a-zA-Z])', 'INFINITY'],

    ['\\\\asin(?![a-zA-Z])', 'LATEXCOMMAND', '\\arcsin'],
    ['\\\\acos(?![a-zA-Z])', 'LATEXCOMMAND', '\\arccos'],
    ['\\\\atan(?![a-zA-Z])', 'LATEXCOMMAND', '\\arctan'],
    ['\\\\sqrt(?![a-zA-Z])', 'SQRT'],

    ['\\\\land(?![a-zA-Z])', 'AND'],
    ['\\\\wedge(?![a-zA-Z])', 'AND'],

    ['\\\\lor(?![a-zA-Z])', 'OR'],
    ['\\\\vee(?![a-zA-Z])', 'OR'],

    ['\\\\lnot(?![a-zA-Z])', 'NOT'],

    ['=', '='],
    ['\\\\neq(?![a-zA-Z])', 'NE'],
    ['\\\\ne(?![a-zA-Z])', 'NE'],
    ['\\\\not\\s*=', 'NE'],
    ['\\\\leq(?![a-zA-Z])', 'LE'],
    ['\\\\le(?![a-zA-Z])', 'LE'],
    ['\\\\geq(?![a-zA-Z])', 'GE'],
    ['\\\\ge(?![a-zA-Z])', 'GE'],
    ['<', '<'],
    ['\\\\lt(?![a-zA-Z])', '<'],
    ['>', '>'],
    ['\\\\gt(?![a-zA-Z])', '>'],

    ['\\\\in(?![a-zA-Z])', 'IN'],

    ['\\\\notin(?![a-zA-Z])', 'NOTIN'],
    ['\\\\not\\s*\\\\in(?![a-zA-Z])', 'NOTIN'],

    ['\\\\ni(?![a-zA-Z])', 'NI'],

    ['\\\\not\\s*\\\\ni(?![a-zA-Z])', 'NOTNI'],

    ['\\\\subset(?![a-zA-Z])', 'SUBSET'],

    ['\\\\not\\s*\\\\subset(?![a-zA-Z])', 'NOTSUBSET'],

    ['\\\\supset(?![a-zA-Z])', 'SUPERSET'],

    ['\\\\not\\s*\\\\supset(?![a-zA-Z])', 'NOTSUPERSET'],

    ['\\\\cup(?![a-zA-Z])', 'UNION'],

    ['\\\\cap(?![a-zA-Z])', 'INTERSECT'],

    ['!', '!'],
    ['\'', '\''],
    ['_', '_'],
    ['&', '&'],
    ['\\\\ldots', 'LDOTS'],

    ['\\\\\\\\', 'LINEBREAK'],

    ['\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}', 'BEGINENVIRONMENT'],

    ['\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}', 'ENDENVIRONMENT'],

    ['\\\\var\\s*{\\s*[a-zA-Z0-9]+\\s*}', 'VARMULTICHAR'],

    ['\\\\[a-zA-Z]+(?![a-zA-Z])', 'LATEXCOMMAND'],
    ['[a-zA-Z]', 'VAR']
  ];


  // defaults for parsers if not overridden by context

  // if true, allowed applied functions to omit parentheses around argument
  // if false, omitting parentheses will lead to a Parse Error
  const allowSimplifiedFunctionApplicationDefault$1 = true;


  // allowed multicharacter latex symbols
  // in addition to the below applied function symbols
  const allowedLatexSymbolsDefault$1 = ['alpha', 'beta', 'gamma', 'Gamma', 'delta', 'Delta', 'epsilon', 'zeta', 'eta', 'theta', 'Theta', 'iota', 'kappa', 'lambda', 'Lambda', 'mu', 'nu', 'xi', 'Xi', 'pi', 'Pi', 'rho', 'sigma', 'Sigma', 'tau', 'Tau', 'upsilon', 'Upsilon', 'phi', 'Phi', 'chi', 'psi', 'Psi', 'omega', 'Omega', 'partial'];

  // Applied functions must be given an argument so that
  // they are applied to the argument
  const appliedFunctionSymbolsDefault$1 = ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "acos", "acosh", "acot", "acoth", "acsc", "acsch", "asec", "asech", "asin", "asinh", "atan", "atanh", "cos", "cosh", "cot", "coth", "csc", "csch", "sec", "sech", "sin", "sinh", "tan", "tanh", 'arcsin', 'arccos', 'arctan', 'arccsc', 'arcsec', 'arccot', 'cosec', 'arg'];

  // Functions could have an argument, in which case they are applied
  // or, if they don't have an argument in parentheses, then they are treated
  // like a variable, except that trailing ^ and ' have higher precedence
  const functionSymbolsDefault$1 = ['f', 'g'];

  // Parse Leibniz notation
  const parseLeibnizNotationDefault$1 = true;


  class latexToAst {
    constructor({
      allowSimplifiedFunctionApplication = allowSimplifiedFunctionApplicationDefault$1,
      allowedLatexSymbols = allowedLatexSymbolsDefault$1,
      appliedFunctionSymbols = appliedFunctionSymbolsDefault$1,
      functionSymbols = functionSymbolsDefault$1,
      parseLeibnizNotation = parseLeibnizNotationDefault$1,
    } = {}) {
      this.allowSimplifiedFunctionApplication = allowSimplifiedFunctionApplication;
      this.allowedLatexSymbols = allowedLatexSymbols;
      this.appliedFunctionSymbols = appliedFunctionSymbols;
      this.functionSymbols = functionSymbols;
      this.parseLeibnizNotation = parseLeibnizNotation;

      this.lexer = new lexer(latex_rules, whitespace_rule);

    }

    advance(params) {
      this.token = this.lexer.advance(params);
      if (this.token.token_type === 'INVALID') {
        throw new ParseError("Invalid symbol '" + this.token.original_text + "'",
          this.lexer.location);
      }
    }

    return_state() {
      return ({
        lexer_state: this.lexer.return_state(),
        token: Object.assign({}, this.token)
      });
    }

    set_state(state) {
      this.lexer.set_state(state.lexer_state);
      this.token = Object.assign({}, state.token);
    }


    convert(input) {

      this.lexer.set_input(input);
      this.advance();

      var result = this.statement_list();

      if (this.token.token_type !== 'EOF') {
        throw new ParseError("Invalid location of '" + this.token.original_text + "'",
          this.lexer.location);
      }

      return flatten$18(result);

    }

    statement_list() {

      var list = [this.statement()];

      while (this.token.token_type === ",") {
        this.advance();
        list.push(this.statement());
      }

      if (list.length > 1)
        list = ['list'].concat(list);
      else
        list = list[0];

      return list;
    }

    statement({ inside_absolute_value = 0 } = {}) {

      // \ldots can be a statement by itself
      if (this.token.token_type === 'LDOTS') {
        this.advance();
        return ['ldots'];
      }

      var original_state;

      try {

        original_state = this.return_state();

        let lhs = this.statement_a({ inside_absolute_value: inside_absolute_value });

        if (this.token.token_type !== ':' && this.token.token_type !== 'MID')
          return lhs;

        let operator = this.token.token_type === ':' ? ':' : '|';

        this.advance();

        let rhs = this.statement_a();

        return [operator, lhs, rhs];

      }
      catch (e) {
        try {

          // if ran into problem parsing statement
          // then try again with ignoring absolute value
          // and then interpreting bar as a binary operator

          // return state to what it was before attempting to parse statement
          this.set_state(original_state);

          let lhs = this.statement_a({ parse_absolute_value: false });

          if (this.token.token_type[0] !== '|') {
            throw (e);
          }

          this.advance();

          let rhs = this.statement_a({ parse_absolute_value: false });

          return ['|', lhs, rhs];

        }
        catch (e2) {
          throw (e);  // throw original error
        }
      }
    }

    statement_a({ inside_absolute_value = 0, parse_absolute_value = true } = {}) {

      var lhs = this.statement_b({
        inside_absolute_value: inside_absolute_value,
        parse_absolute_value: parse_absolute_value
      });

      while (this.token.token_type === 'OR') {

        let operation = this.token.token_type.toLowerCase();

        this.advance();

        let rhs = this.statement_b({
          inside_absolute_value: inside_absolute_value,
          parse_absolute_value: parse_absolute_value
        });

        lhs = [operation, lhs, rhs];
      }

      return lhs;
    }


    statement_b(params) {
      // split AND into second statement to give higher precedence than OR

      var lhs = this.relation(params);

      while (this.token.token_type === 'AND') {

        let operation = this.token.token_type.toLowerCase();

        this.advance();

        let rhs = this.relation(params);

        lhs = [operation, lhs, rhs];
      }

      return lhs;
    }


    relation(params) {

      if (this.token.token_type === 'NOT' || this.token.token_type === '!') {
        this.advance();
        return ['not', this.relation(params)];
      }

      var lhs = this.expression(params);

      while ((this.token.token_type === '=') || (this.token.token_type === 'NE')
        || (this.token.token_type === '<') || (this.token.token_type === '>')
        || (this.token.token_type === 'LE') || (this.token.token_type === 'GE')
        || (this.token.token_type === 'IN') || (this.token.token_type === 'NOTIN')
        || (this.token.token_type === 'NI') || (this.token.token_type === 'NOTNI')
        || (this.token.token_type === 'SUBSET') || (this.token.token_type === 'NOTSUBSET')
        || (this.token.token_type === 'SUPERSET') || (this.token.token_type === 'NOTSUPERSET')) {

        let operation = this.token.token_type.toLowerCase();

        let inequality_sequence = 0;

        if ((this.token.token_type === '<') || (this.token.token_type === 'LE')) {
          inequality_sequence = -1;
        }
        else if ((this.token.token_type === '>') || (this.token.token_type === 'GE')) {
          inequality_sequence = 1;
        }

        this.advance();
        let rhs = this.expression(params);

        if (inequality_sequence === -1) {
          if ((this.token.token_type === '<') || this.token.token_type === 'LE') {
            // sequence of multiple < or <=
            let strict = ['tuple'];
            if (operation === '<')
              strict.push(true);
            else
              strict.push(false);

            let args = ['tuple', lhs, rhs];
            while ((this.token.token_type === '<') || this.token.token_type === 'LE') {
              if (this.token.token_type === '<')
                strict.push(true);
              else
                strict.push(false);

              this.advance();
              args.push(this.expression(params));
            }
            lhs = ['lts', args, strict];
          }
          else {
            lhs = [operation, lhs, rhs];
          }

        }
        else if (inequality_sequence === 1) {
          if ((this.token.token_type === '>') || this.token.token_type === 'GE') {
            // sequence of multiple > or >=
            let strict = ['tuple'];
            if (operation === '>')
              strict.push(true);
            else
              strict.push(false);

            let args = ['tuple', lhs, rhs];
            while ((this.token.token_type === '>') || this.token.token_type === 'GE') {
              if (this.token.token_type === '>')
                strict.push(true);
              else
                strict.push(false);

              this.advance();
              args.push(this.expression(params));
            }
            lhs = ['gts', args, strict];
          }
          else {
            lhs = [operation, lhs, rhs];
          }

        }
        else if (operation === '=') {
          lhs = ['=', lhs, rhs];

          // check for sequence of multiple =
          while (this.token.token_type === '=') {
            this.advance();
            lhs.push(this.expression(params));
          }
        }
        else {

          lhs = [operation, lhs, rhs];
        }

      }

      return lhs;
    }


    expression(params) {
      if (this.token.token_type === '+')
        this.advance();

      let negative_begin = false;
      if (this.token.token_type === '-') {
        negative_begin = true;
        this.advance();
      }

      var lhs = this.term(params);

      if (negative_begin) {
        lhs = ['-', lhs];
      }

      while ((this.token.token_type === '+') || (this.token.token_type === '-')
        || (this.token.token_type === 'UNION')
        || (this.token.token_type === 'INTERSECT')) {

        let operation = this.token.token_type.toLowerCase();
        let negative = false;

        if (this.token.token_type === '-') {
          operation = '+';
          negative = true;
          this.advance();
        }
        else {
          this.advance();
          if (operation === '+' && this.token.token_type === '-') {
            negative = true;
            this.advance();
          }
        }
        let rhs = this.term(params);
        if (negative) {
          rhs = ['-', rhs];
        }

        lhs = [operation, lhs, rhs];
      }

      return lhs;
    }


    term(params) {
      var lhs = this.factor(params);

      var keepGoing = false;

      do {
        keepGoing = false;

        if (this.token.token_type === '*') {
          this.advance();
          lhs = ['*', lhs, this.factor(params)];
          keepGoing = true;
        } else if (this.token.token_type === '/') {
          this.advance();
          lhs = ['/', lhs, this.factor(params)];
          keepGoing = true;
        } else {
          // this is the one case where a | could indicate a closing absolute value
          let params2 = Object.assign({}, params);
          params2.allow_absolute_value_closing = true;
          let rhs = this.nonMinusFactor(params2);
          if (rhs !== false) {
            lhs = ['*', lhs, rhs];
            keepGoing = true;
          }
        }
      } while (keepGoing);

      return lhs;
    }


    factor(params) {
      if (this.token.token_type === '-') {
        this.advance();
        return ['-', this.factor(params)];
      }

      var result = this.nonMinusFactor(params);

      if (result === false) {
        if (this.token.token_type === "EOF") {
          throw new ParseError("Unexpected end of input", this.lexer.location);
        }
        else {
          throw new ParseError("Invalid location of '" + this.token.original_text + "'",
            this.lexer.location);
        }
      }
      else {
        return result;
      }

    }

    nonMinusFactor(params) {

      var result = this.baseFactor(params);

      // allow arbitrary sequence of factorials
      if (this.token.token_type === '!' || this.token.token_type === "'") {
        if (result === false)
          throw new ParseError("Invalid location of " + this.token.token_type,
            this.lexer.location);
        while (this.token.token_type === '!' || this.token.token_type === "'") {
          if (this.token.token_type === '!')
            result = ['apply', 'factorial', result];
          else
            result = ['prime', result];
          this.advance();
        }
      }

      if (this.token.token_type === '^') {
        if (result === false) {
          throw new ParseError("Invalid location of ^", this.lexer.location);
        }
        this.advance();

        // do not allow absolute value closing here
        let params2 = Object.assign({}, params);
        delete params2.allow_absolute_value_closing;
        delete params2.inside_absolute_value;

        return ['^', result, this.factor(params2)];
      }

      return result;
    }


    baseFactor({ inside_absolute_value = 0,
      parse_absolute_value = true,
      allow_absolute_value_closing = false
    } = {}) {

      var result = false;

      if (this.token.token_type === 'FRAC') {
        this.advance();

        if (this.token.token_type !== '{') {
          throw new ParseError("Expecting {", this.lexer.location);
        }
        this.advance();

        // determine if may be a derivative in Leibniz notation
        if (this.parseLeibnizNotation) {

          let original_state = this.return_state();

          let r = this.leibniz_notation();

          if (r) {
            // successfully parsed derivative in Leibniz notation, so return
            return r;
          }
          else {
            // didn't find a properly format Leibniz notation
            // so reset state and continue
            this.set_state(original_state);
          }
        }

        let numerator = this.statement({ parse_absolute_value: parse_absolute_value });

        if (this.token.token_type !== '}') {
          throw new ParseError("Expecting }", this.lexer.location);
        }
        this.advance();

        if (this.token.token_type !== '{') {
          throw new ParseError("Expecting {", this.lexer.location);
        }
        this.advance();

        let denominator = this.statement({ parse_absolute_value: parse_absolute_value });

        if (this.token.token_type !== '}') {
          throw new ParseError("Expecting }", this.lexer.location);
        }
        this.advance();

        return ['/', numerator, denominator];
      }

      if (this.token.token_type === 'BEGINENVIRONMENT') {
        let environment = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];

        if (['matrix', 'pmatrix', 'bmatrix'].includes(environment)) {

          let n_rows = 0;
          let n_cols = 0;

          let all_rows = [];
          let row = [];
          let n_this_row = 0;
          let last_token = this.token.token_type;

          this.advance();


          while (this.token.token_type !== 'ENDENVIRONMENT') {
            if (this.token.token_type === '&') {
              if (last_token === '&' || last_token === 'LINEBREAK') {
                // blank entry, let entry be zero
                row.push(0);
                n_this_row += 1;
              }
              last_token = this.token.token_type;
              this.advance();
            }
            else if (this.token.token_type === 'LINEBREAK') {
              if (last_token === '&' || last_token === 'LINEBREAK') {
                // blank entry, let entry be zero
                row.push(0);
                n_this_row += 1;
              }
              all_rows.push(row);
              if (n_this_row > n_cols)
                n_cols = n_this_row;

              n_rows += 1;
              n_this_row = 0;
              row = [];
              last_token = this.token.token_type;
              this.advance();
            }
            else {
              if (last_token === '&' || last_token === 'LINEBREAK' || 'BEGINENVIRONMENT') {
                row.push(this.statement({ parse_absolute_value: parse_absolute_value }));
                n_this_row += 1;
                last_token = ' ';

              }
              else {
                throw new ParseError("Invalid location of " + this.token.original_text, this.lexer.location);
              }
            }
          }

          // token is ENDENVIRONMENT
          let environment2 = /\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
          if (environment2 !== environment) {
            throw new ParseError("Expecting \\end{" + environment + "}", this.lexer.location);
          }

          // add last row
          if (last_token === '&') {
            // blank entry, let entry be zero
            row.push(0);
            n_this_row += 1;
          }
          all_rows.push(row);
          if (n_this_row > n_cols)
            n_cols = n_this_row;
          n_rows += 1;


          this.advance();

          // create matrix
          result = ["matrix", ["tuple", n_rows, n_cols]];
          let body = ["tuple"];
          for (let r of all_rows) {
            let new_row = ["tuple"].concat(r);
            for (let i = r.length; i < n_cols; i += 1)
              new_row.push(0);

            body.push(new_row);

          }
          result.push(body);

          return result;
        }
        else {
          throw new ParseError("Unrecognized environment " + environment, this.lexer.location);
        }

      }

      if (this.token.token_type === 'NUMBER') {
        result = parseFloat(this.token.token_text);
        this.advance();
      } else if (this.token.token_type === 'INFINITY') {
        result = Infinity;
        this.advance();
      } else if (this.token.token_type === 'SQRT') {
        this.advance();

        let root = 2;
        if (this.token.token_type === '[') {
          this.advance();
          let parameter = this.statement({ parse_absolute_value: parse_absolute_value });
          if (this.token.token_type !== ']') {
            throw new ParseError("Expecting ]", this.lexer.location);
          }
          this.advance();

          root = parameter;
        }

        if (this.token.token_type !== '{') {
          throw new ParseError("Expecting {", this.lexer.location);
        }

        this.advance();
        let parameter = this.statement({ parse_absolute_value: parse_absolute_value });
        if (this.token.token_type !== '}') {
          throw new ParseError("Expecting }", this.lexer.location);
        }
        this.advance();

        if (root === 2)
          result = ['apply', 'sqrt', parameter];
        else
          result = ['^', parameter, ['/', 1, root]];
      } else if (this.token.token_type === 'VAR' || this.token.token_type === 'LATEXCOMMAND'
        || this.token.token_type === 'VARMULTICHAR') {
        result = this.token.token_text;

        if (this.token.token_type === 'LATEXCOMMAND') {
          result = result.slice(1);
          if (!(this.appliedFunctionSymbols.includes(result)
            || this.functionSymbols.includes(result)
            || this.allowedLatexSymbols.includes(result)
          )) {
            throw new ParseError("Unrecognized latex command " + this.token.original_text,
              this.lexer.location);
          }
        }
        else if (this.token.token_type === 'VARMULTICHAR') {
          // strip out name of variable from \var command
          result = /\\var\s*\{\s*([a-zA-Z0-9]+)\s*\}/.exec(result)[1];
        }

        if (this.appliedFunctionSymbols.includes(result)
          || this.functionSymbols.includes(result)) {
          let must_apply = false;
          if (this.appliedFunctionSymbols.includes(result))
            must_apply = true;

          this.advance();

          if (this.token.token_type === '_') {
            this.advance();
            let subresult = this.baseFactor({ parse_absolute_value: parse_absolute_value });

            // since baseFactor could return false, must check
            if (subresult === false) {
              if (this.token.token_type === "EOF") {
                throw new ParseError("Unexpected end of input",
                  this.lexer.location);
              }
              else {
                throw new ParseError("Invalid location of '" + this.token.original_text
                  + "'", this.lexer.location);
              }
            }
            result = ['_', result, subresult];
          }

          while (this.token.token_type === "'") {
            result = ['prime', result];
            this.advance();
          }

          if (this.token.token_type === '^') {
            this.advance();
            result = ['^', result, this.factor({ parse_absolute_value: parse_absolute_value })];
          }

          if (this.token.token_type === '{' || this.token.token_type === '(') {
            let expected_right;
            if (this.token.token_type === '{')
              expected_right = '}';
            else
              expected_right = ')';

            this.advance();
            let parameters = this.statement_list();

            if (this.token.token_type !== expected_right) {
              throw new ParseError('Expecting ' + expected_right,
                this.lexer.location);
            }
            this.advance();

            if (parameters[0] === 'list') {
              // rename from list to tuple
              parameters[0] = 'tuple';
            }

            result = ['apply', result, parameters];

          }
          else {
            // if was an applied function symbol,
            // cannot omit argument
            if (must_apply) {
              if (!this.allowSimplifiedFunctionApplication)
                throw new ParseError("Expecting ( after function",
                  this.lexer.location);

              // if allow simplied function application
              // let the argument be the next factor
              result = ['apply', result, this.factor({ parse_absolute_value: parse_absolute_value })];
            }
          }
        }
        else {
          this.advance();
        }
      } else if (this.token.token_type === '(' || this.token.token_type === '['
        || this.token.token_type === '{'
        || this.token.token_type === 'LBRACE') {
        let token_left = this.token.token_type;
        let expected_right, other_right;
        if (this.token.token_type === '(') {
          expected_right = ')';
          other_right = ']';
        }
        else if (this.token.token_type === '[') {
          expected_right = ']';
          other_right = ')';
        }
        else if (this.token.token_type === '{') {
          expected_right = '}';
          other_right = null;
        }
        else {
          expected_right = 'RBRACE';
          other_right = null;
        }

        this.advance();
        result = this.statement_list();

        let n_elements = 1;
        if (result[0] === "list") {
          n_elements = result.length - 1;
        }

        if (this.token.token_type !== expected_right) {
          if (n_elements !== 2 || other_right === null) {
            throw new ParseError('Expecting ' + expected_right,
              this.lexer.location);
          }
          else if (this.token.token_type !== other_right) {
            throw new ParseError('Expecting ) or ]', this.lexer.location);
          }

          // half-open interval
          result[0] = 'tuple';
          result = ['interval', result];
          let closed;
          if (token_left === '(')
            closed = ['tuple', false, true];
          else
            closed = ['tuple', true, false];
          result.push(closed);

        }
        else if (n_elements >= 2) {
          if (token_left === '(' || token_left === '{') {
            result[0] = 'tuple';
          }
          else if (token_left === '[') {
            result[0] = 'array';
          }
          else {
            result[0] = 'set';
          }
        }
        else if (token_left === 'LBRACE') {
          if (result[0] === '|' || result[0] === ':') {
            result = ['set', result];  // set builder notation
          }
          else {
            result = ['set', result];  // singleton set
          }
        }

        this.advance();

      } else if (this.token.token_type[0] === '|' && parse_absolute_value &&
        (inside_absolute_value === 0 || !allow_absolute_value_closing ||
          this.token.token_type[1] === 'L')) {

        // allow the opening of an absolute value here if either
        // - we aren't already inside an absolute value (inside_absolute_value==0),
        // - we don't allows an absolute value closing, or
        // - the | was marked as a left
        // otherwise, skip this token so that will drop out the factor (and entire statement)
        // to where the absolute value will close

        inside_absolute_value += 1;

        this.advance();

        result = this.statement({ inside_absolute_value: inside_absolute_value });
        result = ['apply', 'abs', result];

        if (this.token.token_type !== '|') {
          throw new ParseError('Expecting |', this.lexer.location);
        }

        this.advance();
      }

      if (this.token.token_type === '_') {
        if (result === false) {
          throw new ParseError("Invalid location of _", this.lexer.location);
        }
        this.advance();
        let subresult = this.baseFactor({ parse_absolute_value: parse_absolute_value });

        if (subresult === false) {
          if (this.token.token_type === "EOF") {
            throw new ParseError("Unexpected end of input", this.lexer.location);
          }
          else {
            throw new ParseError("Invalid location of '" + this.token.original_text + "'",
              this.lexer.location);
          }
        }
        return ['_', result, subresult];
      }

      return result;
    }


    leibniz_notation() {
      // attempt to find and return a derivative in Leibniz notation
      // if unsuccessful, return false

      var result = this.token.token_text;

      let deriv_symbol = "";

      let n_deriv = 1;

      let var1 = "";
      let var2s = [];
      let var2_exponents = [];

      if (this.token.token_type === "LATEXCOMMAND" && result.slice(1) === "partial")
        deriv_symbol = "∂";
      else if (this.token.token_type === "VAR" && result === "d")
        deriv_symbol = "d";
      else
        return false;

      // since have just a d or ∂
      // one option is that have a ^ followed by an integer next possibly in {}

      this.advance();

      if (this.token.token_type === '^') {
        // so far have d or ∂ followed by ^
        // must be followed by an integer
        this.advance();

        let in_braces = false;
        if (this.token.token_type === '{') {
          in_braces = true;

          this.advance();
        }

        if (this.token.token_type !== 'NUMBER') {
          return false;
        }

        n_deriv = parseFloat(this.token.token_text);
        if (!Number.isInteger(n_deriv)) {
          return false;
        }

        // found integer,

        // if in braces, require }
        if (in_braces) {
          this.advance();

          if (this.token.token_type !== '}') {
            return false;
          }
        }

        this.advance();
      }


      // since have a d or ∂, optionally followed by ^ and integer
      // next we must have:
      // a VAR, a VARMULTICHAR, or a LATEXCOMMAND that is in allowedLatexSymbols

      if (this.token.token_type === 'VAR')
        var1 = this.token.token_text;
      else if (this.token.token_type === 'VARMULTICHAR') {
        // strip out name of variable from \var command
        var1 = /\\var\s*\{\s*([a-zA-Z0-9]+)\s*\}/.exec(this.token.token_text)[1];
      }
      else if (this.token.token_type === 'LATEXCOMMAND') {
        result = this.token.token_text.slice(1);
        if (this.allowedLatexSymbols.includes(result))
          var1 = result;
        else
          return false;
      }

      // Finished numerator.
      // Next need a } and {

      this.advance();

      if (this.token.token_type !== '}') {
        return false;
      }

      this.advance();

      if (this.token.token_type !== '{') {
        return false;
      }
      else {
        this.advance();

      }

      // In denominator now
      // find sequence of
      // derivative symbol followed by
      // - a VAR, a VARMULTICHAR, or a LATEXCOMMAND that is in allowedLatexSymbols
      // optionally followed by a ^ and an integer
      // End when sum of exponents meets or exceeds n_deriv

      let exponent_sum = 0;

      while (true) {

        // next must be
        // - a VAR equal to deriv_symbol="d" or \partial when deriv_symbol = "∂"


        if (!((deriv_symbol === "d" && this.token.token_type === "VAR" && this.token.token_text === "d")
          || (deriv_symbol === "∂" && this.token.token_type === "LATEXCOMMAND"
            && this.token.token_text.slice(1) === "partial"))) {
          return false;
        }

        // followed by
        // - a VAR, a VARMULTICHAR, or a LATEXCOMMAND that is in allowedLatexSymbols

        this.advance();

        if (this.token.token_type === 'VAR')
          var2s.push(this.token.token_text);
        else if (this.token.token_type === 'VARMULTICHAR') {
          // strip out name of variable from \var command
          var2s.push(/\\var\s*\{\s*([a-zA-Z0-9]+)\s*\}/.exec(this.token.token_text)[1]);
        }
        else if (this.token.token_type === 'LATEXCOMMAND') {
          let r = this.token.token_text.slice(1);
          if (this.allowedLatexSymbols.includes(r))
            var2s.push(r);
          else {
            return false;
          }
        }
        else {
          return false;
        }
        // have derivative and variable, now check for optional ^ followed by number

        let this_exponent = 1;

        this.advance();

        if (this.token.token_type === '^') {

          this.advance();

          let in_braces = false;
          if (this.token.token_type === '{') {
            in_braces = true;

            this.advance();
          }

          if (this.token.token_type !== 'NUMBER') {
            return false;
          }

          this_exponent = parseFloat(this.token.token_text);
          if (!Number.isInteger(this_exponent)) {
            return false;
          }

          // if in braces, require }
          if (in_braces) {
            this.advance();

            if (this.token.token_type !== '}') {
              return false;
            }
          }

          this.advance();

        }

        var2_exponents.push(this_exponent);
        exponent_sum += this_exponent;

        if (exponent_sum > n_deriv) {
          return false;
        }

        // possibly found derivative
        if (exponent_sum === n_deriv) {

          // next token must be a }
          if (this.token.token_type !== '}') {
            return false;

          }

          // found derivative!

          this.advance();

          let result_name = "derivative_leibniz";
          if (deriv_symbol === "∂")
            result_name = "partial_" + result_name;

          result = [result_name];

          if (n_deriv === 1)
            result.push(var1);
          else
            result.push(["tuple", var1, n_deriv]);

          let r2 = [];
          for (let i = 0; i < var2s.length; i += 1) {
            if (var2_exponents[i] === 1)
              r2.push(var2s[i]);
            else
              r2.push(["tuple", var2s[i], var2_exponents[i]]);
          }
          r2 = ["tuple"].concat(r2);

          result.push(r2);

          return result;

        }
      }
    }
  }

  /*
   * convert math.s tree to AST
   *
   * Copyright 2014-2017 by
   * Jim Fowler <kisonecat@gmail.com>
   * Duane Nykamp <nykamp@umn.edu>
   *
   * This file is part of a math-expressions library
   *
   * math-expressions is free software: you can redistribute
   * it and/or modify it under the terms of the GNU General Public
   * License as published by the Free Software Foundation, either
   * version 3 of the License, or at your option any later version.
   *
   * math-expressions is distributed in the hope that it
   * will be useful, but WITHOUT ANY WARRANTY; without even the implied
   * warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
   * See the GNU General Public License for more details.
   *
   */

  /**
   * Helpers.
   */

  var s = 1000;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var y = d * 365.25;

  /**
   * Parse or format the given `val`.
   *
   * Options:
   *
   *  - `long` verbose formatting [false]
   *
   * @param {String|Number} val
   * @param {Object} [options]
   * @throws {Error} throw an error if val is not a non-empty string or a number
   * @return {String|Number}
   * @api public
   */

  var ms = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) {
      return parse$2(val);
    } else if (type === 'number' && isNaN(val) === false) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }
    throw new Error(
      'val is not a non-empty string or a valid number. val=' +
        JSON.stringify(val)
    );
  };

  /**
   * Parse the given `str` and return milliseconds.
   *
   * @param {String} str
   * @return {Number}
   * @api private
   */

  function parse$2(str) {
    str = String(str);
    if (str.length > 100) {
      return;
    }
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
      str
    );
    if (!match) {
      return;
    }
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch (type) {
      case 'years':
      case 'year':
      case 'yrs':
      case 'yr':
      case 'y':
        return n * y;
      case 'days':
      case 'day':
      case 'd':
        return n * d;
      case 'hours':
      case 'hour':
      case 'hrs':
      case 'hr':
      case 'h':
        return n * h;
      case 'minutes':
      case 'minute':
      case 'mins':
      case 'min':
      case 'm':
        return n * m;
      case 'seconds':
      case 'second':
      case 'secs':
      case 'sec':
      case 's':
        return n * s;
      case 'milliseconds':
      case 'millisecond':
      case 'msecs':
      case 'msec':
      case 'ms':
        return n;
      default:
        return undefined;
    }
  }

  /**
   * Short format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtShort(ms) {
    if (ms >= d) {
      return Math.round(ms / d) + 'd';
    }
    if (ms >= h) {
      return Math.round(ms / h) + 'h';
    }
    if (ms >= m) {
      return Math.round(ms / m) + 'm';
    }
    if (ms >= s) {
      return Math.round(ms / s) + 's';
    }
    return ms + 'ms';
  }

  /**
   * Long format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */

  function fmtLong(ms) {
    return plural(ms, d, 'day') ||
      plural(ms, h, 'hour') ||
      plural(ms, m, 'minute') ||
      plural(ms, s, 'second') ||
      ms + ' ms';
  }

  /**
   * Pluralization helper.
   */

  function plural(ms, n, name) {
    if (ms < n) {
      return;
    }
    if (ms < n * 1.5) {
      return Math.floor(ms / n) + ' ' + name;
    }
    return Math.ceil(ms / n) + ' ' + name + 's';
  }

  var debug = createCommonjsModule(function (module, exports) {
  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   *
   * Expose `debug()` as the module.
   */

  exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
  exports.coerce = coerce;
  exports.disable = disable;
  exports.enable = enable;
  exports.enabled = enabled;
  exports.humanize = ms;

  /**
   * The currently active debug mode names, and names to skip.
   */

  exports.names = [];
  exports.skips = [];

  /**
   * Map of special "%n" handling functions, for the debug "format" argument.
   *
   * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
   */

  exports.formatters = {};

  /**
   * Previous log timestamp.
   */

  var prevTime;

  /**
   * Select a color.
   * @param {String} namespace
   * @return {Number}
   * @api private
   */

  function selectColor(namespace) {
    var hash = 0, i;

    for (i in namespace) {
      hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return exports.colors[Math.abs(hash) % exports.colors.length];
  }

  /**
   * Create a debugger with the given `namespace`.
   *
   * @param {String} namespace
   * @return {Function}
   * @api public
   */

  function createDebug(namespace) {

    function debug() {
      // disabled?
      if (!debug.enabled) return;

      var self = debug;

      // set `diff` timestamp
      var curr = +new Date();
      var ms$$1 = curr - (prevTime || curr);
      self.diff = ms$$1;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;

      // turn the `arguments` into a proper Array
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }

      args[0] = exports.coerce(args[0]);

      if ('string' !== typeof args[0]) {
        // anything else let's inspect with %O
        args.unshift('%O');
      }

      // apply any `formatters` transformations
      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
        // if we encounter an escaped % then don't increase the array index
        if (match === '%%') return match;
        index++;
        var formatter = exports.formatters[format];
        if ('function' === typeof formatter) {
          var val = args[index];
          match = formatter.call(self, val);

          // now we need to remove `args[index]` since it's inlined in the `format`
          args.splice(index, 1);
          index--;
        }
        return match;
      });

      // apply env-specific formatting (colors, etc.)
      exports.formatArgs.call(self, args);

      var logFn = debug.log || exports.log || console.log.bind(console);
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);

    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) {
      exports.init(debug);
    }

    return debug;
  }

  /**
   * Enables a debug mode by namespaces. This can include modes
   * separated by a colon and wildcards.
   *
   * @param {String} namespaces
   * @api public
   */

  function enable(namespaces) {
    exports.save(namespaces);

    exports.names = [];
    exports.skips = [];

    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (var i = 0; i < len; i++) {
      if (!split[i]) continue; // ignore empty strings
      namespaces = split[i].replace(/\*/g, '.*?');
      if (namespaces[0] === '-') {
        exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        exports.names.push(new RegExp('^' + namespaces + '$'));
      }
    }
  }

  /**
   * Disable debug output.
   *
   * @api public
   */

  function disable() {
    exports.enable('');
  }

  /**
   * Returns true if the given mode name is enabled, false otherwise.
   *
   * @param {String} name
   * @return {Boolean}
   * @api public
   */

  function enabled(name) {
    var i, len;
    for (i = 0, len = exports.skips.length; i < len; i++) {
      if (exports.skips[i].test(name)) {
        return false;
      }
    }
    for (i = 0, len = exports.names.length; i < len; i++) {
      if (exports.names[i].test(name)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Coerce `val`.
   *
   * @param {Mixed} val
   * @return {Mixed}
   * @api private
   */

  function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
  }
  });
  var debug_1 = debug.coerce;
  var debug_2 = debug.disable;
  var debug_3 = debug.enable;
  var debug_4 = debug.enabled;
  var debug_5 = debug.humanize;
  var debug_6 = debug.names;
  var debug_7 = debug.skips;
  var debug_8 = debug.formatters;

  var browser = createCommonjsModule(function (module, exports) {
  /**
   * This is the web browser implementation of `debug()`.
   *
   * Expose `debug()` as the module.
   */

  exports = module.exports = debug;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = 'undefined' != typeof chrome
                 && 'undefined' != typeof chrome.storage
                    ? chrome.storage.local
                    : localstorage();

  /**
   * Colors.
   */

  exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
  ];

  /**
   * Currently only WebKit-based Web Inspectors, Firefox >= v31,
   * and the Firebug extension (any Firefox version) are known
   * to support "%c" CSS customizations.
   *
   * TODO: add a `localStorage` variable to explicitly enable/disable colors
   */

  function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
      return true;
    }

    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
      // is firebug? http://stackoverflow.com/a/398120/376773
      (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
      // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
      // double check webkit in userAgent just in case we are in a worker
      (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  }

  /**
   * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
   */

  exports.formatters.j = function(v) {
    try {
      return JSON.stringify(v);
    } catch (err) {
      return '[UnexpectedJSONParseError]: ' + err.message;
    }
  };


  /**
   * Colorize log arguments if enabled.
   *
   * @api public
   */

  function formatArgs(args) {
    var useColors = this.useColors;

    args[0] = (useColors ? '%c' : '')
      + this.namespace
      + (useColors ? ' %c' : ' ')
      + args[0]
      + (useColors ? '%c ' : ' ')
      + '+' + exports.humanize(this.diff);

    if (!useColors) return;

    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');

    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
      if ('%%' === match) return;
      index++;
      if ('%c' === match) {
        // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
      }
    });

    args.splice(lastC, 0, c);
  }

  /**
   * Invokes `console.log()` when available.
   * No-op when `console.log` is not a "function".
   *
   * @api public
   */

  function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console
      && console.log
      && Function.prototype.apply.call(console.log, console, arguments);
  }

  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */

  function save(namespaces) {
    try {
      if (null == namespaces) {
        exports.storage.removeItem('debug');
      } else {
        exports.storage.debug = namespaces;
      }
    } catch(e) {}
  }

  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */

  function load() {
    var r;
    try {
      r = exports.storage.debug;
    } catch(e) {}

    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof process !== 'undefined' && 'env' in process) {
      r = process.env.DEBUG;
    }

    return r;
  }

  /**
   * Enable namespaces listed in `localStorage.debug` initially.
   */

  exports.enable(load());

  /**
   * Localstorage attempts to return the localstorage.
   *
   * This is necessary because safari throws
   * when a user disables cookies/localstorage
   * and you attempt to access it.
   *
   * @return {LocalStorage}
   * @api private
   */

  function localstorage() {
    try {
      return window.localStorage;
    } catch (e) {}
  }
  });
  var browser_1 = browser.log;
  var browser_2 = browser.formatArgs;
  var browser_3 = browser.save;
  var browser_4 = browser.load;
  var browser_5 = browser.useColors;
  var browser_6 = browser.storage;
  var browser_7 = browser.colors;

  // MIT lisence
  // from https://github.com/substack/tty-browserify/blob/1ba769a6429d242f36226538835b4034bf6b7886/index.js

  function isatty() {
    return false;
  }

  function ReadStream() {
    throw new Error('tty.ReadStream is not implemented');
  }

  function WriteStream() {
    throw new Error('tty.ReadStream is not implemented');
  }

  var tty = {
    isatty: isatty,
    ReadStream: ReadStream,
    WriteStream: WriteStream
  }

  // shim for using process in browser
  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

  function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout () {
      throw new Error('clearTimeout has not been defined');
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global.setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
  }
  if (typeof global.clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
  }

  function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
      } catch(e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
          } catch(e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
          }
      }


  }
  function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
      } catch (e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
          } catch (e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
          }
      }



  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
      if (!draining || !currentQueue) {
          return;
      }
      draining = false;
      if (currentQueue.length) {
          queue = currentQueue.concat(queue);
      } else {
          queueIndex = -1;
      }
      if (queue.length) {
          drainQueue();
      }
  }

  function drainQueue() {
      if (draining) {
          return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while(len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
              if (currentQueue) {
                  currentQueue[queueIndex].run();
              }
          }
          queueIndex = -1;
          len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
  }
  function nextTick(fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
          }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
      }
  }
  // v8 likes predictible objects
  function Item(fun, array) {
      this.fun = fun;
      this.array = array;
  }
  Item.prototype.run = function () {
      this.fun.apply(null, this.array);
  };
  var title = 'browser';
  var platform = 'browser';
  var browser$1 = true;
  var env = {};
  var argv = [];
  var version$2 = ''; // empty string to avoid regexp issues
  var versions = {};
  var release = {};
  var config$2 = {};

  function noop() {}

  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;

  function binding(name) {
      throw new Error('process.binding is not supported');
  }

  function cwd () { return '/' }
  function chdir (dir) {
      throw new Error('process.chdir is not supported');
  }function umask() { return 0; }

  // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
  var performance = global.performance || {};
  var performanceNow =
    performance.now        ||
    performance.mozNow     ||
    performance.msNow      ||
    performance.oNow       ||
    performance.webkitNow  ||
    function(){ return (new Date()).getTime() };

  // generate timestamp or delta
  // see http://nodejs.org/api/process.html#process_process_hrtime
  function hrtime(previousTimestamp){
    var clocktime = performanceNow.call(performance)*1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor((clocktime%1)*1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds<0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }
    return [seconds,nanoseconds]
  }

  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
  }

  var process$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser$1,
    env: env,
    argv: argv,
    version: version$2,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config$2,
    uptime: uptime
  };

  var inherits;
  if (typeof Object.create === 'function'){
    inherits = function inherits(ctor, superCtor) {
      // implementation from standard node.js 'util' module
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    inherits = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  var inherits$1 = inherits;

  // Copyright Joyent, Inc. and other Node contributors.
  var formatRegExp = /%[sdj%]/g;
  function format$10(f) {
    if (!isString$6(f)) {
      var objects = [];
      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }
      return objects.join(' ');
    }

    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
      if (x === '%%') return '%';
      if (i >= len) return x;
      switch (x) {
        case '%s': return String(args[i++]);
        case '%d': return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
        default:
          return x;
      }
    });
    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }
    return str;
  }

  // Mark that a method should not be used.
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.
  function deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global.process)) {
      return function() {
        return deprecate(fn, msg).apply(this, arguments);
      };
    }

    if (process$1.noDeprecation === true) {
      return fn;
    }

    var warned = false;
    function deprecated() {
      if (!warned) {
        if (process$1.throwDeprecation) {
          throw new Error(msg);
        } else if (process$1.traceDeprecation) {
          console.trace(msg);
        } else {
          console.error(msg);
        }
        warned = true;
      }
      return fn.apply(this, arguments);
    }

    return deprecated;
  }

  var debugs = {};
  var debugEnviron;
  function debuglog(set) {
    if (isUndefined(debugEnviron))
      debugEnviron = process$1.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = 0;
        debugs[set] = function() {
          var msg = format$10.apply(null, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function() {};
      }
    }
    return debugs[set];
  }

  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */
  /* legacy: obj, showHidden, depth, colors*/
  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean$1(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      _extend(ctx, opts);
    }
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }

  // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
  inspect.colors = {
    'bold' : [1, 22],
    'italic' : [3, 23],
    'underline' : [4, 24],
    'inverse' : [7, 27],
    'white' : [37, 39],
    'grey' : [90, 39],
    'black' : [30, 39],
    'blue' : [34, 39],
    'cyan' : [36, 39],
    'green' : [32, 39],
    'magenta' : [35, 39],
    'red' : [31, 39],
    'yellow' : [33, 39]
  };

  // Don't use 'blue' not visible on cmd.exe
  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };


  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];

    if (style) {
      return '\u001b[' + inspect.colors[style][0] + 'm' + str +
             '\u001b[' + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }


  function stylizeNoColor(str, styleType) {
    return str;
  }


  function arrayToHash(array) {
    var hash = {};

    array.forEach(function(val, idx) {
      hash[val] = true;
    });

    return hash;
  }


  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect &&
        value &&
        isFunction(value.inspect) &&
        // Filter out the util module, it's inspect function is special
        value.inspect !== inspect &&
        // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);
      if (!isString$6(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }
      return ret;
    }

    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) {
      return primitive;
    }

    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);

    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    }

    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value)
        && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    }

    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }
      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }
      if (isError(value)) {
        return formatError(value);
      }
    }

    var base = '', array = false, braces = ['{', '}'];

    // Make Array say that they are Array
    if (isArray$5(value)) {
      array = true;
      braces = ['[', ']'];
    }

    // Make functions say that they are functions
    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    }

    // Make RegExps say that they are RegExps
    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    }

    // Make dates with properties first say the date
    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    }

    // Make error with message first say the error
    if (isError(value)) {
      base = ' ' + formatError(value);
    }

    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }

    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }

    ctx.seen.push(value);

    var output;
    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }

    ctx.seen.pop();

    return reduceToSingleString(output, base, braces);
  }


  function formatPrimitive(ctx, value) {
    if (isUndefined(value))
      return ctx.stylize('undefined', 'undefined');
    if (isString$6(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                               .replace(/'/g, "\\'")
                                               .replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }
    if (isNumber$5(value))
      return ctx.stylize('' + value, 'number');
    if (isBoolean$1(value))
      return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if (isNull(value))
      return ctx.stylize('null', 'null');
  }


  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }


  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty$5(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            String(i), true));
      } else {
        output.push('');
      }
    }
    keys.forEach(function(key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            key, true));
      }
    });
    return output;
  }


  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }
    if (!hasOwnProperty$5(visibleKeys, key)) {
      name = '[' + key + ']';
    }
    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }
        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function(line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function(line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }
    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }
      name = JSON.stringify('' + key);
      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'")
                   .replace(/\\"/g, '"')
                   .replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }

    return name + ': ' + str;
  }


  function reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
      numLinesEst++;
      if (cur.indexOf('\n') >= 0) numLinesEst++;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);

    if (length > 60) {
      return braces[0] +
             (base === '' ? '' : base + '\n ') +
             ' ' +
             output.join(',\n  ') +
             ' ' +
             braces[1];
    }

    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  }


  // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.
  function isArray$5(ar) {
    return Array.isArray(ar);
  }

  function isBoolean$1(arg) {
    return typeof arg === 'boolean';
  }

  function isNull(arg) {
    return arg === null;
  }

  function isNullOrUndefined(arg) {
    return arg == null;
  }

  function isNumber$5(arg) {
    return typeof arg === 'number';
  }

  function isString$6(arg) {
    return typeof arg === 'string';
  }

  function isSymbol(arg) {
    return typeof arg === 'symbol';
  }

  function isUndefined(arg) {
    return arg === void 0;
  }

  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }

  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }

  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }

  function isError(e) {
    return isObject(e) &&
        (objectToString(e) === '[object Error]' || e instanceof Error);
  }

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  function isPrimitive(arg) {
    return arg === null ||
           typeof arg === 'boolean' ||
           typeof arg === 'number' ||
           typeof arg === 'string' ||
           typeof arg === 'symbol' ||  // ES6 symbol
           typeof arg === 'undefined';
  }

  function isBuffer(maybeBuf) {
    return Buffer.isBuffer(maybeBuf);
  }

  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }


  function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
  }


  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
                'Oct', 'Nov', 'Dec'];

  // 26 Feb 16:19:34
  function timestamp() {
    var d = new Date();
    var time = [pad(d.getHours()),
                pad(d.getMinutes()),
                pad(d.getSeconds())].join(':');
    return [d.getDate(), months[d.getMonth()], time].join(' ');
  }


  // log is just a thin wrapper to console.log that prepends a timestamp
  function log$3() {
    console.log('%s - %s', timestamp(), format$10.apply(null, arguments));
  }

  function _extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;

    var keys = Object.keys(add);
    var i = keys.length;
    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }
    return origin;
  }
  function hasOwnProperty$5(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var util$1 = {
    inherits: inherits$1,
    _extend: _extend,
    log: log$3,
    isBuffer: isBuffer,
    isPrimitive: isPrimitive,
    isFunction: isFunction,
    isError: isError,
    isDate: isDate,
    isObject: isObject,
    isRegExp: isRegExp,
    isUndefined: isUndefined,
    isSymbol: isSymbol,
    isString: isString$6,
    isNumber: isNumber$5,
    isNullOrUndefined: isNullOrUndefined,
    isNull: isNull,
    isBoolean: isBoolean$1,
    isArray: isArray$5,
    inspect: inspect,
    deprecate: deprecate,
    format: format$10,
    debuglog: debuglog
  }

  var require$$2 = {};

  var node$2 = createCommonjsModule(function (module, exports) {
  /**
   * Module dependencies.
   */




  /**
   * This is the Node.js implementation of `debug()`.
   *
   * Expose `debug()` as the module.
   */

  exports = module.exports = debug;
  exports.init = init;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;

  /**
   * Colors.
   */

  exports.colors = [6, 2, 3, 4, 5, 1];

  /**
   * Build up the default `inspectOpts` object from the environment variables.
   *
   *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
   */

  exports.inspectOpts = Object.keys(process.env).filter(function (key) {
    return /^debug_/i.test(key);
  }).reduce(function (obj, key) {
    // camel-case
    var prop = key
      .substring(6)
      .toLowerCase()
      .replace(/_([a-z])/g, function (_, k) { return k.toUpperCase() });

    // coerce string value into JS value
    var val = process.env[key];
    if (/^(yes|on|true|enabled)$/i.test(val)) val = true;
    else if (/^(no|off|false|disabled)$/i.test(val)) val = false;
    else if (val === 'null') val = null;
    else val = Number(val);

    obj[prop] = val;
    return obj;
  }, {});

  /**
   * The file descriptor to write the `debug()` calls to.
   * Set the `DEBUG_FD` env variable to override with another value. i.e.:
   *
   *   $ DEBUG_FD=3 node script.js 3>debug.log
   */

  var fd = parseInt(process.env.DEBUG_FD, 10) || 2;

  if (1 !== fd && 2 !== fd) {
    util$1.deprecate(function(){}, 'except for stderr(2) and stdout(1), any other usage of DEBUG_FD is deprecated. Override debug.log if you want to use a different log function (https://git.io/debug_fd)')();
  }

  var stream = 1 === fd ? process.stdout :
               2 === fd ? process.stderr :
               createWritableStdioStream(fd);

  /**
   * Is stdout a TTY? Colored output is enabled when `true`.
   */

  function useColors() {
    return 'colors' in exports.inspectOpts
      ? Boolean(exports.inspectOpts.colors)
      : tty.isatty(fd);
  }

  /**
   * Map %o to `util.inspect()`, all on a single line.
   */

  exports.formatters.o = function(v) {
    this.inspectOpts.colors = this.useColors;
    return util$1.inspect(v, this.inspectOpts)
      .split('\n').map(function(str) {
        return str.trim()
      }).join(' ');
  };

  /**
   * Map %o to `util.inspect()`, allowing multiple lines if needed.
   */

  exports.formatters.O = function(v) {
    this.inspectOpts.colors = this.useColors;
    return util$1.inspect(v, this.inspectOpts);
  };

  /**
   * Adds ANSI color escape codes if enabled.
   *
   * @api public
   */

  function formatArgs(args) {
    var name = this.namespace;
    var useColors = this.useColors;

    if (useColors) {
      var c = this.color;
      var prefix = '  \u001b[3' + c + ';1m' + name + ' ' + '\u001b[0m';

      args[0] = prefix + args[0].split('\n').join('\n' + prefix);
      args.push('\u001b[3' + c + 'm+' + exports.humanize(this.diff) + '\u001b[0m');
    } else {
      args[0] = new Date().toUTCString()
        + ' ' + name + ' ' + args[0];
    }
  }

  /**
   * Invokes `util.format()` with the specified arguments and writes to `stream`.
   */

  function log() {
    return stream.write(util$1.format.apply(util$1, arguments) + '\n');
  }

  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */

  function save(namespaces) {
    if (null == namespaces) {
      // If you set a process.env field to null or undefined, it gets cast to the
      // string 'null' or 'undefined'. Just delete instead.
      delete process.env.DEBUG;
    } else {
      process.env.DEBUG = namespaces;
    }
  }

  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */

  function load() {
    return process.env.DEBUG;
  }

  /**
   * Copied from `node/src/node.js`.
   *
   * XXX: It's lame that node doesn't expose this API out-of-the-box. It also
   * relies on the undocumented `tty_wrap.guessHandleType()` which is also lame.
   */

  function createWritableStdioStream (fd) {
    var stream;
    var tty_wrap = process.binding('tty_wrap');

    // Note stream._type is used for test-module-load-list.js

    switch (tty_wrap.guessHandleType(fd)) {
      case 'TTY':
        stream = new tty.WriteStream(fd);
        stream._type = 'tty';

        // Hack to have stream not keep the event loop alive.
        // See https://github.com/joyent/node/issues/1726
        if (stream._handle && stream._handle.unref) {
          stream._handle.unref();
        }
        break;

      case 'FILE':
        var fs = require$$2;
        stream = new fs.SyncWriteStream(fd, { autoClose: false });
        stream._type = 'fs';
        break;

      case 'PIPE':
      case 'TCP':
        var net = require$$2;
        stream = new net.Socket({
          fd: fd,
          readable: false,
          writable: true
        });

        // FIXME Should probably have an option in net.Socket to create a
        // stream from an existing fd which is writable only. But for now
        // we'll just add this hack and set the `readable` member to false.
        // Test: ./node test/fixtures/echo.js < /etc/passwd
        stream.readable = false;
        stream.read = null;
        stream._type = 'pipe';

        // FIXME Hack to have stream not keep the event loop alive.
        // See https://github.com/joyent/node/issues/1726
        if (stream._handle && stream._handle.unref) {
          stream._handle.unref();
        }
        break;

      default:
        // Probably an error on in uv_guess_handle()
        throw new Error('Implement me. Unknown stream file type!');
    }

    // For supporting legacy API we put the FD here.
    stream.fd = fd;

    stream._isStdio = true;

    return stream;
  }

  /**
   * Init logic for `debug` instances.
   *
   * Create a new `inspectOpts` object in case `useColors` is set
   * differently for a particular `debug` instance.
   */

  function init (debug$$1) {
    debug$$1.inspectOpts = {};

    var keys = Object.keys(exports.inspectOpts);
    for (var i = 0; i < keys.length; i++) {
      debug$$1.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
    }
  }

  /**
   * Enable namespaces listed in `process.env.DEBUG` initially.
   */

  exports.enable(load());
  });
  var node_1 = node$2.init;
  var node_2 = node$2.log;
  var node_3 = node$2.formatArgs;
  var node_4 = node$2.save;
  var node_5 = node$2.load;
  var node_6 = node$2.useColors;
  var node_7 = node$2.colors;
  var node_8 = node$2.inspectOpts;

  var src = createCommonjsModule(function (module) {
  /**
   * Detect Electron renderer process, which is node, but we should
   * treat as a browser.
   */

  if (typeof process !== 'undefined' && process.type === 'renderer') {
    module.exports = browser;
  } else {
    module.exports = node$2;
  }
  });

  /**
   * Module dependencies.
   */

  var debug$1 = src('xml-parser');

  /**
   * Expose `parse`.
   */

  var xmlParser = parse$3;

  /**
   * Parse the given string of `xml`.
   *
   * @param {String} xml
   * @return {Object}
   * @api public
   */

  function parse$3(xml) {
    xml = xml.trim();

    // strip comments
    xml = xml.replace(/<!--[\s\S]*?-->/g, '');

    return document();

    /**
     * XML document.
     */

    function document() {
      return {
        declaration: declaration(),
        root: tag()
      }
    }

    /**
     * Declaration.
     */

    function declaration() {
      var m = match(/^<\?xml\s*/);
      if (!m) return;

      // tag
      var node = {
        attributes: {}
      };

      // attributes
      while (!(eos() || is('?>'))) {
        var attr = attribute();
        if (!attr) return node;
        node.attributes[attr.name] = attr.value;
      }

      match(/\?>\s*/);

      return node;
    }

    /**
     * Tag.
     */

    function tag() {
      debug$1('tag %j', xml);
      var m = match(/^<([\w-:.]+)\s*/);
      if (!m) return;

      // name
      var node = {
        name: m[1],
        attributes: {},
        children: []
      };

      // attributes
      while (!(eos() || is('>') || is('?>') || is('/>'))) {
        var attr = attribute();
        if (!attr) return node;
        node.attributes[attr.name] = attr.value;
      }

      // self closing tag
      if (match(/^\s*\/>\s*/)) {
        return node;
      }

      match(/\??>\s*/);

      // content
      node.content = content();

      // children
      var child;
      while (child = tag()) {
        node.children.push(child);
      }

      // closing
      match(/^<\/[\w-:.]+>\s*/);

      return node;
    }

    /**
     * Text content.
     */

    function content() {
      debug$1('content %j', xml);
      var m = match(/^([^<]*)/);
      if (m) return m[1];
      return '';
    }

    /**
     * Attribute.
     */

    function attribute() {
      debug$1('attribute %j', xml);
      var m = match(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (!m) return;
      return { name: m[1], value: strip(m[2]) }
    }

    /**
     * Strip quotes from `val`.
     */

    function strip(val) {
      return val.replace(/^['"]|['"]$/g, '');
    }

    /**
     * Match `re` and advance the string.
     */

    function match(re) {
      var m = xml.match(re);
      if (!m) return;
      xml = xml.slice(m[0].length);
      return m;
    }

    /**
     * End-of-source.
     */

    function eos() {
      return 0 == xml.length;
    }

    /**
     * Check for `prefix`.
     */

    function is(prefix) {
      return 0 == xml.indexOf(prefix);
    }
  }

  // I would need var parseString = require('../node_modules/xml-parser/index.js'); for urequire?

  // fix missing semicolons
  const entities = {
      "&#913;": "\\Alpha",
      "&Alpha;": "\\Alpha",
      "&#x0391;": "\\Alpha",
      "\\u0391;": "\\Alpha",
      "&#914;": "\\Beta",
      "&Beta;": "\\Beta",
      "&#x0392;": "\\Beta",
      "\\u0392;": "\\Beta",
      "&#915;": "\\Gamma",
      "&Gamma;": "\\Gamma",
      "&#x0393;": "\\Gamma",
      "\\u0393;": "\\Gamma",
      "&#916;": "\\Delta",
      "&Delta;": "\\Delta",
      "&#x0394;": "\\Delta",
      "\\u0394;": "\\Delta",
      "&#917;": "\\Epsilon",
      "&Epsilon;": "\\Epsilon",
      "&#x0395;": "\\Epsilon",
      "\\u0395;": "\\Epsilon",
      "&#918;": "\\Zeta",
      "&Zeta;": "\\Zeta",
      "&#x0396;": "\\Zeta",
      "\\u0396;": "\\Zeta",
      "&#919;": "\\Eta",
      "&Eta;": "\\Eta",
      "&#x0397;": "\\Eta",
      "\\u0397;": "\\Eta",
      "&#920;": "\\Theta",
      "&Theta;": "\\Theta",
      "&#x0398;": "\\Theta",
      "\\u0398;": "\\Theta",
      "&#921;": "\\Iota",
      "&Iota;": "\\Iota",
      "&#x0399;": "\\Iota",
      "\\u0399;": "\\Iota",
      "&#922;": "\\Kappa",
      "&Kappa;": "\\Kappa",
      "&#x039A;": "\\Kappa",
      "\\u039A;": "\\Kappa",
      "&#923;": "\\Lambda",
      "&Lambda;": "\\Lambda",
      "&#x039B;": "\\Lambda",
      "\\u039B;": "\\Lambda",
      "&#924;": "\\Mu",
      "&Mu;": "\\Mu",
      "&#x039C;": "\\Mu",
      "\\u039C;": "\\Mu",
      "&#925;": "\\Nu",
      "&Nu;": "\\Nu",
      "&#x039D;": "\\Nu",
      "\\u039D;": "\\Nu",
      "&#926;": "\\Xi",
      "&Xi;": "\\Xi",
      "&#x039E;": "\\Xi",
      "\\u039E;": "\\Xi",
      "&#927;": "\\Omicron",
      "&Omicron;": "\\Omicron",
      "&#x039F;": "\\Omicron",
      "\\u039F;": "\\Omicron",
      "&#928;": "\\Pi",
      "&Pi;": "\\Pi",
      "&#x03A0;": "\\Pi",
      "\\u03A0;": "\\Pi",
      "&#929;": "\\Rho",
      "&Rho;": "\\Rho",
      "&#x03A1;": "\\Rho",
      "\\u03A1;": "\\Rho",
      "&#931;": "\\Sigma",
      "&Sigma;": "\\Sigma",
      "&#x03A3;": "\\Sigma",
      "\\u03A3;": "\\Sigma",
      "&#932;": "\\Tau",
      "&Tau;": "\\Tau",
      "&#x03A4;": "\\Tau",
      "\\u03A4;": "\\Tau",
      "&#933;": "\\Upsilon",
      "&Upsilon;": "\\Upsilon",
      "&#x03A5;": "\\Upsilon",
      "\\u03A5;": "\\Upsilon",
      "&#934;": "\\Phi",
      "&Phi;": "\\Phi",
      "&#x03A6;": "\\Phi",
      "\\u03A6;": "\\Phi",
      "&#935;": "\\Chi",
      "&Chi;": "\\Chi",
      "&#x03A7;": "\\Chi",
      "\\u03A7;": "\\Chi",
      "&#936;": "\\Psi",
      "&Psi;": "\\Psi",
      "&#x03A8;": "\\Psi",
      "\\u03A8;": "\\Psi",
      "&#937;": "\\Omega",
      "&Omega;": "\\Omega",
      "&#x03A9;": "\\Omega",
      "\\u03A9;": "\\Omega",
      "&#945;": "\\alpha",
      "&alpha;": "\\alpha",
      "&#x03B1;": "\\alpha",
      "\\u03B1;": "\\alpha",
      "&#946;": "\\beta",
      "&beta;": "\\beta",
      "&#x03B2;": "\\beta",
      "\\u03B2;": "\\beta",
      "&#947;": "\\gamma",
      "&gamma;": "\\gamma",
      "&#x03B3;": "\\gamma",
      "\\u03B3;": "\\gamma",
      "&#948;": "\\delta",
      "&delta;": "\\delta",
      "&#x03B4;": "\\delta",
      "\\u03B4;": "\\delta",
      "&#949;": "\\epsilon",
      "&epsilon;": "\\epsilon",
      "&#x03B5;": "\\epsilon",
      "\\u03B5;": "\\epsilon",
      "&#950;": "\\zeta",
      "&zeta;": "\\zeta",
      "&#x03B6;": "\\zeta",
      "\\u03B6;": "\\zeta",
      "&#951;": "\\eta",
      "&eta;": "\\eta",
      "&#x03B7;": "\\eta",
      "\\u03B7;": "\\eta",
      "&#952;": "\\theta",
      "&theta;": "\\theta",
      "&#x03B8;": "\\theta",
      "\\u03B8;": "\\theta",
      "&#953;": "\\iota",
      "&iota;": "\\iota",
      "&#x03B9;": "\\iota",
      "\\u03B9;": "\\iota",
      "&#954;": "\\kappa",
      "&kappa;": "\\kappa",
      "&#x03BA;": "\\kappa",
      "\\u03BA;": "\\kappa",
      "&#955;": "\\lambda",
      "&lambda;": "\\lambda",
      "&#x03BB;": "\\lambda",
      "\\u03BB;": "\\lambda",
      "&#956;": "\\mu",
      "&mu;": "\\mu",
      "&#x03BC;": "\\mu",
      "\\u03BC;": "\\mu",
      "&#957;": "\\nu",
      "&nu;": "\\nu",
      "&#x03BD;": "\\nu",
      "\\u03BD;": "\\nu",
      "&#958;": "\\xi",
      "&xi;": "\\xi",
      "&#x03BE;": "\\xi",
      "\\u03BE;": "\\xi",
      "&#959;": "\\omicron",
      "&omicron;": "\\omicron",
      "&#x03BF;": "\\omicron",
      "\\u03BF;": "\\omicron",
      "&#960;": "\\pi",
      "&pi;": "\\pi",
      "&#x03C0;": "\\pi",
      "\\u03C0;": "\\pi",
      "&#961;": "\\rho",
      "&rho;": "\\rho",
      "&#x03C1;": "\\rho",
      "\\u03C1;": "\\rho",
      "&#962;": "\\sigma",
      ";": "\\sigma",
      "&#x03C2;": "\\sigma",
      "\\u03C2;": "\\sigma",
      "&#963;": "\\sigma",
      "&sigma;": "\\sigma",
      "&#x03C3;": "\\sigma",
      "\\u03C3;": "\\sigma",
      "&#964;": "\\tau",
      "&tau;": "\\tau",
      "&#x03C4;": "\\tau",
      "\\u03C4;": "\\tau",
      "&#965;": "\\upsilon",
      "&upsilon;": "\\upsilon",
      "&#x03C5;": "\\upsilon",
      "\\u03C5;": "\\upsilon",
      "&#966;": "\\phi",
      "&phi;": "\\phi",
      "&#x03C6;": "\\phi",
      "\\u03C6;": "\\phi",
      "&#967;": "\\chi",
      "&chi;": "\\chi",
      "&#x03C7;": "\\chi",
      "\\u03C7;": "\\chi",
      "&#968;": "\\psi",
      "&psi;": "\\psi",
      "&#x03C8;": "\\psi",
      "\\u03C8;": "\\psi",
      "&#969;": "\\omega",
      "&omega;": "\\omega",
      "&#x03C9;": "\\omega",
      "\\u03C9;": "\\omega",
      "&#x2212;": "-",
      "&minus;": "-",
      "&#x221E;": "\\infty",
      "&#8734;": "\\infty",
      "&infin;": "\\infty",
      "&sdot;": "\\cdot",
      "&#x22C5;": "\\cdot",
      "&#8901;": "\\cdot",
      "&times;": "\\times",
      "&#x00D7;": "\\times",
      "&#215;": "\\times"
  };

  class mmlToLatex{

    // This is an awfully weak MathML parser, but it's good enough for what MathJax generates
   parse(mml) {
    // math identifier
    if (mml.name === 'mi') {
    	if (entities[mml.content]) {
    	    return entities[mml.content];
    	}

    	if (mml.content.length > 1) {
    	    return "\\" + mml.content;
    	} else {
    	    return mml.content;
    	}
    }else if (mml.name === 'mn') { // math number
    	    return mml.content;
    }else if (mml.name === 'msup') {   // superscript
    	return this.parse( mml.children[0] ) + '^{' + this.parse( mml.children[1] ) + "}";
    }else if (mml.name === 'mroot') {// root
    	return "\\sqrt[" + this.parse( mml.children[1] ) + ']{' + this.parse( mml.children[1] ) + "}";
    }else if (mml.name === 'mfrac') {
    	return "\\frac{" + this.parse( mml.children[0] ) + '}{' + this.parse( mml.children[1] ) + "}";
    }else if (mml.name === 'msqrt') { // superscript
    	return "\\sqrt{" + mml.children.map( function(v,i) { return this.parse(v); }.bind(this) ).join(' ') + "}";
    }else if (mml.name === 'mo') { // math operator
    	    if (entities[mml.content]) {
    	    return entities[mml.content];
    	    } else if (mml.content === '&#x2061;') {
    	    return ' ';
    	    } else {
          return mml.content;
          }
    }else if ((mml.name === "mrow") && (mml.attributes.class === "MJX-TeXAtom-ORD")) {
    	return mml.children.map( function(v,i) { return this.parse(v); }.bind(this) ).join(' ');
    } else if ((mml.name === 'math') || (mml.name === 'mrow')) {
    	return '(' + mml.children.map( function(v,i) { return this.parse(v); }.bind(this) ).join(' ') + ')';
    }
    }

    convert(xml) {
        var result =  this.parse( xmlParser(xml).root );
        // console.log( "parsed =", JSON.stringify(result) );
        return result;
    };

  }

  class mmlToAst{
    constructor(){
     this.mmlToLatex = new mmlToLatex();
     this.latexToAst = new latexToAst();
    }

    convert(mml){
      return this.latexToAst.convert(this.mmlToLatex.convert(mml));
    }
  }

  var textToAst$4 = new textToAst();
  var latexToAst$1 = new latexToAst();
  var mmlToAst$1 = new mmlToAst();


  function Expression(ast, context) {
    this.tree = flatten(ast);
    this.context = context;

    this.toJSON = function () {
      return {
        objectType: "math-expression",
        tree: this.tree,
        assumptions: this.context.assumptions
      }
    };
  }

  function extend$4(object, tree_to_expression) {
    // if tree_to_expression, convert ast to expression

    // arguments object is NOT an array
    var args = flatten_array(Array.prototype.slice.call(arguments, 2));

    args.forEach(
      function (rhs) {
        if (rhs) {
          for (var property in rhs) {
            if (tree_to_expression) {
              (function () {
                var prop = property;
                object[prop] = function () {
                  return this.fromAst(
                    rhs[prop].apply(null, arguments));
                };
              })();
            }
            else
              object[property] = rhs[property];
          }
        }
      }
    );

    return object;
  }

  function extend_prototype(object, tree_to_expression) {
    // append a properties to object prepending this as first argument
    // if tree_to_expression, convert ast to expression

    // arguments object is NOT an array
    var args = flatten_array(Array.prototype.slice.call(arguments, 2));

    args.forEach(
      function (rhs) {
        if (rhs) {
          for (var property in rhs) {
            // prepend this as first argument
            (function () {
              var prop = property;
              object[prop] = function () {
                var arg2 = [this].concat(
                  Array.prototype.slice.call(arguments));
                // convert to expression if output_expression
                if (tree_to_expression)
                  return this.context.fromAst(
                    rhs[prop].apply(null, arg2));
                else
                  return rhs[prop].apply(null, arg2);
              };
            })();
          }
        }
      }
    );

    return object;
  }



  /****************************************************************/
  /* Factory methods */

  function create_from_multiple(expr, pars) {
    if (Array.isArray(expr) || (typeof expr === 'number')) {
      return new Expression(expr, Context);
    }
    else if (typeof expr === 'string') {
      try {
        return new Expression(textToAst$4.convert(expr), Context);
      }
      catch (e_text) {
        try {
          return new Expression(latexToAst$1.convert(expr), Context);
        }
        catch (e_latex) {
          try {
            return new Expression(mmlToAst$1.convert(expr), Context);
          }
          catch (e_mml) {
            if (expr.indexOf("\\") !== -1)
              throw (e_latex)
            if (expr.indexOf("</") !== -1)
              throw (e_mml)
            throw (e_text)
          }
        }
      }
    }
  }

  function parseText(string, pars) {
    return new Expression(textToAst$4.convert(string), Context);
  }

  function parseLatex(string, pars) {
    return new Expression(latexToAst$1.convert(string), Context);
  }

  function parseMml(string, pars) {
    return new Expression(mmlToAst$1.convert(string), Context);
  }


  var Context = {
    assumptions: initialize_assumptions(),
    parser_parameters: {},
    from: create_from_multiple,
    fromText: parseText,
    parse: parseText,
    fromLaTeX: parseLatex,
    fromLatex: parseLatex,
    fromTeX: parseLatex,
    fromTex: parseLatex,
    fromMml: parseMml,
    parse_tex: parseLatex,
    fromAst: function (ast) {
      return new Expression(ast, this);
    },
    set_to_default: function () {
      this.assumptions = initialize_assumptions();
      // this.parser_parameters = JSON.parse(JSON.stringify(parser_defaults));
    },
    get_assumptions: function (variables_or_expr, params) {
      return get_assumptions(this.assumptions, variables_or_expr,
        params);
    },
    add_assumption: function (assumption, exclude_generic) {
      return add_assumption(
        this.assumptions, assumption, exclude_generic);
    },
    add_generic_assumption: function (assumption) {
      return add_generic_assumption(this.assumptions, assumption);
    },
    remove_assumption: function (assumption) {
      return remove_assumption(this.assumptions, assumption);
    },
    remove_generic_assumption: function (assumption) {
      return remove_generic_assumption(this.assumptions,
        assumption);
    },
    clear_assumptions: function () {
      this.assumptions = initialize_assumptions();
    },

    math: math$19,

    reviver: function (key, value) {
      if (value && value.objectType === "math-expression" && value.tree !== undefined) {
        let expr = Context.fromAst(value.tree);
        if (value.assumptions !== undefined) {
          expr.assumptions = value.assumptions;
        }
        return expr;
      }
      return value;
    },
    class: Expression,
  };


  Context.set_to_default();


  extend$4(Context, true,
    expression_to_tree,
    expression_to_tree$1,
  );
  extend$4(Context, false,
    expression_to_other,
  );

  extend_prototype(Expression.prototype, true,
    expression_to_tree
  );
  extend_prototype(Expression.prototype, false,
    expression_to_other
  );


  // from https://stackoverflow.com/a/34757676
  function flatten_array(ary, ret) {
    ret = ret === undefined ? [] : ret;
    for (var i = 0; i < ary.length; i++) {
      if (Array.isArray(ary[i])) {
        flatten_array(ary[i], ret);
      } else {
        ret.push(ary[i]);
      }
    }
    return ret;
  }

  return Context;

})));

}).call(this)}).call(this,{"isBuffer":require("../../../../server.base/node_modules/browserify/node_modules/is-buffer/index.js")},require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../../../server.base/node_modules/browserify/node_modules/is-buffer/index.js":"/usr/var/server.base/node_modules/browserify/node_modules/is-buffer/index.js","_process":"/usr/var/server.base/node_modules/browserify/node_modules/process/browser.js"}],"/usr/var/server.base/node_modules/mathjax/unpacked/MathJax.js":[function(require,module,exports){
/* -*- Mode: Javascript; indent-tabs-mode:nil; js-indent-level: 2 -*- */
/* vim: set ts=2 et sw=2 tw=80: */

/*************************************************************
 *
 *  MathJax.js
 *
 *  The main support code for the MathJax Hub, including the
 *  Ajax, Callback, Messaging, and Object-Oriented Programming
 *  libraries, as well as the base Jax classes, and startup
 *  processing code.
 *
 *  ---------------------------------------------------------------------
 *
 *  Copyright (c) 2009-2018 The MathJax Consortium
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */


//
//  Check if browser can support MathJax (no one fails this nowadays)
//
if (document.getElementById && document.childNodes && document.createElement) {
//
//  Skip if MathJax is already loaded
//
if (!(window.MathJax && MathJax.Hub)) {

//
//  Get author configuration from MathJax variable, if any
//
if (window.MathJax) {window.MathJax = {AuthorConfig: window.MathJax}}
               else {window.MathJax = {}}

// MathJax.isPacked = true; // This line is uncommented by the packer.

MathJax.version = "2.7.5";
MathJax.fileversion = "2.7.5";
MathJax.cdnVersion = "2.7.5";  // specifies a revision to break caching
MathJax.cdnFileVersions = {};  // can be used to specify revisions for individual files

/**********************************************************/

(function (BASENAME) {
  var BASE = window[BASENAME];
  if (!BASE) {BASE = window[BASENAME] = {}}

  var PROTO = [];  // a static object used to indicate when a prototype is being created
  var OBJECT = function (def) {
    var obj = def.constructor; if (!obj) {obj = function () {}}
    for (var id in def) {if (id !== 'constructor' && def.hasOwnProperty(id)) {obj[id] = def[id]}}
    return obj;
  };
  var CONSTRUCTOR = function () {
    return function () {return arguments.callee.Init.call(this,arguments)};
  };

  BASE.Object = OBJECT({
    constructor: CONSTRUCTOR(),

    Subclass: function (def,classdef) {
      var obj = CONSTRUCTOR();
      obj.SUPER = this; obj.Init = this.Init;
      obj.Subclass = this.Subclass; obj.Augment = this.Augment;
      obj.protoFunction = this.protoFunction;
      obj.can = this.can; obj.has = this.has; obj.isa = this.isa;
      obj.prototype = new this(PROTO);
      obj.prototype.constructor = obj;  // the real constructor
      obj.Augment(def,classdef);
      return obj;
    },

    Init: function (args) {
      var obj = this;
      if (args.length === 1 && args[0] === PROTO) {return obj}
      if (!(obj instanceof args.callee)) {obj = new args.callee(PROTO)}
      return obj.Init.apply(obj,args) || obj;
    },

    Augment: function (def,classdef) {
      var id;
      if (def != null) {
        for (id in def) {if (def.hasOwnProperty(id)) {this.protoFunction(id,def[id])}}
        // MSIE doesn't list toString even if it is not native so handle it separately
        if (def.toString !== this.prototype.toString && def.toString !== {}.toString)
          {this.protoFunction('toString',def.toString)}
      }
      if (classdef != null) {
        for (id in classdef) {if (classdef.hasOwnProperty(id)) {this[id] = classdef[id]}}
      }
      return this;
    },

    protoFunction: function (id,def) {
      this.prototype[id] = def;
      if (typeof def === "function") {def.SUPER = this.SUPER.prototype}
    },

    prototype: {
      Init: function () {},
      SUPER: function (fn) {return fn.callee.SUPER},
      can: function (method) {return typeof(this[method]) === "function"},
      has: function (property) {return typeof(this[property]) !== "undefined"},
      isa: function (obj) {return (obj instanceof Object) && (this instanceof obj)}
    },

    can: function (method)   {return this.prototype.can.call(this,method)},
    has: function (property) {return this.prototype.has.call(this,property)},
    isa: function (obj) {
      var constructor = this;
      while (constructor) {
        if (constructor === obj) {return true} else {constructor = constructor.SUPER}
      }
      return false;
    },


    SimpleSUPER: OBJECT({
      constructor: function (def) {return this.SimpleSUPER.define(def)},

      define: function (src) {
	var dst = {};
	if (src != null) {
          for (var id in src) {if (src.hasOwnProperty(id)) {dst[id] = this.wrap(id,src[id])}}
	  // MSIE doesn't list toString even if it is not native so handle it separately
          if (src.toString !== this.prototype.toString && src.toString !== {}.toString)
            {dst.toString = this.wrap('toString',src.toString)}
	}
	return dst;
      },

      wrap: function (id,f) {
        if (typeof(f) !== 'function' || !f.toString().match(/\.\s*SUPER\s*\(/)) {return f}
        var fn = function () {
          this.SUPER = fn.SUPER[id];
          try {var result = f.apply(this,arguments)} catch (err) {delete this.SUPER; throw err}
          delete this.SUPER;
          return result;
        }
        fn.toString = function () {return f.toString.apply(f,arguments)}
        return fn;
      }

    })
  });

  BASE.Object.isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  };

  BASE.Object.Array = Array;

})("MathJax");

/**********************************************************/

/*
 *  Create a callback function from various forms of data:
 *
 *     MathJax.Callback(fn)    -- callback to a function
 *
 *     MathJax.Callback([fn])  -- callback to function
 *     MathJax.Callback([fn,data...])
 *                             -- callback to function with given data as arguments
 *     MathJax.Callback([object,fn])
 *                             -- call fn with object as "this"
 *     MathJax.Callback([object,fn,data...])
 *                             -- call fn with object as "this" and data as arguments
 *     MathJax.Callback(["method",object])
 *                             -- call method of object wth object as "this"
 *     MathJax.Callback(["method",object,data...])
 *                             -- as above, but with data as arguments to method
 *
 *     MathJax.Callback({hook: fn, data: [...], object: this})
 *                             -- give function, data, and object to act as "this" explicitly
 *
 *     MathJax.Callback("code")  -- callback that compiles and executes a string
 *
 *     MathJax.Callback([...],i)
 *                             -- use slice of array starting at i and interpret
 *                                result as above.  (Used for passing "arguments" array
 *                                and trimming initial arguments, if any.)
 */

/*
 *    MathJax.Callback.After([...],cb1,cb2,...)
 *                             -- make a callback that isn't called until all the other
 *                                ones are called first.  I.e., wait for a union of
 *                                callbacks to occur before making the given callback.
 */

/*
 *  MathJax.Callback.Queue([callback,...])
 *                             -- make a synchronized queue of commands that process
 *                                sequentially, waiting for those that return uncalled
 *                                callbacks.
 */

/*
 *  MathJax.Callback.Signal(name)
 *                             -- finds or creates a names signal, to which listeners
 *                                can be attached and are signaled by messages posted
 *                                to the signal.  Responses can be asynchronous.
 */

(function (BASENAME) {
  var BASE = window[BASENAME];
  if (!BASE) {BASE = window[BASENAME] = {}}
  var isArray = BASE.Object.isArray;
  //
  //  Create a callback from an associative array
  //
  var CALLBACK = function (data) {
    var cb = function () {return arguments.callee.execute.apply(arguments.callee,arguments)};
    for (var id in CALLBACK.prototype) {
      if (CALLBACK.prototype.hasOwnProperty(id)) {
        if (typeof(data[id]) !== 'undefined') {cb[id] = data[id]}
                                         else {cb[id] = CALLBACK.prototype[id]}
      }
    }
    cb.toString = CALLBACK.prototype.toString;
    return cb;
  };
  CALLBACK.prototype = {
    isCallback: true,
    hook: function () {},
    data: [],
    object: window,
    execute: function () {
      if (!this.called || this.autoReset) {
        this.called = !this.autoReset;
        return this.hook.apply(this.object,this.data.concat([].slice.call(arguments,0)));
      }
    },
    reset: function () {delete this.called},
    toString: function () {return this.hook.toString.apply(this.hook,arguments)}
  };
  var ISCALLBACK = function (f) {
    return (typeof(f) === "function" && f.isCallback);
  }

  //
  //  Evaluate a string in global context
  //
  var EVAL = function (code) {return eval.call(window,code)}
  var TESTEVAL = function () {
    EVAL("var __TeSt_VaR__ = 1"); // check if it works in global context
    if (window.__TeSt_VaR__) {
      try { delete window.__TeSt_VaR__; } // NOTE IE9 throws when in IE7 mode
      catch (error) { window.__TeSt_VaR__ = null; }
    } else {
      if (window.execScript) {
        // IE
        EVAL = function (code) {
          BASE.__code = code;
          code = "try {"+BASENAME+".__result = eval("+BASENAME+".__code)} catch(err) {"+BASENAME+".__result = err}";
          window.execScript(code);
          var result = BASE.__result; delete BASE.__result; delete BASE.__code;
          if (result instanceof Error) {throw result}
          return result;
        }
      } else {
        // Safari2
        EVAL = function (code) {
          BASE.__code = code;
          code = "try {"+BASENAME+".__result = eval("+BASENAME+".__code)} catch(err) {"+BASENAME+".__result = err}";
          var head = (document.getElementsByTagName("head"))[0]; if (!head) {head = document.body}
          var script = document.createElement("script");
          script.appendChild(document.createTextNode(code));
          head.appendChild(script); head.removeChild(script);
          var result = BASE.__result; delete BASE.__result; delete BASE.__code;
          if (result instanceof Error) {throw result}
          return result;
        }
      }
    }
    TESTEVAL = null;
  };

  //
  //  Create a callback from various types of data
  //
  var USING = function (args,i) {
    if (arguments.length > 1) {
      if (arguments.length === 2 && !(typeof arguments[0] === 'function') &&
          arguments[0] instanceof Object && typeof arguments[1] === 'number')
            {args = [].slice.call(args,i)}
      else {args = [].slice.call(arguments,0)}
    }
    if (isArray(args) && args.length === 1 && typeof(args[0]) === 'function') {args = args[0]}
    if (typeof args === 'function') {
      if (args.execute === CALLBACK.prototype.execute) {return args}
      return CALLBACK({hook: args});
    } else if (isArray(args)) {
      if (typeof(args[0]) === 'string' && args[1] instanceof Object &&
                 typeof args[1][args[0]] === 'function') {
        return CALLBACK({hook: args[1][args[0]], object: args[1], data: args.slice(2)});
      } else if (typeof args[0] === 'function') {
        return CALLBACK({hook: args[0], data: args.slice(1)});
      } else if (typeof args[1] === 'function') {
        return CALLBACK({hook: args[1], object: args[0], data: args.slice(2)});
      }
    } else if (typeof(args) === 'string') {
      if (TESTEVAL) TESTEVAL();
      return CALLBACK({hook: EVAL, data: [args]});
    } else if (args instanceof Object) {
      return CALLBACK(args);
    } else if (typeof(args) === 'undefined') {
      return CALLBACK({});
    }
    throw Error("Can't make callback from given data");
  };

  //
  //  Wait for a given time to elapse and then perform the callback
  //
  var DELAY = function (time,callback) {
    callback = USING(callback);
    callback.timeout = setTimeout(callback,time);
    return callback;
  };

  //
  //  Callback used by AFTER, QUEUE, and SIGNAL to check if calls have completed
  //
  var WAITFOR = function (callback,signal) {
    callback = USING(callback);
    if (!callback.called) {WAITSIGNAL(callback,signal); signal.pending++}
  };
  var WAITEXECUTE = function () {
    var signals = this.signal; delete this.signal;
    this.execute = this.oldExecute; delete this.oldExecute;
    var result = this.execute.apply(this,arguments);
    if (ISCALLBACK(result) && !result.called) {WAITSIGNAL(result,signals)} else {
      for (var i = 0, m = signals.length; i < m; i++) {
        signals[i].pending--;
        if (signals[i].pending <= 0) {signals[i].call()}
      }
    }
  };
  var WAITSIGNAL = function (callback,signals) {
    if (!isArray(signals)) {signals = [signals]}
    if (!callback.signal) {
      callback.oldExecute = callback.execute;
      callback.execute = WAITEXECUTE;
      callback.signal = signals;
    } else if (signals.length === 1) {callback.signal.push(signals[0])}
      else {callback.signal = callback.signal.concat(signals)}
  };

  //
  //  Create a callback that is called when a collection of other callbacks have
  //  all been executed.  If the callback gets called immediately (i.e., the
  //  others are all already called), check if it returns another callback
  //  and return that instead.
  //
  var AFTER = function (callback) {
    callback = USING(callback);
    callback.pending = 0;
    for (var i = 1, m = arguments.length; i < m; i++)
      {if (arguments[i]) {WAITFOR(arguments[i],callback)}}
    if (callback.pending === 0) {
      var result = callback();
      if (ISCALLBACK(result)) {callback = result}
    }
    return callback;
  };

  //
  //  An array of prioritized hooks that are executed sequentially
  //  with a given set of data.
  //
  var HOOKS = MathJax.Object.Subclass({
    //
    //  Initialize the array and the auto-reset status
    //
    Init: function (reset) {
      this.hooks = [];
      this.remove = []; // used when hooks are removed during execution of list
      this.reset = reset;
      this.running = false;
    },
    //
    //  Add a callback to the list, in priority order (default priority is 10)
    //
    Add: function (hook,priority) {
      if (priority == null) {priority = 10}
      if (!ISCALLBACK(hook)) {hook = USING(hook)}
      hook.priority = priority;
      var i = this.hooks.length;
      while (i > 0 && priority < this.hooks[i-1].priority) {i--}
      this.hooks.splice(i,0,hook);
      return hook;
    },
    Remove: function (hook) {
      for (var i = 0, m = this.hooks.length; i < m; i++) {
        if (this.hooks[i] === hook) {
          if (this.running) {this.remove.push(i)}
            else {this.hooks.splice(i,1)}
          return;
        }
      }
    },
    //
    //  Execute the list of callbacks, resetting them if requested.
    //  If any return callbacks, return a callback that will be
    //  executed when they all have completed.
    //  Remove any hooks that requested being removed during processing.
    //
    Execute: function () {
      var callbacks = [{}];
      this.running = true;
      for (var i = 0, m = this.hooks.length; i < m; i++) {
        if (this.reset) {this.hooks[i].reset()}
        var result = this.hooks[i].apply(window,arguments);
        if (ISCALLBACK(result) && !result.called) {callbacks.push(result)}
      }
      this.running = false;
      if (this.remove.length) {this.RemovePending()}
      if (callbacks.length === 1) {return null}
      if (callbacks.length === 2) {return callbacks[1]}
      return AFTER.apply({},callbacks);
    },
    //
    //  Remove hooks that asked to be removed during execution of list
    //
    RemovePending: function () {
      this.remove = this.remove.sort();
      for (var i = this.remove.length-1; i >= 0; i--) {this.hooks.splice(i,1)}
      this.remove = [];
    }

  });

  //
  //  Run an array of callbacks passing them the given data.
  //  (Legacy function, since this has been replaced by the HOOKS object).
  //
  var EXECUTEHOOKS = function (hooks,data,reset) {
    if (!hooks) {return null}
    if (!isArray(hooks)) {hooks = [hooks]}
    if (!isArray(data))  {data = (data == null ? [] : [data])}
    var handler = HOOKS(reset);
    for (var i = 0, m = hooks.length; i < m; i++) {handler.Add(hooks[i])}
    return handler.Execute.apply(handler,data);
  };

  //
  //  Command queue that performs commands in order, waiting when
  //  necessary for commands to complete asynchronousely
  //
  var QUEUE = BASE.Object.Subclass({
    //
    //  Create the queue and push any commands that are specified
    //
    Init: function () {
      this.pending = this.running = 0;
      this.queue = [];
      this.Push.apply(this,arguments);
    },
    //
    //  Add commands to the queue and run them. Adding a callback object
    //  (rather than a callback specification) queues a wait for that callback.
    //  Return the final callback for synchronization purposes.
    //
    Push: function () {
      var callback;
      for (var i = 0, m = arguments.length; i < m; i++) {
        callback = USING(arguments[i]);
        if (callback === arguments[i] && !callback.called)
          {callback = USING(["wait",this,callback])}
        this.queue.push(callback);
      }
      if (!this.running && !this.pending) {this.Process()}
      return callback;
    },
    //
    //  Process the command queue if we aren't waiting on another command
    //
    Process: function (queue) {
      while (!this.running && !this.pending && this.queue.length) {
        var callback = this.queue[0];
        queue = this.queue.slice(1); this.queue = [];
        this.Suspend(); var result = callback(); this.Resume();
        if (queue.length) {this.queue = queue.concat(this.queue)}
        if (ISCALLBACK(result) && !result.called) {WAITFOR(result,this)}
      }
    },
    //
    //  Suspend/Resume command processing on this queue
    //
    Suspend: function () {this.running++},
    Resume: function () {if (this.running) {this.running--}},
    //
    //  Used by WAITFOR to restart the queue when an action completes
    //
    call: function () {this.Process.apply(this,arguments)},
    wait: function (callback) {return callback}
  });

  //
  //  Create a named signal that listeners can attach to, to be signaled by
  //  postings made to the signal.  Posts are queued if they occur while one
  //  is already in process.
  //
  var SIGNAL = QUEUE.Subclass({
    Init: function (name) {
      QUEUE.prototype.Init.call(this);
      this.name = name;
      this.posted = [];              // the messages posted so far
      this.listeners = HOOKS(true);  // those with interest in this signal
      this.posting = false;
      this.callback = null;
    },
    //
    // Post a message to the signal listeners, with callback for when complete
    //
    Post: function (message,callback,forget) {
      callback = USING(callback);
      if (this.posting || this.pending) {
        this.Push(["Post",this,message,callback,forget]);
      } else {
        this.callback = callback; callback.reset();
        if (!forget) {this.posted.push(message)}
        this.Suspend(); this.posting = true;
        var result = this.listeners.Execute(message);
        if (ISCALLBACK(result) && !result.called) {WAITFOR(result,this)}
        this.Resume(); this.posting = false;
        if (!this.pending) {this.call()}
      }
      return callback;
    },
    //
    //  Clear the post history (so new listeners won't get old messages)
    //
    Clear: function (callback) {
      callback = USING(callback);
      if (this.posting || this.pending) {
        callback = this.Push(["Clear",this,callback]);
      } else {
        this.posted = [];
        callback();
      }
      return callback;
    },
    //
    //  Call the callback (all replies are in) and process the command queue
    //
    call: function () {this.callback(this); this.Process()},

    //
    //  A listener calls this to register interest in the signal (so it will be called
    //  when posts occur).  If ignorePast is true, it will not be sent the post history.
    //
    Interest: function (callback,ignorePast,priority) {
      callback = USING(callback);
      this.listeners.Add(callback,priority);
      if (!ignorePast) {
        for (var i = 0, m = this.posted.length; i < m; i++) {
          callback.reset();
          var result = callback(this.posted[i]);
          if (ISCALLBACK(result) && i === this.posted.length-1) {WAITFOR(result,this)}
        }
      }
      return callback;
    },
    //
    //  A listener calls this to remove itself from a signal
    //
    NoInterest: function (callback) {
      this.listeners.Remove(callback);
    },

    //
    //  Hook a callback to a particular message on this signal
    //
    MessageHook: function (msg,callback,priority) {
      callback = USING(callback);
      if (!this.hooks) {this.hooks = {}; this.Interest(["ExecuteHooks",this])}
      if (!this.hooks[msg]) {this.hooks[msg] = HOOKS(true)}
      this.hooks[msg].Add(callback,priority);
      for (var i = 0, m = this.posted.length; i < m; i++)
        {if (this.posted[i] == msg) {callback.reset(); callback(this.posted[i])}}
      callback.msg = msg; // keep track so we can remove it
      return callback;
    },
    //
    //  Execute the message hooks for the given message
    //
    ExecuteHooks: function (msg) {
      var type = (isArray(msg) ? msg[0] : msg);
      if (!this.hooks[type]) {return null}
      return this.hooks[type].Execute(msg);
    },
    //
    //  Remove a hook safely
    //
    RemoveHook: function (hook) {
      this.hooks[hook.msg].Remove(hook);
    }

  },{
    signals: {},  // the named signals
    find: function (name) {
      if (!SIGNAL.signals[name]) {SIGNAL.signals[name] = new SIGNAL(name)}
      return SIGNAL.signals[name];
    }
  });

  //
  //  The main entry-points
  //
  BASE.Callback = BASE.CallBack = USING;
  BASE.Callback.Delay = DELAY;
  BASE.Callback.After = AFTER;
  BASE.Callback.Queue = QUEUE;
  BASE.Callback.Signal = SIGNAL.find;
  BASE.Callback.Hooks = HOOKS;
  BASE.Callback.ExecuteHooks = EXECUTEHOOKS;
})("MathJax");


/**********************************************************/

(function (BASENAME) {
  var BASE = window[BASENAME];
  if (!BASE) {BASE = window[BASENAME] = {}}

  var isSafari2 = (navigator.vendor === "Apple Computer, Inc." &&
                   typeof navigator.vendorSub === "undefined");
  var sheets = 0; // used by Safari2

  //
  //  Update sheets count and look up the head object
  //
  var HEAD = function (head) {
    if (document.styleSheets && document.styleSheets.length > sheets)
      {sheets = document.styleSheets.length}
    if (!head) {
      head = document.head || ((document.getElementsByTagName("head"))[0]);
      if (!head) {head = document.body}
    }
    return head;
  };

  //
  //  Remove scripts that are completed so they don't clutter up the HEAD.
  //  This runs via setTimeout since IE7 can't remove the script while it is running.
  //
  var SCRIPTS = [];  // stores scripts to be removed after a delay
  var REMOVESCRIPTS = function () {
    for (var i = 0, m = SCRIPTS.length; i < m; i++) {BASE.Ajax.head.removeChild(SCRIPTS[i])}
    SCRIPTS = [];
  };

  var PATH = {};
  PATH[BASENAME] = "";                                        // empty path gets the root URL
  PATH.a11y = '[MathJax]/extensions/a11y';                    // a11y extensions
  PATH.Contrib = "https://cdn.mathjax.org/mathjax/contrib";   // the third-party extensions

  BASE.Ajax = {
    loaded: {},         // files already loaded
    loading: {},        // files currently in process of loading
    loadHooks: {},      // hooks to call when files are loaded
    timeout: 15*1000,   // timeout for loading of files (15 seconds)
    styleDelay: 1,      // delay to use before styles are available
    config: {
      root: "",         // URL of root directory to load from
      path: PATH        // paths to named URL's (e.g., [MathJax]/...)
    },
    params:  {},        // filled in from MathJax.js?...

    STATUS: {
      OK: 1,         // file is loading or did load OK
      ERROR: -1      // file timed out during load
    },

    //
    //  Return a complete URL to a file (replacing any root names)
    //
    fileURL: function (file) {
      var match;
      while ((match = file.match(/^\[([-._a-z0-9]+)\]/i)) && PATH.hasOwnProperty(match[1])) {
        file = (PATH[match[1]]||this.config.root) + file.substr(match[1].length+2);
      }
      return file;
    },
    //
    //  Replace root names if URL includes one
    //
    fileName: function (url) {
      var root = this.config.root;
      if (url.substr(0,root.length) === root) {url = "["+BASENAME+"]"+url.substr(root.length)}
      do {
        var recheck = false;
        for (var id in PATH) {if (PATH.hasOwnProperty(id) && PATH[id]) {
          if (url.substr(0,PATH[id].length) === PATH[id]) {
            url = "["+id+"]"+url.substr(PATH[id].length);
            recheck = true;
            break;
          }
        }}
      } while (recheck);
      return url;
    },
    //
    //  Cache-breaking revision number for file
    //
    fileRev: function (file) {
      var V = BASE.cdnFileVersions[file] || BASE.cdnVersion || '';
      if (V) {V = "?V="+V}
      return V;
    },
    urlRev: function (file) {return this.fileURL(file)+this.fileRev(file)},

    //
    //  Load a file if it hasn't been already.
    //  Make sure the file URL is "safe"?
    //
    Require: function (file,callback) {
      callback = BASE.Callback(callback); var type;
      if (file instanceof Object) {
        for (var i in file)
          {if (file.hasOwnProperty(i)) {type = i.toUpperCase(); file = file[i]}}
      } else {type = file.split(/\./).pop().toUpperCase()}
      if (this.params.noContrib && file.substr(0,9) === "[Contrib]") {
        callback(this.STATUS.ERROR);
      } else {
        file = this.fileURL(file);
        // FIXME: check that URL is OK
        if (this.loaded[file]) {
          callback(this.loaded[file]);
        } else {
          var FILE = {}; FILE[type] = file;
          this.Load(FILE,callback);
        }
      }
      return callback;
    },

    //
    //  Load a file regardless of where it is and whether it has
    //  already been loaded.
    //
    Load: function (file,callback) {
      callback = BASE.Callback(callback); var type;
      if (file instanceof Object) {
        for (var i in file)
          {if (file.hasOwnProperty(i)) {type = i.toUpperCase(); file = file[i]}}
      } else {type = file.split(/\./).pop().toUpperCase()}
      file = this.fileURL(file);
      if (this.loading[file]) {
        this.addHook(file,callback);
      } else {
        this.head = HEAD(this.head);
        if (this.loader[type]) {this.loader[type].call(this,file,callback)}
          else {throw Error("Can't load files of type "+type)}
      }
      return callback;
    },

    //
    //  Register a load hook for a particular file (it will be called when
    //  loadComplete() is called for that file)
    //
    LoadHook: function (file,callback,priority) {
      callback = BASE.Callback(callback);
      if (file instanceof Object)
        {for (var i in file) {if (file.hasOwnProperty(i)) {file = file[i]}}}
      file = this.fileURL(file);
      if (this.loaded[file]) {callback(this.loaded[file])}
        else {this.addHook(file,callback,priority)}
      return callback;
    },
    addHook: function (file,callback,priority) {
      if (!this.loadHooks[file]) {this.loadHooks[file] = MathJax.Callback.Hooks()}
      this.loadHooks[file].Add(callback,priority);
      callback.file = file;
    },
    removeHook: function (hook) {
      if (this.loadHooks[hook.file]) {
        this.loadHooks[hook.file].Remove(hook);
        if (!this.loadHooks[hook.file].hooks.length) {delete this.loadHooks[hook.file]}
      }
    },

    //
    //  Used when files are combined in a preloading configuration file
    //
    Preloading: function () {
      for (var i = 0, m = arguments.length; i < m; i++) {
        var file = this.fileURL(arguments[i]);
        if (!this.loading[file]) {this.loading[file] = {preloaded: true}}
      }
    },

    //
    //  Code used to load the various types of files
    //  (JS for JavaScript, CSS for style sheets)
    //
    loader: {
      //
      //  Create a SCRIPT tag to load the file
      //
      JS: function (file,callback) {
        var name = this.fileName(file);
        var script = document.createElement("script");
        var timeout = BASE.Callback(["loadTimeout",this,file]);
        this.loading[file] = {
          callback: callback,
          timeout: setTimeout(timeout,this.timeout),
          status: this.STATUS.OK,
          script: script
        };
        //
        // Add this to the structure above after it is created to prevent recursion
        //  when loading the initial localization file (before loading message is available)
        //
        this.loading[file].message = BASE.Message.File(name);
        script.onerror = timeout;  // doesn't work in IE and no apparent substitute
        script.type = "text/javascript";
        script.src = file+this.fileRev(name);
        this.head.appendChild(script);
      },
      //
      //  Create a LINK tag to load the style sheet
      //
      CSS: function (file,callback) {
        var name = this.fileName(file);
        var link = document.createElement("link");
        link.rel = "stylesheet"; link.type = "text/css";
        link.href = file+this.fileRev(name);
        this.loading[file] = {
          callback: callback,
          message: BASE.Message.File(name),
          status: this.STATUS.OK
        };
        this.head.appendChild(link);
        this.timer.create.call(this,[this.timer.file,file],link);
      }
    },

    //
    //  Timing code for checking when style sheets are available.
    //
    timer: {
      //
      //  Create the timing callback and start the timing loop.
      //  We use a delay because some browsers need it to allow the styles
      //  to be processed.
      //
      create: function (callback,node) {
        callback = BASE.Callback(callback);
        if (node.nodeName === "STYLE" && node.styleSheet &&
            typeof(node.styleSheet.cssText) !== 'undefined') {
          callback(this.STATUS.OK); // MSIE processes style immediately, but doesn't set its styleSheet!
        } else if (window.chrome && node.nodeName === "LINK") {
          callback(this.STATUS.OK); // Chrome doesn't give access to cssRules for stylesheet in
                                    //   a link node, so we can't detect when it is loaded.
        } else if (isSafari2) {
          this.timer.start(this,[this.timer.checkSafari2,sheets++,callback],this.styleDelay);
        } else {
          this.timer.start(this,[this.timer.checkLength,node,callback],this.styleDelay);
        }
        return callback;
      },
      //
      //  Start the timer for the given callback checker
      //
      start: function (AJAX,check,delay,timeout) {
        check = BASE.Callback(check);
        check.execute = this.execute; check.time = this.time;
        check.STATUS = AJAX.STATUS; check.timeout = timeout || AJAX.timeout;
        check.delay = check.total = delay || 0;
        if (delay) {setTimeout(check,delay)} else {check()}
      },
      //
      //  Increment the time total, increase the delay
      //  and test if we are past the timeout time.
      //
      time: function (callback) {
        this.total += this.delay;
        this.delay = Math.floor(this.delay * 1.05 + 5);
        if (this.total >= this.timeout) {callback(this.STATUS.ERROR); return 1}
        return 0;
      },
      //
      //  For JS file loads, call the proper routine according to status
      //
      file: function (file,status) {
        if (status < 0) {BASE.Ajax.loadTimeout(file)} else {BASE.Ajax.loadComplete(file)}
      },
      //
      //  Call the hook with the required data
      //
      execute: function () {this.hook.call(this.object,this,this.data[0],this.data[1])},
      //
      //  Safari2 doesn't set the link's stylesheet, so we need to look in the
      //  document.styleSheets array for the new sheet when it is created
      //
      checkSafari2: function (check,length,callback) {
        if (check.time(callback)) return;
        if (document.styleSheets.length > length &&
            document.styleSheets[length].cssRules &&
            document.styleSheets[length].cssRules.length)
          {callback(check.STATUS.OK)} else {setTimeout(check,check.delay)}
      },
      //
      //  Look for the stylesheets rules and check when they are defined
      //  and no longer of length zero.  (This assumes there actually ARE
      //  some rules in the stylesheet.)
      //
      checkLength: function (check,node,callback) {
        if (check.time(callback)) return;
        var isStyle = 0; var sheet = (node.sheet || node.styleSheet);
        try {if ((sheet.cssRules||sheet.rules||[]).length > 0) {isStyle = 1}} catch(err) {
          if (err.message.match(/protected variable|restricted URI/)) {isStyle = 1}
          else if (err.message.match(/Security error/)) {
            // Firefox3 gives "Security error" for missing files, so
            //   can't distinguish that from OK files on remote servers.
            //   or OK files in different directory from local files.
            isStyle = 1; // just say it is OK (can't really tell)
          }
        }
        if (isStyle) {
          // Opera 9.6 requires this setTimeout
          setTimeout(BASE.Callback([callback,check.STATUS.OK]),0);
        } else {
          setTimeout(check,check.delay);
        }
      }
    },

    //
    //  JavaScript code must call this when they are completely initialized
    //  (this allows them to perform asynchronous actions before indicating
    //  that they are complete).
    //
    loadComplete: function (file) {
      file = this.fileURL(file);
      var loading = this.loading[file];
      if (loading && !loading.preloaded) {
        BASE.Message.Clear(loading.message);
        clearTimeout(loading.timeout);
	if (loading.script) {
	  if (SCRIPTS.length === 0) {setTimeout(REMOVESCRIPTS,0)}
	  SCRIPTS.push(loading.script);
	}
        this.loaded[file] = loading.status; delete this.loading[file];
        this.addHook(file,loading.callback);
      } else {
        if (loading) {delete this.loading[file]}
        this.loaded[file] = this.STATUS.OK;
        loading = {status: this.STATUS.OK}
      }
      if (!this.loadHooks[file]) {return null}
      return this.loadHooks[file].Execute(loading.status);
    },

    //
    //  If a file fails to load within the timeout period (or the onerror handler
    //  is called), this routine runs to signal the error condition.
    //
    loadTimeout: function (file) {
      if (this.loading[file].timeout) {clearTimeout(this.loading[file].timeout)}
      this.loading[file].status = this.STATUS.ERROR;
      this.loadError(file);
      this.loadComplete(file);
    },

    //
    //  The default error hook for file load failures
    //
    loadError: function (file) {
      BASE.Message.Set(["LoadFailed","File failed to load: %1",file],null,2000);
      BASE.Hub.signal.Post(["file load error",file]);
    },

    //
    //  Defines a style sheet from a hash of style declarations (key:value pairs
    //  where the key is the style selector and the value is a hash of CSS attributes
    //  and values).
    //
    Styles: function (styles,callback) {
      var styleString = this.StyleString(styles);
      if (styleString === "") {
        callback = BASE.Callback(callback);
        callback();
      } else {
        var style = document.createElement("style"); style.type = "text/css";
        this.head = HEAD(this.head);
        this.head.appendChild(style);
        if (style.styleSheet && typeof(style.styleSheet.cssText) !== 'undefined') {
          style.styleSheet.cssText = styleString;
        } else {
          style.appendChild(document.createTextNode(styleString));
        }
        callback = this.timer.create.call(this,callback,style);
      }
      return callback;
    },

    //
    //  Create a stylesheet string from a style declaration object
    //
    StyleString: function (styles) {
      if (typeof(styles) === 'string') {return styles}
      var string = "", id, style;
      for (id in styles) {if (styles.hasOwnProperty(id)) {
        if (typeof styles[id] === 'string') {
          string += id + " {"+styles[id]+"}\n";
        } else if (BASE.Object.isArray(styles[id])) {
          for (var i = 0; i < styles[id].length; i++) {
            style = {}; style[id] = styles[id][i];
            string += this.StyleString(style);
          }
        } else if (id.substr(0,6) === '@media') {
          string += id + " {"+this.StyleString(styles[id])+"}\n";
        } else if (styles[id] != null) {
          style = [];
          for (var name in styles[id]) {if (styles[id].hasOwnProperty(name)) {
            if (styles[id][name] != null)
              {style[style.length] = name + ': ' + styles[id][name]}
          }}
          string += id +" {"+style.join('; ')+"}\n";
        }
      }}
      return string;
    }
  };

})("MathJax");

/**********************************************************/

MathJax.HTML = {
  //
  //  Create an HTML element with given attributes and content.
  //  The def parameter is an (optional) object containing key:value pairs
  //  of the attributes and their values, and contents is an (optional)
  //  array of strings to be inserted as text, or arrays of the form
  //  [type,def,contents] that describes an HTML element to be inserted
  //  into the current element.  Thus the contents can describe a complete
  //  HTML snippet of arbitrary complexity.  E.g.:
  //
  //    MathJax.HTML.Element("span",{id:"mySpan",style{"font-style":"italic"}},[
  //        "(See the ",["a",{href:"http://www.mathjax.org"},["MathJax home page"]],
  //        " for more details.)"]);
  //
  Element: function (type,def,contents) {
    var obj = document.createElement(type), id;
    if (def) {
      if (def.hasOwnProperty("style")) {
        var style = def.style; def.style = {};
        for (id in style) {if (style.hasOwnProperty(id))
          {def.style[id.replace(/-([a-z])/g,this.ucMatch)] = style[id]}}
      }
      MathJax.Hub.Insert(obj,def);
      for (id in def) {
        if (id === "role" || id.substr(0,5) === "aria-") obj.setAttribute(id,def[id]);
      }
    }
    if (contents) {
      if (!MathJax.Object.isArray(contents)) {contents = [contents]}
      for (var i = 0, m = contents.length; i < m; i++) {
        if (MathJax.Object.isArray(contents[i])) {
          obj.appendChild(this.Element(contents[i][0],contents[i][1],contents[i][2]));
        } else if (type === "script") { // IE throws an error if script is added as a text node
          this.setScript(obj, contents[i]);
        } else {
          obj.appendChild(document.createTextNode(contents[i]));
        }
      }
    }
    return obj;
  },
  ucMatch: function (match,c) {return c.toUpperCase()},
  addElement: function (span,type,def,contents) {return span.appendChild(this.Element(type,def,contents))},
  TextNode: function (text) {return document.createTextNode(text)},
  addText: function (span,text) {return span.appendChild(this.TextNode(text))},

  //
  //  Set and get the text of a script
  //
  setScript: function (script,text) {
    if (this.setScriptBug) {script.text = text} else {
      while (script.firstChild) {script.removeChild(script.firstChild)}
      this.addText(script,text);
    }
  },
  getScript: function (script) {
    var text = (script.text === "" ? script.innerHTML : script.text);
    return text.replace(/^\s+/,"").replace(/\s+$/,"");
  },

  //
  //  Manage cookies
  //
  Cookie: {
    prefix: "mjx",
    expires: 365,

    //
    //  Save an object as a named cookie
    //
    Set: function (name,def) {
      var keys = [];
      if (def) {
        for (var id in def) {if (def.hasOwnProperty(id)) {
          keys.push(id+":"+def[id].toString().replace(/&/g,"&&"));
        }}
      }
      var cookie = this.prefix+"."+name+"="+escape(keys.join('&;'));
      if (this.expires) {
        var time = new Date(); time.setDate(time.getDate() + this.expires);
        cookie += '; expires='+time.toGMTString();
      }
      try {document.cookie = cookie+"; path=/"} catch (err) {} // ignore errors saving cookies
    },

    //
    //  Get the contents of a named cookie and incorporate
    //  it into the given object (or return a fresh one)
    //
    Get: function (name,obj) {
      if (!obj) {obj = {}}
      var pattern = new RegExp("(?:^|;\\s*)"+this.prefix+"\\."+name+"=([^;]*)(?:;|$)");
      var match;
      try {match = pattern.exec(document.cookie)} catch (err) {}; // ignore errors reading cookies
      if (match && match[1] !== "") {
        var keys = unescape(match[1]).split('&;');
        for (var i = 0, m = keys.length; i < m; i++) {
          match = keys[i].match(/([^:]+):(.*)/);
          var value = match[2].replace(/&&/g,'&');
          if (value === "true") {value = true} else if (value === "false") {value = false}
            else if (value.match(/^-?(\d+(\.\d+)?|\.\d+)$/)) {value = parseFloat(value)}
          obj[match[1]] = value;
        }
      }
      return obj;
    }
  }

};


/**********************************************************/

MathJax.Localization = {

  locale: "en",
  directory: "[MathJax]/localization",
  strings: {
    // Currently, this list is not modified by the MathJax-i18n script. You can
    // run the following command in MathJax/unpacked/localization to update it:
    //
    // find . -name "*.js" | xargs grep menuTitle\: | grep -v qqq | sed 's/^\.\/\(.*\)\/.*\.js\:  /    "\1"\: \{/' | sed 's/,$/\},/' | sed 's/"English"/"English", isLoaded: true/' > tmp ; sort tmp > tmp2 ; sed '$ s/,$//' tmp2 ; rm tmp*
    //
    // This only takes languages with localization data so you must also add
    // the languages that use a remap but are not translated at all.
    //
    "ar": {menuTitle: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629"},
    "ast": {menuTitle: "asturianu"},
    "bg": {menuTitle: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438"},
    "bcc": {menuTitle: "\u0628\u0644\u0648\u0686\u06CC"},
    "br": {menuTitle: "brezhoneg"},
    "ca": {menuTitle: "catal\u00E0"},
    "cdo": {menuTitle: "M\u00ECng-d\u0115\u0324ng-ng\u1E73\u0304"},
    "cs": {menuTitle: "\u010De\u0161tina"},
    "da": {menuTitle: "dansk"},
    "de": {menuTitle: "Deutsch"},
    "diq": {menuTitle: "Zazaki"},
    "en": {menuTitle: "English", isLoaded: true},
    "eo": {menuTitle: "Esperanto"},
    "es": {menuTitle: "espa\u00F1ol"},
    "fa": {menuTitle: "\u0641\u0627\u0631\u0633\u06CC"},
    "fi": {menuTitle: "suomi"},
    "fr": {menuTitle: "fran\u00E7ais"},
    "gl": {menuTitle: "galego"},
    "he": {menuTitle: "\u05E2\u05D1\u05E8\u05D9\u05EA"},
    "ia": {menuTitle: "interlingua"},
    "it": {menuTitle: "italiano"},
    "ja": {menuTitle: "\u65E5\u672C\u8A9E"},
    "kn": {menuTitle: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1"},
    "ko": {menuTitle: "\uD55C\uAD6D\uC5B4"},
    "lb": {menuTitle: "L\u00EBtzebuergesch"},
    "lki": {menuTitle: "\u0644\u06D5\u06A9\u06CC"},
    "lt": {menuTitle: "lietuvi\u0173"},
    "mk": {menuTitle: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438"},
    "nl": {menuTitle: "Nederlands"},
    "oc": {menuTitle: "occitan"},
    "pl": {menuTitle: "polski"},
    "pt": {menuTitle: "portugu\u00EAs"},
    "pt-br": {menuTitle: "portugu\u00EAs do Brasil"},
    "ru": {menuTitle: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"},
    "sco": {menuTitle: "Scots"},
    "scn": {menuTitle: "sicilianu"},
    "sk": {menuTitle: "sloven\u010Dina"},
    "sl": {menuTitle: "sloven\u0161\u010Dina"},
    "sv": {menuTitle: "svenska"},
    "th": {menuTitle: "\u0E44\u0E17\u0E22"},
    "tr": {menuTitle: "T\u00FCrk\u00E7e"},
    "uk": {menuTitle: "\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"},
    "vi": {menuTitle: "Ti\u1EBFng Vi\u1EC7t"},
    "zh-hans": {menuTitle: "\u4E2D\u6587\uFF08\u7B80\u4F53\uFF09"},
    "zh-hant": {menuTitle: "\u6C49\u8BED"}
  },

  //
  //  The pattern for substitution escapes:
  //      %n or %{n} or %{plural:%n|option1|option1|...} or %c
  //
  pattern: /%(\d+|\{\d+\}|\{[a-z]+:\%\d+(?:\|(?:%\{\d+\}|%.|[^\}])*)+\}|.)/g,

  SPLIT: ("axb".split(/(x)/).length === 3 ?
    function (string,regex) {return string.split(regex)} :
    //
    //  IE8 and below don't do split() correctly when the pattern includes
    //    parentheses (the split should include the matched exrepssions).
    //    So implement it by hand here.
    //
    function (string,regex) {
      var result = [], match, last = 0;
      regex.lastIndex = 0;
      while ((match = regex.exec(string))) {
        result.push(string.substr(last,match.index-last));
        result.push.apply(result,match.slice(1));
        last = match.index + match[0].length;
      }
      result.push(string.substr(last));
      return result;
    }),

  _: function (id,phrase) {
    if (MathJax.Object.isArray(phrase)) {return this.processSnippet(id,phrase)}
    return this.processString(this.lookupPhrase(id,phrase),[].slice.call(arguments,2));
  },

  processString: function (string,args,domain) {
    //
    //  Process arguments for substitution
    //    If the argument is a snippet (and we are processing snippets) do so,
    //    Otherwise, if it is a number, convert it for the lacale
    //
    var i, m, isArray = MathJax.Object.isArray;
    for (i = 0, m = args.length; i < m; i++) {
      if (domain && isArray(args[i])) {args[i] = this.processSnippet(domain,args[i])}
    }
    //
    //  Split string at escapes and process them individually
    //
    var parts = this.SPLIT(string,this.pattern);
    for (i = 1, m = parts.length; i < m; i += 2) {
      var c = parts[i].charAt(0);  // first char will be { or \d or a char to be kept literally
      if (c >= "0" && c <= "9") {    // %n
        parts[i] = args[parts[i]-1];
        if (typeof parts[i] === "number") parts[i] = this.number(parts[i]);
      } else if (c === "{") {        // %{n} or %{plural:%n|...}
        c = parts[i].substr(1);
        if (c >= "0" && c <= "9") {  // %{n}
          parts[i] = args[parts[i].substr(1,parts[i].length-2)-1];
          if (typeof parts[i] === "number") parts[i] = this.number(parts[i]);
        } else {                     // %{plural:%n|...}
          var match = parts[i].match(/^\{([a-z]+):%(\d+)\|(.*)\}$/);
          if (match) {
            if (match[1] === "plural") {
              var n = args[match[2]-1];
              if (typeof n === "undefined") {
                parts[i] = "???";        // argument doesn't exist
              } else {
                n = this.plural(n) - 1;  // index of the form to use
                var plurals = match[3].replace(/(^|[^%])(%%)*%\|/g,"$1$2%\uEFEF").split(/\|/); // the parts (replacing %| with a special character)
                if (n >= 0 && n < plurals.length) {
                  parts[i] = this.processString(plurals[n].replace(/\uEFEF/g,"|"),args,domain);
                } else {
                  parts[i] = "???";      // no string for this index
                }
              }
            } else {parts[i] = "%"+parts[i]}  // not "plural", put back the % and leave unchanged
          }
        }
      }
      if (parts[i] == null) {parts[i] = "???"}
    }
    //
    //  If we are not forming a snippet, return the completed string
    //
    if (!domain) {return parts.join("")}
    //
    //  We need to return an HTML snippet, so buld it from the
    //  broken up string with inserted parts (that could be snippets)
    //
    var snippet = [], part = "";
    for (i = 0; i < m; i++) {
      part += parts[i]; i++;  // add the string and move on to substitution result
      if (i < m) {
        if (isArray(parts[i]))  {                // substitution was a snippet
          snippet.push(part);                        // add the accumulated string
          snippet = snippet.concat(parts[i]);        // concatenate the substution snippet
          part = "";                                 // start accumulating a new string
        } else {                                 // substitution was a string
          part += parts[i];                          // add to accumulating string
        }
      }
    }
    if (part !== "") {snippet.push(part)} // add final string
    return snippet;
  },

  processSnippet: function (domain,snippet) {
    var result = [];   // the new snippet
    //
    //  Look through the original snippet for
    //   strings or snippets to translate
    //
    for (var i = 0, m = snippet.length; i < m; i++) {
      if (MathJax.Object.isArray(snippet[i])) {
        //
        //  This could be a sub-snippet:
        //    ["tag"] or ["tag",{properties}] or ["tag",{properties},snippet]
        //  Or it could be something to translate:
        //    [id,string,args] or [domain,snippet]
        var data = snippet[i];
        if (typeof data[1] === "string") {        // [id,string,args]
          var id = data[0]; if (!MathJax.Object.isArray(id)) {id = [domain,id]}
          var phrase = this.lookupPhrase(id,data[1]);
          result = result.concat(this.processMarkdown(phrase,data.slice(2),domain));
        } else if (MathJax.Object.isArray(data[1])) {    // [domain,snippet]
          result = result.concat(this.processSnippet.apply(this,data));
        } else if (data.length >= 3) {            // ["tag",{properties},snippet]
          result.push([data[0],data[1],this.processSnippet(domain,data[2])]);
        } else {                                  // ["tag"] or ["tag",{properties}]
          result.push(snippet[i]);
        }
      } else {                                    // a string
        result.push(snippet[i]);
      }
    }
    return result;
  },

  markdownPattern: /(%.)|(\*{1,3})((?:%.|.)+?)\2|(`+)((?:%.|.)+?)\4|\[((?:%.|.)+?)\]\(([^\s\)]+)\)/,
  //   %c or *bold*, **italics**, ***bold-italics***, or `code`, or [link](url)

  processMarkdown: function (phrase,args,domain) {
    var result = [], data;
    //
    //  Split the string by the Markdown pattern
    //    (the text blocks are separated by
    //      c,stars,star-text,backtics,code-text,link-text,URL).
    //  Start with the first text string from the split.
    //
    var parts = phrase.split(this.markdownPattern);
    var string = parts[0];
    //
    //  Loop through the matches and process them
    //
    for (var i = 1, m = parts.length; i < m; i += 8) {
      if (parts[i+1]) {        // stars (for bold/italic)
        //
        //  Select the tag to use by number of stars (three stars requires two tags)
        //
        data = this.processString(parts[i+2],args,domain);
        if (!MathJax.Object.isArray(data)) {data = [data]}
        data = [["b","i","i"][parts[i+1].length-1],{},data]; // number of stars determines type
        if (parts[i+1].length === 3) {data = ["b",{},data]}  // bold-italic
      } else if (parts[i+3]) { //  backtics (for code)
        //
        //  Remove one leading or trailing space, and process substitutions
        //  Make a <code> tag
        //
        data = this.processString(parts[i+4].replace(/^\s/,"").replace(/\s$/,""),args,domain);
        if (!MathJax.Object.isArray(data)) {data = [data]}
        data = ["code",{},data];
      } else if (parts[i+5]) { //  hyperlink
        //
        //  Process the link text, and make an <a> tag with the URL
        //
        data = this.processString(parts[i+5],args,domain);
        if (!MathJax.Object.isArray(data)) {data = [data]}
        data = ["a",{href:this.processString(parts[i+6],args),target:"_blank"},data];
      } else {
        //
        //  Escaped character (%c) gets added into the string.
        //
        string += parts[i]; data = null;
      }
      //
      //  If there is a tag to insert,
      //     Add any pending string, then push the tag
      //
      if (data) {
        result = this.concatString(result,string,args,domain);
        result.push(data); string = "";
      }
      //
      //  Process the string that follows matches pattern
      //
      if (parts[i+7] !== "") {string += parts[i+7]}
    };
    //
    //  Add any pending string and return the resulting snippet
    //
    result = this.concatString(result,string,args,domain);
    return result;
  },
  concatString: function (result,string,args,domain) {
    if (string != "") {
      //
      //  Process the substutions.
      //  If the result is not a snippet, turn it into one.
      //  Then concatenate the snippet to the current one
      //
      string = this.processString(string,args,domain);
      if (!MathJax.Object.isArray(string)) {string = [string]}
      result = result.concat(string);
    }
    return result;
  },

  lookupPhrase: function (id,phrase,domain) {
    //
    //  Get the domain and messageID
    //
    if (!domain) {domain = "_"}
    if (MathJax.Object.isArray(id)) {domain = (id[0] || "_"); id = (id[1] || "")}
    //
    //  Check if the data is available and if not,
    //    load it and throw a restart error so the calling
    //    code can wait for the load and try again.
    //
    var load = this.loadDomain(domain);
    if (load) {MathJax.Hub.RestartAfter(load)}
    //
    //  Look up the message in the localization data
    //    (if not found, the original English is used)
    //
    var localeData = this.strings[this.locale];
    if (localeData) {
      if (localeData.domains && domain in localeData.domains) {
        var domainData = localeData.domains[domain];
        if (domainData.strings && id in domainData.strings)
          {phrase = domainData.strings[id]}
      }
    }
    //
    //  return the translated phrase
    //
    return phrase;
  },

  //
  //  Load a langauge data file from the proper
  //  directory and file.
  //
  loadFile: function (file,data,callback) {
    callback = MathJax.Callback(callback);
    file = (data.file || file);  // the data's file name or the default name
    if (!file.match(/\.js$/)) {file += ".js"} // add .js if needed
    //
    //  Add the directory if the file doesn't
    //  contain a full URL already.
    //
    if (!file.match(/^([a-z]+:|\[MathJax\])/)) {
      var dir = (this.strings[this.locale].directory  ||
                 this.directory + "/" + this.locale ||
                 "[MathJax]/localization/" + this.locale);
      file = dir + "/" + file;
    }
    //
    //  Load the file and mark the data as loaded (even if it
    //  failed to load, so we don't continue to try to load it
    //  over and over).
    //
    var load = MathJax.Ajax.Require(file,function () {data.isLoaded = true; return callback()});
    //
    //  Return the callback if needed, otherwise null.
    //
    return (load.called ? null : load);
  },

  //
  //  Check to see if the localization data are loaded
  //  for the given domain; if not, load the data file,
  //  and return a callback for the loading operation.
  //  Otherwise return null (data are loaded).
  //
  loadDomain: function (domain,callback) {
    var load, localeData = this.strings[this.locale];
    if (localeData) {
      if (!localeData.isLoaded) {
        load = this.loadFile(this.locale,localeData);
        if (load) {
          return MathJax.Callback.Queue(
            load,["loadDomain",this,domain] // call again to load domain
          ).Push(callback||{});
        }
      }
      if (localeData.domains && domain in localeData.domains) {
        var domainData = localeData.domains[domain];
        if (!domainData.isLoaded) {
          load = this.loadFile(domain,domainData);
          if (load) {return MathJax.Callback.Queue(load).Push(callback)}
        }
      }
    }
    // localization data are loaded, so just do the callback
    return MathJax.Callback(callback)();
  },

  //
  //  Perform a function, properly handling
  //  restarts due to localization file loads.
  //
  //  Note that this may return before the function
  //  has been called successfully, so you should
  //  consider fn as running asynchronously.  (Callbacks
  //  can be used to synchronize it with other actions.)
  //
  Try: function (fn) {
    fn = MathJax.Callback(fn); fn.autoReset = true;
    try {fn()} catch (err) {
      if (!err.restart) {throw err}
      MathJax.Callback.After(["Try",this,fn],err.restart);
    }
  },

  //
  //  Reset the current language
  //
  resetLocale: function(locale) {
    // Selection algorithm:
    // 1) Downcase locale name (e.g. "en-US" => "en-us")
    // 2) Try a parent language (e.g. "en-us" => "en")
    // 3) Try the fallback specified in the data (e.g. "pt" => "pt-br")
    // 4) Otherwise don't change the locale.
    if (!locale) return;
    locale = locale.toLowerCase();
    while (!this.strings[locale]) {
      var dashPos = locale.lastIndexOf("-");
      if (dashPos === -1) return;
      locale = locale.substring(0, dashPos);
    }
    var remap = this.strings[locale].remap;
    this.locale = remap ? remap : locale;
    MathJax.Callback.Signal("Hub").Post(["Locale Reset", this.locale]);
  },

  //
  //  Set the current language
  //
  setLocale: function(locale) {
    this.resetLocale(locale);
    if (MathJax.Menu) {this.loadDomain("MathMenu")}
  },

  //
  //  Add or update a language or domain
  //
  addTranslation: function (locale,domain,definition) {
    var data = this.strings[locale], isNew = false;
    if (!data) {data = this.strings[locale] = {}; isNew = true}
    if (!data.domains) {data.domains = {}}
    if (domain) {
      if (!data.domains[domain]) {data.domains[domain] = {}}
      data = data.domains[domain];
    }
    MathJax.Hub.Insert(data,definition);
    if (isNew && MathJax.Menu.menu) {MathJax.Menu.CreateLocaleMenu()}
  },

  //
  //  Set CSS for an element based on font requirements
  //
  setCSS: function (div) {
    var locale = this.strings[this.locale];
    if (locale) {
      if (locale.fontFamily) {div.style.fontFamily = locale.fontFamily}
      if (locale.fontDirection) {
        div.style.direction = locale.fontDirection;
        if (locale.fontDirection === "rtl") {div.style.textAlign = "right"}
      }
    }
    return div;
  },

  //
  //  Get the language's font family or direction
  //
  fontFamily: function () {
    var locale = this.strings[this.locale];
    return (locale ? locale.fontFamily : null);
  },
  fontDirection: function () {
    var locale = this.strings[this.locale];
    return (locale ? locale.fontDirection : null);
  },

  //
  //  Get the language's plural index for a number
  //
  plural: function (n) {
    var locale = this.strings[this.locale];
    if (locale && locale.plural) {return locale.plural(n)}
    // default
    if (n == 1) {return 1} // one
    return 2; // other
  },

  //
  //  Convert a number to language-specific form
  //
  number: function(n) {
    var locale = this.strings[this.locale];
    if (locale && locale.number) {return locale.number(n)}
    // default
    return n;
  }
};


/**********************************************************/

MathJax.Message = {
  ready: false,  // used to tell when the styles are available
  log: [{}], current: null,
  textNodeBug: (navigator.vendor === "Apple Computer, Inc." &&
                typeof navigator.vendorSub === "undefined") ||
               (window.hasOwnProperty && window.hasOwnProperty("konqueror")), // Konqueror displays some gibberish with text.nodeValue = "..."

  styles: {
    "#MathJax_Message": {
      position: "fixed", left: "1px", bottom: "2px",
      'background-color': "#E6E6E6",  border: "1px solid #959595",
      margin: "0px", padding: "2px 8px",
      'z-index': "102", color: "black", 'font-size': "80%",
      width: "auto", 'white-space': "nowrap"
    },

    "#MathJax_MSIE_Frame": {
      position: "absolute",
      top:0, left: 0, width: "0px", 'z-index': 101,
      border: "0px", margin: "0px", padding: "0px"
    }
  },

  browsers: {
    MSIE: function (browser) {
      MathJax.Message.msieFixedPositionBug = ((document.documentMode||0) < 7);
      if (MathJax.Message.msieFixedPositionBug)
        {MathJax.Hub.config.styles["#MathJax_Message"].position = "absolute"}
      MathJax.Message.quirks = (document.compatMode === "BackCompat");
    },
    Chrome: function (browser) {
      MathJax.Hub.config.styles["#MathJax_Message"].bottom = "1.5em";
      MathJax.Hub.config.styles["#MathJax_Message"].left = "1em";
    }
  },

  Init: function (styles) {
    if (styles) {this.ready = true}
    if (!document.body || !this.ready) {return false}
    //
    //  ASCIIMathML replaces the entire page with a copy of itself (@#!#%@!!)
    //  so check that this.div is still part of the page, otherwise look up
    //  the copy and use that.
    //
    if (this.div && this.div.parentNode == null) {
      this.div = document.getElementById("MathJax_Message");
      this.text = (this.div ? this.div.firstChild : null);
    }
    if (!this.div) {
      var frame = document.body;
      if (this.msieFixedPositionBug && window.attachEvent) {
        frame = this.frame = this.addDiv(document.body); frame.removeAttribute("id");
        frame.style.position = "absolute";
        frame.style.border = frame.style.margin = frame.style.padding = "0px";
        frame.style.zIndex = "101"; frame.style.height = "0px";
        frame = this.addDiv(frame);
        frame.id = "MathJax_MSIE_Frame";
        window.attachEvent("onscroll",this.MoveFrame);
        window.attachEvent("onresize",this.MoveFrame);
        this.MoveFrame();
      }
      this.div = this.addDiv(frame); this.div.style.display = "none";
    }
    if (!this.text) {
      this.text = this.div.appendChild(document.createTextNode(""));
    }
    return true;
  },

  addDiv: function (parent) {
    var div = document.createElement("div");
    div.id = "MathJax_Message";
    if (parent.firstChild) {parent.insertBefore(div,parent.firstChild)}
      else {parent.appendChild(div)}
    return div;
  },

  MoveFrame: function () {
    var body = (MathJax.Message.quirks ? document.body : document.documentElement);
    var frame = MathJax.Message.frame;
    frame.style.left = body.scrollLeft + 'px';
    frame.style.top = body.scrollTop + 'px';
    frame.style.width = body.clientWidth + 'px';
    frame = frame.firstChild;
    frame.style.height = body.clientHeight + 'px';
  },

  localize: function (message) {
    return MathJax.Localization._(message,message);
  },

  filterText: function (text,n,id) {
    if (MathJax.Hub.config.messageStyle === "simple") {
      if (id === "LoadFile") {
        if (!this.loading) {this.loading = this.localize("Loading") + " "}
        text = this.loading; this.loading += ".";
      } else if (id === "ProcessMath") {
        if (!this.processing) {this.processing = this.localize("Processing") + " "}
        text = this.processing; this.processing += ".";
      } else if (id === "TypesetMath") {
        if (!this.typesetting) {this.typesetting = this.localize("Typesetting") + " "}
        text = this.typesetting; this.typesetting += ".";
      }
    }
    return text;
  },

  clearCounts: function () {
    delete this.loading;
    delete this.processing;
    delete this.typesetting;
  },

  Set: function (text,n,clearDelay) {
    if (n == null) {n = this.log.length; this.log[n] = {}}
    //
    //  Translate message if it is [id,message,arguments]
    //
    var id = "";
    if (MathJax.Object.isArray(text)) {
      id = text[0]; if (MathJax.Object.isArray(id)) {id = id[1]}
      //
      // Localization._() will throw a restart error if a localization file
      //   needs to be loaded, so trap that and redo the Set() call
      //   after it is loaded.
      //
      try {
        text = MathJax.Localization._.apply(MathJax.Localization,text);
      } catch (err) {
        if (!err.restart) {throw err}
        if (!err.restart.called) {
          //
          //  Mark it so we can tell if the Clear() comes before the message is displayed
          //
          if (this.log[n].restarted == null) {this.log[n].restarted = 0}
          this.log[n].restarted++; delete this.log[n].cleared;
          MathJax.Callback.After(["Set",this,text,n,clearDelay],err.restart);
          return n;
        }
      }
    }
    //
    // Clear the timout timer.
    //
    if (this.timer) {clearTimeout(this.timer); delete this.timer}
    //
    //  Save the message and filtered message.
    //
    this.log[n].text = text; this.log[n].filteredText = text = this.filterText(text,n,id);
    //
    //  Hook the message into the message list so we can tell
    //   what message to put up when this one is removed.
    //
    if (typeof(this.log[n].next) === "undefined") {
      this.log[n].next = this.current;
      if (this.current != null) {this.log[this.current].prev = n}
      this.current = n;
    }
    //
    //  Show the message if it is the currently active one.
    //
    if (this.current === n && MathJax.Hub.config.messageStyle !== "none") {
      if (this.Init()) {
        if (this.textNodeBug) {this.div.innerHTML = text} else {this.text.nodeValue = text}
        this.div.style.display = "";
        if (this.status) {window.status = ""; delete this.status}
      } else {
        window.status = text;
        this.status = true;
      }
    }
    //
    //  Check if the message was resetarted to load a localization file
    //    and if it has been cleared in the meanwhile.
    //
    if (this.log[n].restarted) {
      if (this.log[n].cleared) {clearDelay = 0}
      if (--this.log[n].restarted === 0) {delete this.log[n].cleared}
    }
    //
    //  Check if we need to clear the message automatically.
    //
    if (clearDelay) {setTimeout(MathJax.Callback(["Clear",this,n]),clearDelay)}
      else if (clearDelay == 0) {this.Clear(n,0)}
    //
    //  Return the message number.
    //
    return n;
  },

  Clear: function (n,delay) {
    //
    //  Detatch the message from the active list.
    //
    if (this.log[n].prev != null) {this.log[this.log[n].prev].next = this.log[n].next}
    if (this.log[n].next != null) {this.log[this.log[n].next].prev = this.log[n].prev}
    //
    //  If it is the current message, get the next one to show.
    //
    if (this.current === n) {
      this.current = this.log[n].next;
      if (this.text) {
        if (this.div.parentNode == null) {this.Init()} // see ASCIIMathML comments above
        if (this.current == null) {
          //
          //  If there are no more messages, remove the message box.
          //
          if (this.timer) {clearTimeout(this.timer); delete this.timer}
          if (delay == null) {delay = 600}
          if (delay === 0) {this.Remove()}
	    else {this.timer = setTimeout(MathJax.Callback(["Remove",this]),delay)}
        } else if (MathJax.Hub.config.messageStyle !== "none") {
          //
          //  If there is an old message, put it in place
          //
          if (this.textNodeBug) {this.div.innerHTML = this.log[this.current].filteredText}
                           else {this.text.nodeValue = this.log[this.current].filteredText}
        }
        if (this.status) {window.status = ""; delete this.status}
      } else if (this.status) {
        window.status = (this.current == null ? "" : this.log[this.current].text);
      }
    }
    //
    //  Clean up the log data no longer needed
    //
    delete this.log[n].next; delete this.log[n].prev;
    delete this.log[n].filteredText;
    //
    //  If this is a restarted localization message, mark that it has been cleared
    //    while waiting for the file to load.
    //
    if (this.log[n].restarted) {this.log[n].cleared = true}
  },

  Remove: function () {
    // FIXME:  do a fade out or something else interesting?
    this.text.nodeValue = "";
    this.div.style.display = "none";
  },

  File: function (file) {
    return this.Set(["LoadFile","Loading %1",file],null,null);
  },

  Log: function () {
    var strings = [];
    for (var i = 1, m = this.log.length; i < m; i++) {strings[i] = this.log[i].text}
    return strings.join("\n");
  }

};

/**********************************************************/

MathJax.Hub = {
  config: {
    root: "",
    config: [],      // list of configuration files to load
    styleSheets: [], // list of CSS files to load
    styles: {        // styles to generate in-line
      ".MathJax_Preview": {color: "#888"}
    },
    jax: [],         // list of input and output jax to load
    extensions: [],  // list of extensions to load
    preJax: null,    // pattern to remove from before math script tag
    postJax: null,   // pattern to remove from after math script tag
    displayAlign: 'center',       // how to align displayed equations (left, center, right)
    displayIndent: '0',           // indentation for displayed equations (when not centered)
    preRemoveClass: 'MathJax_Preview', // class of objects to remove preceding math script
    showProcessingMessages: true, // display "Processing math: nn%" messages or not
    messageStyle: "normal",       // set to "none" or "simple" (for "Loading..." and "Processing...")
    delayStartupUntil: "none",    // set to "onload" to delay setup until the onload handler runs
                                  // set to "configured" to delay startup until MathJax.Hub.Configured() is called
                                  // set to a Callback to wait for before continuing with the startup
    skipStartupTypeset: false,    // set to true to skip PreProcess and Process during startup
    elements: [],             // array of elements to process when none is given explicitly
    positionToHash: true,    // after initial typeset pass, position to #hash location?

    showMathMenu: true,      // attach math context menu to typeset math?
    showMathMenuMSIE: true,  // separtely determine if MSIE should have math menu
                             //  (since the code for that is a bit delicate)

    menuSettings: {
      zoom: "None",        //  when to do MathZoom
      CTRL: false,         //    require CTRL for MathZoom?
      ALT: false,          //    require Alt or Option?
      CMD: false,          //    require CMD?
      Shift: false,        //    require Shift?
      discoverable: false, //  make math menu discoverable on hover?
      zscale: "200%",      //  the scaling factor for MathZoom
      renderer: null,      //  set when Jax are loaded
      font: "Auto",        //  what font HTML-CSS should use
      context: "MathJax",  //  or "Browser" for pass-through to browser menu
      locale: null,        //  the language to use for messages
      mpContext: false,    //  true means pass menu events to MathPlayer in IE
      mpMouse: false,      //  true means pass mouse events to MathPlayer in IE
      texHints: true,      //  include class names for TeXAtom elements
      FastPreview: null,   //  use PreviewHTML output as preview?
      assistiveMML: null,  //  include hidden MathML for screen readers?
      inTabOrder: true,    //  set to false if math elements should be included in the tabindex
      semantics: false     //  add semantics tag with original form in MathML output
    },

    errorSettings: {
       // localized HTML snippet structure for message to use
      message: ["[",["MathProcessingError","Math Processing Error"],"]"],
      style: {color: "#CC0000", "font-style":"italic"}  // style for message
    },

    ignoreMMLattributes: {}  // attributes not to copy to HTML-CSS or SVG output
                             //   from MathML input (in addition to the ones in MML.nocopyAttributes).
                             //   An id set to true will be ignored, one set to false will
                             //   be allowed (even if other criteria normally would prevent
                             //   it from being copied); use false carefully!
  },

  preProcessors: MathJax.Callback.Hooks(true), // list of callbacks for preprocessing (initialized by extensions)
  inputJax: {},          // mime-type mapped to input jax (by registration)
  outputJax: {order:{}}, // mime-type mapped to output jax list (by registration)

  processSectionDelay: 50, // pause between input and output phases of processing
  processUpdateTime: 250, // time between screen updates when processing math (milliseconds)
  processUpdateDelay: 10, // pause between screen updates to allow other processing (milliseconds)

  signal: MathJax.Callback.Signal("Hub"), // Signal used for Hub events

  Config: function (def) {
    this.Insert(this.config,def);
    if (this.config.Augment) {this.Augment(this.config.Augment)}
  },
  CombineConfig: function (name,def) {
    var config = this.config, id, parent; name = name.split(/\./);
    for (var i = 0, m = name.length; i < m; i++) {
      id = name[i]; if (!config[id]) {config[id] = {}}
      parent = config; config = config[id];
    }
    parent[id] = config = this.Insert(def,config);
    return config;
  },

  Register: {
    PreProcessor: function () {return MathJax.Hub.preProcessors.Add.apply(MathJax.Hub.preProcessors,arguments)},
    MessageHook: function () {return MathJax.Hub.signal.MessageHook.apply(MathJax.Hub.signal,arguments)},
    StartupHook: function () {return MathJax.Hub.Startup.signal.MessageHook.apply(MathJax.Hub.Startup.signal,arguments)},
    LoadHook: function () {return MathJax.Ajax.LoadHook.apply(MathJax.Ajax,arguments)}
  },
  UnRegister: {
    PreProcessor: function (hook) {MathJax.Hub.preProcessors.Remove(hook)},
    MessageHook: function (hook) {MathJax.Hub.signal.RemoveHook(hook)},
    StartupHook: function (hook) {MathJax.Hub.Startup.signal.RemoveHook(hook)},
    LoadHook: function (hook) {MathJax.Ajax.removeHook(hook)}
  },

  getAllJax: function (element) {
    var jax = [], scripts = this.elementScripts(element);
    for (var i = 0, m = scripts.length; i < m; i++) {
      if (scripts[i].MathJax && scripts[i].MathJax.elementJax)
        {jax.push(scripts[i].MathJax.elementJax)}
    }
    return jax;
  },

  getJaxByType: function (type,element) {
    var jax = [], scripts = this.elementScripts(element);
    for (var i = 0, m = scripts.length; i < m; i++) {
      if (scripts[i].MathJax && scripts[i].MathJax.elementJax &&
          scripts[i].MathJax.elementJax.mimeType === type)
            {jax.push(scripts[i].MathJax.elementJax)}
    }
    return jax;
  },

  getJaxByInputType: function (type,element) {
    var jax = [], scripts = this.elementScripts(element);
    for (var i = 0, m = scripts.length; i < m; i++) {
      if (scripts[i].MathJax && scripts[i].MathJax.elementJax &&
          scripts[i].type && scripts[i].type.replace(/ *;(.|\s)*/,"") === type)
        {jax.push(scripts[i].MathJax.elementJax)}
    }
    return jax;
  },

  getJaxFor: function (element) {
    if (typeof(element) === 'string') {element = document.getElementById(element)}
    if (element && element.MathJax) {return element.MathJax.elementJax}
    if (this.isMathJaxNode(element)) {
      if (!element.isMathJax) {element = element.firstChild}  // for NativeMML output
      while (element && !element.jaxID) {element = element.parentNode}
      if (element) {return MathJax.OutputJax[element.jaxID].getJaxFromMath(element)}
    }
    return null;
  },

  isJax: function (element) {
    if (typeof(element) === 'string') {element = document.getElementById(element)}
    if (this.isMathJaxNode(element)) {return 1}
    if (element && (element.tagName||"").toLowerCase() === 'script') {
      if (element.MathJax)
        {return (element.MathJax.state === MathJax.ElementJax.STATE.PROCESSED ? 1 : -1)}
      if (element.type && this.inputJax[element.type.replace(/ *;(.|\s)*/,"")]) {return -1}
    }
    return 0;
  },
  isMathJaxNode: function (element) {
    return !!element && (element.isMathJax || (element.className||"") === "MathJax_MathML");
  },

  setRenderer: function (renderer,type) {
    if (!renderer) return;
    var JAX = MathJax.OutputJax[renderer];
    if (!JAX) {
      MathJax.OutputJax[renderer] = MathJax.OutputJax({id: "unknown", version:"1.0.0", isUnknown: true});
      this.config.menuSettings.renderer = "";
      var file = "[MathJax]/jax/output/"+renderer+"/config.js";
      return MathJax.Ajax.Require(file,["setRenderer",this,renderer,type]);
    } else {
      this.config.menuSettings.renderer = renderer;
      if (type == null) {type = "jax/mml"}
      if (JAX.isUnknown) JAX.Register(type);
      var jax = this.outputJax;
      if (jax[type] && jax[type].length) {
        if (renderer !== jax[type][0].id) {
          jax[type].unshift(JAX);
          return this.signal.Post(["Renderer Selected",renderer]);
        }
      }
      return null;
    }
  },

  Queue: function () {
    return this.queue.Push.apply(this.queue,arguments);
  },

  Typeset: function (element,callback) {
    if (!MathJax.isReady) return null;
    var ec = this.elementCallback(element,callback);
    if (ec.count) {
      var queue = MathJax.Callback.Queue(
        ["PreProcess",this,ec.elements],
        ["Process",this,ec.elements]
      );
    }
    return queue.Push(ec.callback);
  },

  PreProcess: function (element,callback) {
    var ec = this.elementCallback(element,callback);
    var queue = MathJax.Callback.Queue();
    if (ec.count) {
      var elements = (ec.count === 1 ? [ec.elements] : ec.elements);
      queue.Push(["Post",this.signal,["Begin PreProcess",ec.elements]]);
      for (var i = 0, m = elements.length; i < m; i++) {
        if (elements[i]) {queue.Push(["Execute",this.preProcessors,elements[i]])}
      }
      queue.Push(["Post",this.signal,["End PreProcess",ec.elements]]);
    }
    return queue.Push(ec.callback);
  },

  Process:   function (element,callback) {return this.takeAction("Process",element,callback)},
  Update:    function (element,callback) {return this.takeAction("Update",element,callback)},
  Reprocess: function (element,callback) {return this.takeAction("Reprocess",element,callback)},
  Rerender:  function (element,callback) {return this.takeAction("Rerender",element,callback)},

  takeAction: function (action,element,callback) {
    var ec = this.elementCallback(element,callback);
    var elements = ec.elements;
    var queue = MathJax.Callback.Queue(["Clear",this.signal]);
    var state = {
      scripts: [],                  // filled in by prepareScripts
      start: new Date().getTime(),  // timer for processing messages
      i: 0, j: 0,                   // current script, current jax
      jax: {},                      // scripts grouped by output jax
      jaxIDs: []                    // id's of jax used
    };
    if (ec.count) {
      var delay = ["Delay",MathJax.Callback,this.processSectionDelay];
      if (!delay[2]) {delay = {}}
      queue.Push(
        ["clearCounts",MathJax.Message],
        ["Post",this.signal,["Begin "+action,elements]],
        ["Post",this.signal,["Begin Math",elements,action]],
        ["prepareScripts",this,action,elements,state],
        ["Post",this.signal,["Begin Math Input",elements,action]],
        ["processInput",this,state],
        ["Post",this.signal,["End Math Input",elements,action]],
        delay,
        ["prepareOutput",this,state,"preProcess"],
        delay,
        ["Post",this.signal,["Begin Math Output",elements,action]],
        ["processOutput",this,state],
        ["Post",this.signal,["End Math Output",elements,action]],
        delay,
        ["prepareOutput",this,state,"postProcess"],
        delay,
        ["Post",this.signal,["End Math",elements,action]],
        ["Post",this.signal,["End "+action,elements]],
        ["clearCounts",MathJax.Message]
      );
    }
    return queue.Push(ec.callback);
  },

  scriptAction: {
    Process: function (script) {},
    Update: function (script) {
      var jax = script.MathJax.elementJax;
      if (jax && jax.needsUpdate()) {jax.Remove(true); script.MathJax.state = jax.STATE.UPDATE}
        else {script.MathJax.state = jax.STATE.PROCESSED}
    },
    Reprocess: function (script) {
      var jax = script.MathJax.elementJax;
      if (jax) {jax.Remove(true); script.MathJax.state = jax.STATE.UPDATE}
    },
    Rerender: function (script) {
      var jax = script.MathJax.elementJax;
      if (jax) {jax.Remove(true); script.MathJax.state = jax.STATE.OUTPUT}
    }
  },

  prepareScripts: function (action,element,state) {
    if (arguments.callee.disabled) return;
    var scripts = this.elementScripts(element);
    var STATE = MathJax.ElementJax.STATE;
    for (var i = 0, m = scripts.length; i < m; i++) {
      var script = scripts[i];
      if (script.type && this.inputJax[script.type.replace(/ *;(.|\n)*/,"")]) {
        if (script.MathJax) {
          if (script.MathJax.elementJax && script.MathJax.elementJax.hover) {
            MathJax.Extension.MathEvents.Hover.ClearHover(script.MathJax.elementJax);
          }
          if (script.MathJax.state !== STATE.PENDING) {this.scriptAction[action](script)}
        }
        if (!script.MathJax) {script.MathJax = {state: STATE.PENDING}}
        if (script.MathJax.error) delete script.MathJax.error;
        if (script.MathJax.state !== STATE.PROCESSED) {state.scripts.push(script)}
      }
    }
  },

  checkScriptSiblings: function (script) {
    if (script.MathJax.checked) return;
    var config = this.config, pre = script.previousSibling;
    if (pre && pre.nodeName === "#text") {
      var preJax,postJax, post = script.nextSibling;
      if (post && post.nodeName !== "#text") {post = null}
      if (config.preJax) {
        if (typeof(config.preJax) === "string") {config.preJax = new RegExp(config.preJax+"$")}
        preJax = pre.nodeValue.match(config.preJax);
      }
      if (config.postJax && post) {
        if (typeof(config.postJax) === "string") {config.postJax = new RegExp("^"+config.postJax)}
        postJax = post.nodeValue.match(config.postJax);
      }
      if (preJax && (!config.postJax || postJax)) {
        pre.nodeValue  = pre.nodeValue.replace
          (config.preJax,(preJax.length > 1? preJax[1] : ""));
        pre = null;
      }
      if (postJax && (!config.preJax || preJax)) {
        post.nodeValue = post.nodeValue.replace
          (config.postJax,(postJax.length > 1? postJax[1] : ""));
      }
      if (pre && !pre.nodeValue.match(/\S/)) {pre = pre.previousSibling}
    }
    if (config.preRemoveClass && pre && pre.className === config.preRemoveClass)
      {script.MathJax.preview = pre}
    script.MathJax.checked = 1;
  },

  processInput: function (state) {
    var jax, STATE = MathJax.ElementJax.STATE;
    var script, prev, m = state.scripts.length;
    try {
      //
      //  Loop through the scripts
      //
      while (state.i < m) {
        script = state.scripts[state.i]; if (!script) {state.i++; continue}
        //
        //  Remove previous error marker, if any
        //
        prev = script.previousSibling;
        if (prev && prev.className === "MathJax_Error") {prev.parentNode.removeChild(prev)}
        //
        //  Check if already processed or needs processing
        //
        if (!script.parentNode || !script.MathJax || script.MathJax.state === STATE.PROCESSED) {state.i++; continue};
        if (!script.MathJax.elementJax || script.MathJax.state === STATE.UPDATE) {
          this.checkScriptSiblings(script);                 // remove preJax/postJax etc.
          var type = script.type.replace(/ *;(.|\s)*/,"");  // the input jax type
          var input = this.inputJax[type];                  // the input jax itself
          jax = input.Process(script,state);                // run the input jax
          if (typeof jax === 'function') {                  // if a callback was returned
            if (jax.called) continue;                       //   go back and call Process() again
            this.RestartAfter(jax);                         //   wait for the callback
          }
          jax = jax.Attach(script,input.id);                // register the jax on the script
          this.saveScript(jax,state,script,STATE);          // add script to state
          this.postInputHooks.Execute(jax,input.id,script); // run global jax filters
        } else if (script.MathJax.state === STATE.OUTPUT) {
          this.saveScript(script.MathJax.elementJax,state,script,STATE); // add script to state
        }
        //
        //  Go on to the next script, and check if we need to update the processing message
        //
        state.i++; var now = new Date().getTime();
        if (now - state.start > this.processUpdateTime && state.i < state.scripts.length)
          {state.start = now; this.RestartAfter(MathJax.Callback.Delay(1))}
      }
    } catch (err) {return this.processError(err,state,"Input")}
    //
    //  Put up final message, reset the state and return
    //
    if (state.scripts.length && this.config.showProcessingMessages)
      {MathJax.Message.Set(["ProcessMath","Processing math: %1%%",100],0)}
    state.start = new Date().getTime(); state.i = state.j = 0;
    return null;
  },
  postInputHooks: MathJax.Callback.Hooks(true),  // hooks to run after element jax is created
  saveScript: function (jax,state,script,STATE) {
    //
    //  Check that output jax exists
    //
    if (!this.outputJax[jax.mimeType]) {
      script.MathJax.state = STATE.UPDATE;
      throw Error("No output jax registered for "+jax.mimeType);
    }
    //
    //  Record the output jax
    //  and put this script in the queue for that jax
    //
    jax.outputJax = this.outputJax[jax.mimeType][0].id;
    if (!state.jax[jax.outputJax]) {
      if (state.jaxIDs.length === 0) {
        // use original array until we know there are more (rather than two copies)
        state.jax[jax.outputJax] = state.scripts;
      } else {
        if (state.jaxIDs.length === 1) // get the script so far for the existing jax
          {state.jax[state.jaxIDs[0]] = state.scripts.slice(0,state.i)}
        state.jax[jax.outputJax] = []; // start a new array for the new jax
      }
      state.jaxIDs.push(jax.outputJax); // save the ID of the jax
    }
    if (state.jaxIDs.length > 1) {state.jax[jax.outputJax].push(script)}
    //
    //  Mark script as needing output
    //
    script.MathJax.state = STATE.OUTPUT;
  },

  //
  //  Pre- and post-process scripts by jax
  //    (to get scaling factors, hide/show output, and so on)
  //  Since this can cause the jax to load, we need to trap restarts
  //
  prepareOutput: function (state,method) {
    while (state.j < state.jaxIDs.length) {
      var id = state.jaxIDs[state.j], JAX = MathJax.OutputJax[id];
      if (JAX[method]) {
        try {
          var result = JAX[method](state);
          if (typeof result === 'function') {
            if (result.called) continue;  // go back and try again
            this.RestartAfter(result);
          }
        } catch (err) {
          if (!err.restart) {
            MathJax.Message.Set(["PrepError","Error preparing %1 output (%2)",id,method],null,600);
            MathJax.Hub.lastPrepError = err;
            state.j++;
          }
          return MathJax.Callback.After(["prepareOutput",this,state,method],err.restart);
        }
      }
      state.j++;
    }
    return null;
  },

  processOutput: function (state) {
    var result, STATE = MathJax.ElementJax.STATE, script, m = state.scripts.length;
    try {
      //
      //  Loop through the scripts
      //
      while (state.i < m) {
        //
        //  Check that there is an element jax
        //
        script = state.scripts[state.i];
        if (!script || !script.parentNode || !script.MathJax || script.MathJax.error) {state.i++; continue}
        var jax = script.MathJax.elementJax; if (!jax) {state.i++; continue}
        //
        //  Call the output Jax's Process method (which will be its Translate()
        //  method once loaded).  Mark it as complete and remove the preview unless
        //  the Process() call returns an explicit false value (in which case, it will
        //  handle this later during the postProcess phase, as HTML-CSS does).
        //
        result = MathJax.OutputJax[jax.outputJax].Process(script,state);
        if (result !== false) {
          script.MathJax.state = STATE.PROCESSED;
          if (script.MathJax.preview) {
            script.MathJax.preview.innerHTML = "";
            script.MathJax.preview.style.display = "none";
          }
          //
          //  Signal that new math is available
          //
          this.signal.Post(["New Math",jax.inputID]); // FIXME: wait for this?  (i.e., restart if returns uncalled callback)
        }
        //
        //  Go on to next math expression
        //
        state.i++;
        //
        //  Update the processing message, if needed
        //
        var now = new Date().getTime();
        if (now - state.start > this.processUpdateTime && state.i < state.scripts.length)
          {state.start = now; this.RestartAfter(MathJax.Callback.Delay(this.processUpdateDelay))}
      }
    } catch (err) {return this.processError(err,state,"Output")}
    //
    //  Put up the typesetting-complete message
    //
    if (state.scripts.length && this.config.showProcessingMessages) {
      MathJax.Message.Set(["TypesetMath","Typesetting math: %1%%",100],0);
      MathJax.Message.Clear(0);
    }
    state.i = state.j = 0;
    return null;
  },

  processMessage: function (state,type) {
    var m = Math.floor(state.i/(state.scripts.length)*100);
    var message = (type === "Output" ? ["TypesetMath","Typesetting math: %1%%"] :
                                       ["ProcessMath","Processing math: %1%%"]);
    if (this.config.showProcessingMessages) {MathJax.Message.Set(message.concat(m),0)}
  },

  processError: function (err,state,type) {
    if (!err.restart) {
      if (!this.config.errorSettings.message) {throw err}
      this.formatError(state.scripts[state.i],err); state.i++;
    }
    this.processMessage(state,type);
    return MathJax.Callback.After(["process"+type,this,state],err.restart);
  },

  formatError: function (script,err) {
    var LOCALIZE = function (id,text,arg1,arg2) {return MathJax.Localization._(id,text,arg1,arg2)};
    //
    //  Get the error message, URL, and line, and save it for
    //    reporting in the Show Math As Error menu
    //
    var message = LOCALIZE("ErrorMessage","Error: %1",err.message)+"\n";
    if (err.sourceURL||err.fileName) message += "\n"+LOCALIZE("ErrorFile","file: %1",err.sourceURL||err.fileName);
    if (err.line||err.lineNumber) message += "\n"+LOCALIZE("ErrorLine","line: %1",err.line||err.lineNumber);
    message += "\n\n"+LOCALIZE("ErrorTips","Debugging tips: use %1, inspect %2 in the browser console","'unpacked/MathJax.js'","'MathJax.Hub.lastError'");
    script.MathJax.error = MathJax.OutputJax.Error.Jax(message,script);
    if (script.MathJax.elementJax)
      script.MathJax.error.inputID = script.MathJax.elementJax.inputID;
    //
    //  Create the [Math Processing Error] span
    //
    var errorSettings = this.config.errorSettings;
    var errorText = LOCALIZE(errorSettings.messageId,errorSettings.message);
    var error = MathJax.HTML.Element("span", {
      className:"MathJax_Error", jaxID:"Error", isMathJax:true,
      id: script.MathJax.error.inputID+"-Frame"
    },[["span",null,errorText]]);
    //
    //  Attach the menu events
    //
    MathJax.Ajax.Require("[MathJax]/extensions/MathEvents.js",function () {
      var EVENT = MathJax.Extension.MathEvents.Event,
          HUB = MathJax.Hub;
      error.oncontextmenu = EVENT.Menu;
      error.onmousedown = EVENT.Mousedown;
      error.onkeydown = EVENT.Keydown;
      error.tabIndex = HUB.getTabOrder(HUB.getJaxFor(script));
    });
    //
    //  Insert the error into the page and remove any preview
    //
    var node = document.getElementById(error.id);
    if (node) node.parentNode.removeChild(node);
    if (script.parentNode) script.parentNode.insertBefore(error,script);
    if (script.MathJax.preview) {
      script.MathJax.preview.innerHTML = "";
      script.MathJax.preview.style.display = "none";
    }
    //
    //  Save the error for debugging purposes
    //  Report the error as a signal
    //
    this.lastError = err;
    this.signal.Post(["Math Processing Error",script,err]);
  },

  RestartAfter: function (callback) {
    throw this.Insert(Error("restart"),{restart: MathJax.Callback(callback)});
  },

  elementCallback: function (element,callback) {
    if (callback == null && (MathJax.Object.isArray(element) || typeof element === 'function'))
      {try {MathJax.Callback(element); callback = element; element = null} catch(e) {}}
    if (element == null) {element = this.config.elements || []}
    if (this.isHTMLCollection(element)) {element = this.HTMLCollection2Array(element)}
    if (!MathJax.Object.isArray(element)) {element = [element]}
    element = [].concat(element); // make a copy so the original isn't changed
    for (var i = 0, m = element.length; i < m; i++)
      {if (typeof(element[i]) === 'string') {element[i] = document.getElementById(element[i])}}
    if (!document.body) {document.body = document.getElementsByTagName("body")[0]}
    if (element.length == 0) {element.push(document.body)}
    if (!callback) {callback = {}}
    return {
      count: element.length,
      elements: (element.length === 1 ? element[0] : element),
      callback: callback
    };
  },

  elementScripts: function (element) {
    var scripts = [];
    if (MathJax.Object.isArray(element) || this.isHTMLCollection(element)) {
      for (var i = 0, m = element.length; i < m; i++) {
        var alreadyDone = 0;
        for (var j = 0; j < i && !alreadyDone; j++)
          {alreadyDone = element[j].contains(element[i])}
        if (!alreadyDone) scripts.push.apply(scripts,this.elementScripts(element[i]));
      }
      return scripts;
    }
    if (typeof(element) === 'string') {element = document.getElementById(element)}
    if (!document.body) {document.body = document.getElementsByTagName("body")[0]}
    if (element == null) {element = document.body}
    if (element.tagName != null && element.tagName.toLowerCase() === "script") {return [element]}
    scripts = element.getElementsByTagName("script");
    if (this.msieHTMLCollectionBug) {scripts = this.HTMLCollection2Array(scripts)}
    return scripts;
  },

  //
  //  IE8 fails to check "obj instanceof HTMLCollection" for some values of obj.
  //
  isHTMLCollection: function (obj) {
    return ("HTMLCollection" in window && typeof(obj) === "object" && obj instanceof HTMLCollection);
  },
  //
  //  IE8 doesn't deal with HTMLCollection as an array, so convert to array
  //
  HTMLCollection2Array: function (nodes) {
    if (!this.msieHTMLCollectionBug) {return [].slice.call(nodes)}
    var NODES = [];
    for (var i = 0, m = nodes.length; i < m; i++) {NODES[i] = nodes[i]}
    return NODES;
  },

  Insert: function (dst,src) {
    for (var id in src) {if (src.hasOwnProperty(id)) {
      // allow for concatenation of arrays?
      if (typeof src[id] === 'object' && !(MathJax.Object.isArray(src[id])) &&
         (typeof dst[id] === 'object' || typeof dst[id] === 'function')) {
        this.Insert(dst[id],src[id]);
      } else {
        dst[id] = src[id];
      }
    }}
    return dst;
  },

  getTabOrder: function(script) {
    return this.config.menuSettings.inTabOrder ? 0 : -1;
  },

  // Old browsers (e.g. Internet Explorer <= 8) do not support trim().
  SplitList: ("trim" in String.prototype ?
              function (list) {return list.trim().split(/\s+/)} :
              function (list) {return list.replace(/^\s+/,'').
                                           replace(/\s+$/,'').split(/\s+/)})
};
MathJax.Hub.Insert(MathJax.Hub.config.styles,MathJax.Message.styles);
MathJax.Hub.Insert(MathJax.Hub.config.styles,{".MathJax_Error":MathJax.Hub.config.errorSettings.style});

//
//  Storage area for extensions and preprocessors
//
MathJax.Extension = {};

//
//  Hub Startup code
//
MathJax.Hub.Configured = MathJax.Callback({}); // called when configuration is complete
MathJax.Hub.Startup = {
  script: "", // the startup script from the SCRIPT call that loads MathJax.js
  queue:   MathJax.Callback.Queue(),           // Queue used for startup actions
  signal:  MathJax.Callback.Signal("Startup"), // Signal used for startup events
  params:  {},

  //
  //  Load the configuration files
  //
  Config: function () {
    this.queue.Push(["Post",this.signal,"Begin Config"]);
    //
    //  Make sure root is set before loading any files
    //
    if (MathJax.AuthorConfig && MathJax.AuthorConfig.root)
      MathJax.Ajax.config.root = MathJax.AuthorConfig.root;
    //
    //  If a locale is given as a parameter,
    //    set the locale and the default menu value for the locale
    //
    if (this.params.locale) {
      MathJax.Localization.resetLocale(this.params.locale);
      MathJax.Hub.config.menuSettings.locale = this.params.locale;
    }
    //
    //  Run the config files, if any are given in the parameter list
    //
    if (this.params.config) {
      var files = this.params.config.split(/,/);
      for (var i = 0, m = files.length; i < m; i++) {
        if (!files[i].match(/\.js$/)) {files[i] += ".js"}
        this.queue.Push(["Require",MathJax.Ajax,this.URL("config",files[i])]);
      }
    }
    //
    //  Perform author configuration from in-line MathJax = {...}
    //
    this.queue.Push(["Config",MathJax.Hub,MathJax.AuthorConfig]);
    //
    //  Run the deprecated configuration script, if any (ignoring return value)
    //  Wait for the startup delay signal
    //  Run the mathjax-config blocks
    //  Load the files in the configuration's config array
    //
    if (this.script.match(/\S/)) {this.queue.Push(this.script+";\n1;")}
    this.queue.Push(
      ["ConfigDelay",this],
      ["ConfigBlocks",this],
      [function (THIS) {return THIS.loadArray(MathJax.Hub.config.config,"config",null,true)},this],
      ["Post",this.signal,"End Config"]
    );
  },
  //
  //  Return the delay callback
  //
  ConfigDelay: function () {
    var delay = this.params.delayStartupUntil || MathJax.Hub.config.delayStartupUntil;
    if (delay === "onload") {return this.onload}
    if (delay === "configured") {return MathJax.Hub.Configured}
    return delay;
  },
  //
  //  Run the scripts of type=text/x-mathjax-config
  //
  ConfigBlocks: function () {
    var scripts = document.getElementsByTagName("script");
    var queue = MathJax.Callback.Queue();
    for (var i = 0, m = scripts.length; i < m; i++) {
      var type = String(scripts[i].type).replace(/ /g,"");
      if (type.match(/^text\/x-mathjax-config(;.*)?$/) && !type.match(/;executed=true/)) {
        scripts[i].type += ";executed=true";
        queue.Push(scripts[i].innerHTML+";\n1;");
      }
    }
    return queue.Push(function () {MathJax.Ajax.config.root = MathJax.Hub.config.root});
  },

  //
  //  Read cookie and set up menu defaults
  //  (set the locale according to the cookie)
  //  (adjust the jax to accommodate renderer preferences)
  //
  Cookie: function () {
    return this.queue.Push(
      ["Post",this.signal,"Begin Cookie"],
      ["Get",MathJax.HTML.Cookie,"menu",MathJax.Hub.config.menuSettings],
      [function (config) {
        var SETTINGS = config.menuSettings;
        if (SETTINGS.locale) MathJax.Localization.resetLocale(SETTINGS.locale);
        var renderer = config.menuSettings.renderer, jax = config.jax;
        if (renderer) {
          var name = "output/"+renderer; jax.sort();
          for (var i = 0, m = jax.length; i < m; i++) {
            if (jax[i].substr(0,7) === "output/") break;
          }
          if (i == m-1) {jax.pop()} else {
            while (i < m) {if (jax[i] === name) {jax.splice(i,1); break}; i++}
          }
          jax.unshift(name);
        }
        if (SETTINGS.CHTMLpreview != null) {
          if (SETTINGS.FastPreview == null) SETTINGS.FastPreview = SETTINGS.CHTMLpreview;
          delete SETTINGS.CHTMLpreview;
        }
        if (SETTINGS.FastPreview && !MathJax.Extension["fast-preview"])
          MathJax.Hub.config.extensions.push("fast-preview.js");
        if (config.menuSettings.assistiveMML && !MathJax.Extension.AssistiveMML)
          MathJax.Hub.config.extensions.push("AssistiveMML.js");
      },MathJax.Hub.config],
      ["Post",this.signal,"End Cookie"]
    );
  },
  //
  //  Setup stylesheets and extra styles
  //
  Styles: function () {
    return this.queue.Push(
      ["Post",this.signal,"Begin Styles"],
      ["loadArray",this,MathJax.Hub.config.styleSheets,"config"],
      ["Styles",MathJax.Ajax,MathJax.Hub.config.styles],
      ["Post",this.signal,"End Styles"]
    );
  },
  //
  //  Load the input and output jax
  //
  Jax: function () {
    var config = MathJax.Hub.config, jax = MathJax.Hub.outputJax;
    //  Save the order of the output jax since they are loading asynchronously
    for (var i = 0, m = config.jax.length, k = 0; i < m; i++) {
      var name = config.jax[i].substr(7);
      if (config.jax[i].substr(0,7) === "output/" && jax.order[name] == null)
        {jax.order[name] = k; k++}
    }
    var queue = MathJax.Callback.Queue();
    return queue.Push(
      ["Post",this.signal,"Begin Jax"],
      ["loadArray",this,config.jax,"jax","config.js"],
      ["Post",this.signal,"End Jax"]
    );
  },
  //
  //  Load the extensions
  //
  Extensions: function () {
    var queue = MathJax.Callback.Queue();
    return queue.Push(
      ["Post",this.signal,"Begin Extensions"],
      ["loadArray",this,MathJax.Hub.config.extensions,"extensions"],
      ["Post",this.signal,"End Extensions"]
    );
  },

  //
  //  Initialize the Message system
  //
  Message: function () {
    MathJax.Message.Init(true);
  },

  //
  //  Set the math menu renderer, if it isn't already
  //  (this must come after the jax are loaded)
  //
  Menu: function () {
    var menu = MathJax.Hub.config.menuSettings, jax = MathJax.Hub.outputJax, registered;
    for (var id in jax) {if (jax.hasOwnProperty(id)) {
      if (jax[id].length) {registered = jax[id]; break}
    }}
    if (registered && registered.length) {
      if (menu.renderer && menu.renderer !== registered[0].id)
        {registered.unshift(MathJax.OutputJax[menu.renderer])}
      menu.renderer = registered[0].id;
    }
  },

  //
  //  Set the location to the designated hash position
  //
  Hash: function () {
    if (MathJax.Hub.config.positionToHash && document.location.hash &&
        document.body && document.body.scrollIntoView) {
      var name = decodeURIComponent(document.location.hash.substr(1));
      var target = document.getElementById(name);
      if (!target) {
        var a = document.getElementsByTagName("a");
        for (var i = 0, m = a.length; i < m; i++)
          {if (a[i].name === name) {target = a[i]; break}}
      }
      if (target) {
        while (!target.scrollIntoView) {target = target.parentNode}
        target = this.HashCheck(target);
        if (target && target.scrollIntoView)
          {setTimeout(function () {target.scrollIntoView(true)},1)}
      }
    }
  },
  HashCheck: function (target) {
    var jax = MathJax.Hub.getJaxFor(target);
    if (jax && MathJax.OutputJax[jax.outputJax].hashCheck)
      {target = MathJax.OutputJax[jax.outputJax].hashCheck(target)}
    return target;
  },

  //
  //  Load the Menu and Zoom code, if it hasn't already been loaded.
  //  This is called after the initial typeset, so should no longer be
  //  competing with other page loads, but will make these available
  //  if needed later on.
  //
  MenuZoom: function () {
    if (MathJax.Hub.config.showMathMenu) {
      if (!MathJax.Extension.MathMenu) {
        setTimeout(
          function () {
            MathJax.Callback.Queue(
              ["Require",MathJax.Ajax,"[MathJax]/extensions/MathMenu.js",{}],
              ["loadDomain",MathJax.Localization,"MathMenu"]
            )
          },1000
        );
      } else {
        setTimeout(
          MathJax.Callback(["loadDomain",MathJax.Localization,"MathMenu"]),
          1000
        );
      }
      if (!MathJax.Extension.MathZoom) {
        setTimeout(
          MathJax.Callback(["Require",MathJax.Ajax,"[MathJax]/extensions/MathZoom.js",{}]),
          2000
        );
      }
    }
  },

  //
  //  Setup the onload callback
  //
  onLoad: function () {
    var onload = this.onload =
      MathJax.Callback(function () {MathJax.Hub.Startup.signal.Post("onLoad")});
    if (document.body && document.readyState)
      if (MathJax.Hub.Browser.isMSIE) {
        // IE can change from loading to interactive before
        //  full page is ready, so go with complete (even though
        //  that means we may have to wait longer).
        if (document.readyState === "complete") {return [onload]}
      } else if (document.readyState !== "loading") {return [onload]}
    if (window.addEventListener) {
      window.addEventListener("load",onload,false);
      if (!this.params.noDOMContentEvent)
        {window.addEventListener("DOMContentLoaded",onload,false)}
    }
    else if (window.attachEvent) {window.attachEvent("onload",onload)}
    else {window.onload = onload}
    return onload;
  },

  //
  //  Perform the initial typesetting (or skip if configuration says to)
  //
  Typeset: function (element,callback) {
    if (MathJax.Hub.config.skipStartupTypeset) {return function () {}}
    return this.queue.Push(
      ["Post",this.signal,"Begin Typeset"],
      ["Typeset",MathJax.Hub,element,callback],
      ["Post",this.signal,"End Typeset"]
    );
  },

  //
  //  Create a URL in the MathJax hierarchy
  //
  URL: function (dir,name) {
    if (!name.match(/^([a-z]+:\/\/|\[|\/)/)) {name = "[MathJax]/"+dir+"/"+name}
    return name;
  },

  //
  //  Load an array of files, waiting for all of them
  //  to be loaded before going on
  //
  loadArray: function (files,dir,name,synchronous) {
    if (files) {
      if (!MathJax.Object.isArray(files)) {files = [files]}
      if (files.length) {
        var queue = MathJax.Callback.Queue(), callback = {}, file;
        for (var i = 0, m = files.length; i < m; i++) {
          file = this.URL(dir,files[i]);
          if (name) {file += "/" + name}
          if (synchronous) {queue.Push(["Require",MathJax.Ajax,file,callback])}
                      else {queue.Push(MathJax.Ajax.Require(file,callback))}
        }
        return queue.Push({}); // wait for everything to finish
      }
    }
    return null;
  }

};


/**********************************************************/

(function (BASENAME) {
  var BASE = window[BASENAME], ROOT = "["+BASENAME+"]";
  var HUB = BASE.Hub, AJAX = BASE.Ajax, CALLBACK = BASE.Callback;

  var JAX = MathJax.Object.Subclass({
    JAXFILE: "jax.js",
    require: null, // array of files to load before jax.js is complete
    config: {},
    //
    //  Make a subclass and return an instance of it.
    //  (FIXME: should we replace config with a copy of the constructor's
    //   config?  Otherwise all subclasses share the same config structure.)
    //
    Init: function (def,cdef) {
      if (arguments.length === 0) {return this}
      return (this.constructor.Subclass(def,cdef))();
    },
    //
    //  Augment by merging with class definition (not replacing)
    //
    Augment: function (def,cdef) {
      var cObject = this.constructor, ndef = {};
      if (def != null) {
        for (var id in def) {if (def.hasOwnProperty(id)) {
          if (typeof def[id] === "function")
            {cObject.protoFunction(id,def[id])} else {ndef[id] = def[id]}
        }}
        // MSIE doesn't list toString even if it is not native so handle it separately
        if (def.toString !== cObject.prototype.toString && def.toString !== {}.toString)
          {cObject.protoFunction('toString',def.toString)}
      }
      HUB.Insert(cObject.prototype,ndef);
      cObject.Augment(null,cdef);
      return this;
    },
    Translate: function (script,state) {
      throw Error(this.directory+"/"+this.JAXFILE+" failed to define the Translate() method");
    },
    Register: function (mimetype) {},
    Config: function () {
      this.config = HUB.CombineConfig(this.id,this.config);
      if (this.config.Augment) {this.Augment(this.config.Augment)}
    },
    Startup: function () {},
    loadComplete: function (file) {
      if (file === "config.js") {
        return AJAX.loadComplete(this.directory+"/"+file);
      } else {
        var queue = CALLBACK.Queue();
        queue.Push(
          HUB.Register.StartupHook("End Config",{}), // wait until config complete
          ["Post",HUB.Startup.signal,this.id+" Jax Config"],
          ["Config",this],
          ["Post",HUB.Startup.signal,this.id+" Jax Require"],
          // Config may set the required and extensions array,
          //  so use functions to delay making the reference until needed
          [function (THIS) {return MathJax.Hub.Startup.loadArray(THIS.require,this.directory)},this],
          [function (config,id) {return MathJax.Hub.Startup.loadArray(config.extensions,"extensions/"+id)},this.config||{},this.id],
          ["Post",HUB.Startup.signal,this.id+" Jax Startup"],
          ["Startup",this],
          ["Post",HUB.Startup.signal,this.id+" Jax Ready"]
        );
        if (this.copyTranslate) {
          queue.Push(
            [function (THIS) {
              THIS.preProcess  = THIS.preTranslate;
              THIS.Process     = THIS.Translate;
              THIS.postProcess = THIS.postTranslate;
            },this.constructor.prototype]
          );
        }
        return queue.Push(["loadComplete",AJAX,this.directory+"/"+file]);
      }
    }
  },{
    id: "Jax",
    version: "2.7.5",
    directory: ROOT+"/jax",
    extensionDir: ROOT+"/extensions"
  });

  /***********************************/

  BASE.InputJax = JAX.Subclass({
    elementJax: "mml",  // the element jax to load for this input jax
    sourceMenuTitle: /*_(MathMenu)*/ ["Original","Original Form"],
    copyTranslate: true,
    Process: function (script,state) {
      var queue = CALLBACK.Queue(), file;
      // Load any needed element jax
      var jax = this.elementJax; if (!BASE.Object.isArray(jax)) {jax = [jax]}
      for (var i = 0, m = jax.length; i < m; i++) {
        file = BASE.ElementJax.directory+"/"+jax[i]+"/"+this.JAXFILE;
        if (!this.require) {this.require = []}
          else if (!BASE.Object.isArray(this.require)) {this.require = [this.require]};
        this.require.push(file);  // so Startup will wait for it to be loaded
        queue.Push(AJAX.Require(file));
      }
      // Load the input jax
      file = this.directory+"/"+this.JAXFILE;
      var load = queue.Push(AJAX.Require(file));
      if (!load.called) {
        this.constructor.prototype.Process = function () {
          if (!load.called) {return load}
          throw Error(file+" failed to load properly");
        }
      }
      // Load the associated output jax
      jax = HUB.outputJax["jax/"+jax[0]];
      if (jax) {queue.Push(AJAX.Require(jax[0].directory+"/"+this.JAXFILE))}
      return queue.Push({});
    },
    needsUpdate: function (jax) {
      var script = jax.SourceElement();
      return (jax.originalText !== BASE.HTML.getScript(script));
    },
    Register: function (mimetype) {
      if (!HUB.inputJax) {HUB.inputJax = {}}
      HUB.inputJax[mimetype] = this;
    }
  },{
    id: "InputJax",
    version: "2.7.5",
    directory: JAX.directory+"/input",
    extensionDir: JAX.extensionDir
  });

  /***********************************/

  BASE.OutputJax = JAX.Subclass({
    copyTranslate: true,
    preProcess: function (state) {
      var load, file = this.directory+"/"+this.JAXFILE;
      this.constructor.prototype.preProcess = function (state) {
	if (!load.called) {return load}
        throw Error(file+" failed to load properly");
      }
      load = AJAX.Require(file);
      return load;
    },
    Process: function (state) {throw Error(this.id + " output jax failed to load properly")},
    Register: function (mimetype) {
      var jax = HUB.outputJax;
      if (!jax[mimetype]) {jax[mimetype] = []}
      //  If the output jax is earlier in the original configuration list, put it first here
      if (jax[mimetype].length && (this.id === HUB.config.menuSettings.renderer ||
            (jax.order[this.id]||0) < (jax.order[jax[mimetype][0].id]||0)))
        {jax[mimetype].unshift(this)} else {jax[mimetype].push(this)}
      //  Make sure the element jax is loaded before Startup is called
      if (!this.require) {this.require = []}
        else if (!BASE.Object.isArray(this.require)) {this.require = [this.require]};
      this.require.push(BASE.ElementJax.directory+"/"+(mimetype.split(/\//)[1])+"/"+this.JAXFILE);
    },
    Remove: function (jax) {}
  },{
    id: "OutputJax",
    version: "2.7.5",
    directory: JAX.directory+"/output",
    extensionDir: JAX.extensionDir,
    fontDir: ROOT+(BASE.isPacked?"":"/..")+"/fonts",
    imageDir: ROOT+(BASE.isPacked?"":"/..")+"/images"
  });

  /***********************************/

  BASE.ElementJax = JAX.Subclass({
    // make a subclass, not an instance
    Init: function (def,cdef) {return this.constructor.Subclass(def,cdef)},

    inputJax: null,
    outputJax: null,
    inputID: null,
    originalText: "",
    mimeType: "",
    sourceMenuTitle: /*_(MathMenu)*/ ["MathMLcode","MathML Code"],

    Text: function (text,callback) {
      var script = this.SourceElement();
      BASE.HTML.setScript(script,text);
      script.MathJax.state = this.STATE.UPDATE;
      return HUB.Update(script,callback);
    },
    Reprocess: function (callback) {
      var script = this.SourceElement();
      script.MathJax.state = this.STATE.UPDATE;
      return HUB.Reprocess(script,callback);
    },
    Update: function (callback) {return this.Rerender(callback)},
    Rerender: function (callback) {
      var script = this.SourceElement();
      script.MathJax.state = this.STATE.OUTPUT;
      return HUB.Process(script,callback);
    },
    Remove: function (keep) {
      if (this.hover) {this.hover.clear(this)}
      BASE.OutputJax[this.outputJax].Remove(this);
      if (!keep) {
        HUB.signal.Post(["Remove Math",this.inputID]); // wait for this to finish?
        this.Detach();
      }
    },
    needsUpdate: function () {
      return BASE.InputJax[this.inputJax].needsUpdate(this);
    },

    SourceElement: function () {return document.getElementById(this.inputID)},

    Attach: function (script,inputJax) {
      var jax = script.MathJax.elementJax;
      if (script.MathJax.state === this.STATE.UPDATE) {
        jax.Clone(this);
      } else {
        jax = script.MathJax.elementJax = this;
        if (script.id) {this.inputID = script.id}
          else {script.id = this.inputID = BASE.ElementJax.GetID(); this.newID = 1}
      }
      jax.originalText = BASE.HTML.getScript(script);
      jax.inputJax = inputJax;
      if (jax.root) {jax.root.inputID = jax.inputID}
      return jax;
    },
    Detach: function () {
      var script = this.SourceElement(); if (!script) return;
      try {delete script.MathJax} catch(err) {script.MathJax = null}
      if (this.newID) {script.id = ""}
    },
    Clone: function (jax) {
      var id;
      for (id in this) {
        if (!this.hasOwnProperty(id)) continue;
        if (typeof(jax[id]) === 'undefined' && id !== 'newID') {delete this[id]}
      }
      for (id in jax) {
        if (!jax.hasOwnProperty(id)) continue;
        if (typeof(this[id]) === 'undefined' || (this[id] !== jax[id] && id !== 'inputID'))
          {this[id] = jax[id]}
      }
    }
  },{
    id: "ElementJax",
    version: "2.7.5",
    directory: JAX.directory+"/element",
    extensionDir: JAX.extensionDir,
    ID: 0,  // jax counter (for IDs)
    STATE: {
      PENDING: 1,      // script is identified as math but not yet processed
      PROCESSED: 2,    // script has been processed
      UPDATE: 3,       // elementJax should be updated
      OUTPUT: 4        // output should be updated (input is OK)
    },

    GetID: function () {this.ID++; return "MathJax-Element-"+this.ID},
    Subclass: function () {
      var obj = JAX.Subclass.apply(this,arguments);
      obj.loadComplete = this.prototype.loadComplete;
      return obj;
    }
  });
  BASE.ElementJax.prototype.STATE = BASE.ElementJax.STATE;

  //
  //  Some "Fake" jax used to allow menu access for "Math Processing Error" messages
  //
  BASE.OutputJax.Error = {
    id: "Error", version: "2.7.5", config: {}, errors: 0,
    ContextMenu: function () {return BASE.Extension.MathEvents.Event.ContextMenu.apply(BASE.Extension.MathEvents.Event,arguments)},
    Mousedown:   function () {return BASE.Extension.MathEvents.Event.AltContextMenu.apply(BASE.Extension.MathEvents.Event,arguments)},
    getJaxFromMath: function (math) {return (math.nextSibling.MathJax||{}).error},
    Jax: function (text,script) {
      var jax = MathJax.Hub.inputJax[script.type.replace(/ *;(.|\s)*/,"")];
      this.errors++;
      return {
        inputJax: (jax||{id:"Error"}).id,  // Use Error InputJax as fallback
        outputJax: "Error",
        inputID: "MathJax-Error-"+this.errors,
        sourceMenuTitle: /*_(MathMenu)*/ ["ErrorMessage","Error Message"],
        sourceMenuFormat: "Error",
        originalText: MathJax.HTML.getScript(script),
        errorText: text
      }
    }
  };
  BASE.InputJax.Error = {
    id: "Error", version: "2.7.5", config: {},
    sourceMenuTitle: /*_(MathMenu)*/ ["Original","Original Form"]
  };

})("MathJax");

/**********************************************************/

(function (BASENAME) {
  var BASE = window[BASENAME];
  if (!BASE) {BASE = window[BASENAME] = {}}

  var HUB = BASE.Hub; var STARTUP = HUB.Startup; var CONFIG = HUB.config;
  var HEAD = document.head || (document.getElementsByTagName("head")[0]);
  if (!HEAD) {HEAD = document.childNodes[0]};
  var scripts = (document.documentElement || document).getElementsByTagName("script");
  if (scripts.length === 0 && HEAD.namespaceURI)
    scripts = document.getElementsByTagNameNS(HEAD.namespaceURI,"script");
  var namePattern = new RegExp("(^|/)"+BASENAME+"\\.js(\\?.*)?$");
  for (var i = scripts.length-1; i >= 0; i--) {
    if ((scripts[i].src||"").match(namePattern)) {
      STARTUP.script = scripts[i].innerHTML;
      if (RegExp.$2) {
        var params = RegExp.$2.substr(1).split(/\&/);
        for (var j = 0, m = params.length; j < m; j++) {
          var KV = params[j].match(/(.*)=(.*)/);
          if (KV) {STARTUP.params[unescape(KV[1])] = unescape(KV[2])}
             else {STARTUP.params[params[j]] = true}
        }
      }
      CONFIG.root = scripts[i].src.replace(/(^|\/)[^\/]*(\?.*)?$/,'');
      BASE.Ajax.config.root = CONFIG.root;
      BASE.Ajax.params = STARTUP.params;
      break;
    }
  }

  var AGENT = navigator.userAgent;
  var BROWSERS = {
    isMac:       (navigator.platform.substr(0,3) === "Mac"),
    isPC:        (navigator.platform.substr(0,3) === "Win"),
    isMSIE:      ("ActiveXObject" in window && "clipboardData" in window),
    isEdge:      ("MSGestureEvent" in window && "chrome" in window &&
                     window.chrome.loadTimes == null),
    isFirefox:   (!!AGENT.match(/Gecko\//) && !AGENT.match(/like Gecko/)),
    isSafari:    (!!AGENT.match(/ (Apple)?WebKit\//) && !AGENT.match(/ like iPhone /) &&
                     (!window.chrome || window.chrome.app == null)),
    isChrome:    ("chrome" in window && window.chrome.loadTimes != null),
    isOpera:     ("opera" in window && window.opera.version != null),
    isKonqueror: ("konqueror" in window && navigator.vendor == "KDE"),
    versionAtLeast: function (v) {
      var bv = (this.version).split('.'); v = (new String(v)).split('.');
      for (var i = 0, m = v.length; i < m; i++)
        {if (bv[i] != v[i]) {return parseInt(bv[i]||"0") >= parseInt(v[i])}}
      return true;
    },
    Select: function (choices) {
      var browser = choices[HUB.Browser];
      if (browser) {return browser(HUB.Browser)}
      return null;
    }
  };

  var xAGENT = AGENT
    .replace(/^Mozilla\/(\d+\.)+\d+ /,"")                                   // remove initial Mozilla, which is never right
    .replace(/[a-z][-a-z0-9._: ]+\/\d+[^ ]*-[^ ]*\.([a-z][a-z])?\d+ /i,"")  // remove linux version
    .replace(/Gentoo |Ubuntu\/(\d+\.)*\d+ (\([^)]*\) )?/,"");               // special case for these

  HUB.Browser = HUB.Insert(HUB.Insert(new String("Unknown"),{version: "0.0"}),BROWSERS);
  for (var browser in BROWSERS) {if (BROWSERS.hasOwnProperty(browser)) {
    if (BROWSERS[browser] && browser.substr(0,2) === "is") {
      browser = browser.slice(2);
      if (browser === "Mac" || browser === "PC") continue;
      HUB.Browser = HUB.Insert(new String(browser),BROWSERS);
      var VERSION = new RegExp(
        ".*(Version/| Trident/.*; rv:)((?:\\d+\\.)+\\d+)|" +                      // for Safari, Opera10, and IE11+
        ".*("+browser+")"+(browser == "MSIE" ? " " : "/")+"((?:\\d+\\.)*\\d+)|"+  // for one of the main browsers
        "(?:^|\\(| )([a-z][-a-z0-9._: ]+|(?:Apple)?WebKit)/((?:\\d+\\.)+\\d+)");  // for unrecognized browser
      var MATCH = VERSION.exec(xAGENT) || ["","","","unknown","0.0"];
      HUB.Browser.name = (MATCH[1] != "" ? browser : (MATCH[3] || MATCH[5]));
      HUB.Browser.version = MATCH[2] || MATCH[4] || MATCH[6];
      break;
    }
  }};

  //
  //  Initial browser-specific info (e.g., touch up version or name, check for MathPlayer, etc.)
  //  Wrap in try/catch just in case of error (see issue #1155).
  //
  try {HUB.Browser.Select({
    Safari: function (browser) {
      var v = parseInt((String(browser.version).split("."))[0]);
      if (v > 85) {browser.webkit = browser.version}
      if      (v >= 538) {browser.version = "8.0"}
      else if (v >= 537) {browser.version = "7.0"}
      else if (v >= 536) {browser.version = "6.0"}
      else if (v >= 534) {browser.version = "5.1"}
      else if (v >= 533) {browser.version = "5.0"}
      else if (v >= 526) {browser.version = "4.0"}
      else if (v >= 525) {browser.version = "3.1"}
      else if (v >  500) {browser.version = "3.0"}
      else if (v >  400) {browser.version = "2.0"}
      else if (v >   85) {browser.version = "1.0"}
      browser.webkit = (navigator.appVersion.match(/WebKit\/(\d+)\./))[1];
      browser.isMobile = (navigator.appVersion.match(/Mobile/i) != null);
      browser.noContextMenu = browser.isMobile;
    },
    Firefox: function (browser) {
      if ((browser.version === "0.0" || AGENT.match(/Firefox/) == null) &&
           navigator.product === "Gecko") {
        var rv = AGENT.match(/[\/ ]rv:(\d+\.\d.*?)[\) ]/);
        if (rv) {browser.version = rv[1]}
        else {
          var date = (navigator.buildID||navigator.productSub||"0").substr(0,8);
          if      (date >= "20111220") {browser.version = "9.0"}
          else if (date >= "20111120") {browser.version = "8.0"}
          else if (date >= "20110927") {browser.version = "7.0"}
          else if (date >= "20110816") {browser.version = "6.0"}
          else if (date >= "20110621") {browser.version = "5.0"}
          else if (date >= "20110320") {browser.version = "4.0"}
          else if (date >= "20100121") {browser.version = "3.6"}
          else if (date >= "20090630") {browser.version = "3.5"}
          else if (date >= "20080617") {browser.version = "3.0"}
          else if (date >= "20061024") {browser.version = "2.0"}
        }
      }
      browser.isMobile = (navigator.appVersion.match(/Android/i) != null ||
                          AGENT.match(/ Fennec\//) != null ||
                          AGENT.match(/Mobile/) != null);
    },
    Chrome: function (browser) {
      browser.noContextMenu = browser.isMobile = !!navigator.userAgent.match(/ Mobile[ \/]/);
    },
    Opera: function (browser) {browser.version = opera.version()},
    Edge: function (browser) {
      browser.isMobile = !!navigator.userAgent.match(/ Phone/);
    },
    MSIE: function (browser) {
      browser.isMobile = !!navigator.userAgent.match(/ Phone/);
      browser.isIE9 = !!(document.documentMode && (window.performance || window.msPerformance));
      MathJax.HTML.setScriptBug = !browser.isIE9 || document.documentMode < 9;
      MathJax.Hub.msieHTMLCollectionBug = (document.documentMode < 9);
      //
      //  MathPlayer doesn't function properly in IE10, and not at all in IE11,
      //  so don't even try to load it.
      //
      if (document.documentMode < 10 && !STARTUP.params.NoMathPlayer) {
        try {
          new ActiveXObject("MathPlayer.Factory.1");
          browser.hasMathPlayer = true;
        } catch (err) {}
        try {
          if (browser.hasMathPlayer) {
            var mathplayer = document.createElement("object");
            mathplayer.id = "mathplayer"; mathplayer.classid = "clsid:32F66A20-7614-11D4-BD11-00104BD3F987";
            HEAD.appendChild(mathplayer);
            document.namespaces.add("m","http://www.w3.org/1998/Math/MathML");
            browser.mpNamespace = true;
            if (document.readyState && (document.readyState === "loading" ||
                                        document.readyState === "interactive")) {
              document.write('<?import namespace="m" implementation="#MathPlayer">');
              browser.mpImported = true;
            }
          } else {
            //  Adding any namespace avoids a crash in IE9 in IE9-standards mode
            //  (any reference to document.namespaces before document.readyState is
            //   "complete" causes an "unspecified error" to be thrown)
            document.namespaces.add("mjx_IE_fix","http://www.w3.org/1999/xlink");
          }
        } catch (err) {}
      }
    }
  });} catch (err) {
    console.error(err.message);
  }
  HUB.Browser.Select(MathJax.Message.browsers);

  if (BASE.AuthorConfig && typeof BASE.AuthorConfig.AuthorInit === "function") {BASE.AuthorConfig.AuthorInit()}
  HUB.queue = BASE.Callback.Queue();
  HUB.queue.Push(
    ["Post",STARTUP.signal,"Begin"],
    ["Config",STARTUP],
    ["Cookie",STARTUP],
    ["Styles",STARTUP],
    ["Message",STARTUP],
    function () {
      // Do Jax and Extensions in parallel, but wait for them all to complete
      var queue = BASE.Callback.Queue(
        STARTUP.Jax(),
        STARTUP.Extensions()
      );
      return queue.Push({});
    },
    ["Menu",STARTUP],
    STARTUP.onLoad(),
    function () {MathJax.isReady = true}, // indicates that MathJax is ready to process math
    ["Typeset",STARTUP],
    ["Hash",STARTUP],
    ["MenuZoom",STARTUP],
    ["Post",STARTUP.signal,"End"]
  );

})("MathJax");

}}

},{}],"/usr/var/server.base/node_modules/moment/moment.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/node_modules/moment/moment.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Converter.js":[function(require,module,exports){
var Markdown;

if (typeof exports === "object" && typeof require === "function") // we're in a CommonJS (e.g. Node.js) module
    Markdown = exports;
else
    Markdown = {};
    
// The following text is included for historical reasons, but should
// be taken with a pinch of salt; it's not all true anymore.

//
// Wherever possible, Showdown is a straight, line-by-line port
// of the Perl version of Markdown.
//
// This is not a normal parser design; it's basically just a
// series of string substitutions.  It's hard to read and
// maintain this way,  but keeping Showdown close to the original
// design makes it easier to port new features.
//
// More importantly, Showdown behaves like markdown.pl in most
// edge cases.  So web applications can do client-side preview
// in Javascript, and then build identical HTML on the server.
//
// This port needs the new RegExp functionality of ECMA 262,
// 3rd Edition (i.e. Javascript 1.5).  Most modern web browsers
// should do fine.  Even with the new regular expression features,
// We do a lot of work to emulate Perl's regex functionality.
// The tricky changes in this file mostly have the "attacklab:"
// label.  Major or self-explanatory changes don't.
//
// Smart diff tools like Araxis Merge will be able to match up
// this file with markdown.pl in a useful way.  A little tweaking
// helps: in a copy of markdown.pl, replace "#" with "//" and
// replace "$text" with "text".  Be sure to ignore whitespace
// and line endings.
//


//
// Usage:
//
//   var text = "Markdown *rocks*.";
//
//   var converter = new Markdown.Converter(autolink); // where autolink is true or false, defaults to false
//   var html = converter.makeHtml(text);
//
//   alert(html);
//
// Note: move the sample code to the bottom of this
// file before uncommenting it.
//

(function () {

    function identity(x) { return x; }
    function returnFalse(x) { return false; }

    function HookCollection() { }

    HookCollection.prototype = {

        chain: function (hookname, func) {
            var original = this[hookname];
            if (!original)
                throw new Error("unknown hook " + hookname);

            if (original === identity)
                this[hookname] = func;
            else
                this[hookname] = function (x) { return func(original(x)); }
        },
        set: function (hookname, func) {
            if (!this[hookname])
                throw new Error("unknown hook " + hookname);
            this[hookname] = func;
        },
        addNoop: function (hookname) {
            this[hookname] = identity;
        },
        addFalse: function (hookname) {
            this[hookname] = returnFalse;
        }
    };

    Markdown.HookCollection = HookCollection;

    // g_urls and g_titles allow arbitrary user-entered strings as keys. This
    // caused an exception (and hence stopped the rendering) when the user entered
    // e.g. [push] or [__proto__]. Adding a prefix to the actual key prevents this
    // (since no builtin property starts with "s_"). See
    // http://meta.stackoverflow.com/questions/64655/strange-wmd-bug
    // (granted, switching from Array() to Object() alone would have left only __proto__
    // to be a problem)
    function SaveHash() { }
    SaveHash.prototype = {
        set: function (key, value) {
            this["s_" + key] = value;
        },
        get: function (key) {
            return this["s_" + key];
        }
    };

    Markdown.Converter = function (autolink) {
        var pluginHooks = this.hooks = new HookCollection();
        pluginHooks.addNoop("plainLinkText");  // given a URL that was encountered by itself (without markup), should return the link text that's to be given to this link
        pluginHooks.addNoop("preConversion");  // called with the orignal text as given to makeHtml. The result of this plugin hook is the actual markdown source that will be cooked
        pluginHooks.addNoop("postConversion"); // called with the final cooked HTML code. The result of this plugin hook is the actual output of makeHtml

        //
        // Private state of the converter instance:
        //

        // Aloow for automatic linking 
        var g_autolink = (autolink === true);
        
        // Global hashes, used by various utility routines
        var g_urls;
        var g_titles;
        var g_html_blocks;

        // Used to track when we're inside an ordered or unordered list
        // (see _ProcessListItems() for details):
        var g_list_level;

        this.makeHtml = function (text) {

            //
            // Main function. The order in which other subs are called here is
            // essential. Link and image substitutions need to happen before
            // _EscapeSpecialCharsWithinTagAttributes(), so that any *'s or _'s in the <a>
            // and <img> tags get encoded.
            //

            // This will only happen if makeHtml on the same converter instance is called from a plugin hook.
            // Don't do that.
            if (g_urls)
                throw new Error("Recursive call to converter.makeHtml");
        
            // Create the private state objects.
            g_urls = new SaveHash();
            g_titles = new SaveHash();
            g_html_blocks = [];
            g_list_level = 0;

            text = pluginHooks.preConversion(text);

            // attacklab: Replace ~ with ~T
            // This lets us use tilde as an escape char to avoid md5 hashes
            // The choice of character is arbitray; anything that isn't
            // magic in Markdown will work.
            text = text.replace(/~/g, "~T");

            // attacklab: Replace $ with ~D
            // RegExp interprets $ as a special character
            // when it's in a replacement string
            text = text.replace(/\$/g, "~D");

            // Standardize line endings
            text = text.replace(/\r\n/g, "\n"); // DOS to Unix
            text = text.replace(/\r/g, "\n"); // Mac to Unix

            // Make sure text begins and ends with a couple of newlines:
            text = "\n\n" + text + "\n\n";

            // Convert all tabs to spaces.
            text = _Detab(text);

            // Strip any lines consisting only of spaces and tabs.
            // This makes subsequent regexen easier to write, because we can
            // match consecutive blank lines with /\n+/ instead of something
            // contorted like /[ \t]*\n+/ .
            text = text.replace(/^[ \t]+$/mg, "");

            // Turn block-level HTML blocks into hash entries
            text = _HashHTMLBlocks(text);

            // Strip link definitions, store in hashes.
            text = _StripLinkDefinitions(text);

            text = _RunBlockGamut(text);

            text = _UnescapeSpecialChars(text);

            // attacklab: Restore dollar signs
            text = text.replace(/~D/g, "$$");

            // attacklab: Restore tildes
            text = text.replace(/~T/g, "~");

            text = pluginHooks.postConversion(text);

            g_html_blocks = g_titles = g_urls = null;

            return text;
        };

        function _StripLinkDefinitions(text) {
            //
            // Strips link definitions from text, stores the URLs and titles in
            // hash references.
            //

            // Link defs are in the form: ^[id]: url "optional title"

            /*
            text = text.replace(/
                ^[ ]{0,3}\[(.+)\]:  // id = $1  attacklab: g_tab_width - 1
                [ \t]*
                \n?                 // maybe *one* newline
                [ \t]*
                <?(\S+?)>?          // url = $2
                (?=\s|$)            // lookahead for whitespace instead of the lookbehind removed below
                [ \t]*
                \n?                 // maybe one newline
                [ \t]*
                (                   // (potential) title = $3
                    (\n*)           // any lines skipped = $4 attacklab: lookbehind removed
                    [ \t]+
                    ["(]
                    (.+?)           // title = $5
                    [")]
                    [ \t]*
                )?                  // title is optional
                (?:\n+|$)
            /gm, function(){...});
            */

            text = text.replace(/^[ ]{0,3}\[(.+)\]:[ \t]*\n?[ \t]*<?(\S+?)>?(?=\s|$)[ \t]*\n?[ \t]*((\n*)["(](.+?)[")][ \t]*)?(?:\n+)/gm,
                function (wholeMatch, m1, m2, m3, m4, m5) {
                    m1 = m1.toLowerCase();
                    g_urls.set(m1, _EncodeAmpsAndAngles(m2));  // Link IDs are case-insensitive
                    if (m4) {
                        // Oops, found blank lines, so it's not a title.
                        // Put back the parenthetical statement we stole.
                        return m3;
                    } else if (m5) {
                        g_titles.set(m1, m5.replace(/"/g, "&quot;"));
                    }

                    // Completely remove the definition from the text
                    return "";
                }
            );

            return text;
        }

        function _HashHTMLBlocks(text) {

            // Hashify HTML blocks:
            // We only want to do this for block-level HTML tags, such as headers,
            // lists, and tables. That's because we still want to wrap <p>s around
            // "paragraphs" that are wrapped in non-block-level tags, such as anchors,
            // phrase emphasis, and spans. The list of tags we're looking for is
            // hard-coded:
            var block_tags_a = "p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math|ins|del"
            var block_tags_b = "p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math"

            // First, look for nested blocks, e.g.:
            //   <div>
            //     <div>
            //     tags for inner block must be indented.
            //     </div>
            //   </div>
            //
            // The outermost tags must start at the left margin for this to match, and
            // the inner nested divs must be indented.
            // We need to do this before the next, more liberal match, because the next
            // match will start at the first `<div>` and stop at the first `</div>`.

            // attacklab: This regex can be expensive when it fails.

            /*
            text = text.replace(/
                (                       // save in $1
                    ^                   // start of line  (with /m)
                    <($block_tags_a)    // start tag = $2
                    \b                  // word break
                                        // attacklab: hack around khtml/pcre bug...
                    [^\r]*?\n           // any number of lines, minimally matching
                    </\2>               // the matching end tag
                    [ \t]*              // trailing spaces/tabs
                    (?=\n+)             // followed by a newline
                )                       // attacklab: there are sentinel newlines at end of document
            /gm,function(){...}};
            */
            text = text.replace(/^(<(p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math|ins|del)\b[^\r]*?\n<\/\2>[ \t]*(?=\n+))/gm, hashElement);

            //
            // Now match more liberally, simply from `\n<tag>` to `</tag>\n`
            //

            /*
            text = text.replace(/
                (                       // save in $1
                    ^                   // start of line  (with /m)
                    <($block_tags_b)    // start tag = $2
                    \b                  // word break
                                        // attacklab: hack around khtml/pcre bug...
                    [^\r]*?             // any number of lines, minimally matching
                    .*</\2>             // the matching end tag
                    [ \t]*              // trailing spaces/tabs
                    (?=\n+)             // followed by a newline
                )                       // attacklab: there are sentinel newlines at end of document
            /gm,function(){...}};
            */
            text = text.replace(/^(<(p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math)\b[^\r]*?.*<\/\2>[ \t]*(?=\n+)\n)/gm, hashElement);

            // Special case just for <hr />. It was easier to make a special case than
            // to make the other regex more complicated.  

            /*
            text = text.replace(/
                \n                  // Starting after a blank line
                [ ]{0,3}
                (                   // save in $1
                    (<(hr)          // start tag = $2
                        \b          // word break
                        ([^<>])*?
                    \/?>)           // the matching end tag
                    [ \t]*
                    (?=\n{2,})      // followed by a blank line
                )
            /g,hashElement);
            */
            text = text.replace(/\n[ ]{0,3}((<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, hashElement);

            // Special case for standalone HTML comments:

            /*
            text = text.replace(/
                \n\n                                            // Starting after a blank line
                [ ]{0,3}                                        // attacklab: g_tab_width - 1
                (                                               // save in $1
                    <!
                    (--(?:|(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)   // see http://www.w3.org/TR/html-markup/syntax.html#comments and http://meta.stackoverflow.com/q/95256
                    >
                    [ \t]*
                    (?=\n{2,})                                  // followed by a blank line
                )
            /g,hashElement);
            */
            text = text.replace(/\n\n[ ]{0,3}(<!(--(?:|(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>[ \t]*(?=\n{2,}))/g, hashElement);

            // PHP and ASP-style processor instructions (<?...?> and <%...%>)

            /*
            text = text.replace(/
                (?:
                    \n\n            // Starting after a blank line
                )
                (                   // save in $1
                    [ ]{0,3}        // attacklab: g_tab_width - 1
                    (?:
                        <([?%])     // $2
                        [^\r]*?
                        \2>
                    )
                    [ \t]*
                    (?=\n{2,})      // followed by a blank line
                )
            /g,hashElement);
            */
            text = text.replace(/(?:\n\n)([ ]{0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, hashElement);

            return text;
        }

        function hashElement(wholeMatch, m1) {
            var blockText = m1;

            // Undo double lines
            blockText = blockText.replace(/^\n+/, "");

            // strip trailing blank lines
            blockText = blockText.replace(/\n+$/g, "");

            // Replace the element text with a marker ("~KxK" where x is its key)
            blockText = "\n\n~K" + (g_html_blocks.push(blockText) - 1) + "K\n\n";

            return blockText;
        }

        function _RunBlockGamut(text, doNotUnhash) {
            //
            // These are all the transformations that form block-level
            // tags like paragraphs, headers, and list items.
            //
            text = _DoHeaders(text);

            // Do Horizontal Rules:
            var replacement = "<hr />\n";
            text = text.replace(/^[ ]{0,2}([ ]?\*[ ]?){3,}[ \t]*$/gm, replacement);
            text = text.replace(/^[ ]{0,2}([ ]?-[ ]?){3,}[ \t]*$/gm, replacement);
            text = text.replace(/^[ ]{0,2}([ ]?_[ ]?){3,}[ \t]*$/gm, replacement);

            text = _DoLists(text);
            text = _DoCodeBlocks(text);
            text = _DoBlockQuotes(text);

            // We already ran _HashHTMLBlocks() before, in Markdown(), but that
            // was to escape raw HTML in the original Markdown source. This time,
            // we're escaping the markup we've just created, so that we don't wrap
            // <p> tags around block-level tags.
            text = _HashHTMLBlocks(text);
            text = _FormParagraphs(text, doNotUnhash);

            return text;
        }

        function _RunSpanGamut(text) {
            //
            // These are all the transformations that occur *within* block-level
            // tags like paragraphs, headers, and list items.
            //

            text = _DoCodeSpans(text);
            text = _EscapeSpecialCharsWithinTagAttributes(text);
            text = _EncodeBackslashEscapes(text);

            // Process anchor and image tags. Images must come first,
            // because ![foo][f] looks like an anchor.
            text = _DoImages(text);
            text = _DoAnchors(text);

            // Make links out of things like `<http://example.com/>`
            // Must come after _DoAnchors(), because you can use < and >
            // delimiters in inline links like [this](<url>).
            if (g_autolink) {
                text = _DoAutoLinks(text);
            }
            
            text = text.replace(/~P/g, "://"); // put in place to prevent autolinking; reset now
            
            text = _EncodeAmpsAndAngles(text);
            text = _DoItalicsAndBold(text);

            // Do hard breaks:
            text = text.replace(/  +\n/g, " <br>\n");

            return text;
        }

        function _EscapeSpecialCharsWithinTagAttributes(text) {
            //
            // Within tags -- meaning between < and > -- encode [\ ` * _] so they
            // don't conflict with their use in Markdown for code, italics and strong.
            //

            // Build a regex to find HTML tags and comments.  See Friedl's 
            // "Mastering Regular Expressions", 2nd Ed., pp. 200-201.

            // SE: changed the comment part of the regex

            var regex = /(<[a-z\/!$]("[^"]*"|'[^']*'|[^'">])*>|<!(--(?:|(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>)/gi;

            text = text.replace(regex, function (wholeMatch) {
                var tag = wholeMatch.replace(/(.)<\/?code>(?=.)/g, "$1`");
                tag = escapeCharacters(tag, wholeMatch.charAt(1) == "!" ? "\\`*_/" : "\\`*_"); // also escape slashes in comments to prevent autolinking there -- http://meta.stackoverflow.com/questions/95987
                return tag;
            });

            return text;
        }

        function _DoAnchors(text) {
            //
            // Turn Markdown link shortcuts into XHTML <a> tags.
            //
            //
            // First, handle reference-style links: [link text] [id]
            //

            /*
            text = text.replace(/
                (                           // wrap whole match in $1
                    \[
                    (
                        (?:
                            \[[^\]]*\]      // allow brackets nested one level
                            |
                            [^\[]           // or anything else
                        )*
                    )
                    \]

                    [ ]?                    // one optional space
                    (?:\n[ ]*)?             // one optional newline followed by spaces

                    \[
                    (.*?)                   // id = $3
                    \]
                )
                ()()()()                    // pad remaining backreferences
            /g, writeAnchorTag);
            */
            text = text.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\][ ]?(?:\n[ ]*)?\[(.*?)\])()()()()/g, writeAnchorTag);

            //
            // Next, inline-style links: [link text](url "optional title")
            //

            /*
            text = text.replace(/
                (                           // wrap whole match in $1
                    \[
                    (
                        (?:
                            \[[^\]]*\]      // allow brackets nested one level
                            |
                            [^\[\]]         // or anything else
                        )*
                    )
                    \]
                    \(                      // literal paren
                    [ \t]*
                    ()                      // no id, so leave $3 empty
                    <?(                     // href = $4
                        (?:
                            \([^)]*\)       // allow one level of (correctly nested) parens (think MSDN)
                            |
                            [^()]
                        )*?
                    )>?                
                    [ \t]*
                    (                       // $5
                        (['"])              // quote char = $6
                        (.*?)               // Title = $7
                        \6                  // matching quote
                        [ \t]*              // ignore any spaces/tabs between closing quote and )
                    )?                      // title is optional
                    \)
                )
            /g, writeAnchorTag);
            */

            text = text.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?((?:\([^)]*\)|[^()])*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, writeAnchorTag);

            //
            // Last, handle reference-style shortcuts: [link text]
            // These must come last in case you've also got [link test][1]
            // or [link test](/foo)
            //

            /*
            text = text.replace(/
                (                   // wrap whole match in $1
                    \[
                    ([^\[\]]+)      // link text = $2; can't contain '[' or ']'
                    \]
                )
                ()()()()()          // pad rest of backreferences
            /g, writeAnchorTag);
            */
            text = text.replace(/(\[([^\[\]]+)\])()()()()()/g, writeAnchorTag);

            return text;
        }

        function writeAnchorTag(wholeMatch, m1, m2, m3, m4, m5, m6, m7) {
            if (m7 == undefined) m7 = "";
            var whole_match = m1;
            var link_text = m2.replace(/:\/\//g, "~P"); // to prevent auto-linking withing the link. will be converted back after the auto-linker runs
            var link_id = m3.toLowerCase();
            var url = m4;
            var title = m7;

            if (url == "") {
                if (link_id == "") {
                    // lower-case and turn embedded newlines into spaces
                    link_id = link_text.toLowerCase().replace(/ ?\n/g, " ");
                }
                url = "#" + link_id;

                if (g_urls.get(link_id) != undefined) {
                    url = g_urls.get(link_id);
                    if (g_titles.get(link_id) != undefined) {
                        title = g_titles.get(link_id);
                    }
                }
                else {
                    if (whole_match.search(/\(\s*\)$/m) > -1) {
                        // Special case for explicit empty url
                        url = "";
                    } else {
                        return whole_match;
                    }
                }
            }
            url = encodeProblemUrlChars(url);
            url = escapeCharacters(url, "*_");
            var result = "<a href=\"" + url + "\"";

            if (title != "") {
                title = attributeEncode(title);
                title = escapeCharacters(title, "*_");
                result += " title=\"" + title + "\"";
            }

            result += ">" + link_text + "</a>";

            return result;
        }

        function _DoImages(text) {
            //
            // Turn Markdown image shortcuts into <img> tags.
            //

            //
            // First, handle reference-style labeled images: ![alt text][id]
            //

            /*
            text = text.replace(/
                (                   // wrap whole match in $1
                    !\[
                    (.*?)           // alt text = $2
                    \]

                    [ ]?            // one optional space
                    (?:\n[ ]*)?     // one optional newline followed by spaces

                    \[
                    (.*?)           // id = $3
                    \]
                )
                ()()()()            // pad rest of backreferences
            /g, writeImageTag);
            */
            text = text.replace(/(!\[(.*?)\][ ]?(?:\n[ ]*)?\[(.*?)\])()()()()/g, writeImageTag);

            //
            // Next, handle inline images:  ![alt text](url "optional title")
            // Don't forget: encode * and _

            /*
            text = text.replace(/
                (                   // wrap whole match in $1
                    !\[
                    (.*?)           // alt text = $2
                    \]
                    \s?             // One optional whitespace character
                    \(              // literal paren
                    [ \t]*
                    ()              // no id, so leave $3 empty
                    <?(\S+?)>?      // src url = $4
                    [ \t]*
                    (               // $5
                        (['"])      // quote char = $6
                        (.*?)       // title = $7
                        \6          // matching quote
                        [ \t]*
                    )?              // title is optional
                    \)
                )
            /g, writeImageTag);
            */
            text = text.replace(/(!\[(.*?)\]\s?\([ \t]*()<?(\S+?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g, writeImageTag);

            return text;
        }
        
        function attributeEncode(text) {
            // unconditionally replace angle brackets here -- what ends up in an attribute (e.g. alt or title)
            // never makes sense to have verbatim HTML in it (and the sanitizer would totally break it)
            return text.replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
        }

        function writeImageTag(wholeMatch, m1, m2, m3, m4, m5, m6, m7) {
            var whole_match = m1;
            var alt_text = m2;
            var link_id = m3.toLowerCase();
            var url = m4;
            var title = m7;

            if (!title) title = "";

            if (url == "") {
                if (link_id == "") {
                    // lower-case and turn embedded newlines into spaces
                    link_id = alt_text.toLowerCase().replace(/ ?\n/g, " ");
                }
                url = "#" + link_id;

                if (g_urls.get(link_id) != undefined) {
                    url = g_urls.get(link_id);
                    if (g_titles.get(link_id) != undefined) {
                        title = g_titles.get(link_id);
                    }
                }
                else {
                    return whole_match;
                }
            }
            
            alt_text = escapeCharacters(attributeEncode(alt_text), "*_[]()");
            url = escapeCharacters(url, "*_");
            var result = "<img src=\"" + url + "\" alt=\"" + alt_text + "\"";

            // attacklab: Markdown.pl adds empty title attributes to images.
            // Replicate this bug.

            //if (title != "") {
            title = attributeEncode(title);
            title = escapeCharacters(title, "*_");
            result += " title=\"" + title + "\"";
            //}

            result += " />";

            return result;
        }

        function _DoHeaders(text) {

            // Setext-style headers:
            //  Header 1
            //  ========
            //  
            //  Header 2
            //  --------
            //
            text = text.replace(/^(.+)[ \t]*\n=+[ \t]*\n+/gm,
                function (wholeMatch, m1) { return "<h1>" + _RunSpanGamut(m1) + "</h1>\n\n"; }
            );

            text = text.replace(/^(.+)[ \t]*\n-+[ \t]*\n+/gm,
                function (matchFound, m1) { return "<h2>" + _RunSpanGamut(m1) + "</h2>\n\n"; }
            );

            // atx-style headers:
            //  # Header 1
            //  ## Header 2
            //  ## Header 2 with closing hashes ##
            //  ...
            //  ###### Header 6
            //

            /*
            text = text.replace(/
                ^(\#{1,6})      // $1 = string of #'s
                [ \t]*
                (.+?)           // $2 = Header text
                [ \t]*
                \#*             // optional closing #'s (not counted)
                \n+
            /gm, function() {...});
            */

            text = text.replace(/^(\#{1,6})[ \t]*(.+?)[ \t]*\#*\n+/gm,
                function (wholeMatch, m1, m2) {
                    var h_level = m1.length;
                    return "<h" + h_level + ">" + _RunSpanGamut(m2) + "</h" + h_level + ">\n\n";
                }
            );

            return text;
        }

        function _DoLists(text) {
            //
            // Form HTML ordered (numbered) and unordered (bulleted) lists.
            //

            // attacklab: add sentinel to hack around khtml/safari bug:
            // http://bugs.webkit.org/show_bug.cgi?id=11231
            text += "~0";

            // Re-usable pattern to match any entirel ul or ol list:

            /*
            var whole_list = /
                (                                   // $1 = whole list
                    (                               // $2
                        [ ]{0,3}                    // attacklab: g_tab_width - 1
                        ([*+-]|\d+[.])              // $3 = first list item marker
                        [ \t]+
                    )
                    [^\r]+?
                    (                               // $4
                        ~0                          // sentinel for workaround; should be $
                        |
                        \n{2,}
                        (?=\S)
                        (?!                         // Negative lookahead for another list item marker
                            [ \t]*
                            (?:[*+-]|\d+[.])[ \t]+
                        )
                    )
                )
            /g
            */
            var whole_list = /^(([ ]{0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(~0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm;

            if (g_list_level) {
                text = text.replace(whole_list, function (wholeMatch, m1, m2) {
                    var list = m1;
                    var list_type = (m2.search(/[*+-]/g) > -1) ? "ul" : "ol";

                    var result = _ProcessListItems(list, list_type);

                    // Trim any trailing whitespace, to put the closing `</$list_type>`
                    // up on the preceding line, to get it past the current stupid
                    // HTML block parser. This is a hack to work around the terrible
                    // hack that is the HTML block parser.
                    result = result.replace(/\s+$/, "");
                    result = "<" + list_type + ">" + result + "</" + list_type + ">\n";
                    return result;
                });
            } else {
                whole_list = /(\n\n|^\n?)(([ ]{0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(~0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/g;
                text = text.replace(whole_list, function (wholeMatch, m1, m2, m3) {
                    var runup = m1;
                    var list = m2;

                    var list_type = (m3.search(/[*+-]/g) > -1) ? "ul" : "ol";
                    var result = _ProcessListItems(list, list_type);
                    result = runup + "<" + list_type + ">\n" + result + "</" + list_type + ">\n";
                    return result;
                });
            }

            // attacklab: strip sentinel
            text = text.replace(/~0/, "");

            return text;
        }

        var _listItemMarkers = { ol: "\\d+[.]", ul: "[*+-]" };

        function _ProcessListItems(list_str, list_type) {
            //
            //  Process the contents of a single ordered or unordered list, splitting it
            //  into individual list items.
            //
            //  list_type is either "ul" or "ol".

            // The $g_list_level global keeps track of when we're inside a list.
            // Each time we enter a list, we increment it; when we leave a list,
            // we decrement. If it's zero, we're not in a list anymore.
            //
            // We do this because when we're not inside a list, we want to treat
            // something like this:
            //
            //    I recommend upgrading to version
            //    8. Oops, now this line is treated
            //    as a sub-list.
            //
            // As a single paragraph, despite the fact that the second line starts
            // with a digit-period-space sequence.
            //
            // Whereas when we're inside a list (or sub-list), that line will be
            // treated as the start of a sub-list. What a kludge, huh? This is
            // an aspect of Markdown's syntax that's hard to parse perfectly
            // without resorting to mind-reading. Perhaps the solution is to
            // change the syntax rules such that sub-lists must start with a
            // starting cardinal number; e.g. "1." or "a.".

            g_list_level++;

            // trim trailing blank lines:
            list_str = list_str.replace(/\n{2,}$/, "\n");

            // attacklab: add sentinel to emulate \z
            list_str += "~0";

            // In the original attacklab showdown, list_type was not given to this function, and anything
            // that matched /[*+-]|\d+[.]/ would just create the next <li>, causing this mismatch:
            //
            //  Markdown          rendered by WMD        rendered by MarkdownSharp
            //  ------------------------------------------------------------------
            //  1. first          1. first               1. first
            //  2. second         2. second              2. second
            //  - third           3. third                   * third
            //
            // We changed this to behave identical to MarkdownSharp. This is the constructed RegEx,
            // with {MARKER} being one of \d+[.] or [*+-], depending on list_type:
        
            /*
            list_str = list_str.replace(/
                (^[ \t]*)                       // leading whitespace = $1
                ({MARKER}) [ \t]+               // list marker = $2
                ([^\r]+?                        // list item text   = $3
                    (\n+)
                )
                (?=
                    (~0 | \2 ({MARKER}) [ \t]+)
                )
            /gm, function(){...});
            */

            var marker = _listItemMarkers[list_type];
            var re = new RegExp("(^[ \\t]*)(" + marker + ")[ \\t]+([^\\r]+?(\\n+))(?=(~0|\\1(" + marker + ")[ \\t]+))", "gm");
            var last_item_had_a_double_newline = false;
            list_str = list_str.replace(re,
                function (wholeMatch, m1, m2, m3) {
                    var item = m3;
                    var leading_space = m1;
                    var ends_with_double_newline = /\n\n$/.test(item);
                    var contains_double_newline = ends_with_double_newline || item.search(/\n{2,}/) > -1;

                    if (contains_double_newline || last_item_had_a_double_newline) {
                        item = _RunBlockGamut(_Outdent(item), /* doNotUnhash = */true);
                    }
                    else {
                        // Recursion for sub-lists:
                        item = _DoLists(_Outdent(item));
                        item = item.replace(/\n$/, ""); // chomp(item)
                        item = _RunSpanGamut(item);
                    }
                    last_item_had_a_double_newline = ends_with_double_newline;
                    return "<li>" + item + "</li>\n";
                }
            );

            // attacklab: strip sentinel
            list_str = list_str.replace(/~0/g, "");

            g_list_level--;
            return list_str;
        }

        function _DoCodeBlocks(text) {
            //
            //  Process Markdown `<pre><code>` blocks.
            //  

            /*
            text = text.replace(/
                (?:\n\n|^)
                (                               // $1 = the code block -- one or more lines, starting with a space/tab
                    (?:
                        (?:[ ]{4}|\t)           // Lines must start with a tab or a tab-width of spaces - attacklab: g_tab_width
                        .*\n+
                    )+
                )
                (\n*[ ]{0,3}[^ \t\n]|(?=~0))    // attacklab: g_tab_width
            /g ,function(){...});
            */

            // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
            text += "~0";

            text = text.replace(/(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=~0))/g,
                function (wholeMatch, m1, m2) {
                    var codeblock = m1;
                    var nextChar = m2;

                    codeblock = _EncodeCode(_Outdent(codeblock));
                    codeblock = _Detab(codeblock);
                    codeblock = codeblock.replace(/^\n+/g, ""); // trim leading newlines
                    codeblock = codeblock.replace(/\n+$/g, ""); // trim trailing whitespace

                    codeblock = '<pre class="prettyprint linenums"><code>' + codeblock + '\n</code></pre>';

                    return "\n\n" + codeblock + "\n\n" + nextChar;
                }
            );

            // attacklab: strip sentinel
            text = text.replace(/~0/, "");

            return text;
        }

        function hashBlock(text) {
            text = text.replace(/(^\n+|\n+$)/g, "");
            return "\n\n~K" + (g_html_blocks.push(text) - 1) + "K\n\n";
        }

        function _DoCodeSpans(text) {
            //
            // * Backtick quotes are used for <code></code> spans.
            // 
            // * You can use multiple backticks as the delimiters if you want to
            //   include literal backticks in the code span. So, this input:
            //     
            //      Just type ``foo `bar` baz`` at the prompt.
            //     
            //   Will translate to:
            //     
            //      <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
            //     
            //   There's no arbitrary limit to the number of backticks you
            //   can use as delimters. If you need three consecutive backticks
            //   in your code, use four for delimiters, etc.
            //
            // * You can use spaces to get literal backticks at the edges:
            //     
            //      ... type `` `bar` `` ...
            //     
            //   Turns to:
            //     
            //      ... type <code>`bar`</code> ...
            //

            /*
            text = text.replace(/
                (^|[^\\])       // Character before opening ` can't be a backslash
                (`+)            // $2 = Opening run of `
                (               // $3 = The code block
                    [^\r]*?
                    [^`]        // attacklab: work around lack of lookbehind
                )
                \2              // Matching closer
                (?!`)
            /gm, function(){...});
            */

            text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm,
                function (wholeMatch, m1, m2, m3, m4) {
                    var c = m3;
                    c = c.replace(/^([ \t]*)/g, ""); // leading whitespace
                    c = c.replace(/[ \t]*$/g, ""); // trailing whitespace
                    c = _EncodeCode(c);
                    c = c.replace(/:\/\//g, "~P"); // to prevent auto-linking. Not necessary in code *blocks*, but in code spans. Will be converted back after the auto-linker runs.
                    return m1 + "<code>" + c + "</code>";
                }
            );

            return text;
        }

        function _EncodeCode(text) {
            //
            // Encode/escape certain characters inside Markdown code runs.
            // The point is that in code, these characters are literals,
            // and lose their special Markdown meanings.
            //
            // Encode all ampersands; HTML entities are not
            // entities within a Markdown code span.
            text = text.replace(/&/g, "&amp;");

            // Do the angle bracket song and dance:
            text = text.replace(/</g, "&lt;");
            text = text.replace(/>/g, "&gt;");

            // Now, escape characters that are magic in Markdown:
            text = escapeCharacters(text, "\*_{}[]\\", false);

            // jj the line above breaks this:
            //---

            //* Item

            //   1. Subitem

            //            special char: *
            //---

            return text;
        }

        function _DoItalicsAndBold(text) {

            // <strong> must go first:
            text = text.replace(/([\W_]|^)(\*\*|__)(?=\S)([^\r]*?\S[\*_]*)\2([\W_]|$)/g,
            "$1<strong>$3</strong>$4");

            text = text.replace(/([\W_]|^)(\*|_)(?=\S)([^\r\*_]*?\S)\2([\W_]|$)/g,
            "$1<em>$3</em>$4");

            return text;
        }

        function _DoBlockQuotes(text) {

            /*
            text = text.replace(/
                (                           // Wrap whole match in $1
                    (
                        ^[ \t]*>[ \t]?      // '>' at the start of a line
                        .+\n                // rest of the first line
                        (.+\n)*             // subsequent consecutive lines
                        \n*                 // blanks
                    )+
                )
            /gm, function(){...});
            */

            text = text.replace(/((^[ \t]*>[ \t]?.+\n(.+\n)*\n*)+)/gm,
                function (wholeMatch, m1) {
                    var bq = m1;

                    // attacklab: hack around Konqueror 3.5.4 bug:
                    // "----------bug".replace(/^-/g,"") == "bug"

                    bq = bq.replace(/^[ \t]*>[ \t]?/gm, "~0"); // trim one level of quoting

                    // attacklab: clean up hack
                    bq = bq.replace(/~0/g, "");

                    bq = bq.replace(/^[ \t]+$/gm, "");     // trim whitespace-only lines
                    bq = _RunBlockGamut(bq);             // recurse

                    bq = bq.replace(/(^|\n)/g, "$1  ");
                    // These leading spaces screw with <pre> content, so we need to fix that:
                    bq = bq.replace(
                            /(\s*<pre>[^\r]+?<\/pre>)/gm,
                        function (wholeMatch, m1) {
                            var pre = m1;
                            // attacklab: hack around Konqueror 3.5.4 bug:
                            pre = pre.replace(/^  /mg, "~0");
                            pre = pre.replace(/~0/g, "");
                            return pre;
                        });

                    return hashBlock("<blockquote>\n" + bq + "\n</blockquote>");
                }
            );
            return text;
        }

        function _FormParagraphs(text, doNotUnhash) {
            //
            //  Params:
            //    $text - string to process with html <p> tags
            //

            // Strip leading and trailing lines:
            text = text.replace(/^\n+/g, "");
            text = text.replace(/\n+$/g, "");

            var grafs = text.split(/\n{2,}/g);
            var grafsOut = [];
            
            var markerRe = /~K(\d+)K/;

            //
            // Wrap <p> tags.
            //
            var end = grafs.length;
            for (var i = 0; i < end; i++) {
                var str = grafs[i];

                // if this is an HTML marker, copy it
                if (markerRe.test(str)) {
                    grafsOut.push(str);
                }
                else if (/\S/.test(str)) {
                    str = _RunSpanGamut(str);
                    str = str.replace(/^([ \t]*)/g, "<p>");
                    str += "</p>"
                    grafsOut.push(str);
                }

            }
            //
            // Unhashify HTML blocks
            //
            if (!doNotUnhash) {
                end = grafsOut.length;
                for (var i = 0; i < end; i++) {
                    var foundAny = true;
                    while (foundAny) { // we may need several runs, since the data may be nested
                        foundAny = false;
                        grafsOut[i] = grafsOut[i].replace(/~K(\d+)K/g, function (wholeMatch, id) {
                            foundAny = true;
                            return g_html_blocks[id];
                        });
                    }
                }
            }
            return grafsOut.join("\n\n");
        }

        function _EncodeAmpsAndAngles(text) {
            // Smart processing for ampersands and angle brackets that need to be encoded.

            // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
            //   http://bumppo.net/projects/amputator/
            text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, "&amp;");

            // Encode naked <'s
            text = text.replace(/<(?![a-z\/?\$!])/gi, "&lt;");

            return text;
        }

        function _EncodeBackslashEscapes(text) {
            //
            //   Parameter:  String.
            //   Returns:    The string, with after processing the following backslash
            //               escape sequences.
            //

            // attacklab: The polite way to do this is with the new
            // escapeCharacters() function:
            //
            //     text = escapeCharacters(text,"\\",true);
            //     text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
            //
            // ...but we're sidestepping its use of the (slow) RegExp constructor
            // as an optimization for Firefox.  This function gets called a LOT.

            text = text.replace(/\\(\\)/g, escapeCharacters_callback);
            text = text.replace(/\\([`*_{}\[\]()>#+-.!])/g, escapeCharacters_callback);
            return text;
        }

        function _DoAutoLinks(text) {

            // note that at this point, all other URL in the text are already hyperlinked as <a href=""></a>
            // *except* for the <http://www.foo.com> case

            // automatically add < and > around unadorned raw hyperlinks
            // must be preceded by space/BOF and followed by non-word/EOF character    
            text = text.replace(/(^|\s)(https?|ftp)(:\/\/[-A-Z0-9+&@#\/%?=~_|\[\]\(\)!:,\.;]*[-A-Z0-9+&@#\/%=~_|\[\]])($|\W)/gi, "$1<$2$3>$4");

            //  autolink anything like <http://example.com>
            
            var replacer = function (wholematch, m1) { return "<a href=\"" + m1 + "\">" + pluginHooks.plainLinkText(m1) + "</a>"; }
            text = text.replace(/<((https?|ftp):[^'">\s]+)>/gi, replacer);

            // Email addresses: <address@domain.foo>
            /*
            text = text.replace(/
                <
                (?:mailto:)?
                (
                    [-.\w]+
                    \@
                    [-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+
                )
                >
            /gi, _DoAutoLinks_callback());
            */

            var email_replacer = function(wholematch, m1) {
                var mailto = 'mailto:'
                var link
                var email
                if (m1.substring(0, mailto.length) != mailto){
                    link = mailto + m1;
                    email = m1;
                } else {
                    link = m1;
                    email = m1.substring(mailto.length, m1.length);
                }
                return "<a href=\"" + link + "\">" + pluginHooks.plainLinkText(email) + "</a>";
            }
            text = text.replace(/<((?:mailto:)?([-.\w]+\@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+))>/gi, email_replacer);

            return text;
        }

        function _UnescapeSpecialChars(text) {
            //
            // Swap back in all the special characters we've hidden.
            //
            text = text.replace(/~E(\d+)E/g,
                function (wholeMatch, m1) {
                    var charCodeToReplace = parseInt(m1);
                    return String.fromCharCode(charCodeToReplace);
                }
            );
            return text;
        }

        function _Outdent(text) {
            //
            // Remove one level of line-leading tabs or spaces
            //

            // attacklab: hack around Konqueror 3.5.4 bug:
            // "----------bug".replace(/^-/g,"") == "bug"

            text = text.replace(/^(\t|[ ]{1,4})/gm, "~0"); // attacklab: g_tab_width

            // attacklab: clean up hack
            text = text.replace(/~0/g, "")

            return text;
        }

        function _Detab(text) {
            if (!/\t/.test(text))
                return text;

            var spaces = ["    ", "   ", "  ", " "],
            skew = 0,
            v;

            return text.replace(/[\n\t]/g, function (match, offset) {
                if (match === "\n") {
                    skew = offset + 1;
                    return match;
                }
                v = (offset - skew) % 4;
                skew = offset + 1;
                return spaces[v];
            });
        }

        //
        //  attacklab: Utility functions
        //

        var _problemUrlChars = /(?:["'*()[\]:]|~D)/g;

        // hex-encodes some unusual "problem" chars in URLs to avoid URL detection problems 
        function encodeProblemUrlChars(url) {
            if (!url)
                return "";

            var len = url.length;

            return url.replace(_problemUrlChars, function (match, offset) {
                if (match == "~D") // escape for dollar
                    return "%24";
                if (match == ":") {
                    if (offset == len - 1 || /[0-9\/]/.test(url.charAt(offset + 1)))
                        return ":";
                    if (url.substring(0, 'mailto:'.length) === 'mailto:')
                        return ":";
                    if (url.substring(0, 'magnet:'.length) === 'magnet:')
                        return ":";
                }
                return "%" + match.charCodeAt(0).toString(16);
            });
        }


        function escapeCharacters(text, charsToEscape, afterBackslash) {
            // First we have to escape the escape characters so that
            // we can build a character class out of them
            var regexString = "([" + charsToEscape.replace(/([\[\]\\])/g, "\\$1") + "])";

            if (afterBackslash) {
                regexString = "\\\\" + regexString;
            }

            var regex = new RegExp(regexString, "g");
            text = text.replace(regex, escapeCharacters_callback);

            return text;
        }


        function escapeCharacters_callback(wholeMatch, m1) {
            var charCodeToEscape = m1.charCodeAt(0);
            return "~E" + charCodeToEscape + "E";
        }

    }; // end of the Markdown.Converter constructor

})();

},{}],"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Editor.js":[function(require,module,exports){
// needs Markdown.Converter.js at the moment

(function () {

    var util = {},
        position = {},
        ui = {},
        doc = window.document,
        re = window.RegExp,
        nav = window.navigator,
        SETTINGS = { lineLength: 72 },

    // Used to work around some browser bugs where we can't use feature testing.
        uaSniffed = {
            isIE: /msie/.test(nav.userAgent.toLowerCase()),
            isIE_5or6: /msie 6/.test(nav.userAgent.toLowerCase()) || /msie 5/.test(nav.userAgent.toLowerCase()),
            isOpera: /opera/.test(nav.userAgent.toLowerCase())
        };


    // -------------------------------------------------------------------
    //  YOUR CHANGES GO HERE
    //
    // I've tried to localize the things you are likely to change to 
    // this area.
    // -------------------------------------------------------------------

    // The text that appears on the upper part of the dialog box when
    // entering links.
    var linkDialogText = "<p>http://example.com/ \"optional title\"</p>";
    var imageDialogText = "<p>http://example.com/images/diagram.jpg \"optional title\"</p>";

    // The default text that appears in the dialog input box when entering
    // links.
    var imageDefaultText = "http://";
    var linkDefaultText = "http://";

    var defaultHelpHoverTitle = "Markdown Editing Help";

    // -------------------------------------------------------------------
    //  END OF YOUR CHANGES
    // -------------------------------------------------------------------

    // help, if given, should have a property "handler", the click handler for the help button,
    // and can have an optional property "title" for the button's tooltip (defaults to "Markdown Editing Help").
    // If help isn't given, not help button is created.
    //
    // The constructed editor object has the methods:
    // - getConverter() returns the markdown converter object that was passed to the constructor
    // - run() actually starts the editor; should be called after all necessary plugins are registered. Calling this more than once is a no-op.
    // - refreshPreview() forces the preview to be updated. This method is only available after run() was called.
    Markdown.Editor = function (markdownConverter, idPostfix, help) {

        idPostfix = idPostfix || "";

        var hooks = this.hooks = new Markdown.HookCollection();
        hooks.addNoop("onPreviewRefresh");       // called with no arguments after the preview has been refreshed
        hooks.addNoop("postBlockquoteCreation"); // called with the user's selection *after* the blockquote was created; should return the actual to-be-inserted text
        hooks.addFalse("insertImageDialog");     /* called with one parameter: a callback to be called with the URL of the image. If the application creates
                                                  * its own image insertion dialog, this hook should return true, and the callback should be called with the chosen
                                                  * image url (or null if the user cancelled). If this hook returns false, the default dialog will be used.
                                                  */

        this.getConverter = function () { return markdownConverter; }

        var that = this,
            panels;

        this.run = function () {
            if (panels)
                return; // already initialized

            panels = new PanelCollection(idPostfix);
            var commandManager = new CommandManager(hooks);
            var previewManager = new PreviewManager(markdownConverter, panels, function () { hooks.onPreviewRefresh(); });
            var undoManager, uiManager;

            if (!/\?noundo/.test(doc.location.href)) {
                undoManager = new UndoManager(function () {
                    previewManager.refresh();
                    if (uiManager) // not available on the first call
                        uiManager.setUndoRedoButtonStates();
                }, panels);
                this.textOperation = function (f) {
                    undoManager.setCommandMode();
                    f();
                    that.refreshPreview();
                }
            }

            uiManager = new UIManager(idPostfix, panels, undoManager, previewManager, commandManager, help);
            uiManager.setUndoRedoButtonStates();

            var forceRefresh = that.refreshPreview = function () { previewManager.refresh(true); };

            forceRefresh();
        };

    }

    // before: contains all the text in the input box BEFORE the selection.
    // after: contains all the text in the input box AFTER the selection.
    function Chunks() { }

    // startRegex: a regular expression to find the start tag
    // endRegex: a regular expresssion to find the end tag
    Chunks.prototype.findTags = function (startRegex, endRegex) {

        var chunkObj = this;
        var regex;

        if (startRegex) {

            regex = util.extendRegExp(startRegex, "", "$");

            this.before = this.before.replace(regex,
                function (match) {
                    chunkObj.startTag = chunkObj.startTag + match;
                    return "";
                });

            regex = util.extendRegExp(startRegex, "^", "");

            this.selection = this.selection.replace(regex,
                function (match) {
                    chunkObj.startTag = chunkObj.startTag + match;
                    return "";
                });
        }

        if (endRegex) {

            regex = util.extendRegExp(endRegex, "", "$");

            this.selection = this.selection.replace(regex,
                function (match) {
                    chunkObj.endTag = match + chunkObj.endTag;
                    return "";
                });

            regex = util.extendRegExp(endRegex, "^", "");

            this.after = this.after.replace(regex,
                function (match) {
                    chunkObj.endTag = match + chunkObj.endTag;
                    return "";
                });
        }
    };

    // If remove is false, the whitespace is transferred
    // to the before/after regions.
    //
    // If remove is true, the whitespace disappears.
    Chunks.prototype.trimWhitespace = function (remove) {
        var beforeReplacer, afterReplacer, that = this;
        if (remove) {
            beforeReplacer = afterReplacer = "";
        } else {
            beforeReplacer = function (s) { that.before += s; return ""; }
            afterReplacer = function (s) { that.after = s + that.after; return ""; }
        }
        
        this.selection = this.selection.replace(/^(\s*)/, beforeReplacer).replace(/(\s*)$/, afterReplacer);
    };


    Chunks.prototype.skipLines = function (nLinesBefore, nLinesAfter, findExtraNewlines) {

        if (nLinesBefore === undefined) {
            nLinesBefore = 1;
        }

        if (nLinesAfter === undefined) {
            nLinesAfter = 1;
        }

        nLinesBefore++;
        nLinesAfter++;

        var regexText;
        var replacementText;

        // chrome bug ... documented at: http://meta.stackoverflow.com/questions/63307/blockquote-glitch-in-editor-in-chrome-6-and-7/65985#65985
        if (navigator.userAgent.match(/Chrome/)) {
            "X".match(/()./);
        }

        this.selection = this.selection.replace(/(^\n*)/, "");

        this.startTag = this.startTag + re.$1;

        this.selection = this.selection.replace(/(\n*$)/, "");
        this.endTag = this.endTag + re.$1;
        this.startTag = this.startTag.replace(/(^\n*)/, "");
        this.before = this.before + re.$1;
        this.endTag = this.endTag.replace(/(\n*$)/, "");
        this.after = this.after + re.$1;

        if (this.before) {

            regexText = replacementText = "";

            while (nLinesBefore--) {
                regexText += "\\n?";
                replacementText += "\n";
            }

            if (findExtraNewlines) {
                regexText = "\\n*";
            }
            this.before = this.before.replace(new re(regexText + "$", ""), replacementText);
        }

        if (this.after) {

            regexText = replacementText = "";

            while (nLinesAfter--) {
                regexText += "\\n?";
                replacementText += "\n";
            }
            if (findExtraNewlines) {
                regexText = "\\n*";
            }

            this.after = this.after.replace(new re(regexText, ""), replacementText);
        }
    };

    // end of Chunks 

    // A collection of the important regions on the page.
    // Cached so we don't have to keep traversing the DOM.
    // Also holds ieCachedRange and ieCachedScrollTop, where necessary; working around
    // this issue:
    // Internet explorer has problems with CSS sprite buttons that use HTML
    // lists.  When you click on the background image "button", IE will 
    // select the non-existent link text and discard the selection in the
    // textarea.  The solution to this is to cache the textarea selection
    // on the button's mousedown event and set a flag.  In the part of the
    // code where we need to grab the selection, we check for the flag
    // and, if it's set, use the cached area instead of querying the
    // textarea.
    //
    // This ONLY affects Internet Explorer (tested on versions 6, 7
    // and 8) and ONLY on button clicks.  Keyboard shortcuts work
    // normally since the focus never leaves the textarea.
    function PanelCollection(postfix) {
        this.buttonBar = doc.getElementById("wmd-button-bar" + postfix);
        this.preview = doc.getElementById("wmd-preview" + postfix);
        this.input = doc.getElementById("wmd-input" + postfix);
    };

    // Returns true if the DOM element is visible, false if it's hidden.
    // Checks if display is anything other than none.
    util.isVisible = function (elem) {

        if (window.getComputedStyle) {
            // Most browsers
            return window.getComputedStyle(elem, null).getPropertyValue("display") !== "none";
        }
        else if (elem.currentStyle) {
            // IE
            return elem.currentStyle["display"] !== "none";
        }
    };


    // Adds a listener callback to a DOM element which is fired on a specified
    // event.
    util.addEvent = function (elem, event, listener) {
        if (elem.attachEvent) {
            // IE only.  The "on" is mandatory.
            elem.attachEvent("on" + event, listener);
        }
        else {
            // Other browsers.
            elem.addEventListener(event, listener, false);
        }
    };


    // Removes a listener callback from a DOM element which is fired on a specified
    // event.
    util.removeEvent = function (elem, event, listener) {
        if (elem.detachEvent) {
            // IE only.  The "on" is mandatory.
            elem.detachEvent("on" + event, listener);
        }
        else {
            // Other browsers.
            elem.removeEventListener(event, listener, false);
        }
    };

    // Converts \r\n and \r to \n.
    util.fixEolChars = function (text) {
        text = text.replace(/\r\n/g, "\n");
        text = text.replace(/\r/g, "\n");
        return text;
    };

    // Extends a regular expression.  Returns a new RegExp
    // using pre + regex + post as the expression.
    // Used in a few functions where we have a base
    // expression and we want to pre- or append some
    // conditions to it (e.g. adding "$" to the end).
    // The flags are unchanged.
    //
    // regex is a RegExp, pre and post are strings.
    util.extendRegExp = function (regex, pre, post) {

        if (pre === null || pre === undefined) {
            pre = "";
        }
        if (post === null || post === undefined) {
            post = "";
        }

        var pattern = regex.toString();
        var flags;

        // Replace the flags with empty space and store them.
        pattern = pattern.replace(/\/([gim]*)$/, function (wholeMatch, flagsPart) {
            flags = flagsPart;
            return "";
        });

        // Remove the slash delimiters on the regular expression.
        pattern = pattern.replace(/(^\/|\/$)/g, "");
        pattern = pre + pattern + post;

        return new re(pattern, flags);
    }

    // UNFINISHED
    // The assignment in the while loop makes jslint cranky.
    // I'll change it to a better loop later.
    position.getTop = function (elem, isInner) {
        var result = elem.offsetTop;
        if (!isInner) {
            while (elem = elem.offsetParent) {
                result += elem.offsetTop;
            }
        }
        return result;
    };

    position.getHeight = function (elem) {
        return elem.offsetHeight || elem.scrollHeight;
    };

    position.getWidth = function (elem) {
        return elem.offsetWidth || elem.scrollWidth;
    };

    position.getPageSize = function () {

        var scrollWidth, scrollHeight;
        var innerWidth, innerHeight;

        // It's not very clear which blocks work with which browsers.
        if (self.innerHeight && self.scrollMaxY) {
            scrollWidth = doc.body.scrollWidth;
            scrollHeight = self.innerHeight + self.scrollMaxY;
        }
        else if (doc.body.scrollHeight > doc.body.offsetHeight) {
            scrollWidth = doc.body.scrollWidth;
            scrollHeight = doc.body.scrollHeight;
        }
        else {
            scrollWidth = doc.body.offsetWidth;
            scrollHeight = doc.body.offsetHeight;
        }

        if (self.innerHeight) {
            // Non-IE browser
            innerWidth = self.innerWidth;
            innerHeight = self.innerHeight;
        }
        else if (doc.documentElement && doc.documentElement.clientHeight) {
            // Some versions of IE (IE 6 w/ a DOCTYPE declaration)
            innerWidth = doc.documentElement.clientWidth;
            innerHeight = doc.documentElement.clientHeight;
        }
        else if (doc.body) {
            // Other versions of IE
            innerWidth = doc.body.clientWidth;
            innerHeight = doc.body.clientHeight;
        }

        var maxWidth = Math.max(scrollWidth, innerWidth);
        var maxHeight = Math.max(scrollHeight, innerHeight);
        return [maxWidth, maxHeight, innerWidth, innerHeight];
    };

    // Handles pushing and popping TextareaStates for undo/redo commands.
    // I should rename the stack variables to list.
    function UndoManager(callback, panels) {

        var undoObj = this;
        var undoStack = []; // A stack of undo states
        var stackPtr = 0; // The index of the current state
        var mode = "none";
        var lastState; // The last state
        var timer; // The setTimeout handle for cancelling the timer
        var inputStateObj;

        // Set the mode for later logic steps.
        var setMode = function (newMode, noSave) {
            if (mode != newMode) {
                mode = newMode;
                if (!noSave) {
                    saveState();
                }
            }

            if (!uaSniffed.isIE || mode != "moving") {
                timer = setTimeout(refreshState, 1);
            }
            else {
                inputStateObj = null;
            }
        };

        var refreshState = function (isInitialState) {
            inputStateObj = new TextareaState(panels, isInitialState);
            timer = undefined;
        };

        this.setCommandMode = function () {
            mode = "command";
            saveState();
            timer = setTimeout(refreshState, 0);
        };

        this.canUndo = function () {
            return stackPtr > 1;
        };

        this.canRedo = function () {
            if (undoStack[stackPtr + 1]) {
                return true;
            }
            return false;
        };

        // Removes the last state and restores it.
        this.undo = function () {

            if (undoObj.canUndo()) {
                if (lastState) {
                    // What about setting state -1 to null or checking for undefined?
                    lastState.restore();
                    lastState = null;
                }
                else {
                    undoStack[stackPtr] = new TextareaState(panels);
                    undoStack[--stackPtr].restore();

                    if (callback) {
                        callback();
                    }
                }
            }

            mode = "none";
            panels.input.focus();
            refreshState();
        };

        // Redo an action.
        this.redo = function () {

            if (undoObj.canRedo()) {

                undoStack[++stackPtr].restore();

                if (callback) {
                    callback();
                }
            }

            mode = "none";
            panels.input.focus();
            refreshState();
        };

        // Push the input area state to the stack.
        var saveState = function () {
            var currState = inputStateObj || new TextareaState(panels);

            if (!currState) {
                return false;
            }
            if (mode == "moving") {
                if (!lastState) {
                    lastState = currState;
                }
                return;
            }
            if (lastState) {
                if (undoStack[stackPtr - 1].text != lastState.text) {
                    undoStack[stackPtr++] = lastState;
                }
                lastState = null;
            }
            undoStack[stackPtr++] = currState;
            undoStack[stackPtr + 1] = null;
            if (callback) {
                callback();
            }
        };

        var handleCtrlYZ = function (event) {

            var handled = false;

            if (event.ctrlKey || event.metaKey) {

                // IE and Opera do not support charCode.
                var keyCode = event.charCode || event.keyCode;
                var keyCodeChar = String.fromCharCode(keyCode);

                switch (keyCodeChar) {

                    case "y":
                        undoObj.redo();
                        handled = true;
                        break;

                    case "z":
                        if (!event.shiftKey) {
                            undoObj.undo();
                        }
                        else {
                            undoObj.redo();
                        }
                        handled = true;
                        break;
                }
            }

            if (handled) {
                if (event.preventDefault) {
                    event.preventDefault();
                }
                if (window.event) {
                    window.event.returnValue = false;
                }
                return;
            }
        };

        // Set the mode depending on what is going on in the input area.
        var handleModeChange = function (event) {

            if (!event.ctrlKey && !event.metaKey) {

                var keyCode = event.keyCode;

                if ((keyCode >= 33 && keyCode <= 40) || (keyCode >= 63232 && keyCode <= 63235)) {
                    // 33 - 40: page up/dn and arrow keys
                    // 63232 - 63235: page up/dn and arrow keys on safari
                    setMode("moving");
                }
                else if (keyCode == 8 || keyCode == 46 || keyCode == 127) {
                    // 8: backspace
                    // 46: delete
                    // 127: delete
                    setMode("deleting");
                }
                else if (keyCode == 13) {
                    // 13: Enter
                    setMode("newlines");
                }
                else if (keyCode == 27) {
                    // 27: escape
                    setMode("escape");
                }
                else if ((keyCode < 16 || keyCode > 20) && keyCode != 91) {
                    // 16-20 are shift, etc. 
                    // 91: left window key
                    // I think this might be a little messed up since there are
                    // a lot of nonprinting keys above 20.
                    setMode("typing");
                }
            }
        };

        var setEventHandlers = function () {
            util.addEvent(panels.input, "keypress", function (event) {
                // keyCode 89: y
                // keyCode 90: z
                if ((event.ctrlKey || event.metaKey) && (event.keyCode == 89 || event.keyCode == 90)) {
                    event.preventDefault();
                }
            });

            var handlePaste = function () {
                if (uaSniffed.isIE || (inputStateObj && inputStateObj.text != panels.input.value)) {
                    if (timer == undefined) {
                        mode = "paste";
                        saveState();
                        refreshState();
                    }
                }
            };

            util.addEvent(panels.input, "keydown", handleCtrlYZ);
            util.addEvent(panels.input, "keydown", handleModeChange);
            util.addEvent(panels.input, "mousedown", function () {
                setMode("moving");
            });

            panels.input.onpaste = handlePaste;
            panels.input.ondrop = handlePaste;
        };

        var init = function () {
            setEventHandlers();
            refreshState(true);
            saveState();
        };

        init();
    }

    // end of UndoManager

    // The input textarea state/contents.
    // This is used to implement undo/redo by the undo manager.
    function TextareaState(panels, isInitialState) {

        // Aliases
        var stateObj = this;
        var inputArea = panels.input;
        this.init = function () {
            if (!util.isVisible(inputArea)) {
                return;
            }
            if (!isInitialState && doc.activeElement && doc.activeElement !== inputArea) { // this happens when tabbing out of the input box
                return;
            }

            this.setInputAreaSelectionStartEnd();
            this.scrollTop = inputArea.scrollTop;
            if (!this.text && inputArea.selectionStart || inputArea.selectionStart === 0) {
                this.text = inputArea.value;
            }

        }

        // Sets the selected text in the input box after we've performed an
        // operation.
        this.setInputAreaSelection = function () {

            if (!util.isVisible(inputArea)) {
                return;
            }

            if (inputArea.selectionStart !== undefined && !uaSniffed.isOpera) {

                inputArea.focus();
                inputArea.selectionStart = stateObj.start;
                inputArea.selectionEnd = stateObj.end;
                inputArea.scrollTop = stateObj.scrollTop;
            }
            else if (doc.selection) {

                if (doc.activeElement && doc.activeElement !== inputArea) {
                    return;
                }

                inputArea.focus();
                var range = inputArea.createTextRange();
                range.moveStart("character", -inputArea.value.length);
                range.moveEnd("character", -inputArea.value.length);
                range.moveEnd("character", stateObj.end);
                range.moveStart("character", stateObj.start);
                range.select();
            }
        };

        this.setInputAreaSelectionStartEnd = function () {

            if (!panels.ieCachedRange && (inputArea.selectionStart || inputArea.selectionStart === 0)) {

                stateObj.start = inputArea.selectionStart;
                stateObj.end = inputArea.selectionEnd;
            }
            else if (doc.selection) {

                stateObj.text = util.fixEolChars(inputArea.value);

                // IE loses the selection in the textarea when buttons are
                // clicked.  On IE we cache the selection. Here, if something is cached,
                // we take it.
                var range = panels.ieCachedRange || doc.selection.createRange();

                var fixedRange = util.fixEolChars(range.text);
                var marker = "\x07";
                var markedRange = marker + fixedRange + marker;
                range.text = markedRange;
                var inputText = util.fixEolChars(inputArea.value);

                range.moveStart("character", -markedRange.length);
                range.text = fixedRange;

                stateObj.start = inputText.indexOf(marker);
                stateObj.end = inputText.lastIndexOf(marker) - marker.length;

                var len = stateObj.text.length - util.fixEolChars(inputArea.value).length;

                if (len) {
                    range.moveStart("character", -fixedRange.length);
                    while (len--) {
                        fixedRange += "\n";
                        stateObj.end += 1;
                    }
                    range.text = fixedRange;
                }

                if (panels.ieCachedRange)
                    stateObj.scrollTop = panels.ieCachedScrollTop; // this is set alongside with ieCachedRange
                
                panels.ieCachedRange = null;

                this.setInputAreaSelection();
            }
        };

        // Restore this state into the input area.
        this.restore = function () {

            if (stateObj.text != undefined && stateObj.text != inputArea.value) {
                inputArea.value = stateObj.text;
            }
            this.setInputAreaSelection();
            inputArea.scrollTop = stateObj.scrollTop;
        };

        // Gets a collection of HTML chunks from the inptut textarea.
        this.getChunks = function () {

            var chunk = new Chunks();
            chunk.before = util.fixEolChars(stateObj.text.substring(0, stateObj.start));
            chunk.startTag = "";
            chunk.selection = util.fixEolChars(stateObj.text.substring(stateObj.start, stateObj.end));
            chunk.endTag = "";
            chunk.after = util.fixEolChars(stateObj.text.substring(stateObj.end));
            chunk.scrollTop = stateObj.scrollTop;

            return chunk;
        };

        // Sets the TextareaState properties given a chunk of markdown.
        this.setChunks = function (chunk) {

            chunk.before = chunk.before + chunk.startTag;
            chunk.after = chunk.endTag + chunk.after;

            this.start = chunk.before.length;
            this.end = chunk.before.length + chunk.selection.length;
            this.text = chunk.before + chunk.selection + chunk.after;
            this.scrollTop = chunk.scrollTop;
        };
        this.init();
    };

    function PreviewManager(converter, panels, previewRefreshCallback) {

        var managerObj = this;
        var timeout;
        var elapsedTime;
        var oldInputText;
        var maxDelay = 3000;
        var startType = "delayed"; // The other legal value is "manual"

        // Adds event listeners to elements
        var setupEvents = function (inputElem, listener) {

            util.addEvent(inputElem, "input", listener);
            inputElem.onpaste = listener;
            inputElem.ondrop = listener;

            util.addEvent(inputElem, "keypress", listener);
            util.addEvent(inputElem, "keydown", listener);
        };

        var getDocScrollTop = function () {

            var result = 0;

            if (window.innerHeight) {
                result = window.pageYOffset;
            }
            else
                if (doc.documentElement && doc.documentElement.scrollTop) {
                    result = doc.documentElement.scrollTop;
                }
                else
                    if (doc.body) {
                        result = doc.body.scrollTop;
                    }

            return result;
        };

        var makePreviewHtml = function () {

            // If there is no registered preview panel
            // there is nothing to do.
            if (!panels.preview)
                return;


            var text = panels.input.value;
            if (text && text == oldInputText) {
                return; // Input text hasn't changed.
            }
            else {
                oldInputText = text;
            }

            var prevTime = new Date().getTime();

            text = converter.makeHtml(text);

            // Calculate the processing time of the HTML creation.
            // It's used as the delay time in the event listener.
            var currTime = new Date().getTime();
            elapsedTime = currTime - prevTime;

            pushPreviewHtml(text);
        };

        // setTimeout is already used.  Used as an event listener.
        var applyTimeout = function () {

            if (timeout) {
                clearTimeout(timeout);
                timeout = undefined;
            }

            if (startType !== "manual") {

                var delay = 0;

                if (startType === "delayed") {
                    delay = elapsedTime;
                }

                if (delay > maxDelay) {
                    delay = maxDelay;
                }
                timeout = setTimeout(makePreviewHtml, delay);
            }
        };

        var getScaleFactor = function (panel) {
            if (panel.scrollHeight <= panel.clientHeight) {
                return 1;
            }
            return panel.scrollTop / (panel.scrollHeight - panel.clientHeight);
        };

        var setPanelScrollTops = function () {
            if (panels.preview) {
                panels.preview.scrollTop = (panels.preview.scrollHeight - panels.preview.clientHeight) * getScaleFactor(panels.preview);
            }
        };

        this.refresh = function (requiresRefresh) {

            if (requiresRefresh) {
                oldInputText = "";
                makePreviewHtml();
            }
            else {
                applyTimeout();
            }
        };

        this.processingTime = function () {
            return elapsedTime;
        };

        var isFirstTimeFilled = true;

        // IE doesn't let you use innerHTML if the element is contained somewhere in a table
        // (which is the case for inline editing) -- in that case, detach the element, set the
        // value, and reattach. Yes, that *is* ridiculous.
        var ieSafePreviewSet = function (text) {
            var preview = panels.preview;
            var parent = preview.parentNode;
            var sibling = preview.nextSibling;
            parent.removeChild(preview);
            preview.innerHTML = text;
            if (!sibling)
                parent.appendChild(preview);
            else
                parent.insertBefore(preview, sibling);
        }

        var nonSuckyBrowserPreviewSet = function (text) {
            panels.preview.innerHTML = text;
        }

        var previewSetter;

        var previewSet = function (text) {
            if (previewSetter)
                return previewSetter(text);

            try {
                nonSuckyBrowserPreviewSet(text);
                previewSetter = nonSuckyBrowserPreviewSet;
            } catch (e) {
                previewSetter = ieSafePreviewSet;
                previewSetter(text);
            }
        };

        var pushPreviewHtml = function (text) {

            var emptyTop = position.getTop(panels.input) - getDocScrollTop();

            if (panels.preview) {
                previewSet(text);
                previewRefreshCallback();
            }

            setPanelScrollTops();

            if (isFirstTimeFilled) {
                isFirstTimeFilled = false;
                return;
            }

            var fullTop = position.getTop(panels.input) - getDocScrollTop();

            if (uaSniffed.isIE) {
                setTimeout(function () {
                    window.scrollBy(0, fullTop - emptyTop);
                }, 0);
            }
            else {
                window.scrollBy(0, fullTop - emptyTop);
            }
        };

        var init = function () {

            setupEvents(panels.input, applyTimeout);
            makePreviewHtml();

            if (panels.preview) {
                panels.preview.scrollTop = 0;
            }
        };

        init();
    };

    
    // This simulates a modal dialog box and asks for the URL when you
    // click the hyperlink or image buttons.
    //
    // text: The html for the input box.
    // defaultInputText: The default value that appears in the input box.
    // callback: The function which is executed when the prompt is dismissed, either via OK or Cancel.
    //      It receives a single argument; either the entered text (if OK was chosen) or null (if Cancel
    //      was chosen).
    ui.prompt = function (title, text, defaultInputText, callback) {

        // These variables need to be declared at this level since they are used
        // in multiple functions.
        var dialog;         // The dialog box.
        var input;         // The text box where you enter the hyperlink.


        if (defaultInputText === undefined) {
            defaultInputText = "";
        }

        // Used as a keydown event handler. Esc dismisses the prompt.
        // Key code 27 is ESC.
        var checkEscape = function (key) {
            var code = (key.charCode || key.keyCode);
            if (code === 27) {
                close(true);
            }
        };

        // Dismisses the hyperlink input box.
        // isCancel is true if we don't care about the input text.
        // isCancel is false if we are going to keep the text.
        var close = function (isCancel) {
            util.removeEvent(doc.body, "keydown", checkEscape);
            var text = input.value;

            if (isCancel) {
                text = null;
            }
            else {
                // Fixes common pasting errors.
                text = text.replace(/^http:\/\/(https?|ftp):\/\//, '$1://');
                if (!/^(?:https?|ftp):\/\//.test(text))
                    text = 'http://' + text;
            }

            $(dialog).modal('hide');

            callback(text);
            return false;
        };



        // Create the text input box form/window.
        var createDialog = function () {
            
            // <div class="modal fade">
            //   <div class="modal-dialog">
            //     <div class="modal-content">
            //       <div class="modal-header">
            //         
            //         <h4 class="modal-title">Modal title</h4>
            //       </div>
            //       <div class="modal-body">
            //         <p>One fine body&hellip;</p>
            //       </div>
            //       <div class="modal-footer">
            //         <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            //         <button type="button" class="btn btn-primary">Save changes</button>
            //       </div>
            //     </div><!-- /.modal-content -->
            //   </div><!-- /.modal-dialog -->
            // </div><!-- /.modal -->

            // The main dialog box.
            dialog = doc.createElement("div");
            dialog.className = "modal hide fade";

            modal_dialog = doc.createElement("div");
            modal_dialog.className = "modal-dialog";
            dialog.appendChild(modal_dialog);

            content_dialog = doc.createElement("div");
            content_dialog.className = "modal-content";
            modal_dialog.appendChild(content_dialog);

            // The header.
            var header = doc.createElement("div");
            header.className = "modal-header";
            header.innerHTML = '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> <h4 class="modal-title">'+title+'</h4>';
            content_dialog.appendChild(header);

            // The body.
            var body = doc.createElement("div");
            body.className = "modal-body";
            content_dialog.appendChild(body);

            // The footer.
            var footer = doc.createElement("div");
            footer.className = "modal-footer";
            content_dialog.appendChild(footer);

            // The dialog text.
            var question = doc.createElement("p");
            question.innerHTML = text;
            question.style.padding = "5px";
            body.appendChild(question);

            // The web form container for the text box and buttons.
            var form = doc.createElement("form"),
                style = form.style;
            form.onsubmit = function () { return close(false); };
            style.padding = "0";
            style.margin = "0";
            body.appendChild(form);

            // The input text box
            input = doc.createElement("input");
            input.type = "text";
            input.value = defaultInputText;
            style = input.style;
            style.display = "block";
            style.width = "80%";
            style.marginLeft = style.marginRight = "auto";
            form.appendChild(input);

            // The ok button
            var okButton = doc.createElement("button");
            okButton.className = "btn btn-primary";
            okButton.type = "button";
            okButton.onclick = function () { return close(false); };
            okButton.innerHTML = "OK";

            // The cancel button
            var cancelButton = doc.createElement("button");
            cancelButton.className = "btn btn-default";
            cancelButton.type = "button";
            cancelButton.onclick = function () { return close(true); };
            cancelButton.innerHTML = "Cancel";

            footer.appendChild(okButton);
            footer.appendChild(cancelButton);

            util.addEvent(doc.body, "keydown", checkEscape);

            doc.body.appendChild(dialog);

        };

        // Why is this in a zero-length timeout?
        // Is it working around a browser bug?
        setTimeout(function () {

            createDialog();

            var defTextLen = defaultInputText.length;
            if (input.selectionStart !== undefined) {
                input.selectionStart = 0;
                input.selectionEnd = defTextLen;
            }
            else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(false);
                range.moveStart("character", -defTextLen);
                range.moveEnd("character", defTextLen);
                range.select();
            }
            
            $(dialog).on('shown', function () {
                input.focus();
            })
            
            $(dialog).on('hidden', function () {
                dialog.parentNode.removeChild(dialog);
            })

            $(dialog).modal()

        }, 0);
    };

    function UIManager(postfix, panels, undoManager, previewManager, commandManager, helpOptions) {

        var inputBox = panels.input,
            buttons = {}; // buttons.undo, buttons.link, etc. The actual DOM elements.

        makeSpritedButtonRow();

        var keyEvent = "keydown";
        if (uaSniffed.isOpera) {
            keyEvent = "keypress";
        }

        util.addEvent(inputBox, keyEvent, function (key) {

            // Check to see if we have a button key and, if so execute the callback.
            if ((key.ctrlKey || key.metaKey) && !key.altKey && !key.shiftKey) {

                var keyCode = key.charCode || key.keyCode;
                var keyCodeStr = String.fromCharCode(keyCode).toLowerCase();

                switch (keyCodeStr) {
                    case "b":
                        doClick(buttons.bold);
                        break;
                    case "i":
                        doClick(buttons.italic);
                        break;
                    case "l":
                        doClick(buttons.link);
                        break;
                    case "q":
                        doClick(buttons.quote);
                        break;
                    case "k":
                        doClick(buttons.code);
                        break;
                    case "g":
                        doClick(buttons.image);
                        break;
                    case "o":
                        doClick(buttons.olist);
                        break;
                    case "u":
                        doClick(buttons.ulist);
                        break;
                    case "h":
                        doClick(buttons.heading);
                        break;
                    case "r":
                        doClick(buttons.hr);
                        break;
                    case "y":
                        doClick(buttons.redo);
                        break;
                    case "z":
                        if (key.shiftKey) {
                            doClick(buttons.redo);
                        }
                        else {
                            doClick(buttons.undo);
                        }
                        break;
                    default:
                        return;
                }


                if (key.preventDefault) {
                    key.preventDefault();
                }

                if (window.event) {
                    window.event.returnValue = false;
                }
            }
        });

        // Auto-indent on shift-enter
        util.addEvent(inputBox, "keyup", function (key) {
            if (key.shiftKey && !key.ctrlKey && !key.metaKey) {
                var keyCode = key.charCode || key.keyCode;
                // Character 13 is Enter
                if (keyCode === 13) {
                    var fakeButton = {};
                    fakeButton.textOp = bindCommand("doAutoindent");
                    doClick(fakeButton);
                }
            }
        });

        // special handler because IE clears the context of the textbox on ESC
        if (uaSniffed.isIE) {
            util.addEvent(inputBox, "keydown", function (key) {
                var code = key.keyCode;
                if (code === 27) {
                    return false;
                }
            });
        }


        // Perform the button's action.
        function doClick(button) {

            inputBox.focus();

            if (button.textOp) {

                if (undoManager) {
                    undoManager.setCommandMode();
                }

                var state = new TextareaState(panels);

                if (!state) {
                    return;
                }

                var chunks = state.getChunks();

                // Some commands launch a "modal" prompt dialog.  Javascript
                // can't really make a modal dialog box and the WMD code
                // will continue to execute while the dialog is displayed.
                // This prevents the dialog pattern I'm used to and means
                // I can't do something like this:
                //
                // var link = CreateLinkDialog();
                // makeMarkdownLink(link);
                // 
                // Instead of this straightforward method of handling a
                // dialog I have to pass any code which would execute
                // after the dialog is dismissed (e.g. link creation)
                // in a function parameter.
                //
                // Yes this is awkward and I think it sucks, but there's
                // no real workaround.  Only the image and link code
                // create dialogs and require the function pointers.
                var fixupInputArea = function () {

                    inputBox.focus();

                    if (chunks) {
                        state.setChunks(chunks);
                    }

                    state.restore();
                    previewManager.refresh();
                };

                var noCleanup = button.textOp(chunks, fixupInputArea);

                if (!noCleanup) {
                    fixupInputArea();
                }

            }

            if (button.execute) {
                button.execute(undoManager);
            }
        };

        function setupButton(button, isEnabled) {

            if (isEnabled) {
                button.disabled = false;

                if (!button.isHelp) {
                    button.onclick = function () {
                        if (this.onmouseout) {
                            this.onmouseout();
                        }
                        doClick(this);
                        return false;
                    }
                }
            }
            else {
                button.disabled = true;
            }
        }

        function bindCommand(method) {
            if (typeof method === "string")
                method = commandManager[method];
            return function () { method.apply(commandManager, arguments); }
        }

        function makeSpritedButtonRow() {

            var buttonBar = panels.buttonBar;
            var buttonRow = document.createElement("div");
            buttonRow.id = "wmd-button-row" + postfix;
            buttonRow.className = 'btn-toolbar';
            buttonRow = buttonBar.appendChild(buttonRow);

            var makeButton = function (id, title, icon, textOp, group) {
                var button = document.createElement("button");
                button.className = "btn btn-default";
                var buttonImage = document.createElement("i");
                buttonImage.className = icon;
                button.id = id + postfix;
                button.appendChild(buttonImage);
                buttonImage.title = title;
                $(buttonImage).tooltip({placement: 'bottom'})
                if (textOp)
                    button.textOp = textOp;
                setupButton(button, true);
                if (group) {
                    group.appendChild(button);
                } else {
                    buttonRow.appendChild(button);
                }
                return button;
            };
            var makeGroup = function (num) {
                var group = document.createElement("div");
                group.className = "btn-group wmd-button-group" + num;
                group.id = "wmd-button-group" + num + postfix;
                buttonRow.appendChild(group);
                return group
            }

            group1 = makeGroup(1);
            buttons.bold = makeButton("wmd-bold-button", "Bold - Ctrl+B", "fa fa-bold", bindCommand("doBold"), group1);
            buttons.italic = makeButton("wmd-italic-button", "Italic - Ctrl+I", "fa fa-italic", bindCommand("doItalic"), group1);
            
            group2 = makeGroup(2);
            buttons.link = makeButton("wmd-link-button", "Link - Ctrl+L", "fa fa-globe", bindCommand(function (chunk, postProcessing) {
                return this.doLinkOrImage(chunk, postProcessing, false);
            }), group2);
            buttons.quote = makeButton("wmd-quote-button", "Blockquote - Ctrl+Q", "fa fa-quote-left", bindCommand("doBlockquote"), group2);
            buttons.code = makeButton("wmd-code-button", "Code Sample - Ctrl+K", "fa fa-code", bindCommand("doCode"), group2);
            buttons.image = makeButton("wmd-image-button", "Image - Ctrl+G", "fa fa-picture-o", bindCommand(function (chunk, postProcessing) {
                return this.doLinkOrImage(chunk, postProcessing, true);
            }), group2);

            group3 = makeGroup(3);
            buttons.olist = makeButton("wmd-olist-button", "Numbered List - Ctrl+O", "fa fa-list-ol", bindCommand(function (chunk, postProcessing) {
                this.doList(chunk, postProcessing, true);
            }), group3);
            buttons.ulist = makeButton("wmd-ulist-button", "Bulleted List - Ctrl+U", "fa fa-list-ul", bindCommand(function (chunk, postProcessing) {
                this.doList(chunk, postProcessing, false);
            }), group3);
            buttons.heading = makeButton("wmd-heading-button", "Heading - Ctrl+H", "icon-header", bindCommand("doHeading"), group3);
            buttons.hr = makeButton("wmd-hr-button", "Horizontal Rule - Ctrl+R", "icon-hr-line", bindCommand("doHorizontalRule"), group3);
            
            group4 = makeGroup(4);
            buttons.undo = makeButton("wmd-undo-button", "Undo - Ctrl+Z", "fa fa-undo", null, group4);
            buttons.undo.execute = function (manager) { if (manager) manager.undo(); };

            var redoTitle = /win/.test(nav.platform.toLowerCase()) ?
                "Redo - Ctrl+Y" :
                "Redo - Ctrl+Shift+Z"; // mac and other non-Windows platforms

            buttons.redo = makeButton("wmd-redo-button", redoTitle, "fa fa-repeat", null, group4);
            buttons.redo.execute = function (manager) { if (manager) manager.redo(); };

            if (helpOptions) {
                group5 = makeGroup(5);
                group5.className = group5.className + " pull-right";
                var helpButton = document.createElement("button");
                var helpButtonImage = document.createElement("i");
                helpButtonImage.className = "fa fa-question-circle";
                helpButton.appendChild(helpButtonImage);
                helpButton.className = "btn btn-default";
                helpButton.id = "wmd-help-button" + postfix;
                helpButton.isHelp = true;
                helpButton.title = helpOptions.title || defaultHelpHoverTitle;
                $(helpButton).tooltip({placement: 'bottom'})
                helpButton.onclick = helpOptions.handler;

                setupButton(helpButton, true);
                group5.appendChild(helpButton);
                buttons.help = helpButton;
            }

            setUndoRedoButtonStates();
        }

        function setUndoRedoButtonStates() {
            if (undoManager) {
                setupButton(buttons.undo, undoManager.canUndo());
                setupButton(buttons.redo, undoManager.canRedo());
            }
        };

        this.setUndoRedoButtonStates = setUndoRedoButtonStates;

    }

    function CommandManager(pluginHooks) {
        this.hooks = pluginHooks;
    }

    var commandProto = CommandManager.prototype;

    // The markdown symbols - 4 spaces = code, > = blockquote, etc.
    commandProto.prefixes = "(?:\\s{4,}|\\s*>|\\s*-\\s+|\\s*\\d+\\.|=|\\+|-|_|\\*|#|\\s*\\[[^\n]]+\\]:)";

    // Remove markdown symbols from the chunk selection.
    commandProto.unwrap = function (chunk) {
        var txt = new re("([^\\n])\\n(?!(\\n|" + this.prefixes + "))", "g");
        chunk.selection = chunk.selection.replace(txt, "$1 $2");
    };

    commandProto.wrap = function (chunk, len) {
        this.unwrap(chunk);
        var regex = new re("(.{1," + len + "})( +|$\\n?)", "gm"),
            that = this;

        chunk.selection = chunk.selection.replace(regex, function (line, marked) {
            if (new re("^" + that.prefixes, "").test(line)) {
                return line;
            }
            return marked + "\n";
        });

        chunk.selection = chunk.selection.replace(/\s+$/, "");
    };

    commandProto.doBold = function (chunk, postProcessing) {
        return this.doBorI(chunk, postProcessing, 2, "strong text");
    };

    commandProto.doItalic = function (chunk, postProcessing) {
        return this.doBorI(chunk, postProcessing, 1, "emphasized text");
    };

    // chunk: The selected region that will be enclosed with */**
    // nStars: 1 for italics, 2 for bold
    // insertText: If you just click the button without highlighting text, this gets inserted
    commandProto.doBorI = function (chunk, postProcessing, nStars, insertText) {

        // Get rid of whitespace and fixup newlines.
        chunk.trimWhitespace();
        chunk.selection = chunk.selection.replace(/\n{2,}/g, "\n");

        // Look for stars before and after.  Is the chunk already marked up?
        // note that these regex matches cannot fail
        var starsBefore = /(\**$)/.exec(chunk.before)[0];
        var starsAfter = /(^\**)/.exec(chunk.after)[0];

        var prevStars = Math.min(starsBefore.length, starsAfter.length);

        // Remove stars if we have to since the button acts as a toggle.
        if ((prevStars >= nStars) && (prevStars != 2 || nStars != 1)) {
            chunk.before = chunk.before.replace(re("[*]{" + nStars + "}$", ""), "");
            chunk.after = chunk.after.replace(re("^[*]{" + nStars + "}", ""), "");
        }
        else if (!chunk.selection && starsAfter) {
            // It's not really clear why this code is necessary.  It just moves
            // some arbitrary stuff around.
            chunk.after = chunk.after.replace(/^([*_]*)/, "");
            chunk.before = chunk.before.replace(/(\s?)$/, "");
            var whitespace = re.$1;
            chunk.before = chunk.before + starsAfter + whitespace;
        }
        else {

            // In most cases, if you don't have any selected text and click the button
            // you'll get a selected, marked up region with the default text inserted.
            if (!chunk.selection && !starsAfter) {
                chunk.selection = insertText;
            }

            // Add the true markup.
            var markup = nStars <= 1 ? "*" : "**"; // shouldn't the test be = ?
            chunk.before = chunk.before + markup;
            chunk.after = markup + chunk.after;
        }

        return;
    };

    commandProto.stripLinkDefs = function (text, defsToAdd) {

        text = text.replace(/^[ ]{0,3}\[(\d+)\]:[ \t]*\n?[ \t]*<?(\S+?)>?[ \t]*\n?[ \t]*(?:(\n*)["(](.+?)[")][ \t]*)?(?:\n+|$)/gm,
            function (totalMatch, id, link, newlines, title) {
                defsToAdd[id] = totalMatch.replace(/\s*$/, "");
                if (newlines) {
                    // Strip the title and return that separately.
                    defsToAdd[id] = totalMatch.replace(/["(](.+?)[")]$/, "");
                    return newlines + title;
                }
                return "";
            });

        return text;
    };

    commandProto.addLinkDef = function (chunk, linkDef) {

        var refNumber = 0; // The current reference number
        var defsToAdd = {}; //
        // Start with a clean slate by removing all previous link definitions.
        chunk.before = this.stripLinkDefs(chunk.before, defsToAdd);
        chunk.selection = this.stripLinkDefs(chunk.selection, defsToAdd);
        chunk.after = this.stripLinkDefs(chunk.after, defsToAdd);

        var defs = "";
        var regex = /(\[)((?:\[[^\]]*\]|[^\[\]])*)(\][ ]?(?:\n[ ]*)?\[)(\d+)(\])/g;

        var addDefNumber = function (def) {
            refNumber++;
            def = def.replace(/^[ ]{0,3}\[(\d+)\]:/, "  [" + refNumber + "]:");
            defs += "\n" + def;
        };

        // note that
        // a) the recursive call to getLink cannot go infinite, because by definition
        //    of regex, inner is always a proper substring of wholeMatch, and
        // b) more than one level of nesting is neither supported by the regex
        //    nor making a lot of sense (the only use case for nesting is a linked image)
        var getLink = function (wholeMatch, before, inner, afterInner, id, end) {
            inner = inner.replace(regex, getLink);
            if (defsToAdd[id]) {
                addDefNumber(defsToAdd[id]);
                return before + inner + afterInner + refNumber + end;
            }
            return wholeMatch;
        };

        chunk.before = chunk.before.replace(regex, getLink);

        if (linkDef) {
            addDefNumber(linkDef);
        }
        else {
            chunk.selection = chunk.selection.replace(regex, getLink);
        }

        var refOut = refNumber;

        chunk.after = chunk.after.replace(regex, getLink);

        if (chunk.after) {
            chunk.after = chunk.after.replace(/\n*$/, "");
        }
        if (!chunk.after) {
            chunk.selection = chunk.selection.replace(/\n*$/, "");
        }

        chunk.after += "\n\n" + defs;

        return refOut;
    };

    // takes the line as entered into the add link/as image dialog and makes
    // sure the URL and the optinal title are "nice".
    function properlyEncoded(linkdef) {
        return linkdef.replace(/^\s*(.*?)(?:\s+"(.+)")?\s*$/, function (wholematch, link, title) {
            link = link.replace(/\?.*$/, function (querypart) {
                return querypart.replace(/\+/g, " "); // in the query string, a plus and a space are identical
            });
            link = decodeURIComponent(link); // unencode first, to prevent double encoding
            link = encodeURI(link).replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29');
            link = link.replace(/\?.*$/, function (querypart) {
                return querypart.replace(/\+/g, "%2b"); // since we replaced plus with spaces in the query part, all pluses that now appear where originally encoded
            });
            if (title) {
                title = title.trim ? title.trim() : title.replace(/^\s*/, "").replace(/\s*$/, "");
                title = $.trim(title).replace(/"/g, "quot;").replace(/\(/g, "&#40;").replace(/\)/g, "&#41;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            }
            return title ? link + ' "' + title + '"' : link;
        });
    }

    commandProto.doLinkOrImage = function (chunk, postProcessing, isImage) {

        chunk.trimWhitespace();
        chunk.findTags(/\s*!?\[/, /\][ ]?(?:\n[ ]*)?(\[.*?\])?/);
        var background;

        if (chunk.endTag.length > 1 && chunk.startTag.length > 0) {

            chunk.startTag = chunk.startTag.replace(/!?\[/, "");
            chunk.endTag = "";
            this.addLinkDef(chunk, null);

        }
        else {
            
            // We're moving start and end tag back into the selection, since (as we're in the else block) we're not
            // *removing* a link, but *adding* one, so whatever findTags() found is now back to being part of the
            // link text. linkEnteredCallback takes care of escaping any brackets.
            chunk.selection = chunk.startTag + chunk.selection + chunk.endTag;
            chunk.startTag = chunk.endTag = "";

            if (/\n\n/.test(chunk.selection)) {
                this.addLinkDef(chunk, null);
                return;
            }
            var that = this;
            // The function to be executed when you enter a link and press OK or Cancel.
            // Marks up the link and adds the ref.
            var linkEnteredCallback = function (link) {

                if (link !== null) {
                    // (                          $1
                    //     [^\\]                  anything that's not a backslash
                    //     (?:\\\\)*              an even number (this includes zero) of backslashes
                    // )
                    // (?=                        followed by
                    //     [[\]]                  an opening or closing bracket
                    // )
                    //
                    // In other words, a non-escaped bracket. These have to be escaped now to make sure they
                    // don't count as the end of the link or similar.
                    // Note that the actual bracket has to be a lookahead, because (in case of to subsequent brackets),
                    // the bracket in one match may be the "not a backslash" character in the next match, so it
                    // should not be consumed by the first match.
                    // The "prepend a space and finally remove it" steps makes sure there is a "not a backslash" at the
                    // start of the string, so this also works if the selection begins with a bracket. We cannot solve
                    // this by anchoring with ^, because in the case that the selection starts with two brackets, this
                    // would mean a zero-width match at the start. Since zero-width matches advance the string position,
                    // the first bracket could then not act as the "not a backslash" for the second.
                    chunk.selection = (" " + chunk.selection).replace(/([^\\](?:\\\\)*)(?=[[\]])/g, "$1\\").substr(1);
                    
                    var linkDef = " [999]: " + properlyEncoded(link);

                    var num = that.addLinkDef(chunk, linkDef);
                    chunk.startTag = isImage ? "![" : "[";
                    chunk.endTag = "][" + num + "]";

                    if (!chunk.selection) {
                        if (isImage) {
                            chunk.selection = "enter image description here";
                        }
                        else {
                            chunk.selection = "enter link description here";
                        }
                    }
                }
                postProcessing();
            };


            if (isImage) {
                if (!this.hooks.insertImageDialog(linkEnteredCallback))
                    ui.prompt('Insert Image', imageDialogText, imageDefaultText, linkEnteredCallback);
            }
            else {
                ui.prompt('Insert Link', linkDialogText, linkDefaultText, linkEnteredCallback);
            }
            return true;
        }
    };

    // When making a list, hitting shift-enter will put your cursor on the next line
    // at the current indent level.
    commandProto.doAutoindent = function (chunk, postProcessing) {

        var commandMgr = this,
            fakeSelection = false;

        chunk.before = chunk.before.replace(/(\n|^)[ ]{0,3}([*+-]|\d+[.])[ \t]*\n$/, "\n\n");
        chunk.before = chunk.before.replace(/(\n|^)[ ]{0,3}>[ \t]*\n$/, "\n\n");
        chunk.before = chunk.before.replace(/(\n|^)[ \t]+\n$/, "\n\n");
        
        // There's no selection, end the cursor wasn't at the end of the line:
        // The user wants to split the current list item / code line / blockquote line
        // (for the latter it doesn't really matter) in two. Temporarily select the
        // (rest of the) line to achieve this.
        if (!chunk.selection && !/^[ \t]*(?:\n|$)/.test(chunk.after)) {
            chunk.after = chunk.after.replace(/^[^\n]*/, function (wholeMatch) {
                chunk.selection = wholeMatch;
                return "";
            });
            fakeSelection = true;
        }

        if (/(\n|^)[ ]{0,3}([*+-]|\d+[.])[ \t]+.*\n$/.test(chunk.before)) {
            if (commandMgr.doList) {
                commandMgr.doList(chunk);
            }
        }
        if (/(\n|^)[ ]{0,3}>[ \t]+.*\n$/.test(chunk.before)) {
            if (commandMgr.doBlockquote) {
                commandMgr.doBlockquote(chunk);
            }
        }
        if (/(\n|^)(\t|[ ]{4,}).*\n$/.test(chunk.before)) {
            if (commandMgr.doCode) {
                commandMgr.doCode(chunk);
            }
        }
        
        if (fakeSelection) {
            chunk.after = chunk.selection + chunk.after;
            chunk.selection = "";
        }
    };

    commandProto.doBlockquote = function (chunk, postProcessing) {

        chunk.selection = chunk.selection.replace(/^(\n*)([^\r]+?)(\n*)$/,
            function (totalMatch, newlinesBefore, text, newlinesAfter) {
                chunk.before += newlinesBefore;
                chunk.after = newlinesAfter + chunk.after;
                return text;
            });

        chunk.before = chunk.before.replace(/(>[ \t]*)$/,
            function (totalMatch, blankLine) {
                chunk.selection = blankLine + chunk.selection;
                return "";
            });

        chunk.selection = chunk.selection.replace(/^(\s|>)+$/, "");
        chunk.selection = chunk.selection || "Blockquote";

        // The original code uses a regular expression to find out how much of the
        // text *directly before* the selection already was a blockquote:

        /*
        if (chunk.before) {
        chunk.before = chunk.before.replace(/\n?$/, "\n");
        }
        chunk.before = chunk.before.replace(/(((\n|^)(\n[ \t]*)*>(.+\n)*.*)+(\n[ \t]*)*$)/,
        function (totalMatch) {
        chunk.startTag = totalMatch;
        return "";
        });
        */

        // This comes down to:
        // Go backwards as many lines a possible, such that each line
        //  a) starts with ">", or
        //  b) is almost empty, except for whitespace, or
        //  c) is preceeded by an unbroken chain of non-empty lines
        //     leading up to a line that starts with ">" and at least one more character
        // and in addition
        //  d) at least one line fulfills a)
        //
        // Since this is essentially a backwards-moving regex, it's susceptible to
        // catstrophic backtracking and can cause the browser to hang;
        // see e.g. http://meta.stackoverflow.com/questions/9807.
        //
        // Hence we replaced this by a simple state machine that just goes through the
        // lines and checks for a), b), and c).

        var match = "",
            leftOver = "",
            line;
        if (chunk.before) {
            var lines = chunk.before.replace(/\n$/, "").split("\n");
            var inChain = false;
            for (var i = 0; i < lines.length; i++) {
                var good = false;
                line = lines[i];
                inChain = inChain && line.length > 0; // c) any non-empty line continues the chain
                if (/^>/.test(line)) {                // a)
                    good = true;
                    if (!inChain && line.length > 1)  // c) any line that starts with ">" and has at least one more character starts the chain
                        inChain = true;
                } else if (/^[ \t]*$/.test(line)) {   // b)
                    good = true;
                } else {
                    good = inChain;                   // c) the line is not empty and does not start with ">", so it matches if and only if we're in the chain
                }
                if (good) {
                    match += line + "\n";
                } else {
                    leftOver += match + line;
                    match = "\n";
                }
            }
            if (!/(^|\n)>/.test(match)) {             // d)
                leftOver += match;
                match = "";
            }
        }

        chunk.startTag = match;
        chunk.before = leftOver;

        // end of change

        if (chunk.after) {
            chunk.after = chunk.after.replace(/^\n?/, "\n");
        }

        chunk.after = chunk.after.replace(/^(((\n|^)(\n[ \t]*)*>(.+\n)*.*)+(\n[ \t]*)*)/,
            function (totalMatch) {
                chunk.endTag = totalMatch;
                return "";
            }
        );

        var replaceBlanksInTags = function (useBracket) {

            var replacement = useBracket ? "> " : "";

            if (chunk.startTag) {
                chunk.startTag = chunk.startTag.replace(/\n((>|\s)*)\n$/,
                    function (totalMatch, markdown) {
                        return "\n" + markdown.replace(/^[ ]{0,3}>?[ \t]*$/gm, replacement) + "\n";
                    });
            }
            if (chunk.endTag) {
                chunk.endTag = chunk.endTag.replace(/^\n((>|\s)*)\n/,
                    function (totalMatch, markdown) {
                        return "\n" + markdown.replace(/^[ ]{0,3}>?[ \t]*$/gm, replacement) + "\n";
                    });
            }
        };

        if (/^(?![ ]{0,3}>)/m.test(chunk.selection)) {
            this.wrap(chunk, SETTINGS.lineLength - 2);
            chunk.selection = chunk.selection.replace(/^/gm, "> ");
            replaceBlanksInTags(true);
            chunk.skipLines();
        } else {
            chunk.selection = chunk.selection.replace(/^[ ]{0,3}> ?/gm, "");
            this.unwrap(chunk);
            replaceBlanksInTags(false);

            if (!/^(\n|^)[ ]{0,3}>/.test(chunk.selection) && chunk.startTag) {
                chunk.startTag = chunk.startTag.replace(/\n{0,2}$/, "\n\n");
            }

            if (!/(\n|^)[ ]{0,3}>.*$/.test(chunk.selection) && chunk.endTag) {
                chunk.endTag = chunk.endTag.replace(/^\n{0,2}/, "\n\n");
            }
        }

        chunk.selection = this.hooks.postBlockquoteCreation(chunk.selection);

        if (!/\n/.test(chunk.selection)) {
            chunk.selection = chunk.selection.replace(/^(> *)/,
            function (wholeMatch, blanks) {
                chunk.startTag += blanks;
                return "";
            });
        }
    };

    commandProto.doCode = function (chunk, postProcessing) {

        var hasTextBefore = /\S[ ]*$/.test(chunk.before);
        var hasTextAfter = /^[ ]*\S/.test(chunk.after);

        // Use 'four space' markdown if the selection is on its own
        // line or is multiline.
        if ((!hasTextAfter && !hasTextBefore) || /\n/.test(chunk.selection)) {

            chunk.before = chunk.before.replace(/[ ]{4}$/,
                function (totalMatch) {
                    chunk.selection = totalMatch + chunk.selection;
                    return "";
                });

            var nLinesBack = 1;
            var nLinesForward = 1;

            if (/(\n|^)(\t|[ ]{4,}).*\n$/.test(chunk.before)) {
                nLinesBack = 0;
            }
            if (/^\n(\t|[ ]{4,})/.test(chunk.after)) {
                nLinesForward = 0;
            }

            chunk.skipLines(nLinesBack, nLinesForward);

            if (!chunk.selection) {
                chunk.startTag = "    ";
                chunk.selection = "enter code here";
            }
            else {
                if (/^[ ]{0,3}\S/m.test(chunk.selection)) {
                    if (/\n/.test(chunk.selection))
                        chunk.selection = chunk.selection.replace(/^/gm, "    ");
                    else // if it's not multiline, do not select the four added spaces; this is more consistent with the doList behavior
                        chunk.before += "    ";
                }
                else {
                    chunk.selection = chunk.selection.replace(/^[ ]{4}/gm, "");
                }
            }
        }
        else {
            // Use backticks (`) to delimit the code block.

            chunk.trimWhitespace();
            chunk.findTags(/`/, /`/);

            if (!chunk.startTag && !chunk.endTag) {
                chunk.startTag = chunk.endTag = "`";
                if (!chunk.selection) {
                    chunk.selection = "enter code here";
                }
            }
            else if (chunk.endTag && !chunk.startTag) {
                chunk.before += chunk.endTag;
                chunk.endTag = "";
            }
            else {
                chunk.startTag = chunk.endTag = "";
            }
        }
    };

    commandProto.doList = function (chunk, postProcessing, isNumberedList) {

        // These are identical except at the very beginning and end.
        // Should probably use the regex extension function to make this clearer.
        var previousItemsRegex = /(\n|^)(([ ]{0,3}([*+-]|\d+[.])[ \t]+.*)(\n.+|\n{2,}([*+-].*|\d+[.])[ \t]+.*|\n{2,}[ \t]+\S.*)*)\n*$/;
        var nextItemsRegex = /^\n*(([ ]{0,3}([*+-]|\d+[.])[ \t]+.*)(\n.+|\n{2,}([*+-].*|\d+[.])[ \t]+.*|\n{2,}[ \t]+\S.*)*)\n*/;

        // The default bullet is a dash but others are possible.
        // This has nothing to do with the particular HTML bullet,
        // it's just a markdown bullet.
        var bullet = "-";

        // The number in a numbered list.
        var num = 1;

        // Get the item prefix - e.g. " 1. " for a numbered list, " - " for a bulleted list.
        var getItemPrefix = function () {
            var prefix;
            if (isNumberedList) {
                prefix = " " + num + ". ";
                num++;
            }
            else {
                prefix = " " + bullet + " ";
            }
            return prefix;
        };

        // Fixes the prefixes of the other list items.
        var getPrefixedItem = function (itemText) {

            // The numbering flag is unset when called by autoindent.
            if (isNumberedList === undefined) {
                isNumberedList = /^\s*\d/.test(itemText);
            }

            // Renumber/bullet the list element.
            itemText = itemText.replace(/^[ ]{0,3}([*+-]|\d+[.])\s/gm,
                function (_) {
                    return getItemPrefix();
                });

            return itemText;
        };

        chunk.findTags(/(\n|^)*[ ]{0,3}([*+-]|\d+[.])\s+/, null);

        if (chunk.before && !/\n$/.test(chunk.before) && !/^\n/.test(chunk.startTag)) {
            chunk.before += chunk.startTag;
            chunk.startTag = "";
        }

        if (chunk.startTag) {

            var hasDigits = /\d+[.]/.test(chunk.startTag);
            chunk.startTag = "";
            chunk.selection = chunk.selection.replace(/\n[ ]{4}/g, "\n");
            this.unwrap(chunk);
            chunk.skipLines();

            if (hasDigits) {
                // Have to renumber the bullet points if this is a numbered list.
                chunk.after = chunk.after.replace(nextItemsRegex, getPrefixedItem);
            }
            if (isNumberedList == hasDigits) {
                return;
            }
        }

        var nLinesUp = 1;

        chunk.before = chunk.before.replace(previousItemsRegex,
            function (itemText) {
                if (/^\s*([*+-])/.test(itemText)) {
                    bullet = re.$1;
                }
                nLinesUp = /[^\n]\n\n[^\n]/.test(itemText) ? 1 : 0;
                return getPrefixedItem(itemText);
            });

        if (!chunk.selection) {
            chunk.selection = "List item";
        }

        var prefix = getItemPrefix();

        var nLinesDown = 1;

        chunk.after = chunk.after.replace(nextItemsRegex,
            function (itemText) {
                nLinesDown = /[^\n]\n\n[^\n]/.test(itemText) ? 1 : 0;
                return getPrefixedItem(itemText);
            });

        chunk.trimWhitespace(true);
        chunk.skipLines(nLinesUp, nLinesDown, true);
        chunk.startTag = prefix;
        var spaces = prefix.replace(/./g, " ");
        this.wrap(chunk, SETTINGS.lineLength - spaces.length);
        chunk.selection = chunk.selection.replace(/\n/g, "\n" + spaces);

    };

    commandProto.doHeading = function (chunk, postProcessing) {

        // Remove leading/trailing whitespace and reduce internal spaces to single spaces.
        chunk.selection = chunk.selection.replace(/\s+/g, " ");
        chunk.selection = chunk.selection.replace(/(^\s+|\s+$)/g, "");

        // If we clicked the button with no selected text, we just
        // make a level 2 hash header around some default text.
        if (!chunk.selection) {
            chunk.startTag = "## ";
            chunk.selection = "Heading";
            chunk.endTag = " ##";
            return;
        }

        var headerLevel = 0;     // The existing header level of the selected text.

        // Remove any existing hash heading markdown and save the header level.
        chunk.findTags(/#+[ ]*/, /[ ]*#+/);
        if (/#+/.test(chunk.startTag)) {
            headerLevel = re.lastMatch.length;
        }
        chunk.startTag = chunk.endTag = "";

        // Try to get the current header level by looking for - and = in the line
        // below the selection.
        chunk.findTags(null, /\s?(-+|=+)/);
        if (/=+/.test(chunk.endTag)) {
            headerLevel = 1;
        }
        if (/-+/.test(chunk.endTag)) {
            headerLevel = 2;
        }

        // Skip to the next line so we can create the header markdown.
        chunk.startTag = chunk.endTag = "";
        chunk.skipLines(1, 1);

        // We make a level 2 header if there is no current header.
        // If there is a header level, we substract one from the header level.
        // If it's already a level 1 header, it's removed.
        var headerLevelToCreate = headerLevel == 0 ? 2 : headerLevel - 1;

        if (headerLevelToCreate > 0) {

            // The button only creates level 1 and 2 underline headers.
            // Why not have it iterate over hash header levels?  Wouldn't that be easier and cleaner?
            var headerChar = headerLevelToCreate >= 2 ? "-" : "=";
            var len = chunk.selection.length;
            if (len > SETTINGS.lineLength) {
                len = SETTINGS.lineLength;
            }
            chunk.endTag = "\n";
            while (len--) {
                chunk.endTag += headerChar;
            }
        }
    };

    commandProto.doHorizontalRule = function (chunk, postProcessing) {
        chunk.startTag = "----------\n";
        chunk.selection = "";
        chunk.skipLines(2, 1, true);
    }


})();

},{}],"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Sanitizer.js":[function(require,module,exports){
(function () {
    var output, Converter;
    if (typeof exports === "object" && typeof require === "function") { // we're in a CommonJS (e.g. Node.js) module
        output = exports;
        Converter = require("./Markdown.Converter").Converter;
    } else {
        output = window.Markdown;
        Converter = output.Converter;
    }
        
    output.getSanitizingConverter = function () {
        var converter = new Converter();
        converter.hooks.chain("postConversion", sanitizeHtml);
        converter.hooks.chain("postConversion", balanceTags);
        return converter;
    }

    function sanitizeHtml(html) {
        return html.replace(/<[^>]*>?/gi, sanitizeTag);
    }

    // (tags that can be opened/closed) | (tags that stand alone)
    var basic_tag_whitelist = /^(<\/?(b|blockquote|code|del|dd|dl|dt|em|h1|h2|h3|i|kbd|li|ol|p|s|sup|sub|strong|strike|ul)>|<(br|hr)\s?\/?>)$/i;
    // <a href="url..." optional title>|</a>
    var a_white = /^(<a\shref="(https?:(\/\/|\/)|ftp:(\/\/|\/)|mailto:|magnet:)[-A-Za-z0-9+&@#\/%?=~_|!:,.;\(\)]+"(\stitle="[^"<>]+")?\s?>|<\/a>)$/i;

    // <img src="url..." optional width  optional height  optional alt  optional title
    var img_white = /^(<img\ssrc="(https?:\/\/|\/)[-A-Za-z0-9+&@#\/%?=~_|!:,.;\(\)]+"(\swidth="\d{1,3}")?(\sheight="\d{1,3}")?(\salt="[^"<>]*")?(\stitle="[^"<>]*")?\s?\/?>)$/i;

    // <pre optional class="prettyprint linenums">|</pre> for twitter bootstrap
    var pre_white = /^(<pre(\sclass="prettyprint linenums")?>|<\/pre>)$/i;

    function sanitizeTag(tag) {
        if (tag.match(basic_tag_whitelist) || tag.match(a_white) || tag.match(img_white) || tag.match(pre_white))
            return tag;
        else
            return "";
    }

    /// <summary>
    /// attempt to balance HTML tags in the html string
    /// by removing any unmatched opening or closing tags
    /// IMPORTANT: we *assume* HTML has *already* been 
    /// sanitized and is safe/sane before balancing!
    /// 
    /// adapted from CODESNIPPET: A8591DBA-D1D3-11DE-947C-BA5556D89593
    /// </summary>
    function balanceTags(html) {

        if (html == "")
            return "";

        var re = /<\/?\w+[^>]*(\s|$|>)/g;
        // convert everything to lower case; this makes
        // our case insensitive comparisons easier
        var tags = html.toLowerCase().match(re);

        // no HTML tags present? nothing to do; exit now
        var tagcount = (tags || []).length;
        if (tagcount == 0)
            return html;

        var tagname, tag;
        var ignoredtags = "<p><img><br><li><hr>";
        var match;
        var tagpaired = [];
        var tagremove = [];
        var needsRemoval = false;

        // loop through matched tags in forward order
        for (var ctag = 0; ctag < tagcount; ctag++) {
            tagname = tags[ctag].replace(/<\/?(\w+).*/, "$1");
            // skip any already paired tags
            // and skip tags in our ignore list; assume they're self-closed
            if (tagpaired[ctag] || ignoredtags.search("<" + tagname + ">") > -1)
                continue;

            tag = tags[ctag];
            match = -1;

            if (!/^<\//.test(tag)) {
                // this is an opening tag
                // search forwards (next tags), look for closing tags
                for (var ntag = ctag + 1; ntag < tagcount; ntag++) {
                    if (!tagpaired[ntag] && tags[ntag] == "</" + tagname + ">") {
                        match = ntag;
                        break;
                    }
                }
            }

            if (match == -1)
                needsRemoval = tagremove[ctag] = true; // mark for removal
            else
                tagpaired[match] = true; // mark paired
        }

        if (!needsRemoval)
            return html;

        // delete all orphaned tags from the string

        var ctag = 0;
        html = html.replace(re, function (match) {
            var res = tagremove[ctag] ? "" : match;
            ctag++;
            return res;
        });
        return html;
    }
})();

},{"./Markdown.Converter":"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Converter.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter-regex/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js"][0].apply(exports,arguments)
},{"./xregexp":"/usr/var/server.base/node_modules/syntaxhighlighter-regex/xregexp.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter-regex/xregexp.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/xregexp.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/brush-base/brush-base.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/brush-base.js"][0].apply(exports,arguments)
},{"syntaxhighlighter-html-renderer":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-html-renderer/index.js","syntaxhighlighter-match":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/index.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/opts-parser/opts-parser.js":[function(require,module,exports){
var XRegExp = require('syntaxhighlighter-regex').XRegExp;

var BOOLEANS = {'true': true, 'false': false};

function camelize(key)
{
  return key.replace(/-(\w+)/g, function(match, word)
  {
    return word.charAt(0).toUpperCase() + word.substr(1);
  });
}

function process(value)
{
  var result = BOOLEANS[value];
  return result == null ? value : result;
}

module.exports = {
  defaults: function(target, source)
  {
    for(var key in source || {})
      if (!target.hasOwnProperty(key))
        target[key] = target[camelize(key)] = source[key];

    return target;
  },

  parse: function(str)
  {
    var match,
        key,
        result = {},
        arrayRegex = XRegExp("^\\[(?<values>(.*?))\\]$"),
        pos = 0,
        regex = XRegExp(
          "(?<name>[\\w-]+)" +
          "\\s*:\\s*" +
          "(?<value>" +
            "[\\w%#-]+|" +    // word
            "\\[.*?\\]|" +    // [] array
            '".*?"|' +        // "" string
            "'.*?'" +         // '' string
          ")\\s*;?",
          "g"
        )
        ;

    while ((match = XRegExp.exec(str, regex, pos)) != null)
    {
      var value = match.value
        .replace(/^['"]|['"]$/g, '') // strip quotes from end of strings
        ;

      // try to parse array value
      if (value != null && arrayRegex.test(value))
      {
        var m = XRegExp.exec(value, arrayRegex);
        value = m.values.length > 0 ? m.values.split(/\s*,\s*/) : [];
      }

      value = process(value);
      result[match.name] = result[camelize(match.name)] = value;
      pos = match.index + match[0].length;
    }

    return result;
  }
};

},{"syntaxhighlighter-regex":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/retabber/retabber.js":[function(require,module,exports){
var spaces = '';

// Create a string with 1000 spaces to copy spaces from...
// It's assumed that there would be no indentation longer than that.
for (var i = 0; i < 50; i++)
  spaces += '                    '; // 20 spaces * 50

// This function inserts specified amount of spaces in the string
// where a tab is while removing that given tab.
function insertSpaces(line, pos, count)
{
  return line.substr(0, pos)
    + spaces.substr(0, count)
    + line.substr(pos + 1, line.length) // pos + 1 will get rid of the tab
    ;
}

module.exports = {
  smart: function(code, tabSize)
  {
    var lines = code.split(/\r?\n/),
        tab = '\t',
        line,
        pos,
        i,
        l
        ;

    // Go through all the lines and do the 'smart tabs' magic.
    for (i = 0, l = lines.length; i < l; i++)
    {
      line = lines[i];

      if (line.indexOf(tab) === -1)
        continue;

      pos = 0;

      while ((pos = line.indexOf(tab)) !== -1)
      {
        // This is pretty much all there is to the 'smart tabs' logic.
        // Based on the position within the line and size of a tab,
        // calculate the amount of spaces we need to insert.
        line = insertSpaces(line, pos, tabSize - pos % tabSize);
      }

      lines[i] = line;
    }

    return lines.join('\n');
  },

  regular: function(code, tabSize)
  {
    return code.replace(/\t/g, spaces.substr(0, tabSize));
  }
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-html-renderer/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-html-renderer/index.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/index.js"][0].apply(exports,arguments)
},{"./lib/apply-regex-list":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js","./lib/match":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/match.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/apply-regex-list.js"][0].apply(exports,arguments)
},{"./matches":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/matches.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/match.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/match.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/matches.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-match/lib/matches.js"][0].apply(exports,arguments)
},{"./match":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/lib/match.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/index.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/index.js"][0].apply(exports,arguments)
},{"./xregexp":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/xregexp.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/xregexp.js":[function(require,module,exports){
arguments[4]["/usr/var/server.base/node_modules/brush-base/node_modules/syntaxhighlighter-regex/xregexp.js"][0].apply(exports,arguments)
},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/unindenter/unindenter.js":[function(require,module,exports){
function isEmpty(str)
{
  return /^\s*$/.test(str);
}

module.exports = {
  unindent: function(code)
  {
    var lines = code.split(/\r?\n/),
        regex = /^\s*/,
        min = 1000,
        line,
        matches,
        i,
        l
        ;

    // go through every line and check for common number of indents
    for (i = 0, l = lines.length; i < l && min > 0; i++)
    {
      line = lines[i];

      if (isEmpty(line))
        continue;

      matches = regex.exec(line);

      // In the event that just one line doesn't have leading white space
      // we can't unindent anything, so bail completely.
      if (matches == null)
        return code;

      min = Math.min(matches[0].length, min);
    }

    // trim minimum common number of white space from the begining of every line
    if (min > 0)
      for (i = 0, l = lines.length; i < l; i++)
        if (!isEmpty(lines[i]))
          lines[i] = lines[i].substr(min);

    return lines.join('\n');
  }
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/config.js":[function(require,module,exports){
'use strict';

module.exports = {
  space: '&nbsp;',

  /** Enables use of <SCRIPT type="syntaxhighlighter" /> tags. */
  useScriptTags: true,

  /** Blogger mode flag. */
  bloggerMode: false,

  stripBrs: false,

  /** Name of the tag that SyntaxHighlighter will automatically look for. */
  tagName: 'pre'
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/core.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var optsParser = require('opts-parser'),
    match = require('syntaxhighlighter-match'),
    Renderer = require('syntaxhighlighter-html-renderer').default,
    utils = require('./utils'),
    transformers = require('./transformers'),
    dom = require('./dom'),
    config = require('./config'),
    defaults = require('./defaults'),
    HtmlScript = require('./html_script');

var sh = {
  Match: match.Match,
  Highlighter: require('brush-base'),

  config: require('./config'),
  regexLib: require('syntaxhighlighter-regex').commonRegExp,

  /** Internal 'global' variables. */
  vars: {
    discoveredBrushes: null,
    highlighters: {}
  },

  /** This object is populated by user included external brush files. */
  brushes: {},

  /**
   * Finds all elements on the page which should be processes by SyntaxHighlighter.
   *
   * @param {Object} globalParams   Optional parameters which override element's
   *                  parameters. Only used if element is specified.
   *
   * @param {Object} element  Optional element to highlight. If none is
   *              provided, all elements in the current document
   *              are returned which qualify.
   *
   * @return {Array}  Returns list of <code>{ target: DOMElement, params: Object }</code> objects.
   */
  findElements: function findElements(globalParams, element) {
    var elements = element ? [element] : utils.toArray(document.getElementsByTagName(sh.config.tagName)),
        conf = sh.config,
        result = [];

    // support for <SCRIPT TYPE="syntaxhighlighter" /> feature
    elements = elements.concat(dom.getSyntaxHighlighterScriptTags());

    if (elements.length === 0) return result;

    for (var i = 0, l = elements.length; i < l; i++) {
      var item = {
        target: elements[i],
        // local params take precedence over globals
        params: optsParser.defaults(optsParser.parse(elements[i].className), globalParams)
      };

      if (item.params['brush'] == null) continue;

      result.push(item);
    }

    return result;
  },

  /**
   * Shorthand to highlight all elements on the page that are marked as
   * SyntaxHighlighter source code.
   *
   * @param {Object} globalParams   Optional parameters which override element's
   *                  parameters. Only used if element is specified.
   *
   * @param {Object} element  Optional element to highlight. If none is
   *              provided, all elements in the current document
   *              are highlighted.
   */
  highlight: function highlight(globalParams, element) {
    var elements = sh.findElements(globalParams, element),
        propertyName = 'innerHTML',
        brush = null,
        renderer,
        conf = sh.config;

    if (elements.length === 0) return;

    for (var i = 0, l = elements.length; i < l; i++) {
      var element = elements[i],
          target = element.target,
          params = element.params,
          brushName = params.brush,
          brush,
          matches,
          code;

      if (brushName == null) continue;

      brush = findBrush(brushName);

      if (!brush) continue;

      // local params take precedence over defaults
      params = optsParser.defaults(params || {}, defaults);
      params = optsParser.defaults(params, config);

      // Instantiate a brush
      if (params['html-script'] == true || defaults['html-script'] == true) {
        brush = new HtmlScript(findBrush('xml'), brush);
        brushName = 'htmlscript';
      } else {
        brush = new brush();
      }

      code = target[propertyName];

      // remove CDATA from <SCRIPT/> tags if it's present
      if (conf.useScriptTags) code = stripCData(code);

      // Inject title if the attribute is present
      if ((target.title || '') != '') params.title = target.title;

      params['brush'] = brushName;

      code = transformers(code, params);
      matches = match.applyRegexList(code, brush.regexList, params);
      renderer = new Renderer(code, matches, params);

      element = dom.create('div');
      element.innerHTML = renderer.getHtml();

      // id = utils.guid();
      // element.id = highlighters.id(id);
      // highlighters.set(id, element);

      if (params.quickCode) dom.attachEvent(dom.findElement(element, '.code'), 'dblclick', dom.quickCodeHandler);

      // carry over ID
      if ((target.id || '') != '') element.id = target.id;

      target.parentNode.replaceChild(element, target);
    }
  }
}; // end of sh

/**
 * Displays an alert.
 * @param {String} str String to display.
 */
function alert(str) {
  window.alert('SyntaxHighlighter\n\n' + str);
};

/**
 * Finds a brush by its alias.
 *
 * @param {String} alias    Brush alias.
 * @param {Boolean} showAlert Suppresses the alert if false.
 * @return {Brush}        Returns bursh constructor if found, null otherwise.
 */
function findBrush(alias, showAlert) {
  var brushes = sh.vars.discoveredBrushes,
      result = null;

  if (brushes == null) {
    brushes = {};

    // Find all brushes
    for (var brushName in sh.brushes) {
      var brush = sh.brushes[brushName],
          aliases = brush.aliases;

      if (aliases == null) {
        continue;
      }

      brush.className = brush.className || brush.aliases[0];
      brush.brushName = brush.className || brushName.toLowerCase();

      for (var i = 0, l = aliases.length; i < l; i++) {
        brushes[aliases[i]] = brushName;
      }
    }

    sh.vars.discoveredBrushes = brushes;
  }

  result = sh.brushes[brushes[alias]];

  if (result == null && showAlert) alert(sh.config.strings.noBrush + alias);

  return result;
};

/**
 * Strips <![CDATA[]]> from <SCRIPT /> content because it should be used
 * there in most cases for XHTML compliance.
 * @param {String} original Input code.
 * @return {String} Returns code without leading <![CDATA[]]> tags.
 */
function stripCData(original) {
  var left = '<![CDATA[',
      right = ']]>',

  // for some reason IE inserts some leading blanks here
  copy = utils.trim(original),
      changed = false,
      leftLength = left.length,
      rightLength = right.length;

  if (copy.indexOf(left) == 0) {
    copy = copy.substring(leftLength);
    changed = true;
  }

  var copyLength = copy.length;

  if (copy.indexOf(right) == copyLength - rightLength) {
    copy = copy.substring(0, copyLength - rightLength);
    changed = true;
  }

  return changed ? copy : original;
};

var brushCounter = 0;

exports.default = sh;
var registerBrush = exports.registerBrush = function registerBrush(brush) {
  return sh.brushes['brush' + brushCounter++] = brush.default || brush;
};
var clearRegisteredBrushes = exports.clearRegisteredBrushes = function clearRegisteredBrushes() {
  sh.brushes = {};
  brushCounter = 0;
};

/* an EJS hook for `gulp build --brushes` command
 * <%- registerBrushes %>
 */

},{"./config":"/usr/var/server.base/node_modules/syntaxhighlighter/src/config.js","./defaults":"/usr/var/server.base/node_modules/syntaxhighlighter/src/defaults.js","./dom":"/usr/var/server.base/node_modules/syntaxhighlighter/src/dom.js","./html_script":"/usr/var/server.base/node_modules/syntaxhighlighter/src/html_script.js","./transformers":"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/index.js","./utils":"/usr/var/server.base/node_modules/syntaxhighlighter/src/utils.js","brush-base":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/brush-base/brush-base.js","opts-parser":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/opts-parser/opts-parser.js","syntaxhighlighter-html-renderer":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-html-renderer/index.js","syntaxhighlighter-match":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/index.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/defaults.js":[function(require,module,exports){
'use strict';

module.exports = {
  /** Additional CSS class names to be added to highlighter elements. */
  'class-name': '',

  /** First line number. */
  'first-line': 1,

  /**
   * Pads line numbers. Possible values are:
   *
   *   false - don't pad line numbers.
   *   true  - automaticaly pad numbers with minimum required number of leading zeroes.
   *   [int] - length up to which pad line numbers.
   */
  'pad-line-numbers': false,

  /** Lines to highlight. */
  'highlight': null,

  /** Title to be displayed above the code block. */
  'title': null,

  /** Enables or disables smart tabs. */
  'smart-tabs': true,

  /** Gets or sets tab size. */
  'tab-size': 4,

  /** Enables or disables gutter. */
  'gutter': true,

  /** Enables quick code copy and paste from double click. */
  'quick-code': true,

  /** Forces code view to be collapsed. */
  'collapse': false,

  /** Enables or disables automatic links. */
  'auto-links': true,

  'unindent': true,

  'html-script': false
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/dom.js":[function(require,module,exports){
'use strict';

/**
 * Finds all &lt;SCRIPT TYPE="text/syntaxhighlighter" /> elementss.
 * Finds both "text/syntaxhighlighter" and "syntaxhighlighter"
 * ...in order to make W3C validator happy with subtype and backwardscompatible without subtype
 * @return {Array} Returns array of all found SyntaxHighlighter tags.
 */
function getSyntaxHighlighterScriptTags() {
  var tags = document.getElementsByTagName('script'),
      result = [];

  for (var i = 0; i < tags.length; i++) {
    if (tags[i].type == 'text/syntaxhighlighter' || tags[i].type == 'syntaxhighlighter') result.push(tags[i]);
  }return result;
};

/**
 * Checks if target DOM elements has specified CSS class.
 * @param {DOMElement} target Target DOM element to check.
 * @param {String} className Name of the CSS class to check for.
 * @return {Boolean} Returns true if class name is present, false otherwise.
 */
function hasClass(target, className) {
  return target.className.indexOf(className) != -1;
}

/**
 * Adds CSS class name to the target DOM element.
 * @param {DOMElement} target Target DOM element.
 * @param {String} className New CSS class to add.
 */
function addClass(target, className) {
  if (!hasClass(target, className)) target.className += ' ' + className;
}

/**
 * Removes CSS class name from the target DOM element.
 * @param {DOMElement} target Target DOM element.
 * @param {String} className CSS class to remove.
 */
function removeClass(target, className) {
  target.className = target.className.replace(className, '');
}

/**
 * Adds event handler to the target object.
 * @param {Object} obj    Target object.
 * @param {String} type   Name of the event.
 * @param {Function} func Handling function.
 */
function attachEvent(obj, type, func, scope) {
  function handler(e) {
    e = e || window.event;

    if (!e.target) {
      e.target = e.srcElement;
      e.preventDefault = function () {
        this.returnValue = false;
      };
    }

    func.call(scope || window, e);
  };

  if (obj.attachEvent) {
    obj.attachEvent('on' + type, handler);
  } else {
    obj.addEventListener(type, handler, false);
  }
}

/**
 * Looks for a child or parent node which has specified classname.
 * Equivalent to jQuery's $(container).find(".className")
 * @param {Element} target Target element.
 * @param {String} search Class name or node name to look for.
 * @param {Boolean} reverse If set to true, will go up the node tree instead of down.
 * @return {Element} Returns found child or parent element on null.
 */
function findElement(target, search, reverse /* optional */) {
  if (target == null) return null;

  var nodes = reverse != true ? target.childNodes : [target.parentNode],
      propertyToFind = { '#': 'id', '.': 'className' }[search.substr(0, 1)] || 'nodeName',
      expectedValue,
      found;

  expectedValue = propertyToFind != 'nodeName' ? search.substr(1) : search.toUpperCase();

  // main return of the found node
  if ((target[propertyToFind] || '').indexOf(expectedValue) != -1) return target;

  for (var i = 0, l = nodes.length; nodes && i < l && found == null; i++) {
    found = findElement(nodes[i], search, reverse);
  }return found;
}

/**
 * Looks for a parent node which has specified classname.
 * This is an alias to <code>findElement(container, className, true)</code>.
 * @param {Element} target Target element.
 * @param {String} className Class name to look for.
 * @return {Element} Returns found parent element on null.
 */
function findParentElement(target, className) {
  return findElement(target, className, true);
}

/**
 * Opens up a centered popup window.
 * @param {String} url    URL to open in the window.
 * @param {String} name   Popup name.
 * @param {int} width   Popup width.
 * @param {int} height    Popup height.
 * @param {String} options  window.open() options.
 * @return {Window}     Returns window instance.
 */
function popup(url, name, width, height, options) {
  var x = (screen.width - width) / 2,
      y = (screen.height - height) / 2;

  options += ', left=' + x + ', top=' + y + ', width=' + width + ', height=' + height;
  options = options.replace(/^,/, '');

  var win = window.open(url, name, options);
  win.focus();
  return win;
}

function getElementsByTagName(name) {
  return document.getElementsByTagName(name);
}

/**
 * Finds all elements on the page which could be processes by SyntaxHighlighter.
 */
function findElementsToHighlight(opts) {
  var elements = getElementsByTagName(opts['tagName']),
      scripts,
      i;

  // support for <SCRIPT TYPE="syntaxhighlighter" /> feature
  if (opts['useScriptTags']) {
    scripts = getElementsByTagName('script');

    for (i = 0; i < scripts.length; i++) {
      if (scripts[i].type.match(/^(text\/)?syntaxhighlighter$/)) elements.push(scripts[i]);
    }
  }

  return elements;
}

function create(name) {
  return document.createElement(name);
}

/**
 * Quick code mouse double click handler.
 */
function quickCodeHandler(e) {
  var target = e.target,
      highlighterDiv = findParentElement(target, '.syntaxhighlighter'),
      container = findParentElement(target, '.container'),
      textarea = document.createElement('textarea'),
      highlighter;

  if (!container || !highlighterDiv || findElement(container, 'textarea')) return;

  //highlighter = highlighters.get(highlighterDiv.id);

  // add source class name
  addClass(highlighterDiv, 'source');

  // Have to go over each line and grab it's text, can't just do it on the
  // container because Firefox loses all \n where as Webkit doesn't.
  var lines = container.childNodes,
      code = [];

  for (var i = 0, l = lines.length; i < l; i++) {
    code.push(lines[i].innerText || lines[i].textContent);
  } // using \r instead of \r or \r\n makes this work equally well on IE, FF and Webkit
  code = code.join('\r');

  // For Webkit browsers, replace nbsp with a breaking space
  code = code.replace(/\u00a0/g, " ");

  // inject <textarea/> tag
  textarea.readOnly = true; // https://github.com/syntaxhighlighter/syntaxhighlighter/pull/329
  textarea.appendChild(document.createTextNode(code));
  container.appendChild(textarea);

  // preselect all text
  textarea.focus();
  textarea.select();

  // set up handler for lost focus
  attachEvent(textarea, 'blur', function (e) {
    textarea.parentNode.removeChild(textarea);
    removeClass(highlighterDiv, 'source');
  });
};

module.exports = {
  quickCodeHandler: quickCodeHandler,
  create: create,
  popup: popup,
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  attachEvent: attachEvent,
  findElement: findElement,
  findParentElement: findParentElement,
  getSyntaxHighlighterScriptTags: getSyntaxHighlighterScriptTags,
  findElementsToHighlight: findElementsToHighlight
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/html_script.js":[function(require,module,exports){
(function (process){(function (){
'use strict';

var applyRegexList = require('syntaxhighlighter-match').applyRegexList;

function HtmlScript(BrushXML, brushClass) {
  var scriptBrush,
      xmlBrush = new BrushXML();

  if (brushClass == null) return;

  scriptBrush = new brushClass();

  if (scriptBrush.htmlScript == null) throw new Error('Brush wasn\'t configured for html-script option: ' + brushClass.brushName);

  xmlBrush.regexList.push({ regex: scriptBrush.htmlScript.code, func: process });

  this.regexList = xmlBrush.regexList;

  function offsetMatches(matches, offset) {
    for (var j = 0, l = matches.length; j < l; j++) {
      matches[j].index += offset;
    }
  }

  function process(match, info) {
    var code = match.code,
        results = [],
        regexList = scriptBrush.regexList,
        offset = match.index + match.left.length,
        htmlScript = scriptBrush.htmlScript,
        matches;

    function add(matches) {
      results = results.concat(matches);
    }

    matches = applyRegexList(code, regexList);
    offsetMatches(matches, offset);
    add(matches);

    // add left script bracket
    if (htmlScript.left != null && match.left != null) {
      matches = applyRegexList(match.left, [htmlScript.left]);
      offsetMatches(matches, match.index);
      add(matches);
    }

    // add right script bracket
    if (htmlScript.right != null && match.right != null) {
      matches = applyRegexList(match.right, [htmlScript.right]);
      offsetMatches(matches, match.index + match[0].lastIndexOf(match.right));
      add(matches);
    }

    for (var j = 0, l = results.length; j < l; j++) {
      results[j].brushName = brushClass.brushName;
    }return results;
  }
};

module.exports = HtmlScript;

}).call(this)}).call(this,require('_process'))
},{"_process":"/usr/var/server.base/node_modules/browserify/node_modules/process/browser.js","syntaxhighlighter-match":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/syntaxhighlighter-match/index.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/blogger_mode.js":[function(require,module,exports){
'use strict';

module.exports = function (code, opts) {
  var br = /<br\s*\/?>|&lt;br\s*\/?&gt;/gi;

  if (opts['bloggerMode'] === true) code = code.replace(br, '\n');

  return code;
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/index.js":[function(require,module,exports){
'use strict';

var trim = require('./trim'),
    bloggerMode = require('./blogger_mode'),
    stripBrs = require('./strip_brs'),
    unindenter = require('unindenter'),
    retabber = require('retabber');

module.exports = function (code, opts) {
  code = trim(code, opts);
  code = bloggerMode(code, opts);
  code = stripBrs(code, opts);
  code = unindenter.unindent(code, opts);

  var tabSize = opts['tab-size'];
  code = opts['smart-tabs'] === true ? retabber.smart(code, tabSize) : retabber.regular(code, tabSize);

  return code;
};

},{"./blogger_mode":"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/blogger_mode.js","./strip_brs":"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/strip_brs.js","./trim":"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/trim.js","retabber":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/retabber/retabber.js","unindenter":"/usr/var/server.base/node_modules/syntaxhighlighter/node_modules/unindenter/unindenter.js"}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/strip_brs.js":[function(require,module,exports){
'use strict';

module.exports = function (code, opts) {
  var br = /<br\s*\/?>|&lt;br\s*\/?&gt;/gi;

  if (opts['stripBrs'] === true) code = code.replace(br, '');

  return code;
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/transformers/trim.js":[function(require,module,exports){
'use strict';

module.exports = function (code, opts) {
   return code
   // This is a special trim which only removes first and last empty lines
   // and doesn't affect valid leading space on the first line.
   .replace(/^[ ]*[\n]+|[\n]*[ ]*$/g, '')

   // IE lets these buggers through
   .replace(/\r/g, ' ');
};

},{}],"/usr/var/server.base/node_modules/syntaxhighlighter/src/utils.js":[function(require,module,exports){
'use strict';

/**
 * Splits block of text into lines.
 * @param {String} block Block of text.
 * @return {Array} Returns array of lines.
 */
function splitLines(block) {
  return block.split(/\r?\n/);
}

/**
 * Executes a callback on each line and replaces each line with result from the callback.
 * @param {Object} str      Input string.
 * @param {Object} callback   Callback function taking one string argument and returning a string.
 */
function eachLine(str, callback) {
  var lines = splitLines(str);

  for (var i = 0, l = lines.length; i < l; i++) {
    lines[i] = callback(lines[i], i);
  }return lines.join('\n');
}

/**
 * Generates a unique element ID.
 */
function guid(prefix) {
  return (prefix || '') + Math.round(Math.random() * 1000000).toString();
}

/**
 * Merges two objects. Values from obj2 override values in obj1.
 * Function is NOT recursive and works only for one dimensional objects.
 * @param {Object} obj1 First object.
 * @param {Object} obj2 Second object.
 * @return {Object} Returns combination of both objects.
 */
function merge(obj1, obj2) {
  var result = {},
      name;

  for (name in obj1) {
    result[name] = obj1[name];
  }for (name in obj2) {
    result[name] = obj2[name];
  }return result;
}

/**
 * Removes all white space at the begining and end of a string.
 *
 * @param {String} str   String to trim.
 * @return {String}      Returns string without leading and following white space characters.
 */
function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}

/**
 * Converts the source to array object. Mostly used for function arguments and
 * lists returned by getElementsByTagName() which aren't Array objects.
 * @param {List} source Source list.
 * @return {Array} Returns array.
 */
function toArray(source) {
  return Array.prototype.slice.apply(source);
}

/**
 * Attempts to convert string to boolean.
 * @param {String} value Input string.
 * @return {Boolean} Returns true if input was "true", false if input was "false" and value otherwise.
 */
function toBoolean(value) {
  var result = { "true": true, "false": false }[value];
  return result == null ? value : result;
}

module.exports = {
  splitLines: splitLines,
  eachLine: eachLine,
  guid: guid,
  merge: merge,
  trim: trim,
  toArray: toArray,
  toBoolean: toBoolean
};

},{}],"/usr/var/server.base/node_modules/tether/dist/js/tether.js":[function(require,module,exports){
/*! tether 1.4.7 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Tether = factory();
  }
}(this, function() {

'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var TetherBase = undefined;
if (typeof TetherBase === 'undefined') {
  TetherBase = { modules: [] };
}

var zeroElement = null;

// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
// if the element lies within a nested document (<frame> or <iframe>-like).
function getActualBoundingClientRect(node) {
  var boundingRect = node.getBoundingClientRect();

  // The original object returned by getBoundingClientRect is immutable, so we clone it
  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
  var rect = {};
  for (var k in boundingRect) {
    rect[k] = boundingRect[k];
  }

  try {
    if (node.ownerDocument !== document) {
      var _frameElement = node.ownerDocument.defaultView.frameElement;
      if (_frameElement) {
        var frameRect = getActualBoundingClientRect(_frameElement);
        rect.top += frameRect.top;
        rect.bottom += frameRect.top;
        rect.left += frameRect.left;
        rect.right += frameRect.left;
      }
    }
  } catch (err) {
    // Ignore "Access is denied" in IE11/Edge
  }

  return rect;
}

function getScrollParents(el) {
  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  var computedStyle = getComputedStyle(el) || {};
  var position = computedStyle.position;
  var parents = [];

  if (position === 'fixed') {
    return [el];
  }

  var parent = el;
  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    var style = undefined;
    try {
      style = getComputedStyle(parent);
    } catch (err) {}

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    var _style = style;
    var overflow = _style.overflow;
    var overflowX = _style.overflowX;
    var overflowY = _style.overflowY;

    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}

var uniqueId = (function () {
  var id = 0;
  return function () {
    return ++id;
  };
})();

var zeroPosCache = {};
var getOrigin = function getOrigin() {
  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
  // jitter as the user scrolls that messes with our ability to detect if two positions
  // are equivilant or not.  We place an element at the top left of the page that will
  // get the same jitter, so we can cancel the two out.
  var node = zeroElement;
  if (!node || !document.body.contains(node)) {
    node = document.createElement('div');
    node.setAttribute('data-tether-id', uniqueId());
    extend(node.style, {
      top: 0,
      left: 0,
      position: 'absolute'
    });

    document.body.appendChild(node);

    zeroElement = node;
  }

  var id = node.getAttribute('data-tether-id');
  if (typeof zeroPosCache[id] === 'undefined') {
    zeroPosCache[id] = getActualBoundingClientRect(node);

    // Clear the cache when this position call is done
    defer(function () {
      delete zeroPosCache[id];
    });
  }

  return zeroPosCache[id];
};

function removeUtilElements() {
  if (zeroElement) {
    document.body.removeChild(zeroElement);
  }
  zeroElement = null;
};

function getBounds(el) {
  var doc = undefined;
  if (el === document) {
    doc = document;
    el = document.documentElement;
  } else {
    doc = el.ownerDocument;
  }

  var docEl = doc.documentElement;

  var box = getActualBoundingClientRect(el);

  var origin = getOrigin();

  box.top -= origin.top;
  box.left -= origin.left;

  if (typeof box.width === 'undefined') {
    box.width = document.body.scrollWidth - box.left - box.right;
  }
  if (typeof box.height === 'undefined') {
    box.height = document.body.scrollHeight - box.top - box.bottom;
  }

  box.top = box.top - docEl.clientTop;
  box.left = box.left - docEl.clientLeft;
  box.right = doc.body.clientWidth - box.width - box.left;
  box.bottom = doc.body.clientHeight - box.height - box.top;

  return box;
}

function getOffsetParent(el) {
  return el.offsetParent || document.documentElement;
}

var _scrollBarSize = null;
function getScrollBarSize() {
  if (_scrollBarSize) {
    return _scrollBarSize;
  }
  var inner = document.createElement('div');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  extend(outer.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });

  outer.appendChild(inner);

  document.body.appendChild(outer);

  var widthContained = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var widthScroll = inner.offsetWidth;

  if (widthContained === widthScroll) {
    widthScroll = outer.clientWidth;
  }

  document.body.removeChild(outer);

  var width = widthContained - widthScroll;

  _scrollBarSize = { width: width, height: width };
  return _scrollBarSize;
}

function extend() {
  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var args = [];

  Array.prototype.push.apply(args, arguments);

  args.slice(1).forEach(function (obj) {
    if (obj) {
      for (var key in obj) {
        if (({}).hasOwnProperty.call(obj, key)) {
          out[key] = obj[key];
        }
      }
    }
  });

  return out;
}

function removeClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.remove(cls);
      }
    });
  } else {
    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
    var className = getClassName(el).replace(regex, ' ');
    setClassName(el, className);
  }
}

function addClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    name.split(' ').forEach(function (cls) {
      if (cls.trim()) {
        el.classList.add(cls);
      }
    });
  } else {
    removeClass(el, name);
    var cls = getClassName(el) + (' ' + name);
    setClassName(el, cls);
  }
}

function hasClass(el, name) {
  if (typeof el.classList !== 'undefined') {
    return el.classList.contains(name);
  }
  var className = getClassName(el);
  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
}

function getClassName(el) {
  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
  // completely separately SVGAnimatedString base classes
  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
    return el.className.baseVal;
  }
  return el.className;
}

function setClassName(el, className) {
  el.setAttribute('class', className);
}

function updateClasses(el, add, all) {
  // Of the set of 'all' classes, we need the 'add' classes, and only the
  // 'add' classes to be set.
  all.forEach(function (cls) {
    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
      removeClass(el, cls);
    }
  });

  add.forEach(function (cls) {
    if (!hasClass(el, cls)) {
      addClass(el, cls);
    }
  });
}

var deferred = [];

var defer = function defer(fn) {
  deferred.push(fn);
};

var flush = function flush() {
  var fn = undefined;
  while (fn = deferred.pop()) {
    fn();
  }
};

var Evented = (function () {
  function Evented() {
    _classCallCheck(this, Evented);
  }

  _createClass(Evented, [{
    key: 'on',
    value: function on(event, handler, ctx) {
      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

      if (typeof this.bindings === 'undefined') {
        this.bindings = {};
      }
      if (typeof this.bindings[event] === 'undefined') {
        this.bindings[event] = [];
      }
      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
    }
  }, {
    key: 'once',
    value: function once(event, handler, ctx) {
      this.on(event, handler, ctx, true);
    }
  }, {
    key: 'off',
    value: function off(event, handler) {
      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
        return;
      }

      if (typeof handler === 'undefined') {
        delete this.bindings[event];
      } else {
        var i = 0;
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }, {
    key: 'trigger',
    value: function trigger(event) {
      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
        var i = 0;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        while (i < this.bindings[event].length) {
          var _bindings$event$i = this.bindings[event][i];
          var handler = _bindings$event$i.handler;
          var ctx = _bindings$event$i.ctx;
          var once = _bindings$event$i.once;

          var context = ctx;
          if (typeof context === 'undefined') {
            context = this;
          }

          handler.apply(context, args);

          if (once) {
            this.bindings[event].splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    }
  }]);

  return Evented;
})();

TetherBase.Utils = {
  getActualBoundingClientRect: getActualBoundingClientRect,
  getScrollParents: getScrollParents,
  getBounds: getBounds,
  getOffsetParent: getOffsetParent,
  extend: extend,
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  updateClasses: updateClasses,
  defer: defer,
  flush: flush,
  uniqueId: uniqueId,
  Evented: Evented,
  getScrollBarSize: getScrollBarSize,
  removeUtilElements: removeUtilElements
};
/* globals TetherBase, performance */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

if (typeof TetherBase === 'undefined') {
  throw new Error('You must include the utils.js file before tether.js');
}

var _TetherBase$Utils = TetherBase.Utils;
var getScrollParents = _TetherBase$Utils.getScrollParents;
var getBounds = _TetherBase$Utils.getBounds;
var getOffsetParent = _TetherBase$Utils.getOffsetParent;
var extend = _TetherBase$Utils.extend;
var addClass = _TetherBase$Utils.addClass;
var removeClass = _TetherBase$Utils.removeClass;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;
var flush = _TetherBase$Utils.flush;
var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
var removeUtilElements = _TetherBase$Utils.removeUtilElements;

function within(a, b) {
  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

  return a + diff >= b && b >= a - diff;
}

var transformKey = (function () {
  if (typeof document === 'undefined') {
    return '';
  }
  var el = document.createElement('div');

  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
  for (var i = 0; i < transforms.length; ++i) {
    var key = transforms[i];
    if (el.style[key] !== undefined) {
      return key;
    }
  }
})();

var tethers = [];

var position = function position() {
  tethers.forEach(function (tether) {
    tether.position(false);
  });
  flush();
};

function now() {
  if (typeof performance === 'object' && typeof performance.now === 'function') {
    return performance.now();
  }
  return +new Date();
}

(function () {
  var lastCall = null;
  var lastDuration = null;
  var pendingTimeout = null;

  var tick = function tick() {
    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250);

      // Just in case this is the last event, remember to position just once more
      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = now();
    position();
    lastDuration = now() - lastCall;
  };

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }
})();

var MIRROR_LR = {
  center: 'center',
  left: 'right',
  right: 'left'
};

var MIRROR_TB = {
  middle: 'middle',
  top: 'bottom',
  bottom: 'top'
};

var OFFSET_MAP = {
  top: 0,
  left: 0,
  middle: '50%',
  center: '50%',
  bottom: '100%',
  right: '100%'
};

var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (left === 'auto') {
    left = MIRROR_LR[relativeToAttachment.left];
  }

  if (top === 'auto') {
    top = MIRROR_TB[relativeToAttachment.top];
  }

  return { left: left, top: top };
};

var attachmentToOffset = function attachmentToOffset(attachment) {
  var left = attachment.left;
  var top = attachment.top;

  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
    left = OFFSET_MAP[attachment.left];
  }

  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
    top = OFFSET_MAP[attachment.top];
  }

  return { left: left, top: top };
};

function addOffset() {
  var out = { top: 0, left: 0 };

  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
    offsets[_key] = arguments[_key];
  }

  offsets.forEach(function (_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (typeof top === 'string') {
      top = parseFloat(top, 10);
    }
    if (typeof left === 'string') {
      left = parseFloat(left, 10);
    }

    out.top += top;
    out.left += left;
  });

  return out;
}

function offsetToPx(offset, size) {
  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
  }
  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
  }

  return offset;
}

var parseOffset = function parseOffset(value) {
  var _value$split = value.split(' ');

  var _value$split2 = _slicedToArray(_value$split, 2);

  var top = _value$split2[0];
  var left = _value$split2[1];

  return { top: top, left: left };
};
var parseAttachment = parseOffset;

var TetherClass = (function (_Evented) {
  _inherits(TetherClass, _Evented);

  function TetherClass(options) {
    var _this = this;

    _classCallCheck(this, TetherClass);

    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
    this.position = this.position.bind(this);

    tethers.push(this);

    this.history = [];

    this.setOptions(options, false);

    TetherBase.modules.forEach(function (module) {
      if (typeof module.initialize !== 'undefined') {
        module.initialize.call(_this);
      }
    });

    this.position();
  }

  _createClass(TetherClass, [{
    key: 'getClass',
    value: function getClass() {
      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
      var classes = this.options.classes;

      if (typeof classes !== 'undefined' && classes[key]) {
        return this.options.classes[key];
      } else if (this.options.classPrefix) {
        return this.options.classPrefix + '-' + key;
      } else {
        return key;
      }
    }
  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      var defaults = {
        offset: '0 0',
        targetOffset: '0 0',
        targetAttachment: 'auto auto',
        classPrefix: 'tether'
      };

      this.options = extend(defaults, options);

      var _options = this.options;
      var element = _options.element;
      var target = _options.target;
      var targetModifier = _options.targetModifier;

      this.element = element;
      this.target = target;
      this.targetModifier = targetModifier;

      if (this.target === 'viewport') {
        this.target = document.body;
        this.targetModifier = 'visible';
      } else if (this.target === 'scroll-handle') {
        this.target = document.body;
        this.targetModifier = 'scroll-handle';
      }

      ['element', 'target'].forEach(function (key) {
        if (typeof _this2[key] === 'undefined') {
          throw new Error('Tether Error: Both element and target must be defined');
        }

        if (typeof _this2[key].jquery !== 'undefined') {
          _this2[key] = _this2[key][0];
        } else if (typeof _this2[key] === 'string') {
          _this2[key] = document.querySelector(_this2[key]);
        }
      });

      addClass(this.element, this.getClass('element'));
      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('target'));
      }

      if (!this.options.attachment) {
        throw new Error('Tether Error: You must provide an attachment');
      }

      this.targetAttachment = parseAttachment(this.options.targetAttachment);
      this.attachment = parseAttachment(this.options.attachment);
      this.offset = parseOffset(this.options.offset);
      this.targetOffset = parseOffset(this.options.targetOffset);

      if (typeof this.scrollParents !== 'undefined') {
        this.disable();
      }

      if (this.targetModifier === 'scroll-handle') {
        this.scrollParents = [this.target];
      } else {
        this.scrollParents = getScrollParents(this.target);
      }

      if (!(this.options.enabled === false)) {
        this.enable(pos);
      }
    }
  }, {
    key: 'getTargetBounds',
    value: function getTargetBounds() {
      if (typeof this.targetModifier !== 'undefined') {
        if (this.targetModifier === 'visible') {
          if (this.target === document.body) {
            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
          } else {
            var bounds = getBounds(this.target);

            var out = {
              height: bounds.height,
              width: bounds.width,
              top: bounds.top,
              left: bounds.left
            };

            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
            out.height = Math.min(innerHeight, out.height);
            out.height -= 2;

            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
            out.width = Math.min(innerWidth, out.width);
            out.width -= 2;

            if (out.top < pageYOffset) {
              out.top = pageYOffset;
            }
            if (out.left < pageXOffset) {
              out.left = pageXOffset;
            }

            return out;
          }
        } else if (this.targetModifier === 'scroll-handle') {
          var bounds = undefined;
          var target = this.target;
          if (target === document.body) {
            target = document.documentElement;

            bounds = {
              left: pageXOffset,
              top: pageYOffset,
              height: innerHeight,
              width: innerWidth
            };
          } else {
            bounds = getBounds(target);
          }

          var style = getComputedStyle(target);

          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;

          var scrollBottom = 0;
          if (hasBottomScroll) {
            scrollBottom = 15;
          }

          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;

          var out = {
            width: 15,
            height: height * 0.975 * (height / target.scrollHeight),
            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
          };

          var fitAdj = 0;
          if (height < 408 && this.target === document.body) {
            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
          }

          if (this.target !== document.body) {
            out.height = Math.max(out.height, 24);
          }

          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);

          if (this.target === document.body) {
            out.height = Math.max(out.height, 24);
          }

          return out;
        }
      } else {
        return getBounds(this.target);
      }
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this._cache = {};
    }
  }, {
    key: 'cache',
    value: function cache(k, getter) {
      // More than one module will often need the same DOM info, so
      // we keep a cache which is cleared on each position call
      if (typeof this._cache === 'undefined') {
        this._cache = {};
      }

      if (typeof this._cache[k] === 'undefined') {
        this._cache[k] = getter.call(this);
      }

      return this._cache[k];
    }
  }, {
    key: 'enable',
    value: function enable() {
      var _this3 = this;

      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      if (!(this.options.addTargetClasses === false)) {
        addClass(this.target, this.getClass('enabled'));
      }
      addClass(this.element, this.getClass('enabled'));
      this.enabled = true;

      this.scrollParents.forEach(function (parent) {
        if (parent !== _this3.target.ownerDocument) {
          parent.addEventListener('scroll', _this3.position);
        }
      });

      if (pos) {
        this.position();
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      var _this4 = this;

      removeClass(this.target, this.getClass('enabled'));
      removeClass(this.element, this.getClass('enabled'));
      this.enabled = false;

      if (typeof this.scrollParents !== 'undefined') {
        this.scrollParents.forEach(function (parent) {
          parent.removeEventListener('scroll', _this4.position);
        });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var _this5 = this;

      this.disable();

      tethers.forEach(function (tether, i) {
        if (tether === _this5) {
          tethers.splice(i, 1);
        }
      });

      // Remove any elements we were using for convenience from the DOM
      if (tethers.length === 0) {
        removeUtilElements();
      }
    }
  }, {
    key: 'updateAttachClasses',
    value: function updateAttachClasses(elementAttach, targetAttach) {
      var _this6 = this;

      elementAttach = elementAttach || this.attachment;
      targetAttach = targetAttach || this.targetAttachment;
      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];

      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
        // updateAttachClasses can be called more than once in a position call, so
        // we need to clean up after ourselves such that when the last defer gets
        // ran it doesn't add any extra classes from previous calls.
        this._addAttachClasses.splice(0, this._addAttachClasses.length);
      }

      if (typeof this._addAttachClasses === 'undefined') {
        this._addAttachClasses = [];
      }
      var add = this._addAttachClasses;

      if (elementAttach.top) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
      }
      if (elementAttach.left) {
        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
      }
      if (targetAttach.top) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
      }
      if (targetAttach.left) {
        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
      }

      var all = [];
      sides.forEach(function (side) {
        all.push(_this6.getClass('element-attached') + '-' + side);
        all.push(_this6.getClass('target-attached') + '-' + side);
      });

      defer(function () {
        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
          return;
        }

        updateClasses(_this6.element, _this6._addAttachClasses, all);
        if (!(_this6.options.addTargetClasses === false)) {
          updateClasses(_this6.target, _this6._addAttachClasses, all);
        }

        delete _this6._addAttachClasses;
      });
    }
  }, {
    key: 'position',
    value: function position() {
      var _this7 = this;

      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
      // tethers (in which case call Tether.Utils.flush yourself when you're done)

      if (!this.enabled) {
        return;
      }

      this.clearCache();

      // Turn 'auto' attachments into the appropriate corner or edge
      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);

      this.updateAttachClasses(this.attachment, targetAttachment);

      var elementPos = this.cache('element-bounds', function () {
        return getBounds(_this7.element);
      });

      var width = elementPos.width;
      var height = elementPos.height;

      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
        var _lastSize = this.lastSize;

        // We cache the height and width to make it possible to position elements that are
        // getting hidden.
        width = _lastSize.width;
        height = _lastSize.height;
      } else {
        this.lastSize = { width: width, height: height };
      }

      var targetPos = this.cache('target-bounds', function () {
        return _this7.getTargetBounds();
      });
      var targetSize = targetPos;

      // Get an actual px offset from the attachment
      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);

      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);

      // Add the manually provided offset
      offset = addOffset(offset, manualOffset);
      targetOffset = addOffset(targetOffset, manualTargetOffset);

      // It's now our goal to make (element position + offset) == (target position + target offset)
      var left = targetPos.left + targetOffset.left - offset.left;
      var top = targetPos.top + targetOffset.top - offset.top;

      for (var i = 0; i < TetherBase.modules.length; ++i) {
        var _module2 = TetherBase.modules[i];
        var ret = _module2.position.call(this, {
          left: left,
          top: top,
          targetAttachment: targetAttachment,
          targetPos: targetPos,
          elementPos: elementPos,
          offset: offset,
          targetOffset: targetOffset,
          manualOffset: manualOffset,
          manualTargetOffset: manualTargetOffset,
          scrollbarSize: scrollbarSize,
          attachment: this.attachment
        });

        if (ret === false) {
          return false;
        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
          continue;
        } else {
          top = ret.top;
          left = ret.left;
        }
      }

      // We describe the position three different ways to give the optimizer
      // a chance to decide the best possible way to position the element
      // with the fewest repaints.
      var next = {
        // It's position relative to the page (absolute positioning when
        // the element is a child of the body)
        page: {
          top: top,
          left: left
        },

        // It's position relative to the viewport (fixed positioning)
        viewport: {
          top: top - pageYOffset,
          bottom: pageYOffset - top - height + innerHeight,
          left: left - pageXOffset,
          right: pageXOffset - left - width + innerWidth
        }
      };

      var doc = this.target.ownerDocument;
      var win = doc.defaultView;

      var scrollbarSize = undefined;
      if (win.innerHeight > doc.documentElement.clientHeight) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.bottom -= scrollbarSize.height;
      }

      if (win.innerWidth > doc.documentElement.clientWidth) {
        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
        next.viewport.right -= scrollbarSize.width;
      }

      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
        next.page.bottom = doc.body.scrollHeight - top - height;
        next.page.right = doc.body.scrollWidth - left - width;
      }

      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
        (function () {
          var offsetParent = _this7.cache('target-offsetparent', function () {
            return getOffsetParent(_this7.target);
          });
          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
            return getBounds(offsetParent);
          });
          var offsetParentStyle = getComputedStyle(offsetParent);
          var offsetParentSize = offsetPosition;

          var offsetBorder = {};
          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
          });

          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;

          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
              // We're within the visible part of the target's scroll parent
              var scrollTop = offsetParent.scrollTop;
              var scrollLeft = offsetParent.scrollLeft;

              // It's position relative to the target's offset parent (absolute positioning when
              // the element is moved to be a child of the target's offset parent).
              next.offset = {
                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
              };
            }
          }
        })();
      }

      // We could also travel up the DOM and try each containing context, rather than only
      // looking at the body, but we're gonna get diminishing returns.

      this.move(next);

      this.history.unshift(next);

      if (this.history.length > 3) {
        this.history.pop();
      }

      if (flushChanges) {
        flush();
      }

      return true;
    }

    // THE ISSUE
  }, {
    key: 'move',
    value: function move(pos) {
      var _this8 = this;

      if (!(typeof this.element.parentNode !== 'undefined')) {
        return;
      }

      var same = {};

      for (var type in pos) {
        same[type] = {};

        for (var key in pos[type]) {
          var found = false;

          for (var i = 0; i < this.history.length; ++i) {
            var point = this.history[i];
            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
              found = true;
              break;
            }
          }

          if (!found) {
            same[type][key] = true;
          }
        }
      }

      var css = { top: '', left: '', right: '', bottom: '' };

      var transcribe = function transcribe(_same, _pos) {
        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
        if (gpu !== false) {
          var yPos = undefined,
              xPos = undefined;
          if (_same.top) {
            css.top = 0;
            yPos = _pos.top;
          } else {
            css.bottom = 0;
            yPos = -_pos.bottom;
          }

          if (_same.left) {
            css.left = 0;
            xPos = _pos.left;
          } else {
            css.right = 0;
            xPos = -_pos.right;
          }

          if (typeof window.devicePixelRatio === 'number' && devicePixelRatio % 1 === 0) {
            xPos = Math.round(xPos * devicePixelRatio) / devicePixelRatio;
            yPos = Math.round(yPos * devicePixelRatio) / devicePixelRatio;
          }

          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';

          if (transformKey !== 'msTransform') {
            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
            // but IE9 doesn't support 3d transforms and will choke.
            css[transformKey] += " translateZ(0)";
          }
        } else {
          if (_same.top) {
            css.top = _pos.top + 'px';
          } else {
            css.bottom = _pos.bottom + 'px';
          }

          if (_same.left) {
            css.left = _pos.left + 'px';
          } else {
            css.right = _pos.right + 'px';
          }
        }
      };

      var moved = false;
      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
        css.position = 'absolute';
        transcribe(same.page, pos.page);
      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
        css.position = 'fixed';
        transcribe(same.viewport, pos.viewport);
      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
        (function () {
          css.position = 'absolute';
          var offsetParent = _this8.cache('target-offsetparent', function () {
            return getOffsetParent(_this8.target);
          });

          if (getOffsetParent(_this8.element) !== offsetParent) {
            defer(function () {
              _this8.element.parentNode.removeChild(_this8.element);
              offsetParent.appendChild(_this8.element);
            });
          }

          transcribe(same.offset, pos.offset);
          moved = true;
        })();
      } else {
        css.position = 'absolute';
        transcribe({ top: true, left: true }, pos.page);
      }

      if (!moved) {
        if (this.options.bodyElement) {
          if (this.element.parentNode !== this.options.bodyElement) {
            this.options.bodyElement.appendChild(this.element);
          }
        } else {
          var isFullscreenElement = function isFullscreenElement(e) {
            var d = e.ownerDocument;
            var fe = d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement;
            return fe === e;
          };

          var offsetParentIsBody = true;

          var currentNode = this.element.parentNode;
          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY' && !isFullscreenElement(currentNode)) {
            if (getComputedStyle(currentNode).position !== 'static') {
              offsetParentIsBody = false;
              break;
            }

            currentNode = currentNode.parentNode;
          }

          if (!offsetParentIsBody) {
            this.element.parentNode.removeChild(this.element);
            this.element.ownerDocument.body.appendChild(this.element);
          }
        }
      }

      // Any css change will trigger a repaint, so let's avoid one if nothing changed
      var writeCSS = {};
      var write = false;
      for (var key in css) {
        var val = css[key];
        var elVal = this.element.style[key];

        if (elVal !== val) {
          write = true;
          writeCSS[key] = val;
        }
      }

      if (write) {
        defer(function () {
          extend(_this8.element.style, writeCSS);
          _this8.trigger('repositioned');
        });
      }
    }
  }]);

  return TetherClass;
})(Evented);

TetherClass.modules = [];

TetherBase.position = position;

var Tether = extend(TetherClass, TetherBase);
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var extend = _TetherBase$Utils.extend;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];

function getBoundingRect(tether, to) {
  if (to === 'scrollParent') {
    to = tether.scrollParents[0];
  } else if (to === 'window') {
    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
  }

  if (to === document) {
    to = to.documentElement;
  }

  if (typeof to.nodeType !== 'undefined') {
    (function () {
      var node = to;
      var size = getBounds(to);
      var pos = size;
      var style = getComputedStyle(to);

      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];

      // Account any parent Frames scroll offset
      if (node.ownerDocument !== document) {
        var win = node.ownerDocument.defaultView;
        to[0] += win.pageXOffset;
        to[1] += win.pageYOffset;
        to[2] += win.pageXOffset;
        to[3] += win.pageYOffset;
      }

      BOUNDS_FORMAT.forEach(function (side, i) {
        side = side[0].toUpperCase() + side.substr(1);
        if (side === 'Top' || side === 'Left') {
          to[i] += parseFloat(style['border' + side + 'Width']);
        } else {
          to[i] -= parseFloat(style['border' + side + 'Width']);
        }
      });
    })();
  }

  return to;
}

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;
    var targetAttachment = _ref.targetAttachment;

    if (!this.options.constraints) {
      return true;
    }

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
      var _lastSize = this.lastSize;

      // Handle the item getting hidden as a result of our positioning without glitching
      // the classes in and out
      width = _lastSize.width;
      height = _lastSize.height;
    }

    var targetSize = this.cache('target-bounds', function () {
      return _this.getTargetBounds();
    });

    var targetHeight = targetSize.height;
    var targetWidth = targetSize.width;

    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];

    this.options.constraints.forEach(function (constraint) {
      var outOfBoundsClass = constraint.outOfBoundsClass;
      var pinnedClass = constraint.pinnedClass;

      if (outOfBoundsClass) {
        allClasses.push(outOfBoundsClass);
      }
      if (pinnedClass) {
        allClasses.push(pinnedClass);
      }
    });

    allClasses.forEach(function (cls) {
      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
        allClasses.push(cls + '-' + side);
      });
    });

    var addClasses = [];

    var tAttachment = extend({}, targetAttachment);
    var eAttachment = extend({}, this.attachment);

    this.options.constraints.forEach(function (constraint) {
      var to = constraint.to;
      var attachment = constraint.attachment;
      var pin = constraint.pin;

      if (typeof attachment === 'undefined') {
        attachment = '';
      }

      var changeAttachX = undefined,
          changeAttachY = undefined;
      if (attachment.indexOf(' ') >= 0) {
        var _attachment$split = attachment.split(' ');

        var _attachment$split2 = _slicedToArray(_attachment$split, 2);

        changeAttachY = _attachment$split2[0];
        changeAttachX = _attachment$split2[1];
      } else {
        changeAttachX = changeAttachY = attachment;
      }

      var bounds = getBoundingRect(_this, to);

      if (changeAttachY === 'target' || changeAttachY === 'both') {
        if (top < bounds[1] && tAttachment.top === 'top') {
          top += targetHeight;
          tAttachment.top = 'bottom';
        }

        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
          top -= targetHeight;
          tAttachment.top = 'top';
        }
      }

      if (changeAttachY === 'together') {
        if (tAttachment.top === 'top') {
          if (eAttachment.top === 'bottom' && top < bounds[1]) {
            top += targetHeight;
            tAttachment.top = 'bottom';

            top += height;
            eAttachment.top = 'top';
          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
            top -= height - targetHeight;
            tAttachment.top = 'bottom';

            eAttachment.top = 'bottom';
          }
        }

        if (tAttachment.top === 'bottom') {
          if (eAttachment.top === 'top' && top + height > bounds[3]) {
            top -= targetHeight;
            tAttachment.top = 'top';

            top -= height;
            eAttachment.top = 'bottom';
          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
            top += height - targetHeight;
            tAttachment.top = 'top';

            eAttachment.top = 'top';
          }
        }

        if (tAttachment.top === 'middle') {
          if (top + height > bounds[3] && eAttachment.top === 'top') {
            top -= height;
            eAttachment.top = 'bottom';
          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
            top += height;
            eAttachment.top = 'top';
          }
        }
      }

      if (changeAttachX === 'target' || changeAttachX === 'both') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          left += targetWidth;
          tAttachment.left = 'right';
        }

        if (left + width > bounds[2] && tAttachment.left === 'right') {
          left -= targetWidth;
          tAttachment.left = 'left';
        }
      }

      if (changeAttachX === 'together') {
        if (left < bounds[0] && tAttachment.left === 'left') {
          if (eAttachment.left === 'right') {
            left += targetWidth;
            tAttachment.left = 'right';

            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'left') {
            left += targetWidth;
            tAttachment.left = 'right';

            left -= width;
            eAttachment.left = 'right';
          }
        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
          if (eAttachment.left === 'left') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'right') {
            left -= targetWidth;
            tAttachment.left = 'left';

            left += width;
            eAttachment.left = 'left';
          }
        } else if (tAttachment.left === 'center') {
          if (left + width > bounds[2] && eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (left < bounds[0] && eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          }
        }
      }

      if (changeAttachY === 'element' || changeAttachY === 'both') {
        if (top < bounds[1] && eAttachment.top === 'bottom') {
          top += height;
          eAttachment.top = 'top';
        }

        if (top + height > bounds[3] && eAttachment.top === 'top') {
          top -= height;
          eAttachment.top = 'bottom';
        }
      }

      if (changeAttachX === 'element' || changeAttachX === 'both') {
        if (left < bounds[0]) {
          if (eAttachment.left === 'right') {
            left += width;
            eAttachment.left = 'left';
          } else if (eAttachment.left === 'center') {
            left += width / 2;
            eAttachment.left = 'left';
          }
        }

        if (left + width > bounds[2]) {
          if (eAttachment.left === 'left') {
            left -= width;
            eAttachment.left = 'right';
          } else if (eAttachment.left === 'center') {
            left -= width / 2;
            eAttachment.left = 'right';
          }
        }
      }

      if (typeof pin === 'string') {
        pin = pin.split(',').map(function (p) {
          return p.trim();
        });
      } else if (pin === true) {
        pin = ['top', 'left', 'right', 'bottom'];
      }

      pin = pin || [];

      var pinned = [];
      var oob = [];

      if (top < bounds[1]) {
        if (pin.indexOf('top') >= 0) {
          top = bounds[1];
          pinned.push('top');
        } else {
          oob.push('top');
        }
      }

      if (top + height > bounds[3]) {
        if (pin.indexOf('bottom') >= 0) {
          top = bounds[3] - height;
          pinned.push('bottom');
        } else {
          oob.push('bottom');
        }
      }

      if (left < bounds[0]) {
        if (pin.indexOf('left') >= 0) {
          left = bounds[0];
          pinned.push('left');
        } else {
          oob.push('left');
        }
      }

      if (left + width > bounds[2]) {
        if (pin.indexOf('right') >= 0) {
          left = bounds[2] - width;
          pinned.push('right');
        } else {
          oob.push('right');
        }
      }

      if (pinned.length) {
        (function () {
          var pinnedClass = undefined;
          if (typeof _this.options.pinnedClass !== 'undefined') {
            pinnedClass = _this.options.pinnedClass;
          } else {
            pinnedClass = _this.getClass('pinned');
          }

          addClasses.push(pinnedClass);
          pinned.forEach(function (side) {
            addClasses.push(pinnedClass + '-' + side);
          });
        })();
      }

      if (oob.length) {
        (function () {
          var oobClass = undefined;
          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
            oobClass = _this.options.outOfBoundsClass;
          } else {
            oobClass = _this.getClass('out-of-bounds');
          }

          addClasses.push(oobClass);
          oob.forEach(function (side) {
            addClasses.push(oobClass + '-' + side);
          });
        })();
      }

      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
        eAttachment.left = tAttachment.left = false;
      }
      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
        eAttachment.top = tAttachment.top = false;
      }

      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
        _this.updateAttachClasses(eAttachment, tAttachment);
        _this.trigger('update', {
          attachment: eAttachment,
          targetAttachment: tAttachment
        });
      }
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return { top: top, left: left };
  }
});
/* globals TetherBase */

'use strict';

var _TetherBase$Utils = TetherBase.Utils;
var getBounds = _TetherBase$Utils.getBounds;
var updateClasses = _TetherBase$Utils.updateClasses;
var defer = _TetherBase$Utils.defer;

TetherBase.modules.push({
  position: function position(_ref) {
    var _this = this;

    var top = _ref.top;
    var left = _ref.left;

    var _cache = this.cache('element-bounds', function () {
      return getBounds(_this.element);
    });

    var height = _cache.height;
    var width = _cache.width;

    var targetPos = this.getTargetBounds();

    var bottom = top + height;
    var right = left + width;

    var abutted = [];
    if (top <= targetPos.bottom && bottom >= targetPos.top) {
      ['left', 'right'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === left || targetPosSide === right) {
          abutted.push(side);
        }
      });
    }

    if (left <= targetPos.right && right >= targetPos.left) {
      ['top', 'bottom'].forEach(function (side) {
        var targetPosSide = targetPos[side];
        if (targetPosSide === top || targetPosSide === bottom) {
          abutted.push(side);
        }
      });
    }

    var allClasses = [];
    var addClasses = [];

    var sides = ['left', 'top', 'right', 'bottom'];
    allClasses.push(this.getClass('abutted'));
    sides.forEach(function (side) {
      allClasses.push(_this.getClass('abutted') + '-' + side);
    });

    if (abutted.length) {
      addClasses.push(this.getClass('abutted'));
    }

    abutted.forEach(function (side) {
      addClasses.push(_this.getClass('abutted') + '-' + side);
    });

    defer(function () {
      if (!(_this.options.addTargetClasses === false)) {
        updateClasses(_this.target, addClasses, allClasses);
      }
      updateClasses(_this.element, addClasses, allClasses);
    });

    return true;
  }
});
/* globals TetherBase */

'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

TetherBase.modules.push({
  position: function position(_ref) {
    var top = _ref.top;
    var left = _ref.left;

    if (!this.options.shift) {
      return;
    }

    var shift = this.options.shift;
    if (typeof this.options.shift === 'function') {
      shift = this.options.shift.call(this, { top: top, left: left });
    }

    var shiftTop = undefined,
        shiftLeft = undefined;
    if (typeof shift === 'string') {
      shift = shift.split(' ');
      shift[1] = shift[1] || shift[0];

      var _shift = shift;

      var _shift2 = _slicedToArray(_shift, 2);

      shiftTop = _shift2[0];
      shiftLeft = _shift2[1];

      shiftTop = parseFloat(shiftTop, 10);
      shiftLeft = parseFloat(shiftLeft, 10);
    } else {
      shiftTop = shift.top;
      shiftLeft = shift.left;
    }

    top += shiftTop;
    left += shiftLeft;

    return { top: top, left: left };
  }
});
return Tether;

}));

},{}],"/usr/var/server.base/node_modules/underscore/underscore-umd.js":[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.4
  //     https://underscorejs.org
  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.4';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global) ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || (type === 'object' && !!obj);
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key] === true; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = toArray(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = (array && max(array, getLength).length) || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],"/usr/var/server.base/node_modules/xxhashjs/lib/index.js":[function(require,module,exports){
module.exports = {
	h32: require("./xxhash")
,	h64: require("./xxhash64")
}

},{"./xxhash":"/usr/var/server.base/node_modules/xxhashjs/lib/xxhash.js","./xxhash64":"/usr/var/server.base/node_modules/xxhashjs/lib/xxhash64.js"}],"/usr/var/server.base/node_modules/xxhashjs/lib/xxhash.js":[function(require,module,exports){
(function (Buffer){(function (){
/**
xxHash implementation in pure Javascript

Copyright (C) 2013, Pierre Curto
MIT license
*/
var UINT32 = require('cuint').UINT32

/*
	Merged this sequence of method calls as it speeds up
	the calculations by a factor of 2
 */
// this.v1.add( other.multiply(PRIME32_2) ).rotl(13).multiply(PRIME32_1);
UINT32.prototype.xxh_update = function (low, high) {
	var b00 = PRIME32_2._low
	var b16 = PRIME32_2._high

	var c16, c00
	c00 = low * b00
	c16 = c00 >>> 16

	c16 += high * b00
	c16 &= 0xFFFF		// Not required but improves performance
	c16 += low * b16

	var a00 = this._low + (c00 & 0xFFFF)
	var a16 = a00 >>> 16

	a16 += this._high + (c16 & 0xFFFF)

	var v = (a16 << 16) | (a00 & 0xFFFF)
	v = (v << 13) | (v >>> 19)

	a00 = v & 0xFFFF
	a16 = v >>> 16

	b00 = PRIME32_1._low
	b16 = PRIME32_1._high

	c00 = a00 * b00
	c16 = c00 >>> 16

	c16 += a16 * b00
	c16 &= 0xFFFF		// Not required but improves performance
	c16 += a00 * b16

	this._low = c00 & 0xFFFF
	this._high = c16 & 0xFFFF
}

/*
 * Constants
 */
var PRIME32_1 = UINT32( '2654435761' )
var PRIME32_2 = UINT32( '2246822519' )
var PRIME32_3 = UINT32( '3266489917' )
var PRIME32_4 = UINT32(  '668265263' )
var PRIME32_5 = UINT32(  '374761393' )

/**
* Convert string to proper UTF-8 array
* @param str Input string
* @returns {Uint8Array} UTF8 array is returned as uint8 array
*/
function toUTF8Array (str) {
	var utf8 = []
	for (var i=0, n=str.length; i < n; i++) {
		var charcode = str.charCodeAt(i)
		if (charcode < 0x80) utf8.push(charcode)
		else if (charcode < 0x800) {
			utf8.push(0xc0 | (charcode >> 6),
			0x80 | (charcode & 0x3f))
		}
		else if (charcode < 0xd800 || charcode >= 0xe000) {
			utf8.push(0xe0 | (charcode >> 12),
			0x80 | ((charcode>>6) & 0x3f),
			0x80 | (charcode & 0x3f))
		}
		// surrogate pair
		else {
			i++;
			// UTF-16 encodes 0x10000-0x10FFFF by
			// subtracting 0x10000 and splitting the
			// 20 bits of 0x0-0xFFFFF into two halves
			charcode = 0x10000 + (((charcode & 0x3ff)<<10)
			| (str.charCodeAt(i) & 0x3ff))
			utf8.push(0xf0 | (charcode >>18),
			0x80 | ((charcode>>12) & 0x3f),
			0x80 | ((charcode>>6) & 0x3f),
			0x80 | (charcode & 0x3f))
		}
	}

	return new Uint8Array(utf8)
}

/**
 * XXH object used as a constructor or a function
 * @constructor
 * or
 * @param {Object|String} input data
 * @param {Number|UINT32} seed
 * @return ThisExpression
 * or
 * @return {UINT32} xxHash
 */
function XXH () {
	if (arguments.length == 2)
		return new XXH( arguments[1] ).update( arguments[0] ).digest()

	if (!(this instanceof XXH))
		return new XXH( arguments[0] )

	init.call(this, arguments[0])
}

/**
 * Initialize the XXH instance with the given seed
 * @method init
 * @param {Number|Object} seed as a number or an unsigned 32 bits integer
 * @return ThisExpression
 */
 function init (seed) {
	this.seed = seed instanceof UINT32 ? seed.clone() : UINT32(seed)
	this.v1 = this.seed.clone().add(PRIME32_1).add(PRIME32_2)
	this.v2 = this.seed.clone().add(PRIME32_2)
	this.v3 = this.seed.clone()
	this.v4 = this.seed.clone().subtract(PRIME32_1)
	this.total_len = 0
	this.memsize = 0
	this.memory = null

	return this
}
XXH.prototype.init = init

/**
 * Add data to be computed for the XXH hash
 * @method update
 * @param {String|Buffer|ArrayBuffer} input as a string or nodejs Buffer or ArrayBuffer
 * @return ThisExpression
 */
XXH.prototype.update = function (input) {
	var isString = typeof input == 'string'
	var isArrayBuffer

	// Convert all strings to utf-8 first (issue #5)
	if (isString) {
		input = toUTF8Array(input)
		isString = false
		isArrayBuffer = true
	}

	if (typeof ArrayBuffer !== "undefined" && input instanceof ArrayBuffer)
	{
		isArrayBuffer = true
		input = new Uint8Array(input);
	}

	var p = 0
	var len = input.length
	var bEnd = p + len

	if (len == 0) return this

	this.total_len += len

	if (this.memsize == 0)
	{
		if (isString) {
			this.memory = ''
		} else if (isArrayBuffer) {
			this.memory = new Uint8Array(16)
		} else {
			this.memory = new Buffer(16)
		}
	}

	if (this.memsize + len < 16)   // fill in tmp buffer
	{
		// XXH_memcpy(this.memory + this.memsize, input, len)
		if (isString) {
			this.memory += input
		} else if (isArrayBuffer) {
			this.memory.set( input.subarray(0, len), this.memsize )
		} else {
			input.copy( this.memory, this.memsize, 0, len )
		}

		this.memsize += len
		return this
	}

	if (this.memsize > 0)   // some data left from previous update
	{
		// XXH_memcpy(this.memory + this.memsize, input, 16-this.memsize);
		if (isString) {
			this.memory += input.slice(0, 16 - this.memsize)
		} else if (isArrayBuffer) {
			this.memory.set( input.subarray(0, 16 - this.memsize), this.memsize )
		} else {
			input.copy( this.memory, this.memsize, 0, 16 - this.memsize )
		}

		var p32 = 0
		if (isString) {
			this.v1.xxh_update(
				(this.memory.charCodeAt(p32+1) << 8) | this.memory.charCodeAt(p32)
			,	(this.memory.charCodeAt(p32+3) << 8) | this.memory.charCodeAt(p32+2)
			)
			p32 += 4
			this.v2.xxh_update(
				(this.memory.charCodeAt(p32+1) << 8) | this.memory.charCodeAt(p32)
			,	(this.memory.charCodeAt(p32+3) << 8) | this.memory.charCodeAt(p32+2)
			)
			p32 += 4
			this.v3.xxh_update(
				(this.memory.charCodeAt(p32+1) << 8) | this.memory.charCodeAt(p32)
			,	(this.memory.charCodeAt(p32+3) << 8) | this.memory.charCodeAt(p32+2)
			)
			p32 += 4
			this.v4.xxh_update(
				(this.memory.charCodeAt(p32+1) << 8) | this.memory.charCodeAt(p32)
			,	(this.memory.charCodeAt(p32+3) << 8) | this.memory.charCodeAt(p32+2)
			)
		} else {
			this.v1.xxh_update(
				(this.memory[p32+1] << 8) | this.memory[p32]
			,	(this.memory[p32+3] << 8) | this.memory[p32+2]
			)
			p32 += 4
			this.v2.xxh_update(
				(this.memory[p32+1] << 8) | this.memory[p32]
			,	(this.memory[p32+3] << 8) | this.memory[p32+2]
			)
			p32 += 4
			this.v3.xxh_update(
				(this.memory[p32+1] << 8) | this.memory[p32]
			,	(this.memory[p32+3] << 8) | this.memory[p32+2]
			)
			p32 += 4
			this.v4.xxh_update(
				(this.memory[p32+1] << 8) | this.memory[p32]
			,	(this.memory[p32+3] << 8) | this.memory[p32+2]
			)
		}

		p += 16 - this.memsize
		this.memsize = 0
		if (isString) this.memory = ''
	}

	if (p <= bEnd - 16)
	{
		var limit = bEnd - 16

		do
		{
			if (isString) {
				this.v1.xxh_update(
					(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
				,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
				)
				p += 4
				this.v2.xxh_update(
					(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
				,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
				)
				p += 4
				this.v3.xxh_update(
					(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
				,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
				)
				p += 4
				this.v4.xxh_update(
					(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
				,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
				)
			} else {
				this.v1.xxh_update(
					(input[p+1] << 8) | input[p]
				,	(input[p+3] << 8) | input[p+2]
				)
				p += 4
				this.v2.xxh_update(
					(input[p+1] << 8) | input[p]
				,	(input[p+3] << 8) | input[p+2]
				)
				p += 4
				this.v3.xxh_update(
					(input[p+1] << 8) | input[p]
				,	(input[p+3] << 8) | input[p+2]
				)
				p += 4
				this.v4.xxh_update(
					(input[p+1] << 8) | input[p]
				,	(input[p+3] << 8) | input[p+2]
				)
			}
			p += 4
		} while (p <= limit)
	}

	if (p < bEnd)
	{
		// XXH_memcpy(this.memory, p, bEnd-p);
		if (isString) {
			this.memory += input.slice(p)
		} else if (isArrayBuffer) {
			this.memory.set( input.subarray(p, bEnd), this.memsize )
		} else {
			input.copy( this.memory, this.memsize, p, bEnd )
		}

		this.memsize = bEnd - p
	}

	return this
}

/**
 * Finalize the XXH computation. The XXH instance is ready for reuse for the given seed
 * @method digest
 * @return {UINT32} xxHash
 */
XXH.prototype.digest = function () {
	var input = this.memory
	var isString = typeof input == 'string'
	var p = 0
	var bEnd = this.memsize
	var h32, h
	var u = new UINT32

	if (this.total_len >= 16)
	{
		h32 = this.v1.rotl(1).add( this.v2.rotl(7).add( this.v3.rotl(12).add( this.v4.rotl(18) ) ) )
	}
	else
	{
		h32  = this.seed.clone().add( PRIME32_5 )
	}

	h32.add( u.fromNumber(this.total_len) )

	while (p <= bEnd - 4)
	{
		if (isString) {
			u.fromBits(
				(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
			,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
			)
		} else {
			u.fromBits(
				(input[p+1] << 8) | input[p]
			,	(input[p+3] << 8) | input[p+2]
			)
		}
		h32
			.add( u.multiply(PRIME32_3) )
			.rotl(17)
			.multiply( PRIME32_4 )
		p += 4
	}

	while (p < bEnd)
	{
		u.fromBits( isString ? input.charCodeAt(p++) : input[p++], 0 )
		h32
			.add( u.multiply(PRIME32_5) )
			.rotl(11)
			.multiply(PRIME32_1)
	}

	h = h32.clone().shiftRight(15)
	h32.xor(h).multiply(PRIME32_2)

	h = h32.clone().shiftRight(13)
	h32.xor(h).multiply(PRIME32_3)

	h = h32.clone().shiftRight(16)
	h32.xor(h)

	// Reset the state
	this.init( this.seed )

	return h32
}

module.exports = XXH

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":"/usr/var/server.base/node_modules/browserify/node_modules/buffer/index.js","cuint":"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/index.js"}],"/usr/var/server.base/node_modules/xxhashjs/lib/xxhash64.js":[function(require,module,exports){
(function (Buffer){(function (){
/**
xxHash64 implementation in pure Javascript

Copyright (C) 2016, Pierre Curto
MIT license
*/
var UINT64 = require('cuint').UINT64

/*
 * Constants
 */
var PRIME64_1 = UINT64( '11400714785074694791' )
var PRIME64_2 = UINT64( '14029467366897019727' )
var PRIME64_3 = UINT64(  '1609587929392839161' )
var PRIME64_4 = UINT64(  '9650029242287828579' )
var PRIME64_5 = UINT64(  '2870177450012600261' )

/**
* Convert string to proper UTF-8 array
* @param str Input string
* @returns {Uint8Array} UTF8 array is returned as uint8 array
*/
function toUTF8Array (str) {
	var utf8 = []
	for (var i=0, n=str.length; i < n; i++) {
		var charcode = str.charCodeAt(i)
		if (charcode < 0x80) utf8.push(charcode)
		else if (charcode < 0x800) {
			utf8.push(0xc0 | (charcode >> 6),
			0x80 | (charcode & 0x3f))
		}
		else if (charcode < 0xd800 || charcode >= 0xe000) {
			utf8.push(0xe0 | (charcode >> 12),
			0x80 | ((charcode>>6) & 0x3f),
			0x80 | (charcode & 0x3f))
		}
		// surrogate pair
		else {
			i++;
			// UTF-16 encodes 0x10000-0x10FFFF by
			// subtracting 0x10000 and splitting the
			// 20 bits of 0x0-0xFFFFF into two halves
			charcode = 0x10000 + (((charcode & 0x3ff)<<10)
			| (str.charCodeAt(i) & 0x3ff))
			utf8.push(0xf0 | (charcode >>18),
			0x80 | ((charcode>>12) & 0x3f),
			0x80 | ((charcode>>6) & 0x3f),
			0x80 | (charcode & 0x3f))
		}
	}

	return new Uint8Array(utf8)
}

/**
 * XXH64 object used as a constructor or a function
 * @constructor
 * or
 * @param {Object|String} input data
 * @param {Number|UINT64} seed
 * @return ThisExpression
 * or
 * @return {UINT64} xxHash
 */
function XXH64 () {
	if (arguments.length == 2)
		return new XXH64( arguments[1] ).update( arguments[0] ).digest()

	if (!(this instanceof XXH64))
		return new XXH64( arguments[0] )

	init.call(this, arguments[0])
}

/**
 * Initialize the XXH64 instance with the given seed
 * @method init
 * @param {Number|Object} seed as a number or an unsigned 32 bits integer
 * @return ThisExpression
 */
 function init (seed) {
	this.seed = seed instanceof UINT64 ? seed.clone() : UINT64(seed)
	this.v1 = this.seed.clone().add(PRIME64_1).add(PRIME64_2)
	this.v2 = this.seed.clone().add(PRIME64_2)
	this.v3 = this.seed.clone()
	this.v4 = this.seed.clone().subtract(PRIME64_1)
	this.total_len = 0
	this.memsize = 0
	this.memory = null

	return this
}
XXH64.prototype.init = init

/**
 * Add data to be computed for the XXH64 hash
 * @method update
 * @param {String|Buffer|ArrayBuffer} input as a string or nodejs Buffer or ArrayBuffer
 * @return ThisExpression
 */
XXH64.prototype.update = function (input) {
	var isString = typeof input == 'string'
	var isArrayBuffer

	// Convert all strings to utf-8 first (issue #5)
	if (isString) {
		input = toUTF8Array(input)
		isString = false
		isArrayBuffer = true
	}

	if (typeof ArrayBuffer !== "undefined" && input instanceof ArrayBuffer)
	{
		isArrayBuffer = true
		input = new Uint8Array(input);
	}

	var p = 0
	var len = input.length
	var bEnd = p + len

	if (len == 0) return this

	this.total_len += len

	if (this.memsize == 0)
	{
		if (isString) {
			this.memory = ''
		} else if (isArrayBuffer) {
			this.memory = new Uint8Array(32)
		} else {
			this.memory = new Buffer(32)
		}
	}

	if (this.memsize + len < 32)   // fill in tmp buffer
	{
		// XXH64_memcpy(this.memory + this.memsize, input, len)
		if (isString) {
			this.memory += input
		} else if (isArrayBuffer) {
			this.memory.set( input.subarray(0, len), this.memsize )
		} else {
			input.copy( this.memory, this.memsize, 0, len )
		}

		this.memsize += len
		return this
	}

	if (this.memsize > 0)   // some data left from previous update
	{
		// XXH64_memcpy(this.memory + this.memsize, input, 16-this.memsize);
		if (isString) {
			this.memory += input.slice(0, 32 - this.memsize)
		} else if (isArrayBuffer) {
			this.memory.set( input.subarray(0, 32 - this.memsize), this.memsize )
		} else {
			input.copy( this.memory, this.memsize, 0, 32 - this.memsize )
		}

		var p64 = 0
		if (isString) {
			var other
			other = UINT64(
					(this.memory.charCodeAt(p64+1) << 8) | this.memory.charCodeAt(p64)
				,	(this.memory.charCodeAt(p64+3) << 8) | this.memory.charCodeAt(p64+2)
				,	(this.memory.charCodeAt(p64+5) << 8) | this.memory.charCodeAt(p64+4)
				,	(this.memory.charCodeAt(p64+7) << 8) | this.memory.charCodeAt(p64+6)
				)
			this.v1.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			p64 += 8
			other = UINT64(
					(this.memory.charCodeAt(p64+1) << 8) | this.memory.charCodeAt(p64)
				,	(this.memory.charCodeAt(p64+3) << 8) | this.memory.charCodeAt(p64+2)
				,	(this.memory.charCodeAt(p64+5) << 8) | this.memory.charCodeAt(p64+4)
				,	(this.memory.charCodeAt(p64+7) << 8) | this.memory.charCodeAt(p64+6)
				)
			this.v2.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			p64 += 8
			other = UINT64(
					(this.memory.charCodeAt(p64+1) << 8) | this.memory.charCodeAt(p64)
				,	(this.memory.charCodeAt(p64+3) << 8) | this.memory.charCodeAt(p64+2)
				,	(this.memory.charCodeAt(p64+5) << 8) | this.memory.charCodeAt(p64+4)
				,	(this.memory.charCodeAt(p64+7) << 8) | this.memory.charCodeAt(p64+6)
				)
			this.v3.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			p64 += 8
			other = UINT64(
					(this.memory.charCodeAt(p64+1) << 8) | this.memory.charCodeAt(p64)
				,	(this.memory.charCodeAt(p64+3) << 8) | this.memory.charCodeAt(p64+2)
				,	(this.memory.charCodeAt(p64+5) << 8) | this.memory.charCodeAt(p64+4)
				,	(this.memory.charCodeAt(p64+7) << 8) | this.memory.charCodeAt(p64+6)
				)
			this.v4.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
		} else {
			var other
			other = UINT64(
					(this.memory[p64+1] << 8) | this.memory[p64]
				,	(this.memory[p64+3] << 8) | this.memory[p64+2]
				,	(this.memory[p64+5] << 8) | this.memory[p64+4]
				,	(this.memory[p64+7] << 8) | this.memory[p64+6]
				)
			this.v1.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			p64 += 8
			other = UINT64(
					(this.memory[p64+1] << 8) | this.memory[p64]
				,	(this.memory[p64+3] << 8) | this.memory[p64+2]
				,	(this.memory[p64+5] << 8) | this.memory[p64+4]
				,	(this.memory[p64+7] << 8) | this.memory[p64+6]
				)
			this.v2.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			p64 += 8
			other = UINT64(
					(this.memory[p64+1] << 8) | this.memory[p64]
				,	(this.memory[p64+3] << 8) | this.memory[p64+2]
				,	(this.memory[p64+5] << 8) | this.memory[p64+4]
				,	(this.memory[p64+7] << 8) | this.memory[p64+6]
				)
			this.v3.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			p64 += 8
			other = UINT64(
					(this.memory[p64+1] << 8) | this.memory[p64]
				,	(this.memory[p64+3] << 8) | this.memory[p64+2]
				,	(this.memory[p64+5] << 8) | this.memory[p64+4]
				,	(this.memory[p64+7] << 8) | this.memory[p64+6]
				)
			this.v4.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
		}

		p += 32 - this.memsize
		this.memsize = 0
		if (isString) this.memory = ''
	}

	if (p <= bEnd - 32)
	{
		var limit = bEnd - 32

		do
		{
			if (isString) {
				var other
				other = UINT64(
						(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
					,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
					,	(input.charCodeAt(p+5) << 8) | input.charCodeAt(p+4)
					,	(input.charCodeAt(p+7) << 8) | input.charCodeAt(p+6)
					)
				this.v1.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
				p += 8
				other = UINT64(
						(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
					,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
					,	(input.charCodeAt(p+5) << 8) | input.charCodeAt(p+4)
					,	(input.charCodeAt(p+7) << 8) | input.charCodeAt(p+6)
					)
				this.v2.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
				p += 8
				other = UINT64(
						(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
					,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
					,	(input.charCodeAt(p+5) << 8) | input.charCodeAt(p+4)
					,	(input.charCodeAt(p+7) << 8) | input.charCodeAt(p+6)
					)
				this.v3.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
				p += 8
				other = UINT64(
						(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
					,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
					,	(input.charCodeAt(p+5) << 8) | input.charCodeAt(p+4)
					,	(input.charCodeAt(p+7) << 8) | input.charCodeAt(p+6)
					)
				this.v4.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			} else {
				var other
				other = UINT64(
						(input[p+1] << 8) | input[p]
					,	(input[p+3] << 8) | input[p+2]
					,	(input[p+5] << 8) | input[p+4]
					,	(input[p+7] << 8) | input[p+6]
					)
				this.v1.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
				p += 8
				other = UINT64(
						(input[p+1] << 8) | input[p]
					,	(input[p+3] << 8) | input[p+2]
					,	(input[p+5] << 8) | input[p+4]
					,	(input[p+7] << 8) | input[p+6]
					)
				this.v2.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
				p += 8
				other = UINT64(
						(input[p+1] << 8) | input[p]
					,	(input[p+3] << 8) | input[p+2]
					,	(input[p+5] << 8) | input[p+4]
					,	(input[p+7] << 8) | input[p+6]
					)
				this.v3.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
				p += 8
				other = UINT64(
						(input[p+1] << 8) | input[p]
					,	(input[p+3] << 8) | input[p+2]
					,	(input[p+5] << 8) | input[p+4]
					,	(input[p+7] << 8) | input[p+6]
					)
				this.v4.add( other.multiply(PRIME64_2) ).rotl(31).multiply(PRIME64_1);
			}
			p += 8
		} while (p <= limit)
	}

	if (p < bEnd)
	{
		// XXH64_memcpy(this.memory, p, bEnd-p);
		if (isString) {
			this.memory += input.slice(p)
		} else if (isArrayBuffer) {
			this.memory.set( input.subarray(p, bEnd), this.memsize )
		} else {
			input.copy( this.memory, this.memsize, p, bEnd )
		}

		this.memsize = bEnd - p
	}

	return this
}

/**
 * Finalize the XXH64 computation. The XXH64 instance is ready for reuse for the given seed
 * @method digest
 * @return {UINT64} xxHash
 */
XXH64.prototype.digest = function () {
	var input = this.memory
	var isString = typeof input == 'string'
	var p = 0
	var bEnd = this.memsize
	var h64, h
	var u = new UINT64

	if (this.total_len >= 32)
	{
		h64 = this.v1.clone().rotl(1)
		h64.add( this.v2.clone().rotl(7) )
		h64.add( this.v3.clone().rotl(12) )
		h64.add( this.v4.clone().rotl(18) )

		h64.xor( this.v1.multiply(PRIME64_2).rotl(31).multiply(PRIME64_1) )
		h64.multiply(PRIME64_1).add(PRIME64_4)

		h64.xor( this.v2.multiply(PRIME64_2).rotl(31).multiply(PRIME64_1) )
		h64.multiply(PRIME64_1).add(PRIME64_4)

		h64.xor( this.v3.multiply(PRIME64_2).rotl(31).multiply(PRIME64_1) )
		h64.multiply(PRIME64_1).add(PRIME64_4)

		h64.xor( this.v4.multiply(PRIME64_2).rotl(31).multiply(PRIME64_1) )
		h64.multiply(PRIME64_1).add(PRIME64_4)
	}
	else
	{
		h64  = this.seed.clone().add( PRIME64_5 )
	}

	h64.add( u.fromNumber(this.total_len) )

	while (p <= bEnd - 8)
	{
		if (isString) {
			u.fromBits(
				(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
			,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
			,	(input.charCodeAt(p+5) << 8) | input.charCodeAt(p+4)
			,	(input.charCodeAt(p+7) << 8) | input.charCodeAt(p+6)
			)
		} else {
			u.fromBits(
				(input[p+1] << 8) | input[p]
			,	(input[p+3] << 8) | input[p+2]
			,	(input[p+5] << 8) | input[p+4]
			,	(input[p+7] << 8) | input[p+6]
			)
		}
		u.multiply(PRIME64_2).rotl(31).multiply(PRIME64_1)
		h64
			.xor(u)
			.rotl(27)
			.multiply( PRIME64_1 )
			.add( PRIME64_4 )
		p += 8
	}

	if (p + 4 <= bEnd) {
		if (isString) {
			u.fromBits(
				(input.charCodeAt(p+1) << 8) | input.charCodeAt(p)
			,	(input.charCodeAt(p+3) << 8) | input.charCodeAt(p+2)
			,	0
			,	0
			)
		} else {
			u.fromBits(
				(input[p+1] << 8) | input[p]
			,	(input[p+3] << 8) | input[p+2]
			,	0
			,	0
			)
		}
		h64
			.xor( u.multiply(PRIME64_1) )
			.rotl(23)
			.multiply( PRIME64_2 )
			.add( PRIME64_3 )
		p += 4
	}

	while (p < bEnd)
	{
		u.fromBits( isString ? input.charCodeAt(p++) : input[p++], 0, 0, 0 )
		h64
			.xor( u.multiply(PRIME64_5) )
			.rotl(11)
			.multiply(PRIME64_1)
	}

	h = h64.clone().shiftRight(33)
	h64.xor(h).multiply(PRIME64_2)

	h = h64.clone().shiftRight(29)
	h64.xor(h).multiply(PRIME64_3)

	h = h64.clone().shiftRight(32)
	h64.xor(h)

	// Reset the state
	this.init( this.seed )

	return h64
}

module.exports = XXH64

}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":"/usr/var/server.base/node_modules/browserify/node_modules/buffer/index.js","cuint":"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/index.js"}],"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/index.js":[function(require,module,exports){
exports.UINT32 = require('./lib/uint32')
exports.UINT64 = require('./lib/uint64')
},{"./lib/uint32":"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/lib/uint32.js","./lib/uint64":"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/lib/uint64.js"}],"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/lib/uint32.js":[function(require,module,exports){
/**
	C-like unsigned 32 bits integers in Javascript
	Copyright (C) 2013, Pierre Curto
	MIT license
 */
;(function (root) {

	// Local cache for typical radices
	var radixPowerCache = {
		36: UINT32( Math.pow(36, 5) )
	,	16: UINT32( Math.pow(16, 7) )
	,	10: UINT32( Math.pow(10, 9) )
	,	2:  UINT32( Math.pow(2, 30) )
	}
	var radixCache = {
		36: UINT32(36)
	,	16: UINT32(16)
	,	10: UINT32(10)
	,	2:  UINT32(2)
	}

	/**
	 *	Represents an unsigned 32 bits integer
	 * @constructor
	 * @param {Number|String|Number} low bits     | integer as a string 		 | integer as a number
	 * @param {Number|Number|Undefined} high bits | radix (optional, default=10)
	 * @return 
	 */
	function UINT32 (l, h) {
		if ( !(this instanceof UINT32) )
			return new UINT32(l, h)

		this._low = 0
		this._high = 0
		this.remainder = null
		if (typeof h == 'undefined')
			return fromNumber.call(this, l)

		if (typeof l == 'string')
			return fromString.call(this, l, h)

		fromBits.call(this, l, h)
	}

	/**
	 * Set the current _UINT32_ object with its low and high bits
	 * @method fromBits
	 * @param {Number} low bits
	 * @param {Number} high bits
	 * @return ThisExpression
	 */
	function fromBits (l, h) {
		this._low = l | 0
		this._high = h | 0

		return this
	}
	UINT32.prototype.fromBits = fromBits

	/**
	 * Set the current _UINT32_ object from a number
	 * @method fromNumber
	 * @param {Number} number
	 * @return ThisExpression
	 */
	function fromNumber (value) {
		this._low = value & 0xFFFF
		this._high = value >>> 16

		return this
	}
	UINT32.prototype.fromNumber = fromNumber

	/**
	 * Set the current _UINT32_ object from a string
	 * @method fromString
	 * @param {String} integer as a string
	 * @param {Number} radix (optional, default=10)
	 * @return ThisExpression
	 */
	function fromString (s, radix) {
		var value = parseInt(s, radix || 10)

		this._low = value & 0xFFFF
		this._high = value >>> 16

		return this
	}
	UINT32.prototype.fromString = fromString

	/**
	 * Convert this _UINT32_ to a number
	 * @method toNumber
	 * @return {Number} the converted UINT32
	 */
	UINT32.prototype.toNumber = function () {
		return (this._high * 65536) + this._low
	}

	/**
	 * Convert this _UINT32_ to a string
	 * @method toString
	 * @param {Number} radix (optional, default=10)
	 * @return {String} the converted UINT32
	 */
	UINT32.prototype.toString = function (radix) {
		return this.toNumber().toString(radix || 10)
	}

	/**
	 * Add two _UINT32_. The current _UINT32_ stores the result
	 * @method add
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.add = function (other) {
		var a00 = this._low + other._low
		var a16 = a00 >>> 16

		a16 += this._high + other._high

		this._low = a00 & 0xFFFF
		this._high = a16 & 0xFFFF

		return this
	}

	/**
	 * Subtract two _UINT32_. The current _UINT32_ stores the result
	 * @method subtract
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.subtract = function (other) {
		//TODO inline
		return this.add( other.clone().negate() )
	}

	/**
	 * Multiply two _UINT32_. The current _UINT32_ stores the result
	 * @method multiply
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.multiply = function (other) {
		/*
			a = a00 + a16
			b = b00 + b16
			a*b = (a00 + a16)(b00 + b16)
				= a00b00 + a00b16 + a16b00 + a16b16

			a16b16 overflows the 32bits
		 */
		var a16 = this._high
		var a00 = this._low
		var b16 = other._high
		var b00 = other._low

/* Removed to increase speed under normal circumstances (i.e. not multiplying by 0 or 1)
		// this == 0 or other == 1: nothing to do
		if ((a00 == 0 && a16 == 0) || (b00 == 1 && b16 == 0)) return this

		// other == 0 or this == 1: this = other
		if ((b00 == 0 && b16 == 0) || (a00 == 1 && a16 == 0)) {
			this._low = other._low
			this._high = other._high
			return this
		}
*/

		var c16, c00
		c00 = a00 * b00
		c16 = c00 >>> 16

		c16 += a16 * b00
		c16 &= 0xFFFF		// Not required but improves performance
		c16 += a00 * b16

		this._low = c00 & 0xFFFF
		this._high = c16 & 0xFFFF

		return this
	}

	/**
	 * Divide two _UINT32_. The current _UINT32_ stores the result.
	 * The remainder is made available as the _remainder_ property on
	 * the _UINT32_ object. It can be null, meaning there are no remainder.
	 * @method div
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.div = function (other) {
		if ( (other._low == 0) && (other._high == 0) ) throw Error('division by zero')

		// other == 1
		if (other._high == 0 && other._low == 1) {
			this.remainder = new UINT32(0)
			return this
		}

		// other > this: 0
		if ( other.gt(this) ) {
			this.remainder = this.clone()
			this._low = 0
			this._high = 0
			return this
		}
		// other == this: 1
		if ( this.eq(other) ) {
			this.remainder = new UINT32(0)
			this._low = 1
			this._high = 0
			return this
		}

		// Shift the divisor left until it is higher than the dividend
		var _other = other.clone()
		var i = -1
		while ( !this.lt(_other) ) {
			// High bit can overflow the default 16bits
			// Its ok since we right shift after this loop
			// The overflown bit must be kept though
			_other.shiftLeft(1, true)
			i++
		}

		// Set the remainder
		this.remainder = this.clone()
		// Initialize the current result to 0
		this._low = 0
		this._high = 0
		for (; i >= 0; i--) {
			_other.shiftRight(1)
			// If shifted divisor is smaller than the dividend
			// then subtract it from the dividend
			if ( !this.remainder.lt(_other) ) {
				this.remainder.subtract(_other)
				// Update the current result
				if (i >= 16) {
					this._high |= 1 << (i - 16)
				} else {
					this._low |= 1 << i
				}
			}
		}

		return this
	}

	/**
	 * Negate the current _UINT32_
	 * @method negate
	 * @return ThisExpression
	 */
	UINT32.prototype.negate = function () {
		var v = ( ~this._low & 0xFFFF ) + 1
		this._low = v & 0xFFFF
		this._high = (~this._high + (v >>> 16)) & 0xFFFF

		return this
	}

	/**
	 * Equals
	 * @method eq
	 * @param {Object} other UINT32
	 * @return {Boolean}
	 */
	UINT32.prototype.equals = UINT32.prototype.eq = function (other) {
		return (this._low == other._low) && (this._high == other._high)
	}

	/**
	 * Greater than (strict)
	 * @method gt
	 * @param {Object} other UINT32
	 * @return {Boolean}
	 */
	UINT32.prototype.greaterThan = UINT32.prototype.gt = function (other) {
		if (this._high > other._high) return true
		if (this._high < other._high) return false
		return this._low > other._low
	}

	/**
	 * Less than (strict)
	 * @method lt
	 * @param {Object} other UINT32
	 * @return {Boolean}
	 */
	UINT32.prototype.lessThan = UINT32.prototype.lt = function (other) {
		if (this._high < other._high) return true
		if (this._high > other._high) return false
		return this._low < other._low
	}

	/**
	 * Bitwise OR
	 * @method or
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.or = function (other) {
		this._low |= other._low
		this._high |= other._high

		return this
	}

	/**
	 * Bitwise AND
	 * @method and
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.and = function (other) {
		this._low &= other._low
		this._high &= other._high

		return this
	}

	/**
	 * Bitwise NOT
	 * @method not
	 * @return ThisExpression
	 */
	UINT32.prototype.not = function() {
		this._low = ~this._low & 0xFFFF
		this._high = ~this._high & 0xFFFF

		return this
	}

	/**
	 * Bitwise XOR
	 * @method xor
	 * @param {Object} other UINT32
	 * @return ThisExpression
	 */
	UINT32.prototype.xor = function (other) {
		this._low ^= other._low
		this._high ^= other._high

		return this
	}

	/**
	 * Bitwise shift right
	 * @method shiftRight
	 * @param {Number} number of bits to shift
	 * @return ThisExpression
	 */
	UINT32.prototype.shiftRight = UINT32.prototype.shiftr = function (n) {
		if (n > 16) {
			this._low = this._high >> (n - 16)
			this._high = 0
		} else if (n == 16) {
			this._low = this._high
			this._high = 0
		} else {
			this._low = (this._low >> n) | ( (this._high << (16-n)) & 0xFFFF )
			this._high >>= n
		}

		return this
	}

	/**
	 * Bitwise shift left
	 * @method shiftLeft
	 * @param {Number} number of bits to shift
	 * @param {Boolean} allow overflow
	 * @return ThisExpression
	 */
	UINT32.prototype.shiftLeft = UINT32.prototype.shiftl = function (n, allowOverflow) {
		if (n > 16) {
			this._high = this._low << (n - 16)
			this._low = 0
			if (!allowOverflow) {
				this._high &= 0xFFFF
			}
		} else if (n == 16) {
			this._high = this._low
			this._low = 0
		} else {
			this._high = (this._high << n) | (this._low >> (16-n))
			this._low = (this._low << n) & 0xFFFF
			if (!allowOverflow) {
				// Overflow only allowed on the high bits...
				this._high &= 0xFFFF
			}
		}

		return this
	}

	/**
	 * Bitwise rotate left
	 * @method rotl
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */
	UINT32.prototype.rotateLeft = UINT32.prototype.rotl = function (n) {
		var v = (this._high << 16) | this._low
		v = (v << n) | (v >>> (32 - n))
		this._low = v & 0xFFFF
		this._high = v >>> 16

		return this
	}

	/**
	 * Bitwise rotate right
	 * @method rotr
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */
	UINT32.prototype.rotateRight = UINT32.prototype.rotr = function (n) {
		var v = (this._high << 16) | this._low
		v = (v >>> n) | (v << (32 - n))
		this._low = v & 0xFFFF
		this._high = v >>> 16

		return this
	}

	/**
	 * Clone the current _UINT32_
	 * @method clone
	 * @return {Object} cloned UINT32
	 */
	UINT32.prototype.clone = function () {
		return new UINT32(this._low, this._high)
	}

	if (typeof define != 'undefined' && define.amd) {
		// AMD / RequireJS
		define([], function () {
			return UINT32
		})
	} else if (typeof module != 'undefined' && module.exports) {
		// Node.js
		module.exports = UINT32
	} else {
		// Browser
		root['UINT32'] = UINT32
	}

})(this)

},{}],"/usr/var/server.base/node_modules/xxhashjs/node_modules/cuint/lib/uint64.js":[function(require,module,exports){
/**
	C-like unsigned 64 bits integers in Javascript
	Copyright (C) 2013, Pierre Curto
	MIT license
 */
;(function (root) {

	// Local cache for typical radices
	var radixPowerCache = {
		16: UINT64( Math.pow(16, 5) )
	,	10: UINT64( Math.pow(10, 5) )
	,	2:  UINT64( Math.pow(2, 5) )
	}
	var radixCache = {
		16: UINT64(16)
	,	10: UINT64(10)
	,	2:  UINT64(2)
	}

	/**
	 *	Represents an unsigned 64 bits integer
	 * @constructor
	 * @param {Number} first low bits (8)
	 * @param {Number} second low bits (8)
	 * @param {Number} first high bits (8)
	 * @param {Number} second high bits (8)
	 * or
	 * @param {Number} low bits (32)
	 * @param {Number} high bits (32)
	 * or
	 * @param {String|Number} integer as a string 		 | integer as a number
	 * @param {Number|Undefined} radix (optional, default=10)
	 * @return 
	 */
	function UINT64 (a00, a16, a32, a48) {
		if ( !(this instanceof UINT64) )
			return new UINT64(a00, a16, a32, a48)

		this.remainder = null
		if (typeof a00 == 'string')
			return fromString.call(this, a00, a16)

		if (typeof a16 == 'undefined')
			return fromNumber.call(this, a00)

		fromBits.apply(this, arguments)
	}

	/**
	 * Set the current _UINT64_ object with its low and high bits
	 * @method fromBits
	 * @param {Number} first low bits (8)
	 * @param {Number} second low bits (8)
	 * @param {Number} first high bits (8)
	 * @param {Number} second high bits (8)
	 * or
	 * @param {Number} low bits (32)
	 * @param {Number} high bits (32)
	 * @return ThisExpression
	 */
	function fromBits (a00, a16, a32, a48) {
		if (typeof a32 == 'undefined') {
			this._a00 = a00 & 0xFFFF
			this._a16 = a00 >>> 16
			this._a32 = a16 & 0xFFFF
			this._a48 = a16 >>> 16
			return this
		}

		this._a00 = a00 | 0
		this._a16 = a16 | 0
		this._a32 = a32 | 0
		this._a48 = a48 | 0

		return this
	}
	UINT64.prototype.fromBits = fromBits

	/**
	 * Set the current _UINT64_ object from a number
	 * @method fromNumber
	 * @param {Number} number
	 * @return ThisExpression
	 */
	function fromNumber (value) {
		this._a00 = value & 0xFFFF
		this._a16 = value >>> 16
		this._a32 = 0
		this._a48 = 0

		return this
	}
	UINT64.prototype.fromNumber = fromNumber

	/**
	 * Set the current _UINT64_ object from a string
	 * @method fromString
	 * @param {String} integer as a string
	 * @param {Number} radix (optional, default=10)
	 * @return ThisExpression
	 */
	function fromString (s, radix) {
		radix = radix || 10

		this._a00 = 0
		this._a16 = 0
		this._a32 = 0
		this._a48 = 0

		/*
			In Javascript, bitwise operators only operate on the first 32 bits 
			of a number, even though parseInt() encodes numbers with a 53 bits 
			mantissa.
			Therefore UINT64(<Number>) can only work on 32 bits.
			The radix maximum value is 36 (as per ECMA specs) (26 letters + 10 digits)
			maximum input value is m = 32bits as 1 = 2^32 - 1
			So the maximum substring length n is:
			36^(n+1) - 1 = 2^32 - 1
			36^(n+1) = 2^32
			(n+1)ln(36) = 32ln(2)
			n = 32ln(2)/ln(36) - 1
			n = 5.189644915687692
			n = 5
		 */
		var radixUint = radixPowerCache[radix] || new UINT64( Math.pow(radix, 5) )

		for (var i = 0, len = s.length; i < len; i += 5) {
			var size = Math.min(5, len - i)
			var value = parseInt( s.slice(i, i + size), radix )
			this.multiply(
					size < 5
						? new UINT64( Math.pow(radix, size) )
						: radixUint
				)
				.add( new UINT64(value) )
		}

		return this
	}
	UINT64.prototype.fromString = fromString

	/**
	 * Convert this _UINT64_ to a number (last 32 bits are dropped)
	 * @method toNumber
	 * @return {Number} the converted UINT64
	 */
	UINT64.prototype.toNumber = function () {
		return (this._a16 * 65536) + this._a00
	}

	/**
	 * Convert this _UINT64_ to a string
	 * @method toString
	 * @param {Number} radix (optional, default=10)
	 * @return {String} the converted UINT64
	 */
	UINT64.prototype.toString = function (radix) {
		radix = radix || 10
		var radixUint = radixCache[radix] || new UINT64(radix)

		if ( !this.gt(radixUint) ) return this.toNumber().toString(radix)

		var self = this.clone()
		var res = new Array(64)
		for (var i = 63; i >= 0; i--) {
			self.div(radixUint)
			res[i] = self.remainder.toNumber().toString(radix)
			if ( !self.gt(radixUint) ) break
		}
		res[i-1] = self.toNumber().toString(radix)

		return res.join('')
	}

	/**
	 * Add two _UINT64_. The current _UINT64_ stores the result
	 * @method add
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.add = function (other) {
		var a00 = this._a00 + other._a00

		var a16 = a00 >>> 16
		a16 += this._a16 + other._a16

		var a32 = a16 >>> 16
		a32 += this._a32 + other._a32

		var a48 = a32 >>> 16
		a48 += this._a48 + other._a48

		this._a00 = a00 & 0xFFFF
		this._a16 = a16 & 0xFFFF
		this._a32 = a32 & 0xFFFF
		this._a48 = a48 & 0xFFFF

		return this
	}

	/**
	 * Subtract two _UINT64_. The current _UINT64_ stores the result
	 * @method subtract
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.subtract = function (other) {
		return this.add( other.clone().negate() )
	}

	/**
	 * Multiply two _UINT64_. The current _UINT64_ stores the result
	 * @method multiply
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.multiply = function (other) {
		/*
			a = a00 + a16 + a32 + a48
			b = b00 + b16 + b32 + b48
			a*b = (a00 + a16 + a32 + a48)(b00 + b16 + b32 + b48)
				= a00b00 + a00b16 + a00b32 + a00b48
				+ a16b00 + a16b16 + a16b32 + a16b48
				+ a32b00 + a32b16 + a32b32 + a32b48
				+ a48b00 + a48b16 + a48b32 + a48b48

			a16b48, a32b32, a48b16, a48b32 and a48b48 overflow the 64 bits
			so it comes down to:
			a*b	= a00b00 + a00b16 + a00b32 + a00b48
				+ a16b00 + a16b16 + a16b32
				+ a32b00 + a32b16
				+ a48b00
				= a00b00
				+ a00b16 + a16b00
				+ a00b32 + a16b16 + a32b00
				+ a00b48 + a16b32 + a32b16 + a48b00
		 */
		var a00 = this._a00
		var a16 = this._a16
		var a32 = this._a32
		var a48 = this._a48
		var b00 = other._a00
		var b16 = other._a16
		var b32 = other._a32
		var b48 = other._a48

		var c00 = a00 * b00

		var c16 = c00 >>> 16
		c16 += a00 * b16
		var c32 = c16 >>> 16
		c16 &= 0xFFFF
		c16 += a16 * b00

		c32 += c16 >>> 16
		c32 += a00 * b32
		var c48 = c32 >>> 16
		c32 &= 0xFFFF
		c32 += a16 * b16
		c48 += c32 >>> 16
		c32 &= 0xFFFF
		c32 += a32 * b00

		c48 += c32 >>> 16
		c48 += a00 * b48
		c48 &= 0xFFFF
		c48 += a16 * b32
		c48 &= 0xFFFF
		c48 += a32 * b16
		c48 &= 0xFFFF
		c48 += a48 * b00

		this._a00 = c00 & 0xFFFF
		this._a16 = c16 & 0xFFFF
		this._a32 = c32 & 0xFFFF
		this._a48 = c48 & 0xFFFF

		return this
	}

	/**
	 * Divide two _UINT64_. The current _UINT64_ stores the result.
	 * The remainder is made available as the _remainder_ property on
	 * the _UINT64_ object. It can be null, meaning there are no remainder.
	 * @method div
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.div = function (other) {
		if ( (other._a16 == 0) && (other._a32 == 0) && (other._a48 == 0) ) {
			if (other._a00 == 0) throw Error('division by zero')

			// other == 1: this
			if (other._a00 == 1) {
				this.remainder = new UINT64(0)
				return this
			}
		}

		// other > this: 0
		if ( other.gt(this) ) {
			this.remainder = this.clone()
			this._a00 = 0
			this._a16 = 0
			this._a32 = 0
			this._a48 = 0
			return this
		}
		// other == this: 1
		if ( this.eq(other) ) {
			this.remainder = new UINT64(0)
			this._a00 = 1
			this._a16 = 0
			this._a32 = 0
			this._a48 = 0
			return this
		}

		// Shift the divisor left until it is higher than the dividend
		var _other = other.clone()
		var i = -1
		while ( !this.lt(_other) ) {
			// High bit can overflow the default 16bits
			// Its ok since we right shift after this loop
			// The overflown bit must be kept though
			_other.shiftLeft(1, true)
			i++
		}

		// Set the remainder
		this.remainder = this.clone()
		// Initialize the current result to 0
		this._a00 = 0
		this._a16 = 0
		this._a32 = 0
		this._a48 = 0
		for (; i >= 0; i--) {
			_other.shiftRight(1)
			// If shifted divisor is smaller than the dividend
			// then subtract it from the dividend
			if ( !this.remainder.lt(_other) ) {
				this.remainder.subtract(_other)
				// Update the current result
				if (i >= 48) {
					this._a48 |= 1 << (i - 48)
				} else if (i >= 32) {
					this._a32 |= 1 << (i - 32)
				} else if (i >= 16) {
					this._a16 |= 1 << (i - 16)
				} else {
					this._a00 |= 1 << i
				}
			}
		}

		return this
	}

	/**
	 * Negate the current _UINT64_
	 * @method negate
	 * @return ThisExpression
	 */
	UINT64.prototype.negate = function () {
		var v = ( ~this._a00 & 0xFFFF ) + 1
		this._a00 = v & 0xFFFF
		v = (~this._a16 & 0xFFFF) + (v >>> 16)
		this._a16 = v & 0xFFFF
		v = (~this._a32 & 0xFFFF) + (v >>> 16)
		this._a32 = v & 0xFFFF
		this._a48 = (~this._a48 + (v >>> 16)) & 0xFFFF

		return this
	}

	/**

	 * @method eq
	 * @param {Object} other UINT64
	 * @return {Boolean}
	 */
	UINT64.prototype.equals = UINT64.prototype.eq = function (other) {
		return (this._a48 == other._a48) && (this._a00 == other._a00)
			 && (this._a32 == other._a32) && (this._a16 == other._a16)
	}

	/**
	 * Greater than (strict)
	 * @method gt
	 * @param {Object} other UINT64
	 * @return {Boolean}
	 */
	UINT64.prototype.greaterThan = UINT64.prototype.gt = function (other) {
		if (this._a48 > other._a48) return true
		if (this._a48 < other._a48) return false
		if (this._a32 > other._a32) return true
		if (this._a32 < other._a32) return false
		if (this._a16 > other._a16) return true
		if (this._a16 < other._a16) return false
		return this._a00 > other._a00
	}

	/**
	 * Less than (strict)
	 * @method lt
	 * @param {Object} other UINT64
	 * @return {Boolean}
	 */
	UINT64.prototype.lessThan = UINT64.prototype.lt = function (other) {
		if (this._a48 < other._a48) return true
		if (this._a48 > other._a48) return false
		if (this._a32 < other._a32) return true
		if (this._a32 > other._a32) return false
		if (this._a16 < other._a16) return true
		if (this._a16 > other._a16) return false
		return this._a00 < other._a00
	}

	/**
	 * Bitwise OR
	 * @method or
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.or = function (other) {
		this._a00 |= other._a00
		this._a16 |= other._a16
		this._a32 |= other._a32
		this._a48 |= other._a48

		return this
	}

	/**
	 * Bitwise AND
	 * @method and
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.and = function (other) {
		this._a00 &= other._a00
		this._a16 &= other._a16
		this._a32 &= other._a32
		this._a48 &= other._a48

		return this
	}

	/**
	 * Bitwise XOR
	 * @method xor
	 * @param {Object} other UINT64
	 * @return ThisExpression
	 */
	UINT64.prototype.xor = function (other) {
		this._a00 ^= other._a00
		this._a16 ^= other._a16
		this._a32 ^= other._a32
		this._a48 ^= other._a48

		return this
	}

	/**
	 * Bitwise NOT
	 * @method not
	 * @return ThisExpression
	 */
	UINT64.prototype.not = function() {
		this._a00 = ~this._a00 & 0xFFFF
		this._a16 = ~this._a16 & 0xFFFF
		this._a32 = ~this._a32 & 0xFFFF
		this._a48 = ~this._a48 & 0xFFFF

		return this
	}

	/**
	 * Bitwise shift right
	 * @method shiftRight
	 * @param {Number} number of bits to shift
	 * @return ThisExpression
	 */
	UINT64.prototype.shiftRight = UINT64.prototype.shiftr = function (n) {
		n %= 64
		if (n >= 48) {
			this._a00 = this._a48 >> (n - 48)
			this._a16 = 0
			this._a32 = 0
			this._a48 = 0
		} else if (n >= 32) {
			n -= 32
			this._a00 = ( (this._a32 >> n) | (this._a48 << (16-n)) ) & 0xFFFF
			this._a16 = (this._a48 >> n) & 0xFFFF
			this._a32 = 0
			this._a48 = 0
		} else if (n >= 16) {
			n -= 16
			this._a00 = ( (this._a16 >> n) | (this._a32 << (16-n)) ) & 0xFFFF
			this._a16 = ( (this._a32 >> n) | (this._a48 << (16-n)) ) & 0xFFFF
			this._a32 = (this._a48 >> n) & 0xFFFF
			this._a48 = 0
		} else {
			this._a00 = ( (this._a00 >> n) | (this._a16 << (16-n)) ) & 0xFFFF
			this._a16 = ( (this._a16 >> n) | (this._a32 << (16-n)) ) & 0xFFFF
			this._a32 = ( (this._a32 >> n) | (this._a48 << (16-n)) ) & 0xFFFF
			this._a48 = (this._a48 >> n) & 0xFFFF
		}

		return this
	}

	/**
	 * Bitwise shift left
	 * @method shiftLeft
	 * @param {Number} number of bits to shift
	 * @param {Boolean} allow overflow
	 * @return ThisExpression
	 */
	UINT64.prototype.shiftLeft = UINT64.prototype.shiftl = function (n, allowOverflow) {
		n %= 64
		if (n >= 48) {
			this._a48 = this._a00 << (n - 48)
			this._a32 = 0
			this._a16 = 0
			this._a00 = 0
		} else if (n >= 32) {
			n -= 32
			this._a48 = (this._a16 << n) | (this._a00 >> (16-n))
			this._a32 = (this._a00 << n) & 0xFFFF
			this._a16 = 0
			this._a00 = 0
		} else if (n >= 16) {
			n -= 16
			this._a48 = (this._a32 << n) | (this._a16 >> (16-n))
			this._a32 = ( (this._a16 << n) | (this._a00 >> (16-n)) ) & 0xFFFF
			this._a16 = (this._a00 << n) & 0xFFFF
			this._a00 = 0
		} else {
			this._a48 = (this._a48 << n) | (this._a32 >> (16-n))
			this._a32 = ( (this._a32 << n) | (this._a16 >> (16-n)) ) & 0xFFFF
			this._a16 = ( (this._a16 << n) | (this._a00 >> (16-n)) ) & 0xFFFF
			this._a00 = (this._a00 << n) & 0xFFFF
		}
		if (!allowOverflow) {
			this._a48 &= 0xFFFF
		}

		return this
	}

	/**
	 * Bitwise rotate left
	 * @method rotl
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */
	UINT64.prototype.rotateLeft = UINT64.prototype.rotl = function (n) {
		n %= 64
		if (n == 0) return this
		if (n >= 32) {
			// A.B.C.D
			// B.C.D.A rotl(16)
			// C.D.A.B rotl(32)
			var v = this._a00
			this._a00 = this._a32
			this._a32 = v
			v = this._a48
			this._a48 = this._a16
			this._a16 = v
			if (n == 32) return this
			n -= 32
		}

		var high = (this._a48 << 16) | this._a32
		var low = (this._a16 << 16) | this._a00

		var _high = (high << n) | (low >>> (32 - n))
		var _low = (low << n) | (high >>> (32 - n))

		this._a00 = _low & 0xFFFF
		this._a16 = _low >>> 16
		this._a32 = _high & 0xFFFF
		this._a48 = _high >>> 16

		return this
	}

	/**
	 * Bitwise rotate right
	 * @method rotr
	 * @param {Number} number of bits to rotate
	 * @return ThisExpression
	 */
	UINT64.prototype.rotateRight = UINT64.prototype.rotr = function (n) {
		n %= 64
		if (n == 0) return this
		if (n >= 32) {
			// A.B.C.D
			// D.A.B.C rotr(16)
			// C.D.A.B rotr(32)
			var v = this._a00
			this._a00 = this._a32
			this._a32 = v
			v = this._a48
			this._a48 = this._a16
			this._a16 = v
			if (n == 32) return this
			n -= 32
		}

		var high = (this._a48 << 16) | this._a32
		var low = (this._a16 << 16) | this._a00

		var _high = (high >>> n) | (low << (32 - n))
		var _low = (low >>> n) | (high << (32 - n))

		this._a00 = _low & 0xFFFF
		this._a16 = _low >>> 16
		this._a32 = _high & 0xFFFF
		this._a48 = _high >>> 16

		return this
	}

	/**
	 * Clone the current _UINT64_
	 * @method clone
	 * @return {Object} cloned UINT64
	 */
	UINT64.prototype.clone = function () {
		return new UINT64(this._a00, this._a16, this._a32, this._a48)
	}

	if (typeof define != 'undefined' && define.amd) {
		// AMD / RequireJS
		define([], function () {
			return UINT64
		})
	} else if (typeof module != 'undefined' && module.exports) {
		// Node.js
		module.exports = UINT64
	} else {
		// Browser
		root['UINT64'] = UINT64
	}

})(this)

},{}],"/usr/var/server/dbm.json":[function(require,module,exports){
module.exports={
    "name": "ximera-server-standalone",
    "version": "2.3.7i"
}

},{}],"/usr/var/server/public/javascripts/activity-card.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var gradebook = require('./gradebook');
var database = require('./database');

var users = require('./users');

var displayProgress = function displayProgress(card, progress) {
    var progressBar = $('.progress-bar', card);
    progressBar.css('width', Math.round(progress * 100).toString() + '%');
    progressBar.toggleClass('progress-bar-striped', progress > 0.9999);
};

var createActivityCard = function createActivityCard() {
    var activityCard = $(this);
    var href = activityCard.attr('data-path');

    ////////////////////////////////////////////////////////////////
    // add counters
    var itself = 0;
    if (activityCard.hasClass('part')) itself = 1;
    activityCard.attr('data-part-counter', activityCard.prevAll('.activity-card.part').length + itself);
    itself = 0;
    var label = activityCard.attr('data-part-counter');

    if (!activityCard.hasClass('part')) {
        if (activityCard.hasClass('chapter')) itself = 1;
        activityCard.attr('data-chapter-counter', activityCard.prevUntil('.activity-card.part', '.activity-card.chapter').length + itself);
        label = label + "." + activityCard.attr('data-chapter-counter');
    }

    if (!activityCard.hasClass('chapter')) {
        activityCard.attr('data-section-counter', activityCard.prevUntil('.activity-card.chapter', '.activity-card').not('.part').length + 1);
        label = label + "." + activityCard.attr('data-section-counter');
    }

    if (activityCard.attr('data-chapter-counter') != "0" && !activityCard.hasClass('part')) {
        $('.card-header', activityCard).prepend('<span class="card-number">' + label + '</span>');
        // MYBADBAD: also add nav-counter (for grid layout, without cards ...!)
        $(activityCard).attr('data-nav-counter', label);
    }

    if (activityCard.hasClass('part')) {
        // MYBADBAD: also add number to parts ...
        $(activityCard).attr('data-nav-counter', activityCard.attr('data-part-counter'));
    }

    // This is the new method for storing completion data
    var repositoryName = activityCard.attr('data-repository-name');
    var activityPath = activityCard.attr('data-path');

    if (repositoryName) {
        database.onCompletion(repositoryName, activityPath, function (c) {
            displayProgress(activityCard, c);
            activityCard.attr('data-max-completion', c);
            gradebook.update();
        });
    }
};

$.fn.extend({
    activityCard: function activityCard() {
        return this.each(createActivityCard);
    }
});

},{"./database":"/usr/var/server/public/javascripts/database.js","./gradebook":"/usr/var/server/public/javascripts/gradebook.js","./users":"/usr/var/server/public/javascripts/users.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/activity.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax.js');
var TinCan = require('./tincan');
var ProgressBar = require('./progress-bar');

var activityCard = require('./activity-card');
var problem = require('./problem');
var theorem = require('./theorem');
var question = require('./question');
var mathAnswer = require('./math-answer');
var multipleChoice = require('./multiple-choice');
var selectAll = require('./select-all');
var wordChoice = require('./word-choice');
var hint = require('./hint');
var foldable = require('./foldable');
var youtube = require('./youtube');

var freeResponse = require('./free-response');
var coding = require('./coding');
var shuffle = require('./shuffle');
var feedback = require('./feedback');
var validator = require('./validator');
var javascript = require('./javascript');

var connectInteractives = require('./interactives').connectInteractives;

var database = require('./database');

var annotator = require('./annotator');

var createActivity = function createActivity() {
			var activity = $(this);

			$(".foldable", activity).foldable();
			$(".accordion", activity).addClass('hidden-out-of-view');

			//$('.activity-body', this).annotator();

			activity.fetchData(function () {
						activity.persistentData(function () {
									if (!activity.persistentData('experienced')) {
												TinCan.experience(activity);
												activity.persistentData('experienced', true);
									}
						});

						ProgressBar.monitorActivity(activity);

						// Number theorems
						["theorem", "axiom", "conjecture", "corollary", "proposition", "lemma", "claim", "condition", "idea", "definition", "conclusion", "summary", "warning", "paradox", "example", "observation", "fact", "remark", "algorithm", "notation", "criterion", "exercise", "problem", "explanation", "exploration", "model", "formula", "procedure", "template"].forEach(function (t) {
									$("." + t, activity).numberTheorem();
						});

						$(".question", activity).numberQuestion();

						$(".problem-environment", activity).problemEnvironment();
						$(".multiple-choice", activity).multipleChoice();
						$(".select-all", activity).selectAll();
						$(".word-choice", activity).wordChoice();
						$(".hint", activity).hint();

						$(".free-response", activity).freeResponse();
						$(".javascript-code", activity).coding();

						$(".shuffle", activity).shuffle();
						$(".feedback", activity).feedback();
						$(".validator", activity).validator();
						$(".inline-javascript", activity).javascript();
						$('.youtube-player', activity).youtube();

						connectInteractives();

						$('.activity-card').activityCard();
			});
};

$.fn.extend({
			activity: function activity() {
						return this.each(createActivity);
			},

			recordCompletion: function recordCompletion(proportionComplete) {
						var hash = $(this).activityHash();

						if (hash != undefined) {
									var repositoryName = $(this).repositoryName();
									var activityPath = $(this).activityPath();

									database.setCompletion(repositoryName, activityPath, proportionComplete);
						}

						return;
			}
});

},{"./activity-card":"/usr/var/server/public/javascripts/activity-card.js","./annotator":"/usr/var/server/public/javascripts/annotator.js","./coding":"/usr/var/server/public/javascripts/coding.js","./database":"/usr/var/server/public/javascripts/database.js","./feedback":"/usr/var/server/public/javascripts/feedback.js","./foldable":"/usr/var/server/public/javascripts/foldable.js","./free-response":"/usr/var/server/public/javascripts/free-response.js","./hint":"/usr/var/server/public/javascripts/hint.js","./interactives":"/usr/var/server/public/javascripts/interactives.js","./javascript":"/usr/var/server/public/javascripts/javascript.js","./math-answer":"/usr/var/server/public/javascripts/math-answer.js","./mathjax.js":"/usr/var/server/public/javascripts/mathjax.js","./multiple-choice":"/usr/var/server/public/javascripts/multiple-choice.js","./problem":"/usr/var/server/public/javascripts/problem.js","./progress-bar":"/usr/var/server/public/javascripts/progress-bar.js","./question":"/usr/var/server/public/javascripts/question.js","./select-all":"/usr/var/server/public/javascripts/select-all.js","./shuffle":"/usr/var/server/public/javascripts/shuffle.js","./theorem":"/usr/var/server/public/javascripts/theorem.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","./validator":"/usr/var/server/public/javascripts/validator.js","./word-choice":"/usr/var/server/public/javascripts/word-choice.js","./youtube":"/usr/var/server/public/javascripts/youtube.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/annotator.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var annotator = require('annotator');

var activityHash = function activityHash() {
    return {
        beforeAnnotationCreated: function beforeAnnotationCreated(ann) {
            // get the actual activity hash
            ann.activityHash = window.location.href;
        }
    };
};

function addAnnotator() {
    var app = new annotator.App();
    app.include(annotator.ui.main, { element: this }).include(annotator.storage.http, { prefix: 'http://example.com/api' }).include(activityHash);
    app.start().then(function () {
        app.annotations.load({ activityHash: window.location.href });
    });
}

$.fn.extend({
    annotator: function annotator() {
        return this.each(addAnnotator);
    }
});

},{"annotator":"/usr/var/server.base/node_modules/annotator/annotator.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/brushes/shBrushLatex.js":[function(require,module,exports){
'use strict';

/*
 * Improved version of the very simple LaTeX brush from
 * http://www.jorgemarsal.com/blog/
 * some code from Gheorghe Milas and Ahmad Sherif
 */

var BrushBase = require('brush-base');
var regexLib = require('syntaxhighlighter-regex').commonRegExp;

function Brush() {
			var keywords = 'break continue case return in eq ne gt lt ge le';

			this.regexList = [
			// one line comments
			{ regex: new RegExp('%.*', 'gm'),
						css: 'comments' },
			// double quoted strings	
			{ regex: regexLib.doubleQuotedString,
						css: 'string' },
			// commands
			{ regex: new RegExp('\\\\\\w*', 'gm'),
						css: 'keyword' },
			// commands	
			{ regex: new RegExp('\\$[^\\$]+\\$', 'gm'),
						css: 'color2' },
			// keywords	
			{ regex: new RegExp(this.getKeywords(keywords), 'gm'),
						css: 'function' }];

			this.forHtmlScript(regexLib.scriptScriptTags);
}

Brush.prototype = new BrushBase();
Brush.aliases = ['tex', 'latex', 'LaTeX', 'TeX'];
module.exports = Brush;

},{"brush-base":"/usr/var/server.base/node_modules/brush-base/brush-base.js","syntaxhighlighter-regex":"/usr/var/server.base/node_modules/syntaxhighlighter-regex/index.js"}],"/usr/var/server/public/javascripts/cache-bust.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');

$(document).ready(function () {
				// Refresh to bust cache
				if (window.location.search.match(/^\?/)) {
								if (window.history && window.history.pushState) {
												window.history.pushState({}, document.title, window.location.pathname);
												window.location.reload(true);
								}
				}
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/chat.js":[function(require,module,exports){
'use strict';

$(function () {
    $('.chat').on('click', function () {
        $('.chat-body').show();
    });

    $('.chat .close').on('click', function () {
        if ($('.chat-body').is(":visible")) {
            $('.chat-body').hide();
        } else {
            $('.chat').hide();
        }
        return false;
    });
});

module.exports.onSendMessage = function (callback) {
    $('.chat input').keypress(function (event) {
        if (event.which == 13) {
            callback($(this).val());
            $(this).val('');
            return false;
        }
    });
};

module.exports.appendToTranscript = function (name, text, other) {
    $('.chat').show();
    $('.chat-body').show();

    var nameTag = $('<dt></dt>');
    nameTag.text(name);
    var textTag = $('<dd></dd>');
    textTag.text(text);

    if (other) {
        nameTag.addClass('other');
        textTag.addClass('other');
    }

    $('.chat .transcript').append(nameTag);
    $('.chat .transcript').append(textTag);

    $('.transcript').scrollTop($('.transcript')[0].scrollHeight);

    return;
};

},{}],"/usr/var/server/public/javascripts/coding.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var database = require('./database');
var CodeMirror = require('codemirror');
require('./../../node_modules/codemirror/mode/javascript/javascript.js');

var createCoding = function createCoding() {
			var element = $(this);

			var initialContent = $('script', element).text();
			$('script', element).remove();

			var myCodeMirror = CodeMirror(element.get(0), {
						value: "",
						mode: "javascript",
						lineNumbers: true,
						lineWrapping: true
			});

			// update database from view
			myCodeMirror.on("changes", function (e) {
						$(element).persistentData('code', myCodeMirror.getValue());
			});

			// update view from database
			$(element).persistentData(function (event) {
						console.log(event);
						if (!$(element).persistentData('code')) {
									console.log("empty code");
									myCodeMirror.setValue(initialContent);
						}

						if ('code' in event.data) {
									if (event.data['code'] != myCodeMirror.getValue()) {
												myCodeMirror.setValue(event.data['code']);
									}
						}
			});

			var button = $('<button type="button" class="btn btn-primary"><i class="fa fa-play"></i>&nbsp;Run</button>');
			element.append(button);
			button.wrapInner($('<div class="btn-group" role="group" aria-label="Basic example">'));

			button.click(function () {
						$('#p5-canvas', element).remove();
						element.append($('<div id="p5-canvas"></div>'));
						$('#p5-canvas', element).css('width', '750px');
						$('#p5-canvas', element).css('height', '500px');

						$('#p5-canvas').hover(function () {
									console.log('DISABLE');
									$(document).keydown(function (e) {
												var key = e.which;
												if (key == 35 || key == 36 || key == 37 || key == 39) {
															e.preventDefault();
															return false;
												}
												return true;
									});
						}, function () {
									//$("body").css("overflow","auto");
						});

						var prefix = 'for(var k in p) { window[k]=p[k]; if (window[k] && window[k].bind) window[k] = window[k].bind(p); } ; var width = 750; var height = 500;';
						var sneaky = Function('p', prefix + myCodeMirror.getValue());
						window.sketch = sneaky;
						new window.p5(sneaky, 'p5-canvas');
			});

			return;
};

$.fn.extend({
			coding: function coding() {
						return this.each(createCoding);
			}
});

},{"./../../node_modules/codemirror/mode/javascript/javascript.js":"/usr/var/server.base/node_modules/codemirror/mode/javascript/javascript.js","./database":"/usr/var/server/public/javascripts/database.js","codemirror":"/usr/var/server.base/node_modules/codemirror/lib/codemirror.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/database.js":[function(require,module,exports){
'use strict';

/*
  The 'database' provides a mechanism for saving page state to the server.
*/
var $ = require('jquery');
var _ = require('underscore');
var async = require('async');
var jsondiffpatch = require('jsondiffpatch');

var chat = require('./chat');
var users = require('./users');

var CANON = require('canon');
var XXH = require('xxhashjs');

function checksumObject(object) {
			return XXH.h32(CANON.stringify(object), 0x1337).toString(16);
}

var DIFFSYNC_DEBOUNCE = 5003; // milliseconds to wait to save
var socket = undefined;

// Some heartbeat code to provide feedback when we aren't receiving pings
/* BADBAD disabled pings for now
var lastPing = undefined;
window.setInterval( function() {
    var interval = new Date() - lastPing;
    if (interval > 120000) {
	saveWorkStatus( 'error', "The connection is slow. Your work is not being saved." );
    }
}, 10000);
*/

var SAVE_WORK_BUTTON_ID = '#save-work-button';
var RESET_WORK_BUTTON_ID = '#reset-work-button';

function saveButtonOnlyGrows() {
			// This is less important when the save button is on the lefthand side
			$(SAVE_WORK_BUTTON_ID).css('min-width', $(SAVE_WORK_BUTTON_ID).css('width'));
}

function saveWorkStatus(status, tooltip) {
			$(SAVE_WORK_BUTTON_ID).children('span').not('#work-' + status).hide();
			$(SAVE_WORK_BUTTON_ID).children('#work-' + status).show();
			saveButtonOnlyGrows();

			if (tooltip) {
						$(SAVE_WORK_BUTTON_ID).attr('title', tooltip);
			} else {
						$(SAVE_WORK_BUTTON_ID).attr('title', '');
			}
}

var DATABASE = undefined;
var SHADOW = undefined;
var COMPLETIONS = {};
var completionCallbacks = {};

module.exports.DATABASE = DATABASE;

var wantPageUpdates = [];
module.exports.onPageUpdate = function (callback) {
			wantPageUpdates.unshift(callback);
};

/****************************************************************/
// At various points in storing page state, we want to refer to the
// activity by its hash
var activityHash = undefined;

var findActivityHash = _.memoize(function () {
			return $('main').attr('data-hash');
});

$.fn.extend({ activityHash: function activityHash() {
						return findActivityHash();
			} });

var findActivityPath = _.memoize(function () {
			return $('main.activity').attr('data-path');
});

$.fn.extend({ activityPath: function activityPath() {
						return findActivityPath(this);
			} });

window.addEventListener('online', connectToServer);

window.addEventListener('offline', function () {
			saveWorkStatus('error', "No internet available");
});

function differentialSynchronization() {
			if (!socket || !(socket.readyState == WebSocket.OPEN)) {
						saveWorkStatus('error', "Synchronization failed");
						connectToServer();
						window.setTimeout(differentialSynchronizationDebounced, DIFFSYNC_DEBOUNCE);
						return;
			}

			var delta = jsondiffpatch.diff(SHADOW, DATABASE);

			if (delta !== undefined) {
						saveWorkStatus('saving');
						socket.sendJSON('patch', delta, checksumObject(SHADOW));
						SHADOW = jsondiffpatch.clone(DATABASE);
			}
}

var differentialSynchronizationDebounced = _.debounce(differentialSynchronization, DIFFSYNC_DEBOUNCE);

var findRepositoryName = _.memoize(function (element) {
			if ($(element).hasClass('activity')) return $(element).attr('data-repository-name');

			return $(element).parents("[data-hash]").attr('data-repository-name');
});

$.fn.extend({ repositoryName: function repositoryName() {
						return findRepositoryName(this);
			} });

// Return the database hash associated to the given element
module.exports.get = function (element) {
			if (DATABASE === undefined) {
						throw "Database not loaded.";
			}

			var identifier = $(element).attr('id');

			if (!(identifier in DATABASE)) DATABASE[identifier] = {};

			return DATABASE[identifier];
};

// Commit some changes to the database (which will propagate them to other instances)
module.exports.commit = _.throttle(function () {
			// After making a change, the "save work" button should be shown, as opposed to the "work saved!" button
			$(SAVE_WORK_BUTTON_ID).children('span').not('#work-save').hide();
			$(SAVE_WORK_BUTTON_ID).children('#work-save').show();
			saveButtonOnlyGrows();
}, 50);

// Register a listener to be called whenever the database changes
module.exports.listen = function (element, callback) {
			var identifier = $(element).attr('id');

			$(element).on('ximera:database', $(element).database(), function (event) {
						return callback.bind(this)(event);

						// BADBAD: Do I need to return true, so I don't prevent this from bubbling?
			});

			// Because we might register our listener AFTER we download
			// the database for the first time, let's just let our
			// listener know about what's currently in the database
			$(element).trigger('ximera:database');

			return;
};

// Call $(element).database() to get the database hash associated
// to the given element
$.fn.extend({
			database: function database() {
						var element = $(this);
						var db = module.exports.get(this);
						var originalDatabase = jsondiffpatch.clone(db);

						// If we change the database...
						_.defer(function () {
									if (jsondiffpatch.diff(db, originalDatabase) !== undefined) {
												// Trigger a remote update
												module.exports.commit();
												element.trigger('ximera:database');
												differentialSynchronizationDebounced();
									}
						});

						return module.exports.get(this);
			},

			persistentData: function persistentData(key, value) {
						if (typeof key == 'function') {
									var callback = key;
									module.exports.listen(this, callback);
									return this;
						}

						if (value === undefined) {
									return module.exports.get(this)[key];
						}

						module.exports.get(this)[key] = value;

						var element = this;

						// Trigger a remote update
						_.defer(function () {
									module.exports.commit();
									element.trigger('ximera:database');
									differentialSynchronizationDebounced();
						});

						return this;
			}
});

var fetcherCallbacks = [];

// activity.js will use this to download the database from the server
$.fn.extend({ fetchData: function fetchData(callback) {
						if (DATABASE !== undefined) callback(DATABASE);else fetcherCallbacks.unshift(callback);
			} });

function synchronizePageWithDatabase() {
			_.each(DATABASE, function (database, identifier, list) {
						$("#" + identifier).trigger('ximera:database');
			});
}

var backOff = 1000;

function connectToServer() {
			// If we're currently connected...
			if (socket) {
						if (socket.readyState == WebSocket.OPEN) {
									// just ignore the request to reconnect
									return;
						}
						if (socket.readyState == WebSocket.CONNECTING) {
									console.log("Still connecting...");
									return;
						}
			}

			// Build an appropriate URL based on the page URL
			var websocketUrl = "ws:";
			if (window.location.protocol === "https:") {
						websocketUrl = "wss:";
			}
			websocketUrl += "//" + window.location.host + window.toValidPath("/ws");

			saveWorkStatus('error', "Connecting...");

			try {
						console.log("Attempting websocket connection...");
						socket = new WebSocket(websocketUrl);

						// It would be nicer to use ...parameters, and I can't just
						// use arguments because it's not actually an array
						socket.sendJSON = function () {
									var parameters = [];
									var i;
									for (i = 0; i < arguments.length; i++) {
												parameters[i] = arguments[i];
									}socket.send(JSON.stringify(parameters));
						};
			} catch (err) {
						saveWorkStatus('error', "Could not connect.  Your work is not being saved.");
			}

			socket.addEventListener('error', function (event) {
						saveWorkStatus('error', "There was an error with the WebSocket");
			});

			socket.addEventListener('close', function (event) {
						backOff = backOff * 2.0;
						if (backOff > 15000) backOff = 15000;

						saveWorkStatus('error', "You have been disconnected.  Reconnecting in " + Math.round(backOff / 1000).toString() + " seconds");
						console.log("You have been disconnected.  Reconnecting in " + Math.round(backOff / 1000).toString() + " seconds");
						window.setTimeout(connectToServer, backOff);
			});

			var learnerId = $('main').attr('data-learner');
			var repositoryName = $('main').attr('data-repository-name');
			var filename = $('main').attr('data-path');

			socket.addEventListener('open', function (event) {
						console.log("WebSocket open!");
						saveWorkStatus('save');
						socket.sendJSON('watch', learnerId, findActivityHash());
						socket.sendJSON('want-commit', repositoryName, filename);
			});

			var handlers = {};

			handlers.push = function () {
						socket.sendJSON('want-commit', repositoryName, filename);
			};

			handlers.commit = function (remoteRepositoryName, remoteFilename, commitHash, remoteContentHash) {
						if (remoteContentHash != activityHash) {
									$('#update-version-button').attr('href', window.location.pathname + "?" + commitHash);
									$('#pageUpdate').show();
						}
			};

			handlers.sync = function (remoteDatabase) {
						SHADOW = jsondiffpatch.clone(remoteDatabase);

						if (DATABASE === undefined) {
									DATABASE = {};

									_.each(remoteDatabase, function (database, identifier, list) {
												// It's possible that, for some reason, I've
												// already made changes to the database, so I
												// just want to merge in the remote
												if (identifier in DATABASE) _.extend(DATABASE[identifier], database);else {
															DATABASE[identifier] = database;
												}
									});

									synchronizePageWithDatabase();

									_.each(fetcherCallbacks, function (callback) {
												callback(DATABASE);
									});
						}
			};

			handlers.outOfSync = function () {
						socket.sendJSON('sync', SHADOW);
			};

			handlers.haveDifferential = _.debounce(function (checksum) {
						if (checksumObject(SHADOW) != checksum) {
									socket.sendJSON('want-differential');
						} else {
									saveWorkStatus('saved', 'Uploaded at ' + new Date().toLocaleTimeString());
						}
			}, 100);

			handlers.patched = function (err) {
						if (err) {
									saveWorkStatus('error', err);
									console.log(err);
						}
			};

			handlers.patch = function (delta, checksum) {
						// Apply patch to the client state...
						jsondiffpatch.patch(DATABASE, delta);

						synchronizePageWithDatabase();

						// Confirm that our shadow now matches their shadow
						if (checksumObject(SHADOW) != checksum) {
									// We are out of sync, and should request synchronization
									socket.sendJSON('out-of-sync');
						} else {
									jsondiffpatch.patch(SHADOW, delta);
						}
			};

			handlers.completions = function (completions) {
						_.each(completions, function (c) {
									var url = c.repositoryName + '/' + c.activityPath;
									var changed = false;
									if (url in COMPLETIONS) {
												if (COMPLETIONS[url] < c.complete) {
															COMPLETIONS[url] = c.complete;
															changed = true;
												}
									} else {
												COMPLETIONS[url] = c.complete;
												changed = true;
									}

									if (changed && completionCallbacks[url]) {
												_.each(completionCallbacks[url], function (callback) {
															callback(c.complete);
												});
									}
						});
			};

			/*
   handlers.pong = function(latency)  {
   lastPing = new Date();
   console.log( "ping: " + latency.toString() + "ms" );
   $(SAVE_WORK_BUTTON_ID).attr( 'title', latency.toString() + "ms ping" );
   };
   */

			handlers.chat = function (name, message) {
						chat.appendToTranscript(name, message, true);
			};

			socket.addEventListener('message', function (event) {
						var payload = JSON.parse(event.data);

						if (!Array.isArray(payload)) {
									console.log("WebSocket message is not an array.");
									return;
						}

						if (payload.length == 0) {
									console.log("WebSocket message is empty.");
									return;
						}

						var message = payload[0];
						var camelCased = message.replace(/-([a-z])/g, function (g) {
									return g[1].toUpperCase();
						});

						if (handlers[camelCased]) {
									handlers[camelCased].apply(socket, payload.slice(1));
						} else {
									console.log("Do not know how to handle " + message);
						}
			});

			chat.onSendMessage(function (message) {
						var name = users.me().then(function (user) {
									var first = user.name.split(' ')[0];
									var last = user.name.split(' ').slice(-1)[0];
									var initials = '??';
									if (first && last) initials = first.substr(0, 1) + last.substr(0, 1);

									socket.sendJSON('chat', initials, message);
						});
			});
}

$(document).ready(function () {
			var activityHash = findActivityHash();

			if (!activityHash) return;

			connectToServer();
});

module.exports.setCompletion = function (repositoryName, activityPath, complete) {
			if (!socket) {
						saveWorkStatus('error', "No socket for progress bar");
						return;
			}

			if (socket.readyState !== WebSocket.OPEN) {
						saveWorkStatus('error', "Socket not open for progress bar");
						return;
			}

			socket.sendJSON('completion', { repositoryName: repositoryName, activityPath: activityPath, complete: complete });
};

module.exports.onCompletion = function (repositoryName, activityPath, callback) {
			var url = repositoryName + '/' + activityPath;

			if (!(url in completionCallbacks)) completionCallbacks[url] = [];

			completionCallbacks[url].unshift(callback);

			if (COMPLETIONS[url]) {
						callback(COMPLETIONS[url]);
			}
};

// No need to confirm with the user to delete work---that happens via a Bootstrap Modal
var clickResetWorkButton = function clickResetWorkButton() {
			var keys = _.keys(DATABASE);

			_.each(keys, function (identifier) {
						// Want to empty the object but can't throw away the reference
						var hash = DATABASE[identifier];
						for (var i in hash) {
									delete hash[i];
						}
			});

			synchronizePageWithDatabase();
			differentialSynchronization();
};

module.exports.resetWork = clickResetWorkButton;

// After the document loads, every few seconds, make sure the database is saved.
$(document).ready(function () {
			activityHash = findActivityHash();

			//
			// 2025-03: REMOVED, as it pops up way too often
			//
			// window.onbeforeunload = function() {
			// // Before the page disappears, let's test to see if there is unsaved data
			// if (jsondiffpatch.diff( SHADOW, DATABASE ) !== undefined) {
			//     return "There is unsaved data on this page.";
			// }
			// };

			$(SAVE_WORK_BUTTON_ID).click(differentialSynchronization);
			$(RESET_WORK_BUTTON_ID).click(clickResetWorkButton);
});

},{"./chat":"/usr/var/server/public/javascripts/chat.js","./users":"/usr/var/server/public/javascripts/users.js","async":"/usr/var/server.base/node_modules/async/dist/async.js","canon":"/usr/var/server.base/node_modules/canon/lib/canon.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","jsondiffpatch":"/usr/var/server.base/node_modules/jsondiffpatch/src/main.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js","xxhashjs":"/usr/var/server.base/node_modules/xxhashjs/lib/index.js"}],"/usr/var/server/public/javascripts/desmos.js":[function(require,module,exports){
"use strict";

var $ = require('jquery');

var DesmosNeeded = false;

exports.promise = $.Deferred();

exports.onReady = function (callback) {
	$.when(exports.promise).done(callback);
};

exports.loadAsynchronously = function () {
	if (DesmosNeeded == false) {
		DesmosNeeded = true;

		$.getScript("https://www.desmos.com/api/v0.7/calculator.js?apiKey=dcb31709b452b1cf9dc26972add0fda6", function () {
			function waitForDesmos() {
				if (typeof window.Desmos !== "undefined") {
					exports.promise.resolve(window.Desmos);
				} else {
					setTimeout(function () {
						waitForDesmos();
					}, 250);
				}
			}

			waitForDesmos();
		});
	}
};

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/feedback.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var database = require('./database');

var createFeedback = function createFeedback() {
			var feedback = $(this);

			feedback.persistentData(function () {
						if (feedback.persistentData('available')) {
									feedback.css({ visibility: 'visible', position: 'relative' });
									feedback.fadeTo('slow', 1);
						} else {
									feedback.css({ visibility: 'hidden', position: 'absolute' });
									feedback.css({ opacity: 0 });
						}
			});

			var problem = feedback.parents(".problem-environment").first();

			if (feedback.attr('data-feedback') === 'attempt') {
						problem.on('ximera:attempt', function (event) {
									feedback.persistentData('available', true);
						});
			}

			if (feedback.attr('data-feedback') === 'correct') {
						problem.on('ximera:correct', function (event) {
									feedback.persistentData('available', true);
						});
			}

			if (feedback.attr('data-feedback') === 'solution') {
						feedback.trigger('ximera:register-hint');
						/*problem.on('ximera:showsolution', function (event) {
      	feedback.persistentData('available', true);
      });*/
			}

			if (feedback.attr('data-feedback') == 'script') {
						problem.on('ximera:attempt', function (event) {
									var release = false;
									try {
												release = window[feedback.attr('id')]();
									} catch (err) {
												release = false;
									}

									feedback.persistentData('available', release);
						});

						console.log(feedback);
			}
};

$.fn.extend({
			feedback: function feedback() {
						return this.each(createFeedback);
			}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/foldable.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
require('jquery-ui/ui/widgets/accordion');
var _ = require('underscore');
var database = require('./database');

var buttonHtml = '<button class="btn btn-info btn-xs btn-hint-collapse" type="button" aria-expanded="false" aria-controls="collapse"><i class="fa fa-chevron-down"></i></button>';

jQuery.fn.removeAttributes = function () {
	return this.each(function () {
		var attributes = $.map(this.attributes, function (item) {
			return item.name;
		});
		var img = $(this);
		$.each(attributes, function (i, item) {
			img.removeAttr(item);
		});
	});
};

var createFoldable = function createFoldable() {
	var foldable = $(this);
	foldable.removeAttributes();
	foldable.wrap('<div class="accordion"></div>');
	foldable.before("<h3>Klap uit</h3>");

	/*foldable.wrap(function () {
 	return '<div class="accordion"><h3>Klap uit</h3><div>'+ $(this).html() + '</div></div>'
 });*/

	/*var button = $(buttonHtml);
 foldable.before('<div class="clearfix"></div>');
 foldable.before(button);
  button.click( function() {
 if (foldable.persistentData( 'collapsed' )) {
  foldable.persistentData( 'collapsed', false );
 } else {
  foldable.persistentData( 'collapsed', true );
 }
 });
 
 foldable.persistentData( function(event) {
 if ( (foldable.persistentData( 'collapsed' ) == true) != (foldable.attr('data-original') == 'expandable') ) {
  button.find('i').addClass('fa-rotate-90');
  //foldable.collapse('hide');
  foldable.css( 'font-size', '0px' );
  foldable.children().hide();
  $('.unfoldable', foldable).show();
  $('.unfoldable', foldable).parentsUntil( foldable ).show();
  $('.foldable', foldable).hide();	    
 } else {
  button.find('i').removeClass('fa-rotate-90');
  foldable.children().show();
  //$('.unfoldable', foldable).show();	    
  //foldable.collapse('show');
  foldable.css( 'font-size', '12pt' );
  $('.foldable', foldable).show();
 }
  });*/
};

$.fn.extend({
	foldable: function foldable() {
		this.each(createFoldable);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","jquery-ui/ui/widgets/accordion":"/usr/var/server.base/node_modules/jquery-ui/ui/widgets/accordion.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/free-response.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var database = require('./database');

window.Markdown = require('./../../node_modules/pagedown-bootstrap/Markdown.Converter.js');
var Converter = Markdown.Converter;
var Sanitizer = require('./../../node_modules/pagedown-bootstrap/Markdown.Sanitizer.js').getSanitizingConverter;
var editor = require('./../../node_modules/pagedown-bootstrap/Markdown.Editor.js');

var TinCan = require('./tincan');

var createFreeResponse = function createFreeResponse() {
   var element = $(this);

   var wmdName = "-" + $(this).attr('id');

   var formHtml = '<div class="wmd-panel compose">' + '<div id="wmd-button-bar' + wmdName + '"></div>' + '<textarea class="content form-control" rows="5" id="wmd-input' + wmdName + '" name="content"/>' + '<div id="wmd-preview' + wmdName + '" class="wmd-panel wmd-preview"></div>' +
   //'<div class="model-solution" ng-show="db.viewSolution" ng-bind-html="htmlSolution"></div>' +
   '</div>';

   var form = $(formHtml);
   $(element).append(form);

   var textarea = $('textarea', element);

   var converter = Sanitizer();
   var editor = new Markdown.Editor(converter, wmdName);

   editor.hooks.chain("onPreviewRefresh", function () {
      /*
       MathJax.Hub.Queue(
       ["Typeset",MathJax.Hub, $('.wmd-preview' + wmdName).get(0)]
         	 );
       */
   });

   // update database from view
   $(textarea).on("keyup change input propertychange", function (e) {
      $(element).persistentData('response', $(textarea).val());
   });

   $(element).persistentData(function (event) {
      if ('response' in event.data) $(textarea).val(event.data['response']);
   });

   // run should be called after you've added your plugins to the editor (if any).
   editor.run();

   var toolbar = $('#wmd-button-row' + wmdName, form);
   //toolbar.append( $('<div class="btn-group"><button class="btn btn-primary"><i class="fa fa-share"></i>&nbsp;Submit to Peers</button><button class="btn btn-warning"><i class="fa fa-thumbs-up"></i>&nbsp;Review Peers</button></div>') );

   var buttonGroup = $('<div class="btn-group"></div>');

   var submit = $('<button class="btn btn-primary"><i class="fa fa-share"></i>&nbsp;<span class="submit-label">Submit</span></button>');
   buttonGroup.append(submit);
   toolbar.append(buttonGroup);

   submit.on('click', function () {
      var e = $(this);
      $('.submit-label', e).text('Submitted!');

      var result = $(element).persistentData('response');

      TinCan.submitted(element, result);
   });

   /*
    var button = '<button class="btn btn-info" ng-click="db.viewSolution = true;" ng-hide="db.viewSolution"><i class="fa fa-eye"></i>&nbsp;View model solution</button><button class="btn btn-info" ng-click="db.viewSolution = false;" ng-show="db.viewSolution"><i class="fa fa-eye-slash"></i>&nbsp;Hide model solution</button>';
    toolbar.append( $(button) );
    */

   // Remove the "add image" button since it is broken
   $('#wmd-image-button' + wmdName).remove();
};

$.fn.extend({
   freeResponse: function freeResponse() {
      return this.each(createFreeResponse);
   }
});

},{"./../../node_modules/pagedown-bootstrap/Markdown.Converter.js":"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Converter.js","./../../node_modules/pagedown-bootstrap/Markdown.Editor.js":"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Editor.js","./../../node_modules/pagedown-bootstrap/Markdown.Sanitizer.js":"/usr/var/server.base/node_modules/pagedown-bootstrap/Markdown.Sanitizer.js","./database":"/usr/var/server/public/javascripts/database.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/gradebook.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');

exports.update = _.debounce(function () {
			var pointsEarned = 0;

			$(".activity-card").each(function () {
						var card = $(this);
						var weight = parseFloat(card.attr('data-weight'));
						var completion = parseFloat(card.attr('data-max-completion'));

						if (!isNaN(weight)) {
									if (!isNaN(completion)) {
												var points = weight * completion;
												pointsEarned = pointsEarned + points;
									}
						}
			});

			var pointsPossible = $("main").attr('data-points');
			var xourseUrl = $("main").attr('data-xourse-url');

			var payload = {
						pointsEarned: pointsEarned,
						pointsPossible: pointsPossible
			};

			$(".progress.completion-meter").attr('title', 'Submitting grade...');

			$.ajax({
						url: window.toValidPath('/' + xourseUrl + '/gradebook'),
						type: 'PUT',
						data: JSON.stringify(payload),
						contentType: 'application/json',
						success: function success(result) {
									console.log("Recorded gradebook", payload);
									$('.progress-bar', ".progress.completion-meter").removeClass('bg-danger');
									$('.progress-bar', ".progress.completion-meter").addClass('bg-success');
									$(".progress.completion-meter").attr('title', 'Grade submitted at ' + new Date().toLocaleTimeString());
						},
						error: function error(jqXHR, err, exception) {
									$(".progress.completion-meter").attr('title', 'Could not submit grade.');
									$('.progress-bar', ".progress.completion-meter").removeClass('bg-success');
									$('.progress-bar', ".progress.completion-meter").addClass('bg-danger');
									window.setTimeout(exports.update, 1000);
						}
			});
}, 300);

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/hint.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var database = require('./database');

var buttonHtml = '<button class="btn btn-info btn-xs btn-hint-collapse" type="button" aria-expanded="false" aria-controls="collapse"><i class="fa fa-chevron-down"></i></button>';

var createHint = function createHint() {
			var hint = $(this);

			hint.addClass('collapse');
			hint.collapse('hide');

			var button = $(buttonHtml);
			hint.wrap('<div></div>');
			hint.before(button);

			button.click(function () {
						if (hint.persistentData('collapsed')) {
									hint.persistentData('collapsed', false);
						} else {
									hint.persistentData('collapsed', true);
						}
			});

			hint.trigger('ximera:register-hint');

			hint.persistentData(function (event) {
						if (hint.persistentData('available')) {
									button.show('fast');

									if (hint.persistentData('collapsed')) {
												button.find('i').addClass('fa-rotate-90');
												hint.collapse('hide');
									} else {
												button.find('i').removeClass('fa-rotate-90');
												hint.collapse('show');
									}
						} else {
									hint.collapse('hide');
									button.hide();
						}
						/*
       if (hint.persistentData( 'available' )) {
      	 } else {
       button.hide();
       }
       */
			});
};

$.fn.extend({
			hint: function hint() {
						return this.each(createHint);
			}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/image-environment.js":[function(require,module,exports){
"use strict";

var $ = require('jquery');
window.jQuery = $;

$(function () {
	// Get the modal
	var imageEnvironmentModal = document.getElementById("image-environment-modal");
	if (imageEnvironmentModal) {
		var imageEnvironmentModalImg = document.getElementById("image-environment-modal-img");
		var imageEnvironmentModalCaptionText = document.getElementById("image-environment-modal-caption");
		// Get the <span> element that closes the modal
		var span = document.getElementsByClassName("image-environment-modal-close")[0];
		// When the user clicks on <span> (x), close the modal
		span.onclick = function () {
			imageEnvironmentModal.style.display = "none";
		};
		$('div.image-environment').each(function () {

			var imageEnvironment = $(this);

			$('img', imageEnvironment).each(function () {

				// Get the image and insert it inside the modal - use its "alt" text as a caption
				var img = $(this);
				img.click(function () {
					imageEnvironmentModal.style.display = "block";
					imageEnvironmentModalImg.src = this.src;
					imageEnvironmentModalCaptionText.innerHTML = this.alt;
				});
			});
		});
	}
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/instructor.js":[function(require,module,exports){
"use strict";

var $ = require('jquery');

function announce(hash, answers) {
				var selector = function selector(hash, problem, answerable) {
								return "[data-hash='" + hash + "'] " + "#" + problem + " #" + answerable;
				};

				Object.keys(answers).forEach(function (problem) {
								Object.keys(answers[problem]).forEach(function (answerable) {
												var element = $(selector(hash, problem, answerable));
												var statistics = answers[problem][answerable];

												element.trigger("ximera:statistics:answers", statistics.responses);
												element.trigger("ximera:statistics:successes", statistics.successes);
								});
				});
}

$(function () {
				$("#instructor-view-statistics").click(function () {
								$("#instructor-view-statistics").hide();

								var url = $(this).attr('data-activity-url');
								var hash = $(this).attr('data-activity-hash');

								$.ajax({
												url: window.toValidPath('/statistics/' + url + '/' + hash),
												type: 'GET',
												success: function success(result) {
																if (result) announce(hash, result);
												}
								});
				});
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/interactives.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var async = require('async');
var TinCan = require('./tincan');
var Desmos = require('./desmos');
var Javascript = require('./javascript');

var libraries = {
			jquery: $,
			underscore: _,
			tincan: TinCan
};

function asynchronousLibrary(dependencies, name, url, object) {
			return function (callback) {
						if (libraries[name] == undefined && dependencies.some(function (dependency) {
									return dependency == name;
						})) {
									$.getScript(url, function () {
												libraries[name] = window[object];
												callback(null);
									});
						} else {
									callback(null);
						}
			};
}

// Connected to 'db'
function createProxiedPersistentDataObject(element) {
			var handler = {
						get: function get(target, prop, receiver) {
									return element.persistentData(prop);
						},
						set: function set(target, prop, value, receiver) {
									element.persistentData(prop, value);
									Javascript.reevaluate(element);
									return true;
						}
			};

			var p = new Proxy(function (callback) {
						element.persistentData(callback);
			}, handler);

			return p;
}

// Connected to 'reset'
function createResetButton(element) {
			var button = $('<button class="btn btn-danger" type="button"><i class="fa fa-eraser"></i>Reset</button>');
			button.insertAfter(element);

			return function (callback) {
						$(button).click(callback);
			};
}

// TODO reset button
// TODO checkwork
// TODO includeinteractive needs to be access the parameters that it is passed
// basically as an "parameters" object
function parseParameters(parameters) {
			if (parameters === null) return {};

			var pairs = parameters.split(',').map(function (x) {
						return x.trim();
			});
			var hash = {};
			pairs.forEach(function (pair) {
						var left = pair.split('=')[0];
						var right = pair.split('=')[1];

						hash[left] = right;
			});

			return hash;
}

exports.connectInteractives = function () {
			if (window.interactives) {
						window.interactives.forEach(function (interactive) {
									var dependencies = interactive.dependencies;
									var code = interactive.callback;
									var parameters = interactive.parameters;

									var variableName = parseParameters(parameters)['id'];

									var targetId = interactive.targetId;
									var target = $("#" + targetId);

									async.series([
									// Additional asynchronously loaded scripts could be placed here
									function (callback) {
												if (dependencies.some(function (dependency) {
															return dependency == "desmos";
												})) {
															Desmos.loadAsynchronously();

															Desmos.onReady(function (Desmos) {
																		libraries['desmos'] = Desmos;
																		callback(null);
															});
												} else {
															callback(null);
												}
									}, asynchronousLibrary(dependencies, "three", "https://cdnjs.cloudflare.com/ajax/libs/three.js/r81/three.min.js", "THREE"), asynchronousLibrary(dependencies, "jsxgraph", "https://cdnjs.cloudflare.com/ajax/libs/jsxgraph/0.99.5/jsxgraphcore.js", "JXG"), asynchronousLibrary(dependencies, "numeric", "https://cdnjs.cloudflare.com/ajax/libs/numeric/1.2.6/numeric.min.js", "numeric")], function (err) {
												code.apply(target, dependencies.map(function (name) {
															if (name == 'db') {
																		var proxy = createProxiedPersistentDataObject(target);

																		if (variableName) {
																					window[variableName] = proxy;
																		}

																		return proxy;
															} else if (name == 'reset') return createResetButton(target);else if (name == 'parameters') return parseParameters(parameters);else return libraries[name];
												}));
									});
						});
			}
};

},{"./desmos":"/usr/var/server/public/javascripts/desmos.js","./javascript":"/usr/var/server/public/javascripts/javascript.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","async":"/usr/var/server.base/node_modules/async/dist/async.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/javascript.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax');

$(function () {
			var anyRandomness = false;

			$('.javascript script').each(function () {
						if ($(this).html().match(/random/)) anyRandomness = true;
			});

			if (anyRandomness) {
						$("#show-me-another-button").show();

						var seedDiv;
						if ($("#seed").length > 0) {
									seedDiv = $("#seed").first();
						} else {
									seedDiv = $('<div id="seed" style="display: none;"></div>');
									$('main.activity .activity-body').append(seedDiv);
						}

						seedDiv.fetchData(function () {
									seedDiv.persistentData(function () {
												var newSeed = seedDiv.persistentData('seed');

												if (newSeed !== undefined) {
															Math.seedrandom(newSeed);
												} else {
															var activityPath = $('main.activity').attr('data-path');
															var currfilebase = activityPath.split('/').slice(-1)[0];
															Math.seedrandom(currfilebase);
												}
												console.log("newSeed=", newSeed);
												console.log("reevaluate", seedDiv);

												$('.javascript script').each(function () {
															$.globalEval($(this).html());
												});
												exports.reevaluate(seedDiv);
									});
						});
			}
});

var createJavascript = function createJavascript() {
			var element = $(this);

			element.on('ximera:reevaluate', function (event) {
						var value = $('<span class="value"></span>');
						if ($('.value', element).length > 0) {
									value = $('.value', element);
						} else {
									element.append(value);
						}

						try {
									value.text(window[element.attr('id')].call(this).toString());
						} catch (err) {
									value.html('&#9633;');
						};
			});

			element.trigger('ximera:reevaluate');
};

$.fn.extend({
			javascript: function javascript() {
						return this.each(createJavascript);
			}
});

var evaluateLatex = exports.evaluateLatex = function (code) {
			var value;

			try {
						value = eval(code);

						if (typeof value === "number") {
									value = value.toString();
						}

						if (typeof value.tex !== "undefined") {
									value = value.tex();
						}

						value = value.toString();
			} catch (err) {
						value = '\\square';
			}

			return value;
};

var reevaluateMathjaxNow = function reevaluateMathjaxNow(element) {
			var activity = element.closest('.activity-body');

			var ids = new Set();

			$('.mathjax-javascript', activity).each(function (i, e) {
						var value;
						var code = $(e).attr('data-code');
						try {
									value = evaluateLatex(code);
						} catch (err) {
									value = '\\square';
						}

						if (value != $(e).attr('data-value')) {
									var id = $(e).closest(".MathJax").attr('id').replace('-Frame', '');
									ids.add(id);
						}
			});

			ids.forEach(function (id) {
						MathJax.Hub.Queue(["Reprocess", MathJax.Hub, id]);
			});
};

var reevaluateMathjax = _.debounce(reevaluateMathjaxNow, 250);

exports.reevaluate = function (element) {
			var activity = element.closest('.activity-body');

			$('.inline-javascript', activity).each(function (i, e) {
						$(e).triggerHandler('ximera:reevaluate');
			});

			reevaluateMathjax(element);
};

},{"./mathjax":"/usr/var/server/public/javascripts/mathjax.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/main.js":[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

console.log("  ▀██▄   ▄██▀ ██ █████     █████ ▄███████████████████▄    ███");
console.log("    ▀██▄██▀   ██▐██ ▐██   ██▌ ██▌██                 ██▌  ██▀██");
console.log("      ███     ██▐██  ██▌ ▐██  ██▌▐█████████ ▄████████▀  ██▀ ▀██");
console.log("    ▄██▀██▄   ██▐██  ▐██ ██▌  ██▌██        ▐█▌  ▀██▄   ██▀   ▀██");
console.log("  ▄██▀   ▀██▄ ██▐██   ▀███▀   ██▌▀█████████▐█▌    ▀██▄██▀     ▀██");

var ximera_subpath = localStorage.getItem("ximera-subpath");
var http = new XMLHttpRequest();
http.onreadystatechange = function () {
	var res = http.getResponseHeader('X-Ximera-SubPath');
	if (res != null) {
		ximera_subpath = res;
		localStorage.setItem("ximera-subpath", ximera_subpath);
	}
};
http.open('HEAD', document.location, false);
http.send();

window.toValidPath = function (uri) {
	return ximera_subpath + uri;
};

require('./version');

/* Definitely not ready for a serviceworker
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js', {scope: '/'})
	.then(function(reg) {
	    console.log('Registered Service Worker.');

	    window.updateServiceWorker = function() {
		console.log('updating sw');
		reg.update();
	    };
	}).catch(function(error) {
	    console.log('Registration failed: ' + error);
	});
}
*/

// bootstrap is expecting a global jQuery object
var $ = window.$ = window.jQuery = require('jquery');

// jsondiffpatch expects this loaded globally
window.diff_match_patch = require('diff-match-patch');

require('./cache-bust');

var Expression = require('math-expressions');

var jqueryUI = require('jquery-ui');
var jqueryTransit = require('jquery.transit');
var tether = require('tether');
window.Tether = tether;
var bootstrap = require('bootstrap');
var kinetic = require('jquery.kinetic/jquery.kinetic.min.js');

require('./chat');

var syntaxHighlighter = require('syntaxhighlighter');
window.sh = syntaxHighlighter;
syntaxHighlighter.registerBrush(require('./brushes/shBrushLatex'));
syntaxHighlighter.registerBrush(require('brush-javascript'));
syntaxHighlighter.registerBrush(require('brush-python'));

var MathJax = require('./mathjax');

var activity = require('./activity');
var mathAnswer = require('./math-answer');
var ProgressBar = require('./progress-bar');

var userProfile = require('./profile');
var users = require('./users');
var StickyScroll = require('./sticky-scroll');

var xourse = require('./xourse');
var imageEnvironment = require('./image-environment');

var instructor = require('./instructor');

var rowclick = require('./rowclick');
var supervision = require('./supervision');

var references = require('./references');
var Desmos = require('./desmos');

var Javascript = require('./javascript');

var sagemath = require('./sagemath');

var pencil = require('./pencil');

MathJax.Hub.Register.MessageHook("TeX Jax - parse error", function (message) {
	// do something with the error.  message[1] will contain the data about the error.
	console.log(message);
});

MathJax.Hub.Register.MessageHook("Math Processing Error", function (message) {
	//  do something with the error.  message[2] is the Error object that records the problem.
	console.log(message);
});

// Cervone says this will speed things up
MathJax.Hub.processSectionDelay = 0;
MathJax.Hub.processUpdateTime = 0;

MathJax.Hub.Register.StartupHook("End", function () {
	$(".accordion").accordion({
		active: false,
		autoHeight: false,
		collapsible: true,
		heightStyle: "content"
	});
	$(".accordion").removeClass('hidden-out-of-view');

	$("#loadingSpinner").hide();
	//$("#theActivity").removeClass('hidden') // Currently, the hidden class is not set

	references.highlightTarget(); // Scroll to target
});

MathJax.Hub.Register.StartupHook("TeX Jax Ready", function () {
	// Remove CDATA's from the script tags
	MathJax.InputJax.TeX.prefilterHooks.Add(function (data) {
		data.math = data.math.replace(/<!\[CDATA\[\s*((.|\n)*)\s*\]\]>/m, "$1");
	});

	// Replace "answer" commands with DOM elements
	var VERSION = "1.0";

	var TEX = MathJax.InputJax.TeX,
	    TEXDEF = TEX.Definitions,
	    MML = MathJax.ElementJax.mml,
	    HTML = MathJax.HTML;

	TEXDEF.macros.answer = "answer";
	TEXDEF.macros.graph = "graph";
	TEXDEF.macros.newlabel = "newlabel";
	TEXDEF.macros.sage = "sage";
	TEXDEF.macros.sagestr = "sagestr";
	TEXDEF.macros.delimiter = "delimiter";

	TEXDEF.macros.js = "js";

	var calculatorCount = 0;

	/* Sometimes htlatex generates \relax's which should be ignored */
	MathJax.InputJax.TeX.Definitions.Add({
		macros: {
			relax: ["Macro", ""],
			ensuremath: ["Macro", ""],
			xspace: ["Macro", ""]
		} });

	TEX.Parse.Augment({
		/* sage emits delimiter commands pretty frequently? */
		delimiter: function delimiter(name) {
			var d = this.GetArgument(name);

			if (d.match(/426830A/)) {
				var mml = TEX.Parse("\\langle", this.stack.env).mml();
				this.Push(mml);
				return;
			}

			if (d.match(/526930B/)) {
				var mml = TEX.Parse("\\rangle", this.stack.env).mml();
				this.Push(mml);
				return;
			}
		},

		// https://stackoverflow.com/questions/38726590/replace-variable-in-mathjax-equation
		sage: function sage(name) {
			return this.sagestr(name, true);
		},

		sagestr: function sagestr(name, latexify) {
			var code = this.GetArgument(name);

			if (latexify) code = "latex(" + code + ")";

			var spinner = HTML.Element("i", { className: "fa fa-spinner fa-spin" });
			var spinnerMml = MML["annotation-xml"](MML.xml(spinner)).With({ encoding: "application/xhtml+xml", isToken: true });
			var placeholder = MML.none(MML.semantics(spinnerMml));
			this.Push(placeholder);

			var env = this.stack.env;
			var that = this;

			sagemath.sage(code).then(function (result) {
				// The sagecell server returns quoted strings?  Let's
				// unquote them in this unsafe way.
				if (latexify != true) result = eval(result);

				MathJax.Hub.Queue([function () {
					// We act as if we are "Translate"ing the TeX into
					// MML, so most of this is copied from MathJax's
					// input/TeX/jax.js
					var mml = TEX.Parse(result, env).mml();

					// I have no idea what this does, but MathJax's
					// Translate command does it, and it doesn't work
					// without it.
					if (mml.inferred) mml = MML.apply(MathJax.ElementJax, mml.data);else mml = MML(mml);

					// Copy the newly Translate'd TeX over to the
					// placeholder "mnone" MathML element
					placeholder.data = mml.root.data;

					// We need to figure out our MathJax ID so we can
					// request a Rerender
					var parent = placeholder;
					while (parent.parent != undefined) {
						parent = parent.parent;
					}if (parent.inputID) MathJax.Hub.Queue(["Rerender", MathJax.Hub, parent.inputID]);

					return;
				}]);
			}, function (err) {
				console.log(err);
				// BADBAD: Display the error
			});

			return;
		},

		/* Implements \graph{y=x^2, r = theta} and the like */
		graph: function graph(name) {
			// Load Desmos asynchronously
			Desmos.loadAsynchronously();

			var optionalArguments = this.GetBrackets(name);
			var equations = this.GetArgument(name);

			var keys = {};
			if (optionalArguments) {
				optionalArguments.split(/,/).forEach(function (kv) {
					kv = kv.trim().split(/=/);
					if (kv.length > 1) keys[kv[0]] = kv[1];else keys[kv[0]] = true;
				});
			}

			var id = "calculator" + calculatorCount;
			calculatorCount = calculatorCount + 1;
			var element = HTML.Element("div", { className: "calculator",
				id: id,
				style: { width: "30px", height: "300px" }
			});
			var mml = MML["annotation-xml"](MML.xml(element)).With({ encoding: "application/xhtml+xml", isToken: true });
			this.Push(MML.semantics(mml));

			MathJax.Hub.Queue(function () {
				var element = document.getElementById(id);
				var parent = $(element).closest('div.MathJax_Display');
				parent.empty();
				element = parent;

				Desmos.onReady(function (Desmos) {
					var calculator = Desmos.Calculator(element, {
						expressionsCollapsed: !keys.panel
					});
					window.calculator = calculator;

					if (equations.match(/^\(.*\)$/)) calculator.setExpression({ id: 'graph', latex: equations });else {
						equations.split(',').forEach(function (equation, index) {
							calculator.setExpression({ id: 'graph' + index, latex: equation });
						});
					}
					if (keys.xmax !== undefined) {
						calculator.setMathBounds({
							left: parseFloat(keys.xmin),
							right: parseFloat(keys.xmax),
							top: parseFloat(keys.ymax),
							bottom: parseFloat(keys.ymin) });
					}
					if (keys.polar !== undefined) {
						calculator.setGraphSettings({ polarMode: true });
					}
					if (keys.hideXAxis) {
						calculator.setGraphSettings({ showXAxis: false });
					}
					if (keys.hideYAxis) {
						calculator.setGraphSettings({ showYAxis: false });
					}
					if (keys.xAxisLabel) {
						calculator.setGraphSettings({ xAxisLabel: keys.xAxisLabel });
					}
					if (keys.yAxisLabel) {
						calculator.setGraphSettings({ yAxisLabel: keys.yAxisLabel });
					}
					if (keys.hideXAxisNumbers) {
						calculator.setGraphSettings({ xAxisNumbers: false });
					}
					if (keys.hideYAxisNumbers) {
						calculator.setGraphSettings({ yAxisNumbers: false });
					}

					// Bart requests that projectorMode be default
					calculator.setGraphSettings({ projectorMode: true });
					if (keys.projectorMode) {
						calculator.setGraphSettings({ projectorMode: true });
					}
					if (keys.thinMode) {
						calculator.setGraphSettings({ projectorMode: false });
					}
					var height = keys.height || 300;
					$(element).height(height);
					calculator.resize();
				});
			});
		},

		/* Implements \js{code} */
		js: function js(name) {
			var code = this.GetArgument(name);
			var value = Javascript.evaluateLatex(code);

			var mml = TEX.Parse(value, this.stack.env).mml();

			this.Push(mml);

			var watcher = HTML.Element("span", { className: "mathjax-javascript",
				style: { display: "none" }
			});

			watcher.setAttribute("data-code", code);
			watcher.setAttribute("data-value", value);

			var watcherMml = MML["annotation-xml"](MML.xml(watcher)).With({ encoding: "application/xhtml+xml", isToken: true });
			this.Push(MML.semantics(watcherMml));
		},

		/* Implements \answer[key=value]{text} */
		answer: function answer(name) {
			var keys = this.GetBrackets(name);

			var input = HTML.Element("form", { className: "mathjaxed-input",
				style: { marginBottom: "10px", marginTop: "10px", display: "inline-flex" }
			});
			input.setAttribute("xmlns", "http://www.w3.org/1999/xhtml");

			// Parse key=value pairs from optional [bracket] into data- attributes
			var options = {};
			if (keys !== undefined) {
				keys.split(",").forEach(function (keyvalue) {
					var key = keyvalue.split("=")[0];
					var value = keyvalue.split("=").slice(1).join('=');
					if (value === undefined) value = true;

					input.setAttribute("data-" + key, value);

					options[key] = value;
				});
			}
			var showAnswer = options['onlinenoinput'] === '' || options['onlineshowanswerbutton'] === '';
			var showInput = options['onlinenoinput'] !== '';

			var format = options['format'];
			var answer;

			if (format == 'string') {
				answer = this.GetArgument(name);
				answer = MML.mtext(answer);
			} else if (format == 'integer' || format == 'float') {
				answer = this.GetArgument(name);
				answer = MML.mn(answer);
			} else {
				// This actually PARSES the content of the \answer command
				// with mathjax; the result will be MathML.  If we had
				// instead used this.GetArgument(name) we could have
				// gotten the raw string passed to \answer, but by using
				// ParseArg, we can invoke \newcommand's from inside an
				// \answer.
				answer = this.ParseArg(name);
			}
			input.style.width = (155 + (showAnswer && showInput ? 25 : 0)).toString() + "px";

			// Attempt to change size if we have a short answer
			try {
				answer.parent = { inferRow: false };
				var correctAnswerMml = answer.toMathML("");
				var correctAnswer = Expression.fromMml(correctAnswerMml).toString().toString();
				if (correctAnswer.length <= 3) {
					input.classList.add('narrow'); // to eliminate some padding
					input.style.width = (70 + (showAnswer && showInput ? 25 : 0)).toString() + "px";
				}
			} catch (err) {}

			this.Push(MML.mpadded(MML.mphantom(answer)).With({ height: 0, width: 0 }));
			mathAnswer.createMathAnswer(input, showInput, showAnswer);

			var xml = MML.xml(input);
			var mml = MML["annotation-xml"](xml).With({ encoding: "application/xhtml+xml", isToken: true });
			var semantics = MML.semantics(mml);
			this.Push(semantics);
			this.Push(MML.mpadded().With({ height: "30px", width: 0 }));

			return;
		}
	});
});

function searchJax(jax, spanID) {
	// Sometimes the jax is null?  I don't really know why.
	if (jax === null) return null;

	if (jax.spanID == spanID) {
		return jax;
	} else if (jax.data != null) {
		var i;
		var result = null;
		for (i = 0; result == null && i < jax.data.length; i++) {
			result = searchJax(jax.data[i], spanID);
		}
		return result;
	}
	return null;
}

var answerIdBindings = {};

MathJax.Hub.signal.Interest(function (message) {
	if (message[0] == "New Math") {
		var id = message[1];

		if (answerIdBindings[id] === undefined) {
			answerIdBindings[id] = {};
		}

		var element = $('#' + id + "-Frame");
		var jax = MathJax.Hub.getAllJax(id);

		var internalCount = 0;

		$(".mathjaxed-input", element).each(function () {
			var result = $(this);

			if (answerIdBindings[id][internalCount] === undefined) {
				// Number the answer boxes in order
				var problem = result.parents(".problem-environment").first();
				var count = problem.attr("data-answer-count");
				if ((typeof count === "undefined" ? "undefined" : _typeof(count)) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) || count === false) {
					count = 0;
				}

				problem.attr("data-answer-count", parseInt(count) + 1);
				var problemIdentifier = problem.attr("id");

				// Store the answer index as an id
				answerIdBindings[id][internalCount] = "answer" + count + problemIdentifier;
			}

			result.attr('id', answerIdBindings[id][internalCount]);
			internalCount = internalCount + 1;

			var answerDom = result.closest('.semantics').prev('.mpadded').find('.mphantom').first();
			var answerId = parseInt(answerDom.attr('id').replace('MathJax-Span-', ''));
			var answer = searchJax(jax[0].root, answerId);

			mathAnswer.connectMathAnswer(result, answer);
		});
	}
});

MathJax.Hub.Configured();

$(document).ready(function () {
	// Make anchors with references from \ref actually work
	$('a.ximera-label').texLabel();
	$('a.reference').reference();

	// This could go in "init" above, but it needs to be after the end process hook
	MathJax.Hub.Startup.onload();

	// BADBAD: This seems like the wrong thing---why is default here?
	syntaxHighlighter.default.highlight();

	rowclick.addClickableTableRows();

	// Scroll to correct item in (old) top card-list
	$('.kinetic').kinetic({});
	var active = $('.activity-card.active');
	if (active.length > 0) {
		var left = $('.activity-card.active').position().left;
		var cardWidth = $('.activity-card.active').width();
		var windowWidth = $('.kinetic').width();
		$('.kinetic').scrollLeft(left - windowWidth / 2 + cardWidth / 2);
	}

	// Scroll to correct item in (new) nav menu
	$('.main-toc').kinetic({});
	var active = $('.activity-card.active');
	if (active.length > 0) {
		var top = $('.activity-card.active').position().top;
		var cardHeight = $('.activity-card.active').height();
		var windowHeight = $('.main-toc').height();
		$('.main-toc').scrollTop(top - windowHeight / 2 + cardHeight / 2);
	}

	// This is both mouseup for desktop
	$('.activity-card a').bind("mouseup", function (event) {
		if ($('.kinetic-moving-left').length > 0 || $('.kinetic-moving-right').length > 0) {
			event.preventDefault();
		}
	});

	// This handles touchscreens; moving less than 100 pixels in less
	// than 500 ms should count as a click
	// var position = 0;
	// var distance = 0;
	// var startTime = 0;
	// $('.activity-card').on( "touchstart", function(e){
	// position = e.originalEvent.touches[0].screenX;
	// distance = 0;
	// startTime = e.originalEvent.timeStamp
	// });

	// $('.activity-card').on( "touchmove", function(e){
	// var newPosition = e.originalEvent.touches[0].screenX;
	// distance = distance + Math.abs( newPosition - position );
	// position = newPosition;
	// });    

	// $('.activity-card').on( "touchend", function(e){
	// var duration = e.originalEvent.timeStamp - startTime;
	// if ((distance < 100) && (duration < 500)) {
	// 	var href = $(this).children('a').attr('href');
	// 	if(href)
	//     	window.location.href = href;
	// }
	// });

	$(".dropdown-toggle").dropdown();

	$('[data-toggle="tooltip"]').tooltip();

	$(".activity").activity();
});

console.log("done.");

},{"./activity":"/usr/var/server/public/javascripts/activity.js","./brushes/shBrushLatex":"/usr/var/server/public/javascripts/brushes/shBrushLatex.js","./cache-bust":"/usr/var/server/public/javascripts/cache-bust.js","./chat":"/usr/var/server/public/javascripts/chat.js","./desmos":"/usr/var/server/public/javascripts/desmos.js","./image-environment":"/usr/var/server/public/javascripts/image-environment.js","./instructor":"/usr/var/server/public/javascripts/instructor.js","./javascript":"/usr/var/server/public/javascripts/javascript.js","./math-answer":"/usr/var/server/public/javascripts/math-answer.js","./mathjax":"/usr/var/server/public/javascripts/mathjax.js","./pencil":"/usr/var/server/public/javascripts/pencil.js","./profile":"/usr/var/server/public/javascripts/profile.js","./progress-bar":"/usr/var/server/public/javascripts/progress-bar.js","./references":"/usr/var/server/public/javascripts/references.js","./rowclick":"/usr/var/server/public/javascripts/rowclick.js","./sagemath":"/usr/var/server/public/javascripts/sagemath.js","./sticky-scroll":"/usr/var/server/public/javascripts/sticky-scroll.js","./supervision":"/usr/var/server/public/javascripts/supervision.js","./users":"/usr/var/server/public/javascripts/users.js","./version":"/usr/var/server/public/javascripts/version.js","./xourse":"/usr/var/server/public/javascripts/xourse.js","bootstrap":"/usr/var/server.base/node_modules/bootstrap/dist/js/bootstrap.js","brush-javascript":"/usr/var/server.base/node_modules/brush-javascript/brush.js","brush-python":"/usr/var/server.base/node_modules/brush-python/brush.js","diff-match-patch":"/usr/var/server.base/node_modules/diff-match-patch/index.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","jquery-ui":"/usr/var/server.base/node_modules/jquery-ui/ui/widget.js","jquery.kinetic/jquery.kinetic.min.js":"/usr/var/server.base/node_modules/jquery.kinetic/jquery.kinetic.min.js","jquery.transit":"/usr/var/server.base/node_modules/jquery.transit/jquery.transit.js","math-expressions":"/usr/var/server.base/node_modules/math-expressions/build/math-expressions_umd.js","syntaxhighlighter":"/usr/var/server.base/node_modules/syntaxhighlighter/src/core.js","tether":"/usr/var/server.base/node_modules/tether/dist/js/tether.js"}],"/usr/var/server/public/javascripts/math-answer.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var jqueryUI = require('jquery-ui/ui/unique-id');
var _ = require('underscore');
var MathJax = require('./mathjax');
var TinCan = require('./tincan');
var database = require('./database');
var Expression = require('math-expressions');
var ProgressBar = require('./progress-bar');
var popover = require('./popover');
var Javascript = require('./javascript');
var palette = require('./math-palette');

var buttonlessTemplate = '<input class="form-control" type="text"/>';

// add labels for screenreader
var template = '<div class="input-group" style="width:100%">' + '<input class="form-control answer-input-part" aria-label="answer" type="text"/>' + '<span class="input-group-btn answer-input-part">' + '<button class="px-0 btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Correct!" style="display: none; z-index: 1;" aria-label="Correct" aria-live="polite">' + '<i class="fa fa-fw fa-check"></i>' + '</button>' + '<button class="px-0 btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Incorrect, try again!" style="display: none; z-index: 1;" aria-label="Incorrect, try again" aria-live="polite">' + '<i class="fa fa-fw fa-times"></i>' + '</button>' + '<button class="px-0 btn btn-primary disabled btn-ximera-checking" aria-label="Checking" data-toggle="tooltip" data-placement="top" title="Check..." style="z-index: 1; display: none;">' + '<i class="fa fa-fw fa-spinner fa-spin"></i>' + '</button>' + '<button class="px-0 btn btn-primary btn-ximera-submit" aria-label="Check" data-toggle="tooltip" data-placement="top" title="Click to check your answer." style="z-index: 1;">' + '<i class="fa fa-fw fa-question"></i>' + '</button>' + '</span>' + '<span class="input-group-btn show-answer-small">' + '<button class="px-0 btn btn-primary btn-info btn-ximera-show-answer" style="vertical-align:baseline" aria-label="Show Answer" data-toggle="tooltip" data-placement="top" title="Click to Show Answer." style="z-index: 1;">' + '<i class="fa fa-fw fa-key"></i>' + '</button>' + '</span>' + '<span class="input-group-btn show-answer-large" style="width:100%">' + '<button class="px-0 btn btn-primary btn-info btn-ximera-show-answer" style="vertical-align:baseline; width:100%" aria-label="Show Answer" data-toggle="tooltip" data-placement="top" title="Click to Show Answer." style="z-index: 1;">' + '<i class="fa fa-fw fa-key"></i><span class="show-answer-text">Show Answer</span>' + '</button>' + '</span>' + '</div>';

var template_nl = '<div class="input-group" style="width:100%">' + '<input class="form-control answer-input-part" aria-label="answer" type="text"/>' + '<span class="input-group-btn answer-input-part">' + '<button class="px-0 btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Juist!" style="display: none; z-index: 1;" aria-label="juist" aria-live="assertive">' + '<i class="fa fa-fw fa-check"></i>' + '</button>' + '<button class="px-0 btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Fout. Probeer opnieuw!" style="display: none; z-index: 1;" aria-label="fout! probeer opnieuw" aria-live="assertive">' + '<i class="fa fa-fw fa-times"></i>' + '</button>' + '<button class="px-0 btn btn-primary disabled btn-ximera-checking" aria-label="aan het controleren" data-toggle="tooltip" data-placement="top" title="Controleren..." style="z-index: 1; display: none;">' + '<i class="fa fa-fw fa-spinner fa-spin"></i>' + '</button>' + '<button class="px-0 btn btn-primary btn-ximera-submit" aria-label="kijk na" data-toggle="tooltip" data-placement="top" title="Klik om je antwoord na te kijken." style="z-index: 1;">' + '<i class="fa fa-fw fa-question"></i>' + '</button>' + '</span>' + '<span class="input-group-btn show-answer-small">' + '<button class="px-0 btn btn-primary btn-info btn-ximera-show-answer" style="vertical-align:baseline" aria-label="Toon antwoord" data-toggle="tooltip" data-placement="top" title="Klik om het antwoord te tonen." style="z-index: 1;">' + '<i class="fa fa-fw fa-key"></i>' + '</button>' + '</span>' + '<span class="input-group-btn show-answer-large" style="width:100%">' + '<button class="px-0 btn btn-primary btn-info btn-ximera-show-answer" style="vertical-align:baseline; width:100%" aria-label="Toon antwoord" data-toggle="tooltip" data-placement="top" title="Klik om het antwoord te tonen." style="z-index: 1;">' + '<i class="fa fa-fw fa-key"></i><span class="show-answer-text">Toon Antwoord</span>' + '</button>' + '</span>' + '</div>';

function parseFormattedInput(format, input) {
	if (format == 'integer') return parseInt(input);else if (format == 'float') return parseFloat(input);else if (format == 'string') return input;else {
		try {
			return Expression.fromText(input);
		} catch (err) {
			try {
				return Expression.fromLatex(input);
			} catch (err) {
				return undefined;
			}
		}
	}

	return undefined;
}

function assignGlobalVariable(answerBox, text) {
	var result = answerBox;

	if (result.attr('data-id')) {
		window[result.attr('data-id')] = parseFormattedInput(result.attr('data-format'), text);

		Javascript.reevaluate(result);
	}
}

exports.createMathAnswer = function (input, showInput, showAnswerButton) {
	input = $(input);
	var width = input.width();

	var lang = (navigator.language || 'en').slice(0, 2);
	if (lang === "nl") {
		input.append($(template_nl));
	} else {
		input.append($(template));
	}

	if (!showInput) {
		input.find('.show-answer-small').hide();
		input.find('.answer-input-part').hide();
	} else {
		input.find('.show-answer-large').hide();
		if (!showAnswerButton) {
			input.find('.show-answer-small').hide();
		}
	}

	return;
};

exports.connectMathAnswer = function (result, answer) {
	var buttonless = false;
	if (result.parents('.validator').length > 0) {
		buttonless = true;
	}

	// When the box changes, update the database AND any javascript variables
	var inputBox = result.find("input.form-control");

	inputBox.on('input', function () {
		var text = $(this).val();
		result.persistentData('response', text);
		assignGlobalVariable(result, text);
	});

	// ACCESSIBILITY: unfortunately, we prevent spacebar from opening
	// a mathjax menu.  By enabling menus in mathjax, right-clicking
	// still opens the menu.
	//inputBox.on( 'keydown', function(event) {
	inputBox.on('keydown', function (event) {
		if (event.keyCode == 32) {
			event.stopPropagation();
		}
	});

	////////////////////////////////////////////////////////////////
	// Link the "math editor" button in the toolbar to the CURRENTLY
	// FOCUSED textfield
	function updateMathEditButton() {
		if ($(document.activeElement).attr('data-input-box')) $("#math-edit-button").show();else $("#math-edit-button").hide();
	}

	/*
   If you happen to click outside a math input box, then the math
 editor will still be linked to your previous choice.
 inputBox.focusout( function() { window.setTimeout( function() {
 updateMathEditButton(); }, 100 ); });
 */

	inputBox.focus(function () {
		$(this).attr('data-input-box', true);
		updateMathEditButton();

		$("#math-edit-button").unbind("click");
		$("#math-edit-button").click(function () {
			palette.launch(inputBox.val(), function (err, text) {
				inputBox.val(text), result.persistentData('response', text);
				assignGlobalVariable(result, text);
				inputBox.focus();
				inputBox.trigger('input');
			});
		});
	});

	result.on('ximera:statistics:answers', function (event, answers) {
		var total = Object.keys(answers).map(function (x) {
			return answers[x];
		}).reduce(function (a, b) {
			return a + b;
		});

		var control = result.find("input.form-control");

		var table = '<table class="table table-striped">' + '<thead>' + '  <tr>' + '    <th>Number</th>' + '    <th>Answer</th>' + '  </tr>' + '</thead><tbody>';

		var sortedAnswers = Object.keys(answers).sort(function (a, b) {
			return -(+(answers[a] > answers[b]) || +(answers[a] === answers[b]) - 1);
		});

		sortedAnswers.slice(0, 3).forEach(function (answer) {
			table = table + '<tr><td>' + answers[answer] + '</td><td>' + answer + '</td></tr>';
		});

		var additionalAnswers = sortedAnswers.slice(3, sortedAnswers.length).join(', ');

		table = table + '</tbody></table>';

		var modal = $('<div class="modal fade" tabindex="-1" role="dialog">' + '  <div class="modal-dialog">' + '    <div class="modal-content">' + '      <div class="modal-header">' + '        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + '        <h4 class="modal-title">' + total + ' Answers</h4>' + '      </div>' + '      <div class="modal-body">' + '        ' + table + '        <p>Additional Answers: ' + additionalAnswers + '<p>' + '      </div>' + '      <div class="modal-footer">' + '        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>' + '      </div>' + '    </div><!-- /.modal-content -->' + '  </div><!-- /.modal-dialog -->' + '</div><!-- /.modal -->');
		modal.uniqueId();

		$('body').prepend(modal);
		modal.find('button').click(function () {
			modal.modal('hide');
		});

		result.find('span.input-group-btn').prepend($('<button class="btn btn-info" data-toggle="tooltip" data-placement="top" title="' + total + '  Answers">' + '<i class="fa fa-bar-chart"/>' + '</button>'));

		result.find('button.btn-info').click(function () {
			$('#' + modal.attr('id')).modal('show');
			return false;
		});

		// fix the button size
		var width = result.width();
		inputBox.css('min-width', '2em');
		inputBox.width(width - (138 - 70) - 45);
	});

	result.on('ximera:statistics:successes', function (event, successes) {
		var total = Object.keys(successes).map(function (x) {
			return successes[x];
		}).reduce(function (a, b) {
			return a + b;
		});

		if (!('true' in successes)) successes['true'] = 0;
		if (!('false' in successes)) successes['false'] = 0;

		var correctPercent = successes['true'] * 100.0 / total;
		var incorrectPercent = successes['false'] * 100.0 / total;
		var fraction = correctPercent;
		if (fraction == 0) inputBox.css('background', 'rgba(255,0,0,0.08)');else if (fraction == 100) inputBox.css('background', 'rgba(0,0,255,0.13)');else inputBox.css('background', 'linear-gradient(90deg, rgba(0,0,255,0.13) ' + fraction + '%, rgba(255,0,0,0.08) ' + fraction + '%)');
	});

	// Tell whoever is above us that we need an answer to proceed
	if (!buttonless) result.trigger('ximera:answer-needed');

	// When the database changes, update the box
	result.persistentData(function (event) {
		console.log("Persisting " + result.attr("id"));
		if (result.persistentData('response')) {
			if ($(inputBox).val() != result.persistentData('response')) {
				$(inputBox).val(result.persistentData('response'));
				assignGlobalVariable(result, result.persistentData('response'));
			}
		} else {
			$(inputBox).val('');
		}

		var mjElement = result.closest('.MathJax, .MathJax_Display');
		var divElement = mjElement.parent();
		var scriptElement = divElement.attr('class') === 'MathJax_Display' ? divElement.next() : mjElement.next();
		var solScriptElementId = scriptElement.attr('id') + "-sol";
		var tex = scriptElement.text();
		var a = MathJax.Hub.getAllJax(scriptElement.attr('id'))[0];
		$("#" + solScriptElementId).prev().remove();
		$("#" + solScriptElementId).remove();
		if (result.persistentData('correct')) {
			result.find('.btn-ximera-correct').show();
			result.find('.btn-ximera-incorrect').hide();
			result.find('.btn-ximera-checking').hide();
			result.find('.btn-ximera-submit').hide();

			result.find('.show-answer-small').hide();
			result.find('.show-answer-large').hide();

			if ((tex.match(/\\answer/g) || []).length === 1) {
				var answerRegExp = /\\answer (\[.*\])*{(.*)}/;
				var m = tex.match(answerRegExp);
				if (m) {
					mjElement.hide();
					console.log(scriptElement.attr('type'));
					scriptElement.after("<script type='" + scriptElement.attr('type') + "' id='" + solScriptElementId + "'>" + tex.replace(answerRegExp, "{\\color{blue} " + m[2] + "}") + "</script>");
					MathJax.Hub.Queue(["Typeset", MathJax.Hub, "#" + solScriptElementId]);
				}
			}

			inputBox.prop('disabled', true);
			// Disabled elements won't fire the blur event that would otherwise hide this
			$(result).popover('hide');
		} else {
			inputBox.prop('disabled', false);

			// I'm doing "result.find('.btn').hide();" but avoiding the info button
			result.find('.btn-ximera-correct').hide();
			result.find('.btn-ximera-incorrect').hide();
			result.find('.btn-ximera-checking').hide();
			result.find('.btn-ximera-submit').hide();

			if (scriptElement[0] && scriptElement[0].hasAttribute("data-initial") && scriptElement.attr("data-initial") !== tex) {
				MathJax.Hub.Queue(["Text", a, scriptElement.attr("data-initial")]);
			}

			mjElement.show();

			var showInput = !result.is('[data-onlinenoinput]');
			var showAnswerButton = result.is('[data-onlineshowanswerbutton]');

			if (!showInput) {
				result.find('.show-answer-small').hide();
				result.find('.answer-input-part').hide();
				result.find('.show-answer-large').show();
			} else {
				result.find('.show-answer-large').hide();
				if (!showAnswerButton) {
					result.find('.show-answer-small').hide();
				} else {
					result.find('.show-answer-small').show();
				}
				result.find('.answer-input-part').show();
			}

			if (result.persistentData('response') == result.persistentData('attempt') && result.persistentData('response')) {
				result.find('.btn-ximera-incorrect').show();
			} else {
				result.find('.btn-ximera-submit').show();
			}
		}
	});

	result.find(".btn-ximera-correct").click(function () {
		return false;
	});

	result.find(".btn-ximera-incorrect").click(function () {
		result.find(".btn-ximera-submit").click();
		return false;
	});

	var correctAnswerText = answer.toMathML("");
	correctAnswerText = correctAnswerText.replace('<none>', '').replace('</none>', '');
	correctAnswerText = correctAnswerText.replace('<mphantom>', '<math>').replace('</mphantom>', '</math>');

	var correctAnswer;
	var format = result.attr('data-format');
	if (format === undefined) format = 'expression';

	if (format == 'integer' || format == 'float') {
		correctAnswerText = correctAnswerText.replace('<math>', '').replace('</math>', '');
		correctAnswerText = correctAnswerText.replace('<mn>', '').replace('</mn>', '');
	}

	if (format == 'string') {
		correctAnswerText = correctAnswerText.replace('<math>', '').replace('</math>', '');
		correctAnswerText = correctAnswerText.replace('<mtext>', '').replace('</mtext>', '');
		correctAnswerText = correctAnswerText.trim();
	}

	if (format == 'integer') {
		correctAnswer = parseInt(correctAnswerText);
	} else if (format == 'float') {
		correctAnswer = parseFloat(correctAnswerText);
	} else if (format == 'string') {
		correctAnswer = correctAnswerText;
	} else {
		try {
			correctAnswer = Expression.fromLatex(correctAnswerText);

			if (!correctAnswer) {
				try {
					correctAnswer = Expression.fromLatex(correctAnswerText.toLowerCase());
				} catch (err) {
					correctAnswer = false;
				}
			}
		} catch (err) {
			try {
				correctAnswer = Expression.fromMml(correctAnswerText);
			} catch (err) {
				console.log("Instructor error in \\answer: " + err);
				correctAnswer = Expression.fromText("sqrt(-1)");
			}
		}
	}

	result.find(".btn-ximera-submit").click(function () {
		// We're passing an "answer" from MathJax, as "jax"
		answer.parent = { inferRow: false };
		var studentAnswerText = inputBox.val();
		var studentAnswer = parseFormattedInput(format, studentAnswerText);
		if (studentAnswer === undefined) studentAnswer = Expression.fromText("sqrt(-1)");

		var tolerance = result.attr('data-tolerance');

		if (tolerance) {
			tolerance = parseFloat(tolerance);

			var correctAnswerFloat = correctAnswer.evaluate({});
			var studentAnswerFloat = studentAnswer.evaluate({});

			result.persistentData('correct', Math.abs(correctAnswerFloat - studentAnswerFloat) <= tolerance);
			result.persistentData('attempt', inputBox.val());

			if (result.persistentData('correct')) result.trigger('ximera:correct');
		} else {
			var correct = false;

			if (result.attr('data-validator')) {
				var code = result.attr('data-validator');
				try {
					var f = Function('return ' + code + ';');

					correct = f.call(studentAnswer);
					if (typeof correct === 'function') correct = correct(studentAnswer, correctAnswer);
				} catch (err) {
					console.log(err);
					correct = false;
				}
			} else {
				if (format === 'string') {
					// Strings should be normalized to uppercase when
					// doing case insensitive comparison, per
					// https://msdn.microsoft.com/en-us/library/bb386042.aspx
					correct = correctAnswer.toUpperCase() == studentAnswer.toUpperCase();
				} else {
					if (format !== 'expression') {
						console.log("compare ", correctAnswer, " and ", studentAnswer);
						correct = correctAnswer == studentAnswer;
					} else correct = studentAnswer.equals(correctAnswer);
				}
			}

			// Check if the correct answer is actually a promise to check for correctness
			if (correct.then) {
				result.find('.btn-ximera-correct').hide();
				result.find('.btn-ximera-incorrect').hide();
				result.find('.btn-ximera-checking').show();
				result.find('.btn-ximera-submit').hide();
				// Disabled elements won't fire the blur event that would otherwise hide this		
				inputBox.prop('disabled', true);

				correct.then(function (value) {
					if (value) {
						result.persistentData('correct', true);
						result.trigger('ximera:correct');
					} else {
						result.persistentData('correct', false);
						result.persistentData('attempt', inputBox.val());
					}
				}, function (reason) {
					result.find('.btn-ximera-correct').hide();
					result.find('.btn-ximera-incorrect').hide();
					result.find('.btn-ximera-checking').hide();
					result.find('.btn-ximera-submit').show();
					inputBox.prop('disabled', false);

					alert(reason);
				});
			} else {
				if (correct) {
					result.persistentData('correct', true);
					result.trigger('ximera:correct');
				} else {
					result.persistentData('correct', false);
					result.persistentData('attempt', inputBox.val());
				}
			}
		}

		result.trigger('ximera:attempt');

		TinCan.answer(result, { response: result.persistentData('response'),
			success: result.persistentData('correct') });

		return false;
	});

	result.find(".btn-ximera-show-answer").click(function () {
		// TODO: log that this button has been clicked
		result.find('.show-answer-large').hide();
		result.find('.show-answer-small').hide();
		result.find('.answer-input-part').show();

		result.find('[aria-label="answer"]').val(correctAnswer);
		result.find('input.form-control').focus();
		result.find('input.form-control').trigger('input');

		result.find(".btn-ximera-submit").click();

		return false;
	});

	inputBox.keydown(function (event) {
		if (event.keyCode == 13) {
			event.preventDefault();
			return false;
		}
	});

	inputBox.keyup(function (event) {
		if (buttonless) result.closest('.validator').trigger('ximera:answers-changed');

		if (event.keyCode == 13) {
			if (!buttonless) result.find(".btn-ximera-submit").click();else {
				// Submit the validator if it is wrapped in a validator
				result.closest('.validator').find(".btn-ximera-submit").click();
			}
		}

		return false;
	});

	popover.bindPopover(result);
};

},{"./database":"/usr/var/server/public/javascripts/database.js","./javascript":"/usr/var/server/public/javascripts/javascript.js","./math-palette":"/usr/var/server/public/javascripts/math-palette.js","./mathjax":"/usr/var/server/public/javascripts/mathjax.js","./popover":"/usr/var/server/public/javascripts/popover.js","./progress-bar":"/usr/var/server/public/javascripts/progress-bar.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","jquery-ui/ui/unique-id":"/usr/var/server.base/node_modules/jquery-ui/ui/unique-id.js","math-expressions":"/usr/var/server.base/node_modules/math-expressions/build/math-expressions_umd.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/math-palette.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');

// https://github.com/daniel3735928559/guppy
var Guppy = require('guppy-dev/src/guppy.js');

var Expression = require('math-expressions');
var guppyDiv = undefined;
var callback = undefined;

$(function () {
	if ($("#guppy").length > 0) {
		var symbolizer = function symbolizer(id, sym) {
			$('#guppy-' + id).mousedown(function (event) {
				guppyDiv.engine.insert_symbol(sym);
				event.stopImmediatePropagation();
				document.getElementById("guppy").focus();
			});
		};

		var stringizer = function stringizer(id, str) {
			$('#guppy-' + id).mousedown(function (event) {
				guppyDiv.engine.insert_string(str);
				event.stopImmediatePropagation();
				document.getElementById("guppy").focus();
			});
		};

		Guppy.init({ "path": "/lib/guppy",
			"symbols": window.toValidPath("/public/json/symbols.json")
		});

		guppyDiv = new Guppy("guppy", {
			settings: {
				"buttons": []
			},
			"events": {
				'done': function done(event) {
					var input = guppyDiv.engine.get_content('latex');
					try {
						var output = Expression.fromLatex(input.replace(/\\dfrac/g, '\\frac').replace(/\\cdot/g, ' ')).toString();
						$('#guppymathModal').modal('hide');

						callback(null, output);
					} catch (err) {
						$('#guppy-error').text(err);
					}
				}
			}
		});

		symbolizer('pi', 'pi');
		symbolizer('theta', 'theta');
		symbolizer('phi', 'phi');
		symbolizer('rho', 'rho');

		symbolizer('sqrt', 'sqrt');
		symbolizer('root', 'root');
		stringizer('times', '*');
		stringizer('plus', '+');
		stringizer('minus', '-');
		symbolizer('slash', 'slash');
		symbolizer('paren', 'paren');
		symbolizer('abs', 'abs');
		symbolizer('exp', 'exp');

		stringizer('sin', 'sin');
		stringizer('cos', 'cos');
		stringizer('tan', 'tan');
		stringizer('log', 'log');
		stringizer('ln', 'ln');
		stringizer('arcsin', 'arcsin');
		stringizer('arccos', 'arccos');
		stringizer('arctan', 'arctan');

		$('#guppy-etothe').mousedown(function (event) {
			guppyDiv.engine.insert_string('e');
			guppyDiv.engine.insert_symbol('exp');
			event.stopImmediatePropagation();
			document.getElementById("guppy").focus();
		});
	}

	$('#guppy-save-button').click(function () {
		guppyDiv.engine.done();
	});
});

module.exports.launch = function (text, f) {
	callback = f;

	try {
		if (text.match(/^ *$/)) {
			guppyDiv.engine.set_content('<m><e></e></m>');
		} else {
			var expression = Expression.fromText(text);
			guppyDiv.engine.set_content(expression.toXML());
		}
	} catch (err) {
		guppyDiv.engine.set_content('<m><e></e></m>');
		//$('#guppy-error').text(err);
	}

	$('#guppymathModal').modal('show');
	guppyDiv.activate();
};

},{"guppy-dev/src/guppy.js":"/usr/var/server.base/node_modules/guppy-dev/src/guppy.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","math-expressions":"/usr/var/server.base/node_modules/math-expressions/build/math-expressions_umd.js"}],"/usr/var/server/public/javascripts/mathjax.js":[function(require,module,exports){
"use strict";

window.MathJax = {
    delayStartupUntil: "configured",

    jax: ["input/TeX", "output/HTML-CSS"],
    extensions: ["tex2jax.js", "MathMenu.js", "MathZoom.js", "toMathML.js", "AssistiveMML.js", "[a11y]/accessibility-menu.js"],

    tex2jax: { preview: "none" },

    "HTML-CSS": {
        availableFonts: ["Tex"],
        imageFont: null
    },

    processEnvironments: true,
    showProcessingMessages: false,
    messageStyle: 'none',

    // MathMenu: {
    // showRenderer: false,
    // showMathPlayer: false
    // },

    // BADBAD: this also breaks the layout triggers
    // showMathMenu: false,

    TeX: {
        equationNumbers: { autoNumber: "AMS" },
        // siunitx copied from  https://github.com/mathjax/MathJax-third-party-extensions/blob/master/legacy/siunitx/siunitx.js
        extensions: ["AMSmath.js", "AMSsymbols.js", "noErrors.js", "noUndefined.js", "color.js", "cancel.js", "mhchem.js", "siunitx.js"],
        noErrors: { disabled: true },
        Macros: {
            SI: ['\\num{#1}\\,\\si{#2}', 2],
            xspace: '',
            ensuremath: ''
        }
    },

    root: window.toValidPath("/node_modules/mathjax/")
};

if (window.standalone) window.MathJax.root = "https://ximera.osu.edu/node_modules/mathjax";

require('./../../node_modules/mathjax/unpacked/MathJax.js');

module.exports = window.MathJax;

},{"./../../node_modules/mathjax/unpacked/MathJax.js":"/usr/var/server.base/node_modules/mathjax/unpacked/MathJax.js"}],"/usr/var/server/public/javascripts/multiple-choice.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax.js');
var database = require('./database');
var TinCan = require('./tincan');
var Javascript = require('./javascript');

var buttonTemplate = _.template('<button class="text-left btn btn-secondary <%= correct %>" id="<%= id %>"></button>');

var answerHtml = '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Correct answer!" style="display: none">' + '<i class="fa fa-check"></i>&nbsp;Correct' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Incorrect.  Try again!" style="display: none">' + '<i class="fa fa-times"></i>&nbsp;Try again' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; ">' + '<button class="btn btn-primary btn-ximera-submit" data-toggle="tooltip" data-placement="top" title="Click to check your answer.">' + '<i class="fa fa-question"></i>&nbsp;Check work' + '</button>' + '</div>';

var ungradedAnswerHtml = '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Thank you for your submission" style="display: none">' + '<i class="fa fa-envelope"></i>&nbsp;Submitted' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Submit again!" style="display: none">' + '<i class="fa fa-times"></i>&nbsp;Try again' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; ">' + '<button class="btn btn-primary btn-ximera-submit" data-toggle="tooltip" data-placement="top" title="Click to submit your answer.">' + '<i class="fa fa-envelope-open"></i>&nbsp;Submit your work' + '</button>' + '</div>';

var answerHtml_nl = '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Juiste antwoord!" style="display: none">' + '<i class="fa fa-check"></i>&nbsp;Correct' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Fout. Probeer opnieuw!" style="display: none">' + '<i class="fa fa-times"></i>&nbsp;Probeer opnieuw' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; ">' + '<button class="btn btn-primary btn-ximera-submit btn-ximera-check" data-toggle="tooltip" data-placement="top" title="Klik om je antwoord te controleren.">' + '<i class="fa fa-question"></i><span class="show-check-text">&nbsp;Controleer</span>' + '</button>' + '</div>';

var ungradedAnswerHtml_nl = '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Bedankt voor je inzending" style="display: none">' + '<i class="fa fa-envelope"></i>&nbsp;Verzonden' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Verzend opnieuw!" style="display: none">' + '<i class="fa fa-times"></i>&nbsp;Probeer opnieuw' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; ">' + '<button class="btn btn-primary btn-ximera-submit" data-toggle="tooltip" data-placement="top" title="Klik om je antwoord te verzenden.">' + '<i class="fa fa-envelope-open"></i>&nbsp;Verzend' + '</button>' + '</div>';

function assignGlobalVariable(multipleChoice, choice) {
	if (multipleChoice.attr('data-id')) {
		if ($(choice).attr('data-value')) {
			if (window[multipleChoice.attr('data-id')] != $(choice).attr('data-value')) {
				window[multipleChoice.attr('data-id')] = $(choice).attr('data-value');
				Javascript.reevaluate(multipleChoice);
			}
		}
	}
}

var createMultipleChoice = function createMultipleChoice() {
	var multipleChoice = $(this);

	multipleChoice.wrapInner('<div class="ximera-horizontal"><div class="btn-group-vertical" role="group" data-toggle="buttons" style="padding-right: 1em;"></div></div>');

	var isUngraded = multipleChoice.closest(".ungraded").length > 0;

	var replacement;
	var lang = (navigator.language || 'en').slice(0, 2);

	if (lang === "nl") {
		if (isUngraded) replacement = $(ungradedAnswerHtml_nl);else replacement = $(answerHtml_nl);
	} else {
		if (isUngraded) replacement = $(ungradedAnswerHtml_nl);else replacement = $(answerHtml);
	}

	$('.ximera-horizontal', multipleChoice).append(replacement);

	multipleChoice.find(".choice").each(function () {
		var correct = '';
		if ($(this).hasClass("correct")) correct = "correct";

		if (isUngraded) {
			$(this).addClass("correct");
			correct = "correct";
		}

		var identifier = $(this).attr('id');
		$(this).removeAttr('id');

		var value = $(this).attr('data-value');
		var label = $(this);

		label.wrap(buttonTemplate({ id: identifier, correct: correct }));
		label.prepend('<input type="radio"></input>');

		if (value) {
			label.closest('button').attr('data-value', value);
		}
	});

	multipleChoice.trigger('ximera:answer-needed');

	// Display statistics for this problem
	multipleChoice.on('ximera:statistics:answers', function (event, answers) {
		var total = Object.keys(answers).map(function (x) {
			return answers[x];
		}).reduce(function (a, b) {
			return a + b;
		});

		Object.keys(answers).forEach(function (choice) {
			var fraction = answers[choice] * 100.0 / total;
			var element = multipleChoice.find('#' + choice);
			element.css('background', 'linear-gradient(90deg, rgba(0,0,255,0.1) ' + fraction + '%, rgba(0,0,0,0) ' + fraction + '%)');

			element.attr('data-toggle', 'tooltip');
			element.attr('title', answers[choice].toString() + ' of ' + total.toString() + ' learners chose this response.');
			$(element).tooltip();
		});
	});

	multipleChoice.persistentData(function (event) {
		multipleChoice.find('button').removeClass('active');
		multipleChoice.find('#' + multipleChoice.persistentData('chosen')).find('input').attr('aria-checked', false);

		if (multipleChoice.persistentData('chosen')) {
			multipleChoice.find('#' + multipleChoice.persistentData('chosen')).addClass('active');
			multipleChoice.find('#' + multipleChoice.persistentData('chosen')).find('input').attr('aria-checked', true);
			multipleChoice.find('.btn-group button').removeClass('disabled');
			multipleChoice.find('.btn-group .btn-ximera-submit').addClass('pulsate');

			var choice = multipleChoice.find('#' + multipleChoice.persistentData('chosen'));
			assignGlobalVariable(multipleChoice, choice);
		} else {
			multipleChoice.find('.btn-group button').addClass('disabled');
			multipleChoice.find('.btn-group .btn-ximera-submit').removeClass('pulsate');
		}

		if (multipleChoice.persistentData('correct')) {
			multipleChoice.find('.btn-group button').hide();
			multipleChoice.find('.btn-group .btn-ximera-correct').show();

			multipleChoice.find('button').not('.correct').addClass('disabled');
			multipleChoice.find('button .correct').removeClass('disabled');
		} else {
			multipleChoice.find('button').removeClass('disabled');

			multipleChoice.find('button').filter(function () {
				var wrongAnswers = multipleChoice.persistentData('wrong');

				return wrongAnswers && wrongAnswers[$(this).attr('id')];
			}).addClass('disabled');

			multipleChoice.find('.btn-group button').hide();

			if (multipleChoice.persistentData('checked') === multipleChoice.persistentData('chosen') && multipleChoice.persistentData('chosen') !== undefined) multipleChoice.find('.btn-group .btn-ximera-incorrect').show();else {
				multipleChoice.find('.btn-group .btn-ximera-submit').show();
				multipleChoice.find('.btn-group .btn-ximera-submit').show();
			}
		}

		multipleChoice.find('.btn-ximera-submit').prop('disabled', !multipleChoice.find('button').hasClass('active'));
		multipleChoice.find('.btn-ximera-incorrect').prop('disabled', !multipleChoice.find('button').hasClass('active'));
	});

	var checkAnswer = function checkAnswer() {
		if (multipleChoice.persistentData('chosen')) {
			multipleChoice.persistentData('checked', multipleChoice.persistentData('chosen'));

			multipleChoice.persistentData('correct', multipleChoice.find('#' + multipleChoice.persistentData('chosen')).hasClass('correct'));

			multipleChoice.trigger('ximera:attempt');

			if (multipleChoice.persistentData('correct')) {
				multipleChoice.trigger('ximera:correct');
			} else {
				var wrongAnswers = multipleChoice.persistentData('wrong');

				if (!wrongAnswers) wrongAnswers = {};

				wrongAnswers[multipleChoice.persistentData('chosen')] = true;
				multipleChoice.persistentData('wrong', wrongAnswers);
			}

			TinCan.answer(multipleChoice, { response: multipleChoice.persistentData('chosen'),
				success: multipleChoice.persistentData('correct') });
		}
	};

	$(this).find(".btn-ximera-submit").click(checkAnswer);
	$(this).find(".btn-ximera-incorrect").click(checkAnswer);

	$(this).find("button").each(function () {
		var id = $(this).attr('id');
		$(this).click(function () {
			if ($(this).hasClass('disabled')) {
				return false;
			}
			multipleChoice.persistentData('chosen', id);
			assignGlobalVariable(multipleChoice, $(this));
		});

		$(this).find("input").each(function () {
			$(this).change(function () {
				if ($(this).prop('checked')) {
					multipleChoice.persistentData('chosen', id);
					assignGlobalVariable(multipleChoice, $(this));
				}
			});
		});
	});
};

$.fn.extend({
	multipleChoice: function multipleChoice() {
		return this.each(createMultipleChoice);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","./javascript":"/usr/var/server/public/javascripts/javascript.js","./mathjax.js":"/usr/var/server/public/javascripts/mathjax.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/pencil.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');

$(function () {
			// Only activities get the pencil
			if ($('main.activity').length == 0) return;

			var pencilDiv;
			if ($("#pencil").length > 0) {
						pencilDiv = $("#pencil").first();
			} else {
						pencilDiv = $('<svg id="pencil"></svg>');
						$('div.container-fluid').append(pencilDiv);
			}

			var drawn = {};
			var maxCounter = 0;

			pencilDiv.fetchData(function () {
						pencilDiv.persistentData(function (event) {
									// When erase, let's actually clear things
									if (Object.keys(event.data).length == 0) {
												drawn = {};
												pencilDiv.empty();
									}

									Object.keys(event.data).forEach(function (key) {
												if (parseInt(key) > maxCounter) maxCounter = parseInt(key);

												if (drawn[key] !== true) {
															var stroke = event.data[key];
															drawn[key] = true;
															drawLine(stroke.x1, stroke.y1, stroke.x2, stroke.y2);
												}
									});
						});
			});

			var parent = $('div.container-fluid');

			pencilDiv.css('position', 'absolute');
			pencilDiv.css('top', '0');
			pencilDiv.css('left', '0');
			pencilDiv.css('width', '100%');
			pencilDiv.css('height', '100%');
			pencilDiv.css('overflow', 'visible');
			pencilDiv.css('z-index', '1029');
			pencilDiv.css('pointer-events', 'none');

			var drawing = false;
			var lastX = undefined;
			var lastY = undefined;

			function drawLine(ax, ay, bx, by) {
						var newLine = document.createElementNS('http://www.w3.org/2000/svg', 'line');
						newLine.setAttribute('id', 'line2');
						newLine.setAttribute('x1', ax);
						newLine.setAttribute('y1', ay);
						newLine.setAttribute('x2', bx);
						newLine.setAttribute('y2', by);
						newLine.setAttribute('stroke', 'black');
						$("#pencil").append(newLine);
			}

			parent.on("touchstart", function (e) {
						if (e.touches[0].touchType !== "stylus") return;

						var touch = e.touches[0];
						drawing = true;

						lastX = touch.pageX - parent.offset().left;
						lastY = touch.pageY - parent.offset().top;

						e.preventDefault();
			});

			parent.on("touchend", function (e) {
						if (drawing == false) return;

						drawing = false;
						e.preventDefault();
			});

			parent.on("touchmove", function (e) {
						if (drawing == false) return;

						var touch = e.touches[0];

						var bx = touch.pageX - parent.offset().left;
						var by = touch.pageY - parent.offset().top;
						var ax = lastX;
						var ay = lastY;
						drawLine(ax, ay, bx, by);

						maxCounter = maxCounter + 1;
						var uuid = maxCounter.toString();
						drawn[uuid] = true;
						pencilDiv.persistentData(uuid, { 'x1': ax, 'y1': ay, 'x2': bx, 'y2': by });

						lastX = touch.pageX - parent.offset().left;
						lastY = touch.pageY - parent.offset().top;

						e.preventDefault();
			});
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/popover.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax');
var Expression = require('math-expressions');

exports.bindPopover = function (element) {
			var update = function update() {
						var text = $(element).find("input").val();
						exports.displayPopover(text, element);
			};

			$(element).popover({
						animation: false,
						placement: 'right',
						container: 'body',
						//animation: false,
						trigger: 'manual',
						content: function content() {
									return '';
						} });

			var inputBox = $(element).find("input.form-control");

			inputBox.on('input', update);

			inputBox.focus(update);

			inputBox.blur(function () {
						$(element).popover('hide');
			});

			inputBox.focusout(function () {
						$(element).popover('hide');
			});
};

// Binds latex popover occur next to element when watched variable changes.
exports.displayPopover = function (answer, element) {
			if (answer.trim().length == 0) {
						$(element).popover('hide');
						return;
			}

			if (answer.trim().length == 0) {
						$(element).popover('hide');
						return;
			}

			try {
						var format = $(element).attr('data-format');

						if (format == 'string') {
									return;
						}

						if (format == 'integer' && answer.trim().match(/[^0-9-]/)) {
									throw 'Verwacht een geheel getal.';
						}

						// Don't need to give a preview for numeric answers
						if (answer.trim().match(/^-?[0-9\.]+$/)) {
									$(element).popover('hide');
									return;
						}

						var latex = Expression.fromText(answer).tex();

						$(element).data('bs.popover').config.title = '';
						$(element).data('bs.popover').config.content = '\\(' + latex + '\\)';
						$(element).popover('show');
						MathJax.Hub.Queue(["Typeset", MathJax.Hub, $(element).data('bs.popover').tip[0]]);
			}
			// display errors as popovers, too
			catch (err) {
						$(element).data('bs.popover').config.title = 'Error';
						$(element).data('bs.popover').config.content = err;
						$(element).popover('show');
			}
};

},{"./mathjax":"/usr/var/server/public/javascripts/mathjax.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","math-expressions":"/usr/var/server.base/node_modules/math-expressions/build/math-expressions_umd.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/problem.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var TinCan = require('./tincan');
var database = require('./database');

var hintCountdown = 10;

$(function () {
	var timer = window.setInterval(function () {
		if (hintCountdown > 0) {
			hintCountdown = hintCountdown - 1;
			$('.seconds-remaining').text(hintCountdown.toString());
		} else {
			window.clearInterval(timer);
			$('.countdown').hide();
			$('.hint-unlocked').show();
		}
	}, 1000);
});

var hintButtonHtml = '<button class="btn btn-info btn-reveal-hint" type="button" data-toggle="tooltip" data-placement="top" title="Toon de volgende hint."><i class="fa fa-life-ring"></i>&nbsp; <span class="hint-text">Toon Hint</span><span class="counter" style="display: none;"> (<span class="count">1</span> of <span class="total">1</span>)</span><span class="hint-locked" style="display: none;"><span class="countdown"> (<i class="fa fa-lock"></i> <span class="seconds-remaining">1</span>)</span><span class="hint-unlocked" style="display: none;"> <i class="fa fa-unlock"></i></span></span></button>';

var createProblem = function createProblem() {
	var problem = $(this);

	if (!problem.hasClass("hint")) {
		problem.persistentData(function (event) {
			if (problem.persistentData('available') && !problem.persistentData('experienced')) {
				TinCan.experience(problem);
				problem.persistentData('experienced', true);
			}

			if (!problem.persistentData('available')) {
				if (problem.parents(".problem-environment").length == 0) problem.persistentData('available', true);
			}

			// You'd think you might want to call MathJax Rerender
			// to update things when you're messing around with
			// visibility, but NO!  MathJax seems to be removing
			// things from the DOM (like our problem divs) and
			// replacing them with identical copies---except that
			// our event handlers weren't attached to the copies.
			// So instead of hiding and showing things, we have to
			// do this CSS visibility thing, which lets MathJax
			// size everything appropriately even while it is
			// hidden,

			var visible = false;

			if (problem.persistentData('available')) visible = true;

			var parent = problem.parents(".problem-environment").first();
			if (!$(parent).attr('data-blocking')) visible = true;

			if (visible) {
				problem.css({ visibility: 'visible', position: 'relative' });
				problem.fadeTo('slow', 1);
			} else {
				problem.css({ visibility: 'hidden', position: 'absolute' });
				problem.css({ opacity: 0 });
			}

			return false;
		});
	}

	// Elements that will block problem completion until answered
	// should emit a "ximera:answer-needed" so we record this
	problem.on('ximera:answer-needed', function (event) {
		var answersNeeded = [];
		if (problem.data('answers-needed')) answersNeeded = problem.data('answers-needed');

		answersNeeded.unshift(event.target);

		// Sometimes I end up recreating answers, and when those
		// answers are recreated they again emit
		// ximera:answer-needed, but without the following lines,
		// I would then have extraneous entries in answersNeeded
		// which would be, worse, unanswerable since the are no
		// longer in the DOM.

		var inDom = function inDom(e) {
			return $.contains(document.documentElement, e);
		};
		answersNeeded = _.filter(answersNeeded, inDom);

		// mathjax also sticks extra stuff under a "semantics" tag now
		var notSemantic = function notSemantic(e) {
			return $(e).closest('semantics').length == 0;
		};
		answersNeeded = _.filter(answersNeeded, notSemantic);

		problem.data('answers-needed', answersNeeded);

		// 'blocking' is used for progress calculations, which must
		// survive the erase work button
		problem.attr('data-blocking', true);

		return false;
	});

	var hintButton = $(hintButtonHtml);

	problem.on('ximera:register-hint', function (event) {
		// Hints /are/ problems, but they shouldn't provide their own hints
		if ($(event.target).is(problem)) return true;

		var hints = [];

		if (problem.data('hints')) hints = problem.data('hints');

		hints.push(event.target);
		problem.data('hints', hints);

		if (hints.length === 1) {
			var firstHint = _.first(_.filter(hints, function (element) {
				return !$(element).persistentData('available');
			}));
			hintButton.click(function (event) {
				if (hintCountdown > 0) {
					hintButton.find(".hint-locked").show();
					return;
				}

				hintButton.find(".counter").show();

				var revealed = _.filter(hints, function (element) {
					return $(element).persistentData('available');
				});
				hintButton.find(".count").html(revealed.length + 1);
				var nextHint = _.first(_.filter(hints, function (element) {
					return !$(element).persistentData('available');
				}));
				$(nextHint).persistentData('available', true);
				$(nextHint).persistentData('collapsed', false);

				nextHint = _.first(_.filter(hints, function (element) {
					return !$(element).persistentData('available');
				}));
				if (!nextHint) {
					problem.persistentData('uncovered-all-hints', true);
				} else if ($(nextHint).hasClass('feedback')) {
					hintButton.find('.hint-text').text('Toon Uitwerking');
					hintButton.addClass('oplossing'); /* to overwrite text in css (English) ... */
				}
			});

			if ($(firstHint).hasClass('feedback')) {
				hintButton.find('.hint-text').text('Toon Uitwerking');
				hintButton.addClass('oplossing'); /* to overwrite text in css (English) ... */
			}

			problem.persistentData(function () {
				if (problem.persistentData('uncovered-all-hints')) $(hintButton).fadeOut();else hintButton.show();
			});

			problem.prepend(hintButton);
		} else {
			hintButton.find(".total").html(hints.length);
		}

		var revealed = _.filter(hints, function (element) {
			return $(element).persistentData('available');
		});

		return false;
	});

	// When an answer is correct, it should emit "ximera:correct"
	// after setting its 'correct' data to true.
	problem.on('ximera:correct', function (event) {
		if (_.every(problem.data('answers-needed'), function (answer) {
			return $(answer).persistentData('correct');
		})) {
			if (!problem.persistentData('complete')) TinCan.completeProblem(problem);

			problem.persistentData('complete', true);

			// When a problem is complete, we announce it to the world
			problem.trigger('ximera:complete');

			// Uncover the next level of problem-environments
			problem.find('.problem-environment').not('.hint').each(function () {
				if ($(this).parent().closest('.problem-environment').is(problem)) {
					$(this).persistentData('available', true);
				}
			});
		}

		return false;
	});
};

$.fn.extend({
	problemEnvironment: function problemEnvironment() {
		return this.each(createProblem);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/profile.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var ui = require('jquery-ui');
var moment = require('moment');
var bootstrapDateTimePicker = require("eonasdan-bootstrap-datetimepicker");

// jsfiddle which updates all relative dates defined by <time class='relative-date'>
var updateAllRelativeDates = function updateAllRelativeDates() {
			$('time').each(function (i, e) {
						if ($(e).attr("class") == 'absolute-date') {
									var time = moment(new Date($(e).attr('datetime')));
									$(e).html('<span>' + time.format('MMMM D, YYYY') + '</span>');
						}

						if ($(e).attr("class") == 'relative-date') {

									// Initialise momentjs
									var now = moment();

									moment.locale('en', {
												calendar: {
															lastDay: '[Yesterday at] LT',
															sameDay: '[Today at] LT',
															nextDay: '[Tomorrow at] LT',
															lastWeek: '[Last] dddd [at] LT',
															nextWeek: 'dddd [at] LT',
															sameElse: 'D MMM YYYY [at] LT'
												}
									});

									// Grab the datetime for the element and compare to now                    
									var time = moment(new Date($(e).attr('datetime')));
									var diff = now.diff(time, 'days');

									// If less than one day ago/away use relative, else use calendar display
									if (diff <= 1 && diff >= -1) {
												$(e).html('<span>' + time.from(now) + '</span>');

												// Add tooltip with missing information for relative dates
												$(e).tooltip({
															'show': true,
															'placement': 'right',
															'title': time.calendar()
												});
									} else {
												$(e).html('<span>' + time.calendar() + '</span>');
									}
						}
			});
};

$(document).ready(function () {
			/* BADBAD: probably should bring back the datepicker someday
   $("#datepicker").datetimepicker({
   format: "MMMM D, YYYY",
   icons: {
    time: "fa fa-clock-o",
    date: "fa fa-calendar",		
    up: "fa fa-arrow-up",
    down: "fa fa-arrow-down",
    previous: "fa fa-arrow-left",
    next: "fa fa-arrow-right",		
   }
   });
    */

			var userId = $('main.container').attr('data-user-id');

			if (!userId) return;

			// Update all dates
			updateAllRelativeDates();

			// Update dates every minute
			setInterval(updateAllRelativeDates, 60000);

			var updateLinkedAccountButtons = function updateLinkedAccountButtons() {
						$('.linked-account[connected]').switchClass('btn-default', 'btn-danger');
						$('.linked-account:not([connected])').switchClass('btn-danger', 'btn-default');

						$('.linked-account[connected] .connect').hide();
						$('.linked-account[connected] .disconnect').show();

						$('.linked-account:not([connected]) .connect').show();
						$('.linked-account:not([connected]) .disconnect').hide();
			};

			updateLinkedAccountButtons();

			$('#create-secret').click(function () {
						var button = this;
						console.log('requesting secret');

						$.ajax({
									url: window.toValidPath('/users/' + $(button).attr("userId") + '/secret'),
									type: 'PUT',
									success: function success(result) {
												$('#api-key').fadeOut(function () {
															$(this).text(result.apiKey);
												}).fadeIn();
												$('#api-secret').fadeOut(function () {
															$(this).text(result.apiSecret);
												}).fadeIn();
									}
						});
			});

			$('.select-all').click(function () {
						var range, selection;

						if (window.getSelection && document.createRange) {
									selection = window.getSelection();
									range = document.createRange();
									range.selectNodeContents(this);
									selection.removeAllRanges();
									selection.addRange(range);
						} else if (document.selection && document.body.createTextRange) {
									range = document.body.createTextRange();
									range.moveToElementText(this);
									range.select();
						}
			});

			$('.linked-account').click(function () {
						var button = this;

						if ($(button).attr("connected")) {
									$.ajax({
												url: window.toValidPath('/users/' + $(button).attr("userId") + '/' + $(button).attr("id")),
												type: 'DELETE',
												success: function success(result) {
															console.log("linked-account click result = ", result);
															$(button).removeAttr("connected");
															updateLinkedAccountButtons();
												}
									});
						} else {
									window.location.href = "/auth/" + $(this).attr("id");
						}
			});

			////////////////////////////////////////////////////////////////
			// User interface to disconnect LTI bridges

			$('.delete-bridge').click(function () {
						var button = this;

						// Connect the modal to the button which opened it
						$('#confirm-delete').on('show.bs.modal', function (e) {
									$(this).find('#disconnect-button').attr('data-userId', $(e.relatedTarget).attr('data-userId'));
									$(this).find('#disconnect-button').attr('data-bridge', $(e.relatedTarget).attr('data-bridge'));
						});
			});

			$('#confirm-delete').on('click', '#disconnect-button', function (e) {
						var button = $(this);

						// Close the modal
						$('#confirm-delete').modal('hide');

						// Display spinner
						$('button .fa', '#bridge-' + button.attr("data-bridge")).hide();
						$('button .fa-spinner', '#bridge-' + button.attr("data-bridge")).show();

						$.ajax({
									url: window.toValidPath('/users/' + button.attr("data-userId") + '/bridges/' + button.attr("data-bridge")),
									type: 'DELETE',
									success: function success(result) {
												$('#bridge-' + button.attr("data-bridge")).fadeOut(500, function () {
															$(this).remove();
												});
									}
						});
			});
});

},{"eonasdan-bootstrap-datetimepicker":"/usr/var/server.base/node_modules/eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","jquery-ui":"/usr/var/server.base/node_modules/jquery-ui/ui/widget.js","moment":"/usr/var/server.base/node_modules/moment/moment.js"}],"/usr/var/server/public/javascripts/progress-bar.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var gradebook = require('./gradebook');

exports.progress = function (n, d) {
   var percent = Math.round(n * 100 / d);

   $('.navbar-progress-bar').show();

   var progressBar = $('div.progress.completion-meter div.progress-bar');

   progressBar.attr('aria-valuenow', n);
   progressBar.attr('aria-valuemax', d);
   progressBar.css('width', percent.toString() + '%');

   // BADBAD: if'd be nicer if I only displayed the string when I knew it wouldn't overflow
   if (percent > 25) $('span', progressBar).text(n.toString() + ' of ' + d.toString());else $('span', progressBar).text('');

   progressBar.toggleClass('progress-bar-striped', n == d);
};

exports.progressProportion = function (proportion) {
   var percent = Math.round(proportion * 10000) / 100;

   $('.navbar-progress-bar').show();

   // Progress bar on top of screen
   var progressBar = $('div.progress.completion-meter div.progress-bar');

   progressBar.attr('aria-valuenow', Math.round(percent));
   progressBar.attr('aria-valuemax', 100);
   progressBar.css('width', percent.toString() + '%');
   $('span', progressBar).text('');

   progressBar.toggleClass('progress-bar-striped', proportion > 0.9999);

   // Progress bar in xourse
   var otherProgressBar = $('.activity-card.active div.progress-bar');

   otherProgressBar.attr('aria-valuenow', Math.round(percent));
   otherProgressBar.attr('aria-valuemax', 100);
   otherProgressBar.css('width', percent.toString() + '%');
   $('span', otherProgressBar).text('');
   otherProgressBar.toggleClass('progress-bar-striped', proportion > 0.9999);

   // the activity card get attribute 'max-completion' set
   var activityCard = $('.activity-card.active');
   activityCard.attr('data-max-completion', proportion);
};

var calculateProgress = function calculateProgress(problem, depth) {
   if (depth === undefined) depth = 0;

   // Find immediate problem-environment children which aren't hints or feedback
   var children = $(problem).find('.problem-environment').not('.hint').not('.feedback').filter(function () {
      var parents = $(this).parent('.problem-environment');
      return parents.length == 0 || parents.first().is(problem);
   });

   // Non-root nodes also contribute to their value via their 'completion' flag
   var nodeValue = 0;
   var nodeMaxValue = 0;

   if (depth != 0) {
      if ($(problem).attr('data-blocking')) {
         if ($(problem).persistentData('complete')) {
            nodeValue = 1;
            nodeMaxValue = 1;
         } else {
            var answersNeeded = 0;
            var answersCorrect = 0;
            $(problem).data('answers-needed').forEach(function (answer) {
               if ($(answer).persistentData('correct')) answersCorrect++;
               answersNeeded++;
            });

            if (answersNeeded == 0) {
               nodeValue = 1;
               nodeMaxValue = 1;
            } else {
               nodeValue = answersCorrect / answersNeeded;
               nodeMaxValue = 1;
            }
         }
      }
   }

   // Each node's value is the average of its children's values and its own completion flag
   var total = 0;
   var countedChildren = 0;
   children.each(function () {
      var calculatedProgress = calculateProgress(this, depth + 1);
      if (calculatedProgress !== undefined) {
         total = total + calculatedProgress;
         countedChildren++;
      }
   });

   if (total === 0 && countedChildren === 0 && !$(problem).attr('data-blocking')) /* Don't count empty things without data-blocking (e.g a plain definition block) */
      return undefined;

   return (total + nodeValue) / (countedChildren + nodeMaxValue);
};

var activityToMonitor = undefined;

var update = _.debounce(function () {
   var value = calculateProgress(activityToMonitor);

   // Top level videos are also counted
   var videoCount = 0;
   var totalViewed = 0.0;
   $('.youtube-player').each(function () {
      videoCount = videoCount + 1;
      var fraction = $(this).persistentData('fractionViewed');
      if (fraction) {
         totalViewed = totalViewed + fraction;
      }
   });

   // Activities that have NO problems will have total progress
   // NaN because of the 0 denominator; let's give credit to
   // students who simply look at such activities
   if (isNaN(value)) {
      if (videoCount > 0) {
         value = totalViewed / videoCount;
      } else {
         value = 1;
      }
   } else {
      if (videoCount > 0) {
         value = (value + totalViewed) / (1 + videoCount);
      }
   }

   exports.progressProportion(value);

   // Store the progress as the "score" in the database
   $(activityToMonitor).persistentData('score', value);

   // and in a separate "completion" table
   $(activityToMonitor).recordCompletion(value);

   // total the points in the course (if there is one)
   gradebook.update();

   if (value == 1) {
      $('#next-activity .page-link').addClass('pulsate');
   }
}, 217);

var MathJax = require('./mathjax');

exports.monitorActivity = function (activity) {
   activityToMonitor = activity;

   // BADBAD: Is this really always called after the math is done
   // being processed?
   MathJax.Hub.Register.StartupHook("End", function () {
      update();

      $('.problem-environment', activity).each(function () {
         $(this).persistentData(update);
      });

      $('.youtube-player', activity).each(function () {
         $(this).persistentData(update);
      });
   });
};

},{"./gradebook":"/usr/var/server/public/javascripts/gradebook.js","./mathjax":"/usr/var/server/public/javascripts/mathjax.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/question.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
//
// Number questions within there parent environment (presumable exercise or example ...)
// 
var addNumbers = function addNumbers(index) {
    var q = $(this);
    var nr = q.parent().children('[class~="question"]').index(q);
    //	console.log("sibling questions of " + q.attr("id"))
    //	console.log(q.parent().children('[class~="question"]'))
    q.attr("numbered", nr + 1);
    // or without jQuery ...?
    //	q.setAttribute("numbered",[].slice.call(q.parentNode.getElementsByClassName("question")).indexOf(q)+1)
};

$.fn.extend({
    numberQuestion: function numberQuestion() {
        return this.each(addNumbers);
    }
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/references.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var MathJax = require('./mathjax');

// var ddebug = window.debug || require('debug');
var ddebug = require('debug');
var debug = ddebug('references');

debug("references.js loaded");

function zoomTo(id) {
	var extraOffset = 0;
	var target = $(document.getElementById(id));
	if (target.length > 0) {
		console.log('Target found:', target);
	} else {
		console.log('No element found with id:', id);
	}

	// var target = document.getElementById(id);
	// if (!target) {
	// 	debug("zoomTo: no element with id " + id);
	// 	return;
	// }

	var previousElement = target.prev();

	if (previousElement && previousElement.prop("tagName") && previousElement.prop("tagName").toLowerCase() == "a") {
		debug('zoomTo: previous element is an anchor: skip that');
		previousElement = previousElement.prev();
	}

	// debug("zoomTo: "+ id + " previousElement is " + previousElement.prop("tagName").toLowerCase() + " with id " + previousElement.attr('id') + " and class " + previousElement.attr('class'));

	if (previousElement.hasClass('caption')) {
		target = previousElement;
		var previousElement = target.prev();
		if (previousElement.prop("tagName").toLowerCase() == "img" && previousElement.parent().prop("tagName").toLowerCase() == "div") {
			target = previousElement.parent();
		}
	} else if (previousElement.hasClass('mathjax-env')) {
		debug("zoomTo: previousElement is a mathjax-env, so zooming to that");
		extraOffset = 200;
		target = previousElement;
	} else {
		debug("zoomTo closest div/dl/dd");
		target = target.closest('div, dl, dd');
	}

	debug("zoomTo: target is now " + target.prop("tagName").toLowerCase() + " with id " + target.attr('id') + " and class " + target.attr('class'));

	// Make the div flash
	target.addClass("flash");
	window.setTimeout(function () {
		target.removeClass("flash");
	}, 5000);

	var el = target;
	var elOffset = el.offset().top;
	debug("elOffset = " + elOffset);
	var elHeight = el.outerHeight();
	var windowHeight = $(window).height();
	debug("windowHeight = " + windowHeight);
	var offset;

	if (elHeight < windowHeight) {
		offset = elOffset - (windowHeight / 2 - elHeight / 2);
	} else {
		offset = elOffset;
	}

	debug("Scroll to top + " + offset + " + " + extraOffset);

	// offset = offset + extraOffset;


	// $('.main-activity').animate({
	// 	scrollTop: $('.main-activity').scrollTop() + offset 
	// }, 1000);

	window.scrollTo({ top: $('.main-activity').scrollTop() + offset, behavior: 'smooth' });
}

var maximumNumber = 1;
var problemNumber = 1;

var createLabel = function createLabel() {
	var label = $(this);
	var href = label.attr('id');
	var referenceText = $('[href="#' + href + '"').first().text();

	function addLabel(reference) {
		if (!(href in MathJax.Extension["TeX/AMSmath"].labels)) {
			var tag = undefined;

			// debug("href (label.id) "+ href + ": " + "#" + referenceText)
			/*if (href !== "#" + referenceText){
   	tag = referenceText
   }
   else{*/
			var enumerated = label.closest('dd.enumerate-enumitem');
			if (enumerated.length > 0) {
				tag = $.trim(enumerated.prev('dt').text());
				debug("Adding tag " + tag + " for ref '" + href + "' from enumerated");
			} else {
				var previousElement = label.prev();
				if (previousElement.hasClass("caption")) {
					tag = referenceText;
					debug("Adding tag " + tag + " for ref '" + href + "' from caption referenceText (ie, first child)");
				} else {
					var problem = label.closest('.problem-environment');
					if (problem.is('[numbered]')) {
						tag = problem.attr('numbered');
						debug("Adding tag " + tag + " for ref '" + href + "' from numbered problem");
					} else if (problem.hasClass('problem')) {
						tag = problemNumber.toString();
						problemNumber = problemNumber + 1;
						debug("Adding tag " + tag + " for ref '" + href + "' from next problem");
					} else {
						tag = maximumNumber.toString();
						debug("Adding tag " + tag + " for ref '" + href + "' from next other");
						maximumNumber = maximumNumber + 1;
					}
				}
			}
			//}
			MathJax.Extension["TeX/AMSmath"].labels[href] = { id: href, tag: tag };
			// debug("Added tag '" + tag + "' for ref '" + href + "'")
		}
	}

	MathJax.Hub.Queue([addLabel]);
};

var createReference = function createReference() {
	var reference = $(this);

	console.log("DEBUG: createReference " + reference.text()); // debug ...

	function checkLabel(reference) {
		var href = reference.attr('href');
		console.log("DEBUG: checklabel " + reference.text()); // debug ...
		href = href.replace(/^#/, '');
		if (MathJax.Extension["TeX/AMSmath"].labels[href]) {
			var label = MathJax.Extension["TeX/AMSmath"].labels[href];
			if (reference.hasClass('reference-keeptext')) {
				console.log(href + " " + "#" + reference.text() + " not replacing"); // debug ...
			} else {
				console.log(href + " " + "#" + reference.text() + " replacing by " + label.tag); //debug ...
				reference.text(label.tag);
			}
			reference.attr('href', '#' + label.id);
			reference.addClass('mathjax-link');
		}
	}

	MathJax.Hub.Queue([checkLabel, reference]);

	reference.click(function (event) {

		console.log("DEBUG: click " + reference.text()); // debug ...


		if (reference.hasClass('broken')) return false;

		var href = reference.attr('href');

		href = href.replace(/^#/, '');

		if (reference.hasClass('mathjax-link')) {
			debug("zoomTo (mathjax-link) " + href);
			event.preventDefault(); // prevents the browser from scrolling
			zoomTo(href);
			debug("zoomed to " + href);
			return;
		}

		var repository = $("#theActivity").attr('data-repository-name');

		if (!repository) {
			console.log("References must be on a page with #theActivity");
			return false;
		}

		$.ajax({
			url: window.toValidPath("/labels/" + repository + "/" + href)
		}).done(function (filename) {
			// BADBAD: test if I'm on the curent page
			if (filename == $("#theActivity").attr('data-path')) {
				zoomTo(href);
			} else {
				var xourse = "";
				if ($("#theActivity").attr('data-xourse-path')) xourse = "/" + $("#theActivity").attr('data-xourse-path');
				window.location.href = window.toValidPath("/" + repository + xourse + "/" + filename + "#" + href);
			}
		}).fail(function (xhr, status, err) {
			reference.prepend($('<i class="fa fa-unlink"></i><span>&nbsp;</span>'));
			reference.css('background-color', 'red'); // animate this?
			reference.css('color', 'white');
			reference.css('cursor', 'not-allowed');
			reference.addClass('broken');
		});

		return false;
	});

	reference.css('cursor', 'pointer');
};

$.fn.extend({
	reference: function reference() {
		return this.each(createReference);
	},

	texLabel: function texLabel() {
		return this.each(createLabel);
	}
});

var targetHash = window.location.hash;

// remove hash
if (window.location.hash) {
	if (history && history.pushState) {
		// Get rid of hash
		history.pushState("", document.title, window.location.pathname + window.location.search);
	}
}

MathJax.Hub.Queue(function () {
	var links = document.querySelectorAll('.MathJax a[href^="#mjx-eqn-"]');
	for (var i = 0; i < links.length; i++) {
		links[i].addEventListener('click', function (event) {
			event.preventDefault();

			var rawHref = this.getAttribute('href'); // e.g., "#mjx-eqn-xeq%3A2.3.8"
			var targetId = decodeURIComponent(rawHref.substring(1)); // remove '#' and decode

			console.log('Intercepted MathJax ref to: ' + targetId);

			var target = document.getElementById(targetId);
			if (target) {
				// target.scrollIntoView({ behavior: 'smooth', block: 'start' });
				console.log('Zooming to MathJax target: ' + targetId);
				zoomTo(targetId);
			} else {
				console.warn('Target not found: ' + targetId);
			}
		});
	}
});

exports.highlightTarget = function () {
	if (targetHash) {
		debug("Will highlight " + targetHash);
		window.setTimeout(function () {
			zoomTo(targetHash.replace(/^#/, ''));
		}, 1000);
	}
};

},{"./mathjax":"/usr/var/server/public/javascripts/mathjax.js","debug":"/usr/var/server.base/node_modules/debug/src/browser.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/rowclick.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');

// transforms any bootstrap table row that has data-href attribute set into a clickable element
exports.addClickableTableRows = function () {
    $('.table tr[data-href]').each(function () {
        $(this).css('cursor', 'pointer').hover(function () {
            $(this).addClass('active');
        }, function () {
            $(this).removeClass('active');
        }).click(function () {
            document.location = $(this).attr('data-href');
        });
    });
};

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/sagemath.js":[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax.js');
var database = require('./database');

$(function () {
			// If there are any sage cells on the page
			if ($(".sage").length > 0 || $(".sageOutput").length > 0) {
						// Creating a kernel incidentally processes sagecells
						exports.createKernel();
			}
});

var seeded = false;
var seedCallbacks = [];
var setSeed = function setSeed(callback) {
			if (seeded) {
						callback();
			} else {
						seedCallbacks.push(callback);
						getSeed();
			}
};

var seed = null;
var sendSeed = function sendSeed(newSeed) {
			if (seed == newSeed && seed !== null) return;

			seed = newSeed;

			if (newSeed !== undefined) {
						exports.sage("set_random_seed(" + newSeed + ")");
			} else {
						if ($('main.activity').length > 0) {
									var activityPath = $('main.activity').attr('data-path');
									var currfilebase = activityPath.split('/').slice(-1)[0];

									var code = 'jobname="' + currfilebase + '"' + "\n";
									code = code + "import hashlib\n";
									code = code + "set_random_seed(int(hashlib.sha256(jobname.encode('utf-8')).hexdigest(), 16))\n";
									exports.sage(code);
						}
			}
};

var reprocessMathjax = _.debounce(function () {
			MathJax.Hub.Queue(["Reprocess", MathJax.Hub]);
}, 250);

var getSeed = _.once(function () {
			var seedDiv;
			if ($("#seed").length > 0) {
						seedDiv = $("#seed").first();
			} else {
						seedDiv = $('<div id="seed" style="display: none;"></div>');
						$('main.activity').append(seedDiv);
			}

			seedDiv.fetchData(function () {
						seeded = true;

						var seed = seedDiv.persistentData('seed');
						sendSeed(seed);

						seedDiv.persistentData(function () {
									var newSeed = seedDiv.persistentData('seed');
									if (newSeed == seed) {
												return;
									}
									sendSeed(newSeed);

									executedSageSilents = false;
									executeSageSilents();

									reprocessMathjax();
						});

						seedCallbacks.forEach(function (callback) {
									callback();
						});
						seedCallbacks = [];
			});
});

var stopSpinning = _.debounce(function () {
			$("#show-me-another-button i").css('animation-play-state', 'paused');
}, 250);

MathJax.Hub.signal.Interest(function (message) {
			if (message[0] == "End Reprocess") {
						stopSpinning();
			}
			if (message[0] == "End Rerender") {
						stopSpinning();
			}
});

$(function () {
			$("#show-me-another-button").click(function () {
						$("i", this).addClass("fa-spin");
						$("#show-me-another-button i").css('animation-play-state', 'running');

						// A different seed algorithm would be better here, just so
						// students get different problems
						var oldSeed = $("#seed").persistentData('seed');

						seed = undefined;
						database.resetWork();

						if (oldSeed !== undefined) {
									$("#seed").persistentData('seed', oldSeed + 1);
						} else {
									$("#seed").persistentData('seed', 0);
						}
			});
});

var executedSageSilents = false;
var executeSageSilents = function executeSageSilents() {
			if (executedSageSilents == false) {
						executedSageSilents = true;
						// Execute any sagesilent blocks
						$('script[type="text/sagemath"]').each(function () {
									var code = $(this).text();
									// Remove any CDATA
									code = code.replace(/[\s\S]*#<!\[CDATA\[\s*\n((.|\n)*)\s*#\]\]>/m, "$1");

									// The snippet "rand" is enough to trigger the "Another..." button
									if (code.match('rand')) {
												$("#show-me-another-button").show();
									}

									exports.sage(code);
						});
			}
};

exports.createKernel = _.once(function () {
			return new Promise(function (resolve, reject) {
						// There's a race condition here: window.sagecell may not be
						// set quickly enough.  So we wait until window.sagecell is
						// set
						var walkback = 10;
						function sagecellReady() {
									if (_typeof(window.sagecell) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && _typeof(window.sagecell.kernels) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined))) {
												// Create a sagecell in order to trigger the creation of a kernel
												var arrayChangeHandler = {
															set: function set(target, property, value, receiver) {
																		if (property == 0) {
																					if (value != null) {
																								window.setTimeout(function () {
																											resolve(value);
																								}, 0);
																					}
																		}
																		target[property] = value;
																		return true;
															}
												};
												window.sagecell.kernels = new Proxy(window.sagecell.kernels, arrayChangeHandler);

												var d = document.createElement('div');
												window.sagecell.makeSagecell({ inputLocation: d, linked: true });
												// console.log(d);
												var observer = new MutationObserver(function (mutations, observer) {
															if (d.children && d.children[0] && d.children[0].children[1]) {
																		d.children[0].children[1].click();
																		observer.disconnect();
															}
												});
												observer.observe(d, { childList: true, subtree: true });
												// Make sage cells---but make them linked so there's just one kernel.
												window.sagecell.makeSagecell({ "inputLocation": ".sage", linked: true });
												window.sagecell.makeSagecell({ "inputLocation": ".sageOutput", "hide": ["editor", "evalButton"], "autoeval": true, linked: true });
									} else {
												walkback = walkback * 1.05;
												console.log("Walking back", walkback);
												window.setTimeout(sagecellReady, walkback);
									}
						}
						sagecellReady();
			});
});

exports.sage = function (code) {
			// Perversely, these are presented out of order -- and despite
			// that fact, the code from setSeed will actually be executed
			// first.
			executeSageSilents();
			return new Promise(function (resolve, reject) {
						setSeed(function () {

									var output = function output(msg) {
												if (msg.msg_type == "error") {
															reject(msg.content);
												}
												if (msg.msg_type == "execute_result") {
															resolve(msg.content.data["text/plain"]);
												}
									};

									var callbacks = { iopub: { "output": output } };

									exports.createKernel().then(function (kernel) {
												console.log("sage: ", code);

												kernel.execute(code, callbacks, {
															"silent": false,
															"user_expressions": { "_sagecell_files": "sys._sage_.new_files()" }
												});
									});
						});
			});
};

window.sage = function (code) {
			exports.sage(code).then(function (result) {
						console.log(result);
			}, function (err) {
						console.log("err=", err);
			});
};

},{"./database":"/usr/var/server/public/javascripts/database.js","./mathjax.js":"/usr/var/server/public/javascripts/mathjax.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/select-all.js":[function(require,module,exports){
'use strict';

// BADBAD: This code is unfortunately a minor tweak of multiple-choice.  The similar code should be shared somehow.

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax.js');
var database = require('./database');
var TinCan = require('./tincan');

var buttonTemplate = _.template('<button class="btn text-left btn-secondary <%= correct %>" id="<%= id %>"></button>');

var answerHtml = '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Correct answer!" style="display: none">' + '<i class="fa fa-check"></i>&nbsp;Correct' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Incorrect.  Try again!" style="display: none">' + '<i class="fa fa-times"></i>&nbsp;Try again' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; ">' + '<button class="btn btn-primary btn-ximera-submit" data-toggle="tooltip" data-placement="top" title="Click to check your answer.">' + '<i class="fa fa-question"></i>&nbsp;Check work' + '</button>' + '</div>';

var answerHtml_nl = '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Juiste answer!" style="display: none">' + '<i class="fa fa-check"></i>&nbsp;Correct' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; " aria-live="assertive">' + '<button class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Fout. Probeer opnieuw!" style="display: none">' + '<i class="fa fa-times"></i>&nbsp;Probeer opnieuw' + '</button></div>' + '<div class="btn-group" style="vertical-align: bottom; ">' + '<button class="btn btn-primary btn-ximera-submit btn-ximera-check" data-toggle="tooltip" data-placement="top" title="Klik om je antwoord na te kijken.">' + '<i class="fa fa-question"></i><span class="show-check-text">&nbsp;Controleer</span>' + '</button>' + '</div>';

var createSelectAll = function createSelectAll() {
	var selectAll = $(this);

	selectAll.wrapInner('<div class="ximera-horizontal"><div class="btn-group-vertical" role="group" data-toggle="buttons" style="padding-right: 1em;"></div></div>');

	var lang = (navigator.language || 'en').slice(0, 2);

	if (lang === "nl") {
		$('.ximera-horizontal', selectAll).append($(answerHtml_nl));
	} else {
		$('.ximera-horizontal', selectAll).append($(answerHtml));
	}

	selectAll.find(".choice").each(function () {
		var correct = '';
		if ($(this).hasClass("correct")) correct = "correct";

		var identifier = $(this).attr('id');
		var label = $(this);

		label.wrap(buttonTemplate({ id: identifier, correct: correct }));

		// Major change from multiple-choice
		label.prepend('<input type="checkbox"></input>');
	});

	selectAll.trigger('ximera:answer-needed');

	selectAll.persistentData(function (event) {
		selectAll.find('button').removeClass('active');

		if (selectAll.persistentData('chosen')) {
			selectAll.persistentData('chosen').forEach(function (id) {
				selectAll.find('#' + id).addClass('active');
			});

			selectAll.find('.btn-group button').removeClass('disabled');
			selectAll.find('.btn-group .btn-ximera-submit').addClass('pulsate');
		} else {
			selectAll.find('.btn-group button').addClass('disabled');
			selectAll.find('.btn-group .btn-ximera-submit').removeClass('pulsate');
		}

		if (selectAll.persistentData('correct')) {
			selectAll.find('.btn-group button').hide();
			selectAll.find('.btn-group .btn-ximera-correct').show();

			selectAll.find('button').not('.correct').addClass('disabled');
			selectAll.find('button .correct').removeClass('disabled');
		} else {
			selectAll.find('button').removeClass('disabled');

			selectAll.find('.btn-group button').hide();

			var checked = selectAll.persistentData('checked');
			if (checked) checked = checked.filter(function (x) {
				return x != null;
			});

			var chosen = selectAll.persistentData('chosen');
			if (chosen) chosen = chosen.filter(function (x) {
				return x != null;
			});

			if (selectAll.persistentData('checked') && _.isEqual(_.sortBy(checked), _.sortBy(chosen))) selectAll.find('.btn-group .btn-ximera-incorrect').show();else {
				selectAll.find('.btn-group .btn-ximera-submit').show();
			}
		}

		selectAll.find('.btn-ximera-submit').prop('disabled', !selectAll.find('button').hasClass('active'));
		selectAll.find('.btn-ximera-incorrect').prop('disabled', !selectAll.find('button').hasClass('active'));
	});

	var checkAnswer = function checkAnswer() {
		if (selectAll.persistentData('chosen')) {
			selectAll.persistentData('checked', selectAll.persistentData('chosen'));

			var chosen = selectAll.persistentData('chosen');

			var correct = true;
			selectAll.find('button.btn-secondary').each(function () {
				var id = $(this).attr('id');
				console.log(id);
				if ($(this).hasClass('correct') !== _.contains(chosen, id)) correct = false;
			});

			selectAll.persistentData('correct', correct);

			selectAll.trigger('ximera:attempt');

			if (selectAll.persistentData('correct')) {
				selectAll.trigger('ximera:correct');
			}

			TinCan.answer(selectAll, { response: selectAll.persistentData('chosen'),
				success: selectAll.persistentData('correct') });
		}
	};

	$(this).find(".btn-ximera-submit").click(checkAnswer);
	$(this).find(".btn-ximera-incorrect").click(checkAnswer);

	$(this).find("button.btn-secondary").each(function () {
		$(this).click(function () {
			if ($(this).hasClass('disabled')) {
				return false;
			}

			if (selectAll.persistentData('correct')) return false;

			var id = $(this).attr('id');
			var chosen = selectAll.persistentData('chosen');

			if (!chosen) chosen = [];

			if (_.contains(chosen, id)) selectAll.persistentData('chosen', _.difference(chosen, [id]));else selectAll.persistentData('chosen', _.union(chosen, [id]));

			return false;
		});
	});
};

$.fn.extend({
	selectAll: function selectAll() {
		return this.each(createSelectAll);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","./mathjax.js":"/usr/var/server/public/javascripts/mathjax.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/shuffle.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var database = require('./database');

var createShuffle = function createShuffle() {
	var shuffle = $(this);

	shuffle.persistentData(function () {

		if (!shuffle.persistentData('initialized')) {
			shuffle.persistentData('initialized', true);

			var problems = shuffle.children('.problem-environment');
			problemIds = $.makeArray(problems.map(function () {
				return $(this).attr('id');
			}));

			// BADBAD: this must be done deterministically, to avoid
			// a student just clicking over and over to get a new problem
			shuffle.persistentData('shuffle', _.shuffle(problemIds));

			var firstProblemId = shuffle.persistentData('shuffle')[0];
			var firstProblem = shuffle.children('#' + firstProblemId);
			firstProblem.persistentData('available', true);
		}

		if (shuffle.persistentData('available')) {
			var order = shuffle.persistentData('shuffle');
			shuffle.children('.problem-environment').sort(function (a, b) {
				var ai = _.indexOf(order, $(a).attr('id'));
				var bi = _.indexOf(order, $(b).attr('id'));
				if (ai == bi) return 0;
				if (ai < bi) return -1;
				if (ai > bi) return 1;
			}).each(function () {
				this.parentNode.appendChild(this);
			});
		}
	});

	var problems = shuffle.children('.problem-environment');

	problems.each(function () {
		var problem = $(this);
		var problemId = problem.attr('id');

		problem.persistentData(function () {
			if (problem.persistentData('complete')) {
				var nextProblem = $(this).next('.problem-environment');
				nextProblem.persistentData('available', true);
			}
		});
	});
};

$.fn.extend({
	shuffle: function shuffle() {
		return this.each(createShuffle);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/sticky-scroll.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var bootstrap = require('bootstrap');

$(document).ready(function () {
				var offset = $("#scroller-anchor").offset();

				if (offset) {
								$('#scroller').affix({
												offset: {
																top: offset.top
												}
								});
				}
});

},{"bootstrap":"/usr/var/server.base/node_modules/bootstrap/dist/js/bootstrap.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/supervision.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');

var socket;

function getUser(userId) {
			var supervision = $('#supervision');
			var user = $('#user-' + userId, supervision);

			if (user.length == 0) {
						user = $('<li class="media supervised-user mb-4"></div>');
						user.attr('id', 'user-' + userId);

						var image = $('<img class="d-flex mr-3">');
						user.prepend(image);

						var body = $('<div class="media-body" style="overflow: hidden;"><h5 class="mt-0"><a href="' + window.toValidPath('/users/' + userId) + '"><span class="supervised-name"></span></a> <small><a class="supervised-email"href="#"></a></small></h5><div class="supervised-completions"></div></div>');
						user.append(body);

						supervision.append(user);
			}

			return user;
}

function updateUser(userId, user) {
			var element = getUser(userId);

			if (user.imageUrl) $('img', element).attr('src', user.imageUrl);

			if (user.name) $('h5 .supervised-name', element).text(user.name);

			if (user.email) {
						$('h5 .supervised-email', element).text(user.email);
						$('h5 .supervised-email', element).attr('href', 'mailto:' + user.email);
			}
}

function upvoteUser(userId) {
			var supervision = $('#supervision');
			var user = getUser(userId);

			user.attr('data-reference', parseInt(user.attr('data-reference')) + 1);
			supervision.prepend(user);

			// Move it to the top
			user.parent().prepend(user);
}

function downvoteUser(userId, repositoryName, activityPath) {
			var supervision = $('#supervision');
			var user = getUser(userId);

			if (user.length > 0) {
						user.attr('data-reference', parseInt(user.attr('data-reference')) - 1);
			}

			if (repositoryName && activityPath) {
						console.log("removing ", repositoryName, activityPath);
						var card = $("[data-repository='" + repositoryName + "'][data-path='" + activityPath + "']", user);
						card.remove();
			}
}

function completion(userId, repositoryName, activityPath, complete) {
			var supervision = $('#supervision');
			var user = getUser(userId);

			var card = $("[data-repository='" + repositoryName + "'][data-path='" + activityPath + "']", user);

			if (card.length > 0) {
						console.log("updating");
						card.attr('data-complete', complete);
			} else {
						card = $('<div class="media supervised-activity"></div>');
						card.attr('data-repository', repositoryName);
						card.attr('data-path', activityPath);
						card.attr('data-complete', complete);

						var url = window.toValidPath('/users/' + userId + '/' + repositoryName + '/' + activityPath);
						card.prepend($('<div class="media-body" style="overflow: hidden;"><h5 class="d-flex align-items-center"><div style="width: 48pt;" class="mr-2 progress h-100"><div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div><a style="text-overflow: ellipsis; overflow: hidden;" href="' + url + '">' + repositoryName + '/' + activityPath + '</a></h5></div>'));

						$('.supervised-completions', user).prepend(card);
			}

			var progress = $('.progress-bar', card);
			var percent = Math.round(complete * 100);
			progress.attr('aria-valuenow', percent);
			progress.attr('aria-valuemax', 100);
			progress.css('width', percent.toString() + '%');

			return;
}

function supervise() {
			// Build an appropriate URL based on the page URL
			var websocketUrl = "ws:";
			if (window.location.protocol === "https:") {
						websocketUrl = "wss:";
			}
			websocketUrl += "//" + window.location.host + window.toValidPath("/ws");

			try {
						console.log("Attempting websocket connection...");

						socket = new WebSocket(websocketUrl);

						// It would be nicer to use ...parameters, and I can't just
						// use arguments because it's not actually an array
						socket.sendJSON = function () {
									var parameters = [];
									var i;
									for (i = 0; i < arguments.length; i++) {
												parameters[i] = arguments[i];
									}socket.send(JSON.stringify(parameters));
						};
			} catch (err) {
						alert("Could not connect.  We are not supervising.");
			}

			socket.sendJSON('supervise');

			var handlers = {};

			handlers.enter = function (user) {
						upvoteUser(user._id);
						updateUser(user._id, user);
			};

			handlers.leave = function (payload) {
						var userId = payload.userId;
						var repositoryName = payload.repositoryName;
						var activityPath = payload.activityPath;

						downvoteUser(userId, repositoryName, activityPath);
			};

			handlers.completions = function (payload) {
						console.log(payload);
						payload.forEach(function (c) {
									completion(c.userId, c.repositoryName, c.activityPath, c.complete);
						});
			};

			socket.addEventListener('message', function (event) {
						var payload = JSON.parse(event.data);

						if (!Array.isArray(payload)) {
									console.log("WebSocket message is not an array.");
									return;
						}

						if (payload.length == 0) {
									console.log("WebSocket message is empty.");
									return;
						}

						var message = payload[0];
						var camelCased = message.replace(/-([a-z])/g, function (g) {
									return g[1].toUpperCase();
						});

						if (handlers[camelCased]) {
									handlers[camelCased].apply(socket, payload.slice(1));
						} else {
									console.log("Do not know how to handle " + message);
						}
			});
}

$(function () {
			var supervision = $('#supervision');

			if (supervision.length > 0) {
						supervise();
			}
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/theorem.js":[function(require,module,exports){
"use strict";

var $ = require('jquery');

var addNumbers = function addNumbers(index) {
    var theorem = $(this);
    theorem.attr("numbered", " " + (index + 1));
};

$.fn.extend({
    numberTheorem: function numberTheorem() {
        return this.each(addNumbers);
    }
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/tincan.js":[function(require,module,exports){
"use strict";

var $ = require("jquery");
var _ = require("underscore");
var database = require("./database");

// The trailing slash is necsesary here
var ximeraUrl = window.location.protocol + "//" + window.location.host + "/";

////////////////////////////////////////////////////////////////
// Common verbs from ADL
var verb = function verb(word) {
  return {
    id: "http://adlnet.gov/expapi/verbs/" + word,
    display: {
      "en-US": word
    }
  };
};

var xAPIverb = function xAPIverb(word) {
  return {
    id: "http://activitystrea.ms/schema/1.0/" + word,
    display: {
      "en-US": word
    }
  };
};

var verbExperienced = verb("experienced");
var verbAttempted = verb("attempted");
var verbAnswered = verb("answered");
var verbCompleted = verb("completed");
var verbSubmitted = xAPIverb("submit");

exports.verbExperienced = verb("experienced");
exports.verbAttempted = verb("attempted");
exports.verbAnswered = verb("answered");
exports.verbCompleted = verb("completed");
exports.verbSubmitted = xAPIverb("submit");

exports.activityHashToActivityObject = function (activityHash) {
  var result = {
    objectType: "Activity",
    id: ximeraUrl + "activities/" + activityHash
  };

  // If we are actually talking about the current activity...
  if (activityHash == $("#theActivity").attr("data-hash")) {
    // Then we can grab a bit more information
    var title = $("#theActivity").attr("data-title");

    result.definition = {
      name: { "en-US": title },
      moreInfo: window.location.href
    };

    // And use a better URL?  Maybe not.
    /*
    result.id = ximeraUrl +
     $(this).repositoryName() + "/" +
     $(this).activityPath() + "?" +
     activityHash;
    */
  }

  return result;
};

////////////////////////////////////////////////////////////////
// Shortcuts for recording certain kinds of experience
exports.experienceProblemById = function (activityHash, problemId) {
  exports.recordStatement({
    verb: verbExperienced,
    object: {
      objectType: "Activity",
      id: ximeraUrl + "activities/" + activityHash + "/problems/" + problemId
      // BADBAD: should include a definition
    },
    context: {
      contextActivities: {
        parent: exports.activityHashToActivityObject(activityHash)
      }
    }
  });
};

exports.experienceActivityByHash = function (activityHash) {
  exports.recordVerbObject(verbExperienced, exports.activityHashToActivityObject(activityHash));
};

exports.experienceActivity = function (element) {
  return exports.experienceActivityByHash($(element).activityHash());
};

exports.experienceProblem = function (element) {
  return exports.experienceProblemById($(element).activityHash(), $(element).attr("id"));
};

var problemUrl = function problemUrl(element) {
  var activityHash = $(element).activityHash();
  var problemId = $(element).attr("id");

  var url = ximeraUrl + "activities/" + activityHash + "/problems/" + problemId;

  return url;
};

var answerUrl = function answerUrl(element) {
  var activityHash = $(element).activityHash();
  var problemId = $(element).parents(".problem-environment").first().attr("id");
  var answerId = $(element).attr("id");

  var url = ximeraUrl + "activities/" + activityHash + "/problems/" + problemId + "/answers/" + answerId;

  return url;
};

exports.answer = function (element, result) {
  exports.recordVerbObject(verbAnswered, {
    objectType: "Activity",
    id: answerUrl(element)
  }, {
    result: result
  });
};

var freeResponseUrl = function freeResponseUrl(element) {
  var activityHash = $(element).activityHash();
  var answerId = $(element).attr("id");

  var url = ximeraUrl + "activities/" + activityHash + "/freeResponse/" + answerId;

  return url;
};

exports.submitted = function (element, response) {
  exports.recordVerbObject(verbSubmitted, {
    objectType: "Activity",
    id: freeResponseUrl(element)
  }, {
    result: { response: response }
  });
};

exports.completeProblem = function (element) {
  exports.recordStatement({
    verb: verbCompleted,
    object: {
      objectType: "Activity",
      id: problemUrl(element)
    },
    context: {
      contextActivities: {
        parent: exports.activityHashToActivityObject($(element).activityHash())
      }
    }
  });
};

exports.experience = function (element) {
  if ($(element).hasClass("activity")) exports.experienceActivity(element);else if ($(element).hasClass("problem-environment")) exports.experienceProblem(element);else throw "I do not know how to 'experience' this DOM element.";
};

////////////////////////////////////////////////////////////////
// Commands to serialize a learning record to our learning record store

var queue = [];

var uploadQueue = _.throttle(function () {
  var repositoryName = $("#theActivity").attr("data-repository-name");

  if (repositoryName === undefined) repositoryName = "";

  var data = JSON.stringify(queue);
  queue = [];

  $.ajax({
    url: window.toValidPath("/" + repositoryName + "/xAPI/statements"),
    type: "POST",
    data: data,
    contentType: "application/json",
    error: function error(xhr, textStatus, errorThrown) {
      // If we fail, put our payload back into the queue...
      JSON.parse(data).forEach(function (statement) {
        queue.push(statement);
      });
      // and try again later
      window.setTimeout(uploadQueue, 15001);
    }
  });
}, 1009);

// statement should include a verb and an object; the current user is implied
exports.recordStatement = function (statement) {
  statement.timestamp = new Date().toISOString();

  queue.push(statement);

  uploadQueue();
};

exports.recordVerbObject = function (verb, object, others) {
  var statement = { verb: verb, object: object };

  if (others) _.extend(statement, others);

  console.log(statement);

  return exports.recordStatement(statement);
};

},{"./database":"/usr/var/server/public/javascripts/database.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/users.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var moment = require('moment');

exports.get = _.memoize(function (userId) {
	return $.ajax({
		url: window.toValidPath("/users/" + userId),
		headers: { Accept: "application/json;charset=utf-8" }
	});
});

function me() {
	return exports.get('me');
};

exports.me = me;

$(document).ready(function () {
	me().then(function (user) {
		if (user.isGuest === false) {
			$('#loginUser').show();

			if (user.name.split(' ')[0]) $('#userFirstName').text(user.name.split(' ')[0]);
		} else {
			$('#loginGuest').show(); // If enabled in the server !
		}

		// Instructors should see a "statistics" button
		if (user.instructorRepositoryPaths) {
			$('#menu-supervise').show();

			user.instructorRepositoryPaths.forEach(function (p) {
				if (window.location.pathname.startsWith(window.toValidPath(p))) $('#instructor-view-statistics').show();
				if (window.location.pathname.startsWith(window.toValidPath('/' + p))) $('#instructor-view-statistics').show();
			});
		}

		// If there's git content loaded...
		var repositoryName = $('main').attr('data-repository-name');
		var xourse = $('main').attr('data-xourse-path');
		if (xourse && repositoryName) {
			// and if we have 
			if (user.bridges) {
				var assignment = undefined;
				user.bridges.forEach(function (bridge) {
					if (bridge.path == xourse && bridge.repository == repositoryName) {
						assignment = bridge;
					}
				});

				if (assignment) {
					var dueDate = moment(Date.parse(assignment.dueDate));
					if (dueDate.isValid()) {
						$('#dueDateCountdown').text(dueDate.fromNow());
						$('#dueDate').attr('title', "Due at " + dueDate.format('LLLL'));
						$('#dueDate').show();
						$('#dueDate').tooltip();

						window.setInterval(function () {
							$('#dueDateCountdown').text(dueDate.fromNow());
						}, 1000);
					}
				}
			}
		}
	});
});

},{"jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","moment":"/usr/var/server.base/node_modules/moment/moment.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/validator.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var database = require('./database');

var answerHtml = '<div class="btn-group" style="vertical-align: center;">' + '<button  type="button" class="btn btn-success btn-ximera-correct" data-toggle="tooltip" data-placement="top" title="Correct answer!" style="display: none" aria-label="correct answer" aria-live="assertive">' + '<i class="fa fa-check"></i>&nbsp;Correct' + '</button></div>' + '<div class="btn-group" style="vertical-align: center;">' + '<button  type="button" class="btn btn-danger btn-ximera-incorrect" data-toggle="tooltip" data-placement="top" title="Incorrect.  Try again!" style="display: none" aria-label="incorrect!  try again" aria-live="assertive">' + '<i class="fa fa-times"></i>&nbsp;Try again' + '</button></div>' + '<div class="btn-group" style="vertical-align: center;">' + '<button  type="button" class="btn btn-primary btn-ximera-submit" data-toggle="tooltip" data-placement="top" title="Click to check your answer.">' + '<i class="fa fa-question"></i>&nbsp;Check work' + '</button>' + '</div>';

var createValidator = function createValidator() {
	var validator = $(this);

	$(validator).append($(answerHtml));

	validator.trigger('ximera:answer-needed');

	validator.on('ximera:answers-changed', function () {
		// BADBAD: disable check work button

		// Mark it as "incorrect" if all the responses match the last attempt
		var good = true;
		validator.find('.mathjaxed-input').each(function (i, e) {
			if ($(e).persistentData('response') && $(e).persistentData('attempt') != $(e).persistentData('response')) {
				good = false;
			}
		});
		validator.persistentData('incorrect', good);
	});

	validator.persistentData(function (event) {
		if (validator.persistentData('correct')) {
			validator.find('.btn-group button').hide();
			validator.find('.btn-group .btn-ximera-correct').show();
		} else {
			validator.find('.btn-ximera-correct').hide();
			validator.find('.btn-ximera-incorrect').hide();
			validator.find('.btn-ximera-submit').hide();

			if (validator.persistentData('incorrect')) validator.find('.btn-ximera-incorrect').show();else validator.find('.btn-ximera-submit').show();
		}
	});

	var checkAnswer = function checkAnswer() {
		// BADBAD: this should check whether validation is possible -- i.e., does the validator code throw an error?
		// this should acatually validate
		try {
			var correct = window[validator.attr('id')]();
			validator.persistentData('correct', correct);
		} catch (err) {
			console.log(err);
			validator.persistentData('correct', false);
		};

		validator.trigger('ximera:attempt');

		validator.find('.mathjaxed-input').each(function (i, e) {
			$(e).persistentData('attempt', $(e).persistentData('response'));
			$(e).persistentData('correct', validator.persistentData('correct'));
		});

		if (validator.persistentData('correct')) {
			validator.trigger('ximera:correct');
		}

		validator.trigger('ximera:answers-changed');

		return false;
	};

	$(validator).find(".btn-ximera-submit").click(checkAnswer);
	$(validator).find(".btn-ximera-incorrect").click(checkAnswer);
};

$.fn.extend({
	validator: function validator() {
		return this.each(createValidator);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/version.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');

// Check to see if there is a newer version available
var version = require('../../dbm.json').version;
console.log("This is XIMERA, Version " + version);

$(function () {
	// Check which version the server is providing, avoiding the cache
	var version_endpoint = window.toValidPath("/version?");
	// console.log("VERSIONENDPOINT", version_endpoint);
	$.ajax(version_endpoint + new Date().getTime()).done(function (data) {
		// If the server can offer a newer version, let's update
		if (data != version) {
			if (sessionStorage.getItem('refreshedToVersion') == data) {
				alert('Attempted to refresh; try a force refresh.');
			} else {
				sessionStorage.setItem('refreshedToVersion', data);

				console.log("Uppdating from version " + version + " to version " + data);

				// This is MAYBE needed in Chrome
				$.ajax({
					url: window.location.href,
					headers: {
						"Pragma": "no-cache",
						"Expires": -1,
						"Cache-Control": "no-cache"
					}
				}).done(function () {
					window.location.reload(true);
				});
			}
		}
	});
});

},{"../../dbm.json":"/usr/var/server/dbm.json","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js"}],"/usr/var/server/public/javascripts/word-choice.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var MathJax = require('./mathjax.js');
var database = require('./database');
var TinCan = require('./tincan');

var createWordChoice = function createWordChoice() {
	var wordChoice = $(this);

	var id = wordChoice.attr('id');
	var element = $('<div class="dropdown word-choice btn-ximera-submit"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">&mdash;</button></div>');
	var button = $('button', element);
	element.attr('id', id);
	button.attr('id', id + "-button");

	var menu = $('<div class="dropdown-menu" aria-labelledby="' + id + '-button"></div>');
	element.append(menu);

	$('.choice', wordChoice).each(function () {
		var choice = $(this);

		var link = $('<button class="dropdown-item choice" type="button"></button>');
		if (choice.hasClass("correct")) link.addClass("correct");
		link.attr('id', choice.attr('id'));

		link.append(choice.contents());
		menu.append(link);

		link.click(function () {
			element.persistentData('response', choice.attr('id'));

			if (link.hasClass("correct")) {
				element.persistentData('correct', true);
			} else {
				element.persistentData('correct', false);
			}

			element.trigger('ximera:attempt');

			if (element.persistentData('correct')) {
				element.trigger('ximera:correct');
			}

			TinCan.answer(element, { response: element.persistentData('response'),
				success: element.persistentData('correct') });
		});
	});

	wordChoice.replaceWith(element);

	element.trigger('ximera:answer-needed');

	element.persistentData(function (event) {
		if (element.persistentData('response')) {
			var link = element.find('#' + element.persistentData('response'));
			button.empty();
			button.append(link.clone().contents());
		} else {
			button.html('&mdash;');
		}

		if (element.persistentData('correct')) {
			element.addClass('btn-ximera-correct');
			element.removeClass('btn-ximera-incorrect');
			element.removeClass('btn-ximera-submit');
			button.addClass('btn-success');
			button.removeClass('btn-danger');
			button.removeClass('btn-primary');
		} else {
			if (element.persistentData('correct') === undefined) {
				element.removeClass('btn-ximera-correct');
				element.removeClass('btn-ximera-incorrect');
				element.addClass('btn-ximera-submit');
				button.removeClass('btn-success');
				button.removeClass('btn-danger');
				button.addClass('btn-primary');
			} else {
				element.removeClass('btn-ximera-correct');
				element.addClass('btn-ximera-incorrect');
				element.removeClass('btn-ximera-submit');
				button.removeClass('btn-success');
				button.addClass('btn-danger');
				button.removeClass('btn-primary');
			}
		}

		return false;
	});
};

$.fn.extend({
	wordChoice: function wordChoice() {
		return this.each(createWordChoice);
	}
});

},{"./database":"/usr/var/server/public/javascripts/database.js","./mathjax.js":"/usr/var/server/public/javascripts/mathjax.js","./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/xourse.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Isotope = require('isotope-layout');

var activityCard = require('./activity-card');
var xourseIsotope = undefined;
var layoutMode = 'fitRows';
var search = undefined;

var filtering = function filtering() {
	if (typeof search === 'undefined' || search.length == 0) return $(this).hasClass('part') || $('.part').eq($(this).attr("data-part-counter") - 1).hasClass('part-open');else {
		var regexps = _.map(search.toLowerCase().split(" "), function (word) {
			return new RegExp(word);
		});
		if ($(this).hasClass('part')) return true;

		if (!$('.part').eq($(this).attr("data-part-counter") - 1).hasClass('part-open')) return false;

		var text = $(this).text().toLowerCase();

		return _.all(regexps, function (re) {
			return re.test(text);
		});
	}
};

var updateSearch = function updateSearch() {
	if (!xourseIsotope) return;
	xourseIsotope.arrange({ filter: filtering });
};

var layoutXourse = function layoutXourse() {
	var xourse = $(this);
	// console.log('layoutXourse for ');
	// console.log(xourse);

	$('.activity-card', xourse).activityCard();

	xourse.find('.part').each(function (index, value) {
		$(this).click(function () {
			$(value).toggleClass('part-open');
			xourseIsotope.arrange({ filter: filtering });
		});
	});

	/* make sure the part with the current activity is open */
	document.querySelectorAll('.activity-card.active').forEach(function (crd) {
		$('.part').eq($(crd).attr("data-part-counter") - 1).addClass('part-open');
	});

	xourse.show();

	var options = {
		// layoutMode: 'fitRows',
		// layoutMode: 'vertical',
		layoutMode: layoutMode,
		itemSelector: '.activity-card',
		filter: filtering,
		animationOptions: {
			duration: 750,
			easing: 'linear',
			queue: false
		}
	};

	xourseIsotope = new Isotope(xourse.get(0), options);
};

// On document ready...
$(function () {
	$('#xourse-expand').click(function () {
		$('.part').addClass('part-open');
		$('#xourse-implode').show();
		$('#xourse-expand').hide();
		xourseIsotope.arrange({ filter: filtering });
	});

	$('#xourse-implode').click(function () {
		$('.part').removeClass('part-open');
		$('#xourse-implode').hide();
		$('#xourse-expand').show();
		xourseIsotope.arrange({ filter: filtering });
	});

	var mainnav = $('.main-nav')[0];

	// If no toc present, hide it (otherwise empty space at left side of page)
	if ($('.main-nav').length > 0 && !mainnav.contains(mainnav.querySelector('.toc'))) {
		mainnav.classList.add("hidden");
		// Hide now useless 'Toon/Verberg vooruitgang' button
		$("#xmprogess-close").addClass("xmprogresshidden");
		$("#xmprogess-open").addClass("xmprogresshidden");
	}

	// TOC toggle (main-nav)
	$('#toc-expand-btn').click(function () {
		if (mainnav.classList.contains("hidden")) {
			// Nav was hidden: remove "hidden" to show it again
			mainnav.classList.remove("hidden");
			// Hide progress, and show 'Toon vooruitgang' button
			$("#xmprogess-open").removeClass("xmprogresshidden");
			$(".progress").addClass("xmprogresshidden");
		} else {
			// Nav was shown: hide it by adding class  "hidden" 
			mainnav.classList.add("hidden");
			// Hide now useless 'Toon/Verberg vooruitgang' button
			$("#xmprogess-close").addClass("xmprogresshidden");
			$("#xmprogess-open").addClass("xmprogresshidden");
		}
	});
	// TOC toggle (progress)
	$('.xmhideprogress').click(function () {
		if ($("#xmprogess-close").hasClass("xmprogresshidden")) {
			$("#xmprogess-close").removeClass("xmprogresshidden");
			$("#xmprogess-open").addClass("xmprogresshidden");
			$(".progress").removeClass("xmprogresshidden");
		} else {
			$("#xmprogess-open").removeClass("xmprogresshidden");
			$("#xmprogess-close").addClass("xmprogresshidden");
			$(".progress").addClass("xmprogresshidden");
		}
	});

	// Menu toggle
	$('.toggle').click(function () {
		if ($(".item").hasClass("active")) {
			$(".item").removeClass("active");
		} else {
			$(".item").addClass("active");
		}
	});

	layoutMode = 'fitRows';
	$('.xourse').each(layoutXourse);

	layoutMode = 'vertical';
	$('.toc').each(layoutXourse);

	$('.xourse-search').on('input', function (e) {
		$('#xourse-clear').show();
		$('#xourse-search').hide();
		search = $(e.target).val();
		updateSearch();
	});

	$('#xourse-clear').click(function (e) {
		$('.xourse-search').val('');
		$('#xourse-clear').hide();
		$('#xourse-search').show();
		search = "";
		updateSearch();
	});
});

},{"./activity-card":"/usr/var/server/public/javascripts/activity-card.js","isotope-layout":"/usr/var/server.base/node_modules/isotope-layout/js/isotope.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}],"/usr/var/server/public/javascripts/youtube.js":[function(require,module,exports){
'use strict';

var $ = require('jquery');
var jqueryUI = require('jquery-ui/ui/unique-id');
var _ = require('underscore');
var TinCan = require('./tincan');

// This is an attempt to implement https://registry.tincanapi.com/#profile/19/recipes

function videoObject(target) {
    var videoData = target.getVideoData();
    var title = videoData.title;
    var id = videoData.video_id;
    var duration = target.getDuration();

    return {
        id: 'http://www.youtube.com/watch?v=' + id,
        definition: {
            name: { "en-US": title },
            type: "http://activitystrea.ms/schema/1.0/video",
            extensions: {
                "http://id.tincanapi.com/extension/duration": duration
            }
        }
    };
}

function videoVerb(target, container, verb, word) {
    TinCan.recordStatement({
        verb: {
            id: verb,
            display: { 'en-US': word }
        },
        object: videoObject(target),
        context: {
            contextActivities: {
                parent: TinCan.activityHashToActivityObject($(container).activityHash())
            }
        }
    });
}

function videoStarted(target, container, start) {

    TinCan.recordStatement({
        verb: {
            id: "http://activitystrea.ms/schema/1.0/play",
            display: { 'en-US': "played" }
        },
        object: videoObject(target),
        context: {
            extensions: {
                "http://id.tincanapi.com/extension/starting-point": start
            },
            contextActivities: {
                parent: TinCan.activityHashToActivityObject($(container).activityHash())
            }
        }
    });
}

function videoPaused(target, container, finish) {
    TinCan.recordStatement({
        verb: {
            id: "http://id.tincanapi.com/verb/paused",
            display: { 'en-US': "paused" }
        },
        object: videoObject(target),
        context: {
            extensions: {
                "http://id.tincanapi.com/extension/ending-point": finish
            },
            contextActivities: {
                parent: TinCan.activityHashToActivityObject($(container).activityHash())
            }
        }
    });
}

function videoEnded(target, container) {
    videoVerb(target, container, "http://activitystrea.ms/schema/1.0/complete", "completed");
}

function timeString(seconds) {
    function pad(n) {
        return n < 10 ? "0" + n.toString() : n.toString();
    }

    return Math.floor(seconds / 60).toString() + ":" + pad(seconds % 60);
}

function videoSkipped(target, container, start, finish) {
    TinCan.recordStatement({
        verb: {
            id: "http://id.tincanapi.com/verb/skipped",
            display: { 'en-US': 'skipped' }
        },
        object: videoObject(target),
        context: {
            extensions: {
                "http://id.tincanapi.com/extension/starting-point": start,
                "http://id.tincanapi.com/extension/ending-point": finish
            },
            contextActivities: {
                parent: TinCan.activityHashToActivityObject($(container).activityHash())
            }
        }
    });
}

function videoWatched(target, container, start, finish) {
    TinCan.recordStatement({
        verb: {
            id: "http://activitystrea.ms/schema/1.0/watch",
            display: { 'en-US': 'watched' }
        },
        object: videoObject(target),
        context: {
            extensions: {
                "http://id.tincanapi.com/extension/starting-point": start,
                "http://id.tincanapi.com/extension/ending-point": finish
            },
            contextActivities: {
                parent: TinCan.activityHashToActivityObject($(container).activityHash())
            }
        }
    });
}

function updateViewedFraction(event, container) {
    var currentTime = event.target.getCurrentTime();

    if (event.target.getDuration() > 0) {
        var duration = event.target.getDuration();

        if (container.persistentData('fractionViewed')) {
            if (currentTime / duration > container.persistentData('fractionViewed')) {
                container.persistentData('fractionViewed', currentTime / duration);
            }
        } else {
            container.persistentData('fractionViewed', currentTime / duration);
        }
    }
}

function onPlayerStateChange(event, container, videoId) {
    var container = $('#' + container);

    var lastPlayerState = container.data('lastPlayerState');
    updateViewedFraction(event, container);

    switch (event.data) {
        case YT.PlayerState.PLAYING:
            container.data('lastPlayedTime', event.target.getCurrentTime());
            videoStarted(event.target, container, event.target.getCurrentTime());
            break;

        case YT.PlayerState.PAUSED:
            var timer = setTimeout(function () {
                if (lastPlayerState == YT.PlayerState.PLAYING) {
                    videoWatched(event.target, container, container.data('lastPlayedTime'), event.target.getCurrentTime());
                }
                videoPaused(event.target, container, event.target.getCurrentTime());
            }, 250);

            container.data('lastPausedTime', event.target.getCurrentTime());
            container.data('timer', timer);
            break;

        case YT.PlayerState.BUFFERING:
            clearTimeout(container.data('timer'));

            if (lastPlayerState != YT.PlayerState.UNSTARTED) {
                videoWatched(event.target, container, container.data('lastPlayedTime'), container.data('currentTime'));
                videoSkipped(event.target, container, container.data('currentTime'), event.target.getCurrentTime());
            }
            break;

        case YT.PlayerState.ENDED:
            // BADBAD: I'm faking this as if it meant "completed" but it
            // doesn't necessarily mean the learner watched ALL the video
            videoWatched(event.target, container, container.data('lastPlayedTime'), event.target.getCurrentTime());
            videoEnded(event.target, container);
            break;

        case YT.PlayerState.UNSTARTED:
            break;
    }

    container.data('lastPlayerState', event.data);
}

function onPlayerReady(event, container, videoId) {
    var target = event.target;
    // Matt Thomas requests that videos defualt to something with a higher resolution
    target.setPlaybackQuality("hd720");

    // This is the only way I could capture the "watched" events
    container = $('#' + container);

    window.setInterval(function () {
        container.data('currentTime', target.getCurrentTime());
    }, 200); // 200ms granularity seems good enough to me

    window.setInterval(function () {
        updateViewedFraction(event, container);
    }, 17011);
}

var videosToConstruct = [];

var player = {
    playVideo: function playVideo(container, videoId) {
        if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
            videosToConstruct.push([container, videoId]);

            $.getScript('//www.youtube.com/iframe_api');
        } else {
            player.loadPlayer(container, videoId);
        }
    },

    loadPlayer: function loadPlayer(container, videoId) {
        new YT.Player(container, {
            videoId: videoId,
            width: 720,
            height: 405,
            // For a list of all parameters, see:
            // https://developers.google.com/youtube/player_parameters
            playerVars: {
                autoplay: 0,
                controls: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0
            },
            events: {
                'onReady': function onReady(event) {
                    return onPlayerReady(event, container, videoId);
                },
                'onStateChange': function onStateChange(event) {
                    return onPlayerStateChange(event, container, videoId);
                }
            }
        });
    }
};

window.onYouTubeIframeAPIReady = _.once(function () {
    _.each(videosToConstruct, function (video) {
        player.loadPlayer(video[0], video[1]);
    });
});

function createVideo() {
    var div = $(this);

    div.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');

    // <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" allowfullscreen></iframe>

    div.uniqueId();
    var id = div.attr('id');

    var url = div.attr('data-youtube');

    if (url.match(/watch\?v=/)) {
        url = url.replace(/.*watch\?v=/, '');
    }

    player.playVideo(id, url);
}

$.fn.extend({
    youtube: function youtube() {
        return this.each(createVideo);
    }
});

module.exports = player;

},{"./tincan":"/usr/var/server/public/javascripts/tincan.js","jquery":"/usr/var/server.base/node_modules/jquery/dist/jquery.js","jquery-ui/ui/unique-id":"/usr/var/server.base/node_modules/jquery-ui/ui/unique-id.js","underscore":"/usr/var/server.base/node_modules/underscore/underscore-umd.js"}]},{},["/usr/var/server/public/javascripts/main.js"]);
